import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "FormSection": [
      "DetectorReportConfigFormSection",
      "IntegrationConfigFormSection",
      "IntegrationStateSection",
      "ModuleFormSection"
    ],
    "FormView": [
      "DetectorReportConfigFormView",
      "IntegrationConfigFormView",
      "IntegrationStateView",
      "ModuleSettingsFormView"
    ],
    "SceneContent": [
      "Camera",
      "Tour",
      "Widget"
    ],
    "VideoWallObject": [
      "CameraGroup",
      "Scene",
      "Screen",
      "Widget"
    ],
    "_Entity": [
      "Asset",
      "AssetTransaction",
      "AssetWorkOrder",
      "DetectorReportConfiguration",
      "DetectorReportRule",
      "Location",
      "OrganizationKineticUser",
      "WorkOrderConfiguration"
    ],
    "iComment": [
      "BasicComment"
    ]
  }
};
      export default result;
    
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
  LocalTime: any;
  Object: any;
  _Any: any;
  _FieldSet: any;
};

export enum AtspmSignalReport {
  ApproachDelay = 'APPROACH_DELAY',
  ApproachVolume = 'APPROACH_VOLUME',
  ArrivalsOnRed = 'ARRIVALS_ON_RED',
  EventTimeline = 'EVENT_TIMELINE',
  FlowProfile = 'FLOW_PROFILE',
  Pcd = 'PCD',
  PhaseTerm = 'PHASE_TERM',
  SplitFailure = 'SPLIT_FAILURE',
  SplitMonitor = 'SPLIT_MONITOR',
  TurningMovement = 'TURNING_MOVEMENT',
  YellowAndRedViolations = 'YELLOW_AND_RED_VIOLATIONS'
}

export type AcceptedWord = {
  __typename?: 'AcceptedWord';
  /**  Identifier of the accepted word  */
  id: Scalars['ID'];
  /** The accepted word  */
  word: Scalars['String'];
};

export type AcceptedWordInput = {
  /**  Identifier of the accepted word  */
  id?: InputMaybe<Scalars['ID']>;
  /** The accepted word  */
  word: Scalars['String'];
};

export type Action = {
  __typename?: 'Action';
  route?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  toolTip?: Maybe<Scalars['String']>;
};

export type ActionInput = {
  route?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  toolTip?: InputMaybe<Scalars['String']>;
};

export type ActionSetRule = {
  __typename?: 'ActionSetRule';
  /**  if the rule is enabled for evaluation  */
  enabled: Scalars['Boolean'];
  /**  identifier for event form  */
  formId: Scalars['String'];
  /**  rule identifier  */
  id: Scalars['ID'];
  /**  rule name  */
  name: Scalars['String'];
  /**  rule priority  */
  priority: Scalars['Int'];
  /**  the mvel rule string  */
  rule: Scalars['String'];
  /**  rule tree  */
  tree: Scalars['Object'];
};

export type ActionSetRuleConnection = {
  __typename?: 'ActionSetRuleConnection';
  /**  connection edges  */
  edges: Array<ActionSetRuleConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type ActionSetRuleConnectionEdge = {
  __typename?: 'ActionSetRuleConnectionEdge';
  /**  cursor position  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: ActionSetRule;
};

export type ActionSetRuleInput = {
  /**  if the rule is enabled for evaluation  */
  enabled: Scalars['Boolean'];
  /**  identifier for event form  */
  formId: Scalars['String'];
  /**  rule identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  rule name  */
  name: Scalars['String'];
  /**  rule priority  */
  priority: Scalars['Int'];
  /**  the mvel rule string  */
  rule: Scalars['String'];
  /**  rule tree  */
  tree: Scalars['Object'];
};

export type ActionSetRuleInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum ActivationStatus {
  Active = 'ACTIVE',
  Failed = 'FAILED'
}

export enum ActivationType {
  /**  Event will be automatically activated  */
  Automatic = 'AUTOMATIC',
  /**  Event will require confirmation before activating  */
  ConfirmationRequired = 'CONFIRMATION_REQUIRED',
  /**  Event will be manually activated  */
  Manual = 'MANUAL'
}

export type ActivityLog = {
  __typename?: 'ActivityLog';
  action: Scalars['String'];
  changes?: Maybe<Array<ActivityLogChange>>;
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  id: Scalars['ID'];
  module: KineticModule;
  object?: Maybe<Scalars['Object']>;
  timestamp: Scalars['DateTime'];
  type?: Maybe<Scalars['String']>;
  user?: Maybe<OrganizationKineticUser>;
  userFullName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ActivityLogChange = {
  __typename?: 'ActivityLogChange';
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  operation?: Maybe<ActivityLogChangeType>;
  path?: Maybe<Scalars['String']>;
};

export enum ActivityLogChangeType {
  Add = 'ADD',
  Remove = 'REMOVE',
  Update = 'UPDATE'
}

export type ActivityLogConnection = {
  __typename?: 'ActivityLogConnection';
  edges: Array<ActivityLogEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ActivityLogEdge = {
  __typename?: 'ActivityLogEdge';
  cursor?: Maybe<Scalars['String']>;
  node: ActivityLog;
};

export type ActivityLogInput = {
  action: Scalars['String'];
  description: Scalars['String'];
  entityId: Scalars['ID'];
  module: KineticModule;
  type?: InputMaybe<Scalars['String']>;
};

export type ActivityLogName = {
  __typename?: 'ActivityLogName';
  id: Scalars['ID'];
  integrationType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ActivityLogNameConnection = {
  __typename?: 'ActivityLogNameConnection';
  edges: Array<ActivityLogNameEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ActivityLogNameEdge = {
  __typename?: 'ActivityLogNameEdge';
  cursor?: Maybe<Scalars['String']>;
  node: ActivityLogName;
};

export type AddWorkOrderArguments = {
  /**  asset id */
  assetId: Scalars['String'];
  /**  work order attributes */
  attributes: Scalars['JSON'];
  /**  device id */
  id: Scalars['ID'];
  /**  request id */
  requestId?: InputMaybe<Scalars['String']>;
};

export type Aggregation = {
  __typename?: 'Aggregation';
  count?: Maybe<CountAggregation>;
  name?: Maybe<Scalars['String']>;
  sum?: Maybe<SumAggregation>;
  values?: Maybe<Array<Maybe<ValueAggregation>>>;
};

export type AggregationInput = {
  /**  Field to aggregate on. Can use JSON Path notation. */
  field?: InputMaybe<Scalars['String']>;
  /**  Filters to apply to the historical data before aggregation */
  filters?: InputMaybe<Array<FilterInput>>;
  /**  Range to enclose aggregations */
  interval: AggregationIntervalInput;
  /**  Name of the aggregation to compute, e.g. "Total Incidents" */
  name?: InputMaybe<Scalars['String']>;
  /**  Limit the number of VALUE aggregations */
  top?: InputMaybe<Scalars['Int']>;
  /**
   *  ISO8601 for the start date when computing comparative
   *  trend values for aggregations. If omitted, it will default
   *  to 3 periods before the input interval. E.g. if the interval
   *  is WEEKLY starting September 18th, this value will default
   *  to August 28th.
   */
  trendStart?: InputMaybe<Scalars['DateTime']>;
  /**  Type of aggregation to perform */
  type: AggregationType;
};

export type AggregationIntervalInput = {
  /**  ISO8601 datetime for the start of the interval */
  date: Scalars['DateTime'];
  mode: AggregationIntervalMode;
};

export enum AggregationIntervalMode {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum AggregationType {
  /**  Number of matches to a filter with the given field */
  Count = 'COUNT',
  /**  Sum of values for an aggregation. Only for numeric values */
  Sum = 'SUM',
  /**  Distinct values along with their total count */
  Values = 'VALUES'
}

export type Alarm = {
  __typename?: 'Alarm';
  /**  Is this alarm in its current alarming state acknowledged  */
  acknowledged: Scalars['Boolean'];
  /**  When the alarm was acknowledged  */
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  /**  User ID that acknowledged the alarm  */
  acknowledgedBy?: Maybe<Scalars['ID']>;
  /**  User name that acknowledged the alarm  */
  acknowledgedByDisplayName?: Maybe<Scalars['String']>;
  /**  Is this alarm currently going off  */
  active: Scalars['Boolean'];
  /**  When this alarm was activated  */
  activeAt?: Maybe<Scalars['DateTime']>;
  /**  The alarm's owning center, if any */
  centerId?: Maybe<Scalars['String']>;
  /**  When the alarm was cleared, if cleared  */
  clearedAt?: Maybe<Scalars['DateTime']>;
  /**  Additional comments tied to the acknowledgement  */
  comments?: Maybe<Scalars['String']>;
  /**  The configuration attached to this alarm  */
  config: AlarmConfig;
  /** Total number of times this alarm has been fired */
  count: Scalars['Int'];
  /**
   * Additional metadata associated with this alarm.
   * E.g. the device or intersection that triggered it,
   * index information for NTCIP alarms (Preempt, etc)
   */
  data?: Maybe<Scalars['Object']>;
  /**  Additional details about this alarm  */
  description?: Maybe<Scalars['String']>;
  /**  Display name of this alarm. E.g. `Communication Failure` */
  displayName?: Maybe<Scalars['String']>;
  /**  Unique identifier for the entity that triggered the alarm  */
  entityId: Scalars['ID'];
  /**  Type of entity that triggered the alarm, e.g. an intersection  */
  entityType: AlarmEntityType;
  id: Scalars['ID'];
  /**  Name of this alarm. E.g. `CommFail`  */
  name: Scalars['String'];
  /**
   * When this alarm was first received. If the alarm has not been received
   * since last activation, this will be null
   */
  receivedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Number of recurrences of this alarm. Includes both
   * recurrence count that activated it as well as the
   * number of recurrences since it's been active
   */
  recurrenceCount: Scalars['Int'];
  /**  Resolved status (if the most recent alarm activation was acknowledged) */
  resolved: Scalars['Boolean'];
  /**  Severity of the alarm when it was activated  */
  severity: AlarmSeverity;
  /**  Kinetic module that triggered the alarm  */
  source: KineticModule;
  /**  Subtypes of the alarm, if any */
  subtypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * When the alarm was last modified
   * e.g. by acknowledgement, clearing, or a new count
   */
  updatedAt: Scalars['DateTime'];
};

export enum AlarmAcknowledgementType {
  AutomaticOnActivation = 'AUTOMATIC_ON_ACTIVATION',
  AutomaticOnDeactivation = 'AUTOMATIC_ON_DEACTIVATION',
  NoAcknowledgementPossible = 'NO_ACKNOWLEDGEMENT_POSSIBLE',
  RequireAcknowledgementToResolve = 'REQUIRE_ACKNOWLEDGEMENT_TO_RESOLVE',
  Standard = 'STANDARD'
}

export type AlarmConfig = {
  __typename?: 'AlarmConfig';
  acknowledgementType: AlarmAcknowledgementType;
  alarmSeverity: AlarmSeverity;
  alarmType: AlarmType;
  delayThreshold?: Maybe<Scalars['Int']>;
  delayThresholdEnabled?: Maybe<Scalars['Boolean']>;
  delayThresholdUnit?: Maybe<ChronoUnit>;
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  entityId?: Maybe<Scalars['ID']>;
  entityType: AlarmEntityType;
  id: Scalars['ID'];
  name: Scalars['String'];
  playAudibleAlert?: Maybe<Scalars['Boolean']>;
  recurrenceCount?: Maybe<Scalars['Int']>;
  recurrencePeriod?: Maybe<Scalars['Int']>;
  recurrenceUnit?: Maybe<ChronoUnit>;
  soundFile?: Maybe<Scalars['String']>;
  source: KineticModule;
  systemNotification: Scalars['Boolean'];
  triggerOnRecurrence: Scalars['Boolean'];
  urgentNotification: Scalars['Boolean'];
};

export type AlarmConfigInput = {
  acknowledgementType: AlarmAcknowledgementType;
  alarmSeverity: AlarmSeverity;
  alarmType: AlarmType;
  delayThreshold?: InputMaybe<Scalars['Int']>;
  delayThresholdEnabled?: InputMaybe<Scalars['Boolean']>;
  delayThresholdUnit?: InputMaybe<ChronoUnit>;
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  entityId?: InputMaybe<Scalars['ID']>;
  entityType: AlarmEntityType;
  name: Scalars['String'];
  playAudibleAlert?: InputMaybe<Scalars['Boolean']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  recurrencePeriod?: InputMaybe<Scalars['Int']>;
  recurrenceUnit?: InputMaybe<ChronoUnit>;
  soundFile?: InputMaybe<Scalars['String']>;
  source: KineticModule;
  systemNotification: Scalars['Boolean'];
  triggerOnRecurrence: Scalars['Boolean'];
  urgentNotification: Scalars['Boolean'];
};

export type AlarmConfigsConnection = {
  __typename?: 'AlarmConfigsConnection';
  edges: Array<AlarmConfigsConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AlarmConfigsConnectionEdge = {
  __typename?: 'AlarmConfigsConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: AlarmConfig;
};

export type AlarmConfigsQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter alarms.  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type AlarmConnection = {
  __typename?: 'AlarmConnection';
  edges: Array<AlarmConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AlarmConnectionEdge = {
  __typename?: 'AlarmConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Alarm;
};

export enum AlarmEntityType {
  Aid = 'AID',
  Alert = 'ALERT',
  Camera = 'CAMERA',
  ConnectedVehicle = 'CONNECTED_VEHICLE',
  Count = 'COUNT',
  CountSite = 'COUNT_SITE',
  DpsInterface = 'DPS_INTERFACE',
  Event = 'EVENT',
  Gate = 'GATE',
  GateSystem = 'GATE_SYSTEM',
  Intersection = 'INTERSECTION',
  Jupiter = 'JUPITER',
  Nvr = 'NVR',
  Sign = 'SIGN',
  TollingPoint = 'TOLLING_POINT',
  TravelTime = 'TRAVEL_TIME',
  TunnelFan = 'TUNNEL_FAN'
}

export enum AlarmSeverity {
  Critical = 'CRITICAL',
  Informational = 'INFORMATIONAL',
  Warning = 'WARNING'
}

export enum AlarmType {
  Custom = 'CUSTOM',
  Mib = 'MIB',
  Standard = 'STANDARD'
}

export type AlarmsQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter alarms.  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type Alert = {
  __typename?: 'Alert';
  alertId: Scalars['String'];
  confidence?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['JSON']>;
  evidence?: Maybe<AlertEvidence>;
  location?: Maybe<Scalars['Object']>;
  severity?: Maybe<Severity>;
  source?: Maybe<AlertSource>;
  sourceName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['DateTime']>;
};

export type AlertEvidence = {
  __typename?: 'AlertEvidence';
  fileId?: Maybe<Scalars['String']>;
  status?: Maybe<AlertEvidenceStatus>;
  type?: Maybe<AlertEvidenceType>;
};

export enum AlertEvidenceStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export enum AlertEvidenceType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export enum AlertSource {
  Cad = 'CAD',
  Flow = 'FLOW',
  GenetecCamera = 'GENETEC_CAMERA',
  Queue = 'QUEUE',
  TrafficVision = 'TRAFFIC_VISION',
  TravelTime = 'TRAVEL_TIME',
  Waze = 'WAZE',
  Weather = 'WEATHER'
}

export type AlertSourceName = {
  __typename?: 'AlertSourceName';
  names?: Maybe<Array<Maybe<Scalars['String']>>>;
  source?: Maybe<AlertSource>;
};

export type AlertState = {
  __typename?: 'AlertState';
  alertId?: Maybe<Scalars['String']>;
  alertStatus?: Maybe<Status>;
};

export type ArchivePartitionField = {
  __typename?: 'ArchivePartitionField';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ArchivePartitionFieldType>;
};

export enum ArchivePartitionFieldType {
  Int = 'INT',
  Isodate = 'ISODATE',
  String = 'STRING'
}

export type ArchiveRuleConfig = {
  __typename?: 'ArchiveRuleConfig';
  archiveExpireAfterDays?: Maybe<Scalars['Int']>;
  collectionName?: Maybe<Scalars['String']>;
  dateField?: Maybe<Scalars['String']>;
  dbType?: Maybe<DbInstanceType>;
  expireAfterDays?: Maybe<Scalars['Int']>;
  partitionFields?: Maybe<Array<Maybe<ArchivePartitionField>>>;
  version?: Maybe<Scalars['Int']>;
};

export type Asset = {
  __typename?: 'Asset';
  /**  The asset id  */
  assetNumber: Scalars['String'];
  associatedLocation?: Maybe<Location>;
  /**  The attributes of the asset built from an asset form  */
  attributes: Scalars['Object'];
  /** Stock available units */
  availableUnits: Array<AssetLocationCount>;
  /** burn rate threshold */
  burnRateThreshold?: Maybe<Scalars['Int']>;
  /**  The asset code  */
  code?: Maybe<AssetCode>;
  /**  Indicate if asset is consumable  */
  consumable?: Maybe<Scalars['Boolean']>;
  /** Created time */
  createdAt: Scalars['DateTime'];
  /** Created by */
  createdBy: Scalars['String'];
  /**  The asset description  */
  description?: Maybe<Scalars['String']>;
  /**  The identifier of the asset  */
  id: Scalars['ID'];
  /** lead times  */
  leadTimes?: Maybe<Scalars['Int']>;
  /** asset life cycle */
  lifecycles: Array<AssetLifeCycle>;
  /**  The asset location  */
  location?: Maybe<Scalars['Object']>;
  /** maximum stock level */
  maxStockLevel?: Maybe<Scalars['Int']>;
  /** minimum stock level */
  minStockLevel?: Maybe<Scalars['Int']>;
  /**  The asset name  */
  name: Scalars['String'];
  /**  The asset owner  */
  owner?: Maybe<Scalars['String']>;
  /**  The asset parent  */
  parent?: Maybe<Asset>;
  /**  The asset priority  */
  priority?: Maybe<AssetPriority>;
  /**  The asset quantity  */
  quantity?: Maybe<Scalars['Int']>;
  /** send burn rate threshold email */
  sendBurnRateThresholdEmail?: Maybe<Scalars['Boolean']>;
  /** send lead times email */
  sendLeadTimesEmail?: Maybe<Scalars['Boolean']>;
  /** send maximum stock level email */
  sendMaxStockLevelEmail?: Maybe<Scalars['Boolean']>;
  /** send minimum stock level email */
  sendMinStockLevelEmail?: Maybe<Scalars['Boolean']>;
  /**  The asset serial number  */
  serialNumber: Scalars['String'];
  /** stats of an asset */
  stats?: Maybe<AssetStatistics>;
  /**  The asset status  */
  status?: Maybe<AssetStatus>;
  /** stock details */
  stockDetail?: Maybe<AssetStockDetail>;
  /**  The asset type  */
  type?: Maybe<AssetType>;
  /** Updated time */
  updatedAt: Scalars['DateTime'];
  /**  The asset warranty date range  */
  warrantyDate?: Maybe<DateRange>;
};

export type AssetCode = {
  __typename?: 'AssetCode';
  /**  Indicate if asset is consumable  */
  consumable?: Maybe<Scalars['Boolean']>;
  /**  The identifier of the asset code */
  id: Scalars['ID'];
  /**  The manufacturer of the asset code */
  manufacturer?: Maybe<Scalars['String']>;
  /**  The max inventory of the asset code */
  maxInventory?: Maybe<Scalars['Int']>;
  /**  The min inventory of the asset code */
  minInventory?: Maybe<Scalars['Int']>;
  /**  The model of the asset code */
  model?: Maybe<Scalars['String']>;
  /**  The name of the asset code */
  name: Scalars['String'];
  /**  The partNumber of the asset code */
  partNumber?: Maybe<Scalars['Int']>;
  /**  The name of the asset code */
  type: Scalars['String'];
  /**  The value of the asset code */
  value: Scalars['String'];
};

export type AssetConnection = {
  __typename?: 'AssetConnection';
  /**  connection edges  */
  edges: Array<AssetConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type AssetConnectionEdge = {
  __typename?: 'AssetConnectionEdge';
  /**  connection edge node  */
  cursor?: Maybe<Scalars['String']>;
  /**  node cursor  */
  node: Asset;
};

export type AssetCounts = {
  __typename?: 'AssetCounts';
  color?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum AssetGroupBy {
  Code = 'CODE',
  Priority = 'PRIORITY',
  Status = 'STATUS'
}

export type AssetHealthStats = {
  __typename?: 'AssetHealthStats';
  date: Scalars['String'];
  totalDowntimeMinutes: Scalars['Float'];
};

export type AssetInput = {
  /**  The asset associated location  */
  associatedLocation?: InputMaybe<Scalars['ID']>;
  /**  The attributes of the asset built from an asset form  */
  attributes: Scalars['Object'];
  /** burn rate threshold */
  burnRateThreshold?: InputMaybe<Scalars['Int']>;
  /**  The asset code  */
  code: Scalars['String'];
  /**  The asset description  */
  description?: InputMaybe<Scalars['String']>;
  /**  The identifier of the asset  */
  id?: InputMaybe<Scalars['ID']>;
  /** lead times  */
  leadTimes?: InputMaybe<Scalars['Int']>;
  /**  The asset location  */
  location?: InputMaybe<Scalars['Object']>;
  /** maximum stock level */
  maxStockLevel?: InputMaybe<Scalars['Int']>;
  /** minimum stock level */
  minStockLevel?: InputMaybe<Scalars['Int']>;
  /**  The asset name  */
  name: Scalars['String'];
  /**  The asset owner  */
  owner?: InputMaybe<Scalars['String']>;
  /**  The asset parent  */
  parent?: InputMaybe<Scalars['ID']>;
  /**  The asset priority  */
  priority?: InputMaybe<Scalars['String']>;
  /**  The asset quantity  */
  quantity?: InputMaybe<Scalars['Int']>;
  /** send burn rate threshold email */
  sendBurnRateThresholdEmail?: InputMaybe<Scalars['Boolean']>;
  /** send lead times email */
  sendLeadTimesEmail?: InputMaybe<Scalars['Boolean']>;
  /** send maximum stock level email */
  sendMaxStockLevelEmail?: InputMaybe<Scalars['Boolean']>;
  /** send minimum stock level email */
  sendMinStockLevelEmail?: InputMaybe<Scalars['Boolean']>;
  /**  The asset serial number  */
  serialNumber: Scalars['String'];
  /**  The asset status  */
  status?: InputMaybe<Scalars['String']>;
  /**  The asset type  */
  type: Scalars['String'];
  /**  The asset warranty date range  */
  warrantyDate?: InputMaybe<DateRangeInput>;
};

export type AssetInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter assets */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** User preference for data and time format */
  reportPreference?: InputMaybe<ReportPreference>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type AssetLifeCycle = {
  __typename?: 'AssetLifeCycle';
  /** end timestamp */
  endTimestamp?: Maybe<Scalars['DateTime']>;
  /** is life cycle step complete */
  isComplete?: Maybe<Scalars['Boolean']>;
  /** asset Life cycle name */
  name: Scalars['String'];
  /** start timestamp */
  startTimestamp?: Maybe<Scalars['DateTime']>;
};

export type AssetLocationCount = {
  __typename?: 'AssetLocationCount';
  count: Scalars['Int'];
  location: Location;
};

export type AssetNote = {
  __typename?: 'AssetNote';
  /** The unique identifier of the asset note */
  id: Scalars['ID'];
  /** The message associated with the asset note */
  message: Scalars['String'];
  /** The type of the asset note */
  type: AssetNoteType;
};

export enum AssetNoteType {
  Asset = 'ASSET',
  WorkOrder = 'WORK_ORDER'
}

export type AssetPriority = {
  __typename?: 'AssetPriority';
  /**  The value of the asset priority */
  color: Scalars['String'];
  /**  The description of the asset priority */
  description?: Maybe<Scalars['String']>;
  /**  The identifier of the asset priority */
  id: Scalars['ID'];
  /**  The name of the asset priority */
  name: Scalars['String'];
  /**  The value of the asset priority */
  value: Scalars['String'];
};

export type AssetStatistics = {
  __typename?: 'AssetStatistics';
  daysInUpTime: Scalars['Int'];
  daysInUse: Scalars['Int'];
  daysWithoutIncident: Scalars['Int'];
  totalDowntime: Scalars['Int'];
};

export type AssetStatus = {
  __typename?: 'AssetStatus';
  /**  The color of the asset status */
  color: Scalars['String'];
  /**  The identifier of the asset status */
  id: Scalars['ID'];
  /**  The name of the asset status */
  name: Scalars['String'];
  /** The state of the asset status */
  state: AssetStatusState;
  /**  The value of the asset status */
  value: Scalars['String'];
};

export enum AssetStatusState {
  Deployed = 'DEPLOYED',
  Downtime = 'DOWNTIME',
  EndOfLife = 'END_OF_LIFE',
  Retiring = 'RETIRING',
  Undeployed = 'UNDEPLOYED',
  Uptime = 'UPTIME'
}

export type AssetStockDetail = {
  __typename?: 'AssetStockDetail';
  inStockCount?: Maybe<Scalars['Int']>;
  stockOutRate?: Maybe<Scalars['Float']>;
};

export type AssetTransaction = {
  __typename?: 'AssetTransaction';
  asset: Asset;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['ID'];
  createdByName: Scalars['String'];
  executed?: Maybe<Scalars['Boolean']>;
  fromLocation?: Maybe<Location>;
  fromParent?: Maybe<Asset>;
  fromStatus?: Maybe<AssetStatus>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  quantityAvailable?: Maybe<Scalars['Int']>;
  quantityConsumed?: Maybe<Scalars['Int']>;
  quantityRemaining?: Maybe<Scalars['Int']>;
  subStepId: Scalars['ID'];
  toLocation?: Maybe<Location>;
  toParent?: Maybe<Asset>;
  toStatus?: Maybe<AssetStatus>;
  transactedAt?: Maybe<Scalars['DateTime']>;
  transactionNumber: Scalars['ID'];
  type: AssetTransactionType;
  updatedAt: Scalars['DateTime'];
  workOrder: AssetWorkOrder;
  workOrderId: Scalars['ID'];
};

export type AssetTransactionConnection = {
  __typename?: 'AssetTransactionConnection';
  /**  connection edges  */
  edges: Array<AssetTransactionConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type AssetTransactionConnectionEdge = {
  __typename?: 'AssetTransactionConnectionEdge';
  /**  connection edge node  */
  cursor?: Maybe<Scalars['String']>;
  /**  node cursor  */
  node: AssetTransaction;
};

export type AssetTransactionInput = {
  assetId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  quantityConsumed?: InputMaybe<Scalars['Int']>;
  subStepId: Scalars['ID'];
  toLocation?: InputMaybe<Scalars['ID']>;
  toParentId?: InputMaybe<Scalars['String']>;
  toStatus?: InputMaybe<Scalars['String']>;
  type: AssetTransactionType;
  workOrderId: Scalars['ID'];
};

export type AssetTransactionInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter assets */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum AssetTransactionType {
  Consumable = 'CONSUMABLE',
  MoveLocation = 'MOVE_LOCATION',
  StatusChange = 'STATUS_CHANGE'
}

export type AssetType = {
  __typename?: 'AssetType';
  /**  The form of the asset type */
  form?: Maybe<Scalars['ID']>;
  /**  The identifier of the asset type */
  id: Scalars['ID'];
  /**  The labels of the asset type */
  labels?: Maybe<Array<Scalars['String']>>;
  /**  The name of the asset type */
  name: Scalars['String'];
  /**  The value of the asset code */
  value: Scalars['String'];
};

export type AssetWorkOrder = {
  __typename?: 'AssetWorkOrder';
  /** The list of assigned asset codes */
  assetCodes: Array<AssetCode>;
  /** The list of assets associated with the work order */
  assets: Array<Asset>;
  /** The list of assignee IDs for the work order */
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  /** close Resolution of an work order */
  closeResolution?: Maybe<Scalars['String']>;
  /**  Indicates if work order is closed */
  closed?: Maybe<Scalars['Boolean']>;
  /** The unique identifier of the configuration */
  config: WorkOrderConfiguration;
  /** The time the work order was created */
  createdAt: Scalars['DateTime'];
  /** The ID of the user who created the work order */
  createdBy: Scalars['String'];
  /** The name of the user who created the work order */
  createdByName: Scalars['String'];
  /** decline Or Close Reason of an work order */
  declineOrCloseReason?: Maybe<Scalars['String']>;
  /** Flag associated with the sub-step */
  flag?: Maybe<AssetWorkOrderFlag>;
  /** The unique identifier of the work order */
  id: Scalars['ID'];
  /** The labels associated with the work order */
  labels?: Maybe<Array<Scalars['String']>>;
  /** The unique identifier of the location */
  location?: Maybe<Location>;
  /** Name of work order */
  name?: Maybe<Scalars['String']>;
  /** The note attached to the work order */
  note?: Maybe<AssetNote>;
  /** The work order number */
  orderNumber: Scalars['String'];
  /**  The asset work order parent  */
  parent?: Maybe<AssetWorkOrder>;
  /** The priority level of the work order */
  priority?: Maybe<AssetPriority>;
  /** The unique identifier of the requester */
  requesterId: Scalars['String'];
  /** The current status of the work order */
  status?: Maybe<AssetWorkOrderStatus>;
  /** The time the work order was last updated */
  updatedAt: Scalars['DateTime'];
  /** The ID of the user who last updated the work order */
  updatedBy: Scalars['String'];
  /** The name of the user who last updated the work order */
  updatedByName: Scalars['String'];
};

export type AssetWorkOrderAssignmentsInput = {
  /** sub step assignment ids */
  assignmentIds: Array<Scalars['ID']>;
  /** sub step id of work order */
  subStepId: Scalars['ID'];
  /** Id of the work order */
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderCloseInput = {
  /** comment to close step */
  comment?: InputMaybe<Scalars['String']>;
  commentHtml?: InputMaybe<Scalars['String']>;
  mentionedUsers?: InputMaybe<Array<InputMaybe<WorkOrderRecipientInput>>>;
  /** reason to close step */
  reason?: InputMaybe<Scalars['String']>;
  /** resolution to close step */
  resolution?: InputMaybe<Scalars['String']>;
  /** Id of the work order */
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderComment = {
  __typename?: 'AssetWorkOrderComment';
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  comment: Scalars['String'];
  commentHtml?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['ID'];
  createdByName: Scalars['String'];
  id: Scalars['ID'];
  mentionedUsers?: Maybe<Array<Maybe<WorkOrderRecipient>>>;
  step?: Maybe<AssetWorkOrderStep>;
  stepId?: Maybe<Scalars['String']>;
  subStep?: Maybe<AssetWorkOrderSubStep>;
  subStepId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderCommentConnection = {
  __typename?: 'AssetWorkOrderCommentConnection';
  /**  connection edges  */
  edges: Array<AssetWorkOrderCommentConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type AssetWorkOrderCommentConnectionEdge = {
  __typename?: 'AssetWorkOrderCommentConnectionEdge';
  /**  connection edge node  */
  cursor?: Maybe<Scalars['String']>;
  /**  node cursor  */
  node: AssetWorkOrderComment;
};

export type AssetWorkOrderCommentInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  comment: Scalars['String'];
  commentHtml?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  mentionedUsers?: InputMaybe<Array<InputMaybe<WorkOrderRecipientInput>>>;
  stepId?: InputMaybe<Scalars['String']>;
  subStepId?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderCommentInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter assets */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type AssetWorkOrderConnection = {
  __typename?: 'AssetWorkOrderConnection';
  /**  connection edges  */
  edges: Array<AssetWorkOrderConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type AssetWorkOrderConnectionEdge = {
  __typename?: 'AssetWorkOrderConnectionEdge';
  /**  connection edge node  */
  cursor?: Maybe<Scalars['String']>;
  /**  node cursor  */
  node: AssetWorkOrder;
};

export type AssetWorkOrderDeclineInput = {
  /** comment to close step */
  comment?: InputMaybe<Scalars['String']>;
  commentHtml?: InputMaybe<Scalars['String']>;
  mentionedUsers?: InputMaybe<Array<InputMaybe<WorkOrderRecipientInput>>>;
  /** reason to close step */
  reason?: InputMaybe<Scalars['String']>;
  /** Id of the step work order */
  stepId: Scalars['ID'];
  /** Id of the work order */
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderFlag = {
  __typename?: 'AssetWorkOrderFlag';
  /** Specifies whether the flag is enabled or not. */
  enabled: Scalars['Boolean'];
  mentionedUsers?: Maybe<Array<Maybe<WorkOrderRecipient>>>;
  /** Optional reason for why the flag is set. */
  reason?: Maybe<Scalars['String']>;
  reasonHtml?: Maybe<Scalars['String']>;
};

export type AssetWorkOrderFlagInput = {
  mentionedUsers?: InputMaybe<Array<InputMaybe<WorkOrderRecipientInput>>>;
  /** sub step data */
  reasonForFlag?: InputMaybe<Scalars['String']>;
  reasonHtml?: InputMaybe<Scalars['String']>;
  /** sub step id of work order */
  subStepId: Scalars['ID'];
  /** Id of the work order */
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderInput = {
  /** The list of asset IDs associated with the work order */
  assetIds: Array<Scalars['String']>;
  /** The list of assignee IDs for the work order */
  assigneeIds?: InputMaybe<Array<Scalars['String']>>;
  /** The unique identifier of the configuration */
  configId: Scalars['String'];
  /** The unique identifier of the work order */
  id?: InputMaybe<Scalars['ID']>;
  /** The labels associated with the work order */
  labels?: InputMaybe<Array<Scalars['String']>>;
  /** The unique identifier of the location */
  locationId: Scalars['String'];
  /** Name of work order */
  name?: InputMaybe<Scalars['String']>;
  /**  The asset work order parent  */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The unique identifier of the priority */
  priorityId: Scalars['String'];
  /** The unique identifier of the requester */
  requesterId?: InputMaybe<Scalars['String']>;
};

export type AssetWorkOrderInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter assets */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** User preference for data and time format */
  reportPreference?: InputMaybe<ReportPreference>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type AssetWorkOrderLink = {
  __typename?: 'AssetWorkOrderLink';
  /** Any comment on Link */
  comment?: Maybe<Scalars['String']>;
  /** The unique identifier of the Link */
  id: Scalars['ID'];
  /** link id to link */
  linkId: Scalars['String'];
  /** Type of Link */
  linkType: Scalars['String'];
  /** Asset work order */
  linkedWorkOrder: AssetWorkOrder;
  /** sub work order name to a Link */
  workOrderId: Scalars['String'];
};

export type AssetWorkOrderLinkConnection = {
  __typename?: 'AssetWorkOrderLinkConnection';
  /**  connection edges  */
  edges: Array<AssetWorkOrderLinkConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type AssetWorkOrderLinkConnectionEdge = {
  __typename?: 'AssetWorkOrderLinkConnectionEdge';
  /**  connection edge node  */
  cursor?: Maybe<Scalars['String']>;
  /**  node cursor  */
  node: AssetWorkOrderLink;
};

export type AssetWorkOrderLinkInput = {
  /** Any comment on Link */
  comment?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the Link */
  id?: InputMaybe<Scalars['ID']>;
  /** link id to link */
  linkId: Scalars['String'];
  /** Type of Link */
  linkType: Scalars['String'];
  /** sub work order name to a Link */
  workOrderId: Scalars['String'];
};

export type AssetWorkOrderLinkInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter assets */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type AssetWorkOrderStatus = {
  __typename?: 'AssetWorkOrderStatus';
  /** The color associated with the asset work order status */
  color: Scalars['String'];
  /** The unique identifier of the asset work order status */
  id: Scalars['ID'];
  /** The name of the asset work order status */
  name: Scalars['String'];
  /** The value of the asset work order status */
  value: Scalars['String'];
};

export type AssetWorkOrderStep = {
  __typename?: 'AssetWorkOrderStep';
  /** Unique identifier for the work order step. */
  id: Scalars['ID'];
  /** name of the step */
  name: Scalars['ID'];
  /** Current status of the work order step. */
  status: AssetWorkOrderStepStatus;
  /** Identifier of the step. */
  stepId: Scalars['ID'];
  /** List of sub-steps that are part of this work order step. */
  subSteps: Array<AssetWorkOrderSubStep>;
  /** Identifier of the parent work order. */
  workOrderId: Scalars['ID'];
};

export enum AssetWorkOrderStepStatus {
  /** Indicates that the step is currently active and in progress. */
  Active = 'ACTIVE',
  /** Indicates that the step has been completed successfully. */
  Complete = 'COMPLETE',
  /** Indicates that the step is disabled and not in use. */
  Disabled = 'DISABLED',
  /** Indicated invalid data found on executing rule */
  RuleInvalid = 'RULE_INVALID'
}

export type AssetWorkOrderSubStep = {
  __typename?: 'AssetWorkOrderSubStep';
  /** additional views for work order form */
  additionalViews?: Maybe<Array<WorkOrderAdditionalView>>;
  /** List of assignment identifiers related to this sub-step. */
  assignments: Array<Scalars['ID']>;
  /** sub step data */
  data?: Maybe<Scalars['Object']>;
  /** List of default assignees related to this sub-step. */
  defaultAssignees?: Maybe<Array<Scalars['ID']>>;
  /** Flag associated with the sub-step, providing additional context. */
  flag?: Maybe<AssetWorkOrderFlag>;
  /** form id of the sub step */
  formId?: Maybe<Scalars['ID']>;
  /** Unique identifier for the sub-step. */
  id: Scalars['ID'];
  /** for multi form sections */
  multiFormSections?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** name of the sub step */
  name: Scalars['ID'];
  /** Current status of the sub-step. */
  status: AssetWorkOrderStepStatus;
  /** step id of work order */
  stepId: Scalars['ID'];
  /** sub step id of work order */
  subStepId: Scalars['ID'];
  /** use for list */
  useCrudList?: Maybe<Scalars['Boolean']>;
  /** use form stepper */
  useStepper?: Maybe<Scalars['Boolean']>;
  /** Id of the work order */
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderSubStepInput = {
  /** sub step data */
  data: Scalars['Object'];
  /** execute sub step */
  execute?: InputMaybe<Scalars['Boolean']>;
  /** sub step id of work order */
  subStepId: Scalars['ID'];
  /** Id of the work order */
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderTracking = {
  __typename?: 'AssetWorkOrderTracking';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  createdByName: Scalars['String'];
  fromTimestamp?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  minutes?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  step?: Maybe<AssetWorkOrderStep>;
  stepId?: Maybe<Scalars['String']>;
  subStep?: Maybe<AssetWorkOrderSubStep>;
  subStepId?: Maybe<Scalars['String']>;
  toTimestamp?: Maybe<Scalars['DateTime']>;
  totalDuration?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  updatedByName: Scalars['String'];
  userId: Scalars['String'];
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderTrackingConnection = {
  __typename?: 'AssetWorkOrderTrackingConnection';
  /**  connection edges  */
  edges: Array<AssetWorkOrderTrackingConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type AssetWorkOrderTrackingConnectionEdge = {
  __typename?: 'AssetWorkOrderTrackingConnectionEdge';
  /**  connection edge node  */
  cursor?: Maybe<Scalars['String']>;
  /**  node cursor  */
  node: AssetWorkOrderTracking;
};

export type AssetWorkOrderTrackingInput = {
  fromTimestamp: Scalars['DateTime'];
  hours: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  minutes: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  stepId?: InputMaybe<Scalars['ID']>;
  subStepId: Scalars['ID'];
  toTimestamp: Scalars['DateTime'];
  userId: Scalars['String'];
  workOrderId: Scalars['ID'];
};

export type AssetWorkOrderTrackingInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter assets */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type AssociatedCorridor = {
  __typename?: 'AssociatedCorridor';
  /**  corridor id  */
  id?: Maybe<Scalars['ID']>;
  /**  corridor name  */
  name?: Maybe<Scalars['String']>;
  /**  corridor type  */
  type?: Maybe<Scalars['String']>;
};

export type AssociatedEntityFilterInput = {
  entityType: LocationAssociationEntityType;
  exists?: InputMaybe<Scalars['Boolean']>;
};

export type AvlLocationInput = {
  /**  latitude  */
  latitude: Scalars['Float'];
  /**  longitude  */
  longitude: Scalars['Float'];
};

export type AxisInfo = {
  __typename?: 'AxisInfo';
  max?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['String']>;
  series: Array<Maybe<Scalars['String']>>;
  /**  Title  */
  title: Scalars['String'];
  /**  Data Type  */
  type: DataType;
};

export type BasicComment = IComment & {
  __typename?: 'BasicComment';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['ID'];
  entityId: Scalars['ID'];
  html: Scalars['String'];
  id: Scalars['ID'];
  mentionedUsers?: Maybe<Array<Scalars['ID']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BasicCommentInput = {
  entityId: Scalars['ID'];
  html: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  mentionedUsers?: InputMaybe<Array<Scalars['ID']>>;
};

export type BasicIntersection = {
  __typename?: 'BasicIntersection';
  devices: Array<BasicIntersectionDevice>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type BasicIntersectionDevice = {
  __typename?: 'BasicIntersectionDevice';
  id: Scalars['String'];
  name: Scalars['String'];
  type: IntersectionType;
};

export type BlockVideoStreamInput = {
  associatedEventIds?: InputMaybe<Array<Scalars['ID']>>;
  cameraId?: InputMaybe<Scalars['ID']>;
  duration?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['String']>;
  streamName?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type Camera = {
  __typename?: 'Camera';
  autoFocusEnabled?: Maybe<Scalars['Boolean']>;
  autoIrisEnabled?: Maybe<Scalars['Boolean']>;
  autoPanEnabled?: Maybe<Scalars['Boolean']>;
  cameraCategory?: Maybe<Scalars['String']>;
  capabilities?: Maybe<Array<CameraCapabilityDto>>;
  capabilitiesState: Scalars['Object'];
  communicationParameters?: Maybe<Scalars['Object']>;
  communicationStatus?: Maybe<CommunicationState>;
  dataReceived?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  firmware?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastPollAttempt?: Maybe<Scalars['DateTime']>;
  lastSuccessfulPoll?: Maybe<Scalars['DateTime']>;
  liveRecordings?: Maybe<Array<VideoRecord>>;
  location?: Maybe<Scalars['JSON']>;
  locationDescription?: Maybe<Scalars['String']>;
  locationFixed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  poweredOn?: Maybe<Scalars['Boolean']>;
  presets?: Maybe<Array<Maybe<Preset>>>;
  privateStreamRecordingInProgress?: Maybe<Scalars['Boolean']>;
  ptzLock: PtzLockInfo;
  publicFeedEnabled?: Maybe<Scalars['Boolean']>;
  publicStreamRecordingInProgress?: Maybe<Scalars['Boolean']>;
  referencePoint?: Maybe<Scalars['String']>;
  road?: Maybe<Scalars['String']>;
  streams?: Maybe<Array<Maybe<VideoStream>>>;
  timeDrift?: Maybe<Scalars['Int']>;
  tours?: Maybe<Array<Maybe<Tour>>>;
  trustedStreamRecordingInProgress?: Maybe<Scalars['Boolean']>;
  userNotes?: Maybe<Scalars['String']>;
};

export type CameraAutoFocusInput = {
  cameraId: Scalars['String'];
  enable: Scalars['Boolean'];
};

export type CameraAutoIrisInput = {
  cameraId: Scalars['String'];
  enable: Scalars['Boolean'];
};

export enum CameraCapability {
  Antifog = 'ANTIFOG',
  Autotracker = 'AUTOTRACKER',
  IntelligentTracker = 'INTELLIGENT_TRACKER',
  IntermediateWiper = 'INTERMEDIATE_WIPER',
  Ircorrection = 'IRCORRECTION',
  NightModeSettings = 'NIGHT_MODE_SETTINGS',
  OneshotWipes = 'ONESHOT_WIPES',
  Scan360 = 'SCAN360',
  StartTourA = 'START_TOUR_A',
  StartTourB = 'START_TOUR_B',
  Washer = 'WASHER',
  WashingProcedure = 'WASHING_PROCEDURE',
  WhiteBalance = 'WHITE_BALANCE',
  Wiper = 'WIPER'
}

export type CameraCapabilityDto = {
  __typename?: 'CameraCapabilityDto';
  capability: CameraCapability;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CameraConnection = {
  __typename?: 'CameraConnection';
  edges: Array<CameraConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CameraConnectionEdge = {
  __typename?: 'CameraConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Camera;
};

export type CameraDetectionStatus = {
  __typename?: 'CameraDetectionStatus';
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isSupported?: Maybe<Scalars['Boolean']>;
};

export type CameraFocusInput = {
  cameraId: Scalars['String'];
  focusSpeed: Scalars['Int'];
};

export type CameraGotoPresetInput = {
  cameraId: Scalars['String'];
  presetId: Scalars['String'];
};

export type CameraGroup = {
  __typename?: 'CameraGroup';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items: Array<GroupItem>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  subGroups: Array<SubGroup>;
};

export type CameraGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  items: Array<InputMaybe<GroupItemInput>>;
  name: Scalars['String'];
  order: Scalars['Int'];
  subGroups: Array<InputMaybe<SubGroupInput>>;
};

export type CameraGroupListFormat = {
  searchFields?: InputMaybe<Array<CameraGroupSearchField>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<CameraGroupSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type CameraGroupOrderInput = {
  id: Scalars['ID'];
  order: Scalars['Int'];
};

export enum CameraGroupSearchField {
  Description = 'DESCRIPTION',
  Name = 'NAME'
}

export enum CameraGroupSortField {
  Id = 'ID',
  Name = 'NAME',
  Order = 'ORDER'
}

export type CameraInputQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type CameraIrisInput = {
  cameraId: Scalars['String'];
  irisSpeed: Scalars['Int'];
};

export type CameraPanTiltInput = {
  cameraId: Scalars['String'];
  panSpeed: Scalars['Int'];
  tiltSpeed: Scalars['Int'];
};

export type CameraPublicFeedInput = {
  cameraId: Scalars['String'];
  connect: Scalars['Boolean'];
  streamManagerId: Scalars['String'];
};

export type CameraPublicStreamTargetInput = {
  cameraId: Scalars['String'];
  enable: Scalars['Boolean'];
  streamManagerId: Scalars['String'];
};

export type CameraStreamRecordingInput = {
  cameraId: Scalars['String'];
  recordingInitiatedBy?: InputMaybe<RecordingInitiatedBy>;
  recordingInitiatorId?: InputMaybe<Scalars['String']>;
  recordingName: Scalars['String'];
  recordingType?: InputMaybe<RecordingType>;
  start: Scalars['Boolean'];
  streamAccessType: VideoStreamAccessType;
  streamRecorderId: Scalars['String'];
};

export type CameraZoomInput = {
  cameraId: Scalars['String'];
  zoomSpeed: Scalars['Int'];
};

export type CellValidation = {
  options?: InputMaybe<Array<Scalars['String']>>;
  type: CellValidationType;
};

export enum CellValidationType {
  Date = 'DATE',
  Decimal = 'DECIMAL',
  Dropdown = 'DROPDOWN',
  Integer = 'INTEGER'
}

export type CenterInfo = {
  __typename?: 'CenterInfo';
  centerId: Scalars['String'];
  id: Scalars['String'];
};

export type CentralAuthPinSettings = {
  __typename?: 'CentralAuthPinSettings';
  id: Scalars['String'];
  pin: Scalars['String'];
};

export type ChartData = {
  __typename?: 'ChartData';
  /**  Preferred Color */
  color?: Maybe<Scalars['String']>;
  /**  Data points  */
  dataPoints?: Maybe<Array<Maybe<DataPoint>>>;
  /**  Chart Legend  */
  legend?: Maybe<Scalars['String']>;
  /**  Chart data name  */
  name: Scalars['String'];
  /**  Preferred Shape  */
  shape?: Maybe<Scalars['String']>;
  /**  Chart Type  */
  type: Scalars['String'];
};

export type CheckPoint = {
  __typename?: 'CheckPoint';
  /**  Background fill color  */
  color?: Maybe<Scalars['String']>;
  /**  Data Points  */
  dataPoints?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**  Legend  */
  legend?: Maybe<Scalars['String']>;
  /**  Data Type  */
  type: DataType;
};

export enum ChronoUnit {
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Seconds = 'SECONDS'
}

export type ColumnProperty = {
  __typename?: 'ColumnProperty';
  name: Scalars['String'];
  type: DataType;
};

export type CommandIntersection = {
  __typename?: 'CommandIntersection';
  devices: Array<BasicIntersectionDevice>;
  group?: Maybe<BasicIntersectionDevice>;
  id: Scalars['String'];
  labels?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export enum CommandType {
  ActionPlan = 'ACTION_PLAN',
  Pattern = 'PATTERN',
  PhaseHold = 'PHASE_HOLD',
  Preempt = 'PREEMPT',
  RingMax2 = 'RING_MAX2',
  SetTime = 'SET_TIME',
  SpecialFunction = 'SPECIAL_FUNCTION',
  StopTime = 'STOP_TIME',
  SystemPatternOverride = 'SYSTEM_PATTERN_OVERRIDE',
  VehicleRecall = 'VEHICLE_RECALL'
}

export type CommandValue = {
  __typename?: 'CommandValue';
  name: Scalars['String'];
  value?: Maybe<Scalars['Object']>;
};

export enum CommunicationDetailsType {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING',
  Radio = 'RADIO',
  Verbal = 'VERBAL'
}

export type CommunicationLog = {
  __typename?: 'CommunicationLog';
  attributes: Scalars['Object'];
  contact?: Maybe<CommunicationLogContact>;
  detailsType?: Maybe<Scalars['String']>;
  discussion?: Maybe<Scalars['String']>;
  eventIds: Array<Scalars['ID']>;
  events?: Maybe<Array<Maybe<Event>>>;
  id: Scalars['ID'];
  impactedGroup?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  reported?: Maybe<Scalars['DateTime']>;
};

export type CommunicationLogConnection = {
  __typename?: 'CommunicationLogConnection';
  edges: Array<CommunicationLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CommunicationLogContact = {
  __typename?: 'CommunicationLogContact';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type CommunicationLogContactInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type CommunicationLogEdge = {
  __typename?: 'CommunicationLogEdge';
  cursor: Scalars['String'];
  node: CommunicationLog;
};

export type CommunicationLogInput = {
  attributes: Scalars['Object'];
  contact?: InputMaybe<CommunicationLogContactInput>;
  detailsType?: InputMaybe<CommunicationDetailsType>;
  discussion?: InputMaybe<Scalars['String']>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  impactedGroup?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  reported?: InputMaybe<Scalars['DateTime']>;
};

export type CommunicationLogInputQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type CommunicationLogStreamObject = {
  __typename?: 'CommunicationLogStreamObject';
  dto?: Maybe<CommunicationLog>;
  streamObjectOperation?: Maybe<StreamObjectOperation>;
};

export type CommunicationReportRow = {
  __typename?: 'CommunicationReportRow';
  communicationParameters?: Maybe<Scalars['String']>;
  communicationState: CommunicationState;
  deviceId: Scalars['String'];
  deviceName?: Maybe<Scalars['String']>;
  downTime: Scalars['Int'];
  failureCount: Scalars['Int'];
  group?: Maybe<Scalars['String']>;
  integrationType: IntegrationType;
  intersectionId: Scalars['String'];
  intersectionName: Scalars['String'];
  latency: Scalars['Int'];
  requestCount: Scalars['Int'];
};

export type CommunicationReportRowEdge = {
  __typename?: 'CommunicationReportRowEdge';
  cursor?: Maybe<Scalars['String']>;
  node: CommunicationReportRow;
};

export enum CommunicationState {
  Disabled = 'DISABLED',
  Failed = 'FAILED',
  NoData = 'NO_DATA',
  Operational = 'OPERATIONAL',
  OperationalWithError = 'OPERATIONAL_WITH_ERROR',
  OperationalWithWarning = 'OPERATIONAL_WITH_WARNING',
  Suspect = 'SUSPECT'
}

export type ConnectedVehicle = {
  __typename?: 'ConnectedVehicle';
  communicationState: CommunicationState;
  description?: Maybe<Scalars['String']>;
  device: ConnectedVehicleDevice;
  id: Scalars['ID'];
  location: Scalars['Object'];
  name: Scalars['String'];
};

export type ConnectedVehicleCategory = {
  __typename?: 'ConnectedVehicleCategory';
  rsuMainStatusCategories: RsuMainStatusCategory;
  rsuModeStatusCategories: RsuModeStatusCategory;
};

export type ConnectedVehicleComment = {
  __typename?: 'ConnectedVehicleComment';
  comment: Scalars['String'];
  connectedVehicleId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  userDisplayName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ConnectedVehicleCommentConnection = {
  __typename?: 'ConnectedVehicleCommentConnection';
  edges: Array<ConnectedVehicleCommentConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ConnectedVehicleCommentConnectionEdge = {
  __typename?: 'ConnectedVehicleCommentConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: ConnectedVehicleComment;
};

export type ConnectedVehicleCommentStreamObject = {
  __typename?: 'ConnectedVehicleCommentStreamObject';
  dto: ConnectedVehicleComment;
  streamObjectOperation: StreamObjectOperation;
};

export type ConnectedVehicleConnection = {
  __typename?: 'ConnectedVehicleConnection';
  edges: Array<ConnectedVehicleConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ConnectedVehicleConnectionEdge = {
  __typename?: 'ConnectedVehicleConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: ConnectedVehicle;
};

export type ConnectedVehicleDevice = {
  __typename?: 'ConnectedVehicleDevice';
  deviceApi: Scalars['String'];
  moduleVersion?: Maybe<Scalars['String']>;
  rsuMainStatus: RsuMainStatus;
  rsuModeStatus: RsuModeStatus;
  rsuRadioStatus: RsuRadioStatus;
};

export type Contact = {
  __typename?: 'Contact';
  cellNumber?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  faxNumber?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  groups?: Maybe<Array<Maybe<ContactGroupDto>>>;
  homeNumber?: Maybe<Scalars['String']>;
  hoursOfOperation?: Maybe<Array<Maybe<HoursOfOperation>>>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  mailingAddress?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Maybe<OrganizationDto>>>;
  otherNumber?: Maybe<Scalars['String']>;
  pagerNumber?: Maybe<Scalars['String']>;
  publicMode?: Maybe<Scalars['Boolean']>;
  website?: Maybe<Scalars['String']>;
  workNumber?: Maybe<Scalars['String']>;
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  edges: Array<ContactConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ContactConnectionEdge = {
  __typename?: 'ContactConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Contact;
};

export type ContactGroup = {
  __typename?: 'ContactGroup';
  id?: Maybe<Scalars['ID']>;
};

export type ContactGroupConnection = {
  __typename?: 'ContactGroupConnection';
  edges: Array<ContactGroupConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ContactGroupConnectionEdge = {
  __typename?: 'ContactGroupConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: ContactGroupDto;
};

export type ContactGroupDto = {
  __typename?: 'ContactGroupDto';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  items: Array<Maybe<Contact>>;
  name: Scalars['String'];
  parentGroup?: Maybe<Scalars['String']>;
  subGroups: Array<Maybe<ContactGroupDto>>;
};

export type ContactGroupFilterInput = {
  field: Scalars['String'];
  operator: FilterOperator;
  value?: InputMaybe<Scalars['Object']>;
};

export type ContactGroupInput = {
  contacts: Array<InputMaybe<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  parentGroup?: InputMaybe<Scalars['String']>;
  subGroups: Array<InputMaybe<ContactGroupInput>>;
};

export type ContactGroupQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ContactGroupFilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ContactGroupStreamObject = {
  __typename?: 'ContactGroupStreamObject';
  dto?: Maybe<ContactGroupDto>;
  streamObjectOperation?: Maybe<StreamObjectOperation>;
};

export type ContactInput = {
  cellNumber?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  faxNumber?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  homeNumber?: InputMaybe<Scalars['String']>;
  hoursOfOperation?: InputMaybe<Array<InputMaybe<HoursOfOperationInput>>>;
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mailingAddress?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  otherNumber?: InputMaybe<Scalars['String']>;
  pagerNumber?: InputMaybe<Scalars['String']>;
  publicMode?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
  workNumber?: InputMaybe<Scalars['String']>;
};

export type ContactInputQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ContactOrganizationQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['String'];
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ContactStreamObject = {
  __typename?: 'ContactStreamObject';
  dto?: Maybe<Contact>;
  streamObjectOperation?: Maybe<StreamObjectOperation>;
};

export enum ConversionUnitType {
  Imperial = 'Imperial',
  Metric = 'Metric'
}

export enum CoordStatus {
  Badcycle = 'BADCYCLE',
  Badplan = 'BADPLAN',
  Commandfree = 'COMMANDFREE',
  Coord = 'COORD',
  Coordfree = 'COORDFREE',
  Failed = 'FAILED',
  Inputfree = 'INPUTFREE',
  Invalidoffset = 'INVALIDOFFSET',
  Minsunder = 'MINSUNDER',
  Other = 'OTHER',
  Splitover = 'SPLITOVER',
  Transition = 'TRANSITION'
}

export type Corridor = {
  __typename?: 'Corridor';
  /**  activation type  */
  activationType: CorridorActivationType;
  /**  response confirmed  */
  confirmed: Scalars['Boolean'];
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  associated detections */
  detections: Array<Scalars['ID']>;
  /**  supported device types  */
  deviceTypes: Array<CorridorDeviceType>;
  /**  associated events  */
  events: Array<Scalars['ID']>;
  /**  bounds  */
  geometry: Scalars['Object'];
  /**  identifier  */
  id: Scalars['ID'];
  /**  associated integrations  */
  integrations: Array<Scalars['String']>;
  /**  schematic landmarks  */
  landmarks: Array<CorridorLandmark>;
  /**  schematic lanes  */
  lanes: Array<CorridorLane>;
  /**  name  */
  name: Scalars['String'];
  /**  schematic presets  */
  presets: Array<CorridorPreset>;
  /**  response period (secs)  */
  responsePeriod: Scalars['Int'];
  /**  general settings  */
  settings: Scalars['Object'];
  /**  shift notes */
  shiftNotes?: Maybe<Scalars['String']>;
  /**  type  */
  type: CorridorType;
  /**  schematic zones  */
  zones: Array<CorridorZone>;
};

export enum CorridorActivationType {
  /**  Corridor will be automatically activated  */
  Automatic = 'AUTOMATIC',
  /**  Corridor will require confirmation before activating  */
  ConfirmationRequired = 'CONFIRMATION_REQUIRED',
  /**  Corridor will be manually activated  */
  Manual = 'MANUAL'
}

export type CorridorConnection = {
  __typename?: 'CorridorConnection';
  /**  Connection Edges  */
  edges: Array<CorridorConnectionEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type CorridorConnectionEdge = {
  __typename?: 'CorridorConnectionEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The Corridor object  */
  node: Corridor;
};

export enum CorridorDeviceType {
  /**  action sets  */
  ActionSets = 'ACTION_SETS',
  /**  cameras  */
  Cameras = 'CAMERAS',
  /**  dangerous cargo  */
  DangerousCargo = 'DANGEROUS_CARGO',
  /**  detectors  */
  Detectors = 'DETECTORS',
  /**  gate systems  */
  GateSystem = 'GATE_SYSTEM',
  /**  lane controls  */
  Lcs = 'LCS',
  /**  over-height vehicles  */
  OverHeight = 'OVER_HEIGHT',
  /**  general dms  */
  Signs = 'SIGNS',
  /**  sign groups  */
  SignGroup = 'SIGN_GROUP',
  /**  toll points  */
  TollPoint = 'TOLL_POINT',
  /**  traffic control signals  */
  TrafficControl = 'TRAFFIC_CONTROL',
  /**  travel times  */
  TravelTime = 'TRAVEL_TIME',
  /**  tunnel fans  */
  TunnelFan = 'TUNNEL_FAN',
  /**  tunnel lights  */
  TunnelLight = 'TUNNEL_LIGHT',
  /**  speed limits  */
  Vsl = 'VSL',
  /**  weather stations  */
  WeatherStations = 'WEATHER_STATIONS'
}

export type CorridorInput = {
  /**  activation type  */
  activationType: CorridorActivationType;
  /**  description  */
  description?: InputMaybe<Scalars['String']>;
  /**  supported device types  */
  deviceTypes: Array<CorridorDeviceType>;
  /**  bounds  */
  geometry: Scalars['Object'];
  /**  identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  associated integrations  */
  integrations: Array<Scalars['String']>;
  /**  schematic landmarks  */
  landmarks: Array<CorridorLandmarkInput>;
  /**  schematic lanes  */
  lanes: Array<CorridorLaneInput>;
  /**  name  */
  name: Scalars['String'];
  /**  response period (secs)  */
  responsePeriod: Scalars['Int'];
  /**  general settings  */
  settings: Scalars['Object'];
  /**  shift notes  */
  shiftNotes?: InputMaybe<Scalars['String']>;
  /**  type  */
  type: CorridorType;
  /**  schematic zones  */
  zones: Array<CorridorZoneInput>;
};

export type CorridorInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type CorridorLandmark = {
  __typename?: 'CorridorLandmark';
  /**  if the landmark is in both directions  */
  bothDirections: Scalars['Boolean'];
  /**  direction  */
  direction?: Maybe<Direction>;
  /**  identifier  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
  /**  reference point  */
  referencePoint: Scalars['Float'];
  /**  landmark settings  */
  settings?: Maybe<Scalars['Object']>;
  /**  if the landmark should display the reference point  */
  showReferencePoint: Scalars['Boolean'];
};

export type CorridorLandmarkInput = {
  /**  if the landmark is in both directions  */
  bothDirections: Scalars['Boolean'];
  /**  direction  */
  direction?: InputMaybe<Direction>;
  /**  identifier  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
  /**  reference point  */
  referencePoint: Scalars['Float'];
  /**  landmark settings  */
  settings?: InputMaybe<Scalars['Object']>;
  /**  if the landmark should display the reference point  */
  showReferencePoint: Scalars['Boolean'];
};

export type CorridorLane = {
  __typename?: 'CorridorLane';
  /**  lane abbreviation */
  abbreviation?: Maybe<Scalars['String']>;
  /**  gate controller  */
  controller?: Maybe<Scalars['ID']>;
  /**  detector group  */
  detectorGroupId?: Maybe<Scalars['ID']>;
  /**  the direction  */
  direction: Direction;
  /**  end reference  */
  endReference: Scalars['Float'];
  /**  identifier  */
  id: Scalars['ID'];
  /**  line type  */
  lineType: CorridorLineType;
  /**  lane position  */
  position: Scalars['Int'];
  /**  reversible lane  */
  reversible?: Maybe<Scalars['Boolean']>;
  /**  reversible lane position  */
  reversiblePosition?: Maybe<Scalars['Int']>;
  /**  The road of the lane  */
  road: Scalars['String'];
  /**  start reference  */
  startReference: Scalars['Float'];
  /**  the lane type  */
  type: LaneType;
};

export type CorridorLaneInput = {
  /**  lane abbreviation */
  abbreviation?: InputMaybe<Scalars['String']>;
  /**  gate controller  */
  controller?: InputMaybe<Scalars['ID']>;
  /**  detector group  */
  detectorGroupId?: InputMaybe<Scalars['ID']>;
  /**  the direction  */
  direction: Direction;
  /**  end reference  */
  endReference: Scalars['Float'];
  /**  identifier  */
  id: Scalars['ID'];
  /**  line type  */
  lineType: CorridorLineType;
  /**  lane position  */
  position: Scalars['Int'];
  /**  reversible lane  */
  reversible?: InputMaybe<Scalars['Boolean']>;
  /**  reversible lane position  */
  reversiblePosition?: InputMaybe<Scalars['Int']>;
  /**  The road of the lane  */
  road: Scalars['String'];
  /**  start reference  */
  startReference: Scalars['Float'];
  /**  the lane type  */
  type: LaneType;
};

export enum CorridorLineType {
  /**  shows a dashed line on the left side  */
  Dash = 'DASH',
  /**  shows a dashed line on the right side  */
  DashOffset = 'DASH_OFFSET',
  /**  no decoration  */
  None = 'NONE',
  /**  shows a solid line on the left side  */
  Solid = 'SOLID',
  /**  shows a solid line on the right side  */
  SolidOffset = 'SOLID_OFFSET'
}

export type CorridorLinkCongestion = {
  __typename?: 'CorridorLinkCongestion';
  /**  Color code for congestion level */
  color: Scalars['String'];
  /**  Detector group ID assigned to the corridor link */
  detectorGroupId?: Maybe<Scalars['ID']>;
  /**  Current occupancy percentage */
  occupancy?: Maybe<Scalars['Float']>;
};

export type CorridorPreset = {
  __typename?: 'CorridorPreset';
  /**  identifier  */
  id: Scalars['ID'];
  /**  is the default preset for the type  */
  isDefault: Scalars['Boolean'];
  /**  name  */
  name: Scalars['String'];
  /**  rotation  */
  rotation: Scalars['Int'];
  /**  scale  */
  scale: Scalars['Float'];
  /**  schematic type to use preset  */
  type: CorridorPresetType;
  /**  x  */
  x: Scalars['Float'];
  /**  y  */
  y: Scalars['Float'];
};

export type CorridorPresetInput = {
  /**  identifier  */
  id: Scalars['ID'];
  /**  is the default preset for the type  */
  isDefault: Scalars['Boolean'];
  /**  name  */
  name: Scalars['String'];
  /**  rotation  */
  rotation: Scalars['Int'];
  /**  scale  */
  scale: Scalars['Float'];
  /**  schematic type to use preset  */
  type: CorridorPresetType;
  /**  x  */
  x: Scalars['Float'];
  /**  y  */
  y: Scalars['Float'];
};

export enum CorridorPresetType {
  /**  config schematic  */
  Configuration = 'CONFIGURATION',
  /**  response schematic  */
  Response = 'RESPONSE',
  /**  view schematic  */
  View = 'VIEW',
  /**  widget schematic  */
  Widget = 'WIDGET'
}

export type CorridorRule = {
  __typename?: 'CorridorRule';
  /**  if the rule is to be executed automatically  */
  automatic: Scalars['Boolean'];
  /**  associated corridor  */
  corridorId: Scalars['String'];
  /**  rule description  */
  description?: Maybe<Scalars['String']>;
  /**  if the rule is enabled for evaluation  */
  enabled: Scalars['Boolean'];
  /**  rule identifier  */
  id: Scalars['ID'];
  /**  rule name  */
  name: Scalars['String'];
  /**  rule priority  */
  priority: Scalars['Int'];
  /**  the mvel rule string  */
  rule: Scalars['String'];
  /**  the sign message template  */
  template: SignMessage;
  /**  rule tree  */
  tree: Scalars['Object'];
  /**  rule type  */
  type: CorridorRuleType;
};

export type CorridorRuleConnection = {
  __typename?: 'CorridorRuleConnection';
  edges: Array<CorridorRuleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CorridorRuleEdge = {
  __typename?: 'CorridorRuleEdge';
  cursor?: Maybe<Scalars['String']>;
  node: CorridorRule;
};

export type CorridorRuleInput = {
  /**  if the rule is to be executed automatically  */
  automatic: Scalars['Boolean'];
  /**  associated corridor  */
  corridorId: Scalars['String'];
  /**  rule description  */
  description?: InputMaybe<Scalars['String']>;
  /**  if the rule is enabled for evaluation  */
  enabled: Scalars['Boolean'];
  /**  rule identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  rule name  */
  name: Scalars['String'];
  /**  rule priority  */
  priority: Scalars['Int'];
  /**  the mvel rule string  */
  rule: Scalars['String'];
  /**  the sign message template  */
  template: SignMessageInput;
  /**  rule tree  */
  tree: Scalars['Object'];
  /**  rule type  */
  type: CorridorRuleType;
};

export type CorridorRuleInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  corridor identifier for rules  */
  corridorId?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum CorridorRuleType {
  Queue = 'QUEUE',
  Tolling = 'TOLLING',
  Weather = 'WEATHER'
}

export enum CorridorType {
  /**  corridor  */
  Corridor = 'CORRIDOR',
  /**  tunnel  */
  Tunnel = 'TUNNEL'
}

export type CorridorZone = {
  __typename?: 'CorridorZone';
  /**  if the landmark is in both directions  */
  bothDirections: Scalars['Boolean'];
  /**  color  */
  color: Scalars['String'];
  /**  direction  */
  direction?: Maybe<Direction>;
  /**  end reference point  */
  endReference: Scalars['Float'];
  /**  identifier  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
  /**  start reference point  */
  startReference: Scalars['Float'];
};

export type CorridorZoneInput = {
  /**  if the landmark is in both directions  */
  bothDirections: Scalars['Boolean'];
  /**  color  */
  color: Scalars['String'];
  /**  direction  */
  direction?: InputMaybe<Direction>;
  /**  end reference point  */
  endReference: Scalars['Float'];
  /**  identifier  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
  /**  start reference point  */
  startReference: Scalars['Float'];
};

export type CountAggregation = {
  __typename?: 'CountAggregation';
  /**  Previous trending number of results */
  trend: Scalars['Int'];
  /**  Number of results */
  value: Scalars['Int'];
};

export type CrosshairStatus = {
  __typename?: 'CrosshairStatus';
  anchor?: Maybe<IconAnchor>;
  color?: Maybe<SignalOutputColor>;
  phase?: Maybe<Scalars['Int']>;
  type?: Maybe<SignalIndicationType>;
};

export type Crosswalk = {
  __typename?: 'Crosswalk';
  description?: Maybe<Scalars['String']>;
  geometry: Scalars['Object'];
  id: Scalars['ID'];
};

export type CrosswalkInput = {
  description?: InputMaybe<Scalars['String']>;
  geometry: Scalars['Object'];
  id: Scalars['ID'];
};

export enum DbInstanceType {
  Historical = 'HISTORICAL',
  HistoricalFederated = 'HISTORICAL_FEDERATED',
  Operational = 'OPERATIONAL',
  OperationalFederated = 'OPERATIONAL_FEDERATED'
}

export type DailyTimeInterval = {
  /**  The days of the week upon which to fire. 1-7 as defined by Calendar.SUNDAY - Calendar.SATURDAY. */
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /**  The time of day to complete firing at the given interval. */
  endTimeOfDay?: InputMaybe<TimeOfDay>;
  /**  Get the the number of times for interval this job should repeat, after which it will be automatically deleted. leave blank to indefinitely repeat. */
  repeatCount?: InputMaybe<Scalars['Int']>;
  repeatInterval?: InputMaybe<RepeatInterval>;
  /**  The time of day to start firing at the given interval. */
  startTimeOfDay?: InputMaybe<TimeOfDay>;
};

export type DataPoint = {
  __typename?: 'DataPoint';
  x: Scalars['String'];
  y: Scalars['String'];
};

export type DataSource = {
  __typename?: 'DataSource';
  /**  the attributes for the data source  */
  attributes: Scalars['Object'];
  /**  the config for the data source  */
  config: DataSourceConfig;
  /**  if the option is available for selection  */
  enabled?: Maybe<Scalars['Boolean']>;
  /**  the identifier of data source  */
  id: Scalars['ID'];
  /**  identifies if it is a system source  */
  system?: Maybe<Scalars['Boolean']>;
  /**  the value of the data source  */
  value: Scalars['String'];
};

export type DataSourceConfig = {
  __typename?: 'DataSourceConfig';
  /**  the fields for the data source object  */
  fields: Array<FieldConfig>;
  /**  the identifier of the form  */
  id: Scalars['ID'];
  /**  the module that the form belongs to  */
  module: KineticModule;
  /**  the name of the data source object  */
  name: Scalars['String'];
  /**  identifies if source config is read only */
  readOnly?: Maybe<Scalars['Boolean']>;
  /**  identifies if it is a system source config  */
  system?: Maybe<Scalars['Boolean']>;
};

export type DataSourceConfigConnection = {
  __typename?: 'DataSourceConfigConnection';
  /**  connection edges  */
  edges: Array<DataSourceConfigConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type DataSourceConfigConnectionEdge = {
  __typename?: 'DataSourceConfigConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: DataSourceConfig;
};

export type DataSourceConfigInput = {
  /**  the field configs for the data source object  */
  fields: Array<FieldConfigInput>;
  /**  the identifier of the form  */
  id?: InputMaybe<Scalars['ID']>;
  /**  the module that the form belongs to  */
  module: KineticModule;
  /**  the name of the data source object  */
  name: Scalars['String'];
};

export type DataSourceConfigInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  Kinetic Module to filter by  */
  module?: InputMaybe<KineticModule>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type DataSourceConnection = {
  __typename?: 'DataSourceConnection';
  /**  connection edges  */
  edges: Array<DataSourceConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type DataSourceConnectionEdge = {
  __typename?: 'DataSourceConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: DataSource;
};

export type DataSourceInput = {
  /**  the attributes for the data source  */
  attributes: Scalars['Object'];
  /**  the form config for the data source  */
  configId: Scalars['String'];
  /**  if the option is available for selection  */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**  the identifier of data source  */
  id?: InputMaybe<Scalars['ID']>;
  /**  the value of the data source  */
  value: Scalars['String'];
};

export type DataSourceInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  return only enabled data sources if true, otherwise return all  */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  data source collection id  */
  formId?: InputMaybe<Scalars['ID']>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum DataType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  Numeric = 'NUMERIC',
  String = 'STRING'
}

export enum DataTypes {
  Control = 'CONTROL',
  ParameterTransactionNotRequired = 'PARAMETER_TRANSACTION_NOT_REQUIRED',
  ParameterTransactionRequired = 'PARAMETER_TRANSACTION_REQUIRED',
  Status = 'STATUS',
  Unknown = 'UNKNOWN'
}

export type DatabaseComparisonMibValue = {
  __typename?: 'DatabaseComparisonMibValue';
  bitIndex?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  indexes?: Maybe<Array<Maybe<Scalars['Int']>>>;
  name: Scalars['String'];
  shortName: Scalars['String'];
  tableName: Scalars['String'];
  value?: Maybe<Scalars['Object']>;
};

export type DatabaseExportTemplate = {
  __typename?: 'DatabaseExportTemplate';
  /**  Device protocol / API the template can be used with  */
  deviceApi: DeviceViewsProtocolEntityEnum;
  id: Scalars['ID'];
  /**  Unique name of the template  */
  name: Scalars['String'];
  /**  Tables to be exported. This must be internal names, e.g. MaxViewPhaseTimingPlansGrid  */
  tableNames: Array<Scalars['String']>;
};

export type DatabaseExportTemplateInput = {
  deviceApi: DeviceViewsProtocolEntityEnum;
  /**  Existing template ID to update, or null to create a new template  */
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  tableNames: Array<Scalars['String']>;
};

export enum DatabaseLockAction {
  Lock = 'LOCK',
  Unlock = 'UNLOCK'
}

export enum DatabaseLockUpdateAction {
  Admin = 'ADMIN',
  TimedUnlock = 'TIMED_UNLOCK',
  User = 'USER'
}

export type DatabaseMibValue = {
  bitIndex?: InputMaybe<Scalars['Int']>;
  indexes?: InputMaybe<Array<Scalars['Int']>>;
  name: Scalars['String'];
  shortName: Scalars['String'];
  tableName: Scalars['String'];
  value?: InputMaybe<Scalars['Object']>;
};

export type DatabasePatternIdExport = {
  databaseId: Scalars['String'];
  id: Scalars['Int'];
  intersectionId: Scalars['String'];
  pattern: Scalars['Int'];
};

export type DatabaseReportProtocolInput = {
  /**  Exclude defaults  */
  excludeDefaults?: InputMaybe<Scalars['Boolean']>;
  /**  Exclude zeroes for some tables  */
  excludeZeros?: InputMaybe<Scalars['Boolean']>;
  protocol: DeviceViewsProtocolEntityEnum;
  /**  Table standard names to export */
  tableNames: Array<Scalars['String']>;
};

export type DatabaseValidation = {
  __typename?: 'DatabaseValidation';
  results?: Maybe<Array<DatabaseValidationResult>>;
  status?: Maybe<DatabaseValidationStatus>;
};

export type DatabaseValidationResult = {
  __typename?: 'DatabaseValidationResult';
  description: Scalars['String'];
  severity: DatabaseValidationSeverity;
};

export enum DatabaseValidationSeverity {
  Error = 'ERROR',
  Fatal = 'FATAL',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum DatabaseValidationStatus {
  NotRun = 'NOT_RUN',
  Valid = 'VALID',
  ValidatedWithErrors = 'VALIDATED_WITH_ERRORS',
  ValidatedWithWarnings = 'VALIDATED_WITH_WARNINGS',
  ValidationAccepted = 'VALIDATION_ACCEPTED',
  ValidationFailed = 'VALIDATION_FAILED',
  ValidationRejected = 'VALIDATION_REJECTED',
  ValidationRunning = 'VALIDATION_RUNNING'
}

export type DateRange = {
  __typename?: 'DateRange';
  /** Range end timestamp */
  endTimestamp: Scalars['DateTime'];
  /** Range start timestamp */
  startTimestamp: Scalars['DateTime'];
};

export type DateRangeInput = {
  /** Range end timestamp */
  endTimestamp: Scalars['DateTime'];
  /** Range start timestamp */
  startTimestamp: Scalars['DateTime'];
};

export type DateTasks = {
  __typename?: 'DateTasks';
  /**  the date for the tasks  */
  date: Scalars['DateTime'];
  /**  the list of task occurrences for the range  */
  tasks?: Maybe<Array<Maybe<TaskOccurrence>>>;
};

export enum DateViewType {
  Daily = 'DAILY',
  DailyRealtime = 'DAILY_REALTIME',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Detection = {
  __typename?: 'Detection';
  alertId?: Maybe<Scalars['String']>;
  alertStates: Array<Maybe<AlertState>>;
  alerts: Array<Maybe<Alert>>;
  associatedEventIds?: Maybe<Array<Scalars['String']>>;
  confidence?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  examined?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastUpdated: Scalars['DateTime'];
  location?: Maybe<Scalars['Object']>;
  severity?: Maybe<Severity>;
  sourceNames?: Maybe<Array<Maybe<AlertSourceName>>>;
  sources: Array<Maybe<AlertSource>>;
  status: Status;
  type?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['String']>;
};

export type DetectionConnection = {
  __typename?: 'DetectionConnection';
  edges: Array<DetectionConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DetectionConnectionEdge = {
  __typename?: 'DetectionConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Detection;
};

export type Detector = {
  __typename?: 'Detector';
  /** axle 1 weight lane wise upper and lower threshold */
  axle1WeightThreshold?: Maybe<Array<DetectorWeightThreshold>>;
  classScheme?: Maybe<Scalars['String']>;
  communicationParameters?: Maybe<Scalars['Object']>;
  communicationState?: Maybe<CommunicationState>;
  /** Configuration Settings */
  configSettings?: Maybe<Scalars['Object']>;
  connectInterval?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  /** the protocol of the device */
  deviceProtocol?: Maybe<Scalars['String']>;
  deviceType?: Maybe<DetectorDeviceType>;
  /** current direction  */
  direction?: Maybe<Scalars['String']>;
  /** direction description configuration */
  directionDescriptions?: Maybe<Array<DirectionDescriptionConfig>>;
  equipmentNumber?: Maybe<Scalars['Float']>;
  /**  If this weather station is owned by an external center  */
  external: Scalars['Boolean'];
  /**  The ID of the external center that owns this weather station  */
  externalCenter?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  /** gross weight lane wise upper and lower threshold */
  grossWeightThreshold?: Maybe<Array<DetectorWeightThreshold>>;
  hiTrac?: Maybe<HiTrac>;
  id: Scalars['ID'];
  /** If detector is reversed  */
  isReversed: Scalars['Boolean'];
  /** lane description configuration */
  laneDescription?: Maybe<Array<DetectorLaneDescriptionConfig>>;
  /**  lane direction  */
  laneDirection?: Maybe<Direction>;
  /**  lane data  */
  lanes: Array<DetectorLaneData>;
  /**  last connect  */
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  lastVehicle?: Maybe<DetectorVehicle>;
  location?: Maybe<Scalars['Object']>;
  maneuvers?: Maybe<Array<DetectorManeuverSettingConfig>>;
  maxGrossWeight?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  /** Predict next-hour traffic for a given detector using 5 weeks of historical hourly data  */
  nextHourTrafficForecast: Array<LaneVolumeForecast>;
  numberOfLanes?: Maybe<Scalars['Int']>;
  /**  primary direction  */
  primaryDirection?: Maybe<Scalars['String']>;
  /**  reference point  */
  referencePoint?: Maybe<Scalars['Float']>;
  /**  road  */
  road?: Maybe<Scalars['String']>;
  roadType?: Maybe<Scalars['String']>;
  siteImages?: Maybe<Array<File>>;
  siteNumber?: Maybe<Scalars['Float']>;
  /** speed bins configuration */
  speedBins?: Maybe<Array<DetectorSpeedBinConfig>>;
  speedLimit?: Maybe<Scalars['Float']>;
  speedUnit?: Maybe<Scalars['String']>;
  /** system enabled flag */
  systemEnabled?: Maybe<Scalars['Boolean']>;
  timeZone?: Maybe<Scalars['String']>;
  timezoneId?: Maybe<Scalars['String']>;
  type?: Maybe<DetectorType>;
};

export type DetectorActivity = {
  __typename?: 'DetectorActivity';
  count?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  level?: Maybe<FieldConfigOption>;
  message?: Maybe<FieldConfigOption>;
  parameter?: Maybe<Scalars['String']>;
  subtype?: Maybe<FieldConfigOption>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type DetectorActivityConnection = {
  __typename?: 'DetectorActivityConnection';
  edges: Array<DetectorActivityConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DetectorActivityConnectionEdge = {
  __typename?: 'DetectorActivityConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DetectorActivity;
};

export type DetectorActivityQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /**  The detector id of detector */
  detectorId: Scalars['ID'];
  /**  End time filter */
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  /**  The fields and values to filter routes */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Log level filter */
  level?: InputMaybe<DetectorLogLevel>;
  /**  Limit the number of results. We do not allow returning all docs */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. If not sent, all fields will be searched. */
  searchFields?: InputMaybe<Array<DetectorActivitySearchField>>;
  /**  Text to search for */
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<DetectorActivitySortField>;
  sortOrder?: InputMaybe<SortOrder>;
  /**  Start time filter */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export enum DetectorActivitySearchField {
  Level = 'LEVEL',
  Message = 'MESSAGE'
}

export enum DetectorActivitySortField {
  Level = 'LEVEL',
  Message = 'MESSAGE',
  Timestamp = 'TIMESTAMP'
}

export type DetectorAiClass = {
  __typename?: 'DetectorAiClass';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DetectorAlarm = {
  __typename?: 'DetectorAlarm';
  acknowledged?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
  cleared?: Maybe<Scalars['Boolean']>;
  clearedAt?: Maybe<Scalars['DateTime']>;
  count?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  detector?: Maybe<Detector>;
  firstReceivedAt?: Maybe<Scalars['DateTime']>;
  group?: Maybe<DetectorAlarmGroup>;
  id: Scalars['ID'];
  receivedAt?: Maybe<Scalars['DateTime']>;
  subtypes?: Maybe<Array<DetectorAlarmSubtype>>;
  type?: Maybe<DetectorAlarmType>;
};

export type DetectorAlarmConnection = {
  __typename?: 'DetectorAlarmConnection';
  edges: Array<DetectorAlarmConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DetectorAlarmConnectionEdge = {
  __typename?: 'DetectorAlarmConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DetectorAlarm;
};

export type DetectorAlarmGroup = {
  __typename?: 'DetectorAlarmGroup';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DetectorAlarmQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /**  End time filter */
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  /**  The fields and values to filter routes */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. If not sent, all fields will be searched. */
  searchFields?: InputMaybe<Array<DetectorAlarmsSearchField>>;
  /**  Text to search for */
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<DetectorAlarmsSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  /**  Start time filter */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type DetectorAlarmSubtype = {
  __typename?: 'DetectorAlarmSubtype';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DetectorAlarmType = {
  __typename?: 'DetectorAlarmType';
  code?: Maybe<DetectorAlarmTypeCode>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  notificationEnabled?: Maybe<Scalars['String']>;
  severity?: Maybe<NotificationSeverity>;
};

export enum DetectorAlarmTypeCode {
  BackDoorOpen = 'BACK_DOOR_OPEN',
  BrownoutReset = 'BROWNOUT_RESET',
  CommunicationsFailure = 'COMMUNICATIONS_FAILURE',
  CommFail = 'COMM_FAIL',
  DataError = 'DATA_ERROR',
  FlashChipAccessFailure = 'FLASH_CHIP_ACCESS_FAILURE',
  FlashChipFault = 'FLASH_CHIP_FAULT',
  FrontDoorOpen = 'FRONT_DOOR_OPEN',
  LastConnectError = 'LAST_CONNECT_ERROR',
  LastConnectWarning = 'LAST_CONNECT_WARNING',
  LineCpuOrRtcFailure = 'LINE_CPU_OR_RTC_FAILURE',
  LoopFailure = 'LOOP_FAILURE',
  LowBattery = 'LOW_BATTERY',
  LowVoltage = 'LOW_VOLTAGE',
  MainsFail = 'MAINS_FAIL',
  MemoryCorruption = 'MEMORY_CORRUPTION',
  PrimarySelfTestFailed = 'PRIMARY_SELF_TEST_FAILED',
  ProductionDataIncomplete = 'PRODUCTION_DATA_INCOMPLETE',
  Profiler_1SelfTestFailed = 'PROFILER_1_SELF_TEST_FAILED',
  Profiler_2SelfTestFailed = 'PROFILER_2_SELF_TEST_FAILED',
  SdCardAccessFailure = 'SD_CARD_ACCESS_FAILURE',
  SdCardFault = 'SD_CARD_FAULT',
  SensorFailure = 'SENSOR_FAILURE',
  TimeDrift = 'TIME_DRIFT',
  TimeDriftError = 'TIME_DRIFT_ERROR',
  Unknown = 'UNKNOWN'
}

export enum DetectorAlarmsSearchField {
  Description = 'DESCRIPTION',
  Type = 'TYPE'
}

export enum DetectorAlarmsSortField {
  Id = 'ID',
  ReceivedAt = 'RECEIVED_AT'
}

export type DetectorAlertFrequencyOption = {
  __typename?: 'DetectorAlertFrequencyOption';
  code?: Maybe<DetectorEmailAlertFrequency>;
  label: Scalars['String'];
  types?: Maybe<Array<DetectorAlertType>>;
};

export enum DetectorAlertSubtype {
  BackDoorOpen = 'BACK_DOOR_OPEN',
  BrownoutReset = 'BROWNOUT_RESET',
  Class = 'CLASS',
  CommunicationsFailure = 'COMMUNICATIONS_FAILURE',
  CommFail = 'COMM_FAIL',
  DataError = 'DATA_ERROR',
  Direction = 'DIRECTION',
  DirectionClass = 'DIRECTION_CLASS',
  FlashChipAccessFailure = 'FLASH_CHIP_ACCESS_FAILURE',
  FlashChipFault = 'FLASH_CHIP_FAULT',
  FrontDoorOpen = 'FRONT_DOOR_OPEN',
  Htv = 'HTV',
  Lane = 'LANE',
  LaneClass = 'LANE_CLASS',
  LaneDirection = 'LANE_DIRECTION',
  LaneDirectionClass = 'LANE_DIRECTION_CLASS',
  LastConnectError = 'LAST_CONNECT_ERROR',
  LastConnectWarning = 'LAST_CONNECT_WARNING',
  LineCpuOrRtcFailure = 'LINE_CPU_OR_RTC_FAILURE',
  LoopFailure = 'LOOP_FAILURE',
  LowBattery = 'LOW_BATTERY',
  LowVoltage = 'LOW_VOLTAGE',
  MainsFail = 'MAINS_FAIL',
  MemoryCorruption = 'MEMORY_CORRUPTION',
  PrimarySelfTestFailed = 'PRIMARY_SELF_TEST_FAILED',
  ProductionDataIncomplete = 'PRODUCTION_DATA_INCOMPLETE',
  Profiler_1SelfTestFailed = 'PROFILER_1_SELF_TEST_FAILED',
  Profiler_2SelfTestFailed = 'PROFILER_2_SELF_TEST_FAILED',
  SdCardAccessFailure = 'SD_CARD_ACCESS_FAILURE',
  SdCardFault = 'SD_CARD_FAULT',
  SensorFailure = 'SENSOR_FAILURE',
  Summary = 'SUMMARY',
  TimeDrift = 'TIME_DRIFT',
  TimeDriftError = 'TIME_DRIFT_ERROR',
  Vcr = 'VCR',
  VehiclePacketMissingForDay = 'VEHICLE_PACKET_MISSING_FOR_DAY'
}

export type DetectorAlertSubtypeOption = {
  __typename?: 'DetectorAlertSubtypeOption';
  code?: Maybe<DetectorAlertSubtype>;
  label: Scalars['String'];
  type?: Maybe<DetectorAlertType>;
};

export enum DetectorAlertType {
  CaltransTns = 'CALTRANS_TNS',
  ConfigurationChange = 'CONFIGURATION_CHANGE',
  DiagnosticErrors = 'DIAGNOSTIC_ERRORS',
  Euro_6ClassSpeed = 'EURO_6_CLASS_SPEED',
  PerformanceReport = 'PERFORMANCE_REPORT',
  SpeedReport = 'SPEED_REPORT',
  VolumeReport = 'VOLUME_REPORT'
}

export type DetectorAlertTypeOption = {
  __typename?: 'DetectorAlertTypeOption';
  code?: Maybe<DetectorAlertType>;
  label: Scalars['String'];
};

export enum DetectorAxleType {
  Single = 'SINGLE',
  Tandem = 'TANDEM',
  Tridem = 'TRIDEM'
}

export type DetectorBattery = {
  __typename?: 'DetectorBattery';
  id: Scalars['ID'];
  timestamp?: Maybe<Scalars['DateTime']>;
  volts?: Maybe<Scalars['Float']>;
};

export enum DetectorBatteryGranularity {
  All = 'ALL',
  Hourly = 'HOURLY'
}

export type DetectorBatteryInputQuery = {
  /**  The detector id of detector */
  detectorId: Scalars['ID'];
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  granularity?: InputMaybe<DetectorBatteryGranularity>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type DetectorClass = {
  __typename?: 'DetectorClass';
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type DetectorClassIndex = {
  __typename?: 'DetectorClassIndex';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DetectorClassIntervalCount = {
  __typename?: 'DetectorClassIntervalCount';
  classCounts: Scalars['Object'];
  date: Scalars['String'];
  hour: Scalars['Int'];
  isDailyTotal: Scalars['Boolean'];
  isHourlyTotal: Scalars['Boolean'];
  minute: Scalars['Int'];
  total: Scalars['Int'];
};

export type DetectorConfig = {
  __typename?: 'DetectorConfig';
  classNumberOfAxles?: Maybe<Array<Scalars['Int']>>;
  classString?: Maybe<Array<Scalars['String']>>;
  detectorId?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['DateTime']>;
  extraConfig?: Maybe<DetectorExtraConfig>;
  id?: Maybe<Scalars['String']>;
  laneDirection?: Maybe<Array<Scalars['Int']>>;
  loopCorrectionFactor?: Maybe<Array<Scalars['Int']>>;
  loopLength?: Maybe<Array<Scalars['Int']>>;
  loopSensitivity?: Maybe<Array<Scalars['Int']>>;
  presenceTime?: Maybe<Array<Scalars['Int']>>;
  reverseDirection?: Maybe<Array<Scalars['Int']>>;
  roadConfiguration?: Maybe<Array<Scalars['Int']>>;
  sensorSpacing?: Maybe<Array<Scalars['Int']>>;
  storeCodes?: Maybe<Array<Scalars['Int']>>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type DetectorConfigInput = {
  classNumberOfAxles?: InputMaybe<Array<Scalars['Int']>>;
  classString?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  laneDirection?: InputMaybe<Array<Scalars['Int']>>;
  loopCorrectionFactor?: InputMaybe<Array<Scalars['Int']>>;
  loopLength?: InputMaybe<Array<Scalars['Int']>>;
  loopSensitivity?: InputMaybe<Array<Scalars['Int']>>;
  presenceTime?: InputMaybe<Array<Scalars['Int']>>;
  reverseDirection?: InputMaybe<Array<Scalars['Int']>>;
  roadConfiguration?: InputMaybe<Array<Scalars['Int']>>;
  sensorSpacing?: InputMaybe<Array<Scalars['Int']>>;
  storeCodes?: InputMaybe<Array<Scalars['Int']>>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type DetectorConnection = {
  __typename?: 'DetectorConnection';
  edges: Array<DetectorConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DetectorConnectionEdge = {
  __typename?: 'DetectorConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Detector;
};

export type DetectorConnectionGroup = {
  __typename?: 'DetectorConnectionGroup';
  bytesIncoming?: Maybe<Scalars['Int']>;
  bytesOutgoing?: Maybe<Scalars['Int']>;
  connectionPushType?: Maybe<Scalars['String']>;
  elapsedSeconds?: Maybe<Scalars['Int']>;
  groupID?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logs?: Maybe<Array<DetectorConnectionLog>>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type DetectorConnectionLog = {
  __typename?: 'DetectorConnectionLog';
  groupID?: Maybe<Scalars['String']>;
  hexDump?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  level?: Maybe<FieldConfigOption>;
  message?: Maybe<Scalars['String']>;
  messageParams?: Maybe<Scalars['Object']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type DetectorConnectionLogConnection = {
  __typename?: 'DetectorConnectionLogConnection';
  edges: Array<DetectorConnectionLogConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DetectorConnectionLogConnectionEdge = {
  __typename?: 'DetectorConnectionLogConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DetectorConnectionGroup;
};

export type DetectorConnectionLogDetailsConnection = {
  __typename?: 'DetectorConnectionLogDetailsConnection';
  edges: Array<DetectorConnectionLogDetailsConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DetectorConnectionLogDetailsConnectionEdge = {
  __typename?: 'DetectorConnectionLogDetailsConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DetectorConnectionLog;
};

export type DetectorConnectionLogDetailsQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /**  The connection id of detector */
  connectionId: Scalars['ID'];
  /**  End time filter */
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  /**  The fields and values to filter routes */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs */
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DetectorConnectionLogDetailsSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  /**  Start time filter */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export enum DetectorConnectionLogDetailsSortField {
  Timestamp = 'TIMESTAMP'
}

export type DetectorConnectionLogInput = {
  hexDump?: InputMaybe<Scalars['String']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  messageParams?: InputMaybe<Array<Scalars['Object']>>;
  numberOfBytes?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type DetectorConnectionLogQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /**  The detector id of detector */
  detectorId: Scalars['ID'];
  /**  End time filter */
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  /**  The fields and values to filter routes */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Log level filter */
  level?: InputMaybe<DetectorLogLevel>;
  /**  Limit the number of results. We do not allow returning all docs */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. If not sent, all fields will be searched. */
  searchFields?: InputMaybe<Array<DetectorConnectionLogSearchField>>;
  /**  Text to search for */
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<DetectorConnectionLogSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  /**  Start time filter */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export enum DetectorConnectionLogSearchField {
  Message = 'MESSAGE'
}

export enum DetectorConnectionLogSortField {
  Timestamp = 'TIMESTAMP'
}

/**  Device type from integrations form */
export type DetectorDeviceType = {
  __typename?: 'DetectorDeviceType';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export enum DetectorDirection {
  /**  East  */
  East = 'EAST',
  /**  North  */
  North = 'NORTH',
  /**  Northeast  */
  NorthEast = 'NORTH_EAST',
  /**  Northwest  */
  NorthWest = 'NORTH_WEST',
  /**  South  */
  South = 'SOUTH',
  /**  Southeast  */
  SouthEast = 'SOUTH_EAST',
  /**  Southwest  */
  SouthWest = 'SOUTH_WEST',
  /**  West  */
  West = 'WEST'
}

export enum DetectorEmailAlertFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Realtime = 'REALTIME',
  Weekly = 'WEEKLY'
}

export type DetectorEmailAlertSetting = {
  __typename?: 'DetectorEmailAlertSetting';
  allSites: Scalars['Boolean'];
  classGroup?: Maybe<Array<Maybe<Scalars['String']>>>;
  consecutiveAlerts?: Maybe<Scalars['Int']>;
  detectorClass?: Maybe<Array<Maybe<Scalars['String']>>>;
  detectorGroups?: Maybe<Array<DetectorGroup>>;
  detectors?: Maybe<Array<Detector>>;
  direction?: Maybe<Array<Maybe<Direction>>>;
  emailIds: Array<Scalars['String']>;
  emailTemplate?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  frequency?: Maybe<DetectorAlertFrequencyOption>;
  frequencyDay?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  interval?: Maybe<DetectorVehicleVolumeGranularity>;
  lane?: Maybe<Array<Maybe<Scalars['Int']>>>;
  performanceReportId?: Maybe<Scalars['String']>;
  reportConfig?: Maybe<DetectorReportConfiguration>;
  reportPreference?: Maybe<DetectorReportPreference>;
  reportRule?: Maybe<DetectorReportRule>;
  ruleId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  subtypes?: Maybe<Array<DetectorAlertSubtypeOption>>;
  timestamp?: Maybe<Scalars['DateTime']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<DetectorAlertTypeOption>;
  unitPreference?: Maybe<ConversionUnitType>;
  userIds: Array<Scalars['String']>;
};

export type DetectorEmailAlertSettingConnection = {
  __typename?: 'DetectorEmailAlertSettingConnection';
  /**  connection edges  */
  edges: Array<DetectorEmailAlertSettingConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type DetectorEmailAlertSettingConnectionEdge = {
  __typename?: 'DetectorEmailAlertSettingConnectionEdge';
  /**  cursor position  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: DetectorEmailAlertSetting;
};

export type DetectorEmailAlertSettingInput = {
  allSites: Scalars['Boolean'];
  classGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  consecutiveAlerts?: InputMaybe<Scalars['Int']>;
  detectorClass?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  detectorGroups?: InputMaybe<Array<Scalars['String']>>;
  detectorIds?: InputMaybe<Array<Scalars['String']>>;
  direction?: InputMaybe<Array<InputMaybe<Direction>>>;
  emailTemplate?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  frequency: DetectorEmailAlertFrequency;
  frequencyDay?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<DetectorVehicleVolumeGranularity>;
  lane?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  performanceReportId?: InputMaybe<Scalars['String']>;
  reportPreference?: InputMaybe<ReportPreference>;
  ruleId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  subtypes?: InputMaybe<Array<DetectorAlertSubtype>>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  timezone?: InputMaybe<Scalars['String']>;
  type: DetectorAlertType;
  unitPreference?: InputMaybe<ConversionUnitType>;
  userIds: Array<Scalars['String']>;
};

export type DetectorEmailAlertSettingQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type DetectorExtraConfig = {
  __typename?: 'DetectorExtraConfig';
  classConfigDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  laneDirection?: Maybe<Array<Scalars['Int']>>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  loopCorrectionFactor?: Maybe<Array<Scalars['Int']>>;
  loopLength?: Maybe<Array<Scalars['Int']>>;
  loopSensitivity?: Maybe<Array<Scalars['Int']>>;
  lowBatteryLevel?: Maybe<Scalars['Int']>;
  port?: Maybe<Scalars['Int']>;
  reverseDirection?: Maybe<Array<Scalars['Int']>>;
  roadConfiguration?: Maybe<Array<Scalars['Int']>>;
  sensorSpacing?: Maybe<Array<Scalars['Int']>>;
  siteIdentifier?: Maybe<Scalars['String']>;
  storeCodes?: Maybe<Array<Scalars['Int']>>;
  storeConfigDateTime?: Maybe<Scalars['DateTime']>;
};

export type DetectorExtraConfigInput = {
  classConfigDateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  laneDirection?: InputMaybe<Array<Scalars['Int']>>;
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  loopCorrectionFactor?: InputMaybe<Array<Scalars['Int']>>;
  loopLength?: InputMaybe<Array<Scalars['Int']>>;
  loopSensitivity?: InputMaybe<Array<Scalars['Int']>>;
  lowBatteryLevel?: InputMaybe<Scalars['Int']>;
  port?: InputMaybe<Scalars['Int']>;
  reverseDirection?: InputMaybe<Array<Scalars['Int']>>;
  roadConfiguration?: InputMaybe<Array<Scalars['Int']>>;
  sensorSpacing?: InputMaybe<Array<Scalars['Int']>>;
  siteIdentifier?: InputMaybe<Scalars['String']>;
  storeCodes?: InputMaybe<Array<Scalars['Int']>>;
  storeConfigDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type DetectorGroup = {
  __typename?: 'DetectorGroup';
  /**  the description  */
  description?: Maybe<Scalars['String']>;
  /**  associated sites  */
  detectorIds: Array<Scalars['String']>;
  /**  enabled flag */
  enabled: Scalars['Boolean'];
  /**  the id  */
  id: Scalars['ID'];
  /**  the name  */
  name: Scalars['String'];
};

export type DetectorGroupConnection = {
  __typename?: 'DetectorGroupConnection';
  /**  connection edges  */
  edges: Array<DetectorGroupConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type DetectorGroupConnectionEdge = {
  __typename?: 'DetectorGroupConnectionEdge';
  /**  cursor position  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: DetectorGroup;
};

export type DetectorGroupInput = {
  /**  the description  */
  description?: InputMaybe<Scalars['String']>;
  /**  associated Detectors  */
  detectorIds: Array<Scalars['String']>;
  /**  enabled flag  */
  enabled: Scalars['Boolean'];
  /**  the id  */
  id?: InputMaybe<Scalars['ID']>;
  /**  the name  */
  name: Scalars['String'];
};

export type DetectorGroupInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type DetectorInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Show disabled detectors */
  showDisabled?: InputMaybe<Scalars['Boolean']>;
  /**  Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type DetectorLaneData = {
  __typename?: 'DetectorLaneData';
  /**  current density  */
  density?: Maybe<Scalars['Float']>;
  /**  direction  */
  direction: Scalars['String'];
  /**  engineering lane  */
  engineeringLane: Scalars['Int'];
  /**  if the lane should be excluded from vos accumulation  */
  excludeVos?: Maybe<Scalars['Boolean']>;
  /** If detector lane is reversed */
  isReversed: Scalars['Boolean'];
  /**  lane index  */
  laneIndex: Scalars['Int'];
  /**  lane name  */
  name?: Maybe<Scalars['String']>;
  /**  current occupancy  */
  occupancy?: Maybe<Scalars['Float']>;
  /**  if the lane is reversible  */
  reversible?: Maybe<Scalars['Boolean']>;
  /**  current speed  */
  speed?: Maybe<Scalars['Float']>;
  /**  status  */
  status?: Maybe<Scalars['String']>;
  /**  total error count */
  totalErrorCount: Scalars['Int'];
  /**  lane type  */
  type: LaneType;
  /**  current volume  */
  volume?: Maybe<Scalars['Float']>;
};

export type DetectorLaneDescriptionConfig = {
  __typename?: 'DetectorLaneDescriptionConfig';
  lane?: Maybe<Scalars['Int']>;
  laneDescription?: Maybe<Scalars['String']>;
  laneIndex?: Maybe<DetectorLaneIndex>;
};

export enum DetectorLaneIndex {
  Index_1 = 'INDEX_1',
  Index_2 = 'INDEX_2',
  Index_3 = 'INDEX_3',
  Index_4 = 'INDEX_4',
  Index_5 = 'INDEX_5',
  Index_6 = 'INDEX_6',
  Index_7 = 'INDEX_7',
  Index_8 = 'INDEX_8',
  Index_9 = 'INDEX_9',
  Index_10 = 'INDEX_10',
  Index_11 = 'INDEX_11',
  Index_12 = 'INDEX_12',
  Index_13 = 'INDEX_13',
  Index_14 = 'INDEX_14',
  Index_15 = 'INDEX_15',
  Index_16 = 'INDEX_16'
}

export enum DetectorLogLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Fatal = 'FATAL',
  Info = 'INFO',
  Trace = 'TRACE',
  Warning = 'WARNING'
}

export enum DetectorLogMessage {
  AdcNonZero = 'ADC_NON_ZERO',
  AdcZero = 'ADC_ZERO',
  AntennaBaudTimeout = 'ANTENNA_BAUD_TIMEOUT',
  AntennaReconfigure = 'ANTENNA_RECONFIGURE',
  AntennaResponseId = 'ANTENNA_RESPONSE_ID',
  AntennaSearchState = 'ANTENNA_SEARCH_STATE',
  AntennaStarted = 'ANTENNA_STARTED',
  AntennaStopped = 'ANTENNA_STOPPED',
  AntennaTimedOut = 'ANTENNA_TIMED_OUT',
  AntennaUninit = 'ANTENNA_UNINIT',
  AuxiliaryAntBaudTimeout = 'AUXILIARY_ANT_BAUD_TIMEOUT',
  AuxiliaryAntReconfigure = 'AUXILIARY_ANT_RECONFIGURE',
  AuxiliaryAntResponseId = 'AUXILIARY_ANT_RESPONSE_ID',
  AuxiliaryAntSearchState = 'AUXILIARY_ANT_SEARCH_STATE',
  AuxiliaryAntStarted = 'AUXILIARY_ANT_STARTED',
  AuxiliaryAntStopped = 'AUXILIARY_ANT_STOPPED',
  AuxiliaryAntTimedOut = 'AUXILIARY_ANT_TIMED_OUT',
  AuxiliaryAntUninit = 'AUXILIARY_ANT_UNINIT',
  AuxData = 'AUX_DATA',
  BadOffset = 'BAD_OFFSET',
  BatteryVoltage = 'BATTERY_VOLTAGE',
  BatteryVoltageWarning = 'BATTERY_VOLTAGE_WARNING',
  BluetoothDisabled = 'BLUETOOTH_DISABLED',
  BluetoothReady = 'BLUETOOTH_READY',
  BtConfigFail = 'BT_CONFIG_FAIL',
  BtNoCarrier = 'BT_NO_CARRIER',
  BtReconfigure = 'BT_RECONFIGURE',
  BtResetFail = 'BT_RESET_FAIL',
  BtWaitRing = 'BT_WAIT_RING',
  ClassTableChange = 'CLASS_TABLE_CHANGE',
  ClearanceText = 'CLEARANCE_TEXT',
  ClockSpeed = 'CLOCK_SPEED',
  CodeDebug = 'CODE_DEBUG',
  CommsOverflow = 'COMMS_OVERFLOW',
  ConfigurationChange = 'CONFIGURATION_CHANGE',
  ConfigSaveErr = 'CONFIG_SAVE_ERR',
  Connection = 'CONNECTION',
  CreateDummyVeh = 'CREATE_DUMMY_VEH',
  CreateDummyVeh2 = 'CREATE_DUMMY_VEH2',
  CurrentFirmware = 'CURRENT_FIRMWARE',
  DaylightSavingBias = 'DAYLIGHT_SAVING_BIAS',
  DaylightSavingChange = 'DAYLIGHT_SAVING_CHANGE',
  DaysDiff = 'DAYS_DIFF',
  DebugMac = 'DEBUG_MAC',
  DetectionFirmware = 'DETECTION_FIRMWARE',
  DeviceReady = 'DEVICE_READY',
  DiagnosticCode = 'DIAGNOSTIC_CODE',
  DialinConnected = 'DIALIN_CONNECTED',
  EndOffset = 'END_OFFSET',
  Erase_4K = 'ERASE_4K',
  Ethernet = 'ETHERNET',
  EthernetConfig = 'ETHERNET_CONFIG',
  EthernetConnect = 'ETHERNET_CONNECT',
  EthernetConnectFail = 'ETHERNET_CONNECT_FAIL',
  EthernetHeartbeatMissed = 'ETHERNET_HEARTBEAT_MISSED',
  EthernetPowerdown = 'ETHERNET_POWERDOWN',
  EthernetPowerup = 'ETHERNET_POWERUP',
  EthernetReady = 'ETHERNET_READY',
  EthernetSocketClosed = 'ETHERNET_SOCKET_CLOSED',
  FinishModem = 'FINISH_MODEM',
  FirmwareDebug = 'FIRMWARE_DEBUG',
  FirmwareState = 'FIRMWARE_STATE',
  FirmwareUpdate = 'FIRMWARE_UPDATE',
  FirstSensor = 'FIRST_SENSOR',
  FlashAddress = 'FLASH_ADDRESS',
  FlashEraseFailed = 'FLASH_ERASE_FAILED',
  FlashId = 'FLASH_ID',
  FlashReadFailed = 'FLASH_READ_FAILED',
  FlashWriteFailed = 'FLASH_WRITE_FAILED',
  ForceReboot = 'FORCE_REBOOT',
  FtpBadPassword = 'FTP_BAD_PASSWORD',
  FtpBadUsername = 'FTP_BAD_USERNAME',
  FtpConnect = 'FTP_CONNECT',
  FtpDeleteFile = 'FTP_DELETE_FILE',
  FtpDownloadFile = 'FTP_DOWNLOAD_FILE',
  FtpHangup = 'FTP_HANGUP',
  FtpListen = 'FTP_LISTEN',
  FtpListening = 'FTP_LISTENING',
  FtpListFiles = 'FTP_LIST_FILES',
  FtpLoginSuccess = 'FTP_LOGIN_SUCCESS',
  FtpShutdown = 'FTP_SHUTDOWN',
  GatewayReady = 'GATEWAY_READY',
  GprsConnected = 'GPRS_CONNECTED',
  GprsConnectTimeout = 'GPRS_CONNECT_TIMEOUT',
  GprsDataCheck = 'GPRS_DATA_CHECK',
  GprsDisconnected = 'GPRS_DISCONNECTED',
  GprsRxError = 'GPRS_RX_ERROR',
  GprsState = 'GPRS_STATE',
  GprsTransferBlockEnd = 'GPRS_TRANSFER_BLOCK_END',
  GprsTransferBlockStart = 'GPRS_TRANSFER_BLOCK_START',
  GprsTransferDataEnd = 'GPRS_TRANSFER_DATA_END',
  GprsTransferDataStart = 'GPRS_TRANSFER_DATA_START',
  GprsTransferEnd = 'GPRS_TRANSFER_END',
  GprsTransferSize = 'GPRS_TRANSFER_SIZE',
  GprsTransferStart = 'GPRS_TRANSFER_START',
  GpsError = 'GPS_ERROR',
  GpsReady = 'GPS_READY',
  HaltTimeError = 'HALT_TIME_ERROR',
  HeaderFound = 'HEADER_FOUND',
  HeaderWrap = 'HEADER_WRAP',
  HicommCsFail = 'HICOMM_CS_FAIL',
  HicommError = 'HICOMM_ERROR',
  HicommInstruction = 'HICOMM_INSTRUCTION',
  HourIndex = 'HOUR_INDEX',
  HourInvalid = 'HOUR_INVALID',
  Iccid = 'ICCID',
  InvalidTimeSets = 'INVALID_TIME_SETS',
  IwrapVersion = 'IWRAP_VERSION',
  LegacyConfigUpdate = 'LEGACY_CONFIG_UPDATE',
  Log_3V3A = 'LOG_3V3A',
  LogPointer = 'LOG_POINTER',
  LogVsys = 'LOG_VSYS',
  MacConfigChange = 'MAC_CONFIG_CHANGE',
  MappingUpdate = 'MAPPING_UPDATE',
  MapDayPointer = 'MAP_DAY_POINTER',
  Memory = 'MEMORY',
  MemoryReadAddress = 'MEMORY_READ_ADDRESS',
  MemoryReadFail = 'MEMORY_READ_FAIL',
  MemoryReset = 'MEMORY_RESET',
  MemoryWriteAddress = 'MEMORY_WRITE_ADDRESS',
  MemoryWriteOversize = 'MEMORY_WRITE_OVERSIZE',
  Modem = 'MODEM',
  Modem_2G = 'MODEM_2G',
  Modem_4GSignal = 'MODEM_4G_SIGNAL',
  ModemActivationFail = 'MODEM_ACTIVATION_FAIL',
  ModemArfcn = 'MODEM_ARFCN',
  ModemAtFailed = 'MODEM_AT_FAILED',
  ModemAuthType = 'MODEM_AUTH_TYPE',
  ModemAutoband = 'MODEM_AUTOBAND',
  ModemBands = 'MODEM_BANDS',
  ModemBandsUtms = 'MODEM_BANDS_UTMS',
  ModemBer = 'MODEM_BER',
  ModemBoardType = 'MODEM_BOARD_TYPE',
  ModemChangeBands = 'MODEM_CHANGE_BANDS',
  ModemChangeBandsUtms = 'MODEM_CHANGE_BANDS_UTMS',
  ModemClass = 'MODEM_CLASS',
  ModemCommand = 'MODEM_COMMAND',
  ModemConnectFail = 'MODEM_CONNECT_FAIL',
  ModemContext = 'MODEM_CONTEXT',
  ModemDcdLow = 'MODEM_DCD_LOW',
  ModemDebug = 'MODEM_DEBUG',
  ModemDebug2 = 'MODEM_DEBUG2',
  ModemDebugNetwork = 'MODEM_DEBUG_NETWORK',
  ModemDebugRssi = 'MODEM_DEBUG_RSSI',
  ModemDebugSim = 'MODEM_DEBUG_SIM',
  ModemEarfcn = 'MODEM_EARFCN',
  ModemError = 'MODEM_ERROR',
  ModemFirmware = 'MODEM_FIRMWARE',
  ModemImei = 'MODEM_IMEI',
  ModemMessage = 'MODEM_MESSAGE',
  ModemModel = 'MODEM_MODEL',
  ModemModelName = 'MODEM_MODEL_NAME',
  ModemNetworkName = 'MODEM_NETWORK_NAME',
  ModemNetworkRegistration = 'MODEM_NETWORK_REGISTRATION',
  ModemNoCarrier = 'MODEM_NO_CARRIER',
  ModemNoNetwork = 'MODEM_NO_NETWORK',
  ModemNoSignal = 'MODEM_NO_SIGNAL',
  ModemNoSim = 'MODEM_NO_SIM',
  ModemOkFail = 'MODEM_OK_FAIL',
  ModemPowerFail = 'MODEM_POWER_FAIL',
  ModemPowerRetry = 'MODEM_POWER_RETRY',
  ModemPowerSaveMode = 'MODEM_POWER_SAVE_MODE',
  ModemReady = 'MODEM_READY',
  ModemRepeat = 'MODEM_REPEAT',
  ModemResetFail = 'MODEM_RESET_FAIL',
  ModemResetRetry = 'MODEM_RESET_RETRY',
  ModemShutdownFail = 'MODEM_SHUTDOWN_FAIL',
  ModemStatus = 'MODEM_STATUS',
  ModemStopShutdown = 'MODEM_STOP_SHUTDOWN',
  ModemUarfcn = 'MODEM_UARFCN',
  ModemUsageChange = 'MODEM_USAGE_CHANGE',
  ModemWaitDialin = 'MODEM_WAIT_DIALIN',
  MoteHealthCheck = 'MOTE_HEALTH_CHECK',
  MoteTableFlash = 'MOTE_TABLE_FLASH',
  MoteTableFull = 'MOTE_TABLE_FULL',
  NetworkCellId = 'NETWORK_CELL_ID',
  NetworkDetach = 'NETWORK_DETACH',
  NetworkFirewall = 'NETWORK_FIREWALL',
  NetworkName = 'NETWORK_NAME',
  NetworkType = 'NETWORK_TYPE',
  NewMapKey = 'NEW_MAP_KEY',
  NoVolumeByLane = 'NO_VOLUME_BY_LANE',
  NtcipInfo = 'NTCIP_INFO',
  OldestVbvIndex = 'OLDEST_VBV_INDEX',
  OutputOff = 'OUTPUT_OFF',
  OutputOn = 'OUTPUT_ON',
  PacketNetworkType = 'PACKET_NETWORK_TYPE',
  PacketWrap = 'PACKET_WRAP',
  PeripheralAreaFetch = 'PERIPHERAL_AREA_FETCH',
  PgsApiError = 'PGS_API_ERROR',
  PgsVehicleCount = 'PGS_VEHICLE_COUNT',
  PmError = 'PM_ERROR',
  PmPowerDown = 'PM_POWER_DOWN',
  PmPowerUp = 'PM_POWER_UP',
  PowerSwitch = 'POWER_SWITCH',
  Pro1Config = 'PRO1_CONFIG',
  Pro1DataSize = 'PRO1_DATA_SIZE',
  Pro1ExtStatusChange = 'PRO1_EXT_STATUS_CHANGE',
  Pro1Firmware = 'PRO1_FIRMWARE',
  Pro1Nak = 'PRO1_NAK',
  Pro1StateChange = 'PRO1_STATE_CHANGE',
  Pro1StatusChange = 'PRO1_STATUS_CHANGE',
  Pro1TxCount = 'PRO1_TX_COUNT',
  Pro1TxError = 'PRO1_TX_ERROR',
  Pro2Config = 'PRO2_CONFIG',
  Pro2DataSize = 'PRO2_DATA_SIZE',
  Pro2ExtStatusChange = 'PRO2_EXT_STATUS_CHANGE',
  Pro2Firmware = 'PRO2_FIRMWARE',
  Pro2Nak = 'PRO2_NAK',
  Pro2StateChange = 'PRO2_STATE_CHANGE',
  Pro2StatusChange = 'PRO2_STATUS_CHANGE',
  Pro2TxCount = 'PRO2_TX_COUNT',
  Pro2TxError = 'PRO2_TX_ERROR',
  ProbeFault = 'PROBE_FAULT',
  ProbeRecover = 'PROBE_RECOVER',
  ProcessorTemperature = 'PROCESSOR_TEMPERATURE',
  Profiler = 'PROFILER',
  ProConfig = 'PRO_CONFIG',
  ProConfig2 = 'PRO_CONFIG2',
  ReadFlashMsg = 'READ_FLASH_MSG',
  ReadLog = 'READ_LOG',
  ReadLogGprs = 'READ_LOG_GPRS',
  Reconfig = 'RECONFIG',
  ReedSwitch = 'REED_SWITCH',
  ReflashFirmware = 'REFLASH_FIRMWARE',
  ResetLog = 'RESET_LOG',
  ResetPin = 'RESET_PIN',
  ResetReason = 'RESET_REASON',
  ResetSd = 'RESET_SD',
  ResetUnknown = 'RESET_UNKNOWN',
  Rtc = 'RTC',
  RtcDisabled = 'RTC_DISABLED',
  RtcFail = 'RTC_FAIL',
  RtcOscFault = 'RTC_OSC_FAULT',
  RtcOsfCleared = 'RTC_OSF_CLEARED',
  RtcTime = 'RTC_TIME',
  RtcTimeDay = 'RTC_TIME_DAY',
  RtcTimeDow = 'RTC_TIME_DOW',
  RtcTimeFail = 'RTC_TIME_FAIL',
  RtcTimeHour = 'RTC_TIME_HOUR',
  RtcTimeMinute = 'RTC_TIME_MINUTE',
  RtcTimeMonth = 'RTC_TIME_MONTH',
  RtcTimeSecond = 'RTC_TIME_SECOND',
  RtcTimeYear = 'RTC_TIME_YEAR',
  RtError = 'RT_ERROR',
  RtPowerDown = 'RT_POWER_DOWN',
  RtPowerUp = 'RT_POWER_UP',
  RtStatus = 'RT_STATUS',
  SdCardAccess = 'SD_CARD_ACCESS',
  SdCardNotPresent = 'SD_CARD_NOT_PRESENT',
  SdCardPresent = 'SD_CARD_PRESENT',
  SdErrorCode = 'SD_ERROR_CODE',
  SdFail = 'SD_FAIL',
  SdInitFail = 'SD_INIT_FAIL',
  SdInvalidCard = 'SD_INVALID_CARD',
  SdInvalidResponse = 'SD_INVALID_RESPONSE',
  SdManfDate = 'SD_MANF_DATE',
  SdManfId = 'SD_MANF_ID',
  SdNotIdle = 'SD_NOT_IDLE',
  SdNumAttempts = 'SD_NUM_ATTEMPTS',
  SdNumBlocks = 'SD_NUM_BLOCKS',
  SdOem = 'SD_OEM',
  SdPreEraseInvalid = 'SD_PRE_ERASE_INVALID',
  SdR1Response = 'SD_R1_RESPONSE',
  SdR2Response = 'SD_R2_RESPONSE',
  SdR3Response = 'SD_R3_RESPONSE',
  SdReadFail = 'SD_READ_FAIL',
  SdReadResponse = 'SD_READ_RESPONSE',
  SdReadStatusFail = 'SD_READ_STATUS_FAIL',
  SdReboot = 'SD_REBOOT',
  SdSerial = 'SD_SERIAL',
  SdTransferFail = 'SD_TRANSFER_FAIL',
  SdWriteBlockFail = 'SD_WRITE_BLOCK_FAIL',
  SdWriteProtect = 'SD_WRITE_PROTECT',
  SdWriteResponse = 'SD_WRITE_RESPONSE',
  SearchHeader = 'SEARCH_HEADER',
  SecurityText = 'SECURITY_TEXT',
  SendingConnect = 'SENDING_CONNECT',
  Sensor = 'SENSOR',
  SensorsPerLane = 'SENSORS_PER_LANE',
  Sensor_1Average = 'SENSOR_1_AVERAGE',
  Sensor_2Average = 'SENSOR_2_AVERAGE',
  Sensor_3Average = 'SENSOR_3_AVERAGE',
  Sensor_4Average = 'SENSOR_4_AVERAGE',
  Sensor_5Average = 'SENSOR_5_AVERAGE',
  Sensor_6Average = 'SENSOR_6_AVERAGE',
  Sensor_7Average = 'SENSOR_7_AVERAGE',
  Sensor_8Average = 'SENSOR_8_AVERAGE',
  Sensor_9Average = 'SENSOR_9_AVERAGE',
  Sensor_10Average = 'SENSOR_10_AVERAGE',
  Sensor_11Average = 'SENSOR_11_AVERAGE',
  Sensor_12Average = 'SENSOR_12_AVERAGE',
  Sensor_13Average = 'SENSOR_13_AVERAGE',
  Sensor_14Average = 'SENSOR_14_AVERAGE',
  Sensor_15Average = 'SENSOR_15_AVERAGE',
  Sensor_16Average = 'SENSOR_16_AVERAGE',
  SensorLane = 'SENSOR_LANE',
  SensorProbeNew = 'SENSOR_PROBE_NEW',
  SensorProbeOld = 'SENSOR_PROBE_OLD',
  SentEscape = 'SENT_ESCAPE',
  ShutdownBatteryVoltage = 'SHUTDOWN_BATTERY_VOLTAGE',
  SignalQuality = 'SIGNAL_QUALITY',
  SizeRecord = 'SIZE_RECORD',
  SlaveError = 'SLAVE_ERROR',
  SlaveResetReason = 'SLAVE_RESET_REASON',
  SlaveStackMemory = 'SLAVE_STACK_MEMORY',
  SlaveStackPointerFunc = 'SLAVE_STACK_POINTER_FUNC',
  SlaveStackPointerVal = 'SLAVE_STACK_POINTER_VAL',
  SocketError = 'SOCKET_ERROR',
  SolarVoltage = 'SOLAR_VOLTAGE',
  Spi1Error = 'SPI1_ERROR',
  Spi1Nak = 'SPI1_NAK',
  Spi1Reset = 'SPI1_RESET',
  Spi1SendError = 'SPI1_SEND_ERROR',
  Spi2Error = 'SPI2_ERROR',
  Spi2Nak = 'SPI2_NAK',
  Spi2Reset = 'SPI2_RESET',
  Spi2SendError = 'SPI2_SEND_ERROR',
  SpiError = 'SPI_ERROR',
  StackMemory = 'STACK_MEMORY',
  StackPointerFunc = 'STACK_POINTER_FUNC',
  StackPointerVal = 'STACK_POINTER_VAL',
  StartupBatteryVoltage = 'STARTUP_BATTERY_VOLTAGE',
  StartGps = 'START_GPS',
  StartModem = 'START_MODEM',
  StopGps = 'STOP_GPS',
  StrainOffset = 'STRAIN_OFFSET',
  StrainZero = 'STRAIN_ZERO',
  StrainZeroComplete = 'STRAIN_ZERO_COMPLETE',
  System = 'SYSTEM',
  SystemHalt = 'SYSTEM_HALT',
  SystemInit = 'SYSTEM_INIT',
  SystemInitComplete = 'SYSTEM_INIT_COMPLETE',
  TdfAddress = 'TDF_ADDRESS',
  TdfAddress_4K = 'TDF_ADDRESS_4K',
  TdfDaysDiff = 'TDF_DAYS_DIFF',
  TdfErase_4K = 'TDF_ERASE_4K',
  TdfHoursCopied = 'TDF_HOURS_COPIED',
  TdfHoursDiff = 'TDF_HOURS_DIFF',
  TdfInvalid = 'TDF_INVALID',
  TdfReset = 'TDF_RESET',
  TdfSaveHour = 'TDF_SAVE_HOUR',
  TelitAtFailed = 'TELIT_AT_FAILED',
  TimeDiff = 'TIME_DIFF',
  TimeUpdate = 'TIME_UPDATE',
  TnlUpdated = 'TNL_UPDATED',
  TransFlashSz = 'TRANS_FLASH_SZ',
  TransLastHour = 'TRANS_LAST_HOUR',
  UiDelay = 'UI_DELAY',
  Unknown1 = 'UNKNOWN1',
  Unknown2 = 'UNKNOWN2',
  Unknown3 = 'UNKNOWN3',
  Unknown4 = 'UNKNOWN4',
  UserRequestFactoryReset = 'USER_REQUEST_FACTORY_RESET',
  ValidDateTime = 'VALID_DATE_TIME',
  Vbv = 'VBV',
  VbvDayUsage = 'VBV_DAY_USAGE',
  VbvHourSdPointer = 'VBV_HOUR_SD_POINTER',
  VbvHourUsage = 'VBV_HOUR_USAGE',
  VbvLastDate = 'VBV_LAST_DATE',
  VbvLastFullHour = 'VBV_LAST_FULL_HOUR',
  VbvLastPartialHour = 'VBV_LAST_PARTIAL_HOUR',
  VbvMaxDayStorage = 'VBV_MAX_DAY_STORAGE',
  VbvPointer = 'VBV_POINTER',
  VbvReadFail = 'VBV_READ_FAIL',
  VbvSdPointer = 'VBV_SD_POINTER',
  VbvTransferDataEnd = 'VBV_TRANSFER_DATA_END',
  VbvTransferDataStart = 'VBV_TRANSFER_DATA_START',
  VbvTransferEnd = 'VBV_TRANSFER_END',
  VbvTransferStart = 'VBV_TRANSFER_START',
  VehicleBytes = 'VEHICLE_BYTES',
  VehicleCount = 'VEHICLE_COUNT',
  VehicleFront = 'VEHICLE_FRONT',
  WaitRingTimeout = 'WAIT_RING_TIMEOUT',
  WanIp = 'WAN_IP',
  WatchdogTimeout = 'WATCHDOG_TIMEOUT',
  WriteFlashMsg = 'WRITE_FLASH_MSG',
  WsError = 'WS_ERROR',
  WsPowerDown = 'WS_POWER_DOWN',
  WsPowerUp = 'WS_POWER_UP'
}

export type DetectorLogSubtype = {
  __typename?: 'DetectorLogSubtype';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DetectorManeuverSettingConfig = {
  __typename?: 'DetectorManeuverSettingConfig';
  destinationDirection?: Maybe<Scalars['String']>;
  maneuverDescription?: Maybe<Scalars['String']>;
  maneuverId?: Maybe<Scalars['String']>;
  originDirection?: Maybe<Scalars['String']>;
};

export type DetectorMeanGrossWeightReportQuery = {
  classGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  className?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  detectorIds: Array<Scalars['ID']>;
  endDate: Scalars['Date'];
  lane?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  laneDirection?: InputMaybe<Array<InputMaybe<Direction>>>;
  startDate: Scalars['Date'];
  unitPreference: ConversionUnitType;
  viewType: DateViewType;
};

export type DetectorMeanGrossWeightReportResult = {
  __typename?: 'DetectorMeanGrossWeightReportResult';
  columns: Array<Scalars['String']>;
  rows: Array<Scalars['Object']>;
};

export type DetectorPerformanceReportAvailabilityQuery = {
  detectorIds: Array<Scalars['ID']>;
  endDateTime: Scalars['Date'];
  ruleIds: Array<Scalars['ID']>;
  startDateTime: Scalars['Date'];
};

export type DetectorPerformanceReportDayWiseAvailabilityDetailInfo = {
  __typename?: 'DetectorPerformanceReportDayWiseAvailabilityDetailInfo';
  date?: Maybe<Scalars['String']>;
  detector?: Maybe<Detector>;
  rule?: Maybe<DetectorReportRule>;
};

export type DetectorPerformanceReportDayWiseAvailabilityInfo = {
  __typename?: 'DetectorPerformanceReportDayWiseAvailabilityInfo';
  availability?: Maybe<Array<DetectorReportRuleAvailability>>;
  date?: Maybe<Scalars['String']>;
  rules?: Maybe<Array<DetectorReportRule>>;
};

export type DetectorPerformanceReportQuery = {
  detectorIds: Array<Scalars['ID']>;
  endDateTime: Scalars['Date'];
  ruleId: Scalars['ID'];
  startDateTime: Scalars['Date'];
};

export type DetectorPerformanceReportResult = {
  __typename?: 'DetectorPerformanceReportResult';
  date?: Maybe<Scalars['String']>;
  detector?: Maybe<Detector>;
  intervalList?: Maybe<Array<Scalars['Object']>>;
};

export type DetectorReceiverIpPort = {
  __typename?: 'DetectorReceiverIpPort';
  ip: Scalars['String'];
  port: Scalars['Int'];
};

export enum DetectorRecordAvailability {
  Full = 'FULL',
  NoConnect = 'NO_CONNECT',
  NoData = 'NO_DATA',
  Partial = 'PARTIAL'
}

export type DetectorReportConfigFormSection = FormSection & {
  __typename?: 'DetectorReportConfigFormSection';
  fields: Array<FieldConfig>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DetectorReportConfigFormView = FormView & {
  __typename?: 'DetectorReportConfigFormView';
  id: Scalars['ID'];
  name: Scalars['String'];
  sections: Array<DetectorReportConfigFormSection>;
  type: FormViewType;
  views: Array<DetectorReportConfigFormView>;
};

export type DetectorReportConfiguration = {
  __typename?: 'DetectorReportConfiguration';
  defaultSelection?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ruleIds?: Maybe<Array<Scalars['String']>>;
};

export type DetectorReportConfigurationConnection = {
  __typename?: 'DetectorReportConfigurationConnection';
  edges: Array<DetectorReportConfigurationConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DetectorReportConfigurationConnectionEdge = {
  __typename?: 'DetectorReportConfigurationConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DetectorReportConfiguration;
};

export type DetectorReportConfigurationInput = {
  defaultSelection?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  ruleIds?: InputMaybe<Array<Scalars['String']>>;
};

export type DetectorReportPreference = {
  __typename?: 'DetectorReportPreference';
  /** Preferred date format */
  dateFormat: Scalars['String'];
  /** Preferred time format */
  timeFormat: Scalars['String'];
};

export type DetectorReportRule = {
  __typename?: 'DetectorReportRule';
  config: DetectorReportRuleConfig;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  reportTemplateName: Scalars['String'];
  template: DetectorReportTemplate;
};

export type DetectorReportRuleAvailability = {
  __typename?: 'DetectorReportRuleAvailability';
  availability?: Maybe<Scalars['Boolean']>;
  ruleId?: Maybe<Scalars['String']>;
};

export type DetectorReportRuleConfig = {
  __typename?: 'DetectorReportRuleConfig';
  comparableQuery?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  settings: Scalars['Object'];
};

export type DetectorReportRuleConnection = {
  __typename?: 'DetectorReportRuleConnection';
  edges: Array<DetectorReportRuleConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DetectorReportRuleConnectionEdge = {
  __typename?: 'DetectorReportRuleConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DetectorReportRule;
};

export type DetectorReportRuleForm = {
  __typename?: 'DetectorReportRuleForm';
  extraConfig: Scalars['Object'];
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  reportTemplate?: Maybe<DetectorReportTemplate>;
  views: Array<DetectorReportConfigFormView>;
};

export type DetectorReportRuleInput = {
  comparableQuery?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  settings: Scalars['Object'];
  template: DetectorReportTemplate;
};

export enum DetectorReportTemplate {
  AiClassAccuracyCheck = 'AI_CLASS_ACCURACY_CHECK',
  AxleDataCheck = 'AXLE_DATA_CHECK',
  HistoricalCompareCheck = 'HISTORICAL_COMPARE_CHECK',
  MissingDataCheck = 'MISSING_DATA_CHECK',
  RatioCheck = 'RATIO_CHECK',
  ZeroFlowCheck = 'ZERO_FLOW_CHECK'
}

export type DetectorReportTemplateOption = {
  __typename?: 'DetectorReportTemplateOption';
  code?: Maybe<DetectorReportTemplate>;
  label?: Maybe<Scalars['String']>;
};

export type DetectorSpeedBinConfig = {
  __typename?: 'DetectorSpeedBinConfig';
  speedBinIndex?: Maybe<Scalars['Int']>;
  speedBinName?: Maybe<Scalars['String']>;
  speedEndRange?: Maybe<Scalars['Float']>;
  speedStartRange?: Maybe<Scalars['Float']>;
};

export type DetectorSpeedReportQuery = {
  detectorId: Scalars['ID'];
  endDate: Scalars['Date'];
  lane?: InputMaybe<Scalars['Int']>;
  laneDirection?: InputMaybe<Direction>;
  startDate: Scalars['Date'];
};

export type DetectorTmasReport = {
  __typename?: 'DetectorTMASReport';
  content?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DetectorTmasReportQuery = {
  detectorId: Scalars['ID'];
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
  type: DetectorTmasReportType;
};

export enum DetectorTmasReportType {
  TnsClass = 'TNS_CLASS',
  TnsVolume = 'TNS_VOLUME'
}

export type DetectorTurningReport = {
  __typename?: 'DetectorTurningReport';
  classNames: Array<Scalars['String']>;
  data: Array<DetectorTurningReportOriginData>;
};

export type DetectorTurningReportDestinationData = {
  __typename?: 'DetectorTurningReportDestinationData';
  data: Array<DetectorClassIntervalCount>;
  isInwardTotal: Scalars['Boolean'];
  isOutwardTotal: Scalars['Boolean'];
  name: Scalars['String'];
  total: Scalars['Int'];
};

export type DetectorTurningReportOriginData = {
  __typename?: 'DetectorTurningReportOriginData';
  data: Array<DetectorTurningReportDestinationData>;
  inwardCount: Scalars['Int'];
  name: Scalars['String'];
  outwardCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type DetectorTurningReportQuery = {
  detectorId: Scalars['ID'];
  endDate: Scalars['Date'];
  granularity: DetectorVehicleVolumeGranularity;
  reportPreference?: InputMaybe<ReportPreference>;
  startDate: Scalars['Date'];
  viewType: DateViewType;
};

export enum DetectorType {
  Classifier = 'CLASSIFIER',
  CyclePed = 'CYCLE_PED',
  VideoDetector = 'VIDEO_DETECTOR',
  Wim = 'WIM'
}

export type DetectorVehicle = {
  __typename?: 'DetectorVehicle';
  aiClassName?: Maybe<Scalars['String']>;
  aiClassVerified?: Maybe<Scalars['Boolean']>;
  aiClassVerifiedCodes?: Maybe<Array<Maybe<DetectorVehicleVerificationStatus>>>;
  aiClassVerifiedTS?: Maybe<Scalars['DateTime']>;
  aiConfidence?: Maybe<Scalars['Int']>;
  anprImageAvailable?: Maybe<Scalars['Boolean']>;
  axleSpace1?: Maybe<Scalars['Float']>;
  axleSpace2?: Maybe<Scalars['Float']>;
  axleSpace3?: Maybe<Scalars['Float']>;
  axleSpace4?: Maybe<Scalars['Float']>;
  axleSpace5?: Maybe<Scalars['Float']>;
  axleSpace6?: Maybe<Scalars['Float']>;
  axleSpace7?: Maybe<Scalars['Float']>;
  axleSpace8?: Maybe<Scalars['Float']>;
  axleSpace9?: Maybe<Scalars['Float']>;
  axleSpace10?: Maybe<Scalars['Float']>;
  axleSpace11?: Maybe<Scalars['Float']>;
  axleSpace12?: Maybe<Scalars['Float']>;
  axleSpace13?: Maybe<Scalars['Float']>;
  axleSpace14?: Maybe<Scalars['Float']>;
  axleSpace15?: Maybe<Scalars['Float']>;
  axleSpace16?: Maybe<Scalars['Float']>;
  axleSpace17?: Maybe<Scalars['Float']>;
  axleSpace18?: Maybe<Scalars['Float']>;
  axleSpace19?: Maybe<Scalars['Float']>;
  axleSpace20?: Maybe<Scalars['Float']>;
  axleSpace21?: Maybe<Scalars['Float']>;
  axleSpace22?: Maybe<Scalars['Float']>;
  axleSpace23?: Maybe<Scalars['Float']>;
  axleSpace24?: Maybe<Scalars['Float']>;
  axleSpace25?: Maybe<Scalars['Float']>;
  axleSpace26?: Maybe<Scalars['Float']>;
  axleSpace27?: Maybe<Scalars['Float']>;
  axleSpace28?: Maybe<Scalars['Float']>;
  axleSpace29?: Maybe<Scalars['Float']>;
  axleSpacings?: Maybe<Array<Scalars['Int']>>;
  axleType1?: Maybe<DetectorAxleType>;
  axleType2?: Maybe<DetectorAxleType>;
  axleType3?: Maybe<DetectorAxleType>;
  axleType4?: Maybe<DetectorAxleType>;
  axleType5?: Maybe<DetectorAxleType>;
  axleType6?: Maybe<DetectorAxleType>;
  axleType7?: Maybe<DetectorAxleType>;
  axleType8?: Maybe<DetectorAxleType>;
  axleType9?: Maybe<DetectorAxleType>;
  axleType10?: Maybe<DetectorAxleType>;
  axleWeight1?: Maybe<Scalars['Float']>;
  axleWeight2?: Maybe<Scalars['Float']>;
  axleWeight3?: Maybe<Scalars['Float']>;
  axleWeight4?: Maybe<Scalars['Float']>;
  axleWeight5?: Maybe<Scalars['Float']>;
  axleWeight6?: Maybe<Scalars['Float']>;
  axleWeight7?: Maybe<Scalars['Float']>;
  axleWeight8?: Maybe<Scalars['Float']>;
  axleWeight9?: Maybe<Scalars['Float']>;
  axleWeight10?: Maybe<Scalars['Float']>;
  axleWeight11?: Maybe<Scalars['Float']>;
  axleWeight12?: Maybe<Scalars['Float']>;
  axleWeight13?: Maybe<Scalars['Float']>;
  axleWeight14?: Maybe<Scalars['Float']>;
  axleWeight15?: Maybe<Scalars['Float']>;
  axleWeight16?: Maybe<Scalars['Float']>;
  axleWeight17?: Maybe<Scalars['Float']>;
  axleWeight18?: Maybe<Scalars['Float']>;
  axleWeight19?: Maybe<Scalars['Float']>;
  axleWeight20?: Maybe<Scalars['Float']>;
  axleWeight21?: Maybe<Scalars['Float']>;
  axleWeight22?: Maybe<Scalars['Float']>;
  axleWeight23?: Maybe<Scalars['Float']>;
  axleWeight24?: Maybe<Scalars['Float']>;
  axleWeight25?: Maybe<Scalars['Float']>;
  axleWeight26?: Maybe<Scalars['Float']>;
  axleWeight27?: Maybe<Scalars['Float']>;
  axleWeight28?: Maybe<Scalars['Float']>;
  axleWeight29?: Maybe<Scalars['Float']>;
  axleWeight30?: Maybe<Scalars['Float']>;
  axlesCount?: Maybe<Scalars['Int']>;
  chassisCode?: Maybe<Scalars['Int']>;
  classInfo?: Maybe<DetectorClass>;
  dimensionProfile?: Maybe<File>;
  dimensionProfileAvailable?: Maybe<Scalars['Boolean']>;
  direction?: Maybe<HiTracVehicleDirection>;
  firstConnectAt?: Maybe<Scalars['DateTime']>;
  grossWeight?: Maybe<Scalars['Float']>;
  headerTimestamp?: Maybe<Scalars['DateTime']>;
  headway?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  images?: Maybe<Array<File>>;
  imagesAvailable?: Maybe<Scalars['Boolean']>;
  lane?: Maybe<Scalars['Int']>;
  laneDirection?: Maybe<DetectorDirection>;
  lastAxleSpeed?: Maybe<Scalars['Int']>;
  leftTyreType?: Maybe<Array<Scalars['Int']>>;
  legalStatus?: Maybe<Scalars['Int']>;
  legalStatusCodes?: Maybe<Array<LegalStatusCode>>;
  length?: Maybe<Scalars['Int']>;
  loopFailure?: Maybe<Scalars['Boolean']>;
  loopOnTime?: Maybe<Scalars['Int']>;
  loopSignature?: Maybe<File>;
  loopSignatureAvailable?: Maybe<Scalars['Boolean']>;
  maneuverId?: Maybe<Scalars['String']>;
  maxChassisList?: Maybe<Array<Scalars['Int']>>;
  minChassisList?: Maybe<Array<Scalars['Int']>>;
  ocr?: Maybe<Scalars['String']>;
  ocrRear?: Maybe<Scalars['String']>;
  overViewImageAvailable?: Maybe<Scalars['Boolean']>;
  overWeight?: Maybe<Scalars['Boolean']>;
  rightTyreType?: Maybe<Array<Scalars['Int']>>;
  sensorWeights?: Maybe<Array<Array<Scalars['Int']>>>;
  sensorWheelWeights?: Maybe<Array<Scalars['Int']>>;
  serial?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['Float']>;
  straddle?: Maybe<Scalars['Boolean']>;
  straddleLane?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  temperature?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  typeAPositions?: Maybe<Array<Scalars['Int']>>;
  typeBPositions?: Maybe<Array<Scalars['Int']>>;
  tyreA1Parameter?: Maybe<Scalars['Int']>;
  tyreA2Parameter?: Maybe<Scalars['Int']>;
  tyreA3Parameter?: Maybe<Scalars['Int']>;
  tyreA4Parameter?: Maybe<Scalars['Int']>;
  tyreB1Parameter?: Maybe<Scalars['Int']>;
  tyreB2Parameter?: Maybe<Scalars['Int']>;
  tyreB3Parameter?: Maybe<Scalars['Int']>;
  tyreB4Parameter?: Maybe<Scalars['Int']>;
  validity?: Maybe<Array<HiTracVehicleValidity>>;
  verifiedAiClassName?: Maybe<Scalars['String']>;
  verifiedClassIndex?: Maybe<Scalars['Int']>;
  verifiedClassName?: Maybe<Scalars['String']>;
  verifiedClassNameStatus?: Maybe<Scalars['Boolean']>;
  verifiedClassNameStatusAt?: Maybe<Scalars['DateTime']>;
  verifiedClassNameStatusCodes?: Maybe<Array<Maybe<DetectorVehicleVerificationStatus>>>;
  wheelBase?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type DetectorVehicle3DProfile = {
  __typename?: 'DetectorVehicle3DProfile';
  dimensionProfile: Array<Array<Scalars['Int']>>;
  id: Scalars['String'];
};

export type DetectorVehicleAxleWeightChart = {
  __typename?: 'DetectorVehicleAxleWeightChart';
  data?: Maybe<Array<DetectorVehicleAxleWeightChartDetail>>;
  lane?: Maybe<Scalars['Int']>;
};

export type DetectorVehicleAxleWeightChartDetail = {
  __typename?: 'DetectorVehicleAxleWeightChartDetail';
  averageWeight: Scalars['Int'];
  grossWeight: Scalars['Int'];
  temperature: Scalars['Int'];
  timestamp: Scalars['DateTime'];
};

export type DetectorVehicleAxleWeightChartQuery = {
  classIndex: Scalars['Int'];
  detectorId: Scalars['ID'];
  endDate: Scalars['Date'];
  granularity: DetectorVehicleVolumeGranularity;
  startDate: Scalars['Date'];
};

export type DetectorVehicleConnection = {
  __typename?: 'DetectorVehicleConnection';
  edges: Array<DetectorVehicleConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DetectorVehicleConnectionEdge = {
  __typename?: 'DetectorVehicleConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DetectorVehicle;
};

export type DetectorVehicleDayWiseAvailability = {
  __typename?: 'DetectorVehicleDayWiseAvailability';
  availability?: Maybe<DetectorRecordAvailability>;
  id?: Maybe<Scalars['String']>;
};

export type DetectorVehicleDayWiseAvailabilityQuery = {
  detectorIds: Array<Scalars['ID']>;
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
};

export type DetectorVehicleDayWisePartialData = {
  __typename?: 'DetectorVehicleDayWisePartialData';
  numberOfPartialDataOccurance?: Maybe<Scalars['Int']>;
  packetLossDate?: Maybe<Scalars['String']>;
  packetLossInfo: Array<DetectorVehiclePartialData>;
  totalMissingRecordCount?: Maybe<Scalars['Int']>;
};

export type DetectorVehicleImportProgress = {
  __typename?: 'DetectorVehicleImportProgress';
  fileIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  status?: Maybe<DetectorVehicleImportStatus>;
  type?: Maybe<DetectorVehicleImportType>;
};

export type DetectorVehicleImportProgressInput = {
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<DetectorVehicleImportStatus>;
  type?: InputMaybe<DetectorVehicleImportType>;
};

export enum DetectorVehicleImportStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export enum DetectorVehicleImportType {
  VehicleImport = 'VEHICLE_IMPORT'
}

export type DetectorVehiclePartialData = {
  __typename?: 'DetectorVehiclePartialData';
  endSerial?: Maybe<Scalars['Int']>;
  missingRecordsCount?: Maybe<Scalars['Int']>;
  packetLossEndTime?: Maybe<Scalars['DateTime']>;
  packetLossStartTime?: Maybe<Scalars['DateTime']>;
  startSerial?: Maybe<Scalars['Int']>;
};

export type DetectorVehicleQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /**  The class index of vehicle */
  classIndexes?: InputMaybe<Array<Scalars['Int']>>;
  /**  The class name of vehicle */
  classNames?: InputMaybe<Array<Scalars['String']>>;
  /**  The detector id of detector */
  detectorId: Scalars['ID'];
  /**  End time filter */
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  /**  The fields and values to filter routes */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs */
  limit?: InputMaybe<Scalars['Int']>;
  /**  date and time format */
  reportPreference?: InputMaybe<ReportPreference>;
  /**  The fields to search for the search text. If not sent, all fields will be searched. */
  searchFields?: InputMaybe<Array<DetectorVehiclesSearchField>>;
  /**  Text to search for */
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<DetectorVehiclesSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  /**  Start time filter */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type DetectorVehicleSignature = {
  __typename?: 'DetectorVehicleSignature';
  id: Scalars['String'];
  signature: Array<Scalars['Int']>;
};

export type DetectorVehicleSpeedBinReport = {
  __typename?: 'DetectorVehicleSpeedBinReport';
  averageSpeed?: Maybe<Scalars['Int']>;
  hour?: Maybe<Scalars['Int']>;
  lane?: Maybe<Scalars['Int']>;
  laneDirection?: Maybe<Direction>;
  speedAt85Percent?: Maybe<Scalars['Int']>;
  speedBinInfo?: Maybe<Scalars['Object']>;
  speedStandardDeviation?: Maybe<Scalars['Int']>;
  totalVolume?: Maybe<Scalars['Int']>;
};

export type DetectorVehicleSpeedBinReportResult = {
  __typename?: 'DetectorVehicleSpeedBinReportResult';
  intervals?: Maybe<Array<DetectorVehicleSpeedBinReport>>;
};

export enum DetectorVehicleVerificationStatus {
  NonVerified = 'NON_VERIFIED',
  Verified = 'VERIFIED',
  VerifiedCorrectClass = 'VERIFIED_CORRECT_CLASS',
  VerifiedWrongClass = 'VERIFIED_WRONG_CLASS'
}

export type DetectorVehicleVolume = {
  __typename?: 'DetectorVehicleVolume';
  timestamp?: Maybe<Scalars['DateTime']>;
  volume?: Maybe<Scalars['Int']>;
};

export type DetectorVehicleVolumeCount = {
  __typename?: 'DetectorVehicleVolumeCount';
  count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type DetectorVehicleVolumeCountQuery = {
  detectorId: Scalars['ID'];
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
};

export enum DetectorVehicleVolumeGranularity {
  All = 'ALL',
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Minutes_1 = 'MINUTES_1',
  Minutes_5 = 'MINUTES_5',
  Minutes_10 = 'MINUTES_10',
  Minutes_15 = 'MINUTES_15',
  Minutes_30 = 'MINUTES_30'
}

export enum DetectorVehicleVolumeGroup {
  Class = 'CLASS',
  Direction = 'DIRECTION',
  DirectionClass = 'DIRECTION_CLASS',
  Lane = 'LANE',
  LaneClass = 'LANE_CLASS',
  LaneDirection = 'LANE_DIRECTION',
  LaneDirectionClass = 'LANE_DIRECTION_CLASS',
  Maneuver = 'MANEUVER',
  ManeuverClass = 'MANEUVER_CLASS',
  SpeedBand = 'SPEED_BAND',
  Summary = 'SUMMARY'
}

export type DetectorVehicleVolumeGroupCountsQuery = {
  detectorId: Scalars['ID'];
  endDateTime: Scalars['DateTime'];
  groupBy?: InputMaybe<DetectorVehicleVolumeGroup>;
  startDateTime: Scalars['DateTime'];
};

export type DetectorVehicleVolumeGroupInfo = {
  __typename?: 'DetectorVehicleVolumeGroupInfo';
  name?: Maybe<Scalars['String']>;
  volumeInfo?: Maybe<Array<DetectorVehicleVolume>>;
};

export type DetectorVehicleVolumeIntervalCount = {
  __typename?: 'DetectorVehicleVolumeIntervalCount';
  date?: Maybe<Scalars['String']>;
  intervalList?: Maybe<Array<DetectorVehicleVolumeIntervalInfo>>;
  lane?: Maybe<Scalars['String']>;
  laneDirection?: Maybe<Scalars['String']>;
  maneuver?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  peaks?: Maybe<DetectorVolumePeaks>;
};

export type DetectorVehicleVolumeIntervalCountsClearQuery = {
  detectorId: Scalars['ID'];
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
};

export type DetectorVehicleVolumeIntervalCountsQuery = {
  dateRanges: Array<DateRangeInput>;
  detectorIds: Array<Scalars['ID']>;
  granularity?: InputMaybe<DetectorVehicleVolumeGranularity>;
  groupBy?: InputMaybe<DetectorVehicleVolumeGroup>;
  viewType: DateViewType;
};

export type DetectorVehicleVolumeIntervalInfo = {
  __typename?: 'DetectorVehicleVolumeIntervalInfo';
  count?: Maybe<Scalars['Int']>;
  hour?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['Int']>;
};

export type DetectorVehicleVolumeQuery = {
  detectorId: Scalars['ID'];
  endDateTime: Scalars['DateTime'];
  granularity?: InputMaybe<DetectorVehicleVolumeGranularity>;
  groupBy?: InputMaybe<DetectorVehicleVolumeGroup>;
  startDateTime: Scalars['DateTime'];
};

export type DetectorVehicleYearlySummary = {
  __typename?: 'DetectorVehicleYearlySummary';
  averageDailyTraffic?: Maybe<Scalars['Float']>;
  averageSpeed?: Maybe<Scalars['Float']>;
  averageSpeedAt85Percent?: Maybe<Scalars['Float']>;
  coverage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type DetectorVehicleYearlySummaryQuery = {
  detectorId: Scalars['ID'];
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  viewType?: InputMaybe<DateViewType>;
};

export enum DetectorVehiclesSearchField {
  AiClassName = 'AI_CLASS_NAME',
  Ocr = 'OCR',
  RearOcr = 'REAR_OCR',
  VerifiedAiClassName = 'VERIFIED_AI_CLASS_NAME'
}

export enum DetectorVehiclesSortField {
  Lane = 'LANE',
  Serial = 'SERIAL',
  Speed = 'SPEED',
  Timestamp = 'TIMESTAMP'
}

export type DetectorVerificationClass = {
  __typename?: 'DetectorVerificationClass';
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DetectorVolumePeaks = {
  __typename?: 'DetectorVolumePeaks';
  amPeakCount?: Maybe<Scalars['Int']>;
  amPeakHour?: Maybe<Scalars['Int']>;
  average?: Maybe<Scalars['Int']>;
  daytimeAverage?: Maybe<Scalars['Int']>;
  daytimeTotal?: Maybe<Scalars['Int']>;
  nightTimeAverage?: Maybe<Scalars['Int']>;
  nightTimeTotal?: Maybe<Scalars['Int']>;
  pmPeakCount?: Maybe<Scalars['Int']>;
  pmPeakHour?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  twelveHourAverage?: Maybe<Scalars['Int']>;
  twelveHourTotal?: Maybe<Scalars['Int']>;
  weekdayAverage?: Maybe<Scalars['Int']>;
  weekdayTotal?: Maybe<Scalars['Int']>;
  weekendAverage?: Maybe<Scalars['Int']>;
  weekendTotal?: Maybe<Scalars['Int']>;
};

export type DetectorWeather = {
  __typename?: 'DetectorWeather';
  date?: Maybe<Scalars['String']>;
  detectorId?: Maybe<Scalars['String']>;
  hour?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  weatherInfo?: Maybe<Weather>;
};

export type DetectorWeatherQuery = {
  detectorId: Scalars['ID'];
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
};

export type DetectorWeightThreshold = {
  __typename?: 'DetectorWeightThreshold';
  lane?: Maybe<Scalars['Int']>;
  laneIndex?: Maybe<DetectorLaneIndex>;
  weightLowerThreshold?: Maybe<Scalars['Float']>;
  weightUpperThreshold?: Maybe<Scalars['Float']>;
};

export type DeviceDatabase = {
  __typename?: 'DeviceDatabase';
  approved: Scalars['Boolean'];
  approvedComment?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  archived: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  databaseValidation?: Maybe<DatabaseValidation>;
  end?: Maybe<Scalars['DateTime']>;
  files: Array<DeviceDatabaseFile>;
  firmwareVersion?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intersectionId: Scalars['String'];
  locked: Scalars['Boolean'];
  lockedByUser?: Maybe<OrganizationKineticUser>;
  lockedDate?: Maybe<Scalars['DateTime']>;
  progress?: Maybe<Scalars['Int']>;
  protocol?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  status?: Maybe<DeviceDatabaseStatus>;
  type: DeviceDatabaseType;
  user?: Maybe<OrganizationKineticUser>;
};

export type DeviceDatabaseActionUpdated = {
  __typename?: 'DeviceDatabaseActionUpdated';
  hasActiveDatabaseAction: Scalars['Boolean'];
  intersectionId: Scalars['ID'];
};

export type DeviceDatabaseComparison = {
  __typename?: 'DeviceDatabaseComparison';
  compareDatabaseId: Scalars['ID'];
  differences: Array<DeviceDatabaseComparisonDifference>;
  originalDatabaseId: Scalars['ID'];
};

export type DeviceDatabaseComparisonDifference = {
  __typename?: 'DeviceDatabaseComparisonDifference';
  compareMib: DatabaseComparisonMibValue;
  originalMib: DatabaseComparisonMibValue;
  type: DeviceDatabaseComparisonDifferenceType;
};

export enum DeviceDatabaseComparisonDifferenceType {
  Added = 'ADDED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type DeviceDatabaseConnection = {
  __typename?: 'DeviceDatabaseConnection';
  edges: Array<DeviceDatabaseConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DeviceDatabaseConnectionEdge = {
  __typename?: 'DeviceDatabaseConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DeviceDatabase;
};

export type DeviceDatabaseFile = {
  __typename?: 'DeviceDatabaseFile';
  format: DeviceDatabaseFormat;
  key: Scalars['String'];
  url: Scalars['String'];
};

export type DeviceDatabaseFileRequest = {
  fileId?: InputMaybe<Scalars['String']>;
  fileKey?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
};

export enum DeviceDatabaseFormat {
  Bin = 'BIN',
  Json = 'JSON'
}

export type DeviceDatabaseLock = {
  __typename?: 'DeviceDatabaseLock';
  databaseId?: Maybe<Scalars['String']>;
  intersectionId: Scalars['String'];
  lockedDate: Scalars['DateTime'];
  userDisplayName: Scalars['String'];
  userId: Scalars['String'];
};

export type DeviceDatabaseLockStatus = {
  __typename?: 'DeviceDatabaseLockStatus';
  action: DatabaseLockAction;
  databaseId?: Maybe<Scalars['String']>;
  databaseType: DeviceDatabaseType;
  intersectionId: Scalars['String'];
  updatedBy: DatabaseLockUpdateAction;
  userDisplayName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type DeviceDatabaseMibChangeLog = {
  __typename?: 'DeviceDatabaseMibChangeLog';
  comment?: Maybe<Scalars['String']>;
  databaseId?: Maybe<Scalars['String']>;
  databaseName?: Maybe<Scalars['String']>;
  deviceDatabaseType?: Maybe<DeviceDatabaseType>;
  id: Scalars['ID'];
  intersectionId: Scalars['String'];
  mib?: Maybe<Scalars['Object']>;
  updatedAt: Scalars['DateTime'];
  userDisplayName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type DeviceDatabaseMibChangeLogConnection = {
  __typename?: 'DeviceDatabaseMibChangeLogConnection';
  edges: Array<DeviceDatabaseMibChangeLogConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DeviceDatabaseMibChangeLogConnectionEdge = {
  __typename?: 'DeviceDatabaseMibChangeLogConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DeviceDatabaseMibChangeLog;
};

export enum DeviceDatabaseStatus {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  FieldReady = 'FIELD_READY',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED'
}

export enum DeviceDatabaseType {
  Draft = 'DRAFT',
  FullDownload = 'FULL_DOWNLOAD',
  Live = 'LIVE',
  ManualUpload = 'MANUAL_UPLOAD',
  PartialDownload = 'PARTIAL_DOWNLOAD',
  PostLockUpload = 'POST_LOCK_UPLOAD',
  ScheduledUpload = 'SCHEDULED_UPLOAD',
  UserSavedUpload = 'USER_SAVED_UPLOAD'
}

export type DeviceEvent = {
  __typename?: 'DeviceEvent';
  deviceId: Scalars['String'];
  id: Scalars['ID'];
  intersectionId: Scalars['String'];
  parameter?: Maybe<Scalars['Object']>;
  timestamp: Scalars['DateTime'];
  vendorEventCode: Scalars['Int'];
};

export type DeviceEventConnection = {
  __typename?: 'DeviceEventConnection';
  edges: Array<DeviceEventConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DeviceEventConnectionEdge = {
  __typename?: 'DeviceEventConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: DeviceEvent;
};

export enum DeviceViewsProtocolEntityEnum {
  CaltransAb3418E = 'CALTRANS_AB3418E',
  Dynamic = 'DYNAMIC',
  EconoliteAsc3 = 'ECONOLITE_ASC3',
  EconoliteEos = 'ECONOLITE_EOS',
  Maxtime = 'MAXTIME',
  MaxtimeRampmeter = 'MAXTIME_RAMPMETER',
  SiemensSepac = 'SIEMENS_SEPAC'
}

export type DeviceViewsUi = {
  __typename?: 'DeviceViewsUi';
  id: DeviceViewsProtocolEntityEnum;
  views: IntersectionDeviceUiView;
};

export enum Direction {
  /**  East  */
  East = 'EAST',
  /**  North  */
  North = 'NORTH',
  /**  Other  */
  Other = 'OTHER',
  /**  Reversible  */
  Reversible = 'REVERSIBLE',
  /**  South  */
  South = 'SOUTH',
  /**  West  */
  West = 'WEST'
}

export type DirectionDescriptionConfig = {
  __typename?: 'DirectionDescriptionConfig';
  description: Scalars['String'];
  direction: Scalars['String'];
};

export type DirectionalProgrammedSplits = {
  __typename?: 'DirectionalProgrammedSplits';
  down?: Maybe<PhaseServiceTimes>;
  up?: Maybe<PhaseServiceTimes>;
};

export type Directory = {
  __typename?: 'Directory';
  directories: Array<Directory>;
  id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  owner: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  publicAccess: Scalars['Boolean'];
  readOnly: Scalars['Boolean'];
};

export type DirectoryInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  publicAccess?: InputMaybe<Scalars['Boolean']>;
};

export type EffectivePrivilegeAssignment = {
  __typename?: 'EffectivePrivilegeAssignment';
  kineticModule: KineticModule;
  privilegeType: PrivilegeType;
  restrictedAreas: Array<Scalars['Object']>;
  restrictedEntities?: Maybe<Scalars['Object']>;
  restrictedIntegrationGroups?: Maybe<Array<Scalars['String']>>;
  restrictedIntegrations: Array<Scalars['String']>;
  restrictedLocationGroups?: Maybe<Array<Scalars['String']>>;
  restrictedLocations?: Maybe<Array<Scalars['String']>>;
};

export type Element = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export type EmailAttachment = {
  data: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
};

export type EmailMessage = {
  attachments: Array<EmailAttachment>;
  bcc?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['Object']>;
  html?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type EmailNotification = {
  __typename?: 'EmailNotification';
  bccRecipients?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  ccRecipients?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Object']>;
  id: Scalars['ID'];
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  /**  Kinetic module which sent this email notification  */
  module?: Maybe<KineticModule>;
  sentAt: Scalars['DateTime'];
  /**  True if the email was sent successfully.  */
  sentStatus: Scalars['Boolean'];
  subject?: Maybe<Scalars['String']>;
  toRecipients?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type EmailNotificationConnection = {
  __typename?: 'EmailNotificationConnection';
  edges: Array<EmailNotificationConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type EmailNotificationConnectionEdge = {
  __typename?: 'EmailNotificationConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: EmailNotification;
};

export type EmailNotificationHistoryQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter alarms.  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type EmailRuleAutomationSettingsDto = {
  __typename?: 'EmailRuleAutomationSettingsDto';
  onEventClosed?: Maybe<Scalars['Boolean']>;
  onEventCreated?: Maybe<Scalars['Boolean']>;
  onEventUpdated?: Maybe<Scalars['Boolean']>;
};

export type EmailRuleAutomationSettingsInput = {
  onEventClosed?: InputMaybe<Scalars['Boolean']>;
  onEventCreated?: InputMaybe<Scalars['Boolean']>;
  onEventUpdated?: InputMaybe<Scalars['Boolean']>;
};

export type EmailRuleConnection = {
  __typename?: 'EmailRuleConnection';
  edges: Array<EmailRuleConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type EmailRuleConnectionEdge = {
  __typename?: 'EmailRuleConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: EmailRuleDto;
};

export type EmailRuleDto = {
  __typename?: 'EmailRuleDto';
  active: Scalars['Boolean'];
  /** Email Rule Automation Settings */
  automationSettings?: Maybe<EmailRuleAutomationSettingsDto>;
  /**  Query configuration  */
  config?: Maybe<Scalars['Object']>;
  description?: Maybe<Scalars['String']>;
  /**  when the task should end  */
  end?: Maybe<Scalars['DateTime']>;
  executive: Scalars['Boolean'];
  formId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  module?: Maybe<KineticModule>;
  name: Scalars['String'];
  recipients?: Maybe<Array<Maybe<RecipientDto>>>;
  /**  when the on-call task recurrence should end  */
  recurrenceEndDate?: Maybe<Scalars['DateTime']>;
  /**  when the on-call task recurrence should start */
  recurrenceStartDate?: Maybe<Scalars['DateTime']>;
  /**  RFC 5545 string rrule configuration  */
  rrule?: Maybe<Scalars['String']>;
  /**  The mvel rule string  */
  rule?: Maybe<Scalars['String']>;
  /**  when the task should start  */
  start?: Maybe<Scalars['DateTime']>;
  /**  The associated templates  */
  templates: Array<EmailTemplateDto>;
};

export type EmailRuleInput = {
  active: Scalars['Boolean'];
  /** Email Rule Automation Settings */
  automationSettings?: InputMaybe<EmailRuleAutomationSettingsInput>;
  config?: InputMaybe<Scalars['Object']>;
  description?: InputMaybe<Scalars['String']>;
  /**  when the task should end  */
  end?: InputMaybe<Scalars['DateTime']>;
  executive: Scalars['Boolean'];
  formId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  module?: InputMaybe<KineticModule>;
  name: Scalars['String'];
  recipients?: InputMaybe<Array<InputMaybe<Recipient>>>;
  /**  when the task recurrence should end  */
  recurrenceEndDate?: InputMaybe<Scalars['DateTime']>;
  /**  RFC 5545 string rrule configuration  */
  rrule?: InputMaybe<Scalars['String']>;
  /**  The mvel rule string  */
  rule?: InputMaybe<Scalars['String']>;
  /**  when the task should start  */
  start?: InputMaybe<Scalars['DateTime']>;
  /**  The associated templates  */
  templates: Array<Scalars['String']>;
};

export type EmailRuleQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  formId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  onlyOnCall?: InputMaybe<Scalars['Boolean']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type EmailServerSettings = {
  __typename?: 'EmailServerSettings';
  auth: Scalars['Boolean'];
  from: Scalars['String'];
  host: Scalars['String'];
  ignoreTls: Scalars['Boolean'];
  password?: Maybe<Scalars['String']>;
  port: Scalars['Int'];
  requireStartTls: Scalars['Boolean'];
  sslEnabled: Scalars['Boolean'];
  sslTrust: Scalars['Boolean'];
  startTls: Scalars['Boolean'];
  username?: Maybe<Scalars['String']>;
};

export type EmailServerSettingsInput = {
  auth: Scalars['Boolean'];
  from: Scalars['String'];
  host: Scalars['String'];
  ignoreTls: Scalars['Boolean'];
  password?: InputMaybe<Scalars['String']>;
  port: Scalars['Int'];
  requireStartTls: Scalars['Boolean'];
  sslEnabled: Scalars['Boolean'];
  sslTrust: Scalars['Boolean'];
  startTls: Scalars['Boolean'];
  username?: InputMaybe<Scalars['String']>;
};

export type EmailTemplateConnection = {
  __typename?: 'EmailTemplateConnection';
  edges: Array<EmailTemplateConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type EmailTemplateConnectionEdge = {
  __typename?: 'EmailTemplateConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: EmailTemplateDto;
};

export type EmailTemplateDto = {
  __typename?: 'EmailTemplateDto';
  body: Scalars['String'];
  form?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  module: KineticModule;
  name: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  type: TemplateType;
};

export type EmailTemplateInput = {
  body: Scalars['String'];
  form?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  module: KineticModule;
  name: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
  type: TemplateType;
};

export type EmbeddedLayoutInput = {
  areas: Array<LayoutAreaInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EntityWorkOrder = {
  __typename?: 'EntityWorkOrder';
  /** Work order attributes */
  attributes: Scalars['JSON'];
  /** The unique identifier of the work order */
  id: Scalars['ID'];
  /** Link path to work order */
  link: Scalars['String'];
  /** Work order number */
  workOrderNo: Scalars['String'];
};

export type EntityWorkOrderConnection = {
  __typename?: 'EntityWorkOrderConnection';
  /**  connection edges  */
  edges: Array<EntityWorkOrderConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type EntityWorkOrderConnectionEdge = {
  __typename?: 'EntityWorkOrderConnectionEdge';
  /**  connection edge node  */
  cursor?: Maybe<Scalars['String']>;
  /**  node cursor  */
  node: EntityWorkOrder;
};

export type EntityWorkOrderInput = {
  /** Work order attributes */
  attributes: Scalars['JSON'];
  /** The unique identifier of the entity */
  entityId: Scalars['ID'];
  /** Work order system id  */
  workOrderSystemId: Scalars['String'];
};

export type EntityWorkOrderInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** Entity id  */
  entityId: Scalars['String'];
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
  /** Work order system id  */
  workOrderSystemId: Scalars['String'];
};

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN'
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN'
}

export type Event = {
  __typename?: 'Event';
  /**  The activation type of the planned event  */
  activationType?: Maybe<ActivationType>;
  /**  Associated communication logs */
  associatedCommunicationLogs: Array<CommunicationLog>;
  /**  Associated detections */
  associatedDetections: Array<Detection>;
  /**  The attributes of the event built from an event form  */
  attributes: Scalars['Object'];
  /**  The event category  */
  category: EventCategory;
  /**  Does the event require confirmation before activating  */
  confirmationRequired?: Maybe<Scalars['Boolean']>;
  /**  The list of contacts  */
  contacts: Array<Contact>;
  /**  The date at which the event was created  */
  created: Scalars['DateTime'];
  /**  The user who created the event  */
  createdBy?: Maybe<Scalars['String']>;
  /**  The user's display name who created the event */
  createdByDisplayName?: Maybe<Scalars['String']>;
  /**  Duration between start and end time  */
  duration?: Maybe<Scalars['Int']>;
  /**  The end time of the event  */
  end?: Maybe<Scalars['DateTime']>;
  /**  If this device is owned by an external center  */
  external: Scalars['Boolean'];
  /**  The ID of the external center that owns this device  */
  externalCenter?: Maybe<Scalars['String']>;
  fiveOneOneMessage: FiveOneOneMessage;
  /**  fleet Dispatched  */
  fleetDispatches?: Maybe<Array<FleetDispatch>>;
  /**  Flag to indicate if the event is a floodgate event  */
  floodgate?: Maybe<Scalars['Boolean']>;
  /**  The kinetic form to use for this event  */
  form: KineticForm;
  /**  The geometry of the event  */
  geometry: Scalars['Object'];
  id: Scalars['ID'];
  /**  list of custom labels  */
  labels: Array<Scalars['String']>;
  /**  The lanes associated with this event  */
  lanes: Array<EventLane>;
  /**  The time at which the lanes were cleared  */
  lanesClear?: Maybe<Scalars['DateTime']>;
  /**  The time at which the event was last updated  */
  lastUpdated: Scalars['DateTime'];
  /**  The user who last updated the event  */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /**  The user's display name who last updated the event */
  lastUpdatedByDisplayName?: Maybe<Scalars['String']>;
  /**  The list of linked events for the plan  */
  links: Array<EventLink>;
  /**  The name of the event  */
  name: Scalars['String'];
  /**  internal notes  */
  notes: Array<EventNote>;
  /**  The time at which the scene was cleared  */
  sceneClear?: Maybe<Scalars['DateTime']>;
  /**  Event shortId  */
  shortId?: Maybe<Scalars['String']>;
  /**  The start time of the event  */
  start?: Maybe<Scalars['DateTime']>;
  /**  The event status  */
  status: EventStatus;
  /**  The event type  */
  type: Scalars['String'];
};

export enum EventCategory {
  /**  Incident Category  */
  Incident = 'INCIDENT',
  /**  Planned Event Category  */
  PlannedEvent = 'PLANNED_EVENT',
  /**  Road Condition Category  */
  RoadCondition = 'ROAD_CONDITION',
  /**  Scheduled Event Category  */
  ScheduledEvent = 'SCHEDULED_EVENT',
  /**  Weather Category  */
  Weather = 'WEATHER'
}

export type EventConnection = {
  __typename?: 'EventConnection';
  /**  connection edges  */
  edges: Array<EventConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type EventConnectionEdge = {
  __typename?: 'EventConnectionEdge';
  /**  connection edge node  */
  cursor?: Maybe<Scalars['String']>;
  /**  node cursor  */
  node: Event;
};

export type EventInput = {
  /**  The activation type of the planned event  */
  activationType?: InputMaybe<ActivationType>;
  /**  The attributes of the event built from an event form  */
  attributes: Scalars['Object'];
  /**  The event category  */
  category: EventCategory;
  /**  The list of contacts  */
  contacts: Array<Scalars['String']>;
  /**  Flag to indicate if the event is a floodgate event  */
  floodgate?: InputMaybe<Scalars['Boolean']>;
  /**  The kinetic form to use for this event  */
  formId: Scalars['String'];
  /**  The geometry of the event  */
  geometry: Scalars['Object'];
  /**  The identifier of the event  */
  id?: InputMaybe<Scalars['ID']>;
  /**  list of custom labels  */
  labels: Array<Scalars['String']>;
  /**  The lanes associated with this event  */
  lanes: Array<EventLaneInput>;
  /**  The name of the event  */
  name: Scalars['String'];
  /**  The event status  */
  status: EventStatus;
  /**  The event type  */
  type: Scalars['String'];
};

export type EventInputQuery = {
  /**  The activation type of the planned event  */
  activationType?: InputMaybe<ActivationType>;
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /**  Fetch by specific event category */
  category?: InputMaybe<EventCategory>;
  /**  End time filter  */
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  /** The fields and values to filter events */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
  /**  Start time filter  */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type EventLane = {
  __typename?: 'EventLane';
  /**  The time at which the lane was closed  */
  closedTime?: Maybe<Scalars['DateTime']>;
  /**  Direction of the the lane  */
  direction: Direction;
  /**  Position of lane relative to type  */
  engineeringLane: Scalars['Int'];
  /**  identifier  */
  id: Scalars['ID'];
  /**  Status of the lane  */
  laneStatus: LaneStatus;
  /**  Type of lane  */
  laneType: LaneType;
  /**  line type  */
  lineType: Scalars['String'];
  /**  The time at which the lane was reopened  */
  openTime?: Maybe<Scalars['DateTime']>;
  /**  Indicates the roadway type for the lane  */
  roadwayType: RoadwayType;
};

export type EventLaneInput = {
  /**  The time at which the lane was closed  */
  closedTime?: InputMaybe<Scalars['DateTime']>;
  /**  Direction of the the lane  */
  direction: Direction;
  /**  Position of lane relative to type  */
  engineeringLane: Scalars['Int'];
  /**  identifier  */
  id: Scalars['ID'];
  /**  Status of the lane  */
  laneStatus: LaneStatus;
  /**  Type of lane  */
  laneType: LaneType;
  /**  line type  */
  lineType: Scalars['String'];
  /**  The time at which the lane was reopened  */
  openTime?: InputMaybe<Scalars['DateTime']>;
  /**  Indicates the roadway type for the lane  */
  roadwayType: RoadwayType;
};

export type EventLink = {
  __typename?: 'EventLink';
  /**  Comment on the link  */
  comment?: Maybe<Scalars['String']>;
  /**  The identifier of the linked event  */
  id: Scalars['String'];
  /**  The name of the linked event  */
  name?: Maybe<Scalars['String']>;
  /**  The status of the linked event  */
  status?: Maybe<EventStatus>;
  /**  Type of link for the events  */
  type: EventLinkType;
};

export type EventLinkInput = {
  /**  Comment on the link  */
  comment?: InputMaybe<Scalars['String']>;
  /**  Identifier of the event to link  */
  id: Scalars['ID'];
  /**  The name of the linked Event */
  name?: InputMaybe<Scalars['String']>;
  /**  The status of the linked event  */
  status?: InputMaybe<EventStatus>;
  /**  Type of link for the events  */
  type: EventLinkType;
};

export enum EventLinkType {
  /**  does the event cause  */
  Causes = 'CAUSES',
  /**  is the event a duplicate  */
  Duplicates = 'DUPLICATES',
  /**  is the event caused  */
  IsCausedBy = 'IS_CAUSED_BY',
  /**  is the event a duplicate  */
  IsDuplicatedBy = 'IS_DUPLICATED_BY',
  /**  is the event related  */
  IsRelatedTo = 'IS_RELATED_TO'
}

export type EventNote = {
  __typename?: 'EventNote';
  /**  content of the note  */
  note: Scalars['String'];
  /**  timestamp of the note  */
  timestamp: Scalars['DateTime'];
  /**  user who recorded the note  */
  user: Scalars['String'];
};

export type EventNoteInput = {
  /**  content of the note  */
  note: Scalars['String'];
  /**  timestamp of the note  */
  timestamp: Scalars['DateTime'];
  /**  user who recorded the note  */
  user: Scalars['ID'];
};

export enum EventRuleType {
  /**  action sets  */
  ActionSet = 'ACTION_SET',
  /**  signs  */
  Sign = 'SIGN'
}

export enum EventStatus {
  /**  Event is currently active  */
  Active = 'ACTIVE',
  /**  Event has been closed  */
  Closed = 'CLOSED',
  /**  Planned Event created but not scheduled  */
  Draft = 'DRAFT',
  /**  Planned Event is no longer active and no more scheduled occurrences  */
  Expired = 'EXPIRED',
  /**  Event has been scheduled  */
  Scheduled = 'SCHEDULED',
  /**  Event is not yet verified, but has been entered  */
  Suspect = 'SUSPECT',
  /**  Event has been verified  */
  Verified = 'VERIFIED'
}

export type EventTemplate = {
  __typename?: 'EventTemplate';
  /**  The description of the template  */
  description?: Maybe<Scalars['String']>;
  /**  The identifier of the template  */
  id: Scalars['ID'];
  /**  The name of the template  */
  name: Scalars['String'];
  /**  The event to serve as the template  */
  template: Event;
};

export type EventTemplateConnection = {
  __typename?: 'EventTemplateConnection';
  /**  connection edges  */
  edges: Array<EventTemplateConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type EventTemplateConnectionEdge = {
  __typename?: 'EventTemplateConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: EventTemplate;
};

export type EventTemplateInput = {
  /**  The description of the template  */
  description?: InputMaybe<Scalars['String']>;
  /**  The identifier of the template  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The name of the template  */
  name: Scalars['String'];
  /**  The event to serve as the template  */
  template: EventInput;
};

export type EventTemplateInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter events */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventType = {
  __typename?: 'EventType';
  /**  The event category for the type  */
  category: EventCategory;
  /**  The description of the event type  */
  description?: Maybe<Scalars['String']>;
  /**  The list of detection codes for this type  */
  detectionCodes: Array<Scalars['String']>;
  /**  The identifier of the event type  */
  id: Scalars['ID'];
  /**  The name of the event type  */
  name: Scalars['String'];
};

export type EventTypeConnection = {
  __typename?: 'EventTypeConnection';
  /**  connection edges  */
  edges: Array<EventTypeConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type EventTypeConnectionEdge = {
  __typename?: 'EventTypeConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: EventType;
};

export type EventTypeInput = {
  /**  The event category for the type  */
  category: EventCategory;
  /**  The description of the event type  */
  description?: InputMaybe<Scalars['String']>;
  /**  The list of detection codes for this type  */
  detectionCodes: Array<Scalars['String']>;
  /**  The identifier of the event type  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The name of the event type  */
  name: Scalars['String'];
};

export type EventTypeInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The category to filter on  */
  category?: InputMaybe<EventCategory>;
  /**  The fields and values to filter events  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ExportColumn = {
  /**  Dot-delimited path in the exported object to extract the field value from.  */
  field: Scalars['String'];
  /**  Human-readable column title  */
  title: Scalars['String'];
  /**
   * Optional type hint when converting data for export.
   * If omitted, the exporter will make a best guess while converting.
   */
  type?: InputMaybe<ExportColumnType>;
};

/**  How to treat exportable data when exporting as a column */
export enum ExportColumnType {
  /**
   * Interpret the column data as a datetime value.
   * Supports values stored as either ISO8601 or Unix timestamps
   */
  Date = 'DATE',
  Text = 'TEXT'
}

export type ExportConfig = {
  /**  Columns to include in the export  */
  columns: Array<ExportColumn>;
  /**
   * Name to use for the exported file.
   * Exported files will always be stored in My Files / Downloads of managed files.
   */
  fileName: Scalars['String'];
  /**
   * Default timezone to use for date columns.
   * If omitted, UTC will be used.
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type ExportFileInput = {
  bucket: Scalars['String'];
  destinationFileName: Scalars['String'];
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  module: Scalars['String'];
};

export type ExportReport = {
  logo?: InputMaybe<Scalars['String']>;
  metaData: Array<InputMaybe<Element>>;
  printDateTime?: InputMaybe<Scalars['String']>;
  reportPreference?: InputMaybe<ReportPreference>;
  reportTitle: Scalars['String'];
  tables: Array<ExportReportTable>;
};

export type ExportReportCollection = {
  name?: InputMaybe<Scalars['String']>;
  reportDtoList: Array<ExportReport>;
};

export type ExportReportHeader = {
  name: Scalars['String'];
};

export type ExportReportRow = {
  rows: Array<StyledObject>;
};

export type ExportReportTable = {
  headers: Array<ExportReportHeader>;
  headersOptional?: InputMaybe<Scalars['Boolean']>;
  maxColumns?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  rows: Array<ExportReportRow>;
  swapped?: InputMaybe<Scalars['Boolean']>;
  tableNameOptional?: InputMaybe<Scalars['Boolean']>;
};

export enum ExportReportType {
  Bin = 'BIN',
  Csv = 'CSV',
  Excel = 'EXCEL',
  Html = 'HTML',
  Json = 'JSON',
  Pdf = 'PDF'
}

export type ExportedDataSources = {
  __typename?: 'ExportedDataSources';
  dataSourceConfigs: Array<DataSourceConfig>;
  dataSources: Array<DataSource>;
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  description: Scalars['String'];
  linkText: Scalars['String'];
  linkTitle: Scalars['String'];
};

export type ExternalLinkInput = {
  description: Scalars['String'];
  linkText: Scalars['String'];
  linkTitle: Scalars['String'];
};

export type ExtractZipResults = {
  __typename?: 'ExtractZipResults';
  /**
   *  All directories created from the zip.
   *  First directory is always the root.
   */
  directories: Array<Directory>;
  /**  All files created from the zip */
  files: Array<ManagedFile>;
};

export enum FanRunStatus {
  Off = 'OFF',
  On = 'ON',
  Unknown = 'UNKNOWN'
}

export enum FanServiceStatus {
  InService = 'IN_SERVICE',
  OutOfService = 'OUT_OF_SERVICE'
}

export type FieldConfig = {
  __typename?: 'FieldConfig';
  accept?: Maybe<Scalars['String']>;
  activeLogic?: Maybe<Scalars['JSON']>;
  choicesTitle?: Maybe<Scalars['String']>;
  chosenTitle?: Maybe<Scalars['String']>;
  dataSource?: Maybe<Scalars['String']>;
  dataSourceVariables?: Maybe<Array<ValueVariable>>;
  defaultValue?: Maybe<Scalars['JSON']>;
  deselectAllLabel?: Maybe<Scalars['String']>;
  disableFuture?: Maybe<Scalars['Boolean']>;
  disablePast?: Maybe<Scalars['Boolean']>;
  disabled?: Maybe<Scalars['Boolean']>;
  disabledLogic?: Maybe<Scalars['JSON']>;
  displayFormat?: Maybe<Scalars['String']>;
  fieldConfigs?: Maybe<Array<FieldConfig>>;
  fieldSize?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  help?: Maybe<Scalars['String']>;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
  limitTags?: Maybe<Scalars['Int']>;
  loading?: Maybe<Scalars['Boolean']>;
  max?: Maybe<Scalars['Float']>;
  maxLength?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Float']>;
  mode?: Maybe<Scalars['String']>;
  moduleName?: Maybe<Scalars['String']>;
  multiline?: Maybe<Scalars['Boolean']>;
  multiple?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  options?: Maybe<Array<Maybe<FieldConfigOption>>>;
  pickerZIndex?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  requiredLogic?: Maybe<Scalars['JSON']>;
  rows?: Maybe<Scalars['Int']>;
  selectAllLabel?: Maybe<Scalars['String']>;
  showInput?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  step?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  uniqueFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  uploadType?: Maybe<Scalars['String']>;
  useCheckedIcon?: Maybe<Scalars['Boolean']>;
  useIcon?: Maybe<Scalars['Boolean']>;
  useStepper?: Maybe<Scalars['Boolean']>;
  valueLabelDisplay?: Maybe<Scalars['String']>;
};

export type FieldConfigInput = {
  accept?: InputMaybe<Scalars['String']>;
  activeLogic?: InputMaybe<Scalars['JSON']>;
  choicesTitle?: InputMaybe<Scalars['String']>;
  chosenTitle?: InputMaybe<Scalars['String']>;
  defaultValue?: InputMaybe<Scalars['JSON']>;
  deselectAllLabel?: InputMaybe<Scalars['String']>;
  disableFuture?: InputMaybe<Scalars['Boolean']>;
  disablePast?: InputMaybe<Scalars['Boolean']>;
  displayFormat?: InputMaybe<Scalars['String']>;
  fieldSize?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  hint?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
  limitTags?: InputMaybe<Scalars['Int']>;
  loading?: InputMaybe<Scalars['Boolean']>;
  max?: InputMaybe<Scalars['Float']>;
  maxLength?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Float']>;
  mode?: InputMaybe<Scalars['String']>;
  moduleName?: InputMaybe<Scalars['String']>;
  multiline?: InputMaybe<Scalars['Boolean']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  options?: InputMaybe<Array<InputMaybe<FieldConfigOptionInput>>>;
  required?: InputMaybe<Scalars['Boolean']>;
  requiredLogic?: InputMaybe<Scalars['JSON']>;
  rows?: InputMaybe<Scalars['Int']>;
  selectAllLabel?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  step?: InputMaybe<Scalars['Float']>;
  type: Scalars['String'];
  uniqueFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uploadType?: InputMaybe<Scalars['String']>;
  useCheckedIcon?: InputMaybe<Scalars['Boolean']>;
  useIcon?: InputMaybe<Scalars['Boolean']>;
  useStepper?: InputMaybe<Scalars['Boolean']>;
};

export type FieldConfigOption = {
  __typename?: 'FieldConfigOption';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type FieldConfigOptionInput = {
  label?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type File = {
  __typename?: 'File';
  additionalData?: Maybe<Scalars['Object']>;
  contentType?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  module?: Maybe<KineticModule>;
  name: Scalars['String'];
  path: Scalars['String'];
  size?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type FileConnection = {
  __typename?: 'FileConnection';
  edges: Array<FileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type FileEdge = {
  __typename?: 'FileEdge';
  cursor: Scalars['String'];
  node: File;
};

export type FileModel = {
  __typename?: 'FileModel';
  content: Scalars['String'];
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};

export type Filter = {
  __typename?: 'Filter';
  field: Scalars['String'];
  operator: FilterOperator;
  value?: Maybe<Scalars['Object']>;
};

export type FilterInput = {
  field: Scalars['String'];
  operator: FilterOperator;
  value?: InputMaybe<Scalars['Object']>;
};

export enum FilterOperator {
  /**  AND operator for combining filters. The filter input field is not used here and the value is an array of filters. */
  And = 'AND',
  /**  Element Matching operator for combining filters of complex objects. The filter input field is not used here and the value is an array of filters. */
  ElemMatch = 'ELEM_MATCH',
  Equals = 'EQUALS',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEquals = 'GREATER_THAN_EQUALS',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanEquals = 'LESS_THAN_EQUALS',
  /**  Element 'Non' Matching operator for combining filters of complex objects. The filter input field is not used here and the value is an array of filters. */
  NotElemMatch = 'NOT_ELEM_MATCH',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN',
  /**  OR operator for combining filters. The filter input field is not used here and the value is an array of filters. */
  Or = 'OR',
  Regex = 'REGEX'
}

export type FiveOneOneMessage = {
  __typename?: 'FiveOneOneMessage';
  extraText?: Maybe<Scalars['String']>;
  floodgate?: Maybe<Scalars['Boolean']>;
  floodgateMessage?: Maybe<Scalars['String']>;
  floodgateTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  reasonForSuppression?: Maybe<Scalars['String']>;
  suppressed?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export enum FlashStatus {
  Auto = 'AUTO',
  Faultmonitor = 'FAULTMONITOR',
  Localmanual = 'LOCALMANUAL',
  Mmu = 'MMU',
  Off = 'OFF',
  Other = 'OTHER',
  Preempt = 'PREEMPT',
  Startup = 'STARTUP'
}

export type FlatLocationGroup = {
  __typename?: 'FlatLocationGroup';
  /**  Color to visually identify different groups  */
  color?: Maybe<Scalars['String']>;
  /**  External center, if C2C is enabled  */
  externalCenterId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**  Human-readable name for the group  */
  name: Scalars['String'];
  /**  Order within the parent group  */
  order?: Maybe<Scalars['Float']>;
  /**  Parent group, if applicable  */
  parentId?: Maybe<Scalars['String']>;
  /**  Groups that are loaded from an external center are flagged as read-only  */
  readOnly?: Maybe<Scalars['Boolean']>;
};

export type FleetCamera = {
  __typename?: 'FleetCamera';
  /**  Fleet camera Id  */
  cameraId?: Maybe<Scalars['String']>;
  /**  Fleet camera name  */
  cameraName?: Maybe<Scalars['String']>;
  /**  Fleet camera description  */
  description?: Maybe<Scalars['String']>;
  /**  Fleet camera Status  */
  status?: Maybe<Scalars['String']>;
};

export type FleetCameraDetails = {
  __typename?: 'FleetCameraDetails';
  /**  Partner Device Camera Attributes */
  attributes?: Maybe<Scalars['Object']>;
  /**  Partner Device Camera details */
  cameras?: Maybe<Array<Maybe<FleetCamera>>>;
  /**  Partner Device Connection Protocol */
  protocol?: Maybe<Scalars['String']>;
  /**  Partner Device Status  */
  status: FleetCameraStatus;
};

export enum FleetCameraStatus {
  /**  Cameras are offline  */
  Offline = 'OFFLINE',
  /**  Cameras are online  */
  Online = 'ONLINE',
  /**  Cameras are in standby mode  */
  Standby = 'STANDBY',
  /**  Cameras are Unavailable  */
  Unavailable = 'UNAVAILABLE'
}

export type FleetDispatch = {
  __typename?: 'FleetDispatch';
  /**  data  */
  data: Scalars['Object'];
  /**  dispatching user  */
  dispatchingUser: Scalars['ID'];
  /**  dispatching user name  */
  dispatchingUsername: Scalars['String'];
  /**  driver id  */
  driver: Scalars['ID'];
  /**  email  */
  email?: Maybe<Scalars['String']>;
  /**  event  */
  event: Scalars['ID'];
  /**  first name  */
  firstName: Scalars['String'];
  /**  formated response time  */
  formatResponseTime?: Maybe<Scalars['String']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  last name  */
  lastName: Scalars['String'];
  /**  module  */
  module: KineticModule;
  /**  phone  */
  phone?: Maybe<Scalars['String']>;
  /**  rejection reason  */
  rejectionReason?: Maybe<Scalars['String']>;
  /**  response time  */
  responseTime?: Maybe<Scalars['Int']>;
  /**  shift  */
  shift: Scalars['ID'];
  /**  status  */
  status: FleetDispatchStatus;
  /**  time departed  */
  timeDeparted?: Maybe<Scalars['DateTime']>;
  /**  time on scene  */
  timeOnScene?: Maybe<Scalars['DateTime']>;
  /**  time requested  */
  timeRequested: Scalars['DateTime'];
  /**  time responded  */
  timeResponded?: Maybe<Scalars['DateTime']>;
  /**  driver username  */
  username: Scalars['String'];
};

export type FleetDispatchConnection = {
  __typename?: 'FleetDispatchConnection';
  /**  Connection Edges  */
  edges: Array<FleetDispatchEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type FleetDispatchEdge = {
  __typename?: 'FleetDispatchEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: FleetDispatch;
};

export type FleetDispatchHistory = {
  __typename?: 'FleetDispatchHistory';
  /**  id  */
  id: Scalars['ID'];
  /**  dispatch history  */
  shift: FleetDispatch;
  /**  timestamp  */
  timestamp: Scalars['DateTime'];
};

export type FleetDispatchHistoryConnection = {
  __typename?: 'FleetDispatchHistoryConnection';
  /**  Connection Edges  */
  edges: Array<FleetDispatchHistoryEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type FleetDispatchHistoryEdge = {
  __typename?: 'FleetDispatchHistoryEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: FleetDispatchHistory;
};

export type FleetDispatchHistoryInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type FleetDispatchInput = {
  /**  data  */
  data: Scalars['Object'];
  /**  identifier  */
  id: Scalars['ID'];
  /**  time departed  */
  timeDeparted?: InputMaybe<Scalars['DateTime']>;
  /**  time on scene  */
  timeOnScene?: InputMaybe<Scalars['DateTime']>;
  /**  time requested  */
  timeRequested: Scalars['DateTime'];
  /**  time responded  */
  timeResponded?: InputMaybe<Scalars['DateTime']>;
};

export type FleetDispatchInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum FleetDispatchStatus {
  /**  The driver actively accepted the dispatch request  */
  Accepted = 'ACCEPTED',
  /**  The system automatically accepted the request on behalf of the driver  */
  AutoAccepted = 'AUTO_ACCEPTED',
  /**  The driver has not yet responded  */
  Pending = 'PENDING',
  /**  The driver refused the dispatch request  */
  Rejected = 'REJECTED'
}

export type FleetDriver = {
  __typename?: 'FleetDriver';
  /**  call sign  */
  callSign: Scalars['String'];
  /**  capabilities  */
  capabilities: Array<Scalars['String']>;
  /**  email  */
  email?: Maybe<Scalars['String']>;
  /**  first name  */
  firstName: Scalars['String'];
  /**  identifier  */
  id: Scalars['ID'];
  /**  last name */
  lastName: Scalars['String'];
  /**  list of supported modules  */
  modules: Array<KineticModule>;
  /**  phone  */
  phone?: Maybe<Scalars['String']>;
  /**  status  */
  status: FleetShiftStatus;
  /**  username  */
  username: Scalars['String'];
};

export type FleetDriverConnection = {
  __typename?: 'FleetDriverConnection';
  /**  Connection Edges  */
  edges: Array<FleetDriverEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type FleetDriverEdge = {
  __typename?: 'FleetDriverEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The driver object  */
  node: FleetDriver;
};

export type FleetDriverInput = {
  /**  call sign  */
  callSign: Scalars['String'];
  /**  capabilities  */
  capabilities: Array<Scalars['String']>;
  /**  email  */
  email?: InputMaybe<Scalars['String']>;
  /**  first name  */
  firstName: Scalars['String'];
  /**  id  */
  id?: InputMaybe<Scalars['ID']>;
  /**  last name */
  lastName: Scalars['String'];
  /**  list of supported modules  */
  modules: Array<KineticModule>;
  /**  phone  */
  phone?: InputMaybe<Scalars['String']>;
  /**  username  */
  username: Scalars['String'];
};

export type FleetDriverInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type FleetRoute = {
  __typename?: 'FleetRoute';
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  end reference  */
  endReference?: Maybe<Scalars['Float']>;
  /**  location  */
  geometry: Scalars['Object'];
  /**  id  */
  id: Scalars['ID'];
  /**  module  */
  module: KineticModule;
  /**  name  */
  name: Scalars['String'];
  /**  route  */
  route?: Maybe<Scalars['String']>;
  /**  start reference  */
  startReference?: Maybe<Scalars['Float']>;
};

export type FleetRouteConnection = {
  __typename?: 'FleetRouteConnection';
  /**  Connection Edges  */
  edges: Array<FleetRouteEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type FleetRouteEdge = {
  __typename?: 'FleetRouteEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: FleetRoute;
};

export type FleetRouteInput = {
  /**  description  */
  description?: InputMaybe<Scalars['String']>;
  /**  end reference  */
  endReference: Scalars['Float'];
  /**  location  */
  geometry: Scalars['Object'];
  /**  id  */
  id?: InputMaybe<Scalars['ID']>;
  /**  module  */
  module: KineticModule;
  /**  name  */
  name: Scalars['String'];
  /**  route  */
  route: Scalars['String'];
  /**  start reference  */
  startReference: Scalars['Float'];
};

export type FleetRouteInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type FleetShift = {
  __typename?: 'FleetShift';
  /**  address  */
  address?: Maybe<Scalars['String']>;
  /**  avl  */
  avl?: Maybe<Scalars['ID']>;
  /**  callSign  */
  callSign: Scalars['String'];
  /**  driver  */
  driver: Scalars['ID'];
  /**  driver capabilities  */
  driverCapabilities: Array<Scalars['String']>;
  /**  email  */
  email?: Maybe<Scalars['String']>;
  /**  first name  */
  firstName: Scalars['String'];
  /**  id  */
  id: Scalars['ID'];
  /**  last name  */
  lastName: Scalars['String'];
  /**  location  */
  location?: Maybe<Scalars['Object']>;
  /**  make  */
  make?: Maybe<Scalars['String']>;
  /**  model  */
  model?: Maybe<Scalars['String']>;
  /**  module  */
  module: KineticModule;
  /**  movement status  */
  moveStatus?: Maybe<FleetShiftMoveStatus>;
  /**  odometer  */
  odometer?: Maybe<Scalars['Float']>;
  /**  patrol number  */
  patrolNumber: Scalars['String'];
  /**  phone  */
  phone?: Maybe<Scalars['String']>;
  /**  plate number  */
  plateNumber: Scalars['String'];
  /**  radio number  */
  radioNumber?: Maybe<Scalars['String']>;
  /**  route  */
  route?: Maybe<Scalars['ID']>;
  /**  route name  */
  routeName?: Maybe<Scalars['String']>;
  /**  serial  */
  serial?: Maybe<Scalars['String']>;
  /**  speed  */
  speed?: Maybe<Scalars['Float']>;
  /**  status  */
  status: FleetShiftStatus;
  /**  type  */
  type: Scalars['String'];
  /**  username  */
  username: Scalars['String'];
  /**  vehicle  */
  vehicle: Scalars['ID'];
  /**  vehicle capabilities  */
  vehicleCapabilities: Array<Scalars['String']>;
  /**  vehicle name  */
  vehicleName: Scalars['String'];
  /**  year  */
  year?: Maybe<Scalars['Int']>;
};

export type FleetShiftConnection = {
  __typename?: 'FleetShiftConnection';
  /**  Connection Edges  */
  edges: Array<FleetShiftEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type FleetShiftEdge = {
  __typename?: 'FleetShiftEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: FleetShift;
};

export type FleetShiftHistory = {
  __typename?: 'FleetShiftHistory';
  /**  id  */
  id: Scalars['ID'];
  /**  shift status  */
  shift: FleetShift;
  /**  timestamp  */
  timestamp: Scalars['DateTime'];
};

export type FleetShiftHistoryConnection = {
  __typename?: 'FleetShiftHistoryConnection';
  /**  Connection Edges  */
  edges: Array<FleetShiftHistoryEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type FleetShiftHistoryEdge = {
  __typename?: 'FleetShiftHistoryEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: FleetShiftHistory;
};

export type FleetShiftHistoryInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type FleetShiftInput = {
  /**  avl  */
  avl?: InputMaybe<Scalars['ID']>;
  /**  driver  */
  driver: Scalars['ID'];
  /**  id  */
  id?: InputMaybe<Scalars['ID']>;
  /**  module that the shift belongs to  */
  module: KineticModule;
  /**  patrol number  */
  patrolNumber?: InputMaybe<Scalars['String']>;
  /**  radio number  */
  radioNumber?: InputMaybe<Scalars['String']>;
  /**  route  */
  route?: InputMaybe<Scalars['ID']>;
  /**  vehicle  */
  vehicle: Scalars['ID'];
};

export type FleetShiftInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum FleetShiftMoveState {
  /**  Fleet shift vehicle is driving  */
  Driving = 'DRIVING',
  /**  Fleet shift vehicle is not communicating  */
  NotCommunicating = 'NOT_COMMUNICATING',
  /**  Fleet shift vehicle has stopped  */
  Stopped = 'STOPPED'
}

export type FleetShiftMoveStatus = {
  __typename?: 'FleetShiftMoveStatus';
  /**  Fleet shift vehicle movement indicator  */
  isMoving: Scalars['Boolean'];
  /**  Fleet shift vehicle movement date and time  */
  lastMoved: Scalars['DateTime'];
  /**  Fleet shift vehicle movement status  */
  state: FleetShiftMoveState;
};

export enum FleetShiftStatus {
  /**  Driver is available for deployment  */
  Available = 'AVAILABLE',
  /**  A dispatch request has been sent to the driver.  */
  DispatchRequested = 'DISPATCH_REQUESTED',
  /**  Driver is en-route to incident  */
  Enroute = 'ENROUTE',
  /**  Driver is off duty and is not available to be dispatched  */
  OffDuty = 'OFF_DUTY',
  /**  Driver is on scene of incident  */
  Onscene = 'ONSCENE',
  /**  Driver is on duty but unavailable  */
  OnDutyUnavailable = 'ON_DUTY_UNAVAILABLE',
  /**  Driver is unavailable for deployment  */
  Unavailable = 'UNAVAILABLE'
}

export type FleetVehicle = {
  __typename?: 'FleetVehicle';
  /**  capabilities  */
  capabilities: Array<Scalars['String']>;
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  make  */
  make?: Maybe<Scalars['String']>;
  /**  model  */
  model?: Maybe<Scalars['String']>;
  /**  list of supported modules  */
  modules: Array<KineticModule>;
  /**  name  */
  name: Scalars['String'];
  /**  odometer  */
  odometer?: Maybe<Scalars['Float']>;
  /**  plate number  */
  plateNumber?: Maybe<Scalars['String']>;
  /**  vehicle status  */
  status: FleetVehicleStatus;
  /**  type  */
  type: Scalars['String'];
  /**  year  */
  year?: Maybe<Scalars['Int']>;
};

export type FleetVehicleConnection = {
  __typename?: 'FleetVehicleConnection';
  /**  Connection Edges  */
  edges: Array<FleetVehicleEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type FleetVehicleEdge = {
  __typename?: 'FleetVehicleEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The vehicle object  */
  node: FleetVehicle;
};

export type FleetVehicleInput = {
  /**  capabilities  */
  capabilities: Array<Scalars['String']>;
  /**  description  */
  description?: InputMaybe<Scalars['String']>;
  /**  identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  make  */
  make?: InputMaybe<Scalars['String']>;
  /**  model  */
  model?: InputMaybe<Scalars['String']>;
  /**  list of supported modules  */
  modules: Array<KineticModule>;
  /**  name  */
  name: Scalars['String'];
  /**  odometer  */
  odometer?: InputMaybe<Scalars['Float']>;
  /**  plate number  */
  plateNumber?: InputMaybe<Scalars['String']>;
  /**  vehicle status  */
  status: FleetVehicleStatus;
  /**  type  */
  type: Scalars['String'];
  /**  year  */
  year?: InputMaybe<Scalars['Int']>;
};

export type FleetVehicleInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum FleetVehicleStatus {
  /**  vehicle is in service  */
  InService = 'IN_SERVICE',
  /**  vehicle is not in service  */
  OutOfService = 'OUT_OF_SERVICE'
}

export type ForbiddenWord = {
  __typename?: 'ForbiddenWord';
  /**  Identifier of the forbidden word  */
  id: Scalars['ID'];
  /** The forbidden word  */
  word: Scalars['String'];
};

export type ForbiddenWordInput = {
  /**  Identifier of the forbidden word  */
  id?: InputMaybe<Scalars['ID']>;
  /** The forbidden word  */
  word: Scalars['String'];
};

export type FormSection = {
  fields: Array<Maybe<FieldConfig>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FormView = {
  id: Scalars['ID'];
  name: Scalars['String'];
  sections: Array<FormSection>;
  type: FormViewType;
  views: Array<FormView>;
};

export enum FormViewType {
  Embedded = 'EMBEDDED',
  Route = 'ROUTE'
}

export enum GateActivityType {
  /**  Activated the associated sign messages during the gate operation  */
  ActivatedSignMessages = 'ACTIVATED_SIGN_MESSAGES',
  /**  Gate Controller Operation override authorization  */
  AuthorizeOverrideOperation = 'AUTHORIZE_OVERRIDE_OPERATION',
  /**  Gate's Configuration was changed  */
  ConfigurationChanged = 'CONFIGURATION_CHANGED',
  /**  Confirmed Area Clear for Gate Operation Step  */
  ConfirmedAreaClear = 'CONFIRMED_AREA_CLEAR',
  /**  Confirmed Gates in Correct Position  */
  ConfirmedGatePosition = 'CONFIRMED_GATE_POSITION',
  /**  Confirmed Operator On-site  */
  ConfirmedOperatorOnsite = 'CONFIRMED_OPERATOR_ONSITE',
  /**  Confirmed Signs have correct message posted  */
  ConfirmedSignMessage = 'CONFIRMED_SIGN_MESSAGE',
  /**  Confirm reverse alert  */
  ConfirmReverseAlert = 'CONFIRM_REVERSE_ALERT',
  /**  Confirm reverse detector  */
  ConfirmReverseDetector = 'CONFIRM_REVERSE_DETECTOR',
  /**  Confirm toll points  */
  ConfirmTollPoints = 'CONFIRM_TOLL_POINTS',
  /**  Continued the Gate Operation even though some Gate positions are currently unknown  */
  ContinuedOperationWithGatesUnknown = 'CONTINUED_OPERATION_WITH_GATES_UNKNOWN',
  /**  User attempted to start new gate operation while having another gate operation running, and choose to interrupt the currently running Gate Operation  */
  CurrentUserOperationInterruptRequested = 'CURRENT_USER_OPERATION_INTERRUPT_REQUESTED',
  /**  A Flow Conflict Restriction Violation has been detected  */
  FlowConflict = 'FLOW_CONFLICT',
  /**  A flow conflict violation was detected but was suppressed due to restriction bypass  */
  FlowConflictSuppressed = 'FLOW_CONFLICT_SUPPRESSED',
  /**  An operation command was issued by a user  */
  GateChangeCommandIssued = 'GATE_CHANGE_COMMAND_ISSUED',
  /**  The operator has bypassed a gate command step in the gate operation wizard  */
  GateCommandBypassed = 'GATE_COMMAND_BYPASSED',
  /**  Gate command was sent while there were operations in progress  */
  GateCommandSentWhileOperationsActive = 'GATE_COMMAND_SENT_WHILE_OPERATIONS_ACTIVE',
  /**  Command was sent to a controller while existing violations were bypassed  */
  GateCommandSentWithViolationsBypassed = 'GATE_COMMAND_SENT_WITH_VIOLATIONS_BYPASSED',
  /**  Gate Command Sent Successfully  */
  GateCommandSuccessful = 'GATE_COMMAND_SUCCESSFUL',
  /**  Gate is reporting one or more errors  */
  GateError = 'GATE_ERROR',
  /**  Gate Controller Operation approved by Supervisor  */
  GateOperationApprovedBySupervisor = 'GATE_OPERATION_APPROVED_BY_SUPERVISOR',
  /**  Gate Controller Operation rejected by Supervisor  */
  GateOperationRejectedBySupervisor = 'GATE_OPERATION_REJECTED_BY_SUPERVISOR',
  /**  User Interrupted Another Gate Operation to Start Their Own  */
  InterruptedOperation = 'INTERRUPTED_OPERATION',
  /**  Notes Added for a Gate Operation Step  */
  NotesAdded = 'NOTES_ADDED',
  /**  Notified the Tunnel Supervisor  */
  NotifiedTunnelSupervisor = 'NOTIFIED_TUNNEL_SUPERVISOR',
  /**  Gate Operation Aborted  */
  OperationAborted = 'OPERATION_ABORTED',
  /**  User authentication for Gate Operation failed  */
  OperationAuthenticationFailed = 'OPERATION_AUTHENTICATION_FAILED',
  /**  Gate Operation Successfully Completed  */
  OperationCompleted = 'OPERATION_COMPLETED',
  /**  Gate Operation Started  */
  OperationStarted = 'OPERATION_STARTED',
  OperationStepSelected = 'OPERATION_STEP_SELECTED',
  OperationStepSkipped = 'OPERATION_STEP_SKIPPED',
  /**  Gate's Position has changed *  */
  PositionChanged = 'POSITION_CHANGED',
  /**  Received call from HOV Operator  */
  ReceivedOperatorCall = 'RECEIVED_OPERATOR_CALL',
  ResourcePlanActivateRules = 'RESOURCE_PLAN_ACTIVATE_RULES',
  ResourcePlanExpireRules = 'RESOURCE_PLAN_EXPIRE_RULES',
  /**  reverse alert  */
  ReverseAlert = 'REVERSE_ALERT',
  /**  reverse detector  */
  ReverseDetector = 'REVERSE_DETECTOR',
  SignActivateRules = 'SIGN_ACTIVATE_RULES',
  SignExpireRules = 'SIGN_EXPIRE_RULES',
  /**  Gate's Status has received a notable update  */
  StatusChanged = 'STATUS_CHANGED',
  /**  Represents change in critical status of the GateController associated Signs  */
  ToggleCriticalSignsStatus = 'TOGGLE_CRITICAL_SIGNS_STATUS',
  /**  Represents change (enable/disable) in Gate Bypass Restrictions status  */
  ToggleGateBypassRestrictions = 'TOGGLE_GATE_BYPASS_RESTRICTIONS',
  /**  Represents change (enable/disable) in Gate Enable Safe Reversal Time status  */
  ToggleGateEnableSafeReversalTime = 'TOGGLE_GATE_ENABLE_SAFE_REVERSAL_TIME',
  TollingPointNoChangeRequested = 'TOLLING_POINT_NO_CHANGE_REQUESTED',
  TollPointActivation = 'TOLL_POINT_ACTIVATION',
  TollPointDeactivation = 'TOLL_POINT_DEACTIVATION',
  /**  An unauthorized access has been detected  */
  UnauthorizedAccess = 'UNAUTHORIZED_ACCESS',
  /**  User ignored unexpected gate message.  */
  UnexpectedMessageIgnored = 'UNEXPECTED_MESSAGE_IGNORED',
  /**  User resolved unexpected gate message.  */
  UnexpectedMessageResolved = 'UNEXPECTED_MESSAGE_RESOLVED'
}

export enum GateApprovalType {
  /**  Approve Gate Control System Operation.  */
  GateApproveOperation = 'GATE_APPROVE_OPERATION',
  /**  Enable / Disable Gate Bypass Restrictions.  */
  GateBypassRestrictions = 'GATE_BYPASS_RESTRICTIONS',
  /**  Gate close operation.  */
  GateClose = 'GATE_CLOSE',
  /**  Manage Gate Control System Operation.  */
  GateIndividualOperation = 'GATE_INDIVIDUAL_OPERATION',
  /**  Manage Gate Control System Operation.  */
  GateManage = 'GATE_MANAGE',
  /**  Gate open inbound operation.  */
  GateOpenInbound = 'GATE_OPEN_INBOUND',
  /**  Gate open outbound operation.  */
  GateOpenOutbound = 'GATE_OPEN_OUTBOUND',
  /**  Gate override gate controller operation.  */
  GateOverrideGcOperation = 'GATE_OVERRIDE_GC_OPERATION',
  /**  Reject Gate Control System Operation.  */
  GateRejectOperation = 'GATE_REJECT_OPERATION',
  /**  Enable / Disable Safe Reversal Time.  */
  SafeReversalTime = 'SAFE_REVERSAL_TIME'
}

export enum GateArmHealth {
  /**  failed  */
  Failed = 'FAILED',
  /**  ok  */
  Ok = 'OK',
  /**  unknown  */
  Unknown = 'UNKNOWN'
}

export enum GateArmPosition {
  /**  closed  */
  Closed = 'CLOSED',
  /**  open  */
  Open = 'OPEN',
  /**  transitioning  */
  Transitioning = 'TRANSITIONING',
  /**  unknown  */
  Unknown = 'UNKNOWN'
}

export type GateCamera = {
  __typename?: 'GateCamera';
  /**  the identifier  */
  cameraId: Scalars['ID'];
  /**  camera preset ID  */
  presetId?: Maybe<Scalars['ID']>;
};

export enum GateControlMode {
  /**  local  */
  Local = 'LOCAL',
  /**  manual  */
  Manual = 'MANUAL',
  /**  remote  */
  Remote = 'REMOTE',
  /**  schedule  */
  Schedule = 'SCHEDULE'
}

export type GateController = {
  __typename?: 'GateController';
  /**  active alarms  */
  activeAlarms: Array<Scalars['String']>;
  /**  If there is currently an operation  */
  activeOperation: Scalars['Boolean'];
  /**  Active Switch state  */
  activeSwitches: Array<GateSwitch>;
  /**  If the Backup Schedule is active  */
  backupScheduleActive: Scalars['Boolean'];
  /**  if restrictions are bypassed  */
  bypassingRestrictions?: Maybe<Scalars['Boolean']>;
  /**  communication status  */
  communicationStatus: CommunicationState;
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  direction  */
  direction: Direction;
  /**  entrance direction  */
  entranceDirection: GateControllerDirection;
  /**  list of current errors  */
  errors: Array<Scalars['String']>;
  /**  the list of gate arms  */
  gateArms: Array<GateControllerArm>;
  /**  the list of cameras  */
  gateCameras: Array<GateCamera>;
  /**  detectors  */
  gateDetectors?: Maybe<Array<Scalars['ID']>>;
  /**  the list of signs  */
  gateSigns: Array<Scalars['ID']>;
  /**  tolling points  */
  gateTollingPoints: Array<Scalars['ID']>;
  /**  the list of video tours  */
  gateTours: Array<Scalars['ID']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  interlock status  */
  interlock: GateInterlockStatus;
  /**  last data received  */
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  /**  location  */
  location: Scalars['Object'];
  /**  control mode  */
  mode: GateControlMode;
  /**  name  */
  name: Scalars['String'];
  /**  operation status  */
  operationStatus: GateOperationStatus;
  /**  reference point  */
  referencePoint: Scalars['Float'];
  /**  if remote operations are disabled  */
  remoteOperationDisabled?: Maybe<Scalars['Boolean']>;
  /**  the list of restrictions  */
  restrictions: Array<GateControllerRestriction>;
  /**  road  */
  road: Scalars['String'];
  /**  if safe reversal time is disabled  */
  safeReversalTimeDisabled?: Maybe<Scalars['Boolean']>;
  /**  The set control type. this value is set when the controller is polled, but it is initially null until then. */
  setControl?: Maybe<GateSetControlType>;
  /**  signal verification status  */
  signalVerificationStatus?: Maybe<Array<GateSignalVerificationStatus>>;
  /**  current status  */
  status: GateControllerStatus;
  /**  supported errors  */
  supportedErrors: Array<GateControllerError>;
  /**  system enabled  */
  systemEnabled: Scalars['Boolean'];
  /**  if user auth is required  */
  userAuthenticationRequired?: Maybe<Scalars['Boolean']>;
};

export type GateControllerArm = {
  __typename?: 'GateControllerArm';
  /**  direction  */
  direction: GateDirection;
  /**  arm health  */
  health: GateArmHealth;
  /**  location  */
  location: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
  /**  native id  */
  nativeId: Scalars['Int'];
  /**  arm position  */
  position: GateArmPosition;
};

export type GateControllerConnection = {
  __typename?: 'GateControllerConnection';
  /**  Connection Edges  */
  edges: Array<GateControllerEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export enum GateControllerDirection {
  /**  both  */
  Both = 'BOTH',
  /**  inbound  */
  Inbound = 'INBOUND',
  /**  none  */
  None = 'NONE',
  /**  outbound  */
  Outbound = 'OUTBOUND'
}

export type GateControllerEdge = {
  __typename?: 'GateControllerEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The TravelTime object  */
  node: GateController;
};

export enum GateControllerError {
  /**  Communication data error (in last received message)  */
  Communication = 'COMMUNICATION',
  /**  Configuration failure  */
  Configuration = 'CONFIGURATION',
  /**  Cabinet door is open  */
  DoorOpen = 'DOOR_OPEN',
  /**  EPROM checksum error  */
  Eprom = 'EPROM',
  /**  Gate failure  */
  GateFailure = 'GATE_FAILURE',
  /**  Illegal command in last message  */
  IllegalCommand = 'ILLEGAL_COMMAND',
  /**  Interlock disabled  */
  InterlockDisabled = 'INTERLOCK_DISABLED',
  /**  Power-failure recovery  */
  Power = 'POWER',
  /**  RAM failure or controller data base corrupted  */
  Ram = 'RAM',
  /**  Sign failure  */
  Sign = 'SIGN',
  /**  Signal failure  */
  Signal = 'SIGNAL'
}

export type GateControllerInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type GateControllerOperationRestriction = {
  __typename?: 'GateControllerOperationRestriction';
  /**  the identifier of the controller  */
  id: Scalars['ID'];
  /**  the name of the controller  */
  name: Scalars['String'];
  /**  the offending status  */
  status: GateControllerStatus;
};

export type GateControllerOperationResult = {
  __typename?: 'GateControllerOperationResult';
  /**  if the operation is allowed  */
  allowed: Scalars['Boolean'];
  /**  the identifier  */
  id: Scalars['ID'];
  /**  the name of the controller  */
  name: Scalars['String'];
  /**  the list of restrictions that would be violated  */
  restrictions: Array<GateControllerOperationRestriction>;
  /**  if restrictions are being bypassed  */
  restrictionsBypassed: Scalars['Boolean'];
  /**  the type of operation  */
  type: GateOperationType;
};

export type GateControllerRestriction = {
  __typename?: 'GateControllerRestriction';
  /**  restricting action  */
  restrictedStatus: GateControllerStatus;
  /**  restricting controller  */
  restrictingControllerId: Scalars['ID'];
  /**  violating action  */
  violationStatus: GateControllerStatus;
};

export type GateControllerSignMessage = {
  __typename?: 'GateControllerSignMessage';
  /**  controller  */
  controller: Scalars['ID'];
  /**  identifier  */
  id: Scalars['ID'];
  /**  message  */
  message: SignMessage;
  /**  sign  */
  sign: Scalars['ID'];
  /**  type  */
  type: Scalars['ID'];
};

export type GateControllerSignMessageConnection = {
  __typename?: 'GateControllerSignMessageConnection';
  /**  Connection Edges  */
  edges: Array<GateControllerSignMessageEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type GateControllerSignMessageEdge = {
  __typename?: 'GateControllerSignMessageEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The TravelTime object  */
  node: GateControllerSignMessage;
};

export type GateControllerSignMessageInput = {
  /**  controller  */
  controller: Scalars['ID'];
  /**  identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  message  */
  message: SignMessageInput;
  /**  sign  */
  sign: Scalars['ID'];
  /**  type  */
  type: Scalars['ID'];
};

export type GateControllerSignMessageInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum GateControllerStatus {
  /**  closed  */
  Closed = 'CLOSED',
  /**  mixed  */
  Mixed = 'MIXED',
  /**  open both  */
  OpenBoth = 'OPEN_BOTH',
  /**  open inbound  */
  OpenInbound = 'OPEN_INBOUND',
  /**  open outbound  */
  OpenOutbound = 'OPEN_OUTBOUND',
  /**  unknown  */
  Unknown = 'UNKNOWN'
}

export type GateControllerSystem = {
  __typename?: 'GateControllerSystem';
  /**  active alarms  */
  activeAlarms: Array<Scalars['String']>;
  /**  active operation name  */
  activeOperation?: Maybe<Scalars['String']>;
  /**  active operation type */
  activeOperationType?: Maybe<GateOperationType>;
  /**  alert integrations  */
  alertIntegrations?: Maybe<Array<Scalars['ID']>>;
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  detectors  */
  detectors?: Maybe<Array<Scalars['ID']>>;
  /**  associated groups  */
  groups: Array<GateGroup>;
  /**  identifier of the system  */
  id: Scalars['ID'];
  /**  associated inbound controllers  */
  inboundControllers: Array<Scalars['ID']>;
  /**  the inbound direction  */
  inboundDirection: Direction;
  /**  managing user  */
  managingUser?: Maybe<Scalars['ID']>;
  /**  the min safe reversal time in secs  */
  minReversalTimeSecs?: Maybe<Scalars['Int']>;
  /**  name of the system  */
  name: Scalars['String'];
  /**  list of gate operations  */
  operations: Array<GateOperationNode>;
  /**  associated outbound controllers  */
  outboundControllers: Array<Scalars['ID']>;
  /**  the outbound direction  */
  outboundDirection: Direction;
  /**  associated reversible routes  */
  routes: Array<Scalars['String']>;
  /**  schematic settings  */
  settings: Scalars['Object'];
  /**  associated signs  */
  signs: Array<Scalars['ID']>;
  /**  current status of the system  */
  status: GateControllerStatus;
  /**  associated toll points  */
  tollPoints: Array<Scalars['ID']>;
};

export type GateControllerSystemConnection = {
  __typename?: 'GateControllerSystemConnection';
  /**  Connection Edges  */
  edges: Array<GateControllerSystemEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type GateControllerSystemEdge = {
  __typename?: 'GateControllerSystemEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The TravelTime object  */
  node: GateControllerSystem;
};

export type GateControllerSystemInput = {
  /**  alert integrations  */
  alertIntegrations?: InputMaybe<Array<Scalars['ID']>>;
  /**  description  */
  description?: InputMaybe<Scalars['String']>;
  /**  detectors  */
  detectors?: InputMaybe<Array<Scalars['ID']>>;
  /**  associated groups  */
  groups: Array<GateGroupInput>;
  /**  identifier of the system  */
  id?: InputMaybe<Scalars['ID']>;
  /**  associated inbound controllers  */
  inboundControllers: Array<Scalars['ID']>;
  /**  the inbound direction  */
  inboundDirection: Direction;
  /**  the min safe reversal time in secs  */
  minReversalTimeSecs?: InputMaybe<Scalars['Int']>;
  /**  name of the system  */
  name: Scalars['String'];
  /**  list of gate operations  */
  operations: Array<GateOperationNodeInput>;
  /**  associated outbound controllers  */
  outboundControllers: Array<Scalars['ID']>;
  /**  the outbound direction  */
  outboundDirection: Direction;
  /**  associated reversible routes  */
  routes?: InputMaybe<Array<Scalars['String']>>;
  /**  schematic settings  */
  settings: Scalars['Object'];
  /**  associated signs  */
  signs: Array<Scalars['ID']>;
  /**  associated toll points  */
  tollPoints: Array<Scalars['ID']>;
};

export type GateControllerSystemInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum GateDirection {
  /**  both  */
  Both = 'BOTH',
  /**  inbound  */
  Inbound = 'INBOUND',
  /**  outbound  */
  Outbound = 'OUTBOUND'
}

export type GateGroup = {
  __typename?: 'GateGroup';
  /**  cardinal direction  */
  cardinalDirection: Direction;
  /**  associated controllers  */
  controllers: Array<Scalars['ID']>;
  /**  direction  */
  direction: GateDirection;
  /**  identifier  */
  id: Scalars['ID'];
  /**  name  */
  name: Scalars['String'];
  /**  position  */
  position: Scalars['Int'];
  /**  the ramp type  */
  rampType: GateGroupRampType;
  /**  reference point  */
  referencePoint: Scalars['Float'];
  /**  associated signs  */
  signs: Array<Scalars['ID']>;
  /**  associated toll points  */
  tollPoints: Array<Scalars['ID']>;
};

export type GateGroupInput = {
  /**  associated controllers  */
  controllers: Array<Scalars['ID']>;
  /**  direction  */
  direction: GateDirection;
  /**  identifier  */
  id: Scalars['ID'];
  /**  name  */
  name: Scalars['String'];
  /**  position  */
  position: Scalars['Int'];
  /**  the ramp type  */
  rampType: GateGroupRampType;
  /**  reference point  */
  referencePoint: Scalars['Float'];
  /**  associated signs  */
  signs: Array<Scalars['ID']>;
  /**  associated toll points  */
  tollPoints: Array<Scalars['ID']>;
};

export enum GateGroupRampType {
  None = 'NONE',
  OffRamp = 'OFF_RAMP',
  OnRamp = 'ON_RAMP',
  Reversible = 'REVERSIBLE'
}

export type GateGroupUpdate = {
  __typename?: 'GateGroupUpdate';
  /**  cardinal direction  */
  cardinalDirection: Direction;
  /**  associated controllers  */
  controllers: Array<Scalars['ID']>;
  /**  direction  */
  direction: GateDirection;
  /**  identifier  */
  id: Scalars['ID'];
  /**  name  */
  name: Scalars['String'];
  /**  position of group  */
  position: Scalars['Int'];
  /**  the ramp type  */
  rampType: GateGroupRampType;
  /**  reference point  */
  referencePoint: Scalars['Float'];
  /**  associated signs  */
  signs: Array<Scalars['ID']>;
  /**  the group status  */
  status: GateControllerStatus;
  /**  gate system  */
  system: Scalars['ID'];
  /**  associated toll points  */
  tollPoints: Array<Scalars['ID']>;
};

export enum GateInterlockStatus {
  InterlockBypass = 'INTERLOCK_BYPASS',
  InterlockOff = 'INTERLOCK_OFF',
  InterlockOn = 'INTERLOCK_ON'
}

export type GateOperation = {
  __typename?: 'GateOperation';
  /**  the time at which the operation was ended  */
  endTime?: Maybe<Scalars['DateTime']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  name of the operation  */
  name: Scalars['String'];
  /**  the time at which the operation was started  */
  startTime: Scalars['DateTime'];
  /**  list of steps  */
  steps: Array<GateOperationStep>;
  /**  the associated system  */
  system: Scalars['ID'];
  /**  operation type  */
  type: GateOperationType;
  /**  list of logged in users  */
  users: Array<Scalars['ID']>;
};

export type GateOperationActivityInput = {
  /**  additional details  */
  additionalDetails?: InputMaybe<Scalars['String']>;
  /**  operation identifier  */
  operation: Scalars['ID'];
  /**  task identifier  */
  task: Scalars['ID'];
  /**  activity type, optional  */
  type?: InputMaybe<GateActivityType>;
};

export type GateOperationApproval = {
  __typename?: 'GateOperationApproval';
  /**  if the approval is approved  */
  approved: Scalars['Boolean'];
  /**  the approving user  */
  approver?: Maybe<Scalars['ID']>;
  /**  time at which the approval was created  */
  created: Scalars['DateTime'];
  /**  description of the request  */
  description?: Maybe<Scalars['String']>;
  /**  the identifier  */
  id: Scalars['ID'];
  /**  the operation id  */
  operation: Scalars['ID'];
  /**  if the approval was rejected  */
  rejected: Scalars['Boolean'];
  /**  the system that the request is attached to  */
  system: Scalars['ID'];
  /**  type of gate approval  */
  type: GateApprovalType;
  /**  the requesting user  */
  user: Scalars['ID'];
  /**  display name of requesting user  */
  userDisplayName: Scalars['String'];
};

export type GateOperationApprovalConnection = {
  __typename?: 'GateOperationApprovalConnection';
  /**  Connection Edges  */
  edges: Array<GateOperationApprovalEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type GateOperationApprovalEdge = {
  __typename?: 'GateOperationApprovalEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The TravelTime object  */
  node: GateOperationApproval;
};

export type GateOperationApprovalInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type GateOperationHistory = {
  __typename?: 'GateOperationHistory';
  /**  the end time of the operation  */
  endTime?: Maybe<Scalars['DateTime']>;
  /**  the history identifier  */
  id: Scalars['ID'];
  /**  name of the operation  */
  name: Scalars['String'];
  /**  the operation identifier  */
  operationId: Scalars['ID'];
  /**  the result of the operation  */
  result: GateOperationResult;
  /**  the start time of the operation  */
  startTime: Scalars['DateTime'];
  /**  system identifier  */
  system: Scalars['ID'];
};

export type GateOperationHistoryConnection = {
  __typename?: 'GateOperationHistoryConnection';
  /**  edges  */
  edges: Array<GateOperationHistoryEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type GateOperationHistoryEdge = {
  __typename?: 'GateOperationHistoryEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: GateOperationHistory;
};

export type GateOperationHistoryQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type GateOperationNode = {
  __typename?: 'GateOperationNode';
  /**  data associated with node  */
  data: Scalars['Object'];
  /**  if the node is expandable  */
  droppable: Scalars['Boolean'];
  /**  identifier  */
  id: Scalars['Int'];
  /**  parent identifier  */
  parent: Scalars['Int'];
  /**  name of the operation  */
  text: Scalars['String'];
};

export type GateOperationNodeInput = {
  /**  data associated with node  */
  data: Scalars['Object'];
  /**  if the node is expandable  */
  droppable: Scalars['Boolean'];
  /**  identifier  */
  id: Scalars['Int'];
  /**  parent identifier  */
  parent: Scalars['Int'];
  /**  name of the operation  */
  text: Scalars['String'];
};

export enum GateOperationResult {
  /**  the gate operation was aborted  */
  Aborted = 'ABORTED',
  /**  the gate operation is in progress  */
  InProgress = 'IN_PROGRESS',
  /**  the gate operation completed successfully  */
  Success = 'SUCCESS'
}

export enum GateOperationStatus {
  /**  None of the restricting controllers were in a state that should block this gate  */
  Allowed = 'ALLOWED',
  /**  A restricting controller is in a state that should block this controller  */
  Blocked = 'BLOCKED',
  /**  Only safe gate operations allowed: CLOSE, OPEN EXIT  */
  SafeOnly = 'SAFE_ONLY'
}

export type GateOperationStep = {
  __typename?: 'GateOperationStep';
  /**  the time at which the step was ended  */
  endTime?: Maybe<Scalars['DateTime']>;
  /**  the group associated with the step  */
  group?: Maybe<Scalars['String']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  if the step has been completed  */
  isCompleted: Scalars['Boolean'];
  /**  name  */
  name: Scalars['String'];
  /**  the time at which the step was started  */
  startTime?: Maybe<Scalars['DateTime']>;
  /**  step type  */
  stepType: GateOperationStepType;
  /**  list of tasks  */
  tasks: Array<GateOperationTask>;
  /**  the display name of the user  */
  userDisplayName?: Maybe<Scalars['String']>;
  /**  current user  */
  userId?: Maybe<Scalars['String']>;
};

export enum GateOperationStepType {
  /**  reverse alert  */
  Alert = 'ALERT',
  /**  reverse detector  */
  Detector = 'DETECTOR',
  /**  activate / confirm gate positions  */
  Group = 'GROUP',
  /**  resource plan  */
  ResourcePlan = 'RESOURCE_PLAN',
  /**  activate toll points  */
  TollPoint = 'TOLL_POINT'
}

export type GateOperationTask = {
  __typename?: 'GateOperationTask';
  /**  if the message needs to be blanked before activating  */
  blankBeforeDisplay?: Maybe<Scalars['Boolean']>;
  /**  options data source to use  */
  confirmDataSource?: Maybe<Scalars['String']>;
  /**  if the confirm message is required  */
  confirmOptionRequired: Scalars['Boolean'];
  /**  controller  */
  controller?: Maybe<Scalars['String']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  if the task has been completed  */
  isCompleted: Scalars['Boolean'];
  /**  message type  */
  messageType?: Maybe<Scalars['String']>;
  /**  name  */
  name: Scalars['String'];
  /**  if notes are required  */
  notesRequired?: Maybe<Scalars['Boolean']>;
  /**  identifier of resource plan  */
  resourcePlan?: Maybe<Scalars['ID']>;
  /**  task type  */
  taskType: GateOperationTaskType;
};

export enum GateOperationTaskType {
  /**  Activate a resource plan  */
  ActivateResourcePlan = 'ACTIVATE_RESOURCE_PLAN',
  /** Activated the associated sign messages during the gate operation  */
  ActivateSignMessages = 'ACTIVATE_SIGN_MESSAGES',
  /**  Notes Added for a Gate Operation Step  */
  AddNotes = 'ADD_NOTES',
  /**  Gate Command Sent Successfully  */
  CloseGates = 'CLOSE_GATES',
  /** Confirmed Area Clear for Gate Operation Step  */
  ConfirmAreaClear = 'CONFIRM_AREA_CLEAR',
  /** Confirmed Gates in Correct Position  */
  ConfirmGatePosition = 'CONFIRM_GATE_POSITION',
  /** Confirmed Operator On-site  */
  ConfirmOperatorOnsite = 'CONFIRM_OPERATOR_ONSITE',
  /**  Confirm Resource plan  */
  ConfirmResourcePlan = 'CONFIRM_RESOURCE_PLAN',
  /** Confirm Reverse alert direction  */
  ConfirmReverseAlert = 'CONFIRM_REVERSE_ALERT',
  /** Confirm Reverse detector direction  */
  ConfirmReverseDetector = 'CONFIRM_REVERSE_DETECTOR',
  /** Confirmed Signs have correct message posted  */
  ConfirmSignMessage = 'CONFIRM_SIGN_MESSAGE',
  /**  Confirm toll points reversed  */
  ConfirmTollPoints = 'CONFIRM_TOLL_POINTS',
  /** Notified the Tunnel Supervisor  */
  NotifyTunnelSupervisor = 'NOTIFY_TUNNEL_SUPERVISOR',
  /** Gate Command Sent Successfully  */
  OpenInboundGates = 'OPEN_INBOUND_GATES',
  /** Gate Command Sent Successfully  */
  OpenOutboundGates = 'OPEN_OUTBOUND_GATES',
  /** Reverse alert direction  */
  ReverseAlert = 'REVERSE_ALERT',
  /** Reverse detector direction  */
  ReverseDetector = 'REVERSE_DETECTOR',
  /** Reverse toll points  */
  ReverseTollPoints = 'REVERSE_TOLL_POINTS'
}

export enum GateOperationType {
  /**  close all gates  */
  Close = 'CLOSE',
  /**  open inbound gates  */
  OpenInbound = 'OPEN_INBOUND',
  /**  open outbound gates  */
  OpenOutbound = 'OPEN_OUTBOUND'
}

export type GateSafeReversalTime = {
  __typename?: 'GateSafeReversalTime';
  /**  disabled if the safe reversal time is disabled, false otherwise  */
  disabled: Scalars['Boolean'];
  /**  system configured minimum reversal time in millis  */
  minReversalTimeInMillis: Scalars['Int'];
  /**  the remaining safe reversal time  */
  remainingTimeInMillis: Scalars['Int'];
};

export enum GateSetControlType {
  Close = 'CLOSE',
  Off = 'OFF',
  Open = 'OPEN'
}

export type GateSignalVerificationStatus = {
  __typename?: 'GateSignalVerificationStatus';
  index: Scalars['Int'];
  verified: Scalars['Boolean'];
};

export enum GateSwitch {
  BackupSchedule = 'BACKUP_SCHEDULE',
  ControlClose = 'CONTROL_CLOSE',
  ControlOpen = 'CONTROL_OPEN',
  Interlock = 'INTERLOCK',
  InterlockBypass = 'INTERLOCK_BYPASS',
  Local = 'LOCAL',
  Remote = 'REMOTE'
}

export type GenericInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type GeoTabCameraArguments = {
  /**  Integration id */
  integrationId: Scalars['String'];
  /**  request id */
  requestId: Scalars['String'];
  /**  Serial No. of the device */
  serialNo: Scalars['String'];
};

export type GlobalFileConnection = {
  __typename?: 'GlobalFileConnection';
  edges: Array<FileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type GraphData = {
  __typename?: 'GraphData';
  /**  Checkpoints In X Axis  */
  checkPoints: Array<Maybe<CheckPoint>>;
  /**  Chart Data  */
  data: Array<ChartData>;
  /**  Overlay Info  */
  overlay: Array<OverlayInfo>;
  /**  Name of the graph  */
  title: Scalars['String'];
  /**  xAxis info  */
  xAxis: AxisInfo;
  /**  yAxis info  */
  yAxis: Array<AxisInfo>;
};

export enum GraphicLocation {
  BottomLeft = 'BOTTOM_LEFT',
  BottomRight = 'BOTTOM_RIGHT',
  MiddleLeft = 'MIDDLE_LEFT',
  MiddleRight = 'MIDDLE_RIGHT',
  TopLeft = 'TOP_LEFT',
  TopRight = 'TOP_RIGHT'
}

export type GroupItem = {
  __typename?: 'GroupItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: VideoItemType;
};

export type GroupItemInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  type: VideoItemType;
};

/**  Grouped Report Table  */
export type GroupedReportTable = {
  __typename?: 'GroupedReportTable';
  /**  Name of group for related tables  */
  groupName: Scalars['String'];
  groupedTables: Array<Table>;
};

export type HarAssociation = {
  __typename?: 'HarAssociation';
  /**  id  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
};

export type HarAssociationInput = {
  /**  id  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
};

export enum HarBroadcastState {
  /**  Transmitter is broadcasting messages  */
  StatePlaying = 'STATE_PLAYING',
  /**  Transmitter is not broadcasting  */
  StateQuiet = 'STATE_QUIET',
  /**  Transmitter is in weather radio mode  */
  WeatherRadio = 'WEATHER_RADIO'
}

export enum HarCommandState {
  /**  Execution of a command is currently in progress  */
  Busy = 'BUSY',
  /**  Device is disabled  */
  Disabled = 'DISABLED',
  /**  Last command failed  */
  Failed = 'FAILED',
  /**  No command is currently being executed on the beacon or transmitter  */
  Idle = 'IDLE',
  /**  System is waiting to send a command with to device  */
  Pending = 'PENDING',
  /**  Command state is unknown  */
  Unknown = 'UNKNOWN'
}

export enum HarHardwareState {
  /**  Hardware is in failure  */
  Bad = 'BAD',
  /**  Hardware is OK  */
  Good = 'GOOD',
  /**  Hardware status is currently being retrieved  */
  Retrieving = 'RETRIEVING',
  /**  Hardware status is unknown  */
  Unknown = 'UNKNOWN'
}

export type HarMessage = {
  __typename?: 'HarMessage';
  /**  identifier  */
  id: Scalars['ID'];
  /**  name  */
  name: Scalars['String'];
  /**  priority  */
  text: Scalars['String'];
};

export type HarMessageConnection = {
  __typename?: 'HarMessageConnection';
  /**  Connection Edges  */
  edges: Array<HarMessageEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type HarMessageEdge = {
  __typename?: 'HarMessageEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The object  */
  node: HarMessage;
};

export type HarMessageInput = {
  /**  identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  name  */
  name: Scalars['String'];
  /**  priority  */
  text: Scalars['String'];
};

export type HarMessageInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type HarPlaylist = {
  __typename?: 'HarPlaylist';
  /**  identifier  */
  id: Scalars['ID'];
  /**  messages  */
  messages: Array<HarMessage>;
  /**  name  */
  name: Scalars['String'];
  /**  priority  */
  priority: HarPriority;
};

export type HarPlaylistConnection = {
  __typename?: 'HarPlaylistConnection';
  /**  Connection Edges  */
  edges: Array<HarPlaylistEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type HarPlaylistEdge = {
  __typename?: 'HarPlaylistEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The object  */
  node: HarPlaylist;
};

export type HarPlaylistInput = {
  /**  identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  messages  */
  messages: Array<Scalars['String']>;
  /**  name  */
  name: Scalars['String'];
  /**  priority  */
  priority: Scalars['String'];
};

export type HarPlaylistInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type HarPriority = {
  __typename?: 'HarPriority';
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  message default  */
  messageDefault: Scalars['Boolean'];
  /**  name  */
  name: Scalars['String'];
  /**  priority  */
  priority: Scalars['Int'];
};

export type HarPriorityConnection = {
  __typename?: 'HarPriorityConnection';
  /**  Connection Edges  */
  edges: Array<HarPriorityEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type HarPriorityEdge = {
  __typename?: 'HarPriorityEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The object  */
  node: HarPriority;
};

export type HarPriorityInput = {
  /**  description  */
  description?: InputMaybe<Scalars['String']>;
  /**  identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  message default  */
  messageDefault?: InputMaybe<Scalars['Boolean']>;
  /**  name  */
  name: Scalars['String'];
  /**  priority  */
  priority: Scalars['Int'];
};

export type HarPriorityInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type HarQueuedPlaylist = {
  __typename?: 'HarQueuedPlaylist';
  /**  associations  */
  associations: Array<HarAssociation>;
  /**  beacons  */
  beacons: Array<Scalars['ID']>;
  /**  expiration time  */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /**  id  */
  id: Scalars['ID'];
  /**  messages  */
  messages: Array<HarMessage>;
  /**  name  */
  name: Scalars['String'];
  /**  priority  */
  priority: HarPriority;
  /**  user  */
  user: HarUser;
};

export enum HarSyncState {
  /**  Transmitter is not synchronized with other transmitters that have overlapping broadcast range  */
  NotSynchronized = 'NOT_SYNCHRONIZED',
  /**  Transmitter is synchronized with other transmitters that have overlapping broadcast range  */
  Synchronized = 'SYNCHRONIZED',
  /**  Synchronization status is unknown  */
  Unknown = 'UNKNOWN'
}

export type HarTransmitter = {
  __typename?: 'HarTransmitter';
  /**  attenuator level  */
  attenuatorLevel: Scalars['Int'];
  /**  broadcasting state  */
  broadcastState: HarBroadcastState;
  /**  command state  */
  commandState: HarCommandState;
  /**  current communication state  */
  communicationStatus: CommunicationState;
  /**  current playlist  */
  currentPlaylist?: Maybe<HarQueuedPlaylist>;
  /**  The direction of the sign  */
  direction?: Maybe<Scalars['String']>;
  /**  hardware state  */
  hardwareState: HarHardwareState;
  /**  identifier  */
  id: Scalars['ID'];
  /**  last time data was received from device  */
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  /**  last operation  */
  lastOperation: Scalars['String'];
  /**  The coordinate of the sign  */
  location: Scalars['JSON'];
  /**  The location description  */
  locationDescription?: Maybe<Scalars['String']>;
  /**  If the sign is in a fixed location  */
  locationFixed?: Maybe<Scalars['Boolean']>;
  /**  name  */
  name: Scalars['String'];
  /**  power level  */
  powerLevel: Scalars['Int'];
  /**  queued playlists  */
  queuedPlaylists: Array<HarQueuedPlaylist>;
  /**  The reference point of the sign  */
  referencePoint?: Maybe<Scalars['Float']>;
  /**  The road that the sign serves  */
  road?: Maybe<Scalars['String']>;
  /**  sync state  */
  syncState: HarSyncState;
  /**  voice speed  */
  voiceSpeed: Scalars['Int'];
};

export type HarTransmitterBlank = {
  /**  transmitter id  */
  id: Scalars['ID'];
  /**  request id  */
  requestId?: InputMaybe<Scalars['String']>;
  /**  user  */
  user: HarUserInput;
};

export type HarTransmitterConnection = {
  __typename?: 'HarTransmitterConnection';
  /**  Connection Edges  */
  edges: Array<HarTransmitterEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type HarTransmitterEdge = {
  __typename?: 'HarTransmitterEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: HarTransmitter;
};

export type HarTransmitterInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type HarTransmitterMessage = {
  __typename?: 'HarTransmitterMessage';
  /**  id  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
  /**  text  */
  text: Scalars['String'];
};

export type HarTransmitterMessageInput = {
  /**  id  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
  /**  text  */
  text: Scalars['String'];
};

export type HarTransmitterPlaylist = {
  __typename?: 'HarTransmitterPlaylist';
  /**  id  */
  id: Scalars['String'];
  /**  messages  */
  messages: Array<HarTransmitterMessage>;
  /**  name  */
  name: Scalars['String'];
};

export type HarTransmitterPlaylistInput = {
  /**  id  */
  id: Scalars['String'];
  /**  messages  */
  messages: Array<HarTransmitterMessageInput>;
  /**  name  */
  name: Scalars['String'];
};

export type HarTransmitterPost = {
  /**  associations  */
  associations: Array<HarAssociationInput>;
  /**  expiration time  */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  transmitter id  */
  id: Scalars['ID'];
  /**  playlist  */
  playlist: HarTransmitterPlaylistInput;
  /**  priority  */
  priority: Scalars['Int'];
  /**  request id  */
  requestId?: InputMaybe<Scalars['String']>;
  /**  user  */
  user: HarUserInput;
};

export type HarTransmitterPostInput = {
  /**  associations  */
  associations?: InputMaybe<Array<HarAssociationInput>>;
  /**  beacons  */
  beacons?: InputMaybe<Array<Scalars['ID']>>;
  /**  expiration time  */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  id  */
  id: Scalars['ID'];
  /**  priority  */
  priority?: InputMaybe<Scalars['Int']>;
  /**  transmitter  */
  transmitter: Scalars['ID'];
};

export type HarTransmitterStateHistory = {
  __typename?: 'HarTransmitterStateHistory';
  /**  broadcasting state  */
  broadcastState: HarBroadcastState;
  /**  current communication state  */
  communicationState: CommunicationState;
  /**  identifier  */
  id: Scalars['ID'];
  /**  timestamp  */
  timestamp: Scalars['DateTime'];
  /**  transmitter  */
  transmitter: Scalars['ID'];
};

export type HarTransmitterStateHistoryConnection = {
  __typename?: 'HarTransmitterStateHistoryConnection';
  /**  Connection Edges  */
  edges: Array<HarTransmitterStateHistoryEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type HarTransmitterStateHistoryEdge = {
  __typename?: 'HarTransmitterStateHistoryEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: HarTransmitterStateHistory;
};

export type HarTransmitterStateHistoryInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type HarUser = {
  __typename?: 'HarUser';
  /**  id  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
};

export type HarUserInput = {
  /**  id  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
};

export type Header = {
  name: Scalars['String'];
};

/**  Hi Trac Specific data models */
export type HiTrac = {
  __typename?: 'HiTrac';
  firmwareVersions?: Maybe<Array<HiTracFirmwareRecord>>;
  lastBattery?: Maybe<Scalars['Float']>;
  lastConnect?: Maybe<Scalars['DateTime']>;
  lastResetReason?: Maybe<Scalars['String']>;
  lastResetTime?: Maybe<Scalars['DateTime']>;
};

export type HiTracFirmwareRecord = {
  __typename?: 'HiTracFirmwareRecord';
  processor?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
};

export type HiTracLogRecord = {
  count?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['Int']>;
  parameter1?: InputMaybe<Scalars['Int']>;
  parameter2?: InputMaybe<Scalars['Int']>;
  subtype?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export enum HiTracVehicleDirection {
  Forward = 'FORWARD',
  Reverse = 'REVERSE'
}

export type HiTracVehicleInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  equipmentNumber?: InputMaybe<Scalars['Float']>;
  hexDump?: InputMaybe<Scalars['String']>;
  missingRecordsCount?: InputMaybe<Scalars['Int']>;
  numberOfBytes?: InputMaybe<Scalars['Float']>;
  packetLossStartTime?: InputMaybe<Scalars['DateTime']>;
  packetsLost?: InputMaybe<Scalars['Boolean']>;
  records?: InputMaybe<Array<HiTracVehicleRecordInput>>;
  serialNumber?: InputMaybe<Scalars['Int']>;
  siteNumber?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  temperature?: InputMaybe<Scalars['Int']>;
};

export type HiTracVehicleRecordInput = {
  axleSpacings?: InputMaybe<Array<Scalars['Int']>>;
  axleWeights?: InputMaybe<Array<Scalars['Int']>>;
  axlesCount?: InputMaybe<Scalars['Int']>;
  chassisCode?: InputMaybe<Scalars['Int']>;
  classIndex?: InputMaybe<Scalars['Int']>;
  direction?: InputMaybe<HiTracVehicleDirection>;
  failReason?: InputMaybe<Scalars['String']>;
  failed?: InputMaybe<Scalars['Boolean']>;
  grossWeight?: InputMaybe<Scalars['Int']>;
  headway?: InputMaybe<Scalars['Int']>;
  lane?: InputMaybe<Scalars['Int']>;
  laneDirection?: InputMaybe<DetectorDirection>;
  lastAxleSpeed?: InputMaybe<Scalars['Int']>;
  legalStatus?: InputMaybe<Scalars['Int']>;
  length?: InputMaybe<Scalars['Int']>;
  loopFailure?: InputMaybe<Scalars['Boolean']>;
  loopOnTime?: InputMaybe<Scalars['Int']>;
  maxChassisList?: InputMaybe<Array<Scalars['Int']>>;
  minChassisList?: InputMaybe<Array<Scalars['Int']>>;
  overWeight?: InputMaybe<Scalars['Boolean']>;
  sensorWeights?: InputMaybe<Array<Array<Scalars['Int']>>>;
  sensorWheelWeights?: InputMaybe<Array<Scalars['Int']>>;
  serialNumber?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['Float']>;
  straddle?: InputMaybe<Scalars['Boolean']>;
  straddleLane?: InputMaybe<Scalars['Int']>;
  temperature?: InputMaybe<Scalars['Int']>;
  timeStamp?: InputMaybe<Scalars['DateTime']>;
  typeAPositions?: InputMaybe<Array<Scalars['Int']>>;
  typeBPositions?: InputMaybe<Array<Scalars['Int']>>;
  tyreA1Parameter?: InputMaybe<Scalars['Int']>;
  tyreA2Parameter?: InputMaybe<Scalars['Int']>;
  tyreA3Parameter?: InputMaybe<Scalars['Int']>;
  tyreA4Parameter?: InputMaybe<Scalars['Int']>;
  tyreB1Parameter?: InputMaybe<Scalars['Int']>;
  tyreB2Parameter?: InputMaybe<Scalars['Int']>;
  tyreB3Parameter?: InputMaybe<Scalars['Int']>;
  tyreB4Parameter?: InputMaybe<Scalars['Int']>;
  validity?: InputMaybe<Array<HiTracVehicleValidity>>;
};

export enum HiTracVehicleValidity {
  BadGap = 'BAD_GAP',
  HighSpeed = 'HIGH_SPEED',
  LoopFailure = 'LOOP_FAILURE',
  LowSpeed = 'LOW_SPEED',
  None = 'NONE',
  ReverseDirection = 'REVERSE_DIRECTION',
  SpeedChange = 'SPEED_CHANGE',
  StraddleVehicle = 'STRADDLE_VEHICLE',
  Unclassified = 'UNCLASSIFIED'
}

export type HistoricalEntity = {
  __typename?: 'HistoricalEntity';
  entity: Scalars['JSON'];
  entityId: Scalars['String'];
  id: Scalars['String'];
  timestamp: Scalars['DateTime'];
  type: HistoricalEntityType;
};

export type HistoricalEntityConnection = {
  __typename?: 'HistoricalEntityConnection';
  edges: Array<HistoricalEntityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type HistoricalEntityEdge = {
  __typename?: 'HistoricalEntityEdge';
  cursor?: Maybe<Scalars['String']>;
  node: HistoricalEntity;
};

export enum HistoricalEntityType {
  Corridor = 'CORRIDOR',
  Event = 'EVENT',
  Integration = 'INTEGRATION',
  TollingSegment = 'TOLLING_SEGMENT'
}

export type HistoricalPricingRate = {
  __typename?: 'HistoricalPricingRate';
  /**  the first destination  */
  firstDestination: Scalars['String'];
  /**  the second destination  */
  secondDestination?: Maybe<Scalars['String']>;
  /**  the list of signs that are attached to this rate  */
  signs: Array<Scalars['String']>;
  /**  the third destination  */
  thirdDestination?: Maybe<Scalars['String']>;
};

export type HistoricalSignRate = {
  __typename?: 'HistoricalSignRate';
  /**  the end time of the rate  */
  endTime: Scalars['DateTime'];
  /**  the first destination  */
  firstDestination: Scalars['String'];
  /**  the first rate  */
  firstRate: Scalars['Float'];
  /**  name of the rate to display  */
  name: Scalars['String'];
  /**  the second destination  */
  secondDestination?: Maybe<Scalars['String']>;
  /**  the second rate  */
  secondRate?: Maybe<Scalars['Float']>;
  /**  the start time of the rate  */
  startTime: Scalars['DateTime'];
  /**  the third destination  */
  thirdDestination?: Maybe<Scalars['String']>;
  /**  the third rate  */
  thirdRate?: Maybe<Scalars['Float']>;
};

export type HomePresetInput = {
  isHomePreset: Scalars['Boolean'];
  presetId: Scalars['String'];
};

export enum HorizontalJustification {
  Center = 'CENTER',
  Default = 'DEFAULT',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type HoursOfOperation = {
  __typename?: 'HoursOfOperation';
  daysOfWeek?: Maybe<Array<Maybe<DayOfWeek>>>;
  endDate?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export type HoursOfOperationInput = {
  daysOfWeek?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type IconAnchor = {
  __typename?: 'IconAnchor';
  bearing?: Maybe<Scalars['Float']>;
  coordinates?: Maybe<Array<Scalars['Float']>>;
};

export type ImportDataSources = {
  dataSourceConfigs: Array<Scalars['Object']>;
  dataSources: Array<Scalars['Object']>;
};

export enum InboundEventFormat {
  /**  open tmdd event format  */
  OpenTmdd = 'OPEN_TMDD'
}

export type InboundEventRequestParams = {
  /**  format  */
  format: InboundEventFormat;
  /**  organization requesting  */
  organizationId: Scalars['String'];
  /**  request type  */
  requestType: InboundEventRequestType;
};

export enum InboundEventRequestType {
  /**  request incidents and weather events  */
  Incidents = 'INCIDENTS',
  /**  request planned events  */
  PlannedEvents = 'PLANNED_EVENTS'
}

export type Integration = {
  __typename?: 'Integration';
  assetIdentifier?: Maybe<Scalars['String']>;
  config: IntegrationConfig;
  description?: Maybe<Scalars['String']>;
  groups: Array<IntegrationGroup>;
  id: Scalars['ID'];
  name: Scalars['String'];
  state: IntegrationState;
  systemEnabled: Scalars['Boolean'];
};

export type IntegrationConfig = {
  __typename?: 'IntegrationConfig';
  associatedLocation?: Maybe<Location>;
  form: IntegrationsForm;
  integrationType: IntegrationType;
  location?: Maybe<Scalars['Object']>;
  locationSupported?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<Scalars['Object']>;
};

export type IntegrationConfigFormSection = FormSection & {
  __typename?: 'IntegrationConfigFormSection';
  fields: Array<Maybe<FieldConfig>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IntegrationConfigFormView = FormView & {
  __typename?: 'IntegrationConfigFormView';
  id: Scalars['ID'];
  name: Scalars['String'];
  sections: Array<IntegrationConfigFormSection>;
  type: FormViewType;
  views: Array<IntegrationConfigFormView>;
};

export type IntegrationConnection = {
  __typename?: 'IntegrationConnection';
  edges: Array<IntegrationConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type IntegrationConnectionEdge = {
  __typename?: 'IntegrationConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Integration;
};

export type IntegrationGroup = {
  __typename?: 'IntegrationGroup';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrations: Array<Integration>;
  name: Scalars['String'];
};

export type IntegrationGroupConnection = {
  __typename?: 'IntegrationGroupConnection';
  edges: Array<IntegrationGroupConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type IntegrationGroupConnectionEdge = {
  __typename?: 'IntegrationGroupConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: IntegrationGroup;
};

export type IntegrationGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  integrations?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
};

export type IntegrationJob = {
  __typename?: 'IntegrationJob';
  /**  description of the job */
  description?: Maybe<Scalars['String']>;
  /**  id of the integration */
  id: Scalars['String'];
  /**  the request id */
  requestId?: Maybe<Scalars['String']>;
};

export type IntegrationState = {
  __typename?: 'IntegrationState';
  /**  Current state data. */
  current: Scalars['Object'];
  /**  state data split into sections for viewing in the ui. */
  views: Array<Maybe<IntegrationStateView>>;
};

export type IntegrationStateSection = FormSection & {
  __typename?: 'IntegrationStateSection';
  fields: Array<Maybe<FieldConfig>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IntegrationStateView = FormView & {
  __typename?: 'IntegrationStateView';
  id: Scalars['ID'];
  /**  The name of the section */
  name: Scalars['String'];
  sections: Array<IntegrationStateSection>;
  type: FormViewType;
  views: Array<IntegrationStateView>;
};

export enum IntegrationType {
  /**  Alert field entity type  */
  Alert = 'ALERT',
  /**  AVL field entity type  */
  Avl = 'AVL',
  /**  Center To Center */
  C2C = 'C2C',
  /**  CAD field entity type  */
  Cad = 'CAD',
  /**  Callbox field entity type  */
  Callbox = 'CALLBOX',
  /**  Camera field entity type  */
  Camera = 'CAMERA',
  /**  Detector field entity type  */
  Counts = 'COUNTS',
  /**  Dangerous Cargo entity type  */
  DangerousCargo = 'DANGEROUS_CARGO',
  /**  Fog Light field entity type  */
  FogLight = 'FOG_LIGHT',
  /**  Gate Controller field entity type  */
  GateController = 'GATE_CONTROLLER',
  /**  HAR Beach field entity type  */
  HarBeacon = 'HAR_BEACON',
  /**  HAR Transmitter field entity type  */
  HarTransmitter = 'HAR_TRANSMITTER',
  /**  Modem entity type  */
  Modem = 'MODEM',
  /**  Network Video Recorder entity type  */
  NetworkVideoRecorder = 'NETWORK_VIDEO_RECORDER',
  /**  Over-Height entity type  */
  OverHeight = 'OVER_HEIGHT',
  /**  Devices for monitoring/administering parking areas  */
  ParkingArea = 'PARKING_AREA',
  /**  Preset field entity type  */
  Preset = 'PRESET',
  /**  Pricing entity type  */
  Pricing = 'PRICING',
  /**  Ramp Meter field entity type  */
  RampMeter = 'RAMP_METER',
  /**  Response field entity type  */
  Response = 'RESPONSE',
  /**  Road Side Unit entity type */
  RoadSideUnit = 'ROAD_SIDE_UNIT',
  /**  Sign field entity type  */
  Sign = 'SIGN',
  /**  Signal Field entity type */
  Signal = 'SIGNAL',
  /**  Tolling Point entity type  */
  TollingPoint = 'TOLLING_POINT',
  /**  Traffic Control Signal entity type  */
  TrafficControl = 'TRAFFIC_CONTROL',
  /**  Travel Time Segment field entity type  */
  TravelTimeSegment = 'TRAVEL_TIME_SEGMENT',
  /**  Tunnel Fan entity type  */
  TunnelFan = 'TUNNEL_FAN',
  /**  Tunnel Light entity type  */
  TunnelLight = 'TUNNEL_LIGHT',
  /**  Video Analyzers field entity type  */
  VideoAnalyzers = 'VIDEO_ANALYZERS',
  /**  Video Stream Manager entity type  */
  VideoStreamManager = 'VIDEO_STREAM_MANAGER',
  /**  Video Switcher field entity type  */
  VideoSwitcher = 'VIDEO_SWITCHER',
  /**  Video Wall entity type  */
  VideoWall = 'VIDEO_WALL',
  /**  Weather Station field entity type  */
  WeatherStation = 'WEATHER_STATION',
  /**  Work Order system Field entity type */
  WorkOrderSystem = 'WORK_ORDER_SYSTEM'
}

export type IntegrationsForm = {
  __typename?: 'IntegrationsForm';
  areaSupported?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  extraConfig: Scalars['Object'];
  id: Scalars['ID'];
  integrationType: IntegrationType;
  locationSupported?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  views: Array<Maybe<IntegrationConfigFormView>>;
};

export type IntegrationsFormConnection = {
  __typename?: 'IntegrationsFormConnection';
  edges: Array<IntegrationsFormConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type IntegrationsFormConnectionEdge = {
  __typename?: 'IntegrationsFormConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: IntegrationsForm;
};

export enum IntegrationsFormSortField {
  Description = 'DESCRIPTION',
  Id = 'ID',
  IntegrationType = 'INTEGRATION_TYPE',
  Name = 'NAME'
}

export type IntegrationsInput = {
  assetIdentifier?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  formId: Scalars['ID'];
  groups?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  integrationType: IntegrationType;
  location?: InputMaybe<Scalars['Object']>;
  locationId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  settings: Scalars['Object'];
  systemEnabled: Scalars['Boolean'];
};

export type Intersection = {
  __typename?: 'Intersection';
  /**  Alarm configurations associated with an intersection  */
  alarms: Array<AlarmConfig>;
  centerInfo?: Maybe<CenterInfo>;
  crosswalks: Array<IntersectionCrosswalk>;
  details: IntersectionDetails;
  devices: Array<IntersectionDevice>;
  groupId?: Maybe<Scalars['String']>;
  icons: Array<IntersectionIcon>;
  /**  The identifier of the intersection  */
  id: Scalars['ID'];
  lanes: Array<IntersectionLane>;
  location: Scalars['Object'];
  /**  Location data associated with this intersection  */
  locationId: Scalars['ID'];
  maneuvers: Array<IntersectionManeuver>;
  multiModals: Array<IntersectionMultiModal>;
  rampMeterActionStatus?: Maybe<RmcImplementAction>;
  statusCategory: IntersectionStatusCategory;
};

export type IntersectionComment = {
  __typename?: 'IntersectionComment';
  comment: Scalars['String'];
  id: Scalars['ID'];
  intersectionId: Scalars['String'];
  timestamp: Scalars['DateTime'];
  user: OrganizationKineticUser;
};

export type IntersectionCommunicationStatus = {
  __typename?: 'IntersectionCommunicationStatus';
  category: IntersectionStatusCategory;
  communicationState: CommunicationState;
  intersectionId: Scalars['ID'];
  mainlineColor: SignalOutputColor;
};

export type IntersectionConnection = {
  __typename?: 'IntersectionConnection';
  edges: Array<IntersectionConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type IntersectionConnectionEdge = {
  __typename?: 'IntersectionConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Intersection;
};

export type IntersectionCrosswalk = {
  __typename?: 'IntersectionCrosswalk';
  description?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  icon?: Maybe<Array<IntersectionIcon>>;
  /**  The associated location's Crosswalk.id  */
  id: Scalars['ID'];
  location: Scalars['Object'];
  signalIndication: SignalIndication;
};

export type IntersectionCrosswalkInput = {
  description?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Array<IntersectionIconInput>>;
  /**  The associated location's Crosswalk.id  */
  id: Scalars['ID'];
  location: Scalars['Object'];
  signalIndication: SignalIndicationInput;
};

export type IntersectionDetailStatus = {
  __typename?: 'IntersectionDetailStatus';
  activeAlarms: Array<Scalars['String']>;
  category: IntersectionStatusCategory;
  crosshairs: Array<CrosshairStatus>;
  customIndexedMibs: Array<MibIcon>;
  dynamicIndexedMibs: Array<MibIndexed>;
  firmwareVersion?: Maybe<Scalars['String']>;
  intersectionId: Scalars['ID'];
  isPreemptActive: Scalars['Boolean'];
  isPrioritorActive: Scalars['Boolean'];
  preemptStatus: Array<PreemptStatus>;
  prioritorStatus: Array<PrioritorStatus>;
  specialFunctionStatus: Array<SpecialFunctionStatus>;
  time: IntersectionDeviceTime;
  unitFlashStatus: FlashStatus;
};

export type IntersectionDetails = {
  __typename?: 'IntersectionDetails';
  labels: Array<Scalars['String']>;
  mainPhases: Array<Scalars['Int']>;
  mainStreet?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  sideStreet?: Maybe<Scalars['String']>;
  type: IntersectionType;
};

export type IntersectionDetailsInput = {
  labels: Array<Scalars['String']>;
  mainPhases: Array<Scalars['Int']>;
  mainStreet?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  sideStreet?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type IntersectionDevice = {
  __typename?: 'IntersectionDevice';
  connectionInfo?: Maybe<Scalars['String']>;
  fieldEntityProtocol?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['Object']>;
  name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  type: IntersectionDeviceType;
};

export type IntersectionDeviceInput = {
  connectionInfo?: InputMaybe<Scalars['String']>;
  fieldEntityProtocol?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<Scalars['Object']>;
  name: Scalars['String'];
  type: IntersectionDeviceType;
};

export type IntersectionDeviceTime = {
  __typename?: 'IntersectionDeviceTime';
  drift?: Maybe<Scalars['Float']>;
  globalTime?: Maybe<Scalars['Float']>;
};

export enum IntersectionDeviceType {
  Signal = 'SIGNAL',
  Stop = 'STOP',
  Yield = 'YIELD'
}

export type IntersectionDeviceUi = {
  __typename?: 'IntersectionDeviceUI';
  version: Scalars['String'];
  views?: Maybe<Array<IntersectionDeviceUiView>>;
};

export type IntersectionDeviceUiColumn = {
  __typename?: 'IntersectionDeviceUIColumn';
  description?: Maybe<Scalars['String']>;
  displayAsHeader?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  mib: IntersectionDeviceUiMib;
  mibName: Scalars['String'];
  name: Scalars['String'];
  readonly: Scalars['Boolean'];
  type: IntersectionDeviceUiColumnType;
};

export type IntersectionDeviceUiColumnBit = {
  __typename?: 'IntersectionDeviceUIColumnBit';
  appendIndex?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  multiply?: Maybe<Scalars['Int']>;
  plus?: Maybe<Scalars['Int']>;
  used?: Maybe<Scalars['Boolean']>;
};

export type IntersectionDeviceUiColumnEnumeration = {
  __typename?: 'IntersectionDeviceUIColumnEnumeration';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type IntersectionDeviceUiColumnType = {
  __typename?: 'IntersectionDeviceUIColumnType';
  bits?: Maybe<Array<IntersectionDeviceUiColumnBit>>;
  decimalPos?: Maybe<Scalars['Int']>;
  displayAsHeader?: Maybe<Scalars['Boolean']>;
  enum?: Maybe<Array<IntersectionDeviceUiColumnEnumeration>>;
  isHexadecimal?: Maybe<Scalars['Boolean']>;
  isMultiLines?: Maybe<Scalars['Boolean']>;
  maxValue?: Maybe<Scalars['Float']>;
  minValue?: Maybe<Scalars['Float']>;
  onlyFirstRowDescription?: Maybe<Scalars['Boolean']>;
  swapRowsColumns?: Maybe<Scalars['Boolean']>;
  type: IntersectionDeviceUiColumnTypeEnum;
};

export enum IntersectionDeviceUiColumnTypeEnum {
  BitField = 'BIT_FIELD',
  DateTime = 'DATE_TIME',
  Decimal = 'DECIMAL',
  Enumeration = 'ENUMERATION',
  NumSequence = 'NUM_SEQUENCE',
  Oid = 'OID',
  String = 'STRING'
}

export type IntersectionDeviceUiIndex = {
  __typename?: 'IntersectionDeviceUIIndex';
  displayed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rows?: Maybe<Scalars['Int']>;
};

export type IntersectionDeviceUiMib = {
  __typename?: 'IntersectionDeviceUIMib';
  data?: Maybe<Array<IntersectionDeviceUiMibData>>;
  displayName?: Maybe<Scalars['String']>;
  mibIndex?: Maybe<Array<IntersectionDeviceUiMibIndex>>;
  name: Scalars['String'];
  tableDisplayName?: Maybe<Scalars['String']>;
  tableName?: Maybe<Scalars['String']>;
};

export type IntersectionDeviceUiMibBitField = {
  __typename?: 'IntersectionDeviceUIMibBitField';
  description?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  prevValue?: Maybe<Scalars['Boolean']>;
  value: Scalars['Boolean'];
};

export type IntersectionDeviceUiMibData = {
  __typename?: 'IntersectionDeviceUIMibData';
  bitField?: Maybe<Array<IntersectionDeviceUiMibBitField>>;
  counter?: Maybe<Scalars['Int']>;
  index: Scalars['Int'];
  mibIndex?: Maybe<Array<IntersectionDeviceUiMibIndex>>;
  prevValue?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type IntersectionDeviceUiMibIndex = {
  __typename?: 'IntersectionDeviceUIMibIndex';
  data?: Maybe<Array<IntersectionDeviceUiMibData>>;
  name: Scalars['String'];
};

export type IntersectionDeviceUiTable = {
  __typename?: 'IntersectionDeviceUITable';
  col?: Maybe<Scalars['Int']>;
  columns?: Maybe<Array<IntersectionDeviceUiColumn>>;
  displayName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  indexes?: Maybe<Array<IntersectionDeviceUiIndex>>;
  name?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['Int']>;
  swap?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Int']>;
};

export type IntersectionDeviceUiView = {
  __typename?: 'IntersectionDeviceUIView';
  displayName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tables?: Maybe<Array<IntersectionDeviceUiTable>>;
  views?: Maybe<Array<IntersectionDeviceUiView>>;
};

export type IntersectionGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  group: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  parentId?: InputMaybe<Scalars['String']>;
};

export type IntersectionIcon = {
  __typename?: 'IntersectionIcon';
  bearing: Scalars['Int'];
  config: Scalars['Object'];
  link?: Maybe<Scalars['String']>;
  location: Scalars['Object'];
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['Object']>;
  type: IntersectionIconType;
};

export type IntersectionIconInput = {
  bearing: Scalars['Int'];
  config: Scalars['Object'];
  link?: InputMaybe<Scalars['String']>;
  location: Scalars['Object'];
  name?: InputMaybe<Scalars['String']>;
  type: IntersectionIconType;
};

export type IntersectionIconStatus = {
  __typename?: 'IntersectionIconStatus';
  icons?: Maybe<Array<IntersectionIcon>>;
  intersectionId: Scalars['ID'];
};

export enum IntersectionIconType {
  Alarm = 'ALARM',
  Ball = 'BALL',
  Bikemaneuver = 'BIKEMANEUVER',
  Custom = 'CUSTOM',
  Emergency = 'EMERGENCY',
  Label = 'LABEL',
  Lrtmaneuver = 'LRTMANEUVER',
  Pattern = 'PATTERN',
  Pedmaneuver = 'PEDMANEUVER',
  Prioritor = 'PRIORITOR',
  Rail = 'RAIL',
  RampIndication = 'RAMP_INDICATION',
  RampLaneActRate = 'RAMP_LANE_ACT_RATE',
  RampLaneCmd = 'RAMP_LANE_CMD',
  RampLaneCmdRate = 'RAMP_LANE_CMD_RATE',
  RampLaneCmdSource = 'RAMP_LANE_CMD_SOURCE',
  RampLanePlan = 'RAMP_LANE_PLAN',
  RampWarningFlasher = 'RAMP_WARNING_FLASHER',
  Specialfx = 'SPECIALFX',
  Status = 'STATUS',
  Vehdetector = 'VEHDETECTOR',
  Vehmaneuver = 'VEHMANEUVER'
}

export type IntersectionInput = {
  crosswalks: Array<IntersectionCrosswalkInput>;
  details: IntersectionDetailsInput;
  devices: Array<IntersectionDeviceInput>;
  groupId?: InputMaybe<Scalars['String']>;
  icons: Array<IntersectionIconInput>;
  /**  Identifier of the intersection  */
  id?: InputMaybe<Scalars['ID']>;
  lanes: Array<IntersectionLaneInput>;
  location: Scalars['Object'];
  locationId: Scalars['ID'];
  maneuvers: Array<IntersectionManeuverInput>;
  multiModals: Array<IntersectionMultiModalInput>;
};

export type IntersectionLane = {
  __typename?: 'IntersectionLane';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  laneDirection: IntersectionLaneDirection;
  location: Scalars['Object'];
  travelDirection?: Maybe<IntersectionTravelDirection>;
  vehicleDetectors: Array<IntersectionVehicleDetector>;
};

export enum IntersectionLaneDirection {
  Approach = 'APPROACH',
  Departure = 'DEPARTURE'
}

export type IntersectionLaneInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  laneDirection: IntersectionLaneDirection;
  location: Scalars['Object'];
  travelDirection?: InputMaybe<IntersectionTravelDirection>;
  vehicleDetectors?: InputMaybe<Array<IntersectionVehicleDetectorInput>>;
};

export type IntersectionLocation = {
  __typename?: 'IntersectionLocation';
  deviceIds: Array<Scalars['String']>;
  intersectionId: Scalars['ID'];
  location: Scalars['Object'];
  locationId: Scalars['String'];
};

export type IntersectionManeuver = {
  __typename?: 'IntersectionManeuver';
  deviceId?: Maybe<Scalars['String']>;
  icon: IntersectionIcon;
  /**  The associated location's Maneuver.id  */
  id: Scalars['ID'];
  maneuverType: IntersectionManeuverType;
  permissiveSignalIndication?: Maybe<SignalIndication>;
  protectedSignalIndication?: Maybe<SignalIndication>;
  refApproachLane: Scalars['String'];
  refDepartureLane: Scalars['String'];
};

export type IntersectionManeuverInput = {
  deviceId?: InputMaybe<Scalars['String']>;
  icon: IntersectionIconInput;
  /**  The associated location's Maneuver.id  */
  id: Scalars['ID'];
  maneuverType: IntersectionManeuverType;
  permissiveSignalIndication?: InputMaybe<SignalIndicationInput>;
  protectedSignalIndication?: InputMaybe<SignalIndicationInput>;
  refApproachLane: Scalars['String'];
  refDepartureLane: Scalars['String'];
};

export enum IntersectionManeuverType {
  Bike = 'BIKE',
  Lrt = 'LRT',
  Ped = 'PED',
  Vehicle = 'VEHICLE',
  Vehicleped = 'VEHICLEPED'
}

export enum IntersectionMapIcon {
  Ball = 'BALL',
  Bike = 'BIKE',
  Custom = 'CUSTOM',
  Hand = 'HAND',
  Leftarrow = 'LEFTARROW',
  Lrtgo = 'LRTGO',
  Lrtstop = 'LRTSTOP',
  Rightarrow = 'RIGHTARROW',
  Slightleftarrow = 'SLIGHTLEFTARROW',
  Slightrightarrow = 'SLIGHTRIGHTARROW',
  Stopbar = 'STOPBAR',
  Straightarrow = 'STRAIGHTARROW',
  Triangle = 'TRIANGLE',
  Uturn = 'UTURN',
  Walk = 'WALK'
}

export type IntersectionMultiModal = {
  __typename?: 'IntersectionMultiModal';
  deviceId: Scalars['String'];
  icon: IntersectionIcon;
  signalIndication?: Maybe<SignalIndication>;
};

export type IntersectionMultiModalInput = {
  deviceId: Scalars['String'];
  icon: IntersectionIconInput;
  signalIndication?: InputMaybe<SignalIndicationInput>;
};

export type IntersectionOverlapStatus = {
  __typename?: 'IntersectionOverlapStatus';
  intersectionId: Scalars['ID'];
  overlapStatus: Array<OverlapStatus>;
};

export type IntersectionPatternStatus = {
  __typename?: 'IntersectionPatternStatus';
  activeCycleLength: Scalars['Int'];
  activeOffset: Scalars['Int'];
  coordStatus: CoordStatus;
  intersectionId: Scalars['ID'];
  localCycle: Scalars['Int'];
  masterCycle: Scalars['Int'];
  patternNumber: Scalars['Int'];
  patternType: PatternType;
  programmedCycleLength: Scalars['Int'];
  programmedOffset: Scalars['Int'];
  splitTable: Scalars['Int'];
  timeDrift: Scalars['Int'];
};

export type IntersectionPedStatus = {
  __typename?: 'IntersectionPedStatus';
  intersectionId: Scalars['ID'];
  pedStatus: Array<PedStatus>;
};

export type IntersectionPhaseStatus = {
  __typename?: 'IntersectionPhaseStatus';
  intersectionId: Scalars['ID'];
  phaseStatus: Array<PhaseStatus>;
};

export type IntersectionPhaseSummaryCounts = {
  __typename?: 'IntersectionPhaseSummaryCounts';
  commDisabled: Scalars['Int'];
  commFailed: Scalars['Int'];
  green: Scalars['Int'];
  red: Scalars['Int'];
  unknown: Scalars['Int'];
  yellow: Scalars['Int'];
};

export type IntersectionSimpleStatus = {
  __typename?: 'IntersectionSimpleStatus';
  communicationState: CommunicationState;
  intersectionId: Scalars['ID'];
  mainActionColor?: Maybe<SignalOutputColor>;
  mainCommandSourceColor?: Maybe<SignalOutputColor>;
  mainImplementAction?: Maybe<RmcImplementAction>;
  mainImplementCommandSource?: Maybe<RmcImplementCommandSource>;
  mainImplementPlan: Scalars['Int'];
  mainImplementRate: Scalars['Int'];
  mainStatus?: Maybe<RmcImplementAction>;
  mainlineColor: SignalOutputColor;
  maneuverColor: Array<ManeuverColor>;
};

export type IntersectionStatusCategories = {
  __typename?: 'IntersectionStatusCategories';
  badPlan: Scalars['Int'];
  cabinetFlash: Scalars['Int'];
  commDisabled: Scalars['Int'];
  commFailed: Scalars['Int'];
  coordination: Scalars['Int'];
  free: Scalars['Int'];
  localFlash: Scalars['Int'];
  preempt: Scalars['Int'];
  transition: Scalars['Int'];
  unknown: Scalars['Int'];
};

export enum IntersectionStatusCategory {
  BadPlan = 'BAD_PLAN',
  CabinetFlash = 'CABINET_FLASH',
  CommDisabled = 'COMM_DISABLED',
  CommFailed = 'COMM_FAILED',
  Coord = 'COORD',
  Free = 'FREE',
  LocalFlash = 'LOCAL_FLASH',
  Preempt = 'PREEMPT',
  Transition = 'TRANSITION',
  Unknown = 'UNKNOWN'
}

export type IntersectionTemplate = {
  __typename?: 'IntersectionTemplate';
  /**  The description of the template  */
  description?: Maybe<Scalars['String']>;
  /**  The identifier of the template  */
  id: Scalars['ID'];
  /**  The name of the template  */
  name: Scalars['String'];
  /**  The intersectiion to serve as the template  */
  template: Intersection;
};

export type IntersectionTemplateConnection = {
  __typename?: 'IntersectionTemplateConnection';
  /**  connection edges  */
  edges: Array<IntersectionTemplateConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type IntersectionTemplateConnectionEdge = {
  __typename?: 'IntersectionTemplateConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: IntersectionTemplate;
};

export type IntersectionTemplateInput = {
  /**  The description of the template  */
  description?: InputMaybe<Scalars['String']>;
  /**  The identifier of the template  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The name of the template  */
  name: Scalars['String'];
  /**  The intersection to serve as the template  */
  template: IntersectionInput;
};

export type IntersectionTemplateInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter intersections */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum IntersectionTravelDirection {
  East = 'EAST',
  North = 'NORTH',
  NorthEast = 'NORTH_EAST',
  NorthWest = 'NORTH_WEST',
  Other = 'OTHER',
  South = 'SOUTH',
  SouthEast = 'SOUTH_EAST',
  SouthWest = 'SOUTH_WEST',
  West = 'WEST'
}

export enum IntersectionType {
  RampMeter = 'RAMP_METER',
  Signal = 'SIGNAL'
}

export type IntersectionVehicleDetector = {
  __typename?: 'IntersectionVehicleDetector';
  description?: Maybe<Scalars['String']>;
  distance: Scalars['Int'];
  icon: IntersectionIcon;
  length: Scalars['Int'];
  location?: Maybe<Scalars['Object']>;
  number: Scalars['Int'];
  showOnMap: Scalars['Boolean'];
  type?: Maybe<IntersectionVehicleDetectorType>;
  width: Scalars['Int'];
};

export type IntersectionVehicleDetectorInput = {
  description?: InputMaybe<Scalars['String']>;
  distance: Scalars['Int'];
  icon: IntersectionIconInput;
  length: Scalars['Int'];
  location?: InputMaybe<Scalars['Object']>;
  number: Scalars['Int'];
  showOnMap: Scalars['Boolean'];
  type?: InputMaybe<IntersectionVehicleDetectorType>;
  width: Scalars['Int'];
};

export enum IntersectionVehicleDetectorType {
  Advanced = 'ADVANCED',
  Demand = 'DEMAND',
  Exit = 'EXIT',
  Passage = 'PASSAGE',
  Queue = 'QUEUE',
  Stopbar = 'STOPBAR'
}

export enum IntervalUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Millisecond = 'MILLISECOND',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Second = 'SECOND',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type JobRequest = {
  __typename?: 'JobRequest';
  /**  The failure message to why the job failed to be created.  */
  failure?: Maybe<Scalars['String']>;
  /**  id of the integration  */
  id: Scalars['String'];
  /**  request id of the job  */
  requestId?: Maybe<Scalars['String']>;
  /**  if the job was successfully queued  */
  success: Scalars['Boolean'];
};

export type JobResult = {
  __typename?: 'JobResult';
  /**  The main response of the job */
  body?: Maybe<Scalars['JSON']>;
  /**  The failure message to what went wrong with the job. */
  failure?: Maybe<Scalars['String']>;
  /**  id of the integration */
  id: Scalars['String'];
  /**  the type of job run */
  jobType: JobType;
  /**  the request id */
  requestId?: Maybe<Scalars['String']>;
  /**  if the job was successfully run */
  success: Scalars['Boolean'];
};

export enum JobType {
  AddWorkOrder = 'ADD_WORK_ORDER',
  AlertPoll = 'ALERT_POLL',
  AlertUpdate = 'ALERT_UPDATE',
  BackupDeviceDatabase = 'BACKUP_DEVICE_DATABASE',
  C2CPoll = 'C2C_POLL',
  CadSubscription = 'CAD_SUBSCRIPTION',
  CameraAutoFocus = 'CAMERA_AUTO_FOCUS',
  CameraAutoIris = 'CAMERA_AUTO_IRIS',
  CameraCapabilities = 'CAMERA_CAPABILITIES',
  CameraConnectStreamFile = 'CAMERA_CONNECT_STREAM_FILE',
  CameraDisablePublicStreamTarget = 'CAMERA_DISABLE_PUBLIC_STREAM_TARGET',
  CameraDisconnectStreamFile = 'CAMERA_DISCONNECT_STREAM_FILE',
  CameraEnablePublicStreamTarget = 'CAMERA_ENABLE_PUBLIC_STREAM_TARGET',
  CameraFetchRecording = 'CAMERA_FETCH_RECORDING',
  CameraFocus = 'CAMERA_FOCUS',
  CameraGetMaxPresets = 'CAMERA_GET_MAX_PRESETS',
  CameraGoToPreset = 'CAMERA_GO_TO_PRESET',
  CameraIris = 'CAMERA_IRIS',
  CameraPanTilt = 'CAMERA_PAN_TILT',
  CameraPoll = 'CAMERA_POLL',
  CameraSavePreset = 'CAMERA_SAVE_PRESET',
  CameraStartStreamRecording = 'CAMERA_START_STREAM_RECORDING',
  CameraStopStreamRecording = 'CAMERA_STOP_STREAM_RECORDING',
  CameraZoom = 'CAMERA_ZOOM',
  ChangeDeviceFirmware = 'CHANGE_DEVICE_FIRMWARE',
  ConnectedVehiclePoll = 'CONNECTED_VEHICLE_POLL',
  Detector = 'DETECTOR',
  DetectorConnectionLogs = 'DETECTOR_CONNECTION_LOGS',
  DetectorPoll = 'DETECTOR_POLL',
  DetectorSubscription = 'DETECTOR_SUBSCRIPTION',
  DetectorVehicleRecords = 'DETECTOR_VEHICLE_RECORDS',
  DownloadDeviceDatabase = 'DOWNLOAD_DEVICE_DATABASE',
  /**  Value representing that a gate controller has been polled */
  GateControllerPoll = 'GATE_CONTROLLER_POLL',
  GetPublicFeed = 'GET_PUBLIC_FEED',
  GetStreamFileEnabled = 'GET_STREAM_FILE_ENABLED',
  GetStreamTargetEnabled = 'GET_STREAM_TARGET_ENABLED',
  HarBeaconPoll = 'HAR_BEACON_POLL',
  HarBeaconToggle = 'HAR_BEACON_TOGGLE',
  HarTransmitterAttenuatorLevel = 'HAR_TRANSMITTER_ATTENUATOR_LEVEL',
  HarTransmitterBlank = 'HAR_TRANSMITTER_BLANK',
  HarTransmitterPoll = 'HAR_TRANSMITTER_POLL',
  HarTransmitterPost = 'HAR_TRANSMITTER_POST',
  HarTransmitterPowerLevel = 'HAR_TRANSMITTER_POWER_LEVEL',
  HarTransmitterVoiceSpeed = 'HAR_TRANSMITTER_VOICE_SPEED',
  HarTransmitterWeatherRadio = 'HAR_TRANSMITTER_WEATHER_RADIO',
  InstantCameraSnapshot = 'INSTANT_CAMERA_SNAPSHOT',
  ListWorkOrders = 'LIST_WORK_ORDERS',
  ResponsePoll = 'RESPONSE_POLL',
  SetSnapshotsTag = 'SET_SNAPSHOTS_TAG',
  SetTimeNow = 'SET_TIME_NOW',
  SignalGetMibs = 'SIGNAL_GET_MIBS',
  SignalInterval = 'SIGNAL_INTERVAL',
  SignalPoll = 'SIGNAL_POLL',
  SignalPollSubscription = 'SIGNAL_POLL_SUBSCRIPTION',
  SignalSetMibs = 'SIGNAL_SET_MIBS',
  SignalSubscription = 'SIGNAL_SUBSCRIPTION',
  SignalSubscriptionOnDemand = 'SIGNAL_SUBSCRIPTION_ON_DEMAND',
  SignalTrafficEvents = 'SIGNAL_TRAFFIC_EVENTS',
  SignalUiTable = 'SIGNAL_UI_TABLE',
  SignalUiViews = 'SIGNAL_UI_VIEWS',
  /**  Value representing that the message being sent is for blanking the signage */
  SignBlank = 'SIGN_BLANK',
  SignCapabilities = 'SIGN_CAPABILITIES',
  /**  Value representing that the graphic is being marked for deletion */
  SignDeleteGraphic = 'SIGN_DELETE_GRAPHIC',
  /**  Value representing that the message being sent is for displaying something */
  SignDisplay = 'SIGN_DISPLAY',
  /**  Value representing that the graphic is being downloaded */
  SignDownloadGraphic = 'SIGN_DOWNLOAD_GRAPHIC',
  /**  Value representing that messages can be downloaded from the controller */
  SignDownloadMessage = 'SIGN_DOWNLOAD_MESSAGE',
  /**  Value representing that the message being sent is for extending message displaying time */
  SignExtend = 'SIGN_EXTEND',
  /**  Value representing that the sign fan test has been completed */
  SignFanTest = 'SIGN_FAN_TEST',
  /**  Value representing that the message being sent is for getting supported fonts */
  SignFont = 'SIGN_FONT',
  SignFonts = 'SIGN_FONTS',
  /**  Value representing that the message being sent is for getting font info */
  SignFontInfo = 'SIGN_FONT_INFO',
  /**  Value representing that the message being sent is for polling the display */
  SignPoll = 'SIGN_POLL',
  /**  Value representing that the message being sent is for Setting Brightness */
  SignSetBrightness = 'SIGN_SET_BRIGHTNESS',
  /**  Value representing that the message being sent is for a Soft Reset */
  SignSoftReset = 'SIGN_SOFT_RESET',
  /**  Value representing that the graphic is being uploaded */
  SignUploadGraphic = 'SIGN_UPLOAD_GRAPHIC',
  /**  Value representing that messages can be uploaded to the controller */
  SignUploadMessage = 'SIGN_UPLOAD_MESSAGE',
  StreamManagerPoll = 'STREAM_MANAGER_POLL',
  TravelTimeSegmentPoll = 'TRAVEL_TIME_SEGMENT_POLL',
  UseCameraCapability = 'USE_CAMERA_CAPABILITY',
  WeatherStationPoll = 'WEATHER_STATION_POLL'
}

export type JsReportConfig = {
  /**  data  */
  data: Scalars['JSON'];
  /**  template  */
  template?: InputMaybe<JsReportTemplate>;
  /**  type  */
  type: Scalars['String'];
};

export type JsReportRequest = {
  /**  charts  */
  charts?: InputMaybe<Array<Scalars['JSON']>>;
  /**  report  */
  report: JsReportConfig;
};

export type JsReportTemplate = {
  /**  content  */
  content?: InputMaybe<Scalars['String']>;
  /**  engine  */
  engine?: InputMaybe<Scalars['String']>;
  /**  helpers  */
  helpers?: InputMaybe<Scalars['String']>;
  /**  recipe  */
  recipe?: InputMaybe<Scalars['String']>;
};

export type KeycloakClient = {
  __typename?: 'KeycloakClient';
  clientId: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  secret: Scalars['String'];
};

export type KineticEffectivePrivilegeAssignment = {
  __typename?: 'KineticEffectivePrivilegeAssignment';
  id: Scalars['ID'];
  kineticModule: KineticModule;
  privilegeType: PrivilegeType;
  restrictedAreas: Array<Scalars['Object']>;
  restrictedEntities?: Maybe<Scalars['Object']>;
  restrictedIntegrationGroups?: Maybe<Array<Scalars['String']>>;
  restrictedIntegrations: Array<Scalars['String']>;
  restrictedLocationGroups?: Maybe<Array<Scalars['String']>>;
  restrictedLocations?: Maybe<Array<Scalars['String']>>;
};

export type KineticForm = {
  __typename?: 'KineticForm';
  /**  can the form be modified within a tenant  */
  canOverride?: Maybe<Scalars['Boolean']>;
  /**  form description  */
  description?: Maybe<Scalars['String']>;
  /**  extra form config  */
  extraConfig: Scalars['Object'];
  id: Scalars['ID'];
  /**  when the form was last modified for tenant forms  */
  modified?: Maybe<Scalars['DateTime']>;
  /**  form module  */
  module: KineticModule;
  /**  form name  */
  name: Scalars['String'];
  /**  identifies if it is a system form  */
  system?: Maybe<Scalars['Boolean']>;
  /**  form views  */
  views: Array<Maybe<KineticFormView>>;
};

export type KineticFormConnection = {
  __typename?: 'KineticFormConnection';
  /**  connection edges  */
  edges: Array<KineticFormConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type KineticFormConnectionEdge = {
  __typename?: 'KineticFormConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: KineticForm;
};

export type KineticFormField = {
  __typename?: 'KineticFormField';
  /**  accept type  */
  accept?: Maybe<Scalars['String']>;
  /**  json logic for active  */
  activeLogic?: Maybe<Scalars['Object']>;
  /**  can the field be modified within a tenant  */
  canOverride?: Maybe<Scalars['Boolean']>;
  /**  The ID of the data source associated with this field */
  dataSource?: Maybe<Scalars['String']>;
  /**  Default for the form field  */
  defaultValue?: Maybe<Scalars['Object']>;
  /**  field description  */
  description?: Maybe<Scalars['String']>;
  /**  prevent future dates for date field type  */
  disableFuture?: Maybe<Scalars['Boolean']>;
  /**  prevent previous dates for date field type  */
  disablePast?: Maybe<Scalars['Boolean']>;
  /**  if the field is active  */
  disabled?: Maybe<Scalars['Boolean']>;
  /**  display date format for date field type  */
  displayFormat?: Maybe<Scalars['String']>;
  /**  field size  */
  fieldSize?: Maybe<Scalars['String']>;
  /**  date format for date field type  */
  format?: Maybe<Scalars['String']>;
  /**  help details  */
  help?: Maybe<Scalars['String']>;
  /**  field hint  */
  hint?: Maybe<Scalars['String']>;
  /**  The icon config  */
  iconConfig?: Maybe<Scalars['Object']>;
  /**  unique identifier  */
  id: Scalars['ID'];
  /**  field label  */
  label: Scalars['String'];
  /**  if the loading indicator is shown  */
  loading?: Maybe<Scalars['Boolean']>;
  /**  max value for number fields  */
  max?: Maybe<Scalars['Float']>;
  /**  min value for number fields  */
  min?: Maybe<Scalars['Float']>;
  /**  the mode of the field */
  mode?: Maybe<Scalars['String']>;
  /**  the module for upload  */
  moduleName?: Maybe<Scalars['String']>;
  /**  if multiline supported for text field */
  multiline?: Maybe<Scalars['Boolean']>;
  /**  if multi select supported  */
  multiple?: Maybe<Scalars['Boolean']>;
  /**  name of the field  */
  name: Scalars['String'];
  /**  field options  */
  options?: Maybe<Array<KineticFormFieldOption>>;
  /**  the z-index of a color-picker field */
  pickerZIndex?: Maybe<Scalars['Int']>;
  /**  if field is required  */
  required?: Maybe<Scalars['Boolean']>;
  /**  json logic for required  */
  requiredLogic?: Maybe<Scalars['Object']>;
  /**  No of rows in a text field */
  rows?: Maybe<Scalars['Int']>;
  /**  order for options list  */
  sortOrder?: Maybe<Scalars['String']>;
  /**  collection id for type data source  */
  source?: Maybe<Scalars['ID']>;
  /**  stepper value  */
  step?: Maybe<Scalars['Float']>;
  /**  identifies if it is a system form field  */
  system?: Maybe<Scalars['Boolean']>;
  /**  field type  */
  type: Scalars['String'];
  /**  upload type  */
  uploadType?: Maybe<Scalars['String']>;
  /**  if number field should use stepper  */
  useStepper?: Maybe<Scalars['Boolean']>;
};

export type KineticFormFieldConnection = {
  __typename?: 'KineticFormFieldConnection';
  /**  connection edges  */
  edges: Array<KineticFormFieldConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type KineticFormFieldConnectionEdge = {
  __typename?: 'KineticFormFieldConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: KineticFormField;
};

export type KineticFormFieldInput = {
  /**  accept type  */
  accept?: InputMaybe<Scalars['String']>;
  /**  json logic for active  */
  activeLogic?: InputMaybe<Scalars['Object']>;
  /**  The ID of the data source associated with this field */
  dataSource?: InputMaybe<Scalars['String']>;
  /**  Default for the form field  */
  defaultValue?: InputMaybe<Scalars['Object']>;
  /**  field description  */
  description?: InputMaybe<Scalars['String']>;
  /**  prevent future dates for date field type  */
  disableFuture?: InputMaybe<Scalars['Boolean']>;
  /**  prevent previous dates for date field type  */
  disablePast?: InputMaybe<Scalars['Boolean']>;
  /**  if the field is active  */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /**  display date format for date field type  */
  displayFormat?: InputMaybe<Scalars['String']>;
  /**  field size  */
  fieldSize?: InputMaybe<Scalars['String']>;
  /**  date format for date field type  */
  format?: InputMaybe<Scalars['String']>;
  /**  help details  */
  help?: InputMaybe<Scalars['String']>;
  /**  field hint  */
  hint?: InputMaybe<Scalars['String']>;
  /**  The icon config  */
  iconConfig?: InputMaybe<Scalars['Object']>;
  /**  unique identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  field label  */
  label: Scalars['String'];
  /**  if the loading indicator is shown  */
  loading?: InputMaybe<Scalars['Boolean']>;
  /**  max value for number fields  */
  max?: InputMaybe<Scalars['Float']>;
  /**  min value for number fields  */
  min?: InputMaybe<Scalars['Float']>;
  /**  the mode of the field */
  mode?: InputMaybe<Scalars['String']>;
  /**  the module for upload  */
  moduleName?: InputMaybe<Scalars['String']>;
  /**  if multiline supported for text field */
  multiline?: InputMaybe<Scalars['Boolean']>;
  /**  if multi select supported  */
  multiple?: InputMaybe<Scalars['Boolean']>;
  /**  name of the field  */
  name: Scalars['String'];
  /**  field options  */
  options?: InputMaybe<Array<KineticFormFieldOptionInput>>;
  /**  the z-index of a color-picker field */
  pickerZIndex?: InputMaybe<Scalars['Int']>;
  /**  if field is required  */
  required?: InputMaybe<Scalars['Boolean']>;
  /**  json logic for required  */
  requiredLogic?: InputMaybe<Scalars['Object']>;
  /**  No of rows in a text field */
  rows?: InputMaybe<Scalars['Int']>;
  /**  order for options list  */
  sortOrder?: InputMaybe<Scalars['String']>;
  /**  collection id for type data source  */
  source?: InputMaybe<Scalars['ID']>;
  /**  stepper value  */
  step?: InputMaybe<Scalars['Float']>;
  /**  field type  */
  type: Scalars['String'];
  /**  upload type  */
  uploadType?: InputMaybe<Scalars['String']>;
  /**  if number field should use stepper  */
  useStepper?: InputMaybe<Scalars['Boolean']>;
};

export type KineticFormFieldInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type KineticFormFieldOption = {
  __typename?: 'KineticFormFieldOption';
  /**  option label  */
  label: Scalars['String'];
  /**  type */
  type?: Maybe<Scalars['String']>;
  /**  option value  */
  value: Scalars['String'];
};

export type KineticFormFieldOptionInput = {
  /**  option label  */
  label: Scalars['String'];
  /**  option value  */
  value: Scalars['String'];
};

export type KineticFormInput = {
  /**  form description  */
  description?: InputMaybe<Scalars['String']>;
  /**  extra form config  */
  extraConfig: Scalars['Object'];
  /**  form identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  form module  */
  module: KineticModule;
  /**  form name  */
  name: Scalars['String'];
  /**  form views  */
  views: Array<InputMaybe<KineticFormViewInput>>;
};

export type KineticFormInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  Kinetic Module to filter by  */
  module?: InputMaybe<KineticModule>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type KineticFormSection = {
  __typename?: 'KineticFormSection';
  /**  list of fields  */
  fields: Array<Maybe<KineticFormField>>;
  /**  section identifier  */
  id: Scalars['ID'];
  /**  name of section  */
  name: Scalars['String'];
};

export type KineticFormSectionInput = {
  /**  list of identifiers for kinetic form fields  */
  fields: Array<Scalars['String']>;
  /**  section identifier  */
  id: Scalars['ID'];
  /**  name of section  */
  name: Scalars['String'];
};

export type KineticFormView = {
  __typename?: 'KineticFormView';
  /**  view identifier  */
  id: Scalars['ID'];
  /**  view name  */
  name: Scalars['String'];
  /**  view sections  */
  sections: Array<KineticFormSection>;
};

export type KineticFormViewInput = {
  /**  view identifier  */
  id: Scalars['ID'];
  /**  view name  */
  name: Scalars['String'];
  /**  view sections  */
  sections: Array<KineticFormSectionInput>;
};

export type KineticGateController = {
  __typename?: 'KineticGateController';
  /**  gate arms  */
  gateArms: Array<KineticGateControllerArm>;
  /**  gate controller  */
  id: Scalars['ID'];
};

export type KineticGateControllerArm = {
  __typename?: 'KineticGateControllerArm';
  /**  arm health  */
  health: GateArmHealth;
  /**  native id  */
  nativeId: Scalars['Int'];
  /**  arm position  */
  position: GateArmPosition;
};

export type KineticLicenseDetails = {
  __typename?: 'KineticLicenseDetails';
  accountId?: Maybe<Scalars['String']>;
  activationId: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  leaseExpiresAt?: Maybe<Scalars['DateTime']>;
};

export enum KineticLicenseFeature {
  AssetManagement = 'ASSET_MANAGEMENT',
  C2C = 'C2C',
  ConnectedVehicle = 'CONNECTED_VEHICLE',
  Corridors = 'CORRIDORS',
  Counts = 'COUNTS',
  Events = 'EVENTS',
  Fleet = 'FLEET',
  Gates = 'GATES',
  Har = 'HAR',
  Parking = 'PARKING',
  RampMeter = 'RAMP_METER',
  Response = 'RESPONSE',
  RoadAssistance = 'ROAD_ASSISTANCE',
  RoadConditions = 'ROAD_CONDITIONS',
  Signals = 'SIGNALS',
  Signs = 'SIGNS',
  Tolling = 'TOLLING',
  TravelTime = 'TRAVEL_TIME',
  Tunnels = 'TUNNELS',
  Video = 'VIDEO',
  Weather = 'WEATHER'
}

export type KineticLicenseFeatureValue = {
  __typename?: 'KineticLicenseFeatureValue';
  enabled: Scalars['Boolean'];
  feature: KineticLicenseFeature;
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

export enum KineticModule {
  AssetManagement = 'ASSET_MANAGEMENT',
  C2C = 'C2C',
  ConnectedVehicle = 'CONNECTED_VEHICLE',
  Contacts = 'CONTACTS',
  Corridors = 'CORRIDORS',
  Counts = 'COUNTS',
  Emails = 'EMAILS',
  Events = 'EVENTS',
  Fleet = 'FLEET',
  Gates = 'GATES',
  Har = 'HAR',
  Integrations = 'INTEGRATIONS',
  Locations = 'LOCATIONS',
  Parking = 'PARKING',
  RampMeter = 'RAMP_METER',
  Reports = 'REPORTS',
  Response = 'RESPONSE',
  RoadAssistance = 'ROAD_ASSISTANCE',
  RoadConditions = 'ROAD_CONDITIONS',
  Signals = 'SIGNALS',
  Signs = 'SIGNS',
  System = 'SYSTEM',
  Tolling = 'TOLLING',
  TravelTime = 'TRAVEL_TIME',
  Tunnels = 'TUNNELS',
  Video = 'VIDEO',
  Weather = 'WEATHER'
}

export type KineticOrganization = {
  __typename?: 'KineticOrganization';
  address?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type KineticOrganizationInput = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type KineticPrivilege = {
  __typename?: 'KineticPrivilege';
  id: Scalars['ID'];
  kineticModule: KineticModule;
  privilegeType: PrivilegeType;
};

export type KineticPrivilegeAssignment = {
  __typename?: 'KineticPrivilegeAssignment';
  id: Scalars['ID'];
  kineticModule: KineticModule;
  privilegeType: PrivilegeType;
  restrictedAreas: Array<Scalars['Object']>;
  restrictedEntities?: Maybe<Scalars['Object']>;
  restrictedIntegrationGroups: Array<Scalars['String']>;
  restrictedIntegrations: Array<Scalars['String']>;
  restrictedLocationGroups?: Maybe<Array<Scalars['String']>>;
  restrictedLocations?: Maybe<Array<Scalars['String']>>;
};

export type KineticPrivilegeAssignmentInput = {
  id: Scalars['ID'];
  kineticModule: KineticModule;
  privilegeType: PrivilegeType;
  restrictedAreas: Array<Scalars['Object']>;
  restrictedEntities?: InputMaybe<Scalars['Object']>;
  restrictedIntegrationGroups: Array<Scalars['String']>;
  restrictedIntegrations: Array<Scalars['String']>;
  restrictedLocationGroups?: InputMaybe<Array<Scalars['String']>>;
  restrictedLocations?: InputMaybe<Array<Scalars['String']>>;
};

export type KineticRole = {
  __typename?: 'KineticRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  privilegeAssignmentList: Array<KineticPrivilegeAssignment>;
  restrictedAreas: Array<Scalars['Object']>;
  restrictedEntities?: Maybe<Scalars['Object']>;
  restrictedIntegrationGroups: Array<Scalars['String']>;
  restrictedIntegrations: Array<Scalars['String']>;
  restrictedLocationGroups?: Maybe<Array<Scalars['String']>>;
  restrictedLocations?: Maybe<Array<Scalars['String']>>;
};

export type KineticRoleInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  privilegeAssignmentList: Array<KineticPrivilegeAssignmentInput>;
  restrictedAreas: Array<Scalars['Object']>;
  restrictedEntities?: InputMaybe<Scalars['Object']>;
  restrictedIntegrationGroups: Array<Scalars['String']>;
  restrictedIntegrations: Array<Scalars['String']>;
  restrictedLocationGroups?: InputMaybe<Array<Scalars['String']>>;
  restrictedLocations?: InputMaybe<Array<Scalars['String']>>;
};

export type KineticTransmitter = {
  __typename?: 'KineticTransmitter';
  /**  attenuator level  */
  attenuatorLevel: Scalars['Int'];
  /**  broadcast state  */
  broadcastState: Scalars['String'];
  /**  identifier  */
  id: Scalars['ID'];
  /**  playlist  */
  playlist?: Maybe<KineticTransmitterPlaylist>;
  /**  power level  */
  powerLevel: Scalars['Int'];
  /**  voice speed  */
  voiceSpeed: Scalars['Int'];
};

export type KineticTransmitterMessage = {
  __typename?: 'KineticTransmitterMessage';
  /**  message id  */
  id: Scalars['ID'];
  /**  message name  */
  name: Scalars['String'];
  /**  message text  */
  text: Scalars['String'];
};

export type KineticTransmitterMessageInput = {
  /**  message id  */
  id: Scalars['ID'];
  /**  message name  */
  name: Scalars['String'];
  /**  message text  */
  text: Scalars['String'];
};

export type KineticTransmitterPlaylist = {
  __typename?: 'KineticTransmitterPlaylist';
  /**  id  */
  id: Scalars['ID'];
  /**  messages  */
  messages: Array<KineticTransmitterMessage>;
  /**  name  */
  name: Scalars['String'];
};

export type KineticTransmitterPlaylistInput = {
  /**  id  */
  id: Scalars['ID'];
  /**  messages  */
  messages: Array<KineticTransmitterMessageInput>;
  /**  name  */
  name: Scalars['String'];
};

export type KineticUser = {
  __typename?: 'KineticUser';
  email?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['String']>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kineticPreference?: Maybe<Scalars['JSON']>;
  kineticPreferences: Array<UserPreference>;
  lastName?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  preference?: Maybe<Scalars['JSON']>;
  preferences: Array<UserPreference>;
  username: Scalars['String'];
};


export type KineticUserFilesArgs = {
  key: Scalars['String'];
};


export type KineticUserKineticPreferenceArgs = {
  key: Scalars['ID'];
};


export type KineticUserPreferenceArgs = {
  key: Scalars['ID'];
};

export type KineticUserConnection = {
  __typename?: 'KineticUserConnection';
  edges: Array<KineticUserConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type KineticUserConnectionEdge = {
  __typename?: 'KineticUserConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: OrganizationKineticUser;
};

export type KineticUserGroup = {
  __typename?: 'KineticUserGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  privilegeAssignmentList: Array<KineticPrivilegeAssignment>;
  restrictedAreas: Array<Scalars['Object']>;
  restrictedEntities?: Maybe<Scalars['Object']>;
  restrictedIntegrationGroups: Array<Scalars['String']>;
  restrictedIntegrations: Array<Scalars['String']>;
  restrictedLocationGroups?: Maybe<Array<Scalars['String']>>;
  restrictedLocations?: Maybe<Array<Scalars['String']>>;
  roles: Array<KineticRole>;
  users: Array<OrganizationKineticUser>;
};

export type KineticUserGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  privilegeAssignmentList: Array<KineticPrivilegeAssignmentInput>;
  restrictedAreas: Array<Scalars['Object']>;
  restrictedEntities?: InputMaybe<Scalars['Object']>;
  restrictedIntegrationGroups: Array<Scalars['String']>;
  restrictedIntegrations: Array<Scalars['String']>;
  restrictedLocationGroups?: InputMaybe<Array<Scalars['String']>>;
  restrictedLocations?: InputMaybe<Array<Scalars['String']>>;
  roleIds: Array<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type KineticUserPrivilegeAssignment = {
  __typename?: 'KineticUserPrivilegeAssignment';
  id: Scalars['ID'];
  privilegeAssignmentList: Array<KineticPrivilegeAssignment>;
  roles: Array<KineticRole>;
};

export type KineticUserPrivilegeAssignmentInput = {
  id: Scalars['ID'];
  privilegeAssignmentList: Array<KineticPrivilegeAssignmentInput>;
  roleIds: Array<Scalars['String']>;
  userGroupIds: Array<Scalars['String']>;
};

export enum LabelType {
  Executive = 'EXECUTIVE',
  FirstResponse = 'FIRST_RESPONSE'
}

export type Lane = {
  __typename?: 'Lane';
  description?: Maybe<Scalars['String']>;
  geometry: Scalars['Object'];
  id: Scalars['ID'];
  laneDirection: LaneDirection;
  travelDirection?: Maybe<TravelDirection>;
};

export type LaneControlAction = {
  __typename?: 'LaneControlAction';
  /**  lane control action command  */
  command?: Maybe<Scalars['String']>;
  /**  lane control action priority */
  priority?: Maybe<Scalars['Int']>;
};

export type LaneControlActionInput = {
  /**  lane control action command  */
  command?: InputMaybe<Scalars['String']>;
  /**  lane control action priority */
  priority?: InputMaybe<Scalars['Int']>;
};

export type LaneControlCommand = {
  __typename?: 'LaneControlCommand';
  /**  if the command is the default  */
  defaultCommand: Scalars['Boolean'];
  /**  the translated image data  */
  image: Scalars['Object'];
  /**  the translated message markup  */
  message: Scalars['String'];
  /**  name of the command  */
  name: Scalars['String'];
};

export type LaneControlCommandInput = {
  /**  if the command is the default  */
  defaultCommand: Scalars['Boolean'];
  /**  the translated image data  */
  image: Scalars['Object'];
  /**  the translated message markup  */
  message: Scalars['String'];
  /**  name of the command  */
  name: Scalars['String'];
};

export type LaneControlSettings = {
  __typename?: 'LaneControlSettings';
  /**  The list of configured commands  */
  commands: Array<LaneControlCommand>;
  /**  if the sign should be blank by default  */
  defaultBlank: Scalars['Boolean'];
  /**  The identifier of the settings  */
  id: Scalars['ID'];
  /**  The name of the settings  */
  name: Scalars['String'];
  /**  The list of sign identifiers who use these settings  */
  signs: Array<Scalars['ID']>;
  /**  if the settings should be used as the system default  */
  systemDefault: Scalars['Boolean'];
};

export type LaneControlSettingsConnection = {
  __typename?: 'LaneControlSettingsConnection';
  /**  The contained edges  */
  edges: Array<LaneControlSettingsConnectionEdge>;
  /**  Pagination info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type LaneControlSettingsConnectionEdge = {
  __typename?: 'LaneControlSettingsConnectionEdge';
  /**  the location of the edge in the page results  */
  cursor?: Maybe<Scalars['String']>;
  /**  entity details for the node  */
  node: LaneControlSettings;
};

export type LaneControlSettingsInput = {
  /**  The list of configured commands  */
  commands: Array<LaneControlCommandInput>;
  /**  if the sign should be blank by default  */
  defaultBlank: Scalars['Boolean'];
  /**  The identifier of the settings  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The name of the settings  */
  name: Scalars['String'];
  /**  The list of sign identifiers who use these settings  */
  signs: Array<Scalars['ID']>;
  /**  if the settings should be used as the system default  */
  systemDefault: Scalars['Boolean'];
};

export enum LaneDirection {
  Approach = 'APPROACH',
  Departure = 'DEPARTURE'
}

export type LaneInput = {
  description?: InputMaybe<Scalars['String']>;
  geometry: Scalars['Object'];
  id: Scalars['ID'];
  laneDirection: LaneDirection;
  travelDirection?: InputMaybe<TravelDirection>;
};

export enum LaneStatus {
  /**  Lane is cautioned  */
  Caution = 'CAUTION',
  /**  Lane is closed  */
  Closed = 'CLOSED',
  /**  Lane is open  */
  Open = 'OPEN'
}

export enum LaneType {
  /**  Express Lane  */
  ExpressLane = 'EXPRESS_LANE',
  /**  Flyover  */
  Flyover = 'FLYOVER',
  /**  General Purpose  */
  GeneralPurpose = 'GENERAL_PURPOSE',
  /**  HOV  */
  Hov = 'HOV',
  /**  Left Shoulder  */
  LeftShoulder = 'LEFT_SHOULDER',
  /**  Left Turn  */
  LeftTurn = 'LEFT_TURN',
  /**  Median  */
  Median = 'MEDIAN',
  /**  Off Ramp  */
  OffRamp = 'OFF_RAMP',
  /**  On Ramp  */
  OnRamp = 'ON_RAMP',
  /**  Reversible  */
  Reversible = 'REVERSIBLE',
  /**  Right Shoulder  */
  RightShoulder = 'RIGHT_SHOULDER',
  /**  Right Turn  */
  RightTurn = 'RIGHT_TURN',
  /**  Through  */
  Through = 'THROUGH',
  /**  Detection Zone  */
  Zone = 'ZONE'
}

export type LaneVolumeForecast = {
  __typename?: 'LaneVolumeForecast';
  lane?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Int']>;
};

export type Layout = {
  __typename?: 'Layout';
  areas: Array<LayoutArea>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LayoutArea = {
  __typename?: 'LayoutArea';
  areaId?: Maybe<Scalars['String']>;
  columns: Scalars['Int'];
  disabled?: Maybe<Scalars['Boolean']>;
  rows: Scalars['Int'];
};

export type LayoutAreaInput = {
  areaId?: InputMaybe<Scalars['String']>;
  columns: Scalars['Int'];
  disabled?: InputMaybe<Scalars['Boolean']>;
  rows: Scalars['Int'];
};

export type LayoutInput = {
  areas: Array<LayoutAreaInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export enum LegalStatusCode {
  AlarmSign = 'ALARM_SIGN',
  Axle_1Overloaded = 'AXLE_1_OVERLOADED',
  Axle_2Overloaded = 'AXLE_2_OVERLOADED',
  Axle_3Overloaded = 'AXLE_3_OVERLOADED',
  Axle_4Overloaded = 'AXLE_4_OVERLOADED',
  Axle_5Overloaded = 'AXLE_5_OVERLOADED',
  Axle_6Overloaded = 'AXLE_6_OVERLOADED',
  Axle_7Overloaded = 'AXLE_7_OVERLOADED',
  Axle_8Overloaded = 'AXLE_8_OVERLOADED',
  AxleOverloaded = 'AXLE_OVERLOADED',
  GrossOverloaded = 'GROSS_OVERLOADED',
  OutOfLane = 'OUT_OF_LANE',
  OverHeight = 'OVER_HEIGHT',
  OverLength = 'OVER_LENGTH',
  OverSpeed = 'OVER_SPEED',
  Reserved = 'RESERVED'
}

export enum LightStatus {
  Off = 'OFF',
  On = 'ON'
}

export type ListWorkOrderArguments = {
  /**  asset id */
  assetId: Scalars['String'];
  /**  device id */
  id: Scalars['ID'];
  /**  limit */
  limit: Scalars['Int'];
  /**  request id */
  requestId?: InputMaybe<Scalars['String']>;
  /**  sort field */
  sortField?: InputMaybe<Scalars['String']>;
  /**  sort order */
  sortOrder?: InputMaybe<Scalars['String']>;
  /**  start index for query */
  startIndex?: InputMaybe<Scalars['Int']>;
};

export type LocalDeviceDatabase = {
  __typename?: 'LocalDeviceDatabase';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: LocalDeviceDatabaseType;
};

export enum LocalDeviceDatabaseType {
  Active = 'ACTIVE',
  Factory = 'FACTORY',
  Unknown = 'UNKNOWN',
  Usb = 'USB',
  User = 'USER'
}

export type Location = {
  __typename?: 'Location';
  assets?: Maybe<Array<Asset>>;
  /**  Entities in other modules associated with this location  */
  associatedEntities: Array<LocationAssociation>;
  /**  Fill or edge color for certain geometry types  */
  color?: Maybe<Scalars['String']>;
  crosswalks: Array<Crosswalk>;
  details: LocationDetails;
  /**  C2C external center ID, if applicable  */
  externalCenterId?: Maybe<Scalars['String']>;
  geometry: Scalars['Object'];
  /**  Associated location group ID, if applicable  */
  groupId?: Maybe<Scalars['String']>;
  /**  The identifier of the location  */
  id: Scalars['ID'];
  integrations: Array<Integration>;
  lanes: Array<Lane>;
  locationType: Scalars['String'];
  maneuvers: Array<Maneuver>;
  /**  Background opacity for certain geometry types  */
  opacity?: Maybe<Scalars['Float']>;
  /**  Order within the group, if applicable  */
  order?: Maybe<Scalars['Float']>;
  signalIntersection?: Maybe<Intersection>;
};

export type LocationArea = {
  __typename?: 'LocationArea';
  /**  The code of the area, distinct by type  */
  code: Scalars['String'];
  /**  The density of the area  */
  density?: Maybe<LocationAreaDensity>;
  /**  The geometry of the area  */
  geometry: Scalars['Object'];
  /**  The name of the area  */
  name: Scalars['String'];
  /**  The type of the area  */
  type: Scalars['String'];
};

export type LocationAreaConnection = {
  __typename?: 'LocationAreaConnection';
  edges: Array<LocationAreaConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LocationAreaConnectionEdge = {
  __typename?: 'LocationAreaConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: LocationArea;
};

export enum LocationAreaDensity {
  DenseUrban = 'DENSE_URBAN',
  Rural = 'RURAL',
  Urban = 'URBAN'
}

export type LocationAreaInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter locations */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type LocationAreaRouteInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter locations */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Name of the area */
  name: Scalars['String'];
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
  /** Type of the area */
  type: Scalars['String'];
};

/**  Information about entities associated with a location  */
export type LocationAssociation = {
  __typename?: 'LocationAssociation';
  entityId: Scalars['String'];
  /**  The name of the associated entity  */
  entityName?: Maybe<Scalars['String']>;
  entityType: LocationAssociationEntityType;
  /**  The type of the associated integration  */
  integrationType?: Maybe<IntegrationType>;
  locationId: Scalars['ID'];
  /**  The protocol of the associated integration  */
  protocol?: Maybe<Scalars['String']>;
  /**  Whether or not the associated integration is enabled  */
  systemEnabled?: Maybe<Scalars['Boolean']>;
};

export enum LocationAssociationEntityType {
  Integration = 'INTEGRATION',
  RampMeterSite = 'RAMP_METER_SITE',
  SignalsIntersection = 'SIGNALS_INTERSECTION'
}

export type LocationBoundedRoute = {
  __typename?: 'LocationBoundedRoute';
  /**  The area name  */
  area: Scalars['String'];
  /**  area type  */
  areaType: Scalars['String'];
  /**  The classification of the route  */
  classification: Scalars['String'];
  /**  The direction of the route  */
  direction: Scalars['String'];
  /**  the end landmark  */
  endLandmark?: Maybe<Scalars['String']>;
  /**  The end measure of the segment  */
  endMeasure: Scalars['Float'];
  /**  The name of the route ex: I-70  */
  name: Scalars['String'];
  /**  The native id of the route */
  routeNativeId: Scalars['String'];
  /**  the start landmark  */
  startLandmark?: Maybe<Scalars['String']>;
  /**  The start measure of the segment  */
  startMeasure: Scalars['Float'];
};

export type LocationBoundedRouteConnection = {
  __typename?: 'LocationBoundedRouteConnection';
  edges: Array<LocationBoundedRouteConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LocationBoundedRouteConnectionEdge = {
  __typename?: 'LocationBoundedRouteConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: LocationBoundedRoute;
};

export type LocationComment = {
  __typename?: 'LocationComment';
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  locationId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userDisplayName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type LocationCommentConnection = {
  __typename?: 'LocationCommentConnection';
  edges: Array<LocationCommentConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LocationCommentConnectionEdge = {
  __typename?: 'LocationCommentConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: LocationComment;
};

export type LocationCommentInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter location comments */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type LocationConnection = {
  __typename?: 'LocationConnection';
  edges: Array<LocationConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LocationConnectionEdge = {
  __typename?: 'LocationConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Location;
};

export type LocationCorridor = {
  __typename?: 'LocationCorridor';
  entryLeg: LocationCorridorLeg;
  exitLeg: LocationCorridorLeg;
  id: Scalars['ID'];
  links: Array<LocationCorridorConnectedLink>;
  name: Scalars['String'];
};

export type LocationCorridorConnectedLink = {
  __typename?: 'LocationCorridorConnectedLink';
  downLinkLane: LocationCorridorLinkLane;
  link: LocationCorridorLink;
  linkOrder: Scalars['Int'];
  upLinkLane: LocationCorridorLinkLane;
};

export type LocationCorridorConnectedLinkInput = {
  downLinkLaneId: Scalars['String'];
  linkId: Scalars['String'];
  linkOrder: Scalars['Int'];
  upLinkLaneId: Scalars['String'];
};

export type LocationCorridorConnection = {
  __typename?: 'LocationCorridorConnection';
  edges: Array<LocationCorridorConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LocationCorridorConnectionEdge = {
  __typename?: 'LocationCorridorConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: LocationCorridor;
};

export type LocationCorridorInput = {
  entryLeg: Scalars['String'];
  exitLeg: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  links: Array<LocationCorridorConnectedLinkInput>;
  name: Scalars['String'];
};

export type LocationCorridorLeg = {
  __typename?: 'LocationCorridorLeg';
  approachGeometry?: Maybe<Scalars['Object']>;
  departureGeometry?: Maybe<Scalars['Object']>;
  geometry: Scalars['Object'];
  id: Scalars['ID'];
  lanes: Array<Lane>;
  location: Location;
  name: Scalars['String'];
};

export type LocationCorridorLegConnection = {
  __typename?: 'LocationCorridorLegConnection';
  edges: Array<LocationCorridorLegConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LocationCorridorLegConnectionEdge = {
  __typename?: 'LocationCorridorLegConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: LocationCorridorLeg;
};

export type LocationCorridorLegInput = {
  approachGeometry?: InputMaybe<Scalars['Object']>;
  departureGeometry?: InputMaybe<Scalars['Object']>;
  geometry: Scalars['Object'];
  id?: InputMaybe<Scalars['ID']>;
  lanes: Array<Scalars['String']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
};

export type LocationCorridorLink = {
  __typename?: 'LocationCorridorLink';
  id: Scalars['ID'];
  linkLanes: Array<LocationCorridorLinkLane>;
  name: Scalars['String'];
};

export type LocationCorridorLinkConnection = {
  __typename?: 'LocationCorridorLinkConnection';
  edges: Array<LocationCorridorLinkConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LocationCorridorLinkConnectionEdge = {
  __typename?: 'LocationCorridorLinkConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: LocationCorridorLink;
};

export type LocationCorridorLinkInput = {
  id?: InputMaybe<Scalars['ID']>;
  linkLanes: Array<LocationCorridorLinkLaneInput>;
  name: Scalars['String'];
};

export type LocationCorridorLinkLane = {
  __typename?: 'LocationCorridorLinkLane';
  approachLeg: LocationCorridorLeg;
  congestionColor?: Maybe<Scalars['String']>;
  departureLeg: LocationCorridorLeg;
  detectorGroupId?: Maybe<Scalars['ID']>;
  geometry: Scalars['Object'];
  id: Scalars['String'];
  occupancy?: Maybe<Scalars['Float']>;
  queueClearanceTime?: Maybe<Scalars['Int']>;
  speed: Scalars['Float'];
};

export type LocationCorridorLinkLaneInput = {
  approachLegId: Scalars['String'];
  departureLegId: Scalars['String'];
  detectorGroupId?: InputMaybe<Scalars['ID']>;
  geometry: Scalars['Object'];
  id: Scalars['String'];
  queueClearanceTime?: InputMaybe<Scalars['Int']>;
  speed: Scalars['Float'];
};

export type LocationDetails = {
  __typename?: 'LocationDetails';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type LocationDetailsInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type LocationExternalLink = {
  __typename?: 'LocationExternalLink';
  description: Scalars['String'];
  id: Scalars['ID'];
  locationId: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type LocationExternalLinkInput = {
  description: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  locationId: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

/**  Association of one or more locations and child groups  */
export type LocationGroup = {
  __typename?: 'LocationGroup';
  /**  Color to visually identify different groups  */
  color?: Maybe<Scalars['String']>;
  /**  External center, if C2C is enabled  */
  externalCenterId?: Maybe<Scalars['String']>;
  /**  Child groups  */
  groups: Array<LocationGroup>;
  id: Scalars['ID'];
  /**  Human-readable name for the group  */
  name: Scalars['String'];
  /**  Order within the parent group  */
  order?: Maybe<Scalars['Float']>;
  /**  Parent group, if applicable  */
  parentId?: Maybe<Scalars['String']>;
  /**  Groups that are loaded from an external center may be flagged as read-only  */
  readOnly: Scalars['Boolean'];
};

export type LocationGroupInput = {
  /**  Color to visually identify different groups  */
  color?: InputMaybe<Scalars['String']>;
  /**  Group ID, if modifying an existing group  */
  id?: InputMaybe<Scalars['ID']>;
  /**
   * Locations to associate with the group. If a location was previously
   * associated with the group and omitted from this list, it will become unparented.
   */
  locationIds: Array<Scalars['String']>;
  /**  Human-readable name for the group  */
  name: Scalars['String'];
  /**  Order within the parent group, if applicable  */
  order?: InputMaybe<Scalars['Float']>;
  /**  Parent group, if applicable  */
  parentId?: InputMaybe<Scalars['String']>;
};

export enum LocationImportFileType {
  Csv = 'CSV',
  Kml = 'KML'
}

export type LocationInput = {
  color?: InputMaybe<Scalars['String']>;
  crosswalks: Array<CrosswalkInput>;
  details: LocationDetailsInput;
  geometry: Scalars['Object'];
  groupId?: InputMaybe<Scalars['String']>;
  /**  Identifier of the location  */
  id?: InputMaybe<Scalars['ID']>;
  lanes: Array<LaneInput>;
  locationType: Scalars['String'];
  maneuvers: Array<ManeuverInput>;
  opacity?: InputMaybe<Scalars['Float']>;
  order?: InputMaybe<Scalars['Float']>;
};

export type LocationInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Filter locations based on associations */
  associatedEntityFilters?: InputMaybe<Array<AssociatedEntityFilterInput>>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter signs */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type LocationLinkAssociation = {
  __typename?: 'LocationLinkAssociation';
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  module: KineticModule;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export enum LocationMapIcon {
  Ball = 'BALL',
  Bike = 'BIKE',
  Custom = 'CUSTOM',
  Hand = 'HAND',
  Leftarrow = 'LEFTARROW',
  Lrtgo = 'LRTGO',
  Lrtstop = 'LRTSTOP',
  Rightarrow = 'RIGHTARROW',
  Slightleftarrow = 'SLIGHTLEFTARROW',
  Slightrightarrow = 'SLIGHTRIGHTARROW',
  Stopbar = 'STOPBAR',
  Straightarrow = 'STRAIGHTARROW',
  Triangle = 'TRIANGLE',
  Uturn = 'UTURN',
  Walk = 'WALK'
}

export type LocationRoadwayPoint = {
  __typename?: 'LocationRoadwayPoint';
  /**  the set of contained areas  */
  areas: Scalars['Object'];
  /**  the route classification  */
  classification: Scalars['String'];
  /**  the area density  */
  density?: Maybe<Scalars['String']>;
  /**  the route direction  */
  direction: Scalars['String'];
  /**  the snapped point on the route  */
  geometry: Scalars['Object'];
  /**  the closest landmark  */
  landmark?: Maybe<Scalars['String']>;
  /**  the patrol route  */
  patrolRoute?: Maybe<Scalars['String']>;
  /**  the route measure  */
  referencePoint: Scalars['Float'];
  /**  the route name  */
  road: Scalars['String'];
};

export type LocationRoute = {
  __typename?: 'LocationRoute';
  /**  The intersecting areas  */
  areas: Scalars['Object'];
  /**  The classification of the route  */
  classification: Scalars['String'];
  /**  The direction of the route  */
  direction: Scalars['String'];
  /**  The geometry of the route  */
  geometry: Scalars['Object'];
  /**  The identifier of the route  */
  id: Scalars['ID'];
  /**  custom label for the route, if present  */
  label?: Maybe<Scalars['String']>;
  /**  The name of the route ex: I-70  */
  name: Scalars['String'];
  /**  The native id of the route */
  nativeId: Scalars['String'];
};

export type LocationRouteConnection = {
  __typename?: 'LocationRouteConnection';
  edges: Array<LocationRouteConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LocationRouteConnectionEdge = {
  __typename?: 'LocationRouteConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: LocationRoute;
};

export type LocationRouteInput = {
  /**  The classification of the route  */
  classification: Scalars['String'];
  /**  The direction of the route  */
  direction: Scalars['String'];
  /**  The from measure of the route  */
  fromMeasure?: InputMaybe<Scalars['Float']>;
  /**  The geometry of the route  */
  geometry: Scalars['Object'];
  /**  The identifier of the route  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The name of the route ex: I-70  */
  name: Scalars['String'];
  /**  The native id of the route */
  nativeId?: InputMaybe<Scalars['String']>;
  /**  The to measure of the route  */
  toMeasure?: InputMaybe<Scalars['Float']>;
};

export type LocationRouteInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter locations */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type LocationRouteLandmark = {
  __typename?: 'LocationRouteLandmark';
  /**  The coordinate of the reference post  */
  geometry: Scalars['Object'];
  /**  The measure of the reference post  */
  measure: Scalars['Float'];
  /**  The name of the landmark  */
  name: Scalars['String'];
  /**  The native id of the route for the reference post */
  routeNativeId: Scalars['String'];
};

export type LocationRouteLandmarkConnection = {
  __typename?: 'LocationRouteLandmarkConnection';
  edges: Array<LocationRouteLandmarkConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LocationRouteLandmarkConnectionEdge = {
  __typename?: 'LocationRouteLandmarkConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: LocationRouteLandmark;
};

export type LocationRouteLandmarkInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter locations */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type LocationRouteMeasure = {
  __typename?: 'LocationRouteMeasure';
  /**  The coordinate of the reference post  */
  geometry: Scalars['Object'];
  /**  The measure of the reference post  */
  measure: Scalars['Float'];
  /**  The native id of the route for the reference post */
  routeNativeId: Scalars['String'];
};

export type LocationRouteRange = {
  __typename?: 'LocationRouteRange';
  /**  end reference  */
  endReference: Scalars['Float'];
  /**  start reference */
  startReference: Scalars['Float'];
};

export type LocationTemplate = {
  __typename?: 'LocationTemplate';
  /**  The description of the template  */
  description?: Maybe<Scalars['String']>;
  /**  The identifier of the template  */
  id: Scalars['ID'];
  /**  The name of the template  */
  name: Scalars['String'];
  /**  The location to serve as the template  */
  template: Location;
};

export type LocationTemplateConnection = {
  __typename?: 'LocationTemplateConnection';
  /**  connection edges  */
  edges: Array<LocationTemplateConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type LocationTemplateConnectionEdge = {
  __typename?: 'LocationTemplateConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: LocationTemplate;
};

export type LocationTemplateInput = {
  /**  The description of the template  */
  description?: InputMaybe<Scalars['String']>;
  /**  The identifier of the template  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The name of the template  */
  name: Scalars['String'];
  /**  The location to serve as the template  */
  template: LocationInput;
};

export type LocationTemplateInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter locations */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ManagedFile = {
  __typename?: 'ManagedFile';
  contentType: Scalars['String'];
  directoryId: Scalars['String'];
  fileName: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  timestamp?: Maybe<Scalars['DateTime']>;
  width?: Maybe<Scalars['Int']>;
};

export type ManagedFileConnection = {
  __typename?: 'ManagedFileConnection';
  edges: Array<ManagedFileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ManagedFileEdge = {
  __typename?: 'ManagedFileEdge';
  cursor: Scalars['String'];
  node: ManagedFile;
};

export type ManagedFileInput = {
  directoryId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ManagedFiles = {
  __typename?: 'ManagedFiles';
  managedFiles?: Maybe<Array<Maybe<ManagedFile>>>;
};

export type Maneuver = {
  __typename?: 'Maneuver';
  id: Scalars['ID'];
  refApproachLane: Scalars['String'];
  refDepartureLane: Scalars['String'];
};

export type ManeuverColor = {
  __typename?: 'ManeuverColor';
  color?: Maybe<SignalOutputColor>;
  id: Scalars['String'];
};

export type ManeuverInput = {
  id: Scalars['ID'];
  refApproachLane: Scalars['String'];
  refDepartureLane: Scalars['String'];
};

export type MapConfig = {
  __typename?: 'MapConfig';
  geometry: Scalars['Object'];
  id: Scalars['ID'];
  layers: Array<Scalars['String']>;
  name: Scalars['String'];
  zoom?: Maybe<Scalars['Float']>;
};

export type MapConfigInput = {
  geometry: Scalars['Object'];
  id?: InputMaybe<Scalars['ID']>;
  layers: Array<Scalars['String']>;
  name: Scalars['String'];
  zoom?: InputMaybe<Scalars['Float']>;
};

export type MapLayerConfig = {
  __typename?: 'MapLayerConfig';
  baseLayer: Scalars['Boolean'];
  data: Scalars['Object'];
  group?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: MapLayerType;
  visible: Scalars['Boolean'];
};

export type MapLayerConfigInput = {
  baseLayer: Scalars['Boolean'];
  data: Scalars['Object'];
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  type: MapLayerType;
  visible: Scalars['Boolean'];
};

export enum MapLayerType {
  Geojson = 'GEOJSON',
  Google = 'GOOGLE',
  Quadkey = 'QUADKEY',
  Vector = 'VECTOR',
  Wms = 'WMS',
  Xyz = 'XYZ'
}

export type MibAlarmConfig = {
  __typename?: 'MibAlarmConfig';
  bitIndex?: Maybe<Scalars['Int']>;
  comparison?: Maybe<MibValueComparison>;
  /**  Editable alarm name. Defaults to MIB Alarm N */
  displayName: Scalars['String'];
  id: Scalars['ID'];
  index1?: Maybe<Scalars['Int']>;
  index2?: Maybe<Scalars['Int']>;
  /**  Short name, e.g. MxCntdwn  */
  mibName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value1?: Maybe<Scalars['Object']>;
  /**  Required if comparison is BETWEEN or NOT_BETWEEN  */
  value2?: Maybe<Scalars['Object']>;
};

export type MibAlarmConfigInput = {
  bitIndex?: InputMaybe<Scalars['Int']>;
  comparison?: InputMaybe<MibValueComparison>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  index1?: InputMaybe<Scalars['Int']>;
  index2?: InputMaybe<Scalars['Int']>;
  mibName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  value1?: InputMaybe<Scalars['Object']>;
  value2?: InputMaybe<Scalars['Object']>;
};

export type MibDefinition = {
  __typename?: 'MibDefinition';
  blockDataId: Scalars['Int'];
  blockDataType: Scalars['Int'];
  blockSupported: Scalars['Boolean'];
  dataType: DataTypes;
  hexadecimal: Scalars['Boolean'];
  indexes?: Maybe<Array<Maybe<Scalars['Int']>>>;
  name: Scalars['String'];
  numberOfBits: Scalars['Int'];
  oerType: OerType;
  oid: Scalars['String'];
  shortName?: Maybe<Scalars['String']>;
  type: MibType;
};

export type MibIcon = {
  __typename?: 'MibIcon';
  iconId: Scalars['String'];
  mib?: Maybe<MibIndexed>;
  value?: Maybe<Scalars['String']>;
};

export type MibIndexed = {
  __typename?: 'MibIndexed';
  bitIndex?: Maybe<Scalars['Int']>;
  indexes?: Maybe<Array<Scalars['Int']>>;
  name: Scalars['String'];
  shortName?: Maybe<Scalars['String']>;
};

export enum MibType {
  BitField = 'BIT_FIELD',
  Integer = 'INTEGER',
  String = 'STRING',
  TableEntry = 'TABLE_ENTRY',
  Unknown = 'UNKNOWN'
}

export type MibValue = {
  bitIndex?: InputMaybe<Scalars['Int']>;
  indexes?: InputMaybe<Array<Scalars['Int']>>;
  name: Scalars['String'];
  shortName?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Object']>;
};

export enum MibValueComparison {
  Between = 'BETWEEN',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEquals = 'GREATER_THAN_EQUALS',
  Includes = 'INCLUDES',
  LessThan = 'LESS_THAN',
  LessThanEquals = 'LESS_THAN_EQUALS',
  NotBetween = 'NOT_BETWEEN',
  NotEquals = 'NOT_EQUALS',
  NotIncludes = 'NOT_INCLUDES'
}

export type MibWithIndexes = {
  indexes: Array<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  oid?: InputMaybe<Scalars['String']>;
};

export type ModuleFormSection = FormSection & {
  __typename?: 'ModuleFormSection';
  fields: Array<Maybe<FieldConfig>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ModuleSettingsFormView = FormView & {
  __typename?: 'ModuleSettingsFormView';
  id: Scalars['ID'];
  name: Scalars['String'];
  sections: Array<ModuleFormSection>;
  type: FormViewType;
  views: Array<FormView>;
};

export type MongoArchiveJob = {
  __typename?: 'MongoArchiveJob';
  config?: Maybe<ArchiveRuleConfig>;
  errorReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastArchivedAt?: Maybe<Scalars['DateTime']>;
  lastStartTimestamp?: Maybe<Scalars['DateTime']>;
  status?: Maybe<MongoArchiveJobStatusCode>;
};

export enum MongoArchiveJobStatusCode {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type MoveLocationGroupInput = {
  /**  The group to move  */
  id: Scalars['ID'];
  /**  Order within the parent  */
  order?: InputMaybe<Scalars['Float']>;
  /**  The new parent group. If null or omitted, will unparent the group.  */
  parentId?: InputMaybe<Scalars['ID']>;
};

export type MoveLocationInput = {
  /**  The new group. If null or omitted, will ungroup the location.  */
  groupId?: InputMaybe<Scalars['ID']>;
  /**  The location to move  */
  id: Scalars['ID'];
  /**  Order within the group  */
  order?: InputMaybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** send work order request to system */
  _addEntityWorkOrders: JobRequest;
  /**  move the avl device along the coordinates  */
  _avlCheckIn: JobRequest;
  /**  stop avl tracking  */
  _avlCheckOut: JobRequest;
  /**  move the avl device to the specified location  */
  _avlDispatch: JobRequest;
  /**  resume the avl device move after a dispatch  */
  _avlResume: JobRequest;
  /**  Device Database Upload */
  _backupDeviceDatabase: JobRequest;
  /**  Get the camera auxiliary capabilities */
  _cameraCapabilities?: Maybe<JobRequest>;
  /**  Device Firmware Change */
  _changeDeviceFirmware: JobRequest;
  /**  Trigger ramp meter status count refresh  */
  _confirmRampMeterStatusCategoryCount: Scalars['Boolean'];
  /**  Trigger signal status count refresh  */
  _confirmStatusCategoryCount: Scalars['Boolean'];
  /**  Device Database Download */
  _downloadDeviceDatabase: JobRequest;
  /**  Flush integrations */
  _flushIntegrations?: Maybe<Scalars['Boolean']>;
  /** abort operation */
  _gateControllerAbort: JobRequest;
  /**  close gates  */
  _gateControllerClose: JobRequest;
  /**  open inbound gates  */
  _gateControllerOpenInbound: JobRequest;
  /**  open outbound gates  */
  _gateControllerOpenOutbound: JobRequest;
  /**  gets geo tab camera details for the fleet */
  _geoTabCameraDetails: JobRequest;
  /**  Get the signal mibs for a device. */
  _getSignalMibs: JobRequest;
  /**  attenuator level transmitter  */
  _harTransmitterAttenuatorLevel: JobRequest;
  /**  blank transmitter  */
  _harTransmitterBlank: JobRequest;
  /**  poll transmitter  */
  _harTransmitterPoll: JobRequest;
  /**  post transmitter  */
  _harTransmitterPost: JobRequest;
  /**  power level transmitter  */
  _harTransmitterPowerLevel: JobRequest;
  /**  voice speed transmitter  */
  _harTransmitterVoiceSpeed: JobRequest;
  /**  weather radio transmitter  */
  _harTransmitterWeatherRadio: JobRequest;
  /** lists work orders from system */
  _listEntityWorkOrders: JobRequest;
  /** Lists video wall layouts */
  _listVideoWallLayouts: JobRequest;
  /**  confirm rates for pricing sign  */
  _pricingConfirmRates: JobRequest;
  /**  poll historical data for pricing  */
  _pricingHistoricalPoll: JobRequest;
  /**  poll current data for pricing  */
  _pricingPoll: Array<JobRequest>;
  /**  update detector data for pricing integration  */
  _pricingSetDetectorData: JobRequest;
  /**  update toll point data for pricing integration  */
  _pricingSetTollPointData: JobRequest;
  _regenerateEffectivePrivileges: Scalars['Boolean'];
  /**  Stop the currently running poll for an integration and immediately restart it */
  _restartPoll: Scalars['Boolean'];
  /**  direction reverse for alert  */
  _reverseAlertDirection: JobRequest;
  /**  direction reverse for detector  */
  _reverseDetector: JobRequest;
  /**  Create a generic job */
  _runOneTimeJob: JobRequest;
  _sdl: Scalars['String'];
  /**  Set Signal Mibs */
  _setSignalMibs: JobRequest;
  /** Set Time Now */
  _setTimeNow: JobRequest;
  /** Sets video wall area camera */
  _setVideoWallAreaCamera: JobRequest;
  /** Sets video wall screen layout */
  _setVideoWallLayout: JobRequest;
  /**  Blank the display on the requested sign  */
  _signBlank: JobRequest;
  /**  Set the brightness level on a sign  */
  _signBrightness: JobRequest;
  /**  Check for sign capabilities  */
  _signCapabilities: JobRequest;
  /**  Delete graphic Definition  */
  _signDeleteGraphic: JobRequest;
  /**  Delete Sign Message Definition  */
  _signDeleteMessage: JobRequest;
  /**  Display the requested messages on the sign  */
  _signDisplay: JobRequest;
  /**  Create a download all graphics job  */
  _signDownloadAllGraphics: JobRequest;
  /**  Create a download all messages job  */
  _signDownloadAllMessages: JobRequest;
  /**  Download Graphic Definition  */
  _signDownloadGraphic: JobRequest;
  /**  Download Message Definition  */
  _signDownloadMessage: JobRequest;
  /**  Extend the currently displayed message  */
  _signExtend: JobRequest;
  /**  Run Fan Test  */
  _signFanTest: JobRequest;
  /**  Download the fonts installed on the controller  */
  _signFonts: JobRequest;
  /**  Run Lamp Test  */
  _signLampTest: JobRequest;
  /**  Run Pixel Test  */
  _signPixelTest: JobRequest;
  /**  Poll the requested sign  */
  _signPoll: JobRequest;
  /**  Reset a sign  */
  _signReset: JobRequest;
  /**  Set the sign color  */
  _signSetColor?: Maybe<JobRequest>;
  /**  Upload Graphic Definition  */
  _signUploadGraphic: JobRequest;
  /**  Upload Message Definition  */
  _signUploadMessage: JobRequest;
  /**  Upload multiple graphics to a sign  */
  _signUploadMultipleGraphics: JobRequest;
  /**  Upload multiple messages to a sign  */
  _signUploadMultipleMessages: JobRequest;
  /**  Get the signal UI table for a device. */
  _signalGetUiTable: JobRequest;
  /**  Get the signal UI view for a device. */
  _signalGetUiView: JobRequest;
  /**  activate a tolling point  */
  _tollingPointActivate: JobRequest;
  /**  poll a traffic control  */
  _trafficControlPoll: JobRequest;
  /**  set a traffic control mode  */
  _trafficControlSetMode: JobRequest;
  _useCameraCapability?: Maybe<JobRequest>;
  /**  Validate Device Database */
  _validateDeviceDatabase: JobRequest;
  /**  Abort the current operation  */
  abortControllerOperation: Scalars['Boolean'];
  /**  Accept a device database validation */
  acceptDeviceDatabaseValidation: Scalars['Boolean'];
  /**  Acknowledge one or more active alarms  */
  acknowledgeAlarms: Array<Alarm>;
  acknowledgeNotification?: Maybe<Notification>;
  /**  Acknowledge resources  */
  acknowledgeResources: ResourcePlan;
  /**  activate the set of sign messages for the controller and type  */
  activateGateSignMessages: Array<JobRequest>;
  /**  activate toll points for the given operation  */
  activateGateTollPoints: Array<Scalars['Boolean']>;
  /**  Activate resources, data is optional and it should be a map of resource id to data  */
  activateResources: Array<JobRequest>;
  /**  activate a toll point  */
  activateTollPoint: JobRequest;
  /**  activate a set of toll points by direction  */
  activateTollPoints: Array<JobRequest>;
  /**  Add an activity log. */
  addActivityLog: ActivityLog;
  /**  Add a comment to an intersection */
  addIntersectionComment: IntersectionComment;
  /**  add network conditions to an event  */
  addNetworkConditions: Array<NetworkCondition>;
  /**  Admin unlock a saved database - unlocks a database lock made by another user  */
  adminUnlockDatabase: Scalars['Boolean'];
  /**  Admin unlock a live database - unlocks a database lock made by another user  */
  adminUnlockLiveDatabase: Scalars['Boolean'];
  /**  Promote a device database to approved. */
  approveDatabase: DeviceDatabase;
  /**  approve the given gate operation  */
  approveGateOperation: Scalars['Boolean'];
  /**  approve the sign interlock override requests  */
  approveInterlockOverride: Scalars['Boolean'];
  /**  Associated comm logs with an event */
  associateCommLogsToEvent?: Maybe<Scalars['Boolean']>;
  /**  Associated comm logs with an events */
  associateCommLogsToEvents?: Maybe<Scalars['Boolean']>;
  /**  Associated detection with events */
  associateDetectionToEvents?: Maybe<Scalars['Boolean']>;
  /**  Associated detections with an event */
  associateDetectionsToEvent?: Maybe<Scalars['Boolean']>;
  associateEventsToCommLogs?: Maybe<Scalars['Boolean']>;
  /**  Associate event ids to corridor  */
  associateEventsToCorridor?: Maybe<Scalars['Boolean']>;
  /**  Associate event to detections */
  associateEventsToDetections?: Maybe<Scalars['Boolean']>;
  /**  Creates a database backup (upload) from the current active controller database */
  backupDeviceDatabase: DeviceDatabase;
  /**  Create or update a block for a camera or stream  */
  blockVideoStream: Array<VideoStreamBlock>;
  /**  Set the auto focus */
  cameraAutoFocus?: Maybe<JobRequest>;
  /**  Set the auto iris */
  cameraAutoIris?: Maybe<JobRequest>;
  cameraExplicitLock?: Maybe<Scalars['Boolean']>;
  /**  Fetch camera recordings */
  cameraFetchRecordings?: Maybe<JobRequest>;
  /**  camera focus command */
  cameraFocus?: Maybe<JobRequest>;
  /**  camera go to preset */
  cameraGoToPreset?: Maybe<JobRequest>;
  /**  camera iris command */
  cameraIris?: Maybe<JobRequest>;
  /**  get the max presets of a camera */
  cameraMaxPresets?: Maybe<JobRequest>;
  cameraOnDemandLock?: Maybe<Scalars['Boolean']>;
  /**  camera pan tilt */
  cameraPanTilt?: Maybe<JobRequest>;
  /**  Poll the camera */
  cameraPoll?: Maybe<JobRequest>;
  cameraPublicFeed?: Maybe<JobRequest>;
  cameraPublicStreamTarget?: Maybe<JobRequest>;
  cameraRecording?: Maybe<JobRequest>;
  /**  Get the recent camera snapshot. */
  cameraSnapshot: JobRequest;
  /**  Start or stop saving camera snapshots */
  cameraSnapshots?: Maybe<JobRequest>;
  /**  Start camera stream recording */
  cameraStreamRecording?: Maybe<JobRequest>;
  /**  camera zoom */
  cameraZoom?: Maybe<JobRequest>;
  /**  Cancel a database backup or download action  */
  cancelDeviceDatabaseAction: Scalars['Boolean'];
  /**  cancel the given gate operation  */
  cancelGateOperation: Scalars['Boolean'];
  /**  cancel the sign interlock override requests  */
  cancelInterlockOverride: Scalars['Boolean'];
  /**  Cancel a running job */
  cancelJob: Scalars['Boolean'];
  /**  Cancel task occurrence  */
  cancelTaskOccurrence: Scalars['Boolean'];
  changeTourState: Scalars['Boolean'];
  /**  Remove acknowledgement state from active alarms  */
  clearAlarmAcknowledgement: Array<Alarm>;
  /**  Clear one or more active alarms  */
  clearAlarms: Array<Alarm>;
  /**  Clear all active alarms for a specific source module  */
  clearAllAlarms: Scalars['Boolean'];
  /**  Clear all active alarms associated with a specific entity (e.g. intersection)  */
  clearAllAlarmsForEntity: Scalars['Boolean'];
  /**  Clears all detector alarms */
  clearAllDetectorAlarms?: Maybe<Scalars['Boolean']>;
  /**  Clears detector alarms for given id's */
  clearDetectorAlarms?: Maybe<Array<DetectorAlarm>>;
  /**  clear network conditions  */
  clearNetworkConditions: Array<NetworkCondition>;
  /**  Clone an event  */
  cloneEvent: Event;
  /**  Clone an work order configuration  */
  cloneWorkOrderConfiguration: WorkOrderConfiguration;
  /** Closes work order */
  closeAssetWorkOrder?: Maybe<Scalars['Boolean']>;
  /**  Close an event  */
  closeEvent?: Maybe<Scalars['Boolean']>;
  /**  close gates  */
  closeGates: Scalars['Boolean'];
  /**  confirm network conditions  */
  confirmNetworkConditions: Array<NetworkCondition>;
  /**  Confirm video stream is blocked  */
  confirmVideoStreamBlocked: Scalars['Boolean'];
  /**  Poll the connected vehicles */
  connectedVehiclesPoll: Array<JobRequest>;
  /**
   * Copy a device database from one device to another as a draft.
   * Returns the new database copy associated with toIntersectionId.
   */
  copyDeviceDatabaseDraft: DeviceDatabase;
  /**  Copy a file to a new directory */
  copyFile: Scalars['Boolean'];
  /**  Delete a Corridor by id  */
  corridorDelete?: Maybe<Scalars['Boolean']>;
  /**  Load corridor devices by boundary  */
  corridorLoadDevices: Corridor;
  /**  Save a Corridor  */
  corridorSave: Corridor;
  /**  confirm response if confirmation required  */
  corridorUpdateConfirmation?: Maybe<Scalars['Boolean']>;
  /**  Create a draft database from a present database */
  createDraftDatabase: DeviceDatabase;
  /**  Create event from corridor/tunnel  */
  createEventFromCorridor: Event;
  /**  Create an event from a detection  */
  createEventFromDetection: Event;
  createKeycloakClient: KeycloakClient;
  /**  creates or retrieves the user Directories path */
  createOrGetUserDirectoryPath: Directory;
  /**  Generate report export and upload to file system  */
  createReportExport: Array<File>;
  createUser: OrganizationKineticUser;
  /** Declines work order step */
  declineAssetWorkOrderStep?: Maybe<Scalars['Boolean']>;
  /**  delete action set rule  */
  deleteActionSetResponseRule: Scalars['Boolean'];
  /**  Delete an alarm config  */
  deleteAlarmConfig: Scalars['Boolean'];
  /**  Delete all connected vehicle comments for a given connected vehicle  */
  deleteAllConnectedVehicleComments: Scalars['Boolean'];
  /** Delete all intersection comments */
  deleteAllIntersectionComments: Scalars['Boolean'];
  /** Delete all location comments */
  deleteAllLocationComments: Scalars['Boolean'];
  /** deletes work order comment */
  deleteAssetWorkOrderComment?: Maybe<Scalars['Boolean']>;
  /**  delete asset work order flag  */
  deleteAssetWorkOrderFlag: Scalars['Boolean'];
  /**  delete asset work order link  */
  deleteAssetWorkOrderLink: Scalars['Boolean'];
  /** deletes asset work order time tracking */
  deleteAssetWorkOrderTracking?: Maybe<Scalars['Boolean']>;
  /** deletes work order transaction */
  deleteAssetWorkOrderTransaction?: Maybe<Scalars['Boolean']>;
  deleteCameraGroups: Scalars['Boolean'];
  /**  Delete connected vehicle comment by id  */
  deleteConnectedVehicleComment: Scalars['Boolean'];
  deleteContact?: Maybe<Contact>;
  deleteContactGroup?: Maybe<ContactGroup>;
  /**  Delete a response rule  */
  deleteCorridorRule?: Maybe<Scalars['Boolean']>;
  /**  delete data source form, will also delete associated data sources  */
  deleteDataSourceConfigs?: Maybe<Scalars['Boolean']>;
  /**  delete data sources  */
  deleteDataSources?: Maybe<Scalars['Boolean']>;
  /**  Delete a database export template  */
  deleteDatabaseExportTemplate: Scalars['Boolean'];
  /**  delete detector  email  alert setting */
  deleteDetectorEmailAlertSetting?: Maybe<Scalars['Boolean']>;
  /**  delete detector group  */
  deleteDetectorGroup: Scalars['Boolean'];
  deleteDetectorReportConfiguration?: Maybe<Scalars['Boolean']>;
  /**  deletes detector Report Rules */
  deleteDetectorReportRule?: Maybe<Scalars['Boolean']>;
  /**  Delete a draft or system database.  */
  deleteDeviceDatabase: DeviceDatabase;
  deleteEmailRule?: Maybe<Scalars['Boolean']>;
  deleteEmailRulesList?: Maybe<Scalars['Boolean']>;
  deleteEmailTemplate?: Maybe<Scalars['Boolean']>;
  deleteEmailTemplateList?: Maybe<Scalars['Boolean']>;
  /**  Delete an event template  */
  deleteEventTemplate?: Maybe<Scalars['Boolean']>;
  /**  Delete an event type  */
  deleteEventType?: Maybe<Scalars['Boolean']>;
  deleteFile: Scalars['Boolean'];
  deleteFiles: Scalars['Boolean'];
  /**  delete a gate controller sign message  */
  deleteGateControllerSignMessage: Scalars['Boolean'];
  /**  delete a gate control system  */
  deleteGateControllerSystem: Scalars['Boolean'];
  deleteGlobalFile: Scalars['Boolean'];
  deleteGlobalFiles: Scalars['Boolean'];
  /**  Delete an integration by id.  */
  deleteIntegration?: Maybe<Scalars['Boolean']>;
  /**  Delete integration group */
  deleteIntegrationGroup?: Maybe<Scalars['Boolean']>;
  /**  Delete an intersection by id.  */
  deleteIntersection: Scalars['Boolean'];
  /** Delete all intersection comment by id */
  deleteIntersectionComment: Scalars['Boolean'];
  /**  Delete an intersection template  */
  deleteIntersectionTemplate?: Maybe<Scalars['Boolean']>;
  /**  Delete a scheduled job */
  deleteJob: Scalars['Boolean'];
  /**  Delete the form fields by unique identifier  */
  deleteKineticFormFields?: Maybe<Scalars['Boolean']>;
  /**  Delete the forms by unique identifier  */
  deleteKineticForms?: Maybe<Scalars['Boolean']>;
  deleteKineticUserPreference: Scalars['Boolean'];
  /**  Delete lane control settings  */
  deleteLaneControlSettings: Scalars['Boolean'];
  /**  Delete a location  */
  deleteLocation: Scalars['Boolean'];
  /** Delete all location comment by id */
  deleteLocationComment: Scalars['Boolean'];
  /**  Delete a corridor  */
  deleteLocationCorridor: Scalars['Boolean'];
  /**  Delete a corridor leg  */
  deleteLocationCorridorLeg: Scalars['Boolean'];
  /**  Delete a corridor link  */
  deleteLocationCorridorLink: Scalars['Boolean'];
  /**  Delete a location group  */
  deleteLocationGroup: Scalars['Boolean'];
  /**  Delete location link  */
  deleteLocationLink: Scalars['Boolean'];
  /**  Delete an location template  */
  deleteLocationTemplate?: Maybe<Scalars['Boolean']>;
  /**  Delete Managed Files */
  deleteManagedFiles: Scalars['Boolean'];
  /**  Delete a map config */
  deleteMapConfig?: Maybe<Scalars['Boolean']>;
  /**  Delete a map layer config */
  deleteMapLayerConfig?: Maybe<Scalars['Boolean']>;
  /**  Delete an alarm config  */
  deleteMibAlarmConfig: Scalars['Boolean'];
  /**  Delete mib alarm configs  */
  deleteMibAlarmConfigs: Scalars['Boolean'];
  /**  delete network conditions  */
  deleteNetworkConditions?: Maybe<Scalars['Boolean']>;
  deleteNetworkJurisdictions?: Maybe<Scalars['Boolean']>;
  deleteOrganizationContact?: Maybe<Scalars['Boolean']>;
  deleteOrganizationContactList?: Maybe<Scalars['Boolean']>;
  deleteOrganizationPreference: Scalars['Boolean'];
  deletePresets: Scalars['Boolean'];
  deleteRecordings: Scalars['Boolean'];
  /**  Delete a resource plan  */
  deleteResourcePlan: Scalars['Boolean'];
  /**  Delete resource plan task  */
  deleteResourcePlanTask: Scalars['Boolean'];
  /**  Remove resource from plan  */
  deleteResources: ResourcePlan;
  /**  Delete a response rule  */
  deleteResponseRule?: Maybe<Scalars['Boolean']>;
  deleteRole: Scalars['Boolean'];
  /**  Delete the route with the provided identifier  */
  deleteRoute?: Maybe<Scalars['Boolean']>;
  deleteScenes: Scalars['Boolean'];
  /**  Delete Scheduled Event task  */
  deleteScheduledEventTask: Scalars['Boolean'];
  deleteScreens: Scalars['Boolean'];
  /**  Delete sign cutout  */
  deleteSignCutout: Scalars['Boolean'];
  /**  Delete sign gantry  */
  deleteSignGantry: Scalars['Boolean'];
  /**  Delete sign message priorities  */
  deleteSignMessagePriorities: Scalars['Boolean'];
  /**  Delete sign messages */
  deleteSignMessages: Scalars['Boolean'];
  /**  Delete a response rule  */
  deleteSignResponseRule?: Maybe<Scalars['Boolean']>;
  /**  Delete an Action Set  */
  deleteSignalActionSet: Scalars['Boolean'];
  /**  Delete a detector group  */
  deleteSignalDetectorGroup: Scalars['Boolean'];
  /**  Delete a signal scheduled task  */
  deleteSignalScheduledTask: Scalars['Boolean'];
  /**  delete a comment  */
  deleteTollingSegmentComment: Scalars['Boolean'];
  deleteTours: Scalars['Boolean'];
  /**  Delete a traffic responsive plan  */
  deleteTrafficResponsivePlan: Scalars['Boolean'];
  /**  Delete an tunnel log by id  */
  deleteTunnelLog?: Maybe<Scalars['Boolean']>;
  deleteUserGroup: Scalars['Boolean'];
  deleteUserPreference: Scalars['Boolean'];
  deleteVideoTask: Scalars['Boolean'];
  deleteWidgets: Scalars['Boolean'];
  /**  delete work order configuration  */
  deleteWorkOrderConfiguration: Scalars['Boolean'];
  /**  Returns true if config exists for timestamp */
  detectorConfigExists?: Maybe<Scalars['Boolean']>;
  /**  Export Volume, Occupancy, Speed data for a detector group  */
  detectorGroupExport: Scalars['Boolean'];
  deviceEventExport: Scalars['Boolean'];
  dismissNotification: Scalars['Boolean'];
  dismissNotifications: Scalars['Boolean'];
  /**  display a series of travel time messages  */
  displayTravelTimeMessages: Array<JobRequest>;
  /**  Send a database to a controller and activate it. */
  downloadDeviceDatabase: DeviceDatabase;
  enableCameraAutoFocus?: Maybe<JobRequest>;
  enableCameraAutoIris?: Maybe<JobRequest>;
  /** Enable or disable list of integrations */
  enableIntegrations?: Maybe<Array<Maybe<Integration>>>;
  /** executes work order transaction */
  executeAssetWorkOrderTransaction: AssetTransaction;
  executeDetectorEmailAlertSettings: Scalars['Boolean'];
  /**  Expire resources  */
  expireResources: Array<JobRequest>;
  /**
   * Starts a background asynchronous export of activity
   * logs into the user's managed files.
   */
  exportActivityLogs: Scalars['Boolean'];
  /** Exports activity logs and sends the CSV file via email to specified recipients. */
  exportActivityLogsAndSendEmail: Scalars['Boolean'];
  /**  Export alarm configurations  */
  exportAlarmConfigs: Scalars['Boolean'];
  /**  Export alarms matching the given query to the file manager  */
  exportAlarms: Scalars['Boolean'];
  /**  Export alarms matching the given query and send via email  */
  exportAlarmsAndSendEmail: Scalars['Boolean'];
  /**  Exports asset template for import */
  exportAssetTemplate: Scalars['String'];
  /**  Exports list of asset work orders.  */
  exportAssetWorkOrders: Scalars['Boolean'];
  /**  Exports list of assets.  */
  exportAssets: Scalars['Boolean'];
  /**  Export a report containing the current historical rates */
  exportCurrentHistoricalRates: Scalars['Boolean'];
  /**  Export PVR matching the given query to the file manager  */
  exportDayWisePVRDetails: Scalars['Boolean'];
  /** Export Intersection report for a site  */
  exportDetectorIntersectionReport: Scalars['Boolean'];
  exportDirectoryToZip: Scalars['Boolean'];
  exportFileToManagedDirectory: Scalars['Boolean'];
  exportJsReport: Scalars['Boolean'];
  /**  Exports a location tree  */
  exportLocationTree: Scalars['Boolean'];
  /**  Export Latest Bin Files  */
  exportMultipleDatabaseBins: Scalars['Boolean'];
  exportMultipleFilesToZip: Scalars['Boolean'];
  /**  Export Bin File  */
  exportSingleDatabaseBin: Scalars['Boolean'];
  /** Export turning report for a site  */
  exportTurningReport: Scalars['Boolean'];
  /**  Extract a managed zip file into a destination path.  */
  extractZip: ExtractZipResults;
  /**  Finalizes a draft database and promotes it to all system databases. */
  finalizeDraftDeviceDatabase: DeviceDatabase;
  /**  Finish resource plan task  */
  finishResourcePlanTask: Scalars['Boolean'];
  /**  Finish a signal scheduled task  */
  finishSignalScheduledTask: Scalars['Boolean'];
  /**  check in driver  */
  fleetCheckIn: FleetShift;
  /**  check out driver  */
  fleetCheckOut: Scalars['Boolean'];
  /**  delete driver  */
  fleetDeleteDriver: Scalars['Boolean'];
  /**  delete route  */
  fleetDeleteRoute: Scalars['Boolean'];
  /**  delete vehicle  */
  fleetDeleteVehicle: Scalars['Boolean'];
  /**  dispatch a shift to an event  */
  fleetDispatch: FleetDispatch;
  /**  accept a dispatch request  */
  fleetDispatchAccept: FleetDispatch;
  /**  log shift user entry  */
  fleetLogActivity: Scalars['Boolean'];
  /**  save a dispatch  */
  fleetSaveDispatch: FleetDispatch;
  /**  save driver  */
  fleetSaveDriver: FleetDriver;
  /**  save route  */
  fleetSaveRoute: FleetRoute;
  /**  save vehicle  */
  fleetSaveVehicle: FleetVehicle;
  /**  update shift status  */
  fleetUpdateStatus: Scalars['Boolean'];
  focusCamera?: Maybe<JobRequest>;
  /**  set selected arm positions for kinetic controller  */
  gateKineticControllerSetArmPosition: Scalars['Boolean'];
  /**  abort an active gate operation  */
  gateOperationAbort: Scalars['Boolean'];
  /**  log operation activity for each task  */
  gateOperationActivity: Scalars['Boolean'];
  /**  create a gate operation for the given type and direction  */
  gateOperationCreate: Scalars['Boolean'];
  /**  finish a gate operation  */
  gateOperationFinish: Scalars['Boolean'];
  /**  initiate a gate operation for the active user  */
  gateOperationInitiate: GateOperation;
  /**  join an active gate operation for the active user  */
  gateOperationLogIn?: Maybe<Scalars['ID']>;
  /**  return the next available step for the user  */
  gateOperationNextStep?: Maybe<Scalars['ID']>;
  /**  select the given step in the operation  */
  gateOperationSelectStep?: Maybe<Scalars['ID']>;
  /**  skip the provided step in the operation  */
  gateOperationSkipStep?: Maybe<Scalars['ID']>;
  generateCsv: FileModel;
  /**  Returns detector tmas report content */
  generateDetectorTMASReport?: Maybe<DetectorTmasReport>;
  /**  Generate Device Database Reports  */
  generateDeviceDatabaseReportExports: Scalars['Boolean'];
  /** Generates token URL to stream file */
  generateFileTokenURL: Scalars['String'];
  /**  Generate an intersection report  */
  generateIntersectionStatusReport: Scalars['Boolean'];
  /**  Generate Multi-Device Database Reports  */
  generateMultiDatabaseReportExports: Scalars['Boolean'];
  /**  Generate multi-report export and upload to My Downloads  */
  generateMultiReportExports: Scalars['Boolean'];
  generateRecordingTokenURL: Scalars['String'];
  /**  Generate report export and upload to My Downloads  */
  generateReportExport: ManagedFiles;
  generateTokenZip: Scalars['Boolean'];
  /**  Converts spread sheet to rows map  */
  getSpreadSheetData: Array<SpreadSheetData>;
  gotoPreset?: Maybe<JobRequest>;
  /**  delete message  */
  harDeleteMessage: Scalars['Boolean'];
  /**  delete playlist  */
  harDeletePlaylist: Scalars['Boolean'];
  /**  delete priority  */
  harDeletePriority: Scalars['Boolean'];
  /**  save message  */
  harSaveMessage: HarMessage;
  /**  save module settings  */
  harSaveModuleSettings?: Maybe<Scalars['Boolean']>;
  /**  save playlist  */
  harSavePlaylist: HarPlaylist;
  /**  save priority  */
  harSavePriority: HarPriority;
  /**  blank a set of transmitters  */
  harTransmitterBlank: Array<JobRequest>;
  /**  extend a set of playlists  */
  harTransmitterExtendPlaylist: Array<JobRequest>;
  /**  poll a set of transmitters  */
  harTransmitterPoll: Array<JobRequest>;
  /**  post a set of playlists  */
  harTransmitterPostPlaylist: Array<JobRequest>;
  /**  remove a set of playlists  */
  harTransmitterRemovePlaylist: JobRequest;
  /**  set attenuator level  */
  harTransmitterSetAttenuatorLevel: JobRequest;
  /**  set power level  */
  harTransmitterSetPowerLevel: JobRequest;
  /**  set voice speed  */
  harTransmitterSetVoiceSpeed: JobRequest;
  /**  enable weather radio  */
  harTransmitterSetWeatherRadio: JobRequest;
  /**  Ignore a detection for the current user. */
  ignoreDetections: Scalars['Boolean'];
  /**  imports asset */
  importAssets?: Maybe<Scalars['Boolean']>;
  /** Imports data source configs and data. Accepts 'dataSourceConfigs' and 'dataSources' arrays from a previous export. */
  importDataSources: Scalars['Boolean'];
  /**  import vehicles data. */
  importDetectorVehiclesData?: Maybe<Scalars['String']>;
  /** Imports form fields. Accepts json array from a previous export. */
  importFormFields: Scalars['Boolean'];
  /** Imports forms. Accepts json array from a previous export. */
  importForms: Scalars['Boolean'];
  /**  Save a list of integrations in plain text json. Returns a list of failed integrations names */
  importIntegrationsFromJson: Array<Scalars['String']>;
  importLocations: Scalars['Boolean'];
  /**  Initialize the My Files directory */
  initializeMyFilesDirectory: Directory;
  irisCamera?: Maybe<JobRequest>;
  /**  set attenuator level  */
  kineticTransmitterAttenuatorLevel?: Maybe<KineticTransmitter>;
  /**  blank transmitter  */
  kineticTransmitterBlank?: Maybe<KineticTransmitter>;
  /**  post playlist  */
  kineticTransmitterPost?: Maybe<KineticTransmitter>;
  /**  set power level  */
  kineticTransmitterPowerLevel?: Maybe<KineticTransmitter>;
  /**  set voice speed  */
  kineticTransmitterVoiceSpeed?: Maybe<KineticTransmitter>;
  /**  set weather radio  */
  kineticTransmitterWeatherRadio?: Maybe<KineticTransmitter>;
  /**  Link two events together  */
  linkEvent?: Maybe<Scalars['Boolean']>;
  /**  Lock a saved database, requesting a lock on an already locked database will restart the unlock timer  */
  lockDatabase: Scalars['Boolean'];
  /**  Lock a live database, requesting a lock on an already locked database will restart the unlock timer  */
  lockLiveDatabase: Scalars['Boolean'];
  /**  set the current user to manage the gate control system  */
  manageGateSystem: GateOperationApproval;
  /**  Mark a detection as examined */
  markDetectionAsExamined: Detection;
  /**  Move a file to a new directory */
  moveFile: Scalars['Boolean'];
  /**  Move one or more location groups to a new parent or root. Returns the updated groups as a flat list. */
  moveLocationGroups: Array<FlatLocationGroup>;
  /**  Move one or more locations to a new group or root.  */
  moveLocations: Scalars['Boolean'];
  /**  Multiple poll integrations" */
  multiplePoll?: Maybe<Array<JobRequest>>;
  /**  open inbound gates  */
  openInboundGates: Scalars['Boolean'];
  /**  open outbound gates  */
  openOutboundGates: Scalars['Boolean'];
  panTiltCamera?: Maybe<JobRequest>;
  /**  blank the parking message for the given area and signs  */
  parkingAreaBlankMessage: Array<JobRequest>;
  /**  delete a parking area message  */
  parkingAreaDeleteMessage: Scalars['Boolean'];
  /**  post the provided parking area messages  */
  parkingAreaPostMessage: Array<JobRequest>;
  /**  save a parking area message  */
  parkingAreaSaveMessage: ParkingAreaMessage;
  /**  Connect/Disconnect camera stream file */
  publicStreamFile?: Maybe<JobRequest>;
  /**  Enable/Disable camera stream target */
  publicStreamTarget?: Maybe<JobRequest>;
  /**  Updates vehicle aggregate data */
  reValidateDetectorPVR?: Maybe<Scalars['Boolean']>;
  /**  refresh link status for a toll point  */
  refreshTollingPointLinkStatus: Scalars['Boolean'];
  regenerateClientSecret: Scalars['Boolean'];
  /**  Reject device database validation */
  rejectDeviceDatabaseValidation: Scalars['Boolean'];
  /**  reject a dispatch request  */
  rejectDispatchRequest: Scalars['Boolean'];
  /**  Reject an event  */
  rejectEvent?: Maybe<Scalars['Boolean']>;
  /**  reject the given gate operation  */
  rejectGateOperation: Scalars['Boolean'];
  /**  reject the sign interlock override requests  */
  rejectInterlockOverride: Scalars['Boolean'];
  /**  Remove comm logs associations from an event */
  removeAssociatedCommLogsFromEvent?: Maybe<Scalars['Boolean']>;
  /**  Remove comm logs associations from an events */
  removeAssociatedCommLogsFromEvents?: Maybe<Scalars['Boolean']>;
  /**  Remove detections associated with any events  */
  removeAssociatedDetectionsFromAllEvents?: Maybe<Scalars['Boolean']>;
  /**  Remove a detection associations from an event */
  removeAssociatedDetectionsFromEvent?: Maybe<Scalars['Boolean']>;
  /**  Remove a detection associations from events */
  removeAssociatedDetectionsFromEvents?: Maybe<Scalars['Boolean']>;
  /**  Internal Service Call only - Not to be used by UI  */
  removeAssociatedEventsFromAllCommLogs?: Maybe<Scalars['Boolean']>;
  /**  Remove an event from all detections  */
  removeAssociatedEventsFromAllDetections?: Maybe<Scalars['Boolean']>;
  removeAssociatedEventsFromCommLogs?: Maybe<Scalars['Boolean']>;
  /**  Remove associated events from detections */
  removeAssociatedEventsFromDetections?: Maybe<Scalars['Boolean']>;
  /**  Remove any messages for the signs with the association id  */
  removeAssociations?: Maybe<Array<JobRequest>>;
  removePartialOrganizationPreference: Scalars['JSON'];
  removePartialUserPreference: Scalars['JSON'];
  /**  Remove the provided messages in the sign queue  */
  removeQueuedMessages: JobRequest;
  /**  remove a series of travel time messages  */
  removeTravelTimeMessages: Array<JobRequest>;
  removeUser?: Maybe<Scalars['Boolean']>;
  removeUserPicture?: Maybe<Scalars['Boolean']>;
  removeUserPreferences: Scalars['Boolean'];
  reorderCameraGroups?: Maybe<Scalars['Boolean']>;
  reorderScreens?: Maybe<Scalars['Boolean']>;
  /**  delete report builder block */
  reportBuilderBlockDelete: Scalars['Boolean'];
  /**  preview report builder block */
  reportBuilderBlockPreview?: Maybe<Scalars['Object']>;
  /**  save report builder block  */
  reportBuilderBlockSave: ReportBuilderBlock;
  /**  delete report builder  */
  reportBuilderDelete: Scalars['Boolean'];
  /**  generate and export report to downloads  */
  reportBuilderExport: Scalars['Boolean'];
  /**  preview a report  */
  reportBuilderPreview?: Maybe<Scalars['Object']>;
  /**  save report builder  */
  reportBuilderSave: ReportBuilder;
  /**  cancel report builder task occurrence  */
  reportBuilderTaskCancel: Scalars['Boolean'];
  /**  delete report builder task  */
  reportBuilderTaskDelete: Scalars['Boolean'];
  /**  save report builder task  */
  reportBuilderTaskSave?: Maybe<Task>;
  /**  request for the sign interlock override  */
  requestInterlockOverride: SignInterlockOverrideApproval;
  /**  Resets detector cache */
  resetDetectorCache?: Maybe<Scalars['Boolean']>;
  /**  Regenerates performance report */
  resetDetectorPerformanceReport?: Maybe<Scalars['Boolean']>;
  /**  Reset the event confirmation required  */
  resetEventConfirmationRequired: Scalars['Boolean'];
  resetPassword?: Maybe<Scalars['Boolean']>;
  /**  reverse alert direction  */
  reverseAlertDirection: Array<Scalars['Boolean']>;
  /**  reverse detector direction  */
  reverseDetectorDirection: Array<Scalars['Boolean']>;
  /** reverts work order transaction */
  revertAssetWorkOrderTransaction: AssetTransaction;
  /**  create or update action set rule  */
  saveActionSetResponseRule: ActionSetRule;
  /**  Save event activation confirmation. True to require confirmation, False to not require confirmation.  */
  saveActivationConfirmation?: Maybe<Scalars['Boolean']>;
  /**  Save an alarm config  */
  saveAlarmConfig: AlarmConfig;
  /**  Save multiple alarm configs  */
  saveAlarmConfigs: Array<AlarmConfig>;
  /**  Save and Close an event  */
  saveAndCloseEvent?: Maybe<Scalars['Boolean']>;
  /**  Save an asset  */
  saveAsset: Asset;
  /**  Save an work order  */
  saveAssetWorkOrder: AssetWorkOrder;
  /**  Save an work order comment  */
  saveAssetWorkOrderComment: AssetWorkOrderComment;
  /** Save work order sub step flag */
  saveAssetWorkOrderFlag: AssetWorkOrderSubStep;
  /**  Save Link  */
  saveAssetWorkOrderLink: AssetWorkOrderLink;
  saveAssetWorkOrderStepAssignments?: Maybe<Scalars['Boolean']>;
  /** Save work order sub step */
  saveAssetWorkOrderSubStep: AssetWorkOrderSubStep;
  /**  Save asset work order time tracking */
  saveAssetWorkOrderTracking: AssetWorkOrderTracking;
  /** saves work order transaction */
  saveAssetWorkOrderTransaction: AssetTransaction;
  /**  Save atlas archive module settings  */
  saveAtlasArchiveModuleSettings?: Maybe<Scalars['Boolean']>;
  saveCameraGroup?: Maybe<CameraGroup>;
  /**  Connect preset with camera */
  saveCameraPreset?: Maybe<JobRequest>;
  saveCentralAuthPinSettings?: Maybe<CentralAuthPinSettings>;
  saveCommunicationLog: CommunicationLog;
  /**  Add a comment to an Connected Vehicle  */
  saveConnectedVehicleComment: ConnectedVehicleComment;
  saveContact?: Maybe<Contact>;
  saveContactGroup?: Maybe<ContactGroupDto>;
  /**  Save a corridor rule  */
  saveCorridorRule: CorridorRule;
  /** Save Count Module settings  */
  saveCountsModuleSettings?: Maybe<Scalars['Boolean']>;
  /**  save data source  */
  saveDataSource: DataSource;
  /**  save data source form  */
  saveDataSourceConfig: DataSourceConfig;
  /**  Save a template for database exports  */
  saveDatabaseExportTemplate: DatabaseExportTemplate;
  /**  Saves detector  vehicle config */
  saveDetectorConfig?: Maybe<DetectorConfig>;
  /**  Saves detector  vehicle config */
  saveDetectorConnectionLog?: Maybe<Array<DetectorConnectionLog>>;
  /**  Saves detector  email  alert setting */
  saveDetectorEmailAlertSetting?: Maybe<DetectorEmailAlertSetting>;
  /**  Saves detector  extra  config */
  saveDetectorExtraConfig?: Maybe<DetectorConfig>;
  /**  create or update detector group  */
  saveDetectorGroup: DetectorGroup;
  /**  Saves detector Report Rule */
  saveDetectorReportConfiguration?: Maybe<DetectorReportConfiguration>;
  /**  Saves detector Report Rule */
  saveDetectorReportRule?: Maybe<DetectorReportRule>;
  saveEmailRule?: Maybe<EmailRuleDto>;
  saveEmailServerSettings: EmailServerSettings;
  saveEmailTemplate?: Maybe<EmailTemplateDto>;
  /**  Save entity work order */
  saveEntityWorkOrder: EntityWorkOrder;
  /**  Save an event  */
  saveEvent: Event;
  /**  Add a note to an event  */
  saveEventNote: Scalars['Boolean'];
  /**  Save an event template  */
  saveEventTemplate: EventTemplate;
  /**  Save an event type  */
  saveEventType: EventType;
  /**  Save events module settings  */
  saveEventsModuleSettings?: Maybe<Scalars['Boolean']>;
  /**  save gate controller sign messages  */
  saveGateControllerSignMessage: GateControllerSignMessage;
  /**  save a gate control system  */
  saveGateControllerSystem: GateControllerSystem;
  /**  Save gate module settings  */
  saveGateModuleSettings?: Maybe<Scalars['Boolean']>;
  /**  Saves hi trac log packets */
  saveHiTracLogPackets?: Maybe<Scalars['Boolean']>;
  /**  Saves hi trac vehicle packets */
  saveHiTracVehiclePackets?: Maybe<Scalars['Boolean']>;
  /**  Save an integration.  */
  saveIntegration?: Maybe<Integration>;
  /**  Save integration groups  */
  saveIntegrationGroup?: Maybe<IntegrationGroup>;
  /**  Save a list of integrations. Returns a list of failed integrations names */
  saveIntegrations: Array<Scalars['String']>;
  /**  Save an intersection.  */
  saveIntersection: Intersection;
  /**  Save an intersection template  */
  saveIntersectionTemplate: IntersectionTemplate;
  /**  Save Signal module settings  */
  saveKineticAuthSettings?: Maybe<Scalars['Boolean']>;
  /**  Save the provided form  */
  saveKineticForm: KineticForm;
  /**  Save the provided form field  */
  saveKineticFormField: KineticFormField;
  saveKineticUserPreference: Scalars['JSON'];
  /**  Save lane control settings  */
  saveLaneControlSettings: LaneControlSettings;
  saveLicense: Scalars['Boolean'];
  /**  Save a location  */
  saveLocation?: Maybe<Location>;
  /**  Add a comment to an Location */
  saveLocationComment: LocationComment;
  /**  Save a corridor  */
  saveLocationCorridor: LocationCorridor;
  /**  Save a corridor leg  */
  saveLocationCorridorLeg: LocationCorridorLeg;
  /**  Save a corridor link  */
  saveLocationCorridorLink: LocationCorridorLink;
  /**  Save one or more location groups. Returns the updated groups as a flat list.  */
  saveLocationGroups: Array<FlatLocationGroup>;
  /**  Save location links  */
  saveLocationLink: LocationExternalLink;
  /**  Save a location template  */
  saveLocationTemplate: LocationTemplate;
  /** Save a map config */
  saveMapConfig: MapConfig;
  /**  Save a map layer config. */
  saveMapLayerConfig: MapLayerConfig;
  /**  Save an alarm config  */
  saveMibAlarmConfig: MibAlarmConfig;
  /**  Save multiple alarm configs  */
  saveMibAlarmConfigs: Array<MibAlarmConfig>;
  /**  Save module-specific map setting  */
  saveModuleMapSettings?: Maybe<Scalars['Boolean']>;
  saveNotification?: Maybe<Notification>;
  saveNotificationPreferences?: Maybe<NotificationPreference>;
  saveOrganization?: Maybe<KineticOrganization>;
  saveOrganizationContact?: Maybe<OrganizationDto>;
  saveOrganizationPreference: Scalars['JSON'];
  savePreset?: Maybe<Preset>;
  /**  Save an ramp meter site.  */
  saveRampMeter: Intersection;
  /**  Save a resource plan  */
  saveResourcePlan: ResourcePlan;
  /**  Save resource plan task  */
  saveResourcePlanTask?: Maybe<Task>;
  /**  Save a Resource to plan  */
  saveResources: ResourcePlan;
  /**  Save response module settings  */
  saveResponseModuleSettings?: Maybe<Scalars['Boolean']>;
  /**  Save a response rule  */
  saveResponseRule: ResponseRule;
  saveRole: KineticRole;
  /**  Save a route with the provided input  */
  saveRoute: LocationRoute;
  saveScene?: Maybe<Scene>;
  /**  Save Scheduled Event task  */
  saveScheduledEventTask?: Maybe<Task>;
  saveScreen?: Maybe<Screen>;
  /**  Save Shift notes  */
  saveShiftNotes: Corridor;
  /**  Save sign cutout  */
  saveSignCutout: SignCutout;
  /**  Save sign gantry  */
  saveSignGantry: SignGantry;
  /**  Save sign message  */
  saveSignMessage?: Maybe<SignLibraryMessage>;
  /**  Save sign message priority  */
  saveSignMessagePriority?: Maybe<SignMessagePriority>;
  /**  Save sign module settings  */
  saveSignModuleSettings?: Maybe<Scalars['Boolean']>;
  /**  Save a response rule  */
  saveSignResponseRule: SignResponseRule;
  /**  Save an Action Set  */
  saveSignalActionSet: SignalActionSet;
  /**  Save a detector group  */
  saveSignalDetectorGroup: SignalDetectorGroup;
  /**  Save signal module settings  */
  saveSignalModuleSettings?: Maybe<Scalars['Boolean']>;
  /**  Save a signal scheduled task  */
  saveSignalScheduledTask?: Maybe<Task>;
  /**  Save the system Directories */
  saveSystemDirectories: Array<Directory>;
  saveTask?: Maybe<Task>;
  /**  Save the time drift settings */
  saveTimeDriftSettings: TimeDriftSettings;
  /**  save module settings  */
  saveTollingModuleSettings?: Maybe<Scalars['Boolean']>;
  /**  save a tolling segment comment  */
  saveTollingSegmentComment: BasicComment;
  saveTour: Tour;
  /**  Save a traffic responsive plan  */
  saveTrafficResponsivePlan: TrafficResponsivePlan;
  /** Save Travel Time Module settings  */
  saveTravelTimeModuleSettings?: Maybe<Scalars['Boolean']>;
  /**  Save an tunnel log */
  saveTunnelLog: TunnelLog;
  /**  Save the user Directories */
  saveUserDirectories: Array<Directory>;
  saveUserGroup: KineticUserGroup;
  saveUserPreference: Scalars['JSON'];
  saveVideoModuleSettings?: Maybe<Scalars['Boolean']>;
  saveWidget?: Maybe<Widget>;
  /**  Save an work order configuration  */
  saveWorkOrderConfiguration: WorkOrderConfiguration;
  sendEmail: Scalars['Boolean'];
  setActiveHardwareScreen: Scalars['Boolean'];
  /**  Sets alarms Acknowledge/Un Acknowledge */
  setAlarmAcknowledgeState?: Maybe<Array<DetectorAlarm>>;
  setAsHomePreset?: Maybe<Preset>;
  /**  Update Mibs on a device database  */
  setDatabaseMibs: DeviceDatabase;
  /** Set the default color */
  setDefaultColor: Scalars['Boolean'];
  /**  Sets the isFiveOneOneSubmitted status to true on the event  */
  setFiveOneOneSubmitted?: Maybe<Scalars['Boolean']>;
  /**  Update lane control settings for the provided sign  */
  setSignLaneControlSettings: Scalars['Boolean'];
  /**  Set Mibs on a device  */
  setSignalMibs: Scalars['Boolean'];
  /**  Set a devices time to now */
  setTimeNow: Scalars['Boolean'];
  /**  Blank the requested signs  */
  signBlank: Array<JobRequest>;
  /**  Set the brightness  */
  signBrightness: JobRequest;
  /**  Check for sign capabilities  */
  signCapabilities: JobRequest;
  signDeleteCommand: JobRequest;
  /**  delete sign group  */
  signDeleteGroup: Scalars['Boolean'];
  /**  Display the requested messages  */
  signDisplay: Array<JobRequest>;
  /**  Enable or disable default message */
  signEnableDisableDefaultMessage: Scalars['Boolean'];
  /**  Extend the currently displayed message  */
  signExtend: JobRequest;
  /**  Run a fan test  */
  signFanTest: JobRequest;
  /**  Download the fonts  */
  signFonts: JobRequest;
  /**  ack the interlock  */
  signInterlockAcknowledge: Scalars['Boolean'];
  /**  Run a lamp test  */
  signLampTest: JobRequest;
  /**  Display Lane Control  */
  signLaneControlDisplay: Array<JobRequest>;
  /**  Run a pixel test  */
  signPixelTest: JobRequest;
  /**  Poll the requested signs  */
  signPoll: Array<JobRequest>;
  /**  Reset a sign  */
  signReset: JobRequest;
  /**  save font  */
  signSaveFont: Scalars['Boolean'];
  /**  create or update sign group  */
  signSaveGroup: SignGroup;
  /** set priority for command message for given slot */
  signSetCommandMessagePriority: Scalars['Boolean'];
  /**  set mapping of commands to slot  */
  signSetCommands: Scalars['Boolean'];
  /**  update default font  */
  signSetDefaultFont: Scalars['Boolean'];
  /**  Set the default message  */
  signSetDefaultMessage: Scalars['Boolean'];
  /**  update fonts  */
  signSetFonts: Scalars['Boolean'];
  /**  set mapping of grahpic labels to slot  */
  signSetGraphicLabels: Scalars['Boolean'];
  /**  set sign message preferences  */
  signSetMessagePreferences: Scalars['Boolean'];
  /**  set sign speed settings  */
  signSetSpeedSettings: Scalars['Boolean'];
  /**  Upload all graphics in KMob for the device to the controller  */
  signUploadAllGraphics: Scalars['Boolean'];
  /**  Upload all messages in KMob for the device to the controller  */
  signUploadAllMessages: Scalars['Boolean'];
  /**  upload message definition  */
  signUploadMessage: JobRequest;
  snoozeNotification: Scalars['Boolean'];
  splitMonitorExport: Scalars['Boolean'];
  /**  Subscribe to a list of mibs with an optional request id. Use the same request id to keep the current subscription alive. */
  subscribeMibs: JobRequest;
  /**  Sync used licenses. */
  syncIntegrationLicenses?: Maybe<Scalars['Boolean']>;
  syncLicense: Scalars['Boolean'];
  /**  Export a Synchro Database  */
  synchroExport: Scalars['Boolean'];
  /**  toggle the bypassing restriction flag  */
  toggleGateRestrictionBypass: Scalars['Boolean'];
  /**  toggle the safe reversal time flag  */
  toggleGateSafeReversalTime: Scalars['Boolean'];
  /**  deletes a tolling road  */
  tollingRoadDelete: Scalars['Boolean'];
  /**  saves a tolling road  */
  tollingRoadSave: TollingRoad;
  /**  delete a tolling segment  */
  tollingSegmentDelete: Scalars['Boolean'];
  /**  save a tolling segment  */
  tollingSegmentSave: TollingSegment;
  tourHeartBeat: Scalars['Boolean'];
  /**  Poll the given travel time segments  */
  travelTimeSegmentPoll: Array<JobRequest>;
  /**  Trigger event to re run all responses */
  triggerResourcePlanRules?: Maybe<Scalars['String']>;
  unDismissNotification: Scalars['Boolean'];
  /**  Remove a block for a camera or stream  */
  unblockVideoStream: Scalars['Boolean'];
  /**  Unlink two events  */
  unlinkEvent?: Maybe<Scalars['Boolean']>;
  /**  Unlock a saved database  */
  unlockDatabase: Scalars['Boolean'];
  /**  Unlock a live database  */
  unlockLiveDatabase: Scalars['Boolean'];
  unlockPTZCamera?: Maybe<Scalars['Boolean']>;
  /**  unmanage the gate control system  */
  unmanageGateSystem: GateControllerSystem;
  /**  Update the comments associated with an alarm  */
  updateAlarmComments: Array<Alarm>;
  /** Enable/Disable Detection status of camera */
  updateCameraDetectionStatus: CameraDetectionStatus;
  updateDefaultDetectorReportConfiguration?: Maybe<DetectorReportConfiguration>;
  /**  updates  detector  email  alert setting's status */
  updateDetectorEmailAlertSettingStatus?: Maybe<Scalars['Boolean']>;
  /**  update vehicle's AI class name */
  updateDetectorVehicleAIClassName?: Maybe<Scalars['Boolean']>;
  /**  update vehicle's AI Verified status */
  updateDetectorVehicleAIVerificationStatus?: Maybe<Scalars['Boolean']>;
  /**  update vehicle's record tags. */
  updateDetectorVehicleRecordTags?: Maybe<DetectorVehicle>;
  /**  update vehicle's verified class name. DetectorVehicle object will be used to determine status of verified class name icon. */
  updateDetectorVehicleVerifiedClassName?: Maybe<DetectorVehicle>;
  /**  update vehicle's verified class name status */
  updateDetectorVehicleVerifiedClassNameStatus?: Maybe<Scalars['Boolean']>;
  /**  Updates vehicle aggregate data */
  updateDetectorVehicleVolumeIntervalCounts?: Maybe<Scalars['Boolean']>;
  /**  Update archive flag on a device database  */
  updateDeviceDatabasesArchiveFlag: Scalars['Boolean'];
  /** Updates the location associated with the integration */
  updateIntegrationLocation: Scalars['Boolean'];
  /** Updates the settings associated with the integration */
  updateIntegrationSettings: Scalars['Boolean'];
  /**  update network conditions  */
  updateNetworkConditions: Array<NetworkCondition>;
  updateNetworkJurisdiction: NetworkJurisdiction;
  updatePartialOrganizationPreference: Scalars['JSON'];
  updatePartialUserPreference: Scalars['JSON'];
  /**  Update a queued message and evaluate queue  */
  updateQueuedMessage: JobRequest;
  updateUserPrivileges: KineticUserPrivilegeAssignment;
  useCameraCapability?: Maybe<JobRequest>;
  /**  Validate a device database  */
  validateDeviceDatabase: Scalars['Boolean'];
  /**  Poll the given weather stations  */
  weatherStationPoll: Array<JobRequest>;
  zoomCamera?: Maybe<JobRequest>;
};


export type Mutation_AddEntityWorkOrdersArgs = {
  addArguments: AddWorkOrderArguments;
};


export type Mutation_AvlCheckInArgs = {
  coordinates: Array<AvlLocationInput>;
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_AvlCheckOutArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_AvlDispatchArgs = {
  coordinate: AvlLocationInput;
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_AvlResumeArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_BackupDeviceDatabaseArgs = {
  deviceId: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_CameraCapabilitiesArgs = {
  cameraId: Scalars['String'];
  requestId: Scalars['String'];
};


export type Mutation_ChangeDeviceFirmwareArgs = {
  deviceId: Scalars['String'];
  firmwareUrl: Scalars['String'];
  productName: Scalars['String'];
  productVersion: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
  timeout: Scalars['Int'];
};


export type Mutation_DownloadDeviceDatabaseArgs = {
  binFile?: InputMaybe<DeviceDatabaseFileRequest>;
  deviceId: Scalars['String'];
  jsonFile: DeviceDatabaseFileRequest;
  requestId?: InputMaybe<Scalars['String']>;
  tables?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Mutation_FlushIntegrationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type Mutation_GateControllerAbortArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  userDisplayName: Scalars['String'];
  userId: Scalars['ID'];
};


export type Mutation_GateControllerCloseArgs = {
  id: Scalars['ID'];
  manualOperation?: InputMaybe<Scalars['Boolean']>;
  requestId?: InputMaybe<Scalars['String']>;
  systemId: Scalars['ID'];
  userDisplayName: Scalars['String'];
  userId: Scalars['ID'];
};


export type Mutation_GateControllerOpenInboundArgs = {
  id: Scalars['ID'];
  manualOperation?: InputMaybe<Scalars['Boolean']>;
  requestId?: InputMaybe<Scalars['String']>;
  systemId: Scalars['ID'];
  userDisplayName: Scalars['String'];
  userId: Scalars['ID'];
};


export type Mutation_GateControllerOpenOutboundArgs = {
  id: Scalars['ID'];
  manualOperation?: InputMaybe<Scalars['Boolean']>;
  requestId?: InputMaybe<Scalars['String']>;
  systemId: Scalars['ID'];
  userDisplayName: Scalars['String'];
  userId: Scalars['ID'];
};


export type Mutation_GeoTabCameraDetailsArgs = {
  geoTabCameraArguments: GeoTabCameraArguments;
};


export type Mutation_GetSignalMibsArgs = {
  id: Scalars['String'];
  mibs: Array<MibWithIndexes>;
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_HarTransmitterAttenuatorLevelArgs = {
  id: Scalars['ID'];
  level: Scalars['Int'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_HarTransmitterBlankArgs = {
  blank: HarTransmitterBlank;
};


export type Mutation_HarTransmitterPollArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_HarTransmitterPostArgs = {
  post: HarTransmitterPost;
};


export type Mutation_HarTransmitterPowerLevelArgs = {
  id: Scalars['ID'];
  level: Scalars['Int'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_HarTransmitterVoiceSpeedArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  speed: Scalars['Int'];
};


export type Mutation_HarTransmitterWeatherRadioArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_ListEntityWorkOrdersArgs = {
  listArguments: ListWorkOrderArguments;
};


export type Mutation_ListVideoWallLayoutsArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_PricingConfirmRatesArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_PricingHistoricalPollArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_PricingPollArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_PricingSetDetectorDataArgs = {
  detectorId: Scalars['ID'];
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_PricingSetTollPointDataArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  tollPointId: Scalars['ID'];
};


export type Mutation_RegenerateEffectivePrivilegesArgs = {
  id: Scalars['String'];
};


export type Mutation_RestartPollArgs = {
  id: Scalars['ID'];
};


export type Mutation_ReverseAlertDirectionArgs = {
  id: Scalars['ID'];
  isReversed: Scalars['Boolean'];
  requestId?: InputMaybe<Scalars['String']>;
  userDisplayName: Scalars['String'];
  userId: Scalars['ID'];
};


export type Mutation_ReverseDetectorArgs = {
  direction: Scalars['String'];
  id: Scalars['ID'];
  isReversed: Scalars['Boolean'];
  requestId?: InputMaybe<Scalars['String']>;
  userDisplayName: Scalars['String'];
  userId: Scalars['ID'];
};


export type Mutation_RunOneTimeJobArgs = {
  id: Scalars['String'];
  requestId: Scalars['String'];
  settings: Scalars['Object'];
};


export type Mutation_SetSignalMibsArgs = {
  id: Scalars['String'];
  ignoreMissingBitIndexes?: InputMaybe<Scalars['Boolean']>;
  mibs: Array<SetMibsInput>;
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SetTimeNowArgs = {
  deviceId: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SetVideoWallAreaCameraArgs = {
  arguments: SetVideoWallAreaCameraArguments;
};


export type Mutation_SetVideoWallLayoutArgs = {
  arguments: SetVideoWallLayoutArguments;
};


export type Mutation_SignBlankArgs = {
  blankArguments: SignBlankArguments;
};


export type Mutation_SignBrightnessArgs = {
  brightness?: InputMaybe<Scalars['Int']>;
  brightnessMode: SignBrightnessMode;
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignCapabilitiesArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignDeleteGraphicArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  slot: Scalars['Int'];
};


export type Mutation_SignDeleteMessageArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  slot: Scalars['Int'];
};


export type Mutation_SignDisplayArgs = {
  displayArguments: SignDisplayArguments;
};


export type Mutation_SignDownloadAllGraphicsArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignDownloadAllMessagesArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignDownloadGraphicArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  slot: Scalars['Int'];
};


export type Mutation_SignDownloadMessageArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  slot: Scalars['Int'];
};


export type Mutation_SignExtendArgs = {
  expirationTime: Scalars['DateTime'];
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignFanTestArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignFontsArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignLampTestArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignPixelTestArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignPollArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignResetArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignSetColorArgs = {
  color: Scalars['String'];
  id: Scalars['ID'];
  isBackground: Scalars['Boolean'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignUploadGraphicArgs = {
  arguments: SignUploadGraphicArguments;
};


export type Mutation_SignUploadMessageArgs = {
  arguments: SignUploadMessageArguments;
};


export type Mutation_SignUploadMultipleGraphicsArgs = {
  graphics: Array<SignImageInput>;
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignUploadMultipleMessagesArgs = {
  id: Scalars['ID'];
  messages: Array<SignMessageInput>;
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_SignalGetUiTableArgs = {
  id: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
  tableName: Scalars['String'];
};


export type Mutation_SignalGetUiViewArgs = {
  id: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_TollingPointActivateArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  userDisplayName: Scalars['String'];
  userId: Scalars['ID'];
};


export type Mutation_TrafficControlPollArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_TrafficControlSetModeArgs = {
  id: Scalars['ID'];
  mode: TrafficControlMode;
  requestId?: InputMaybe<Scalars['String']>;
};


export type Mutation_UseCameraCapabilityArgs = {
  cameraId: Scalars['String'];
  capability: CameraCapability;
  option: Scalars['String'];
};


export type Mutation_ValidateDeviceDatabaseArgs = {
  deviceId: Scalars['String'];
  jsonFile: DeviceDatabaseFileRequest;
  podIp: Scalars['String'];
  podName: Scalars['String'];
  requestId?: InputMaybe<Scalars['String']>;
  tables?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationAbortControllerOperationArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type MutationAcceptDeviceDatabaseValidationArgs = {
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationAcknowledgeAlarmsArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};


export type MutationAcknowledgeNotificationArgs = {
  id: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};


export type MutationAcknowledgeResourcesArgs = {
  id: Scalars['ID'];
  resources: Array<Scalars['ID']>;
};


export type MutationActivateGateSignMessagesArgs = {
  blankBeforeDisplay?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  type: Scalars['ID'];
};


export type MutationActivateGateTollPointsArgs = {
  id: Scalars['ID'];
};


export type MutationActivateResourcesArgs = {
  activationId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['Object']>;
  id: Scalars['ID'];
  resources?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationActivateTollPointArgs = {
  id: Scalars['ID'];
};


export type MutationActivateTollPointsArgs = {
  direction: Direction;
  ids: Array<Scalars['ID']>;
  userDisplayName: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationAddActivityLogArgs = {
  input: ActivityLogInput;
};


export type MutationAddIntersectionCommentArgs = {
  comment: Scalars['String'];
  intersectionId: Scalars['ID'];
};


export type MutationAddNetworkConditionsArgs = {
  boundedRoutes: Array<NetworkConditionInput>;
  id: Scalars['ID'];
};


export type MutationAdminUnlockDatabaseArgs = {
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationAdminUnlockLiveDatabaseArgs = {
  intersectionId: Scalars['String'];
};


export type MutationApproveDatabaseArgs = {
  comment?: InputMaybe<Scalars['String']>;
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationApproveGateOperationArgs = {
  id: Scalars['ID'];
};


export type MutationApproveInterlockOverrideArgs = {
  approvalId: Scalars['ID'];
};


export type MutationAssociateCommLogsToEventArgs = {
  commLogIds: Array<Scalars['ID']>;
  eventId: Scalars['ID'];
  internalCall?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAssociateCommLogsToEventsArgs = {
  commLogIds: Array<Scalars['ID']>;
  eventIds: Array<Scalars['ID']>;
  internalCall?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAssociateDetectionToEventsArgs = {
  detectionId: Scalars['ID'];
  eventIds: Array<Scalars['ID']>;
};


export type MutationAssociateDetectionsToEventArgs = {
  detectionIds: Array<Scalars['ID']>;
  eventId: Scalars['ID'];
};


export type MutationAssociateEventsToCommLogsArgs = {
  commLogIds: Array<Scalars['ID']>;
  eventIds: Array<Scalars['ID']>;
  internalCall?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAssociateEventsToCorridorArgs = {
  corridorId: Scalars['ID'];
  eventIds: Array<Scalars['String']>;
};


export type MutationAssociateEventsToDetectionsArgs = {
  detectionIds: Array<Scalars['ID']>;
  eventIds: Array<Scalars['ID']>;
};


export type MutationBackupDeviceDatabaseArgs = {
  comment?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  makeApproved?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBlockVideoStreamArgs = {
  input: BlockVideoStreamInput;
};


export type MutationCameraAutoFocusArgs = {
  enable: Scalars['Boolean'];
  id: Scalars['String'];
};


export type MutationCameraAutoIrisArgs = {
  enable: Scalars['Boolean'];
  id: Scalars['String'];
};


export type MutationCameraExplicitLockArgs = {
  cameraId: Scalars['ID'];
};


export type MutationCameraFetchRecordingsArgs = {
  cameraId: Scalars['String'];
  recordingInitiatedBy: RecordingInitiatedBy;
  recordingInitiatorDisplayName?: InputMaybe<Scalars['String']>;
  recordingInitiatorId?: InputMaybe<Scalars['String']>;
  recordingName: Scalars['String'];
  recordingType: RecordingType;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  streamAccessType: Scalars['String'];
  streamRecorderId: Scalars['String'];
};


export type MutationCameraFocusArgs = {
  focusSpeed: Scalars['Int'];
  id: Scalars['String'];
};


export type MutationCameraGoToPresetArgs = {
  id: Scalars['String'];
  presetNumber: Scalars['Int'];
};


export type MutationCameraIrisArgs = {
  id: Scalars['String'];
  irisSpeed: Scalars['Int'];
};


export type MutationCameraMaxPresetsArgs = {
  id: Scalars['String'];
};


export type MutationCameraOnDemandLockArgs = {
  cameraId: Scalars['ID'];
};


export type MutationCameraPanTiltArgs = {
  id: Scalars['String'];
  panSpeed: Scalars['Int'];
  tiltSpeed: Scalars['Int'];
};


export type MutationCameraPollArgs = {
  id: Scalars['String'];
};


export type MutationCameraPublicFeedArgs = {
  cameraPublicFeedInput: CameraPublicFeedInput;
};


export type MutationCameraPublicStreamTargetArgs = {
  cameraPublicStreamTargetInput: CameraPublicStreamTargetInput;
};


export type MutationCameraRecordingArgs = {
  cameraStreamRecordingInput?: InputMaybe<CameraStreamRecordingInput>;
};


export type MutationCameraSnapshotArgs = {
  requestId: Scalars['String'];
  streamManagerId: Scalars['String'];
  streamName: Scalars['String'];
};


export type MutationCameraSnapshotsArgs = {
  action: StreamTagRequestAction;
  cameraId: Scalars['String'];
  incidentId: Scalars['String'];
};


export type MutationCameraStreamRecordingArgs = {
  cameraId: Scalars['String'];
  plannedStartTime?: InputMaybe<Scalars['String']>;
  recordingInitiatedBy: RecordingInitiatedBy;
  recordingInitiatorDisplayName?: InputMaybe<Scalars['String']>;
  recordingInitiatorId?: InputMaybe<Scalars['String']>;
  recordingName: Scalars['String'];
  recordingType: RecordingType;
  start: Scalars['Boolean'];
  streamAccessType: Scalars['String'];
  streamRecorderId: Scalars['String'];
};


export type MutationCameraZoomArgs = {
  id: Scalars['String'];
  zoomSpeed: Scalars['Int'];
};


export type MutationCancelDeviceDatabaseActionArgs = {
  databaseId: Scalars['ID'];
  intersectionId: Scalars['ID'];
};


export type MutationCancelGateOperationArgs = {
  id: Scalars['ID'];
};


export type MutationCancelInterlockOverrideArgs = {
  approvalId: Scalars['ID'];
};


export type MutationCancelJobArgs = {
  id: Scalars['String'];
  requestId: Scalars['String'];
};


export type MutationCancelTaskOccurrenceArgs = {
  date: Scalars['DateTime'];
  id: Scalars['ID'];
};


export type MutationChangeTourStateArgs = {
  paused?: InputMaybe<Scalars['Boolean']>;
  tourId: Scalars['ID'];
};


export type MutationClearAlarmAcknowledgementArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};


export type MutationClearAlarmsArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};


export type MutationClearAllAlarmsArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  source: KineticModule;
};


export type MutationClearAllAlarmsForEntityArgs = {
  entityId: Scalars['ID'];
  entityType: AlarmEntityType;
};


export type MutationClearDetectorAlarmsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationClearNetworkConditionsArgs = {
  id: Scalars['ID'];
  networkConditions: Array<Scalars['String']>;
};


export type MutationCloneEventArgs = {
  id: Scalars['ID'];
};


export type MutationCloneWorkOrderConfigurationArgs = {
  id: Scalars['ID'];
};


export type MutationCloseAssetWorkOrderArgs = {
  input: AssetWorkOrderCloseInput;
};


export type MutationCloseEventArgs = {
  closureResolution?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lanesClear?: InputMaybe<Scalars['DateTime']>;
  sceneClear?: InputMaybe<Scalars['DateTime']>;
};


export type MutationCloseGatesArgs = {
  id: Scalars['ID'];
  manualOperation?: InputMaybe<Scalars['Boolean']>;
  requestId?: InputMaybe<Scalars['String']>;
  systemId: Scalars['ID'];
};


export type MutationConfirmNetworkConditionsArgs = {
  id: Scalars['ID'];
  networkConditions: Array<Scalars['String']>;
};


export type MutationConfirmVideoStreamBlockedArgs = {
  id: Scalars['ID'];
  serverConfirmedName: Scalars['String'];
};


export type MutationConnectedVehiclesPollArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationCopyDeviceDatabaseDraftArgs = {
  databaseId: Scalars['String'];
  fromIntersectionId: Scalars['String'];
  toIntersectionId: Scalars['String'];
};


export type MutationCopyFileArgs = {
  destinationDirectoryId: Scalars['String'];
  fileId: Scalars['String'];
};


export type MutationCorridorDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationCorridorLoadDevicesArgs = {
  id: Scalars['ID'];
};


export type MutationCorridorSaveArgs = {
  input: CorridorInput;
};


export type MutationCorridorUpdateConfirmationArgs = {
  confirmed: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationCreateDraftDatabaseArgs = {
  comment?: InputMaybe<Scalars['String']>;
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationCreateEventFromCorridorArgs = {
  category: EventCategory;
  corridorId: Scalars['ID'];
  direction: Direction;
  lanes?: InputMaybe<Array<InputMaybe<EventLaneInput>>>;
  referencePoint?: InputMaybe<Scalars['Float']>;
  road?: InputMaybe<Scalars['String']>;
};


export type MutationCreateEventFromDetectionArgs = {
  attributes?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
};


export type MutationCreateOrGetUserDirectoryPathArgs = {
  directories: Array<Scalars['String']>;
};


export type MutationCreateReportExportArgs = {
  exportTypes: Array<ExportReportType>;
  module: KineticModule;
  report: ExportReport;
};


export type MutationCreateUserArgs = {
  user: OrganizationKineticUserInput;
};


export type MutationDeclineAssetWorkOrderStepArgs = {
  input?: InputMaybe<AssetWorkOrderDeclineInput>;
};


export type MutationDeleteActionSetResponseRuleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAlarmConfigArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAllConnectedVehicleCommentsArgs = {
  connectedVehicleId: Scalars['ID'];
};


export type MutationDeleteAllIntersectionCommentsArgs = {
  intersectionId: Scalars['ID'];
};


export type MutationDeleteAllLocationCommentsArgs = {
  locationId: Scalars['ID'];
};


export type MutationDeleteAssetWorkOrderCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAssetWorkOrderFlagArgs = {
  input: AssetWorkOrderFlagInput;
};


export type MutationDeleteAssetWorkOrderLinkArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAssetWorkOrderTrackingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAssetWorkOrderTransactionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCameraGroupsArgs = {
  groups: Array<Scalars['ID']>;
};


export type MutationDeleteConnectedVehicleCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteContactArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteContactGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCorridorRuleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDataSourceConfigsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteDataSourcesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteDatabaseExportTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDetectorEmailAlertSettingArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationDeleteDetectorGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDetectorReportConfigurationArgs = {
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteDetectorReportRuleArgs = {
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteDeviceDatabaseArgs = {
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationDeleteEmailRuleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEmailRulesListArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteEmailTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEmailTemplateListArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteEventTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEventTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFileArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  module?: InputMaybe<KineticModule>;
};


export type MutationDeleteFilesArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  module?: InputMaybe<KineticModule>;
};


export type MutationDeleteGateControllerSignMessageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGateControllerSystemArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGlobalFileArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteGlobalFilesArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteIntegrationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteIntegrationGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteIntersectionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteIntersectionCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteIntersectionTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteJobArgs = {
  id: Scalars['String'];
  requestId: Scalars['String'];
};


export type MutationDeleteKineticFormFieldsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteKineticFormsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteKineticUserPreferenceArgs = {
  key: Scalars['ID'];
};


export type MutationDeleteLaneControlSettingsArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationCorridorArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationCorridorLegArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationCorridorLinkArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationLinkArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteManagedFilesArgs = {
  fileIds: Array<Scalars['ID']>;
};


export type MutationDeleteMapConfigArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMapLayerConfigArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMibAlarmConfigArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMibAlarmConfigsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteNetworkConditionsArgs = {
  id: Scalars['ID'];
  networkConditions: Array<Scalars['String']>;
};


export type MutationDeleteNetworkJurisdictionsArgs = {
  id: Scalars['ID'];
  networkJurisdictions: Array<Scalars['String']>;
};


export type MutationDeleteOrganizationContactArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationContactListArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteOrganizationPreferenceArgs = {
  key: Scalars['ID'];
};


export type MutationDeletePresetsArgs = {
  presets: Array<Scalars['ID']>;
};


export type MutationDeleteRecordingsArgs = {
  videoRecords?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationDeleteResourcePlanArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteResourcePlanTaskArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteResourcesArgs = {
  id: Scalars['ID'];
  resources: Array<Scalars['ID']>;
};


export type MutationDeleteResponseRuleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRouteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteScenesArgs = {
  scenes: Array<Scalars['ID']>;
};


export type MutationDeleteScheduledEventTaskArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteScreensArgs = {
  screens: Array<Scalars['ID']>;
};


export type MutationDeleteSignCutoutArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSignGantryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSignMessagePrioritiesArgs = {
  priorities: Array<Scalars['ID']>;
};


export type MutationDeleteSignMessagesArgs = {
  messages: Array<Scalars['ID']>;
};


export type MutationDeleteSignResponseRuleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSignalActionSetArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSignalDetectorGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSignalScheduledTaskArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
};


export type MutationDeleteTollingSegmentCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteToursArgs = {
  tours: Array<Scalars['ID']>;
};


export type MutationDeleteTrafficResponsivePlanArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTunnelLogArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserPreferenceArgs = {
  key: Scalars['ID'];
};


export type MutationDeleteVideoTaskArgs = {
  taskId: Scalars['ID'];
};


export type MutationDeleteWidgetsArgs = {
  widgets: Array<Scalars['ID']>;
};


export type MutationDeleteWorkOrderConfigurationArgs = {
  id: Scalars['ID'];
};


export type MutationDetectorConfigExistsArgs = {
  detectorId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};


export type MutationDetectorGroupExportArgs = {
  detectorGroupId: Scalars['String'];
  endDateTime: Scalars['DateTime'];
  fileName: Scalars['String'];
  startDateTime: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['String']>;
};


export type MutationDeviceEventExportArgs = {
  endDateTime: Scalars['DateTime'];
  fileName: Scalars['String'];
  intersectionId: Scalars['String'];
  rule?: InputMaybe<Scalars['String']>;
  startDateTime: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['String']>;
};


export type MutationDismissNotificationArgs = {
  id: Scalars['String'];
};


export type MutationDisplayTravelTimeMessagesArgs = {
  requests: Array<TravelTimeDisplayRequest>;
};


export type MutationDownloadDeviceDatabaseArgs = {
  comment?: InputMaybe<Scalars['String']>;
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
  tables?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationEnableCameraAutoFocusArgs = {
  cameraAutoFocusInput: CameraAutoFocusInput;
};


export type MutationEnableCameraAutoIrisArgs = {
  cameraAutoIrisInput: CameraAutoIrisInput;
};


export type MutationEnableIntegrationsArgs = {
  enabled: Scalars['Boolean'];
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationExecuteAssetWorkOrderTransactionArgs = {
  id: Scalars['ID'];
};


export type MutationExecuteDetectorEmailAlertSettingsArgs = {
  id: Scalars['ID'];
};


export type MutationExpireResourcesArgs = {
  id: Scalars['ID'];
  resources?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationExportActivityLogsArgs = {
  config: ExportConfig;
  filters: Array<FilterInput>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type MutationExportActivityLogsAndSendEmailArgs = {
  emailRecipients: Array<Scalars['String']>;
  fileName: Scalars['String'];
  filters: Array<FilterInput>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type MutationExportAlarmConfigsArgs = {
  query: AlarmConfigsQuery;
};


export type MutationExportAlarmsArgs = {
  customDataKeys?: InputMaybe<Array<Scalars['String']>>;
  fileName: Scalars['String'];
  query?: InputMaybe<AlarmsQuery>;
};


export type MutationExportAlarmsAndSendEmailArgs = {
  customDataKeys?: InputMaybe<Array<Scalars['String']>>;
  emailRecipients: Array<Scalars['String']>;
  fileName: Scalars['String'];
  query?: InputMaybe<AlarmsQuery>;
};


export type MutationExportAssetTemplateArgs = {
  reportPreference?: InputMaybe<ReportPreference>;
  types?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationExportAssetWorkOrdersArgs = {
  query?: InputMaybe<AssetWorkOrderInputQuery>;
};


export type MutationExportAssetsArgs = {
  query?: InputMaybe<AssetInputQuery>;
};


export type MutationExportCurrentHistoricalRatesArgs = {
  rate: Scalars['String'];
};


export type MutationExportDayWisePvrDetailsArgs = {
  query?: InputMaybe<DetectorVehicleQuery>;
  unitType?: InputMaybe<ConversionUnitType>;
};


export type MutationExportDetectorIntersectionReportArgs = {
  query?: InputMaybe<DetectorTurningReportQuery>;
};


export type MutationExportDirectoryToZipArgs = {
  destinationDirectory: Scalars['String'];
  inputDirectory: Scalars['String'];
  module: KineticModule;
  zipFileName: Scalars['String'];
};


export type MutationExportFileToManagedDirectoryArgs = {
  destinationDirectory: Scalars['String'];
  fileLocation: ExportFileInput;
};


export type MutationExportJsReportArgs = {
  directories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName: Scalars['String'];
  jsReportRequest: JsReportRequest;
  reportType: Scalars['String'];
};


export type MutationExportLocationTreeArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationExportMultipleDatabaseBinsArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  entityIds: Array<Scalars['String']>;
};


export type MutationExportMultipleFilesToZipArgs = {
  destinationDirectory: Scalars['String'];
  fileLocations: Array<ExportFileInput>;
  zipFileName: Scalars['String'];
};


export type MutationExportSingleDatabaseBinArgs = {
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationExportTurningReportArgs = {
  query?: InputMaybe<DetectorTurningReportQuery>;
};


export type MutationExtractZipArgs = {
  fileId: Scalars['ID'];
  path: Scalars['String'];
};


export type MutationFinalizeDraftDeviceDatabaseArgs = {
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationFinishResourcePlanTaskArgs = {
  id: Scalars['ID'];
};


export type MutationFinishSignalScheduledTaskArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
};


export type MutationFleetCheckInArgs = {
  shift: FleetShiftInput;
};


export type MutationFleetCheckOutArgs = {
  id: Scalars['ID'];
};


export type MutationFleetDeleteDriverArgs = {
  id: Scalars['ID'];
};


export type MutationFleetDeleteRouteArgs = {
  id: Scalars['ID'];
};


export type MutationFleetDeleteVehicleArgs = {
  id: Scalars['ID'];
};


export type MutationFleetDispatchArgs = {
  event: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationFleetDispatchAcceptArgs = {
  id: Scalars['ID'];
};


export type MutationFleetLogActivityArgs = {
  description: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationFleetSaveDispatchArgs = {
  dispatch: FleetDispatchInput;
};


export type MutationFleetSaveDriverArgs = {
  driver: FleetDriverInput;
};


export type MutationFleetSaveRouteArgs = {
  route: FleetRouteInput;
};


export type MutationFleetSaveVehicleArgs = {
  vehicle: FleetVehicleInput;
};


export type MutationFleetUpdateStatusArgs = {
  id: Scalars['ID'];
  status: FleetShiftStatus;
};


export type MutationFocusCameraArgs = {
  cameraFocusInput: CameraFocusInput;
};


export type MutationGateKineticControllerSetArmPositionArgs = {
  arms: Array<Scalars['Int']>;
  id: Scalars['ID'];
  position: GateArmPosition;
};


export type MutationGateOperationAbortArgs = {
  id: Scalars['ID'];
};


export type MutationGateOperationActivityArgs = {
  input: GateOperationActivityInput;
};


export type MutationGateOperationCreateArgs = {
  direction: GateDirection;
  id: Scalars['ID'];
  type: GateOperationType;
};


export type MutationGateOperationFinishArgs = {
  id: Scalars['ID'];
};


export type MutationGateOperationInitiateArgs = {
  id: Scalars['ID'];
  operationId: Scalars['ID'];
};


export type MutationGateOperationLogInArgs = {
  id: Scalars['ID'];
};


export type MutationGateOperationNextStepArgs = {
  id: Scalars['ID'];
};


export type MutationGateOperationSelectStepArgs = {
  id: Scalars['ID'];
  stepId: Scalars['ID'];
};


export type MutationGateOperationSkipStepArgs = {
  id: Scalars['ID'];
  stepId: Scalars['ID'];
};


export type MutationGenerateCsvArgs = {
  report: ReportDto;
};


export type MutationGenerateDetectorTmasReportArgs = {
  query?: InputMaybe<DetectorTmasReportQuery>;
};


export type MutationGenerateDeviceDatabaseReportExportsArgs = {
  databaseId: Scalars['String'];
  excludeDefaults?: InputMaybe<Scalars['Boolean']>;
  excludeZeros?: InputMaybe<Scalars['Boolean']>;
  exportReportTypes: Array<ExportReportType>;
  intersectionId: Scalars['String'];
  tableNames: Array<Scalars['String']>;
};


export type MutationGenerateFileTokenUrlArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationGenerateIntersectionStatusReportArgs = {
  columns?: InputMaybe<Array<Scalars['String']>>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type MutationGenerateMultiDatabaseReportExportsArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  entityIds: Array<Scalars['String']>;
  exportReportTypes: Array<ExportReportType>;
  reportProtocolInputs: Array<DatabaseReportProtocolInput>;
};


export type MutationGenerateMultiReportExportsArgs = {
  compressedReportCollection?: InputMaybe<Scalars['String']>;
  directoryId: Scalars['String'];
  exportTypes: Array<ExportReportType>;
  reportCollection?: InputMaybe<ExportReportCollection>;
  userId: Scalars['String'];
};


export type MutationGenerateRecordingTokenUrlArgs = {
  id: Scalars['ID'];
};


export type MutationGenerateReportExportArgs = {
  compressedReport?: InputMaybe<Scalars['String']>;
  directoryId: Scalars['String'];
  exportTypes: Array<ExportReportType>;
  report?: InputMaybe<ExportReport>;
  userId: Scalars['String'];
};


export type MutationGenerateTokenZipArgs = {
  idToken: Scalars['String'];
  refreshToken: Scalars['String'];
};


export type MutationGetSpreadSheetDataArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  headerRowIndex: Scalars['Int'];
  id: Scalars['ID'];
  module: KineticModule;
};


export type MutationGotoPresetArgs = {
  cameraGotoPresetInput: CameraGotoPresetInput;
};


export type MutationHarDeleteMessageArgs = {
  id: Scalars['ID'];
};


export type MutationHarDeletePlaylistArgs = {
  id: Scalars['ID'];
};


export type MutationHarDeletePriorityArgs = {
  id: Scalars['ID'];
};


export type MutationHarSaveMessageArgs = {
  input: HarMessageInput;
};


export type MutationHarSaveModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationHarSavePlaylistArgs = {
  input: HarPlaylistInput;
};


export type MutationHarSavePriorityArgs = {
  input: HarPriorityInput;
};


export type MutationHarTransmitterBlankArgs = {
  transmitters: Array<Scalars['ID']>;
};


export type MutationHarTransmitterExtendPlaylistArgs = {
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  playlists: Array<Scalars['ID']>;
  transmitter: Scalars['ID'];
};


export type MutationHarTransmitterPollArgs = {
  transmitters: Array<Scalars['ID']>;
};


export type MutationHarTransmitterPostPlaylistArgs = {
  post: Array<HarTransmitterPostInput>;
};


export type MutationHarTransmitterRemovePlaylistArgs = {
  playlists: Array<Scalars['ID']>;
  transmitter: Scalars['ID'];
};


export type MutationHarTransmitterSetAttenuatorLevelArgs = {
  level: Scalars['Int'];
  transmitter: Scalars['ID'];
};


export type MutationHarTransmitterSetPowerLevelArgs = {
  level: Scalars['Int'];
  transmitter: Scalars['ID'];
};


export type MutationHarTransmitterSetVoiceSpeedArgs = {
  speed: Scalars['Int'];
  transmitter: Scalars['ID'];
};


export type MutationHarTransmitterSetWeatherRadioArgs = {
  enabled: Scalars['Boolean'];
  transmitter: Scalars['ID'];
};


export type MutationIgnoreDetectionsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationImportAssetsArgs = {
  fileId: Scalars['String'];
};


export type MutationImportDataSourcesArgs = {
  input: ImportDataSources;
};


export type MutationImportDetectorVehiclesDataArgs = {
  dateFormat: Scalars['String'];
  fileIds: Array<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationImportFormFieldsArgs = {
  input: Array<Scalars['Object']>;
};


export type MutationImportFormsArgs = {
  input: Array<Scalars['Object']>;
};


export type MutationImportIntegrationsFromJsonArgs = {
  input: Scalars['String'];
};


export type MutationImportLocationsArgs = {
  fileIds: Array<Scalars['ID']>;
  fileType: LocationImportFileType;
  locationType: Scalars['String'];
};


export type MutationIrisCameraArgs = {
  cameraIrisInput: CameraIrisInput;
};


export type MutationKineticTransmitterAttenuatorLevelArgs = {
  id: Scalars['ID'];
  level: Scalars['Int'];
};


export type MutationKineticTransmitterBlankArgs = {
  id: Scalars['ID'];
};


export type MutationKineticTransmitterPostArgs = {
  id: Scalars['ID'];
  playlist: KineticTransmitterPlaylistInput;
};


export type MutationKineticTransmitterPowerLevelArgs = {
  id: Scalars['ID'];
  level: Scalars['Int'];
};


export type MutationKineticTransmitterVoiceSpeedArgs = {
  id: Scalars['ID'];
  speed: Scalars['Int'];
};


export type MutationKineticTransmitterWeatherRadioArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationLinkEventArgs = {
  eventId: Scalars['ID'];
  link: EventLinkInput;
};


export type MutationLockDatabaseArgs = {
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationLockLiveDatabaseArgs = {
  intersectionId: Scalars['String'];
};


export type MutationManageGateSystemArgs = {
  id: Scalars['ID'];
  operation: Scalars['ID'];
};


export type MutationMarkDetectionAsExaminedArgs = {
  detectionId: Scalars['ID'];
};


export type MutationMoveFileArgs = {
  destinationDirectoryId: Scalars['String'];
  fileId: Scalars['String'];
};


export type MutationMoveLocationGroupsArgs = {
  input: Array<MoveLocationGroupInput>;
};


export type MutationMoveLocationsArgs = {
  input: Array<MoveLocationInput>;
};


export type MutationMultiplePollArgs = {
  ids: Array<Scalars['ID']>;
  integrationType: IntegrationType;
};


export type MutationOpenInboundGatesArgs = {
  id: Scalars['ID'];
  manualOperation?: InputMaybe<Scalars['Boolean']>;
  requestId?: InputMaybe<Scalars['String']>;
  systemId: Scalars['ID'];
};


export type MutationOpenOutboundGatesArgs = {
  id: Scalars['ID'];
  manualOperation?: InputMaybe<Scalars['Boolean']>;
  requestId?: InputMaybe<Scalars['String']>;
  systemId: Scalars['ID'];
};


export type MutationPanTiltCameraArgs = {
  cameraPanTiltInput: CameraPanTiltInput;
};


export type MutationParkingAreaBlankMessageArgs = {
  id: Scalars['ID'];
  signs: Array<Scalars['ID']>;
};


export type MutationParkingAreaDeleteMessageArgs = {
  id: Scalars['ID'];
};


export type MutationParkingAreaPostMessageArgs = {
  messages: Array<ParkingPostRequest>;
};


export type MutationParkingAreaSaveMessageArgs = {
  message: ParkingAreaMessageInput;
};


export type MutationPublicStreamFileArgs = {
  cameraId: Scalars['String'];
  connect: Scalars['Boolean'];
  streamManagerId: Scalars['String'];
};


export type MutationPublicStreamTargetArgs = {
  cameraId: Scalars['String'];
  enable: Scalars['Boolean'];
  streamManagerId: Scalars['String'];
};


export type MutationReValidateDetectorPvrArgs = {
  query?: InputMaybe<ReValidateDetectorPvrQuery>;
};


export type MutationRefreshTollingPointLinkStatusArgs = {
  id: Scalars['ID'];
};


export type MutationRejectDeviceDatabaseValidationArgs = {
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationRejectDispatchRequestArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationRejectEventArgs = {
  id: Scalars['ID'];
  rejectionReasons: Array<Scalars['String']>;
};


export type MutationRejectGateOperationArgs = {
  id: Scalars['ID'];
};


export type MutationRejectInterlockOverrideArgs = {
  approvalId: Scalars['ID'];
};


export type MutationRemoveAssociatedCommLogsFromEventArgs = {
  commLogIds: Array<Scalars['ID']>;
  eventId: Scalars['ID'];
  internalCall?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveAssociatedCommLogsFromEventsArgs = {
  commLogIds: Array<Scalars['ID']>;
  eventIds: Array<Scalars['ID']>;
  internalCall?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveAssociatedDetectionsFromAllEventsArgs = {
  detectionId: Array<Scalars['ID']>;
};


export type MutationRemoveAssociatedDetectionsFromEventArgs = {
  detectionIds: Array<Scalars['ID']>;
  eventId: Scalars['ID'];
  internalCall?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveAssociatedDetectionsFromEventsArgs = {
  detectionIds: Array<Scalars['ID']>;
  eventIds: Array<Scalars['ID']>;
  internalCall?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveAssociatedEventsFromAllCommLogsArgs = {
  eventIds: Array<Scalars['ID']>;
};


export type MutationRemoveAssociatedEventsFromAllDetectionsArgs = {
  eventIds: Array<Scalars['ID']>;
};


export type MutationRemoveAssociatedEventsFromCommLogsArgs = {
  commLogIds: Array<Scalars['ID']>;
  eventIds: Array<Scalars['ID']>;
  internalCall?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveAssociatedEventsFromDetectionsArgs = {
  detectionIds: Array<Scalars['ID']>;
  eventIds: Array<Scalars['ID']>;
  internalCall?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveAssociationsArgs = {
  associationId: Scalars['ID'];
  signs: Array<Scalars['ID']>;
};


export type MutationRemovePartialOrganizationPreferenceArgs = {
  key: Scalars['ID'];
  valueId?: InputMaybe<Scalars['String']>;
};


export type MutationRemovePartialUserPreferenceArgs = {
  key: Scalars['ID'];
  valueId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveQueuedMessagesArgs = {
  id: Scalars['ID'];
  queuedMessages: Array<Scalars['ID']>;
};


export type MutationRemoveTravelTimeMessagesArgs = {
  requests: Array<Scalars['ID']>;
};


export type MutationRemoveUserArgs = {
  id: Scalars['ID'];
};


export type MutationReorderCameraGroupsArgs = {
  groups: Array<CameraGroupOrderInput>;
};


export type MutationReorderScreensArgs = {
  screens: Array<ScreenOrderInput>;
};


export type MutationReportBuilderBlockDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationReportBuilderBlockPreviewArgs = {
  input: ReportBuilderBlockInput;
  params?: InputMaybe<Scalars['Object']>;
};


export type MutationReportBuilderBlockSaveArgs = {
  input: ReportBuilderBlockInput;
};


export type MutationReportBuilderDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationReportBuilderExportArgs = {
  id: Scalars['ID'];
};


export type MutationReportBuilderPreviewArgs = {
  id: Scalars['ID'];
};


export type MutationReportBuilderSaveArgs = {
  input: ReportBuilderInput;
};


export type MutationReportBuilderTaskCancelArgs = {
  date: Scalars['DateTime'];
  id: Scalars['ID'];
};


export type MutationReportBuilderTaskDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationReportBuilderTaskSaveArgs = {
  input: TaskInput;
};


export type MutationRequestInterlockOverrideArgs = {
  activatePlan?: InputMaybe<Scalars['Boolean']>;
  input: Array<SignInterlockInput>;
  resourcePlanIds?: InputMaybe<Array<Scalars['String']>>;
  resourcePlanNames?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationResetDetectorCacheArgs = {
  id: Scalars['String'];
};


export type MutationResetDetectorPerformanceReportArgs = {
  query?: InputMaybe<DetectorPerformanceReportQuery>;
};


export type MutationResetEventConfirmationRequiredArgs = {
  id: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  id: Scalars['ID'];
  newPassword: Scalars['String'];
};


export type MutationReverseAlertDirectionArgs = {
  id: Scalars['ID'];
};


export type MutationReverseDetectorDirectionArgs = {
  id: Scalars['ID'];
};


export type MutationRevertAssetWorkOrderTransactionArgs = {
  id: Scalars['ID'];
};


export type MutationSaveActionSetResponseRuleArgs = {
  input: ActionSetRuleInput;
};


export type MutationSaveActivationConfirmationArgs = {
  confirmationRequired: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationSaveAlarmConfigArgs = {
  input: AlarmConfigInput;
};


export type MutationSaveAlarmConfigsArgs = {
  input: Array<AlarmConfigInput>;
};


export type MutationSaveAndCloseEventArgs = {
  closureResolution?: InputMaybe<Scalars['String']>;
  input: EventInput;
  lanesClear?: InputMaybe<Scalars['DateTime']>;
  sceneClear?: InputMaybe<Scalars['DateTime']>;
};


export type MutationSaveAssetArgs = {
  input: AssetInput;
};


export type MutationSaveAssetWorkOrderArgs = {
  input: AssetWorkOrderInput;
};


export type MutationSaveAssetWorkOrderCommentArgs = {
  input: AssetWorkOrderCommentInput;
};


export type MutationSaveAssetWorkOrderFlagArgs = {
  input: AssetWorkOrderFlagInput;
};


export type MutationSaveAssetWorkOrderLinkArgs = {
  input: AssetWorkOrderLinkInput;
};


export type MutationSaveAssetWorkOrderStepAssignmentsArgs = {
  inputs: Array<AssetWorkOrderAssignmentsInput>;
};


export type MutationSaveAssetWorkOrderSubStepArgs = {
  input: AssetWorkOrderSubStepInput;
};


export type MutationSaveAssetWorkOrderTrackingArgs = {
  input: AssetWorkOrderTrackingInput;
};


export type MutationSaveAssetWorkOrderTransactionArgs = {
  input: AssetTransactionInput;
};


export type MutationSaveAtlasArchiveModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveCameraGroupArgs = {
  input: CameraGroupInput;
};


export type MutationSaveCameraPresetArgs = {
  id: Scalars['String'];
  presetId: Scalars['String'];
  presetNumber: Scalars['Int'];
};


export type MutationSaveCentralAuthPinSettingsArgs = {
  pin: Scalars['String'];
};


export type MutationSaveCommunicationLogArgs = {
  input: CommunicationLogInput;
};


export type MutationSaveConnectedVehicleCommentArgs = {
  comment: Scalars['String'];
  connectedVehicleId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationSaveContactArgs = {
  contact: ContactInput;
};


export type MutationSaveContactGroupArgs = {
  contactGroup: ContactGroupInput;
};


export type MutationSaveCorridorRuleArgs = {
  input: CorridorRuleInput;
};


export type MutationSaveCountsModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveDataSourceArgs = {
  input: DataSourceInput;
};


export type MutationSaveDataSourceConfigArgs = {
  input: DataSourceConfigInput;
};


export type MutationSaveDatabaseExportTemplateArgs = {
  input: DatabaseExportTemplateInput;
};


export type MutationSaveDetectorConfigArgs = {
  input?: InputMaybe<SaveDetectorConfigInput>;
};


export type MutationSaveDetectorConnectionLogArgs = {
  input?: InputMaybe<SaveDetectorConnectionLogInput>;
};


export type MutationSaveDetectorEmailAlertSettingArgs = {
  input?: InputMaybe<DetectorEmailAlertSettingInput>;
};


export type MutationSaveDetectorExtraConfigArgs = {
  input?: InputMaybe<SaveDetectorExtraConfigInput>;
};


export type MutationSaveDetectorGroupArgs = {
  input: DetectorGroupInput;
};


export type MutationSaveDetectorReportConfigurationArgs = {
  input?: InputMaybe<DetectorReportConfigurationInput>;
};


export type MutationSaveDetectorReportRuleArgs = {
  input?: InputMaybe<DetectorReportRuleInput>;
};


export type MutationSaveEmailRuleArgs = {
  emailRule: EmailRuleInput;
};


export type MutationSaveEmailServerSettingsArgs = {
  settings: EmailServerSettingsInput;
};


export type MutationSaveEmailTemplateArgs = {
  template: EmailTemplateInput;
};


export type MutationSaveEntityWorkOrderArgs = {
  input: EntityWorkOrderInput;
};


export type MutationSaveEventArgs = {
  input: EventInput;
};


export type MutationSaveEventNoteArgs = {
  content: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationSaveEventTemplateArgs = {
  input: EventTemplateInput;
};


export type MutationSaveEventTypeArgs = {
  input: EventTypeInput;
};


export type MutationSaveEventsModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveGateControllerSignMessageArgs = {
  input: GateControllerSignMessageInput;
};


export type MutationSaveGateControllerSystemArgs = {
  input: GateControllerSystemInput;
};


export type MutationSaveGateModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveHiTracLogPacketsArgs = {
  input?: InputMaybe<SaveHiTracLogPacketsInput>;
};


export type MutationSaveHiTracVehiclePacketsArgs = {
  input?: InputMaybe<SaveHiTracVehiclePacketsInput>;
};


export type MutationSaveIntegrationArgs = {
  input: IntegrationsInput;
};


export type MutationSaveIntegrationGroupArgs = {
  input?: InputMaybe<IntegrationGroupInput>;
};


export type MutationSaveIntegrationsArgs = {
  input: Array<IntegrationsInput>;
};


export type MutationSaveIntersectionArgs = {
  intersectionInput?: InputMaybe<IntersectionInput>;
};


export type MutationSaveIntersectionTemplateArgs = {
  input: IntersectionTemplateInput;
};


export type MutationSaveKineticAuthSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveKineticFormArgs = {
  form?: InputMaybe<KineticFormInput>;
};


export type MutationSaveKineticFormFieldArgs = {
  field?: InputMaybe<KineticFormFieldInput>;
};


export type MutationSaveKineticUserPreferenceArgs = {
  key: Scalars['ID'];
  value: Scalars['JSON'];
};


export type MutationSaveLaneControlSettingsArgs = {
  input: LaneControlSettingsInput;
};


export type MutationSaveLicenseArgs = {
  key: Scalars['String'];
};


export type MutationSaveLocationArgs = {
  locationInput: LocationInput;
};


export type MutationSaveLocationCommentArgs = {
  comment: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  locationId: Scalars['ID'];
};


export type MutationSaveLocationCorridorArgs = {
  input: LocationCorridorInput;
};


export type MutationSaveLocationCorridorLegArgs = {
  input: LocationCorridorLegInput;
};


export type MutationSaveLocationCorridorLinkArgs = {
  input: LocationCorridorLinkInput;
};


export type MutationSaveLocationGroupsArgs = {
  input: Array<LocationGroupInput>;
};


export type MutationSaveLocationLinkArgs = {
  link: LocationExternalLinkInput;
};


export type MutationSaveLocationTemplateArgs = {
  input: LocationTemplateInput;
};


export type MutationSaveMapConfigArgs = {
  config: MapConfigInput;
};


export type MutationSaveMapLayerConfigArgs = {
  config: MapLayerConfigInput;
};


export type MutationSaveMibAlarmConfigArgs = {
  input: MibAlarmConfigInput;
};


export type MutationSaveMibAlarmConfigsArgs = {
  input: Array<MibAlarmConfigInput>;
};


export type MutationSaveModuleMapSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveNotificationArgs = {
  notificationInput?: InputMaybe<NotificationInput>;
};


export type MutationSaveNotificationPreferencesArgs = {
  notificationPreferences?: InputMaybe<NotificationPreferenceInput>;
};


export type MutationSaveOrganizationArgs = {
  organization?: InputMaybe<KineticOrganizationInput>;
};


export type MutationSaveOrganizationContactArgs = {
  organization: OrganizationInput;
};


export type MutationSaveOrganizationPreferenceArgs = {
  key: Scalars['ID'];
  value: Scalars['JSON'];
};


export type MutationSavePresetArgs = {
  input: PresetInput;
};


export type MutationSaveRampMeterArgs = {
  intersectionInput?: InputMaybe<IntersectionInput>;
};


export type MutationSaveResourcePlanArgs = {
  input: ResourcePlanInput;
};


export type MutationSaveResourcePlanTaskArgs = {
  input: TaskInput;
};


export type MutationSaveResourcesArgs = {
  id: Scalars['ID'];
  resources: Array<ResourceInput>;
};


export type MutationSaveResponseModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveResponseRuleArgs = {
  input: ResponseRuleInput;
};


export type MutationSaveRoleArgs = {
  role?: InputMaybe<KineticRoleInput>;
};


export type MutationSaveRouteArgs = {
  input: LocationRouteInput;
};


export type MutationSaveSceneArgs = {
  input: SceneInput;
};


export type MutationSaveScheduledEventTaskArgs = {
  input: TaskInput;
};


export type MutationSaveScreenArgs = {
  input: ScreenInput;
};


export type MutationSaveShiftNotesArgs = {
  id: Scalars['ID'];
  shiftNotes: Scalars['String'];
};


export type MutationSaveSignCutoutArgs = {
  input: SignCutoutInput;
};


export type MutationSaveSignGantryArgs = {
  input: SignGantryInput;
};


export type MutationSaveSignMessageArgs = {
  input: SignLibraryMessageInput;
};


export type MutationSaveSignMessagePriorityArgs = {
  input: SignMessagePriorityInput;
};


export type MutationSaveSignModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveSignResponseRuleArgs = {
  input: SignResponseRuleInput;
};


export type MutationSaveSignalActionSetArgs = {
  input: SignalActionSetInput;
};


export type MutationSaveSignalDetectorGroupArgs = {
  input: SignalDetectorGroupInput;
};


export type MutationSaveSignalModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveSignalScheduledTaskArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  input: TaskInput;
  intersectionType?: InputMaybe<IntersectionType>;
};


export type MutationSaveSystemDirectoriesArgs = {
  input: Array<DirectoryInput>;
  removedDirectories: Array<Scalars['String']>;
};


export type MutationSaveTaskArgs = {
  input: TaskInput;
};


export type MutationSaveTimeDriftSettingsArgs = {
  input: TimeDriftSettingsInput;
};


export type MutationSaveTollingModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveTollingSegmentCommentArgs = {
  commentInput: BasicCommentInput;
};


export type MutationSaveTourArgs = {
  input: TourInput;
};


export type MutationSaveTrafficResponsivePlanArgs = {
  input: TrafficResponsivePlanInput;
};


export type MutationSaveTravelTimeModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveTunnelLogArgs = {
  input: TunnelLogInput;
};


export type MutationSaveUserDirectoriesArgs = {
  input: Array<DirectoryInput>;
  removedDirectories: Array<Scalars['String']>;
};


export type MutationSaveUserGroupArgs = {
  userGroup: KineticUserGroupInput;
};


export type MutationSaveUserPreferenceArgs = {
  key: Scalars['ID'];
  value: Scalars['JSON'];
};


export type MutationSaveVideoModuleSettingsArgs = {
  settings: Scalars['JSON'];
};


export type MutationSaveWidgetArgs = {
  input: WidgetInput;
};


export type MutationSaveWorkOrderConfigurationArgs = {
  input: WorkOrderConfigInput;
};


export type MutationSendEmailArgs = {
  message: EmailMessage;
};


export type MutationSetActiveHardwareScreenArgs = {
  id: Scalars['String'];
};


export type MutationSetAlarmAcknowledgeStateArgs = {
  acknowledge?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSetAsHomePresetArgs = {
  homePresetInput: HomePresetInput;
};


export type MutationSetDatabaseMibsArgs = {
  comment?: InputMaybe<Scalars['String']>;
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
  mibs: Array<DatabaseMibValue>;
};


export type MutationSetDefaultColorArgs = {
  color: Scalars['String'];
  id: Scalars['ID'];
  isBackground: Scalars['Boolean'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type MutationSetFiveOneOneSubmittedArgs = {
  id: Scalars['ID'];
};


export type MutationSetSignLaneControlSettingsArgs = {
  id: Scalars['ID'];
  signId: Scalars['ID'];
};


export type MutationSetSignalMibsArgs = {
  comment?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  mibs: Array<MibValue>;
};


export type MutationSetTimeNowArgs = {
  deviceId: Scalars['ID'];
};


export type MutationSignBlankArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationSignBrightnessArgs = {
  brightness?: InputMaybe<Scalars['Int']>;
  brightnessMode: SignBrightnessMode;
  id: Scalars['ID'];
};


export type MutationSignCapabilitiesArgs = {
  id: Scalars['ID'];
};


export type MutationSignDeleteCommandArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  slot: Scalars['Int'];
};


export type MutationSignDeleteGroupArgs = {
  id: Scalars['ID'];
};


export type MutationSignDisplayArgs = {
  requests: Array<SignMessageDisplayRequest>;
};


export type MutationSignEnableDisableDefaultMessageArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationSignExtendArgs = {
  expirationTime: Scalars['DateTime'];
  id: Scalars['ID'];
};


export type MutationSignFanTestArgs = {
  id: Scalars['ID'];
};


export type MutationSignFontsArgs = {
  id: Scalars['ID'];
};


export type MutationSignInterlockAcknowledgeArgs = {
  input: Array<SignInterlockInput>;
  resourcePlanIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSignLampTestArgs = {
  id: Scalars['ID'];
};


export type MutationSignLaneControlDisplayArgs = {
  requests: Array<SignLaneControlDisplayRequest>;
};


export type MutationSignPixelTestArgs = {
  id: Scalars['ID'];
};


export type MutationSignPollArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationSignResetArgs = {
  id: Scalars['ID'];
};


export type MutationSignSaveFontArgs = {
  font: SignFontInput;
};


export type MutationSignSaveGroupArgs = {
  input: SignGroupInput;
};


export type MutationSignSetCommandMessagePriorityArgs = {
  id: Scalars['ID'];
  priority: Scalars['Int'];
  slot: Scalars['Int'];
};


export type MutationSignSetCommandsArgs = {
  commands: Array<SignCommandNumberInput>;
  id: Scalars['ID'];
};


export type MutationSignSetDefaultFontArgs = {
  hash: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationSignSetDefaultMessageArgs = {
  requests: Array<SignMessageDisplayRequest>;
};


export type MutationSignSetFontsArgs = {
  fontNumbers: Array<SignFontNumberInput>;
  id: Scalars['ID'];
};


export type MutationSignSetGraphicLabelsArgs = {
  id: Scalars['ID'];
  labels: Array<SignGraphicLabelInput>;
};


export type MutationSignSetMessagePreferencesArgs = {
  id: Scalars['ID'];
  preference?: InputMaybe<Scalars['ID']>;
};


export type MutationSignSetSpeedSettingsArgs = {
  id: Scalars['ID'];
  settings: SignSpeedSettingsInput;
};


export type MutationSignUploadAllGraphicsArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type MutationSignUploadAllMessagesArgs = {
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
};


export type MutationSignUploadMessageArgs = {
  id: Scalars['ID'];
  message: SignMessageInput;
  requestId?: InputMaybe<Scalars['String']>;
  slot: Scalars['Int'];
};


export type MutationSnoozeNotificationArgs = {
  duration: Scalars['Int'];
  id: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
};


export type MutationSplitMonitorExportArgs = {
  endDateTime: Scalars['DateTime'];
  fileName: Scalars['String'];
  intersectionId: Scalars['String'];
  reportType: QFreeSplitMonitorReportType;
  startDateTime: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['String']>;
};


export type MutationSubscribeMibsArgs = {
  id: Scalars['String'];
  mibs: Array<MibWithIndexes>;
  onDemand?: InputMaybe<Scalars['Boolean']>;
  requestId?: InputMaybe<Scalars['String']>;
};


export type MutationSynchroExportArgs = {
  databasePatterns: Array<DatabasePatternIdExport>;
  filename: Scalars['String'];
  format: SynchroExportFormat;
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type MutationToggleGateRestrictionBypassArgs = {
  id: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationToggleGateSafeReversalTimeArgs = {
  id: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationTollingRoadDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationTollingRoadSaveArgs = {
  input: TollingRoadInput;
};


export type MutationTollingSegmentDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationTollingSegmentSaveArgs = {
  input: TollingSegmentInput;
};


export type MutationTourHeartBeatArgs = {
  tourId: Scalars['ID'];
};


export type MutationTravelTimeSegmentPollArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationTriggerResourcePlanRulesArgs = {
  id: Scalars['ID'];
};


export type MutationUnDismissNotificationArgs = {
  id: Scalars['String'];
};


export type MutationUnblockVideoStreamArgs = {
  input: UnblockVideoStreamInput;
};


export type MutationUnlinkEventArgs = {
  eventId: Scalars['ID'];
  linkId: Scalars['ID'];
};


export type MutationUnlockDatabaseArgs = {
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationUnlockLiveDatabaseArgs = {
  intersectionId: Scalars['String'];
};


export type MutationUnlockPtzCameraArgs = {
  cameraId: Scalars['ID'];
};


export type MutationUnmanageGateSystemArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAlarmCommentsArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};


export type MutationUpdateCameraDetectionStatusArgs = {
  cameraId: Scalars['ID'];
  enable: Scalars['Boolean'];
};


export type MutationUpdateDefaultDetectorReportConfigurationArgs = {
  id: Scalars['ID'];
  selection?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateDetectorEmailAlertSettingStatusArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateDetectorVehicleAiClassNameArgs = {
  className?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDetectorVehicleAiVerificationStatusArgs = {
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateDetectorVehicleRecordTagsArgs = {
  id: Scalars['String'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationUpdateDetectorVehicleVerifiedClassNameArgs = {
  classIndex: Scalars['Int'];
  id: Scalars['String'];
};


export type MutationUpdateDetectorVehicleVerifiedClassNameStatusArgs = {
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateDetectorVehicleVolumeIntervalCountsArgs = {
  query?: InputMaybe<DetectorVehicleVolumeIntervalCountsClearQuery>;
};


export type MutationUpdateDeviceDatabasesArchiveFlagArgs = {
  archive: Scalars['Boolean'];
  databaseIds: Array<Scalars['String']>;
  intersectionId: Scalars['String'];
};


export type MutationUpdateIntegrationLocationArgs = {
  integrationId: Scalars['ID'];
  locationId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateIntegrationSettingsArgs = {
  integrationId: Scalars['ID'];
  settings: Scalars['JSON'];
};


export type MutationUpdateNetworkConditionsArgs = {
  conditions: Array<Scalars['String']>;
  id: Scalars['ID'];
  networkConditions: Array<Scalars['String']>;
  status: Scalars['String'];
};


export type MutationUpdateNetworkJurisdictionArgs = {
  id: Scalars['ID'];
  networkJurisdiction: NetworkJurisdictionInput;
};


export type MutationUpdatePartialOrganizationPreferenceArgs = {
  key: Scalars['ID'];
  value: Scalars['JSON'];
};


export type MutationUpdatePartialUserPreferenceArgs = {
  key: Scalars['ID'];
  value: Scalars['JSON'];
};


export type MutationUpdateQueuedMessageArgs = {
  id: Scalars['ID'];
  queuedMessage: SignQueuedMessageInput;
};


export type MutationUpdateUserPrivilegesArgs = {
  user: KineticUserPrivilegeAssignmentInput;
};


export type MutationUseCameraCapabilityArgs = {
  cameraId: Scalars['ID'];
  capability: CameraCapability;
  option: Scalars['String'];
};


export type MutationValidateDeviceDatabaseArgs = {
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
};


export type MutationWeatherStationPollArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationZoomCameraArgs = {
  cameraZoomInput: CameraZoomInput;
};

export type NetworkCondition = {
  __typename?: 'NetworkCondition';
  /**  the classification of the network  */
  classification: Scalars['String'];
  /**  the direction of the route  */
  direction: Direction;
  /**  identifier of the event  */
  event: Scalars['ID'];
  /**  identifier  */
  id: Scalars['String'];
  /**  the jurisdiction of the route  */
  jurisdiction: Scalars['String'];
  /**  the last time the segment was updated  */
  lastUpdated: Scalars['DateTime'];
  /**  the last updated by user  */
  lastUpdatedBy: Scalars['String'];
  /**  the user name of the last updated user  */
  lastUpdatedByDisplayName: Scalars['String'];
  /**  the road name  */
  road: Scalars['String'];
  /**  the list of segments for the network  */
  segments: Array<NetworkConditionSegment>;
};

export type NetworkConditionConnection = {
  __typename?: 'NetworkConditionConnection';
  /**  connection edges  */
  edges: Array<NetworkConditionConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type NetworkConditionConnectionEdge = {
  __typename?: 'NetworkConditionConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: NetworkCondition;
};

export type NetworkConditionInput = {
  /**  The area name  */
  area: Scalars['String'];
  /**  area type  */
  areaType: Scalars['String'];
  /**  The classification of the route  */
  classification: Scalars['String'];
  /**  The direction of the route  */
  direction: Scalars['String'];
  /**  the end landmark  */
  endLandmark?: InputMaybe<Scalars['String']>;
  /**  The end measure of the segment  */
  endMeasure: Scalars['Float'];
  /**  The name of the route ex: I-70  */
  name: Scalars['String'];
  /**  The native id of the route */
  routeNativeId: Scalars['String'];
  /**  the start landmark  */
  startLandmark?: InputMaybe<Scalars['String']>;
  /**  The start measure of the segment  */
  startMeasure: Scalars['Float'];
};

export type NetworkConditionInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter events */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type NetworkConditionSegment = {
  __typename?: 'NetworkConditionSegment';
  /**  the list of current conditions  */
  conditions: Array<Scalars['String']>;
  /**  the custom 511 text  */
  customText?: Maybe<Scalars['String']>;
  /**  the end landmark  */
  endLandmark?: Maybe<Scalars['String']>;
  /**  the end reference  */
  endMeasure: Scalars['Float'];
  /**  the geometry of the segment  */
  geometry?: Maybe<Scalars['Object']>;
  /**  the public 511 text  */
  publicText?: Maybe<Scalars['String']>;
  /**  the start landmark  */
  startLandmark?: Maybe<Scalars['String']>;
  /**  the start reference  */
  startMeasure: Scalars['Float'];
  /**  the segment status  */
  status: Scalars['String'];
};

export type NetworkJurisdiction = {
  __typename?: 'NetworkJurisdiction';
  /**  jurisdiction attributes  */
  attributes: Scalars['Object'];
  /**  list of conditions  */
  conditions: Array<Scalars['String']>;
  /**  event identifier  */
  event: Scalars['String'];
  /**  the geometry of the jurisdiction  */
  geometry?: Maybe<Scalars['Object']>;
  /**  identifier  */
  id: Scalars['String'];
  /**  last updated  */
  lastUpdated: Scalars['DateTime'];
  /**  last updated user  */
  lastUpdatedBy: Scalars['ID'];
  /**  last updated display name  */
  lastUpdatedByDisplayName: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
  /**  status  */
  status: Scalars['String'];
  /**  type  */
  type: Scalars['String'];
};

export type NetworkJurisdictionConnection = {
  __typename?: 'NetworkJurisdictionConnection';
  /**  connection edges  */
  edges: Array<NetworkJurisdictionConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type NetworkJurisdictionConnectionEdge = {
  __typename?: 'NetworkJurisdictionConnectionEdge';
  /**  node cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  connection edge node  */
  node: NetworkJurisdiction;
};

export type NetworkJurisdictionInput = {
  /**  jurisdiction attributes  */
  attributes: Scalars['Object'];
  /**  list of conditions  */
  conditions: Array<Scalars['String']>;
  /**  event identifier  */
  event: Scalars['String'];
  /**  identifier  */
  id: Scalars['String'];
  /**  name  */
  name: Scalars['String'];
  /**  status  */
  status: Scalars['String'];
  /**  type  */
  type: Scalars['String'];
};

export type NetworkJurisdictionInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter events */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type Notification = {
  __typename?: 'Notification';
  acknowledgedBy?: Maybe<Scalars['String']>;
  acknowledgedByName?: Maybe<Scalars['String']>;
  acknowledgedNotes?: Maybe<Scalars['String']>;
  acknowledgedTime?: Maybe<Scalars['DateTime']>;
  actions?: Maybe<Array<Maybe<Action>>>;
  audibleAlarm?: Maybe<Scalars['Boolean']>;
  createdTime?: Maybe<Scalars['DateTime']>;
  /**  Notification data  */
  data: Scalars['JSON'];
  details?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ignorable?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['JSON']>;
  nonDismissible?: Maybe<Scalars['Boolean']>;
  objectId?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  severity?: Maybe<NotificationSeverity>;
  snoozeDurationInMinutes?: Maybe<Scalars['Int']>;
  snoozeMessage?: Maybe<Scalars['String']>;
  snoozed?: Maybe<Scalars['Boolean']>;
  snoozedAt?: Maybe<Scalars['DateTime']>;
  soundFile?: Maybe<Scalars['String']>;
  source: KineticModule;
  status?: Maybe<NotificationStatus>;
  systemNotification?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updatedTS?: Maybe<Scalars['DateTime']>;
  urgentNotification?: Maybe<Scalars['Boolean']>;
  userIds: Array<Maybe<Scalars['String']>>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type NotificationConnectionEdge = {
  __typename?: 'NotificationConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Notification;
};

export type NotificationInput = {
  actions?: InputMaybe<Array<InputMaybe<ActionInput>>>;
  /**  Notification data  */
  data: Scalars['JSON'];
  id?: InputMaybe<Scalars['String']>;
  ignorable?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['JSON']>;
  objectId?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<NotificationSeverity>;
  source: KineticModule;
  systemNotification?: InputMaybe<Scalars['Boolean']>;
  translationDetails: NotificationTranslationDetailsInput;
  updatedTS?: InputMaybe<Scalars['DateTime']>;
  urgentNotification?: InputMaybe<Scalars['Boolean']>;
  userIds: Array<InputMaybe<Scalars['String']>>;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  location?: Maybe<Scalars['JSON']>;
  preferenceSourceList: Array<Maybe<NotificationPreferenceSource>>;
};

export type NotificationPreferenceInput = {
  location?: InputMaybe<Scalars['JSON']>;
  preferenceSourceList: Array<InputMaybe<NotificationPreferenceSourceInput>>;
};

export type NotificationPreferenceSource = {
  __typename?: 'NotificationPreferenceSource';
  severitySet: Array<Maybe<NotificationSeverity>>;
  source?: Maybe<KineticModule>;
};

export type NotificationPreferenceSourceInput = {
  severitySet: Array<InputMaybe<NotificationSeverity>>;
  source?: InputMaybe<KineticModule>;
};

export enum NotificationSeverity {
  /**  Critical Notification */
  Critical = 'CRITICAL',
  /**  Information only notification */
  Info = 'INFO',
  /**  Warning Notification */
  Warning = 'WARNING'
}

export enum NotificationSortField {
  Acknowledged = 'ACKNOWLEDGED',
  AcknowledgedBy = 'ACKNOWLEDGED_BY',
  AcknowledgedNotes = 'ACKNOWLEDGED_NOTES',
  Created = 'CREATED',
  Details = 'DETAILS',
  Severity = 'SEVERITY',
  Source = 'SOURCE',
  Title = 'TITLE',
  UpdatedTs = 'UPDATED_TS'
}

export enum NotificationStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Dismissed = 'DISMISSED',
  Reminder = 'REMINDER',
  Unacknowledged = 'UNACKNOWLEDGED'
}

export type NotificationTranslationDetailsInput = {
  af?: InputMaybe<TranslatedNotification>;
  an?: InputMaybe<TranslatedNotification>;
  ar?: InputMaybe<TranslatedNotification>;
  as?: InputMaybe<TranslatedNotification>;
  ast?: InputMaybe<TranslatedNotification>;
  az?: InputMaybe<TranslatedNotification>;
  be?: InputMaybe<TranslatedNotification>;
  bg?: InputMaybe<TranslatedNotification>;
  bn?: InputMaybe<TranslatedNotification>;
  br?: InputMaybe<TranslatedNotification>;
  bs?: InputMaybe<TranslatedNotification>;
  ca?: InputMaybe<TranslatedNotification>;
  ce?: InputMaybe<TranslatedNotification>;
  ch?: InputMaybe<TranslatedNotification>;
  co?: InputMaybe<TranslatedNotification>;
  cr?: InputMaybe<TranslatedNotification>;
  cs?: InputMaybe<TranslatedNotification>;
  cv?: InputMaybe<TranslatedNotification>;
  cy?: InputMaybe<TranslatedNotification>;
  da?: InputMaybe<TranslatedNotification>;
  de?: InputMaybe<TranslatedNotification>;
  el?: InputMaybe<TranslatedNotification>;
  en: TranslatedNotification;
  eo?: InputMaybe<TranslatedNotification>;
  es?: InputMaybe<TranslatedNotification>;
  et?: InputMaybe<TranslatedNotification>;
  eu?: InputMaybe<TranslatedNotification>;
  fa?: InputMaybe<TranslatedNotification>;
  fi?: InputMaybe<TranslatedNotification>;
  fj?: InputMaybe<TranslatedNotification>;
  fo?: InputMaybe<TranslatedNotification>;
  fr?: InputMaybe<TranslatedNotification>;
  fur?: InputMaybe<TranslatedNotification>;
  fy?: InputMaybe<TranslatedNotification>;
  ga?: InputMaybe<TranslatedNotification>;
  gd?: InputMaybe<TranslatedNotification>;
  gl?: InputMaybe<TranslatedNotification>;
  gu?: InputMaybe<TranslatedNotification>;
  he?: InputMaybe<TranslatedNotification>;
  hi?: InputMaybe<TranslatedNotification>;
  hr?: InputMaybe<TranslatedNotification>;
  hsb?: InputMaybe<TranslatedNotification>;
  ht?: InputMaybe<TranslatedNotification>;
  hu?: InputMaybe<TranslatedNotification>;
  hy?: InputMaybe<TranslatedNotification>;
  id?: InputMaybe<TranslatedNotification>;
  is?: InputMaybe<TranslatedNotification>;
  it?: InputMaybe<TranslatedNotification>;
  iu?: InputMaybe<TranslatedNotification>;
  ja?: InputMaybe<TranslatedNotification>;
  ji?: InputMaybe<TranslatedNotification>;
  ka?: InputMaybe<TranslatedNotification>;
  kk?: InputMaybe<TranslatedNotification>;
  km?: InputMaybe<TranslatedNotification>;
  kn?: InputMaybe<TranslatedNotification>;
  ko?: InputMaybe<TranslatedNotification>;
  ks?: InputMaybe<TranslatedNotification>;
  ky?: InputMaybe<TranslatedNotification>;
  la?: InputMaybe<TranslatedNotification>;
  lb?: InputMaybe<TranslatedNotification>;
  lt?: InputMaybe<TranslatedNotification>;
  lv?: InputMaybe<TranslatedNotification>;
  mi?: InputMaybe<TranslatedNotification>;
  mk?: InputMaybe<TranslatedNotification>;
  ml?: InputMaybe<TranslatedNotification>;
  mo?: InputMaybe<TranslatedNotification>;
  mr?: InputMaybe<TranslatedNotification>;
  ms?: InputMaybe<TranslatedNotification>;
  mt?: InputMaybe<TranslatedNotification>;
  my?: InputMaybe<TranslatedNotification>;
  nb?: InputMaybe<TranslatedNotification>;
  ne?: InputMaybe<TranslatedNotification>;
  ng?: InputMaybe<TranslatedNotification>;
  nl?: InputMaybe<TranslatedNotification>;
  nn?: InputMaybe<TranslatedNotification>;
  no?: InputMaybe<TranslatedNotification>;
  nv?: InputMaybe<TranslatedNotification>;
  oc?: InputMaybe<TranslatedNotification>;
  om?: InputMaybe<TranslatedNotification>;
  or?: InputMaybe<TranslatedNotification>;
  pa?: InputMaybe<TranslatedNotification>;
  pl?: InputMaybe<TranslatedNotification>;
  pt?: InputMaybe<TranslatedNotification>;
  qu?: InputMaybe<TranslatedNotification>;
  rm?: InputMaybe<TranslatedNotification>;
  ro?: InputMaybe<TranslatedNotification>;
  ru?: InputMaybe<TranslatedNotification>;
  sa?: InputMaybe<TranslatedNotification>;
  sb?: InputMaybe<TranslatedNotification>;
  sc?: InputMaybe<TranslatedNotification>;
  sd?: InputMaybe<TranslatedNotification>;
  sg?: InputMaybe<TranslatedNotification>;
  si?: InputMaybe<TranslatedNotification>;
  sk?: InputMaybe<TranslatedNotification>;
  sl?: InputMaybe<TranslatedNotification>;
  so?: InputMaybe<TranslatedNotification>;
  sq?: InputMaybe<TranslatedNotification>;
  sr?: InputMaybe<TranslatedNotification>;
  sv?: InputMaybe<TranslatedNotification>;
  sw?: InputMaybe<TranslatedNotification>;
  sx?: InputMaybe<TranslatedNotification>;
  sz?: InputMaybe<TranslatedNotification>;
  ta?: InputMaybe<TranslatedNotification>;
  te?: InputMaybe<TranslatedNotification>;
  th?: InputMaybe<TranslatedNotification>;
  tig?: InputMaybe<TranslatedNotification>;
  tk?: InputMaybe<TranslatedNotification>;
  tlh?: InputMaybe<TranslatedNotification>;
  tn?: InputMaybe<TranslatedNotification>;
  tr?: InputMaybe<TranslatedNotification>;
  ts?: InputMaybe<TranslatedNotification>;
  tt?: InputMaybe<TranslatedNotification>;
  uk?: InputMaybe<TranslatedNotification>;
  ur?: InputMaybe<TranslatedNotification>;
  ve?: InputMaybe<TranslatedNotification>;
  vi?: InputMaybe<TranslatedNotification>;
  vo?: InputMaybe<TranslatedNotification>;
  wa?: InputMaybe<TranslatedNotification>;
  xh?: InputMaybe<TranslatedNotification>;
  zh?: InputMaybe<TranslatedNotification>;
  zu?: InputMaybe<TranslatedNotification>;
};

export type NotificationsQuery = {
  acknowledged?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  notificationSortField?: InputMaybe<NotificationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum OerType {
  FixString = 'FIX_STRING',
  Int = 'INT',
  Int_8 = 'INT_8',
  Int_16 = 'INT_16',
  Int_32 = 'INT_32',
  Oid = 'OID',
  Uint = 'UINT',
  Uint_8 = 'UINT_8',
  Uint_16 = 'UINT_16',
  Uint_32 = 'UINT_32',
  Unknown = 'UNKNOWN',
  VarString = 'VAR_STRING'
}

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges: Array<OrganizationConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrganizationConnectionEdge = {
  __typename?: 'OrganizationConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: OrganizationDto;
};

export type OrganizationDto = {
  __typename?: 'OrganizationDto';
  cellNumber?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Maybe<Scalars['String']>>>;
  email: Scalars['String'];
  faxNumber?: Maybe<Scalars['String']>;
  homeNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mailingAddress?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  otherNumber?: Maybe<Scalars['String']>;
  pagerNumber?: Maybe<Scalars['String']>;
  useAsContact?: Maybe<Scalars['Boolean']>;
  website?: Maybe<Scalars['String']>;
  workNumber: Scalars['String'];
};

export type OrganizationInput = {
  cellNumber?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email: Scalars['String'];
  faxNumber?: InputMaybe<Scalars['String']>;
  homeNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mailingAddress?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  otherNumber?: InputMaybe<Scalars['String']>;
  pagerNumber?: InputMaybe<Scalars['String']>;
  useAsContact?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
  workNumber: Scalars['String'];
};

export type OrganizationKineticUser = {
  __typename?: 'OrganizationKineticUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  online?: Maybe<Scalars['Boolean']>;
  phoneNumbers: Array<Scalars['String']>;
  privilegeAssignmentList: Array<KineticPrivilegeAssignment>;
  roleIds: Array<Scalars['String']>;
  userGroupIds: Array<Scalars['String']>;
  username: Scalars['String'];
};

export type OrganizationKineticUserInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumbers: Array<Scalars['String']>;
  privilegeAssignmentList: Array<KineticPrivilegeAssignmentInput>;
  roleIds: Array<Scalars['String']>;
  temporaryPassword?: InputMaybe<Scalars['String']>;
  userGroupIds: Array<Scalars['String']>;
  username: Scalars['String'];
};

export type OrganizationPreference = {
  __typename?: 'OrganizationPreference';
  key: Scalars['ID'];
  value: Scalars['JSON'];
};

export type OrganizationPreferenceStreamObject = {
  __typename?: 'OrganizationPreferenceStreamObject';
  id: Scalars['ID'];
  organizationPreference: OrganizationPreference;
  preferenceKey: Scalars['String'];
  streamObjectOperation: StreamObjectOperation;
};

export type OrganizationQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type OrganizationStreamObject = {
  __typename?: 'OrganizationStreamObject';
  dto?: Maybe<OrganizationDto>;
  streamObjectOperation?: Maybe<StreamObjectOperation>;
};

export type OverlapStatus = {
  __typename?: 'OverlapStatus';
  color: SignalOutputColor;
  number: Scalars['Int'];
};

export type OverlayInfo = {
  __typename?: 'OverlayInfo';
  /**  Background fill color  */
  color?: Maybe<Scalars['String']>;
  /**  Labels  */
  label: Scalars['String'];
  /**  Opacity  */
  opacity?: Maybe<Scalars['Float']>;
  /**  Data Type  */
  type: DataType;
  x1: Scalars['String'];
  x2: Scalars['String'];
};

export enum OwnershipType {
  Personal = 'PERSONAL',
  System = 'SYSTEM'
}

export type PtzLockInfo = {
  __typename?: 'PTZLockInfo';
  fullName?: Maybe<Scalars['String']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lastUsedTime?: Maybe<Scalars['DateTime']>;
  lockEndsAt?: Maybe<Scalars['DateTime']>;
  lockStartedAt?: Maybe<Scalars['DateTime']>;
  requireExplicitCameraControlLocking?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ParkingArea = {
  __typename?: 'ParkingArea';
  /**  cameras  */
  cameras: Array<Scalars['ID']>;
  /**  communication status  */
  communicationStatus: CommunicationState;
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  direction  */
  direction: Direction;
  /**  identifier  */
  id: Scalars['ID'];
  /**  last data received  */
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  /**  levels  */
  levels: Array<ParkingAreaLevel>;
  /**  location  */
  location: Scalars['Object'];
  /**  manual mode  */
  manual: Scalars['Boolean'];
  /**  name  */
  name: Scalars['String'];
  /**  occupied spaces  */
  occupied: Scalars['Int'];
  /**  reference point  */
  referencePoint: Scalars['Float'];
  /**  road  */
  road: Scalars['String'];
  /**  signs  */
  signs: Array<Scalars['ID']>;
  /**  status  */
  status: ParkingAreaStatus;
  /**  system enabled  */
  systemEnabled: Scalars['Boolean'];
  /**  total spaces  */
  total: Scalars['Int'];
  /**  vacant spaces  */
  vacant: Scalars['Int'];
};

export type ParkingAreaConnection = {
  __typename?: 'ParkingAreaConnection';
  /**  Connection Edges  */
  edges: Array<ParkingAreaEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type ParkingAreaDisplayRequest = {
  /**  association display names  */
  associationDisplayNames?: InputMaybe<Array<Scalars['String']>>;
  /**  association identifiers  */
  associations?: InputMaybe<Array<Scalars['String']>>;
  /**  expiration time  */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  sign identifier  */
  id: Scalars['ID'];
  /**  message template to display  */
  template: SignMessageInput;
};

export type ParkingAreaEdge = {
  __typename?: 'ParkingAreaEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: ParkingArea;
};

export type ParkingAreaInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ParkingAreaLevel = {
  __typename?: 'ParkingAreaLevel';
  /**  full threshold  */
  fullThreshold: Scalars['Int'];
  /**  index  */
  index: Scalars['Int'];
  /**  name  */
  name: Scalars['String'];
  /**  nearly full threshold  */
  nearlyFullThreshold: Scalars['Int'];
  /**  occupied spaces  */
  occupied: Scalars['Int'];
  /**  reported availability  */
  reportedAvailability: Scalars['Int'];
  /**  spaces  */
  spaces: Array<ParkingAreaSpace>;
  /**  status  */
  status: ParkingAreaStatus;
  /**  total spaces  */
  total: Scalars['Int'];
  /**  vacant spaces  */
  vacant: Scalars['Int'];
};

export type ParkingAreaMessage = {
  __typename?: 'ParkingAreaMessage';
  /**  id  */
  id: Scalars['ID'];
  /**  name  */
  name: Scalars['String'];
  /**  parking area  */
  parkingArea: Scalars['ID'];
  /**  sign  */
  sign: Scalars['ID'];
  /**  template  */
  template: SignMessage;
};

export type ParkingAreaMessageConnection = {
  __typename?: 'ParkingAreaMessageConnection';
  /**  Connection Edges  */
  edges: Array<ParkingAreaMessageEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type ParkingAreaMessageEdge = {
  __typename?: 'ParkingAreaMessageEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  the message object  */
  node: ParkingAreaMessage;
};

export type ParkingAreaMessageInput = {
  /**  id  */
  id?: InputMaybe<Scalars['ID']>;
  /**  name  */
  name: Scalars['String'];
  /**  parking area  */
  parkingArea: Scalars['ID'];
  /**  sign  */
  sign: Scalars['ID'];
  /**  template  */
  template: SignMessageInput;
};

export type ParkingAreaMessageInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ParkingAreaSpace = {
  __typename?: 'ParkingAreaSpace';
  /**  index  */
  index: Scalars['Int'];
  /**  status  */
  status: ParkingAreaSpaceStatus;
  /**  type  */
  type: ParkingAreaSpaceType;
};

export enum ParkingAreaSpaceStatus {
  /**  Medical - stall is open but designated as a Handicap Stall - Blue Light  */
  Medical = 'MEDICAL',
  /**  Not Available - stall is open but not available - Red Light  */
  NotAvailable = 'NOT_AVAILABLE',
  /**  Occupied - stall has a vehicle in it - Red Light  */
  Occupied = 'OCCUPIED',
  /**  Other - maintenance or other state the sensor is in  */
  Other = 'OTHER',
  /**  Reserved - stall is open, not occupied but reserved for a customer - Amber Light  */
  Reserved = 'RESERVED',
  /**  Vacant - stall is open and available. Green Light  */
  Vacant = 'VACANT'
}

export enum ParkingAreaSpaceType {
  /**  Indicates that this is a handicap space  */
  Handicap = 'HANDICAP',
  /**  Indicates that this is a regular space  */
  Regular = 'REGULAR'
}

export enum ParkingAreaStatus {
  /**  Indicates that the parking area is closed  */
  Closed = 'CLOSED',
  /**  Indicates that there are no available parking spaces  */
  Full = 'FULL',
  /**  Indicates that there are a few available parking spaces  */
  NearlyFull = 'NEARLY_FULL',
  /**  Indicates that there are available parking spaces  */
  Open = 'OPEN',
  /**  Indicates that the parking area is in an unknown state  */
  Unknown = 'UNKNOWN'
}

export type ParkingPostRequest = {
  /**  expiration time  */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  parking area  */
  parkingArea: Scalars['ID'];
  /**  sign  */
  sign: Scalars['ID'];
  /**  template  */
  template: SignMessageInput;
};

export enum PatternType {
  Flash = 'FLASH',
  Free = 'FREE',
  Pattern = 'PATTERN',
  Unknown = 'UNKNOWN'
}

export enum PavementStatus {
  /**  Absorption  */
  Absorption = 'ABSORPTION',
  /**  Absorption At Dew Point  */
  AbsorptionAtDewpoint = 'ABSORPTION_AT_DEWPOINT',
  /**  Chemically Wet  */
  ChemicallyWet = 'CHEMICALLY_WET',
  /**  Dew  */
  Dew = 'DEW',
  /**  Dry  */
  Dry = 'DRY',
  /**  Error  */
  Error = 'ERROR',
  /**  Frost  */
  Frost = 'FROST',
  /**  Ice Warning  */
  IceWarning = 'ICE_WARNING',
  /**  Ice Watch  */
  IceWatch = 'ICE_WATCH',
  /**  Other  */
  Other = 'OTHER',
  /**  Snow Warning  */
  SnowWarning = 'SNOW_WARNING',
  /**  Snow Watch  */
  SnowWatch = 'SNOW_WATCH',
  /**  Trace Moisture  */
  TraceMoisture = 'TRACE_MOISTURE',
  /**  Wet  */
  Wet = 'WET'
}

export type PedStatus = {
  __typename?: 'PedStatus';
  color?: Maybe<SignalOutputColor>;
  hasCall: Scalars['Boolean'];
  number: Scalars['Int'];
};

export type PhaseServiceTimes = {
  __typename?: 'PhaseServiceTimes';
  green: Scalars['Int'];
  red: Scalars['Int'];
  yellow: Scalars['Int'];
};

export type PhaseStatus = {
  __typename?: 'PhaseStatus';
  actualSplit: Scalars['Int'];
  color?: Maybe<SignalOutputColor>;
  hasCall: Scalars['Boolean'];
  isNext: Scalars['Boolean'];
  lastTerm?: Maybe<PhaseTerminationReason>;
  number: Scalars['Int'];
  programmedSplit: Scalars['Int'];
  timeStampSecondForActualSplit?: Maybe<Scalars['Float']>;
};

export enum PhaseTerminationReason {
  Forceoff = 'FORCEOFF',
  Gapout = 'GAPOUT',
  Max1 = 'MAX1',
  Max2 = 'MAX2',
  Max3 = 'MAX3',
  Preempt = 'PREEMPT',
  Splitmax = 'SPLITMAX',
  Unknown = 'UNKNOWN',
  Yield = 'YIELD'
}

export type Position = {
  __typename?: 'Position';
  /**  The horizontal position  */
  x?: Maybe<Scalars['Int']>;
  /**  The vertical position  */
  y?: Maybe<Scalars['Int']>;
};

export type PositionInput = {
  /**  The horizontal position  */
  x?: InputMaybe<Scalars['Int']>;
  /**  The vertical position  */
  y?: InputMaybe<Scalars['Int']>;
};

export enum PrecipitationSituation {
  /**  Frozen Heavy  */
  FrozenHeavy = 'FROZEN_HEAVY',
  /**  Frozen Moderate  */
  FrozenModerate = 'FROZEN_MODERATE',
  /**  Frozen Slight  */
  FrozenSlight = 'FROZEN_SLIGHT',
  /**  Not Available  */
  NotAvailable = 'NOT_AVAILABLE',
  /**  No Precipitation  */
  NoPrecipitation = 'NO_PRECIPITATION',
  /**  Other  */
  Other = 'OTHER',
  /**  Rain Heavy  */
  RainHeavy = 'RAIN_HEAVY',
  /**  Rain Moderate  */
  RainModerate = 'RAIN_MODERATE',
  /**  Rain Slight  */
  RainSlight = 'RAIN_SLIGHT',
  /**  Snow Heavy  */
  SnowHeavy = 'SNOW_HEAVY',
  /**  Snow Moderate  */
  SnowModerate = 'SNOW_MODERATE',
  /**  Snow Slight  */
  SnowSlight = 'SNOW_SLIGHT',
  /**  Unidentified Heavy  */
  UnidentifiedHeavy = 'UNIDENTIFIED_HEAVY',
  /**  Unidentified Moderate  */
  UnidentifiedModerate = 'UNIDENTIFIED_MODERATE',
  /**  Unidentified Slight  */
  UnidentifiedSlight = 'UNIDENTIFIED_SLIGHT',
  /**  Unknown  */
  Unknown = 'UNKNOWN'
}

export type PreemptStatus = {
  __typename?: 'PreemptStatus';
  active: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  mibValue?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
};

export type Preset = {
  __typename?: 'Preset';
  id: Scalars['ID'];
  isHomePreset?: Maybe<Scalars['Boolean']>;
  isSelected?: Maybe<Scalars['Boolean']>;
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
  presetIndex: Scalars['Int'];
};

export type PresetInput = {
  cameraId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
};

export type PricingRate = {
  __typename?: 'PricingRate';
  /**  the first destination  */
  firstDestination?: Maybe<Scalars['String']>;
  /**  Rate Pricing must have at least one rate. We think this is true, but there may be a bug causing null values to get stored here. currently nullable to avoid apollo rejecting the request. */
  firstRate?: Maybe<Scalars['Float']>;
  /**  name of the rate to display  */
  name: Scalars['String'];
  /**  the second destination  */
  secondDestination?: Maybe<Scalars['String']>;
  /**  the second rate  */
  secondRate?: Maybe<Scalars['Float']>;
  /**  the third destination  */
  thirdDestination?: Maybe<Scalars['String']>;
  /**  the third rate  */
  thirdRate?: Maybe<Scalars['Float']>;
};

export type PricingRateInput = {
  /**  the first destination  */
  firstDestination?: InputMaybe<Scalars['String']>;
  /**  Rate Pricing must have at least one rate. We think this is true, but there may be a bug causing null values to get stored here. currently nullable to avoid apollo rejecting the request. */
  firstRate?: InputMaybe<Scalars['Float']>;
  /**  name of the rate to display  */
  name: Scalars['String'];
  /**  the second destination  */
  secondDestination?: InputMaybe<Scalars['String']>;
  /**  the second rate  */
  secondRate?: InputMaybe<Scalars['Float']>;
  /**  the third destination  */
  thirdDestination?: InputMaybe<Scalars['String']>;
  /**  the third rate  */
  thirdRate?: InputMaybe<Scalars['Float']>;
};

export type PrioritorStatus = {
  __typename?: 'PrioritorStatus';
  active: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  mibValue?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
};

export enum PrivilegeType {
  Admin = 'ADMIN',
  AlarmAck = 'ALARM_ACK',
  ApproveResourcePlan = 'APPROVE_RESOURCE_PLAN',
  Blank = 'BLANK',
  CloseGates = 'CLOSE_GATES',
  Configure = 'CONFIGURE',
  Control = 'CONTROL',
  Create = 'CREATE',
  DatabaseDownload = 'DATABASE_DOWNLOAD',
  DatabaseUpload = 'DATABASE_UPLOAD',
  Delete = 'DELETE',
  DevicePlans = 'DEVICE_PLANS',
  EditDatabase = 'EDIT_DATABASE',
  EventResponse = 'EVENT_RESPONSE',
  Interlock = 'INTERLOCK',
  ManageAcceptableWords = 'MANAGE_ACCEPTABLE_WORDS',
  ManageDetections = 'MANAGE_DETECTIONS',
  ManageRecordings = 'MANAGE_RECORDINGS',
  ManageSignalCorridors = 'MANAGE_SIGNAL_CORRIDORS',
  NotificationAck = 'NOTIFICATION_ACK',
  NotificationDismiss = 'NOTIFICATION_DISMISS',
  NotificationReminder = 'NOTIFICATION_REMINDER',
  NotificationReminderCustomization = 'NOTIFICATION_REMINDER_CUSTOMIZATION',
  OpenGates = 'OPEN_GATES',
  Poll = 'POLL',
  Post = 'POST',
  Ptz = 'PTZ',
  PtzOverrideLock = 'PTZ_OVERRIDE_LOCK',
  SuperviseGates = 'SUPERVISE_GATES',
  SyncTime = 'SYNC_TIME',
  Update = 'UPDATE',
  View = 'VIEW',
  ViewActivityLog = 'VIEW_ACTIVITY_LOG',
  WorkOrderAssignment = 'WORK_ORDER_ASSIGNMENT',
  WorkOrderNoRestriction = 'WORK_ORDER_NO_RESTRICTION'
}

export enum QFreeSplitMonitorReportType {
  AverageSplitData = 'AVERAGE_SPLIT_DATA',
  SplitData = 'SPLIT_DATA',
  SplitMonitor = 'SPLIT_MONITOR'
}

export type Query = {
  __typename?: 'Query';
  _entities: Array<Maybe<_Entity>>;
  /**  Get a 511 message by id - used by schema stitching */
  _fiveOneOneMessage?: Maybe<FiveOneOneMessage>;
  /**  stitch the intersection entity into the alarm config  */
  _intersectionAlarm?: Maybe<Intersection>;
  /**  Stitch integrations into a location  */
  _locationIntegrations?: Maybe<Location>;
  /**  Stitch an Intersection into a location  */
  _locationSignalIntersection?: Maybe<Location>;
  /**  plain sdl directive for schema stitching  */
  _sdl: Scalars['String'];
  _service: _Service;
  _signalCommandTasks: Array<SignalCommandTask>;
  _signalScheduledTasks?: Maybe<Array<Task>>;
  /**  Fetch action set rule by identifier  */
  actionSetResponseRule: ActionSetRule;
  /**  Fetch all configured action set rules  */
  actionSetResponseRules: ActionSetRuleConnection;
  /**  Get a page list of devices tied to activity logs */
  activityLogNames: ActivityLogNameConnection;
  /**  Get a page list of activity logs */
  activityLogs: ActivityLogConnection;
  /**  aggregate data by defining a MongoDB pipeline directly */
  aggregate?: Maybe<Scalars['JSON']>;
  /**  Gets the configuration for an alarm type */
  alarmConfig: AlarmConfig;
  /**  Search for system alarm configurations  */
  alarmConfigs: AlarmConfigsConnection;
  /**  Gets all alarm configs for the given entity  */
  alarmConfigsForEntity: Array<AlarmConfig>;
  /**  Search for active and recent alarms  */
  alarms: AlarmConnection;
  /**  Get all intersection icon statuses */
  allIntersectionIconStatus: Array<IntersectionIconStatus>;
  allOrganizations: Array<KineticOrganization>;
  /**  get all report builder tasks  */
  allReportBuilderTasks?: Maybe<Array<Task>>;
  /**  Get all resource plan tasks  */
  allResourcePlanTasks?: Maybe<Array<Task>>;
  /**  Get all scheduled event plan tasks for a period  */
  allScheduledEventTasks?: Maybe<Array<DateTasks>>;
  /**  Get all scheduled report builder tasks for a period  */
  allScheduledReportBuilderTasks?: Maybe<Array<DateTasks>>;
  /**  Get asset by id  */
  asset?: Maybe<Asset>;
  /** Get asset counts */
  assetCounts?: Maybe<Array<Maybe<AssetCounts>>>;
  /** Get asset health info */
  assetHealth?: Maybe<Array<Maybe<AssetHealthStats>>>;
  /**  Get transaction by id  */
  assetTransaction?: Maybe<AssetTransaction>;
  /**  Get a pageable list of transactions.  */
  assetTransactions: AssetTransactionConnection;
  /** Get asset work order counts */
  assetWorkOderCounts?: Maybe<Array<Maybe<AssetCounts>>>;
  /**  Get work order  by id  */
  assetWorkOrder?: Maybe<AssetWorkOrder>;
  assetWorkOrderComments: AssetWorkOrderCommentConnection;
  /**  Get a pageable list of asset work order links.  */
  assetWorkOrderLinks: AssetWorkOrderLinkConnection;
  /**  Get work order steps by  by id  */
  assetWorkOrderSteps: Array<AssetWorkOrderStep>;
  /** Get asset work order time tracking by id */
  assetWorkOrderTracking?: Maybe<AssetWorkOrderTracking>;
  /** Get asset work order time tracking list */
  assetWorkOrderTrackings: AssetWorkOrderTrackingConnection;
  /**  Get a pageable list of work orders.  */
  assetWorkOrders: AssetWorkOrderConnection;
  /**  Get a pageable list of assets.  */
  assets: AssetConnection;
  /**  Return the status of the associated message in the queue  */
  associatedMessageQueueStatus: SignMessageQueueStatus;
  /**  Get the atlas archive module settings  */
  atlasArchiveModuleSettings: ModuleSettingsFormView;
  /**  Get ATSPM Report  */
  atspmReport: Report;
  camera?: Maybe<Camera>;
  cameraCapabilities?: Maybe<Array<CameraCapabilityDto>>;
  /**  Detection status of camera  */
  cameraDetectionStatus: CameraDetectionStatus;
  cameraFutureTasks: Array<Task>;
  cameraGroup?: Maybe<CameraGroup>;
  cameraGroups: Array<CameraGroup>;
  cameraMapEntities: Scalars['JSON'];
  cameraMapEntityIds: Array<Scalars['String']>;
  /**  Get camera presets by camera (integration) ID */
  cameraPresets?: Maybe<Array<Maybe<Scalars['String']>>>;
  cameraPrivateStream?: Maybe<VideoStream>;
  cameras: CameraConnection;
  centralAuthPinSettings?: Maybe<CentralAuthPinSettings>;
  communicationLog?: Maybe<CommunicationLog>;
  communicationLogs: CommunicationLogConnection;
  /**  Fetch an individual connected vehicle by id  */
  connectedVehicle: ConnectedVehicle;
  /**  Search Connected Vehicle Comments  */
  connectedVehicleComments: ConnectedVehicleCommentConnection;
  /**  Get Connected Vehicle Comments for a given connected vehicle  */
  connectedVehicleCommentsByConnectedVehicle: Array<ConnectedVehicleComment>;
  /**  Get Connected Vehicle Configuration ids  */
  connectedVehicleIds: Array<Scalars['String']>;
  /**  Get Connected Vehicle Status Category Counts  */
  connectedVehicleStatusCategories: ConnectedVehicleCategory;
  /**  Get Connected Vehicle Configurations  */
  connectedVehicles: ConnectedVehicleConnection;
  contact?: Maybe<Contact>;
  contactGroup?: Maybe<ContactGroupDto>;
  contactGroupsByIds: Array<ContactGroupDto>;
  contactGroupsQuery: ContactGroupConnection;
  contacts: ContactConnection;
  contactsByIds?: Maybe<Array<Maybe<Contact>>>;
  contactsGroupByIds?: Maybe<Array<Maybe<ContactGroupDto>>>;
  contactsOfOrganization: ContactConnection;
  contactsToBeAssigned: ContactConnection;
  /**  Fetch a Corridor by identifier  */
  corridor: Corridor;
  /**  Get congestion data for a specific corridor link */
  corridorLinkCongestion: CorridorLinkCongestion;
  /**  Get corridor rule by id  */
  corridorRule?: Maybe<CorridorRule>;
  /**  Fetch corridor rule config  */
  corridorRuleConfig: Scalars['Object'];
  /**  Get a pageable list of corridor rules.  */
  corridorRules: CorridorRuleConnection;
  /**  Fetch a pageable list of Corridors  */
  corridors: CorridorConnection;
  /** Get counts module settings */
  countsModuleSettings: ModuleSettingsFormView;
  /**  Fetch data source  */
  dataSource: DataSource;
  /**  Fetch data source config  */
  dataSourceConfig: DataSourceConfig;
  /**  Fetch data source configs  */
  dataSourceConfigs: DataSourceConfigConnection;
  /**  Fetch data sources  */
  dataSources: DataSourceConnection;
  /**  fetch data sources by config id  */
  dataSourcesByConfigId?: Maybe<Array<DataSource>>;
  /**  Retrieve a template by ID  */
  databaseExportTemplate: DatabaseExportTemplate;
  /**  Get all database export templates  */
  databaseExportTemplates: Array<DatabaseExportTemplate>;
  /**  Get a database lock for a given database, if one exists  */
  databaseLock?: Maybe<DeviceDatabaseLock>;
  detection?: Maybe<Detection>;
  detections: DetectionConnection;
  /**  Get detector by id */
  detector: Detector;
  /**  Returns list of activity for given detector */
  detectorActivities: DetectorActivityConnection;
  /**  Returns list of ai classes */
  detectorAiClass?: Maybe<Array<DetectorAiClass>>;
  /**  Returns list of detector alarm groups */
  detectorAlarmGroups?: Maybe<Array<DetectorAlarmGroup>>;
  /**  Returns list of detector alarms sub types */
  detectorAlarmSubtypes?: Maybe<Array<DetectorAlarmSubtype>>;
  /**  Returns list of detector alarms types */
  detectorAlarmTypes?: Maybe<Array<DetectorAlarmType>>;
  /**  Returns list of alarms */
  detectorAlarms: DetectorAlarmConnection;
  /**  Returns list of detector alert types */
  detectorAlertTypes?: Maybe<Array<FieldConfigOption>>;
  /**  Returns list of battery info for given detector */
  detectorBattery: Array<DetectorBattery>;
  /**  Returns list of detector classes configuration */
  detectorClassConfiguration?: Maybe<Array<DetectorClass>>;
  /**  Returns list of detector classes */
  detectorClasses?: Maybe<Array<DetectorClass>>;
  /** Return latest config for detector id */
  detectorConfig?: Maybe<DetectorConfig>;
  /** Return config at particular time for detector id */
  detectorConfigAtTime?: Maybe<DetectorConfig>;
  /**  Returns list of connection log details for given detector */
  detectorConnectionLogDetails: DetectorConnectionLogDetailsConnection;
  /**  Returns list of detector connection log levels */
  detectorConnectionLogLevels?: Maybe<Array<FieldConfigOption>>;
  /**  Returns list of connection log for given detector */
  detectorConnectionLogs: DetectorConnectionLogConnection;
  /**  Returns list of email alert frequencies */
  detectorEmailAlertFrequencies?: Maybe<Array<DetectorAlertFrequencyOption>>;
  /**  Returns a  Detector Email Alert Setting for a given setting id number */
  detectorEmailAlertSetting?: Maybe<DetectorEmailAlertSetting>;
  /**  Returns list of Detector Email Alert Settings */
  detectorEmailAlertSettings: DetectorEmailAlertSettingConnection;
  /**  Returns list of email alert subtypes */
  detectorEmailAlertSubtypes?: Maybe<Array<DetectorAlertSubtypeOption>>;
  /**  Returns list of email alert types */
  detectorEmailAlertTypes?: Maybe<Array<DetectorAlertTypeOption>>;
  /**  Fetch Detector group by identifier  */
  detectorGroup?: Maybe<DetectorGroup>;
  /**  Get Detector Group Overview report  */
  detectorGroupOverviewReport: Array<ChartData>;
  /**  Fetch all configured detector groups  */
  detectorGroups: DetectorGroupConnection;
  /**  Returns list of detector log levels */
  detectorLogLevels?: Maybe<Array<FieldConfigOption>>;
  /**  Returns list of detector log message */
  detectorLogMessages?: Maybe<Array<FieldConfigOption>>;
  /**  Returns list of detector log sub types */
  detectorLogSubtypes?: Maybe<Array<FieldConfigOption>>;
  /**  Return the detectors to show on the map. */
  detectorMapEntities: Array<Scalars['JSON']>;
  /**  Returns performance report */
  detectorPerformanceReport: Array<DetectorPerformanceReportResult>;
  /**  Returns Performance Report Availability */
  detectorPerformanceReportAvailability: Array<DetectorPerformanceReportDayWiseAvailabilityInfo>;
  /**  Returns Performance Report Availability Details */
  detectorPerformanceReportAvailabilityDetails: Array<DetectorPerformanceReportDayWiseAvailabilityDetailInfo>;
  /**  Get detector ip and port */
  detectorReceiverIpPort?: Maybe<DetectorReceiverIpPort>;
  /**  Get report rule by id  */
  detectorReportConfiguration?: Maybe<DetectorReportConfiguration>;
  /**  Gets detector report rules */
  detectorReportConfigurations: DetectorReportConfigurationConnection;
  /**  Gets detector report  by template */
  detectorReportForm?: Maybe<DetectorReportRuleForm>;
  /** Returns Report Query Config */
  detectorReportFormQueryConfig?: Maybe<Scalars['Object']>;
  /**  Get report rule by id  */
  detectorReportRule?: Maybe<DetectorReportRule>;
  /**  Gets detector report rules */
  detectorReportRules: DetectorReportRuleConnection;
  /**  Gets detector report templates */
  detectorReportTemplateOptions: Array<DetectorReportTemplateOption>;
  /** Returns turning report for a site  */
  detectorTurningReport: DetectorTurningReport;
  /**  Returns axle weight chart details */
  detectorVehicleAxleWeightChart: Array<DetectorVehicleAxleWeightChart>;
  /** Return detector axle Weight Report */
  detectorVehicleAxleWeightReport?: Maybe<Array<Maybe<VehicleAxleWeightReportResult>>>;
  /** Return detector Axles Count Report */
  detectorVehicleAxlesCountReport?: Maybe<Array<Maybe<VehicleAxlesCountReportResult>>>;
  /**  Returns vehicle day wise availability */
  detectorVehicleDayWiseAvailability: Array<DetectorVehicleDayWiseAvailability>;
  /**  Returns vehicle day wise partial data availability */
  detectorVehicleDayWisePartialData: Array<DetectorVehicleDayWisePartialData>;
  /**  Returns detectorVehicleDetail for given vehicle ID */
  detectorVehicleDetail: DetectorVehicle;
  /** Return detector Gross Weight Report */
  detectorVehicleGrossWeightReport?: Maybe<Array<Maybe<VehicleGrossWeightReportResult>>>;
  /**  Returns speed bin volume data for detector between 2 DateTimes */
  detectorVehicleSpeedBinVolume: Array<DetectorVehicleSpeedBinReport>;
  /** Return detector speedReport */
  detectorVehicleSpeedReport?: Maybe<DetectorVehicleSpeedBinReportResult>;
  /**  Returns timeline series data of vehicle volume */
  detectorVehicleVolume: Array<Maybe<DetectorVehicleVolumeGroupInfo>>;
  /**  Returns volume for given query */
  detectorVehicleVolumeCount: Scalars['Int'];
  /**  Returns volumes for groups */
  detectorVehicleVolumeGroupCounts: Array<DetectorVehicleVolumeCount>;
  /**  Returns vehicle intervals volume */
  detectorVehicleVolumeIntervalCounts: Array<DetectorVehicleVolumeIntervalCount>;
  /**  Returns vehicle yearly summary */
  detectorVehicleYearlySummary: Array<DetectorVehicleYearlySummary>;
  /**  Returns list of vehicles for given detector */
  detectorVehicles: DetectorVehicleConnection;
  /**  Returns count of vehicles for given filter */
  detectorVehiclesCount: Scalars['Int'];
  /**  Returns list of verified class names */
  detectorVerificationClass: Array<DetectorVerificationClass>;
  /**  Returns detector weather info */
  detectorWeather: Array<DetectorWeather>;
  /** Return Detector Mean gross weight Report */
  detectorWimMeanGrossWeightReport: DetectorMeanGrossWeightReportResult;
  /**  Get a pageable list of detectors */
  detectors: DetectorConnection;
  /**  Fetch a device database by id */
  deviceDatabase?: Maybe<DeviceDatabase>;
  /**  Compare the diff between two device databases  */
  deviceDatabaseComparison: DeviceDatabaseComparison;
  /**  Fetch deviceDatabaseMibChangeLog by intersection id and filter */
  deviceDatabaseMibChangeLogs: DeviceDatabaseMibChangeLogConnection;
  /**  Fetch device databases by device id and filter */
  deviceDatabases: DeviceDatabaseConnection;
  /**  Fetch device events by device id and filter */
  deviceEvents: DeviceEventConnection;
  /**  Gets an entire database views from a device of database file */
  deviceUI?: Maybe<IntersectionDeviceUi>;
  /**  Get an entire database table from a device or database file  */
  deviceUITable?: Maybe<IntersectionDeviceUiTable>;
  deviceViews?: Maybe<DeviceViewsUi>;
  effectivePrivileges: Array<KineticEffectivePrivilegeAssignment>;
  /**  fetches 10 email notification history objects */
  emailHistory: EmailNotificationConnection;
  /**   Get Email history by event id */
  emailNotificationsByEventId: Array<Maybe<EmailNotification>>;
  emailRule: EmailRuleDto;
  emailServerSettings?: Maybe<EmailServerSettings>;
  emailTemplate: EmailTemplateDto;
  emailsRule: EmailRuleConnection;
  emailsTemplate: EmailTemplateConnection;
  /**  Get a pageable list of entity work order.  */
  entityWorkOrders: EntityWorkOrderConnection;
  /**  Get event by id  */
  event?: Maybe<Event>;
  /**  Get current event jurisdiction filters  */
  eventJurisdictionFilters: Array<Scalars['String']>;
  /**  Get current event road filters  */
  eventRoadFilters: Array<Scalars['String']>;
  /**  Fetch query builder config for event rule form  */
  eventRuleQueryConfig: Scalars['Object'];
  /**  Get the event summary report  */
  eventSummaryReport?: Maybe<Scalars['String']>;
  /**  Get event template by id  */
  eventTemplate: EventTemplate;
  /**  Get a list of event templates  */
  eventTemplates: EventTemplateConnection;
  /**  Get an event type by id  */
  eventType: EventType;
  /**  Get current event type filters  */
  eventTypeFilters: Array<Scalars['String']>;
  /**  Get a list of event types  */
  eventTypes: EventTypeConnection;
  /**  Get a pageable list of events.  */
  events: EventConnection;
  /**  Get the events module settings  */
  eventsModuleSettings: ModuleSettingsFormView;
  /** Export data source configs and data. Exports all if no IDs are provided. */
  exportDataSources: Scalars['Object'];
  /** Export form fields. Exports all if no IDs are provided. */
  exportFormFields: Scalars['Object'];
  /** Export forms. Exports all if no IDs are provided. */
  exportForms: Scalars['Object'];
  /**  Search location comments. */
  findLocationComments: LocationCommentConnection;
  /**  fetch a fleet dispatch  */
  fleetDispatch: FleetDispatch;
  /**  fetch a list of fleet dispatch history  */
  fleetDispatchHistory: FleetDispatchHistoryConnection;
  /**  fetch a list of fleet dispatches  */
  fleetDispatches: FleetDispatchConnection;
  /**  fetch a fleet driver  */
  fleetDriver: FleetDriver;
  /**  fetch a list of fleet drivers  */
  fleetDrivers: FleetDriverConnection;
  /**  find a fleet route for an event  */
  fleetEventRoute?: Maybe<FleetRoute>;
  /**  fetch a fleet route  */
  fleetRoute: FleetRoute;
  /**  fetch a list of fleet routes  */
  fleetRoutes: FleetRouteConnection;
  /**  fetch a fleet shift  */
  fleetShift: FleetShift;
  /**  fetch a list of fleet shift history  */
  fleetShiftHistory: FleetShiftHistoryConnection;
  /**  fetch a list of fleet shifts  */
  fleetShifts: FleetShiftConnection;
  /**  fetch a fleet vehicle  */
  fleetVehicle: FleetVehicle;
  /**  fetch a list of fleet vehicles  */
  fleetVehicles: FleetVehicleConnection;
  /**  fetch a configured gate controller  */
  gateController: GateController;
  /**  determine if an individual operation is allowed for gate controller  */
  gateControllerOperationAllowed: GateControllerOperationResult;
  /**  fetch a configured gate controller  */
  gateControllerSignMessage: GateControllerSignMessage;
  /**  fetch a list of configured gate controllers  */
  gateControllerSignMessages: GateControllerSignMessageConnection;
  /**  fetch a gate control system  */
  gateControllerSystem: GateControllerSystem;
  /**  fetch a list of gate control systems  */
  gateControllerSystems: GateControllerSystemConnection;
  /**  fetch a list of configured gate controllers  */
  gateControllers: GateControllerConnection;
  /**  fetch a gate group status  */
  gateGroupStatus: GateControllerStatus;
  /**  poll a kinetic controller  */
  gateKineticControllerPoll: KineticGateController;
  /**  Get the gate module settings  */
  gateModuleSettings: ModuleSettingsFormView;
  /**  fetch the operation  */
  gateOperation?: Maybe<GateOperation>;
  /**  fetch a configured gate operation approval  */
  gateOperationApproval: GateOperationApproval;
  /**  fetch a list of current operation approval requests  */
  gateOperationApprovals: GateOperationApprovalConnection;
  /**  fetch a history entry  */
  gateOperationHistory?: Maybe<GateOperationHistory>;
  /**  fetch a list of gate operation history for a system  */
  gateOperationHistoryList: GateOperationHistoryConnection;
  /**  fetch a list of gate operation options for a system  */
  gateOperationOptions: Array<FieldConfigOption>;
  /**  validate that the gate operation can be run  */
  gateOperationValidate: Scalars['Boolean'];
  /**  fetch the safe reversal time for a gate  */
  gateSafeReversalTime: GateSafeReversalTime;
  /**  fetch a list of groups for a gate system  */
  gateSystemGroups: Array<GateGroupUpdate>;
  getCameraSnapshot?: Maybe<Scalars['String']>;
  /**  Gets vehicle data  import progress information " */
  getDetectorVehicleImportProgressInfo: DetectorVehicleImportProgress;
  /**  Gets the list of DeviceViewsProtocolEntityEnum from each intersection or group in the list  */
  getDeviceViewsProtocolsFromEntities: Array<DeviceViewsProtocolEntityEnum>;
  /**  Gets file information  */
  getFileInfo: File;
  getFileTags: Array<Scalars['String']>;
  /**  Gets a list of files  */
  getFiles: FileConnection;
  /**  fetch fleet camera details for live video feed */
  getFleetCameraDetails: FleetCameraDetails;
  /**  Get Global Files */
  getGlobalFiles: GlobalFileConnection;
  /**  Gets the total intersection count in the provided entity list  */
  getIntersectionCountFromEntities: Scalars['Int'];
  getKineticUser?: Maybe<OrganizationKineticUser>;
  /**  Get the parent group details, if it exists, of the given location */
  getLocationParentGroup?: Maybe<FlatLocationGroup>;
  /**  Retrieve a managed file by ID  */
  getManagedFile?: Maybe<ManagedFile>;
  /**  Gets a list of managed files  */
  getManagedFiles: ManagedFileConnection;
  /**  Fetch all Managed Files for a directory */
  getManagedFilesByDirectory: Array<ManagedFile>;
  /**  get pricing sign integrations  */
  getPricingSignIntegrations: Array<SignIntegration>;
  /**  Get System Directories */
  getSystemDirectories: Array<Directory>;
  /**  Get tenant integration by externalId  */
  getTenantByExternalId?: Maybe<TenantIntegration>;
  /**  Get User Directories */
  getUserDirectories: Array<Directory>;
  /**  Pulls a managed zip file and returns filenames within the zip.  */
  getZipFilenames: Array<Scalars['String']>;
  gitHash: Scalars['String'];
  /**  fetch a har message  */
  harMessage?: Maybe<HarMessage>;
  /**  fetch a list of messages  */
  harMessages: HarMessageConnection;
  /**  module settings  */
  harModuleSettings: ModuleSettingsFormView;
  /**  fetch a har playlist  */
  harPlaylist?: Maybe<HarPlaylist>;
  /**  fetch a list of playlist  */
  harPlaylists: HarPlaylistConnection;
  /**  fetch a list of transmitters  */
  harPriorities: HarPriorityConnection;
  /**  fetch a har transmitter  */
  harPriority?: Maybe<HarPriority>;
  /**  fetch a har transmitter  */
  harTransmitter?: Maybe<HarTransmitter>;
  /**  fetch a list of transmitter state history  */
  harTransmitterStateHistory: HarTransmitterStateHistoryConnection;
  /**  fetch a list of transmitters  */
  harTransmitters: HarTransmitterConnection;
  /**  Tells if an intersection has a database action in progress  */
  hasActiveDatabaseAction: Scalars['Boolean'];
  /**  Check if user has privileges to remove associations  */
  hasRemoveAssociationPrivilege?: Maybe<Scalars['Boolean']>;
  hasValidLicense?: Maybe<Scalars['Boolean']>;
  /**  Get the historical event summary report  */
  historicalEventSummaryReport?: Maybe<Scalars['String']>;
  /**  Get a page list of historical entities */
  history: HistoricalEntityConnection;
  /**  fetch inbound events for c2c for the given format and requests  */
  inboundEvents: Array<Scalars['Object']>;
  /**  Get integration by id  */
  integration?: Maybe<Integration>;
  /**  Get an integration from by id  */
  integrationForm: IntegrationsForm;
  /**  Gets a list of available integrations form  */
  integrationForms: IntegrationsFormConnection;
  integrationGroup?: Maybe<IntegrationGroup>;
  integrationGroups: IntegrationGroupConnection;
  /**  Get a pageable list of integrations.  */
  integrations: IntegrationConnection;
  /**  fetch sign interlock override requests  */
  interlockOverrideRequests: SignInterlockOverrideApprovalViewDto;
  /**  Fetch a list of nearby integrations  */
  intersectingIntegrations?: Maybe<Array<Integration>>;
  /**  Fetch a list of nearby sign groups  */
  intersectingSignGroups?: Maybe<Array<SignGroup>>;
  /**  Fetch an individual intersection by id  */
  intersection?: Maybe<Intersection>;
  /**  Get intersection comments. */
  intersectionComments: Array<IntersectionComment>;
  /**  Get all the intersections communication statuses. IntersectionCommunicationStatus */
  intersectionCommunicationStatus: Array<Scalars['Object']>;
  /**  Get communication status by id */
  intersectionCommunicationStatusById?: Maybe<IntersectionCommunicationStatus>;
  /**  Get all the intersections detailed statuses */
  intersectionDetailStatus: Array<Scalars['Object']>;
  /**  Gets an intersections detailed status */
  intersectionDetailStatusById?: Maybe<IntersectionDetailStatus>;
  /**  Get an intersection icon status */
  intersectionIconStatus: IntersectionIconStatus;
  /**  Search for intersections that match the criteria of ids */
  intersectionIds: Array<Scalars['String']>;
  /**  Get all the intersections lane statuses. IntersectionLaneStatus */
  intersectionLaneStatus: Array<Scalars['Object']>;
  /**  Get the all the intersections location. Removed type for faster performance IntersectionLocation */
  intersectionLocation: Array<Scalars['Object']>;
  intersectionMibLists: Array<MibDefinition>;
  /**  Get all the intersections overlap statuses */
  intersectionOverlapStatus: Array<IntersectionOverlapStatus>;
  /**  Get phase status by id */
  intersectionOverlapStatusById?: Maybe<IntersectionOverlapStatus>;
  /**  Get all the intersections pattern statuses */
  intersectionPatternStatus: Array<Scalars['Object']>;
  /**  Get the intersection pattern status for a given intersection */
  intersectionPatternStatusById?: Maybe<IntersectionPatternStatus>;
  /**  Get all the intersections ped statuses */
  intersectionPedStatus: Array<IntersectionPedStatus>;
  /**  Get ped status by id */
  intersectionPedStatusById?: Maybe<IntersectionPedStatus>;
  /**  Get all the intersections phase statuses */
  intersectionPhaseStatus: Array<IntersectionPhaseStatus>;
  /**  Get phase status by id */
  intersectionPhaseStatusById?: Maybe<IntersectionPhaseStatus>;
  /**  Get the intersection phase summary counts */
  intersectionPhaseSummaryCounts: IntersectionPhaseSummaryCounts;
  /**  Get all the intersections simple statuses. IntersectionSimpleStatus */
  intersectionSimpleStatus: Array<Scalars['Object']>;
  /**  Get simple status by id */
  intersectionSimpleStatusById?: Maybe<IntersectionSimpleStatus>;
  /**  Get the intersection status categories. */
  intersectionStatusCategories: IntersectionStatusCategories;
  /**  Get intersection template by id  */
  intersectionTemplate: IntersectionTemplate;
  /**  Get a list of intersection templates  */
  intersectionTemplates: IntersectionTemplateConnection;
  /**  Return a paged list of intersections */
  intersections: IntersectionConnection;
  isUsernameUnique: Scalars['Boolean'];
  /**  Check if a video stream is blocked  */
  isVideoStreamBlocked: Scalars['Boolean'];
  keycloakClient?: Maybe<KeycloakClient>;
  kineticAuthJwt: Scalars['String'];
  kineticAuthSettings: ModuleSettingsFormView;
  /**  Fetch an event form by category and optional type  */
  kineticEventForm?: Maybe<KineticForm>;
  /**  Fetch template fields for all event forms  */
  kineticEventFormTemplateFields: Array<KineticFormFieldOption>;
  /**  Fetch form by unique identifier  */
  kineticForm: KineticForm;
  /**  Fetch form config by id  */
  kineticFormField: KineticFormField;
  /**  Fetch configured form fields  */
  kineticFormFields: KineticFormFieldConnection;
  /**  Fetch field names  */
  kineticFormModelFields: Array<Scalars['String']>;
  /**  Fetch query builder config for form  */
  kineticFormQueryConfig: Scalars['Object'];
  /**  Fetch template fields for form  */
  kineticFormTemplateFields: Array<KineticFormFieldOption>;
  /**  Fetch configured forms  */
  kineticForms: KineticFormConnection;
  /**  poll a transmitter  */
  kineticTransmitterPoll?: Maybe<KineticTransmitter>;
  kineticUser: KineticUser;
  /**  Fetch lane control settings by unique identifier  */
  laneControlSetting: LaneControlSettings;
  /**  Fetch all available lane control settings  */
  laneControlSettings: LaneControlSettingsConnection;
  lastGitTag: Scalars['String'];
  layout?: Maybe<Layout>;
  layouts: Array<Layout>;
  licenseDetails?: Maybe<KineticLicenseDetails>;
  licenseFeatures: Array<KineticLicenseFeatureValue>;
  /**  fetch linked data sources  */
  linkedDataSources?: Maybe<Array<DataSource>>;
  /**  Get a database lock for a given live database, if one exists  */
  liveDatabaseLock?: Maybe<DeviceDatabaseLock>;
  /**  Get a list of the controllers databases. */
  localDeviceDatabases: Array<LocalDeviceDatabase>;
  /**  Fetch an individual location by id  */
  location?: Maybe<Location>;
  /**  Get a pageable list of areas  */
  locationAreas: LocationAreaConnection;
  /**  Get a pageable list of bounded routes by area  */
  locationBoundedRoutes: LocationBoundedRouteConnection;
  /**  Get location comments. */
  locationComments: Array<LocationComment>;
  /**  Fetch an individual corridor by id  */
  locationCorridor?: Maybe<LocationCorridor>;
  /**  Fetch an individual corridor leg by id  */
  locationCorridorLeg?: Maybe<LocationCorridorLeg>;
  /**  Return a paged list of corridor legs */
  locationCorridorLegs: LocationCorridorLegConnection;
  /**  Fetch an individual corridor link by id  */
  locationCorridorLink?: Maybe<LocationCorridorLink>;
  locationCorridorLinks: LocationCorridorLinkConnection;
  /**  Return a paged list of corridors */
  locationCorridors: LocationCorridorConnection;
  /**  Find a route by road, direction, and measure  */
  locationFindRoute?: Maybe<LocationRoute>;
  /**  Return the location form attributes when an area has changed  */
  locationFormAreaChange: Scalars['Object'];
  /**  Return the location form attributes when Region/District has changed  */
  locationFormDistrictChange: Scalars['Object'];
  /**  Return the location form attributes when the end landmark has changed  */
  locationFormEndLandmarkChange: Scalars['Object'];
  /**  Return the location form attributes when the end reference point has changed  */
  locationFormEndReferencePointChange: Scalars['Object'];
  /** Return location form attributes when geometry changes. retrieveAllTypes specifies area types to return all matches; defaults to distinct areas if empty or not provided. */
  locationFormGeometryChange: Scalars['Object'];
  /**  Return the location form attributes when the landmark has changed  */
  locationFormLandmarkChange: Scalars['Object'];
  /**  Return the location form attributes when the reference point has changed  */
  locationFormReferencePointChange: Scalars['Object'];
  /**  Return the location form attributes when the start landmark has changed  */
  locationFormStartLandmarkChange: Scalars['Object'];
  /**  Return the location form attributes when the start reference point has changed  */
  locationFormStartReferencePointChange: Scalars['Object'];
  /**  Return the polygon that describes the given area  */
  locationGeocodeArea?: Maybe<Scalars['Object']>;
  /**  Return the segment that describes the given route parameters  */
  locationGeocodeBoundedRoute?: Maybe<Scalars['Object']>;
  /**  Return the segment that describes the given route parameters  */
  locationGeocodeRoute?: Maybe<Scalars['Object']>;
  /**  Fetch all location groups as a flat list */
  locationGroups: Array<FlatLocationGroup>;
  /**  Return the whole list of locations external links  */
  locationLinkAssociations: Array<LocationLinkAssociation>;
  /**  Get location links. */
  locationLinks: Array<LocationExternalLink>;
  /**  Return the list of nearest routes to a given point  */
  locationNearestRoute?: Maybe<LocationRoadwayPoint>;
  /**  Find a route by native id  */
  locationRoute?: Maybe<LocationRoute>;
  /**  Fetch a list of available route classifications  */
  locationRouteClassifications: Array<Scalars['String']>;
  /**  Get a pageable list of landmarks  */
  locationRouteLandmarks: LocationRouteLandmarkConnection;
  /**  Find a route range by native id  */
  locationRouteRange: LocationRouteRange;
  /**  Get a pageable list of routes  */
  locationRoutes: LocationRouteConnection;
  /**  Get location template by id  */
  locationTemplate: LocationTemplate;
  /**  Get a list of location templates  */
  locationTemplates: LocationTemplateConnection;
  /**
   * Fetch a tree of all LocationGroups -> Locations -> LocationAssociation identifiers.
   * Ungrouped locations are automatically added to an 'Ungrouped' group.
   * Includes only type and id information. GraphQL type information is omitted due to the
   * large potential size of associations and the unknown depth of the child groups.
   */
  locationTree: Scalars['Object'];
  /**  Return a paged list of locations */
  locations: LocationConnection;
  /**  Get a map config by id */
  mapConfig?: Maybe<MapConfig>;
  /**  Get all map configs.  */
  mapConfigs: Array<MapConfig>;
  /**  Get a map layer config by id */
  mapLayerConfig?: Maybe<MapLayerConfig>;
  /**  Get all layer configs.  */
  mapLayerConfigs: Array<MapLayerConfig>;
  /**  Gets the configuration for an alarm type */
  mibAlarmConfig: MibAlarmConfig;
  /**  Get all Mib alarm configs  */
  mibAlarmConfigs: Array<MibAlarmConfig>;
  /**  Gets a module map setting value  */
  moduleMapSettingValue?: Maybe<Scalars['Object']>;
  /**  Gets module map setting form view  */
  moduleMapSettings: ModuleSettingsFormView;
  nearbyCameras?: Maybe<Array<Camera>>;
  /**  Fetch a list of nearby integrations  */
  nearbyIntegrationsByPoint?: Maybe<Array<Integration>>;
  /**  Fetch a list of nearby intersection  */
  nearbyIntersectionsByPoint: Array<Intersection>;
  /**  fetch network condition by id  */
  networkCondition?: Maybe<NetworkCondition>;
  /**  fetch a list of network conditions  */
  networkConditions: NetworkConditionConnection;
  /**  fetch network jurisdiction by id  */
  networkJurisdiction?: Maybe<NetworkJurisdiction>;
  /**  fetch a list of network jurisdictions  */
  networkJurisdictions: NetworkJurisdictionConnection;
  notificationPreferences?: Maybe<NotificationPreference>;
  notifications: NotificationConnection;
  /**  Get a page list of historical entities */
  onlineArchivalStatus?: Maybe<Array<Maybe<MongoArchiveJob>>>;
  organization?: Maybe<KineticOrganization>;
  organizationContact?: Maybe<OrganizationDto>;
  organizationPreference?: Maybe<Scalars['JSON']>;
  organizationPreferences: Array<OrganizationPreference>;
  organizations: Array<KineticOrganization>;
  organizationsContact: OrganizationConnection;
  /**  fetch a fleet vehicle  */
  parkingArea: ParkingArea;
  /**  fetch a parking area message  */
  parkingAreaMessage?: Maybe<ParkingAreaMessage>;
  /**  fetch a list of parking area messages  */
  parkingAreaMessages: ParkingAreaMessageConnection;
  /**  fetch a list of fleet vehicles  */
  parkingAreas: ParkingAreaConnection;
  preset?: Maybe<Preset>;
  presets: Array<Preset>;
  privileges: Array<KineticPrivilege>;
  ptzLock: PtzLockInfo;
  rampMeterControllers: SignalControllerConnection;
  /**  Search for ramp meter sites that match the criteria of ids */
  rampMeterIds: Array<Scalars['String']>;
  /**  Get the ramp meter status categories. */
  rampMeterStatusCategories: RampMeterStatusCategories;
  /**  Return a paged list of ramp meter sites */
  rampMeters: IntersectionConnection;
  /**  Get the recent remote agent heartbeats. */
  recentRemoteAgents: Array<RemoteAgentHeartbeat>;
  /**  fetch a report builder  */
  reportBuilder?: Maybe<ReportBuilder>;
  /**  fetch a report builder blocks  */
  reportBuilderBlock?: Maybe<ReportBuilderBlock>;
  /**  fetch a list of report builder blocks  */
  reportBuilderBlocks: ReportBuilderBlockConnection;
  /**  get future tasks for a report builder  */
  reportBuilderFutureTasks: Array<Task>;
  /**  get report builder task by id  */
  reportBuilderTask?: Maybe<Task>;
  /**  get scheduled report builder tasks for a period  */
  reportBuilderTasks?: Maybe<Array<DateTasks>>;
  /**  fetch a list of report builders  */
  reportBuilders: ReportBuilderConnection;
  /**  fetch report data for events  */
  reportEventData?: Maybe<Scalars['JSON']>;
  /**  Fetch a resource plan by identifier  */
  resourcePlan?: Maybe<ResourcePlan>;
  /**  Fetch a pageable list of resource plan activation results */
  resourcePlanActivationResults: ResourcePlanActivationResultConnection;
  /**  Get future tasks for a resource plan  */
  resourcePlanFutureTasks: Array<Task>;
  /**  Get resource plan task by id  */
  resourcePlanTask?: Maybe<Task>;
  /**  Get scheduled resource plan tasks for a period  */
  resourcePlanTasks?: Maybe<Array<DateTasks>>;
  /**  Get resource plan tasks by parent id and task type */
  resourcePlanTasksByParentAndType?: Maybe<Array<Task>>;
  /**  Fetch a pageable list of resource plans  */
  resourcePlans: ResourcePlanConnection;
  /**  Get the response module settings  */
  responseModuleSettings: ModuleSettingsFormView;
  /**  Fetch response rule by identifier  */
  responseRule: ResponseRule;
  /**  Fetch response rule config  */
  responseRuleConfig: Scalars['Object'];
  /**  Fetch all configured response rules  */
  responseRules: ResponseRuleConnection;
  roads?: Maybe<Array<Maybe<Scalars['String']>>>;
  role?: Maybe<KineticRole>;
  roles: Array<KineticRole>;
  /**  Get any currently running jobs. */
  runningJobs: Array<IntegrationJob>;
  scene?: Maybe<Scene>;
  scenes: Array<Scene>;
  scheduledEventFutureTasks: Array<Task>;
  scheduledEventTask?: Maybe<Task>;
  /**  Get scheduled event tasks for a period  */
  scheduledEventTasks?: Maybe<Array<DateTasks>>;
  screen?: Maybe<Screen>;
  screens: Array<Screen>;
  /**  Fetch an individual sign by id  */
  sign: Sign;
  /**  Fetch controller message for signs by command  */
  signCommandMessage: Array<SignLibraryMessage>;
  /**  Fetch fonts for an individual sign  */
  signControllerFonts: Array<SignControllerFont>;
  /**  Fetch graphics for an individual sign  */
  signControllerGraphics: Array<SignGraphic>;
  /**  Fetch controller messages by sign  */
  signControllerMessages: Array<SignMessage>;
  /**  Fetch sign cutout by id  */
  signCutout: SignCutout;
  /**  Fetch all available sign cutouts  */
  signCutouts: SignCutoutConnection;
  /**  Fetch the font used for common displays  */
  signDefaultFont: SignFont;
  /**  Fetch display type by sign id  */
  signDisplayType: SignDisplayType;
  /**  Return the sign font by id  */
  signFont: SignFont;
  /**  Fetch the list of distinct fonts  */
  signFonts: Array<SignFont>;
  /**  Fetch all configured sign gantries  */
  signGantries: SignGantryConnection;
  /**  Fetch gantry configuration by id  */
  signGantry: SignGantry;
  /**  Return the sign graphic by id  */
  signGraphic: SignGraphic;
  /**  Fetch the list of graphics  */
  signGraphics: Array<SignGraphic>;
  /**  Fetch sign group by identifier  */
  signGroup: SignGroup;
  /**  Return the sign groups to show on the map. */
  signGroupMapEntities: Array<Scalars['JSON']>;
  /**  Fetch all configured sign groups  */
  signGroups: SignGroupConnection;
  /**  fetch the associated sign integrations  */
  signIntegrations: Array<SignIntegration>;
  /**  check the interlock state of a lus or vsl  */
  signInterlockValidate: Array<SignInterlockResult>;
  /**  Fetch lane control settings by sign identifier  */
  signLaneControlSettings?: Maybe<LaneControlSettings>;
  /**  Return the signs to show on the map. Only returns signs that are system enabled  */
  signMapEntities: Array<Scalars['JSON']>;
  /**  Fetch an individual sign message by id  */
  signMessage?: Maybe<SignLibraryMessage>;
  /**  Fetch distinct display types for library message creation  */
  signMessageDisplayTypes: Array<SignMessageDisplayType>;
  /**  Fetch the message history for a sign  */
  signMessageHistory: SignMessageHistoryConnection;
  /**  Fetch a paged list of messages by sign  */
  signMessageLibrary: SignLibraryMessageConnection;
  /**  Return list of message priorities  */
  signMessagePriorities: Array<SignMessagePriority>;
  /**  Get a message priority  */
  signMessagePriority?: Maybe<SignMessagePriority>;
  /**  Return a paged list of sign messages  */
  signMessages: SignLibraryMessageConnection;
  /**  Get the sign module settings  */
  signModuleSettings: ModuleSettingsFormView;
  /**  Get sign rule by id  */
  signResponseRule?: Maybe<SignResponseRule>;
  /**  Get a pageable list of sign rules.  */
  signResponseRules: SignResponseRuleConnection;
  /**  Return the signs to show on the schematic */
  signSchematicEntities: Array<Scalars['JSON']>;
  signalActionSetOptions: Array<Maybe<FieldConfigOption>>;
  /**  Get Action Sets  */
  signalActionSets: SignalActionSetConnection;
  signalAppliedCommandFilterOptions: SignalAppliedCommandFilterOptions;
  signalAppliedCommands: SignalAppliedCommandConnection;
  signalCommandDefinition?: Maybe<SignalCommandDefinition>;
  signalCommandDefinitions?: Maybe<Array<SignalCommandDefinition>>;
  signalCommandTypes: Array<Scalars['String']>;
  /**  Get the signal communication report  */
  signalCommunicationReport: SignalCommunicationReportRowConnection;
  /**  Fetch an individual signal controller by id  */
  signalController?: Maybe<SignalController>;
  signalControllers: SignalControllerConnection;
  /**  Get Detector Groups  */
  signalDetectorGroups: SignalDetectorGroupConnection;
  /**  Get the signal module settings  */
  signalModuleSettings: ModuleSettingsFormView;
  signalScheduledFutureTasksByIntersection?: Maybe<Array<Task>>;
  signalScheduledTask?: Maybe<Task>;
  signalScheduledTasks?: Maybe<Array<TaskOccurrence>>;
  signalScheduledTasksByIntersection?: Maybe<Array<TaskOccurrence>>;
  signalTasks: SignalTaskConnection;
  /**  Return a paged list of signs that are system enabled  */
  signs: SignConnection;
  /**  aggregate data from the historical entities */
  simpleAggregate: Array<Aggregation>;
  snapshots: SnapshotsConnection;
  systemNotifications: NotificationConnection;
  /**  Get task progressions in the system  */
  taskProgress: TaskProgressConnection;
  /**  Get the time drift settings  */
  timeDriftSettings: TimeDriftSettings;
  timeSpaceData: Array<Maybe<TimeSpaceNodeData>>;
  /**  fetch a tolling road  */
  tollRoad?: Maybe<TollingRoad>;
  /**  module settings  */
  tollingModuleSettings: ModuleSettingsFormView;
  /**  Gets a specific tolling points  */
  tollingPoint?: Maybe<TollingPoint>;
  /**  fetch a list of gate groups by tolling point id  */
  tollingPointGateGroups: Array<GateGroupUpdate>;
  /**  Gets a list of tolling points  */
  tollingPoints: TollingPointsConnection;
  /**  fetch a pricing integration  */
  tollingPricing?: Maybe<TollingPricing>;
  /**  fetch a list of historical rate history received  */
  tollingPricingConfirmedRateHistory: TollingPricingConfirmedRateHistoryConnection;
  /**  fetch confirmed rates for a pricing sign  */
  tollingPricingConfirmedRates: TollingPricingConfirmedRateConnection;
  /**  generate confirmed rates for a pricing integration  */
  tollingPricingGenerateConfirmedRates: Scalars['Boolean'];
  /**  fetch historical pricing rate by pricing id and name  */
  tollingPricingHistoricalRate: Array<HistoricalSignRate>;
  /**  fetch a historical record for historical rates  */
  tollingPricingHistoricalRateHistory: Array<HistoricalSignRate>;
  /**  fetch a list of historical rate history received  */
  tollingPricingHistoricalRateHistoryList: TollingPricingHistoricalRateHistoryConnection;
  /**  fetch a list of pricing integrations  */
  tollingPricingList: TollingPricingConnection;
  /**  fetch a list of current rate history received  */
  tollingPricingRateHistory: TollingPricingRateHistoryConnection;
  /**  fetch rate options for pricing  */
  tollingPricingRateOptions: Array<FieldConfigOption>;
  /**  fetch a list of tolling roads  */
  tollingRoads: TollingRoadConnection;
  /**  fetch a tolling segment  */
  tollingSegment?: Maybe<TollingSegment>;
  /**  fetch a tolling segment's comments  */
  tollingSegmentComments: Array<BasicComment>;
  /**  fetch a list of tolling segments  */
  tollingSegments: TollingSegmentConnection;
  /**  fetch a list of tolling signs  */
  tollingSigns: TollingSignsConnection;
  tour?: Maybe<Tour>;
  tours: TourConnection;
  /**  Fetch a Traffic Control by id  */
  trafficControl: TrafficControl;
  /**  Fetch a pageable list of traffic controls  */
  trafficControls: TrafficControlConnection;
  trafficEventCategory: Array<TrafficEventCategory>;
  trafficEventDefinitions: Array<TrafficEventDefinition>;
  /**  Get traffic responsive action control logs. Action control logs are TR action changes when a TR is scheduled and new commands are sent to device.  */
  trafficResponsiveActionControlLogs: TrafficResponsiveActionLogConnection;
  /**  Get traffic responsive action report  */
  trafficResponsiveActionReport: GraphData;
  /**  Get traffic responsive action results. Action results are the TR action selections, which happen even if a TR is not scheduled. This is intended for diagnostic information.  */
  trafficResponsiveActionResults: TrafficResponsiveActionLogConnection;
  trafficResponsivePlanOptions: Array<Maybe<FieldConfigOption>>;
  trafficResponsivePlanSummary: TrafficResponsivePlanSummary;
  /**  Get Traffic Responsive Plans  */
  trafficResponsivePlans: TrafficResponsivePlanConnection;
  /**  Fetch a travel time by identifier  */
  travelTime: TravelTime;
  /**  Fetch travel time delay summary with aggregated data  */
  travelTimeDelaySummary: Array<TravelTimeDelaySummary>;
  /**  Fetch the historical 5 minute average for this timeframe  */
  travelTimeDowHistory?: Maybe<TravelTimeDowHistory>;
  /**  Fetch a pageable list of travel time history  */
  travelTimeHistory: TravelTimeHistoryConnection;
  /**  Get travel time module settings  */
  travelTimeModuleSettings: ModuleSettingsFormView;
  /**  Fetch a pageable list of travel times  */
  travelTimes: TravelTimeConnection;
  /**  Fetch a tunnel fan by id  */
  tunnelFan: TunnelFan;
  /**  Fetch a pageable list of tunnel fans  */
  tunnelFans: TunnelFanConnection;
  /**  Fetch a tunnel light by id  */
  tunnelLight: TunnelLight;
  /**  Fetch a pageable list of tunnel lights  */
  tunnelLights: TunnelLightConnection;
  /**  Fetch a tunnel log by id  */
  tunnelLog: TunnelLog;
  /**  Fetch a pageable list of tunnel logs  */
  tunnelLogs: TunnelLogConnection;
  ungroupedCamerasTours?: Maybe<CameraGroup>;
  userGroup?: Maybe<KineticUserGroup>;
  userGroups: Array<KineticUserGroup>;
  userPrivilegeAssignment?: Maybe<KineticUserPrivilegeAssignment>;
  /**  Get all ramp meter privileges for the current user  */
  userRampMeterPrivileges: Array<SignalPrivilege>;
  /**  Get all the signal privileges for the current user  */
  userSignalPrivileges: Array<SignalPrivilege>;
  users: KineticUserConnection;
  usersByPrivilege: Array<OrganizationKineticUser>;
  validateActivityLog?: Maybe<Scalars['Boolean']>;
  /**  Validate a display type message  */
  validateDisplayTypeMessage: SignMessageValidationResult;
  /**  Validate a sign library message  */
  validateLibraryMessage: Array<SignLibraryMessageValidationResult>;
  /**  Validate and format a sign message  */
  validateSignMessage: SignMessageValidationResult;
  validateSignalFirmware: Scalars['Boolean'];
  version: Scalars['String'];
  videoModuleSettings: ModuleSettingsFormView;
  videoRecordings: VideoRecordConnection;
  /**  Get a specific block by camera id */
  videoStreamBlocked?: Maybe<VideoStreamBlock>;
  /**  Paged, filterable list of blocked streams.  */
  videoStreamBlocks: VideoStreamBlockConnection;
  videoTask?: Maybe<Task>;
  videoTasks?: Maybe<Array<DateTasks>>;
  /**  Fetch an individual weather station by id  */
  weatherStation: WeatherStation;
  /**  Returns historical chart data formatted for chart display  */
  weatherStationChartHistory: Array<WeatherStationChartHistory>;
  /**  Return historical weather data  */
  weatherStationHistory: WeatherStationHistoryConnection;
  /**  Return the weather stations to show on the map. */
  weatherStationMapEntities: Array<Scalars['JSON']>;
  /**  Return a paged list of weather stations  */
  weatherStations: WeatherStationConnection;
  widget?: Maybe<Widget>;
  widgets: Array<Widget>;
  /**  Get work order configuration by id  */
  workOrderConfiguration?: Maybe<WorkOrderConfiguration>;
  /**  Get a pageable list of work order configurations.  */
  workOrderConfigurations: WorkOrderConfigurationConnection;
};


export type Query_EntitiesArgs = {
  representations: Array<Scalars['_Any']>;
};


export type Query_FiveOneOneMessageArgs = {
  id: Scalars['ID'];
};


export type Query_IntersectionAlarmArgs = {
  id: Scalars['ID'];
};


export type Query_LocationIntegrationsArgs = {
  id: Scalars['ID'];
};


export type Query_LocationSignalIntersectionArgs = {
  id: Scalars['ID'];
};


export type Query_SignalScheduledTasksArgs = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};


export type QueryActionSetResponseRuleArgs = {
  id: Scalars['ID'];
};


export type QueryActionSetResponseRulesArgs = {
  query?: InputMaybe<ActionSetRuleInputQuery>;
};


export type QueryActivityLogNamesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: Array<FilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryActivityLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: Array<FilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryAggregateArgs = {
  aggregation: Array<Scalars['JSON']>;
  end: Scalars['DateTime'];
  entityIds: Array<Scalars['String']>;
  start: Scalars['DateTime'];
};


export type QueryAlarmConfigArgs = {
  id: Scalars['ID'];
};


export type QueryAlarmConfigsArgs = {
  query: AlarmConfigsQuery;
};


export type QueryAlarmConfigsForEntityArgs = {
  entityId: Scalars['ID'];
  entityType: AlarmEntityType;
  source: KineticModule;
};


export type QueryAlarmsArgs = {
  query: AlarmsQuery;
};


export type QueryAllReportBuilderTasksArgs = {
  id: Scalars['ID'];
};


export type QueryAllResourcePlanTasksArgs = {
  id: Scalars['ID'];
};


export type QueryAllScheduledEventTasksArgs = {
  from: Scalars['DateTime'];
  query?: InputMaybe<EventInputQuery>;
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


export type QueryAllScheduledReportBuilderTasksArgs = {
  from: Scalars['DateTime'];
  query?: InputMaybe<ReportBuilderInputQuery>;
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


export type QueryAssetArgs = {
  id: Scalars['ID'];
};


export type QueryAssetCountsArgs = {
  groupBy?: InputMaybe<AssetGroupBy>;
};


export type QueryAssetHealthArgs = {
  id: Scalars['ID'];
};


export type QueryAssetTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryAssetTransactionsArgs = {
  query?: InputMaybe<AssetTransactionInputQuery>;
};


export type QueryAssetWorkOderCountsArgs = {
  groupBy?: InputMaybe<WorkOrderGroupBy>;
};


export type QueryAssetWorkOrderArgs = {
  id: Scalars['ID'];
};


export type QueryAssetWorkOrderCommentsArgs = {
  query?: InputMaybe<AssetWorkOrderCommentInputQuery>;
};


export type QueryAssetWorkOrderLinksArgs = {
  query?: InputMaybe<AssetWorkOrderLinkInputQuery>;
};


export type QueryAssetWorkOrderStepsArgs = {
  id: Scalars['ID'];
};


export type QueryAssetWorkOrderTrackingArgs = {
  id: Scalars['ID'];
};


export type QueryAssetWorkOrderTrackingsArgs = {
  query?: InputMaybe<AssetWorkOrderTrackingInputQuery>;
};


export type QueryAssetWorkOrdersArgs = {
  query?: InputMaybe<AssetWorkOrderInputQuery>;
};


export type QueryAssetsArgs = {
  query?: InputMaybe<AssetInputQuery>;
};


export type QueryAssociatedMessageQueueStatusArgs = {
  associationId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryAtlasArchiveModuleSettingsArgs = {
  formViewName: Scalars['String'];
};


export type QueryAtspmReportArgs = {
  endDateTime: Scalars['DateTime'];
  intersectionId: Scalars['String'];
  params?: InputMaybe<Scalars['Object']>;
  reportType: AtspmSignalReport;
  startDateTime: Scalars['DateTime'];
};


export type QueryCameraArgs = {
  id: Scalars['ID'];
};


export type QueryCameraCapabilitiesArgs = {
  cameraId: Scalars['ID'];
};


export type QueryCameraDetectionStatusArgs = {
  cameraId: Scalars['ID'];
};


export type QueryCameraFutureTasksArgs = {
  cameraId: Scalars['String'];
  timezone: Scalars['String'];
};


export type QueryCameraGroupArgs = {
  id: Scalars['ID'];
};


export type QueryCameraGroupsArgs = {
  cameraGroupListFormat?: InputMaybe<CameraGroupListFormat>;
};


export type QueryCameraMapEntitiesArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryCameraMapEntityIdsArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryCameraPresetsArgs = {
  id: Scalars['ID'];
};


export type QueryCameraPrivateStreamArgs = {
  cameraId: Scalars['ID'];
};


export type QueryCamerasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryCommunicationLogArgs = {
  id: Scalars['ID'];
};


export type QueryCommunicationLogsArgs = {
  query?: InputMaybe<CommunicationLogInputQuery>;
};


export type QueryConnectedVehicleArgs = {
  id: Scalars['ID'];
};


export type QueryConnectedVehicleCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryConnectedVehicleCommentsByConnectedVehicleArgs = {
  connectedVehicleId: Scalars['ID'];
};


export type QueryConnectedVehicleIdsArgs = {
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryConnectedVehiclesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryContactArgs = {
  id: Scalars['ID'];
};


export type QueryContactGroupArgs = {
  id: Scalars['ID'];
};


export type QueryContactGroupsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryContactGroupsQueryArgs = {
  query?: InputMaybe<ContactGroupQuery>;
};


export type QueryContactsArgs = {
  query?: InputMaybe<ContactInputQuery>;
};


export type QueryContactsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryContactsGroupByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryContactsOfOrganizationArgs = {
  query: ContactOrganizationQuery;
};


export type QueryContactsToBeAssignedArgs = {
  query: ContactOrganizationQuery;
};


export type QueryCorridorArgs = {
  id: Scalars['ID'];
};


export type QueryCorridorLinkCongestionArgs = {
  detectorGroupId?: InputMaybe<Scalars['ID']>;
};


export type QueryCorridorRuleArgs = {
  id: Scalars['ID'];
};


export type QueryCorridorRulesArgs = {
  query?: InputMaybe<CorridorRuleInputQuery>;
};


export type QueryCorridorsArgs = {
  query?: InputMaybe<CorridorInputQuery>;
};


export type QueryDataSourceArgs = {
  id: Scalars['ID'];
};


export type QueryDataSourceConfigArgs = {
  id: Scalars['ID'];
};


export type QueryDataSourceConfigsArgs = {
  query?: InputMaybe<DataSourceConfigInputQuery>;
};


export type QueryDataSourcesArgs = {
  query?: InputMaybe<DataSourceInputQuery>;
};


export type QueryDataSourcesByConfigIdArgs = {
  configId: Scalars['ID'];
};


export type QueryDatabaseExportTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryDatabaseExportTemplatesArgs = {
  deviceApi?: InputMaybe<DeviceViewsProtocolEntityEnum>;
};


export type QueryDatabaseLockArgs = {
  databaseId: Scalars['ID'];
  intersectionId: Scalars['ID'];
};


export type QueryDetectionArgs = {
  id: Scalars['ID'];
};


export type QueryDetectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};


export type QueryDetectorArgs = {
  id: Scalars['ID'];
};


export type QueryDetectorActivitiesArgs = {
  query?: InputMaybe<DetectorActivityQuery>;
};


export type QueryDetectorAlarmsArgs = {
  query?: InputMaybe<DetectorAlarmQuery>;
};


export type QueryDetectorBatteryArgs = {
  query?: InputMaybe<DetectorBatteryInputQuery>;
};


export type QueryDetectorClassConfigurationArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
};


export type QueryDetectorClassesArgs = {
  detectorIds: Array<Scalars['ID']>;
};


export type QueryDetectorConfigArgs = {
  detectorId?: InputMaybe<Scalars['String']>;
};


export type QueryDetectorConfigAtTimeArgs = {
  detectorId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};


export type QueryDetectorConnectionLogDetailsArgs = {
  query?: InputMaybe<DetectorConnectionLogDetailsQuery>;
};


export type QueryDetectorConnectionLogsArgs = {
  query?: InputMaybe<DetectorConnectionLogQuery>;
};


export type QueryDetectorEmailAlertSettingArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDetectorEmailAlertSettingsArgs = {
  query?: InputMaybe<DetectorEmailAlertSettingQuery>;
};


export type QueryDetectorGroupArgs = {
  id: Scalars['ID'];
};


export type QueryDetectorGroupOverviewReportArgs = {
  detectorGroupId: Scalars['ID'];
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
};


export type QueryDetectorGroupsArgs = {
  query?: InputMaybe<DetectorGroupInputQuery>;
};


export type QueryDetectorMapEntitiesArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryDetectorPerformanceReportArgs = {
  query?: InputMaybe<DetectorPerformanceReportQuery>;
};


export type QueryDetectorPerformanceReportAvailabilityArgs = {
  query?: InputMaybe<DetectorPerformanceReportAvailabilityQuery>;
};


export type QueryDetectorPerformanceReportAvailabilityDetailsArgs = {
  query?: InputMaybe<DetectorPerformanceReportAvailabilityQuery>;
};


export type QueryDetectorReportConfigurationArgs = {
  id: Scalars['ID'];
};


export type QueryDetectorReportConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryDetectorReportFormArgs = {
  reportTemplate?: InputMaybe<DetectorReportTemplate>;
};


export type QueryDetectorReportFormQueryConfigArgs = {
  reportTemplate?: InputMaybe<DetectorReportTemplate>;
};


export type QueryDetectorReportRuleArgs = {
  id: Scalars['ID'];
};


export type QueryDetectorReportRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  template?: InputMaybe<DetectorReportTemplate>;
};


export type QueryDetectorTurningReportArgs = {
  query?: InputMaybe<DetectorTurningReportQuery>;
};


export type QueryDetectorVehicleAxleWeightChartArgs = {
  query?: InputMaybe<DetectorVehicleAxleWeightChartQuery>;
};


export type QueryDetectorVehicleAxleWeightReportArgs = {
  query?: InputMaybe<VehicleAxleWeightReportQuery>;
};


export type QueryDetectorVehicleAxlesCountReportArgs = {
  query?: InputMaybe<VehicleAxlesCountReportQuery>;
};


export type QueryDetectorVehicleDayWiseAvailabilityArgs = {
  query?: InputMaybe<DetectorVehicleDayWiseAvailabilityQuery>;
};


export type QueryDetectorVehicleDayWisePartialDataArgs = {
  query?: InputMaybe<DetectorVehicleDayWiseAvailabilityQuery>;
};


export type QueryDetectorVehicleDetailArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDetectorVehicleGrossWeightReportArgs = {
  query?: InputMaybe<VehicleGrossWeightReportQuery>;
};


export type QueryDetectorVehicleSpeedBinVolumeArgs = {
  query?: InputMaybe<DetectorVehicleVolumeCountQuery>;
};


export type QueryDetectorVehicleSpeedReportArgs = {
  query?: InputMaybe<DetectorSpeedReportQuery>;
};


export type QueryDetectorVehicleVolumeArgs = {
  query?: InputMaybe<DetectorVehicleVolumeQuery>;
};


export type QueryDetectorVehicleVolumeCountArgs = {
  query?: InputMaybe<DetectorVehicleVolumeCountQuery>;
};


export type QueryDetectorVehicleVolumeGroupCountsArgs = {
  query?: InputMaybe<DetectorVehicleVolumeGroupCountsQuery>;
};


export type QueryDetectorVehicleVolumeIntervalCountsArgs = {
  query?: InputMaybe<DetectorVehicleVolumeIntervalCountsQuery>;
};


export type QueryDetectorVehicleYearlySummaryArgs = {
  query?: InputMaybe<DetectorVehicleYearlySummaryQuery>;
};


export type QueryDetectorVehiclesArgs = {
  query?: InputMaybe<DetectorVehicleQuery>;
};


export type QueryDetectorVehiclesCountArgs = {
  query?: InputMaybe<DetectorVehicleQuery>;
};


export type QueryDetectorWeatherArgs = {
  query?: InputMaybe<DetectorWeatherQuery>;
};


export type QueryDetectorWimMeanGrossWeightReportArgs = {
  query?: InputMaybe<DetectorMeanGrossWeightReportQuery>;
};


export type QueryDetectorsArgs = {
  query?: InputMaybe<DetectorInputQuery>;
};


export type QueryDeviceDatabaseArgs = {
  id: Scalars['ID'];
  intersectionId: Scalars['ID'];
};


export type QueryDeviceDatabaseComparisonArgs = {
  compareDatabaseId: Scalars['ID'];
  intersectionId: Scalars['ID'];
  originalDatabaseId: Scalars['ID'];
};


export type QueryDeviceDatabaseMibChangeLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput>>;
  intersectionId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryDeviceDatabasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput>>;
  intersectionId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryDeviceEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  intersectionId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  rule?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};


export type QueryDeviceUiArgs = {
  databaseId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intersectionId: Scalars['String'];
  timeoutMs?: InputMaybe<Scalars['Int']>;
};


export type QueryDeviceUiTableArgs = {
  databaseId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['Boolean']>;
  firstIndexOnly?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  intersectionId: Scalars['String'];
  name: Scalars['String'];
  timeoutMs?: InputMaybe<Scalars['Int']>;
  topIndex?: InputMaybe<Scalars['Int']>;
};


export type QueryDeviceViewsArgs = {
  id: DeviceViewsProtocolEntityEnum;
};


export type QueryEmailHistoryArgs = {
  query?: InputMaybe<EmailNotificationHistoryQuery>;
};


export type QueryEmailNotificationsByEventIdArgs = {
  eventId: Scalars['String'];
};


export type QueryEmailRuleArgs = {
  id: Scalars['ID'];
};


export type QueryEmailTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryEmailsRuleArgs = {
  query?: InputMaybe<EmailRuleQuery>;
};


export type QueryEmailsTemplateArgs = {
  query?: InputMaybe<EmailRuleQuery>;
};


export type QueryEntityWorkOrdersArgs = {
  query: EntityWorkOrderInputQuery;
};


export type QueryEventArgs = {
  id: Scalars['ID'];
};


export type QueryEventRuleQueryConfigArgs = {
  id: Scalars['ID'];
  type?: InputMaybe<EventRuleType>;
};


export type QueryEventSummaryReportArgs = {
  id: Scalars['ID'];
};


export type QueryEventTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryEventTemplatesArgs = {
  query?: InputMaybe<EventTemplateInputQuery>;
};


export type QueryEventTypeArgs = {
  id: Scalars['ID'];
};


export type QueryEventTypeFiltersArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryEventTypesArgs = {
  query?: InputMaybe<EventTypeInputQuery>;
};


export type QueryEventsArgs = {
  query?: InputMaybe<EventInputQuery>;
};


export type QueryExportDataSourcesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryExportFormFieldsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryExportFormsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryFindLocationCommentsArgs = {
  query?: InputMaybe<LocationCommentInputQuery>;
};


export type QueryFleetDispatchArgs = {
  id: Scalars['ID'];
};


export type QueryFleetDispatchHistoryArgs = {
  query?: InputMaybe<FleetDispatchHistoryInputQuery>;
};


export type QueryFleetDispatchesArgs = {
  query?: InputMaybe<FleetDispatchInputQuery>;
};


export type QueryFleetDriverArgs = {
  id: Scalars['ID'];
};


export type QueryFleetDriversArgs = {
  query?: InputMaybe<FleetDriverInputQuery>;
};


export type QueryFleetEventRouteArgs = {
  referencePoint: Scalars['Float'];
  route: Scalars['String'];
};


export type QueryFleetRouteArgs = {
  id: Scalars['ID'];
};


export type QueryFleetRoutesArgs = {
  query?: InputMaybe<FleetRouteInputQuery>;
};


export type QueryFleetShiftArgs = {
  id: Scalars['ID'];
};


export type QueryFleetShiftHistoryArgs = {
  query?: InputMaybe<FleetShiftHistoryInputQuery>;
};


export type QueryFleetShiftsArgs = {
  query?: InputMaybe<FleetShiftInputQuery>;
};


export type QueryFleetVehicleArgs = {
  id: Scalars['ID'];
};


export type QueryFleetVehiclesArgs = {
  query?: InputMaybe<FleetVehicleInputQuery>;
};


export type QueryGateControllerArgs = {
  id: Scalars['ID'];
};


export type QueryGateControllerOperationAllowedArgs = {
  id: Scalars['ID'];
  type: GateOperationType;
};


export type QueryGateControllerSignMessageArgs = {
  id: Scalars['ID'];
};


export type QueryGateControllerSignMessagesArgs = {
  query?: InputMaybe<GateControllerSignMessageInputQuery>;
};


export type QueryGateControllerSystemArgs = {
  id: Scalars['ID'];
};


export type QueryGateControllerSystemsArgs = {
  query?: InputMaybe<GateControllerSystemInputQuery>;
};


export type QueryGateControllersArgs = {
  query?: InputMaybe<GateControllerInputQuery>;
};


export type QueryGateGroupStatusArgs = {
  id: Scalars['ID'];
};


export type QueryGateKineticControllerPollArgs = {
  id: Scalars['ID'];
};


export type QueryGateOperationArgs = {
  id: Scalars['ID'];
};


export type QueryGateOperationApprovalArgs = {
  id: Scalars['ID'];
};


export type QueryGateOperationApprovalsArgs = {
  query?: InputMaybe<GateOperationApprovalInputQuery>;
};


export type QueryGateOperationHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryGateOperationHistoryListArgs = {
  query?: InputMaybe<GateOperationHistoryQuery>;
};


export type QueryGateOperationOptionsArgs = {
  id: Scalars['ID'];
};


export type QueryGateOperationValidateArgs = {
  id: Scalars['ID'];
  operationId: Scalars['ID'];
};


export type QueryGateSafeReversalTimeArgs = {
  id: Scalars['ID'];
};


export type QueryGateSystemGroupsArgs = {
  id: Scalars['ID'];
};


export type QueryGetCameraSnapshotArgs = {
  cameraId: Scalars['ID'];
};


export type QueryGetDetectorVehicleImportProgressInfoArgs = {
  id: Scalars['ID'];
};


export type QueryGetDeviceViewsProtocolsFromEntitiesArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  entityIds: Array<Scalars['String']>;
};


export type QueryGetFileInfoArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type QueryGetFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  centerId?: InputMaybe<Scalars['String']>;
  filterInput?: InputMaybe<Array<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryGetFleetCameraDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryGetGlobalFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterInput?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryGetIntersectionCountFromEntitiesArgs = {
  centerId?: InputMaybe<Scalars['String']>;
  entityIds: Array<Scalars['String']>;
};


export type QueryGetKineticUserArgs = {
  id: Scalars['ID'];
};


export type QueryGetLocationParentGroupArgs = {
  id: Scalars['ID'];
};


export type QueryGetManagedFileArgs = {
  id: Scalars['ID'];
};


export type QueryGetManagedFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterInput?: InputMaybe<Array<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryGetManagedFilesByDirectoryArgs = {
  directoryId: Scalars['String'];
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryGetPricingSignIntegrationsArgs = {
  id: Scalars['ID'];
};


export type QueryGetSystemDirectoriesArgs = {
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryGetTenantByExternalIdArgs = {
  externalId: Scalars['String'];
};


export type QueryGetUserDirectoriesArgs = {
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryGetZipFilenamesArgs = {
  fileId: Scalars['ID'];
};


export type QueryHarMessageArgs = {
  id: Scalars['ID'];
};


export type QueryHarMessagesArgs = {
  query?: InputMaybe<HarMessageInputQuery>;
};


export type QueryHarPlaylistArgs = {
  id: Scalars['ID'];
};


export type QueryHarPlaylistsArgs = {
  query?: InputMaybe<HarPlaylistInputQuery>;
};


export type QueryHarPrioritiesArgs = {
  query?: InputMaybe<HarPriorityInputQuery>;
};


export type QueryHarPriorityArgs = {
  id: Scalars['ID'];
};


export type QueryHarTransmitterArgs = {
  id: Scalars['ID'];
};


export type QueryHarTransmitterStateHistoryArgs = {
  query?: InputMaybe<HarTransmitterStateHistoryInputQuery>;
};


export type QueryHarTransmittersArgs = {
  query?: InputMaybe<HarTransmitterInputQuery>;
};


export type QueryHasActiveDatabaseActionArgs = {
  intersectionId: Scalars['ID'];
};


export type QueryHasRemoveAssociationPrivilegeArgs = {
  associationId: Scalars['ID'];
  signs: Array<Scalars['ID']>;
};


export type QueryHistoricalEventSummaryReportArgs = {
  id: Scalars['ID'];
};


export type QueryHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  entityIds: Array<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};


export type QueryInboundEventsArgs = {
  params: InboundEventRequestParams;
};


export type QueryIntegrationArgs = {
  id: Scalars['ID'];
};


export type QueryIntegrationFormArgs = {
  id: Scalars['String'];
};


export type QueryIntegrationFormsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  integrationType?: InputMaybe<IntegrationType>;
  integrationsFormSortField?: InputMaybe<IntegrationsFormSortField>;
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryIntegrationGroupArgs = {
  id: Scalars['ID'];
};


export type QueryIntegrationGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  integrationTypes?: InputMaybe<Array<InputMaybe<IntegrationType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  integrationType?: InputMaybe<IntegrationType>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  systemEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInterlockOverrideRequestsArgs = {
  approvalId: Scalars['ID'];
};


export type QueryIntersectingIntegrationsArgs = {
  bounds: Scalars['Object'];
  integrationTypes?: InputMaybe<Array<InputMaybe<IntegrationType>>>;
};


export type QueryIntersectingSignGroupsArgs = {
  bounds: Scalars['Object'];
  types?: InputMaybe<Array<SignGroupType>>;
};


export type QueryIntersectionArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionCommentsArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionCommunicationStatusArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QueryIntersectionCommunicationStatusByIdArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionDetailStatusArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QueryIntersectionDetailStatusByIdArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionIconStatusArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionIdsArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryIntersectionLaneStatusArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QueryIntersectionLocationArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QueryIntersectionMibListsArgs = {
  intersectionId: Scalars['String'];
};


export type QueryIntersectionOverlapStatusArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QueryIntersectionOverlapStatusByIdArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionPatternStatusArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QueryIntersectionPatternStatusByIdArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionPedStatusArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QueryIntersectionPedStatusByIdArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionPhaseStatusArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QueryIntersectionPhaseStatusByIdArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionSimpleStatusArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QueryIntersectionSimpleStatusByIdArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryIntersectionTemplatesArgs = {
  query?: InputMaybe<IntersectionTemplateInputQuery>;
};


export type QueryIntersectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryIsUsernameUniqueArgs = {
  username: Scalars['String'];
};


export type QueryIsVideoStreamBlockedArgs = {
  cameraId?: InputMaybe<Scalars['ID']>;
  streamName?: InputMaybe<Scalars['String']>;
};


export type QueryKineticAuthJwtArgs = {
  id: Scalars['ID'];
};


export type QueryKineticEventFormArgs = {
  category: Scalars['String'];
};


export type QueryKineticFormArgs = {
  id: Scalars['ID'];
};


export type QueryKineticFormFieldArgs = {
  id: Scalars['ID'];
};


export type QueryKineticFormFieldsArgs = {
  query?: InputMaybe<KineticFormFieldInputQuery>;
};


export type QueryKineticFormModelFieldsArgs = {
  id: Scalars['ID'];
};


export type QueryKineticFormQueryConfigArgs = {
  id: Scalars['ID'];
};


export type QueryKineticFormTemplateFieldsArgs = {
  id: Scalars['ID'];
};


export type QueryKineticFormsArgs = {
  query?: InputMaybe<KineticFormInputQuery>;
};


export type QueryKineticTransmitterPollArgs = {
  id: Scalars['ID'];
};


export type QueryLaneControlSettingArgs = {
  id: Scalars['ID'];
};


export type QueryLaneControlSettingsArgs = {
  query?: InputMaybe<GenericInputQuery>;
};


export type QueryLayoutArgs = {
  id: Scalars['ID'];
};


export type QueryLayoutsArgs = {
  videoWallId?: InputMaybe<Scalars['ID']>;
};


export type QueryLinkedDataSourcesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryLiveDatabaseLockArgs = {
  intersectionId: Scalars['ID'];
};


export type QueryLocalDeviceDatabasesArgs = {
  id: Scalars['ID'];
};


export type QueryLocationArgs = {
  id: Scalars['ID'];
};


export type QueryLocationAreasArgs = {
  query?: InputMaybe<LocationAreaInputQuery>;
};


export type QueryLocationBoundedRoutesArgs = {
  query?: InputMaybe<LocationRouteInputQuery>;
};


export type QueryLocationCommentsArgs = {
  id: Scalars['ID'];
};


export type QueryLocationCorridorArgs = {
  id: Scalars['ID'];
};


export type QueryLocationCorridorLegArgs = {
  id: Scalars['ID'];
};


export type QueryLocationCorridorLegsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryLocationCorridorLinkArgs = {
  id: Scalars['ID'];
};


export type QueryLocationCorridorLinksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryLocationCorridorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryLocationFindRouteArgs = {
  direction: Scalars['String'];
  measure: Scalars['Float'];
  road: Scalars['String'];
};


export type QueryLocationFormAreaChangeArgs = {
  type: Scalars['String'];
  value: Scalars['Object'];
};


export type QueryLocationFormDistrictChangeArgs = {
  returnAreaTypes: Array<Scalars['String']>;
  searchAreaType: Scalars['String'];
  values: Scalars['Object'];
};


export type QueryLocationFormEndLandmarkChangeArgs = {
  values: Scalars['Object'];
};


export type QueryLocationFormEndReferencePointChangeArgs = {
  values: Scalars['Object'];
};


export type QueryLocationFormGeometryChangeArgs = {
  geometry: Scalars['Object'];
  retrieveAllTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryLocationFormLandmarkChangeArgs = {
  values: Scalars['Object'];
};


export type QueryLocationFormReferencePointChangeArgs = {
  values: Scalars['Object'];
};


export type QueryLocationFormStartLandmarkChangeArgs = {
  values: Scalars['Object'];
};


export type QueryLocationFormStartReferencePointChangeArgs = {
  values: Scalars['Object'];
};


export type QueryLocationGeocodeAreaArgs = {
  name: Scalars['String'];
  type: Scalars['String'];
};


export type QueryLocationGeocodeBoundedRouteArgs = {
  direction: Scalars['String'];
  jurisdiction: Scalars['String'];
  jurisdictionType: Scalars['String'];
  road: Scalars['String'];
  startReference?: InputMaybe<Scalars['Float']>;
};


export type QueryLocationGeocodeRouteArgs = {
  direction: Scalars['String'];
  endMeasure: Scalars['Float'];
  road: Scalars['String'];
  startMeasure: Scalars['Float'];
};


export type QueryLocationLinkAssociationsArgs = {
  locationId: Scalars['ID'];
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryLocationLinksArgs = {
  locationId: Scalars['ID'];
};


export type QueryLocationNearestRouteArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};


export type QueryLocationRouteArgs = {
  nativeId: Scalars['String'];
};


export type QueryLocationRouteLandmarksArgs = {
  query?: InputMaybe<LocationRouteLandmarkInputQuery>;
};


export type QueryLocationRouteRangeArgs = {
  nativeId: Scalars['String'];
};


export type QueryLocationRoutesArgs = {
  query?: InputMaybe<LocationRouteInputQuery>;
};


export type QueryLocationTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryLocationTemplatesArgs = {
  query?: InputMaybe<LocationTemplateInputQuery>;
};


export type QueryLocationsArgs = {
  query?: InputMaybe<LocationInputQuery>;
};


export type QueryMapConfigArgs = {
  id: Scalars['ID'];
};


export type QueryMapLayerConfigArgs = {
  id: Scalars['ID'];
};


export type QueryMibAlarmConfigArgs = {
  id: Scalars['ID'];
};


export type QueryModuleMapSettingValueArgs = {
  key: Scalars['String'];
};


export type QueryModuleMapSettingsArgs = {
  formViewName: Scalars['String'];
};


export type QueryNearbyCamerasArgs = {
  thresholdMiles?: InputMaybe<Scalars['Float']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};


export type QueryNearbyIntegrationsByPointArgs = {
  integrationType?: InputMaybe<IntegrationType>;
  thresholdMiles?: InputMaybe<Scalars['Float']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};


export type QueryNearbyIntersectionsByPointArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
  thresholdMiles?: InputMaybe<Scalars['Float']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};


export type QueryNetworkConditionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryNetworkConditionsArgs = {
  query?: InputMaybe<NetworkConditionInputQuery>;
};


export type QueryNetworkJurisdictionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryNetworkJurisdictionsArgs = {
  query?: InputMaybe<NetworkJurisdictionInputQuery>;
};


export type QueryNotificationsArgs = {
  query: NotificationsQuery;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationContactArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationPreferenceArgs = {
  key: Scalars['ID'];
};


export type QueryOrganizationsContactArgs = {
  query?: InputMaybe<OrganizationQuery>;
};


export type QueryParkingAreaArgs = {
  id: Scalars['ID'];
};


export type QueryParkingAreaMessageArgs = {
  id: Scalars['ID'];
};


export type QueryParkingAreaMessagesArgs = {
  query?: InputMaybe<ParkingAreaMessageInputQuery>;
};


export type QueryParkingAreasArgs = {
  query?: InputMaybe<ParkingAreaInputQuery>;
};


export type QueryPresetArgs = {
  id: Scalars['ID'];
};


export type QueryPtzLockArgs = {
  cameraId: Scalars['ID'];
};


export type QueryRampMeterControllersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  unassigned?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRampMeterIdsArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryRampMetersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryReportBuilderArgs = {
  id: Scalars['ID'];
};


export type QueryReportBuilderBlockArgs = {
  id: Scalars['ID'];
};


export type QueryReportBuilderBlocksArgs = {
  query?: InputMaybe<ReportBuilderBlockInputQuery>;
};


export type QueryReportBuilderFutureTasksArgs = {
  id: Scalars['String'];
  timezone: Scalars['String'];
};


export type QueryReportBuilderTaskArgs = {
  id: Scalars['ID'];
};


export type QueryReportBuilderTasksArgs = {
  from: Scalars['DateTime'];
  id: Scalars['ID'];
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


export type QueryReportBuildersArgs = {
  query?: InputMaybe<ReportBuilderInputQuery>;
};


export type QueryReportEventDataArgs = {
  params: ReportDataParamsInput;
};


export type QueryResourcePlanArgs = {
  id: Scalars['ID'];
};


export type QueryResourcePlanActivationResultsArgs = {
  query?: InputMaybe<ResourcePlanActivationResultInputQuery>;
};


export type QueryResourcePlanFutureTasksArgs = {
  id: Scalars['String'];
  timezone: Scalars['String'];
};


export type QueryResourcePlanTaskArgs = {
  id: Scalars['ID'];
};


export type QueryResourcePlanTasksArgs = {
  from: Scalars['DateTime'];
  id: Scalars['ID'];
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


export type QueryResourcePlanTasksByParentAndTypeArgs = {
  parentId: Scalars['ID'];
  taskType: Scalars['String'];
};


export type QueryResourcePlansArgs = {
  query?: InputMaybe<ResourcePlanInputQuery>;
};


export type QueryResponseRuleArgs = {
  id: Scalars['ID'];
};


export type QueryResponseRuleConfigArgs = {
  actionType: ResponseRuleActionType;
  conditionType: ResponseRuleConditionType;
  form?: InputMaybe<Scalars['ID']>;
};


export type QueryResponseRulesArgs = {
  query?: InputMaybe<ResponseRuleInputQuery>;
};


export type QueryRoadsArgs = {
  integrationType?: InputMaybe<Array<InputMaybe<IntegrationType>>>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QuerySceneArgs = {
  id: Scalars['ID'];
};


export type QueryScenesArgs = {
  sceneListFormat?: InputMaybe<SceneListFormat>;
};


export type QueryScheduledEventFutureTasksArgs = {
  id: Scalars['ID'];
  timezone: Scalars['String'];
};


export type QueryScheduledEventTaskArgs = {
  id: Scalars['ID'];
};


export type QueryScheduledEventTasksArgs = {
  from: Scalars['DateTime'];
  id: Scalars['ID'];
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


export type QueryScreenArgs = {
  id: Scalars['ID'];
};


export type QueryScreensArgs = {
  screenListFormat?: InputMaybe<ScreenListFormat>;
};


export type QuerySignArgs = {
  id: Scalars['ID'];
};


export type QuerySignCommandMessageArgs = {
  command: Scalars['String'];
  ids: Array<Scalars['ID']>;
};


export type QuerySignControllerFontsArgs = {
  id: Scalars['ID'];
};


export type QuerySignControllerGraphicsArgs = {
  id: Scalars['ID'];
};


export type QuerySignControllerMessagesArgs = {
  id: Scalars['ID'];
};


export type QuerySignCutoutArgs = {
  id: Scalars['ID'];
};


export type QuerySignCutoutsArgs = {
  query?: InputMaybe<SignCutoutInputQuery>;
};


export type QuerySignDisplayTypeArgs = {
  id: Scalars['ID'];
};


export type QuerySignFontArgs = {
  id: Scalars['ID'];
};


export type QuerySignGantriesArgs = {
  query?: InputMaybe<SignGantryInputQuery>;
};


export type QuerySignGantryArgs = {
  id: Scalars['ID'];
};


export type QuerySignGraphicArgs = {
  id: Scalars['ID'];
};


export type QuerySignGroupArgs = {
  id: Scalars['ID'];
};


export type QuerySignGroupMapEntitiesArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<SignGroupType>>;
};


export type QuerySignGroupsArgs = {
  query?: InputMaybe<SignGroupInputQuery>;
};


export type QuerySignIntegrationsArgs = {
  id: Scalars['ID'];
};


export type QuerySignInterlockValidateArgs = {
  input: Array<SignInterlockInput>;
  requiresApproval?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySignLaneControlSettingsArgs = {
  id: Scalars['ID'];
};


export type QuerySignMapEntitiesArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QuerySignMessageArgs = {
  id: Scalars['ID'];
};


export type QuerySignMessageHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  association?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};


export type QuerySignMessageLibraryArgs = {
  query?: InputMaybe<SignMessageInputQuery>;
};


export type QuerySignMessagePriorityArgs = {
  id: Scalars['ID'];
};


export type QuerySignMessagesArgs = {
  query?: InputMaybe<SignMessageInputQuery>;
};


export type QuerySignResponseRuleArgs = {
  id: Scalars['ID'];
};


export type QuerySignResponseRulesArgs = {
  query?: InputMaybe<SignResponseRuleInputQuery>;
};


export type QuerySignSchematicEntitiesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QuerySignalActionSetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySignalAppliedCommandFilterOptionsArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type QuerySignalAppliedCommandsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeExternalCenters?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  intersectionType?: InputMaybe<IntersectionType>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  timezone: Scalars['String'];
};


export type QuerySignalCommandDefinitionArgs = {
  commandType: Scalars['String'];
};


export type QuerySignalCommunicationReportArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDateTime: Scalars['DateTime'];
  limit?: InputMaybe<Scalars['Int']>;
  startDateTime: Scalars['DateTime'];
};


export type QuerySignalControllerArgs = {
  id: Scalars['ID'];
};


export type QuerySignalControllersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  unassigned?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySignalDetectorGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySignalModuleSettingsArgs = {
  formViewName: Scalars['String'];
};


export type QuerySignalScheduledFutureTasksByIntersectionArgs = {
  intersectionId: Scalars['ID'];
  intersectionType?: InputMaybe<IntersectionType>;
  timezone: Scalars['String'];
};


export type QuerySignalScheduledTaskArgs = {
  taskId: Scalars['ID'];
};


export type QuerySignalScheduledTasksArgs = {
  from: Scalars['DateTime'];
  intersectionType?: InputMaybe<IntersectionType>;
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


export type QuerySignalScheduledTasksByIntersectionArgs = {
  from: Scalars['DateTime'];
  intersectionId: Scalars['ID'];
  intersectionType?: InputMaybe<IntersectionType>;
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


export type QuerySignalTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySimpleAggregateArgs = {
  input: Array<AggregationInput>;
};


export type QuerySnapshotsArgs = {
  query?: InputMaybe<SnapshotsInputQuery>;
};


export type QuerySystemNotificationsArgs = {
  query: SystemNotificationsQuery;
};


export type QueryTaskProgressArgs = {
  query?: InputMaybe<TaskProgressQuery>;
};


export type QueryTimeSpaceDataArgs = {
  corridorId: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};


export type QueryTollRoadArgs = {
  id: Scalars['ID'];
};


export type QueryTollingPointArgs = {
  id: Scalars['ID'];
};


export type QueryTollingPointGateGroupsArgs = {
  id: Scalars['ID'];
};


export type QueryTollingPointsArgs = {
  query?: InputMaybe<TollingPointsQuery>;
};


export type QueryTollingPricingArgs = {
  id: Scalars['ID'];
};


export type QueryTollingPricingConfirmedRateHistoryArgs = {
  query?: InputMaybe<TollingInputQuery>;
};


export type QueryTollingPricingConfirmedRatesArgs = {
  query?: InputMaybe<TollingInputQuery>;
};


export type QueryTollingPricingGenerateConfirmedRatesArgs = {
  id: Scalars['ID'];
};


export type QueryTollingPricingHistoricalRateArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type QueryTollingPricingHistoricalRateHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryTollingPricingHistoricalRateHistoryListArgs = {
  query?: InputMaybe<TollingInputQuery>;
};


export type QueryTollingPricingListArgs = {
  query?: InputMaybe<TollingPricingQuery>;
};


export type QueryTollingPricingRateHistoryArgs = {
  query?: InputMaybe<TollingInputQuery>;
};


export type QueryTollingPricingRateOptionsArgs = {
  id: Scalars['ID'];
};


export type QueryTollingRoadsArgs = {
  query?: InputMaybe<TollingRoadQuery>;
};


export type QueryTollingSegmentArgs = {
  id: Scalars['ID'];
};


export type QueryTollingSegmentCommentsArgs = {
  entityId: Scalars['ID'];
};


export type QueryTollingSegmentsArgs = {
  query?: InputMaybe<TollingSegmentQuery>;
};


export type QueryTollingSignsArgs = {
  query?: InputMaybe<TollingInputQuery>;
};


export type QueryTourArgs = {
  id: Scalars['ID'];
};


export type QueryToursArgs = {
  query?: InputMaybe<TourInputQuery>;
};


export type QueryTrafficControlArgs = {
  id: Scalars['ID'];
};


export type QueryTrafficControlsArgs = {
  query?: InputMaybe<TrafficControlInputQuery>;
};


export type QueryTrafficEventDefinitionsArgs = {
  intersectionId: Scalars['String'];
};


export type QueryTrafficResponsiveActionControlLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  trafficResponsivePlanId: Scalars['ID'];
};


export type QueryTrafficResponsiveActionReportArgs = {
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
  trafficResponsivePlanId: Scalars['ID'];
};


export type QueryTrafficResponsiveActionResultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  trafficResponsivePlanId: Scalars['ID'];
};


export type QueryTrafficResponsivePlanSummaryArgs = {
  id: Scalars['ID'];
};


export type QueryTrafficResponsivePlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryTravelTimeArgs = {
  id: Scalars['ID'];
};


export type QueryTravelTimeDowHistoryArgs = {
  id: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};


export type QueryTravelTimeHistoryArgs = {
  query?: InputMaybe<TravelTimeHistoryInputQuery>;
};


export type QueryTravelTimesArgs = {
  query?: InputMaybe<TravelTimeInputQuery>;
};


export type QueryTunnelFanArgs = {
  id: Scalars['ID'];
};


export type QueryTunnelFansArgs = {
  query?: InputMaybe<TunnelDeviceInputQuery>;
};


export type QueryTunnelLightArgs = {
  id: Scalars['ID'];
};


export type QueryTunnelLightsArgs = {
  query?: InputMaybe<TunnelDeviceInputQuery>;
};


export type QueryTunnelLogArgs = {
  id: Scalars['ID'];
};


export type QueryTunnelLogsArgs = {
  query?: InputMaybe<TunnelLogInputQuery>;
};


export type QueryUngroupedCamerasToursArgs = {
  cameraGroupListFormat?: InputMaybe<CameraGroupListFormat>;
};


export type QueryUserGroupArgs = {
  id: Scalars['ID'];
};


export type QueryUserGroupsArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryUserPrivilegeAssignmentArgs = {
  userId: Scalars['ID'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  online?: InputMaybe<Scalars['Boolean']>;
  searchGroup?: InputMaybe<Scalars['Boolean']>;
  searchRole?: InputMaybe<Scalars['Boolean']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryUsersByPrivilegeArgs = {
  module: KineticModule;
  type: PrivilegeType;
};


export type QueryValidateActivityLogArgs = {
  id: Scalars['ID'];
};


export type QueryValidateDisplayTypeMessageArgs = {
  id: Scalars['ID'];
  message: SignMessageInput;
};


export type QueryValidateLibraryMessageArgs = {
  message: SignLibraryMessageInput;
};


export type QueryValidateSignMessageArgs = {
  id: Scalars['ID'];
  message: SignMessageInput;
  useDefaultFont?: InputMaybe<Scalars['Boolean']>;
};


export type QueryValidateSignalFirmwareArgs = {
  fileId: Scalars['ID'];
};


export type QueryVideoRecordingsArgs = {
  recordingsQueryInput?: InputMaybe<RecordingsQueryInput>;
};


export type QueryVideoStreamBlockedArgs = {
  cameraId: Scalars['ID'];
};


export type QueryVideoStreamBlocksArgs = {
  query?: InputMaybe<VideoStreamBlockInputQuery>;
};


export type QueryVideoTaskArgs = {
  taskId: Scalars['ID'];
};


export type QueryVideoTasksArgs = {
  cameraId: Scalars['ID'];
  from: Scalars['DateTime'];
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


export type QueryWeatherStationArgs = {
  id: Scalars['ID'];
};


export type QueryWeatherStationChartHistoryArgs = {
  query: WeatherStationChartHistoryInputQuery;
};


export type QueryWeatherStationHistoryArgs = {
  query: WeatherStationHistoryInputQuery;
};


export type QueryWeatherStationMapEntitiesArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryWeatherStationsArgs = {
  query?: InputMaybe<WeatherStationInputQuery>;
};


export type QueryWidgetArgs = {
  id: Scalars['ID'];
};


export type QueryWidgetsArgs = {
  widgetListFormat?: InputMaybe<WidgetListFormat>;
};


export type QueryWorkOrderConfigurationArgs = {
  id: Scalars['ID'];
};


export type QueryWorkOrderConfigurationsArgs = {
  query?: InputMaybe<WorkOrderConfigInputQuery>;
};

export enum RmcImplementAction {
  CommDisabled = 'COMM_DISABLED',
  CommFailed = 'COMM_FAILED',
  Dark = 'DARK',
  EmergencyGreen = 'EMERGENCY_GREEN',
  FixedRate = 'FIXED_RATE',
  HoldMeter = 'HOLD_METER',
  HoldNoNmeter = 'HOLD_NO_NMETER',
  HoldRestinGreen = 'HOLD_RESTIN_GREEN',
  RestinGreen = 'RESTIN_GREEN',
  TrafficResponsive = 'TRAFFIC_RESPONSIVE',
  Unknown = 'UNKNOWN'
}

export enum RmcImplementCommandSource {
  Central = 'CENTRAL',
  Communications = 'COMMUNICATIONS',
  CommDisabled = 'COMM_DISABLED',
  CommFailed = 'COMM_FAILED',
  Default = 'DEFAULT',
  Interconnect = 'INTERCONNECT',
  Manual = 'MANUAL',
  TimeBaseControl = 'TIME_BASE_CONTROL',
  Unknown = 'UNKNOWN'
}

export type RampMeterStatusCategories = {
  __typename?: 'RampMeterStatusCategories';
  commDisabled: Scalars['Int'];
  commFailed: Scalars['Int'];
  dark: Scalars['Int'];
  emergencyGreen: Scalars['Int'];
  fixedRate: Scalars['Int'];
  holdMeter: Scalars['Int'];
  holdNonMeter: Scalars['Int'];
  holdRestInGreen: Scalars['Int'];
  restInGreen: Scalars['Int'];
  trafficResponsive: Scalars['Int'];
  unknown: Scalars['Int'];
};

export enum RampType {
  /**  Config has no ramps  */
  None = 'NONE',
  /**  Config has an off ramp  */
  Off = 'OFF',
  /**  Config has an on ramp  */
  On = 'ON'
}

export type ReValidateDetectorPvrQuery = {
  detectorId: Scalars['ID'];
  endDateTime: Scalars['DateTime'];
  startDateTime: Scalars['DateTime'];
  type: Scalars['String'];
};

export type Recipient = {
  email?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<LabelType>;
  name?: InputMaybe<Scalars['String']>;
  recipientId?: InputMaybe<Scalars['String']>;
  smsRecipient: Scalars['Boolean'];
  type: RecipientType;
  workNumber?: InputMaybe<Scalars['String']>;
};

export type RecipientDto = {
  __typename?: 'RecipientDto';
  email?: Maybe<Scalars['String']>;
  label?: Maybe<LabelType>;
  name?: Maybe<Scalars['String']>;
  recipientId?: Maybe<Scalars['String']>;
  smsRecipient: Scalars['Boolean'];
  type: RecipientType;
  workNumber?: Maybe<Scalars['String']>;
};

export enum RecipientType {
  Contact = 'CONTACT',
  Group = 'GROUP'
}

export enum RecordingInitiatedBy {
  Event = 'EVENT',
  User = 'USER'
}

export enum RecordingType {
  Manual = 'MANUAL',
  Scheduled = 'SCHEDULED'
}

export type RecordingsQueryInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type RemoteAgentHeartbeat = {
  __typename?: 'RemoteAgentHeartbeat';
  clientId: Scalars['String'];
  instanceId: Scalars['String'];
  internalIpAddress: Scalars['String'];
  labels: Array<Scalars['String']>;
  lastHeartbeat: Scalars['DateTime'];
  processId: Scalars['Int'];
  remoteIpAddress: Scalars['String'];
  systemName: Scalars['String'];
  version: Scalars['String'];
};

export type RepeatInterval = {
  /**  the interval between repeats */
  interval: Scalars['Int'];
  /**  the unit of the interval */
  intervalUnit: IntervalUnit;
};

/**  Generic Object Type for Reports  */
export type Report = {
  __typename?: 'Report';
  /**  Represents tabs that report can have  */
  reportTabs: Array<Maybe<ReportTab>>;
  /**  Type of report selected  */
  reportType: Scalars['String'];
};

export type ReportBuilder = {
  __typename?: 'ReportBuilder';
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  name  */
  name: Scalars['String'];
  /**  sections  */
  sections: Array<ReportBuilderSection>;
};

export type ReportBuilderBlock = {
  __typename?: 'ReportBuilderBlock';
  /**  id  */
  id: Scalars['ID'];
  /**  name  */
  name: Scalars['String'];
  /**  data parameters  */
  parameters: ReportDataParams;
  /**  source  */
  source: ReportDataSource;
};

export type ReportBuilderBlockConnection = {
  __typename?: 'ReportBuilderBlockConnection';
  /**  Connection Edges  */
  edges: Array<ReportBuilderBlockEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type ReportBuilderBlockEdge = {
  __typename?: 'ReportBuilderBlockEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: ReportBuilderBlock;
};

export type ReportBuilderBlockInput = {
  /**  id  */
  id?: InputMaybe<Scalars['ID']>;
  /**  name  */
  name: Scalars['String'];
  /**  data parameters  */
  parameters: ReportDataParamsInput;
  /**  source  */
  source: ReportDataSource;
};

export type ReportBuilderBlockInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ReportBuilderConnection = {
  __typename?: 'ReportBuilderConnection';
  /**  Connection Edges  */
  edges: Array<ReportBuilderEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type ReportBuilderEdge = {
  __typename?: 'ReportBuilderEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The shift object  */
  node: ReportBuilder;
};

export type ReportBuilderInput = {
  /**  description  */
  description?: InputMaybe<Scalars['String']>;
  /**  identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  name  */
  name: Scalars['String'];
  /**  sections  */
  sections: Array<ReportBuilderSectionInput>;
};

export type ReportBuilderInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ReportBuilderSection = {
  __typename?: 'ReportBuilderSection';
  /**  blocks  */
  blocks: Array<ReportBuilderSectionBlock>;
  /**  id  */
  id: Scalars['ID'];
  /**  name  */
  name: Scalars['String'];
  /**  type  */
  type: ReportBuilderSectionType;
};

export type ReportBuilderSectionBlock = {
  __typename?: 'ReportBuilderSectionBlock';
  /**  block configuration  */
  blockId: Scalars['ID'];
  /**  id  */
  id: Scalars['ID'];
};

export type ReportBuilderSectionBlockInput = {
  /**  block configuration  */
  blockId: Scalars['ID'];
  /**  id  */
  id: Scalars['ID'];
};

export type ReportBuilderSectionInput = {
  /**  blocks  */
  blocks: Array<ReportBuilderSectionBlockInput>;
  /**  id  */
  id: Scalars['ID'];
  /**  name  */
  name: Scalars['String'];
  /**  type  */
  type: ReportBuilderSectionType;
};

export enum ReportBuilderSectionType {
  Footer = 'FOOTER',
  Header = 'HEADER',
  Section = 'SECTION'
}

export type ReportDataAggregation = {
  __typename?: 'ReportDataAggregation';
  /**  field to aggregate on  */
  field?: Maybe<Scalars['String']>;
  /**  aggregation type (COUNT, SUM....)  */
  type: ReportDataAggregationType;
};

export type ReportDataAggregationInput = {
  /**  field to aggregate on  */
  field?: InputMaybe<Scalars['String']>;
  /**  aggregation type (COUNT, SUM....)  */
  type: ReportDataAggregationType;
};

export enum ReportDataAggregationType {
  Avg = 'AVG',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export type ReportDataDateParams = {
  __typename?: 'ReportDataDateParams';
  /**  date to run relative  */
  date?: Maybe<Scalars['String']>;
  /**  end date  */
  end?: Maybe<Scalars['String']>;
  /**  modifier on the range  */
  modifier?: Maybe<Scalars['Int']>;
  /**  range type  */
  range?: Maybe<ReportDataDateRangeType>;
  /**  start date  */
  start?: Maybe<Scalars['String']>;
  /**  type  */
  type: ReportDataDateType;
};

export type ReportDataDateParamsInput = {
  /**  date to run relative  */
  date?: InputMaybe<Scalars['String']>;
  /**  end date  */
  end?: InputMaybe<Scalars['String']>;
  /**  modifier on the range  */
  modifier?: InputMaybe<Scalars['Int']>;
  /**  range type  */
  range?: InputMaybe<ReportDataDateRangeType>;
  /**  start date  */
  start?: InputMaybe<Scalars['String']>;
  /**  type  */
  type: ReportDataDateType;
};

export enum ReportDataDateRangeType {
  DaysAgo = 'DAYS_AGO',
  DaysAhead = 'DAYS_AHEAD',
  MonthsAgo = 'MONTHS_AGO',
  MonthsAhead = 'MONTHS_AHEAD',
  WeeksAgo = 'WEEKS_AGO',
  WeeksAhead = 'WEEKS_AHEAD',
  YearsAgo = 'YEARS_AGO',
  YearsAhead = 'YEARS_AHEAD'
}

export enum ReportDataDateType {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE'
}

export enum ReportDataDisplayType {
  BarChart = 'BAR_CHART',
  LineChart = 'LINE_CHART',
  PieChart = 'PIE_CHART',
  Table = 'TABLE',
  Text = 'TEXT'
}

export type ReportDataParams = {
  __typename?: 'ReportDataParams';
  /**  list of aggregations  */
  aggregations: Array<ReportDataAggregation>;
  /**  date params  */
  date: ReportDataDateParams;
  /**  additional filters  */
  filters: Array<Filter>;
  /**  field to group by  */
  groupBy?: Maybe<Scalars['String']>;
  /**  table configuration  */
  table?: Maybe<ReportDataTableParams>;
  /**  how to visualize the data  */
  type: ReportDataDisplayType;
};

export type ReportDataParamsInput = {
  /**  list of aggregations  */
  aggregations: Array<ReportDataAggregationInput>;
  /**  date params  */
  date: ReportDataDateParamsInput;
  /**  additional filters  */
  filters: Array<FilterInput>;
  /**  field to group by  */
  groupBy?: InputMaybe<Scalars['String']>;
  /**  table configuration  */
  table?: InputMaybe<ReportDataTableParamsInput>;
  /**  how to visualize the data  */
  type: ReportDataDisplayType;
};

export enum ReportDataSource {
  Events = 'EVENTS'
}

export type ReportDataTableCellParams = {
  __typename?: 'ReportDataTableCellParams';
  /**  attribute to fetch  */
  attribute?: Maybe<Scalars['String']>;
  /**  label to display  */
  label?: Maybe<Scalars['String']>;
  /**  the type of cell  */
  type: ReportDataTableCellType;
};

export type ReportDataTableCellParamsInput = {
  /**  attribute to fetch  */
  attribute?: InputMaybe<Scalars['String']>;
  /**  label to display  */
  label?: InputMaybe<Scalars['String']>;
  /**  the type of cell  */
  type: ReportDataTableCellType;
};

export enum ReportDataTableCellType {
  Average = 'AVERAGE',
  Empty = 'EMPTY',
  Label = 'LABEL',
  Sum = 'SUM',
  Value = 'VALUE'
}

export type ReportDataTableParams = {
  __typename?: 'ReportDataTableParams';
  /**  data row  */
  data: ReportDataTableRowParams;
  /**  header row  */
  header: ReportDataTableRowParams;
  /**  additional rows  */
  rows: Array<ReportDataTableRowParams>;
};

export type ReportDataTableParamsInput = {
  /**  data row  */
  data: ReportDataTableRowParamsInput;
  /**  header row  */
  header: ReportDataTableRowParamsInput;
  /**  additional rows  */
  rows: Array<ReportDataTableRowParamsInput>;
};

export type ReportDataTableRowParams = {
  __typename?: 'ReportDataTableRowParams';
  /**  the array of cells to draw in row  */
  cells: Array<ReportDataTableCellParams>;
};

export type ReportDataTableRowParamsInput = {
  /**  the array of cells to draw in row  */
  cells: Array<ReportDataTableCellParamsInput>;
};

export type ReportDto = {
  logo?: InputMaybe<Scalars['String']>;
  metaData?: InputMaybe<Array<Element>>;
  printDateTime?: InputMaybe<Scalars['String']>;
  reportPreference?: InputMaybe<ReportPreference>;
  reportTitle: Scalars['String'];
  tables?: InputMaybe<Array<ReportTable>>;
};

export type ReportPreference = {
  /** The preferred date format of the user */
  dateFormat: Scalars['String'];
  /** The preferred time format of the user */
  timeFormat: Scalars['String'];
};

export type ReportTab = {
  __typename?: 'ReportTab';
  /**  Holds data to plot graph  */
  graphData: GraphData;
  /**  Report Tab Title  */
  tabName: Scalars['String'];
  /**  Holds data to draw tables  */
  tableData: Array<GroupedReportTable>;
  /**  Name of selected intersection name  */
  title: Scalars['String'];
};

export type ReportTable = {
  headers?: InputMaybe<Array<Header>>;
  name: Scalars['String'];
  rows?: InputMaybe<Array<Row>>;
  swapped?: InputMaybe<Scalars['Boolean']>;
};

export type Resource = {
  __typename?: 'Resource';
  /**  Is resource acknowledged */
  acknowledged?: Maybe<Scalars['Boolean']>;
  /**  Identifies if the resource was added manually */
  adhoc?: Maybe<Scalars['Boolean']>;
  /**  Data for the resource  */
  data: Scalars['Object'];
  /**  Identifier of the resource  */
  id: Scalars['String'];
  /**  Resource Status  */
  status: ResourceStatus;
  /**  Resource Type  */
  type: ResourceType;
};

export type ResourceInput = {
  /**  Is resource acknowledged */
  acknowledged?: InputMaybe<Scalars['Boolean']>;
  /**  Is the resource adhoc  */
  adhoc?: InputMaybe<Scalars['Boolean']>;
  /**  Data for the resource  */
  data: Scalars['Object'];
  /**  Identifier of the resource  */
  id: Scalars['ID'];
  /**  Resource Status  */
  status?: InputMaybe<ResourceStatus>;
  /**  Resource Type  */
  type?: InputMaybe<ResourceType>;
};

export type ResourcePlan = {
  __typename?: 'ResourcePlan';
  /**  Resource Plan Details  */
  details: ResourcePlanDetails;
  /**  The identifier of the resourcePlan  */
  id: Scalars['ID'];
  /**  The list of resources  */
  resources: Array<Resource>;
};

export type ResourcePlanActivationResult = {
  __typename?: 'ResourcePlanActivationResult';
  /** the activation id for the resource plan */
  activationId: Scalars['String'];
  /**  The activation status of the resource  */
  activationStatus: ActivationStatus;
  /**  The error message if any  */
  errorMessage?: Maybe<Scalars['String']>;
  /**  The identifier of the resourcePlan activation result  */
  id: Scalars['ID'];
  /**  The resource identifier  */
  resourceId: Scalars['String'];
  /**  The resource name */
  resourceName?: Maybe<Scalars['String']>;
  /**  The resource plan identifier */
  resourcePlanId: Scalars['String'];
  /**  The resource type  */
  resourceType: ResourceType;
};

export type ResourcePlanActivationResultConnection = {
  __typename?: 'ResourcePlanActivationResultConnection';
  /**  Connection Edges  */
  edges: Array<ResourcePlanActivationResultConnectionEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type ResourcePlanActivationResultConnectionEdge = {
  __typename?: 'ResourcePlanActivationResultConnectionEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The resource plan activation result object  */
  node: ResourcePlanActivationResult;
};

export type ResourcePlanActivationResultInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ResourcePlanConnection = {
  __typename?: 'ResourcePlanConnection';
  /**  Connection Edges  */
  edges: Array<ResourcePlanConnectionEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type ResourcePlanConnectionEdge = {
  __typename?: 'ResourcePlanConnectionEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The resource plan object  */
  node: ResourcePlan;
};

export type ResourcePlanDetails = {
  __typename?: 'ResourcePlanDetails';
  /**  Indicates if the resource plan has been approved */
  approved?: Maybe<Scalars['Boolean']>;
  /**  the approving user  */
  approver?: Maybe<Scalars['ID']>;
  /**  The description of the resourcePlan  */
  description?: Maybe<Scalars['String']>;
  /**  The name of the resourcePlan  */
  name: Scalars['String'];
  /**  plan settings  */
  settings?: Maybe<Scalars['Object']>;
  /**  Resource Plan status  */
  status: ResourceStatus;
};

export type ResourcePlanDetailsInput = {
  /** Indicates if the resource plan has been approved */
  approved?: InputMaybe<Scalars['Boolean']>;
  /**  the approving user  */
  approver?: InputMaybe<Scalars['ID']>;
  /**  The description of the resourcePlan  */
  description?: InputMaybe<Scalars['String']>;
  /**  The name of the resourcePlan  */
  name: Scalars['String'];
  /**  plan settings  */
  settings?: InputMaybe<Scalars['Object']>;
  /**  Resource Plan status  */
  status: ResourceStatus;
};

export type ResourcePlanInput = {
  /**  Resource Plan Details  */
  details: ResourcePlanDetailsInput;
  /**  The identifier of the resourcePlan  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The list of resources  */
  resources: Array<ResourceInput>;
};

export type ResourcePlanInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  identifier of corridor  */
  corridorId?: InputMaybe<Scalars['ID']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
  /**  Indicates if the resource plan is system generated (true for Event Resource Plan) or manually created (false for Manual Resource Plan)  */
  systemGenerated?: InputMaybe<Scalars['Boolean']>;
};

export enum ResourceStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  New = 'NEW',
  NotPresent = 'NOT_PRESENT',
  Pending = 'PENDING',
  Queued = 'QUEUED',
  Scheduled = 'SCHEDULED',
  Unscheduled = 'UNSCHEDULED'
}

export enum ResourceType {
  ActionSet = 'ACTION_SET',
  Camera = 'CAMERA',
  Detour = 'DETOUR',
  DriverAssistance = 'DRIVER_ASSISTANCE',
  DualSpeedLimit = 'DUAL_SPEED_LIMIT',
  Email = 'EMAIL',
  FiveOneOne = 'FIVE_ONE_ONE',
  LaneControl = 'LANE_CONTROL',
  RecommendedContacts = 'RECOMMENDED_CONTACTS',
  ResourcePlan = 'RESOURCE_PLAN',
  Sign = 'SIGN',
  Sms = 'SMS',
  SpeedLimit = 'SPEED_LIMIT',
  TrafficControl = 'TRAFFIC_CONTROL'
}

export enum ResponseAlgorithmType {
  Minnesota = 'MINNESOTA'
}

export type ResponseRule = {
  __typename?: 'ResponseRule';
  /**  action details  */
  action: ResponseRuleAction;
  /**  if the rule can be run in automatic mode  */
  automatic: Scalars['Boolean'];
  /**  condition details  */
  condition: ResponseRuleCondition;
  /**  associated corridor  */
  corridor?: Maybe<Scalars['ID']>;
  /**  if the rule is enabled  */
  enabled: Scalars['Boolean'];
  /**  associated event form  */
  form?: Maybe<Scalars['ID']>;
  /**  identifier of the rule  */
  id: Scalars['ID'];
  /**  name of the rule  */
  name: Scalars['String'];
  /**  type of rule  */
  type: ResponseRuleType;
};

export type ResponseRuleAction = {
  __typename?: 'ResponseRuleAction';
  /**  list of action sets to recommend  */
  actionSets: Array<Scalars['ID']>;
  /**  list of detours to recommend  */
  detours: Array<Scalars['ID']>;
  /** lcs action to recommend */
  laneControlAction?: Maybe<LaneControlAction>;
  /**  sign message template to recommend  */
  message?: Maybe<SignMessage>;
  /**  list of contacts to recommend  */
  recommendedContacts?: Maybe<Array<Maybe<RecipientDto>>>;
  /**  list of resource plans to recommend  */
  resourcePlans: Array<Scalars['ID']>;
  /**  action type  */
  type: ResponseRuleActionType;
};

export type ResponseRuleActionInput = {
  /**  list of action sets to recommend  */
  actionSets?: InputMaybe<Array<Scalars['ID']>>;
  /**  list of detours to recommend  */
  detours?: InputMaybe<Array<Scalars['ID']>>;
  /** lcs action to recommend */
  laneControlAction?: InputMaybe<LaneControlActionInput>;
  /**  sign message template to recommend  */
  message?: InputMaybe<SignMessageInput>;
  /**  list of contacts to recommend  */
  recommendedContacts?: InputMaybe<Array<InputMaybe<Recipient>>>;
  /**  list of resource plans to recommend  */
  resourcePlans?: InputMaybe<Array<Scalars['ID']>>;
  /**  action type  */
  type: ResponseRuleActionType;
};

export enum ResponseRuleActionType {
  /**  recommend action sets to activate  */
  ActionSet = 'ACTION_SET',
  /**  detours  */
  Detour = 'DETOUR',
  /**  recommend driver assistance  */
  DriverAssistance = 'DRIVER_ASSISTANCE',
  /** recommend lane control signs by selection */
  LaneControl = 'LANE_CONTROL',
  /**  recommend contacts  */
  RecommendedContacts = 'RECOMMENDED_CONTACTS',
  /**  recommend resources from plan  */
  ResourcePlan = 'RESOURCE_PLAN',
  /**  recommend sign messages by selection  */
  SignMessage = 'SIGN_MESSAGE',
  /** recommend variable speed limit signs by selection */
  VariableSpeedLimit = 'VARIABLE_SPEED_LIMIT'
}

export type ResponseRuleCondition = {
  __typename?: 'ResponseRuleCondition';
  /**  rule priority  */
  priority: Scalars['Int'];
  /**  mvel rule string  */
  rule: Scalars['String'];
  /**  query builder tree  */
  tree: Scalars['Object'];
  /**  condition type  */
  type: ResponseRuleConditionType;
};

export type ResponseRuleConditionInput = {
  /**  rule priority  */
  priority: Scalars['Int'];
  /**  mvel rule string  */
  rule: Scalars['String'];
  /**  query builder tree  */
  tree: Scalars['Object'];
  /**  condition type  */
  type: ResponseRuleConditionType;
};

export enum ResponseRuleConditionType {
  /**  trigger rule by event  */
  Event = 'EVENT',
  /**  trigger rule by network conditions  */
  NetworkCondition = 'NETWORK_CONDITION',
  /**  trigger rule by queue detection  */
  QueueDetection = 'QUEUE_DETECTION',
  /**  trigger rule by time of day  */
  Tolling = 'TOLLING',
  /**  trigger rule by travel time detection  */
  TravelTimeDetection = 'TRAVEL_TIME_DETECTION',
  /**  trigger rule by weather detection  */
  WeatherDetection = 'WEATHER_DETECTION'
}

export type ResponseRuleConnection = {
  __typename?: 'ResponseRuleConnection';
  /**  connection edges  */
  edges: Array<ResponseRuleConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type ResponseRuleConnectionEdge = {
  __typename?: 'ResponseRuleConnectionEdge';
  /**  cursor position  */
  cursor?: Maybe<Scalars['String']>;
  /**  response rule node  */
  node: ResponseRule;
};

export type ResponseRuleInput = {
  /**  action details  */
  action: ResponseRuleActionInput;
  /**  if the rule can be run in automatic mode  */
  automatic: Scalars['Boolean'];
  /**  condition details  */
  condition: ResponseRuleConditionInput;
  /**  associated corridor  */
  corridor?: InputMaybe<Scalars['ID']>;
  /**  if the rule is enabled  */
  enabled: Scalars['Boolean'];
  /**  associated event form  */
  form?: InputMaybe<Scalars['ID']>;
  /**  identifier of the rule  */
  id?: InputMaybe<Scalars['ID']>;
  /**  name of the rule  */
  name: Scalars['String'];
  /**  type of rule  */
  type: ResponseRuleType;
};

export type ResponseRuleInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum ResponseRuleType {
  /**  rule is triggered by corridor response  */
  Corridor = 'CORRIDOR',
  /**  rule is triggered by event response  */
  Event = 'EVENT'
}

export enum RoadwayType {
  /**  Indicates config is in the current direction  */
  Current = 'CURRENT',
  /**  Indicates config is in the opposite direction  */
  Opposite = 'OPPOSITE',
  /**  Indicates config is in the reversible direction  */
  Reversible = 'REVERSIBLE'
}

export type Row = {
  rows?: InputMaybe<Array<StyledObject>>;
};

export enum RsuMainStatus {
  CommDisabled = 'COMM_DISABLED',
  CommFailed = 'COMM_FAILED',
  Critical = 'CRITICAL',
  Okay = 'OKAY',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  Warning = 'WARNING'
}

export type RsuMainStatusCategory = {
  __typename?: 'RsuMainStatusCategory';
  commDisabled: Scalars['Int'];
  commFailed: Scalars['Int'];
  critical: Scalars['Int'];
  okay: Scalars['Int'];
  other: Scalars['Int'];
  unknown: Scalars['Int'];
  warning: Scalars['Int'];
};

export enum RsuModeStatus {
  CommDisabled = 'COMM_DISABLED',
  CommFailed = 'COMM_FAILED',
  Fault = 'FAULT',
  Operate = 'OPERATE',
  Other = 'OTHER',
  Standby = 'STANDBY',
  Unknown = 'UNKNOWN'
}

export type RsuModeStatusCategory = {
  __typename?: 'RsuModeStatusCategory';
  commDisabled: Scalars['Int'];
  commFailed: Scalars['Int'];
  fault: Scalars['Int'];
  operate: Scalars['Int'];
  other: Scalars['Int'];
  standby: Scalars['Int'];
  unknown: Scalars['Int'];
};

export enum RsuRadioStatus {
  Alternating = 'ALTERNATING',
  Both = 'BOTH',
  CommDisabled = 'COMM_DISABLED',
  CommFailed = 'COMM_FAILED',
  Continuous = 'CONTINUOUS',
  None = 'NONE',
  Unknown = 'UNKNOWN'
}

export type SaveDetectorConfigInput = {
  config?: InputMaybe<DetectorConfigInput>;
  detectorId: Scalars['ID'];
};

export type SaveDetectorConnectionLogInput = {
  connectionId: Scalars['ID'];
  detectorId: Scalars['ID'];
  logs?: InputMaybe<Array<DetectorConnectionLogInput>>;
};

export type SaveDetectorExtraConfigInput = {
  config?: InputMaybe<DetectorExtraConfigInput>;
  detectorId: Scalars['ID'];
};

export type SaveHiTracLogPacketsInput = {
  detectorId: Scalars['ID'];
  deviceType: Scalars['Int'];
  logs?: InputMaybe<Array<HiTracLogRecord>>;
};

export type SaveHiTracVehiclePacketsInput = {
  detectorId: Scalars['ID'];
  vehicles?: InputMaybe<Array<HiTracVehicleInput>>;
};

export type Scene = {
  __typename?: 'Scene';
  content: Array<Maybe<SceneContent>>;
  id: Scalars['ID'];
  layout: Layout;
  name: Scalars['String'];
  ownershipType: OwnershipType;
};

export type SceneContent = Camera | Tour | Widget;

export type SceneContentInput = {
  camera?: InputMaybe<Scalars['ID']>;
  tour?: InputMaybe<Scalars['ID']>;
  widget?: InputMaybe<Scalars['ID']>;
};

export type SceneInput = {
  content: Array<SceneContentInput>;
  id?: InputMaybe<Scalars['ID']>;
  layout: EmbeddedLayoutInput;
  name: Scalars['String'];
  ownershipType: OwnershipType;
};

export type SceneListFormat = {
  searchFields?: InputMaybe<Array<SceneSearchField>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<SceneSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum SceneSearchField {
  Name = 'NAME'
}

export enum SceneSortField {
  Id = 'ID',
  Name = 'NAME'
}

export type Schedule = {
  /**  Create a scheduled job that will fire the Job at given moments in time, defined with Unix 'cron-like' schedule definitions. */
  cronExpression?: InputMaybe<Scalars['String']>;
  /**  Creates a scheduled job that will fire every N seconds, minutes or hours (see repeatInterval) during a given time window on specified days of the week. */
  dailyTimeInterval?: InputMaybe<DailyTimeInterval>;
  /**  When to end the schedule */
  end?: InputMaybe<Scalars['DateTime']>;
  /**  Create a scheduled job that will fire upon repeating calendar time intervals. The job will fire every N (see RepeatInterval) units of calendar time (see IntervalUnit) */
  repeatInterval?: InputMaybe<RepeatInterval>;
  /**  Rrule schedule to run the job */
  rruleExpression?: InputMaybe<Scalars['String']>;
  /**  Simple interval to run a job now, or for at a specific interval. */
  simpleInterval?: InputMaybe<SimpleInterval>;
  /**  When to start the schedule */
  start?: InputMaybe<Scalars['DateTime']>;
};

export type Screen = {
  __typename?: 'Screen';
  content: Array<Maybe<SceneContent>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  layout: Layout;
  name: Scalars['String'];
  orderNum?: Maybe<Scalars['Int']>;
  ownershipType: OwnershipType;
  type?: Maybe<ScreenType>;
  videoWallDetail?: Maybe<VideoWallDetail>;
  videoWallId?: Maybe<Scalars['ID']>;
};

export type ScreenInput = {
  content: Array<SceneContentInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  layout: EmbeddedLayoutInput;
  name: Scalars['String'];
  orderNum: Scalars['Int'];
  ownershipType: OwnershipType;
  type?: InputMaybe<ScreenType>;
  videoWallId?: InputMaybe<Scalars['ID']>;
};

export type ScreenListFormat = {
  searchFields?: InputMaybe<Array<ScreenSearchField>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ScreenOrderInput = {
  id: Scalars['ID'];
  orderNum: Scalars['Int'];
};

export enum ScreenSearchField {
  Description = 'DESCRIPTION',
  Name = 'NAME'
}

export enum ScreenType {
  Hardware = 'HARDWARE',
  Software = 'SOFTWARE'
}

export type SetMibsInput = {
  bitIndex?: InputMaybe<Scalars['Int']>;
  indexes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name: Scalars['String'];
  shortName?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Object']>;
};

export type SetVideoWallAreaCameraArguments = {
  /**  layout area to camera mapping. */
  cameraMapping: Scalars['Object'];
  /**  device id */
  id: Scalars['ID'];
  /**  layout id */
  layoutId: Scalars['String'];
  /**  request id */
  requestId?: InputMaybe<Scalars['String']>;
  /**  user id */
  userId?: InputMaybe<Scalars['String']>;
};

export type SetVideoWallLayoutArguments = {
  /**  device id */
  id: Scalars['ID'];
  /**  layout id */
  layoutId: Scalars['String'];
  /**  request id */
  requestId?: InputMaybe<Scalars['String']>;
  /**  user id */
  userId?: InputMaybe<Scalars['String']>;
};

export enum Severity {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE',
  Unknown = 'UNKNOWN'
}

export enum ShoulderType {
  /**  Config has both shoulders  */
  Both = 'BOTH',
  /**  Config only has a left shoulder  */
  Left = 'LEFT',
  /**  Config has no shoulders  */
  None = 'NONE',
  /**  Config only has a right shoulder  */
  Right = 'RIGHT'
}

export type Sign = {
  __typename?: 'Sign';
  /**  default background color  */
  backgroundColor?: Maybe<Scalars['String']>;
  /**  The current brightness level  */
  brightness?: Maybe<Scalars['Int']>;
  /**  The number of brightness levels  */
  brightnessLevels?: Maybe<Scalars['Int']>;
  /**  The brightness mode  */
  brightnessMode?: Maybe<SignBrightnessMode>;
  /**  The cabinet temperature  */
  cabinetTemperature?: Maybe<Scalars['Int']>;
  /**  The set of currently supported capabilities  */
  capabilities: Array<SignCapability>;
  /**  The sign color scheme  */
  colorScheme?: Maybe<SignColorScheme>;
  /**  mapping of command to slot  */
  commands: Array<SignCommandNumber>;
  /**  Communication Parameters  */
  communicationParameters?: Maybe<Scalars['Object']>;
  /**  The current communication status of the sign  */
  communicationStatus: CommunicationState;
  /**  control mode  */
  controlMode?: Maybe<SignControlMode>;
  /**  Corridors associated with the sign.  */
  corridors?: Maybe<Array<Maybe<AssociatedCorridor>>>;
  /**  The currently displayed message on the sign  */
  currentMessage?: Maybe<SignQueuedMessage>;
  /**  Default message for the sign  */
  defaultMessage?: Maybe<SignQueuedMessage>;
  /**  Flag to determine whether default message is enabled  */
  defaultMessageEnabled?: Maybe<Scalars['Boolean']>;
  /**  The description of the sign  */
  description?: Maybe<Scalars['String']>;
  /**  The direction of the sign  */
  direction?: Maybe<Scalars['String']>;
  /**  The state of the display  */
  displayState: SignDisplayState;
  /**  Display Type  */
  displayType: SignDisplayType;
  /**  The list of current errors  */
  errors: Array<SignError>;
  /**  If this device is owned by an external center  */
  external: Scalars['Boolean'];
  /**  The ID of the external center that owns this device  */
  externalCenter?: Maybe<Scalars['String']>;
  /**  The current firmware of the sign  */
  firmware?: Maybe<Scalars['String']>;
  /**  mapping of font to number  */
  fonts: Array<SignFontNumber>;
  /**  default foreground color  */
  foregroundColor?: Maybe<Scalars['String']>;
  /**  the time at which a closed command can be posted based on gates  */
  gateClosedTime?: Maybe<Scalars['DateTime']>;
  /**  the time at which an open command can be posted based on gates  */
  gateOpenTime?: Maybe<Scalars['DateTime']>;
  /**  mapping of graphic to number  */
  graphics: Array<SignGraphicNumber>;
  /**  High Critical Temperature  */
  highCriticalTemperature?: Maybe<Scalars['Int']>;
  /**  The housing temperature  */
  housingTemperature?: Maybe<Scalars['Int']>;
  /**  The identifier of the sign  */
  id: Scalars['ID'];
  /**
   * describes the identifier of the integration, if the
   * integration has split displays, this will be the
   * id of the integration, if no splits, this will be
   * the same as the sign identifier
   */
  integrationId: Scalars['ID'];
  /**  lane control settings identifier  */
  laneControlSettingsId?: Maybe<Scalars['String']>;
  /**  direction of the lane  */
  laneDirection?: Maybe<Scalars['String']>;
  /**  Lane Position  */
  lanePosition?: Maybe<Scalars['Int']>;
  /**  Lane Type  */
  laneType?: Maybe<LaneType>;
  /**  The last time the sign was successfully polled  */
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  /**  Time at which the sign was last reset  */
  lastReset?: Maybe<Scalars['DateTime']>;
  /**  The coordinate of the sign  */
  location: Scalars['JSON'];
  /**  The location description  */
  locationDescription?: Maybe<Scalars['String']>;
  /**  If the sign is in a fixed location  */
  locationFixed?: Maybe<Scalars['Boolean']>;
  /**  Low Critical Temperature  */
  lowCriticalTemperature?: Maybe<Scalars['Int']>;
  /**  Median  */
  median?: Maybe<Scalars['Boolean']>;
  /**  message preferences  */
  messagePreferences?: Maybe<SignMessagePreferences>;
  /**  mapping of message to slot  */
  messages: Array<SignMessageNumber>;
  /**  The name of the sign  */
  name: Scalars['String'];
  /**  if the sign is polling enabled  */
  pollEnabled: Scalars['Boolean'];
  /**  The power source of the sign  */
  powerSource?: Maybe<SignPowerSource>;
  /**  The list of currently queued messages */
  queue: Array<SignQueuedMessage>;
  /**  if the sign is read only  */
  readOnly?: Maybe<Scalars['Boolean']>;
  /**  The reference point of the sign  */
  referencePoint?: Maybe<Scalars['Float']>;
  /**  Restrict public visibility of the device in Data Prism.  */
  restricted?: Maybe<Scalars['Boolean']>;
  /**  The road that the sign serves  */
  road?: Maybe<Scalars['String']>;
  /**  speed settings  */
  speedSettings?: Maybe<SignSpeedSettings>;
  /**  if the sign is enabled  */
  systemEnabled: Scalars['Boolean'];
  /**  test results  */
  tests?: Maybe<SignTests>;
  /**  list of travel times this sign can display  */
  travelTimeSegments: Array<Scalars['String']>;
  /**  The volt level of the sign  */
  volts?: Maybe<Scalars['Float']>;
};

export enum SignActivityLogType {
  ControllerReset = 'CONTROLLER_RESET',
  SignBrightness = 'SIGN_BRIGHTNESS',
  SignExtendMessageTime = 'SIGN_EXTEND_MESSAGE_TIME',
  SignFontDownloaded = 'SIGN_FONT_DOWNLOADED',
  SignFoundBlank = 'SIGN_FOUND_BLANK',
  SignMessageBlanked = 'SIGN_MESSAGE_BLANKED',
  SignMessageDisplayed = 'SIGN_MESSAGE_DISPLAYED',
  SignMessageQueued = 'SIGN_MESSAGE_QUEUED',
  SignPoll = 'SIGN_POLL',
  SignState = 'SIGN_STATE',
  UnexpectedMessage = 'UNEXPECTED_MESSAGE'
}

export type SignApprovalMessageDto = {
  __typename?: 'SignApprovalMessageDto';
  /**  the identifier  */
  id: Scalars['ID'];
  /**  the message to display  */
  message: SignMessage;
};

export type SignBlankArguments = {
  /**  integration id */
  id: Scalars['ID'];
  /**  number of logical signs */
  numberOfLogicalSigns?: InputMaybe<Scalars['Int']>;
  /**  request id */
  requestId?: InputMaybe<Scalars['String']>;
  /**  sign id */
  signId: Scalars['ID'];
  /**  split line number */
  splitLineNumber?: InputMaybe<Scalars['Int']>;
  /**  split logical sign number */
  splitLogicalSignNumber?: InputMaybe<Scalars['Int']>;
  /**  user display name */
  userDisplayName?: InputMaybe<Scalars['String']>;
  /**  user id */
  userId?: InputMaybe<Scalars['String']>;
};

export enum SignBrightnessMode {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export enum SignCapability {
  Beacons = 'BEACONS',
  BrightnessControl = 'BRIGHTNESS_CONTROL',
  ChangeBackgroundColor = 'CHANGE_BACKGROUND_COLOR',
  ChangeForegroundColor = 'CHANGE_FOREGROUND_COLOR',
  DownloadFonts = 'DOWNLOAD_FONTS',
  ExtendedFonts = 'EXTENDED_FONTS',
  Flashing = 'FLASHING',
  GpsLocation = 'GPS_LOCATION',
  Graphics = 'GRAPHICS',
  GraphicsWithText = 'GRAPHICS_WITH_TEXT',
  ManageFonts = 'MANAGE_FONTS',
  ManageGraphics = 'MANAGE_GRAPHICS',
  MessagesArrowBoard = 'MESSAGES_ARROW_BOARD',
  MessagesContraflowLane = 'MESSAGES_CONTRAFLOW_LANE',
  MessagesDualSpeedLimit = 'MESSAGES_DUAL_SPEED_LIMIT',
  MessagesGeneral = 'MESSAGES_GENERAL',
  MessagesLaneControl = 'MESSAGES_LANE_CONTROL',
  MessagesSpeedLimit = 'MESSAGES_SPEED_LIMIT',
  MessagesTolling = 'MESSAGES_TOLLING',
  MessagesTravelTime = 'MESSAGES_TRAVEL_TIME',
  ReportsFirmware = 'REPORTS_FIRMWARE',
  ReportsPowerStatus = 'REPORTS_POWER_STATUS',
  ReportsTemperature = 'REPORTS_TEMPERATURE',
  ReportsUptime = 'REPORTS_UPTIME',
  SideMounted = 'SIDE_MOUNTED',
  Simulator = 'SIMULATOR',
  SoftwareReset = 'SOFTWARE_RESET',
  SplitDisplay = 'SPLIT_DISPLAY',
  SupportsResponse = 'SUPPORTS_RESPONSE',
  TestFans = 'TEST_FANS',
  TestLamps = 'TEST_LAMPS',
  TestPixels = 'TEST_PIXELS'
}

export type SignCharacterLabel = {
  __typename?: 'SignCharacterLabel';
  /**  the character index  */
  characterIndex: Scalars['Int'];
  /**  character label  */
  label: Scalars['String'];
};

export enum SignColorScheme {
  Color_24Bit = 'COLOR_24_BIT',
  ColorClassic = 'COLOR_CLASSIC',
  Monochrome_1Bit = 'MONOCHROME_1_BIT',
  Monochrome_8Bit = 'MONOCHROME_8_BIT',
  Other = 'OTHER'
}

export type SignCommandNumber = {
  __typename?: 'SignCommandNumber';
  /**  name of the command  */
  command: Scalars['String'];
  /**  slot of the message  */
  number: Scalars['Int'];
};

export type SignCommandNumberInput = {
  /**  name of the command  */
  command: Scalars['String'];
  /**  slot of the message  */
  number: Scalars['Int'];
};

export type SignConnection = {
  __typename?: 'SignConnection';
  edges: Array<SignConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignConnectionEdge = {
  __typename?: 'SignConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Sign;
};

export enum SignControlMode {
  Central = 'CENTRAL',
  CentralOverride = 'CENTRAL_OVERRIDE',
  External = 'EXTERNAL',
  Local = 'LOCAL',
  Other = 'OTHER',
  Simulation = 'SIMULATION'
}

export type SignControllerFont = {
  __typename?: 'SignControllerFont';
  /**  The height of the font characters in pixels  */
  characterHeight: Scalars['Int'];
  /**  The number of pixels between characters  */
  characterSpacing: Scalars['Int'];
  /**  The font character bitmaps in a hex string  */
  font: Scalars['String'];
  /**  The font file name  */
  fontFileName?: Maybe<Scalars['String']>;
  /**  The font number for the font  */
  fontNumber: Scalars['Int'];
  /**  The font version  */
  fontVersion: Scalars['Int'];
  /**  The identifier of the font  */
  id: Scalars['ID'];
  /**  The number of pixels between lines  */
  lineSpacing: Scalars['Int'];
};

export type SignCutout = {
  __typename?: 'SignCutout';
  /**  the description  */
  description?: Maybe<Scalars['String']>;
  /**  the direction  */
  direction: Scalars['String'];
  /**  the id  */
  id: Scalars['ID'];
  /**  cutout image  */
  image: Scalars['Object'];
  /**  the location  */
  location: Scalars['Object'];
  /**  the name  */
  name: Scalars['String'];
  /**  the reference point  */
  referencePoint: Scalars['Float'];
  /**  the road  */
  road: Scalars['String'];
  /**  settings  */
  settings: Scalars['Object'];
  /**  cutout signs  */
  signs: Array<Sign>;
};

export type SignCutoutConnection = {
  __typename?: 'SignCutoutConnection';
  /**  connection edges  */
  edges: Array<SignCutoutConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type SignCutoutConnectionEdge = {
  __typename?: 'SignCutoutConnectionEdge';
  /**  cursor position  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: SignCutout;
};

export type SignCutoutInput = {
  /**  the description  */
  description?: InputMaybe<Scalars['String']>;
  /**  the direction  */
  direction: Scalars['String'];
  /**  the id  */
  id?: InputMaybe<Scalars['ID']>;
  /**  cutout image  */
  image: Scalars['Object'];
  /**  the location  */
  location: Scalars['Object'];
  /**  the name  */
  name: Scalars['String'];
  /**  the reference point  */
  referencePoint: Scalars['Float'];
  /**  the road  */
  road: Scalars['String'];
  /**  settings  */
  settings: Scalars['Object'];
  /**  cutout signs  */
  signs: Array<Scalars['String']>;
};

export type SignCutoutInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type SignDisplayArguments = {
  /**  association display names */
  associationDisplayNames?: InputMaybe<Array<Scalars['String']>>;
  /**  associations */
  associations?: InputMaybe<Array<Scalars['String']>>;
  /**  current user display name */
  currentUserDisplayName?: InputMaybe<Scalars['String']>;
  /**  current user id */
  currentUserId?: InputMaybe<Scalars['String']>;
  /**  expiration time */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  identifier of the queued message to remove if editing */
  expiredQueuedMessageId?: InputMaybe<Scalars['String']>;
  /**  integration id */
  id: Scalars['ID'];
  /**  message to display */
  message: SignMessageInput;
  /**  number of logical signs */
  numberOfLogicalSigns?: InputMaybe<Scalars['Int']>;
  /**  queued user display name */
  queuedUserDisplayName?: InputMaybe<Scalars['String']>;
  /**  user id that queued the message */
  queuedUserId?: InputMaybe<Scalars['String']>;
  /**  the associated rate package, if present " */
  rate?: InputMaybe<PricingRateInput>;
  /**  request id */
  requestId?: InputMaybe<Scalars['String']>;
  /**  sign id */
  signId: Scalars['ID'];
  /**  split line number */
  splitLineNumber?: InputMaybe<Scalars['Int']>;
  /**  split logical sign number */
  splitLogicalSignNumber?: InputMaybe<Scalars['Int']>;
  /**  message to display */
  template?: InputMaybe<SignMessageInput>;
};

export enum SignDisplayState {
  Blank = 'BLANK',
  Display = 'DISPLAY'
}

export type SignDisplayType = {
  __typename?: 'SignDisplayType';
  /**  The height of a character for a display  */
  characterHeight?: Maybe<Scalars['Int']>;
  /**  list of character labels, optional  */
  characterLabels?: Maybe<Array<SignCharacterLabel>>;
  /**  The width of a character for the display  */
  characterWidth?: Maybe<Scalars['Int']>;
  /**  The default font of the display  */
  defaultFont?: Maybe<Scalars['ID']>;
  /**  The hash value of similar displays  */
  hash: Scalars['String'];
  /**  The height of the sign in pixels  */
  height: Scalars['Int'];
  /**  The matrix type  */
  matrixType: SignMatrixType;
  /**  The number of max characters for a line  */
  maxCharacters?: Maybe<Scalars['Int']>;
  /**  The number of max lines for the display  */
  maxLines?: Maybe<Scalars['Int']>;
  /**  The max number of pages for the display  */
  maxPages?: Maybe<Scalars['Int']>;
  /**  The width of the sign in pixels  */
  width: Scalars['Int'];
};

export enum SignError {
  AttachedDevice = 'ATTACHED_DEVICE',
  Communication = 'COMMUNICATION',
  Controller = 'CONTROLLER',
  ControllerToDisplayInterface = 'CONTROLLER_TO_DISPLAY_INTERFACE',
  CriticalTemperature = 'CRITICAL_TEMPERATURE',
  DoorOpen = 'DOOR_OPEN',
  DrumSignRotor = 'DRUM_SIGN_ROTOR',
  Fan = 'FAN',
  Humidity = 'HUMIDITY',
  Lamp = 'LAMP',
  Message = 'MESSAGE',
  Other = 'OTHER',
  OtherController = 'OTHER_CONTROLLER',
  Photocell = 'PHOTOCELL',
  Pixel = 'PIXEL',
  Power = 'POWER',
  Program = 'PROGRAM',
  Prom = 'PROM',
  Ram = 'RAM',
  Temperature = 'TEMPERATURE'
}

export type SignFanTest = {
  __typename?: 'SignFanTest';
  /**  errors running tests  */
  error?: Maybe<Scalars['String']>;
  /**  the list of fan failures  */
  fans: Array<Scalars['Int']>;
  /**  if the test is running  */
  running: Scalars['Boolean'];
};

export type SignFont = {
  __typename?: 'SignFont';
  /**  The height of the font characters in pixels  */
  characterHeight: Scalars['Int'];
  /**  The number of pixels between characters  */
  characterSpacing: Scalars['Int'];
  /**  The font character bitmaps in a hex string  */
  font: Scalars['String'];
  /**  The font file name  */
  fontFileName?: Maybe<Scalars['String']>;
  /**  The font version  */
  fontVersion: Scalars['Int'];
  /**  The identifier of the font  */
  id: Scalars['ID'];
  /**  The number of pixels between lines  */
  lineSpacing: Scalars['Int'];
};

export type SignFontInput = {
  /**  The height of the font characters in pixels  */
  characterHeight: Scalars['Int'];
  /**  The number of pixels between characters  */
  characterSpacing: Scalars['Int'];
  /**  The font character bitmaps in a hex string  */
  font: Scalars['String'];
  /**  The font file name  */
  fontFileName?: InputMaybe<Scalars['String']>;
  /**  The font version  */
  fontVersion: Scalars['Int'];
  /**  The number of pixels between lines  */
  lineSpacing: Scalars['Int'];
};

export type SignFontNumber = {
  __typename?: 'SignFontNumber';
  /**  hash of the font  */
  hash: Scalars['String'];
  /**  number of the font */
  number: Scalars['Int'];
};

export type SignFontNumberInput = {
  /**  The unique hash for the font  */
  hash: Scalars['String'];
  /**  The font number for the font  */
  number: Scalars['Int'];
};

export type SignGantry = {
  __typename?: 'SignGantry';
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  The direction of the gantry  */
  direction: Scalars['String'];
  /**  identifier of the gantry  */
  id: Scalars['ID'];
  /**  gantry image  */
  image: Scalars['Object'];
  /**  The location of the gantry  */
  location: Scalars['Object'];
  /**  Name of the gantry  */
  name: Scalars['String'];
  /**  The reference point of the gantry  */
  referencePoint: Scalars['Float'];
  /**  The road of the gantry  */
  road: Scalars['String'];
  /**  gantry settings  */
  settings: Scalars['Object'];
  /**  gantry signs  */
  signs: Array<Sign>;
};

export type SignGantryConnection = {
  __typename?: 'SignGantryConnection';
  /**  The contained edges  */
  edges: Array<SignGantryConnectionEdge>;
  /**  Pagination info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type SignGantryConnectionEdge = {
  __typename?: 'SignGantryConnectionEdge';
  /**  the location of the edge in the page results  */
  cursor?: Maybe<Scalars['String']>;
  /**  entity details for the node  */
  node: SignGantry;
};

export type SignGantryInput = {
  /**  description  */
  description?: InputMaybe<Scalars['String']>;
  /**  The direction of the gantry  */
  direction: Scalars['String'];
  /**  identifier of the gantry  */
  id?: InputMaybe<Scalars['ID']>;
  /**  gantry image  */
  image: Scalars['Object'];
  /**  The location of the gantry  */
  location: Scalars['Object'];
  /**  Name of the gantry  */
  name: Scalars['String'];
  /**  The reference point of the gantry  */
  referencePoint: Scalars['Float'];
  /**  The road of the gantry  */
  road: Scalars['String'];
  /**  gantry settings  */
  settings: Scalars['Object'];
  /**  gantry signs  */
  signs: Array<Scalars['String']>;
};

export type SignGantryInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  directions to filter by  */
  directions?: InputMaybe<Array<Scalars['String']>>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  roads to filter by  */
  roads?: InputMaybe<Array<Scalars['String']>>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type SignGraphic = {
  __typename?: 'SignGraphic';
  /**  height of the graphic in pixels  */
  height: Scalars['Int'];
  /**  The identifier of the graphic  */
  id: Scalars['ID'];
  /**  base 64 encoded image  */
  image: Scalars['Object'];
  /**  name of the graphic  */
  name: Scalars['String'];
  /**  optional slot  */
  slot?: Maybe<Scalars['Int']>;
  /**  width of the graphic in pixels  */
  width: Scalars['Int'];
};

export type SignGraphicLabelInput = {
  /**  hash of the graphic  */
  hash: Scalars['String'];
  /**  label for the graphic  */
  label?: InputMaybe<Scalars['String']>;
  /**  slot of the graphic  */
  number: Scalars['Int'];
};

export type SignGraphicNumber = {
  __typename?: 'SignGraphicNumber';
  /**  hash of the graphic  */
  hash: Scalars['String'];
  /**  the label used to identify the graphic  */
  label?: Maybe<Scalars['String']>;
  /**  number of the graphic  */
  number: Scalars['Int'];
};

export type SignGroup = {
  __typename?: 'SignGroup';
  /**  settings  */
  attributes: Scalars['Object'];
  /**  the description  */
  description?: Maybe<Scalars['String']>;
  /**  the id  */
  id: Scalars['ID'];
  /**  the name  */
  name: Scalars['String'];
  /**  associated signs  */
  signs: Array<Sign>;
  /**  type  */
  type: SignGroupType;
};

export type SignGroupConnection = {
  __typename?: 'SignGroupConnection';
  /**  connection edges  */
  edges: Array<SignGroupConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type SignGroupConnectionEdge = {
  __typename?: 'SignGroupConnectionEdge';
  /**  cursor position  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: SignGroup;
};

export type SignGroupInput = {
  /**  settings  */
  attributes: Scalars['Object'];
  /**  the description  */
  description?: InputMaybe<Scalars['String']>;
  /**  the id  */
  id?: InputMaybe<Scalars['ID']>;
  /**  the name  */
  name: Scalars['String'];
  /**  associated signs  */
  signs: Array<Scalars['String']>;
  /**  type  */
  type: SignGroupType;
};

export type SignGroupInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum SignGroupType {
  BridgeOpening = 'BRIDGE_OPENING',
  ChokePoint = 'CHOKE_POINT',
  Cutout = 'CUTOUT',
  Gantry = 'GANTRY',
  General = 'GENERAL',
  LaneControl = 'LANE_CONTROL',
  SpeedSynchronization = 'SPEED_SYNCHRONIZATION',
  Tolling = 'TOLLING',
  VariableSpeedLimit = 'VARIABLE_SPEED_LIMIT'
}

export type SignImage = {
  __typename?: 'SignImage';
  /**  height  */
  height: Scalars['Int'];
  /**  identifier  */
  id: Scalars['String'];
  /**  base 64 encoded string  */
  image: Scalars['Object'];
  /**  name  */
  name: Scalars['String'];
  /**  slot  */
  slot?: Maybe<Scalars['Int']>;
  /**  width  */
  width: Scalars['Int'];
};

export type SignImageInput = {
  /**  height  */
  height: Scalars['Int'];
  /**  identifier  */
  id: Scalars['String'];
  /**  base 64 encoded string  */
  image: Scalars['Object'];
  /**  name  */
  name: Scalars['String'];
  /**  slot  */
  slot?: InputMaybe<Scalars['Int']>;
  /**  width  */
  width: Scalars['Int'];
};

export type SignIntegration = {
  __typename?: 'SignIntegration';
  /**  the identifier of the integration  */
  id: Scalars['ID'];
  /**  the name of the integration  */
  name: Scalars['String'];
  /**  the type of integration  */
  type: IntegrationType;
  /**  the list of available variables  */
  variables: Array<FieldConfigOption>;
};

export type SignInterlockInput = {
  /**  the identifier of the device  */
  id: Scalars['ID'];
  /**  the message to check  */
  message?: InputMaybe<SignMessageInput>;
  /**  the slot to get the message  */
  slot?: InputMaybe<Scalars['Int']>;
};

export type SignInterlockOverrideApproval = {
  __typename?: 'SignInterlockOverrideApproval';
  /**  if the approval is approved  */
  approved: Scalars['Boolean'];
  /**  the approving user  */
  approver?: Maybe<Scalars['ID']>;
  /**  time at which the approval was created  */
  createdAt: Scalars['DateTime'];
  /**  description of the request  */
  description?: Maybe<Scalars['String']>;
  /**  the identifier  */
  id: Scalars['ID'];
  /**  if the approval was rejected  */
  rejected: Scalars['Boolean'];
  /**  display name of requesting user  */
  userDisplayName: Scalars['String'];
};

export type SignInterlockOverrideApprovalViewDto = {
  __typename?: 'SignInterlockOverrideApprovalViewDto';
  /**  the identifier  */
  approvalId: Scalars['ID'];
  /**  time at which the approval was created  */
  createdAt: Scalars['DateTime'];
  resourcePlanIds?: Maybe<Array<Scalars['String']>>;
  signs: Array<SignApprovalMessageDto>;
  /**  display name of requesting user  */
  userDisplayName: Scalars['String'];
};

export type SignInterlockResult = {
  __typename?: 'SignInterlockResult';
  /**  the acknowledgement message  */
  acknowledgementMessage?: Maybe<Scalars['String']>;
  /**  failure  */
  failure?: Maybe<Scalars['String']>;
  /**  if the device is in an interlock state  */
  hasInterlock: Scalars['Boolean'];
  /**  the identifier of the device  */
  id: Scalars['ID'];
  /**  if the user has the override interlock privilege  */
  requiresAcknowledgement: Scalars['Boolean'];
  /**  if the interlock requires approval  */
  requiresApproval: Scalars['Boolean'];
};

export type SignLampTest = {
  __typename?: 'SignLampTest';
  /**  errors running tests  */
  error?: Maybe<Scalars['String']>;
  /**  if the test is running  */
  running: Scalars['Boolean'];
  /**  stuck off lamps  */
  stuckOff: Array<Scalars['Int']>;
  /**  stuck on lamps  */
  stuckOn: Array<Scalars['Int']>;
};

export type SignLaneControlDisplayRequest = {
  /**  identifiers of associations  */
  associations?: InputMaybe<Array<Scalars['ID']>>;
  /**  The name of the command to display  */
  command: Scalars['String'];
  /**  The time at which to expire the message  */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  The identifier of the sign to display  */
  id: Scalars['ID'];
};

export type SignLibraryMessage = {
  __typename?: 'SignLibraryMessage';
  /**  The list of exclusions for this message  */
  exclusions?: Maybe<Array<Scalars['String']>>;
  /**  group identifier  */
  group?: Maybe<Scalars['String']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  The default message  */
  message: SignMessage;
  /**  message name  */
  name: Scalars['String'];
  /**  The list of overrides for the library message based on display  */
  overrides?: Maybe<Array<SignLibraryMessageOverride>>;
  /**  sign identifier  */
  sign?: Maybe<Scalars['ID']>;
};

export type SignLibraryMessageConnection = {
  __typename?: 'SignLibraryMessageConnection';
  edges: Array<SignLibraryMessageConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignLibraryMessageConnectionEdge = {
  __typename?: 'SignLibraryMessageConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: SignLibraryMessage;
};

export type SignLibraryMessageInput = {
  /**  The list of exclusions for this message  */
  exclusions?: InputMaybe<Array<Scalars['String']>>;
  /**  The identifier of the message  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The default message  */
  message: SignMessageInput;
  /**  The name of the message  */
  name: Scalars['String'];
  /**  The list of overrides for the library message based on display  */
  overrides?: InputMaybe<Array<SignLibraryMessageOverrideInput>>;
  /**  identifier for sign specific message  */
  sign?: InputMaybe<Scalars['ID']>;
};

export type SignLibraryMessageOverride = {
  __typename?: 'SignLibraryMessageOverride';
  /**  The hash value generated by the display dimensions and selected font  */
  hash: Scalars['String'];
  /**  The override message for the display type and font  */
  message: SignMessage;
};

export type SignLibraryMessageOverrideInput = {
  /**  The hash value generated by the display dimensions and selected font  */
  hash: Scalars['String'];
  /**  The override message for the display type and font  */
  message: SignMessageInput;
};

export type SignLibraryMessageValidationResult = {
  __typename?: 'SignLibraryMessageValidationResult';
  /**  The display type hash  */
  hash: Scalars['String'];
  /**  The validation result, null if valid  */
  result?: Maybe<Scalars['String']>;
};

export enum SignMatrixType {
  Character = 'CHARACTER',
  Full = 'FULL',
  Line = 'LINE'
}

export type SignMessage = {
  __typename?: 'SignMessage';
  /**  If beacons should be enabled for this message if supported  */
  beaconsEnabled: Scalars['Boolean'];
  /**  The associated lane control command, if supported  */
  command?: Maybe<Scalars['String']>;
  /**  message image identifiers  */
  images: Array<SignImage>;
  isDefaultMessage?: Maybe<Scalars['Boolean']>;
  /**  The list of pages attached to the sign message  */
  pages: Array<SignMessagePage>;
  /**  The priority value for the message  */
  priority: Scalars['Int'];
  /**  optional message slot  */
  slot?: Maybe<Scalars['Int']>;
  /**  type of message  */
  type: SignMessageType;
};

export type SignMessageAbbreviation = {
  __typename?: 'SignMessageAbbreviation';
  /**  The text to exchange for the search string  */
  abbreviation: Scalars['String'];
  /**  The identifier of the display type for the abbreviation  */
  displayTypeId: Scalars['ID'];
  /**  The identifier of the abbreviation  */
  id: Scalars['ID'];
  /**  The text to search for  */
  searchString: Scalars['String'];
};

export type SignMessageAbbreviationInput = {
  /**  The text to exchange for the search string  */
  abbreviation: Scalars['String'];
  /**  The identifier of the display type for the abbreviation  */
  displayTypeId: Scalars['ID'];
  /**  The identifier of the abbreviation  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The text to search for  */
  searchString: Scalars['String'];
};

export type SignMessageDisplayRequest = {
  /**  association display names  */
  associationDisplayNames?: InputMaybe<Array<Scalars['String']>>;
  /**  identifiers of associations  */
  associations?: InputMaybe<Array<Scalars['String']>>;
  /**  Time at which to expire the message  */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  sign identifier  */
  id: Scalars['ID'];
  /**  requested message to display, required if slot missing  */
  message?: InputMaybe<SignMessageInput>;
  /** If the speed limit should be capped based on configured speed settings */
  shouldCapSpeedLimit?: InputMaybe<Scalars['Boolean']>;
  /**  requested slot to activate, required if message missing  */
  slot?: InputMaybe<Scalars['Int']>;
};

export type SignMessageDisplayType = {
  __typename?: 'SignMessageDisplayType';
  /**  The height of a character for a display  */
  characterHeight?: Maybe<Scalars['Int']>;
  /**  The width of a character for the display  */
  characterWidth?: Maybe<Scalars['Int']>;
  /**  The default font of the display  */
  defaultFont?: Maybe<Scalars['ID']>;
  /**  The hash value of similar displays  */
  hash: Scalars['String'];
  /**  The height of the sign in pixels  */
  height: Scalars['Int'];
  /**  The matrix type  */
  matrixType: SignMatrixType;
  /**  The number of max characters for a line  */
  maxCharacters?: Maybe<Scalars['Int']>;
  /**  The number of max lines for the display  */
  maxLines?: Maybe<Scalars['Int']>;
  /**  The max number of pages for the display  */
  maxPages?: Maybe<Scalars['Int']>;
  /**  The list of associated sign  */
  signs: Scalars['Object'];
  /**  The width of the sign in pixels  */
  width: Scalars['Int'];
};

export type SignMessageHistory = {
  __typename?: 'SignMessageHistory';
  /**  association display names  */
  associationDisplayNames: Array<Scalars['String']>;
  /**  message associations  */
  associations: Array<Scalars['String']>;
  /**  The user who blanked the message  */
  blankedUser?: Maybe<Scalars['String']>;
  /**  The user id who blanked the message */
  blankedUserId?: Maybe<Scalars['String']>;
  /**  The time at which the message will expire  */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /**  The identifier of the message history  */
  id: Scalars['ID'];
  /**  The message that was posted  */
  message: SignMessage;
  /**  The user who posted the message  */
  postedUser?: Maybe<Scalars['String']>;
  /**  The user id who posted the message */
  postedUserId?: Maybe<Scalars['String']>;
  /**  The user who queued the message  */
  queuedUser?: Maybe<Scalars['String']>;
  /**  The user id who queued the message */
  queuedUserId?: Maybe<Scalars['String']>;
  /**  The identifier of the sign for the history  */
  signId: Scalars['ID'];
  /**  The time at which the message was blanked  */
  timeBlanked?: Maybe<Scalars['DateTime']>;
  /**  The time at which the message was posted  */
  timePosted?: Maybe<Scalars['DateTime']>;
  /**  The time at which the message was added to the queue  */
  timeQueued?: Maybe<Scalars['DateTime']>;
};

export type SignMessageHistoryConnection = {
  __typename?: 'SignMessageHistoryConnection';
  edges: Array<SignMessageHistoryConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignMessageHistoryConnectionEdge = {
  __typename?: 'SignMessageHistoryConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: SignMessageHistory;
};

export type SignMessageImage = {
  __typename?: 'SignMessageImage';
  /**  The image  */
  image: Scalars['Int'];
  /**  The position of the image  */
  position: Position;
};

export type SignMessageImageInput = {
  /**  The image  */
  image: Scalars['Int'];
  /**  The position of the image  */
  position: PositionInput;
};

export type SignMessageInput = {
  /**  If beacons should be enabled for this message if supported  */
  beaconsEnabled?: InputMaybe<Scalars['Boolean']>;
  /**  The associated lane control command, if supported  */
  command?: InputMaybe<Scalars['String']>;
  /**  message image identifiers  */
  images?: InputMaybe<Array<SignImageInput>>;
  isDefaultMessage?: InputMaybe<Scalars['Boolean']>;
  /**  The list of pages attached to the sign message  */
  pages: Array<SignMessagePageInput>;
  /**  The number priority value for the message  */
  priority: Scalars['Int'];
  /**  optional message slot  */
  slot?: InputMaybe<Scalars['Int']>;
  /**  type of message  */
  type: SignMessageType;
};

export type SignMessageInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  The sign to filter by  */
  sign?: InputMaybe<Scalars['ID']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
  /**  The message type to filter  */
  type?: InputMaybe<SignMessageType>;
};

export type SignMessageLine = {
  __typename?: 'SignMessageLine';
  /**  The horizontal justification for the line  */
  horizontalJustification?: Maybe<HorizontalJustification>;
  /**  associated integration  */
  integration?: Maybe<Scalars['String']>;
  /**  The segments for the line  */
  lineSegments: Array<SignMessageLineSegment>;
};

export type SignMessageLineInput = {
  /**  The horizontal justification for the line  */
  horizontalJustification?: InputMaybe<HorizontalJustification>;
  /**  associated integration  */
  integration?: InputMaybe<Scalars['String']>;
  /**  The segments for the line  */
  lineSegments: Array<SignMessageLineSegmentInput>;
};

export type SignMessageLineSegment = {
  __typename?: 'SignMessageLineSegment';
  /**  The background color of the segment  */
  backgroundColor?: Maybe<Scalars['String']>;
  /**  The flash off time for the segment  */
  flashOffMillis?: Maybe<Scalars['Int']>;
  /**  The flash on time for the segment  */
  flashOnMillis?: Maybe<Scalars['Int']>;
  /**  If flashing is enabled for the segment  */
  flashingEnabled?: Maybe<Scalars['Boolean']>;
  /**  The font number for the line  */
  font: Scalars['Int'];
  /**  The foreground color of the segment  */
  foregroundColor?: Maybe<Scalars['String']>;
  /**  The horizontal justification for the segment  */
  horizontalJustification?: Maybe<HorizontalJustification>;
  /**  The text of the line  */
  text: Scalars['String'];
};

export type SignMessageLineSegmentInput = {
  /**  The background color of the segment  */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /**  The flash off time for the segment  */
  flashOffMillis?: InputMaybe<Scalars['Int']>;
  /**  The flash on time for the segment  */
  flashOnMillis?: InputMaybe<Scalars['Int']>;
  /**  If flashing is enabled for the segment  */
  flashingEnabled?: InputMaybe<Scalars['Boolean']>;
  /**  The font number for the line  */
  font: Scalars['Int'];
  /**  The foreground color of the segment  */
  foregroundColor?: InputMaybe<Scalars['String']>;
  /**  The horizontal justification for the segment  */
  horizontalJustification?: InputMaybe<HorizontalJustification>;
  /**  The text of the line  */
  text: Scalars['String'];
};

export type SignMessageNumber = {
  __typename?: 'SignMessageNumber';
  /**  hash of the font  */
  hash: Scalars['String'];
  /**  number of the font */
  number: Scalars['Int'];
};

export type SignMessagePage = {
  __typename?: 'SignMessagePage';
  /**  The background color of the page  */
  backgroundColor?: Maybe<Scalars['String']>;
  /**  The list of images to display  */
  images: Array<SignMessageImage>;
  /**  the owning integration for the page  */
  integration?: Maybe<Scalars['String']>;
  /**  The list of lines for the page  */
  lines: Array<SignMessageLine>;
  /**  The page off time in mills  */
  pageOffTime?: Maybe<Scalars['Int']>;
  /**  The page on time in mills  */
  pageOnTime?: Maybe<Scalars['Int']>;
  /**  the name of the rate-set to display  */
  rateName?: Maybe<Scalars['String']>;
  /**  The text areas on the page  */
  textAreas: Array<SignMessageTextArea>;
  /**  The vertical justification for the page  */
  verticalJustification?: Maybe<VerticalJustification>;
};

export type SignMessagePageInput = {
  /**  The background color of the page  */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /**  The list of images to display  */
  images?: InputMaybe<Array<SignMessageImageInput>>;
  /**  the owning integration for the page  */
  integration?: InputMaybe<Scalars['String']>;
  /**  The list of lines for the page  */
  lines?: InputMaybe<Array<SignMessageLineInput>>;
  /**  The page off time in mills  */
  pageOffTime?: InputMaybe<Scalars['Int']>;
  /**  The page on time in mills  */
  pageOnTime?: InputMaybe<Scalars['Int']>;
  /**  the name of the rate-set to display  */
  rateName?: InputMaybe<Scalars['String']>;
  /**  The text areas on the page  */
  textAreas?: InputMaybe<Array<SignMessageTextAreaInput>>;
  /**  The vertical justification for the page  */
  verticalJustification?: InputMaybe<VerticalJustification>;
};

export type SignMessagePreferences = {
  __typename?: 'SignMessagePreferences';
  /**  horizontal justification  */
  horizontalJustification: HorizontalJustification;
  /**  identifier  */
  id: Scalars['String'];
  /**  page off time  */
  pageOffTime: Scalars['Float'];
  /**  page on time  */
  pageOnTime: Scalars['Float'];
  /**  vertical justification  */
  verticalJustification: VerticalJustification;
};

export type SignMessagePriority = {
  __typename?: 'SignMessagePriority';
  /**  The description of the priority  */
  description?: Maybe<Scalars['String']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  If the priority is the default for messages  */
  messageDefault: Scalars['Boolean'];
  /**  The name of the priority  */
  name: Scalars['String'];
  /**  The number priority value  */
  priority: Scalars['Int'];
  /**  If the priority is the default for travel times  */
  travelTimeDefault: Scalars['Boolean'];
};

export type SignMessagePriorityInput = {
  /**  The description of the priority  */
  description?: InputMaybe<Scalars['String']>;
  /**  identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  If the priority is the default for messages  */
  messageDefault?: InputMaybe<Scalars['Boolean']>;
  /**  The name of the priority  */
  name: Scalars['String'];
  /**  The number priority value  */
  priority: Scalars['Int'];
  /**  If the priority is the default for travel times  */
  travelTimeDefault?: InputMaybe<Scalars['Boolean']>;
};

export enum SignMessageQueueStatus {
  /**  The queued message is currently being displayed on the sign  */
  Active = 'ACTIVE',
  /**  The message is not present in the queue  */
  NotPresent = 'NOT_PRESENT',
  /**  The message has yet to be activated  */
  Pending = 'PENDING',
  /**  The message is currently being queued  */
  Queued = 'QUEUED'
}

export type SignMessageTextArea = {
  __typename?: 'SignMessageTextArea';
  /**  The height of the text area  */
  height: Scalars['Int'];
  /**  The list of lines for the page  */
  lines: Array<SignMessageLine>;
  /**  The position of the text area  */
  position: Position;
  /**  The vertical justification for the page  */
  verticalJustification: VerticalJustification;
  /**  The width of the text area  */
  width: Scalars['Int'];
};

export type SignMessageTextAreaInput = {
  /**  The height of the text area  */
  height: Scalars['Int'];
  /**  The list of lines for the page  */
  lines: Array<SignMessageLineInput>;
  /**  The position of the text area  */
  position: PositionInput;
  /**  The vertical justification for the page  */
  verticalJustification?: InputMaybe<VerticalJustification>;
  /**  The width of the text area  */
  width: Scalars['Int'];
};

export enum SignMessageType {
  /**  Used for messages retrieved through C2C  */
  C2C = 'C2C',
  /**  Used to display advisory or regulatory dual speed limits  */
  DualSpeedLimit = 'DUAL_SPEED_LIMIT',
  /**  Used to display plain text and/or graphic messages  */
  General = 'GENERAL',
  /**  Used to display information that lives on an integration state  */
  Integration = 'INTEGRATION',
  /**  Used to display lane control graphic messages  */
  LaneControl = 'LANE_CONTROL',
  /**  Used to display advisory or regulatory speed limits  */
  SpeedLimit = 'SPEED_LIMIT',
  /**  Used to display tolling rates  */
  Tolling = 'TOLLING',
  /**  Used to display travel time information  */
  TravelTime = 'TRAVEL_TIME',
  /**  Used when KMob finds an unexpected message  */
  Unexpected = 'UNEXPECTED'
}

export type SignMessageValidationResult = {
  __typename?: 'SignMessageValidationResult';
  /**  The reason for the validation failure  */
  failure?: Maybe<Scalars['String']>;
  /**  The formatted and validated message, can be null  */
  message?: Maybe<SignMessage>;
};

export type SignPixelTest = {
  __typename?: 'SignPixelTest';
  /**  errors running tests  */
  error?: Maybe<Scalars['String']>;
  /**  the list of error pixels  */
  pixels: Array<SignPixelTestError>;
  /**  if the test is running  */
  running: Scalars['Boolean'];
};

export type SignPixelTestError = {
  __typename?: 'SignPixelTestError';
  /**  status  */
  status?: Maybe<Scalars['String']>;
  /**  x coordinate  */
  x: Scalars['Int'];
  /**  y coordinate  */
  y: Scalars['Int'];
};

export enum SignPowerSource {
  AcLine = 'AC_LINE',
  Battery = 'BATTERY',
  Generator = 'GENERATOR',
  NoSignPower = 'NO_SIGN_POWER',
  Other = 'OTHER',
  PowerShutdown = 'POWER_SHUTDOWN',
  Solar = 'SOLAR'
}

export type SignQueuedMessage = {
  __typename?: 'SignQueuedMessage';
  /**  association display names  */
  associationDisplayNames: Array<Scalars['String']>;
  /**  message associations  */
  associations: Array<Scalars['String']>;
  /**  The expiration time of the message  */
  expirationTime?: Maybe<Scalars['DateTime']>;
  /**  The identifier of the queued message  */
  id: Scalars['ID'];
  /**  The content of the message  */
  message: SignMessage;
  /**  The user who posted the message  */
  user?: Maybe<Scalars['String']>;
};

export type SignQueuedMessageInput = {
  /**  association display names  */
  associationDisplayNames?: InputMaybe<Array<Scalars['String']>>;
  /**  message associations  */
  associations?: InputMaybe<Array<Scalars['String']>>;
  /**  The expiration time of the message  */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  The identifier of the queued message  */
  id: Scalars['ID'];
  /**  The content of the message  */
  message: SignMessageInput;
  /**  The user who posted the message  */
  user?: InputMaybe<Scalars['String']>;
};

export type SignResponseRule = {
  __typename?: 'SignResponseRule';
  /**  if the rule is enabled for evaluation  */
  enabled: Scalars['Boolean'];
  /**  identifier for event form  */
  formId: Scalars['String'];
  /**  rule identifier  */
  id: Scalars['ID'];
  /**  rule name  */
  name: Scalars['String'];
  /**  rule priority  */
  priority: Scalars['Int'];
  /**  the mvel rule string  */
  rule: Scalars['String'];
  /**  the sign message template  */
  template: SignMessage;
  /**  rule tree  */
  tree: Scalars['Object'];
};

export type SignResponseRuleConnection = {
  __typename?: 'SignResponseRuleConnection';
  edges: Array<SignResponseRuleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignResponseRuleEdge = {
  __typename?: 'SignResponseRuleEdge';
  cursor?: Maybe<Scalars['String']>;
  node: SignResponseRule;
};

export type SignResponseRuleInput = {
  /**  if the rule is enabled for evaluation  */
  enabled: Scalars['Boolean'];
  /**  identifier for event form  */
  formId: Scalars['String'];
  /**  rule identifier  */
  id?: InputMaybe<Scalars['ID']>;
  /**  rule name  */
  name: Scalars['String'];
  /**  rule priority  */
  priority: Scalars['Int'];
  /**  the mvel rule string  */
  rule: Scalars['String'];
  /**  sign template to be generated for recommendations  */
  template: SignMessageInput;
  /**  rule tree  */
  tree: Scalars['Object'];
};

export type SignResponseRuleInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  form identifier for rules  */
  formId?: InputMaybe<Scalars['String']>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type SignSpeedSettings = {
  __typename?: 'SignSpeedSettings';
  /**  number of intervals for speed  */
  intervals: Scalars['Int'];
  /**  Maximum amount of change for speed limits  */
  maximumChange: Scalars['Int'];
  /**  Maximum allowed speed  */
  maximumSpeed: Scalars['Int'];
  /**  Minimum allowed speed  */
  minimumSpeed: Scalars['Int'];
  /**  Minimum allowed secondary speed  */
  secondaryMaximumSpeed?: Maybe<Scalars['Int']>;
  /**  Maximum allowed secondary speed  */
  secondaryMinimumSpeed?: Maybe<Scalars['Int']>;
};

export type SignSpeedSettingsInput = {
  /**  number of intervals for speed  */
  intervals: Scalars['Int'];
  /**  Maximum amount of change for speed limits  */
  maximumChange: Scalars['Int'];
  /**  Maximum allowed speed  */
  maximumSpeed: Scalars['Int'];
  /**  Minimum allowed speed  */
  minimumSpeed: Scalars['Int'];
  /**  Minimum allowed secondary speed  */
  secondaryMaximumSpeed?: InputMaybe<Scalars['Int']>;
  /**  Maximum allowed secondary speed  */
  secondaryMinimumSpeed?: InputMaybe<Scalars['Int']>;
};

export type SignTests = {
  __typename?: 'SignTests';
  /**  fan test  */
  fan?: Maybe<SignFanTest>;
  /**  lamp test  */
  lamp?: Maybe<SignLampTest>;
  /**  pixel tests  */
  pixel?: Maybe<SignPixelTest>;
};

export type SignUploadGraphicArguments = {
  /**  height of image in pixels */
  height: Scalars['Int'];
  /**  device id */
  id: Scalars['ID'];
  /**  base 64 encoded image string */
  image: Scalars['String'];
  /**  name of image */
  name: Scalars['String'];
  /**  request id */
  requestId?: InputMaybe<Scalars['String']>;
  /**  slot to upload the image */
  slot: Scalars['Int'];
  /**  width of image in pixels */
  width: Scalars['Int'];
};

export type SignUploadMessageArguments = {
  /**  device id */
  id: Scalars['ID'];
  /**  Sign message */
  message: SignMessageInput;
  /**  request id */
  requestId?: InputMaybe<Scalars['String']>;
  /**  slot to upload the message */
  slot: Scalars['Int'];
};

export type SignalActionSet = {
  __typename?: 'SignalActionSet';
  centerId?: Maybe<Scalars['String']>;
  commands: Array<Scalars['JSON']>;
  id: Scalars['ID'];
  impact?: Maybe<SignalActionSetImpactType>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  priority: Scalars['Int'];
};

export type SignalActionSetConnection = {
  __typename?: 'SignalActionSetConnection';
  edges: Array<SignalActionSetConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignalActionSetConnectionEdge = {
  __typename?: 'SignalActionSetConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: SignalActionSet;
};

export enum SignalActionSetImpactType {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type SignalActionSetInput = {
  commands: Array<Scalars['JSON']>;
  id?: InputMaybe<Scalars['ID']>;
  impact?: InputMaybe<SignalActionSetImpactType>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  number: Scalars['Int'];
  priority: Scalars['Int'];
};

export type SignalAppliedCommand = {
  __typename?: 'SignalAppliedCommand';
  command: Scalars['String'];
  device: BasicIntersectionDevice;
  endDateTime: Scalars['DateTime'];
  externalCenterId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inheritedGroup?: Maybe<BasicIntersectionDevice>;
  intersection: BasicIntersectionDevice;
  intersectionType?: Maybe<IntersectionType>;
  priority?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  startDateTime: Scalars['DateTime'];
  status: Scalars['String'];
  taskId: Scalars['String'];
  value: Scalars['String'];
};

export type SignalAppliedCommandConnection = {
  __typename?: 'SignalAppliedCommandConnection';
  edges: Array<SignalAppliedCommandConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignalAppliedCommandConnectionEdge = {
  __typename?: 'SignalAppliedCommandConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: SignalAppliedCommand;
};

export type SignalAppliedCommandFilterOptions = {
  __typename?: 'SignalAppliedCommandFilterOptions';
  commands: Array<Scalars['String']>;
  devices: Array<BasicIntersectionDevice>;
  inheritedGroups: Array<BasicIntersectionDevice>;
  intersections: Array<BasicIntersectionDevice>;
  sources: Array<Scalars['String']>;
};

export type SignalAppliedCommandStreamObject = {
  __typename?: 'SignalAppliedCommandStreamObject';
  dto: SignalAppliedCommand;
  streamObjectOperation: StreamObjectOperation;
};

export type SignalCommand = {
  __typename?: 'SignalCommand';
  commandValues: Array<CommandValue>;
  description?: Maybe<Scalars['String']>;
  type: CommandType;
};

export type SignalCommandDefinition = {
  __typename?: 'SignalCommandDefinition';
  commandType: Scalars['String'];
  commandValues?: Maybe<Array<SignalCommandValueDefinition>>;
  supportedProtocols?: Maybe<Array<Scalars['String']>>;
};

export type SignalCommandTask = {
  __typename?: 'SignalCommandTask';
  command: SignalCommand;
  createdDateTime?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['DateTime']>;
  externalCenterId?: Maybe<Scalars['String']>;
  flattenedIntersections?: Maybe<Array<Maybe<CommandIntersection>>>;
  groupIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  intersectionIds?: Maybe<Array<Scalars['String']>>;
  labels?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  runningTaskId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  taskId: Scalars['String'];
  taskRecurrenceType?: Maybe<TaskRecurrenceType>;
  taskType?: Maybe<TaskType>;
};

export type SignalCommandValueDefinition = {
  __typename?: 'SignalCommandValueDefinition';
  defaultValue?: Maybe<Scalars['Int']>;
  maxValue?: Maybe<Scalars['Int']>;
  minValue?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  unsetValue?: Maybe<Scalars['Int']>;
};

export type SignalCommunicationReportRowConnection = {
  __typename?: 'SignalCommunicationReportRowConnection';
  edges: Array<CommunicationReportRowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignalController = {
  __typename?: 'SignalController';
  /**  URL or ip:port  */
  connectionParameters?: Maybe<Scalars['String']>;
  /**  Description of the signal controller  */
  description?: Maybe<Scalars['String']>;
  /**  ID of the signal controller */
  id: Scalars['ID'];
  /**  The location of the signal controller  */
  location?: Maybe<Scalars['Object']>;
  /**  Name of the signal controller */
  name: Scalars['String'];
};

export type SignalControllerConnection = {
  __typename?: 'SignalControllerConnection';
  edges: Array<SignalControllerConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignalControllerConnectionEdge = {
  __typename?: 'SignalControllerConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: SignalController;
};

export type SignalDetector = {
  __typename?: 'SignalDetector';
  detector: Scalars['Int'];
  direction: SignalDetectorDirectionType;
  intersectionId: Scalars['String'];
  movement: SignalDetectorMovementType;
  note?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};

export enum SignalDetectorDirectionType {
  BothDirections = 'BOTH_DIRECTIONS',
  East = 'EAST',
  Negative = 'NEGATIVE',
  North = 'NORTH',
  Northeast = 'NORTHEAST',
  Northwest = 'NORTHWEST',
  NotDirectional = 'NOT_DIRECTIONAL',
  Other = 'OTHER',
  Positive = 'POSITIVE',
  South = 'SOUTH',
  Southeast = 'SOUTHEAST',
  Southwest = 'SOUTHWEST',
  Unknown = 'UNKNOWN',
  West = 'WEST'
}

export type SignalDetectorGroup = {
  __typename?: 'SignalDetectorGroup';
  aggregationMethod: SignalDetectorGroupAggregationMethodType;
  description?: Maybe<Scalars['String']>;
  detectors: Array<SignalDetector>;
  id: Scalars['ID'];
  loggingEnabled: Scalars['Boolean'];
  loggingPeriodMinutes?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export enum SignalDetectorGroupAggregationMethodType {
  Average = 'AVERAGE',
  Sum = 'SUM'
}

export type SignalDetectorGroupConnection = {
  __typename?: 'SignalDetectorGroupConnection';
  edges: Array<SignalDetectorGroupConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignalDetectorGroupConnectionEdge = {
  __typename?: 'SignalDetectorGroupConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: SignalDetectorGroup;
};

export type SignalDetectorGroupInput = {
  aggregationMethod: SignalDetectorGroupAggregationMethodType;
  description?: InputMaybe<Scalars['String']>;
  detectors: Array<SignalDetectorInput>;
  id?: InputMaybe<Scalars['ID']>;
  loggingEnabled: Scalars['Boolean'];
  loggingPeriodMinutes?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type SignalDetectorInput = {
  detector: Scalars['Int'];
  direction: SignalDetectorDirectionType;
  intersectionId: Scalars['String'];
  movement: SignalDetectorMovementType;
  note?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export enum SignalDetectorMovementType {
  Left = 'LEFT',
  Right = 'RIGHT',
  Thru = 'THRU',
  Unknown = 'UNKNOWN'
}

export type SignalIndication = {
  __typename?: 'SignalIndication';
  green: SignalOutputColor;
  greenFlashing: Scalars['Boolean'];
  greenIcon: IntersectionMapIcon;
  red: SignalOutputColor;
  redFlashing: Scalars['Boolean'];
  redIcon: IntersectionMapIcon;
  signalNumber: Scalars['Int'];
  signalType: SignalIndicationType;
  yellow: SignalOutputColor;
  yellowFlashing: Scalars['Boolean'];
  yellowIcon: IntersectionMapIcon;
};

export type SignalIndicationInput = {
  green: SignalOutputColor;
  greenFlashing: Scalars['Boolean'];
  greenIcon: IntersectionMapIcon;
  red: SignalOutputColor;
  redFlashing: Scalars['Boolean'];
  redIcon: IntersectionMapIcon;
  signalNumber: Scalars['Int'];
  signalType: SignalIndicationType;
  yellow: SignalOutputColor;
  yellowFlashing: Scalars['Boolean'];
  yellowIcon: IntersectionMapIcon;
};

export enum SignalIndicationType {
  Overlap = 'OVERLAP',
  Ped = 'PED',
  Phase = 'PHASE'
}

export type SignalLaneStatus = {
  __typename?: 'SignalLaneStatus';
  enabled: Scalars['Boolean'];
  intervalColor?: Maybe<SignalOutputColor>;
  laneNumber: Scalars['Int'];
  rgyValue?: Maybe<Scalars['Int']>;
  rmcActiveMeterRate: Scalars['Int'];
  rmcImplementAction?: Maybe<RmcImplementAction>;
  rmcImplementCommandSource?: Maybe<RmcImplementCommandSource>;
  rmcImplementPlan: Scalars['Int'];
  rmcImplementRate: Scalars['Int'];
};

export enum SignalOutputColor {
  Black = 'BLACK',
  Blue = 'BLUE',
  Brown = 'BROWN',
  Dark = 'DARK',
  DarkGreen = 'DARK_GREEN',
  DarkOrange = 'DARK_ORANGE',
  DarkRed = 'DARK_RED',
  DarkYellow = 'DARK_YELLOW',
  Green = 'GREEN',
  Grey = 'GREY',
  Lavender = 'LAVENDER',
  LightGreen = 'LIGHT_GREEN',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Ultramarine = 'ULTRAMARINE',
  Unknown = 'UNKNOWN',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export type SignalPrivilege = {
  __typename?: 'SignalPrivilege';
  lastUpdated: Scalars['Float'];
  privilegeType: PrivilegeType;
  restrictions: Scalars['JSON'];
};

export type SignalTask = {
  __typename?: 'SignalTask';
  associatedId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intersectionId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  progress: Scalars['Int'];
  status?: Maybe<SignalTaskStatus>;
  updated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<OrganizationKineticUser>;
};

export type SignalTaskConnection = {
  __typename?: 'SignalTaskConnection';
  edges: Array<SignalTaskEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SignalTaskEdge = {
  __typename?: 'SignalTaskEdge';
  cursor?: Maybe<Scalars['String']>;
  node: SignalTask;
};

export enum SignalTaskStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED'
}

export type SimpleInterval = {
  /**  Defines the number of times to repeat, Null would repeat forever. */
  repeatCount?: InputMaybe<Scalars['Int']>;
  /**  The repeat interval */
  repeatInterval?: InputMaybe<RepeatInterval>;
};

export type Snapshot = {
  __typename?: 'Snapshot';
  camera?: Maybe<Camera>;
  id: Scalars['ID'];
  key: Scalars['String'];
  module: KineticModule;
  path: Scalars['String'];
  serverFileName: Scalars['String'];
  size?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type SnapshotConnectionEdge = {
  __typename?: 'SnapshotConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Snapshot;
};

export enum SnapshotInitiatedBy {
  Service = 'SERVICE',
  User = 'USER'
}

export type SnapshotInput = {
  cameraId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  initiatedBy: SnapshotInitiatedBy;
  serverFileName: Scalars['String'];
  takerId?: InputMaybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  url: Scalars['String'];
};

export type SnapshotStreamObject = {
  __typename?: 'SnapshotStreamObject';
  dto?: Maybe<Snapshot>;
  streamObjectOperation?: Maybe<StreamObjectOperation>;
};

export type SnapshotsConnection = {
  __typename?: 'SnapshotsConnection';
  edges: Array<SnapshotConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SnapshotsInputQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cameraId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  incidentId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type SpecialFunctionStatus = {
  __typename?: 'SpecialFunctionStatus';
  active: Scalars['Boolean'];
  number: Scalars['Int'];
};

export type SpreadSheetData = {
  __typename?: 'SpreadSheetData';
  name?: Maybe<Scalars['String']>;
  rows?: Maybe<Array<Maybe<Scalars['Object']>>>;
};

export enum Status {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export enum StreamObjectOperation {
  Add = 'ADD',
  Remove = 'REMOVE',
  Update = 'UPDATE'
}

export enum StreamTagRequestAction {
  Start = 'START',
  Stop = 'STOP'
}

export type StyledObject = {
  alignment?: InputMaybe<Scalars['String']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  fillForegroundColor?: InputMaybe<Scalars['String']>;
  fillPattern?: InputMaybe<Scalars['String']>;
  object?: InputMaybe<Scalars['Object']>;
  validation?: InputMaybe<CellValidation>;
  weight?: InputMaybe<Scalars['String']>;
};

export type SubGroup = {
  __typename?: 'SubGroup';
  items: Array<GroupItem>;
  name: Scalars['String'];
  subGroups: Array<SubGroup>;
};

export type SubGroupInput = {
  items: Array<InputMaybe<GroupItemInput>>;
  name: Scalars['String'];
  subGroups: Array<InputMaybe<SubGroupInput>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _runOneTimeJobSubscribe: JobResult;
  /**  Subscribe to activity logs */
  addedActivityLog: ActivityLog;
  alarmUpdated: Alarm;
  cameraGroupUpdated?: Maybe<CameraGroup>;
  cameraUpdated: Camera;
  communicationLogUpdated?: Maybe<CommunicationLogStreamObject>;
  /**  Listen for changes to connected vehicle comments  */
  connectedVehicleCommentUpdated: ConnectedVehicleCommentStreamObject;
  /**  Listen for changes to status category counts  */
  connectedVehicleStatusCategoriesUpdated: ConnectedVehicleCategory;
  /**  Listen for changes to connected vehicle configurations  */
  connectedVehicleUpdated: ConnectedVehicle;
  contactGroupUpdated?: Maybe<ContactGroupStreamObject>;
  contactUpdated?: Maybe<ContactStreamObject>;
  /**  Listen for changes on corridors  */
  corridorUpdated: Corridor;
  /**  Listen for device database lock/unlock actions for an intersection  */
  databaseLockUpdated: Array<DeviceDatabaseLockStatus>;
  /**  Listen for changes on the provided identifiers  */
  detectionUpdated: Detection;
  /**  Returns Detector on update */
  detectorUpdated: Detector;
  detectorVehicleImportProgressUpdated: DetectorVehicleImportProgress;
  detectorVehicleVolumeCountsUpdated?: Maybe<Scalars['Boolean']>;
  /**  Listen for changes to a device database  */
  deviceDatabaseUpdated: DeviceDatabase;
  effectivePrivilegesUpdated?: Maybe<Array<Maybe<KineticEffectivePrivilegeAssignment>>>;
  emailRuleUpdated?: Maybe<EmailRuleDto>;
  emailTemplateUpdated?: Maybe<EmailTemplateDto>;
  /**  Listen for changes for events  */
  eventUpdated: Event;
  /**  dispatch updates  */
  fleetDispatchUpdated: FleetDispatch;
  /**  driver updates  */
  fleetDriverUpdated: FleetDriver;
  /**  route updates  */
  fleetRouteUpdated: FleetRoute;
  /**  shift updates  */
  fleetShiftUpdated: FleetShift;
  /**  vehicle updates  */
  fleetVehicleUpdated: FleetVehicle;
  /**  Listen for changes to gantry map entities  */
  gantryMapUpdated: Scalars['JSON'];
  /**  Listen for changes for gantry events  */
  gantryUpdated: Scalars['String'];
  /**  listen for gate job results  */
  gateControllerJobResults: JobRequest;
  /**  listen for gate controller sign message updates  */
  gateControllerSignMessageUpdated: GateControllerSignMessage;
  /**  listen for gate controller system updates  */
  gateControllerSystemUpdated: GateControllerSystem;
  /**  listen for gate controller updates  */
  gateControllerUpdated: GateController;
  /**  listen for gate group updates  */
  gateGroupUpdated: GateGroupUpdate;
  /**  listen for gate operation approval updates  */
  gateOperationApprovalUpdated: GateOperationApproval;
  /**  listen for gate operation updates  */
  gateOperationUpdated: GateOperation;
  /**  message updates  */
  harMessageUpdated: HarMessage;
  /**  playlist updates  */
  harPlaylistUpdated: HarPlaylist;
  /**  priority updates  */
  harPriorityUpdated: HarPriority;
  /**  transmitter updates  */
  harTransmitterUpdated: HarTransmitter;
  /** Listen for changes of config and state in integrations */
  integrationUpdated: Integration;
  /**  listen for sign interlock override approval updates  */
  interlockOverrideApprovalUpdated: SignInterlockOverrideApproval;
  /**  Listen for any changes to intersection comments */
  intersectionCommentsUpdated?: Maybe<Array<IntersectionComment>>;
  /**  Listen for changes on intersection communication status  */
  intersectionCommunicationStatusUpdated: Array<IntersectionCommunicationStatus>;
  /**  Listen for changes on intersections  */
  intersectionConfigUpdated: Array<Intersection>;
  /**  Oversees the activation/deactivation of database actions for provided intersections  */
  intersectionDatabaseActionUpdated: DeviceDatabaseActionUpdated;
  /**  Listen for changes to detailed intersection status changes. */
  intersectionDetailStatusUpdated: Array<Maybe<IntersectionDetailStatus>>;
  /**  Listen for changes in the intersection icon status. If onDemand is null or true create extra mib subscriptions for the devices. */
  intersectionIconStatusUpdate: Array<IntersectionIconStatus>;
  /**  Listen for changes on intersection overlap status  */
  intersectionOverlapStatusUpdated: Array<IntersectionOverlapStatus>;
  /**  Listen for changes to pattern status changes. If onDemand is null or true create extra mib susbcriptions for the devices. */
  intersectionPatternStatusUpdated: Array<IntersectionPatternStatus>;
  /**  Listen for changes on intersection ped status  */
  intersectionPedStatusUpdated: Array<IntersectionPedStatus>;
  /**  Listen for changes on intersection phase status. If onDemand is null or true create extra mib susbcriptions for the devices.  */
  intersectionPhaseStatusUpdated: Array<IntersectionPhaseStatus>;
  /**  Listen for changes on intersection simple status  */
  intersectionSimpleStatusUpdated: Array<IntersectionSimpleStatus>;
  /**  Listen for changes to the intersection status categories. */
  intersectionStatusCategoriesUpdated: IntersectionStatusCategories;
  /**  Subscription for JobResults */
  jobResults?: Maybe<JobResult>;
  kineticUserPreferenceUpdated: UserPreferenceStreamObject;
  /**  Listen for changes to library messages  */
  libraryMessageUpdated: SignLibraryMessage;
  /**  listen for updates to network conditions  */
  networkConditionUpdated: NetworkCondition;
  /**  listen for updates to network jurisdictions  */
  networkJurisdictionUpdated: NetworkJurisdiction;
  notificationUpdated?: Maybe<Notification>;
  organizationPreferenceUpdated: OrganizationPreferenceStreamObject;
  organizationUpdated?: Maybe<OrganizationStreamObject>;
  /**  parking area updates  */
  parkingAreaUpdated: ParkingArea;
  privilegeAssignmentsUpdated?: Maybe<KineticUserPrivilegeAssignment>;
  /**  Listen for changes to the ramp meter status categories. */
  rampMeterStatusCategoriesUpdated: RampMeterStatusCategories;
  /**  report builder block updated  */
  reportBuilderBlockUpdated: ReportBuilderBlock;
  /**  report builder task updated  */
  reportBuilderTaskUpdated: Task;
  /**  report builder updated  */
  reportBuilderUpdated: ReportBuilder;
  /**  Tasks updates subscription.  */
  resourcePlanTaskUpdated: Task;
  /**  Subscription for when a resource plan has been updated  */
  resourcePlanUpdated?: Maybe<ResourcePlan>;
  rolesUpdated?: Maybe<KineticRole>;
  sceneUpdated: Scene;
  /**  Tasks updates subscription.  */
  scheduledEventTaskUpdated: Task;
  screenUpdated: Screen;
  /**  Listen for changes to sign groups  */
  signGroupUpdated: SignGroup;
  /**  Listen for changes to map entities  */
  signMapUpdated: Scalars['JSON'];
  /**  Listen for changes for sign events  */
  signUpdated: Sign;
  /**  Listen for any changes to signal applied commands */
  signalAppliedCommandUpdated?: Maybe<Array<SignalAppliedCommandStreamObject>>;
  /**  Listen for changes on signal tasks. */
  signalTaskUpdated: SignalTask;
  snapshotsUpdated?: Maybe<SnapshotStreamObject>;
  taskProgressUpdated: TaskProgress;
  taskUpdated: Task;
  /**  tolling point updated  */
  tollingPointUpdated: TollingPoint;
  /**  tolling pricing updated  */
  tollingPricingUpdated: TollingPricing;
  /**  tolling road updated  */
  tollingRoadUpdated: TollingRoad;
  /**  tolling segment updated  */
  tollingSegmentUpdated: TollingSegment;
  /**  tolling sign updated  */
  tollingSignUpdated: TollingSign;
  tourUpdated: Tour;
  /**  Listen for changes on traffic control  */
  trafficControlUpdated: TrafficControl;
  /**  Listen for changes on travel times  */
  travelTimeUpdated: TravelTime;
  /**  Listen for changes on tunnel fan  */
  tunnelFanUpdated: TunnelFan;
  /**  Listen for changes on tunnel light  */
  tunnelLightUpdated: TunnelLight;
  /**  Listen for changes on tunnel logs */
  tunnelLogsUpdated: TunnelLog;
  userGroupsUpdated?: Maybe<KineticUserGroup>;
  userPreferenceUpdated: UserPreferenceStreamObject;
  /**  video stream block updates subscription  */
  videoStreamBlockUpdated: VideoStreamBlock;
  /**  Emits when a block is removed (unblocked).  */
  videoStreamUnblocked: VideoStreamBlock;
  videoWallUpdated?: Maybe<VideoWallStreamObject>;
  watchTour: WatchedTour;
  /**  Listen for changes on the provided identifiers  */
  weatherStationUpdated: WeatherStation;
  widgetUpdated: Widget;
};


export type Subscription_RunOneTimeJobSubscribeArgs = {
  id: Scalars['String'];
  requestId: Scalars['String'];
  settings: Scalars['Object'];
};


export type SubscriptionAddedActivityLogArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  module?: InputMaybe<KineticModule>;
  types?: InputMaybe<Array<Scalars['String']>>;
};


export type SubscriptionAlarmUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionCameraGroupUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionCameraUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionCommunicationLogUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionConnectedVehicleCommentUpdatedArgs = {
  connectedVehicleIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionConnectedVehicleUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionContactGroupUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionContactUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionCorridorUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionDatabaseLockUpdatedArgs = {
  intersectionIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionDetectionUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionDetectorUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionDetectorVehicleImportProgressUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionDetectorVehicleVolumeCountsUpdatedArgs = {
  id: Scalars['ID'];
};


export type SubscriptionDeviceDatabaseUpdatedArgs = {
  databaseIds?: InputMaybe<Array<Scalars['ID']>>;
  intersectionIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionEmailRuleUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionEmailTemplateUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionEventUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionFleetDispatchUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionFleetDriverUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionFleetRouteUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionFleetShiftUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionFleetVehicleUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionGantryUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionGateControllerJobResultsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionGateControllerSignMessageUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionGateControllerSystemUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionGateControllerUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionGateGroupUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionGateOperationApprovalUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionGateOperationUpdatedArgs = {
  id: Scalars['ID'];
};


export type SubscriptionHarMessageUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionHarPlaylistUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionHarPriorityUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionHarTransmitterUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionIntegrationUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionInterlockOverrideApprovalUpdatedArgs = {
  approvalId: Scalars['ID'];
};


export type SubscriptionIntersectionCommentsUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionIntersectionCommunicationStatusUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionIntersectionConfigUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionIntersectionDatabaseActionUpdatedArgs = {
  intersectionIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionIntersectionDetailStatusUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  intersectionType?: InputMaybe<IntersectionType>;
};


export type SubscriptionIntersectionIconStatusUpdateArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  onDemand?: InputMaybe<Scalars['Boolean']>;
};


export type SubscriptionIntersectionOverlapStatusUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionIntersectionPatternStatusUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  onDemand?: InputMaybe<Scalars['Boolean']>;
};


export type SubscriptionIntersectionPedStatusUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionIntersectionPhaseStatusUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  onDemand?: InputMaybe<Scalars['Boolean']>;
};


export type SubscriptionIntersectionSimpleStatusUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  intersectionType?: InputMaybe<IntersectionType>;
};


export type SubscriptionJobResultsArgs = {
  requestIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type SubscriptionKineticUserPreferenceUpdatedArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type SubscriptionLibraryMessageUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionNetworkConditionUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionNetworkJurisdictionUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionOrganizationPreferenceUpdatedArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type SubscriptionOrganizationUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionParkingAreaUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionPrivilegeAssignmentsUpdatedArgs = {
  ids: Array<Scalars['ID']>;
};


export type SubscriptionReportBuilderBlockUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionReportBuilderTaskUpdatedArgs = {
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type SubscriptionReportBuilderUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionResourcePlanTaskUpdatedArgs = {
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type SubscriptionResourcePlanUpdatedArgs = {
  ids: Array<Scalars['ID']>;
};


export type SubscriptionRolesUpdatedArgs = {
  ids: Array<Scalars['ID']>;
};


export type SubscriptionSceneUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionScheduledEventTaskUpdatedArgs = {
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type SubscriptionScreenUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionSignGroupUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  types?: InputMaybe<Array<SignGroupType>>;
};


export type SubscriptionSignUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionSignalAppliedCommandUpdatedArgs = {
  intersectionType?: InputMaybe<IntersectionType>;
};


export type SubscriptionSignalTaskUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  intersectionIds?: InputMaybe<Array<Scalars['String']>>;
};


export type SubscriptionSnapshotsUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionTaskUpdatedArgs = {
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type SubscriptionTollingPointUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionTollingPricingUpdatedArgs = {
  ids: Array<Scalars['ID']>;
};


export type SubscriptionTollingRoadUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionTollingSegmentUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionTollingSignUpdatedArgs = {
  ids: Array<Scalars['ID']>;
};


export type SubscriptionTourUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionTrafficControlUpdatedArgs = {
  ids: Array<Scalars['ID']>;
};


export type SubscriptionTravelTimeUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionTunnelFanUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionTunnelLightUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionTunnelLogsUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionUserGroupsUpdatedArgs = {
  ids: Array<Scalars['ID']>;
};


export type SubscriptionUserPreferenceUpdatedArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type SubscriptionVideoStreamBlockUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionVideoStreamUnblockedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionWatchTourArgs = {
  tourId: Scalars['ID'];
};


export type SubscriptionWeatherStationUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type SubscriptionWidgetUpdatedArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type SumAggregation = {
  __typename?: 'SumAggregation';
  /**  Previous trending sum of this aggregation */
  trend: Scalars['Float'];
  /**  Sum of this aggregation */
  value: Scalars['Float'];
};

export enum SynchroExportFormat {
  UtdfAll = 'UTDF_ALL',
  UtdfPhasing = 'UTDF_PHASING',
  UtdfTiming = 'UTDF_TIMING'
}

export type SystemNotificationsQuery = {
  acknowledged?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  languageCode?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  notificationSortField?: InputMaybe<NotificationSortField>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<NotificationStatus>>;
};

export type Table = {
  __typename?: 'Table';
  /**  Column properties of table  */
  columnProperties: Array<ColumnProperty>;
  /**  Data of table */
  data: Array<Maybe<Scalars['Object']>>;
  /**  Table Name  */
  name: Scalars['String'];
};

export type Task = {
  __typename?: 'Task';
  /**  when the task was created  */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**  task data  */
  data: Scalars['JSON'];
  /**  when the task should end  */
  end: Scalars['DateTime'];
  /**  exdate  */
  exdate?: Maybe<Scalars['String']>;
  /**  External Center Id */
  externalCenterId?: Maybe<Scalars['String']>;
  /**  task id  */
  id: Scalars['ID'];
  /**  task name  */
  name: Scalars['String'];
  /**  the next scheduled date for the task  */
  nextExecutionDate?: Maybe<Scalars['DateTime']>;
  /**  when the task recurrence should end  */
  recurrenceEndDate?: Maybe<Scalars['DateTime']>;
  /**  when the task recurrence started  */
  recurrenceStartDate?: Maybe<Scalars['DateTime']>;
  /**  RFC 5545 string rrule configuration  */
  rrule?: Maybe<Scalars['String']>;
  /**  when the task should start  */
  start: Scalars['DateTime'];
  /**  recurrence type for the task  */
  taskRecurrenceType: TaskRecurrenceType;
  /**  type for the task  */
  taskType: TaskType;
  /**  timezone  */
  timezone?: Maybe<Scalars['String']>;
  /**  when the task was updated  */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskInput = {
  /**  bean name  */
  beanName?: InputMaybe<Scalars['String']>;
  /**  when the task was created  */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /**  task data  */
  data: Scalars['JSON'];
  /**  when the task should end  */
  end: Scalars['DateTime'];
  /**  task id  */
  id?: InputMaybe<Scalars['ID']>;
  /**  task name  */
  name: Scalars['String'];
  /**  when the task recurrence should end  */
  recurrenceEndDate?: InputMaybe<Scalars['DateTime']>;
  /**  when the task recurrence started  */
  recurrenceStartDate?: InputMaybe<Scalars['DateTime']>;
  /**  RFC 5545 string rrule configuration  */
  rrule?: InputMaybe<Scalars['String']>;
  /**  when the task should start  */
  start: Scalars['DateTime'];
  /**  recurrence type for the task  */
  taskRecurrenceType: TaskRecurrenceType;
  /**  type for the task  */
  taskType: TaskType;
  /**  timezone  */
  timezone?: InputMaybe<Scalars['String']>;
  /**  when the task was updated  */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TaskOccurrence = {
  __typename?: 'TaskOccurrence';
  /**  end time of the occurrence  */
  end: Scalars['DateTime'];
  /**  start time of the occurrence  */
  start: Scalars['DateTime'];
  /**  the task attached to the occurrence  */
  task: Task;
};

export type TaskProgress = {
  __typename?: 'TaskProgress';
  associatedIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  progress: Scalars['Int'];
  resource?: Maybe<Scalars['String']>;
  source: KineticModule;
  status: TaskProgressStatus;
  systemTask?: Maybe<Scalars['Boolean']>;
  task: Scalars['String'];
  type: TaskProgressType;
  updated: Scalars['DateTime'];
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TaskProgressConnection = {
  __typename?: 'TaskProgressConnection';
  edges: Array<TaskProgressConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TaskProgressConnectionEdge = {
  __typename?: 'TaskProgressConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: TaskProgress;
};

export type TaskProgressQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter alarms.  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum TaskProgressStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED'
}

export enum TaskProgressType {
  FileDownload = 'FILE_DOWNLOAD',
  Import = 'IMPORT',
  JobExecution = 'JOB_EXECUTION',
  SignalDatabaseDownload = 'SIGNAL_DATABASE_DOWNLOAD',
  SignalDatabaseUpload = 'SIGNAL_DATABASE_UPLOAD'
}

export enum TaskRecurrenceType {
  /**  creates a recurring task  */
  RecurringTask = 'RECURRING_TASK',
  /**  creates a single task  */
  SingleTask = 'SINGLE_TASK'
}

export enum TaskType {
  /**  camera public feed */
  CameraCutPublicFeed = 'CAMERA_CUT_PUBLIC_FEED',
  /**  camera home preset  */
  CameraHomePreset = 'CAMERA_HOME_PRESET',
  /**  camera recording  */
  CameraRecord = 'CAMERA_RECORD',
  InternalActivationEvent = 'INTERNAL_ACTIVATION_EVENT',
  InternalScheduledEvent = 'INTERNAL_SCHEDULED_EVENT',
  ReportBuilder = 'REPORT_BUILDER',
  /**  resource plan recurrence  */
  ResourcePlanRecurrence = 'RESOURCE_PLAN_RECURRENCE',
  ScheduledEvent = 'SCHEDULED_EVENT',
  SignalActionSet = 'SIGNAL_ACTION_SET',
  SignalActivityLogReportExport = 'SIGNAL_ACTIVITY_LOG_REPORT_EXPORT',
  SignalAlarmNotification = 'SIGNAL_ALARM_NOTIFICATION',
  SignalAlarmReportExport = 'SIGNAL_ALARM_REPORT_EXPORT',
  SignalChangeFirmware = 'SIGNAL_CHANGE_FIRMWARE',
  SignalCommand = 'SIGNAL_COMMAND',
  SignalCommandSet = 'SIGNAL_COMMAND_SET',
  SignalDatabaseArchive = 'SIGNAL_DATABASE_ARCHIVE',
  SignalDatabaseBackup = 'SIGNAL_DATABASE_BACKUP',
  SignalReminder = 'SIGNAL_REMINDER',
  SignalTrafficResponsive = 'SIGNAL_TRAFFIC_RESPONSIVE'
}

export enum TemplateType {
  Email = 'EMAIL',
  EventReport = 'EVENT_REPORT',
  FiveOneOne = 'FIVE_ONE_ONE',
  Sms = 'SMS'
}

export type TenantIntegration = {
  __typename?: 'TenantIntegration';
  externalId: Scalars['String'];
  id: Scalars['ID'];
  tenant?: Maybe<Scalars['String']>;
};

export type TimeDriftException = {
  __typename?: 'TimeDriftException';
  /**  A time without a time-zone in the ISO-8601 calendar system, such as 10:45:30 */
  end: Scalars['LocalTime'];
  /**  A time without a time-zone in the ISO-8601 calendar system, such as 10:15:30 */
  start: Scalars['LocalTime'];
};

export type TimeDriftExceptionInput = {
  /**  A time without a time-zone in the ISO-8601 calendar system, such as 10:45:30 */
  end: Scalars['LocalTime'];
  /**  A time without a time-zone in the ISO-8601 calendar system, such as 10:15:30 */
  start: Scalars['LocalTime'];
};

export type TimeDriftSettings = {
  __typename?: 'TimeDriftSettings';
  /**  The time drift threshold in seconds  */
  alarmThreshold: Scalars['Int'];
  /**  If true, kinetic mobility will send set time now.  */
  autoCorrect: Scalars['Boolean'];
  /**  Auto Correct threshold */
  correctionThreshold: Scalars['Int'];
  /**  The time drift exceptions */
  exceptions: Array<TimeDriftException>;
};

export type TimeDriftSettingsInput = {
  /**  The time drift threshold in seconds  */
  alarmThreshold: Scalars['Int'];
  /**  If true, kinetic mobility will send set time now.  */
  autoCorrect: Scalars['Boolean'];
  /**  Auto Correct threshold */
  correctionThreshold: Scalars['Int'];
  /**  The time drift exceptions */
  exceptions: Array<TimeDriftExceptionInput>;
};

export type TimeOfDay = {
  /**  hour – The hour of day, between 0 and 23. */
  hour?: InputMaybe<Scalars['Int']>;
  /**  minute – The minute of the hour, between 0 and 59. */
  minute?: InputMaybe<Scalars['Int']>;
  /**  second – The second of the minute, between 0 and 59. */
  second?: InputMaybe<Scalars['Int']>;
};

export type TimeSpaceNodeData = {
  __typename?: 'TimeSpaceNodeData';
  deviceId: Scalars['String'];
  downPhase?: Maybe<TimeSpacePhase>;
  id: Scalars['String'];
  name: Scalars['String'];
  pattern: Array<TimeSpacePattern>;
  travelDown?: Maybe<TravelDirectionData>;
  travelUp?: Maybe<TravelDirectionData>;
  upPhase?: Maybe<TimeSpacePhase>;
};

export type TimeSpaceOffsetData = {
  __typename?: 'TimeSpaceOffsetData';
  timestamp: Scalars['Int'];
  value: Scalars['Int'];
};

export type TimeSpacePattern = {
  __typename?: 'TimeSpacePattern';
  cycleLength: Scalars['Int'];
  from: Scalars['Int'];
  number: Scalars['Int'];
  offset: TimeSpaceOffsetData;
  programmedSplits?: Maybe<DirectionalProgrammedSplits>;
  to: Scalars['Int'];
};

export type TimeSpacePhase = {
  __typename?: 'TimeSpacePhase';
  historicData: Array<PhaseServiceTimes>;
  number?: Maybe<Scalars['Int']>;
};

export type TollingInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter toll roads  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  search text  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort on  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Sort order  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum TollingLinkStatus {
  Closed = 'CLOSED',
  NorthboundClosing = 'NORTHBOUND_CLOSING',
  NorthboundOpen = 'NORTHBOUND_OPEN',
  NorthboundOpening = 'NORTHBOUND_OPENING',
  NoDetermination = 'NO_DETERMINATION',
  Open = 'OPEN',
  Restricted = 'RESTRICTED',
  SouthboundClosing = 'SOUTHBOUND_CLOSING',
  SouthboundOpen = 'SOUTHBOUND_OPEN',
  SouthboundOpening = 'SOUTHBOUND_OPENING',
  Unknown = 'UNKNOWN'
}

export type TollingPoint = {
  __typename?: 'TollingPoint';
  /**  the active alarms  */
  activeAlarms?: Maybe<Array<Scalars['String']>>;
  /**  the communication status of the tolling point  */
  communicationState: CommunicationState;
  /**  the description  */
  description?: Maybe<Scalars['String']>;
  /**  the direction of the point  */
  direction?: Maybe<Direction>;
  /** the Id  */
  id: Scalars['ID'];
  /**  Is the tolling point message currently being displayed  */
  isActive: Scalars['Boolean'];
  /**  the current link status  */
  linkStatus: TollingLinkStatus;
  /**  the location geometry  */
  location?: Maybe<Scalars['Object']>;
  /**  the location description  */
  locationDescription?: Maybe<Scalars['String']>;
  /**  the associated kinetic location id  */
  locationId?: Maybe<Scalars['String']>;
  /**  the name  */
  name: Scalars['String'];
  /**  the plaza direction, if reversible  */
  plazaDirection?: Maybe<Direction>;
  /**  the plaza id  */
  plazaId?: Maybe<Scalars['String']>;
  /**  the reference point  */
  referencePoint?: Maybe<Scalars['Float']>;
  /**  the reversal plaza id  */
  reversalPlazaId?: Maybe<Scalars['String']>;
  /**  the road  */
  road?: Maybe<Scalars['String']>;
  /**  The id of the toll road, if this point is associated  */
  tollRoadId?: Maybe<Scalars['ID']>;
  /**  The current status of the tolling point  */
  tollingPointStatus: TollingPointStatus;
  /**  The updated at time  */
  updatedAt: Scalars['DateTime'];
};

export enum TollingPointStatus {
  AppNotRunning = 'APP_NOT_RUNNING',
  Initializing = 'INITIALIZING',
  InOverride = 'IN_OVERRIDE',
  Normal = 'NORMAL',
  NotInFromPlaza = 'NOT_IN_FROM_PLAZA',
  NotReversible = 'NOT_REVERSIBLE',
  NoChangeRequested = 'NO_CHANGE_REQUESTED',
  OtherError = 'OTHER_ERROR',
  UnauthorizedHost = 'UNAUTHORIZED_HOST'
}

export type TollingPointsConnection = {
  __typename?: 'TollingPointsConnection';
  /**  edges  */
  edges: Array<TollingPointsConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type TollingPointsConnectionEdge = {
  __typename?: 'TollingPointsConnectionEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: TollingPoint;
};

export type TollingPointsQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter tolling points  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  search text  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort on  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Sort order  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type TollingPricing = {
  __typename?: 'TollingPricing';
  /**  the list of active alarms  */
  activeAlarms: Array<Scalars['String']>;
  /**  communication state  */
  communicationStatus: CommunicationState;
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  failed poll count  */
  failedPollCount: Scalars['Int'];
  /**  the identifier of the pricing  */
  id: Scalars['ID'];
  /**  last data received  */
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  /**  the current pricing mode  */
  mode: TollingPricingMode;
  /**  the name of the pricing  */
  name: Scalars['String'];
  /**  the list of current rates  */
  rates: Array<PricingRate>;
  /**  the list of historical rates  */
  ratesHistorical: Array<HistoricalPricingRate>;
};

export type TollingPricingConfirmedRate = {
  __typename?: 'TollingPricingConfirmedRate';
  /**  communication status  */
  communicationStatus: Scalars['String'];
  /**  end time of the rate  */
  endTime?: Maybe<Scalars['DateTime']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  sign name  */
  name: Scalars['String'];
  /**  the rate details  */
  rate?: Maybe<PricingRate>;
  /**  start time of the rate  */
  startTime: Scalars['DateTime'];
  /**  sign status  */
  status: Scalars['String'];
};

export type TollingPricingConfirmedRateConnection = {
  __typename?: 'TollingPricingConfirmedRateConnection';
  /**  edges  */
  edges: Array<TollingPricingConfirmedRateConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type TollingPricingConfirmedRateConnectionEdge = {
  __typename?: 'TollingPricingConfirmedRateConnectionEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: TollingPricingConfirmedRate;
};

export type TollingPricingConfirmedRateHistory = {
  __typename?: 'TollingPricingConfirmedRateHistory';
  /**  communication status  */
  communicationStatus: Scalars['String'];
  /**  end time of the rate  */
  endTime?: Maybe<Scalars['DateTime']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  sign name  */
  name: Scalars['String'];
  /**  the rate details  */
  rate?: Maybe<PricingRate>;
  /**  start time of the rate  */
  startTime: Scalars['DateTime'];
  /**  sign status  */
  status: Scalars['String'];
  /**  timestamp  */
  timestamp: Scalars['DateTime'];
};

export type TollingPricingConfirmedRateHistoryConnection = {
  __typename?: 'TollingPricingConfirmedRateHistoryConnection';
  /**  edges  */
  edges: Array<TollingPricingConfirmedRateHistoryConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type TollingPricingConfirmedRateHistoryConnectionEdge = {
  __typename?: 'TollingPricingConfirmedRateHistoryConnectionEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: TollingPricingConfirmedRateHistory;
};

export type TollingPricingConnection = {
  __typename?: 'TollingPricingConnection';
  /**  edges  */
  edges: Array<TollingPricingConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type TollingPricingConnectionEdge = {
  __typename?: 'TollingPricingConnectionEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: TollingPricing;
};

export type TollingPricingHistoricalRateHistory = {
  __typename?: 'TollingPricingHistoricalRateHistory';
  /**  identifier  */
  id: Scalars['ID'];
  /**  pricing integration  */
  pricingId: Scalars['ID'];
  /**  the rate package  */
  rate: HistoricalPricingRate;
  /**  timestamp  */
  timestamp: Scalars['DateTime'];
};

export type TollingPricingHistoricalRateHistoryConnection = {
  __typename?: 'TollingPricingHistoricalRateHistoryConnection';
  /**  edges  */
  edges: Array<TollingPricingHistoricalRateHistoryConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type TollingPricingHistoricalRateHistoryConnectionEdge = {
  __typename?: 'TollingPricingHistoricalRateHistoryConnectionEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: TollingPricingHistoricalRateHistory;
};

export enum TollingPricingMode {
  /**  pricing is using historical rates  */
  Historical = 'HISTORICAL',
  /**  pricing is using current rates  */
  Normal = 'NORMAL'
}

export type TollingPricingQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter toll roads  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  search text  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort on  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Sort order  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type TollingPricingRateHistory = {
  __typename?: 'TollingPricingRateHistory';
  /**  identifier  */
  id: Scalars['ID'];
  /**  pricing integration  */
  pricingId: Scalars['ID'];
  /**  the rate package  */
  rate: PricingRate;
  /**  timestamp  */
  timestamp: Scalars['DateTime'];
};

export type TollingPricingRateHistoryConnection = {
  __typename?: 'TollingPricingRateHistoryConnection';
  /**  edges  */
  edges: Array<TollingPricingRateHistoryConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type TollingPricingRateHistoryConnectionEdge = {
  __typename?: 'TollingPricingRateHistoryConnectionEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: TollingPricingRateHistory;
};

export type TollingRoad = {
  __typename?: 'TollingRoad';
  /**  description of the road  */
  description?: Maybe<Scalars['String']>;
  /**  associated pricing identifier  */
  dynamicPricingId?: Maybe<Scalars['ID']>;
  /**  the identifier of the road  */
  id: Scalars['ID'];
  /**  the name of road  */
  name: Scalars['String'];
  /**  associated toll points  */
  tollingPoints: Array<Scalars['ID']>;
  /**  associated toll segments  */
  tollingSegments: Array<Scalars['ID']>;
};

export type TollingRoadConnection = {
  __typename?: 'TollingRoadConnection';
  /**  edges  */
  edges: Array<TollingRoadConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type TollingRoadConnectionEdge = {
  __typename?: 'TollingRoadConnectionEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: TollingRoad;
};

export type TollingRoadInput = {
  /**  description of the road  */
  description?: InputMaybe<Scalars['String']>;
  /**  associated pricing identifier  */
  dynamicPricingId?: InputMaybe<Scalars['ID']>;
  /**  the identifier of the road  */
  id?: InputMaybe<Scalars['ID']>;
  /**  the name of road  */
  name: Scalars['String'];
  /**  associated toll points  */
  tollingPoints: Array<Scalars['ID']>;
  /**  associated toll segments  */
  tollingSegments: Array<Scalars['ID']>;
};

export type TollingRoadQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter toll roads  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  search text  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort on  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Sort order  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type TollingSegment = {
  __typename?: 'TollingSegment';
  /**  the description, optional  */
  description?: Maybe<Scalars['String']>;
  /**  the list of destinations  */
  destinations: Array<Scalars['String']>;
  /**  associated detector identifiers  */
  detectors: Array<Scalars['ID']>;
  /**  the direction of the segment  */
  direction: Direction;
  /**  the end linear reference  */
  endReference: Scalars['Float'];
  /**  the identifier of the segment  */
  id: Scalars['ID'];
  /**  the location of the segment  */
  location?: Maybe<Scalars['Object']>;
  /**  associated location identifier  */
  locationId: Scalars['ID'];
  /**  the name of the segment  */
  name: Scalars['String'];
  /**  the roadway of the segment  */
  road: Scalars['String'];
  /**  associated sign identifiers  */
  signs: Array<Scalars['ID']>;
  /**  the start linear reference  */
  startReference: Scalars['Float'];
  /**  associated toll road  */
  tollRoadId?: Maybe<Scalars['ID']>;
};

export type TollingSegmentConnection = {
  __typename?: 'TollingSegmentConnection';
  /**  edges  */
  edges: Array<TollingSegmentConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type TollingSegmentConnectionEdge = {
  __typename?: 'TollingSegmentConnectionEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: TollingSegment;
};

export type TollingSegmentInput = {
  /**  the description, optional  */
  description?: InputMaybe<Scalars['String']>;
  /**  the list of destinations  */
  destinations?: Array<Scalars['String']>;
  /**  associated detector identifiers  */
  detectors?: Array<Scalars['ID']>;
  /**  the direction of the segment  */
  direction: Direction;
  /**  the end linear reference  */
  endReference: Scalars['Float'];
  /**  identifier of the segment  */
  id?: InputMaybe<Scalars['ID']>;
  /**  the location of the segment  */
  location?: InputMaybe<Scalars['Object']>;
  /**  associated location identifier  */
  locationId: Scalars['ID'];
  /**  the name of the segment  */
  name: Scalars['String'];
  /**  the roadway of the segment  */
  road: Scalars['String'];
  /**  associated sign identifiers  */
  signs?: Array<Scalars['ID']>;
  /**  the start linear reference  */
  startReference: Scalars['Float'];
  /**  associated toll road  */
  tollRoadId?: InputMaybe<Scalars['ID']>;
};

export type TollingSegmentQuery = {
  /**  Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter toll roads  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  search text  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort on  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Sort order  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type TollingSign = {
  __typename?: 'TollingSign';
  /**  communication status  */
  communicationState?: Maybe<Scalars['String']>;
  /**  current message  */
  currentMessage?: Maybe<SignMessage>;
  /**  The direction of the sign  */
  direction?: Maybe<Scalars['String']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  The last time the sign was successfully polled  */
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  /**  current pricing mode  */
  mode: TollingPricingMode;
  /**  sign name  */
  name: Scalars['String'];
  /**  pricing identifier  */
  pricingId?: Maybe<Scalars['ID']>;
  primaryHistoricalRate?: Maybe<PricingRate>;
  rate?: Maybe<PricingRate>;
  /**  The reference point of the sign  */
  referencePoint?: Maybe<Scalars['Float']>;
  /**  The road that the sign serves  */
  road?: Maybe<Scalars['String']>;
  /**  rate details  */
  secondaryHistoricalRate?: Maybe<PricingRate>;
};

export type TollingSignsConnection = {
  __typename?: 'TollingSignsConnection';
  /**  edges  */
  edges: Array<TollingSignsEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type TollingSignsEdge = {
  __typename?: 'TollingSignsEdge';
  /**  cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  node  */
  node: TollingSign;
};

export type Tour = {
  __typename?: 'Tour';
  description?: Maybe<Scalars['String']>;
  heartBeatIntervalSeconds?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
  speed?: Maybe<Scalars['Int']>;
  steps: Array<TourStep>;
};

export type TourCamera = {
  __typename?: 'TourCamera';
  camera: Camera;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TourCameraInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TourConnection = {
  __typename?: 'TourConnection';
  edges: Array<TourConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TourConnectionEdge = {
  __typename?: 'TourConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Tour;
};

export type TourInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
  speed?: InputMaybe<Scalars['Int']>;
  steps: Array<TourStepInput>;
};

export type TourInputQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type TourPreset = {
  __typename?: 'TourPreset';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TourPresetInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TourStep = {
  __typename?: 'TourStep';
  camera: TourCamera;
  preset?: Maybe<TourPreset>;
};

export type TourStepInput = {
  camera: TourCameraInput;
  preset?: InputMaybe<TourPresetInput>;
};

export type TrafficControl = {
  __typename?: 'TrafficControl';
  /**  communication status  */
  communicationStatus: CommunicationState;
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  direction  */
  direction: Direction;
  /**  identifier  */
  id: Scalars['ID'];
  /**  lane direction  */
  laneDirection?: Maybe<Direction>;
  /**  lane position  */
  lanePosition: Scalars['Int'];
  /**  lane type  */
  laneType: LaneType;
  /**  last data received  */
  lastDataReceived: Scalars['DateTime'];
  /**  location  */
  location: Scalars['Object'];
  /**  control mode  */
  mode: TrafficControlMode;
  /**  name  */
  name: Scalars['String'];
  /**  reference point  */
  referencePoint: Scalars['Float'];
  /**  road  */
  road: Scalars['String'];
  /**  system enabled  */
  systemEnabled: Scalars['Boolean'];
};

export type TrafficControlConnection = {
  __typename?: 'TrafficControlConnection';
  /**  Connection Edges  */
  edges: Array<TrafficControlConnectionEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type TrafficControlConnectionEdge = {
  __typename?: 'TrafficControlConnectionEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The Corridor object  */
  node: TrafficControl;
};

export type TrafficControlInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum TrafficControlMode {
  /**  Traffic Control is flashing yellow  */
  Flashing = 'FLASHING',
  /**  Traffic Control is off  */
  Off = 'OFF',
  /**  Traffic Control is open green  */
  Open = 'OPEN',
  /**  Traffic Control is stopped red  */
  Stop = 'STOP',
  /**  Traffic Control is in an unknown state  */
  Unknown = 'UNKNOWN'
}

export type TrafficEventCategory = {
  __typename?: 'TrafficEventCategory';
  categoryId: Scalars['Int'];
  categoryName: Scalars['String'];
  universalEventCodeRange: Scalars['String'];
};

export type TrafficEventDefinition = {
  __typename?: 'TrafficEventDefinition';
  eventCategoryId: Scalars['Int'];
  eventCategoryName?: Maybe<Scalars['String']>;
  eventDefinitionType: TrafficEventDefinitionType;
  eventDescription?: Maybe<Scalars['String']>;
  parameterDescription?: Maybe<Scalars['String']>;
  universalEventCode?: Maybe<Scalars['Int']>;
  universalEventName?: Maybe<Scalars['String']>;
  vendorEventCode: Scalars['Int'];
  vendorEventName: Scalars['String'];
};

export enum TrafficEventDefinitionType {
  CubicScout = 'CUBIC_SCOUT',
  Econolite = 'ECONOLITE',
  Peek = 'PEEK',
  Qfree = 'QFREE',
  Siemens = 'SIEMENS'
}

export type TrafficResponsiveActionDeviceLog = {
  __typename?: 'TrafficResponsiveActionDeviceLog';
  firstCommandSent: Scalars['DateTime'];
  id: Scalars['ID'];
  intersection: BasicIntersection;
};

export type TrafficResponsiveActionLog = {
  __typename?: 'TrafficResponsiveActionLog';
  actionName: Scalars['String'];
  activated?: Maybe<Scalars['Boolean']>;
  commandDescription: Scalars['String'];
  devices: Array<TrafficResponsiveActionDeviceLog>;
  id: Scalars['ID'];
  referenceValue: Scalars['Float'];
  selected: Scalars['Boolean'];
  timestamp: Scalars['DateTime'];
  trafficResponsivePlanId: Scalars['String'];
};

export type TrafficResponsiveActionLogConnection = {
  __typename?: 'TrafficResponsiveActionLogConnection';
  edges: Array<TrafficResponsiveActionLogConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TrafficResponsiveActionLogConnectionEdge = {
  __typename?: 'TrafficResponsiveActionLogConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: TrafficResponsiveActionLog;
};

export type TrafficResponsivePlan = {
  __typename?: 'TrafficResponsivePlan';
  actions: Array<TrafficResponsivePlanAction>;
  description?: Maybe<Scalars['String']>;
  frequency: Scalars['Int'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
};

export type TrafficResponsivePlanAction = {
  __typename?: 'TrafficResponsivePlanAction';
  command: Scalars['JSON'];
  detectorGroups: Array<TrafficResponsivePlanDetectorGroup>;
  id: Scalars['ID'];
  minimumImprovement: Scalars['Int'];
  name: Scalars['String'];
};

export type TrafficResponsivePlanActionInput = {
  command: Scalars['JSON'];
  detectorGroups: Array<TrafficResponsivePlanDetectorGroupInput>;
  id?: InputMaybe<Scalars['ID']>;
  minimumImprovement: Scalars['Int'];
  name: Scalars['String'];
};

export type TrafficResponsivePlanActionSummary = {
  __typename?: 'TrafficResponsivePlanActionSummary';
  command: Scalars['JSON'];
  detectorGroups: Array<TrafficResponsivePlanDetectorGroupSummary>;
  id: Scalars['ID'];
  minimumImprovement: Scalars['Int'];
  name: Scalars['String'];
  observedFrom?: Maybe<Scalars['DateTime']>;
  observedTo?: Maybe<Scalars['DateTime']>;
  referenceValue?: Maybe<Scalars['Float']>;
  selected?: Maybe<Scalars['Boolean']>;
};

export type TrafficResponsivePlanConnection = {
  __typename?: 'TrafficResponsivePlanConnection';
  edges: Array<TrafficResponsivePlanConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TrafficResponsivePlanConnectionEdge = {
  __typename?: 'TrafficResponsivePlanConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: TrafficResponsivePlan;
};

export type TrafficResponsivePlanDetectorGroup = {
  __typename?: 'TrafficResponsivePlanDetectorGroup';
  detectorGroupId: Scalars['String'];
  kValue: Scalars['Float'];
  occupancy: Scalars['Int'];
  volume: Scalars['Int'];
};

export type TrafficResponsivePlanDetectorGroupInput = {
  detectorGroupId: Scalars['String'];
  kValue: Scalars['Float'];
  occupancy: Scalars['Int'];
  volume: Scalars['Int'];
};

export type TrafficResponsivePlanDetectorGroupSummary = {
  __typename?: 'TrafficResponsivePlanDetectorGroupSummary';
  description?: Maybe<Scalars['String']>;
  detectorGroupId: Scalars['String'];
  detectors: Array<TrafficResponsivePlanDetectorSummary>;
  kValue: Scalars['Float'];
  name: Scalars['String'];
  observedOccupancy?: Maybe<Scalars['Int']>;
  observedSpeed?: Maybe<Scalars['Int']>;
  observedVolume?: Maybe<Scalars['Int']>;
  occupancy: Scalars['Int'];
  referenceValue?: Maybe<Scalars['Float']>;
  volume: Scalars['Int'];
};

export type TrafficResponsivePlanDetectorSummary = {
  __typename?: 'TrafficResponsivePlanDetectorSummary';
  detector: Scalars['Int'];
  intersection: BasicIntersectionDevice;
  observedOccupancy?: Maybe<Scalars['Int']>;
  observedVolume?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type TrafficResponsivePlanInput = {
  actions: Array<TrafficResponsivePlanActionInput>;
  description?: InputMaybe<Scalars['String']>;
  frequency: Scalars['Int'];
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  number: Scalars['Int'];
};

export type TrafficResponsivePlanSummary = {
  __typename?: 'TrafficResponsivePlanSummary';
  actions: Array<TrafficResponsivePlanActionSummary>;
  description?: Maybe<Scalars['String']>;
  frequency: Scalars['Int'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
};

export type TranslatedNotification = {
  details?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum TravelDirection {
  East = 'EAST',
  North = 'NORTH',
  NorthEast = 'NORTH_EAST',
  NorthWest = 'NORTH_WEST',
  Other = 'OTHER',
  South = 'SOUTH',
  SouthEast = 'SOUTH_EAST',
  SouthWest = 'SOUTH_WEST',
  West = 'WEST'
}

export type TravelDirectionData = {
  __typename?: 'TravelDirectionData';
  distance: Scalars['Float'];
  speed: Scalars['Float'];
};

export type TravelTime = {
  __typename?: 'TravelTime';
  /**  associated signs  */
  associatedSigns: Array<Scalars['String']>;
  /**  communication state */
  communicationState?: Maybe<CommunicationState>;
  /**  delay travel time  */
  delay?: Maybe<Scalars['Int']>;
  /**  description  */
  description?: Maybe<Scalars['String']>;
  /**  distance  */
  distance?: Maybe<Scalars['Float']>;
  /**  if entity is external  */
  external: Scalars['Boolean'];
  /**  identifier of the external center  */
  externalCenter?: Maybe<Scalars['ID']>;
  /**  geometry  */
  geometry?: Maybe<Scalars['Object']>;
  /**  historic speed  */
  historicSpeed?: Maybe<Scalars['Float']>;
  /**  historic time  */
  historicTime?: Maybe<Scalars['Int']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  incremental reported time  */
  incrementalReportedTime: Scalars['Int'];
  /**  last connect time */
  lastConnect?: Maybe<Scalars['DateTime']>;
  /**  max reported delay  */
  maximumReportedDelay: Scalars['Int'];
  /**  max reported time  */
  maximumReportedTime: Scalars['Int'];
  /**  min reported delay  */
  minimumReportedDelay: Scalars['Int'];
  /**  min reported time  */
  minimumReportedTime: Scalars['Int'];
  /**  name  */
  name: Scalars['String'];
  /**  parts  */
  parts: Array<TravelTimePart>;
  /**  polling enabled  */
  pollingEnabled: Scalars['Boolean'];
  /**  data quality  */
  quality?: Maybe<TravelTimeDataQuality>;
  /**  reported time  */
  reportedTime?: Maybe<Scalars['Int']>;
  /**  smoothed time  */
  smoothedTime?: Maybe<Scalars['Int']>;
  /**  current speed in kph  */
  speed?: Maybe<Scalars['Float']>;
  /**  current travel time  */
  travelTime?: Maybe<Scalars['Int']>;
};

export type TravelTimeConnection = {
  __typename?: 'TravelTimeConnection';
  /**  Connection Edges  */
  edges: Array<TravelTimeConnectionEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type TravelTimeConnectionEdge = {
  __typename?: 'TravelTimeConnectionEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The TravelTime object  */
  node: TravelTime;
};

export enum TravelTimeDataQuality {
  /**  data is bad  */
  Bad = 'BAD',
  /**  data is good  */
  Good = 'GOOD',
  /**  no data received  */
  NoData = 'NO_DATA',
  /**  data is suspect  */
  Suspect = 'SUSPECT'
}

export type TravelTimeDelaySummary = {
  __typename?: 'TravelTimeDelaySummary';
  /**  The color associated with this range  */
  color: Scalars['String'];
  /**  Total number of results delayed within the range  */
  count: Scalars['Int'];
  /**  The end range for the travel time range  */
  endRange?: Maybe<Scalars['String']>;
  /**  Id of range  */
  id: Scalars['String'];
  /**  The start range for the travel time range  */
  startRange?: Maybe<Scalars['String']>;
};

export type TravelTimeDisplayRequest = {
  /**  association display names  */
  associationDisplayNames?: InputMaybe<Array<Scalars['String']>>;
  /**  association identifiers  */
  associations?: InputMaybe<Array<Scalars['String']>>;
  /**  expiration time  */
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  /**  sign identifier  */
  id: Scalars['ID'];
  /**  message template to display  */
  template: SignMessageInput;
};

export type TravelTimeDowHistory = {
  __typename?: 'TravelTimeDowHistory';
  /**  day of week  */
  dayOfWeek?: Maybe<Scalars['Int']>;
  /**  entity  */
  entity: Scalars['String'];
  /**  bucket period  */
  period?: Maybe<Scalars['Int']>;
  /**  number of samples  */
  samples?: Maybe<Scalars['Int']>;
  /**  speed  */
  speed?: Maybe<Scalars['Float']>;
  /**  travel time  */
  travelTime?: Maybe<Scalars['Float']>;
};

export type TravelTimeHistory = {
  __typename?: 'TravelTimeHistory';
  /**  entity identifier  */
  entityId: Scalars['ID'];
  /**  historic speed  */
  historicSpeed?: Maybe<Scalars['Float']>;
  /**  historic time  */
  historicTime?: Maybe<Scalars['Int']>;
  /**  identifier  */
  id: Scalars['ID'];
  /**  data quality  */
  quality?: Maybe<TravelTimeDataQuality>;
  /**  reported time  */
  reportedTime?: Maybe<Scalars['Int']>;
  /**  smoothed time  */
  smoothedTime?: Maybe<Scalars['Int']>;
  /**  current speed in kph  */
  speed?: Maybe<Scalars['Float']>;
  /**  timestamp  */
  timestamp: Scalars['DateTime'];
  /**  current travel time  */
  travelTime?: Maybe<Scalars['Int']>;
};

export type TravelTimeHistoryConnection = {
  __typename?: 'TravelTimeHistoryConnection';
  /**  Connection Edges  */
  edges: Array<TravelTimeHistoryConnectionEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type TravelTimeHistoryConnectionEdge = {
  __typename?: 'TravelTimeHistoryConnectionEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The TravelTime object  */
  node: TravelTimeHistory;
};

export type TravelTimeHistoryInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  end date  */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /**  identifier to filter history  */
  entityId: Scalars['String'];
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
  /**  start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type TravelTimeInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type TravelTimePart = {
  __typename?: 'TravelTimePart';
  /**  direction  */
  direction: Direction;
  /**  end reference  */
  endReference: Scalars['Float'];
  /**  road  */
  road: Scalars['String'];
  /**  start reference  */
  startReference: Scalars['Float'];
};

export type TunnelDeviceInputQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  showDisabled?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type TunnelFan = {
  __typename?: 'TunnelFan';
  communicationStatus?: Maybe<CommunicationState>;
  description?: Maybe<Scalars['String']>;
  direction?: Maybe<Direction>;
  id: Scalars['ID'];
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['Object']>;
  locationDescription?: Maybe<Scalars['String']>;
  locationFixed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  priority?: Maybe<Scalars['String']>;
  referencePoint?: Maybe<Scalars['Float']>;
  road?: Maybe<Scalars['String']>;
  runStatus?: Maybe<FanRunStatus>;
  running?: Maybe<Scalars['Boolean']>;
  serviceStatus?: Maybe<FanServiceStatus>;
  speed?: Maybe<Scalars['Int']>;
};

export type TunnelFanConnection = {
  __typename?: 'TunnelFanConnection';
  edges: Array<TunnelFanConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TunnelFanConnectionEdge = {
  __typename?: 'TunnelFanConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: TunnelFan;
};

export type TunnelLight = {
  __typename?: 'TunnelLight';
  communicationStatus?: Maybe<CommunicationState>;
  description?: Maybe<Scalars['String']>;
  direction?: Maybe<Direction>;
  id: Scalars['ID'];
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['Object']>;
  locationDescription?: Maybe<Scalars['String']>;
  locationFixed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  referencePoint?: Maybe<Scalars['Float']>;
  road?: Maybe<Scalars['String']>;
  status?: Maybe<LightStatus>;
};

export type TunnelLightConnection = {
  __typename?: 'TunnelLightConnection';
  edges: Array<TunnelLightConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TunnelLightConnectionEdge = {
  __typename?: 'TunnelLightConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: TunnelLight;
};

export type TunnelLog = {
  __typename?: 'TunnelLog';
  /**  identifier of the corridor  */
  corridorId: Scalars['ID'];
  /**  time at which log was created  */
  created: Scalars['DateTime'];
  /**  The data of the tunnel log built from a tunnel log form  */
  data?: Maybe<Scalars['Object']>;
  /**  the direction of the tunnel log  */
  directions?: Maybe<Array<Maybe<Direction>>>;
  /**  the event details  */
  event: Scalars['String'];
  /**  identifier of the log entry  */
  id: Scalars['ID'];
  /**  notes  */
  notes?: Maybe<Scalars['String']>;
  /**  user captured timestamp of entry  */
  timestamp: Scalars['DateTime'];
  /**  time at which log was updated  */
  updated: Scalars['DateTime'];
  /**  the full name of the user  */
  userFullName?: Maybe<Scalars['String']>;
  /**  the id of the user  */
  userId: Scalars['String'];
};

export type TunnelLogConnection = {
  __typename?: 'TunnelLogConnection';
  /**  Connection Edges  */
  edges: Array<TunnelLogConnectionEdge>;
  /**  Page Info  */
  pageInfo: PageInfo;
  /**  Total number of results  */
  totalCount: Scalars['Int'];
};

export type TunnelLogConnectionEdge = {
  __typename?: 'TunnelLogConnectionEdge';
  /**  Edge location in page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The tunnel log object  */
  node: TunnelLog;
};

export type TunnelLogInput = {
  /**  identifier of the corridor  */
  corridorId: Scalars['ID'];
  /**  The data of the tunnel log built from a tunnel log form  */
  data?: InputMaybe<Scalars['Object']>;
  /**  the direction of the tunnel log  */
  directions?: InputMaybe<Array<InputMaybe<Direction>>>;
  /**  the event details  */
  event: Scalars['String'];
  /**  identifier of the log entry  */
  id?: InputMaybe<Scalars['ID']>;
  /**  notes  */
  notes?: InputMaybe<Scalars['String']>;
  /**  user captured timestamp of entry  */
  timestamp: Scalars['DateTime'];
};

export type TunnelLogInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The corridor identifier  */
  corridorId: Scalars['ID'];
  /**  The fields and values to filter routes  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Field to sort object results  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Order to sort results  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type UnblockVideoStreamInput = {
  cameraId?: InputMaybe<Scalars['ID']>;
  streamName?: InputMaybe<Scalars['String']>;
};

export type UserPreference = {
  __typename?: 'UserPreference';
  key: Scalars['ID'];
  value: Scalars['JSON'];
};

export type UserPreferenceStreamObject = {
  __typename?: 'UserPreferenceStreamObject';
  id: Scalars['ID'];
  preferenceKey: Scalars['String'];
  streamObjectOperation: StreamObjectOperation;
  userPreference: UserPreference;
};

export type ValueAggregation = {
  __typename?: 'ValueAggregation';
  /**  Number of occurrences for this value */
  count: Scalars['Int'];
  /**  Previous trend of occurrences for this value */
  trend: Scalars['Int'];
  value: Scalars['String'];
};

export type ValueVariable = {
  __typename?: 'ValueVariable';
  address?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  value?: Maybe<Scalars['Object']>;
};

export type VehicleAxleWeightReportQuery = {
  classGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  className?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  detectorAxleWeightBandResolution?: InputMaybe<Scalars['Float']>;
  detectorIds: Array<Scalars['ID']>;
  endDate: Scalars['Date'];
  lane?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  laneDirection?: InputMaybe<Array<InputMaybe<Direction>>>;
  startDate: Scalars['Date'];
  types?: InputMaybe<Array<DetectorAxleType>>;
  unitPreference: ConversionUnitType;
  viewType: DateViewType;
};

export type VehicleAxleWeightReportResult = {
  __typename?: 'VehicleAxleWeightReportResult';
  date?: Maybe<Scalars['Date']>;
  maxAxleWeight: Scalars['Float'];
  minAxleWeight: Scalars['Float'];
  weightBinInfo: Scalars['Object'];
};

export type VehicleAxlesCountReportQuery = {
  classGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  className?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  detectorIds: Array<Scalars['ID']>;
  endDate: Scalars['Date'];
  lane?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  laneDirection?: InputMaybe<Array<InputMaybe<Direction>>>;
  startDate: Scalars['Date'];
  viewType: DateViewType;
};

export type VehicleAxlesCountReportResult = {
  __typename?: 'VehicleAxlesCountReportResult';
  axlesCountBinInfo: Scalars['Object'];
  date?: Maybe<Scalars['Date']>;
  maxAxleNumber: Scalars['Int'];
  minAxleNumber: Scalars['Int'];
};

export type VehicleGrossWeightReportQuery = {
  classGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  className?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  detectorGrossWeightBandResolution?: InputMaybe<Scalars['Int']>;
  detectorIds: Array<Scalars['ID']>;
  endDate: Scalars['Date'];
  lane?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  laneDirection?: InputMaybe<Array<InputMaybe<Direction>>>;
  startDate: Scalars['Date'];
  unitPreference: ConversionUnitType;
  viewType: DateViewType;
};

export type VehicleGrossWeightReportResult = {
  __typename?: 'VehicleGrossWeightReportResult';
  date?: Maybe<Scalars['Date']>;
  maxGrossWeight: Scalars['Float'];
  minGrossWeight: Scalars['Float'];
  weightBinInfo: Scalars['Object'];
};

export enum VerticalJustification {
  Bottom = 'BOTTOM',
  Middle = 'MIDDLE',
  Top = 'TOP'
}

export enum VideoItemType {
  Camera = 'CAMERA',
  Tour = 'TOUR',
  Widget = 'WIDGET'
}

export type VideoRecord = {
  __typename?: 'VideoRecord';
  camera?: Maybe<Camera>;
  cameraId: Scalars['String'];
  cameraName: Scalars['String'];
  id: Scalars['ID'];
  inProgress?: Maybe<Scalars['Boolean']>;
  recorderId: Scalars['String'];
  recorderName: Scalars['String'];
  recorderType?: Maybe<Scalars['String']>;
  recordingDuration?: Maybe<Scalars['Int']>;
  recordingEnd: Scalars['DateTime'];
  recordingInitiatedBy: RecordingInitiatedBy;
  recordingInitiatorId?: Maybe<Scalars['String']>;
  recordingInitiatorProperties?: Maybe<Scalars['JSON']>;
  recordingMediaFormat?: Maybe<Scalars['String']>;
  recordingName?: Maybe<Scalars['String']>;
  recordingStart: Scalars['DateTime'];
  recordingType: RecordingType;
  redundancyEnabled?: Maybe<Scalars['Boolean']>;
  secondaryServer?: Maybe<Scalars['Boolean']>;
  serverFileName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  streamUrl: Scalars['String'];
};

export type VideoRecordConnection = {
  __typename?: 'VideoRecordConnection';
  edges: Array<VideoRecordConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VideoRecordConnectionEdge = {
  __typename?: 'VideoRecordConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: VideoRecord;
};

export type VideoStream = {
  __typename?: 'VideoStream';
  accessType?: Maybe<VideoStreamAccessType>;
  application?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  recordingServer?: Maybe<Scalars['String']>;
  streamManager?: Maybe<Scalars['String']>;
  streamName?: Maybe<Scalars['String']>;
  streamTargetName?: Maybe<Scalars['String']>;
  streamType: Scalars['String'];
  url: Scalars['String'];
};

export enum VideoStreamAccessType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Trusted = 'TRUSTED'
}

export type VideoStreamBlock = {
  __typename?: 'VideoStreamBlock';
  associatedEventIds?: Maybe<Array<Scalars['ID']>>;
  /**  Used in conjunction with duration to save the exact time the block will be removed  */
  blockedUntil?: Maybe<Scalars['DateTime']>;
  cameraId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  disabledByUserId: Scalars['String'];
  disabledByUserName?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  serverConfirmed?: Maybe<Scalars['Boolean']>;
  serverConfirmedAt?: Maybe<Scalars['DateTime']>;
  serverConfirmedName?: Maybe<Scalars['String']>;
  streamName?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
};

export type VideoStreamBlockConnection = {
  __typename?: 'VideoStreamBlockConnection';
  edges: Array<VideoStreamBlockConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VideoStreamBlockConnectionEdge = {
  __typename?: 'VideoStreamBlockConnectionEdge';
  cursor?: Maybe<Scalars['String']>;
  node: VideoStreamBlock;
};

export type VideoStreamBlockInputQuery = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type VideoWallDetail = {
  __typename?: 'VideoWallDetail';
  name: Scalars['String'];
  protocol: Scalars['String'];
};

export type VideoWallObject = CameraGroup | Scene | Screen | Widget;

export enum VideoWallObjectType {
  Group = 'GROUP',
  Scene = 'SCENE',
  Screen = 'SCREEN',
  Widget = 'WIDGET'
}

export type VideoWallStreamObject = {
  __typename?: 'VideoWallStreamObject';
  id: Scalars['ID'];
  streamObjectOperation: StreamObjectOperation;
  videoWallObject?: Maybe<VideoWallObject>;
  videoWallObjectType: VideoWallObjectType;
};

export type WatchedTour = {
  __typename?: 'WatchedTour';
  camera: Camera;
  isPaused?: Maybe<Scalars['Boolean']>;
  nextCamera: Camera;
};

export type Weather = {
  __typename?: 'Weather';
  base?: Maybe<Scalars['String']>;
  clouds?: Maybe<WeatherClouds>;
  cod?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  hour?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  main?: Maybe<WeatherMain>;
  name?: Maybe<Scalars['String']>;
  sys?: Maybe<WeatherSys>;
  timestamp?: Maybe<Scalars['DateTime']>;
  visibility?: Maybe<Scalars['Int']>;
  weather?: Maybe<Array<Maybe<WeatherDetail>>>;
  wind?: Maybe<WeatherWind>;
};

export type WeatherClouds = {
  __typename?: 'WeatherClouds';
  all?: Maybe<Scalars['Int']>;
};

export type WeatherDetail = {
  __typename?: 'WeatherDetail';
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  main?: Maybe<Scalars['String']>;
};

export type WeatherMain = {
  __typename?: 'WeatherMain';
  feels_like?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Int']>;
  pressure?: Maybe<Scalars['Int']>;
  temp?: Maybe<Scalars['Float']>;
  temp_max?: Maybe<Scalars['Float']>;
  temp_min?: Maybe<Scalars['Float']>;
};

export enum WeatherSensorCategory {
  /**  Atmospheric  */
  Atmospheric = 'ATMOSPHERIC',
  /**  Extended Atmospheric  */
  AtmosphericExtended = 'ATMOSPHERIC_EXTENDED',
  /**  Pavement  */
  Pavement = 'PAVEMENT',
  /**  Subsurface  */
  Subsurface = 'SUBSURFACE'
}

export enum WeatherSensorType {
  AdjacentSnowDepth = 'ADJACENT_SNOW_DEPTH',
  AirQuality = 'AIR_QUALITY',
  AverageWindDirection = 'AVERAGE_WIND_DIRECTION',
  AverageWindSpeed = 'AVERAGE_WIND_SPEED',
  BatteryStatus = 'BATTERY_STATUS',
  DewPointTemperature = 'DEW_POINT_TEMPERATURE',
  Fog = 'FOG',
  FreezingTemperature = 'FREEZING_TEMPERATURE',
  GroundTemperature = 'GROUND_TEMPERATURE',
  Humidity = 'HUMIDITY',
  IceThickness = 'ICE_THICKNESS',
  LineVoltage = 'LINE_VOLTAGE',
  LiquidFreezingTemperature = 'LIQUID_FREEZING_TEMPERATURE',
  MaxTemperature = 'MAX_TEMPERATURE',
  MaxWindGustSpeed = 'MAX_WIND_GUST_SPEED',
  MinTemperature = 'MIN_TEMPERATURE',
  PavementBlackIceSignal = 'PAVEMENT_BLACK_ICE_SIGNAL',
  PavementConductivity = 'PAVEMENT_CONDUCTIVITY',
  PavementElevation = 'PAVEMENT_ELEVATION',
  PavementExposure = 'PAVEMENT_EXPOSURE',
  PavementFreezingPoint = 'PAVEMENT_FREEZING_POINT',
  PavementFrictionIndex = 'PAVEMENT_FRICTION_INDEX',
  PavementSalinity = 'PAVEMENT_SALINITY',
  PavementSensorError = 'PAVEMENT_SENSOR_ERROR',
  PavementSensorType = 'PAVEMENT_SENSOR_TYPE',
  PavementStatus = 'PAVEMENT_STATUS',
  PavementSurfaceState = 'PAVEMENT_SURFACE_STATE',
  PavementSurfaceType = 'PAVEMENT_SURFACE_TYPE',
  PavementTemperature = 'PAVEMENT_TEMPERATURE',
  PavementType = 'PAVEMENT_TYPE',
  PavementWaterDepth = 'PAVEMENT_WATER_DEPTH',
  PrecipitationEndTime = 'PRECIPITATION_END_TIME',
  PrecipitationPresent = 'PRECIPITATION_PRESENT',
  PrecipitationRate = 'PRECIPITATION_RATE',
  PrecipitationRate_1Hr = 'PRECIPITATION_RATE_1HR',
  PrecipitationRate_3Hr = 'PRECIPITATION_RATE_3HR',
  PrecipitationRate_6Hr = 'PRECIPITATION_RATE_6HR',
  PrecipitationRate_12Hr = 'PRECIPITATION_RATE_12HR',
  PrecipitationRate_24Hr = 'PRECIPITATION_RATE_24HR',
  PrecipitationSituation = 'PRECIPITATION_SITUATION',
  PrecipitationStartTime = 'PRECIPITATION_START_TIME',
  Pressure = 'PRESSURE',
  RainOnOff = 'RAIN_ON_OFF',
  RainState = 'RAIN_STATE',
  RoadSnowDepth = 'ROAD_SNOW_DEPTH',
  RoadSnowPackDepth = 'ROAD_SNOW_PACK_DEPTH',
  Snowfall = 'SNOWFALL',
  SnowfallRate = 'SNOWFALL_RATE',
  SolarRadiation = 'SOLAR_RADIATION',
  SolarRadiationAccumulation_10M = 'SOLAR_RADIATION_ACCUMULATION_10M',
  SpotWindDirection = 'SPOT_WIND_DIRECTION',
  SpotWindSpeed = 'SPOT_WIND_SPEED',
  SubsurfaceError = 'SUBSURFACE_ERROR',
  SubsurfaceMoisture = 'SUBSURFACE_MOISTURE',
  SubsurfaceTemperature = 'SUBSURFACE_TEMPERATURE',
  SubsurfaceType = 'SUBSURFACE_TYPE',
  Temperature = 'TEMPERATURE',
  TerminalVoltage = 'TERMINAL_VOLTAGE',
  TotalSun = 'TOTAL_SUN',
  Visibility = 'VISIBILITY',
  VisibilitySensorStatus = 'VISIBILITY_SENSOR_STATUS',
  WetBulbTemperature = 'WET_BULB_TEMPERATURE',
  WindGustDirection = 'WIND_GUST_DIRECTION',
  WindGustSpeed = 'WIND_GUST_SPEED',
  WindSituation = 'WIND_SITUATION'
}

export type WeatherStation = {
  __typename?: 'WeatherStation';
  communicationParameters?: Maybe<Scalars['Object']>;
  /**  The current communication status of the weather station  */
  communicationStatus: CommunicationState;
  /**  The description of the weather station  */
  description?: Maybe<Scalars['String']>;
  /**  The direction of the weather station  */
  direction?: Maybe<Scalars['String']>;
  /**  If this weather station is owned by an external center  */
  external: Scalars['Boolean'];
  /**  The ID of the external center that owns this weather station  */
  externalCenter?: Maybe<Scalars['String']>;
  /**  The identifier of the weather station  */
  id: Scalars['ID'];
  /**  The last time the weather station was successfully polled  */
  lastDataReceived?: Maybe<Scalars['DateTime']>;
  /** The coordinate of the weather station  */
  location?: Maybe<Scalars['JSON']>;
  /**  The location description  */
  locationDescription?: Maybe<Scalars['String']>;
  /**  The name of the weather station  */
  name: Scalars['String'];
  /**  current readings for the station  */
  readings: Array<WeatherStationReading>;
  /**  The reference point of the weather station  */
  referencePoint?: Maybe<Scalars['Float']>;
  /**  The road of the weather station  */
  road?: Maybe<Scalars['String']>;
  /**  Map of current values to sensor types  */
  values: Scalars['Object'];
};

export type WeatherStationChartHistory = {
  __typename?: 'WeatherStationChartHistory';
  /**  The time series data for the type  */
  data: Array<WeatherStationChartHistoryData>;
  /**  The link address for the sensor  */
  linkAddress: Scalars['Int'];
  /**  The type of weather sensor  */
  type: WeatherSensorType;
};

export type WeatherStationChartHistoryData = {
  __typename?: 'WeatherStationChartHistoryData';
  /**  The timestamp of the data  */
  timestamp: Scalars['DateTime'];
  /**  The value of the data  */
  value: Scalars['Object'];
};

export type WeatherStationChartHistoryInputQuery = {
  /**  The end date time to filter data  */
  end: Scalars['DateTime'];
  /**  The start date time to filter data  */
  start: Scalars['DateTime'];
  /**  The weather sensor type to filter data  */
  types?: InputMaybe<Array<WeatherSensorType>>;
  /**  Identifier of the weather station  */
  weatherStationId: Scalars['ID'];
};

export type WeatherStationConnection = {
  __typename?: 'WeatherStationConnection';
  /**  The edges of the connection object  */
  edges: Array<WeatherStationConnectionEdge>;
  /**  The page info of the connection object  */
  pageInfo: PageInfo;
  /**  The total number of results for the query  */
  totalCount: Scalars['Int'];
};

export type WeatherStationConnectionEdge = {
  __typename?: 'WeatherStationConnectionEdge';
  /**  The position of this object in the page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The weather station object  */
  node: WeatherStation;
};

export type WeatherStationHistory = {
  __typename?: 'WeatherStationHistory';
  /**  The category of the reading  */
  category: WeatherSensorCategory;
  /**  The identifier of the history record  */
  id: Scalars['ID'];
  /**  The link address of the reading, if present  */
  linkAddress?: Maybe<Scalars['Int']>;
  /**  The readings attached to the history entry  */
  readings: Array<Maybe<WeatherStationReading>>;
  /**  The timestamp at which this data was recorded  */
  timestamp: Scalars['DateTime'];
  /**  The identifier of the station  */
  weatherStationId: Scalars['ID'];
};

export type WeatherStationHistoryConnection = {
  __typename?: 'WeatherStationHistoryConnection';
  /**  The edges of the connection object  */
  edges: Array<WeatherStationHistoryConnectionEdge>;
  /**  The page info of the connection object  */
  pageInfo: PageInfo;
  /**  The total number of results for the query  */
  totalCount: Scalars['Int'];
};

export type WeatherStationHistoryConnectionEdge = {
  __typename?: 'WeatherStationHistoryConnectionEdge';
  /**  The position of this object in the page  */
  cursor?: Maybe<Scalars['String']>;
  /**  The weather station object  */
  node: WeatherStationHistory;
};

export type WeatherStationHistoryInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The sensor category to filter  */
  category?: InputMaybe<WeatherSensorCategory>;
  /**  End time filter  */
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  /**  The fields and values to filter  */
  filters?: InputMaybe<Array<FilterInput>>;
  /**  Identifier of the weather station  */
  id: Scalars['ID'];
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The sensor link addresses  */
  linkAddresses?: InputMaybe<Array<Scalars['Int']>>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for.  */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<Scalars['String']>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
  /**  Start time filter  */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type WeatherStationInputQuery = {
  /**  Fetch items after this cursor. Cannot be used with before  */
  after?: InputMaybe<Scalars['String']>;
  /**  Fetch items before this cursor. Cannot be used with after  */
  before?: InputMaybe<Scalars['String']>;
  /**  The fields and values to filter integrations  */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /**  Limit the number of results. We do not allow returning all docs.  */
  limit?: InputMaybe<Scalars['Int']>;
  /**  The fields to search for the search text.  */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /**  Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /**  Which field to sort the results on.  */
  sortField?: InputMaybe<WeatherStationSortField>;
  /**  Which direction to sort the field on.  */
  sortOrder?: InputMaybe<SortOrder>;
};

export type WeatherStationReading = {
  __typename?: 'WeatherStationReading';
  /**  The category that this reading belongs to  */
  category: WeatherSensorCategory;
  /**  Index of the sensor for the reading  */
  linkAddress: Scalars['Int'];
  /**  Raw value of the reading  */
  rawValue?: Maybe<Scalars['Object']>;
  /**  The sensor type of the reading  */
  type: WeatherSensorType;
  /**  The units of the reading  */
  units: WeatherUnits;
  /**  If the sensor reading is valid  */
  valid: Scalars['Boolean'];
  /**  The current value of the reading  */
  value: Scalars['Object'];
};

export enum WeatherStationSortField {
  /**  Communication Status  */
  CommunicationStatus = 'COMMUNICATION_STATUS',
  /**  Data Received  */
  DataReceived = 'DATA_RECEIVED',
  /**  Dew Point Temperature  */
  DewPointTemperature = 'DEW_POINT_TEMPERATURE',
  /**  Humidity  */
  Humidity = 'HUMIDITY',
  /**  Name  */
  Name = 'NAME',
  /**  Pavement Status  */
  PavementStatus = 'PAVEMENT_STATUS',
  /**  Precipitation Rate  */
  PrecipitationRate = 'PRECIPITATION_RATE',
  /**  Precipitation Situation  */
  PrecipitationSituation = 'PRECIPITATION_SITUATION',
  /**  Subsurface Temperature  */
  SubsurfaceTemperature = 'SUBSURFACE_TEMPERATURE',
  /**  Temperature  */
  Temperature = 'TEMPERATURE',
  /**  Visibility  */
  Visibility = 'VISIBILITY',
  /**  Wind Gust Direction  */
  WindGustDirection = 'WIND_GUST_DIRECTION',
  /**  Wind Gust Speed  */
  WindGustSpeed = 'WIND_GUST_SPEED'
}

export type WeatherSys = {
  __typename?: 'WeatherSys';
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  sunrise?: Maybe<Scalars['Int']>;
  sunset?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
};

export enum WeatherUnits {
  /**  Boolean  */
  Boolean = 'BOOLEAN',
  /**  Centimeters  */
  Centimeters = 'CENTIMETERS',
  /**  Centimeters Per Hour  */
  CentimetersPerHour = 'CENTIMETERS_PER_HOUR',
  /**  Degrees  */
  Degrees = 'DEGREES',
  /**  Degrees Celsius  */
  DegreesCelsius = 'DEGREES_CELSIUS',
  /**  Degrees Fahrenheit  */
  DegreesFahrenheit = 'DEGREES_FAHRENHEIT',
  /**  Feet  */
  Feet = 'FEET',
  /**  Inches  */
  Inches = 'INCHES',
  /**  Inches Mercury  */
  InchesMercury = 'INCHES_MERCURY',
  /**  Inches Per Hour  */
  InchesPerHour = 'INCHES_PER_HOUR',
  /**  Kilometers  */
  Kilometers = 'KILOMETERS',
  /**  Kilometers Per Hour  */
  KilometersPerHour = 'KILOMETERS_PER_HOUR',
  /**  Knots  */
  Knots = 'KNOTS',
  /**  Meters  */
  Meters = 'METERS',
  /**  Meters Per Hour  */
  MetersPerHour = 'METERS_PER_HOUR',
  /**  Meters Per Second  */
  MetersPerSecond = 'METERS_PER_SECOND',
  /**  Miles  */
  Miles = 'MILES',
  /**  Miles Per Hour  */
  MilesPerHour = 'MILES_PER_HOUR',
  /**  Millibars  */
  Millibars = 'MILLIBARS',
  /**  Millimeters  */
  Millimeters = 'MILLIMETERS',
  /**  Millimeters Per Hour  */
  MillimetersPerHour = 'MILLIMETERS_PER_HOUR',
  /**  Newtons  */
  Newtons = 'NEWTONS',
  /**  None  */
  None = 'NONE',
  /**  Parts Per Billion By Volume  */
  PartsPerBillionByVolume = 'PARTS_PER_BILLION_BY_VOLUME',
  /**  Parts Per Million By Volume  */
  PartsPerMillionByVolume = 'PARTS_PER_MILLION_BY_VOLUME',
  /**  Percentage  */
  Percentage = 'PERCENTAGE',
  /**  Practical Salinity Unit  */
  PracticalSalinityUnit = 'PRACTICAL_SALINITY_UNIT',
  /**  Siemens Per Meter  */
  SiemensPerMeter = 'SIEMENS_PER_METER',
  /**  Volts  */
  Volts = 'VOLTS',
  /**  Watts Per Square Meter  */
  WattsPerSquareMeter = 'WATTS_PER_SQUARE_METER'
}

export type WeatherWind = {
  __typename?: 'WeatherWind';
  deg?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['Float']>;
};

export type Widget = {
  __typename?: 'Widget';
  id: Scalars['ID'];
  name: Scalars['String'];
  properties: Scalars['JSON'];
  type: WidgetType;
};

export type WidgetInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  properties: Scalars['JSON'];
  type: WidgetType;
};

export type WidgetListFormat = {
  searchFields?: InputMaybe<Array<WidgetSearchField>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<WidgetSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum WidgetSearchField {
  Name = 'NAME'
}

export enum WidgetSortField {
  Id = 'ID',
  Name = 'NAME'
}

export enum WidgetType {
  Iframe = 'IFRAME'
}

export enum WindSituation {
  /**  Calm  */
  Calm = 'CALM',
  /**  Gale  */
  Gale = 'GALE',
  /**  Gusty Winds  */
  GustyWinds = 'GUSTY_WINDS',
  /**  Hurricane Force Winds  */
  HurricaneForceWinds = 'HURRICANE_FORCE_WINDS',
  /**  Light Breeze  */
  LightBreeze = 'LIGHT_BREEZE',
  /**  Moderate Breeze  */
  ModerateBreeze = 'MODERATE_BREEZE',
  /**  Moderate Gale  */
  ModerateGale = 'MODERATE_GALE',
  /**  Other  */
  Other = 'OTHER',
  /**  Strong Winds  */
  StormWinds = 'STORM_WINDS',
  /**  Strong Breeze  */
  StrongBreeze = 'STRONG_BREEZE',
  /**  Strong Gale  */
  StrongGale = 'STRONG_GALE',
  /**  Unknown  */
  Unknown = 'UNKNOWN'
}

export enum WorkFlowActionType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum WorkFlowType {
  Action = 'ACTION',
  Decision = 'DECISION',
  Step = 'STEP'
}

export enum WorkOrderAdditionalView {
  Assignment = 'ASSIGNMENT',
  TimeTracker = 'TIME_TRACKER',
  Transaction = 'TRANSACTION'
}

export type WorkOrderConfigInput = {
  /**  The work order active  */
  active: Scalars['Boolean'];
  /**  The attributes of the work order built from an asset form  */
  attributes?: InputMaybe<Scalars['Object']>;
  /**  The work order configuration description  */
  description?: InputMaybe<Scalars['String']>;
  /**  The identifier of the work order config  */
  id?: InputMaybe<Scalars['ID']>;
  /**  The work order name  */
  name: Scalars['String'];
  /** Work order config setting */
  setting?: InputMaybe<WorkOrderConfigurationSettingInput>;
  /**  The work order types  */
  typeIds: Array<Scalars['String']>;
};

export type WorkOrderConfigInputQuery = {
  /** Fetch items after this cursor. Cannot be used with before */
  after?: InputMaybe<Scalars['String']>;
  /** Fetch items before this cursor. Cannot be used with after */
  before?: InputMaybe<Scalars['String']>;
  /** The fields and values to filter assets */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** Limit the number of results. We do not allow returning all docs. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The fields to search for the search text. */
  searchFields?: InputMaybe<Array<Scalars['String']>>;
  /** Text to search for. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Which field to sort the results on. */
  sortField?: InputMaybe<Scalars['String']>;
  /** Which direction to sort the field on. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type WorkOrderConfiguration = {
  __typename?: 'WorkOrderConfiguration';
  /**  The work order configuration active flag  */
  active?: Maybe<Scalars['Boolean']>;
  /**  The attributes of the work order configuration  */
  attributes?: Maybe<Scalars['Object']>;
  /** Created time */
  createdAt: Scalars['DateTime'];
  /** Created by */
  createdBy: Scalars['String'];
  /** Created by name */
  createdByName: Scalars['String'];
  /**  The work order configuration description  */
  description?: Maybe<Scalars['String']>;
  /**  The identifier of the work order config  */
  id: Scalars['ID'];
  /**  The work order configuration name  */
  name: Scalars['String'];
  /** Work order config setting */
  setting?: Maybe<WorkOrderConfigurationSetting>;
  /**  The work order types id */
  typeIds: Array<Scalars['String']>;
  /**  The work order types  */
  types: Array<AssetType>;
  /** Updated time */
  updatedAt: Scalars['DateTime'];
  /** updated by */
  updatedBy: Scalars['String'];
  /** Updated by name */
  updatedByName: Scalars['String'];
};

export type WorkOrderConfigurationAction = {
  __typename?: 'WorkOrderConfigurationAction';
  attributes?: Maybe<Scalars['JSON']>;
  children: Array<WorkOrderConfigurationChild>;
  id: Scalars['ID'];
  items: Array<WorkOrderConfigurationActionItem>;
};

export type WorkOrderConfigurationActionInput = {
  attributes?: InputMaybe<Scalars['JSON']>;
  children: Array<WorkOrderConfigurationChildInput>;
  id: Scalars['ID'];
  items: Array<WorkOrderConfigurationActionItemInput>;
};

export type WorkOrderConfigurationActionItem = {
  __typename?: 'WorkOrderConfigurationActionItem';
  recipients?: Maybe<Array<WorkOrderRecipient>>;
  template?: Maybe<Scalars['String']>;
  type: WorkFlowActionType;
};

export type WorkOrderConfigurationActionItemInput = {
  recipients?: InputMaybe<Array<WorkOrderRecipientInput>>;
  template?: InputMaybe<Scalars['String']>;
  type: WorkFlowActionType;
};

export type WorkOrderConfigurationChild = {
  __typename?: 'WorkOrderConfigurationChild';
  id: Scalars['ID'];
  workFlowType: WorkFlowType;
};

export type WorkOrderConfigurationChildInput = {
  id: Scalars['ID'];
  workFlowType: WorkFlowType;
};

export type WorkOrderConfigurationConnection = {
  __typename?: 'WorkOrderConfigurationConnection';
  /**  connection edges  */
  edges: Array<WorkOrderConfigurationConnectionEdge>;
  /**  page info  */
  pageInfo: PageInfo;
  /**  total results  */
  totalCount: Scalars['Int'];
};

export type WorkOrderConfigurationConnectionEdge = {
  __typename?: 'WorkOrderConfigurationConnectionEdge';
  /**  connection edge node  */
  cursor?: Maybe<Scalars['String']>;
  /**  node cursor  */
  node: WorkOrderConfiguration;
};

export type WorkOrderConfigurationDecision = {
  __typename?: 'WorkOrderConfigurationDecision';
  attributes?: Maybe<Scalars['JSON']>;
  children?: Maybe<Array<WorkOrderConfigurationChild>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  query?: Maybe<Array<WorkOrderConfigurationDecisionQuery>>;
  skipCondition?: Maybe<Scalars['Boolean']>;
};

export type WorkOrderConfigurationDecisionInput = {
  attributes?: InputMaybe<Scalars['JSON']>;
  children: Array<WorkOrderConfigurationChildInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  query: Array<WorkOrderConfigurationQueryInput>;
  skipCondition?: InputMaybe<Scalars['Boolean']>;
};

export type WorkOrderConfigurationDecisionQuery = {
  __typename?: 'WorkOrderConfigurationDecisionQuery';
  formId: Scalars['ID'];
  query?: Maybe<Scalars['JSON']>;
  rule: Scalars['String'];
};

export type WorkOrderConfigurationQueryInput = {
  formId: Scalars['ID'];
  query?: InputMaybe<Scalars['JSON']>;
  rule: Scalars['String'];
};

export type WorkOrderConfigurationSetting = {
  __typename?: 'WorkOrderConfigurationSetting';
  steps: Array<WorkOrderConfigurationStep>;
};

export type WorkOrderConfigurationSettingInput = {
  steps: Array<WorkOrderConfigurationStepInput>;
};

export type WorkOrderConfigurationStep = {
  __typename?: 'WorkOrderConfigurationStep';
  actions: Array<WorkOrderConfigurationAction>;
  attributes?: Maybe<Scalars['JSON']>;
  children: Array<WorkOrderConfigurationChild>;
  decisions: Array<WorkOrderConfigurationDecision>;
  id: Scalars['ID'];
  name: Scalars['String'];
  orderNo: Scalars['Int'];
  status: Scalars['String'];
  subSteps: Array<WorkOrderConfigurationSubStep>;
};

export type WorkOrderConfigurationStepInput = {
  actions: Array<WorkOrderConfigurationActionInput>;
  attributes?: InputMaybe<Scalars['JSON']>;
  children: Array<WorkOrderConfigurationChildInput>;
  decisions: Array<WorkOrderConfigurationDecisionInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
  orderNo: Scalars['Int'];
  status: Scalars['String'];
  subSteps: Array<WorkOrderConfigurationSubStepInput>;
};

export type WorkOrderConfigurationSubStep = {
  __typename?: 'WorkOrderConfigurationSubStep';
  additionalViews?: Maybe<Array<WorkOrderAdditionalView>>;
  multiFormSections?: Maybe<Array<Maybe<Scalars['String']>>>;
  subStepForm: Scalars['String'];
  subStepId: Scalars['ID'];
  subStepName: Scalars['String'];
  useCrudList?: Maybe<Scalars['Boolean']>;
  useStepper?: Maybe<Scalars['Boolean']>;
  useTimeTracker?: Maybe<Scalars['Boolean']>;
  useTransactions?: Maybe<Scalars['Boolean']>;
};

export type WorkOrderConfigurationSubStepInput = {
  additionalViews?: InputMaybe<Array<WorkOrderAdditionalView>>;
  multiFormSections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subStepForm: Scalars['String'];
  subStepId: Scalars['ID'];
  subStepName: Scalars['String'];
  useCrudList?: InputMaybe<Scalars['Boolean']>;
  useStepper?: InputMaybe<Scalars['Boolean']>;
  useTimeTracker?: InputMaybe<Scalars['Boolean']>;
  useTransactions?: InputMaybe<Scalars['Boolean']>;
};

export enum WorkOrderGroupBy {
  Code = 'CODE',
  Priority = 'PRIORITY',
  Status = 'STATUS'
}

export type WorkOrderRecipient = {
  __typename?: 'WorkOrderRecipient';
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type WorkOrderRecipientInput = {
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type _Entity = Asset | AssetTransaction | AssetWorkOrder | DetectorReportConfiguration | DetectorReportRule | Location | OrganizationKineticUser | WorkOrderConfiguration;

export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String'];
};

export type IComment = {
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['ID'];
  entityId: Scalars['ID'];
  html: Scalars['String'];
  id: Scalars['ID'];
  mentionedUsers?: Maybe<Array<Scalars['ID']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SignalActionSetSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SignalActionSetSelectionListQuery = { __typename?: 'Query', signalActionSets: { __typename?: 'SignalActionSetConnection', totalCount: number, edges: Array<{ __typename?: 'SignalActionSetConnectionEdge', node: { __typename?: 'SignalActionSet', number: number, impact?: SignalActionSetImpactType | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ActivityLogNodeFragmentFragment = { __typename?: 'ActivityLog', id: string, entityId: string, timestamp: any, action: string, description?: string | null, userId?: string | null, userFullName?: string | null, module: KineticModule, object?: any | null, type?: string | null, changes?: Array<{ __typename?: 'ActivityLogChange', path?: string | null, operation?: ActivityLogChangeType | null, oldValue?: string | null, newValue?: string | null }> | null };

export type ExportActivityLogsMutationVariables = Exact<{
  filters: Array<FilterInput> | FilterInput;
  searchText: Scalars['String'];
  searchFields: Array<Scalars['String']> | Scalars['String'];
  config: ExportConfig;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type ExportActivityLogsMutation = { __typename?: 'Mutation', exportActivityLogs: boolean };

export type ActivityLogsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  filters: Array<FilterInput> | FilterInput;
}>;


export type ActivityLogsQuery = { __typename?: 'Query', activityLogs: { __typename?: 'ActivityLogConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ActivityLogEdge', node: (
        { __typename?: 'ActivityLog' }
        & ActivityLogNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ActivityLogAddedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ActivityLogAddedSubscription = { __typename?: 'Subscription', addedActivityLog: (
    { __typename?: 'ActivityLog' }
    & ActivityLogNodeFragmentFragment
  ) };

export type IsActivityLogValidatedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IsActivityLogValidatedQuery = { __typename?: 'Query', validateActivityLog?: boolean | null };

export type ExportAlarmsListMutationVariables = Exact<{
  query?: InputMaybe<AlarmsQuery>;
  fileName: Scalars['String'];
  customDataKeys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ExportAlarmsListMutation = { __typename?: 'Mutation', exportAlarms: boolean };

export type AcknowledgeAlarmsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  comments?: InputMaybe<Scalars['String']>;
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type AcknowledgeAlarmsMutation = { __typename?: 'Mutation', acknowledgeAlarms: Array<{ __typename?: 'Alarm', id: string, acknowledged: boolean, acknowledgedBy?: string | null, acknowledgedAt?: any | null, comments?: string | null }> };

export type ClearAlarmAcknowledgementMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  comments?: InputMaybe<Scalars['String']>;
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type ClearAlarmAcknowledgementMutation = { __typename?: 'Mutation', clearAlarmAcknowledgement: Array<{ __typename?: 'Alarm', id: string, acknowledged: boolean, comments?: string | null }> };

export type UpdateAlarmCommentsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  comments?: InputMaybe<Scalars['String']>;
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAlarmCommentsMutation = { __typename?: 'Mutation', updateAlarmComments: Array<{ __typename?: 'Alarm', id: string, comments?: string | null, updatedAt: any }> };

export type ClearAlarmsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type ClearAlarmsMutation = { __typename?: 'Mutation', clearAlarms: Array<{ __typename?: 'Alarm', id: string, clearedAt?: any | null }> };

export type ClearAllAlarmsMutationVariables = Exact<{
  source: KineticModule;
}>;


export type ClearAllAlarmsMutation = { __typename?: 'Mutation', clearAllAlarms: boolean };

export type ClearAllAlarmsForEntityMutationVariables = Exact<{
  entityType: AlarmEntityType;
  entityId: Scalars['ID'];
}>;


export type ClearAllAlarmsForEntityMutation = { __typename?: 'Mutation', clearAllAlarmsForEntity: boolean };

export type ExportAlarmConfigurationsMutationVariables = Exact<{
  query: AlarmConfigsQuery;
}>;


export type ExportAlarmConfigurationsMutation = { __typename?: 'Mutation', exportAlarmConfigs: boolean };

export type AlarmConfigOptionsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AlarmConfigOptionsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string, displayName: string } }> } };

export type AlarmsListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AlarmsListQuery = { __typename?: 'Query', alarms: { __typename?: 'AlarmConnection', totalCount: number, edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', acknowledged: boolean, acknowledgedAt?: any | null, acknowledgedBy?: string | null, acknowledgedByDisplayName?: string | null, active: boolean, activeAt?: any | null, clearedAt?: any | null, comments?: string | null, recurrenceCount: number, data?: any | null, entityId: string, entityType: AlarmEntityType, id: string, name: string, displayName?: string | null, receivedAt?: any | null, severity: AlarmSeverity, source: KineticModule, updatedAt: any, centerId?: string | null, resolved: boolean, subtypes?: Array<string | null> | null, config: { __typename?: 'AlarmConfig', acknowledgementType: AlarmAcknowledgementType } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveAlarmsListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveAlarmsListSubscription = { __typename?: 'Subscription', alarmUpdated: { __typename?: 'Alarm', acknowledged: boolean, acknowledgedAt?: any | null, acknowledgedBy?: string | null, active: boolean, activeAt?: any | null, clearedAt?: any | null, comments?: string | null, recurrenceCount: number, data?: any | null, entityId: string, entityType: AlarmEntityType, id: string, name: string, displayName?: string | null, receivedAt?: any | null, severity: AlarmSeverity, source: KineticModule, updatedAt: any, resolved: boolean } };

export type CountsAlarmSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type CountsAlarmSummaryQuery = { __typename?: 'Query', INFORMATIONAL: { __typename?: 'AlarmConnection', totalCount: number }, WARNING: { __typename?: 'AlarmConnection', totalCount: number }, CRITICAL: { __typename?: 'AlarmConnection', totalCount: number } };

export type GatesAlarmSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GatesAlarmSummaryQuery = { __typename?: 'Query', INFORMATIONAL: { __typename?: 'AlarmConnection', totalCount: number }, WARNING: { __typename?: 'AlarmConnection', totalCount: number }, CRITICAL: { __typename?: 'AlarmConnection', totalCount: number } };

export type EventsAlarmSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type EventsAlarmSummaryQuery = { __typename?: 'Query', INFORMATIONAL: { __typename?: 'AlarmConnection', totalCount: number }, WARNING: { __typename?: 'AlarmConnection', totalCount: number }, CRITICAL: { __typename?: 'AlarmConnection', totalCount: number } };

export type SignalsAlarmSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SignalsAlarmSummaryQuery = { __typename?: 'Query', INFORMATIONAL: { __typename?: 'AlarmConnection', totalCount: number }, WARNING: { __typename?: 'AlarmConnection', totalCount: number }, CRITICAL: { __typename?: 'AlarmConnection', totalCount: number } };

export type SignsAlarmSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SignsAlarmSummaryQuery = { __typename?: 'Query', INFORMATIONAL: { __typename?: 'AlarmConnection', totalCount: number }, WARNING: { __typename?: 'AlarmConnection', totalCount: number }, CRITICAL: { __typename?: 'AlarmConnection', totalCount: number } };

export type TollingAlarmSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type TollingAlarmSummaryQuery = { __typename?: 'Query', INFORMATIONAL: { __typename?: 'AlarmConnection', totalCount: number }, WARNING: { __typename?: 'AlarmConnection', totalCount: number }, CRITICAL: { __typename?: 'AlarmConnection', totalCount: number } };

export type TravelTimeAlarmSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type TravelTimeAlarmSummaryQuery = { __typename?: 'Query', INFORMATIONAL: { __typename?: 'AlarmConnection', totalCount: number }, WARNING: { __typename?: 'AlarmConnection', totalCount: number }, CRITICAL: { __typename?: 'AlarmConnection', totalCount: number } };

export type VideoAlarmSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type VideoAlarmSummaryQuery = { __typename?: 'Query', INFORMATIONAL: { __typename?: 'AlarmConnection', totalCount: number }, WARNING: { __typename?: 'AlarmConnection', totalCount: number }, CRITICAL: { __typename?: 'AlarmConnection', totalCount: number } };

export type SaveAssetMutationVariables = Exact<{
  input: AssetInput;
}>;


export type SaveAssetMutation = { __typename?: 'Mutation', saveAsset: { __typename?: 'Asset', id: string, description?: string | null } };

export type ExportAssetsMutationVariables = Exact<{
  query: AssetInputQuery;
}>;


export type ExportAssetsMutation = { __typename?: 'Mutation', exportAssets: boolean };

export type ExportAssetTemplateMutationVariables = Exact<{
  types?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  reportPreference?: InputMaybe<ReportPreference>;
}>;


export type ExportAssetTemplateMutation = { __typename?: 'Mutation', exportAssetTemplate: string };

export type ImportAssetsMutationVariables = Exact<{
  fileId: Scalars['String'];
}>;


export type ImportAssetsMutation = { __typename?: 'Mutation', importAssets?: boolean | null };

export type AssetListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AssetListQuery = { __typename?: 'Query', assets: { __typename?: 'AssetConnection', totalCount: number, edges: Array<{ __typename?: 'AssetConnectionEdge', node: { __typename?: 'Asset', id: string, name: string, assetNumber: string, description?: string | null, quantity?: number | null, consumable?: boolean | null, location?: any | null, serialNumber: string, code?: { __typename?: 'AssetCode', id: string, value: string, type: string, name: string } | null, priority?: { __typename?: 'AssetPriority', id: string, value: string, description?: string | null, name: string, color: string } | null, type?: { __typename?: 'AssetType', id: string, name: string, form?: string | null, labels?: Array<string> | null } | null, status?: { __typename?: 'AssetStatus', id: string, name: string, value: string, color: string } | null, parent?: { __typename?: 'Asset', id: string, name: string } | null, associatedLocation?: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string, description?: string | null } } | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EditAssetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EditAssetQuery = { __typename?: 'Query', asset?: { __typename?: 'Asset', id: string, assetNumber: string, name: string, quantity?: number | null, consumable?: boolean | null, owner?: string | null, description?: string | null, serialNumber: string, location?: any | null, attributes: any, minStockLevel?: number | null, sendMinStockLevelEmail?: boolean | null, maxStockLevel?: number | null, sendMaxStockLevelEmail?: boolean | null, burnRateThreshold?: number | null, sendBurnRateThresholdEmail?: boolean | null, leadTimes?: number | null, sendLeadTimesEmail?: boolean | null, type?: { __typename?: 'AssetType', id: string, value: string, name: string } | null, code?: { __typename?: 'AssetCode', id: string, value: string, name: string } | null, priority?: { __typename?: 'AssetPriority', id: string, name: string, value: string, color: string } | null, parent?: { __typename?: 'Asset', id: string, name: string, location?: any | null, associatedLocation?: { __typename?: 'Location', id: string, geometry: any } | null } | null, status?: { __typename?: 'AssetStatus', id: string, name: string, value: string, color: string } | null, warrantyDate?: { __typename?: 'DateRange', startTimestamp: any, endTimestamp: any } | null, associatedLocation?: { __typename?: 'Location', id: string, geometry: any, details: { __typename?: 'LocationDetails', name: string, description?: string | null } } | null, lifecycles: Array<{ __typename?: 'AssetLifeCycle', name: string, startTimestamp?: any | null, endTimestamp?: any | null, isComplete?: boolean | null }>, stats?: { __typename?: 'AssetStatistics', daysInUse: number, daysWithoutIncident: number, totalDowntime: number, daysInUpTime: number } | null, availableUnits: Array<{ __typename?: 'AssetLocationCount', count: number, location: { __typename?: 'Location', id: string, geometry: any, details: { __typename?: 'LocationDetails', name: string } } }>, stockDetail?: { __typename?: 'AssetStockDetail', stockOutRate?: number | null, inStockCount?: number | null } | null } | null };

export type AssetHealthQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AssetHealthQuery = { __typename?: 'Query', assetHealth?: Array<{ __typename?: 'AssetHealthStats', date: string, totalDowntimeMinutes: number } | null> | null };

export type AssetTransactionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  sortField?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AssetTransactionListQuery = { __typename?: 'Query', assetTransactions: { __typename: 'AssetTransactionConnection', totalCount: number, edges: Array<{ __typename: 'AssetTransactionConnectionEdge', node: { __typename: 'AssetTransaction', id?: string | null, transactionNumber: string, workOrderId: string, note?: string | null, type: AssetTransactionType, createdAt: any, createdBy: string, createdByName: string, updatedAt: any, transactedAt?: any | null, executed?: boolean | null, quantityAvailable?: number | null, quantityConsumed?: number | null, quantityRemaining?: number | null, asset: { __typename: 'Asset', id: string, name: string }, fromLocation?: { __typename: 'Location', id: string, locationType: string, color?: string | null, details: { __typename?: 'LocationDetails', name: string } } | null, toLocation?: { __typename: 'Location', id: string, locationType: string, color?: string | null, details: { __typename?: 'LocationDetails', name: string } } | null, fromStatus?: { __typename: 'AssetStatus', id: string, name: string, color: string } | null, toStatus?: { __typename: 'AssetStatus', id: string, name: string, color: string } | null, workOrder: { __typename?: 'AssetWorkOrder', orderNumber: string }, toParent?: { __typename?: 'Asset', id: string, name: string } | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type AssetTransactionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AssetTransactionQuery = { __typename?: 'Query', assetTransaction?: { __typename?: 'AssetTransaction', id?: string | null, workOrderId: string, subStepId: string, type: AssetTransactionType, note?: string | null, asset: { __typename?: 'Asset', id: string }, toLocation?: { __typename?: 'Location', id: string } | null, toStatus?: { __typename?: 'AssetStatus', id: string } | null } | null };

export type AssetOptionsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AssetOptionsQuery = { __typename?: 'Query', assets: { __typename: 'AssetConnection', totalCount: number, edges: Array<{ __typename: 'AssetConnectionEdge', node: { __typename: 'Asset', id: string, name: string, assetNumber: string, consumable?: boolean | null, code?: { __typename: 'AssetCode', id: string, value: string, name: string } | null, type?: { __typename: 'AssetType', id: string, name: string, form?: string | null, labels?: Array<string> | null } | null, status?: { __typename?: 'AssetStatus', id: string, name: string, value: string, color: string } | null, parent?: { __typename: 'Asset', id: string, name: string, code?: { __typename?: 'AssetCode', id: string, name: string } | null, type?: { __typename?: 'AssetType', id: string, name: string } | null, associatedLocation?: { __typename: 'Location', id: string, details: { __typename: 'LocationDetails', name: string } } | null } | null, associatedLocation?: { __typename: 'Location', id: string, details: { __typename: 'LocationDetails', name: string } } | null } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SaveAssetWorkOrderMutationVariables = Exact<{
  input: AssetWorkOrderInput;
}>;


export type SaveAssetWorkOrderMutation = { __typename?: 'Mutation', saveAssetWorkOrder: { __typename?: 'AssetWorkOrder', id: string } };

export type SaveAssetWorkOrderLinkMutationVariables = Exact<{
  input: AssetWorkOrderLinkInput;
}>;


export type SaveAssetWorkOrderLinkMutation = { __typename?: 'Mutation', saveAssetWorkOrderLink: { __typename?: 'AssetWorkOrderLink', id: string } };

export type DeleteAssetWorkOrderLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAssetWorkOrderLinkMutation = { __typename?: 'Mutation', deleteAssetWorkOrderLink: boolean };

export type SaveAssetWorkOrderSubStepMutationVariables = Exact<{
  input: AssetWorkOrderSubStepInput;
}>;


export type SaveAssetWorkOrderSubStepMutation = { __typename?: 'Mutation', saveAssetWorkOrderSubStep: { __typename?: 'AssetWorkOrderSubStep', id: string } };

export type SaveAssetWorkOrderTransactionMutationVariables = Exact<{
  input: AssetTransactionInput;
}>;


export type SaveAssetWorkOrderTransactionMutation = { __typename?: 'Mutation', saveAssetWorkOrderTransaction: { __typename?: 'AssetTransaction', id?: string | null } };

export type DeleteAssetWorkOrderTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAssetWorkOrderTransactionMutation = { __typename?: 'Mutation', deleteAssetWorkOrderTransaction?: boolean | null };

export type RevertAssetWorkOrderTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RevertAssetWorkOrderTransactionMutation = { __typename?: 'Mutation', revertAssetWorkOrderTransaction: { __typename?: 'AssetTransaction', id?: string | null } };

export type ExecuteAssetWorkOrderTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExecuteAssetWorkOrderTransactionMutation = { __typename?: 'Mutation', executeAssetWorkOrderTransaction: { __typename?: 'AssetTransaction', id?: string | null } };

export type DeclineAssetWorkOrderStepMutationVariables = Exact<{
  input?: InputMaybe<AssetWorkOrderDeclineInput>;
}>;


export type DeclineAssetWorkOrderStepMutation = { __typename?: 'Mutation', declineAssetWorkOrderStep?: boolean | null };

export type CloseAssetWorkOrderMutationVariables = Exact<{
  input: AssetWorkOrderCloseInput;
}>;


export type CloseAssetWorkOrderMutation = { __typename?: 'Mutation', closeAssetWorkOrder?: boolean | null };

export type SaveAssetWorkOrderFlagMutationVariables = Exact<{
  input: AssetWorkOrderFlagInput;
}>;


export type SaveAssetWorkOrderFlagMutation = { __typename?: 'Mutation', saveAssetWorkOrderFlag: { __typename?: 'AssetWorkOrderSubStep', id: string } };

export type DeleteAssetWorkOrderFlagMutationVariables = Exact<{
  input: AssetWorkOrderFlagInput;
}>;


export type DeleteAssetWorkOrderFlagMutation = { __typename?: 'Mutation', deleteAssetWorkOrderFlag: boolean };

export type SaveAssetWorkOrderTrackingMutationVariables = Exact<{
  input: AssetWorkOrderTrackingInput;
}>;


export type SaveAssetWorkOrderTrackingMutation = { __typename?: 'Mutation', saveAssetWorkOrderTracking: { __typename?: 'AssetWorkOrderTracking', id: string } };

export type DeleteAssetWorkOrderTrackingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAssetWorkOrderTrackingMutation = { __typename?: 'Mutation', deleteAssetWorkOrderTracking?: boolean | null };

export type SaveAssetWorkOrderStepAssignmentsMutationVariables = Exact<{
  inputs: Array<AssetWorkOrderAssignmentsInput> | AssetWorkOrderAssignmentsInput;
}>;


export type SaveAssetWorkOrderStepAssignmentsMutation = { __typename?: 'Mutation', saveAssetWorkOrderStepAssignments?: boolean | null };

export type SaveAssetWorkOrderCommentMutationVariables = Exact<{
  input: AssetWorkOrderCommentInput;
}>;


export type SaveAssetWorkOrderCommentMutation = { __typename?: 'Mutation', saveAssetWorkOrderComment: { __typename?: 'AssetWorkOrderComment', id: string } };

export type DeleteAssetWorkOrderCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
}>;


export type DeleteAssetWorkOrderCommentMutation = { __typename?: 'Mutation', deleteAssetWorkOrderComment?: boolean | null };

export type ExportAssetWorkOrdersMutationVariables = Exact<{
  query: AssetWorkOrderInputQuery;
}>;


export type ExportAssetWorkOrdersMutation = { __typename?: 'Mutation', exportAssetWorkOrders: boolean };

export type SaveEntityWorkOrderMutationVariables = Exact<{
  input: EntityWorkOrderInput;
}>;


export type SaveEntityWorkOrderMutation = { __typename?: 'Mutation', saveEntityWorkOrder: { __typename?: 'EntityWorkOrder', id: string, workOrderNo: string, link: string, attributes: any } };

export type AssetWorkOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AssetWorkOrderQuery = { __typename?: 'Query', assetWorkOrder?: { __typename?: 'AssetWorkOrder', name?: string | null, id: string, orderNumber: string, labels?: Array<string> | null, requesterId: string, createdAt: any, updatedAt: any, assigneeIds?: Array<string> | null, parent?: { __typename?: 'AssetWorkOrder', id: string } | null, config: { __typename: 'WorkOrderConfiguration', id: string, name: string }, assets: Array<{ __typename: 'Asset', id: string, name: string, code?: { __typename?: 'AssetCode', id: string, name: string, value: string } | null, status?: { __typename?: 'AssetStatus', id: string, color: string, name: string, value: string } | null, priority?: { __typename?: 'AssetPriority', id: string, value: string, description?: string | null, name: string, color: string } | null }>, assetCodes: Array<{ __typename?: 'AssetCode', id: string, name: string, value: string }>, status?: { __typename?: 'AssetWorkOrderStatus', id: string, name: string, color: string } | null, priority?: { __typename: 'AssetPriority', id: string, name: string, color: string } | null, location?: { __typename: 'Location', id: string, locationType: string, geometry: any, details: { __typename?: 'LocationDetails', name: string } } | null } | null };

export type AssetWorkOrdersListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AssetWorkOrdersListQuery = { __typename?: 'Query', assetWorkOrders: { __typename?: 'AssetWorkOrderConnection', totalCount: number, edges: Array<{ __typename?: 'AssetWorkOrderConnectionEdge', node: { __typename?: 'AssetWorkOrder', id: string, name?: string | null, orderNumber: string, labels?: Array<string> | null, requesterId: string, createdAt: any, updatedAt: any, assigneeIds?: Array<string> | null, config: { __typename?: 'WorkOrderConfiguration', id: string, name: string }, assets: Array<{ __typename?: 'Asset', id: string }>, status?: { __typename?: 'AssetWorkOrderStatus', id: string, name: string, color: string } | null, priority?: { __typename?: 'AssetPriority', id: string, name: string, color: string } | null, location?: { __typename?: 'Location', id: string, geometry: any, details: { __typename?: 'LocationDetails', name: string } } | null, assetCodes: Array<{ __typename?: 'AssetCode', id: string, name: string, value: string }>, parent?: { __typename?: 'AssetWorkOrder', id: string, orderNumber: string } | null, flag?: { __typename?: 'AssetWorkOrderFlag', enabled: boolean, reason?: string | null, reasonHtml?: string | null, mentionedUsers?: Array<{ __typename?: 'WorkOrderRecipient', id: string, name: string, email: string } | null> | null } | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type AssetWorkOrderIdsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AssetWorkOrderIdsQuery = { __typename?: 'Query', assetWorkOrders: { __typename?: 'AssetWorkOrderConnection', edges: Array<{ __typename?: 'AssetWorkOrderConnectionEdge', node: { __typename?: 'AssetWorkOrder', id: string } }> } };

export type AssetWorkOrderLayerItemListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AssetWorkOrderLayerItemListQuery = { __typename?: 'Query', assetWorkOrders: { __typename?: 'AssetWorkOrderConnection', edges: Array<{ __typename?: 'AssetWorkOrderConnectionEdge', node: { __typename?: 'AssetWorkOrder', id: string, orderNumber: string, labels?: Array<string> | null, status?: { __typename?: 'AssetWorkOrderStatus', id: string, name: string, color: string } | null, location?: { __typename?: 'Location', id: string, geometry: any, details: { __typename?: 'LocationDetails', name: string } } | null } }> } };

export type AssetWorkOrderLinksListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AssetWorkOrderLinksListQuery = { __typename?: 'Query', assetWorkOrderLinks: { __typename?: 'AssetWorkOrderLinkConnection', totalCount: number, edges: Array<{ __typename?: 'AssetWorkOrderLinkConnectionEdge', node: { __typename?: 'AssetWorkOrderLink', id: string, linkType: string, linkId: string, workOrderId: string, comment?: string | null, linkedWorkOrder: { __typename?: 'AssetWorkOrder', id: string, orderNumber: string, labels?: Array<string> | null, assigneeIds?: Array<string> | null, requesterId: string, config: { __typename?: 'WorkOrderConfiguration', id: string, name: string }, assetCodes: Array<{ __typename?: 'AssetCode', id: string, name: string, value: string }>, status?: { __typename?: 'AssetWorkOrderStatus', id: string, name: string, color: string } | null, priority?: { __typename?: 'AssetPriority', id: string, name: string, color: string } | null } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type AssetWorkOrderStepsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AssetWorkOrderStepsQuery = { __typename?: 'Query', assetWorkOrderSteps: Array<{ __typename?: 'AssetWorkOrderStep', id: string, name: string, workOrderId: string, stepId: string, status: AssetWorkOrderStepStatus, subSteps: Array<{ __typename?: 'AssetWorkOrderSubStep', id: string, name: string, workOrderId: string, stepId: string, subStepId: string, formId?: string | null, data?: any | null, assignments: Array<string>, defaultAssignees?: Array<string> | null, status: AssetWorkOrderStepStatus, additionalViews?: Array<WorkOrderAdditionalView> | null, useStepper?: boolean | null, useCrudList?: boolean | null, multiFormSections?: Array<string | null> | null, flag?: { __typename?: 'AssetWorkOrderFlag', enabled: boolean, reason?: string | null, reasonHtml?: string | null } | null }> }> };

export type AssetWorkOrderTrackingListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AssetWorkOrderTrackingListQuery = { __typename?: 'Query', assetWorkOrderTrackings: { __typename?: 'AssetWorkOrderTrackingConnection', totalCount: number, edges: Array<{ __typename?: 'AssetWorkOrderTrackingConnectionEdge', node: { __typename?: 'AssetWorkOrderTracking', id: string, workOrderId: string, subStepId?: string | null, userId: string, fromTimestamp?: any | null, toTimestamp?: any | null, totalDuration?: number | null, minutes?: string | null, hours?: string | null, note?: string | null, createdByName: string, subStep?: { __typename?: 'AssetWorkOrderSubStep', id: string, name: string } | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EditAssetWorkOrderTrackingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EditAssetWorkOrderTrackingQuery = { __typename?: 'Query', assetWorkOrderTracking?: { __typename?: 'AssetWorkOrderTracking', id: string, workOrderId: string, subStepId?: string | null, fromTimestamp?: any | null, toTimestamp?: any | null, totalDuration?: number | null, minutes?: string | null, hours?: string | null, note?: string | null, userId: string } | null };

export type AssetWorkOrderCommentListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type AssetWorkOrderCommentListQuery = { __typename?: 'Query', assetWorkOrderComments: { __typename?: 'AssetWorkOrderCommentConnection', totalCount: number, edges: Array<{ __typename?: 'AssetWorkOrderCommentConnectionEdge', node: { __typename?: 'AssetWorkOrderComment', id: string, workOrderId: string, subStepId?: string | null, comment: string, commentHtml?: string | null, stepId?: string | null, createdByName: string, createdBy: string, createdAt: any, updatedAt: any, mentionedUsers?: Array<{ __typename?: 'WorkOrderRecipient', id: string, name: string, email: string } | null> | null, step?: { __typename?: 'AssetWorkOrderStep', name: string } | null, subStep?: { __typename?: 'AssetWorkOrderSubStep', name: string } | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type AssetWorkOderCountsQueryVariables = Exact<{
  groupBy?: InputMaybe<WorkOrderGroupBy>;
}>;


export type AssetWorkOderCountsQuery = { __typename?: 'Query', assetWorkOderCounts?: Array<{ __typename?: 'AssetCounts', id: string, name: string, color?: string | null, count?: number | null } | null> | null };

export type EntityWorkOrdersListQueryVariables = Exact<{
  entityId: Scalars['String'];
  workOrderSystemId: Scalars['String'];
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type EntityWorkOrdersListQuery = { __typename?: 'Query', entityWorkOrders: { __typename?: 'EntityWorkOrderConnection', totalCount: number, edges: Array<{ __typename?: 'EntityWorkOrderConnectionEdge', node: { __typename?: 'EntityWorkOrder', id: string, workOrderNo: string, link: string, attributes: any } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SaveWorkOrderConfigurationMutationVariables = Exact<{
  input: WorkOrderConfigInput;
}>;


export type SaveWorkOrderConfigurationMutation = { __typename?: 'Mutation', saveWorkOrderConfiguration: { __typename?: 'WorkOrderConfiguration', id: string } };

export type DeleteWorkOrderConfigurationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteWorkOrderConfigurationMutation = { __typename?: 'Mutation', deleteWorkOrderConfiguration: boolean };

export type CloneWorkOrderConfigurationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CloneWorkOrderConfigurationMutation = { __typename?: 'Mutation', cloneWorkOrderConfiguration: { __typename?: 'WorkOrderConfiguration', id: string, name: string, description?: string | null, active?: boolean | null, typeIds: Array<string>, attributes?: any | null, setting?: { __typename?: 'WorkOrderConfigurationSetting', steps: Array<{ __typename?: 'WorkOrderConfigurationStep', id: string, orderNo: number, name: string, status: string, attributes?: any | null, subSteps: Array<{ __typename?: 'WorkOrderConfigurationSubStep', subStepId: string, subStepName: string, subStepForm: string, additionalViews?: Array<WorkOrderAdditionalView> | null, useStepper?: boolean | null, useCrudList?: boolean | null }>, decisions: Array<{ __typename?: 'WorkOrderConfigurationDecision', id: string, skipCondition?: boolean | null, attributes?: any | null, query?: Array<{ __typename?: 'WorkOrderConfigurationDecisionQuery', formId: string, query?: any | null, rule: string }> | null, children?: Array<{ __typename?: 'WorkOrderConfigurationChild', id: string, workFlowType: WorkFlowType }> | null }>, actions: Array<{ __typename?: 'WorkOrderConfigurationAction', id: string, attributes?: any | null, items: Array<{ __typename?: 'WorkOrderConfigurationActionItem', template?: string | null, type: WorkFlowActionType, recipients?: Array<{ __typename?: 'WorkOrderRecipient', id: string, name: string, email: string }> | null }>, children: Array<{ __typename?: 'WorkOrderConfigurationChild', id: string, workFlowType: WorkFlowType }> }>, children: Array<{ __typename?: 'WorkOrderConfigurationChild', id: string, workFlowType: WorkFlowType }> }> } | null } };

export type WorkOrderConfigurationListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type WorkOrderConfigurationListQuery = { __typename?: 'Query', workOrderConfigurations: { __typename?: 'WorkOrderConfigurationConnection', totalCount: number, edges: Array<{ __typename?: 'WorkOrderConfigurationConnectionEdge', node: { __typename?: 'WorkOrderConfiguration', id: string, name: string, description?: string | null, active?: boolean | null, typeIds: Array<string>, attributes?: any | null, createdBy: string, createdAt: any, createdByName: string, updatedAt: any, updatedBy: string, updatedByName: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type WorkOrderConfigurationEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WorkOrderConfigurationEditQuery = { __typename?: 'Query', workOrderConfiguration?: { __typename?: 'WorkOrderConfiguration', id: string, name: string, description?: string | null, active?: boolean | null, typeIds: Array<string>, attributes?: any | null, setting?: { __typename?: 'WorkOrderConfigurationSetting', steps: Array<{ __typename?: 'WorkOrderConfigurationStep', id: string, orderNo: number, name: string, status: string, attributes?: any | null, subSteps: Array<{ __typename?: 'WorkOrderConfigurationSubStep', subStepId: string, subStepName: string, subStepForm: string, additionalViews?: Array<WorkOrderAdditionalView> | null, useStepper?: boolean | null, useCrudList?: boolean | null, multiFormSections?: Array<string | null> | null }>, decisions: Array<{ __typename?: 'WorkOrderConfigurationDecision', id: string, skipCondition?: boolean | null, attributes?: any | null, query?: Array<{ __typename?: 'WorkOrderConfigurationDecisionQuery', formId: string, query?: any | null, rule: string }> | null, children?: Array<{ __typename?: 'WorkOrderConfigurationChild', id: string, workFlowType: WorkFlowType }> | null }>, actions: Array<{ __typename?: 'WorkOrderConfigurationAction', id: string, attributes?: any | null, items: Array<{ __typename?: 'WorkOrderConfigurationActionItem', template?: string | null, type: WorkFlowActionType, recipients?: Array<{ __typename?: 'WorkOrderRecipient', id: string, name: string, email: string }> | null }>, children: Array<{ __typename?: 'WorkOrderConfigurationChild', id: string, workFlowType: WorkFlowType }> }>, children: Array<{ __typename?: 'WorkOrderConfigurationChild', id: string, workFlowType: WorkFlowType }> }> } | null } | null };

export type WorkOrderConfigurationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WorkOrderConfigurationQuery = { __typename?: 'Query', workOrderConfiguration?: { __typename?: 'WorkOrderConfiguration', id: string, name: string, description?: string | null, active?: boolean | null, typeIds: Array<string>, attributes?: any | null, createdBy: string, createdAt: any, createdByName: string, updatedAt: any, updatedBy: string, updatedByName: string, setting?: { __typename?: 'WorkOrderConfigurationSetting', steps: Array<{ __typename?: 'WorkOrderConfigurationStep', id: string, orderNo: number, name: string, status: string, attributes?: any | null, subSteps: Array<{ __typename?: 'WorkOrderConfigurationSubStep', subStepId: string, subStepName: string, subStepForm: string, additionalViews?: Array<WorkOrderAdditionalView> | null, useStepper?: boolean | null, useCrudList?: boolean | null, multiFormSections?: Array<string | null> | null }>, decisions: Array<{ __typename?: 'WorkOrderConfigurationDecision', id: string, skipCondition?: boolean | null, attributes?: any | null, query?: Array<{ __typename?: 'WorkOrderConfigurationDecisionQuery', formId: string, query?: any | null, rule: string }> | null, children?: Array<{ __typename?: 'WorkOrderConfigurationChild', id: string, workFlowType: WorkFlowType }> | null }>, actions: Array<{ __typename?: 'WorkOrderConfigurationAction', id: string, attributes?: any | null, items: Array<{ __typename?: 'WorkOrderConfigurationActionItem', template?: string | null, type: WorkFlowActionType, recipients?: Array<{ __typename?: 'WorkOrderRecipient', name: string, email: string }> | null }>, children: Array<{ __typename?: 'WorkOrderConfigurationChild', id: string, workFlowType: WorkFlowType }> }>, children: Array<{ __typename?: 'WorkOrderConfigurationChild', id: string, workFlowType: WorkFlowType }> }> } | null } | null };

export type WorkOrderConfigurationOptionsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type WorkOrderConfigurationOptionsQuery = { __typename?: 'Query', workOrderConfigurations: { __typename?: 'WorkOrderConfigurationConnection', totalCount: number, edges: Array<{ __typename?: 'WorkOrderConfigurationConnectionEdge', node: { __typename?: 'WorkOrderConfiguration', id: string, name: string, active?: boolean | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type CameraNodeFragment = { __typename?: 'Camera', id: string, name: string, communicationStatus?: CommunicationState | null, poweredOn?: boolean | null, road?: string | null, direction?: string | null, description?: string | null, location?: any | null, locationDescription?: string | null, autoFocusEnabled?: boolean | null, autoIrisEnabled?: boolean | null, userNotes?: string | null, referencePoint?: string | null, publicFeedEnabled?: boolean | null, privateStreamRecordingInProgress?: boolean | null, capabilitiesState: any, communicationParameters?: any | null, presets?: Array<{ __typename?: 'Preset', id: string, name: string, presetIndex: number, isHomePreset?: boolean | null, isSystem: boolean, isSelected?: boolean | null } | null> | null, ptzLock: { __typename?: 'PTZLockInfo', isLocked?: boolean | null, requireExplicitCameraControlLocking?: boolean | null, userId?: string | null, fullName?: string | null, lockStartedAt?: any | null, lockEndsAt?: any | null, lastUsedTime?: any | null }, streams?: Array<{ __typename?: 'VideoStream', name: string, url: string, accessType?: VideoStreamAccessType | null, application?: string | null, streamName?: string | null, streamType: string, streamManager?: string | null, recordingServer?: string | null } | null> | null, capabilities?: Array<{ __typename?: 'CameraCapabilityDto', capability: CameraCapability, options?: Array<string | null> | null }> | null };

export type PanTiltVideoCameraMutationVariables = Exact<{
  cameraPanTiltInput: CameraPanTiltInput;
}>;


export type PanTiltVideoCameraMutation = { __typename?: 'Mutation', panTiltCamera?: { __typename?: 'JobRequest', success: boolean } | null };

export type VideoCameraZoomMutationVariables = Exact<{
  cameraZoomInput: CameraZoomInput;
}>;


export type VideoCameraZoomMutation = { __typename?: 'Mutation', zoomCamera?: { __typename?: 'JobRequest', success: boolean } | null };

export type VideoCameraExplicitLockMutationVariables = Exact<{
  cameraId: Scalars['ID'];
}>;


export type VideoCameraExplicitLockMutation = { __typename?: 'Mutation', cameraExplicitLock?: boolean | null };

export type UnlockPtzVideoCameraMutationVariables = Exact<{
  cameraId: Scalars['ID'];
}>;


export type UnlockPtzVideoCameraMutation = { __typename?: 'Mutation', unlockPTZCamera?: boolean | null };

export type VideoCameraGoToPresetMutationVariables = Exact<{
  cameraId: Scalars['String'];
  presetId: Scalars['String'];
}>;


export type VideoCameraGoToPresetMutation = { __typename?: 'Mutation', gotoPreset?: { __typename?: 'JobRequest', success: boolean, requestId?: string | null, id: string, failure?: string | null } | null };

export type SaveVideoCameraPresetMutationVariables = Exact<{
  input: PresetInput;
}>;


export type SaveVideoCameraPresetMutation = { __typename?: 'Mutation', savePreset?: { __typename?: 'Preset', id: string, presetIndex: number, name: string } | null };

export type UseVideoCameraCapabilityMutationVariables = Exact<{
  cameraId: Scalars['ID'];
  capability: CameraCapability;
  option: Scalars['String'];
}>;


export type UseVideoCameraCapabilityMutation = { __typename?: 'Mutation', useCameraCapability?: { __typename?: 'JobRequest', success: boolean } | null };

export type EnableVideoCameraAutoFocusMutationVariables = Exact<{
  cameraAutoFocusInput: CameraAutoFocusInput;
}>;


export type EnableVideoCameraAutoFocusMutation = { __typename?: 'Mutation', enableCameraAutoFocus?: (
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  ) | null };

export type EnableVideoCameraAutoIrisMutationVariables = Exact<{
  cameraAutoIrisInput: CameraAutoIrisInput;
}>;


export type EnableVideoCameraAutoIrisMutation = { __typename?: 'Mutation', enableCameraAutoIris?: (
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  ) | null };

export type FocusVideoCameraMutationVariables = Exact<{
  cameraFocusInput: CameraFocusInput;
}>;


export type FocusVideoCameraMutation = { __typename?: 'Mutation', focusCamera?: (
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  ) | null };

export type IrisVideoCameraMutationVariables = Exact<{
  cameraIrisInput: CameraIrisInput;
}>;


export type IrisVideoCameraMutation = { __typename?: 'Mutation', irisCamera?: (
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  ) | null };

export type VideoCameraRecordingMutationVariables = Exact<{
  cameraId: Scalars['String'];
  streamRecorderId: Scalars['String'];
  streamAccessType: VideoStreamAccessType;
  recordingType?: InputMaybe<RecordingType>;
  start: Scalars['Boolean'];
  recordingName: Scalars['String'];
}>;


export type VideoCameraRecordingMutation = { __typename?: 'Mutation', cameraRecording?: (
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  ) | null };

export type ChangeVideoTourStateMutationVariables = Exact<{
  tourId: Scalars['ID'];
  paused?: InputMaybe<Scalars['Boolean']>;
}>;


export type ChangeVideoTourStateMutation = { __typename?: 'Mutation', changeTourState: boolean };

export type VideoCameraPublicFeedMutationVariables = Exact<{
  cameraPublicFeedInput: CameraPublicFeedInput;
}>;


export type VideoCameraPublicFeedMutation = { __typename?: 'Mutation', cameraPublicFeed?: { __typename?: 'JobRequest', success: boolean } | null };

export type CamerasQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type CamerasQuery = { __typename?: 'Query', cameras: { __typename?: 'CameraConnection', totalCount: number, edges: Array<{ __typename?: 'CameraConnectionEdge', node: (
        { __typename?: 'Camera' }
        & CameraNodeFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetCameraSnapshotQueryVariables = Exact<{
  cameraId: Scalars['ID'];
}>;


export type GetCameraSnapshotQuery = { __typename?: 'Query', getCameraSnapshot?: string | null };

export type CameraPresetsQueryVariables = Exact<{
  cameraId: Scalars['ID'];
}>;


export type CameraPresetsQuery = { __typename?: 'Query', camera?: { __typename?: 'Camera', id: string, presets?: Array<{ __typename?: 'Preset', id: string, name: string } | null> | null } | null };

export type CommunicationLogFragment = { __typename?: 'CommunicationLog', id: string, reason?: string | null, eventIds: Array<string>, detailsType?: string | null, impactedGroup?: string | null, reported?: any | null, discussion?: string | null, attributes: any, contact?: { __typename?: 'CommunicationLogContact', id?: string | null, firstName: string, lastName: string, phoneNumber: string, email: string } | null, events?: Array<{ __typename?: 'Event', id: string, name: string } | null> | null };

export type SaveCommunicationLogMutationVariables = Exact<{
  input: CommunicationLogInput;
}>;


export type SaveCommunicationLogMutation = { __typename?: 'Mutation', saveCommunicationLog: (
    { __typename?: 'CommunicationLog' }
    & CommunicationLogFragment
  ) };

export type CommunicationLogListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CommunicationLogListQuery = { __typename?: 'Query', communicationLogs: { __typename?: 'CommunicationLogConnection', totalCount: number, edges: Array<{ __typename?: 'CommunicationLogEdge', node: (
        { __typename?: 'CommunicationLog' }
        & CommunicationLogFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type CommunicationLogUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CommunicationLogUpdatedSubscription = { __typename?: 'Subscription', communicationLogUpdated?: { __typename?: 'CommunicationLogStreamObject', streamObjectOperation?: StreamObjectOperation | null, dto?: (
      { __typename?: 'CommunicationLog' }
      & CommunicationLogFragment
    ) | null } | null };

export type ConnectedVehiclesAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectedVehiclesAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string, displayName: string } }> } };

export type RsuMainStatusCategoryFragmentFragment = { __typename?: 'RsuMainStatusCategory', other: number, okay: number, warning: number, critical: number, unknown: number, commFailed: number, commDisabled: number };

export type RsuModeStatusCategoryFragmentFragment = { __typename?: 'RsuModeStatusCategory', other: number, standby: number, operate: number, fault: number, unknown: number, commFailed: number, commDisabled: number };

export type RsuModeStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type RsuModeStatusQuery = { __typename?: 'Query', connectedVehicles: { __typename?: 'ConnectedVehicleConnection', edges: Array<{ __typename?: 'ConnectedVehicleConnectionEdge', node: { __typename?: 'ConnectedVehicle', id: string, name: string, communicationState: CommunicationState, location: any, device: { __typename?: 'ConnectedVehicleDevice', rsuModeStatus: RsuModeStatus } } }> } };

export type RsuModeStatusUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RsuModeStatusUpdatedSubscription = { __typename?: 'Subscription', connectedVehicleUpdated: { __typename?: 'ConnectedVehicle', id: string, name: string, communicationState: CommunicationState, device: { __typename?: 'ConnectedVehicleDevice', rsuModeStatus: RsuModeStatus } } };

export type RsuMainStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type RsuMainStatusQuery = { __typename?: 'Query', connectedVehicles: { __typename?: 'ConnectedVehicleConnection', edges: Array<{ __typename?: 'ConnectedVehicleConnectionEdge', node: { __typename?: 'ConnectedVehicle', id: string, name: string, communicationState: CommunicationState, location: any, device: { __typename?: 'ConnectedVehicleDevice', rsuMainStatus: RsuMainStatus } } }> } };

export type RsuMainStatusUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RsuMainStatusUpdatedSubscription = { __typename?: 'Subscription', connectedVehicleUpdated: { __typename?: 'ConnectedVehicle', id: string, name: string, communicationState: CommunicationState, device: { __typename?: 'ConnectedVehicleDevice', rsuMainStatus: RsuMainStatus } } };

export type ConnectedVehicleLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectedVehicleLocationsQuery = { __typename?: 'Query', connectedVehicles: { __typename?: 'ConnectedVehicleConnection', edges: Array<{ __typename?: 'ConnectedVehicleConnectionEdge', node: { __typename?: 'ConnectedVehicle', id: string, location: any } }> } };

export type ConnectedVehicleTooltipQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConnectedVehicleTooltipQuery = { __typename?: 'Query', connectedVehicle: { __typename?: 'ConnectedVehicle', id: string, name: string, description?: string | null, communicationState: CommunicationState, device: { __typename?: 'ConnectedVehicleDevice', rsuMainStatus: RsuMainStatus, rsuModeStatus: RsuModeStatus, rsuRadioStatus: RsuRadioStatus } } };

export type ConnectedVehicleMapLegendCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectedVehicleMapLegendCountQuery = { __typename?: 'Query', connectedVehicleStatusCategories: { __typename?: 'ConnectedVehicleCategory', rsuMainStatusCategories: (
      { __typename?: 'RsuMainStatusCategory' }
      & RsuMainStatusCategoryFragmentFragment
    ), rsuModeStatusCategories: (
      { __typename?: 'RsuModeStatusCategory' }
      & RsuModeStatusCategoryFragmentFragment
    ) } };

export type ConnectedVehicleMapLegendCountUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ConnectedVehicleMapLegendCountUpdatedSubscription = { __typename?: 'Subscription', connectedVehicleStatusCategoriesUpdated: { __typename?: 'ConnectedVehicleCategory', rsuMainStatusCategories: (
      { __typename?: 'RsuMainStatusCategory' }
      & RsuMainStatusCategoryFragmentFragment
    ), rsuModeStatusCategories: (
      { __typename?: 'RsuModeStatusCategory' }
      & RsuModeStatusCategoryFragmentFragment
    ) } };

export type ConnectedVehiclStatusBarQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectedVehiclStatusBarQuery = { __typename?: 'Query', connectedVehicleStatusCategories: { __typename?: 'ConnectedVehicleCategory', rsuMainStatusCategories: (
      { __typename?: 'RsuMainStatusCategory' }
      & RsuMainStatusCategoryFragmentFragment
    ) } };

export type ConnectedVehicleStatusBarUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ConnectedVehicleStatusBarUpdatedSubscription = { __typename?: 'Subscription', connectedVehicleStatusCategoriesUpdated: { __typename?: 'ConnectedVehicleCategory', rsuMainStatusCategories: (
      { __typename?: 'RsuMainStatusCategory' }
      & RsuMainStatusCategoryFragmentFragment
    ) } };

export type ConnectedVehiclesMapSearchQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ConnectedVehiclesMapSearchQuery = { __typename?: 'Query', connectedVehicles: { __typename?: 'ConnectedVehicleConnection', edges: Array<{ __typename?: 'ConnectedVehicleConnectionEdge', node: { __typename: 'ConnectedVehicle', id: string, name: string, location: any } }> } };

export type ConnectedVehicleFragmentFragment = { __typename?: 'ConnectedVehicle', id: string, name: string, description?: string | null, communicationState: CommunicationState, location: any, device: { __typename?: 'ConnectedVehicleDevice', deviceApi: string, moduleVersion?: string | null, rsuMainStatus: RsuMainStatus, rsuModeStatus: RsuModeStatus, rsuRadioStatus: RsuRadioStatus } };

export type ConnectedVehicleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConnectedVehicleQuery = { __typename?: 'Query', connectedVehicle: { __typename?: 'ConnectedVehicle', id: string, name: string, description?: string | null, communicationState: CommunicationState, device: { __typename?: 'ConnectedVehicleDevice', deviceApi: string, moduleVersion?: string | null } } };

export type ConnectedVehicleNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConnectedVehicleNameQuery = { __typename?: 'Query', connectedVehicle: { __typename?: 'ConnectedVehicle', id: string, name: string } };

export type ConnectedVehicleDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConnectedVehicleDetailsQuery = { __typename?: 'Query', connectedVehicle: (
    { __typename?: 'ConnectedVehicle' }
    & ConnectedVehicleFragmentFragment
  ) };

export type ConnectedVehicleDetailsUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ConnectedVehicleDetailsUpdatedSubscription = { __typename?: 'Subscription', connectedVehicleUpdated: (
    { __typename?: 'ConnectedVehicle' }
    & ConnectedVehicleFragmentFragment
  ) };

export type ConnectedVehicleIdsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type ConnectedVehicleIdsQuery = { __typename?: 'Query', connectedVehicleIds: Array<string> };

export type ConnectedVehicleCommentFragment = { __typename?: 'ConnectedVehicleComment', id: string, connectedVehicleId: string, comment: string, createdAt: any, updatedAt: any, userId?: string | null, userDisplayName?: string | null };

export type DeleteAllConnectedVehicleCommentsMutationVariables = Exact<{
  connectedVehicleId: Scalars['ID'];
}>;


export type DeleteAllConnectedVehicleCommentsMutation = { __typename?: 'Mutation', deleteAllConnectedVehicleComments: boolean };

export type DeleteConnectedVehicleCommentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteConnectedVehicleCommentMutation = { __typename?: 'Mutation', deleteConnectedVehicleComment: boolean };

export type SaveConnectedVehicleCommentMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  connectedVehicleId: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type SaveConnectedVehicleCommentMutation = { __typename?: 'Mutation', saveConnectedVehicleComment: (
    { __typename?: 'ConnectedVehicleComment' }
    & ConnectedVehicleCommentFragment
  ) };

export type ConnectedVehicleCommentByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConnectedVehicleCommentByIdQuery = { __typename?: 'Query', connectedVehicleCommentsByConnectedVehicle: Array<(
    { __typename?: 'ConnectedVehicleComment' }
    & ConnectedVehicleCommentFragment
  )> };

export type ConnectedVehicleCommentUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ConnectedVehicleCommentUpdatedSubscription = { __typename?: 'Subscription', connectedVehicleCommentUpdated: { __typename?: 'ConnectedVehicleCommentStreamObject', streamObjectOperation: StreamObjectOperation, dto: (
      { __typename?: 'ConnectedVehicleComment' }
      & ConnectedVehicleCommentFragment
    ) } };

export type ConnectedVehiclesListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ConnectedVehiclesListQuery = { __typename?: 'Query', connectedVehicles: { __typename?: 'ConnectedVehicleConnection', totalCount: number, edges: Array<{ __typename?: 'ConnectedVehicleConnectionEdge', node: (
        { __typename?: 'ConnectedVehicle' }
        & ConnectedVehicleFragmentFragment
      ) }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ConnectedVehiclesListUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ConnectedVehiclesListUpdatedSubscription = { __typename?: 'Subscription', connectedVehicleUpdated: (
    { __typename?: 'ConnectedVehicle' }
    & ConnectedVehicleFragmentFragment
  ) };

export type SubGroupShortFragment = { __typename?: 'ContactGroupDto', id: string, name: string, description?: string | null, parentGroup?: string | null, items: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, workNumber?: string | null, notes?: string | null } | null> };

export type ContactSubGroupShortRecursiveFragment = { __typename?: 'ContactGroupDto', subGroups: Array<(
    { __typename?: 'ContactGroupDto', subGroups: Array<(
      { __typename?: 'ContactGroupDto', subGroups: Array<(
        { __typename?: 'ContactGroupDto', subGroups: Array<(
          { __typename?: 'ContactGroupDto', subGroups: Array<(
            { __typename?: 'ContactGroupDto' }
            & SubGroupShortFragment
          ) | null> }
          & SubGroupShortFragment
        ) | null> }
        & SubGroupShortFragment
      ) | null> }
      & SubGroupShortFragment
    ) | null> }
    & SubGroupShortFragment
  ) | null> };

export type ContactGroupShortFragmentFragment = (
  { __typename?: 'ContactGroupDto' }
  & SubGroupShortFragment
  & ContactSubGroupShortRecursiveFragment
);

export type ContactGroupsShortQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type ContactGroupsShortQuery = { __typename?: 'Query', contactGroupsQuery: { __typename?: 'ContactGroupConnection', edges: Array<{ __typename?: 'ContactGroupConnectionEdge', node: (
        { __typename?: 'ContactGroupDto' }
        & ContactGroupShortFragmentFragment
      ) }> } };

export type ContactGroupShortListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ContactGroupShortListQuery = { __typename?: 'Query', contactGroupsQuery: { __typename?: 'ContactGroupConnection', edges: Array<{ __typename?: 'ContactGroupConnectionEdge', node: { __typename?: 'ContactGroupDto', id: string, name: string } }> } };

export type HoursOfOperationFragmentFragment = { __typename?: 'HoursOfOperation', startDate?: any | null, endDate?: any | null, daysOfWeek?: Array<DayOfWeek | null> | null, startTime?: any | null, endTime?: any | null };

export type ContactListNodeFragmentFragment = { __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, notes?: string | null, workNumber?: string | null, organizations?: Array<{ __typename?: 'OrganizationDto', id: string, name: string, email: string, workNumber: string } | null> | null };

export type ContactFragmentFragment = { __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, website?: string | null, mailingAddress?: string | null, notes?: string | null, workNumber?: string | null, cellNumber?: string | null, faxNumber?: string | null, homeNumber?: string | null, pagerNumber?: string | null, otherNumber?: string | null, publicMode?: boolean | null, organizations?: Array<{ __typename?: 'OrganizationDto', id: string, name: string, email: string, workNumber: string } | null> | null, groups?: Array<{ __typename?: 'ContactGroupDto', id: string, name: string, items: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string } | null>, subGroups: Array<{ __typename?: 'ContactGroupDto', id: string, name: string, items: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string } | null>, subGroups: Array<{ __typename?: 'ContactGroupDto', id: string, name: string, items: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string } | null>, subGroups: Array<{ __typename?: 'ContactGroupDto', id: string, name: string, items: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string } | null> } | null> } | null> } | null> } | null> | null, hoursOfOperation?: Array<(
    { __typename?: 'HoursOfOperation' }
    & HoursOfOperationFragmentFragment
  ) | null> | null };

export type ContactsShortFragmentFragment = { __typename?: 'Contact', id: string, firstName: string, lastName: string };

export type OrganizationsShortFragmentFragment = { __typename?: 'OrganizationDto', id: string, name: string };

export type SubGroupFragment = { __typename?: 'ContactGroupDto', id: string, name: string, description?: string | null, parentGroup?: string | null, items: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string } | null> };

export type ContactSubGroupRecursiveFragment = { __typename?: 'ContactGroupDto', subGroups: Array<(
    { __typename?: 'ContactGroupDto', subGroups: Array<(
      { __typename?: 'ContactGroupDto', subGroups: Array<(
        { __typename?: 'ContactGroupDto', subGroups: Array<(
          { __typename?: 'ContactGroupDto', subGroups: Array<(
            { __typename?: 'ContactGroupDto' }
            & SubGroupFragment
          ) | null> }
          & SubGroupFragment
        ) | null> }
        & SubGroupFragment
      ) | null> }
      & SubGroupFragment
    ) | null> }
    & SubGroupFragment
  ) | null> };

export type ContactGroupListNodeFragmentFragment = (
  { __typename?: 'ContactGroupDto' }
  & SubGroupFragment
  & ContactSubGroupRecursiveFragment
);

export type OrganizationsListFragmentFragment = { __typename?: 'OrganizationDto', id: string, name: string, email: string, workNumber: string, notes?: string | null };

export type OrganizationFragmentFragment = { __typename?: 'OrganizationDto', id: string, name: string, email: string, website?: string | null, mailingAddress?: string | null, useAsContact?: boolean | null, notes?: string | null, workNumber: string, cellNumber?: string | null, faxNumber?: string | null, homeNumber?: string | null, pagerNumber?: string | null, otherNumber?: string | null, contacts?: Array<string | null> | null };

export type ContactListItemFragment = { __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, notes?: string | null, workNumber?: string | null, cellNumber?: string | null, faxNumber?: string | null, homeNumber?: string | null, pagerNumber?: string | null, otherNumber?: string | null, hoursOfOperation?: Array<(
    { __typename?: 'HoursOfOperation' }
    & HoursOfOperationFragmentFragment
  ) | null> | null };

export type DeleteContactMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact?: { __typename?: 'Contact', id: string } | null };

export type SaveContactMutationVariables = Exact<{
  contact: ContactInput;
}>;


export type SaveContactMutation = { __typename?: 'Mutation', saveContact?: (
    { __typename?: 'Contact' }
    & ContactFragmentFragment
  ) | null };

export type DeleteContactGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteContactGroupMutation = { __typename?: 'Mutation', deleteContactGroup?: { __typename?: 'ContactGroup', id?: string | null } | null };

export type SaveContactGroupMutationVariables = Exact<{
  contactGroup: ContactGroupInput;
}>;


export type SaveContactGroupMutation = { __typename?: 'Mutation', saveContactGroup?: (
    { __typename?: 'ContactGroupDto' }
    & ContactGroupListNodeFragmentFragment
  ) | null };

export type SaveOrganizationMutationVariables = Exact<{
  organization: OrganizationInput;
}>;


export type SaveOrganizationMutation = { __typename?: 'Mutation', saveOrganizationContact?: (
    { __typename?: 'OrganizationDto' }
    & OrganizationFragmentFragment
  ) | null };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganizationContact?: boolean | null };

export type ContactsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type ContactsListQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactConnection', totalCount: number, edges: Array<{ __typename?: 'ContactConnectionEdge', node: (
        { __typename?: 'Contact' }
        & ContactListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ContactListShortQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type ContactListShortQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactConnection', totalCount: number, edges: Array<{ __typename?: 'ContactConnectionEdge', node: { __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, workNumber?: string | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ContactQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContactQuery = { __typename?: 'Query', contact?: (
    { __typename?: 'Contact' }
    & ContactFragmentFragment
  ) | null };

export type ContactUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ContactUpdatedSubscription = { __typename?: 'Subscription', contactUpdated?: { __typename?: 'ContactStreamObject', streamObjectOperation?: StreamObjectOperation | null, dto?: (
      { __typename?: 'Contact' }
      & ContactFragmentFragment
    ) | null } | null };

export type OrganizationsShortQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type OrganizationsShortQuery = { __typename?: 'Query', organizationsContact: { __typename?: 'OrganizationConnection', totalCount: number, edges: Array<{ __typename?: 'OrganizationConnectionEdge', node: (
        { __typename?: 'OrganizationDto' }
        & OrganizationsShortFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ContactGroupsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type ContactGroupsQuery = { __typename?: 'Query', contactGroupsQuery: { __typename?: 'ContactGroupConnection', totalCount: number, edges: Array<{ __typename?: 'ContactGroupConnectionEdge', node: (
        { __typename?: 'ContactGroupDto' }
        & ContactGroupListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetContactGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetContactGroupQuery = { __typename?: 'Query', contactGroup?: (
    { __typename?: 'ContactGroupDto' }
    & ContactGroupListNodeFragmentFragment
  ) | null };

export type ContactGroupUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ContactGroupUpdatedSubscription = { __typename?: 'Subscription', contactGroupUpdated?: { __typename?: 'ContactGroupStreamObject', streamObjectOperation?: StreamObjectOperation | null, dto?: (
      { __typename?: 'ContactGroupDto' }
      & ContactGroupListNodeFragmentFragment
    ) | null } | null };

export type OrganizationsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type OrganizationsListQuery = { __typename?: 'Query', organizationsContact: { __typename?: 'OrganizationConnection', totalCount: number, edges: Array<{ __typename?: 'OrganizationConnectionEdge', node: (
        { __typename?: 'OrganizationDto' }
        & OrganizationsListFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organizationContact?: (
    { __typename?: 'OrganizationDto' }
    & OrganizationFragmentFragment
  ) | null };

export type OrganizationUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type OrganizationUpdatedSubscription = { __typename?: 'Subscription', organizationUpdated?: { __typename?: 'OrganizationStreamObject', streamObjectOperation?: StreamObjectOperation | null, dto?: (
      { __typename?: 'OrganizationDto' }
      & OrganizationFragmentFragment
    ) | null } | null };

export type ContactUpdatedSubscriptionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ContactUpdatedSubscriptionSubscription = { __typename?: 'Subscription', contactUpdated?: { __typename?: 'ContactStreamObject', streamObjectOperation?: StreamObjectOperation | null, dto?: { __typename?: 'Contact', id: string } | null } | null };

export type ContactsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ContactsByIdsQuery = { __typename?: 'Query', contactsByIds?: Array<(
    { __typename?: 'Contact' }
    & ContactListItemFragment
  ) | null> | null };

export type ContactGroupsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ContactGroupsByIdsQuery = { __typename?: 'Query', contactsGroupByIds?: Array<{ __typename?: 'ContactGroupDto', id: string, name: string, items: Array<(
      { __typename?: 'Contact' }
      & ContactListItemFragment
    ) | null>, subGroups: Array<{ __typename?: 'ContactGroupDto', id: string, name: string, items: Array<(
        { __typename?: 'Contact' }
        & ContactListItemFragment
      ) | null> } | null> } | null> | null };

export type CorridorActionSetListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorActionSetListQuery = { __typename?: 'Query', signalActionSets: { __typename?: 'SignalActionSetConnection', totalCount: number, edges: Array<{ __typename?: 'SignalActionSetConnectionEdge', node: { __typename?: 'SignalActionSet', number: number, impact?: SignalActionSetImpactType | null, notes?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type CorridorCamerasListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorCamerasListQuery = { __typename?: 'Query', cameras: { __typename?: 'CameraConnection', edges: Array<{ __typename?: 'CameraConnectionEdge', node: { __typename?: 'Camera', id: string } }> } };

export type CorridorCameraRoadsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type CorridorCameraRoadsQuery = { __typename?: 'Query', cameras: { __typename?: 'CameraConnection', edges: Array<{ __typename?: 'CameraConnectionEdge', node: { __typename?: 'Camera', id: string, road?: string | null } }> } };

export type CorridorCutoutsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type CorridorCutoutsListQuery = { __typename?: 'Query', signGroups: { __typename?: 'SignGroupConnection', totalCount: number, edges: Array<{ __typename?: 'SignGroupConnectionEdge', node: { __typename?: 'SignGroup', description?: string | null, attributes: any, type: SignGroupType, name: string, id: string, signs: Array<(
          { __typename?: 'Sign' }
          & CorridorSchematicSignFragment
        )> } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type CreateEventFromDetectionMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes?: InputMaybe<Scalars['JSON']>;
}>;


export type CreateEventFromDetectionMutation = { __typename?: 'Mutation', createEventFromDetection: { __typename?: 'Event', id: string } };

export type CorridorDetectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorDetectionListQuery = { __typename?: 'Query', detections: { __typename?: 'DetectionConnection', totalCount: number, edges: Array<{ __typename?: 'DetectionConnectionEdge', node: { __typename?: 'Detection', id: string, type?: string | null, description?: string | null, sources: Array<AlertSource | null>, created: any, lastUpdated: any, severity?: Severity | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveCorridorDetectionListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveCorridorDetectionListSubscription = { __typename?: 'Subscription', detectionUpdated: { __typename?: 'Detection', id: string, type?: string | null, description?: string | null, sources: Array<AlertSource | null>, created: any, lastUpdated: any, severity?: Severity | null } };

export type CorridorDetectorFragment = { __typename?: 'Detector', communicationState?: CommunicationState | null, lastDataReceived?: any | null, referencePoint?: number | null, laneDirection?: Direction | null, direction?: string | null, timeZone?: string | null, location?: any | null, road?: string | null, name: string, id: string, lanes: Array<{ __typename?: 'DetectorLaneData', engineeringLane: number, reversible?: boolean | null, laneIndex: number, occupancy?: number | null, direction: string, status?: string | null, volume?: number | null, speed?: number | null, type: LaneType }>, nextHourTrafficForecast: Array<{ __typename?: 'LaneVolumeForecast', lane?: string | null, volume?: number | null }> };

export type DetectorPollMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DetectorPollMutation = { __typename?: 'Mutation', multiplePoll?: Array<(
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  )> | null };

export type CorridorDetectorsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorDetectorsListQuery = { __typename?: 'Query', detectors: { __typename?: 'DetectorConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorConnectionEdge', node: (
        { __typename?: 'Detector' }
        & CorridorDetectorFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveCorridorDetectorsListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveCorridorDetectorsListSubscription = { __typename?: 'Subscription', detectorUpdated: (
    { __typename?: 'Detector' }
    & CorridorDetectorFragment
  ) };

export type CorridorEventListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorEventListQuery = { __typename?: 'Query', events: { __typename?: 'EventConnection', totalCount: number, edges: Array<{ __typename?: 'EventConnectionEdge', node: { __typename?: 'Event', category: EventCategory, created: any, status: EventStatus, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveCorridorEventListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveCorridorEventListSubscription = { __typename?: 'Subscription', eventUpdated: { __typename?: 'Event', id: string, name: string, category: EventCategory, status: EventStatus, created: any, lastUpdated: any, attributes: any, geometry: any, type: string, lanes: Array<{ __typename?: 'EventLane', id: string, direction: Direction, laneStatus: LaneStatus, engineeringLane: number, laneType: LaneType, lineType: string, roadwayType: RoadwayType, closedTime?: any | null, openTime?: any | null }> } };

export type CorridorFragment = { __typename?: 'Corridor', activationType: CorridorActivationType, responsePeriod: number, integrations: Array<string>, description?: string | null, deviceTypes: Array<CorridorDeviceType>, detections: Array<string>, confirmed: boolean, settings: any, geometry: any, events: Array<string>, shiftNotes?: string | null, type: CorridorType, name: string, id: string, lanes: Array<{ __typename?: 'CorridorLane', reversiblePosition?: number | null, startReference: number, endReference: number, controller?: string | null, reversible?: boolean | null, direction: Direction, position: number, lineType: CorridorLineType, type: LaneType, road: string, id: string }>, landmarks: Array<{ __typename?: 'CorridorLandmark', showReferencePoint: boolean, bothDirections: boolean, referencePoint: number, direction?: Direction | null, name: string, id: string, settings?: any | null }>, zones: Array<{ __typename?: 'CorridorZone', bothDirections: boolean, startReference: number, endReference: number, direction?: Direction | null, color: string, name: string, id: string }> };

export type CorridorSignGroupFragment = { __typename?: 'SignGroup', attributes: any, type: SignGroupType, name: string, id: string, signs: Array<{ __typename?: 'Sign', id: string }> };

export type CorridorEventFragment = { __typename?: 'Event', lastUpdated: any, attributes: any, category: EventCategory, created: any, status: EventStatus, type: string, name: string, id: string, lanes: Array<{ __typename?: 'EventLane', engineeringLane: number, laneStatus: LaneStatus, direction: Direction, laneType: LaneType }> };

export type TunnelLogFragment = { __typename?: 'TunnelLog', id: string, created: any, timestamp: any, event: string, userId: string, userFullName?: string | null, notes?: string | null, corridorId: string, directions?: Array<Direction | null> | null, data?: any | null };

export type SchematicGateUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicGateUpdatedSubscription = { __typename?: 'Subscription', gateControllerUpdated: { __typename?: 'GateController', id: string, name: string, referencePoint: number, direction: Direction, entranceDirection: GateControllerDirection, road: string, mode: GateControlMode, status: GateControllerStatus } };

export type SchematicGateDirectionQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type SchematicGateDirectionQuery = { __typename?: 'Query', gateControllerSystems: { __typename?: 'GateControllerSystemConnection', edges: Array<{ __typename?: 'GateControllerSystemEdge', node: { __typename?: 'GateControllerSystem', outboundDirection: Direction, inboundDirection: Direction, status: GateControllerStatus, id: string } }> } };

export type LiveSchematicGateDirectionSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveSchematicGateDirectionSubscription = { __typename?: 'Subscription', gateControllerSystemUpdated: { __typename?: 'GateControllerSystem', outboundDirection: Direction, inboundDirection: Direction, status: GateControllerStatus, id: string } };

export type SchematicGateGroupsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SchematicGateGroupsListQuery = { __typename?: 'Query', gateControllerSystems: { __typename?: 'GateControllerSystemConnection', edges: Array<{ __typename?: 'GateControllerSystemEdge', node: { __typename?: 'GateControllerSystem', groups: Array<{ __typename?: 'GateGroup', referencePoint: number, controllers: Array<string>, tollPoints: Array<string>, direction: GateDirection, rampType: GateGroupRampType, position: number, name: string, id: string }> } }> } };

export type SaveCorridorMutationVariables = Exact<{
  input: CorridorInput;
}>;


export type SaveCorridorMutation = { __typename?: 'Mutation', corridorSave: (
    { __typename?: 'Corridor' }
    & CorridorFragment
  ) };

export type DeleteCorridorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCorridorMutation = { __typename?: 'Mutation', corridorDelete?: boolean | null };

export type SaveActivityLogMutationVariables = Exact<{
  input: ActivityLogInput;
}>;


export type SaveActivityLogMutation = { __typename?: 'Mutation', addActivityLog: { __typename?: 'ActivityLog', id: string } };

export type LoadCorridorDevicesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadCorridorDevicesMutation = { __typename?: 'Mutation', corridorLoadDevices: { __typename?: 'Corridor', integrations: Array<string>, id: string } };

export type SaveShiftNotesMutationVariables = Exact<{
  id: Scalars['ID'];
  shiftNotes: Scalars['String'];
}>;


export type SaveShiftNotesMutation = { __typename?: 'Mutation', saveShiftNotes: (
    { __typename?: 'Corridor' }
    & CorridorFragment
  ) };

export type SaveTunnelLogMutationVariables = Exact<{
  input: TunnelLogInput;
}>;


export type SaveTunnelLogMutation = { __typename?: 'Mutation', saveTunnelLog: { __typename?: 'TunnelLog', id: string } };

export type CorridorSearchListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorSearchListQuery = { __typename?: 'Query', corridors: { __typename?: 'CorridorConnection', edges: Array<{ __typename?: 'CorridorConnectionEdge', node: { __typename?: 'Corridor', integrations: Array<string>, type: CorridorType, geometry: any, name: string, id: string } }> } };

export type CorridorListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorListQuery = { __typename?: 'Query', corridors: { __typename?: 'CorridorConnection', totalCount: number, edges: Array<{ __typename?: 'CorridorConnectionEdge', node: { __typename?: 'Corridor', shiftNotes?: string | null, activationType: CorridorActivationType, description?: string | null, deviceTypes: Array<CorridorDeviceType>, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveCorridorListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveCorridorListSubscription = { __typename?: 'Subscription', corridorUpdated: { __typename?: 'Corridor', activationType: CorridorActivationType, description?: string | null, deviceTypes: Array<CorridorDeviceType>, name: string, id: string } };

export type CorridorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CorridorQuery = { __typename?: 'Query', corridor: (
    { __typename?: 'Corridor' }
    & CorridorFragment
  ) };

export type CorridorUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CorridorUpdatedSubscription = { __typename?: 'Subscription', corridorUpdated: (
    { __typename?: 'Corridor' }
    & CorridorFragment
  ) };

export type CorridorListUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CorridorListUpdatedSubscription = { __typename?: 'Subscription', corridorUpdated: (
    { __typename?: 'Corridor' }
    & CorridorFragment
  ) };

export type RoadsQueryVariables = Exact<{
  integrationType?: InputMaybe<Array<InputMaybe<IntegrationType>> | InputMaybe<IntegrationType>>;
}>;


export type RoadsQuery = { __typename?: 'Query', roads?: Array<string | null> | null };

export type ResponseRuleCorridorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResponseRuleCorridorQuery = { __typename?: 'Query', responseRule: { __typename?: 'ResponseRule', corridor?: string | null } };

export type CorridorFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CorridorFormQuery = { __typename?: 'Query', corridor: { __typename?: 'Corridor', activationType: CorridorActivationType, responsePeriod: number, integrations: Array<string>, description?: string | null, shiftNotes?: string | null, deviceTypes: Array<CorridorDeviceType>, settings: any, geometry: any, type: CorridorType, name: string, id: string, lanes: Array<{ __typename?: 'CorridorLane', reversiblePosition?: number | null, startReference: number, endReference: number, controller?: string | null, reversible?: boolean | null, direction: Direction, position: number, lineType: CorridorLineType, type: LaneType, road: string, id: string }>, landmarks: Array<{ __typename?: 'CorridorLandmark', showReferencePoint: boolean, bothDirections: boolean, referencePoint: number, direction?: Direction | null, name: string, id: string, settings?: any | null }>, zones: Array<{ __typename?: 'CorridorZone', bothDirections: boolean, startReference: number, endReference: number, direction?: Direction | null, color: string, name: string, id: string }> } };

export type CorridorEventsQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CorridorEventsQuery = { __typename?: 'Query', events: { __typename?: 'EventConnection', edges: Array<{ __typename?: 'EventConnectionEdge', node: (
        { __typename?: 'Event' }
        & CorridorEventFragment
      ) }> } };

export type CorridorEventUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CorridorEventUpdatedSubscription = { __typename?: 'Subscription', eventUpdated: (
    { __typename?: 'Event' }
    & CorridorEventFragment
  ) };

export type CorridorMapListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorMapListQuery = { __typename?: 'Query', corridors: { __typename?: 'CorridorConnection', edges: Array<{ __typename?: 'CorridorConnectionEdge', node: { __typename?: 'Corridor', type: CorridorType, settings: any, geometry: any, name: string, id: string } }> } };

export type TunnelLogListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  corridorId: Scalars['ID'];
}>;


export type TunnelLogListQuery = { __typename?: 'Query', tunnelLogs: { __typename?: 'TunnelLogConnection', totalCount: number, edges: Array<{ __typename?: 'TunnelLogConnectionEdge', node: (
        { __typename?: 'TunnelLog' }
        & TunnelLogFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TunnelLogIdListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  corridorId: Scalars['ID'];
}>;


export type TunnelLogIdListQuery = { __typename?: 'Query', tunnelLogs: { __typename?: 'TunnelLogConnection', edges: Array<{ __typename?: 'TunnelLogConnectionEdge', node: { __typename?: 'TunnelLog', id: string } }> } };

export type TunnelLogQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TunnelLogQuery = { __typename?: 'Query', tunnelLog: (
    { __typename?: 'TunnelLog' }
    & TunnelLogFragment
  ) };

export type CorridorResourcePlanFragment = { __typename?: 'ResourcePlan', id: string, details: { __typename?: 'ResourcePlanDetails', description?: string | null, settings?: any | null, status: ResourceStatus, name: string }, resources: Array<{ __typename?: 'Resource', status: ResourceStatus, type: ResourceType, data: any, id: string, adhoc?: boolean | null }> };

export type DeleteResourcePlanMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteResourcePlanMutation = { __typename?: 'Mutation', deleteResourcePlan: boolean };

export type SaveCorridorResourcePlanMutationVariables = Exact<{
  input: ResourcePlanInput;
}>;


export type SaveCorridorResourcePlanMutation = { __typename?: 'Mutation', saveResourcePlan: (
    { __typename?: 'ResourcePlan' }
    & CorridorResourcePlanFragment
  ) };

export type ActivateResourcePlanMutationVariables = Exact<{
  id: Scalars['ID'];
  resources?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activationId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['Object']>;
}>;


export type ActivateResourcePlanMutation = { __typename?: 'Mutation', activateResources: Array<{ __typename?: 'JobRequest', requestId?: string | null, failure?: string | null, success: boolean, id: string }> };

export type GetResourcePlanQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourcePlanQuery = { __typename?: 'Query', resourcePlan?: (
    { __typename?: 'ResourcePlan' }
    & CorridorResourcePlanFragment
  ) | null };

export type CorridorResourcePlanQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CorridorResourcePlanQuery = { __typename?: 'Query', resourcePlan?: (
    { __typename?: 'ResourcePlan' }
    & CorridorResourcePlanFragment
  ) | null };

export type CorridorResourcePlanListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  corridorId?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorResourcePlanListQuery = { __typename?: 'Query', resourcePlans: { __typename?: 'ResourcePlanConnection', totalCount: number, edges: Array<{ __typename?: 'ResourcePlanConnectionEdge', node: (
        { __typename?: 'ResourcePlan' }
        & CorridorResourcePlanFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveCorridorResourcePlanListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveCorridorResourcePlanListSubscription = { __typename?: 'Subscription', resourcePlanUpdated?: (
    { __typename?: 'ResourcePlan' }
    & CorridorResourcePlanFragment
  ) | null };

export type ResourcePlanResourcesListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResourcePlanResourcesListQuery = { __typename?: 'Query', resourcePlan?: { __typename?: 'ResourcePlan', resources: Array<{ __typename?: 'Resource', status: ResourceStatus, type: ResourceType, data: any, id: string }> } | null };

export type CorridorSignFragment = { __typename?: 'Sign', communicationStatus: CommunicationState, travelTimeSegments: Array<string>, lastDataReceived?: any | null, referencePoint?: number | null, laneDirection?: string | null, lanePosition?: number | null, capabilities: Array<SignCapability>, backgroundColor?: string | null, foregroundColor?: string | null, colorScheme?: SignColorScheme | null, direction?: string | null, laneType?: LaneType | null, road?: string | null, name: string, id: string, currentMessage?: (
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  ) | null, displayType: (
    { __typename?: 'SignDisplayType' }
    & SignDisplayTypeFragment
  ) };

export type CorridorSchematicSignFragment = { __typename?: 'Sign', communicationStatus: CommunicationState, travelTimeSegments: Array<string>, referencePoint?: number | null, capabilities: Array<SignCapability>, backgroundColor?: string | null, foregroundColor?: string | null, laneDirection?: string | null, lanePosition?: number | null, colorScheme?: SignColorScheme | null, direction?: string | null, laneType?: LaneType | null, road?: string | null, name: string, id: string, displayType: (
    { __typename?: 'SignDisplayType' }
    & SignDisplayTypeFragment
  ), currentMessage?: (
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  ) | null, messagePreferences?: (
    { __typename?: 'SignMessagePreferences' }
    & SignMessagePreferencesFragment
  ) | null, speedSettings?: (
    { __typename?: 'SignSpeedSettings' }
    & SignSpeedSettingsFragment
  ) | null, tests?: (
    { __typename?: 'SignTests' }
    & SignTestsTypeFragment
  ) | null };

export type SchematicResponsePostMutationVariables = Exact<{
  requests: Array<SignMessageDisplayRequest> | SignMessageDisplayRequest;
}>;


export type SchematicResponsePostMutation = { __typename?: 'Mutation', signDisplay: Array<{ __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null, id: string }> };

export type CorridorSchematicSignsQueryVariables = Exact<{
  filters: Array<FilterInput> | FilterInput;
  limit: Scalars['Int'];
}>;


export type CorridorSchematicSignsQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: (
        { __typename?: 'Sign' }
        & CorridorSchematicSignFragment
      ) }> } };

export type LiveCorridorSchematicSignsSubscriptionVariables = Exact<{
  integrations: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveCorridorSchematicSignsSubscription = { __typename?: 'Subscription', signUpdated: (
    { __typename?: 'Sign' }
    & CorridorSchematicSignFragment
  ) };

export type CorridorSignsListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorSignsListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', totalCount: number, edges: Array<{ __typename?: 'SignConnectionEdge', node: (
        { __typename?: 'Sign' }
        & CorridorSignFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveCorridorSignsListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveCorridorSignsListSubscription = { __typename?: 'Subscription', signUpdated: (
    { __typename?: 'Sign' }
    & CorridorSignFragment
  ) };

export type SignMessageValidateQueryVariables = Exact<{
  id: Scalars['ID'];
  message: SignMessageInput;
}>;


export type SignMessageValidateQuery = { __typename?: 'Query', validateSignMessage: { __typename?: 'SignMessageValidationResult', failure?: string | null } };

export type SignSchematicEntitiesQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SignSchematicEntitiesQuery = { __typename?: 'Query', signSchematicEntities: Array<any> };

export type SchematicSignUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicSignUpdatedSubscription = { __typename?: 'Subscription', signUpdated: (
    { __typename?: 'Sign' }
    & CorridorSchematicSignFragment
  ) };

export type SchematicCameraUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicCameraUpdatedSubscription = { __typename?: 'Subscription', cameraUpdated: { __typename?: 'Camera', communicationStatus?: CommunicationState | null, direction?: string | null, id: string, name: string, referencePoint?: string | null, road?: string | null } };

export type SchematicDetectorUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicDetectorUpdatedSubscription = { __typename?: 'Subscription', detectorUpdated: { __typename?: 'Detector', id: string, referencePoint?: number | null, laneDirection?: Direction | null, direction?: string | null, lanes: Array<{ __typename?: 'DetectorLaneData', laneIndex: number, reversible?: boolean | null, speed?: number | null, density?: number | null, occupancy?: number | null, volume?: number | null, type: LaneType, engineeringLane: number, direction: string }> } };

export type SchematicTrafficControlUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicTrafficControlUpdatedSubscription = { __typename?: 'Subscription', trafficControlUpdated: { __typename?: 'TrafficControl', referencePoint: number, laneDirection?: Direction | null, lanePosition: number, direction: Direction, laneType: LaneType, mode: TrafficControlMode, id: string } };

export type SchematicTunnelFanUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicTunnelFanUpdatedSubscription = { __typename?: 'Subscription', tunnelFanUpdated: { __typename?: 'TunnelFan', speed?: number | null, running?: boolean | null, runStatus?: FanRunStatus | null, serviceStatus?: FanServiceStatus | null, priority?: string | null, communicationStatus?: CommunicationState | null, lastDataReceived?: any | null, referencePoint?: number | null, direction?: Direction | null, road?: string | null, name: string, id: string } };

export type SchematicCutoutUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicCutoutUpdatedSubscription = { __typename?: 'Subscription', signGroupUpdated: { __typename?: 'SignGroup', id: string, attributes: any, signs: Array<{ __typename?: 'Sign', id: string, direction?: string | null }> } };

export type SchematicTunnelLightUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicTunnelLightUpdatedSubscription = { __typename?: 'Subscription', tunnelLightUpdated: { __typename?: 'TunnelLight', status?: LightStatus | null, communicationStatus?: CommunicationState | null, lastDataReceived?: any | null, referencePoint?: number | null, direction?: Direction | null, road?: string | null, name: string, id: string } };

export type SchematicWeatherStationUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicWeatherStationUpdatedSubscription = { __typename?: 'Subscription', weatherStationUpdated: { __typename?: 'WeatherStation', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint?: number | null, description?: string | null, direction?: string | null, location?: any | null, values: any, road?: string | null, name: string, id: string, communicationParameters?: any | null } };

export type SchematicTollingPointUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SchematicTollingPointUpdatedSubscription = { __typename?: 'Subscription', tollingPointUpdated: { __typename?: 'TollingPoint', id: string, name: string, road?: string | null, direction?: Direction | null, referencePoint?: number | null, communicationState: CommunicationState, plazaDirection?: Direction | null, reversalPlazaId?: string | null, isActive: boolean } };

export type TrafficControlListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TrafficControlListQuery = { __typename?: 'Query', trafficControls: { __typename?: 'TrafficControlConnection', totalCount: number, edges: Array<{ __typename?: 'TrafficControlConnectionEdge', node: { __typename?: 'TrafficControl', communicationStatus: CommunicationState, lastDataReceived: any, referencePoint: number, laneDirection?: Direction | null, lanePosition: number, direction: Direction, laneType: LaneType, mode: TrafficControlMode, road: string, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveTrafficControlListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveTrafficControlListSubscription = { __typename?: 'Subscription', trafficControlUpdated: { __typename?: 'TrafficControl', communicationStatus: CommunicationState, lastDataReceived: any, referencePoint: number, direction: Direction, laneType: LaneType, mode: TrafficControlMode, road: string, name: string, id: string } };

export type TrafficControlSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TrafficControlSelectionListQuery = { __typename?: 'Query', trafficControls: { __typename?: 'TrafficControlConnection', totalCount: number, edges: Array<{ __typename?: 'TrafficControlConnectionEdge', node: { __typename?: 'TrafficControl', referencePoint: number, laneDirection?: Direction | null, lanePosition: number, direction: Direction, road: string, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type CorridorTravelTimeFragment = { __typename?: 'TravelTime', communicationState?: CommunicationState | null, reportedTime?: number | null, historicTime?: number | null, lastConnect?: any | null, travelTime?: number | null, distance?: number | null, quality?: TravelTimeDataQuality | null, speed?: number | null, name: string, id: string, parts: Array<{ __typename?: 'TravelTimePart', startReference: number, endReference: number, direction: Direction, road: string }> };

export type TravelTimePollMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TravelTimePollMutation = { __typename?: 'Mutation', multiplePoll?: Array<(
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  )> | null };

export type SaveTravelTimeModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveTravelTimeModuleSettingsMutation = { __typename?: 'Mutation', saveTravelTimeModuleSettings?: boolean | null };

export type CorridorTravelTimeListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorTravelTimeListQuery = { __typename?: 'Query', travelTimes: { __typename?: 'TravelTimeConnection', totalCount: number, edges: Array<{ __typename?: 'TravelTimeConnectionEdge', node: (
        { __typename?: 'TravelTime' }
        & CorridorTravelTimeFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveCorridorTravelTimeListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveCorridorTravelTimeListSubscription = { __typename?: 'Subscription', travelTimeUpdated: (
    { __typename?: 'TravelTime' }
    & CorridorTravelTimeFragment
  ) };

export type TunnelFanListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TunnelFanListQuery = { __typename?: 'Query', tunnelFans: { __typename?: 'TunnelFanConnection', totalCount: number, edges: Array<{ __typename?: 'TunnelFanConnectionEdge', node: { __typename?: 'TunnelFan', speed?: number | null, running?: boolean | null, runStatus?: FanRunStatus | null, serviceStatus?: FanServiceStatus | null, priority?: string | null, communicationStatus?: CommunicationState | null, lastDataReceived?: any | null, referencePoint?: number | null, direction?: Direction | null, road?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveTunnelFanListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveTunnelFanListSubscription = { __typename?: 'Subscription', tunnelFanUpdated: { __typename?: 'TunnelFan', speed?: number | null, running?: boolean | null, runStatus?: FanRunStatus | null, serviceStatus?: FanServiceStatus | null, priority?: string | null, communicationStatus?: CommunicationState | null, lastDataReceived?: any | null, referencePoint?: number | null, direction?: Direction | null, road?: string | null, name: string, id: string } };

export type TunnelFanSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TunnelFanSelectionListQuery = { __typename?: 'Query', tunnelFans: { __typename?: 'TunnelFanConnection', totalCount: number, edges: Array<{ __typename?: 'TunnelFanConnectionEdge', node: { __typename?: 'TunnelFan', referencePoint?: number | null, direction?: Direction | null, road?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TunnelFanNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type TunnelFanNamesQuery = { __typename?: 'Query', tunnelFans: { __typename?: 'TunnelFanConnection', edges: Array<{ __typename?: 'TunnelFanConnectionEdge', node: { __typename?: 'TunnelFan', id: string, name: string } }> } };

export type TunnelLightListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TunnelLightListQuery = { __typename?: 'Query', tunnelLights: { __typename?: 'TunnelLightConnection', totalCount: number, edges: Array<{ __typename?: 'TunnelLightConnectionEdge', node: { __typename?: 'TunnelLight', status?: LightStatus | null, communicationStatus?: CommunicationState | null, lastDataReceived?: any | null, referencePoint?: number | null, direction?: Direction | null, road?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveTunnelLightListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveTunnelLightListSubscription = { __typename?: 'Subscription', tunnelLightUpdated: { __typename?: 'TunnelLight', status?: LightStatus | null, communicationStatus?: CommunicationState | null, lastDataReceived?: any | null, referencePoint?: number | null, direction?: Direction | null, road?: string | null, name: string, id: string } };

export type TunnelLightSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TunnelLightSelectionListQuery = { __typename?: 'Query', tunnelLights: { __typename?: 'TunnelLightConnection', totalCount: number, edges: Array<{ __typename?: 'TunnelLightConnectionEdge', node: { __typename?: 'TunnelLight', referencePoint?: number | null, direction?: Direction | null, road?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TunnelLightNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type TunnelLightNamesQuery = { __typename?: 'Query', tunnelLights: { __typename?: 'TunnelLightConnection', edges: Array<{ __typename?: 'TunnelLightConnectionEdge', node: { __typename?: 'TunnelLight', id: string, name: string } }> } };

export type TunnelLogsUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type TunnelLogsUpdatedSubscription = { __typename?: 'Subscription', tunnelLogsUpdated: { __typename?: 'TunnelLog', id: string } };

export type CorridorWeatherStationFragment = { __typename?: 'WeatherStation', communicationStatus: CommunicationState, locationDescription?: string | null, lastDataReceived?: any | null, referencePoint?: number | null, description?: string | null, direction?: string | null, location?: any | null, values: any, road?: string | null, name: string, id: string };

export type CorridorsWeatherStationPollMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CorridorsWeatherStationPollMutation = { __typename?: 'Mutation', multiplePoll?: Array<(
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  )> | null };

export type CorridorWeatherStationListQueryVariables = Exact<{
  sortField?: InputMaybe<WeatherStationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CorridorWeatherStationListQuery = { __typename?: 'Query', weatherStations: { __typename?: 'WeatherStationConnection', totalCount: number, edges: Array<{ __typename?: 'WeatherStationConnectionEdge', node: (
        { __typename?: 'WeatherStation' }
        & CorridorWeatherStationFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveCorridorWeatherListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveCorridorWeatherListSubscription = { __typename?: 'Subscription', weatherStationUpdated: (
    { __typename?: 'WeatherStation' }
    & CorridorWeatherStationFragment
  ) };

export type DataSourceFieldConfigFragment = { __typename?: 'FieldConfig', label: string, type: string, name: string, id: string, activeLogic?: any | null, choicesTitle?: string | null, chosenTitle?: string | null, defaultValue?: any | null, deselectAllLabel?: string | null, disableFuture?: boolean | null, disablePast?: boolean | null, displayFormat?: string | null, fieldSize?: string | null, format?: string | null, help?: string | null, hint?: string | null, limitTags?: number | null, max?: number | null, maxLength?: number | null, min?: number | null, multiple?: boolean | null, sortOrder?: string | null, required?: boolean | null, requiredLogic?: any | null, selectAllLabel?: string | null, step?: number | null, uniqueFields?: Array<string | null> | null, useCheckedIcon?: boolean | null, useIcon?: boolean | null, useStepper?: boolean | null, moduleName?: string | null, sourceId?: string | null, rows?: number | null, multiline?: boolean | null, mode?: string | null, pickerZIndex?: number | null, fieldConfigs?: Array<(
    { __typename?: 'FieldConfig' }
    & FieldConfigRecursiveFragment
  )> | null, options?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null> | null };

export type DataSourceConfigFragment = { __typename?: 'DataSourceConfig', module: KineticModule, name: string, id: string, system?: boolean | null, readOnly?: boolean | null, fields: Array<(
    { __typename?: 'FieldConfig' }
    & DataSourceFieldConfigFragment
  )> };

export type DataSourceFragment = { __typename?: 'DataSource', attributes: any, enabled?: boolean | null, value: string, id: string, config: (
    { __typename?: 'DataSourceConfig' }
    & DataSourceConfigFragment
  ) };

export type SaveDataSourceMutationVariables = Exact<{
  input: DataSourceInput;
}>;


export type SaveDataSourceMutation = { __typename?: 'Mutation', saveDataSource: (
    { __typename?: 'DataSource' }
    & DataSourceFragment
  ) };

export type DeleteDataSourceMutationVariables = Exact<{
  selection: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteDataSourceMutation = { __typename?: 'Mutation', deleteDataSources?: boolean | null };

export type SaveDataSourceConfigMutationVariables = Exact<{
  input: DataSourceConfigInput;
}>;


export type SaveDataSourceConfigMutation = { __typename?: 'Mutation', saveDataSourceConfig: (
    { __typename?: 'DataSourceConfig' }
    & DataSourceConfigFragment
  ) };

export type DeleteDataSourceConfigMutationVariables = Exact<{
  selection: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteDataSourceConfigMutation = { __typename?: 'Mutation', deleteDataSourceConfigs?: boolean | null };

export type ImportDataSourcesMutationVariables = Exact<{
  input: ImportDataSources;
}>;


export type ImportDataSourcesMutation = { __typename?: 'Mutation', importDataSources: boolean };

export type DataSourceSelectionListQueryVariables = Exact<{
  query?: InputMaybe<DataSourceInputQuery>;
}>;


export type DataSourceSelectionListQuery = { __typename?: 'Query', dataSources: { __typename?: 'DataSourceConnection', totalCount: number, edges: Array<{ __typename?: 'DataSourceConnectionEdge', node: { __typename?: 'DataSource', attributes: any, value: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DataSourceListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['ID']>;
}>;


export type DataSourceListQuery = { __typename?: 'Query', dataSources: { __typename?: 'DataSourceConnection', totalCount: number, edges: Array<{ __typename?: 'DataSourceConnectionEdge', node: (
        { __typename?: 'DataSource' }
        & DataSourceFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DataSourcesByConfigIdQueryVariables = Exact<{
  configId: Scalars['ID'];
}>;


export type DataSourcesByConfigIdQuery = { __typename?: 'Query', dataSourcesByConfigId?: Array<{ __typename?: 'DataSource', value: string, attributes: any }> | null };

export type DataSourceConfigNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DataSourceConfigNameQuery = { __typename?: 'Query', dataSourceConfig: { __typename?: 'DataSourceConfig', name: string } };

export type DataSourceDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DataSourceDetailQuery = { __typename?: 'Query', dataSource: (
    { __typename?: 'DataSource' }
    & DataSourceFragment
  ) };

export type EventTypesQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  category: Scalars['Object'];
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type EventTypesQuery = { __typename?: 'Query', dataSources: { __typename?: 'DataSourceConnection', totalCount: number, edges: Array<{ __typename?: 'DataSourceConnectionEdge', node: { __typename?: 'DataSource', enabled?: boolean | null, value: string, id: string, attributes: any } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DataSourceConfigDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DataSourceConfigDetailQuery = { __typename?: 'Query', dataSourceConfig: (
    { __typename?: 'DataSourceConfig' }
    & DataSourceConfigFragment
  ) };

export type DataSourceConfigurationListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  module?: InputMaybe<KineticModule>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type DataSourceConfigurationListQuery = { __typename?: 'Query', dataSourceConfigs: { __typename?: 'DataSourceConfigConnection', totalCount: number, edges: Array<{ __typename?: 'DataSourceConfigConnectionEdge', node: (
        { __typename?: 'DataSourceConfig' }
        & DataSourceConfigFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LinkedDataSourcesQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LinkedDataSourcesQuery = { __typename?: 'Query', linkedDataSources?: Array<{ __typename?: 'DataSource', id: string, value: string, config: { __typename?: 'DataSourceConfig', name: string } }> | null };

export type DataSourceDefaultValueOptionsQueryVariables = Exact<{
  name: Scalars['ID'];
}>;


export type DataSourceDefaultValueOptionsQuery = { __typename?: 'Query', dataSources: { __typename?: 'DataSourceConnection', edges: Array<{ __typename?: 'DataSourceConnectionEdge', node: { __typename?: 'DataSource', value: string, attributes: any } }> } };

export type ExportDataSourcesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ExportDataSourcesQuery = { __typename?: 'Query', exportDataSources: any };

export type DetectorFragment = { __typename?: 'Detector', communicationState?: CommunicationState | null, referencePoint?: number | null, direction?: string | null, timeZone?: string | null, location?: any | null, road?: string | null, name: string, id: string, lanes: Array<{ __typename?: 'DetectorLaneData', engineeringLane: number, laneIndex: number, occupancy?: number | null, direction: string, status?: string | null, volume?: number | null, speed?: number | null, type: LaneType, name?: string | null }> };

export type HiTracFragmentFragment = { __typename?: 'HiTrac', lastResetTime?: any | null, lastResetReason?: string | null, lastConnect?: any | null, lastBattery?: number | null, firmwareVersions?: Array<{ __typename?: 'HiTracFirmwareRecord', version?: string | null, processor?: number | null }> | null };

export type DetectorLaneDataFragment = { __typename?: 'DetectorLaneData', laneIndex: number, totalErrorCount: number, excludeVos?: boolean | null, reversible?: boolean | null, volume?: number | null, occupancy?: number | null, direction: string, type: LaneType, engineeringLane: number, status?: string | null, name?: string | null, density?: number | null, isReversed: boolean };

export type DetectorWeightThresholdFragment = { __typename?: 'DetectorWeightThreshold', laneIndex?: DetectorLaneIndex | null, lane?: number | null, weightLowerThreshold?: number | null, weightUpperThreshold?: number | null };

export type DetectorLaneDescriptionConfigFragment = { __typename?: 'DetectorLaneDescriptionConfig', laneIndex?: DetectorLaneIndex | null, lane?: number | null, laneDescription?: string | null };

export type DetectorManeuverSettingConfigFragment = { __typename?: 'DetectorManeuverSettingConfig', maneuverId?: string | null, maneuverDescription?: string | null, originDirection?: string | null, destinationDirection?: string | null };

export type DetectorListNodeFragmentFragment = { __typename?: 'Detector', id: string, name: string, description?: string | null, communicationState?: CommunicationState | null, primaryDirection?: string | null, classScheme?: string | null, timeZone?: string | null, timezoneId?: string | null, speedUnit?: string | null, speedLimit?: number | null, type?: DetectorType | null, roadType?: string | null, externalCenter?: string | null, location?: any | null, maxGrossWeight?: number | null, numberOfLanes?: number | null, laneDirection?: Direction | null, siteNumber?: number | null, equipmentNumber?: number | null, communicationParameters?: any | null, lastDataReceived?: any | null, referencePoint?: number | null, direction?: string | null, road?: string | null, deviceProtocol?: string | null, systemEnabled?: boolean | null, isReversed: boolean, deviceType?: { __typename?: 'DetectorDeviceType', id: string, name?: string | null } | null, lanes: Array<(
    { __typename?: 'DetectorLaneData', laneIndex: number, reversible?: boolean | null, volume?: number | null, speed?: number | null, occupancy?: number | null, direction: string, type: LaneType, engineeringLane: number, status?: string | null, isReversed: boolean }
    & DetectorLaneDataFragment
  )>, hiTrac?: (
    { __typename?: 'HiTrac' }
    & HiTracFragmentFragment
  ) | null, lastVehicle?: { __typename?: 'DetectorVehicle', id: string, serial?: number | null, timestamp?: any | null, headerTimestamp?: any | null } | null, speedBins?: Array<{ __typename?: 'DetectorSpeedBinConfig', speedBinName?: string | null, speedBinIndex?: number | null, speedStartRange?: number | null, speedEndRange?: number | null }> | null, grossWeightThreshold?: Array<(
    { __typename?: 'DetectorWeightThreshold' }
    & DetectorWeightThresholdFragment
  )> | null, axle1WeightThreshold?: Array<(
    { __typename?: 'DetectorWeightThreshold' }
    & DetectorWeightThresholdFragment
  )> | null, laneDescription?: Array<(
    { __typename?: 'DetectorLaneDescriptionConfig' }
    & DetectorLaneDescriptionConfigFragment
  )> | null, maneuvers?: Array<(
    { __typename?: 'DetectorManeuverSettingConfig' }
    & DetectorManeuverSettingConfigFragment
  )> | null, directionDescriptions?: Array<{ __typename: 'DirectionDescriptionConfig', description: string, direction: string }> | null, nextHourTrafficForecast: Array<{ __typename?: 'LaneVolumeForecast', lane?: string | null, volume?: number | null }> };

export type DetectorVehicleDetailNodeFragmentFragment = { __typename?: 'DetectorVehicle', leftTyreType?: Array<number> | null, rightTyreType?: Array<number> | null, dimensionProfile?: { __typename?: 'File', id: string, name: string, size?: number | null, contentType?: string | null, path: string } | null, loopSignature?: { __typename?: 'File', id: string, name: string, size?: number | null, contentType?: string | null, path: string } | null };

export type DetectorVehicleListNodeFragmentFragment = { __typename?: 'DetectorVehicle', id: string, serial?: number | null, timestamp?: any | null, axlesCount?: number | null, tags?: Array<string | null> | null, lane?: number | null, speed?: number | null, grossWeight?: number | null, axleWeight1?: number | null, axleWeight2?: number | null, axleWeight3?: number | null, axleWeight4?: number | null, axleWeight5?: number | null, axleWeight6?: number | null, axleWeight7?: number | null, axleWeight8?: number | null, axleWeight9?: number | null, axleWeight10?: number | null, axleWeight11?: number | null, axleWeight12?: number | null, axleWeight13?: number | null, axleWeight14?: number | null, axleWeight15?: number | null, axleWeight16?: number | null, axleWeight17?: number | null, axleWeight18?: number | null, axleWeight19?: number | null, axleWeight20?: number | null, axleWeight21?: number | null, axleWeight22?: number | null, axleWeight23?: number | null, axleWeight24?: number | null, axleWeight25?: number | null, axleWeight26?: number | null, axleWeight27?: number | null, axleWeight28?: number | null, axleWeight29?: number | null, axleWeight30?: number | null, length?: number | null, axleSpace1?: number | null, axleSpace2?: number | null, axleSpace3?: number | null, axleSpace4?: number | null, axleSpace5?: number | null, axleSpace6?: number | null, axleSpace7?: number | null, axleSpace8?: number | null, axleSpace9?: number | null, axleSpace10?: number | null, axleSpace11?: number | null, axleSpace12?: number | null, axleSpace13?: number | null, axleSpace14?: number | null, axleSpace15?: number | null, axleSpace16?: number | null, axleSpace17?: number | null, axleSpace18?: number | null, axleSpace19?: number | null, axleSpace20?: number | null, axleSpace21?: number | null, axleSpace22?: number | null, axleSpace23?: number | null, axleSpace24?: number | null, axleSpace25?: number | null, axleSpace26?: number | null, axleSpace27?: number | null, axleSpace28?: number | null, axleSpace29?: number | null, chassisCode?: number | null, straddle?: boolean | null, overWeight?: boolean | null, loopOnTime?: number | null, loopFailure?: boolean | null, headway?: number | null, legalStatus?: number | null, straddleLane?: number | null, validity?: Array<HiTracVehicleValidity> | null, direction?: HiTracVehicleDirection | null, laneDirection?: DetectorDirection | null, minChassisList?: Array<number> | null, maxChassisList?: Array<number> | null, anprImageAvailable?: boolean | null, overViewImageAvailable?: boolean | null, dimensionProfileAvailable?: boolean | null, loopSignatureAvailable?: boolean | null, width?: number | null, height?: number | null, ocr?: string | null, ocrRear?: string | null, aiClassName?: string | null, aiConfidence?: number | null, aiClassVerified?: boolean | null, aiClassVerifiedTS?: any | null, typeAPositions?: Array<number> | null, typeBPositions?: Array<number> | null, lastAxleSpeed?: number | null, sensorWheelWeights?: Array<number> | null, sensorWeights?: Array<Array<number>> | null, verifiedAiClassName?: string | null, temperature?: number | null, maneuverId?: string | null, verifiedClassName?: string | null, verifiedClassNameStatus?: boolean | null, verifiedClassNameStatusAt?: any | null, verifiedClassIndex?: number | null, verifiedClassNameStatusCodes?: Array<DetectorVehicleVerificationStatus | null> | null, aiClassVerifiedCodes?: Array<DetectorVehicleVerificationStatus | null> | null, axleType1?: DetectorAxleType | null, axleType2?: DetectorAxleType | null, axleType3?: DetectorAxleType | null, axleType4?: DetectorAxleType | null, axleType5?: DetectorAxleType | null, axleType6?: DetectorAxleType | null, axleType7?: DetectorAxleType | null, axleType8?: DetectorAxleType | null, axleType9?: DetectorAxleType | null, axleType10?: DetectorAxleType | null, leftTyreType?: Array<number> | null, rightTyreType?: Array<number> | null, classInfo?: { __typename?: 'DetectorClass', id: string, name?: string | null, index?: number | null } | null, images?: Array<{ __typename?: 'File', id: string, name: string, size?: number | null, contentType?: string | null, path: string, timestamp?: any | null, module?: KineticModule | null, key?: string | null }> | null };

export type DetectorAlarmListNodeFragmentFragment = { __typename?: 'DetectorAlarm', id: string, description?: string | null, receivedAt?: any | null, clearedAt?: any | null, active?: boolean | null, acknowledged?: boolean | null, cleared?: boolean | null, count?: number | null, firstReceivedAt?: any | null, type?: { __typename?: 'DetectorAlarmType', id: string, name?: string | null, description?: string | null, code?: DetectorAlarmTypeCode | null, severity?: NotificationSeverity | null } | null, subtypes?: Array<{ __typename?: 'DetectorAlarmSubtype', name?: string | null }> | null, detector?: { __typename?: 'Detector', id: string, name: string, timezoneId?: string | null, siteNumber?: number | null, equipmentNumber?: number | null } | null, group?: { __typename?: 'DetectorAlarmGroup', id: string, name?: string | null } | null };

export type DetectorBatteryListNodeFragmentFragment = { __typename?: 'DetectorBattery', id: string, volts?: number | null, timestamp?: any | null };

export type DetectorActivityListNodeFragmentFragment = { __typename?: 'DetectorActivity', id: string, count?: number | null, timestamp?: any | null, parameter?: string | null, level?: { __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null, message?: { __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null, subtype?: { __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null };

export type DetectorConnectionLogListNodeFragmentFragment = { __typename?: 'DetectorConnectionGroup', timestamp?: any | null, groupID?: string | null, bytesIncoming?: number | null, bytesOutgoing?: number | null, status?: string | null, elapsedSeconds?: number | null, id: string, connectionPushType?: string | null };

export type DetectorWeatherListNodeFragmentFragment = { __typename?: 'DetectorWeather', id?: string | null, detectorId?: string | null, hour?: number | null, date?: string | null, timestamp?: any | null, weatherInfo?: { __typename?: 'Weather', name?: string | null, base?: string | null, visibility?: number | null, cod?: number | null, weather?: Array<{ __typename?: 'WeatherDetail', main?: string | null, icon?: string | null, description?: string | null } | null> | null, main?: { __typename?: 'WeatherMain', temp?: number | null, feels_like?: number | null, temp_min?: number | null, temp_max?: number | null, pressure?: number | null, humidity?: number | null } | null, wind?: { __typename?: 'WeatherWind', speed?: number | null, deg?: number | null } | null, clouds?: { __typename?: 'WeatherClouds', all?: number | null } | null, sys?: { __typename?: 'WeatherSys', country?: string | null, type?: number | null, sunrise?: number | null, sunset?: number | null } | null } | null };

export type DetectorEmailAlertSettingFragmentFragment = { __typename?: 'DetectorEmailAlertSetting', id: string, emailIds: Array<string>, allSites: boolean, userIds: Array<string>, frequencyDay?: number | null, timezone?: string | null, startTime?: string | null, enabled?: boolean | null, emailTemplate?: string | null, interval?: DetectorVehicleVolumeGranularity | null, detectorClass?: Array<string | null> | null, classGroup?: Array<string | null> | null, direction?: Array<Direction | null> | null, lane?: Array<number | null> | null, performanceReportId?: string | null, ruleId?: string | null, consecutiveAlerts?: number | null, unitPreference?: ConversionUnitType | null, timestamp?: any | null, frequency?: { __typename?: 'DetectorAlertFrequencyOption', code?: DetectorEmailAlertFrequency | null, label: string, types?: Array<DetectorAlertType> | null } | null, type?: { __typename?: 'DetectorAlertTypeOption', code?: DetectorAlertType | null, label: string } | null, subtypes?: Array<{ __typename?: 'DetectorAlertSubtypeOption', code?: DetectorAlertSubtype | null, label: string, type?: DetectorAlertType | null }> | null, detectors?: Array<{ __typename?: 'Detector', id: string, name: string }> | null, detectorGroups?: Array<{ __typename?: 'DetectorGroup', id: string, name: string }> | null, reportRule?: { __typename?: 'DetectorReportRule', name: string, id: string } | null, reportConfig?: { __typename?: 'DetectorReportConfiguration', id: string } | null };

export type DetectorTmasReportFragmentFragment = { __typename?: 'DetectorTMASReport', name?: string | null, content?: string | null };

export type DetectorConnectionLogFragmentFragment = { __typename?: 'DetectorConnectionLog', groupID?: string | null, hexDump?: string | null, timestamp?: any | null, message?: string | null, id: string, level?: { __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null };

export type DetectorPerformanceReportResultFragmentFragment = { __typename?: 'DetectorPerformanceReportResult', date?: string | null, intervalList?: Array<any> | null, detector?: { __typename?: 'Detector', id: string, name: string } | null };

export type DetectorReportConfigurationFragmentFragment = { __typename?: 'DetectorReportConfiguration', id: string, name: string, description?: string | null, ruleIds?: Array<string> | null, defaultSelection?: boolean | null };

export type DetectorPerformanceReportDayWiseAvailabilityInfoFragmentFragment = { __typename?: 'DetectorPerformanceReportDayWiseAvailabilityInfo', date?: string | null, rules?: Array<{ __typename?: 'DetectorReportRule', id: string, name: string, template: DetectorReportTemplate }> | null, availability?: Array<{ __typename?: 'DetectorReportRuleAvailability', ruleId?: string | null, availability?: boolean | null }> | null };

export type FormViewFragment = { __typename?: 'DetectorReportConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'DetectorReportConfigFormSection', id: string, name: string, fields: Array<(
      { __typename?: 'FieldConfig' }
      & FieldConfigRecursiveFragment
    )> }> };

export type DetectorReportFormViewsRecursiveFragment = { __typename?: 'DetectorReportRuleForm', views: Array<(
    { __typename?: 'DetectorReportConfigFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment
          )> }
          & FormViewFragment
        )> }
        & FormViewFragment
      )> }
      & FormViewFragment
    )> }
    & FormViewFragment
  )> };

export type FormFragment = (
  { __typename?: 'DetectorReportRuleForm', id?: string | null, name?: string | null, reportTemplate?: DetectorReportTemplate | null, extraConfig: any }
  & DetectorReportFormViewsRecursiveFragment
);

export type DetectorReportRuleFragmentFragment = { __typename?: 'DetectorReportRule', id: string, name: string, template: DetectorReportTemplate, enabled: boolean, reportTemplateName: string, config: { __typename?: 'DetectorReportRuleConfig', settings: any, query?: string | null } };

export type DetectorVehicleAxleWeightChartFragmentFragment = { __typename?: 'DetectorVehicleAxleWeightChart', lane?: number | null, data?: Array<{ __typename?: 'DetectorVehicleAxleWeightChartDetail', timestamp: any, averageWeight: number, grossWeight: number, temperature: number }> | null };

export type DetectorVehicleSpeedBinReportFragmentFragment = { __typename?: 'DetectorVehicleSpeedBinReportResult', intervals?: Array<{ __typename?: 'DetectorVehicleSpeedBinReport', hour?: number | null, totalVolume?: number | null, speedAt85Percent?: number | null, averageSpeed?: number | null, speedStandardDeviation?: number | null, speedBinInfo?: any | null }> | null };

export type DetectorTurningReportFragmentFragment = { __typename?: 'DetectorTurningReport', classNames: Array<string>, data: Array<{ __typename?: 'DetectorTurningReportOriginData', name: string, inwardCount: number, outwardCount: number, totalCount: number, data: Array<{ __typename?: 'DetectorTurningReportDestinationData', name: string, isInwardTotal: boolean, isOutwardTotal: boolean, total: number, data: Array<{ __typename?: 'DetectorClassIntervalCount', date: string, hour: number, minute: number, total: number, isHourlyTotal: boolean, isDailyTotal: boolean, classCounts: any }> }> }> };

export type DetectorPerformanceReportDayWiseAvailabilityDetailInfoFragmentFragment = { __typename?: 'DetectorPerformanceReportDayWiseAvailabilityDetailInfo', date?: string | null, rule?: { __typename?: 'DetectorReportRule', id: string, name: string, template: DetectorReportTemplate } | null, detector?: { __typename?: 'Detector', id: string, name: string } | null };

export type SetAlarmAcknowledgeStateMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  acknowledge?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetAlarmAcknowledgeStateMutation = { __typename?: 'Mutation', setAlarmAcknowledgeState?: Array<(
    { __typename?: 'DetectorAlarm' }
    & DetectorAlarmListNodeFragmentFragment
  )> | null };

export type ClearDetectorAlarmsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ClearDetectorAlarmsMutation = { __typename?: 'Mutation', clearDetectorAlarms?: Array<(
    { __typename?: 'DetectorAlarm' }
    & DetectorAlarmListNodeFragmentFragment
  )> | null };

export type ClearAllDetectorAlarmsMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearAllDetectorAlarmsMutation = { __typename?: 'Mutation', clearAllDetectorAlarms?: boolean | null };

export type SaveDetectorEmailAlertSettingMutationVariables = Exact<{
  input?: InputMaybe<DetectorEmailAlertSettingInput>;
}>;


export type SaveDetectorEmailAlertSettingMutation = { __typename?: 'Mutation', saveDetectorEmailAlertSetting?: (
    { __typename?: 'DetectorEmailAlertSetting' }
    & DetectorEmailAlertSettingFragmentFragment
  ) | null };

export type UpdateDetectorEmailAlertSettingStatusMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateDetectorEmailAlertSettingStatusMutation = { __typename?: 'Mutation', updateDetectorEmailAlertSettingStatus?: boolean | null };

export type ImportDetectorVehiclesDataMutationVariables = Exact<{
  id: Scalars['String'];
  dateFormat: Scalars['String'];
  fileIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ImportDetectorVehiclesDataMutation = { __typename?: 'Mutation', importDetectorVehiclesData?: string | null };

export type DeleteDetectorEmailAlertSettingMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DeleteDetectorEmailAlertSettingMutation = { __typename?: 'Mutation', deleteDetectorEmailAlertSetting?: boolean | null };

export type GenerateDetectorTmasReportMutationVariables = Exact<{
  input?: InputMaybe<DetectorTmasReportQuery>;
}>;


export type GenerateDetectorTmasReportMutation = { __typename?: 'Mutation', generateDetectorTMASReport?: (
    { __typename?: 'DetectorTMASReport' }
    & DetectorTmasReportFragmentFragment
  ) | null };

export type UpdateDetectorVehicleAiClassNameMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  className?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDetectorVehicleAiClassNameMutation = { __typename?: 'Mutation', updateDetectorVehicleAIClassName?: boolean | null };

export type UpdateDetectorVehicleAiVerificationStatusMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateDetectorVehicleAiVerificationStatusMutation = { __typename?: 'Mutation', updateDetectorVehicleAIVerificationStatus?: boolean | null };

export type UpdateDetectorVehicleVerifiedClassNameMutationVariables = Exact<{
  id: Scalars['String'];
  classIndex: Scalars['Int'];
}>;


export type UpdateDetectorVehicleVerifiedClassNameMutation = { __typename?: 'Mutation', updateDetectorVehicleVerifiedClassName?: (
    { __typename?: 'DetectorVehicle' }
    & DetectorVehicleListNodeFragmentFragment
  ) | null };

export type UpdateDetectorVehicleVerifiedClassNameStatusMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateDetectorVehicleVerifiedClassNameStatusMutation = { __typename?: 'Mutation', updateDetectorVehicleVerifiedClassNameStatus?: boolean | null };

export type SaveDetectorReportConfigurationMutationVariables = Exact<{
  input?: InputMaybe<DetectorReportConfigurationInput>;
}>;


export type SaveDetectorReportConfigurationMutation = { __typename?: 'Mutation', saveDetectorReportConfiguration?: (
    { __typename?: 'DetectorReportConfiguration' }
    & DetectorReportConfigurationFragmentFragment
  ) | null };

export type DeleteDetectorReportConfigurationMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  forceDelete?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteDetectorReportConfigurationMutation = { __typename?: 'Mutation', deleteDetectorReportConfiguration?: boolean | null };

export type DeleteDetectorReportRuleMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  forceDelete?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteDetectorReportRuleMutation = { __typename?: 'Mutation', deleteDetectorReportRule?: boolean | null };

export type SaveDetectorReportRuleMutationVariables = Exact<{
  input?: InputMaybe<DetectorReportRuleInput>;
}>;


export type SaveDetectorReportRuleMutation = { __typename?: 'Mutation', saveDetectorReportRule?: (
    { __typename?: 'DetectorReportRule' }
    & DetectorReportRuleFragmentFragment
  ) | null };

export type ResetDetectorPerformanceReportsMutationVariables = Exact<{
  ruleId: Scalars['ID'];
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDateTime: Scalars['Date'];
  endDateTime: Scalars['Date'];
}>;


export type ResetDetectorPerformanceReportsMutation = { __typename?: 'Mutation', resetDetectorPerformanceReport?: boolean | null };

export type UpdateDetectorVehicleVolumeIntervalCountsMutationVariables = Exact<{
  detectorId: Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
}>;


export type UpdateDetectorVehicleVolumeIntervalCountsMutation = { __typename?: 'Mutation', updateDetectorVehicleVolumeIntervalCounts?: boolean | null };

export type MultiplePollMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  integrationType: IntegrationType;
}>;


export type MultiplePollMutation = { __typename?: 'Mutation', multiplePoll?: Array<{ __typename?: 'JobRequest', failure?: string | null, success: boolean, requestId?: string | null, id: string }> | null };

export type DownloadBulkDailyFilesMutationVariables = Exact<{
  query?: InputMaybe<DetectorVehicleQuery>;
  unitType?: InputMaybe<ConversionUnitType>;
}>;


export type DownloadBulkDailyFilesMutation = { __typename?: 'Mutation', exportDayWisePVRDetails: boolean };

export type UpdateDefaultDetectorReportConfigurationMutationVariables = Exact<{
  id: Scalars['ID'];
  selection?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateDefaultDetectorReportConfigurationMutation = { __typename?: 'Mutation', updateDefaultDetectorReportConfiguration?: { __typename?: 'DetectorReportConfiguration', id: string, name: string, description?: string | null, ruleIds?: Array<string> | null, defaultSelection?: boolean | null } | null };

export type SaveDetectorGroupMutationVariables = Exact<{
  input: DetectorGroupInput;
}>;


export type SaveDetectorGroupMutation = { __typename?: 'Mutation', saveDetectorGroup: { __typename?: 'DetectorGroup', id: string } };

export type DeleteDetectorGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDetectorGroupMutation = { __typename?: 'Mutation', deleteDetectorGroup: boolean };

export type UpdateDetectorVehicleRecordTagsMutationVariables = Exact<{
  id: Scalars['String'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type UpdateDetectorVehicleRecordTagsMutation = { __typename?: 'Mutation', updateDetectorVehicleRecordTags?: { __typename?: 'DetectorVehicle', id: string, serial?: number | null, timestamp?: any | null, firstConnectAt?: any | null, axlesCount?: number | null, lane?: number | null, speed?: number | null, grossWeight?: number | null, tags?: Array<string | null> | null, classInfo?: { __typename: 'DetectorClass', id: string, name?: string | null, index?: number | null } | null } | null };

export type DownloadDetectorTurningReportsMutationVariables = Exact<{
  detectorId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  viewType: DateViewType;
  granularity: DetectorVehicleVolumeGranularity;
  reportPreference?: InputMaybe<ReportPreference>;
}>;


export type DownloadDetectorTurningReportsMutation = { __typename?: 'Mutation', exportTurningReport: boolean };

export type SaveCountsModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveCountsModuleSettingsMutation = { __typename?: 'Mutation', saveCountsModuleSettings?: boolean | null };

export type ExportDetectorIntersectionReportMutationVariables = Exact<{
  detectorId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  viewType: DateViewType;
  granularity: DetectorVehicleVolumeGranularity;
  reportPreference?: InputMaybe<ReportPreference>;
}>;


export type ExportDetectorIntersectionReportMutation = { __typename?: 'Mutation', exportDetectorIntersectionReport: boolean };

export type ProtocolsQueryVariables = Exact<{
  integrationType?: InputMaybe<IntegrationType>;
  integrationsFormSortField?: InputMaybe<IntegrationsFormSortField>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type ProtocolsQuery = { __typename?: 'Query', integrationForms: { __typename?: 'IntegrationsFormConnection', edges: Array<{ __typename?: 'IntegrationsFormConnectionEdge', node: { __typename?: 'IntegrationsForm', id: string, name: string, integrationType: IntegrationType } }> } };

export type DetectorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DetectorQuery = { __typename?: 'Query', detector: (
    { __typename?: 'Detector', siteImages?: Array<{ __typename?: 'File', id: string, name: string, size?: number | null, contentType?: string | null, path: string, timestamp?: any | null, module?: KineticModule | null, key?: string | null }> | null }
    & DetectorListNodeFragmentFragment
  ) };

export type DetectorsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  showDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type DetectorsQuery = { __typename?: 'Query', detectors: { __typename?: 'DetectorConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorConnectionEdge', node: (
        { __typename?: 'Detector', siteImages?: Array<{ __typename?: 'File', id: string, name: string, size?: number | null, contentType?: string | null, path: string, timestamp?: any | null, module?: KineticModule | null, key?: string | null }> | null }
        & DetectorListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorVehicleDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type DetectorVehicleDetailsQuery = { __typename?: 'Query', detectorVehicleDetail: (
    { __typename?: 'DetectorVehicle' }
    & DetectorVehicleListNodeFragmentFragment
    & DetectorVehicleDetailNodeFragmentFragment
  ) };

export type DetectorVehiclesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DetectorVehiclesSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  classNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  classIndexes?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  detectorId: Scalars['ID'];
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
}>;


export type DetectorVehiclesQuery = { __typename?: 'Query', detectorVehicles: { __typename?: 'DetectorVehicleConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorVehicleConnectionEdge', node: (
        { __typename?: 'DetectorVehicle' }
        & DetectorVehicleListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorVehiclesCountQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DetectorVehiclesSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  classNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  classIndexes?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  detectorId: Scalars['ID'];
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  reportPreference?: InputMaybe<ReportPreference>;
}>;


export type DetectorVehiclesCountQuery = { __typename?: 'Query', detectorVehiclesCount: number };

export type DetectorUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DetectorUpdatedSubscription = { __typename?: 'Subscription', detectorUpdated: (
    { __typename?: 'Detector' }
    & DetectorListNodeFragmentFragment
  ) };

export type DetectorAlarmsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DetectorAlarmsSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
}>;


export type DetectorAlarmsQuery = { __typename?: 'Query', detectorAlarms: { __typename?: 'DetectorAlarmConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorAlarmConnectionEdge', node: (
        { __typename?: 'DetectorAlarm' }
        & DetectorAlarmListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorBatteryQueryVariables = Exact<{
  detectorId: Scalars['ID'];
  granularity?: InputMaybe<DetectorBatteryGranularity>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
}>;


export type DetectorBatteryQuery = { __typename?: 'Query', detectorBattery: Array<(
    { __typename?: 'DetectorBattery' }
    & DetectorBatteryListNodeFragmentFragment
  )> };

export type DetectorActivitiesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DetectorActivitySortField>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  detectorId: Scalars['ID'];
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  level?: InputMaybe<DetectorLogLevel>;
}>;


export type DetectorActivitiesQuery = { __typename?: 'Query', detectorActivities: { __typename?: 'DetectorActivityConnection', edges: Array<{ __typename?: 'DetectorActivityConnectionEdge', node: (
        { __typename?: 'DetectorActivity' }
        & DetectorActivityListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorClassesQueryVariables = Exact<{
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DetectorClassesQuery = { __typename?: 'Query', detectorClasses?: Array<{ __typename?: 'DetectorClass', id: string, name?: string | null, index?: number | null }> | null };

export type DetectorVerificationClassQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorVerificationClassQuery = { __typename?: 'Query', detectorVerificationClass: Array<{ __typename?: 'DetectorVerificationClass', name: string, key?: string | null }> };

export type DetectorAiClassQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorAiClassQuery = { __typename?: 'Query', detectorAiClass?: Array<{ __typename?: 'DetectorAiClass', id: string, name?: string | null, description?: string | null }> | null };

export type DetectorLogLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorLogLevelsQuery = { __typename?: 'Query', detectorLogLevels?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null }> | null };

export type DetectorLogMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorLogMessagesQuery = { __typename?: 'Query', detectorLogMessages?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null }> | null };

export type DetectorLogSubtypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorLogSubtypesQuery = { __typename?: 'Query', detectorLogSubtypes?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null }> | null };

export type DetectorAlarmTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorAlarmTypesQuery = { __typename?: 'Query', detectorAlarmTypes?: Array<{ __typename?: 'DetectorAlarmType', id: string, name?: string | null }> | null };

export type DetectorAlarmGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorAlarmGroupsQuery = { __typename?: 'Query', detectorAlarmGroups?: Array<{ __typename?: 'DetectorAlarmGroup', id: string, name?: string | null }> | null };

export type DetectorMiniViewCountsQueryVariables = Exact<{
  detectorId: Scalars['ID'];
  yesterdayStartDate: Scalars['DateTime'];
  yesterdayEndDate: Scalars['DateTime'];
  lastWeekStartDate: Scalars['DateTime'];
  lastWeekEndDate: Scalars['DateTime'];
  lastMonthStartDate: Scalars['DateTime'];
  lastMonthEndDate: Scalars['DateTime'];
}>;


export type DetectorMiniViewCountsQuery = { __typename?: 'Query', yesterday: number, lastWeek: number, lastMonth: number };

export type DetectorVehiclesVolumeQueryVariables = Exact<{
  query?: InputMaybe<DetectorVehicleVolumeQuery>;
}>;


export type DetectorVehiclesVolumeQuery = { __typename?: 'Query', detectorVehicleVolume: Array<{ __typename?: 'DetectorVehicleVolumeGroupInfo', name?: string | null, volumeInfo?: Array<{ __typename?: 'DetectorVehicleVolume', volume?: number | null, timestamp?: any | null }> | null } | null> };

export type DetectorVehiclesYearlySummaryQueryVariables = Exact<{
  detectorId: Scalars['ID'];
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  viewType?: InputMaybe<DateViewType>;
}>;


export type DetectorVehiclesYearlySummaryQuery = { __typename?: 'Query', detectorVehicleYearlySummary: Array<{ __typename?: 'DetectorVehicleYearlySummary', year?: string | null, averageSpeed?: number | null, averageSpeedAt85Percent?: number | null, averageDailyTraffic?: number | null }> };

export type DetectorVehiclesVolumeGroupCountsQueryVariables = Exact<{
  detectorId: Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  groupBy?: InputMaybe<DetectorVehicleVolumeGroup>;
}>;


export type DetectorVehiclesVolumeGroupCountsQuery = { __typename?: 'Query', detectorVehicleVolumeGroupCounts: Array<{ __typename?: 'DetectorVehicleVolumeCount', name?: string | null, count?: number | null }> };

export type DetectorVehiclesDayWiseAvailabilityQueryVariables = Exact<{
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
}>;


export type DetectorVehiclesDayWiseAvailabilityQuery = { __typename?: 'Query', detectorVehicleDayWiseAvailability: Array<{ __typename?: 'DetectorVehicleDayWiseAvailability', id?: string | null, availability?: DetectorRecordAvailability | null }> };

export type DetectorVehicleDayWisePartialDataQueryVariables = Exact<{
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
}>;


export type DetectorVehicleDayWisePartialDataQuery = { __typename?: 'Query', detectorVehicleDayWisePartialData: Array<{ __typename: 'DetectorVehicleDayWisePartialData', packetLossDate?: string | null, totalMissingRecordCount?: number | null, packetLossInfo: Array<{ __typename?: 'DetectorVehiclePartialData', packetLossStartTime?: any | null, packetLossEndTime?: any | null, startSerial?: number | null, endSerial?: number | null, missingRecordsCount?: number | null }> }> };

export type DetectorVehiclesVolumeIntervalCountsQueryVariables = Exact<{
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  dateRanges: Array<DateRangeInput> | DateRangeInput;
  groupBy?: InputMaybe<DetectorVehicleVolumeGroup>;
  viewType: DateViewType;
  granularity?: InputMaybe<DetectorVehicleVolumeGranularity>;
}>;


export type DetectorVehiclesVolumeIntervalCountsQuery = { __typename?: 'Query', detectorVehicleVolumeIntervalCounts: Array<{ __typename: 'DetectorVehicleVolumeIntervalCount', date?: string | null, name?: string | null, lane?: string | null, laneDirection?: string | null, maneuver?: string | null, intervalList?: Array<{ __typename: 'DetectorVehicleVolumeIntervalInfo', count?: number | null, interval?: number | null, hour?: number | null }> | null, peaks?: { __typename: 'DetectorVolumePeaks', amPeakCount?: number | null, amPeakHour?: number | null, pmPeakCount?: number | null, pmPeakHour?: number | null, daytimeTotal?: number | null, daytimeAverage?: number | null, nightTimeTotal?: number | null, nightTimeAverage?: number | null, average?: number | null, total?: number | null, weekdayTotal?: number | null, weekdayAverage?: number | null, weekendTotal?: number | null, weekendAverage?: number | null, twelveHourTotal?: number | null, twelveHourAverage?: number | null } | null }> };

export type DetectorsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorsSummaryQuery = { __typename?: 'Query', operational: { __typename?: 'DetectorConnection', totalCount: number }, nonoperational: { __typename?: 'DetectorConnection', totalCount: number }, warning: { __typename?: 'DetectorConnection', totalCount: number }, disabled: { __typename?: 'DetectorConnection', totalCount: number } };

export type DetectorConnectionLogsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  detectorId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
}>;


export type DetectorConnectionLogsQuery = { __typename?: 'Query', detectorConnectionLogs: { __typename?: 'DetectorConnectionLogConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorConnectionLogConnectionEdge', node: (
        { __typename?: 'DetectorConnectionGroup' }
        & DetectorConnectionLogListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorConnectionLogDetailQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  connectionId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
}>;


export type DetectorConnectionLogDetailQuery = { __typename?: 'Query', detectorConnectionLogDetails: { __typename?: 'DetectorConnectionLogDetailsConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorConnectionLogDetailsConnectionEdge', node: (
        { __typename?: 'DetectorConnectionLog' }
        & DetectorConnectionLogFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorWeatherQueryQueryVariables = Exact<{
  detectorId: Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
}>;


export type DetectorWeatherQueryQuery = { __typename?: 'Query', detectorWeather: Array<(
    { __typename?: 'DetectorWeather' }
    & DetectorWeatherListNodeFragmentFragment
  )> };

export type DetectorEmailAlertTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorEmailAlertTypesQuery = { __typename?: 'Query', detectorEmailAlertTypes?: Array<{ __typename?: 'DetectorAlertTypeOption', code?: DetectorAlertType | null, label: string }> | null };

export type DetectorEmailAlertSubtypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorEmailAlertSubtypesQuery = { __typename?: 'Query', detectorEmailAlertSubtypes?: Array<{ __typename?: 'DetectorAlertSubtypeOption', code?: DetectorAlertSubtype | null, label: string, type?: DetectorAlertType | null }> | null };

export type DetectorEmailAlertFrequenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorEmailAlertFrequenciesQuery = { __typename?: 'Query', detectorEmailAlertFrequencies?: Array<{ __typename?: 'DetectorAlertFrequencyOption', code?: DetectorEmailAlertFrequency | null, label: string, types?: Array<DetectorAlertType> | null }> | null };

export type DetectorEmailAlertSettingsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type DetectorEmailAlertSettingsQuery = { __typename?: 'Query', detectorEmailAlertSettings: { __typename?: 'DetectorEmailAlertSettingConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorEmailAlertSettingConnectionEdge', node: (
        { __typename?: 'DetectorEmailAlertSetting' }
        & DetectorEmailAlertSettingFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorEmailAlertSettingDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type DetectorEmailAlertSettingDetailQuery = { __typename?: 'Query', detectorEmailAlertSetting?: (
    { __typename?: 'DetectorEmailAlertSetting' }
    & DetectorEmailAlertSettingFragmentFragment
  ) | null };

export type GetUserWithPrivilegesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetUserWithPrivilegesQuery = { __typename?: 'Query', users: { __typename?: 'KineticUserConnection', edges: Array<{ __typename?: 'KineticUserConnectionEdge', node: (
        { __typename?: 'OrganizationKineticUser' }
        & KineticUserFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorPerformanceReportsQueryVariables = Exact<{
  ruleId: Scalars['ID'];
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDateTime: Scalars['Date'];
  endDateTime: Scalars['Date'];
}>;


export type DetectorPerformanceReportsQuery = { __typename?: 'Query', detectorPerformanceReport: Array<(
    { __typename?: 'DetectorPerformanceReportResult' }
    & DetectorPerformanceReportResultFragmentFragment
  )> };

export type DetectorReportConfigurationQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type DetectorReportConfigurationQuery = { __typename?: 'Query', detectorReportConfigurations: { __typename?: 'DetectorReportConfigurationConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorReportConfigurationConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'DetectorReportConfiguration' }
        & DetectorReportConfigurationFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorReportRulesQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  template?: InputMaybe<DetectorReportTemplate>;
}>;


export type DetectorReportRulesQuery = { __typename?: 'Query', detectorReportRules: { __typename?: 'DetectorReportRuleConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorReportRuleConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'DetectorReportRule' }
        & DetectorReportRuleFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorPerformanceReportAvailabilitysQueryVariables = Exact<{
  ruleIds: Array<Scalars['ID']> | Scalars['ID'];
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDateTime: Scalars['Date'];
  endDateTime: Scalars['Date'];
}>;


export type DetectorPerformanceReportAvailabilitysQuery = { __typename?: 'Query', detectorPerformanceReportAvailability: Array<(
    { __typename?: 'DetectorPerformanceReportDayWiseAvailabilityInfo' }
    & DetectorPerformanceReportDayWiseAvailabilityInfoFragmentFragment
  )> };

export type DetectorReportConfigurationDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DetectorReportConfigurationDetailQuery = { __typename?: 'Query', detectorReportConfiguration?: (
    { __typename?: 'DetectorReportConfiguration' }
    & DetectorReportConfigurationFragmentFragment
  ) | null };

export type DetectorReportTemplateOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorReportTemplateOptionsQuery = { __typename?: 'Query', detectorReportTemplateOptions: Array<{ __typename?: 'DetectorReportTemplateOption', code?: DetectorReportTemplate | null, label?: string | null }> };

export type DetectorReportFormQueryVariables = Exact<{
  reportTemplate?: InputMaybe<DetectorReportTemplate>;
}>;


export type DetectorReportFormQuery = { __typename?: 'Query', detectorReportForm?: (
    { __typename?: 'DetectorReportRuleForm' }
    & FormFragment
  ) | null };

export type DetectorReportFormQueryConfigQueryVariables = Exact<{
  reportTemplate?: InputMaybe<DetectorReportTemplate>;
}>;


export type DetectorReportFormQueryConfigQuery = { __typename?: 'Query', detectorReportFormQueryConfig?: any | null };

export type DetectorReportRuleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DetectorReportRuleQuery = { __typename?: 'Query', detectorReportRule?: (
    { __typename?: 'DetectorReportRule' }
    & DetectorReportRuleFragmentFragment
  ) | null };

export type DetectorUpdatedShortSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DetectorUpdatedShortSubscription = { __typename?: 'Subscription', detectorUpdated: { __typename?: 'Detector', id: string } };

export type DetectorVehicleAxleWeightChartWidgetQueryVariables = Exact<{
  detectorId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  granularity: DetectorVehicleVolumeGranularity;
  classIndex: Scalars['Int'];
}>;


export type DetectorVehicleAxleWeightChartWidgetQuery = { __typename?: 'Query', detectorVehicleAxleWeightChart: Array<(
    { __typename?: 'DetectorVehicleAxleWeightChart' }
    & DetectorVehicleAxleWeightChartFragmentFragment
  )> };

export type DetectorSpeedReportBinsQueryVariables = Exact<{
  detectorId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  lane?: InputMaybe<Scalars['Int']>;
  laneDirection?: InputMaybe<Direction>;
}>;


export type DetectorSpeedReportBinsQuery = { __typename?: 'Query', detectorVehicleSpeedReport?: (
    { __typename?: 'DetectorVehicleSpeedBinReportResult' }
    & DetectorVehicleSpeedBinReportFragmentFragment
  ) | null };

export type DetectorVolumeSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DetectorVolumeSubscription = { __typename?: 'Subscription', detectorVehicleVolumeCountsUpdated?: boolean | null };

export type CountsActivityLogAddedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  module?: InputMaybe<KineticModule>;
}>;


export type CountsActivityLogAddedSubscription = { __typename?: 'Subscription', addedActivityLog: (
    { __typename?: 'ActivityLog' }
    & ActivityLogNodeFragmentFragment
  ) };

export type DetectorTurningReportsQueryVariables = Exact<{
  detectorId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  viewType: DateViewType;
  granularity: DetectorVehicleVolumeGranularity;
}>;


export type DetectorTurningReportsQuery = { __typename?: 'Query', detectorTurningReport: (
    { __typename?: 'DetectorTurningReport' }
    & DetectorTurningReportFragmentFragment
  ) };

export type DetectorGroupsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type DetectorGroupsQuery = { __typename?: 'Query', detectorGroups: { __typename?: 'DetectorGroupConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorGroupConnectionEdge', node: { __typename?: 'DetectorGroup', id: string, name: string, description?: string | null, detectorIds: Array<string>, enabled: boolean } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DetectorGroupQuery = { __typename?: 'Query', detectorGroup?: { __typename?: 'DetectorGroup', id: string, name: string, description?: string | null, detectorIds: Array<string>, enabled: boolean } | null };

export type DetectorClassConfigurationQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type DetectorClassConfigurationQuery = { __typename?: 'Query', detectorClassConfiguration?: Array<{ __typename?: 'DetectorClass', id: string, name?: string | null, index?: number | null }> | null };

export type DetectorMapEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectorMapEntitiesQuery = { __typename?: 'Query', detectorMapEntities: Array<any> };

export type DetectorsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type DetectorsListQuery = { __typename?: 'Query', detectors: { __typename?: 'DetectorConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorConnectionEdge', node: (
        { __typename?: 'Detector' }
        & DetectorFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorListUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DetectorListUpdatedSubscription = { __typename?: 'Subscription', detectorUpdated: (
    { __typename?: 'Detector' }
    & DetectorFragment
  ) };

export type DetectorPerformanceReportAvailabilityDetailsQueryVariables = Exact<{
  ruleIds: Array<Scalars['ID']> | Scalars['ID'];
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDateTime: Scalars['Date'];
  endDateTime: Scalars['Date'];
}>;


export type DetectorPerformanceReportAvailabilityDetailsQuery = { __typename?: 'Query', detectorPerformanceReportAvailabilityDetails: Array<(
    { __typename?: 'DetectorPerformanceReportDayWiseAvailabilityDetailInfo' }
    & DetectorPerformanceReportDayWiseAvailabilityDetailInfoFragmentFragment
  )> };

export type DetectorVehicleAxlesCountReportQueryVariables = Exact<{
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  viewType: DateViewType;
  classGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  className?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  lane?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  laneDirection?: InputMaybe<Array<InputMaybe<Direction>> | InputMaybe<Direction>>;
}>;


export type DetectorVehicleAxlesCountReportQuery = { __typename?: 'Query', detectorVehicleAxlesCountReport?: Array<{ __typename?: 'VehicleAxlesCountReportResult', date?: any | null, axlesCountBinInfo: any, minAxleNumber: number, maxAxleNumber: number } | null> | null };

export type DetectorVehicleGrossWeightReportQueryVariables = Exact<{
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  viewType: DateViewType;
  classGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  unitPreference: ConversionUnitType;
  className?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  lane?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  laneDirection?: InputMaybe<Array<InputMaybe<Direction>> | InputMaybe<Direction>>;
  detectorGrossWeightBandResolution?: InputMaybe<Scalars['Int']>;
}>;


export type DetectorVehicleGrossWeightReportQuery = { __typename?: 'Query', detectorVehicleGrossWeightReport?: Array<{ __typename?: 'VehicleGrossWeightReportResult', date?: any | null, weightBinInfo: any, minGrossWeight: number, maxGrossWeight: number } | null> | null };

export type DetectorVehicleAxleWeightReportQueryVariables = Exact<{
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  viewType: DateViewType;
  classGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  unitPreference: ConversionUnitType;
  className?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  lane?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  laneDirection?: InputMaybe<Array<InputMaybe<Direction>> | InputMaybe<Direction>>;
  detectorAxleWeightBandResolution?: InputMaybe<Scalars['Float']>;
  types?: InputMaybe<Array<DetectorAxleType> | DetectorAxleType>;
}>;


export type DetectorVehicleAxleWeightReportQuery = { __typename?: 'Query', detectorVehicleAxleWeightReport?: Array<{ __typename?: 'VehicleAxleWeightReportResult', date?: any | null, weightBinInfo: any, minAxleWeight: number, maxAxleWeight: number } | null> | null };

export type DetectorWimMeanGrossWeightReportQueryVariables = Exact<{
  detectorIds: Array<Scalars['ID']> | Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  viewType: DateViewType;
  classGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  unitPreference: ConversionUnitType;
  className?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  lane?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  laneDirection?: InputMaybe<Array<InputMaybe<Direction>> | InputMaybe<Direction>>;
}>;


export type DetectorWimMeanGrossWeightReportQuery = { __typename?: 'Query', detectorWimMeanGrossWeightReport: { __typename?: 'DetectorMeanGrossWeightReportResult', columns: Array<string>, rows: Array<any> } };

export type CountsModuleSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountsModuleSettingsQuery = { __typename?: 'Query', countsModuleSettings: { __typename: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename: 'ModuleFormSection', name: string, id: string, fields: Array<{ __typename: 'FieldConfig', id: string, name: string, label: string, type: string, required?: boolean | null, hint?: string | null, sourceId?: string | null, defaultValue?: any | null, loading?: boolean | null, showInput?: boolean | null, step?: number | null, max?: number | null, min?: number | null, useStepper?: boolean | null, options?: Array<{ __typename: 'FieldConfigOption', label?: string | null, value?: any | null } | null> | null } | null> }> } };

export type CountsAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountsAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string, displayName: string } }> } };

export type EmailNotificationsHistoryListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type EmailNotificationsHistoryListQuery = { __typename?: 'Query', emailHistory: { __typename?: 'EmailNotificationConnection', totalCount: number, edges: Array<{ __typename?: 'EmailNotificationConnectionEdge', node: { __typename?: 'EmailNotification', id: string, sentAt: any, sentStatus: boolean, type?: string | null, subject?: string | null, module?: KineticModule | null } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EmailNotificationsHistoryItemQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type EmailNotificationsHistoryItemQuery = { __typename?: 'Query', emailHistory: { __typename?: 'EmailNotificationConnection', totalCount: number, edges: Array<{ __typename?: 'EmailNotificationConnectionEdge', node: { __typename?: 'EmailNotification', id: string, sentAt: any, sentStatus: boolean, type?: string | null, subject?: string | null, body?: string | null, toRecipients?: string | null, ccRecipients?: string | null, bccRecipients?: string | null, lastViewedAt?: any | null, module?: KineticModule | null, data?: any | null } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type RecipientFragmentFragment = { __typename?: 'RecipientDto', recipientId?: string | null, name?: string | null, label?: LabelType | null, email?: string | null, smsRecipient: boolean, type: RecipientType, workNumber?: string | null };

export type EmailRuleListFragment = { __typename?: 'EmailRuleDto', id: string, name: string, description?: string | null, module?: KineticModule | null, active: boolean, executive: boolean, templates: Array<{ __typename?: 'EmailTemplateDto', id: string, name: string }> };

export type EmailRuleDetailsFragmentFragment = { __typename?: 'EmailRuleDto', id: string, name: string, description?: string | null, module?: KineticModule | null, formId?: string | null, active: boolean, rule?: string | null, executive: boolean, config?: any | null, recurrenceEndDate?: any | null, start?: any | null, end?: any | null, rrule?: string | null, templates: Array<{ __typename?: 'EmailTemplateDto', id: string, module: KineticModule, name: string, type: TemplateType, subject?: string | null, body: string }>, recipients?: Array<(
    { __typename?: 'RecipientDto' }
    & RecipientFragmentFragment
  ) | null> | null, automationSettings?: { __typename?: 'EmailRuleAutomationSettingsDto', onEventCreated?: boolean | null, onEventUpdated?: boolean | null, onEventClosed?: boolean | null } | null };

export type EmailTemplateListNodeFragmentFragment = { __typename?: 'EmailTemplateDto', id: string, name: string, type: TemplateType, form?: string | null, module: KineticModule, subject?: string | null, body: string };

export type DeleteEmailTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEmailTemplateMutation = { __typename?: 'Mutation', deleteEmailTemplate?: boolean | null };

export type DeleteEmailsTemplateListMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteEmailsTemplateListMutation = { __typename?: 'Mutation', deleteEmailTemplateList?: boolean | null };

export type SaveEmailTemplateMutationVariables = Exact<{
  template: EmailTemplateInput;
}>;


export type SaveEmailTemplateMutation = { __typename?: 'Mutation', saveEmailTemplate?: (
    { __typename?: 'EmailTemplateDto' }
    & EmailTemplateListNodeFragmentFragment
  ) | null };

export type SaveEmailRuleMutationVariables = Exact<{
  emailRule: EmailRuleInput;
}>;


export type SaveEmailRuleMutation = { __typename?: 'Mutation', saveEmailRule?: (
    { __typename?: 'EmailRuleDto' }
    & EmailRuleDetailsFragmentFragment
  ) | null };

export type DeleteEmailRuleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEmailRuleMutation = { __typename?: 'Mutation', deleteEmailRule?: boolean | null };

export type DeleteEmailRulesListMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteEmailRulesListMutation = { __typename?: 'Mutation', deleteEmailRulesList?: boolean | null };

export type RuleActivityLogsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  filters: Array<FilterInput> | FilterInput;
}>;


export type RuleActivityLogsQuery = { __typename?: 'Query', activityLogs: { __typename?: 'ActivityLogConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ActivityLogEdge', node: (
        { __typename?: 'ActivityLog' }
        & ActivityLogNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EmailRuleActivityLogAddedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  module?: InputMaybe<KineticModule>;
}>;


export type EmailRuleActivityLogAddedSubscription = { __typename?: 'Subscription', addedActivityLog: (
    { __typename?: 'ActivityLog' }
    & ActivityLogNodeFragmentFragment
  ) };

export type EmailsRulesListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type EmailsRulesListQuery = { __typename?: 'Query', emailsRule: { __typename?: 'EmailRuleConnection', totalCount: number, edges: Array<{ __typename?: 'EmailRuleConnectionEdge', node: (
        { __typename?: 'EmailRuleDto' }
        & EmailRuleListFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EmailRuleDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmailRuleDetailsQuery = { __typename?: 'Query', emailRule: (
    { __typename?: 'EmailRuleDto' }
    & EmailRuleDetailsFragmentFragment
  ) };

export type EmailRuleUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type EmailRuleUpdatedSubscription = { __typename?: 'Subscription', emailRuleUpdated?: (
    { __typename?: 'EmailRuleDto' }
    & EmailRuleDetailsFragmentFragment
  ) | null };

export type EmailKineticFormsQueryVariables = Exact<{
  query: KineticFormInputQuery;
}>;


export type EmailKineticFormsQuery = { __typename?: 'Query', kineticForms: { __typename?: 'KineticFormConnection', totalCount: number, edges: Array<{ __typename?: 'KineticFormConnectionEdge', node: (
        { __typename?: 'KineticForm' }
        & KineticFormFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type KineticFormQueryConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type KineticFormQueryConfigQuery = { __typename?: 'Query', kineticFormQueryConfig: any };

export type EmailsTemplateListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type EmailsTemplateListQuery = { __typename?: 'Query', emailsTemplate: { __typename?: 'EmailTemplateConnection', totalCount: number, edges: Array<{ __typename?: 'EmailTemplateConnectionEdge', node: (
        { __typename?: 'EmailTemplateDto' }
        & EmailTemplateListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EmailTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmailTemplateQuery = { __typename?: 'Query', emailTemplate: (
    { __typename?: 'EmailTemplateDto' }
    & EmailTemplateListNodeFragmentFragment
  ) };

export type EmailTemplateUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type EmailTemplateUpdatedSubscription = { __typename?: 'Subscription', emailTemplateUpdated?: { __typename?: 'EmailTemplateDto', id: string } | null };

export type GetSignalAlarmPreviewAlarmsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSignalAlarmPreviewAlarmsQuery = { __typename?: 'Query', alarms: { __typename?: 'AlarmConnection', edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', data?: any | null, ID: string, ALARM_NAME: string, ALARM_SEVERITY: AlarmSeverity, ALARM_SOURCE: KineticModule, RECEIVED_AT?: any | null, ACTIVE_AT?: any | null, CLEARED_AT?: any | null, UPDATED_AT: any, ACTIVE: boolean, COUNT: number, ACKNOWLEDGED: boolean, ACKNOWLEDGED_AT?: any | null, COMMENTS?: string | null, ENTITY_TYPE: AlarmEntityType, ENTITY_ID: string, ALARM_DISPLAY_NAME?: string | null } }> } };

export type GetGatesAlarmPreviewAlarmsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGatesAlarmPreviewAlarmsQuery = { __typename?: 'Query', alarms: { __typename?: 'AlarmConnection', edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', data?: any | null, ID: string, ALARM_NAME: string, ALARM_SEVERITY: AlarmSeverity, ALARM_SOURCE: KineticModule, RECEIVED_AT?: any | null, ACTIVE_AT?: any | null, CLEARED_AT?: any | null, UPDATED_AT: any, ACTIVE: boolean, COUNT: number, ACKNOWLEDGED: boolean, ACKNOWLEDGED_AT?: any | null, COMMENTS?: string | null, ENTITY_TYPE: AlarmEntityType, ENTITY_ID: string } }> } };

export type GetSignsAlarmPreviewAlarmsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSignsAlarmPreviewAlarmsQuery = { __typename?: 'Query', alarms: { __typename?: 'AlarmConnection', edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', data?: any | null, ID: string, ALARM_NAME: string, ALARM_SEVERITY: AlarmSeverity, ALARM_SOURCE: KineticModule, RECEIVED_AT?: any | null, ACTIVE_AT?: any | null, CLEARED_AT?: any | null, UPDATED_AT: any, ACTIVE: boolean, COUNT: number, ACKNOWLEDGED: boolean, ACKNOWLEDGED_AT?: any | null, COMMENTS?: string | null, ENTITY_TYPE: AlarmEntityType, ENTITY_ID: string } }> } };

export type GetTravelTimeAlarmPreviewAlarmsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTravelTimeAlarmPreviewAlarmsQuery = { __typename?: 'Query', alarms: { __typename?: 'AlarmConnection', edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', data?: any | null, ID: string, ALARM_NAME: string, ALARM_SEVERITY: AlarmSeverity, ALARM_SOURCE: KineticModule, RECEIVED_AT?: any | null, ACTIVE_AT?: any | null, CLEARED_AT?: any | null, UPDATED_AT: any, ACTIVE: boolean, COUNT: number, ACKNOWLEDGED: boolean, ACKNOWLEDGED_AT?: any | null, COMMENTS?: string | null, ENTITY_TYPE: AlarmEntityType, ENTITY_ID: string } }> } };

export type GetVideoAlarmPreviewAlarmsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVideoAlarmPreviewAlarmsQuery = { __typename?: 'Query', alarms: { __typename?: 'AlarmConnection', edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', data?: any | null, ID: string, ALARM_NAME: string, ALARM_SEVERITY: AlarmSeverity, ALARM_SOURCE: KineticModule, RECEIVED_AT?: any | null, ACTIVE_AT?: any | null, CLEARED_AT?: any | null, UPDATED_AT: any, ACTIVE: boolean, COUNT: number, ACKNOWLEDGED: boolean, ACKNOWLEDGED_AT?: any | null, COMMENTS?: string | null, ENTITY_TYPE: AlarmEntityType, ENTITY_ID: string } }> } };

export type GetTollingAlarmPreviewAlarmsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTollingAlarmPreviewAlarmsQuery = { __typename?: 'Query', alarms: { __typename?: 'AlarmConnection', edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', data?: any | null, ID: string, ALARM_NAME: string, ALARM_SEVERITY: AlarmSeverity, ALARM_SOURCE: KineticModule, RECEIVED_AT?: any | null, ACTIVE_AT?: any | null, CLEARED_AT?: any | null, UPDATED_AT: any, ACTIVE: boolean, COUNT: number, ACKNOWLEDGED: boolean, ACKNOWLEDGED_AT?: any | null, COMMENTS?: string | null, ENTITY_TYPE: AlarmEntityType, ENTITY_ID: string } }> } };

export type JobResultFragment = { __typename?: 'JobResult', requestId?: string | null, success: boolean, failure?: string | null, id: string };

export type EventTypeFragment = { __typename?: 'EventType', detectionCodes: Array<string>, description?: string | null, category: EventCategory, name: string, id: string };

export type EventTypeShortFragment = { __typename?: 'EventType', name: string, id: string };

export type EventLinkFragment = { __typename?: 'EventLink', comment?: string | null, name?: string | null, type: EventLinkType, id: string };

export type EventMapFragment = { __typename?: 'Event', lastUpdated: any, attributes: any, geometry: any, category: EventCategory, created: any, status: EventStatus, type: string, name: string, id: string, lanes: Array<(
    { __typename?: 'EventLane' }
    & EventLaneFragment
  )> };

export type EventListFragment = { __typename?: 'Event', geometry: any, lastUpdated: any, lastUpdatedBy?: string | null, externalCenter?: string | null, attributes: any, category: EventCategory, created: any, createdBy?: string | null, start?: any | null, end?: any | null, status: EventStatus, type: string, name: string, id: string, shortId?: string | null, floodgate?: boolean | null, fiveOneOneMessage: { __typename?: 'FiveOneOneMessage', suppressed?: boolean | null } };

export type EventLaneFragment = { __typename?: 'EventLane', closedTime?: any | null, openTime?: any | null, roadwayType: RoadwayType, laneStatus: LaneStatus, engineeringLane: number, direction: Direction, laneType: LaneType, lineType: string, id: string };

export type AlertFragment = { __typename?: 'Alert', alertId: string, type?: string | null, description?: string | null, source?: AlertSource | null, location?: any | null, updateTime?: any | null, confidence?: number | null, severity?: Severity | null, details?: any | null, evidence?: { __typename?: 'AlertEvidence', fileId?: string | null, status?: AlertEvidenceStatus | null, type?: AlertEvidenceType | null } | null };

export type DetectionFragment = { __typename?: 'Detection', id: string, alertId?: string | null, type?: string | null, description?: string | null, status: Status, location?: any | null, confidence?: number | null, severity?: Severity | null, created: any, lastUpdated: any, sources: Array<AlertSource | null>, associatedEventIds?: Array<string> | null, examined?: boolean | null, sourceNames?: Array<{ __typename?: 'AlertSourceName', source?: AlertSource | null, names?: Array<string | null> | null } | null> | null, alertStates: Array<{ __typename?: 'AlertState', alertId?: string | null, alertStatus?: Status | null } | null>, alerts: Array<(
    { __typename?: 'Alert' }
    & AlertFragment
  ) | null> };

export type DetectionListItemFragment = { __typename?: 'Detection', id: string, alertId?: string | null, type?: string | null, typeId?: string | null, description?: string | null, status: Status, location?: any | null, confidence?: number | null, severity?: Severity | null, created: any, lastUpdated: any, sources: Array<AlertSource | null>, associatedEventIds?: Array<string> | null, examined?: boolean | null, sourceNames?: Array<{ __typename?: 'AlertSourceName', source?: AlertSource | null, names?: Array<string | null> | null } | null> | null };

export type EventContactFragment = { __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, workNumber?: string | null, cellNumber?: string | null, faxNumber?: string | null, homeNumber?: string | null, pagerNumber?: string | null, otherNumber?: string | null, publicMode?: boolean | null };

export type CommunicationLogEventFragment = { __typename?: 'CommunicationLog', id: string, reported?: any | null, reason?: string | null, detailsType?: string | null, impactedGroup?: string | null, discussion?: string | null, attributes: any, contact?: { __typename?: 'CommunicationLogContact', firstName: string, lastName: string } | null };

export type ContactFragment = { __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, workNumber?: string | null, cellNumber?: string | null, faxNumber?: string | null, homeNumber?: string | null, pagerNumber?: string | null, otherNumber?: string | null, publicMode?: boolean | null };

export type EventFragment = { __typename?: 'Event', id: string, shortId?: string | null, name: string, floodgate?: boolean | null, category: EventCategory, external: boolean, type: string, status: EventStatus, attributes: any, geometry: any, labels: Array<string>, start?: any | null, end?: any | null, created: any, lastUpdated: any, sceneClear?: any | null, lastUpdatedBy?: string | null, lastUpdatedByDisplayName?: string | null, createdBy?: string | null, activationType?: ActivationType | null, confirmationRequired?: boolean | null, notes: Array<{ __typename?: 'EventNote', timestamp: any, user: string, note: string }>, lanes: Array<(
    { __typename?: 'EventLane' }
    & EventLaneFragment
  )>, form: (
    { __typename?: 'KineticForm' }
    & KineticFormFragment
  ), links: Array<(
    { __typename?: 'EventLink' }
    & EventLinkFragment
  )>, contacts: Array<(
    { __typename?: 'Contact' }
    & ContactFragment
  )>, associatedCommunicationLogs: Array<(
    { __typename?: 'CommunicationLog' }
    & CommunicationLogEventFragment
  )>, associatedDetections: Array<(
    { __typename?: 'Detection' }
    & DetectionFragment
  )>, fiveOneOneMessage: { __typename?: 'FiveOneOneMessage', suppressed?: boolean | null }, fleetDispatches?: Array<{ __typename?: 'FleetDispatch', id: string, event: string, status: FleetDispatchStatus, timeRequested: any, timeResponded?: any | null, timeDeparted?: any | null, timeOnScene?: any | null, dispatchingUsername: string, dispatchingUser: string, rejectionReason?: string | null, shift: string, firstName: string, lastName: string, username: string, driver: string, phone?: string | null, email?: string | null, responseTime?: number | null, formatResponseTime?: string | null }> | null };

export type TemplateEventFragment = { __typename?: 'Event', id: string, name: string, floodgate?: boolean | null, category: EventCategory, type: string, status: EventStatus, attributes: any, geometry: any, labels: Array<string>, start?: any | null, end?: any | null, created: any, lastUpdated: any, sceneClear?: any | null, lastUpdatedBy?: string | null, createdBy?: string | null, activationType?: ActivationType | null, confirmationRequired?: boolean | null, notes: Array<{ __typename?: 'EventNote', timestamp: any, user: string, note: string }>, lanes: Array<(
    { __typename?: 'EventLane' }
    & EventLaneFragment
  )>, form: (
    { __typename?: 'KineticForm' }
    & KineticFormFragment
  ), links: Array<(
    { __typename?: 'EventLink' }
    & EventLinkFragment
  )> };

export type EventFragmentFragment = { __typename?: 'Event', id: string, shortId?: string | null, name: string, category: EventCategory, floodgate?: boolean | null, type: string, status: EventStatus, attributes: any, geometry: any, start?: any | null, end?: any | null, created: any, lastUpdated: any, sceneClear?: any | null, lastUpdatedBy?: string | null, createdBy?: string | null, labels: Array<string>, lanes: Array<(
    { __typename?: 'EventLane' }
    & EventLaneFragment
  )>, form: (
    { __typename?: 'KineticForm' }
    & KineticFormFragmentFragment
  ), links: Array<(
    { __typename?: 'EventLink' }
    & EventLinkFragment
  )>, notes: Array<{ __typename?: 'EventNote', timestamp: any, user: string, note: string }>, associatedCommunicationLogs: Array<(
    { __typename?: 'CommunicationLog' }
    & CommunicationLogEventFragment
  )>, contacts: Array<(
    { __typename?: 'Contact' }
    & EventContactFragment
  )>, associatedDetections: Array<(
    { __typename?: 'Detection' }
    & DetectionFragment
  )>, fiveOneOneMessage: { __typename?: 'FiveOneOneMessage', suppressed?: boolean | null } };

export type EventDetailsFragment = { __typename?: 'Event', lastUpdated: any, category: EventCategory, created: any, name: string, id: string };

export type ResourceFragment = { __typename?: 'Resource', status: ResourceStatus, type: ResourceType, data: any, id: string, adhoc?: boolean | null, acknowledged?: boolean | null };

export type ResourcePlanDetailsFragment = { __typename?: 'ResourcePlanDetails', description?: string | null, settings?: any | null, status: ResourceStatus, name: string, approved?: boolean | null, approver?: string | null };

export type ResourcePlanFragment = { __typename?: 'ResourcePlan', id: string, details: (
    { __typename?: 'ResourcePlanDetails' }
    & ResourcePlanDetailsFragment
  ), resources: Array<(
    { __typename?: 'Resource' }
    & ResourceFragment
  )> };

export type ResourcePlanTaskFragmentFragment = { __typename?: 'Task', taskRecurrenceType: TaskRecurrenceType, recurrenceEndDate?: any | null, taskType: TaskType, rrule?: string | null, start: any, data: any, name: string, end: any, id: string };

export type EventSignDetailFragment = { __typename?: 'Sign', locationDescription?: string | null, communicationStatus: CommunicationState, travelTimeSegments: Array<string>, lastDataReceived?: any | null, referencePoint?: number | null, capabilities: Array<SignCapability>, backgroundColor?: string | null, foregroundColor?: string | null, colorScheme?: SignColorScheme | null, laneDirection?: string | null, lanePosition?: number | null, direction?: string | null, laneType?: LaneType | null, location: any, road?: string | null, name: string, id: string, speedSettings?: (
    { __typename?: 'SignSpeedSettings' }
    & SignSpeedSettingsFragment
  ) | null, messagePreferences?: { __typename?: 'SignMessagePreferences', verticalJustification: VerticalJustification, horizontalJustification: HorizontalJustification, pageOffTime: number, pageOnTime: number, id: string } | null, displayType: { __typename?: 'SignDisplayType', maxCharacters?: number | null, defaultFont?: string | null, matrixType: SignMatrixType, maxLines?: number | null, maxPages?: number | null, height: number, width: number, hash: string, characterLabels?: Array<{ __typename?: 'SignCharacterLabel', characterIndex: number, label: string }> | null }, currentMessage?: (
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  ) | null, tests?: (
    { __typename?: 'SignTests' }
    & SignTestsTypeFragment
  ) | null };

export type ResourceSubGroupFragment = { __typename?: 'ContactGroupDto', id: string, name: string, description?: string | null, parentGroup?: string | null, items: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, workNumber?: string | null, notes?: string | null } | null> };

export type ResourceContactSubGroupRecursiveFragment = { __typename?: 'ContactGroupDto', subGroups: Array<(
    { __typename?: 'ContactGroupDto', subGroups: Array<(
      { __typename?: 'ContactGroupDto', subGroups: Array<(
        { __typename?: 'ContactGroupDto', subGroups: Array<(
          { __typename?: 'ContactGroupDto', subGroups: Array<(
            { __typename?: 'ContactGroupDto' }
            & ResourceSubGroupFragment
          ) | null> }
          & ResourceSubGroupFragment
        ) | null> }
        & ResourceSubGroupFragment
      ) | null> }
      & ResourceSubGroupFragment
    ) | null> }
    & ResourceSubGroupFragment
  ) | null> };

export type ResourceContactGroupListNodeFragmentFragment = (
  { __typename?: 'ContactGroupDto' }
  & ResourceSubGroupFragment
  & ResourceContactSubGroupRecursiveFragment
);

export type ResourcePlanActivationResultFragment = { __typename?: 'ResourcePlanActivationResult', id: string, activationId: string, resourcePlanId: string, resourceId: string, resourceName?: string | null, errorMessage?: string | null, activationStatus: ActivationStatus, resourceType: ResourceType };

export type SaveEventMutationVariables = Exact<{
  input: EventInput;
}>;


export type SaveEventMutation = { __typename?: 'Mutation', saveEvent: (
    { __typename?: 'Event' }
    & EventFragment
  ) };

export type TriggerResourcePlanRulesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TriggerResourcePlanRulesMutation = { __typename?: 'Mutation', triggerResourcePlanRules?: string | null };

export type SaveEventTypeMutationVariables = Exact<{
  input: EventTypeInput;
}>;


export type SaveEventTypeMutation = { __typename?: 'Mutation', saveEventType: (
    { __typename?: 'EventType' }
    & EventTypeFragment
  ) };

export type DeleteEventTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEventTypeMutation = { __typename?: 'Mutation', deleteEventType?: boolean | null };

export type SaveEventsModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveEventsModuleSettingsMutation = { __typename?: 'Mutation', saveEventsModuleSettings?: boolean | null };

export type SaveResponseModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveResponseModuleSettingsMutation = { __typename?: 'Mutation', saveResponseModuleSettings?: boolean | null };

export type SaveEventTemplateMutationVariables = Exact<{
  input: EventTemplateInput;
}>;


export type SaveEventTemplateMutation = { __typename?: 'Mutation', saveEventTemplate: { __typename?: 'EventTemplate', id: string } };

export type DeleteEventTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEventTemplateMutation = { __typename?: 'Mutation', deleteEventTemplate?: boolean | null };

export type SaveAndCloseEventMutationVariables = Exact<{
  input: EventInput;
  sceneClear?: InputMaybe<Scalars['DateTime']>;
  lanesClear?: InputMaybe<Scalars['DateTime']>;
  closureResolution?: InputMaybe<Scalars['String']>;
}>;


export type SaveAndCloseEventMutation = { __typename?: 'Mutation', saveAndCloseEvent?: boolean | null };

export type CancelEventTaskOccurrenceMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['DateTime'];
}>;


export type CancelEventTaskOccurrenceMutation = { __typename?: 'Mutation', cancelTaskOccurrence: boolean };

export type CloneEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CloneEventMutation = { __typename?: 'Mutation', cloneEvent: (
    { __typename?: 'Event' }
    & EventFragment
  ) };

export type CloseEventMutationVariables = Exact<{
  id: Scalars['ID'];
  sceneClear: Scalars['DateTime'];
  lanesClear: Scalars['DateTime'];
}>;


export type CloseEventMutation = { __typename?: 'Mutation', closeEvent?: boolean | null };

export type RejectEventMutationVariables = Exact<{
  id: Scalars['ID'];
  rejectionReasons: Array<Scalars['String']> | Scalars['String'];
}>;


export type RejectEventMutation = { __typename?: 'Mutation', rejectEvent?: boolean | null };

export type LinkEventMutationVariables = Exact<{
  eventId: Scalars['ID'];
  link: EventLinkInput;
}>;


export type LinkEventMutation = { __typename?: 'Mutation', linkEvent?: boolean | null };

export type IgnoreDetectionsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type IgnoreDetectionsMutation = { __typename?: 'Mutation', ignoreDetections: boolean };

export type SaveEventResourcePlanMutationVariables = Exact<{
  input: ResourcePlanInput;
}>;


export type SaveEventResourcePlanMutation = { __typename?: 'Mutation', saveResourcePlan: (
    { __typename?: 'ResourcePlan' }
    & ResourcePlanFragment
  ) };

export type SaveResourcePlanTaskMutationVariables = Exact<{
  input: TaskInput;
}>;


export type SaveResourcePlanTaskMutation = { __typename?: 'Mutation', saveResourcePlanTask?: (
    { __typename?: 'Task' }
    & ResourcePlanTaskFragmentFragment
  ) | null };

export type SaveScheduledEventTaskMutationVariables = Exact<{
  input: TaskInput;
}>;


export type SaveScheduledEventTaskMutation = { __typename?: 'Mutation', saveScheduledEventTask?: (
    { __typename?: 'Task' }
    & ResourcePlanTaskFragmentFragment
  ) | null };

export type DeleteResourcePlanTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteResourcePlanTaskMutation = { __typename?: 'Mutation', deleteResourcePlanTask: boolean };

export type DeleteScheduledEventTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteScheduledEventTaskMutation = { __typename?: 'Mutation', deleteScheduledEventTask: boolean };

export type ExpireResourcePlanMutationVariables = Exact<{
  id: Scalars['ID'];
  resources?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ExpireResourcePlanMutation = { __typename?: 'Mutation', expireResources: Array<{ __typename?: 'JobRequest', requestId?: string | null, failure?: string | null, success: boolean, id: string }> };

export type ActivateResourcesMutationVariables = Exact<{
  id: Scalars['ID'];
  resources?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  data?: InputMaybe<Scalars['Object']>;
}>;


export type ActivateResourcesMutation = { __typename?: 'Mutation', activateResources: Array<{ __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null, id: string }> };

export type AcknowledgeResourcesMutationVariables = Exact<{
  id: Scalars['ID'];
  resources: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AcknowledgeResourcesMutation = { __typename?: 'Mutation', acknowledgeResources: (
    { __typename?: 'ResourcePlan' }
    & ResourcePlanFragment
  ) };

export type ExpireResourcesMutationVariables = Exact<{
  id: Scalars['ID'];
  resources?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ExpireResourcesMutation = { __typename?: 'Mutation', expireResources: Array<{ __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null, id: string }> };

export type SaveEventActivityLogMutationVariables = Exact<{
  input: ActivityLogInput;
}>;


export type SaveEventActivityLogMutation = { __typename?: 'Mutation', addActivityLog: { __typename?: 'ActivityLog', id: string } };

export type SaveEventNoteMutationVariables = Exact<{
  id: Scalars['ID'];
  content: Scalars['String'];
}>;


export type SaveEventNoteMutation = { __typename?: 'Mutation', saveEventNote: boolean };

export type RemoveEventLinkMutationVariables = Exact<{
  eventId: Scalars['ID'];
  linkId: Scalars['ID'];
}>;


export type RemoveEventLinkMutation = { __typename?: 'Mutation', unlinkEvent?: boolean | null };

export type SaveActivationConfirmationMutationVariables = Exact<{
  id: Scalars['ID'];
  confirmationRequired: Scalars['Boolean'];
}>;


export type SaveActivationConfirmationMutation = { __typename?: 'Mutation', saveActivationConfirmation?: boolean | null };

export type AssociateDetectionsToEventMutationVariables = Exact<{
  detectionIds: Array<Scalars['ID']> | Scalars['ID'];
  eventId: Scalars['ID'];
}>;


export type AssociateDetectionsToEventMutation = { __typename?: 'Mutation', associateDetectionsToEvent?: boolean | null };

export type RemoveAssociatedDetectionsFromEventMutationVariables = Exact<{
  detectionIds: Array<Scalars['ID']> | Scalars['ID'];
  eventId: Scalars['ID'];
}>;


export type RemoveAssociatedDetectionsFromEventMutation = { __typename?: 'Mutation', removeAssociatedDetectionsFromEvent?: boolean | null };

export type AssociateDetectionToEventsMutationVariables = Exact<{
  detectionId: Scalars['ID'];
  eventIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AssociateDetectionToEventsMutation = { __typename?: 'Mutation', associateDetectionToEvents?: boolean | null };

export type RemoveAssociatedEventsFromDetectionsMutationVariables = Exact<{
  detectionIds: Array<Scalars['ID']> | Scalars['ID'];
  eventIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveAssociatedEventsFromDetectionsMutation = { __typename?: 'Mutation', removeAssociatedEventsFromDetections?: boolean | null };

export type RemoveSignAssociationsMutationVariables = Exact<{
  signs: Array<Scalars['ID']> | Scalars['ID'];
  associationId: Scalars['ID'];
}>;


export type RemoveSignAssociationsMutation = { __typename?: 'Mutation', removeAssociations?: Array<{ __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null, id: string }> | null };

export type AssociateCommLogsToEventsMutationVariables = Exact<{
  commLogIds: Array<Scalars['ID']> | Scalars['ID'];
  eventIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AssociateCommLogsToEventsMutation = { __typename?: 'Mutation', associateCommLogsToEvents?: boolean | null };

export type RemoveAssociatedCommLogsFromEventsMutationVariables = Exact<{
  commLogIds: Array<Scalars['ID']> | Scalars['ID'];
  eventIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveAssociatedCommLogsFromEventsMutation = { __typename?: 'Mutation', removeAssociatedCommLogsFromEvents?: boolean | null };

export type SaveResourcesMutationVariables = Exact<{
  id: Scalars['ID'];
  resources: Array<ResourceInput> | ResourceInput;
}>;


export type SaveResourcesMutation = { __typename?: 'Mutation', saveResources: { __typename?: 'ResourcePlan', id: string } };

export type MarkDetectionAsExaminedMutationVariables = Exact<{
  detectionId: Scalars['ID'];
}>;


export type MarkDetectionAsExaminedMutation = { __typename?: 'Mutation', markDetectionAsExamined: (
    { __typename?: 'Detection' }
    & DetectionFragment
  ) };

export type CreateEventFromCorridorMutationVariables = Exact<{
  corridorId: Scalars['ID'];
  direction: Direction;
  road?: InputMaybe<Scalars['String']>;
  referencePoint?: InputMaybe<Scalars['Float']>;
  category: EventCategory;
  lanes?: InputMaybe<Array<InputMaybe<EventLaneInput>> | InputMaybe<EventLaneInput>>;
}>;


export type CreateEventFromCorridorMutation = { __typename?: 'Mutation', createEventFromCorridor: { __typename?: 'Event', id: string, type: string, status: EventStatus } };

export type GenerateFileTokenUrlMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GenerateFileTokenUrlMutation = { __typename?: 'Mutation', generateFileTokenURL: string };

export type EventFormQueryVariables = Exact<{
  category: Scalars['String'];
}>;


export type EventFormQuery = { __typename?: 'Query', kineticEventForm?: (
    { __typename?: 'KineticForm' }
    & KineticFormFragmentFragment
  ) | null };

export type EmailNotificationsByEventIdQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type EmailNotificationsByEventIdQuery = { __typename?: 'Query', emailNotificationsByEventId: Array<{ __typename?: 'EmailNotification', id: string, sentAt: any, type?: string | null, subject?: string | null, body?: string | null, sentStatus: boolean, toRecipients?: string | null, ccRecipients?: string | null, bccRecipients?: string | null } | null> };

export type EventsKineticFormsQueryVariables = Exact<{
  query: KineticFormInputQuery;
}>;


export type EventsKineticFormsQuery = { __typename?: 'Query', kineticForms: { __typename?: 'KineticFormConnection', totalCount: number, edges: Array<{ __typename?: 'KineticFormConnectionEdge', node: (
        { __typename?: 'KineticForm' }
        & KineticFormFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEventQuery = { __typename?: 'Query', event?: (
    { __typename?: 'Event' }
    & EventFragmentFragment
  ) | null };

export type EventTypeListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<EventCategory>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type EventTypeListQuery = { __typename?: 'Query', eventTypes: { __typename?: 'EventTypeConnection', edges: Array<{ __typename?: 'EventTypeConnectionEdge', node: (
        { __typename?: 'EventType' }
        & EventTypeFragment
      ) }> } };

export type EventTemplateDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventTemplateDetailsQuery = { __typename?: 'Query', eventTemplate: { __typename?: 'EventTemplate', id: string, name: string } };

export type EventTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventTemplateQuery = { __typename?: 'Query', eventTemplate: { __typename?: 'EventTemplate', id: string, name: string, description?: string | null, template: (
      { __typename?: 'Event' }
      & TemplateEventFragment
    ) } };

export type EventsIntegrationsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type EventsIntegrationsListQuery = { __typename?: 'Query', integrations: { __typename?: 'IntegrationConnection', totalCount: number, edges: Array<{ __typename?: 'IntegrationConnectionEdge', node: { __typename?: 'Integration', id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EventTemplatesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type EventTemplatesQuery = { __typename?: 'Query', eventTemplates: { __typename?: 'EventTemplateConnection', totalCount: number, edges: Array<{ __typename?: 'EventTemplateConnectionEdge', node: { __typename?: 'EventTemplate', id: string, name: string, description?: string | null, template: (
          { __typename?: 'Event' }
          & TemplateEventFragment
        ) } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventQuery = { __typename?: 'Query', event?: (
    { __typename?: 'Event' }
    & EventFragment
  ) | null };

export type ShortEventListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ShortEventListQuery = { __typename?: 'Query', events: { __typename?: 'EventConnection', totalCount: number, edges: Array<{ __typename?: 'EventConnectionEdge', node: { __typename?: 'Event', name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EventIdsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type EventIdsQuery = { __typename?: 'Query', events: { __typename?: 'EventConnection', edges: Array<{ __typename?: 'EventConnectionEdge', node: { __typename?: 'Event', id: string } }> } };

export type EventItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventItemQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, name: string, created: any, category: EventCategory, type: string, status: EventStatus, geometry: any } | null };

export type EventMapQueryVariables = Exact<{
  filters: Array<FilterInput> | FilterInput;
}>;


export type EventMapQuery = { __typename?: 'Query', events: { __typename?: 'EventConnection', edges: Array<{ __typename?: 'EventConnectionEdge', node: (
        { __typename?: 'Event' }
        & EventMapFragment
      ) }> } };

export type EventMapUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type EventMapUpdatedSubscription = { __typename?: 'Subscription', eventUpdated: { __typename?: 'Event', id: string } };

export type EventDashboardQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type EventDashboardQuery = { __typename?: 'Query', events: { __typename?: 'EventConnection', totalCount: number, edges: Array<{ __typename?: 'EventConnectionEdge', node: { __typename?: 'Event', id: string, category: EventCategory, attributes: any, type: string, geometry: any } }> } };

export type EventChartHistoryQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  agg: Array<Scalars['JSON']> | Scalars['JSON'];
}>;


export type EventChartHistoryQuery = { __typename?: 'Query', aggregate?: any | null };

export type EventDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventDetailsQuery = { __typename?: 'Query', event?: (
    { __typename?: 'Event' }
    & EventDetailsFragment
  ) | null };

export type SignMapUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SignMapUpdatedSubscription = { __typename?: 'Subscription', signMapUpdated: any };

export type CameraMapQueryVariables = Exact<{ [key: string]: never; }>;


export type CameraMapQuery = { __typename?: 'Query', cameraMapEntities: any };

export type ResourcePlanQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResourcePlanQuery = { __typename?: 'Query', resourcePlan?: (
    { __typename?: 'ResourcePlan' }
    & ResourcePlanFragment
  ) | null };

export type ResourcePlanListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ResourcePlanListQuery = { __typename?: 'Query', resourcePlans: { __typename?: 'ResourcePlanConnection', totalCount: number, edges: Array<{ __typename?: 'ResourcePlanConnectionEdge', node: (
        { __typename?: 'ResourcePlan' }
        & ResourcePlanFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ResourcePlanMessageListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sign?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<SignMessageType>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type ResourcePlanMessageListQuery = { __typename?: 'Query', signMessages: { __typename?: 'SignLibraryMessageConnection', totalCount: number, edges: Array<{ __typename?: 'SignLibraryMessageConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'SignLibraryMessage' }
        & SignLibraryMessageFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EventsModuleSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type EventsModuleSettingsQuery = { __typename?: 'Query', eventsModuleSettings: { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'ModuleFormSection', name: string, id: string, fields: Array<{ __typename?: 'FieldConfig', id: string, name: string, label: string, type: string, required?: boolean | null, hint?: string | null, sourceId?: string | null, defaultValue?: any | null, loading?: boolean | null, showInput?: boolean | null, options?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null> | null } | null> }> } };

export type ResponseModuleSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ResponseModuleSettingsQuery = { __typename?: 'Query', responseModuleSettings: { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'ModuleFormSection', name: string, id: string, fields: Array<{ __typename?: 'FieldConfig', id: string, name: string, label: string, type: string, required?: boolean | null, hint?: string | null, sourceId?: string | null, defaultValue?: any | null, loading?: boolean | null, showInput?: boolean | null, options?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null> | null } | null> }> } };

export type ResourcePlanUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ResourcePlanUpdatedSubscription = { __typename?: 'Subscription', resourcePlanUpdated?: (
    { __typename?: 'ResourcePlan' }
    & ResourcePlanFragment
  ) | null };

export type DetectionListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
}>;


export type DetectionListQuery = { __typename?: 'Query', detections: { __typename?: 'DetectionConnection', totalCount: number, edges: Array<{ __typename?: 'DetectionConnectionEdge', node: (
        { __typename?: 'Detection' }
        & DetectionListItemFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TrackingDetectionListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
}>;


export type TrackingDetectionListQuery = { __typename?: 'Query', detections: { __typename?: 'DetectionConnection', totalCount: number, edges: Array<{ __typename?: 'DetectionConnectionEdge', node: (
        { __typename?: 'Detection' }
        & DetectionFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EventTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventTypeQuery = { __typename?: 'Query', eventType: (
    { __typename?: 'EventType' }
    & EventTypeFragment
  ) };

export type EventTypesListQueryVariables = Exact<{ [key: string]: never; }>;


export type EventTypesListQuery = { __typename?: 'Query', eventTypes: { __typename?: 'EventTypeConnection', edges: Array<{ __typename?: 'EventTypeConnectionEdge', node: (
        { __typename?: 'EventType' }
        & EventTypeShortFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EventManagementQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type EventManagementQuery = { __typename?: 'Query', events: { __typename?: 'EventConnection', totalCount: number, edges: Array<{ __typename?: 'EventConnectionEdge', node: (
        { __typename?: 'Event' }
        & EventListFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type EventUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventUpdatedSubscription = { __typename?: 'Subscription', eventUpdated: { __typename?: 'Event', lastUpdatedBy?: string | null, status: EventStatus, id: string } };

export type EventListUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type EventListUpdatedSubscription = { __typename?: 'Subscription', eventUpdated: (
    { __typename?: 'Event' }
    & EventListFragment
  ) };

export type ShortEventListUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ShortEventListUpdatedSubscription = { __typename?: 'Subscription', eventUpdated: { __typename?: 'Event', id: string } };

export type EventTypeFiltersQueryVariables = Exact<{
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type EventTypeFiltersQuery = { __typename?: 'Query', eventTypeFilters: Array<string> };

export type EventJurisdictionFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type EventJurisdictionFiltersQuery = { __typename?: 'Query', eventJurisdictionFilters: Array<string> };

export type EventRoadFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type EventRoadFiltersQuery = { __typename?: 'Query', eventRoadFilters: Array<string> };

export type DetectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DetectionQuery = { __typename?: 'Query', detection?: (
    { __typename?: 'Detection' }
    & DetectionFragment
  ) | null };

export type EventsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type EventsSummaryQuery = { __typename?: 'Query', scheduled: { __typename?: 'EventConnection', totalCount: number }, active: { __typename?: 'EventConnection', totalCount: number }, suspect: { __typename?: 'EventConnection', totalCount: number }, verified: { __typename?: 'EventConnection', totalCount: number } };

export type DetectionUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DetectionUpdatedSubscription = { __typename?: 'Subscription', detectionUpdated: (
    { __typename?: 'Detection' }
    & DetectionFragment
  ) };

export type ActiveEventsDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveEventsDashboardQuery = { __typename?: 'Query', events: { __typename?: 'EventConnection', edges: Array<{ __typename?: 'EventConnectionEdge', node: { __typename?: 'Event', type: string, category: EventCategory, attributes: any } }> } };

export type AllResourcePlanTasksQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AllResourcePlanTasksQuery = { __typename?: 'Query', allResourcePlanTasks?: Array<(
    { __typename?: 'Task' }
    & TaskFragmentFragment
  )> | null };

export type ResourcePlanTasksQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
}>;


export type ResourcePlanTasksQuery = { __typename?: 'Query', resourcePlanTasks?: Array<{ __typename?: 'DateTasks', date: any, tasks?: Array<(
      { __typename?: 'TaskOccurrence' }
      & TaskOccurrenceFragmentFragment
    ) | null> | null }> | null };

export type ResourcePlanTaskUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
}>;


export type ResourcePlanTaskUpdatedSubscription = { __typename?: 'Subscription', resourcePlanTaskUpdated: (
    { __typename?: 'Task' }
    & ResourcePlanTaskFragmentFragment
  ) };

export type SignListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SignListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', totalCount: number, edges: Array<{ __typename?: 'SignConnectionEdge', node: (
        { __typename?: 'Sign' }
        & SignDetailFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ResourcePlanFutureTasksQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResourcePlanFutureTasksQuery = { __typename?: 'Query', resourcePlanFutureTasks: Array<{ __typename?: 'Task', nextExecutionDate?: any | null }> };

export type NearbyCamerasQueryVariables = Exact<{
  thresholdMiles?: InputMaybe<Scalars['Float']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
}>;


export type NearbyCamerasQuery = { __typename?: 'Query', nearbyCameras?: Array<(
    { __typename?: 'Camera' }
    & CameraNodeFragment
  )> | null };

export type EventsCameraQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventsCameraQuery = { __typename?: 'Query', camera?: (
    { __typename?: 'Camera' }
    & CameraNodeFragment
  ) | null };

export type EventUpdatedShortSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type EventUpdatedShortSubscription = { __typename?: 'Subscription', eventUpdated: { __typename?: 'Event', id: string } };

export type GetKineticUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetKineticUserQuery = { __typename?: 'Query', getKineticUser?: (
    { __typename?: 'OrganizationKineticUser' }
    & KineticUserFragmentFragment
  ) | null };

export type EventActivityLogAddedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  module?: InputMaybe<KineticModule>;
}>;


export type EventActivityLogAddedSubscription = { __typename?: 'Subscription', addedActivityLog: (
    { __typename?: 'ActivityLog' }
    & ActivityLogNodeFragmentFragment
  ) };

export type ResourcePlanActivityLogAddedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  module?: InputMaybe<KineticModule>;
}>;


export type ResourcePlanActivityLogAddedSubscription = { __typename?: 'Subscription', addedActivityLog: (
    { __typename?: 'ActivityLog' }
    & ActivityLogNodeFragmentFragment
  ) };

export type EventCorridorQueryVariables = Exact<{
  filters: Array<FilterInput> | FilterInput;
}>;


export type EventCorridorQuery = { __typename?: 'Query', corridors: { __typename?: 'CorridorConnection', edges: Array<{ __typename?: 'CorridorConnectionEdge', node: { __typename?: 'Corridor', integrations: Array<string>, settings: any, lanes: Array<{ __typename?: 'CorridorLane', startReference: number, endReference: number, direction: Direction, lineType: CorridorLineType, position: number, type: LaneType }> } }> } };

export type MessageTemplateListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type MessageTemplateListQuery = { __typename?: 'Query', emailsTemplate: { __typename?: 'EmailTemplateConnection', edges: Array<{ __typename?: 'EmailTemplateConnectionEdge', node: { __typename?: 'EmailTemplateDto', id: string, name: string, type: TemplateType, form?: string | null, module: KineticModule, subject?: string | null, body: string } }> } };

export type EventSummaryReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventSummaryReportQuery = { __typename?: 'Query', eventSummaryReport?: string | null };

export type HistoricalEventSummaryReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HistoricalEventSummaryReportQuery = { __typename?: 'Query', historicalEventSummaryReport?: string | null };

export type IntegrationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntegrationByIdQuery = { __typename?: 'Query', integration?: { __typename?: 'Integration', name: string, id: string } | null };

export type SignalActionSetListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SignalActionSetListQuery = { __typename?: 'Query', signalActionSets: { __typename?: 'SignalActionSetConnection', totalCount: number, edges: Array<{ __typename?: 'SignalActionSetConnectionEdge', node: { __typename?: 'SignalActionSet', number: number, impact?: SignalActionSetImpactType | null, notes?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type AllScheduledEventTasksQueryVariables = Exact<{
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
}>;


export type AllScheduledEventTasksQuery = { __typename?: 'Query', allScheduledEventTasks?: Array<{ __typename?: 'DateTasks', date: any, tasks?: Array<(
      { __typename?: 'TaskOccurrence' }
      & TaskOccurrenceFragmentFragment
    ) | null> | null }> | null };

export type ScheduledEventTasksQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
}>;


export type ScheduledEventTasksQuery = { __typename?: 'Query', scheduledEventTasks?: Array<{ __typename?: 'DateTasks', date: any, tasks?: Array<(
      { __typename?: 'TaskOccurrence' }
      & TaskOccurrenceFragmentFragment
    ) | null> | null }> | null };

export type ScheduledEventTaskUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
}>;


export type ScheduledEventTaskUpdatedSubscription = { __typename?: 'Subscription', scheduledEventTaskUpdated: (
    { __typename?: 'Task' }
    & TaskFragmentFragment
  ) };

export type EventReviewQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters: Array<FilterInput> | FilterInput;
  entityIds: Array<Scalars['String']> | Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type EventReviewQuery = { __typename?: 'Query', history: { __typename?: 'HistoricalEntityConnection', totalCount: number, edges: Array<{ __typename?: 'HistoricalEntityEdge', node: { __typename?: 'HistoricalEntity', id: string, type: HistoricalEntityType, entityId: string, entity: any, timestamp: any } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetResourceContactGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceContactGroupQuery = { __typename?: 'Query', contactGroup?: (
    { __typename?: 'ContactGroupDto' }
    & ResourceContactGroupListNodeFragmentFragment
  ) | null };

export type EventAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type EventAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string, displayName: string } }> } };

export type GetFileInfoQueryVariables = Exact<{
  id: Scalars['ID'];
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type GetFileInfoQuery = { __typename?: 'Query', getFileInfo: { __typename?: 'File', id: string, name: string, contentType?: string | null, path: string } };

export type ResourcePlanActivationResultsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ResourcePlanActivationResultsQuery = { __typename?: 'Query', resourcePlanActivationResults: { __typename?: 'ResourcePlanActivationResultConnection', totalCount: number, edges: Array<{ __typename?: 'ResourcePlanActivationResultConnectionEdge', node: (
        { __typename?: 'ResourcePlanActivationResult' }
        & ResourcePlanActivationResultFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TrafficControlNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TrafficControlNameQuery = { __typename?: 'Query', trafficControl: { __typename?: 'TrafficControl', id: string, name: string } };

export type DirectoryFragmentFragment = { __typename?: 'Directory', id: string, order: number, name: string, owner: string, parentId?: string | null, readOnly: boolean };

export type DirectoryRecursiveFragment = (
  { __typename?: 'Directory', directories: Array<(
    { __typename?: 'Directory', directories: Array<(
      { __typename?: 'Directory', directories: Array<(
        { __typename?: 'Directory', directories: Array<(
          { __typename?: 'Directory', directories: Array<(
            { __typename?: 'Directory', directories: Array<(
              { __typename?: 'Directory', directories: Array<(
                { __typename?: 'Directory', directories: Array<(
                  { __typename?: 'Directory', directories: Array<(
                    { __typename?: 'Directory' }
                    & DirectoryFragmentFragment
                  )> }
                  & DirectoryFragmentFragment
                )> }
                & DirectoryFragmentFragment
              )> }
              & DirectoryFragmentFragment
            )> }
            & DirectoryFragmentFragment
          )> }
          & DirectoryFragmentFragment
        )> }
        & DirectoryFragmentFragment
      )> }
      & DirectoryFragmentFragment
    )> }
    & DirectoryFragmentFragment
  )> }
  & DirectoryFragmentFragment
);

export type SaveSystemDirectoriesMutationVariables = Exact<{
  input: Array<DirectoryInput> | DirectoryInput;
  removedDirectories: Array<Scalars['String']> | Scalars['String'];
}>;


export type SaveSystemDirectoriesMutation = { __typename?: 'Mutation', saveSystemDirectories: Array<(
    { __typename?: 'Directory' }
    & DirectoryRecursiveFragment
  )> };

export type SaveUserDirectoriesMutationVariables = Exact<{
  input: Array<DirectoryInput> | DirectoryInput;
  removedDirectories: Array<Scalars['String']> | Scalars['String'];
}>;


export type SaveUserDirectoriesMutation = { __typename?: 'Mutation', saveUserDirectories: Array<(
    { __typename?: 'Directory' }
    & DirectoryRecursiveFragment
  )> };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['ID'];
  module?: InputMaybe<KineticModule>;
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: boolean };

export type DeleteManagedFilesMutationVariables = Exact<{
  fileIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteManagedFilesMutation = { __typename?: 'Mutation', deleteManagedFiles: boolean };

export type InitMyFilesMutationVariables = Exact<{ [key: string]: never; }>;


export type InitMyFilesMutation = { __typename?: 'Mutation', initializeMyFilesDirectory: { __typename?: 'Directory', id: string, order: number, name: string, owner: string, parentId?: string | null } };

export type MoveFileMutationVariables = Exact<{
  destinationDirectoryId: Scalars['String'];
  fileId: Scalars['String'];
}>;


export type MoveFileMutation = { __typename?: 'Mutation', moveFile: boolean };

export type CopyFileMutationVariables = Exact<{
  destinationDirectoryId: Scalars['String'];
  fileId: Scalars['String'];
}>;


export type CopyFileMutation = { __typename?: 'Mutation', copyFile: boolean };

export type GetSystemDirectoriesQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetSystemDirectoriesQuery = { __typename?: 'Query', getSystemDirectories: Array<(
    { __typename?: 'Directory' }
    & DirectoryRecursiveFragment
  )> };

export type GetUserDirectoriesQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetUserDirectoriesQuery = { __typename?: 'Query', getUserDirectories: Array<(
    { __typename?: 'Directory' }
    & DirectoryRecursiveFragment
  )> };

export type GetManagedFilesByDirectoryQueryVariables = Exact<{
  directoryId: Scalars['String'];
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type GetManagedFilesByDirectoryQuery = { __typename?: 'Query', getManagedFilesByDirectory: Array<{ __typename?: 'ManagedFile', contentType: string, directoryId: string, fileName: string, id: string, name: string, owner?: string | null, timestamp?: any | null, tags?: Array<string> | null }> };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', getFileTags: Array<string> };

export type ManagedFileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ManagedFileQuery = { __typename?: 'Query', getManagedFile?: { __typename?: 'ManagedFile', contentType: string, directoryId: string, fileName: string, id: string, name: string, owner?: string | null, tags?: Array<string> | null } | null };

export type ManagedFileNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ManagedFileNameQuery = { __typename?: 'Query', getManagedFile?: { __typename?: 'ManagedFile', name: string } | null };

export type GetFileListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  filterInput?: InputMaybe<Array<FilterInput> | FilterInput>;
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type GetFileListQuery = { __typename?: 'Query', getFiles: { __typename?: 'FileConnection', totalCount: number, edges: Array<{ __typename?: 'FileEdge', node: { __typename?: 'File', id: string, name: string, size?: number | null, contentType?: string | null, path: string, timestamp?: any | null, module?: KineticModule | null, key?: string | null, additionalData?: any | null, createdBy?: string | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetGlobalFileListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  filterInput?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type GetGlobalFileListQuery = { __typename?: 'Query', getGlobalFiles: { __typename?: 'GlobalFileConnection', totalCount: number, edges: Array<{ __typename?: 'FileEdge', node: { __typename?: 'File', id: string, name: string, size?: number | null, contentType?: string | null, path: string, timestamp?: any | null, module?: KineticModule | null, key?: string | null, additionalData?: any | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type FileManagerActivityLogAddedSubscriptionVariables = Exact<{
  module?: InputMaybe<KineticModule>;
  types?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FileManagerActivityLogAddedSubscription = { __typename?: 'Subscription', addedActivityLog: (
    { __typename?: 'ActivityLog' }
    & ActivityLogNodeFragmentFragment
  ) };

export type FleetDispatchMutationVariables = Exact<{
  id: Scalars['ID'];
  event: Scalars['ID'];
}>;


export type FleetDispatchMutation = { __typename?: 'Mutation', fleetDispatch: { __typename?: 'FleetDispatch', status: FleetDispatchStatus, id: string } };

export type FleetDispatchListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type FleetDispatchListQuery = { __typename?: 'Query', fleetDispatches: { __typename?: 'FleetDispatchConnection', totalCount: number, edges: Array<{ __typename?: 'FleetDispatchEdge', node: { __typename?: 'FleetDispatch', dispatchingUsername: string, timeRequested: any, timeResponded?: any | null, timeOnScene?: any | null, timeDeparted?: any | null, firstName: string, lastName: string, username: string, status: FleetDispatchStatus, phone?: string | null, email?: string | null, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveFleetDispatchListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveFleetDispatchListSubscription = { __typename?: 'Subscription', fleetDispatchUpdated: { __typename?: 'FleetDispatch', dispatchingUsername: string, timeRequested: any, timeResponded?: any | null, timeOnScene?: any | null, timeDeparted?: any | null, firstName: string, lastName: string, username: string, status: FleetDispatchStatus, phone?: string | null, email?: string | null, id: string } };

export type SaveFleetDriverMutationVariables = Exact<{
  driver: FleetDriverInput;
}>;


export type SaveFleetDriverMutation = { __typename?: 'Mutation', fleetSaveDriver: { __typename?: 'FleetDriver', id: string } };

export type DeleteFleetDriverMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFleetDriverMutation = { __typename?: 'Mutation', fleetDeleteDriver: boolean };

export type FleetDriverListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type FleetDriverListQuery = { __typename?: 'Query', fleetDrivers: { __typename?: 'FleetDriverConnection', totalCount: number, edges: Array<{ __typename?: 'FleetDriverEdge', node: { __typename?: 'FleetDriver', capabilities: Array<string>, firstName: string, callSign: string, username: string, lastName: string, modules: Array<KineticModule>, phone?: string | null, email?: string | null, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveFleetDriverListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveFleetDriverListSubscription = { __typename?: 'Subscription', fleetDriverUpdated: { __typename?: 'FleetDriver', capabilities: Array<string>, firstName: string, callSign: string, username: string, lastName: string, modules: Array<KineticModule>, phone?: string | null, email?: string | null, id: string } };

export type FleetDriverEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FleetDriverEditQuery = { __typename?: 'Query', fleetDriver: { __typename?: 'FleetDriver', capabilities: Array<string>, firstName: string, callSign: string, username: string, lastName: string, modules: Array<KineticModule>, phone?: string | null, email?: string | null, id: string } };

export type FleetDriverAvatarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FleetDriverAvatarQuery = { __typename?: 'Query', fleetDriver: { __typename?: 'FleetDriver', firstName: string, lastName: string, status: FleetShiftStatus, id: string } };

export type LiveFleetDriverAvatarSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveFleetDriverAvatarSubscription = { __typename?: 'Subscription', fleetDriverUpdated: { __typename?: 'FleetDriver', firstName: string, lastName: string, status: FleetShiftStatus, id: string } };

export type FleetDriverUserSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type FleetDriverUserSelectionListQuery = { __typename?: 'Query', users: { __typename?: 'KineticUserConnection', edges: Array<{ __typename?: 'KineticUserConnectionEdge', node: { __typename?: 'OrganizationKineticUser', firstName?: string | null, lastName?: string | null, username: string, email?: string | null, id: string } }> } };

export type FleetDriverIdListQueryVariables = Exact<{ [key: string]: never; }>;


export type FleetDriverIdListQuery = { __typename?: 'Query', fleetDrivers: { __typename?: 'FleetDriverConnection', edges: Array<{ __typename?: 'FleetDriverEdge', node: { __typename?: 'FleetDriver', id: string } }> } };

export type FleetDriverSelectionListQueryVariables = Exact<{
  module: Scalars['Object'];
}>;


export type FleetDriverSelectionListQuery = { __typename?: 'Query', fleetDrivers: { __typename?: 'FleetDriverConnection', edges: Array<{ __typename?: 'FleetDriverEdge', node: { __typename?: 'FleetDriver', firstName: string, lastName: string, username: string, id: string } }> } };

export type ActiveFleetDriverListQueryVariables = Exact<{
  module: Scalars['Object'];
}>;


export type ActiveFleetDriverListQuery = { __typename?: 'Query', fleetShifts: { __typename?: 'FleetShiftConnection', edges: Array<{ __typename?: 'FleetShiftEdge', node: { __typename?: 'FleetShift', driver: string } }> } };

export type SaveFleetRouteMutationVariables = Exact<{
  route: FleetRouteInput;
}>;


export type SaveFleetRouteMutation = { __typename?: 'Mutation', fleetSaveRoute: { __typename?: 'FleetRoute', id: string } };

export type DeleteFleetRouteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFleetRouteMutation = { __typename?: 'Mutation', fleetDeleteRoute: boolean };

export type FleetRouteListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type FleetRouteListQuery = { __typename?: 'Query', fleetRoutes: { __typename?: 'FleetRouteConnection', totalCount: number, edges: Array<{ __typename?: 'FleetRouteEdge', node: { __typename?: 'FleetRoute', startReference?: number | null, endReference?: number | null, description?: string | null, route?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveFleetRouteListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveFleetRouteListSubscription = { __typename?: 'Subscription', fleetRouteUpdated: { __typename?: 'FleetRoute', startReference?: number | null, endReference?: number | null, description?: string | null, route?: string | null, name: string, id: string } };

export type FleetRouteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FleetRouteQuery = { __typename?: 'Query', fleetRoute: { __typename?: 'FleetRoute', startReference?: number | null, endReference?: number | null, description?: string | null, geometry: any, route?: string | null, name: string, id: string } };

export type FleetRouteSelectionListQueryVariables = Exact<{
  module: Scalars['Object'];
}>;


export type FleetRouteSelectionListQuery = { __typename?: 'Query', fleetRoutes: { __typename?: 'FleetRouteConnection', edges: Array<{ __typename?: 'FleetRouteEdge', node: { __typename?: 'FleetRoute', name: string, id: string } }> } };

export type FleetRouteDriverListQueryVariables = Exact<{
  id: Scalars['Object'];
  module: Scalars['Object'];
}>;


export type FleetRouteDriverListQuery = { __typename?: 'Query', fleetShifts: { __typename?: 'FleetShiftConnection', edges: Array<{ __typename?: 'FleetShiftEdge', node: { __typename?: 'FleetShift', driver: string } }> } };

export type FleetCheckInMutationVariables = Exact<{
  shift: FleetShiftInput;
}>;


export type FleetCheckInMutation = { __typename?: 'Mutation', fleetCheckIn: { __typename?: 'FleetShift', id: string } };

export type FleetCheckOutMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FleetCheckOutMutation = { __typename?: 'Mutation', fleetCheckOut: boolean };

export type FleetUpdateStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: FleetShiftStatus;
}>;


export type FleetUpdateStatusMutation = { __typename?: 'Mutation', fleetUpdateStatus: boolean };

export type FleetShiftLogActivityMutationVariables = Exact<{
  id: Scalars['ID'];
  description: Scalars['String'];
}>;


export type FleetShiftLogActivityMutation = { __typename?: 'Mutation', fleetLogActivity: boolean };

export type FleetShiftListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type FleetShiftListQuery = { __typename?: 'Query', fleetShifts: { __typename?: 'FleetShiftConnection', totalCount: number, edges: Array<{ __typename?: 'FleetShiftEdge', node: { __typename?: 'FleetShift', patrolNumber: string, radioNumber?: string | null, vehicleName: string, routeName?: string | null, firstName: string, lastName: string, callSign: string, status: FleetShiftStatus, driver: string, phone?: string | null, type: string, avl?: string | null, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveFleetShiftListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveFleetShiftListSubscription = { __typename?: 'Subscription', fleetShiftUpdated: { __typename?: 'FleetShift', patrolNumber: string, radioNumber?: string | null, vehicleName: string, routeName?: string | null, firstName: string, lastName: string, callSign: string, driver: string, status: FleetShiftStatus, phone?: string | null, type: string, avl?: string | null, id: string, speed?: number | null, address?: string | null, moveStatus?: { __typename?: 'FleetShiftMoveStatus', lastMoved: any, isMoving: boolean, state: FleetShiftMoveState } | null } };

export type ActiveFleetGpsListQueryVariables = Exact<{
  module: Scalars['Object'];
}>;


export type ActiveFleetGpsListQuery = { __typename?: 'Query', fleetShifts: { __typename?: 'FleetShiftConnection', edges: Array<{ __typename?: 'FleetShiftEdge', node: { __typename?: 'FleetShift', avl?: string | null } }> } };

export type ActiveFleetPatrolNumberListQueryVariables = Exact<{
  module: Scalars['Object'];
}>;


export type ActiveFleetPatrolNumberListQuery = { __typename?: 'Query', fleetShifts: { __typename?: 'FleetShiftConnection', edges: Array<{ __typename?: 'FleetShiftEdge', node: { __typename?: 'FleetShift', patrolNumber: string } }> } };

export type ActiveFleetRadioNumberListQueryVariables = Exact<{
  module: Scalars['Object'];
}>;


export type ActiveFleetRadioNumberListQuery = { __typename?: 'Query', fleetShifts: { __typename?: 'FleetShiftConnection', edges: Array<{ __typename?: 'FleetShiftEdge', node: { __typename?: 'FleetShift', radioNumber?: string | null } }> } };

export type FleetShiftMapQueryVariables = Exact<{
  module: Scalars['Object'];
}>;


export type FleetShiftMapQuery = { __typename?: 'Query', fleetShifts: { __typename?: 'FleetShiftConnection', edges: Array<{ __typename?: 'FleetShiftEdge', node: { __typename?: 'FleetShift', location?: any | null, status: FleetShiftStatus, type: string, id: string, speed?: number | null, address?: string | null, moveStatus?: { __typename?: 'FleetShiftMoveStatus', lastMoved: any, isMoving: boolean, state: FleetShiftMoveState } | null } }> } };

export type LiveFleetShiftMapSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveFleetShiftMapSubscription = { __typename?: 'Subscription', fleetShiftUpdated: { __typename?: 'FleetShift', location?: any | null, status: FleetShiftStatus, type: string, id: string } };

export type FleetShiftQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FleetShiftQuery = { __typename?: 'Query', fleetShift: { __typename?: 'FleetShift', vehicleCapabilities: Array<string>, driverCapabilities: Array<string>, patrolNumber: string, plateNumber: string, vehicleName: string, radioNumber?: string | null, routeName?: string | null, firstName: string, lastName: string, callSign: string, location?: any | null, driver: string, status: FleetShiftStatus, phone?: string | null, type: string, id: string, avl?: string | null, serial?: string | null, address?: string | null, speed?: number | null, moveStatus?: { __typename?: 'FleetShiftMoveStatus', lastMoved: any, isMoving: boolean, state: FleetShiftMoveState } | null } };

export type FleetShiftStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FleetShiftStatusQuery = { __typename?: 'Query', fleetShift: { __typename?: 'FleetShift', status: FleetShiftStatus, id: string } };

export type LiveFleetShiftSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveFleetShiftSubscription = { __typename?: 'Subscription', fleetShiftUpdated: { __typename?: 'FleetShift', vehicleCapabilities: Array<string>, driverCapabilities: Array<string>, patrolNumber: string, plateNumber: string, vehicleName: string, radioNumber?: string | null, routeName?: string | null, firstName: string, lastName: string, callSign: string, location?: any | null, driver: string, status: FleetShiftStatus, phone?: string | null, type: string, id: string, speed?: number | null, address?: string | null, moveStatus?: { __typename?: 'FleetShiftMoveStatus', lastMoved: any, isMoving: boolean, state: FleetShiftMoveState } | null } };

export type FleetShiftSearchQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type FleetShiftSearchQuery = { __typename?: 'Query', fleetShifts: { __typename?: 'FleetShiftConnection', totalCount: number, edges: Array<{ __typename?: 'FleetShiftEdge', node: { __typename?: 'FleetShift', vehicleName: string, location?: any | null, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type FleetShiftSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type FleetShiftSummaryQuery = { __typename?: 'Query', AVAILABLE: { __typename?: 'FleetShiftConnection', totalCount: number }, DISPATCH_REQUESTED: { __typename?: 'FleetShiftConnection', totalCount: number }, ENROUTE: { __typename?: 'FleetShiftConnection', totalCount: number }, ONSCENE: { __typename?: 'FleetShiftConnection', totalCount: number }, ON_DUTY_UNAVAILABLE: { __typename?: 'FleetShiftConnection', totalCount: number } };

export type FleetShiftCameraDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FleetShiftCameraDetailsQuery = { __typename?: 'Query', getFleetCameraDetails: { __typename?: 'FleetCameraDetails', protocol?: string | null, attributes?: any | null, status: FleetCameraStatus, cameras?: Array<{ __typename?: 'FleetCamera', cameraId?: string | null, cameraName?: string | null, status?: string | null, description?: string | null } | null> | null } };

export type SaveFleetVehicleMutationVariables = Exact<{
  vehicle: FleetVehicleInput;
}>;


export type SaveFleetVehicleMutation = { __typename?: 'Mutation', fleetSaveVehicle: { __typename?: 'FleetVehicle', id: string } };

export type DeleteFleetVehicleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFleetVehicleMutation = { __typename?: 'Mutation', fleetDeleteVehicle: boolean };

export type FleetVehicleListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type FleetVehicleListQuery = { __typename?: 'Query', fleetVehicles: { __typename?: 'FleetVehicleConnection', totalCount: number, edges: Array<{ __typename?: 'FleetVehicleEdge', node: { __typename?: 'FleetVehicle', capabilities: Array<string>, description?: string | null, plateNumber?: string | null, odometer?: number | null, modules: Array<KineticModule>, status: FleetVehicleStatus, model?: string | null, name: string, year?: number | null, make?: string | null, type: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveFleetVehicleListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveFleetVehicleListSubscription = { __typename?: 'Subscription', fleetVehicleUpdated: { __typename?: 'FleetVehicle', capabilities: Array<string>, description?: string | null, plateNumber?: string | null, odometer?: number | null, modules: Array<KineticModule>, status: FleetVehicleStatus, model?: string | null, name: string, year?: number | null, make?: string | null, type: string, id: string } };

export type FleetVehicleEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FleetVehicleEditQuery = { __typename?: 'Query', fleetVehicle: { __typename?: 'FleetVehicle', capabilities: Array<string>, description?: string | null, plateNumber?: string | null, odometer?: number | null, modules: Array<KineticModule>, status: FleetVehicleStatus, model?: string | null, name: string, year?: number | null, make?: string | null, type: string, id: string } };

export type FleetVehicleSelectionListQueryVariables = Exact<{
  module: Scalars['Object'];
}>;


export type FleetVehicleSelectionListQuery = { __typename?: 'Query', fleetVehicles: { __typename?: 'FleetVehicleConnection', edges: Array<{ __typename?: 'FleetVehicleEdge', node: { __typename?: 'FleetVehicle', name: string, id: string, plateNumber?: string | null, status: FleetVehicleStatus } }> } };

export type ActiveFleetVehicleListQueryVariables = Exact<{
  module: Scalars['Object'];
}>;


export type ActiveFleetVehicleListQuery = { __typename?: 'Query', fleetShifts: { __typename?: 'FleetShiftConnection', edges: Array<{ __typename?: 'FleetShiftEdge', node: { __typename?: 'FleetShift', vehicle: string } }> } };

export type FieldConfigFieldsFragment = { __typename?: 'FieldConfig', activeLogic?: any | null, choicesTitle?: string | null, chosenTitle?: string | null, defaultValue?: any | null, showInput?: boolean | null, valueLabelDisplay?: string | null, deselectAllLabel?: string | null, disableFuture?: boolean | null, disablePast?: boolean | null, displayFormat?: string | null, fieldSize?: string | null, format?: string | null, help?: string | null, hint?: string | null, id: string, label: string, limitTags?: number | null, max?: number | null, maxLength?: number | null, min?: number | null, multiple?: boolean | null, name: string, sortOrder?: string | null, required?: boolean | null, requiredLogic?: any | null, selectAllLabel?: string | null, step?: number | null, type: string, uniqueFields?: Array<string | null> | null, useCheckedIcon?: boolean | null, useIcon?: boolean | null, useStepper?: boolean | null, moduleName?: string | null, sourceId?: string | null, rows?: number | null, multiline?: boolean | null, mode?: string | null, pickerZIndex?: number | null, dataSource?: string | null, options?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null> | null, dataSourceVariables?: Array<{ __typename?: 'ValueVariable', address?: string | null, value?: any | null, required?: boolean | null, name: string, type: string }> | null };

export type FieldConfigRecursiveFragment = (
  { __typename?: 'FieldConfig', fieldConfigs?: Array<(
    { __typename?: 'FieldConfig', fieldConfigs?: Array<(
      { __typename?: 'FieldConfig', fieldConfigs?: Array<(
        { __typename?: 'FieldConfig' }
        & FieldConfigFieldsFragment
      )> | null }
      & FieldConfigFieldsFragment
    )> | null }
    & FieldConfigFieldsFragment
  )> | null }
  & FieldConfigFieldsFragment
);

export type KineticFormFieldFragmentFragment = { __typename?: 'KineticFormField', id: string, name: string, description?: string | null, label: string, type: string, fieldSize?: string | null, help?: string | null, hint?: string | null, disabled?: boolean | null, disablePast?: boolean | null, disableFuture?: boolean | null, format?: string | null, displayFormat?: string | null, max?: number | null, min?: number | null, useStepper?: boolean | null, step?: number | null, source?: string | null, multiple?: boolean | null, sortOrder?: string | null, requiredLogic?: any | null, activeLogic?: any | null, moduleName?: string | null, loading?: boolean | null, uploadType?: string | null, accept?: string | null, required?: boolean | null, defaultValue?: any | null, mode?: string | null, iconConfig?: any | null, rows?: number | null, multiline?: boolean | null, pickerZIndex?: number | null, options?: Array<{ __typename?: 'KineticFormFieldOption', label: string, value: string, type?: string | null }> | null };

export type KineticFieldConfigFragment = (
  { __typename?: 'FieldConfig' }
  & FieldConfigFieldsFragment
);

export type KineticFormSectionFragmentFragment = { __typename?: 'KineticFormSection', id: string, name: string, fields: Array<(
    { __typename?: 'KineticFormField' }
    & KineticFormFieldFragmentFragment
  ) | null> };

export type KineticFormViewFragmentFragment = { __typename?: 'KineticFormView', id: string, name: string, sections: Array<(
    { __typename?: 'KineticFormSection' }
    & KineticFormSectionFragmentFragment
  )> };

export type KineticFormFragment = { __typename?: 'KineticForm', system?: boolean | null, canOverride?: boolean | null, modified?: any | null, extraConfig: any, description?: string | null, module: KineticModule, name: string, id: string, views: Array<(
    { __typename?: 'KineticFormView' }
    & KineticFormViewFragmentFragment
  ) | null> };

export type KineticFormFragmentFragment = { __typename?: 'KineticForm', system?: boolean | null, canOverride?: boolean | null, modified?: any | null, extraConfig: any, description?: string | null, module: KineticModule, name: string, id: string, views: Array<(
    { __typename?: 'KineticFormView' }
    & KineticFormViewFragmentFragment
  ) | null> };

export type FieldConfigFragmentFragment = { __typename?: 'FieldConfig', id: string, name: string, label: string, type: string, required?: boolean | null, help?: string | null, hint?: string | null, fieldSize?: string | null, sortOrder?: string | null, disablePast?: boolean | null, disableFuture?: boolean | null, useStepper?: boolean | null, max?: number | null, min?: number | null, step?: number | null, multiple?: boolean | null, limitTags?: number | null, selectAllLabel?: string | null, deselectAllLabel?: string | null, useCheckedIcon?: boolean | null, useIcon?: boolean | null, choicesTitle?: string | null, defaultValue?: any | null, format?: string | null, displayFormat?: string | null, activeLogic?: any | null, requiredLogic?: any | null, moduleName?: string | null, sourceId?: string | null, uploadType?: string | null, accept?: string | null, loading?: boolean | null, valueLabelDisplay?: string | null, showInput?: boolean | null, maxLength?: number | null, uniqueFields?: Array<string | null> | null, multiline?: boolean | null, rows?: number | null, mode?: string | null, disabled?: boolean | null, disabledLogic?: any | null, pickerZIndex?: number | null, dataSource?: string | null, options?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null> | null, dataSourceVariables?: Array<{ __typename?: 'ValueVariable', address?: string | null, value?: any | null, required?: boolean | null, name: string, type: string }> | null };

export type ModuleFormSectionFragmentFragment = { __typename?: 'ModuleFormSection', name: string, id: string, fields: Array<(
    { __typename?: 'FieldConfig', fieldConfigs?: Array<(
      { __typename?: 'FieldConfig', fieldConfigs?: Array<(
        { __typename?: 'FieldConfig', fieldConfigs?: Array<(
          { __typename?: 'FieldConfig' }
          & FieldConfigFragmentFragment
        )> | null }
        & FieldConfigFragmentFragment
      )> | null }
      & FieldConfigFragmentFragment
    )> | null }
    & FieldConfigFragmentFragment
  ) | null> };

type FormSectionFragment_DetectorReportConfigFormSection_Fragment = { __typename?: 'DetectorReportConfigFormSection', name: string, id: string, fields: Array<(
    { __typename?: 'FieldConfig', fieldConfigs?: Array<(
      { __typename?: 'FieldConfig', fieldConfigs?: Array<(
        { __typename?: 'FieldConfig', fieldConfigs?: Array<(
          { __typename?: 'FieldConfig' }
          & FieldConfigFragmentFragment
        )> | null }
        & FieldConfigFragmentFragment
      )> | null }
      & FieldConfigFragmentFragment
    )> | null }
    & FieldConfigFragmentFragment
  )> };

type FormSectionFragment_IntegrationConfigFormSection_Fragment = { __typename?: 'IntegrationConfigFormSection', name: string, id: string, fields: Array<(
    { __typename?: 'FieldConfig', fieldConfigs?: Array<(
      { __typename?: 'FieldConfig', fieldConfigs?: Array<(
        { __typename?: 'FieldConfig', fieldConfigs?: Array<(
          { __typename?: 'FieldConfig' }
          & FieldConfigFragmentFragment
        )> | null }
        & FieldConfigFragmentFragment
      )> | null }
      & FieldConfigFragmentFragment
    )> | null }
    & FieldConfigFragmentFragment
  ) | null> };

type FormSectionFragment_IntegrationStateSection_Fragment = { __typename?: 'IntegrationStateSection', name: string, id: string, fields: Array<(
    { __typename?: 'FieldConfig', fieldConfigs?: Array<(
      { __typename?: 'FieldConfig', fieldConfigs?: Array<(
        { __typename?: 'FieldConfig', fieldConfigs?: Array<(
          { __typename?: 'FieldConfig' }
          & FieldConfigFragmentFragment
        )> | null }
        & FieldConfigFragmentFragment
      )> | null }
      & FieldConfigFragmentFragment
    )> | null }
    & FieldConfigFragmentFragment
  ) | null> };

type FormSectionFragment_ModuleFormSection_Fragment = { __typename?: 'ModuleFormSection', name: string, id: string, fields: Array<(
    { __typename?: 'FieldConfig', fieldConfigs?: Array<(
      { __typename?: 'FieldConfig', fieldConfigs?: Array<(
        { __typename?: 'FieldConfig', fieldConfigs?: Array<(
          { __typename?: 'FieldConfig' }
          & FieldConfigFragmentFragment
        )> | null }
        & FieldConfigFragmentFragment
      )> | null }
      & FieldConfigFragmentFragment
    )> | null }
    & FieldConfigFragmentFragment
  ) | null> };

export type FormSectionFragmentFragment = FormSectionFragment_DetectorReportConfigFormSection_Fragment | FormSectionFragment_IntegrationConfigFormSection_Fragment | FormSectionFragment_IntegrationStateSection_Fragment | FormSectionFragment_ModuleFormSection_Fragment;

type FormViewFragment_DetectorReportConfigFormView_Fragment = { __typename?: 'DetectorReportConfigFormView', type: FormViewType, id: string, name: string, sections: Array<(
    { __typename?: 'DetectorReportConfigFormSection' }
    & FormSectionFragment_DetectorReportConfigFormSection_Fragment
  )> };

type FormViewFragment_IntegrationConfigFormView_Fragment = { __typename?: 'IntegrationConfigFormView', type: FormViewType, id: string, name: string, sections: Array<(
    { __typename?: 'IntegrationConfigFormSection' }
    & FormSectionFragment_IntegrationConfigFormSection_Fragment
  )> };

type FormViewFragment_IntegrationStateView_Fragment = { __typename?: 'IntegrationStateView', type: FormViewType, id: string, name: string, sections: Array<(
    { __typename?: 'IntegrationStateSection' }
    & FormSectionFragment_IntegrationStateSection_Fragment
  )> };

type FormViewFragment_ModuleSettingsFormView_Fragment = { __typename?: 'ModuleSettingsFormView', type: FormViewType, id: string, name: string, sections: Array<(
    { __typename?: 'ModuleFormSection' }
    & FormSectionFragment_ModuleFormSection_Fragment
  )> };

export type FormViewFragmentFragment = FormViewFragment_DetectorReportConfigFormView_Fragment | FormViewFragment_IntegrationConfigFormView_Fragment | FormViewFragment_IntegrationStateView_Fragment | FormViewFragment_ModuleSettingsFormView_Fragment;

export type GetKineticFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetKineticFormQuery = { __typename?: 'Query', kineticForm: (
    { __typename?: 'KineticForm' }
    & KineticFormFragmentFragment
  ) };

export type GetKineticFormsQueryVariables = Exact<{
  query?: InputMaybe<KineticFormInputQuery>;
}>;


export type GetKineticFormsQuery = { __typename?: 'Query', kineticForms: { __typename?: 'KineticFormConnection', edges: Array<{ __typename?: 'KineticFormConnectionEdge', node: (
        { __typename?: 'KineticForm' }
        & KineticFormFragmentFragment
      ) }> } };

export type KineticFormsOptionsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  module?: InputMaybe<KineticModule>;
}>;


export type KineticFormsOptionsQuery = { __typename?: 'Query', kineticForms: { __typename?: 'KineticFormConnection', totalCount: number, edges: Array<{ __typename?: 'KineticFormConnectionEdge', node: { __typename?: 'KineticForm', id: string, name: string, views: Array<{ __typename?: 'KineticFormView', id: string, sections: Array<{ __typename?: 'KineticFormSection', name: string, id: string }> } | null> } }> } };

export type KineticFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type KineticFormQuery = { __typename?: 'Query', kineticForm: (
    { __typename?: 'KineticForm' }
    & KineticFormFragment
  ) };

export type KineticEventFormQueryVariables = Exact<{
  category: Scalars['String'];
}>;


export type KineticEventFormQuery = { __typename?: 'Query', kineticEventForm?: (
    { __typename?: 'KineticForm' }
    & KineticFormFragmentFragment
  ) | null };

export type GateControllerNamesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GateControllerNamesQuery = { __typename?: 'Query', gateControllers: { __typename?: 'GateControllerConnection', edges: Array<{ __typename?: 'GateControllerEdge', node: { __typename?: 'GateController', id: string, name: string } }> } };

export type GateAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GateAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string } }> } };

export type GateCameraQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateCameraQuery = { __typename?: 'Query', camera?: (
    { __typename?: 'Camera' }
    & CameraNodeFragment
  ) | null };

export type GateControllerCameraListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GateControllerCameraListQuery = { __typename?: 'Query', cameras: { __typename?: 'CameraConnection', totalCount: number, edges: Array<{ __typename?: 'CameraConnectionEdge', node: { __typename?: 'Camera', communicationStatus?: CommunicationState | null, lastSuccessfulPoll?: any | null, referencePoint?: string | null, direction?: string | null, location?: any | null, road?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type OpenInboundGatesMutationVariables = Exact<{
  id: Scalars['ID'];
  systemId: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  manualOperation?: InputMaybe<Scalars['Boolean']>;
}>;


export type OpenInboundGatesMutation = { __typename?: 'Mutation', openInboundGates: boolean };

export type OpenOutboundGatesMutationVariables = Exact<{
  id: Scalars['ID'];
  systemId: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  manualOperation?: InputMaybe<Scalars['Boolean']>;
}>;


export type OpenOutboundGatesMutation = { __typename?: 'Mutation', openOutboundGates: boolean };

export type CloseGatesMutationVariables = Exact<{
  id: Scalars['ID'];
  systemId: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  manualOperation?: InputMaybe<Scalars['Boolean']>;
}>;


export type CloseGatesMutation = { __typename?: 'Mutation', closeGates: boolean };

export type AbortGateOperationMutationVariables = Exact<{
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
}>;


export type AbortGateOperationMutation = { __typename?: 'Mutation', abortControllerOperation: boolean };

export type ToggleGateRestrictionBypassMutationVariables = Exact<{
  id: Scalars['ID'];
  value: Scalars['Boolean'];
}>;


export type ToggleGateRestrictionBypassMutation = { __typename?: 'Mutation', toggleGateRestrictionBypass: boolean };

export type ToggleSafeReversalTimeMutationVariables = Exact<{
  id: Scalars['ID'];
  value: Scalars['Boolean'];
}>;


export type ToggleSafeReversalTimeMutation = { __typename?: 'Mutation', toggleGateSafeReversalTime: boolean };

export type GateControllerPollMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GateControllerPollMutation = { __typename?: 'Mutation', multiplePoll?: Array<{ __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null, id: string }> | null };

export type GateControllerOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GateControllerOptionsQuery = { __typename?: 'Query', gateControllers: { __typename?: 'GateControllerConnection', edges: Array<{ __typename?: 'GateControllerEdge', node: { __typename?: 'GateController', name: string, id: string } }> } };

export type GateControllerDetailsSignalsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerDetailsSignalsQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', signalVerificationStatus?: Array<{ __typename?: 'GateSignalVerificationStatus', index: number, verified: boolean }> | null } };

export type GateControllerDetailsOperationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerDetailsOperationsQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', bypassingRestrictions?: boolean | null, entranceDirection: GateControllerDirection, operationStatus: GateOperationStatus, name: string } };

export type GateControllerDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerDetailsQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', operationStatus: GateOperationStatus, communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, name: string, id: string, gateCameras: Array<{ __typename?: 'GateCamera', cameraId: string }> } };

export type GateControllerDetailsMapQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerDetailsMapQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', location: any, status: GateControllerStatus, communicationStatus: CommunicationState } };

export type GateControllerDetailsArmsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerDetailsArmsQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', gateArms: Array<{ __typename?: 'GateControllerArm', direction: GateDirection, nativeId: number, position: GateArmPosition, health: GateArmHealth, name: string }> } };

export type GateControllerToggleRestrictionBypassQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerToggleRestrictionBypassQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', bypassingRestrictions?: boolean | null, name: string } };

export type GateControllerSafeReversalTimeDisabledQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerSafeReversalTimeDisabledQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', safeReversalTimeDisabled?: boolean | null, name: string } };

export type GateControllerDetailsSignsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerDetailsSignsQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', gateSigns: Array<string> } };

export type GateControllerDetailsCamerasQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerDetailsCamerasQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', gateCameras: Array<{ __typename?: 'GateCamera', cameraId: string }> } };

export type GateControllerSummaryCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerSummaryCardQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', safeReversalTimeDisabled?: boolean | null, backupScheduleActive: boolean, bypassingRestrictions?: boolean | null, communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, lastDataReceived?: any | null, operationStatus: GateOperationStatus, referencePoint: number, setControl?: GateSetControlType | null, description?: string | null, interlock: GateInterlockStatus, direction: Direction, status: GateControllerStatus, errors: Array<string>, mode: GateControlMode, road: string, name: string } };

export type LiveGateControllersSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveGateControllersSubscription = { __typename?: 'Subscription', gateControllerUpdated: { __typename?: 'GateController', id: string, bypassingRestrictions?: boolean | null, communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, lastDataReceived?: any | null, operationStatus: GateOperationStatus, referencePoint: number, description?: string | null, direction: Direction, interlock: GateInterlockStatus, status: GateControllerStatus, mode: GateControlMode, road: string, name: string } };

export type LiveGateControllerSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveGateControllerSubscription = { __typename?: 'Subscription', gateControllerUpdated: { __typename?: 'GateController', id: string } };

export type GateControllerListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GateControllerListQuery = { __typename?: 'Query', gateControllers: { __typename?: 'GateControllerConnection', totalCount: number, edges: Array<{ __typename?: 'GateControllerEdge', node: { __typename?: 'GateController', bypassingRestrictions?: boolean | null, communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, lastDataReceived?: any | null, operationStatus: GateOperationStatus, referencePoint: number, description?: string | null, direction: Direction, interlock: GateInterlockStatus, status: GateControllerStatus, mode: GateControlMode, road: string, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GateControllerSearchListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GateControllerSearchListQuery = { __typename?: 'Query', gateControllers: { __typename?: 'GateControllerConnection', edges: Array<{ __typename?: 'GateControllerEdge', node: { __typename?: 'GateController', location: any, name: string, id: string } }> } };

export type GateControllerMapListQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type GateControllerMapListQuery = { __typename?: 'Query', gateControllers: { __typename?: 'GateControllerConnection', edges: Array<{ __typename?: 'GateControllerEdge', node: { __typename?: 'GateController', location: any, status: GateControllerStatus, id: string, communicationStatus: CommunicationState } }> } };

export type LiveGateControllerListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveGateControllerListSubscription = { __typename?: 'Subscription', gateControllerUpdated: { __typename?: 'GateController', bypassingRestrictions?: boolean | null, communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, lastDataReceived?: any | null, operationStatus: GateOperationStatus, referencePoint: number, description?: string | null, direction: Direction, interlock: GateInterlockStatus, status: GateControllerStatus, mode: GateControlMode, road: string, name: string, id: string } };

export type GateSystemControllerListQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GateSystemControllerListQuery = { __typename?: 'Query', gateControllers: { __typename?: 'GateControllerConnection', edges: Array<{ __typename?: 'GateControllerEdge', node: { __typename?: 'GateController', entranceDirection: GateControllerDirection, operationStatus: GateOperationStatus, description?: string | null, gateSigns: Array<string>, location: any, interlock: GateInterlockStatus, status: GateControllerStatus, mode: GateControlMode, name: string, id: string } }> } };

export type LiveGateSystemControllerListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveGateSystemControllerListSubscription = { __typename?: 'Subscription', gateControllerUpdated: { __typename?: 'GateController', entranceDirection: GateControllerDirection, operationStatus: GateOperationStatus, description?: string | null, gateSigns: Array<string>, interlock: GateInterlockStatus, location: any, status: GateControllerStatus, mode: GateControlMode, name: string, id: string } };

export type GateControllerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', safeReversalTimeDisabled?: boolean | null, bypassingRestrictions?: boolean | null, communicationStatus: CommunicationState, lastDataReceived?: any | null, operationStatus: GateOperationStatus, referencePoint: number, direction: Direction, interlock: GateInterlockStatus, entranceDirection: GateControllerDirection, description?: string | null, gateSigns: Array<string>, location: any, status: GateControllerStatus, mode: GateControlMode, road: string, name: string, id: string, gateArms: Array<{ __typename?: 'GateControllerArm', direction: GateDirection, position: GateArmPosition, location: string, nativeId: number, health: GateArmHealth, name: string }>, gateCameras: Array<{ __typename?: 'GateCamera', cameraId: string }> } };

export type GateControllerStatusLogListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters: Array<FilterInput> | FilterInput;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GateControllerStatusLogListQuery = { __typename?: 'Query', activityLogs: { __typename?: 'ActivityLogConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ActivityLogEdge', node: { __typename?: 'ActivityLog', description?: string | null, timestamp: any, object?: any | null, type?: string | null, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GateControllerSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GateControllerSummaryQuery = { __typename?: 'Query', CLOSED: { __typename?: 'GateControllerConnection', totalCount: number }, OPEN_OUTBOUND: { __typename?: 'GateControllerConnection', totalCount: number }, OPEN_INBOUND: { __typename?: 'GateControllerConnection', totalCount: number }, MIXED: { __typename?: 'GateControllerConnection', totalCount: number }, UNKNOWN: { __typename?: 'GateControllerConnection', totalCount: number } };

export type GateOperationStepControllerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationStepControllerQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', entranceDirection: GateControllerDirection, status: GateControllerStatus, mode: GateControlMode, name: string, id: string } };

export type GateOperationDetailControllerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationDetailControllerQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', gateSigns: Array<string>, location: any, id: string, gateCameras: Array<{ __typename?: 'GateCamera', cameraId: string }>, gateArms: Array<{ __typename?: 'GateControllerArm', direction: GateDirection, position: GateArmPosition, location: string, nativeId: number, health: GateArmHealth, name: string }> } };

export type LiveGateOperationDetailControllerSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveGateOperationDetailControllerSubscription = { __typename?: 'Subscription', gateControllerUpdated: { __typename?: 'GateController', gateSigns: Array<string>, location: any, id: string, gateCameras: Array<{ __typename?: 'GateCamera', cameraId: string }>, gateArms: Array<{ __typename?: 'GateControllerArm', direction: GateDirection, position: GateArmPosition, location: string, nativeId: number, health: GateArmHealth, name: string }> } };

export type GateControllerOperationAllowedQueryVariables = Exact<{
  id: Scalars['ID'];
  type: GateOperationType;
}>;


export type GateControllerOperationAllowedQuery = { __typename?: 'Query', gateControllerOperationAllowed: { __typename?: 'GateControllerOperationResult', restrictionsBypassed: boolean, allowed: boolean, name: string, type: GateOperationType, id: string, restrictions: Array<{ __typename?: 'GateControllerOperationRestriction', status: GateControllerStatus, name: string, id: string }> } };

export type SaveGateControllerSignMessageMutationVariables = Exact<{
  input: GateControllerSignMessageInput;
}>;


export type SaveGateControllerSignMessageMutation = { __typename?: 'Mutation', saveGateControllerSignMessage: { __typename?: 'GateControllerSignMessage', id: string } };

export type DeleteGateControllerSignMessageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGateControllerSignMessageMutation = { __typename?: 'Mutation', deleteGateControllerSignMessage: boolean };

export type ActivateGateSignMessagesMutationVariables = Exact<{
  id: Scalars['ID'];
  type: Scalars['ID'];
  blankBeforeDisplay?: InputMaybe<Scalars['Boolean']>;
}>;


export type ActivateGateSignMessagesMutation = { __typename?: 'Mutation', activateGateSignMessages: Array<{ __typename?: 'JobRequest', requestId?: string | null, failure?: string | null, success: boolean, id: string }> };

export type GateControllerSignMessagesListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GateControllerSignMessagesListQuery = { __typename?: 'Query', gateControllerSignMessages: { __typename?: 'GateControllerSignMessageConnection', totalCount: number, edges: Array<{ __typename?: 'GateControllerSignMessageEdge', node: { __typename?: 'GateControllerSignMessage', controller: string, type: string, sign: string, id: string, message: (
          { __typename?: 'SignMessage' }
          & SignMessageFragment
        ) } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveGateControllerSignListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveGateControllerSignListSubscription = { __typename?: 'Subscription', gateControllerSignMessageUpdated: { __typename?: 'GateControllerSignMessage', controller: string, type: string, sign: string, id: string, message: (
      { __typename?: 'SignMessage' }
      & SignMessageFragment
    ) } };

export type GateControllerSignMessageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerSignMessageQuery = { __typename?: 'Query', gateControllerSignMessage: { __typename?: 'GateControllerSignMessage', controller: string, type: string, sign: string, id: string, message: (
      { __typename?: 'SignMessage' }
      & SignMessageFragment
    ) } };

export type GateOperationSignMessageCountQueryVariables = Exact<{
  id: Scalars['Object'];
  type: Scalars['Object'];
}>;


export type GateOperationSignMessageCountQuery = { __typename?: 'Query', gateControllerSignMessages: { __typename?: 'GateControllerSignMessageConnection', totalCount: number } };

export type GateControllerSignListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GateControllerSignListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', totalCount: number, edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint?: number | null, colorScheme?: SignColorScheme | null, direction?: string | null, location: any, road?: string | null, name: string, id: string, currentMessage?: (
          { __typename?: 'SignQueuedMessage' }
          & SignQueuedMessageFragment
        ) | null, displayType: (
          { __typename?: 'SignDisplayType' }
          & SignDisplayTypeFragment
        ), tests?: (
          { __typename?: 'SignTests' }
          & SignTestsTypeFragment
        ) | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ListGateControllerSignListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ListGateControllerSignListSubscription = { __typename?: 'Subscription', signUpdated: { __typename?: 'Sign', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint?: number | null, colorScheme?: SignColorScheme | null, direction?: string | null, location: any, road?: string | null, name: string, id: string, currentMessage?: (
      { __typename?: 'SignQueuedMessage' }
      & SignQueuedMessageFragment
    ) | null, displayType: (
      { __typename?: 'SignDisplayType' }
      & SignDisplayTypeFragment
    ), tests?: (
      { __typename?: 'SignTests' }
      & SignTestsTypeFragment
    ) | null } };

export type GateControllerSignQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateControllerSignQuery = { __typename?: 'Query', sign: { __typename?: 'Sign', communicationStatus: CommunicationState, locationDescription?: string | null, referencePoint?: number | null, capabilities: Array<SignCapability>, backgroundColor?: string | null, foregroundColor?: string | null, colorScheme?: SignColorScheme | null, direction?: string | null, road?: string | null, name: string, id: string, messagePreferences?: (
      { __typename?: 'SignMessagePreferences' }
      & SignMessagePreferencesFragment
    ) | null, currentMessage?: (
      { __typename?: 'SignQueuedMessage' }
      & SignQueuedMessageFragment
    ) | null, displayType: (
      { __typename?: 'SignDisplayType' }
      & SignDisplayTypeFragment
    ), tests?: (
      { __typename?: 'SignTests' }
      & SignTestsTypeFragment
    ) | null } };

export type LiveGateControllerSignSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveGateControllerSignSubscription = { __typename?: 'Subscription', signUpdated: { __typename?: 'Sign', communicationStatus: CommunicationState, locationDescription?: string | null, referencePoint?: number | null, capabilities: Array<SignCapability>, direction?: string | null, road?: string | null, name: string, id: string, messagePreferences?: (
      { __typename?: 'SignMessagePreferences' }
      & SignMessagePreferencesFragment
    ) | null, currentMessage?: (
      { __typename?: 'SignQueuedMessage' }
      & SignQueuedMessageFragment
    ) | null, displayType: (
      { __typename?: 'SignDisplayType' }
      & SignDisplayTypeFragment
    ), tests?: (
      { __typename?: 'SignTests' }
      & SignTestsTypeFragment
    ) | null } };

export type GateOperationSignQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationSignQuery = { __typename?: 'Query', sign: { __typename?: 'Sign', communicationStatus: CommunicationState, referencePoint?: number | null, capabilities: Array<SignCapability>, backgroundColor?: string | null, foregroundColor?: string | null, direction?: string | null, road?: string | null, name: string, id: string, currentMessage?: (
      { __typename?: 'SignQueuedMessage' }
      & SignQueuedMessageFragment
    ) | null, displayType: (
      { __typename?: 'SignDisplayType' }
      & SignDisplayTypeFragment
    ), tests?: (
      { __typename?: 'SignTests' }
      & SignTestsTypeFragment
    ) | null } };

export type LiveGateOperationSignSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveGateOperationSignSubscription = { __typename?: 'Subscription', signUpdated: { __typename?: 'Sign', communicationStatus: CommunicationState, referencePoint?: number | null, capabilities: Array<SignCapability>, direction?: string | null, road?: string | null, name: string, id: string, currentMessage?: (
      { __typename?: 'SignQueuedMessage' }
      & SignQueuedMessageFragment
    ) | null, displayType: (
      { __typename?: 'SignDisplayType' }
      & SignDisplayTypeFragment
    ), tests?: (
      { __typename?: 'SignTests' }
      & SignTestsTypeFragment
    ) | null } };

export type SaveGateSystemMutationVariables = Exact<{
  input: GateControllerSystemInput;
}>;


export type SaveGateSystemMutation = { __typename?: 'Mutation', saveGateControllerSystem: { __typename?: 'GateControllerSystem', id: string } };

export type DeleteGateSystemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGateSystemMutation = { __typename?: 'Mutation', deleteGateControllerSystem: boolean };

export type DeleteGateControllerSystemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGateControllerSystemMutation = { __typename?: 'Mutation', deleteGateControllerSystem: boolean };

export type GateSystemListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GateSystemListQuery = { __typename?: 'Query', gateControllerSystems: { __typename?: 'GateControllerSystemConnection', totalCount: number, edges: Array<{ __typename?: 'GateControllerSystemEdge', node: { __typename?: 'GateControllerSystem', outboundDirection: Direction, inboundDirection: Direction, activeOperation?: string | null, description?: string | null, status: GateControllerStatus, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveGateSystemListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveGateSystemListSubscription = { __typename?: 'Subscription', gateControllerSystemUpdated: { __typename?: 'GateControllerSystem', outboundDirection: Direction, inboundDirection: Direction, activeOperation?: string | null, description?: string | null, status: GateControllerStatus, name: string, id: string } };

export type GateSystemSimpleListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type GateSystemSimpleListQuery = { __typename?: 'Query', gateControllerSystems: { __typename?: 'GateControllerSystemConnection', edges: Array<{ __typename?: 'GateControllerSystemEdge', node: { __typename?: 'GateControllerSystem', name: string, id: string } }> } };

export type GateSystemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSystemQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', outboundControllers: Array<string>, minReversalTimeSecs?: number | null, inboundControllers: Array<string>, outboundDirection: Direction, inboundDirection: Direction, managingUser?: string | null, description?: string | null, tollPoints: Array<string>, settings: any, routes: Array<string>, signs: Array<string>, name: string, id: string, detectors?: Array<string> | null, alertIntegrations?: Array<string> | null, operations: Array<{ __typename?: 'GateOperationNode', droppable: boolean, parent: number, data: any, text: string, id: number }>, groups: Array<{ __typename?: 'GateGroup', referencePoint: number, controllers: Array<string>, tollPoints: Array<string>, direction: GateDirection, rampType: GateGroupRampType, position: number, signs: Array<string>, name: string, id: string }> } };

export type LiveGateSystemSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveGateSystemSubscription = { __typename?: 'Subscription', gateControllerSystemUpdated: { __typename?: 'GateControllerSystem', outboundDirection: Direction, inboundDirection: Direction, managingUser?: string | null, description?: string | null, inboundControllers: Array<string>, outboundControllers: Array<string>, name: string, id: string } };

export type DataSourceNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DataSourceNameQuery = { __typename?: 'Query', dataSource: { __typename?: 'DataSource', value: string } };

export type IntegrationNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntegrationNameQuery = { __typename?: 'Query', integration?: { __typename?: 'Integration', name: string } | null };

export type GateOperationSystemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationSystemQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', name: string, id: string } };

export type GateSystemControllerSearchListQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GateSystemControllerSearchListQuery = { __typename?: 'Query', gateControllerSystems: { __typename?: 'GateControllerSystemConnection', edges: Array<{ __typename?: 'GateControllerSystemEdge', node: { __typename?: 'GateControllerSystem', outboundDirection: Direction, inboundDirection: Direction, inboundControllers: Array<string>, outboundControllers: Array<string> } }> } };

export type GateSystemDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSystemDetailsQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', description?: string | null, name: string, id: string } };

export type GateSystemSchematicQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSystemSchematicQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', outboundDirection: Direction, inboundDirection: Direction, status: GateControllerStatus, groups: Array<{ __typename?: 'GateGroup', controllers: Array<string>, tollPoints: Array<string>, direction: GateDirection, rampType: GateGroupRampType, position: number, signs: Array<string>, name: string, id: string }> } };

export type GateSystemDetailsControllersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSystemDetailsControllersQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', outboundControllers: Array<string>, inboundControllers: Array<string> } };

export type GateSystemDetailsTollPointsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSystemDetailsTollPointsQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', tollPoints: Array<string> } };

export type GateSystemDetailsControllersListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GateSystemDetailsControllersListQuery = { __typename?: 'Query', gateControllers: { __typename?: 'GateControllerConnection', totalCount: number, edges: Array<{ __typename?: 'GateControllerEdge', node: { __typename?: 'GateController', communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, operationStatus: GateOperationStatus, referencePoint: number, direction: Direction, interlock: GateInterlockStatus, status: GateControllerStatus, mode: GateControlMode, road: string, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GateSystemTollPointsQueryVariables = Exact<{
  tollPoints: Scalars['Object'];
}>;


export type GateSystemTollPointsQuery = { __typename?: 'Query', tollingPoints: { __typename?: 'TollingPointsConnection', edges: Array<{ __typename?: 'TollingPointsConnectionEdge', node: { __typename?: 'TollingPoint', id: string, name: string, road?: string | null, direction?: Direction | null, referencePoint?: number | null } }> } };

export type GateSystemSignsQueryVariables = Exact<{
  signs: Scalars['Object'];
}>;


export type GateSystemSignsQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', id: string, name: string, road?: string | null, direction?: string | null, referencePoint?: number | null } }> } };

export type GateSystemControllersQueryVariables = Exact<{
  controllers: Scalars['Object'];
}>;


export type GateSystemControllersQuery = { __typename?: 'Query', gateControllers: { __typename?: 'GateControllerConnection', edges: Array<{ __typename?: 'GateControllerEdge', node: { __typename?: 'GateController', id: string, name: string, road: string, direction: Direction, referencePoint: number } }> } };

export type GateSchematicControllerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSchematicControllerQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, operationStatus: GateOperationStatus, interlock: GateInterlockStatus, status: GateControllerStatus, name: string, mode: GateControlMode, id: string } };

export type LiveGateSchematicControllerSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveGateSchematicControllerSubscription = { __typename?: 'Subscription', gateControllerUpdated: { __typename?: 'GateController', communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, operationStatus: GateOperationStatus, interlock: GateInterlockStatus, status: GateControllerStatus, name: string, mode: GateControlMode, id: string } };

export type GateSystemSchematicGroupsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSystemSchematicGroupsQuery = { __typename?: 'Query', gateSystemGroups: Array<{ __typename?: 'GateGroupUpdate', controllers: Array<string>, direction: GateDirection, rampType: GateGroupRampType, position: number, status: GateControllerStatus, name: string, id: string }> };

export type GateSystemSchematicStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSystemSchematicStatusQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', outboundDirection: Direction, inboundDirection: Direction, activeOperation?: string | null, status: GateControllerStatus } };

export type LiveGateSystemSchematicSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveGateSystemSchematicSubscription = { __typename?: 'Subscription', gateControllerSystemUpdated: { __typename?: 'GateControllerSystem', status: GateControllerStatus } };

export type LiveGateGroupSchematicSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveGateGroupSchematicSubscription = { __typename?: 'Subscription', gateGroupUpdated: { __typename?: 'GateGroupUpdate', id: string } };

export type GateSystemRoutesQueryVariables = Exact<{
  routes: Scalars['Object'];
}>;


export type GateSystemRoutesQuery = { __typename?: 'Query', locationRoutes: { __typename?: 'LocationRouteConnection', edges: Array<{ __typename?: 'LocationRouteConnectionEdge', node: { __typename?: 'LocationRoute', id: string, name: string, direction: string } }> } };

export type GateSystemDetectorsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSystemDetectorsQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', id: string, detectors?: Array<string> | null } };

export type GateSystemAlertsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSystemAlertsQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', id: string, alertIntegrations?: Array<string> | null } };

export type GateSafeReversalTimeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSafeReversalTimeQuery = { __typename?: 'Query', gateSafeReversalTime: { __typename?: 'GateSafeReversalTime', minReversalTimeInMillis: number, remainingTimeInMillis: number, disabled: boolean } };

export type ViewGateSchematicEntitiesQueryVariables = Exact<{
  id: Scalars['ID'];
  integrationIds: Scalars['Object'];
  integrationCount: Scalars['Int'];
}>;


export type ViewGateSchematicEntitiesQuery = { __typename?: 'Query', gateSystemGroups: Array<{ __typename?: 'GateGroupUpdate', controllers: Array<string>, direction: GateDirection, rampType: GateGroupRampType, position: number, status: GateControllerStatus, name: string, id: string }>, gateControllers: { __typename?: 'GateControllerConnection', edges: Array<{ __typename?: 'GateControllerEdge', node: { __typename?: 'GateController', communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, systemEnabled: boolean, status: GateControllerStatus, name: string, mode: GateControlMode, id: string } }> } };

export type GateSchematicControllersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateSchematicControllersQuery = { __typename?: 'Query', gateControllerSystem: { __typename?: 'GateControllerSystem', outboundControllers: Array<string>, inboundControllers: Array<string> } };

export type LiveGateSchematicGateSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveGateSchematicGateSubscription = { __typename?: 'Subscription', gateControllerUpdated: { __typename?: 'GateController', communicationStatus: CommunicationState, entranceDirection: GateControllerDirection, systemEnabled: boolean, status: GateControllerStatus, name: string, mode: GateControlMode, id: string } };

export type LiveGateSchematicGroupSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveGateSchematicGroupSubscription = { __typename?: 'Subscription', gateGroupUpdated: { __typename?: 'GateGroupUpdate', controllers: Array<string>, direction: GateDirection, rampType: GateGroupRampType, position: number, status: GateControllerStatus, name: string, id: string } };

export type GateOperationCreateMutationVariables = Exact<{
  id: Scalars['ID'];
  direction: GateDirection;
  type: GateOperationType;
}>;


export type GateOperationCreateMutation = { __typename?: 'Mutation', gateOperationCreate: boolean };

export type GateOperationInitiateMutationVariables = Exact<{
  id: Scalars['ID'];
  operationId: Scalars['ID'];
}>;


export type GateOperationInitiateMutation = { __typename?: 'Mutation', gateOperationInitiate: { __typename?: 'GateOperation', steps: Array<{ __typename?: 'GateOperationStep', userId?: string | null, id: string }> } };

export type GateOperationFinishMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationFinishMutation = { __typename?: 'Mutation', gateOperationFinish: boolean };

export type GateOperationAbortMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationAbortMutation = { __typename?: 'Mutation', gateOperationAbort: boolean };

export type GateOperationLogInMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationLogInMutation = { __typename?: 'Mutation', gateOperationLogIn?: string | null };

export type GateOperationNextStepMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationNextStepMutation = { __typename?: 'Mutation', gateOperationNextStep?: string | null };

export type GateOperationActivityMutationVariables = Exact<{
  input: GateOperationActivityInput;
}>;


export type GateOperationActivityMutation = { __typename?: 'Mutation', gateOperationActivity: boolean };

export type ActivateGateTollingPointsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateGateTollingPointsMutation = { __typename?: 'Mutation', activateGateTollPoints: Array<boolean> };

export type ReverseDetectorDirectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReverseDetectorDirectionMutation = { __typename?: 'Mutation', reverseDetectorDirection: Array<boolean> };

export type ReverseAlertDirectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReverseAlertDirectionMutation = { __typename?: 'Mutation', reverseAlertDirection: Array<boolean> };

export type GateOperationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationQuery = { __typename?: 'Query', gateOperation?: { __typename?: 'GateOperation', startTime: any, system: string, users: Array<string>, type: GateOperationType, name: string, id: string, steps: Array<{ __typename?: 'GateOperationStep', userDisplayName?: string | null, isCompleted: boolean, stepType: GateOperationStepType, userId?: string | null, group?: string | null, name: string, id: string, tasks: Array<{ __typename?: 'GateOperationTask', confirmOptionRequired: boolean, blankBeforeDisplay?: boolean | null, confirmDataSource?: string | null, notesRequired?: boolean | null, resourcePlan?: string | null, isCompleted: boolean, messageType?: string | null, controller?: string | null, taskType: GateOperationTaskType, name: string, id: string }> }> } | null };

export type GateOperationOptionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationOptionsQuery = { __typename?: 'Query', gateOperationOptions: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null }> };

export type GateOperationControllerDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationControllerDetailsQuery = { __typename?: 'Query', gateController: { __typename?: 'GateController', gateSigns: Array<string>, gateTours: Array<string>, name: string, gateCameras: Array<{ __typename?: 'GateCamera', cameraId: string }>, gateArms: Array<{ __typename?: 'GateControllerArm', nativeId: number, position: GateArmPosition }> } };

export type GateOperationHistoryDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GateOperationHistoryDetailQuery = { __typename?: 'Query', gateOperationHistory?: { __typename?: 'GateOperationHistory', operationId: string, system: string, name: string } | null };

export type GateOperationHistoryListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GateOperationHistoryListQuery = { __typename?: 'Query', gateOperationHistoryList: { __typename?: 'GateOperationHistoryConnection', totalCount: number, edges: Array<{ __typename?: 'GateOperationHistoryEdge', node: { __typename?: 'GateOperationHistory', operationId: string, startTime: any, endTime?: any | null, result: GateOperationResult, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveGateOperationSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveGateOperationSubscription = { __typename?: 'Subscription', gateOperationUpdated: { __typename?: 'GateOperation', startTime: any, system: string, users: Array<string>, type: GateOperationType, name: string, id: string, steps: Array<{ __typename?: 'GateOperationStep', userDisplayName?: string | null, isCompleted: boolean, stepType: GateOperationStepType, userId?: string | null, group?: string | null, name: string, id: string, tasks: Array<{ __typename?: 'GateOperationTask', confirmOptionRequired: boolean, blankBeforeDisplay?: boolean | null, confirmDataSource?: string | null, notesRequired?: boolean | null, resourcePlan?: string | null, isCompleted: boolean, messageType?: string | null, controller?: string | null, taskType: GateOperationTaskType, name: string, id: string }> }> } };

export type GateOperationValidateQueryVariables = Exact<{
  id: Scalars['ID'];
  operationId: Scalars['ID'];
}>;


export type GateOperationValidateQuery = { __typename?: 'Query', gateOperationValidate: boolean };

export type GateOperationSelectStepMutationVariables = Exact<{
  id: Scalars['ID'];
  stepId: Scalars['ID'];
}>;


export type GateOperationSelectStepMutation = { __typename?: 'Mutation', gateOperationSelectStep?: string | null };

export type GateOperationSkipStepMutationVariables = Exact<{
  id: Scalars['ID'];
  stepId: Scalars['ID'];
}>;


export type GateOperationSkipStepMutation = { __typename?: 'Mutation', gateOperationSkipStep?: string | null };

export type GateOperationJobSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GateOperationJobSubscription = { __typename?: 'Subscription', gateControllerJobResults: { __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null, id: string } };

export type GateSettingSectionFragment = { __typename?: 'ModuleFormSection', id: string, name: string, fields: Array<(
    { __typename?: 'FieldConfig' }
    & KineticFieldConfigFragment
  ) | null> };

type GateSettingView_DetectorReportConfigFormView_Fragment = { __typename?: 'DetectorReportConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'DetectorReportConfigFormSection' }> };

type GateSettingView_IntegrationConfigFormView_Fragment = { __typename?: 'IntegrationConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'IntegrationConfigFormSection' }> };

type GateSettingView_IntegrationStateView_Fragment = { __typename?: 'IntegrationStateView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'IntegrationStateSection' }> };

type GateSettingView_ModuleSettingsFormView_Fragment = { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, sections: Array<(
    { __typename?: 'ModuleFormSection' }
    & GateSettingSectionFragment
  )> };

export type GateSettingViewFragment = GateSettingView_DetectorReportConfigFormView_Fragment | GateSettingView_IntegrationConfigFormView_Fragment | GateSettingView_IntegrationStateView_Fragment | GateSettingView_ModuleSettingsFormView_Fragment;

type GateSettingViewsRecursive_DetectorReportConfigFormView_Fragment = { __typename?: 'DetectorReportConfigFormView', views: Array<(
    { __typename?: 'DetectorReportConfigFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & GateSettingView_DetectorReportConfigFormView_Fragment
      )> }
      & GateSettingView_DetectorReportConfigFormView_Fragment
    )> }
    & GateSettingView_DetectorReportConfigFormView_Fragment
  )> };

type GateSettingViewsRecursive_IntegrationConfigFormView_Fragment = { __typename?: 'IntegrationConfigFormView', views: Array<(
    { __typename?: 'IntegrationConfigFormView', views: Array<(
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & GateSettingView_IntegrationConfigFormView_Fragment
      )> }
      & GateSettingView_IntegrationConfigFormView_Fragment
    )> }
    & GateSettingView_IntegrationConfigFormView_Fragment
  )> };

type GateSettingViewsRecursive_IntegrationStateView_Fragment = { __typename?: 'IntegrationStateView', views: Array<(
    { __typename?: 'IntegrationStateView', views: Array<(
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & GateSettingView_IntegrationStateView_Fragment
      )> }
      & GateSettingView_IntegrationStateView_Fragment
    )> }
    & GateSettingView_IntegrationStateView_Fragment
  )> };

type GateSettingViewsRecursive_ModuleSettingsFormView_Fragment = { __typename?: 'ModuleSettingsFormView', views: Array<(
    { __typename?: 'DetectorReportConfigFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & GateSettingView_DetectorReportConfigFormView_Fragment
      )> }
      & GateSettingView_DetectorReportConfigFormView_Fragment
    )> }
    & GateSettingView_DetectorReportConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationConfigFormView', views: Array<(
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & GateSettingView_IntegrationConfigFormView_Fragment
      )> }
      & GateSettingView_IntegrationConfigFormView_Fragment
    )> }
    & GateSettingView_IntegrationConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationStateView', views: Array<(
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & GateSettingView_IntegrationStateView_Fragment
      )> }
      & GateSettingView_IntegrationStateView_Fragment
    )> }
    & GateSettingView_IntegrationStateView_Fragment
  ) | (
    { __typename?: 'ModuleSettingsFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & GateSettingView_DetectorReportConfigFormView_Fragment
      )> }
      & GateSettingView_DetectorReportConfigFormView_Fragment
    ) | (
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & GateSettingView_IntegrationConfigFormView_Fragment
      )> }
      & GateSettingView_IntegrationConfigFormView_Fragment
    ) | (
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & GateSettingView_IntegrationStateView_Fragment
      )> }
      & GateSettingView_IntegrationStateView_Fragment
    ) | (
      { __typename?: 'ModuleSettingsFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & GateSettingView_DetectorReportConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationConfigFormView' }
        & GateSettingView_IntegrationConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationStateView' }
        & GateSettingView_IntegrationStateView_Fragment
      ) | (
        { __typename?: 'ModuleSettingsFormView' }
        & GateSettingView_ModuleSettingsFormView_Fragment
      )> }
      & GateSettingView_ModuleSettingsFormView_Fragment
    )> }
    & GateSettingView_ModuleSettingsFormView_Fragment
  )> };

export type GateSettingViewsRecursiveFragment = GateSettingViewsRecursive_DetectorReportConfigFormView_Fragment | GateSettingViewsRecursive_IntegrationConfigFormView_Fragment | GateSettingViewsRecursive_IntegrationStateView_Fragment | GateSettingViewsRecursive_ModuleSettingsFormView_Fragment;

export type GateSettingsFragment = { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, views: Array<(
    { __typename?: 'DetectorReportConfigFormView' }
    & GateSettingViewsRecursive_DetectorReportConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationConfigFormView' }
    & GateSettingViewsRecursive_IntegrationConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationStateView' }
    & GateSettingViewsRecursive_IntegrationStateView_Fragment
  ) | (
    { __typename?: 'ModuleSettingsFormView' }
    & GateSettingViewsRecursive_ModuleSettingsFormView_Fragment
  )>, sections: Array<(
    { __typename?: 'ModuleFormSection' }
    & GateSettingSectionFragment
  )> };

export type SaveGateModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveGateModuleSettingsMutation = { __typename?: 'Mutation', saveGateModuleSettings?: boolean | null };

export type GateModuleSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GateModuleSettingsQuery = { __typename?: 'Query', gateModuleSettings: (
    { __typename?: 'ModuleSettingsFormView' }
    & GateSettingsFragment
  ) };

export type HarDeleteMessageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HarDeleteMessageMutation = { __typename?: 'Mutation', harDeleteMessage: boolean };

export type HarSaveMessageMutationVariables = Exact<{
  input: HarMessageInput;
}>;


export type HarSaveMessageMutation = { __typename?: 'Mutation', harSaveMessage: { __typename?: 'HarMessage', id: string } };

export type HarMessageListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type HarMessageListQuery = { __typename?: 'Query', harMessages: { __typename?: 'HarMessageConnection', totalCount: number, edges: Array<{ __typename?: 'HarMessageEdge', node: { __typename?: 'HarMessage', text: string, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveHarMessageListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveHarMessageListSubscription = { __typename?: 'Subscription', harMessageUpdated: { __typename?: 'HarMessage', text: string, name: string, id: string } };

export type HarMessageDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HarMessageDetailQuery = { __typename?: 'Query', harMessage?: { __typename?: 'HarMessage', text: string, name: string, id: string } | null };

export type HarDeletePlaylistMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HarDeletePlaylistMutation = { __typename?: 'Mutation', harDeletePlaylist: boolean };

export type HarSavePlaylistMutationVariables = Exact<{
  input: HarPlaylistInput;
}>;


export type HarSavePlaylistMutation = { __typename?: 'Mutation', harSavePlaylist: { __typename?: 'HarPlaylist', id: string } };

export type HarPlaylistListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type HarPlaylistListQuery = { __typename?: 'Query', harPlaylists: { __typename?: 'HarPlaylistConnection', totalCount: number, edges: Array<{ __typename?: 'HarPlaylistEdge', node: { __typename?: 'HarPlaylist', name: string, id: string, messages: Array<{ __typename?: 'HarMessage', name: string, text: string, id: string }>, priority: { __typename?: 'HarPriority', priority: number, name: string } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveHarPlaylistListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveHarPlaylistListSubscription = { __typename?: 'Subscription', harPlaylistUpdated: { __typename?: 'HarPlaylist', name: string, id: string, messages: Array<{ __typename?: 'HarMessage', name: string, text: string, id: string }>, priority: { __typename?: 'HarPriority', priority: number, name: string } } };

export type HarPlaylistDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HarPlaylistDetailQuery = { __typename?: 'Query', harPlaylist?: { __typename?: 'HarPlaylist', name: string, id: string, messages: Array<{ __typename?: 'HarMessage', id: string }>, priority: { __typename?: 'HarPriority', priority: number, name: string, id: string } } | null };

export type HarDeletePriorityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HarDeletePriorityMutation = { __typename?: 'Mutation', harDeletePriority: boolean };

export type HarSavePriorityMutationVariables = Exact<{
  input: HarPriorityInput;
}>;


export type HarSavePriorityMutation = { __typename?: 'Mutation', harSavePriority: { __typename?: 'HarPriority', id: string } };

export type HarPriorityListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type HarPriorityListQuery = { __typename?: 'Query', harPriorities: { __typename?: 'HarPriorityConnection', totalCount: number, edges: Array<{ __typename?: 'HarPriorityEdge', node: { __typename?: 'HarPriority', messageDefault: boolean, description?: string | null, priority: number, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveHarPriorityListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveHarPriorityListSubscription = { __typename?: 'Subscription', harPriorityUpdated: { __typename?: 'HarPriority', messageDefault: boolean, description?: string | null, priority: number, name: string, id: string } };

export type HarPriorityDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HarPriorityDetailQuery = { __typename?: 'Query', harPriority?: { __typename?: 'HarPriority', messageDefault: boolean, description?: string | null, priority: number, name: string, id: string } | null };

export type HarSettingSectionFragment = { __typename?: 'ModuleFormSection', id: string, name: string, fields: Array<(
    { __typename?: 'FieldConfig' }
    & FieldConfigFieldsFragment
  ) | null> };

type HarSettingView_DetectorReportConfigFormView_Fragment = { __typename?: 'DetectorReportConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'DetectorReportConfigFormSection' }> };

type HarSettingView_IntegrationConfigFormView_Fragment = { __typename?: 'IntegrationConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'IntegrationConfigFormSection' }> };

type HarSettingView_IntegrationStateView_Fragment = { __typename?: 'IntegrationStateView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'IntegrationStateSection' }> };

type HarSettingView_ModuleSettingsFormView_Fragment = { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, sections: Array<(
    { __typename?: 'ModuleFormSection' }
    & HarSettingSectionFragment
  )> };

export type HarSettingViewFragment = HarSettingView_DetectorReportConfigFormView_Fragment | HarSettingView_IntegrationConfigFormView_Fragment | HarSettingView_IntegrationStateView_Fragment | HarSettingView_ModuleSettingsFormView_Fragment;

type HarSettingViewsRecursive_DetectorReportConfigFormView_Fragment = { __typename?: 'DetectorReportConfigFormView', views: Array<(
    { __typename?: 'DetectorReportConfigFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & HarSettingView_DetectorReportConfigFormView_Fragment
      )> }
      & HarSettingView_DetectorReportConfigFormView_Fragment
    )> }
    & HarSettingView_DetectorReportConfigFormView_Fragment
  )> };

type HarSettingViewsRecursive_IntegrationConfigFormView_Fragment = { __typename?: 'IntegrationConfigFormView', views: Array<(
    { __typename?: 'IntegrationConfigFormView', views: Array<(
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & HarSettingView_IntegrationConfigFormView_Fragment
      )> }
      & HarSettingView_IntegrationConfigFormView_Fragment
    )> }
    & HarSettingView_IntegrationConfigFormView_Fragment
  )> };

type HarSettingViewsRecursive_IntegrationStateView_Fragment = { __typename?: 'IntegrationStateView', views: Array<(
    { __typename?: 'IntegrationStateView', views: Array<(
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & HarSettingView_IntegrationStateView_Fragment
      )> }
      & HarSettingView_IntegrationStateView_Fragment
    )> }
    & HarSettingView_IntegrationStateView_Fragment
  )> };

type HarSettingViewsRecursive_ModuleSettingsFormView_Fragment = { __typename?: 'ModuleSettingsFormView', views: Array<(
    { __typename?: 'DetectorReportConfigFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & HarSettingView_DetectorReportConfigFormView_Fragment
      )> }
      & HarSettingView_DetectorReportConfigFormView_Fragment
    )> }
    & HarSettingView_DetectorReportConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationConfigFormView', views: Array<(
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & HarSettingView_IntegrationConfigFormView_Fragment
      )> }
      & HarSettingView_IntegrationConfigFormView_Fragment
    )> }
    & HarSettingView_IntegrationConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationStateView', views: Array<(
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & HarSettingView_IntegrationStateView_Fragment
      )> }
      & HarSettingView_IntegrationStateView_Fragment
    )> }
    & HarSettingView_IntegrationStateView_Fragment
  ) | (
    { __typename?: 'ModuleSettingsFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & HarSettingView_DetectorReportConfigFormView_Fragment
      )> }
      & HarSettingView_DetectorReportConfigFormView_Fragment
    ) | (
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & HarSettingView_IntegrationConfigFormView_Fragment
      )> }
      & HarSettingView_IntegrationConfigFormView_Fragment
    ) | (
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & HarSettingView_IntegrationStateView_Fragment
      )> }
      & HarSettingView_IntegrationStateView_Fragment
    ) | (
      { __typename?: 'ModuleSettingsFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & HarSettingView_DetectorReportConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationConfigFormView' }
        & HarSettingView_IntegrationConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationStateView' }
        & HarSettingView_IntegrationStateView_Fragment
      ) | (
        { __typename?: 'ModuleSettingsFormView' }
        & HarSettingView_ModuleSettingsFormView_Fragment
      )> }
      & HarSettingView_ModuleSettingsFormView_Fragment
    )> }
    & HarSettingView_ModuleSettingsFormView_Fragment
  )> };

export type HarSettingViewsRecursiveFragment = HarSettingViewsRecursive_DetectorReportConfigFormView_Fragment | HarSettingViewsRecursive_IntegrationConfigFormView_Fragment | HarSettingViewsRecursive_IntegrationStateView_Fragment | HarSettingViewsRecursive_ModuleSettingsFormView_Fragment;

export type HarSettingsFragment = { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, views: Array<(
    { __typename?: 'DetectorReportConfigFormView' }
    & HarSettingViewsRecursive_DetectorReportConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationConfigFormView' }
    & HarSettingViewsRecursive_IntegrationConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationStateView' }
    & HarSettingViewsRecursive_IntegrationStateView_Fragment
  ) | (
    { __typename?: 'ModuleSettingsFormView' }
    & HarSettingViewsRecursive_ModuleSettingsFormView_Fragment
  )>, sections: Array<(
    { __typename?: 'ModuleFormSection' }
    & HarSettingSectionFragment
  )> };

export type HarSaveSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type HarSaveSettingsMutation = { __typename?: 'Mutation', harSaveModuleSettings?: boolean | null };

export type HarSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type HarSettingsQuery = { __typename?: 'Query', harModuleSettings: (
    { __typename?: 'ModuleSettingsFormView' }
    & HarSettingsFragment
  ) };

export type HarQueuedPlaylistFragment = { __typename?: 'HarQueuedPlaylist', expirationTime?: any | null, name: string, id: string, messages: Array<{ __typename?: 'HarMessage', text: string, name: string, id: string }>, associations: Array<{ __typename?: 'HarAssociation', name: string, id: string }>, priority: { __typename?: 'HarPriority', priority: number, name: string }, user: { __typename?: 'HarUser', name: string, id: string } };

export type HarTransmitterPollMutationVariables = Exact<{
  transmitters: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type HarTransmitterPollMutation = { __typename?: 'Mutation', harTransmitterPoll: Array<{ __typename?: 'JobRequest', success: boolean }> };

export type HarTransmitterSetPowerLevelMutationVariables = Exact<{
  transmitter: Scalars['ID'];
  level: Scalars['Int'];
}>;


export type HarTransmitterSetPowerLevelMutation = { __typename?: 'Mutation', harTransmitterSetPowerLevel: { __typename?: 'JobRequest', success: boolean } };

export type HarTransmitterSetAttenuatorLevelMutationVariables = Exact<{
  transmitter: Scalars['ID'];
  level: Scalars['Int'];
}>;


export type HarTransmitterSetAttenuatorLevelMutation = { __typename?: 'Mutation', harTransmitterSetAttenuatorLevel: { __typename?: 'JobRequest', success: boolean } };

export type HarTransmitterSetVoiceSpeedMutationVariables = Exact<{
  transmitter: Scalars['ID'];
  speed: Scalars['Int'];
}>;


export type HarTransmitterSetVoiceSpeedMutation = { __typename?: 'Mutation', harTransmitterSetVoiceSpeed: { __typename?: 'JobRequest', success: boolean } };

export type HarTransmitterEnableWeatherRadioMutationVariables = Exact<{
  transmitter: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type HarTransmitterEnableWeatherRadioMutation = { __typename?: 'Mutation', harTransmitterSetWeatherRadio: { __typename?: 'JobRequest', success: boolean } };

export type HarTransmitterPostMutationVariables = Exact<{
  post: Array<HarTransmitterPostInput> | HarTransmitterPostInput;
}>;


export type HarTransmitterPostMutation = { __typename?: 'Mutation', harTransmitterPostPlaylist: Array<{ __typename?: 'JobRequest', success: boolean }> };

export type HarTransmitterBlankMutationVariables = Exact<{
  transmitters: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type HarTransmitterBlankMutation = { __typename?: 'Mutation', harTransmitterBlank: Array<{ __typename?: 'JobRequest', success: boolean }> };

export type HarTransmitterRemoveMutationVariables = Exact<{
  playlists: Array<Scalars['ID']> | Scalars['ID'];
  transmitter: Scalars['ID'];
}>;


export type HarTransmitterRemoveMutation = { __typename?: 'Mutation', harTransmitterRemovePlaylist: { __typename?: 'JobRequest', success: boolean } };

export type HarTransmitterListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type HarTransmitterListQuery = { __typename?: 'Query', harTransmitters: { __typename?: 'HarTransmitterConnection', totalCount: number, edges: Array<{ __typename?: 'HarTransmitterEdge', node: { __typename?: 'HarTransmitter', communicationStatus: CommunicationState, lastDataReceived?: any | null, broadcastState: HarBroadcastState, referencePoint?: number | null, lastOperation: string, commandState: HarCommandState, syncState: HarSyncState, direction?: string | null, road?: string | null, name: string, id: string, currentPlaylist?: { __typename?: 'HarQueuedPlaylist', name: string, priority: { __typename?: 'HarPriority', priority: number } } | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveHarTransmitterListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveHarTransmitterListSubscription = { __typename?: 'Subscription', harTransmitterUpdated: { __typename?: 'HarTransmitter', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint?: number | null, broadcastState: HarBroadcastState, lastOperation: string, commandState: HarCommandState, syncState: HarSyncState, direction?: string | null, road?: string | null, name: string, id: string, currentPlaylist?: { __typename?: 'HarQueuedPlaylist', name: string, priority: { __typename?: 'HarPriority', priority: number } } | null } };

export type HarTransmitterMapQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type HarTransmitterMapQuery = { __typename?: 'Query', harTransmitters: { __typename?: 'HarTransmitterConnection', edges: Array<{ __typename?: 'HarTransmitterEdge', node: { __typename?: 'HarTransmitter', broadcastState: HarBroadcastState, location: any, name: string, id: string } }> } };

export type LiveHarTransmitterMapSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveHarTransmitterMapSubscription = { __typename?: 'Subscription', harTransmitterUpdated: { __typename?: 'HarTransmitter', broadcastState: HarBroadcastState, location: any, name: string, id: string } };

export type HarTransmitterSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type HarTransmitterSummaryQuery = { __typename?: 'Query', STATE_QUIET: { __typename?: 'HarTransmitterConnection', totalCount: number }, STATE_PLAYING: { __typename?: 'HarTransmitterConnection', totalCount: number }, WEATHER_RADIO: { __typename?: 'HarTransmitterConnection', totalCount: number } };

export type HarTransmitterDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HarTransmitterDetailQuery = { __typename?: 'Query', harTransmitter?: { __typename?: 'HarTransmitter', communicationStatus: CommunicationState, lastDataReceived?: any | null, attenuatorLevel: number, referencePoint?: number | null, broadcastState: HarBroadcastState, hardwareState: HarHardwareState, lastOperation: string, commandState: HarCommandState, voiceSpeed: number, powerLevel: number, syncState: HarSyncState, direction?: string | null, location: any, road?: string | null, name: string, id: string, currentPlaylist?: (
      { __typename?: 'HarQueuedPlaylist' }
      & HarQueuedPlaylistFragment
    ) | null, queuedPlaylists: Array<(
      { __typename?: 'HarQueuedPlaylist' }
      & HarQueuedPlaylistFragment
    )> } | null };

export type LiveHarTransmitterDetailSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveHarTransmitterDetailSubscription = { __typename?: 'Subscription', harTransmitterUpdated: { __typename?: 'HarTransmitter', communicationStatus: CommunicationState, lastDataReceived?: any | null, attenuatorLevel: number, referencePoint?: number | null, broadcastState: HarBroadcastState, hardwareState: HarHardwareState, lastOperation: string, commandState: HarCommandState, voiceSpeed: number, powerLevel: number, syncState: HarSyncState, direction?: string | null, location: any, road?: string | null, name: string, id: string, currentPlaylist?: (
      { __typename?: 'HarQueuedPlaylist' }
      & HarQueuedPlaylistFragment
    ) | null, queuedPlaylists: Array<(
      { __typename?: 'HarQueuedPlaylist' }
      & HarQueuedPlaylistFragment
    )> } };

export type HarTransmitterHistoryListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type HarTransmitterHistoryListQuery = { __typename?: 'Query', harTransmitterStateHistory: { __typename?: 'HarTransmitterStateHistoryConnection', totalCount: number, edges: Array<{ __typename?: 'HarTransmitterStateHistoryEdge', node: { __typename?: 'HarTransmitterStateHistory', communicationState: CommunicationState, broadcastState: HarBroadcastState, timestamp: any, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type IntegrationsFormViewFragment = { __typename?: 'IntegrationConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'IntegrationConfigFormSection', id: string, name: string, fields: Array<(
      { __typename?: 'FieldConfig' }
      & FieldConfigRecursiveFragment
    ) | null> }> };

export type IntegrationsFormViewRecursiveFragment = { __typename?: 'IntegrationsForm', views: Array<(
    { __typename?: 'IntegrationConfigFormView', views: Array<(
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView', views: Array<(
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & IntegrationsFormViewFragment
          )> }
          & IntegrationsFormViewFragment
        )> }
        & IntegrationsFormViewFragment
      )> }
      & IntegrationsFormViewFragment
    )> }
    & IntegrationsFormViewFragment
  ) | null> };

export type IntegrationsFormFragment = (
  { __typename?: 'IntegrationsForm', id: string, name: string, description?: string | null, integrationType: IntegrationType, locationSupported?: boolean | null, areaSupported?: boolean | null, extraConfig: any }
  & IntegrationsFormViewRecursiveFragment
);

export type IntegrationConfigFragment = { __typename?: 'IntegrationConfig', location?: any | null, settings?: any | null, integrationType: IntegrationType, associatedLocation?: { __typename?: 'Location', id: string } | null, form: (
    { __typename?: 'IntegrationsForm' }
    & IntegrationsFormFragment
  ) };

export type SavedIntegrationFragment = { __typename?: 'Integration', id: string, name: string, description?: string | null, systemEnabled: boolean, assetIdentifier?: string | null, config: (
    { __typename?: 'IntegrationConfig' }
    & IntegrationConfigFragment
  ) };

export type SaveIntegrationGroupMutationVariables = Exact<{
  input: IntegrationGroupInput;
}>;


export type SaveIntegrationGroupMutation = { __typename?: 'Mutation', saveIntegrationGroup?: { __typename?: 'IntegrationGroup', id: string, name: string, description?: string | null, integrations: Array<{ __typename?: 'Integration', id: string, name: string }> } | null };

export type DeleteIntegrationGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIntegrationGroupMutation = { __typename?: 'Mutation', deleteIntegrationGroup?: boolean | null };

export type IntegrationGroupsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type IntegrationGroupsListQuery = { __typename?: 'Query', integrationGroups: { __typename?: 'IntegrationGroupConnection', edges: Array<{ __typename?: 'IntegrationGroupConnectionEdge', node: { __typename?: 'IntegrationGroup', id: string, name: string, description?: string | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetIntegrationGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetIntegrationGroupQuery = { __typename?: 'Query', integrationGroup?: { __typename?: 'IntegrationGroup', id: string, name: string, description?: string | null, integrations: Array<{ __typename?: 'Integration', id: string, name: string, description?: string | null, config: { __typename?: 'IntegrationConfig', integrationType: IntegrationType } }> } | null };

export type IntegrationStateSectionFragment = { __typename?: 'IntegrationStateSection', id: string, name: string, fields: Array<(
    { __typename?: 'FieldConfig' }
    & FieldConfigRecursiveFragment
  ) | null> };

export type IntegrationStateViewFragment = { __typename?: 'IntegrationStateView', id: string, name: string, type: FormViewType, sections: Array<(
    { __typename?: 'IntegrationStateSection' }
    & IntegrationStateSectionFragment
  )> };

export type IntegrationStateViewRecursiveFragment = (
  { __typename?: 'IntegrationStateView', views: Array<(
    { __typename?: 'IntegrationStateView', views: Array<(
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView', views: Array<(
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & IntegrationStateViewFragment
          )> }
          & IntegrationStateViewFragment
        )> }
        & IntegrationStateViewFragment
      )> }
      & IntegrationStateViewFragment
    )> }
    & IntegrationStateViewFragment
  )> }
  & IntegrationStateViewFragment
);

export type IntegrationStateFragment = { __typename?: 'IntegrationState', views: Array<(
    { __typename?: 'IntegrationStateView' }
    & IntegrationStateViewRecursiveFragment
  ) | null> };

export type IntegrationAndStateFragment = { __typename?: 'Integration', id: string, name: string, config: { __typename?: 'IntegrationConfig', integrationType: IntegrationType }, state: (
    { __typename?: 'IntegrationState' }
    & IntegrationStateFragment
  ) };

export type GetIntegrationStateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetIntegrationStateQuery = { __typename?: 'Query', integration?: (
    { __typename?: 'Integration' }
    & IntegrationAndStateFragment
  ) | null };

export type SaveIntegrationMutationVariables = Exact<{
  input: IntegrationsInput;
}>;


export type SaveIntegrationMutation = { __typename?: 'Mutation', saveIntegration?: (
    { __typename?: 'Integration' }
    & SavedIntegrationFragment
  ) | null };

export type EnableIntegrationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type EnableIntegrationsMutation = { __typename?: 'Mutation', enableIntegrations?: Array<(
    { __typename?: 'Integration' }
    & SavedIntegrationFragment
  ) | null> | null };

export type DeleteIntegrationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIntegrationMutation = { __typename?: 'Mutation', deleteIntegration?: boolean | null };

export type ImportIntegrationsJsonMutationVariables = Exact<{
  integrations: Scalars['String'];
}>;


export type ImportIntegrationsJsonMutation = { __typename?: 'Mutation', importIntegrationsFromJson: Array<string> };

export type IntegrationControllerPollMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  integrationType: IntegrationType;
}>;


export type IntegrationControllerPollMutation = { __typename?: 'Mutation', multiplePoll?: Array<{ __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null, id: string }> | null };

export type GetIntegrationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetIntegrationQuery = { __typename?: 'Query', integration?: (
    { __typename?: 'Integration' }
    & SavedIntegrationFragment
  ) | null };

export type GetIntegrationDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetIntegrationDetailsQuery = { __typename?: 'Query', integration?: { __typename?: 'Integration', id: string, name: string, description?: string | null, assetIdentifier?: string | null } | null };

export type AllProtocolsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProtocolsQuery = { __typename?: 'Query', integrationForms: { __typename?: 'IntegrationsFormConnection', edges: Array<{ __typename?: 'IntegrationsFormConnectionEdge', node: { __typename?: 'IntegrationsForm', id: string, name: string, integrationType: IntegrationType } }> } };

export type IntegrationFormQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type IntegrationFormQuery = { __typename?: 'Query', integrationForm: (
    { __typename?: 'IntegrationsForm' }
    & IntegrationsFormFragment
  ) };

export type IntegrationsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type IntegrationsListQuery = { __typename?: 'Query', integrations: { __typename?: 'IntegrationConnection', totalCount: number, edges: Array<{ __typename?: 'IntegrationConnectionEdge', node: { __typename?: 'Integration', id: string, name: string, description?: string | null, systemEnabled: boolean, assetIdentifier?: string | null, state: { __typename?: 'IntegrationState', current: any }, config: { __typename?: 'IntegrationConfig', settings?: any | null, location?: any | null, integrationType: IntegrationType, form: { __typename?: 'IntegrationsForm', id: string, name: string } } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type IntegrationsSelectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type IntegrationsSelectionQuery = { __typename?: 'Query', integrations: { __typename?: 'IntegrationConnection', edges: Array<{ __typename?: 'IntegrationConnectionEdge', node: { __typename?: 'Integration', id: string, name: string, config: { __typename?: 'IntegrationConfig', integrationType: IntegrationType } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetBasicIntegrationGroupsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetBasicIntegrationGroupsQuery = { __typename?: 'Query', integrationGroups: { __typename?: 'IntegrationGroupConnection', edges: Array<{ __typename?: 'IntegrationGroupConnectionEdge', node: { __typename?: 'IntegrationGroup', id: string, name: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type IntegrationFormLocationRoutesQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationFormLocationRoutesQuery = { __typename?: 'Query', locationRoutes: { __typename?: 'LocationRouteConnection', edges: Array<{ __typename?: 'LocationRouteConnectionEdge', node: { __typename?: 'LocationRoute', nativeId: string, label?: string | null, name: string, direction: string } }> } };

export type IntegrationUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type IntegrationUpdatedSubscription = { __typename?: 'Subscription', integrationUpdated: { __typename?: 'Integration', id: string, name: string, description?: string | null, systemEnabled: boolean, assetIdentifier?: string | null, state: { __typename?: 'IntegrationState', current: any }, config: { __typename?: 'IntegrationConfig', settings?: any | null, location?: any | null, integrationType: IntegrationType, form: { __typename?: 'IntegrationsForm', id: string, name: string } } } };

export type JobRequestFragment = { __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null, id: string };

export type CancelJobMutationVariables = Exact<{
  id: Scalars['String'];
  requestId: Scalars['String'];
}>;


export type CancelJobMutation = { __typename?: 'Mutation', cancelJob: boolean };

export type GetLocationAssociatedIntegrationsQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;


export type GetLocationAssociatedIntegrationsQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, integrations: Array<{ __typename?: 'Integration', id: string, name: string, description?: string | null, config: { __typename?: 'IntegrationConfig', integrationType: IntegrationType, form: { __typename?: 'IntegrationsForm', name: string } } }> } | null };

export type NewLocationCommentMutationVariables = Exact<{
  locationId: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type NewLocationCommentMutation = { __typename?: 'Mutation', saveLocationComment: { __typename?: 'LocationComment', id: string, locationId: string, comment: string, updatedAt?: any | null, createdAt: any, userId?: string | null, userDisplayName?: string | null } };

export type EditLocationCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
  locationId: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type EditLocationCommentMutation = { __typename?: 'Mutation', saveLocationComment: { __typename?: 'LocationComment', id: string, locationId: string, comment: string, updatedAt?: any | null, createdAt: any, userId?: string | null, userDisplayName?: string | null } };

export type DeleteLocationCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
}>;


export type DeleteLocationCommentMutation = { __typename?: 'Mutation', deleteLocationComment: boolean };

export type LocationCommentsQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;


export type LocationCommentsQuery = { __typename?: 'Query', locationComments: Array<{ __typename?: 'LocationComment', id: string, locationId: string, comment: string, createdAt: any, updatedAt?: any | null, userId?: string | null }> };

export type SaveLocationLinkMutationVariables = Exact<{
  link: LocationExternalLinkInput;
}>;


export type SaveLocationLinkMutation = { __typename?: 'Mutation', saveLocationLink: { __typename?: 'LocationExternalLink', id: string, locationId: string, url: string, title: string, description: string } };

export type DeleteLocationLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLocationLinkMutation = { __typename?: 'Mutation', deleteLocationLink: boolean };

export type LocationLinksQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;


export type LocationLinksQuery = { __typename?: 'Query', locationLinks: Array<{ __typename?: 'LocationExternalLink', id: string, locationId: string, url: string, title: string, description: string }> };

export type CreateLocationGroupMutationVariables = Exact<{
  input: LocationGroupInput;
}>;


export type CreateLocationGroupMutation = { __typename?: 'Mutation', saveLocationGroups: Array<{ __typename?: 'FlatLocationGroup', id: string }> };

export type DeleteLocationGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type DeleteLocationGroupMutation = { __typename?: 'Mutation', deleteLocationGroup: boolean };

export type MoveGroupMutationVariables = Exact<{
  input: MoveLocationGroupInput;
}>;


export type MoveGroupMutation = { __typename?: 'Mutation', moveLocationGroups: Array<{ __typename?: 'FlatLocationGroup', id: string, parentId?: string | null }> };

export type MoveLocationMutationVariables = Exact<{
  input: MoveLocationInput;
}>;


export type MoveLocationMutation = { __typename?: 'Mutation', moveLocations: boolean };

export type ReorderLocationGroupsMutationVariables = Exact<{
  input: Array<MoveLocationGroupInput> | MoveLocationGroupInput;
}>;


export type ReorderLocationGroupsMutation = { __typename?: 'Mutation', moveLocationGroups: Array<{ __typename?: 'FlatLocationGroup', id: string, parentId?: string | null, order?: number | null }> };

export type ReorderLocationsMutationVariables = Exact<{
  input: Array<MoveLocationInput> | MoveLocationInput;
}>;


export type ReorderLocationsMutation = { __typename?: 'Mutation', moveLocations: boolean };

export type ExportLocationTreeMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ExportLocationTreeMutation = { __typename?: 'Mutation', exportLocationTree: boolean };

export type GetLocationsTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsTreeQuery = { __typename?: 'Query', locationGroups: Array<{ __typename?: 'FlatLocationGroup', id: string, name: string, parentId?: string | null, readOnly?: boolean | null, externalCenterId?: string | null, color?: string | null, order?: number | null }>, locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, groupId?: string | null, color?: string | null, locationType: string, order?: number | null, externalCenterId?: string | null, details: { __typename?: 'LocationDetails', name: string }, associatedEntities: Array<{ __typename?: 'LocationAssociation', entityId: string, entityType: LocationAssociationEntityType, integrationType?: IntegrationType | null, entityName?: string | null, protocol?: string | null, systemEnabled?: boolean | null }> } }> } };

export type GetUngroupedLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUngroupedLocationsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, groupId?: string | null, color?: string | null, locationType: string, order?: number | null, externalCenterId?: string | null, details: { __typename?: 'LocationDetails', name: string, description?: string | null }, associatedEntities: Array<{ __typename?: 'LocationAssociation', entityId: string, entityType: LocationAssociationEntityType, integrationType?: IntegrationType | null, entityName?: string | null, protocol?: string | null, systemEnabled?: boolean | null }> } }> } };

export type GetGroupLocationsQueryVariables = Exact<{
  groupId: Scalars['Object'];
}>;


export type GetGroupLocationsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, groupId?: string | null, color?: string | null, locationType: string, order?: number | null, externalCenterId?: string | null, details: { __typename?: 'LocationDetails', name: string, description?: string | null }, associatedEntities: Array<{ __typename?: 'LocationAssociation', entityId: string, entityType: LocationAssociationEntityType, integrationType?: IntegrationType | null, entityName?: string | null, protocol?: string | null, systemEnabled?: boolean | null }> } }> } };

export type GetLocationGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationGroupsQuery = { __typename?: 'Query', locationGroups: Array<{ __typename?: 'FlatLocationGroup', id: string, name: string, parentId?: string | null, readOnly?: boolean | null, externalCenterId?: string | null, color?: string | null, order?: number | null }> };

export type SaveLocationMutationVariables = Exact<{
  input: LocationInput;
}>;


export type SaveLocationMutation = { __typename?: 'Mutation', saveLocation?: { __typename?: 'Location', id: string, geometry: any, locationType: string, details: { __typename?: 'LocationDetails', name: string, description?: string | null } } | null };

export type SaveSignalLocationMutationVariables = Exact<{
  input: LocationInput;
}>;


export type SaveSignalLocationMutation = { __typename?: 'Mutation', saveLocation?: { __typename?: 'Location', id: string, geometry: any, locationType: string, details: { __typename?: 'LocationDetails', name: string, description?: string | null }, lanes: Array<{ __typename?: 'Lane', id: string, description?: string | null, geometry: any, laneDirection: LaneDirection, travelDirection?: TravelDirection | null }>, crosswalks: Array<{ __typename?: 'Crosswalk', id: string, description?: string | null, geometry: any }>, maneuvers: Array<{ __typename?: 'Maneuver', id: string, refApproachLane: string, refDepartureLane: string }> } | null };

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation: boolean };

export type DeleteLocationTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLocationTemplateMutation = { __typename?: 'Mutation', deleteLocationTemplate?: boolean | null };

export type ImportLocationsMutationVariables = Exact<{
  fileType: LocationImportFileType;
  locationType: Scalars['String'];
  fileIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ImportLocationsMutation = { __typename?: 'Mutation', importLocations: boolean };

export type LocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, locationType: string, geometry: any, color?: string | null, opacity?: number | null, details: { __typename?: 'LocationDetails', name: string, description?: string | null }, crosswalks: Array<{ __typename?: 'Crosswalk', id: string, description?: string | null, geometry: any }>, maneuvers: Array<{ __typename?: 'Maneuver', id: string, refApproachLane: string, refDepartureLane: string }>, lanes: Array<{ __typename?: 'Lane', id: string, description?: string | null, geometry: any, laneDirection: LaneDirection, travelDirection?: TravelDirection | null }> } | null };

export type LocationDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationDetailsQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, externalCenterId?: string | null, details: { __typename?: 'LocationDetails', name: string, description?: string | null } } | null };

export type EditLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EditLocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, locationType: string, geometry: any, color?: string | null, opacity?: number | null, details: { __typename?: 'LocationDetails', name: string, description?: string | null }, associatedEntities: Array<{ __typename?: 'LocationAssociation', locationId: string, entityType: LocationAssociationEntityType, entityId: string }>, crosswalks: Array<{ __typename?: 'Crosswalk', id: string, description?: string | null, geometry: any }>, maneuvers: Array<{ __typename?: 'Maneuver', id: string, refApproachLane: string, refDepartureLane: string }>, lanes: Array<{ __typename?: 'Lane', id: string, description?: string | null, geometry: any, laneDirection: LaneDirection, travelDirection?: TravelDirection | null }> } | null };

export type CloneLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CloneLocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, locationType: string, geometry: any, color?: string | null, opacity?: number | null, details: { __typename?: 'LocationDetails', name: string, description?: string | null }, crosswalks: Array<{ __typename?: 'Crosswalk', id: string, description?: string | null, geometry: any }>, maneuvers: Array<{ __typename?: 'Maneuver', id: string, refApproachLane: string, refDepartureLane: string }>, lanes: Array<{ __typename?: 'Lane', id: string, description?: string | null, geometry: any, laneDirection: LaneDirection, travelDirection?: TravelDirection | null }> } | null };

export type LocationsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  associatedEntityFilters?: InputMaybe<Array<AssociatedEntityFilterInput> | AssociatedEntityFilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type LocationsListQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', totalCount: number, edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, locationType: string, geometry: any, externalCenterId?: string | null, details: { __typename?: 'LocationDetails', name: string, description?: string | null } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LocationFormGeometryChangeQueryVariables = Exact<{
  geometry: Scalars['Object'];
  retrieveAllTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type LocationFormGeometryChangeQuery = { __typename?: 'Query', locationFormGeometryChange: any };

export type LocationFormStartReferencePointChangeQueryVariables = Exact<{
  values: Scalars['Object'];
}>;


export type LocationFormStartReferencePointChangeQuery = { __typename?: 'Query', locationFormStartReferencePointChange: any };

export type LocationFormEndReferencePointChangeQueryVariables = Exact<{
  values: Scalars['Object'];
}>;


export type LocationFormEndReferencePointChangeQuery = { __typename?: 'Query', locationFormEndReferencePointChange: any };

export type LocationFormReferencePointChangeQueryVariables = Exact<{
  values: Scalars['Object'];
}>;


export type LocationFormReferencePointChangeQuery = { __typename?: 'Query', locationFormReferencePointChange: any };

export type LocationFormStartLandmarkChangeQueryVariables = Exact<{
  values: Scalars['Object'];
}>;


export type LocationFormStartLandmarkChangeQuery = { __typename?: 'Query', locationFormStartLandmarkChange: any };

export type LocationFormEndLandmarkChangeQueryVariables = Exact<{
  values: Scalars['Object'];
}>;


export type LocationFormEndLandmarkChangeQuery = { __typename?: 'Query', locationFormEndLandmarkChange: any };

export type LocationFormLandmarkChangeQueryVariables = Exact<{
  values: Scalars['Object'];
}>;


export type LocationFormLandmarkChangeQuery = { __typename?: 'Query', locationFormLandmarkChange: any };

export type LocationFormAreaChangeQueryVariables = Exact<{
  value: Scalars['Object'];
  type: Scalars['String'];
}>;


export type LocationFormAreaChangeQuery = { __typename?: 'Query', locationFormAreaChange: any };

export type LocationRouteClassificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationRouteClassificationsQuery = { __typename?: 'Query', locationRouteClassifications: Array<string> };

export type LocationRoutesListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type LocationRoutesListQuery = { __typename?: 'Query', locationRoutes: { __typename?: 'LocationRouteConnection', totalCount: number, edges: Array<{ __typename?: 'LocationRouteConnectionEdge', node: { __typename?: 'LocationRoute', direction: string, nativeId: string, label?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LocationBoundedRoutesListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type LocationBoundedRoutesListQuery = { __typename?: 'Query', locationBoundedRoutes: { __typename?: 'LocationBoundedRouteConnection', totalCount: number, edges: Array<{ __typename?: 'LocationBoundedRouteConnectionEdge', node: { __typename?: 'LocationBoundedRoute', classification: string, startLandmark?: string | null, routeNativeId: string, direction: string, startMeasure: number, endLandmark?: string | null, endMeasure: number, areaType: string, area: string, name: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LocationRouteQueryVariables = Exact<{
  nativeId: Scalars['String'];
}>;


export type LocationRouteQuery = { __typename?: 'Query', locationRoute?: { __typename?: 'LocationRoute', classification: string, direction: string, name: string } | null };

export type LocationSwitcherOptionsQueryVariables = Exact<{
  currentLocationId: Scalars['Object'];
}>;


export type LocationSwitcherOptionsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } }> } };

export type LocationRouteRangeQueryVariables = Exact<{
  nativeId: Scalars['String'];
}>;


export type LocationRouteRangeQuery = { __typename?: 'Query', locationRouteRange: { __typename?: 'LocationRouteRange', startReference: number, endReference: number } };

export type LocationDetailsSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationDetailsSummaryQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, locationType: string, details: { __typename?: 'LocationDetails', name: string, description?: string | null } } | null };

export type LocationRouteLandmarkListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type LocationRouteLandmarkListQuery = { __typename?: 'Query', locationRouteLandmarks: { __typename?: 'LocationRouteLandmarkConnection', totalCount: number, edges: Array<{ __typename?: 'LocationRouteLandmarkConnectionEdge', node: { __typename?: 'LocationRouteLandmark', measure: number, name: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LocationDetailsMapQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationDetailsMapQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, locationType: string, geometry: any, color?: string | null, opacity?: number | null } | null };

export type LocationAreaListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type LocationAreaListQuery = { __typename?: 'Query', locationAreas: { __typename?: 'LocationAreaConnection', totalCount: number, edges: Array<{ __typename?: 'LocationAreaConnectionEdge', node: { __typename?: 'LocationArea', type: string, name: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LocationParentGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationParentGroupQuery = { __typename?: 'Query', getLocationParentGroup?: { __typename?: 'FlatLocationGroup', id: string, name: string, parentId?: string | null, order?: number | null } | null };

export type AssetLocationsOptionsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  associatedEntityFilters?: InputMaybe<Array<AssociatedEntityFilterInput> | AssociatedEntityFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AssetLocationsOptionsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', totalCount: number, edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LocationFormDistrictChangeQueryVariables = Exact<{
  values: Scalars['Object'];
  searchAreaType: Scalars['String'];
  returnAreaTypes: Array<Scalars['String']> | Scalars['String'];
}>;


export type LocationFormDistrictChangeQuery = { __typename?: 'Query', locationFormDistrictChange: any };

export type LocationsByIdQueryVariables = Exact<{
  ids: Scalars['Object'];
}>;


export type LocationsByIdQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, locationType: string, geometry: any, details: { __typename?: 'LocationDetails', name: string, description?: string | null } } }> } };

export type SaveLocationTemplateMutationVariables = Exact<{
  input: LocationTemplateInput;
}>;


export type SaveLocationTemplateMutation = { __typename?: 'Mutation', saveLocationTemplate: { __typename?: 'LocationTemplate', id: string, name: string, description?: string | null, template: { __typename?: 'Location', locationType: string, geometry: any, details: { __typename?: 'LocationDetails', name: string, description?: string | null }, crosswalks: Array<{ __typename?: 'Crosswalk', id: string, description?: string | null, geometry: any }>, maneuvers: Array<{ __typename?: 'Maneuver', id: string, refApproachLane: string, refDepartureLane: string }>, lanes: Array<{ __typename?: 'Lane', id: string, description?: string | null, geometry: any, laneDirection: LaneDirection, travelDirection?: TravelDirection | null }> } } };

export type LocationTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationTemplateQuery = { __typename?: 'Query', locationTemplate: { __typename?: 'LocationTemplate', id: string, name: string, description?: string | null, template: { __typename?: 'Location', locationType: string, geometry: any, details: { __typename?: 'LocationDetails', name: string, description?: string | null }, crosswalks: Array<{ __typename?: 'Crosswalk', id: string, description?: string | null, geometry: any }>, maneuvers: Array<{ __typename?: 'Maneuver', id: string, refApproachLane: string, refDepartureLane: string }>, lanes: Array<{ __typename?: 'Lane', id: string, description?: string | null, geometry: any, laneDirection: LaneDirection, travelDirection?: TravelDirection | null }> } } };

export type LocationTemplatesListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type LocationTemplatesListQuery = { __typename?: 'Query', locationTemplates: { __typename?: 'LocationTemplateConnection', totalCount: number, edges: Array<{ __typename?: 'LocationTemplateConnectionEdge', node: { __typename?: 'LocationTemplate', id: string, name: string, description?: string | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LocationTemplateOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationTemplateOptionsQuery = { __typename?: 'Query', locationTemplates: { __typename?: 'LocationTemplateConnection', edges: Array<{ __typename?: 'LocationTemplateConnectionEdge', node: { __typename?: 'LocationTemplate', id: string, name: string } }> } };

export type NotificationFragmentFragment = { __typename?: 'Notification', id: string, userIds: Array<string | null>, systemNotification?: boolean | null, source: KineticModule, severity?: NotificationSeverity | null, createdTime?: any | null, acknowledgedTime?: any | null, acknowledgedNotes?: string | null, acknowledgedBy?: string | null, nonDismissible?: boolean | null, acknowledgedByName?: string | null, snoozed?: boolean | null, snoozeMessage?: string | null, snoozeDurationInMinutes?: number | null, location?: any | null, objectId?: string | null, ignorable?: boolean | null, title: string, details?: string | null, updatedTS?: any | null, route?: string | null, data: any, snoozedAt?: any | null, status?: NotificationStatus | null, actions?: Array<{ __typename?: 'Action', route?: string | null, title?: string | null, toolTip?: string | null } | null> | null };

export type AcknowledgeNotificationMutationVariables = Exact<{
  id: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
}>;


export type AcknowledgeNotificationMutation = { __typename?: 'Mutation', acknowledgeNotification?: { __typename?: 'Notification', id: string, acknowledgedBy?: string | null, acknowledgedTime?: any | null } | null };

export type DismissNotificationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DismissNotificationMutation = { __typename?: 'Mutation', dismissNotification: boolean };

export type DismissNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DismissNotificationsMutation = { __typename?: 'Mutation', dismissNotifications: boolean };

export type SnoozeNotificationMutationVariables = Exact<{
  id: Scalars['String'];
  duration: Scalars['Int'];
  message?: InputMaybe<Scalars['String']>;
}>;


export type SnoozeNotificationMutation = { __typename?: 'Mutation', snoozeNotification: boolean };

export type UnDismissNotificationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UnDismissNotificationMutation = { __typename?: 'Mutation', unDismissNotification: boolean };

export type UserNotificationsQueryVariables = Exact<{
  acknowledged?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type UserNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', totalCount: number, edges: Array<{ __typename?: 'NotificationConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'Notification' }
        & NotificationFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SystemNotificationsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  notificationSortField?: InputMaybe<NotificationSortField>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  statuses?: InputMaybe<Array<NotificationStatus> | NotificationStatus>;
}>;


export type SystemNotificationsListQuery = { __typename?: 'Query', systemNotifications: { __typename?: 'NotificationConnection', totalCount: number, edges: Array<{ __typename?: 'NotificationConnectionEdge', node: (
        { __typename?: 'Notification' }
        & NotificationFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type UserNotificationsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']>;
  acknowledged?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type UserNotificationsListQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', totalCount: number, edges: Array<{ __typename?: 'NotificationConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'Notification' }
        & NotificationFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type UserNotificationUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationUpdatedSubscription = { __typename?: 'Subscription', notificationUpdated?: { __typename?: 'Notification', id: string, acknowledgedTime?: any | null, urgentNotification?: boolean | null, acknowledgedBy?: string | null, audibleAlarm?: boolean | null, soundFile?: string | null } | null };

export type NotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPreferencesQuery = { __typename?: 'Query', notificationPreferences?: { __typename?: 'NotificationPreference', location?: any | null, preferenceSourceList: Array<{ __typename?: 'NotificationPreferenceSource', source?: KineticModule | null, severitySet: Array<NotificationSeverity | null> } | null> } | null };

export type CursorPageInfoFragment = { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type SaveParkingAreaMessageMutationVariables = Exact<{
  message: ParkingAreaMessageInput;
}>;


export type SaveParkingAreaMessageMutation = { __typename?: 'Mutation', parkingAreaSaveMessage: { __typename?: 'ParkingAreaMessage', id: string } };

export type DeleteParkingAreaMessageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteParkingAreaMessageMutation = { __typename?: 'Mutation', parkingAreaDeleteMessage: boolean };

export type ParkingAreaPostMessageMutationVariables = Exact<{
  messages: Array<ParkingPostRequest> | ParkingPostRequest;
}>;


export type ParkingAreaPostMessageMutation = { __typename?: 'Mutation', parkingAreaPostMessage: Array<{ __typename?: 'JobRequest', success: boolean }> };

export type ParkingAreaBlankMessageMutationVariables = Exact<{
  id: Scalars['ID'];
  signs: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ParkingAreaBlankMessageMutation = { __typename?: 'Mutation', parkingAreaBlankMessage: Array<{ __typename?: 'JobRequest', success: boolean }> };

export type ParkingAreaListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ParkingAreaListQuery = { __typename?: 'Query', parkingAreas: { __typename?: 'ParkingAreaConnection', totalCount: number, edges: Array<{ __typename?: 'ParkingAreaEdge', node: { __typename?: 'ParkingArea', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint: number, direction: Direction, occupied: number, vacant: number, status: ParkingAreaStatus, total: number, road: string, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ParkingAreaSearchListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ParkingAreaSearchListQuery = { __typename?: 'Query', parkingAreas: { __typename?: 'ParkingAreaConnection', totalCount: number, edges: Array<{ __typename?: 'ParkingAreaEdge', node: { __typename?: 'ParkingArea', location: any, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveParkingAreaListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveParkingAreaListSubscription = { __typename?: 'Subscription', parkingAreaUpdated: { __typename?: 'ParkingArea', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint: number, direction: Direction, occupied: number, vacant: number, status: ParkingAreaStatus, total: number, road: string, name: string, id: string } };

export type ParkingAreaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ParkingAreaQuery = { __typename?: 'Query', parkingArea: { __typename?: 'ParkingArea', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint: number, cameras: Array<string>, direction: Direction, occupied: number, location: any, vacant: number, status: ParkingAreaStatus, total: number, signs: Array<string>, road: string, name: string, id: string, levels: Array<{ __typename?: 'ParkingAreaLevel', occupied: number, status: ParkingAreaStatus, vacant: number, total: number, index: number, name: string, spaces: Array<{ __typename?: 'ParkingAreaSpace', status: ParkingAreaSpaceStatus, index: number, type: ParkingAreaSpaceType }> }> } };

export type LiveParkingAreaSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveParkingAreaSubscription = { __typename?: 'Subscription', parkingAreaUpdated: { __typename?: 'ParkingArea', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint: number, direction: Direction, occupied: number, location: any, cameras: Array<string>, vacant: number, status: ParkingAreaStatus, signs: Array<string>, total: number, road: string, name: string, id: string, levels: Array<{ __typename?: 'ParkingAreaLevel', occupied: number, status: ParkingAreaStatus, vacant: number, total: number, index: number, name: string, spaces: Array<{ __typename?: 'ParkingAreaSpace', status: ParkingAreaSpaceStatus, index: number, type: ParkingAreaSpaceType }> }> } };

export type ParkingAreaDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ParkingAreaDetailQuery = { __typename?: 'Query', parkingArea: { __typename?: 'ParkingArea', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint: number, direction: Direction, occupied: number, vacant: number, status: ParkingAreaStatus, total: number, road: string, name: string, id: string } };

export type LiveParkingAreaDetailSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveParkingAreaDetailSubscription = { __typename?: 'Subscription', parkingAreaUpdated: { __typename?: 'ParkingArea', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint: number, direction: Direction, occupied: number, vacant: number, status: ParkingAreaStatus, total: number, road: string, name: string, id: string } };

export type ParkingAreaMapQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ParkingAreaMapQuery = { __typename?: 'Query', parkingAreas: { __typename?: 'ParkingAreaConnection', totalCount: number, edges: Array<{ __typename?: 'ParkingAreaEdge', node: { __typename?: 'ParkingArea', location: any, status: ParkingAreaStatus, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveParkingAreaMapSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveParkingAreaMapSubscription = { __typename?: 'Subscription', parkingAreaUpdated: { __typename?: 'ParkingArea', location: any, status: ParkingAreaStatus, id: string } };

export type ParkingAreaSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ParkingAreaSummaryQuery = { __typename?: 'Query', OPEN: { __typename?: 'ParkingAreaConnection', totalCount: number }, FULL: { __typename?: 'ParkingAreaConnection', totalCount: number }, CLOSED: { __typename?: 'ParkingAreaConnection', totalCount: number }, UNKNOWN: { __typename?: 'ParkingAreaConnection', totalCount: number }, NEARLY_FULL: { __typename?: 'ParkingAreaConnection', totalCount: number } };

export type ParkingAreaMessageListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ParkingAreaMessageListQuery = { __typename?: 'Query', parkingAreaMessages: { __typename?: 'ParkingAreaMessageConnection', totalCount: number, edges: Array<{ __typename?: 'ParkingAreaMessageEdge', node: { __typename?: 'ParkingAreaMessage', parkingArea: string, sign: string, name: string, id: string, template: (
          { __typename?: 'SignMessage' }
          & SignMessageFragment
        ) } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ParkingAreaMessageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ParkingAreaMessageQuery = { __typename?: 'Query', parkingAreaMessage?: { __typename?: 'ParkingAreaMessage', parkingArea: string, sign: string, name: string, id: string, template: (
      { __typename?: 'SignMessage' }
      & SignMessageFragment
    ) } | null };

export type DeleteUserTenantPreferenceMutationVariables = Exact<{
  key: Scalars['ID'];
}>;


export type DeleteUserTenantPreferenceMutation = { __typename?: 'Mutation', deleteUserPreference: boolean };

export type DeleteUserKineticPreferenceMutationVariables = Exact<{
  key: Scalars['ID'];
}>;


export type DeleteUserKineticPreferenceMutation = { __typename?: 'Mutation', deleteKineticUserPreference: boolean };

export type DeleteOrganizationPreferenceMutationVariables = Exact<{
  key: Scalars['ID'];
}>;


export type DeleteOrganizationPreferenceMutation = { __typename?: 'Mutation', deleteOrganizationPreference: boolean };

export type UpdatePartialKineticUserPreferenceMutationVariables = Exact<{
  key: Scalars['ID'];
  value: Scalars['JSON'];
}>;


export type UpdatePartialKineticUserPreferenceMutation = { __typename?: 'Mutation', updatePartialUserPreference: any };

export type RemovePartialKineticUserPreferenceMutationVariables = Exact<{
  key: Scalars['ID'];
  valueId: Scalars['String'];
}>;


export type RemovePartialKineticUserPreferenceMutation = { __typename?: 'Mutation', removePartialUserPreference: any };

export type SaveUserPrefMutationVariables = Exact<{
  key: Scalars['ID'];
  value: Scalars['JSON'];
}>;


export type SaveUserPrefMutation = { __typename?: 'Mutation', saveUserPreference: any };

export type SaveKineticUserPrefMutationMutationVariables = Exact<{
  key: Scalars['ID'];
  value: Scalars['JSON'];
}>;


export type SaveKineticUserPrefMutationMutation = { __typename?: 'Mutation', saveKineticUserPreference: any };

export type SaveNotificationPreferencesMutationVariables = Exact<{
  notificationPreferences?: InputMaybe<NotificationPreferenceInput>;
}>;


export type SaveNotificationPreferencesMutation = { __typename?: 'Mutation', saveNotificationPreferences?: { __typename?: 'NotificationPreference', location?: any | null, preferenceSourceList: Array<{ __typename?: 'NotificationPreferenceSource', source?: KineticModule | null, severitySet: Array<NotificationSeverity | null> } | null> } | null };

export type SaveOrganizationPreferenceMutationVariables = Exact<{
  key: Scalars['ID'];
  value: Scalars['JSON'];
}>;


export type SaveOrganizationPreferenceMutation = { __typename?: 'Mutation', saveOrganizationPreference: any };

export type UpdatePartialOrganizationPreferenceMutationVariables = Exact<{
  key: Scalars['ID'];
  value: Scalars['JSON'];
}>;


export type UpdatePartialOrganizationPreferenceMutation = { __typename?: 'Mutation', updatePartialOrganizationPreference: any };

export type RemovePartialOrganizationPreferenceMutationVariables = Exact<{
  key: Scalars['ID'];
  valueId: Scalars['String'];
}>;


export type RemovePartialOrganizationPreferenceMutation = { __typename?: 'Mutation', removePartialOrganizationPreference: any };

export type ClearAllPreferencesMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearAllPreferencesMutation = { __typename?: 'Mutation', removeUserPreferences: boolean };

export type SaveKineticUserPrefMutationVariables = Exact<{
  key: Scalars['ID'];
  value: Scalars['JSON'];
}>;


export type SaveKineticUserPrefMutation = { __typename?: 'Mutation', saveKineticUserPreference: any };

export type SaveModuleMapSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveModuleMapSettingsMutation = { __typename?: 'Mutation', saveModuleMapSettings?: boolean | null };

export type UserTenantPreferenceUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserTenantPreferenceUpdatedSubscription = { __typename?: 'Subscription', userPreferenceUpdated: { __typename?: 'UserPreferenceStreamObject', streamObjectOperation: StreamObjectOperation, userPreference: { __typename?: 'UserPreference', key: string, value: any } } };

export type UserKineticPreferenceUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserKineticPreferenceUpdatedSubscription = { __typename?: 'Subscription', kineticUserPreferenceUpdated: { __typename?: 'UserPreferenceStreamObject', streamObjectOperation: StreamObjectOperation, userPreference: { __typename?: 'UserPreference', key: string, value: any } } };

export type ModuleMapSettingsQueryVariables = Exact<{
  formViewName: Scalars['String'];
}>;


export type ModuleMapSettingsQuery = { __typename?: 'Query', moduleMapSettings: { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, views: Array<{ __typename?: 'DetectorReportConfigFormView', id: string, name: string, views: Array<(
        { __typename?: 'DetectorReportConfigFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          )> }
          & FormViewFragment_DetectorReportConfigFormView_Fragment
        )> }
        & FormViewFragment_DetectorReportConfigFormView_Fragment
      )> } | { __typename?: 'IntegrationConfigFormView', id: string, name: string, views: Array<(
        { __typename?: 'IntegrationConfigFormView', views: Array<(
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          )> }
          & FormViewFragment_IntegrationConfigFormView_Fragment
        )> }
        & FormViewFragment_IntegrationConfigFormView_Fragment
      )> } | { __typename?: 'IntegrationStateView', id: string, name: string, views: Array<(
        { __typename?: 'IntegrationStateView', views: Array<(
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          )> }
          & FormViewFragment_IntegrationStateView_Fragment
        )> }
        & FormViewFragment_IntegrationStateView_Fragment
      )> } | { __typename?: 'ModuleSettingsFormView', id: string, name: string, views: Array<(
        { __typename?: 'DetectorReportConfigFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          )> }
          & FormViewFragment_DetectorReportConfigFormView_Fragment
        )> }
        & FormViewFragment_DetectorReportConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationConfigFormView', views: Array<(
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          )> }
          & FormViewFragment_IntegrationConfigFormView_Fragment
        )> }
        & FormViewFragment_IntegrationConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationStateView', views: Array<(
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          )> }
          & FormViewFragment_IntegrationStateView_Fragment
        )> }
        & FormViewFragment_IntegrationStateView_Fragment
      ) | (
        { __typename?: 'ModuleSettingsFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          )> }
          & FormViewFragment_DetectorReportConfigFormView_Fragment
        ) | (
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          )> }
          & FormViewFragment_IntegrationConfigFormView_Fragment
        ) | (
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          )> }
          & FormViewFragment_IntegrationStateView_Fragment
        ) | (
          { __typename?: 'ModuleSettingsFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          ) | (
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          ) | (
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          ) | (
            { __typename?: 'ModuleSettingsFormView' }
            & FormViewFragment_ModuleSettingsFormView_Fragment
          )> }
          & FormViewFragment_ModuleSettingsFormView_Fragment
        )> }
        & FormViewFragment_ModuleSettingsFormView_Fragment
      )> }>, sections: Array<(
      { __typename?: 'ModuleFormSection' }
      & ModuleFormSectionFragmentFragment
    )> } };

export type OrganizationPreferenceUpdatedSubscriptionVariables = Exact<{
  key?: InputMaybe<Scalars['String']>;
}>;


export type OrganizationPreferenceUpdatedSubscription = { __typename?: 'Subscription', organizationPreferenceUpdated: { __typename?: 'OrganizationPreferenceStreamObject', streamObjectOperation: StreamObjectOperation, organizationPreference: { __typename?: 'OrganizationPreference', key: string, value: any } } };

export type RampMeterAppliedCommandUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RampMeterAppliedCommandUpdatedSubscription = { __typename?: 'Subscription', signalAppliedCommandUpdated?: Array<{ __typename?: 'SignalAppliedCommandStreamObject', streamObjectOperation: StreamObjectOperation, dto: { __typename?: 'SignalAppliedCommand', id: string, command: string, value: string, taskId: string, startDateTime: any, endDateTime: any, status: string, source?: string | null, intersection: { __typename?: 'BasicIntersectionDevice', id: string, name: string }, device: { __typename?: 'BasicIntersectionDevice', id: string, name: string }, inheritedGroup?: { __typename?: 'BasicIntersectionDevice', id: string, name: string } | null } }> | null };

export type RampMeterAppliedCommandFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RampMeterAppliedCommandFilterOptionsQuery = { __typename?: 'Query', signalAppliedCommandFilterOptions: { __typename?: 'SignalAppliedCommandFilterOptions', commands: Array<string>, sources: Array<string>, intersections: Array<{ __typename?: 'BasicIntersectionDevice', id: string, name: string }>, devices: Array<{ __typename?: 'BasicIntersectionDevice', id: string, name: string }>, inheritedGroups: Array<{ __typename?: 'BasicIntersectionDevice', id: string, name: string }> } };

export type SaveRampMeterMutationVariables = Exact<{
  input: IntersectionInput;
}>;


export type SaveRampMeterMutation = { __typename?: 'Mutation', saveRampMeter: (
    { __typename?: 'Intersection' }
    & IntersectionDetailFragment
  ) };

export type RampMeterControllerListQueryVariables = Exact<{ [key: string]: never; }>;


export type RampMeterControllerListQuery = { __typename?: 'Query', rampMeterControllers: { __typename?: 'SignalControllerConnection', edges: Array<{ __typename?: 'SignalControllerConnectionEdge', node: { __typename?: 'SignalController', id: string, name: string, location?: any | null } }> } };

export type GetRampMeterByIntegrationIdQueryVariables = Exact<{
  integrationId: Scalars['Object'];
}>;


export type GetRampMeterByIntegrationIdQuery = { __typename?: 'Query', rampMeters: { __typename?: 'IntersectionConnection', edges: Array<{ __typename?: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, details: { __typename?: 'IntersectionDetails', name: string } } }> } };

export type RampMeterDetailPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RampMeterDetailPageQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', id: string, location: any, details: { __typename?: 'IntersectionDetails', name: string, note?: string | null, mainPhases: Array<number> }, devices: Array<{ __typename?: 'IntersectionDevice', id: string, name: string, type: IntersectionDeviceType }>, centerInfo?: { __typename?: 'CenterInfo', centerId: string } | null, icons: Array<(
      { __typename?: 'IntersectionIcon' }
      & IntersectionIconFragment
    )> } | null };

export type RampMeterListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type RampMeterListQuery = { __typename?: 'Query', rampMeters: { __typename?: 'IntersectionConnection', totalCount: number, edges: Array<{ __typename: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, statusCategory: IntersectionStatusCategory, details: { __typename?: 'IntersectionDetails', name: string, labels: Array<string> }, devices: Array<{ __typename?: 'IntersectionDevice', id: string, connectionInfo?: string | null, fieldEntityProtocol?: string | null }> } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type RampMeterStatusCategoriesFragment = { __typename?: 'RampMeterStatusCategories', dark: number, emergencyGreen: number, fixedRate: number, restInGreen: number, trafficResponsive: number, holdMeter: number, holdNonMeter: number, holdRestInGreen: number, commDisabled: number, commFailed: number, unknown: number };

export type RampMeterSimpleStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type RampMeterSimpleStatusQuery = { __typename?: 'Query', intersectionSimpleStatus: Array<any> };

export type RampMeterLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type RampMeterLocationQuery = { __typename?: 'Query', intersectionLocation: Array<any> };

export type RampMeterAppliedCommandsQueryVariables = Exact<{
  timezone: Scalars['String'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type RampMeterAppliedCommandsQuery = { __typename?: 'Query', signalAppliedCommands: { __typename?: 'SignalAppliedCommandConnection', totalCount: number, edges: Array<{ __typename: 'SignalAppliedCommandConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'SignalAppliedCommand' }
        & AppliedCommandFragmentFragment
      ) }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type RampMeterSimpleAndDetailStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type RampMeterSimpleAndDetailStatusQuery = { __typename?: 'Query', intersectionSimpleStatus: Array<any>, intersectionDetailStatus: Array<any> };

export type RampMeterAlarmStatusLayerQueryVariables = Exact<{ [key: string]: never; }>;


export type RampMeterAlarmStatusLayerQuery = { __typename?: 'Query', intersectionSimpleStatus: Array<any>, alarms: { __typename?: 'AlarmConnection', edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', entityId: string, id: string } }> } };

export type PrimaryLaneStatusLayerUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PrimaryLaneStatusLayerUpdatedSubscription = { __typename?: 'Subscription', intersectionSimpleStatusUpdated: Array<{ __typename?: 'IntersectionSimpleStatus', intersectionId: string, mainlineColor: SignalOutputColor, communicationState: CommunicationState }> };

export type ActionStatusLayerUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ActionStatusLayerUpdatedSubscription = { __typename?: 'Subscription', intersectionSimpleStatusUpdated: Array<{ __typename?: 'IntersectionSimpleStatus', intersectionId: string, mainActionColor?: SignalOutputColor | null, communicationState: CommunicationState }> };

export type CommandSourceStatusLayerUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CommandSourceStatusLayerUpdatedSubscription = { __typename?: 'Subscription', intersectionSimpleStatusUpdated: Array<{ __typename?: 'IntersectionSimpleStatus', intersectionId: string, mainCommandSourceColor?: SignalOutputColor | null, communicationState: CommunicationState }> };

export type RampMeterCommunicationStateUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RampMeterCommunicationStateUpdatedSubscription = { __typename?: 'Subscription', intersectionSimpleStatusUpdated: Array<{ __typename?: 'IntersectionSimpleStatus', intersectionId: string, communicationState: CommunicationState }> };

export type RampMeterTimeDriftUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RampMeterTimeDriftUpdatedSubscription = { __typename?: 'Subscription', intersectionDetailStatusUpdated: Array<{ __typename?: 'IntersectionDetailStatus', intersectionId: string, time: { __typename?: 'IntersectionDeviceTime', drift?: number | null } } | null> };

export type RampMeterAlarmStatusUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type RampMeterAlarmStatusUpdatedSubscription = { __typename?: 'Subscription', alarmUpdated: { __typename?: 'Alarm', entityId: string, id: string, active: boolean, source: KineticModule } };

export type RampMeterIdsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type RampMeterIdsQuery = { __typename?: 'Query', rampMeterIds: Array<string> };

export type NearbyRampMetersByPointQueryVariables = Exact<{
  x: Scalars['Float'];
  y: Scalars['Float'];
  thresholdMiles?: InputMaybe<Scalars['Float']>;
}>;


export type NearbyRampMetersByPointQuery = { __typename?: 'Query', nearbyIntersectionsByPoint: Array<{ __typename?: 'Intersection', id: string }> };

export type RampMetersWithIconsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type RampMetersWithIconsQuery = { __typename?: 'Query', rampMeters: { __typename?: 'IntersectionConnection', edges: Array<{ __typename?: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, location: any, icons: Array<(
          { __typename?: 'IntersectionIcon' }
          & IntersectionIconFragment
        )>, lanes: Array<{ __typename?: 'IntersectionLane', id: string, description?: string | null, location: any, laneDirection: IntersectionLaneDirection, travelDirection?: IntersectionTravelDirection | null, vehicleDetectors: Array<{ __typename?: 'IntersectionVehicleDetector', description?: string | null, distance: number, length: number, location?: any | null, number: number, showOnMap: boolean, type?: IntersectionVehicleDetectorType | null, width: number, icon: (
              { __typename?: 'IntersectionIcon' }
              & IntersectionIconFragment
            ) }> }> } }> } };

export type RampMeterStatusCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type RampMeterStatusCategoriesQuery = { __typename?: 'Query', rampMeterStatusCategories: (
    { __typename?: 'RampMeterStatusCategories' }
    & RampMeterStatusCategoriesFragment
  ) };

export type RampMeterStatusCategoriesUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RampMeterStatusCategoriesUpdatedSubscription = { __typename?: 'Subscription', rampMeterStatusCategoriesUpdated: (
    { __typename?: 'RampMeterStatusCategories' }
    & RampMeterStatusCategoriesFragment
  ) };

export type RampMeterMapSearchResultQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type RampMeterMapSearchResultQuery = { __typename?: 'Query', rampMeters: { __typename?: 'IntersectionConnection', edges: Array<{ __typename?: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, location: any, details: { __typename?: 'IntersectionDetails', name: string }, devices: Array<{ __typename?: 'IntersectionDevice', name: string }> } }> } };

export type SaveRampMeterTaskMutationVariables = Exact<{
  input: TaskInput;
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type SaveRampMeterTaskMutation = { __typename?: 'Mutation', saveSignalScheduledTask?: (
    { __typename?: 'Task' }
    & SignalsTaskFragmentFragment
  ) | null };

export type GetAllRampMeterTasksQueryVariables = Exact<{
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
}>;


export type GetAllRampMeterTasksQuery = { __typename?: 'Query', signalScheduledTasks?: Array<(
    { __typename?: 'TaskOccurrence' }
    & TaskOccurrenceFragmentFragment
  )> | null };

export type GetRampMeterTasksByRampMeterIdQueryVariables = Exact<{
  intersectionId: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
}>;


export type GetRampMeterTasksByRampMeterIdQuery = { __typename?: 'Query', signalScheduledTasksByIntersection?: Array<(
    { __typename?: 'TaskOccurrence' }
    & TaskOccurrenceFragmentFragment
  )> | null };

export type RampMeterDetailStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type RampMeterDetailStatusesQuery = { __typename?: 'Query', intersectionDetailStatus: Array<any> };

export type RampMeterPatternStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type RampMeterPatternStatusQuery = { __typename?: 'Query', intersectionPatternStatus: Array<any> };

export type RampMeterSimpleStatusUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type RampMeterSimpleStatusUpdatedSubscription = { __typename?: 'Subscription', intersectionSimpleStatusUpdated: Array<{ __typename?: 'IntersectionSimpleStatus', intersectionId: string, communicationState: CommunicationState, mainImplementAction?: RmcImplementAction | null, mainImplementCommandSource?: RmcImplementCommandSource | null }> };

export type UserRampMeterPrivilegesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRampMeterPrivilegesQuery = { __typename?: 'Query', userRampMeterPrivileges: Array<{ __typename?: 'SignalPrivilege', privilegeType: PrivilegeType, restrictions: any, lastUpdated: number }> };

export type SaveReportBuilderMutationVariables = Exact<{
  input: ReportBuilderInput;
}>;


export type SaveReportBuilderMutation = { __typename?: 'Mutation', reportBuilderSave: { __typename?: 'ReportBuilder', id: string } };

export type CancelReportBuilderTaskMutationVariables = Exact<{
  id: Scalars['ID'];
  date: Scalars['DateTime'];
}>;


export type CancelReportBuilderTaskMutation = { __typename?: 'Mutation', reportBuilderTaskCancel: boolean };

export type SaveReportBuilderTaskMutationVariables = Exact<{
  input: TaskInput;
}>;


export type SaveReportBuilderTaskMutation = { __typename?: 'Mutation', reportBuilderTaskSave?: (
    { __typename?: 'Task' }
    & TaskFragmentFragment
  ) | null };

export type DeleteReportBuilderTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReportBuilderTaskMutation = { __typename?: 'Mutation', reportBuilderTaskDelete: boolean };

export type SaveReportBuilderBlockMutationVariables = Exact<{
  input: ReportBuilderBlockInput;
}>;


export type SaveReportBuilderBlockMutation = { __typename?: 'Mutation', reportBuilderBlockSave: { __typename?: 'ReportBuilderBlock', id: string } };

export type DeleteReportBuilderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReportBuilderMutation = { __typename?: 'Mutation', reportBuilderDelete: boolean };

export type DeleteReportBuilderBlockMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReportBuilderBlockMutation = { __typename?: 'Mutation', reportBuilderBlockDelete: boolean };

export type ReportBuilderBlockPreviewMutationVariables = Exact<{
  input: ReportBuilderBlockInput;
  params?: InputMaybe<Scalars['Object']>;
}>;


export type ReportBuilderBlockPreviewMutation = { __typename?: 'Mutation', reportBuilderBlockPreview?: any | null };

export type ReportBuilderListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ReportBuilderListQuery = { __typename?: 'Query', reportBuilders: { __typename?: 'ReportBuilderConnection', totalCount: number, edges: Array<{ __typename?: 'ReportBuilderEdge', node: { __typename?: 'ReportBuilder', description?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveReportBuilderListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveReportBuilderListSubscription = { __typename?: 'Subscription', reportBuilderUpdated: { __typename?: 'ReportBuilder', description?: string | null, name: string, id: string } };

export type AllScheduledReportTasksQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type AllScheduledReportTasksQuery = { __typename?: 'Query', allScheduledReportBuilderTasks?: Array<{ __typename?: 'DateTasks', date: any, tasks?: Array<(
      { __typename?: 'TaskOccurrence' }
      & TaskOccurrenceFragmentFragment
    ) | null> | null }> | null };

export type ScheduledReportTasksQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
}>;


export type ScheduledReportTasksQuery = { __typename?: 'Query', reportBuilderTasks?: Array<{ __typename?: 'DateTasks', date: any, tasks?: Array<(
      { __typename?: 'TaskOccurrence' }
      & TaskOccurrenceFragmentFragment
    ) | null> | null }> | null };

export type ScheduledReportTaskUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
}>;


export type ScheduledReportTaskUpdatedSubscription = { __typename?: 'Subscription', reportBuilderTaskUpdated: (
    { __typename?: 'Task' }
    & TaskFragmentFragment
  ) };

export type AllReportBuilderTasksQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AllReportBuilderTasksQuery = { __typename?: 'Query', allReportBuilderTasks?: Array<(
    { __typename?: 'Task' }
    & TaskFragmentFragment
  )> | null };

export type ReportBuilderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportBuilderQuery = { __typename?: 'Query', reportBuilder?: { __typename?: 'ReportBuilder', description?: string | null, name: string, id: string, sections: Array<{ __typename?: 'ReportBuilderSection', type: ReportBuilderSectionType, name: string, id: string, blocks: Array<{ __typename?: 'ReportBuilderSectionBlock', blockId: string, id: string }> }> } | null };

export type ReportBuilderBlockListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ReportBuilderBlockListQuery = { __typename?: 'Query', reportBuilderBlocks: { __typename?: 'ReportBuilderBlockConnection', totalCount: number, edges: Array<{ __typename?: 'ReportBuilderBlockEdge', node: { __typename?: 'ReportBuilderBlock', source: ReportDataSource, name: string, id: string, parameters: { __typename?: 'ReportDataParams', type: ReportDataDisplayType } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveReportBuilderBlockListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveReportBuilderBlockListSubscription = { __typename?: 'Subscription', reportBuilderBlockUpdated: { __typename?: 'ReportBuilderBlock', source: ReportDataSource, name: string, id: string, parameters: { __typename?: 'ReportDataParams', type: ReportDataDisplayType } } };

export type ReportBuilderBlockQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportBuilderBlockQuery = { __typename?: 'Query', reportBuilderBlock?: { __typename?: 'ReportBuilderBlock', source: ReportDataSource, name: string, id: string, parameters: { __typename?: 'ReportDataParams', groupBy?: string | null, type: ReportDataDisplayType, table?: { __typename?: 'ReportDataTableParams', header: { __typename?: 'ReportDataTableRowParams', cells: Array<{ __typename?: 'ReportDataTableCellParams', attribute?: string | null, label?: string | null, type: ReportDataTableCellType }> }, data: { __typename?: 'ReportDataTableRowParams', cells: Array<{ __typename?: 'ReportDataTableCellParams', attribute?: string | null, label?: string | null, type: ReportDataTableCellType }> }, rows: Array<{ __typename?: 'ReportDataTableRowParams', cells: Array<{ __typename?: 'ReportDataTableCellParams', attribute?: string | null, label?: string | null, type: ReportDataTableCellType }> }> } | null, aggregations: Array<{ __typename?: 'ReportDataAggregation', field?: string | null, type: ReportDataAggregationType }>, filters: Array<{ __typename?: 'Filter', operator: FilterOperator, field: string, value?: any | null }>, date: { __typename?: 'ReportDataDateParams', modifier?: number | null, range?: ReportDataDateRangeType | null, start?: string | null, type: ReportDataDateType, end?: string | null } } } | null };

export type KineticEventFormTemplateFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type KineticEventFormTemplateFieldsQuery = { __typename?: 'Query', kineticEventFormTemplateFields: Array<{ __typename?: 'KineticFormFieldOption', label: string, value: string, type?: string | null }> };

export type AddNetworkConditionsMutationVariables = Exact<{
  id: Scalars['ID'];
  boundedRoutes: Array<NetworkConditionInput> | NetworkConditionInput;
}>;


export type AddNetworkConditionsMutation = { __typename?: 'Mutation', addNetworkConditions: Array<{ __typename?: 'NetworkCondition', id: string }> };

export type UpdateNetworkConditionsMutationVariables = Exact<{
  networkConditions: Array<Scalars['String']> | Scalars['String'];
  conditions: Array<Scalars['String']> | Scalars['String'];
  status: Scalars['String'];
  id: Scalars['ID'];
}>;


export type UpdateNetworkConditionsMutation = { __typename?: 'Mutation', updateNetworkConditions: Array<{ __typename?: 'NetworkCondition', id: string }> };

export type ConfirmNetworkConditionsMutationVariables = Exact<{
  id: Scalars['ID'];
  networkConditions: Array<Scalars['String']> | Scalars['String'];
}>;


export type ConfirmNetworkConditionsMutation = { __typename?: 'Mutation', confirmNetworkConditions: Array<{ __typename?: 'NetworkCondition', id: string }> };

export type ClearNetworkConditionsMutationVariables = Exact<{
  id: Scalars['ID'];
  networkConditions: Array<Scalars['String']> | Scalars['String'];
}>;


export type ClearNetworkConditionsMutation = { __typename?: 'Mutation', clearNetworkConditions: Array<{ __typename?: 'NetworkCondition', id: string }> };

export type DeleteNetworkConditionsMutationVariables = Exact<{
  id: Scalars['ID'];
  networkConditions: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteNetworkConditionsMutation = { __typename?: 'Mutation', deleteNetworkConditions?: boolean | null };

export type UpdateNetworkJurisdictionMutationVariables = Exact<{
  id: Scalars['ID'];
  networkJurisdiction: NetworkJurisdictionInput;
}>;


export type UpdateNetworkJurisdictionMutation = { __typename?: 'Mutation', updateNetworkJurisdiction: { __typename?: 'NetworkJurisdiction', id: string } };

export type DeleteNetworkJurisdictionsMutationVariables = Exact<{
  id: Scalars['ID'];
  networkJurisdictions: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteNetworkJurisdictionsMutation = { __typename?: 'Mutation', deleteNetworkJurisdictions?: boolean | null };

export type NetworkConditionsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type NetworkConditionsListQuery = { __typename?: 'Query', networkConditions: { __typename?: 'NetworkConditionConnection', totalCount: number, edges: Array<{ __typename?: 'NetworkConditionConnectionEdge', node: { __typename?: 'NetworkCondition', classification: string, jurisdiction: string, lastUpdated: any, road: string, id: string, segments: Array<{ __typename?: 'NetworkConditionSegment', startMeasure: number, endMeasure: number, conditions: Array<string>, status: string }> } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveNetworkConditionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveNetworkConditionSubscription = { __typename?: 'Subscription', networkConditionUpdated: { __typename?: 'NetworkCondition', id: string } };

export type LiveNetworkConditionsListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveNetworkConditionsListSubscription = { __typename?: 'Subscription', networkConditionUpdated: { __typename?: 'NetworkCondition', classification: string, jurisdiction: string, lastUpdated: any, road: string, id: string, segments: Array<{ __typename?: 'NetworkConditionSegment', startMeasure: number, endMeasure: number, conditions: Array<string>, status: string }> } };

export type NetworkConditionsMapListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type NetworkConditionsMapListQuery = { __typename?: 'Query', networkConditions: { __typename?: 'NetworkConditionConnection', edges: Array<{ __typename?: 'NetworkConditionConnectionEdge', node: { __typename?: 'NetworkCondition', event: string, id: string, segments: Array<{ __typename?: 'NetworkConditionSegment', geometry?: any | null, status: string }> } }> } };

export type NetworkJurisdictionsMapListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type NetworkJurisdictionsMapListQuery = { __typename?: 'Query', networkJurisdictions: { __typename?: 'NetworkJurisdictionConnection', edges: Array<{ __typename?: 'NetworkJurisdictionConnectionEdge', node: { __typename?: 'NetworkJurisdiction', geometry?: any | null, status: string, event: string, id: string } }> } };

export type NetworkConditionsCountQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type NetworkConditionsCountQuery = { __typename?: 'Query', networkConditions: { __typename?: 'NetworkConditionConnection', totalCount: number } };

export type NetworkConditionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NetworkConditionQuery = { __typename?: 'Query', networkCondition?: { __typename?: 'NetworkCondition', classification: string, jurisdiction: string, lastUpdated: any, direction: Direction, event: string, road: string, id: string, segments: Array<{ __typename?: 'NetworkConditionSegment', startMeasure: number, endMeasure: number, conditions: Array<string>, status: string }> } | null };

export type NetworkConditionsSummaryListQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type NetworkConditionsSummaryListQuery = { __typename?: 'Query', networkConditions: { __typename?: 'NetworkConditionConnection', edges: Array<{ __typename?: 'NetworkConditionConnectionEdge', node: { __typename?: 'NetworkCondition', segments: Array<{ __typename?: 'NetworkConditionSegment', status: string }> } }> } };

export type LiveNetworkConditionsSummaryListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveNetworkConditionsSummaryListSubscription = { __typename?: 'Subscription', networkConditionUpdated: { __typename?: 'NetworkCondition', segments: Array<{ __typename?: 'NetworkConditionSegment', status: string }> } };

export type RoadConditionsSearchListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type RoadConditionsSearchListQuery = { __typename?: 'Query', events: { __typename?: 'EventConnection', edges: Array<{ __typename?: 'EventConnectionEdge', node: { __typename?: 'Event', attributes: any, geometry: any, name: string, id: string } }> } };

export type NetworkConditionFiltersListQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type NetworkConditionFiltersListQuery = { __typename?: 'Query', networkConditions: { __typename?: 'NetworkConditionConnection', edges: Array<{ __typename?: 'NetworkConditionConnectionEdge', node: { __typename?: 'NetworkCondition', classification: string, jurisdiction: string, id: string, segments: Array<{ __typename?: 'NetworkConditionSegment', conditions: Array<string>, status: string }> } }> } };

export type NetworkJurisdictionsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type NetworkJurisdictionsListQuery = { __typename?: 'Query', networkJurisdictions: { __typename?: 'NetworkJurisdictionConnection', totalCount: number, edges: Array<{ __typename?: 'NetworkJurisdictionConnectionEdge', node: { __typename?: 'NetworkJurisdiction', lastUpdated: any, conditions: Array<string>, attributes: any, status: string, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveNetworkJurisdictionsListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveNetworkJurisdictionsListSubscription = { __typename?: 'Subscription', networkJurisdictionUpdated: { __typename?: 'NetworkJurisdiction', lastUpdated: any, conditions: Array<string>, attributes: any, status: string, name: string, id: string } };

export type LiveNetworkJurisdictionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveNetworkJurisdictionSubscription = { __typename?: 'Subscription', networkJurisdictionUpdated: { __typename?: 'NetworkJurisdiction', id: string } };

export type NetworkJurisdictionFiltersListQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type NetworkJurisdictionFiltersListQuery = { __typename?: 'Query', networkJurisdictions: { __typename?: 'NetworkJurisdictionConnection', edges: Array<{ __typename?: 'NetworkJurisdictionConnectionEdge', node: { __typename?: 'NetworkJurisdiction', conditions: Array<string>, status: string, id: string } }> } };

export type NetworkJurisdictionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NetworkJurisdictionQuery = { __typename?: 'Query', networkJurisdiction?: { __typename?: 'NetworkJurisdiction', lastUpdated: any, attributes: any, conditions: Array<string>, status: string, type: string, name: string, id: string } | null };

export type NetworkJurisdictionCountQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type NetworkJurisdictionCountQuery = { __typename?: 'Query', networkJurisdictions: { __typename?: 'NetworkJurisdictionConnection', totalCount: number } };

export type SaveResponseRuleMutationVariables = Exact<{
  input: ResponseRuleInput;
}>;


export type SaveResponseRuleMutation = { __typename?: 'Mutation', saveResponseRule: { __typename?: 'ResponseRule', id: string } };

export type DeleteResponseRuleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteResponseRuleMutation = { __typename?: 'Mutation', deleteResponseRule?: boolean | null };

export type ResponseRulesListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ResponseRulesListQuery = { __typename?: 'Query', responseRules: { __typename?: 'ResponseRuleConnection', totalCount: number, edges: Array<{ __typename?: 'ResponseRuleConnectionEdge', node: { __typename?: 'ResponseRule', automatic: boolean, enabled: boolean, form?: string | null, name: string, id: string, condition: { __typename?: 'ResponseRuleCondition', priority: number, type: ResponseRuleConditionType }, action: { __typename?: 'ResponseRuleAction', type: ResponseRuleActionType } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type KineticFormTemplateFieldsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type KineticFormTemplateFieldsQuery = { __typename?: 'Query', kineticFormTemplateFields: Array<{ __typename?: 'KineticFormFieldOption', label: string, value: string, type?: string | null }> };

export type KineticFormOptionsListQueryVariables = Exact<{
  query: KineticFormInputQuery;
}>;


export type KineticFormOptionsListQuery = { __typename?: 'Query', kineticForms: { __typename?: 'KineticFormConnection', edges: Array<{ __typename?: 'KineticFormConnectionEdge', node: { __typename?: 'KineticForm', name: string, id: string } }> } };

export type ResponseRuleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResponseRuleQuery = { __typename?: 'Query', responseRule: { __typename?: 'ResponseRule', automatic: boolean, corridor?: string | null, enabled: boolean, type: ResponseRuleType, form?: string | null, name: string, id: string, condition: { __typename?: 'ResponseRuleCondition', type: ResponseRuleConditionType, priority: number, tree: any, rule: string }, action: { __typename?: 'ResponseRuleAction', resourcePlans: Array<string>, actionSets: Array<string>, detours: Array<string>, type: ResponseRuleActionType, message?: (
        { __typename?: 'SignMessage' }
        & SignMessageFragment
      ) | null, laneControlAction?: { __typename?: 'LaneControlAction', command?: string | null, priority?: number | null } | null, recommendedContacts?: Array<{ __typename?: 'RecipientDto', recipientId?: string | null, name?: string | null, label?: LabelType | null, email?: string | null, smsRecipient: boolean, type: RecipientType, workNumber?: string | null } | null> | null } } };

export type ResourcePlanSelectionOptionsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type ResourcePlanSelectionOptionsQuery = { __typename?: 'Query', resourcePlans: { __typename?: 'ResourcePlanConnection', edges: Array<{ __typename?: 'ResourcePlanConnectionEdge', node: { __typename?: 'ResourcePlan', id: string, details: { __typename?: 'ResourcePlanDetails', name: string } } }> } };

export type ActionSetSelectionOptionsQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type ActionSetSelectionOptionsQuery = { __typename?: 'Query', signalActionSets: { __typename?: 'SignalActionSetConnection', edges: Array<{ __typename?: 'SignalActionSetConnectionEdge', node: { __typename?: 'SignalActionSet', name: string, id: string } }> } };

export type SignSelectionOptionsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SignSelectionOptionsQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', name: string, id: string } }> } };

export type ResponseRuleConfigQueryVariables = Exact<{
  conditionType: ResponseRuleConditionType;
  actionType: ResponseRuleActionType;
  form?: InputMaybe<Scalars['ID']>;
}>;


export type ResponseRuleConfigQuery = { __typename?: 'Query', responseRuleConfig: any };

export type CorridorIntegrationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CorridorIntegrationsQuery = { __typename?: 'Query', corridor: { __typename?: 'Corridor', integrations: Array<string> } };

export type CameraSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type CameraSelectionListQuery = { __typename?: 'Query', cameras: { __typename?: 'CameraConnection', totalCount: number, edges: Array<{ __typename?: 'CameraConnectionEdge', node: { __typename?: 'Camera', referencePoint?: string | null, direction?: string | null, road?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type DetectorSelectionListQuery = { __typename?: 'Query', detectors: { __typename?: 'DetectorConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorConnectionEdge', node: { __typename?: 'Detector', referencePoint?: number | null, direction?: string | null, road?: string | null, name: string, id: string, communicationState?: CommunicationState | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorSelectionListUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DetectorSelectionListUpdatedSubscription = { __typename?: 'Subscription', detectorUpdated: { __typename?: 'Detector', referencePoint?: number | null, direction?: string | null, road?: string | null, name: string, id: string, communicationState?: CommunicationState | null } };

export type ResourcePlanSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ResourcePlanSelectionListQuery = { __typename?: 'Query', resourcePlans: { __typename?: 'ResourcePlanConnection', totalCount: number, edges: Array<{ __typename?: 'ResourcePlanConnectionEdge', node: { __typename?: 'ResourcePlan', id: string, details: { __typename?: 'ResourcePlanDetails', description?: string | null, name: string } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveResourcePlanSelectionListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveResourcePlanSelectionListSubscription = { __typename?: 'Subscription', resourcePlanUpdated?: { __typename?: 'ResourcePlan', id: string, details: { __typename?: 'ResourcePlanDetails', description?: string | null, name: string } } | null };

export type SignSelectionMapEntitiesQueryVariables = Exact<{
  filters: Array<FilterInput> | FilterInput;
}>;


export type SignSelectionMapEntitiesQuery = { __typename?: 'Query', signMapEntities: Array<any> };

export type TravelTimeSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TravelTimeSelectionListQuery = { __typename?: 'Query', travelTimes: { __typename?: 'TravelTimeConnection', totalCount: number, edges: Array<{ __typename?: 'TravelTimeConnectionEdge', node: { __typename?: 'TravelTime', name: string, id: string, parts: Array<{ __typename?: 'TravelTimePart', startReference: number, endReference: number, direction: Direction, road: string }> } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type WeatherStationSelectionListQueryVariables = Exact<{
  sortField?: InputMaybe<WeatherStationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type WeatherStationSelectionListQuery = { __typename?: 'Query', weatherStations: { __typename?: 'WeatherStationConnection', totalCount: number, edges: Array<{ __typename?: 'WeatherStationConnectionEdge', node: { __typename?: 'WeatherStation', referencePoint?: number | null, direction?: string | null, road?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type AlarmConfigFragmentFragment = { __typename?: 'AlarmConfig', id: string, name: string, source: KineticModule, entityType: AlarmEntityType, entityId?: string | null, alarmType: AlarmType, enabled: boolean, displayName: string, alarmSeverity: AlarmSeverity, triggerOnRecurrence: boolean, recurrenceUnit?: ChronoUnit | null, recurrencePeriod?: number | null, recurrenceCount?: number | null, systemNotification: boolean, acknowledgementType: AlarmAcknowledgementType, urgentNotification: boolean, delayThreshold?: number | null, delayThresholdUnit?: ChronoUnit | null, delayThresholdEnabled?: boolean | null, playAudibleAlert?: boolean | null, soundFile?: string | null };

export type SaveAlarmConfigMutationVariables = Exact<{
  input: AlarmConfigInput;
}>;


export type SaveAlarmConfigMutation = { __typename?: 'Mutation', saveAlarmConfig: (
    { __typename?: 'AlarmConfig' }
    & AlarmConfigFragmentFragment
  ) };

export type SaveAlarmConfigsMutationVariables = Exact<{
  input: Array<AlarmConfigInput> | AlarmConfigInput;
}>;


export type SaveAlarmConfigsMutation = { __typename?: 'Mutation', saveAlarmConfigs: Array<(
    { __typename?: 'AlarmConfig' }
    & AlarmConfigFragmentFragment
  )> };

export type DeleteAlarmConfigMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAlarmConfigMutation = { __typename?: 'Mutation', deleteAlarmConfig: boolean };

export type SaveMibAlarmConfigMutationVariables = Exact<{
  input: MibAlarmConfigInput;
}>;


export type SaveMibAlarmConfigMutation = { __typename?: 'Mutation', saveMibAlarmConfig: { __typename?: 'MibAlarmConfig', id: string } };

export type DeleteMibAlarmConfigsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteMibAlarmConfigsMutation = { __typename?: 'Mutation', deleteMibAlarmConfigs: boolean };

export type GetAlarmConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAlarmConfigQuery = { __typename?: 'Query', alarmConfig: (
    { __typename?: 'AlarmConfig' }
    & AlarmConfigFragmentFragment
  ) };

export type AlarmConfigsForEntityQueryVariables = Exact<{
  source: KineticModule;
  entityType: AlarmEntityType;
  entityId: Scalars['ID'];
}>;


export type AlarmConfigsForEntityQuery = { __typename?: 'Query', alarmConfigsForEntity: Array<(
    { __typename?: 'AlarmConfig' }
    & AlarmConfigFragmentFragment
  )> };

export type AlarmIntersectionNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type AlarmIntersectionNamesQuery = { __typename?: 'Query', intersections: { __typename?: 'IntersectionConnection', edges: Array<{ __typename?: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, details: { __typename?: 'IntersectionDetails', name: string } } }> } };

export type IntersectionAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string } }> } };

export type SearchAlarmConfigsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', totalCount: number, edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: (
        { __typename?: 'AlarmConfig' }
        & AlarmConfigFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type MibAlarmsConfigListQueryVariables = Exact<{ [key: string]: never; }>;


export type MibAlarmsConfigListQuery = { __typename?: 'Query', mibAlarmConfigs: Array<{ __typename?: 'MibAlarmConfig', id: string, index1?: number | null, index2?: number | null, bitIndex?: number | null, name: string, mibName?: string | null, displayName: string, value1?: any | null, value2?: any | null, comparison?: MibValueComparison | null }> };

export type MibAlarmConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MibAlarmConfigQuery = { __typename?: 'Query', mibAlarmConfig: { __typename?: 'MibAlarmConfig', id: string, index1?: number | null, index2?: number | null, bitIndex?: number | null, name: string, mibName?: string | null, displayName: string, value1?: any | null, value2?: any | null, comparison?: MibValueComparison | null } };

export type GetAlarmsClearedStateQueryVariables = Exact<{
  ids: Scalars['Object'];
}>;


export type GetAlarmsClearedStateQuery = { __typename?: 'Query', alarms: { __typename?: 'AlarmConnection', edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', id: string, clearedAt?: any | null } }> } };

export type SaveDatabaseExportTemplateMutationVariables = Exact<{
  input: DatabaseExportTemplateInput;
}>;


export type SaveDatabaseExportTemplateMutation = { __typename?: 'Mutation', saveDatabaseExportTemplate: { __typename?: 'DatabaseExportTemplate', id: string, name: string, deviceApi: DeviceViewsProtocolEntityEnum, tableNames: Array<string> } };

export type DeleteDatabaseExportTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDatabaseExportTemplateMutation = { __typename?: 'Mutation', deleteDatabaseExportTemplate: boolean };

export type DatabaseExportTemplatesListQueryVariables = Exact<{
  deviceApi?: InputMaybe<DeviceViewsProtocolEntityEnum>;
}>;


export type DatabaseExportTemplatesListQuery = { __typename?: 'Query', databaseExportTemplates: Array<{ __typename?: 'DatabaseExportTemplate', id: string, name: string, deviceApi: DeviceViewsProtocolEntityEnum }> };

export type ViewDatabaseExportTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ViewDatabaseExportTemplateQuery = { __typename?: 'Query', databaseExportTemplate: { __typename?: 'DatabaseExportTemplate', id: string, name: string, deviceApi: DeviceViewsProtocolEntityEnum, tableNames: Array<string> } };

export type GetDatabaseExportTableNamesQueryVariables = Exact<{
  deviceApi: DeviceViewsProtocolEntityEnum;
}>;


export type GetDatabaseExportTableNamesQuery = { __typename?: 'Query', deviceViews?: { __typename?: 'DeviceViewsUi', id: DeviceViewsProtocolEntityEnum, views: (
      { __typename?: 'IntersectionDeviceUIView', views?: Array<(
        { __typename?: 'IntersectionDeviceUIView', views?: Array<(
          { __typename?: 'IntersectionDeviceUIView', views?: Array<(
            { __typename?: 'IntersectionDeviceUIView', views?: Array<(
              { __typename?: 'IntersectionDeviceUIView', views?: Array<(
                { __typename?: 'IntersectionDeviceUIView', views?: Array<(
                  { __typename?: 'IntersectionDeviceUIView', views?: Array<(
                    { __typename?: 'IntersectionDeviceUIView', views?: Array<(
                      { __typename?: 'IntersectionDeviceUIView', views?: Array<(
                        { __typename?: 'IntersectionDeviceUIView' }
                        & ViewFragmentFragment
                      )> | null }
                      & ViewFragmentFragment
                    )> | null }
                    & ViewFragmentFragment
                  )> | null }
                  & ViewFragmentFragment
                )> | null }
                & ViewFragmentFragment
              )> | null }
              & ViewFragmentFragment
            )> | null }
            & ViewFragmentFragment
          )> | null }
          & ViewFragmentFragment
        )> | null }
        & ViewFragmentFragment
      )> | null }
      & ViewFragmentFragment
    ) } | null };

export type DatabaseExportViewFragment = { __typename?: 'IntersectionDeviceUIView', name?: string | null, displayName?: string | null, tables?: Array<{ __typename?: 'IntersectionDeviceUITable', name?: string | null, displayName?: string | null, indexes?: Array<{ __typename?: 'IntersectionDeviceUIIndex', name: string }> | null }> | null };

export type GetDatabaseProtocolQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  intersectionId: Scalars['ID'];
}>;


export type GetDatabaseProtocolQuery = { __typename?: 'Query', deviceDatabase?: { __typename?: 'DeviceDatabase', id: string, protocol?: string | null } | null, intersection?: { __typename?: 'Intersection', id: string, devices: Array<{ __typename?: 'IntersectionDevice', id: string, fieldEntityProtocol?: string | null }> } | null };

export type SynchroExportMutationVariables = Exact<{
  format: SynchroExportFormat;
  databasePatterns: Array<DatabasePatternIdExport> | DatabasePatternIdExport;
  filename: Scalars['String'];
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type SynchroExportMutation = { __typename?: 'Mutation', synchroExport: boolean };

export type SynchroIntersectionQueryVariables = Exact<{
  intersectionId: Scalars['ID'];
}>;


export type SynchroIntersectionQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', id: string, details: { __typename?: 'IntersectionDetails', name: string }, devices: Array<{ __typename?: 'IntersectionDevice', id: string, name: string, fieldEntityProtocol?: string | null }> } | null };

export type SynchroDeviceDatabasesQueryVariables = Exact<{
  intersectionId: Scalars['String'];
}>;


export type SynchroDeviceDatabasesQuery = { __typename?: 'Query', deviceDatabases: { __typename?: 'DeviceDatabaseConnection', edges: Array<{ __typename: 'DeviceDatabaseConnectionEdge', cursor?: string | null, node: { __typename?: 'DeviceDatabase', id: string, intersectionId: string, comment?: string | null, start?: any | null, type: DeviceDatabaseType } }> } };

export type CancelDeviceDatabaseActionMutationVariables = Exact<{
  databaseId: Scalars['ID'];
  intersectionId: Scalars['ID'];
}>;


export type CancelDeviceDatabaseActionMutation = { __typename?: 'Mutation', cancelDeviceDatabaseAction: boolean };

export type HasActiveDatabaseActionQueryVariables = Exact<{
  intersectionId: Scalars['ID'];
}>;


export type HasActiveDatabaseActionQuery = { __typename?: 'Query', hasActiveDatabaseAction: boolean };

export type IntersectionDatabaseActionUpdatedSubscriptionVariables = Exact<{
  intersectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type IntersectionDatabaseActionUpdatedSubscription = { __typename?: 'Subscription', intersectionDatabaseActionUpdated: { __typename?: 'DeviceDatabaseActionUpdated', intersectionId: string, hasActiveDatabaseAction: boolean } };

export type DeviceDatabaseMibChangeLogFragmentFragment = { __typename?: 'DeviceDatabaseMibChangeLog', id: string, databaseId?: string | null, updatedAt: any, intersectionId: string, comment?: string | null, userId?: string | null, userDisplayName?: string | null, databaseName?: string | null, deviceDatabaseType?: DeviceDatabaseType | null, mib?: any | null };

export type DeviceDatabaseMibChangeLogsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  intersectionId?: InputMaybe<Scalars['String']>;
}>;


export type DeviceDatabaseMibChangeLogsQuery = { __typename?: 'Query', deviceDatabaseMibChangeLogs: { __typename?: 'DeviceDatabaseMibChangeLogConnection', totalCount: number, edges: Array<{ __typename?: 'DeviceDatabaseMibChangeLogConnectionEdge', node: (
        { __typename?: 'DeviceDatabaseMibChangeLog' }
        & DeviceDatabaseMibChangeLogFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type IntersectionMibListsQueryVariables = Exact<{
  intersectionId: Scalars['String'];
}>;


export type IntersectionMibListsQuery = { __typename?: 'Query', intersectionMibLists: Array<{ __typename?: 'MibDefinition', name: string, shortName?: string | null }> };

export type DeviceDatabaseLockFragment = { __typename?: 'DeviceDatabaseLock', intersectionId: string, databaseId?: string | null, lockedDate: any, userId: string, userDisplayName: string };

export type LockDatabaseMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
}>;


export type LockDatabaseMutation = { __typename?: 'Mutation', lockDatabase: boolean };

export type UnlockDatabaseMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
}>;


export type UnlockDatabaseMutation = { __typename?: 'Mutation', unlockDatabase: boolean };

export type LockLiveDatabaseMutationVariables = Exact<{
  intersectionId: Scalars['String'];
}>;


export type LockLiveDatabaseMutation = { __typename?: 'Mutation', lockLiveDatabase: boolean };

export type UnlockLiveDatabaseMutationVariables = Exact<{
  intersectionId: Scalars['String'];
}>;


export type UnlockLiveDatabaseMutation = { __typename?: 'Mutation', unlockLiveDatabase: boolean };

export type AdminUnlockDatabaseMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
}>;


export type AdminUnlockDatabaseMutation = { __typename?: 'Mutation', adminUnlockDatabase: boolean };

export type AdminUnlockLiveDatabaseMutationVariables = Exact<{
  intersectionId: Scalars['String'];
}>;


export type AdminUnlockLiveDatabaseMutation = { __typename?: 'Mutation', adminUnlockLiveDatabase: boolean };

export type LiveDatabaseLockQueryVariables = Exact<{
  intersectionId: Scalars['ID'];
}>;


export type LiveDatabaseLockQuery = { __typename?: 'Query', liveDatabaseLock?: (
    { __typename?: 'DeviceDatabaseLock' }
    & DeviceDatabaseLockFragment
  ) | null };

export type DatabaseLockQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  intersectionId: Scalars['ID'];
}>;


export type DatabaseLockQuery = { __typename?: 'Query', databaseLock?: (
    { __typename?: 'DeviceDatabaseLock' }
    & DeviceDatabaseLockFragment
  ) | null };

export type DatabaseLockUpdatedSubscriptionVariables = Exact<{
  intersectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DatabaseLockUpdatedSubscription = { __typename?: 'Subscription', databaseLockUpdated: Array<{ __typename?: 'DeviceDatabaseLockStatus', intersectionId: string, databaseId?: string | null, action: DatabaseLockAction, databaseType: DeviceDatabaseType, updatedBy: DatabaseLockUpdateAction, userId?: string | null, userDisplayName?: string | null }> };

export type DatabaseUiTableQueryVariables = Exact<{
  intersectionId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  databaseId?: InputMaybe<Scalars['String']>;
  firstIndexOnly?: InputMaybe<Scalars['Boolean']>;
  topIndex?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['Boolean']>;
}>;


export type DatabaseUiTableQuery = { __typename?: 'Query', deviceUITable?: { __typename?: 'IntersectionDeviceUITable', name?: string | null, displayName?: string | null, col?: number | null, row?: number | null, height?: number | null, width?: number | null, swap?: boolean | null, columns?: Array<{ __typename?: 'IntersectionDeviceUIColumn', name: string, displayName?: string | null, displayAsHeader?: boolean | null, readonly: boolean, mibName: string, description?: string | null, type: { __typename?: 'IntersectionDeviceUIColumnType', type: IntersectionDeviceUiColumnTypeEnum, maxValue?: number | null, minValue?: number | null, decimalPos?: number | null, isHexadecimal?: boolean | null, isMultiLines?: boolean | null, onlyFirstRowDescription?: boolean | null, swapRowsColumns?: boolean | null, displayAsHeader?: boolean | null, bits?: Array<{ __typename?: 'IntersectionDeviceUIColumnBit', used?: boolean | null, description?: string | null, appendIndex?: boolean | null, multiply?: number | null, plus?: number | null }> | null, enum?: Array<{ __typename?: 'IntersectionDeviceUIColumnEnumeration', value?: string | null, description?: string | null }> | null }, mib: { __typename?: 'IntersectionDeviceUIMib', name: string, mibIndex?: Array<{ __typename?: 'IntersectionDeviceUIMibIndex', name: string, data?: Array<{ __typename?: 'IntersectionDeviceUIMibData', index: number, counter?: number | null, value?: string | null, bitField?: Array<{ __typename?: 'IntersectionDeviceUIMibBitField', index: number, value: boolean }> | null, mibIndex?: Array<{ __typename?: 'IntersectionDeviceUIMibIndex', name: string, data?: Array<{ __typename?: 'IntersectionDeviceUIMibData', index: number, counter?: number | null, value?: string | null, bitField?: Array<{ __typename?: 'IntersectionDeviceUIMibBitField', index: number, value: boolean }> | null }> | null }> | null }> | null }> | null, data?: Array<{ __typename?: 'IntersectionDeviceUIMibData', index: number, counter?: number | null, value?: string | null, bitField?: Array<{ __typename?: 'IntersectionDeviceUIMibBitField', index: number, value: boolean }> | null, mibIndex?: Array<{ __typename?: 'IntersectionDeviceUIMibIndex', name: string, data?: Array<{ __typename?: 'IntersectionDeviceUIMibData', index: number, counter?: number | null, value?: string | null, bitField?: Array<{ __typename?: 'IntersectionDeviceUIMibBitField', index: number, value: boolean }> | null }> | null }> | null }> | null } }> | null, indexes?: Array<{ __typename?: 'IntersectionDeviceUIIndex', name: string, displayed?: boolean | null, rows?: number | null }> | null } | null };

export type DatabaseUiViewQueryVariables = Exact<{
  intersectionId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  databaseId?: InputMaybe<Scalars['String']>;
  timeout?: InputMaybe<Scalars['Int']>;
}>;


export type DatabaseUiViewQuery = { __typename?: 'Query', deviceUI?: { __typename?: 'IntersectionDeviceUI', views?: Array<(
      { __typename?: 'IntersectionDeviceUIView', views?: Array<(
        { __typename?: 'IntersectionDeviceUIView', views?: Array<(
          { __typename?: 'IntersectionDeviceUIView', views?: Array<(
            { __typename?: 'IntersectionDeviceUIView', views?: Array<(
              { __typename?: 'IntersectionDeviceUIView' }
              & ViewFragmentFragment
            )> | null }
            & ViewFragmentFragment
          )> | null }
          & ViewFragmentFragment
        )> | null }
        & ViewFragmentFragment
      )> | null }
      & ViewFragmentFragment
    )> | null } | null };

export type DatabaseComparisonMibValueFragmentFragment = { __typename?: 'DatabaseComparisonMibValue', tableName: string, name: string, shortName: string, indexes?: Array<number | null> | null, bitIndex?: number | null, value?: any | null, description?: string | null };

export type DeviceDatabaseComparisonQueryVariables = Exact<{
  db1: Scalars['ID'];
  db2: Scalars['ID'];
  intersectionId: Scalars['ID'];
}>;


export type DeviceDatabaseComparisonQuery = { __typename?: 'Query', deviceDatabaseComparison: { __typename?: 'DeviceDatabaseComparison', differences: Array<{ __typename?: 'DeviceDatabaseComparisonDifference', type: DeviceDatabaseComparisonDifferenceType, originalMib: (
        { __typename?: 'DatabaseComparisonMibValue' }
        & DatabaseComparisonMibValueFragmentFragment
      ), compareMib: (
        { __typename?: 'DatabaseComparisonMibValue' }
        & DatabaseComparisonMibValueFragmentFragment
      ) }> } };

export type GetDatabaseCompareLocationsTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDatabaseCompareLocationsTreeQuery = { __typename?: 'Query', locationGroups: Array<{ __typename?: 'FlatLocationGroup', id: string, name: string, parentId?: string | null, readOnly?: boolean | null, externalCenterId?: string | null, order?: number | null }>, locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, groupId?: string | null, locationType: string, order?: number | null, details: { __typename?: 'LocationDetails', name: string }, associatedEntities: Array<{ __typename?: 'LocationAssociation', entityType: LocationAssociationEntityType, entityId: string }>, integrations: Array<{ __typename?: 'Integration', id: string, systemEnabled: boolean, config: { __typename?: 'IntegrationConfig', integrationType: IntegrationType } }> } }> } };

export type DetectorGroupListItemFragment = { __typename?: 'SignalDetectorGroup', id: string, name: string, aggregationMethod: SignalDetectorGroupAggregationMethodType, loggingEnabled: boolean, loggingPeriodMinutes?: number | null, description?: string | null, detectors: Array<{ __typename?: 'SignalDetector', intersectionId: string, detector: number, direction: SignalDetectorDirectionType, movement: SignalDetectorMovementType, weight?: number | null, note?: string | null }> };

export type SaveSignalDetectorGroupMutationVariables = Exact<{
  input: SignalDetectorGroupInput;
}>;


export type SaveSignalDetectorGroupMutation = { __typename?: 'Mutation', saveSignalDetectorGroup: { __typename?: 'SignalDetectorGroup', id: string } };

export type DeleteSignalDetectorGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSignalDetectorGroupMutation = { __typename?: 'Mutation', deleteSignalDetectorGroup: boolean };

export type DetectorGroupExportMutationVariables = Exact<{
  detectorGroupId: Scalars['String'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  fileName: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type DetectorGroupExportMutation = { __typename?: 'Mutation', detectorGroupExport: boolean };

export type SignalDetectorGroupsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SignalDetectorGroupsListQuery = { __typename?: 'Query', signalDetectorGroups: { __typename?: 'SignalDetectorGroupConnection', edges: Array<{ __typename?: 'SignalDetectorGroupConnectionEdge', node: (
        { __typename?: 'SignalDetectorGroup' }
        & DetectorGroupListItemFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DetectorGroupOverviewReportQueryVariables = Exact<{
  detectorGroupId: Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
}>;


export type DetectorGroupOverviewReportQuery = { __typename?: 'Query', detectorGroupOverviewReport: Array<{ __typename?: 'ChartData', name: string, dataPoints?: Array<{ __typename?: 'DataPoint', x: string, y: string } | null> | null }> };

export type AcceptDeviceDatabaseValidationMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
}>;


export type AcceptDeviceDatabaseValidationMutation = { __typename?: 'Mutation', acceptDeviceDatabaseValidation: boolean };

export type RejectDeviceDatabaseValidationMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
}>;


export type RejectDeviceDatabaseValidationMutation = { __typename?: 'Mutation', rejectDeviceDatabaseValidation: boolean };

export type ValidateDeviceDatabaseMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
}>;


export type ValidateDeviceDatabaseMutation = { __typename?: 'Mutation', validateDeviceDatabase: boolean };

export type GetDeviceDatabaseQueryVariables = Exact<{
  intersectionId: Scalars['String'];
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetDeviceDatabaseQuery = { __typename?: 'Query', deviceDatabases: { __typename?: 'DeviceDatabaseConnection', totalCount: number, edges: Array<{ __typename: 'DeviceDatabaseConnectionEdge', cursor?: string | null, node: { __typename?: 'DeviceDatabase', id: string, intersectionId: string, comment?: string | null, start?: any | null, end?: any | null, type: DeviceDatabaseType, status?: DeviceDatabaseStatus | null, revision?: string | null, approved: boolean, approvedComment?: string | null, approvedDate?: string | null, archived: boolean, progress?: number | null, firmwareVersion?: string | null, protocol?: string | null, user?: { __typename?: 'OrganizationKineticUser', id: string } | null, databaseValidation?: { __typename?: 'DatabaseValidation', status?: DatabaseValidationStatus | null, results?: Array<{ __typename?: 'DatabaseValidationResult', severity: DatabaseValidationSeverity, description: string }> | null } | null } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetDeviceDatabasesEditorQueryVariables = Exact<{
  intersectionId: Scalars['String'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetDeviceDatabasesEditorQuery = { __typename?: 'Query', deviceDatabases: { __typename?: 'DeviceDatabaseConnection', totalCount: number, edges: Array<{ __typename?: 'DeviceDatabaseConnectionEdge', cursor?: string | null, node: { __typename?: 'DeviceDatabase', id: string, intersectionId: string, comment?: string | null, start?: any | null, end?: any | null, type: DeviceDatabaseType, status?: DeviceDatabaseStatus | null, revision?: string | null, approved: boolean, approvedComment?: string | null, approvedDate?: string | null, archived: boolean, firmwareVersion?: string | null, locked: boolean, lockedDate?: any | null, protocol?: string | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LocalDeviceDatabasesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocalDeviceDatabasesQuery = { __typename?: 'Query', localDeviceDatabases: Array<{ __typename?: 'LocalDeviceDatabase', id: string, type: LocalDeviceDatabaseType, name: string }> };

export type IntersectionDatabaseDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
  intersectionId: Scalars['ID'];
}>;


export type IntersectionDatabaseDetailsQuery = { __typename?: 'Query', deviceDatabase?: { __typename?: 'DeviceDatabase', id: string, comment?: string | null, start?: any | null, type: DeviceDatabaseType, status?: DeviceDatabaseStatus | null, firmwareVersion?: string | null, protocol?: string | null } | null };

export type DeviceDatabaseUpdatedSubscriptionVariables = Exact<{
  databaseIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  intersectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DeviceDatabaseUpdatedSubscription = { __typename?: 'Subscription', deviceDatabaseUpdated: { __typename?: 'DeviceDatabase', id: string, intersectionId: string, comment?: string | null, progress?: number | null, start?: any | null, end?: any | null, type: DeviceDatabaseType, status?: DeviceDatabaseStatus | null, revision?: string | null, approved: boolean, approvedComment?: string | null, approvedDate?: string | null, archived: boolean, firmwareVersion?: string | null, protocol?: string | null, user?: { __typename?: 'OrganizationKineticUser', id: string } | null } };

export type MiniMapIntersectionFragment = { __typename?: 'Intersection', id: string, location: any, locationId: string, details: { __typename?: 'IntersectionDetails', name: string }, devices: Array<{ __typename?: 'IntersectionDevice', id: string, name: string, type: IntersectionDeviceType, fieldEntityProtocol?: string | null }>, icons: Array<{ __typename?: 'IntersectionIcon', name?: string | null, type: IntersectionIconType, location: any, bearing: number, config: any, state?: any | null, link?: string | null }>, lanes: Array<{ __typename?: 'IntersectionLane', id: string, travelDirection?: IntersectionTravelDirection | null, vehicleDetectors: Array<{ __typename?: 'IntersectionVehicleDetector', type?: IntersectionVehicleDetectorType | null }> }> };

export type IntersectionStatusCategoriesFragmentFragment = { __typename?: 'IntersectionStatusCategories', badPlan: number, cabinetFlash: number, commDisabled: number, commFailed: number, coordination: number, unknown: number, transition: number, preempt: number, localFlash: number, free: number };

export type ViewFragmentFragment = { __typename?: 'IntersectionDeviceUIView', name?: string | null, displayName?: string | null, tables?: Array<{ __typename?: 'IntersectionDeviceUITable', name?: string | null, displayName?: string | null, indexes?: Array<{ __typename?: 'IntersectionDeviceUIIndex', name: string }> | null }> | null };

export type DeviceUiViewFragmentFragment = { __typename?: 'IntersectionDeviceUIView', displayName?: string | null, tables?: Array<{ __typename?: 'IntersectionDeviceUITable', name?: string | null, displayName?: string | null, indexes?: Array<{ __typename?: 'IntersectionDeviceUIIndex', name: string }> | null }> | null };

export type SignalsTaskFragmentFragment = { __typename?: 'Task', id: string, name: string, taskType: TaskType, timezone?: string | null, start: any, end: any, data: any, taskRecurrenceType: TaskRecurrenceType, rrule?: string | null, recurrenceEndDate?: any | null, externalCenterId?: string | null };

export type IntersectionDetailStatusFragment = { __typename?: 'IntersectionDetailStatus', category: IntersectionStatusCategory, activeAlarms: Array<string>, firmwareVersion?: string | null, unitFlashStatus: FlashStatus, isPreemptActive: boolean, isPrioritorActive: boolean, time: { __typename?: 'IntersectionDeviceTime', globalTime?: number | null, drift?: number | null }, specialFunctionStatus: Array<{ __typename?: 'SpecialFunctionStatus', number: number, active: boolean }>, preemptStatus: Array<{ __typename?: 'PreemptStatus', number: number, enabled: boolean, active: boolean, mibValue?: string | null }>, prioritorStatus: Array<{ __typename?: 'PrioritorStatus', number: number, enabled: boolean, active: boolean, mibValue?: string | null }>, dynamicIndexedMibs: Array<{ __typename?: 'MibIndexed', name: string, shortName?: string | null, indexes?: Array<number> | null, bitIndex?: number | null }>, crosshairs: Array<{ __typename?: 'CrosshairStatus', type?: SignalIndicationType | null, phase?: number | null, color?: SignalOutputColor | null, anchor?: { __typename?: 'IconAnchor', coordinates?: Array<number> | null, bearing?: number | null } | null }> };

export type PatternStatusFragmentFragment = { __typename?: 'IntersectionPatternStatus', activeCycleLength: number, programmedCycleLength: number, coordStatus: CoordStatus, patternType: PatternType, patternNumber: number, localCycle: number, masterCycle: number, programmedOffset: number, activeOffset: number };

export type DeviceEventFragmentFragment = { __typename: 'DeviceEvent', id: string, timestamp: any, deviceId: string, intersectionId: string, parameter?: any | null, vendorEventCode: number };

export type AppliedCommandFragmentFragment = { __typename: 'SignalAppliedCommand', id: string, taskId: string, command: string, value: string, source?: string | null, startDateTime: any, endDateTime: any, status: string, intersection: { __typename?: 'BasicIntersectionDevice', id: string, name: string }, device: { __typename?: 'BasicIntersectionDevice', id: string, name: string }, inheritedGroup?: { __typename?: 'BasicIntersectionDevice', id: string, name: string } | null };

export type GraphDataFragmentFragment = { __typename?: 'GraphData', title: string, xAxis: { __typename?: 'AxisInfo', title: string, type: DataType, min?: string | null, max?: string | null }, yAxis: Array<{ __typename?: 'AxisInfo', title: string, type: DataType, min?: string | null, max?: string | null, series: Array<string | null> }>, overlay: Array<{ __typename?: 'OverlayInfo', label: string, x1: string, x2: string, type: DataType, color?: string | null, opacity?: number | null }>, checkPoints: Array<{ __typename?: 'CheckPoint', type: DataType, color?: string | null, legend?: string | null, dataPoints?: Array<string | null> | null } | null>, data: Array<{ __typename?: 'ChartData', name: string, legend?: string | null, type: string, color?: string | null, shape?: string | null, dataPoints?: Array<{ __typename?: 'DataPoint', x: string, y: string } | null> | null }> };

export type TableDataFragmentFragment = { __typename?: 'GroupedReportTable', groupName: string, groupedTables: Array<{ __typename: 'Table', name: string, data: Array<any | null>, columnProperties: Array<{ __typename?: 'ColumnProperty', name: string, type: DataType }> }> };

export type ReportTabsFragmentFragment = { __typename?: 'ReportTab', tabName: string, title: string, graphData: (
    { __typename?: 'GraphData' }
    & GraphDataFragmentFragment
  ), tableData: Array<(
    { __typename?: 'GroupedReportTable' }
    & TableDataFragmentFragment
  )> };

export type SignalActivityLogFragment = { __typename?: 'ActivityLog', description?: string | null, timestamp: any, object?: any | null, userId?: string | null, type?: string | null, id: string, changes?: Array<{ __typename?: 'ActivityLogChange', path?: string | null, operation?: ActivityLogChangeType | null, oldValue?: string | null, newValue?: string | null }> | null };

export type IntersectionCommunicationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionCommunicationStatusQuery = { __typename?: 'Query', intersectionCommunicationStatus: Array<any> };

export type IntersectionCommunicationStatusUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IntersectionCommunicationStatusUpdatedSubscription = { __typename?: 'Subscription', intersectionCommunicationStatusUpdated: Array<{ __typename?: 'IntersectionCommunicationStatus', intersectionId: string, mainlineColor: SignalOutputColor, communicationState: CommunicationState, category: IntersectionStatusCategory }> };

export type IntersectionIconFragment = { __typename?: 'IntersectionIcon', name?: string | null, type: IntersectionIconType, location: any, bearing: number, link?: string | null, config: any };

export type SignalIndicationFragment = { __typename?: 'SignalIndication', signalNumber: number, signalType: SignalIndicationType, green: SignalOutputColor, yellow: SignalOutputColor, red: SignalOutputColor, greenFlashing: boolean, yellowFlashing: boolean, redFlashing: boolean, greenIcon: IntersectionMapIcon, yellowIcon: IntersectionMapIcon, redIcon: IntersectionMapIcon };

export type BaseIntersectionDetailFragment = { __typename?: 'Intersection', id: string, statusCategory: IntersectionStatusCategory, groupId?: string | null, locationId: string, location: any, centerInfo?: { __typename?: 'CenterInfo', id: string, centerId: string } | null, details: { __typename?: 'IntersectionDetails', name: string, mainPhases: Array<number>, labels: Array<string>, note?: string | null }, devices: Array<{ __typename?: 'IntersectionDevice', id: string, type: IntersectionDeviceType, name: string, location?: any | null, fieldEntityProtocol?: string | null, connectionInfo?: string | null }>, icons: Array<(
    { __typename?: 'IntersectionIcon' }
    & IntersectionIconFragment
  )>, lanes: Array<{ __typename?: 'IntersectionLane', id: string, description?: string | null, location: any, laneDirection: IntersectionLaneDirection, travelDirection?: IntersectionTravelDirection | null, vehicleDetectors: Array<{ __typename?: 'IntersectionVehicleDetector', description?: string | null, distance: number, length: number, location?: any | null, number: number, showOnMap: boolean, type?: IntersectionVehicleDetectorType | null, width: number, icon: (
        { __typename?: 'IntersectionIcon' }
        & IntersectionIconFragment
      ) }> }>, crosswalks: Array<{ __typename?: 'IntersectionCrosswalk', id: string, description?: string | null, location: any, deviceId?: string | null, signalIndication: (
      { __typename?: 'SignalIndication' }
      & SignalIndicationFragment
    ), icon?: Array<(
      { __typename?: 'IntersectionIcon' }
      & IntersectionIconFragment
    )> | null }>, multiModals: Array<{ __typename?: 'IntersectionMultiModal', deviceId: string, signalIndication?: (
      { __typename?: 'SignalIndication' }
      & SignalIndicationFragment
    ) | null, icon: (
      { __typename?: 'IntersectionIcon' }
      & IntersectionIconFragment
    ) }>, maneuvers: Array<{ __typename?: 'IntersectionManeuver', id: string, maneuverType: IntersectionManeuverType, refApproachLane: string, refDepartureLane: string, protectedSignalIndication?: (
      { __typename?: 'SignalIndication' }
      & SignalIndicationFragment
    ) | null, permissiveSignalIndication?: (
      { __typename?: 'SignalIndication' }
      & SignalIndicationFragment
    ) | null, icon: (
      { __typename?: 'IntersectionIcon' }
      & IntersectionIconFragment
    ) }> };

export type BaseSignalTemplateDetailFragment = { __typename?: 'Intersection', id: string, groupId?: string | null, locationId: string, location: any, centerInfo?: { __typename?: 'CenterInfo', id: string, centerId: string } | null, details: { __typename?: 'IntersectionDetails', name: string, mainPhases: Array<number>, labels: Array<string>, note?: string | null }, devices: Array<{ __typename?: 'IntersectionDevice', id: string, type: IntersectionDeviceType, name: string, location?: any | null, fieldEntityProtocol?: string | null, connectionInfo?: string | null }>, icons: Array<(
    { __typename?: 'IntersectionIcon' }
    & IntersectionIconFragment
  )>, lanes: Array<{ __typename?: 'IntersectionLane', id: string, description?: string | null, location: any, laneDirection: IntersectionLaneDirection, travelDirection?: IntersectionTravelDirection | null, vehicleDetectors: Array<{ __typename?: 'IntersectionVehicleDetector', description?: string | null, distance: number, length: number, location?: any | null, number: number, showOnMap: boolean, type?: IntersectionVehicleDetectorType | null, width: number, icon: (
        { __typename?: 'IntersectionIcon' }
        & IntersectionIconFragment
      ) }> }>, crosswalks: Array<{ __typename?: 'IntersectionCrosswalk', id: string, description?: string | null, location: any, deviceId?: string | null, signalIndication: (
      { __typename?: 'SignalIndication' }
      & SignalIndicationFragment
    ), icon?: Array<(
      { __typename?: 'IntersectionIcon' }
      & IntersectionIconFragment
    )> | null }>, multiModals: Array<{ __typename?: 'IntersectionMultiModal', deviceId: string, signalIndication?: (
      { __typename?: 'SignalIndication' }
      & SignalIndicationFragment
    ) | null, icon: (
      { __typename?: 'IntersectionIcon' }
      & IntersectionIconFragment
    ) }>, maneuvers: Array<{ __typename?: 'IntersectionManeuver', id: string, maneuverType: IntersectionManeuverType, refApproachLane: string, refDepartureLane: string, protectedSignalIndication?: (
      { __typename?: 'SignalIndication' }
      & SignalIndicationFragment
    ) | null, permissiveSignalIndication?: (
      { __typename?: 'SignalIndication' }
      & SignalIndicationFragment
    ) | null, icon: (
      { __typename?: 'IntersectionIcon' }
      & IntersectionIconFragment
    ) }> };

export type IntersectionDetailFragment = (
  { __typename?: 'Intersection' }
  & BaseIntersectionDetailFragment
);

export type GenerateIntersectionStatusReportMutationVariables = Exact<{
  columns?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GenerateIntersectionStatusReportMutation = { __typename?: 'Mutation', generateIntersectionStatusReport: boolean };

export type IntersectionDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionDetailQuery = { __typename?: 'Query', intersection?: (
    { __typename?: 'Intersection' }
    & IntersectionDetailFragment
  ) | null };

export type IntersectionDetailPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionDetailPageQuery = { __typename?: 'Query', intersection?: (
    { __typename?: 'Intersection' }
    & IntersectionDetailFragment
  ) | null };

export type SignalTemplateDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignalTemplateDetailQuery = { __typename?: 'Query', intersection?: (
    { __typename?: 'Intersection' }
    & BaseSignalTemplateDetailFragment
  ) | null };

export type IntersectionDevicesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionDevicesQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', location: any, details: { __typename?: 'IntersectionDetails', name: string }, devices: Array<{ __typename?: 'IntersectionDevice', id: string, type: IntersectionDeviceType }> } | null };

export type IntersectionCloneDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionCloneDetailQuery = { __typename?: 'Query', intersection?: (
    { __typename?: 'Intersection' }
    & BaseIntersectionDetailFragment
  ) | null };

export type IntersectionNameDevicesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionNameDevicesQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', details: { __typename?: 'IntersectionDetails', name: string }, devices: Array<{ __typename?: 'IntersectionDevice', id: string, name: string, type: IntersectionDeviceType, fieldEntityProtocol?: string | null }> } | null, intersectionDetailStatusById?: { __typename?: 'IntersectionDetailStatus', firmwareVersion?: string | null } | null };

export type GetDeviceIdQueryVariables = Exact<{
  intersectionId: Scalars['ID'];
}>;


export type GetDeviceIdQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', devices: Array<{ __typename?: 'IntersectionDevice', id: string }> } | null };

export type IntersectionNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionNameQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', id: string, details: { __typename?: 'IntersectionDetails', name: string } } | null };

export type TimeOfDayWidgetIntersectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TimeOfDayWidgetIntersectionQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', devices: Array<{ __typename?: 'IntersectionDevice', id: string, type: IntersectionDeviceType }> } | null };

export type IntersectionTooltipQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionTooltipQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', locationId: string, details: { __typename?: 'IntersectionDetails', name: string }, devices: Array<{ __typename?: 'IntersectionDevice', type: IntersectionDeviceType, name: string, connectionInfo?: string | null, fieldEntityProtocol?: string | null }> } | null };

export type MiniMapIntersectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MiniMapIntersectionQuery = { __typename?: 'Query', intersection?: (
    { __typename?: 'Intersection' }
    & MiniMapIntersectionFragment
  ) | null };

export type MainMapCloneIntersectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MainMapCloneIntersectionQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', id: string, location: any, locationId: string, details: { __typename?: 'IntersectionDetails', name: string } } | null };

export type IntersectionListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type IntersectionListQuery = { __typename?: 'Query', intersections: { __typename?: 'IntersectionConnection', totalCount: number, edges: Array<{ __typename: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, location: any, locationId: string, statusCategory: IntersectionStatusCategory, details: { __typename?: 'IntersectionDetails', name: string, mainStreet?: string | null, sideStreet?: string | null, note?: string | null, labels: Array<string> }, devices: Array<{ __typename?: 'IntersectionDevice', id: string, name: string, connectionInfo?: string | null, fieldEntityProtocol?: string | null }> } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type IntersectionTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionTemplateQuery = { __typename?: 'Query', intersectionTemplate: { __typename?: 'IntersectionTemplate', id: string, name: string, description?: string | null, template: (
      { __typename?: 'Intersection' }
      & BaseSignalTemplateDetailFragment
    ) } };

export type IntersectionTemplatesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type IntersectionTemplatesQuery = { __typename?: 'Query', intersectionTemplates: { __typename?: 'IntersectionTemplateConnection', totalCount: number, edges: Array<{ __typename?: 'IntersectionTemplateConnectionEdge', node: { __typename?: 'IntersectionTemplate', id: string, name: string, description?: string | null, template: (
          { __typename?: 'Intersection' }
          & BaseSignalTemplateDetailFragment
        ) } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type IntersectionIconListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type IntersectionIconListQuery = { __typename?: 'Query', intersections: { __typename?: 'IntersectionConnection', edges: Array<{ __typename?: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, location: any, icons: Array<(
          { __typename?: 'IntersectionIcon' }
          & IntersectionIconFragment
        )>, lanes: Array<{ __typename?: 'IntersectionLane', id: string, description?: string | null, location: any, laneDirection: IntersectionLaneDirection, travelDirection?: IntersectionTravelDirection | null, vehicleDetectors: Array<{ __typename?: 'IntersectionVehicleDetector', description?: string | null, distance: number, length: number, location?: any | null, number: number, showOnMap: boolean, type?: IntersectionVehicleDetectorType | null, width: number, icon: (
              { __typename?: 'IntersectionIcon' }
              & IntersectionIconFragment
            ) }> }> } }> } };

export type IntersectionNamesQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type IntersectionNamesQuery = { __typename?: 'Query', intersections: { __typename?: 'IntersectionConnection', edges: Array<{ __typename?: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, details: { __typename?: 'IntersectionDetails', name: string } } }> } };

export type SaveLocationCorridorMutationVariables = Exact<{
  input: LocationCorridorInput;
}>;


export type SaveLocationCorridorMutation = { __typename?: 'Mutation', saveLocationCorridor: { __typename?: 'LocationCorridor', id: string, name: string, entryLeg: { __typename?: 'LocationCorridorLeg', id: string }, exitLeg: { __typename?: 'LocationCorridorLeg', id: string }, links: Array<{ __typename?: 'LocationCorridorConnectedLink', linkOrder: number, link: { __typename?: 'LocationCorridorLink', id: string }, downLinkLane: { __typename?: 'LocationCorridorLinkLane', id: string }, upLinkLane: { __typename?: 'LocationCorridorLinkLane', id: string } }> } };

export type DeleteLocationCorridorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLocationCorridorMutation = { __typename?: 'Mutation', deleteLocationCorridor: boolean };

export type LocationCorridorsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type LocationCorridorsListQuery = { __typename?: 'Query', locationCorridors: { __typename?: 'LocationCorridorConnection', edges: Array<{ __typename?: 'LocationCorridorConnectionEdge', node: { __typename?: 'LocationCorridor', id: string, name: string, entryLeg: { __typename?: 'LocationCorridorLeg', id: string, name: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } }, exitLeg: { __typename?: 'LocationCorridorLeg', id: string, name: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetLocationCorridorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationCorridorQuery = { __typename?: 'Query', locationCorridor?: { __typename?: 'LocationCorridor', id: string, name: string, entryLeg: { __typename?: 'LocationCorridorLeg', id: string }, exitLeg: { __typename?: 'LocationCorridorLeg', id: string }, links: Array<{ __typename?: 'LocationCorridorConnectedLink', linkOrder: number, downLinkLane: { __typename?: 'LocationCorridorLinkLane', id: string }, link: { __typename?: 'LocationCorridorLink', id: string, name: string, linkLanes: Array<{ __typename?: 'LocationCorridorLinkLane', id: string, geometry: any, occupancy?: number | null, departureLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } }, approachLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } } }> }, upLinkLane: { __typename?: 'LocationCorridorLinkLane', id: string } }> } | null };

export type GetMainMapLocationCorridorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMainMapLocationCorridorsQuery = { __typename?: 'Query', locationCorridors: { __typename?: 'LocationCorridorConnection', edges: Array<{ __typename?: 'LocationCorridorConnectionEdge', node: { __typename?: 'LocationCorridor', id: string, name: string, entryLeg: { __typename?: 'LocationCorridorLeg', id: string, name: string }, exitLeg: { __typename?: 'LocationCorridorLeg', id: string, name: string }, links: Array<{ __typename?: 'LocationCorridorConnectedLink', linkOrder: number, link: { __typename?: 'LocationCorridorLink', id: string, linkLanes: Array<{ __typename?: 'LocationCorridorLinkLane', id: string, geometry: any, congestionColor?: string | null, occupancy?: number | null }> } }> } }> } };

export type GetMainMapLocationCorridorsLinkQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetMainMapLocationCorridorsLinkQuery = { __typename?: 'Query', locationCorridors: { __typename?: 'LocationCorridorConnection', edges: Array<{ __typename?: 'LocationCorridorConnectionEdge', node: { __typename?: 'LocationCorridor', id: string, name: string, links: Array<{ __typename?: 'LocationCorridorConnectedLink', link: { __typename?: 'LocationCorridorLink', id: string, name: string, linkLanes: Array<{ __typename?: 'LocationCorridorLinkLane', id: string, geometry: any, occupancy?: number | null, congestionColor?: string | null, departureLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } }, approachLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } } }> } }> } }> } };

export type SaveLocationCorridorLegMutationVariables = Exact<{
  input: LocationCorridorLegInput;
}>;


export type SaveLocationCorridorLegMutation = { __typename?: 'Mutation', saveLocationCorridorLeg: { __typename?: 'LocationCorridorLeg', id: string } };

export type DeleteLocationCorridorLegMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLocationCorridorLegMutation = { __typename?: 'Mutation', deleteLocationCorridorLeg: boolean };

export type LocationCorridorsLegsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type LocationCorridorsLegsListQuery = { __typename?: 'Query', locationCorridorLegs: { __typename?: 'LocationCorridorLegConnection', edges: Array<{ __typename?: 'LocationCorridorLegConnectionEdge', node: { __typename?: 'LocationCorridorLeg', id: string, name: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetAllLocationCorridorMapLegsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllLocationCorridorMapLegsQuery = { __typename?: 'Query', locationCorridorLegs: { __typename?: 'LocationCorridorLegConnection', edges: Array<{ __typename?: 'LocationCorridorLegConnectionEdge', node: { __typename?: 'LocationCorridorLeg', id: string, name: string, approachGeometry?: any | null, departureGeometry?: any | null, location: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } } }> } };

export type LocationCorridorsLanesQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;


export type LocationCorridorsLanesQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, geometry: any, lanes: Array<{ __typename?: 'Lane', id: string, geometry: any, description?: string | null, laneDirection: LaneDirection, travelDirection?: TravelDirection | null }> } | null };

export type EditLocationCorridorsLegQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EditLocationCorridorsLegQuery = { __typename?: 'Query', locationCorridorLeg?: { __typename?: 'LocationCorridorLeg', id: string, name: string, approachGeometry?: any | null, departureGeometry?: any | null, location: { __typename?: 'Location', id: string, geometry: any, details: { __typename?: 'LocationDetails', name: string } }, lanes: Array<{ __typename?: 'Lane', id: string, geometry: any, description?: string | null, laneDirection: LaneDirection, travelDirection?: TravelDirection | null }> } | null };

export type GetLocationCorridorLegLocationNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationCorridorLegLocationNameQuery = { __typename?: 'Query', locationCorridorLeg?: { __typename?: 'LocationCorridorLeg', name: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } } | null };

export type GetLocationCorridorLegTailDataQueryVariables = Exact<{
  ids: Scalars['Object'];
}>;


export type GetLocationCorridorLegTailDataQuery = { __typename?: 'Query', locationCorridorLegs: { __typename?: 'LocationCorridorLegConnection', edges: Array<{ __typename?: 'LocationCorridorLegConnectionEdge', node: { __typename?: 'LocationCorridorLeg', id: string, name: string, location: { __typename?: 'Location', id: string } } }> } };

export type GetLocationCorridorLegTooltipQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationCorridorLegTooltipQuery = { __typename?: 'Query', locationCorridorLeg?: { __typename?: 'LocationCorridorLeg', name: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } }, lanes: Array<{ __typename?: 'Lane', description?: string | null, laneDirection: LaneDirection, travelDirection?: TravelDirection | null }> } | null };

export type DeleteLocationCorridorLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLocationCorridorLinkMutation = { __typename?: 'Mutation', deleteLocationCorridorLink: boolean };

export type SaveLocationCorridorLinkMutationVariables = Exact<{
  input: LocationCorridorLinkInput;
}>;


export type SaveLocationCorridorLinkMutation = { __typename?: 'Mutation', saveLocationCorridorLink: { __typename?: 'LocationCorridorLink', id: string } };

export type GetLocationCorridorLinkLegLocationsQueryVariables = Exact<{
  approachLegId: Scalars['ID'];
  departureLegId: Scalars['ID'];
}>;


export type GetLocationCorridorLinkLegLocationsQuery = { __typename?: 'Query', approachLeg?: { __typename?: 'LocationCorridorLeg', approachGeometry?: any | null, departureGeometry?: any | null } | null, departureLeg?: { __typename?: 'LocationCorridorLeg', approachGeometry?: any | null, departureGeometry?: any | null } | null };

export type LocationCorridorsLinksListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type LocationCorridorsLinksListQuery = { __typename?: 'Query', locationCorridorLinks: { __typename?: 'LocationCorridorLinkConnection', edges: Array<{ __typename?: 'LocationCorridorLinkConnectionEdge', node: { __typename?: 'LocationCorridorLink', id: string, name: string, linkLanes: Array<{ __typename?: 'LocationCorridorLinkLane', departureLeg: { __typename?: 'LocationCorridorLeg', location: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } }, approachLeg: { __typename?: 'LocationCorridorLeg', location: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } } }> } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetAllLocationCorridorMapLinksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllLocationCorridorMapLinksQuery = { __typename?: 'Query', locationCorridorLinks: { __typename?: 'LocationCorridorLinkConnection', edges: Array<{ __typename?: 'LocationCorridorLinkConnectionEdge', node: { __typename?: 'LocationCorridorLink', id: string, name: string, linkLanes: Array<{ __typename?: 'LocationCorridorLinkLane', id: string, speed: number, queueClearanceTime?: number | null, geometry: any, departureLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', id: string } }, approachLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', id: string } } }> } }> } };

export type EditLocationCorridorsLinkQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EditLocationCorridorsLinkQuery = { __typename?: 'Query', locationCorridorLink?: { __typename?: 'LocationCorridorLink', id: string, name: string, linkLanes: Array<{ __typename?: 'LocationCorridorLinkLane', id: string, speed: number, queueClearanceTime?: number | null, geometry: any, detectorGroupId?: string | null, departureLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } }, approachLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', details: { __typename?: 'LocationDetails', name: string } } } }> } | null };

export type GetLocationCorridorLinksTailDataQueryVariables = Exact<{
  ids: Scalars['Object'];
}>;


export type GetLocationCorridorLinksTailDataQuery = { __typename?: 'Query', locationCorridorLinks: { __typename?: 'LocationCorridorLinkConnection', edges: Array<{ __typename?: 'LocationCorridorLinkConnectionEdge', node: { __typename?: 'LocationCorridorLink', id: string, name: string, linkLanes: Array<{ __typename?: 'LocationCorridorLinkLane', departureLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } }, approachLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } } }> } }> } };

export type GetLocationCorridorLinkDisplayQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationCorridorLinkDisplayQuery = { __typename?: 'Query', locationCorridorLink?: { __typename?: 'LocationCorridorLink', id: string, name: string, linkLanes: Array<{ __typename?: 'LocationCorridorLinkLane', departureLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } }, approachLeg: { __typename?: 'LocationCorridorLeg', id: string, location: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } } }> } | null };

export type GetIntegrationIntersectionQueryVariables = Exact<{
  integrationId: Scalars['Object'];
}>;


export type GetIntegrationIntersectionQuery = { __typename?: 'Query', intersections: { __typename?: 'IntersectionConnection', edges: Array<{ __typename?: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, details: { __typename?: 'IntersectionDetails', name: string } } }> } };

export type IntersectionsLayerLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionsLayerLocationsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, locationType: string, geometry: any, details: { __typename?: 'LocationDetails', name: string }, signalIntersection?: { __typename?: 'Intersection', id: string } | null } }> } };

export type LocationNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationNameQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } | null };

export type SaveIntersectionMutationVariables = Exact<{
  input: IntersectionInput;
}>;


export type SaveIntersectionMutation = { __typename?: 'Mutation', saveIntersection: (
    { __typename?: 'Intersection' }
    & IntersectionDetailFragment
  ) };

export type CreateMibSubscriptionMutationVariables = Exact<{
  id: Scalars['String'];
  mibs: Array<MibWithIndexes> | MibWithIndexes;
  subscriptionId: Scalars['String'];
}>;


export type CreateMibSubscriptionMutation = { __typename?: 'Mutation', subscribeMibs: { __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null } };

export type DeleteIntersectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIntersectionMutation = { __typename?: 'Mutation', deleteIntersection: boolean };

export type BackupDeviceDatabaseMutationVariables = Exact<{
  deviceId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  makeApproved?: InputMaybe<Scalars['Boolean']>;
}>;


export type BackupDeviceDatabaseMutation = { __typename?: 'Mutation', backupDeviceDatabase: { __typename?: 'DeviceDatabase', id: string } };

export type DownloadDeviceDatabaseMutationVariables = Exact<{
  intersectionId: Scalars['String'];
  databaseId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type DownloadDeviceDatabaseMutation = { __typename?: 'Mutation', downloadDeviceDatabase: { __typename?: 'DeviceDatabase', id: string } };

export type CreateDraftDatabaseMutationVariables = Exact<{
  intersectionId: Scalars['String'];
  databaseId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type CreateDraftDatabaseMutation = { __typename?: 'Mutation', createDraftDatabase: { __typename?: 'DeviceDatabase', id: string } };

export type ApproveDatabaseMutationVariables = Exact<{
  intersectionId: Scalars['String'];
  databaseId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type ApproveDatabaseMutation = { __typename?: 'Mutation', approveDatabase: { __typename?: 'DeviceDatabase', id: string } };

export type SetSignalMibsMutationVariables = Exact<{
  deviceId: Scalars['String'];
  mibs: Array<MibValue> | MibValue;
  comment?: InputMaybe<Scalars['String']>;
}>;


export type SetSignalMibsMutation = { __typename?: 'Mutation', setSignalMibs: boolean };

export type SetDatabaseMibsMutationVariables = Exact<{
  intersectionId: Scalars['String'];
  databaseId: Scalars['String'];
  mibs: Array<DatabaseMibValue> | DatabaseMibValue;
  comment?: InputMaybe<Scalars['String']>;
}>;


export type SetDatabaseMibsMutation = { __typename?: 'Mutation', setDatabaseMibs: { __typename?: 'DeviceDatabase', id: string } };

export type AddIntersectionCommentMutationVariables = Exact<{
  intersectionId: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type AddIntersectionCommentMutation = { __typename?: 'Mutation', addIntersectionComment: { __typename?: 'IntersectionComment', id: string, comment: string } };

export type DeleteIntersectionCommentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIntersectionCommentMutation = { __typename?: 'Mutation', deleteIntersectionComment: boolean };

export type DeleteAllIntersectionCommentsMutationVariables = Exact<{
  intersectionId: Scalars['ID'];
}>;


export type DeleteAllIntersectionCommentsMutation = { __typename?: 'Mutation', deleteAllIntersectionComments: boolean };

export type SetTimeNowMutationVariables = Exact<{
  deviceId: Scalars['ID'];
}>;


export type SetTimeNowMutation = { __typename?: 'Mutation', setTimeNow: boolean };

export type SaveSignalsTaskMutationMutationVariables = Exact<{
  input: TaskInput;
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type SaveSignalsTaskMutationMutation = { __typename?: 'Mutation', saveSignalScheduledTask?: (
    { __typename?: 'Task' }
    & SignalsTaskFragmentFragment
  ) | null };

export type DeleteSignalScheduledTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
  centerId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteSignalScheduledTaskMutation = { __typename?: 'Mutation', deleteSignalScheduledTask: boolean };

export type DeleteIntersectionTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIntersectionTemplateMutation = { __typename?: 'Mutation', deleteIntersectionTemplate?: boolean | null };

export type SaveIntersectionTemplateMutationVariables = Exact<{
  input: IntersectionTemplateInput;
}>;


export type SaveIntersectionTemplateMutation = { __typename?: 'Mutation', saveIntersectionTemplate: { __typename?: 'IntersectionTemplate', id: string } };

export type SaveSignalActionSetMutationVariables = Exact<{
  input: SignalActionSetInput;
}>;


export type SaveSignalActionSetMutation = { __typename?: 'Mutation', saveSignalActionSet: { __typename?: 'SignalActionSet', id: string } };

export type DeleteSignalActionSetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSignalActionSetMutation = { __typename?: 'Mutation', deleteSignalActionSet: boolean };

export type DeviceEventExportMutationVariables = Exact<{
  intersectionId: Scalars['String'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  rule?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type DeviceEventExportMutation = { __typename?: 'Mutation', deviceEventExport: boolean };

export type DeleteDeviceDatabaseMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
}>;


export type DeleteDeviceDatabaseMutation = { __typename?: 'Mutation', deleteDeviceDatabase: { __typename?: 'DeviceDatabase', id: string } };

export type FinalizeDraftDeviceDatabaseMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
}>;


export type FinalizeDraftDeviceDatabaseMutation = { __typename?: 'Mutation', finalizeDraftDeviceDatabase: { __typename?: 'DeviceDatabase', id: string, type: DeviceDatabaseType, status?: DeviceDatabaseStatus | null } };

export type CloneDatabaseMutationVariables = Exact<{
  databaseId: Scalars['String'];
  fromIntersectionId: Scalars['String'];
  toIntersectionId: Scalars['String'];
}>;


export type CloneDatabaseMutation = { __typename?: 'Mutation', copyDeviceDatabaseDraft: { __typename: 'DeviceDatabase', id: string, type: DeviceDatabaseType, status?: DeviceDatabaseStatus | null } };

export type UpdateDeviceDatabasesArchiveFlagMutationVariables = Exact<{
  databaseIds: Array<Scalars['String']> | Scalars['String'];
  intersectionId: Scalars['String'];
  archive: Scalars['Boolean'];
}>;


export type UpdateDeviceDatabasesArchiveFlagMutation = { __typename?: 'Mutation', updateDeviceDatabasesArchiveFlag: boolean };

export type SignalControllersQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SignalControllersQuery = { __typename?: 'Query', signalControllers: { __typename?: 'SignalControllerConnection', edges: Array<{ __typename?: 'SignalControllerConnectionEdge', node: { __typename?: 'SignalController', id: string, name: string, description?: string | null, connectionParameters?: string | null, location?: any | null } }> } };

export type SignalControllerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignalControllerQuery = { __typename?: 'Query', signalController?: { __typename?: 'SignalController', id: string, name: string, description?: string | null, connectionParameters?: string | null, location?: any | null } | null };

export type SignalControllerListQueryVariables = Exact<{ [key: string]: never; }>;


export type SignalControllerListQuery = { __typename?: 'Query', signalControllers: { __typename?: 'SignalControllerConnection', edges: Array<{ __typename?: 'SignalControllerConnectionEdge', node: { __typename?: 'SignalController', id: string, name: string, location?: any | null } }> } };

export type IntersectionLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionLocationQuery = { __typename?: 'Query', intersectionLocation: Array<any> };

export type IntersectionSimpleStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionSimpleStatusQuery = { __typename?: 'Query', intersectionSimpleStatus: Array<any> };

export type IntersectionSimpleStatusByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionSimpleStatusByIdQuery = { __typename?: 'Query', intersectionSimpleStatusById?: { __typename?: 'IntersectionSimpleStatus', mainlineColor: SignalOutputColor, communicationState: CommunicationState, mainActionColor?: SignalOutputColor | null, mainCommandSourceColor?: SignalOutputColor | null, mainImplementAction?: RmcImplementAction | null, mainImplementCommandSource?: RmcImplementCommandSource | null, mainImplementPlan: number, mainImplementRate: number, mainStatus?: RmcImplementAction | null, maneuverColor: Array<{ __typename?: 'ManeuverColor', id: string, color?: SignalOutputColor | null }> } | null };

export type IntersectionPhaseSummaryCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionPhaseSummaryCountsQuery = { __typename?: 'Query', intersectionPhaseSummaryCounts: { __typename?: 'IntersectionPhaseSummaryCounts', green: number, yellow: number, red: number, commDisabled: number, commFailed: number, unknown: number } };

export type SignalsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SignalsSummaryQuery = { __typename?: 'Query', coord: { __typename?: 'SignConnection', totalCount: number }, free: { __typename?: 'SignConnection', totalCount: number }, transition: { __typename?: 'SignConnection', totalCount: number }, preempt: { __typename?: 'SignConnection', totalCount: number }, badPlan: { __typename?: 'SignConnection', totalCount: number }, cabinetFlash: { __typename?: 'SignConnection', totalCount: number }, controllerFlash: { __typename?: 'SignConnection', totalCount: number }, commFailed: { __typename?: 'SignConnection', totalCount: number }, commDisabled: { __typename?: 'SignConnection', totalCount: number }, unknown: { __typename?: 'SignConnection', totalCount: number } };

export type MibSubscriptionSubscriptionVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type MibSubscriptionSubscription = { __typename?: 'Subscription', jobResults?: { __typename?: 'JobResult', body?: any | null } | null };

export type MainlineColorSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MainlineColorSubscriptionSubscription = { __typename?: 'Subscription', intersectionSimpleStatusUpdated: Array<{ __typename?: 'IntersectionSimpleStatus', intersectionId: string, mainlineColor: SignalOutputColor, communicationState: CommunicationState }> };

export type CommunicationStatusColorSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CommunicationStatusColorSubscriptionSubscription = { __typename?: 'Subscription', intersectionSimpleStatusUpdated: Array<{ __typename?: 'IntersectionSimpleStatus', intersectionId: string, communicationState: CommunicationState }> };

export type PreemptLayerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PreemptLayerStatusSubscription = { __typename?: 'Subscription', intersectionDetailStatusUpdated: Array<{ __typename?: 'IntersectionDetailStatus', intersectionId: string, category: IntersectionStatusCategory, preemptStatus: Array<{ __typename?: 'PreemptStatus', active: boolean, enabled: boolean, number: number }>, prioritorStatus: Array<{ __typename?: 'PrioritorStatus', active: boolean, enabled: boolean, number: number }> } | null> };

export type TimeSyncStatusSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TimeSyncStatusSubscriptionSubscription = { __typename?: 'Subscription', intersectionDetailStatusUpdated: Array<{ __typename?: 'IntersectionDetailStatus', intersectionId: string, category: IntersectionStatusCategory, time: { __typename?: 'IntersectionDeviceTime', drift?: number | null } } | null> };

export type CoordinationStatusDetailSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CoordinationStatusDetailSubscriptionSubscription = { __typename?: 'Subscription', intersectionDetailStatusUpdated: Array<{ __typename?: 'IntersectionDetailStatus', intersectionId: string, category: IntersectionStatusCategory } | null> };

export type CoordinationStatusPatternSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CoordinationStatusPatternSubscriptionSubscription = { __typename?: 'Subscription', intersectionPatternStatusUpdated: Array<{ __typename?: 'IntersectionPatternStatus', intersectionId: string, coordStatus: CoordStatus, patternNumber: number, patternType: PatternType }> };

export type AlarmDetailStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AlarmDetailStatusSubscription = { __typename?: 'Subscription', intersectionDetailStatusUpdated: Array<{ __typename?: 'IntersectionDetailStatus', intersectionId: string, category: IntersectionStatusCategory } | null> };

export type SimpleSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SimpleSubscriptionSubscription = { __typename?: 'Subscription', intersectionSimpleStatusUpdated: Array<{ __typename?: 'IntersectionSimpleStatus', mainlineColor: SignalOutputColor, communicationState: CommunicationState, mainActionColor?: SignalOutputColor | null, mainCommandSourceColor?: SignalOutputColor | null, mainImplementAction?: RmcImplementAction | null, mainImplementCommandSource?: RmcImplementCommandSource | null, mainImplementPlan: number, mainImplementRate: number, mainStatus?: RmcImplementAction | null, maneuverColor: Array<{ __typename?: 'ManeuverColor', id: string, color?: SignalOutputColor | null }> }> };

export type IntersectionDetailStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionDetailStatusQuery = { __typename?: 'Query', intersectionDetailStatusById?: (
    { __typename?: 'IntersectionDetailStatus' }
    & IntersectionDetailStatusFragment
  ) | null };

export type IntersectionPatternStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionPatternStatusQuery = { __typename?: 'Query', intersectionPatternStatus: Array<any> };

export type IntersectionDetailAndPatternStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionDetailAndPatternStatusQuery = { __typename?: 'Query', intersectionDetailStatus: Array<any>, intersectionPatternStatus: Array<any> };

export type DetailStatusSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DetailStatusSubscriptionSubscription = { __typename?: 'Subscription', intersectionDetailStatusUpdated: Array<(
    { __typename?: 'IntersectionDetailStatus' }
    & IntersectionDetailStatusFragment
  ) | null> };

export type IntersectionDetailStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionDetailStatusesQuery = { __typename?: 'Query', intersectionDetailStatus: Array<any> };

export type DetailStatusesSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DetailStatusesSubscriptionSubscription = { __typename?: 'Subscription', intersectionDetailStatusUpdated: Array<(
    { __typename?: 'IntersectionDetailStatus', intersectionId: string }
    & IntersectionDetailStatusFragment
  ) | null> };

export type IntersectionIdsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type IntersectionIdsQuery = { __typename?: 'Query', intersectionIds: Array<string> };

export type IntersectionStatusCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type IntersectionStatusCategoriesQuery = { __typename?: 'Query', intersectionStatusCategories: (
    { __typename?: 'IntersectionStatusCategories' }
    & IntersectionStatusCategoriesFragmentFragment
  ) };

export type IntersectionStatusCategoriesSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IntersectionStatusCategoriesSubscriptionSubscription = { __typename?: 'Subscription', intersectionStatusCategoriesUpdated: (
    { __typename?: 'IntersectionStatusCategories' }
    & IntersectionStatusCategoriesFragmentFragment
  ) };

export type IntersectionPhaseStatusByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionPhaseStatusByIdQuery = { __typename?: 'Query', intersectionPhaseStatusById?: { __typename?: 'IntersectionPhaseStatus', phaseStatus: Array<{ __typename?: 'PhaseStatus', number: number, color?: SignalOutputColor | null, actualSplit: number, programmedSplit: number, lastTerm?: PhaseTerminationReason | null, timeStampSecondForActualSplit?: number | null }> } | null };

export type IntersectionPhaseStatusSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionPhaseStatusSubscription = { __typename?: 'Subscription', intersectionPhaseStatusUpdated: Array<{ __typename?: 'IntersectionPhaseStatus', phaseStatus: Array<{ __typename?: 'PhaseStatus', number: number, color?: SignalOutputColor | null, actualSplit: number, programmedSplit: number, lastTerm?: PhaseTerminationReason | null, timeStampSecondForActualSplit?: number | null }> }> };

export type IntersectionPatternStatusByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionPatternStatusByIdQuery = { __typename?: 'Query', intersectionPatternStatusById?: (
    { __typename?: 'IntersectionPatternStatus' }
    & PatternStatusFragmentFragment
  ) | null };

export type IntersectionPatternStatusUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionPatternStatusUpdatedSubscription = { __typename?: 'Subscription', intersectionPatternStatusUpdated: Array<(
    { __typename?: 'IntersectionPatternStatus' }
    & PatternStatusFragmentFragment
  )> };

export type PatternStatusesSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PatternStatusesSubscriptionSubscription = { __typename?: 'Subscription', intersectionPatternStatusUpdated: Array<(
    { __typename?: 'IntersectionPatternStatus', intersectionId: string }
    & PatternStatusFragmentFragment
  )> };

export type PatternStatuseMultipleIdsSubscriptionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PatternStatuseMultipleIdsSubscriptionSubscription = { __typename?: 'Subscription', intersectionPatternStatusUpdated: Array<(
    { __typename?: 'IntersectionPatternStatus', intersectionId: string }
    & PatternStatusFragmentFragment
  )> };

export type DetailStatusMultipleIdsSubscriptionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DetailStatusMultipleIdsSubscriptionSubscription = { __typename?: 'Subscription', intersectionDetailStatusUpdated: Array<(
    { __typename?: 'IntersectionDetailStatus', intersectionId: string }
    & IntersectionDetailStatusFragment
  ) | null> };

export type IntegrationConfigSettingsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntegrationConfigSettingsQuery = { __typename?: 'Query', integration?: { __typename?: 'Integration', config: { __typename?: 'IntegrationConfig', settings?: any | null } } | null };

export type IntersectionCommentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionCommentsQuery = { __typename?: 'Query', intersectionComments: Array<{ __typename?: 'IntersectionComment', id: string, comment: string, intersectionId: string, timestamp: any, user: { __typename?: 'OrganizationKineticUser', username: string } }> };

export type IntersectionCommentsUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type IntersectionCommentsUpdatedSubscription = { __typename?: 'Subscription', intersectionCommentsUpdated?: Array<{ __typename?: 'IntersectionComment', id: string, comment: string, intersectionId: string, timestamp: any }> | null };

export type IntersectionIconStatusUpdateSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type IntersectionIconStatusUpdateSubscription = { __typename?: 'Subscription', intersectionIconStatusUpdate: Array<{ __typename?: 'IntersectionIconStatus', intersectionId: string, icons?: Array<{ __typename?: 'IntersectionIcon', name?: string | null, type: IntersectionIconType, bearing: number, config: any, location: any, state?: any | null }> | null }> };

export type IntersectionIconStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntersectionIconStatusQuery = { __typename?: 'Query', intersectionIconStatus: { __typename?: 'IntersectionIconStatus', intersectionId: string, icons?: Array<{ __typename?: 'IntersectionIcon', name?: string | null, type: IntersectionIconType, config: any, location: any, state?: any | null, bearing: number }> | null } };

export type GetSignalTasksByIntersectionQueryVariables = Exact<{
  intersectionId: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
}>;


export type GetSignalTasksByIntersectionQuery = { __typename?: 'Query', signalScheduledTasksByIntersection?: Array<(
    { __typename?: 'TaskOccurrence' }
    & TaskOccurrenceFragmentFragment
  )> | null };

export type GetAllSignalTasksQueryVariables = Exact<{
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
}>;


export type GetAllSignalTasksQuery = { __typename?: 'Query', signalScheduledTasks?: Array<(
    { __typename?: 'TaskOccurrence' }
    & TaskOccurrenceFragmentFragment
  )> | null };

export type GetSignalTaskByIdQueryQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type GetSignalTaskByIdQueryQuery = { __typename?: 'Query', signalScheduledTask?: (
    { __typename?: 'Task' }
    & TaskFragmentFragment
  ) | null };

export type SignalsTaskUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
}>;


export type SignalsTaskUpdatedSubscription = { __typename?: 'Subscription', taskUpdated: (
    { __typename?: 'Task' }
    & SignalsTaskFragmentFragment
  ) };

export type SignalCommandDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SignalCommandDefinitionsQuery = { __typename?: 'Query', signalCommandDefinitions?: Array<{ __typename?: 'SignalCommandDefinition', commandType: string, supportedProtocols?: Array<string> | null, commandValues?: Array<{ __typename?: 'SignalCommandValueDefinition', name: string, minValue?: number | null, maxValue?: number | null, defaultValue?: number | null, unsetValue?: number | null }> | null }> | null };

export type GetDeviceEventsQueryVariables = Exact<{
  intersectionId: Scalars['String'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  rule?: InputMaybe<Scalars['String']>;
}>;


export type GetDeviceEventsQuery = { __typename?: 'Query', deviceEvents: { __typename?: 'DeviceEventConnection', totalCount: number, edges: Array<{ __typename: 'DeviceEventConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'DeviceEvent' }
        & DeviceEventFragmentFragment
      ) }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TrafficEventDefinitionsQueryVariables = Exact<{
  intersectionId: Scalars['String'];
}>;


export type TrafficEventDefinitionsQuery = { __typename?: 'Query', trafficEventDefinitions: Array<{ __typename?: 'TrafficEventDefinition', vendorEventName: string, vendorEventCode: number, parameterDescription?: string | null, eventDescription?: string | null, eventDefinitionType: TrafficEventDefinitionType, universalEventCode?: number | null, universalEventName?: string | null, eventCategoryId: number, eventCategoryName?: string | null }> };

export type TrafficEventCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type TrafficEventCategoryQuery = { __typename?: 'Query', trafficEventCategory: Array<{ __typename?: 'TrafficEventCategory', categoryId: number, categoryName: string, universalEventCodeRange: string }> };

export type SignalAppliedCommandsQueryVariables = Exact<{
  timezone: Scalars['String'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type SignalAppliedCommandsQuery = { __typename?: 'Query', signalAppliedCommands: { __typename?: 'SignalAppliedCommandConnection', totalCount: number, edges: Array<{ __typename: 'SignalAppliedCommandConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'SignalAppliedCommand' }
        & AppliedCommandFragmentFragment
      ) }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type AppliedCommandFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppliedCommandFilterOptionsQuery = { __typename?: 'Query', signalAppliedCommandFilterOptions: { __typename?: 'SignalAppliedCommandFilterOptions', commands: Array<string>, sources: Array<string>, intersections: Array<{ __typename?: 'BasicIntersectionDevice', id: string, name: string }>, devices: Array<{ __typename?: 'BasicIntersectionDevice', id: string, name: string }>, inheritedGroups: Array<{ __typename?: 'BasicIntersectionDevice', id: string, name: string }> } };

export type AppliedCommandsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AppliedCommandsSubscriptionSubscription = { __typename?: 'Subscription', signalAppliedCommandUpdated?: Array<{ __typename?: 'SignalAppliedCommandStreamObject', streamObjectOperation: StreamObjectOperation, dto: { __typename?: 'SignalAppliedCommand', id: string, command: string, value: string, taskId: string, startDateTime: any, endDateTime: any, status: string, source?: string | null, intersection: { __typename?: 'BasicIntersectionDevice', id: string, name: string, type: IntersectionType }, device: { __typename?: 'BasicIntersectionDevice', id: string, name: string, type: IntersectionType }, inheritedGroup?: { __typename?: 'BasicIntersectionDevice', id: string, name: string, type: IntersectionType } | null } }> | null };

export type NearbyIntersectionsByPointQueryVariables = Exact<{
  x: Scalars['Float'];
  y: Scalars['Float'];
  thresholdMiles?: InputMaybe<Scalars['Float']>;
}>;


export type NearbyIntersectionsByPointQuery = { __typename?: 'Query', nearbyIntersectionsByPoint: Array<{ __typename?: 'Intersection', id: string }> };

export type AtspmReportQueryVariables = Exact<{
  intersectionId: Scalars['String'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  reportType: AtspmSignalReport;
  params?: InputMaybe<Scalars['Object']>;
}>;


export type AtspmReportQuery = { __typename?: 'Query', atspmReport: { __typename?: 'Report', reportType: string, reportTabs: Array<(
      { __typename?: 'ReportTab' }
      & ReportTabsFragmentFragment
    ) | null> } };

export type SignalActionSetsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SignalActionSetsListQuery = { __typename?: 'Query', signalActionSets: { __typename?: 'SignalActionSetConnection', totalCount: number, edges: Array<{ __typename?: 'SignalActionSetConnectionEdge', node: { __typename?: 'SignalActionSet', id: string, name: string, number: number, impact?: SignalActionSetImpactType | null, notes?: string | null, priority: number, commands: Array<any>, centerId?: string | null } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type IntegrationsForExternalLinksQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type IntegrationsForExternalLinksQuery = { __typename?: 'Query', integrations: { __typename?: 'IntegrationConnection', edges: Array<{ __typename?: 'IntegrationConnectionEdge', node: { __typename?: 'Integration', id: string, config: { __typename?: 'IntegrationConfig', integrationType: IntegrationType, settings?: any | null } } }> } };

export type AppliedCommandLayerStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type AppliedCommandLayerStatusQuery = { __typename?: 'Query', intersectionDetailStatus: Array<any>, signalAppliedCommands: { __typename?: 'SignalAppliedCommandConnection', edges: Array<{ __typename?: 'SignalAppliedCommandConnectionEdge', node: { __typename?: 'SignalAppliedCommand', id: string, source?: string | null, intersection: { __typename?: 'BasicIntersectionDevice', id: string } } }> } };

export type AlarmStatusLayerQueryVariables = Exact<{ [key: string]: never; }>;


export type AlarmStatusLayerQuery = { __typename?: 'Query', intersectionDetailStatus: Array<any>, alarms: { __typename?: 'AlarmConnection', edges: Array<{ __typename?: 'AlarmConnectionEdge', node: { __typename?: 'Alarm', entityId: string, id: string } }> } };

export type MainLineGreenLayerQueryVariables = Exact<{ [key: string]: never; }>;


export type MainLineGreenLayerQuery = { __typename?: 'Query', intersectionDetailStatus: Array<any>, intersectionSimpleStatus: Array<any> };

export type SignalActionSetCommandOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SignalActionSetCommandOptionsQuery = { __typename?: 'Query', signalActionSets: { __typename?: 'SignalActionSetConnection', edges: Array<{ __typename?: 'SignalActionSetConnectionEdge', node: { __typename?: 'SignalActionSet', id: string, name: string, commands: Array<any> } }> } };

export type SignalActionSetOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SignalActionSetOptionsQuery = { __typename?: 'Query', signalActionSetOptions: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null> };

export type IntersectionLocationsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type IntersectionLocationsQuery = { __typename?: 'Query', intersections: { __typename?: 'IntersectionConnection', edges: Array<{ __typename: 'IntersectionConnectionEdge', node: { __typename?: 'Intersection', id: string, location: any, details: { __typename?: 'IntersectionDetails', name: string, mainStreet?: string | null, sideStreet?: string | null, note?: string | null, labels: Array<string> } } }> } };

export type GetDeviceViewsProtocolsFromEntitiesQueryVariables = Exact<{
  entityIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetDeviceViewsProtocolsFromEntitiesQuery = { __typename?: 'Query', getDeviceViewsProtocolsFromEntities: Array<DeviceViewsProtocolEntityEnum> };

export type GetIntersectionCountFromEntitiesQueryVariables = Exact<{
  entityIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetIntersectionCountFromEntitiesQuery = { __typename?: 'Query', getIntersectionCountFromEntities: number };

export type ExportSplitMonitorReportMutationVariables = Exact<{
  intersectionId: Scalars['String'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  fileName: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
  reportType: QFreeSplitMonitorReportType;
}>;


export type ExportSplitMonitorReportMutation = { __typename?: 'Mutation', splitMonitorExport: boolean };

export type SignalTasksQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SignalTasksQuery = { __typename?: 'Query', signalTasks: { __typename?: 'SignalTaskConnection', totalCount: number, edges: Array<{ __typename?: 'SignalTaskEdge', node: { __typename?: 'SignalTask', id: string, intersectionId?: string | null, name?: string | null, description?: string | null, progress: number, status?: SignalTaskStatus | null, associatedId?: string | null, error?: string | null, updated?: any | null } }> } };

export type SignalTaskUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  intersectionIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type SignalTaskUpdatedSubscription = { __typename?: 'Subscription', signalTaskUpdated: { __typename?: 'SignalTask', id: string, intersectionId?: string | null, name?: string | null, description?: string | null, progress: number, status?: SignalTaskStatus | null, associatedId?: string | null, error?: string | null, updated?: any | null } };

export type ModuleMapSettingValueQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type ModuleMapSettingValueQuery = { __typename?: 'Query', moduleMapSettingValue?: any | null };

export type SaveSignalModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveSignalModuleSettingsMutation = { __typename?: 'Mutation', saveSignalModuleSettings?: boolean | null };

export type SignalModuleSettingsQueryVariables = Exact<{
  formViewName: Scalars['String'];
}>;


export type SignalModuleSettingsQuery = { __typename?: 'Query', signalModuleSettings: { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, views: Array<{ __typename?: 'DetectorReportConfigFormView', id: string, name: string, views: Array<(
        { __typename?: 'DetectorReportConfigFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          )> }
          & FormViewFragment_DetectorReportConfigFormView_Fragment
        )> }
        & FormViewFragment_DetectorReportConfigFormView_Fragment
      )> } | { __typename?: 'IntegrationConfigFormView', id: string, name: string, views: Array<(
        { __typename?: 'IntegrationConfigFormView', views: Array<(
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          )> }
          & FormViewFragment_IntegrationConfigFormView_Fragment
        )> }
        & FormViewFragment_IntegrationConfigFormView_Fragment
      )> } | { __typename?: 'IntegrationStateView', id: string, name: string, views: Array<(
        { __typename?: 'IntegrationStateView', views: Array<(
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          )> }
          & FormViewFragment_IntegrationStateView_Fragment
        )> }
        & FormViewFragment_IntegrationStateView_Fragment
      )> } | { __typename?: 'ModuleSettingsFormView', id: string, name: string, views: Array<(
        { __typename?: 'DetectorReportConfigFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          )> }
          & FormViewFragment_DetectorReportConfigFormView_Fragment
        )> }
        & FormViewFragment_DetectorReportConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationConfigFormView', views: Array<(
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          )> }
          & FormViewFragment_IntegrationConfigFormView_Fragment
        )> }
        & FormViewFragment_IntegrationConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationStateView', views: Array<(
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          )> }
          & FormViewFragment_IntegrationStateView_Fragment
        )> }
        & FormViewFragment_IntegrationStateView_Fragment
      ) | (
        { __typename?: 'ModuleSettingsFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          )> }
          & FormViewFragment_DetectorReportConfigFormView_Fragment
        ) | (
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          )> }
          & FormViewFragment_IntegrationConfigFormView_Fragment
        ) | (
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          )> }
          & FormViewFragment_IntegrationStateView_Fragment
        ) | (
          { __typename?: 'ModuleSettingsFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          ) | (
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          ) | (
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          ) | (
            { __typename?: 'ModuleSettingsFormView' }
            & FormViewFragment_ModuleSettingsFormView_Fragment
          )> }
          & FormViewFragment_ModuleSettingsFormView_Fragment
        )> }
        & FormViewFragment_ModuleSettingsFormView_Fragment
      )> }>, sections: Array<(
      { __typename?: 'ModuleFormSection' }
      & ModuleFormSectionFragmentFragment
    )> } };

export type GenerateDeviceDatabaseReportExportsMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
  tableNames: Array<Scalars['String']> | Scalars['String'];
  exportReportTypes: Array<ExportReportType> | ExportReportType;
  excludeDefaults?: InputMaybe<Scalars['Boolean']>;
  excludeZeros?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenerateDeviceDatabaseReportExportsMutation = { __typename?: 'Mutation', generateDeviceDatabaseReportExports: boolean };

export type GenerateMultiDatabaseReportExportsMutationVariables = Exact<{
  entityIds: Array<Scalars['String']> | Scalars['String'];
  exportReportTypes: Array<ExportReportType> | ExportReportType;
  reportProtocolInputs: Array<DatabaseReportProtocolInput> | DatabaseReportProtocolInput;
}>;


export type GenerateMultiDatabaseReportExportsMutation = { __typename?: 'Mutation', generateMultiDatabaseReportExports: boolean };

export type ExportSingleDatabaseBinMutationVariables = Exact<{
  databaseId: Scalars['String'];
  intersectionId: Scalars['String'];
}>;


export type ExportSingleDatabaseBinMutation = { __typename?: 'Mutation', exportSingleDatabaseBin: boolean };

export type ExportMultipleDatabaseBinsMutationVariables = Exact<{
  entityIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ExportMultipleDatabaseBinsMutation = { __typename?: 'Mutation', exportMultipleDatabaseBins: boolean };

export type SignalCommunicationReportQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
}>;


export type SignalCommunicationReportQuery = { __typename?: 'Query', signalCommunicationReport: { __typename?: 'SignalCommunicationReportRowConnection', totalCount: number, edges: Array<{ __typename?: 'CommunicationReportRowEdge', node: { __typename?: 'CommunicationReportRow', integrationType: IntegrationType, deviceId: string, deviceName?: string | null, intersectionId: string, intersectionName: string, group?: string | null, communicationParameters?: string | null, communicationState: CommunicationState, latency: number, downTime: number, requestCount: number, failureCount: number } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetIntersectionDeviceProtocolQueryVariables = Exact<{
  intersectionId: Scalars['ID'];
}>;


export type GetIntersectionDeviceProtocolQuery = { __typename?: 'Query', intersection?: { __typename?: 'Intersection', id: string, devices: Array<{ __typename?: 'IntersectionDevice', id: string, fieldEntityProtocol?: string | null }> } | null };

export type SaveTimeDriftSettingsMutationVariables = Exact<{
  input: TimeDriftSettingsInput;
}>;


export type SaveTimeDriftSettingsMutation = { __typename?: 'Mutation', saveTimeDriftSettings: { __typename?: 'TimeDriftSettings', autoCorrect: boolean, correctionThreshold: number, alarmThreshold: number, exceptions: Array<{ __typename?: 'TimeDriftException', start: any, end: any }> } };

export type TimeDriftSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeDriftSettingsQuery = { __typename?: 'Query', timeDriftSettings: { __typename?: 'TimeDriftSettings', autoCorrect: boolean, correctionThreshold: number, alarmThreshold: number, exceptions: Array<{ __typename?: 'TimeDriftException', start: any, end: any }> } };

export type PhaseServiceTimesFragmentFragment = { __typename?: 'PhaseServiceTimes', green: number, yellow: number, red: number };

export type DirectionalProgrammedSplitsFragmentFragment = { __typename?: 'DirectionalProgrammedSplits', up?: (
    { __typename?: 'PhaseServiceTimes' }
    & PhaseServiceTimesFragmentFragment
  ) | null, down?: (
    { __typename?: 'PhaseServiceTimes' }
    & PhaseServiceTimesFragmentFragment
  ) | null };

export type TimeSpaceOffsetDataFragmentFragment = { __typename?: 'TimeSpaceOffsetData', value: number, timestamp: number };

export type TimeSpacePhaseFragmentFragment = { __typename?: 'TimeSpacePhase', number?: number | null, historicData: Array<(
    { __typename?: 'PhaseServiceTimes' }
    & PhaseServiceTimesFragmentFragment
  )> };

export type TimeSpacePatternFragmentFragment = { __typename?: 'TimeSpacePattern', number: number, cycleLength: number, from: number, to: number, offset: (
    { __typename?: 'TimeSpaceOffsetData' }
    & TimeSpaceOffsetDataFragmentFragment
  ), programmedSplits?: (
    { __typename?: 'DirectionalProgrammedSplits' }
    & DirectionalProgrammedSplitsFragmentFragment
  ) | null };

export type TravelDirectionDataFragmentFragment = { __typename?: 'TravelDirectionData', speed: number, distance: number };

export type GetTimeSpaceDataQueryVariables = Exact<{
  corridorId: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type GetTimeSpaceDataQuery = { __typename?: 'Query', timeSpaceData: Array<{ __typename?: 'TimeSpaceNodeData', id: string, name: string, deviceId: string, upPhase?: (
      { __typename?: 'TimeSpacePhase' }
      & TimeSpacePhaseFragmentFragment
    ) | null, downPhase?: (
      { __typename?: 'TimeSpacePhase' }
      & TimeSpacePhaseFragmentFragment
    ) | null, pattern: Array<(
      { __typename?: 'TimeSpacePattern' }
      & TimeSpacePatternFragmentFragment
    )>, travelUp?: (
      { __typename?: 'TravelDirectionData' }
      & TravelDirectionDataFragmentFragment
    ) | null, travelDown?: (
      { __typename?: 'TravelDirectionData' }
      & TravelDirectionDataFragmentFragment
    ) | null } | null> };

export type TrafficResponsiveControlLogListQueryVariables = Exact<{
  trafficResponsivePlanId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type TrafficResponsiveControlLogListQuery = { __typename?: 'Query', trafficResponsiveActionControlLogs: { __typename?: 'TrafficResponsiveActionLogConnection', totalCount: number, edges: Array<{ __typename?: 'TrafficResponsiveActionLogConnectionEdge', node: { __typename?: 'TrafficResponsiveActionLog', id: string, timestamp: any, actionName: string, commandDescription: string, referenceValue: number, selected: boolean, devices: Array<{ __typename?: 'TrafficResponsiveActionDeviceLog', id: string, firstCommandSent: any, intersection: { __typename?: 'BasicIntersection', id: string, name: string, devices: Array<{ __typename?: 'BasicIntersectionDevice', id: string, name: string }> } }> } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TrafficResponsivePlanActionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TrafficResponsivePlanActionsQuery = { __typename?: 'Query', trafficResponsivePlanSummary: { __typename?: 'TrafficResponsivePlanSummary', id: string, actions: Array<{ __typename?: 'TrafficResponsivePlanActionSummary', id: string, name: string }> } };

export type TrafficResponsivePlanDetectorGroupFragmentFragment = { __typename?: 'TrafficResponsivePlanDetectorGroup', detectorGroupId: string, kValue: number, volume: number, occupancy: number };

export type TrafficResponsivePlanActionFragmentFragment = { __typename?: 'TrafficResponsivePlanAction', id: string, name: string, command: any, minimumImprovement: number, detectorGroups: Array<(
    { __typename?: 'TrafficResponsivePlanDetectorGroup' }
    & TrafficResponsivePlanDetectorGroupFragmentFragment
  )> };

export type TrafficResponsivePlanFragmentFragment = { __typename?: 'TrafficResponsivePlan', id: string, name?: string | null, number: number, description?: string | null, frequency: number, actions: Array<(
    { __typename?: 'TrafficResponsivePlanAction' }
    & TrafficResponsivePlanActionFragmentFragment
  )> };

export type SaveTrafficResponsivePlanMutationVariables = Exact<{
  input: TrafficResponsivePlanInput;
}>;


export type SaveTrafficResponsivePlanMutation = { __typename?: 'Mutation', saveTrafficResponsivePlan: { __typename?: 'TrafficResponsivePlan', id: string } };

export type DeleteTrafficResponsivePlanMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTrafficResponsivePlanMutation = { __typename?: 'Mutation', deleteTrafficResponsivePlan: boolean };

export type TrafficResponsivePlansQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TrafficResponsivePlansQuery = { __typename?: 'Query', trafficResponsivePlans: { __typename?: 'TrafficResponsivePlanConnection', totalCount: number, edges: Array<{ __typename?: 'TrafficResponsivePlanConnectionEdge', node: (
        { __typename?: 'TrafficResponsivePlan' }
        & TrafficResponsivePlanFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TrafficResponsivePlanOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TrafficResponsivePlanOptionsQuery = { __typename?: 'Query', trafficResponsivePlans: { __typename?: 'TrafficResponsivePlanConnection', edges: Array<{ __typename?: 'TrafficResponsivePlanConnectionEdge', node: { __typename?: 'TrafficResponsivePlan', id: string, name?: string | null, actions: Array<{ __typename?: 'TrafficResponsivePlanAction', detectorGroups: Array<{ __typename?: 'TrafficResponsivePlanDetectorGroup', detectorGroupId: string }> }> } }> } };

export type TrafficResponsivePlanDetectorGroupsQueryVariables = Exact<{
  ids: Scalars['Object'];
}>;


export type TrafficResponsivePlanDetectorGroupsQuery = { __typename?: 'Query', signalDetectorGroups: { __typename?: 'SignalDetectorGroupConnection', edges: Array<{ __typename?: 'SignalDetectorGroupConnectionEdge', node: { __typename?: 'SignalDetectorGroup', id: string, detectors: Array<{ __typename?: 'SignalDetector', intersectionId: string }> } }> } };

export type TrafficResponsivePlanSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TrafficResponsivePlanSummaryQuery = { __typename?: 'Query', trafficResponsivePlanSummary: { __typename?: 'TrafficResponsivePlanSummary', id: string, name?: string | null, description?: string | null, number: number, frequency: number, actions: Array<{ __typename?: 'TrafficResponsivePlanActionSummary', observedFrom?: any | null, observedTo?: any | null, selected?: boolean | null, id: string, command: any, minimumImprovement: number, referenceValue?: number | null, name: string, detectorGroups: Array<{ __typename?: 'TrafficResponsivePlanDetectorGroupSummary', detectorGroupId: string, name: string, description?: string | null, kValue: number, occupancy: number, volume: number, observedOccupancy?: number | null, observedVolume?: number | null, observedSpeed?: number | null, referenceValue?: number | null, detectors: Array<{ __typename?: 'TrafficResponsivePlanDetectorSummary', detector: number, observedOccupancy?: number | null, observedVolume?: number | null, weight?: number | null, intersection: { __typename?: 'BasicIntersectionDevice', id: string, name: string, type: IntersectionType } }> }> }> } };

export type TrafficResponsiveActionReportQueryVariables = Exact<{
  trafficResponsivePlanId: Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
}>;


export type TrafficResponsiveActionReportQuery = { __typename?: 'Query', trafficResponsiveActionReport: { __typename?: 'GraphData', title: string, xAxis: { __typename?: 'AxisInfo', title: string, type: DataType, min?: string | null, max?: string | null, series: Array<string | null> }, yAxis: Array<{ __typename?: 'AxisInfo', title: string, type: DataType, min?: string | null, max?: string | null, series: Array<string | null> }>, overlay: Array<{ __typename?: 'OverlayInfo', x1: string, x2: string, type: DataType, label: string, color?: string | null, opacity?: number | null }>, checkPoints: Array<{ __typename?: 'CheckPoint', type: DataType, color?: string | null, legend?: string | null, dataPoints?: Array<string | null> | null } | null>, data: Array<{ __typename?: 'ChartData', name: string, legend?: string | null, type: string, color?: string | null, shape?: string | null, dataPoints?: Array<{ __typename?: 'DataPoint', x: string, y: string } | null> | null }> } };

export type SignAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type SignAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string, displayName: string } }> } };

export type SignNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type SignNamesQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', id: string, name: string } }> } };

export type SetSignDefaultMessageMutationVariables = Exact<{
  requests: Array<SignMessageDisplayRequest> | SignMessageDisplayRequest;
}>;


export type SetSignDefaultMessageMutation = { __typename?: 'Mutation', signSetDefaultMessage: boolean };

export type SetSignDefaultMessageEnabledMutationVariables = Exact<{
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type SetSignDefaultMessageEnabledMutation = { __typename?: 'Mutation', signEnableDisableDefaultMessage: boolean };

export type SignMessageLineSegmentFragment = { __typename?: 'SignMessageLineSegment', horizontalJustification?: HorizontalJustification | null, flashingEnabled?: boolean | null, foregroundColor?: string | null, backgroundColor?: string | null, flashOffMillis?: number | null, flashOnMillis?: number | null, font: number, text: string };

export type SignSpeedSettingsFragment = { __typename?: 'SignSpeedSettings', secondaryMaximumSpeed?: number | null, secondaryMinimumSpeed?: number | null, maximumChange: number, minimumSpeed: number, maximumSpeed: number, intervals: number };

export type SignMessageLineFragment = { __typename?: 'SignMessageLine', integration?: string | null, horizontalJustification?: HorizontalJustification | null, lineSegments: Array<(
    { __typename?: 'SignMessageLineSegment' }
    & SignMessageLineSegmentFragment
  )> };

export type SignPositionFragment = { __typename?: 'Position', x?: number | null, y?: number | null };

export type SignMessageImageFragment = { __typename?: 'SignMessageImage', image: number, position: (
    { __typename?: 'Position' }
    & SignPositionFragment
  ) };

export type SignMessageTextAreaFragment = { __typename?: 'SignMessageTextArea', verticalJustification: VerticalJustification, height: number, width: number, position: (
    { __typename?: 'Position' }
    & SignPositionFragment
  ), lines: Array<(
    { __typename?: 'SignMessageLine' }
    & SignMessageLineFragment
  )> };

export type SignMessagePageFragment = { __typename?: 'SignMessagePage', verticalJustification?: VerticalJustification | null, backgroundColor?: string | null, integration?: string | null, pageOffTime?: number | null, rateName?: string | null, pageOnTime?: number | null, textAreas: Array<(
    { __typename?: 'SignMessageTextArea' }
    & SignMessageTextAreaFragment
  )>, images: Array<(
    { __typename?: 'SignMessageImage' }
    & SignMessageImageFragment
  )>, lines: Array<(
    { __typename?: 'SignMessageLine' }
    & SignMessageLineFragment
  )> };

export type SignImageFragment = { __typename?: 'SignImage', height: number, width: number, image: any, slot?: number | null, name: string, id: string };

export type SignMessageFragment = { __typename?: 'SignMessage', beaconsEnabled: boolean, isDefaultMessage?: boolean | null, priority: number, command?: string | null, slot?: number | null, type: SignMessageType, images: Array<(
    { __typename?: 'SignImage' }
    & SignImageFragment
  )>, pages: Array<(
    { __typename?: 'SignMessagePage' }
    & SignMessagePageFragment
  )> };

export type SignMessageDetailsFragment = { __typename?: 'SignLibraryMessage', sign?: string | null, name: string, id: string, message: (
    { __typename?: 'SignMessage' }
    & SignMessageFragment
  ) };

export type SignDisplayTypeFragment = { __typename?: 'SignDisplayType', matrixType: SignMatrixType, characterWidth?: number | null, characterHeight?: number | null, defaultFont?: string | null, maxCharacters?: number | null, height: number, width: number, hash: string, maxLines?: number | null, maxPages?: number | null, characterLabels?: Array<{ __typename?: 'SignCharacterLabel', characterIndex: number, label: string }> | null };

export type SignQueuedMessageFragment = { __typename?: 'SignQueuedMessage', associationDisplayNames: Array<string>, expirationTime?: any | null, associations: Array<string>, user?: string | null, id: string, message: (
    { __typename?: 'SignMessage' }
    & SignMessageFragment
  ) };

export type SignTestsTypeFragment = { __typename?: 'SignTests', fan?: { __typename?: 'SignFanTest', running: boolean, error?: string | null, fans: Array<number> } | null, lamp?: { __typename?: 'SignLampTest', running: boolean, stuckOff: Array<number>, stuckOn: Array<number>, error?: string | null } | null, pixel?: { __typename?: 'SignPixelTest', running: boolean, error?: string | null, pixels: Array<{ __typename?: 'SignPixelTestError', x: number, y: number }> } | null };

export type SignListFragment = { __typename?: 'Sign', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint?: number | null, colorScheme?: SignColorScheme | null, laneDirection?: string | null, lanePosition?: number | null, capabilities: Array<SignCapability>, backgroundColor?: string | null, foregroundColor?: string | null, direction?: string | null, location: any, laneType?: LaneType | null, median?: boolean | null, road?: string | null, name: string, id: string, currentMessage?: (
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  ) | null, displayType: (
    { __typename?: 'SignDisplayType' }
    & SignDisplayTypeFragment
  ), tests?: (
    { __typename?: 'SignTests' }
    & SignTestsTypeFragment
  ) | null, queue: Array<(
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  )> };

export type LaneControlCommandFragment = { __typename?: 'LaneControlCommand', defaultCommand: boolean, message: string, image: any, name: string };

export type LaneControlSettingsFragment = { __typename?: 'LaneControlSettings', systemDefault: boolean, defaultBlank: boolean, signs: Array<string>, name: string, id: string, commands: Array<(
    { __typename?: 'LaneControlCommand' }
    & LaneControlCommandFragment
  )> };

export type SignMessagePreferencesFragment = { __typename?: 'SignMessagePreferences', horizontalJustification: HorizontalJustification, verticalJustification: VerticalJustification, pageOffTime: number, pageOnTime: number, id: string };

export type SignListFragmentFragment = { __typename?: 'Sign', locationDescription?: string | null, communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint?: number | null, externalCenter?: string | null, capabilities: Array<SignCapability>, backgroundColor?: string | null, foregroundColor?: string | null, laneDirection?: string | null, lanePosition?: number | null, colorScheme?: SignColorScheme | null, laneType?: LaneType | null, locationFixed?: boolean | null, direction?: string | null, location: any, road?: string | null, name: string, id: string, communicationParameters?: any | null, messagePreferences?: (
    { __typename?: 'SignMessagePreferences' }
    & SignMessagePreferencesFragment
  ) | null, displayType: (
    { __typename?: 'SignDisplayType' }
    & SignDisplayTypeFragment
  ), speedSettings?: (
    { __typename?: 'SignSpeedSettings' }
    & SignSpeedSettingsFragment
  ) | null, currentMessage?: (
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  ) | null, queue: Array<(
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  )>, tests?: (
    { __typename?: 'SignTests' }
    & SignTestsTypeFragment
  ) | null, corridors?: Array<{ __typename?: 'AssociatedCorridor', id?: string | null, name?: string | null, type?: string | null } | null> | null };

export type SignDetailFragment = { __typename?: 'Sign', cabinetTemperature?: number | null, housingTemperature?: number | null, locationDescription?: string | null, communicationStatus: CommunicationState, travelTimeSegments: Array<string>, lastDataReceived?: any | null, brightnessLevels?: number | null, referencePoint?: number | null, brightnessMode?: SignBrightnessMode | null, externalCenter?: string | null, integrationId: string, laneDirection?: string | null, lanePosition?: number | null, gateClosedTime?: any | null, colorScheme?: SignColorScheme | null, gateOpenTime?: any | null, laneType?: LaneType | null, capabilities: Array<SignCapability>, backgroundColor?: string | null, foregroundColor?: string | null, powerSource?: SignPowerSource | null, brightness?: number | null, external: boolean, direction?: string | null, lastReset?: any | null, location: any, firmware?: string | null, readOnly?: boolean | null, errors: Array<SignError>, volts?: number | null, road?: string | null, name: string, id: string, defaultMessageEnabled?: boolean | null, speedSettings?: (
    { __typename?: 'SignSpeedSettings' }
    & SignSpeedSettingsFragment
  ) | null, messagePreferences?: (
    { __typename?: 'SignMessagePreferences' }
    & SignMessagePreferencesFragment
  ) | null, displayType: (
    { __typename?: 'SignDisplayType' }
    & SignDisplayTypeFragment
  ), tests?: (
    { __typename?: 'SignTests' }
    & SignTestsTypeFragment
  ) | null, commands: Array<{ __typename?: 'SignCommandNumber', number: number, command: string }>, messages: Array<{ __typename?: 'SignMessageNumber', number: number, hash: string }>, graphics: Array<{ __typename?: 'SignGraphicNumber', number: number, label?: string | null, hash: string }>, fonts: Array<{ __typename?: 'SignFontNumber', number: number, hash: string }>, currentMessage?: (
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  ) | null, queue: Array<(
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  )>, defaultMessage?: (
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  ) | null };

export type SignGroupFragment = { __typename?: 'SignGroup', type: SignGroupType, description?: string | null, attributes: any, name: string, id: string, signs: Array<(
    { __typename?: 'Sign' }
    & SignDetailFragment
  )> };

export type SignActivityLogFragment = { __typename?: 'ActivityLog', description?: string | null, timestamp: any, object?: any | null, userId?: string | null, userFullName?: string | null, type?: string | null, id: string, changes?: Array<{ __typename?: 'ActivityLogChange', path?: string | null, operation?: ActivityLogChangeType | null, oldValue?: string | null, newValue?: string | null }> | null };

export type SignSettingSectionFragment = { __typename?: 'ModuleFormSection', id: string, name: string, fields: Array<(
    { __typename?: 'FieldConfig' }
    & FieldConfigFieldsFragment
  ) | null> };

type SignSettingView_DetectorReportConfigFormView_Fragment = { __typename?: 'DetectorReportConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'DetectorReportConfigFormSection' }> };

type SignSettingView_IntegrationConfigFormView_Fragment = { __typename?: 'IntegrationConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'IntegrationConfigFormSection' }> };

type SignSettingView_IntegrationStateView_Fragment = { __typename?: 'IntegrationStateView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'IntegrationStateSection' }> };

type SignSettingView_ModuleSettingsFormView_Fragment = { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, sections: Array<(
    { __typename?: 'ModuleFormSection' }
    & SignSettingSectionFragment
  )> };

export type SignSettingViewFragment = SignSettingView_DetectorReportConfigFormView_Fragment | SignSettingView_IntegrationConfigFormView_Fragment | SignSettingView_IntegrationStateView_Fragment | SignSettingView_ModuleSettingsFormView_Fragment;

type SignSettingViewsRecursive_DetectorReportConfigFormView_Fragment = { __typename?: 'DetectorReportConfigFormView', views: Array<(
    { __typename?: 'DetectorReportConfigFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & SignSettingView_DetectorReportConfigFormView_Fragment
      )> }
      & SignSettingView_DetectorReportConfigFormView_Fragment
    )> }
    & SignSettingView_DetectorReportConfigFormView_Fragment
  )> };

type SignSettingViewsRecursive_IntegrationConfigFormView_Fragment = { __typename?: 'IntegrationConfigFormView', views: Array<(
    { __typename?: 'IntegrationConfigFormView', views: Array<(
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & SignSettingView_IntegrationConfigFormView_Fragment
      )> }
      & SignSettingView_IntegrationConfigFormView_Fragment
    )> }
    & SignSettingView_IntegrationConfigFormView_Fragment
  )> };

type SignSettingViewsRecursive_IntegrationStateView_Fragment = { __typename?: 'IntegrationStateView', views: Array<(
    { __typename?: 'IntegrationStateView', views: Array<(
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & SignSettingView_IntegrationStateView_Fragment
      )> }
      & SignSettingView_IntegrationStateView_Fragment
    )> }
    & SignSettingView_IntegrationStateView_Fragment
  )> };

type SignSettingViewsRecursive_ModuleSettingsFormView_Fragment = { __typename?: 'ModuleSettingsFormView', views: Array<(
    { __typename?: 'DetectorReportConfigFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & SignSettingView_DetectorReportConfigFormView_Fragment
      )> }
      & SignSettingView_DetectorReportConfigFormView_Fragment
    )> }
    & SignSettingView_DetectorReportConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationConfigFormView', views: Array<(
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & SignSettingView_IntegrationConfigFormView_Fragment
      )> }
      & SignSettingView_IntegrationConfigFormView_Fragment
    )> }
    & SignSettingView_IntegrationConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationStateView', views: Array<(
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & SignSettingView_IntegrationStateView_Fragment
      )> }
      & SignSettingView_IntegrationStateView_Fragment
    )> }
    & SignSettingView_IntegrationStateView_Fragment
  ) | (
    { __typename?: 'ModuleSettingsFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & SignSettingView_DetectorReportConfigFormView_Fragment
      )> }
      & SignSettingView_DetectorReportConfigFormView_Fragment
    ) | (
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & SignSettingView_IntegrationConfigFormView_Fragment
      )> }
      & SignSettingView_IntegrationConfigFormView_Fragment
    ) | (
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & SignSettingView_IntegrationStateView_Fragment
      )> }
      & SignSettingView_IntegrationStateView_Fragment
    ) | (
      { __typename?: 'ModuleSettingsFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & SignSettingView_DetectorReportConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationConfigFormView' }
        & SignSettingView_IntegrationConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationStateView' }
        & SignSettingView_IntegrationStateView_Fragment
      ) | (
        { __typename?: 'ModuleSettingsFormView' }
        & SignSettingView_ModuleSettingsFormView_Fragment
      )> }
      & SignSettingView_ModuleSettingsFormView_Fragment
    )> }
    & SignSettingView_ModuleSettingsFormView_Fragment
  )> };

export type SignSettingViewsRecursiveFragment = SignSettingViewsRecursive_DetectorReportConfigFormView_Fragment | SignSettingViewsRecursive_IntegrationConfigFormView_Fragment | SignSettingViewsRecursive_IntegrationStateView_Fragment | SignSettingViewsRecursive_ModuleSettingsFormView_Fragment;

export type SignSettingsFragment = { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, views: Array<(
    { __typename?: 'DetectorReportConfigFormView' }
    & SignSettingViewsRecursive_DetectorReportConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationConfigFormView' }
    & SignSettingViewsRecursive_IntegrationConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationStateView' }
    & SignSettingViewsRecursive_IntegrationStateView_Fragment
  ) | (
    { __typename?: 'ModuleSettingsFormView' }
    & SignSettingViewsRecursive_ModuleSettingsFormView_Fragment
  )>, sections: Array<(
    { __typename?: 'ModuleFormSection' }
    & SignSettingSectionFragment
  )> };

export type SignMessageOverrideFragment = { __typename?: 'SignLibraryMessageOverride', hash: string, message: (
    { __typename?: 'SignMessage' }
    & SignMessageFragment
  ) };

export type SignLibraryMessageFragment = { __typename?: 'SignLibraryMessage', id: string, name: string, sign?: string | null, exclusions?: Array<string> | null, overrides?: Array<(
    { __typename?: 'SignLibraryMessageOverride' }
    & SignMessageOverrideFragment
  )> | null, message: (
    { __typename?: 'SignMessage' }
    & SignMessageFragment
  ) };

export type SignMessageHistoryFragment = { __typename?: 'SignMessageHistory', associationDisplayNames: Array<string>, timeBlanked?: any | null, blankedUser?: string | null, timePosted?: any | null, timeQueued?: any | null, postedUser?: string | null, associations: Array<string>, id: string, signId: string, expirationTime?: any | null, message: (
    { __typename?: 'SignMessage' }
    & SignMessageFragment
  ) };

export type SignDetailsFragment = { __typename?: 'Sign', locationDescription?: string | null, communicationStatus: CommunicationState, travelTimeSegments: Array<string>, lastDataReceived?: any | null, brightnessLevels?: number | null, referencePoint?: number | null, colorScheme?: SignColorScheme | null, brightnessMode?: SignBrightnessMode | null, capabilities: Array<SignCapability>, backgroundColor?: string | null, foregroundColor?: string | null, powerSource?: SignPowerSource | null, brightness?: number | null, direction?: string | null, lastReset?: any | null, location: any, firmware?: string | null, volts?: number | null, road?: string | null, name: string, id: string, messagePreferences?: (
    { __typename?: 'SignMessagePreferences' }
    & SignMessagePreferencesFragment
  ) | null, displayType: (
    { __typename?: 'SignDisplayType' }
    & SignDisplayTypeFragment
  ), fonts: Array<{ __typename?: 'SignFontNumber', number: number, hash: string }>, currentMessage?: (
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  ) | null, queue: Array<(
    { __typename?: 'SignQueuedMessage' }
    & SignQueuedMessageFragment
  )>, tests?: (
    { __typename?: 'SignTests' }
    & SignTestsTypeFragment
  ) | null };

export type SaveSignGroupMutationVariables = Exact<{
  input: SignGroupInput;
}>;


export type SaveSignGroupMutation = { __typename?: 'Mutation', signSaveGroup: { __typename?: 'SignGroup', id: string } };

export type DeleteSignGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSignGroupMutation = { __typename?: 'Mutation', signDeleteGroup: boolean };

export type RequestInterlockOverrideMutationVariables = Exact<{
  input: Array<SignInterlockInput> | SignInterlockInput;
  resourcePlanIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  resourcePlanNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type RequestInterlockOverrideMutation = { __typename?: 'Mutation', requestInterlockOverride: { __typename?: 'SignInterlockOverrideApproval', approved: boolean, rejected: boolean, id: string } };

export type CancelInterlockOverrideMutationVariables = Exact<{
  approvalId: Scalars['ID'];
}>;


export type CancelInterlockOverrideMutation = { __typename?: 'Mutation', cancelInterlockOverride: boolean };

export type ApproveInterlockOverrideMutationVariables = Exact<{
  approvalId: Scalars['ID'];
}>;


export type ApproveInterlockOverrideMutation = { __typename?: 'Mutation', approveInterlockOverride: boolean };

export type RejectInterlockOverrideMutationVariables = Exact<{
  approvalId: Scalars['ID'];
}>;


export type RejectInterlockOverrideMutation = { __typename?: 'Mutation', rejectInterlockOverride: boolean };

export type InterlockOverrideRequestsQueryVariables = Exact<{
  approvalId: Scalars['ID'];
}>;


export type InterlockOverrideRequestsQuery = { __typename?: 'Query', interlockOverrideRequests: { __typename?: 'SignInterlockOverrideApprovalViewDto', userDisplayName: string, approvalId: string, resourcePlanIds?: Array<string> | null, signs: Array<{ __typename?: 'SignApprovalMessageDto', id: string, message: (
        { __typename?: 'SignMessage' }
        & SignMessageFragment
      ) }> } };

export type InterlockOverrideApprovalUpdatedSubscriptionVariables = Exact<{
  approvalId: Scalars['ID'];
}>;


export type InterlockOverrideApprovalUpdatedSubscription = { __typename?: 'Subscription', interlockOverrideApprovalUpdated: { __typename?: 'SignInterlockOverrideApproval', id: string, rejected: boolean, approved: boolean } };

export type SignBlankMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SignBlankMutation = { __typename?: 'Mutation', signBlank: Array<(
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  )> };

export type SignPollMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SignPollMutation = { __typename?: 'Mutation', signPoll: Array<(
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  )> };

export type SignFontDownloadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignFontDownloadMutation = { __typename?: 'Mutation', signFonts: (
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  ) };

export type SignResetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignResetMutation = { __typename?: 'Mutation', signReset: (
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  ) };

export type SetDefaultColorMutationVariables = Exact<{
  id: Scalars['ID'];
  requestId?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  isBackground: Scalars['Boolean'];
}>;


export type SetDefaultColorMutation = { __typename?: 'Mutation', setDefaultColor: boolean };

export type SignBrightnessMutationVariables = Exact<{
  id: Scalars['ID'];
  brightnessMode: SignBrightnessMode;
  brightness?: InputMaybe<Scalars['Int']>;
}>;


export type SignBrightnessMutation = { __typename?: 'Mutation', signBrightness: (
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  ) };

export type SignExtendMutationVariables = Exact<{
  id: Scalars['ID'];
  expirationTime: Scalars['DateTime'];
}>;


export type SignExtendMutation = { __typename?: 'Mutation', signExtend: (
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  ) };

export type DeleteSignMessagesMutationVariables = Exact<{
  messageIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteSignMessagesMutation = { __typename?: 'Mutation', deleteSignMessages: boolean };

export type RemoveQueuedMessagesMutationVariables = Exact<{
  id: Scalars['ID'];
  queuedMessages: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveQueuedMessagesMutation = { __typename?: 'Mutation', removeQueuedMessages: { __typename?: 'JobRequest', requestId?: string | null, success: boolean, failure?: string | null, id: string } };

export type SaveSignModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveSignModuleSettingsMutation = { __typename?: 'Mutation', saveSignModuleSettings?: boolean | null };

export type MultiPostMutationVariables = Exact<{
  messages: Array<SignMessageDisplayRequest> | SignMessageDisplayRequest;
}>;


export type MultiPostMutation = { __typename?: 'Mutation', signDisplay: Array<{ __typename?: 'JobRequest', failure?: string | null, success: boolean, id: string }> };

export type SetSignMessagePreferencesMutationVariables = Exact<{
  id: Scalars['ID'];
  preference?: InputMaybe<Scalars['ID']>;
}>;


export type SetSignMessagePreferencesMutation = { __typename?: 'Mutation', signSetMessagePreferences: boolean };

export type SignFanTestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignFanTestMutation = { __typename?: 'Mutation', signFanTest: { __typename?: 'JobRequest', failure?: string | null, success: boolean } };

export type SignPixelTestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignPixelTestMutation = { __typename?: 'Mutation', signPixelTest: { __typename?: 'JobRequest', failure?: string | null, success: boolean } };

export type SignLampTestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignLampTestMutation = { __typename?: 'Mutation', signLampTest: { __typename?: 'JobRequest', failure?: string | null, success: boolean } };

export type SignSetSpeedSettingsMutationVariables = Exact<{
  id: Scalars['ID'];
  settings: SignSpeedSettingsInput;
}>;


export type SignSetSpeedSettingsMutation = { __typename?: 'Mutation', signSetSpeedSettings: boolean };

export type SignSetDefaultFontMutationVariables = Exact<{
  id: Scalars['ID'];
  hash: Scalars['ID'];
}>;


export type SignSetDefaultFontMutation = { __typename?: 'Mutation', signSetDefaultFont: boolean };

export type SignDownloadMessageMutationVariables = Exact<{
  id: Scalars['ID'];
  slot: Scalars['Int'];
}>;


export type SignDownloadMessageMutation = { __typename?: 'Mutation', _signDownloadMessage: { __typename?: 'JobRequest', failure?: string | null, success: boolean } };

export type SignDownloadAllMessagesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignDownloadAllMessagesMutation = { __typename?: 'Mutation', _signDownloadAllMessages: { __typename?: 'JobRequest', failure?: string | null, success: boolean } };

export type SignDownloadGraphicMutationVariables = Exact<{
  id: Scalars['ID'];
  slot: Scalars['Int'];
}>;


export type SignDownloadGraphicMutation = { __typename?: 'Mutation', _signDownloadGraphic: { __typename?: 'JobRequest', failure?: string | null, success: boolean } };

export type SignDownloadAllGraphicsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignDownloadAllGraphicsMutation = { __typename?: 'Mutation', _signDownloadAllGraphics: { __typename?: 'JobRequest', failure?: string | null, success: boolean } };

export type SignUploadGraphicMutationVariables = Exact<{
  arguments: SignUploadGraphicArguments;
}>;


export type SignUploadGraphicMutation = { __typename?: 'Mutation', _signUploadGraphic: { __typename?: 'JobRequest', success: boolean, failure?: string | null, id: string } };

export type SignUploadAllGraphicsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignUploadAllGraphicsMutation = { __typename?: 'Mutation', signUploadAllGraphics: boolean };

export type SignDeleteGraphicMutationVariables = Exact<{
  slot: Scalars['Int'];
  id: Scalars['ID'];
}>;


export type SignDeleteGraphicMutation = { __typename?: 'Mutation', _signDeleteGraphic: { __typename?: 'JobRequest', success: boolean, failure?: string | null, id: string } };

export type SignDeleteMessageMutationVariables = Exact<{
  slot: Scalars['Int'];
  id: Scalars['ID'];
}>;


export type SignDeleteMessageMutation = { __typename?: 'Mutation', signDeleteCommand: { __typename?: 'JobRequest', success: boolean, failure?: string | null, id: string } };

export type SignUploadMessageMutationVariables = Exact<{
  message: SignMessageInput;
  slot: Scalars['Int'];
  id: Scalars['ID'];
}>;


export type SignUploadMessageMutation = { __typename?: 'Mutation', signUploadMessage: { __typename?: 'JobRequest', success: boolean, failure?: string | null, id: string } };

export type SignUploadAllCommandsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignUploadAllCommandsMutation = { __typename?: 'Mutation', signUploadAllMessages: boolean };

export type SignSetFontsMutationVariables = Exact<{
  id: Scalars['ID'];
  fontNumbers: Array<SignFontNumberInput> | SignFontNumberInput;
}>;


export type SignSetFontsMutation = { __typename?: 'Mutation', signSetFonts: boolean };

export type SignSetCommandsMutationVariables = Exact<{
  id: Scalars['ID'];
  commands: Array<SignCommandNumberInput> | SignCommandNumberInput;
}>;


export type SignSetCommandsMutation = { __typename?: 'Mutation', signSetCommands: boolean };

export type SignSetGraphicLabelsMutationVariables = Exact<{
  id: Scalars['ID'];
  labels: Array<SignGraphicLabelInput> | SignGraphicLabelInput;
}>;


export type SignSetGraphicLabelsMutation = { __typename?: 'Mutation', signSetGraphicLabels: boolean };

export type SignSetCommandMessagePriorityMutationVariables = Exact<{
  id: Scalars['ID'];
  slot: Scalars['Int'];
  priority: Scalars['Int'];
}>;


export type SignSetCommandMessagePriorityMutation = { __typename?: 'Mutation', signSetCommandMessagePriority: boolean };

export type SaveResourcePlanMutationVariables = Exact<{
  input: ResourcePlanInput;
}>;


export type SaveResourcePlanMutation = { __typename?: 'Mutation', saveResourcePlan: { __typename?: 'ResourcePlan', id: string } };

export type SaveSignMessageMutationVariables = Exact<{
  input: SignLibraryMessageInput;
}>;


export type SaveSignMessageMutation = { __typename?: 'Mutation', saveSignMessage?: (
    { __typename?: 'SignLibraryMessage' }
    & SignLibraryMessageFragment
  ) | null };

export type SignDisplayMutationVariables = Exact<{
  requests: Array<SignMessageDisplayRequest> | SignMessageDisplayRequest;
}>;


export type SignDisplayMutation = { __typename?: 'Mutation', signDisplay: Array<(
    { __typename?: 'JobRequest' }
    & JobRequestFragment
  )> };

export type UpdateQueuedMessageMutationVariables = Exact<{
  id: Scalars['ID'];
  queuedMessage: SignQueuedMessageInput;
}>;


export type UpdateQueuedMessageMutation = { __typename?: 'Mutation', updateQueuedMessage: { __typename?: 'JobRequest', success: boolean, failure?: string | null, id: string } };

export type SignInterlockAcknowledgeMutationVariables = Exact<{
  input: Array<SignInterlockInput> | SignInterlockInput;
  resourcePlanIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SignInterlockAcknowledgeMutation = { __typename?: 'Mutation', signInterlockAcknowledge: boolean };

export type DeleteSignMessagePrioritiesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteSignMessagePrioritiesMutation = { __typename?: 'Mutation', deleteSignMessagePriorities: boolean };

export type SaveSignMessagePriorityMutationVariables = Exact<{
  input: SignMessagePriorityInput;
}>;


export type SaveSignMessagePriorityMutation = { __typename?: 'Mutation', saveSignMessagePriority?: { __typename?: 'SignMessagePriority', id: string } | null };

export type SignMessagePrioritiesListQueryVariables = Exact<{ [key: string]: never; }>;


export type SignMessagePrioritiesListQuery = { __typename?: 'Query', signMessagePriorities: Array<{ __typename?: 'SignMessagePriority', travelTimeDefault: boolean, messageDefault: boolean, description?: string | null, priority: number, name: string, id: string }> };

export type SignMessagePriorityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignMessagePriorityQuery = { __typename?: 'Query', signMessagePriority?: { __typename?: 'SignMessagePriority', travelTimeDefault: boolean, messageDefault: boolean, description?: string | null, priority: number, name: string, id: string } | null };

export type SignLibraryMessageUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SignLibraryMessageUpdatedSubscription = { __typename?: 'Subscription', libraryMessageUpdated: (
    { __typename?: 'SignLibraryMessage' }
    & SignLibraryMessageFragment
  ) };

export type SignSpeedSettingsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignSpeedSettingsQuery = { __typename?: 'Query', sign: { __typename?: 'Sign', speedSettings?: (
      { __typename?: 'SignSpeedSettings' }
      & SignSpeedSettingsFragment
    ) | null } };

export type SignColorsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignColorsQuery = { __typename?: 'Query', sign: { __typename?: 'Sign', backgroundColor?: string | null, foregroundColor?: string | null } };

export type SignControllerFontsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignControllerFontsQuery = { __typename?: 'Query', signControllerFonts: Array<{ __typename?: 'SignControllerFont', characterSpacing: number, characterHeight: number, fontFileName?: string | null, lineSpacing: number, fontVersion: number, font: string, id: string }> };

export type SignDefaultFontQueryVariables = Exact<{ [key: string]: never; }>;


export type SignDefaultFontQuery = { __typename?: 'Query', signDefaultFont: { __typename?: 'SignFont', characterSpacing: number, characterHeight: number, fontFileName?: string | null, lineSpacing: number, fontVersion: number, font: string, id: string } };

export type SignCapabilitiesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignCapabilitiesQuery = { __typename?: 'Query', sign: { __typename?: 'Sign', capabilities: Array<SignCapability> } };

export type SignDisplayTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignDisplayTypeQuery = { __typename?: 'Query', signDisplayType: (
    { __typename?: 'SignDisplayType' }
    & SignDisplayTypeFragment
  ) };

export type SignMessageDisplayTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SignMessageDisplayTypesQuery = { __typename?: 'Query', signMessageDisplayTypes: Array<{ __typename?: 'SignMessageDisplayType', characterHeight?: number | null, characterWidth?: number | null, maxCharacters?: number | null, defaultFont?: string | null, matrixType: SignMatrixType, maxLines?: number | null, maxPages?: number | null, height: number, width: number, hash: string }> };

export type SignGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignGroupQuery = { __typename?: 'Query', signGroup: (
    { __typename?: 'SignGroup' }
    & SignGroupFragment
  ) };

export type SignGroupsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type SignGroupsListQuery = { __typename?: 'Query', signGroups: { __typename?: 'SignGroupConnection', totalCount: number, edges: Array<{ __typename?: 'SignGroupConnectionEdge', node: { __typename?: 'SignGroup', description?: string | null, attributes: any, type: SignGroupType, name: string, id: string, signs: Array<{ __typename?: 'Sign', referencePoint?: number | null, direction?: string | null, id: string, displayType: (
            { __typename?: 'SignDisplayType' }
            & SignDisplayTypeFragment
          ) }> } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetSignQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSignQuery = { __typename?: 'Query', sign: (
    { __typename?: 'Sign' }
    & SignDetailFragment
  ) };

export type GetSignGraphicsQueryVariables = Exact<{
  filterInput: Array<FilterInput> | FilterInput;
}>;


export type GetSignGraphicsQuery = { __typename?: 'Query', getManagedFiles: { __typename?: 'ManagedFileConnection', edges: Array<{ __typename?: 'ManagedFileEdge', node: { __typename?: 'ManagedFile', height?: number | null, image?: string | null, width?: number | null, name: string, id: string } }> } };

export type SignUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignUpdatedSubscription = { __typename?: 'Subscription', signUpdated: (
    { __typename?: 'Sign' }
    & SignDetailFragment
  ) };

export type SignMapEntitiesQueryVariables = Exact<{
  filters: Array<FilterInput> | FilterInput;
}>;


export type SignMapEntitiesQuery = { __typename?: 'Query', signMapEntities: Array<any> };

export type SignDisplayTypeMessageValidateQueryVariables = Exact<{
  id: Scalars['ID'];
  message: SignMessageInput;
}>;


export type SignDisplayTypeMessageValidateQuery = { __typename?: 'Query', validateDisplayTypeMessage: { __typename?: 'SignMessageValidationResult', failure?: string | null } };

export type SignLibraryMessageValidateQueryVariables = Exact<{
  message: SignLibraryMessageInput;
}>;


export type SignLibraryMessageValidateQuery = { __typename?: 'Query', validateLibraryMessage: Array<{ __typename?: 'SignLibraryMessageValidationResult', result?: string | null, hash: string }> };

export type SignsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SignsSummaryQuery = { __typename?: 'Query', activeSign: { __typename?: 'SignConnection', totalCount: number }, allSigns: { __typename?: 'SignConnection', totalCount: number } };

export type SignsListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SignsListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', totalCount: number, edges: Array<{ __typename?: 'SignConnectionEdge', node: (
        { __typename?: 'Sign' }
        & SignListFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SignLibraryMessageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignLibraryMessageQuery = { __typename?: 'Query', signMessage?: (
    { __typename?: 'SignLibraryMessage' }
    & SignLibraryMessageFragment
  ) | null };

export type LiveSignListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveSignListSubscription = { __typename?: 'Subscription', signUpdated: (
    { __typename?: 'Sign' }
    & SignListFragmentFragment
  ) };

export type MessageLibraryQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sign?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<SignMessageType>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type MessageLibraryQuery = { __typename?: 'Query', signMessages: { __typename?: 'SignLibraryMessageConnection', totalCount: number, edges: Array<{ __typename?: 'SignLibraryMessageConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'SignLibraryMessage' }
        & SignLibraryMessageFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SignSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SignSettingsQuery = { __typename?: 'Query', signModuleSettings: (
    { __typename?: 'ModuleSettingsFormView' }
    & SignSettingsFragment
  ) };

export type SignControllerFontListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignControllerFontListQuery = { __typename?: 'Query', signControllerFonts: Array<{ __typename?: 'SignControllerFont', characterSpacing: number, characterHeight: number, fontFileName?: string | null, lineSpacing: number, fontVersion: number, fontNumber: number, font: string, id: string }> };

export type SignControllerMessagesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignControllerMessagesQuery = { __typename?: 'Query', signControllerMessages: Array<(
    { __typename?: 'SignMessage' }
    & SignMessageFragment
  )> };

export type SignControllerGraphicsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignControllerGraphicsQuery = { __typename?: 'Query', signControllerGraphics: Array<{ __typename?: 'SignGraphic', height: number, width: number, image: any, name: string, slot?: number | null, id: string }> };

export type GetSignCapabilitiesListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type GetSignCapabilitiesListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', capabilities: Array<SignCapability>, id: string } }> } };

export type SignMultiPostListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type SignMultiPostListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', capabilities: Array<SignCapability>, readOnly?: boolean | null, id: string } }> } };

export type SignSelectListQueryVariables = Exact<{ [key: string]: never; }>;


export type SignSelectListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', name: string, id: string } }> } };

export type SignReadOnlyListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type SignReadOnlyListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', external: boolean, readOnly?: boolean | null, id: string } }> } };

export type NearbySignsByPointQueryVariables = Exact<{
  x: Scalars['Float'];
  y: Scalars['Float'];
  thresholdMiles?: InputMaybe<Scalars['Float']>;
  integrationType?: InputMaybe<IntegrationType>;
}>;


export type NearbySignsByPointQuery = { __typename?: 'Query', nearbyIntegrationsByPoint?: Array<{ __typename?: 'Integration', id: string, state: { __typename?: 'IntegrationState', current: any } }> | null };

export type SignListUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SignListUpdatedSubscription = { __typename?: 'Subscription', signUpdated: (
    { __typename?: 'Sign' }
    & SignListFragment
  ) };

export type SignMessagesQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  type?: InputMaybe<SignMessageType>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sign: Scalars['ID'];
}>;


export type SignMessagesQuery = { __typename?: 'Query', signMessageLibrary: { __typename?: 'SignLibraryMessageConnection', totalCount: number, edges: Array<{ __typename?: 'SignLibraryMessageConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'SignLibraryMessage' }
        & SignLibraryMessageFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SignMessageLibraryQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  type?: InputMaybe<SignMessageType>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  sign?: InputMaybe<Scalars['ID']>;
}>;


export type SignMessageLibraryQuery = { __typename?: 'Query', signMessages: { __typename?: 'SignLibraryMessageConnection', totalCount: number, edges: Array<{ __typename?: 'SignLibraryMessageConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'SignLibraryMessage' }
        & SignLibraryMessageFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SignMessageHistoryQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  association?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}>;


export type SignMessageHistoryQuery = { __typename?: 'Query', signMessageHistory: { __typename?: 'SignMessageHistoryConnection', totalCount: number, edges: Array<{ __typename?: 'SignMessageHistoryConnectionEdge', node: (
        { __typename?: 'SignMessageHistory' }
        & SignMessageHistoryFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SignFontQueryVariables = Exact<{
  hash: Scalars['ID'];
}>;


export type SignFontQuery = { __typename?: 'Query', signFont: { __typename?: 'SignFont', characterSpacing: number, characterHeight: number, fontFileName?: string | null, lineSpacing: number, fontVersion: number, font: string, id: string } };

export type SignFontsQueryVariables = Exact<{ [key: string]: never; }>;


export type SignFontsQuery = { __typename?: 'Query', signFonts: Array<{ __typename?: 'SignFont', characterSpacing: number, characterHeight: number, fontFileName?: string | null, lineSpacing: number, fontVersion: number, font: string, id: string }> };

export type SignMessagePrioritiesQueryVariables = Exact<{ [key: string]: never; }>;


export type SignMessagePrioritiesQuery = { __typename?: 'Query', signMessagePriorities: Array<{ __typename?: 'SignMessagePriority', travelTimeDefault: boolean, messageDefault: boolean, description?: string | null, priority: number, name: string, id: string }> };

export type SignMessagePriorityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SignMessagePriorityOptionsQuery = { __typename?: 'Query', signMessagePriorities: Array<{ __typename?: 'SignMessagePriority', name: string, priority: number, id: string }> };

export type SignCommandMessageQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  command: Scalars['String'];
}>;


export type SignCommandMessageQuery = { __typename?: 'Query', signCommandMessage: Array<{ __typename?: 'SignLibraryMessage', sign?: string | null, message: (
      { __typename?: 'SignMessage' }
      & SignMessageFragment
    ) }> };

export type SignSelectionListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SignSelectionListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', totalCount: number, edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', referencePoint?: number | null, laneDirection?: string | null, lanePosition?: number | null, direction?: string | null, laneType?: LaneType | null, road?: string | null, name: string, id: string, displayType: (
          { __typename?: 'SignDisplayType' }
          & SignDisplayTypeFragment
        ) } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SignIdsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type SignIdsQuery = { __typename?: 'Query', signMapEntities: Array<any> };

export type GetLedEditorManagedGraphicsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLedEditorManagedGraphicsQuery = { __typename?: 'Query', signControllerGraphics: Array<{ __typename?: 'SignGraphic', height: number, width: number, image: any, name: string, slot?: number | null, id: string }> };

export type SignGroupMapEntitiesQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<SignGroupType> | SignGroupType>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type SignGroupMapEntitiesQuery = { __typename?: 'Query', signGroupMapEntities: Array<any> };

export type SignGroupUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  types?: InputMaybe<Array<SignGroupType> | SignGroupType>;
}>;


export type SignGroupUpdatedSubscription = { __typename?: 'Subscription', signGroupUpdated: { __typename?: 'SignGroup', id: string } };

export type SignInterlockValidateQueryVariables = Exact<{
  input: Array<SignInterlockInput> | SignInterlockInput;
}>;


export type SignInterlockValidateQuery = { __typename?: 'Query', signInterlockValidate: Array<{ __typename?: 'SignInterlockResult', requiresAcknowledgement: boolean, acknowledgementMessage?: string | null, requiresApproval: boolean, hasInterlock: boolean, failure?: string | null, id: string }> };

export type SignMessageFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignMessageFormQuery = { __typename?: 'Query', signMessage?: (
    { __typename?: 'SignLibraryMessage' }
    & SignMessageDetailsFragment
  ) | null };

export type SignMessageListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  type?: InputMaybe<SignMessageType>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SignMessageListQuery = { __typename?: 'Query', signMessages: { __typename?: 'SignLibraryMessageConnection', totalCount: number, edges: Array<{ __typename?: 'SignLibraryMessageConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'SignLibraryMessage' }
        & SignMessageDetailsFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SignDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignDetailsQuery = { __typename?: 'Query', sign: (
    { __typename?: 'Sign' }
    & SignDetailsFragment
  ) };

export type SignGraphicNumbersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignGraphicNumbersQuery = { __typename?: 'Query', sign: { __typename?: 'Sign', graphics: Array<{ __typename?: 'SignGraphicNumber', number: number, label?: string | null }> } };

export type SignNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignNameQuery = { __typename?: 'Query', sign: { __typename?: 'Sign', name: string } };

export type SignIntegrationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignIntegrationsQuery = { __typename?: 'Query', signIntegrations: Array<{ __typename?: 'SignIntegration', name: string, type: IntegrationType, id: string, variables: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null }> }> };

export type PricingSignIntegrationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PricingSignIntegrationsQuery = { __typename?: 'Query', getPricingSignIntegrations: Array<{ __typename?: 'SignIntegration', name: string, type: IntegrationType, id: string, variables: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null }> }> };

export type SignGateDelayTimesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SignGateDelayTimesQuery = { __typename?: 'Query', sign: { __typename?: 'Sign', gateOpenTime?: any | null, gateClosedTime?: any | null } };

export type TollRoadWidgetSignsQueryVariables = Exact<{
  ids: Scalars['Object'];
}>;


export type TollRoadWidgetSignsQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', name: string, id: string, communicationStatus: CommunicationState, backgroundColor?: string | null, foregroundColor?: string | null, referencePoint?: number | null, displayType: (
          { __typename?: 'SignDisplayType' }
          & SignDisplayTypeFragment
        ), tests?: (
          { __typename?: 'SignTests' }
          & SignTestsTypeFragment
        ) | null, currentMessage?: { __typename?: 'SignQueuedMessage', message: (
            { __typename?: 'SignMessage' }
            & SignMessageFragment
          ) } | null } }> } };

export type SaveAtlasArchiveModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveAtlasArchiveModuleSettingsMutation = { __typename?: 'Mutation', saveAtlasArchiveModuleSettings?: boolean | null };

export type AtlasArchiveModuleSettingsQueryVariables = Exact<{
  formViewName: Scalars['String'];
}>;


export type AtlasArchiveModuleSettingsQuery = { __typename?: 'Query', atlasArchiveModuleSettings: { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, views: Array<{ __typename?: 'DetectorReportConfigFormView', id: string, name: string, views: Array<(
        { __typename?: 'DetectorReportConfigFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          )> }
          & FormViewFragment_DetectorReportConfigFormView_Fragment
        )> }
        & FormViewFragment_DetectorReportConfigFormView_Fragment
      )> } | { __typename?: 'IntegrationConfigFormView', id: string, name: string, views: Array<(
        { __typename?: 'IntegrationConfigFormView', views: Array<(
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          )> }
          & FormViewFragment_IntegrationConfigFormView_Fragment
        )> }
        & FormViewFragment_IntegrationConfigFormView_Fragment
      )> } | { __typename?: 'IntegrationStateView', id: string, name: string, views: Array<(
        { __typename?: 'IntegrationStateView', views: Array<(
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          )> }
          & FormViewFragment_IntegrationStateView_Fragment
        )> }
        & FormViewFragment_IntegrationStateView_Fragment
      )> } | { __typename?: 'ModuleSettingsFormView', id: string, name: string, views: Array<(
        { __typename?: 'DetectorReportConfigFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          )> }
          & FormViewFragment_DetectorReportConfigFormView_Fragment
        )> }
        & FormViewFragment_DetectorReportConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationConfigFormView', views: Array<(
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          )> }
          & FormViewFragment_IntegrationConfigFormView_Fragment
        )> }
        & FormViewFragment_IntegrationConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationStateView', views: Array<(
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          )> }
          & FormViewFragment_IntegrationStateView_Fragment
        )> }
        & FormViewFragment_IntegrationStateView_Fragment
      ) | (
        { __typename?: 'ModuleSettingsFormView', views: Array<(
          { __typename?: 'DetectorReportConfigFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          )> }
          & FormViewFragment_DetectorReportConfigFormView_Fragment
        ) | (
          { __typename?: 'IntegrationConfigFormView', views: Array<(
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          )> }
          & FormViewFragment_IntegrationConfigFormView_Fragment
        ) | (
          { __typename?: 'IntegrationStateView', views: Array<(
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          )> }
          & FormViewFragment_IntegrationStateView_Fragment
        ) | (
          { __typename?: 'ModuleSettingsFormView', views: Array<(
            { __typename?: 'DetectorReportConfigFormView' }
            & FormViewFragment_DetectorReportConfigFormView_Fragment
          ) | (
            { __typename?: 'IntegrationConfigFormView' }
            & FormViewFragment_IntegrationConfigFormView_Fragment
          ) | (
            { __typename?: 'IntegrationStateView' }
            & FormViewFragment_IntegrationStateView_Fragment
          ) | (
            { __typename?: 'ModuleSettingsFormView' }
            & FormViewFragment_ModuleSettingsFormView_Fragment
          )> }
          & FormViewFragment_ModuleSettingsFormView_Fragment
        )> }
        & FormViewFragment_ModuleSettingsFormView_Fragment
      )> }>, sections: Array<(
      { __typename?: 'ModuleFormSection' }
      & ModuleFormSectionFragmentFragment
    )> } };

export type PrivilegeAssignmentFragmentFragment = { __typename?: 'KineticPrivilegeAssignment', id: string, privilegeType: PrivilegeType, kineticModule: KineticModule, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null, restrictedLocationGroups?: Array<string> | null, restrictedLocations?: Array<string> | null };

export type KineticFormEventTypeFragment = { __typename?: 'EventType', id: string, name: string };

export type TaskProgressFragmentFragment = { __typename?: 'TaskProgress', id: string, name: string, description?: string | null, status: TaskProgressStatus, progress: number, resource?: string | null, associatedIds?: Array<string | null> | null, systemTask?: boolean | null, userIds?: Array<string | null> | null, source: KineticModule, created: any, updated: any, error?: string | null, task: string, type: TaskProgressType };

export type DeviceViewFragmentFragment = { __typename?: 'IntersectionDeviceUIView', displayName?: string | null, name?: string | null };

export type SavedRouteFragment = { __typename?: 'LocationRoute', id: string, name: string, classification: string, direction: string, geometry: any };

export type KineticUserFragmentFragment = { __typename?: 'OrganizationKineticUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumbers: Array<string>, roleIds: Array<string>, userGroupIds: Array<string>, online?: boolean | null, privilegeAssignmentList: Array<(
    { __typename?: 'KineticPrivilegeAssignment' }
    & PrivilegeAssignmentFragmentFragment
  )> };

export type KineticUserQueryVariables = Exact<{ [key: string]: never; }>;


export type KineticUserQuery = { __typename?: 'Query', kineticUser: { __typename?: 'KineticUser', id: string, username: string, firstName?: string | null, lastName?: string | null, picture?: string | null, email?: string | null, preferences: Array<{ __typename?: 'UserPreference', key: string, value: any }>, kineticPreferences: Array<{ __typename?: 'UserPreference', key: string, value: any }> }, organizationPreferences: Array<{ __typename?: 'OrganizationPreference', key: string, value: any }> };

export type GetKineticUserUsernameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetKineticUserUsernameQuery = { __typename?: 'Query', getKineticUser?: { __typename?: 'OrganizationKineticUser', username: string } | null };

export type GetActiveUserListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  online?: InputMaybe<Scalars['Boolean']>;
  searchGroup?: InputMaybe<Scalars['Boolean']>;
  searchRole?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetActiveUserListQuery = { __typename?: 'Query', users: { __typename?: 'KineticUserConnection', totalCount: number, edges: Array<{ __typename?: 'KineticUserConnectionEdge', node: (
        { __typename?: 'OrganizationKineticUser' }
        & KineticUserFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type MapConfigFragmentFragment = { __typename?: 'MapConfig', id: string, name: string, geometry: any, layers: Array<string>, zoom?: number | null };

export type MapLayerConfigFragmentFragment = { __typename?: 'MapLayerConfig', id: string, name: string, type: MapLayerType, data: any, baseLayer: boolean, visible: boolean, group?: string | null };

export type GetDefaultMapConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultMapConfigQuery = { __typename?: 'Query', mapConfig?: (
    { __typename?: 'MapConfig' }
    & MapConfigFragmentFragment
  ) | null };

export type GetMapLayerConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMapLayerConfigQuery = { __typename?: 'Query', mapLayerConfig?: (
    { __typename?: 'MapLayerConfig' }
    & MapLayerConfigFragmentFragment
  ) | null };

export type GetMapLayerConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMapLayerConfigsQuery = { __typename?: 'Query', mapLayerConfigs: Array<(
    { __typename?: 'MapLayerConfig' }
    & MapLayerConfigFragmentFragment
  )> };

export type GetMapConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMapConfigQuery = { __typename?: 'Query', mapConfig?: (
    { __typename?: 'MapConfig' }
    & MapConfigFragmentFragment
  ) | null };

export type GetMapConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMapConfigsQuery = { __typename?: 'Query', mapConfigs: Array<(
    { __typename?: 'MapConfig' }
    & MapConfigFragmentFragment
  )> };

export type SaveEmailServerSettingsMutationVariables = Exact<{
  settings: EmailServerSettingsInput;
}>;


export type SaveEmailServerSettingsMutation = { __typename?: 'Mutation', saveEmailServerSettings: { __typename?: 'EmailServerSettings', host: string, port: number, auth: boolean, startTls: boolean, requireStartTls: boolean, sslTrust: boolean, username?: string | null, password?: string | null, ignoreTls: boolean, from: string, sslEnabled: boolean } };

export type DeleteKineticFormsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteKineticFormsMutation = { __typename?: 'Mutation', deleteKineticForms?: boolean | null };

export type SaveKineticFormMutationVariables = Exact<{
  form: KineticFormInput;
}>;


export type SaveKineticFormMutation = { __typename?: 'Mutation', saveKineticForm: (
    { __typename?: 'KineticForm' }
    & KineticFormFragment
  ) };

export type CreateKeycloakClientMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateKeycloakClientMutation = { __typename?: 'Mutation', createKeycloakClient: { __typename?: 'KeycloakClient', id: string, clientId: string, name?: string | null, secret: string } };

export type RegenerateClientSecretMutationVariables = Exact<{ [key: string]: never; }>;


export type RegenerateClientSecretMutation = { __typename?: 'Mutation', regenerateClientSecret: boolean };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: boolean };

export type DeleteUserGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserGroupMutation = { __typename?: 'Mutation', deleteUserGroup: boolean };

export type SaveRoleMutationVariables = Exact<{
  role: KineticRoleInput;
}>;


export type SaveRoleMutation = { __typename?: 'Mutation', saveRole: { __typename?: 'KineticRole', id: string, name: string, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null, privilegeAssignmentList: Array<(
      { __typename?: 'KineticPrivilegeAssignment' }
      & PrivilegeAssignmentFragmentFragment
    )> } };

export type SaveUserGroupMutationVariables = Exact<{
  userGroup: KineticUserGroupInput;
}>;


export type SaveUserGroupMutation = { __typename?: 'Mutation', saveUserGroup: { __typename?: 'KineticUserGroup', id: string, name: string, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null, privilegeAssignmentList: Array<(
      { __typename?: 'KineticPrivilegeAssignment' }
      & PrivilegeAssignmentFragmentFragment
    )>, roles: Array<{ __typename?: 'KineticRole', id: string, name: string, privilegeAssignmentList: Array<(
        { __typename?: 'KineticPrivilegeAssignment' }
        & PrivilegeAssignmentFragmentFragment
      )> }>, users: Array<{ __typename?: 'OrganizationKineticUser', id: string, username: string, firstName?: string | null, lastName?: string | null }> } };

export type CreateUserMutationVariables = Exact<{
  user: OrganizationKineticUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'OrganizationKineticUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumbers: Array<string>, roleIds: Array<string>, userGroupIds: Array<string>, privilegeAssignmentList: Array<(
      { __typename?: 'KineticPrivilegeAssignment' }
      & PrivilegeAssignmentFragmentFragment
    )> } };

export type UpdateUserPrivilegesMutationVariables = Exact<{
  user: KineticUserPrivilegeAssignmentInput;
}>;


export type UpdateUserPrivilegesMutation = { __typename?: 'Mutation', updateUserPrivileges: { __typename?: 'KineticUserPrivilegeAssignment', id: string, roles: Array<{ __typename?: 'KineticRole', id: string, name: string }>, privilegeAssignmentList: Array<(
      { __typename?: 'KineticPrivilegeAssignment' }
      & PrivilegeAssignmentFragmentFragment
    )> } };

export type ResetPasswordMutationVariables = Exact<{
  id: Scalars['ID'];
  newPassword: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser?: boolean | null };

export type SaveMapConfigMutationVariables = Exact<{
  config: MapConfigInput;
}>;


export type SaveMapConfigMutation = { __typename?: 'Mutation', saveMapConfig: (
    { __typename?: 'MapConfig' }
    & MapConfigFragmentFragment
  ) };

export type SaveMapLayerConfigMutationVariables = Exact<{
  config: MapLayerConfigInput;
}>;


export type SaveMapLayerConfigMutation = { __typename?: 'Mutation', saveMapLayerConfig: (
    { __typename?: 'MapLayerConfig' }
    & MapLayerConfigFragmentFragment
  ) };

export type DeleteMapLayerConfigMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMapLayerConfigMutation = { __typename?: 'Mutation', deleteMapLayerConfig?: boolean | null };

export type DeleteMapConfigMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMapConfigMutation = { __typename?: 'Mutation', deleteMapConfig?: boolean | null };

export type SyncMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncMutation = { __typename?: 'Mutation', syncLicense: boolean };

export type SaveLicenseMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type SaveLicenseMutation = { __typename?: 'Mutation', saveLicense: boolean };

export type SaveKineticFormFieldMutationVariables = Exact<{
  field: KineticFormFieldInput;
}>;


export type SaveKineticFormFieldMutation = { __typename?: 'Mutation', saveKineticFormField: (
    { __typename?: 'KineticFormField' }
    & KineticFormFieldFragmentFragment
  ) };

export type DeleteKineticFormFieldsMutationVariables = Exact<{
  selection: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteKineticFormFieldsMutation = { __typename?: 'Mutation', deleteKineticFormFields?: boolean | null };

export type SaveCentralAuthPinSettingsMutationVariables = Exact<{
  pin: Scalars['String'];
}>;


export type SaveCentralAuthPinSettingsMutation = { __typename?: 'Mutation', saveCentralAuthPinSettings?: { __typename?: 'CentralAuthPinSettings', id: string } | null };

export type GenerateTokenZipMutationVariables = Exact<{
  refreshToken: Scalars['String'];
  idToken: Scalars['String'];
}>;


export type GenerateTokenZipMutation = { __typename?: 'Mutation', generateTokenZip: boolean };

export type ImportFormFieldsMutationVariables = Exact<{
  input: Array<Scalars['Object']> | Scalars['Object'];
}>;


export type ImportFormFieldsMutation = { __typename?: 'Mutation', importFormFields: boolean };

export type ImportFormsMutationVariables = Exact<{
  input: Array<Scalars['Object']> | Scalars['Object'];
}>;


export type ImportFormsMutation = { __typename?: 'Mutation', importForms: boolean };

export type KeycloakClientQueryVariables = Exact<{ [key: string]: never; }>;


export type KeycloakClientQuery = { __typename?: 'Query', keycloakClient?: { __typename?: 'KeycloakClient', id: string, clientId: string, name?: string | null, secret: string } | null };

export type EmailServerSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailServerSettingsQuery = { __typename?: 'Query', emailServerSettings?: { __typename?: 'EmailServerSettings', host: string, port: number, auth: boolean, startTls: boolean, requireStartTls: boolean, sslTrust: boolean, username?: string | null, password?: string | null, ignoreTls: boolean, from: string, sslEnabled: boolean } | null };

export type RecentRemoteAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentRemoteAgentsQuery = { __typename?: 'Query', recentRemoteAgents: Array<{ __typename?: 'RemoteAgentHeartbeat', instanceId: string, processId: number, systemName: string, remoteIpAddress: string, clientId: string, version: string, internalIpAddress: string, lastHeartbeat: any, labels: Array<string> }> };

export type GetOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'KineticOrganization', id: string, name: string, address?: string | null }> };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'KineticRole', id: string, name: string, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null, restrictedLocations?: Array<string> | null, restrictedLocationGroups?: Array<string> | null, privilegeAssignmentList: Array<(
      { __typename?: 'KineticPrivilegeAssignment' }
      & PrivilegeAssignmentFragmentFragment
    )> }> };

export type GetRoleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetRoleQuery = { __typename?: 'Query', role?: { __typename?: 'KineticRole', id: string, name: string, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null, privilegeAssignmentList: Array<(
      { __typename?: 'KineticPrivilegeAssignment' }
      & PrivilegeAssignmentFragmentFragment
    )> } | null };

export type RolesUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RolesUpdatedSubscription = { __typename?: 'Subscription', rolesUpdated?: { __typename?: 'KineticRole', id: string, name: string, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null, privilegeAssignmentList: Array<(
      { __typename?: 'KineticPrivilegeAssignment' }
      & PrivilegeAssignmentFragmentFragment
    )> } | null };

export type GetUserGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserGroupQuery = { __typename?: 'Query', userGroup?: { __typename?: 'KineticUserGroup', id: string, name: string, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null, restrictedLocations?: Array<string> | null, restrictedLocationGroups?: Array<string> | null, users: Array<{ __typename?: 'OrganizationKineticUser', id: string, username: string, firstName?: string | null, lastName?: string | null }>, roles: Array<{ __typename?: 'KineticRole', id: string, name: string }>, privilegeAssignmentList: Array<(
      { __typename?: 'KineticPrivilegeAssignment' }
      & PrivilegeAssignmentFragmentFragment
    )> } | null };

export type GetUserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'KineticUserGroup', id: string, name: string, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null, users: Array<{ __typename?: 'OrganizationKineticUser', id: string }>, roles: Array<{ __typename?: 'KineticRole', id: string, name: string }> }> };

export type UserGroupsUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UserGroupsUpdatedSubscription = { __typename?: 'Subscription', userGroupsUpdated?: { __typename?: 'KineticUserGroup', id: string, name: string, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null, users: Array<{ __typename?: 'OrganizationKineticUser', id: string }>, roles: Array<{ __typename?: 'KineticRole', id: string, name: string }> } | null };

export type GetPrivilegesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrivilegesQuery = { __typename?: 'Query', privileges: Array<{ __typename?: 'KineticPrivilege', id: string, privilegeType: PrivilegeType, kineticModule: KineticModule }> };

export type PrivilegeAssignmentsUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PrivilegeAssignmentsUpdatedSubscription = { __typename?: 'Subscription', privilegeAssignmentsUpdated?: { __typename?: 'KineticUserPrivilegeAssignment', id: string } | null };

export type IsUsernameUniqueQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type IsUsernameUniqueQuery = { __typename?: 'Query', isUsernameUnique: boolean };

export type LicenseFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type LicenseFeaturesQuery = { __typename?: 'Query', licenseFeatures: Array<{ __typename?: 'KineticLicenseFeatureValue', feature: KineticLicenseFeature, value?: number | null, enabled: boolean, used?: number | null }> };

export type VersionQueryVariables = Exact<{ [key: string]: never; }>;


export type VersionQuery = { __typename?: 'Query', version: string, gitHash: string, lastGitTag: string };

export type LicenseDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type LicenseDetailsQuery = { __typename?: 'Query', licenseDetails?: { __typename?: 'KineticLicenseDetails', key: string, activationId: string, expiresAt?: any | null, leaseExpiresAt?: any | null, accountId?: string | null, company?: string | null, email?: string | null } | null };

export type HasValidLicenseQueryVariables = Exact<{ [key: string]: never; }>;


export type HasValidLicenseQuery = { __typename?: 'Query', hasValidLicense?: boolean | null };

export type KineticFormEventTypesQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<EventCategory>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type KineticFormEventTypesQuery = { __typename?: 'Query', eventTypes: { __typename?: 'EventTypeConnection', edges: Array<{ __typename?: 'EventTypeConnectionEdge', node: (
        { __typename?: 'EventType' }
        & KineticFormEventTypeFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type DataSourceConfigListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  module?: InputMaybe<KineticModule>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type DataSourceConfigListQuery = { __typename?: 'Query', dataSourceConfigs: { __typename?: 'DataSourceConfigConnection', totalCount: number, edges: Array<{ __typename?: 'DataSourceConfigConnectionEdge', node: { __typename?: 'DataSourceConfig', name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type KineticFormsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  module?: InputMaybe<KineticModule>;
}>;


export type KineticFormsQuery = { __typename?: 'Query', kineticForms: { __typename?: 'KineticFormConnection', totalCount: number, edges: Array<{ __typename?: 'KineticFormConnectionEdge', node: (
        { __typename?: 'KineticForm' }
        & KineticFormFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type KineticFormDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type KineticFormDetailQuery = { __typename?: 'Query', kineticForm: (
    { __typename?: 'KineticForm' }
    & KineticFormFragment
  ) };

export type KineticFormFieldsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type KineticFormFieldsQuery = { __typename?: 'Query', kineticFormFields: { __typename?: 'KineticFormFieldConnection', totalCount: number, edges: Array<{ __typename?: 'KineticFormFieldConnectionEdge', node: (
        { __typename?: 'KineticFormField' }
        & KineticFormFieldFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type KineticFormFieldDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type KineticFormFieldDetailQuery = { __typename?: 'Query', kineticFormField: (
    { __typename?: 'KineticFormField' }
    & KineticFormFieldFragmentFragment
  ) };

export type GetTaskProgressQueryVariables = Exact<{
  query: TaskProgressQuery;
}>;


export type GetTaskProgressQuery = { __typename?: 'Query', taskProgress: { __typename?: 'TaskProgressConnection', edges: Array<{ __typename?: 'TaskProgressConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'TaskProgress' }
        & TaskProgressFragmentFragment
      ) }> } };

export type TaskProgressUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TaskProgressUpdatedSubscription = { __typename?: 'Subscription', taskProgressUpdated: (
    { __typename?: 'TaskProgress' }
    & TaskProgressFragmentFragment
  ) };

export type CentralAuthenticationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CentralAuthenticationSettingsQuery = { __typename?: 'Query', kineticAuthSettings: { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'ModuleFormSection', name: string, id: string, fields: Array<{ __typename?: 'FieldConfig', id: string, name: string, label: string, type: string, required?: boolean | null, hint?: string | null, sourceId?: string | null, defaultValue?: any | null, loading?: boolean | null, showInput?: boolean | null, options?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null> | null } | null> }> } };

export type SaveCentralAuthenticationSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveCentralAuthenticationSettingsMutation = { __typename?: 'Mutation', saveKineticAuthSettings?: boolean | null };

export type DeviceViewsQueryVariables = Exact<{
  id: DeviceViewsProtocolEntityEnum;
}>;


export type DeviceViewsQuery = { __typename?: 'Query', deviceViews?: { __typename: 'DeviceViewsUi', views: (
      { __typename: 'IntersectionDeviceUIView', views?: Array<(
        { __typename: 'IntersectionDeviceUIView', views?: Array<(
          { __typename: 'IntersectionDeviceUIView', views?: Array<(
            { __typename: 'IntersectionDeviceUIView', views?: Array<(
              { __typename: 'IntersectionDeviceUIView', views?: Array<(
                { __typename: 'IntersectionDeviceUIView' }
                & ViewFragmentFragment
              )> | null }
              & ViewFragmentFragment
            )> | null }
            & ViewFragmentFragment
          )> | null }
          & ViewFragmentFragment
        )> | null }
        & ViewFragmentFragment
      )> | null }
      & ViewFragmentFragment
    ) } | null };

export type CentralAuthPinSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CentralAuthPinSettingsQuery = { __typename?: 'Query', centralAuthPinSettings?: { __typename?: 'CentralAuthPinSettings', id: string, pin: string } | null };

export type ExportFormFieldsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ExportFormFieldsQuery = { __typename?: 'Query', exportFormFields: any };

export type ExportFormsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ExportFormsQuery = { __typename?: 'Query', exportForms: any };

export type TaskFragmentFragment = { __typename?: 'Task', id: string, name: string, taskType: TaskType, timezone?: string | null, start: any, end: any, data: any, taskRecurrenceType: TaskRecurrenceType, rrule?: string | null, recurrenceEndDate?: any | null, externalCenterId?: string | null, exdate?: string | null };

export type TaskOccurrenceFragmentFragment = { __typename?: 'TaskOccurrence', start: any, end: any, task: (
    { __typename?: 'Task' }
    & TaskFragmentFragment
  ) };

export type TaskUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
}>;


export type TaskUpdatedSubscription = { __typename?: 'Subscription', taskUpdated: (
    { __typename?: 'Task' }
    & TaskFragmentFragment
  ) };

export type SaveTollingModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveTollingModuleSettingsMutation = { __typename?: 'Mutation', saveTollingModuleSettings?: boolean | null };

export type TollingPointNamesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TollingPointNamesQuery = { __typename?: 'Query', tollingPoints: { __typename?: 'TollingPointsConnection', edges: Array<{ __typename?: 'TollingPointsConnectionEdge', node: { __typename?: 'TollingPoint', id: string, name: string } }> } };

export type TollingAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type TollingAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string } }> } };

export type TollingModuleSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TollingModuleSettingsQuery = { __typename?: 'Query', tollingModuleSettings: { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, views: Array<{ __typename?: 'DetectorReportConfigFormView', id: string, name: string, views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & FormViewFragment_DetectorReportConfigFormView_Fragment
      )> } | { __typename?: 'IntegrationConfigFormView', id: string, name: string, views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & FormViewFragment_IntegrationConfigFormView_Fragment
      )> } | { __typename?: 'IntegrationStateView', id: string, name: string, views: Array<(
        { __typename?: 'IntegrationStateView' }
        & FormViewFragment_IntegrationStateView_Fragment
      )> } | { __typename?: 'ModuleSettingsFormView', id: string, name: string, views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & FormViewFragment_DetectorReportConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationConfigFormView' }
        & FormViewFragment_IntegrationConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationStateView' }
        & FormViewFragment_IntegrationStateView_Fragment
      ) | (
        { __typename?: 'ModuleSettingsFormView' }
        & FormViewFragment_ModuleSettingsFormView_Fragment
      )> }>, sections: Array<(
      { __typename?: 'ModuleFormSection' }
      & ModuleFormSectionFragmentFragment
    )> } };

export type ActivateTollPointMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateTollPointMutation = { __typename?: 'Mutation', activateTollPoint: { __typename?: 'JobRequest', requestId?: string | null, failure?: string | null, success: boolean, id: string } };

export type RefreshTollingPointLinkStatusMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefreshTollingPointLinkStatusMutation = { __typename?: 'Mutation', refreshTollingPointLinkStatus: boolean };

export type TollPointsListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollPointsListQuery = { __typename?: 'Query', tollingPoints: { __typename?: 'TollingPointsConnection', totalCount: number, edges: Array<{ __typename?: 'TollingPointsConnectionEdge', node: { __typename?: 'TollingPoint', id: string, name: string, plazaId?: string | null, reversalPlazaId?: string | null, location?: any | null, locationId?: string | null, description?: string | null, referencePoint?: number | null, plazaDirection?: Direction | null, locationDescription?: string | null, linkStatus: TollingLinkStatus, direction?: Direction | null, road?: string | null, updatedAt: any, tollingPointStatus: TollingPointStatus, communicationState: CommunicationState, isActive: boolean, tollRoadId?: string | null, activeAlarms?: Array<string> | null } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveTollingPointsListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveTollingPointsListSubscription = { __typename?: 'Subscription', tollingPointUpdated: { __typename?: 'TollingPoint', name: string, plazaId?: string | null, reversalPlazaId?: string | null, plazaDirection?: Direction | null, location?: any | null, locationId?: string | null, description?: string | null, referencePoint?: number | null, linkStatus: TollingLinkStatus, locationDescription?: string | null, direction?: Direction | null, road?: string | null, updatedAt: any, tollingPointStatus: TollingPointStatus, communicationState: CommunicationState, isActive: boolean, tollRoadId?: string | null, id: string } };

export type TollPointSwitcherOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TollPointSwitcherOptionsQuery = { __typename?: 'Query', tollingPoints: { __typename?: 'TollingPointsConnection', edges: Array<{ __typename?: 'TollingPointsConnectionEdge', node: { __typename?: 'TollingPoint', id: string, name: string } }> } };

export type TollingPointOptionsQueryVariables = Exact<{
  ids: Scalars['Object'];
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type TollingPointOptionsQuery = { __typename?: 'Query', tollingPoints: { __typename?: 'TollingPointsConnection', edges: Array<{ __typename?: 'TollingPointsConnectionEdge', node: { __typename?: 'TollingPoint', id: string, name: string } }> } };

export type TollingPointMapListQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type TollingPointMapListQuery = { __typename?: 'Query', tollingPoints: { __typename?: 'TollingPointsConnection', edges: Array<{ __typename?: 'TollingPointsConnectionEdge', node: { __typename?: 'TollingPoint', id: string, location?: any | null, tollingPointStatus: TollingPointStatus, communicationState: CommunicationState, isActive: boolean } }> } };

export type TollingPointMapTooltipQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingPointMapTooltipQuery = { __typename?: 'Query', tollingPoint?: { __typename?: 'TollingPoint', id: string, name: string, description?: string | null, isActive: boolean, plazaId?: string | null, tollingPointStatus: TollingPointStatus, communicationState: CommunicationState, road?: string | null, referencePoint?: number | null, direction?: Direction | null, updatedAt: any } | null };

export type TollPointDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollPointDetailsQuery = { __typename?: 'Query', tollingPoint?: { __typename?: 'TollingPoint', id: string, name: string, plazaId?: string | null, reversalPlazaId?: string | null, location?: any | null, locationId?: string | null, description?: string | null, referencePoint?: number | null, locationDescription?: string | null, linkStatus: TollingLinkStatus, direction?: Direction | null, road?: string | null, updatedAt: any, tollingPointStatus: TollingPointStatus, communicationState: CommunicationState, isActive: boolean, tollRoadId?: string | null } | null };

export type TollingPointSearchListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TollingPointSearchListQuery = { __typename?: 'Query', tollingPoints: { __typename?: 'TollingPointsConnection', edges: Array<{ __typename?: 'TollingPointsConnectionEdge', node: { __typename?: 'TollingPoint', location?: any | null, name: string, id: string } }> } };

export type TollingPointStatusCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type TollingPointStatusCountsQuery = { __typename?: 'Query', DISABLED: { __typename?: 'TollingPointsConnection', totalCount: number }, FAILED: { __typename?: 'TollingPointsConnection', totalCount: number }, NO_DATA: { __typename?: 'TollingPointsConnection', totalCount: number }, OPERATIONAL: { __typename?: 'TollingPointsConnection', totalCount: number }, OPERATIONAL_WITH_ERROR: { __typename?: 'TollingPointsConnection', totalCount: number }, OPERATIONAL_WITH_WARNING: { __typename?: 'TollingPointsConnection', totalCount: number }, SUSPECT: { __typename?: 'TollingPointsConnection', totalCount: number } };

export type TollingPointsByIdQueryVariables = Exact<{
  ids: Scalars['Object'];
}>;


export type TollingPointsByIdQuery = { __typename?: 'Query', tollingPoints: { __typename?: 'TollingPointsConnection', edges: Array<{ __typename?: 'TollingPointsConnectionEdge', node: { __typename?: 'TollingPoint', id: string, name: string, location?: any | null, locationId?: string | null, description?: string | null, communicationState: CommunicationState } }> } };

export type TollingPointGateGroupsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingPointGateGroupsQuery = { __typename?: 'Query', tollingPointGateGroups: Array<{ __typename?: 'GateGroupUpdate', referencePoint: number, direction: GateDirection, rampType: GateGroupRampType, status: GateControllerStatus, name: string, id: string }> };

export type TollingPricingListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollingPricingListQuery = { __typename?: 'Query', tollingPricingList: { __typename?: 'TollingPricingConnection', totalCount: number, edges: Array<{ __typename?: 'TollingPricingConnectionEdge', node: { __typename?: 'TollingPricing', communicationStatus: CommunicationState, lastDataReceived?: any | null, failedPollCount: number, description?: string | null, mode: TollingPricingMode, name: string, id: string } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveTollingPricingListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveTollingPricingListSubscription = { __typename?: 'Subscription', tollingPricingUpdated: { __typename?: 'TollingPricing', communicationStatus: CommunicationState, lastDataReceived?: any | null, failedPollCount: number, description?: string | null, name: string, mode: TollingPricingMode, id: string } };

export type LiveTollingPricingSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LiveTollingPricingSubscription = { __typename?: 'Subscription', tollingPricingUpdated: { __typename?: 'TollingPricing', id: string } };

export type TollingPricingRateOptionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingPricingRateOptionsQuery = { __typename?: 'Query', tollingPricingRateOptions: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null }> };

export type TollingPricingDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingPricingDetailsQuery = { __typename?: 'Query', tollingPricing?: { __typename?: 'TollingPricing', name: string } | null };

export type TollingPricingCurrentRatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingPricingCurrentRatesQuery = { __typename?: 'Query', tollingPricing?: { __typename?: 'TollingPricing', rates: Array<{ __typename?: 'PricingRate', firstDestination?: string | null, firstRate?: number | null, secondDestination?: string | null, secondRate?: number | null, thirdDestination?: string | null, thirdRate?: number | null, name: string }> } | null };

export type TollingPricingHistoricalRatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingPricingHistoricalRatesQuery = { __typename?: 'Query', tollingPricing?: { __typename?: 'TollingPricing', ratesHistorical: Array<{ __typename?: 'HistoricalPricingRate', secondDestination?: string | null, thirdDestination?: string | null, firstDestination: string, signs: Array<string> }> } | null };

export type TollingPricingHistoricalRateQueryVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type TollingPricingHistoricalRateQuery = { __typename?: 'Query', tollingPricingHistoricalRate: Array<{ __typename?: 'HistoricalSignRate', secondDestination?: string | null, thirdDestination?: string | null, firstDestination: string, secondRate?: number | null, thirdRate?: number | null, firstRate: number, startTime: any, endTime: any }> };

export type TollingPricingRateHistoryListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollingPricingRateHistoryListQuery = { __typename?: 'Query', tollingPricingRateHistory: { __typename?: 'TollingPricingRateHistoryConnection', totalCount: number, edges: Array<{ __typename?: 'TollingPricingRateHistoryConnectionEdge', node: { __typename?: 'TollingPricingRateHistory', timestamp: any, id: string, rate: { __typename?: 'PricingRate', firstDestination?: string | null, firstRate?: number | null, secondDestination?: string | null, secondRate?: number | null, thirdDestination?: string | null, thirdRate?: number | null, name: string } } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TollingPricingHistoricalRateHistoryListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollingPricingHistoricalRateHistoryListQuery = { __typename?: 'Query', tollingPricingHistoricalRateHistoryList: { __typename?: 'TollingPricingHistoricalRateHistoryConnection', totalCount: number, edges: Array<{ __typename?: 'TollingPricingHistoricalRateHistoryConnectionEdge', node: { __typename?: 'TollingPricingHistoricalRateHistory', timestamp: any, id: string, rate: { __typename?: 'HistoricalPricingRate', firstDestination: string, secondDestination?: string | null, thirdDestination?: string | null, signs: Array<string> } } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TollingPricingHistoricalRateHistoryRatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingPricingHistoricalRateHistoryRatesQuery = { __typename?: 'Query', tollingPricingHistoricalRateHistory: Array<{ __typename?: 'HistoricalSignRate', secondDestination?: string | null, thirdDestination?: string | null, firstDestination: string, secondRate?: number | null, thirdRate?: number | null, firstRate: number, startTime: any, endTime: any }> };

export type TollingPricingConfirmedRateHistoryQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollingPricingConfirmedRateHistoryQuery = { __typename?: 'Query', tollingPricingConfirmedRateHistory: { __typename?: 'TollingPricingConfirmedRateHistoryConnection', totalCount: number, edges: Array<{ __typename?: 'TollingPricingConfirmedRateHistoryConnectionEdge', node: { __typename?: 'TollingPricingConfirmedRateHistory', communicationStatus: string, timestamp: any, startTime: any, endTime?: any | null, name: string, id: string, rate?: { __typename?: 'PricingRate', firstDestination?: string | null, secondDestination?: string | null, thirdDestination?: string | null, firstRate?: number | null, secondRate?: number | null, thirdRate?: number | null, name: string } | null } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TollingRoadSaveMutationVariables = Exact<{
  input: TollingRoadInput;
}>;


export type TollingRoadSaveMutation = { __typename?: 'Mutation', tollingRoadSave: { __typename?: 'TollingRoad', id: string } };

export type TollingRoadDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingRoadDeleteMutation = { __typename?: 'Mutation', tollingRoadDelete: boolean };

export type TollRoadsListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollRoadsListQuery = { __typename?: 'Query', tollingRoads: { __typename?: 'TollingRoadConnection', totalCount: number, edges: Array<{ __typename?: 'TollingRoadConnectionEdge', node: { __typename?: 'TollingRoad', dynamicPricingId?: string | null, description?: string | null, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TollRoadNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollRoadNameQuery = { __typename?: 'Query', tollRoad?: { __typename?: 'TollingRoad', name: string, id: string } | null };

export type TollRoadDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollRoadDetailsQuery = { __typename?: 'Query', tollRoad?: { __typename?: 'TollingRoad', dynamicPricingId?: string | null, tollingSegments: Array<string>, tollingPoints: Array<string>, description?: string | null, name: string, id: string } | null };

export type DynamicPricingSelectionListQueryVariables = Exact<{ [key: string]: never; }>;


export type DynamicPricingSelectionListQuery = { __typename?: 'Query', integrations: { __typename?: 'IntegrationConnection', totalCount: number, edges: Array<{ __typename?: 'IntegrationConnectionEdge', node: { __typename?: 'Integration', name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TollSegmentSelectionListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TollSegmentSelectionListQuery = { __typename?: 'Query', tollingSegments: { __typename?: 'TollingSegmentConnection', totalCount: number, edges: Array<{ __typename?: 'TollingSegmentConnectionEdge', node: { __typename?: 'TollingSegment', startReference: number, endReference: number, destinations: Array<string>, description?: string | null, direction: Direction, road: string, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TollRoadsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TollRoadsOptionsQuery = { __typename?: 'Query', tollingRoads: { __typename?: 'TollingRoadConnection', edges: Array<{ __typename?: 'TollingRoadConnectionEdge', node: { __typename?: 'TollingRoad', id: string, name: string, dynamicPricingId?: string | null } }> } };

export type TollRoadPricingIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollRoadPricingIdQuery = { __typename?: 'Query', tollRoad?: { __typename?: 'TollingRoad', dynamicPricingId?: string | null } | null };

export type TollRoadPricingModeQueryVariables = Exact<{
  dynamicPricingId: Scalars['ID'];
}>;


export type TollRoadPricingModeQuery = { __typename?: 'Query', tollingPricing?: { __typename?: 'TollingPricing', id: string, mode: TollingPricingMode, communicationStatus: CommunicationState } | null };

export type TollRoadSegmentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollRoadSegmentsQuery = { __typename?: 'Query', tollRoad?: { __typename?: 'TollingRoad', tollingSegments: Array<string>, id: string } | null };

export type TollingSegmentSaveMutationVariables = Exact<{
  input: TollingSegmentInput;
}>;


export type TollingSegmentSaveMutation = { __typename?: 'Mutation', tollingSegmentSave: { __typename?: 'TollingSegment', description?: string | null, destinations: Array<string>, detectors: Array<string>, direction: Direction, endReference: number, id: string, locationId: string, name: string, road: string, signs: Array<string>, startReference: number, tollRoadId?: string | null } };

export type TollingSegmentDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingSegmentDeleteMutation = { __typename?: 'Mutation', tollingSegmentDelete: boolean };

export type SaveTollingSegmentCommentMutationVariables = Exact<{
  commentId?: InputMaybe<Scalars['ID']>;
  entityId: Scalars['ID'];
  mentionedUsers?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  html: Scalars['String'];
}>;


export type SaveTollingSegmentCommentMutation = { __typename?: 'Mutation', saveTollingSegmentComment: { __typename?: 'BasicComment', id: string, entityId: string, createdBy: string, createdAt: any, updatedAt?: any | null, mentionedUsers?: Array<string> | null, html: string } };

export type DeleteTollingSegmentCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
}>;


export type DeleteTollingSegmentCommentMutation = { __typename?: 'Mutation', deleteTollingSegmentComment: boolean };

export type ExportCurrentHistoricalRatesMutationVariables = Exact<{
  rate: Scalars['String'];
}>;


export type ExportCurrentHistoricalRatesMutation = { __typename?: 'Mutation', exportCurrentHistoricalRates: boolean };

export type TollingSegmentsListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollingSegmentsListQuery = { __typename?: 'Query', tollingSegments: { __typename?: 'TollingSegmentConnection', totalCount: number, edges: Array<{ __typename?: 'TollingSegmentConnectionEdge', node: { __typename?: 'TollingSegment', id: string, name: string, description?: string | null, direction: Direction, destinations: Array<string>, startReference: number, endReference: number, tollRoadId?: string | null } }>, pageInfo: (
      { __typename: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SegmentLocationOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentLocationOptionsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationConnectionEdge', node: { __typename?: 'Location', id: string, details: { __typename?: 'LocationDetails', name: string } } }> } };

export type TollingSegmentSignsQueryVariables = Exact<{
  signIds: Scalars['Object'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TollingSegmentSignsQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', id: string, name: string, road?: string | null, direction?: string | null, referencePoint?: number | null } }> } };

export type TollingSegmentDetectorsQueryVariables = Exact<{
  detectorIds: Scalars['Object'];
}>;


export type TollingSegmentDetectorsQuery = { __typename?: 'Query', detectors: { __typename?: 'DetectorConnection', edges: Array<{ __typename?: 'DetectorConnectionEdge', node: { __typename?: 'Detector', id: string, name: string, road?: string | null, direction?: string | null, referencePoint?: number | null } }> } };

export type TollingSegmentFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingSegmentFormQuery = { __typename?: 'Query', tollingSegment?: { __typename?: 'TollingSegment', description?: string | null, destinations: Array<string>, detectors: Array<string>, direction: Direction, endReference: number, id: string, locationId: string, name: string, road: string, signs: Array<string>, startReference: number, tollRoadId?: string | null } | null };

export type TollingSegmentDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingSegmentDetailsQuery = { __typename?: 'Query', tollingSegment?: { __typename?: 'TollingSegment', id: string, name: string, description?: string | null, destinations: Array<string> } | null };

export type TollingSegmentOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TollingSegmentOptionsQuery = { __typename?: 'Query', tollingSegments: { __typename?: 'TollingSegmentConnection', edges: Array<{ __typename?: 'TollingSegmentConnectionEdge', node: { __typename?: 'TollingSegment', id: string, name: string } }> } };

export type TollingSegmentSummaryCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingSegmentSummaryCardQuery = { __typename?: 'Query', tollingSegment?: { __typename?: 'TollingSegment', id: string, name: string, description?: string | null, destinations: Array<string>, startReference: number, endReference: number, tollRoadId?: string | null } | null };

export type TollingSegmentDetailsSignsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingSegmentDetailsSignsQuery = { __typename?: 'Query', tollingSegment?: { __typename?: 'TollingSegment', id: string, signs: Array<string> } | null };

export type TollingSegmentDetailsDetectorsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TollingSegmentDetailsDetectorsQuery = { __typename?: 'Query', tollingSegment?: { __typename?: 'TollingSegment', id: string, detectors: Array<string> } | null };

export type TollingSegmentDetailsSignsListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollingSegmentDetailsSignsListQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', totalCount: number, edges: Array<{ __typename?: 'SignConnectionEdge', node: (
        { __typename?: 'Sign' }
        & SignListFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TollingSegmentDetailsDetectorsListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollingSegmentDetailsDetectorsListQuery = { __typename?: 'Query', detectors: { __typename?: 'DetectorConnection', totalCount: number, edges: Array<{ __typename?: 'DetectorConnectionEdge', node: (
        { __typename?: 'Detector' }
        & DetectorFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TollSegmentTollRoadQueryVariables = Exact<{
  segmentId: Scalars['ID'];
}>;


export type TollSegmentTollRoadQuery = { __typename?: 'Query', tollingSegment?: { __typename?: 'TollingSegment', id: string, tollRoadId?: string | null } | null };

export type TollSegmentMapLocationQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;


export type TollSegmentMapLocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, geometry: any } | null };

export type TollSegmentLocationQueryVariables = Exact<{
  segmentId: Scalars['ID'];
}>;


export type TollSegmentLocationQuery = { __typename?: 'Query', tollingSegment?: { __typename?: 'TollingSegment', id: string, locationId: string } | null };

export type TollRoadWidgetSegmentsQueryVariables = Exact<{
  ids: Scalars['Object'];
  direction: Scalars['Object'];
}>;


export type TollRoadWidgetSegmentsQuery = { __typename?: 'Query', tollingSegments: { __typename?: 'TollingSegmentConnection', edges: Array<{ __typename?: 'TollingSegmentConnectionEdge', node: { __typename?: 'TollingSegment', id: string, name: string, signs: Array<string> } }> } };

export type TollSegmentCommentsQueryVariables = Exact<{
  segmentId: Scalars['ID'];
}>;


export type TollSegmentCommentsQuery = { __typename?: 'Query', tollingSegmentComments: Array<{ __typename?: 'BasicComment', id: string, entityId: string, createdBy: string, createdAt: any, updatedAt?: any | null, mentionedUsers?: Array<string> | null, html: string }> };

export type TollingSegmentsByIdQueryVariables = Exact<{
  ids: Scalars['Object'];
}>;


export type TollingSegmentsByIdQuery = { __typename?: 'Query', tollingSegments: { __typename?: 'TollingSegmentConnection', edges: Array<{ __typename?: 'TollingSegmentConnectionEdge', node: { __typename?: 'TollingSegment', id: string, name: string, location?: any | null, locationId: string } }> } };

export type TollingSignsListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type TollingSignsListQuery = { __typename?: 'Query', tollingSigns: { __typename?: 'TollingSignsConnection', totalCount: number, edges: Array<{ __typename?: 'TollingSignsEdge', node: { __typename?: 'TollingSign', id: string, communicationState?: string | null, road?: string | null, direction?: string | null, referencePoint?: number | null, lastDataReceived?: any | null, pricingId?: string | null, name: string, mode: TollingPricingMode, secondaryHistoricalRate?: { __typename?: 'PricingRate', firstDestination?: string | null, firstRate?: number | null, secondDestination?: string | null, secondRate?: number | null, thirdDestination?: string | null, thirdRate?: number | null, name: string } | null, primaryHistoricalRate?: { __typename?: 'PricingRate', firstDestination?: string | null, firstRate?: number | null, secondDestination?: string | null, secondRate?: number | null, thirdDestination?: string | null, thirdRate?: number | null, name: string } | null, currentMessage?: (
          { __typename?: 'SignMessage' }
          & SignMessageFragment
        ) | null, rate?: { __typename?: 'PricingRate', name: string } | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveTollingSignsListSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiveTollingSignsListSubscription = { __typename?: 'Subscription', tollingSignUpdated: { __typename?: 'TollingSign', id: string, communicationState?: string | null, road?: string | null, direction?: string | null, referencePoint?: number | null, lastDataReceived?: any | null, pricingId?: string | null, name: string, mode: TollingPricingMode, secondaryHistoricalRate?: { __typename?: 'PricingRate', firstDestination?: string | null, firstRate?: number | null, secondDestination?: string | null, secondRate?: number | null, thirdDestination?: string | null, thirdRate?: number | null, name: string } | null, primaryHistoricalRate?: { __typename?: 'PricingRate', firstDestination?: string | null, firstRate?: number | null, secondDestination?: string | null, secondRate?: number | null, thirdDestination?: string | null, thirdRate?: number | null, name: string } | null, currentMessage?: (
      { __typename?: 'SignMessage' }
      & SignMessageFragment
    ) | null, rate?: { __typename?: 'PricingRate', name: string } | null } };

export type TravelTimeFragment = { __typename?: 'TravelTime', incrementalReportedTime: number, maximumReportedDelay: number, minimumReportedDelay: number, maximumReportedTime: number, minimumReportedTime: number, communicationState?: CommunicationState | null, associatedSigns: Array<string>, pollingEnabled: boolean, externalCenter?: string | null, reportedTime?: number | null, smoothedTime?: number | null, historicTime?: number | null, lastConnect?: any | null, description?: string | null, travelTime?: number | null, geometry?: any | null, distance?: number | null, quality?: TravelTimeDataQuality | null, speed?: number | null, name: string, id: string, parts: Array<{ __typename?: 'TravelTimePart', startReference: number, endReference: number, direction: Direction, road: string }> };

export type TravelTimeHistoryFragment = { __typename?: 'TravelTimeHistory', historicSpeed?: number | null, reportedTime?: number | null, smoothedTime?: number | null, historicTime?: number | null, travelTime?: number | null, timestamp: any, quality?: TravelTimeDataQuality | null, speed?: number | null, id: string };

export type SignDisplayTypesFragment = { __typename?: 'SignDisplayType', matrixType: SignMatrixType, characterWidth?: number | null, characterHeight?: number | null, defaultFont?: string | null, maxCharacters?: number | null, height: number, width: number, hash: string, maxLines?: number | null, characterLabels?: Array<{ __typename?: 'SignCharacterLabel', characterIndex: number, label: string }> | null };

export type TravelTimeMapEntityFragment = { __typename?: 'TravelTime', incrementalReportedTime: number, maximumReportedDelay: number, minimumReportedDelay: number, maximumReportedTime: number, minimumReportedTime: number, communicationState?: CommunicationState | null, reportedTime?: number | null, smoothedTime?: number | null, historicTime?: number | null, lastConnect?: any | null, travelTime?: number | null, geometry?: any | null, distance?: number | null, quality?: TravelTimeDataQuality | null, speed?: number | null, name: string, id: string, parts: Array<{ __typename?: 'TravelTimePart', startReference: number, endReference: number, direction: Direction, road: string }> };

export type TravelTimeSegmentPollMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TravelTimeSegmentPollMutation = { __typename?: 'Mutation', travelTimeSegmentPoll: Array<{ __typename?: 'JobRequest', success: boolean }> };

export type TravelTimeListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  searchFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TravelTimeListQuery = { __typename?: 'Query', travelTimes: { __typename?: 'TravelTimeConnection', totalCount: number, edges: Array<{ __typename?: 'TravelTimeConnectionEdge', node: (
        { __typename?: 'TravelTime' }
        & TravelTimeFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TravelTimeHistoryListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TravelTimeHistoryListQuery = { __typename?: 'Query', travelTimeHistory: { __typename?: 'TravelTimeHistoryConnection', totalCount: number, edges: Array<{ __typename?: 'TravelTimeHistoryConnectionEdge', node: (
        { __typename?: 'TravelTimeHistory' }
        & TravelTimeHistoryFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TravelTimeDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TravelTimeDetailQuery = { __typename?: 'Query', travelTime: (
    { __typename?: 'TravelTime' }
    & TravelTimeFragment
  ) };

export type TravelTimeUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TravelTimeUpdatedSubscription = { __typename?: 'Subscription', travelTimeUpdated: (
    { __typename?: 'TravelTime' }
    & TravelTimeFragment
  ) };

export type TravelTimeSelectionQueryVariables = Exact<{
  id: Scalars['Object'];
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type TravelTimeSelectionQuery = { __typename?: 'Query', travelTimes: { __typename?: 'TravelTimeConnection', edges: Array<{ __typename?: 'TravelTimeConnectionEdge', node: { __typename?: 'TravelTime', id: string, name: string } }> } };

export type TravelTimeSelectionOptionsQueryVariables = Exact<{
  ids: Scalars['Object'];
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type TravelTimeSelectionOptionsQuery = { __typename?: 'Query', travelTimes: { __typename?: 'TravelTimeConnection', edges: Array<{ __typename?: 'TravelTimeConnectionEdge', node: { __typename?: 'TravelTime', id: string, name: string } }> } };

export type SignSelectionQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters: Array<FilterInput> | FilterInput;
}>;


export type SignSelectionQuery = { __typename?: 'Query', signs: { __typename?: 'SignConnection', totalCount: number, edges: Array<{ __typename?: 'SignConnectionEdge', node: { __typename?: 'Sign', id: string, name: string, capabilities: Array<SignCapability>, travelTimeSegments: Array<string> } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type TravelTimeActivityLogAddedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  module?: InputMaybe<KineticModule>;
}>;


export type TravelTimeActivityLogAddedSubscription = { __typename?: 'Subscription', addedActivityLog: (
    { __typename?: 'ActivityLog' }
    & ActivityLogNodeFragmentFragment
  ) };

export type TravelTimeSummaryQueryVariables = Exact<{
  filtersZero?: InputMaybe<Array<FilterInput> | FilterInput>;
  filtersOne?: InputMaybe<Array<FilterInput> | FilterInput>;
  filtersTwo?: InputMaybe<Array<FilterInput> | FilterInput>;
  filtersThree?: InputMaybe<Array<FilterInput> | FilterInput>;
  filtersFour?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type TravelTimeSummaryQuery = { __typename?: 'Query', zero: { __typename?: 'TravelTimeConnection', totalCount: number }, one: { __typename?: 'TravelTimeConnection', totalCount: number }, two: { __typename?: 'TravelTimeConnection', totalCount: number }, three: { __typename?: 'TravelTimeConnection', totalCount: number }, four: { __typename?: 'TravelTimeConnection', totalCount: number } };

export type TravelTimeMapEntitiesQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TravelTimeMapEntitiesQuery = { __typename?: 'Query', travelTimes: { __typename?: 'TravelTimeConnection', totalCount: number, edges: Array<{ __typename?: 'TravelTimeConnectionEdge', node: (
        { __typename?: 'TravelTime' }
        & TravelTimeMapEntityFragment
      ) }> } };

export type TravelTimeUpdatedShortSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TravelTimeUpdatedShortSubscription = { __typename?: 'Subscription', travelTimeUpdated: { __typename?: 'TravelTime', id: string } };

export type TravelTimeNameQueryVariables = Exact<{
  filters: Array<FilterInput> | FilterInput;
  limit: Scalars['Int'];
}>;


export type TravelTimeNameQuery = { __typename?: 'Query', travelTimes: { __typename?: 'TravelTimeConnection', edges: Array<{ __typename?: 'TravelTimeConnectionEdge', node: { __typename?: 'TravelTime', id: string, name: string } }> } };

export type TravelTimeNamesQueryVariables = Exact<{
  limit: Scalars['Int'];
}>;


export type TravelTimeNamesQuery = { __typename?: 'Query', travelTimes: { __typename?: 'TravelTimeConnection', edges: Array<{ __typename?: 'TravelTimeConnectionEdge', node: { __typename?: 'TravelTime', id: string, name: string } }> } };

export type TravelTimeAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type TravelTimeAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string } }> } };

export type TravelTimeModuleSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TravelTimeModuleSettingsQuery = { __typename?: 'Query', travelTimeModuleSettings: { __typename: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename: 'ModuleFormSection', name: string, id: string, fields: Array<{ __typename: 'FieldConfig', id: string, name: string, label: string, type: string, required?: boolean | null, hint?: string | null, sourceId?: string | null, defaultValue?: any | null, loading?: boolean | null, showInput?: boolean | null, step?: number | null, max?: number | null, min?: number | null, useStepper?: boolean | null, options?: Array<{ __typename: 'FieldConfigOption', label?: string | null, value?: any | null } | null> | null } | null> }> } };

export type GetTravelTimeDelaySummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTravelTimeDelaySummaryQuery = { __typename?: 'Query', travelTimeDelaySummary: Array<{ __typename?: 'TravelTimeDelaySummary', id: string, count: number, startRange?: string | null, endRange?: string | null, color: string }> };

export type TunnelListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TunnelListQuery = { __typename?: 'Query', corridors: { __typename?: 'CorridorConnection', totalCount: number, edges: Array<{ __typename?: 'CorridorConnectionEdge', node: { __typename?: 'Corridor', activationType: CorridorActivationType, description?: string | null, deviceTypes: Array<CorridorDeviceType>, name: string, id: string } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type LiveTunnelListSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type LiveTunnelListSubscription = { __typename?: 'Subscription', corridorUpdated: { __typename?: 'Corridor', activationType: CorridorActivationType, description?: string | null, deviceTypes: Array<CorridorDeviceType>, name: string, id: string } };

export type TunnelMapListQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TunnelMapListQuery = { __typename?: 'Query', corridors: { __typename?: 'CorridorConnection', edges: Array<{ __typename?: 'CorridorConnectionEdge', node: { __typename?: 'Corridor', geometry: any, name: string, id: string, settings: any } }> } };

export type TunnelMapQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TunnelMapQuery = { __typename?: 'Query', corridor: { __typename?: 'Corridor', geometry: any, name: string, id: string } };

export type TunnelFanAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type TunnelFanAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string, displayName: string } }> } };

export type SharedPrivilegeAssignmentFragmentFragment = { __typename?: 'KineticPrivilegeAssignment', id: string, privilegeType: PrivilegeType, kineticModule: KineticModule, restrictedIntegrationGroups: Array<string>, restrictedIntegrations: Array<string>, restrictedAreas: Array<any>, restrictedEntities?: any | null };

export type SharedKineticUserFragmentFragment = { __typename?: 'OrganizationKineticUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumbers: Array<string>, roleIds: Array<string>, userGroupIds: Array<string>, privilegeAssignmentList: Array<(
    { __typename?: 'KineticPrivilegeAssignment' }
    & SharedPrivilegeAssignmentFragmentFragment
  )> };

export type RemoveUserPictureMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveUserPictureMutation = { __typename?: 'Mutation', removeUserPicture?: boolean | null };

export type EffectivePrivilegesQueryVariables = Exact<{ [key: string]: never; }>;


export type EffectivePrivilegesQuery = { __typename?: 'Query', effectivePrivileges: Array<{ __typename?: 'KineticEffectivePrivilegeAssignment', id: string, privilegeType: PrivilegeType, kineticModule: KineticModule, restrictedIntegrations: Array<string>, restrictedIntegrationGroups?: Array<string> | null, restrictedAreas: Array<any>, restrictedEntities?: any | null, restrictedLocationGroups?: Array<string> | null, restrictedLocations?: Array<string> | null }> };

export type EffectivePrivilegesUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type EffectivePrivilegesUpdatedSubscription = { __typename?: 'Subscription', effectivePrivilegesUpdated?: Array<{ __typename?: 'KineticEffectivePrivilegeAssignment', id: string, privilegeType: PrivilegeType, kineticModule: KineticModule, restrictedIntegrations: Array<string>, restrictedIntegrationGroups?: Array<string> | null, restrictedAreas: Array<any>, restrictedEntities?: any | null } | null> | null };

export type UserSignalPrivilegesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSignalPrivilegesQuery = { __typename?: 'Query', userSignalPrivileges: Array<{ __typename?: 'SignalPrivilege', privilegeType: PrivilegeType, restrictions: any, lastUpdated: number }> };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'KineticUserConnection', edges: Array<{ __typename?: 'KineticUserConnectionEdge', node: { __typename?: 'OrganizationKineticUser', id: string, firstName?: string | null, lastName?: string | null } }> } };

export type GetUsersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'KineticUserConnection', edges: Array<{ __typename?: 'KineticUserConnectionEdge', node: { __typename?: 'OrganizationKineticUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetBasicUserGroupsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetBasicUserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'KineticUserGroup', id: string, name: string }> };

export type BasicUserGroupsUpdatedSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BasicUserGroupsUpdatedSubscription = { __typename?: 'Subscription', userGroupsUpdated?: { __typename?: 'KineticUserGroup', id: string, name: string } | null };

export type CommentUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CommentUserQuery = { __typename?: 'Query', getKineticUser?: { __typename?: 'OrganizationKineticUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumbers: Array<string>, roleIds: Array<string> } | null };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', getKineticUser?: { __typename?: 'OrganizationKineticUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumbers: Array<string>, roleIds: Array<string>, userGroupIds: Array<string> } | null };

export type AllRoleNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRoleNamesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'KineticRole', id: string, name: string }> };

export type VideoAlarmConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type VideoAlarmConfigsQuery = { __typename?: 'Query', alarmConfigs: { __typename?: 'AlarmConfigsConnection', edges: Array<{ __typename?: 'AlarmConfigsConnectionEdge', node: { __typename?: 'AlarmConfig', id: string, name: string } }> } };

export type CameraNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type CameraNamesQuery = { __typename?: 'Query', cameras: { __typename?: 'CameraConnection', edges: Array<{ __typename?: 'CameraConnectionEdge', node: { __typename?: 'Camera', id: string, name: string } }> } };

export type CameraSubGroupFragment = { __typename?: 'SubGroup', name: string, items: Array<{ __typename?: 'GroupItem', id: string, name: string, type: VideoItemType }> };

export type CameraSubGroupRecursiveFragment = { __typename?: 'CameraGroup', subGroups: Array<(
    { __typename?: 'SubGroup', subGroups: Array<(
      { __typename?: 'SubGroup', subGroups: Array<(
        { __typename?: 'SubGroup', subGroups: Array<(
          { __typename?: 'SubGroup', subGroups: Array<(
            { __typename?: 'SubGroup' }
            & CameraSubGroupFragment
          )> }
          & CameraSubGroupFragment
        )> }
        & CameraSubGroupFragment
      )> }
      & CameraSubGroupFragment
    )> }
    & CameraSubGroupFragment
  )> };

export type CameraGroupFragmentFragment = (
  { __typename?: 'CameraGroup', id: string, name: string, description?: string | null, order?: number | null, items: Array<{ __typename?: 'GroupItem', id: string, name: string, type: VideoItemType }> }
  & CameraSubGroupRecursiveFragment
);

export type CameraListNodeFragmentFragment = { __typename?: 'Camera', id: string, name: string, description?: string | null, autoIrisEnabled?: boolean | null, autoPanEnabled?: boolean | null, autoFocusEnabled?: boolean | null, road?: string | null, direction?: string | null, referencePoint?: string | null, location?: any | null, locationFixed?: boolean | null, locationDescription?: string | null, userNotes?: string | null, communicationStatus?: CommunicationState | null, poweredOn?: boolean | null, firmware?: string | null, dataReceived?: any | null, lastSuccessfulPoll?: any | null, lastPollAttempt?: any | null, timeDrift?: number | null, communicationParameters?: any | null, liveRecordings?: Array<{ __typename?: 'VideoRecord', id: string, recordingName?: string | null, recordingType: RecordingType }> | null };

export type CameraNodeFragmentFragment = { __typename?: 'Camera', id: string, name: string, communicationStatus?: CommunicationState | null, poweredOn?: boolean | null, road?: string | null, direction?: string | null, description?: string | null, locationDescription?: string | null, userNotes?: string | null, referencePoint?: string | null, capabilitiesState: any, communicationParameters?: any | null, presets?: Array<{ __typename?: 'Preset', id: string, name: string, presetIndex: number, isHomePreset?: boolean | null, isSystem: boolean } | null> | null, ptzLock: { __typename?: 'PTZLockInfo', isLocked?: boolean | null, requireExplicitCameraControlLocking?: boolean | null, userId?: string | null, fullName?: string | null, lockStartedAt?: any | null, lockEndsAt?: any | null, lastUsedTime?: any | null }, streams?: Array<{ __typename?: 'VideoStream', name: string, url: string, accessType?: VideoStreamAccessType | null, application?: string | null, streamName?: string | null, streamType: string } | null> | null, capabilities?: Array<{ __typename?: 'CameraCapabilityDto', capability: CameraCapability, options?: Array<string | null> | null }> | null };

export type TourListNodeFragmentFragment = { __typename?: 'Tour', id: string, name: string, description?: string | null, speed?: number | null, heartBeatIntervalSeconds?: number | null, steps: Array<{ __typename?: 'TourStep', camera: { __typename?: 'TourCamera', id: string, name: string, camera: (
        { __typename?: 'Camera' }
        & CameraNodeFragmentFragment
      ) }, preset?: { __typename?: 'TourPreset', id: string, name: string } | null }> };

export type CreatedJobRequestFragment = { __typename?: 'JobRequest', success: boolean, requestId?: string | null, id: string, failure?: string | null };

export type LayoutAreaFragment = { __typename?: 'LayoutArea', columns: number, rows: number, areaId?: string | null, disabled?: boolean | null };

export type LayoutFragment = { __typename?: 'Layout', id: string, name: string, description?: string | null, areas: Array<(
    { __typename?: 'LayoutArea' }
    & LayoutAreaFragment
  )> };

export type WidgetFragment = { __typename?: 'Widget', id: string, name: string, type: WidgetType, properties: any };

export type ScreenFragment = { __typename?: 'Screen', id: string, name: string, description?: string | null, ownershipType: OwnershipType, orderNum?: number | null, type?: ScreenType | null, videoWallId?: string | null, layout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ), content: Array<(
    { __typename?: 'Camera' }
    & CameraListNodeFragmentFragment
  ) | (
    { __typename?: 'Tour' }
    & TourListNodeFragmentFragment
  ) | (
    { __typename?: 'Widget' }
    & WidgetFragment
  ) | null> };

export type SceneFragment = { __typename?: 'Scene', id: string, name: string, ownershipType: OwnershipType, layout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ), content: Array<(
    { __typename?: 'Camera' }
    & CameraListNodeFragmentFragment
  ) | (
    { __typename?: 'Tour' }
    & TourListNodeFragmentFragment
  ) | (
    { __typename?: 'Widget' }
    & WidgetFragment
  ) | null> };

export type SettingFieldsFragment = { __typename?: 'FieldConfig', id: string, name: string, label: string, type: string, required?: boolean | null, help?: string | null, hint?: string | null, fieldSize?: string | null, sortOrder?: string | null, disablePast?: boolean | null, disableFuture?: boolean | null, useStepper?: boolean | null, max?: number | null, min?: number | null, step?: number | null, multiple?: boolean | null, limitTags?: number | null, selectAllLabel?: string | null, deselectAllLabel?: string | null, useCheckedIcon?: boolean | null, useIcon?: boolean | null, choicesTitle?: string | null, chosenTitle?: string | null, defaultValue?: any | null, format?: string | null, displayFormat?: string | null, activeLogic?: any | null, requiredLogic?: any | null, rows?: number | null, multiline?: boolean | null, options?: Array<{ __typename?: 'FieldConfigOption', label?: string | null, value?: any | null } | null> | null };

export type SettingSectionsFragment = { __typename?: 'ModuleFormSection', id: string, name: string, fields: Array<(
    { __typename?: 'FieldConfig' }
    & SettingFieldsFragment
  ) | null> };

type VideoSettingViews_DetectorReportConfigFormView_Fragment = { __typename?: 'DetectorReportConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'DetectorReportConfigFormSection' }> };

type VideoSettingViews_IntegrationConfigFormView_Fragment = { __typename?: 'IntegrationConfigFormView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'IntegrationConfigFormSection' }> };

type VideoSettingViews_IntegrationStateView_Fragment = { __typename?: 'IntegrationStateView', id: string, name: string, type: FormViewType, sections: Array<{ __typename?: 'IntegrationStateSection' }> };

type VideoSettingViews_ModuleSettingsFormView_Fragment = { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, sections: Array<(
    { __typename?: 'ModuleFormSection' }
    & SettingSectionsFragment
  )> };

export type VideoSettingViewsFragment = VideoSettingViews_DetectorReportConfigFormView_Fragment | VideoSettingViews_IntegrationConfigFormView_Fragment | VideoSettingViews_IntegrationStateView_Fragment | VideoSettingViews_ModuleSettingsFormView_Fragment;

type VideoSettingViewsRecursive_DetectorReportConfigFormView_Fragment = { __typename?: 'DetectorReportConfigFormView', views: Array<(
    { __typename?: 'DetectorReportConfigFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & VideoSettingViews_DetectorReportConfigFormView_Fragment
      )> }
      & VideoSettingViews_DetectorReportConfigFormView_Fragment
    )> }
    & VideoSettingViews_DetectorReportConfigFormView_Fragment
  )> };

type VideoSettingViewsRecursive_IntegrationConfigFormView_Fragment = { __typename?: 'IntegrationConfigFormView', views: Array<(
    { __typename?: 'IntegrationConfigFormView', views: Array<(
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & VideoSettingViews_IntegrationConfigFormView_Fragment
      )> }
      & VideoSettingViews_IntegrationConfigFormView_Fragment
    )> }
    & VideoSettingViews_IntegrationConfigFormView_Fragment
  )> };

type VideoSettingViewsRecursive_IntegrationStateView_Fragment = { __typename?: 'IntegrationStateView', views: Array<(
    { __typename?: 'IntegrationStateView', views: Array<(
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & VideoSettingViews_IntegrationStateView_Fragment
      )> }
      & VideoSettingViews_IntegrationStateView_Fragment
    )> }
    & VideoSettingViews_IntegrationStateView_Fragment
  )> };

type VideoSettingViewsRecursive_ModuleSettingsFormView_Fragment = { __typename?: 'ModuleSettingsFormView', views: Array<(
    { __typename?: 'DetectorReportConfigFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & VideoSettingViews_DetectorReportConfigFormView_Fragment
      )> }
      & VideoSettingViews_DetectorReportConfigFormView_Fragment
    )> }
    & VideoSettingViews_DetectorReportConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationConfigFormView', views: Array<(
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & VideoSettingViews_IntegrationConfigFormView_Fragment
      )> }
      & VideoSettingViews_IntegrationConfigFormView_Fragment
    )> }
    & VideoSettingViews_IntegrationConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationStateView', views: Array<(
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & VideoSettingViews_IntegrationStateView_Fragment
      )> }
      & VideoSettingViews_IntegrationStateView_Fragment
    )> }
    & VideoSettingViews_IntegrationStateView_Fragment
  ) | (
    { __typename?: 'ModuleSettingsFormView', views: Array<(
      { __typename?: 'DetectorReportConfigFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & VideoSettingViews_DetectorReportConfigFormView_Fragment
      )> }
      & VideoSettingViews_DetectorReportConfigFormView_Fragment
    ) | (
      { __typename?: 'IntegrationConfigFormView', views: Array<(
        { __typename?: 'IntegrationConfigFormView' }
        & VideoSettingViews_IntegrationConfigFormView_Fragment
      )> }
      & VideoSettingViews_IntegrationConfigFormView_Fragment
    ) | (
      { __typename?: 'IntegrationStateView', views: Array<(
        { __typename?: 'IntegrationStateView' }
        & VideoSettingViews_IntegrationStateView_Fragment
      )> }
      & VideoSettingViews_IntegrationStateView_Fragment
    ) | (
      { __typename?: 'ModuleSettingsFormView', views: Array<(
        { __typename?: 'DetectorReportConfigFormView' }
        & VideoSettingViews_DetectorReportConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationConfigFormView' }
        & VideoSettingViews_IntegrationConfigFormView_Fragment
      ) | (
        { __typename?: 'IntegrationStateView' }
        & VideoSettingViews_IntegrationStateView_Fragment
      ) | (
        { __typename?: 'ModuleSettingsFormView' }
        & VideoSettingViews_ModuleSettingsFormView_Fragment
      )> }
      & VideoSettingViews_ModuleSettingsFormView_Fragment
    )> }
    & VideoSettingViews_ModuleSettingsFormView_Fragment
  )> };

export type VideoSettingViewsRecursiveFragment = VideoSettingViewsRecursive_DetectorReportConfigFormView_Fragment | VideoSettingViewsRecursive_IntegrationConfigFormView_Fragment | VideoSettingViewsRecursive_IntegrationStateView_Fragment | VideoSettingViewsRecursive_ModuleSettingsFormView_Fragment;

export type VideoFormFragment = { __typename?: 'ModuleSettingsFormView', id: string, name: string, type: FormViewType, views: Array<(
    { __typename?: 'DetectorReportConfigFormView' }
    & VideoSettingViewsRecursive_DetectorReportConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationConfigFormView' }
    & VideoSettingViewsRecursive_IntegrationConfigFormView_Fragment
  ) | (
    { __typename?: 'IntegrationStateView' }
    & VideoSettingViewsRecursive_IntegrationStateView_Fragment
  ) | (
    { __typename?: 'ModuleSettingsFormView' }
    & VideoSettingViewsRecursive_ModuleSettingsFormView_Fragment
  )>, sections: Array<(
    { __typename?: 'ModuleFormSection' }
    & SettingSectionsFragment
  )> };

export type CameraLocationInfoFragmentFragment = { __typename?: 'Camera', location?: any | null, road?: string | null, direction?: string | null, referencePoint?: string | null, locationDescription?: string | null };

export type ToursFieldsFragment = { __typename?: 'Tour', id: string, name: string, description?: string | null, isSystem: boolean };

export type VideoRecordNodeFragmentFragment = { __typename?: 'VideoRecord', id: string, recorderId: string, recorderName: string, recordingStart: any, recordingEnd: any, recordingType: RecordingType, recordingInitiatorId?: string | null, recordingInitiatedBy: RecordingInitiatedBy, recordingInitiatorProperties?: any | null, recordingDuration?: number | null, cameraId: string, cameraName: string, recordingName?: string | null, streamUrl: string, serverFileName?: string | null, recorderType?: string | null, size?: number | null, redundancyEnabled?: boolean | null, secondaryServer?: boolean | null, camera?: (
    { __typename?: 'Camera' }
    & CameraLocationInfoFragmentFragment
  ) | null };

export type SnapshotNodeFragmentFragment = { __typename?: 'Snapshot', id: string, path: string, size?: number | null, module: KineticModule, key: string, serverFileName: string, timestamp?: any | null, camera?: { __typename?: 'Camera', id: string, name: string } | null };

export type CameraTaskFragmentFragment = { __typename?: 'Task', id: string, name: string, taskType: TaskType, timezone?: string | null, start: any, end: any, data: any, taskRecurrenceType: TaskRecurrenceType, rrule?: string | null, recurrenceEndDate?: any | null, externalCenterId?: string | null };

export type CameraTaskOccurrenceFragmentFragment = { __typename?: 'TaskOccurrence', start: any, end: any, task: (
    { __typename?: 'Task' }
    & CameraTaskFragmentFragment
  ) };

export type VideoStreamBlockFragment = { __typename?: 'VideoStreamBlock', id: string, cameraId?: string | null, streamName?: string | null, endsAt?: any | null, duration?: string | null, tags?: Array<string> | null, associatedEventIds?: Array<string> | null, reason?: string | null, serverConfirmed?: boolean | null, blockedUntil?: any | null };

export type DeleteCameraGroupsMutationVariables = Exact<{
  groups: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteCameraGroupsMutation = { __typename?: 'Mutation', deleteCameraGroups: boolean };

export type DeleteToursMutationVariables = Exact<{
  tours: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteToursMutation = { __typename?: 'Mutation', deleteTours: boolean };

export type CameraGoToPresetMutationVariables = Exact<{
  cameraId: Scalars['String'];
  presetId: Scalars['String'];
}>;


export type CameraGoToPresetMutation = { __typename?: 'Mutation', gotoPreset?: (
    { __typename?: 'JobRequest' }
    & CreatedJobRequestFragment
  ) | null };

export type DeleteScreensMutationVariables = Exact<{
  screens: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteScreensMutation = { __typename?: 'Mutation', deleteScreens: boolean };

export type DeleteScenesMutationVariables = Exact<{
  scenes: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteScenesMutation = { __typename?: 'Mutation', deleteScenes: boolean };

export type SaveSceneMutationVariables = Exact<{
  input: SceneInput;
}>;


export type SaveSceneMutation = { __typename?: 'Mutation', saveScene?: (
    { __typename?: 'Scene' }
    & SceneFragment
  ) | null };

export type TourHeartBeatMutationVariables = Exact<{
  tourId: Scalars['ID'];
}>;


export type TourHeartBeatMutation = { __typename?: 'Mutation', tourHeartBeat: boolean };

export type DeletePresetsMutationVariables = Exact<{
  presets: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeletePresetsMutation = { __typename?: 'Mutation', deletePresets: boolean };

export type SavePresetMutationVariables = Exact<{
  input: PresetInput;
}>;


export type SavePresetMutation = { __typename?: 'Mutation', savePreset?: { __typename?: 'Preset', id: string, presetIndex: number, name: string } | null };

export type SaveCameraPresetMutationVariables = Exact<{
  id: Scalars['String'];
  presetId: Scalars['String'];
  presetNumber: Scalars['Int'];
}>;


export type SaveCameraPresetMutation = { __typename?: 'Mutation', saveCameraPreset?: { __typename?: 'JobRequest', id: string, success: boolean, requestId?: string | null, failure?: string | null } | null };

export type UseCameraCapabilityMutationVariables = Exact<{
  cameraId: Scalars['ID'];
  capability: CameraCapability;
  option: Scalars['String'];
}>;


export type UseCameraCapabilityMutation = { __typename?: 'Mutation', useCameraCapability?: { __typename?: 'JobRequest', success: boolean } | null };

export type EnableCameraAutoFocusMutationVariables = Exact<{
  cameraAutoFocusInput: CameraAutoFocusInput;
}>;


export type EnableCameraAutoFocusMutation = { __typename?: 'Mutation', enableCameraAutoFocus?: (
    { __typename?: 'JobRequest' }
    & CreatedJobRequestFragment
  ) | null };

export type EnableCameraAutoIrisMutationVariables = Exact<{
  cameraAutoIrisInput: CameraAutoIrisInput;
}>;


export type EnableCameraAutoIrisMutation = { __typename?: 'Mutation', enableCameraAutoIris?: (
    { __typename?: 'JobRequest' }
    & CreatedJobRequestFragment
  ) | null };

export type FocusCameraMutationVariables = Exact<{
  cameraFocusInput: CameraFocusInput;
}>;


export type FocusCameraMutation = { __typename?: 'Mutation', focusCamera?: (
    { __typename?: 'JobRequest' }
    & CreatedJobRequestFragment
  ) | null };

export type IrisCameraMutationVariables = Exact<{
  cameraIrisInput: CameraIrisInput;
}>;


export type IrisCameraMutation = { __typename?: 'Mutation', irisCamera?: (
    { __typename?: 'JobRequest' }
    & CreatedJobRequestFragment
  ) | null };

export type ChangeTourStateMutationVariables = Exact<{
  tourId: Scalars['ID'];
  paused?: InputMaybe<Scalars['Boolean']>;
}>;


export type ChangeTourStateMutation = { __typename?: 'Mutation', changeTourState: boolean };

export type SaveVideoModuleSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type SaveVideoModuleSettingsMutation = { __typename?: 'Mutation', saveVideoModuleSettings?: boolean | null };

export type CameraExplicitLockMutationVariables = Exact<{
  cameraId: Scalars['ID'];
}>;


export type CameraExplicitLockMutation = { __typename?: 'Mutation', cameraExplicitLock?: boolean | null };

export type UnlockPtzCameraMutationVariables = Exact<{
  cameraId: Scalars['ID'];
}>;


export type UnlockPtzCameraMutation = { __typename?: 'Mutation', unlockPTZCamera?: boolean | null };

export type CameraRecordingMutationVariables = Exact<{
  cameraId: Scalars['String'];
  streamRecorderId: Scalars['String'];
  streamAccessType: VideoStreamAccessType;
  recordingType?: InputMaybe<RecordingType>;
  start: Scalars['Boolean'];
  recordingName: Scalars['String'];
}>;


export type CameraRecordingMutation = { __typename?: 'Mutation', cameraRecording?: (
    { __typename?: 'JobRequest' }
    & CreatedJobRequestFragment
  ) | null };

export type DeleteRecordingsMutationVariables = Exact<{
  videoRecords: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteRecordingsMutation = { __typename?: 'Mutation', deleteRecordings: boolean };

export type SaveTourMutationVariables = Exact<{
  input: TourInput;
}>;


export type SaveTourMutation = { __typename?: 'Mutation', saveTour: (
    { __typename?: 'Tour' }
    & TourListNodeFragmentFragment
  ) };

export type SaveScreenMutationVariables = Exact<{
  input: ScreenInput;
}>;


export type SaveScreenMutation = { __typename?: 'Mutation', saveScreen?: (
    { __typename?: 'Screen' }
    & ScreenFragment
  ) | null };

export type ReorderScreensMutationVariables = Exact<{
  screens: Array<ScreenOrderInput> | ScreenOrderInput;
}>;


export type ReorderScreensMutation = { __typename?: 'Mutation', reorderScreens?: boolean | null };

export type ReorderCameraGroupsMutationVariables = Exact<{
  groups: Array<CameraGroupOrderInput> | CameraGroupOrderInput;
}>;


export type ReorderCameraGroupsMutation = { __typename?: 'Mutation', reorderCameraGroups?: boolean | null };

export type PanTiltCameraMutationVariables = Exact<{
  cameraPanTiltInput: CameraPanTiltInput;
}>;


export type PanTiltCameraMutation = { __typename?: 'Mutation', panTiltCamera?: { __typename?: 'JobRequest', success: boolean } | null };

export type CameraZoomMutationVariables = Exact<{
  cameraZoomInput: CameraZoomInput;
}>;


export type CameraZoomMutation = { __typename?: 'Mutation', zoomCamera?: { __typename?: 'JobRequest', success: boolean } | null };

export type CameraPublicFeedMutationVariables = Exact<{
  cameraPublicFeedInput: CameraPublicFeedInput;
}>;


export type CameraPublicFeedMutation = { __typename?: 'Mutation', cameraPublicFeed?: { __typename?: 'JobRequest', success: boolean } | null };

export type SetAsHomePresetMutationVariables = Exact<{
  homePresetInput: HomePresetInput;
}>;


export type SetAsHomePresetMutation = { __typename?: 'Mutation', setAsHomePreset?: { __typename?: 'Preset', id: string, presetIndex: number, name: string, isHomePreset?: boolean | null } | null };

export type SaveCameraGroupMutationVariables = Exact<{
  input: CameraGroupInput;
}>;


export type SaveCameraGroupMutation = { __typename?: 'Mutation', saveCameraGroup?: (
    { __typename?: 'CameraGroup' }
    & CameraGroupFragmentFragment
  ) | null };

export type SaveWidgetMutationVariables = Exact<{
  input: WidgetInput;
}>;


export type SaveWidgetMutation = { __typename?: 'Mutation', saveWidget?: (
    { __typename?: 'Widget' }
    & WidgetFragment
  ) | null };

export type DeleteWidgetsMutationVariables = Exact<{
  widgets: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteWidgetsMutation = { __typename?: 'Mutation', deleteWidgets: boolean };

export type DeleteVideoTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type DeleteVideoTaskMutation = { __typename?: 'Mutation', deleteVideoTask: boolean };

export type SaveVideoTaskMutationVariables = Exact<{
  input: TaskInput;
}>;


export type SaveVideoTaskMutation = { __typename?: 'Mutation', saveTask?: (
    { __typename?: 'Task' }
    & CameraTaskFragmentFragment
  ) | null };

export type GenerateRecordingTokenUrlMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GenerateRecordingTokenUrlMutation = { __typename?: 'Mutation', generateRecordingTokenURL: string };

export type BlockVideoStreamMutationVariables = Exact<{
  input: BlockVideoStreamInput;
}>;


export type BlockVideoStreamMutation = { __typename?: 'Mutation', blockVideoStream: Array<(
    { __typename?: 'VideoStreamBlock' }
    & VideoStreamBlockFragment
  )> };

export type UnblockVideoStreamMutationVariables = Exact<{
  input: UnblockVideoStreamInput;
}>;


export type UnblockVideoStreamMutation = { __typename?: 'Mutation', unblockVideoStream: boolean };

export type SetActiveHardwareScreenMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SetActiveHardwareScreenMutation = { __typename?: 'Mutation', setActiveHardwareScreen: boolean };

export type UpdateCameraDetectionStatusMutationVariables = Exact<{
  cameraId: Scalars['ID'];
  enable: Scalars['Boolean'];
}>;


export type UpdateCameraDetectionStatusMutation = { __typename?: 'Mutation', updateCameraDetectionStatus: { __typename?: 'CameraDetectionStatus', id: string, isSupported?: boolean | null, enabled?: boolean | null } };

export type CameraGroupsQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<CameraGroupSearchField> | CameraGroupSearchField>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<CameraGroupSortField>;
}>;


export type CameraGroupsQuery = { __typename?: 'Query', cameraGroups: Array<(
    { __typename?: 'CameraGroup', id: string, name: string, description?: string | null, order?: number | null, items: Array<{ __typename?: 'GroupItem', id: string, name: string, type: VideoItemType }> }
    & CameraSubGroupRecursiveFragment
  )> };

export type CamerasListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type CamerasListQuery = { __typename?: 'Query', cameras: { __typename?: 'CameraConnection', totalCount: number, edges: Array<{ __typename?: 'CameraConnectionEdge', node: (
        { __typename?: 'Camera' }
        & CameraListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type CameraQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CameraQuery = { __typename?: 'Query', camera?: { __typename?: 'Camera', communicationParameters?: any | null, id: string, name: string, communicationStatus?: CommunicationState | null, poweredOn?: boolean | null, road?: string | null, direction?: string | null, description?: string | null, location?: any | null, locationDescription?: string | null, autoFocusEnabled?: boolean | null, autoIrisEnabled?: boolean | null, userNotes?: string | null, referencePoint?: string | null, publicFeedEnabled?: boolean | null, privateStreamRecordingInProgress?: boolean | null, cameraCategory?: string | null, capabilitiesState: any, presets?: Array<{ __typename?: 'Preset', id: string, name: string, presetIndex: number, isHomePreset?: boolean | null, isSystem: boolean, isSelected?: boolean | null } | null> | null, ptzLock: { __typename?: 'PTZLockInfo', isLocked?: boolean | null, requireExplicitCameraControlLocking?: boolean | null, userId?: string | null, fullName?: string | null, lockStartedAt?: any | null, lockEndsAt?: any | null, lastUsedTime?: any | null }, streams?: Array<{ __typename?: 'VideoStream', name: string, url: string, accessType?: VideoStreamAccessType | null, application?: string | null, streamName?: string | null, streamType: string, streamManager?: string | null, recordingServer?: string | null } | null> | null, tours?: Array<{ __typename?: 'Tour', id: string, name: string } | null> | null, capabilities?: Array<{ __typename?: 'CameraCapabilityDto', capability: CameraCapability, options?: Array<string | null> | null }> | null, liveRecordings?: Array<{ __typename?: 'VideoRecord', id: string, recordingName?: string | null, recordingType: RecordingType }> | null } | null };

export type CameraMapEntityShortQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type CameraMapEntityShortQuery = { __typename?: 'Query', cameraMapEntities: any };

export type ToursQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type ToursQuery = { __typename?: 'Query', tours: { __typename?: 'TourConnection', edges: Array<{ __typename?: 'TourConnectionEdge', node: (
        { __typename?: 'Tour' }
        & TourListNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ToursShortListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type ToursShortListQuery = { __typename?: 'Query', tours: { __typename?: 'TourConnection', totalCount: number, edges: Array<{ __typename?: 'TourConnectionEdge', cursor?: string | null, node: (
        { __typename?: 'Tour' }
        & ToursFieldsFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type ScreensQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<ScreenSearchField> | ScreenSearchField>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type ScreensQuery = { __typename?: 'Query', screens: Array<(
    { __typename?: 'Screen' }
    & ScreenFragment
  )> };

export type ScreensShortListQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<ScreenSearchField> | ScreenSearchField>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type ScreensShortListQuery = { __typename?: 'Query', screens: Array<{ __typename?: 'Screen', id: string, name: string, description?: string | null, orderNum?: number | null, type?: ScreenType | null, videoWallId?: string | null, videoWallDetail?: { __typename?: 'VideoWallDetail', name: string, protocol: string } | null }> };

export type ScreenUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ScreenUpdatedSubscription = { __typename?: 'Subscription', screenUpdated: (
    { __typename?: 'Screen' }
    & ScreenFragment
  ) };

export type VideoWallUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type VideoWallUpdatedSubscription = { __typename?: 'Subscription', videoWallUpdated?: { __typename?: 'VideoWallStreamObject', videoWallObjectType: VideoWallObjectType, streamObjectOperation: StreamObjectOperation, id: string } | null };

export type ScenesQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<SceneSearchField> | SceneSearchField>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<SceneSortField>;
}>;


export type ScenesQuery = { __typename?: 'Query', scenes: Array<(
    { __typename?: 'Scene' }
    & SceneFragment
  )> };

export type WatchTourSubscriptionSubscriptionVariables = Exact<{
  tourId: Scalars['ID'];
}>;


export type WatchTourSubscriptionSubscription = { __typename?: 'Subscription', watchTour: { __typename?: 'WatchedTour', isPaused?: boolean | null, camera: (
      { __typename?: 'Camera' }
      & CameraNodeFragmentFragment
    ), nextCamera: (
      { __typename?: 'Camera' }
      & CameraNodeFragmentFragment
    ) } };

export type UngroupedCamerasToursQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<CameraGroupSearchField> | CameraGroupSearchField>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<CameraGroupSortField>;
}>;


export type UngroupedCamerasToursQuery = { __typename?: 'Query', ungroupedCamerasTours?: { __typename?: 'CameraGroup', items: Array<{ __typename?: 'GroupItem', id: string, name: string, type: VideoItemType }> } | null };

export type TourQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TourQuery = { __typename?: 'Query', tour?: (
    { __typename?: 'Tour' }
    & TourListNodeFragmentFragment
  ) | null };

export type WidgetsQueryVariables = Exact<{
  searchFields?: InputMaybe<Array<WidgetSearchField> | WidgetSearchField>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<WidgetSortField>;
}>;


export type WidgetsQuery = { __typename?: 'Query', widgets: Array<(
    { __typename?: 'Widget' }
    & WidgetFragment
  )> };

export type WidgetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WidgetQuery = { __typename?: 'Query', widget?: (
    { __typename?: 'Widget' }
    & WidgetFragment
  ) | null };

export type WidgetUpdatedSubscriptionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type WidgetUpdatedSubscriptionSubscription = { __typename?: 'Subscription', widgetUpdated: (
    { __typename?: 'Widget' }
    & WidgetFragment
  ) };

export type ScreenUpdatedSubscriptionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ScreenUpdatedSubscriptionSubscription = { __typename?: 'Subscription', screenUpdated: (
    { __typename?: 'Screen' }
    & ScreenFragment
  ) };

export type SceneUpdatedSubscriptionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SceneUpdatedSubscriptionSubscription = { __typename?: 'Subscription', sceneUpdated: (
    { __typename?: 'Scene' }
    & SceneFragment
  ) };

export type CameraUpdatedSubscriptionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CameraUpdatedSubscriptionSubscription = { __typename?: 'Subscription', cameraUpdated: (
    { __typename?: 'Camera' }
    & CameraListNodeFragmentFragment
  ) };

export type TourUpdatedSubscriptionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type TourUpdatedSubscriptionSubscription = { __typename?: 'Subscription', tourUpdated: (
    { __typename?: 'Tour' }
    & TourListNodeFragmentFragment
  ) };

export type CameraGroupUpdatedSubscriptionSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CameraGroupUpdatedSubscriptionSubscription = { __typename?: 'Subscription', cameraGroupUpdated?: (
    { __typename?: 'CameraGroup', id: string, name: string, description?: string | null, items: Array<{ __typename?: 'GroupItem', id: string, name: string, type: VideoItemType }> }
    & CameraSubGroupRecursiveFragment
  ) | null };

export type VideoModuleSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type VideoModuleSettingsQuery = { __typename?: 'Query', videoModuleSettings: (
    { __typename?: 'ModuleSettingsFormView' }
    & VideoFormFragment
  ) };

export type VideoRecordingsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type VideoRecordingsQuery = { __typename?: 'Query', videoRecordings: { __typename?: 'VideoRecordConnection', totalCount: number, edges: Array<{ __typename?: 'VideoRecordConnectionEdge', node: (
        { __typename?: 'VideoRecord' }
        & VideoRecordNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type VideoRecordersQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type VideoRecordersQuery = { __typename?: 'Query', integrations: { __typename?: 'IntegrationConnection', edges: Array<{ __typename?: 'IntegrationConnectionEdge', node: { __typename?: 'Integration', id: string, name: string } }> } };

export type VideoSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type VideoSummaryQuery = { __typename?: 'Query', operational: { __typename?: 'CameraConnection', totalCount: number }, nonoperational: { __typename?: 'CameraConnection', totalCount: number } };

export type SnapshotsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
}>;


export type SnapshotsListQuery = { __typename?: 'Query', snapshots: { __typename?: 'SnapshotsConnection', totalCount: number, edges: Array<{ __typename?: 'SnapshotConnectionEdge', node: (
        { __typename?: 'Snapshot' }
        & SnapshotNodeFragmentFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type SnapshostUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SnapshostUpdatedSubscription = { __typename?: 'Subscription', snapshotsUpdated?: { __typename?: 'SnapshotStreamObject', streamObjectOperation?: StreamObjectOperation | null, dto?: (
      { __typename?: 'Snapshot' }
      & SnapshotNodeFragmentFragment
    ) | null } | null };

export type ActivityLogNamesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  filters: Array<FilterInput> | FilterInput;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type ActivityLogNamesQuery = { __typename?: 'Query', activityLogNames: { __typename?: 'ActivityLogNameConnection', edges: Array<{ __typename?: 'ActivityLogNameEdge', node: { __typename?: 'ActivityLogName', id: string, name: string, integrationType?: string | null } }> } };

export type LayoutsQueryVariables = Exact<{
  videoWallId?: InputMaybe<Scalars['ID']>;
}>;


export type LayoutsQuery = { __typename?: 'Query', layouts: Array<{ __typename?: 'Layout', id: string, name: string, description?: string | null, areas: Array<{ __typename?: 'LayoutArea', columns: number, rows: number, areaId?: string | null, disabled?: boolean | null }> }> };

export type GetPresetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPresetQuery = { __typename?: 'Query', preset?: { __typename?: 'Preset', id: string, presetIndex: number, name: string, isSystem: boolean } | null };

export type CameraFutureTasksQueryVariables = Exact<{
  cameraId: Scalars['String'];
  timezone: Scalars['String'];
}>;


export type CameraFutureTasksQuery = { __typename?: 'Query', cameraFutureTasks: Array<{ __typename?: 'Task', id: string, name: string, start: any, end: any, data: any, rrule?: string | null, taskRecurrenceType: TaskRecurrenceType, taskType: TaskType }> };

export type CameraActivityLogAddedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  module?: InputMaybe<KineticModule>;
}>;


export type CameraActivityLogAddedSubscription = { __typename?: 'Subscription', addedActivityLog: (
    { __typename?: 'ActivityLog' }
    & ActivityLogNodeFragmentFragment
  ) };

export type GetTourQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTourQuery = { __typename?: 'Query', tour?: (
    { __typename?: 'Tour' }
    & TourListNodeFragmentFragment
  ) | null };

export type GetTourInputQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTourInputQuery = { __typename?: 'Query', tour?: { __typename?: 'Tour', id: string, name: string, description?: string | null, speed?: number | null, isSystem: boolean, steps: Array<{ __typename?: 'TourStep', camera: { __typename?: 'TourCamera', id: string, name: string }, preset?: { __typename?: 'TourPreset', id: string, name: string } | null }> } | null };

export type TourStepCamerasQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type TourStepCamerasQuery = { __typename?: 'Query', cameras: { __typename?: 'CameraConnection', totalCount: number, edges: Array<{ __typename?: 'CameraConnectionEdge', node: { __typename?: 'Camera', id: string, name: string, streams?: Array<{ __typename?: 'VideoStream', name: string, accessType?: VideoStreamAccessType | null, url: string, application?: string | null, streamName?: string | null, streamType: string } | null> | null, ptzLock: { __typename?: 'PTZLockInfo', isLocked?: boolean | null }, presets?: Array<{ __typename?: 'Preset', id: string, presetIndex: number, name: string } | null> | null } }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type GetCameraGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCameraGroupQuery = { __typename?: 'Query', cameraGroup?: (
    { __typename?: 'CameraGroup' }
    & CameraGroupFragmentFragment
  ) | null };

export type GetToursQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetToursQuery = { __typename?: 'Query', tours: { __typename?: 'TourConnection', edges: Array<{ __typename?: 'TourConnectionEdge', node: { __typename?: 'Tour', id: string, name: string, description?: string | null, speed?: number | null, steps: Array<{ __typename?: 'TourStep', camera: { __typename?: 'TourCamera', id: string, name: string }, preset?: { __typename?: 'TourPreset', id: string, name: string } | null }> } }> } };

export type GetScreenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetScreenQuery = { __typename?: 'Query', screen?: (
    { __typename?: 'Screen' }
    & ScreenFragment
  ) | null };

export type CameraMapEntitiesIdQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type CameraMapEntitiesIdQuery = { __typename?: 'Query', cameraMapEntityIds: Array<string> };

export type CameraMapEntityFullQueryVariables = Exact<{ [key: string]: never; }>;


export type CameraMapEntityFullQuery = { __typename?: 'Query', cameraMapEntities: any };

export type CameraTaskUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  creation?: InputMaybe<Scalars['Boolean']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
}>;


export type CameraTaskUpdatedSubscription = { __typename?: 'Subscription', taskUpdated: (
    { __typename?: 'Task' }
    & CameraTaskFragmentFragment
  ) };

export type CameraUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CameraUpdatedSubscription = { __typename?: 'Subscription', cameraUpdated: { __typename?: 'Camera', id: string, name: string, presets?: Array<{ __typename?: 'Preset', id: string, name: string, presetIndex: number, isHomePreset?: boolean | null } | null> | null } };

export type GetCameraCapabilitiesQueryVariables = Exact<{
  cameraId: Scalars['ID'];
}>;


export type GetCameraCapabilitiesQuery = { __typename?: 'Query', cameraCapabilities?: Array<{ __typename?: 'CameraCapabilityDto', capability: CameraCapability, options?: Array<string | null> | null }> | null };

export type GetCameraQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCameraQuery = { __typename?: 'Query', camera?: (
    { __typename?: 'Camera' }
    & CameraNodeFragment
  ) | null };

export type GetVideoTasksQueryVariables = Exact<{
  cameraId: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
}>;


export type GetVideoTasksQuery = { __typename?: 'Query', videoTasks?: Array<{ __typename?: 'DateTasks', date: any, tasks?: Array<(
      { __typename?: 'TaskOccurrence' }
      & CameraTaskOccurrenceFragmentFragment
    ) | null> | null }> | null };

export type GetVideoStreamBlockQueryVariables = Exact<{
  cameraId: Scalars['ID'];
}>;


export type GetVideoStreamBlockQuery = { __typename?: 'Query', videoStreamBlocked?: (
    { __typename?: 'VideoStreamBlock' }
    & VideoStreamBlockFragment
  ) | null };

export type VideoStreamBlockUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type VideoStreamBlockUpdatedSubscription = { __typename?: 'Subscription', videoStreamBlockUpdated: (
    { __typename?: 'VideoStreamBlock' }
    & VideoStreamBlockFragment
  ) };

export type VideoStreamUnblockedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type VideoStreamUnblockedSubscription = { __typename?: 'Subscription', videoStreamUnblocked: (
    { __typename?: 'VideoStreamBlock' }
    & VideoStreamBlockFragment
  ) };

export type CameraDetectionStatusQueryVariables = Exact<{
  cameraId: Scalars['ID'];
}>;


export type CameraDetectionStatusQuery = { __typename?: 'Query', cameraDetectionStatus: { __typename?: 'CameraDetectionStatus', id: string, isSupported?: boolean | null, enabled?: boolean | null } };

export type WeatherStationReadingFragment = { __typename?: 'WeatherStationReading', linkAddress: number, category: WeatherSensorCategory, value: any, valid: boolean, units: WeatherUnits, type: WeatherSensorType };

export type WeatherStationListFragment = { __typename?: 'WeatherStation', communicationStatus: CommunicationState, lastDataReceived?: any | null, referencePoint?: number | null, description?: string | null, direction?: string | null, location?: any | null, values: any, road?: string | null, name: string, id: string, communicationParameters?: any | null, externalCenter?: string | null, readings: Array<(
    { __typename?: 'WeatherStationReading' }
    & WeatherStationReadingFragment
  )> };

export type WeatherStationHistoryFragment = { __typename?: 'WeatherStationHistory', linkAddress?: number | null, timestamp: any, category: WeatherSensorCategory, id: string, readings: Array<(
    { __typename?: 'WeatherStationReading' }
    & WeatherStationReadingFragment
  ) | null> };

export type WeatherStationSelectFragment = { __typename?: 'WeatherStation', name: string, id: string };

export type WeatherStationChartHistoryDataFragment = { __typename?: 'WeatherStationChartHistoryData', timestamp: any, value: any };

export type WeatherStationChartHistoryFragment = { __typename?: 'WeatherStationChartHistory', linkAddress: number, type: WeatherSensorType, data: Array<(
    { __typename?: 'WeatherStationChartHistoryData' }
    & WeatherStationChartHistoryDataFragment
  )> };

export type WeatherStationPollMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type WeatherStationPollMutation = { __typename?: 'Mutation', weatherStationPoll: Array<{ __typename?: 'JobRequest', success: boolean, failure?: string | null }> };

export type WeatherStationsListQueryVariables = Exact<{
  sortField?: InputMaybe<WeatherStationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type WeatherStationsListQuery = { __typename?: 'Query', weatherStations: { __typename?: 'WeatherStationConnection', totalCount: number, edges: Array<{ __typename?: 'WeatherStationConnectionEdge', node: (
        { __typename?: 'WeatherStation' }
        & WeatherStationListFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type WeatherStationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WeatherStationQuery = { __typename?: 'Query', weatherStation: (
    { __typename?: 'WeatherStation' }
    & WeatherStationListFragment
  ) };

export type WeatherStationUpdatedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type WeatherStationUpdatedSubscription = { __typename?: 'Subscription', weatherStationUpdated: (
    { __typename?: 'WeatherStation' }
    & WeatherStationListFragment
  ) };

export type WeatherStationRoadsQueryVariables = Exact<{ [key: string]: never; }>;


export type WeatherStationRoadsQuery = { __typename?: 'Query', roads?: Array<string | null> | null };

export type WeatherStationHistoryQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  category?: InputMaybe<WeatherSensorCategory>;
  sortField?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  linkAddress?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}>;


export type WeatherStationHistoryQuery = { __typename?: 'Query', weatherStationHistory: { __typename?: 'WeatherStationHistoryConnection', totalCount: number, edges: Array<{ __typename?: 'WeatherStationHistoryConnectionEdge', node: (
        { __typename?: 'WeatherStationHistory' }
        & WeatherStationHistoryFragment
      ) }>, pageInfo: (
      { __typename?: 'PageInfo' }
      & CursorPageInfoFragment
    ) } };

export type WeatherStationSelectionQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type WeatherStationSelectionQuery = { __typename?: 'Query', weatherStations: { __typename?: 'WeatherStationConnection', edges: Array<{ __typename?: 'WeatherStationConnectionEdge', node: (
        { __typename?: 'WeatherStation' }
        & WeatherStationSelectFragment
      ) }> } };

export type WeatherStationEntityListQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  filters: Array<FilterInput> | FilterInput;
}>;


export type WeatherStationEntityListQuery = { __typename?: 'Query', weatherStations: { __typename?: 'WeatherStationConnection', edges: Array<{ __typename?: 'WeatherStationConnectionEdge', node: { __typename?: 'WeatherStation', id: string } }> } };

export type WeatherStationChartHistoryQueryVariables = Exact<{
  types?: InputMaybe<Array<WeatherSensorType> | WeatherSensorType>;
  weatherStationId: Scalars['ID'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
}>;


export type WeatherStationChartHistoryQuery = { __typename?: 'Query', weatherStationChartHistory: Array<(
    { __typename?: 'WeatherStationChartHistory' }
    & WeatherStationChartHistoryFragment
  )> };

export type WeatherStationActivityLogAddedSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  module?: InputMaybe<KineticModule>;
}>;


export type WeatherStationActivityLogAddedSubscription = { __typename?: 'Subscription', addedActivityLog: (
    { __typename?: 'ActivityLog' }
    & ActivityLogNodeFragmentFragment
  ) };

export type WeatherStationSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type WeatherStationSummaryQuery = { __typename?: 'Query', operationalWeatherStation: { __typename?: 'WeatherStationConnection', totalCount: number }, nonOperationalWeatherStation: { __typename?: 'WeatherStationConnection', totalCount: number } };

export type WeatherStationMapEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type WeatherStationMapEntitiesQuery = { __typename?: 'Query', weatherStationMapEntities: Array<any> };

export const ActivityLogNodeFragmentFragmentDoc = gql`
    fragment ActivityLogNodeFragment on ActivityLog {
  id
  entityId
  timestamp
  action
  description
  userId
  userFullName
  changes {
    path
    operation
    oldValue
    newValue
  }
  module
  object
  type
}
    `;
export const CameraNodeFragmentDoc = gql`
    fragment CameraNode on Camera {
  id
  name
  communicationStatus
  poweredOn
  road
  direction
  description
  location
  locationDescription
  autoFocusEnabled
  autoIrisEnabled
  userNotes
  referencePoint
  publicFeedEnabled
  privateStreamRecordingInProgress
  presets {
    id
    name
    presetIndex
    isHomePreset
    isSystem
    isSelected
  }
  ptzLock {
    isLocked
    requireExplicitCameraControlLocking
    userId
    fullName
    lockStartedAt
    lockEndsAt
    lastUsedTime
  }
  streams {
    name
    url
    accessType
    application
    streamName
    streamType
    streamManager
    recordingServer
  }
  capabilities {
    capability
    options
  }
  capabilitiesState
  communicationParameters
}
    `;
export const CommunicationLogFragmentDoc = gql`
    fragment CommunicationLog on CommunicationLog {
  id
  reason
  eventIds
  contact {
    id
    firstName
    lastName
    phoneNumber
    email
  }
  events {
    id
    name
  }
  detailsType
  impactedGroup
  reported
  discussion
  attributes
}
    `;
export const RsuMainStatusCategoryFragmentFragmentDoc = gql`
    fragment RsuMainStatusCategoryFragment on RsuMainStatusCategory {
  other
  okay
  warning
  critical
  unknown
  commFailed
  commDisabled
}
    `;
export const RsuModeStatusCategoryFragmentFragmentDoc = gql`
    fragment RsuModeStatusCategoryFragment on RsuModeStatusCategory {
  other
  standby
  operate
  fault
  unknown
  commFailed
  commDisabled
}
    `;
export const ConnectedVehicleFragmentFragmentDoc = gql`
    fragment ConnectedVehicleFragment on ConnectedVehicle {
  id
  name
  description
  communicationState
  device {
    deviceApi
    moduleVersion
    rsuMainStatus
    rsuModeStatus
    rsuRadioStatus
  }
  location
}
    `;
export const ConnectedVehicleCommentFragmentDoc = gql`
    fragment ConnectedVehicleComment on ConnectedVehicleComment {
  id
  connectedVehicleId
  comment
  createdAt
  updatedAt
  userId
  userDisplayName
}
    `;
export const SubGroupShortFragmentDoc = gql`
    fragment SubGroupShort on ContactGroupDto {
  id
  name
  description
  parentGroup
  items {
    id
    firstName
    lastName
    email
    workNumber
    notes
  }
}
    `;
export const ContactSubGroupShortRecursiveFragmentDoc = gql`
    fragment ContactSubGroupShortRecursive on ContactGroupDto {
  subGroups {
    ...SubGroupShort
    subGroups {
      ...SubGroupShort
      subGroups {
        ...SubGroupShort
        subGroups {
          ...SubGroupShort
          subGroups {
            ...SubGroupShort
          }
        }
      }
    }
  }
}
    ${SubGroupShortFragmentDoc}`;
export const ContactGroupShortFragmentFragmentDoc = gql`
    fragment ContactGroupShortFragment on ContactGroupDto {
  ...SubGroupShort
  ...ContactSubGroupShortRecursive
}
    ${SubGroupShortFragmentDoc}
${ContactSubGroupShortRecursiveFragmentDoc}`;
export const ContactListNodeFragmentFragmentDoc = gql`
    fragment ContactListNodeFragment on Contact {
  id
  firstName
  lastName
  email
  notes
  workNumber
  organizations {
    id
    name
    email
    workNumber
  }
}
    `;
export const HoursOfOperationFragmentFragmentDoc = gql`
    fragment HoursOfOperationFragment on HoursOfOperation {
  startDate
  endDate
  daysOfWeek
  startTime
  endTime
}
    `;
export const ContactFragmentFragmentDoc = gql`
    fragment ContactFragment on Contact {
  id
  firstName
  lastName
  email
  website
  mailingAddress
  notes
  workNumber
  cellNumber
  faxNumber
  homeNumber
  pagerNumber
  otherNumber
  publicMode
  organizations {
    id
    name
    email
    workNumber
  }
  groups {
    id
    name
    items {
      id
      firstName
      lastName
    }
    subGroups {
      id
      name
      items {
        id
        firstName
        lastName
      }
      subGroups {
        id
        name
        items {
          id
          firstName
          lastName
        }
        subGroups {
          id
          name
          items {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
  hoursOfOperation {
    ...HoursOfOperationFragment
  }
}
    ${HoursOfOperationFragmentFragmentDoc}`;
export const ContactsShortFragmentFragmentDoc = gql`
    fragment ContactsShortFragment on Contact {
  id
  firstName
  lastName
}
    `;
export const OrganizationsShortFragmentFragmentDoc = gql`
    fragment OrganizationsShortFragment on OrganizationDto {
  id
  name
}
    `;
export const SubGroupFragmentDoc = gql`
    fragment SubGroup on ContactGroupDto {
  id
  name
  description
  parentGroup
  items {
    id
    firstName
    lastName
  }
}
    `;
export const ContactSubGroupRecursiveFragmentDoc = gql`
    fragment ContactSubGroupRecursive on ContactGroupDto {
  subGroups {
    ...SubGroup
    subGroups {
      ...SubGroup
      subGroups {
        ...SubGroup
        subGroups {
          ...SubGroup
          subGroups {
            ...SubGroup
          }
        }
      }
    }
  }
}
    ${SubGroupFragmentDoc}`;
export const ContactGroupListNodeFragmentFragmentDoc = gql`
    fragment ContactGroupListNodeFragment on ContactGroupDto {
  ...SubGroup
  ...ContactSubGroupRecursive
}
    ${SubGroupFragmentDoc}
${ContactSubGroupRecursiveFragmentDoc}`;
export const OrganizationsListFragmentFragmentDoc = gql`
    fragment OrganizationsListFragment on OrganizationDto {
  id
  name
  email
  workNumber
  notes
}
    `;
export const OrganizationFragmentFragmentDoc = gql`
    fragment OrganizationFragment on OrganizationDto {
  id
  name
  email
  website
  mailingAddress
  useAsContact
  notes
  workNumber
  cellNumber
  faxNumber
  homeNumber
  pagerNumber
  otherNumber
  contacts
}
    `;
export const ContactListItemFragmentDoc = gql`
    fragment ContactListItem on Contact {
  id
  firstName
  lastName
  email
  notes
  workNumber
  cellNumber
  faxNumber
  homeNumber
  pagerNumber
  otherNumber
  hoursOfOperation {
    ...HoursOfOperationFragment
  }
}
    ${HoursOfOperationFragmentFragmentDoc}`;
export const CorridorDetectorFragmentDoc = gql`
    fragment CorridorDetector on Detector {
  communicationState
  lastDataReceived
  referencePoint
  laneDirection
  direction
  timeZone
  location
  road
  name
  id
  lanes {
    engineeringLane
    reversible
    laneIndex
    occupancy
    direction
    status
    volume
    speed
    type
  }
  nextHourTrafficForecast {
    lane
    volume
  }
}
    `;
export const CorridorFragmentDoc = gql`
    fragment Corridor on Corridor {
  lanes {
    reversiblePosition
    startReference
    endReference
    controller
    reversible
    direction
    position
    lineType
    type
    road
    id
  }
  landmarks {
    showReferencePoint
    bothDirections
    referencePoint
    direction
    name
    id
    settings
  }
  zones {
    bothDirections
    startReference
    endReference
    direction
    color
    name
    id
  }
  activationType
  responsePeriod
  integrations
  description
  deviceTypes
  detections
  confirmed
  settings
  geometry
  events
  shiftNotes
  type
  name
  id
}
    `;
export const CorridorSignGroupFragmentDoc = gql`
    fragment CorridorSignGroup on SignGroup {
  attributes
  signs {
    id
  }
  type
  name
  id
}
    `;
export const CorridorEventFragmentDoc = gql`
    fragment CorridorEvent on Event {
  lastUpdated
  attributes
  category
  created
  status
  lanes {
    engineeringLane
    laneStatus
    direction
    laneType
  }
  type
  name
  id
}
    `;
export const TunnelLogFragmentDoc = gql`
    fragment TunnelLog on TunnelLog {
  id
  created
  timestamp
  event
  userId
  userFullName
  notes
  corridorId
  directions
  data
}
    `;
export const CorridorResourcePlanFragmentDoc = gql`
    fragment CorridorResourcePlan on ResourcePlan {
  details {
    description
    settings
    status
    name
  }
  resources {
    status
    type
    data
    id
    adhoc
  }
  id
}
    `;
export const SignImageFragmentDoc = gql`
    fragment SignImage on SignImage {
  height
  width
  image
  slot
  name
  id
}
    `;
export const SignPositionFragmentDoc = gql`
    fragment SignPosition on Position {
  x
  y
}
    `;
export const SignMessageLineSegmentFragmentDoc = gql`
    fragment SignMessageLineSegment on SignMessageLineSegment {
  horizontalJustification
  flashingEnabled
  foregroundColor
  backgroundColor
  flashOffMillis
  flashOnMillis
  font
  text
}
    `;
export const SignMessageLineFragmentDoc = gql`
    fragment SignMessageLine on SignMessageLine {
  integration
  horizontalJustification
  lineSegments {
    ...SignMessageLineSegment
  }
}
    ${SignMessageLineSegmentFragmentDoc}`;
export const SignMessageTextAreaFragmentDoc = gql`
    fragment SignMessageTextArea on SignMessageTextArea {
  verticalJustification
  height
  width
  position {
    ...SignPosition
  }
  lines {
    ...SignMessageLine
  }
}
    ${SignPositionFragmentDoc}
${SignMessageLineFragmentDoc}`;
export const SignMessageImageFragmentDoc = gql`
    fragment SignMessageImage on SignMessageImage {
  image
  position {
    ...SignPosition
  }
}
    ${SignPositionFragmentDoc}`;
export const SignMessagePageFragmentDoc = gql`
    fragment SignMessagePage on SignMessagePage {
  verticalJustification
  backgroundColor
  integration
  pageOffTime
  rateName
  pageOnTime
  textAreas {
    ...SignMessageTextArea
  }
  images {
    ...SignMessageImage
  }
  lines {
    ...SignMessageLine
  }
}
    ${SignMessageTextAreaFragmentDoc}
${SignMessageImageFragmentDoc}
${SignMessageLineFragmentDoc}`;
export const SignMessageFragmentDoc = gql`
    fragment SignMessage on SignMessage {
  beaconsEnabled
  isDefaultMessage
  priority
  command
  slot
  type
  images {
    ...SignImage
  }
  pages {
    ...SignMessagePage
  }
}
    ${SignImageFragmentDoc}
${SignMessagePageFragmentDoc}`;
export const SignQueuedMessageFragmentDoc = gql`
    fragment SignQueuedMessage on SignQueuedMessage {
  associationDisplayNames
  expirationTime
  associations
  user
  id
  message {
    ...SignMessage
  }
}
    ${SignMessageFragmentDoc}`;
export const SignDisplayTypeFragmentDoc = gql`
    fragment SignDisplayType on SignDisplayType {
  characterLabels {
    characterIndex
    label
  }
  matrixType
  characterWidth
  characterHeight
  defaultFont
  maxCharacters
  height
  width
  hash
  maxLines
  maxPages
}
    `;
export const CorridorSignFragmentDoc = gql`
    fragment CorridorSign on Sign {
  currentMessage {
    ...SignQueuedMessage
  }
  displayType {
    ...SignDisplayType
  }
  communicationStatus
  travelTimeSegments
  lastDataReceived
  referencePoint
  laneDirection
  lanePosition
  capabilities
  backgroundColor
  foregroundColor
  colorScheme
  direction
  laneType
  road
  name
  id
}
    ${SignQueuedMessageFragmentDoc}
${SignDisplayTypeFragmentDoc}`;
export const SignMessagePreferencesFragmentDoc = gql`
    fragment SignMessagePreferences on SignMessagePreferences {
  horizontalJustification
  verticalJustification
  pageOffTime
  pageOnTime
  id
}
    `;
export const SignSpeedSettingsFragmentDoc = gql`
    fragment SignSpeedSettings on SignSpeedSettings {
  secondaryMaximumSpeed
  secondaryMinimumSpeed
  maximumChange
  minimumSpeed
  maximumSpeed
  intervals
}
    `;
export const SignTestsTypeFragmentDoc = gql`
    fragment SignTestsType on SignTests {
  fan {
    running
    error
    fans
  }
  lamp {
    running
    stuckOff
    stuckOn
    error
  }
  pixel {
    pixels {
      x
      y
    }
    running
    error
  }
}
    `;
export const CorridorSchematicSignFragmentDoc = gql`
    fragment CorridorSchematicSign on Sign {
  displayType {
    ...SignDisplayType
  }
  currentMessage {
    ...SignQueuedMessage
  }
  communicationStatus
  messagePreferences {
    ...SignMessagePreferences
  }
  speedSettings {
    ...SignSpeedSettings
  }
  travelTimeSegments
  referencePoint
  capabilities
  backgroundColor
  foregroundColor
  laneDirection
  lanePosition
  colorScheme
  direction
  laneType
  road
  name
  id
  tests {
    ...SignTestsType
  }
}
    ${SignDisplayTypeFragmentDoc}
${SignQueuedMessageFragmentDoc}
${SignMessagePreferencesFragmentDoc}
${SignSpeedSettingsFragmentDoc}
${SignTestsTypeFragmentDoc}`;
export const CorridorTravelTimeFragmentDoc = gql`
    fragment CorridorTravelTime on TravelTime {
  communicationState
  reportedTime
  historicTime
  lastConnect
  travelTime
  distance
  quality
  speed
  name
  id
  parts {
    startReference
    endReference
    direction
    road
  }
}
    `;
export const CorridorWeatherStationFragmentDoc = gql`
    fragment CorridorWeatherStation on WeatherStation {
  communicationStatus
  locationDescription
  lastDataReceived
  referencePoint
  description
  direction
  location
  values
  road
  name
  id
}
    `;
export const FieldConfigFieldsFragmentDoc = gql`
    fragment FieldConfigFields on FieldConfig {
  activeLogic
  choicesTitle
  chosenTitle
  defaultValue
  showInput
  valueLabelDisplay
  deselectAllLabel
  disableFuture
  disablePast
  displayFormat
  fieldSize
  format
  help
  hint
  id
  label
  limitTags
  max
  maxLength
  min
  multiple
  name
  sortOrder
  options {
    label
    value
  }
  required
  requiredLogic
  selectAllLabel
  step
  type
  uniqueFields
  useCheckedIcon
  useIcon
  useStepper
  moduleName
  sourceId
  rows
  multiline
  mode
  pickerZIndex
  dataSource
  dataSourceVariables {
    address
    value
    required
    name
    type
  }
}
    `;
export const FieldConfigRecursiveFragmentDoc = gql`
    fragment FieldConfigRecursive on FieldConfig {
  ...FieldConfigFields
  fieldConfigs {
    ...FieldConfigFields
    fieldConfigs {
      ...FieldConfigFields
      fieldConfigs {
        ...FieldConfigFields
      }
    }
  }
}
    ${FieldConfigFieldsFragmentDoc}`;
export const DataSourceFieldConfigFragmentDoc = gql`
    fragment DataSourceFieldConfig on FieldConfig {
  label
  type
  name
  id
  activeLogic
  choicesTitle
  chosenTitle
  defaultValue
  deselectAllLabel
  disableFuture
  disablePast
  displayFormat
  fieldSize
  fieldConfigs {
    ...FieldConfigRecursive
  }
  format
  help
  hint
  limitTags
  max
  maxLength
  min
  multiple
  sortOrder
  options {
    label
    value
  }
  required
  requiredLogic
  selectAllLabel
  step
  uniqueFields
  useCheckedIcon
  useIcon
  useStepper
  moduleName
  sourceId
  rows
  multiline
  mode
  pickerZIndex
}
    ${FieldConfigRecursiveFragmentDoc}`;
export const DataSourceConfigFragmentDoc = gql`
    fragment DataSourceConfig on DataSourceConfig {
  fields {
    ...DataSourceFieldConfig
  }
  module
  name
  id
  system
  readOnly
}
    ${DataSourceFieldConfigFragmentDoc}`;
export const DataSourceFragmentDoc = gql`
    fragment DataSource on DataSource {
  config {
    ...DataSourceConfig
  }
  attributes
  enabled
  value
  id
}
    ${DataSourceConfigFragmentDoc}`;
export const DetectorFragmentDoc = gql`
    fragment Detector on Detector {
  communicationState
  referencePoint
  direction
  timeZone
  location
  road
  name
  id
  lanes {
    engineeringLane
    laneIndex
    occupancy
    direction
    status
    volume
    speed
    type
    name
  }
}
    `;
export const DetectorLaneDataFragmentDoc = gql`
    fragment DetectorLaneData on DetectorLaneData {
  laneIndex
  totalErrorCount
  excludeVos
  reversible
  volume
  occupancy
  direction
  type
  engineeringLane
  status
  name
  density
  isReversed
}
    `;
export const HiTracFragmentFragmentDoc = gql`
    fragment HiTracFragment on HiTrac {
  lastResetTime
  lastResetReason
  lastConnect
  lastBattery
  firmwareVersions {
    version
    processor
  }
}
    `;
export const DetectorWeightThresholdFragmentDoc = gql`
    fragment DetectorWeightThreshold on DetectorWeightThreshold {
  laneIndex
  lane
  weightLowerThreshold
  weightUpperThreshold
}
    `;
export const DetectorLaneDescriptionConfigFragmentDoc = gql`
    fragment DetectorLaneDescriptionConfig on DetectorLaneDescriptionConfig {
  laneIndex
  lane
  laneDescription
}
    `;
export const DetectorManeuverSettingConfigFragmentDoc = gql`
    fragment DetectorManeuverSettingConfig on DetectorManeuverSettingConfig {
  maneuverId
  maneuverDescription
  originDirection
  destinationDirection
}
    `;
export const DetectorListNodeFragmentFragmentDoc = gql`
    fragment DetectorListNodeFragment on Detector {
  id
  name
  description
  communicationState
  primaryDirection
  classScheme
  deviceType {
    id
    name
  }
  timeZone
  timezoneId
  speedUnit
  speedLimit
  type
  roadType
  externalCenter
  location
  maxGrossWeight
  numberOfLanes
  laneDirection
  siteNumber
  lanes {
    ...DetectorLaneData
  }
  equipmentNumber
  hiTrac {
    ...HiTracFragment
  }
  lastVehicle {
    id
    serial
    timestamp
    headerTimestamp
  }
  communicationParameters
  lastDataReceived
  lanes {
    laneIndex
    reversible
    volume
    speed
    occupancy
    direction
    type
    engineeringLane
    status
    isReversed
  }
  referencePoint
  direction
  road
  speedBins {
    speedBinName
    speedBinIndex
    speedStartRange
    speedEndRange
  }
  grossWeightThreshold {
    ...DetectorWeightThreshold
  }
  axle1WeightThreshold {
    ...DetectorWeightThreshold
  }
  laneDescription {
    ...DetectorLaneDescriptionConfig
  }
  maneuvers {
    ...DetectorManeuverSettingConfig
  }
  deviceProtocol
  directionDescriptions {
    description
    direction
    __typename
  }
  nextHourTrafficForecast {
    lane
    volume
  }
  systemEnabled
  direction
  isReversed
}
    ${DetectorLaneDataFragmentDoc}
${HiTracFragmentFragmentDoc}
${DetectorWeightThresholdFragmentDoc}
${DetectorLaneDescriptionConfigFragmentDoc}
${DetectorManeuverSettingConfigFragmentDoc}`;
export const DetectorVehicleDetailNodeFragmentFragmentDoc = gql`
    fragment DetectorVehicleDetailNodeFragment on DetectorVehicle {
  dimensionProfile {
    id
    name
    size
    contentType
    path
  }
  loopSignature {
    id
    name
    size
    contentType
    path
  }
  leftTyreType
  rightTyreType
}
    `;
export const DetectorVehicleListNodeFragmentFragmentDoc = gql`
    fragment DetectorVehicleListNodeFragment on DetectorVehicle {
  id
  serial
  timestamp
  axlesCount
  tags
  classInfo {
    id
    name
    index
  }
  lane
  speed
  grossWeight
  axleWeight1
  axleWeight2
  axleWeight3
  axleWeight4
  axleWeight5
  axleWeight6
  axleWeight7
  axleWeight8
  axleWeight9
  axleWeight10
  axleWeight11
  axleWeight12
  axleWeight13
  axleWeight14
  axleWeight15
  axleWeight16
  axleWeight17
  axleWeight18
  axleWeight19
  axleWeight20
  axleWeight21
  axleWeight22
  axleWeight23
  axleWeight23
  axleWeight24
  axleWeight25
  axleWeight26
  axleWeight27
  axleWeight28
  axleWeight29
  axleWeight30
  length
  axleSpace1
  axleSpace2
  axleSpace3
  axleSpace4
  axleSpace5
  axleSpace6
  axleSpace7
  axleSpace8
  axleSpace9
  axleSpace10
  axleSpace11
  axleSpace12
  axleSpace13
  axleSpace14
  axleSpace15
  axleSpace16
  axleSpace17
  axleSpace18
  axleSpace19
  axleSpace20
  axleSpace21
  axleSpace22
  axleSpace23
  axleSpace24
  axleSpace25
  axleSpace26
  axleSpace27
  axleSpace28
  axleSpace29
  chassisCode
  straddle
  overWeight
  loopOnTime
  loopFailure
  headway
  legalStatus
  straddleLane
  validity
  direction
  laneDirection
  minChassisList
  maxChassisList
  images {
    id
    name
    size
    contentType
    path
    timestamp
    module
    key
  }
  anprImageAvailable
  overViewImageAvailable
  dimensionProfileAvailable
  loopSignatureAvailable
  width
  height
  ocr
  ocrRear
  aiClassName
  aiConfidence
  aiClassVerified
  aiClassVerifiedTS
  typeAPositions
  typeBPositions
  lastAxleSpeed
  sensorWheelWeights
  sensorWeights
  verifiedAiClassName
  temperature
  maneuverId
  verifiedClassName
  verifiedClassNameStatus
  verifiedClassNameStatusAt
  verifiedClassIndex
  verifiedClassNameStatusCodes
  aiClassVerifiedCodes
  axleType1
  axleType2
  axleType3
  axleType4
  axleType5
  axleType6
  axleType7
  axleType8
  axleType9
  axleType10
  leftTyreType
  rightTyreType
}
    `;
export const DetectorAlarmListNodeFragmentFragmentDoc = gql`
    fragment DetectorAlarmListNodeFragment on DetectorAlarm {
  id
  description
  receivedAt
  clearedAt
  type {
    id
    name
    description
    code
    severity
  }
  subtypes {
    name
  }
  detector {
    id
    name
    timezoneId
    siteNumber
    equipmentNumber
  }
  group {
    id
    name
  }
  active
  acknowledged
  cleared
  count
  firstReceivedAt
}
    `;
export const DetectorBatteryListNodeFragmentFragmentDoc = gql`
    fragment DetectorBatteryListNodeFragment on DetectorBattery {
  id
  volts
  timestamp
}
    `;
export const DetectorActivityListNodeFragmentFragmentDoc = gql`
    fragment DetectorActivityListNodeFragment on DetectorActivity {
  id
  count
  timestamp
  level {
    label
    value
  }
  message {
    label
    value
  }
  subtype {
    label
    value
  }
  parameter
}
    `;
export const DetectorConnectionLogListNodeFragmentFragmentDoc = gql`
    fragment DetectorConnectionLogListNodeFragment on DetectorConnectionGroup {
  timestamp
  groupID
  bytesIncoming
  bytesOutgoing
  status
  elapsedSeconds
  id
  connectionPushType
}
    `;
export const DetectorWeatherListNodeFragmentFragmentDoc = gql`
    fragment DetectorWeatherListNodeFragment on DetectorWeather {
  id
  detectorId
  hour
  date
  timestamp
  weatherInfo {
    name
    base
    visibility
    cod
    weather {
      main
      icon
      description
    }
    main {
      temp
      feels_like
      temp_min
      temp_max
      pressure
      humidity
    }
    wind {
      speed
      deg
    }
    clouds {
      all
    }
    sys {
      country
      type
      sunrise
      sunset
    }
  }
}
    `;
export const DetectorEmailAlertSettingFragmentFragmentDoc = gql`
    fragment DetectorEmailAlertSettingFragment on DetectorEmailAlertSetting {
  id
  emailIds
  allSites
  userIds
  frequency {
    code
    label
    types
  }
  frequencyDay
  timezone
  startTime
  type {
    code
    label
  }
  subtypes {
    code
    label
    type
  }
  enabled
  detectors {
    id
    name
  }
  detectorGroups {
    id
    name
  }
  emailTemplate
  interval
  detectorClass
  classGroup
  direction
  lane
  performanceReportId
  ruleId
  consecutiveAlerts
  unitPreference
  reportRule {
    name
    id
  }
  reportConfig {
    id
  }
  timestamp
}
    `;
export const DetectorTmasReportFragmentFragmentDoc = gql`
    fragment DetectorTMASReportFragment on DetectorTMASReport {
  name
  content
}
    `;
export const DetectorConnectionLogFragmentFragmentDoc = gql`
    fragment DetectorConnectionLogFragment on DetectorConnectionLog {
  groupID
  hexDump
  timestamp
  message
  level {
    label
    value
  }
  id
}
    `;
export const DetectorPerformanceReportResultFragmentFragmentDoc = gql`
    fragment DetectorPerformanceReportResultFragment on DetectorPerformanceReportResult {
  date
  detector {
    id
    name
  }
  intervalList
}
    `;
export const DetectorReportConfigurationFragmentFragmentDoc = gql`
    fragment DetectorReportConfigurationFragment on DetectorReportConfiguration {
  id
  name
  description
  ruleIds
  defaultSelection
}
    `;
export const DetectorPerformanceReportDayWiseAvailabilityInfoFragmentFragmentDoc = gql`
    fragment DetectorPerformanceReportDayWiseAvailabilityInfoFragment on DetectorPerformanceReportDayWiseAvailabilityInfo {
  date
  rules {
    id
    name
    template
  }
  availability {
    ruleId
    availability
  }
}
    `;
export const FormViewFragmentDoc = gql`
    fragment FormView on DetectorReportConfigFormView {
  id
  name
  type
  sections {
    id
    name
    fields {
      ...FieldConfigRecursive
    }
  }
}
    ${FieldConfigRecursiveFragmentDoc}`;
export const DetectorReportFormViewsRecursiveFragmentDoc = gql`
    fragment DetectorReportFormViewsRecursive on DetectorReportRuleForm {
  views {
    ...FormView
    views {
      ...FormView
      views {
        ...FormView
        views {
          ...FormView
          views {
            ...FormView
          }
        }
      }
    }
  }
}
    ${FormViewFragmentDoc}`;
export const FormFragmentDoc = gql`
    fragment Form on DetectorReportRuleForm {
  id
  name
  reportTemplate
  extraConfig
  ...DetectorReportFormViewsRecursive
}
    ${DetectorReportFormViewsRecursiveFragmentDoc}`;
export const DetectorReportRuleFragmentFragmentDoc = gql`
    fragment DetectorReportRuleFragment on DetectorReportRule {
  id
  name
  template
  enabled
  reportTemplateName
  config {
    settings
    query
  }
}
    `;
export const DetectorVehicleAxleWeightChartFragmentFragmentDoc = gql`
    fragment DetectorVehicleAxleWeightChartFragment on DetectorVehicleAxleWeightChart {
  lane
  data {
    timestamp
    averageWeight
    grossWeight
    temperature
  }
}
    `;
export const DetectorVehicleSpeedBinReportFragmentFragmentDoc = gql`
    fragment DetectorVehicleSpeedBinReportFragment on DetectorVehicleSpeedBinReportResult {
  intervals {
    hour
    totalVolume
    speedAt85Percent
    averageSpeed
    speedStandardDeviation
    speedBinInfo
  }
}
    `;
export const DetectorTurningReportFragmentFragmentDoc = gql`
    fragment DetectorTurningReportFragment on DetectorTurningReport {
  classNames
  data {
    name
    inwardCount
    outwardCount
    totalCount
    data {
      name
      isInwardTotal
      isOutwardTotal
      total
      data {
        date
        hour
        minute
        total
        isHourlyTotal
        isDailyTotal
        classCounts
      }
    }
  }
}
    `;
export const DetectorPerformanceReportDayWiseAvailabilityDetailInfoFragmentFragmentDoc = gql`
    fragment DetectorPerformanceReportDayWiseAvailabilityDetailInfoFragment on DetectorPerformanceReportDayWiseAvailabilityDetailInfo {
  date
  rule {
    id
    name
    template
  }
  detector {
    id
    name
  }
}
    `;
export const EmailRuleListFragmentDoc = gql`
    fragment EmailRuleList on EmailRuleDto {
  id
  name
  description
  module
  active
  executive
  templates {
    id
    name
  }
}
    `;
export const RecipientFragmentFragmentDoc = gql`
    fragment RecipientFragment on RecipientDto {
  recipientId
  name
  label
  email
  smsRecipient
  type
  workNumber
}
    `;
export const EmailRuleDetailsFragmentFragmentDoc = gql`
    fragment EmailRuleDetailsFragment on EmailRuleDto {
  id
  name
  description
  module
  formId
  active
  templates {
    id
    module
    name
    type
    subject
    body
  }
  rule
  executive
  recipients {
    ...RecipientFragment
  }
  automationSettings {
    onEventCreated
    onEventUpdated
    onEventClosed
  }
  config
  recurrenceEndDate
  start
  end
  rrule
}
    ${RecipientFragmentFragmentDoc}`;
export const EmailTemplateListNodeFragmentFragmentDoc = gql`
    fragment EmailTemplateListNodeFragment on EmailTemplateDto {
  id
  name
  type
  form
  module
  subject
  body
}
    `;
export const JobResultFragmentDoc = gql`
    fragment JobResult on JobResult {
  requestId
  success
  failure
  id
}
    `;
export const EventTypeFragmentDoc = gql`
    fragment EventType on EventType {
  detectionCodes
  description
  category
  name
  id
}
    `;
export const EventTypeShortFragmentDoc = gql`
    fragment EventTypeShort on EventType {
  name
  id
}
    `;
export const EventLaneFragmentDoc = gql`
    fragment EventLane on EventLane {
  closedTime
  openTime
  roadwayType
  laneStatus
  engineeringLane
  direction
  laneType
  lineType
  id
}
    `;
export const EventMapFragmentDoc = gql`
    fragment EventMap on Event {
  lastUpdated
  attributes
  lanes {
    ...EventLane
  }
  geometry
  category
  created
  status
  type
  name
  id
}
    ${EventLaneFragmentDoc}`;
export const EventListFragmentDoc = gql`
    fragment EventList on Event {
  geometry
  lastUpdated
  lastUpdatedBy
  externalCenter
  attributes
  category
  created
  createdBy
  start
  end
  status
  type
  name
  id
  shortId
  floodgate
  fiveOneOneMessage {
    suppressed
  }
}
    `;
export const DetectionListItemFragmentDoc = gql`
    fragment DetectionListItem on Detection {
  id
  alertId
  type
  typeId
  description
  status
  location
  confidence
  severity
  created
  lastUpdated
  sources
  sourceNames {
    source
    names
  }
  associatedEventIds
  examined
}
    `;
export const KineticFormFieldFragmentFragmentDoc = gql`
    fragment KineticFormFieldFragment on KineticFormField {
  id
  name
  description
  label
  type
  fieldSize
  help
  hint
  options {
    label
    value
    type
  }
  disabled
  disablePast
  disableFuture
  format
  displayFormat
  max
  min
  useStepper
  step
  source
  multiple
  sortOrder
  requiredLogic
  activeLogic
  moduleName
  loading
  uploadType
  accept
  required
  defaultValue
  mode
  iconConfig
  rows
  multiline
  pickerZIndex
}
    `;
export const KineticFormSectionFragmentFragmentDoc = gql`
    fragment KineticFormSectionFragment on KineticFormSection {
  id
  name
  fields {
    ...KineticFormFieldFragment
  }
}
    ${KineticFormFieldFragmentFragmentDoc}`;
export const KineticFormViewFragmentFragmentDoc = gql`
    fragment KineticFormViewFragment on KineticFormView {
  id
  name
  sections {
    ...KineticFormSectionFragment
  }
}
    ${KineticFormSectionFragmentFragmentDoc}`;
export const KineticFormFragmentDoc = gql`
    fragment KineticForm on KineticForm {
  views {
    ...KineticFormViewFragment
  }
  system
  canOverride
  modified
  extraConfig
  description
  module
  name
  id
}
    ${KineticFormViewFragmentFragmentDoc}`;
export const EventLinkFragmentDoc = gql`
    fragment EventLink on EventLink {
  comment
  name
  type
  id
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on Contact {
  id
  firstName
  lastName
  email
  workNumber
  cellNumber
  faxNumber
  homeNumber
  pagerNumber
  otherNumber
  publicMode
}
    `;
export const CommunicationLogEventFragmentDoc = gql`
    fragment CommunicationLogEvent on CommunicationLog {
  id
  reported
  reason
  detailsType
  impactedGroup
  discussion
  attributes
  contact {
    firstName
    lastName
  }
}
    `;
export const AlertFragmentDoc = gql`
    fragment Alert on Alert {
  alertId
  type
  description
  source
  location
  updateTime
  confidence
  severity
  details
  evidence {
    fileId
    status
    type
  }
}
    `;
export const DetectionFragmentDoc = gql`
    fragment Detection on Detection {
  id
  alertId
  type
  description
  status
  location
  confidence
  severity
  created
  lastUpdated
  sources
  sourceNames {
    source
    names
  }
  alertStates {
    alertId
    alertStatus
  }
  alerts {
    ...Alert
  }
  associatedEventIds
  examined
}
    ${AlertFragmentDoc}`;
export const EventFragmentDoc = gql`
    fragment Event on Event {
  id
  shortId
  name
  floodgate
  category
  external
  notes {
    timestamp
    user
    note
  }
  type
  status
  lanes {
    ...EventLane
  }
  form {
    ...KineticForm
  }
  attributes
  links {
    ...EventLink
  }
  geometry
  labels
  start
  end
  created
  lastUpdated
  sceneClear
  lastUpdatedBy
  lastUpdatedByDisplayName
  createdBy
  contacts {
    ...Contact
  }
  associatedCommunicationLogs {
    ...CommunicationLogEvent
  }
  associatedDetections {
    ...Detection
  }
  fiveOneOneMessage {
    suppressed
  }
  activationType
  confirmationRequired
  fleetDispatches {
    id
    event
    status
    timeRequested
    timeResponded
    timeDeparted
    timeOnScene
    dispatchingUsername
    dispatchingUser
    rejectionReason
    shift
    firstName
    lastName
    username
    driver
    phone
    email
    responseTime
    formatResponseTime
  }
}
    ${EventLaneFragmentDoc}
${KineticFormFragmentDoc}
${EventLinkFragmentDoc}
${ContactFragmentDoc}
${CommunicationLogEventFragmentDoc}
${DetectionFragmentDoc}`;
export const TemplateEventFragmentDoc = gql`
    fragment TemplateEvent on Event {
  id
  name
  floodgate
  category
  notes {
    timestamp
    user
    note
  }
  type
  status
  lanes {
    ...EventLane
  }
  form {
    ...KineticForm
  }
  attributes
  links {
    ...EventLink
  }
  geometry
  labels
  start
  end
  created
  lastUpdated
  sceneClear
  lastUpdatedBy
  createdBy
  activationType
  confirmationRequired
}
    ${EventLaneFragmentDoc}
${KineticFormFragmentDoc}
${EventLinkFragmentDoc}`;
export const KineticFormFragmentFragmentDoc = gql`
    fragment KineticFormFragment on KineticForm {
  views {
    ...KineticFormViewFragment
  }
  system
  canOverride
  modified
  extraConfig
  description
  module
  name
  id
}
    ${KineticFormViewFragmentFragmentDoc}`;
export const EventContactFragmentDoc = gql`
    fragment EventContact on Contact {
  id
  firstName
  lastName
  email
  workNumber
  cellNumber
  faxNumber
  homeNumber
  pagerNumber
  otherNumber
  publicMode
}
    `;
export const EventFragmentFragmentDoc = gql`
    fragment EventFragment on Event {
  id
  shortId
  name
  category
  floodgate
  type
  status
  lanes {
    ...EventLane
  }
  form {
    ...KineticFormFragment
  }
  attributes
  links {
    ...EventLink
  }
  geometry
  start
  end
  created
  lastUpdated
  sceneClear
  lastUpdatedBy
  createdBy
  labels
  notes {
    timestamp
    user
    note
  }
  associatedCommunicationLogs {
    ...CommunicationLogEvent
  }
  contacts {
    ...EventContact
  }
  associatedDetections {
    ...Detection
  }
  fiveOneOneMessage {
    suppressed
  }
}
    ${EventLaneFragmentDoc}
${KineticFormFragmentFragmentDoc}
${EventLinkFragmentDoc}
${CommunicationLogEventFragmentDoc}
${EventContactFragmentDoc}
${DetectionFragmentDoc}`;
export const EventDetailsFragmentDoc = gql`
    fragment EventDetails on Event {
  lastUpdated
  category
  created
  name
  id
}
    `;
export const ResourcePlanDetailsFragmentDoc = gql`
    fragment ResourcePlanDetails on ResourcePlanDetails {
  description
  settings
  status
  name
  approved
  approver
}
    `;
export const ResourceFragmentDoc = gql`
    fragment Resource on Resource {
  status
  type
  data
  id
  adhoc
  acknowledged
}
    `;
export const ResourcePlanFragmentDoc = gql`
    fragment ResourcePlan on ResourcePlan {
  id
  details {
    ...ResourcePlanDetails
  }
  resources {
    ...Resource
  }
}
    ${ResourcePlanDetailsFragmentDoc}
${ResourceFragmentDoc}`;
export const ResourcePlanTaskFragmentFragmentDoc = gql`
    fragment ResourcePlanTaskFragment on Task {
  taskRecurrenceType
  recurrenceEndDate
  taskType
  rrule
  start
  data
  name
  end
  id
}
    `;
export const EventSignDetailFragmentDoc = gql`
    fragment EventSignDetail on Sign {
  locationDescription
  communicationStatus
  travelTimeSegments
  lastDataReceived
  referencePoint
  capabilities
  backgroundColor
  foregroundColor
  speedSettings {
    ...SignSpeedSettings
  }
  messagePreferences {
    verticalJustification
    horizontalJustification
    pageOffTime
    pageOnTime
    id
  }
  displayType {
    characterLabels {
      characterIndex
      label
    }
    maxCharacters
    defaultFont
    matrixType
    maxLines
    maxPages
    height
    width
    hash
  }
  colorScheme
  laneDirection
  lanePosition
  direction
  laneType
  location
  road
  name
  id
  currentMessage {
    ...SignQueuedMessage
  }
  tests {
    ...SignTestsType
  }
}
    ${SignSpeedSettingsFragmentDoc}
${SignQueuedMessageFragmentDoc}
${SignTestsTypeFragmentDoc}`;
export const ResourceSubGroupFragmentDoc = gql`
    fragment ResourceSubGroup on ContactGroupDto {
  id
  name
  description
  parentGroup
  items {
    id
    firstName
    lastName
    email
    workNumber
    notes
  }
}
    `;
export const ResourceContactSubGroupRecursiveFragmentDoc = gql`
    fragment ResourceContactSubGroupRecursive on ContactGroupDto {
  subGroups {
    ...ResourceSubGroup
    subGroups {
      ...ResourceSubGroup
      subGroups {
        ...ResourceSubGroup
        subGroups {
          ...ResourceSubGroup
          subGroups {
            ...ResourceSubGroup
          }
        }
      }
    }
  }
}
    ${ResourceSubGroupFragmentDoc}`;
export const ResourceContactGroupListNodeFragmentFragmentDoc = gql`
    fragment ResourceContactGroupListNodeFragment on ContactGroupDto {
  ...ResourceSubGroup
  ...ResourceContactSubGroupRecursive
}
    ${ResourceSubGroupFragmentDoc}
${ResourceContactSubGroupRecursiveFragmentDoc}`;
export const ResourcePlanActivationResultFragmentDoc = gql`
    fragment ResourcePlanActivationResult on ResourcePlanActivationResult {
  id
  activationId
  resourcePlanId
  resourceId
  resourceName
  errorMessage
  activationStatus
  resourceType
}
    `;
export const DirectoryFragmentFragmentDoc = gql`
    fragment DirectoryFragment on Directory {
  id
  order
  name
  owner
  parentId
  readOnly
}
    `;
export const DirectoryRecursiveFragmentDoc = gql`
    fragment DirectoryRecursive on Directory {
  ...DirectoryFragment
  directories {
    ...DirectoryFragment
    directories {
      ...DirectoryFragment
      directories {
        ...DirectoryFragment
        directories {
          ...DirectoryFragment
          directories {
            ...DirectoryFragment
            directories {
              ...DirectoryFragment
              directories {
                ...DirectoryFragment
                directories {
                  ...DirectoryFragment
                  directories {
                    ...DirectoryFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DirectoryFragmentFragmentDoc}`;
export const FieldConfigFragmentFragmentDoc = gql`
    fragment FieldConfigFragment on FieldConfig {
  id
  name
  label
  type
  required
  help
  hint
  fieldSize
  sortOrder
  options {
    label
    value
  }
  disablePast
  disableFuture
  useStepper
  max
  min
  step
  multiple
  limitTags
  selectAllLabel
  deselectAllLabel
  useCheckedIcon
  useIcon
  choicesTitle
  defaultValue
  format
  displayFormat
  activeLogic
  requiredLogic
  moduleName
  sourceId
  uploadType
  accept
  loading
  valueLabelDisplay
  showInput
  maxLength
  uniqueFields
  multiline
  rows
  mode
  disabled
  disabledLogic
  pickerZIndex
  dataSource
  dataSourceVariables {
    address
    value
    required
    name
    type
  }
}
    `;
export const ModuleFormSectionFragmentFragmentDoc = gql`
    fragment ModuleFormSectionFragment on ModuleFormSection {
  fields {
    ...FieldConfigFragment
    fieldConfigs {
      ...FieldConfigFragment
      fieldConfigs {
        ...FieldConfigFragment
        fieldConfigs {
          ...FieldConfigFragment
        }
      }
    }
  }
  name
  id
}
    ${FieldConfigFragmentFragmentDoc}`;
export const FormSectionFragmentFragmentDoc = gql`
    fragment FormSectionFragment on FormSection {
  fields {
    ...FieldConfigFragment
    fieldConfigs {
      ...FieldConfigFragment
      fieldConfigs {
        ...FieldConfigFragment
        fieldConfigs {
          ...FieldConfigFragment
        }
      }
    }
  }
  name
  id
}
    ${FieldConfigFragmentFragmentDoc}`;
export const FormViewFragmentFragmentDoc = gql`
    fragment FormViewFragment on FormView {
  sections {
    ...FormSectionFragment
  }
  type
  id
  name
}
    ${FormSectionFragmentFragmentDoc}`;
export const KineticFieldConfigFragmentDoc = gql`
    fragment KineticFieldConfig on FieldConfig {
  ...FieldConfigFields
}
    ${FieldConfigFieldsFragmentDoc}`;
export const GateSettingSectionFragmentDoc = gql`
    fragment GateSettingSection on ModuleFormSection {
  fields {
    ...KineticFieldConfig
  }
  id
  name
}
    ${KineticFieldConfigFragmentDoc}`;
export const GateSettingViewFragmentDoc = gql`
    fragment GateSettingView on FormView {
  id
  name
  sections {
    ...GateSettingSection
  }
  type
}
    ${GateSettingSectionFragmentDoc}`;
export const GateSettingViewsRecursiveFragmentDoc = gql`
    fragment GateSettingViewsRecursive on FormView {
  views {
    ...GateSettingView
    views {
      ...GateSettingView
      views {
        ...GateSettingView
      }
    }
  }
}
    ${GateSettingViewFragmentDoc}`;
export const GateSettingsFragmentDoc = gql`
    fragment GateSettings on ModuleSettingsFormView {
  id
  name
  views {
    ...GateSettingViewsRecursive
  }
  sections {
    ...GateSettingSection
  }
  type
}
    ${GateSettingViewsRecursiveFragmentDoc}
${GateSettingSectionFragmentDoc}`;
export const HarSettingSectionFragmentDoc = gql`
    fragment HarSettingSection on ModuleFormSection {
  fields {
    ...FieldConfigFields
  }
  id
  name
}
    ${FieldConfigFieldsFragmentDoc}`;
export const HarSettingViewFragmentDoc = gql`
    fragment HarSettingView on FormView {
  id
  name
  sections {
    ...HarSettingSection
  }
  type
}
    ${HarSettingSectionFragmentDoc}`;
export const HarSettingViewsRecursiveFragmentDoc = gql`
    fragment HarSettingViewsRecursive on FormView {
  views {
    ...HarSettingView
    views {
      ...HarSettingView
      views {
        ...HarSettingView
      }
    }
  }
}
    ${HarSettingViewFragmentDoc}`;
export const HarSettingsFragmentDoc = gql`
    fragment HarSettings on ModuleSettingsFormView {
  id
  name
  views {
    ...HarSettingViewsRecursive
  }
  sections {
    ...HarSettingSection
  }
  type
}
    ${HarSettingViewsRecursiveFragmentDoc}
${HarSettingSectionFragmentDoc}`;
export const HarQueuedPlaylistFragmentDoc = gql`
    fragment HarQueuedPlaylist on HarQueuedPlaylist {
  messages {
    text
    name
    id
  }
  associations {
    name
    id
  }
  expirationTime
  priority {
    priority
    name
  }
  user {
    name
    id
  }
  name
  id
}
    `;
export const IntegrationsFormViewFragmentDoc = gql`
    fragment IntegrationsFormView on IntegrationConfigFormView {
  id
  name
  type
  sections {
    id
    name
    fields {
      ...FieldConfigRecursive
    }
  }
}
    ${FieldConfigRecursiveFragmentDoc}`;
export const IntegrationsFormViewRecursiveFragmentDoc = gql`
    fragment IntegrationsFormViewRecursive on IntegrationsForm {
  views {
    ...IntegrationsFormView
    views {
      ...IntegrationsFormView
      views {
        ...IntegrationsFormView
        views {
          ...IntegrationsFormView
          views {
            ...IntegrationsFormView
          }
        }
      }
    }
  }
}
    ${IntegrationsFormViewFragmentDoc}`;
export const IntegrationsFormFragmentDoc = gql`
    fragment IntegrationsForm on IntegrationsForm {
  id
  name
  description
  integrationType
  locationSupported
  areaSupported
  extraConfig
  ...IntegrationsFormViewRecursive
}
    ${IntegrationsFormViewRecursiveFragmentDoc}`;
export const IntegrationConfigFragmentDoc = gql`
    fragment IntegrationConfig on IntegrationConfig {
  location
  associatedLocation {
    id
  }
  form {
    ...IntegrationsForm
  }
  settings
  integrationType
}
    ${IntegrationsFormFragmentDoc}`;
export const SavedIntegrationFragmentDoc = gql`
    fragment SavedIntegration on Integration {
  id
  name
  description
  systemEnabled
  assetIdentifier
  config {
    ...IntegrationConfig
  }
}
    ${IntegrationConfigFragmentDoc}`;
export const IntegrationStateSectionFragmentDoc = gql`
    fragment IntegrationStateSection on IntegrationStateSection {
  id
  name
  fields {
    ...FieldConfigRecursive
  }
}
    ${FieldConfigRecursiveFragmentDoc}`;
export const IntegrationStateViewFragmentDoc = gql`
    fragment IntegrationStateView on IntegrationStateView {
  id
  name
  type
  sections {
    ...IntegrationStateSection
  }
}
    ${IntegrationStateSectionFragmentDoc}`;
export const IntegrationStateViewRecursiveFragmentDoc = gql`
    fragment IntegrationStateViewRecursive on IntegrationStateView {
  ...IntegrationStateView
  views {
    ...IntegrationStateView
    views {
      ...IntegrationStateView
      views {
        ...IntegrationStateView
        views {
          ...IntegrationStateView
          views {
            ...IntegrationStateView
          }
        }
      }
    }
  }
}
    ${IntegrationStateViewFragmentDoc}`;
export const IntegrationStateFragmentDoc = gql`
    fragment IntegrationState on IntegrationState {
  views {
    ...IntegrationStateViewRecursive
  }
}
    ${IntegrationStateViewRecursiveFragmentDoc}`;
export const IntegrationAndStateFragmentDoc = gql`
    fragment IntegrationAndState on Integration {
  id
  name
  config {
    integrationType
  }
  state {
    ...IntegrationState
  }
}
    ${IntegrationStateFragmentDoc}`;
export const JobRequestFragmentDoc = gql`
    fragment JobRequest on JobRequest {
  requestId
  success
  failure
  id
}
    `;
export const NotificationFragmentFragmentDoc = gql`
    fragment NotificationFragment on Notification {
  id
  userIds
  systemNotification
  source
  severity
  createdTime
  acknowledgedTime
  acknowledgedNotes
  acknowledgedBy
  nonDismissible
  acknowledgedByName
  snoozed
  snoozeMessage
  snoozeDurationInMinutes
  location
  objectId
  ignorable
  title
  details
  updatedTS
  route
  data
  snoozedAt
  status
  actions {
    route
    title
    toolTip
  }
}
    `;
export const CursorPageInfoFragmentDoc = gql`
    fragment CursorPageInfo on PageInfo {
  hasPreviousPage
  hasNextPage
  startCursor
  endCursor
}
    `;
export const RampMeterStatusCategoriesFragmentDoc = gql`
    fragment RampMeterStatusCategories on RampMeterStatusCategories {
  dark
  emergencyGreen
  fixedRate
  restInGreen
  trafficResponsive
  holdMeter
  holdNonMeter
  holdRestInGreen
  commDisabled
  commFailed
  unknown
}
    `;
export const AlarmConfigFragmentFragmentDoc = gql`
    fragment AlarmConfigFragment on AlarmConfig {
  id
  name
  source
  entityType
  entityId
  alarmType
  enabled
  displayName
  alarmSeverity
  triggerOnRecurrence
  recurrenceUnit
  recurrencePeriod
  recurrenceCount
  systemNotification
  acknowledgementType
  urgentNotification
  delayThreshold
  delayThresholdUnit
  delayThresholdEnabled
  playAudibleAlert
  soundFile
}
    `;
export const DatabaseExportViewFragmentDoc = gql`
    fragment DatabaseExportView on IntersectionDeviceUIView {
  name
  displayName
  tables {
    name
    displayName
    indexes {
      name
    }
  }
}
    `;
export const DeviceDatabaseMibChangeLogFragmentFragmentDoc = gql`
    fragment DeviceDatabaseMibChangeLogFragment on DeviceDatabaseMibChangeLog {
  id
  databaseId
  updatedAt
  intersectionId
  comment
  userId
  userDisplayName
  databaseName
  deviceDatabaseType
  mib
}
    `;
export const DeviceDatabaseLockFragmentDoc = gql`
    fragment DeviceDatabaseLock on DeviceDatabaseLock {
  intersectionId
  databaseId
  lockedDate
  userId
  userDisplayName
}
    `;
export const DatabaseComparisonMibValueFragmentFragmentDoc = gql`
    fragment DatabaseComparisonMibValueFragment on DatabaseComparisonMibValue {
  tableName
  name
  shortName
  indexes
  bitIndex
  value
  description
}
    `;
export const DetectorGroupListItemFragmentDoc = gql`
    fragment DetectorGroupListItem on SignalDetectorGroup {
  id
  name
  aggregationMethod
  loggingEnabled
  loggingPeriodMinutes
  detectors {
    intersectionId
    detector
    direction
    movement
    weight
    note
  }
  description
}
    `;
export const MiniMapIntersectionFragmentDoc = gql`
    fragment MiniMapIntersection on Intersection {
  id
  details {
    name
  }
  location
  locationId
  devices {
    id
    name
    type
    fieldEntityProtocol
  }
  icons {
    name
    type
    location
    bearing
    config
    state
    link
  }
  lanes {
    id
    travelDirection
    vehicleDetectors {
      type
    }
  }
}
    `;
export const IntersectionStatusCategoriesFragmentFragmentDoc = gql`
    fragment IntersectionStatusCategoriesFragment on IntersectionStatusCategories {
  badPlan
  cabinetFlash
  commDisabled
  commFailed
  coordination
  unknown
  transition
  preempt
  localFlash
  free
}
    `;
export const ViewFragmentFragmentDoc = gql`
    fragment viewFragment on IntersectionDeviceUIView {
  name
  displayName
  tables {
    name
    displayName
    indexes {
      name
    }
  }
}
    `;
export const DeviceUiViewFragmentFragmentDoc = gql`
    fragment deviceUIViewFragment on IntersectionDeviceUIView {
  displayName
  tables {
    name
    displayName
    indexes {
      name
    }
  }
}
    `;
export const SignalsTaskFragmentFragmentDoc = gql`
    fragment SignalsTaskFragment on Task {
  id
  name
  taskType
  timezone
  start
  end
  data
  taskRecurrenceType
  rrule
  recurrenceEndDate
  externalCenterId
}
    `;
export const IntersectionDetailStatusFragmentDoc = gql`
    fragment IntersectionDetailStatus on IntersectionDetailStatus {
  category
  activeAlarms
  firmwareVersion
  time {
    globalTime
    drift
  }
  specialFunctionStatus {
    number
    active
  }
  preemptStatus {
    number
    enabled
    active
    mibValue
  }
  prioritorStatus {
    number
    enabled
    active
    mibValue
  }
  dynamicIndexedMibs {
    name
    shortName
    indexes
    bitIndex
  }
  unitFlashStatus
  isPreemptActive
  isPrioritorActive
  crosshairs {
    anchor {
      coordinates
      bearing
    }
    type
    phase
    color
  }
}
    `;
export const PatternStatusFragmentFragmentDoc = gql`
    fragment PatternStatusFragment on IntersectionPatternStatus {
  activeCycleLength
  programmedCycleLength
  coordStatus
  patternType
  patternNumber
  localCycle
  masterCycle
  programmedOffset
  activeOffset
}
    `;
export const DeviceEventFragmentFragmentDoc = gql`
    fragment DeviceEventFragment on DeviceEvent {
  id
  timestamp
  deviceId
  intersectionId
  parameter
  vendorEventCode
  __typename
}
    `;
export const AppliedCommandFragmentFragmentDoc = gql`
    fragment AppliedCommandFragment on SignalAppliedCommand {
  id
  taskId
  intersection {
    id
    name
  }
  device {
    id
    name
  }
  inheritedGroup {
    id
    name
  }
  command
  value
  source
  startDateTime
  endDateTime
  status
  __typename
}
    `;
export const GraphDataFragmentFragmentDoc = gql`
    fragment GraphDataFragment on GraphData {
  title
  xAxis {
    title
    type
    min
    max
  }
  yAxis {
    title
    type
    min
    max
    series
  }
  overlay {
    label
    x1
    x2
    type
    color
    opacity
  }
  checkPoints {
    type
    color
    legend
    dataPoints
  }
  data {
    name
    legend
    type
    color
    shape
    dataPoints {
      x
      y
    }
  }
}
    `;
export const TableDataFragmentFragmentDoc = gql`
    fragment TableDataFragment on GroupedReportTable {
  groupName
  groupedTables {
    __typename
    name
    columnProperties {
      name
      type
    }
    data
  }
}
    `;
export const ReportTabsFragmentFragmentDoc = gql`
    fragment ReportTabsFragment on ReportTab {
  tabName
  title
  graphData {
    ...GraphDataFragment
  }
  tableData {
    ...TableDataFragment
  }
}
    ${GraphDataFragmentFragmentDoc}
${TableDataFragmentFragmentDoc}`;
export const SignalActivityLogFragmentDoc = gql`
    fragment SignalActivityLog on ActivityLog {
  description
  timestamp
  changes {
    path
    operation
    oldValue
    newValue
  }
  object
  userId
  type
  id
}
    `;
export const IntersectionIconFragmentDoc = gql`
    fragment IntersectionIcon on IntersectionIcon {
  name
  type
  location
  bearing
  link
  config
}
    `;
export const SignalIndicationFragmentDoc = gql`
    fragment SignalIndication on SignalIndication {
  signalNumber
  signalType
  green
  yellow
  red
  greenFlashing
  yellowFlashing
  redFlashing
  greenIcon
  yellowIcon
  redIcon
}
    `;
export const BaseSignalTemplateDetailFragmentDoc = gql`
    fragment BaseSignalTemplateDetail on Intersection {
  id
  groupId
  locationId
  location
  centerInfo {
    id
    centerId
  }
  details {
    name
    mainPhases
    labels
    note
  }
  devices {
    id
    type
    name
    location
    fieldEntityProtocol
    connectionInfo
  }
  icons {
    ...IntersectionIcon
  }
  lanes {
    id
    description
    location
    laneDirection
    travelDirection
    vehicleDetectors {
      description
      distance
      length
      icon {
        ...IntersectionIcon
      }
      location
      number
      showOnMap
      type
      width
    }
  }
  crosswalks {
    id
    description
    location
    deviceId
    signalIndication {
      ...SignalIndication
    }
    icon {
      ...IntersectionIcon
    }
  }
  multiModals {
    deviceId
    signalIndication {
      ...SignalIndication
    }
    icon {
      ...IntersectionIcon
    }
  }
  maneuvers {
    id
    maneuverType
    refApproachLane
    refDepartureLane
    protectedSignalIndication {
      ...SignalIndication
    }
    permissiveSignalIndication {
      ...SignalIndication
    }
    icon {
      ...IntersectionIcon
    }
  }
}
    ${IntersectionIconFragmentDoc}
${SignalIndicationFragmentDoc}`;
export const BaseIntersectionDetailFragmentDoc = gql`
    fragment BaseIntersectionDetail on Intersection {
  id
  statusCategory
  groupId
  locationId
  location
  centerInfo {
    id
    centerId
  }
  details {
    name
    mainPhases
    labels
    note
  }
  devices {
    id
    type
    name
    location
    fieldEntityProtocol
    connectionInfo
  }
  icons {
    ...IntersectionIcon
  }
  lanes {
    id
    description
    location
    laneDirection
    travelDirection
    vehicleDetectors {
      description
      distance
      length
      icon {
        ...IntersectionIcon
      }
      location
      number
      showOnMap
      type
      width
    }
  }
  crosswalks {
    id
    description
    location
    deviceId
    signalIndication {
      ...SignalIndication
    }
    icon {
      ...IntersectionIcon
    }
  }
  multiModals {
    deviceId
    signalIndication {
      ...SignalIndication
    }
    icon {
      ...IntersectionIcon
    }
  }
  maneuvers {
    id
    maneuverType
    refApproachLane
    refDepartureLane
    protectedSignalIndication {
      ...SignalIndication
    }
    permissiveSignalIndication {
      ...SignalIndication
    }
    icon {
      ...IntersectionIcon
    }
  }
}
    ${IntersectionIconFragmentDoc}
${SignalIndicationFragmentDoc}`;
export const IntersectionDetailFragmentDoc = gql`
    fragment IntersectionDetail on Intersection {
  ...BaseIntersectionDetail
}
    ${BaseIntersectionDetailFragmentDoc}`;
export const PhaseServiceTimesFragmentFragmentDoc = gql`
    fragment phaseServiceTimesFragment on PhaseServiceTimes {
  green
  yellow
  red
}
    `;
export const TimeSpacePhaseFragmentFragmentDoc = gql`
    fragment timeSpacePhaseFragment on TimeSpacePhase {
  number
  historicData {
    ...phaseServiceTimesFragment
  }
}
    ${PhaseServiceTimesFragmentFragmentDoc}`;
export const TimeSpaceOffsetDataFragmentFragmentDoc = gql`
    fragment timeSpaceOffsetDataFragment on TimeSpaceOffsetData {
  value
  timestamp
}
    `;
export const DirectionalProgrammedSplitsFragmentFragmentDoc = gql`
    fragment directionalProgrammedSplitsFragment on DirectionalProgrammedSplits {
  up {
    ...phaseServiceTimesFragment
  }
  down {
    ...phaseServiceTimesFragment
  }
}
    ${PhaseServiceTimesFragmentFragmentDoc}`;
export const TimeSpacePatternFragmentFragmentDoc = gql`
    fragment timeSpacePatternFragment on TimeSpacePattern {
  number
  cycleLength
  offset {
    ...timeSpaceOffsetDataFragment
  }
  from
  to
  programmedSplits {
    ...directionalProgrammedSplitsFragment
  }
}
    ${TimeSpaceOffsetDataFragmentFragmentDoc}
${DirectionalProgrammedSplitsFragmentFragmentDoc}`;
export const TravelDirectionDataFragmentFragmentDoc = gql`
    fragment travelDirectionDataFragment on TravelDirectionData {
  speed
  distance
}
    `;
export const TrafficResponsivePlanDetectorGroupFragmentFragmentDoc = gql`
    fragment TrafficResponsivePlanDetectorGroupFragment on TrafficResponsivePlanDetectorGroup {
  detectorGroupId
  kValue
  volume
  occupancy
}
    `;
export const TrafficResponsivePlanActionFragmentFragmentDoc = gql`
    fragment TrafficResponsivePlanActionFragment on TrafficResponsivePlanAction {
  id
  name
  command
  minimumImprovement
  detectorGroups {
    ...TrafficResponsivePlanDetectorGroupFragment
  }
}
    ${TrafficResponsivePlanDetectorGroupFragmentFragmentDoc}`;
export const TrafficResponsivePlanFragmentFragmentDoc = gql`
    fragment TrafficResponsivePlanFragment on TrafficResponsivePlan {
  id
  name
  number
  description
  frequency
  actions {
    ...TrafficResponsivePlanActionFragment
  }
}
    ${TrafficResponsivePlanActionFragmentFragmentDoc}`;
export const SignMessageDetailsFragmentDoc = gql`
    fragment SignMessageDetails on SignLibraryMessage {
  message {
    ...SignMessage
  }
  sign
  name
  id
}
    ${SignMessageFragmentDoc}`;
export const SignListFragmentDoc = gql`
    fragment SignList on Sign {
  currentMessage {
    ...SignQueuedMessage
  }
  communicationStatus
  lastDataReceived
  referencePoint
  displayType {
    ...SignDisplayType
  }
  colorScheme
  laneDirection
  lanePosition
  capabilities
  backgroundColor
  foregroundColor
  direction
  location
  laneType
  median
  road
  name
  id
  tests {
    ...SignTestsType
  }
  queue {
    ...SignQueuedMessage
  }
}
    ${SignQueuedMessageFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignTestsTypeFragmentDoc}`;
export const LaneControlCommandFragmentDoc = gql`
    fragment LaneControlCommand on LaneControlCommand {
  defaultCommand
  message
  image
  name
}
    `;
export const LaneControlSettingsFragmentDoc = gql`
    fragment LaneControlSettings on LaneControlSettings {
  commands {
    ...LaneControlCommand
  }
  systemDefault
  defaultBlank
  signs
  name
  id
}
    ${LaneControlCommandFragmentDoc}`;
export const SignListFragmentFragmentDoc = gql`
    fragment SignListFragment on Sign {
  locationDescription
  communicationStatus
  lastDataReceived
  referencePoint
  externalCenter
  capabilities
  backgroundColor
  foregroundColor
  laneDirection
  lanePosition
  colorScheme
  laneType
  locationFixed
  direction
  messagePreferences {
    ...SignMessagePreferences
  }
  location
  displayType {
    ...SignDisplayType
  }
  speedSettings {
    ...SignSpeedSettings
  }
  road
  name
  id
  communicationParameters
  currentMessage {
    ...SignQueuedMessage
  }
  queue {
    ...SignQueuedMessage
  }
  tests {
    ...SignTestsType
  }
  corridors {
    id
    name
    type
  }
}
    ${SignMessagePreferencesFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignSpeedSettingsFragmentDoc}
${SignQueuedMessageFragmentDoc}
${SignTestsTypeFragmentDoc}`;
export const SignDetailFragmentDoc = gql`
    fragment SignDetail on Sign {
  cabinetTemperature
  housingTemperature
  locationDescription
  communicationStatus
  travelTimeSegments
  lastDataReceived
  brightnessLevels
  referencePoint
  brightnessMode
  externalCenter
  integrationId
  laneDirection
  lanePosition
  gateClosedTime
  colorScheme
  gateOpenTime
  laneType
  capabilities
  backgroundColor
  foregroundColor
  powerSource
  brightness
  external
  speedSettings {
    ...SignSpeedSettings
  }
  messagePreferences {
    ...SignMessagePreferences
  }
  direction
  displayType {
    ...SignDisplayType
  }
  lastReset
  location
  firmware
  readOnly
  errors
  tests {
    ...SignTestsType
  }
  commands {
    number
    command
  }
  messages {
    number
    hash
  }
  graphics {
    number
    label
    hash
  }
  fonts {
    number
    hash
  }
  volts
  road
  name
  id
  currentMessage {
    ...SignQueuedMessage
  }
  queue {
    ...SignQueuedMessage
  }
  defaultMessage {
    ...SignQueuedMessage
  }
  defaultMessageEnabled
}
    ${SignSpeedSettingsFragmentDoc}
${SignMessagePreferencesFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignTestsTypeFragmentDoc}
${SignQueuedMessageFragmentDoc}`;
export const SignGroupFragmentDoc = gql`
    fragment SignGroup on SignGroup {
  type
  description
  attributes
  name
  id
  signs {
    ...SignDetail
  }
}
    ${SignDetailFragmentDoc}`;
export const SignActivityLogFragmentDoc = gql`
    fragment SignActivityLog on ActivityLog {
  description
  timestamp
  changes {
    path
    operation
    oldValue
    newValue
  }
  object
  userId
  userFullName
  type
  id
}
    `;
export const SignSettingSectionFragmentDoc = gql`
    fragment SignSettingSection on ModuleFormSection {
  fields {
    ...FieldConfigFields
  }
  id
  name
}
    ${FieldConfigFieldsFragmentDoc}`;
export const SignSettingViewFragmentDoc = gql`
    fragment SignSettingView on FormView {
  id
  name
  sections {
    ...SignSettingSection
  }
  type
}
    ${SignSettingSectionFragmentDoc}`;
export const SignSettingViewsRecursiveFragmentDoc = gql`
    fragment SignSettingViewsRecursive on FormView {
  views {
    ...SignSettingView
    views {
      ...SignSettingView
      views {
        ...SignSettingView
      }
    }
  }
}
    ${SignSettingViewFragmentDoc}`;
export const SignSettingsFragmentDoc = gql`
    fragment SignSettings on ModuleSettingsFormView {
  id
  name
  views {
    ...SignSettingViewsRecursive
  }
  sections {
    ...SignSettingSection
  }
  type
}
    ${SignSettingViewsRecursiveFragmentDoc}
${SignSettingSectionFragmentDoc}`;
export const SignMessageOverrideFragmentDoc = gql`
    fragment SignMessageOverride on SignLibraryMessageOverride {
  message {
    ...SignMessage
  }
  hash
}
    ${SignMessageFragmentDoc}`;
export const SignLibraryMessageFragmentDoc = gql`
    fragment SignLibraryMessage on SignLibraryMessage {
  id
  name
  sign
  exclusions
  overrides {
    ...SignMessageOverride
  }
  message {
    ...SignMessage
  }
}
    ${SignMessageOverrideFragmentDoc}
${SignMessageFragmentDoc}`;
export const SignMessageHistoryFragmentDoc = gql`
    fragment SignMessageHistory on SignMessageHistory {
  associationDisplayNames
  timeBlanked
  blankedUser
  timePosted
  timeQueued
  postedUser
  associations
  message {
    ...SignMessage
  }
  id
  signId
  expirationTime
}
    ${SignMessageFragmentDoc}`;
export const SignDetailsFragmentDoc = gql`
    fragment SignDetails on Sign {
  locationDescription
  communicationStatus
  travelTimeSegments
  lastDataReceived
  brightnessLevels
  referencePoint
  colorScheme
  brightnessMode
  capabilities
  backgroundColor
  foregroundColor
  powerSource
  brightness
  messagePreferences {
    ...SignMessagePreferences
  }
  direction
  displayType {
    ...SignDisplayType
  }
  fonts {
    number
    hash
  }
  lastReset
  location
  firmware
  volts
  road
  name
  id
  currentMessage {
    ...SignQueuedMessage
  }
  queue {
    ...SignQueuedMessage
  }
  tests {
    ...SignTestsType
  }
}
    ${SignMessagePreferencesFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignQueuedMessageFragmentDoc}
${SignTestsTypeFragmentDoc}`;
export const KineticFormEventTypeFragmentDoc = gql`
    fragment KineticFormEventType on EventType {
  id
  name
}
    `;
export const TaskProgressFragmentFragmentDoc = gql`
    fragment TaskProgressFragment on TaskProgress {
  id
  name
  description
  status
  progress
  resource
  associatedIds
  systemTask
  userIds
  source
  created
  updated
  error
  task
  type
}
    `;
export const DeviceViewFragmentFragmentDoc = gql`
    fragment deviceViewFragment on IntersectionDeviceUIView {
  displayName
  name
}
    `;
export const SavedRouteFragmentDoc = gql`
    fragment SavedRoute on LocationRoute {
  id
  name
  classification
  direction
  geometry
}
    `;
export const PrivilegeAssignmentFragmentFragmentDoc = gql`
    fragment PrivilegeAssignmentFragment on KineticPrivilegeAssignment {
  id
  privilegeType
  kineticModule
  restrictedIntegrationGroups
  restrictedIntegrations
  restrictedAreas
  restrictedEntities
  restrictedLocationGroups
  restrictedLocations
}
    `;
export const KineticUserFragmentFragmentDoc = gql`
    fragment KineticUserFragment on OrganizationKineticUser {
  id
  username
  firstName
  lastName
  email
  phoneNumbers
  privilegeAssignmentList {
    ...PrivilegeAssignmentFragment
  }
  roleIds
  userGroupIds
  online
}
    ${PrivilegeAssignmentFragmentFragmentDoc}`;
export const MapConfigFragmentFragmentDoc = gql`
    fragment MapConfigFragment on MapConfig {
  id
  name
  geometry
  layers
  zoom
}
    `;
export const MapLayerConfigFragmentFragmentDoc = gql`
    fragment MapLayerConfigFragment on MapLayerConfig {
  id
  name
  type
  data
  baseLayer
  visible
  group
}
    `;
export const TaskFragmentFragmentDoc = gql`
    fragment TaskFragment on Task {
  id
  name
  taskType
  timezone
  start
  end
  data
  taskRecurrenceType
  rrule
  recurrenceEndDate
  externalCenterId
  exdate
}
    `;
export const TaskOccurrenceFragmentFragmentDoc = gql`
    fragment TaskOccurrenceFragment on TaskOccurrence {
  start
  end
  task {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;
export const TravelTimeFragmentDoc = gql`
    fragment TravelTime on TravelTime {
  incrementalReportedTime
  maximumReportedDelay
  minimumReportedDelay
  maximumReportedTime
  minimumReportedTime
  communicationState
  associatedSigns
  pollingEnabled
  externalCenter
  reportedTime
  smoothedTime
  historicTime
  lastConnect
  description
  travelTime
  geometry
  distance
  quality
  speed
  name
  id
  parts {
    startReference
    endReference
    direction
    road
  }
}
    `;
export const TravelTimeHistoryFragmentDoc = gql`
    fragment TravelTimeHistory on TravelTimeHistory {
  historicSpeed
  reportedTime
  smoothedTime
  historicTime
  travelTime
  timestamp
  quality
  speed
  id
}
    `;
export const SignDisplayTypesFragmentDoc = gql`
    fragment SignDisplayTypes on SignDisplayType {
  characterLabels {
    characterIndex
    label
  }
  matrixType
  characterWidth
  characterHeight
  defaultFont
  maxCharacters
  height
  width
  hash
  maxLines
}
    `;
export const TravelTimeMapEntityFragmentDoc = gql`
    fragment TravelTimeMapEntity on TravelTime {
  incrementalReportedTime
  maximumReportedDelay
  minimumReportedDelay
  maximumReportedTime
  minimumReportedTime
  communicationState
  reportedTime
  smoothedTime
  historicTime
  lastConnect
  travelTime
  geometry
  distance
  quality
  speed
  name
  id
  parts {
    startReference
    endReference
    direction
    road
  }
}
    `;
export const SharedPrivilegeAssignmentFragmentFragmentDoc = gql`
    fragment SharedPrivilegeAssignmentFragment on KineticPrivilegeAssignment {
  id
  privilegeType
  kineticModule
  restrictedIntegrationGroups
  restrictedIntegrations
  restrictedAreas
  restrictedEntities
}
    `;
export const SharedKineticUserFragmentFragmentDoc = gql`
    fragment SharedKineticUserFragment on OrganizationKineticUser {
  id
  username
  firstName
  lastName
  email
  phoneNumbers
  privilegeAssignmentList {
    ...SharedPrivilegeAssignmentFragment
  }
  roleIds
  userGroupIds
}
    ${SharedPrivilegeAssignmentFragmentFragmentDoc}`;
export const CameraSubGroupFragmentDoc = gql`
    fragment CameraSubGroup on SubGroup {
  name
  items {
    id
    name
    type
  }
}
    `;
export const CameraSubGroupRecursiveFragmentDoc = gql`
    fragment CameraSubGroupRecursive on CameraGroup {
  subGroups {
    ...CameraSubGroup
    subGroups {
      ...CameraSubGroup
      subGroups {
        ...CameraSubGroup
        subGroups {
          ...CameraSubGroup
          subGroups {
            ...CameraSubGroup
          }
        }
      }
    }
  }
}
    ${CameraSubGroupFragmentDoc}`;
export const CameraGroupFragmentFragmentDoc = gql`
    fragment CameraGroupFragment on CameraGroup {
  id
  name
  description
  order
  items {
    id
    name
    type
  }
  ...CameraSubGroupRecursive
}
    ${CameraSubGroupRecursiveFragmentDoc}`;
export const CreatedJobRequestFragmentDoc = gql`
    fragment CreatedJobRequest on JobRequest {
  success
  requestId
  id
  failure
}
    `;
export const LayoutAreaFragmentDoc = gql`
    fragment LayoutArea on LayoutArea {
  columns
  rows
  areaId
  disabled
}
    `;
export const LayoutFragmentDoc = gql`
    fragment Layout on Layout {
  id
  name
  description
  areas {
    ...LayoutArea
  }
}
    ${LayoutAreaFragmentDoc}`;
export const CameraListNodeFragmentFragmentDoc = gql`
    fragment CameraListNodeFragment on Camera {
  id
  name
  description
  autoIrisEnabled
  autoPanEnabled
  autoFocusEnabled
  road
  direction
  referencePoint
  location
  locationFixed
  locationDescription
  userNotes
  communicationStatus
  poweredOn
  firmware
  dataReceived
  lastSuccessfulPoll
  lastPollAttempt
  timeDrift
  communicationParameters
  liveRecordings {
    id
    recordingName
    recordingType
  }
}
    `;
export const CameraNodeFragmentFragmentDoc = gql`
    fragment CameraNodeFragment on Camera {
  id
  name
  communicationStatus
  poweredOn
  road
  direction
  description
  locationDescription
  userNotes
  referencePoint
  presets {
    id
    name
    presetIndex
    isHomePreset
    isSystem
  }
  ptzLock {
    isLocked
    requireExplicitCameraControlLocking
    userId
    fullName
    lockStartedAt
    lockEndsAt
    lastUsedTime
  }
  streams {
    name
    url
    accessType
    application
    streamName
    streamType
  }
  capabilities {
    capability
    options
  }
  capabilitiesState
  communicationParameters
}
    `;
export const TourListNodeFragmentFragmentDoc = gql`
    fragment TourListNodeFragment on Tour {
  id
  name
  steps {
    camera {
      id
      name
      camera {
        ...CameraNodeFragment
      }
    }
    preset {
      id
      name
    }
  }
  description
  speed
  heartBeatIntervalSeconds
}
    ${CameraNodeFragmentFragmentDoc}`;
export const WidgetFragmentDoc = gql`
    fragment Widget on Widget {
  id
  name
  type
  properties
}
    `;
export const ScreenFragmentDoc = gql`
    fragment Screen on Screen {
  id
  name
  description
  ownershipType
  orderNum
  layout {
    ...Layout
  }
  content {
    ... on Camera {
      ...CameraListNodeFragment
    }
    ... on Tour {
      ...TourListNodeFragment
    }
    ... on Widget {
      ...Widget
    }
  }
  type
  videoWallId
}
    ${LayoutFragmentDoc}
${CameraListNodeFragmentFragmentDoc}
${TourListNodeFragmentFragmentDoc}
${WidgetFragmentDoc}`;
export const SceneFragmentDoc = gql`
    fragment Scene on Scene {
  id
  name
  ownershipType
  layout {
    ...Layout
  }
  content {
    ... on Camera {
      ...CameraListNodeFragment
    }
    ... on Tour {
      ...TourListNodeFragment
    }
    ... on Widget {
      ...Widget
    }
  }
}
    ${LayoutFragmentDoc}
${CameraListNodeFragmentFragmentDoc}
${TourListNodeFragmentFragmentDoc}
${WidgetFragmentDoc}`;
export const SettingFieldsFragmentDoc = gql`
    fragment settingFields on FieldConfig {
  id
  name
  label
  type
  required
  help
  hint
  fieldSize
  sortOrder
  options {
    label
    value
  }
  disablePast
  disableFuture
  useStepper
  max
  min
  step
  multiple
  limitTags
  selectAllLabel
  deselectAllLabel
  useCheckedIcon
  useIcon
  choicesTitle
  chosenTitle
  defaultValue
  format
  displayFormat
  activeLogic
  requiredLogic
  rows
  multiline
}
    `;
export const SettingSectionsFragmentDoc = gql`
    fragment settingSections on ModuleFormSection {
  fields {
    ...settingFields
  }
  id
  name
}
    ${SettingFieldsFragmentDoc}`;
export const VideoSettingViewsFragmentDoc = gql`
    fragment videoSettingViews on FormView {
  id
  name
  sections {
    ...settingSections
  }
  type
}
    ${SettingSectionsFragmentDoc}`;
export const VideoSettingViewsRecursiveFragmentDoc = gql`
    fragment videoSettingViewsRecursive on FormView {
  views {
    ...videoSettingViews
    views {
      ...videoSettingViews
      views {
        ...videoSettingViews
      }
    }
  }
}
    ${VideoSettingViewsFragmentDoc}`;
export const VideoFormFragmentDoc = gql`
    fragment VideoForm on ModuleSettingsFormView {
  id
  name
  views {
    ...videoSettingViewsRecursive
  }
  sections {
    ...settingSections
  }
  type
}
    ${VideoSettingViewsRecursiveFragmentDoc}
${SettingSectionsFragmentDoc}`;
export const ToursFieldsFragmentDoc = gql`
    fragment ToursFields on Tour {
  id
  name
  description
  isSystem
}
    `;
export const CameraLocationInfoFragmentFragmentDoc = gql`
    fragment CameraLocationInfoFragment on Camera {
  location
  road
  direction
  referencePoint
  locationDescription
}
    `;
export const VideoRecordNodeFragmentFragmentDoc = gql`
    fragment VideoRecordNodeFragment on VideoRecord {
  id
  recorderId
  recorderName
  recordingStart
  recordingEnd
  recordingType
  recordingInitiatorId
  recordingInitiatedBy
  recordingInitiatorProperties
  recordingDuration
  cameraId
  cameraName
  recordingName
  camera {
    ...CameraLocationInfoFragment
  }
  streamUrl
  serverFileName
  recorderType
  size
  redundancyEnabled
  secondaryServer
}
    ${CameraLocationInfoFragmentFragmentDoc}`;
export const SnapshotNodeFragmentFragmentDoc = gql`
    fragment SnapshotNodeFragment on Snapshot {
  id
  path
  size
  module
  key
  camera {
    id
    name
  }
  serverFileName
  timestamp
}
    `;
export const CameraTaskFragmentFragmentDoc = gql`
    fragment CameraTaskFragment on Task {
  id
  name
  taskType
  timezone
  start
  end
  data
  taskRecurrenceType
  rrule
  recurrenceEndDate
  externalCenterId
}
    `;
export const CameraTaskOccurrenceFragmentFragmentDoc = gql`
    fragment CameraTaskOccurrenceFragment on TaskOccurrence {
  start
  end
  task {
    ...CameraTaskFragment
  }
}
    ${CameraTaskFragmentFragmentDoc}`;
export const VideoStreamBlockFragmentDoc = gql`
    fragment VideoStreamBlock on VideoStreamBlock {
  id
  cameraId
  streamName
  endsAt
  duration
  tags
  associatedEventIds
  reason
  serverConfirmed
  blockedUntil
}
    `;
export const WeatherStationReadingFragmentDoc = gql`
    fragment WeatherStationReading on WeatherStationReading {
  linkAddress
  category
  value
  valid
  units
  type
}
    `;
export const WeatherStationListFragmentDoc = gql`
    fragment WeatherStationList on WeatherStation {
  communicationStatus
  lastDataReceived
  referencePoint
  description
  readings {
    ...WeatherStationReading
  }
  direction
  location
  values
  road
  name
  id
  communicationParameters
  externalCenter
}
    ${WeatherStationReadingFragmentDoc}`;
export const WeatherStationHistoryFragmentDoc = gql`
    fragment WeatherStationHistory on WeatherStationHistory {
  readings {
    ...WeatherStationReading
  }
  linkAddress
  timestamp
  category
  id
}
    ${WeatherStationReadingFragmentDoc}`;
export const WeatherStationSelectFragmentDoc = gql`
    fragment WeatherStationSelect on WeatherStation {
  name
  id
}
    `;
export const WeatherStationChartHistoryDataFragmentDoc = gql`
    fragment WeatherStationChartHistoryData on WeatherStationChartHistoryData {
  timestamp
  value
}
    `;
export const WeatherStationChartHistoryFragmentDoc = gql`
    fragment WeatherStationChartHistory on WeatherStationChartHistory {
  linkAddress
  type
  data {
    ...WeatherStationChartHistoryData
  }
}
    ${WeatherStationChartHistoryDataFragmentDoc}`;
export const SignalActionSetSelectionListDocument = gql`
    query SignalActionSetSelectionList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  signalActionSets(
    searchText: $searchText
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    before: $before
    after: $after
    limit: $limit
  ) {
    edges {
      node {
        number
        impact
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useSignalActionSetSelectionListQuery__
 *
 * To run a query within a React component, call `useSignalActionSetSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalActionSetSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalActionSetSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSignalActionSetSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<SignalActionSetSelectionListQuery, SignalActionSetSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalActionSetSelectionListQuery, SignalActionSetSelectionListQueryVariables>(SignalActionSetSelectionListDocument, options);
      }
export function useSignalActionSetSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalActionSetSelectionListQuery, SignalActionSetSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalActionSetSelectionListQuery, SignalActionSetSelectionListQueryVariables>(SignalActionSetSelectionListDocument, options);
        }
export type SignalActionSetSelectionListQueryHookResult = ReturnType<typeof useSignalActionSetSelectionListQuery>;
export type SignalActionSetSelectionListLazyQueryHookResult = ReturnType<typeof useSignalActionSetSelectionListLazyQuery>;
export type SignalActionSetSelectionListQueryResult = Apollo.QueryResult<SignalActionSetSelectionListQuery, SignalActionSetSelectionListQueryVariables>;
export function refetchSignalActionSetSelectionListQuery(variables?: SignalActionSetSelectionListQueryVariables) {
      return { query: SignalActionSetSelectionListDocument, variables: variables }
    }
export const ExportActivityLogsDocument = gql`
    mutation ExportActivityLogs($filters: [FilterInput!]!, $searchText: String!, $searchFields: [String!]!, $config: ExportConfig!, $sortOrder: SortOrder) {
  exportActivityLogs(
    filters: $filters
    searchText: $searchText
    config: $config
    searchFields: $searchFields
    sortOrder: $sortOrder
  )
}
    `;
export type ExportActivityLogsMutationFn = Apollo.MutationFunction<ExportActivityLogsMutation, ExportActivityLogsMutationVariables>;

/**
 * __useExportActivityLogsMutation__
 *
 * To run a mutation, you first call `useExportActivityLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportActivityLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportActivityLogsMutation, { data, loading, error }] = useExportActivityLogsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      config: // value for 'config'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useExportActivityLogsMutation(baseOptions?: Apollo.MutationHookOptions<ExportActivityLogsMutation, ExportActivityLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportActivityLogsMutation, ExportActivityLogsMutationVariables>(ExportActivityLogsDocument, options);
      }
export type ExportActivityLogsMutationHookResult = ReturnType<typeof useExportActivityLogsMutation>;
export type ExportActivityLogsMutationResult = Apollo.MutationResult<ExportActivityLogsMutation>;
export type ExportActivityLogsMutationOptions = Apollo.BaseMutationOptions<ExportActivityLogsMutation, ExportActivityLogsMutationVariables>;
export const ActivityLogsDocument = gql`
    query ActivityLogs($after: String, $before: String, $limit: Int = 100, $searchText: String, $searchFields: [String!] = ["description", "translationVariables", "object.name", "userFullName", "action"], $sortOrder: SortOrder, $filters: [FilterInput!]!) {
  activityLogs(
    after: $after
    before: $before
    limit: $limit
    searchText: $searchText
    filters: $filters
    searchFields: $searchFields
    sortOrder: $sortOrder
  ) {
    edges {
      node {
        ...ActivityLogNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useActivityLogsQuery__
 *
 * To run a query within a React component, call `useActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useActivityLogsQuery(baseOptions: Apollo.QueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
      }
export function useActivityLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
        }
export type ActivityLogsQueryHookResult = ReturnType<typeof useActivityLogsQuery>;
export type ActivityLogsLazyQueryHookResult = ReturnType<typeof useActivityLogsLazyQuery>;
export type ActivityLogsQueryResult = Apollo.QueryResult<ActivityLogsQuery, ActivityLogsQueryVariables>;
export function refetchActivityLogsQuery(variables: ActivityLogsQueryVariables) {
      return { query: ActivityLogsDocument, variables: variables }
    }
export const ActivityLogAddedDocument = gql`
    subscription ActivityLogAdded($ids: [ID!]) {
  addedActivityLog(ids: $ids) {
    ...ActivityLogNodeFragment
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}`;

/**
 * __useActivityLogAddedSubscription__
 *
 * To run a query within a React component, call `useActivityLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogAddedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useActivityLogAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ActivityLogAddedSubscription, ActivityLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ActivityLogAddedSubscription, ActivityLogAddedSubscriptionVariables>(ActivityLogAddedDocument, options);
      }
export type ActivityLogAddedSubscriptionHookResult = ReturnType<typeof useActivityLogAddedSubscription>;
export type ActivityLogAddedSubscriptionResult = Apollo.SubscriptionResult<ActivityLogAddedSubscription>;
export const IsActivityLogValidatedDocument = gql`
    query IsActivityLogValidated($id: ID!) {
  validateActivityLog(id: $id)
}
    `;

/**
 * __useIsActivityLogValidatedQuery__
 *
 * To run a query within a React component, call `useIsActivityLogValidatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsActivityLogValidatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsActivityLogValidatedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsActivityLogValidatedQuery(baseOptions: Apollo.QueryHookOptions<IsActivityLogValidatedQuery, IsActivityLogValidatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsActivityLogValidatedQuery, IsActivityLogValidatedQueryVariables>(IsActivityLogValidatedDocument, options);
      }
export function useIsActivityLogValidatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsActivityLogValidatedQuery, IsActivityLogValidatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsActivityLogValidatedQuery, IsActivityLogValidatedQueryVariables>(IsActivityLogValidatedDocument, options);
        }
export type IsActivityLogValidatedQueryHookResult = ReturnType<typeof useIsActivityLogValidatedQuery>;
export type IsActivityLogValidatedLazyQueryHookResult = ReturnType<typeof useIsActivityLogValidatedLazyQuery>;
export type IsActivityLogValidatedQueryResult = Apollo.QueryResult<IsActivityLogValidatedQuery, IsActivityLogValidatedQueryVariables>;
export function refetchIsActivityLogValidatedQuery(variables: IsActivityLogValidatedQueryVariables) {
      return { query: IsActivityLogValidatedDocument, variables: variables }
    }
export const ExportAlarmsListDocument = gql`
    mutation ExportAlarmsList($query: AlarmsQuery, $fileName: String!, $customDataKeys: [String!]) {
  exportAlarms(
    query: $query
    fileName: $fileName
    customDataKeys: $customDataKeys
  )
}
    `;
export type ExportAlarmsListMutationFn = Apollo.MutationFunction<ExportAlarmsListMutation, ExportAlarmsListMutationVariables>;

/**
 * __useExportAlarmsListMutation__
 *
 * To run a mutation, you first call `useExportAlarmsListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAlarmsListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAlarmsListMutation, { data, loading, error }] = useExportAlarmsListMutation({
 *   variables: {
 *      query: // value for 'query'
 *      fileName: // value for 'fileName'
 *      customDataKeys: // value for 'customDataKeys'
 *   },
 * });
 */
export function useExportAlarmsListMutation(baseOptions?: Apollo.MutationHookOptions<ExportAlarmsListMutation, ExportAlarmsListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAlarmsListMutation, ExportAlarmsListMutationVariables>(ExportAlarmsListDocument, options);
      }
export type ExportAlarmsListMutationHookResult = ReturnType<typeof useExportAlarmsListMutation>;
export type ExportAlarmsListMutationResult = Apollo.MutationResult<ExportAlarmsListMutation>;
export type ExportAlarmsListMutationOptions = Apollo.BaseMutationOptions<ExportAlarmsListMutation, ExportAlarmsListMutationVariables>;
export const AcknowledgeAlarmsDocument = gql`
    mutation AcknowledgeAlarms($ids: [ID!]!, $comments: String, $centerId: String) {
  acknowledgeAlarms(ids: $ids, comments: $comments, centerId: $centerId) {
    id
    acknowledged
    acknowledgedBy
    acknowledgedAt
    comments
  }
}
    `;
export type AcknowledgeAlarmsMutationFn = Apollo.MutationFunction<AcknowledgeAlarmsMutation, AcknowledgeAlarmsMutationVariables>;

/**
 * __useAcknowledgeAlarmsMutation__
 *
 * To run a mutation, you first call `useAcknowledgeAlarmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeAlarmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeAlarmsMutation, { data, loading, error }] = useAcknowledgeAlarmsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      comments: // value for 'comments'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useAcknowledgeAlarmsMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeAlarmsMutation, AcknowledgeAlarmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeAlarmsMutation, AcknowledgeAlarmsMutationVariables>(AcknowledgeAlarmsDocument, options);
      }
export type AcknowledgeAlarmsMutationHookResult = ReturnType<typeof useAcknowledgeAlarmsMutation>;
export type AcknowledgeAlarmsMutationResult = Apollo.MutationResult<AcknowledgeAlarmsMutation>;
export type AcknowledgeAlarmsMutationOptions = Apollo.BaseMutationOptions<AcknowledgeAlarmsMutation, AcknowledgeAlarmsMutationVariables>;
export const ClearAlarmAcknowledgementDocument = gql`
    mutation ClearAlarmAcknowledgement($ids: [ID!]!, $comments: String, $centerId: String) {
  clearAlarmAcknowledgement(ids: $ids, comments: $comments, centerId: $centerId) {
    id
    acknowledged
    comments
  }
}
    `;
export type ClearAlarmAcknowledgementMutationFn = Apollo.MutationFunction<ClearAlarmAcknowledgementMutation, ClearAlarmAcknowledgementMutationVariables>;

/**
 * __useClearAlarmAcknowledgementMutation__
 *
 * To run a mutation, you first call `useClearAlarmAcknowledgementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAlarmAcknowledgementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAlarmAcknowledgementMutation, { data, loading, error }] = useClearAlarmAcknowledgementMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      comments: // value for 'comments'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useClearAlarmAcknowledgementMutation(baseOptions?: Apollo.MutationHookOptions<ClearAlarmAcknowledgementMutation, ClearAlarmAcknowledgementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAlarmAcknowledgementMutation, ClearAlarmAcknowledgementMutationVariables>(ClearAlarmAcknowledgementDocument, options);
      }
export type ClearAlarmAcknowledgementMutationHookResult = ReturnType<typeof useClearAlarmAcknowledgementMutation>;
export type ClearAlarmAcknowledgementMutationResult = Apollo.MutationResult<ClearAlarmAcknowledgementMutation>;
export type ClearAlarmAcknowledgementMutationOptions = Apollo.BaseMutationOptions<ClearAlarmAcknowledgementMutation, ClearAlarmAcknowledgementMutationVariables>;
export const UpdateAlarmCommentsDocument = gql`
    mutation UpdateAlarmComments($ids: [ID!]!, $comments: String, $centerId: String) {
  updateAlarmComments(ids: $ids, comments: $comments, centerId: $centerId) {
    id
    comments
    updatedAt
  }
}
    `;
export type UpdateAlarmCommentsMutationFn = Apollo.MutationFunction<UpdateAlarmCommentsMutation, UpdateAlarmCommentsMutationVariables>;

/**
 * __useUpdateAlarmCommentsMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlarmCommentsMutation, { data, loading, error }] = useUpdateAlarmCommentsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      comments: // value for 'comments'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useUpdateAlarmCommentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlarmCommentsMutation, UpdateAlarmCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlarmCommentsMutation, UpdateAlarmCommentsMutationVariables>(UpdateAlarmCommentsDocument, options);
      }
export type UpdateAlarmCommentsMutationHookResult = ReturnType<typeof useUpdateAlarmCommentsMutation>;
export type UpdateAlarmCommentsMutationResult = Apollo.MutationResult<UpdateAlarmCommentsMutation>;
export type UpdateAlarmCommentsMutationOptions = Apollo.BaseMutationOptions<UpdateAlarmCommentsMutation, UpdateAlarmCommentsMutationVariables>;
export const ClearAlarmsDocument = gql`
    mutation ClearAlarms($ids: [ID!]!, $centerId: String) {
  clearAlarms(ids: $ids, centerId: $centerId) {
    id
    clearedAt
  }
}
    `;
export type ClearAlarmsMutationFn = Apollo.MutationFunction<ClearAlarmsMutation, ClearAlarmsMutationVariables>;

/**
 * __useClearAlarmsMutation__
 *
 * To run a mutation, you first call `useClearAlarmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAlarmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAlarmsMutation, { data, loading, error }] = useClearAlarmsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useClearAlarmsMutation(baseOptions?: Apollo.MutationHookOptions<ClearAlarmsMutation, ClearAlarmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAlarmsMutation, ClearAlarmsMutationVariables>(ClearAlarmsDocument, options);
      }
export type ClearAlarmsMutationHookResult = ReturnType<typeof useClearAlarmsMutation>;
export type ClearAlarmsMutationResult = Apollo.MutationResult<ClearAlarmsMutation>;
export type ClearAlarmsMutationOptions = Apollo.BaseMutationOptions<ClearAlarmsMutation, ClearAlarmsMutationVariables>;
export const ClearAllAlarmsDocument = gql`
    mutation ClearAllAlarms($source: KineticModule!) {
  clearAllAlarms(source: $source)
}
    `;
export type ClearAllAlarmsMutationFn = Apollo.MutationFunction<ClearAllAlarmsMutation, ClearAllAlarmsMutationVariables>;

/**
 * __useClearAllAlarmsMutation__
 *
 * To run a mutation, you first call `useClearAllAlarmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllAlarmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllAlarmsMutation, { data, loading, error }] = useClearAllAlarmsMutation({
 *   variables: {
 *      source: // value for 'source'
 *   },
 * });
 */
export function useClearAllAlarmsMutation(baseOptions?: Apollo.MutationHookOptions<ClearAllAlarmsMutation, ClearAllAlarmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAllAlarmsMutation, ClearAllAlarmsMutationVariables>(ClearAllAlarmsDocument, options);
      }
export type ClearAllAlarmsMutationHookResult = ReturnType<typeof useClearAllAlarmsMutation>;
export type ClearAllAlarmsMutationResult = Apollo.MutationResult<ClearAllAlarmsMutation>;
export type ClearAllAlarmsMutationOptions = Apollo.BaseMutationOptions<ClearAllAlarmsMutation, ClearAllAlarmsMutationVariables>;
export const ClearAllAlarmsForEntityDocument = gql`
    mutation ClearAllAlarmsForEntity($entityType: AlarmEntityType!, $entityId: ID!) {
  clearAllAlarmsForEntity(entityType: $entityType, entityId: $entityId)
}
    `;
export type ClearAllAlarmsForEntityMutationFn = Apollo.MutationFunction<ClearAllAlarmsForEntityMutation, ClearAllAlarmsForEntityMutationVariables>;

/**
 * __useClearAllAlarmsForEntityMutation__
 *
 * To run a mutation, you first call `useClearAllAlarmsForEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllAlarmsForEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllAlarmsForEntityMutation, { data, loading, error }] = useClearAllAlarmsForEntityMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useClearAllAlarmsForEntityMutation(baseOptions?: Apollo.MutationHookOptions<ClearAllAlarmsForEntityMutation, ClearAllAlarmsForEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAllAlarmsForEntityMutation, ClearAllAlarmsForEntityMutationVariables>(ClearAllAlarmsForEntityDocument, options);
      }
export type ClearAllAlarmsForEntityMutationHookResult = ReturnType<typeof useClearAllAlarmsForEntityMutation>;
export type ClearAllAlarmsForEntityMutationResult = Apollo.MutationResult<ClearAllAlarmsForEntityMutation>;
export type ClearAllAlarmsForEntityMutationOptions = Apollo.BaseMutationOptions<ClearAllAlarmsForEntityMutation, ClearAllAlarmsForEntityMutationVariables>;
export const ExportAlarmConfigurationsDocument = gql`
    mutation ExportAlarmConfigurations($query: AlarmConfigsQuery!) {
  exportAlarmConfigs(query: $query)
}
    `;
export type ExportAlarmConfigurationsMutationFn = Apollo.MutationFunction<ExportAlarmConfigurationsMutation, ExportAlarmConfigurationsMutationVariables>;

/**
 * __useExportAlarmConfigurationsMutation__
 *
 * To run a mutation, you first call `useExportAlarmConfigurationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAlarmConfigurationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAlarmConfigurationsMutation, { data, loading, error }] = useExportAlarmConfigurationsMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useExportAlarmConfigurationsMutation(baseOptions?: Apollo.MutationHookOptions<ExportAlarmConfigurationsMutation, ExportAlarmConfigurationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAlarmConfigurationsMutation, ExportAlarmConfigurationsMutationVariables>(ExportAlarmConfigurationsDocument, options);
      }
export type ExportAlarmConfigurationsMutationHookResult = ReturnType<typeof useExportAlarmConfigurationsMutation>;
export type ExportAlarmConfigurationsMutationResult = Apollo.MutationResult<ExportAlarmConfigurationsMutation>;
export type ExportAlarmConfigurationsMutationOptions = Apollo.BaseMutationOptions<ExportAlarmConfigurationsMutation, ExportAlarmConfigurationsMutationVariables>;
export const AlarmConfigOptionsDocument = gql`
    query AlarmConfigOptions($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $filters: [FilterInput], $limit: Int = 10000) {
  alarmConfigs(
    query: {sortField: $sortField, sortOrder: $sortOrder, filters: $filters, limit: $limit}
  ) {
    edges {
      node {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useAlarmConfigOptionsQuery__
 *
 * To run a query within a React component, call `useAlarmConfigOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlarmConfigOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlarmConfigOptionsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAlarmConfigOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AlarmConfigOptionsQuery, AlarmConfigOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlarmConfigOptionsQuery, AlarmConfigOptionsQueryVariables>(AlarmConfigOptionsDocument, options);
      }
export function useAlarmConfigOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlarmConfigOptionsQuery, AlarmConfigOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlarmConfigOptionsQuery, AlarmConfigOptionsQueryVariables>(AlarmConfigOptionsDocument, options);
        }
export type AlarmConfigOptionsQueryHookResult = ReturnType<typeof useAlarmConfigOptionsQuery>;
export type AlarmConfigOptionsLazyQueryHookResult = ReturnType<typeof useAlarmConfigOptionsLazyQuery>;
export type AlarmConfigOptionsQueryResult = Apollo.QueryResult<AlarmConfigOptionsQuery, AlarmConfigOptionsQueryVariables>;
export function refetchAlarmConfigOptionsQuery(variables?: AlarmConfigOptionsQueryVariables) {
      return { query: AlarmConfigOptionsDocument, variables: variables }
    }
export const AlarmsListDocument = gql`
    query AlarmsList($searchFields: [String!] = ["displayName", "name", "comments", "entityId", "data.ENTITY_NAME", "acknowledgedByDisplayName"], $searchText: String, $sortOrder: SortOrder = DESCENDING, $sortField: String = "updatedAt", $filters: [FilterInput], $limit: Int = 10, $before: String, $after: String) {
  alarms(
    query: {searchFields: $searchFields, searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, limit: $limit, before: $before, after: $after}
  ) {
    edges {
      node {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        acknowledgedByDisplayName
        active
        activeAt
        clearedAt
        comments
        recurrenceCount
        data
        config {
          acknowledgementType
        }
        entityId
        entityType
        id
        name
        displayName
        receivedAt
        severity
        source
        updatedAt
        centerId
        resolved
        subtypes
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useAlarmsListQuery__
 *
 * To run a query within a React component, call `useAlarmsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlarmsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlarmsListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAlarmsListQuery(baseOptions?: Apollo.QueryHookOptions<AlarmsListQuery, AlarmsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlarmsListQuery, AlarmsListQueryVariables>(AlarmsListDocument, options);
      }
export function useAlarmsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlarmsListQuery, AlarmsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlarmsListQuery, AlarmsListQueryVariables>(AlarmsListDocument, options);
        }
export type AlarmsListQueryHookResult = ReturnType<typeof useAlarmsListQuery>;
export type AlarmsListLazyQueryHookResult = ReturnType<typeof useAlarmsListLazyQuery>;
export type AlarmsListQueryResult = Apollo.QueryResult<AlarmsListQuery, AlarmsListQueryVariables>;
export function refetchAlarmsListQuery(variables?: AlarmsListQueryVariables) {
      return { query: AlarmsListDocument, variables: variables }
    }
export const LiveAlarmsListDocument = gql`
    subscription LiveAlarmsList($ids: [ID!]) {
  alarmUpdated(ids: $ids) {
    acknowledged
    acknowledgedAt
    acknowledgedBy
    active
    activeAt
    clearedAt
    comments
    recurrenceCount
    data
    entityId
    entityType
    id
    name
    displayName
    receivedAt
    severity
    source
    updatedAt
    resolved
  }
}
    `;

/**
 * __useLiveAlarmsListSubscription__
 *
 * To run a query within a React component, call `useLiveAlarmsListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveAlarmsListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveAlarmsListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveAlarmsListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveAlarmsListSubscription, LiveAlarmsListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveAlarmsListSubscription, LiveAlarmsListSubscriptionVariables>(LiveAlarmsListDocument, options);
      }
export type LiveAlarmsListSubscriptionHookResult = ReturnType<typeof useLiveAlarmsListSubscription>;
export type LiveAlarmsListSubscriptionResult = Apollo.SubscriptionResult<LiveAlarmsListSubscription>;
export const CountsAlarmSummaryDocument = gql`
    query CountsAlarmSummary {
  INFORMATIONAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["INFORMATIONAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: COUNTS}]}
  ) {
    totalCount
  }
  WARNING: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["WARNING"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: COUNTS}]}
  ) {
    totalCount
  }
  CRITICAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["CRITICAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: COUNTS}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useCountsAlarmSummaryQuery__
 *
 * To run a query within a React component, call `useCountsAlarmSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountsAlarmSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountsAlarmSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountsAlarmSummaryQuery(baseOptions?: Apollo.QueryHookOptions<CountsAlarmSummaryQuery, CountsAlarmSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountsAlarmSummaryQuery, CountsAlarmSummaryQueryVariables>(CountsAlarmSummaryDocument, options);
      }
export function useCountsAlarmSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountsAlarmSummaryQuery, CountsAlarmSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountsAlarmSummaryQuery, CountsAlarmSummaryQueryVariables>(CountsAlarmSummaryDocument, options);
        }
export type CountsAlarmSummaryQueryHookResult = ReturnType<typeof useCountsAlarmSummaryQuery>;
export type CountsAlarmSummaryLazyQueryHookResult = ReturnType<typeof useCountsAlarmSummaryLazyQuery>;
export type CountsAlarmSummaryQueryResult = Apollo.QueryResult<CountsAlarmSummaryQuery, CountsAlarmSummaryQueryVariables>;
export function refetchCountsAlarmSummaryQuery(variables?: CountsAlarmSummaryQueryVariables) {
      return { query: CountsAlarmSummaryDocument, variables: variables }
    }
export const GatesAlarmSummaryDocument = gql`
    query GatesAlarmSummary {
  INFORMATIONAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["INFORMATIONAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: GATES}]}
  ) {
    totalCount
  }
  WARNING: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["WARNING"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: GATES}]}
  ) {
    totalCount
  }
  CRITICAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["CRITICAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: GATES}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useGatesAlarmSummaryQuery__
 *
 * To run a query within a React component, call `useGatesAlarmSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatesAlarmSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatesAlarmSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGatesAlarmSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GatesAlarmSummaryQuery, GatesAlarmSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GatesAlarmSummaryQuery, GatesAlarmSummaryQueryVariables>(GatesAlarmSummaryDocument, options);
      }
export function useGatesAlarmSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatesAlarmSummaryQuery, GatesAlarmSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GatesAlarmSummaryQuery, GatesAlarmSummaryQueryVariables>(GatesAlarmSummaryDocument, options);
        }
export type GatesAlarmSummaryQueryHookResult = ReturnType<typeof useGatesAlarmSummaryQuery>;
export type GatesAlarmSummaryLazyQueryHookResult = ReturnType<typeof useGatesAlarmSummaryLazyQuery>;
export type GatesAlarmSummaryQueryResult = Apollo.QueryResult<GatesAlarmSummaryQuery, GatesAlarmSummaryQueryVariables>;
export function refetchGatesAlarmSummaryQuery(variables?: GatesAlarmSummaryQueryVariables) {
      return { query: GatesAlarmSummaryDocument, variables: variables }
    }
export const EventsAlarmSummaryDocument = gql`
    query EventsAlarmSummary {
  INFORMATIONAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["INFORMATIONAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: EVENTS}]}
  ) {
    totalCount
  }
  WARNING: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["WARNING"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: EVENTS}]}
  ) {
    totalCount
  }
  CRITICAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["CRITICAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: EVENTS}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useEventsAlarmSummaryQuery__
 *
 * To run a query within a React component, call `useEventsAlarmSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsAlarmSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsAlarmSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventsAlarmSummaryQuery(baseOptions?: Apollo.QueryHookOptions<EventsAlarmSummaryQuery, EventsAlarmSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsAlarmSummaryQuery, EventsAlarmSummaryQueryVariables>(EventsAlarmSummaryDocument, options);
      }
export function useEventsAlarmSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsAlarmSummaryQuery, EventsAlarmSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsAlarmSummaryQuery, EventsAlarmSummaryQueryVariables>(EventsAlarmSummaryDocument, options);
        }
export type EventsAlarmSummaryQueryHookResult = ReturnType<typeof useEventsAlarmSummaryQuery>;
export type EventsAlarmSummaryLazyQueryHookResult = ReturnType<typeof useEventsAlarmSummaryLazyQuery>;
export type EventsAlarmSummaryQueryResult = Apollo.QueryResult<EventsAlarmSummaryQuery, EventsAlarmSummaryQueryVariables>;
export function refetchEventsAlarmSummaryQuery(variables?: EventsAlarmSummaryQueryVariables) {
      return { query: EventsAlarmSummaryDocument, variables: variables }
    }
export const SignalsAlarmSummaryDocument = gql`
    query SignalsAlarmSummary {
  INFORMATIONAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["INFORMATIONAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: SIGNALS}]}
  ) {
    totalCount
  }
  WARNING: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["WARNING"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: SIGNALS}]}
  ) {
    totalCount
  }
  CRITICAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["CRITICAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: SIGNALS}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useSignalsAlarmSummaryQuery__
 *
 * To run a query within a React component, call `useSignalsAlarmSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalsAlarmSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalsAlarmSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignalsAlarmSummaryQuery(baseOptions?: Apollo.QueryHookOptions<SignalsAlarmSummaryQuery, SignalsAlarmSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalsAlarmSummaryQuery, SignalsAlarmSummaryQueryVariables>(SignalsAlarmSummaryDocument, options);
      }
export function useSignalsAlarmSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalsAlarmSummaryQuery, SignalsAlarmSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalsAlarmSummaryQuery, SignalsAlarmSummaryQueryVariables>(SignalsAlarmSummaryDocument, options);
        }
export type SignalsAlarmSummaryQueryHookResult = ReturnType<typeof useSignalsAlarmSummaryQuery>;
export type SignalsAlarmSummaryLazyQueryHookResult = ReturnType<typeof useSignalsAlarmSummaryLazyQuery>;
export type SignalsAlarmSummaryQueryResult = Apollo.QueryResult<SignalsAlarmSummaryQuery, SignalsAlarmSummaryQueryVariables>;
export function refetchSignalsAlarmSummaryQuery(variables?: SignalsAlarmSummaryQueryVariables) {
      return { query: SignalsAlarmSummaryDocument, variables: variables }
    }
export const SignsAlarmSummaryDocument = gql`
    query SignsAlarmSummary {
  INFORMATIONAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["INFORMATIONAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: SIGNS}]}
  ) {
    totalCount
  }
  WARNING: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["WARNING"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: SIGNS}]}
  ) {
    totalCount
  }
  CRITICAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["CRITICAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: SIGNS}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useSignsAlarmSummaryQuery__
 *
 * To run a query within a React component, call `useSignsAlarmSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignsAlarmSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignsAlarmSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignsAlarmSummaryQuery(baseOptions?: Apollo.QueryHookOptions<SignsAlarmSummaryQuery, SignsAlarmSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignsAlarmSummaryQuery, SignsAlarmSummaryQueryVariables>(SignsAlarmSummaryDocument, options);
      }
export function useSignsAlarmSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignsAlarmSummaryQuery, SignsAlarmSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignsAlarmSummaryQuery, SignsAlarmSummaryQueryVariables>(SignsAlarmSummaryDocument, options);
        }
export type SignsAlarmSummaryQueryHookResult = ReturnType<typeof useSignsAlarmSummaryQuery>;
export type SignsAlarmSummaryLazyQueryHookResult = ReturnType<typeof useSignsAlarmSummaryLazyQuery>;
export type SignsAlarmSummaryQueryResult = Apollo.QueryResult<SignsAlarmSummaryQuery, SignsAlarmSummaryQueryVariables>;
export function refetchSignsAlarmSummaryQuery(variables?: SignsAlarmSummaryQueryVariables) {
      return { query: SignsAlarmSummaryDocument, variables: variables }
    }
export const TollingAlarmSummaryDocument = gql`
    query TollingAlarmSummary {
  INFORMATIONAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["INFORMATIONAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: TOLLING}]}
  ) {
    totalCount
  }
  WARNING: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["WARNING"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: TOLLING}]}
  ) {
    totalCount
  }
  CRITICAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["CRITICAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: TOLLING}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useTollingAlarmSummaryQuery__
 *
 * To run a query within a React component, call `useTollingAlarmSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingAlarmSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingAlarmSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTollingAlarmSummaryQuery(baseOptions?: Apollo.QueryHookOptions<TollingAlarmSummaryQuery, TollingAlarmSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingAlarmSummaryQuery, TollingAlarmSummaryQueryVariables>(TollingAlarmSummaryDocument, options);
      }
export function useTollingAlarmSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingAlarmSummaryQuery, TollingAlarmSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingAlarmSummaryQuery, TollingAlarmSummaryQueryVariables>(TollingAlarmSummaryDocument, options);
        }
export type TollingAlarmSummaryQueryHookResult = ReturnType<typeof useTollingAlarmSummaryQuery>;
export type TollingAlarmSummaryLazyQueryHookResult = ReturnType<typeof useTollingAlarmSummaryLazyQuery>;
export type TollingAlarmSummaryQueryResult = Apollo.QueryResult<TollingAlarmSummaryQuery, TollingAlarmSummaryQueryVariables>;
export function refetchTollingAlarmSummaryQuery(variables?: TollingAlarmSummaryQueryVariables) {
      return { query: TollingAlarmSummaryDocument, variables: variables }
    }
export const TravelTimeAlarmSummaryDocument = gql`
    query TravelTimeAlarmSummary {
  INFORMATIONAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["INFORMATIONAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: TRAVEL_TIME}]}
  ) {
    totalCount
  }
  WARNING: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["WARNING"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: TRAVEL_TIME}]}
  ) {
    totalCount
  }
  CRITICAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["CRITICAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: TRAVEL_TIME}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useTravelTimeAlarmSummaryQuery__
 *
 * To run a query within a React component, call `useTravelTimeAlarmSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeAlarmSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeAlarmSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTravelTimeAlarmSummaryQuery(baseOptions?: Apollo.QueryHookOptions<TravelTimeAlarmSummaryQuery, TravelTimeAlarmSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeAlarmSummaryQuery, TravelTimeAlarmSummaryQueryVariables>(TravelTimeAlarmSummaryDocument, options);
      }
export function useTravelTimeAlarmSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeAlarmSummaryQuery, TravelTimeAlarmSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeAlarmSummaryQuery, TravelTimeAlarmSummaryQueryVariables>(TravelTimeAlarmSummaryDocument, options);
        }
export type TravelTimeAlarmSummaryQueryHookResult = ReturnType<typeof useTravelTimeAlarmSummaryQuery>;
export type TravelTimeAlarmSummaryLazyQueryHookResult = ReturnType<typeof useTravelTimeAlarmSummaryLazyQuery>;
export type TravelTimeAlarmSummaryQueryResult = Apollo.QueryResult<TravelTimeAlarmSummaryQuery, TravelTimeAlarmSummaryQueryVariables>;
export function refetchTravelTimeAlarmSummaryQuery(variables?: TravelTimeAlarmSummaryQueryVariables) {
      return { query: TravelTimeAlarmSummaryDocument, variables: variables }
    }
export const VideoAlarmSummaryDocument = gql`
    query VideoAlarmSummary {
  INFORMATIONAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["INFORMATIONAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: VIDEO}]}
  ) {
    totalCount
  }
  WARNING: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["WARNING"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: VIDEO}]}
  ) {
    totalCount
  }
  CRITICAL: alarms(
    query: {filters: [{field: "severity", operator: IN, value: ["CRITICAL"]}, {field: "active", operator: EQUALS, value: true}, {field: "source", operator: EQUALS, value: VIDEO}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useVideoAlarmSummaryQuery__
 *
 * To run a query within a React component, call `useVideoAlarmSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoAlarmSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoAlarmSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useVideoAlarmSummaryQuery(baseOptions?: Apollo.QueryHookOptions<VideoAlarmSummaryQuery, VideoAlarmSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoAlarmSummaryQuery, VideoAlarmSummaryQueryVariables>(VideoAlarmSummaryDocument, options);
      }
export function useVideoAlarmSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoAlarmSummaryQuery, VideoAlarmSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoAlarmSummaryQuery, VideoAlarmSummaryQueryVariables>(VideoAlarmSummaryDocument, options);
        }
export type VideoAlarmSummaryQueryHookResult = ReturnType<typeof useVideoAlarmSummaryQuery>;
export type VideoAlarmSummaryLazyQueryHookResult = ReturnType<typeof useVideoAlarmSummaryLazyQuery>;
export type VideoAlarmSummaryQueryResult = Apollo.QueryResult<VideoAlarmSummaryQuery, VideoAlarmSummaryQueryVariables>;
export function refetchVideoAlarmSummaryQuery(variables?: VideoAlarmSummaryQueryVariables) {
      return { query: VideoAlarmSummaryDocument, variables: variables }
    }
export const SaveAssetDocument = gql`
    mutation saveAsset($input: AssetInput!) {
  saveAsset(input: $input) {
    id
    description
  }
}
    `;
export type SaveAssetMutationFn = Apollo.MutationFunction<SaveAssetMutation, SaveAssetMutationVariables>;

/**
 * __useSaveAssetMutation__
 *
 * To run a mutation, you first call `useSaveAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssetMutation, { data, loading, error }] = useSaveAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssetMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssetMutation, SaveAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssetMutation, SaveAssetMutationVariables>(SaveAssetDocument, options);
      }
export type SaveAssetMutationHookResult = ReturnType<typeof useSaveAssetMutation>;
export type SaveAssetMutationResult = Apollo.MutationResult<SaveAssetMutation>;
export type SaveAssetMutationOptions = Apollo.BaseMutationOptions<SaveAssetMutation, SaveAssetMutationVariables>;
export const ExportAssetsDocument = gql`
    mutation exportAssets($query: AssetInputQuery!) {
  exportAssets(query: $query)
}
    `;
export type ExportAssetsMutationFn = Apollo.MutationFunction<ExportAssetsMutation, ExportAssetsMutationVariables>;

/**
 * __useExportAssetsMutation__
 *
 * To run a mutation, you first call `useExportAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAssetsMutation, { data, loading, error }] = useExportAssetsMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useExportAssetsMutation(baseOptions?: Apollo.MutationHookOptions<ExportAssetsMutation, ExportAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAssetsMutation, ExportAssetsMutationVariables>(ExportAssetsDocument, options);
      }
export type ExportAssetsMutationHookResult = ReturnType<typeof useExportAssetsMutation>;
export type ExportAssetsMutationResult = Apollo.MutationResult<ExportAssetsMutation>;
export type ExportAssetsMutationOptions = Apollo.BaseMutationOptions<ExportAssetsMutation, ExportAssetsMutationVariables>;
export const ExportAssetTemplateDocument = gql`
    mutation exportAssetTemplate($types: [String!], $reportPreference: ReportPreference) {
  exportAssetTemplate(types: $types, reportPreference: $reportPreference)
}
    `;
export type ExportAssetTemplateMutationFn = Apollo.MutationFunction<ExportAssetTemplateMutation, ExportAssetTemplateMutationVariables>;

/**
 * __useExportAssetTemplateMutation__
 *
 * To run a mutation, you first call `useExportAssetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAssetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAssetTemplateMutation, { data, loading, error }] = useExportAssetTemplateMutation({
 *   variables: {
 *      types: // value for 'types'
 *      reportPreference: // value for 'reportPreference'
 *   },
 * });
 */
export function useExportAssetTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ExportAssetTemplateMutation, ExportAssetTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAssetTemplateMutation, ExportAssetTemplateMutationVariables>(ExportAssetTemplateDocument, options);
      }
export type ExportAssetTemplateMutationHookResult = ReturnType<typeof useExportAssetTemplateMutation>;
export type ExportAssetTemplateMutationResult = Apollo.MutationResult<ExportAssetTemplateMutation>;
export type ExportAssetTemplateMutationOptions = Apollo.BaseMutationOptions<ExportAssetTemplateMutation, ExportAssetTemplateMutationVariables>;
export const ImportAssetsDocument = gql`
    mutation ImportAssets($fileId: String!) {
  importAssets(fileId: $fileId)
}
    `;
export type ImportAssetsMutationFn = Apollo.MutationFunction<ImportAssetsMutation, ImportAssetsMutationVariables>;

/**
 * __useImportAssetsMutation__
 *
 * To run a mutation, you first call `useImportAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAssetsMutation, { data, loading, error }] = useImportAssetsMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useImportAssetsMutation(baseOptions?: Apollo.MutationHookOptions<ImportAssetsMutation, ImportAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportAssetsMutation, ImportAssetsMutationVariables>(ImportAssetsDocument, options);
      }
export type ImportAssetsMutationHookResult = ReturnType<typeof useImportAssetsMutation>;
export type ImportAssetsMutationResult = Apollo.MutationResult<ImportAssetsMutation>;
export type ImportAssetsMutationOptions = Apollo.BaseMutationOptions<ImportAssetsMutation, ImportAssetsMutationVariables>;
export const AssetListDocument = gql`
    query AssetList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $searchFields: [String!] = ["name", "description", "assetNumber", "serialNumber"], $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  assets(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
        name
        assetNumber
        description
        quantity
        consumable
        code {
          id
          value
          type
          name
        }
        priority {
          id
          value
          description
          name
          color
        }
        type {
          id
          name
          form
          labels
        }
        status {
          id
          name
          value
          color
        }
        parent {
          id
          name
        }
        associatedLocation {
          id
          details {
            name
            description
          }
        }
        location
        serialNumber
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useAssetListQuery__
 *
 * To run a query within a React component, call `useAssetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAssetListQuery(baseOptions?: Apollo.QueryHookOptions<AssetListQuery, AssetListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetListQuery, AssetListQueryVariables>(AssetListDocument, options);
      }
export function useAssetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetListQuery, AssetListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetListQuery, AssetListQueryVariables>(AssetListDocument, options);
        }
export type AssetListQueryHookResult = ReturnType<typeof useAssetListQuery>;
export type AssetListLazyQueryHookResult = ReturnType<typeof useAssetListLazyQuery>;
export type AssetListQueryResult = Apollo.QueryResult<AssetListQuery, AssetListQueryVariables>;
export function refetchAssetListQuery(variables?: AssetListQueryVariables) {
      return { query: AssetListDocument, variables: variables }
    }
export const EditAssetDocument = gql`
    query EditAsset($id: ID!) {
  asset(id: $id) {
    id
    assetNumber
    name
    quantity
    consumable
    type {
      id
      value
      name
    }
    code {
      id
      value
      name
    }
    owner
    description
    serialNumber
    priority {
      id
      name
      value
      color
    }
    parent {
      id
      name
      location
      associatedLocation {
        id
        geometry
      }
    }
    status {
      id
      name
      value
      color
    }
    warrantyDate {
      startTimestamp
      endTimestamp
    }
    location
    associatedLocation {
      id
      geometry
      details {
        name
        description
      }
    }
    attributes
    minStockLevel
    sendMinStockLevelEmail
    maxStockLevel
    sendMaxStockLevelEmail
    burnRateThreshold
    sendBurnRateThresholdEmail
    leadTimes
    sendLeadTimesEmail
    lifecycles {
      name
      startTimestamp
      endTimestamp
      isComplete
    }
    stats {
      daysInUse
      daysWithoutIncident
      totalDowntime
      daysInUpTime
    }
    availableUnits {
      location {
        id
        geometry
        details {
          name
        }
      }
      count
    }
    stockDetail {
      stockOutRate
      inStockCount
    }
  }
}
    `;

/**
 * __useEditAssetQuery__
 *
 * To run a query within a React component, call `useEditAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAssetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditAssetQuery(baseOptions: Apollo.QueryHookOptions<EditAssetQuery, EditAssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditAssetQuery, EditAssetQueryVariables>(EditAssetDocument, options);
      }
export function useEditAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditAssetQuery, EditAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditAssetQuery, EditAssetQueryVariables>(EditAssetDocument, options);
        }
export type EditAssetQueryHookResult = ReturnType<typeof useEditAssetQuery>;
export type EditAssetLazyQueryHookResult = ReturnType<typeof useEditAssetLazyQuery>;
export type EditAssetQueryResult = Apollo.QueryResult<EditAssetQuery, EditAssetQueryVariables>;
export function refetchEditAssetQuery(variables: EditAssetQueryVariables) {
      return { query: EditAssetDocument, variables: variables }
    }
export const AssetHealthDocument = gql`
    query AssetHealth($id: ID!) {
  assetHealth(id: $id) {
    date
    totalDowntimeMinutes
  }
}
    `;

/**
 * __useAssetHealthQuery__
 *
 * To run a query within a React component, call `useAssetHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetHealthQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetHealthQuery(baseOptions: Apollo.QueryHookOptions<AssetHealthQuery, AssetHealthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetHealthQuery, AssetHealthQueryVariables>(AssetHealthDocument, options);
      }
export function useAssetHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetHealthQuery, AssetHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetHealthQuery, AssetHealthQueryVariables>(AssetHealthDocument, options);
        }
export type AssetHealthQueryHookResult = ReturnType<typeof useAssetHealthQuery>;
export type AssetHealthLazyQueryHookResult = ReturnType<typeof useAssetHealthLazyQuery>;
export type AssetHealthQueryResult = Apollo.QueryResult<AssetHealthQuery, AssetHealthQueryVariables>;
export function refetchAssetHealthQuery(variables: AssetHealthQueryVariables) {
      return { query: AssetHealthDocument, variables: variables }
    }
export const AssetTransactionListDocument = gql`
    query AssetTransactionList($sortOrder: SortOrder = ASCENDING, $limit: Int = 100, $filters: [FilterInput], $sortField: String, $before: String, $after: String, $searchText: String, $searchFields: [String!] = ["transactionNumber", "note"]) {
  assetTransactions(
    query: {sortOrder: $sortOrder, limit: $limit, filters: $filters, sortField: $sortField, after: $after, before: $before, searchText: $searchText, searchFields: $searchFields}
  ) {
    edges {
      node {
        id
        transactionNumber
        workOrderId
        note
        asset {
          id
          name
          __typename
        }
        type
        fromLocation {
          id
          details {
            name
          }
          locationType
          color
          __typename
        }
        toLocation {
          id
          details {
            name
          }
          locationType
          color
          __typename
        }
        fromStatus {
          id
          name
          color
          __typename
        }
        toStatus {
          id
          name
          color
          __typename
        }
        workOrder {
          orderNumber
        }
        toParent {
          id
          name
        }
        createdAt
        createdBy
        createdByName
        updatedAt
        transactedAt
        executed
        quantityAvailable
        quantityConsumed
        quantityRemaining
        __typename
      }
      __typename
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
    __typename
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useAssetTransactionListQuery__
 *
 * To run a query within a React component, call `useAssetTransactionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetTransactionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetTransactionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sortField: // value for 'sortField'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *   },
 * });
 */
export function useAssetTransactionListQuery(baseOptions?: Apollo.QueryHookOptions<AssetTransactionListQuery, AssetTransactionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetTransactionListQuery, AssetTransactionListQueryVariables>(AssetTransactionListDocument, options);
      }
export function useAssetTransactionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetTransactionListQuery, AssetTransactionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetTransactionListQuery, AssetTransactionListQueryVariables>(AssetTransactionListDocument, options);
        }
export type AssetTransactionListQueryHookResult = ReturnType<typeof useAssetTransactionListQuery>;
export type AssetTransactionListLazyQueryHookResult = ReturnType<typeof useAssetTransactionListLazyQuery>;
export type AssetTransactionListQueryResult = Apollo.QueryResult<AssetTransactionListQuery, AssetTransactionListQueryVariables>;
export function refetchAssetTransactionListQuery(variables?: AssetTransactionListQueryVariables) {
      return { query: AssetTransactionListDocument, variables: variables }
    }
export const AssetTransactionDocument = gql`
    query AssetTransaction($id: ID!) {
  assetTransaction(id: $id) {
    id
    workOrderId
    subStepId
    asset {
      id
    }
    type
    toLocation {
      id
    }
    toStatus {
      id
    }
    note
  }
}
    `;

/**
 * __useAssetTransactionQuery__
 *
 * To run a query within a React component, call `useAssetTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetTransactionQuery(baseOptions: Apollo.QueryHookOptions<AssetTransactionQuery, AssetTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetTransactionQuery, AssetTransactionQueryVariables>(AssetTransactionDocument, options);
      }
export function useAssetTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetTransactionQuery, AssetTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetTransactionQuery, AssetTransactionQueryVariables>(AssetTransactionDocument, options);
        }
export type AssetTransactionQueryHookResult = ReturnType<typeof useAssetTransactionQuery>;
export type AssetTransactionLazyQueryHookResult = ReturnType<typeof useAssetTransactionLazyQuery>;
export type AssetTransactionQueryResult = Apollo.QueryResult<AssetTransactionQuery, AssetTransactionQueryVariables>;
export function refetchAssetTransactionQuery(variables: AssetTransactionQueryVariables) {
      return { query: AssetTransactionDocument, variables: variables }
    }
export const AssetOptionsDocument = gql`
    query AssetOptions($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  assets(
    query: {sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
        name
        assetNumber
        consumable
        code {
          id
          value
          name
          __typename
        }
        type {
          id
          name
          form
          labels
          __typename
        }
        status {
          id
          name
          value
          color
        }
        parent {
          id
          name
          code {
            id
            name
          }
          type {
            id
            name
          }
          associatedLocation {
            id
            details {
              name
              __typename
            }
            __typename
          }
          __typename
        }
        associatedLocation {
          id
          details {
            name
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    __typename
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useAssetOptionsQuery__
 *
 * To run a query within a React component, call `useAssetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetOptionsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAssetOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AssetOptionsQuery, AssetOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetOptionsQuery, AssetOptionsQueryVariables>(AssetOptionsDocument, options);
      }
export function useAssetOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetOptionsQuery, AssetOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetOptionsQuery, AssetOptionsQueryVariables>(AssetOptionsDocument, options);
        }
export type AssetOptionsQueryHookResult = ReturnType<typeof useAssetOptionsQuery>;
export type AssetOptionsLazyQueryHookResult = ReturnType<typeof useAssetOptionsLazyQuery>;
export type AssetOptionsQueryResult = Apollo.QueryResult<AssetOptionsQuery, AssetOptionsQueryVariables>;
export function refetchAssetOptionsQuery(variables?: AssetOptionsQueryVariables) {
      return { query: AssetOptionsDocument, variables: variables }
    }
export const SaveAssetWorkOrderDocument = gql`
    mutation SaveAssetWorkOrder($input: AssetWorkOrderInput!) {
  saveAssetWorkOrder(input: $input) {
    id
  }
}
    `;
export type SaveAssetWorkOrderMutationFn = Apollo.MutationFunction<SaveAssetWorkOrderMutation, SaveAssetWorkOrderMutationVariables>;

/**
 * __useSaveAssetWorkOrderMutation__
 *
 * To run a mutation, you first call `useSaveAssetWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssetWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssetWorkOrderMutation, { data, loading, error }] = useSaveAssetWorkOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssetWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssetWorkOrderMutation, SaveAssetWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssetWorkOrderMutation, SaveAssetWorkOrderMutationVariables>(SaveAssetWorkOrderDocument, options);
      }
export type SaveAssetWorkOrderMutationHookResult = ReturnType<typeof useSaveAssetWorkOrderMutation>;
export type SaveAssetWorkOrderMutationResult = Apollo.MutationResult<SaveAssetWorkOrderMutation>;
export type SaveAssetWorkOrderMutationOptions = Apollo.BaseMutationOptions<SaveAssetWorkOrderMutation, SaveAssetWorkOrderMutationVariables>;
export const SaveAssetWorkOrderLinkDocument = gql`
    mutation SaveAssetWorkOrderLink($input: AssetWorkOrderLinkInput!) {
  saveAssetWorkOrderLink(input: $input) {
    id
  }
}
    `;
export type SaveAssetWorkOrderLinkMutationFn = Apollo.MutationFunction<SaveAssetWorkOrderLinkMutation, SaveAssetWorkOrderLinkMutationVariables>;

/**
 * __useSaveAssetWorkOrderLinkMutation__
 *
 * To run a mutation, you first call `useSaveAssetWorkOrderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssetWorkOrderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssetWorkOrderLinkMutation, { data, loading, error }] = useSaveAssetWorkOrderLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssetWorkOrderLinkMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssetWorkOrderLinkMutation, SaveAssetWorkOrderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssetWorkOrderLinkMutation, SaveAssetWorkOrderLinkMutationVariables>(SaveAssetWorkOrderLinkDocument, options);
      }
export type SaveAssetWorkOrderLinkMutationHookResult = ReturnType<typeof useSaveAssetWorkOrderLinkMutation>;
export type SaveAssetWorkOrderLinkMutationResult = Apollo.MutationResult<SaveAssetWorkOrderLinkMutation>;
export type SaveAssetWorkOrderLinkMutationOptions = Apollo.BaseMutationOptions<SaveAssetWorkOrderLinkMutation, SaveAssetWorkOrderLinkMutationVariables>;
export const DeleteAssetWorkOrderLinkDocument = gql`
    mutation DeleteAssetWorkOrderLink($id: ID!) {
  deleteAssetWorkOrderLink(id: $id)
}
    `;
export type DeleteAssetWorkOrderLinkMutationFn = Apollo.MutationFunction<DeleteAssetWorkOrderLinkMutation, DeleteAssetWorkOrderLinkMutationVariables>;

/**
 * __useDeleteAssetWorkOrderLinkMutation__
 *
 * To run a mutation, you first call `useDeleteAssetWorkOrderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetWorkOrderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetWorkOrderLinkMutation, { data, loading, error }] = useDeleteAssetWorkOrderLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssetWorkOrderLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetWorkOrderLinkMutation, DeleteAssetWorkOrderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetWorkOrderLinkMutation, DeleteAssetWorkOrderLinkMutationVariables>(DeleteAssetWorkOrderLinkDocument, options);
      }
export type DeleteAssetWorkOrderLinkMutationHookResult = ReturnType<typeof useDeleteAssetWorkOrderLinkMutation>;
export type DeleteAssetWorkOrderLinkMutationResult = Apollo.MutationResult<DeleteAssetWorkOrderLinkMutation>;
export type DeleteAssetWorkOrderLinkMutationOptions = Apollo.BaseMutationOptions<DeleteAssetWorkOrderLinkMutation, DeleteAssetWorkOrderLinkMutationVariables>;
export const SaveAssetWorkOrderSubStepDocument = gql`
    mutation SaveAssetWorkOrderSubStep($input: AssetWorkOrderSubStepInput!) {
  saveAssetWorkOrderSubStep(input: $input) {
    id
  }
}
    `;
export type SaveAssetWorkOrderSubStepMutationFn = Apollo.MutationFunction<SaveAssetWorkOrderSubStepMutation, SaveAssetWorkOrderSubStepMutationVariables>;

/**
 * __useSaveAssetWorkOrderSubStepMutation__
 *
 * To run a mutation, you first call `useSaveAssetWorkOrderSubStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssetWorkOrderSubStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssetWorkOrderSubStepMutation, { data, loading, error }] = useSaveAssetWorkOrderSubStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssetWorkOrderSubStepMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssetWorkOrderSubStepMutation, SaveAssetWorkOrderSubStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssetWorkOrderSubStepMutation, SaveAssetWorkOrderSubStepMutationVariables>(SaveAssetWorkOrderSubStepDocument, options);
      }
export type SaveAssetWorkOrderSubStepMutationHookResult = ReturnType<typeof useSaveAssetWorkOrderSubStepMutation>;
export type SaveAssetWorkOrderSubStepMutationResult = Apollo.MutationResult<SaveAssetWorkOrderSubStepMutation>;
export type SaveAssetWorkOrderSubStepMutationOptions = Apollo.BaseMutationOptions<SaveAssetWorkOrderSubStepMutation, SaveAssetWorkOrderSubStepMutationVariables>;
export const SaveAssetWorkOrderTransactionDocument = gql`
    mutation SaveAssetWorkOrderTransaction($input: AssetTransactionInput!) {
  saveAssetWorkOrderTransaction(input: $input) {
    id
  }
}
    `;
export type SaveAssetWorkOrderTransactionMutationFn = Apollo.MutationFunction<SaveAssetWorkOrderTransactionMutation, SaveAssetWorkOrderTransactionMutationVariables>;

/**
 * __useSaveAssetWorkOrderTransactionMutation__
 *
 * To run a mutation, you first call `useSaveAssetWorkOrderTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssetWorkOrderTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssetWorkOrderTransactionMutation, { data, loading, error }] = useSaveAssetWorkOrderTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssetWorkOrderTransactionMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssetWorkOrderTransactionMutation, SaveAssetWorkOrderTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssetWorkOrderTransactionMutation, SaveAssetWorkOrderTransactionMutationVariables>(SaveAssetWorkOrderTransactionDocument, options);
      }
export type SaveAssetWorkOrderTransactionMutationHookResult = ReturnType<typeof useSaveAssetWorkOrderTransactionMutation>;
export type SaveAssetWorkOrderTransactionMutationResult = Apollo.MutationResult<SaveAssetWorkOrderTransactionMutation>;
export type SaveAssetWorkOrderTransactionMutationOptions = Apollo.BaseMutationOptions<SaveAssetWorkOrderTransactionMutation, SaveAssetWorkOrderTransactionMutationVariables>;
export const DeleteAssetWorkOrderTransactionDocument = gql`
    mutation DeleteAssetWorkOrderTransaction($id: ID!) {
  deleteAssetWorkOrderTransaction(id: $id)
}
    `;
export type DeleteAssetWorkOrderTransactionMutationFn = Apollo.MutationFunction<DeleteAssetWorkOrderTransactionMutation, DeleteAssetWorkOrderTransactionMutationVariables>;

/**
 * __useDeleteAssetWorkOrderTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteAssetWorkOrderTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetWorkOrderTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetWorkOrderTransactionMutation, { data, loading, error }] = useDeleteAssetWorkOrderTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssetWorkOrderTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetWorkOrderTransactionMutation, DeleteAssetWorkOrderTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetWorkOrderTransactionMutation, DeleteAssetWorkOrderTransactionMutationVariables>(DeleteAssetWorkOrderTransactionDocument, options);
      }
export type DeleteAssetWorkOrderTransactionMutationHookResult = ReturnType<typeof useDeleteAssetWorkOrderTransactionMutation>;
export type DeleteAssetWorkOrderTransactionMutationResult = Apollo.MutationResult<DeleteAssetWorkOrderTransactionMutation>;
export type DeleteAssetWorkOrderTransactionMutationOptions = Apollo.BaseMutationOptions<DeleteAssetWorkOrderTransactionMutation, DeleteAssetWorkOrderTransactionMutationVariables>;
export const RevertAssetWorkOrderTransactionDocument = gql`
    mutation RevertAssetWorkOrderTransaction($id: ID!) {
  revertAssetWorkOrderTransaction(id: $id) {
    id
  }
}
    `;
export type RevertAssetWorkOrderTransactionMutationFn = Apollo.MutationFunction<RevertAssetWorkOrderTransactionMutation, RevertAssetWorkOrderTransactionMutationVariables>;

/**
 * __useRevertAssetWorkOrderTransactionMutation__
 *
 * To run a mutation, you first call `useRevertAssetWorkOrderTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertAssetWorkOrderTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertAssetWorkOrderTransactionMutation, { data, loading, error }] = useRevertAssetWorkOrderTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevertAssetWorkOrderTransactionMutation(baseOptions?: Apollo.MutationHookOptions<RevertAssetWorkOrderTransactionMutation, RevertAssetWorkOrderTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertAssetWorkOrderTransactionMutation, RevertAssetWorkOrderTransactionMutationVariables>(RevertAssetWorkOrderTransactionDocument, options);
      }
export type RevertAssetWorkOrderTransactionMutationHookResult = ReturnType<typeof useRevertAssetWorkOrderTransactionMutation>;
export type RevertAssetWorkOrderTransactionMutationResult = Apollo.MutationResult<RevertAssetWorkOrderTransactionMutation>;
export type RevertAssetWorkOrderTransactionMutationOptions = Apollo.BaseMutationOptions<RevertAssetWorkOrderTransactionMutation, RevertAssetWorkOrderTransactionMutationVariables>;
export const ExecuteAssetWorkOrderTransactionDocument = gql`
    mutation ExecuteAssetWorkOrderTransaction($id: ID!) {
  executeAssetWorkOrderTransaction(id: $id) {
    id
  }
}
    `;
export type ExecuteAssetWorkOrderTransactionMutationFn = Apollo.MutationFunction<ExecuteAssetWorkOrderTransactionMutation, ExecuteAssetWorkOrderTransactionMutationVariables>;

/**
 * __useExecuteAssetWorkOrderTransactionMutation__
 *
 * To run a mutation, you first call `useExecuteAssetWorkOrderTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteAssetWorkOrderTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeAssetWorkOrderTransactionMutation, { data, loading, error }] = useExecuteAssetWorkOrderTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExecuteAssetWorkOrderTransactionMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteAssetWorkOrderTransactionMutation, ExecuteAssetWorkOrderTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteAssetWorkOrderTransactionMutation, ExecuteAssetWorkOrderTransactionMutationVariables>(ExecuteAssetWorkOrderTransactionDocument, options);
      }
export type ExecuteAssetWorkOrderTransactionMutationHookResult = ReturnType<typeof useExecuteAssetWorkOrderTransactionMutation>;
export type ExecuteAssetWorkOrderTransactionMutationResult = Apollo.MutationResult<ExecuteAssetWorkOrderTransactionMutation>;
export type ExecuteAssetWorkOrderTransactionMutationOptions = Apollo.BaseMutationOptions<ExecuteAssetWorkOrderTransactionMutation, ExecuteAssetWorkOrderTransactionMutationVariables>;
export const DeclineAssetWorkOrderStepDocument = gql`
    mutation DeclineAssetWorkOrderStep($input: AssetWorkOrderDeclineInput) {
  declineAssetWorkOrderStep(input: $input)
}
    `;
export type DeclineAssetWorkOrderStepMutationFn = Apollo.MutationFunction<DeclineAssetWorkOrderStepMutation, DeclineAssetWorkOrderStepMutationVariables>;

/**
 * __useDeclineAssetWorkOrderStepMutation__
 *
 * To run a mutation, you first call `useDeclineAssetWorkOrderStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAssetWorkOrderStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAssetWorkOrderStepMutation, { data, loading, error }] = useDeclineAssetWorkOrderStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineAssetWorkOrderStepMutation(baseOptions?: Apollo.MutationHookOptions<DeclineAssetWorkOrderStepMutation, DeclineAssetWorkOrderStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineAssetWorkOrderStepMutation, DeclineAssetWorkOrderStepMutationVariables>(DeclineAssetWorkOrderStepDocument, options);
      }
export type DeclineAssetWorkOrderStepMutationHookResult = ReturnType<typeof useDeclineAssetWorkOrderStepMutation>;
export type DeclineAssetWorkOrderStepMutationResult = Apollo.MutationResult<DeclineAssetWorkOrderStepMutation>;
export type DeclineAssetWorkOrderStepMutationOptions = Apollo.BaseMutationOptions<DeclineAssetWorkOrderStepMutation, DeclineAssetWorkOrderStepMutationVariables>;
export const CloseAssetWorkOrderDocument = gql`
    mutation CloseAssetWorkOrder($input: AssetWorkOrderCloseInput!) {
  closeAssetWorkOrder(input: $input)
}
    `;
export type CloseAssetWorkOrderMutationFn = Apollo.MutationFunction<CloseAssetWorkOrderMutation, CloseAssetWorkOrderMutationVariables>;

/**
 * __useCloseAssetWorkOrderMutation__
 *
 * To run a mutation, you first call `useCloseAssetWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseAssetWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeAssetWorkOrderMutation, { data, loading, error }] = useCloseAssetWorkOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseAssetWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<CloseAssetWorkOrderMutation, CloseAssetWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseAssetWorkOrderMutation, CloseAssetWorkOrderMutationVariables>(CloseAssetWorkOrderDocument, options);
      }
export type CloseAssetWorkOrderMutationHookResult = ReturnType<typeof useCloseAssetWorkOrderMutation>;
export type CloseAssetWorkOrderMutationResult = Apollo.MutationResult<CloseAssetWorkOrderMutation>;
export type CloseAssetWorkOrderMutationOptions = Apollo.BaseMutationOptions<CloseAssetWorkOrderMutation, CloseAssetWorkOrderMutationVariables>;
export const SaveAssetWorkOrderFlagDocument = gql`
    mutation SaveAssetWorkOrderFlag($input: AssetWorkOrderFlagInput!) {
  saveAssetWorkOrderFlag(input: $input) {
    id
  }
}
    `;
export type SaveAssetWorkOrderFlagMutationFn = Apollo.MutationFunction<SaveAssetWorkOrderFlagMutation, SaveAssetWorkOrderFlagMutationVariables>;

/**
 * __useSaveAssetWorkOrderFlagMutation__
 *
 * To run a mutation, you first call `useSaveAssetWorkOrderFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssetWorkOrderFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssetWorkOrderFlagMutation, { data, loading, error }] = useSaveAssetWorkOrderFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssetWorkOrderFlagMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssetWorkOrderFlagMutation, SaveAssetWorkOrderFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssetWorkOrderFlagMutation, SaveAssetWorkOrderFlagMutationVariables>(SaveAssetWorkOrderFlagDocument, options);
      }
export type SaveAssetWorkOrderFlagMutationHookResult = ReturnType<typeof useSaveAssetWorkOrderFlagMutation>;
export type SaveAssetWorkOrderFlagMutationResult = Apollo.MutationResult<SaveAssetWorkOrderFlagMutation>;
export type SaveAssetWorkOrderFlagMutationOptions = Apollo.BaseMutationOptions<SaveAssetWorkOrderFlagMutation, SaveAssetWorkOrderFlagMutationVariables>;
export const DeleteAssetWorkOrderFlagDocument = gql`
    mutation DeleteAssetWorkOrderFlag($input: AssetWorkOrderFlagInput!) {
  deleteAssetWorkOrderFlag(input: $input)
}
    `;
export type DeleteAssetWorkOrderFlagMutationFn = Apollo.MutationFunction<DeleteAssetWorkOrderFlagMutation, DeleteAssetWorkOrderFlagMutationVariables>;

/**
 * __useDeleteAssetWorkOrderFlagMutation__
 *
 * To run a mutation, you first call `useDeleteAssetWorkOrderFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetWorkOrderFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetWorkOrderFlagMutation, { data, loading, error }] = useDeleteAssetWorkOrderFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAssetWorkOrderFlagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetWorkOrderFlagMutation, DeleteAssetWorkOrderFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetWorkOrderFlagMutation, DeleteAssetWorkOrderFlagMutationVariables>(DeleteAssetWorkOrderFlagDocument, options);
      }
export type DeleteAssetWorkOrderFlagMutationHookResult = ReturnType<typeof useDeleteAssetWorkOrderFlagMutation>;
export type DeleteAssetWorkOrderFlagMutationResult = Apollo.MutationResult<DeleteAssetWorkOrderFlagMutation>;
export type DeleteAssetWorkOrderFlagMutationOptions = Apollo.BaseMutationOptions<DeleteAssetWorkOrderFlagMutation, DeleteAssetWorkOrderFlagMutationVariables>;
export const SaveAssetWorkOrderTrackingDocument = gql`
    mutation SaveAssetWorkOrderTracking($input: AssetWorkOrderTrackingInput!) {
  saveAssetWorkOrderTracking(input: $input) {
    id
  }
}
    `;
export type SaveAssetWorkOrderTrackingMutationFn = Apollo.MutationFunction<SaveAssetWorkOrderTrackingMutation, SaveAssetWorkOrderTrackingMutationVariables>;

/**
 * __useSaveAssetWorkOrderTrackingMutation__
 *
 * To run a mutation, you first call `useSaveAssetWorkOrderTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssetWorkOrderTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssetWorkOrderTrackingMutation, { data, loading, error }] = useSaveAssetWorkOrderTrackingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssetWorkOrderTrackingMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssetWorkOrderTrackingMutation, SaveAssetWorkOrderTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssetWorkOrderTrackingMutation, SaveAssetWorkOrderTrackingMutationVariables>(SaveAssetWorkOrderTrackingDocument, options);
      }
export type SaveAssetWorkOrderTrackingMutationHookResult = ReturnType<typeof useSaveAssetWorkOrderTrackingMutation>;
export type SaveAssetWorkOrderTrackingMutationResult = Apollo.MutationResult<SaveAssetWorkOrderTrackingMutation>;
export type SaveAssetWorkOrderTrackingMutationOptions = Apollo.BaseMutationOptions<SaveAssetWorkOrderTrackingMutation, SaveAssetWorkOrderTrackingMutationVariables>;
export const DeleteAssetWorkOrderTrackingDocument = gql`
    mutation DeleteAssetWorkOrderTracking($id: ID!) {
  deleteAssetWorkOrderTracking(id: $id)
}
    `;
export type DeleteAssetWorkOrderTrackingMutationFn = Apollo.MutationFunction<DeleteAssetWorkOrderTrackingMutation, DeleteAssetWorkOrderTrackingMutationVariables>;

/**
 * __useDeleteAssetWorkOrderTrackingMutation__
 *
 * To run a mutation, you first call `useDeleteAssetWorkOrderTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetWorkOrderTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetWorkOrderTrackingMutation, { data, loading, error }] = useDeleteAssetWorkOrderTrackingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssetWorkOrderTrackingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetWorkOrderTrackingMutation, DeleteAssetWorkOrderTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetWorkOrderTrackingMutation, DeleteAssetWorkOrderTrackingMutationVariables>(DeleteAssetWorkOrderTrackingDocument, options);
      }
export type DeleteAssetWorkOrderTrackingMutationHookResult = ReturnType<typeof useDeleteAssetWorkOrderTrackingMutation>;
export type DeleteAssetWorkOrderTrackingMutationResult = Apollo.MutationResult<DeleteAssetWorkOrderTrackingMutation>;
export type DeleteAssetWorkOrderTrackingMutationOptions = Apollo.BaseMutationOptions<DeleteAssetWorkOrderTrackingMutation, DeleteAssetWorkOrderTrackingMutationVariables>;
export const SaveAssetWorkOrderStepAssignmentsDocument = gql`
    mutation SaveAssetWorkOrderStepAssignments($inputs: [AssetWorkOrderAssignmentsInput!]!) {
  saveAssetWorkOrderStepAssignments(inputs: $inputs)
}
    `;
export type SaveAssetWorkOrderStepAssignmentsMutationFn = Apollo.MutationFunction<SaveAssetWorkOrderStepAssignmentsMutation, SaveAssetWorkOrderStepAssignmentsMutationVariables>;

/**
 * __useSaveAssetWorkOrderStepAssignmentsMutation__
 *
 * To run a mutation, you first call `useSaveAssetWorkOrderStepAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssetWorkOrderStepAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssetWorkOrderStepAssignmentsMutation, { data, loading, error }] = useSaveAssetWorkOrderStepAssignmentsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveAssetWorkOrderStepAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssetWorkOrderStepAssignmentsMutation, SaveAssetWorkOrderStepAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssetWorkOrderStepAssignmentsMutation, SaveAssetWorkOrderStepAssignmentsMutationVariables>(SaveAssetWorkOrderStepAssignmentsDocument, options);
      }
export type SaveAssetWorkOrderStepAssignmentsMutationHookResult = ReturnType<typeof useSaveAssetWorkOrderStepAssignmentsMutation>;
export type SaveAssetWorkOrderStepAssignmentsMutationResult = Apollo.MutationResult<SaveAssetWorkOrderStepAssignmentsMutation>;
export type SaveAssetWorkOrderStepAssignmentsMutationOptions = Apollo.BaseMutationOptions<SaveAssetWorkOrderStepAssignmentsMutation, SaveAssetWorkOrderStepAssignmentsMutationVariables>;
export const SaveAssetWorkOrderCommentDocument = gql`
    mutation SaveAssetWorkOrderComment($input: AssetWorkOrderCommentInput!) {
  saveAssetWorkOrderComment(input: $input) {
    id
  }
}
    `;
export type SaveAssetWorkOrderCommentMutationFn = Apollo.MutationFunction<SaveAssetWorkOrderCommentMutation, SaveAssetWorkOrderCommentMutationVariables>;

/**
 * __useSaveAssetWorkOrderCommentMutation__
 *
 * To run a mutation, you first call `useSaveAssetWorkOrderCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssetWorkOrderCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssetWorkOrderCommentMutation, { data, loading, error }] = useSaveAssetWorkOrderCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssetWorkOrderCommentMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssetWorkOrderCommentMutation, SaveAssetWorkOrderCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssetWorkOrderCommentMutation, SaveAssetWorkOrderCommentMutationVariables>(SaveAssetWorkOrderCommentDocument, options);
      }
export type SaveAssetWorkOrderCommentMutationHookResult = ReturnType<typeof useSaveAssetWorkOrderCommentMutation>;
export type SaveAssetWorkOrderCommentMutationResult = Apollo.MutationResult<SaveAssetWorkOrderCommentMutation>;
export type SaveAssetWorkOrderCommentMutationOptions = Apollo.BaseMutationOptions<SaveAssetWorkOrderCommentMutation, SaveAssetWorkOrderCommentMutationVariables>;
export const DeleteAssetWorkOrderCommentDocument = gql`
    mutation DeleteAssetWorkOrderComment($commentId: ID!) {
  deleteAssetWorkOrderComment(id: $commentId)
}
    `;
export type DeleteAssetWorkOrderCommentMutationFn = Apollo.MutationFunction<DeleteAssetWorkOrderCommentMutation, DeleteAssetWorkOrderCommentMutationVariables>;

/**
 * __useDeleteAssetWorkOrderCommentMutation__
 *
 * To run a mutation, you first call `useDeleteAssetWorkOrderCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetWorkOrderCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetWorkOrderCommentMutation, { data, loading, error }] = useDeleteAssetWorkOrderCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteAssetWorkOrderCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetWorkOrderCommentMutation, DeleteAssetWorkOrderCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetWorkOrderCommentMutation, DeleteAssetWorkOrderCommentMutationVariables>(DeleteAssetWorkOrderCommentDocument, options);
      }
export type DeleteAssetWorkOrderCommentMutationHookResult = ReturnType<typeof useDeleteAssetWorkOrderCommentMutation>;
export type DeleteAssetWorkOrderCommentMutationResult = Apollo.MutationResult<DeleteAssetWorkOrderCommentMutation>;
export type DeleteAssetWorkOrderCommentMutationOptions = Apollo.BaseMutationOptions<DeleteAssetWorkOrderCommentMutation, DeleteAssetWorkOrderCommentMutationVariables>;
export const ExportAssetWorkOrdersDocument = gql`
    mutation exportAssetWorkOrders($query: AssetWorkOrderInputQuery!) {
  exportAssetWorkOrders(query: $query)
}
    `;
export type ExportAssetWorkOrdersMutationFn = Apollo.MutationFunction<ExportAssetWorkOrdersMutation, ExportAssetWorkOrdersMutationVariables>;

/**
 * __useExportAssetWorkOrdersMutation__
 *
 * To run a mutation, you first call `useExportAssetWorkOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAssetWorkOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAssetWorkOrdersMutation, { data, loading, error }] = useExportAssetWorkOrdersMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useExportAssetWorkOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ExportAssetWorkOrdersMutation, ExportAssetWorkOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAssetWorkOrdersMutation, ExportAssetWorkOrdersMutationVariables>(ExportAssetWorkOrdersDocument, options);
      }
export type ExportAssetWorkOrdersMutationHookResult = ReturnType<typeof useExportAssetWorkOrdersMutation>;
export type ExportAssetWorkOrdersMutationResult = Apollo.MutationResult<ExportAssetWorkOrdersMutation>;
export type ExportAssetWorkOrdersMutationOptions = Apollo.BaseMutationOptions<ExportAssetWorkOrdersMutation, ExportAssetWorkOrdersMutationVariables>;
export const SaveEntityWorkOrderDocument = gql`
    mutation SaveEntityWorkOrder($input: EntityWorkOrderInput!) {
  saveEntityWorkOrder(input: $input) {
    id
    workOrderNo
    link
    attributes
  }
}
    `;
export type SaveEntityWorkOrderMutationFn = Apollo.MutationFunction<SaveEntityWorkOrderMutation, SaveEntityWorkOrderMutationVariables>;

/**
 * __useSaveEntityWorkOrderMutation__
 *
 * To run a mutation, you first call `useSaveEntityWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEntityWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEntityWorkOrderMutation, { data, loading, error }] = useSaveEntityWorkOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEntityWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<SaveEntityWorkOrderMutation, SaveEntityWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEntityWorkOrderMutation, SaveEntityWorkOrderMutationVariables>(SaveEntityWorkOrderDocument, options);
      }
export type SaveEntityWorkOrderMutationHookResult = ReturnType<typeof useSaveEntityWorkOrderMutation>;
export type SaveEntityWorkOrderMutationResult = Apollo.MutationResult<SaveEntityWorkOrderMutation>;
export type SaveEntityWorkOrderMutationOptions = Apollo.BaseMutationOptions<SaveEntityWorkOrderMutation, SaveEntityWorkOrderMutationVariables>;
export const AssetWorkOrderDocument = gql`
    query AssetWorkOrder($id: ID!) {
  assetWorkOrder(id: $id) {
    name
    id
    orderNumber
    labels
    parent {
      id
    }
    config {
      id
      name
      __typename
    }
    assets {
      id
      name
      code {
        id
        name
        value
      }
      status {
        id
        color
        name
        value
      }
      priority {
        id
        value
        description
        name
        color
      }
      __typename
    }
    assetCodes {
      id
      name
      value
    }
    status {
      id
      name
      color
    }
    priority {
      id
      name
      color
      __typename
    }
    location {
      id
      locationType
      geometry
      details {
        name
      }
      __typename
    }
    requesterId
    createdAt
    updatedAt
    assigneeIds
  }
}
    `;

/**
 * __useAssetWorkOrderQuery__
 *
 * To run a query within a React component, call `useAssetWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWorkOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWorkOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetWorkOrderQuery(baseOptions: Apollo.QueryHookOptions<AssetWorkOrderQuery, AssetWorkOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWorkOrderQuery, AssetWorkOrderQueryVariables>(AssetWorkOrderDocument, options);
      }
export function useAssetWorkOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWorkOrderQuery, AssetWorkOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWorkOrderQuery, AssetWorkOrderQueryVariables>(AssetWorkOrderDocument, options);
        }
export type AssetWorkOrderQueryHookResult = ReturnType<typeof useAssetWorkOrderQuery>;
export type AssetWorkOrderLazyQueryHookResult = ReturnType<typeof useAssetWorkOrderLazyQuery>;
export type AssetWorkOrderQueryResult = Apollo.QueryResult<AssetWorkOrderQuery, AssetWorkOrderQueryVariables>;
export function refetchAssetWorkOrderQuery(variables: AssetWorkOrderQueryVariables) {
      return { query: AssetWorkOrderDocument, variables: variables }
    }
export const AssetWorkOrdersListDocument = gql`
    query AssetWorkOrdersList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $searchFields: [String!] = ["orderNumber", "labels", "name"], $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  assetWorkOrders(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
        name
        orderNumber
        labels
        config {
          id
          name
        }
        assets {
          id
        }
        status {
          id
          name
          color
        }
        priority {
          id
          name
          color
        }
        location {
          id
          geometry
          details {
            name
          }
        }
        assetCodes {
          id
          name
          value
        }
        parent {
          id
          orderNumber
        }
        flag {
          enabled
          reason
          reasonHtml
          mentionedUsers {
            id
            name
            email
          }
        }
        requesterId
        createdAt
        updatedAt
        assigneeIds
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useAssetWorkOrdersListQuery__
 *
 * To run a query within a React component, call `useAssetWorkOrdersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWorkOrdersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWorkOrdersListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAssetWorkOrdersListQuery(baseOptions?: Apollo.QueryHookOptions<AssetWorkOrdersListQuery, AssetWorkOrdersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWorkOrdersListQuery, AssetWorkOrdersListQueryVariables>(AssetWorkOrdersListDocument, options);
      }
export function useAssetWorkOrdersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWorkOrdersListQuery, AssetWorkOrdersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWorkOrdersListQuery, AssetWorkOrdersListQueryVariables>(AssetWorkOrdersListDocument, options);
        }
export type AssetWorkOrdersListQueryHookResult = ReturnType<typeof useAssetWorkOrdersListQuery>;
export type AssetWorkOrdersListLazyQueryHookResult = ReturnType<typeof useAssetWorkOrdersListLazyQuery>;
export type AssetWorkOrdersListQueryResult = Apollo.QueryResult<AssetWorkOrdersListQuery, AssetWorkOrdersListQueryVariables>;
export function refetchAssetWorkOrdersListQuery(variables?: AssetWorkOrdersListQueryVariables) {
      return { query: AssetWorkOrdersListDocument, variables: variables }
    }
export const AssetWorkOrderIdsDocument = gql`
    query AssetWorkOrderIds($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $searchFields: [String!] = ["orderNumber", "labels"], $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  assetWorkOrders(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useAssetWorkOrderIdsQuery__
 *
 * To run a query within a React component, call `useAssetWorkOrderIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWorkOrderIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWorkOrderIdsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAssetWorkOrderIdsQuery(baseOptions?: Apollo.QueryHookOptions<AssetWorkOrderIdsQuery, AssetWorkOrderIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWorkOrderIdsQuery, AssetWorkOrderIdsQueryVariables>(AssetWorkOrderIdsDocument, options);
      }
export function useAssetWorkOrderIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWorkOrderIdsQuery, AssetWorkOrderIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWorkOrderIdsQuery, AssetWorkOrderIdsQueryVariables>(AssetWorkOrderIdsDocument, options);
        }
export type AssetWorkOrderIdsQueryHookResult = ReturnType<typeof useAssetWorkOrderIdsQuery>;
export type AssetWorkOrderIdsLazyQueryHookResult = ReturnType<typeof useAssetWorkOrderIdsLazyQuery>;
export type AssetWorkOrderIdsQueryResult = Apollo.QueryResult<AssetWorkOrderIdsQuery, AssetWorkOrderIdsQueryVariables>;
export function refetchAssetWorkOrderIdsQuery(variables?: AssetWorkOrderIdsQueryVariables) {
      return { query: AssetWorkOrderIdsDocument, variables: variables }
    }
export const AssetWorkOrderLayerItemListDocument = gql`
    query AssetWorkOrderLayerItemList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $searchFields: [String!] = ["orderNumber", "labels"], $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  assetWorkOrders(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
        orderNumber
        labels
        status {
          id
          name
          color
        }
        location {
          id
          geometry
          details {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAssetWorkOrderLayerItemListQuery__
 *
 * To run a query within a React component, call `useAssetWorkOrderLayerItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWorkOrderLayerItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWorkOrderLayerItemListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAssetWorkOrderLayerItemListQuery(baseOptions?: Apollo.QueryHookOptions<AssetWorkOrderLayerItemListQuery, AssetWorkOrderLayerItemListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWorkOrderLayerItemListQuery, AssetWorkOrderLayerItemListQueryVariables>(AssetWorkOrderLayerItemListDocument, options);
      }
export function useAssetWorkOrderLayerItemListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWorkOrderLayerItemListQuery, AssetWorkOrderLayerItemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWorkOrderLayerItemListQuery, AssetWorkOrderLayerItemListQueryVariables>(AssetWorkOrderLayerItemListDocument, options);
        }
export type AssetWorkOrderLayerItemListQueryHookResult = ReturnType<typeof useAssetWorkOrderLayerItemListQuery>;
export type AssetWorkOrderLayerItemListLazyQueryHookResult = ReturnType<typeof useAssetWorkOrderLayerItemListLazyQuery>;
export type AssetWorkOrderLayerItemListQueryResult = Apollo.QueryResult<AssetWorkOrderLayerItemListQuery, AssetWorkOrderLayerItemListQueryVariables>;
export function refetchAssetWorkOrderLayerItemListQuery(variables?: AssetWorkOrderLayerItemListQueryVariables) {
      return { query: AssetWorkOrderLayerItemListDocument, variables: variables }
    }
export const AssetWorkOrderLinksListDocument = gql`
    query AssetWorkOrderLinksList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $searchFields: [String!], $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  assetWorkOrderLinks(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
        linkType
        linkId
        workOrderId
        comment
        linkedWorkOrder {
          id
          orderNumber
          labels
          config {
            id
            name
          }
          assetCodes {
            id
            name
            value
          }
          status {
            id
            name
            color
          }
          priority {
            id
            name
            color
          }
          assigneeIds
          requesterId
        }
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useAssetWorkOrderLinksListQuery__
 *
 * To run a query within a React component, call `useAssetWorkOrderLinksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWorkOrderLinksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWorkOrderLinksListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAssetWorkOrderLinksListQuery(baseOptions?: Apollo.QueryHookOptions<AssetWorkOrderLinksListQuery, AssetWorkOrderLinksListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWorkOrderLinksListQuery, AssetWorkOrderLinksListQueryVariables>(AssetWorkOrderLinksListDocument, options);
      }
export function useAssetWorkOrderLinksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWorkOrderLinksListQuery, AssetWorkOrderLinksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWorkOrderLinksListQuery, AssetWorkOrderLinksListQueryVariables>(AssetWorkOrderLinksListDocument, options);
        }
export type AssetWorkOrderLinksListQueryHookResult = ReturnType<typeof useAssetWorkOrderLinksListQuery>;
export type AssetWorkOrderLinksListLazyQueryHookResult = ReturnType<typeof useAssetWorkOrderLinksListLazyQuery>;
export type AssetWorkOrderLinksListQueryResult = Apollo.QueryResult<AssetWorkOrderLinksListQuery, AssetWorkOrderLinksListQueryVariables>;
export function refetchAssetWorkOrderLinksListQuery(variables?: AssetWorkOrderLinksListQueryVariables) {
      return { query: AssetWorkOrderLinksListDocument, variables: variables }
    }
export const AssetWorkOrderStepsDocument = gql`
    query AssetWorkOrderSteps($id: ID!) {
  assetWorkOrderSteps(id: $id) {
    id
    name
    workOrderId
    stepId
    subSteps {
      id
      name
      workOrderId
      stepId
      subStepId
      formId
      data
      assignments
      defaultAssignees
      status
      additionalViews
      useStepper
      useCrudList
      multiFormSections
      flag {
        enabled
        reason
        reasonHtml
      }
    }
    status
  }
}
    `;

/**
 * __useAssetWorkOrderStepsQuery__
 *
 * To run a query within a React component, call `useAssetWorkOrderStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWorkOrderStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWorkOrderStepsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetWorkOrderStepsQuery(baseOptions: Apollo.QueryHookOptions<AssetWorkOrderStepsQuery, AssetWorkOrderStepsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWorkOrderStepsQuery, AssetWorkOrderStepsQueryVariables>(AssetWorkOrderStepsDocument, options);
      }
export function useAssetWorkOrderStepsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWorkOrderStepsQuery, AssetWorkOrderStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWorkOrderStepsQuery, AssetWorkOrderStepsQueryVariables>(AssetWorkOrderStepsDocument, options);
        }
export type AssetWorkOrderStepsQueryHookResult = ReturnType<typeof useAssetWorkOrderStepsQuery>;
export type AssetWorkOrderStepsLazyQueryHookResult = ReturnType<typeof useAssetWorkOrderStepsLazyQuery>;
export type AssetWorkOrderStepsQueryResult = Apollo.QueryResult<AssetWorkOrderStepsQuery, AssetWorkOrderStepsQueryVariables>;
export function refetchAssetWorkOrderStepsQuery(variables: AssetWorkOrderStepsQueryVariables) {
      return { query: AssetWorkOrderStepsDocument, variables: variables }
    }
export const AssetWorkOrderTrackingListDocument = gql`
    query AssetWorkOrderTrackingList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $searchFields: [String!] = ["note"], $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  assetWorkOrderTrackings(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
        workOrderId
        subStepId
        subStep {
          id
          name
        }
        userId
        fromTimestamp
        toTimestamp
        totalDuration
        minutes
        hours
        note
        createdByName
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useAssetWorkOrderTrackingListQuery__
 *
 * To run a query within a React component, call `useAssetWorkOrderTrackingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWorkOrderTrackingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWorkOrderTrackingListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAssetWorkOrderTrackingListQuery(baseOptions?: Apollo.QueryHookOptions<AssetWorkOrderTrackingListQuery, AssetWorkOrderTrackingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWorkOrderTrackingListQuery, AssetWorkOrderTrackingListQueryVariables>(AssetWorkOrderTrackingListDocument, options);
      }
export function useAssetWorkOrderTrackingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWorkOrderTrackingListQuery, AssetWorkOrderTrackingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWorkOrderTrackingListQuery, AssetWorkOrderTrackingListQueryVariables>(AssetWorkOrderTrackingListDocument, options);
        }
export type AssetWorkOrderTrackingListQueryHookResult = ReturnType<typeof useAssetWorkOrderTrackingListQuery>;
export type AssetWorkOrderTrackingListLazyQueryHookResult = ReturnType<typeof useAssetWorkOrderTrackingListLazyQuery>;
export type AssetWorkOrderTrackingListQueryResult = Apollo.QueryResult<AssetWorkOrderTrackingListQuery, AssetWorkOrderTrackingListQueryVariables>;
export function refetchAssetWorkOrderTrackingListQuery(variables?: AssetWorkOrderTrackingListQueryVariables) {
      return { query: AssetWorkOrderTrackingListDocument, variables: variables }
    }
export const EditAssetWorkOrderTrackingDocument = gql`
    query EditAssetWorkOrderTracking($id: ID!) {
  assetWorkOrderTracking(id: $id) {
    id
    workOrderId
    subStepId
    fromTimestamp
    toTimestamp
    totalDuration
    minutes
    hours
    note
    userId
  }
}
    `;

/**
 * __useEditAssetWorkOrderTrackingQuery__
 *
 * To run a query within a React component, call `useEditAssetWorkOrderTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAssetWorkOrderTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAssetWorkOrderTrackingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditAssetWorkOrderTrackingQuery(baseOptions: Apollo.QueryHookOptions<EditAssetWorkOrderTrackingQuery, EditAssetWorkOrderTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditAssetWorkOrderTrackingQuery, EditAssetWorkOrderTrackingQueryVariables>(EditAssetWorkOrderTrackingDocument, options);
      }
export function useEditAssetWorkOrderTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditAssetWorkOrderTrackingQuery, EditAssetWorkOrderTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditAssetWorkOrderTrackingQuery, EditAssetWorkOrderTrackingQueryVariables>(EditAssetWorkOrderTrackingDocument, options);
        }
export type EditAssetWorkOrderTrackingQueryHookResult = ReturnType<typeof useEditAssetWorkOrderTrackingQuery>;
export type EditAssetWorkOrderTrackingLazyQueryHookResult = ReturnType<typeof useEditAssetWorkOrderTrackingLazyQuery>;
export type EditAssetWorkOrderTrackingQueryResult = Apollo.QueryResult<EditAssetWorkOrderTrackingQuery, EditAssetWorkOrderTrackingQueryVariables>;
export function refetchEditAssetWorkOrderTrackingQuery(variables: EditAssetWorkOrderTrackingQueryVariables) {
      return { query: EditAssetWorkOrderTrackingDocument, variables: variables }
    }
export const AssetWorkOrderCommentListDocument = gql`
    query AssetWorkOrderCommentList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $searchFields: [String!] = ["name"], $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  assetWorkOrderComments(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
        workOrderId
        subStepId
        comment
        commentHtml
        mentionedUsers {
          id
          name
          email
        }
        stepId
        step {
          name
        }
        subStep {
          name
        }
        createdByName
        createdBy
        createdAt
        updatedAt
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useAssetWorkOrderCommentListQuery__
 *
 * To run a query within a React component, call `useAssetWorkOrderCommentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWorkOrderCommentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWorkOrderCommentListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAssetWorkOrderCommentListQuery(baseOptions?: Apollo.QueryHookOptions<AssetWorkOrderCommentListQuery, AssetWorkOrderCommentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWorkOrderCommentListQuery, AssetWorkOrderCommentListQueryVariables>(AssetWorkOrderCommentListDocument, options);
      }
export function useAssetWorkOrderCommentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWorkOrderCommentListQuery, AssetWorkOrderCommentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWorkOrderCommentListQuery, AssetWorkOrderCommentListQueryVariables>(AssetWorkOrderCommentListDocument, options);
        }
export type AssetWorkOrderCommentListQueryHookResult = ReturnType<typeof useAssetWorkOrderCommentListQuery>;
export type AssetWorkOrderCommentListLazyQueryHookResult = ReturnType<typeof useAssetWorkOrderCommentListLazyQuery>;
export type AssetWorkOrderCommentListQueryResult = Apollo.QueryResult<AssetWorkOrderCommentListQuery, AssetWorkOrderCommentListQueryVariables>;
export function refetchAssetWorkOrderCommentListQuery(variables?: AssetWorkOrderCommentListQueryVariables) {
      return { query: AssetWorkOrderCommentListDocument, variables: variables }
    }
export const AssetWorkOderCountsDocument = gql`
    query AssetWorkOderCounts($groupBy: WorkOrderGroupBy) {
  assetWorkOderCounts(groupBy: $groupBy) {
    id
    name
    color
    count
  }
}
    `;

/**
 * __useAssetWorkOderCountsQuery__
 *
 * To run a query within a React component, call `useAssetWorkOderCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWorkOderCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWorkOderCountsQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useAssetWorkOderCountsQuery(baseOptions?: Apollo.QueryHookOptions<AssetWorkOderCountsQuery, AssetWorkOderCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWorkOderCountsQuery, AssetWorkOderCountsQueryVariables>(AssetWorkOderCountsDocument, options);
      }
export function useAssetWorkOderCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWorkOderCountsQuery, AssetWorkOderCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWorkOderCountsQuery, AssetWorkOderCountsQueryVariables>(AssetWorkOderCountsDocument, options);
        }
export type AssetWorkOderCountsQueryHookResult = ReturnType<typeof useAssetWorkOderCountsQuery>;
export type AssetWorkOderCountsLazyQueryHookResult = ReturnType<typeof useAssetWorkOderCountsLazyQuery>;
export type AssetWorkOderCountsQueryResult = Apollo.QueryResult<AssetWorkOderCountsQuery, AssetWorkOderCountsQueryVariables>;
export function refetchAssetWorkOderCountsQuery(variables?: AssetWorkOderCountsQueryVariables) {
      return { query: AssetWorkOderCountsDocument, variables: variables }
    }
export const EntityWorkOrdersListDocument = gql`
    query EntityWorkOrdersList($entityId: String!, $workOrderSystemId: String!, $sortField: String, $sortOrder: SortOrder = DESCENDING, $limit: Int = 10, $before: String, $after: String) {
  entityWorkOrders(
    query: {entityId: $entityId, workOrderSystemId: $workOrderSystemId, sortField: $sortField, sortOrder: $sortOrder, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        id
        workOrderNo
        link
        attributes
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useEntityWorkOrdersListQuery__
 *
 * To run a query within a React component, call `useEntityWorkOrdersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityWorkOrdersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityWorkOrdersListQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      workOrderSystemId: // value for 'workOrderSystemId'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEntityWorkOrdersListQuery(baseOptions: Apollo.QueryHookOptions<EntityWorkOrdersListQuery, EntityWorkOrdersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityWorkOrdersListQuery, EntityWorkOrdersListQueryVariables>(EntityWorkOrdersListDocument, options);
      }
export function useEntityWorkOrdersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityWorkOrdersListQuery, EntityWorkOrdersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityWorkOrdersListQuery, EntityWorkOrdersListQueryVariables>(EntityWorkOrdersListDocument, options);
        }
export type EntityWorkOrdersListQueryHookResult = ReturnType<typeof useEntityWorkOrdersListQuery>;
export type EntityWorkOrdersListLazyQueryHookResult = ReturnType<typeof useEntityWorkOrdersListLazyQuery>;
export type EntityWorkOrdersListQueryResult = Apollo.QueryResult<EntityWorkOrdersListQuery, EntityWorkOrdersListQueryVariables>;
export function refetchEntityWorkOrdersListQuery(variables: EntityWorkOrdersListQueryVariables) {
      return { query: EntityWorkOrdersListDocument, variables: variables }
    }
export const SaveWorkOrderConfigurationDocument = gql`
    mutation SaveWorkOrderConfiguration($input: WorkOrderConfigInput!) {
  saveWorkOrderConfiguration(input: $input) {
    id
  }
}
    `;
export type SaveWorkOrderConfigurationMutationFn = Apollo.MutationFunction<SaveWorkOrderConfigurationMutation, SaveWorkOrderConfigurationMutationVariables>;

/**
 * __useSaveWorkOrderConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveWorkOrderConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkOrderConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkOrderConfigurationMutation, { data, loading, error }] = useSaveWorkOrderConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveWorkOrderConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SaveWorkOrderConfigurationMutation, SaveWorkOrderConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWorkOrderConfigurationMutation, SaveWorkOrderConfigurationMutationVariables>(SaveWorkOrderConfigurationDocument, options);
      }
export type SaveWorkOrderConfigurationMutationHookResult = ReturnType<typeof useSaveWorkOrderConfigurationMutation>;
export type SaveWorkOrderConfigurationMutationResult = Apollo.MutationResult<SaveWorkOrderConfigurationMutation>;
export type SaveWorkOrderConfigurationMutationOptions = Apollo.BaseMutationOptions<SaveWorkOrderConfigurationMutation, SaveWorkOrderConfigurationMutationVariables>;
export const DeleteWorkOrderConfigurationDocument = gql`
    mutation DeleteWorkOrderConfiguration($id: ID!) {
  deleteWorkOrderConfiguration(id: $id)
}
    `;
export type DeleteWorkOrderConfigurationMutationFn = Apollo.MutationFunction<DeleteWorkOrderConfigurationMutation, DeleteWorkOrderConfigurationMutationVariables>;

/**
 * __useDeleteWorkOrderConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteWorkOrderConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkOrderConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkOrderConfigurationMutation, { data, loading, error }] = useDeleteWorkOrderConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkOrderConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkOrderConfigurationMutation, DeleteWorkOrderConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkOrderConfigurationMutation, DeleteWorkOrderConfigurationMutationVariables>(DeleteWorkOrderConfigurationDocument, options);
      }
export type DeleteWorkOrderConfigurationMutationHookResult = ReturnType<typeof useDeleteWorkOrderConfigurationMutation>;
export type DeleteWorkOrderConfigurationMutationResult = Apollo.MutationResult<DeleteWorkOrderConfigurationMutation>;
export type DeleteWorkOrderConfigurationMutationOptions = Apollo.BaseMutationOptions<DeleteWorkOrderConfigurationMutation, DeleteWorkOrderConfigurationMutationVariables>;
export const CloneWorkOrderConfigurationDocument = gql`
    mutation CloneWorkOrderConfiguration($id: ID!) {
  cloneWorkOrderConfiguration(id: $id) {
    id
    name
    description
    active
    typeIds
    setting {
      steps {
        id
        orderNo
        name
        status
        subSteps {
          subStepId
          subStepName
          subStepForm
          additionalViews
          useStepper
          useCrudList
        }
        decisions {
          id
          skipCondition
          query {
            formId
            query
            rule
          }
          children {
            id
            workFlowType
          }
          attributes
        }
        actions {
          id
          items {
            template
            type
            recipients {
              id
              name
              email
            }
          }
          children {
            id
            workFlowType
          }
          attributes
        }
        children {
          id
          workFlowType
        }
        attributes
      }
    }
    attributes
  }
}
    `;
export type CloneWorkOrderConfigurationMutationFn = Apollo.MutationFunction<CloneWorkOrderConfigurationMutation, CloneWorkOrderConfigurationMutationVariables>;

/**
 * __useCloneWorkOrderConfigurationMutation__
 *
 * To run a mutation, you first call `useCloneWorkOrderConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneWorkOrderConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneWorkOrderConfigurationMutation, { data, loading, error }] = useCloneWorkOrderConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneWorkOrderConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CloneWorkOrderConfigurationMutation, CloneWorkOrderConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneWorkOrderConfigurationMutation, CloneWorkOrderConfigurationMutationVariables>(CloneWorkOrderConfigurationDocument, options);
      }
export type CloneWorkOrderConfigurationMutationHookResult = ReturnType<typeof useCloneWorkOrderConfigurationMutation>;
export type CloneWorkOrderConfigurationMutationResult = Apollo.MutationResult<CloneWorkOrderConfigurationMutation>;
export type CloneWorkOrderConfigurationMutationOptions = Apollo.BaseMutationOptions<CloneWorkOrderConfigurationMutation, CloneWorkOrderConfigurationMutationVariables>;
export const WorkOrderConfigurationListDocument = gql`
    query WorkOrderConfigurationList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $searchFields: [String!] = ["name", "createdByName"], $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  workOrderConfigurations(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
        name
        description
        active
        typeIds
        attributes
        createdBy
        createdAt
        createdByName
        updatedAt
        updatedBy
        updatedByName
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useWorkOrderConfigurationListQuery__
 *
 * To run a query within a React component, call `useWorkOrderConfigurationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderConfigurationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderConfigurationListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWorkOrderConfigurationListQuery(baseOptions?: Apollo.QueryHookOptions<WorkOrderConfigurationListQuery, WorkOrderConfigurationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderConfigurationListQuery, WorkOrderConfigurationListQueryVariables>(WorkOrderConfigurationListDocument, options);
      }
export function useWorkOrderConfigurationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderConfigurationListQuery, WorkOrderConfigurationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderConfigurationListQuery, WorkOrderConfigurationListQueryVariables>(WorkOrderConfigurationListDocument, options);
        }
export type WorkOrderConfigurationListQueryHookResult = ReturnType<typeof useWorkOrderConfigurationListQuery>;
export type WorkOrderConfigurationListLazyQueryHookResult = ReturnType<typeof useWorkOrderConfigurationListLazyQuery>;
export type WorkOrderConfigurationListQueryResult = Apollo.QueryResult<WorkOrderConfigurationListQuery, WorkOrderConfigurationListQueryVariables>;
export function refetchWorkOrderConfigurationListQuery(variables?: WorkOrderConfigurationListQueryVariables) {
      return { query: WorkOrderConfigurationListDocument, variables: variables }
    }
export const WorkOrderConfigurationEditDocument = gql`
    query WorkOrderConfigurationEdit($id: ID!) {
  workOrderConfiguration(id: $id) {
    id
    name
    description
    active
    typeIds
    setting {
      steps {
        id
        orderNo
        name
        status
        subSteps {
          subStepId
          subStepName
          subStepForm
          additionalViews
          useStepper
          useCrudList
          multiFormSections
        }
        decisions {
          id
          skipCondition
          query {
            formId
            query
            rule
          }
          children {
            id
            workFlowType
          }
          attributes
        }
        actions {
          id
          items {
            template
            type
            recipients {
              id
              name
              email
            }
          }
          children {
            id
            workFlowType
          }
          attributes
        }
        children {
          id
          workFlowType
        }
        attributes
      }
    }
    attributes
  }
}
    `;

/**
 * __useWorkOrderConfigurationEditQuery__
 *
 * To run a query within a React component, call `useWorkOrderConfigurationEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderConfigurationEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderConfigurationEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkOrderConfigurationEditQuery(baseOptions: Apollo.QueryHookOptions<WorkOrderConfigurationEditQuery, WorkOrderConfigurationEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderConfigurationEditQuery, WorkOrderConfigurationEditQueryVariables>(WorkOrderConfigurationEditDocument, options);
      }
export function useWorkOrderConfigurationEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderConfigurationEditQuery, WorkOrderConfigurationEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderConfigurationEditQuery, WorkOrderConfigurationEditQueryVariables>(WorkOrderConfigurationEditDocument, options);
        }
export type WorkOrderConfigurationEditQueryHookResult = ReturnType<typeof useWorkOrderConfigurationEditQuery>;
export type WorkOrderConfigurationEditLazyQueryHookResult = ReturnType<typeof useWorkOrderConfigurationEditLazyQuery>;
export type WorkOrderConfigurationEditQueryResult = Apollo.QueryResult<WorkOrderConfigurationEditQuery, WorkOrderConfigurationEditQueryVariables>;
export function refetchWorkOrderConfigurationEditQuery(variables: WorkOrderConfigurationEditQueryVariables) {
      return { query: WorkOrderConfigurationEditDocument, variables: variables }
    }
export const WorkOrderConfigurationDocument = gql`
    query WorkOrderConfiguration($id: ID!) {
  workOrderConfiguration(id: $id) {
    id
    name
    description
    active
    typeIds
    setting {
      steps {
        id
        orderNo
        name
        status
        subSteps {
          subStepId
          subStepName
          subStepForm
          additionalViews
          useStepper
          useCrudList
          multiFormSections
        }
        decisions {
          id
          skipCondition
          query {
            formId
            query
            rule
          }
          children {
            id
            workFlowType
          }
          attributes
        }
        actions {
          id
          items {
            template
            type
            recipients {
              name
              email
            }
          }
          children {
            id
            workFlowType
          }
          attributes
        }
        children {
          id
          workFlowType
        }
        attributes
      }
    }
    attributes
    createdBy
    createdAt
    createdByName
    updatedAt
    updatedBy
    updatedByName
  }
}
    `;

/**
 * __useWorkOrderConfigurationQuery__
 *
 * To run a query within a React component, call `useWorkOrderConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkOrderConfigurationQuery(baseOptions: Apollo.QueryHookOptions<WorkOrderConfigurationQuery, WorkOrderConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderConfigurationQuery, WorkOrderConfigurationQueryVariables>(WorkOrderConfigurationDocument, options);
      }
export function useWorkOrderConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderConfigurationQuery, WorkOrderConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderConfigurationQuery, WorkOrderConfigurationQueryVariables>(WorkOrderConfigurationDocument, options);
        }
export type WorkOrderConfigurationQueryHookResult = ReturnType<typeof useWorkOrderConfigurationQuery>;
export type WorkOrderConfigurationLazyQueryHookResult = ReturnType<typeof useWorkOrderConfigurationLazyQuery>;
export type WorkOrderConfigurationQueryResult = Apollo.QueryResult<WorkOrderConfigurationQuery, WorkOrderConfigurationQueryVariables>;
export function refetchWorkOrderConfigurationQuery(variables: WorkOrderConfigurationQueryVariables) {
      return { query: WorkOrderConfigurationDocument, variables: variables }
    }
export const WorkOrderConfigurationOptionsDocument = gql`
    query WorkOrderConfigurationOptions($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $sortField: String, $limit: Int = 100) {
  workOrderConfigurations(
    query: {sortField: $sortField, sortOrder: $sortOrder, filters: $filters, limit: $limit}
  ) {
    edges {
      node {
        id
        name
        active
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useWorkOrderConfigurationOptionsQuery__
 *
 * To run a query within a React component, call `useWorkOrderConfigurationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderConfigurationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderConfigurationOptionsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWorkOrderConfigurationOptionsQuery(baseOptions?: Apollo.QueryHookOptions<WorkOrderConfigurationOptionsQuery, WorkOrderConfigurationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderConfigurationOptionsQuery, WorkOrderConfigurationOptionsQueryVariables>(WorkOrderConfigurationOptionsDocument, options);
      }
export function useWorkOrderConfigurationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderConfigurationOptionsQuery, WorkOrderConfigurationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderConfigurationOptionsQuery, WorkOrderConfigurationOptionsQueryVariables>(WorkOrderConfigurationOptionsDocument, options);
        }
export type WorkOrderConfigurationOptionsQueryHookResult = ReturnType<typeof useWorkOrderConfigurationOptionsQuery>;
export type WorkOrderConfigurationOptionsLazyQueryHookResult = ReturnType<typeof useWorkOrderConfigurationOptionsLazyQuery>;
export type WorkOrderConfigurationOptionsQueryResult = Apollo.QueryResult<WorkOrderConfigurationOptionsQuery, WorkOrderConfigurationOptionsQueryVariables>;
export function refetchWorkOrderConfigurationOptionsQuery(variables?: WorkOrderConfigurationOptionsQueryVariables) {
      return { query: WorkOrderConfigurationOptionsDocument, variables: variables }
    }
export const PanTiltVideoCameraDocument = gql`
    mutation PanTiltVideoCamera($cameraPanTiltInput: CameraPanTiltInput!) {
  panTiltCamera(cameraPanTiltInput: $cameraPanTiltInput) {
    success
  }
}
    `;
export type PanTiltVideoCameraMutationFn = Apollo.MutationFunction<PanTiltVideoCameraMutation, PanTiltVideoCameraMutationVariables>;

/**
 * __usePanTiltVideoCameraMutation__
 *
 * To run a mutation, you first call `usePanTiltVideoCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePanTiltVideoCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [panTiltVideoCameraMutation, { data, loading, error }] = usePanTiltVideoCameraMutation({
 *   variables: {
 *      cameraPanTiltInput: // value for 'cameraPanTiltInput'
 *   },
 * });
 */
export function usePanTiltVideoCameraMutation(baseOptions?: Apollo.MutationHookOptions<PanTiltVideoCameraMutation, PanTiltVideoCameraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PanTiltVideoCameraMutation, PanTiltVideoCameraMutationVariables>(PanTiltVideoCameraDocument, options);
      }
export type PanTiltVideoCameraMutationHookResult = ReturnType<typeof usePanTiltVideoCameraMutation>;
export type PanTiltVideoCameraMutationResult = Apollo.MutationResult<PanTiltVideoCameraMutation>;
export type PanTiltVideoCameraMutationOptions = Apollo.BaseMutationOptions<PanTiltVideoCameraMutation, PanTiltVideoCameraMutationVariables>;
export const VideoCameraZoomDocument = gql`
    mutation VideoCameraZoom($cameraZoomInput: CameraZoomInput!) {
  zoomCamera(cameraZoomInput: $cameraZoomInput) {
    success
  }
}
    `;
export type VideoCameraZoomMutationFn = Apollo.MutationFunction<VideoCameraZoomMutation, VideoCameraZoomMutationVariables>;

/**
 * __useVideoCameraZoomMutation__
 *
 * To run a mutation, you first call `useVideoCameraZoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoCameraZoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoCameraZoomMutation, { data, loading, error }] = useVideoCameraZoomMutation({
 *   variables: {
 *      cameraZoomInput: // value for 'cameraZoomInput'
 *   },
 * });
 */
export function useVideoCameraZoomMutation(baseOptions?: Apollo.MutationHookOptions<VideoCameraZoomMutation, VideoCameraZoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoCameraZoomMutation, VideoCameraZoomMutationVariables>(VideoCameraZoomDocument, options);
      }
export type VideoCameraZoomMutationHookResult = ReturnType<typeof useVideoCameraZoomMutation>;
export type VideoCameraZoomMutationResult = Apollo.MutationResult<VideoCameraZoomMutation>;
export type VideoCameraZoomMutationOptions = Apollo.BaseMutationOptions<VideoCameraZoomMutation, VideoCameraZoomMutationVariables>;
export const VideoCameraExplicitLockDocument = gql`
    mutation VideoCameraExplicitLock($cameraId: ID!) {
  cameraExplicitLock(cameraId: $cameraId)
}
    `;
export type VideoCameraExplicitLockMutationFn = Apollo.MutationFunction<VideoCameraExplicitLockMutation, VideoCameraExplicitLockMutationVariables>;

/**
 * __useVideoCameraExplicitLockMutation__
 *
 * To run a mutation, you first call `useVideoCameraExplicitLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoCameraExplicitLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoCameraExplicitLockMutation, { data, loading, error }] = useVideoCameraExplicitLockMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useVideoCameraExplicitLockMutation(baseOptions?: Apollo.MutationHookOptions<VideoCameraExplicitLockMutation, VideoCameraExplicitLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoCameraExplicitLockMutation, VideoCameraExplicitLockMutationVariables>(VideoCameraExplicitLockDocument, options);
      }
export type VideoCameraExplicitLockMutationHookResult = ReturnType<typeof useVideoCameraExplicitLockMutation>;
export type VideoCameraExplicitLockMutationResult = Apollo.MutationResult<VideoCameraExplicitLockMutation>;
export type VideoCameraExplicitLockMutationOptions = Apollo.BaseMutationOptions<VideoCameraExplicitLockMutation, VideoCameraExplicitLockMutationVariables>;
export const UnlockPtzVideoCameraDocument = gql`
    mutation unlockPTZVideoCamera($cameraId: ID!) {
  unlockPTZCamera(cameraId: $cameraId)
}
    `;
export type UnlockPtzVideoCameraMutationFn = Apollo.MutationFunction<UnlockPtzVideoCameraMutation, UnlockPtzVideoCameraMutationVariables>;

/**
 * __useUnlockPtzVideoCameraMutation__
 *
 * To run a mutation, you first call `useUnlockPtzVideoCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockPtzVideoCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockPtzVideoCameraMutation, { data, loading, error }] = useUnlockPtzVideoCameraMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useUnlockPtzVideoCameraMutation(baseOptions?: Apollo.MutationHookOptions<UnlockPtzVideoCameraMutation, UnlockPtzVideoCameraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockPtzVideoCameraMutation, UnlockPtzVideoCameraMutationVariables>(UnlockPtzVideoCameraDocument, options);
      }
export type UnlockPtzVideoCameraMutationHookResult = ReturnType<typeof useUnlockPtzVideoCameraMutation>;
export type UnlockPtzVideoCameraMutationResult = Apollo.MutationResult<UnlockPtzVideoCameraMutation>;
export type UnlockPtzVideoCameraMutationOptions = Apollo.BaseMutationOptions<UnlockPtzVideoCameraMutation, UnlockPtzVideoCameraMutationVariables>;
export const VideoCameraGoToPresetDocument = gql`
    mutation VideoCameraGoToPreset($cameraId: String!, $presetId: String!) {
  gotoPreset(cameraGotoPresetInput: {cameraId: $cameraId, presetId: $presetId}) {
    success
    requestId
    id
    failure
  }
}
    `;
export type VideoCameraGoToPresetMutationFn = Apollo.MutationFunction<VideoCameraGoToPresetMutation, VideoCameraGoToPresetMutationVariables>;

/**
 * __useVideoCameraGoToPresetMutation__
 *
 * To run a mutation, you first call `useVideoCameraGoToPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoCameraGoToPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoCameraGoToPresetMutation, { data, loading, error }] = useVideoCameraGoToPresetMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      presetId: // value for 'presetId'
 *   },
 * });
 */
export function useVideoCameraGoToPresetMutation(baseOptions?: Apollo.MutationHookOptions<VideoCameraGoToPresetMutation, VideoCameraGoToPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoCameraGoToPresetMutation, VideoCameraGoToPresetMutationVariables>(VideoCameraGoToPresetDocument, options);
      }
export type VideoCameraGoToPresetMutationHookResult = ReturnType<typeof useVideoCameraGoToPresetMutation>;
export type VideoCameraGoToPresetMutationResult = Apollo.MutationResult<VideoCameraGoToPresetMutation>;
export type VideoCameraGoToPresetMutationOptions = Apollo.BaseMutationOptions<VideoCameraGoToPresetMutation, VideoCameraGoToPresetMutationVariables>;
export const SaveVideoCameraPresetDocument = gql`
    mutation SaveVideoCameraPreset($input: PresetInput!) {
  savePreset(input: $input) {
    id
    presetIndex
    name
  }
}
    `;
export type SaveVideoCameraPresetMutationFn = Apollo.MutationFunction<SaveVideoCameraPresetMutation, SaveVideoCameraPresetMutationVariables>;

/**
 * __useSaveVideoCameraPresetMutation__
 *
 * To run a mutation, you first call `useSaveVideoCameraPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveVideoCameraPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveVideoCameraPresetMutation, { data, loading, error }] = useSaveVideoCameraPresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveVideoCameraPresetMutation(baseOptions?: Apollo.MutationHookOptions<SaveVideoCameraPresetMutation, SaveVideoCameraPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveVideoCameraPresetMutation, SaveVideoCameraPresetMutationVariables>(SaveVideoCameraPresetDocument, options);
      }
export type SaveVideoCameraPresetMutationHookResult = ReturnType<typeof useSaveVideoCameraPresetMutation>;
export type SaveVideoCameraPresetMutationResult = Apollo.MutationResult<SaveVideoCameraPresetMutation>;
export type SaveVideoCameraPresetMutationOptions = Apollo.BaseMutationOptions<SaveVideoCameraPresetMutation, SaveVideoCameraPresetMutationVariables>;
export const UseVideoCameraCapabilityDocument = gql`
    mutation UseVideoCameraCapability($cameraId: ID!, $capability: CameraCapability!, $option: String!) {
  useCameraCapability(
    cameraId: $cameraId
    capability: $capability
    option: $option
  ) {
    success
  }
}
    `;
export type UseVideoCameraCapabilityMutationFn = Apollo.MutationFunction<UseVideoCameraCapabilityMutation, UseVideoCameraCapabilityMutationVariables>;

/**
 * __useUseVideoCameraCapabilityMutation__
 *
 * To run a mutation, you first call `useUseVideoCameraCapabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseVideoCameraCapabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useVideoCameraCapabilityMutation, { data, loading, error }] = useUseVideoCameraCapabilityMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      capability: // value for 'capability'
 *      option: // value for 'option'
 *   },
 * });
 */
export function useUseVideoCameraCapabilityMutation(baseOptions?: Apollo.MutationHookOptions<UseVideoCameraCapabilityMutation, UseVideoCameraCapabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseVideoCameraCapabilityMutation, UseVideoCameraCapabilityMutationVariables>(UseVideoCameraCapabilityDocument, options);
      }
export type UseVideoCameraCapabilityMutationHookResult = ReturnType<typeof useUseVideoCameraCapabilityMutation>;
export type UseVideoCameraCapabilityMutationResult = Apollo.MutationResult<UseVideoCameraCapabilityMutation>;
export type UseVideoCameraCapabilityMutationOptions = Apollo.BaseMutationOptions<UseVideoCameraCapabilityMutation, UseVideoCameraCapabilityMutationVariables>;
export const EnableVideoCameraAutoFocusDocument = gql`
    mutation EnableVideoCameraAutoFocus($cameraAutoFocusInput: CameraAutoFocusInput!) {
  enableCameraAutoFocus(cameraAutoFocusInput: $cameraAutoFocusInput) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type EnableVideoCameraAutoFocusMutationFn = Apollo.MutationFunction<EnableVideoCameraAutoFocusMutation, EnableVideoCameraAutoFocusMutationVariables>;

/**
 * __useEnableVideoCameraAutoFocusMutation__
 *
 * To run a mutation, you first call `useEnableVideoCameraAutoFocusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableVideoCameraAutoFocusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableVideoCameraAutoFocusMutation, { data, loading, error }] = useEnableVideoCameraAutoFocusMutation({
 *   variables: {
 *      cameraAutoFocusInput: // value for 'cameraAutoFocusInput'
 *   },
 * });
 */
export function useEnableVideoCameraAutoFocusMutation(baseOptions?: Apollo.MutationHookOptions<EnableVideoCameraAutoFocusMutation, EnableVideoCameraAutoFocusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableVideoCameraAutoFocusMutation, EnableVideoCameraAutoFocusMutationVariables>(EnableVideoCameraAutoFocusDocument, options);
      }
export type EnableVideoCameraAutoFocusMutationHookResult = ReturnType<typeof useEnableVideoCameraAutoFocusMutation>;
export type EnableVideoCameraAutoFocusMutationResult = Apollo.MutationResult<EnableVideoCameraAutoFocusMutation>;
export type EnableVideoCameraAutoFocusMutationOptions = Apollo.BaseMutationOptions<EnableVideoCameraAutoFocusMutation, EnableVideoCameraAutoFocusMutationVariables>;
export const EnableVideoCameraAutoIrisDocument = gql`
    mutation EnableVideoCameraAutoIris($cameraAutoIrisInput: CameraAutoIrisInput!) {
  enableCameraAutoIris(cameraAutoIrisInput: $cameraAutoIrisInput) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type EnableVideoCameraAutoIrisMutationFn = Apollo.MutationFunction<EnableVideoCameraAutoIrisMutation, EnableVideoCameraAutoIrisMutationVariables>;

/**
 * __useEnableVideoCameraAutoIrisMutation__
 *
 * To run a mutation, you first call `useEnableVideoCameraAutoIrisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableVideoCameraAutoIrisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableVideoCameraAutoIrisMutation, { data, loading, error }] = useEnableVideoCameraAutoIrisMutation({
 *   variables: {
 *      cameraAutoIrisInput: // value for 'cameraAutoIrisInput'
 *   },
 * });
 */
export function useEnableVideoCameraAutoIrisMutation(baseOptions?: Apollo.MutationHookOptions<EnableVideoCameraAutoIrisMutation, EnableVideoCameraAutoIrisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableVideoCameraAutoIrisMutation, EnableVideoCameraAutoIrisMutationVariables>(EnableVideoCameraAutoIrisDocument, options);
      }
export type EnableVideoCameraAutoIrisMutationHookResult = ReturnType<typeof useEnableVideoCameraAutoIrisMutation>;
export type EnableVideoCameraAutoIrisMutationResult = Apollo.MutationResult<EnableVideoCameraAutoIrisMutation>;
export type EnableVideoCameraAutoIrisMutationOptions = Apollo.BaseMutationOptions<EnableVideoCameraAutoIrisMutation, EnableVideoCameraAutoIrisMutationVariables>;
export const FocusVideoCameraDocument = gql`
    mutation FocusVideoCamera($cameraFocusInput: CameraFocusInput!) {
  focusCamera(cameraFocusInput: $cameraFocusInput) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type FocusVideoCameraMutationFn = Apollo.MutationFunction<FocusVideoCameraMutation, FocusVideoCameraMutationVariables>;

/**
 * __useFocusVideoCameraMutation__
 *
 * To run a mutation, you first call `useFocusVideoCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFocusVideoCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [focusVideoCameraMutation, { data, loading, error }] = useFocusVideoCameraMutation({
 *   variables: {
 *      cameraFocusInput: // value for 'cameraFocusInput'
 *   },
 * });
 */
export function useFocusVideoCameraMutation(baseOptions?: Apollo.MutationHookOptions<FocusVideoCameraMutation, FocusVideoCameraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FocusVideoCameraMutation, FocusVideoCameraMutationVariables>(FocusVideoCameraDocument, options);
      }
export type FocusVideoCameraMutationHookResult = ReturnType<typeof useFocusVideoCameraMutation>;
export type FocusVideoCameraMutationResult = Apollo.MutationResult<FocusVideoCameraMutation>;
export type FocusVideoCameraMutationOptions = Apollo.BaseMutationOptions<FocusVideoCameraMutation, FocusVideoCameraMutationVariables>;
export const IrisVideoCameraDocument = gql`
    mutation IrisVideoCamera($cameraIrisInput: CameraIrisInput!) {
  irisCamera(cameraIrisInput: $cameraIrisInput) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type IrisVideoCameraMutationFn = Apollo.MutationFunction<IrisVideoCameraMutation, IrisVideoCameraMutationVariables>;

/**
 * __useIrisVideoCameraMutation__
 *
 * To run a mutation, you first call `useIrisVideoCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIrisVideoCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [irisVideoCameraMutation, { data, loading, error }] = useIrisVideoCameraMutation({
 *   variables: {
 *      cameraIrisInput: // value for 'cameraIrisInput'
 *   },
 * });
 */
export function useIrisVideoCameraMutation(baseOptions?: Apollo.MutationHookOptions<IrisVideoCameraMutation, IrisVideoCameraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IrisVideoCameraMutation, IrisVideoCameraMutationVariables>(IrisVideoCameraDocument, options);
      }
export type IrisVideoCameraMutationHookResult = ReturnType<typeof useIrisVideoCameraMutation>;
export type IrisVideoCameraMutationResult = Apollo.MutationResult<IrisVideoCameraMutation>;
export type IrisVideoCameraMutationOptions = Apollo.BaseMutationOptions<IrisVideoCameraMutation, IrisVideoCameraMutationVariables>;
export const VideoCameraRecordingDocument = gql`
    mutation VideoCameraRecording($cameraId: String!, $streamRecorderId: String!, $streamAccessType: VideoStreamAccessType!, $recordingType: RecordingType, $start: Boolean!, $recordingName: String!) {
  cameraRecording(
    cameraStreamRecordingInput: {cameraId: $cameraId, recordingInitiatedBy: USER, streamRecorderId: $streamRecorderId, streamAccessType: $streamAccessType, recordingType: $recordingType, start: $start, recordingName: $recordingName}
  ) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type VideoCameraRecordingMutationFn = Apollo.MutationFunction<VideoCameraRecordingMutation, VideoCameraRecordingMutationVariables>;

/**
 * __useVideoCameraRecordingMutation__
 *
 * To run a mutation, you first call `useVideoCameraRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoCameraRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoCameraRecordingMutation, { data, loading, error }] = useVideoCameraRecordingMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      streamRecorderId: // value for 'streamRecorderId'
 *      streamAccessType: // value for 'streamAccessType'
 *      recordingType: // value for 'recordingType'
 *      start: // value for 'start'
 *      recordingName: // value for 'recordingName'
 *   },
 * });
 */
export function useVideoCameraRecordingMutation(baseOptions?: Apollo.MutationHookOptions<VideoCameraRecordingMutation, VideoCameraRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoCameraRecordingMutation, VideoCameraRecordingMutationVariables>(VideoCameraRecordingDocument, options);
      }
export type VideoCameraRecordingMutationHookResult = ReturnType<typeof useVideoCameraRecordingMutation>;
export type VideoCameraRecordingMutationResult = Apollo.MutationResult<VideoCameraRecordingMutation>;
export type VideoCameraRecordingMutationOptions = Apollo.BaseMutationOptions<VideoCameraRecordingMutation, VideoCameraRecordingMutationVariables>;
export const ChangeVideoTourStateDocument = gql`
    mutation ChangeVideoTourState($tourId: ID!, $paused: Boolean) {
  changeTourState(tourId: $tourId, paused: $paused)
}
    `;
export type ChangeVideoTourStateMutationFn = Apollo.MutationFunction<ChangeVideoTourStateMutation, ChangeVideoTourStateMutationVariables>;

/**
 * __useChangeVideoTourStateMutation__
 *
 * To run a mutation, you first call `useChangeVideoTourStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeVideoTourStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeVideoTourStateMutation, { data, loading, error }] = useChangeVideoTourStateMutation({
 *   variables: {
 *      tourId: // value for 'tourId'
 *      paused: // value for 'paused'
 *   },
 * });
 */
export function useChangeVideoTourStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeVideoTourStateMutation, ChangeVideoTourStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeVideoTourStateMutation, ChangeVideoTourStateMutationVariables>(ChangeVideoTourStateDocument, options);
      }
export type ChangeVideoTourStateMutationHookResult = ReturnType<typeof useChangeVideoTourStateMutation>;
export type ChangeVideoTourStateMutationResult = Apollo.MutationResult<ChangeVideoTourStateMutation>;
export type ChangeVideoTourStateMutationOptions = Apollo.BaseMutationOptions<ChangeVideoTourStateMutation, ChangeVideoTourStateMutationVariables>;
export const VideoCameraPublicFeedDocument = gql`
    mutation VideoCameraPublicFeed($cameraPublicFeedInput: CameraPublicFeedInput!) {
  cameraPublicFeed(cameraPublicFeedInput: $cameraPublicFeedInput) {
    success
  }
}
    `;
export type VideoCameraPublicFeedMutationFn = Apollo.MutationFunction<VideoCameraPublicFeedMutation, VideoCameraPublicFeedMutationVariables>;

/**
 * __useVideoCameraPublicFeedMutation__
 *
 * To run a mutation, you first call `useVideoCameraPublicFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoCameraPublicFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoCameraPublicFeedMutation, { data, loading, error }] = useVideoCameraPublicFeedMutation({
 *   variables: {
 *      cameraPublicFeedInput: // value for 'cameraPublicFeedInput'
 *   },
 * });
 */
export function useVideoCameraPublicFeedMutation(baseOptions?: Apollo.MutationHookOptions<VideoCameraPublicFeedMutation, VideoCameraPublicFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoCameraPublicFeedMutation, VideoCameraPublicFeedMutationVariables>(VideoCameraPublicFeedDocument, options);
      }
export type VideoCameraPublicFeedMutationHookResult = ReturnType<typeof useVideoCameraPublicFeedMutation>;
export type VideoCameraPublicFeedMutationResult = Apollo.MutationResult<VideoCameraPublicFeedMutation>;
export type VideoCameraPublicFeedMutationOptions = Apollo.BaseMutationOptions<VideoCameraPublicFeedMutation, VideoCameraPublicFeedMutationVariables>;
export const CamerasDocument = gql`
    query Cameras($after: String, $before: String, $limit: Int = 800, $sortField: String = "id", $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput!]) {
  cameras(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
    filters: $filters
  ) {
    edges {
      node {
        ...CameraNode
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CameraNodeFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCamerasQuery__
 *
 * To run a query within a React component, call `useCamerasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCamerasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCamerasQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCamerasQuery(baseOptions?: Apollo.QueryHookOptions<CamerasQuery, CamerasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CamerasQuery, CamerasQueryVariables>(CamerasDocument, options);
      }
export function useCamerasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CamerasQuery, CamerasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CamerasQuery, CamerasQueryVariables>(CamerasDocument, options);
        }
export type CamerasQueryHookResult = ReturnType<typeof useCamerasQuery>;
export type CamerasLazyQueryHookResult = ReturnType<typeof useCamerasLazyQuery>;
export type CamerasQueryResult = Apollo.QueryResult<CamerasQuery, CamerasQueryVariables>;
export function refetchCamerasQuery(variables?: CamerasQueryVariables) {
      return { query: CamerasDocument, variables: variables }
    }
export const GetCameraSnapshotDocument = gql`
    query GetCameraSnapshot($cameraId: ID!) {
  getCameraSnapshot(cameraId: $cameraId)
}
    `;

/**
 * __useGetCameraSnapshotQuery__
 *
 * To run a query within a React component, call `useGetCameraSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraSnapshotQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useGetCameraSnapshotQuery(baseOptions: Apollo.QueryHookOptions<GetCameraSnapshotQuery, GetCameraSnapshotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCameraSnapshotQuery, GetCameraSnapshotQueryVariables>(GetCameraSnapshotDocument, options);
      }
export function useGetCameraSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCameraSnapshotQuery, GetCameraSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCameraSnapshotQuery, GetCameraSnapshotQueryVariables>(GetCameraSnapshotDocument, options);
        }
export type GetCameraSnapshotQueryHookResult = ReturnType<typeof useGetCameraSnapshotQuery>;
export type GetCameraSnapshotLazyQueryHookResult = ReturnType<typeof useGetCameraSnapshotLazyQuery>;
export type GetCameraSnapshotQueryResult = Apollo.QueryResult<GetCameraSnapshotQuery, GetCameraSnapshotQueryVariables>;
export function refetchGetCameraSnapshotQuery(variables: GetCameraSnapshotQueryVariables) {
      return { query: GetCameraSnapshotDocument, variables: variables }
    }
export const CameraPresetsDocument = gql`
    query CameraPresets($cameraId: ID!) {
  camera(id: $cameraId) {
    id
    presets {
      id
      name
    }
  }
}
    `;

/**
 * __useCameraPresetsQuery__
 *
 * To run a query within a React component, call `useCameraPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraPresetsQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useCameraPresetsQuery(baseOptions: Apollo.QueryHookOptions<CameraPresetsQuery, CameraPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraPresetsQuery, CameraPresetsQueryVariables>(CameraPresetsDocument, options);
      }
export function useCameraPresetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraPresetsQuery, CameraPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraPresetsQuery, CameraPresetsQueryVariables>(CameraPresetsDocument, options);
        }
export type CameraPresetsQueryHookResult = ReturnType<typeof useCameraPresetsQuery>;
export type CameraPresetsLazyQueryHookResult = ReturnType<typeof useCameraPresetsLazyQuery>;
export type CameraPresetsQueryResult = Apollo.QueryResult<CameraPresetsQuery, CameraPresetsQueryVariables>;
export function refetchCameraPresetsQuery(variables: CameraPresetsQueryVariables) {
      return { query: CameraPresetsDocument, variables: variables }
    }
export const SaveCommunicationLogDocument = gql`
    mutation SaveCommunicationLog($input: CommunicationLogInput!) {
  saveCommunicationLog(input: $input) {
    ...CommunicationLog
  }
}
    ${CommunicationLogFragmentDoc}`;
export type SaveCommunicationLogMutationFn = Apollo.MutationFunction<SaveCommunicationLogMutation, SaveCommunicationLogMutationVariables>;

/**
 * __useSaveCommunicationLogMutation__
 *
 * To run a mutation, you first call `useSaveCommunicationLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommunicationLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommunicationLogMutation, { data, loading, error }] = useSaveCommunicationLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCommunicationLogMutation(baseOptions?: Apollo.MutationHookOptions<SaveCommunicationLogMutation, SaveCommunicationLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCommunicationLogMutation, SaveCommunicationLogMutationVariables>(SaveCommunicationLogDocument, options);
      }
export type SaveCommunicationLogMutationHookResult = ReturnType<typeof useSaveCommunicationLogMutation>;
export type SaveCommunicationLogMutationResult = Apollo.MutationResult<SaveCommunicationLogMutation>;
export type SaveCommunicationLogMutationOptions = Apollo.BaseMutationOptions<SaveCommunicationLogMutation, SaveCommunicationLogMutationVariables>;
export const CommunicationLogListDocument = gql`
    query CommunicationLogList($sortOrder: SortOrder = DESCENDING, $sortField: String = "reported", $filters: [FilterInput], $searchText: String, $searchFields: [String] = ["reason", "detailsType", "discussion"], $limit: Int = 10, $before: String, $after: String) {
  communicationLogs(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after, searchFields: $searchFields}
  ) {
    edges {
      node {
        ...CommunicationLog
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CommunicationLogFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCommunicationLogListQuery__
 *
 * To run a query within a React component, call `useCommunicationLogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationLogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationLogListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunicationLogListQuery(baseOptions?: Apollo.QueryHookOptions<CommunicationLogListQuery, CommunicationLogListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunicationLogListQuery, CommunicationLogListQueryVariables>(CommunicationLogListDocument, options);
      }
export function useCommunicationLogListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunicationLogListQuery, CommunicationLogListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunicationLogListQuery, CommunicationLogListQueryVariables>(CommunicationLogListDocument, options);
        }
export type CommunicationLogListQueryHookResult = ReturnType<typeof useCommunicationLogListQuery>;
export type CommunicationLogListLazyQueryHookResult = ReturnType<typeof useCommunicationLogListLazyQuery>;
export type CommunicationLogListQueryResult = Apollo.QueryResult<CommunicationLogListQuery, CommunicationLogListQueryVariables>;
export function refetchCommunicationLogListQuery(variables?: CommunicationLogListQueryVariables) {
      return { query: CommunicationLogListDocument, variables: variables }
    }
export const CommunicationLogUpdatedDocument = gql`
    subscription CommunicationLogUpdated($ids: [ID!]) {
  communicationLogUpdated(ids: $ids) {
    dto {
      ...CommunicationLog
    }
    streamObjectOperation
  }
}
    ${CommunicationLogFragmentDoc}`;

/**
 * __useCommunicationLogUpdatedSubscription__
 *
 * To run a query within a React component, call `useCommunicationLogUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationLogUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationLogUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCommunicationLogUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CommunicationLogUpdatedSubscription, CommunicationLogUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommunicationLogUpdatedSubscription, CommunicationLogUpdatedSubscriptionVariables>(CommunicationLogUpdatedDocument, options);
      }
export type CommunicationLogUpdatedSubscriptionHookResult = ReturnType<typeof useCommunicationLogUpdatedSubscription>;
export type CommunicationLogUpdatedSubscriptionResult = Apollo.SubscriptionResult<CommunicationLogUpdatedSubscription>;
export const ConnectedVehiclesAlarmConfigsDocument = gql`
    query ConnectedVehiclesAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "CONNECTED_VEHICLE"}, {field: "entityType", operator: EQUALS, value: "CONNECTED_VEHICLE"}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useConnectedVehiclesAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useConnectedVehiclesAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehiclesAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehiclesAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectedVehiclesAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedVehiclesAlarmConfigsQuery, ConnectedVehiclesAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehiclesAlarmConfigsQuery, ConnectedVehiclesAlarmConfigsQueryVariables>(ConnectedVehiclesAlarmConfigsDocument, options);
      }
export function useConnectedVehiclesAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehiclesAlarmConfigsQuery, ConnectedVehiclesAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehiclesAlarmConfigsQuery, ConnectedVehiclesAlarmConfigsQueryVariables>(ConnectedVehiclesAlarmConfigsDocument, options);
        }
export type ConnectedVehiclesAlarmConfigsQueryHookResult = ReturnType<typeof useConnectedVehiclesAlarmConfigsQuery>;
export type ConnectedVehiclesAlarmConfigsLazyQueryHookResult = ReturnType<typeof useConnectedVehiclesAlarmConfigsLazyQuery>;
export type ConnectedVehiclesAlarmConfigsQueryResult = Apollo.QueryResult<ConnectedVehiclesAlarmConfigsQuery, ConnectedVehiclesAlarmConfigsQueryVariables>;
export function refetchConnectedVehiclesAlarmConfigsQuery(variables?: ConnectedVehiclesAlarmConfigsQueryVariables) {
      return { query: ConnectedVehiclesAlarmConfigsDocument, variables: variables }
    }
export const RsuModeStatusDocument = gql`
    query RSUModeStatus {
  connectedVehicles(limit: 10000) {
    edges {
      node {
        id
        name
        communicationState
        location
        device {
          rsuModeStatus
        }
      }
    }
  }
}
    `;

/**
 * __useRsuModeStatusQuery__
 *
 * To run a query within a React component, call `useRsuModeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRsuModeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRsuModeStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useRsuModeStatusQuery(baseOptions?: Apollo.QueryHookOptions<RsuModeStatusQuery, RsuModeStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RsuModeStatusQuery, RsuModeStatusQueryVariables>(RsuModeStatusDocument, options);
      }
export function useRsuModeStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RsuModeStatusQuery, RsuModeStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RsuModeStatusQuery, RsuModeStatusQueryVariables>(RsuModeStatusDocument, options);
        }
export type RsuModeStatusQueryHookResult = ReturnType<typeof useRsuModeStatusQuery>;
export type RsuModeStatusLazyQueryHookResult = ReturnType<typeof useRsuModeStatusLazyQuery>;
export type RsuModeStatusQueryResult = Apollo.QueryResult<RsuModeStatusQuery, RsuModeStatusQueryVariables>;
export function refetchRsuModeStatusQuery(variables?: RsuModeStatusQueryVariables) {
      return { query: RsuModeStatusDocument, variables: variables }
    }
export const RsuModeStatusUpdatedDocument = gql`
    subscription RSUModeStatusUpdated {
  connectedVehicleUpdated {
    id
    name
    communicationState
    device {
      rsuModeStatus
    }
  }
}
    `;

/**
 * __useRsuModeStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useRsuModeStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRsuModeStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRsuModeStatusUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRsuModeStatusUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RsuModeStatusUpdatedSubscription, RsuModeStatusUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RsuModeStatusUpdatedSubscription, RsuModeStatusUpdatedSubscriptionVariables>(RsuModeStatusUpdatedDocument, options);
      }
export type RsuModeStatusUpdatedSubscriptionHookResult = ReturnType<typeof useRsuModeStatusUpdatedSubscription>;
export type RsuModeStatusUpdatedSubscriptionResult = Apollo.SubscriptionResult<RsuModeStatusUpdatedSubscription>;
export const RsuMainStatusDocument = gql`
    query RSUMainStatus {
  connectedVehicles(limit: 10000) {
    edges {
      node {
        id
        name
        communicationState
        location
        device {
          rsuMainStatus
        }
      }
    }
  }
}
    `;

/**
 * __useRsuMainStatusQuery__
 *
 * To run a query within a React component, call `useRsuMainStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRsuMainStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRsuMainStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useRsuMainStatusQuery(baseOptions?: Apollo.QueryHookOptions<RsuMainStatusQuery, RsuMainStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RsuMainStatusQuery, RsuMainStatusQueryVariables>(RsuMainStatusDocument, options);
      }
export function useRsuMainStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RsuMainStatusQuery, RsuMainStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RsuMainStatusQuery, RsuMainStatusQueryVariables>(RsuMainStatusDocument, options);
        }
export type RsuMainStatusQueryHookResult = ReturnType<typeof useRsuMainStatusQuery>;
export type RsuMainStatusLazyQueryHookResult = ReturnType<typeof useRsuMainStatusLazyQuery>;
export type RsuMainStatusQueryResult = Apollo.QueryResult<RsuMainStatusQuery, RsuMainStatusQueryVariables>;
export function refetchRsuMainStatusQuery(variables?: RsuMainStatusQueryVariables) {
      return { query: RsuMainStatusDocument, variables: variables }
    }
export const RsuMainStatusUpdatedDocument = gql`
    subscription RSUMainStatusUpdated {
  connectedVehicleUpdated {
    id
    name
    communicationState
    device {
      rsuMainStatus
    }
  }
}
    `;

/**
 * __useRsuMainStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useRsuMainStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRsuMainStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRsuMainStatusUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRsuMainStatusUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RsuMainStatusUpdatedSubscription, RsuMainStatusUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RsuMainStatusUpdatedSubscription, RsuMainStatusUpdatedSubscriptionVariables>(RsuMainStatusUpdatedDocument, options);
      }
export type RsuMainStatusUpdatedSubscriptionHookResult = ReturnType<typeof useRsuMainStatusUpdatedSubscription>;
export type RsuMainStatusUpdatedSubscriptionResult = Apollo.SubscriptionResult<RsuMainStatusUpdatedSubscription>;
export const ConnectedVehicleLocationsDocument = gql`
    query ConnectedVehicleLocations {
  connectedVehicles(limit: 10000) {
    edges {
      node {
        id
        location
      }
    }
  }
}
    `;

/**
 * __useConnectedVehicleLocationsQuery__
 *
 * To run a query within a React component, call `useConnectedVehicleLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectedVehicleLocationsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedVehicleLocationsQuery, ConnectedVehicleLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehicleLocationsQuery, ConnectedVehicleLocationsQueryVariables>(ConnectedVehicleLocationsDocument, options);
      }
export function useConnectedVehicleLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehicleLocationsQuery, ConnectedVehicleLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehicleLocationsQuery, ConnectedVehicleLocationsQueryVariables>(ConnectedVehicleLocationsDocument, options);
        }
export type ConnectedVehicleLocationsQueryHookResult = ReturnType<typeof useConnectedVehicleLocationsQuery>;
export type ConnectedVehicleLocationsLazyQueryHookResult = ReturnType<typeof useConnectedVehicleLocationsLazyQuery>;
export type ConnectedVehicleLocationsQueryResult = Apollo.QueryResult<ConnectedVehicleLocationsQuery, ConnectedVehicleLocationsQueryVariables>;
export function refetchConnectedVehicleLocationsQuery(variables?: ConnectedVehicleLocationsQueryVariables) {
      return { query: ConnectedVehicleLocationsDocument, variables: variables }
    }
export const ConnectedVehicleTooltipDocument = gql`
    query ConnectedVehicleTooltip($id: ID!) {
  connectedVehicle(id: $id) {
    id
    name
    description
    communicationState
    device {
      rsuMainStatus
      rsuModeStatus
      rsuRadioStatus
    }
  }
}
    `;

/**
 * __useConnectedVehicleTooltipQuery__
 *
 * To run a query within a React component, call `useConnectedVehicleTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleTooltipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectedVehicleTooltipQuery(baseOptions: Apollo.QueryHookOptions<ConnectedVehicleTooltipQuery, ConnectedVehicleTooltipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehicleTooltipQuery, ConnectedVehicleTooltipQueryVariables>(ConnectedVehicleTooltipDocument, options);
      }
export function useConnectedVehicleTooltipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehicleTooltipQuery, ConnectedVehicleTooltipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehicleTooltipQuery, ConnectedVehicleTooltipQueryVariables>(ConnectedVehicleTooltipDocument, options);
        }
export type ConnectedVehicleTooltipQueryHookResult = ReturnType<typeof useConnectedVehicleTooltipQuery>;
export type ConnectedVehicleTooltipLazyQueryHookResult = ReturnType<typeof useConnectedVehicleTooltipLazyQuery>;
export type ConnectedVehicleTooltipQueryResult = Apollo.QueryResult<ConnectedVehicleTooltipQuery, ConnectedVehicleTooltipQueryVariables>;
export function refetchConnectedVehicleTooltipQuery(variables: ConnectedVehicleTooltipQueryVariables) {
      return { query: ConnectedVehicleTooltipDocument, variables: variables }
    }
export const ConnectedVehicleMapLegendCountDocument = gql`
    query ConnectedVehicleMapLegendCount {
  connectedVehicleStatusCategories {
    rsuMainStatusCategories {
      ...RsuMainStatusCategoryFragment
    }
    rsuModeStatusCategories {
      ...RsuModeStatusCategoryFragment
    }
  }
}
    ${RsuMainStatusCategoryFragmentFragmentDoc}
${RsuModeStatusCategoryFragmentFragmentDoc}`;

/**
 * __useConnectedVehicleMapLegendCountQuery__
 *
 * To run a query within a React component, call `useConnectedVehicleMapLegendCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleMapLegendCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleMapLegendCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectedVehicleMapLegendCountQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedVehicleMapLegendCountQuery, ConnectedVehicleMapLegendCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehicleMapLegendCountQuery, ConnectedVehicleMapLegendCountQueryVariables>(ConnectedVehicleMapLegendCountDocument, options);
      }
export function useConnectedVehicleMapLegendCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehicleMapLegendCountQuery, ConnectedVehicleMapLegendCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehicleMapLegendCountQuery, ConnectedVehicleMapLegendCountQueryVariables>(ConnectedVehicleMapLegendCountDocument, options);
        }
export type ConnectedVehicleMapLegendCountQueryHookResult = ReturnType<typeof useConnectedVehicleMapLegendCountQuery>;
export type ConnectedVehicleMapLegendCountLazyQueryHookResult = ReturnType<typeof useConnectedVehicleMapLegendCountLazyQuery>;
export type ConnectedVehicleMapLegendCountQueryResult = Apollo.QueryResult<ConnectedVehicleMapLegendCountQuery, ConnectedVehicleMapLegendCountQueryVariables>;
export function refetchConnectedVehicleMapLegendCountQuery(variables?: ConnectedVehicleMapLegendCountQueryVariables) {
      return { query: ConnectedVehicleMapLegendCountDocument, variables: variables }
    }
export const ConnectedVehicleMapLegendCountUpdatedDocument = gql`
    subscription ConnectedVehicleMapLegendCountUpdated {
  connectedVehicleStatusCategoriesUpdated {
    rsuMainStatusCategories {
      ...RsuMainStatusCategoryFragment
    }
    rsuModeStatusCategories {
      ...RsuModeStatusCategoryFragment
    }
  }
}
    ${RsuMainStatusCategoryFragmentFragmentDoc}
${RsuModeStatusCategoryFragmentFragmentDoc}`;

/**
 * __useConnectedVehicleMapLegendCountUpdatedSubscription__
 *
 * To run a query within a React component, call `useConnectedVehicleMapLegendCountUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleMapLegendCountUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleMapLegendCountUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useConnectedVehicleMapLegendCountUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ConnectedVehicleMapLegendCountUpdatedSubscription, ConnectedVehicleMapLegendCountUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConnectedVehicleMapLegendCountUpdatedSubscription, ConnectedVehicleMapLegendCountUpdatedSubscriptionVariables>(ConnectedVehicleMapLegendCountUpdatedDocument, options);
      }
export type ConnectedVehicleMapLegendCountUpdatedSubscriptionHookResult = ReturnType<typeof useConnectedVehicleMapLegendCountUpdatedSubscription>;
export type ConnectedVehicleMapLegendCountUpdatedSubscriptionResult = Apollo.SubscriptionResult<ConnectedVehicleMapLegendCountUpdatedSubscription>;
export const ConnectedVehiclStatusBarDocument = gql`
    query ConnectedVehiclStatusBar {
  connectedVehicleStatusCategories {
    rsuMainStatusCategories {
      ...RsuMainStatusCategoryFragment
    }
  }
}
    ${RsuMainStatusCategoryFragmentFragmentDoc}`;

/**
 * __useConnectedVehiclStatusBarQuery__
 *
 * To run a query within a React component, call `useConnectedVehiclStatusBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehiclStatusBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehiclStatusBarQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectedVehiclStatusBarQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedVehiclStatusBarQuery, ConnectedVehiclStatusBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehiclStatusBarQuery, ConnectedVehiclStatusBarQueryVariables>(ConnectedVehiclStatusBarDocument, options);
      }
export function useConnectedVehiclStatusBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehiclStatusBarQuery, ConnectedVehiclStatusBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehiclStatusBarQuery, ConnectedVehiclStatusBarQueryVariables>(ConnectedVehiclStatusBarDocument, options);
        }
export type ConnectedVehiclStatusBarQueryHookResult = ReturnType<typeof useConnectedVehiclStatusBarQuery>;
export type ConnectedVehiclStatusBarLazyQueryHookResult = ReturnType<typeof useConnectedVehiclStatusBarLazyQuery>;
export type ConnectedVehiclStatusBarQueryResult = Apollo.QueryResult<ConnectedVehiclStatusBarQuery, ConnectedVehiclStatusBarQueryVariables>;
export function refetchConnectedVehiclStatusBarQuery(variables?: ConnectedVehiclStatusBarQueryVariables) {
      return { query: ConnectedVehiclStatusBarDocument, variables: variables }
    }
export const ConnectedVehicleStatusBarUpdatedDocument = gql`
    subscription ConnectedVehicleStatusBarUpdated {
  connectedVehicleStatusCategoriesUpdated {
    rsuMainStatusCategories {
      ...RsuMainStatusCategoryFragment
    }
  }
}
    ${RsuMainStatusCategoryFragmentFragmentDoc}`;

/**
 * __useConnectedVehicleStatusBarUpdatedSubscription__
 *
 * To run a query within a React component, call `useConnectedVehicleStatusBarUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleStatusBarUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleStatusBarUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useConnectedVehicleStatusBarUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ConnectedVehicleStatusBarUpdatedSubscription, ConnectedVehicleStatusBarUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConnectedVehicleStatusBarUpdatedSubscription, ConnectedVehicleStatusBarUpdatedSubscriptionVariables>(ConnectedVehicleStatusBarUpdatedDocument, options);
      }
export type ConnectedVehicleStatusBarUpdatedSubscriptionHookResult = ReturnType<typeof useConnectedVehicleStatusBarUpdatedSubscription>;
export type ConnectedVehicleStatusBarUpdatedSubscriptionResult = Apollo.SubscriptionResult<ConnectedVehicleStatusBarUpdatedSubscription>;
export const ConnectedVehiclesMapSearchDocument = gql`
    query ConnectedVehiclesMapSearch($searchText: String, $limit: Int = 10) {
  connectedVehicles(
    searchText: $searchText
    limit: $limit
    searchFields: ["name"]
  ) {
    edges {
      node {
        id
        name
        location
        __typename
      }
    }
  }
}
    `;

/**
 * __useConnectedVehiclesMapSearchQuery__
 *
 * To run a query within a React component, call `useConnectedVehiclesMapSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehiclesMapSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehiclesMapSearchQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useConnectedVehiclesMapSearchQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedVehiclesMapSearchQuery, ConnectedVehiclesMapSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehiclesMapSearchQuery, ConnectedVehiclesMapSearchQueryVariables>(ConnectedVehiclesMapSearchDocument, options);
      }
export function useConnectedVehiclesMapSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehiclesMapSearchQuery, ConnectedVehiclesMapSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehiclesMapSearchQuery, ConnectedVehiclesMapSearchQueryVariables>(ConnectedVehiclesMapSearchDocument, options);
        }
export type ConnectedVehiclesMapSearchQueryHookResult = ReturnType<typeof useConnectedVehiclesMapSearchQuery>;
export type ConnectedVehiclesMapSearchLazyQueryHookResult = ReturnType<typeof useConnectedVehiclesMapSearchLazyQuery>;
export type ConnectedVehiclesMapSearchQueryResult = Apollo.QueryResult<ConnectedVehiclesMapSearchQuery, ConnectedVehiclesMapSearchQueryVariables>;
export function refetchConnectedVehiclesMapSearchQuery(variables?: ConnectedVehiclesMapSearchQueryVariables) {
      return { query: ConnectedVehiclesMapSearchDocument, variables: variables }
    }
export const ConnectedVehicleDocument = gql`
    query ConnectedVehicle($id: ID!) {
  connectedVehicle(id: $id) {
    id
    name
    description
    communicationState
    device {
      deviceApi
      moduleVersion
    }
  }
}
    `;

/**
 * __useConnectedVehicleQuery__
 *
 * To run a query within a React component, call `useConnectedVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectedVehicleQuery(baseOptions: Apollo.QueryHookOptions<ConnectedVehicleQuery, ConnectedVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehicleQuery, ConnectedVehicleQueryVariables>(ConnectedVehicleDocument, options);
      }
export function useConnectedVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehicleQuery, ConnectedVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehicleQuery, ConnectedVehicleQueryVariables>(ConnectedVehicleDocument, options);
        }
export type ConnectedVehicleQueryHookResult = ReturnType<typeof useConnectedVehicleQuery>;
export type ConnectedVehicleLazyQueryHookResult = ReturnType<typeof useConnectedVehicleLazyQuery>;
export type ConnectedVehicleQueryResult = Apollo.QueryResult<ConnectedVehicleQuery, ConnectedVehicleQueryVariables>;
export function refetchConnectedVehicleQuery(variables: ConnectedVehicleQueryVariables) {
      return { query: ConnectedVehicleDocument, variables: variables }
    }
export const ConnectedVehicleNameDocument = gql`
    query ConnectedVehicleName($id: ID!) {
  connectedVehicle(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useConnectedVehicleNameQuery__
 *
 * To run a query within a React component, call `useConnectedVehicleNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectedVehicleNameQuery(baseOptions: Apollo.QueryHookOptions<ConnectedVehicleNameQuery, ConnectedVehicleNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehicleNameQuery, ConnectedVehicleNameQueryVariables>(ConnectedVehicleNameDocument, options);
      }
export function useConnectedVehicleNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehicleNameQuery, ConnectedVehicleNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehicleNameQuery, ConnectedVehicleNameQueryVariables>(ConnectedVehicleNameDocument, options);
        }
export type ConnectedVehicleNameQueryHookResult = ReturnType<typeof useConnectedVehicleNameQuery>;
export type ConnectedVehicleNameLazyQueryHookResult = ReturnType<typeof useConnectedVehicleNameLazyQuery>;
export type ConnectedVehicleNameQueryResult = Apollo.QueryResult<ConnectedVehicleNameQuery, ConnectedVehicleNameQueryVariables>;
export function refetchConnectedVehicleNameQuery(variables: ConnectedVehicleNameQueryVariables) {
      return { query: ConnectedVehicleNameDocument, variables: variables }
    }
export const ConnectedVehicleDetailsDocument = gql`
    query ConnectedVehicleDetails($id: ID!) {
  connectedVehicle(id: $id) {
    ...ConnectedVehicleFragment
  }
}
    ${ConnectedVehicleFragmentFragmentDoc}`;

/**
 * __useConnectedVehicleDetailsQuery__
 *
 * To run a query within a React component, call `useConnectedVehicleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectedVehicleDetailsQuery(baseOptions: Apollo.QueryHookOptions<ConnectedVehicleDetailsQuery, ConnectedVehicleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehicleDetailsQuery, ConnectedVehicleDetailsQueryVariables>(ConnectedVehicleDetailsDocument, options);
      }
export function useConnectedVehicleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehicleDetailsQuery, ConnectedVehicleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehicleDetailsQuery, ConnectedVehicleDetailsQueryVariables>(ConnectedVehicleDetailsDocument, options);
        }
export type ConnectedVehicleDetailsQueryHookResult = ReturnType<typeof useConnectedVehicleDetailsQuery>;
export type ConnectedVehicleDetailsLazyQueryHookResult = ReturnType<typeof useConnectedVehicleDetailsLazyQuery>;
export type ConnectedVehicleDetailsQueryResult = Apollo.QueryResult<ConnectedVehicleDetailsQuery, ConnectedVehicleDetailsQueryVariables>;
export function refetchConnectedVehicleDetailsQuery(variables: ConnectedVehicleDetailsQueryVariables) {
      return { query: ConnectedVehicleDetailsDocument, variables: variables }
    }
export const ConnectedVehicleDetailsUpdatedDocument = gql`
    subscription ConnectedVehicleDetailsUpdated($ids: [ID!]) {
  connectedVehicleUpdated(ids: $ids) {
    ...ConnectedVehicleFragment
  }
}
    ${ConnectedVehicleFragmentFragmentDoc}`;

/**
 * __useConnectedVehicleDetailsUpdatedSubscription__
 *
 * To run a query within a React component, call `useConnectedVehicleDetailsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleDetailsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleDetailsUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useConnectedVehicleDetailsUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ConnectedVehicleDetailsUpdatedSubscription, ConnectedVehicleDetailsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConnectedVehicleDetailsUpdatedSubscription, ConnectedVehicleDetailsUpdatedSubscriptionVariables>(ConnectedVehicleDetailsUpdatedDocument, options);
      }
export type ConnectedVehicleDetailsUpdatedSubscriptionHookResult = ReturnType<typeof useConnectedVehicleDetailsUpdatedSubscription>;
export type ConnectedVehicleDetailsUpdatedSubscriptionResult = Apollo.SubscriptionResult<ConnectedVehicleDetailsUpdatedSubscription>;
export const ConnectedVehicleIdsDocument = gql`
    query ConnectedVehicleIds($searchText: String, $filters: [FilterInput]) {
  connectedVehicleIds(searchText: $searchText, filters: $filters)
}
    `;

/**
 * __useConnectedVehicleIdsQuery__
 *
 * To run a query within a React component, call `useConnectedVehicleIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleIdsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useConnectedVehicleIdsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedVehicleIdsQuery, ConnectedVehicleIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehicleIdsQuery, ConnectedVehicleIdsQueryVariables>(ConnectedVehicleIdsDocument, options);
      }
export function useConnectedVehicleIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehicleIdsQuery, ConnectedVehicleIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehicleIdsQuery, ConnectedVehicleIdsQueryVariables>(ConnectedVehicleIdsDocument, options);
        }
export type ConnectedVehicleIdsQueryHookResult = ReturnType<typeof useConnectedVehicleIdsQuery>;
export type ConnectedVehicleIdsLazyQueryHookResult = ReturnType<typeof useConnectedVehicleIdsLazyQuery>;
export type ConnectedVehicleIdsQueryResult = Apollo.QueryResult<ConnectedVehicleIdsQuery, ConnectedVehicleIdsQueryVariables>;
export function refetchConnectedVehicleIdsQuery(variables?: ConnectedVehicleIdsQueryVariables) {
      return { query: ConnectedVehicleIdsDocument, variables: variables }
    }
export const DeleteAllConnectedVehicleCommentsDocument = gql`
    mutation DeleteAllConnectedVehicleComments($connectedVehicleId: ID!) {
  deleteAllConnectedVehicleComments(connectedVehicleId: $connectedVehicleId)
}
    `;
export type DeleteAllConnectedVehicleCommentsMutationFn = Apollo.MutationFunction<DeleteAllConnectedVehicleCommentsMutation, DeleteAllConnectedVehicleCommentsMutationVariables>;

/**
 * __useDeleteAllConnectedVehicleCommentsMutation__
 *
 * To run a mutation, you first call `useDeleteAllConnectedVehicleCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllConnectedVehicleCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllConnectedVehicleCommentsMutation, { data, loading, error }] = useDeleteAllConnectedVehicleCommentsMutation({
 *   variables: {
 *      connectedVehicleId: // value for 'connectedVehicleId'
 *   },
 * });
 */
export function useDeleteAllConnectedVehicleCommentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllConnectedVehicleCommentsMutation, DeleteAllConnectedVehicleCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllConnectedVehicleCommentsMutation, DeleteAllConnectedVehicleCommentsMutationVariables>(DeleteAllConnectedVehicleCommentsDocument, options);
      }
export type DeleteAllConnectedVehicleCommentsMutationHookResult = ReturnType<typeof useDeleteAllConnectedVehicleCommentsMutation>;
export type DeleteAllConnectedVehicleCommentsMutationResult = Apollo.MutationResult<DeleteAllConnectedVehicleCommentsMutation>;
export type DeleteAllConnectedVehicleCommentsMutationOptions = Apollo.BaseMutationOptions<DeleteAllConnectedVehicleCommentsMutation, DeleteAllConnectedVehicleCommentsMutationVariables>;
export const DeleteConnectedVehicleCommentDocument = gql`
    mutation DeleteConnectedVehicleComment($id: ID!) {
  deleteConnectedVehicleComment(id: $id)
}
    `;
export type DeleteConnectedVehicleCommentMutationFn = Apollo.MutationFunction<DeleteConnectedVehicleCommentMutation, DeleteConnectedVehicleCommentMutationVariables>;

/**
 * __useDeleteConnectedVehicleCommentMutation__
 *
 * To run a mutation, you first call `useDeleteConnectedVehicleCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectedVehicleCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectedVehicleCommentMutation, { data, loading, error }] = useDeleteConnectedVehicleCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConnectedVehicleCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectedVehicleCommentMutation, DeleteConnectedVehicleCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectedVehicleCommentMutation, DeleteConnectedVehicleCommentMutationVariables>(DeleteConnectedVehicleCommentDocument, options);
      }
export type DeleteConnectedVehicleCommentMutationHookResult = ReturnType<typeof useDeleteConnectedVehicleCommentMutation>;
export type DeleteConnectedVehicleCommentMutationResult = Apollo.MutationResult<DeleteConnectedVehicleCommentMutation>;
export type DeleteConnectedVehicleCommentMutationOptions = Apollo.BaseMutationOptions<DeleteConnectedVehicleCommentMutation, DeleteConnectedVehicleCommentMutationVariables>;
export const SaveConnectedVehicleCommentDocument = gql`
    mutation SaveConnectedVehicleComment($id: ID, $connectedVehicleId: ID!, $comment: String!) {
  saveConnectedVehicleComment(
    id: $id
    connectedVehicleId: $connectedVehicleId
    comment: $comment
  ) {
    ...ConnectedVehicleComment
  }
}
    ${ConnectedVehicleCommentFragmentDoc}`;
export type SaveConnectedVehicleCommentMutationFn = Apollo.MutationFunction<SaveConnectedVehicleCommentMutation, SaveConnectedVehicleCommentMutationVariables>;

/**
 * __useSaveConnectedVehicleCommentMutation__
 *
 * To run a mutation, you first call `useSaveConnectedVehicleCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConnectedVehicleCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConnectedVehicleCommentMutation, { data, loading, error }] = useSaveConnectedVehicleCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      connectedVehicleId: // value for 'connectedVehicleId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSaveConnectedVehicleCommentMutation(baseOptions?: Apollo.MutationHookOptions<SaveConnectedVehicleCommentMutation, SaveConnectedVehicleCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConnectedVehicleCommentMutation, SaveConnectedVehicleCommentMutationVariables>(SaveConnectedVehicleCommentDocument, options);
      }
export type SaveConnectedVehicleCommentMutationHookResult = ReturnType<typeof useSaveConnectedVehicleCommentMutation>;
export type SaveConnectedVehicleCommentMutationResult = Apollo.MutationResult<SaveConnectedVehicleCommentMutation>;
export type SaveConnectedVehicleCommentMutationOptions = Apollo.BaseMutationOptions<SaveConnectedVehicleCommentMutation, SaveConnectedVehicleCommentMutationVariables>;
export const ConnectedVehicleCommentByIdDocument = gql`
    query ConnectedVehicleCommentById($id: ID!) {
  connectedVehicleCommentsByConnectedVehicle(connectedVehicleId: $id) {
    ...ConnectedVehicleComment
  }
}
    ${ConnectedVehicleCommentFragmentDoc}`;

/**
 * __useConnectedVehicleCommentByIdQuery__
 *
 * To run a query within a React component, call `useConnectedVehicleCommentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleCommentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleCommentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectedVehicleCommentByIdQuery(baseOptions: Apollo.QueryHookOptions<ConnectedVehicleCommentByIdQuery, ConnectedVehicleCommentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehicleCommentByIdQuery, ConnectedVehicleCommentByIdQueryVariables>(ConnectedVehicleCommentByIdDocument, options);
      }
export function useConnectedVehicleCommentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehicleCommentByIdQuery, ConnectedVehicleCommentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehicleCommentByIdQuery, ConnectedVehicleCommentByIdQueryVariables>(ConnectedVehicleCommentByIdDocument, options);
        }
export type ConnectedVehicleCommentByIdQueryHookResult = ReturnType<typeof useConnectedVehicleCommentByIdQuery>;
export type ConnectedVehicleCommentByIdLazyQueryHookResult = ReturnType<typeof useConnectedVehicleCommentByIdLazyQuery>;
export type ConnectedVehicleCommentByIdQueryResult = Apollo.QueryResult<ConnectedVehicleCommentByIdQuery, ConnectedVehicleCommentByIdQueryVariables>;
export function refetchConnectedVehicleCommentByIdQuery(variables: ConnectedVehicleCommentByIdQueryVariables) {
      return { query: ConnectedVehicleCommentByIdDocument, variables: variables }
    }
export const ConnectedVehicleCommentUpdatedDocument = gql`
    subscription connectedVehicleCommentUpdated($ids: [ID!]) {
  connectedVehicleCommentUpdated(connectedVehicleIds: $ids) {
    streamObjectOperation
    dto {
      ...ConnectedVehicleComment
    }
  }
}
    ${ConnectedVehicleCommentFragmentDoc}`;

/**
 * __useConnectedVehicleCommentUpdatedSubscription__
 *
 * To run a query within a React component, call `useConnectedVehicleCommentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehicleCommentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehicleCommentUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useConnectedVehicleCommentUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ConnectedVehicleCommentUpdatedSubscription, ConnectedVehicleCommentUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConnectedVehicleCommentUpdatedSubscription, ConnectedVehicleCommentUpdatedSubscriptionVariables>(ConnectedVehicleCommentUpdatedDocument, options);
      }
export type ConnectedVehicleCommentUpdatedSubscriptionHookResult = ReturnType<typeof useConnectedVehicleCommentUpdatedSubscription>;
export type ConnectedVehicleCommentUpdatedSubscriptionResult = Apollo.SubscriptionResult<ConnectedVehicleCommentUpdatedSubscription>;
export const ConnectedVehiclesListDocument = gql`
    query ConnectedVehiclesList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  connectedVehicles(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
    searchFields: ["name", "device.deviceApi", "device.moduleVersion"]
  ) {
    edges {
      node {
        ...ConnectedVehicleFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${ConnectedVehicleFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useConnectedVehiclesListQuery__
 *
 * To run a query within a React component, call `useConnectedVehiclesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehiclesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehiclesListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useConnectedVehiclesListQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedVehiclesListQuery, ConnectedVehiclesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedVehiclesListQuery, ConnectedVehiclesListQueryVariables>(ConnectedVehiclesListDocument, options);
      }
export function useConnectedVehiclesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedVehiclesListQuery, ConnectedVehiclesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedVehiclesListQuery, ConnectedVehiclesListQueryVariables>(ConnectedVehiclesListDocument, options);
        }
export type ConnectedVehiclesListQueryHookResult = ReturnType<typeof useConnectedVehiclesListQuery>;
export type ConnectedVehiclesListLazyQueryHookResult = ReturnType<typeof useConnectedVehiclesListLazyQuery>;
export type ConnectedVehiclesListQueryResult = Apollo.QueryResult<ConnectedVehiclesListQuery, ConnectedVehiclesListQueryVariables>;
export function refetchConnectedVehiclesListQuery(variables?: ConnectedVehiclesListQueryVariables) {
      return { query: ConnectedVehiclesListDocument, variables: variables }
    }
export const ConnectedVehiclesListUpdatedDocument = gql`
    subscription ConnectedVehiclesListUpdated {
  connectedVehicleUpdated {
    ...ConnectedVehicleFragment
  }
}
    ${ConnectedVehicleFragmentFragmentDoc}`;

/**
 * __useConnectedVehiclesListUpdatedSubscription__
 *
 * To run a query within a React component, call `useConnectedVehiclesListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConnectedVehiclesListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedVehiclesListUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useConnectedVehiclesListUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ConnectedVehiclesListUpdatedSubscription, ConnectedVehiclesListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConnectedVehiclesListUpdatedSubscription, ConnectedVehiclesListUpdatedSubscriptionVariables>(ConnectedVehiclesListUpdatedDocument, options);
      }
export type ConnectedVehiclesListUpdatedSubscriptionHookResult = ReturnType<typeof useConnectedVehiclesListUpdatedSubscription>;
export type ConnectedVehiclesListUpdatedSubscriptionResult = Apollo.SubscriptionResult<ConnectedVehiclesListUpdatedSubscription>;
export const ContactGroupsShortDocument = gql`
    query ContactGroupsShort($limit: Int = 1000000, $sortField: String = "name", $sortOrder: SortOrder = ASCENDING) {
  contactGroupsQuery(
    query: {limit: $limit, sortField: $sortField, sortOrder: $sortOrder}
  ) {
    edges {
      node {
        ...ContactGroupShortFragment
      }
    }
  }
}
    ${ContactGroupShortFragmentFragmentDoc}`;

/**
 * __useContactGroupsShortQuery__
 *
 * To run a query within a React component, call `useContactGroupsShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactGroupsShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactGroupsShortQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useContactGroupsShortQuery(baseOptions?: Apollo.QueryHookOptions<ContactGroupsShortQuery, ContactGroupsShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactGroupsShortQuery, ContactGroupsShortQueryVariables>(ContactGroupsShortDocument, options);
      }
export function useContactGroupsShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactGroupsShortQuery, ContactGroupsShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactGroupsShortQuery, ContactGroupsShortQueryVariables>(ContactGroupsShortDocument, options);
        }
export type ContactGroupsShortQueryHookResult = ReturnType<typeof useContactGroupsShortQuery>;
export type ContactGroupsShortLazyQueryHookResult = ReturnType<typeof useContactGroupsShortLazyQuery>;
export type ContactGroupsShortQueryResult = Apollo.QueryResult<ContactGroupsShortQuery, ContactGroupsShortQueryVariables>;
export function refetchContactGroupsShortQuery(variables?: ContactGroupsShortQueryVariables) {
      return { query: ContactGroupsShortDocument, variables: variables }
    }
export const ContactGroupShortListDocument = gql`
    query ContactGroupShortList($limit: Int = 1000000, $sortField: String = "name", $sortOrder: SortOrder = ASCENDING, $searchText: String, $searchFields: [String] = ["name"]) {
  contactGroupsQuery(
    query: {limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, searchFields: $searchFields}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useContactGroupShortListQuery__
 *
 * To run a query within a React component, call `useContactGroupShortListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactGroupShortListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactGroupShortListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *   },
 * });
 */
export function useContactGroupShortListQuery(baseOptions?: Apollo.QueryHookOptions<ContactGroupShortListQuery, ContactGroupShortListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactGroupShortListQuery, ContactGroupShortListQueryVariables>(ContactGroupShortListDocument, options);
      }
export function useContactGroupShortListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactGroupShortListQuery, ContactGroupShortListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactGroupShortListQuery, ContactGroupShortListQueryVariables>(ContactGroupShortListDocument, options);
        }
export type ContactGroupShortListQueryHookResult = ReturnType<typeof useContactGroupShortListQuery>;
export type ContactGroupShortListLazyQueryHookResult = ReturnType<typeof useContactGroupShortListLazyQuery>;
export type ContactGroupShortListQueryResult = Apollo.QueryResult<ContactGroupShortListQuery, ContactGroupShortListQueryVariables>;
export function refetchContactGroupShortListQuery(variables?: ContactGroupShortListQueryVariables) {
      return { query: ContactGroupShortListDocument, variables: variables }
    }
export const DeleteContactDocument = gql`
    mutation DeleteContact($id: ID!) {
  deleteContact(id: $id) {
    id
  }
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const SaveContactDocument = gql`
    mutation SaveContact($contact: ContactInput!) {
  saveContact(contact: $contact) {
    ...ContactFragment
  }
}
    ${ContactFragmentFragmentDoc}`;
export type SaveContactMutationFn = Apollo.MutationFunction<SaveContactMutation, SaveContactMutationVariables>;

/**
 * __useSaveContactMutation__
 *
 * To run a mutation, you first call `useSaveContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContactMutation, { data, loading, error }] = useSaveContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useSaveContactMutation(baseOptions?: Apollo.MutationHookOptions<SaveContactMutation, SaveContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveContactMutation, SaveContactMutationVariables>(SaveContactDocument, options);
      }
export type SaveContactMutationHookResult = ReturnType<typeof useSaveContactMutation>;
export type SaveContactMutationResult = Apollo.MutationResult<SaveContactMutation>;
export type SaveContactMutationOptions = Apollo.BaseMutationOptions<SaveContactMutation, SaveContactMutationVariables>;
export const DeleteContactGroupDocument = gql`
    mutation DeleteContactGroup($id: ID!) {
  deleteContactGroup(id: $id) {
    id
  }
}
    `;
export type DeleteContactGroupMutationFn = Apollo.MutationFunction<DeleteContactGroupMutation, DeleteContactGroupMutationVariables>;

/**
 * __useDeleteContactGroupMutation__
 *
 * To run a mutation, you first call `useDeleteContactGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactGroupMutation, { data, loading, error }] = useDeleteContactGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactGroupMutation, DeleteContactGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactGroupMutation, DeleteContactGroupMutationVariables>(DeleteContactGroupDocument, options);
      }
export type DeleteContactGroupMutationHookResult = ReturnType<typeof useDeleteContactGroupMutation>;
export type DeleteContactGroupMutationResult = Apollo.MutationResult<DeleteContactGroupMutation>;
export type DeleteContactGroupMutationOptions = Apollo.BaseMutationOptions<DeleteContactGroupMutation, DeleteContactGroupMutationVariables>;
export const SaveContactGroupDocument = gql`
    mutation SaveContactGroup($contactGroup: ContactGroupInput!) {
  saveContactGroup(contactGroup: $contactGroup) {
    ...ContactGroupListNodeFragment
  }
}
    ${ContactGroupListNodeFragmentFragmentDoc}`;
export type SaveContactGroupMutationFn = Apollo.MutationFunction<SaveContactGroupMutation, SaveContactGroupMutationVariables>;

/**
 * __useSaveContactGroupMutation__
 *
 * To run a mutation, you first call `useSaveContactGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContactGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContactGroupMutation, { data, loading, error }] = useSaveContactGroupMutation({
 *   variables: {
 *      contactGroup: // value for 'contactGroup'
 *   },
 * });
 */
export function useSaveContactGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveContactGroupMutation, SaveContactGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveContactGroupMutation, SaveContactGroupMutationVariables>(SaveContactGroupDocument, options);
      }
export type SaveContactGroupMutationHookResult = ReturnType<typeof useSaveContactGroupMutation>;
export type SaveContactGroupMutationResult = Apollo.MutationResult<SaveContactGroupMutation>;
export type SaveContactGroupMutationOptions = Apollo.BaseMutationOptions<SaveContactGroupMutation, SaveContactGroupMutationVariables>;
export const SaveOrganizationDocument = gql`
    mutation SaveOrganization($organization: OrganizationInput!) {
  saveOrganizationContact(organization: $organization) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export type SaveOrganizationMutationFn = Apollo.MutationFunction<SaveOrganizationMutation, SaveOrganizationMutationVariables>;

/**
 * __useSaveOrganizationMutation__
 *
 * To run a mutation, you first call `useSaveOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrganizationMutation, { data, loading, error }] = useSaveOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useSaveOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrganizationMutation, SaveOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrganizationMutation, SaveOrganizationMutationVariables>(SaveOrganizationDocument, options);
      }
export type SaveOrganizationMutationHookResult = ReturnType<typeof useSaveOrganizationMutation>;
export type SaveOrganizationMutationResult = Apollo.MutationResult<SaveOrganizationMutation>;
export type SaveOrganizationMutationOptions = Apollo.BaseMutationOptions<SaveOrganizationMutation, SaveOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($id: ID!) {
  deleteOrganizationContact(id: $id)
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const ContactsListDocument = gql`
    query ContactsList($after: String, $before: String, $limit: Int = 1000000, $sortField: String = "firstName", $searchFields: [String] = ["firstName", "lastName", "workNumber", "email", "notes", "organization"], $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput]) {
  contacts(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, filters: $filters, searchFields: $searchFields}
  ) {
    edges {
      node {
        ...ContactListNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${ContactListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useContactsListQuery__
 *
 * To run a query within a React component, call `useContactsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useContactsListQuery(baseOptions?: Apollo.QueryHookOptions<ContactsListQuery, ContactsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsListQuery, ContactsListQueryVariables>(ContactsListDocument, options);
      }
export function useContactsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsListQuery, ContactsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsListQuery, ContactsListQueryVariables>(ContactsListDocument, options);
        }
export type ContactsListQueryHookResult = ReturnType<typeof useContactsListQuery>;
export type ContactsListLazyQueryHookResult = ReturnType<typeof useContactsListLazyQuery>;
export type ContactsListQueryResult = Apollo.QueryResult<ContactsListQuery, ContactsListQueryVariables>;
export function refetchContactsListQuery(variables?: ContactsListQueryVariables) {
      return { query: ContactsListDocument, variables: variables }
    }
export const ContactListShortDocument = gql`
    query ContactListShort($after: String, $before: String, $limit: Int = 10000000, $sortField: String = "firstName", $sortOrder: SortOrder = ASCENDING, $searchText: String, $searchFields: [String] = ["firstName", "lastName", "email"], $filters: [FilterInput!]) {
  contacts(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, searchFields: $searchFields, filters: $filters}
  ) {
    edges {
      node {
        id
        firstName
        lastName
        email
        workNumber
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useContactListShortQuery__
 *
 * To run a query within a React component, call `useContactListShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListShortQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useContactListShortQuery(baseOptions?: Apollo.QueryHookOptions<ContactListShortQuery, ContactListShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListShortQuery, ContactListShortQueryVariables>(ContactListShortDocument, options);
      }
export function useContactListShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListShortQuery, ContactListShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListShortQuery, ContactListShortQueryVariables>(ContactListShortDocument, options);
        }
export type ContactListShortQueryHookResult = ReturnType<typeof useContactListShortQuery>;
export type ContactListShortLazyQueryHookResult = ReturnType<typeof useContactListShortLazyQuery>;
export type ContactListShortQueryResult = Apollo.QueryResult<ContactListShortQuery, ContactListShortQueryVariables>;
export function refetchContactListShortQuery(variables?: ContactListShortQueryVariables) {
      return { query: ContactListShortDocument, variables: variables }
    }
export const ContactDocument = gql`
    query Contact($id: ID!) {
  contact(id: $id) {
    ...ContactFragment
  }
}
    ${ContactFragmentFragmentDoc}`;

/**
 * __useContactQuery__
 *
 * To run a query within a React component, call `useContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactQuery(baseOptions: Apollo.QueryHookOptions<ContactQuery, ContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
      }
export function useContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export type ContactQueryHookResult = ReturnType<typeof useContactQuery>;
export type ContactLazyQueryHookResult = ReturnType<typeof useContactLazyQuery>;
export type ContactQueryResult = Apollo.QueryResult<ContactQuery, ContactQueryVariables>;
export function refetchContactQuery(variables: ContactQueryVariables) {
      return { query: ContactDocument, variables: variables }
    }
export const ContactUpdatedDocument = gql`
    subscription ContactUpdated($ids: [ID!]) {
  contactUpdated(ids: $ids) {
    streamObjectOperation
    dto {
      ...ContactFragment
    }
  }
}
    ${ContactFragmentFragmentDoc}`;

/**
 * __useContactUpdatedSubscription__
 *
 * To run a query within a React component, call `useContactUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContactUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useContactUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ContactUpdatedSubscription, ContactUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ContactUpdatedSubscription, ContactUpdatedSubscriptionVariables>(ContactUpdatedDocument, options);
      }
export type ContactUpdatedSubscriptionHookResult = ReturnType<typeof useContactUpdatedSubscription>;
export type ContactUpdatedSubscriptionResult = Apollo.SubscriptionResult<ContactUpdatedSubscription>;
export const OrganizationsShortDocument = gql`
    query OrganizationsShort($after: String, $before: String, $limit: Int = 100, $sortField: String = "name", $searchFields: [String] = ["name"], $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput!]) {
  organizationsContact(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, filters: $filters, searchFields: $searchFields}
  ) {
    edges {
      node {
        ...OrganizationsShortFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${OrganizationsShortFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useOrganizationsShortQuery__
 *
 * To run a query within a React component, call `useOrganizationsShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsShortQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOrganizationsShortQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsShortQuery, OrganizationsShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsShortQuery, OrganizationsShortQueryVariables>(OrganizationsShortDocument, options);
      }
export function useOrganizationsShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsShortQuery, OrganizationsShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsShortQuery, OrganizationsShortQueryVariables>(OrganizationsShortDocument, options);
        }
export type OrganizationsShortQueryHookResult = ReturnType<typeof useOrganizationsShortQuery>;
export type OrganizationsShortLazyQueryHookResult = ReturnType<typeof useOrganizationsShortLazyQuery>;
export type OrganizationsShortQueryResult = Apollo.QueryResult<OrganizationsShortQuery, OrganizationsShortQueryVariables>;
export function refetchOrganizationsShortQuery(variables?: OrganizationsShortQueryVariables) {
      return { query: OrganizationsShortDocument, variables: variables }
    }
export const ContactGroupsDocument = gql`
    query ContactGroups($after: String, $before: String, $limit: Int = 1000000, $sortField: String = "name", $searchFields: [String] = ["name", "description"], $sortOrder: SortOrder = ASCENDING, $searchText: String) {
  contactGroupsQuery(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, searchFields: $searchFields}
  ) {
    edges {
      node {
        ...ContactGroupListNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${ContactGroupListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useContactGroupsQuery__
 *
 * To run a query within a React component, call `useContactGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactGroupsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useContactGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ContactGroupsQuery, ContactGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactGroupsQuery, ContactGroupsQueryVariables>(ContactGroupsDocument, options);
      }
export function useContactGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactGroupsQuery, ContactGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactGroupsQuery, ContactGroupsQueryVariables>(ContactGroupsDocument, options);
        }
export type ContactGroupsQueryHookResult = ReturnType<typeof useContactGroupsQuery>;
export type ContactGroupsLazyQueryHookResult = ReturnType<typeof useContactGroupsLazyQuery>;
export type ContactGroupsQueryResult = Apollo.QueryResult<ContactGroupsQuery, ContactGroupsQueryVariables>;
export function refetchContactGroupsQuery(variables?: ContactGroupsQueryVariables) {
      return { query: ContactGroupsDocument, variables: variables }
    }
export const GetContactGroupDocument = gql`
    query GetContactGroup($id: ID!) {
  contactGroup(id: $id) {
    ...ContactGroupListNodeFragment
  }
}
    ${ContactGroupListNodeFragmentFragmentDoc}`;

/**
 * __useGetContactGroupQuery__
 *
 * To run a query within a React component, call `useGetContactGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactGroupQuery(baseOptions: Apollo.QueryHookOptions<GetContactGroupQuery, GetContactGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactGroupQuery, GetContactGroupQueryVariables>(GetContactGroupDocument, options);
      }
export function useGetContactGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactGroupQuery, GetContactGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactGroupQuery, GetContactGroupQueryVariables>(GetContactGroupDocument, options);
        }
export type GetContactGroupQueryHookResult = ReturnType<typeof useGetContactGroupQuery>;
export type GetContactGroupLazyQueryHookResult = ReturnType<typeof useGetContactGroupLazyQuery>;
export type GetContactGroupQueryResult = Apollo.QueryResult<GetContactGroupQuery, GetContactGroupQueryVariables>;
export function refetchGetContactGroupQuery(variables: GetContactGroupQueryVariables) {
      return { query: GetContactGroupDocument, variables: variables }
    }
export const ContactGroupUpdatedDocument = gql`
    subscription ContactGroupUpdated($ids: [ID!]) {
  contactGroupUpdated(ids: $ids) {
    streamObjectOperation
    dto {
      ...ContactGroupListNodeFragment
    }
  }
}
    ${ContactGroupListNodeFragmentFragmentDoc}`;

/**
 * __useContactGroupUpdatedSubscription__
 *
 * To run a query within a React component, call `useContactGroupUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContactGroupUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactGroupUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useContactGroupUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ContactGroupUpdatedSubscription, ContactGroupUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ContactGroupUpdatedSubscription, ContactGroupUpdatedSubscriptionVariables>(ContactGroupUpdatedDocument, options);
      }
export type ContactGroupUpdatedSubscriptionHookResult = ReturnType<typeof useContactGroupUpdatedSubscription>;
export type ContactGroupUpdatedSubscriptionResult = Apollo.SubscriptionResult<ContactGroupUpdatedSubscription>;
export const OrganizationsListDocument = gql`
    query OrganizationsList($after: String, $before: String, $limit: Int = 100000, $sortOrder: SortOrder = ASCENDING, $searchText: String, $searchFields: [String] = ["name", "notes"], $sortField: String = "name", $filters: [FilterInput]) {
  organizationsContact(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, searchFields: $searchFields, sortField: $sortField, filters: $filters}
  ) {
    edges {
      node {
        ...OrganizationsListFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${OrganizationsListFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useOrganizationsListQuery__
 *
 * To run a query within a React component, call `useOrganizationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOrganizationsListQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsListQuery, OrganizationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsListQuery, OrganizationsListQueryVariables>(OrganizationsListDocument, options);
      }
export function useOrganizationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsListQuery, OrganizationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsListQuery, OrganizationsListQueryVariables>(OrganizationsListDocument, options);
        }
export type OrganizationsListQueryHookResult = ReturnType<typeof useOrganizationsListQuery>;
export type OrganizationsListLazyQueryHookResult = ReturnType<typeof useOrganizationsListLazyQuery>;
export type OrganizationsListQueryResult = Apollo.QueryResult<OrganizationsListQuery, OrganizationsListQueryVariables>;
export function refetchOrganizationsListQuery(variables?: OrganizationsListQueryVariables) {
      return { query: OrganizationsListDocument, variables: variables }
    }
export const GetOrganizationDocument = gql`
    query GetOrganization($id: ID!) {
  organizationContact(id: $id) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export function refetchGetOrganizationQuery(variables: GetOrganizationQueryVariables) {
      return { query: GetOrganizationDocument, variables: variables }
    }
export const OrganizationUpdatedDocument = gql`
    subscription OrganizationUpdated($ids: [ID!]) {
  organizationUpdated(ids: $ids) {
    streamObjectOperation
    dto {
      ...OrganizationFragment
    }
  }
}
    ${OrganizationFragmentFragmentDoc}`;

/**
 * __useOrganizationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOrganizationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useOrganizationUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OrganizationUpdatedSubscription, OrganizationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrganizationUpdatedSubscription, OrganizationUpdatedSubscriptionVariables>(OrganizationUpdatedDocument, options);
      }
export type OrganizationUpdatedSubscriptionHookResult = ReturnType<typeof useOrganizationUpdatedSubscription>;
export type OrganizationUpdatedSubscriptionResult = Apollo.SubscriptionResult<OrganizationUpdatedSubscription>;
export const ContactUpdatedSubscriptionDocument = gql`
    subscription ContactUpdatedSubscription($ids: [ID!]) {
  contactUpdated(ids: $ids) {
    streamObjectOperation
    dto {
      id
    }
  }
}
    `;

/**
 * __useContactUpdatedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useContactUpdatedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContactUpdatedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactUpdatedSubscriptionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useContactUpdatedSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ContactUpdatedSubscriptionSubscription, ContactUpdatedSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ContactUpdatedSubscriptionSubscription, ContactUpdatedSubscriptionSubscriptionVariables>(ContactUpdatedSubscriptionDocument, options);
      }
export type ContactUpdatedSubscriptionSubscriptionHookResult = ReturnType<typeof useContactUpdatedSubscriptionSubscription>;
export type ContactUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<ContactUpdatedSubscriptionSubscription>;
export const ContactsByIdsDocument = gql`
    query ContactsByIds($ids: [ID!]!) {
  contactsByIds(ids: $ids) {
    ...ContactListItem
  }
}
    ${ContactListItemFragmentDoc}`;

/**
 * __useContactsByIdsQuery__
 *
 * To run a query within a React component, call `useContactsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useContactsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ContactsByIdsQuery, ContactsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsByIdsQuery, ContactsByIdsQueryVariables>(ContactsByIdsDocument, options);
      }
export function useContactsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsByIdsQuery, ContactsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsByIdsQuery, ContactsByIdsQueryVariables>(ContactsByIdsDocument, options);
        }
export type ContactsByIdsQueryHookResult = ReturnType<typeof useContactsByIdsQuery>;
export type ContactsByIdsLazyQueryHookResult = ReturnType<typeof useContactsByIdsLazyQuery>;
export type ContactsByIdsQueryResult = Apollo.QueryResult<ContactsByIdsQuery, ContactsByIdsQueryVariables>;
export function refetchContactsByIdsQuery(variables: ContactsByIdsQueryVariables) {
      return { query: ContactsByIdsDocument, variables: variables }
    }
export const ContactGroupsByIdsDocument = gql`
    query ContactGroupsByIds($ids: [ID!]!) {
  contactsGroupByIds(ids: $ids) {
    id
    name
    items {
      ...ContactListItem
    }
    subGroups {
      id
      name
      items {
        ...ContactListItem
      }
    }
  }
}
    ${ContactListItemFragmentDoc}`;

/**
 * __useContactGroupsByIdsQuery__
 *
 * To run a query within a React component, call `useContactGroupsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactGroupsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactGroupsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useContactGroupsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ContactGroupsByIdsQuery, ContactGroupsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactGroupsByIdsQuery, ContactGroupsByIdsQueryVariables>(ContactGroupsByIdsDocument, options);
      }
export function useContactGroupsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactGroupsByIdsQuery, ContactGroupsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactGroupsByIdsQuery, ContactGroupsByIdsQueryVariables>(ContactGroupsByIdsDocument, options);
        }
export type ContactGroupsByIdsQueryHookResult = ReturnType<typeof useContactGroupsByIdsQuery>;
export type ContactGroupsByIdsLazyQueryHookResult = ReturnType<typeof useContactGroupsByIdsLazyQuery>;
export type ContactGroupsByIdsQueryResult = Apollo.QueryResult<ContactGroupsByIdsQuery, ContactGroupsByIdsQueryVariables>;
export function refetchContactGroupsByIdsQuery(variables: ContactGroupsByIdsQueryVariables) {
      return { query: ContactGroupsByIdsDocument, variables: variables }
    }
export const CorridorActionSetListDocument = gql`
    query CorridorActionSetList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  signalActionSets(
    searchText: $searchText
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    before: $before
    after: $after
    limit: $limit
  ) {
    edges {
      node {
        number
        impact
        notes
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorActionSetListQuery__
 *
 * To run a query within a React component, call `useCorridorActionSetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorActionSetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorActionSetListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorActionSetListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorActionSetListQuery, CorridorActionSetListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorActionSetListQuery, CorridorActionSetListQueryVariables>(CorridorActionSetListDocument, options);
      }
export function useCorridorActionSetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorActionSetListQuery, CorridorActionSetListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorActionSetListQuery, CorridorActionSetListQueryVariables>(CorridorActionSetListDocument, options);
        }
export type CorridorActionSetListQueryHookResult = ReturnType<typeof useCorridorActionSetListQuery>;
export type CorridorActionSetListLazyQueryHookResult = ReturnType<typeof useCorridorActionSetListLazyQuery>;
export type CorridorActionSetListQueryResult = Apollo.QueryResult<CorridorActionSetListQuery, CorridorActionSetListQueryVariables>;
export function refetchCorridorActionSetListQuery(variables?: CorridorActionSetListQueryVariables) {
      return { query: CorridorActionSetListDocument, variables: variables }
    }
export const CorridorCamerasListDocument = gql`
    query CorridorCamerasList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput!], $searchText: String, $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  cameras(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    searchFields: ["name"]
    after: $after
  ) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useCorridorCamerasListQuery__
 *
 * To run a query within a React component, call `useCorridorCamerasListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorCamerasListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorCamerasListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorCamerasListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorCamerasListQuery, CorridorCamerasListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorCamerasListQuery, CorridorCamerasListQueryVariables>(CorridorCamerasListDocument, options);
      }
export function useCorridorCamerasListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorCamerasListQuery, CorridorCamerasListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorCamerasListQuery, CorridorCamerasListQueryVariables>(CorridorCamerasListDocument, options);
        }
export type CorridorCamerasListQueryHookResult = ReturnType<typeof useCorridorCamerasListQuery>;
export type CorridorCamerasListLazyQueryHookResult = ReturnType<typeof useCorridorCamerasListLazyQuery>;
export type CorridorCamerasListQueryResult = Apollo.QueryResult<CorridorCamerasListQuery, CorridorCamerasListQueryVariables>;
export function refetchCorridorCamerasListQuery(variables?: CorridorCamerasListQueryVariables) {
      return { query: CorridorCamerasListDocument, variables: variables }
    }
export const CorridorCameraRoadsDocument = gql`
    query CorridorCameraRoads($filters: [FilterInput!]) {
  cameras(filters: $filters) {
    edges {
      node {
        id
        road
      }
    }
  }
}
    `;

/**
 * __useCorridorCameraRoadsQuery__
 *
 * To run a query within a React component, call `useCorridorCameraRoadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorCameraRoadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorCameraRoadsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCorridorCameraRoadsQuery(baseOptions?: Apollo.QueryHookOptions<CorridorCameraRoadsQuery, CorridorCameraRoadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorCameraRoadsQuery, CorridorCameraRoadsQueryVariables>(CorridorCameraRoadsDocument, options);
      }
export function useCorridorCameraRoadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorCameraRoadsQuery, CorridorCameraRoadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorCameraRoadsQuery, CorridorCameraRoadsQueryVariables>(CorridorCameraRoadsDocument, options);
        }
export type CorridorCameraRoadsQueryHookResult = ReturnType<typeof useCorridorCameraRoadsQuery>;
export type CorridorCameraRoadsLazyQueryHookResult = ReturnType<typeof useCorridorCameraRoadsLazyQuery>;
export type CorridorCameraRoadsQueryResult = Apollo.QueryResult<CorridorCameraRoadsQuery, CorridorCameraRoadsQueryVariables>;
export function refetchCorridorCameraRoadsQuery(variables?: CorridorCameraRoadsQueryVariables) {
      return { query: CorridorCameraRoadsDocument, variables: variables }
    }
export const CorridorCutoutsListDocument = gql`
    query CorridorCutoutsList($after: String, $before: String, $limit: Int = 10, $sortField: String = "name", $sortOrder: SortOrder = DESCENDING, $searchText: String, $searchFields: [String!] = ["name", "type", "description"], $filters: [FilterInput]) {
  signGroups(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, searchFields: $searchFields, filters: $filters}
  ) {
    edges {
      node {
        description
        attributes
        signs {
          ...CorridorSchematicSign
        }
        type
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CorridorSchematicSignFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorCutoutsListQuery__
 *
 * To run a query within a React component, call `useCorridorCutoutsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorCutoutsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorCutoutsListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCorridorCutoutsListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorCutoutsListQuery, CorridorCutoutsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorCutoutsListQuery, CorridorCutoutsListQueryVariables>(CorridorCutoutsListDocument, options);
      }
export function useCorridorCutoutsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorCutoutsListQuery, CorridorCutoutsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorCutoutsListQuery, CorridorCutoutsListQueryVariables>(CorridorCutoutsListDocument, options);
        }
export type CorridorCutoutsListQueryHookResult = ReturnType<typeof useCorridorCutoutsListQuery>;
export type CorridorCutoutsListLazyQueryHookResult = ReturnType<typeof useCorridorCutoutsListLazyQuery>;
export type CorridorCutoutsListQueryResult = Apollo.QueryResult<CorridorCutoutsListQuery, CorridorCutoutsListQueryVariables>;
export function refetchCorridorCutoutsListQuery(variables?: CorridorCutoutsListQueryVariables) {
      return { query: CorridorCutoutsListDocument, variables: variables }
    }
export const CreateEventFromDetectionDocument = gql`
    mutation CreateEventFromDetection($id: ID!, $attributes: JSON) {
  createEventFromDetection(id: $id, attributes: $attributes) {
    id
  }
}
    `;
export type CreateEventFromDetectionMutationFn = Apollo.MutationFunction<CreateEventFromDetectionMutation, CreateEventFromDetectionMutationVariables>;

/**
 * __useCreateEventFromDetectionMutation__
 *
 * To run a mutation, you first call `useCreateEventFromDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventFromDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventFromDetectionMutation, { data, loading, error }] = useCreateEventFromDetectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateEventFromDetectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventFromDetectionMutation, CreateEventFromDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventFromDetectionMutation, CreateEventFromDetectionMutationVariables>(CreateEventFromDetectionDocument, options);
      }
export type CreateEventFromDetectionMutationHookResult = ReturnType<typeof useCreateEventFromDetectionMutation>;
export type CreateEventFromDetectionMutationResult = Apollo.MutationResult<CreateEventFromDetectionMutation>;
export type CreateEventFromDetectionMutationOptions = Apollo.BaseMutationOptions<CreateEventFromDetectionMutation, CreateEventFromDetectionMutationVariables>;
export const CorridorDetectionListDocument = gql`
    query CorridorDetectionList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  detections(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    after: $after
    limit: $limit
  ) {
    edges {
      node {
        id
        type
        description
        sources
        created
        lastUpdated
        severity
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorDetectionListQuery__
 *
 * To run a query within a React component, call `useCorridorDetectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorDetectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorDetectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorDetectionListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorDetectionListQuery, CorridorDetectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorDetectionListQuery, CorridorDetectionListQueryVariables>(CorridorDetectionListDocument, options);
      }
export function useCorridorDetectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorDetectionListQuery, CorridorDetectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorDetectionListQuery, CorridorDetectionListQueryVariables>(CorridorDetectionListDocument, options);
        }
export type CorridorDetectionListQueryHookResult = ReturnType<typeof useCorridorDetectionListQuery>;
export type CorridorDetectionListLazyQueryHookResult = ReturnType<typeof useCorridorDetectionListLazyQuery>;
export type CorridorDetectionListQueryResult = Apollo.QueryResult<CorridorDetectionListQuery, CorridorDetectionListQueryVariables>;
export function refetchCorridorDetectionListQuery(variables?: CorridorDetectionListQueryVariables) {
      return { query: CorridorDetectionListDocument, variables: variables }
    }
export const LiveCorridorDetectionListDocument = gql`
    subscription LiveCorridorDetectionList($ids: [ID!]) {
  detectionUpdated(ids: $ids) {
    id
    type
    description
    sources
    created
    lastUpdated
    severity
  }
}
    `;

/**
 * __useLiveCorridorDetectionListSubscription__
 *
 * To run a query within a React component, call `useLiveCorridorDetectionListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCorridorDetectionListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCorridorDetectionListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveCorridorDetectionListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveCorridorDetectionListSubscription, LiveCorridorDetectionListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveCorridorDetectionListSubscription, LiveCorridorDetectionListSubscriptionVariables>(LiveCorridorDetectionListDocument, options);
      }
export type LiveCorridorDetectionListSubscriptionHookResult = ReturnType<typeof useLiveCorridorDetectionListSubscription>;
export type LiveCorridorDetectionListSubscriptionResult = Apollo.SubscriptionResult<LiveCorridorDetectionListSubscription>;
export const DetectorPollDocument = gql`
    mutation DetectorPoll($ids: [ID!]!) {
  multiplePoll(ids: $ids, integrationType: COUNTS) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type DetectorPollMutationFn = Apollo.MutationFunction<DetectorPollMutation, DetectorPollMutationVariables>;

/**
 * __useDetectorPollMutation__
 *
 * To run a mutation, you first call `useDetectorPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetectorPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detectorPollMutation, { data, loading, error }] = useDetectorPollMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDetectorPollMutation(baseOptions?: Apollo.MutationHookOptions<DetectorPollMutation, DetectorPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetectorPollMutation, DetectorPollMutationVariables>(DetectorPollDocument, options);
      }
export type DetectorPollMutationHookResult = ReturnType<typeof useDetectorPollMutation>;
export type DetectorPollMutationResult = Apollo.MutationResult<DetectorPollMutation>;
export type DetectorPollMutationOptions = Apollo.BaseMutationOptions<DetectorPollMutation, DetectorPollMutationVariables>;
export const CorridorDetectorsListDocument = gql`
    query CorridorDetectorsList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  detectors(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        ...CorridorDetector
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CorridorDetectorFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorDetectorsListQuery__
 *
 * To run a query within a React component, call `useCorridorDetectorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorDetectorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorDetectorsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorDetectorsListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorDetectorsListQuery, CorridorDetectorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorDetectorsListQuery, CorridorDetectorsListQueryVariables>(CorridorDetectorsListDocument, options);
      }
export function useCorridorDetectorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorDetectorsListQuery, CorridorDetectorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorDetectorsListQuery, CorridorDetectorsListQueryVariables>(CorridorDetectorsListDocument, options);
        }
export type CorridorDetectorsListQueryHookResult = ReturnType<typeof useCorridorDetectorsListQuery>;
export type CorridorDetectorsListLazyQueryHookResult = ReturnType<typeof useCorridorDetectorsListLazyQuery>;
export type CorridorDetectorsListQueryResult = Apollo.QueryResult<CorridorDetectorsListQuery, CorridorDetectorsListQueryVariables>;
export function refetchCorridorDetectorsListQuery(variables?: CorridorDetectorsListQueryVariables) {
      return { query: CorridorDetectorsListDocument, variables: variables }
    }
export const LiveCorridorDetectorsListDocument = gql`
    subscription LiveCorridorDetectorsList($ids: [ID!]) {
  detectorUpdated(ids: $ids) {
    ...CorridorDetector
  }
}
    ${CorridorDetectorFragmentDoc}`;

/**
 * __useLiveCorridorDetectorsListSubscription__
 *
 * To run a query within a React component, call `useLiveCorridorDetectorsListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCorridorDetectorsListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCorridorDetectorsListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveCorridorDetectorsListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveCorridorDetectorsListSubscription, LiveCorridorDetectorsListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveCorridorDetectorsListSubscription, LiveCorridorDetectorsListSubscriptionVariables>(LiveCorridorDetectorsListDocument, options);
      }
export type LiveCorridorDetectorsListSubscriptionHookResult = ReturnType<typeof useLiveCorridorDetectorsListSubscription>;
export type LiveCorridorDetectorsListSubscriptionResult = Apollo.SubscriptionResult<LiveCorridorDetectorsListSubscription>;
export const CorridorEventListDocument = gql`
    query CorridorEventList($sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  events(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        category
        created
        status
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorEventListQuery__
 *
 * To run a query within a React component, call `useCorridorEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorEventListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorEventListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorEventListQuery, CorridorEventListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorEventListQuery, CorridorEventListQueryVariables>(CorridorEventListDocument, options);
      }
export function useCorridorEventListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorEventListQuery, CorridorEventListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorEventListQuery, CorridorEventListQueryVariables>(CorridorEventListDocument, options);
        }
export type CorridorEventListQueryHookResult = ReturnType<typeof useCorridorEventListQuery>;
export type CorridorEventListLazyQueryHookResult = ReturnType<typeof useCorridorEventListLazyQuery>;
export type CorridorEventListQueryResult = Apollo.QueryResult<CorridorEventListQuery, CorridorEventListQueryVariables>;
export function refetchCorridorEventListQuery(variables?: CorridorEventListQueryVariables) {
      return { query: CorridorEventListDocument, variables: variables }
    }
export const LiveCorridorEventListDocument = gql`
    subscription LiveCorridorEventList($ids: [ID!]) {
  eventUpdated(ids: $ids) {
    id
    name
    category
    status
    created
    lastUpdated
    attributes
    geometry
    type
    lanes {
      id
      direction
      laneStatus
      engineeringLane
      laneType
      lineType
      roadwayType
      closedTime
      openTime
    }
  }
}
    `;

/**
 * __useLiveCorridorEventListSubscription__
 *
 * To run a query within a React component, call `useLiveCorridorEventListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCorridorEventListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCorridorEventListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveCorridorEventListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveCorridorEventListSubscription, LiveCorridorEventListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveCorridorEventListSubscription, LiveCorridorEventListSubscriptionVariables>(LiveCorridorEventListDocument, options);
      }
export type LiveCorridorEventListSubscriptionHookResult = ReturnType<typeof useLiveCorridorEventListSubscription>;
export type LiveCorridorEventListSubscriptionResult = Apollo.SubscriptionResult<LiveCorridorEventListSubscription>;
export const SchematicGateUpdatedDocument = gql`
    subscription SchematicGateUpdated($ids: [ID!]!) {
  gateControllerUpdated(ids: $ids) {
    id
    name
    referencePoint
    direction
    entranceDirection
    road
    mode
    status
  }
}
    `;

/**
 * __useSchematicGateUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicGateUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicGateUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicGateUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicGateUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicGateUpdatedSubscription, SchematicGateUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicGateUpdatedSubscription, SchematicGateUpdatedSubscriptionVariables>(SchematicGateUpdatedDocument, options);
      }
export type SchematicGateUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicGateUpdatedSubscription>;
export type SchematicGateUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicGateUpdatedSubscription>;
export const SchematicGateDirectionDocument = gql`
    query SchematicGateDirection($filters: [FilterInput]) {
  gateControllerSystems(query: {filters: $filters}) {
    edges {
      node {
        outboundDirection
        inboundDirection
        status
        id
      }
    }
  }
}
    `;

/**
 * __useSchematicGateDirectionQuery__
 *
 * To run a query within a React component, call `useSchematicGateDirectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchematicGateDirectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicGateDirectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSchematicGateDirectionQuery(baseOptions?: Apollo.QueryHookOptions<SchematicGateDirectionQuery, SchematicGateDirectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchematicGateDirectionQuery, SchematicGateDirectionQueryVariables>(SchematicGateDirectionDocument, options);
      }
export function useSchematicGateDirectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchematicGateDirectionQuery, SchematicGateDirectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchematicGateDirectionQuery, SchematicGateDirectionQueryVariables>(SchematicGateDirectionDocument, options);
        }
export type SchematicGateDirectionQueryHookResult = ReturnType<typeof useSchematicGateDirectionQuery>;
export type SchematicGateDirectionLazyQueryHookResult = ReturnType<typeof useSchematicGateDirectionLazyQuery>;
export type SchematicGateDirectionQueryResult = Apollo.QueryResult<SchematicGateDirectionQuery, SchematicGateDirectionQueryVariables>;
export function refetchSchematicGateDirectionQuery(variables?: SchematicGateDirectionQueryVariables) {
      return { query: SchematicGateDirectionDocument, variables: variables }
    }
export const LiveSchematicGateDirectionDocument = gql`
    subscription LiveSchematicGateDirection($id: ID!) {
  gateControllerSystemUpdated(ids: [$id]) {
    outboundDirection
    inboundDirection
    status
    id
  }
}
    `;

/**
 * __useLiveSchematicGateDirectionSubscription__
 *
 * To run a query within a React component, call `useLiveSchematicGateDirectionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveSchematicGateDirectionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveSchematicGateDirectionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveSchematicGateDirectionSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveSchematicGateDirectionSubscription, LiveSchematicGateDirectionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveSchematicGateDirectionSubscription, LiveSchematicGateDirectionSubscriptionVariables>(LiveSchematicGateDirectionDocument, options);
      }
export type LiveSchematicGateDirectionSubscriptionHookResult = ReturnType<typeof useLiveSchematicGateDirectionSubscription>;
export type LiveSchematicGateDirectionSubscriptionResult = Apollo.SubscriptionResult<LiveSchematicGateDirectionSubscription>;
export const SchematicGateGroupsListDocument = gql`
    query SchematicGateGroupsList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  gateControllerSystems(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        groups {
          referencePoint
          controllers
          tollPoints
          direction
          rampType
          position
          name
          id
        }
      }
    }
  }
}
    `;

/**
 * __useSchematicGateGroupsListQuery__
 *
 * To run a query within a React component, call `useSchematicGateGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchematicGateGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicGateGroupsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSchematicGateGroupsListQuery(baseOptions?: Apollo.QueryHookOptions<SchematicGateGroupsListQuery, SchematicGateGroupsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchematicGateGroupsListQuery, SchematicGateGroupsListQueryVariables>(SchematicGateGroupsListDocument, options);
      }
export function useSchematicGateGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchematicGateGroupsListQuery, SchematicGateGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchematicGateGroupsListQuery, SchematicGateGroupsListQueryVariables>(SchematicGateGroupsListDocument, options);
        }
export type SchematicGateGroupsListQueryHookResult = ReturnType<typeof useSchematicGateGroupsListQuery>;
export type SchematicGateGroupsListLazyQueryHookResult = ReturnType<typeof useSchematicGateGroupsListLazyQuery>;
export type SchematicGateGroupsListQueryResult = Apollo.QueryResult<SchematicGateGroupsListQuery, SchematicGateGroupsListQueryVariables>;
export function refetchSchematicGateGroupsListQuery(variables?: SchematicGateGroupsListQueryVariables) {
      return { query: SchematicGateGroupsListDocument, variables: variables }
    }
export const SaveCorridorDocument = gql`
    mutation SaveCorridor($input: CorridorInput!) {
  corridorSave(input: $input) {
    ...Corridor
  }
}
    ${CorridorFragmentDoc}`;
export type SaveCorridorMutationFn = Apollo.MutationFunction<SaveCorridorMutation, SaveCorridorMutationVariables>;

/**
 * __useSaveCorridorMutation__
 *
 * To run a mutation, you first call `useSaveCorridorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCorridorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCorridorMutation, { data, loading, error }] = useSaveCorridorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCorridorMutation(baseOptions?: Apollo.MutationHookOptions<SaveCorridorMutation, SaveCorridorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCorridorMutation, SaveCorridorMutationVariables>(SaveCorridorDocument, options);
      }
export type SaveCorridorMutationHookResult = ReturnType<typeof useSaveCorridorMutation>;
export type SaveCorridorMutationResult = Apollo.MutationResult<SaveCorridorMutation>;
export type SaveCorridorMutationOptions = Apollo.BaseMutationOptions<SaveCorridorMutation, SaveCorridorMutationVariables>;
export const DeleteCorridorDocument = gql`
    mutation DeleteCorridor($id: ID!) {
  corridorDelete(id: $id)
}
    `;
export type DeleteCorridorMutationFn = Apollo.MutationFunction<DeleteCorridorMutation, DeleteCorridorMutationVariables>;

/**
 * __useDeleteCorridorMutation__
 *
 * To run a mutation, you first call `useDeleteCorridorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCorridorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCorridorMutation, { data, loading, error }] = useDeleteCorridorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCorridorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCorridorMutation, DeleteCorridorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCorridorMutation, DeleteCorridorMutationVariables>(DeleteCorridorDocument, options);
      }
export type DeleteCorridorMutationHookResult = ReturnType<typeof useDeleteCorridorMutation>;
export type DeleteCorridorMutationResult = Apollo.MutationResult<DeleteCorridorMutation>;
export type DeleteCorridorMutationOptions = Apollo.BaseMutationOptions<DeleteCorridorMutation, DeleteCorridorMutationVariables>;
export const SaveActivityLogDocument = gql`
    mutation SaveActivityLog($input: ActivityLogInput!) {
  addActivityLog(input: $input) {
    id
  }
}
    `;
export type SaveActivityLogMutationFn = Apollo.MutationFunction<SaveActivityLogMutation, SaveActivityLogMutationVariables>;

/**
 * __useSaveActivityLogMutation__
 *
 * To run a mutation, you first call `useSaveActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveActivityLogMutation, { data, loading, error }] = useSaveActivityLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveActivityLogMutation(baseOptions?: Apollo.MutationHookOptions<SaveActivityLogMutation, SaveActivityLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveActivityLogMutation, SaveActivityLogMutationVariables>(SaveActivityLogDocument, options);
      }
export type SaveActivityLogMutationHookResult = ReturnType<typeof useSaveActivityLogMutation>;
export type SaveActivityLogMutationResult = Apollo.MutationResult<SaveActivityLogMutation>;
export type SaveActivityLogMutationOptions = Apollo.BaseMutationOptions<SaveActivityLogMutation, SaveActivityLogMutationVariables>;
export const LoadCorridorDevicesDocument = gql`
    mutation LoadCorridorDevices($id: ID!) {
  corridorLoadDevices(id: $id) {
    integrations
    id
  }
}
    `;
export type LoadCorridorDevicesMutationFn = Apollo.MutationFunction<LoadCorridorDevicesMutation, LoadCorridorDevicesMutationVariables>;

/**
 * __useLoadCorridorDevicesMutation__
 *
 * To run a mutation, you first call `useLoadCorridorDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoadCorridorDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loadCorridorDevicesMutation, { data, loading, error }] = useLoadCorridorDevicesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadCorridorDevicesMutation(baseOptions?: Apollo.MutationHookOptions<LoadCorridorDevicesMutation, LoadCorridorDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoadCorridorDevicesMutation, LoadCorridorDevicesMutationVariables>(LoadCorridorDevicesDocument, options);
      }
export type LoadCorridorDevicesMutationHookResult = ReturnType<typeof useLoadCorridorDevicesMutation>;
export type LoadCorridorDevicesMutationResult = Apollo.MutationResult<LoadCorridorDevicesMutation>;
export type LoadCorridorDevicesMutationOptions = Apollo.BaseMutationOptions<LoadCorridorDevicesMutation, LoadCorridorDevicesMutationVariables>;
export const SaveShiftNotesDocument = gql`
    mutation SaveShiftNotes($id: ID!, $shiftNotes: String!) {
  saveShiftNotes(id: $id, shiftNotes: $shiftNotes) {
    ...Corridor
  }
}
    ${CorridorFragmentDoc}`;
export type SaveShiftNotesMutationFn = Apollo.MutationFunction<SaveShiftNotesMutation, SaveShiftNotesMutationVariables>;

/**
 * __useSaveShiftNotesMutation__
 *
 * To run a mutation, you first call `useSaveShiftNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveShiftNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveShiftNotesMutation, { data, loading, error }] = useSaveShiftNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      shiftNotes: // value for 'shiftNotes'
 *   },
 * });
 */
export function useSaveShiftNotesMutation(baseOptions?: Apollo.MutationHookOptions<SaveShiftNotesMutation, SaveShiftNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveShiftNotesMutation, SaveShiftNotesMutationVariables>(SaveShiftNotesDocument, options);
      }
export type SaveShiftNotesMutationHookResult = ReturnType<typeof useSaveShiftNotesMutation>;
export type SaveShiftNotesMutationResult = Apollo.MutationResult<SaveShiftNotesMutation>;
export type SaveShiftNotesMutationOptions = Apollo.BaseMutationOptions<SaveShiftNotesMutation, SaveShiftNotesMutationVariables>;
export const SaveTunnelLogDocument = gql`
    mutation SaveTunnelLog($input: TunnelLogInput!) {
  saveTunnelLog(input: $input) {
    id
  }
}
    `;
export type SaveTunnelLogMutationFn = Apollo.MutationFunction<SaveTunnelLogMutation, SaveTunnelLogMutationVariables>;

/**
 * __useSaveTunnelLogMutation__
 *
 * To run a mutation, you first call `useSaveTunnelLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTunnelLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTunnelLogMutation, { data, loading, error }] = useSaveTunnelLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTunnelLogMutation(baseOptions?: Apollo.MutationHookOptions<SaveTunnelLogMutation, SaveTunnelLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTunnelLogMutation, SaveTunnelLogMutationVariables>(SaveTunnelLogDocument, options);
      }
export type SaveTunnelLogMutationHookResult = ReturnType<typeof useSaveTunnelLogMutation>;
export type SaveTunnelLogMutationResult = Apollo.MutationResult<SaveTunnelLogMutation>;
export type SaveTunnelLogMutationOptions = Apollo.BaseMutationOptions<SaveTunnelLogMutation, SaveTunnelLogMutationVariables>;
export const CorridorSearchListDocument = gql`
    query CorridorSearchList($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  corridors(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        integrations
        type
        geometry
        name
        id
      }
    }
  }
}
    `;

/**
 * __useCorridorSearchListQuery__
 *
 * To run a query within a React component, call `useCorridorSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorSearchListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorSearchListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorSearchListQuery, CorridorSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorSearchListQuery, CorridorSearchListQueryVariables>(CorridorSearchListDocument, options);
      }
export function useCorridorSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorSearchListQuery, CorridorSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorSearchListQuery, CorridorSearchListQueryVariables>(CorridorSearchListDocument, options);
        }
export type CorridorSearchListQueryHookResult = ReturnType<typeof useCorridorSearchListQuery>;
export type CorridorSearchListLazyQueryHookResult = ReturnType<typeof useCorridorSearchListLazyQuery>;
export type CorridorSearchListQueryResult = Apollo.QueryResult<CorridorSearchListQuery, CorridorSearchListQueryVariables>;
export function refetchCorridorSearchListQuery(variables?: CorridorSearchListQueryVariables) {
      return { query: CorridorSearchListDocument, variables: variables }
    }
export const CorridorListDocument = gql`
    query CorridorList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  corridors(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        shiftNotes
        activationType
        description
        deviceTypes
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorListQuery__
 *
 * To run a query within a React component, call `useCorridorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorListQuery, CorridorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorListQuery, CorridorListQueryVariables>(CorridorListDocument, options);
      }
export function useCorridorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorListQuery, CorridorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorListQuery, CorridorListQueryVariables>(CorridorListDocument, options);
        }
export type CorridorListQueryHookResult = ReturnType<typeof useCorridorListQuery>;
export type CorridorListLazyQueryHookResult = ReturnType<typeof useCorridorListLazyQuery>;
export type CorridorListQueryResult = Apollo.QueryResult<CorridorListQuery, CorridorListQueryVariables>;
export function refetchCorridorListQuery(variables?: CorridorListQueryVariables) {
      return { query: CorridorListDocument, variables: variables }
    }
export const LiveCorridorListDocument = gql`
    subscription LiveCorridorList($ids: [ID!]) {
  corridorUpdated(ids: $ids) {
    activationType
    description
    deviceTypes
    name
    id
  }
}
    `;

/**
 * __useLiveCorridorListSubscription__
 *
 * To run a query within a React component, call `useLiveCorridorListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCorridorListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCorridorListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveCorridorListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveCorridorListSubscription, LiveCorridorListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveCorridorListSubscription, LiveCorridorListSubscriptionVariables>(LiveCorridorListDocument, options);
      }
export type LiveCorridorListSubscriptionHookResult = ReturnType<typeof useLiveCorridorListSubscription>;
export type LiveCorridorListSubscriptionResult = Apollo.SubscriptionResult<LiveCorridorListSubscription>;
export const CorridorDocument = gql`
    query Corridor($id: ID!) {
  corridor(id: $id) {
    ...Corridor
  }
}
    ${CorridorFragmentDoc}`;

/**
 * __useCorridorQuery__
 *
 * To run a query within a React component, call `useCorridorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCorridorQuery(baseOptions: Apollo.QueryHookOptions<CorridorQuery, CorridorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorQuery, CorridorQueryVariables>(CorridorDocument, options);
      }
export function useCorridorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorQuery, CorridorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorQuery, CorridorQueryVariables>(CorridorDocument, options);
        }
export type CorridorQueryHookResult = ReturnType<typeof useCorridorQuery>;
export type CorridorLazyQueryHookResult = ReturnType<typeof useCorridorLazyQuery>;
export type CorridorQueryResult = Apollo.QueryResult<CorridorQuery, CorridorQueryVariables>;
export function refetchCorridorQuery(variables: CorridorQueryVariables) {
      return { query: CorridorDocument, variables: variables }
    }
export const CorridorUpdatedDocument = gql`
    subscription CorridorUpdated($id: ID!) {
  corridorUpdated(ids: [$id]) {
    ...Corridor
  }
}
    ${CorridorFragmentDoc}`;

/**
 * __useCorridorUpdatedSubscription__
 *
 * To run a query within a React component, call `useCorridorUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCorridorUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCorridorUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CorridorUpdatedSubscription, CorridorUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CorridorUpdatedSubscription, CorridorUpdatedSubscriptionVariables>(CorridorUpdatedDocument, options);
      }
export type CorridorUpdatedSubscriptionHookResult = ReturnType<typeof useCorridorUpdatedSubscription>;
export type CorridorUpdatedSubscriptionResult = Apollo.SubscriptionResult<CorridorUpdatedSubscription>;
export const CorridorListUpdatedDocument = gql`
    subscription CorridorListUpdated($ids: [ID!]!) {
  corridorUpdated(ids: $ids) {
    ...Corridor
  }
}
    ${CorridorFragmentDoc}`;

/**
 * __useCorridorListUpdatedSubscription__
 *
 * To run a query within a React component, call `useCorridorListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCorridorListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorListUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCorridorListUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CorridorListUpdatedSubscription, CorridorListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CorridorListUpdatedSubscription, CorridorListUpdatedSubscriptionVariables>(CorridorListUpdatedDocument, options);
      }
export type CorridorListUpdatedSubscriptionHookResult = ReturnType<typeof useCorridorListUpdatedSubscription>;
export type CorridorListUpdatedSubscriptionResult = Apollo.SubscriptionResult<CorridorListUpdatedSubscription>;
export const RoadsDocument = gql`
    query Roads($integrationType: [IntegrationType]) {
  roads(integrationType: $integrationType)
}
    `;

/**
 * __useRoadsQuery__
 *
 * To run a query within a React component, call `useRoadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoadsQuery({
 *   variables: {
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useRoadsQuery(baseOptions?: Apollo.QueryHookOptions<RoadsQuery, RoadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoadsQuery, RoadsQueryVariables>(RoadsDocument, options);
      }
export function useRoadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoadsQuery, RoadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoadsQuery, RoadsQueryVariables>(RoadsDocument, options);
        }
export type RoadsQueryHookResult = ReturnType<typeof useRoadsQuery>;
export type RoadsLazyQueryHookResult = ReturnType<typeof useRoadsLazyQuery>;
export type RoadsQueryResult = Apollo.QueryResult<RoadsQuery, RoadsQueryVariables>;
export function refetchRoadsQuery(variables?: RoadsQueryVariables) {
      return { query: RoadsDocument, variables: variables }
    }
export const ResponseRuleCorridorDocument = gql`
    query ResponseRuleCorridor($id: ID!) {
  responseRule(id: $id) {
    corridor
  }
}
    `;

/**
 * __useResponseRuleCorridorQuery__
 *
 * To run a query within a React component, call `useResponseRuleCorridorQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseRuleCorridorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseRuleCorridorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResponseRuleCorridorQuery(baseOptions: Apollo.QueryHookOptions<ResponseRuleCorridorQuery, ResponseRuleCorridorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseRuleCorridorQuery, ResponseRuleCorridorQueryVariables>(ResponseRuleCorridorDocument, options);
      }
export function useResponseRuleCorridorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseRuleCorridorQuery, ResponseRuleCorridorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseRuleCorridorQuery, ResponseRuleCorridorQueryVariables>(ResponseRuleCorridorDocument, options);
        }
export type ResponseRuleCorridorQueryHookResult = ReturnType<typeof useResponseRuleCorridorQuery>;
export type ResponseRuleCorridorLazyQueryHookResult = ReturnType<typeof useResponseRuleCorridorLazyQuery>;
export type ResponseRuleCorridorQueryResult = Apollo.QueryResult<ResponseRuleCorridorQuery, ResponseRuleCorridorQueryVariables>;
export function refetchResponseRuleCorridorQuery(variables: ResponseRuleCorridorQueryVariables) {
      return { query: ResponseRuleCorridorDocument, variables: variables }
    }
export const CorridorFormDocument = gql`
    query CorridorForm($id: ID!) {
  corridor(id: $id) {
    lanes {
      reversiblePosition
      startReference
      endReference
      controller
      reversible
      direction
      position
      lineType
      type
      road
      id
    }
    landmarks {
      showReferencePoint
      bothDirections
      referencePoint
      direction
      name
      id
      settings
    }
    zones {
      bothDirections
      startReference
      endReference
      direction
      color
      name
      id
    }
    activationType
    responsePeriod
    integrations
    description
    shiftNotes
    deviceTypes
    settings
    geometry
    type
    name
    id
  }
}
    `;

/**
 * __useCorridorFormQuery__
 *
 * To run a query within a React component, call `useCorridorFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCorridorFormQuery(baseOptions: Apollo.QueryHookOptions<CorridorFormQuery, CorridorFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorFormQuery, CorridorFormQueryVariables>(CorridorFormDocument, options);
      }
export function useCorridorFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorFormQuery, CorridorFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorFormQuery, CorridorFormQueryVariables>(CorridorFormDocument, options);
        }
export type CorridorFormQueryHookResult = ReturnType<typeof useCorridorFormQuery>;
export type CorridorFormLazyQueryHookResult = ReturnType<typeof useCorridorFormLazyQuery>;
export type CorridorFormQueryResult = Apollo.QueryResult<CorridorFormQuery, CorridorFormQueryVariables>;
export function refetchCorridorFormQuery(variables: CorridorFormQueryVariables) {
      return { query: CorridorFormDocument, variables: variables }
    }
export const CorridorEventsDocument = gql`
    query CorridorEvents($filters: [FilterInput], $limit: Int = 10) {
  events(query: {filters: $filters, limit: $limit}) {
    edges {
      node {
        ...CorridorEvent
      }
    }
  }
}
    ${CorridorEventFragmentDoc}`;

/**
 * __useCorridorEventsQuery__
 *
 * To run a query within a React component, call `useCorridorEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCorridorEventsQuery(baseOptions?: Apollo.QueryHookOptions<CorridorEventsQuery, CorridorEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorEventsQuery, CorridorEventsQueryVariables>(CorridorEventsDocument, options);
      }
export function useCorridorEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorEventsQuery, CorridorEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorEventsQuery, CorridorEventsQueryVariables>(CorridorEventsDocument, options);
        }
export type CorridorEventsQueryHookResult = ReturnType<typeof useCorridorEventsQuery>;
export type CorridorEventsLazyQueryHookResult = ReturnType<typeof useCorridorEventsLazyQuery>;
export type CorridorEventsQueryResult = Apollo.QueryResult<CorridorEventsQuery, CorridorEventsQueryVariables>;
export function refetchCorridorEventsQuery(variables?: CorridorEventsQueryVariables) {
      return { query: CorridorEventsDocument, variables: variables }
    }
export const CorridorEventUpdatedDocument = gql`
    subscription CorridorEventUpdated($ids: [ID!]) {
  eventUpdated(ids: $ids) {
    ...CorridorEvent
  }
}
    ${CorridorEventFragmentDoc}`;

/**
 * __useCorridorEventUpdatedSubscription__
 *
 * To run a query within a React component, call `useCorridorEventUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCorridorEventUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorEventUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCorridorEventUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CorridorEventUpdatedSubscription, CorridorEventUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CorridorEventUpdatedSubscription, CorridorEventUpdatedSubscriptionVariables>(CorridorEventUpdatedDocument, options);
      }
export type CorridorEventUpdatedSubscriptionHookResult = ReturnType<typeof useCorridorEventUpdatedSubscription>;
export type CorridorEventUpdatedSubscriptionResult = Apollo.SubscriptionResult<CorridorEventUpdatedSubscription>;
export const CorridorMapListDocument = gql`
    query CorridorMapList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  corridors(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        type
        settings
        geometry
        name
        id
      }
    }
  }
}
    `;

/**
 * __useCorridorMapListQuery__
 *
 * To run a query within a React component, call `useCorridorMapListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorMapListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorMapListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorMapListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorMapListQuery, CorridorMapListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorMapListQuery, CorridorMapListQueryVariables>(CorridorMapListDocument, options);
      }
export function useCorridorMapListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorMapListQuery, CorridorMapListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorMapListQuery, CorridorMapListQueryVariables>(CorridorMapListDocument, options);
        }
export type CorridorMapListQueryHookResult = ReturnType<typeof useCorridorMapListQuery>;
export type CorridorMapListLazyQueryHookResult = ReturnType<typeof useCorridorMapListLazyQuery>;
export type CorridorMapListQueryResult = Apollo.QueryResult<CorridorMapListQuery, CorridorMapListQueryVariables>;
export function refetchCorridorMapListQuery(variables?: CorridorMapListQueryVariables) {
      return { query: CorridorMapListDocument, variables: variables }
    }
export const TunnelLogListDocument = gql`
    query TunnelLogList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String, $corridorId: ID!) {
  tunnelLogs(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, corridorId: $corridorId, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        ...TunnelLog
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${TunnelLogFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useTunnelLogListQuery__
 *
 * To run a query within a React component, call `useTunnelLogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelLogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelLogListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      corridorId: // value for 'corridorId'
 *   },
 * });
 */
export function useTunnelLogListQuery(baseOptions: Apollo.QueryHookOptions<TunnelLogListQuery, TunnelLogListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelLogListQuery, TunnelLogListQueryVariables>(TunnelLogListDocument, options);
      }
export function useTunnelLogListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelLogListQuery, TunnelLogListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelLogListQuery, TunnelLogListQueryVariables>(TunnelLogListDocument, options);
        }
export type TunnelLogListQueryHookResult = ReturnType<typeof useTunnelLogListQuery>;
export type TunnelLogListLazyQueryHookResult = ReturnType<typeof useTunnelLogListLazyQuery>;
export type TunnelLogListQueryResult = Apollo.QueryResult<TunnelLogListQuery, TunnelLogListQueryVariables>;
export function refetchTunnelLogListQuery(variables: TunnelLogListQueryVariables) {
      return { query: TunnelLogListDocument, variables: variables }
    }
export const TunnelLogIdListDocument = gql`
    query TunnelLogIdList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10000, $before: String, $after: String, $corridorId: ID!) {
  tunnelLogs(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, corridorId: $corridorId, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useTunnelLogIdListQuery__
 *
 * To run a query within a React component, call `useTunnelLogIdListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelLogIdListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelLogIdListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      corridorId: // value for 'corridorId'
 *   },
 * });
 */
export function useTunnelLogIdListQuery(baseOptions: Apollo.QueryHookOptions<TunnelLogIdListQuery, TunnelLogIdListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelLogIdListQuery, TunnelLogIdListQueryVariables>(TunnelLogIdListDocument, options);
      }
export function useTunnelLogIdListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelLogIdListQuery, TunnelLogIdListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelLogIdListQuery, TunnelLogIdListQueryVariables>(TunnelLogIdListDocument, options);
        }
export type TunnelLogIdListQueryHookResult = ReturnType<typeof useTunnelLogIdListQuery>;
export type TunnelLogIdListLazyQueryHookResult = ReturnType<typeof useTunnelLogIdListLazyQuery>;
export type TunnelLogIdListQueryResult = Apollo.QueryResult<TunnelLogIdListQuery, TunnelLogIdListQueryVariables>;
export function refetchTunnelLogIdListQuery(variables: TunnelLogIdListQueryVariables) {
      return { query: TunnelLogIdListDocument, variables: variables }
    }
export const TunnelLogDocument = gql`
    query TunnelLog($id: ID!) {
  tunnelLog(id: $id) {
    ...TunnelLog
  }
}
    ${TunnelLogFragmentDoc}`;

/**
 * __useTunnelLogQuery__
 *
 * To run a query within a React component, call `useTunnelLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTunnelLogQuery(baseOptions: Apollo.QueryHookOptions<TunnelLogQuery, TunnelLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelLogQuery, TunnelLogQueryVariables>(TunnelLogDocument, options);
      }
export function useTunnelLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelLogQuery, TunnelLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelLogQuery, TunnelLogQueryVariables>(TunnelLogDocument, options);
        }
export type TunnelLogQueryHookResult = ReturnType<typeof useTunnelLogQuery>;
export type TunnelLogLazyQueryHookResult = ReturnType<typeof useTunnelLogLazyQuery>;
export type TunnelLogQueryResult = Apollo.QueryResult<TunnelLogQuery, TunnelLogQueryVariables>;
export function refetchTunnelLogQuery(variables: TunnelLogQueryVariables) {
      return { query: TunnelLogDocument, variables: variables }
    }
export const DeleteResourcePlanDocument = gql`
    mutation DeleteResourcePlan($id: ID!) {
  deleteResourcePlan(id: $id)
}
    `;
export type DeleteResourcePlanMutationFn = Apollo.MutationFunction<DeleteResourcePlanMutation, DeleteResourcePlanMutationVariables>;

/**
 * __useDeleteResourcePlanMutation__
 *
 * To run a mutation, you first call `useDeleteResourcePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourcePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourcePlanMutation, { data, loading, error }] = useDeleteResourcePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourcePlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourcePlanMutation, DeleteResourcePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourcePlanMutation, DeleteResourcePlanMutationVariables>(DeleteResourcePlanDocument, options);
      }
export type DeleteResourcePlanMutationHookResult = ReturnType<typeof useDeleteResourcePlanMutation>;
export type DeleteResourcePlanMutationResult = Apollo.MutationResult<DeleteResourcePlanMutation>;
export type DeleteResourcePlanMutationOptions = Apollo.BaseMutationOptions<DeleteResourcePlanMutation, DeleteResourcePlanMutationVariables>;
export const SaveCorridorResourcePlanDocument = gql`
    mutation SaveCorridorResourcePlan($input: ResourcePlanInput!) {
  saveResourcePlan(input: $input) {
    ...CorridorResourcePlan
  }
}
    ${CorridorResourcePlanFragmentDoc}`;
export type SaveCorridorResourcePlanMutationFn = Apollo.MutationFunction<SaveCorridorResourcePlanMutation, SaveCorridorResourcePlanMutationVariables>;

/**
 * __useSaveCorridorResourcePlanMutation__
 *
 * To run a mutation, you first call `useSaveCorridorResourcePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCorridorResourcePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCorridorResourcePlanMutation, { data, loading, error }] = useSaveCorridorResourcePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCorridorResourcePlanMutation(baseOptions?: Apollo.MutationHookOptions<SaveCorridorResourcePlanMutation, SaveCorridorResourcePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCorridorResourcePlanMutation, SaveCorridorResourcePlanMutationVariables>(SaveCorridorResourcePlanDocument, options);
      }
export type SaveCorridorResourcePlanMutationHookResult = ReturnType<typeof useSaveCorridorResourcePlanMutation>;
export type SaveCorridorResourcePlanMutationResult = Apollo.MutationResult<SaveCorridorResourcePlanMutation>;
export type SaveCorridorResourcePlanMutationOptions = Apollo.BaseMutationOptions<SaveCorridorResourcePlanMutation, SaveCorridorResourcePlanMutationVariables>;
export const ActivateResourcePlanDocument = gql`
    mutation ActivateResourcePlan($id: ID!, $resources: [ID!], $activationId: String, $data: Object) {
  activateResources(
    id: $id
    resources: $resources
    activationId: $activationId
    data: $data
  ) {
    requestId
    failure
    success
    id
  }
}
    `;
export type ActivateResourcePlanMutationFn = Apollo.MutationFunction<ActivateResourcePlanMutation, ActivateResourcePlanMutationVariables>;

/**
 * __useActivateResourcePlanMutation__
 *
 * To run a mutation, you first call `useActivateResourcePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateResourcePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateResourcePlanMutation, { data, loading, error }] = useActivateResourcePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resources: // value for 'resources'
 *      activationId: // value for 'activationId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useActivateResourcePlanMutation(baseOptions?: Apollo.MutationHookOptions<ActivateResourcePlanMutation, ActivateResourcePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateResourcePlanMutation, ActivateResourcePlanMutationVariables>(ActivateResourcePlanDocument, options);
      }
export type ActivateResourcePlanMutationHookResult = ReturnType<typeof useActivateResourcePlanMutation>;
export type ActivateResourcePlanMutationResult = Apollo.MutationResult<ActivateResourcePlanMutation>;
export type ActivateResourcePlanMutationOptions = Apollo.BaseMutationOptions<ActivateResourcePlanMutation, ActivateResourcePlanMutationVariables>;
export const GetResourcePlanDocument = gql`
    query GetResourcePlan($id: ID!) {
  resourcePlan(id: $id) {
    ...CorridorResourcePlan
  }
}
    ${CorridorResourcePlanFragmentDoc}`;

/**
 * __useGetResourcePlanQuery__
 *
 * To run a query within a React component, call `useGetResourcePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcePlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResourcePlanQuery(baseOptions: Apollo.QueryHookOptions<GetResourcePlanQuery, GetResourcePlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourcePlanQuery, GetResourcePlanQueryVariables>(GetResourcePlanDocument, options);
      }
export function useGetResourcePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourcePlanQuery, GetResourcePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourcePlanQuery, GetResourcePlanQueryVariables>(GetResourcePlanDocument, options);
        }
export type GetResourcePlanQueryHookResult = ReturnType<typeof useGetResourcePlanQuery>;
export type GetResourcePlanLazyQueryHookResult = ReturnType<typeof useGetResourcePlanLazyQuery>;
export type GetResourcePlanQueryResult = Apollo.QueryResult<GetResourcePlanQuery, GetResourcePlanQueryVariables>;
export function refetchGetResourcePlanQuery(variables: GetResourcePlanQueryVariables) {
      return { query: GetResourcePlanDocument, variables: variables }
    }
export const CorridorResourcePlanDocument = gql`
    query CorridorResourcePlan($id: ID!) {
  resourcePlan(id: $id) {
    ...CorridorResourcePlan
  }
}
    ${CorridorResourcePlanFragmentDoc}`;

/**
 * __useCorridorResourcePlanQuery__
 *
 * To run a query within a React component, call `useCorridorResourcePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorResourcePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorResourcePlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCorridorResourcePlanQuery(baseOptions: Apollo.QueryHookOptions<CorridorResourcePlanQuery, CorridorResourcePlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorResourcePlanQuery, CorridorResourcePlanQueryVariables>(CorridorResourcePlanDocument, options);
      }
export function useCorridorResourcePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorResourcePlanQuery, CorridorResourcePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorResourcePlanQuery, CorridorResourcePlanQueryVariables>(CorridorResourcePlanDocument, options);
        }
export type CorridorResourcePlanQueryHookResult = ReturnType<typeof useCorridorResourcePlanQuery>;
export type CorridorResourcePlanLazyQueryHookResult = ReturnType<typeof useCorridorResourcePlanLazyQuery>;
export type CorridorResourcePlanQueryResult = Apollo.QueryResult<CorridorResourcePlanQuery, CorridorResourcePlanQueryVariables>;
export function refetchCorridorResourcePlanQuery(variables: CorridorResourcePlanQueryVariables) {
      return { query: CorridorResourcePlanDocument, variables: variables }
    }
export const CorridorResourcePlanListDocument = gql`
    query CorridorResourcePlanList($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 1000, $corridorId: ID, $before: String, $after: String) {
  resourcePlans(
    query: {searchText: $searchText, corridorId: $corridorId, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        ...CorridorResourcePlan
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CorridorResourcePlanFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorResourcePlanListQuery__
 *
 * To run a query within a React component, call `useCorridorResourcePlanListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorResourcePlanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorResourcePlanListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      corridorId: // value for 'corridorId'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorResourcePlanListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorResourcePlanListQuery, CorridorResourcePlanListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorResourcePlanListQuery, CorridorResourcePlanListQueryVariables>(CorridorResourcePlanListDocument, options);
      }
export function useCorridorResourcePlanListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorResourcePlanListQuery, CorridorResourcePlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorResourcePlanListQuery, CorridorResourcePlanListQueryVariables>(CorridorResourcePlanListDocument, options);
        }
export type CorridorResourcePlanListQueryHookResult = ReturnType<typeof useCorridorResourcePlanListQuery>;
export type CorridorResourcePlanListLazyQueryHookResult = ReturnType<typeof useCorridorResourcePlanListLazyQuery>;
export type CorridorResourcePlanListQueryResult = Apollo.QueryResult<CorridorResourcePlanListQuery, CorridorResourcePlanListQueryVariables>;
export function refetchCorridorResourcePlanListQuery(variables?: CorridorResourcePlanListQueryVariables) {
      return { query: CorridorResourcePlanListDocument, variables: variables }
    }
export const LiveCorridorResourcePlanListDocument = gql`
    subscription LiveCorridorResourcePlanList($ids: [ID!]!) {
  resourcePlanUpdated(ids: $ids) {
    ...CorridorResourcePlan
  }
}
    ${CorridorResourcePlanFragmentDoc}`;

/**
 * __useLiveCorridorResourcePlanListSubscription__
 *
 * To run a query within a React component, call `useLiveCorridorResourcePlanListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCorridorResourcePlanListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCorridorResourcePlanListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveCorridorResourcePlanListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveCorridorResourcePlanListSubscription, LiveCorridorResourcePlanListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveCorridorResourcePlanListSubscription, LiveCorridorResourcePlanListSubscriptionVariables>(LiveCorridorResourcePlanListDocument, options);
      }
export type LiveCorridorResourcePlanListSubscriptionHookResult = ReturnType<typeof useLiveCorridorResourcePlanListSubscription>;
export type LiveCorridorResourcePlanListSubscriptionResult = Apollo.SubscriptionResult<LiveCorridorResourcePlanListSubscription>;
export const ResourcePlanResourcesListDocument = gql`
    query ResourcePlanResourcesList($id: ID!) {
  resourcePlan(id: $id) {
    resources {
      status
      type
      data
      id
    }
  }
}
    `;

/**
 * __useResourcePlanResourcesListQuery__
 *
 * To run a query within a React component, call `useResourcePlanResourcesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanResourcesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanResourcesListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourcePlanResourcesListQuery(baseOptions: Apollo.QueryHookOptions<ResourcePlanResourcesListQuery, ResourcePlanResourcesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcePlanResourcesListQuery, ResourcePlanResourcesListQueryVariables>(ResourcePlanResourcesListDocument, options);
      }
export function useResourcePlanResourcesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcePlanResourcesListQuery, ResourcePlanResourcesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcePlanResourcesListQuery, ResourcePlanResourcesListQueryVariables>(ResourcePlanResourcesListDocument, options);
        }
export type ResourcePlanResourcesListQueryHookResult = ReturnType<typeof useResourcePlanResourcesListQuery>;
export type ResourcePlanResourcesListLazyQueryHookResult = ReturnType<typeof useResourcePlanResourcesListLazyQuery>;
export type ResourcePlanResourcesListQueryResult = Apollo.QueryResult<ResourcePlanResourcesListQuery, ResourcePlanResourcesListQueryVariables>;
export function refetchResourcePlanResourcesListQuery(variables: ResourcePlanResourcesListQueryVariables) {
      return { query: ResourcePlanResourcesListDocument, variables: variables }
    }
export const SchematicResponsePostDocument = gql`
    mutation SchematicResponsePost($requests: [SignMessageDisplayRequest!]!) {
  signDisplay(requests: $requests) {
    requestId
    success
    failure
    id
  }
}
    `;
export type SchematicResponsePostMutationFn = Apollo.MutationFunction<SchematicResponsePostMutation, SchematicResponsePostMutationVariables>;

/**
 * __useSchematicResponsePostMutation__
 *
 * To run a mutation, you first call `useSchematicResponsePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchematicResponsePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schematicResponsePostMutation, { data, loading, error }] = useSchematicResponsePostMutation({
 *   variables: {
 *      requests: // value for 'requests'
 *   },
 * });
 */
export function useSchematicResponsePostMutation(baseOptions?: Apollo.MutationHookOptions<SchematicResponsePostMutation, SchematicResponsePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchematicResponsePostMutation, SchematicResponsePostMutationVariables>(SchematicResponsePostDocument, options);
      }
export type SchematicResponsePostMutationHookResult = ReturnType<typeof useSchematicResponsePostMutation>;
export type SchematicResponsePostMutationResult = Apollo.MutationResult<SchematicResponsePostMutation>;
export type SchematicResponsePostMutationOptions = Apollo.BaseMutationOptions<SchematicResponsePostMutation, SchematicResponsePostMutationVariables>;
export const CorridorSchematicSignsDocument = gql`
    query CorridorSchematicSigns($filters: [FilterInput!]!, $limit: Int!) {
  signs(filters: $filters, limit: $limit) {
    edges {
      node {
        ...CorridorSchematicSign
      }
    }
  }
}
    ${CorridorSchematicSignFragmentDoc}`;

/**
 * __useCorridorSchematicSignsQuery__
 *
 * To run a query within a React component, call `useCorridorSchematicSignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorSchematicSignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorSchematicSignsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCorridorSchematicSignsQuery(baseOptions: Apollo.QueryHookOptions<CorridorSchematicSignsQuery, CorridorSchematicSignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorSchematicSignsQuery, CorridorSchematicSignsQueryVariables>(CorridorSchematicSignsDocument, options);
      }
export function useCorridorSchematicSignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorSchematicSignsQuery, CorridorSchematicSignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorSchematicSignsQuery, CorridorSchematicSignsQueryVariables>(CorridorSchematicSignsDocument, options);
        }
export type CorridorSchematicSignsQueryHookResult = ReturnType<typeof useCorridorSchematicSignsQuery>;
export type CorridorSchematicSignsLazyQueryHookResult = ReturnType<typeof useCorridorSchematicSignsLazyQuery>;
export type CorridorSchematicSignsQueryResult = Apollo.QueryResult<CorridorSchematicSignsQuery, CorridorSchematicSignsQueryVariables>;
export function refetchCorridorSchematicSignsQuery(variables: CorridorSchematicSignsQueryVariables) {
      return { query: CorridorSchematicSignsDocument, variables: variables }
    }
export const LiveCorridorSchematicSignsDocument = gql`
    subscription LiveCorridorSchematicSigns($integrations: [ID!]!) {
  signUpdated(ids: $integrations) {
    ...CorridorSchematicSign
  }
}
    ${CorridorSchematicSignFragmentDoc}`;

/**
 * __useLiveCorridorSchematicSignsSubscription__
 *
 * To run a query within a React component, call `useLiveCorridorSchematicSignsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCorridorSchematicSignsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCorridorSchematicSignsSubscription({
 *   variables: {
 *      integrations: // value for 'integrations'
 *   },
 * });
 */
export function useLiveCorridorSchematicSignsSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveCorridorSchematicSignsSubscription, LiveCorridorSchematicSignsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveCorridorSchematicSignsSubscription, LiveCorridorSchematicSignsSubscriptionVariables>(LiveCorridorSchematicSignsDocument, options);
      }
export type LiveCorridorSchematicSignsSubscriptionHookResult = ReturnType<typeof useLiveCorridorSchematicSignsSubscription>;
export type LiveCorridorSchematicSignsSubscriptionResult = Apollo.SubscriptionResult<LiveCorridorSchematicSignsSubscription>;
export const CorridorSignsListDocument = gql`
    query CorridorSignsList($searchFields: [String!] = ["name", "road", "direction", "referencePoint"], $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  signs(
    searchFields: $searchFields
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...CorridorSign
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CorridorSignFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorSignsListQuery__
 *
 * To run a query within a React component, call `useCorridorSignsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorSignsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorSignsListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorSignsListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorSignsListQuery, CorridorSignsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorSignsListQuery, CorridorSignsListQueryVariables>(CorridorSignsListDocument, options);
      }
export function useCorridorSignsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorSignsListQuery, CorridorSignsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorSignsListQuery, CorridorSignsListQueryVariables>(CorridorSignsListDocument, options);
        }
export type CorridorSignsListQueryHookResult = ReturnType<typeof useCorridorSignsListQuery>;
export type CorridorSignsListLazyQueryHookResult = ReturnType<typeof useCorridorSignsListLazyQuery>;
export type CorridorSignsListQueryResult = Apollo.QueryResult<CorridorSignsListQuery, CorridorSignsListQueryVariables>;
export function refetchCorridorSignsListQuery(variables?: CorridorSignsListQueryVariables) {
      return { query: CorridorSignsListDocument, variables: variables }
    }
export const LiveCorridorSignsListDocument = gql`
    subscription LiveCorridorSignsList($ids: [ID!]) {
  signUpdated(ids: $ids) {
    ...CorridorSign
  }
}
    ${CorridorSignFragmentDoc}`;

/**
 * __useLiveCorridorSignsListSubscription__
 *
 * To run a query within a React component, call `useLiveCorridorSignsListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCorridorSignsListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCorridorSignsListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveCorridorSignsListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveCorridorSignsListSubscription, LiveCorridorSignsListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveCorridorSignsListSubscription, LiveCorridorSignsListSubscriptionVariables>(LiveCorridorSignsListDocument, options);
      }
export type LiveCorridorSignsListSubscriptionHookResult = ReturnType<typeof useLiveCorridorSignsListSubscription>;
export type LiveCorridorSignsListSubscriptionResult = Apollo.SubscriptionResult<LiveCorridorSignsListSubscription>;
export const SignMessageValidateDocument = gql`
    query SignMessageValidate($id: ID!, $message: SignMessageInput!) {
  validateSignMessage(id: $id, message: $message) {
    failure
  }
}
    `;

/**
 * __useSignMessageValidateQuery__
 *
 * To run a query within a React component, call `useSignMessageValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessageValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessageValidateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSignMessageValidateQuery(baseOptions: Apollo.QueryHookOptions<SignMessageValidateQuery, SignMessageValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessageValidateQuery, SignMessageValidateQueryVariables>(SignMessageValidateDocument, options);
      }
export function useSignMessageValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessageValidateQuery, SignMessageValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessageValidateQuery, SignMessageValidateQueryVariables>(SignMessageValidateDocument, options);
        }
export type SignMessageValidateQueryHookResult = ReturnType<typeof useSignMessageValidateQuery>;
export type SignMessageValidateLazyQueryHookResult = ReturnType<typeof useSignMessageValidateLazyQuery>;
export type SignMessageValidateQueryResult = Apollo.QueryResult<SignMessageValidateQuery, SignMessageValidateQueryVariables>;
export function refetchSignMessageValidateQuery(variables: SignMessageValidateQueryVariables) {
      return { query: SignMessageValidateDocument, variables: variables }
    }
export const SignSchematicEntitiesDocument = gql`
    query SignSchematicEntities($ids: [ID!]!) {
  signSchematicEntities(ids: $ids)
}
    `;

/**
 * __useSignSchematicEntitiesQuery__
 *
 * To run a query within a React component, call `useSignSchematicEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignSchematicEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignSchematicEntitiesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSignSchematicEntitiesQuery(baseOptions: Apollo.QueryHookOptions<SignSchematicEntitiesQuery, SignSchematicEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignSchematicEntitiesQuery, SignSchematicEntitiesQueryVariables>(SignSchematicEntitiesDocument, options);
      }
export function useSignSchematicEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignSchematicEntitiesQuery, SignSchematicEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignSchematicEntitiesQuery, SignSchematicEntitiesQueryVariables>(SignSchematicEntitiesDocument, options);
        }
export type SignSchematicEntitiesQueryHookResult = ReturnType<typeof useSignSchematicEntitiesQuery>;
export type SignSchematicEntitiesLazyQueryHookResult = ReturnType<typeof useSignSchematicEntitiesLazyQuery>;
export type SignSchematicEntitiesQueryResult = Apollo.QueryResult<SignSchematicEntitiesQuery, SignSchematicEntitiesQueryVariables>;
export function refetchSignSchematicEntitiesQuery(variables: SignSchematicEntitiesQueryVariables) {
      return { query: SignSchematicEntitiesDocument, variables: variables }
    }
export const SchematicSignUpdatedDocument = gql`
    subscription SchematicSignUpdated($ids: [ID!]!) {
  signUpdated(ids: $ids) {
    ...CorridorSchematicSign
  }
}
    ${CorridorSchematicSignFragmentDoc}`;

/**
 * __useSchematicSignUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicSignUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicSignUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicSignUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicSignUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicSignUpdatedSubscription, SchematicSignUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicSignUpdatedSubscription, SchematicSignUpdatedSubscriptionVariables>(SchematicSignUpdatedDocument, options);
      }
export type SchematicSignUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicSignUpdatedSubscription>;
export type SchematicSignUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicSignUpdatedSubscription>;
export const SchematicCameraUpdatedDocument = gql`
    subscription SchematicCameraUpdated($ids: [ID!]!) {
  cameraUpdated(ids: $ids) {
    communicationStatus
    direction
    id
    name
    referencePoint
    road
  }
}
    `;

/**
 * __useSchematicCameraUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicCameraUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicCameraUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicCameraUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicCameraUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicCameraUpdatedSubscription, SchematicCameraUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicCameraUpdatedSubscription, SchematicCameraUpdatedSubscriptionVariables>(SchematicCameraUpdatedDocument, options);
      }
export type SchematicCameraUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicCameraUpdatedSubscription>;
export type SchematicCameraUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicCameraUpdatedSubscription>;
export const SchematicDetectorUpdatedDocument = gql`
    subscription SchematicDetectorUpdated($ids: [ID!]!) {
  detectorUpdated(ids: $ids) {
    id
    referencePoint
    laneDirection
    direction
    lanes {
      laneIndex
      reversible
      speed
      density
      occupancy
      volume
      type
      engineeringLane
      direction
    }
  }
}
    `;

/**
 * __useSchematicDetectorUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicDetectorUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicDetectorUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicDetectorUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicDetectorUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicDetectorUpdatedSubscription, SchematicDetectorUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicDetectorUpdatedSubscription, SchematicDetectorUpdatedSubscriptionVariables>(SchematicDetectorUpdatedDocument, options);
      }
export type SchematicDetectorUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicDetectorUpdatedSubscription>;
export type SchematicDetectorUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicDetectorUpdatedSubscription>;
export const SchematicTrafficControlUpdatedDocument = gql`
    subscription SchematicTrafficControlUpdated($ids: [ID!]!) {
  trafficControlUpdated(ids: $ids) {
    referencePoint
    laneDirection
    lanePosition
    direction
    laneType
    mode
    id
  }
}
    `;

/**
 * __useSchematicTrafficControlUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicTrafficControlUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicTrafficControlUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicTrafficControlUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicTrafficControlUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicTrafficControlUpdatedSubscription, SchematicTrafficControlUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicTrafficControlUpdatedSubscription, SchematicTrafficControlUpdatedSubscriptionVariables>(SchematicTrafficControlUpdatedDocument, options);
      }
export type SchematicTrafficControlUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicTrafficControlUpdatedSubscription>;
export type SchematicTrafficControlUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicTrafficControlUpdatedSubscription>;
export const SchematicTunnelFanUpdatedDocument = gql`
    subscription SchematicTunnelFanUpdated($ids: [ID!]!) {
  tunnelFanUpdated(ids: $ids) {
    speed
    running
    runStatus
    serviceStatus
    priority
    communicationStatus
    lastDataReceived
    referencePoint
    direction
    road
    name
    id
  }
}
    `;

/**
 * __useSchematicTunnelFanUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicTunnelFanUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicTunnelFanUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicTunnelFanUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicTunnelFanUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicTunnelFanUpdatedSubscription, SchematicTunnelFanUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicTunnelFanUpdatedSubscription, SchematicTunnelFanUpdatedSubscriptionVariables>(SchematicTunnelFanUpdatedDocument, options);
      }
export type SchematicTunnelFanUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicTunnelFanUpdatedSubscription>;
export type SchematicTunnelFanUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicTunnelFanUpdatedSubscription>;
export const SchematicCutoutUpdatedDocument = gql`
    subscription SchematicCutoutUpdated($ids: [ID!]!) {
  signGroupUpdated(ids: $ids, types: [CUTOUT]) {
    id
    attributes
    signs {
      id
      direction
    }
  }
}
    `;

/**
 * __useSchematicCutoutUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicCutoutUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicCutoutUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicCutoutUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicCutoutUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicCutoutUpdatedSubscription, SchematicCutoutUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicCutoutUpdatedSubscription, SchematicCutoutUpdatedSubscriptionVariables>(SchematicCutoutUpdatedDocument, options);
      }
export type SchematicCutoutUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicCutoutUpdatedSubscription>;
export type SchematicCutoutUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicCutoutUpdatedSubscription>;
export const SchematicTunnelLightUpdatedDocument = gql`
    subscription SchematicTunnelLightUpdated($ids: [ID!]!) {
  tunnelLightUpdated(ids: $ids) {
    status
    communicationStatus
    lastDataReceived
    referencePoint
    direction
    road
    name
    id
  }
}
    `;

/**
 * __useSchematicTunnelLightUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicTunnelLightUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicTunnelLightUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicTunnelLightUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicTunnelLightUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicTunnelLightUpdatedSubscription, SchematicTunnelLightUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicTunnelLightUpdatedSubscription, SchematicTunnelLightUpdatedSubscriptionVariables>(SchematicTunnelLightUpdatedDocument, options);
      }
export type SchematicTunnelLightUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicTunnelLightUpdatedSubscription>;
export type SchematicTunnelLightUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicTunnelLightUpdatedSubscription>;
export const SchematicWeatherStationUpdatedDocument = gql`
    subscription SchematicWeatherStationUpdated($ids: [ID!]!) {
  weatherStationUpdated(ids: $ids) {
    communicationStatus
    lastDataReceived
    referencePoint
    description
    direction
    location
    values
    road
    name
    id
    communicationParameters
  }
}
    `;

/**
 * __useSchematicWeatherStationUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicWeatherStationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicWeatherStationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicWeatherStationUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicWeatherStationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicWeatherStationUpdatedSubscription, SchematicWeatherStationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicWeatherStationUpdatedSubscription, SchematicWeatherStationUpdatedSubscriptionVariables>(SchematicWeatherStationUpdatedDocument, options);
      }
export type SchematicWeatherStationUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicWeatherStationUpdatedSubscription>;
export type SchematicWeatherStationUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicWeatherStationUpdatedSubscription>;
export const SchematicTollingPointUpdatedDocument = gql`
    subscription SchematicTollingPointUpdated($ids: [ID!]!) {
  tollingPointUpdated(ids: $ids) {
    id
    name
    road
    direction
    referencePoint
    communicationState
    plazaDirection
    reversalPlazaId
    isActive
  }
}
    `;

/**
 * __useSchematicTollingPointUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchematicTollingPointUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchematicTollingPointUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchematicTollingPointUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSchematicTollingPointUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchematicTollingPointUpdatedSubscription, SchematicTollingPointUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchematicTollingPointUpdatedSubscription, SchematicTollingPointUpdatedSubscriptionVariables>(SchematicTollingPointUpdatedDocument, options);
      }
export type SchematicTollingPointUpdatedSubscriptionHookResult = ReturnType<typeof useSchematicTollingPointUpdatedSubscription>;
export type SchematicTollingPointUpdatedSubscriptionResult = Apollo.SubscriptionResult<SchematicTollingPointUpdatedSubscription>;
export const TrafficControlListDocument = gql`
    query TrafficControlList($sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  trafficControls(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        communicationStatus
        lastDataReceived
        referencePoint
        laneDirection
        lanePosition
        direction
        laneType
        mode
        road
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTrafficControlListQuery__
 *
 * To run a query within a React component, call `useTrafficControlListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficControlListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficControlListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTrafficControlListQuery(baseOptions?: Apollo.QueryHookOptions<TrafficControlListQuery, TrafficControlListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficControlListQuery, TrafficControlListQueryVariables>(TrafficControlListDocument, options);
      }
export function useTrafficControlListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficControlListQuery, TrafficControlListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficControlListQuery, TrafficControlListQueryVariables>(TrafficControlListDocument, options);
        }
export type TrafficControlListQueryHookResult = ReturnType<typeof useTrafficControlListQuery>;
export type TrafficControlListLazyQueryHookResult = ReturnType<typeof useTrafficControlListLazyQuery>;
export type TrafficControlListQueryResult = Apollo.QueryResult<TrafficControlListQuery, TrafficControlListQueryVariables>;
export function refetchTrafficControlListQuery(variables?: TrafficControlListQueryVariables) {
      return { query: TrafficControlListDocument, variables: variables }
    }
export const LiveTrafficControlListDocument = gql`
    subscription LiveTrafficControlList($ids: [ID!]!) {
  trafficControlUpdated(ids: $ids) {
    communicationStatus
    lastDataReceived
    referencePoint
    direction
    laneType
    mode
    road
    name
    id
  }
}
    `;

/**
 * __useLiveTrafficControlListSubscription__
 *
 * To run a query within a React component, call `useLiveTrafficControlListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTrafficControlListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTrafficControlListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveTrafficControlListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveTrafficControlListSubscription, LiveTrafficControlListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveTrafficControlListSubscription, LiveTrafficControlListSubscriptionVariables>(LiveTrafficControlListDocument, options);
      }
export type LiveTrafficControlListSubscriptionHookResult = ReturnType<typeof useLiveTrafficControlListSubscription>;
export type LiveTrafficControlListSubscriptionResult = Apollo.SubscriptionResult<LiveTrafficControlListSubscription>;
export const TrafficControlSelectionListDocument = gql`
    query TrafficControlSelectionList($sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  trafficControls(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        referencePoint
        laneDirection
        lanePosition
        direction
        road
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTrafficControlSelectionListQuery__
 *
 * To run a query within a React component, call `useTrafficControlSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficControlSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficControlSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTrafficControlSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<TrafficControlSelectionListQuery, TrafficControlSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficControlSelectionListQuery, TrafficControlSelectionListQueryVariables>(TrafficControlSelectionListDocument, options);
      }
export function useTrafficControlSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficControlSelectionListQuery, TrafficControlSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficControlSelectionListQuery, TrafficControlSelectionListQueryVariables>(TrafficControlSelectionListDocument, options);
        }
export type TrafficControlSelectionListQueryHookResult = ReturnType<typeof useTrafficControlSelectionListQuery>;
export type TrafficControlSelectionListLazyQueryHookResult = ReturnType<typeof useTrafficControlSelectionListLazyQuery>;
export type TrafficControlSelectionListQueryResult = Apollo.QueryResult<TrafficControlSelectionListQuery, TrafficControlSelectionListQueryVariables>;
export function refetchTrafficControlSelectionListQuery(variables?: TrafficControlSelectionListQueryVariables) {
      return { query: TrafficControlSelectionListDocument, variables: variables }
    }
export const TravelTimePollDocument = gql`
    mutation TravelTimePoll($ids: [ID!]!) {
  multiplePoll(ids: $ids, integrationType: TRAVEL_TIME_SEGMENT) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type TravelTimePollMutationFn = Apollo.MutationFunction<TravelTimePollMutation, TravelTimePollMutationVariables>;

/**
 * __useTravelTimePollMutation__
 *
 * To run a mutation, you first call `useTravelTimePollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelTimePollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelTimePollMutation, { data, loading, error }] = useTravelTimePollMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTravelTimePollMutation(baseOptions?: Apollo.MutationHookOptions<TravelTimePollMutation, TravelTimePollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelTimePollMutation, TravelTimePollMutationVariables>(TravelTimePollDocument, options);
      }
export type TravelTimePollMutationHookResult = ReturnType<typeof useTravelTimePollMutation>;
export type TravelTimePollMutationResult = Apollo.MutationResult<TravelTimePollMutation>;
export type TravelTimePollMutationOptions = Apollo.BaseMutationOptions<TravelTimePollMutation, TravelTimePollMutationVariables>;
export const SaveTravelTimeModuleSettingsDocument = gql`
    mutation saveTravelTimeModuleSettings($settings: JSON!) {
  saveTravelTimeModuleSettings(settings: $settings)
}
    `;
export type SaveTravelTimeModuleSettingsMutationFn = Apollo.MutationFunction<SaveTravelTimeModuleSettingsMutation, SaveTravelTimeModuleSettingsMutationVariables>;

/**
 * __useSaveTravelTimeModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveTravelTimeModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTravelTimeModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTravelTimeModuleSettingsMutation, { data, loading, error }] = useSaveTravelTimeModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveTravelTimeModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveTravelTimeModuleSettingsMutation, SaveTravelTimeModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTravelTimeModuleSettingsMutation, SaveTravelTimeModuleSettingsMutationVariables>(SaveTravelTimeModuleSettingsDocument, options);
      }
export type SaveTravelTimeModuleSettingsMutationHookResult = ReturnType<typeof useSaveTravelTimeModuleSettingsMutation>;
export type SaveTravelTimeModuleSettingsMutationResult = Apollo.MutationResult<SaveTravelTimeModuleSettingsMutation>;
export type SaveTravelTimeModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveTravelTimeModuleSettingsMutation, SaveTravelTimeModuleSettingsMutationVariables>;
export const CorridorTravelTimeListDocument = gql`
    query CorridorTravelTimeList($sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  travelTimes(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        ...CorridorTravelTime
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CorridorTravelTimeFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorTravelTimeListQuery__
 *
 * To run a query within a React component, call `useCorridorTravelTimeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorTravelTimeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorTravelTimeListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorTravelTimeListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorTravelTimeListQuery, CorridorTravelTimeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorTravelTimeListQuery, CorridorTravelTimeListQueryVariables>(CorridorTravelTimeListDocument, options);
      }
export function useCorridorTravelTimeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorTravelTimeListQuery, CorridorTravelTimeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorTravelTimeListQuery, CorridorTravelTimeListQueryVariables>(CorridorTravelTimeListDocument, options);
        }
export type CorridorTravelTimeListQueryHookResult = ReturnType<typeof useCorridorTravelTimeListQuery>;
export type CorridorTravelTimeListLazyQueryHookResult = ReturnType<typeof useCorridorTravelTimeListLazyQuery>;
export type CorridorTravelTimeListQueryResult = Apollo.QueryResult<CorridorTravelTimeListQuery, CorridorTravelTimeListQueryVariables>;
export function refetchCorridorTravelTimeListQuery(variables?: CorridorTravelTimeListQueryVariables) {
      return { query: CorridorTravelTimeListDocument, variables: variables }
    }
export const LiveCorridorTravelTimeListDocument = gql`
    subscription LiveCorridorTravelTimeList($ids: [ID!]) {
  travelTimeUpdated(ids: $ids) {
    ...CorridorTravelTime
  }
}
    ${CorridorTravelTimeFragmentDoc}`;

/**
 * __useLiveCorridorTravelTimeListSubscription__
 *
 * To run a query within a React component, call `useLiveCorridorTravelTimeListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCorridorTravelTimeListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCorridorTravelTimeListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveCorridorTravelTimeListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveCorridorTravelTimeListSubscription, LiveCorridorTravelTimeListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveCorridorTravelTimeListSubscription, LiveCorridorTravelTimeListSubscriptionVariables>(LiveCorridorTravelTimeListDocument, options);
      }
export type LiveCorridorTravelTimeListSubscriptionHookResult = ReturnType<typeof useLiveCorridorTravelTimeListSubscription>;
export type LiveCorridorTravelTimeListSubscriptionResult = Apollo.SubscriptionResult<LiveCorridorTravelTimeListSubscription>;
export const TunnelFanListDocument = gql`
    query TunnelFanList($sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  tunnelFans(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        speed
        running
        runStatus
        serviceStatus
        priority
        communicationStatus
        lastDataReceived
        referencePoint
        direction
        road
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTunnelFanListQuery__
 *
 * To run a query within a React component, call `useTunnelFanListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelFanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelFanListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTunnelFanListQuery(baseOptions?: Apollo.QueryHookOptions<TunnelFanListQuery, TunnelFanListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelFanListQuery, TunnelFanListQueryVariables>(TunnelFanListDocument, options);
      }
export function useTunnelFanListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelFanListQuery, TunnelFanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelFanListQuery, TunnelFanListQueryVariables>(TunnelFanListDocument, options);
        }
export type TunnelFanListQueryHookResult = ReturnType<typeof useTunnelFanListQuery>;
export type TunnelFanListLazyQueryHookResult = ReturnType<typeof useTunnelFanListLazyQuery>;
export type TunnelFanListQueryResult = Apollo.QueryResult<TunnelFanListQuery, TunnelFanListQueryVariables>;
export function refetchTunnelFanListQuery(variables?: TunnelFanListQueryVariables) {
      return { query: TunnelFanListDocument, variables: variables }
    }
export const LiveTunnelFanListDocument = gql`
    subscription LiveTunnelFanList($ids: [ID!]) {
  tunnelFanUpdated(ids: $ids) {
    speed
    running
    runStatus
    serviceStatus
    priority
    communicationStatus
    lastDataReceived
    referencePoint
    direction
    road
    name
    id
  }
}
    `;

/**
 * __useLiveTunnelFanListSubscription__
 *
 * To run a query within a React component, call `useLiveTunnelFanListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTunnelFanListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTunnelFanListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveTunnelFanListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveTunnelFanListSubscription, LiveTunnelFanListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveTunnelFanListSubscription, LiveTunnelFanListSubscriptionVariables>(LiveTunnelFanListDocument, options);
      }
export type LiveTunnelFanListSubscriptionHookResult = ReturnType<typeof useLiveTunnelFanListSubscription>;
export type LiveTunnelFanListSubscriptionResult = Apollo.SubscriptionResult<LiveTunnelFanListSubscription>;
export const TunnelFanSelectionListDocument = gql`
    query TunnelFanSelectionList($sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  tunnelFans(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        referencePoint
        direction
        road
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTunnelFanSelectionListQuery__
 *
 * To run a query within a React component, call `useTunnelFanSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelFanSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelFanSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTunnelFanSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<TunnelFanSelectionListQuery, TunnelFanSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelFanSelectionListQuery, TunnelFanSelectionListQueryVariables>(TunnelFanSelectionListDocument, options);
      }
export function useTunnelFanSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelFanSelectionListQuery, TunnelFanSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelFanSelectionListQuery, TunnelFanSelectionListQueryVariables>(TunnelFanSelectionListDocument, options);
        }
export type TunnelFanSelectionListQueryHookResult = ReturnType<typeof useTunnelFanSelectionListQuery>;
export type TunnelFanSelectionListLazyQueryHookResult = ReturnType<typeof useTunnelFanSelectionListLazyQuery>;
export type TunnelFanSelectionListQueryResult = Apollo.QueryResult<TunnelFanSelectionListQuery, TunnelFanSelectionListQueryVariables>;
export function refetchTunnelFanSelectionListQuery(variables?: TunnelFanSelectionListQueryVariables) {
      return { query: TunnelFanSelectionListDocument, variables: variables }
    }
export const TunnelFanNamesDocument = gql`
    query TunnelFanNames {
  tunnelFans(query: {limit: 10000}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTunnelFanNamesQuery__
 *
 * To run a query within a React component, call `useTunnelFanNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelFanNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelFanNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTunnelFanNamesQuery(baseOptions?: Apollo.QueryHookOptions<TunnelFanNamesQuery, TunnelFanNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelFanNamesQuery, TunnelFanNamesQueryVariables>(TunnelFanNamesDocument, options);
      }
export function useTunnelFanNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelFanNamesQuery, TunnelFanNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelFanNamesQuery, TunnelFanNamesQueryVariables>(TunnelFanNamesDocument, options);
        }
export type TunnelFanNamesQueryHookResult = ReturnType<typeof useTunnelFanNamesQuery>;
export type TunnelFanNamesLazyQueryHookResult = ReturnType<typeof useTunnelFanNamesLazyQuery>;
export type TunnelFanNamesQueryResult = Apollo.QueryResult<TunnelFanNamesQuery, TunnelFanNamesQueryVariables>;
export function refetchTunnelFanNamesQuery(variables?: TunnelFanNamesQueryVariables) {
      return { query: TunnelFanNamesDocument, variables: variables }
    }
export const TunnelLightListDocument = gql`
    query TunnelLightList($sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  tunnelLights(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        status
        communicationStatus
        lastDataReceived
        referencePoint
        direction
        road
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTunnelLightListQuery__
 *
 * To run a query within a React component, call `useTunnelLightListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelLightListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelLightListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTunnelLightListQuery(baseOptions?: Apollo.QueryHookOptions<TunnelLightListQuery, TunnelLightListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelLightListQuery, TunnelLightListQueryVariables>(TunnelLightListDocument, options);
      }
export function useTunnelLightListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelLightListQuery, TunnelLightListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelLightListQuery, TunnelLightListQueryVariables>(TunnelLightListDocument, options);
        }
export type TunnelLightListQueryHookResult = ReturnType<typeof useTunnelLightListQuery>;
export type TunnelLightListLazyQueryHookResult = ReturnType<typeof useTunnelLightListLazyQuery>;
export type TunnelLightListQueryResult = Apollo.QueryResult<TunnelLightListQuery, TunnelLightListQueryVariables>;
export function refetchTunnelLightListQuery(variables?: TunnelLightListQueryVariables) {
      return { query: TunnelLightListDocument, variables: variables }
    }
export const LiveTunnelLightListDocument = gql`
    subscription LiveTunnelLightList($ids: [ID!]) {
  tunnelLightUpdated(ids: $ids) {
    status
    communicationStatus
    lastDataReceived
    referencePoint
    direction
    road
    name
    id
  }
}
    `;

/**
 * __useLiveTunnelLightListSubscription__
 *
 * To run a query within a React component, call `useLiveTunnelLightListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTunnelLightListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTunnelLightListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveTunnelLightListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveTunnelLightListSubscription, LiveTunnelLightListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveTunnelLightListSubscription, LiveTunnelLightListSubscriptionVariables>(LiveTunnelLightListDocument, options);
      }
export type LiveTunnelLightListSubscriptionHookResult = ReturnType<typeof useLiveTunnelLightListSubscription>;
export type LiveTunnelLightListSubscriptionResult = Apollo.SubscriptionResult<LiveTunnelLightListSubscription>;
export const TunnelLightSelectionListDocument = gql`
    query TunnelLightSelectionList($sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  tunnelLights(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        referencePoint
        direction
        road
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTunnelLightSelectionListQuery__
 *
 * To run a query within a React component, call `useTunnelLightSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelLightSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelLightSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTunnelLightSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<TunnelLightSelectionListQuery, TunnelLightSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelLightSelectionListQuery, TunnelLightSelectionListQueryVariables>(TunnelLightSelectionListDocument, options);
      }
export function useTunnelLightSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelLightSelectionListQuery, TunnelLightSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelLightSelectionListQuery, TunnelLightSelectionListQueryVariables>(TunnelLightSelectionListDocument, options);
        }
export type TunnelLightSelectionListQueryHookResult = ReturnType<typeof useTunnelLightSelectionListQuery>;
export type TunnelLightSelectionListLazyQueryHookResult = ReturnType<typeof useTunnelLightSelectionListLazyQuery>;
export type TunnelLightSelectionListQueryResult = Apollo.QueryResult<TunnelLightSelectionListQuery, TunnelLightSelectionListQueryVariables>;
export function refetchTunnelLightSelectionListQuery(variables?: TunnelLightSelectionListQueryVariables) {
      return { query: TunnelLightSelectionListDocument, variables: variables }
    }
export const TunnelLightNamesDocument = gql`
    query TunnelLightNames {
  tunnelLights(query: {limit: 10000}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTunnelLightNamesQuery__
 *
 * To run a query within a React component, call `useTunnelLightNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelLightNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelLightNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTunnelLightNamesQuery(baseOptions?: Apollo.QueryHookOptions<TunnelLightNamesQuery, TunnelLightNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelLightNamesQuery, TunnelLightNamesQueryVariables>(TunnelLightNamesDocument, options);
      }
export function useTunnelLightNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelLightNamesQuery, TunnelLightNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelLightNamesQuery, TunnelLightNamesQueryVariables>(TunnelLightNamesDocument, options);
        }
export type TunnelLightNamesQueryHookResult = ReturnType<typeof useTunnelLightNamesQuery>;
export type TunnelLightNamesLazyQueryHookResult = ReturnType<typeof useTunnelLightNamesLazyQuery>;
export type TunnelLightNamesQueryResult = Apollo.QueryResult<TunnelLightNamesQuery, TunnelLightNamesQueryVariables>;
export function refetchTunnelLightNamesQuery(variables?: TunnelLightNamesQueryVariables) {
      return { query: TunnelLightNamesDocument, variables: variables }
    }
export const TunnelLogsUpdatedDocument = gql`
    subscription tunnelLogsUpdated($ids: [ID!]) {
  tunnelLogsUpdated(ids: $ids) {
    id
  }
}
    `;

/**
 * __useTunnelLogsUpdatedSubscription__
 *
 * To run a query within a React component, call `useTunnelLogsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTunnelLogsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelLogsUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTunnelLogsUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TunnelLogsUpdatedSubscription, TunnelLogsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TunnelLogsUpdatedSubscription, TunnelLogsUpdatedSubscriptionVariables>(TunnelLogsUpdatedDocument, options);
      }
export type TunnelLogsUpdatedSubscriptionHookResult = ReturnType<typeof useTunnelLogsUpdatedSubscription>;
export type TunnelLogsUpdatedSubscriptionResult = Apollo.SubscriptionResult<TunnelLogsUpdatedSubscription>;
export const CorridorsWeatherStationPollDocument = gql`
    mutation CorridorsWeatherStationPoll($ids: [ID!]!) {
  multiplePoll(ids: $ids, integrationType: WEATHER_STATION) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type CorridorsWeatherStationPollMutationFn = Apollo.MutationFunction<CorridorsWeatherStationPollMutation, CorridorsWeatherStationPollMutationVariables>;

/**
 * __useCorridorsWeatherStationPollMutation__
 *
 * To run a mutation, you first call `useCorridorsWeatherStationPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorridorsWeatherStationPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [corridorsWeatherStationPollMutation, { data, loading, error }] = useCorridorsWeatherStationPollMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCorridorsWeatherStationPollMutation(baseOptions?: Apollo.MutationHookOptions<CorridorsWeatherStationPollMutation, CorridorsWeatherStationPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CorridorsWeatherStationPollMutation, CorridorsWeatherStationPollMutationVariables>(CorridorsWeatherStationPollDocument, options);
      }
export type CorridorsWeatherStationPollMutationHookResult = ReturnType<typeof useCorridorsWeatherStationPollMutation>;
export type CorridorsWeatherStationPollMutationResult = Apollo.MutationResult<CorridorsWeatherStationPollMutation>;
export type CorridorsWeatherStationPollMutationOptions = Apollo.BaseMutationOptions<CorridorsWeatherStationPollMutation, CorridorsWeatherStationPollMutationVariables>;
export const CorridorWeatherStationListDocument = gql`
    query CorridorWeatherStationList($sortField: WeatherStationSortField = DATA_RECEIVED, $sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  weatherStations(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        ...CorridorWeatherStation
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CorridorWeatherStationFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCorridorWeatherStationListQuery__
 *
 * To run a query within a React component, call `useCorridorWeatherStationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorWeatherStationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorWeatherStationListQuery({
 *   variables: {
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCorridorWeatherStationListQuery(baseOptions?: Apollo.QueryHookOptions<CorridorWeatherStationListQuery, CorridorWeatherStationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorWeatherStationListQuery, CorridorWeatherStationListQueryVariables>(CorridorWeatherStationListDocument, options);
      }
export function useCorridorWeatherStationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorWeatherStationListQuery, CorridorWeatherStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorWeatherStationListQuery, CorridorWeatherStationListQueryVariables>(CorridorWeatherStationListDocument, options);
        }
export type CorridorWeatherStationListQueryHookResult = ReturnType<typeof useCorridorWeatherStationListQuery>;
export type CorridorWeatherStationListLazyQueryHookResult = ReturnType<typeof useCorridorWeatherStationListLazyQuery>;
export type CorridorWeatherStationListQueryResult = Apollo.QueryResult<CorridorWeatherStationListQuery, CorridorWeatherStationListQueryVariables>;
export function refetchCorridorWeatherStationListQuery(variables?: CorridorWeatherStationListQueryVariables) {
      return { query: CorridorWeatherStationListDocument, variables: variables }
    }
export const LiveCorridorWeatherListDocument = gql`
    subscription LiveCorridorWeatherList($ids: [ID!]) {
  weatherStationUpdated(ids: $ids) {
    ...CorridorWeatherStation
  }
}
    ${CorridorWeatherStationFragmentDoc}`;

/**
 * __useLiveCorridorWeatherListSubscription__
 *
 * To run a query within a React component, call `useLiveCorridorWeatherListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveCorridorWeatherListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveCorridorWeatherListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveCorridorWeatherListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveCorridorWeatherListSubscription, LiveCorridorWeatherListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveCorridorWeatherListSubscription, LiveCorridorWeatherListSubscriptionVariables>(LiveCorridorWeatherListDocument, options);
      }
export type LiveCorridorWeatherListSubscriptionHookResult = ReturnType<typeof useLiveCorridorWeatherListSubscription>;
export type LiveCorridorWeatherListSubscriptionResult = Apollo.SubscriptionResult<LiveCorridorWeatherListSubscription>;
export const SaveDataSourceDocument = gql`
    mutation SaveDataSource($input: DataSourceInput!) {
  saveDataSource(input: $input) {
    ...DataSource
  }
}
    ${DataSourceFragmentDoc}`;
export type SaveDataSourceMutationFn = Apollo.MutationFunction<SaveDataSourceMutation, SaveDataSourceMutationVariables>;

/**
 * __useSaveDataSourceMutation__
 *
 * To run a mutation, you first call `useSaveDataSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDataSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDataSourceMutation, { data, loading, error }] = useSaveDataSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDataSourceMutation(baseOptions?: Apollo.MutationHookOptions<SaveDataSourceMutation, SaveDataSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDataSourceMutation, SaveDataSourceMutationVariables>(SaveDataSourceDocument, options);
      }
export type SaveDataSourceMutationHookResult = ReturnType<typeof useSaveDataSourceMutation>;
export type SaveDataSourceMutationResult = Apollo.MutationResult<SaveDataSourceMutation>;
export type SaveDataSourceMutationOptions = Apollo.BaseMutationOptions<SaveDataSourceMutation, SaveDataSourceMutationVariables>;
export const DeleteDataSourceDocument = gql`
    mutation DeleteDataSource($selection: [ID!]!) {
  deleteDataSources(ids: $selection)
}
    `;
export type DeleteDataSourceMutationFn = Apollo.MutationFunction<DeleteDataSourceMutation, DeleteDataSourceMutationVariables>;

/**
 * __useDeleteDataSourceMutation__
 *
 * To run a mutation, you first call `useDeleteDataSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataSourceMutation, { data, loading, error }] = useDeleteDataSourceMutation({
 *   variables: {
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useDeleteDataSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDataSourceMutation, DeleteDataSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDataSourceMutation, DeleteDataSourceMutationVariables>(DeleteDataSourceDocument, options);
      }
export type DeleteDataSourceMutationHookResult = ReturnType<typeof useDeleteDataSourceMutation>;
export type DeleteDataSourceMutationResult = Apollo.MutationResult<DeleteDataSourceMutation>;
export type DeleteDataSourceMutationOptions = Apollo.BaseMutationOptions<DeleteDataSourceMutation, DeleteDataSourceMutationVariables>;
export const SaveDataSourceConfigDocument = gql`
    mutation SaveDataSourceConfig($input: DataSourceConfigInput!) {
  saveDataSourceConfig(input: $input) {
    ...DataSourceConfig
  }
}
    ${DataSourceConfigFragmentDoc}`;
export type SaveDataSourceConfigMutationFn = Apollo.MutationFunction<SaveDataSourceConfigMutation, SaveDataSourceConfigMutationVariables>;

/**
 * __useSaveDataSourceConfigMutation__
 *
 * To run a mutation, you first call `useSaveDataSourceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDataSourceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDataSourceConfigMutation, { data, loading, error }] = useSaveDataSourceConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDataSourceConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveDataSourceConfigMutation, SaveDataSourceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDataSourceConfigMutation, SaveDataSourceConfigMutationVariables>(SaveDataSourceConfigDocument, options);
      }
export type SaveDataSourceConfigMutationHookResult = ReturnType<typeof useSaveDataSourceConfigMutation>;
export type SaveDataSourceConfigMutationResult = Apollo.MutationResult<SaveDataSourceConfigMutation>;
export type SaveDataSourceConfigMutationOptions = Apollo.BaseMutationOptions<SaveDataSourceConfigMutation, SaveDataSourceConfigMutationVariables>;
export const DeleteDataSourceConfigDocument = gql`
    mutation DeleteDataSourceConfig($selection: [ID!]!) {
  deleteDataSourceConfigs(ids: $selection)
}
    `;
export type DeleteDataSourceConfigMutationFn = Apollo.MutationFunction<DeleteDataSourceConfigMutation, DeleteDataSourceConfigMutationVariables>;

/**
 * __useDeleteDataSourceConfigMutation__
 *
 * To run a mutation, you first call `useDeleteDataSourceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataSourceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataSourceConfigMutation, { data, loading, error }] = useDeleteDataSourceConfigMutation({
 *   variables: {
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useDeleteDataSourceConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDataSourceConfigMutation, DeleteDataSourceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDataSourceConfigMutation, DeleteDataSourceConfigMutationVariables>(DeleteDataSourceConfigDocument, options);
      }
export type DeleteDataSourceConfigMutationHookResult = ReturnType<typeof useDeleteDataSourceConfigMutation>;
export type DeleteDataSourceConfigMutationResult = Apollo.MutationResult<DeleteDataSourceConfigMutation>;
export type DeleteDataSourceConfigMutationOptions = Apollo.BaseMutationOptions<DeleteDataSourceConfigMutation, DeleteDataSourceConfigMutationVariables>;
export const ImportDataSourcesDocument = gql`
    mutation ImportDataSources($input: ImportDataSources!) {
  importDataSources(input: $input)
}
    `;
export type ImportDataSourcesMutationFn = Apollo.MutationFunction<ImportDataSourcesMutation, ImportDataSourcesMutationVariables>;

/**
 * __useImportDataSourcesMutation__
 *
 * To run a mutation, you first call `useImportDataSourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDataSourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDataSourcesMutation, { data, loading, error }] = useImportDataSourcesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportDataSourcesMutation(baseOptions?: Apollo.MutationHookOptions<ImportDataSourcesMutation, ImportDataSourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportDataSourcesMutation, ImportDataSourcesMutationVariables>(ImportDataSourcesDocument, options);
      }
export type ImportDataSourcesMutationHookResult = ReturnType<typeof useImportDataSourcesMutation>;
export type ImportDataSourcesMutationResult = Apollo.MutationResult<ImportDataSourcesMutation>;
export type ImportDataSourcesMutationOptions = Apollo.BaseMutationOptions<ImportDataSourcesMutation, ImportDataSourcesMutationVariables>;
export const DataSourceSelectionListDocument = gql`
    query DataSourceSelectionList($query: DataSourceInputQuery) {
  dataSources(query: $query) {
    edges {
      node {
        attributes
        value
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useDataSourceSelectionListQuery__
 *
 * To run a query within a React component, call `useDataSourceSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceSelectionListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDataSourceSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<DataSourceSelectionListQuery, DataSourceSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceSelectionListQuery, DataSourceSelectionListQueryVariables>(DataSourceSelectionListDocument, options);
      }
export function useDataSourceSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceSelectionListQuery, DataSourceSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceSelectionListQuery, DataSourceSelectionListQueryVariables>(DataSourceSelectionListDocument, options);
        }
export type DataSourceSelectionListQueryHookResult = ReturnType<typeof useDataSourceSelectionListQuery>;
export type DataSourceSelectionListLazyQueryHookResult = ReturnType<typeof useDataSourceSelectionListLazyQuery>;
export type DataSourceSelectionListQueryResult = Apollo.QueryResult<DataSourceSelectionListQuery, DataSourceSelectionListQueryVariables>;
export function refetchDataSourceSelectionListQuery(variables?: DataSourceSelectionListQueryVariables) {
      return { query: DataSourceSelectionListDocument, variables: variables }
    }
export const DataSourceListDocument = gql`
    query DataSourceList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $enabled: Boolean = true, $filters: [FilterInput!], $searchText: String, $searchFields: [String!] = ["value", "attributes.LABEL"], $limit: Int = 10, $before: String, $after: String, $sourceId: ID) {
  dataSources(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, formId: $sourceId, enabled: $enabled, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        ...DataSource
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${DataSourceFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDataSourceListQuery__
 *
 * To run a query within a React component, call `useDataSourceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      enabled: // value for 'enabled'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useDataSourceListQuery(baseOptions?: Apollo.QueryHookOptions<DataSourceListQuery, DataSourceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceListQuery, DataSourceListQueryVariables>(DataSourceListDocument, options);
      }
export function useDataSourceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceListQuery, DataSourceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceListQuery, DataSourceListQueryVariables>(DataSourceListDocument, options);
        }
export type DataSourceListQueryHookResult = ReturnType<typeof useDataSourceListQuery>;
export type DataSourceListLazyQueryHookResult = ReturnType<typeof useDataSourceListLazyQuery>;
export type DataSourceListQueryResult = Apollo.QueryResult<DataSourceListQuery, DataSourceListQueryVariables>;
export function refetchDataSourceListQuery(variables?: DataSourceListQueryVariables) {
      return { query: DataSourceListDocument, variables: variables }
    }
export const DataSourcesByConfigIdDocument = gql`
    query DataSourcesByConfigId($configId: ID!) {
  dataSourcesByConfigId(configId: $configId) {
    value
    attributes
  }
}
    `;

/**
 * __useDataSourcesByConfigIdQuery__
 *
 * To run a query within a React component, call `useDataSourcesByConfigIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourcesByConfigIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourcesByConfigIdQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useDataSourcesByConfigIdQuery(baseOptions: Apollo.QueryHookOptions<DataSourcesByConfigIdQuery, DataSourcesByConfigIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourcesByConfigIdQuery, DataSourcesByConfigIdQueryVariables>(DataSourcesByConfigIdDocument, options);
      }
export function useDataSourcesByConfigIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourcesByConfigIdQuery, DataSourcesByConfigIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourcesByConfigIdQuery, DataSourcesByConfigIdQueryVariables>(DataSourcesByConfigIdDocument, options);
        }
export type DataSourcesByConfigIdQueryHookResult = ReturnType<typeof useDataSourcesByConfigIdQuery>;
export type DataSourcesByConfigIdLazyQueryHookResult = ReturnType<typeof useDataSourcesByConfigIdLazyQuery>;
export type DataSourcesByConfigIdQueryResult = Apollo.QueryResult<DataSourcesByConfigIdQuery, DataSourcesByConfigIdQueryVariables>;
export function refetchDataSourcesByConfigIdQuery(variables: DataSourcesByConfigIdQueryVariables) {
      return { query: DataSourcesByConfigIdDocument, variables: variables }
    }
export const DataSourceConfigNameDocument = gql`
    query DataSourceConfigName($id: ID!) {
  dataSourceConfig(id: $id) {
    name
  }
}
    `;

/**
 * __useDataSourceConfigNameQuery__
 *
 * To run a query within a React component, call `useDataSourceConfigNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceConfigNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceConfigNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataSourceConfigNameQuery(baseOptions: Apollo.QueryHookOptions<DataSourceConfigNameQuery, DataSourceConfigNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceConfigNameQuery, DataSourceConfigNameQueryVariables>(DataSourceConfigNameDocument, options);
      }
export function useDataSourceConfigNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceConfigNameQuery, DataSourceConfigNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceConfigNameQuery, DataSourceConfigNameQueryVariables>(DataSourceConfigNameDocument, options);
        }
export type DataSourceConfigNameQueryHookResult = ReturnType<typeof useDataSourceConfigNameQuery>;
export type DataSourceConfigNameLazyQueryHookResult = ReturnType<typeof useDataSourceConfigNameLazyQuery>;
export type DataSourceConfigNameQueryResult = Apollo.QueryResult<DataSourceConfigNameQuery, DataSourceConfigNameQueryVariables>;
export function refetchDataSourceConfigNameQuery(variables: DataSourceConfigNameQueryVariables) {
      return { query: DataSourceConfigNameDocument, variables: variables }
    }
export const DataSourceDetailDocument = gql`
    query DataSourceDetail($id: ID!) {
  dataSource(id: $id) {
    ...DataSource
  }
}
    ${DataSourceFragmentDoc}`;

/**
 * __useDataSourceDetailQuery__
 *
 * To run a query within a React component, call `useDataSourceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataSourceDetailQuery(baseOptions: Apollo.QueryHookOptions<DataSourceDetailQuery, DataSourceDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceDetailQuery, DataSourceDetailQueryVariables>(DataSourceDetailDocument, options);
      }
export function useDataSourceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceDetailQuery, DataSourceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceDetailQuery, DataSourceDetailQueryVariables>(DataSourceDetailDocument, options);
        }
export type DataSourceDetailQueryHookResult = ReturnType<typeof useDataSourceDetailQuery>;
export type DataSourceDetailLazyQueryHookResult = ReturnType<typeof useDataSourceDetailLazyQuery>;
export type DataSourceDetailQueryResult = Apollo.QueryResult<DataSourceDetailQuery, DataSourceDetailQueryVariables>;
export function refetchDataSourceDetailQuery(variables: DataSourceDetailQueryVariables) {
      return { query: DataSourceDetailDocument, variables: variables }
    }
export const EventTypesDocument = gql`
    query EventTypes($sortOrder: SortOrder = ASCENDING, $sortField: String = "value", $searchText: String, $category: Object!, $limit: Int = 500, $before: String, $after: String) {
  dataSources(
    query: {filters: [{field: "attributes.category", value: $category, operator: EQUALS}], searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, formId: "eventType", before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        enabled
        value
        id
        attributes
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useEventTypesQuery__
 *
 * To run a query within a React component, call `useEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTypesQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      category: // value for 'category'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventTypesQuery(baseOptions: Apollo.QueryHookOptions<EventTypesQuery, EventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTypesQuery, EventTypesQueryVariables>(EventTypesDocument, options);
      }
export function useEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTypesQuery, EventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTypesQuery, EventTypesQueryVariables>(EventTypesDocument, options);
        }
export type EventTypesQueryHookResult = ReturnType<typeof useEventTypesQuery>;
export type EventTypesLazyQueryHookResult = ReturnType<typeof useEventTypesLazyQuery>;
export type EventTypesQueryResult = Apollo.QueryResult<EventTypesQuery, EventTypesQueryVariables>;
export function refetchEventTypesQuery(variables: EventTypesQueryVariables) {
      return { query: EventTypesDocument, variables: variables }
    }
export const DataSourceConfigDetailDocument = gql`
    query DataSourceConfigDetail($id: ID!) {
  dataSourceConfig(id: $id) {
    ...DataSourceConfig
  }
}
    ${DataSourceConfigFragmentDoc}`;

/**
 * __useDataSourceConfigDetailQuery__
 *
 * To run a query within a React component, call `useDataSourceConfigDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceConfigDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceConfigDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataSourceConfigDetailQuery(baseOptions: Apollo.QueryHookOptions<DataSourceConfigDetailQuery, DataSourceConfigDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceConfigDetailQuery, DataSourceConfigDetailQueryVariables>(DataSourceConfigDetailDocument, options);
      }
export function useDataSourceConfigDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceConfigDetailQuery, DataSourceConfigDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceConfigDetailQuery, DataSourceConfigDetailQueryVariables>(DataSourceConfigDetailDocument, options);
        }
export type DataSourceConfigDetailQueryHookResult = ReturnType<typeof useDataSourceConfigDetailQuery>;
export type DataSourceConfigDetailLazyQueryHookResult = ReturnType<typeof useDataSourceConfigDetailLazyQuery>;
export type DataSourceConfigDetailQueryResult = Apollo.QueryResult<DataSourceConfigDetailQuery, DataSourceConfigDetailQueryVariables>;
export function refetchDataSourceConfigDetailQuery(variables: DataSourceConfigDetailQueryVariables) {
      return { query: DataSourceConfigDetailDocument, variables: variables }
    }
export const DataSourceConfigurationListDocument = gql`
    query DataSourceConfigurationList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $module: KineticModule, $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  dataSourceConfigs(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, module: $module, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        ...DataSourceConfig
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${DataSourceConfigFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDataSourceConfigurationListQuery__
 *
 * To run a query within a React component, call `useDataSourceConfigurationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceConfigurationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceConfigurationListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      module: // value for 'module'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDataSourceConfigurationListQuery(baseOptions?: Apollo.QueryHookOptions<DataSourceConfigurationListQuery, DataSourceConfigurationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceConfigurationListQuery, DataSourceConfigurationListQueryVariables>(DataSourceConfigurationListDocument, options);
      }
export function useDataSourceConfigurationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceConfigurationListQuery, DataSourceConfigurationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceConfigurationListQuery, DataSourceConfigurationListQueryVariables>(DataSourceConfigurationListDocument, options);
        }
export type DataSourceConfigurationListQueryHookResult = ReturnType<typeof useDataSourceConfigurationListQuery>;
export type DataSourceConfigurationListLazyQueryHookResult = ReturnType<typeof useDataSourceConfigurationListLazyQuery>;
export type DataSourceConfigurationListQueryResult = Apollo.QueryResult<DataSourceConfigurationListQuery, DataSourceConfigurationListQueryVariables>;
export function refetchDataSourceConfigurationListQuery(variables?: DataSourceConfigurationListQueryVariables) {
      return { query: DataSourceConfigurationListDocument, variables: variables }
    }
export const LinkedDataSourcesDocument = gql`
    query LinkedDataSources($ids: [ID!]!) {
  linkedDataSources(ids: $ids) {
    id
    value
    config {
      name
    }
  }
}
    `;

/**
 * __useLinkedDataSourcesQuery__
 *
 * To run a query within a React component, call `useLinkedDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedDataSourcesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLinkedDataSourcesQuery(baseOptions: Apollo.QueryHookOptions<LinkedDataSourcesQuery, LinkedDataSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkedDataSourcesQuery, LinkedDataSourcesQueryVariables>(LinkedDataSourcesDocument, options);
      }
export function useLinkedDataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedDataSourcesQuery, LinkedDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkedDataSourcesQuery, LinkedDataSourcesQueryVariables>(LinkedDataSourcesDocument, options);
        }
export type LinkedDataSourcesQueryHookResult = ReturnType<typeof useLinkedDataSourcesQuery>;
export type LinkedDataSourcesLazyQueryHookResult = ReturnType<typeof useLinkedDataSourcesLazyQuery>;
export type LinkedDataSourcesQueryResult = Apollo.QueryResult<LinkedDataSourcesQuery, LinkedDataSourcesQueryVariables>;
export function refetchLinkedDataSourcesQuery(variables: LinkedDataSourcesQueryVariables) {
      return { query: LinkedDataSourcesDocument, variables: variables }
    }
export const DataSourceDefaultValueOptionsDocument = gql`
    query DataSourceDefaultValueOptions($name: ID!) {
  dataSources(query: {limit: 100, formId: $name}) {
    edges {
      node {
        value
        attributes
      }
    }
  }
}
    `;

/**
 * __useDataSourceDefaultValueOptionsQuery__
 *
 * To run a query within a React component, call `useDataSourceDefaultValueOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceDefaultValueOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceDefaultValueOptionsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDataSourceDefaultValueOptionsQuery(baseOptions: Apollo.QueryHookOptions<DataSourceDefaultValueOptionsQuery, DataSourceDefaultValueOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceDefaultValueOptionsQuery, DataSourceDefaultValueOptionsQueryVariables>(DataSourceDefaultValueOptionsDocument, options);
      }
export function useDataSourceDefaultValueOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceDefaultValueOptionsQuery, DataSourceDefaultValueOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceDefaultValueOptionsQuery, DataSourceDefaultValueOptionsQueryVariables>(DataSourceDefaultValueOptionsDocument, options);
        }
export type DataSourceDefaultValueOptionsQueryHookResult = ReturnType<typeof useDataSourceDefaultValueOptionsQuery>;
export type DataSourceDefaultValueOptionsLazyQueryHookResult = ReturnType<typeof useDataSourceDefaultValueOptionsLazyQuery>;
export type DataSourceDefaultValueOptionsQueryResult = Apollo.QueryResult<DataSourceDefaultValueOptionsQuery, DataSourceDefaultValueOptionsQueryVariables>;
export function refetchDataSourceDefaultValueOptionsQuery(variables: DataSourceDefaultValueOptionsQueryVariables) {
      return { query: DataSourceDefaultValueOptionsDocument, variables: variables }
    }
export const ExportDataSourcesDocument = gql`
    query ExportDataSources($ids: [ID!]) {
  exportDataSources(ids: $ids)
}
    `;

/**
 * __useExportDataSourcesQuery__
 *
 * To run a query within a React component, call `useExportDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDataSourcesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useExportDataSourcesQuery(baseOptions?: Apollo.QueryHookOptions<ExportDataSourcesQuery, ExportDataSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportDataSourcesQuery, ExportDataSourcesQueryVariables>(ExportDataSourcesDocument, options);
      }
export function useExportDataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportDataSourcesQuery, ExportDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportDataSourcesQuery, ExportDataSourcesQueryVariables>(ExportDataSourcesDocument, options);
        }
export type ExportDataSourcesQueryHookResult = ReturnType<typeof useExportDataSourcesQuery>;
export type ExportDataSourcesLazyQueryHookResult = ReturnType<typeof useExportDataSourcesLazyQuery>;
export type ExportDataSourcesQueryResult = Apollo.QueryResult<ExportDataSourcesQuery, ExportDataSourcesQueryVariables>;
export function refetchExportDataSourcesQuery(variables?: ExportDataSourcesQueryVariables) {
      return { query: ExportDataSourcesDocument, variables: variables }
    }
export const SetAlarmAcknowledgeStateDocument = gql`
    mutation SetAlarmAcknowledgeState($ids: [ID!]!, $acknowledge: Boolean) {
  setAlarmAcknowledgeState(ids: $ids, acknowledge: $acknowledge) {
    ...DetectorAlarmListNodeFragment
  }
}
    ${DetectorAlarmListNodeFragmentFragmentDoc}`;
export type SetAlarmAcknowledgeStateMutationFn = Apollo.MutationFunction<SetAlarmAcknowledgeStateMutation, SetAlarmAcknowledgeStateMutationVariables>;

/**
 * __useSetAlarmAcknowledgeStateMutation__
 *
 * To run a mutation, you first call `useSetAlarmAcknowledgeStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAlarmAcknowledgeStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAlarmAcknowledgeStateMutation, { data, loading, error }] = useSetAlarmAcknowledgeStateMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      acknowledge: // value for 'acknowledge'
 *   },
 * });
 */
export function useSetAlarmAcknowledgeStateMutation(baseOptions?: Apollo.MutationHookOptions<SetAlarmAcknowledgeStateMutation, SetAlarmAcknowledgeStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAlarmAcknowledgeStateMutation, SetAlarmAcknowledgeStateMutationVariables>(SetAlarmAcknowledgeStateDocument, options);
      }
export type SetAlarmAcknowledgeStateMutationHookResult = ReturnType<typeof useSetAlarmAcknowledgeStateMutation>;
export type SetAlarmAcknowledgeStateMutationResult = Apollo.MutationResult<SetAlarmAcknowledgeStateMutation>;
export type SetAlarmAcknowledgeStateMutationOptions = Apollo.BaseMutationOptions<SetAlarmAcknowledgeStateMutation, SetAlarmAcknowledgeStateMutationVariables>;
export const ClearDetectorAlarmsDocument = gql`
    mutation clearDetectorAlarms($ids: [ID!]!) {
  clearDetectorAlarms(ids: $ids) {
    ...DetectorAlarmListNodeFragment
  }
}
    ${DetectorAlarmListNodeFragmentFragmentDoc}`;
export type ClearDetectorAlarmsMutationFn = Apollo.MutationFunction<ClearDetectorAlarmsMutation, ClearDetectorAlarmsMutationVariables>;

/**
 * __useClearDetectorAlarmsMutation__
 *
 * To run a mutation, you first call `useClearDetectorAlarmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearDetectorAlarmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearDetectorAlarmsMutation, { data, loading, error }] = useClearDetectorAlarmsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useClearDetectorAlarmsMutation(baseOptions?: Apollo.MutationHookOptions<ClearDetectorAlarmsMutation, ClearDetectorAlarmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearDetectorAlarmsMutation, ClearDetectorAlarmsMutationVariables>(ClearDetectorAlarmsDocument, options);
      }
export type ClearDetectorAlarmsMutationHookResult = ReturnType<typeof useClearDetectorAlarmsMutation>;
export type ClearDetectorAlarmsMutationResult = Apollo.MutationResult<ClearDetectorAlarmsMutation>;
export type ClearDetectorAlarmsMutationOptions = Apollo.BaseMutationOptions<ClearDetectorAlarmsMutation, ClearDetectorAlarmsMutationVariables>;
export const ClearAllDetectorAlarmsDocument = gql`
    mutation clearAllDetectorAlarms {
  clearAllDetectorAlarms
}
    `;
export type ClearAllDetectorAlarmsMutationFn = Apollo.MutationFunction<ClearAllDetectorAlarmsMutation, ClearAllDetectorAlarmsMutationVariables>;

/**
 * __useClearAllDetectorAlarmsMutation__
 *
 * To run a mutation, you first call `useClearAllDetectorAlarmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllDetectorAlarmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllDetectorAlarmsMutation, { data, loading, error }] = useClearAllDetectorAlarmsMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearAllDetectorAlarmsMutation(baseOptions?: Apollo.MutationHookOptions<ClearAllDetectorAlarmsMutation, ClearAllDetectorAlarmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAllDetectorAlarmsMutation, ClearAllDetectorAlarmsMutationVariables>(ClearAllDetectorAlarmsDocument, options);
      }
export type ClearAllDetectorAlarmsMutationHookResult = ReturnType<typeof useClearAllDetectorAlarmsMutation>;
export type ClearAllDetectorAlarmsMutationResult = Apollo.MutationResult<ClearAllDetectorAlarmsMutation>;
export type ClearAllDetectorAlarmsMutationOptions = Apollo.BaseMutationOptions<ClearAllDetectorAlarmsMutation, ClearAllDetectorAlarmsMutationVariables>;
export const SaveDetectorEmailAlertSettingDocument = gql`
    mutation SaveDetectorEmailAlertSetting($input: DetectorEmailAlertSettingInput) {
  saveDetectorEmailAlertSetting(input: $input) {
    ...DetectorEmailAlertSettingFragment
  }
}
    ${DetectorEmailAlertSettingFragmentFragmentDoc}`;
export type SaveDetectorEmailAlertSettingMutationFn = Apollo.MutationFunction<SaveDetectorEmailAlertSettingMutation, SaveDetectorEmailAlertSettingMutationVariables>;

/**
 * __useSaveDetectorEmailAlertSettingMutation__
 *
 * To run a mutation, you first call `useSaveDetectorEmailAlertSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDetectorEmailAlertSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDetectorEmailAlertSettingMutation, { data, loading, error }] = useSaveDetectorEmailAlertSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDetectorEmailAlertSettingMutation(baseOptions?: Apollo.MutationHookOptions<SaveDetectorEmailAlertSettingMutation, SaveDetectorEmailAlertSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDetectorEmailAlertSettingMutation, SaveDetectorEmailAlertSettingMutationVariables>(SaveDetectorEmailAlertSettingDocument, options);
      }
export type SaveDetectorEmailAlertSettingMutationHookResult = ReturnType<typeof useSaveDetectorEmailAlertSettingMutation>;
export type SaveDetectorEmailAlertSettingMutationResult = Apollo.MutationResult<SaveDetectorEmailAlertSettingMutation>;
export type SaveDetectorEmailAlertSettingMutationOptions = Apollo.BaseMutationOptions<SaveDetectorEmailAlertSettingMutation, SaveDetectorEmailAlertSettingMutationVariables>;
export const UpdateDetectorEmailAlertSettingStatusDocument = gql`
    mutation UpdateDetectorEmailAlertSettingStatus($ids: [String!], $enabled: Boolean) {
  updateDetectorEmailAlertSettingStatus(ids: $ids, enabled: $enabled)
}
    `;
export type UpdateDetectorEmailAlertSettingStatusMutationFn = Apollo.MutationFunction<UpdateDetectorEmailAlertSettingStatusMutation, UpdateDetectorEmailAlertSettingStatusMutationVariables>;

/**
 * __useUpdateDetectorEmailAlertSettingStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDetectorEmailAlertSettingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetectorEmailAlertSettingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetectorEmailAlertSettingStatusMutation, { data, loading, error }] = useUpdateDetectorEmailAlertSettingStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateDetectorEmailAlertSettingStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetectorEmailAlertSettingStatusMutation, UpdateDetectorEmailAlertSettingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetectorEmailAlertSettingStatusMutation, UpdateDetectorEmailAlertSettingStatusMutationVariables>(UpdateDetectorEmailAlertSettingStatusDocument, options);
      }
export type UpdateDetectorEmailAlertSettingStatusMutationHookResult = ReturnType<typeof useUpdateDetectorEmailAlertSettingStatusMutation>;
export type UpdateDetectorEmailAlertSettingStatusMutationResult = Apollo.MutationResult<UpdateDetectorEmailAlertSettingStatusMutation>;
export type UpdateDetectorEmailAlertSettingStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDetectorEmailAlertSettingStatusMutation, UpdateDetectorEmailAlertSettingStatusMutationVariables>;
export const ImportDetectorVehiclesDataDocument = gql`
    mutation ImportDetectorVehiclesData($id: String!, $dateFormat: String!, $fileIds: [String!]!) {
  importDetectorVehiclesData(id: $id, dateFormat: $dateFormat, fileIds: $fileIds)
}
    `;
export type ImportDetectorVehiclesDataMutationFn = Apollo.MutationFunction<ImportDetectorVehiclesDataMutation, ImportDetectorVehiclesDataMutationVariables>;

/**
 * __useImportDetectorVehiclesDataMutation__
 *
 * To run a mutation, you first call `useImportDetectorVehiclesDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDetectorVehiclesDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDetectorVehiclesDataMutation, { data, loading, error }] = useImportDetectorVehiclesDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dateFormat: // value for 'dateFormat'
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useImportDetectorVehiclesDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportDetectorVehiclesDataMutation, ImportDetectorVehiclesDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportDetectorVehiclesDataMutation, ImportDetectorVehiclesDataMutationVariables>(ImportDetectorVehiclesDataDocument, options);
      }
export type ImportDetectorVehiclesDataMutationHookResult = ReturnType<typeof useImportDetectorVehiclesDataMutation>;
export type ImportDetectorVehiclesDataMutationResult = Apollo.MutationResult<ImportDetectorVehiclesDataMutation>;
export type ImportDetectorVehiclesDataMutationOptions = Apollo.BaseMutationOptions<ImportDetectorVehiclesDataMutation, ImportDetectorVehiclesDataMutationVariables>;
export const DeleteDetectorEmailAlertSettingDocument = gql`
    mutation DeleteDetectorEmailAlertSetting($ids: [String!]) {
  deleteDetectorEmailAlertSetting(ids: $ids)
}
    `;
export type DeleteDetectorEmailAlertSettingMutationFn = Apollo.MutationFunction<DeleteDetectorEmailAlertSettingMutation, DeleteDetectorEmailAlertSettingMutationVariables>;

/**
 * __useDeleteDetectorEmailAlertSettingMutation__
 *
 * To run a mutation, you first call `useDeleteDetectorEmailAlertSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDetectorEmailAlertSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDetectorEmailAlertSettingMutation, { data, loading, error }] = useDeleteDetectorEmailAlertSettingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteDetectorEmailAlertSettingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDetectorEmailAlertSettingMutation, DeleteDetectorEmailAlertSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDetectorEmailAlertSettingMutation, DeleteDetectorEmailAlertSettingMutationVariables>(DeleteDetectorEmailAlertSettingDocument, options);
      }
export type DeleteDetectorEmailAlertSettingMutationHookResult = ReturnType<typeof useDeleteDetectorEmailAlertSettingMutation>;
export type DeleteDetectorEmailAlertSettingMutationResult = Apollo.MutationResult<DeleteDetectorEmailAlertSettingMutation>;
export type DeleteDetectorEmailAlertSettingMutationOptions = Apollo.BaseMutationOptions<DeleteDetectorEmailAlertSettingMutation, DeleteDetectorEmailAlertSettingMutationVariables>;
export const GenerateDetectorTmasReportDocument = gql`
    mutation GenerateDetectorTMASReport($input: DetectorTMASReportQuery) {
  generateDetectorTMASReport(query: $input) {
    ...DetectorTMASReportFragment
  }
}
    ${DetectorTmasReportFragmentFragmentDoc}`;
export type GenerateDetectorTmasReportMutationFn = Apollo.MutationFunction<GenerateDetectorTmasReportMutation, GenerateDetectorTmasReportMutationVariables>;

/**
 * __useGenerateDetectorTmasReportMutation__
 *
 * To run a mutation, you first call `useGenerateDetectorTmasReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDetectorTmasReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDetectorTmasReportMutation, { data, loading, error }] = useGenerateDetectorTmasReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateDetectorTmasReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDetectorTmasReportMutation, GenerateDetectorTmasReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDetectorTmasReportMutation, GenerateDetectorTmasReportMutationVariables>(GenerateDetectorTmasReportDocument, options);
      }
export type GenerateDetectorTmasReportMutationHookResult = ReturnType<typeof useGenerateDetectorTmasReportMutation>;
export type GenerateDetectorTmasReportMutationResult = Apollo.MutationResult<GenerateDetectorTmasReportMutation>;
export type GenerateDetectorTmasReportMutationOptions = Apollo.BaseMutationOptions<GenerateDetectorTmasReportMutation, GenerateDetectorTmasReportMutationVariables>;
export const UpdateDetectorVehicleAiClassNameDocument = gql`
    mutation UpdateDetectorVehicleAIClassName($id: String, $className: String) {
  updateDetectorVehicleAIClassName(id: $id, className: $className)
}
    `;
export type UpdateDetectorVehicleAiClassNameMutationFn = Apollo.MutationFunction<UpdateDetectorVehicleAiClassNameMutation, UpdateDetectorVehicleAiClassNameMutationVariables>;

/**
 * __useUpdateDetectorVehicleAiClassNameMutation__
 *
 * To run a mutation, you first call `useUpdateDetectorVehicleAiClassNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetectorVehicleAiClassNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetectorVehicleAiClassNameMutation, { data, loading, error }] = useUpdateDetectorVehicleAiClassNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      className: // value for 'className'
 *   },
 * });
 */
export function useUpdateDetectorVehicleAiClassNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetectorVehicleAiClassNameMutation, UpdateDetectorVehicleAiClassNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetectorVehicleAiClassNameMutation, UpdateDetectorVehicleAiClassNameMutationVariables>(UpdateDetectorVehicleAiClassNameDocument, options);
      }
export type UpdateDetectorVehicleAiClassNameMutationHookResult = ReturnType<typeof useUpdateDetectorVehicleAiClassNameMutation>;
export type UpdateDetectorVehicleAiClassNameMutationResult = Apollo.MutationResult<UpdateDetectorVehicleAiClassNameMutation>;
export type UpdateDetectorVehicleAiClassNameMutationOptions = Apollo.BaseMutationOptions<UpdateDetectorVehicleAiClassNameMutation, UpdateDetectorVehicleAiClassNameMutationVariables>;
export const UpdateDetectorVehicleAiVerificationStatusDocument = gql`
    mutation UpdateDetectorVehicleAIVerificationStatus($id: String, $status: Boolean) {
  updateDetectorVehicleAIVerificationStatus(id: $id, status: $status)
}
    `;
export type UpdateDetectorVehicleAiVerificationStatusMutationFn = Apollo.MutationFunction<UpdateDetectorVehicleAiVerificationStatusMutation, UpdateDetectorVehicleAiVerificationStatusMutationVariables>;

/**
 * __useUpdateDetectorVehicleAiVerificationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDetectorVehicleAiVerificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetectorVehicleAiVerificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetectorVehicleAiVerificationStatusMutation, { data, loading, error }] = useUpdateDetectorVehicleAiVerificationStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateDetectorVehicleAiVerificationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetectorVehicleAiVerificationStatusMutation, UpdateDetectorVehicleAiVerificationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetectorVehicleAiVerificationStatusMutation, UpdateDetectorVehicleAiVerificationStatusMutationVariables>(UpdateDetectorVehicleAiVerificationStatusDocument, options);
      }
export type UpdateDetectorVehicleAiVerificationStatusMutationHookResult = ReturnType<typeof useUpdateDetectorVehicleAiVerificationStatusMutation>;
export type UpdateDetectorVehicleAiVerificationStatusMutationResult = Apollo.MutationResult<UpdateDetectorVehicleAiVerificationStatusMutation>;
export type UpdateDetectorVehicleAiVerificationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDetectorVehicleAiVerificationStatusMutation, UpdateDetectorVehicleAiVerificationStatusMutationVariables>;
export const UpdateDetectorVehicleVerifiedClassNameDocument = gql`
    mutation UpdateDetectorVehicleVerifiedClassName($id: String!, $classIndex: Int!) {
  updateDetectorVehicleVerifiedClassName(id: $id, classIndex: $classIndex) {
    ...DetectorVehicleListNodeFragment
  }
}
    ${DetectorVehicleListNodeFragmentFragmentDoc}`;
export type UpdateDetectorVehicleVerifiedClassNameMutationFn = Apollo.MutationFunction<UpdateDetectorVehicleVerifiedClassNameMutation, UpdateDetectorVehicleVerifiedClassNameMutationVariables>;

/**
 * __useUpdateDetectorVehicleVerifiedClassNameMutation__
 *
 * To run a mutation, you first call `useUpdateDetectorVehicleVerifiedClassNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetectorVehicleVerifiedClassNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetectorVehicleVerifiedClassNameMutation, { data, loading, error }] = useUpdateDetectorVehicleVerifiedClassNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      classIndex: // value for 'classIndex'
 *   },
 * });
 */
export function useUpdateDetectorVehicleVerifiedClassNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetectorVehicleVerifiedClassNameMutation, UpdateDetectorVehicleVerifiedClassNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetectorVehicleVerifiedClassNameMutation, UpdateDetectorVehicleVerifiedClassNameMutationVariables>(UpdateDetectorVehicleVerifiedClassNameDocument, options);
      }
export type UpdateDetectorVehicleVerifiedClassNameMutationHookResult = ReturnType<typeof useUpdateDetectorVehicleVerifiedClassNameMutation>;
export type UpdateDetectorVehicleVerifiedClassNameMutationResult = Apollo.MutationResult<UpdateDetectorVehicleVerifiedClassNameMutation>;
export type UpdateDetectorVehicleVerifiedClassNameMutationOptions = Apollo.BaseMutationOptions<UpdateDetectorVehicleVerifiedClassNameMutation, UpdateDetectorVehicleVerifiedClassNameMutationVariables>;
export const UpdateDetectorVehicleVerifiedClassNameStatusDocument = gql`
    mutation UpdateDetectorVehicleVerifiedClassNameStatus($id: String, $status: Boolean) {
  updateDetectorVehicleVerifiedClassNameStatus(id: $id, status: $status)
}
    `;
export type UpdateDetectorVehicleVerifiedClassNameStatusMutationFn = Apollo.MutationFunction<UpdateDetectorVehicleVerifiedClassNameStatusMutation, UpdateDetectorVehicleVerifiedClassNameStatusMutationVariables>;

/**
 * __useUpdateDetectorVehicleVerifiedClassNameStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDetectorVehicleVerifiedClassNameStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetectorVehicleVerifiedClassNameStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetectorVehicleVerifiedClassNameStatusMutation, { data, loading, error }] = useUpdateDetectorVehicleVerifiedClassNameStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateDetectorVehicleVerifiedClassNameStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetectorVehicleVerifiedClassNameStatusMutation, UpdateDetectorVehicleVerifiedClassNameStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetectorVehicleVerifiedClassNameStatusMutation, UpdateDetectorVehicleVerifiedClassNameStatusMutationVariables>(UpdateDetectorVehicleVerifiedClassNameStatusDocument, options);
      }
export type UpdateDetectorVehicleVerifiedClassNameStatusMutationHookResult = ReturnType<typeof useUpdateDetectorVehicleVerifiedClassNameStatusMutation>;
export type UpdateDetectorVehicleVerifiedClassNameStatusMutationResult = Apollo.MutationResult<UpdateDetectorVehicleVerifiedClassNameStatusMutation>;
export type UpdateDetectorVehicleVerifiedClassNameStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDetectorVehicleVerifiedClassNameStatusMutation, UpdateDetectorVehicleVerifiedClassNameStatusMutationVariables>;
export const SaveDetectorReportConfigurationDocument = gql`
    mutation SaveDetectorReportConfiguration($input: DetectorReportConfigurationInput) {
  saveDetectorReportConfiguration(input: $input) {
    ...DetectorReportConfigurationFragment
  }
}
    ${DetectorReportConfigurationFragmentFragmentDoc}`;
export type SaveDetectorReportConfigurationMutationFn = Apollo.MutationFunction<SaveDetectorReportConfigurationMutation, SaveDetectorReportConfigurationMutationVariables>;

/**
 * __useSaveDetectorReportConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveDetectorReportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDetectorReportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDetectorReportConfigurationMutation, { data, loading, error }] = useSaveDetectorReportConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDetectorReportConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SaveDetectorReportConfigurationMutation, SaveDetectorReportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDetectorReportConfigurationMutation, SaveDetectorReportConfigurationMutationVariables>(SaveDetectorReportConfigurationDocument, options);
      }
export type SaveDetectorReportConfigurationMutationHookResult = ReturnType<typeof useSaveDetectorReportConfigurationMutation>;
export type SaveDetectorReportConfigurationMutationResult = Apollo.MutationResult<SaveDetectorReportConfigurationMutation>;
export type SaveDetectorReportConfigurationMutationOptions = Apollo.BaseMutationOptions<SaveDetectorReportConfigurationMutation, SaveDetectorReportConfigurationMutationVariables>;
export const DeleteDetectorReportConfigurationDocument = gql`
    mutation DeleteDetectorReportConfiguration($ids: [ID!]!, $forceDelete: Boolean) {
  deleteDetectorReportConfiguration(ids: $ids, forceDelete: $forceDelete)
}
    `;
export type DeleteDetectorReportConfigurationMutationFn = Apollo.MutationFunction<DeleteDetectorReportConfigurationMutation, DeleteDetectorReportConfigurationMutationVariables>;

/**
 * __useDeleteDetectorReportConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteDetectorReportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDetectorReportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDetectorReportConfigurationMutation, { data, loading, error }] = useDeleteDetectorReportConfigurationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      forceDelete: // value for 'forceDelete'
 *   },
 * });
 */
export function useDeleteDetectorReportConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDetectorReportConfigurationMutation, DeleteDetectorReportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDetectorReportConfigurationMutation, DeleteDetectorReportConfigurationMutationVariables>(DeleteDetectorReportConfigurationDocument, options);
      }
export type DeleteDetectorReportConfigurationMutationHookResult = ReturnType<typeof useDeleteDetectorReportConfigurationMutation>;
export type DeleteDetectorReportConfigurationMutationResult = Apollo.MutationResult<DeleteDetectorReportConfigurationMutation>;
export type DeleteDetectorReportConfigurationMutationOptions = Apollo.BaseMutationOptions<DeleteDetectorReportConfigurationMutation, DeleteDetectorReportConfigurationMutationVariables>;
export const DeleteDetectorReportRuleDocument = gql`
    mutation DeleteDetectorReportRule($ids: [ID!]!, $forceDelete: Boolean) {
  deleteDetectorReportRule(ids: $ids, forceDelete: $forceDelete)
}
    `;
export type DeleteDetectorReportRuleMutationFn = Apollo.MutationFunction<DeleteDetectorReportRuleMutation, DeleteDetectorReportRuleMutationVariables>;

/**
 * __useDeleteDetectorReportRuleMutation__
 *
 * To run a mutation, you first call `useDeleteDetectorReportRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDetectorReportRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDetectorReportRuleMutation, { data, loading, error }] = useDeleteDetectorReportRuleMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      forceDelete: // value for 'forceDelete'
 *   },
 * });
 */
export function useDeleteDetectorReportRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDetectorReportRuleMutation, DeleteDetectorReportRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDetectorReportRuleMutation, DeleteDetectorReportRuleMutationVariables>(DeleteDetectorReportRuleDocument, options);
      }
export type DeleteDetectorReportRuleMutationHookResult = ReturnType<typeof useDeleteDetectorReportRuleMutation>;
export type DeleteDetectorReportRuleMutationResult = Apollo.MutationResult<DeleteDetectorReportRuleMutation>;
export type DeleteDetectorReportRuleMutationOptions = Apollo.BaseMutationOptions<DeleteDetectorReportRuleMutation, DeleteDetectorReportRuleMutationVariables>;
export const SaveDetectorReportRuleDocument = gql`
    mutation SaveDetectorReportRule($input: DetectorReportRuleInput) {
  saveDetectorReportRule(input: $input) {
    ...DetectorReportRuleFragment
  }
}
    ${DetectorReportRuleFragmentFragmentDoc}`;
export type SaveDetectorReportRuleMutationFn = Apollo.MutationFunction<SaveDetectorReportRuleMutation, SaveDetectorReportRuleMutationVariables>;

/**
 * __useSaveDetectorReportRuleMutation__
 *
 * To run a mutation, you first call `useSaveDetectorReportRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDetectorReportRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDetectorReportRuleMutation, { data, loading, error }] = useSaveDetectorReportRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDetectorReportRuleMutation(baseOptions?: Apollo.MutationHookOptions<SaveDetectorReportRuleMutation, SaveDetectorReportRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDetectorReportRuleMutation, SaveDetectorReportRuleMutationVariables>(SaveDetectorReportRuleDocument, options);
      }
export type SaveDetectorReportRuleMutationHookResult = ReturnType<typeof useSaveDetectorReportRuleMutation>;
export type SaveDetectorReportRuleMutationResult = Apollo.MutationResult<SaveDetectorReportRuleMutation>;
export type SaveDetectorReportRuleMutationOptions = Apollo.BaseMutationOptions<SaveDetectorReportRuleMutation, SaveDetectorReportRuleMutationVariables>;
export const ResetDetectorPerformanceReportsDocument = gql`
    mutation ResetDetectorPerformanceReports($ruleId: ID!, $detectorIds: [ID!]!, $startDateTime: Date!, $endDateTime: Date!) {
  resetDetectorPerformanceReport(
    query: {ruleId: $ruleId, detectorIds: $detectorIds, startDateTime: $startDateTime, endDateTime: $endDateTime}
  )
}
    `;
export type ResetDetectorPerformanceReportsMutationFn = Apollo.MutationFunction<ResetDetectorPerformanceReportsMutation, ResetDetectorPerformanceReportsMutationVariables>;

/**
 * __useResetDetectorPerformanceReportsMutation__
 *
 * To run a mutation, you first call `useResetDetectorPerformanceReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetDetectorPerformanceReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetDetectorPerformanceReportsMutation, { data, loading, error }] = useResetDetectorPerformanceReportsMutation({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *      detectorIds: // value for 'detectorIds'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useResetDetectorPerformanceReportsMutation(baseOptions?: Apollo.MutationHookOptions<ResetDetectorPerformanceReportsMutation, ResetDetectorPerformanceReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetDetectorPerformanceReportsMutation, ResetDetectorPerformanceReportsMutationVariables>(ResetDetectorPerformanceReportsDocument, options);
      }
export type ResetDetectorPerformanceReportsMutationHookResult = ReturnType<typeof useResetDetectorPerformanceReportsMutation>;
export type ResetDetectorPerformanceReportsMutationResult = Apollo.MutationResult<ResetDetectorPerformanceReportsMutation>;
export type ResetDetectorPerformanceReportsMutationOptions = Apollo.BaseMutationOptions<ResetDetectorPerformanceReportsMutation, ResetDetectorPerformanceReportsMutationVariables>;
export const UpdateDetectorVehicleVolumeIntervalCountsDocument = gql`
    mutation updateDetectorVehicleVolumeIntervalCounts($detectorId: ID!, $startDateTime: DateTime!, $endDateTime: DateTime!) {
  updateDetectorVehicleVolumeIntervalCounts(
    query: {detectorId: $detectorId, startDateTime: $startDateTime, endDateTime: $endDateTime}
  )
}
    `;
export type UpdateDetectorVehicleVolumeIntervalCountsMutationFn = Apollo.MutationFunction<UpdateDetectorVehicleVolumeIntervalCountsMutation, UpdateDetectorVehicleVolumeIntervalCountsMutationVariables>;

/**
 * __useUpdateDetectorVehicleVolumeIntervalCountsMutation__
 *
 * To run a mutation, you first call `useUpdateDetectorVehicleVolumeIntervalCountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetectorVehicleVolumeIntervalCountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetectorVehicleVolumeIntervalCountsMutation, { data, loading, error }] = useUpdateDetectorVehicleVolumeIntervalCountsMutation({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useUpdateDetectorVehicleVolumeIntervalCountsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetectorVehicleVolumeIntervalCountsMutation, UpdateDetectorVehicleVolumeIntervalCountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetectorVehicleVolumeIntervalCountsMutation, UpdateDetectorVehicleVolumeIntervalCountsMutationVariables>(UpdateDetectorVehicleVolumeIntervalCountsDocument, options);
      }
export type UpdateDetectorVehicleVolumeIntervalCountsMutationHookResult = ReturnType<typeof useUpdateDetectorVehicleVolumeIntervalCountsMutation>;
export type UpdateDetectorVehicleVolumeIntervalCountsMutationResult = Apollo.MutationResult<UpdateDetectorVehicleVolumeIntervalCountsMutation>;
export type UpdateDetectorVehicleVolumeIntervalCountsMutationOptions = Apollo.BaseMutationOptions<UpdateDetectorVehicleVolumeIntervalCountsMutation, UpdateDetectorVehicleVolumeIntervalCountsMutationVariables>;
export const MultiplePollDocument = gql`
    mutation multiplePoll($ids: [ID!]!, $integrationType: IntegrationType!) {
  multiplePoll(ids: $ids, integrationType: $integrationType) {
    failure
    success
    requestId
    id
  }
}
    `;
export type MultiplePollMutationFn = Apollo.MutationFunction<MultiplePollMutation, MultiplePollMutationVariables>;

/**
 * __useMultiplePollMutation__
 *
 * To run a mutation, you first call `useMultiplePollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMultiplePollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [multiplePollMutation, { data, loading, error }] = useMultiplePollMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useMultiplePollMutation(baseOptions?: Apollo.MutationHookOptions<MultiplePollMutation, MultiplePollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MultiplePollMutation, MultiplePollMutationVariables>(MultiplePollDocument, options);
      }
export type MultiplePollMutationHookResult = ReturnType<typeof useMultiplePollMutation>;
export type MultiplePollMutationResult = Apollo.MutationResult<MultiplePollMutation>;
export type MultiplePollMutationOptions = Apollo.BaseMutationOptions<MultiplePollMutation, MultiplePollMutationVariables>;
export const DownloadBulkDailyFilesDocument = gql`
    mutation downloadBulkDailyFiles($query: DetectorVehicleQuery, $unitType: ConversionUnitType) {
  exportDayWisePVRDetails(query: $query, unitType: $unitType)
}
    `;
export type DownloadBulkDailyFilesMutationFn = Apollo.MutationFunction<DownloadBulkDailyFilesMutation, DownloadBulkDailyFilesMutationVariables>;

/**
 * __useDownloadBulkDailyFilesMutation__
 *
 * To run a mutation, you first call `useDownloadBulkDailyFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadBulkDailyFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadBulkDailyFilesMutation, { data, loading, error }] = useDownloadBulkDailyFilesMutation({
 *   variables: {
 *      query: // value for 'query'
 *      unitType: // value for 'unitType'
 *   },
 * });
 */
export function useDownloadBulkDailyFilesMutation(baseOptions?: Apollo.MutationHookOptions<DownloadBulkDailyFilesMutation, DownloadBulkDailyFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadBulkDailyFilesMutation, DownloadBulkDailyFilesMutationVariables>(DownloadBulkDailyFilesDocument, options);
      }
export type DownloadBulkDailyFilesMutationHookResult = ReturnType<typeof useDownloadBulkDailyFilesMutation>;
export type DownloadBulkDailyFilesMutationResult = Apollo.MutationResult<DownloadBulkDailyFilesMutation>;
export type DownloadBulkDailyFilesMutationOptions = Apollo.BaseMutationOptions<DownloadBulkDailyFilesMutation, DownloadBulkDailyFilesMutationVariables>;
export const UpdateDefaultDetectorReportConfigurationDocument = gql`
    mutation updateDefaultDetectorReportConfiguration($id: ID!, $selection: Boolean) {
  updateDefaultDetectorReportConfiguration(id: $id, selection: $selection) {
    id
    name
    description
    ruleIds
    defaultSelection
  }
}
    `;
export type UpdateDefaultDetectorReportConfigurationMutationFn = Apollo.MutationFunction<UpdateDefaultDetectorReportConfigurationMutation, UpdateDefaultDetectorReportConfigurationMutationVariables>;

/**
 * __useUpdateDefaultDetectorReportConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultDetectorReportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultDetectorReportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultDetectorReportConfigurationMutation, { data, loading, error }] = useUpdateDefaultDetectorReportConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useUpdateDefaultDetectorReportConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultDetectorReportConfigurationMutation, UpdateDefaultDetectorReportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultDetectorReportConfigurationMutation, UpdateDefaultDetectorReportConfigurationMutationVariables>(UpdateDefaultDetectorReportConfigurationDocument, options);
      }
export type UpdateDefaultDetectorReportConfigurationMutationHookResult = ReturnType<typeof useUpdateDefaultDetectorReportConfigurationMutation>;
export type UpdateDefaultDetectorReportConfigurationMutationResult = Apollo.MutationResult<UpdateDefaultDetectorReportConfigurationMutation>;
export type UpdateDefaultDetectorReportConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultDetectorReportConfigurationMutation, UpdateDefaultDetectorReportConfigurationMutationVariables>;
export const SaveDetectorGroupDocument = gql`
    mutation SaveDetectorGroup($input: DetectorGroupInput!) {
  saveDetectorGroup(input: $input) {
    id
  }
}
    `;
export type SaveDetectorGroupMutationFn = Apollo.MutationFunction<SaveDetectorGroupMutation, SaveDetectorGroupMutationVariables>;

/**
 * __useSaveDetectorGroupMutation__
 *
 * To run a mutation, you first call `useSaveDetectorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDetectorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDetectorGroupMutation, { data, loading, error }] = useSaveDetectorGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDetectorGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveDetectorGroupMutation, SaveDetectorGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDetectorGroupMutation, SaveDetectorGroupMutationVariables>(SaveDetectorGroupDocument, options);
      }
export type SaveDetectorGroupMutationHookResult = ReturnType<typeof useSaveDetectorGroupMutation>;
export type SaveDetectorGroupMutationResult = Apollo.MutationResult<SaveDetectorGroupMutation>;
export type SaveDetectorGroupMutationOptions = Apollo.BaseMutationOptions<SaveDetectorGroupMutation, SaveDetectorGroupMutationVariables>;
export const DeleteDetectorGroupDocument = gql`
    mutation DeleteDetectorGroup($id: ID!) {
  deleteDetectorGroup(id: $id)
}
    `;
export type DeleteDetectorGroupMutationFn = Apollo.MutationFunction<DeleteDetectorGroupMutation, DeleteDetectorGroupMutationVariables>;

/**
 * __useDeleteDetectorGroupMutation__
 *
 * To run a mutation, you first call `useDeleteDetectorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDetectorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDetectorGroupMutation, { data, loading, error }] = useDeleteDetectorGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDetectorGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDetectorGroupMutation, DeleteDetectorGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDetectorGroupMutation, DeleteDetectorGroupMutationVariables>(DeleteDetectorGroupDocument, options);
      }
export type DeleteDetectorGroupMutationHookResult = ReturnType<typeof useDeleteDetectorGroupMutation>;
export type DeleteDetectorGroupMutationResult = Apollo.MutationResult<DeleteDetectorGroupMutation>;
export type DeleteDetectorGroupMutationOptions = Apollo.BaseMutationOptions<DeleteDetectorGroupMutation, DeleteDetectorGroupMutationVariables>;
export const UpdateDetectorVehicleRecordTagsDocument = gql`
    mutation UpdateDetectorVehicleRecordTags($id: String!, $tags: [String]) {
  updateDetectorVehicleRecordTags(id: $id, tags: $tags) {
    id
    serial
    timestamp
    firstConnectAt
    axlesCount
    classInfo {
      id
      name
      index
      __typename
    }
    lane
    speed
    grossWeight
    tags
  }
}
    `;
export type UpdateDetectorVehicleRecordTagsMutationFn = Apollo.MutationFunction<UpdateDetectorVehicleRecordTagsMutation, UpdateDetectorVehicleRecordTagsMutationVariables>;

/**
 * __useUpdateDetectorVehicleRecordTagsMutation__
 *
 * To run a mutation, you first call `useUpdateDetectorVehicleRecordTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetectorVehicleRecordTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetectorVehicleRecordTagsMutation, { data, loading, error }] = useUpdateDetectorVehicleRecordTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateDetectorVehicleRecordTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetectorVehicleRecordTagsMutation, UpdateDetectorVehicleRecordTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetectorVehicleRecordTagsMutation, UpdateDetectorVehicleRecordTagsMutationVariables>(UpdateDetectorVehicleRecordTagsDocument, options);
      }
export type UpdateDetectorVehicleRecordTagsMutationHookResult = ReturnType<typeof useUpdateDetectorVehicleRecordTagsMutation>;
export type UpdateDetectorVehicleRecordTagsMutationResult = Apollo.MutationResult<UpdateDetectorVehicleRecordTagsMutation>;
export type UpdateDetectorVehicleRecordTagsMutationOptions = Apollo.BaseMutationOptions<UpdateDetectorVehicleRecordTagsMutation, UpdateDetectorVehicleRecordTagsMutationVariables>;
export const DownloadDetectorTurningReportsDocument = gql`
    mutation downloadDetectorTurningReports($detectorId: ID!, $startDate: Date!, $endDate: Date!, $viewType: DateViewType!, $granularity: DetectorVehicleVolumeGranularity!, $reportPreference: ReportPreference) {
  exportTurningReport(
    query: {detectorId: $detectorId, startDate: $startDate, endDate: $endDate, viewType: $viewType, granularity: $granularity, reportPreference: $reportPreference}
  )
}
    `;
export type DownloadDetectorTurningReportsMutationFn = Apollo.MutationFunction<DownloadDetectorTurningReportsMutation, DownloadDetectorTurningReportsMutationVariables>;

/**
 * __useDownloadDetectorTurningReportsMutation__
 *
 * To run a mutation, you first call `useDownloadDetectorTurningReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDetectorTurningReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDetectorTurningReportsMutation, { data, loading, error }] = useDownloadDetectorTurningReportsMutation({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      viewType: // value for 'viewType'
 *      granularity: // value for 'granularity'
 *      reportPreference: // value for 'reportPreference'
 *   },
 * });
 */
export function useDownloadDetectorTurningReportsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadDetectorTurningReportsMutation, DownloadDetectorTurningReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadDetectorTurningReportsMutation, DownloadDetectorTurningReportsMutationVariables>(DownloadDetectorTurningReportsDocument, options);
      }
export type DownloadDetectorTurningReportsMutationHookResult = ReturnType<typeof useDownloadDetectorTurningReportsMutation>;
export type DownloadDetectorTurningReportsMutationResult = Apollo.MutationResult<DownloadDetectorTurningReportsMutation>;
export type DownloadDetectorTurningReportsMutationOptions = Apollo.BaseMutationOptions<DownloadDetectorTurningReportsMutation, DownloadDetectorTurningReportsMutationVariables>;
export const SaveCountsModuleSettingsDocument = gql`
    mutation saveCountsModuleSettings($settings: JSON!) {
  saveCountsModuleSettings(settings: $settings)
}
    `;
export type SaveCountsModuleSettingsMutationFn = Apollo.MutationFunction<SaveCountsModuleSettingsMutation, SaveCountsModuleSettingsMutationVariables>;

/**
 * __useSaveCountsModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveCountsModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCountsModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCountsModuleSettingsMutation, { data, loading, error }] = useSaveCountsModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveCountsModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveCountsModuleSettingsMutation, SaveCountsModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCountsModuleSettingsMutation, SaveCountsModuleSettingsMutationVariables>(SaveCountsModuleSettingsDocument, options);
      }
export type SaveCountsModuleSettingsMutationHookResult = ReturnType<typeof useSaveCountsModuleSettingsMutation>;
export type SaveCountsModuleSettingsMutationResult = Apollo.MutationResult<SaveCountsModuleSettingsMutation>;
export type SaveCountsModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveCountsModuleSettingsMutation, SaveCountsModuleSettingsMutationVariables>;
export const ExportDetectorIntersectionReportDocument = gql`
    mutation exportDetectorIntersectionReport($detectorId: ID!, $startDate: Date!, $endDate: Date!, $viewType: DateViewType!, $granularity: DetectorVehicleVolumeGranularity!, $reportPreference: ReportPreference) {
  exportDetectorIntersectionReport(
    query: {detectorId: $detectorId, startDate: $startDate, endDate: $endDate, viewType: $viewType, granularity: $granularity, reportPreference: $reportPreference}
  )
}
    `;
export type ExportDetectorIntersectionReportMutationFn = Apollo.MutationFunction<ExportDetectorIntersectionReportMutation, ExportDetectorIntersectionReportMutationVariables>;

/**
 * __useExportDetectorIntersectionReportMutation__
 *
 * To run a mutation, you first call `useExportDetectorIntersectionReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportDetectorIntersectionReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportDetectorIntersectionReportMutation, { data, loading, error }] = useExportDetectorIntersectionReportMutation({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      viewType: // value for 'viewType'
 *      granularity: // value for 'granularity'
 *      reportPreference: // value for 'reportPreference'
 *   },
 * });
 */
export function useExportDetectorIntersectionReportMutation(baseOptions?: Apollo.MutationHookOptions<ExportDetectorIntersectionReportMutation, ExportDetectorIntersectionReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportDetectorIntersectionReportMutation, ExportDetectorIntersectionReportMutationVariables>(ExportDetectorIntersectionReportDocument, options);
      }
export type ExportDetectorIntersectionReportMutationHookResult = ReturnType<typeof useExportDetectorIntersectionReportMutation>;
export type ExportDetectorIntersectionReportMutationResult = Apollo.MutationResult<ExportDetectorIntersectionReportMutation>;
export type ExportDetectorIntersectionReportMutationOptions = Apollo.BaseMutationOptions<ExportDetectorIntersectionReportMutation, ExportDetectorIntersectionReportMutationVariables>;
export const ProtocolsDocument = gql`
    query Protocols($integrationType: IntegrationType, $integrationsFormSortField: IntegrationsFormSortField = NAME, $sortOrder: SortOrder = ASCENDING) {
  integrationForms(
    limit: 10000
    integrationType: $integrationType
    integrationsFormSortField: $integrationsFormSortField
    sortOrder: $sortOrder
  ) {
    edges {
      node {
        id
        name
        integrationType
      }
    }
  }
}
    `;

/**
 * __useProtocolsQuery__
 *
 * To run a query within a React component, call `useProtocolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProtocolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProtocolsQuery({
 *   variables: {
 *      integrationType: // value for 'integrationType'
 *      integrationsFormSortField: // value for 'integrationsFormSortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useProtocolsQuery(baseOptions?: Apollo.QueryHookOptions<ProtocolsQuery, ProtocolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProtocolsQuery, ProtocolsQueryVariables>(ProtocolsDocument, options);
      }
export function useProtocolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProtocolsQuery, ProtocolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProtocolsQuery, ProtocolsQueryVariables>(ProtocolsDocument, options);
        }
export type ProtocolsQueryHookResult = ReturnType<typeof useProtocolsQuery>;
export type ProtocolsLazyQueryHookResult = ReturnType<typeof useProtocolsLazyQuery>;
export type ProtocolsQueryResult = Apollo.QueryResult<ProtocolsQuery, ProtocolsQueryVariables>;
export function refetchProtocolsQuery(variables?: ProtocolsQueryVariables) {
      return { query: ProtocolsDocument, variables: variables }
    }
export const DetectorDocument = gql`
    query Detector($id: ID!) {
  detector(id: $id) {
    ...DetectorListNodeFragment
    siteImages {
      id
      name
      size
      contentType
      path
      timestamp
      module
      key
    }
  }
}
    ${DetectorListNodeFragmentFragmentDoc}`;

/**
 * __useDetectorQuery__
 *
 * To run a query within a React component, call `useDetectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectorQuery(baseOptions: Apollo.QueryHookOptions<DetectorQuery, DetectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorQuery, DetectorQueryVariables>(DetectorDocument, options);
      }
export function useDetectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorQuery, DetectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorQuery, DetectorQueryVariables>(DetectorDocument, options);
        }
export type DetectorQueryHookResult = ReturnType<typeof useDetectorQuery>;
export type DetectorLazyQueryHookResult = ReturnType<typeof useDetectorLazyQuery>;
export type DetectorQueryResult = Apollo.QueryResult<DetectorQuery, DetectorQueryVariables>;
export function refetchDetectorQuery(variables: DetectorQueryVariables) {
      return { query: DetectorDocument, variables: variables }
    }
export const DetectorsDocument = gql`
    query Detectors($after: String, $before: String, $limit: Int = 1000, $sortField: String, $sortOrder: SortOrder = ASCENDING, $searchFields: [String!] = ["name", "description", "config.integrationType", "config.settings.DIRECTION", "config.settings.DETECTOR_TYPE", "state.currentState.communicationState"], $searchText: String, $filters: [FilterInput], $showDisabled: Boolean) {
  detectors(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchFields: $searchFields, searchText: $searchText, filters: $filters, showDisabled: $showDisabled}
  ) {
    edges {
      node {
        ...DetectorListNodeFragment
        siteImages {
          id
          name
          size
          contentType
          path
          timestamp
          module
          key
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectorListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorsQuery__
 *
 * To run a query within a React component, call `useDetectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      showDisabled: // value for 'showDisabled'
 *   },
 * });
 */
export function useDetectorsQuery(baseOptions?: Apollo.QueryHookOptions<DetectorsQuery, DetectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorsQuery, DetectorsQueryVariables>(DetectorsDocument, options);
      }
export function useDetectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorsQuery, DetectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorsQuery, DetectorsQueryVariables>(DetectorsDocument, options);
        }
export type DetectorsQueryHookResult = ReturnType<typeof useDetectorsQuery>;
export type DetectorsLazyQueryHookResult = ReturnType<typeof useDetectorsLazyQuery>;
export type DetectorsQueryResult = Apollo.QueryResult<DetectorsQuery, DetectorsQueryVariables>;
export function refetchDetectorsQuery(variables?: DetectorsQueryVariables) {
      return { query: DetectorsDocument, variables: variables }
    }
export const DetectorVehicleDetailsDocument = gql`
    query DetectorVehicleDetails($id: String) {
  detectorVehicleDetail(id: $id) {
    ...DetectorVehicleListNodeFragment
    ...DetectorVehicleDetailNodeFragment
  }
}
    ${DetectorVehicleListNodeFragmentFragmentDoc}
${DetectorVehicleDetailNodeFragmentFragmentDoc}`;

/**
 * __useDetectorVehicleDetailsQuery__
 *
 * To run a query within a React component, call `useDetectorVehicleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehicleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehicleDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectorVehicleDetailsQuery(baseOptions?: Apollo.QueryHookOptions<DetectorVehicleDetailsQuery, DetectorVehicleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehicleDetailsQuery, DetectorVehicleDetailsQueryVariables>(DetectorVehicleDetailsDocument, options);
      }
export function useDetectorVehicleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehicleDetailsQuery, DetectorVehicleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehicleDetailsQuery, DetectorVehicleDetailsQueryVariables>(DetectorVehicleDetailsDocument, options);
        }
export type DetectorVehicleDetailsQueryHookResult = ReturnType<typeof useDetectorVehicleDetailsQuery>;
export type DetectorVehicleDetailsLazyQueryHookResult = ReturnType<typeof useDetectorVehicleDetailsLazyQuery>;
export type DetectorVehicleDetailsQueryResult = Apollo.QueryResult<DetectorVehicleDetailsQuery, DetectorVehicleDetailsQueryVariables>;
export function refetchDetectorVehicleDetailsQuery(variables?: DetectorVehicleDetailsQueryVariables) {
      return { query: DetectorVehicleDetailsDocument, variables: variables }
    }
export const DetectorVehiclesDocument = gql`
    query DetectorVehicles($after: String, $before: String, $limit: Int = 100, $sortField: DetectorVehiclesSortField, $sortOrder: SortOrder = ASCENDING, $searchText: String, $classNames: [String!], $classIndexes: [Int!], $filters: [FilterInput], $detectorId: ID!, $startDateTime: DateTime, $endDateTime: DateTime) {
  detectorVehicles(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, classNames: $classNames, classIndexes: $classIndexes, filters: $filters, detectorId: $detectorId, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    edges {
      node {
        ...DetectorVehicleListNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectorVehicleListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorVehiclesQuery__
 *
 * To run a query within a React component, call `useDetectorVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehiclesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      classNames: // value for 'classNames'
 *      classIndexes: // value for 'classIndexes'
 *      filters: // value for 'filters'
 *      detectorId: // value for 'detectorId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorVehiclesQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehiclesQuery, DetectorVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehiclesQuery, DetectorVehiclesQueryVariables>(DetectorVehiclesDocument, options);
      }
export function useDetectorVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehiclesQuery, DetectorVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehiclesQuery, DetectorVehiclesQueryVariables>(DetectorVehiclesDocument, options);
        }
export type DetectorVehiclesQueryHookResult = ReturnType<typeof useDetectorVehiclesQuery>;
export type DetectorVehiclesLazyQueryHookResult = ReturnType<typeof useDetectorVehiclesLazyQuery>;
export type DetectorVehiclesQueryResult = Apollo.QueryResult<DetectorVehiclesQuery, DetectorVehiclesQueryVariables>;
export function refetchDetectorVehiclesQuery(variables: DetectorVehiclesQueryVariables) {
      return { query: DetectorVehiclesDocument, variables: variables }
    }
export const DetectorVehiclesCountDocument = gql`
    query DetectorVehiclesCount($after: String, $before: String, $limit: Int = 100, $sortField: DetectorVehiclesSortField, $sortOrder: SortOrder = DESCENDING, $searchText: String, $classNames: [String!], $classIndexes: [Int!], $filters: [FilterInput], $detectorId: ID!, $startDateTime: DateTime, $endDateTime: DateTime, $reportPreference: ReportPreference) {
  detectorVehiclesCount(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, classNames: $classNames, classIndexes: $classIndexes, filters: $filters, detectorId: $detectorId, startDateTime: $startDateTime, endDateTime: $endDateTime, reportPreference: $reportPreference}
  )
}
    `;

/**
 * __useDetectorVehiclesCountQuery__
 *
 * To run a query within a React component, call `useDetectorVehiclesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehiclesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehiclesCountQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      classNames: // value for 'classNames'
 *      classIndexes: // value for 'classIndexes'
 *      filters: // value for 'filters'
 *      detectorId: // value for 'detectorId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      reportPreference: // value for 'reportPreference'
 *   },
 * });
 */
export function useDetectorVehiclesCountQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehiclesCountQuery, DetectorVehiclesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehiclesCountQuery, DetectorVehiclesCountQueryVariables>(DetectorVehiclesCountDocument, options);
      }
export function useDetectorVehiclesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehiclesCountQuery, DetectorVehiclesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehiclesCountQuery, DetectorVehiclesCountQueryVariables>(DetectorVehiclesCountDocument, options);
        }
export type DetectorVehiclesCountQueryHookResult = ReturnType<typeof useDetectorVehiclesCountQuery>;
export type DetectorVehiclesCountLazyQueryHookResult = ReturnType<typeof useDetectorVehiclesCountLazyQuery>;
export type DetectorVehiclesCountQueryResult = Apollo.QueryResult<DetectorVehiclesCountQuery, DetectorVehiclesCountQueryVariables>;
export function refetchDetectorVehiclesCountQuery(variables: DetectorVehiclesCountQueryVariables) {
      return { query: DetectorVehiclesCountDocument, variables: variables }
    }
export const DetectorUpdatedDocument = gql`
    subscription DetectorUpdated($ids: [ID!]) {
  detectorUpdated(ids: $ids) {
    ...DetectorListNodeFragment
  }
}
    ${DetectorListNodeFragmentFragmentDoc}`;

/**
 * __useDetectorUpdatedSubscription__
 *
 * To run a query within a React component, call `useDetectorUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetectorUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDetectorUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DetectorUpdatedSubscription, DetectorUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetectorUpdatedSubscription, DetectorUpdatedSubscriptionVariables>(DetectorUpdatedDocument, options);
      }
export type DetectorUpdatedSubscriptionHookResult = ReturnType<typeof useDetectorUpdatedSubscription>;
export type DetectorUpdatedSubscriptionResult = Apollo.SubscriptionResult<DetectorUpdatedSubscription>;
export const DetectorAlarmsDocument = gql`
    query DetectorAlarms($after: String, $before: String, $limit: Int = 100, $sortField: DetectorAlarmsSortField, $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput], $startDateTime: DateTime, $endDateTime: DateTime) {
  detectorAlarms(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, filters: $filters, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    edges {
      node {
        ...DetectorAlarmListNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectorAlarmListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorAlarmsQuery__
 *
 * To run a query within a React component, call `useDetectorAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorAlarmsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorAlarmsQuery(baseOptions?: Apollo.QueryHookOptions<DetectorAlarmsQuery, DetectorAlarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorAlarmsQuery, DetectorAlarmsQueryVariables>(DetectorAlarmsDocument, options);
      }
export function useDetectorAlarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorAlarmsQuery, DetectorAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorAlarmsQuery, DetectorAlarmsQueryVariables>(DetectorAlarmsDocument, options);
        }
export type DetectorAlarmsQueryHookResult = ReturnType<typeof useDetectorAlarmsQuery>;
export type DetectorAlarmsLazyQueryHookResult = ReturnType<typeof useDetectorAlarmsLazyQuery>;
export type DetectorAlarmsQueryResult = Apollo.QueryResult<DetectorAlarmsQuery, DetectorAlarmsQueryVariables>;
export function refetchDetectorAlarmsQuery(variables?: DetectorAlarmsQueryVariables) {
      return { query: DetectorAlarmsDocument, variables: variables }
    }
export const DetectorBatteryDocument = gql`
    query DetectorBattery($detectorId: ID!, $granularity: DetectorBatteryGranularity, $startDateTime: DateTime, $endDateTime: DateTime) {
  detectorBattery(
    query: {detectorId: $detectorId, granularity: $granularity, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    ...DetectorBatteryListNodeFragment
  }
}
    ${DetectorBatteryListNodeFragmentFragmentDoc}`;

/**
 * __useDetectorBatteryQuery__
 *
 * To run a query within a React component, call `useDetectorBatteryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorBatteryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorBatteryQuery({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      granularity: // value for 'granularity'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorBatteryQuery(baseOptions: Apollo.QueryHookOptions<DetectorBatteryQuery, DetectorBatteryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorBatteryQuery, DetectorBatteryQueryVariables>(DetectorBatteryDocument, options);
      }
export function useDetectorBatteryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorBatteryQuery, DetectorBatteryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorBatteryQuery, DetectorBatteryQueryVariables>(DetectorBatteryDocument, options);
        }
export type DetectorBatteryQueryHookResult = ReturnType<typeof useDetectorBatteryQuery>;
export type DetectorBatteryLazyQueryHookResult = ReturnType<typeof useDetectorBatteryLazyQuery>;
export type DetectorBatteryQueryResult = Apollo.QueryResult<DetectorBatteryQuery, DetectorBatteryQueryVariables>;
export function refetchDetectorBatteryQuery(variables: DetectorBatteryQueryVariables) {
      return { query: DetectorBatteryDocument, variables: variables }
    }
export const DetectorActivitiesDocument = gql`
    query DetectorActivities($after: String, $before: String, $limit: Int = 100, $sortField: DetectorActivitySortField, $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput], $detectorId: ID!, $startDateTime: DateTime, $endDateTime: DateTime, $level: DetectorLogLevel) {
  detectorActivities(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, filters: $filters, detectorId: $detectorId, startDateTime: $startDateTime, endDateTime: $endDateTime, level: $level}
  ) {
    edges {
      node {
        ...DetectorActivityListNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${DetectorActivityListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorActivitiesQuery__
 *
 * To run a query within a React component, call `useDetectorActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorActivitiesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      detectorId: // value for 'detectorId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useDetectorActivitiesQuery(baseOptions: Apollo.QueryHookOptions<DetectorActivitiesQuery, DetectorActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorActivitiesQuery, DetectorActivitiesQueryVariables>(DetectorActivitiesDocument, options);
      }
export function useDetectorActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorActivitiesQuery, DetectorActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorActivitiesQuery, DetectorActivitiesQueryVariables>(DetectorActivitiesDocument, options);
        }
export type DetectorActivitiesQueryHookResult = ReturnType<typeof useDetectorActivitiesQuery>;
export type DetectorActivitiesLazyQueryHookResult = ReturnType<typeof useDetectorActivitiesLazyQuery>;
export type DetectorActivitiesQueryResult = Apollo.QueryResult<DetectorActivitiesQuery, DetectorActivitiesQueryVariables>;
export function refetchDetectorActivitiesQuery(variables: DetectorActivitiesQueryVariables) {
      return { query: DetectorActivitiesDocument, variables: variables }
    }
export const DetectorClassesDocument = gql`
    query DetectorClasses($detectorIds: [ID!]!) {
  detectorClasses(detectorIds: $detectorIds) {
    id
    name
    index
  }
}
    `;

/**
 * __useDetectorClassesQuery__
 *
 * To run a query within a React component, call `useDetectorClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorClassesQuery({
 *   variables: {
 *      detectorIds: // value for 'detectorIds'
 *   },
 * });
 */
export function useDetectorClassesQuery(baseOptions: Apollo.QueryHookOptions<DetectorClassesQuery, DetectorClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorClassesQuery, DetectorClassesQueryVariables>(DetectorClassesDocument, options);
      }
export function useDetectorClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorClassesQuery, DetectorClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorClassesQuery, DetectorClassesQueryVariables>(DetectorClassesDocument, options);
        }
export type DetectorClassesQueryHookResult = ReturnType<typeof useDetectorClassesQuery>;
export type DetectorClassesLazyQueryHookResult = ReturnType<typeof useDetectorClassesLazyQuery>;
export type DetectorClassesQueryResult = Apollo.QueryResult<DetectorClassesQuery, DetectorClassesQueryVariables>;
export function refetchDetectorClassesQuery(variables: DetectorClassesQueryVariables) {
      return { query: DetectorClassesDocument, variables: variables }
    }
export const DetectorVerificationClassDocument = gql`
    query DetectorVerificationClass {
  detectorVerificationClass {
    name
    key
  }
}
    `;

/**
 * __useDetectorVerificationClassQuery__
 *
 * To run a query within a React component, call `useDetectorVerificationClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVerificationClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVerificationClassQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorVerificationClassQuery(baseOptions?: Apollo.QueryHookOptions<DetectorVerificationClassQuery, DetectorVerificationClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVerificationClassQuery, DetectorVerificationClassQueryVariables>(DetectorVerificationClassDocument, options);
      }
export function useDetectorVerificationClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVerificationClassQuery, DetectorVerificationClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVerificationClassQuery, DetectorVerificationClassQueryVariables>(DetectorVerificationClassDocument, options);
        }
export type DetectorVerificationClassQueryHookResult = ReturnType<typeof useDetectorVerificationClassQuery>;
export type DetectorVerificationClassLazyQueryHookResult = ReturnType<typeof useDetectorVerificationClassLazyQuery>;
export type DetectorVerificationClassQueryResult = Apollo.QueryResult<DetectorVerificationClassQuery, DetectorVerificationClassQueryVariables>;
export function refetchDetectorVerificationClassQuery(variables?: DetectorVerificationClassQueryVariables) {
      return { query: DetectorVerificationClassDocument, variables: variables }
    }
export const DetectorAiClassDocument = gql`
    query DetectorAiClass {
  detectorAiClass {
    id
    name
    description
  }
}
    `;

/**
 * __useDetectorAiClassQuery__
 *
 * To run a query within a React component, call `useDetectorAiClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorAiClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorAiClassQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorAiClassQuery(baseOptions?: Apollo.QueryHookOptions<DetectorAiClassQuery, DetectorAiClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorAiClassQuery, DetectorAiClassQueryVariables>(DetectorAiClassDocument, options);
      }
export function useDetectorAiClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorAiClassQuery, DetectorAiClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorAiClassQuery, DetectorAiClassQueryVariables>(DetectorAiClassDocument, options);
        }
export type DetectorAiClassQueryHookResult = ReturnType<typeof useDetectorAiClassQuery>;
export type DetectorAiClassLazyQueryHookResult = ReturnType<typeof useDetectorAiClassLazyQuery>;
export type DetectorAiClassQueryResult = Apollo.QueryResult<DetectorAiClassQuery, DetectorAiClassQueryVariables>;
export function refetchDetectorAiClassQuery(variables?: DetectorAiClassQueryVariables) {
      return { query: DetectorAiClassDocument, variables: variables }
    }
export const DetectorLogLevelsDocument = gql`
    query DetectorLogLevels {
  detectorLogLevels {
    label
    value
  }
}
    `;

/**
 * __useDetectorLogLevelsQuery__
 *
 * To run a query within a React component, call `useDetectorLogLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorLogLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorLogLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorLogLevelsQuery(baseOptions?: Apollo.QueryHookOptions<DetectorLogLevelsQuery, DetectorLogLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorLogLevelsQuery, DetectorLogLevelsQueryVariables>(DetectorLogLevelsDocument, options);
      }
export function useDetectorLogLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorLogLevelsQuery, DetectorLogLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorLogLevelsQuery, DetectorLogLevelsQueryVariables>(DetectorLogLevelsDocument, options);
        }
export type DetectorLogLevelsQueryHookResult = ReturnType<typeof useDetectorLogLevelsQuery>;
export type DetectorLogLevelsLazyQueryHookResult = ReturnType<typeof useDetectorLogLevelsLazyQuery>;
export type DetectorLogLevelsQueryResult = Apollo.QueryResult<DetectorLogLevelsQuery, DetectorLogLevelsQueryVariables>;
export function refetchDetectorLogLevelsQuery(variables?: DetectorLogLevelsQueryVariables) {
      return { query: DetectorLogLevelsDocument, variables: variables }
    }
export const DetectorLogMessagesDocument = gql`
    query DetectorLogMessages {
  detectorLogMessages {
    label
    value
  }
}
    `;

/**
 * __useDetectorLogMessagesQuery__
 *
 * To run a query within a React component, call `useDetectorLogMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorLogMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorLogMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorLogMessagesQuery(baseOptions?: Apollo.QueryHookOptions<DetectorLogMessagesQuery, DetectorLogMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorLogMessagesQuery, DetectorLogMessagesQueryVariables>(DetectorLogMessagesDocument, options);
      }
export function useDetectorLogMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorLogMessagesQuery, DetectorLogMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorLogMessagesQuery, DetectorLogMessagesQueryVariables>(DetectorLogMessagesDocument, options);
        }
export type DetectorLogMessagesQueryHookResult = ReturnType<typeof useDetectorLogMessagesQuery>;
export type DetectorLogMessagesLazyQueryHookResult = ReturnType<typeof useDetectorLogMessagesLazyQuery>;
export type DetectorLogMessagesQueryResult = Apollo.QueryResult<DetectorLogMessagesQuery, DetectorLogMessagesQueryVariables>;
export function refetchDetectorLogMessagesQuery(variables?: DetectorLogMessagesQueryVariables) {
      return { query: DetectorLogMessagesDocument, variables: variables }
    }
export const DetectorLogSubtypesDocument = gql`
    query DetectorLogSubtypes {
  detectorLogSubtypes {
    label
    value
  }
}
    `;

/**
 * __useDetectorLogSubtypesQuery__
 *
 * To run a query within a React component, call `useDetectorLogSubtypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorLogSubtypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorLogSubtypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorLogSubtypesQuery(baseOptions?: Apollo.QueryHookOptions<DetectorLogSubtypesQuery, DetectorLogSubtypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorLogSubtypesQuery, DetectorLogSubtypesQueryVariables>(DetectorLogSubtypesDocument, options);
      }
export function useDetectorLogSubtypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorLogSubtypesQuery, DetectorLogSubtypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorLogSubtypesQuery, DetectorLogSubtypesQueryVariables>(DetectorLogSubtypesDocument, options);
        }
export type DetectorLogSubtypesQueryHookResult = ReturnType<typeof useDetectorLogSubtypesQuery>;
export type DetectorLogSubtypesLazyQueryHookResult = ReturnType<typeof useDetectorLogSubtypesLazyQuery>;
export type DetectorLogSubtypesQueryResult = Apollo.QueryResult<DetectorLogSubtypesQuery, DetectorLogSubtypesQueryVariables>;
export function refetchDetectorLogSubtypesQuery(variables?: DetectorLogSubtypesQueryVariables) {
      return { query: DetectorLogSubtypesDocument, variables: variables }
    }
export const DetectorAlarmTypesDocument = gql`
    query DetectorAlarmTypes {
  detectorAlarmTypes {
    id
    name
  }
}
    `;

/**
 * __useDetectorAlarmTypesQuery__
 *
 * To run a query within a React component, call `useDetectorAlarmTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorAlarmTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorAlarmTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorAlarmTypesQuery(baseOptions?: Apollo.QueryHookOptions<DetectorAlarmTypesQuery, DetectorAlarmTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorAlarmTypesQuery, DetectorAlarmTypesQueryVariables>(DetectorAlarmTypesDocument, options);
      }
export function useDetectorAlarmTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorAlarmTypesQuery, DetectorAlarmTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorAlarmTypesQuery, DetectorAlarmTypesQueryVariables>(DetectorAlarmTypesDocument, options);
        }
export type DetectorAlarmTypesQueryHookResult = ReturnType<typeof useDetectorAlarmTypesQuery>;
export type DetectorAlarmTypesLazyQueryHookResult = ReturnType<typeof useDetectorAlarmTypesLazyQuery>;
export type DetectorAlarmTypesQueryResult = Apollo.QueryResult<DetectorAlarmTypesQuery, DetectorAlarmTypesQueryVariables>;
export function refetchDetectorAlarmTypesQuery(variables?: DetectorAlarmTypesQueryVariables) {
      return { query: DetectorAlarmTypesDocument, variables: variables }
    }
export const DetectorAlarmGroupsDocument = gql`
    query DetectorAlarmGroups {
  detectorAlarmGroups {
    id
    name
  }
}
    `;

/**
 * __useDetectorAlarmGroupsQuery__
 *
 * To run a query within a React component, call `useDetectorAlarmGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorAlarmGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorAlarmGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorAlarmGroupsQuery(baseOptions?: Apollo.QueryHookOptions<DetectorAlarmGroupsQuery, DetectorAlarmGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorAlarmGroupsQuery, DetectorAlarmGroupsQueryVariables>(DetectorAlarmGroupsDocument, options);
      }
export function useDetectorAlarmGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorAlarmGroupsQuery, DetectorAlarmGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorAlarmGroupsQuery, DetectorAlarmGroupsQueryVariables>(DetectorAlarmGroupsDocument, options);
        }
export type DetectorAlarmGroupsQueryHookResult = ReturnType<typeof useDetectorAlarmGroupsQuery>;
export type DetectorAlarmGroupsLazyQueryHookResult = ReturnType<typeof useDetectorAlarmGroupsLazyQuery>;
export type DetectorAlarmGroupsQueryResult = Apollo.QueryResult<DetectorAlarmGroupsQuery, DetectorAlarmGroupsQueryVariables>;
export function refetchDetectorAlarmGroupsQuery(variables?: DetectorAlarmGroupsQueryVariables) {
      return { query: DetectorAlarmGroupsDocument, variables: variables }
    }
export const DetectorMiniViewCountsDocument = gql`
    query DetectorMiniViewCounts($detectorId: ID!, $yesterdayStartDate: DateTime!, $yesterdayEndDate: DateTime!, $lastWeekStartDate: DateTime!, $lastWeekEndDate: DateTime!, $lastMonthStartDate: DateTime!, $lastMonthEndDate: DateTime!) {
  yesterday: detectorVehicleVolumeCount(
    query: {detectorId: $detectorId, startDateTime: $yesterdayStartDate, endDateTime: $yesterdayEndDate}
  )
  lastWeek: detectorVehicleVolumeCount(
    query: {detectorId: $detectorId, startDateTime: $lastWeekStartDate, endDateTime: $lastWeekEndDate}
  )
  lastMonth: detectorVehicleVolumeCount(
    query: {detectorId: $detectorId, startDateTime: $lastMonthStartDate, endDateTime: $lastMonthEndDate}
  )
}
    `;

/**
 * __useDetectorMiniViewCountsQuery__
 *
 * To run a query within a React component, call `useDetectorMiniViewCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorMiniViewCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorMiniViewCountsQuery({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      yesterdayStartDate: // value for 'yesterdayStartDate'
 *      yesterdayEndDate: // value for 'yesterdayEndDate'
 *      lastWeekStartDate: // value for 'lastWeekStartDate'
 *      lastWeekEndDate: // value for 'lastWeekEndDate'
 *      lastMonthStartDate: // value for 'lastMonthStartDate'
 *      lastMonthEndDate: // value for 'lastMonthEndDate'
 *   },
 * });
 */
export function useDetectorMiniViewCountsQuery(baseOptions: Apollo.QueryHookOptions<DetectorMiniViewCountsQuery, DetectorMiniViewCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorMiniViewCountsQuery, DetectorMiniViewCountsQueryVariables>(DetectorMiniViewCountsDocument, options);
      }
export function useDetectorMiniViewCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorMiniViewCountsQuery, DetectorMiniViewCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorMiniViewCountsQuery, DetectorMiniViewCountsQueryVariables>(DetectorMiniViewCountsDocument, options);
        }
export type DetectorMiniViewCountsQueryHookResult = ReturnType<typeof useDetectorMiniViewCountsQuery>;
export type DetectorMiniViewCountsLazyQueryHookResult = ReturnType<typeof useDetectorMiniViewCountsLazyQuery>;
export type DetectorMiniViewCountsQueryResult = Apollo.QueryResult<DetectorMiniViewCountsQuery, DetectorMiniViewCountsQueryVariables>;
export function refetchDetectorMiniViewCountsQuery(variables: DetectorMiniViewCountsQueryVariables) {
      return { query: DetectorMiniViewCountsDocument, variables: variables }
    }
export const DetectorVehiclesVolumeDocument = gql`
    query DetectorVehiclesVolume($query: DetectorVehicleVolumeQuery) {
  detectorVehicleVolume(query: $query) {
    name
    volumeInfo {
      volume
      timestamp
    }
  }
}
    `;

/**
 * __useDetectorVehiclesVolumeQuery__
 *
 * To run a query within a React component, call `useDetectorVehiclesVolumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehiclesVolumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehiclesVolumeQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDetectorVehiclesVolumeQuery(baseOptions?: Apollo.QueryHookOptions<DetectorVehiclesVolumeQuery, DetectorVehiclesVolumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehiclesVolumeQuery, DetectorVehiclesVolumeQueryVariables>(DetectorVehiclesVolumeDocument, options);
      }
export function useDetectorVehiclesVolumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehiclesVolumeQuery, DetectorVehiclesVolumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehiclesVolumeQuery, DetectorVehiclesVolumeQueryVariables>(DetectorVehiclesVolumeDocument, options);
        }
export type DetectorVehiclesVolumeQueryHookResult = ReturnType<typeof useDetectorVehiclesVolumeQuery>;
export type DetectorVehiclesVolumeLazyQueryHookResult = ReturnType<typeof useDetectorVehiclesVolumeLazyQuery>;
export type DetectorVehiclesVolumeQueryResult = Apollo.QueryResult<DetectorVehiclesVolumeQuery, DetectorVehiclesVolumeQueryVariables>;
export function refetchDetectorVehiclesVolumeQuery(variables?: DetectorVehiclesVolumeQueryVariables) {
      return { query: DetectorVehiclesVolumeDocument, variables: variables }
    }
export const DetectorVehiclesYearlySummaryDocument = gql`
    query DetectorVehiclesYearlySummary($detectorId: ID!, $startDateTime: DateTime, $endDateTime: DateTime, $viewType: DateViewType) {
  detectorVehicleYearlySummary(
    query: {detectorId: $detectorId, startDateTime: $startDateTime, endDateTime: $endDateTime, viewType: $viewType}
  ) {
    year
    averageSpeed
    averageSpeedAt85Percent
    averageDailyTraffic
  }
}
    `;

/**
 * __useDetectorVehiclesYearlySummaryQuery__
 *
 * To run a query within a React component, call `useDetectorVehiclesYearlySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehiclesYearlySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehiclesYearlySummaryQuery({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useDetectorVehiclesYearlySummaryQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehiclesYearlySummaryQuery, DetectorVehiclesYearlySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehiclesYearlySummaryQuery, DetectorVehiclesYearlySummaryQueryVariables>(DetectorVehiclesYearlySummaryDocument, options);
      }
export function useDetectorVehiclesYearlySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehiclesYearlySummaryQuery, DetectorVehiclesYearlySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehiclesYearlySummaryQuery, DetectorVehiclesYearlySummaryQueryVariables>(DetectorVehiclesYearlySummaryDocument, options);
        }
export type DetectorVehiclesYearlySummaryQueryHookResult = ReturnType<typeof useDetectorVehiclesYearlySummaryQuery>;
export type DetectorVehiclesYearlySummaryLazyQueryHookResult = ReturnType<typeof useDetectorVehiclesYearlySummaryLazyQuery>;
export type DetectorVehiclesYearlySummaryQueryResult = Apollo.QueryResult<DetectorVehiclesYearlySummaryQuery, DetectorVehiclesYearlySummaryQueryVariables>;
export function refetchDetectorVehiclesYearlySummaryQuery(variables: DetectorVehiclesYearlySummaryQueryVariables) {
      return { query: DetectorVehiclesYearlySummaryDocument, variables: variables }
    }
export const DetectorVehiclesVolumeGroupCountsDocument = gql`
    query detectorVehiclesVolumeGroupCounts($detectorId: ID!, $startDateTime: DateTime!, $endDateTime: DateTime!, $groupBy: DetectorVehicleVolumeGroup) {
  detectorVehicleVolumeGroupCounts(
    query: {detectorId: $detectorId, startDateTime: $startDateTime, endDateTime: $endDateTime, groupBy: $groupBy}
  ) {
    name
    count
  }
}
    `;

/**
 * __useDetectorVehiclesVolumeGroupCountsQuery__
 *
 * To run a query within a React component, call `useDetectorVehiclesVolumeGroupCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehiclesVolumeGroupCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehiclesVolumeGroupCountsQuery({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useDetectorVehiclesVolumeGroupCountsQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehiclesVolumeGroupCountsQuery, DetectorVehiclesVolumeGroupCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehiclesVolumeGroupCountsQuery, DetectorVehiclesVolumeGroupCountsQueryVariables>(DetectorVehiclesVolumeGroupCountsDocument, options);
      }
export function useDetectorVehiclesVolumeGroupCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehiclesVolumeGroupCountsQuery, DetectorVehiclesVolumeGroupCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehiclesVolumeGroupCountsQuery, DetectorVehiclesVolumeGroupCountsQueryVariables>(DetectorVehiclesVolumeGroupCountsDocument, options);
        }
export type DetectorVehiclesVolumeGroupCountsQueryHookResult = ReturnType<typeof useDetectorVehiclesVolumeGroupCountsQuery>;
export type DetectorVehiclesVolumeGroupCountsLazyQueryHookResult = ReturnType<typeof useDetectorVehiclesVolumeGroupCountsLazyQuery>;
export type DetectorVehiclesVolumeGroupCountsQueryResult = Apollo.QueryResult<DetectorVehiclesVolumeGroupCountsQuery, DetectorVehiclesVolumeGroupCountsQueryVariables>;
export function refetchDetectorVehiclesVolumeGroupCountsQuery(variables: DetectorVehiclesVolumeGroupCountsQueryVariables) {
      return { query: DetectorVehiclesVolumeGroupCountsDocument, variables: variables }
    }
export const DetectorVehiclesDayWiseAvailabilityDocument = gql`
    query detectorVehiclesDayWiseAvailability($detectorIds: [ID!]!, $startDateTime: DateTime!, $endDateTime: DateTime!) {
  detectorVehicleDayWiseAvailability(
    query: {detectorIds: $detectorIds, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    id
    availability
  }
}
    `;

/**
 * __useDetectorVehiclesDayWiseAvailabilityQuery__
 *
 * To run a query within a React component, call `useDetectorVehiclesDayWiseAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehiclesDayWiseAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehiclesDayWiseAvailabilityQuery({
 *   variables: {
 *      detectorIds: // value for 'detectorIds'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorVehiclesDayWiseAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehiclesDayWiseAvailabilityQuery, DetectorVehiclesDayWiseAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehiclesDayWiseAvailabilityQuery, DetectorVehiclesDayWiseAvailabilityQueryVariables>(DetectorVehiclesDayWiseAvailabilityDocument, options);
      }
export function useDetectorVehiclesDayWiseAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehiclesDayWiseAvailabilityQuery, DetectorVehiclesDayWiseAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehiclesDayWiseAvailabilityQuery, DetectorVehiclesDayWiseAvailabilityQueryVariables>(DetectorVehiclesDayWiseAvailabilityDocument, options);
        }
export type DetectorVehiclesDayWiseAvailabilityQueryHookResult = ReturnType<typeof useDetectorVehiclesDayWiseAvailabilityQuery>;
export type DetectorVehiclesDayWiseAvailabilityLazyQueryHookResult = ReturnType<typeof useDetectorVehiclesDayWiseAvailabilityLazyQuery>;
export type DetectorVehiclesDayWiseAvailabilityQueryResult = Apollo.QueryResult<DetectorVehiclesDayWiseAvailabilityQuery, DetectorVehiclesDayWiseAvailabilityQueryVariables>;
export function refetchDetectorVehiclesDayWiseAvailabilityQuery(variables: DetectorVehiclesDayWiseAvailabilityQueryVariables) {
      return { query: DetectorVehiclesDayWiseAvailabilityDocument, variables: variables }
    }
export const DetectorVehicleDayWisePartialDataDocument = gql`
    query detectorVehicleDayWisePartialData($detectorIds: [ID!]!, $startDateTime: DateTime!, $endDateTime: DateTime!) {
  detectorVehicleDayWisePartialData(
    query: {detectorIds: $detectorIds, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    packetLossDate
    totalMissingRecordCount
    packetLossInfo {
      packetLossStartTime
      packetLossEndTime
      startSerial
      endSerial
      missingRecordsCount
    }
    __typename
  }
}
    `;

/**
 * __useDetectorVehicleDayWisePartialDataQuery__
 *
 * To run a query within a React component, call `useDetectorVehicleDayWisePartialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehicleDayWisePartialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehicleDayWisePartialDataQuery({
 *   variables: {
 *      detectorIds: // value for 'detectorIds'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorVehicleDayWisePartialDataQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehicleDayWisePartialDataQuery, DetectorVehicleDayWisePartialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehicleDayWisePartialDataQuery, DetectorVehicleDayWisePartialDataQueryVariables>(DetectorVehicleDayWisePartialDataDocument, options);
      }
export function useDetectorVehicleDayWisePartialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehicleDayWisePartialDataQuery, DetectorVehicleDayWisePartialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehicleDayWisePartialDataQuery, DetectorVehicleDayWisePartialDataQueryVariables>(DetectorVehicleDayWisePartialDataDocument, options);
        }
export type DetectorVehicleDayWisePartialDataQueryHookResult = ReturnType<typeof useDetectorVehicleDayWisePartialDataQuery>;
export type DetectorVehicleDayWisePartialDataLazyQueryHookResult = ReturnType<typeof useDetectorVehicleDayWisePartialDataLazyQuery>;
export type DetectorVehicleDayWisePartialDataQueryResult = Apollo.QueryResult<DetectorVehicleDayWisePartialDataQuery, DetectorVehicleDayWisePartialDataQueryVariables>;
export function refetchDetectorVehicleDayWisePartialDataQuery(variables: DetectorVehicleDayWisePartialDataQueryVariables) {
      return { query: DetectorVehicleDayWisePartialDataDocument, variables: variables }
    }
export const DetectorVehiclesVolumeIntervalCountsDocument = gql`
    query detectorVehiclesVolumeIntervalCounts($detectorIds: [ID!]!, $dateRanges: [DateRangeInput!]!, $groupBy: DetectorVehicleVolumeGroup, $viewType: DateViewType!, $granularity: DetectorVehicleVolumeGranularity) {
  detectorVehicleVolumeIntervalCounts(
    query: {detectorIds: $detectorIds, dateRanges: $dateRanges, groupBy: $groupBy, viewType: $viewType, granularity: $granularity}
  ) {
    date
    name
    lane
    laneDirection
    maneuver
    intervalList {
      count
      interval
      hour
      __typename
    }
    peaks {
      amPeakCount
      amPeakHour
      pmPeakCount
      pmPeakHour
      daytimeTotal
      daytimeAverage
      nightTimeTotal
      nightTimeAverage
      average
      total
      weekdayTotal
      weekdayAverage
      weekendTotal
      weekendAverage
      twelveHourTotal
      twelveHourAverage
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useDetectorVehiclesVolumeIntervalCountsQuery__
 *
 * To run a query within a React component, call `useDetectorVehiclesVolumeIntervalCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehiclesVolumeIntervalCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehiclesVolumeIntervalCountsQuery({
 *   variables: {
 *      detectorIds: // value for 'detectorIds'
 *      dateRanges: // value for 'dateRanges'
 *      groupBy: // value for 'groupBy'
 *      viewType: // value for 'viewType'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useDetectorVehiclesVolumeIntervalCountsQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehiclesVolumeIntervalCountsQuery, DetectorVehiclesVolumeIntervalCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehiclesVolumeIntervalCountsQuery, DetectorVehiclesVolumeIntervalCountsQueryVariables>(DetectorVehiclesVolumeIntervalCountsDocument, options);
      }
export function useDetectorVehiclesVolumeIntervalCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehiclesVolumeIntervalCountsQuery, DetectorVehiclesVolumeIntervalCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehiclesVolumeIntervalCountsQuery, DetectorVehiclesVolumeIntervalCountsQueryVariables>(DetectorVehiclesVolumeIntervalCountsDocument, options);
        }
export type DetectorVehiclesVolumeIntervalCountsQueryHookResult = ReturnType<typeof useDetectorVehiclesVolumeIntervalCountsQuery>;
export type DetectorVehiclesVolumeIntervalCountsLazyQueryHookResult = ReturnType<typeof useDetectorVehiclesVolumeIntervalCountsLazyQuery>;
export type DetectorVehiclesVolumeIntervalCountsQueryResult = Apollo.QueryResult<DetectorVehiclesVolumeIntervalCountsQuery, DetectorVehiclesVolumeIntervalCountsQueryVariables>;
export function refetchDetectorVehiclesVolumeIntervalCountsQuery(variables: DetectorVehiclesVolumeIntervalCountsQueryVariables) {
      return { query: DetectorVehiclesVolumeIntervalCountsDocument, variables: variables }
    }
export const DetectorsSummaryDocument = gql`
    query DetectorsSummary {
  operational: detectors(
    query: {filters: [{operator: IN, field: "state.currentState.communicationState", value: [OPERATIONAL]}]}
  ) {
    totalCount
  }
  nonoperational: detectors(
    query: {filters: [{operator: IN, field: "state.currentState.communicationState", value: [OPERATIONAL_WITH_ERROR, FAILED, NO_DATA, SUSPECT]}]}
  ) {
    totalCount
  }
  warning: detectors(
    query: {filters: [{operator: IN, field: "state.currentState.communicationState", value: [OPERATIONAL_WITH_WARNING]}]}
  ) {
    totalCount
  }
  disabled: detectors(
    query: {filters: [{operator: IN, field: "state.currentState.communicationState", value: [DISABLED]}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useDetectorsSummaryQuery__
 *
 * To run a query within a React component, call `useDetectorsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<DetectorsSummaryQuery, DetectorsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorsSummaryQuery, DetectorsSummaryQueryVariables>(DetectorsSummaryDocument, options);
      }
export function useDetectorsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorsSummaryQuery, DetectorsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorsSummaryQuery, DetectorsSummaryQueryVariables>(DetectorsSummaryDocument, options);
        }
export type DetectorsSummaryQueryHookResult = ReturnType<typeof useDetectorsSummaryQuery>;
export type DetectorsSummaryLazyQueryHookResult = ReturnType<typeof useDetectorsSummaryLazyQuery>;
export type DetectorsSummaryQueryResult = Apollo.QueryResult<DetectorsSummaryQuery, DetectorsSummaryQueryVariables>;
export function refetchDetectorsSummaryQuery(variables?: DetectorsSummaryQueryVariables) {
      return { query: DetectorsSummaryDocument, variables: variables }
    }
export const DetectorConnectionLogsDocument = gql`
    query DetectorConnectionLogs($after: String, $before: String, $detectorId: ID!, $limit: Int = 100, $filters: [FilterInput], $startDateTime: DateTime, $endDateTime: DateTime) {
  detectorConnectionLogs(
    query: {after: $after, before: $before, detectorId: $detectorId, limit: $limit, filters: $filters, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    edges {
      node {
        ...DetectorConnectionLogListNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectorConnectionLogListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorConnectionLogsQuery__
 *
 * To run a query within a React component, call `useDetectorConnectionLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorConnectionLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorConnectionLogsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      detectorId: // value for 'detectorId'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorConnectionLogsQuery(baseOptions: Apollo.QueryHookOptions<DetectorConnectionLogsQuery, DetectorConnectionLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorConnectionLogsQuery, DetectorConnectionLogsQueryVariables>(DetectorConnectionLogsDocument, options);
      }
export function useDetectorConnectionLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorConnectionLogsQuery, DetectorConnectionLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorConnectionLogsQuery, DetectorConnectionLogsQueryVariables>(DetectorConnectionLogsDocument, options);
        }
export type DetectorConnectionLogsQueryHookResult = ReturnType<typeof useDetectorConnectionLogsQuery>;
export type DetectorConnectionLogsLazyQueryHookResult = ReturnType<typeof useDetectorConnectionLogsLazyQuery>;
export type DetectorConnectionLogsQueryResult = Apollo.QueryResult<DetectorConnectionLogsQuery, DetectorConnectionLogsQueryVariables>;
export function refetchDetectorConnectionLogsQuery(variables: DetectorConnectionLogsQueryVariables) {
      return { query: DetectorConnectionLogsDocument, variables: variables }
    }
export const DetectorConnectionLogDetailDocument = gql`
    query DetectorConnectionLogDetail($after: String, $before: String, $connectionId: ID!, $limit: Int = 1000, $filters: [FilterInput], $startDateTime: DateTime, $endDateTime: DateTime) {
  detectorConnectionLogDetails(
    query: {after: $after, before: $before, connectionId: $connectionId, limit: $limit, filters: $filters, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    edges {
      node {
        ...DetectorConnectionLogFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectorConnectionLogFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorConnectionLogDetailQuery__
 *
 * To run a query within a React component, call `useDetectorConnectionLogDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorConnectionLogDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorConnectionLogDetailQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      connectionId: // value for 'connectionId'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorConnectionLogDetailQuery(baseOptions: Apollo.QueryHookOptions<DetectorConnectionLogDetailQuery, DetectorConnectionLogDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorConnectionLogDetailQuery, DetectorConnectionLogDetailQueryVariables>(DetectorConnectionLogDetailDocument, options);
      }
export function useDetectorConnectionLogDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorConnectionLogDetailQuery, DetectorConnectionLogDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorConnectionLogDetailQuery, DetectorConnectionLogDetailQueryVariables>(DetectorConnectionLogDetailDocument, options);
        }
export type DetectorConnectionLogDetailQueryHookResult = ReturnType<typeof useDetectorConnectionLogDetailQuery>;
export type DetectorConnectionLogDetailLazyQueryHookResult = ReturnType<typeof useDetectorConnectionLogDetailLazyQuery>;
export type DetectorConnectionLogDetailQueryResult = Apollo.QueryResult<DetectorConnectionLogDetailQuery, DetectorConnectionLogDetailQueryVariables>;
export function refetchDetectorConnectionLogDetailQuery(variables: DetectorConnectionLogDetailQueryVariables) {
      return { query: DetectorConnectionLogDetailDocument, variables: variables }
    }
export const DetectorWeatherQueryDocument = gql`
    query DetectorWeatherQuery($detectorId: ID!, $startDateTime: DateTime!, $endDateTime: DateTime!) {
  detectorWeather(
    query: {detectorId: $detectorId, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    ...DetectorWeatherListNodeFragment
  }
}
    ${DetectorWeatherListNodeFragmentFragmentDoc}`;

/**
 * __useDetectorWeatherQueryQuery__
 *
 * To run a query within a React component, call `useDetectorWeatherQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorWeatherQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorWeatherQueryQuery({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorWeatherQueryQuery(baseOptions: Apollo.QueryHookOptions<DetectorWeatherQueryQuery, DetectorWeatherQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorWeatherQueryQuery, DetectorWeatherQueryQueryVariables>(DetectorWeatherQueryDocument, options);
      }
export function useDetectorWeatherQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorWeatherQueryQuery, DetectorWeatherQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorWeatherQueryQuery, DetectorWeatherQueryQueryVariables>(DetectorWeatherQueryDocument, options);
        }
export type DetectorWeatherQueryQueryHookResult = ReturnType<typeof useDetectorWeatherQueryQuery>;
export type DetectorWeatherQueryLazyQueryHookResult = ReturnType<typeof useDetectorWeatherQueryLazyQuery>;
export type DetectorWeatherQueryQueryResult = Apollo.QueryResult<DetectorWeatherQueryQuery, DetectorWeatherQueryQueryVariables>;
export function refetchDetectorWeatherQueryQuery(variables: DetectorWeatherQueryQueryVariables) {
      return { query: DetectorWeatherQueryDocument, variables: variables }
    }
export const DetectorEmailAlertTypesDocument = gql`
    query DetectorEmailAlertTypes {
  detectorEmailAlertTypes {
    code
    label
  }
}
    `;

/**
 * __useDetectorEmailAlertTypesQuery__
 *
 * To run a query within a React component, call `useDetectorEmailAlertTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorEmailAlertTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorEmailAlertTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorEmailAlertTypesQuery(baseOptions?: Apollo.QueryHookOptions<DetectorEmailAlertTypesQuery, DetectorEmailAlertTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorEmailAlertTypesQuery, DetectorEmailAlertTypesQueryVariables>(DetectorEmailAlertTypesDocument, options);
      }
export function useDetectorEmailAlertTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorEmailAlertTypesQuery, DetectorEmailAlertTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorEmailAlertTypesQuery, DetectorEmailAlertTypesQueryVariables>(DetectorEmailAlertTypesDocument, options);
        }
export type DetectorEmailAlertTypesQueryHookResult = ReturnType<typeof useDetectorEmailAlertTypesQuery>;
export type DetectorEmailAlertTypesLazyQueryHookResult = ReturnType<typeof useDetectorEmailAlertTypesLazyQuery>;
export type DetectorEmailAlertTypesQueryResult = Apollo.QueryResult<DetectorEmailAlertTypesQuery, DetectorEmailAlertTypesQueryVariables>;
export function refetchDetectorEmailAlertTypesQuery(variables?: DetectorEmailAlertTypesQueryVariables) {
      return { query: DetectorEmailAlertTypesDocument, variables: variables }
    }
export const DetectorEmailAlertSubtypesDocument = gql`
    query DetectorEmailAlertSubtypes {
  detectorEmailAlertSubtypes {
    code
    label
    type
  }
}
    `;

/**
 * __useDetectorEmailAlertSubtypesQuery__
 *
 * To run a query within a React component, call `useDetectorEmailAlertSubtypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorEmailAlertSubtypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorEmailAlertSubtypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorEmailAlertSubtypesQuery(baseOptions?: Apollo.QueryHookOptions<DetectorEmailAlertSubtypesQuery, DetectorEmailAlertSubtypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorEmailAlertSubtypesQuery, DetectorEmailAlertSubtypesQueryVariables>(DetectorEmailAlertSubtypesDocument, options);
      }
export function useDetectorEmailAlertSubtypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorEmailAlertSubtypesQuery, DetectorEmailAlertSubtypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorEmailAlertSubtypesQuery, DetectorEmailAlertSubtypesQueryVariables>(DetectorEmailAlertSubtypesDocument, options);
        }
export type DetectorEmailAlertSubtypesQueryHookResult = ReturnType<typeof useDetectorEmailAlertSubtypesQuery>;
export type DetectorEmailAlertSubtypesLazyQueryHookResult = ReturnType<typeof useDetectorEmailAlertSubtypesLazyQuery>;
export type DetectorEmailAlertSubtypesQueryResult = Apollo.QueryResult<DetectorEmailAlertSubtypesQuery, DetectorEmailAlertSubtypesQueryVariables>;
export function refetchDetectorEmailAlertSubtypesQuery(variables?: DetectorEmailAlertSubtypesQueryVariables) {
      return { query: DetectorEmailAlertSubtypesDocument, variables: variables }
    }
export const DetectorEmailAlertFrequenciesDocument = gql`
    query DetectorEmailAlertFrequencies {
  detectorEmailAlertFrequencies {
    code
    label
    types
  }
}
    `;

/**
 * __useDetectorEmailAlertFrequenciesQuery__
 *
 * To run a query within a React component, call `useDetectorEmailAlertFrequenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorEmailAlertFrequenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorEmailAlertFrequenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorEmailAlertFrequenciesQuery(baseOptions?: Apollo.QueryHookOptions<DetectorEmailAlertFrequenciesQuery, DetectorEmailAlertFrequenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorEmailAlertFrequenciesQuery, DetectorEmailAlertFrequenciesQueryVariables>(DetectorEmailAlertFrequenciesDocument, options);
      }
export function useDetectorEmailAlertFrequenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorEmailAlertFrequenciesQuery, DetectorEmailAlertFrequenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorEmailAlertFrequenciesQuery, DetectorEmailAlertFrequenciesQueryVariables>(DetectorEmailAlertFrequenciesDocument, options);
        }
export type DetectorEmailAlertFrequenciesQueryHookResult = ReturnType<typeof useDetectorEmailAlertFrequenciesQuery>;
export type DetectorEmailAlertFrequenciesLazyQueryHookResult = ReturnType<typeof useDetectorEmailAlertFrequenciesLazyQuery>;
export type DetectorEmailAlertFrequenciesQueryResult = Apollo.QueryResult<DetectorEmailAlertFrequenciesQuery, DetectorEmailAlertFrequenciesQueryVariables>;
export function refetchDetectorEmailAlertFrequenciesQuery(variables?: DetectorEmailAlertFrequenciesQueryVariables) {
      return { query: DetectorEmailAlertFrequenciesDocument, variables: variables }
    }
export const DetectorEmailAlertSettingsDocument = gql`
    query DetectorEmailAlertSettings($after: String, $before: String, $limit: Int = 100, $sortField: String = "type", $sortOrder: SortOrder = ASCENDING, $searchText: String, $searchFields: [String!] = ["type"], $filters: [FilterInput]) {
  detectorEmailAlertSettings(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, searchFields: $searchFields, filters: $filters}
  ) {
    edges {
      node {
        ...DetectorEmailAlertSettingFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectorEmailAlertSettingFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorEmailAlertSettingsQuery__
 *
 * To run a query within a React component, call `useDetectorEmailAlertSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorEmailAlertSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorEmailAlertSettingsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDetectorEmailAlertSettingsQuery(baseOptions?: Apollo.QueryHookOptions<DetectorEmailAlertSettingsQuery, DetectorEmailAlertSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorEmailAlertSettingsQuery, DetectorEmailAlertSettingsQueryVariables>(DetectorEmailAlertSettingsDocument, options);
      }
export function useDetectorEmailAlertSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorEmailAlertSettingsQuery, DetectorEmailAlertSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorEmailAlertSettingsQuery, DetectorEmailAlertSettingsQueryVariables>(DetectorEmailAlertSettingsDocument, options);
        }
export type DetectorEmailAlertSettingsQueryHookResult = ReturnType<typeof useDetectorEmailAlertSettingsQuery>;
export type DetectorEmailAlertSettingsLazyQueryHookResult = ReturnType<typeof useDetectorEmailAlertSettingsLazyQuery>;
export type DetectorEmailAlertSettingsQueryResult = Apollo.QueryResult<DetectorEmailAlertSettingsQuery, DetectorEmailAlertSettingsQueryVariables>;
export function refetchDetectorEmailAlertSettingsQuery(variables?: DetectorEmailAlertSettingsQueryVariables) {
      return { query: DetectorEmailAlertSettingsDocument, variables: variables }
    }
export const DetectorEmailAlertSettingDetailDocument = gql`
    query DetectorEmailAlertSettingDetail($id: String) {
  detectorEmailAlertSetting(id: $id) {
    ...DetectorEmailAlertSettingFragment
  }
}
    ${DetectorEmailAlertSettingFragmentFragmentDoc}`;

/**
 * __useDetectorEmailAlertSettingDetailQuery__
 *
 * To run a query within a React component, call `useDetectorEmailAlertSettingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorEmailAlertSettingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorEmailAlertSettingDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectorEmailAlertSettingDetailQuery(baseOptions?: Apollo.QueryHookOptions<DetectorEmailAlertSettingDetailQuery, DetectorEmailAlertSettingDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorEmailAlertSettingDetailQuery, DetectorEmailAlertSettingDetailQueryVariables>(DetectorEmailAlertSettingDetailDocument, options);
      }
export function useDetectorEmailAlertSettingDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorEmailAlertSettingDetailQuery, DetectorEmailAlertSettingDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorEmailAlertSettingDetailQuery, DetectorEmailAlertSettingDetailQueryVariables>(DetectorEmailAlertSettingDetailDocument, options);
        }
export type DetectorEmailAlertSettingDetailQueryHookResult = ReturnType<typeof useDetectorEmailAlertSettingDetailQuery>;
export type DetectorEmailAlertSettingDetailLazyQueryHookResult = ReturnType<typeof useDetectorEmailAlertSettingDetailLazyQuery>;
export type DetectorEmailAlertSettingDetailQueryResult = Apollo.QueryResult<DetectorEmailAlertSettingDetailQuery, DetectorEmailAlertSettingDetailQueryVariables>;
export function refetchDetectorEmailAlertSettingDetailQuery(variables?: DetectorEmailAlertSettingDetailQueryVariables) {
      return { query: DetectorEmailAlertSettingDetailDocument, variables: variables }
    }
export const GetUserWithPrivilegesDocument = gql`
    query GetUserWithPrivileges($after: String, $before: String, $limit: Int = 10, $sortField: String, $sortOrder: SortOrder, $searchText: String) {
  users(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
  ) {
    edges {
      node {
        ...KineticUserFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${KineticUserFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useGetUserWithPrivilegesQuery__
 *
 * To run a query within a React component, call `useGetUserWithPrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithPrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithPrivilegesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetUserWithPrivilegesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWithPrivilegesQuery, GetUserWithPrivilegesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithPrivilegesQuery, GetUserWithPrivilegesQueryVariables>(GetUserWithPrivilegesDocument, options);
      }
export function useGetUserWithPrivilegesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithPrivilegesQuery, GetUserWithPrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithPrivilegesQuery, GetUserWithPrivilegesQueryVariables>(GetUserWithPrivilegesDocument, options);
        }
export type GetUserWithPrivilegesQueryHookResult = ReturnType<typeof useGetUserWithPrivilegesQuery>;
export type GetUserWithPrivilegesLazyQueryHookResult = ReturnType<typeof useGetUserWithPrivilegesLazyQuery>;
export type GetUserWithPrivilegesQueryResult = Apollo.QueryResult<GetUserWithPrivilegesQuery, GetUserWithPrivilegesQueryVariables>;
export function refetchGetUserWithPrivilegesQuery(variables?: GetUserWithPrivilegesQueryVariables) {
      return { query: GetUserWithPrivilegesDocument, variables: variables }
    }
export const DetectorPerformanceReportsDocument = gql`
    query DetectorPerformanceReports($ruleId: ID!, $detectorIds: [ID!]!, $startDateTime: Date!, $endDateTime: Date!) {
  detectorPerformanceReport(
    query: {ruleId: $ruleId, detectorIds: $detectorIds, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    ...DetectorPerformanceReportResultFragment
  }
}
    ${DetectorPerformanceReportResultFragmentFragmentDoc}`;

/**
 * __useDetectorPerformanceReportsQuery__
 *
 * To run a query within a React component, call `useDetectorPerformanceReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorPerformanceReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorPerformanceReportsQuery({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *      detectorIds: // value for 'detectorIds'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorPerformanceReportsQuery(baseOptions: Apollo.QueryHookOptions<DetectorPerformanceReportsQuery, DetectorPerformanceReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorPerformanceReportsQuery, DetectorPerformanceReportsQueryVariables>(DetectorPerformanceReportsDocument, options);
      }
export function useDetectorPerformanceReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorPerformanceReportsQuery, DetectorPerformanceReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorPerformanceReportsQuery, DetectorPerformanceReportsQueryVariables>(DetectorPerformanceReportsDocument, options);
        }
export type DetectorPerformanceReportsQueryHookResult = ReturnType<typeof useDetectorPerformanceReportsQuery>;
export type DetectorPerformanceReportsLazyQueryHookResult = ReturnType<typeof useDetectorPerformanceReportsLazyQuery>;
export type DetectorPerformanceReportsQueryResult = Apollo.QueryResult<DetectorPerformanceReportsQuery, DetectorPerformanceReportsQueryVariables>;
export function refetchDetectorPerformanceReportsQuery(variables: DetectorPerformanceReportsQueryVariables) {
      return { query: DetectorPerformanceReportsDocument, variables: variables }
    }
export const DetectorReportConfigurationDocument = gql`
    query DetectorReportConfiguration($after: String, $before: String, $limit: Int = 10, $sortField: String, $sortOrder: SortOrder = ASCENDING, $searchText: String, $searchFields: [String!] = ["name", "description"], $filters: [FilterInput]) {
  detectorReportConfigurations(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
    searchFields: $searchFields
    filters: $filters
  ) {
    edges {
      cursor
      node {
        ...DetectorReportConfigurationFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectorReportConfigurationFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorReportConfigurationQuery__
 *
 * To run a query within a React component, call `useDetectorReportConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorReportConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorReportConfigurationQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDetectorReportConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<DetectorReportConfigurationQuery, DetectorReportConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorReportConfigurationQuery, DetectorReportConfigurationQueryVariables>(DetectorReportConfigurationDocument, options);
      }
export function useDetectorReportConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorReportConfigurationQuery, DetectorReportConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorReportConfigurationQuery, DetectorReportConfigurationQueryVariables>(DetectorReportConfigurationDocument, options);
        }
export type DetectorReportConfigurationQueryHookResult = ReturnType<typeof useDetectorReportConfigurationQuery>;
export type DetectorReportConfigurationLazyQueryHookResult = ReturnType<typeof useDetectorReportConfigurationLazyQuery>;
export type DetectorReportConfigurationQueryResult = Apollo.QueryResult<DetectorReportConfigurationQuery, DetectorReportConfigurationQueryVariables>;
export function refetchDetectorReportConfigurationQuery(variables?: DetectorReportConfigurationQueryVariables) {
      return { query: DetectorReportConfigurationDocument, variables: variables }
    }
export const DetectorReportRulesDocument = gql`
    query DetectorReportRules($enabled: Boolean, $after: String, $before: String, $limit: Int = 10, $sortField: String = "id", $sortOrder: SortOrder = ASCENDING, $searchText: String, $searchFields: [String!] = ["name", "template"], $filters: [FilterInput], $template: DetectorReportTemplate) {
  detectorReportRules(
    enabled: $enabled
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
    searchFields: $searchFields
    filters: $filters
    template: $template
  ) {
    edges {
      cursor
      node {
        ...DetectorReportRuleFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectorReportRuleFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorReportRulesQuery__
 *
 * To run a query within a React component, call `useDetectorReportRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorReportRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorReportRulesQuery({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *      template: // value for 'template'
 *   },
 * });
 */
export function useDetectorReportRulesQuery(baseOptions?: Apollo.QueryHookOptions<DetectorReportRulesQuery, DetectorReportRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorReportRulesQuery, DetectorReportRulesQueryVariables>(DetectorReportRulesDocument, options);
      }
export function useDetectorReportRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorReportRulesQuery, DetectorReportRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorReportRulesQuery, DetectorReportRulesQueryVariables>(DetectorReportRulesDocument, options);
        }
export type DetectorReportRulesQueryHookResult = ReturnType<typeof useDetectorReportRulesQuery>;
export type DetectorReportRulesLazyQueryHookResult = ReturnType<typeof useDetectorReportRulesLazyQuery>;
export type DetectorReportRulesQueryResult = Apollo.QueryResult<DetectorReportRulesQuery, DetectorReportRulesQueryVariables>;
export function refetchDetectorReportRulesQuery(variables?: DetectorReportRulesQueryVariables) {
      return { query: DetectorReportRulesDocument, variables: variables }
    }
export const DetectorPerformanceReportAvailabilitysDocument = gql`
    query DetectorPerformanceReportAvailabilitys($ruleIds: [ID!]!, $detectorIds: [ID!]!, $startDateTime: Date!, $endDateTime: Date!) {
  detectorPerformanceReportAvailability(
    query: {ruleIds: $ruleIds, detectorIds: $detectorIds, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    ...DetectorPerformanceReportDayWiseAvailabilityInfoFragment
  }
}
    ${DetectorPerformanceReportDayWiseAvailabilityInfoFragmentFragmentDoc}`;

/**
 * __useDetectorPerformanceReportAvailabilitysQuery__
 *
 * To run a query within a React component, call `useDetectorPerformanceReportAvailabilitysQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorPerformanceReportAvailabilitysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorPerformanceReportAvailabilitysQuery({
 *   variables: {
 *      ruleIds: // value for 'ruleIds'
 *      detectorIds: // value for 'detectorIds'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorPerformanceReportAvailabilitysQuery(baseOptions: Apollo.QueryHookOptions<DetectorPerformanceReportAvailabilitysQuery, DetectorPerformanceReportAvailabilitysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorPerformanceReportAvailabilitysQuery, DetectorPerformanceReportAvailabilitysQueryVariables>(DetectorPerformanceReportAvailabilitysDocument, options);
      }
export function useDetectorPerformanceReportAvailabilitysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorPerformanceReportAvailabilitysQuery, DetectorPerformanceReportAvailabilitysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorPerformanceReportAvailabilitysQuery, DetectorPerformanceReportAvailabilitysQueryVariables>(DetectorPerformanceReportAvailabilitysDocument, options);
        }
export type DetectorPerformanceReportAvailabilitysQueryHookResult = ReturnType<typeof useDetectorPerformanceReportAvailabilitysQuery>;
export type DetectorPerformanceReportAvailabilitysLazyQueryHookResult = ReturnType<typeof useDetectorPerformanceReportAvailabilitysLazyQuery>;
export type DetectorPerformanceReportAvailabilitysQueryResult = Apollo.QueryResult<DetectorPerformanceReportAvailabilitysQuery, DetectorPerformanceReportAvailabilitysQueryVariables>;
export function refetchDetectorPerformanceReportAvailabilitysQuery(variables: DetectorPerformanceReportAvailabilitysQueryVariables) {
      return { query: DetectorPerformanceReportAvailabilitysDocument, variables: variables }
    }
export const DetectorReportConfigurationDetailDocument = gql`
    query DetectorReportConfigurationDetail($id: ID!) {
  detectorReportConfiguration(id: $id) {
    ...DetectorReportConfigurationFragment
  }
}
    ${DetectorReportConfigurationFragmentFragmentDoc}`;

/**
 * __useDetectorReportConfigurationDetailQuery__
 *
 * To run a query within a React component, call `useDetectorReportConfigurationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorReportConfigurationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorReportConfigurationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectorReportConfigurationDetailQuery(baseOptions: Apollo.QueryHookOptions<DetectorReportConfigurationDetailQuery, DetectorReportConfigurationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorReportConfigurationDetailQuery, DetectorReportConfigurationDetailQueryVariables>(DetectorReportConfigurationDetailDocument, options);
      }
export function useDetectorReportConfigurationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorReportConfigurationDetailQuery, DetectorReportConfigurationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorReportConfigurationDetailQuery, DetectorReportConfigurationDetailQueryVariables>(DetectorReportConfigurationDetailDocument, options);
        }
export type DetectorReportConfigurationDetailQueryHookResult = ReturnType<typeof useDetectorReportConfigurationDetailQuery>;
export type DetectorReportConfigurationDetailLazyQueryHookResult = ReturnType<typeof useDetectorReportConfigurationDetailLazyQuery>;
export type DetectorReportConfigurationDetailQueryResult = Apollo.QueryResult<DetectorReportConfigurationDetailQuery, DetectorReportConfigurationDetailQueryVariables>;
export function refetchDetectorReportConfigurationDetailQuery(variables: DetectorReportConfigurationDetailQueryVariables) {
      return { query: DetectorReportConfigurationDetailDocument, variables: variables }
    }
export const DetectorReportTemplateOptionsDocument = gql`
    query detectorReportTemplateOptions {
  detectorReportTemplateOptions {
    code
    label
  }
}
    `;

/**
 * __useDetectorReportTemplateOptionsQuery__
 *
 * To run a query within a React component, call `useDetectorReportTemplateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorReportTemplateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorReportTemplateOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorReportTemplateOptionsQuery(baseOptions?: Apollo.QueryHookOptions<DetectorReportTemplateOptionsQuery, DetectorReportTemplateOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorReportTemplateOptionsQuery, DetectorReportTemplateOptionsQueryVariables>(DetectorReportTemplateOptionsDocument, options);
      }
export function useDetectorReportTemplateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorReportTemplateOptionsQuery, DetectorReportTemplateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorReportTemplateOptionsQuery, DetectorReportTemplateOptionsQueryVariables>(DetectorReportTemplateOptionsDocument, options);
        }
export type DetectorReportTemplateOptionsQueryHookResult = ReturnType<typeof useDetectorReportTemplateOptionsQuery>;
export type DetectorReportTemplateOptionsLazyQueryHookResult = ReturnType<typeof useDetectorReportTemplateOptionsLazyQuery>;
export type DetectorReportTemplateOptionsQueryResult = Apollo.QueryResult<DetectorReportTemplateOptionsQuery, DetectorReportTemplateOptionsQueryVariables>;
export function refetchDetectorReportTemplateOptionsQuery(variables?: DetectorReportTemplateOptionsQueryVariables) {
      return { query: DetectorReportTemplateOptionsDocument, variables: variables }
    }
export const DetectorReportFormDocument = gql`
    query DetectorReportForm($reportTemplate: DetectorReportTemplate) {
  detectorReportForm(reportTemplate: $reportTemplate) {
    ...Form
  }
}
    ${FormFragmentDoc}`;

/**
 * __useDetectorReportFormQuery__
 *
 * To run a query within a React component, call `useDetectorReportFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorReportFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorReportFormQuery({
 *   variables: {
 *      reportTemplate: // value for 'reportTemplate'
 *   },
 * });
 */
export function useDetectorReportFormQuery(baseOptions?: Apollo.QueryHookOptions<DetectorReportFormQuery, DetectorReportFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorReportFormQuery, DetectorReportFormQueryVariables>(DetectorReportFormDocument, options);
      }
export function useDetectorReportFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorReportFormQuery, DetectorReportFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorReportFormQuery, DetectorReportFormQueryVariables>(DetectorReportFormDocument, options);
        }
export type DetectorReportFormQueryHookResult = ReturnType<typeof useDetectorReportFormQuery>;
export type DetectorReportFormLazyQueryHookResult = ReturnType<typeof useDetectorReportFormLazyQuery>;
export type DetectorReportFormQueryResult = Apollo.QueryResult<DetectorReportFormQuery, DetectorReportFormQueryVariables>;
export function refetchDetectorReportFormQuery(variables?: DetectorReportFormQueryVariables) {
      return { query: DetectorReportFormDocument, variables: variables }
    }
export const DetectorReportFormQueryConfigDocument = gql`
    query DetectorReportFormQueryConfig($reportTemplate: DetectorReportTemplate) {
  detectorReportFormQueryConfig(reportTemplate: $reportTemplate)
}
    `;

/**
 * __useDetectorReportFormQueryConfigQuery__
 *
 * To run a query within a React component, call `useDetectorReportFormQueryConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorReportFormQueryConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorReportFormQueryConfigQuery({
 *   variables: {
 *      reportTemplate: // value for 'reportTemplate'
 *   },
 * });
 */
export function useDetectorReportFormQueryConfigQuery(baseOptions?: Apollo.QueryHookOptions<DetectorReportFormQueryConfigQuery, DetectorReportFormQueryConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorReportFormQueryConfigQuery, DetectorReportFormQueryConfigQueryVariables>(DetectorReportFormQueryConfigDocument, options);
      }
export function useDetectorReportFormQueryConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorReportFormQueryConfigQuery, DetectorReportFormQueryConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorReportFormQueryConfigQuery, DetectorReportFormQueryConfigQueryVariables>(DetectorReportFormQueryConfigDocument, options);
        }
export type DetectorReportFormQueryConfigQueryHookResult = ReturnType<typeof useDetectorReportFormQueryConfigQuery>;
export type DetectorReportFormQueryConfigLazyQueryHookResult = ReturnType<typeof useDetectorReportFormQueryConfigLazyQuery>;
export type DetectorReportFormQueryConfigQueryResult = Apollo.QueryResult<DetectorReportFormQueryConfigQuery, DetectorReportFormQueryConfigQueryVariables>;
export function refetchDetectorReportFormQueryConfigQuery(variables?: DetectorReportFormQueryConfigQueryVariables) {
      return { query: DetectorReportFormQueryConfigDocument, variables: variables }
    }
export const DetectorReportRuleDocument = gql`
    query detectorReportRule($id: ID!) {
  detectorReportRule(id: $id) {
    ...DetectorReportRuleFragment
  }
}
    ${DetectorReportRuleFragmentFragmentDoc}`;

/**
 * __useDetectorReportRuleQuery__
 *
 * To run a query within a React component, call `useDetectorReportRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorReportRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorReportRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectorReportRuleQuery(baseOptions: Apollo.QueryHookOptions<DetectorReportRuleQuery, DetectorReportRuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorReportRuleQuery, DetectorReportRuleQueryVariables>(DetectorReportRuleDocument, options);
      }
export function useDetectorReportRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorReportRuleQuery, DetectorReportRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorReportRuleQuery, DetectorReportRuleQueryVariables>(DetectorReportRuleDocument, options);
        }
export type DetectorReportRuleQueryHookResult = ReturnType<typeof useDetectorReportRuleQuery>;
export type DetectorReportRuleLazyQueryHookResult = ReturnType<typeof useDetectorReportRuleLazyQuery>;
export type DetectorReportRuleQueryResult = Apollo.QueryResult<DetectorReportRuleQuery, DetectorReportRuleQueryVariables>;
export function refetchDetectorReportRuleQuery(variables: DetectorReportRuleQueryVariables) {
      return { query: DetectorReportRuleDocument, variables: variables }
    }
export const DetectorUpdatedShortDocument = gql`
    subscription DetectorUpdatedShort {
  detectorUpdated {
    id
  }
}
    `;

/**
 * __useDetectorUpdatedShortSubscription__
 *
 * To run a query within a React component, call `useDetectorUpdatedShortSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetectorUpdatedShortSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorUpdatedShortSubscription({
 *   variables: {
 *   },
 * });
 */
export function useDetectorUpdatedShortSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DetectorUpdatedShortSubscription, DetectorUpdatedShortSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetectorUpdatedShortSubscription, DetectorUpdatedShortSubscriptionVariables>(DetectorUpdatedShortDocument, options);
      }
export type DetectorUpdatedShortSubscriptionHookResult = ReturnType<typeof useDetectorUpdatedShortSubscription>;
export type DetectorUpdatedShortSubscriptionResult = Apollo.SubscriptionResult<DetectorUpdatedShortSubscription>;
export const DetectorVehicleAxleWeightChartWidgetDocument = gql`
    query DetectorVehicleAxleWeightChartWidget($detectorId: ID!, $startDate: Date!, $endDate: Date!, $granularity: DetectorVehicleVolumeGranularity!, $classIndex: Int!) {
  detectorVehicleAxleWeightChart(
    query: {detectorId: $detectorId, startDate: $startDate, endDate: $endDate, granularity: $granularity, classIndex: $classIndex}
  ) {
    ...DetectorVehicleAxleWeightChartFragment
  }
}
    ${DetectorVehicleAxleWeightChartFragmentFragmentDoc}`;

/**
 * __useDetectorVehicleAxleWeightChartWidgetQuery__
 *
 * To run a query within a React component, call `useDetectorVehicleAxleWeightChartWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehicleAxleWeightChartWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehicleAxleWeightChartWidgetQuery({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      granularity: // value for 'granularity'
 *      classIndex: // value for 'classIndex'
 *   },
 * });
 */
export function useDetectorVehicleAxleWeightChartWidgetQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehicleAxleWeightChartWidgetQuery, DetectorVehicleAxleWeightChartWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehicleAxleWeightChartWidgetQuery, DetectorVehicleAxleWeightChartWidgetQueryVariables>(DetectorVehicleAxleWeightChartWidgetDocument, options);
      }
export function useDetectorVehicleAxleWeightChartWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehicleAxleWeightChartWidgetQuery, DetectorVehicleAxleWeightChartWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehicleAxleWeightChartWidgetQuery, DetectorVehicleAxleWeightChartWidgetQueryVariables>(DetectorVehicleAxleWeightChartWidgetDocument, options);
        }
export type DetectorVehicleAxleWeightChartWidgetQueryHookResult = ReturnType<typeof useDetectorVehicleAxleWeightChartWidgetQuery>;
export type DetectorVehicleAxleWeightChartWidgetLazyQueryHookResult = ReturnType<typeof useDetectorVehicleAxleWeightChartWidgetLazyQuery>;
export type DetectorVehicleAxleWeightChartWidgetQueryResult = Apollo.QueryResult<DetectorVehicleAxleWeightChartWidgetQuery, DetectorVehicleAxleWeightChartWidgetQueryVariables>;
export function refetchDetectorVehicleAxleWeightChartWidgetQuery(variables: DetectorVehicleAxleWeightChartWidgetQueryVariables) {
      return { query: DetectorVehicleAxleWeightChartWidgetDocument, variables: variables }
    }
export const DetectorSpeedReportBinsDocument = gql`
    query DetectorSpeedReportBins($detectorId: ID!, $startDate: Date!, $endDate: Date!, $lane: Int, $laneDirection: Direction) {
  detectorVehicleSpeedReport(
    query: {detectorId: $detectorId, startDate: $startDate, endDate: $endDate, lane: $lane, laneDirection: $laneDirection}
  ) {
    ...DetectorVehicleSpeedBinReportFragment
  }
}
    ${DetectorVehicleSpeedBinReportFragmentFragmentDoc}`;

/**
 * __useDetectorSpeedReportBinsQuery__
 *
 * To run a query within a React component, call `useDetectorSpeedReportBinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorSpeedReportBinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorSpeedReportBinsQuery({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      lane: // value for 'lane'
 *      laneDirection: // value for 'laneDirection'
 *   },
 * });
 */
export function useDetectorSpeedReportBinsQuery(baseOptions: Apollo.QueryHookOptions<DetectorSpeedReportBinsQuery, DetectorSpeedReportBinsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorSpeedReportBinsQuery, DetectorSpeedReportBinsQueryVariables>(DetectorSpeedReportBinsDocument, options);
      }
export function useDetectorSpeedReportBinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorSpeedReportBinsQuery, DetectorSpeedReportBinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorSpeedReportBinsQuery, DetectorSpeedReportBinsQueryVariables>(DetectorSpeedReportBinsDocument, options);
        }
export type DetectorSpeedReportBinsQueryHookResult = ReturnType<typeof useDetectorSpeedReportBinsQuery>;
export type DetectorSpeedReportBinsLazyQueryHookResult = ReturnType<typeof useDetectorSpeedReportBinsLazyQuery>;
export type DetectorSpeedReportBinsQueryResult = Apollo.QueryResult<DetectorSpeedReportBinsQuery, DetectorSpeedReportBinsQueryVariables>;
export function refetchDetectorSpeedReportBinsQuery(variables: DetectorSpeedReportBinsQueryVariables) {
      return { query: DetectorSpeedReportBinsDocument, variables: variables }
    }
export const DetectorVolumeDocument = gql`
    subscription DetectorVolume($id: ID!) {
  detectorVehicleVolumeCountsUpdated(id: $id)
}
    `;

/**
 * __useDetectorVolumeSubscription__
 *
 * To run a query within a React component, call `useDetectorVolumeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVolumeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVolumeSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectorVolumeSubscription(baseOptions: Apollo.SubscriptionHookOptions<DetectorVolumeSubscription, DetectorVolumeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetectorVolumeSubscription, DetectorVolumeSubscriptionVariables>(DetectorVolumeDocument, options);
      }
export type DetectorVolumeSubscriptionHookResult = ReturnType<typeof useDetectorVolumeSubscription>;
export type DetectorVolumeSubscriptionResult = Apollo.SubscriptionResult<DetectorVolumeSubscription>;
export const CountsActivityLogAddedDocument = gql`
    subscription CountsActivityLogAdded($ids: [ID!], $module: KineticModule = COUNTS) {
  addedActivityLog(ids: $ids, module: $module) {
    ...ActivityLogNodeFragment
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}`;

/**
 * __useCountsActivityLogAddedSubscription__
 *
 * To run a query within a React component, call `useCountsActivityLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCountsActivityLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountsActivityLogAddedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useCountsActivityLogAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CountsActivityLogAddedSubscription, CountsActivityLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CountsActivityLogAddedSubscription, CountsActivityLogAddedSubscriptionVariables>(CountsActivityLogAddedDocument, options);
      }
export type CountsActivityLogAddedSubscriptionHookResult = ReturnType<typeof useCountsActivityLogAddedSubscription>;
export type CountsActivityLogAddedSubscriptionResult = Apollo.SubscriptionResult<CountsActivityLogAddedSubscription>;
export const DetectorTurningReportsDocument = gql`
    query DetectorTurningReports($detectorId: ID!, $startDate: Date!, $endDate: Date!, $viewType: DateViewType!, $granularity: DetectorVehicleVolumeGranularity!) {
  detectorTurningReport(
    query: {detectorId: $detectorId, startDate: $startDate, endDate: $endDate, viewType: $viewType, granularity: $granularity}
  ) {
    ...DetectorTurningReportFragment
  }
}
    ${DetectorTurningReportFragmentFragmentDoc}`;

/**
 * __useDetectorTurningReportsQuery__
 *
 * To run a query within a React component, call `useDetectorTurningReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorTurningReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorTurningReportsQuery({
 *   variables: {
 *      detectorId: // value for 'detectorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      viewType: // value for 'viewType'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useDetectorTurningReportsQuery(baseOptions: Apollo.QueryHookOptions<DetectorTurningReportsQuery, DetectorTurningReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorTurningReportsQuery, DetectorTurningReportsQueryVariables>(DetectorTurningReportsDocument, options);
      }
export function useDetectorTurningReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorTurningReportsQuery, DetectorTurningReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorTurningReportsQuery, DetectorTurningReportsQueryVariables>(DetectorTurningReportsDocument, options);
        }
export type DetectorTurningReportsQueryHookResult = ReturnType<typeof useDetectorTurningReportsQuery>;
export type DetectorTurningReportsLazyQueryHookResult = ReturnType<typeof useDetectorTurningReportsLazyQuery>;
export type DetectorTurningReportsQueryResult = Apollo.QueryResult<DetectorTurningReportsQuery, DetectorTurningReportsQueryVariables>;
export function refetchDetectorTurningReportsQuery(variables: DetectorTurningReportsQueryVariables) {
      return { query: DetectorTurningReportsDocument, variables: variables }
    }
export const DetectorGroupsDocument = gql`
    query DetectorGroups($after: String, $before: String, $limit: Int = 100, $sortField: String = "name", $sortOrder: SortOrder = DESCENDING, $searchText: String, $searchFields: [String!] = ["name", "description"], $filters: [FilterInput]) {
  detectorGroups(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, searchFields: $searchFields, filters: $filters}
  ) {
    edges {
      node {
        id
        name
        description
        detectorIds
        enabled
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorGroupsQuery__
 *
 * To run a query within a React component, call `useDetectorGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorGroupsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDetectorGroupsQuery(baseOptions?: Apollo.QueryHookOptions<DetectorGroupsQuery, DetectorGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorGroupsQuery, DetectorGroupsQueryVariables>(DetectorGroupsDocument, options);
      }
export function useDetectorGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorGroupsQuery, DetectorGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorGroupsQuery, DetectorGroupsQueryVariables>(DetectorGroupsDocument, options);
        }
export type DetectorGroupsQueryHookResult = ReturnType<typeof useDetectorGroupsQuery>;
export type DetectorGroupsLazyQueryHookResult = ReturnType<typeof useDetectorGroupsLazyQuery>;
export type DetectorGroupsQueryResult = Apollo.QueryResult<DetectorGroupsQuery, DetectorGroupsQueryVariables>;
export function refetchDetectorGroupsQuery(variables?: DetectorGroupsQueryVariables) {
      return { query: DetectorGroupsDocument, variables: variables }
    }
export const DetectorGroupDocument = gql`
    query DetectorGroup($id: ID!) {
  detectorGroup(id: $id) {
    id
    name
    description
    detectorIds
    enabled
  }
}
    `;

/**
 * __useDetectorGroupQuery__
 *
 * To run a query within a React component, call `useDetectorGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectorGroupQuery(baseOptions: Apollo.QueryHookOptions<DetectorGroupQuery, DetectorGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorGroupQuery, DetectorGroupQueryVariables>(DetectorGroupDocument, options);
      }
export function useDetectorGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorGroupQuery, DetectorGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorGroupQuery, DetectorGroupQueryVariables>(DetectorGroupDocument, options);
        }
export type DetectorGroupQueryHookResult = ReturnType<typeof useDetectorGroupQuery>;
export type DetectorGroupLazyQueryHookResult = ReturnType<typeof useDetectorGroupLazyQuery>;
export type DetectorGroupQueryResult = Apollo.QueryResult<DetectorGroupQuery, DetectorGroupQueryVariables>;
export function refetchDetectorGroupQuery(variables: DetectorGroupQueryVariables) {
      return { query: DetectorGroupDocument, variables: variables }
    }
export const DetectorClassConfigurationDocument = gql`
    query DetectorClassConfiguration($filters: [FilterInput!]) {
  detectorClassConfiguration(filters: $filters) {
    id
    name
    index
  }
}
    `;

/**
 * __useDetectorClassConfigurationQuery__
 *
 * To run a query within a React component, call `useDetectorClassConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorClassConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorClassConfigurationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDetectorClassConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<DetectorClassConfigurationQuery, DetectorClassConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorClassConfigurationQuery, DetectorClassConfigurationQueryVariables>(DetectorClassConfigurationDocument, options);
      }
export function useDetectorClassConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorClassConfigurationQuery, DetectorClassConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorClassConfigurationQuery, DetectorClassConfigurationQueryVariables>(DetectorClassConfigurationDocument, options);
        }
export type DetectorClassConfigurationQueryHookResult = ReturnType<typeof useDetectorClassConfigurationQuery>;
export type DetectorClassConfigurationLazyQueryHookResult = ReturnType<typeof useDetectorClassConfigurationLazyQuery>;
export type DetectorClassConfigurationQueryResult = Apollo.QueryResult<DetectorClassConfigurationQuery, DetectorClassConfigurationQueryVariables>;
export function refetchDetectorClassConfigurationQuery(variables?: DetectorClassConfigurationQueryVariables) {
      return { query: DetectorClassConfigurationDocument, variables: variables }
    }
export const DetectorMapEntitiesDocument = gql`
    query DetectorMapEntities {
  detectorMapEntities
}
    `;

/**
 * __useDetectorMapEntitiesQuery__
 *
 * To run a query within a React component, call `useDetectorMapEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorMapEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorMapEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectorMapEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<DetectorMapEntitiesQuery, DetectorMapEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorMapEntitiesQuery, DetectorMapEntitiesQueryVariables>(DetectorMapEntitiesDocument, options);
      }
export function useDetectorMapEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorMapEntitiesQuery, DetectorMapEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorMapEntitiesQuery, DetectorMapEntitiesQueryVariables>(DetectorMapEntitiesDocument, options);
        }
export type DetectorMapEntitiesQueryHookResult = ReturnType<typeof useDetectorMapEntitiesQuery>;
export type DetectorMapEntitiesLazyQueryHookResult = ReturnType<typeof useDetectorMapEntitiesLazyQuery>;
export type DetectorMapEntitiesQueryResult = Apollo.QueryResult<DetectorMapEntitiesQuery, DetectorMapEntitiesQueryVariables>;
export function refetchDetectorMapEntitiesQuery(variables?: DetectorMapEntitiesQueryVariables) {
      return { query: DetectorMapEntitiesDocument, variables: variables }
    }
export const DetectorsListDocument = gql`
    query DetectorsList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 100, $before: String, $after: String) {
  detectors(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        ...Detector
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${DetectorFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorsListQuery__
 *
 * To run a query within a React component, call `useDetectorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDetectorsListQuery(baseOptions?: Apollo.QueryHookOptions<DetectorsListQuery, DetectorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorsListQuery, DetectorsListQueryVariables>(DetectorsListDocument, options);
      }
export function useDetectorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorsListQuery, DetectorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorsListQuery, DetectorsListQueryVariables>(DetectorsListDocument, options);
        }
export type DetectorsListQueryHookResult = ReturnType<typeof useDetectorsListQuery>;
export type DetectorsListLazyQueryHookResult = ReturnType<typeof useDetectorsListLazyQuery>;
export type DetectorsListQueryResult = Apollo.QueryResult<DetectorsListQuery, DetectorsListQueryVariables>;
export function refetchDetectorsListQuery(variables?: DetectorsListQueryVariables) {
      return { query: DetectorsListDocument, variables: variables }
    }
export const DetectorListUpdatedDocument = gql`
    subscription DetectorListUpdated($ids: [ID!]) {
  detectorUpdated(ids: $ids) {
    ...Detector
  }
}
    ${DetectorFragmentDoc}`;

/**
 * __useDetectorListUpdatedSubscription__
 *
 * To run a query within a React component, call `useDetectorListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetectorListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorListUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDetectorListUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DetectorListUpdatedSubscription, DetectorListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetectorListUpdatedSubscription, DetectorListUpdatedSubscriptionVariables>(DetectorListUpdatedDocument, options);
      }
export type DetectorListUpdatedSubscriptionHookResult = ReturnType<typeof useDetectorListUpdatedSubscription>;
export type DetectorListUpdatedSubscriptionResult = Apollo.SubscriptionResult<DetectorListUpdatedSubscription>;
export const DetectorPerformanceReportAvailabilityDetailsDocument = gql`
    query DetectorPerformanceReportAvailabilityDetails($ruleIds: [ID!]!, $detectorIds: [ID!]!, $startDateTime: Date!, $endDateTime: Date!) {
  detectorPerformanceReportAvailabilityDetails(
    query: {ruleIds: $ruleIds, detectorIds: $detectorIds, startDateTime: $startDateTime, endDateTime: $endDateTime}
  ) {
    ...DetectorPerformanceReportDayWiseAvailabilityDetailInfoFragment
  }
}
    ${DetectorPerformanceReportDayWiseAvailabilityDetailInfoFragmentFragmentDoc}`;

/**
 * __useDetectorPerformanceReportAvailabilityDetailsQuery__
 *
 * To run a query within a React component, call `useDetectorPerformanceReportAvailabilityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorPerformanceReportAvailabilityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorPerformanceReportAvailabilityDetailsQuery({
 *   variables: {
 *      ruleIds: // value for 'ruleIds'
 *      detectorIds: // value for 'detectorIds'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorPerformanceReportAvailabilityDetailsQuery(baseOptions: Apollo.QueryHookOptions<DetectorPerformanceReportAvailabilityDetailsQuery, DetectorPerformanceReportAvailabilityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorPerformanceReportAvailabilityDetailsQuery, DetectorPerformanceReportAvailabilityDetailsQueryVariables>(DetectorPerformanceReportAvailabilityDetailsDocument, options);
      }
export function useDetectorPerformanceReportAvailabilityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorPerformanceReportAvailabilityDetailsQuery, DetectorPerformanceReportAvailabilityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorPerformanceReportAvailabilityDetailsQuery, DetectorPerformanceReportAvailabilityDetailsQueryVariables>(DetectorPerformanceReportAvailabilityDetailsDocument, options);
        }
export type DetectorPerformanceReportAvailabilityDetailsQueryHookResult = ReturnType<typeof useDetectorPerformanceReportAvailabilityDetailsQuery>;
export type DetectorPerformanceReportAvailabilityDetailsLazyQueryHookResult = ReturnType<typeof useDetectorPerformanceReportAvailabilityDetailsLazyQuery>;
export type DetectorPerformanceReportAvailabilityDetailsQueryResult = Apollo.QueryResult<DetectorPerformanceReportAvailabilityDetailsQuery, DetectorPerformanceReportAvailabilityDetailsQueryVariables>;
export function refetchDetectorPerformanceReportAvailabilityDetailsQuery(variables: DetectorPerformanceReportAvailabilityDetailsQueryVariables) {
      return { query: DetectorPerformanceReportAvailabilityDetailsDocument, variables: variables }
    }
export const DetectorVehicleAxlesCountReportDocument = gql`
    query DetectorVehicleAxlesCountReport($detectorIds: [ID!]!, $startDate: Date!, $endDate: Date!, $viewType: DateViewType!, $classGroup: [String], $className: [String], $lane: [Int], $laneDirection: [Direction]) {
  detectorVehicleAxlesCountReport(
    query: {detectorIds: $detectorIds, startDate: $startDate, endDate: $endDate, viewType: $viewType, classGroup: $classGroup, className: $className, lane: $lane, laneDirection: $laneDirection}
  ) {
    date
    axlesCountBinInfo
    minAxleNumber
    maxAxleNumber
  }
}
    `;

/**
 * __useDetectorVehicleAxlesCountReportQuery__
 *
 * To run a query within a React component, call `useDetectorVehicleAxlesCountReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehicleAxlesCountReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehicleAxlesCountReportQuery({
 *   variables: {
 *      detectorIds: // value for 'detectorIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      viewType: // value for 'viewType'
 *      classGroup: // value for 'classGroup'
 *      className: // value for 'className'
 *      lane: // value for 'lane'
 *      laneDirection: // value for 'laneDirection'
 *   },
 * });
 */
export function useDetectorVehicleAxlesCountReportQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehicleAxlesCountReportQuery, DetectorVehicleAxlesCountReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehicleAxlesCountReportQuery, DetectorVehicleAxlesCountReportQueryVariables>(DetectorVehicleAxlesCountReportDocument, options);
      }
export function useDetectorVehicleAxlesCountReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehicleAxlesCountReportQuery, DetectorVehicleAxlesCountReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehicleAxlesCountReportQuery, DetectorVehicleAxlesCountReportQueryVariables>(DetectorVehicleAxlesCountReportDocument, options);
        }
export type DetectorVehicleAxlesCountReportQueryHookResult = ReturnType<typeof useDetectorVehicleAxlesCountReportQuery>;
export type DetectorVehicleAxlesCountReportLazyQueryHookResult = ReturnType<typeof useDetectorVehicleAxlesCountReportLazyQuery>;
export type DetectorVehicleAxlesCountReportQueryResult = Apollo.QueryResult<DetectorVehicleAxlesCountReportQuery, DetectorVehicleAxlesCountReportQueryVariables>;
export function refetchDetectorVehicleAxlesCountReportQuery(variables: DetectorVehicleAxlesCountReportQueryVariables) {
      return { query: DetectorVehicleAxlesCountReportDocument, variables: variables }
    }
export const DetectorVehicleGrossWeightReportDocument = gql`
    query DetectorVehicleGrossWeightReport($detectorIds: [ID!]!, $startDate: Date!, $endDate: Date!, $viewType: DateViewType!, $classGroup: [String], $unitPreference: ConversionUnitType!, $className: [String], $lane: [Int], $laneDirection: [Direction], $detectorGrossWeightBandResolution: Int) {
  detectorVehicleGrossWeightReport(
    query: {detectorIds: $detectorIds, startDate: $startDate, endDate: $endDate, viewType: $viewType, classGroup: $classGroup, unitPreference: $unitPreference, className: $className, lane: $lane, laneDirection: $laneDirection, detectorGrossWeightBandResolution: $detectorGrossWeightBandResolution}
  ) {
    date
    weightBinInfo
    minGrossWeight
    maxGrossWeight
  }
}
    `;

/**
 * __useDetectorVehicleGrossWeightReportQuery__
 *
 * To run a query within a React component, call `useDetectorVehicleGrossWeightReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehicleGrossWeightReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehicleGrossWeightReportQuery({
 *   variables: {
 *      detectorIds: // value for 'detectorIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      viewType: // value for 'viewType'
 *      classGroup: // value for 'classGroup'
 *      unitPreference: // value for 'unitPreference'
 *      className: // value for 'className'
 *      lane: // value for 'lane'
 *      laneDirection: // value for 'laneDirection'
 *      detectorGrossWeightBandResolution: // value for 'detectorGrossWeightBandResolution'
 *   },
 * });
 */
export function useDetectorVehicleGrossWeightReportQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehicleGrossWeightReportQuery, DetectorVehicleGrossWeightReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehicleGrossWeightReportQuery, DetectorVehicleGrossWeightReportQueryVariables>(DetectorVehicleGrossWeightReportDocument, options);
      }
export function useDetectorVehicleGrossWeightReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehicleGrossWeightReportQuery, DetectorVehicleGrossWeightReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehicleGrossWeightReportQuery, DetectorVehicleGrossWeightReportQueryVariables>(DetectorVehicleGrossWeightReportDocument, options);
        }
export type DetectorVehicleGrossWeightReportQueryHookResult = ReturnType<typeof useDetectorVehicleGrossWeightReportQuery>;
export type DetectorVehicleGrossWeightReportLazyQueryHookResult = ReturnType<typeof useDetectorVehicleGrossWeightReportLazyQuery>;
export type DetectorVehicleGrossWeightReportQueryResult = Apollo.QueryResult<DetectorVehicleGrossWeightReportQuery, DetectorVehicleGrossWeightReportQueryVariables>;
export function refetchDetectorVehicleGrossWeightReportQuery(variables: DetectorVehicleGrossWeightReportQueryVariables) {
      return { query: DetectorVehicleGrossWeightReportDocument, variables: variables }
    }
export const DetectorVehicleAxleWeightReportDocument = gql`
    query DetectorVehicleAxleWeightReport($detectorIds: [ID!]!, $startDate: Date!, $endDate: Date!, $viewType: DateViewType!, $classGroup: [String], $unitPreference: ConversionUnitType!, $className: [String], $lane: [Int], $laneDirection: [Direction], $detectorAxleWeightBandResolution: Float, $types: [DetectorAxleType!]) {
  detectorVehicleAxleWeightReport(
    query: {detectorIds: $detectorIds, startDate: $startDate, endDate: $endDate, viewType: $viewType, classGroup: $classGroup, unitPreference: $unitPreference, className: $className, lane: $lane, laneDirection: $laneDirection, detectorAxleWeightBandResolution: $detectorAxleWeightBandResolution, types: $types}
  ) {
    date
    weightBinInfo
    minAxleWeight
    maxAxleWeight
  }
}
    `;

/**
 * __useDetectorVehicleAxleWeightReportQuery__
 *
 * To run a query within a React component, call `useDetectorVehicleAxleWeightReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorVehicleAxleWeightReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorVehicleAxleWeightReportQuery({
 *   variables: {
 *      detectorIds: // value for 'detectorIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      viewType: // value for 'viewType'
 *      classGroup: // value for 'classGroup'
 *      unitPreference: // value for 'unitPreference'
 *      className: // value for 'className'
 *      lane: // value for 'lane'
 *      laneDirection: // value for 'laneDirection'
 *      detectorAxleWeightBandResolution: // value for 'detectorAxleWeightBandResolution'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDetectorVehicleAxleWeightReportQuery(baseOptions: Apollo.QueryHookOptions<DetectorVehicleAxleWeightReportQuery, DetectorVehicleAxleWeightReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorVehicleAxleWeightReportQuery, DetectorVehicleAxleWeightReportQueryVariables>(DetectorVehicleAxleWeightReportDocument, options);
      }
export function useDetectorVehicleAxleWeightReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorVehicleAxleWeightReportQuery, DetectorVehicleAxleWeightReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorVehicleAxleWeightReportQuery, DetectorVehicleAxleWeightReportQueryVariables>(DetectorVehicleAxleWeightReportDocument, options);
        }
export type DetectorVehicleAxleWeightReportQueryHookResult = ReturnType<typeof useDetectorVehicleAxleWeightReportQuery>;
export type DetectorVehicleAxleWeightReportLazyQueryHookResult = ReturnType<typeof useDetectorVehicleAxleWeightReportLazyQuery>;
export type DetectorVehicleAxleWeightReportQueryResult = Apollo.QueryResult<DetectorVehicleAxleWeightReportQuery, DetectorVehicleAxleWeightReportQueryVariables>;
export function refetchDetectorVehicleAxleWeightReportQuery(variables: DetectorVehicleAxleWeightReportQueryVariables) {
      return { query: DetectorVehicleAxleWeightReportDocument, variables: variables }
    }
export const DetectorWimMeanGrossWeightReportDocument = gql`
    query DetectorWimMeanGrossWeightReport($detectorIds: [ID!]!, $startDate: Date!, $endDate: Date!, $viewType: DateViewType!, $classGroup: [String], $unitPreference: ConversionUnitType!, $className: [String], $lane: [Int], $laneDirection: [Direction]) {
  detectorWimMeanGrossWeightReport(
    query: {detectorIds: $detectorIds, startDate: $startDate, endDate: $endDate, viewType: $viewType, classGroup: $classGroup, unitPreference: $unitPreference, className: $className, lane: $lane, laneDirection: $laneDirection}
  ) {
    columns
    rows
  }
}
    `;

/**
 * __useDetectorWimMeanGrossWeightReportQuery__
 *
 * To run a query within a React component, call `useDetectorWimMeanGrossWeightReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorWimMeanGrossWeightReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorWimMeanGrossWeightReportQuery({
 *   variables: {
 *      detectorIds: // value for 'detectorIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      viewType: // value for 'viewType'
 *      classGroup: // value for 'classGroup'
 *      unitPreference: // value for 'unitPreference'
 *      className: // value for 'className'
 *      lane: // value for 'lane'
 *      laneDirection: // value for 'laneDirection'
 *   },
 * });
 */
export function useDetectorWimMeanGrossWeightReportQuery(baseOptions: Apollo.QueryHookOptions<DetectorWimMeanGrossWeightReportQuery, DetectorWimMeanGrossWeightReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorWimMeanGrossWeightReportQuery, DetectorWimMeanGrossWeightReportQueryVariables>(DetectorWimMeanGrossWeightReportDocument, options);
      }
export function useDetectorWimMeanGrossWeightReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorWimMeanGrossWeightReportQuery, DetectorWimMeanGrossWeightReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorWimMeanGrossWeightReportQuery, DetectorWimMeanGrossWeightReportQueryVariables>(DetectorWimMeanGrossWeightReportDocument, options);
        }
export type DetectorWimMeanGrossWeightReportQueryHookResult = ReturnType<typeof useDetectorWimMeanGrossWeightReportQuery>;
export type DetectorWimMeanGrossWeightReportLazyQueryHookResult = ReturnType<typeof useDetectorWimMeanGrossWeightReportLazyQuery>;
export type DetectorWimMeanGrossWeightReportQueryResult = Apollo.QueryResult<DetectorWimMeanGrossWeightReportQuery, DetectorWimMeanGrossWeightReportQueryVariables>;
export function refetchDetectorWimMeanGrossWeightReportQuery(variables: DetectorWimMeanGrossWeightReportQueryVariables) {
      return { query: DetectorWimMeanGrossWeightReportDocument, variables: variables }
    }
export const CountsModuleSettingsDocument = gql`
    query countsModuleSettings {
  countsModuleSettings {
    id
    name
    type
    sections {
      name
      id
      fields {
        id
        name
        label
        type
        required
        hint
        sourceId
        defaultValue
        loading
        showInput
        options {
          label
          value
          __typename
        }
        step
        max
        min
        useStepper
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useCountsModuleSettingsQuery__
 *
 * To run a query within a React component, call `useCountsModuleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountsModuleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountsModuleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountsModuleSettingsQuery(baseOptions?: Apollo.QueryHookOptions<CountsModuleSettingsQuery, CountsModuleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountsModuleSettingsQuery, CountsModuleSettingsQueryVariables>(CountsModuleSettingsDocument, options);
      }
export function useCountsModuleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountsModuleSettingsQuery, CountsModuleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountsModuleSettingsQuery, CountsModuleSettingsQueryVariables>(CountsModuleSettingsDocument, options);
        }
export type CountsModuleSettingsQueryHookResult = ReturnType<typeof useCountsModuleSettingsQuery>;
export type CountsModuleSettingsLazyQueryHookResult = ReturnType<typeof useCountsModuleSettingsLazyQuery>;
export type CountsModuleSettingsQueryResult = Apollo.QueryResult<CountsModuleSettingsQuery, CountsModuleSettingsQueryVariables>;
export function refetchCountsModuleSettingsQuery(variables?: CountsModuleSettingsQueryVariables) {
      return { query: CountsModuleSettingsDocument, variables: variables }
    }
export const CountsAlarmConfigsDocument = gql`
    query CountsAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "COUNTS"}, {field: "entityType", operator: EQUALS, value: "COUNT_SITE"}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useCountsAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useCountsAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountsAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountsAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountsAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<CountsAlarmConfigsQuery, CountsAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountsAlarmConfigsQuery, CountsAlarmConfigsQueryVariables>(CountsAlarmConfigsDocument, options);
      }
export function useCountsAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountsAlarmConfigsQuery, CountsAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountsAlarmConfigsQuery, CountsAlarmConfigsQueryVariables>(CountsAlarmConfigsDocument, options);
        }
export type CountsAlarmConfigsQueryHookResult = ReturnType<typeof useCountsAlarmConfigsQuery>;
export type CountsAlarmConfigsLazyQueryHookResult = ReturnType<typeof useCountsAlarmConfigsLazyQuery>;
export type CountsAlarmConfigsQueryResult = Apollo.QueryResult<CountsAlarmConfigsQuery, CountsAlarmConfigsQueryVariables>;
export function refetchCountsAlarmConfigsQuery(variables?: CountsAlarmConfigsQueryVariables) {
      return { query: CountsAlarmConfigsDocument, variables: variables }
    }
export const EmailNotificationsHistoryListDocument = gql`
    query EmailNotificationsHistoryList($searchText: String, $searchFields: [String!] = ["toRecipients", "ccRecipients", "bccRecipients", "subject", "body", "sentAt", "module"], $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10000, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  emailHistory(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, sortField: $sortField, searchText: $searchText, searchFields: $searchFields, filters: $filters}
  ) {
    edges {
      node {
        id
        sentAt
        sentStatus
        type
        subject
        module
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useEmailNotificationsHistoryListQuery__
 *
 * To run a query within a React component, call `useEmailNotificationsHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailNotificationsHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailNotificationsHistoryListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useEmailNotificationsHistoryListQuery(baseOptions?: Apollo.QueryHookOptions<EmailNotificationsHistoryListQuery, EmailNotificationsHistoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailNotificationsHistoryListQuery, EmailNotificationsHistoryListQueryVariables>(EmailNotificationsHistoryListDocument, options);
      }
export function useEmailNotificationsHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailNotificationsHistoryListQuery, EmailNotificationsHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailNotificationsHistoryListQuery, EmailNotificationsHistoryListQueryVariables>(EmailNotificationsHistoryListDocument, options);
        }
export type EmailNotificationsHistoryListQueryHookResult = ReturnType<typeof useEmailNotificationsHistoryListQuery>;
export type EmailNotificationsHistoryListLazyQueryHookResult = ReturnType<typeof useEmailNotificationsHistoryListLazyQuery>;
export type EmailNotificationsHistoryListQueryResult = Apollo.QueryResult<EmailNotificationsHistoryListQuery, EmailNotificationsHistoryListQueryVariables>;
export function refetchEmailNotificationsHistoryListQuery(variables?: EmailNotificationsHistoryListQueryVariables) {
      return { query: EmailNotificationsHistoryListDocument, variables: variables }
    }
export const EmailNotificationsHistoryItemDocument = gql`
    query EmailNotificationsHistoryItem($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  emailHistory(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, sortField: $sortField, searchText: $searchText, filters: $filters}
  ) {
    edges {
      node {
        id
        sentAt
        sentStatus
        type
        subject
        body
        toRecipients
        ccRecipients
        bccRecipients
        lastViewedAt
        module
        data
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useEmailNotificationsHistoryItemQuery__
 *
 * To run a query within a React component, call `useEmailNotificationsHistoryItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailNotificationsHistoryItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailNotificationsHistoryItemQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useEmailNotificationsHistoryItemQuery(baseOptions?: Apollo.QueryHookOptions<EmailNotificationsHistoryItemQuery, EmailNotificationsHistoryItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailNotificationsHistoryItemQuery, EmailNotificationsHistoryItemQueryVariables>(EmailNotificationsHistoryItemDocument, options);
      }
export function useEmailNotificationsHistoryItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailNotificationsHistoryItemQuery, EmailNotificationsHistoryItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailNotificationsHistoryItemQuery, EmailNotificationsHistoryItemQueryVariables>(EmailNotificationsHistoryItemDocument, options);
        }
export type EmailNotificationsHistoryItemQueryHookResult = ReturnType<typeof useEmailNotificationsHistoryItemQuery>;
export type EmailNotificationsHistoryItemLazyQueryHookResult = ReturnType<typeof useEmailNotificationsHistoryItemLazyQuery>;
export type EmailNotificationsHistoryItemQueryResult = Apollo.QueryResult<EmailNotificationsHistoryItemQuery, EmailNotificationsHistoryItemQueryVariables>;
export function refetchEmailNotificationsHistoryItemQuery(variables?: EmailNotificationsHistoryItemQueryVariables) {
      return { query: EmailNotificationsHistoryItemDocument, variables: variables }
    }
export const DeleteEmailTemplateDocument = gql`
    mutation DeleteEmailTemplate($id: ID!) {
  deleteEmailTemplate(id: $id)
}
    `;
export type DeleteEmailTemplateMutationFn = Apollo.MutationFunction<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;

/**
 * __useDeleteEmailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailTemplateMutation, { data, loading, error }] = useDeleteEmailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>(DeleteEmailTemplateDocument, options);
      }
export type DeleteEmailTemplateMutationHookResult = ReturnType<typeof useDeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationResult = Apollo.MutationResult<DeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;
export const DeleteEmailsTemplateListDocument = gql`
    mutation DeleteEmailsTemplateList($ids: [ID!]!) {
  deleteEmailTemplateList(ids: $ids)
}
    `;
export type DeleteEmailsTemplateListMutationFn = Apollo.MutationFunction<DeleteEmailsTemplateListMutation, DeleteEmailsTemplateListMutationVariables>;

/**
 * __useDeleteEmailsTemplateListMutation__
 *
 * To run a mutation, you first call `useDeleteEmailsTemplateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailsTemplateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailsTemplateListMutation, { data, loading, error }] = useDeleteEmailsTemplateListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteEmailsTemplateListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailsTemplateListMutation, DeleteEmailsTemplateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailsTemplateListMutation, DeleteEmailsTemplateListMutationVariables>(DeleteEmailsTemplateListDocument, options);
      }
export type DeleteEmailsTemplateListMutationHookResult = ReturnType<typeof useDeleteEmailsTemplateListMutation>;
export type DeleteEmailsTemplateListMutationResult = Apollo.MutationResult<DeleteEmailsTemplateListMutation>;
export type DeleteEmailsTemplateListMutationOptions = Apollo.BaseMutationOptions<DeleteEmailsTemplateListMutation, DeleteEmailsTemplateListMutationVariables>;
export const SaveEmailTemplateDocument = gql`
    mutation SaveEmailTemplate($template: EmailTemplateInput!) {
  saveEmailTemplate(template: $template) {
    ...EmailTemplateListNodeFragment
  }
}
    ${EmailTemplateListNodeFragmentFragmentDoc}`;
export type SaveEmailTemplateMutationFn = Apollo.MutationFunction<SaveEmailTemplateMutation, SaveEmailTemplateMutationVariables>;

/**
 * __useSaveEmailTemplateMutation__
 *
 * To run a mutation, you first call `useSaveEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEmailTemplateMutation, { data, loading, error }] = useSaveEmailTemplateMutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useSaveEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveEmailTemplateMutation, SaveEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEmailTemplateMutation, SaveEmailTemplateMutationVariables>(SaveEmailTemplateDocument, options);
      }
export type SaveEmailTemplateMutationHookResult = ReturnType<typeof useSaveEmailTemplateMutation>;
export type SaveEmailTemplateMutationResult = Apollo.MutationResult<SaveEmailTemplateMutation>;
export type SaveEmailTemplateMutationOptions = Apollo.BaseMutationOptions<SaveEmailTemplateMutation, SaveEmailTemplateMutationVariables>;
export const SaveEmailRuleDocument = gql`
    mutation SaveEmailRule($emailRule: EmailRuleInput!) {
  saveEmailRule(emailRule: $emailRule) {
    ...EmailRuleDetailsFragment
  }
}
    ${EmailRuleDetailsFragmentFragmentDoc}`;
export type SaveEmailRuleMutationFn = Apollo.MutationFunction<SaveEmailRuleMutation, SaveEmailRuleMutationVariables>;

/**
 * __useSaveEmailRuleMutation__
 *
 * To run a mutation, you first call `useSaveEmailRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEmailRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEmailRuleMutation, { data, loading, error }] = useSaveEmailRuleMutation({
 *   variables: {
 *      emailRule: // value for 'emailRule'
 *   },
 * });
 */
export function useSaveEmailRuleMutation(baseOptions?: Apollo.MutationHookOptions<SaveEmailRuleMutation, SaveEmailRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEmailRuleMutation, SaveEmailRuleMutationVariables>(SaveEmailRuleDocument, options);
      }
export type SaveEmailRuleMutationHookResult = ReturnType<typeof useSaveEmailRuleMutation>;
export type SaveEmailRuleMutationResult = Apollo.MutationResult<SaveEmailRuleMutation>;
export type SaveEmailRuleMutationOptions = Apollo.BaseMutationOptions<SaveEmailRuleMutation, SaveEmailRuleMutationVariables>;
export const DeleteEmailRuleDocument = gql`
    mutation DeleteEmailRule($id: ID!) {
  deleteEmailRule(id: $id)
}
    `;
export type DeleteEmailRuleMutationFn = Apollo.MutationFunction<DeleteEmailRuleMutation, DeleteEmailRuleMutationVariables>;

/**
 * __useDeleteEmailRuleMutation__
 *
 * To run a mutation, you first call `useDeleteEmailRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailRuleMutation, { data, loading, error }] = useDeleteEmailRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmailRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailRuleMutation, DeleteEmailRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailRuleMutation, DeleteEmailRuleMutationVariables>(DeleteEmailRuleDocument, options);
      }
export type DeleteEmailRuleMutationHookResult = ReturnType<typeof useDeleteEmailRuleMutation>;
export type DeleteEmailRuleMutationResult = Apollo.MutationResult<DeleteEmailRuleMutation>;
export type DeleteEmailRuleMutationOptions = Apollo.BaseMutationOptions<DeleteEmailRuleMutation, DeleteEmailRuleMutationVariables>;
export const DeleteEmailRulesListDocument = gql`
    mutation DeleteEmailRulesList($ids: [ID!]!) {
  deleteEmailRulesList(ids: $ids)
}
    `;
export type DeleteEmailRulesListMutationFn = Apollo.MutationFunction<DeleteEmailRulesListMutation, DeleteEmailRulesListMutationVariables>;

/**
 * __useDeleteEmailRulesListMutation__
 *
 * To run a mutation, you first call `useDeleteEmailRulesListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailRulesListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailRulesListMutation, { data, loading, error }] = useDeleteEmailRulesListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteEmailRulesListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailRulesListMutation, DeleteEmailRulesListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailRulesListMutation, DeleteEmailRulesListMutationVariables>(DeleteEmailRulesListDocument, options);
      }
export type DeleteEmailRulesListMutationHookResult = ReturnType<typeof useDeleteEmailRulesListMutation>;
export type DeleteEmailRulesListMutationResult = Apollo.MutationResult<DeleteEmailRulesListMutation>;
export type DeleteEmailRulesListMutationOptions = Apollo.BaseMutationOptions<DeleteEmailRulesListMutation, DeleteEmailRulesListMutationVariables>;
export const RuleActivityLogsDocument = gql`
    query RuleActivityLogs($after: String, $before: String, $limit: Int = 10000, $searchText: String, $searchFields: [String!] = ["entityId", "userId", "description", "object.name", "userFullName", "action"], $sortOrder: SortOrder, $filters: [FilterInput!]!) {
  activityLogs(
    after: $after
    before: $before
    limit: $limit
    searchText: $searchText
    searchFields: $searchFields
    sortOrder: $sortOrder
    filters: $filters
  ) {
    edges {
      node {
        ...ActivityLogNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useRuleActivityLogsQuery__
 *
 * To run a query within a React component, call `useRuleActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleActivityLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleActivityLogsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRuleActivityLogsQuery(baseOptions: Apollo.QueryHookOptions<RuleActivityLogsQuery, RuleActivityLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleActivityLogsQuery, RuleActivityLogsQueryVariables>(RuleActivityLogsDocument, options);
      }
export function useRuleActivityLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleActivityLogsQuery, RuleActivityLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleActivityLogsQuery, RuleActivityLogsQueryVariables>(RuleActivityLogsDocument, options);
        }
export type RuleActivityLogsQueryHookResult = ReturnType<typeof useRuleActivityLogsQuery>;
export type RuleActivityLogsLazyQueryHookResult = ReturnType<typeof useRuleActivityLogsLazyQuery>;
export type RuleActivityLogsQueryResult = Apollo.QueryResult<RuleActivityLogsQuery, RuleActivityLogsQueryVariables>;
export function refetchRuleActivityLogsQuery(variables: RuleActivityLogsQueryVariables) {
      return { query: RuleActivityLogsDocument, variables: variables }
    }
export const EmailRuleActivityLogAddedDocument = gql`
    subscription EmailRuleActivityLogAdded($ids: [ID!], $module: KineticModule = EMAILS) {
  addedActivityLog(ids: $ids, module: $module) {
    ...ActivityLogNodeFragment
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}`;

/**
 * __useEmailRuleActivityLogAddedSubscription__
 *
 * To run a query within a React component, call `useEmailRuleActivityLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEmailRuleActivityLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailRuleActivityLogAddedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useEmailRuleActivityLogAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EmailRuleActivityLogAddedSubscription, EmailRuleActivityLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EmailRuleActivityLogAddedSubscription, EmailRuleActivityLogAddedSubscriptionVariables>(EmailRuleActivityLogAddedDocument, options);
      }
export type EmailRuleActivityLogAddedSubscriptionHookResult = ReturnType<typeof useEmailRuleActivityLogAddedSubscription>;
export type EmailRuleActivityLogAddedSubscriptionResult = Apollo.SubscriptionResult<EmailRuleActivityLogAddedSubscription>;
export const EmailsRulesListDocument = gql`
    query EmailsRulesList($after: String, $before: String, $limit: Int = 1000000, $sortField: String, $searchFields: [String] = ["id", "name", "module"], $sortOrder: SortOrder = DESCENDING, $searchText: String, $filters: [FilterInput]) {
  emailsRule(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, filters: $filters, searchFields: $searchFields}
  ) {
    edges {
      node {
        ...EmailRuleList
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${EmailRuleListFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useEmailsRulesListQuery__
 *
 * To run a query within a React component, call `useEmailsRulesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailsRulesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailsRulesListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEmailsRulesListQuery(baseOptions?: Apollo.QueryHookOptions<EmailsRulesListQuery, EmailsRulesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailsRulesListQuery, EmailsRulesListQueryVariables>(EmailsRulesListDocument, options);
      }
export function useEmailsRulesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailsRulesListQuery, EmailsRulesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailsRulesListQuery, EmailsRulesListQueryVariables>(EmailsRulesListDocument, options);
        }
export type EmailsRulesListQueryHookResult = ReturnType<typeof useEmailsRulesListQuery>;
export type EmailsRulesListLazyQueryHookResult = ReturnType<typeof useEmailsRulesListLazyQuery>;
export type EmailsRulesListQueryResult = Apollo.QueryResult<EmailsRulesListQuery, EmailsRulesListQueryVariables>;
export function refetchEmailsRulesListQuery(variables?: EmailsRulesListQueryVariables) {
      return { query: EmailsRulesListDocument, variables: variables }
    }
export const EmailRuleDetailsDocument = gql`
    query EmailRuleDetails($id: ID!) {
  emailRule(id: $id) {
    ...EmailRuleDetailsFragment
  }
}
    ${EmailRuleDetailsFragmentFragmentDoc}`;

/**
 * __useEmailRuleDetailsQuery__
 *
 * To run a query within a React component, call `useEmailRuleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailRuleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailRuleDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailRuleDetailsQuery(baseOptions: Apollo.QueryHookOptions<EmailRuleDetailsQuery, EmailRuleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailRuleDetailsQuery, EmailRuleDetailsQueryVariables>(EmailRuleDetailsDocument, options);
      }
export function useEmailRuleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailRuleDetailsQuery, EmailRuleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailRuleDetailsQuery, EmailRuleDetailsQueryVariables>(EmailRuleDetailsDocument, options);
        }
export type EmailRuleDetailsQueryHookResult = ReturnType<typeof useEmailRuleDetailsQuery>;
export type EmailRuleDetailsLazyQueryHookResult = ReturnType<typeof useEmailRuleDetailsLazyQuery>;
export type EmailRuleDetailsQueryResult = Apollo.QueryResult<EmailRuleDetailsQuery, EmailRuleDetailsQueryVariables>;
export function refetchEmailRuleDetailsQuery(variables: EmailRuleDetailsQueryVariables) {
      return { query: EmailRuleDetailsDocument, variables: variables }
    }
export const EmailRuleUpdatedDocument = gql`
    subscription EmailRuleUpdated($ids: [ID!]) {
  emailRuleUpdated(ids: $ids) {
    ...EmailRuleDetailsFragment
  }
}
    ${EmailRuleDetailsFragmentFragmentDoc}`;

/**
 * __useEmailRuleUpdatedSubscription__
 *
 * To run a query within a React component, call `useEmailRuleUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEmailRuleUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailRuleUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEmailRuleUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EmailRuleUpdatedSubscription, EmailRuleUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EmailRuleUpdatedSubscription, EmailRuleUpdatedSubscriptionVariables>(EmailRuleUpdatedDocument, options);
      }
export type EmailRuleUpdatedSubscriptionHookResult = ReturnType<typeof useEmailRuleUpdatedSubscription>;
export type EmailRuleUpdatedSubscriptionResult = Apollo.SubscriptionResult<EmailRuleUpdatedSubscription>;
export const EmailKineticFormsDocument = gql`
    query EmailKineticForms($query: KineticFormInputQuery!) {
  kineticForms(query: $query) {
    edges {
      node {
        ...KineticForm
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${KineticFormFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useEmailKineticFormsQuery__
 *
 * To run a query within a React component, call `useEmailKineticFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailKineticFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailKineticFormsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useEmailKineticFormsQuery(baseOptions: Apollo.QueryHookOptions<EmailKineticFormsQuery, EmailKineticFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailKineticFormsQuery, EmailKineticFormsQueryVariables>(EmailKineticFormsDocument, options);
      }
export function useEmailKineticFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailKineticFormsQuery, EmailKineticFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailKineticFormsQuery, EmailKineticFormsQueryVariables>(EmailKineticFormsDocument, options);
        }
export type EmailKineticFormsQueryHookResult = ReturnType<typeof useEmailKineticFormsQuery>;
export type EmailKineticFormsLazyQueryHookResult = ReturnType<typeof useEmailKineticFormsLazyQuery>;
export type EmailKineticFormsQueryResult = Apollo.QueryResult<EmailKineticFormsQuery, EmailKineticFormsQueryVariables>;
export function refetchEmailKineticFormsQuery(variables: EmailKineticFormsQueryVariables) {
      return { query: EmailKineticFormsDocument, variables: variables }
    }
export const KineticFormQueryConfigDocument = gql`
    query KineticFormQueryConfig($id: ID!) {
  kineticFormQueryConfig(id: $id)
}
    `;

/**
 * __useKineticFormQueryConfigQuery__
 *
 * To run a query within a React component, call `useKineticFormQueryConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormQueryConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormQueryConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKineticFormQueryConfigQuery(baseOptions: Apollo.QueryHookOptions<KineticFormQueryConfigQuery, KineticFormQueryConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormQueryConfigQuery, KineticFormQueryConfigQueryVariables>(KineticFormQueryConfigDocument, options);
      }
export function useKineticFormQueryConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormQueryConfigQuery, KineticFormQueryConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormQueryConfigQuery, KineticFormQueryConfigQueryVariables>(KineticFormQueryConfigDocument, options);
        }
export type KineticFormQueryConfigQueryHookResult = ReturnType<typeof useKineticFormQueryConfigQuery>;
export type KineticFormQueryConfigLazyQueryHookResult = ReturnType<typeof useKineticFormQueryConfigLazyQuery>;
export type KineticFormQueryConfigQueryResult = Apollo.QueryResult<KineticFormQueryConfigQuery, KineticFormQueryConfigQueryVariables>;
export function refetchKineticFormQueryConfigQuery(variables: KineticFormQueryConfigQueryVariables) {
      return { query: KineticFormQueryConfigDocument, variables: variables }
    }
export const EmailsTemplateListDocument = gql`
    query EmailsTemplateList($after: String, $before: String, $limit: Int = 100, $sortField: String = "name", $searchFields: [String] = ["name"], $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput]) {
  emailsTemplate(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, filters: $filters, searchFields: $searchFields}
  ) {
    edges {
      node {
        ...EmailTemplateListNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${EmailTemplateListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useEmailsTemplateListQuery__
 *
 * To run a query within a React component, call `useEmailsTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailsTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailsTemplateListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEmailsTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<EmailsTemplateListQuery, EmailsTemplateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailsTemplateListQuery, EmailsTemplateListQueryVariables>(EmailsTemplateListDocument, options);
      }
export function useEmailsTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailsTemplateListQuery, EmailsTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailsTemplateListQuery, EmailsTemplateListQueryVariables>(EmailsTemplateListDocument, options);
        }
export type EmailsTemplateListQueryHookResult = ReturnType<typeof useEmailsTemplateListQuery>;
export type EmailsTemplateListLazyQueryHookResult = ReturnType<typeof useEmailsTemplateListLazyQuery>;
export type EmailsTemplateListQueryResult = Apollo.QueryResult<EmailsTemplateListQuery, EmailsTemplateListQueryVariables>;
export function refetchEmailsTemplateListQuery(variables?: EmailsTemplateListQueryVariables) {
      return { query: EmailsTemplateListDocument, variables: variables }
    }
export const EmailTemplateDocument = gql`
    query EmailTemplate($id: ID!) {
  emailTemplate(id: $id) {
    ...EmailTemplateListNodeFragment
  }
}
    ${EmailTemplateListNodeFragmentFragmentDoc}`;

/**
 * __useEmailTemplateQuery__
 *
 * To run a query within a React component, call `useEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<EmailTemplateQuery, EmailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(EmailTemplateDocument, options);
      }
export function useEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailTemplateQuery, EmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(EmailTemplateDocument, options);
        }
export type EmailTemplateQueryHookResult = ReturnType<typeof useEmailTemplateQuery>;
export type EmailTemplateLazyQueryHookResult = ReturnType<typeof useEmailTemplateLazyQuery>;
export type EmailTemplateQueryResult = Apollo.QueryResult<EmailTemplateQuery, EmailTemplateQueryVariables>;
export function refetchEmailTemplateQuery(variables: EmailTemplateQueryVariables) {
      return { query: EmailTemplateDocument, variables: variables }
    }
export const EmailTemplateUpdatedDocument = gql`
    subscription EmailTemplateUpdated($ids: [ID!]) {
  emailTemplateUpdated(ids: $ids) {
    id
  }
}
    `;

/**
 * __useEmailTemplateUpdatedSubscription__
 *
 * To run a query within a React component, call `useEmailTemplateUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEmailTemplateUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailTemplateUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEmailTemplateUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EmailTemplateUpdatedSubscription, EmailTemplateUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EmailTemplateUpdatedSubscription, EmailTemplateUpdatedSubscriptionVariables>(EmailTemplateUpdatedDocument, options);
      }
export type EmailTemplateUpdatedSubscriptionHookResult = ReturnType<typeof useEmailTemplateUpdatedSubscription>;
export type EmailTemplateUpdatedSubscriptionResult = Apollo.SubscriptionResult<EmailTemplateUpdatedSubscription>;
export const GetSignalAlarmPreviewAlarmsDocument = gql`
    query GetSignalAlarmPreviewAlarms {
  alarms(query: {filters: [{operator: EQUALS, value: SIGNALS, field: "source"}]}) {
    edges {
      node {
        ID: id
        ALARM_NAME: name
        ALARM_SEVERITY: severity
        ALARM_SOURCE: source
        RECEIVED_AT: receivedAt
        ACTIVE_AT: activeAt
        CLEARED_AT: clearedAt
        UPDATED_AT: updatedAt
        ACTIVE: active
        COUNT: count
        ACKNOWLEDGED: acknowledged
        ACKNOWLEDGED_AT: acknowledgedAt
        COMMENTS: comments
        ENTITY_TYPE: entityType
        ENTITY_ID: entityId
        ALARM_DISPLAY_NAME: displayName
        data
      }
    }
  }
}
    `;

/**
 * __useGetSignalAlarmPreviewAlarmsQuery__
 *
 * To run a query within a React component, call `useGetSignalAlarmPreviewAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalAlarmPreviewAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalAlarmPreviewAlarmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSignalAlarmPreviewAlarmsQuery(baseOptions?: Apollo.QueryHookOptions<GetSignalAlarmPreviewAlarmsQuery, GetSignalAlarmPreviewAlarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignalAlarmPreviewAlarmsQuery, GetSignalAlarmPreviewAlarmsQueryVariables>(GetSignalAlarmPreviewAlarmsDocument, options);
      }
export function useGetSignalAlarmPreviewAlarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignalAlarmPreviewAlarmsQuery, GetSignalAlarmPreviewAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignalAlarmPreviewAlarmsQuery, GetSignalAlarmPreviewAlarmsQueryVariables>(GetSignalAlarmPreviewAlarmsDocument, options);
        }
export type GetSignalAlarmPreviewAlarmsQueryHookResult = ReturnType<typeof useGetSignalAlarmPreviewAlarmsQuery>;
export type GetSignalAlarmPreviewAlarmsLazyQueryHookResult = ReturnType<typeof useGetSignalAlarmPreviewAlarmsLazyQuery>;
export type GetSignalAlarmPreviewAlarmsQueryResult = Apollo.QueryResult<GetSignalAlarmPreviewAlarmsQuery, GetSignalAlarmPreviewAlarmsQueryVariables>;
export function refetchGetSignalAlarmPreviewAlarmsQuery(variables?: GetSignalAlarmPreviewAlarmsQueryVariables) {
      return { query: GetSignalAlarmPreviewAlarmsDocument, variables: variables }
    }
export const GetGatesAlarmPreviewAlarmsDocument = gql`
    query GetGatesAlarmPreviewAlarms {
  alarms(query: {filters: [{operator: EQUALS, value: GATES, field: "source"}]}) {
    edges {
      node {
        ID: id
        ALARM_NAME: name
        ALARM_SEVERITY: severity
        ALARM_SOURCE: source
        RECEIVED_AT: receivedAt
        ACTIVE_AT: activeAt
        CLEARED_AT: clearedAt
        UPDATED_AT: updatedAt
        ACTIVE: active
        COUNT: count
        ACKNOWLEDGED: acknowledged
        ACKNOWLEDGED_AT: acknowledgedAt
        COMMENTS: comments
        ENTITY_TYPE: entityType
        ENTITY_ID: entityId
        data
      }
    }
  }
}
    `;

/**
 * __useGetGatesAlarmPreviewAlarmsQuery__
 *
 * To run a query within a React component, call `useGetGatesAlarmPreviewAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGatesAlarmPreviewAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGatesAlarmPreviewAlarmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGatesAlarmPreviewAlarmsQuery(baseOptions?: Apollo.QueryHookOptions<GetGatesAlarmPreviewAlarmsQuery, GetGatesAlarmPreviewAlarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGatesAlarmPreviewAlarmsQuery, GetGatesAlarmPreviewAlarmsQueryVariables>(GetGatesAlarmPreviewAlarmsDocument, options);
      }
export function useGetGatesAlarmPreviewAlarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGatesAlarmPreviewAlarmsQuery, GetGatesAlarmPreviewAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGatesAlarmPreviewAlarmsQuery, GetGatesAlarmPreviewAlarmsQueryVariables>(GetGatesAlarmPreviewAlarmsDocument, options);
        }
export type GetGatesAlarmPreviewAlarmsQueryHookResult = ReturnType<typeof useGetGatesAlarmPreviewAlarmsQuery>;
export type GetGatesAlarmPreviewAlarmsLazyQueryHookResult = ReturnType<typeof useGetGatesAlarmPreviewAlarmsLazyQuery>;
export type GetGatesAlarmPreviewAlarmsQueryResult = Apollo.QueryResult<GetGatesAlarmPreviewAlarmsQuery, GetGatesAlarmPreviewAlarmsQueryVariables>;
export function refetchGetGatesAlarmPreviewAlarmsQuery(variables?: GetGatesAlarmPreviewAlarmsQueryVariables) {
      return { query: GetGatesAlarmPreviewAlarmsDocument, variables: variables }
    }
export const GetSignsAlarmPreviewAlarmsDocument = gql`
    query GetSignsAlarmPreviewAlarms {
  alarms(query: {filters: [{operator: EQUALS, value: SIGNS, field: "source"}]}) {
    edges {
      node {
        ID: id
        ALARM_NAME: name
        ALARM_SEVERITY: severity
        ALARM_SOURCE: source
        RECEIVED_AT: receivedAt
        ACTIVE_AT: activeAt
        CLEARED_AT: clearedAt
        UPDATED_AT: updatedAt
        ACTIVE: active
        COUNT: count
        ACKNOWLEDGED: acknowledged
        ACKNOWLEDGED_AT: acknowledgedAt
        COMMENTS: comments
        ENTITY_TYPE: entityType
        ENTITY_ID: entityId
        data
      }
    }
  }
}
    `;

/**
 * __useGetSignsAlarmPreviewAlarmsQuery__
 *
 * To run a query within a React component, call `useGetSignsAlarmPreviewAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignsAlarmPreviewAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignsAlarmPreviewAlarmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSignsAlarmPreviewAlarmsQuery(baseOptions?: Apollo.QueryHookOptions<GetSignsAlarmPreviewAlarmsQuery, GetSignsAlarmPreviewAlarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignsAlarmPreviewAlarmsQuery, GetSignsAlarmPreviewAlarmsQueryVariables>(GetSignsAlarmPreviewAlarmsDocument, options);
      }
export function useGetSignsAlarmPreviewAlarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignsAlarmPreviewAlarmsQuery, GetSignsAlarmPreviewAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignsAlarmPreviewAlarmsQuery, GetSignsAlarmPreviewAlarmsQueryVariables>(GetSignsAlarmPreviewAlarmsDocument, options);
        }
export type GetSignsAlarmPreviewAlarmsQueryHookResult = ReturnType<typeof useGetSignsAlarmPreviewAlarmsQuery>;
export type GetSignsAlarmPreviewAlarmsLazyQueryHookResult = ReturnType<typeof useGetSignsAlarmPreviewAlarmsLazyQuery>;
export type GetSignsAlarmPreviewAlarmsQueryResult = Apollo.QueryResult<GetSignsAlarmPreviewAlarmsQuery, GetSignsAlarmPreviewAlarmsQueryVariables>;
export function refetchGetSignsAlarmPreviewAlarmsQuery(variables?: GetSignsAlarmPreviewAlarmsQueryVariables) {
      return { query: GetSignsAlarmPreviewAlarmsDocument, variables: variables }
    }
export const GetTravelTimeAlarmPreviewAlarmsDocument = gql`
    query GetTravelTimeAlarmPreviewAlarms {
  alarms(
    query: {filters: [{operator: EQUALS, value: TRAVEL_TIME, field: "source"}]}
  ) {
    edges {
      node {
        ID: id
        ALARM_NAME: name
        ALARM_SEVERITY: severity
        ALARM_SOURCE: source
        RECEIVED_AT: receivedAt
        ACTIVE_AT: activeAt
        CLEARED_AT: clearedAt
        UPDATED_AT: updatedAt
        ACTIVE: active
        COUNT: count
        ACKNOWLEDGED: acknowledged
        ACKNOWLEDGED_AT: acknowledgedAt
        COMMENTS: comments
        ENTITY_TYPE: entityType
        ENTITY_ID: entityId
        data
      }
    }
  }
}
    `;

/**
 * __useGetTravelTimeAlarmPreviewAlarmsQuery__
 *
 * To run a query within a React component, call `useGetTravelTimeAlarmPreviewAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTravelTimeAlarmPreviewAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTravelTimeAlarmPreviewAlarmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTravelTimeAlarmPreviewAlarmsQuery(baseOptions?: Apollo.QueryHookOptions<GetTravelTimeAlarmPreviewAlarmsQuery, GetTravelTimeAlarmPreviewAlarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTravelTimeAlarmPreviewAlarmsQuery, GetTravelTimeAlarmPreviewAlarmsQueryVariables>(GetTravelTimeAlarmPreviewAlarmsDocument, options);
      }
export function useGetTravelTimeAlarmPreviewAlarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTravelTimeAlarmPreviewAlarmsQuery, GetTravelTimeAlarmPreviewAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTravelTimeAlarmPreviewAlarmsQuery, GetTravelTimeAlarmPreviewAlarmsQueryVariables>(GetTravelTimeAlarmPreviewAlarmsDocument, options);
        }
export type GetTravelTimeAlarmPreviewAlarmsQueryHookResult = ReturnType<typeof useGetTravelTimeAlarmPreviewAlarmsQuery>;
export type GetTravelTimeAlarmPreviewAlarmsLazyQueryHookResult = ReturnType<typeof useGetTravelTimeAlarmPreviewAlarmsLazyQuery>;
export type GetTravelTimeAlarmPreviewAlarmsQueryResult = Apollo.QueryResult<GetTravelTimeAlarmPreviewAlarmsQuery, GetTravelTimeAlarmPreviewAlarmsQueryVariables>;
export function refetchGetTravelTimeAlarmPreviewAlarmsQuery(variables?: GetTravelTimeAlarmPreviewAlarmsQueryVariables) {
      return { query: GetTravelTimeAlarmPreviewAlarmsDocument, variables: variables }
    }
export const GetVideoAlarmPreviewAlarmsDocument = gql`
    query GetVideoAlarmPreviewAlarms {
  alarms(query: {filters: [{operator: EQUALS, value: VIDEO, field: "source"}]}) {
    edges {
      node {
        ID: id
        ALARM_NAME: name
        ALARM_SEVERITY: severity
        ALARM_SOURCE: source
        RECEIVED_AT: receivedAt
        ACTIVE_AT: activeAt
        CLEARED_AT: clearedAt
        UPDATED_AT: updatedAt
        ACTIVE: active
        COUNT: count
        ACKNOWLEDGED: acknowledged
        ACKNOWLEDGED_AT: acknowledgedAt
        COMMENTS: comments
        ENTITY_TYPE: entityType
        ENTITY_ID: entityId
        data
      }
    }
  }
}
    `;

/**
 * __useGetVideoAlarmPreviewAlarmsQuery__
 *
 * To run a query within a React component, call `useGetVideoAlarmPreviewAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoAlarmPreviewAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoAlarmPreviewAlarmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVideoAlarmPreviewAlarmsQuery(baseOptions?: Apollo.QueryHookOptions<GetVideoAlarmPreviewAlarmsQuery, GetVideoAlarmPreviewAlarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoAlarmPreviewAlarmsQuery, GetVideoAlarmPreviewAlarmsQueryVariables>(GetVideoAlarmPreviewAlarmsDocument, options);
      }
export function useGetVideoAlarmPreviewAlarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoAlarmPreviewAlarmsQuery, GetVideoAlarmPreviewAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoAlarmPreviewAlarmsQuery, GetVideoAlarmPreviewAlarmsQueryVariables>(GetVideoAlarmPreviewAlarmsDocument, options);
        }
export type GetVideoAlarmPreviewAlarmsQueryHookResult = ReturnType<typeof useGetVideoAlarmPreviewAlarmsQuery>;
export type GetVideoAlarmPreviewAlarmsLazyQueryHookResult = ReturnType<typeof useGetVideoAlarmPreviewAlarmsLazyQuery>;
export type GetVideoAlarmPreviewAlarmsQueryResult = Apollo.QueryResult<GetVideoAlarmPreviewAlarmsQuery, GetVideoAlarmPreviewAlarmsQueryVariables>;
export function refetchGetVideoAlarmPreviewAlarmsQuery(variables?: GetVideoAlarmPreviewAlarmsQueryVariables) {
      return { query: GetVideoAlarmPreviewAlarmsDocument, variables: variables }
    }
export const GetTollingAlarmPreviewAlarmsDocument = gql`
    query GetTollingAlarmPreviewAlarms {
  alarms(query: {filters: [{operator: EQUALS, value: TOLLING, field: "source"}]}) {
    edges {
      node {
        ID: id
        ALARM_NAME: name
        ALARM_SEVERITY: severity
        ALARM_SOURCE: source
        RECEIVED_AT: receivedAt
        ACTIVE_AT: activeAt
        CLEARED_AT: clearedAt
        UPDATED_AT: updatedAt
        ACTIVE: active
        COUNT: count
        ACKNOWLEDGED: acknowledged
        ACKNOWLEDGED_AT: acknowledgedAt
        COMMENTS: comments
        ENTITY_TYPE: entityType
        ENTITY_ID: entityId
        data
      }
    }
  }
}
    `;

/**
 * __useGetTollingAlarmPreviewAlarmsQuery__
 *
 * To run a query within a React component, call `useGetTollingAlarmPreviewAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTollingAlarmPreviewAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTollingAlarmPreviewAlarmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTollingAlarmPreviewAlarmsQuery(baseOptions?: Apollo.QueryHookOptions<GetTollingAlarmPreviewAlarmsQuery, GetTollingAlarmPreviewAlarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTollingAlarmPreviewAlarmsQuery, GetTollingAlarmPreviewAlarmsQueryVariables>(GetTollingAlarmPreviewAlarmsDocument, options);
      }
export function useGetTollingAlarmPreviewAlarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTollingAlarmPreviewAlarmsQuery, GetTollingAlarmPreviewAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTollingAlarmPreviewAlarmsQuery, GetTollingAlarmPreviewAlarmsQueryVariables>(GetTollingAlarmPreviewAlarmsDocument, options);
        }
export type GetTollingAlarmPreviewAlarmsQueryHookResult = ReturnType<typeof useGetTollingAlarmPreviewAlarmsQuery>;
export type GetTollingAlarmPreviewAlarmsLazyQueryHookResult = ReturnType<typeof useGetTollingAlarmPreviewAlarmsLazyQuery>;
export type GetTollingAlarmPreviewAlarmsQueryResult = Apollo.QueryResult<GetTollingAlarmPreviewAlarmsQuery, GetTollingAlarmPreviewAlarmsQueryVariables>;
export function refetchGetTollingAlarmPreviewAlarmsQuery(variables?: GetTollingAlarmPreviewAlarmsQueryVariables) {
      return { query: GetTollingAlarmPreviewAlarmsDocument, variables: variables }
    }
export const SaveEventDocument = gql`
    mutation SaveEvent($input: EventInput!) {
  saveEvent(input: $input) {
    ...Event
  }
}
    ${EventFragmentDoc}`;
export type SaveEventMutationFn = Apollo.MutationFunction<SaveEventMutation, SaveEventMutationVariables>;

/**
 * __useSaveEventMutation__
 *
 * To run a mutation, you first call `useSaveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventMutation, { data, loading, error }] = useSaveEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEventMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventMutation, SaveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventMutation, SaveEventMutationVariables>(SaveEventDocument, options);
      }
export type SaveEventMutationHookResult = ReturnType<typeof useSaveEventMutation>;
export type SaveEventMutationResult = Apollo.MutationResult<SaveEventMutation>;
export type SaveEventMutationOptions = Apollo.BaseMutationOptions<SaveEventMutation, SaveEventMutationVariables>;
export const TriggerResourcePlanRulesDocument = gql`
    mutation TriggerResourcePlanRules($id: ID!) {
  triggerResourcePlanRules(id: $id)
}
    `;
export type TriggerResourcePlanRulesMutationFn = Apollo.MutationFunction<TriggerResourcePlanRulesMutation, TriggerResourcePlanRulesMutationVariables>;

/**
 * __useTriggerResourcePlanRulesMutation__
 *
 * To run a mutation, you first call `useTriggerResourcePlanRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerResourcePlanRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerResourcePlanRulesMutation, { data, loading, error }] = useTriggerResourcePlanRulesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerResourcePlanRulesMutation(baseOptions?: Apollo.MutationHookOptions<TriggerResourcePlanRulesMutation, TriggerResourcePlanRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerResourcePlanRulesMutation, TriggerResourcePlanRulesMutationVariables>(TriggerResourcePlanRulesDocument, options);
      }
export type TriggerResourcePlanRulesMutationHookResult = ReturnType<typeof useTriggerResourcePlanRulesMutation>;
export type TriggerResourcePlanRulesMutationResult = Apollo.MutationResult<TriggerResourcePlanRulesMutation>;
export type TriggerResourcePlanRulesMutationOptions = Apollo.BaseMutationOptions<TriggerResourcePlanRulesMutation, TriggerResourcePlanRulesMutationVariables>;
export const SaveEventTypeDocument = gql`
    mutation SaveEventType($input: EventTypeInput!) {
  saveEventType(input: $input) {
    ...EventType
  }
}
    ${EventTypeFragmentDoc}`;
export type SaveEventTypeMutationFn = Apollo.MutationFunction<SaveEventTypeMutation, SaveEventTypeMutationVariables>;

/**
 * __useSaveEventTypeMutation__
 *
 * To run a mutation, you first call `useSaveEventTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventTypeMutation, { data, loading, error }] = useSaveEventTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEventTypeMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventTypeMutation, SaveEventTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventTypeMutation, SaveEventTypeMutationVariables>(SaveEventTypeDocument, options);
      }
export type SaveEventTypeMutationHookResult = ReturnType<typeof useSaveEventTypeMutation>;
export type SaveEventTypeMutationResult = Apollo.MutationResult<SaveEventTypeMutation>;
export type SaveEventTypeMutationOptions = Apollo.BaseMutationOptions<SaveEventTypeMutation, SaveEventTypeMutationVariables>;
export const DeleteEventTypeDocument = gql`
    mutation DeleteEventType($id: ID!) {
  deleteEventType(id: $id)
}
    `;
export type DeleteEventTypeMutationFn = Apollo.MutationFunction<DeleteEventTypeMutation, DeleteEventTypeMutationVariables>;

/**
 * __useDeleteEventTypeMutation__
 *
 * To run a mutation, you first call `useDeleteEventTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventTypeMutation, { data, loading, error }] = useDeleteEventTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventTypeMutation, DeleteEventTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventTypeMutation, DeleteEventTypeMutationVariables>(DeleteEventTypeDocument, options);
      }
export type DeleteEventTypeMutationHookResult = ReturnType<typeof useDeleteEventTypeMutation>;
export type DeleteEventTypeMutationResult = Apollo.MutationResult<DeleteEventTypeMutation>;
export type DeleteEventTypeMutationOptions = Apollo.BaseMutationOptions<DeleteEventTypeMutation, DeleteEventTypeMutationVariables>;
export const SaveEventsModuleSettingsDocument = gql`
    mutation saveEventsModuleSettings($settings: JSON!) {
  saveEventsModuleSettings(settings: $settings)
}
    `;
export type SaveEventsModuleSettingsMutationFn = Apollo.MutationFunction<SaveEventsModuleSettingsMutation, SaveEventsModuleSettingsMutationVariables>;

/**
 * __useSaveEventsModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveEventsModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventsModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventsModuleSettingsMutation, { data, loading, error }] = useSaveEventsModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveEventsModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventsModuleSettingsMutation, SaveEventsModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventsModuleSettingsMutation, SaveEventsModuleSettingsMutationVariables>(SaveEventsModuleSettingsDocument, options);
      }
export type SaveEventsModuleSettingsMutationHookResult = ReturnType<typeof useSaveEventsModuleSettingsMutation>;
export type SaveEventsModuleSettingsMutationResult = Apollo.MutationResult<SaveEventsModuleSettingsMutation>;
export type SaveEventsModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveEventsModuleSettingsMutation, SaveEventsModuleSettingsMutationVariables>;
export const SaveResponseModuleSettingsDocument = gql`
    mutation SaveResponseModuleSettings($settings: JSON!) {
  saveResponseModuleSettings(settings: $settings)
}
    `;
export type SaveResponseModuleSettingsMutationFn = Apollo.MutationFunction<SaveResponseModuleSettingsMutation, SaveResponseModuleSettingsMutationVariables>;

/**
 * __useSaveResponseModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveResponseModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveResponseModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveResponseModuleSettingsMutation, { data, loading, error }] = useSaveResponseModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveResponseModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveResponseModuleSettingsMutation, SaveResponseModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveResponseModuleSettingsMutation, SaveResponseModuleSettingsMutationVariables>(SaveResponseModuleSettingsDocument, options);
      }
export type SaveResponseModuleSettingsMutationHookResult = ReturnType<typeof useSaveResponseModuleSettingsMutation>;
export type SaveResponseModuleSettingsMutationResult = Apollo.MutationResult<SaveResponseModuleSettingsMutation>;
export type SaveResponseModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveResponseModuleSettingsMutation, SaveResponseModuleSettingsMutationVariables>;
export const SaveEventTemplateDocument = gql`
    mutation SaveEventTemplate($input: EventTemplateInput!) {
  saveEventTemplate(input: $input) {
    id
  }
}
    `;
export type SaveEventTemplateMutationFn = Apollo.MutationFunction<SaveEventTemplateMutation, SaveEventTemplateMutationVariables>;

/**
 * __useSaveEventTemplateMutation__
 *
 * To run a mutation, you first call `useSaveEventTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventTemplateMutation, { data, loading, error }] = useSaveEventTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEventTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventTemplateMutation, SaveEventTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventTemplateMutation, SaveEventTemplateMutationVariables>(SaveEventTemplateDocument, options);
      }
export type SaveEventTemplateMutationHookResult = ReturnType<typeof useSaveEventTemplateMutation>;
export type SaveEventTemplateMutationResult = Apollo.MutationResult<SaveEventTemplateMutation>;
export type SaveEventTemplateMutationOptions = Apollo.BaseMutationOptions<SaveEventTemplateMutation, SaveEventTemplateMutationVariables>;
export const DeleteEventTemplateDocument = gql`
    mutation DeleteEventTemplate($id: ID!) {
  deleteEventTemplate(id: $id)
}
    `;
export type DeleteEventTemplateMutationFn = Apollo.MutationFunction<DeleteEventTemplateMutation, DeleteEventTemplateMutationVariables>;

/**
 * __useDeleteEventTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEventTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventTemplateMutation, { data, loading, error }] = useDeleteEventTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventTemplateMutation, DeleteEventTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventTemplateMutation, DeleteEventTemplateMutationVariables>(DeleteEventTemplateDocument, options);
      }
export type DeleteEventTemplateMutationHookResult = ReturnType<typeof useDeleteEventTemplateMutation>;
export type DeleteEventTemplateMutationResult = Apollo.MutationResult<DeleteEventTemplateMutation>;
export type DeleteEventTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteEventTemplateMutation, DeleteEventTemplateMutationVariables>;
export const SaveAndCloseEventDocument = gql`
    mutation SaveAndCloseEvent($input: EventInput!, $sceneClear: DateTime, $lanesClear: DateTime, $closureResolution: String) {
  saveAndCloseEvent(
    input: $input
    lanesClear: $lanesClear
    sceneClear: $sceneClear
    closureResolution: $closureResolution
  )
}
    `;
export type SaveAndCloseEventMutationFn = Apollo.MutationFunction<SaveAndCloseEventMutation, SaveAndCloseEventMutationVariables>;

/**
 * __useSaveAndCloseEventMutation__
 *
 * To run a mutation, you first call `useSaveAndCloseEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAndCloseEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAndCloseEventMutation, { data, loading, error }] = useSaveAndCloseEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sceneClear: // value for 'sceneClear'
 *      lanesClear: // value for 'lanesClear'
 *      closureResolution: // value for 'closureResolution'
 *   },
 * });
 */
export function useSaveAndCloseEventMutation(baseOptions?: Apollo.MutationHookOptions<SaveAndCloseEventMutation, SaveAndCloseEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAndCloseEventMutation, SaveAndCloseEventMutationVariables>(SaveAndCloseEventDocument, options);
      }
export type SaveAndCloseEventMutationHookResult = ReturnType<typeof useSaveAndCloseEventMutation>;
export type SaveAndCloseEventMutationResult = Apollo.MutationResult<SaveAndCloseEventMutation>;
export type SaveAndCloseEventMutationOptions = Apollo.BaseMutationOptions<SaveAndCloseEventMutation, SaveAndCloseEventMutationVariables>;
export const CancelEventTaskOccurrenceDocument = gql`
    mutation CancelEventTaskOccurrence($id: ID!, $date: DateTime!) {
  cancelTaskOccurrence(id: $id, date: $date)
}
    `;
export type CancelEventTaskOccurrenceMutationFn = Apollo.MutationFunction<CancelEventTaskOccurrenceMutation, CancelEventTaskOccurrenceMutationVariables>;

/**
 * __useCancelEventTaskOccurrenceMutation__
 *
 * To run a mutation, you first call `useCancelEventTaskOccurrenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEventTaskOccurrenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEventTaskOccurrenceMutation, { data, loading, error }] = useCancelEventTaskOccurrenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCancelEventTaskOccurrenceMutation(baseOptions?: Apollo.MutationHookOptions<CancelEventTaskOccurrenceMutation, CancelEventTaskOccurrenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelEventTaskOccurrenceMutation, CancelEventTaskOccurrenceMutationVariables>(CancelEventTaskOccurrenceDocument, options);
      }
export type CancelEventTaskOccurrenceMutationHookResult = ReturnType<typeof useCancelEventTaskOccurrenceMutation>;
export type CancelEventTaskOccurrenceMutationResult = Apollo.MutationResult<CancelEventTaskOccurrenceMutation>;
export type CancelEventTaskOccurrenceMutationOptions = Apollo.BaseMutationOptions<CancelEventTaskOccurrenceMutation, CancelEventTaskOccurrenceMutationVariables>;
export const CloneEventDocument = gql`
    mutation CloneEvent($id: ID!) {
  cloneEvent(id: $id) {
    ...Event
  }
}
    ${EventFragmentDoc}`;
export type CloneEventMutationFn = Apollo.MutationFunction<CloneEventMutation, CloneEventMutationVariables>;

/**
 * __useCloneEventMutation__
 *
 * To run a mutation, you first call `useCloneEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneEventMutation, { data, loading, error }] = useCloneEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneEventMutation(baseOptions?: Apollo.MutationHookOptions<CloneEventMutation, CloneEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneEventMutation, CloneEventMutationVariables>(CloneEventDocument, options);
      }
export type CloneEventMutationHookResult = ReturnType<typeof useCloneEventMutation>;
export type CloneEventMutationResult = Apollo.MutationResult<CloneEventMutation>;
export type CloneEventMutationOptions = Apollo.BaseMutationOptions<CloneEventMutation, CloneEventMutationVariables>;
export const CloseEventDocument = gql`
    mutation CloseEvent($id: ID!, $sceneClear: DateTime!, $lanesClear: DateTime!) {
  closeEvent(id: $id, lanesClear: $lanesClear, sceneClear: $sceneClear)
}
    `;
export type CloseEventMutationFn = Apollo.MutationFunction<CloseEventMutation, CloseEventMutationVariables>;

/**
 * __useCloseEventMutation__
 *
 * To run a mutation, you first call `useCloseEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeEventMutation, { data, loading, error }] = useCloseEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sceneClear: // value for 'sceneClear'
 *      lanesClear: // value for 'lanesClear'
 *   },
 * });
 */
export function useCloseEventMutation(baseOptions?: Apollo.MutationHookOptions<CloseEventMutation, CloseEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseEventMutation, CloseEventMutationVariables>(CloseEventDocument, options);
      }
export type CloseEventMutationHookResult = ReturnType<typeof useCloseEventMutation>;
export type CloseEventMutationResult = Apollo.MutationResult<CloseEventMutation>;
export type CloseEventMutationOptions = Apollo.BaseMutationOptions<CloseEventMutation, CloseEventMutationVariables>;
export const RejectEventDocument = gql`
    mutation RejectEvent($id: ID!, $rejectionReasons: [String!]!) {
  rejectEvent(id: $id, rejectionReasons: $rejectionReasons)
}
    `;
export type RejectEventMutationFn = Apollo.MutationFunction<RejectEventMutation, RejectEventMutationVariables>;

/**
 * __useRejectEventMutation__
 *
 * To run a mutation, you first call `useRejectEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectEventMutation, { data, loading, error }] = useRejectEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rejectionReasons: // value for 'rejectionReasons'
 *   },
 * });
 */
export function useRejectEventMutation(baseOptions?: Apollo.MutationHookOptions<RejectEventMutation, RejectEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectEventMutation, RejectEventMutationVariables>(RejectEventDocument, options);
      }
export type RejectEventMutationHookResult = ReturnType<typeof useRejectEventMutation>;
export type RejectEventMutationResult = Apollo.MutationResult<RejectEventMutation>;
export type RejectEventMutationOptions = Apollo.BaseMutationOptions<RejectEventMutation, RejectEventMutationVariables>;
export const LinkEventDocument = gql`
    mutation LinkEvent($eventId: ID!, $link: EventLinkInput!) {
  linkEvent(eventId: $eventId, link: $link)
}
    `;
export type LinkEventMutationFn = Apollo.MutationFunction<LinkEventMutation, LinkEventMutationVariables>;

/**
 * __useLinkEventMutation__
 *
 * To run a mutation, you first call `useLinkEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEventMutation, { data, loading, error }] = useLinkEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useLinkEventMutation(baseOptions?: Apollo.MutationHookOptions<LinkEventMutation, LinkEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkEventMutation, LinkEventMutationVariables>(LinkEventDocument, options);
      }
export type LinkEventMutationHookResult = ReturnType<typeof useLinkEventMutation>;
export type LinkEventMutationResult = Apollo.MutationResult<LinkEventMutation>;
export type LinkEventMutationOptions = Apollo.BaseMutationOptions<LinkEventMutation, LinkEventMutationVariables>;
export const IgnoreDetectionsDocument = gql`
    mutation IgnoreDetections($ids: [ID!]!) {
  ignoreDetections(ids: $ids)
}
    `;
export type IgnoreDetectionsMutationFn = Apollo.MutationFunction<IgnoreDetectionsMutation, IgnoreDetectionsMutationVariables>;

/**
 * __useIgnoreDetectionsMutation__
 *
 * To run a mutation, you first call `useIgnoreDetectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreDetectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreDetectionsMutation, { data, loading, error }] = useIgnoreDetectionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useIgnoreDetectionsMutation(baseOptions?: Apollo.MutationHookOptions<IgnoreDetectionsMutation, IgnoreDetectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnoreDetectionsMutation, IgnoreDetectionsMutationVariables>(IgnoreDetectionsDocument, options);
      }
export type IgnoreDetectionsMutationHookResult = ReturnType<typeof useIgnoreDetectionsMutation>;
export type IgnoreDetectionsMutationResult = Apollo.MutationResult<IgnoreDetectionsMutation>;
export type IgnoreDetectionsMutationOptions = Apollo.BaseMutationOptions<IgnoreDetectionsMutation, IgnoreDetectionsMutationVariables>;
export const SaveEventResourcePlanDocument = gql`
    mutation SaveEventResourcePlan($input: ResourcePlanInput!) {
  saveResourcePlan(input: $input) {
    ...ResourcePlan
  }
}
    ${ResourcePlanFragmentDoc}`;
export type SaveEventResourcePlanMutationFn = Apollo.MutationFunction<SaveEventResourcePlanMutation, SaveEventResourcePlanMutationVariables>;

/**
 * __useSaveEventResourcePlanMutation__
 *
 * To run a mutation, you first call `useSaveEventResourcePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventResourcePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventResourcePlanMutation, { data, loading, error }] = useSaveEventResourcePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEventResourcePlanMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventResourcePlanMutation, SaveEventResourcePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventResourcePlanMutation, SaveEventResourcePlanMutationVariables>(SaveEventResourcePlanDocument, options);
      }
export type SaveEventResourcePlanMutationHookResult = ReturnType<typeof useSaveEventResourcePlanMutation>;
export type SaveEventResourcePlanMutationResult = Apollo.MutationResult<SaveEventResourcePlanMutation>;
export type SaveEventResourcePlanMutationOptions = Apollo.BaseMutationOptions<SaveEventResourcePlanMutation, SaveEventResourcePlanMutationVariables>;
export const SaveResourcePlanTaskDocument = gql`
    mutation SaveResourcePlanTask($input: TaskInput!) {
  saveResourcePlanTask(input: $input) {
    ...ResourcePlanTaskFragment
  }
}
    ${ResourcePlanTaskFragmentFragmentDoc}`;
export type SaveResourcePlanTaskMutationFn = Apollo.MutationFunction<SaveResourcePlanTaskMutation, SaveResourcePlanTaskMutationVariables>;

/**
 * __useSaveResourcePlanTaskMutation__
 *
 * To run a mutation, you first call `useSaveResourcePlanTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveResourcePlanTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveResourcePlanTaskMutation, { data, loading, error }] = useSaveResourcePlanTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveResourcePlanTaskMutation(baseOptions?: Apollo.MutationHookOptions<SaveResourcePlanTaskMutation, SaveResourcePlanTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveResourcePlanTaskMutation, SaveResourcePlanTaskMutationVariables>(SaveResourcePlanTaskDocument, options);
      }
export type SaveResourcePlanTaskMutationHookResult = ReturnType<typeof useSaveResourcePlanTaskMutation>;
export type SaveResourcePlanTaskMutationResult = Apollo.MutationResult<SaveResourcePlanTaskMutation>;
export type SaveResourcePlanTaskMutationOptions = Apollo.BaseMutationOptions<SaveResourcePlanTaskMutation, SaveResourcePlanTaskMutationVariables>;
export const SaveScheduledEventTaskDocument = gql`
    mutation SaveScheduledEventTask($input: TaskInput!) {
  saveScheduledEventTask(input: $input) {
    ...ResourcePlanTaskFragment
  }
}
    ${ResourcePlanTaskFragmentFragmentDoc}`;
export type SaveScheduledEventTaskMutationFn = Apollo.MutationFunction<SaveScheduledEventTaskMutation, SaveScheduledEventTaskMutationVariables>;

/**
 * __useSaveScheduledEventTaskMutation__
 *
 * To run a mutation, you first call `useSaveScheduledEventTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduledEventTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScheduledEventTaskMutation, { data, loading, error }] = useSaveScheduledEventTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveScheduledEventTaskMutation(baseOptions?: Apollo.MutationHookOptions<SaveScheduledEventTaskMutation, SaveScheduledEventTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveScheduledEventTaskMutation, SaveScheduledEventTaskMutationVariables>(SaveScheduledEventTaskDocument, options);
      }
export type SaveScheduledEventTaskMutationHookResult = ReturnType<typeof useSaveScheduledEventTaskMutation>;
export type SaveScheduledEventTaskMutationResult = Apollo.MutationResult<SaveScheduledEventTaskMutation>;
export type SaveScheduledEventTaskMutationOptions = Apollo.BaseMutationOptions<SaveScheduledEventTaskMutation, SaveScheduledEventTaskMutationVariables>;
export const DeleteResourcePlanTaskDocument = gql`
    mutation DeleteResourcePlanTask($id: ID!) {
  deleteResourcePlanTask(id: $id)
}
    `;
export type DeleteResourcePlanTaskMutationFn = Apollo.MutationFunction<DeleteResourcePlanTaskMutation, DeleteResourcePlanTaskMutationVariables>;

/**
 * __useDeleteResourcePlanTaskMutation__
 *
 * To run a mutation, you first call `useDeleteResourcePlanTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourcePlanTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourcePlanTaskMutation, { data, loading, error }] = useDeleteResourcePlanTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourcePlanTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourcePlanTaskMutation, DeleteResourcePlanTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourcePlanTaskMutation, DeleteResourcePlanTaskMutationVariables>(DeleteResourcePlanTaskDocument, options);
      }
export type DeleteResourcePlanTaskMutationHookResult = ReturnType<typeof useDeleteResourcePlanTaskMutation>;
export type DeleteResourcePlanTaskMutationResult = Apollo.MutationResult<DeleteResourcePlanTaskMutation>;
export type DeleteResourcePlanTaskMutationOptions = Apollo.BaseMutationOptions<DeleteResourcePlanTaskMutation, DeleteResourcePlanTaskMutationVariables>;
export const DeleteScheduledEventTaskDocument = gql`
    mutation DeleteScheduledEventTask($id: ID!) {
  deleteScheduledEventTask(id: $id)
}
    `;
export type DeleteScheduledEventTaskMutationFn = Apollo.MutationFunction<DeleteScheduledEventTaskMutation, DeleteScheduledEventTaskMutationVariables>;

/**
 * __useDeleteScheduledEventTaskMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledEventTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledEventTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledEventTaskMutation, { data, loading, error }] = useDeleteScheduledEventTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduledEventTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledEventTaskMutation, DeleteScheduledEventTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledEventTaskMutation, DeleteScheduledEventTaskMutationVariables>(DeleteScheduledEventTaskDocument, options);
      }
export type DeleteScheduledEventTaskMutationHookResult = ReturnType<typeof useDeleteScheduledEventTaskMutation>;
export type DeleteScheduledEventTaskMutationResult = Apollo.MutationResult<DeleteScheduledEventTaskMutation>;
export type DeleteScheduledEventTaskMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledEventTaskMutation, DeleteScheduledEventTaskMutationVariables>;
export const ExpireResourcePlanDocument = gql`
    mutation ExpireResourcePlan($id: ID!, $resources: [ID!]) {
  expireResources(id: $id, resources: $resources) {
    requestId
    failure
    success
    id
  }
}
    `;
export type ExpireResourcePlanMutationFn = Apollo.MutationFunction<ExpireResourcePlanMutation, ExpireResourcePlanMutationVariables>;

/**
 * __useExpireResourcePlanMutation__
 *
 * To run a mutation, you first call `useExpireResourcePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireResourcePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireResourcePlanMutation, { data, loading, error }] = useExpireResourcePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resources: // value for 'resources'
 *   },
 * });
 */
export function useExpireResourcePlanMutation(baseOptions?: Apollo.MutationHookOptions<ExpireResourcePlanMutation, ExpireResourcePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpireResourcePlanMutation, ExpireResourcePlanMutationVariables>(ExpireResourcePlanDocument, options);
      }
export type ExpireResourcePlanMutationHookResult = ReturnType<typeof useExpireResourcePlanMutation>;
export type ExpireResourcePlanMutationResult = Apollo.MutationResult<ExpireResourcePlanMutation>;
export type ExpireResourcePlanMutationOptions = Apollo.BaseMutationOptions<ExpireResourcePlanMutation, ExpireResourcePlanMutationVariables>;
export const ActivateResourcesDocument = gql`
    mutation ActivateResources($id: ID!, $resources: [ID!], $data: Object) {
  activateResources(id: $id, resources: $resources, data: $data) {
    requestId
    success
    failure
    id
  }
}
    `;
export type ActivateResourcesMutationFn = Apollo.MutationFunction<ActivateResourcesMutation, ActivateResourcesMutationVariables>;

/**
 * __useActivateResourcesMutation__
 *
 * To run a mutation, you first call `useActivateResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateResourcesMutation, { data, loading, error }] = useActivateResourcesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resources: // value for 'resources'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useActivateResourcesMutation(baseOptions?: Apollo.MutationHookOptions<ActivateResourcesMutation, ActivateResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateResourcesMutation, ActivateResourcesMutationVariables>(ActivateResourcesDocument, options);
      }
export type ActivateResourcesMutationHookResult = ReturnType<typeof useActivateResourcesMutation>;
export type ActivateResourcesMutationResult = Apollo.MutationResult<ActivateResourcesMutation>;
export type ActivateResourcesMutationOptions = Apollo.BaseMutationOptions<ActivateResourcesMutation, ActivateResourcesMutationVariables>;
export const AcknowledgeResourcesDocument = gql`
    mutation AcknowledgeResources($id: ID!, $resources: [ID!]!) {
  acknowledgeResources(id: $id, resources: $resources) {
    ...ResourcePlan
  }
}
    ${ResourcePlanFragmentDoc}`;
export type AcknowledgeResourcesMutationFn = Apollo.MutationFunction<AcknowledgeResourcesMutation, AcknowledgeResourcesMutationVariables>;

/**
 * __useAcknowledgeResourcesMutation__
 *
 * To run a mutation, you first call `useAcknowledgeResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeResourcesMutation, { data, loading, error }] = useAcknowledgeResourcesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resources: // value for 'resources'
 *   },
 * });
 */
export function useAcknowledgeResourcesMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeResourcesMutation, AcknowledgeResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeResourcesMutation, AcknowledgeResourcesMutationVariables>(AcknowledgeResourcesDocument, options);
      }
export type AcknowledgeResourcesMutationHookResult = ReturnType<typeof useAcknowledgeResourcesMutation>;
export type AcknowledgeResourcesMutationResult = Apollo.MutationResult<AcknowledgeResourcesMutation>;
export type AcknowledgeResourcesMutationOptions = Apollo.BaseMutationOptions<AcknowledgeResourcesMutation, AcknowledgeResourcesMutationVariables>;
export const ExpireResourcesDocument = gql`
    mutation ExpireResources($id: ID!, $resources: [ID!]) {
  expireResources(id: $id, resources: $resources) {
    requestId
    success
    failure
    id
  }
}
    `;
export type ExpireResourcesMutationFn = Apollo.MutationFunction<ExpireResourcesMutation, ExpireResourcesMutationVariables>;

/**
 * __useExpireResourcesMutation__
 *
 * To run a mutation, you first call `useExpireResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireResourcesMutation, { data, loading, error }] = useExpireResourcesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resources: // value for 'resources'
 *   },
 * });
 */
export function useExpireResourcesMutation(baseOptions?: Apollo.MutationHookOptions<ExpireResourcesMutation, ExpireResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpireResourcesMutation, ExpireResourcesMutationVariables>(ExpireResourcesDocument, options);
      }
export type ExpireResourcesMutationHookResult = ReturnType<typeof useExpireResourcesMutation>;
export type ExpireResourcesMutationResult = Apollo.MutationResult<ExpireResourcesMutation>;
export type ExpireResourcesMutationOptions = Apollo.BaseMutationOptions<ExpireResourcesMutation, ExpireResourcesMutationVariables>;
export const SaveEventActivityLogDocument = gql`
    mutation SaveEventActivityLog($input: ActivityLogInput!) {
  addActivityLog(input: $input) {
    id
  }
}
    `;
export type SaveEventActivityLogMutationFn = Apollo.MutationFunction<SaveEventActivityLogMutation, SaveEventActivityLogMutationVariables>;

/**
 * __useSaveEventActivityLogMutation__
 *
 * To run a mutation, you first call `useSaveEventActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventActivityLogMutation, { data, loading, error }] = useSaveEventActivityLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEventActivityLogMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventActivityLogMutation, SaveEventActivityLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventActivityLogMutation, SaveEventActivityLogMutationVariables>(SaveEventActivityLogDocument, options);
      }
export type SaveEventActivityLogMutationHookResult = ReturnType<typeof useSaveEventActivityLogMutation>;
export type SaveEventActivityLogMutationResult = Apollo.MutationResult<SaveEventActivityLogMutation>;
export type SaveEventActivityLogMutationOptions = Apollo.BaseMutationOptions<SaveEventActivityLogMutation, SaveEventActivityLogMutationVariables>;
export const SaveEventNoteDocument = gql`
    mutation SaveEventNote($id: ID!, $content: String!) {
  saveEventNote(id: $id, content: $content)
}
    `;
export type SaveEventNoteMutationFn = Apollo.MutationFunction<SaveEventNoteMutation, SaveEventNoteMutationVariables>;

/**
 * __useSaveEventNoteMutation__
 *
 * To run a mutation, you first call `useSaveEventNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventNoteMutation, { data, loading, error }] = useSaveEventNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useSaveEventNoteMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventNoteMutation, SaveEventNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventNoteMutation, SaveEventNoteMutationVariables>(SaveEventNoteDocument, options);
      }
export type SaveEventNoteMutationHookResult = ReturnType<typeof useSaveEventNoteMutation>;
export type SaveEventNoteMutationResult = Apollo.MutationResult<SaveEventNoteMutation>;
export type SaveEventNoteMutationOptions = Apollo.BaseMutationOptions<SaveEventNoteMutation, SaveEventNoteMutationVariables>;
export const RemoveEventLinkDocument = gql`
    mutation RemoveEventLink($eventId: ID!, $linkId: ID!) {
  unlinkEvent(eventId: $eventId, linkId: $linkId)
}
    `;
export type RemoveEventLinkMutationFn = Apollo.MutationFunction<RemoveEventLinkMutation, RemoveEventLinkMutationVariables>;

/**
 * __useRemoveEventLinkMutation__
 *
 * To run a mutation, you first call `useRemoveEventLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventLinkMutation, { data, loading, error }] = useRemoveEventLinkMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useRemoveEventLinkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventLinkMutation, RemoveEventLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventLinkMutation, RemoveEventLinkMutationVariables>(RemoveEventLinkDocument, options);
      }
export type RemoveEventLinkMutationHookResult = ReturnType<typeof useRemoveEventLinkMutation>;
export type RemoveEventLinkMutationResult = Apollo.MutationResult<RemoveEventLinkMutation>;
export type RemoveEventLinkMutationOptions = Apollo.BaseMutationOptions<RemoveEventLinkMutation, RemoveEventLinkMutationVariables>;
export const SaveActivationConfirmationDocument = gql`
    mutation SaveActivationConfirmation($id: ID!, $confirmationRequired: Boolean!) {
  saveActivationConfirmation(id: $id, confirmationRequired: $confirmationRequired)
}
    `;
export type SaveActivationConfirmationMutationFn = Apollo.MutationFunction<SaveActivationConfirmationMutation, SaveActivationConfirmationMutationVariables>;

/**
 * __useSaveActivationConfirmationMutation__
 *
 * To run a mutation, you first call `useSaveActivationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveActivationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveActivationConfirmationMutation, { data, loading, error }] = useSaveActivationConfirmationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      confirmationRequired: // value for 'confirmationRequired'
 *   },
 * });
 */
export function useSaveActivationConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<SaveActivationConfirmationMutation, SaveActivationConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveActivationConfirmationMutation, SaveActivationConfirmationMutationVariables>(SaveActivationConfirmationDocument, options);
      }
export type SaveActivationConfirmationMutationHookResult = ReturnType<typeof useSaveActivationConfirmationMutation>;
export type SaveActivationConfirmationMutationResult = Apollo.MutationResult<SaveActivationConfirmationMutation>;
export type SaveActivationConfirmationMutationOptions = Apollo.BaseMutationOptions<SaveActivationConfirmationMutation, SaveActivationConfirmationMutationVariables>;
export const AssociateDetectionsToEventDocument = gql`
    mutation AssociateDetectionsToEvent($detectionIds: [ID!]!, $eventId: ID!) {
  associateDetectionsToEvent(detectionIds: $detectionIds, eventId: $eventId)
}
    `;
export type AssociateDetectionsToEventMutationFn = Apollo.MutationFunction<AssociateDetectionsToEventMutation, AssociateDetectionsToEventMutationVariables>;

/**
 * __useAssociateDetectionsToEventMutation__
 *
 * To run a mutation, you first call `useAssociateDetectionsToEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateDetectionsToEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateDetectionsToEventMutation, { data, loading, error }] = useAssociateDetectionsToEventMutation({
 *   variables: {
 *      detectionIds: // value for 'detectionIds'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAssociateDetectionsToEventMutation(baseOptions?: Apollo.MutationHookOptions<AssociateDetectionsToEventMutation, AssociateDetectionsToEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateDetectionsToEventMutation, AssociateDetectionsToEventMutationVariables>(AssociateDetectionsToEventDocument, options);
      }
export type AssociateDetectionsToEventMutationHookResult = ReturnType<typeof useAssociateDetectionsToEventMutation>;
export type AssociateDetectionsToEventMutationResult = Apollo.MutationResult<AssociateDetectionsToEventMutation>;
export type AssociateDetectionsToEventMutationOptions = Apollo.BaseMutationOptions<AssociateDetectionsToEventMutation, AssociateDetectionsToEventMutationVariables>;
export const RemoveAssociatedDetectionsFromEventDocument = gql`
    mutation RemoveAssociatedDetectionsFromEvent($detectionIds: [ID!]!, $eventId: ID!) {
  removeAssociatedDetectionsFromEvent(
    detectionIds: $detectionIds
    eventId: $eventId
  )
}
    `;
export type RemoveAssociatedDetectionsFromEventMutationFn = Apollo.MutationFunction<RemoveAssociatedDetectionsFromEventMutation, RemoveAssociatedDetectionsFromEventMutationVariables>;

/**
 * __useRemoveAssociatedDetectionsFromEventMutation__
 *
 * To run a mutation, you first call `useRemoveAssociatedDetectionsFromEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssociatedDetectionsFromEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssociatedDetectionsFromEventMutation, { data, loading, error }] = useRemoveAssociatedDetectionsFromEventMutation({
 *   variables: {
 *      detectionIds: // value for 'detectionIds'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRemoveAssociatedDetectionsFromEventMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssociatedDetectionsFromEventMutation, RemoveAssociatedDetectionsFromEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssociatedDetectionsFromEventMutation, RemoveAssociatedDetectionsFromEventMutationVariables>(RemoveAssociatedDetectionsFromEventDocument, options);
      }
export type RemoveAssociatedDetectionsFromEventMutationHookResult = ReturnType<typeof useRemoveAssociatedDetectionsFromEventMutation>;
export type RemoveAssociatedDetectionsFromEventMutationResult = Apollo.MutationResult<RemoveAssociatedDetectionsFromEventMutation>;
export type RemoveAssociatedDetectionsFromEventMutationOptions = Apollo.BaseMutationOptions<RemoveAssociatedDetectionsFromEventMutation, RemoveAssociatedDetectionsFromEventMutationVariables>;
export const AssociateDetectionToEventsDocument = gql`
    mutation AssociateDetectionToEvents($detectionId: ID!, $eventIds: [ID!]!) {
  associateDetectionToEvents(detectionId: $detectionId, eventIds: $eventIds)
}
    `;
export type AssociateDetectionToEventsMutationFn = Apollo.MutationFunction<AssociateDetectionToEventsMutation, AssociateDetectionToEventsMutationVariables>;

/**
 * __useAssociateDetectionToEventsMutation__
 *
 * To run a mutation, you first call `useAssociateDetectionToEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateDetectionToEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateDetectionToEventsMutation, { data, loading, error }] = useAssociateDetectionToEventsMutation({
 *   variables: {
 *      detectionId: // value for 'detectionId'
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useAssociateDetectionToEventsMutation(baseOptions?: Apollo.MutationHookOptions<AssociateDetectionToEventsMutation, AssociateDetectionToEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateDetectionToEventsMutation, AssociateDetectionToEventsMutationVariables>(AssociateDetectionToEventsDocument, options);
      }
export type AssociateDetectionToEventsMutationHookResult = ReturnType<typeof useAssociateDetectionToEventsMutation>;
export type AssociateDetectionToEventsMutationResult = Apollo.MutationResult<AssociateDetectionToEventsMutation>;
export type AssociateDetectionToEventsMutationOptions = Apollo.BaseMutationOptions<AssociateDetectionToEventsMutation, AssociateDetectionToEventsMutationVariables>;
export const RemoveAssociatedEventsFromDetectionsDocument = gql`
    mutation RemoveAssociatedEventsFromDetections($detectionIds: [ID!]!, $eventIds: [ID!]!) {
  removeAssociatedEventsFromDetections(
    detectionIds: $detectionIds
    eventIds: $eventIds
  )
}
    `;
export type RemoveAssociatedEventsFromDetectionsMutationFn = Apollo.MutationFunction<RemoveAssociatedEventsFromDetectionsMutation, RemoveAssociatedEventsFromDetectionsMutationVariables>;

/**
 * __useRemoveAssociatedEventsFromDetectionsMutation__
 *
 * To run a mutation, you first call `useRemoveAssociatedEventsFromDetectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssociatedEventsFromDetectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssociatedEventsFromDetectionsMutation, { data, loading, error }] = useRemoveAssociatedEventsFromDetectionsMutation({
 *   variables: {
 *      detectionIds: // value for 'detectionIds'
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useRemoveAssociatedEventsFromDetectionsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssociatedEventsFromDetectionsMutation, RemoveAssociatedEventsFromDetectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssociatedEventsFromDetectionsMutation, RemoveAssociatedEventsFromDetectionsMutationVariables>(RemoveAssociatedEventsFromDetectionsDocument, options);
      }
export type RemoveAssociatedEventsFromDetectionsMutationHookResult = ReturnType<typeof useRemoveAssociatedEventsFromDetectionsMutation>;
export type RemoveAssociatedEventsFromDetectionsMutationResult = Apollo.MutationResult<RemoveAssociatedEventsFromDetectionsMutation>;
export type RemoveAssociatedEventsFromDetectionsMutationOptions = Apollo.BaseMutationOptions<RemoveAssociatedEventsFromDetectionsMutation, RemoveAssociatedEventsFromDetectionsMutationVariables>;
export const RemoveSignAssociationsDocument = gql`
    mutation RemoveSignAssociations($signs: [ID!]!, $associationId: ID!) {
  removeAssociations(signs: $signs, associationId: $associationId) {
    requestId
    success
    failure
    id
  }
}
    `;
export type RemoveSignAssociationsMutationFn = Apollo.MutationFunction<RemoveSignAssociationsMutation, RemoveSignAssociationsMutationVariables>;

/**
 * __useRemoveSignAssociationsMutation__
 *
 * To run a mutation, you first call `useRemoveSignAssociationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSignAssociationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSignAssociationsMutation, { data, loading, error }] = useRemoveSignAssociationsMutation({
 *   variables: {
 *      signs: // value for 'signs'
 *      associationId: // value for 'associationId'
 *   },
 * });
 */
export function useRemoveSignAssociationsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSignAssociationsMutation, RemoveSignAssociationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSignAssociationsMutation, RemoveSignAssociationsMutationVariables>(RemoveSignAssociationsDocument, options);
      }
export type RemoveSignAssociationsMutationHookResult = ReturnType<typeof useRemoveSignAssociationsMutation>;
export type RemoveSignAssociationsMutationResult = Apollo.MutationResult<RemoveSignAssociationsMutation>;
export type RemoveSignAssociationsMutationOptions = Apollo.BaseMutationOptions<RemoveSignAssociationsMutation, RemoveSignAssociationsMutationVariables>;
export const AssociateCommLogsToEventsDocument = gql`
    mutation AssociateCommLogsToEvents($commLogIds: [ID!]!, $eventIds: [ID!]!) {
  associateCommLogsToEvents(commLogIds: $commLogIds, eventIds: $eventIds)
}
    `;
export type AssociateCommLogsToEventsMutationFn = Apollo.MutationFunction<AssociateCommLogsToEventsMutation, AssociateCommLogsToEventsMutationVariables>;

/**
 * __useAssociateCommLogsToEventsMutation__
 *
 * To run a mutation, you first call `useAssociateCommLogsToEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateCommLogsToEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateCommLogsToEventsMutation, { data, loading, error }] = useAssociateCommLogsToEventsMutation({
 *   variables: {
 *      commLogIds: // value for 'commLogIds'
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useAssociateCommLogsToEventsMutation(baseOptions?: Apollo.MutationHookOptions<AssociateCommLogsToEventsMutation, AssociateCommLogsToEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateCommLogsToEventsMutation, AssociateCommLogsToEventsMutationVariables>(AssociateCommLogsToEventsDocument, options);
      }
export type AssociateCommLogsToEventsMutationHookResult = ReturnType<typeof useAssociateCommLogsToEventsMutation>;
export type AssociateCommLogsToEventsMutationResult = Apollo.MutationResult<AssociateCommLogsToEventsMutation>;
export type AssociateCommLogsToEventsMutationOptions = Apollo.BaseMutationOptions<AssociateCommLogsToEventsMutation, AssociateCommLogsToEventsMutationVariables>;
export const RemoveAssociatedCommLogsFromEventsDocument = gql`
    mutation RemoveAssociatedCommLogsFromEvents($commLogIds: [ID!]!, $eventIds: [ID!]!) {
  removeAssociatedCommLogsFromEvents(commLogIds: $commLogIds, eventIds: $eventIds)
}
    `;
export type RemoveAssociatedCommLogsFromEventsMutationFn = Apollo.MutationFunction<RemoveAssociatedCommLogsFromEventsMutation, RemoveAssociatedCommLogsFromEventsMutationVariables>;

/**
 * __useRemoveAssociatedCommLogsFromEventsMutation__
 *
 * To run a mutation, you first call `useRemoveAssociatedCommLogsFromEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssociatedCommLogsFromEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssociatedCommLogsFromEventsMutation, { data, loading, error }] = useRemoveAssociatedCommLogsFromEventsMutation({
 *   variables: {
 *      commLogIds: // value for 'commLogIds'
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useRemoveAssociatedCommLogsFromEventsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssociatedCommLogsFromEventsMutation, RemoveAssociatedCommLogsFromEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssociatedCommLogsFromEventsMutation, RemoveAssociatedCommLogsFromEventsMutationVariables>(RemoveAssociatedCommLogsFromEventsDocument, options);
      }
export type RemoveAssociatedCommLogsFromEventsMutationHookResult = ReturnType<typeof useRemoveAssociatedCommLogsFromEventsMutation>;
export type RemoveAssociatedCommLogsFromEventsMutationResult = Apollo.MutationResult<RemoveAssociatedCommLogsFromEventsMutation>;
export type RemoveAssociatedCommLogsFromEventsMutationOptions = Apollo.BaseMutationOptions<RemoveAssociatedCommLogsFromEventsMutation, RemoveAssociatedCommLogsFromEventsMutationVariables>;
export const SaveResourcesDocument = gql`
    mutation SaveResources($id: ID!, $resources: [ResourceInput!]!) {
  saveResources(id: $id, resources: $resources) {
    id
  }
}
    `;
export type SaveResourcesMutationFn = Apollo.MutationFunction<SaveResourcesMutation, SaveResourcesMutationVariables>;

/**
 * __useSaveResourcesMutation__
 *
 * To run a mutation, you first call `useSaveResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveResourcesMutation, { data, loading, error }] = useSaveResourcesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resources: // value for 'resources'
 *   },
 * });
 */
export function useSaveResourcesMutation(baseOptions?: Apollo.MutationHookOptions<SaveResourcesMutation, SaveResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveResourcesMutation, SaveResourcesMutationVariables>(SaveResourcesDocument, options);
      }
export type SaveResourcesMutationHookResult = ReturnType<typeof useSaveResourcesMutation>;
export type SaveResourcesMutationResult = Apollo.MutationResult<SaveResourcesMutation>;
export type SaveResourcesMutationOptions = Apollo.BaseMutationOptions<SaveResourcesMutation, SaveResourcesMutationVariables>;
export const MarkDetectionAsExaminedDocument = gql`
    mutation MarkDetectionAsExamined($detectionId: ID!) {
  markDetectionAsExamined(detectionId: $detectionId) {
    ...Detection
  }
}
    ${DetectionFragmentDoc}`;
export type MarkDetectionAsExaminedMutationFn = Apollo.MutationFunction<MarkDetectionAsExaminedMutation, MarkDetectionAsExaminedMutationVariables>;

/**
 * __useMarkDetectionAsExaminedMutation__
 *
 * To run a mutation, you first call `useMarkDetectionAsExaminedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDetectionAsExaminedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDetectionAsExaminedMutation, { data, loading, error }] = useMarkDetectionAsExaminedMutation({
 *   variables: {
 *      detectionId: // value for 'detectionId'
 *   },
 * });
 */
export function useMarkDetectionAsExaminedMutation(baseOptions?: Apollo.MutationHookOptions<MarkDetectionAsExaminedMutation, MarkDetectionAsExaminedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDetectionAsExaminedMutation, MarkDetectionAsExaminedMutationVariables>(MarkDetectionAsExaminedDocument, options);
      }
export type MarkDetectionAsExaminedMutationHookResult = ReturnType<typeof useMarkDetectionAsExaminedMutation>;
export type MarkDetectionAsExaminedMutationResult = Apollo.MutationResult<MarkDetectionAsExaminedMutation>;
export type MarkDetectionAsExaminedMutationOptions = Apollo.BaseMutationOptions<MarkDetectionAsExaminedMutation, MarkDetectionAsExaminedMutationVariables>;
export const CreateEventFromCorridorDocument = gql`
    mutation CreateEventFromCorridor($corridorId: ID!, $direction: Direction!, $road: String, $referencePoint: Float, $category: EventCategory!, $lanes: [EventLaneInput]) {
  createEventFromCorridor(
    corridorId: $corridorId
    direction: $direction
    road: $road
    referencePoint: $referencePoint
    category: $category
    lanes: $lanes
  ) {
    id
    type
    status
  }
}
    `;
export type CreateEventFromCorridorMutationFn = Apollo.MutationFunction<CreateEventFromCorridorMutation, CreateEventFromCorridorMutationVariables>;

/**
 * __useCreateEventFromCorridorMutation__
 *
 * To run a mutation, you first call `useCreateEventFromCorridorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventFromCorridorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventFromCorridorMutation, { data, loading, error }] = useCreateEventFromCorridorMutation({
 *   variables: {
 *      corridorId: // value for 'corridorId'
 *      direction: // value for 'direction'
 *      road: // value for 'road'
 *      referencePoint: // value for 'referencePoint'
 *      category: // value for 'category'
 *      lanes: // value for 'lanes'
 *   },
 * });
 */
export function useCreateEventFromCorridorMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventFromCorridorMutation, CreateEventFromCorridorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventFromCorridorMutation, CreateEventFromCorridorMutationVariables>(CreateEventFromCorridorDocument, options);
      }
export type CreateEventFromCorridorMutationHookResult = ReturnType<typeof useCreateEventFromCorridorMutation>;
export type CreateEventFromCorridorMutationResult = Apollo.MutationResult<CreateEventFromCorridorMutation>;
export type CreateEventFromCorridorMutationOptions = Apollo.BaseMutationOptions<CreateEventFromCorridorMutation, CreateEventFromCorridorMutationVariables>;
export const GenerateFileTokenUrlDocument = gql`
    mutation GenerateFileTokenURL($id: ID!) {
  generateFileTokenURL(id: $id)
}
    `;
export type GenerateFileTokenUrlMutationFn = Apollo.MutationFunction<GenerateFileTokenUrlMutation, GenerateFileTokenUrlMutationVariables>;

/**
 * __useGenerateFileTokenUrlMutation__
 *
 * To run a mutation, you first call `useGenerateFileTokenUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFileTokenUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFileTokenUrlMutation, { data, loading, error }] = useGenerateFileTokenUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateFileTokenUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateFileTokenUrlMutation, GenerateFileTokenUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateFileTokenUrlMutation, GenerateFileTokenUrlMutationVariables>(GenerateFileTokenUrlDocument, options);
      }
export type GenerateFileTokenUrlMutationHookResult = ReturnType<typeof useGenerateFileTokenUrlMutation>;
export type GenerateFileTokenUrlMutationResult = Apollo.MutationResult<GenerateFileTokenUrlMutation>;
export type GenerateFileTokenUrlMutationOptions = Apollo.BaseMutationOptions<GenerateFileTokenUrlMutation, GenerateFileTokenUrlMutationVariables>;
export const EventFormDocument = gql`
    query EventForm($category: String!) {
  kineticEventForm(category: $category) {
    ...KineticFormFragment
  }
}
    ${KineticFormFragmentFragmentDoc}`;

/**
 * __useEventFormQuery__
 *
 * To run a query within a React component, call `useEventFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFormQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useEventFormQuery(baseOptions: Apollo.QueryHookOptions<EventFormQuery, EventFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventFormQuery, EventFormQueryVariables>(EventFormDocument, options);
      }
export function useEventFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventFormQuery, EventFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventFormQuery, EventFormQueryVariables>(EventFormDocument, options);
        }
export type EventFormQueryHookResult = ReturnType<typeof useEventFormQuery>;
export type EventFormLazyQueryHookResult = ReturnType<typeof useEventFormLazyQuery>;
export type EventFormQueryResult = Apollo.QueryResult<EventFormQuery, EventFormQueryVariables>;
export function refetchEventFormQuery(variables: EventFormQueryVariables) {
      return { query: EventFormDocument, variables: variables }
    }
export const EmailNotificationsByEventIdDocument = gql`
    query EmailNotificationsByEventId($eventId: String!) {
  emailNotificationsByEventId(eventId: $eventId) {
    id
    sentAt
    type
    subject
    body
    sentStatus
    toRecipients
    ccRecipients
    bccRecipients
  }
}
    `;

/**
 * __useEmailNotificationsByEventIdQuery__
 *
 * To run a query within a React component, call `useEmailNotificationsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailNotificationsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailNotificationsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEmailNotificationsByEventIdQuery(baseOptions: Apollo.QueryHookOptions<EmailNotificationsByEventIdQuery, EmailNotificationsByEventIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailNotificationsByEventIdQuery, EmailNotificationsByEventIdQueryVariables>(EmailNotificationsByEventIdDocument, options);
      }
export function useEmailNotificationsByEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailNotificationsByEventIdQuery, EmailNotificationsByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailNotificationsByEventIdQuery, EmailNotificationsByEventIdQueryVariables>(EmailNotificationsByEventIdDocument, options);
        }
export type EmailNotificationsByEventIdQueryHookResult = ReturnType<typeof useEmailNotificationsByEventIdQuery>;
export type EmailNotificationsByEventIdLazyQueryHookResult = ReturnType<typeof useEmailNotificationsByEventIdLazyQuery>;
export type EmailNotificationsByEventIdQueryResult = Apollo.QueryResult<EmailNotificationsByEventIdQuery, EmailNotificationsByEventIdQueryVariables>;
export function refetchEmailNotificationsByEventIdQuery(variables: EmailNotificationsByEventIdQueryVariables) {
      return { query: EmailNotificationsByEventIdDocument, variables: variables }
    }
export const EventsKineticFormsDocument = gql`
    query EventsKineticForms($query: KineticFormInputQuery!) {
  kineticForms(query: $query) {
    edges {
      node {
        ...KineticForm
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${KineticFormFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useEventsKineticFormsQuery__
 *
 * To run a query within a React component, call `useEventsKineticFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsKineticFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsKineticFormsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useEventsKineticFormsQuery(baseOptions: Apollo.QueryHookOptions<EventsKineticFormsQuery, EventsKineticFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsKineticFormsQuery, EventsKineticFormsQueryVariables>(EventsKineticFormsDocument, options);
      }
export function useEventsKineticFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsKineticFormsQuery, EventsKineticFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsKineticFormsQuery, EventsKineticFormsQueryVariables>(EventsKineticFormsDocument, options);
        }
export type EventsKineticFormsQueryHookResult = ReturnType<typeof useEventsKineticFormsQuery>;
export type EventsKineticFormsLazyQueryHookResult = ReturnType<typeof useEventsKineticFormsLazyQuery>;
export type EventsKineticFormsQueryResult = Apollo.QueryResult<EventsKineticFormsQuery, EventsKineticFormsQueryVariables>;
export function refetchEventsKineticFormsQuery(variables: EventsKineticFormsQueryVariables) {
      return { query: EventsKineticFormsDocument, variables: variables }
    }
export const GetEventDocument = gql`
    query GetEvent($id: ID!) {
  event(id: $id) {
    ...EventFragment
  }
}
    ${EventFragmentFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export function refetchGetEventQuery(variables: GetEventQueryVariables) {
      return { query: GetEventDocument, variables: variables }
    }
export const EventTypeListDocument = gql`
    query EventTypeList($after: String, $before: String, $limit: Int = 100, $sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $searchText: String, $category: EventCategory, $filters: [FilterInput]) {
  eventTypes(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, sortField: $sortField, category: $category, filters: $filters}
  ) {
    edges {
      node {
        ...EventType
      }
    }
  }
}
    ${EventTypeFragmentDoc}`;

/**
 * __useEventTypeListQuery__
 *
 * To run a query within a React component, call `useEventTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTypeListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      category: // value for 'category'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEventTypeListQuery(baseOptions?: Apollo.QueryHookOptions<EventTypeListQuery, EventTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTypeListQuery, EventTypeListQueryVariables>(EventTypeListDocument, options);
      }
export function useEventTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTypeListQuery, EventTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTypeListQuery, EventTypeListQueryVariables>(EventTypeListDocument, options);
        }
export type EventTypeListQueryHookResult = ReturnType<typeof useEventTypeListQuery>;
export type EventTypeListLazyQueryHookResult = ReturnType<typeof useEventTypeListLazyQuery>;
export type EventTypeListQueryResult = Apollo.QueryResult<EventTypeListQuery, EventTypeListQueryVariables>;
export function refetchEventTypeListQuery(variables?: EventTypeListQueryVariables) {
      return { query: EventTypeListDocument, variables: variables }
    }
export const EventTemplateDetailsDocument = gql`
    query EventTemplateDetails($id: ID!) {
  eventTemplate(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useEventTemplateDetailsQuery__
 *
 * To run a query within a React component, call `useEventTemplateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTemplateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTemplateDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventTemplateDetailsQuery(baseOptions: Apollo.QueryHookOptions<EventTemplateDetailsQuery, EventTemplateDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTemplateDetailsQuery, EventTemplateDetailsQueryVariables>(EventTemplateDetailsDocument, options);
      }
export function useEventTemplateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTemplateDetailsQuery, EventTemplateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTemplateDetailsQuery, EventTemplateDetailsQueryVariables>(EventTemplateDetailsDocument, options);
        }
export type EventTemplateDetailsQueryHookResult = ReturnType<typeof useEventTemplateDetailsQuery>;
export type EventTemplateDetailsLazyQueryHookResult = ReturnType<typeof useEventTemplateDetailsLazyQuery>;
export type EventTemplateDetailsQueryResult = Apollo.QueryResult<EventTemplateDetailsQuery, EventTemplateDetailsQueryVariables>;
export function refetchEventTemplateDetailsQuery(variables: EventTemplateDetailsQueryVariables) {
      return { query: EventTemplateDetailsDocument, variables: variables }
    }
export const EventTemplateDocument = gql`
    query EventTemplate($id: ID!) {
  eventTemplate(id: $id) {
    id
    name
    description
    template {
      ...TemplateEvent
    }
  }
}
    ${TemplateEventFragmentDoc}`;

/**
 * __useEventTemplateQuery__
 *
 * To run a query within a React component, call `useEventTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventTemplateQuery(baseOptions: Apollo.QueryHookOptions<EventTemplateQuery, EventTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTemplateQuery, EventTemplateQueryVariables>(EventTemplateDocument, options);
      }
export function useEventTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTemplateQuery, EventTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTemplateQuery, EventTemplateQueryVariables>(EventTemplateDocument, options);
        }
export type EventTemplateQueryHookResult = ReturnType<typeof useEventTemplateQuery>;
export type EventTemplateLazyQueryHookResult = ReturnType<typeof useEventTemplateLazyQuery>;
export type EventTemplateQueryResult = Apollo.QueryResult<EventTemplateQuery, EventTemplateQueryVariables>;
export function refetchEventTemplateQuery(variables: EventTemplateQueryVariables) {
      return { query: EventTemplateDocument, variables: variables }
    }
export const EventsIntegrationsListDocument = gql`
    query EventsIntegrationsList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  integrations(
    searchText: $searchText
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    before: $before
    after: $after
    limit: $limit
  ) {
    edges {
      node {
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useEventsIntegrationsListQuery__
 *
 * To run a query within a React component, call `useEventsIntegrationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsIntegrationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsIntegrationsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventsIntegrationsListQuery(baseOptions?: Apollo.QueryHookOptions<EventsIntegrationsListQuery, EventsIntegrationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsIntegrationsListQuery, EventsIntegrationsListQueryVariables>(EventsIntegrationsListDocument, options);
      }
export function useEventsIntegrationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsIntegrationsListQuery, EventsIntegrationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsIntegrationsListQuery, EventsIntegrationsListQueryVariables>(EventsIntegrationsListDocument, options);
        }
export type EventsIntegrationsListQueryHookResult = ReturnType<typeof useEventsIntegrationsListQuery>;
export type EventsIntegrationsListLazyQueryHookResult = ReturnType<typeof useEventsIntegrationsListLazyQuery>;
export type EventsIntegrationsListQueryResult = Apollo.QueryResult<EventsIntegrationsListQuery, EventsIntegrationsListQueryVariables>;
export function refetchEventsIntegrationsListQuery(variables?: EventsIntegrationsListQueryVariables) {
      return { query: EventsIntegrationsListDocument, variables: variables }
    }
export const EventTemplatesDocument = gql`
    query EventTemplates($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $searchText: String, $filters: [FilterInput]) {
  eventTemplates(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, sortField: $sortField, filters: $filters}
  ) {
    edges {
      node {
        id
        name
        description
        template {
          ...TemplateEvent
        }
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${TemplateEventFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useEventTemplatesQuery__
 *
 * To run a query within a React component, call `useEventTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTemplatesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEventTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<EventTemplatesQuery, EventTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTemplatesQuery, EventTemplatesQueryVariables>(EventTemplatesDocument, options);
      }
export function useEventTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTemplatesQuery, EventTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTemplatesQuery, EventTemplatesQueryVariables>(EventTemplatesDocument, options);
        }
export type EventTemplatesQueryHookResult = ReturnType<typeof useEventTemplatesQuery>;
export type EventTemplatesLazyQueryHookResult = ReturnType<typeof useEventTemplatesLazyQuery>;
export type EventTemplatesQueryResult = Apollo.QueryResult<EventTemplatesQuery, EventTemplatesQueryVariables>;
export function refetchEventTemplatesQuery(variables?: EventTemplatesQueryVariables) {
      return { query: EventTemplatesDocument, variables: variables }
    }
export const EventDocument = gql`
    query Event($id: ID!) {
  event(id: $id) {
    ...Event
  }
}
    ${EventFragmentDoc}`;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventQuery(baseOptions: Apollo.QueryHookOptions<EventQuery, EventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventQuery, EventQueryVariables>(EventDocument, options);
      }
export function useEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(EventDocument, options);
        }
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventQueryResult = Apollo.QueryResult<EventQuery, EventQueryVariables>;
export function refetchEventQuery(variables: EventQueryVariables) {
      return { query: EventDocument, variables: variables }
    }
export const ShortEventListDocument = gql`
    query ShortEventList($sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $sortField: String = "lastUpdated", $limit: Int = 10000000, $before: String, $after: String) {
  events(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useShortEventListQuery__
 *
 * To run a query within a React component, call `useShortEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortEventListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useShortEventListQuery(baseOptions?: Apollo.QueryHookOptions<ShortEventListQuery, ShortEventListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShortEventListQuery, ShortEventListQueryVariables>(ShortEventListDocument, options);
      }
export function useShortEventListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortEventListQuery, ShortEventListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShortEventListQuery, ShortEventListQueryVariables>(ShortEventListDocument, options);
        }
export type ShortEventListQueryHookResult = ReturnType<typeof useShortEventListQuery>;
export type ShortEventListLazyQueryHookResult = ReturnType<typeof useShortEventListLazyQuery>;
export type ShortEventListQueryResult = Apollo.QueryResult<ShortEventListQuery, ShortEventListQueryVariables>;
export function refetchShortEventListQuery(variables?: ShortEventListQueryVariables) {
      return { query: ShortEventListDocument, variables: variables }
    }
export const EventIdsDocument = gql`
    query EventIds($after: String, $before: String, $limit: Int = 1000000, $sortField: String, $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput]) {
  events(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, filters: $filters}
  ) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useEventIdsQuery__
 *
 * To run a query within a React component, call `useEventIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventIdsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEventIdsQuery(baseOptions?: Apollo.QueryHookOptions<EventIdsQuery, EventIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventIdsQuery, EventIdsQueryVariables>(EventIdsDocument, options);
      }
export function useEventIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventIdsQuery, EventIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventIdsQuery, EventIdsQueryVariables>(EventIdsDocument, options);
        }
export type EventIdsQueryHookResult = ReturnType<typeof useEventIdsQuery>;
export type EventIdsLazyQueryHookResult = ReturnType<typeof useEventIdsLazyQuery>;
export type EventIdsQueryResult = Apollo.QueryResult<EventIdsQuery, EventIdsQueryVariables>;
export function refetchEventIdsQuery(variables?: EventIdsQueryVariables) {
      return { query: EventIdsDocument, variables: variables }
    }
export const EventItemDocument = gql`
    query EventItem($id: ID!) {
  event(id: $id) {
    id
    name
    created
    category
    type
    status
    geometry
  }
}
    `;

/**
 * __useEventItemQuery__
 *
 * To run a query within a React component, call `useEventItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventItemQuery(baseOptions: Apollo.QueryHookOptions<EventItemQuery, EventItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventItemQuery, EventItemQueryVariables>(EventItemDocument, options);
      }
export function useEventItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventItemQuery, EventItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventItemQuery, EventItemQueryVariables>(EventItemDocument, options);
        }
export type EventItemQueryHookResult = ReturnType<typeof useEventItemQuery>;
export type EventItemLazyQueryHookResult = ReturnType<typeof useEventItemLazyQuery>;
export type EventItemQueryResult = Apollo.QueryResult<EventItemQuery, EventItemQueryVariables>;
export function refetchEventItemQuery(variables: EventItemQueryVariables) {
      return { query: EventItemDocument, variables: variables }
    }
export const EventMapDocument = gql`
    query EventMap($filters: [FilterInput!]!) {
  events(query: {limit: 1000000, filters: $filters}) {
    edges {
      node {
        ...EventMap
      }
    }
  }
}
    ${EventMapFragmentDoc}`;

/**
 * __useEventMapQuery__
 *
 * To run a query within a React component, call `useEventMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventMapQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEventMapQuery(baseOptions: Apollo.QueryHookOptions<EventMapQuery, EventMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventMapQuery, EventMapQueryVariables>(EventMapDocument, options);
      }
export function useEventMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventMapQuery, EventMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventMapQuery, EventMapQueryVariables>(EventMapDocument, options);
        }
export type EventMapQueryHookResult = ReturnType<typeof useEventMapQuery>;
export type EventMapLazyQueryHookResult = ReturnType<typeof useEventMapLazyQuery>;
export type EventMapQueryResult = Apollo.QueryResult<EventMapQuery, EventMapQueryVariables>;
export function refetchEventMapQuery(variables: EventMapQueryVariables) {
      return { query: EventMapDocument, variables: variables }
    }
export const EventMapUpdatedDocument = gql`
    subscription EventMapUpdated {
  eventUpdated {
    id
  }
}
    `;

/**
 * __useEventMapUpdatedSubscription__
 *
 * To run a query within a React component, call `useEventMapUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventMapUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventMapUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEventMapUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EventMapUpdatedSubscription, EventMapUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EventMapUpdatedSubscription, EventMapUpdatedSubscriptionVariables>(EventMapUpdatedDocument, options);
      }
export type EventMapUpdatedSubscriptionHookResult = ReturnType<typeof useEventMapUpdatedSubscription>;
export type EventMapUpdatedSubscriptionResult = Apollo.SubscriptionResult<EventMapUpdatedSubscription>;
export const EventDashboardDocument = gql`
    query EventDashboard($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $startDateTime: DateTime, $filters: [FilterInput], $endDateTime: DateTime, $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  events(
    query: {startDateTime: $startDateTime, endDateTime: $endDateTime, searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    totalCount
    edges {
      node {
        id
        category
        attributes
        type
        geometry
      }
    }
  }
}
    `;

/**
 * __useEventDashboardQuery__
 *
 * To run a query within a React component, call `useEventDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDashboardQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      startDateTime: // value for 'startDateTime'
 *      filters: // value for 'filters'
 *      endDateTime: // value for 'endDateTime'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventDashboardQuery(baseOptions?: Apollo.QueryHookOptions<EventDashboardQuery, EventDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventDashboardQuery, EventDashboardQueryVariables>(EventDashboardDocument, options);
      }
export function useEventDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventDashboardQuery, EventDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventDashboardQuery, EventDashboardQueryVariables>(EventDashboardDocument, options);
        }
export type EventDashboardQueryHookResult = ReturnType<typeof useEventDashboardQuery>;
export type EventDashboardLazyQueryHookResult = ReturnType<typeof useEventDashboardLazyQuery>;
export type EventDashboardQueryResult = Apollo.QueryResult<EventDashboardQuery, EventDashboardQueryVariables>;
export function refetchEventDashboardQuery(variables?: EventDashboardQueryVariables) {
      return { query: EventDashboardDocument, variables: variables }
    }
export const EventChartHistoryDocument = gql`
    query EventChartHistory($ids: [String!]!, $start: DateTime!, $end: DateTime!, $agg: [JSON!]!) {
  aggregate(entityIds: $ids, start: $start, end: $end, aggregation: $agg)
}
    `;

/**
 * __useEventChartHistoryQuery__
 *
 * To run a query within a React component, call `useEventChartHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventChartHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventChartHistoryQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      agg: // value for 'agg'
 *   },
 * });
 */
export function useEventChartHistoryQuery(baseOptions: Apollo.QueryHookOptions<EventChartHistoryQuery, EventChartHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventChartHistoryQuery, EventChartHistoryQueryVariables>(EventChartHistoryDocument, options);
      }
export function useEventChartHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventChartHistoryQuery, EventChartHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventChartHistoryQuery, EventChartHistoryQueryVariables>(EventChartHistoryDocument, options);
        }
export type EventChartHistoryQueryHookResult = ReturnType<typeof useEventChartHistoryQuery>;
export type EventChartHistoryLazyQueryHookResult = ReturnType<typeof useEventChartHistoryLazyQuery>;
export type EventChartHistoryQueryResult = Apollo.QueryResult<EventChartHistoryQuery, EventChartHistoryQueryVariables>;
export function refetchEventChartHistoryQuery(variables: EventChartHistoryQueryVariables) {
      return { query: EventChartHistoryDocument, variables: variables }
    }
export const EventDetailsDocument = gql`
    query EventDetails($id: ID!) {
  event(id: $id) {
    ...EventDetails
  }
}
    ${EventDetailsFragmentDoc}`;

/**
 * __useEventDetailsQuery__
 *
 * To run a query within a React component, call `useEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<EventDetailsQuery, EventDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventDetailsQuery, EventDetailsQueryVariables>(EventDetailsDocument, options);
      }
export function useEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventDetailsQuery, EventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventDetailsQuery, EventDetailsQueryVariables>(EventDetailsDocument, options);
        }
export type EventDetailsQueryHookResult = ReturnType<typeof useEventDetailsQuery>;
export type EventDetailsLazyQueryHookResult = ReturnType<typeof useEventDetailsLazyQuery>;
export type EventDetailsQueryResult = Apollo.QueryResult<EventDetailsQuery, EventDetailsQueryVariables>;
export function refetchEventDetailsQuery(variables: EventDetailsQueryVariables) {
      return { query: EventDetailsDocument, variables: variables }
    }
export const SignMapUpdatedDocument = gql`
    subscription SignMapUpdated {
  signMapUpdated
}
    `;

/**
 * __useSignMapUpdatedSubscription__
 *
 * To run a query within a React component, call `useSignMapUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSignMapUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMapUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSignMapUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SignMapUpdatedSubscription, SignMapUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SignMapUpdatedSubscription, SignMapUpdatedSubscriptionVariables>(SignMapUpdatedDocument, options);
      }
export type SignMapUpdatedSubscriptionHookResult = ReturnType<typeof useSignMapUpdatedSubscription>;
export type SignMapUpdatedSubscriptionResult = Apollo.SubscriptionResult<SignMapUpdatedSubscription>;
export const CameraMapDocument = gql`
    query CameraMap {
  cameraMapEntities
}
    `;

/**
 * __useCameraMapQuery__
 *
 * To run a query within a React component, call `useCameraMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraMapQuery({
 *   variables: {
 *   },
 * });
 */
export function useCameraMapQuery(baseOptions?: Apollo.QueryHookOptions<CameraMapQuery, CameraMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraMapQuery, CameraMapQueryVariables>(CameraMapDocument, options);
      }
export function useCameraMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraMapQuery, CameraMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraMapQuery, CameraMapQueryVariables>(CameraMapDocument, options);
        }
export type CameraMapQueryHookResult = ReturnType<typeof useCameraMapQuery>;
export type CameraMapLazyQueryHookResult = ReturnType<typeof useCameraMapLazyQuery>;
export type CameraMapQueryResult = Apollo.QueryResult<CameraMapQuery, CameraMapQueryVariables>;
export function refetchCameraMapQuery(variables?: CameraMapQueryVariables) {
      return { query: CameraMapDocument, variables: variables }
    }
export const ResourcePlanDocument = gql`
    query ResourcePlan($id: ID!) {
  resourcePlan(id: $id) {
    ...ResourcePlan
  }
}
    ${ResourcePlanFragmentDoc}`;

/**
 * __useResourcePlanQuery__
 *
 * To run a query within a React component, call `useResourcePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourcePlanQuery(baseOptions: Apollo.QueryHookOptions<ResourcePlanQuery, ResourcePlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcePlanQuery, ResourcePlanQueryVariables>(ResourcePlanDocument, options);
      }
export function useResourcePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcePlanQuery, ResourcePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcePlanQuery, ResourcePlanQueryVariables>(ResourcePlanDocument, options);
        }
export type ResourcePlanQueryHookResult = ReturnType<typeof useResourcePlanQuery>;
export type ResourcePlanLazyQueryHookResult = ReturnType<typeof useResourcePlanLazyQuery>;
export type ResourcePlanQueryResult = Apollo.QueryResult<ResourcePlanQuery, ResourcePlanQueryVariables>;
export function refetchResourcePlanQuery(variables: ResourcePlanQueryVariables) {
      return { query: ResourcePlanDocument, variables: variables }
    }
export const ResourcePlanListDocument = gql`
    query ResourcePlanList($sortOrder: SortOrder = DESCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  resourcePlans(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        ...ResourcePlan
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${ResourcePlanFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useResourcePlanListQuery__
 *
 * To run a query within a React component, call `useResourcePlanListQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useResourcePlanListQuery(baseOptions?: Apollo.QueryHookOptions<ResourcePlanListQuery, ResourcePlanListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcePlanListQuery, ResourcePlanListQueryVariables>(ResourcePlanListDocument, options);
      }
export function useResourcePlanListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcePlanListQuery, ResourcePlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcePlanListQuery, ResourcePlanListQueryVariables>(ResourcePlanListDocument, options);
        }
export type ResourcePlanListQueryHookResult = ReturnType<typeof useResourcePlanListQuery>;
export type ResourcePlanListLazyQueryHookResult = ReturnType<typeof useResourcePlanListLazyQuery>;
export type ResourcePlanListQueryResult = Apollo.QueryResult<ResourcePlanListQuery, ResourcePlanListQueryVariables>;
export function refetchResourcePlanListQuery(variables?: ResourcePlanListQueryVariables) {
      return { query: ResourcePlanListDocument, variables: variables }
    }
export const ResourcePlanMessageListDocument = gql`
    query ResourcePlanMessageList($after: String, $before: String, $limit: Int = 10, $sortField: String = "id", $sortOrder: SortOrder = ASCENDING, $searchText: String, $sign: ID, $type: SignMessageType = GENERAL, $filters: [FilterInput!]) {
  signMessages(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, sign: $sign, searchText: $searchText, filters: $filters, type: $type}
  ) {
    edges {
      node {
        ...SignLibraryMessage
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignLibraryMessageFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useResourcePlanMessageListQuery__
 *
 * To run a query within a React component, call `useResourcePlanMessageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanMessageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanMessageListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      sign: // value for 'sign'
 *      type: // value for 'type'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useResourcePlanMessageListQuery(baseOptions?: Apollo.QueryHookOptions<ResourcePlanMessageListQuery, ResourcePlanMessageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcePlanMessageListQuery, ResourcePlanMessageListQueryVariables>(ResourcePlanMessageListDocument, options);
      }
export function useResourcePlanMessageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcePlanMessageListQuery, ResourcePlanMessageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcePlanMessageListQuery, ResourcePlanMessageListQueryVariables>(ResourcePlanMessageListDocument, options);
        }
export type ResourcePlanMessageListQueryHookResult = ReturnType<typeof useResourcePlanMessageListQuery>;
export type ResourcePlanMessageListLazyQueryHookResult = ReturnType<typeof useResourcePlanMessageListLazyQuery>;
export type ResourcePlanMessageListQueryResult = Apollo.QueryResult<ResourcePlanMessageListQuery, ResourcePlanMessageListQueryVariables>;
export function refetchResourcePlanMessageListQuery(variables?: ResourcePlanMessageListQueryVariables) {
      return { query: ResourcePlanMessageListDocument, variables: variables }
    }
export const EventsModuleSettingsDocument = gql`
    query EventsModuleSettings {
  eventsModuleSettings {
    id
    name
    type
    sections {
      name
      id
      fields {
        id
        name
        label
        type
        required
        hint
        sourceId
        defaultValue
        loading
        showInput
        options {
          label
          value
        }
      }
    }
  }
}
    `;

/**
 * __useEventsModuleSettingsQuery__
 *
 * To run a query within a React component, call `useEventsModuleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsModuleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsModuleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventsModuleSettingsQuery(baseOptions?: Apollo.QueryHookOptions<EventsModuleSettingsQuery, EventsModuleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsModuleSettingsQuery, EventsModuleSettingsQueryVariables>(EventsModuleSettingsDocument, options);
      }
export function useEventsModuleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsModuleSettingsQuery, EventsModuleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsModuleSettingsQuery, EventsModuleSettingsQueryVariables>(EventsModuleSettingsDocument, options);
        }
export type EventsModuleSettingsQueryHookResult = ReturnType<typeof useEventsModuleSettingsQuery>;
export type EventsModuleSettingsLazyQueryHookResult = ReturnType<typeof useEventsModuleSettingsLazyQuery>;
export type EventsModuleSettingsQueryResult = Apollo.QueryResult<EventsModuleSettingsQuery, EventsModuleSettingsQueryVariables>;
export function refetchEventsModuleSettingsQuery(variables?: EventsModuleSettingsQueryVariables) {
      return { query: EventsModuleSettingsDocument, variables: variables }
    }
export const ResponseModuleSettingsDocument = gql`
    query ResponseModuleSettings {
  responseModuleSettings {
    id
    name
    type
    sections {
      name
      id
      fields {
        id
        name
        label
        type
        required
        hint
        sourceId
        defaultValue
        loading
        showInput
        options {
          label
          value
        }
      }
    }
  }
}
    `;

/**
 * __useResponseModuleSettingsQuery__
 *
 * To run a query within a React component, call `useResponseModuleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseModuleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseModuleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useResponseModuleSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ResponseModuleSettingsQuery, ResponseModuleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseModuleSettingsQuery, ResponseModuleSettingsQueryVariables>(ResponseModuleSettingsDocument, options);
      }
export function useResponseModuleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseModuleSettingsQuery, ResponseModuleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseModuleSettingsQuery, ResponseModuleSettingsQueryVariables>(ResponseModuleSettingsDocument, options);
        }
export type ResponseModuleSettingsQueryHookResult = ReturnType<typeof useResponseModuleSettingsQuery>;
export type ResponseModuleSettingsLazyQueryHookResult = ReturnType<typeof useResponseModuleSettingsLazyQuery>;
export type ResponseModuleSettingsQueryResult = Apollo.QueryResult<ResponseModuleSettingsQuery, ResponseModuleSettingsQueryVariables>;
export function refetchResponseModuleSettingsQuery(variables?: ResponseModuleSettingsQueryVariables) {
      return { query: ResponseModuleSettingsDocument, variables: variables }
    }
export const ResourcePlanUpdatedDocument = gql`
    subscription ResourcePlanUpdated($ids: [ID!]!) {
  resourcePlanUpdated(ids: $ids) {
    ...ResourcePlan
  }
}
    ${ResourcePlanFragmentDoc}`;

/**
 * __useResourcePlanUpdatedSubscription__
 *
 * To run a query within a React component, call `useResourcePlanUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useResourcePlanUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ResourcePlanUpdatedSubscription, ResourcePlanUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResourcePlanUpdatedSubscription, ResourcePlanUpdatedSubscriptionVariables>(ResourcePlanUpdatedDocument, options);
      }
export type ResourcePlanUpdatedSubscriptionHookResult = ReturnType<typeof useResourcePlanUpdatedSubscription>;
export type ResourcePlanUpdatedSubscriptionResult = Apollo.SubscriptionResult<ResourcePlanUpdatedSubscription>;
export const DetectionListDocument = gql`
    query DetectionList($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $searchText: String, $filters: [FilterInput], $startDateTime: DateTime, $endDateTime: DateTime) {
  detections(
    after: $after
    before: $before
    limit: $limit
    sortOrder: $sortOrder
    searchText: $searchText
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    sortField: $sortField
    filters: $filters
  ) {
    edges {
      node {
        ...DetectionListItem
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectionListItemFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectionListQuery__
 *
 * To run a query within a React component, call `useDetectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectionListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectionListQuery(baseOptions?: Apollo.QueryHookOptions<DetectionListQuery, DetectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectionListQuery, DetectionListQueryVariables>(DetectionListDocument, options);
      }
export function useDetectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectionListQuery, DetectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectionListQuery, DetectionListQueryVariables>(DetectionListDocument, options);
        }
export type DetectionListQueryHookResult = ReturnType<typeof useDetectionListQuery>;
export type DetectionListLazyQueryHookResult = ReturnType<typeof useDetectionListLazyQuery>;
export type DetectionListQueryResult = Apollo.QueryResult<DetectionListQuery, DetectionListQueryVariables>;
export function refetchDetectionListQuery(variables?: DetectionListQueryVariables) {
      return { query: DetectionListDocument, variables: variables }
    }
export const TrackingDetectionListDocument = gql`
    query TrackingDetectionList($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $searchText: String, $filters: [FilterInput], $startDateTime: DateTime, $endDateTime: DateTime) {
  detections(
    after: $after
    before: $before
    limit: $limit
    sortOrder: $sortOrder
    searchText: $searchText
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    sortField: $sortField
    filters: $filters
  ) {
    edges {
      node {
        ...Detection
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectionFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useTrackingDetectionListQuery__
 *
 * To run a query within a React component, call `useTrackingDetectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingDetectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingDetectionListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useTrackingDetectionListQuery(baseOptions?: Apollo.QueryHookOptions<TrackingDetectionListQuery, TrackingDetectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackingDetectionListQuery, TrackingDetectionListQueryVariables>(TrackingDetectionListDocument, options);
      }
export function useTrackingDetectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackingDetectionListQuery, TrackingDetectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackingDetectionListQuery, TrackingDetectionListQueryVariables>(TrackingDetectionListDocument, options);
        }
export type TrackingDetectionListQueryHookResult = ReturnType<typeof useTrackingDetectionListQuery>;
export type TrackingDetectionListLazyQueryHookResult = ReturnType<typeof useTrackingDetectionListLazyQuery>;
export type TrackingDetectionListQueryResult = Apollo.QueryResult<TrackingDetectionListQuery, TrackingDetectionListQueryVariables>;
export function refetchTrackingDetectionListQuery(variables?: TrackingDetectionListQueryVariables) {
      return { query: TrackingDetectionListDocument, variables: variables }
    }
export const EventTypeDocument = gql`
    query EventType($id: ID!) {
  eventType(id: $id) {
    ...EventType
  }
}
    ${EventTypeFragmentDoc}`;

/**
 * __useEventTypeQuery__
 *
 * To run a query within a React component, call `useEventTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventTypeQuery(baseOptions: Apollo.QueryHookOptions<EventTypeQuery, EventTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTypeQuery, EventTypeQueryVariables>(EventTypeDocument, options);
      }
export function useEventTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTypeQuery, EventTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTypeQuery, EventTypeQueryVariables>(EventTypeDocument, options);
        }
export type EventTypeQueryHookResult = ReturnType<typeof useEventTypeQuery>;
export type EventTypeLazyQueryHookResult = ReturnType<typeof useEventTypeLazyQuery>;
export type EventTypeQueryResult = Apollo.QueryResult<EventTypeQuery, EventTypeQueryVariables>;
export function refetchEventTypeQuery(variables: EventTypeQueryVariables) {
      return { query: EventTypeDocument, variables: variables }
    }
export const EventTypesListDocument = gql`
    query EventTypesList {
  eventTypes {
    edges {
      node {
        ...EventTypeShort
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${EventTypeShortFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useEventTypesListQuery__
 *
 * To run a query within a React component, call `useEventTypesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTypesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTypesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventTypesListQuery(baseOptions?: Apollo.QueryHookOptions<EventTypesListQuery, EventTypesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTypesListQuery, EventTypesListQueryVariables>(EventTypesListDocument, options);
      }
export function useEventTypesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTypesListQuery, EventTypesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTypesListQuery, EventTypesListQueryVariables>(EventTypesListDocument, options);
        }
export type EventTypesListQueryHookResult = ReturnType<typeof useEventTypesListQuery>;
export type EventTypesListLazyQueryHookResult = ReturnType<typeof useEventTypesListLazyQuery>;
export type EventTypesListQueryResult = Apollo.QueryResult<EventTypesListQuery, EventTypesListQueryVariables>;
export function refetchEventTypesListQuery(variables?: EventTypesListQueryVariables) {
      return { query: EventTypesListDocument, variables: variables }
    }
export const EventManagementDocument = gql`
    query EventManagement($searchFields: [String!] = ["name", "description", "category", "shortId", "lastUpdatedByDisplayName", "createdByDisplayName"], $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $startDateTime: DateTime, $filters: [FilterInput], $endDateTime: DateTime, $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  events(
    query: {startDateTime: $startDateTime, searchFields: $searchFields, endDateTime: $endDateTime, searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        ...EventList
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${EventListFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useEventManagementQuery__
 *
 * To run a query within a React component, call `useEventManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventManagementQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      startDateTime: // value for 'startDateTime'
 *      filters: // value for 'filters'
 *      endDateTime: // value for 'endDateTime'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventManagementQuery(baseOptions?: Apollo.QueryHookOptions<EventManagementQuery, EventManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventManagementQuery, EventManagementQueryVariables>(EventManagementDocument, options);
      }
export function useEventManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventManagementQuery, EventManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventManagementQuery, EventManagementQueryVariables>(EventManagementDocument, options);
        }
export type EventManagementQueryHookResult = ReturnType<typeof useEventManagementQuery>;
export type EventManagementLazyQueryHookResult = ReturnType<typeof useEventManagementLazyQuery>;
export type EventManagementQueryResult = Apollo.QueryResult<EventManagementQuery, EventManagementQueryVariables>;
export function refetchEventManagementQuery(variables?: EventManagementQueryVariables) {
      return { query: EventManagementDocument, variables: variables }
    }
export const EventUpdatedDocument = gql`
    subscription EventUpdated($id: ID!) {
  eventUpdated(ids: [$id]) {
    lastUpdatedBy
    status
    id
  }
}
    `;

/**
 * __useEventUpdatedSubscription__
 *
 * To run a query within a React component, call `useEventUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<EventUpdatedSubscription, EventUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EventUpdatedSubscription, EventUpdatedSubscriptionVariables>(EventUpdatedDocument, options);
      }
export type EventUpdatedSubscriptionHookResult = ReturnType<typeof useEventUpdatedSubscription>;
export type EventUpdatedSubscriptionResult = Apollo.SubscriptionResult<EventUpdatedSubscription>;
export const EventListUpdatedDocument = gql`
    subscription EventListUpdated($ids: [ID!]!) {
  eventUpdated(ids: $ids) {
    ...EventList
  }
}
    ${EventListFragmentDoc}`;

/**
 * __useEventListUpdatedSubscription__
 *
 * To run a query within a React component, call `useEventListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventListUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEventListUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<EventListUpdatedSubscription, EventListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EventListUpdatedSubscription, EventListUpdatedSubscriptionVariables>(EventListUpdatedDocument, options);
      }
export type EventListUpdatedSubscriptionHookResult = ReturnType<typeof useEventListUpdatedSubscription>;
export type EventListUpdatedSubscriptionResult = Apollo.SubscriptionResult<EventListUpdatedSubscription>;
export const ShortEventListUpdatedDocument = gql`
    subscription ShortEventListUpdated($ids: [ID!]!) {
  eventUpdated(ids: $ids) {
    id
  }
}
    `;

/**
 * __useShortEventListUpdatedSubscription__
 *
 * To run a query within a React component, call `useShortEventListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShortEventListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortEventListUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useShortEventListUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ShortEventListUpdatedSubscription, ShortEventListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ShortEventListUpdatedSubscription, ShortEventListUpdatedSubscriptionVariables>(ShortEventListUpdatedDocument, options);
      }
export type ShortEventListUpdatedSubscriptionHookResult = ReturnType<typeof useShortEventListUpdatedSubscription>;
export type ShortEventListUpdatedSubscriptionResult = Apollo.SubscriptionResult<ShortEventListUpdatedSubscription>;
export const EventTypeFiltersDocument = gql`
    query EventTypeFilters($categories: [String]) {
  eventTypeFilters(categories: $categories)
}
    `;

/**
 * __useEventTypeFiltersQuery__
 *
 * To run a query within a React component, call `useEventTypeFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTypeFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTypeFiltersQuery({
 *   variables: {
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useEventTypeFiltersQuery(baseOptions?: Apollo.QueryHookOptions<EventTypeFiltersQuery, EventTypeFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTypeFiltersQuery, EventTypeFiltersQueryVariables>(EventTypeFiltersDocument, options);
      }
export function useEventTypeFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTypeFiltersQuery, EventTypeFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTypeFiltersQuery, EventTypeFiltersQueryVariables>(EventTypeFiltersDocument, options);
        }
export type EventTypeFiltersQueryHookResult = ReturnType<typeof useEventTypeFiltersQuery>;
export type EventTypeFiltersLazyQueryHookResult = ReturnType<typeof useEventTypeFiltersLazyQuery>;
export type EventTypeFiltersQueryResult = Apollo.QueryResult<EventTypeFiltersQuery, EventTypeFiltersQueryVariables>;
export function refetchEventTypeFiltersQuery(variables?: EventTypeFiltersQueryVariables) {
      return { query: EventTypeFiltersDocument, variables: variables }
    }
export const EventJurisdictionFiltersDocument = gql`
    query EventJurisdictionFilters {
  eventJurisdictionFilters
}
    `;

/**
 * __useEventJurisdictionFiltersQuery__
 *
 * To run a query within a React component, call `useEventJurisdictionFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventJurisdictionFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventJurisdictionFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventJurisdictionFiltersQuery(baseOptions?: Apollo.QueryHookOptions<EventJurisdictionFiltersQuery, EventJurisdictionFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventJurisdictionFiltersQuery, EventJurisdictionFiltersQueryVariables>(EventJurisdictionFiltersDocument, options);
      }
export function useEventJurisdictionFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventJurisdictionFiltersQuery, EventJurisdictionFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventJurisdictionFiltersQuery, EventJurisdictionFiltersQueryVariables>(EventJurisdictionFiltersDocument, options);
        }
export type EventJurisdictionFiltersQueryHookResult = ReturnType<typeof useEventJurisdictionFiltersQuery>;
export type EventJurisdictionFiltersLazyQueryHookResult = ReturnType<typeof useEventJurisdictionFiltersLazyQuery>;
export type EventJurisdictionFiltersQueryResult = Apollo.QueryResult<EventJurisdictionFiltersQuery, EventJurisdictionFiltersQueryVariables>;
export function refetchEventJurisdictionFiltersQuery(variables?: EventJurisdictionFiltersQueryVariables) {
      return { query: EventJurisdictionFiltersDocument, variables: variables }
    }
export const EventRoadFiltersDocument = gql`
    query EventRoadFilters {
  eventRoadFilters
}
    `;

/**
 * __useEventRoadFiltersQuery__
 *
 * To run a query within a React component, call `useEventRoadFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventRoadFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventRoadFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventRoadFiltersQuery(baseOptions?: Apollo.QueryHookOptions<EventRoadFiltersQuery, EventRoadFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventRoadFiltersQuery, EventRoadFiltersQueryVariables>(EventRoadFiltersDocument, options);
      }
export function useEventRoadFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventRoadFiltersQuery, EventRoadFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventRoadFiltersQuery, EventRoadFiltersQueryVariables>(EventRoadFiltersDocument, options);
        }
export type EventRoadFiltersQueryHookResult = ReturnType<typeof useEventRoadFiltersQuery>;
export type EventRoadFiltersLazyQueryHookResult = ReturnType<typeof useEventRoadFiltersLazyQuery>;
export type EventRoadFiltersQueryResult = Apollo.QueryResult<EventRoadFiltersQuery, EventRoadFiltersQueryVariables>;
export function refetchEventRoadFiltersQuery(variables?: EventRoadFiltersQueryVariables) {
      return { query: EventRoadFiltersDocument, variables: variables }
    }
export const DetectionDocument = gql`
    query Detection($id: ID!) {
  detection(id: $id) {
    ...Detection
  }
}
    ${DetectionFragmentDoc}`;

/**
 * __useDetectionQuery__
 *
 * To run a query within a React component, call `useDetectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectionQuery(baseOptions: Apollo.QueryHookOptions<DetectionQuery, DetectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectionQuery, DetectionQueryVariables>(DetectionDocument, options);
      }
export function useDetectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectionQuery, DetectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectionQuery, DetectionQueryVariables>(DetectionDocument, options);
        }
export type DetectionQueryHookResult = ReturnType<typeof useDetectionQuery>;
export type DetectionLazyQueryHookResult = ReturnType<typeof useDetectionLazyQuery>;
export type DetectionQueryResult = Apollo.QueryResult<DetectionQuery, DetectionQueryVariables>;
export function refetchDetectionQuery(variables: DetectionQueryVariables) {
      return { query: DetectionDocument, variables: variables }
    }
export const EventsSummaryDocument = gql`
    query EventsSummary {
  scheduled: events(
    query: {filters: [{operator: IN, field: "status", value: [SCHEDULED]}, {operator: NOT_EQUALS, value: SCHEDULED_EVENT, field: "category"}, {operator: NOT_EQUALS, value: ROAD_CONDITION, field: "category"}]}
  ) {
    totalCount
  }
  active: events(
    query: {filters: [{operator: IN, field: "status", value: [ACTIVE]}, {operator: NOT_EQUALS, value: SCHEDULED_EVENT, field: "category"}, {operator: NOT_EQUALS, value: ROAD_CONDITION, field: "category"}]}
  ) {
    totalCount
  }
  suspect: events(
    query: {filters: [{operator: IN, field: "status", value: [SUSPECT]}, {operator: NOT_EQUALS, value: SCHEDULED_EVENT, field: "category"}, {operator: NOT_EQUALS, value: ROAD_CONDITION, field: "category"}]}
  ) {
    totalCount
  }
  verified: events(
    query: {filters: [{operator: IN, field: "status", value: [VERIFIED]}, {operator: NOT_EQUALS, value: SCHEDULED_EVENT, field: "category"}, {operator: NOT_EQUALS, value: ROAD_CONDITION, field: "category"}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useEventsSummaryQuery__
 *
 * To run a query within a React component, call `useEventsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<EventsSummaryQuery, EventsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsSummaryQuery, EventsSummaryQueryVariables>(EventsSummaryDocument, options);
      }
export function useEventsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsSummaryQuery, EventsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsSummaryQuery, EventsSummaryQueryVariables>(EventsSummaryDocument, options);
        }
export type EventsSummaryQueryHookResult = ReturnType<typeof useEventsSummaryQuery>;
export type EventsSummaryLazyQueryHookResult = ReturnType<typeof useEventsSummaryLazyQuery>;
export type EventsSummaryQueryResult = Apollo.QueryResult<EventsSummaryQuery, EventsSummaryQueryVariables>;
export function refetchEventsSummaryQuery(variables?: EventsSummaryQueryVariables) {
      return { query: EventsSummaryDocument, variables: variables }
    }
export const DetectionUpdatedDocument = gql`
    subscription DetectionUpdated($ids: [ID!]) {
  detectionUpdated(ids: $ids) {
    ...Detection
  }
}
    ${DetectionFragmentDoc}`;

/**
 * __useDetectionUpdatedSubscription__
 *
 * To run a query within a React component, call `useDetectionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetectionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectionUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDetectionUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DetectionUpdatedSubscription, DetectionUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetectionUpdatedSubscription, DetectionUpdatedSubscriptionVariables>(DetectionUpdatedDocument, options);
      }
export type DetectionUpdatedSubscriptionHookResult = ReturnType<typeof useDetectionUpdatedSubscription>;
export type DetectionUpdatedSubscriptionResult = Apollo.SubscriptionResult<DetectionUpdatedSubscription>;
export const ActiveEventsDashboardDocument = gql`
    query ActiveEventsDashboard {
  events(
    query: {limit: 100000, filters: [{field: "status", value: "VERIFIED", operator: EQUALS}]}
  ) {
    edges {
      node {
        type
        category
        attributes
      }
    }
  }
}
    `;

/**
 * __useActiveEventsDashboardQuery__
 *
 * To run a query within a React component, call `useActiveEventsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveEventsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveEventsDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveEventsDashboardQuery(baseOptions?: Apollo.QueryHookOptions<ActiveEventsDashboardQuery, ActiveEventsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveEventsDashboardQuery, ActiveEventsDashboardQueryVariables>(ActiveEventsDashboardDocument, options);
      }
export function useActiveEventsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveEventsDashboardQuery, ActiveEventsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveEventsDashboardQuery, ActiveEventsDashboardQueryVariables>(ActiveEventsDashboardDocument, options);
        }
export type ActiveEventsDashboardQueryHookResult = ReturnType<typeof useActiveEventsDashboardQuery>;
export type ActiveEventsDashboardLazyQueryHookResult = ReturnType<typeof useActiveEventsDashboardLazyQuery>;
export type ActiveEventsDashboardQueryResult = Apollo.QueryResult<ActiveEventsDashboardQuery, ActiveEventsDashboardQueryVariables>;
export function refetchActiveEventsDashboardQuery(variables?: ActiveEventsDashboardQueryVariables) {
      return { query: ActiveEventsDashboardDocument, variables: variables }
    }
export const AllResourcePlanTasksDocument = gql`
    query AllResourcePlanTasks($id: ID!) {
  allResourcePlanTasks(id: $id) {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;

/**
 * __useAllResourcePlanTasksQuery__
 *
 * To run a query within a React component, call `useAllResourcePlanTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllResourcePlanTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllResourcePlanTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllResourcePlanTasksQuery(baseOptions: Apollo.QueryHookOptions<AllResourcePlanTasksQuery, AllResourcePlanTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllResourcePlanTasksQuery, AllResourcePlanTasksQueryVariables>(AllResourcePlanTasksDocument, options);
      }
export function useAllResourcePlanTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllResourcePlanTasksQuery, AllResourcePlanTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllResourcePlanTasksQuery, AllResourcePlanTasksQueryVariables>(AllResourcePlanTasksDocument, options);
        }
export type AllResourcePlanTasksQueryHookResult = ReturnType<typeof useAllResourcePlanTasksQuery>;
export type AllResourcePlanTasksLazyQueryHookResult = ReturnType<typeof useAllResourcePlanTasksLazyQuery>;
export type AllResourcePlanTasksQueryResult = Apollo.QueryResult<AllResourcePlanTasksQuery, AllResourcePlanTasksQueryVariables>;
export function refetchAllResourcePlanTasksQuery(variables: AllResourcePlanTasksQueryVariables) {
      return { query: AllResourcePlanTasksDocument, variables: variables }
    }
export const ResourcePlanTasksDocument = gql`
    query ResourcePlanTasks($id: ID!, $from: DateTime!, $to: DateTime!, $timezone: String!) {
  resourcePlanTasks(id: $id, from: $from, to: $to, timezone: $timezone) {
    date
    tasks {
      ...TaskOccurrenceFragment
    }
  }
}
    ${TaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useResourcePlanTasksQuery__
 *
 * To run a query within a React component, call `useResourcePlanTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useResourcePlanTasksQuery(baseOptions: Apollo.QueryHookOptions<ResourcePlanTasksQuery, ResourcePlanTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcePlanTasksQuery, ResourcePlanTasksQueryVariables>(ResourcePlanTasksDocument, options);
      }
export function useResourcePlanTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcePlanTasksQuery, ResourcePlanTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcePlanTasksQuery, ResourcePlanTasksQueryVariables>(ResourcePlanTasksDocument, options);
        }
export type ResourcePlanTasksQueryHookResult = ReturnType<typeof useResourcePlanTasksQuery>;
export type ResourcePlanTasksLazyQueryHookResult = ReturnType<typeof useResourcePlanTasksLazyQuery>;
export type ResourcePlanTasksQueryResult = Apollo.QueryResult<ResourcePlanTasksQuery, ResourcePlanTasksQueryVariables>;
export function refetchResourcePlanTasksQuery(variables: ResourcePlanTasksQueryVariables) {
      return { query: ResourcePlanTasksDocument, variables: variables }
    }
export const ResourcePlanTaskUpdatedDocument = gql`
    subscription ResourcePlanTaskUpdated($ids: [ID!], $creation: Boolean, $deletion: Boolean) {
  resourcePlanTaskUpdated(ids: $ids, creation: $creation, deletion: $deletion) {
    ...ResourcePlanTaskFragment
  }
}
    ${ResourcePlanTaskFragmentFragmentDoc}`;

/**
 * __useResourcePlanTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useResourcePlanTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanTaskUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      creation: // value for 'creation'
 *      deletion: // value for 'deletion'
 *   },
 * });
 */
export function useResourcePlanTaskUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ResourcePlanTaskUpdatedSubscription, ResourcePlanTaskUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResourcePlanTaskUpdatedSubscription, ResourcePlanTaskUpdatedSubscriptionVariables>(ResourcePlanTaskUpdatedDocument, options);
      }
export type ResourcePlanTaskUpdatedSubscriptionHookResult = ReturnType<typeof useResourcePlanTaskUpdatedSubscription>;
export type ResourcePlanTaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<ResourcePlanTaskUpdatedSubscription>;
export const SignListDocument = gql`
    query SignList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  signs(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...SignDetail
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignDetailFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignListQuery__
 *
 * To run a query within a React component, call `useSignListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSignListQuery(baseOptions?: Apollo.QueryHookOptions<SignListQuery, SignListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignListQuery, SignListQueryVariables>(SignListDocument, options);
      }
export function useSignListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignListQuery, SignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignListQuery, SignListQueryVariables>(SignListDocument, options);
        }
export type SignListQueryHookResult = ReturnType<typeof useSignListQuery>;
export type SignListLazyQueryHookResult = ReturnType<typeof useSignListLazyQuery>;
export type SignListQueryResult = Apollo.QueryResult<SignListQuery, SignListQueryVariables>;
export function refetchSignListQuery(variables?: SignListQueryVariables) {
      return { query: SignListDocument, variables: variables }
    }
export const ResourcePlanFutureTasksDocument = gql`
    query ResourcePlanFutureTasks($id: String!) {
  resourcePlanFutureTasks(id: $id, timezone: "Z") {
    nextExecutionDate
  }
}
    `;

/**
 * __useResourcePlanFutureTasksQuery__
 *
 * To run a query within a React component, call `useResourcePlanFutureTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanFutureTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanFutureTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourcePlanFutureTasksQuery(baseOptions: Apollo.QueryHookOptions<ResourcePlanFutureTasksQuery, ResourcePlanFutureTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcePlanFutureTasksQuery, ResourcePlanFutureTasksQueryVariables>(ResourcePlanFutureTasksDocument, options);
      }
export function useResourcePlanFutureTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcePlanFutureTasksQuery, ResourcePlanFutureTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcePlanFutureTasksQuery, ResourcePlanFutureTasksQueryVariables>(ResourcePlanFutureTasksDocument, options);
        }
export type ResourcePlanFutureTasksQueryHookResult = ReturnType<typeof useResourcePlanFutureTasksQuery>;
export type ResourcePlanFutureTasksLazyQueryHookResult = ReturnType<typeof useResourcePlanFutureTasksLazyQuery>;
export type ResourcePlanFutureTasksQueryResult = Apollo.QueryResult<ResourcePlanFutureTasksQuery, ResourcePlanFutureTasksQueryVariables>;
export function refetchResourcePlanFutureTasksQuery(variables: ResourcePlanFutureTasksQueryVariables) {
      return { query: ResourcePlanFutureTasksDocument, variables: variables }
    }
export const NearbyCamerasDocument = gql`
    query NearbyCameras($thresholdMiles: Float, $x: Float!, $y: Float!) {
  nearbyCameras(thresholdMiles: $thresholdMiles, x: $x, y: $y) {
    ...CameraNode
  }
}
    ${CameraNodeFragmentDoc}`;

/**
 * __useNearbyCamerasQuery__
 *
 * To run a query within a React component, call `useNearbyCamerasQuery` and pass it any options that fit your needs.
 * When your component renders, `useNearbyCamerasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNearbyCamerasQuery({
 *   variables: {
 *      thresholdMiles: // value for 'thresholdMiles'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *   },
 * });
 */
export function useNearbyCamerasQuery(baseOptions: Apollo.QueryHookOptions<NearbyCamerasQuery, NearbyCamerasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NearbyCamerasQuery, NearbyCamerasQueryVariables>(NearbyCamerasDocument, options);
      }
export function useNearbyCamerasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NearbyCamerasQuery, NearbyCamerasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NearbyCamerasQuery, NearbyCamerasQueryVariables>(NearbyCamerasDocument, options);
        }
export type NearbyCamerasQueryHookResult = ReturnType<typeof useNearbyCamerasQuery>;
export type NearbyCamerasLazyQueryHookResult = ReturnType<typeof useNearbyCamerasLazyQuery>;
export type NearbyCamerasQueryResult = Apollo.QueryResult<NearbyCamerasQuery, NearbyCamerasQueryVariables>;
export function refetchNearbyCamerasQuery(variables: NearbyCamerasQueryVariables) {
      return { query: NearbyCamerasDocument, variables: variables }
    }
export const EventsCameraDocument = gql`
    query EventsCamera($id: ID!) {
  camera(id: $id) {
    ...CameraNode
  }
}
    ${CameraNodeFragmentDoc}`;

/**
 * __useEventsCameraQuery__
 *
 * To run a query within a React component, call `useEventsCameraQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsCameraQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsCameraQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventsCameraQuery(baseOptions: Apollo.QueryHookOptions<EventsCameraQuery, EventsCameraQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsCameraQuery, EventsCameraQueryVariables>(EventsCameraDocument, options);
      }
export function useEventsCameraLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsCameraQuery, EventsCameraQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsCameraQuery, EventsCameraQueryVariables>(EventsCameraDocument, options);
        }
export type EventsCameraQueryHookResult = ReturnType<typeof useEventsCameraQuery>;
export type EventsCameraLazyQueryHookResult = ReturnType<typeof useEventsCameraLazyQuery>;
export type EventsCameraQueryResult = Apollo.QueryResult<EventsCameraQuery, EventsCameraQueryVariables>;
export function refetchEventsCameraQuery(variables: EventsCameraQueryVariables) {
      return { query: EventsCameraDocument, variables: variables }
    }
export const EventUpdatedShortDocument = gql`
    subscription EventUpdatedShort {
  eventUpdated {
    id
  }
}
    `;

/**
 * __useEventUpdatedShortSubscription__
 *
 * To run a query within a React component, call `useEventUpdatedShortSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventUpdatedShortSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventUpdatedShortSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEventUpdatedShortSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EventUpdatedShortSubscription, EventUpdatedShortSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EventUpdatedShortSubscription, EventUpdatedShortSubscriptionVariables>(EventUpdatedShortDocument, options);
      }
export type EventUpdatedShortSubscriptionHookResult = ReturnType<typeof useEventUpdatedShortSubscription>;
export type EventUpdatedShortSubscriptionResult = Apollo.SubscriptionResult<EventUpdatedShortSubscription>;
export const GetKineticUserDocument = gql`
    query GetKineticUser($id: ID!) {
  getKineticUser(id: $id) {
    ...KineticUserFragment
  }
}
    ${KineticUserFragmentFragmentDoc}`;

/**
 * __useGetKineticUserQuery__
 *
 * To run a query within a React component, call `useGetKineticUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKineticUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKineticUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKineticUserQuery(baseOptions: Apollo.QueryHookOptions<GetKineticUserQuery, GetKineticUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKineticUserQuery, GetKineticUserQueryVariables>(GetKineticUserDocument, options);
      }
export function useGetKineticUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKineticUserQuery, GetKineticUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKineticUserQuery, GetKineticUserQueryVariables>(GetKineticUserDocument, options);
        }
export type GetKineticUserQueryHookResult = ReturnType<typeof useGetKineticUserQuery>;
export type GetKineticUserLazyQueryHookResult = ReturnType<typeof useGetKineticUserLazyQuery>;
export type GetKineticUserQueryResult = Apollo.QueryResult<GetKineticUserQuery, GetKineticUserQueryVariables>;
export function refetchGetKineticUserQuery(variables: GetKineticUserQueryVariables) {
      return { query: GetKineticUserDocument, variables: variables }
    }
export const EventActivityLogAddedDocument = gql`
    subscription EventActivityLogAdded($ids: [ID!], $module: KineticModule = EVENTS) {
  addedActivityLog(ids: $ids, module: $module) {
    ...ActivityLogNodeFragment
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}`;

/**
 * __useEventActivityLogAddedSubscription__
 *
 * To run a query within a React component, call `useEventActivityLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventActivityLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventActivityLogAddedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useEventActivityLogAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EventActivityLogAddedSubscription, EventActivityLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EventActivityLogAddedSubscription, EventActivityLogAddedSubscriptionVariables>(EventActivityLogAddedDocument, options);
      }
export type EventActivityLogAddedSubscriptionHookResult = ReturnType<typeof useEventActivityLogAddedSubscription>;
export type EventActivityLogAddedSubscriptionResult = Apollo.SubscriptionResult<EventActivityLogAddedSubscription>;
export const ResourcePlanActivityLogAddedDocument = gql`
    subscription ResourcePlanActivityLogAdded($ids: [ID!], $module: KineticModule = EVENTS) {
  addedActivityLog(ids: $ids, module: $module) {
    ...ActivityLogNodeFragment
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}`;

/**
 * __useResourcePlanActivityLogAddedSubscription__
 *
 * To run a query within a React component, call `useResourcePlanActivityLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanActivityLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanActivityLogAddedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useResourcePlanActivityLogAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ResourcePlanActivityLogAddedSubscription, ResourcePlanActivityLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResourcePlanActivityLogAddedSubscription, ResourcePlanActivityLogAddedSubscriptionVariables>(ResourcePlanActivityLogAddedDocument, options);
      }
export type ResourcePlanActivityLogAddedSubscriptionHookResult = ReturnType<typeof useResourcePlanActivityLogAddedSubscription>;
export type ResourcePlanActivityLogAddedSubscriptionResult = Apollo.SubscriptionResult<ResourcePlanActivityLogAddedSubscription>;
export const EventCorridorDocument = gql`
    query EventCorridor($filters: [FilterInput!]!) {
  corridors(query: {filters: $filters}) {
    edges {
      node {
        integrations
        settings
        lanes {
          startReference
          endReference
          direction
          lineType
          position
          type
        }
      }
    }
  }
}
    `;

/**
 * __useEventCorridorQuery__
 *
 * To run a query within a React component, call `useEventCorridorQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventCorridorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventCorridorQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEventCorridorQuery(baseOptions: Apollo.QueryHookOptions<EventCorridorQuery, EventCorridorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventCorridorQuery, EventCorridorQueryVariables>(EventCorridorDocument, options);
      }
export function useEventCorridorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventCorridorQuery, EventCorridorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventCorridorQuery, EventCorridorQueryVariables>(EventCorridorDocument, options);
        }
export type EventCorridorQueryHookResult = ReturnType<typeof useEventCorridorQuery>;
export type EventCorridorLazyQueryHookResult = ReturnType<typeof useEventCorridorLazyQuery>;
export type EventCorridorQueryResult = Apollo.QueryResult<EventCorridorQuery, EventCorridorQueryVariables>;
export function refetchEventCorridorQuery(variables: EventCorridorQueryVariables) {
      return { query: EventCorridorDocument, variables: variables }
    }
export const MessageTemplateListDocument = gql`
    query MessageTemplateList($after: String, $before: String, $limit: Int = 100, $sortField: String = "name", $searchFields: [String] = ["name"], $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput]) {
  emailsTemplate(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, filters: $filters, searchFields: $searchFields}
  ) {
    edges {
      node {
        id
        name
        type
        form
        module
        subject
        body
      }
    }
  }
}
    `;

/**
 * __useMessageTemplateListQuery__
 *
 * To run a query within a React component, call `useMessageTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTemplateListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMessageTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<MessageTemplateListQuery, MessageTemplateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageTemplateListQuery, MessageTemplateListQueryVariables>(MessageTemplateListDocument, options);
      }
export function useMessageTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageTemplateListQuery, MessageTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageTemplateListQuery, MessageTemplateListQueryVariables>(MessageTemplateListDocument, options);
        }
export type MessageTemplateListQueryHookResult = ReturnType<typeof useMessageTemplateListQuery>;
export type MessageTemplateListLazyQueryHookResult = ReturnType<typeof useMessageTemplateListLazyQuery>;
export type MessageTemplateListQueryResult = Apollo.QueryResult<MessageTemplateListQuery, MessageTemplateListQueryVariables>;
export function refetchMessageTemplateListQuery(variables?: MessageTemplateListQueryVariables) {
      return { query: MessageTemplateListDocument, variables: variables }
    }
export const EventSummaryReportDocument = gql`
    query EventSummaryReport($id: ID!) {
  eventSummaryReport(id: $id)
}
    `;

/**
 * __useEventSummaryReportQuery__
 *
 * To run a query within a React component, call `useEventSummaryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSummaryReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSummaryReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventSummaryReportQuery(baseOptions: Apollo.QueryHookOptions<EventSummaryReportQuery, EventSummaryReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventSummaryReportQuery, EventSummaryReportQueryVariables>(EventSummaryReportDocument, options);
      }
export function useEventSummaryReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventSummaryReportQuery, EventSummaryReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventSummaryReportQuery, EventSummaryReportQueryVariables>(EventSummaryReportDocument, options);
        }
export type EventSummaryReportQueryHookResult = ReturnType<typeof useEventSummaryReportQuery>;
export type EventSummaryReportLazyQueryHookResult = ReturnType<typeof useEventSummaryReportLazyQuery>;
export type EventSummaryReportQueryResult = Apollo.QueryResult<EventSummaryReportQuery, EventSummaryReportQueryVariables>;
export function refetchEventSummaryReportQuery(variables: EventSummaryReportQueryVariables) {
      return { query: EventSummaryReportDocument, variables: variables }
    }
export const HistoricalEventSummaryReportDocument = gql`
    query HistoricalEventSummaryReport($id: ID!) {
  historicalEventSummaryReport(id: $id)
}
    `;

/**
 * __useHistoricalEventSummaryReportQuery__
 *
 * To run a query within a React component, call `useHistoricalEventSummaryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricalEventSummaryReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricalEventSummaryReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHistoricalEventSummaryReportQuery(baseOptions: Apollo.QueryHookOptions<HistoricalEventSummaryReportQuery, HistoricalEventSummaryReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoricalEventSummaryReportQuery, HistoricalEventSummaryReportQueryVariables>(HistoricalEventSummaryReportDocument, options);
      }
export function useHistoricalEventSummaryReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoricalEventSummaryReportQuery, HistoricalEventSummaryReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoricalEventSummaryReportQuery, HistoricalEventSummaryReportQueryVariables>(HistoricalEventSummaryReportDocument, options);
        }
export type HistoricalEventSummaryReportQueryHookResult = ReturnType<typeof useHistoricalEventSummaryReportQuery>;
export type HistoricalEventSummaryReportLazyQueryHookResult = ReturnType<typeof useHistoricalEventSummaryReportLazyQuery>;
export type HistoricalEventSummaryReportQueryResult = Apollo.QueryResult<HistoricalEventSummaryReportQuery, HistoricalEventSummaryReportQueryVariables>;
export function refetchHistoricalEventSummaryReportQuery(variables: HistoricalEventSummaryReportQueryVariables) {
      return { query: HistoricalEventSummaryReportDocument, variables: variables }
    }
export const IntegrationByIdDocument = gql`
    query IntegrationById($id: ID!) {
  integration(id: $id) {
    name
    id
  }
}
    `;

/**
 * __useIntegrationByIdQuery__
 *
 * To run a query within a React component, call `useIntegrationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationByIdQuery(baseOptions: Apollo.QueryHookOptions<IntegrationByIdQuery, IntegrationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationByIdQuery, IntegrationByIdQueryVariables>(IntegrationByIdDocument, options);
      }
export function useIntegrationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationByIdQuery, IntegrationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationByIdQuery, IntegrationByIdQueryVariables>(IntegrationByIdDocument, options);
        }
export type IntegrationByIdQueryHookResult = ReturnType<typeof useIntegrationByIdQuery>;
export type IntegrationByIdLazyQueryHookResult = ReturnType<typeof useIntegrationByIdLazyQuery>;
export type IntegrationByIdQueryResult = Apollo.QueryResult<IntegrationByIdQuery, IntegrationByIdQueryVariables>;
export function refetchIntegrationByIdQuery(variables: IntegrationByIdQueryVariables) {
      return { query: IntegrationByIdDocument, variables: variables }
    }
export const SignalActionSetListDocument = gql`
    query SignalActionSetList($sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  signalActionSets(
    searchText: $searchText
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    before: $before
    after: $after
    limit: $limit
  ) {
    edges {
      node {
        number
        impact
        notes
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useSignalActionSetListQuery__
 *
 * To run a query within a React component, call `useSignalActionSetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalActionSetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalActionSetListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSignalActionSetListQuery(baseOptions?: Apollo.QueryHookOptions<SignalActionSetListQuery, SignalActionSetListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalActionSetListQuery, SignalActionSetListQueryVariables>(SignalActionSetListDocument, options);
      }
export function useSignalActionSetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalActionSetListQuery, SignalActionSetListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalActionSetListQuery, SignalActionSetListQueryVariables>(SignalActionSetListDocument, options);
        }
export type SignalActionSetListQueryHookResult = ReturnType<typeof useSignalActionSetListQuery>;
export type SignalActionSetListLazyQueryHookResult = ReturnType<typeof useSignalActionSetListLazyQuery>;
export type SignalActionSetListQueryResult = Apollo.QueryResult<SignalActionSetListQuery, SignalActionSetListQueryVariables>;
export function refetchSignalActionSetListQuery(variables?: SignalActionSetListQueryVariables) {
      return { query: SignalActionSetListDocument, variables: variables }
    }
export const AllScheduledEventTasksDocument = gql`
    query AllScheduledEventTasks($startDateTime: DateTime, $endDateTime: DateTime, $filters: [FilterInput], $searchText: String, $from: DateTime!, $to: DateTime!, $timezone: String!) {
  allScheduledEventTasks(
    query: {filters: $filters, searchText: $searchText, startDateTime: $startDateTime, endDateTime: $endDateTime}
    from: $from
    to: $to
    timezone: $timezone
  ) {
    date
    tasks {
      ...TaskOccurrenceFragment
    }
  }
}
    ${TaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useAllScheduledEventTasksQuery__
 *
 * To run a query within a React component, call `useAllScheduledEventTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllScheduledEventTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllScheduledEventTasksQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useAllScheduledEventTasksQuery(baseOptions: Apollo.QueryHookOptions<AllScheduledEventTasksQuery, AllScheduledEventTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllScheduledEventTasksQuery, AllScheduledEventTasksQueryVariables>(AllScheduledEventTasksDocument, options);
      }
export function useAllScheduledEventTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllScheduledEventTasksQuery, AllScheduledEventTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllScheduledEventTasksQuery, AllScheduledEventTasksQueryVariables>(AllScheduledEventTasksDocument, options);
        }
export type AllScheduledEventTasksQueryHookResult = ReturnType<typeof useAllScheduledEventTasksQuery>;
export type AllScheduledEventTasksLazyQueryHookResult = ReturnType<typeof useAllScheduledEventTasksLazyQuery>;
export type AllScheduledEventTasksQueryResult = Apollo.QueryResult<AllScheduledEventTasksQuery, AllScheduledEventTasksQueryVariables>;
export function refetchAllScheduledEventTasksQuery(variables: AllScheduledEventTasksQueryVariables) {
      return { query: AllScheduledEventTasksDocument, variables: variables }
    }
export const ScheduledEventTasksDocument = gql`
    query ScheduledEventTasks($id: ID!, $from: DateTime!, $to: DateTime!, $timezone: String!) {
  scheduledEventTasks(id: $id, from: $from, to: $to, timezone: $timezone) {
    date
    tasks {
      ...TaskOccurrenceFragment
    }
  }
}
    ${TaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useScheduledEventTasksQuery__
 *
 * To run a query within a React component, call `useScheduledEventTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledEventTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledEventTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useScheduledEventTasksQuery(baseOptions: Apollo.QueryHookOptions<ScheduledEventTasksQuery, ScheduledEventTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledEventTasksQuery, ScheduledEventTasksQueryVariables>(ScheduledEventTasksDocument, options);
      }
export function useScheduledEventTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledEventTasksQuery, ScheduledEventTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledEventTasksQuery, ScheduledEventTasksQueryVariables>(ScheduledEventTasksDocument, options);
        }
export type ScheduledEventTasksQueryHookResult = ReturnType<typeof useScheduledEventTasksQuery>;
export type ScheduledEventTasksLazyQueryHookResult = ReturnType<typeof useScheduledEventTasksLazyQuery>;
export type ScheduledEventTasksQueryResult = Apollo.QueryResult<ScheduledEventTasksQuery, ScheduledEventTasksQueryVariables>;
export function refetchScheduledEventTasksQuery(variables: ScheduledEventTasksQueryVariables) {
      return { query: ScheduledEventTasksDocument, variables: variables }
    }
export const ScheduledEventTaskUpdatedDocument = gql`
    subscription ScheduledEventTaskUpdated($ids: [ID!], $creation: Boolean, $deletion: Boolean) {
  scheduledEventTaskUpdated(ids: $ids, creation: $creation, deletion: $deletion) {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;

/**
 * __useScheduledEventTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useScheduledEventTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useScheduledEventTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledEventTaskUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      creation: // value for 'creation'
 *      deletion: // value for 'deletion'
 *   },
 * });
 */
export function useScheduledEventTaskUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ScheduledEventTaskUpdatedSubscription, ScheduledEventTaskUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ScheduledEventTaskUpdatedSubscription, ScheduledEventTaskUpdatedSubscriptionVariables>(ScheduledEventTaskUpdatedDocument, options);
      }
export type ScheduledEventTaskUpdatedSubscriptionHookResult = ReturnType<typeof useScheduledEventTaskUpdatedSubscription>;
export type ScheduledEventTaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<ScheduledEventTaskUpdatedSubscription>;
export const EventReviewDocument = gql`
    query EventReview($sortOrder: SortOrder = ASCENDING, $sortField: String = "timestamp", $filters: [FilterInput!]!, $entityIds: [String!]!, $limit: Int = 25, $before: String, $after: String, $searchText: String, $searchFields: [String!]) {
  history(
    entityIds: $entityIds
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    after: $after
    limit: $limit
    searchText: $searchText
    searchFields: $searchFields
  ) {
    edges {
      node {
        id
        type
        entityId
        entity
        timestamp
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useEventReviewQuery__
 *
 * To run a query within a React component, call `useEventReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventReviewQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      entityIds: // value for 'entityIds'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *   },
 * });
 */
export function useEventReviewQuery(baseOptions: Apollo.QueryHookOptions<EventReviewQuery, EventReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventReviewQuery, EventReviewQueryVariables>(EventReviewDocument, options);
      }
export function useEventReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventReviewQuery, EventReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventReviewQuery, EventReviewQueryVariables>(EventReviewDocument, options);
        }
export type EventReviewQueryHookResult = ReturnType<typeof useEventReviewQuery>;
export type EventReviewLazyQueryHookResult = ReturnType<typeof useEventReviewLazyQuery>;
export type EventReviewQueryResult = Apollo.QueryResult<EventReviewQuery, EventReviewQueryVariables>;
export function refetchEventReviewQuery(variables: EventReviewQueryVariables) {
      return { query: EventReviewDocument, variables: variables }
    }
export const GetResourceContactGroupDocument = gql`
    query GetResourceContactGroup($id: ID!) {
  contactGroup(id: $id) {
    ...ResourceContactGroupListNodeFragment
  }
}
    ${ResourceContactGroupListNodeFragmentFragmentDoc}`;

/**
 * __useGetResourceContactGroupQuery__
 *
 * To run a query within a React component, call `useGetResourceContactGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceContactGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceContactGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResourceContactGroupQuery(baseOptions: Apollo.QueryHookOptions<GetResourceContactGroupQuery, GetResourceContactGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceContactGroupQuery, GetResourceContactGroupQueryVariables>(GetResourceContactGroupDocument, options);
      }
export function useGetResourceContactGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceContactGroupQuery, GetResourceContactGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceContactGroupQuery, GetResourceContactGroupQueryVariables>(GetResourceContactGroupDocument, options);
        }
export type GetResourceContactGroupQueryHookResult = ReturnType<typeof useGetResourceContactGroupQuery>;
export type GetResourceContactGroupLazyQueryHookResult = ReturnType<typeof useGetResourceContactGroupLazyQuery>;
export type GetResourceContactGroupQueryResult = Apollo.QueryResult<GetResourceContactGroupQuery, GetResourceContactGroupQueryVariables>;
export function refetchGetResourceContactGroupQuery(variables: GetResourceContactGroupQueryVariables) {
      return { query: GetResourceContactGroupDocument, variables: variables }
    }
export const EventAlarmConfigsDocument = gql`
    query EventAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "EVENTS"}, {field: "entityType", operator: IN, value: ["ALERT", "EVENT"]}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useEventAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useEventAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<EventAlarmConfigsQuery, EventAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventAlarmConfigsQuery, EventAlarmConfigsQueryVariables>(EventAlarmConfigsDocument, options);
      }
export function useEventAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventAlarmConfigsQuery, EventAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventAlarmConfigsQuery, EventAlarmConfigsQueryVariables>(EventAlarmConfigsDocument, options);
        }
export type EventAlarmConfigsQueryHookResult = ReturnType<typeof useEventAlarmConfigsQuery>;
export type EventAlarmConfigsLazyQueryHookResult = ReturnType<typeof useEventAlarmConfigsLazyQuery>;
export type EventAlarmConfigsQueryResult = Apollo.QueryResult<EventAlarmConfigsQuery, EventAlarmConfigsQueryVariables>;
export function refetchEventAlarmConfigsQuery(variables?: EventAlarmConfigsQueryVariables) {
      return { query: EventAlarmConfigsDocument, variables: variables }
    }
export const GetFileInfoDocument = gql`
    query GetFileInfo($id: ID!, $centerId: String) {
  getFileInfo(id: $id, centerId: $centerId) {
    id
    name
    contentType
    path
  }
}
    `;

/**
 * __useGetFileInfoQuery__
 *
 * To run a query within a React component, call `useGetFileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useGetFileInfoQuery(baseOptions: Apollo.QueryHookOptions<GetFileInfoQuery, GetFileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileInfoQuery, GetFileInfoQueryVariables>(GetFileInfoDocument, options);
      }
export function useGetFileInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileInfoQuery, GetFileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileInfoQuery, GetFileInfoQueryVariables>(GetFileInfoDocument, options);
        }
export type GetFileInfoQueryHookResult = ReturnType<typeof useGetFileInfoQuery>;
export type GetFileInfoLazyQueryHookResult = ReturnType<typeof useGetFileInfoLazyQuery>;
export type GetFileInfoQueryResult = Apollo.QueryResult<GetFileInfoQuery, GetFileInfoQueryVariables>;
export function refetchGetFileInfoQuery(variables: GetFileInfoQueryVariables) {
      return { query: GetFileInfoDocument, variables: variables }
    }
export const ResourcePlanActivationResultsDocument = gql`
    query ResourcePlanActivationResults($sortOrder: SortOrder = DESCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  resourcePlanActivationResults(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        ...ResourcePlanActivationResult
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${ResourcePlanActivationResultFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useResourcePlanActivationResultsQuery__
 *
 * To run a query within a React component, call `useResourcePlanActivationResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanActivationResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanActivationResultsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useResourcePlanActivationResultsQuery(baseOptions?: Apollo.QueryHookOptions<ResourcePlanActivationResultsQuery, ResourcePlanActivationResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcePlanActivationResultsQuery, ResourcePlanActivationResultsQueryVariables>(ResourcePlanActivationResultsDocument, options);
      }
export function useResourcePlanActivationResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcePlanActivationResultsQuery, ResourcePlanActivationResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcePlanActivationResultsQuery, ResourcePlanActivationResultsQueryVariables>(ResourcePlanActivationResultsDocument, options);
        }
export type ResourcePlanActivationResultsQueryHookResult = ReturnType<typeof useResourcePlanActivationResultsQuery>;
export type ResourcePlanActivationResultsLazyQueryHookResult = ReturnType<typeof useResourcePlanActivationResultsLazyQuery>;
export type ResourcePlanActivationResultsQueryResult = Apollo.QueryResult<ResourcePlanActivationResultsQuery, ResourcePlanActivationResultsQueryVariables>;
export function refetchResourcePlanActivationResultsQuery(variables?: ResourcePlanActivationResultsQueryVariables) {
      return { query: ResourcePlanActivationResultsDocument, variables: variables }
    }
export const TrafficControlNameDocument = gql`
    query TrafficControlName($id: ID!) {
  trafficControl(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useTrafficControlNameQuery__
 *
 * To run a query within a React component, call `useTrafficControlNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficControlNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficControlNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrafficControlNameQuery(baseOptions: Apollo.QueryHookOptions<TrafficControlNameQuery, TrafficControlNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficControlNameQuery, TrafficControlNameQueryVariables>(TrafficControlNameDocument, options);
      }
export function useTrafficControlNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficControlNameQuery, TrafficControlNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficControlNameQuery, TrafficControlNameQueryVariables>(TrafficControlNameDocument, options);
        }
export type TrafficControlNameQueryHookResult = ReturnType<typeof useTrafficControlNameQuery>;
export type TrafficControlNameLazyQueryHookResult = ReturnType<typeof useTrafficControlNameLazyQuery>;
export type TrafficControlNameQueryResult = Apollo.QueryResult<TrafficControlNameQuery, TrafficControlNameQueryVariables>;
export function refetchTrafficControlNameQuery(variables: TrafficControlNameQueryVariables) {
      return { query: TrafficControlNameDocument, variables: variables }
    }
export const SaveSystemDirectoriesDocument = gql`
    mutation SaveSystemDirectories($input: [DirectoryInput!]!, $removedDirectories: [String!]!) {
  saveSystemDirectories(input: $input, removedDirectories: $removedDirectories) {
    ...DirectoryRecursive
  }
}
    ${DirectoryRecursiveFragmentDoc}`;
export type SaveSystemDirectoriesMutationFn = Apollo.MutationFunction<SaveSystemDirectoriesMutation, SaveSystemDirectoriesMutationVariables>;

/**
 * __useSaveSystemDirectoriesMutation__
 *
 * To run a mutation, you first call `useSaveSystemDirectoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSystemDirectoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSystemDirectoriesMutation, { data, loading, error }] = useSaveSystemDirectoriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      removedDirectories: // value for 'removedDirectories'
 *   },
 * });
 */
export function useSaveSystemDirectoriesMutation(baseOptions?: Apollo.MutationHookOptions<SaveSystemDirectoriesMutation, SaveSystemDirectoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSystemDirectoriesMutation, SaveSystemDirectoriesMutationVariables>(SaveSystemDirectoriesDocument, options);
      }
export type SaveSystemDirectoriesMutationHookResult = ReturnType<typeof useSaveSystemDirectoriesMutation>;
export type SaveSystemDirectoriesMutationResult = Apollo.MutationResult<SaveSystemDirectoriesMutation>;
export type SaveSystemDirectoriesMutationOptions = Apollo.BaseMutationOptions<SaveSystemDirectoriesMutation, SaveSystemDirectoriesMutationVariables>;
export const SaveUserDirectoriesDocument = gql`
    mutation SaveUserDirectories($input: [DirectoryInput!]!, $removedDirectories: [String!]!) {
  saveUserDirectories(input: $input, removedDirectories: $removedDirectories) {
    ...DirectoryRecursive
  }
}
    ${DirectoryRecursiveFragmentDoc}`;
export type SaveUserDirectoriesMutationFn = Apollo.MutationFunction<SaveUserDirectoriesMutation, SaveUserDirectoriesMutationVariables>;

/**
 * __useSaveUserDirectoriesMutation__
 *
 * To run a mutation, you first call `useSaveUserDirectoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserDirectoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserDirectoriesMutation, { data, loading, error }] = useSaveUserDirectoriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      removedDirectories: // value for 'removedDirectories'
 *   },
 * });
 */
export function useSaveUserDirectoriesMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserDirectoriesMutation, SaveUserDirectoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserDirectoriesMutation, SaveUserDirectoriesMutationVariables>(SaveUserDirectoriesDocument, options);
      }
export type SaveUserDirectoriesMutationHookResult = ReturnType<typeof useSaveUserDirectoriesMutation>;
export type SaveUserDirectoriesMutationResult = Apollo.MutationResult<SaveUserDirectoriesMutation>;
export type SaveUserDirectoriesMutationOptions = Apollo.BaseMutationOptions<SaveUserDirectoriesMutation, SaveUserDirectoriesMutationVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($id: ID!, $module: KineticModule, $centerId: String) {
  deleteFile(id: $id, module: $module, centerId: $centerId)
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      module: // value for 'module'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const DeleteManagedFilesDocument = gql`
    mutation DeleteManagedFiles($fileIds: [ID!]!) {
  deleteManagedFiles(fileIds: $fileIds)
}
    `;
export type DeleteManagedFilesMutationFn = Apollo.MutationFunction<DeleteManagedFilesMutation, DeleteManagedFilesMutationVariables>;

/**
 * __useDeleteManagedFilesMutation__
 *
 * To run a mutation, you first call `useDeleteManagedFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManagedFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManagedFilesMutation, { data, loading, error }] = useDeleteManagedFilesMutation({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useDeleteManagedFilesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManagedFilesMutation, DeleteManagedFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManagedFilesMutation, DeleteManagedFilesMutationVariables>(DeleteManagedFilesDocument, options);
      }
export type DeleteManagedFilesMutationHookResult = ReturnType<typeof useDeleteManagedFilesMutation>;
export type DeleteManagedFilesMutationResult = Apollo.MutationResult<DeleteManagedFilesMutation>;
export type DeleteManagedFilesMutationOptions = Apollo.BaseMutationOptions<DeleteManagedFilesMutation, DeleteManagedFilesMutationVariables>;
export const InitMyFilesDocument = gql`
    mutation InitMyFiles {
  initializeMyFilesDirectory {
    id
    order
    name
    owner
    parentId
  }
}
    `;
export type InitMyFilesMutationFn = Apollo.MutationFunction<InitMyFilesMutation, InitMyFilesMutationVariables>;

/**
 * __useInitMyFilesMutation__
 *
 * To run a mutation, you first call `useInitMyFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitMyFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initMyFilesMutation, { data, loading, error }] = useInitMyFilesMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitMyFilesMutation(baseOptions?: Apollo.MutationHookOptions<InitMyFilesMutation, InitMyFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitMyFilesMutation, InitMyFilesMutationVariables>(InitMyFilesDocument, options);
      }
export type InitMyFilesMutationHookResult = ReturnType<typeof useInitMyFilesMutation>;
export type InitMyFilesMutationResult = Apollo.MutationResult<InitMyFilesMutation>;
export type InitMyFilesMutationOptions = Apollo.BaseMutationOptions<InitMyFilesMutation, InitMyFilesMutationVariables>;
export const MoveFileDocument = gql`
    mutation MoveFile($destinationDirectoryId: String!, $fileId: String!) {
  moveFile(destinationDirectoryId: $destinationDirectoryId, fileId: $fileId)
}
    `;
export type MoveFileMutationFn = Apollo.MutationFunction<MoveFileMutation, MoveFileMutationVariables>;

/**
 * __useMoveFileMutation__
 *
 * To run a mutation, you first call `useMoveFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFileMutation, { data, loading, error }] = useMoveFileMutation({
 *   variables: {
 *      destinationDirectoryId: // value for 'destinationDirectoryId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useMoveFileMutation(baseOptions?: Apollo.MutationHookOptions<MoveFileMutation, MoveFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveFileMutation, MoveFileMutationVariables>(MoveFileDocument, options);
      }
export type MoveFileMutationHookResult = ReturnType<typeof useMoveFileMutation>;
export type MoveFileMutationResult = Apollo.MutationResult<MoveFileMutation>;
export type MoveFileMutationOptions = Apollo.BaseMutationOptions<MoveFileMutation, MoveFileMutationVariables>;
export const CopyFileDocument = gql`
    mutation CopyFile($destinationDirectoryId: String!, $fileId: String!) {
  copyFile(destinationDirectoryId: $destinationDirectoryId, fileId: $fileId)
}
    `;
export type CopyFileMutationFn = Apollo.MutationFunction<CopyFileMutation, CopyFileMutationVariables>;

/**
 * __useCopyFileMutation__
 *
 * To run a mutation, you first call `useCopyFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyFileMutation, { data, loading, error }] = useCopyFileMutation({
 *   variables: {
 *      destinationDirectoryId: // value for 'destinationDirectoryId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useCopyFileMutation(baseOptions?: Apollo.MutationHookOptions<CopyFileMutation, CopyFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyFileMutation, CopyFileMutationVariables>(CopyFileDocument, options);
      }
export type CopyFileMutationHookResult = ReturnType<typeof useCopyFileMutation>;
export type CopyFileMutationResult = Apollo.MutationResult<CopyFileMutation>;
export type CopyFileMutationOptions = Apollo.BaseMutationOptions<CopyFileMutation, CopyFileMutationVariables>;
export const GetSystemDirectoriesDocument = gql`
    query GetSystemDirectories($searchText: String) {
  getSystemDirectories(searchText: $searchText) {
    ...DirectoryRecursive
  }
}
    ${DirectoryRecursiveFragmentDoc}`;

/**
 * __useGetSystemDirectoriesQuery__
 *
 * To run a query within a React component, call `useGetSystemDirectoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemDirectoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemDirectoriesQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetSystemDirectoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetSystemDirectoriesQuery, GetSystemDirectoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemDirectoriesQuery, GetSystemDirectoriesQueryVariables>(GetSystemDirectoriesDocument, options);
      }
export function useGetSystemDirectoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemDirectoriesQuery, GetSystemDirectoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemDirectoriesQuery, GetSystemDirectoriesQueryVariables>(GetSystemDirectoriesDocument, options);
        }
export type GetSystemDirectoriesQueryHookResult = ReturnType<typeof useGetSystemDirectoriesQuery>;
export type GetSystemDirectoriesLazyQueryHookResult = ReturnType<typeof useGetSystemDirectoriesLazyQuery>;
export type GetSystemDirectoriesQueryResult = Apollo.QueryResult<GetSystemDirectoriesQuery, GetSystemDirectoriesQueryVariables>;
export function refetchGetSystemDirectoriesQuery(variables?: GetSystemDirectoriesQueryVariables) {
      return { query: GetSystemDirectoriesDocument, variables: variables }
    }
export const GetUserDirectoriesDocument = gql`
    query GetUserDirectories($searchText: String) {
  getUserDirectories(searchText: $searchText) {
    ...DirectoryRecursive
  }
}
    ${DirectoryRecursiveFragmentDoc}`;

/**
 * __useGetUserDirectoriesQuery__
 *
 * To run a query within a React component, call `useGetUserDirectoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDirectoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDirectoriesQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetUserDirectoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDirectoriesQuery, GetUserDirectoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDirectoriesQuery, GetUserDirectoriesQueryVariables>(GetUserDirectoriesDocument, options);
      }
export function useGetUserDirectoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDirectoriesQuery, GetUserDirectoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDirectoriesQuery, GetUserDirectoriesQueryVariables>(GetUserDirectoriesDocument, options);
        }
export type GetUserDirectoriesQueryHookResult = ReturnType<typeof useGetUserDirectoriesQuery>;
export type GetUserDirectoriesLazyQueryHookResult = ReturnType<typeof useGetUserDirectoriesLazyQuery>;
export type GetUserDirectoriesQueryResult = Apollo.QueryResult<GetUserDirectoriesQuery, GetUserDirectoriesQueryVariables>;
export function refetchGetUserDirectoriesQuery(variables?: GetUserDirectoriesQueryVariables) {
      return { query: GetUserDirectoriesDocument, variables: variables }
    }
export const GetManagedFilesByDirectoryDocument = gql`
    query GetManagedFilesByDirectory($directoryId: String!, $searchFields: [String!], $searchText: String, $sortField: String, $sortOrder: SortOrder = ASCENDING) {
  getManagedFilesByDirectory(
    directoryId: $directoryId
    searchFields: $searchFields
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    contentType
    directoryId
    fileName
    id
    name
    owner
    timestamp
    tags
  }
}
    `;

/**
 * __useGetManagedFilesByDirectoryQuery__
 *
 * To run a query within a React component, call `useGetManagedFilesByDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedFilesByDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedFilesByDirectoryQuery({
 *   variables: {
 *      directoryId: // value for 'directoryId'
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetManagedFilesByDirectoryQuery(baseOptions: Apollo.QueryHookOptions<GetManagedFilesByDirectoryQuery, GetManagedFilesByDirectoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagedFilesByDirectoryQuery, GetManagedFilesByDirectoryQueryVariables>(GetManagedFilesByDirectoryDocument, options);
      }
export function useGetManagedFilesByDirectoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagedFilesByDirectoryQuery, GetManagedFilesByDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagedFilesByDirectoryQuery, GetManagedFilesByDirectoryQueryVariables>(GetManagedFilesByDirectoryDocument, options);
        }
export type GetManagedFilesByDirectoryQueryHookResult = ReturnType<typeof useGetManagedFilesByDirectoryQuery>;
export type GetManagedFilesByDirectoryLazyQueryHookResult = ReturnType<typeof useGetManagedFilesByDirectoryLazyQuery>;
export type GetManagedFilesByDirectoryQueryResult = Apollo.QueryResult<GetManagedFilesByDirectoryQuery, GetManagedFilesByDirectoryQueryVariables>;
export function refetchGetManagedFilesByDirectoryQuery(variables: GetManagedFilesByDirectoryQueryVariables) {
      return { query: GetManagedFilesByDirectoryDocument, variables: variables }
    }
export const GetTagsDocument = gql`
    query GetTags {
  getFileTags
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export function refetchGetTagsQuery(variables?: GetTagsQueryVariables) {
      return { query: GetTagsDocument, variables: variables }
    }
export const ManagedFileDocument = gql`
    query ManagedFile($id: ID!) {
  getManagedFile(id: $id) {
    contentType
    directoryId
    fileName
    id
    name
    owner
    tags
  }
}
    `;

/**
 * __useManagedFileQuery__
 *
 * To run a query within a React component, call `useManagedFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManagedFileQuery(baseOptions: Apollo.QueryHookOptions<ManagedFileQuery, ManagedFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagedFileQuery, ManagedFileQueryVariables>(ManagedFileDocument, options);
      }
export function useManagedFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagedFileQuery, ManagedFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagedFileQuery, ManagedFileQueryVariables>(ManagedFileDocument, options);
        }
export type ManagedFileQueryHookResult = ReturnType<typeof useManagedFileQuery>;
export type ManagedFileLazyQueryHookResult = ReturnType<typeof useManagedFileLazyQuery>;
export type ManagedFileQueryResult = Apollo.QueryResult<ManagedFileQuery, ManagedFileQueryVariables>;
export function refetchManagedFileQuery(variables: ManagedFileQueryVariables) {
      return { query: ManagedFileDocument, variables: variables }
    }
export const ManagedFileNameDocument = gql`
    query ManagedFileName($id: ID!) {
  getManagedFile(id: $id) {
    name
  }
}
    `;

/**
 * __useManagedFileNameQuery__
 *
 * To run a query within a React component, call `useManagedFileNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedFileNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedFileNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManagedFileNameQuery(baseOptions: Apollo.QueryHookOptions<ManagedFileNameQuery, ManagedFileNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagedFileNameQuery, ManagedFileNameQueryVariables>(ManagedFileNameDocument, options);
      }
export function useManagedFileNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagedFileNameQuery, ManagedFileNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagedFileNameQuery, ManagedFileNameQueryVariables>(ManagedFileNameDocument, options);
        }
export type ManagedFileNameQueryHookResult = ReturnType<typeof useManagedFileNameQuery>;
export type ManagedFileNameLazyQueryHookResult = ReturnType<typeof useManagedFileNameLazyQuery>;
export type ManagedFileNameQueryResult = Apollo.QueryResult<ManagedFileNameQuery, ManagedFileNameQueryVariables>;
export function refetchManagedFileNameQuery(variables: ManagedFileNameQueryVariables) {
      return { query: ManagedFileNameDocument, variables: variables }
    }
export const GetFileListDocument = gql`
    query GetFileList($after: String, $before: String, $limit: Int = 10000, $sortField: String, $sortOrder: SortOrder = ASCENDING, $filterInput: [FilterInput!], $centerId: String) {
  getFiles(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    filterInput: $filterInput
    centerId: $centerId
  ) {
    edges {
      node {
        id
        name
        size
        contentType
        path
        timestamp
        module
        key
        additionalData
        createdBy
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGetFileListQuery__
 *
 * To run a query within a React component, call `useGetFileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filterInput: // value for 'filterInput'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useGetFileListQuery(baseOptions?: Apollo.QueryHookOptions<GetFileListQuery, GetFileListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileListQuery, GetFileListQueryVariables>(GetFileListDocument, options);
      }
export function useGetFileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileListQuery, GetFileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileListQuery, GetFileListQueryVariables>(GetFileListDocument, options);
        }
export type GetFileListQueryHookResult = ReturnType<typeof useGetFileListQuery>;
export type GetFileListLazyQueryHookResult = ReturnType<typeof useGetFileListLazyQuery>;
export type GetFileListQueryResult = Apollo.QueryResult<GetFileListQuery, GetFileListQueryVariables>;
export function refetchGetFileListQuery(variables?: GetFileListQueryVariables) {
      return { query: GetFileListDocument, variables: variables }
    }
export const GetGlobalFileListDocument = gql`
    query GetGlobalFileList($after: String, $before: String, $limit: Int = 10000, $sortField: String, $sortOrder: SortOrder = ASCENDING, $filterInput: [FilterInput!]) {
  getGlobalFiles(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    filterInput: $filterInput
  ) {
    edges {
      node {
        id
        name
        size
        contentType
        path
        timestamp
        module
        key
        additionalData
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGetGlobalFileListQuery__
 *
 * To run a query within a React component, call `useGetGlobalFileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalFileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalFileListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetGlobalFileListQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalFileListQuery, GetGlobalFileListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalFileListQuery, GetGlobalFileListQueryVariables>(GetGlobalFileListDocument, options);
      }
export function useGetGlobalFileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalFileListQuery, GetGlobalFileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalFileListQuery, GetGlobalFileListQueryVariables>(GetGlobalFileListDocument, options);
        }
export type GetGlobalFileListQueryHookResult = ReturnType<typeof useGetGlobalFileListQuery>;
export type GetGlobalFileListLazyQueryHookResult = ReturnType<typeof useGetGlobalFileListLazyQuery>;
export type GetGlobalFileListQueryResult = Apollo.QueryResult<GetGlobalFileListQuery, GetGlobalFileListQueryVariables>;
export function refetchGetGlobalFileListQuery(variables?: GetGlobalFileListQueryVariables) {
      return { query: GetGlobalFileListDocument, variables: variables }
    }
export const FileManagerActivityLogAddedDocument = gql`
    subscription FileManagerActivityLogAdded($module: KineticModule = SYSTEM, $types: [String!] = ["FILE_MANAGER_UPLOAD", "FILE_MANAGER_FILES_DELETED"]) {
  addedActivityLog(module: $module, types: $types) {
    ...ActivityLogNodeFragment
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}`;

/**
 * __useFileManagerActivityLogAddedSubscription__
 *
 * To run a query within a React component, call `useFileManagerActivityLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFileManagerActivityLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileManagerActivityLogAddedSubscription({
 *   variables: {
 *      module: // value for 'module'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useFileManagerActivityLogAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<FileManagerActivityLogAddedSubscription, FileManagerActivityLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<FileManagerActivityLogAddedSubscription, FileManagerActivityLogAddedSubscriptionVariables>(FileManagerActivityLogAddedDocument, options);
      }
export type FileManagerActivityLogAddedSubscriptionHookResult = ReturnType<typeof useFileManagerActivityLogAddedSubscription>;
export type FileManagerActivityLogAddedSubscriptionResult = Apollo.SubscriptionResult<FileManagerActivityLogAddedSubscription>;
export const FleetDispatchDocument = gql`
    mutation FleetDispatch($id: ID!, $event: ID!) {
  fleetDispatch(id: $id, event: $event) {
    status
    id
  }
}
    `;
export type FleetDispatchMutationFn = Apollo.MutationFunction<FleetDispatchMutation, FleetDispatchMutationVariables>;

/**
 * __useFleetDispatchMutation__
 *
 * To run a mutation, you first call `useFleetDispatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFleetDispatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fleetDispatchMutation, { data, loading, error }] = useFleetDispatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useFleetDispatchMutation(baseOptions?: Apollo.MutationHookOptions<FleetDispatchMutation, FleetDispatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FleetDispatchMutation, FleetDispatchMutationVariables>(FleetDispatchDocument, options);
      }
export type FleetDispatchMutationHookResult = ReturnType<typeof useFleetDispatchMutation>;
export type FleetDispatchMutationResult = Apollo.MutationResult<FleetDispatchMutation>;
export type FleetDispatchMutationOptions = Apollo.BaseMutationOptions<FleetDispatchMutation, FleetDispatchMutationVariables>;
export const FleetDispatchListDocument = gql`
    query FleetDispatchList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  fleetDispatches(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        dispatchingUsername
        timeRequested
        timeResponded
        timeOnScene
        timeDeparted
        firstName
        lastName
        username
        status
        phone
        email
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useFleetDispatchListQuery__
 *
 * To run a query within a React component, call `useFleetDispatchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetDispatchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetDispatchListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFleetDispatchListQuery(baseOptions?: Apollo.QueryHookOptions<FleetDispatchListQuery, FleetDispatchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetDispatchListQuery, FleetDispatchListQueryVariables>(FleetDispatchListDocument, options);
      }
export function useFleetDispatchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetDispatchListQuery, FleetDispatchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetDispatchListQuery, FleetDispatchListQueryVariables>(FleetDispatchListDocument, options);
        }
export type FleetDispatchListQueryHookResult = ReturnType<typeof useFleetDispatchListQuery>;
export type FleetDispatchListLazyQueryHookResult = ReturnType<typeof useFleetDispatchListLazyQuery>;
export type FleetDispatchListQueryResult = Apollo.QueryResult<FleetDispatchListQuery, FleetDispatchListQueryVariables>;
export function refetchFleetDispatchListQuery(variables?: FleetDispatchListQueryVariables) {
      return { query: FleetDispatchListDocument, variables: variables }
    }
export const LiveFleetDispatchListDocument = gql`
    subscription LiveFleetDispatchList($ids: [ID!]!) {
  fleetDispatchUpdated(ids: $ids) {
    dispatchingUsername
    timeRequested
    timeResponded
    timeOnScene
    timeDeparted
    firstName
    lastName
    username
    status
    phone
    email
    id
  }
}
    `;

/**
 * __useLiveFleetDispatchListSubscription__
 *
 * To run a query within a React component, call `useLiveFleetDispatchListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveFleetDispatchListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveFleetDispatchListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveFleetDispatchListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveFleetDispatchListSubscription, LiveFleetDispatchListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveFleetDispatchListSubscription, LiveFleetDispatchListSubscriptionVariables>(LiveFleetDispatchListDocument, options);
      }
export type LiveFleetDispatchListSubscriptionHookResult = ReturnType<typeof useLiveFleetDispatchListSubscription>;
export type LiveFleetDispatchListSubscriptionResult = Apollo.SubscriptionResult<LiveFleetDispatchListSubscription>;
export const SaveFleetDriverDocument = gql`
    mutation SaveFleetDriver($driver: FleetDriverInput!) {
  fleetSaveDriver(driver: $driver) {
    id
  }
}
    `;
export type SaveFleetDriverMutationFn = Apollo.MutationFunction<SaveFleetDriverMutation, SaveFleetDriverMutationVariables>;

/**
 * __useSaveFleetDriverMutation__
 *
 * To run a mutation, you first call `useSaveFleetDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFleetDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFleetDriverMutation, { data, loading, error }] = useSaveFleetDriverMutation({
 *   variables: {
 *      driver: // value for 'driver'
 *   },
 * });
 */
export function useSaveFleetDriverMutation(baseOptions?: Apollo.MutationHookOptions<SaveFleetDriverMutation, SaveFleetDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFleetDriverMutation, SaveFleetDriverMutationVariables>(SaveFleetDriverDocument, options);
      }
export type SaveFleetDriverMutationHookResult = ReturnType<typeof useSaveFleetDriverMutation>;
export type SaveFleetDriverMutationResult = Apollo.MutationResult<SaveFleetDriverMutation>;
export type SaveFleetDriverMutationOptions = Apollo.BaseMutationOptions<SaveFleetDriverMutation, SaveFleetDriverMutationVariables>;
export const DeleteFleetDriverDocument = gql`
    mutation DeleteFleetDriver($id: ID!) {
  fleetDeleteDriver(id: $id)
}
    `;
export type DeleteFleetDriverMutationFn = Apollo.MutationFunction<DeleteFleetDriverMutation, DeleteFleetDriverMutationVariables>;

/**
 * __useDeleteFleetDriverMutation__
 *
 * To run a mutation, you first call `useDeleteFleetDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFleetDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFleetDriverMutation, { data, loading, error }] = useDeleteFleetDriverMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFleetDriverMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFleetDriverMutation, DeleteFleetDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFleetDriverMutation, DeleteFleetDriverMutationVariables>(DeleteFleetDriverDocument, options);
      }
export type DeleteFleetDriverMutationHookResult = ReturnType<typeof useDeleteFleetDriverMutation>;
export type DeleteFleetDriverMutationResult = Apollo.MutationResult<DeleteFleetDriverMutation>;
export type DeleteFleetDriverMutationOptions = Apollo.BaseMutationOptions<DeleteFleetDriverMutation, DeleteFleetDriverMutationVariables>;
export const FleetDriverListDocument = gql`
    query FleetDriverList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  fleetDrivers(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        capabilities
        firstName
        callSign
        username
        lastName
        modules
        phone
        email
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useFleetDriverListQuery__
 *
 * To run a query within a React component, call `useFleetDriverListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetDriverListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetDriverListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFleetDriverListQuery(baseOptions?: Apollo.QueryHookOptions<FleetDriverListQuery, FleetDriverListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetDriverListQuery, FleetDriverListQueryVariables>(FleetDriverListDocument, options);
      }
export function useFleetDriverListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetDriverListQuery, FleetDriverListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetDriverListQuery, FleetDriverListQueryVariables>(FleetDriverListDocument, options);
        }
export type FleetDriverListQueryHookResult = ReturnType<typeof useFleetDriverListQuery>;
export type FleetDriverListLazyQueryHookResult = ReturnType<typeof useFleetDriverListLazyQuery>;
export type FleetDriverListQueryResult = Apollo.QueryResult<FleetDriverListQuery, FleetDriverListQueryVariables>;
export function refetchFleetDriverListQuery(variables?: FleetDriverListQueryVariables) {
      return { query: FleetDriverListDocument, variables: variables }
    }
export const LiveFleetDriverListDocument = gql`
    subscription LiveFleetDriverList($ids: [ID!]!) {
  fleetDriverUpdated(ids: $ids) {
    capabilities
    firstName
    callSign
    username
    lastName
    modules
    phone
    email
    id
  }
}
    `;

/**
 * __useLiveFleetDriverListSubscription__
 *
 * To run a query within a React component, call `useLiveFleetDriverListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveFleetDriverListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveFleetDriverListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveFleetDriverListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveFleetDriverListSubscription, LiveFleetDriverListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveFleetDriverListSubscription, LiveFleetDriverListSubscriptionVariables>(LiveFleetDriverListDocument, options);
      }
export type LiveFleetDriverListSubscriptionHookResult = ReturnType<typeof useLiveFleetDriverListSubscription>;
export type LiveFleetDriverListSubscriptionResult = Apollo.SubscriptionResult<LiveFleetDriverListSubscription>;
export const FleetDriverEditDocument = gql`
    query FleetDriverEdit($id: ID!) {
  fleetDriver(id: $id) {
    capabilities
    firstName
    callSign
    username
    lastName
    modules
    phone
    email
    id
  }
}
    `;

/**
 * __useFleetDriverEditQuery__
 *
 * To run a query within a React component, call `useFleetDriverEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetDriverEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetDriverEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFleetDriverEditQuery(baseOptions: Apollo.QueryHookOptions<FleetDriverEditQuery, FleetDriverEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetDriverEditQuery, FleetDriverEditQueryVariables>(FleetDriverEditDocument, options);
      }
export function useFleetDriverEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetDriverEditQuery, FleetDriverEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetDriverEditQuery, FleetDriverEditQueryVariables>(FleetDriverEditDocument, options);
        }
export type FleetDriverEditQueryHookResult = ReturnType<typeof useFleetDriverEditQuery>;
export type FleetDriverEditLazyQueryHookResult = ReturnType<typeof useFleetDriverEditLazyQuery>;
export type FleetDriverEditQueryResult = Apollo.QueryResult<FleetDriverEditQuery, FleetDriverEditQueryVariables>;
export function refetchFleetDriverEditQuery(variables: FleetDriverEditQueryVariables) {
      return { query: FleetDriverEditDocument, variables: variables }
    }
export const FleetDriverAvatarDocument = gql`
    query FleetDriverAvatar($id: ID!) {
  fleetDriver(id: $id) {
    firstName
    lastName
    status
    id
  }
}
    `;

/**
 * __useFleetDriverAvatarQuery__
 *
 * To run a query within a React component, call `useFleetDriverAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetDriverAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetDriverAvatarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFleetDriverAvatarQuery(baseOptions: Apollo.QueryHookOptions<FleetDriverAvatarQuery, FleetDriverAvatarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetDriverAvatarQuery, FleetDriverAvatarQueryVariables>(FleetDriverAvatarDocument, options);
      }
export function useFleetDriverAvatarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetDriverAvatarQuery, FleetDriverAvatarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetDriverAvatarQuery, FleetDriverAvatarQueryVariables>(FleetDriverAvatarDocument, options);
        }
export type FleetDriverAvatarQueryHookResult = ReturnType<typeof useFleetDriverAvatarQuery>;
export type FleetDriverAvatarLazyQueryHookResult = ReturnType<typeof useFleetDriverAvatarLazyQuery>;
export type FleetDriverAvatarQueryResult = Apollo.QueryResult<FleetDriverAvatarQuery, FleetDriverAvatarQueryVariables>;
export function refetchFleetDriverAvatarQuery(variables: FleetDriverAvatarQueryVariables) {
      return { query: FleetDriverAvatarDocument, variables: variables }
    }
export const LiveFleetDriverAvatarDocument = gql`
    subscription LiveFleetDriverAvatar($id: ID!) {
  fleetDriverUpdated(ids: [$id]) {
    firstName
    lastName
    status
    id
  }
}
    `;

/**
 * __useLiveFleetDriverAvatarSubscription__
 *
 * To run a query within a React component, call `useLiveFleetDriverAvatarSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveFleetDriverAvatarSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveFleetDriverAvatarSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveFleetDriverAvatarSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveFleetDriverAvatarSubscription, LiveFleetDriverAvatarSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveFleetDriverAvatarSubscription, LiveFleetDriverAvatarSubscriptionVariables>(LiveFleetDriverAvatarDocument, options);
      }
export type LiveFleetDriverAvatarSubscriptionHookResult = ReturnType<typeof useLiveFleetDriverAvatarSubscription>;
export type LiveFleetDriverAvatarSubscriptionResult = Apollo.SubscriptionResult<LiveFleetDriverAvatarSubscription>;
export const FleetDriverUserSelectionListDocument = gql`
    query FleetDriverUserSelectionList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  users(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    before: $before
    after: $after
    limit: $limit
  ) {
    edges {
      node {
        firstName
        lastName
        username
        email
        id
      }
    }
  }
}
    `;

/**
 * __useFleetDriverUserSelectionListQuery__
 *
 * To run a query within a React component, call `useFleetDriverUserSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetDriverUserSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetDriverUserSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFleetDriverUserSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<FleetDriverUserSelectionListQuery, FleetDriverUserSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetDriverUserSelectionListQuery, FleetDriverUserSelectionListQueryVariables>(FleetDriverUserSelectionListDocument, options);
      }
export function useFleetDriverUserSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetDriverUserSelectionListQuery, FleetDriverUserSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetDriverUserSelectionListQuery, FleetDriverUserSelectionListQueryVariables>(FleetDriverUserSelectionListDocument, options);
        }
export type FleetDriverUserSelectionListQueryHookResult = ReturnType<typeof useFleetDriverUserSelectionListQuery>;
export type FleetDriverUserSelectionListLazyQueryHookResult = ReturnType<typeof useFleetDriverUserSelectionListLazyQuery>;
export type FleetDriverUserSelectionListQueryResult = Apollo.QueryResult<FleetDriverUserSelectionListQuery, FleetDriverUserSelectionListQueryVariables>;
export function refetchFleetDriverUserSelectionListQuery(variables?: FleetDriverUserSelectionListQueryVariables) {
      return { query: FleetDriverUserSelectionListDocument, variables: variables }
    }
export const FleetDriverIdListDocument = gql`
    query FleetDriverIdList {
  fleetDrivers {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useFleetDriverIdListQuery__
 *
 * To run a query within a React component, call `useFleetDriverIdListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetDriverIdListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetDriverIdListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFleetDriverIdListQuery(baseOptions?: Apollo.QueryHookOptions<FleetDriverIdListQuery, FleetDriverIdListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetDriverIdListQuery, FleetDriverIdListQueryVariables>(FleetDriverIdListDocument, options);
      }
export function useFleetDriverIdListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetDriverIdListQuery, FleetDriverIdListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetDriverIdListQuery, FleetDriverIdListQueryVariables>(FleetDriverIdListDocument, options);
        }
export type FleetDriverIdListQueryHookResult = ReturnType<typeof useFleetDriverIdListQuery>;
export type FleetDriverIdListLazyQueryHookResult = ReturnType<typeof useFleetDriverIdListLazyQuery>;
export type FleetDriverIdListQueryResult = Apollo.QueryResult<FleetDriverIdListQuery, FleetDriverIdListQueryVariables>;
export function refetchFleetDriverIdListQuery(variables?: FleetDriverIdListQueryVariables) {
      return { query: FleetDriverIdListDocument, variables: variables }
    }
export const FleetDriverSelectionListDocument = gql`
    query FleetDriverSelectionList($module: Object!) {
  fleetDrivers(
    query: {filters: [{value: $module, field: "modules", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        firstName
        lastName
        username
        id
      }
    }
  }
}
    `;

/**
 * __useFleetDriverSelectionListQuery__
 *
 * To run a query within a React component, call `useFleetDriverSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetDriverSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetDriverSelectionListQuery({
 *   variables: {
 *      module: // value for 'module'
 *   },
 * });
 */
export function useFleetDriverSelectionListQuery(baseOptions: Apollo.QueryHookOptions<FleetDriverSelectionListQuery, FleetDriverSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetDriverSelectionListQuery, FleetDriverSelectionListQueryVariables>(FleetDriverSelectionListDocument, options);
      }
export function useFleetDriverSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetDriverSelectionListQuery, FleetDriverSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetDriverSelectionListQuery, FleetDriverSelectionListQueryVariables>(FleetDriverSelectionListDocument, options);
        }
export type FleetDriverSelectionListQueryHookResult = ReturnType<typeof useFleetDriverSelectionListQuery>;
export type FleetDriverSelectionListLazyQueryHookResult = ReturnType<typeof useFleetDriverSelectionListLazyQuery>;
export type FleetDriverSelectionListQueryResult = Apollo.QueryResult<FleetDriverSelectionListQuery, FleetDriverSelectionListQueryVariables>;
export function refetchFleetDriverSelectionListQuery(variables: FleetDriverSelectionListQueryVariables) {
      return { query: FleetDriverSelectionListDocument, variables: variables }
    }
export const ActiveFleetDriverListDocument = gql`
    query ActiveFleetDriverList($module: Object!) {
  fleetShifts(
    query: {filters: [{value: $module, field: "module", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        driver
      }
    }
  }
}
    `;

/**
 * __useActiveFleetDriverListQuery__
 *
 * To run a query within a React component, call `useActiveFleetDriverListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveFleetDriverListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveFleetDriverListQuery({
 *   variables: {
 *      module: // value for 'module'
 *   },
 * });
 */
export function useActiveFleetDriverListQuery(baseOptions: Apollo.QueryHookOptions<ActiveFleetDriverListQuery, ActiveFleetDriverListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveFleetDriverListQuery, ActiveFleetDriverListQueryVariables>(ActiveFleetDriverListDocument, options);
      }
export function useActiveFleetDriverListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveFleetDriverListQuery, ActiveFleetDriverListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveFleetDriverListQuery, ActiveFleetDriverListQueryVariables>(ActiveFleetDriverListDocument, options);
        }
export type ActiveFleetDriverListQueryHookResult = ReturnType<typeof useActiveFleetDriverListQuery>;
export type ActiveFleetDriverListLazyQueryHookResult = ReturnType<typeof useActiveFleetDriverListLazyQuery>;
export type ActiveFleetDriverListQueryResult = Apollo.QueryResult<ActiveFleetDriverListQuery, ActiveFleetDriverListQueryVariables>;
export function refetchActiveFleetDriverListQuery(variables: ActiveFleetDriverListQueryVariables) {
      return { query: ActiveFleetDriverListDocument, variables: variables }
    }
export const SaveFleetRouteDocument = gql`
    mutation SaveFleetRoute($route: FleetRouteInput!) {
  fleetSaveRoute(route: $route) {
    id
  }
}
    `;
export type SaveFleetRouteMutationFn = Apollo.MutationFunction<SaveFleetRouteMutation, SaveFleetRouteMutationVariables>;

/**
 * __useSaveFleetRouteMutation__
 *
 * To run a mutation, you first call `useSaveFleetRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFleetRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFleetRouteMutation, { data, loading, error }] = useSaveFleetRouteMutation({
 *   variables: {
 *      route: // value for 'route'
 *   },
 * });
 */
export function useSaveFleetRouteMutation(baseOptions?: Apollo.MutationHookOptions<SaveFleetRouteMutation, SaveFleetRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFleetRouteMutation, SaveFleetRouteMutationVariables>(SaveFleetRouteDocument, options);
      }
export type SaveFleetRouteMutationHookResult = ReturnType<typeof useSaveFleetRouteMutation>;
export type SaveFleetRouteMutationResult = Apollo.MutationResult<SaveFleetRouteMutation>;
export type SaveFleetRouteMutationOptions = Apollo.BaseMutationOptions<SaveFleetRouteMutation, SaveFleetRouteMutationVariables>;
export const DeleteFleetRouteDocument = gql`
    mutation DeleteFleetRoute($id: ID!) {
  fleetDeleteRoute(id: $id)
}
    `;
export type DeleteFleetRouteMutationFn = Apollo.MutationFunction<DeleteFleetRouteMutation, DeleteFleetRouteMutationVariables>;

/**
 * __useDeleteFleetRouteMutation__
 *
 * To run a mutation, you first call `useDeleteFleetRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFleetRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFleetRouteMutation, { data, loading, error }] = useDeleteFleetRouteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFleetRouteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFleetRouteMutation, DeleteFleetRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFleetRouteMutation, DeleteFleetRouteMutationVariables>(DeleteFleetRouteDocument, options);
      }
export type DeleteFleetRouteMutationHookResult = ReturnType<typeof useDeleteFleetRouteMutation>;
export type DeleteFleetRouteMutationResult = Apollo.MutationResult<DeleteFleetRouteMutation>;
export type DeleteFleetRouteMutationOptions = Apollo.BaseMutationOptions<DeleteFleetRouteMutation, DeleteFleetRouteMutationVariables>;
export const FleetRouteListDocument = gql`
    query FleetRouteList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  fleetRoutes(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit, searchFields: ["name", "description", "route"]}
  ) {
    edges {
      node {
        startReference
        endReference
        description
        route
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useFleetRouteListQuery__
 *
 * To run a query within a React component, call `useFleetRouteListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetRouteListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetRouteListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFleetRouteListQuery(baseOptions?: Apollo.QueryHookOptions<FleetRouteListQuery, FleetRouteListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetRouteListQuery, FleetRouteListQueryVariables>(FleetRouteListDocument, options);
      }
export function useFleetRouteListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetRouteListQuery, FleetRouteListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetRouteListQuery, FleetRouteListQueryVariables>(FleetRouteListDocument, options);
        }
export type FleetRouteListQueryHookResult = ReturnType<typeof useFleetRouteListQuery>;
export type FleetRouteListLazyQueryHookResult = ReturnType<typeof useFleetRouteListLazyQuery>;
export type FleetRouteListQueryResult = Apollo.QueryResult<FleetRouteListQuery, FleetRouteListQueryVariables>;
export function refetchFleetRouteListQuery(variables?: FleetRouteListQueryVariables) {
      return { query: FleetRouteListDocument, variables: variables }
    }
export const LiveFleetRouteListDocument = gql`
    subscription LiveFleetRouteList($ids: [ID!]!) {
  fleetRouteUpdated(ids: $ids) {
    startReference
    endReference
    description
    route
    name
    id
  }
}
    `;

/**
 * __useLiveFleetRouteListSubscription__
 *
 * To run a query within a React component, call `useLiveFleetRouteListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveFleetRouteListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveFleetRouteListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveFleetRouteListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveFleetRouteListSubscription, LiveFleetRouteListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveFleetRouteListSubscription, LiveFleetRouteListSubscriptionVariables>(LiveFleetRouteListDocument, options);
      }
export type LiveFleetRouteListSubscriptionHookResult = ReturnType<typeof useLiveFleetRouteListSubscription>;
export type LiveFleetRouteListSubscriptionResult = Apollo.SubscriptionResult<LiveFleetRouteListSubscription>;
export const FleetRouteDocument = gql`
    query FleetRoute($id: ID!) {
  fleetRoute(id: $id) {
    startReference
    endReference
    description
    geometry
    route
    name
    id
  }
}
    `;

/**
 * __useFleetRouteQuery__
 *
 * To run a query within a React component, call `useFleetRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetRouteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFleetRouteQuery(baseOptions: Apollo.QueryHookOptions<FleetRouteQuery, FleetRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetRouteQuery, FleetRouteQueryVariables>(FleetRouteDocument, options);
      }
export function useFleetRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetRouteQuery, FleetRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetRouteQuery, FleetRouteQueryVariables>(FleetRouteDocument, options);
        }
export type FleetRouteQueryHookResult = ReturnType<typeof useFleetRouteQuery>;
export type FleetRouteLazyQueryHookResult = ReturnType<typeof useFleetRouteLazyQuery>;
export type FleetRouteQueryResult = Apollo.QueryResult<FleetRouteQuery, FleetRouteQueryVariables>;
export function refetchFleetRouteQuery(variables: FleetRouteQueryVariables) {
      return { query: FleetRouteDocument, variables: variables }
    }
export const FleetRouteSelectionListDocument = gql`
    query FleetRouteSelectionList($module: Object!) {
  fleetRoutes(
    query: {filters: [{value: $module, field: "module", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useFleetRouteSelectionListQuery__
 *
 * To run a query within a React component, call `useFleetRouteSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetRouteSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetRouteSelectionListQuery({
 *   variables: {
 *      module: // value for 'module'
 *   },
 * });
 */
export function useFleetRouteSelectionListQuery(baseOptions: Apollo.QueryHookOptions<FleetRouteSelectionListQuery, FleetRouteSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetRouteSelectionListQuery, FleetRouteSelectionListQueryVariables>(FleetRouteSelectionListDocument, options);
      }
export function useFleetRouteSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetRouteSelectionListQuery, FleetRouteSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetRouteSelectionListQuery, FleetRouteSelectionListQueryVariables>(FleetRouteSelectionListDocument, options);
        }
export type FleetRouteSelectionListQueryHookResult = ReturnType<typeof useFleetRouteSelectionListQuery>;
export type FleetRouteSelectionListLazyQueryHookResult = ReturnType<typeof useFleetRouteSelectionListLazyQuery>;
export type FleetRouteSelectionListQueryResult = Apollo.QueryResult<FleetRouteSelectionListQuery, FleetRouteSelectionListQueryVariables>;
export function refetchFleetRouteSelectionListQuery(variables: FleetRouteSelectionListQueryVariables) {
      return { query: FleetRouteSelectionListDocument, variables: variables }
    }
export const FleetRouteDriverListDocument = gql`
    query FleetRouteDriverList($id: Object!, $module: Object!) {
  fleetShifts(
    query: {filters: [{value: $module, field: "module", operator: EQUALS}, {value: $id, field: "route", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        driver
      }
    }
  }
}
    `;

/**
 * __useFleetRouteDriverListQuery__
 *
 * To run a query within a React component, call `useFleetRouteDriverListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetRouteDriverListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetRouteDriverListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useFleetRouteDriverListQuery(baseOptions: Apollo.QueryHookOptions<FleetRouteDriverListQuery, FleetRouteDriverListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetRouteDriverListQuery, FleetRouteDriverListQueryVariables>(FleetRouteDriverListDocument, options);
      }
export function useFleetRouteDriverListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetRouteDriverListQuery, FleetRouteDriverListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetRouteDriverListQuery, FleetRouteDriverListQueryVariables>(FleetRouteDriverListDocument, options);
        }
export type FleetRouteDriverListQueryHookResult = ReturnType<typeof useFleetRouteDriverListQuery>;
export type FleetRouteDriverListLazyQueryHookResult = ReturnType<typeof useFleetRouteDriverListLazyQuery>;
export type FleetRouteDriverListQueryResult = Apollo.QueryResult<FleetRouteDriverListQuery, FleetRouteDriverListQueryVariables>;
export function refetchFleetRouteDriverListQuery(variables: FleetRouteDriverListQueryVariables) {
      return { query: FleetRouteDriverListDocument, variables: variables }
    }
export const FleetCheckInDocument = gql`
    mutation FleetCheckIn($shift: FleetShiftInput!) {
  fleetCheckIn(shift: $shift) {
    id
  }
}
    `;
export type FleetCheckInMutationFn = Apollo.MutationFunction<FleetCheckInMutation, FleetCheckInMutationVariables>;

/**
 * __useFleetCheckInMutation__
 *
 * To run a mutation, you first call `useFleetCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFleetCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fleetCheckInMutation, { data, loading, error }] = useFleetCheckInMutation({
 *   variables: {
 *      shift: // value for 'shift'
 *   },
 * });
 */
export function useFleetCheckInMutation(baseOptions?: Apollo.MutationHookOptions<FleetCheckInMutation, FleetCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FleetCheckInMutation, FleetCheckInMutationVariables>(FleetCheckInDocument, options);
      }
export type FleetCheckInMutationHookResult = ReturnType<typeof useFleetCheckInMutation>;
export type FleetCheckInMutationResult = Apollo.MutationResult<FleetCheckInMutation>;
export type FleetCheckInMutationOptions = Apollo.BaseMutationOptions<FleetCheckInMutation, FleetCheckInMutationVariables>;
export const FleetCheckOutDocument = gql`
    mutation FleetCheckOut($id: ID!) {
  fleetCheckOut(id: $id)
}
    `;
export type FleetCheckOutMutationFn = Apollo.MutationFunction<FleetCheckOutMutation, FleetCheckOutMutationVariables>;

/**
 * __useFleetCheckOutMutation__
 *
 * To run a mutation, you first call `useFleetCheckOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFleetCheckOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fleetCheckOutMutation, { data, loading, error }] = useFleetCheckOutMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFleetCheckOutMutation(baseOptions?: Apollo.MutationHookOptions<FleetCheckOutMutation, FleetCheckOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FleetCheckOutMutation, FleetCheckOutMutationVariables>(FleetCheckOutDocument, options);
      }
export type FleetCheckOutMutationHookResult = ReturnType<typeof useFleetCheckOutMutation>;
export type FleetCheckOutMutationResult = Apollo.MutationResult<FleetCheckOutMutation>;
export type FleetCheckOutMutationOptions = Apollo.BaseMutationOptions<FleetCheckOutMutation, FleetCheckOutMutationVariables>;
export const FleetUpdateStatusDocument = gql`
    mutation FleetUpdateStatus($id: ID!, $status: FleetShiftStatus!) {
  fleetUpdateStatus(id: $id, status: $status)
}
    `;
export type FleetUpdateStatusMutationFn = Apollo.MutationFunction<FleetUpdateStatusMutation, FleetUpdateStatusMutationVariables>;

/**
 * __useFleetUpdateStatusMutation__
 *
 * To run a mutation, you first call `useFleetUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFleetUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fleetUpdateStatusMutation, { data, loading, error }] = useFleetUpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useFleetUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<FleetUpdateStatusMutation, FleetUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FleetUpdateStatusMutation, FleetUpdateStatusMutationVariables>(FleetUpdateStatusDocument, options);
      }
export type FleetUpdateStatusMutationHookResult = ReturnType<typeof useFleetUpdateStatusMutation>;
export type FleetUpdateStatusMutationResult = Apollo.MutationResult<FleetUpdateStatusMutation>;
export type FleetUpdateStatusMutationOptions = Apollo.BaseMutationOptions<FleetUpdateStatusMutation, FleetUpdateStatusMutationVariables>;
export const FleetShiftLogActivityDocument = gql`
    mutation FleetShiftLogActivity($id: ID!, $description: String!) {
  fleetLogActivity(id: $id, description: $description)
}
    `;
export type FleetShiftLogActivityMutationFn = Apollo.MutationFunction<FleetShiftLogActivityMutation, FleetShiftLogActivityMutationVariables>;

/**
 * __useFleetShiftLogActivityMutation__
 *
 * To run a mutation, you first call `useFleetShiftLogActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFleetShiftLogActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fleetShiftLogActivityMutation, { data, loading, error }] = useFleetShiftLogActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useFleetShiftLogActivityMutation(baseOptions?: Apollo.MutationHookOptions<FleetShiftLogActivityMutation, FleetShiftLogActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FleetShiftLogActivityMutation, FleetShiftLogActivityMutationVariables>(FleetShiftLogActivityDocument, options);
      }
export type FleetShiftLogActivityMutationHookResult = ReturnType<typeof useFleetShiftLogActivityMutation>;
export type FleetShiftLogActivityMutationResult = Apollo.MutationResult<FleetShiftLogActivityMutation>;
export type FleetShiftLogActivityMutationOptions = Apollo.BaseMutationOptions<FleetShiftLogActivityMutation, FleetShiftLogActivityMutationVariables>;
export const FleetShiftListDocument = gql`
    query FleetShiftList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  fleetShifts(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        patrolNumber
        radioNumber
        vehicleName
        routeName
        firstName
        lastName
        callSign
        status
        driver
        phone
        type
        avl
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useFleetShiftListQuery__
 *
 * To run a query within a React component, call `useFleetShiftListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetShiftListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetShiftListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFleetShiftListQuery(baseOptions?: Apollo.QueryHookOptions<FleetShiftListQuery, FleetShiftListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetShiftListQuery, FleetShiftListQueryVariables>(FleetShiftListDocument, options);
      }
export function useFleetShiftListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetShiftListQuery, FleetShiftListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetShiftListQuery, FleetShiftListQueryVariables>(FleetShiftListDocument, options);
        }
export type FleetShiftListQueryHookResult = ReturnType<typeof useFleetShiftListQuery>;
export type FleetShiftListLazyQueryHookResult = ReturnType<typeof useFleetShiftListLazyQuery>;
export type FleetShiftListQueryResult = Apollo.QueryResult<FleetShiftListQuery, FleetShiftListQueryVariables>;
export function refetchFleetShiftListQuery(variables?: FleetShiftListQueryVariables) {
      return { query: FleetShiftListDocument, variables: variables }
    }
export const LiveFleetShiftListDocument = gql`
    subscription LiveFleetShiftList($ids: [ID!]!) {
  fleetShiftUpdated(ids: $ids) {
    patrolNumber
    radioNumber
    vehicleName
    routeName
    firstName
    lastName
    callSign
    driver
    status
    phone
    type
    avl
    id
    speed
    address
    moveStatus {
      lastMoved
      isMoving
      state
    }
  }
}
    `;

/**
 * __useLiveFleetShiftListSubscription__
 *
 * To run a query within a React component, call `useLiveFleetShiftListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveFleetShiftListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveFleetShiftListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveFleetShiftListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveFleetShiftListSubscription, LiveFleetShiftListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveFleetShiftListSubscription, LiveFleetShiftListSubscriptionVariables>(LiveFleetShiftListDocument, options);
      }
export type LiveFleetShiftListSubscriptionHookResult = ReturnType<typeof useLiveFleetShiftListSubscription>;
export type LiveFleetShiftListSubscriptionResult = Apollo.SubscriptionResult<LiveFleetShiftListSubscription>;
export const ActiveFleetGpsListDocument = gql`
    query ActiveFleetGpsList($module: Object!) {
  fleetShifts(
    query: {filters: [{value: $module, field: "module", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        avl
      }
    }
  }
}
    `;

/**
 * __useActiveFleetGpsListQuery__
 *
 * To run a query within a React component, call `useActiveFleetGpsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveFleetGpsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveFleetGpsListQuery({
 *   variables: {
 *      module: // value for 'module'
 *   },
 * });
 */
export function useActiveFleetGpsListQuery(baseOptions: Apollo.QueryHookOptions<ActiveFleetGpsListQuery, ActiveFleetGpsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveFleetGpsListQuery, ActiveFleetGpsListQueryVariables>(ActiveFleetGpsListDocument, options);
      }
export function useActiveFleetGpsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveFleetGpsListQuery, ActiveFleetGpsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveFleetGpsListQuery, ActiveFleetGpsListQueryVariables>(ActiveFleetGpsListDocument, options);
        }
export type ActiveFleetGpsListQueryHookResult = ReturnType<typeof useActiveFleetGpsListQuery>;
export type ActiveFleetGpsListLazyQueryHookResult = ReturnType<typeof useActiveFleetGpsListLazyQuery>;
export type ActiveFleetGpsListQueryResult = Apollo.QueryResult<ActiveFleetGpsListQuery, ActiveFleetGpsListQueryVariables>;
export function refetchActiveFleetGpsListQuery(variables: ActiveFleetGpsListQueryVariables) {
      return { query: ActiveFleetGpsListDocument, variables: variables }
    }
export const ActiveFleetPatrolNumberListDocument = gql`
    query ActiveFleetPatrolNumberList($module: Object!) {
  fleetShifts(
    query: {filters: [{value: $module, field: "module", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        patrolNumber
      }
    }
  }
}
    `;

/**
 * __useActiveFleetPatrolNumberListQuery__
 *
 * To run a query within a React component, call `useActiveFleetPatrolNumberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveFleetPatrolNumberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveFleetPatrolNumberListQuery({
 *   variables: {
 *      module: // value for 'module'
 *   },
 * });
 */
export function useActiveFleetPatrolNumberListQuery(baseOptions: Apollo.QueryHookOptions<ActiveFleetPatrolNumberListQuery, ActiveFleetPatrolNumberListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveFleetPatrolNumberListQuery, ActiveFleetPatrolNumberListQueryVariables>(ActiveFleetPatrolNumberListDocument, options);
      }
export function useActiveFleetPatrolNumberListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveFleetPatrolNumberListQuery, ActiveFleetPatrolNumberListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveFleetPatrolNumberListQuery, ActiveFleetPatrolNumberListQueryVariables>(ActiveFleetPatrolNumberListDocument, options);
        }
export type ActiveFleetPatrolNumberListQueryHookResult = ReturnType<typeof useActiveFleetPatrolNumberListQuery>;
export type ActiveFleetPatrolNumberListLazyQueryHookResult = ReturnType<typeof useActiveFleetPatrolNumberListLazyQuery>;
export type ActiveFleetPatrolNumberListQueryResult = Apollo.QueryResult<ActiveFleetPatrolNumberListQuery, ActiveFleetPatrolNumberListQueryVariables>;
export function refetchActiveFleetPatrolNumberListQuery(variables: ActiveFleetPatrolNumberListQueryVariables) {
      return { query: ActiveFleetPatrolNumberListDocument, variables: variables }
    }
export const ActiveFleetRadioNumberListDocument = gql`
    query ActiveFleetRadioNumberList($module: Object!) {
  fleetShifts(
    query: {filters: [{value: $module, field: "module", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        radioNumber
      }
    }
  }
}
    `;

/**
 * __useActiveFleetRadioNumberListQuery__
 *
 * To run a query within a React component, call `useActiveFleetRadioNumberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveFleetRadioNumberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveFleetRadioNumberListQuery({
 *   variables: {
 *      module: // value for 'module'
 *   },
 * });
 */
export function useActiveFleetRadioNumberListQuery(baseOptions: Apollo.QueryHookOptions<ActiveFleetRadioNumberListQuery, ActiveFleetRadioNumberListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveFleetRadioNumberListQuery, ActiveFleetRadioNumberListQueryVariables>(ActiveFleetRadioNumberListDocument, options);
      }
export function useActiveFleetRadioNumberListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveFleetRadioNumberListQuery, ActiveFleetRadioNumberListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveFleetRadioNumberListQuery, ActiveFleetRadioNumberListQueryVariables>(ActiveFleetRadioNumberListDocument, options);
        }
export type ActiveFleetRadioNumberListQueryHookResult = ReturnType<typeof useActiveFleetRadioNumberListQuery>;
export type ActiveFleetRadioNumberListLazyQueryHookResult = ReturnType<typeof useActiveFleetRadioNumberListLazyQuery>;
export type ActiveFleetRadioNumberListQueryResult = Apollo.QueryResult<ActiveFleetRadioNumberListQuery, ActiveFleetRadioNumberListQueryVariables>;
export function refetchActiveFleetRadioNumberListQuery(variables: ActiveFleetRadioNumberListQueryVariables) {
      return { query: ActiveFleetRadioNumberListDocument, variables: variables }
    }
export const FleetShiftMapDocument = gql`
    query FleetShiftMap($module: Object!) {
  fleetShifts(
    query: {filters: [{value: $module, field: "module", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        location
        status
        type
        id
        speed
        address
        moveStatus {
          lastMoved
          isMoving
          state
        }
      }
    }
  }
}
    `;

/**
 * __useFleetShiftMapQuery__
 *
 * To run a query within a React component, call `useFleetShiftMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetShiftMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetShiftMapQuery({
 *   variables: {
 *      module: // value for 'module'
 *   },
 * });
 */
export function useFleetShiftMapQuery(baseOptions: Apollo.QueryHookOptions<FleetShiftMapQuery, FleetShiftMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetShiftMapQuery, FleetShiftMapQueryVariables>(FleetShiftMapDocument, options);
      }
export function useFleetShiftMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetShiftMapQuery, FleetShiftMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetShiftMapQuery, FleetShiftMapQueryVariables>(FleetShiftMapDocument, options);
        }
export type FleetShiftMapQueryHookResult = ReturnType<typeof useFleetShiftMapQuery>;
export type FleetShiftMapLazyQueryHookResult = ReturnType<typeof useFleetShiftMapLazyQuery>;
export type FleetShiftMapQueryResult = Apollo.QueryResult<FleetShiftMapQuery, FleetShiftMapQueryVariables>;
export function refetchFleetShiftMapQuery(variables: FleetShiftMapQueryVariables) {
      return { query: FleetShiftMapDocument, variables: variables }
    }
export const LiveFleetShiftMapDocument = gql`
    subscription LiveFleetShiftMap($ids: [ID!]) {
  fleetShiftUpdated(ids: $ids) {
    location
    status
    type
    id
  }
}
    `;

/**
 * __useLiveFleetShiftMapSubscription__
 *
 * To run a query within a React component, call `useLiveFleetShiftMapSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveFleetShiftMapSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveFleetShiftMapSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveFleetShiftMapSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveFleetShiftMapSubscription, LiveFleetShiftMapSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveFleetShiftMapSubscription, LiveFleetShiftMapSubscriptionVariables>(LiveFleetShiftMapDocument, options);
      }
export type LiveFleetShiftMapSubscriptionHookResult = ReturnType<typeof useLiveFleetShiftMapSubscription>;
export type LiveFleetShiftMapSubscriptionResult = Apollo.SubscriptionResult<LiveFleetShiftMapSubscription>;
export const FleetShiftDocument = gql`
    query FleetShift($id: ID!) {
  fleetShift(id: $id) {
    vehicleCapabilities
    driverCapabilities
    patrolNumber
    plateNumber
    vehicleName
    radioNumber
    routeName
    firstName
    lastName
    callSign
    location
    driver
    status
    phone
    type
    id
    avl
    serial
    location
    address
    speed
    moveStatus {
      lastMoved
      isMoving
      state
    }
  }
}
    `;

/**
 * __useFleetShiftQuery__
 *
 * To run a query within a React component, call `useFleetShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetShiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetShiftQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFleetShiftQuery(baseOptions: Apollo.QueryHookOptions<FleetShiftQuery, FleetShiftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetShiftQuery, FleetShiftQueryVariables>(FleetShiftDocument, options);
      }
export function useFleetShiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetShiftQuery, FleetShiftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetShiftQuery, FleetShiftQueryVariables>(FleetShiftDocument, options);
        }
export type FleetShiftQueryHookResult = ReturnType<typeof useFleetShiftQuery>;
export type FleetShiftLazyQueryHookResult = ReturnType<typeof useFleetShiftLazyQuery>;
export type FleetShiftQueryResult = Apollo.QueryResult<FleetShiftQuery, FleetShiftQueryVariables>;
export function refetchFleetShiftQuery(variables: FleetShiftQueryVariables) {
      return { query: FleetShiftDocument, variables: variables }
    }
export const FleetShiftStatusDocument = gql`
    query FleetShiftStatus($id: ID!) {
  fleetShift(id: $id) {
    status
    id
  }
}
    `;

/**
 * __useFleetShiftStatusQuery__
 *
 * To run a query within a React component, call `useFleetShiftStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetShiftStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetShiftStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFleetShiftStatusQuery(baseOptions: Apollo.QueryHookOptions<FleetShiftStatusQuery, FleetShiftStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetShiftStatusQuery, FleetShiftStatusQueryVariables>(FleetShiftStatusDocument, options);
      }
export function useFleetShiftStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetShiftStatusQuery, FleetShiftStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetShiftStatusQuery, FleetShiftStatusQueryVariables>(FleetShiftStatusDocument, options);
        }
export type FleetShiftStatusQueryHookResult = ReturnType<typeof useFleetShiftStatusQuery>;
export type FleetShiftStatusLazyQueryHookResult = ReturnType<typeof useFleetShiftStatusLazyQuery>;
export type FleetShiftStatusQueryResult = Apollo.QueryResult<FleetShiftStatusQuery, FleetShiftStatusQueryVariables>;
export function refetchFleetShiftStatusQuery(variables: FleetShiftStatusQueryVariables) {
      return { query: FleetShiftStatusDocument, variables: variables }
    }
export const LiveFleetShiftDocument = gql`
    subscription LiveFleetShift($id: ID!) {
  fleetShiftUpdated(ids: [$id]) {
    vehicleCapabilities
    driverCapabilities
    patrolNumber
    plateNumber
    vehicleName
    radioNumber
    routeName
    firstName
    lastName
    callSign
    location
    driver
    status
    phone
    type
    id
    speed
    address
    moveStatus {
      lastMoved
      isMoving
      state
    }
  }
}
    `;

/**
 * __useLiveFleetShiftSubscription__
 *
 * To run a query within a React component, call `useLiveFleetShiftSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveFleetShiftSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveFleetShiftSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveFleetShiftSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveFleetShiftSubscription, LiveFleetShiftSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveFleetShiftSubscription, LiveFleetShiftSubscriptionVariables>(LiveFleetShiftDocument, options);
      }
export type LiveFleetShiftSubscriptionHookResult = ReturnType<typeof useLiveFleetShiftSubscription>;
export type LiveFleetShiftSubscriptionResult = Apollo.SubscriptionResult<LiveFleetShiftSubscription>;
export const FleetShiftSearchDocument = gql`
    query FleetShiftSearch($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  fleetShifts(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        vehicleName
        location
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useFleetShiftSearchQuery__
 *
 * To run a query within a React component, call `useFleetShiftSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetShiftSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetShiftSearchQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFleetShiftSearchQuery(baseOptions?: Apollo.QueryHookOptions<FleetShiftSearchQuery, FleetShiftSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetShiftSearchQuery, FleetShiftSearchQueryVariables>(FleetShiftSearchDocument, options);
      }
export function useFleetShiftSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetShiftSearchQuery, FleetShiftSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetShiftSearchQuery, FleetShiftSearchQueryVariables>(FleetShiftSearchDocument, options);
        }
export type FleetShiftSearchQueryHookResult = ReturnType<typeof useFleetShiftSearchQuery>;
export type FleetShiftSearchLazyQueryHookResult = ReturnType<typeof useFleetShiftSearchLazyQuery>;
export type FleetShiftSearchQueryResult = Apollo.QueryResult<FleetShiftSearchQuery, FleetShiftSearchQueryVariables>;
export function refetchFleetShiftSearchQuery(variables?: FleetShiftSearchQueryVariables) {
      return { query: FleetShiftSearchDocument, variables: variables }
    }
export const FleetShiftSummaryDocument = gql`
    query FleetShiftSummary {
  AVAILABLE: fleetShifts(
    query: {filters: [{operator: EQUALS, field: "status", value: "AVAILABLE"}]}
  ) {
    totalCount
  }
  DISPATCH_REQUESTED: fleetShifts(
    query: {filters: [{operator: EQUALS, field: "status", value: "DISPATCH_REQUESTED"}]}
  ) {
    totalCount
  }
  ENROUTE: fleetShifts(
    query: {filters: [{operator: EQUALS, field: "status", value: "ENROUTE"}]}
  ) {
    totalCount
  }
  ONSCENE: fleetShifts(
    query: {filters: [{operator: EQUALS, field: "status", value: "ONSCENE"}]}
  ) {
    totalCount
  }
  ON_DUTY_UNAVAILABLE: fleetShifts(
    query: {filters: [{operator: EQUALS, field: "status", value: "ON_DUTY_UNAVAILABLE"}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useFleetShiftSummaryQuery__
 *
 * To run a query within a React component, call `useFleetShiftSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetShiftSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetShiftSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFleetShiftSummaryQuery(baseOptions?: Apollo.QueryHookOptions<FleetShiftSummaryQuery, FleetShiftSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetShiftSummaryQuery, FleetShiftSummaryQueryVariables>(FleetShiftSummaryDocument, options);
      }
export function useFleetShiftSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetShiftSummaryQuery, FleetShiftSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetShiftSummaryQuery, FleetShiftSummaryQueryVariables>(FleetShiftSummaryDocument, options);
        }
export type FleetShiftSummaryQueryHookResult = ReturnType<typeof useFleetShiftSummaryQuery>;
export type FleetShiftSummaryLazyQueryHookResult = ReturnType<typeof useFleetShiftSummaryLazyQuery>;
export type FleetShiftSummaryQueryResult = Apollo.QueryResult<FleetShiftSummaryQuery, FleetShiftSummaryQueryVariables>;
export function refetchFleetShiftSummaryQuery(variables?: FleetShiftSummaryQueryVariables) {
      return { query: FleetShiftSummaryDocument, variables: variables }
    }
export const FleetShiftCameraDetailsDocument = gql`
    query FleetShiftCameraDetails($id: ID!) {
  getFleetCameraDetails(id: $id) {
    protocol
    cameras {
      cameraId
      cameraName
      status
      description
    }
    attributes
    status
  }
}
    `;

/**
 * __useFleetShiftCameraDetailsQuery__
 *
 * To run a query within a React component, call `useFleetShiftCameraDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetShiftCameraDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetShiftCameraDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFleetShiftCameraDetailsQuery(baseOptions: Apollo.QueryHookOptions<FleetShiftCameraDetailsQuery, FleetShiftCameraDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetShiftCameraDetailsQuery, FleetShiftCameraDetailsQueryVariables>(FleetShiftCameraDetailsDocument, options);
      }
export function useFleetShiftCameraDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetShiftCameraDetailsQuery, FleetShiftCameraDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetShiftCameraDetailsQuery, FleetShiftCameraDetailsQueryVariables>(FleetShiftCameraDetailsDocument, options);
        }
export type FleetShiftCameraDetailsQueryHookResult = ReturnType<typeof useFleetShiftCameraDetailsQuery>;
export type FleetShiftCameraDetailsLazyQueryHookResult = ReturnType<typeof useFleetShiftCameraDetailsLazyQuery>;
export type FleetShiftCameraDetailsQueryResult = Apollo.QueryResult<FleetShiftCameraDetailsQuery, FleetShiftCameraDetailsQueryVariables>;
export function refetchFleetShiftCameraDetailsQuery(variables: FleetShiftCameraDetailsQueryVariables) {
      return { query: FleetShiftCameraDetailsDocument, variables: variables }
    }
export const SaveFleetVehicleDocument = gql`
    mutation SaveFleetVehicle($vehicle: FleetVehicleInput!) {
  fleetSaveVehicle(vehicle: $vehicle) {
    id
  }
}
    `;
export type SaveFleetVehicleMutationFn = Apollo.MutationFunction<SaveFleetVehicleMutation, SaveFleetVehicleMutationVariables>;

/**
 * __useSaveFleetVehicleMutation__
 *
 * To run a mutation, you first call `useSaveFleetVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFleetVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFleetVehicleMutation, { data, loading, error }] = useSaveFleetVehicleMutation({
 *   variables: {
 *      vehicle: // value for 'vehicle'
 *   },
 * });
 */
export function useSaveFleetVehicleMutation(baseOptions?: Apollo.MutationHookOptions<SaveFleetVehicleMutation, SaveFleetVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFleetVehicleMutation, SaveFleetVehicleMutationVariables>(SaveFleetVehicleDocument, options);
      }
export type SaveFleetVehicleMutationHookResult = ReturnType<typeof useSaveFleetVehicleMutation>;
export type SaveFleetVehicleMutationResult = Apollo.MutationResult<SaveFleetVehicleMutation>;
export type SaveFleetVehicleMutationOptions = Apollo.BaseMutationOptions<SaveFleetVehicleMutation, SaveFleetVehicleMutationVariables>;
export const DeleteFleetVehicleDocument = gql`
    mutation DeleteFleetVehicle($id: ID!) {
  fleetDeleteVehicle(id: $id)
}
    `;
export type DeleteFleetVehicleMutationFn = Apollo.MutationFunction<DeleteFleetVehicleMutation, DeleteFleetVehicleMutationVariables>;

/**
 * __useDeleteFleetVehicleMutation__
 *
 * To run a mutation, you first call `useDeleteFleetVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFleetVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFleetVehicleMutation, { data, loading, error }] = useDeleteFleetVehicleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFleetVehicleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFleetVehicleMutation, DeleteFleetVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFleetVehicleMutation, DeleteFleetVehicleMutationVariables>(DeleteFleetVehicleDocument, options);
      }
export type DeleteFleetVehicleMutationHookResult = ReturnType<typeof useDeleteFleetVehicleMutation>;
export type DeleteFleetVehicleMutationResult = Apollo.MutationResult<DeleteFleetVehicleMutation>;
export type DeleteFleetVehicleMutationOptions = Apollo.BaseMutationOptions<DeleteFleetVehicleMutation, DeleteFleetVehicleMutationVariables>;
export const FleetVehicleListDocument = gql`
    query FleetVehicleList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  fleetVehicles(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        capabilities
        description
        plateNumber
        odometer
        modules
        status
        model
        name
        year
        make
        type
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useFleetVehicleListQuery__
 *
 * To run a query within a React component, call `useFleetVehicleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetVehicleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetVehicleListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFleetVehicleListQuery(baseOptions?: Apollo.QueryHookOptions<FleetVehicleListQuery, FleetVehicleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetVehicleListQuery, FleetVehicleListQueryVariables>(FleetVehicleListDocument, options);
      }
export function useFleetVehicleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetVehicleListQuery, FleetVehicleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetVehicleListQuery, FleetVehicleListQueryVariables>(FleetVehicleListDocument, options);
        }
export type FleetVehicleListQueryHookResult = ReturnType<typeof useFleetVehicleListQuery>;
export type FleetVehicleListLazyQueryHookResult = ReturnType<typeof useFleetVehicleListLazyQuery>;
export type FleetVehicleListQueryResult = Apollo.QueryResult<FleetVehicleListQuery, FleetVehicleListQueryVariables>;
export function refetchFleetVehicleListQuery(variables?: FleetVehicleListQueryVariables) {
      return { query: FleetVehicleListDocument, variables: variables }
    }
export const LiveFleetVehicleListDocument = gql`
    subscription LiveFleetVehicleList($ids: [ID!]!) {
  fleetVehicleUpdated(ids: $ids) {
    capabilities
    description
    plateNumber
    odometer
    modules
    status
    model
    name
    year
    make
    type
    id
  }
}
    `;

/**
 * __useLiveFleetVehicleListSubscription__
 *
 * To run a query within a React component, call `useLiveFleetVehicleListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveFleetVehicleListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveFleetVehicleListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveFleetVehicleListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveFleetVehicleListSubscription, LiveFleetVehicleListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveFleetVehicleListSubscription, LiveFleetVehicleListSubscriptionVariables>(LiveFleetVehicleListDocument, options);
      }
export type LiveFleetVehicleListSubscriptionHookResult = ReturnType<typeof useLiveFleetVehicleListSubscription>;
export type LiveFleetVehicleListSubscriptionResult = Apollo.SubscriptionResult<LiveFleetVehicleListSubscription>;
export const FleetVehicleEditDocument = gql`
    query FleetVehicleEdit($id: ID!) {
  fleetVehicle(id: $id) {
    capabilities
    description
    plateNumber
    odometer
    modules
    status
    model
    name
    year
    make
    type
    id
  }
}
    `;

/**
 * __useFleetVehicleEditQuery__
 *
 * To run a query within a React component, call `useFleetVehicleEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetVehicleEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetVehicleEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFleetVehicleEditQuery(baseOptions: Apollo.QueryHookOptions<FleetVehicleEditQuery, FleetVehicleEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetVehicleEditQuery, FleetVehicleEditQueryVariables>(FleetVehicleEditDocument, options);
      }
export function useFleetVehicleEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetVehicleEditQuery, FleetVehicleEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetVehicleEditQuery, FleetVehicleEditQueryVariables>(FleetVehicleEditDocument, options);
        }
export type FleetVehicleEditQueryHookResult = ReturnType<typeof useFleetVehicleEditQuery>;
export type FleetVehicleEditLazyQueryHookResult = ReturnType<typeof useFleetVehicleEditLazyQuery>;
export type FleetVehicleEditQueryResult = Apollo.QueryResult<FleetVehicleEditQuery, FleetVehicleEditQueryVariables>;
export function refetchFleetVehicleEditQuery(variables: FleetVehicleEditQueryVariables) {
      return { query: FleetVehicleEditDocument, variables: variables }
    }
export const FleetVehicleSelectionListDocument = gql`
    query FleetVehicleSelectionList($module: Object!) {
  fleetVehicles(
    query: {filters: [{value: $module, field: "modules", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        name
        id
        plateNumber
        status
      }
    }
  }
}
    `;

/**
 * __useFleetVehicleSelectionListQuery__
 *
 * To run a query within a React component, call `useFleetVehicleSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetVehicleSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetVehicleSelectionListQuery({
 *   variables: {
 *      module: // value for 'module'
 *   },
 * });
 */
export function useFleetVehicleSelectionListQuery(baseOptions: Apollo.QueryHookOptions<FleetVehicleSelectionListQuery, FleetVehicleSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetVehicleSelectionListQuery, FleetVehicleSelectionListQueryVariables>(FleetVehicleSelectionListDocument, options);
      }
export function useFleetVehicleSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetVehicleSelectionListQuery, FleetVehicleSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetVehicleSelectionListQuery, FleetVehicleSelectionListQueryVariables>(FleetVehicleSelectionListDocument, options);
        }
export type FleetVehicleSelectionListQueryHookResult = ReturnType<typeof useFleetVehicleSelectionListQuery>;
export type FleetVehicleSelectionListLazyQueryHookResult = ReturnType<typeof useFleetVehicleSelectionListLazyQuery>;
export type FleetVehicleSelectionListQueryResult = Apollo.QueryResult<FleetVehicleSelectionListQuery, FleetVehicleSelectionListQueryVariables>;
export function refetchFleetVehicleSelectionListQuery(variables: FleetVehicleSelectionListQueryVariables) {
      return { query: FleetVehicleSelectionListDocument, variables: variables }
    }
export const ActiveFleetVehicleListDocument = gql`
    query ActiveFleetVehicleList($module: Object!) {
  fleetShifts(
    query: {filters: [{value: $module, field: "module", operator: EQUALS}], limit: 10000}
  ) {
    edges {
      node {
        vehicle
      }
    }
  }
}
    `;

/**
 * __useActiveFleetVehicleListQuery__
 *
 * To run a query within a React component, call `useActiveFleetVehicleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveFleetVehicleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveFleetVehicleListQuery({
 *   variables: {
 *      module: // value for 'module'
 *   },
 * });
 */
export function useActiveFleetVehicleListQuery(baseOptions: Apollo.QueryHookOptions<ActiveFleetVehicleListQuery, ActiveFleetVehicleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveFleetVehicleListQuery, ActiveFleetVehicleListQueryVariables>(ActiveFleetVehicleListDocument, options);
      }
export function useActiveFleetVehicleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveFleetVehicleListQuery, ActiveFleetVehicleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveFleetVehicleListQuery, ActiveFleetVehicleListQueryVariables>(ActiveFleetVehicleListDocument, options);
        }
export type ActiveFleetVehicleListQueryHookResult = ReturnType<typeof useActiveFleetVehicleListQuery>;
export type ActiveFleetVehicleListLazyQueryHookResult = ReturnType<typeof useActiveFleetVehicleListLazyQuery>;
export type ActiveFleetVehicleListQueryResult = Apollo.QueryResult<ActiveFleetVehicleListQuery, ActiveFleetVehicleListQueryVariables>;
export function refetchActiveFleetVehicleListQuery(variables: ActiveFleetVehicleListQueryVariables) {
      return { query: ActiveFleetVehicleListDocument, variables: variables }
    }
export const GetKineticFormDocument = gql`
    query GetKineticForm($id: ID!) {
  kineticForm(id: $id) {
    ...KineticFormFragment
  }
}
    ${KineticFormFragmentFragmentDoc}`;

/**
 * __useGetKineticFormQuery__
 *
 * To run a query within a React component, call `useGetKineticFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKineticFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKineticFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKineticFormQuery(baseOptions: Apollo.QueryHookOptions<GetKineticFormQuery, GetKineticFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKineticFormQuery, GetKineticFormQueryVariables>(GetKineticFormDocument, options);
      }
export function useGetKineticFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKineticFormQuery, GetKineticFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKineticFormQuery, GetKineticFormQueryVariables>(GetKineticFormDocument, options);
        }
export type GetKineticFormQueryHookResult = ReturnType<typeof useGetKineticFormQuery>;
export type GetKineticFormLazyQueryHookResult = ReturnType<typeof useGetKineticFormLazyQuery>;
export type GetKineticFormQueryResult = Apollo.QueryResult<GetKineticFormQuery, GetKineticFormQueryVariables>;
export function refetchGetKineticFormQuery(variables: GetKineticFormQueryVariables) {
      return { query: GetKineticFormDocument, variables: variables }
    }
export const GetKineticFormsDocument = gql`
    query GetKineticForms($query: KineticFormInputQuery) {
  kineticForms(query: $query) {
    edges {
      node {
        ...KineticFormFragment
      }
    }
  }
}
    ${KineticFormFragmentFragmentDoc}`;

/**
 * __useGetKineticFormsQuery__
 *
 * To run a query within a React component, call `useGetKineticFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKineticFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKineticFormsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetKineticFormsQuery(baseOptions?: Apollo.QueryHookOptions<GetKineticFormsQuery, GetKineticFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKineticFormsQuery, GetKineticFormsQueryVariables>(GetKineticFormsDocument, options);
      }
export function useGetKineticFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKineticFormsQuery, GetKineticFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKineticFormsQuery, GetKineticFormsQueryVariables>(GetKineticFormsDocument, options);
        }
export type GetKineticFormsQueryHookResult = ReturnType<typeof useGetKineticFormsQuery>;
export type GetKineticFormsLazyQueryHookResult = ReturnType<typeof useGetKineticFormsLazyQuery>;
export type GetKineticFormsQueryResult = Apollo.QueryResult<GetKineticFormsQuery, GetKineticFormsQueryVariables>;
export function refetchGetKineticFormsQuery(variables?: GetKineticFormsQueryVariables) {
      return { query: GetKineticFormsDocument, variables: variables }
    }
export const KineticFormsOptionsDocument = gql`
    query KineticFormsOptions($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 1000, $before: String, $after: String, $module: KineticModule) {
  kineticForms(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit, module: $module}
  ) {
    edges {
      node {
        id
        name
        views {
          id
          sections {
            name
            id
          }
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useKineticFormsOptionsQuery__
 *
 * To run a query within a React component, call `useKineticFormsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormsOptionsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useKineticFormsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<KineticFormsOptionsQuery, KineticFormsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormsOptionsQuery, KineticFormsOptionsQueryVariables>(KineticFormsOptionsDocument, options);
      }
export function useKineticFormsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormsOptionsQuery, KineticFormsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormsOptionsQuery, KineticFormsOptionsQueryVariables>(KineticFormsOptionsDocument, options);
        }
export type KineticFormsOptionsQueryHookResult = ReturnType<typeof useKineticFormsOptionsQuery>;
export type KineticFormsOptionsLazyQueryHookResult = ReturnType<typeof useKineticFormsOptionsLazyQuery>;
export type KineticFormsOptionsQueryResult = Apollo.QueryResult<KineticFormsOptionsQuery, KineticFormsOptionsQueryVariables>;
export function refetchKineticFormsOptionsQuery(variables?: KineticFormsOptionsQueryVariables) {
      return { query: KineticFormsOptionsDocument, variables: variables }
    }
export const KineticFormDocument = gql`
    query KineticForm($id: ID!) {
  kineticForm(id: $id) {
    ...KineticForm
  }
}
    ${KineticFormFragmentDoc}`;

/**
 * __useKineticFormQuery__
 *
 * To run a query within a React component, call `useKineticFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKineticFormQuery(baseOptions: Apollo.QueryHookOptions<KineticFormQuery, KineticFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormQuery, KineticFormQueryVariables>(KineticFormDocument, options);
      }
export function useKineticFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormQuery, KineticFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormQuery, KineticFormQueryVariables>(KineticFormDocument, options);
        }
export type KineticFormQueryHookResult = ReturnType<typeof useKineticFormQuery>;
export type KineticFormLazyQueryHookResult = ReturnType<typeof useKineticFormLazyQuery>;
export type KineticFormQueryResult = Apollo.QueryResult<KineticFormQuery, KineticFormQueryVariables>;
export function refetchKineticFormQuery(variables: KineticFormQueryVariables) {
      return { query: KineticFormDocument, variables: variables }
    }
export const KineticEventFormDocument = gql`
    query KineticEventForm($category: String!) {
  kineticEventForm(category: $category) {
    ...KineticFormFragment
  }
}
    ${KineticFormFragmentFragmentDoc}`;

/**
 * __useKineticEventFormQuery__
 *
 * To run a query within a React component, call `useKineticEventFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticEventFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticEventFormQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useKineticEventFormQuery(baseOptions: Apollo.QueryHookOptions<KineticEventFormQuery, KineticEventFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticEventFormQuery, KineticEventFormQueryVariables>(KineticEventFormDocument, options);
      }
export function useKineticEventFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticEventFormQuery, KineticEventFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticEventFormQuery, KineticEventFormQueryVariables>(KineticEventFormDocument, options);
        }
export type KineticEventFormQueryHookResult = ReturnType<typeof useKineticEventFormQuery>;
export type KineticEventFormLazyQueryHookResult = ReturnType<typeof useKineticEventFormLazyQuery>;
export type KineticEventFormQueryResult = Apollo.QueryResult<KineticEventFormQuery, KineticEventFormQueryVariables>;
export function refetchKineticEventFormQuery(variables: KineticEventFormQueryVariables) {
      return { query: KineticEventFormDocument, variables: variables }
    }
export const GateControllerNamesDocument = gql`
    query GateControllerNames($limit: Int = 10000) {
  gateControllers(query: {limit: $limit}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGateControllerNamesQuery__
 *
 * To run a query within a React component, call `useGateControllerNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerNamesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGateControllerNamesQuery(baseOptions?: Apollo.QueryHookOptions<GateControllerNamesQuery, GateControllerNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerNamesQuery, GateControllerNamesQueryVariables>(GateControllerNamesDocument, options);
      }
export function useGateControllerNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerNamesQuery, GateControllerNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerNamesQuery, GateControllerNamesQueryVariables>(GateControllerNamesDocument, options);
        }
export type GateControllerNamesQueryHookResult = ReturnType<typeof useGateControllerNamesQuery>;
export type GateControllerNamesLazyQueryHookResult = ReturnType<typeof useGateControllerNamesLazyQuery>;
export type GateControllerNamesQueryResult = Apollo.QueryResult<GateControllerNamesQuery, GateControllerNamesQueryVariables>;
export function refetchGateControllerNamesQuery(variables?: GateControllerNamesQueryVariables) {
      return { query: GateControllerNamesDocument, variables: variables }
    }
export const GateAlarmConfigsDocument = gql`
    query GateAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "GATES"}, {field: "entityType", operator: EQUALS, value: "GATE"}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGateAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useGateAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGateAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GateAlarmConfigsQuery, GateAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateAlarmConfigsQuery, GateAlarmConfigsQueryVariables>(GateAlarmConfigsDocument, options);
      }
export function useGateAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateAlarmConfigsQuery, GateAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateAlarmConfigsQuery, GateAlarmConfigsQueryVariables>(GateAlarmConfigsDocument, options);
        }
export type GateAlarmConfigsQueryHookResult = ReturnType<typeof useGateAlarmConfigsQuery>;
export type GateAlarmConfigsLazyQueryHookResult = ReturnType<typeof useGateAlarmConfigsLazyQuery>;
export type GateAlarmConfigsQueryResult = Apollo.QueryResult<GateAlarmConfigsQuery, GateAlarmConfigsQueryVariables>;
export function refetchGateAlarmConfigsQuery(variables?: GateAlarmConfigsQueryVariables) {
      return { query: GateAlarmConfigsDocument, variables: variables }
    }
export const GateCameraDocument = gql`
    query GateCamera($id: ID!) {
  camera(id: $id) {
    ...CameraNode
  }
}
    ${CameraNodeFragmentDoc}`;

/**
 * __useGateCameraQuery__
 *
 * To run a query within a React component, call `useGateCameraQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateCameraQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateCameraQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateCameraQuery(baseOptions: Apollo.QueryHookOptions<GateCameraQuery, GateCameraQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateCameraQuery, GateCameraQueryVariables>(GateCameraDocument, options);
      }
export function useGateCameraLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateCameraQuery, GateCameraQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateCameraQuery, GateCameraQueryVariables>(GateCameraDocument, options);
        }
export type GateCameraQueryHookResult = ReturnType<typeof useGateCameraQuery>;
export type GateCameraLazyQueryHookResult = ReturnType<typeof useGateCameraLazyQuery>;
export type GateCameraQueryResult = Apollo.QueryResult<GateCameraQuery, GateCameraQueryVariables>;
export function refetchGateCameraQuery(variables: GateCameraQueryVariables) {
      return { query: GateCameraDocument, variables: variables }
    }
export const GateControllerCameraListDocument = gql`
    query GateControllerCameraList($searchFields: [String!] = ["name", "road", "direction", "referencePoint"], $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  cameras(
    searchFields: $searchFields
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        communicationStatus
        lastSuccessfulPoll
        referencePoint
        direction
        location
        road
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGateControllerCameraListQuery__
 *
 * To run a query within a React component, call `useGateControllerCameraListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerCameraListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerCameraListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGateControllerCameraListQuery(baseOptions?: Apollo.QueryHookOptions<GateControllerCameraListQuery, GateControllerCameraListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerCameraListQuery, GateControllerCameraListQueryVariables>(GateControllerCameraListDocument, options);
      }
export function useGateControllerCameraListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerCameraListQuery, GateControllerCameraListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerCameraListQuery, GateControllerCameraListQueryVariables>(GateControllerCameraListDocument, options);
        }
export type GateControllerCameraListQueryHookResult = ReturnType<typeof useGateControllerCameraListQuery>;
export type GateControllerCameraListLazyQueryHookResult = ReturnType<typeof useGateControllerCameraListLazyQuery>;
export type GateControllerCameraListQueryResult = Apollo.QueryResult<GateControllerCameraListQuery, GateControllerCameraListQueryVariables>;
export function refetchGateControllerCameraListQuery(variables?: GateControllerCameraListQueryVariables) {
      return { query: GateControllerCameraListDocument, variables: variables }
    }
export const OpenInboundGatesDocument = gql`
    mutation OpenInboundGates($id: ID!, $systemId: ID!, $requestId: String, $manualOperation: Boolean) {
  openInboundGates(
    id: $id
    systemId: $systemId
    requestId: $requestId
    manualOperation: $manualOperation
  )
}
    `;
export type OpenInboundGatesMutationFn = Apollo.MutationFunction<OpenInboundGatesMutation, OpenInboundGatesMutationVariables>;

/**
 * __useOpenInboundGatesMutation__
 *
 * To run a mutation, you first call `useOpenInboundGatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenInboundGatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openInboundGatesMutation, { data, loading, error }] = useOpenInboundGatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      systemId: // value for 'systemId'
 *      requestId: // value for 'requestId'
 *      manualOperation: // value for 'manualOperation'
 *   },
 * });
 */
export function useOpenInboundGatesMutation(baseOptions?: Apollo.MutationHookOptions<OpenInboundGatesMutation, OpenInboundGatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenInboundGatesMutation, OpenInboundGatesMutationVariables>(OpenInboundGatesDocument, options);
      }
export type OpenInboundGatesMutationHookResult = ReturnType<typeof useOpenInboundGatesMutation>;
export type OpenInboundGatesMutationResult = Apollo.MutationResult<OpenInboundGatesMutation>;
export type OpenInboundGatesMutationOptions = Apollo.BaseMutationOptions<OpenInboundGatesMutation, OpenInboundGatesMutationVariables>;
export const OpenOutboundGatesDocument = gql`
    mutation OpenOutboundGates($id: ID!, $systemId: ID!, $requestId: String, $manualOperation: Boolean) {
  openOutboundGates(
    id: $id
    systemId: $systemId
    requestId: $requestId
    manualOperation: $manualOperation
  )
}
    `;
export type OpenOutboundGatesMutationFn = Apollo.MutationFunction<OpenOutboundGatesMutation, OpenOutboundGatesMutationVariables>;

/**
 * __useOpenOutboundGatesMutation__
 *
 * To run a mutation, you first call `useOpenOutboundGatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenOutboundGatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openOutboundGatesMutation, { data, loading, error }] = useOpenOutboundGatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      systemId: // value for 'systemId'
 *      requestId: // value for 'requestId'
 *      manualOperation: // value for 'manualOperation'
 *   },
 * });
 */
export function useOpenOutboundGatesMutation(baseOptions?: Apollo.MutationHookOptions<OpenOutboundGatesMutation, OpenOutboundGatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenOutboundGatesMutation, OpenOutboundGatesMutationVariables>(OpenOutboundGatesDocument, options);
      }
export type OpenOutboundGatesMutationHookResult = ReturnType<typeof useOpenOutboundGatesMutation>;
export type OpenOutboundGatesMutationResult = Apollo.MutationResult<OpenOutboundGatesMutation>;
export type OpenOutboundGatesMutationOptions = Apollo.BaseMutationOptions<OpenOutboundGatesMutation, OpenOutboundGatesMutationVariables>;
export const CloseGatesDocument = gql`
    mutation CloseGates($id: ID!, $systemId: ID!, $requestId: String, $manualOperation: Boolean) {
  closeGates(
    id: $id
    systemId: $systemId
    requestId: $requestId
    manualOperation: $manualOperation
  )
}
    `;
export type CloseGatesMutationFn = Apollo.MutationFunction<CloseGatesMutation, CloseGatesMutationVariables>;

/**
 * __useCloseGatesMutation__
 *
 * To run a mutation, you first call `useCloseGatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseGatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeGatesMutation, { data, loading, error }] = useCloseGatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      systemId: // value for 'systemId'
 *      requestId: // value for 'requestId'
 *      manualOperation: // value for 'manualOperation'
 *   },
 * });
 */
export function useCloseGatesMutation(baseOptions?: Apollo.MutationHookOptions<CloseGatesMutation, CloseGatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseGatesMutation, CloseGatesMutationVariables>(CloseGatesDocument, options);
      }
export type CloseGatesMutationHookResult = ReturnType<typeof useCloseGatesMutation>;
export type CloseGatesMutationResult = Apollo.MutationResult<CloseGatesMutation>;
export type CloseGatesMutationOptions = Apollo.BaseMutationOptions<CloseGatesMutation, CloseGatesMutationVariables>;
export const AbortGateOperationDocument = gql`
    mutation AbortGateOperation($id: ID!, $requestId: String) {
  abortControllerOperation(id: $id, requestId: $requestId)
}
    `;
export type AbortGateOperationMutationFn = Apollo.MutationFunction<AbortGateOperationMutation, AbortGateOperationMutationVariables>;

/**
 * __useAbortGateOperationMutation__
 *
 * To run a mutation, you first call `useAbortGateOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortGateOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortGateOperationMutation, { data, loading, error }] = useAbortGateOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useAbortGateOperationMutation(baseOptions?: Apollo.MutationHookOptions<AbortGateOperationMutation, AbortGateOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortGateOperationMutation, AbortGateOperationMutationVariables>(AbortGateOperationDocument, options);
      }
export type AbortGateOperationMutationHookResult = ReturnType<typeof useAbortGateOperationMutation>;
export type AbortGateOperationMutationResult = Apollo.MutationResult<AbortGateOperationMutation>;
export type AbortGateOperationMutationOptions = Apollo.BaseMutationOptions<AbortGateOperationMutation, AbortGateOperationMutationVariables>;
export const ToggleGateRestrictionBypassDocument = gql`
    mutation ToggleGateRestrictionBypass($id: ID!, $value: Boolean!) {
  toggleGateRestrictionBypass(id: $id, value: $value)
}
    `;
export type ToggleGateRestrictionBypassMutationFn = Apollo.MutationFunction<ToggleGateRestrictionBypassMutation, ToggleGateRestrictionBypassMutationVariables>;

/**
 * __useToggleGateRestrictionBypassMutation__
 *
 * To run a mutation, you first call `useToggleGateRestrictionBypassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleGateRestrictionBypassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleGateRestrictionBypassMutation, { data, loading, error }] = useToggleGateRestrictionBypassMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useToggleGateRestrictionBypassMutation(baseOptions?: Apollo.MutationHookOptions<ToggleGateRestrictionBypassMutation, ToggleGateRestrictionBypassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleGateRestrictionBypassMutation, ToggleGateRestrictionBypassMutationVariables>(ToggleGateRestrictionBypassDocument, options);
      }
export type ToggleGateRestrictionBypassMutationHookResult = ReturnType<typeof useToggleGateRestrictionBypassMutation>;
export type ToggleGateRestrictionBypassMutationResult = Apollo.MutationResult<ToggleGateRestrictionBypassMutation>;
export type ToggleGateRestrictionBypassMutationOptions = Apollo.BaseMutationOptions<ToggleGateRestrictionBypassMutation, ToggleGateRestrictionBypassMutationVariables>;
export const ToggleSafeReversalTimeDocument = gql`
    mutation ToggleSafeReversalTime($id: ID!, $value: Boolean!) {
  toggleGateSafeReversalTime(id: $id, value: $value)
}
    `;
export type ToggleSafeReversalTimeMutationFn = Apollo.MutationFunction<ToggleSafeReversalTimeMutation, ToggleSafeReversalTimeMutationVariables>;

/**
 * __useToggleSafeReversalTimeMutation__
 *
 * To run a mutation, you first call `useToggleSafeReversalTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSafeReversalTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSafeReversalTimeMutation, { data, loading, error }] = useToggleSafeReversalTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useToggleSafeReversalTimeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleSafeReversalTimeMutation, ToggleSafeReversalTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleSafeReversalTimeMutation, ToggleSafeReversalTimeMutationVariables>(ToggleSafeReversalTimeDocument, options);
      }
export type ToggleSafeReversalTimeMutationHookResult = ReturnType<typeof useToggleSafeReversalTimeMutation>;
export type ToggleSafeReversalTimeMutationResult = Apollo.MutationResult<ToggleSafeReversalTimeMutation>;
export type ToggleSafeReversalTimeMutationOptions = Apollo.BaseMutationOptions<ToggleSafeReversalTimeMutation, ToggleSafeReversalTimeMutationVariables>;
export const GateControllerPollDocument = gql`
    mutation GateControllerPoll($ids: [ID!]!) {
  multiplePoll(ids: $ids, integrationType: GATE_CONTROLLER) {
    requestId
    success
    failure
    id
  }
}
    `;
export type GateControllerPollMutationFn = Apollo.MutationFunction<GateControllerPollMutation, GateControllerPollMutationVariables>;

/**
 * __useGateControllerPollMutation__
 *
 * To run a mutation, you first call `useGateControllerPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateControllerPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateControllerPollMutation, { data, loading, error }] = useGateControllerPollMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGateControllerPollMutation(baseOptions?: Apollo.MutationHookOptions<GateControllerPollMutation, GateControllerPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateControllerPollMutation, GateControllerPollMutationVariables>(GateControllerPollDocument, options);
      }
export type GateControllerPollMutationHookResult = ReturnType<typeof useGateControllerPollMutation>;
export type GateControllerPollMutationResult = Apollo.MutationResult<GateControllerPollMutation>;
export type GateControllerPollMutationOptions = Apollo.BaseMutationOptions<GateControllerPollMutation, GateControllerPollMutationVariables>;
export const GateControllerOptionsDocument = gql`
    query GateControllerOptions {
  gateControllers(query: {limit: 500}) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGateControllerOptionsQuery__
 *
 * To run a query within a React component, call `useGateControllerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGateControllerOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GateControllerOptionsQuery, GateControllerOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerOptionsQuery, GateControllerOptionsQueryVariables>(GateControllerOptionsDocument, options);
      }
export function useGateControllerOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerOptionsQuery, GateControllerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerOptionsQuery, GateControllerOptionsQueryVariables>(GateControllerOptionsDocument, options);
        }
export type GateControllerOptionsQueryHookResult = ReturnType<typeof useGateControllerOptionsQuery>;
export type GateControllerOptionsLazyQueryHookResult = ReturnType<typeof useGateControllerOptionsLazyQuery>;
export type GateControllerOptionsQueryResult = Apollo.QueryResult<GateControllerOptionsQuery, GateControllerOptionsQueryVariables>;
export function refetchGateControllerOptionsQuery(variables?: GateControllerOptionsQueryVariables) {
      return { query: GateControllerOptionsDocument, variables: variables }
    }
export const GateControllerDetailsSignalsDocument = gql`
    query GateControllerDetailsSignals($id: ID!) {
  gateController(id: $id) {
    signalVerificationStatus {
      index
      verified
    }
  }
}
    `;

/**
 * __useGateControllerDetailsSignalsQuery__
 *
 * To run a query within a React component, call `useGateControllerDetailsSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerDetailsSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerDetailsSignalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerDetailsSignalsQuery(baseOptions: Apollo.QueryHookOptions<GateControllerDetailsSignalsQuery, GateControllerDetailsSignalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerDetailsSignalsQuery, GateControllerDetailsSignalsQueryVariables>(GateControllerDetailsSignalsDocument, options);
      }
export function useGateControllerDetailsSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerDetailsSignalsQuery, GateControllerDetailsSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerDetailsSignalsQuery, GateControllerDetailsSignalsQueryVariables>(GateControllerDetailsSignalsDocument, options);
        }
export type GateControllerDetailsSignalsQueryHookResult = ReturnType<typeof useGateControllerDetailsSignalsQuery>;
export type GateControllerDetailsSignalsLazyQueryHookResult = ReturnType<typeof useGateControllerDetailsSignalsLazyQuery>;
export type GateControllerDetailsSignalsQueryResult = Apollo.QueryResult<GateControllerDetailsSignalsQuery, GateControllerDetailsSignalsQueryVariables>;
export function refetchGateControllerDetailsSignalsQuery(variables: GateControllerDetailsSignalsQueryVariables) {
      return { query: GateControllerDetailsSignalsDocument, variables: variables }
    }
export const GateControllerDetailsOperationsDocument = gql`
    query GateControllerDetailsOperations($id: ID!) {
  gateController(id: $id) {
    bypassingRestrictions
    entranceDirection
    operationStatus
    name
  }
}
    `;

/**
 * __useGateControllerDetailsOperationsQuery__
 *
 * To run a query within a React component, call `useGateControllerDetailsOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerDetailsOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerDetailsOperationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerDetailsOperationsQuery(baseOptions: Apollo.QueryHookOptions<GateControllerDetailsOperationsQuery, GateControllerDetailsOperationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerDetailsOperationsQuery, GateControllerDetailsOperationsQueryVariables>(GateControllerDetailsOperationsDocument, options);
      }
export function useGateControllerDetailsOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerDetailsOperationsQuery, GateControllerDetailsOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerDetailsOperationsQuery, GateControllerDetailsOperationsQueryVariables>(GateControllerDetailsOperationsDocument, options);
        }
export type GateControllerDetailsOperationsQueryHookResult = ReturnType<typeof useGateControllerDetailsOperationsQuery>;
export type GateControllerDetailsOperationsLazyQueryHookResult = ReturnType<typeof useGateControllerDetailsOperationsLazyQuery>;
export type GateControllerDetailsOperationsQueryResult = Apollo.QueryResult<GateControllerDetailsOperationsQuery, GateControllerDetailsOperationsQueryVariables>;
export function refetchGateControllerDetailsOperationsQuery(variables: GateControllerDetailsOperationsQueryVariables) {
      return { query: GateControllerDetailsOperationsDocument, variables: variables }
    }
export const GateControllerDetailsDocument = gql`
    query GateControllerDetails($id: ID!) {
  gateController(id: $id) {
    operationStatus
    communicationStatus
    entranceDirection
    gateCameras {
      cameraId
    }
    name
    id
  }
}
    `;

/**
 * __useGateControllerDetailsQuery__
 *
 * To run a query within a React component, call `useGateControllerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GateControllerDetailsQuery, GateControllerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerDetailsQuery, GateControllerDetailsQueryVariables>(GateControllerDetailsDocument, options);
      }
export function useGateControllerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerDetailsQuery, GateControllerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerDetailsQuery, GateControllerDetailsQueryVariables>(GateControllerDetailsDocument, options);
        }
export type GateControllerDetailsQueryHookResult = ReturnType<typeof useGateControllerDetailsQuery>;
export type GateControllerDetailsLazyQueryHookResult = ReturnType<typeof useGateControllerDetailsLazyQuery>;
export type GateControllerDetailsQueryResult = Apollo.QueryResult<GateControllerDetailsQuery, GateControllerDetailsQueryVariables>;
export function refetchGateControllerDetailsQuery(variables: GateControllerDetailsQueryVariables) {
      return { query: GateControllerDetailsDocument, variables: variables }
    }
export const GateControllerDetailsMapDocument = gql`
    query GateControllerDetailsMap($id: ID!) {
  gateController(id: $id) {
    location
    status
    communicationStatus
  }
}
    `;

/**
 * __useGateControllerDetailsMapQuery__
 *
 * To run a query within a React component, call `useGateControllerDetailsMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerDetailsMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerDetailsMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerDetailsMapQuery(baseOptions: Apollo.QueryHookOptions<GateControllerDetailsMapQuery, GateControllerDetailsMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerDetailsMapQuery, GateControllerDetailsMapQueryVariables>(GateControllerDetailsMapDocument, options);
      }
export function useGateControllerDetailsMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerDetailsMapQuery, GateControllerDetailsMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerDetailsMapQuery, GateControllerDetailsMapQueryVariables>(GateControllerDetailsMapDocument, options);
        }
export type GateControllerDetailsMapQueryHookResult = ReturnType<typeof useGateControllerDetailsMapQuery>;
export type GateControllerDetailsMapLazyQueryHookResult = ReturnType<typeof useGateControllerDetailsMapLazyQuery>;
export type GateControllerDetailsMapQueryResult = Apollo.QueryResult<GateControllerDetailsMapQuery, GateControllerDetailsMapQueryVariables>;
export function refetchGateControllerDetailsMapQuery(variables: GateControllerDetailsMapQueryVariables) {
      return { query: GateControllerDetailsMapDocument, variables: variables }
    }
export const GateControllerDetailsArmsDocument = gql`
    query GateControllerDetailsArms($id: ID!) {
  gateController(id: $id) {
    gateArms {
      direction
      nativeId
      position
      health
      name
    }
  }
}
    `;

/**
 * __useGateControllerDetailsArmsQuery__
 *
 * To run a query within a React component, call `useGateControllerDetailsArmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerDetailsArmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerDetailsArmsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerDetailsArmsQuery(baseOptions: Apollo.QueryHookOptions<GateControllerDetailsArmsQuery, GateControllerDetailsArmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerDetailsArmsQuery, GateControllerDetailsArmsQueryVariables>(GateControllerDetailsArmsDocument, options);
      }
export function useGateControllerDetailsArmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerDetailsArmsQuery, GateControllerDetailsArmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerDetailsArmsQuery, GateControllerDetailsArmsQueryVariables>(GateControllerDetailsArmsDocument, options);
        }
export type GateControllerDetailsArmsQueryHookResult = ReturnType<typeof useGateControllerDetailsArmsQuery>;
export type GateControllerDetailsArmsLazyQueryHookResult = ReturnType<typeof useGateControllerDetailsArmsLazyQuery>;
export type GateControllerDetailsArmsQueryResult = Apollo.QueryResult<GateControllerDetailsArmsQuery, GateControllerDetailsArmsQueryVariables>;
export function refetchGateControllerDetailsArmsQuery(variables: GateControllerDetailsArmsQueryVariables) {
      return { query: GateControllerDetailsArmsDocument, variables: variables }
    }
export const GateControllerToggleRestrictionBypassDocument = gql`
    query GateControllerToggleRestrictionBypass($id: ID!) {
  gateController(id: $id) {
    bypassingRestrictions
    name
  }
}
    `;

/**
 * __useGateControllerToggleRestrictionBypassQuery__
 *
 * To run a query within a React component, call `useGateControllerToggleRestrictionBypassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerToggleRestrictionBypassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerToggleRestrictionBypassQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerToggleRestrictionBypassQuery(baseOptions: Apollo.QueryHookOptions<GateControllerToggleRestrictionBypassQuery, GateControllerToggleRestrictionBypassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerToggleRestrictionBypassQuery, GateControllerToggleRestrictionBypassQueryVariables>(GateControllerToggleRestrictionBypassDocument, options);
      }
export function useGateControllerToggleRestrictionBypassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerToggleRestrictionBypassQuery, GateControllerToggleRestrictionBypassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerToggleRestrictionBypassQuery, GateControllerToggleRestrictionBypassQueryVariables>(GateControllerToggleRestrictionBypassDocument, options);
        }
export type GateControllerToggleRestrictionBypassQueryHookResult = ReturnType<typeof useGateControllerToggleRestrictionBypassQuery>;
export type GateControllerToggleRestrictionBypassLazyQueryHookResult = ReturnType<typeof useGateControllerToggleRestrictionBypassLazyQuery>;
export type GateControllerToggleRestrictionBypassQueryResult = Apollo.QueryResult<GateControllerToggleRestrictionBypassQuery, GateControllerToggleRestrictionBypassQueryVariables>;
export function refetchGateControllerToggleRestrictionBypassQuery(variables: GateControllerToggleRestrictionBypassQueryVariables) {
      return { query: GateControllerToggleRestrictionBypassDocument, variables: variables }
    }
export const GateControllerSafeReversalTimeDisabledDocument = gql`
    query GateControllerSafeReversalTimeDisabled($id: ID!) {
  gateController(id: $id) {
    safeReversalTimeDisabled
    name
  }
}
    `;

/**
 * __useGateControllerSafeReversalTimeDisabledQuery__
 *
 * To run a query within a React component, call `useGateControllerSafeReversalTimeDisabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerSafeReversalTimeDisabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerSafeReversalTimeDisabledQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerSafeReversalTimeDisabledQuery(baseOptions: Apollo.QueryHookOptions<GateControllerSafeReversalTimeDisabledQuery, GateControllerSafeReversalTimeDisabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerSafeReversalTimeDisabledQuery, GateControllerSafeReversalTimeDisabledQueryVariables>(GateControllerSafeReversalTimeDisabledDocument, options);
      }
export function useGateControllerSafeReversalTimeDisabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerSafeReversalTimeDisabledQuery, GateControllerSafeReversalTimeDisabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerSafeReversalTimeDisabledQuery, GateControllerSafeReversalTimeDisabledQueryVariables>(GateControllerSafeReversalTimeDisabledDocument, options);
        }
export type GateControllerSafeReversalTimeDisabledQueryHookResult = ReturnType<typeof useGateControllerSafeReversalTimeDisabledQuery>;
export type GateControllerSafeReversalTimeDisabledLazyQueryHookResult = ReturnType<typeof useGateControllerSafeReversalTimeDisabledLazyQuery>;
export type GateControllerSafeReversalTimeDisabledQueryResult = Apollo.QueryResult<GateControllerSafeReversalTimeDisabledQuery, GateControllerSafeReversalTimeDisabledQueryVariables>;
export function refetchGateControllerSafeReversalTimeDisabledQuery(variables: GateControllerSafeReversalTimeDisabledQueryVariables) {
      return { query: GateControllerSafeReversalTimeDisabledDocument, variables: variables }
    }
export const GateControllerDetailsSignsDocument = gql`
    query GateControllerDetailsSigns($id: ID!) {
  gateController(id: $id) {
    gateSigns
  }
}
    `;

/**
 * __useGateControllerDetailsSignsQuery__
 *
 * To run a query within a React component, call `useGateControllerDetailsSignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerDetailsSignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerDetailsSignsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerDetailsSignsQuery(baseOptions: Apollo.QueryHookOptions<GateControllerDetailsSignsQuery, GateControllerDetailsSignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerDetailsSignsQuery, GateControllerDetailsSignsQueryVariables>(GateControllerDetailsSignsDocument, options);
      }
export function useGateControllerDetailsSignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerDetailsSignsQuery, GateControllerDetailsSignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerDetailsSignsQuery, GateControllerDetailsSignsQueryVariables>(GateControllerDetailsSignsDocument, options);
        }
export type GateControllerDetailsSignsQueryHookResult = ReturnType<typeof useGateControllerDetailsSignsQuery>;
export type GateControllerDetailsSignsLazyQueryHookResult = ReturnType<typeof useGateControllerDetailsSignsLazyQuery>;
export type GateControllerDetailsSignsQueryResult = Apollo.QueryResult<GateControllerDetailsSignsQuery, GateControllerDetailsSignsQueryVariables>;
export function refetchGateControllerDetailsSignsQuery(variables: GateControllerDetailsSignsQueryVariables) {
      return { query: GateControllerDetailsSignsDocument, variables: variables }
    }
export const GateControllerDetailsCamerasDocument = gql`
    query GateControllerDetailsCameras($id: ID!) {
  gateController(id: $id) {
    gateCameras {
      cameraId
    }
  }
}
    `;

/**
 * __useGateControllerDetailsCamerasQuery__
 *
 * To run a query within a React component, call `useGateControllerDetailsCamerasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerDetailsCamerasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerDetailsCamerasQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerDetailsCamerasQuery(baseOptions: Apollo.QueryHookOptions<GateControllerDetailsCamerasQuery, GateControllerDetailsCamerasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerDetailsCamerasQuery, GateControllerDetailsCamerasQueryVariables>(GateControllerDetailsCamerasDocument, options);
      }
export function useGateControllerDetailsCamerasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerDetailsCamerasQuery, GateControllerDetailsCamerasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerDetailsCamerasQuery, GateControllerDetailsCamerasQueryVariables>(GateControllerDetailsCamerasDocument, options);
        }
export type GateControllerDetailsCamerasQueryHookResult = ReturnType<typeof useGateControllerDetailsCamerasQuery>;
export type GateControllerDetailsCamerasLazyQueryHookResult = ReturnType<typeof useGateControllerDetailsCamerasLazyQuery>;
export type GateControllerDetailsCamerasQueryResult = Apollo.QueryResult<GateControllerDetailsCamerasQuery, GateControllerDetailsCamerasQueryVariables>;
export function refetchGateControllerDetailsCamerasQuery(variables: GateControllerDetailsCamerasQueryVariables) {
      return { query: GateControllerDetailsCamerasDocument, variables: variables }
    }
export const GateControllerSummaryCardDocument = gql`
    query GateControllerSummaryCard($id: ID!) {
  gateController(id: $id) {
    safeReversalTimeDisabled
    backupScheduleActive
    bypassingRestrictions
    communicationStatus
    entranceDirection
    lastDataReceived
    operationStatus
    referencePoint
    setControl
    description
    interlock
    direction
    status
    errors
    mode
    road
    name
  }
}
    `;

/**
 * __useGateControllerSummaryCardQuery__
 *
 * To run a query within a React component, call `useGateControllerSummaryCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerSummaryCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerSummaryCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerSummaryCardQuery(baseOptions: Apollo.QueryHookOptions<GateControllerSummaryCardQuery, GateControllerSummaryCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerSummaryCardQuery, GateControllerSummaryCardQueryVariables>(GateControllerSummaryCardDocument, options);
      }
export function useGateControllerSummaryCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerSummaryCardQuery, GateControllerSummaryCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerSummaryCardQuery, GateControllerSummaryCardQueryVariables>(GateControllerSummaryCardDocument, options);
        }
export type GateControllerSummaryCardQueryHookResult = ReturnType<typeof useGateControllerSummaryCardQuery>;
export type GateControllerSummaryCardLazyQueryHookResult = ReturnType<typeof useGateControllerSummaryCardLazyQuery>;
export type GateControllerSummaryCardQueryResult = Apollo.QueryResult<GateControllerSummaryCardQuery, GateControllerSummaryCardQueryVariables>;
export function refetchGateControllerSummaryCardQuery(variables: GateControllerSummaryCardQueryVariables) {
      return { query: GateControllerSummaryCardDocument, variables: variables }
    }
export const LiveGateControllersDocument = gql`
    subscription LiveGateControllers($ids: [ID!]) {
  gateControllerUpdated(ids: $ids) {
    id
    bypassingRestrictions
    communicationStatus
    entranceDirection
    lastDataReceived
    operationStatus
    referencePoint
    description
    direction
    interlock
    status
    mode
    road
    name
    id
  }
}
    `;

/**
 * __useLiveGateControllersSubscription__
 *
 * To run a query within a React component, call `useLiveGateControllersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateControllersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateControllersSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveGateControllersSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveGateControllersSubscription, LiveGateControllersSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateControllersSubscription, LiveGateControllersSubscriptionVariables>(LiveGateControllersDocument, options);
      }
export type LiveGateControllersSubscriptionHookResult = ReturnType<typeof useLiveGateControllersSubscription>;
export type LiveGateControllersSubscriptionResult = Apollo.SubscriptionResult<LiveGateControllersSubscription>;
export const LiveGateControllerDocument = gql`
    subscription LiveGateController($id: ID!) {
  gateControllerUpdated(ids: [$id]) {
    id
  }
}
    `;

/**
 * __useLiveGateControllerSubscription__
 *
 * To run a query within a React component, call `useLiveGateControllerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateControllerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateControllerSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveGateControllerSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateControllerSubscription, LiveGateControllerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateControllerSubscription, LiveGateControllerSubscriptionVariables>(LiveGateControllerDocument, options);
      }
export type LiveGateControllerSubscriptionHookResult = ReturnType<typeof useLiveGateControllerSubscription>;
export type LiveGateControllerSubscriptionResult = Apollo.SubscriptionResult<LiveGateControllerSubscription>;
export const GateControllerListDocument = gql`
    query GateControllerList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $searchFields: [String!] = ["name", "description", "communicationStatus"], $limit: Int = 10, $before: String, $after: String) {
  gateControllers(
    query: {searchText: $searchText, searchFields: $searchFields, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        bypassingRestrictions
        communicationStatus
        entranceDirection
        lastDataReceived
        operationStatus
        referencePoint
        description
        direction
        interlock
        status
        mode
        road
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGateControllerListQuery__
 *
 * To run a query within a React component, call `useGateControllerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGateControllerListQuery(baseOptions?: Apollo.QueryHookOptions<GateControllerListQuery, GateControllerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerListQuery, GateControllerListQueryVariables>(GateControllerListDocument, options);
      }
export function useGateControllerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerListQuery, GateControllerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerListQuery, GateControllerListQueryVariables>(GateControllerListDocument, options);
        }
export type GateControllerListQueryHookResult = ReturnType<typeof useGateControllerListQuery>;
export type GateControllerListLazyQueryHookResult = ReturnType<typeof useGateControllerListLazyQuery>;
export type GateControllerListQueryResult = Apollo.QueryResult<GateControllerListQuery, GateControllerListQueryVariables>;
export function refetchGateControllerListQuery(variables?: GateControllerListQueryVariables) {
      return { query: GateControllerListDocument, variables: variables }
    }
export const GateControllerSearchListDocument = gql`
    query GateControllerSearchList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  gateControllers(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        location
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGateControllerSearchListQuery__
 *
 * To run a query within a React component, call `useGateControllerSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerSearchListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGateControllerSearchListQuery(baseOptions?: Apollo.QueryHookOptions<GateControllerSearchListQuery, GateControllerSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerSearchListQuery, GateControllerSearchListQueryVariables>(GateControllerSearchListDocument, options);
      }
export function useGateControllerSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerSearchListQuery, GateControllerSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerSearchListQuery, GateControllerSearchListQueryVariables>(GateControllerSearchListDocument, options);
        }
export type GateControllerSearchListQueryHookResult = ReturnType<typeof useGateControllerSearchListQuery>;
export type GateControllerSearchListLazyQueryHookResult = ReturnType<typeof useGateControllerSearchListLazyQuery>;
export type GateControllerSearchListQueryResult = Apollo.QueryResult<GateControllerSearchListQuery, GateControllerSearchListQueryVariables>;
export function refetchGateControllerSearchListQuery(variables?: GateControllerSearchListQueryVariables) {
      return { query: GateControllerSearchListDocument, variables: variables }
    }
export const GateControllerMapListDocument = gql`
    query GateControllerMapList($filters: [FilterInput]) {
  gateControllers(query: {filters: $filters, limit: 1000}) {
    edges {
      node {
        location
        status
        id
        communicationStatus
      }
    }
  }
}
    `;

/**
 * __useGateControllerMapListQuery__
 *
 * To run a query within a React component, call `useGateControllerMapListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerMapListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerMapListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGateControllerMapListQuery(baseOptions?: Apollo.QueryHookOptions<GateControllerMapListQuery, GateControllerMapListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerMapListQuery, GateControllerMapListQueryVariables>(GateControllerMapListDocument, options);
      }
export function useGateControllerMapListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerMapListQuery, GateControllerMapListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerMapListQuery, GateControllerMapListQueryVariables>(GateControllerMapListDocument, options);
        }
export type GateControllerMapListQueryHookResult = ReturnType<typeof useGateControllerMapListQuery>;
export type GateControllerMapListLazyQueryHookResult = ReturnType<typeof useGateControllerMapListLazyQuery>;
export type GateControllerMapListQueryResult = Apollo.QueryResult<GateControllerMapListQuery, GateControllerMapListQueryVariables>;
export function refetchGateControllerMapListQuery(variables?: GateControllerMapListQueryVariables) {
      return { query: GateControllerMapListDocument, variables: variables }
    }
export const LiveGateControllerListDocument = gql`
    subscription LiveGateControllerList($ids: [ID!]) {
  gateControllerUpdated(ids: $ids) {
    bypassingRestrictions
    communicationStatus
    entranceDirection
    lastDataReceived
    operationStatus
    referencePoint
    description
    direction
    interlock
    status
    mode
    road
    name
    id
  }
}
    `;

/**
 * __useLiveGateControllerListSubscription__
 *
 * To run a query within a React component, call `useLiveGateControllerListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateControllerListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateControllerListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveGateControllerListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveGateControllerListSubscription, LiveGateControllerListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateControllerListSubscription, LiveGateControllerListSubscriptionVariables>(LiveGateControllerListDocument, options);
      }
export type LiveGateControllerListSubscriptionHookResult = ReturnType<typeof useLiveGateControllerListSubscription>;
export type LiveGateControllerListSubscriptionResult = Apollo.SubscriptionResult<LiveGateControllerListSubscription>;
export const GateSystemControllerListDocument = gql`
    query GateSystemControllerList($filters: [FilterInput], $limit: Int = 10) {
  gateControllers(query: {filters: $filters, limit: $limit}) {
    edges {
      node {
        entranceDirection
        operationStatus
        description
        gateSigns
        location
        interlock
        status
        mode
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGateSystemControllerListQuery__
 *
 * To run a query within a React component, call `useGateSystemControllerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemControllerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemControllerListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGateSystemControllerListQuery(baseOptions?: Apollo.QueryHookOptions<GateSystemControllerListQuery, GateSystemControllerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemControllerListQuery, GateSystemControllerListQueryVariables>(GateSystemControllerListDocument, options);
      }
export function useGateSystemControllerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemControllerListQuery, GateSystemControllerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemControllerListQuery, GateSystemControllerListQueryVariables>(GateSystemControllerListDocument, options);
        }
export type GateSystemControllerListQueryHookResult = ReturnType<typeof useGateSystemControllerListQuery>;
export type GateSystemControllerListLazyQueryHookResult = ReturnType<typeof useGateSystemControllerListLazyQuery>;
export type GateSystemControllerListQueryResult = Apollo.QueryResult<GateSystemControllerListQuery, GateSystemControllerListQueryVariables>;
export function refetchGateSystemControllerListQuery(variables?: GateSystemControllerListQueryVariables) {
      return { query: GateSystemControllerListDocument, variables: variables }
    }
export const LiveGateSystemControllerListDocument = gql`
    subscription LiveGateSystemControllerList($ids: [ID!]) {
  gateControllerUpdated(ids: $ids) {
    entranceDirection
    operationStatus
    description
    gateSigns
    interlock
    location
    status
    mode
    name
    id
  }
}
    `;

/**
 * __useLiveGateSystemControllerListSubscription__
 *
 * To run a query within a React component, call `useLiveGateSystemControllerListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateSystemControllerListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateSystemControllerListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveGateSystemControllerListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveGateSystemControllerListSubscription, LiveGateSystemControllerListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateSystemControllerListSubscription, LiveGateSystemControllerListSubscriptionVariables>(LiveGateSystemControllerListDocument, options);
      }
export type LiveGateSystemControllerListSubscriptionHookResult = ReturnType<typeof useLiveGateSystemControllerListSubscription>;
export type LiveGateSystemControllerListSubscriptionResult = Apollo.SubscriptionResult<LiveGateSystemControllerListSubscription>;
export const GateControllerDocument = gql`
    query GateController($id: ID!) {
  gateController(id: $id) {
    safeReversalTimeDisabled
    bypassingRestrictions
    communicationStatus
    lastDataReceived
    operationStatus
    referencePoint
    direction
    interlock
    gateArms {
      direction
      position
      location
      nativeId
      health
      name
    }
    entranceDirection
    description
    gateCameras {
      cameraId
    }
    gateSigns
    direction
    location
    status
    mode
    road
    name
    id
  }
}
    `;

/**
 * __useGateControllerQuery__
 *
 * To run a query within a React component, call `useGateControllerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerQuery(baseOptions: Apollo.QueryHookOptions<GateControllerQuery, GateControllerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerQuery, GateControllerQueryVariables>(GateControllerDocument, options);
      }
export function useGateControllerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerQuery, GateControllerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerQuery, GateControllerQueryVariables>(GateControllerDocument, options);
        }
export type GateControllerQueryHookResult = ReturnType<typeof useGateControllerQuery>;
export type GateControllerLazyQueryHookResult = ReturnType<typeof useGateControllerLazyQuery>;
export type GateControllerQueryResult = Apollo.QueryResult<GateControllerQuery, GateControllerQueryVariables>;
export function refetchGateControllerQuery(variables: GateControllerQueryVariables) {
      return { query: GateControllerDocument, variables: variables }
    }
export const GateControllerStatusLogListDocument = gql`
    query GateControllerStatusLogList($after: String, $before: String, $limit: Int = 100, $filters: [FilterInput!]!, $searchText: String, $sortOrder: SortOrder, $searchFields: [String!] = ["description", "object.name", "userFullName", "entityId", "userId", "action"]) {
  activityLogs(
    searchFields: $searchFields
    searchText: $searchText
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    after: $after
    limit: $limit
  ) {
    edges {
      node {
        description
        timestamp
        object
        type
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGateControllerStatusLogListQuery__
 *
 * To run a query within a React component, call `useGateControllerStatusLogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerStatusLogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerStatusLogListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortOrder: // value for 'sortOrder'
 *      searchFields: // value for 'searchFields'
 *   },
 * });
 */
export function useGateControllerStatusLogListQuery(baseOptions: Apollo.QueryHookOptions<GateControllerStatusLogListQuery, GateControllerStatusLogListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerStatusLogListQuery, GateControllerStatusLogListQueryVariables>(GateControllerStatusLogListDocument, options);
      }
export function useGateControllerStatusLogListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerStatusLogListQuery, GateControllerStatusLogListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerStatusLogListQuery, GateControllerStatusLogListQueryVariables>(GateControllerStatusLogListDocument, options);
        }
export type GateControllerStatusLogListQueryHookResult = ReturnType<typeof useGateControllerStatusLogListQuery>;
export type GateControllerStatusLogListLazyQueryHookResult = ReturnType<typeof useGateControllerStatusLogListLazyQuery>;
export type GateControllerStatusLogListQueryResult = Apollo.QueryResult<GateControllerStatusLogListQuery, GateControllerStatusLogListQueryVariables>;
export function refetchGateControllerStatusLogListQuery(variables: GateControllerStatusLogListQueryVariables) {
      return { query: GateControllerStatusLogListDocument, variables: variables }
    }
export const GateControllerSummaryDocument = gql`
    query GateControllerSummary {
  CLOSED: gateControllers(
    query: {filters: [{operator: EQUALS, field: "status", value: "CLOSED"}]}
  ) {
    totalCount
  }
  OPEN_OUTBOUND: gateControllers(
    query: {filters: [{operator: EQUALS, field: "status", value: "OPEN_OUTBOUND"}]}
  ) {
    totalCount
  }
  OPEN_INBOUND: gateControllers(
    query: {filters: [{operator: EQUALS, field: "status", value: "OPEN_INBOUND"}]}
  ) {
    totalCount
  }
  MIXED: gateControllers(
    query: {filters: [{operator: EQUALS, field: "status", value: "MIXED"}]}
  ) {
    totalCount
  }
  UNKNOWN: gateControllers(
    query: {filters: [{operator: EQUALS, field: "status", value: "UNKNOWN"}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useGateControllerSummaryQuery__
 *
 * To run a query within a React component, call `useGateControllerSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGateControllerSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GateControllerSummaryQuery, GateControllerSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerSummaryQuery, GateControllerSummaryQueryVariables>(GateControllerSummaryDocument, options);
      }
export function useGateControllerSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerSummaryQuery, GateControllerSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerSummaryQuery, GateControllerSummaryQueryVariables>(GateControllerSummaryDocument, options);
        }
export type GateControllerSummaryQueryHookResult = ReturnType<typeof useGateControllerSummaryQuery>;
export type GateControllerSummaryLazyQueryHookResult = ReturnType<typeof useGateControllerSummaryLazyQuery>;
export type GateControllerSummaryQueryResult = Apollo.QueryResult<GateControllerSummaryQuery, GateControllerSummaryQueryVariables>;
export function refetchGateControllerSummaryQuery(variables?: GateControllerSummaryQueryVariables) {
      return { query: GateControllerSummaryDocument, variables: variables }
    }
export const GateOperationStepControllerDocument = gql`
    query GateOperationStepController($id: ID!) {
  gateController(id: $id) {
    entranceDirection
    status
    mode
    name
    id
  }
}
    `;

/**
 * __useGateOperationStepControllerQuery__
 *
 * To run a query within a React component, call `useGateOperationStepControllerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationStepControllerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationStepControllerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationStepControllerQuery(baseOptions: Apollo.QueryHookOptions<GateOperationStepControllerQuery, GateOperationStepControllerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationStepControllerQuery, GateOperationStepControllerQueryVariables>(GateOperationStepControllerDocument, options);
      }
export function useGateOperationStepControllerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationStepControllerQuery, GateOperationStepControllerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationStepControllerQuery, GateOperationStepControllerQueryVariables>(GateOperationStepControllerDocument, options);
        }
export type GateOperationStepControllerQueryHookResult = ReturnType<typeof useGateOperationStepControllerQuery>;
export type GateOperationStepControllerLazyQueryHookResult = ReturnType<typeof useGateOperationStepControllerLazyQuery>;
export type GateOperationStepControllerQueryResult = Apollo.QueryResult<GateOperationStepControllerQuery, GateOperationStepControllerQueryVariables>;
export function refetchGateOperationStepControllerQuery(variables: GateOperationStepControllerQueryVariables) {
      return { query: GateOperationStepControllerDocument, variables: variables }
    }
export const GateOperationDetailControllerDocument = gql`
    query GateOperationDetailController($id: ID!) {
  gateController(id: $id) {
    gateCameras {
      cameraId
    }
    gateSigns
    location
    gateArms {
      direction
      position
      location
      nativeId
      health
      name
    }
    id
  }
}
    `;

/**
 * __useGateOperationDetailControllerQuery__
 *
 * To run a query within a React component, call `useGateOperationDetailControllerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationDetailControllerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationDetailControllerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationDetailControllerQuery(baseOptions: Apollo.QueryHookOptions<GateOperationDetailControllerQuery, GateOperationDetailControllerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationDetailControllerQuery, GateOperationDetailControllerQueryVariables>(GateOperationDetailControllerDocument, options);
      }
export function useGateOperationDetailControllerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationDetailControllerQuery, GateOperationDetailControllerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationDetailControllerQuery, GateOperationDetailControllerQueryVariables>(GateOperationDetailControllerDocument, options);
        }
export type GateOperationDetailControllerQueryHookResult = ReturnType<typeof useGateOperationDetailControllerQuery>;
export type GateOperationDetailControllerLazyQueryHookResult = ReturnType<typeof useGateOperationDetailControllerLazyQuery>;
export type GateOperationDetailControllerQueryResult = Apollo.QueryResult<GateOperationDetailControllerQuery, GateOperationDetailControllerQueryVariables>;
export function refetchGateOperationDetailControllerQuery(variables: GateOperationDetailControllerQueryVariables) {
      return { query: GateOperationDetailControllerDocument, variables: variables }
    }
export const LiveGateOperationDetailControllerDocument = gql`
    subscription LiveGateOperationDetailController($id: ID!) {
  gateControllerUpdated(ids: [$id]) {
    gateCameras {
      cameraId
    }
    gateSigns
    location
    gateArms {
      direction
      position
      location
      nativeId
      health
      name
    }
    id
  }
}
    `;

/**
 * __useLiveGateOperationDetailControllerSubscription__
 *
 * To run a query within a React component, call `useLiveGateOperationDetailControllerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateOperationDetailControllerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateOperationDetailControllerSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveGateOperationDetailControllerSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateOperationDetailControllerSubscription, LiveGateOperationDetailControllerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateOperationDetailControllerSubscription, LiveGateOperationDetailControllerSubscriptionVariables>(LiveGateOperationDetailControllerDocument, options);
      }
export type LiveGateOperationDetailControllerSubscriptionHookResult = ReturnType<typeof useLiveGateOperationDetailControllerSubscription>;
export type LiveGateOperationDetailControllerSubscriptionResult = Apollo.SubscriptionResult<LiveGateOperationDetailControllerSubscription>;
export const GateControllerOperationAllowedDocument = gql`
    query GateControllerOperationAllowed($id: ID!, $type: GateOperationType!) {
  gateControllerOperationAllowed(id: $id, type: $type) {
    restrictionsBypassed
    restrictions {
      status
      name
      id
    }
    allowed
    name
    type
    id
  }
}
    `;

/**
 * __useGateControllerOperationAllowedQuery__
 *
 * To run a query within a React component, call `useGateControllerOperationAllowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerOperationAllowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerOperationAllowedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGateControllerOperationAllowedQuery(baseOptions: Apollo.QueryHookOptions<GateControllerOperationAllowedQuery, GateControllerOperationAllowedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerOperationAllowedQuery, GateControllerOperationAllowedQueryVariables>(GateControllerOperationAllowedDocument, options);
      }
export function useGateControllerOperationAllowedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerOperationAllowedQuery, GateControllerOperationAllowedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerOperationAllowedQuery, GateControllerOperationAllowedQueryVariables>(GateControllerOperationAllowedDocument, options);
        }
export type GateControllerOperationAllowedQueryHookResult = ReturnType<typeof useGateControllerOperationAllowedQuery>;
export type GateControllerOperationAllowedLazyQueryHookResult = ReturnType<typeof useGateControllerOperationAllowedLazyQuery>;
export type GateControllerOperationAllowedQueryResult = Apollo.QueryResult<GateControllerOperationAllowedQuery, GateControllerOperationAllowedQueryVariables>;
export function refetchGateControllerOperationAllowedQuery(variables: GateControllerOperationAllowedQueryVariables) {
      return { query: GateControllerOperationAllowedDocument, variables: variables }
    }
export const SaveGateControllerSignMessageDocument = gql`
    mutation SaveGateControllerSignMessage($input: GateControllerSignMessageInput!) {
  saveGateControllerSignMessage(input: $input) {
    id
  }
}
    `;
export type SaveGateControllerSignMessageMutationFn = Apollo.MutationFunction<SaveGateControllerSignMessageMutation, SaveGateControllerSignMessageMutationVariables>;

/**
 * __useSaveGateControllerSignMessageMutation__
 *
 * To run a mutation, you first call `useSaveGateControllerSignMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGateControllerSignMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGateControllerSignMessageMutation, { data, loading, error }] = useSaveGateControllerSignMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGateControllerSignMessageMutation(baseOptions?: Apollo.MutationHookOptions<SaveGateControllerSignMessageMutation, SaveGateControllerSignMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGateControllerSignMessageMutation, SaveGateControllerSignMessageMutationVariables>(SaveGateControllerSignMessageDocument, options);
      }
export type SaveGateControllerSignMessageMutationHookResult = ReturnType<typeof useSaveGateControllerSignMessageMutation>;
export type SaveGateControllerSignMessageMutationResult = Apollo.MutationResult<SaveGateControllerSignMessageMutation>;
export type SaveGateControllerSignMessageMutationOptions = Apollo.BaseMutationOptions<SaveGateControllerSignMessageMutation, SaveGateControllerSignMessageMutationVariables>;
export const DeleteGateControllerSignMessageDocument = gql`
    mutation DeleteGateControllerSignMessage($id: ID!) {
  deleteGateControllerSignMessage(id: $id)
}
    `;
export type DeleteGateControllerSignMessageMutationFn = Apollo.MutationFunction<DeleteGateControllerSignMessageMutation, DeleteGateControllerSignMessageMutationVariables>;

/**
 * __useDeleteGateControllerSignMessageMutation__
 *
 * To run a mutation, you first call `useDeleteGateControllerSignMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGateControllerSignMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGateControllerSignMessageMutation, { data, loading, error }] = useDeleteGateControllerSignMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGateControllerSignMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGateControllerSignMessageMutation, DeleteGateControllerSignMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGateControllerSignMessageMutation, DeleteGateControllerSignMessageMutationVariables>(DeleteGateControllerSignMessageDocument, options);
      }
export type DeleteGateControllerSignMessageMutationHookResult = ReturnType<typeof useDeleteGateControllerSignMessageMutation>;
export type DeleteGateControllerSignMessageMutationResult = Apollo.MutationResult<DeleteGateControllerSignMessageMutation>;
export type DeleteGateControllerSignMessageMutationOptions = Apollo.BaseMutationOptions<DeleteGateControllerSignMessageMutation, DeleteGateControllerSignMessageMutationVariables>;
export const ActivateGateSignMessagesDocument = gql`
    mutation ActivateGateSignMessages($id: ID!, $type: ID!, $blankBeforeDisplay: Boolean) {
  activateGateSignMessages(
    id: $id
    type: $type
    blankBeforeDisplay: $blankBeforeDisplay
  ) {
    requestId
    failure
    success
    id
  }
}
    `;
export type ActivateGateSignMessagesMutationFn = Apollo.MutationFunction<ActivateGateSignMessagesMutation, ActivateGateSignMessagesMutationVariables>;

/**
 * __useActivateGateSignMessagesMutation__
 *
 * To run a mutation, you first call `useActivateGateSignMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateGateSignMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateGateSignMessagesMutation, { data, loading, error }] = useActivateGateSignMessagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      blankBeforeDisplay: // value for 'blankBeforeDisplay'
 *   },
 * });
 */
export function useActivateGateSignMessagesMutation(baseOptions?: Apollo.MutationHookOptions<ActivateGateSignMessagesMutation, ActivateGateSignMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateGateSignMessagesMutation, ActivateGateSignMessagesMutationVariables>(ActivateGateSignMessagesDocument, options);
      }
export type ActivateGateSignMessagesMutationHookResult = ReturnType<typeof useActivateGateSignMessagesMutation>;
export type ActivateGateSignMessagesMutationResult = Apollo.MutationResult<ActivateGateSignMessagesMutation>;
export type ActivateGateSignMessagesMutationOptions = Apollo.BaseMutationOptions<ActivateGateSignMessagesMutation, ActivateGateSignMessagesMutationVariables>;
export const GateControllerSignMessagesListDocument = gql`
    query GateControllerSignMessagesList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  gateControllerSignMessages(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        message {
          ...SignMessage
        }
        controller
        type
        sign
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${SignMessageFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useGateControllerSignMessagesListQuery__
 *
 * To run a query within a React component, call `useGateControllerSignMessagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerSignMessagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerSignMessagesListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGateControllerSignMessagesListQuery(baseOptions?: Apollo.QueryHookOptions<GateControllerSignMessagesListQuery, GateControllerSignMessagesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerSignMessagesListQuery, GateControllerSignMessagesListQueryVariables>(GateControllerSignMessagesListDocument, options);
      }
export function useGateControllerSignMessagesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerSignMessagesListQuery, GateControllerSignMessagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerSignMessagesListQuery, GateControllerSignMessagesListQueryVariables>(GateControllerSignMessagesListDocument, options);
        }
export type GateControllerSignMessagesListQueryHookResult = ReturnType<typeof useGateControllerSignMessagesListQuery>;
export type GateControllerSignMessagesListLazyQueryHookResult = ReturnType<typeof useGateControllerSignMessagesListLazyQuery>;
export type GateControllerSignMessagesListQueryResult = Apollo.QueryResult<GateControllerSignMessagesListQuery, GateControllerSignMessagesListQueryVariables>;
export function refetchGateControllerSignMessagesListQuery(variables?: GateControllerSignMessagesListQueryVariables) {
      return { query: GateControllerSignMessagesListDocument, variables: variables }
    }
export const LiveGateControllerSignListDocument = gql`
    subscription LiveGateControllerSignList($ids: [ID!]) {
  gateControllerSignMessageUpdated(ids: $ids) {
    message {
      ...SignMessage
    }
    controller
    type
    sign
    id
  }
}
    ${SignMessageFragmentDoc}`;

/**
 * __useLiveGateControllerSignListSubscription__
 *
 * To run a query within a React component, call `useLiveGateControllerSignListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateControllerSignListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateControllerSignListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveGateControllerSignListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveGateControllerSignListSubscription, LiveGateControllerSignListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateControllerSignListSubscription, LiveGateControllerSignListSubscriptionVariables>(LiveGateControllerSignListDocument, options);
      }
export type LiveGateControllerSignListSubscriptionHookResult = ReturnType<typeof useLiveGateControllerSignListSubscription>;
export type LiveGateControllerSignListSubscriptionResult = Apollo.SubscriptionResult<LiveGateControllerSignListSubscription>;
export const GateControllerSignMessageDocument = gql`
    query GateControllerSignMessage($id: ID!) {
  gateControllerSignMessage(id: $id) {
    message {
      ...SignMessage
    }
    controller
    type
    sign
    id
  }
}
    ${SignMessageFragmentDoc}`;

/**
 * __useGateControllerSignMessageQuery__
 *
 * To run a query within a React component, call `useGateControllerSignMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerSignMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerSignMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerSignMessageQuery(baseOptions: Apollo.QueryHookOptions<GateControllerSignMessageQuery, GateControllerSignMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerSignMessageQuery, GateControllerSignMessageQueryVariables>(GateControllerSignMessageDocument, options);
      }
export function useGateControllerSignMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerSignMessageQuery, GateControllerSignMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerSignMessageQuery, GateControllerSignMessageQueryVariables>(GateControllerSignMessageDocument, options);
        }
export type GateControllerSignMessageQueryHookResult = ReturnType<typeof useGateControllerSignMessageQuery>;
export type GateControllerSignMessageLazyQueryHookResult = ReturnType<typeof useGateControllerSignMessageLazyQuery>;
export type GateControllerSignMessageQueryResult = Apollo.QueryResult<GateControllerSignMessageQuery, GateControllerSignMessageQueryVariables>;
export function refetchGateControllerSignMessageQuery(variables: GateControllerSignMessageQueryVariables) {
      return { query: GateControllerSignMessageDocument, variables: variables }
    }
export const GateOperationSignMessageCountDocument = gql`
    query GateOperationSignMessageCount($id: Object!, $type: Object!) {
  gateControllerSignMessages(
    query: {filters: [{value: $id, field: "controller", operator: EQUALS}, {value: $type, field: "type", operator: EQUALS}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useGateOperationSignMessageCountQuery__
 *
 * To run a query within a React component, call `useGateOperationSignMessageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationSignMessageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationSignMessageCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGateOperationSignMessageCountQuery(baseOptions: Apollo.QueryHookOptions<GateOperationSignMessageCountQuery, GateOperationSignMessageCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationSignMessageCountQuery, GateOperationSignMessageCountQueryVariables>(GateOperationSignMessageCountDocument, options);
      }
export function useGateOperationSignMessageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationSignMessageCountQuery, GateOperationSignMessageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationSignMessageCountQuery, GateOperationSignMessageCountQueryVariables>(GateOperationSignMessageCountDocument, options);
        }
export type GateOperationSignMessageCountQueryHookResult = ReturnType<typeof useGateOperationSignMessageCountQuery>;
export type GateOperationSignMessageCountLazyQueryHookResult = ReturnType<typeof useGateOperationSignMessageCountLazyQuery>;
export type GateOperationSignMessageCountQueryResult = Apollo.QueryResult<GateOperationSignMessageCountQuery, GateOperationSignMessageCountQueryVariables>;
export function refetchGateOperationSignMessageCountQuery(variables: GateOperationSignMessageCountQueryVariables) {
      return { query: GateOperationSignMessageCountDocument, variables: variables }
    }
export const GateControllerSignListDocument = gql`
    query GateControllerSignList($searchFields: [String!] = ["name", "road", "direction", "referencePoint"], $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  signs(
    searchFields: $searchFields
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        currentMessage {
          ...SignQueuedMessage
        }
        displayType {
          ...SignDisplayType
        }
        communicationStatus
        lastDataReceived
        referencePoint
        colorScheme
        direction
        location
        road
        name
        id
        tests {
          ...SignTestsType
        }
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${SignQueuedMessageFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignTestsTypeFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useGateControllerSignListQuery__
 *
 * To run a query within a React component, call `useGateControllerSignListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerSignListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerSignListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGateControllerSignListQuery(baseOptions?: Apollo.QueryHookOptions<GateControllerSignListQuery, GateControllerSignListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerSignListQuery, GateControllerSignListQueryVariables>(GateControllerSignListDocument, options);
      }
export function useGateControllerSignListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerSignListQuery, GateControllerSignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerSignListQuery, GateControllerSignListQueryVariables>(GateControllerSignListDocument, options);
        }
export type GateControllerSignListQueryHookResult = ReturnType<typeof useGateControllerSignListQuery>;
export type GateControllerSignListLazyQueryHookResult = ReturnType<typeof useGateControllerSignListLazyQuery>;
export type GateControllerSignListQueryResult = Apollo.QueryResult<GateControllerSignListQuery, GateControllerSignListQueryVariables>;
export function refetchGateControllerSignListQuery(variables?: GateControllerSignListQueryVariables) {
      return { query: GateControllerSignListDocument, variables: variables }
    }
export const ListGateControllerSignListDocument = gql`
    subscription ListGateControllerSignList($ids: [ID!]!) {
  signUpdated(ids: $ids) {
    currentMessage {
      ...SignQueuedMessage
    }
    displayType {
      ...SignDisplayType
    }
    communicationStatus
    lastDataReceived
    referencePoint
    colorScheme
    direction
    location
    road
    name
    id
    tests {
      ...SignTestsType
    }
  }
}
    ${SignQueuedMessageFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignTestsTypeFragmentDoc}`;

/**
 * __useListGateControllerSignListSubscription__
 *
 * To run a query within a React component, call `useListGateControllerSignListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListGateControllerSignListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGateControllerSignListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useListGateControllerSignListSubscription(baseOptions: Apollo.SubscriptionHookOptions<ListGateControllerSignListSubscription, ListGateControllerSignListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ListGateControllerSignListSubscription, ListGateControllerSignListSubscriptionVariables>(ListGateControllerSignListDocument, options);
      }
export type ListGateControllerSignListSubscriptionHookResult = ReturnType<typeof useListGateControllerSignListSubscription>;
export type ListGateControllerSignListSubscriptionResult = Apollo.SubscriptionResult<ListGateControllerSignListSubscription>;
export const GateControllerSignDocument = gql`
    query GateControllerSign($id: ID!) {
  sign(id: $id) {
    messagePreferences {
      ...SignMessagePreferences
    }
    currentMessage {
      ...SignQueuedMessage
    }
    displayType {
      ...SignDisplayType
    }
    communicationStatus
    locationDescription
    referencePoint
    capabilities
    backgroundColor
    foregroundColor
    colorScheme
    direction
    road
    name
    id
    tests {
      ...SignTestsType
    }
  }
}
    ${SignMessagePreferencesFragmentDoc}
${SignQueuedMessageFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignTestsTypeFragmentDoc}`;

/**
 * __useGateControllerSignQuery__
 *
 * To run a query within a React component, call `useGateControllerSignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateControllerSignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateControllerSignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateControllerSignQuery(baseOptions: Apollo.QueryHookOptions<GateControllerSignQuery, GateControllerSignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateControllerSignQuery, GateControllerSignQueryVariables>(GateControllerSignDocument, options);
      }
export function useGateControllerSignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateControllerSignQuery, GateControllerSignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateControllerSignQuery, GateControllerSignQueryVariables>(GateControllerSignDocument, options);
        }
export type GateControllerSignQueryHookResult = ReturnType<typeof useGateControllerSignQuery>;
export type GateControllerSignLazyQueryHookResult = ReturnType<typeof useGateControllerSignLazyQuery>;
export type GateControllerSignQueryResult = Apollo.QueryResult<GateControllerSignQuery, GateControllerSignQueryVariables>;
export function refetchGateControllerSignQuery(variables: GateControllerSignQueryVariables) {
      return { query: GateControllerSignDocument, variables: variables }
    }
export const LiveGateControllerSignDocument = gql`
    subscription LiveGateControllerSign($id: ID!) {
  signUpdated(ids: [$id]) {
    messagePreferences {
      ...SignMessagePreferences
    }
    currentMessage {
      ...SignQueuedMessage
    }
    displayType {
      ...SignDisplayType
    }
    communicationStatus
    locationDescription
    referencePoint
    capabilities
    direction
    road
    name
    id
    tests {
      ...SignTestsType
    }
  }
}
    ${SignMessagePreferencesFragmentDoc}
${SignQueuedMessageFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignTestsTypeFragmentDoc}`;

/**
 * __useLiveGateControllerSignSubscription__
 *
 * To run a query within a React component, call `useLiveGateControllerSignSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateControllerSignSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateControllerSignSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveGateControllerSignSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateControllerSignSubscription, LiveGateControllerSignSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateControllerSignSubscription, LiveGateControllerSignSubscriptionVariables>(LiveGateControllerSignDocument, options);
      }
export type LiveGateControllerSignSubscriptionHookResult = ReturnType<typeof useLiveGateControllerSignSubscription>;
export type LiveGateControllerSignSubscriptionResult = Apollo.SubscriptionResult<LiveGateControllerSignSubscription>;
export const GateOperationSignDocument = gql`
    query GateOperationSign($id: ID!) {
  sign(id: $id) {
    currentMessage {
      ...SignQueuedMessage
    }
    displayType {
      ...SignDisplayType
    }
    communicationStatus
    referencePoint
    capabilities
    backgroundColor
    foregroundColor
    direction
    road
    name
    id
    tests {
      ...SignTestsType
    }
  }
}
    ${SignQueuedMessageFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignTestsTypeFragmentDoc}`;

/**
 * __useGateOperationSignQuery__
 *
 * To run a query within a React component, call `useGateOperationSignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationSignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationSignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationSignQuery(baseOptions: Apollo.QueryHookOptions<GateOperationSignQuery, GateOperationSignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationSignQuery, GateOperationSignQueryVariables>(GateOperationSignDocument, options);
      }
export function useGateOperationSignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationSignQuery, GateOperationSignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationSignQuery, GateOperationSignQueryVariables>(GateOperationSignDocument, options);
        }
export type GateOperationSignQueryHookResult = ReturnType<typeof useGateOperationSignQuery>;
export type GateOperationSignLazyQueryHookResult = ReturnType<typeof useGateOperationSignLazyQuery>;
export type GateOperationSignQueryResult = Apollo.QueryResult<GateOperationSignQuery, GateOperationSignQueryVariables>;
export function refetchGateOperationSignQuery(variables: GateOperationSignQueryVariables) {
      return { query: GateOperationSignDocument, variables: variables }
    }
export const LiveGateOperationSignDocument = gql`
    subscription LiveGateOperationSign($id: ID!) {
  signUpdated(ids: [$id]) {
    currentMessage {
      ...SignQueuedMessage
    }
    displayType {
      ...SignDisplayType
    }
    communicationStatus
    referencePoint
    capabilities
    direction
    road
    name
    id
    tests {
      ...SignTestsType
    }
  }
}
    ${SignQueuedMessageFragmentDoc}
${SignDisplayTypeFragmentDoc}
${SignTestsTypeFragmentDoc}`;

/**
 * __useLiveGateOperationSignSubscription__
 *
 * To run a query within a React component, call `useLiveGateOperationSignSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateOperationSignSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateOperationSignSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveGateOperationSignSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateOperationSignSubscription, LiveGateOperationSignSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateOperationSignSubscription, LiveGateOperationSignSubscriptionVariables>(LiveGateOperationSignDocument, options);
      }
export type LiveGateOperationSignSubscriptionHookResult = ReturnType<typeof useLiveGateOperationSignSubscription>;
export type LiveGateOperationSignSubscriptionResult = Apollo.SubscriptionResult<LiveGateOperationSignSubscription>;
export const SaveGateSystemDocument = gql`
    mutation SaveGateSystem($input: GateControllerSystemInput!) {
  saveGateControllerSystem(input: $input) {
    id
  }
}
    `;
export type SaveGateSystemMutationFn = Apollo.MutationFunction<SaveGateSystemMutation, SaveGateSystemMutationVariables>;

/**
 * __useSaveGateSystemMutation__
 *
 * To run a mutation, you first call `useSaveGateSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGateSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGateSystemMutation, { data, loading, error }] = useSaveGateSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGateSystemMutation(baseOptions?: Apollo.MutationHookOptions<SaveGateSystemMutation, SaveGateSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGateSystemMutation, SaveGateSystemMutationVariables>(SaveGateSystemDocument, options);
      }
export type SaveGateSystemMutationHookResult = ReturnType<typeof useSaveGateSystemMutation>;
export type SaveGateSystemMutationResult = Apollo.MutationResult<SaveGateSystemMutation>;
export type SaveGateSystemMutationOptions = Apollo.BaseMutationOptions<SaveGateSystemMutation, SaveGateSystemMutationVariables>;
export const DeleteGateSystemDocument = gql`
    mutation DeleteGateSystem($id: ID!) {
  deleteGateControllerSystem(id: $id)
}
    `;
export type DeleteGateSystemMutationFn = Apollo.MutationFunction<DeleteGateSystemMutation, DeleteGateSystemMutationVariables>;

/**
 * __useDeleteGateSystemMutation__
 *
 * To run a mutation, you first call `useDeleteGateSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGateSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGateSystemMutation, { data, loading, error }] = useDeleteGateSystemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGateSystemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGateSystemMutation, DeleteGateSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGateSystemMutation, DeleteGateSystemMutationVariables>(DeleteGateSystemDocument, options);
      }
export type DeleteGateSystemMutationHookResult = ReturnType<typeof useDeleteGateSystemMutation>;
export type DeleteGateSystemMutationResult = Apollo.MutationResult<DeleteGateSystemMutation>;
export type DeleteGateSystemMutationOptions = Apollo.BaseMutationOptions<DeleteGateSystemMutation, DeleteGateSystemMutationVariables>;
export const DeleteGateControllerSystemDocument = gql`
    mutation DeleteGateControllerSystem($id: ID!) {
  deleteGateControllerSystem(id: $id)
}
    `;
export type DeleteGateControllerSystemMutationFn = Apollo.MutationFunction<DeleteGateControllerSystemMutation, DeleteGateControllerSystemMutationVariables>;

/**
 * __useDeleteGateControllerSystemMutation__
 *
 * To run a mutation, you first call `useDeleteGateControllerSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGateControllerSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGateControllerSystemMutation, { data, loading, error }] = useDeleteGateControllerSystemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGateControllerSystemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGateControllerSystemMutation, DeleteGateControllerSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGateControllerSystemMutation, DeleteGateControllerSystemMutationVariables>(DeleteGateControllerSystemDocument, options);
      }
export type DeleteGateControllerSystemMutationHookResult = ReturnType<typeof useDeleteGateControllerSystemMutation>;
export type DeleteGateControllerSystemMutationResult = Apollo.MutationResult<DeleteGateControllerSystemMutation>;
export type DeleteGateControllerSystemMutationOptions = Apollo.BaseMutationOptions<DeleteGateControllerSystemMutation, DeleteGateControllerSystemMutationVariables>;
export const GateSystemListDocument = gql`
    query GateSystemList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  gateControllerSystems(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        outboundDirection
        inboundDirection
        activeOperation
        description
        status
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGateSystemListQuery__
 *
 * To run a query within a React component, call `useGateSystemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGateSystemListQuery(baseOptions?: Apollo.QueryHookOptions<GateSystemListQuery, GateSystemListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemListQuery, GateSystemListQueryVariables>(GateSystemListDocument, options);
      }
export function useGateSystemListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemListQuery, GateSystemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemListQuery, GateSystemListQueryVariables>(GateSystemListDocument, options);
        }
export type GateSystemListQueryHookResult = ReturnType<typeof useGateSystemListQuery>;
export type GateSystemListLazyQueryHookResult = ReturnType<typeof useGateSystemListLazyQuery>;
export type GateSystemListQueryResult = Apollo.QueryResult<GateSystemListQuery, GateSystemListQueryVariables>;
export function refetchGateSystemListQuery(variables?: GateSystemListQueryVariables) {
      return { query: GateSystemListDocument, variables: variables }
    }
export const LiveGateSystemListDocument = gql`
    subscription LiveGateSystemList($ids: [ID!]) {
  gateControllerSystemUpdated(ids: $ids) {
    outboundDirection
    inboundDirection
    activeOperation
    description
    status
    name
    id
  }
}
    `;

/**
 * __useLiveGateSystemListSubscription__
 *
 * To run a query within a React component, call `useLiveGateSystemListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateSystemListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateSystemListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveGateSystemListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveGateSystemListSubscription, LiveGateSystemListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateSystemListSubscription, LiveGateSystemListSubscriptionVariables>(LiveGateSystemListDocument, options);
      }
export type LiveGateSystemListSubscriptionHookResult = ReturnType<typeof useLiveGateSystemListSubscription>;
export type LiveGateSystemListSubscriptionResult = Apollo.SubscriptionResult<LiveGateSystemListSubscription>;
export const GateSystemSimpleListDocument = gql`
    query GateSystemSimpleList($searchText: String, $sortOrder: SortOrder = ASCENDING, $sortField: String = "id") {
  gateControllerSystems(
    query: {sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText}
  ) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGateSystemSimpleListQuery__
 *
 * To run a query within a React component, call `useGateSystemSimpleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemSimpleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemSimpleListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useGateSystemSimpleListQuery(baseOptions?: Apollo.QueryHookOptions<GateSystemSimpleListQuery, GateSystemSimpleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemSimpleListQuery, GateSystemSimpleListQueryVariables>(GateSystemSimpleListDocument, options);
      }
export function useGateSystemSimpleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemSimpleListQuery, GateSystemSimpleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemSimpleListQuery, GateSystemSimpleListQueryVariables>(GateSystemSimpleListDocument, options);
        }
export type GateSystemSimpleListQueryHookResult = ReturnType<typeof useGateSystemSimpleListQuery>;
export type GateSystemSimpleListLazyQueryHookResult = ReturnType<typeof useGateSystemSimpleListLazyQuery>;
export type GateSystemSimpleListQueryResult = Apollo.QueryResult<GateSystemSimpleListQuery, GateSystemSimpleListQueryVariables>;
export function refetchGateSystemSimpleListQuery(variables?: GateSystemSimpleListQueryVariables) {
      return { query: GateSystemSimpleListDocument, variables: variables }
    }
export const GateSystemDocument = gql`
    query GateSystem($id: ID!) {
  gateControllerSystem(id: $id) {
    outboundControllers
    minReversalTimeSecs
    inboundControllers
    outboundDirection
    inboundDirection
    managingUser
    description
    tollPoints
    settings
    routes
    signs
    operations {
      droppable
      parent
      data
      text
      id
    }
    groups {
      referencePoint
      controllers
      tollPoints
      direction
      rampType
      position
      signs
      name
      id
    }
    name
    id
    detectors
    alertIntegrations
  }
}
    `;

/**
 * __useGateSystemQuery__
 *
 * To run a query within a React component, call `useGateSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSystemQuery(baseOptions: Apollo.QueryHookOptions<GateSystemQuery, GateSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemQuery, GateSystemQueryVariables>(GateSystemDocument, options);
      }
export function useGateSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemQuery, GateSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemQuery, GateSystemQueryVariables>(GateSystemDocument, options);
        }
export type GateSystemQueryHookResult = ReturnType<typeof useGateSystemQuery>;
export type GateSystemLazyQueryHookResult = ReturnType<typeof useGateSystemLazyQuery>;
export type GateSystemQueryResult = Apollo.QueryResult<GateSystemQuery, GateSystemQueryVariables>;
export function refetchGateSystemQuery(variables: GateSystemQueryVariables) {
      return { query: GateSystemDocument, variables: variables }
    }
export const LiveGateSystemDocument = gql`
    subscription LiveGateSystem($id: ID!) {
  gateControllerSystemUpdated(ids: [$id]) {
    outboundDirection
    inboundDirection
    managingUser
    description
    inboundControllers
    outboundControllers
    name
    id
  }
}
    `;

/**
 * __useLiveGateSystemSubscription__
 *
 * To run a query within a React component, call `useLiveGateSystemSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateSystemSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateSystemSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveGateSystemSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateSystemSubscription, LiveGateSystemSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateSystemSubscription, LiveGateSystemSubscriptionVariables>(LiveGateSystemDocument, options);
      }
export type LiveGateSystemSubscriptionHookResult = ReturnType<typeof useLiveGateSystemSubscription>;
export type LiveGateSystemSubscriptionResult = Apollo.SubscriptionResult<LiveGateSystemSubscription>;
export const DataSourceNameDocument = gql`
    query DataSourceName($id: ID!) {
  dataSource(id: $id) {
    value
  }
}
    `;

/**
 * __useDataSourceNameQuery__
 *
 * To run a query within a React component, call `useDataSourceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataSourceNameQuery(baseOptions: Apollo.QueryHookOptions<DataSourceNameQuery, DataSourceNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceNameQuery, DataSourceNameQueryVariables>(DataSourceNameDocument, options);
      }
export function useDataSourceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceNameQuery, DataSourceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceNameQuery, DataSourceNameQueryVariables>(DataSourceNameDocument, options);
        }
export type DataSourceNameQueryHookResult = ReturnType<typeof useDataSourceNameQuery>;
export type DataSourceNameLazyQueryHookResult = ReturnType<typeof useDataSourceNameLazyQuery>;
export type DataSourceNameQueryResult = Apollo.QueryResult<DataSourceNameQuery, DataSourceNameQueryVariables>;
export function refetchDataSourceNameQuery(variables: DataSourceNameQueryVariables) {
      return { query: DataSourceNameDocument, variables: variables }
    }
export const IntegrationNameDocument = gql`
    query IntegrationName($id: ID!) {
  integration(id: $id) {
    name
  }
}
    `;

/**
 * __useIntegrationNameQuery__
 *
 * To run a query within a React component, call `useIntegrationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationNameQuery(baseOptions: Apollo.QueryHookOptions<IntegrationNameQuery, IntegrationNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationNameQuery, IntegrationNameQueryVariables>(IntegrationNameDocument, options);
      }
export function useIntegrationNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationNameQuery, IntegrationNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationNameQuery, IntegrationNameQueryVariables>(IntegrationNameDocument, options);
        }
export type IntegrationNameQueryHookResult = ReturnType<typeof useIntegrationNameQuery>;
export type IntegrationNameLazyQueryHookResult = ReturnType<typeof useIntegrationNameLazyQuery>;
export type IntegrationNameQueryResult = Apollo.QueryResult<IntegrationNameQuery, IntegrationNameQueryVariables>;
export function refetchIntegrationNameQuery(variables: IntegrationNameQueryVariables) {
      return { query: IntegrationNameDocument, variables: variables }
    }
export const GateOperationSystemDocument = gql`
    query GateOperationSystem($id: ID!) {
  gateControllerSystem(id: $id) {
    name
    id
  }
}
    `;

/**
 * __useGateOperationSystemQuery__
 *
 * To run a query within a React component, call `useGateOperationSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationSystemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationSystemQuery(baseOptions: Apollo.QueryHookOptions<GateOperationSystemQuery, GateOperationSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationSystemQuery, GateOperationSystemQueryVariables>(GateOperationSystemDocument, options);
      }
export function useGateOperationSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationSystemQuery, GateOperationSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationSystemQuery, GateOperationSystemQueryVariables>(GateOperationSystemDocument, options);
        }
export type GateOperationSystemQueryHookResult = ReturnType<typeof useGateOperationSystemQuery>;
export type GateOperationSystemLazyQueryHookResult = ReturnType<typeof useGateOperationSystemLazyQuery>;
export type GateOperationSystemQueryResult = Apollo.QueryResult<GateOperationSystemQuery, GateOperationSystemQueryVariables>;
export function refetchGateOperationSystemQuery(variables: GateOperationSystemQueryVariables) {
      return { query: GateOperationSystemDocument, variables: variables }
    }
export const GateSystemControllerSearchListDocument = gql`
    query GateSystemControllerSearchList($filters: [FilterInput], $limit: Int = 100) {
  gateControllerSystems(query: {filters: $filters, limit: $limit}) {
    edges {
      node {
        outboundDirection
        inboundDirection
        inboundControllers
        outboundControllers
      }
    }
  }
}
    `;

/**
 * __useGateSystemControllerSearchListQuery__
 *
 * To run a query within a React component, call `useGateSystemControllerSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemControllerSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemControllerSearchListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGateSystemControllerSearchListQuery(baseOptions?: Apollo.QueryHookOptions<GateSystemControllerSearchListQuery, GateSystemControllerSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemControllerSearchListQuery, GateSystemControllerSearchListQueryVariables>(GateSystemControllerSearchListDocument, options);
      }
export function useGateSystemControllerSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemControllerSearchListQuery, GateSystemControllerSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemControllerSearchListQuery, GateSystemControllerSearchListQueryVariables>(GateSystemControllerSearchListDocument, options);
        }
export type GateSystemControllerSearchListQueryHookResult = ReturnType<typeof useGateSystemControllerSearchListQuery>;
export type GateSystemControllerSearchListLazyQueryHookResult = ReturnType<typeof useGateSystemControllerSearchListLazyQuery>;
export type GateSystemControllerSearchListQueryResult = Apollo.QueryResult<GateSystemControllerSearchListQuery, GateSystemControllerSearchListQueryVariables>;
export function refetchGateSystemControllerSearchListQuery(variables?: GateSystemControllerSearchListQueryVariables) {
      return { query: GateSystemControllerSearchListDocument, variables: variables }
    }
export const GateSystemDetailsDocument = gql`
    query GateSystemDetails($id: ID!) {
  gateControllerSystem(id: $id) {
    description
    name
    id
  }
}
    `;

/**
 * __useGateSystemDetailsQuery__
 *
 * To run a query within a React component, call `useGateSystemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSystemDetailsQuery(baseOptions: Apollo.QueryHookOptions<GateSystemDetailsQuery, GateSystemDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemDetailsQuery, GateSystemDetailsQueryVariables>(GateSystemDetailsDocument, options);
      }
export function useGateSystemDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemDetailsQuery, GateSystemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemDetailsQuery, GateSystemDetailsQueryVariables>(GateSystemDetailsDocument, options);
        }
export type GateSystemDetailsQueryHookResult = ReturnType<typeof useGateSystemDetailsQuery>;
export type GateSystemDetailsLazyQueryHookResult = ReturnType<typeof useGateSystemDetailsLazyQuery>;
export type GateSystemDetailsQueryResult = Apollo.QueryResult<GateSystemDetailsQuery, GateSystemDetailsQueryVariables>;
export function refetchGateSystemDetailsQuery(variables: GateSystemDetailsQueryVariables) {
      return { query: GateSystemDetailsDocument, variables: variables }
    }
export const GateSystemSchematicDocument = gql`
    query GateSystemSchematic($id: ID!) {
  gateControllerSystem(id: $id) {
    outboundDirection
    inboundDirection
    status
    groups {
      controllers
      tollPoints
      direction
      rampType
      position
      signs
      name
      id
    }
  }
}
    `;

/**
 * __useGateSystemSchematicQuery__
 *
 * To run a query within a React component, call `useGateSystemSchematicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemSchematicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemSchematicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSystemSchematicQuery(baseOptions: Apollo.QueryHookOptions<GateSystemSchematicQuery, GateSystemSchematicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemSchematicQuery, GateSystemSchematicQueryVariables>(GateSystemSchematicDocument, options);
      }
export function useGateSystemSchematicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemSchematicQuery, GateSystemSchematicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemSchematicQuery, GateSystemSchematicQueryVariables>(GateSystemSchematicDocument, options);
        }
export type GateSystemSchematicQueryHookResult = ReturnType<typeof useGateSystemSchematicQuery>;
export type GateSystemSchematicLazyQueryHookResult = ReturnType<typeof useGateSystemSchematicLazyQuery>;
export type GateSystemSchematicQueryResult = Apollo.QueryResult<GateSystemSchematicQuery, GateSystemSchematicQueryVariables>;
export function refetchGateSystemSchematicQuery(variables: GateSystemSchematicQueryVariables) {
      return { query: GateSystemSchematicDocument, variables: variables }
    }
export const GateSystemDetailsControllersDocument = gql`
    query GateSystemDetailsControllers($id: ID!) {
  gateControllerSystem(id: $id) {
    outboundControllers
    inboundControllers
  }
}
    `;

/**
 * __useGateSystemDetailsControllersQuery__
 *
 * To run a query within a React component, call `useGateSystemDetailsControllersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemDetailsControllersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemDetailsControllersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSystemDetailsControllersQuery(baseOptions: Apollo.QueryHookOptions<GateSystemDetailsControllersQuery, GateSystemDetailsControllersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemDetailsControllersQuery, GateSystemDetailsControllersQueryVariables>(GateSystemDetailsControllersDocument, options);
      }
export function useGateSystemDetailsControllersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemDetailsControllersQuery, GateSystemDetailsControllersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemDetailsControllersQuery, GateSystemDetailsControllersQueryVariables>(GateSystemDetailsControllersDocument, options);
        }
export type GateSystemDetailsControllersQueryHookResult = ReturnType<typeof useGateSystemDetailsControllersQuery>;
export type GateSystemDetailsControllersLazyQueryHookResult = ReturnType<typeof useGateSystemDetailsControllersLazyQuery>;
export type GateSystemDetailsControllersQueryResult = Apollo.QueryResult<GateSystemDetailsControllersQuery, GateSystemDetailsControllersQueryVariables>;
export function refetchGateSystemDetailsControllersQuery(variables: GateSystemDetailsControllersQueryVariables) {
      return { query: GateSystemDetailsControllersDocument, variables: variables }
    }
export const GateSystemDetailsTollPointsDocument = gql`
    query GateSystemDetailsTollPoints($id: ID!) {
  gateControllerSystem(id: $id) {
    tollPoints
  }
}
    `;

/**
 * __useGateSystemDetailsTollPointsQuery__
 *
 * To run a query within a React component, call `useGateSystemDetailsTollPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemDetailsTollPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemDetailsTollPointsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSystemDetailsTollPointsQuery(baseOptions: Apollo.QueryHookOptions<GateSystemDetailsTollPointsQuery, GateSystemDetailsTollPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemDetailsTollPointsQuery, GateSystemDetailsTollPointsQueryVariables>(GateSystemDetailsTollPointsDocument, options);
      }
export function useGateSystemDetailsTollPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemDetailsTollPointsQuery, GateSystemDetailsTollPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemDetailsTollPointsQuery, GateSystemDetailsTollPointsQueryVariables>(GateSystemDetailsTollPointsDocument, options);
        }
export type GateSystemDetailsTollPointsQueryHookResult = ReturnType<typeof useGateSystemDetailsTollPointsQuery>;
export type GateSystemDetailsTollPointsLazyQueryHookResult = ReturnType<typeof useGateSystemDetailsTollPointsLazyQuery>;
export type GateSystemDetailsTollPointsQueryResult = Apollo.QueryResult<GateSystemDetailsTollPointsQuery, GateSystemDetailsTollPointsQueryVariables>;
export function refetchGateSystemDetailsTollPointsQuery(variables: GateSystemDetailsTollPointsQueryVariables) {
      return { query: GateSystemDetailsTollPointsDocument, variables: variables }
    }
export const GateSystemDetailsControllersListDocument = gql`
    query GateSystemDetailsControllersList($searchFields: [String!] = ["name", "road", "direction", "entranceDirection", "status", "mode"], $sortOrder: SortOrder = ASCENDING, $filters: [FilterInput], $searchText: String, $sortField: String, $limit: Int = 10, $before: String, $after: String) {
  gateControllers(
    query: {searchFields: $searchFields, searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        communicationStatus
        entranceDirection
        operationStatus
        referencePoint
        direction
        interlock
        status
        mode
        road
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGateSystemDetailsControllersListQuery__
 *
 * To run a query within a React component, call `useGateSystemDetailsControllersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemDetailsControllersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemDetailsControllersListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGateSystemDetailsControllersListQuery(baseOptions?: Apollo.QueryHookOptions<GateSystemDetailsControllersListQuery, GateSystemDetailsControllersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemDetailsControllersListQuery, GateSystemDetailsControllersListQueryVariables>(GateSystemDetailsControllersListDocument, options);
      }
export function useGateSystemDetailsControllersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemDetailsControllersListQuery, GateSystemDetailsControllersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemDetailsControllersListQuery, GateSystemDetailsControllersListQueryVariables>(GateSystemDetailsControllersListDocument, options);
        }
export type GateSystemDetailsControllersListQueryHookResult = ReturnType<typeof useGateSystemDetailsControllersListQuery>;
export type GateSystemDetailsControllersListLazyQueryHookResult = ReturnType<typeof useGateSystemDetailsControllersListLazyQuery>;
export type GateSystemDetailsControllersListQueryResult = Apollo.QueryResult<GateSystemDetailsControllersListQuery, GateSystemDetailsControllersListQueryVariables>;
export function refetchGateSystemDetailsControllersListQuery(variables?: GateSystemDetailsControllersListQueryVariables) {
      return { query: GateSystemDetailsControllersListDocument, variables: variables }
    }
export const GateSystemTollPointsDocument = gql`
    query GateSystemTollPoints($tollPoints: Object!) {
  tollingPoints(
    query: {limit: 500, filters: [{field: "id", operator: IN, value: $tollPoints}]}
  ) {
    edges {
      node {
        id
        name
        road
        direction
        referencePoint
      }
    }
  }
}
    `;

/**
 * __useGateSystemTollPointsQuery__
 *
 * To run a query within a React component, call `useGateSystemTollPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemTollPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemTollPointsQuery({
 *   variables: {
 *      tollPoints: // value for 'tollPoints'
 *   },
 * });
 */
export function useGateSystemTollPointsQuery(baseOptions: Apollo.QueryHookOptions<GateSystemTollPointsQuery, GateSystemTollPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemTollPointsQuery, GateSystemTollPointsQueryVariables>(GateSystemTollPointsDocument, options);
      }
export function useGateSystemTollPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemTollPointsQuery, GateSystemTollPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemTollPointsQuery, GateSystemTollPointsQueryVariables>(GateSystemTollPointsDocument, options);
        }
export type GateSystemTollPointsQueryHookResult = ReturnType<typeof useGateSystemTollPointsQuery>;
export type GateSystemTollPointsLazyQueryHookResult = ReturnType<typeof useGateSystemTollPointsLazyQuery>;
export type GateSystemTollPointsQueryResult = Apollo.QueryResult<GateSystemTollPointsQuery, GateSystemTollPointsQueryVariables>;
export function refetchGateSystemTollPointsQuery(variables: GateSystemTollPointsQueryVariables) {
      return { query: GateSystemTollPointsDocument, variables: variables }
    }
export const GateSystemSignsDocument = gql`
    query GateSystemSigns($signs: Object!) {
  signs(limit: 1000, filters: [{field: "id", operator: IN, value: $signs}]) {
    edges {
      node {
        id
        name
        road
        direction
        referencePoint
      }
    }
  }
}
    `;

/**
 * __useGateSystemSignsQuery__
 *
 * To run a query within a React component, call `useGateSystemSignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemSignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemSignsQuery({
 *   variables: {
 *      signs: // value for 'signs'
 *   },
 * });
 */
export function useGateSystemSignsQuery(baseOptions: Apollo.QueryHookOptions<GateSystemSignsQuery, GateSystemSignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemSignsQuery, GateSystemSignsQueryVariables>(GateSystemSignsDocument, options);
      }
export function useGateSystemSignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemSignsQuery, GateSystemSignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemSignsQuery, GateSystemSignsQueryVariables>(GateSystemSignsDocument, options);
        }
export type GateSystemSignsQueryHookResult = ReturnType<typeof useGateSystemSignsQuery>;
export type GateSystemSignsLazyQueryHookResult = ReturnType<typeof useGateSystemSignsLazyQuery>;
export type GateSystemSignsQueryResult = Apollo.QueryResult<GateSystemSignsQuery, GateSystemSignsQueryVariables>;
export function refetchGateSystemSignsQuery(variables: GateSystemSignsQueryVariables) {
      return { query: GateSystemSignsDocument, variables: variables }
    }
export const GateSystemControllersDocument = gql`
    query GateSystemControllers($controllers: Object!) {
  gateControllers(
    query: {limit: 500, filters: [{field: "id", operator: IN, value: $controllers}]}
  ) {
    edges {
      node {
        id
        name
        road
        direction
        referencePoint
      }
    }
  }
}
    `;

/**
 * __useGateSystemControllersQuery__
 *
 * To run a query within a React component, call `useGateSystemControllersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemControllersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemControllersQuery({
 *   variables: {
 *      controllers: // value for 'controllers'
 *   },
 * });
 */
export function useGateSystemControllersQuery(baseOptions: Apollo.QueryHookOptions<GateSystemControllersQuery, GateSystemControllersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemControllersQuery, GateSystemControllersQueryVariables>(GateSystemControllersDocument, options);
      }
export function useGateSystemControllersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemControllersQuery, GateSystemControllersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemControllersQuery, GateSystemControllersQueryVariables>(GateSystemControllersDocument, options);
        }
export type GateSystemControllersQueryHookResult = ReturnType<typeof useGateSystemControllersQuery>;
export type GateSystemControllersLazyQueryHookResult = ReturnType<typeof useGateSystemControllersLazyQuery>;
export type GateSystemControllersQueryResult = Apollo.QueryResult<GateSystemControllersQuery, GateSystemControllersQueryVariables>;
export function refetchGateSystemControllersQuery(variables: GateSystemControllersQueryVariables) {
      return { query: GateSystemControllersDocument, variables: variables }
    }
export const GateSchematicControllerDocument = gql`
    query GateSchematicController($id: ID!) {
  gateController(id: $id) {
    communicationStatus
    entranceDirection
    operationStatus
    interlock
    status
    name
    mode
    id
  }
}
    `;

/**
 * __useGateSchematicControllerQuery__
 *
 * To run a query within a React component, call `useGateSchematicControllerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSchematicControllerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSchematicControllerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSchematicControllerQuery(baseOptions: Apollo.QueryHookOptions<GateSchematicControllerQuery, GateSchematicControllerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSchematicControllerQuery, GateSchematicControllerQueryVariables>(GateSchematicControllerDocument, options);
      }
export function useGateSchematicControllerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSchematicControllerQuery, GateSchematicControllerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSchematicControllerQuery, GateSchematicControllerQueryVariables>(GateSchematicControllerDocument, options);
        }
export type GateSchematicControllerQueryHookResult = ReturnType<typeof useGateSchematicControllerQuery>;
export type GateSchematicControllerLazyQueryHookResult = ReturnType<typeof useGateSchematicControllerLazyQuery>;
export type GateSchematicControllerQueryResult = Apollo.QueryResult<GateSchematicControllerQuery, GateSchematicControllerQueryVariables>;
export function refetchGateSchematicControllerQuery(variables: GateSchematicControllerQueryVariables) {
      return { query: GateSchematicControllerDocument, variables: variables }
    }
export const LiveGateSchematicControllerDocument = gql`
    subscription LiveGateSchematicController($id: ID!) {
  gateControllerUpdated(ids: [$id]) {
    communicationStatus
    entranceDirection
    operationStatus
    interlock
    status
    name
    mode
    id
  }
}
    `;

/**
 * __useLiveGateSchematicControllerSubscription__
 *
 * To run a query within a React component, call `useLiveGateSchematicControllerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateSchematicControllerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateSchematicControllerSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveGateSchematicControllerSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateSchematicControllerSubscription, LiveGateSchematicControllerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateSchematicControllerSubscription, LiveGateSchematicControllerSubscriptionVariables>(LiveGateSchematicControllerDocument, options);
      }
export type LiveGateSchematicControllerSubscriptionHookResult = ReturnType<typeof useLiveGateSchematicControllerSubscription>;
export type LiveGateSchematicControllerSubscriptionResult = Apollo.SubscriptionResult<LiveGateSchematicControllerSubscription>;
export const GateSystemSchematicGroupsDocument = gql`
    query GateSystemSchematicGroups($id: ID!) {
  gateSystemGroups(id: $id) {
    controllers
    direction
    rampType
    position
    status
    name
    id
  }
}
    `;

/**
 * __useGateSystemSchematicGroupsQuery__
 *
 * To run a query within a React component, call `useGateSystemSchematicGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemSchematicGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemSchematicGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSystemSchematicGroupsQuery(baseOptions: Apollo.QueryHookOptions<GateSystemSchematicGroupsQuery, GateSystemSchematicGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemSchematicGroupsQuery, GateSystemSchematicGroupsQueryVariables>(GateSystemSchematicGroupsDocument, options);
      }
export function useGateSystemSchematicGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemSchematicGroupsQuery, GateSystemSchematicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemSchematicGroupsQuery, GateSystemSchematicGroupsQueryVariables>(GateSystemSchematicGroupsDocument, options);
        }
export type GateSystemSchematicGroupsQueryHookResult = ReturnType<typeof useGateSystemSchematicGroupsQuery>;
export type GateSystemSchematicGroupsLazyQueryHookResult = ReturnType<typeof useGateSystemSchematicGroupsLazyQuery>;
export type GateSystemSchematicGroupsQueryResult = Apollo.QueryResult<GateSystemSchematicGroupsQuery, GateSystemSchematicGroupsQueryVariables>;
export function refetchGateSystemSchematicGroupsQuery(variables: GateSystemSchematicGroupsQueryVariables) {
      return { query: GateSystemSchematicGroupsDocument, variables: variables }
    }
export const GateSystemSchematicStatusDocument = gql`
    query GateSystemSchematicStatus($id: ID!) {
  gateControllerSystem(id: $id) {
    outboundDirection
    inboundDirection
    activeOperation
    status
  }
}
    `;

/**
 * __useGateSystemSchematicStatusQuery__
 *
 * To run a query within a React component, call `useGateSystemSchematicStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemSchematicStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemSchematicStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSystemSchematicStatusQuery(baseOptions: Apollo.QueryHookOptions<GateSystemSchematicStatusQuery, GateSystemSchematicStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemSchematicStatusQuery, GateSystemSchematicStatusQueryVariables>(GateSystemSchematicStatusDocument, options);
      }
export function useGateSystemSchematicStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemSchematicStatusQuery, GateSystemSchematicStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemSchematicStatusQuery, GateSystemSchematicStatusQueryVariables>(GateSystemSchematicStatusDocument, options);
        }
export type GateSystemSchematicStatusQueryHookResult = ReturnType<typeof useGateSystemSchematicStatusQuery>;
export type GateSystemSchematicStatusLazyQueryHookResult = ReturnType<typeof useGateSystemSchematicStatusLazyQuery>;
export type GateSystemSchematicStatusQueryResult = Apollo.QueryResult<GateSystemSchematicStatusQuery, GateSystemSchematicStatusQueryVariables>;
export function refetchGateSystemSchematicStatusQuery(variables: GateSystemSchematicStatusQueryVariables) {
      return { query: GateSystemSchematicStatusDocument, variables: variables }
    }
export const LiveGateSystemSchematicDocument = gql`
    subscription LiveGateSystemSchematic($id: ID!) {
  gateControllerSystemUpdated(ids: [$id]) {
    status
  }
}
    `;

/**
 * __useLiveGateSystemSchematicSubscription__
 *
 * To run a query within a React component, call `useLiveGateSystemSchematicSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateSystemSchematicSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateSystemSchematicSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveGateSystemSchematicSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateSystemSchematicSubscription, LiveGateSystemSchematicSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateSystemSchematicSubscription, LiveGateSystemSchematicSubscriptionVariables>(LiveGateSystemSchematicDocument, options);
      }
export type LiveGateSystemSchematicSubscriptionHookResult = ReturnType<typeof useLiveGateSystemSchematicSubscription>;
export type LiveGateSystemSchematicSubscriptionResult = Apollo.SubscriptionResult<LiveGateSystemSchematicSubscription>;
export const LiveGateGroupSchematicDocument = gql`
    subscription LiveGateGroupSchematic($ids: [ID!]!) {
  gateGroupUpdated(ids: $ids) {
    id
  }
}
    `;

/**
 * __useLiveGateGroupSchematicSubscription__
 *
 * To run a query within a React component, call `useLiveGateGroupSchematicSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateGroupSchematicSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateGroupSchematicSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveGateGroupSchematicSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateGroupSchematicSubscription, LiveGateGroupSchematicSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateGroupSchematicSubscription, LiveGateGroupSchematicSubscriptionVariables>(LiveGateGroupSchematicDocument, options);
      }
export type LiveGateGroupSchematicSubscriptionHookResult = ReturnType<typeof useLiveGateGroupSchematicSubscription>;
export type LiveGateGroupSchematicSubscriptionResult = Apollo.SubscriptionResult<LiveGateGroupSchematicSubscription>;
export const GateSystemRoutesDocument = gql`
    query GateSystemRoutes($routes: Object!) {
  locationRoutes(
    query: {limit: 500, filters: [{field: "id", operator: IN, value: $routes}]}
  ) {
    edges {
      node {
        id
        name
        direction
      }
    }
  }
}
    `;

/**
 * __useGateSystemRoutesQuery__
 *
 * To run a query within a React component, call `useGateSystemRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemRoutesQuery({
 *   variables: {
 *      routes: // value for 'routes'
 *   },
 * });
 */
export function useGateSystemRoutesQuery(baseOptions: Apollo.QueryHookOptions<GateSystemRoutesQuery, GateSystemRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemRoutesQuery, GateSystemRoutesQueryVariables>(GateSystemRoutesDocument, options);
      }
export function useGateSystemRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemRoutesQuery, GateSystemRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemRoutesQuery, GateSystemRoutesQueryVariables>(GateSystemRoutesDocument, options);
        }
export type GateSystemRoutesQueryHookResult = ReturnType<typeof useGateSystemRoutesQuery>;
export type GateSystemRoutesLazyQueryHookResult = ReturnType<typeof useGateSystemRoutesLazyQuery>;
export type GateSystemRoutesQueryResult = Apollo.QueryResult<GateSystemRoutesQuery, GateSystemRoutesQueryVariables>;
export function refetchGateSystemRoutesQuery(variables: GateSystemRoutesQueryVariables) {
      return { query: GateSystemRoutesDocument, variables: variables }
    }
export const GateSystemDetectorsDocument = gql`
    query GateSystemDetectors($id: ID!) {
  gateControllerSystem(id: $id) {
    id
    detectors
  }
}
    `;

/**
 * __useGateSystemDetectorsQuery__
 *
 * To run a query within a React component, call `useGateSystemDetectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemDetectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemDetectorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSystemDetectorsQuery(baseOptions: Apollo.QueryHookOptions<GateSystemDetectorsQuery, GateSystemDetectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemDetectorsQuery, GateSystemDetectorsQueryVariables>(GateSystemDetectorsDocument, options);
      }
export function useGateSystemDetectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemDetectorsQuery, GateSystemDetectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemDetectorsQuery, GateSystemDetectorsQueryVariables>(GateSystemDetectorsDocument, options);
        }
export type GateSystemDetectorsQueryHookResult = ReturnType<typeof useGateSystemDetectorsQuery>;
export type GateSystemDetectorsLazyQueryHookResult = ReturnType<typeof useGateSystemDetectorsLazyQuery>;
export type GateSystemDetectorsQueryResult = Apollo.QueryResult<GateSystemDetectorsQuery, GateSystemDetectorsQueryVariables>;
export function refetchGateSystemDetectorsQuery(variables: GateSystemDetectorsQueryVariables) {
      return { query: GateSystemDetectorsDocument, variables: variables }
    }
export const GateSystemAlertsDocument = gql`
    query GateSystemAlerts($id: ID!) {
  gateControllerSystem(id: $id) {
    id
    alertIntegrations
  }
}
    `;

/**
 * __useGateSystemAlertsQuery__
 *
 * To run a query within a React component, call `useGateSystemAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSystemAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSystemAlertsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSystemAlertsQuery(baseOptions: Apollo.QueryHookOptions<GateSystemAlertsQuery, GateSystemAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSystemAlertsQuery, GateSystemAlertsQueryVariables>(GateSystemAlertsDocument, options);
      }
export function useGateSystemAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSystemAlertsQuery, GateSystemAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSystemAlertsQuery, GateSystemAlertsQueryVariables>(GateSystemAlertsDocument, options);
        }
export type GateSystemAlertsQueryHookResult = ReturnType<typeof useGateSystemAlertsQuery>;
export type GateSystemAlertsLazyQueryHookResult = ReturnType<typeof useGateSystemAlertsLazyQuery>;
export type GateSystemAlertsQueryResult = Apollo.QueryResult<GateSystemAlertsQuery, GateSystemAlertsQueryVariables>;
export function refetchGateSystemAlertsQuery(variables: GateSystemAlertsQueryVariables) {
      return { query: GateSystemAlertsDocument, variables: variables }
    }
export const GateSafeReversalTimeDocument = gql`
    query GateSafeReversalTime($id: ID!) {
  gateSafeReversalTime(id: $id) {
    minReversalTimeInMillis
    remainingTimeInMillis
    disabled
  }
}
    `;

/**
 * __useGateSafeReversalTimeQuery__
 *
 * To run a query within a React component, call `useGateSafeReversalTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSafeReversalTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSafeReversalTimeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSafeReversalTimeQuery(baseOptions: Apollo.QueryHookOptions<GateSafeReversalTimeQuery, GateSafeReversalTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSafeReversalTimeQuery, GateSafeReversalTimeQueryVariables>(GateSafeReversalTimeDocument, options);
      }
export function useGateSafeReversalTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSafeReversalTimeQuery, GateSafeReversalTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSafeReversalTimeQuery, GateSafeReversalTimeQueryVariables>(GateSafeReversalTimeDocument, options);
        }
export type GateSafeReversalTimeQueryHookResult = ReturnType<typeof useGateSafeReversalTimeQuery>;
export type GateSafeReversalTimeLazyQueryHookResult = ReturnType<typeof useGateSafeReversalTimeLazyQuery>;
export type GateSafeReversalTimeQueryResult = Apollo.QueryResult<GateSafeReversalTimeQuery, GateSafeReversalTimeQueryVariables>;
export function refetchGateSafeReversalTimeQuery(variables: GateSafeReversalTimeQueryVariables) {
      return { query: GateSafeReversalTimeDocument, variables: variables }
    }
export const ViewGateSchematicEntitiesDocument = gql`
    query ViewGateSchematicEntities($id: ID!, $integrationIds: Object!, $integrationCount: Int!) {
  gateSystemGroups(id: $id) {
    controllers
    direction
    rampType
    position
    status
    name
    id
  }
  gateControllers(
    query: {filters: [{operator: IN, value: $integrationIds, field: "id"}], limit: $integrationCount}
  ) {
    edges {
      node {
        communicationStatus
        entranceDirection
        systemEnabled
        status
        name
        mode
        id
      }
    }
  }
}
    `;

/**
 * __useViewGateSchematicEntitiesQuery__
 *
 * To run a query within a React component, call `useViewGateSchematicEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewGateSchematicEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewGateSchematicEntitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      integrationIds: // value for 'integrationIds'
 *      integrationCount: // value for 'integrationCount'
 *   },
 * });
 */
export function useViewGateSchematicEntitiesQuery(baseOptions: Apollo.QueryHookOptions<ViewGateSchematicEntitiesQuery, ViewGateSchematicEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewGateSchematicEntitiesQuery, ViewGateSchematicEntitiesQueryVariables>(ViewGateSchematicEntitiesDocument, options);
      }
export function useViewGateSchematicEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewGateSchematicEntitiesQuery, ViewGateSchematicEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewGateSchematicEntitiesQuery, ViewGateSchematicEntitiesQueryVariables>(ViewGateSchematicEntitiesDocument, options);
        }
export type ViewGateSchematicEntitiesQueryHookResult = ReturnType<typeof useViewGateSchematicEntitiesQuery>;
export type ViewGateSchematicEntitiesLazyQueryHookResult = ReturnType<typeof useViewGateSchematicEntitiesLazyQuery>;
export type ViewGateSchematicEntitiesQueryResult = Apollo.QueryResult<ViewGateSchematicEntitiesQuery, ViewGateSchematicEntitiesQueryVariables>;
export function refetchViewGateSchematicEntitiesQuery(variables: ViewGateSchematicEntitiesQueryVariables) {
      return { query: ViewGateSchematicEntitiesDocument, variables: variables }
    }
export const GateSchematicControllersDocument = gql`
    query GateSchematicControllers($id: ID!) {
  gateControllerSystem(id: $id) {
    outboundControllers
    inboundControllers
  }
}
    `;

/**
 * __useGateSchematicControllersQuery__
 *
 * To run a query within a React component, call `useGateSchematicControllersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateSchematicControllersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateSchematicControllersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateSchematicControllersQuery(baseOptions: Apollo.QueryHookOptions<GateSchematicControllersQuery, GateSchematicControllersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateSchematicControllersQuery, GateSchematicControllersQueryVariables>(GateSchematicControllersDocument, options);
      }
export function useGateSchematicControllersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateSchematicControllersQuery, GateSchematicControllersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateSchematicControllersQuery, GateSchematicControllersQueryVariables>(GateSchematicControllersDocument, options);
        }
export type GateSchematicControllersQueryHookResult = ReturnType<typeof useGateSchematicControllersQuery>;
export type GateSchematicControllersLazyQueryHookResult = ReturnType<typeof useGateSchematicControllersLazyQuery>;
export type GateSchematicControllersQueryResult = Apollo.QueryResult<GateSchematicControllersQuery, GateSchematicControllersQueryVariables>;
export function refetchGateSchematicControllersQuery(variables: GateSchematicControllersQueryVariables) {
      return { query: GateSchematicControllersDocument, variables: variables }
    }
export const LiveGateSchematicGateDocument = gql`
    subscription LiveGateSchematicGate($ids: [ID!]!) {
  gateControllerUpdated(ids: $ids) {
    communicationStatus
    entranceDirection
    systemEnabled
    status
    name
    mode
    id
  }
}
    `;

/**
 * __useLiveGateSchematicGateSubscription__
 *
 * To run a query within a React component, call `useLiveGateSchematicGateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateSchematicGateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateSchematicGateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveGateSchematicGateSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateSchematicGateSubscription, LiveGateSchematicGateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateSchematicGateSubscription, LiveGateSchematicGateSubscriptionVariables>(LiveGateSchematicGateDocument, options);
      }
export type LiveGateSchematicGateSubscriptionHookResult = ReturnType<typeof useLiveGateSchematicGateSubscription>;
export type LiveGateSchematicGateSubscriptionResult = Apollo.SubscriptionResult<LiveGateSchematicGateSubscription>;
export const LiveGateSchematicGroupDocument = gql`
    subscription LiveGateSchematicGroup($ids: [ID!]!) {
  gateGroupUpdated(ids: $ids) {
    controllers
    direction
    rampType
    position
    status
    name
    id
  }
}
    `;

/**
 * __useLiveGateSchematicGroupSubscription__
 *
 * To run a query within a React component, call `useLiveGateSchematicGroupSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateSchematicGroupSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateSchematicGroupSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveGateSchematicGroupSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateSchematicGroupSubscription, LiveGateSchematicGroupSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateSchematicGroupSubscription, LiveGateSchematicGroupSubscriptionVariables>(LiveGateSchematicGroupDocument, options);
      }
export type LiveGateSchematicGroupSubscriptionHookResult = ReturnType<typeof useLiveGateSchematicGroupSubscription>;
export type LiveGateSchematicGroupSubscriptionResult = Apollo.SubscriptionResult<LiveGateSchematicGroupSubscription>;
export const GateOperationCreateDocument = gql`
    mutation GateOperationCreate($id: ID!, $direction: GateDirection!, $type: GateOperationType!) {
  gateOperationCreate(id: $id, direction: $direction, type: $type)
}
    `;
export type GateOperationCreateMutationFn = Apollo.MutationFunction<GateOperationCreateMutation, GateOperationCreateMutationVariables>;

/**
 * __useGateOperationCreateMutation__
 *
 * To run a mutation, you first call `useGateOperationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateOperationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateOperationCreateMutation, { data, loading, error }] = useGateOperationCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      direction: // value for 'direction'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGateOperationCreateMutation(baseOptions?: Apollo.MutationHookOptions<GateOperationCreateMutation, GateOperationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateOperationCreateMutation, GateOperationCreateMutationVariables>(GateOperationCreateDocument, options);
      }
export type GateOperationCreateMutationHookResult = ReturnType<typeof useGateOperationCreateMutation>;
export type GateOperationCreateMutationResult = Apollo.MutationResult<GateOperationCreateMutation>;
export type GateOperationCreateMutationOptions = Apollo.BaseMutationOptions<GateOperationCreateMutation, GateOperationCreateMutationVariables>;
export const GateOperationInitiateDocument = gql`
    mutation GateOperationInitiate($id: ID!, $operationId: ID!) {
  gateOperationInitiate(id: $id, operationId: $operationId) {
    steps {
      userId
      id
    }
  }
}
    `;
export type GateOperationInitiateMutationFn = Apollo.MutationFunction<GateOperationInitiateMutation, GateOperationInitiateMutationVariables>;

/**
 * __useGateOperationInitiateMutation__
 *
 * To run a mutation, you first call `useGateOperationInitiateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateOperationInitiateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateOperationInitiateMutation, { data, loading, error }] = useGateOperationInitiateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useGateOperationInitiateMutation(baseOptions?: Apollo.MutationHookOptions<GateOperationInitiateMutation, GateOperationInitiateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateOperationInitiateMutation, GateOperationInitiateMutationVariables>(GateOperationInitiateDocument, options);
      }
export type GateOperationInitiateMutationHookResult = ReturnType<typeof useGateOperationInitiateMutation>;
export type GateOperationInitiateMutationResult = Apollo.MutationResult<GateOperationInitiateMutation>;
export type GateOperationInitiateMutationOptions = Apollo.BaseMutationOptions<GateOperationInitiateMutation, GateOperationInitiateMutationVariables>;
export const GateOperationFinishDocument = gql`
    mutation GateOperationFinish($id: ID!) {
  gateOperationFinish(id: $id)
}
    `;
export type GateOperationFinishMutationFn = Apollo.MutationFunction<GateOperationFinishMutation, GateOperationFinishMutationVariables>;

/**
 * __useGateOperationFinishMutation__
 *
 * To run a mutation, you first call `useGateOperationFinishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateOperationFinishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateOperationFinishMutation, { data, loading, error }] = useGateOperationFinishMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationFinishMutation(baseOptions?: Apollo.MutationHookOptions<GateOperationFinishMutation, GateOperationFinishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateOperationFinishMutation, GateOperationFinishMutationVariables>(GateOperationFinishDocument, options);
      }
export type GateOperationFinishMutationHookResult = ReturnType<typeof useGateOperationFinishMutation>;
export type GateOperationFinishMutationResult = Apollo.MutationResult<GateOperationFinishMutation>;
export type GateOperationFinishMutationOptions = Apollo.BaseMutationOptions<GateOperationFinishMutation, GateOperationFinishMutationVariables>;
export const GateOperationAbortDocument = gql`
    mutation GateOperationAbort($id: ID!) {
  gateOperationAbort(id: $id)
}
    `;
export type GateOperationAbortMutationFn = Apollo.MutationFunction<GateOperationAbortMutation, GateOperationAbortMutationVariables>;

/**
 * __useGateOperationAbortMutation__
 *
 * To run a mutation, you first call `useGateOperationAbortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateOperationAbortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateOperationAbortMutation, { data, loading, error }] = useGateOperationAbortMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationAbortMutation(baseOptions?: Apollo.MutationHookOptions<GateOperationAbortMutation, GateOperationAbortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateOperationAbortMutation, GateOperationAbortMutationVariables>(GateOperationAbortDocument, options);
      }
export type GateOperationAbortMutationHookResult = ReturnType<typeof useGateOperationAbortMutation>;
export type GateOperationAbortMutationResult = Apollo.MutationResult<GateOperationAbortMutation>;
export type GateOperationAbortMutationOptions = Apollo.BaseMutationOptions<GateOperationAbortMutation, GateOperationAbortMutationVariables>;
export const GateOperationLogInDocument = gql`
    mutation GateOperationLogIn($id: ID!) {
  gateOperationLogIn(id: $id)
}
    `;
export type GateOperationLogInMutationFn = Apollo.MutationFunction<GateOperationLogInMutation, GateOperationLogInMutationVariables>;

/**
 * __useGateOperationLogInMutation__
 *
 * To run a mutation, you first call `useGateOperationLogInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateOperationLogInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateOperationLogInMutation, { data, loading, error }] = useGateOperationLogInMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationLogInMutation(baseOptions?: Apollo.MutationHookOptions<GateOperationLogInMutation, GateOperationLogInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateOperationLogInMutation, GateOperationLogInMutationVariables>(GateOperationLogInDocument, options);
      }
export type GateOperationLogInMutationHookResult = ReturnType<typeof useGateOperationLogInMutation>;
export type GateOperationLogInMutationResult = Apollo.MutationResult<GateOperationLogInMutation>;
export type GateOperationLogInMutationOptions = Apollo.BaseMutationOptions<GateOperationLogInMutation, GateOperationLogInMutationVariables>;
export const GateOperationNextStepDocument = gql`
    mutation GateOperationNextStep($id: ID!) {
  gateOperationNextStep(id: $id)
}
    `;
export type GateOperationNextStepMutationFn = Apollo.MutationFunction<GateOperationNextStepMutation, GateOperationNextStepMutationVariables>;

/**
 * __useGateOperationNextStepMutation__
 *
 * To run a mutation, you first call `useGateOperationNextStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateOperationNextStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateOperationNextStepMutation, { data, loading, error }] = useGateOperationNextStepMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationNextStepMutation(baseOptions?: Apollo.MutationHookOptions<GateOperationNextStepMutation, GateOperationNextStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateOperationNextStepMutation, GateOperationNextStepMutationVariables>(GateOperationNextStepDocument, options);
      }
export type GateOperationNextStepMutationHookResult = ReturnType<typeof useGateOperationNextStepMutation>;
export type GateOperationNextStepMutationResult = Apollo.MutationResult<GateOperationNextStepMutation>;
export type GateOperationNextStepMutationOptions = Apollo.BaseMutationOptions<GateOperationNextStepMutation, GateOperationNextStepMutationVariables>;
export const GateOperationActivityDocument = gql`
    mutation GateOperationActivity($input: GateOperationActivityInput!) {
  gateOperationActivity(input: $input)
}
    `;
export type GateOperationActivityMutationFn = Apollo.MutationFunction<GateOperationActivityMutation, GateOperationActivityMutationVariables>;

/**
 * __useGateOperationActivityMutation__
 *
 * To run a mutation, you first call `useGateOperationActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateOperationActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateOperationActivityMutation, { data, loading, error }] = useGateOperationActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGateOperationActivityMutation(baseOptions?: Apollo.MutationHookOptions<GateOperationActivityMutation, GateOperationActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateOperationActivityMutation, GateOperationActivityMutationVariables>(GateOperationActivityDocument, options);
      }
export type GateOperationActivityMutationHookResult = ReturnType<typeof useGateOperationActivityMutation>;
export type GateOperationActivityMutationResult = Apollo.MutationResult<GateOperationActivityMutation>;
export type GateOperationActivityMutationOptions = Apollo.BaseMutationOptions<GateOperationActivityMutation, GateOperationActivityMutationVariables>;
export const ActivateGateTollingPointsDocument = gql`
    mutation ActivateGateTollingPoints($id: ID!) {
  activateGateTollPoints(id: $id)
}
    `;
export type ActivateGateTollingPointsMutationFn = Apollo.MutationFunction<ActivateGateTollingPointsMutation, ActivateGateTollingPointsMutationVariables>;

/**
 * __useActivateGateTollingPointsMutation__
 *
 * To run a mutation, you first call `useActivateGateTollingPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateGateTollingPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateGateTollingPointsMutation, { data, loading, error }] = useActivateGateTollingPointsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateGateTollingPointsMutation(baseOptions?: Apollo.MutationHookOptions<ActivateGateTollingPointsMutation, ActivateGateTollingPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateGateTollingPointsMutation, ActivateGateTollingPointsMutationVariables>(ActivateGateTollingPointsDocument, options);
      }
export type ActivateGateTollingPointsMutationHookResult = ReturnType<typeof useActivateGateTollingPointsMutation>;
export type ActivateGateTollingPointsMutationResult = Apollo.MutationResult<ActivateGateTollingPointsMutation>;
export type ActivateGateTollingPointsMutationOptions = Apollo.BaseMutationOptions<ActivateGateTollingPointsMutation, ActivateGateTollingPointsMutationVariables>;
export const ReverseDetectorDirectionDocument = gql`
    mutation ReverseDetectorDirection($id: ID!) {
  reverseDetectorDirection(id: $id)
}
    `;
export type ReverseDetectorDirectionMutationFn = Apollo.MutationFunction<ReverseDetectorDirectionMutation, ReverseDetectorDirectionMutationVariables>;

/**
 * __useReverseDetectorDirectionMutation__
 *
 * To run a mutation, you first call `useReverseDetectorDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseDetectorDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseDetectorDirectionMutation, { data, loading, error }] = useReverseDetectorDirectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReverseDetectorDirectionMutation(baseOptions?: Apollo.MutationHookOptions<ReverseDetectorDirectionMutation, ReverseDetectorDirectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseDetectorDirectionMutation, ReverseDetectorDirectionMutationVariables>(ReverseDetectorDirectionDocument, options);
      }
export type ReverseDetectorDirectionMutationHookResult = ReturnType<typeof useReverseDetectorDirectionMutation>;
export type ReverseDetectorDirectionMutationResult = Apollo.MutationResult<ReverseDetectorDirectionMutation>;
export type ReverseDetectorDirectionMutationOptions = Apollo.BaseMutationOptions<ReverseDetectorDirectionMutation, ReverseDetectorDirectionMutationVariables>;
export const ReverseAlertDirectionDocument = gql`
    mutation ReverseAlertDirection($id: ID!) {
  reverseAlertDirection(id: $id)
}
    `;
export type ReverseAlertDirectionMutationFn = Apollo.MutationFunction<ReverseAlertDirectionMutation, ReverseAlertDirectionMutationVariables>;

/**
 * __useReverseAlertDirectionMutation__
 *
 * To run a mutation, you first call `useReverseAlertDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseAlertDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseAlertDirectionMutation, { data, loading, error }] = useReverseAlertDirectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReverseAlertDirectionMutation(baseOptions?: Apollo.MutationHookOptions<ReverseAlertDirectionMutation, ReverseAlertDirectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseAlertDirectionMutation, ReverseAlertDirectionMutationVariables>(ReverseAlertDirectionDocument, options);
      }
export type ReverseAlertDirectionMutationHookResult = ReturnType<typeof useReverseAlertDirectionMutation>;
export type ReverseAlertDirectionMutationResult = Apollo.MutationResult<ReverseAlertDirectionMutation>;
export type ReverseAlertDirectionMutationOptions = Apollo.BaseMutationOptions<ReverseAlertDirectionMutation, ReverseAlertDirectionMutationVariables>;
export const GateOperationDocument = gql`
    query GateOperation($id: ID!) {
  gateOperation(id: $id) {
    steps {
      tasks {
        confirmOptionRequired
        blankBeforeDisplay
        confirmDataSource
        notesRequired
        resourcePlan
        isCompleted
        messageType
        controller
        taskType
        name
        id
      }
      userDisplayName
      isCompleted
      stepType
      userId
      group
      name
      id
    }
    startTime
    system
    users
    type
    name
    id
  }
}
    `;

/**
 * __useGateOperationQuery__
 *
 * To run a query within a React component, call `useGateOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationQuery(baseOptions: Apollo.QueryHookOptions<GateOperationQuery, GateOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationQuery, GateOperationQueryVariables>(GateOperationDocument, options);
      }
export function useGateOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationQuery, GateOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationQuery, GateOperationQueryVariables>(GateOperationDocument, options);
        }
export type GateOperationQueryHookResult = ReturnType<typeof useGateOperationQuery>;
export type GateOperationLazyQueryHookResult = ReturnType<typeof useGateOperationLazyQuery>;
export type GateOperationQueryResult = Apollo.QueryResult<GateOperationQuery, GateOperationQueryVariables>;
export function refetchGateOperationQuery(variables: GateOperationQueryVariables) {
      return { query: GateOperationDocument, variables: variables }
    }
export const GateOperationOptionsDocument = gql`
    query GateOperationOptions($id: ID!) {
  gateOperationOptions(id: $id) {
    label
    value
  }
}
    `;

/**
 * __useGateOperationOptionsQuery__
 *
 * To run a query within a React component, call `useGateOperationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationOptionsQuery(baseOptions: Apollo.QueryHookOptions<GateOperationOptionsQuery, GateOperationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationOptionsQuery, GateOperationOptionsQueryVariables>(GateOperationOptionsDocument, options);
      }
export function useGateOperationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationOptionsQuery, GateOperationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationOptionsQuery, GateOperationOptionsQueryVariables>(GateOperationOptionsDocument, options);
        }
export type GateOperationOptionsQueryHookResult = ReturnType<typeof useGateOperationOptionsQuery>;
export type GateOperationOptionsLazyQueryHookResult = ReturnType<typeof useGateOperationOptionsLazyQuery>;
export type GateOperationOptionsQueryResult = Apollo.QueryResult<GateOperationOptionsQuery, GateOperationOptionsQueryVariables>;
export function refetchGateOperationOptionsQuery(variables: GateOperationOptionsQueryVariables) {
      return { query: GateOperationOptionsDocument, variables: variables }
    }
export const GateOperationControllerDetailsDocument = gql`
    query GateOperationControllerDetails($id: ID!) {
  gateController(id: $id) {
    gateCameras {
      cameraId
    }
    gateSigns
    gateArms {
      nativeId
      position
    }
    gateTours
    name
  }
}
    `;

/**
 * __useGateOperationControllerDetailsQuery__
 *
 * To run a query within a React component, call `useGateOperationControllerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationControllerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationControllerDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationControllerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GateOperationControllerDetailsQuery, GateOperationControllerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationControllerDetailsQuery, GateOperationControllerDetailsQueryVariables>(GateOperationControllerDetailsDocument, options);
      }
export function useGateOperationControllerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationControllerDetailsQuery, GateOperationControllerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationControllerDetailsQuery, GateOperationControllerDetailsQueryVariables>(GateOperationControllerDetailsDocument, options);
        }
export type GateOperationControllerDetailsQueryHookResult = ReturnType<typeof useGateOperationControllerDetailsQuery>;
export type GateOperationControllerDetailsLazyQueryHookResult = ReturnType<typeof useGateOperationControllerDetailsLazyQuery>;
export type GateOperationControllerDetailsQueryResult = Apollo.QueryResult<GateOperationControllerDetailsQuery, GateOperationControllerDetailsQueryVariables>;
export function refetchGateOperationControllerDetailsQuery(variables: GateOperationControllerDetailsQueryVariables) {
      return { query: GateOperationControllerDetailsDocument, variables: variables }
    }
export const GateOperationHistoryDetailDocument = gql`
    query GateOperationHistoryDetail($id: ID!) {
  gateOperationHistory(id: $id) {
    operationId
    system
    name
  }
}
    `;

/**
 * __useGateOperationHistoryDetailQuery__
 *
 * To run a query within a React component, call `useGateOperationHistoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationHistoryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationHistoryDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateOperationHistoryDetailQuery(baseOptions: Apollo.QueryHookOptions<GateOperationHistoryDetailQuery, GateOperationHistoryDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationHistoryDetailQuery, GateOperationHistoryDetailQueryVariables>(GateOperationHistoryDetailDocument, options);
      }
export function useGateOperationHistoryDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationHistoryDetailQuery, GateOperationHistoryDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationHistoryDetailQuery, GateOperationHistoryDetailQueryVariables>(GateOperationHistoryDetailDocument, options);
        }
export type GateOperationHistoryDetailQueryHookResult = ReturnType<typeof useGateOperationHistoryDetailQuery>;
export type GateOperationHistoryDetailLazyQueryHookResult = ReturnType<typeof useGateOperationHistoryDetailLazyQuery>;
export type GateOperationHistoryDetailQueryResult = Apollo.QueryResult<GateOperationHistoryDetailQuery, GateOperationHistoryDetailQueryVariables>;
export function refetchGateOperationHistoryDetailQuery(variables: GateOperationHistoryDetailQueryVariables) {
      return { query: GateOperationHistoryDetailDocument, variables: variables }
    }
export const GateOperationHistoryListDocument = gql`
    query GateOperationHistoryList($sortOrder: SortOrder = DESCENDING, $sortField: String = "startTime", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  gateOperationHistoryList(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        operationId
        startTime
        endTime
        result
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGateOperationHistoryListQuery__
 *
 * To run a query within a React component, call `useGateOperationHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationHistoryListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGateOperationHistoryListQuery(baseOptions?: Apollo.QueryHookOptions<GateOperationHistoryListQuery, GateOperationHistoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationHistoryListQuery, GateOperationHistoryListQueryVariables>(GateOperationHistoryListDocument, options);
      }
export function useGateOperationHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationHistoryListQuery, GateOperationHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationHistoryListQuery, GateOperationHistoryListQueryVariables>(GateOperationHistoryListDocument, options);
        }
export type GateOperationHistoryListQueryHookResult = ReturnType<typeof useGateOperationHistoryListQuery>;
export type GateOperationHistoryListLazyQueryHookResult = ReturnType<typeof useGateOperationHistoryListLazyQuery>;
export type GateOperationHistoryListQueryResult = Apollo.QueryResult<GateOperationHistoryListQuery, GateOperationHistoryListQueryVariables>;
export function refetchGateOperationHistoryListQuery(variables?: GateOperationHistoryListQueryVariables) {
      return { query: GateOperationHistoryListDocument, variables: variables }
    }
export const LiveGateOperationDocument = gql`
    subscription LiveGateOperation($id: ID!) {
  gateOperationUpdated(id: $id) {
    steps {
      tasks {
        confirmOptionRequired
        blankBeforeDisplay
        confirmDataSource
        notesRequired
        resourcePlan
        isCompleted
        messageType
        controller
        taskType
        name
        id
      }
      userDisplayName
      isCompleted
      stepType
      userId
      group
      name
      id
    }
    startTime
    system
    users
    type
    name
    id
  }
}
    `;

/**
 * __useLiveGateOperationSubscription__
 *
 * To run a query within a React component, call `useLiveGateOperationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveGateOperationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveGateOperationSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveGateOperationSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveGateOperationSubscription, LiveGateOperationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveGateOperationSubscription, LiveGateOperationSubscriptionVariables>(LiveGateOperationDocument, options);
      }
export type LiveGateOperationSubscriptionHookResult = ReturnType<typeof useLiveGateOperationSubscription>;
export type LiveGateOperationSubscriptionResult = Apollo.SubscriptionResult<LiveGateOperationSubscription>;
export const GateOperationValidateDocument = gql`
    query GateOperationValidate($id: ID!, $operationId: ID!) {
  gateOperationValidate(id: $id, operationId: $operationId)
}
    `;

/**
 * __useGateOperationValidateQuery__
 *
 * To run a query within a React component, call `useGateOperationValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationValidateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useGateOperationValidateQuery(baseOptions: Apollo.QueryHookOptions<GateOperationValidateQuery, GateOperationValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateOperationValidateQuery, GateOperationValidateQueryVariables>(GateOperationValidateDocument, options);
      }
export function useGateOperationValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateOperationValidateQuery, GateOperationValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateOperationValidateQuery, GateOperationValidateQueryVariables>(GateOperationValidateDocument, options);
        }
export type GateOperationValidateQueryHookResult = ReturnType<typeof useGateOperationValidateQuery>;
export type GateOperationValidateLazyQueryHookResult = ReturnType<typeof useGateOperationValidateLazyQuery>;
export type GateOperationValidateQueryResult = Apollo.QueryResult<GateOperationValidateQuery, GateOperationValidateQueryVariables>;
export function refetchGateOperationValidateQuery(variables: GateOperationValidateQueryVariables) {
      return { query: GateOperationValidateDocument, variables: variables }
    }
export const GateOperationSelectStepDocument = gql`
    mutation GateOperationSelectStep($id: ID!, $stepId: ID!) {
  gateOperationSelectStep(id: $id, stepId: $stepId)
}
    `;
export type GateOperationSelectStepMutationFn = Apollo.MutationFunction<GateOperationSelectStepMutation, GateOperationSelectStepMutationVariables>;

/**
 * __useGateOperationSelectStepMutation__
 *
 * To run a mutation, you first call `useGateOperationSelectStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateOperationSelectStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateOperationSelectStepMutation, { data, loading, error }] = useGateOperationSelectStepMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useGateOperationSelectStepMutation(baseOptions?: Apollo.MutationHookOptions<GateOperationSelectStepMutation, GateOperationSelectStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateOperationSelectStepMutation, GateOperationSelectStepMutationVariables>(GateOperationSelectStepDocument, options);
      }
export type GateOperationSelectStepMutationHookResult = ReturnType<typeof useGateOperationSelectStepMutation>;
export type GateOperationSelectStepMutationResult = Apollo.MutationResult<GateOperationSelectStepMutation>;
export type GateOperationSelectStepMutationOptions = Apollo.BaseMutationOptions<GateOperationSelectStepMutation, GateOperationSelectStepMutationVariables>;
export const GateOperationSkipStepDocument = gql`
    mutation GateOperationSkipStep($id: ID!, $stepId: ID!) {
  gateOperationSkipStep(id: $id, stepId: $stepId)
}
    `;
export type GateOperationSkipStepMutationFn = Apollo.MutationFunction<GateOperationSkipStepMutation, GateOperationSkipStepMutationVariables>;

/**
 * __useGateOperationSkipStepMutation__
 *
 * To run a mutation, you first call `useGateOperationSkipStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateOperationSkipStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateOperationSkipStepMutation, { data, loading, error }] = useGateOperationSkipStepMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useGateOperationSkipStepMutation(baseOptions?: Apollo.MutationHookOptions<GateOperationSkipStepMutation, GateOperationSkipStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GateOperationSkipStepMutation, GateOperationSkipStepMutationVariables>(GateOperationSkipStepDocument, options);
      }
export type GateOperationSkipStepMutationHookResult = ReturnType<typeof useGateOperationSkipStepMutation>;
export type GateOperationSkipStepMutationResult = Apollo.MutationResult<GateOperationSkipStepMutation>;
export type GateOperationSkipStepMutationOptions = Apollo.BaseMutationOptions<GateOperationSkipStepMutation, GateOperationSkipStepMutationVariables>;
export const GateOperationJobDocument = gql`
    subscription GateOperationJob($ids: [ID!]) {
  gateControllerJobResults(ids: $ids) {
    requestId
    success
    failure
    id
  }
}
    `;

/**
 * __useGateOperationJobSubscription__
 *
 * To run a query within a React component, call `useGateOperationJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGateOperationJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateOperationJobSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGateOperationJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GateOperationJobSubscription, GateOperationJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GateOperationJobSubscription, GateOperationJobSubscriptionVariables>(GateOperationJobDocument, options);
      }
export type GateOperationJobSubscriptionHookResult = ReturnType<typeof useGateOperationJobSubscription>;
export type GateOperationJobSubscriptionResult = Apollo.SubscriptionResult<GateOperationJobSubscription>;
export const SaveGateModuleSettingsDocument = gql`
    mutation saveGateModuleSettings($settings: JSON!) {
  saveGateModuleSettings(settings: $settings)
}
    `;
export type SaveGateModuleSettingsMutationFn = Apollo.MutationFunction<SaveGateModuleSettingsMutation, SaveGateModuleSettingsMutationVariables>;

/**
 * __useSaveGateModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveGateModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGateModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGateModuleSettingsMutation, { data, loading, error }] = useSaveGateModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveGateModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveGateModuleSettingsMutation, SaveGateModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGateModuleSettingsMutation, SaveGateModuleSettingsMutationVariables>(SaveGateModuleSettingsDocument, options);
      }
export type SaveGateModuleSettingsMutationHookResult = ReturnType<typeof useSaveGateModuleSettingsMutation>;
export type SaveGateModuleSettingsMutationResult = Apollo.MutationResult<SaveGateModuleSettingsMutation>;
export type SaveGateModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveGateModuleSettingsMutation, SaveGateModuleSettingsMutationVariables>;
export const GateModuleSettingsDocument = gql`
    query GateModuleSettings {
  gateModuleSettings {
    ...GateSettings
  }
}
    ${GateSettingsFragmentDoc}`;

/**
 * __useGateModuleSettingsQuery__
 *
 * To run a query within a React component, call `useGateModuleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateModuleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateModuleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGateModuleSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GateModuleSettingsQuery, GateModuleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GateModuleSettingsQuery, GateModuleSettingsQueryVariables>(GateModuleSettingsDocument, options);
      }
export function useGateModuleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GateModuleSettingsQuery, GateModuleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GateModuleSettingsQuery, GateModuleSettingsQueryVariables>(GateModuleSettingsDocument, options);
        }
export type GateModuleSettingsQueryHookResult = ReturnType<typeof useGateModuleSettingsQuery>;
export type GateModuleSettingsLazyQueryHookResult = ReturnType<typeof useGateModuleSettingsLazyQuery>;
export type GateModuleSettingsQueryResult = Apollo.QueryResult<GateModuleSettingsQuery, GateModuleSettingsQueryVariables>;
export function refetchGateModuleSettingsQuery(variables?: GateModuleSettingsQueryVariables) {
      return { query: GateModuleSettingsDocument, variables: variables }
    }
export const HarDeleteMessageDocument = gql`
    mutation HarDeleteMessage($id: ID!) {
  harDeleteMessage(id: $id)
}
    `;
export type HarDeleteMessageMutationFn = Apollo.MutationFunction<HarDeleteMessageMutation, HarDeleteMessageMutationVariables>;

/**
 * __useHarDeleteMessageMutation__
 *
 * To run a mutation, you first call `useHarDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harDeleteMessageMutation, { data, loading, error }] = useHarDeleteMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<HarDeleteMessageMutation, HarDeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarDeleteMessageMutation, HarDeleteMessageMutationVariables>(HarDeleteMessageDocument, options);
      }
export type HarDeleteMessageMutationHookResult = ReturnType<typeof useHarDeleteMessageMutation>;
export type HarDeleteMessageMutationResult = Apollo.MutationResult<HarDeleteMessageMutation>;
export type HarDeleteMessageMutationOptions = Apollo.BaseMutationOptions<HarDeleteMessageMutation, HarDeleteMessageMutationVariables>;
export const HarSaveMessageDocument = gql`
    mutation HarSaveMessage($input: HarMessageInput!) {
  harSaveMessage(input: $input) {
    id
  }
}
    `;
export type HarSaveMessageMutationFn = Apollo.MutationFunction<HarSaveMessageMutation, HarSaveMessageMutationVariables>;

/**
 * __useHarSaveMessageMutation__
 *
 * To run a mutation, you first call `useHarSaveMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarSaveMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harSaveMessageMutation, { data, loading, error }] = useHarSaveMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHarSaveMessageMutation(baseOptions?: Apollo.MutationHookOptions<HarSaveMessageMutation, HarSaveMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarSaveMessageMutation, HarSaveMessageMutationVariables>(HarSaveMessageDocument, options);
      }
export type HarSaveMessageMutationHookResult = ReturnType<typeof useHarSaveMessageMutation>;
export type HarSaveMessageMutationResult = Apollo.MutationResult<HarSaveMessageMutation>;
export type HarSaveMessageMutationOptions = Apollo.BaseMutationOptions<HarSaveMessageMutation, HarSaveMessageMutationVariables>;
export const HarMessageListDocument = gql`
    query HarMessageList($searchFields: [String!] = ["name", "text"], $sortOrder: SortOrder = ASCENDING, $sortField: String = "priority", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  harMessages(
    query: {searchFields: $searchFields, searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        text
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useHarMessageListQuery__
 *
 * To run a query within a React component, call `useHarMessageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarMessageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarMessageListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useHarMessageListQuery(baseOptions?: Apollo.QueryHookOptions<HarMessageListQuery, HarMessageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarMessageListQuery, HarMessageListQueryVariables>(HarMessageListDocument, options);
      }
export function useHarMessageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarMessageListQuery, HarMessageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarMessageListQuery, HarMessageListQueryVariables>(HarMessageListDocument, options);
        }
export type HarMessageListQueryHookResult = ReturnType<typeof useHarMessageListQuery>;
export type HarMessageListLazyQueryHookResult = ReturnType<typeof useHarMessageListLazyQuery>;
export type HarMessageListQueryResult = Apollo.QueryResult<HarMessageListQuery, HarMessageListQueryVariables>;
export function refetchHarMessageListQuery(variables?: HarMessageListQueryVariables) {
      return { query: HarMessageListDocument, variables: variables }
    }
export const LiveHarMessageListDocument = gql`
    subscription LiveHarMessageList($ids: [ID!]) {
  harMessageUpdated(ids: $ids) {
    text
    name
    id
  }
}
    `;

/**
 * __useLiveHarMessageListSubscription__
 *
 * To run a query within a React component, call `useLiveHarMessageListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveHarMessageListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveHarMessageListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveHarMessageListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveHarMessageListSubscription, LiveHarMessageListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveHarMessageListSubscription, LiveHarMessageListSubscriptionVariables>(LiveHarMessageListDocument, options);
      }
export type LiveHarMessageListSubscriptionHookResult = ReturnType<typeof useLiveHarMessageListSubscription>;
export type LiveHarMessageListSubscriptionResult = Apollo.SubscriptionResult<LiveHarMessageListSubscription>;
export const HarMessageDetailDocument = gql`
    query HarMessageDetail($id: ID!) {
  harMessage(id: $id) {
    text
    name
    id
  }
}
    `;

/**
 * __useHarMessageDetailQuery__
 *
 * To run a query within a React component, call `useHarMessageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarMessageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarMessageDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarMessageDetailQuery(baseOptions: Apollo.QueryHookOptions<HarMessageDetailQuery, HarMessageDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarMessageDetailQuery, HarMessageDetailQueryVariables>(HarMessageDetailDocument, options);
      }
export function useHarMessageDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarMessageDetailQuery, HarMessageDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarMessageDetailQuery, HarMessageDetailQueryVariables>(HarMessageDetailDocument, options);
        }
export type HarMessageDetailQueryHookResult = ReturnType<typeof useHarMessageDetailQuery>;
export type HarMessageDetailLazyQueryHookResult = ReturnType<typeof useHarMessageDetailLazyQuery>;
export type HarMessageDetailQueryResult = Apollo.QueryResult<HarMessageDetailQuery, HarMessageDetailQueryVariables>;
export function refetchHarMessageDetailQuery(variables: HarMessageDetailQueryVariables) {
      return { query: HarMessageDetailDocument, variables: variables }
    }
export const HarDeletePlaylistDocument = gql`
    mutation HarDeletePlaylist($id: ID!) {
  harDeletePlaylist(id: $id)
}
    `;
export type HarDeletePlaylistMutationFn = Apollo.MutationFunction<HarDeletePlaylistMutation, HarDeletePlaylistMutationVariables>;

/**
 * __useHarDeletePlaylistMutation__
 *
 * To run a mutation, you first call `useHarDeletePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarDeletePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harDeletePlaylistMutation, { data, loading, error }] = useHarDeletePlaylistMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarDeletePlaylistMutation(baseOptions?: Apollo.MutationHookOptions<HarDeletePlaylistMutation, HarDeletePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarDeletePlaylistMutation, HarDeletePlaylistMutationVariables>(HarDeletePlaylistDocument, options);
      }
export type HarDeletePlaylistMutationHookResult = ReturnType<typeof useHarDeletePlaylistMutation>;
export type HarDeletePlaylistMutationResult = Apollo.MutationResult<HarDeletePlaylistMutation>;
export type HarDeletePlaylistMutationOptions = Apollo.BaseMutationOptions<HarDeletePlaylistMutation, HarDeletePlaylistMutationVariables>;
export const HarSavePlaylistDocument = gql`
    mutation HarSavePlaylist($input: HarPlaylistInput!) {
  harSavePlaylist(input: $input) {
    id
  }
}
    `;
export type HarSavePlaylistMutationFn = Apollo.MutationFunction<HarSavePlaylistMutation, HarSavePlaylistMutationVariables>;

/**
 * __useHarSavePlaylistMutation__
 *
 * To run a mutation, you first call `useHarSavePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarSavePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harSavePlaylistMutation, { data, loading, error }] = useHarSavePlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHarSavePlaylistMutation(baseOptions?: Apollo.MutationHookOptions<HarSavePlaylistMutation, HarSavePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarSavePlaylistMutation, HarSavePlaylistMutationVariables>(HarSavePlaylistDocument, options);
      }
export type HarSavePlaylistMutationHookResult = ReturnType<typeof useHarSavePlaylistMutation>;
export type HarSavePlaylistMutationResult = Apollo.MutationResult<HarSavePlaylistMutation>;
export type HarSavePlaylistMutationOptions = Apollo.BaseMutationOptions<HarSavePlaylistMutation, HarSavePlaylistMutationVariables>;
export const HarPlaylistListDocument = gql`
    query HarPlaylistList($searchFields: [String!] = ["name", "text"], $sortOrder: SortOrder = ASCENDING, $sortField: String = "priority", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  harPlaylists(
    query: {searchFields: $searchFields, searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        messages {
          name
          text
          id
        }
        priority {
          priority
          name
        }
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useHarPlaylistListQuery__
 *
 * To run a query within a React component, call `useHarPlaylistListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarPlaylistListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarPlaylistListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useHarPlaylistListQuery(baseOptions?: Apollo.QueryHookOptions<HarPlaylistListQuery, HarPlaylistListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarPlaylistListQuery, HarPlaylistListQueryVariables>(HarPlaylistListDocument, options);
      }
export function useHarPlaylistListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarPlaylistListQuery, HarPlaylistListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarPlaylistListQuery, HarPlaylistListQueryVariables>(HarPlaylistListDocument, options);
        }
export type HarPlaylistListQueryHookResult = ReturnType<typeof useHarPlaylistListQuery>;
export type HarPlaylistListLazyQueryHookResult = ReturnType<typeof useHarPlaylistListLazyQuery>;
export type HarPlaylistListQueryResult = Apollo.QueryResult<HarPlaylistListQuery, HarPlaylistListQueryVariables>;
export function refetchHarPlaylistListQuery(variables?: HarPlaylistListQueryVariables) {
      return { query: HarPlaylistListDocument, variables: variables }
    }
export const LiveHarPlaylistListDocument = gql`
    subscription LiveHarPlaylistList($ids: [ID!]) {
  harPlaylistUpdated(ids: $ids) {
    messages {
      name
      text
      id
    }
    priority {
      priority
      name
    }
    name
    id
  }
}
    `;

/**
 * __useLiveHarPlaylistListSubscription__
 *
 * To run a query within a React component, call `useLiveHarPlaylistListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveHarPlaylistListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveHarPlaylistListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveHarPlaylistListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveHarPlaylistListSubscription, LiveHarPlaylistListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveHarPlaylistListSubscription, LiveHarPlaylistListSubscriptionVariables>(LiveHarPlaylistListDocument, options);
      }
export type LiveHarPlaylistListSubscriptionHookResult = ReturnType<typeof useLiveHarPlaylistListSubscription>;
export type LiveHarPlaylistListSubscriptionResult = Apollo.SubscriptionResult<LiveHarPlaylistListSubscription>;
export const HarPlaylistDetailDocument = gql`
    query HarPlaylistDetail($id: ID!) {
  harPlaylist(id: $id) {
    messages {
      id
    }
    priority {
      priority
      name
      id
    }
    name
    id
  }
}
    `;

/**
 * __useHarPlaylistDetailQuery__
 *
 * To run a query within a React component, call `useHarPlaylistDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarPlaylistDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarPlaylistDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarPlaylistDetailQuery(baseOptions: Apollo.QueryHookOptions<HarPlaylistDetailQuery, HarPlaylistDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarPlaylistDetailQuery, HarPlaylistDetailQueryVariables>(HarPlaylistDetailDocument, options);
      }
export function useHarPlaylistDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarPlaylistDetailQuery, HarPlaylistDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarPlaylistDetailQuery, HarPlaylistDetailQueryVariables>(HarPlaylistDetailDocument, options);
        }
export type HarPlaylistDetailQueryHookResult = ReturnType<typeof useHarPlaylistDetailQuery>;
export type HarPlaylistDetailLazyQueryHookResult = ReturnType<typeof useHarPlaylistDetailLazyQuery>;
export type HarPlaylistDetailQueryResult = Apollo.QueryResult<HarPlaylistDetailQuery, HarPlaylistDetailQueryVariables>;
export function refetchHarPlaylistDetailQuery(variables: HarPlaylistDetailQueryVariables) {
      return { query: HarPlaylistDetailDocument, variables: variables }
    }
export const HarDeletePriorityDocument = gql`
    mutation HarDeletePriority($id: ID!) {
  harDeletePriority(id: $id)
}
    `;
export type HarDeletePriorityMutationFn = Apollo.MutationFunction<HarDeletePriorityMutation, HarDeletePriorityMutationVariables>;

/**
 * __useHarDeletePriorityMutation__
 *
 * To run a mutation, you first call `useHarDeletePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarDeletePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harDeletePriorityMutation, { data, loading, error }] = useHarDeletePriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarDeletePriorityMutation(baseOptions?: Apollo.MutationHookOptions<HarDeletePriorityMutation, HarDeletePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarDeletePriorityMutation, HarDeletePriorityMutationVariables>(HarDeletePriorityDocument, options);
      }
export type HarDeletePriorityMutationHookResult = ReturnType<typeof useHarDeletePriorityMutation>;
export type HarDeletePriorityMutationResult = Apollo.MutationResult<HarDeletePriorityMutation>;
export type HarDeletePriorityMutationOptions = Apollo.BaseMutationOptions<HarDeletePriorityMutation, HarDeletePriorityMutationVariables>;
export const HarSavePriorityDocument = gql`
    mutation HarSavePriority($input: HarPriorityInput!) {
  harSavePriority(input: $input) {
    id
  }
}
    `;
export type HarSavePriorityMutationFn = Apollo.MutationFunction<HarSavePriorityMutation, HarSavePriorityMutationVariables>;

/**
 * __useHarSavePriorityMutation__
 *
 * To run a mutation, you first call `useHarSavePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarSavePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harSavePriorityMutation, { data, loading, error }] = useHarSavePriorityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHarSavePriorityMutation(baseOptions?: Apollo.MutationHookOptions<HarSavePriorityMutation, HarSavePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarSavePriorityMutation, HarSavePriorityMutationVariables>(HarSavePriorityDocument, options);
      }
export type HarSavePriorityMutationHookResult = ReturnType<typeof useHarSavePriorityMutation>;
export type HarSavePriorityMutationResult = Apollo.MutationResult<HarSavePriorityMutation>;
export type HarSavePriorityMutationOptions = Apollo.BaseMutationOptions<HarSavePriorityMutation, HarSavePriorityMutationVariables>;
export const HarPriorityListDocument = gql`
    query HarPriorityList($searchFields: [String!] = ["name"], $sortOrder: SortOrder = ASCENDING, $sortField: String = "priority", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  harPriorities(
    query: {searchFields: $searchFields, searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        messageDefault
        description
        priority
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useHarPriorityListQuery__
 *
 * To run a query within a React component, call `useHarPriorityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarPriorityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarPriorityListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useHarPriorityListQuery(baseOptions?: Apollo.QueryHookOptions<HarPriorityListQuery, HarPriorityListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarPriorityListQuery, HarPriorityListQueryVariables>(HarPriorityListDocument, options);
      }
export function useHarPriorityListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarPriorityListQuery, HarPriorityListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarPriorityListQuery, HarPriorityListQueryVariables>(HarPriorityListDocument, options);
        }
export type HarPriorityListQueryHookResult = ReturnType<typeof useHarPriorityListQuery>;
export type HarPriorityListLazyQueryHookResult = ReturnType<typeof useHarPriorityListLazyQuery>;
export type HarPriorityListQueryResult = Apollo.QueryResult<HarPriorityListQuery, HarPriorityListQueryVariables>;
export function refetchHarPriorityListQuery(variables?: HarPriorityListQueryVariables) {
      return { query: HarPriorityListDocument, variables: variables }
    }
export const LiveHarPriorityListDocument = gql`
    subscription LiveHarPriorityList($ids: [ID!]) {
  harPriorityUpdated(ids: $ids) {
    messageDefault
    description
    priority
    name
    id
  }
}
    `;

/**
 * __useLiveHarPriorityListSubscription__
 *
 * To run a query within a React component, call `useLiveHarPriorityListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveHarPriorityListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveHarPriorityListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveHarPriorityListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveHarPriorityListSubscription, LiveHarPriorityListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveHarPriorityListSubscription, LiveHarPriorityListSubscriptionVariables>(LiveHarPriorityListDocument, options);
      }
export type LiveHarPriorityListSubscriptionHookResult = ReturnType<typeof useLiveHarPriorityListSubscription>;
export type LiveHarPriorityListSubscriptionResult = Apollo.SubscriptionResult<LiveHarPriorityListSubscription>;
export const HarPriorityDetailDocument = gql`
    query HarPriorityDetail($id: ID!) {
  harPriority(id: $id) {
    messageDefault
    description
    priority
    name
    id
  }
}
    `;

/**
 * __useHarPriorityDetailQuery__
 *
 * To run a query within a React component, call `useHarPriorityDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarPriorityDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarPriorityDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarPriorityDetailQuery(baseOptions: Apollo.QueryHookOptions<HarPriorityDetailQuery, HarPriorityDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarPriorityDetailQuery, HarPriorityDetailQueryVariables>(HarPriorityDetailDocument, options);
      }
export function useHarPriorityDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarPriorityDetailQuery, HarPriorityDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarPriorityDetailQuery, HarPriorityDetailQueryVariables>(HarPriorityDetailDocument, options);
        }
export type HarPriorityDetailQueryHookResult = ReturnType<typeof useHarPriorityDetailQuery>;
export type HarPriorityDetailLazyQueryHookResult = ReturnType<typeof useHarPriorityDetailLazyQuery>;
export type HarPriorityDetailQueryResult = Apollo.QueryResult<HarPriorityDetailQuery, HarPriorityDetailQueryVariables>;
export function refetchHarPriorityDetailQuery(variables: HarPriorityDetailQueryVariables) {
      return { query: HarPriorityDetailDocument, variables: variables }
    }
export const HarSaveSettingsDocument = gql`
    mutation harSaveSettings($settings: JSON!) {
  harSaveModuleSettings(settings: $settings)
}
    `;
export type HarSaveSettingsMutationFn = Apollo.MutationFunction<HarSaveSettingsMutation, HarSaveSettingsMutationVariables>;

/**
 * __useHarSaveSettingsMutation__
 *
 * To run a mutation, you first call `useHarSaveSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarSaveSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harSaveSettingsMutation, { data, loading, error }] = useHarSaveSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useHarSaveSettingsMutation(baseOptions?: Apollo.MutationHookOptions<HarSaveSettingsMutation, HarSaveSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarSaveSettingsMutation, HarSaveSettingsMutationVariables>(HarSaveSettingsDocument, options);
      }
export type HarSaveSettingsMutationHookResult = ReturnType<typeof useHarSaveSettingsMutation>;
export type HarSaveSettingsMutationResult = Apollo.MutationResult<HarSaveSettingsMutation>;
export type HarSaveSettingsMutationOptions = Apollo.BaseMutationOptions<HarSaveSettingsMutation, HarSaveSettingsMutationVariables>;
export const HarSettingsDocument = gql`
    query HarSettings {
  harModuleSettings {
    ...HarSettings
  }
}
    ${HarSettingsFragmentDoc}`;

/**
 * __useHarSettingsQuery__
 *
 * To run a query within a React component, call `useHarSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHarSettingsQuery(baseOptions?: Apollo.QueryHookOptions<HarSettingsQuery, HarSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarSettingsQuery, HarSettingsQueryVariables>(HarSettingsDocument, options);
      }
export function useHarSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarSettingsQuery, HarSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarSettingsQuery, HarSettingsQueryVariables>(HarSettingsDocument, options);
        }
export type HarSettingsQueryHookResult = ReturnType<typeof useHarSettingsQuery>;
export type HarSettingsLazyQueryHookResult = ReturnType<typeof useHarSettingsLazyQuery>;
export type HarSettingsQueryResult = Apollo.QueryResult<HarSettingsQuery, HarSettingsQueryVariables>;
export function refetchHarSettingsQuery(variables?: HarSettingsQueryVariables) {
      return { query: HarSettingsDocument, variables: variables }
    }
export const HarTransmitterPollDocument = gql`
    mutation HarTransmitterPoll($transmitters: [ID!]!) {
  harTransmitterPoll(transmitters: $transmitters) {
    success
  }
}
    `;
export type HarTransmitterPollMutationFn = Apollo.MutationFunction<HarTransmitterPollMutation, HarTransmitterPollMutationVariables>;

/**
 * __useHarTransmitterPollMutation__
 *
 * To run a mutation, you first call `useHarTransmitterPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harTransmitterPollMutation, { data, loading, error }] = useHarTransmitterPollMutation({
 *   variables: {
 *      transmitters: // value for 'transmitters'
 *   },
 * });
 */
export function useHarTransmitterPollMutation(baseOptions?: Apollo.MutationHookOptions<HarTransmitterPollMutation, HarTransmitterPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarTransmitterPollMutation, HarTransmitterPollMutationVariables>(HarTransmitterPollDocument, options);
      }
export type HarTransmitterPollMutationHookResult = ReturnType<typeof useHarTransmitterPollMutation>;
export type HarTransmitterPollMutationResult = Apollo.MutationResult<HarTransmitterPollMutation>;
export type HarTransmitterPollMutationOptions = Apollo.BaseMutationOptions<HarTransmitterPollMutation, HarTransmitterPollMutationVariables>;
export const HarTransmitterSetPowerLevelDocument = gql`
    mutation HarTransmitterSetPowerLevel($transmitter: ID!, $level: Int!) {
  harTransmitterSetPowerLevel(transmitter: $transmitter, level: $level) {
    success
  }
}
    `;
export type HarTransmitterSetPowerLevelMutationFn = Apollo.MutationFunction<HarTransmitterSetPowerLevelMutation, HarTransmitterSetPowerLevelMutationVariables>;

/**
 * __useHarTransmitterSetPowerLevelMutation__
 *
 * To run a mutation, you first call `useHarTransmitterSetPowerLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterSetPowerLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harTransmitterSetPowerLevelMutation, { data, loading, error }] = useHarTransmitterSetPowerLevelMutation({
 *   variables: {
 *      transmitter: // value for 'transmitter'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useHarTransmitterSetPowerLevelMutation(baseOptions?: Apollo.MutationHookOptions<HarTransmitterSetPowerLevelMutation, HarTransmitterSetPowerLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarTransmitterSetPowerLevelMutation, HarTransmitterSetPowerLevelMutationVariables>(HarTransmitterSetPowerLevelDocument, options);
      }
export type HarTransmitterSetPowerLevelMutationHookResult = ReturnType<typeof useHarTransmitterSetPowerLevelMutation>;
export type HarTransmitterSetPowerLevelMutationResult = Apollo.MutationResult<HarTransmitterSetPowerLevelMutation>;
export type HarTransmitterSetPowerLevelMutationOptions = Apollo.BaseMutationOptions<HarTransmitterSetPowerLevelMutation, HarTransmitterSetPowerLevelMutationVariables>;
export const HarTransmitterSetAttenuatorLevelDocument = gql`
    mutation HarTransmitterSetAttenuatorLevel($transmitter: ID!, $level: Int!) {
  harTransmitterSetAttenuatorLevel(transmitter: $transmitter, level: $level) {
    success
  }
}
    `;
export type HarTransmitterSetAttenuatorLevelMutationFn = Apollo.MutationFunction<HarTransmitterSetAttenuatorLevelMutation, HarTransmitterSetAttenuatorLevelMutationVariables>;

/**
 * __useHarTransmitterSetAttenuatorLevelMutation__
 *
 * To run a mutation, you first call `useHarTransmitterSetAttenuatorLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterSetAttenuatorLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harTransmitterSetAttenuatorLevelMutation, { data, loading, error }] = useHarTransmitterSetAttenuatorLevelMutation({
 *   variables: {
 *      transmitter: // value for 'transmitter'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useHarTransmitterSetAttenuatorLevelMutation(baseOptions?: Apollo.MutationHookOptions<HarTransmitterSetAttenuatorLevelMutation, HarTransmitterSetAttenuatorLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarTransmitterSetAttenuatorLevelMutation, HarTransmitterSetAttenuatorLevelMutationVariables>(HarTransmitterSetAttenuatorLevelDocument, options);
      }
export type HarTransmitterSetAttenuatorLevelMutationHookResult = ReturnType<typeof useHarTransmitterSetAttenuatorLevelMutation>;
export type HarTransmitterSetAttenuatorLevelMutationResult = Apollo.MutationResult<HarTransmitterSetAttenuatorLevelMutation>;
export type HarTransmitterSetAttenuatorLevelMutationOptions = Apollo.BaseMutationOptions<HarTransmitterSetAttenuatorLevelMutation, HarTransmitterSetAttenuatorLevelMutationVariables>;
export const HarTransmitterSetVoiceSpeedDocument = gql`
    mutation HarTransmitterSetVoiceSpeed($transmitter: ID!, $speed: Int!) {
  harTransmitterSetVoiceSpeed(transmitter: $transmitter, speed: $speed) {
    success
  }
}
    `;
export type HarTransmitterSetVoiceSpeedMutationFn = Apollo.MutationFunction<HarTransmitterSetVoiceSpeedMutation, HarTransmitterSetVoiceSpeedMutationVariables>;

/**
 * __useHarTransmitterSetVoiceSpeedMutation__
 *
 * To run a mutation, you first call `useHarTransmitterSetVoiceSpeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterSetVoiceSpeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harTransmitterSetVoiceSpeedMutation, { data, loading, error }] = useHarTransmitterSetVoiceSpeedMutation({
 *   variables: {
 *      transmitter: // value for 'transmitter'
 *      speed: // value for 'speed'
 *   },
 * });
 */
export function useHarTransmitterSetVoiceSpeedMutation(baseOptions?: Apollo.MutationHookOptions<HarTransmitterSetVoiceSpeedMutation, HarTransmitterSetVoiceSpeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarTransmitterSetVoiceSpeedMutation, HarTransmitterSetVoiceSpeedMutationVariables>(HarTransmitterSetVoiceSpeedDocument, options);
      }
export type HarTransmitterSetVoiceSpeedMutationHookResult = ReturnType<typeof useHarTransmitterSetVoiceSpeedMutation>;
export type HarTransmitterSetVoiceSpeedMutationResult = Apollo.MutationResult<HarTransmitterSetVoiceSpeedMutation>;
export type HarTransmitterSetVoiceSpeedMutationOptions = Apollo.BaseMutationOptions<HarTransmitterSetVoiceSpeedMutation, HarTransmitterSetVoiceSpeedMutationVariables>;
export const HarTransmitterEnableWeatherRadioDocument = gql`
    mutation HarTransmitterEnableWeatherRadio($transmitter: ID!, $enabled: Boolean!) {
  harTransmitterSetWeatherRadio(transmitter: $transmitter, enabled: $enabled) {
    success
  }
}
    `;
export type HarTransmitterEnableWeatherRadioMutationFn = Apollo.MutationFunction<HarTransmitterEnableWeatherRadioMutation, HarTransmitterEnableWeatherRadioMutationVariables>;

/**
 * __useHarTransmitterEnableWeatherRadioMutation__
 *
 * To run a mutation, you first call `useHarTransmitterEnableWeatherRadioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterEnableWeatherRadioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harTransmitterEnableWeatherRadioMutation, { data, loading, error }] = useHarTransmitterEnableWeatherRadioMutation({
 *   variables: {
 *      transmitter: // value for 'transmitter'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useHarTransmitterEnableWeatherRadioMutation(baseOptions?: Apollo.MutationHookOptions<HarTransmitterEnableWeatherRadioMutation, HarTransmitterEnableWeatherRadioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarTransmitterEnableWeatherRadioMutation, HarTransmitterEnableWeatherRadioMutationVariables>(HarTransmitterEnableWeatherRadioDocument, options);
      }
export type HarTransmitterEnableWeatherRadioMutationHookResult = ReturnType<typeof useHarTransmitterEnableWeatherRadioMutation>;
export type HarTransmitterEnableWeatherRadioMutationResult = Apollo.MutationResult<HarTransmitterEnableWeatherRadioMutation>;
export type HarTransmitterEnableWeatherRadioMutationOptions = Apollo.BaseMutationOptions<HarTransmitterEnableWeatherRadioMutation, HarTransmitterEnableWeatherRadioMutationVariables>;
export const HarTransmitterPostDocument = gql`
    mutation HarTransmitterPost($post: [HarTransmitterPostInput!]!) {
  harTransmitterPostPlaylist(post: $post) {
    success
  }
}
    `;
export type HarTransmitterPostMutationFn = Apollo.MutationFunction<HarTransmitterPostMutation, HarTransmitterPostMutationVariables>;

/**
 * __useHarTransmitterPostMutation__
 *
 * To run a mutation, you first call `useHarTransmitterPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harTransmitterPostMutation, { data, loading, error }] = useHarTransmitterPostMutation({
 *   variables: {
 *      post: // value for 'post'
 *   },
 * });
 */
export function useHarTransmitterPostMutation(baseOptions?: Apollo.MutationHookOptions<HarTransmitterPostMutation, HarTransmitterPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarTransmitterPostMutation, HarTransmitterPostMutationVariables>(HarTransmitterPostDocument, options);
      }
export type HarTransmitterPostMutationHookResult = ReturnType<typeof useHarTransmitterPostMutation>;
export type HarTransmitterPostMutationResult = Apollo.MutationResult<HarTransmitterPostMutation>;
export type HarTransmitterPostMutationOptions = Apollo.BaseMutationOptions<HarTransmitterPostMutation, HarTransmitterPostMutationVariables>;
export const HarTransmitterBlankDocument = gql`
    mutation HarTransmitterBlank($transmitters: [ID!]!) {
  harTransmitterBlank(transmitters: $transmitters) {
    success
  }
}
    `;
export type HarTransmitterBlankMutationFn = Apollo.MutationFunction<HarTransmitterBlankMutation, HarTransmitterBlankMutationVariables>;

/**
 * __useHarTransmitterBlankMutation__
 *
 * To run a mutation, you first call `useHarTransmitterBlankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterBlankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harTransmitterBlankMutation, { data, loading, error }] = useHarTransmitterBlankMutation({
 *   variables: {
 *      transmitters: // value for 'transmitters'
 *   },
 * });
 */
export function useHarTransmitterBlankMutation(baseOptions?: Apollo.MutationHookOptions<HarTransmitterBlankMutation, HarTransmitterBlankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarTransmitterBlankMutation, HarTransmitterBlankMutationVariables>(HarTransmitterBlankDocument, options);
      }
export type HarTransmitterBlankMutationHookResult = ReturnType<typeof useHarTransmitterBlankMutation>;
export type HarTransmitterBlankMutationResult = Apollo.MutationResult<HarTransmitterBlankMutation>;
export type HarTransmitterBlankMutationOptions = Apollo.BaseMutationOptions<HarTransmitterBlankMutation, HarTransmitterBlankMutationVariables>;
export const HarTransmitterRemoveDocument = gql`
    mutation HarTransmitterRemove($playlists: [ID!]!, $transmitter: ID!) {
  harTransmitterRemovePlaylist(transmitter: $transmitter, playlists: $playlists) {
    success
  }
}
    `;
export type HarTransmitterRemoveMutationFn = Apollo.MutationFunction<HarTransmitterRemoveMutation, HarTransmitterRemoveMutationVariables>;

/**
 * __useHarTransmitterRemoveMutation__
 *
 * To run a mutation, you first call `useHarTransmitterRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harTransmitterRemoveMutation, { data, loading, error }] = useHarTransmitterRemoveMutation({
 *   variables: {
 *      playlists: // value for 'playlists'
 *      transmitter: // value for 'transmitter'
 *   },
 * });
 */
export function useHarTransmitterRemoveMutation(baseOptions?: Apollo.MutationHookOptions<HarTransmitterRemoveMutation, HarTransmitterRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarTransmitterRemoveMutation, HarTransmitterRemoveMutationVariables>(HarTransmitterRemoveDocument, options);
      }
export type HarTransmitterRemoveMutationHookResult = ReturnType<typeof useHarTransmitterRemoveMutation>;
export type HarTransmitterRemoveMutationResult = Apollo.MutationResult<HarTransmitterRemoveMutation>;
export type HarTransmitterRemoveMutationOptions = Apollo.BaseMutationOptions<HarTransmitterRemoveMutation, HarTransmitterRemoveMutationVariables>;
export const HarTransmitterListDocument = gql`
    query HarTransmitterList($searchFields: [String!] = ["name", "road", "direction", "referencePoint"], $sortField: String = "lastDataReceived", $sortOrder: SortOrder = DESCENDING, $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  harTransmitters(
    query: {searchFields: $searchFields, searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        communicationStatus
        currentPlaylist {
          priority {
            priority
          }
          name
        }
        lastDataReceived
        broadcastState
        referencePoint
        lastOperation
        commandState
        syncState
        direction
        road
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useHarTransmitterListQuery__
 *
 * To run a query within a React component, call `useHarTransmitterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarTransmitterListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useHarTransmitterListQuery(baseOptions?: Apollo.QueryHookOptions<HarTransmitterListQuery, HarTransmitterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarTransmitterListQuery, HarTransmitterListQueryVariables>(HarTransmitterListDocument, options);
      }
export function useHarTransmitterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarTransmitterListQuery, HarTransmitterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarTransmitterListQuery, HarTransmitterListQueryVariables>(HarTransmitterListDocument, options);
        }
export type HarTransmitterListQueryHookResult = ReturnType<typeof useHarTransmitterListQuery>;
export type HarTransmitterListLazyQueryHookResult = ReturnType<typeof useHarTransmitterListLazyQuery>;
export type HarTransmitterListQueryResult = Apollo.QueryResult<HarTransmitterListQuery, HarTransmitterListQueryVariables>;
export function refetchHarTransmitterListQuery(variables?: HarTransmitterListQueryVariables) {
      return { query: HarTransmitterListDocument, variables: variables }
    }
export const LiveHarTransmitterListDocument = gql`
    subscription LiveHarTransmitterList($ids: [ID!]) {
  harTransmitterUpdated(ids: $ids) {
    communicationStatus
    currentPlaylist {
      priority {
        priority
      }
      name
    }
    lastDataReceived
    referencePoint
    broadcastState
    lastOperation
    commandState
    syncState
    direction
    road
    name
    id
  }
}
    `;

/**
 * __useLiveHarTransmitterListSubscription__
 *
 * To run a query within a React component, call `useLiveHarTransmitterListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveHarTransmitterListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveHarTransmitterListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveHarTransmitterListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveHarTransmitterListSubscription, LiveHarTransmitterListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveHarTransmitterListSubscription, LiveHarTransmitterListSubscriptionVariables>(LiveHarTransmitterListDocument, options);
      }
export type LiveHarTransmitterListSubscriptionHookResult = ReturnType<typeof useLiveHarTransmitterListSubscription>;
export type LiveHarTransmitterListSubscriptionResult = Apollo.SubscriptionResult<LiveHarTransmitterListSubscription>;
export const HarTransmitterMapDocument = gql`
    query HarTransmitterMap($filters: [FilterInput!], $searchText: String, $limit: Int = 10000) {
  harTransmitters(
    query: {searchText: $searchText, filters: $filters, limit: $limit}
  ) {
    edges {
      node {
        broadcastState
        location
        name
        id
      }
    }
  }
}
    `;

/**
 * __useHarTransmitterMapQuery__
 *
 * To run a query within a React component, call `useHarTransmitterMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarTransmitterMapQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useHarTransmitterMapQuery(baseOptions?: Apollo.QueryHookOptions<HarTransmitterMapQuery, HarTransmitterMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarTransmitterMapQuery, HarTransmitterMapQueryVariables>(HarTransmitterMapDocument, options);
      }
export function useHarTransmitterMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarTransmitterMapQuery, HarTransmitterMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarTransmitterMapQuery, HarTransmitterMapQueryVariables>(HarTransmitterMapDocument, options);
        }
export type HarTransmitterMapQueryHookResult = ReturnType<typeof useHarTransmitterMapQuery>;
export type HarTransmitterMapLazyQueryHookResult = ReturnType<typeof useHarTransmitterMapLazyQuery>;
export type HarTransmitterMapQueryResult = Apollo.QueryResult<HarTransmitterMapQuery, HarTransmitterMapQueryVariables>;
export function refetchHarTransmitterMapQuery(variables?: HarTransmitterMapQueryVariables) {
      return { query: HarTransmitterMapDocument, variables: variables }
    }
export const LiveHarTransmitterMapDocument = gql`
    subscription LiveHarTransmitterMap($ids: [ID!]) {
  harTransmitterUpdated(ids: $ids) {
    broadcastState
    location
    name
    id
  }
}
    `;

/**
 * __useLiveHarTransmitterMapSubscription__
 *
 * To run a query within a React component, call `useLiveHarTransmitterMapSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveHarTransmitterMapSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveHarTransmitterMapSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveHarTransmitterMapSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveHarTransmitterMapSubscription, LiveHarTransmitterMapSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveHarTransmitterMapSubscription, LiveHarTransmitterMapSubscriptionVariables>(LiveHarTransmitterMapDocument, options);
      }
export type LiveHarTransmitterMapSubscriptionHookResult = ReturnType<typeof useLiveHarTransmitterMapSubscription>;
export type LiveHarTransmitterMapSubscriptionResult = Apollo.SubscriptionResult<LiveHarTransmitterMapSubscription>;
export const HarTransmitterSummaryDocument = gql`
    query HarTransmitterSummary {
  STATE_QUIET: harTransmitters(
    query: {filters: [{operator: EQUALS, field: "broadcastState", value: "STATE_QUIET"}]}
  ) {
    totalCount
  }
  STATE_PLAYING: harTransmitters(
    query: {filters: [{operator: EQUALS, field: "broadcastState", value: "STATE_PLAYING"}]}
  ) {
    totalCount
  }
  WEATHER_RADIO: harTransmitters(
    query: {filters: [{operator: EQUALS, field: "broadcastState", value: "WEATHER_RADIO"}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useHarTransmitterSummaryQuery__
 *
 * To run a query within a React component, call `useHarTransmitterSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarTransmitterSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useHarTransmitterSummaryQuery(baseOptions?: Apollo.QueryHookOptions<HarTransmitterSummaryQuery, HarTransmitterSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarTransmitterSummaryQuery, HarTransmitterSummaryQueryVariables>(HarTransmitterSummaryDocument, options);
      }
export function useHarTransmitterSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarTransmitterSummaryQuery, HarTransmitterSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarTransmitterSummaryQuery, HarTransmitterSummaryQueryVariables>(HarTransmitterSummaryDocument, options);
        }
export type HarTransmitterSummaryQueryHookResult = ReturnType<typeof useHarTransmitterSummaryQuery>;
export type HarTransmitterSummaryLazyQueryHookResult = ReturnType<typeof useHarTransmitterSummaryLazyQuery>;
export type HarTransmitterSummaryQueryResult = Apollo.QueryResult<HarTransmitterSummaryQuery, HarTransmitterSummaryQueryVariables>;
export function refetchHarTransmitterSummaryQuery(variables?: HarTransmitterSummaryQueryVariables) {
      return { query: HarTransmitterSummaryDocument, variables: variables }
    }
export const HarTransmitterDetailDocument = gql`
    query HarTransmitterDetail($id: ID!) {
  harTransmitter(id: $id) {
    currentPlaylist {
      ...HarQueuedPlaylist
    }
    queuedPlaylists {
      ...HarQueuedPlaylist
    }
    communicationStatus
    lastDataReceived
    attenuatorLevel
    referencePoint
    broadcastState
    hardwareState
    lastOperation
    commandState
    voiceSpeed
    powerLevel
    syncState
    direction
    location
    road
    name
    id
  }
}
    ${HarQueuedPlaylistFragmentDoc}`;

/**
 * __useHarTransmitterDetailQuery__
 *
 * To run a query within a React component, call `useHarTransmitterDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarTransmitterDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarTransmitterDetailQuery(baseOptions: Apollo.QueryHookOptions<HarTransmitterDetailQuery, HarTransmitterDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarTransmitterDetailQuery, HarTransmitterDetailQueryVariables>(HarTransmitterDetailDocument, options);
      }
export function useHarTransmitterDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarTransmitterDetailQuery, HarTransmitterDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarTransmitterDetailQuery, HarTransmitterDetailQueryVariables>(HarTransmitterDetailDocument, options);
        }
export type HarTransmitterDetailQueryHookResult = ReturnType<typeof useHarTransmitterDetailQuery>;
export type HarTransmitterDetailLazyQueryHookResult = ReturnType<typeof useHarTransmitterDetailLazyQuery>;
export type HarTransmitterDetailQueryResult = Apollo.QueryResult<HarTransmitterDetailQuery, HarTransmitterDetailQueryVariables>;
export function refetchHarTransmitterDetailQuery(variables: HarTransmitterDetailQueryVariables) {
      return { query: HarTransmitterDetailDocument, variables: variables }
    }
export const LiveHarTransmitterDetailDocument = gql`
    subscription LiveHarTransmitterDetail($id: ID!) {
  harTransmitterUpdated(ids: [$id]) {
    currentPlaylist {
      ...HarQueuedPlaylist
    }
    queuedPlaylists {
      ...HarQueuedPlaylist
    }
    communicationStatus
    lastDataReceived
    attenuatorLevel
    referencePoint
    broadcastState
    hardwareState
    lastOperation
    commandState
    voiceSpeed
    powerLevel
    syncState
    direction
    location
    road
    name
    id
  }
}
    ${HarQueuedPlaylistFragmentDoc}`;

/**
 * __useLiveHarTransmitterDetailSubscription__
 *
 * To run a query within a React component, call `useLiveHarTransmitterDetailSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveHarTransmitterDetailSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveHarTransmitterDetailSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveHarTransmitterDetailSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveHarTransmitterDetailSubscription, LiveHarTransmitterDetailSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveHarTransmitterDetailSubscription, LiveHarTransmitterDetailSubscriptionVariables>(LiveHarTransmitterDetailDocument, options);
      }
export type LiveHarTransmitterDetailSubscriptionHookResult = ReturnType<typeof useLiveHarTransmitterDetailSubscription>;
export type LiveHarTransmitterDetailSubscriptionResult = Apollo.SubscriptionResult<LiveHarTransmitterDetailSubscription>;
export const HarTransmitterHistoryListDocument = gql`
    query HarTransmitterHistoryList($searchFields: [String!] = ["broadcastState", "communicationStatus"], $sortOrder: SortOrder = DESCENDING, $sortField: String = "timestamp", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  harTransmitterStateHistory(
    query: {searchFields: $searchFields, searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        communicationState
        broadcastState
        timestamp
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useHarTransmitterHistoryListQuery__
 *
 * To run a query within a React component, call `useHarTransmitterHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarTransmitterHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarTransmitterHistoryListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useHarTransmitterHistoryListQuery(baseOptions?: Apollo.QueryHookOptions<HarTransmitterHistoryListQuery, HarTransmitterHistoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarTransmitterHistoryListQuery, HarTransmitterHistoryListQueryVariables>(HarTransmitterHistoryListDocument, options);
      }
export function useHarTransmitterHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarTransmitterHistoryListQuery, HarTransmitterHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarTransmitterHistoryListQuery, HarTransmitterHistoryListQueryVariables>(HarTransmitterHistoryListDocument, options);
        }
export type HarTransmitterHistoryListQueryHookResult = ReturnType<typeof useHarTransmitterHistoryListQuery>;
export type HarTransmitterHistoryListLazyQueryHookResult = ReturnType<typeof useHarTransmitterHistoryListLazyQuery>;
export type HarTransmitterHistoryListQueryResult = Apollo.QueryResult<HarTransmitterHistoryListQuery, HarTransmitterHistoryListQueryVariables>;
export function refetchHarTransmitterHistoryListQuery(variables?: HarTransmitterHistoryListQueryVariables) {
      return { query: HarTransmitterHistoryListDocument, variables: variables }
    }
export const SaveIntegrationGroupDocument = gql`
    mutation SaveIntegrationGroup($input: IntegrationGroupInput!) {
  saveIntegrationGroup(input: $input) {
    id
    name
    description
    integrations {
      id
      name
    }
  }
}
    `;
export type SaveIntegrationGroupMutationFn = Apollo.MutationFunction<SaveIntegrationGroupMutation, SaveIntegrationGroupMutationVariables>;

/**
 * __useSaveIntegrationGroupMutation__
 *
 * To run a mutation, you first call `useSaveIntegrationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveIntegrationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveIntegrationGroupMutation, { data, loading, error }] = useSaveIntegrationGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveIntegrationGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveIntegrationGroupMutation, SaveIntegrationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveIntegrationGroupMutation, SaveIntegrationGroupMutationVariables>(SaveIntegrationGroupDocument, options);
      }
export type SaveIntegrationGroupMutationHookResult = ReturnType<typeof useSaveIntegrationGroupMutation>;
export type SaveIntegrationGroupMutationResult = Apollo.MutationResult<SaveIntegrationGroupMutation>;
export type SaveIntegrationGroupMutationOptions = Apollo.BaseMutationOptions<SaveIntegrationGroupMutation, SaveIntegrationGroupMutationVariables>;
export const DeleteIntegrationGroupDocument = gql`
    mutation DeleteIntegrationGroup($id: ID!) {
  deleteIntegrationGroup(id: $id)
}
    `;
export type DeleteIntegrationGroupMutationFn = Apollo.MutationFunction<DeleteIntegrationGroupMutation, DeleteIntegrationGroupMutationVariables>;

/**
 * __useDeleteIntegrationGroupMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationGroupMutation, { data, loading, error }] = useDeleteIntegrationGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntegrationGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntegrationGroupMutation, DeleteIntegrationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntegrationGroupMutation, DeleteIntegrationGroupMutationVariables>(DeleteIntegrationGroupDocument, options);
      }
export type DeleteIntegrationGroupMutationHookResult = ReturnType<typeof useDeleteIntegrationGroupMutation>;
export type DeleteIntegrationGroupMutationResult = Apollo.MutationResult<DeleteIntegrationGroupMutation>;
export type DeleteIntegrationGroupMutationOptions = Apollo.BaseMutationOptions<DeleteIntegrationGroupMutation, DeleteIntegrationGroupMutationVariables>;
export const IntegrationGroupsListDocument = gql`
    query IntegrationGroupsList($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $searchText: String) {
  integrationGroups(
    after: $after
    before: $before
    limit: $limit
    sortOrder: $sortOrder
    searchText: $searchText
  ) {
    edges {
      node {
        id
        name
        description
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useIntegrationGroupsListQuery__
 *
 * To run a query within a React component, call `useIntegrationGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationGroupsListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useIntegrationGroupsListQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationGroupsListQuery, IntegrationGroupsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationGroupsListQuery, IntegrationGroupsListQueryVariables>(IntegrationGroupsListDocument, options);
      }
export function useIntegrationGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationGroupsListQuery, IntegrationGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationGroupsListQuery, IntegrationGroupsListQueryVariables>(IntegrationGroupsListDocument, options);
        }
export type IntegrationGroupsListQueryHookResult = ReturnType<typeof useIntegrationGroupsListQuery>;
export type IntegrationGroupsListLazyQueryHookResult = ReturnType<typeof useIntegrationGroupsListLazyQuery>;
export type IntegrationGroupsListQueryResult = Apollo.QueryResult<IntegrationGroupsListQuery, IntegrationGroupsListQueryVariables>;
export function refetchIntegrationGroupsListQuery(variables?: IntegrationGroupsListQueryVariables) {
      return { query: IntegrationGroupsListDocument, variables: variables }
    }
export const GetIntegrationGroupDocument = gql`
    query GetIntegrationGroup($id: ID!) {
  integrationGroup(id: $id) {
    id
    name
    description
    integrations {
      id
      name
      description
      config {
        integrationType
      }
    }
  }
}
    `;

/**
 * __useGetIntegrationGroupQuery__
 *
 * To run a query within a React component, call `useGetIntegrationGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationGroupQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationGroupQuery, GetIntegrationGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationGroupQuery, GetIntegrationGroupQueryVariables>(GetIntegrationGroupDocument, options);
      }
export function useGetIntegrationGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationGroupQuery, GetIntegrationGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationGroupQuery, GetIntegrationGroupQueryVariables>(GetIntegrationGroupDocument, options);
        }
export type GetIntegrationGroupQueryHookResult = ReturnType<typeof useGetIntegrationGroupQuery>;
export type GetIntegrationGroupLazyQueryHookResult = ReturnType<typeof useGetIntegrationGroupLazyQuery>;
export type GetIntegrationGroupQueryResult = Apollo.QueryResult<GetIntegrationGroupQuery, GetIntegrationGroupQueryVariables>;
export function refetchGetIntegrationGroupQuery(variables: GetIntegrationGroupQueryVariables) {
      return { query: GetIntegrationGroupDocument, variables: variables }
    }
export const GetIntegrationStateDocument = gql`
    query GetIntegrationState($id: ID!) {
  integration(id: $id) {
    ...IntegrationAndState
  }
}
    ${IntegrationAndStateFragmentDoc}`;

/**
 * __useGetIntegrationStateQuery__
 *
 * To run a query within a React component, call `useGetIntegrationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationStateQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>(GetIntegrationStateDocument, options);
      }
export function useGetIntegrationStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>(GetIntegrationStateDocument, options);
        }
export type GetIntegrationStateQueryHookResult = ReturnType<typeof useGetIntegrationStateQuery>;
export type GetIntegrationStateLazyQueryHookResult = ReturnType<typeof useGetIntegrationStateLazyQuery>;
export type GetIntegrationStateQueryResult = Apollo.QueryResult<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>;
export function refetchGetIntegrationStateQuery(variables: GetIntegrationStateQueryVariables) {
      return { query: GetIntegrationStateDocument, variables: variables }
    }
export const SaveIntegrationDocument = gql`
    mutation SaveIntegration($input: IntegrationsInput!) {
  saveIntegration(input: $input) {
    ...SavedIntegration
  }
}
    ${SavedIntegrationFragmentDoc}`;
export type SaveIntegrationMutationFn = Apollo.MutationFunction<SaveIntegrationMutation, SaveIntegrationMutationVariables>;

/**
 * __useSaveIntegrationMutation__
 *
 * To run a mutation, you first call `useSaveIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveIntegrationMutation, { data, loading, error }] = useSaveIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SaveIntegrationMutation, SaveIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveIntegrationMutation, SaveIntegrationMutationVariables>(SaveIntegrationDocument, options);
      }
export type SaveIntegrationMutationHookResult = ReturnType<typeof useSaveIntegrationMutation>;
export type SaveIntegrationMutationResult = Apollo.MutationResult<SaveIntegrationMutation>;
export type SaveIntegrationMutationOptions = Apollo.BaseMutationOptions<SaveIntegrationMutation, SaveIntegrationMutationVariables>;
export const EnableIntegrationsDocument = gql`
    mutation EnableIntegrations($ids: [ID!]!, $enabled: Boolean!) {
  enableIntegrations(ids: $ids, enabled: $enabled) {
    ...SavedIntegration
  }
}
    ${SavedIntegrationFragmentDoc}`;
export type EnableIntegrationsMutationFn = Apollo.MutationFunction<EnableIntegrationsMutation, EnableIntegrationsMutationVariables>;

/**
 * __useEnableIntegrationsMutation__
 *
 * To run a mutation, you first call `useEnableIntegrationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableIntegrationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableIntegrationsMutation, { data, loading, error }] = useEnableIntegrationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useEnableIntegrationsMutation(baseOptions?: Apollo.MutationHookOptions<EnableIntegrationsMutation, EnableIntegrationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableIntegrationsMutation, EnableIntegrationsMutationVariables>(EnableIntegrationsDocument, options);
      }
export type EnableIntegrationsMutationHookResult = ReturnType<typeof useEnableIntegrationsMutation>;
export type EnableIntegrationsMutationResult = Apollo.MutationResult<EnableIntegrationsMutation>;
export type EnableIntegrationsMutationOptions = Apollo.BaseMutationOptions<EnableIntegrationsMutation, EnableIntegrationsMutationVariables>;
export const DeleteIntegrationDocument = gql`
    mutation DeleteIntegration($id: ID!) {
  deleteIntegration(id: $id)
}
    `;
export type DeleteIntegrationMutationFn = Apollo.MutationFunction<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>;

/**
 * __useDeleteIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationMutation, { data, loading, error }] = useDeleteIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>(DeleteIntegrationDocument, options);
      }
export type DeleteIntegrationMutationHookResult = ReturnType<typeof useDeleteIntegrationMutation>;
export type DeleteIntegrationMutationResult = Apollo.MutationResult<DeleteIntegrationMutation>;
export type DeleteIntegrationMutationOptions = Apollo.BaseMutationOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>;
export const ImportIntegrationsJsonDocument = gql`
    mutation ImportIntegrationsJson($integrations: String!) {
  importIntegrationsFromJson(input: $integrations)
}
    `;
export type ImportIntegrationsJsonMutationFn = Apollo.MutationFunction<ImportIntegrationsJsonMutation, ImportIntegrationsJsonMutationVariables>;

/**
 * __useImportIntegrationsJsonMutation__
 *
 * To run a mutation, you first call `useImportIntegrationsJsonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportIntegrationsJsonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importIntegrationsJsonMutation, { data, loading, error }] = useImportIntegrationsJsonMutation({
 *   variables: {
 *      integrations: // value for 'integrations'
 *   },
 * });
 */
export function useImportIntegrationsJsonMutation(baseOptions?: Apollo.MutationHookOptions<ImportIntegrationsJsonMutation, ImportIntegrationsJsonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportIntegrationsJsonMutation, ImportIntegrationsJsonMutationVariables>(ImportIntegrationsJsonDocument, options);
      }
export type ImportIntegrationsJsonMutationHookResult = ReturnType<typeof useImportIntegrationsJsonMutation>;
export type ImportIntegrationsJsonMutationResult = Apollo.MutationResult<ImportIntegrationsJsonMutation>;
export type ImportIntegrationsJsonMutationOptions = Apollo.BaseMutationOptions<ImportIntegrationsJsonMutation, ImportIntegrationsJsonMutationVariables>;
export const IntegrationControllerPollDocument = gql`
    mutation IntegrationControllerPoll($ids: [ID!]!, $integrationType: IntegrationType!) {
  multiplePoll(ids: $ids, integrationType: $integrationType) {
    requestId
    success
    failure
    id
  }
}
    `;
export type IntegrationControllerPollMutationFn = Apollo.MutationFunction<IntegrationControllerPollMutation, IntegrationControllerPollMutationVariables>;

/**
 * __useIntegrationControllerPollMutation__
 *
 * To run a mutation, you first call `useIntegrationControllerPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationControllerPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationControllerPollMutation, { data, loading, error }] = useIntegrationControllerPollMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useIntegrationControllerPollMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationControllerPollMutation, IntegrationControllerPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationControllerPollMutation, IntegrationControllerPollMutationVariables>(IntegrationControllerPollDocument, options);
      }
export type IntegrationControllerPollMutationHookResult = ReturnType<typeof useIntegrationControllerPollMutation>;
export type IntegrationControllerPollMutationResult = Apollo.MutationResult<IntegrationControllerPollMutation>;
export type IntegrationControllerPollMutationOptions = Apollo.BaseMutationOptions<IntegrationControllerPollMutation, IntegrationControllerPollMutationVariables>;
export const GetIntegrationDocument = gql`
    query GetIntegration($id: ID!) {
  integration(id: $id) {
    ...SavedIntegration
  }
}
    ${SavedIntegrationFragmentDoc}`;

/**
 * __useGetIntegrationQuery__
 *
 * To run a query within a React component, call `useGetIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
      }
export function useGetIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
        }
export type GetIntegrationQueryHookResult = ReturnType<typeof useGetIntegrationQuery>;
export type GetIntegrationLazyQueryHookResult = ReturnType<typeof useGetIntegrationLazyQuery>;
export type GetIntegrationQueryResult = Apollo.QueryResult<GetIntegrationQuery, GetIntegrationQueryVariables>;
export function refetchGetIntegrationQuery(variables: GetIntegrationQueryVariables) {
      return { query: GetIntegrationDocument, variables: variables }
    }
export const GetIntegrationDetailsDocument = gql`
    query GetIntegrationDetails($id: ID!) {
  integration(id: $id) {
    id
    name
    description
    assetIdentifier
  }
}
    `;

/**
 * __useGetIntegrationDetailsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationDetailsQuery, GetIntegrationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationDetailsQuery, GetIntegrationDetailsQueryVariables>(GetIntegrationDetailsDocument, options);
      }
export function useGetIntegrationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationDetailsQuery, GetIntegrationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationDetailsQuery, GetIntegrationDetailsQueryVariables>(GetIntegrationDetailsDocument, options);
        }
export type GetIntegrationDetailsQueryHookResult = ReturnType<typeof useGetIntegrationDetailsQuery>;
export type GetIntegrationDetailsLazyQueryHookResult = ReturnType<typeof useGetIntegrationDetailsLazyQuery>;
export type GetIntegrationDetailsQueryResult = Apollo.QueryResult<GetIntegrationDetailsQuery, GetIntegrationDetailsQueryVariables>;
export function refetchGetIntegrationDetailsQuery(variables: GetIntegrationDetailsQueryVariables) {
      return { query: GetIntegrationDetailsDocument, variables: variables }
    }
export const AllProtocolsDocument = gql`
    query AllProtocols {
  integrationForms(limit: 10000) {
    edges {
      node {
        id
        name
        integrationType
      }
    }
  }
}
    `;

/**
 * __useAllProtocolsQuery__
 *
 * To run a query within a React component, call `useAllProtocolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProtocolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProtocolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProtocolsQuery(baseOptions?: Apollo.QueryHookOptions<AllProtocolsQuery, AllProtocolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProtocolsQuery, AllProtocolsQueryVariables>(AllProtocolsDocument, options);
      }
export function useAllProtocolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProtocolsQuery, AllProtocolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProtocolsQuery, AllProtocolsQueryVariables>(AllProtocolsDocument, options);
        }
export type AllProtocolsQueryHookResult = ReturnType<typeof useAllProtocolsQuery>;
export type AllProtocolsLazyQueryHookResult = ReturnType<typeof useAllProtocolsLazyQuery>;
export type AllProtocolsQueryResult = Apollo.QueryResult<AllProtocolsQuery, AllProtocolsQueryVariables>;
export function refetchAllProtocolsQuery(variables?: AllProtocolsQueryVariables) {
      return { query: AllProtocolsDocument, variables: variables }
    }
export const IntegrationFormDocument = gql`
    query IntegrationForm($id: String!) {
  integrationForm(id: $id) {
    ...IntegrationsForm
  }
}
    ${IntegrationsFormFragmentDoc}`;

/**
 * __useIntegrationFormQuery__
 *
 * To run a query within a React component, call `useIntegrationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationFormQuery(baseOptions: Apollo.QueryHookOptions<IntegrationFormQuery, IntegrationFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationFormQuery, IntegrationFormQueryVariables>(IntegrationFormDocument, options);
      }
export function useIntegrationFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationFormQuery, IntegrationFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationFormQuery, IntegrationFormQueryVariables>(IntegrationFormDocument, options);
        }
export type IntegrationFormQueryHookResult = ReturnType<typeof useIntegrationFormQuery>;
export type IntegrationFormLazyQueryHookResult = ReturnType<typeof useIntegrationFormLazyQuery>;
export type IntegrationFormQueryResult = Apollo.QueryResult<IntegrationFormQuery, IntegrationFormQueryVariables>;
export function refetchIntegrationFormQuery(variables: IntegrationFormQueryVariables) {
      return { query: IntegrationFormDocument, variables: variables }
    }
export const IntegrationsListDocument = gql`
    query IntegrationsList($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String, $searchText: String, $searchFields: [String!], $filters: [FilterInput]) {
  integrations(
    after: $after
    before: $before
    limit: $limit
    sortOrder: $sortOrder
    sortField: $sortField
    searchText: $searchText
    searchFields: $searchFields
    filters: $filters
  ) {
    edges {
      node {
        id
        name
        description
        systemEnabled
        assetIdentifier
        state {
          current
        }
        config {
          form {
            id
            name
          }
          settings
          location
          integrationType
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useIntegrationsListQuery__
 *
 * To run a query within a React component, call `useIntegrationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useIntegrationsListQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationsListQuery, IntegrationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsListQuery, IntegrationsListQueryVariables>(IntegrationsListDocument, options);
      }
export function useIntegrationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsListQuery, IntegrationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsListQuery, IntegrationsListQueryVariables>(IntegrationsListDocument, options);
        }
export type IntegrationsListQueryHookResult = ReturnType<typeof useIntegrationsListQuery>;
export type IntegrationsListLazyQueryHookResult = ReturnType<typeof useIntegrationsListLazyQuery>;
export type IntegrationsListQueryResult = Apollo.QueryResult<IntegrationsListQuery, IntegrationsListQueryVariables>;
export function refetchIntegrationsListQuery(variables?: IntegrationsListQueryVariables) {
      return { query: IntegrationsListDocument, variables: variables }
    }
export const IntegrationsSelectionDocument = gql`
    query IntegrationsSelection($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput!]) {
  integrations(
    after: $after
    before: $before
    limit: $limit
    sortOrder: $sortOrder
    searchText: $searchText
    filters: $filters
  ) {
    edges {
      node {
        id
        name
        config {
          integrationType
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useIntegrationsSelectionQuery__
 *
 * To run a query within a React component, call `useIntegrationsSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsSelectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useIntegrationsSelectionQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationsSelectionQuery, IntegrationsSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsSelectionQuery, IntegrationsSelectionQueryVariables>(IntegrationsSelectionDocument, options);
      }
export function useIntegrationsSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsSelectionQuery, IntegrationsSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsSelectionQuery, IntegrationsSelectionQueryVariables>(IntegrationsSelectionDocument, options);
        }
export type IntegrationsSelectionQueryHookResult = ReturnType<typeof useIntegrationsSelectionQuery>;
export type IntegrationsSelectionLazyQueryHookResult = ReturnType<typeof useIntegrationsSelectionLazyQuery>;
export type IntegrationsSelectionQueryResult = Apollo.QueryResult<IntegrationsSelectionQuery, IntegrationsSelectionQueryVariables>;
export function refetchIntegrationsSelectionQuery(variables?: IntegrationsSelectionQueryVariables) {
      return { query: IntegrationsSelectionDocument, variables: variables }
    }
export const GetBasicIntegrationGroupsDocument = gql`
    query GetBasicIntegrationGroups($after: String, $before: String, $limit: Int = 10, $sortField: String, $sortOrder: SortOrder, $searchText: String) {
  integrationGroups(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
  ) {
    edges {
      node {
        id
        name
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGetBasicIntegrationGroupsQuery__
 *
 * To run a query within a React component, call `useGetBasicIntegrationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicIntegrationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicIntegrationGroupsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetBasicIntegrationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetBasicIntegrationGroupsQuery, GetBasicIntegrationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicIntegrationGroupsQuery, GetBasicIntegrationGroupsQueryVariables>(GetBasicIntegrationGroupsDocument, options);
      }
export function useGetBasicIntegrationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicIntegrationGroupsQuery, GetBasicIntegrationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicIntegrationGroupsQuery, GetBasicIntegrationGroupsQueryVariables>(GetBasicIntegrationGroupsDocument, options);
        }
export type GetBasicIntegrationGroupsQueryHookResult = ReturnType<typeof useGetBasicIntegrationGroupsQuery>;
export type GetBasicIntegrationGroupsLazyQueryHookResult = ReturnType<typeof useGetBasicIntegrationGroupsLazyQuery>;
export type GetBasicIntegrationGroupsQueryResult = Apollo.QueryResult<GetBasicIntegrationGroupsQuery, GetBasicIntegrationGroupsQueryVariables>;
export function refetchGetBasicIntegrationGroupsQuery(variables?: GetBasicIntegrationGroupsQueryVariables) {
      return { query: GetBasicIntegrationGroupsDocument, variables: variables }
    }
export const IntegrationFormLocationRoutesDocument = gql`
    query IntegrationFormLocationRoutes {
  locationRoutes(query: {limit: 10000}) {
    edges {
      node {
        nativeId
        label
        name
        direction
      }
    }
  }
}
    `;

/**
 * __useIntegrationFormLocationRoutesQuery__
 *
 * To run a query within a React component, call `useIntegrationFormLocationRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationFormLocationRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationFormLocationRoutesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationFormLocationRoutesQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationFormLocationRoutesQuery, IntegrationFormLocationRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationFormLocationRoutesQuery, IntegrationFormLocationRoutesQueryVariables>(IntegrationFormLocationRoutesDocument, options);
      }
export function useIntegrationFormLocationRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationFormLocationRoutesQuery, IntegrationFormLocationRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationFormLocationRoutesQuery, IntegrationFormLocationRoutesQueryVariables>(IntegrationFormLocationRoutesDocument, options);
        }
export type IntegrationFormLocationRoutesQueryHookResult = ReturnType<typeof useIntegrationFormLocationRoutesQuery>;
export type IntegrationFormLocationRoutesLazyQueryHookResult = ReturnType<typeof useIntegrationFormLocationRoutesLazyQuery>;
export type IntegrationFormLocationRoutesQueryResult = Apollo.QueryResult<IntegrationFormLocationRoutesQuery, IntegrationFormLocationRoutesQueryVariables>;
export function refetchIntegrationFormLocationRoutesQuery(variables?: IntegrationFormLocationRoutesQueryVariables) {
      return { query: IntegrationFormLocationRoutesDocument, variables: variables }
    }
export const IntegrationUpdatedDocument = gql`
    subscription IntegrationUpdated($ids: [ID!]!) {
  integrationUpdated(ids: $ids) {
    id
    name
    description
    systemEnabled
    assetIdentifier
    state {
      current
    }
    config {
      form {
        id
        name
      }
      settings
      location
      integrationType
    }
  }
}
    `;

/**
 * __useIntegrationUpdatedSubscription__
 *
 * To run a query within a React component, call `useIntegrationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useIntegrationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IntegrationUpdatedSubscription, IntegrationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IntegrationUpdatedSubscription, IntegrationUpdatedSubscriptionVariables>(IntegrationUpdatedDocument, options);
      }
export type IntegrationUpdatedSubscriptionHookResult = ReturnType<typeof useIntegrationUpdatedSubscription>;
export type IntegrationUpdatedSubscriptionResult = Apollo.SubscriptionResult<IntegrationUpdatedSubscription>;
export const CancelJobDocument = gql`
    mutation CancelJob($id: String!, $requestId: String!) {
  cancelJob(id: $id, requestId: $requestId)
}
    `;
export type CancelJobMutationFn = Apollo.MutationFunction<CancelJobMutation, CancelJobMutationVariables>;

/**
 * __useCancelJobMutation__
 *
 * To run a mutation, you first call `useCancelJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelJobMutation, { data, loading, error }] = useCancelJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useCancelJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelJobMutation, CancelJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelJobMutation, CancelJobMutationVariables>(CancelJobDocument, options);
      }
export type CancelJobMutationHookResult = ReturnType<typeof useCancelJobMutation>;
export type CancelJobMutationResult = Apollo.MutationResult<CancelJobMutation>;
export type CancelJobMutationOptions = Apollo.BaseMutationOptions<CancelJobMutation, CancelJobMutationVariables>;
export const GetLocationAssociatedIntegrationsDocument = gql`
    query GetLocationAssociatedIntegrations($locationId: ID!) {
  location(id: $locationId) {
    id
    integrations {
      id
      name
      description
      config {
        integrationType
        form {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationAssociatedIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetLocationAssociatedIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationAssociatedIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationAssociatedIntegrationsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationAssociatedIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationAssociatedIntegrationsQuery, GetLocationAssociatedIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationAssociatedIntegrationsQuery, GetLocationAssociatedIntegrationsQueryVariables>(GetLocationAssociatedIntegrationsDocument, options);
      }
export function useGetLocationAssociatedIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationAssociatedIntegrationsQuery, GetLocationAssociatedIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationAssociatedIntegrationsQuery, GetLocationAssociatedIntegrationsQueryVariables>(GetLocationAssociatedIntegrationsDocument, options);
        }
export type GetLocationAssociatedIntegrationsQueryHookResult = ReturnType<typeof useGetLocationAssociatedIntegrationsQuery>;
export type GetLocationAssociatedIntegrationsLazyQueryHookResult = ReturnType<typeof useGetLocationAssociatedIntegrationsLazyQuery>;
export type GetLocationAssociatedIntegrationsQueryResult = Apollo.QueryResult<GetLocationAssociatedIntegrationsQuery, GetLocationAssociatedIntegrationsQueryVariables>;
export function refetchGetLocationAssociatedIntegrationsQuery(variables: GetLocationAssociatedIntegrationsQueryVariables) {
      return { query: GetLocationAssociatedIntegrationsDocument, variables: variables }
    }
export const NewLocationCommentDocument = gql`
    mutation NewLocationComment($locationId: ID!, $comment: String!) {
  saveLocationComment(locationId: $locationId, comment: $comment) {
    id
    locationId
    comment
    updatedAt
    createdAt
    userId
    userDisplayName
  }
}
    `;
export type NewLocationCommentMutationFn = Apollo.MutationFunction<NewLocationCommentMutation, NewLocationCommentMutationVariables>;

/**
 * __useNewLocationCommentMutation__
 *
 * To run a mutation, you first call `useNewLocationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewLocationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newLocationCommentMutation, { data, loading, error }] = useNewLocationCommentMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useNewLocationCommentMutation(baseOptions?: Apollo.MutationHookOptions<NewLocationCommentMutation, NewLocationCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewLocationCommentMutation, NewLocationCommentMutationVariables>(NewLocationCommentDocument, options);
      }
export type NewLocationCommentMutationHookResult = ReturnType<typeof useNewLocationCommentMutation>;
export type NewLocationCommentMutationResult = Apollo.MutationResult<NewLocationCommentMutation>;
export type NewLocationCommentMutationOptions = Apollo.BaseMutationOptions<NewLocationCommentMutation, NewLocationCommentMutationVariables>;
export const EditLocationCommentDocument = gql`
    mutation EditLocationComment($commentId: ID!, $locationId: ID!, $comment: String!) {
  saveLocationComment(id: $commentId, locationId: $locationId, comment: $comment) {
    id
    locationId
    comment
    updatedAt
    createdAt
    userId
    userDisplayName
  }
}
    `;
export type EditLocationCommentMutationFn = Apollo.MutationFunction<EditLocationCommentMutation, EditLocationCommentMutationVariables>;

/**
 * __useEditLocationCommentMutation__
 *
 * To run a mutation, you first call `useEditLocationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLocationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLocationCommentMutation, { data, loading, error }] = useEditLocationCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      locationId: // value for 'locationId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useEditLocationCommentMutation(baseOptions?: Apollo.MutationHookOptions<EditLocationCommentMutation, EditLocationCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLocationCommentMutation, EditLocationCommentMutationVariables>(EditLocationCommentDocument, options);
      }
export type EditLocationCommentMutationHookResult = ReturnType<typeof useEditLocationCommentMutation>;
export type EditLocationCommentMutationResult = Apollo.MutationResult<EditLocationCommentMutation>;
export type EditLocationCommentMutationOptions = Apollo.BaseMutationOptions<EditLocationCommentMutation, EditLocationCommentMutationVariables>;
export const DeleteLocationCommentDocument = gql`
    mutation DeleteLocationComment($commentId: ID!) {
  deleteLocationComment(id: $commentId)
}
    `;
export type DeleteLocationCommentMutationFn = Apollo.MutationFunction<DeleteLocationCommentMutation, DeleteLocationCommentMutationVariables>;

/**
 * __useDeleteLocationCommentMutation__
 *
 * To run a mutation, you first call `useDeleteLocationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationCommentMutation, { data, loading, error }] = useDeleteLocationCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteLocationCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationCommentMutation, DeleteLocationCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationCommentMutation, DeleteLocationCommentMutationVariables>(DeleteLocationCommentDocument, options);
      }
export type DeleteLocationCommentMutationHookResult = ReturnType<typeof useDeleteLocationCommentMutation>;
export type DeleteLocationCommentMutationResult = Apollo.MutationResult<DeleteLocationCommentMutation>;
export type DeleteLocationCommentMutationOptions = Apollo.BaseMutationOptions<DeleteLocationCommentMutation, DeleteLocationCommentMutationVariables>;
export const LocationCommentsDocument = gql`
    query LocationComments($locationId: ID!) {
  locationComments(id: $locationId) {
    id
    locationId
    comment
    createdAt
    updatedAt
    userId
  }
}
    `;

/**
 * __useLocationCommentsQuery__
 *
 * To run a query within a React component, call `useLocationCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationCommentsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useLocationCommentsQuery(baseOptions: Apollo.QueryHookOptions<LocationCommentsQuery, LocationCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationCommentsQuery, LocationCommentsQueryVariables>(LocationCommentsDocument, options);
      }
export function useLocationCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationCommentsQuery, LocationCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationCommentsQuery, LocationCommentsQueryVariables>(LocationCommentsDocument, options);
        }
export type LocationCommentsQueryHookResult = ReturnType<typeof useLocationCommentsQuery>;
export type LocationCommentsLazyQueryHookResult = ReturnType<typeof useLocationCommentsLazyQuery>;
export type LocationCommentsQueryResult = Apollo.QueryResult<LocationCommentsQuery, LocationCommentsQueryVariables>;
export function refetchLocationCommentsQuery(variables: LocationCommentsQueryVariables) {
      return { query: LocationCommentsDocument, variables: variables }
    }
export const SaveLocationLinkDocument = gql`
    mutation SaveLocationLink($link: LocationExternalLinkInput!) {
  saveLocationLink(link: $link) {
    id
    locationId
    url
    title
    description
  }
}
    `;
export type SaveLocationLinkMutationFn = Apollo.MutationFunction<SaveLocationLinkMutation, SaveLocationLinkMutationVariables>;

/**
 * __useSaveLocationLinkMutation__
 *
 * To run a mutation, you first call `useSaveLocationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationLinkMutation, { data, loading, error }] = useSaveLocationLinkMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useSaveLocationLinkMutation(baseOptions?: Apollo.MutationHookOptions<SaveLocationLinkMutation, SaveLocationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLocationLinkMutation, SaveLocationLinkMutationVariables>(SaveLocationLinkDocument, options);
      }
export type SaveLocationLinkMutationHookResult = ReturnType<typeof useSaveLocationLinkMutation>;
export type SaveLocationLinkMutationResult = Apollo.MutationResult<SaveLocationLinkMutation>;
export type SaveLocationLinkMutationOptions = Apollo.BaseMutationOptions<SaveLocationLinkMutation, SaveLocationLinkMutationVariables>;
export const DeleteLocationLinkDocument = gql`
    mutation DeleteLocationLink($id: ID!) {
  deleteLocationLink(id: $id)
}
    `;
export type DeleteLocationLinkMutationFn = Apollo.MutationFunction<DeleteLocationLinkMutation, DeleteLocationLinkMutationVariables>;

/**
 * __useDeleteLocationLinkMutation__
 *
 * To run a mutation, you first call `useDeleteLocationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationLinkMutation, { data, loading, error }] = useDeleteLocationLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationLinkMutation, DeleteLocationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationLinkMutation, DeleteLocationLinkMutationVariables>(DeleteLocationLinkDocument, options);
      }
export type DeleteLocationLinkMutationHookResult = ReturnType<typeof useDeleteLocationLinkMutation>;
export type DeleteLocationLinkMutationResult = Apollo.MutationResult<DeleteLocationLinkMutation>;
export type DeleteLocationLinkMutationOptions = Apollo.BaseMutationOptions<DeleteLocationLinkMutation, DeleteLocationLinkMutationVariables>;
export const LocationLinksDocument = gql`
    query LocationLinks($locationId: ID!) {
  locationLinks(locationId: $locationId) {
    id
    locationId
    url
    title
    description
  }
}
    `;

/**
 * __useLocationLinksQuery__
 *
 * To run a query within a React component, call `useLocationLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationLinksQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useLocationLinksQuery(baseOptions: Apollo.QueryHookOptions<LocationLinksQuery, LocationLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationLinksQuery, LocationLinksQueryVariables>(LocationLinksDocument, options);
      }
export function useLocationLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationLinksQuery, LocationLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationLinksQuery, LocationLinksQueryVariables>(LocationLinksDocument, options);
        }
export type LocationLinksQueryHookResult = ReturnType<typeof useLocationLinksQuery>;
export type LocationLinksLazyQueryHookResult = ReturnType<typeof useLocationLinksLazyQuery>;
export type LocationLinksQueryResult = Apollo.QueryResult<LocationLinksQuery, LocationLinksQueryVariables>;
export function refetchLocationLinksQuery(variables: LocationLinksQueryVariables) {
      return { query: LocationLinksDocument, variables: variables }
    }
export const CreateLocationGroupDocument = gql`
    mutation CreateLocationGroup($input: LocationGroupInput!) {
  saveLocationGroups(input: [$input]) {
    id
  }
}
    `;
export type CreateLocationGroupMutationFn = Apollo.MutationFunction<CreateLocationGroupMutation, CreateLocationGroupMutationVariables>;

/**
 * __useCreateLocationGroupMutation__
 *
 * To run a mutation, you first call `useCreateLocationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationGroupMutation, { data, loading, error }] = useCreateLocationGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationGroupMutation, CreateLocationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationGroupMutation, CreateLocationGroupMutationVariables>(CreateLocationGroupDocument, options);
      }
export type CreateLocationGroupMutationHookResult = ReturnType<typeof useCreateLocationGroupMutation>;
export type CreateLocationGroupMutationResult = Apollo.MutationResult<CreateLocationGroupMutation>;
export type CreateLocationGroupMutationOptions = Apollo.BaseMutationOptions<CreateLocationGroupMutation, CreateLocationGroupMutationVariables>;
export const DeleteLocationGroupDocument = gql`
    mutation DeleteLocationGroup($groupId: ID!) {
  deleteLocationGroup(id: $groupId)
}
    `;
export type DeleteLocationGroupMutationFn = Apollo.MutationFunction<DeleteLocationGroupMutation, DeleteLocationGroupMutationVariables>;

/**
 * __useDeleteLocationGroupMutation__
 *
 * To run a mutation, you first call `useDeleteLocationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationGroupMutation, { data, loading, error }] = useDeleteLocationGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteLocationGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationGroupMutation, DeleteLocationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationGroupMutation, DeleteLocationGroupMutationVariables>(DeleteLocationGroupDocument, options);
      }
export type DeleteLocationGroupMutationHookResult = ReturnType<typeof useDeleteLocationGroupMutation>;
export type DeleteLocationGroupMutationResult = Apollo.MutationResult<DeleteLocationGroupMutation>;
export type DeleteLocationGroupMutationOptions = Apollo.BaseMutationOptions<DeleteLocationGroupMutation, DeleteLocationGroupMutationVariables>;
export const MoveGroupDocument = gql`
    mutation MoveGroup($input: MoveLocationGroupInput!) {
  moveLocationGroups(input: [$input]) {
    id
    parentId
  }
}
    `;
export type MoveGroupMutationFn = Apollo.MutationFunction<MoveGroupMutation, MoveGroupMutationVariables>;

/**
 * __useMoveGroupMutation__
 *
 * To run a mutation, you first call `useMoveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveGroupMutation, { data, loading, error }] = useMoveGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveGroupMutation(baseOptions?: Apollo.MutationHookOptions<MoveGroupMutation, MoveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveGroupMutation, MoveGroupMutationVariables>(MoveGroupDocument, options);
      }
export type MoveGroupMutationHookResult = ReturnType<typeof useMoveGroupMutation>;
export type MoveGroupMutationResult = Apollo.MutationResult<MoveGroupMutation>;
export type MoveGroupMutationOptions = Apollo.BaseMutationOptions<MoveGroupMutation, MoveGroupMutationVariables>;
export const MoveLocationDocument = gql`
    mutation MoveLocation($input: MoveLocationInput!) {
  moveLocations(input: [$input])
}
    `;
export type MoveLocationMutationFn = Apollo.MutationFunction<MoveLocationMutation, MoveLocationMutationVariables>;

/**
 * __useMoveLocationMutation__
 *
 * To run a mutation, you first call `useMoveLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLocationMutation, { data, loading, error }] = useMoveLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveLocationMutation(baseOptions?: Apollo.MutationHookOptions<MoveLocationMutation, MoveLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveLocationMutation, MoveLocationMutationVariables>(MoveLocationDocument, options);
      }
export type MoveLocationMutationHookResult = ReturnType<typeof useMoveLocationMutation>;
export type MoveLocationMutationResult = Apollo.MutationResult<MoveLocationMutation>;
export type MoveLocationMutationOptions = Apollo.BaseMutationOptions<MoveLocationMutation, MoveLocationMutationVariables>;
export const ReorderLocationGroupsDocument = gql`
    mutation ReorderLocationGroups($input: [MoveLocationGroupInput!]!) {
  moveLocationGroups(input: $input) {
    id
    parentId
    order
  }
}
    `;
export type ReorderLocationGroupsMutationFn = Apollo.MutationFunction<ReorderLocationGroupsMutation, ReorderLocationGroupsMutationVariables>;

/**
 * __useReorderLocationGroupsMutation__
 *
 * To run a mutation, you first call `useReorderLocationGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderLocationGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderLocationGroupsMutation, { data, loading, error }] = useReorderLocationGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderLocationGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderLocationGroupsMutation, ReorderLocationGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderLocationGroupsMutation, ReorderLocationGroupsMutationVariables>(ReorderLocationGroupsDocument, options);
      }
export type ReorderLocationGroupsMutationHookResult = ReturnType<typeof useReorderLocationGroupsMutation>;
export type ReorderLocationGroupsMutationResult = Apollo.MutationResult<ReorderLocationGroupsMutation>;
export type ReorderLocationGroupsMutationOptions = Apollo.BaseMutationOptions<ReorderLocationGroupsMutation, ReorderLocationGroupsMutationVariables>;
export const ReorderLocationsDocument = gql`
    mutation ReorderLocations($input: [MoveLocationInput!]!) {
  moveLocations(input: $input)
}
    `;
export type ReorderLocationsMutationFn = Apollo.MutationFunction<ReorderLocationsMutation, ReorderLocationsMutationVariables>;

/**
 * __useReorderLocationsMutation__
 *
 * To run a mutation, you first call `useReorderLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderLocationsMutation, { data, loading, error }] = useReorderLocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderLocationsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderLocationsMutation, ReorderLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderLocationsMutation, ReorderLocationsMutationVariables>(ReorderLocationsDocument, options);
      }
export type ReorderLocationsMutationHookResult = ReturnType<typeof useReorderLocationsMutation>;
export type ReorderLocationsMutationResult = Apollo.MutationResult<ReorderLocationsMutation>;
export type ReorderLocationsMutationOptions = Apollo.BaseMutationOptions<ReorderLocationsMutation, ReorderLocationsMutationVariables>;
export const ExportLocationTreeDocument = gql`
    mutation ExportLocationTree($ids: [ID!]!) {
  exportLocationTree(ids: $ids)
}
    `;
export type ExportLocationTreeMutationFn = Apollo.MutationFunction<ExportLocationTreeMutation, ExportLocationTreeMutationVariables>;

/**
 * __useExportLocationTreeMutation__
 *
 * To run a mutation, you first call `useExportLocationTreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportLocationTreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportLocationTreeMutation, { data, loading, error }] = useExportLocationTreeMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useExportLocationTreeMutation(baseOptions?: Apollo.MutationHookOptions<ExportLocationTreeMutation, ExportLocationTreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportLocationTreeMutation, ExportLocationTreeMutationVariables>(ExportLocationTreeDocument, options);
      }
export type ExportLocationTreeMutationHookResult = ReturnType<typeof useExportLocationTreeMutation>;
export type ExportLocationTreeMutationResult = Apollo.MutationResult<ExportLocationTreeMutation>;
export type ExportLocationTreeMutationOptions = Apollo.BaseMutationOptions<ExportLocationTreeMutation, ExportLocationTreeMutationVariables>;
export const GetLocationsTreeDocument = gql`
    query GetLocationsTree {
  locationGroups {
    id
    name
    parentId
    readOnly
    externalCenterId
    color
    order
  }
  locations(query: {limit: 10000}) {
    edges {
      node {
        id
        groupId
        color
        locationType
        order
        externalCenterId
        details {
          name
        }
        associatedEntities {
          entityId
          entityType
          integrationType
          entityName
          protocol
          systemEnabled
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationsTreeQuery__
 *
 * To run a query within a React component, call `useGetLocationsTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsTreeQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsTreeQuery, GetLocationsTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsTreeQuery, GetLocationsTreeQueryVariables>(GetLocationsTreeDocument, options);
      }
export function useGetLocationsTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsTreeQuery, GetLocationsTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsTreeQuery, GetLocationsTreeQueryVariables>(GetLocationsTreeDocument, options);
        }
export type GetLocationsTreeQueryHookResult = ReturnType<typeof useGetLocationsTreeQuery>;
export type GetLocationsTreeLazyQueryHookResult = ReturnType<typeof useGetLocationsTreeLazyQuery>;
export type GetLocationsTreeQueryResult = Apollo.QueryResult<GetLocationsTreeQuery, GetLocationsTreeQueryVariables>;
export function refetchGetLocationsTreeQuery(variables?: GetLocationsTreeQueryVariables) {
      return { query: GetLocationsTreeDocument, variables: variables }
    }
export const GetUngroupedLocationsDocument = gql`
    query GetUngroupedLocations {
  locations(
    query: {limit: 10000, filters: [{field: "groupId", operator: EQUALS, value: null}]}
  ) {
    edges {
      node {
        id
        groupId
        color
        locationType
        order
        externalCenterId
        details {
          name
          description
        }
        associatedEntities {
          entityId
          entityType
          integrationType
          entityName
          protocol
          systemEnabled
        }
      }
    }
  }
}
    `;

/**
 * __useGetUngroupedLocationsQuery__
 *
 * To run a query within a React component, call `useGetUngroupedLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUngroupedLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUngroupedLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUngroupedLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUngroupedLocationsQuery, GetUngroupedLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUngroupedLocationsQuery, GetUngroupedLocationsQueryVariables>(GetUngroupedLocationsDocument, options);
      }
export function useGetUngroupedLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUngroupedLocationsQuery, GetUngroupedLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUngroupedLocationsQuery, GetUngroupedLocationsQueryVariables>(GetUngroupedLocationsDocument, options);
        }
export type GetUngroupedLocationsQueryHookResult = ReturnType<typeof useGetUngroupedLocationsQuery>;
export type GetUngroupedLocationsLazyQueryHookResult = ReturnType<typeof useGetUngroupedLocationsLazyQuery>;
export type GetUngroupedLocationsQueryResult = Apollo.QueryResult<GetUngroupedLocationsQuery, GetUngroupedLocationsQueryVariables>;
export function refetchGetUngroupedLocationsQuery(variables?: GetUngroupedLocationsQueryVariables) {
      return { query: GetUngroupedLocationsDocument, variables: variables }
    }
export const GetGroupLocationsDocument = gql`
    query GetGroupLocations($groupId: Object!) {
  locations(
    query: {limit: 10000, filters: [{field: "groupId", operator: EQUALS, value: $groupId}]}
  ) {
    edges {
      node {
        id
        groupId
        color
        locationType
        order
        externalCenterId
        details {
          name
          description
        }
        associatedEntities {
          entityId
          entityType
          integrationType
          entityName
          protocol
          systemEnabled
        }
      }
    }
  }
}
    `;

/**
 * __useGetGroupLocationsQuery__
 *
 * To run a query within a React component, call `useGetGroupLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupLocationsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupLocationsQuery, GetGroupLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupLocationsQuery, GetGroupLocationsQueryVariables>(GetGroupLocationsDocument, options);
      }
export function useGetGroupLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupLocationsQuery, GetGroupLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupLocationsQuery, GetGroupLocationsQueryVariables>(GetGroupLocationsDocument, options);
        }
export type GetGroupLocationsQueryHookResult = ReturnType<typeof useGetGroupLocationsQuery>;
export type GetGroupLocationsLazyQueryHookResult = ReturnType<typeof useGetGroupLocationsLazyQuery>;
export type GetGroupLocationsQueryResult = Apollo.QueryResult<GetGroupLocationsQuery, GetGroupLocationsQueryVariables>;
export function refetchGetGroupLocationsQuery(variables: GetGroupLocationsQueryVariables) {
      return { query: GetGroupLocationsDocument, variables: variables }
    }
export const GetLocationGroupsDocument = gql`
    query GetLocationGroups {
  locationGroups {
    id
    name
    parentId
    readOnly
    externalCenterId
    color
    order
  }
}
    `;

/**
 * __useGetLocationGroupsQuery__
 *
 * To run a query within a React component, call `useGetLocationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>(GetLocationGroupsDocument, options);
      }
export function useGetLocationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>(GetLocationGroupsDocument, options);
        }
export type GetLocationGroupsQueryHookResult = ReturnType<typeof useGetLocationGroupsQuery>;
export type GetLocationGroupsLazyQueryHookResult = ReturnType<typeof useGetLocationGroupsLazyQuery>;
export type GetLocationGroupsQueryResult = Apollo.QueryResult<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>;
export function refetchGetLocationGroupsQuery(variables?: GetLocationGroupsQueryVariables) {
      return { query: GetLocationGroupsDocument, variables: variables }
    }
export const SaveLocationDocument = gql`
    mutation SaveLocation($input: LocationInput!) {
  saveLocation(locationInput: $input) {
    id
    details {
      name
      description
    }
    geometry
    locationType
  }
}
    `;
export type SaveLocationMutationFn = Apollo.MutationFunction<SaveLocationMutation, SaveLocationMutationVariables>;

/**
 * __useSaveLocationMutation__
 *
 * To run a mutation, you first call `useSaveLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationMutation, { data, loading, error }] = useSaveLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLocationMutation(baseOptions?: Apollo.MutationHookOptions<SaveLocationMutation, SaveLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLocationMutation, SaveLocationMutationVariables>(SaveLocationDocument, options);
      }
export type SaveLocationMutationHookResult = ReturnType<typeof useSaveLocationMutation>;
export type SaveLocationMutationResult = Apollo.MutationResult<SaveLocationMutation>;
export type SaveLocationMutationOptions = Apollo.BaseMutationOptions<SaveLocationMutation, SaveLocationMutationVariables>;
export const SaveSignalLocationDocument = gql`
    mutation SaveSignalLocation($input: LocationInput!) {
  saveLocation(locationInput: $input) {
    id
    details {
      name
      description
    }
    geometry
    locationType
    lanes {
      id
      description
      geometry
      laneDirection
      travelDirection
    }
    crosswalks {
      id
      description
      geometry
    }
    maneuvers {
      id
      refApproachLane
      refDepartureLane
    }
  }
}
    `;
export type SaveSignalLocationMutationFn = Apollo.MutationFunction<SaveSignalLocationMutation, SaveSignalLocationMutationVariables>;

/**
 * __useSaveSignalLocationMutation__
 *
 * To run a mutation, you first call `useSaveSignalLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignalLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignalLocationMutation, { data, loading, error }] = useSaveSignalLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignalLocationMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignalLocationMutation, SaveSignalLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignalLocationMutation, SaveSignalLocationMutationVariables>(SaveSignalLocationDocument, options);
      }
export type SaveSignalLocationMutationHookResult = ReturnType<typeof useSaveSignalLocationMutation>;
export type SaveSignalLocationMutationResult = Apollo.MutationResult<SaveSignalLocationMutation>;
export type SaveSignalLocationMutationOptions = Apollo.BaseMutationOptions<SaveSignalLocationMutation, SaveSignalLocationMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($id: ID!) {
  deleteLocation(id: $id)
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const DeleteLocationTemplateDocument = gql`
    mutation DeleteLocationTemplate($id: ID!) {
  deleteLocationTemplate(id: $id)
}
    `;
export type DeleteLocationTemplateMutationFn = Apollo.MutationFunction<DeleteLocationTemplateMutation, DeleteLocationTemplateMutationVariables>;

/**
 * __useDeleteLocationTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteLocationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationTemplateMutation, { data, loading, error }] = useDeleteLocationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationTemplateMutation, DeleteLocationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationTemplateMutation, DeleteLocationTemplateMutationVariables>(DeleteLocationTemplateDocument, options);
      }
export type DeleteLocationTemplateMutationHookResult = ReturnType<typeof useDeleteLocationTemplateMutation>;
export type DeleteLocationTemplateMutationResult = Apollo.MutationResult<DeleteLocationTemplateMutation>;
export type DeleteLocationTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteLocationTemplateMutation, DeleteLocationTemplateMutationVariables>;
export const ImportLocationsDocument = gql`
    mutation ImportLocations($fileType: LocationImportFileType!, $locationType: String!, $fileIds: [ID!]!) {
  importLocations(
    fileType: $fileType
    locationType: $locationType
    fileIds: $fileIds
  )
}
    `;
export type ImportLocationsMutationFn = Apollo.MutationFunction<ImportLocationsMutation, ImportLocationsMutationVariables>;

/**
 * __useImportLocationsMutation__
 *
 * To run a mutation, you first call `useImportLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLocationsMutation, { data, loading, error }] = useImportLocationsMutation({
 *   variables: {
 *      fileType: // value for 'fileType'
 *      locationType: // value for 'locationType'
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useImportLocationsMutation(baseOptions?: Apollo.MutationHookOptions<ImportLocationsMutation, ImportLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportLocationsMutation, ImportLocationsMutationVariables>(ImportLocationsDocument, options);
      }
export type ImportLocationsMutationHookResult = ReturnType<typeof useImportLocationsMutation>;
export type ImportLocationsMutationResult = Apollo.MutationResult<ImportLocationsMutation>;
export type ImportLocationsMutationOptions = Apollo.BaseMutationOptions<ImportLocationsMutation, ImportLocationsMutationVariables>;
export const LocationDocument = gql`
    query Location($id: ID!) {
  location(id: $id) {
    id
    details {
      name
      description
    }
    locationType
    geometry
    crosswalks {
      id
      description
      geometry
    }
    maneuvers {
      id
      refApproachLane
      refDepartureLane
    }
    lanes {
      id
      description
      geometry
      laneDirection
      travelDirection
    }
    color
    opacity
  }
}
    `;

/**
 * __useLocationQuery__
 *
 * To run a query within a React component, call `useLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationQuery(baseOptions: Apollo.QueryHookOptions<LocationQuery, LocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
      }
export function useLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export type LocationQueryHookResult = ReturnType<typeof useLocationQuery>;
export type LocationLazyQueryHookResult = ReturnType<typeof useLocationLazyQuery>;
export type LocationQueryResult = Apollo.QueryResult<LocationQuery, LocationQueryVariables>;
export function refetchLocationQuery(variables: LocationQueryVariables) {
      return { query: LocationDocument, variables: variables }
    }
export const LocationDetailsDocument = gql`
    query LocationDetails($id: ID!) {
  location(id: $id) {
    id
    details {
      name
      description
    }
    externalCenterId
  }
}
    `;

/**
 * __useLocationDetailsQuery__
 *
 * To run a query within a React component, call `useLocationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationDetailsQuery(baseOptions: Apollo.QueryHookOptions<LocationDetailsQuery, LocationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationDetailsQuery, LocationDetailsQueryVariables>(LocationDetailsDocument, options);
      }
export function useLocationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationDetailsQuery, LocationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationDetailsQuery, LocationDetailsQueryVariables>(LocationDetailsDocument, options);
        }
export type LocationDetailsQueryHookResult = ReturnType<typeof useLocationDetailsQuery>;
export type LocationDetailsLazyQueryHookResult = ReturnType<typeof useLocationDetailsLazyQuery>;
export type LocationDetailsQueryResult = Apollo.QueryResult<LocationDetailsQuery, LocationDetailsQueryVariables>;
export function refetchLocationDetailsQuery(variables: LocationDetailsQueryVariables) {
      return { query: LocationDetailsDocument, variables: variables }
    }
export const EditLocationDocument = gql`
    query EditLocation($id: ID!) {
  location(id: $id) {
    id
    details {
      name
      description
    }
    locationType
    geometry
    associatedEntities {
      locationId
      entityType
      entityId
    }
    crosswalks {
      id
      description
      geometry
    }
    maneuvers {
      id
      refApproachLane
      refDepartureLane
    }
    lanes {
      id
      description
      geometry
      laneDirection
      travelDirection
    }
    color
    opacity
  }
}
    `;

/**
 * __useEditLocationQuery__
 *
 * To run a query within a React component, call `useEditLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditLocationQuery(baseOptions: Apollo.QueryHookOptions<EditLocationQuery, EditLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditLocationQuery, EditLocationQueryVariables>(EditLocationDocument, options);
      }
export function useEditLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditLocationQuery, EditLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditLocationQuery, EditLocationQueryVariables>(EditLocationDocument, options);
        }
export type EditLocationQueryHookResult = ReturnType<typeof useEditLocationQuery>;
export type EditLocationLazyQueryHookResult = ReturnType<typeof useEditLocationLazyQuery>;
export type EditLocationQueryResult = Apollo.QueryResult<EditLocationQuery, EditLocationQueryVariables>;
export function refetchEditLocationQuery(variables: EditLocationQueryVariables) {
      return { query: EditLocationDocument, variables: variables }
    }
export const CloneLocationDocument = gql`
    query CloneLocation($id: ID!) {
  location(id: $id) {
    id
    details {
      name
      description
    }
    locationType
    geometry
    crosswalks {
      id
      description
      geometry
    }
    maneuvers {
      id
      refApproachLane
      refDepartureLane
    }
    lanes {
      id
      description
      geometry
      laneDirection
      travelDirection
    }
    color
    opacity
  }
}
    `;

/**
 * __useCloneLocationQuery__
 *
 * To run a query within a React component, call `useCloneLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloneLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloneLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneLocationQuery(baseOptions: Apollo.QueryHookOptions<CloneLocationQuery, CloneLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloneLocationQuery, CloneLocationQueryVariables>(CloneLocationDocument, options);
      }
export function useCloneLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloneLocationQuery, CloneLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloneLocationQuery, CloneLocationQueryVariables>(CloneLocationDocument, options);
        }
export type CloneLocationQueryHookResult = ReturnType<typeof useCloneLocationQuery>;
export type CloneLocationLazyQueryHookResult = ReturnType<typeof useCloneLocationLazyQuery>;
export type CloneLocationQueryResult = Apollo.QueryResult<CloneLocationQuery, CloneLocationQueryVariables>;
export function refetchCloneLocationQuery(variables: CloneLocationQueryVariables) {
      return { query: CloneLocationDocument, variables: variables }
    }
export const LocationsListDocument = gql`
    query LocationsList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $associatedEntityFilters: [AssociatedEntityFilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  locations(
    query: {sortOrder: $sortOrder, sortField: $sortField, filters: $filters, associatedEntityFilters: $associatedEntityFilters, searchText: $searchText, limit: $limit, before: $before, after: $after}
  ) {
    edges {
      node {
        id
        details {
          name
          description
        }
        locationType
        geometry
        externalCenterId
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useLocationsListQuery__
 *
 * To run a query within a React component, call `useLocationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      associatedEntityFilters: // value for 'associatedEntityFilters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLocationsListQuery(baseOptions?: Apollo.QueryHookOptions<LocationsListQuery, LocationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsListQuery, LocationsListQueryVariables>(LocationsListDocument, options);
      }
export function useLocationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsListQuery, LocationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsListQuery, LocationsListQueryVariables>(LocationsListDocument, options);
        }
export type LocationsListQueryHookResult = ReturnType<typeof useLocationsListQuery>;
export type LocationsListLazyQueryHookResult = ReturnType<typeof useLocationsListLazyQuery>;
export type LocationsListQueryResult = Apollo.QueryResult<LocationsListQuery, LocationsListQueryVariables>;
export function refetchLocationsListQuery(variables?: LocationsListQueryVariables) {
      return { query: LocationsListDocument, variables: variables }
    }
export const LocationFormGeometryChangeDocument = gql`
    query LocationFormGeometryChange($geometry: Object!, $retrieveAllTypes: [String!]) {
  locationFormGeometryChange(
    geometry: $geometry
    retrieveAllTypes: $retrieveAllTypes
  )
}
    `;

/**
 * __useLocationFormGeometryChangeQuery__
 *
 * To run a query within a React component, call `useLocationFormGeometryChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationFormGeometryChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationFormGeometryChangeQuery({
 *   variables: {
 *      geometry: // value for 'geometry'
 *      retrieveAllTypes: // value for 'retrieveAllTypes'
 *   },
 * });
 */
export function useLocationFormGeometryChangeQuery(baseOptions: Apollo.QueryHookOptions<LocationFormGeometryChangeQuery, LocationFormGeometryChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationFormGeometryChangeQuery, LocationFormGeometryChangeQueryVariables>(LocationFormGeometryChangeDocument, options);
      }
export function useLocationFormGeometryChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationFormGeometryChangeQuery, LocationFormGeometryChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationFormGeometryChangeQuery, LocationFormGeometryChangeQueryVariables>(LocationFormGeometryChangeDocument, options);
        }
export type LocationFormGeometryChangeQueryHookResult = ReturnType<typeof useLocationFormGeometryChangeQuery>;
export type LocationFormGeometryChangeLazyQueryHookResult = ReturnType<typeof useLocationFormGeometryChangeLazyQuery>;
export type LocationFormGeometryChangeQueryResult = Apollo.QueryResult<LocationFormGeometryChangeQuery, LocationFormGeometryChangeQueryVariables>;
export function refetchLocationFormGeometryChangeQuery(variables: LocationFormGeometryChangeQueryVariables) {
      return { query: LocationFormGeometryChangeDocument, variables: variables }
    }
export const LocationFormStartReferencePointChangeDocument = gql`
    query LocationFormStartReferencePointChange($values: Object!) {
  locationFormStartReferencePointChange(values: $values)
}
    `;

/**
 * __useLocationFormStartReferencePointChangeQuery__
 *
 * To run a query within a React component, call `useLocationFormStartReferencePointChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationFormStartReferencePointChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationFormStartReferencePointChangeQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useLocationFormStartReferencePointChangeQuery(baseOptions: Apollo.QueryHookOptions<LocationFormStartReferencePointChangeQuery, LocationFormStartReferencePointChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationFormStartReferencePointChangeQuery, LocationFormStartReferencePointChangeQueryVariables>(LocationFormStartReferencePointChangeDocument, options);
      }
export function useLocationFormStartReferencePointChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationFormStartReferencePointChangeQuery, LocationFormStartReferencePointChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationFormStartReferencePointChangeQuery, LocationFormStartReferencePointChangeQueryVariables>(LocationFormStartReferencePointChangeDocument, options);
        }
export type LocationFormStartReferencePointChangeQueryHookResult = ReturnType<typeof useLocationFormStartReferencePointChangeQuery>;
export type LocationFormStartReferencePointChangeLazyQueryHookResult = ReturnType<typeof useLocationFormStartReferencePointChangeLazyQuery>;
export type LocationFormStartReferencePointChangeQueryResult = Apollo.QueryResult<LocationFormStartReferencePointChangeQuery, LocationFormStartReferencePointChangeQueryVariables>;
export function refetchLocationFormStartReferencePointChangeQuery(variables: LocationFormStartReferencePointChangeQueryVariables) {
      return { query: LocationFormStartReferencePointChangeDocument, variables: variables }
    }
export const LocationFormEndReferencePointChangeDocument = gql`
    query LocationFormEndReferencePointChange($values: Object!) {
  locationFormEndReferencePointChange(values: $values)
}
    `;

/**
 * __useLocationFormEndReferencePointChangeQuery__
 *
 * To run a query within a React component, call `useLocationFormEndReferencePointChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationFormEndReferencePointChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationFormEndReferencePointChangeQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useLocationFormEndReferencePointChangeQuery(baseOptions: Apollo.QueryHookOptions<LocationFormEndReferencePointChangeQuery, LocationFormEndReferencePointChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationFormEndReferencePointChangeQuery, LocationFormEndReferencePointChangeQueryVariables>(LocationFormEndReferencePointChangeDocument, options);
      }
export function useLocationFormEndReferencePointChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationFormEndReferencePointChangeQuery, LocationFormEndReferencePointChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationFormEndReferencePointChangeQuery, LocationFormEndReferencePointChangeQueryVariables>(LocationFormEndReferencePointChangeDocument, options);
        }
export type LocationFormEndReferencePointChangeQueryHookResult = ReturnType<typeof useLocationFormEndReferencePointChangeQuery>;
export type LocationFormEndReferencePointChangeLazyQueryHookResult = ReturnType<typeof useLocationFormEndReferencePointChangeLazyQuery>;
export type LocationFormEndReferencePointChangeQueryResult = Apollo.QueryResult<LocationFormEndReferencePointChangeQuery, LocationFormEndReferencePointChangeQueryVariables>;
export function refetchLocationFormEndReferencePointChangeQuery(variables: LocationFormEndReferencePointChangeQueryVariables) {
      return { query: LocationFormEndReferencePointChangeDocument, variables: variables }
    }
export const LocationFormReferencePointChangeDocument = gql`
    query LocationFormReferencePointChange($values: Object!) {
  locationFormReferencePointChange(values: $values)
}
    `;

/**
 * __useLocationFormReferencePointChangeQuery__
 *
 * To run a query within a React component, call `useLocationFormReferencePointChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationFormReferencePointChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationFormReferencePointChangeQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useLocationFormReferencePointChangeQuery(baseOptions: Apollo.QueryHookOptions<LocationFormReferencePointChangeQuery, LocationFormReferencePointChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationFormReferencePointChangeQuery, LocationFormReferencePointChangeQueryVariables>(LocationFormReferencePointChangeDocument, options);
      }
export function useLocationFormReferencePointChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationFormReferencePointChangeQuery, LocationFormReferencePointChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationFormReferencePointChangeQuery, LocationFormReferencePointChangeQueryVariables>(LocationFormReferencePointChangeDocument, options);
        }
export type LocationFormReferencePointChangeQueryHookResult = ReturnType<typeof useLocationFormReferencePointChangeQuery>;
export type LocationFormReferencePointChangeLazyQueryHookResult = ReturnType<typeof useLocationFormReferencePointChangeLazyQuery>;
export type LocationFormReferencePointChangeQueryResult = Apollo.QueryResult<LocationFormReferencePointChangeQuery, LocationFormReferencePointChangeQueryVariables>;
export function refetchLocationFormReferencePointChangeQuery(variables: LocationFormReferencePointChangeQueryVariables) {
      return { query: LocationFormReferencePointChangeDocument, variables: variables }
    }
export const LocationFormStartLandmarkChangeDocument = gql`
    query LocationFormStartLandmarkChange($values: Object!) {
  locationFormStartLandmarkChange(values: $values)
}
    `;

/**
 * __useLocationFormStartLandmarkChangeQuery__
 *
 * To run a query within a React component, call `useLocationFormStartLandmarkChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationFormStartLandmarkChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationFormStartLandmarkChangeQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useLocationFormStartLandmarkChangeQuery(baseOptions: Apollo.QueryHookOptions<LocationFormStartLandmarkChangeQuery, LocationFormStartLandmarkChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationFormStartLandmarkChangeQuery, LocationFormStartLandmarkChangeQueryVariables>(LocationFormStartLandmarkChangeDocument, options);
      }
export function useLocationFormStartLandmarkChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationFormStartLandmarkChangeQuery, LocationFormStartLandmarkChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationFormStartLandmarkChangeQuery, LocationFormStartLandmarkChangeQueryVariables>(LocationFormStartLandmarkChangeDocument, options);
        }
export type LocationFormStartLandmarkChangeQueryHookResult = ReturnType<typeof useLocationFormStartLandmarkChangeQuery>;
export type LocationFormStartLandmarkChangeLazyQueryHookResult = ReturnType<typeof useLocationFormStartLandmarkChangeLazyQuery>;
export type LocationFormStartLandmarkChangeQueryResult = Apollo.QueryResult<LocationFormStartLandmarkChangeQuery, LocationFormStartLandmarkChangeQueryVariables>;
export function refetchLocationFormStartLandmarkChangeQuery(variables: LocationFormStartLandmarkChangeQueryVariables) {
      return { query: LocationFormStartLandmarkChangeDocument, variables: variables }
    }
export const LocationFormEndLandmarkChangeDocument = gql`
    query LocationFormEndLandmarkChange($values: Object!) {
  locationFormEndLandmarkChange(values: $values)
}
    `;

/**
 * __useLocationFormEndLandmarkChangeQuery__
 *
 * To run a query within a React component, call `useLocationFormEndLandmarkChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationFormEndLandmarkChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationFormEndLandmarkChangeQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useLocationFormEndLandmarkChangeQuery(baseOptions: Apollo.QueryHookOptions<LocationFormEndLandmarkChangeQuery, LocationFormEndLandmarkChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationFormEndLandmarkChangeQuery, LocationFormEndLandmarkChangeQueryVariables>(LocationFormEndLandmarkChangeDocument, options);
      }
export function useLocationFormEndLandmarkChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationFormEndLandmarkChangeQuery, LocationFormEndLandmarkChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationFormEndLandmarkChangeQuery, LocationFormEndLandmarkChangeQueryVariables>(LocationFormEndLandmarkChangeDocument, options);
        }
export type LocationFormEndLandmarkChangeQueryHookResult = ReturnType<typeof useLocationFormEndLandmarkChangeQuery>;
export type LocationFormEndLandmarkChangeLazyQueryHookResult = ReturnType<typeof useLocationFormEndLandmarkChangeLazyQuery>;
export type LocationFormEndLandmarkChangeQueryResult = Apollo.QueryResult<LocationFormEndLandmarkChangeQuery, LocationFormEndLandmarkChangeQueryVariables>;
export function refetchLocationFormEndLandmarkChangeQuery(variables: LocationFormEndLandmarkChangeQueryVariables) {
      return { query: LocationFormEndLandmarkChangeDocument, variables: variables }
    }
export const LocationFormLandmarkChangeDocument = gql`
    query LocationFormLandmarkChange($values: Object!) {
  locationFormLandmarkChange(values: $values)
}
    `;

/**
 * __useLocationFormLandmarkChangeQuery__
 *
 * To run a query within a React component, call `useLocationFormLandmarkChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationFormLandmarkChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationFormLandmarkChangeQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useLocationFormLandmarkChangeQuery(baseOptions: Apollo.QueryHookOptions<LocationFormLandmarkChangeQuery, LocationFormLandmarkChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationFormLandmarkChangeQuery, LocationFormLandmarkChangeQueryVariables>(LocationFormLandmarkChangeDocument, options);
      }
export function useLocationFormLandmarkChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationFormLandmarkChangeQuery, LocationFormLandmarkChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationFormLandmarkChangeQuery, LocationFormLandmarkChangeQueryVariables>(LocationFormLandmarkChangeDocument, options);
        }
export type LocationFormLandmarkChangeQueryHookResult = ReturnType<typeof useLocationFormLandmarkChangeQuery>;
export type LocationFormLandmarkChangeLazyQueryHookResult = ReturnType<typeof useLocationFormLandmarkChangeLazyQuery>;
export type LocationFormLandmarkChangeQueryResult = Apollo.QueryResult<LocationFormLandmarkChangeQuery, LocationFormLandmarkChangeQueryVariables>;
export function refetchLocationFormLandmarkChangeQuery(variables: LocationFormLandmarkChangeQueryVariables) {
      return { query: LocationFormLandmarkChangeDocument, variables: variables }
    }
export const LocationFormAreaChangeDocument = gql`
    query LocationFormAreaChange($value: Object!, $type: String!) {
  locationFormAreaChange(value: $value, type: $type)
}
    `;

/**
 * __useLocationFormAreaChangeQuery__
 *
 * To run a query within a React component, call `useLocationFormAreaChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationFormAreaChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationFormAreaChangeQuery({
 *   variables: {
 *      value: // value for 'value'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLocationFormAreaChangeQuery(baseOptions: Apollo.QueryHookOptions<LocationFormAreaChangeQuery, LocationFormAreaChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationFormAreaChangeQuery, LocationFormAreaChangeQueryVariables>(LocationFormAreaChangeDocument, options);
      }
export function useLocationFormAreaChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationFormAreaChangeQuery, LocationFormAreaChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationFormAreaChangeQuery, LocationFormAreaChangeQueryVariables>(LocationFormAreaChangeDocument, options);
        }
export type LocationFormAreaChangeQueryHookResult = ReturnType<typeof useLocationFormAreaChangeQuery>;
export type LocationFormAreaChangeLazyQueryHookResult = ReturnType<typeof useLocationFormAreaChangeLazyQuery>;
export type LocationFormAreaChangeQueryResult = Apollo.QueryResult<LocationFormAreaChangeQuery, LocationFormAreaChangeQueryVariables>;
export function refetchLocationFormAreaChangeQuery(variables: LocationFormAreaChangeQueryVariables) {
      return { query: LocationFormAreaChangeDocument, variables: variables }
    }
export const LocationRouteClassificationsDocument = gql`
    query LocationRouteClassifications {
  locationRouteClassifications
}
    `;

/**
 * __useLocationRouteClassificationsQuery__
 *
 * To run a query within a React component, call `useLocationRouteClassificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationRouteClassificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationRouteClassificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationRouteClassificationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationRouteClassificationsQuery, LocationRouteClassificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationRouteClassificationsQuery, LocationRouteClassificationsQueryVariables>(LocationRouteClassificationsDocument, options);
      }
export function useLocationRouteClassificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationRouteClassificationsQuery, LocationRouteClassificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationRouteClassificationsQuery, LocationRouteClassificationsQueryVariables>(LocationRouteClassificationsDocument, options);
        }
export type LocationRouteClassificationsQueryHookResult = ReturnType<typeof useLocationRouteClassificationsQuery>;
export type LocationRouteClassificationsLazyQueryHookResult = ReturnType<typeof useLocationRouteClassificationsLazyQuery>;
export type LocationRouteClassificationsQueryResult = Apollo.QueryResult<LocationRouteClassificationsQuery, LocationRouteClassificationsQueryVariables>;
export function refetchLocationRouteClassificationsQuery(variables?: LocationRouteClassificationsQueryVariables) {
      return { query: LocationRouteClassificationsDocument, variables: variables }
    }
export const LocationRoutesListDocument = gql`
    query LocationRoutesList($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $searchText: String, $filters: [FilterInput]) {
  locationRoutes(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, sortField: $sortField, filters: $filters}
  ) {
    edges {
      node {
        direction
        nativeId
        label
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useLocationRoutesListQuery__
 *
 * To run a query within a React component, call `useLocationRoutesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationRoutesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationRoutesListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLocationRoutesListQuery(baseOptions?: Apollo.QueryHookOptions<LocationRoutesListQuery, LocationRoutesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationRoutesListQuery, LocationRoutesListQueryVariables>(LocationRoutesListDocument, options);
      }
export function useLocationRoutesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationRoutesListQuery, LocationRoutesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationRoutesListQuery, LocationRoutesListQueryVariables>(LocationRoutesListDocument, options);
        }
export type LocationRoutesListQueryHookResult = ReturnType<typeof useLocationRoutesListQuery>;
export type LocationRoutesListLazyQueryHookResult = ReturnType<typeof useLocationRoutesListLazyQuery>;
export type LocationRoutesListQueryResult = Apollo.QueryResult<LocationRoutesListQuery, LocationRoutesListQueryVariables>;
export function refetchLocationRoutesListQuery(variables?: LocationRoutesListQueryVariables) {
      return { query: LocationRoutesListDocument, variables: variables }
    }
export const LocationBoundedRoutesListDocument = gql`
    query LocationBoundedRoutesList($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $searchText: String, $filters: [FilterInput]) {
  locationBoundedRoutes(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, sortField: $sortField, filters: $filters}
  ) {
    edges {
      node {
        classification
        startLandmark
        routeNativeId
        direction
        startMeasure
        endLandmark
        endMeasure
        areaType
        area
        name
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useLocationBoundedRoutesListQuery__
 *
 * To run a query within a React component, call `useLocationBoundedRoutesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationBoundedRoutesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationBoundedRoutesListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLocationBoundedRoutesListQuery(baseOptions?: Apollo.QueryHookOptions<LocationBoundedRoutesListQuery, LocationBoundedRoutesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationBoundedRoutesListQuery, LocationBoundedRoutesListQueryVariables>(LocationBoundedRoutesListDocument, options);
      }
export function useLocationBoundedRoutesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationBoundedRoutesListQuery, LocationBoundedRoutesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationBoundedRoutesListQuery, LocationBoundedRoutesListQueryVariables>(LocationBoundedRoutesListDocument, options);
        }
export type LocationBoundedRoutesListQueryHookResult = ReturnType<typeof useLocationBoundedRoutesListQuery>;
export type LocationBoundedRoutesListLazyQueryHookResult = ReturnType<typeof useLocationBoundedRoutesListLazyQuery>;
export type LocationBoundedRoutesListQueryResult = Apollo.QueryResult<LocationBoundedRoutesListQuery, LocationBoundedRoutesListQueryVariables>;
export function refetchLocationBoundedRoutesListQuery(variables?: LocationBoundedRoutesListQueryVariables) {
      return { query: LocationBoundedRoutesListDocument, variables: variables }
    }
export const LocationRouteDocument = gql`
    query LocationRoute($nativeId: String!) {
  locationRoute(nativeId: $nativeId) {
    classification
    direction
    name
  }
}
    `;

/**
 * __useLocationRouteQuery__
 *
 * To run a query within a React component, call `useLocationRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationRouteQuery({
 *   variables: {
 *      nativeId: // value for 'nativeId'
 *   },
 * });
 */
export function useLocationRouteQuery(baseOptions: Apollo.QueryHookOptions<LocationRouteQuery, LocationRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationRouteQuery, LocationRouteQueryVariables>(LocationRouteDocument, options);
      }
export function useLocationRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationRouteQuery, LocationRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationRouteQuery, LocationRouteQueryVariables>(LocationRouteDocument, options);
        }
export type LocationRouteQueryHookResult = ReturnType<typeof useLocationRouteQuery>;
export type LocationRouteLazyQueryHookResult = ReturnType<typeof useLocationRouteLazyQuery>;
export type LocationRouteQueryResult = Apollo.QueryResult<LocationRouteQuery, LocationRouteQueryVariables>;
export function refetchLocationRouteQuery(variables: LocationRouteQueryVariables) {
      return { query: LocationRouteDocument, variables: variables }
    }
export const LocationSwitcherOptionsDocument = gql`
    query LocationSwitcherOptions($currentLocationId: Object!) {
  locations(
    query: {sortOrder: ASCENDING, sortField: "details.name", limit: 10000, filters: [{field: "id", operator: NOT_EQUALS, value: $currentLocationId}]}
  ) {
    edges {
      node {
        id
        details {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useLocationSwitcherOptionsQuery__
 *
 * To run a query within a React component, call `useLocationSwitcherOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationSwitcherOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationSwitcherOptionsQuery({
 *   variables: {
 *      currentLocationId: // value for 'currentLocationId'
 *   },
 * });
 */
export function useLocationSwitcherOptionsQuery(baseOptions: Apollo.QueryHookOptions<LocationSwitcherOptionsQuery, LocationSwitcherOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationSwitcherOptionsQuery, LocationSwitcherOptionsQueryVariables>(LocationSwitcherOptionsDocument, options);
      }
export function useLocationSwitcherOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationSwitcherOptionsQuery, LocationSwitcherOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationSwitcherOptionsQuery, LocationSwitcherOptionsQueryVariables>(LocationSwitcherOptionsDocument, options);
        }
export type LocationSwitcherOptionsQueryHookResult = ReturnType<typeof useLocationSwitcherOptionsQuery>;
export type LocationSwitcherOptionsLazyQueryHookResult = ReturnType<typeof useLocationSwitcherOptionsLazyQuery>;
export type LocationSwitcherOptionsQueryResult = Apollo.QueryResult<LocationSwitcherOptionsQuery, LocationSwitcherOptionsQueryVariables>;
export function refetchLocationSwitcherOptionsQuery(variables: LocationSwitcherOptionsQueryVariables) {
      return { query: LocationSwitcherOptionsDocument, variables: variables }
    }
export const LocationRouteRangeDocument = gql`
    query LocationRouteRange($nativeId: String!) {
  locationRouteRange(nativeId: $nativeId) {
    startReference
    endReference
  }
}
    `;

/**
 * __useLocationRouteRangeQuery__
 *
 * To run a query within a React component, call `useLocationRouteRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationRouteRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationRouteRangeQuery({
 *   variables: {
 *      nativeId: // value for 'nativeId'
 *   },
 * });
 */
export function useLocationRouteRangeQuery(baseOptions: Apollo.QueryHookOptions<LocationRouteRangeQuery, LocationRouteRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationRouteRangeQuery, LocationRouteRangeQueryVariables>(LocationRouteRangeDocument, options);
      }
export function useLocationRouteRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationRouteRangeQuery, LocationRouteRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationRouteRangeQuery, LocationRouteRangeQueryVariables>(LocationRouteRangeDocument, options);
        }
export type LocationRouteRangeQueryHookResult = ReturnType<typeof useLocationRouteRangeQuery>;
export type LocationRouteRangeLazyQueryHookResult = ReturnType<typeof useLocationRouteRangeLazyQuery>;
export type LocationRouteRangeQueryResult = Apollo.QueryResult<LocationRouteRangeQuery, LocationRouteRangeQueryVariables>;
export function refetchLocationRouteRangeQuery(variables: LocationRouteRangeQueryVariables) {
      return { query: LocationRouteRangeDocument, variables: variables }
    }
export const LocationDetailsSummaryDocument = gql`
    query LocationDetailsSummary($id: ID!) {
  location(id: $id) {
    id
    locationType
    details {
      name
      description
    }
  }
}
    `;

/**
 * __useLocationDetailsSummaryQuery__
 *
 * To run a query within a React component, call `useLocationDetailsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDetailsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDetailsSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationDetailsSummaryQuery(baseOptions: Apollo.QueryHookOptions<LocationDetailsSummaryQuery, LocationDetailsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationDetailsSummaryQuery, LocationDetailsSummaryQueryVariables>(LocationDetailsSummaryDocument, options);
      }
export function useLocationDetailsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationDetailsSummaryQuery, LocationDetailsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationDetailsSummaryQuery, LocationDetailsSummaryQueryVariables>(LocationDetailsSummaryDocument, options);
        }
export type LocationDetailsSummaryQueryHookResult = ReturnType<typeof useLocationDetailsSummaryQuery>;
export type LocationDetailsSummaryLazyQueryHookResult = ReturnType<typeof useLocationDetailsSummaryLazyQuery>;
export type LocationDetailsSummaryQueryResult = Apollo.QueryResult<LocationDetailsSummaryQuery, LocationDetailsSummaryQueryVariables>;
export function refetchLocationDetailsSummaryQuery(variables: LocationDetailsSummaryQueryVariables) {
      return { query: LocationDetailsSummaryDocument, variables: variables }
    }
export const LocationRouteLandmarkListDocument = gql`
    query LocationRouteLandmarkList($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $searchText: String, $filters: [FilterInput]) {
  locationRouteLandmarks(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, sortField: $sortField, filters: $filters}
  ) {
    edges {
      node {
        measure
        name
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useLocationRouteLandmarkListQuery__
 *
 * To run a query within a React component, call `useLocationRouteLandmarkListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationRouteLandmarkListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationRouteLandmarkListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLocationRouteLandmarkListQuery(baseOptions?: Apollo.QueryHookOptions<LocationRouteLandmarkListQuery, LocationRouteLandmarkListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationRouteLandmarkListQuery, LocationRouteLandmarkListQueryVariables>(LocationRouteLandmarkListDocument, options);
      }
export function useLocationRouteLandmarkListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationRouteLandmarkListQuery, LocationRouteLandmarkListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationRouteLandmarkListQuery, LocationRouteLandmarkListQueryVariables>(LocationRouteLandmarkListDocument, options);
        }
export type LocationRouteLandmarkListQueryHookResult = ReturnType<typeof useLocationRouteLandmarkListQuery>;
export type LocationRouteLandmarkListLazyQueryHookResult = ReturnType<typeof useLocationRouteLandmarkListLazyQuery>;
export type LocationRouteLandmarkListQueryResult = Apollo.QueryResult<LocationRouteLandmarkListQuery, LocationRouteLandmarkListQueryVariables>;
export function refetchLocationRouteLandmarkListQuery(variables?: LocationRouteLandmarkListQueryVariables) {
      return { query: LocationRouteLandmarkListDocument, variables: variables }
    }
export const LocationDetailsMapDocument = gql`
    query LocationDetailsMap($id: ID!) {
  location(id: $id) {
    id
    locationType
    geometry
    color
    opacity
  }
}
    `;

/**
 * __useLocationDetailsMapQuery__
 *
 * To run a query within a React component, call `useLocationDetailsMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDetailsMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDetailsMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationDetailsMapQuery(baseOptions: Apollo.QueryHookOptions<LocationDetailsMapQuery, LocationDetailsMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationDetailsMapQuery, LocationDetailsMapQueryVariables>(LocationDetailsMapDocument, options);
      }
export function useLocationDetailsMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationDetailsMapQuery, LocationDetailsMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationDetailsMapQuery, LocationDetailsMapQueryVariables>(LocationDetailsMapDocument, options);
        }
export type LocationDetailsMapQueryHookResult = ReturnType<typeof useLocationDetailsMapQuery>;
export type LocationDetailsMapLazyQueryHookResult = ReturnType<typeof useLocationDetailsMapLazyQuery>;
export type LocationDetailsMapQueryResult = Apollo.QueryResult<LocationDetailsMapQuery, LocationDetailsMapQueryVariables>;
export function refetchLocationDetailsMapQuery(variables: LocationDetailsMapQueryVariables) {
      return { query: LocationDetailsMapDocument, variables: variables }
    }
export const LocationAreaListDocument = gql`
    query LocationAreaList($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $searchText: String, $filters: [FilterInput]) {
  locationAreas(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, sortField: $sortField, filters: $filters}
  ) {
    edges {
      node {
        type
        name
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useLocationAreaListQuery__
 *
 * To run a query within a React component, call `useLocationAreaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationAreaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationAreaListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLocationAreaListQuery(baseOptions?: Apollo.QueryHookOptions<LocationAreaListQuery, LocationAreaListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationAreaListQuery, LocationAreaListQueryVariables>(LocationAreaListDocument, options);
      }
export function useLocationAreaListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationAreaListQuery, LocationAreaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationAreaListQuery, LocationAreaListQueryVariables>(LocationAreaListDocument, options);
        }
export type LocationAreaListQueryHookResult = ReturnType<typeof useLocationAreaListQuery>;
export type LocationAreaListLazyQueryHookResult = ReturnType<typeof useLocationAreaListLazyQuery>;
export type LocationAreaListQueryResult = Apollo.QueryResult<LocationAreaListQuery, LocationAreaListQueryVariables>;
export function refetchLocationAreaListQuery(variables?: LocationAreaListQueryVariables) {
      return { query: LocationAreaListDocument, variables: variables }
    }
export const LocationParentGroupDocument = gql`
    query LocationParentGroup($id: ID!) {
  getLocationParentGroup(id: $id) {
    id
    name
    parentId
    order
  }
}
    `;

/**
 * __useLocationParentGroupQuery__
 *
 * To run a query within a React component, call `useLocationParentGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationParentGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationParentGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationParentGroupQuery(baseOptions: Apollo.QueryHookOptions<LocationParentGroupQuery, LocationParentGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationParentGroupQuery, LocationParentGroupQueryVariables>(LocationParentGroupDocument, options);
      }
export function useLocationParentGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationParentGroupQuery, LocationParentGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationParentGroupQuery, LocationParentGroupQueryVariables>(LocationParentGroupDocument, options);
        }
export type LocationParentGroupQueryHookResult = ReturnType<typeof useLocationParentGroupQuery>;
export type LocationParentGroupLazyQueryHookResult = ReturnType<typeof useLocationParentGroupLazyQuery>;
export type LocationParentGroupQueryResult = Apollo.QueryResult<LocationParentGroupQuery, LocationParentGroupQueryVariables>;
export function refetchLocationParentGroupQuery(variables: LocationParentGroupQueryVariables) {
      return { query: LocationParentGroupDocument, variables: variables }
    }
export const AssetLocationsOptionsDocument = gql`
    query AssetLocationsOptions($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $associatedEntityFilters: [AssociatedEntityFilterInput!], $limit: Int = 100) {
  locations(
    query: {sortOrder: $sortOrder, sortField: $sortField, filters: $filters, associatedEntityFilters: $associatedEntityFilters, limit: $limit}
  ) {
    edges {
      node {
        id
        details {
          name
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useAssetLocationsOptionsQuery__
 *
 * To run a query within a React component, call `useAssetLocationsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetLocationsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetLocationsOptionsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      associatedEntityFilters: // value for 'associatedEntityFilters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAssetLocationsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AssetLocationsOptionsQuery, AssetLocationsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetLocationsOptionsQuery, AssetLocationsOptionsQueryVariables>(AssetLocationsOptionsDocument, options);
      }
export function useAssetLocationsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetLocationsOptionsQuery, AssetLocationsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetLocationsOptionsQuery, AssetLocationsOptionsQueryVariables>(AssetLocationsOptionsDocument, options);
        }
export type AssetLocationsOptionsQueryHookResult = ReturnType<typeof useAssetLocationsOptionsQuery>;
export type AssetLocationsOptionsLazyQueryHookResult = ReturnType<typeof useAssetLocationsOptionsLazyQuery>;
export type AssetLocationsOptionsQueryResult = Apollo.QueryResult<AssetLocationsOptionsQuery, AssetLocationsOptionsQueryVariables>;
export function refetchAssetLocationsOptionsQuery(variables?: AssetLocationsOptionsQueryVariables) {
      return { query: AssetLocationsOptionsDocument, variables: variables }
    }
export const LocationFormDistrictChangeDocument = gql`
    query LocationFormDistrictChange($values: Object!, $searchAreaType: String!, $returnAreaTypes: [String!]!) {
  locationFormDistrictChange(
    values: $values
    searchAreaType: $searchAreaType
    returnAreaTypes: $returnAreaTypes
  )
}
    `;

/**
 * __useLocationFormDistrictChangeQuery__
 *
 * To run a query within a React component, call `useLocationFormDistrictChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationFormDistrictChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationFormDistrictChangeQuery({
 *   variables: {
 *      values: // value for 'values'
 *      searchAreaType: // value for 'searchAreaType'
 *      returnAreaTypes: // value for 'returnAreaTypes'
 *   },
 * });
 */
export function useLocationFormDistrictChangeQuery(baseOptions: Apollo.QueryHookOptions<LocationFormDistrictChangeQuery, LocationFormDistrictChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationFormDistrictChangeQuery, LocationFormDistrictChangeQueryVariables>(LocationFormDistrictChangeDocument, options);
      }
export function useLocationFormDistrictChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationFormDistrictChangeQuery, LocationFormDistrictChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationFormDistrictChangeQuery, LocationFormDistrictChangeQueryVariables>(LocationFormDistrictChangeDocument, options);
        }
export type LocationFormDistrictChangeQueryHookResult = ReturnType<typeof useLocationFormDistrictChangeQuery>;
export type LocationFormDistrictChangeLazyQueryHookResult = ReturnType<typeof useLocationFormDistrictChangeLazyQuery>;
export type LocationFormDistrictChangeQueryResult = Apollo.QueryResult<LocationFormDistrictChangeQuery, LocationFormDistrictChangeQueryVariables>;
export function refetchLocationFormDistrictChangeQuery(variables: LocationFormDistrictChangeQueryVariables) {
      return { query: LocationFormDistrictChangeDocument, variables: variables }
    }
export const LocationsByIdDocument = gql`
    query LocationsById($ids: Object!) {
  locations(query: {filters: [{operator: IN, field: "id", value: $ids}]}) {
    edges {
      node {
        id
        details {
          name
          description
        }
        locationType
        geometry
      }
    }
  }
}
    `;

/**
 * __useLocationsByIdQuery__
 *
 * To run a query within a React component, call `useLocationsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLocationsByIdQuery(baseOptions: Apollo.QueryHookOptions<LocationsByIdQuery, LocationsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsByIdQuery, LocationsByIdQueryVariables>(LocationsByIdDocument, options);
      }
export function useLocationsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsByIdQuery, LocationsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsByIdQuery, LocationsByIdQueryVariables>(LocationsByIdDocument, options);
        }
export type LocationsByIdQueryHookResult = ReturnType<typeof useLocationsByIdQuery>;
export type LocationsByIdLazyQueryHookResult = ReturnType<typeof useLocationsByIdLazyQuery>;
export type LocationsByIdQueryResult = Apollo.QueryResult<LocationsByIdQuery, LocationsByIdQueryVariables>;
export function refetchLocationsByIdQuery(variables: LocationsByIdQueryVariables) {
      return { query: LocationsByIdDocument, variables: variables }
    }
export const SaveLocationTemplateDocument = gql`
    mutation SaveLocationTemplate($input: LocationTemplateInput!) {
  saveLocationTemplate(input: $input) {
    id
    name
    description
    template {
      details {
        name
        description
      }
      locationType
      geometry
      crosswalks {
        id
        description
        geometry
      }
      maneuvers {
        id
        refApproachLane
        refDepartureLane
      }
      lanes {
        id
        description
        geometry
        laneDirection
        travelDirection
      }
    }
  }
}
    `;
export type SaveLocationTemplateMutationFn = Apollo.MutationFunction<SaveLocationTemplateMutation, SaveLocationTemplateMutationVariables>;

/**
 * __useSaveLocationTemplateMutation__
 *
 * To run a mutation, you first call `useSaveLocationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationTemplateMutation, { data, loading, error }] = useSaveLocationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLocationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveLocationTemplateMutation, SaveLocationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLocationTemplateMutation, SaveLocationTemplateMutationVariables>(SaveLocationTemplateDocument, options);
      }
export type SaveLocationTemplateMutationHookResult = ReturnType<typeof useSaveLocationTemplateMutation>;
export type SaveLocationTemplateMutationResult = Apollo.MutationResult<SaveLocationTemplateMutation>;
export type SaveLocationTemplateMutationOptions = Apollo.BaseMutationOptions<SaveLocationTemplateMutation, SaveLocationTemplateMutationVariables>;
export const LocationTemplateDocument = gql`
    query LocationTemplate($id: ID!) {
  locationTemplate(id: $id) {
    id
    name
    description
    template {
      details {
        name
        description
      }
      locationType
      geometry
      crosswalks {
        id
        description
        geometry
      }
      maneuvers {
        id
        refApproachLane
        refDepartureLane
      }
      lanes {
        id
        description
        geometry
        laneDirection
        travelDirection
      }
    }
  }
}
    `;

/**
 * __useLocationTemplateQuery__
 *
 * To run a query within a React component, call `useLocationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationTemplateQuery(baseOptions: Apollo.QueryHookOptions<LocationTemplateQuery, LocationTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationTemplateQuery, LocationTemplateQueryVariables>(LocationTemplateDocument, options);
      }
export function useLocationTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationTemplateQuery, LocationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationTemplateQuery, LocationTemplateQueryVariables>(LocationTemplateDocument, options);
        }
export type LocationTemplateQueryHookResult = ReturnType<typeof useLocationTemplateQuery>;
export type LocationTemplateLazyQueryHookResult = ReturnType<typeof useLocationTemplateLazyQuery>;
export type LocationTemplateQueryResult = Apollo.QueryResult<LocationTemplateQuery, LocationTemplateQueryVariables>;
export function refetchLocationTemplateQuery(variables: LocationTemplateQueryVariables) {
      return { query: LocationTemplateDocument, variables: variables }
    }
export const LocationTemplatesListDocument = gql`
    query LocationTemplatesList($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $searchText: String, $filters: [FilterInput]) {
  locationTemplates(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, sortField: $sortField, filters: $filters}
  ) {
    edges {
      node {
        id
        name
        description
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useLocationTemplatesListQuery__
 *
 * To run a query within a React component, call `useLocationTemplatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationTemplatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationTemplatesListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLocationTemplatesListQuery(baseOptions?: Apollo.QueryHookOptions<LocationTemplatesListQuery, LocationTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationTemplatesListQuery, LocationTemplatesListQueryVariables>(LocationTemplatesListDocument, options);
      }
export function useLocationTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationTemplatesListQuery, LocationTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationTemplatesListQuery, LocationTemplatesListQueryVariables>(LocationTemplatesListDocument, options);
        }
export type LocationTemplatesListQueryHookResult = ReturnType<typeof useLocationTemplatesListQuery>;
export type LocationTemplatesListLazyQueryHookResult = ReturnType<typeof useLocationTemplatesListLazyQuery>;
export type LocationTemplatesListQueryResult = Apollo.QueryResult<LocationTemplatesListQuery, LocationTemplatesListQueryVariables>;
export function refetchLocationTemplatesListQuery(variables?: LocationTemplatesListQueryVariables) {
      return { query: LocationTemplatesListDocument, variables: variables }
    }
export const LocationTemplateOptionsDocument = gql`
    query LocationTemplateOptions {
  locationTemplates(query: {limit: 10000}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useLocationTemplateOptionsQuery__
 *
 * To run a query within a React component, call `useLocationTemplateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationTemplateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationTemplateOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationTemplateOptionsQuery(baseOptions?: Apollo.QueryHookOptions<LocationTemplateOptionsQuery, LocationTemplateOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationTemplateOptionsQuery, LocationTemplateOptionsQueryVariables>(LocationTemplateOptionsDocument, options);
      }
export function useLocationTemplateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationTemplateOptionsQuery, LocationTemplateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationTemplateOptionsQuery, LocationTemplateOptionsQueryVariables>(LocationTemplateOptionsDocument, options);
        }
export type LocationTemplateOptionsQueryHookResult = ReturnType<typeof useLocationTemplateOptionsQuery>;
export type LocationTemplateOptionsLazyQueryHookResult = ReturnType<typeof useLocationTemplateOptionsLazyQuery>;
export type LocationTemplateOptionsQueryResult = Apollo.QueryResult<LocationTemplateOptionsQuery, LocationTemplateOptionsQueryVariables>;
export function refetchLocationTemplateOptionsQuery(variables?: LocationTemplateOptionsQueryVariables) {
      return { query: LocationTemplateOptionsDocument, variables: variables }
    }
export const AcknowledgeNotificationDocument = gql`
    mutation AcknowledgeNotification($id: String!, $notes: String) {
  acknowledgeNotification(id: $id, notes: $notes) {
    id
    acknowledgedBy
    acknowledgedTime
  }
}
    `;
export type AcknowledgeNotificationMutationFn = Apollo.MutationFunction<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>;

/**
 * __useAcknowledgeNotificationMutation__
 *
 * To run a mutation, you first call `useAcknowledgeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeNotificationMutation, { data, loading, error }] = useAcknowledgeNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useAcknowledgeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>(AcknowledgeNotificationDocument, options);
      }
export type AcknowledgeNotificationMutationHookResult = ReturnType<typeof useAcknowledgeNotificationMutation>;
export type AcknowledgeNotificationMutationResult = Apollo.MutationResult<AcknowledgeNotificationMutation>;
export type AcknowledgeNotificationMutationOptions = Apollo.BaseMutationOptions<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>;
export const DismissNotificationDocument = gql`
    mutation DismissNotification($id: String!) {
  dismissNotification(id: $id)
}
    `;
export type DismissNotificationMutationFn = Apollo.MutationFunction<DismissNotificationMutation, DismissNotificationMutationVariables>;

/**
 * __useDismissNotificationMutation__
 *
 * To run a mutation, you first call `useDismissNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissNotificationMutation, { data, loading, error }] = useDismissNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DismissNotificationMutation, DismissNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissNotificationMutation, DismissNotificationMutationVariables>(DismissNotificationDocument, options);
      }
export type DismissNotificationMutationHookResult = ReturnType<typeof useDismissNotificationMutation>;
export type DismissNotificationMutationResult = Apollo.MutationResult<DismissNotificationMutation>;
export type DismissNotificationMutationOptions = Apollo.BaseMutationOptions<DismissNotificationMutation, DismissNotificationMutationVariables>;
export const DismissNotificationsDocument = gql`
    mutation DismissNotifications {
  dismissNotifications
}
    `;
export type DismissNotificationsMutationFn = Apollo.MutationFunction<DismissNotificationsMutation, DismissNotificationsMutationVariables>;

/**
 * __useDismissNotificationsMutation__
 *
 * To run a mutation, you first call `useDismissNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissNotificationsMutation, { data, loading, error }] = useDismissNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<DismissNotificationsMutation, DismissNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissNotificationsMutation, DismissNotificationsMutationVariables>(DismissNotificationsDocument, options);
      }
export type DismissNotificationsMutationHookResult = ReturnType<typeof useDismissNotificationsMutation>;
export type DismissNotificationsMutationResult = Apollo.MutationResult<DismissNotificationsMutation>;
export type DismissNotificationsMutationOptions = Apollo.BaseMutationOptions<DismissNotificationsMutation, DismissNotificationsMutationVariables>;
export const SnoozeNotificationDocument = gql`
    mutation SnoozeNotification($id: String!, $duration: Int!, $message: String) {
  snoozeNotification(id: $id, duration: $duration, message: $message)
}
    `;
export type SnoozeNotificationMutationFn = Apollo.MutationFunction<SnoozeNotificationMutation, SnoozeNotificationMutationVariables>;

/**
 * __useSnoozeNotificationMutation__
 *
 * To run a mutation, you first call `useSnoozeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeNotificationMutation, { data, loading, error }] = useSnoozeNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duration: // value for 'duration'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSnoozeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeNotificationMutation, SnoozeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeNotificationMutation, SnoozeNotificationMutationVariables>(SnoozeNotificationDocument, options);
      }
export type SnoozeNotificationMutationHookResult = ReturnType<typeof useSnoozeNotificationMutation>;
export type SnoozeNotificationMutationResult = Apollo.MutationResult<SnoozeNotificationMutation>;
export type SnoozeNotificationMutationOptions = Apollo.BaseMutationOptions<SnoozeNotificationMutation, SnoozeNotificationMutationVariables>;
export const UnDismissNotificationDocument = gql`
    mutation UnDismissNotification($id: String!) {
  unDismissNotification(id: $id)
}
    `;
export type UnDismissNotificationMutationFn = Apollo.MutationFunction<UnDismissNotificationMutation, UnDismissNotificationMutationVariables>;

/**
 * __useUnDismissNotificationMutation__
 *
 * To run a mutation, you first call `useUnDismissNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnDismissNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unDismissNotificationMutation, { data, loading, error }] = useUnDismissNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnDismissNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UnDismissNotificationMutation, UnDismissNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnDismissNotificationMutation, UnDismissNotificationMutationVariables>(UnDismissNotificationDocument, options);
      }
export type UnDismissNotificationMutationHookResult = ReturnType<typeof useUnDismissNotificationMutation>;
export type UnDismissNotificationMutationResult = Apollo.MutationResult<UnDismissNotificationMutation>;
export type UnDismissNotificationMutationOptions = Apollo.BaseMutationOptions<UnDismissNotificationMutation, UnDismissNotificationMutationVariables>;
export const UserNotificationsDocument = gql`
    query UserNotifications($acknowledged: Boolean, $limit: Int, $after: String) {
  notifications(
    query: {acknowledged: $acknowledged, limit: $limit, after: $after}
  ) {
    edges {
      cursor
      node {
        ...NotificationFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${NotificationFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useUserNotificationsQuery__
 *
 * To run a query within a React component, call `useUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsQuery({
 *   variables: {
 *      acknowledged: // value for 'acknowledged'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
      }
export function useUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
        }
export type UserNotificationsQueryHookResult = ReturnType<typeof useUserNotificationsQuery>;
export type UserNotificationsLazyQueryHookResult = ReturnType<typeof useUserNotificationsLazyQuery>;
export type UserNotificationsQueryResult = Apollo.QueryResult<UserNotificationsQuery, UserNotificationsQueryVariables>;
export function refetchUserNotificationsQuery(variables?: UserNotificationsQueryVariables) {
      return { query: UserNotificationsDocument, variables: variables }
    }
export const SystemNotificationsListDocument = gql`
    query SystemNotificationsList($sortOrder: SortOrder = ASCENDING, $notificationSortField: NotificationSortField, $limit: Int = 25, $after: String, $before: String, $searchText: String, $filters: [FilterInput], $statuses: [NotificationStatus!]) {
  systemNotifications(
    query: {sortOrder: $sortOrder, limit: $limit, after: $after, before: $before, notificationSortField: $notificationSortField, searchText: $searchText, filters: $filters, statuses: $statuses}
  ) {
    edges {
      node {
        ...NotificationFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${NotificationFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSystemNotificationsListQuery__
 *
 * To run a query within a React component, call `useSystemNotificationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      notificationSortField: // value for 'notificationSortField'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useSystemNotificationsListQuery(baseOptions?: Apollo.QueryHookOptions<SystemNotificationsListQuery, SystemNotificationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemNotificationsListQuery, SystemNotificationsListQueryVariables>(SystemNotificationsListDocument, options);
      }
export function useSystemNotificationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemNotificationsListQuery, SystemNotificationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemNotificationsListQuery, SystemNotificationsListQueryVariables>(SystemNotificationsListDocument, options);
        }
export type SystemNotificationsListQueryHookResult = ReturnType<typeof useSystemNotificationsListQuery>;
export type SystemNotificationsListLazyQueryHookResult = ReturnType<typeof useSystemNotificationsListLazyQuery>;
export type SystemNotificationsListQueryResult = Apollo.QueryResult<SystemNotificationsListQuery, SystemNotificationsListQueryVariables>;
export function refetchSystemNotificationsListQuery(variables?: SystemNotificationsListQueryVariables) {
      return { query: SystemNotificationsListDocument, variables: variables }
    }
export const UserNotificationsListDocument = gql`
    query UserNotificationsList($sortOrder: SortOrder = ASCENDING, $limit: Int = 25, $acknowledged: Boolean, $after: String) {
  notifications(
    query: {sortOrder: $sortOrder, acknowledged: $acknowledged, limit: $limit, after: $after}
  ) {
    edges {
      cursor
      node {
        ...NotificationFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${NotificationFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useUserNotificationsListQuery__
 *
 * To run a query within a React component, call `useUserNotificationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      limit: // value for 'limit'
 *      acknowledged: // value for 'acknowledged'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUserNotificationsListQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationsListQuery, UserNotificationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationsListQuery, UserNotificationsListQueryVariables>(UserNotificationsListDocument, options);
      }
export function useUserNotificationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationsListQuery, UserNotificationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationsListQuery, UserNotificationsListQueryVariables>(UserNotificationsListDocument, options);
        }
export type UserNotificationsListQueryHookResult = ReturnType<typeof useUserNotificationsListQuery>;
export type UserNotificationsListLazyQueryHookResult = ReturnType<typeof useUserNotificationsListLazyQuery>;
export type UserNotificationsListQueryResult = Apollo.QueryResult<UserNotificationsListQuery, UserNotificationsListQueryVariables>;
export function refetchUserNotificationsListQuery(variables?: UserNotificationsListQueryVariables) {
      return { query: UserNotificationsListDocument, variables: variables }
    }
export const UserNotificationUpdatedDocument = gql`
    subscription UserNotificationUpdated {
  notificationUpdated {
    id
    acknowledgedTime
    urgentNotification
    acknowledgedBy
    audibleAlarm
    soundFile
  }
}
    `;

/**
 * __useUserNotificationUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserNotificationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserNotificationUpdatedSubscription, UserNotificationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserNotificationUpdatedSubscription, UserNotificationUpdatedSubscriptionVariables>(UserNotificationUpdatedDocument, options);
      }
export type UserNotificationUpdatedSubscriptionHookResult = ReturnType<typeof useUserNotificationUpdatedSubscription>;
export type UserNotificationUpdatedSubscriptionResult = Apollo.SubscriptionResult<UserNotificationUpdatedSubscription>;
export const NotificationPreferencesDocument = gql`
    query NotificationPreferences {
  notificationPreferences {
    location
    preferenceSourceList {
      source
      severitySet
    }
  }
}
    `;

/**
 * __useNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>(NotificationPreferencesDocument, options);
      }
export function useNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>(NotificationPreferencesDocument, options);
        }
export type NotificationPreferencesQueryHookResult = ReturnType<typeof useNotificationPreferencesQuery>;
export type NotificationPreferencesLazyQueryHookResult = ReturnType<typeof useNotificationPreferencesLazyQuery>;
export type NotificationPreferencesQueryResult = Apollo.QueryResult<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>;
export function refetchNotificationPreferencesQuery(variables?: NotificationPreferencesQueryVariables) {
      return { query: NotificationPreferencesDocument, variables: variables }
    }
export const SaveParkingAreaMessageDocument = gql`
    mutation SaveParkingAreaMessage($message: ParkingAreaMessageInput!) {
  parkingAreaSaveMessage(message: $message) {
    id
  }
}
    `;
export type SaveParkingAreaMessageMutationFn = Apollo.MutationFunction<SaveParkingAreaMessageMutation, SaveParkingAreaMessageMutationVariables>;

/**
 * __useSaveParkingAreaMessageMutation__
 *
 * To run a mutation, you first call `useSaveParkingAreaMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveParkingAreaMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveParkingAreaMessageMutation, { data, loading, error }] = useSaveParkingAreaMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSaveParkingAreaMessageMutation(baseOptions?: Apollo.MutationHookOptions<SaveParkingAreaMessageMutation, SaveParkingAreaMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveParkingAreaMessageMutation, SaveParkingAreaMessageMutationVariables>(SaveParkingAreaMessageDocument, options);
      }
export type SaveParkingAreaMessageMutationHookResult = ReturnType<typeof useSaveParkingAreaMessageMutation>;
export type SaveParkingAreaMessageMutationResult = Apollo.MutationResult<SaveParkingAreaMessageMutation>;
export type SaveParkingAreaMessageMutationOptions = Apollo.BaseMutationOptions<SaveParkingAreaMessageMutation, SaveParkingAreaMessageMutationVariables>;
export const DeleteParkingAreaMessageDocument = gql`
    mutation DeleteParkingAreaMessage($id: ID!) {
  parkingAreaDeleteMessage(id: $id)
}
    `;
export type DeleteParkingAreaMessageMutationFn = Apollo.MutationFunction<DeleteParkingAreaMessageMutation, DeleteParkingAreaMessageMutationVariables>;

/**
 * __useDeleteParkingAreaMessageMutation__
 *
 * To run a mutation, you first call `useDeleteParkingAreaMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParkingAreaMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParkingAreaMessageMutation, { data, loading, error }] = useDeleteParkingAreaMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteParkingAreaMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteParkingAreaMessageMutation, DeleteParkingAreaMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteParkingAreaMessageMutation, DeleteParkingAreaMessageMutationVariables>(DeleteParkingAreaMessageDocument, options);
      }
export type DeleteParkingAreaMessageMutationHookResult = ReturnType<typeof useDeleteParkingAreaMessageMutation>;
export type DeleteParkingAreaMessageMutationResult = Apollo.MutationResult<DeleteParkingAreaMessageMutation>;
export type DeleteParkingAreaMessageMutationOptions = Apollo.BaseMutationOptions<DeleteParkingAreaMessageMutation, DeleteParkingAreaMessageMutationVariables>;
export const ParkingAreaPostMessageDocument = gql`
    mutation ParkingAreaPostMessage($messages: [ParkingPostRequest!]!) {
  parkingAreaPostMessage(messages: $messages) {
    success
  }
}
    `;
export type ParkingAreaPostMessageMutationFn = Apollo.MutationFunction<ParkingAreaPostMessageMutation, ParkingAreaPostMessageMutationVariables>;

/**
 * __useParkingAreaPostMessageMutation__
 *
 * To run a mutation, you first call `useParkingAreaPostMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaPostMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parkingAreaPostMessageMutation, { data, loading, error }] = useParkingAreaPostMessageMutation({
 *   variables: {
 *      messages: // value for 'messages'
 *   },
 * });
 */
export function useParkingAreaPostMessageMutation(baseOptions?: Apollo.MutationHookOptions<ParkingAreaPostMessageMutation, ParkingAreaPostMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParkingAreaPostMessageMutation, ParkingAreaPostMessageMutationVariables>(ParkingAreaPostMessageDocument, options);
      }
export type ParkingAreaPostMessageMutationHookResult = ReturnType<typeof useParkingAreaPostMessageMutation>;
export type ParkingAreaPostMessageMutationResult = Apollo.MutationResult<ParkingAreaPostMessageMutation>;
export type ParkingAreaPostMessageMutationOptions = Apollo.BaseMutationOptions<ParkingAreaPostMessageMutation, ParkingAreaPostMessageMutationVariables>;
export const ParkingAreaBlankMessageDocument = gql`
    mutation ParkingAreaBlankMessage($id: ID!, $signs: [ID!]!) {
  parkingAreaBlankMessage(id: $id, signs: $signs) {
    success
  }
}
    `;
export type ParkingAreaBlankMessageMutationFn = Apollo.MutationFunction<ParkingAreaBlankMessageMutation, ParkingAreaBlankMessageMutationVariables>;

/**
 * __useParkingAreaBlankMessageMutation__
 *
 * To run a mutation, you first call `useParkingAreaBlankMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaBlankMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parkingAreaBlankMessageMutation, { data, loading, error }] = useParkingAreaBlankMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      signs: // value for 'signs'
 *   },
 * });
 */
export function useParkingAreaBlankMessageMutation(baseOptions?: Apollo.MutationHookOptions<ParkingAreaBlankMessageMutation, ParkingAreaBlankMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParkingAreaBlankMessageMutation, ParkingAreaBlankMessageMutationVariables>(ParkingAreaBlankMessageDocument, options);
      }
export type ParkingAreaBlankMessageMutationHookResult = ReturnType<typeof useParkingAreaBlankMessageMutation>;
export type ParkingAreaBlankMessageMutationResult = Apollo.MutationResult<ParkingAreaBlankMessageMutation>;
export type ParkingAreaBlankMessageMutationOptions = Apollo.BaseMutationOptions<ParkingAreaBlankMessageMutation, ParkingAreaBlankMessageMutationVariables>;
export const ParkingAreaListDocument = gql`
    query ParkingAreaList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  parkingAreas(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        communicationStatus
        lastDataReceived
        referencePoint
        direction
        occupied
        vacant
        status
        total
        road
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useParkingAreaListQuery__
 *
 * To run a query within a React component, call `useParkingAreaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkingAreaListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useParkingAreaListQuery(baseOptions?: Apollo.QueryHookOptions<ParkingAreaListQuery, ParkingAreaListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParkingAreaListQuery, ParkingAreaListQueryVariables>(ParkingAreaListDocument, options);
      }
export function useParkingAreaListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParkingAreaListQuery, ParkingAreaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParkingAreaListQuery, ParkingAreaListQueryVariables>(ParkingAreaListDocument, options);
        }
export type ParkingAreaListQueryHookResult = ReturnType<typeof useParkingAreaListQuery>;
export type ParkingAreaListLazyQueryHookResult = ReturnType<typeof useParkingAreaListLazyQuery>;
export type ParkingAreaListQueryResult = Apollo.QueryResult<ParkingAreaListQuery, ParkingAreaListQueryVariables>;
export function refetchParkingAreaListQuery(variables?: ParkingAreaListQueryVariables) {
      return { query: ParkingAreaListDocument, variables: variables }
    }
export const ParkingAreaSearchListDocument = gql`
    query ParkingAreaSearchList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  parkingAreas(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        location
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useParkingAreaSearchListQuery__
 *
 * To run a query within a React component, call `useParkingAreaSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkingAreaSearchListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useParkingAreaSearchListQuery(baseOptions?: Apollo.QueryHookOptions<ParkingAreaSearchListQuery, ParkingAreaSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParkingAreaSearchListQuery, ParkingAreaSearchListQueryVariables>(ParkingAreaSearchListDocument, options);
      }
export function useParkingAreaSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParkingAreaSearchListQuery, ParkingAreaSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParkingAreaSearchListQuery, ParkingAreaSearchListQueryVariables>(ParkingAreaSearchListDocument, options);
        }
export type ParkingAreaSearchListQueryHookResult = ReturnType<typeof useParkingAreaSearchListQuery>;
export type ParkingAreaSearchListLazyQueryHookResult = ReturnType<typeof useParkingAreaSearchListLazyQuery>;
export type ParkingAreaSearchListQueryResult = Apollo.QueryResult<ParkingAreaSearchListQuery, ParkingAreaSearchListQueryVariables>;
export function refetchParkingAreaSearchListQuery(variables?: ParkingAreaSearchListQueryVariables) {
      return { query: ParkingAreaSearchListDocument, variables: variables }
    }
export const LiveParkingAreaListDocument = gql`
    subscription LiveParkingAreaList($ids: [ID!]!) {
  parkingAreaUpdated(ids: $ids) {
    communicationStatus
    lastDataReceived
    referencePoint
    direction
    occupied
    vacant
    status
    total
    road
    name
    id
  }
}
    `;

/**
 * __useLiveParkingAreaListSubscription__
 *
 * To run a query within a React component, call `useLiveParkingAreaListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveParkingAreaListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveParkingAreaListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveParkingAreaListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveParkingAreaListSubscription, LiveParkingAreaListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveParkingAreaListSubscription, LiveParkingAreaListSubscriptionVariables>(LiveParkingAreaListDocument, options);
      }
export type LiveParkingAreaListSubscriptionHookResult = ReturnType<typeof useLiveParkingAreaListSubscription>;
export type LiveParkingAreaListSubscriptionResult = Apollo.SubscriptionResult<LiveParkingAreaListSubscription>;
export const ParkingAreaDocument = gql`
    query ParkingArea($id: ID!) {
  parkingArea(id: $id) {
    communicationStatus
    lastDataReceived
    referencePoint
    cameras
    levels {
      spaces {
        status
        index
        type
      }
      occupied
      status
      vacant
      total
      index
      name
    }
    direction
    occupied
    location
    vacant
    status
    total
    signs
    road
    name
    id
  }
}
    `;

/**
 * __useParkingAreaQuery__
 *
 * To run a query within a React component, call `useParkingAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkingAreaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useParkingAreaQuery(baseOptions: Apollo.QueryHookOptions<ParkingAreaQuery, ParkingAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParkingAreaQuery, ParkingAreaQueryVariables>(ParkingAreaDocument, options);
      }
export function useParkingAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParkingAreaQuery, ParkingAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParkingAreaQuery, ParkingAreaQueryVariables>(ParkingAreaDocument, options);
        }
export type ParkingAreaQueryHookResult = ReturnType<typeof useParkingAreaQuery>;
export type ParkingAreaLazyQueryHookResult = ReturnType<typeof useParkingAreaLazyQuery>;
export type ParkingAreaQueryResult = Apollo.QueryResult<ParkingAreaQuery, ParkingAreaQueryVariables>;
export function refetchParkingAreaQuery(variables: ParkingAreaQueryVariables) {
      return { query: ParkingAreaDocument, variables: variables }
    }
export const LiveParkingAreaDocument = gql`
    subscription LiveParkingArea($id: ID!) {
  parkingAreaUpdated(ids: [$id]) {
    communicationStatus
    lastDataReceived
    referencePoint
    direction
    occupied
    location
    cameras
    vacant
    levels {
      spaces {
        status
        index
        type
      }
      occupied
      status
      vacant
      total
      index
      name
    }
    status
    signs
    total
    road
    name
    id
  }
}
    `;

/**
 * __useLiveParkingAreaSubscription__
 *
 * To run a query within a React component, call `useLiveParkingAreaSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveParkingAreaSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveParkingAreaSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveParkingAreaSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveParkingAreaSubscription, LiveParkingAreaSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveParkingAreaSubscription, LiveParkingAreaSubscriptionVariables>(LiveParkingAreaDocument, options);
      }
export type LiveParkingAreaSubscriptionHookResult = ReturnType<typeof useLiveParkingAreaSubscription>;
export type LiveParkingAreaSubscriptionResult = Apollo.SubscriptionResult<LiveParkingAreaSubscription>;
export const ParkingAreaDetailDocument = gql`
    query ParkingAreaDetail($id: ID!) {
  parkingArea(id: $id) {
    communicationStatus
    lastDataReceived
    referencePoint
    direction
    occupied
    vacant
    status
    total
    road
    name
    id
  }
}
    `;

/**
 * __useParkingAreaDetailQuery__
 *
 * To run a query within a React component, call `useParkingAreaDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkingAreaDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useParkingAreaDetailQuery(baseOptions: Apollo.QueryHookOptions<ParkingAreaDetailQuery, ParkingAreaDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParkingAreaDetailQuery, ParkingAreaDetailQueryVariables>(ParkingAreaDetailDocument, options);
      }
export function useParkingAreaDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParkingAreaDetailQuery, ParkingAreaDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParkingAreaDetailQuery, ParkingAreaDetailQueryVariables>(ParkingAreaDetailDocument, options);
        }
export type ParkingAreaDetailQueryHookResult = ReturnType<typeof useParkingAreaDetailQuery>;
export type ParkingAreaDetailLazyQueryHookResult = ReturnType<typeof useParkingAreaDetailLazyQuery>;
export type ParkingAreaDetailQueryResult = Apollo.QueryResult<ParkingAreaDetailQuery, ParkingAreaDetailQueryVariables>;
export function refetchParkingAreaDetailQuery(variables: ParkingAreaDetailQueryVariables) {
      return { query: ParkingAreaDetailDocument, variables: variables }
    }
export const LiveParkingAreaDetailDocument = gql`
    subscription LiveParkingAreaDetail($id: ID!) {
  parkingAreaUpdated(ids: [$id]) {
    communicationStatus
    lastDataReceived
    referencePoint
    direction
    occupied
    vacant
    status
    total
    road
    name
    id
  }
}
    `;

/**
 * __useLiveParkingAreaDetailSubscription__
 *
 * To run a query within a React component, call `useLiveParkingAreaDetailSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveParkingAreaDetailSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveParkingAreaDetailSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveParkingAreaDetailSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveParkingAreaDetailSubscription, LiveParkingAreaDetailSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveParkingAreaDetailSubscription, LiveParkingAreaDetailSubscriptionVariables>(LiveParkingAreaDetailDocument, options);
      }
export type LiveParkingAreaDetailSubscriptionHookResult = ReturnType<typeof useLiveParkingAreaDetailSubscription>;
export type LiveParkingAreaDetailSubscriptionResult = Apollo.SubscriptionResult<LiveParkingAreaDetailSubscription>;
export const ParkingAreaMapDocument = gql`
    query ParkingAreaMap($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  parkingAreas(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        location
        status
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useParkingAreaMapQuery__
 *
 * To run a query within a React component, call `useParkingAreaMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkingAreaMapQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useParkingAreaMapQuery(baseOptions?: Apollo.QueryHookOptions<ParkingAreaMapQuery, ParkingAreaMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParkingAreaMapQuery, ParkingAreaMapQueryVariables>(ParkingAreaMapDocument, options);
      }
export function useParkingAreaMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParkingAreaMapQuery, ParkingAreaMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParkingAreaMapQuery, ParkingAreaMapQueryVariables>(ParkingAreaMapDocument, options);
        }
export type ParkingAreaMapQueryHookResult = ReturnType<typeof useParkingAreaMapQuery>;
export type ParkingAreaMapLazyQueryHookResult = ReturnType<typeof useParkingAreaMapLazyQuery>;
export type ParkingAreaMapQueryResult = Apollo.QueryResult<ParkingAreaMapQuery, ParkingAreaMapQueryVariables>;
export function refetchParkingAreaMapQuery(variables?: ParkingAreaMapQueryVariables) {
      return { query: ParkingAreaMapDocument, variables: variables }
    }
export const LiveParkingAreaMapDocument = gql`
    subscription LiveParkingAreaMap($ids: [ID!]!) {
  parkingAreaUpdated(ids: $ids) {
    location
    status
    id
  }
}
    `;

/**
 * __useLiveParkingAreaMapSubscription__
 *
 * To run a query within a React component, call `useLiveParkingAreaMapSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveParkingAreaMapSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveParkingAreaMapSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveParkingAreaMapSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveParkingAreaMapSubscription, LiveParkingAreaMapSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveParkingAreaMapSubscription, LiveParkingAreaMapSubscriptionVariables>(LiveParkingAreaMapDocument, options);
      }
export type LiveParkingAreaMapSubscriptionHookResult = ReturnType<typeof useLiveParkingAreaMapSubscription>;
export type LiveParkingAreaMapSubscriptionResult = Apollo.SubscriptionResult<LiveParkingAreaMapSubscription>;
export const ParkingAreaSummaryDocument = gql`
    query ParkingAreaSummary {
  OPEN: parkingAreas(
    query: {filters: [{operator: EQUALS, field: "status", value: "OPEN"}]}
  ) {
    totalCount
  }
  FULL: parkingAreas(
    query: {filters: [{operator: EQUALS, field: "status", value: "FULL"}]}
  ) {
    totalCount
  }
  CLOSED: parkingAreas(
    query: {filters: [{operator: EQUALS, field: "status", value: "CLOSED"}]}
  ) {
    totalCount
  }
  UNKNOWN: parkingAreas(
    query: {filters: [{operator: EQUALS, field: "status", value: "UNKNOWN"}]}
  ) {
    totalCount
  }
  NEARLY_FULL: parkingAreas(
    query: {filters: [{operator: EQUALS, field: "status", value: "NEARLY_FULL"}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useParkingAreaSummaryQuery__
 *
 * To run a query within a React component, call `useParkingAreaSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkingAreaSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useParkingAreaSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ParkingAreaSummaryQuery, ParkingAreaSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParkingAreaSummaryQuery, ParkingAreaSummaryQueryVariables>(ParkingAreaSummaryDocument, options);
      }
export function useParkingAreaSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParkingAreaSummaryQuery, ParkingAreaSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParkingAreaSummaryQuery, ParkingAreaSummaryQueryVariables>(ParkingAreaSummaryDocument, options);
        }
export type ParkingAreaSummaryQueryHookResult = ReturnType<typeof useParkingAreaSummaryQuery>;
export type ParkingAreaSummaryLazyQueryHookResult = ReturnType<typeof useParkingAreaSummaryLazyQuery>;
export type ParkingAreaSummaryQueryResult = Apollo.QueryResult<ParkingAreaSummaryQuery, ParkingAreaSummaryQueryVariables>;
export function refetchParkingAreaSummaryQuery(variables?: ParkingAreaSummaryQueryVariables) {
      return { query: ParkingAreaSummaryDocument, variables: variables }
    }
export const ParkingAreaMessageListDocument = gql`
    query ParkingAreaMessageList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  parkingAreaMessages(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        template {
          ...SignMessage
        }
        parkingArea
        sign
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignMessageFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useParkingAreaMessageListQuery__
 *
 * To run a query within a React component, call `useParkingAreaMessageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaMessageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkingAreaMessageListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useParkingAreaMessageListQuery(baseOptions?: Apollo.QueryHookOptions<ParkingAreaMessageListQuery, ParkingAreaMessageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParkingAreaMessageListQuery, ParkingAreaMessageListQueryVariables>(ParkingAreaMessageListDocument, options);
      }
export function useParkingAreaMessageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParkingAreaMessageListQuery, ParkingAreaMessageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParkingAreaMessageListQuery, ParkingAreaMessageListQueryVariables>(ParkingAreaMessageListDocument, options);
        }
export type ParkingAreaMessageListQueryHookResult = ReturnType<typeof useParkingAreaMessageListQuery>;
export type ParkingAreaMessageListLazyQueryHookResult = ReturnType<typeof useParkingAreaMessageListLazyQuery>;
export type ParkingAreaMessageListQueryResult = Apollo.QueryResult<ParkingAreaMessageListQuery, ParkingAreaMessageListQueryVariables>;
export function refetchParkingAreaMessageListQuery(variables?: ParkingAreaMessageListQueryVariables) {
      return { query: ParkingAreaMessageListDocument, variables: variables }
    }
export const ParkingAreaMessageDocument = gql`
    query ParkingAreaMessage($id: ID!) {
  parkingAreaMessage(id: $id) {
    template {
      ...SignMessage
    }
    parkingArea
    sign
    name
    id
  }
}
    ${SignMessageFragmentDoc}`;

/**
 * __useParkingAreaMessageQuery__
 *
 * To run a query within a React component, call `useParkingAreaMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkingAreaMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkingAreaMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useParkingAreaMessageQuery(baseOptions: Apollo.QueryHookOptions<ParkingAreaMessageQuery, ParkingAreaMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParkingAreaMessageQuery, ParkingAreaMessageQueryVariables>(ParkingAreaMessageDocument, options);
      }
export function useParkingAreaMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParkingAreaMessageQuery, ParkingAreaMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParkingAreaMessageQuery, ParkingAreaMessageQueryVariables>(ParkingAreaMessageDocument, options);
        }
export type ParkingAreaMessageQueryHookResult = ReturnType<typeof useParkingAreaMessageQuery>;
export type ParkingAreaMessageLazyQueryHookResult = ReturnType<typeof useParkingAreaMessageLazyQuery>;
export type ParkingAreaMessageQueryResult = Apollo.QueryResult<ParkingAreaMessageQuery, ParkingAreaMessageQueryVariables>;
export function refetchParkingAreaMessageQuery(variables: ParkingAreaMessageQueryVariables) {
      return { query: ParkingAreaMessageDocument, variables: variables }
    }
export const DeleteUserTenantPreferenceDocument = gql`
    mutation DeleteUserTenantPreference($key: ID!) {
  deleteUserPreference(key: $key)
}
    `;
export type DeleteUserTenantPreferenceMutationFn = Apollo.MutationFunction<DeleteUserTenantPreferenceMutation, DeleteUserTenantPreferenceMutationVariables>;

/**
 * __useDeleteUserTenantPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteUserTenantPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTenantPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTenantPreferenceMutation, { data, loading, error }] = useDeleteUserTenantPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteUserTenantPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserTenantPreferenceMutation, DeleteUserTenantPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserTenantPreferenceMutation, DeleteUserTenantPreferenceMutationVariables>(DeleteUserTenantPreferenceDocument, options);
      }
export type DeleteUserTenantPreferenceMutationHookResult = ReturnType<typeof useDeleteUserTenantPreferenceMutation>;
export type DeleteUserTenantPreferenceMutationResult = Apollo.MutationResult<DeleteUserTenantPreferenceMutation>;
export type DeleteUserTenantPreferenceMutationOptions = Apollo.BaseMutationOptions<DeleteUserTenantPreferenceMutation, DeleteUserTenantPreferenceMutationVariables>;
export const DeleteUserKineticPreferenceDocument = gql`
    mutation DeleteUserKineticPreference($key: ID!) {
  deleteKineticUserPreference(key: $key)
}
    `;
export type DeleteUserKineticPreferenceMutationFn = Apollo.MutationFunction<DeleteUserKineticPreferenceMutation, DeleteUserKineticPreferenceMutationVariables>;

/**
 * __useDeleteUserKineticPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteUserKineticPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserKineticPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserKineticPreferenceMutation, { data, loading, error }] = useDeleteUserKineticPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteUserKineticPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserKineticPreferenceMutation, DeleteUserKineticPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserKineticPreferenceMutation, DeleteUserKineticPreferenceMutationVariables>(DeleteUserKineticPreferenceDocument, options);
      }
export type DeleteUserKineticPreferenceMutationHookResult = ReturnType<typeof useDeleteUserKineticPreferenceMutation>;
export type DeleteUserKineticPreferenceMutationResult = Apollo.MutationResult<DeleteUserKineticPreferenceMutation>;
export type DeleteUserKineticPreferenceMutationOptions = Apollo.BaseMutationOptions<DeleteUserKineticPreferenceMutation, DeleteUserKineticPreferenceMutationVariables>;
export const DeleteOrganizationPreferenceDocument = gql`
    mutation DeleteOrganizationPreference($key: ID!) {
  deleteOrganizationPreference(key: $key)
}
    `;
export type DeleteOrganizationPreferenceMutationFn = Apollo.MutationFunction<DeleteOrganizationPreferenceMutation, DeleteOrganizationPreferenceMutationVariables>;

/**
 * __useDeleteOrganizationPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationPreferenceMutation, { data, loading, error }] = useDeleteOrganizationPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteOrganizationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationPreferenceMutation, DeleteOrganizationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationPreferenceMutation, DeleteOrganizationPreferenceMutationVariables>(DeleteOrganizationPreferenceDocument, options);
      }
export type DeleteOrganizationPreferenceMutationHookResult = ReturnType<typeof useDeleteOrganizationPreferenceMutation>;
export type DeleteOrganizationPreferenceMutationResult = Apollo.MutationResult<DeleteOrganizationPreferenceMutation>;
export type DeleteOrganizationPreferenceMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationPreferenceMutation, DeleteOrganizationPreferenceMutationVariables>;
export const UpdatePartialKineticUserPreferenceDocument = gql`
    mutation UpdatePartialKineticUserPreference($key: ID!, $value: JSON!) {
  updatePartialUserPreference(key: $key, value: $value)
}
    `;
export type UpdatePartialKineticUserPreferenceMutationFn = Apollo.MutationFunction<UpdatePartialKineticUserPreferenceMutation, UpdatePartialKineticUserPreferenceMutationVariables>;

/**
 * __useUpdatePartialKineticUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdatePartialKineticUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartialKineticUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartialKineticUserPreferenceMutation, { data, loading, error }] = useUpdatePartialKineticUserPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdatePartialKineticUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartialKineticUserPreferenceMutation, UpdatePartialKineticUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartialKineticUserPreferenceMutation, UpdatePartialKineticUserPreferenceMutationVariables>(UpdatePartialKineticUserPreferenceDocument, options);
      }
export type UpdatePartialKineticUserPreferenceMutationHookResult = ReturnType<typeof useUpdatePartialKineticUserPreferenceMutation>;
export type UpdatePartialKineticUserPreferenceMutationResult = Apollo.MutationResult<UpdatePartialKineticUserPreferenceMutation>;
export type UpdatePartialKineticUserPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdatePartialKineticUserPreferenceMutation, UpdatePartialKineticUserPreferenceMutationVariables>;
export const RemovePartialKineticUserPreferenceDocument = gql`
    mutation RemovePartialKineticUserPreference($key: ID!, $valueId: String!) {
  removePartialUserPreference(key: $key, valueId: $valueId)
}
    `;
export type RemovePartialKineticUserPreferenceMutationFn = Apollo.MutationFunction<RemovePartialKineticUserPreferenceMutation, RemovePartialKineticUserPreferenceMutationVariables>;

/**
 * __useRemovePartialKineticUserPreferenceMutation__
 *
 * To run a mutation, you first call `useRemovePartialKineticUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePartialKineticUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePartialKineticUserPreferenceMutation, { data, loading, error }] = useRemovePartialKineticUserPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *      valueId: // value for 'valueId'
 *   },
 * });
 */
export function useRemovePartialKineticUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<RemovePartialKineticUserPreferenceMutation, RemovePartialKineticUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePartialKineticUserPreferenceMutation, RemovePartialKineticUserPreferenceMutationVariables>(RemovePartialKineticUserPreferenceDocument, options);
      }
export type RemovePartialKineticUserPreferenceMutationHookResult = ReturnType<typeof useRemovePartialKineticUserPreferenceMutation>;
export type RemovePartialKineticUserPreferenceMutationResult = Apollo.MutationResult<RemovePartialKineticUserPreferenceMutation>;
export type RemovePartialKineticUserPreferenceMutationOptions = Apollo.BaseMutationOptions<RemovePartialKineticUserPreferenceMutation, RemovePartialKineticUserPreferenceMutationVariables>;
export const SaveUserPrefDocument = gql`
    mutation SaveUserPref($key: ID!, $value: JSON!) {
  saveUserPreference(key: $key, value: $value)
}
    `;
export type SaveUserPrefMutationFn = Apollo.MutationFunction<SaveUserPrefMutation, SaveUserPrefMutationVariables>;

/**
 * __useSaveUserPrefMutation__
 *
 * To run a mutation, you first call `useSaveUserPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserPrefMutation, { data, loading, error }] = useSaveUserPrefMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSaveUserPrefMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserPrefMutation, SaveUserPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserPrefMutation, SaveUserPrefMutationVariables>(SaveUserPrefDocument, options);
      }
export type SaveUserPrefMutationHookResult = ReturnType<typeof useSaveUserPrefMutation>;
export type SaveUserPrefMutationResult = Apollo.MutationResult<SaveUserPrefMutation>;
export type SaveUserPrefMutationOptions = Apollo.BaseMutationOptions<SaveUserPrefMutation, SaveUserPrefMutationVariables>;
export const SaveKineticUserPrefMutationDocument = gql`
    mutation SaveKineticUserPrefMutation($key: ID!, $value: JSON!) {
  saveKineticUserPreference(key: $key, value: $value)
}
    `;
export type SaveKineticUserPrefMutationMutationFn = Apollo.MutationFunction<SaveKineticUserPrefMutationMutation, SaveKineticUserPrefMutationMutationVariables>;

/**
 * __useSaveKineticUserPrefMutationMutation__
 *
 * To run a mutation, you first call `useSaveKineticUserPrefMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveKineticUserPrefMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveKineticUserPrefMutationMutation, { data, loading, error }] = useSaveKineticUserPrefMutationMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSaveKineticUserPrefMutationMutation(baseOptions?: Apollo.MutationHookOptions<SaveKineticUserPrefMutationMutation, SaveKineticUserPrefMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveKineticUserPrefMutationMutation, SaveKineticUserPrefMutationMutationVariables>(SaveKineticUserPrefMutationDocument, options);
      }
export type SaveKineticUserPrefMutationMutationHookResult = ReturnType<typeof useSaveKineticUserPrefMutationMutation>;
export type SaveKineticUserPrefMutationMutationResult = Apollo.MutationResult<SaveKineticUserPrefMutationMutation>;
export type SaveKineticUserPrefMutationMutationOptions = Apollo.BaseMutationOptions<SaveKineticUserPrefMutationMutation, SaveKineticUserPrefMutationMutationVariables>;
export const SaveNotificationPreferencesDocument = gql`
    mutation SaveNotificationPreferences($notificationPreferences: NotificationPreferenceInput) {
  saveNotificationPreferences(notificationPreferences: $notificationPreferences) {
    location
    preferenceSourceList {
      source
      severitySet
    }
  }
}
    `;
export type SaveNotificationPreferencesMutationFn = Apollo.MutationFunction<SaveNotificationPreferencesMutation, SaveNotificationPreferencesMutationVariables>;

/**
 * __useSaveNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useSaveNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNotificationPreferencesMutation, { data, loading, error }] = useSaveNotificationPreferencesMutation({
 *   variables: {
 *      notificationPreferences: // value for 'notificationPreferences'
 *   },
 * });
 */
export function useSaveNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SaveNotificationPreferencesMutation, SaveNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNotificationPreferencesMutation, SaveNotificationPreferencesMutationVariables>(SaveNotificationPreferencesDocument, options);
      }
export type SaveNotificationPreferencesMutationHookResult = ReturnType<typeof useSaveNotificationPreferencesMutation>;
export type SaveNotificationPreferencesMutationResult = Apollo.MutationResult<SaveNotificationPreferencesMutation>;
export type SaveNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<SaveNotificationPreferencesMutation, SaveNotificationPreferencesMutationVariables>;
export const SaveOrganizationPreferenceDocument = gql`
    mutation SaveOrganizationPreference($key: ID!, $value: JSON!) {
  saveOrganizationPreference(key: $key, value: $value)
}
    `;
export type SaveOrganizationPreferenceMutationFn = Apollo.MutationFunction<SaveOrganizationPreferenceMutation, SaveOrganizationPreferenceMutationVariables>;

/**
 * __useSaveOrganizationPreferenceMutation__
 *
 * To run a mutation, you first call `useSaveOrganizationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrganizationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrganizationPreferenceMutation, { data, loading, error }] = useSaveOrganizationPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSaveOrganizationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrganizationPreferenceMutation, SaveOrganizationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrganizationPreferenceMutation, SaveOrganizationPreferenceMutationVariables>(SaveOrganizationPreferenceDocument, options);
      }
export type SaveOrganizationPreferenceMutationHookResult = ReturnType<typeof useSaveOrganizationPreferenceMutation>;
export type SaveOrganizationPreferenceMutationResult = Apollo.MutationResult<SaveOrganizationPreferenceMutation>;
export type SaveOrganizationPreferenceMutationOptions = Apollo.BaseMutationOptions<SaveOrganizationPreferenceMutation, SaveOrganizationPreferenceMutationVariables>;
export const UpdatePartialOrganizationPreferenceDocument = gql`
    mutation UpdatePartialOrganizationPreference($key: ID!, $value: JSON!) {
  updatePartialOrganizationPreference(key: $key, value: $value)
}
    `;
export type UpdatePartialOrganizationPreferenceMutationFn = Apollo.MutationFunction<UpdatePartialOrganizationPreferenceMutation, UpdatePartialOrganizationPreferenceMutationVariables>;

/**
 * __useUpdatePartialOrganizationPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdatePartialOrganizationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartialOrganizationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartialOrganizationPreferenceMutation, { data, loading, error }] = useUpdatePartialOrganizationPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdatePartialOrganizationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartialOrganizationPreferenceMutation, UpdatePartialOrganizationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartialOrganizationPreferenceMutation, UpdatePartialOrganizationPreferenceMutationVariables>(UpdatePartialOrganizationPreferenceDocument, options);
      }
export type UpdatePartialOrganizationPreferenceMutationHookResult = ReturnType<typeof useUpdatePartialOrganizationPreferenceMutation>;
export type UpdatePartialOrganizationPreferenceMutationResult = Apollo.MutationResult<UpdatePartialOrganizationPreferenceMutation>;
export type UpdatePartialOrganizationPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdatePartialOrganizationPreferenceMutation, UpdatePartialOrganizationPreferenceMutationVariables>;
export const RemovePartialOrganizationPreferenceDocument = gql`
    mutation RemovePartialOrganizationPreference($key: ID!, $valueId: String!) {
  removePartialOrganizationPreference(key: $key, valueId: $valueId)
}
    `;
export type RemovePartialOrganizationPreferenceMutationFn = Apollo.MutationFunction<RemovePartialOrganizationPreferenceMutation, RemovePartialOrganizationPreferenceMutationVariables>;

/**
 * __useRemovePartialOrganizationPreferenceMutation__
 *
 * To run a mutation, you first call `useRemovePartialOrganizationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePartialOrganizationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePartialOrganizationPreferenceMutation, { data, loading, error }] = useRemovePartialOrganizationPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *      valueId: // value for 'valueId'
 *   },
 * });
 */
export function useRemovePartialOrganizationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<RemovePartialOrganizationPreferenceMutation, RemovePartialOrganizationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePartialOrganizationPreferenceMutation, RemovePartialOrganizationPreferenceMutationVariables>(RemovePartialOrganizationPreferenceDocument, options);
      }
export type RemovePartialOrganizationPreferenceMutationHookResult = ReturnType<typeof useRemovePartialOrganizationPreferenceMutation>;
export type RemovePartialOrganizationPreferenceMutationResult = Apollo.MutationResult<RemovePartialOrganizationPreferenceMutation>;
export type RemovePartialOrganizationPreferenceMutationOptions = Apollo.BaseMutationOptions<RemovePartialOrganizationPreferenceMutation, RemovePartialOrganizationPreferenceMutationVariables>;
export const ClearAllPreferencesDocument = gql`
    mutation ClearAllPreferences {
  removeUserPreferences
}
    `;
export type ClearAllPreferencesMutationFn = Apollo.MutationFunction<ClearAllPreferencesMutation, ClearAllPreferencesMutationVariables>;

/**
 * __useClearAllPreferencesMutation__
 *
 * To run a mutation, you first call `useClearAllPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllPreferencesMutation, { data, loading, error }] = useClearAllPreferencesMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearAllPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<ClearAllPreferencesMutation, ClearAllPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAllPreferencesMutation, ClearAllPreferencesMutationVariables>(ClearAllPreferencesDocument, options);
      }
export type ClearAllPreferencesMutationHookResult = ReturnType<typeof useClearAllPreferencesMutation>;
export type ClearAllPreferencesMutationResult = Apollo.MutationResult<ClearAllPreferencesMutation>;
export type ClearAllPreferencesMutationOptions = Apollo.BaseMutationOptions<ClearAllPreferencesMutation, ClearAllPreferencesMutationVariables>;
export const SaveKineticUserPrefDocument = gql`
    mutation SaveKineticUserPref($key: ID!, $value: JSON!) {
  saveKineticUserPreference(key: $key, value: $value)
}
    `;
export type SaveKineticUserPrefMutationFn = Apollo.MutationFunction<SaveKineticUserPrefMutation, SaveKineticUserPrefMutationVariables>;

/**
 * __useSaveKineticUserPrefMutation__
 *
 * To run a mutation, you first call `useSaveKineticUserPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveKineticUserPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveKineticUserPrefMutation, { data, loading, error }] = useSaveKineticUserPrefMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSaveKineticUserPrefMutation(baseOptions?: Apollo.MutationHookOptions<SaveKineticUserPrefMutation, SaveKineticUserPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveKineticUserPrefMutation, SaveKineticUserPrefMutationVariables>(SaveKineticUserPrefDocument, options);
      }
export type SaveKineticUserPrefMutationHookResult = ReturnType<typeof useSaveKineticUserPrefMutation>;
export type SaveKineticUserPrefMutationResult = Apollo.MutationResult<SaveKineticUserPrefMutation>;
export type SaveKineticUserPrefMutationOptions = Apollo.BaseMutationOptions<SaveKineticUserPrefMutation, SaveKineticUserPrefMutationVariables>;
export const SaveModuleMapSettingsDocument = gql`
    mutation SaveModuleMapSettings($settings: JSON!) {
  saveModuleMapSettings(settings: $settings)
}
    `;
export type SaveModuleMapSettingsMutationFn = Apollo.MutationFunction<SaveModuleMapSettingsMutation, SaveModuleMapSettingsMutationVariables>;

/**
 * __useSaveModuleMapSettingsMutation__
 *
 * To run a mutation, you first call `useSaveModuleMapSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveModuleMapSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveModuleMapSettingsMutation, { data, loading, error }] = useSaveModuleMapSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveModuleMapSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveModuleMapSettingsMutation, SaveModuleMapSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveModuleMapSettingsMutation, SaveModuleMapSettingsMutationVariables>(SaveModuleMapSettingsDocument, options);
      }
export type SaveModuleMapSettingsMutationHookResult = ReturnType<typeof useSaveModuleMapSettingsMutation>;
export type SaveModuleMapSettingsMutationResult = Apollo.MutationResult<SaveModuleMapSettingsMutation>;
export type SaveModuleMapSettingsMutationOptions = Apollo.BaseMutationOptions<SaveModuleMapSettingsMutation, SaveModuleMapSettingsMutationVariables>;
export const UserTenantPreferenceUpdatedDocument = gql`
    subscription UserTenantPreferenceUpdated {
  userPreferenceUpdated {
    streamObjectOperation
    userPreference {
      key
      value
    }
  }
}
    `;

/**
 * __useUserTenantPreferenceUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserTenantPreferenceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserTenantPreferenceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTenantPreferenceUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserTenantPreferenceUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserTenantPreferenceUpdatedSubscription, UserTenantPreferenceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserTenantPreferenceUpdatedSubscription, UserTenantPreferenceUpdatedSubscriptionVariables>(UserTenantPreferenceUpdatedDocument, options);
      }
export type UserTenantPreferenceUpdatedSubscriptionHookResult = ReturnType<typeof useUserTenantPreferenceUpdatedSubscription>;
export type UserTenantPreferenceUpdatedSubscriptionResult = Apollo.SubscriptionResult<UserTenantPreferenceUpdatedSubscription>;
export const UserKineticPreferenceUpdatedDocument = gql`
    subscription UserKineticPreferenceUpdated {
  kineticUserPreferenceUpdated {
    streamObjectOperation
    userPreference {
      key
      value
    }
  }
}
    `;

/**
 * __useUserKineticPreferenceUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserKineticPreferenceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserKineticPreferenceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserKineticPreferenceUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserKineticPreferenceUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserKineticPreferenceUpdatedSubscription, UserKineticPreferenceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserKineticPreferenceUpdatedSubscription, UserKineticPreferenceUpdatedSubscriptionVariables>(UserKineticPreferenceUpdatedDocument, options);
      }
export type UserKineticPreferenceUpdatedSubscriptionHookResult = ReturnType<typeof useUserKineticPreferenceUpdatedSubscription>;
export type UserKineticPreferenceUpdatedSubscriptionResult = Apollo.SubscriptionResult<UserKineticPreferenceUpdatedSubscription>;
export const ModuleMapSettingsDocument = gql`
    query ModuleMapSettings($formViewName: String!) {
  moduleMapSettings(formViewName: $formViewName) {
    id
    name
    views {
      id
      name
      views {
        ...FormViewFragment
        views {
          ...FormViewFragment
          views {
            ...FormViewFragment
          }
        }
      }
    }
    sections {
      ...ModuleFormSectionFragment
    }
    type
  }
}
    ${FormViewFragmentFragmentDoc}
${ModuleFormSectionFragmentFragmentDoc}`;

/**
 * __useModuleMapSettingsQuery__
 *
 * To run a query within a React component, call `useModuleMapSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleMapSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleMapSettingsQuery({
 *   variables: {
 *      formViewName: // value for 'formViewName'
 *   },
 * });
 */
export function useModuleMapSettingsQuery(baseOptions: Apollo.QueryHookOptions<ModuleMapSettingsQuery, ModuleMapSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModuleMapSettingsQuery, ModuleMapSettingsQueryVariables>(ModuleMapSettingsDocument, options);
      }
export function useModuleMapSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModuleMapSettingsQuery, ModuleMapSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModuleMapSettingsQuery, ModuleMapSettingsQueryVariables>(ModuleMapSettingsDocument, options);
        }
export type ModuleMapSettingsQueryHookResult = ReturnType<typeof useModuleMapSettingsQuery>;
export type ModuleMapSettingsLazyQueryHookResult = ReturnType<typeof useModuleMapSettingsLazyQuery>;
export type ModuleMapSettingsQueryResult = Apollo.QueryResult<ModuleMapSettingsQuery, ModuleMapSettingsQueryVariables>;
export function refetchModuleMapSettingsQuery(variables: ModuleMapSettingsQueryVariables) {
      return { query: ModuleMapSettingsDocument, variables: variables }
    }
export const OrganizationPreferenceUpdatedDocument = gql`
    subscription OrganizationPreferenceUpdated($key: String) {
  organizationPreferenceUpdated(key: $key) {
    streamObjectOperation
    organizationPreference {
      key
      value
    }
  }
}
    `;

/**
 * __useOrganizationPreferenceUpdatedSubscription__
 *
 * To run a query within a React component, call `useOrganizationPreferenceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPreferenceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPreferenceUpdatedSubscription({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useOrganizationPreferenceUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OrganizationPreferenceUpdatedSubscription, OrganizationPreferenceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrganizationPreferenceUpdatedSubscription, OrganizationPreferenceUpdatedSubscriptionVariables>(OrganizationPreferenceUpdatedDocument, options);
      }
export type OrganizationPreferenceUpdatedSubscriptionHookResult = ReturnType<typeof useOrganizationPreferenceUpdatedSubscription>;
export type OrganizationPreferenceUpdatedSubscriptionResult = Apollo.SubscriptionResult<OrganizationPreferenceUpdatedSubscription>;
export const RampMeterAppliedCommandUpdatedDocument = gql`
    subscription RampMeterAppliedCommandUpdated {
  signalAppliedCommandUpdated(intersectionType: RAMP_METER) {
    streamObjectOperation
    dto {
      id
      intersection {
        id
        name
      }
      device {
        id
        name
      }
      inheritedGroup {
        id
        name
      }
      command
      value
      taskId
      startDateTime
      endDateTime
      status
      source
    }
  }
}
    `;

/**
 * __useRampMeterAppliedCommandUpdatedSubscription__
 *
 * To run a query within a React component, call `useRampMeterAppliedCommandUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterAppliedCommandUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterAppliedCommandUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterAppliedCommandUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RampMeterAppliedCommandUpdatedSubscription, RampMeterAppliedCommandUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RampMeterAppliedCommandUpdatedSubscription, RampMeterAppliedCommandUpdatedSubscriptionVariables>(RampMeterAppliedCommandUpdatedDocument, options);
      }
export type RampMeterAppliedCommandUpdatedSubscriptionHookResult = ReturnType<typeof useRampMeterAppliedCommandUpdatedSubscription>;
export type RampMeterAppliedCommandUpdatedSubscriptionResult = Apollo.SubscriptionResult<RampMeterAppliedCommandUpdatedSubscription>;
export const RampMeterAppliedCommandFilterOptionsDocument = gql`
    query RampMeterAppliedCommandFilterOptions {
  signalAppliedCommandFilterOptions(intersectionType: RAMP_METER) {
    intersections {
      id
      name
    }
    devices {
      id
      name
    }
    inheritedGroups {
      id
      name
    }
    commands
    sources
  }
}
    `;

/**
 * __useRampMeterAppliedCommandFilterOptionsQuery__
 *
 * To run a query within a React component, call `useRampMeterAppliedCommandFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterAppliedCommandFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterAppliedCommandFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterAppliedCommandFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterAppliedCommandFilterOptionsQuery, RampMeterAppliedCommandFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterAppliedCommandFilterOptionsQuery, RampMeterAppliedCommandFilterOptionsQueryVariables>(RampMeterAppliedCommandFilterOptionsDocument, options);
      }
export function useRampMeterAppliedCommandFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterAppliedCommandFilterOptionsQuery, RampMeterAppliedCommandFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterAppliedCommandFilterOptionsQuery, RampMeterAppliedCommandFilterOptionsQueryVariables>(RampMeterAppliedCommandFilterOptionsDocument, options);
        }
export type RampMeterAppliedCommandFilterOptionsQueryHookResult = ReturnType<typeof useRampMeterAppliedCommandFilterOptionsQuery>;
export type RampMeterAppliedCommandFilterOptionsLazyQueryHookResult = ReturnType<typeof useRampMeterAppliedCommandFilterOptionsLazyQuery>;
export type RampMeterAppliedCommandFilterOptionsQueryResult = Apollo.QueryResult<RampMeterAppliedCommandFilterOptionsQuery, RampMeterAppliedCommandFilterOptionsQueryVariables>;
export function refetchRampMeterAppliedCommandFilterOptionsQuery(variables?: RampMeterAppliedCommandFilterOptionsQueryVariables) {
      return { query: RampMeterAppliedCommandFilterOptionsDocument, variables: variables }
    }
export const SaveRampMeterDocument = gql`
    mutation SaveRampMeter($input: IntersectionInput!) {
  saveRampMeter(intersectionInput: $input) {
    ...IntersectionDetail
  }
}
    ${IntersectionDetailFragmentDoc}`;
export type SaveRampMeterMutationFn = Apollo.MutationFunction<SaveRampMeterMutation, SaveRampMeterMutationVariables>;

/**
 * __useSaveRampMeterMutation__
 *
 * To run a mutation, you first call `useSaveRampMeterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRampMeterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRampMeterMutation, { data, loading, error }] = useSaveRampMeterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveRampMeterMutation(baseOptions?: Apollo.MutationHookOptions<SaveRampMeterMutation, SaveRampMeterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRampMeterMutation, SaveRampMeterMutationVariables>(SaveRampMeterDocument, options);
      }
export type SaveRampMeterMutationHookResult = ReturnType<typeof useSaveRampMeterMutation>;
export type SaveRampMeterMutationResult = Apollo.MutationResult<SaveRampMeterMutation>;
export type SaveRampMeterMutationOptions = Apollo.BaseMutationOptions<SaveRampMeterMutation, SaveRampMeterMutationVariables>;
export const RampMeterControllerListDocument = gql`
    query RampMeterControllerList {
  rampMeterControllers(unassigned: true, limit: 100000) {
    edges {
      node {
        id
        name
        location
      }
    }
  }
}
    `;

/**
 * __useRampMeterControllerListQuery__
 *
 * To run a query within a React component, call `useRampMeterControllerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterControllerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterControllerListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterControllerListQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterControllerListQuery, RampMeterControllerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterControllerListQuery, RampMeterControllerListQueryVariables>(RampMeterControllerListDocument, options);
      }
export function useRampMeterControllerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterControllerListQuery, RampMeterControllerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterControllerListQuery, RampMeterControllerListQueryVariables>(RampMeterControllerListDocument, options);
        }
export type RampMeterControllerListQueryHookResult = ReturnType<typeof useRampMeterControllerListQuery>;
export type RampMeterControllerListLazyQueryHookResult = ReturnType<typeof useRampMeterControllerListLazyQuery>;
export type RampMeterControllerListQueryResult = Apollo.QueryResult<RampMeterControllerListQuery, RampMeterControllerListQueryVariables>;
export function refetchRampMeterControllerListQuery(variables?: RampMeterControllerListQueryVariables) {
      return { query: RampMeterControllerListDocument, variables: variables }
    }
export const GetRampMeterByIntegrationIdDocument = gql`
    query GetRampMeterByIntegrationId($integrationId: Object!) {
  rampMeters(
    filters: [{field: "devices.id", operator: EQUALS, value: $integrationId}]
  ) {
    edges {
      node {
        id
        details {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetRampMeterByIntegrationIdQuery__
 *
 * To run a query within a React component, call `useGetRampMeterByIntegrationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRampMeterByIntegrationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRampMeterByIntegrationIdQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetRampMeterByIntegrationIdQuery(baseOptions: Apollo.QueryHookOptions<GetRampMeterByIntegrationIdQuery, GetRampMeterByIntegrationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRampMeterByIntegrationIdQuery, GetRampMeterByIntegrationIdQueryVariables>(GetRampMeterByIntegrationIdDocument, options);
      }
export function useGetRampMeterByIntegrationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRampMeterByIntegrationIdQuery, GetRampMeterByIntegrationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRampMeterByIntegrationIdQuery, GetRampMeterByIntegrationIdQueryVariables>(GetRampMeterByIntegrationIdDocument, options);
        }
export type GetRampMeterByIntegrationIdQueryHookResult = ReturnType<typeof useGetRampMeterByIntegrationIdQuery>;
export type GetRampMeterByIntegrationIdLazyQueryHookResult = ReturnType<typeof useGetRampMeterByIntegrationIdLazyQuery>;
export type GetRampMeterByIntegrationIdQueryResult = Apollo.QueryResult<GetRampMeterByIntegrationIdQuery, GetRampMeterByIntegrationIdQueryVariables>;
export function refetchGetRampMeterByIntegrationIdQuery(variables: GetRampMeterByIntegrationIdQueryVariables) {
      return { query: GetRampMeterByIntegrationIdDocument, variables: variables }
    }
export const RampMeterDetailPageDocument = gql`
    query RampMeterDetailPage($id: ID!) {
  intersection(id: $id) {
    id
    location
    details {
      name
      note
      mainPhases
    }
    devices {
      id
      name
      type
    }
    centerInfo {
      centerId
    }
    icons {
      ...IntersectionIcon
    }
  }
}
    ${IntersectionIconFragmentDoc}`;

/**
 * __useRampMeterDetailPageQuery__
 *
 * To run a query within a React component, call `useRampMeterDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterDetailPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRampMeterDetailPageQuery(baseOptions: Apollo.QueryHookOptions<RampMeterDetailPageQuery, RampMeterDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterDetailPageQuery, RampMeterDetailPageQueryVariables>(RampMeterDetailPageDocument, options);
      }
export function useRampMeterDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterDetailPageQuery, RampMeterDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterDetailPageQuery, RampMeterDetailPageQueryVariables>(RampMeterDetailPageDocument, options);
        }
export type RampMeterDetailPageQueryHookResult = ReturnType<typeof useRampMeterDetailPageQuery>;
export type RampMeterDetailPageLazyQueryHookResult = ReturnType<typeof useRampMeterDetailPageLazyQuery>;
export type RampMeterDetailPageQueryResult = Apollo.QueryResult<RampMeterDetailPageQuery, RampMeterDetailPageQueryVariables>;
export function refetchRampMeterDetailPageQuery(variables: RampMeterDetailPageQueryVariables) {
      return { query: RampMeterDetailPageDocument, variables: variables }
    }
export const RampMeterListDocument = gql`
    query RampMeterList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  rampMeters(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    searchFields: ["details.name", "devices.fieldEntityProtocol"]
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        id
        details {
          name
          labels
        }
        devices {
          id
          connectionInfo
          fieldEntityProtocol
        }
        statusCategory
      }
      __typename
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useRampMeterListQuery__
 *
 * To run a query within a React component, call `useRampMeterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRampMeterListQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterListQuery, RampMeterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterListQuery, RampMeterListQueryVariables>(RampMeterListDocument, options);
      }
export function useRampMeterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterListQuery, RampMeterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterListQuery, RampMeterListQueryVariables>(RampMeterListDocument, options);
        }
export type RampMeterListQueryHookResult = ReturnType<typeof useRampMeterListQuery>;
export type RampMeterListLazyQueryHookResult = ReturnType<typeof useRampMeterListLazyQuery>;
export type RampMeterListQueryResult = Apollo.QueryResult<RampMeterListQuery, RampMeterListQueryVariables>;
export function refetchRampMeterListQuery(variables?: RampMeterListQueryVariables) {
      return { query: RampMeterListDocument, variables: variables }
    }
export const RampMeterSimpleStatusDocument = gql`
    query RampMeterSimpleStatus {
  intersectionSimpleStatus(intersectionType: RAMP_METER)
}
    `;

/**
 * __useRampMeterSimpleStatusQuery__
 *
 * To run a query within a React component, call `useRampMeterSimpleStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterSimpleStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterSimpleStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterSimpleStatusQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterSimpleStatusQuery, RampMeterSimpleStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterSimpleStatusQuery, RampMeterSimpleStatusQueryVariables>(RampMeterSimpleStatusDocument, options);
      }
export function useRampMeterSimpleStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterSimpleStatusQuery, RampMeterSimpleStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterSimpleStatusQuery, RampMeterSimpleStatusQueryVariables>(RampMeterSimpleStatusDocument, options);
        }
export type RampMeterSimpleStatusQueryHookResult = ReturnType<typeof useRampMeterSimpleStatusQuery>;
export type RampMeterSimpleStatusLazyQueryHookResult = ReturnType<typeof useRampMeterSimpleStatusLazyQuery>;
export type RampMeterSimpleStatusQueryResult = Apollo.QueryResult<RampMeterSimpleStatusQuery, RampMeterSimpleStatusQueryVariables>;
export function refetchRampMeterSimpleStatusQuery(variables?: RampMeterSimpleStatusQueryVariables) {
      return { query: RampMeterSimpleStatusDocument, variables: variables }
    }
export const RampMeterLocationDocument = gql`
    query RampMeterLocation {
  intersectionLocation(intersectionType: RAMP_METER)
}
    `;

/**
 * __useRampMeterLocationQuery__
 *
 * To run a query within a React component, call `useRampMeterLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterLocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterLocationQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterLocationQuery, RampMeterLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterLocationQuery, RampMeterLocationQueryVariables>(RampMeterLocationDocument, options);
      }
export function useRampMeterLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterLocationQuery, RampMeterLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterLocationQuery, RampMeterLocationQueryVariables>(RampMeterLocationDocument, options);
        }
export type RampMeterLocationQueryHookResult = ReturnType<typeof useRampMeterLocationQuery>;
export type RampMeterLocationLazyQueryHookResult = ReturnType<typeof useRampMeterLocationLazyQuery>;
export type RampMeterLocationQueryResult = Apollo.QueryResult<RampMeterLocationQuery, RampMeterLocationQueryVariables>;
export function refetchRampMeterLocationQuery(variables?: RampMeterLocationQueryVariables) {
      return { query: RampMeterLocationDocument, variables: variables }
    }
export const RampMeterAppliedCommandsDocument = gql`
    query RampMeterAppliedCommands($timezone: String!, $after: String, $before: String, $limit: Int, $sortField: String, $sortOrder: SortOrder, $searchText: String, $searchFields: [String!], $filters: [FilterInput]) {
  signalAppliedCommands(
    timezone: $timezone
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
    searchFields: $searchFields
    filters: $filters
    intersectionType: RAMP_METER
  ) {
    edges {
      cursor
      node {
        ...AppliedCommandFragment
      }
      __typename
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${AppliedCommandFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useRampMeterAppliedCommandsQuery__
 *
 * To run a query within a React component, call `useRampMeterAppliedCommandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterAppliedCommandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterAppliedCommandsQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRampMeterAppliedCommandsQuery(baseOptions: Apollo.QueryHookOptions<RampMeterAppliedCommandsQuery, RampMeterAppliedCommandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterAppliedCommandsQuery, RampMeterAppliedCommandsQueryVariables>(RampMeterAppliedCommandsDocument, options);
      }
export function useRampMeterAppliedCommandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterAppliedCommandsQuery, RampMeterAppliedCommandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterAppliedCommandsQuery, RampMeterAppliedCommandsQueryVariables>(RampMeterAppliedCommandsDocument, options);
        }
export type RampMeterAppliedCommandsQueryHookResult = ReturnType<typeof useRampMeterAppliedCommandsQuery>;
export type RampMeterAppliedCommandsLazyQueryHookResult = ReturnType<typeof useRampMeterAppliedCommandsLazyQuery>;
export type RampMeterAppliedCommandsQueryResult = Apollo.QueryResult<RampMeterAppliedCommandsQuery, RampMeterAppliedCommandsQueryVariables>;
export function refetchRampMeterAppliedCommandsQuery(variables: RampMeterAppliedCommandsQueryVariables) {
      return { query: RampMeterAppliedCommandsDocument, variables: variables }
    }
export const RampMeterSimpleAndDetailStatusDocument = gql`
    query RampMeterSimpleAndDetailStatus {
  intersectionSimpleStatus(intersectionType: RAMP_METER)
  intersectionDetailStatus(intersectionType: RAMP_METER)
}
    `;

/**
 * __useRampMeterSimpleAndDetailStatusQuery__
 *
 * To run a query within a React component, call `useRampMeterSimpleAndDetailStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterSimpleAndDetailStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterSimpleAndDetailStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterSimpleAndDetailStatusQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterSimpleAndDetailStatusQuery, RampMeterSimpleAndDetailStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterSimpleAndDetailStatusQuery, RampMeterSimpleAndDetailStatusQueryVariables>(RampMeterSimpleAndDetailStatusDocument, options);
      }
export function useRampMeterSimpleAndDetailStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterSimpleAndDetailStatusQuery, RampMeterSimpleAndDetailStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterSimpleAndDetailStatusQuery, RampMeterSimpleAndDetailStatusQueryVariables>(RampMeterSimpleAndDetailStatusDocument, options);
        }
export type RampMeterSimpleAndDetailStatusQueryHookResult = ReturnType<typeof useRampMeterSimpleAndDetailStatusQuery>;
export type RampMeterSimpleAndDetailStatusLazyQueryHookResult = ReturnType<typeof useRampMeterSimpleAndDetailStatusLazyQuery>;
export type RampMeterSimpleAndDetailStatusQueryResult = Apollo.QueryResult<RampMeterSimpleAndDetailStatusQuery, RampMeterSimpleAndDetailStatusQueryVariables>;
export function refetchRampMeterSimpleAndDetailStatusQuery(variables?: RampMeterSimpleAndDetailStatusQueryVariables) {
      return { query: RampMeterSimpleAndDetailStatusDocument, variables: variables }
    }
export const RampMeterAlarmStatusLayerDocument = gql`
    query RampMeterAlarmStatusLayer {
  intersectionSimpleStatus
  alarms(
    query: {limit: 100000, filters: [{field: "active", value: true, operator: EQUALS}, {field: "source", value: "RAMP_METER", operator: EQUALS}]}
  ) {
    edges {
      node {
        entityId
        id
      }
    }
  }
}
    `;

/**
 * __useRampMeterAlarmStatusLayerQuery__
 *
 * To run a query within a React component, call `useRampMeterAlarmStatusLayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterAlarmStatusLayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterAlarmStatusLayerQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterAlarmStatusLayerQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterAlarmStatusLayerQuery, RampMeterAlarmStatusLayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterAlarmStatusLayerQuery, RampMeterAlarmStatusLayerQueryVariables>(RampMeterAlarmStatusLayerDocument, options);
      }
export function useRampMeterAlarmStatusLayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterAlarmStatusLayerQuery, RampMeterAlarmStatusLayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterAlarmStatusLayerQuery, RampMeterAlarmStatusLayerQueryVariables>(RampMeterAlarmStatusLayerDocument, options);
        }
export type RampMeterAlarmStatusLayerQueryHookResult = ReturnType<typeof useRampMeterAlarmStatusLayerQuery>;
export type RampMeterAlarmStatusLayerLazyQueryHookResult = ReturnType<typeof useRampMeterAlarmStatusLayerLazyQuery>;
export type RampMeterAlarmStatusLayerQueryResult = Apollo.QueryResult<RampMeterAlarmStatusLayerQuery, RampMeterAlarmStatusLayerQueryVariables>;
export function refetchRampMeterAlarmStatusLayerQuery(variables?: RampMeterAlarmStatusLayerQueryVariables) {
      return { query: RampMeterAlarmStatusLayerDocument, variables: variables }
    }
export const PrimaryLaneStatusLayerUpdatedDocument = gql`
    subscription PrimaryLaneStatusLayerUpdated {
  intersectionSimpleStatusUpdated(intersectionType: RAMP_METER) {
    intersectionId
    mainlineColor
    communicationState
  }
}
    `;

/**
 * __usePrimaryLaneStatusLayerUpdatedSubscription__
 *
 * To run a query within a React component, call `usePrimaryLaneStatusLayerUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePrimaryLaneStatusLayerUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimaryLaneStatusLayerUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePrimaryLaneStatusLayerUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PrimaryLaneStatusLayerUpdatedSubscription, PrimaryLaneStatusLayerUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PrimaryLaneStatusLayerUpdatedSubscription, PrimaryLaneStatusLayerUpdatedSubscriptionVariables>(PrimaryLaneStatusLayerUpdatedDocument, options);
      }
export type PrimaryLaneStatusLayerUpdatedSubscriptionHookResult = ReturnType<typeof usePrimaryLaneStatusLayerUpdatedSubscription>;
export type PrimaryLaneStatusLayerUpdatedSubscriptionResult = Apollo.SubscriptionResult<PrimaryLaneStatusLayerUpdatedSubscription>;
export const ActionStatusLayerUpdatedDocument = gql`
    subscription ActionStatusLayerUpdated {
  intersectionSimpleStatusUpdated(intersectionType: RAMP_METER) {
    intersectionId
    mainActionColor
    communicationState
  }
}
    `;

/**
 * __useActionStatusLayerUpdatedSubscription__
 *
 * To run a query within a React component, call `useActionStatusLayerUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActionStatusLayerUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionStatusLayerUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useActionStatusLayerUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ActionStatusLayerUpdatedSubscription, ActionStatusLayerUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ActionStatusLayerUpdatedSubscription, ActionStatusLayerUpdatedSubscriptionVariables>(ActionStatusLayerUpdatedDocument, options);
      }
export type ActionStatusLayerUpdatedSubscriptionHookResult = ReturnType<typeof useActionStatusLayerUpdatedSubscription>;
export type ActionStatusLayerUpdatedSubscriptionResult = Apollo.SubscriptionResult<ActionStatusLayerUpdatedSubscription>;
export const CommandSourceStatusLayerUpdatedDocument = gql`
    subscription CommandSourceStatusLayerUpdated {
  intersectionSimpleStatusUpdated(intersectionType: RAMP_METER) {
    intersectionId
    mainCommandSourceColor
    communicationState
  }
}
    `;

/**
 * __useCommandSourceStatusLayerUpdatedSubscription__
 *
 * To run a query within a React component, call `useCommandSourceStatusLayerUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommandSourceStatusLayerUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommandSourceStatusLayerUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCommandSourceStatusLayerUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CommandSourceStatusLayerUpdatedSubscription, CommandSourceStatusLayerUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommandSourceStatusLayerUpdatedSubscription, CommandSourceStatusLayerUpdatedSubscriptionVariables>(CommandSourceStatusLayerUpdatedDocument, options);
      }
export type CommandSourceStatusLayerUpdatedSubscriptionHookResult = ReturnType<typeof useCommandSourceStatusLayerUpdatedSubscription>;
export type CommandSourceStatusLayerUpdatedSubscriptionResult = Apollo.SubscriptionResult<CommandSourceStatusLayerUpdatedSubscription>;
export const RampMeterCommunicationStateUpdatedDocument = gql`
    subscription RampMeterCommunicationStateUpdated {
  intersectionSimpleStatusUpdated(intersectionType: RAMP_METER) {
    intersectionId
    communicationState
  }
}
    `;

/**
 * __useRampMeterCommunicationStateUpdatedSubscription__
 *
 * To run a query within a React component, call `useRampMeterCommunicationStateUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterCommunicationStateUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterCommunicationStateUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterCommunicationStateUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RampMeterCommunicationStateUpdatedSubscription, RampMeterCommunicationStateUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RampMeterCommunicationStateUpdatedSubscription, RampMeterCommunicationStateUpdatedSubscriptionVariables>(RampMeterCommunicationStateUpdatedDocument, options);
      }
export type RampMeterCommunicationStateUpdatedSubscriptionHookResult = ReturnType<typeof useRampMeterCommunicationStateUpdatedSubscription>;
export type RampMeterCommunicationStateUpdatedSubscriptionResult = Apollo.SubscriptionResult<RampMeterCommunicationStateUpdatedSubscription>;
export const RampMeterTimeDriftUpdatedDocument = gql`
    subscription RampMeterTimeDriftUpdated {
  intersectionDetailStatusUpdated(intersectionType: RAMP_METER) {
    intersectionId
    time {
      drift
    }
  }
}
    `;

/**
 * __useRampMeterTimeDriftUpdatedSubscription__
 *
 * To run a query within a React component, call `useRampMeterTimeDriftUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterTimeDriftUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterTimeDriftUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterTimeDriftUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RampMeterTimeDriftUpdatedSubscription, RampMeterTimeDriftUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RampMeterTimeDriftUpdatedSubscription, RampMeterTimeDriftUpdatedSubscriptionVariables>(RampMeterTimeDriftUpdatedDocument, options);
      }
export type RampMeterTimeDriftUpdatedSubscriptionHookResult = ReturnType<typeof useRampMeterTimeDriftUpdatedSubscription>;
export type RampMeterTimeDriftUpdatedSubscriptionResult = Apollo.SubscriptionResult<RampMeterTimeDriftUpdatedSubscription>;
export const RampMeterAlarmStatusUpdatedDocument = gql`
    subscription RampMeterAlarmStatusUpdated($ids: [ID!]) {
  alarmUpdated(ids: $ids) {
    entityId
    id
    active
    source
  }
}
    `;

/**
 * __useRampMeterAlarmStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useRampMeterAlarmStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterAlarmStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterAlarmStatusUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRampMeterAlarmStatusUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RampMeterAlarmStatusUpdatedSubscription, RampMeterAlarmStatusUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RampMeterAlarmStatusUpdatedSubscription, RampMeterAlarmStatusUpdatedSubscriptionVariables>(RampMeterAlarmStatusUpdatedDocument, options);
      }
export type RampMeterAlarmStatusUpdatedSubscriptionHookResult = ReturnType<typeof useRampMeterAlarmStatusUpdatedSubscription>;
export type RampMeterAlarmStatusUpdatedSubscriptionResult = Apollo.SubscriptionResult<RampMeterAlarmStatusUpdatedSubscription>;
export const RampMeterIdsDocument = gql`
    query rampMeterIds($searchText: String, $filters: [FilterInput!]) {
  rampMeterIds(searchText: $searchText, filters: $filters)
}
    `;

/**
 * __useRampMeterIdsQuery__
 *
 * To run a query within a React component, call `useRampMeterIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterIdsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRampMeterIdsQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterIdsQuery, RampMeterIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterIdsQuery, RampMeterIdsQueryVariables>(RampMeterIdsDocument, options);
      }
export function useRampMeterIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterIdsQuery, RampMeterIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterIdsQuery, RampMeterIdsQueryVariables>(RampMeterIdsDocument, options);
        }
export type RampMeterIdsQueryHookResult = ReturnType<typeof useRampMeterIdsQuery>;
export type RampMeterIdsLazyQueryHookResult = ReturnType<typeof useRampMeterIdsLazyQuery>;
export type RampMeterIdsQueryResult = Apollo.QueryResult<RampMeterIdsQuery, RampMeterIdsQueryVariables>;
export function refetchRampMeterIdsQuery(variables?: RampMeterIdsQueryVariables) {
      return { query: RampMeterIdsDocument, variables: variables }
    }
export const NearbyRampMetersByPointDocument = gql`
    query nearbyRampMetersByPoint($x: Float!, $y: Float!, $thresholdMiles: Float) {
  nearbyIntersectionsByPoint(
    x: $x
    y: $y
    thresholdMiles: $thresholdMiles
    intersectionType: RAMP_METER
  ) {
    id
  }
}
    `;

/**
 * __useNearbyRampMetersByPointQuery__
 *
 * To run a query within a React component, call `useNearbyRampMetersByPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useNearbyRampMetersByPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNearbyRampMetersByPointQuery({
 *   variables: {
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      thresholdMiles: // value for 'thresholdMiles'
 *   },
 * });
 */
export function useNearbyRampMetersByPointQuery(baseOptions: Apollo.QueryHookOptions<NearbyRampMetersByPointQuery, NearbyRampMetersByPointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NearbyRampMetersByPointQuery, NearbyRampMetersByPointQueryVariables>(NearbyRampMetersByPointDocument, options);
      }
export function useNearbyRampMetersByPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NearbyRampMetersByPointQuery, NearbyRampMetersByPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NearbyRampMetersByPointQuery, NearbyRampMetersByPointQueryVariables>(NearbyRampMetersByPointDocument, options);
        }
export type NearbyRampMetersByPointQueryHookResult = ReturnType<typeof useNearbyRampMetersByPointQuery>;
export type NearbyRampMetersByPointLazyQueryHookResult = ReturnType<typeof useNearbyRampMetersByPointLazyQuery>;
export type NearbyRampMetersByPointQueryResult = Apollo.QueryResult<NearbyRampMetersByPointQuery, NearbyRampMetersByPointQueryVariables>;
export function refetchNearbyRampMetersByPointQuery(variables: NearbyRampMetersByPointQueryVariables) {
      return { query: NearbyRampMetersByPointDocument, variables: variables }
    }
export const RampMetersWithIconsDocument = gql`
    query RampMetersWithIcons($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  rampMeters(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        icons {
          ...IntersectionIcon
        }
        id
        lanes {
          id
          description
          location
          laneDirection
          travelDirection
          vehicleDetectors {
            description
            distance
            length
            icon {
              ...IntersectionIcon
            }
            location
            number
            showOnMap
            type
            width
          }
        }
        location
      }
    }
  }
}
    ${IntersectionIconFragmentDoc}`;

/**
 * __useRampMetersWithIconsQuery__
 *
 * To run a query within a React component, call `useRampMetersWithIconsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMetersWithIconsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMetersWithIconsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRampMetersWithIconsQuery(baseOptions?: Apollo.QueryHookOptions<RampMetersWithIconsQuery, RampMetersWithIconsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMetersWithIconsQuery, RampMetersWithIconsQueryVariables>(RampMetersWithIconsDocument, options);
      }
export function useRampMetersWithIconsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMetersWithIconsQuery, RampMetersWithIconsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMetersWithIconsQuery, RampMetersWithIconsQueryVariables>(RampMetersWithIconsDocument, options);
        }
export type RampMetersWithIconsQueryHookResult = ReturnType<typeof useRampMetersWithIconsQuery>;
export type RampMetersWithIconsLazyQueryHookResult = ReturnType<typeof useRampMetersWithIconsLazyQuery>;
export type RampMetersWithIconsQueryResult = Apollo.QueryResult<RampMetersWithIconsQuery, RampMetersWithIconsQueryVariables>;
export function refetchRampMetersWithIconsQuery(variables?: RampMetersWithIconsQueryVariables) {
      return { query: RampMetersWithIconsDocument, variables: variables }
    }
export const RampMeterStatusCategoriesDocument = gql`
    query rampMeterStatusCategories {
  rampMeterStatusCategories {
    ...RampMeterStatusCategories
  }
}
    ${RampMeterStatusCategoriesFragmentDoc}`;

/**
 * __useRampMeterStatusCategoriesQuery__
 *
 * To run a query within a React component, call `useRampMeterStatusCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterStatusCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterStatusCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterStatusCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterStatusCategoriesQuery, RampMeterStatusCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterStatusCategoriesQuery, RampMeterStatusCategoriesQueryVariables>(RampMeterStatusCategoriesDocument, options);
      }
export function useRampMeterStatusCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterStatusCategoriesQuery, RampMeterStatusCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterStatusCategoriesQuery, RampMeterStatusCategoriesQueryVariables>(RampMeterStatusCategoriesDocument, options);
        }
export type RampMeterStatusCategoriesQueryHookResult = ReturnType<typeof useRampMeterStatusCategoriesQuery>;
export type RampMeterStatusCategoriesLazyQueryHookResult = ReturnType<typeof useRampMeterStatusCategoriesLazyQuery>;
export type RampMeterStatusCategoriesQueryResult = Apollo.QueryResult<RampMeterStatusCategoriesQuery, RampMeterStatusCategoriesQueryVariables>;
export function refetchRampMeterStatusCategoriesQuery(variables?: RampMeterStatusCategoriesQueryVariables) {
      return { query: RampMeterStatusCategoriesDocument, variables: variables }
    }
export const RampMeterStatusCategoriesUpdatedDocument = gql`
    subscription rampMeterStatusCategoriesUpdated {
  rampMeterStatusCategoriesUpdated {
    ...RampMeterStatusCategories
  }
}
    ${RampMeterStatusCategoriesFragmentDoc}`;

/**
 * __useRampMeterStatusCategoriesUpdatedSubscription__
 *
 * To run a query within a React component, call `useRampMeterStatusCategoriesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterStatusCategoriesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterStatusCategoriesUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterStatusCategoriesUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RampMeterStatusCategoriesUpdatedSubscription, RampMeterStatusCategoriesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RampMeterStatusCategoriesUpdatedSubscription, RampMeterStatusCategoriesUpdatedSubscriptionVariables>(RampMeterStatusCategoriesUpdatedDocument, options);
      }
export type RampMeterStatusCategoriesUpdatedSubscriptionHookResult = ReturnType<typeof useRampMeterStatusCategoriesUpdatedSubscription>;
export type RampMeterStatusCategoriesUpdatedSubscriptionResult = Apollo.SubscriptionResult<RampMeterStatusCategoriesUpdatedSubscription>;
export const RampMeterMapSearchResultDocument = gql`
    query RampMeterMapSearchResult($searchText: String, $limit: Int = 10) {
  rampMeters(searchText: $searchText, limit: $limit) {
    edges {
      node {
        id
        location
        details {
          name
        }
        devices {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useRampMeterMapSearchResultQuery__
 *
 * To run a query within a React component, call `useRampMeterMapSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterMapSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterMapSearchResultQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRampMeterMapSearchResultQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterMapSearchResultQuery, RampMeterMapSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterMapSearchResultQuery, RampMeterMapSearchResultQueryVariables>(RampMeterMapSearchResultDocument, options);
      }
export function useRampMeterMapSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterMapSearchResultQuery, RampMeterMapSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterMapSearchResultQuery, RampMeterMapSearchResultQueryVariables>(RampMeterMapSearchResultDocument, options);
        }
export type RampMeterMapSearchResultQueryHookResult = ReturnType<typeof useRampMeterMapSearchResultQuery>;
export type RampMeterMapSearchResultLazyQueryHookResult = ReturnType<typeof useRampMeterMapSearchResultLazyQuery>;
export type RampMeterMapSearchResultQueryResult = Apollo.QueryResult<RampMeterMapSearchResultQuery, RampMeterMapSearchResultQueryVariables>;
export function refetchRampMeterMapSearchResultQuery(variables?: RampMeterMapSearchResultQueryVariables) {
      return { query: RampMeterMapSearchResultDocument, variables: variables }
    }
export const SaveRampMeterTaskDocument = gql`
    mutation SaveRampMeterTask($input: TaskInput!, $centerId: String) {
  saveSignalScheduledTask(
    input: $input
    centerId: $centerId
    intersectionType: RAMP_METER
  ) {
    ...SignalsTaskFragment
  }
}
    ${SignalsTaskFragmentFragmentDoc}`;
export type SaveRampMeterTaskMutationFn = Apollo.MutationFunction<SaveRampMeterTaskMutation, SaveRampMeterTaskMutationVariables>;

/**
 * __useSaveRampMeterTaskMutation__
 *
 * To run a mutation, you first call `useSaveRampMeterTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRampMeterTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRampMeterTaskMutation, { data, loading, error }] = useSaveRampMeterTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useSaveRampMeterTaskMutation(baseOptions?: Apollo.MutationHookOptions<SaveRampMeterTaskMutation, SaveRampMeterTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRampMeterTaskMutation, SaveRampMeterTaskMutationVariables>(SaveRampMeterTaskDocument, options);
      }
export type SaveRampMeterTaskMutationHookResult = ReturnType<typeof useSaveRampMeterTaskMutation>;
export type SaveRampMeterTaskMutationResult = Apollo.MutationResult<SaveRampMeterTaskMutation>;
export type SaveRampMeterTaskMutationOptions = Apollo.BaseMutationOptions<SaveRampMeterTaskMutation, SaveRampMeterTaskMutationVariables>;
export const GetAllRampMeterTasksDocument = gql`
    query GetAllRampMeterTasks($from: DateTime!, $to: DateTime!, $timezone: String!) {
  signalScheduledTasks(
    from: $from
    to: $to
    timezone: $timezone
    intersectionType: RAMP_METER
  ) {
    ...TaskOccurrenceFragment
  }
}
    ${TaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useGetAllRampMeterTasksQuery__
 *
 * To run a query within a React component, call `useGetAllRampMeterTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRampMeterTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRampMeterTasksQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetAllRampMeterTasksQuery(baseOptions: Apollo.QueryHookOptions<GetAllRampMeterTasksQuery, GetAllRampMeterTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRampMeterTasksQuery, GetAllRampMeterTasksQueryVariables>(GetAllRampMeterTasksDocument, options);
      }
export function useGetAllRampMeterTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRampMeterTasksQuery, GetAllRampMeterTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRampMeterTasksQuery, GetAllRampMeterTasksQueryVariables>(GetAllRampMeterTasksDocument, options);
        }
export type GetAllRampMeterTasksQueryHookResult = ReturnType<typeof useGetAllRampMeterTasksQuery>;
export type GetAllRampMeterTasksLazyQueryHookResult = ReturnType<typeof useGetAllRampMeterTasksLazyQuery>;
export type GetAllRampMeterTasksQueryResult = Apollo.QueryResult<GetAllRampMeterTasksQuery, GetAllRampMeterTasksQueryVariables>;
export function refetchGetAllRampMeterTasksQuery(variables: GetAllRampMeterTasksQueryVariables) {
      return { query: GetAllRampMeterTasksDocument, variables: variables }
    }
export const GetRampMeterTasksByRampMeterIdDocument = gql`
    query GetRampMeterTasksByRampMeterId($intersectionId: ID!, $from: DateTime!, $to: DateTime!, $timezone: String!) {
  signalScheduledTasksByIntersection(
    intersectionId: $intersectionId
    from: $from
    to: $to
    timezone: $timezone
    intersectionType: RAMP_METER
  ) {
    ...TaskOccurrenceFragment
  }
}
    ${TaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useGetRampMeterTasksByRampMeterIdQuery__
 *
 * To run a query within a React component, call `useGetRampMeterTasksByRampMeterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRampMeterTasksByRampMeterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRampMeterTasksByRampMeterIdQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetRampMeterTasksByRampMeterIdQuery(baseOptions: Apollo.QueryHookOptions<GetRampMeterTasksByRampMeterIdQuery, GetRampMeterTasksByRampMeterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRampMeterTasksByRampMeterIdQuery, GetRampMeterTasksByRampMeterIdQueryVariables>(GetRampMeterTasksByRampMeterIdDocument, options);
      }
export function useGetRampMeterTasksByRampMeterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRampMeterTasksByRampMeterIdQuery, GetRampMeterTasksByRampMeterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRampMeterTasksByRampMeterIdQuery, GetRampMeterTasksByRampMeterIdQueryVariables>(GetRampMeterTasksByRampMeterIdDocument, options);
        }
export type GetRampMeterTasksByRampMeterIdQueryHookResult = ReturnType<typeof useGetRampMeterTasksByRampMeterIdQuery>;
export type GetRampMeterTasksByRampMeterIdLazyQueryHookResult = ReturnType<typeof useGetRampMeterTasksByRampMeterIdLazyQuery>;
export type GetRampMeterTasksByRampMeterIdQueryResult = Apollo.QueryResult<GetRampMeterTasksByRampMeterIdQuery, GetRampMeterTasksByRampMeterIdQueryVariables>;
export function refetchGetRampMeterTasksByRampMeterIdQuery(variables: GetRampMeterTasksByRampMeterIdQueryVariables) {
      return { query: GetRampMeterTasksByRampMeterIdDocument, variables: variables }
    }
export const RampMeterDetailStatusesDocument = gql`
    query RampMeterDetailStatuses {
  intersectionDetailStatus(intersectionType: RAMP_METER)
}
    `;

/**
 * __useRampMeterDetailStatusesQuery__
 *
 * To run a query within a React component, call `useRampMeterDetailStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterDetailStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterDetailStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterDetailStatusesQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterDetailStatusesQuery, RampMeterDetailStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterDetailStatusesQuery, RampMeterDetailStatusesQueryVariables>(RampMeterDetailStatusesDocument, options);
      }
export function useRampMeterDetailStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterDetailStatusesQuery, RampMeterDetailStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterDetailStatusesQuery, RampMeterDetailStatusesQueryVariables>(RampMeterDetailStatusesDocument, options);
        }
export type RampMeterDetailStatusesQueryHookResult = ReturnType<typeof useRampMeterDetailStatusesQuery>;
export type RampMeterDetailStatusesLazyQueryHookResult = ReturnType<typeof useRampMeterDetailStatusesLazyQuery>;
export type RampMeterDetailStatusesQueryResult = Apollo.QueryResult<RampMeterDetailStatusesQuery, RampMeterDetailStatusesQueryVariables>;
export function refetchRampMeterDetailStatusesQuery(variables?: RampMeterDetailStatusesQueryVariables) {
      return { query: RampMeterDetailStatusesDocument, variables: variables }
    }
export const RampMeterPatternStatusDocument = gql`
    query RampMeterPatternStatus {
  intersectionPatternStatus(intersectionType: RAMP_METER)
}
    `;

/**
 * __useRampMeterPatternStatusQuery__
 *
 * To run a query within a React component, call `useRampMeterPatternStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterPatternStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterPatternStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampMeterPatternStatusQuery(baseOptions?: Apollo.QueryHookOptions<RampMeterPatternStatusQuery, RampMeterPatternStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RampMeterPatternStatusQuery, RampMeterPatternStatusQueryVariables>(RampMeterPatternStatusDocument, options);
      }
export function useRampMeterPatternStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RampMeterPatternStatusQuery, RampMeterPatternStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RampMeterPatternStatusQuery, RampMeterPatternStatusQueryVariables>(RampMeterPatternStatusDocument, options);
        }
export type RampMeterPatternStatusQueryHookResult = ReturnType<typeof useRampMeterPatternStatusQuery>;
export type RampMeterPatternStatusLazyQueryHookResult = ReturnType<typeof useRampMeterPatternStatusLazyQuery>;
export type RampMeterPatternStatusQueryResult = Apollo.QueryResult<RampMeterPatternStatusQuery, RampMeterPatternStatusQueryVariables>;
export function refetchRampMeterPatternStatusQuery(variables?: RampMeterPatternStatusQueryVariables) {
      return { query: RampMeterPatternStatusDocument, variables: variables }
    }
export const RampMeterSimpleStatusUpdatedDocument = gql`
    subscription RampMeterSimpleStatusUpdated($ids: [ID!]) {
  intersectionSimpleStatusUpdated(intersectionType: RAMP_METER, ids: $ids) {
    intersectionId
    communicationState
    mainImplementAction
    mainImplementCommandSource
  }
}
    `;

/**
 * __useRampMeterSimpleStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useRampMeterSimpleStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRampMeterSimpleStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampMeterSimpleStatusUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRampMeterSimpleStatusUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RampMeterSimpleStatusUpdatedSubscription, RampMeterSimpleStatusUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RampMeterSimpleStatusUpdatedSubscription, RampMeterSimpleStatusUpdatedSubscriptionVariables>(RampMeterSimpleStatusUpdatedDocument, options);
      }
export type RampMeterSimpleStatusUpdatedSubscriptionHookResult = ReturnType<typeof useRampMeterSimpleStatusUpdatedSubscription>;
export type RampMeterSimpleStatusUpdatedSubscriptionResult = Apollo.SubscriptionResult<RampMeterSimpleStatusUpdatedSubscription>;
export const UserRampMeterPrivilegesDocument = gql`
    query UserRampMeterPrivileges {
  userRampMeterPrivileges {
    privilegeType
    restrictions
    lastUpdated
  }
}
    `;

/**
 * __useUserRampMeterPrivilegesQuery__
 *
 * To run a query within a React component, call `useUserRampMeterPrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRampMeterPrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRampMeterPrivilegesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRampMeterPrivilegesQuery(baseOptions?: Apollo.QueryHookOptions<UserRampMeterPrivilegesQuery, UserRampMeterPrivilegesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRampMeterPrivilegesQuery, UserRampMeterPrivilegesQueryVariables>(UserRampMeterPrivilegesDocument, options);
      }
export function useUserRampMeterPrivilegesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRampMeterPrivilegesQuery, UserRampMeterPrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRampMeterPrivilegesQuery, UserRampMeterPrivilegesQueryVariables>(UserRampMeterPrivilegesDocument, options);
        }
export type UserRampMeterPrivilegesQueryHookResult = ReturnType<typeof useUserRampMeterPrivilegesQuery>;
export type UserRampMeterPrivilegesLazyQueryHookResult = ReturnType<typeof useUserRampMeterPrivilegesLazyQuery>;
export type UserRampMeterPrivilegesQueryResult = Apollo.QueryResult<UserRampMeterPrivilegesQuery, UserRampMeterPrivilegesQueryVariables>;
export function refetchUserRampMeterPrivilegesQuery(variables?: UserRampMeterPrivilegesQueryVariables) {
      return { query: UserRampMeterPrivilegesDocument, variables: variables }
    }
export const SaveReportBuilderDocument = gql`
    mutation SaveReportBuilder($input: ReportBuilderInput!) {
  reportBuilderSave(input: $input) {
    id
  }
}
    `;
export type SaveReportBuilderMutationFn = Apollo.MutationFunction<SaveReportBuilderMutation, SaveReportBuilderMutationVariables>;

/**
 * __useSaveReportBuilderMutation__
 *
 * To run a mutation, you first call `useSaveReportBuilderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReportBuilderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReportBuilderMutation, { data, loading, error }] = useSaveReportBuilderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveReportBuilderMutation(baseOptions?: Apollo.MutationHookOptions<SaveReportBuilderMutation, SaveReportBuilderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReportBuilderMutation, SaveReportBuilderMutationVariables>(SaveReportBuilderDocument, options);
      }
export type SaveReportBuilderMutationHookResult = ReturnType<typeof useSaveReportBuilderMutation>;
export type SaveReportBuilderMutationResult = Apollo.MutationResult<SaveReportBuilderMutation>;
export type SaveReportBuilderMutationOptions = Apollo.BaseMutationOptions<SaveReportBuilderMutation, SaveReportBuilderMutationVariables>;
export const CancelReportBuilderTaskDocument = gql`
    mutation CancelReportBuilderTask($id: ID!, $date: DateTime!) {
  reportBuilderTaskCancel(id: $id, date: $date)
}
    `;
export type CancelReportBuilderTaskMutationFn = Apollo.MutationFunction<CancelReportBuilderTaskMutation, CancelReportBuilderTaskMutationVariables>;

/**
 * __useCancelReportBuilderTaskMutation__
 *
 * To run a mutation, you first call `useCancelReportBuilderTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReportBuilderTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReportBuilderTaskMutation, { data, loading, error }] = useCancelReportBuilderTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCancelReportBuilderTaskMutation(baseOptions?: Apollo.MutationHookOptions<CancelReportBuilderTaskMutation, CancelReportBuilderTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReportBuilderTaskMutation, CancelReportBuilderTaskMutationVariables>(CancelReportBuilderTaskDocument, options);
      }
export type CancelReportBuilderTaskMutationHookResult = ReturnType<typeof useCancelReportBuilderTaskMutation>;
export type CancelReportBuilderTaskMutationResult = Apollo.MutationResult<CancelReportBuilderTaskMutation>;
export type CancelReportBuilderTaskMutationOptions = Apollo.BaseMutationOptions<CancelReportBuilderTaskMutation, CancelReportBuilderTaskMutationVariables>;
export const SaveReportBuilderTaskDocument = gql`
    mutation SaveReportBuilderTask($input: TaskInput!) {
  reportBuilderTaskSave(input: $input) {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;
export type SaveReportBuilderTaskMutationFn = Apollo.MutationFunction<SaveReportBuilderTaskMutation, SaveReportBuilderTaskMutationVariables>;

/**
 * __useSaveReportBuilderTaskMutation__
 *
 * To run a mutation, you first call `useSaveReportBuilderTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReportBuilderTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReportBuilderTaskMutation, { data, loading, error }] = useSaveReportBuilderTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveReportBuilderTaskMutation(baseOptions?: Apollo.MutationHookOptions<SaveReportBuilderTaskMutation, SaveReportBuilderTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReportBuilderTaskMutation, SaveReportBuilderTaskMutationVariables>(SaveReportBuilderTaskDocument, options);
      }
export type SaveReportBuilderTaskMutationHookResult = ReturnType<typeof useSaveReportBuilderTaskMutation>;
export type SaveReportBuilderTaskMutationResult = Apollo.MutationResult<SaveReportBuilderTaskMutation>;
export type SaveReportBuilderTaskMutationOptions = Apollo.BaseMutationOptions<SaveReportBuilderTaskMutation, SaveReportBuilderTaskMutationVariables>;
export const DeleteReportBuilderTaskDocument = gql`
    mutation DeleteReportBuilderTask($id: ID!) {
  reportBuilderTaskDelete(id: $id)
}
    `;
export type DeleteReportBuilderTaskMutationFn = Apollo.MutationFunction<DeleteReportBuilderTaskMutation, DeleteReportBuilderTaskMutationVariables>;

/**
 * __useDeleteReportBuilderTaskMutation__
 *
 * To run a mutation, you first call `useDeleteReportBuilderTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportBuilderTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportBuilderTaskMutation, { data, loading, error }] = useDeleteReportBuilderTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportBuilderTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportBuilderTaskMutation, DeleteReportBuilderTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportBuilderTaskMutation, DeleteReportBuilderTaskMutationVariables>(DeleteReportBuilderTaskDocument, options);
      }
export type DeleteReportBuilderTaskMutationHookResult = ReturnType<typeof useDeleteReportBuilderTaskMutation>;
export type DeleteReportBuilderTaskMutationResult = Apollo.MutationResult<DeleteReportBuilderTaskMutation>;
export type DeleteReportBuilderTaskMutationOptions = Apollo.BaseMutationOptions<DeleteReportBuilderTaskMutation, DeleteReportBuilderTaskMutationVariables>;
export const SaveReportBuilderBlockDocument = gql`
    mutation SaveReportBuilderBlock($input: ReportBuilderBlockInput!) {
  reportBuilderBlockSave(input: $input) {
    id
  }
}
    `;
export type SaveReportBuilderBlockMutationFn = Apollo.MutationFunction<SaveReportBuilderBlockMutation, SaveReportBuilderBlockMutationVariables>;

/**
 * __useSaveReportBuilderBlockMutation__
 *
 * To run a mutation, you first call `useSaveReportBuilderBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReportBuilderBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReportBuilderBlockMutation, { data, loading, error }] = useSaveReportBuilderBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveReportBuilderBlockMutation(baseOptions?: Apollo.MutationHookOptions<SaveReportBuilderBlockMutation, SaveReportBuilderBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReportBuilderBlockMutation, SaveReportBuilderBlockMutationVariables>(SaveReportBuilderBlockDocument, options);
      }
export type SaveReportBuilderBlockMutationHookResult = ReturnType<typeof useSaveReportBuilderBlockMutation>;
export type SaveReportBuilderBlockMutationResult = Apollo.MutationResult<SaveReportBuilderBlockMutation>;
export type SaveReportBuilderBlockMutationOptions = Apollo.BaseMutationOptions<SaveReportBuilderBlockMutation, SaveReportBuilderBlockMutationVariables>;
export const DeleteReportBuilderDocument = gql`
    mutation DeleteReportBuilder($id: ID!) {
  reportBuilderDelete(id: $id)
}
    `;
export type DeleteReportBuilderMutationFn = Apollo.MutationFunction<DeleteReportBuilderMutation, DeleteReportBuilderMutationVariables>;

/**
 * __useDeleteReportBuilderMutation__
 *
 * To run a mutation, you first call `useDeleteReportBuilderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportBuilderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportBuilderMutation, { data, loading, error }] = useDeleteReportBuilderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportBuilderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportBuilderMutation, DeleteReportBuilderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportBuilderMutation, DeleteReportBuilderMutationVariables>(DeleteReportBuilderDocument, options);
      }
export type DeleteReportBuilderMutationHookResult = ReturnType<typeof useDeleteReportBuilderMutation>;
export type DeleteReportBuilderMutationResult = Apollo.MutationResult<DeleteReportBuilderMutation>;
export type DeleteReportBuilderMutationOptions = Apollo.BaseMutationOptions<DeleteReportBuilderMutation, DeleteReportBuilderMutationVariables>;
export const DeleteReportBuilderBlockDocument = gql`
    mutation DeleteReportBuilderBlock($id: ID!) {
  reportBuilderBlockDelete(id: $id)
}
    `;
export type DeleteReportBuilderBlockMutationFn = Apollo.MutationFunction<DeleteReportBuilderBlockMutation, DeleteReportBuilderBlockMutationVariables>;

/**
 * __useDeleteReportBuilderBlockMutation__
 *
 * To run a mutation, you first call `useDeleteReportBuilderBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportBuilderBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportBuilderBlockMutation, { data, loading, error }] = useDeleteReportBuilderBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportBuilderBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportBuilderBlockMutation, DeleteReportBuilderBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportBuilderBlockMutation, DeleteReportBuilderBlockMutationVariables>(DeleteReportBuilderBlockDocument, options);
      }
export type DeleteReportBuilderBlockMutationHookResult = ReturnType<typeof useDeleteReportBuilderBlockMutation>;
export type DeleteReportBuilderBlockMutationResult = Apollo.MutationResult<DeleteReportBuilderBlockMutation>;
export type DeleteReportBuilderBlockMutationOptions = Apollo.BaseMutationOptions<DeleteReportBuilderBlockMutation, DeleteReportBuilderBlockMutationVariables>;
export const ReportBuilderBlockPreviewDocument = gql`
    mutation ReportBuilderBlockPreview($input: ReportBuilderBlockInput!, $params: Object) {
  reportBuilderBlockPreview(input: $input, params: $params)
}
    `;
export type ReportBuilderBlockPreviewMutationFn = Apollo.MutationFunction<ReportBuilderBlockPreviewMutation, ReportBuilderBlockPreviewMutationVariables>;

/**
 * __useReportBuilderBlockPreviewMutation__
 *
 * To run a mutation, you first call `useReportBuilderBlockPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportBuilderBlockPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportBuilderBlockPreviewMutation, { data, loading, error }] = useReportBuilderBlockPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useReportBuilderBlockPreviewMutation(baseOptions?: Apollo.MutationHookOptions<ReportBuilderBlockPreviewMutation, ReportBuilderBlockPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportBuilderBlockPreviewMutation, ReportBuilderBlockPreviewMutationVariables>(ReportBuilderBlockPreviewDocument, options);
      }
export type ReportBuilderBlockPreviewMutationHookResult = ReturnType<typeof useReportBuilderBlockPreviewMutation>;
export type ReportBuilderBlockPreviewMutationResult = Apollo.MutationResult<ReportBuilderBlockPreviewMutation>;
export type ReportBuilderBlockPreviewMutationOptions = Apollo.BaseMutationOptions<ReportBuilderBlockPreviewMutation, ReportBuilderBlockPreviewMutationVariables>;
export const ReportBuilderListDocument = gql`
    query ReportBuilderList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  reportBuilders(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        description
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useReportBuilderListQuery__
 *
 * To run a query within a React component, call `useReportBuilderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportBuilderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportBuilderListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportBuilderListQuery(baseOptions?: Apollo.QueryHookOptions<ReportBuilderListQuery, ReportBuilderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportBuilderListQuery, ReportBuilderListQueryVariables>(ReportBuilderListDocument, options);
      }
export function useReportBuilderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportBuilderListQuery, ReportBuilderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportBuilderListQuery, ReportBuilderListQueryVariables>(ReportBuilderListDocument, options);
        }
export type ReportBuilderListQueryHookResult = ReturnType<typeof useReportBuilderListQuery>;
export type ReportBuilderListLazyQueryHookResult = ReturnType<typeof useReportBuilderListLazyQuery>;
export type ReportBuilderListQueryResult = Apollo.QueryResult<ReportBuilderListQuery, ReportBuilderListQueryVariables>;
export function refetchReportBuilderListQuery(variables?: ReportBuilderListQueryVariables) {
      return { query: ReportBuilderListDocument, variables: variables }
    }
export const LiveReportBuilderListDocument = gql`
    subscription LiveReportBuilderList($ids: [ID!]!) {
  reportBuilderUpdated(ids: $ids) {
    description
    name
    id
  }
}
    `;

/**
 * __useLiveReportBuilderListSubscription__
 *
 * To run a query within a React component, call `useLiveReportBuilderListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveReportBuilderListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveReportBuilderListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveReportBuilderListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveReportBuilderListSubscription, LiveReportBuilderListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveReportBuilderListSubscription, LiveReportBuilderListSubscriptionVariables>(LiveReportBuilderListDocument, options);
      }
export type LiveReportBuilderListSubscriptionHookResult = ReturnType<typeof useLiveReportBuilderListSubscription>;
export type LiveReportBuilderListSubscriptionResult = Apollo.SubscriptionResult<LiveReportBuilderListSubscription>;
export const AllScheduledReportTasksDocument = gql`
    query AllScheduledReportTasks($filters: [FilterInput], $searchText: String, $timezone: String!, $from: DateTime!, $to: DateTime!) {
  allScheduledReportBuilderTasks(
    timezone: $timezone
    from: $from
    to: $to
    query: {searchText: $searchText, filters: $filters}
  ) {
    date
    tasks {
      ...TaskOccurrenceFragment
    }
  }
}
    ${TaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useAllScheduledReportTasksQuery__
 *
 * To run a query within a React component, call `useAllScheduledReportTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllScheduledReportTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllScheduledReportTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      timezone: // value for 'timezone'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAllScheduledReportTasksQuery(baseOptions: Apollo.QueryHookOptions<AllScheduledReportTasksQuery, AllScheduledReportTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllScheduledReportTasksQuery, AllScheduledReportTasksQueryVariables>(AllScheduledReportTasksDocument, options);
      }
export function useAllScheduledReportTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllScheduledReportTasksQuery, AllScheduledReportTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllScheduledReportTasksQuery, AllScheduledReportTasksQueryVariables>(AllScheduledReportTasksDocument, options);
        }
export type AllScheduledReportTasksQueryHookResult = ReturnType<typeof useAllScheduledReportTasksQuery>;
export type AllScheduledReportTasksLazyQueryHookResult = ReturnType<typeof useAllScheduledReportTasksLazyQuery>;
export type AllScheduledReportTasksQueryResult = Apollo.QueryResult<AllScheduledReportTasksQuery, AllScheduledReportTasksQueryVariables>;
export function refetchAllScheduledReportTasksQuery(variables: AllScheduledReportTasksQueryVariables) {
      return { query: AllScheduledReportTasksDocument, variables: variables }
    }
export const ScheduledReportTasksDocument = gql`
    query ScheduledReportTasks($id: ID!, $from: DateTime!, $to: DateTime!, $timezone: String!) {
  reportBuilderTasks(id: $id, from: $from, to: $to, timezone: $timezone) {
    date
    tasks {
      ...TaskOccurrenceFragment
    }
  }
}
    ${TaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useScheduledReportTasksQuery__
 *
 * To run a query within a React component, call `useScheduledReportTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledReportTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledReportTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useScheduledReportTasksQuery(baseOptions: Apollo.QueryHookOptions<ScheduledReportTasksQuery, ScheduledReportTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledReportTasksQuery, ScheduledReportTasksQueryVariables>(ScheduledReportTasksDocument, options);
      }
export function useScheduledReportTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledReportTasksQuery, ScheduledReportTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledReportTasksQuery, ScheduledReportTasksQueryVariables>(ScheduledReportTasksDocument, options);
        }
export type ScheduledReportTasksQueryHookResult = ReturnType<typeof useScheduledReportTasksQuery>;
export type ScheduledReportTasksLazyQueryHookResult = ReturnType<typeof useScheduledReportTasksLazyQuery>;
export type ScheduledReportTasksQueryResult = Apollo.QueryResult<ScheduledReportTasksQuery, ScheduledReportTasksQueryVariables>;
export function refetchScheduledReportTasksQuery(variables: ScheduledReportTasksQueryVariables) {
      return { query: ScheduledReportTasksDocument, variables: variables }
    }
export const ScheduledReportTaskUpdatedDocument = gql`
    subscription ScheduledReportTaskUpdated($ids: [ID!], $creation: Boolean, $deletion: Boolean) {
  reportBuilderTaskUpdated(ids: $ids, creation: $creation, deletion: $deletion) {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;

/**
 * __useScheduledReportTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useScheduledReportTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useScheduledReportTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledReportTaskUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      creation: // value for 'creation'
 *      deletion: // value for 'deletion'
 *   },
 * });
 */
export function useScheduledReportTaskUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ScheduledReportTaskUpdatedSubscription, ScheduledReportTaskUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ScheduledReportTaskUpdatedSubscription, ScheduledReportTaskUpdatedSubscriptionVariables>(ScheduledReportTaskUpdatedDocument, options);
      }
export type ScheduledReportTaskUpdatedSubscriptionHookResult = ReturnType<typeof useScheduledReportTaskUpdatedSubscription>;
export type ScheduledReportTaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<ScheduledReportTaskUpdatedSubscription>;
export const AllReportBuilderTasksDocument = gql`
    query AllReportBuilderTasks($id: ID!) {
  allReportBuilderTasks(id: $id) {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;

/**
 * __useAllReportBuilderTasksQuery__
 *
 * To run a query within a React component, call `useAllReportBuilderTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReportBuilderTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReportBuilderTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllReportBuilderTasksQuery(baseOptions: Apollo.QueryHookOptions<AllReportBuilderTasksQuery, AllReportBuilderTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReportBuilderTasksQuery, AllReportBuilderTasksQueryVariables>(AllReportBuilderTasksDocument, options);
      }
export function useAllReportBuilderTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReportBuilderTasksQuery, AllReportBuilderTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReportBuilderTasksQuery, AllReportBuilderTasksQueryVariables>(AllReportBuilderTasksDocument, options);
        }
export type AllReportBuilderTasksQueryHookResult = ReturnType<typeof useAllReportBuilderTasksQuery>;
export type AllReportBuilderTasksLazyQueryHookResult = ReturnType<typeof useAllReportBuilderTasksLazyQuery>;
export type AllReportBuilderTasksQueryResult = Apollo.QueryResult<AllReportBuilderTasksQuery, AllReportBuilderTasksQueryVariables>;
export function refetchAllReportBuilderTasksQuery(variables: AllReportBuilderTasksQueryVariables) {
      return { query: AllReportBuilderTasksDocument, variables: variables }
    }
export const ReportBuilderDocument = gql`
    query ReportBuilder($id: ID!) {
  reportBuilder(id: $id) {
    description
    sections {
      blocks {
        blockId
        id
      }
      type
      name
      id
    }
    name
    id
  }
}
    `;

/**
 * __useReportBuilderQuery__
 *
 * To run a query within a React component, call `useReportBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportBuilderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportBuilderQuery(baseOptions: Apollo.QueryHookOptions<ReportBuilderQuery, ReportBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportBuilderQuery, ReportBuilderQueryVariables>(ReportBuilderDocument, options);
      }
export function useReportBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportBuilderQuery, ReportBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportBuilderQuery, ReportBuilderQueryVariables>(ReportBuilderDocument, options);
        }
export type ReportBuilderQueryHookResult = ReturnType<typeof useReportBuilderQuery>;
export type ReportBuilderLazyQueryHookResult = ReturnType<typeof useReportBuilderLazyQuery>;
export type ReportBuilderQueryResult = Apollo.QueryResult<ReportBuilderQuery, ReportBuilderQueryVariables>;
export function refetchReportBuilderQuery(variables: ReportBuilderQueryVariables) {
      return { query: ReportBuilderDocument, variables: variables }
    }
export const ReportBuilderBlockListDocument = gql`
    query ReportBuilderBlockList($sortOrder: SortOrder = DESCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  reportBuilderBlocks(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        parameters {
          type
        }
        source
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useReportBuilderBlockListQuery__
 *
 * To run a query within a React component, call `useReportBuilderBlockListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportBuilderBlockListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportBuilderBlockListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportBuilderBlockListQuery(baseOptions?: Apollo.QueryHookOptions<ReportBuilderBlockListQuery, ReportBuilderBlockListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportBuilderBlockListQuery, ReportBuilderBlockListQueryVariables>(ReportBuilderBlockListDocument, options);
      }
export function useReportBuilderBlockListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportBuilderBlockListQuery, ReportBuilderBlockListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportBuilderBlockListQuery, ReportBuilderBlockListQueryVariables>(ReportBuilderBlockListDocument, options);
        }
export type ReportBuilderBlockListQueryHookResult = ReturnType<typeof useReportBuilderBlockListQuery>;
export type ReportBuilderBlockListLazyQueryHookResult = ReturnType<typeof useReportBuilderBlockListLazyQuery>;
export type ReportBuilderBlockListQueryResult = Apollo.QueryResult<ReportBuilderBlockListQuery, ReportBuilderBlockListQueryVariables>;
export function refetchReportBuilderBlockListQuery(variables?: ReportBuilderBlockListQueryVariables) {
      return { query: ReportBuilderBlockListDocument, variables: variables }
    }
export const LiveReportBuilderBlockListDocument = gql`
    subscription LiveReportBuilderBlockList($ids: [ID!]!) {
  reportBuilderBlockUpdated(ids: $ids) {
    parameters {
      type
    }
    source
    name
    id
  }
}
    `;

/**
 * __useLiveReportBuilderBlockListSubscription__
 *
 * To run a query within a React component, call `useLiveReportBuilderBlockListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveReportBuilderBlockListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveReportBuilderBlockListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveReportBuilderBlockListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveReportBuilderBlockListSubscription, LiveReportBuilderBlockListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveReportBuilderBlockListSubscription, LiveReportBuilderBlockListSubscriptionVariables>(LiveReportBuilderBlockListDocument, options);
      }
export type LiveReportBuilderBlockListSubscriptionHookResult = ReturnType<typeof useLiveReportBuilderBlockListSubscription>;
export type LiveReportBuilderBlockListSubscriptionResult = Apollo.SubscriptionResult<LiveReportBuilderBlockListSubscription>;
export const ReportBuilderBlockDocument = gql`
    query ReportBuilderBlock($id: ID!) {
  reportBuilderBlock(id: $id) {
    parameters {
      table {
        header {
          cells {
            attribute
            label
            type
          }
        }
        data {
          cells {
            attribute
            label
            type
          }
        }
        rows {
          cells {
            attribute
            label
            type
          }
        }
      }
      aggregations {
        field
        type
      }
      filters {
        operator
        field
        value
      }
      date {
        modifier
        range
        start
        type
        end
      }
      groupBy
      type
    }
    source
    name
    id
  }
}
    `;

/**
 * __useReportBuilderBlockQuery__
 *
 * To run a query within a React component, call `useReportBuilderBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportBuilderBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportBuilderBlockQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportBuilderBlockQuery(baseOptions: Apollo.QueryHookOptions<ReportBuilderBlockQuery, ReportBuilderBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportBuilderBlockQuery, ReportBuilderBlockQueryVariables>(ReportBuilderBlockDocument, options);
      }
export function useReportBuilderBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportBuilderBlockQuery, ReportBuilderBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportBuilderBlockQuery, ReportBuilderBlockQueryVariables>(ReportBuilderBlockDocument, options);
        }
export type ReportBuilderBlockQueryHookResult = ReturnType<typeof useReportBuilderBlockQuery>;
export type ReportBuilderBlockLazyQueryHookResult = ReturnType<typeof useReportBuilderBlockLazyQuery>;
export type ReportBuilderBlockQueryResult = Apollo.QueryResult<ReportBuilderBlockQuery, ReportBuilderBlockQueryVariables>;
export function refetchReportBuilderBlockQuery(variables: ReportBuilderBlockQueryVariables) {
      return { query: ReportBuilderBlockDocument, variables: variables }
    }
export const KineticEventFormTemplateFieldsDocument = gql`
    query KineticEventFormTemplateFields {
  kineticEventFormTemplateFields {
    label
    value
    type
  }
}
    `;

/**
 * __useKineticEventFormTemplateFieldsQuery__
 *
 * To run a query within a React component, call `useKineticEventFormTemplateFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticEventFormTemplateFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticEventFormTemplateFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useKineticEventFormTemplateFieldsQuery(baseOptions?: Apollo.QueryHookOptions<KineticEventFormTemplateFieldsQuery, KineticEventFormTemplateFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticEventFormTemplateFieldsQuery, KineticEventFormTemplateFieldsQueryVariables>(KineticEventFormTemplateFieldsDocument, options);
      }
export function useKineticEventFormTemplateFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticEventFormTemplateFieldsQuery, KineticEventFormTemplateFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticEventFormTemplateFieldsQuery, KineticEventFormTemplateFieldsQueryVariables>(KineticEventFormTemplateFieldsDocument, options);
        }
export type KineticEventFormTemplateFieldsQueryHookResult = ReturnType<typeof useKineticEventFormTemplateFieldsQuery>;
export type KineticEventFormTemplateFieldsLazyQueryHookResult = ReturnType<typeof useKineticEventFormTemplateFieldsLazyQuery>;
export type KineticEventFormTemplateFieldsQueryResult = Apollo.QueryResult<KineticEventFormTemplateFieldsQuery, KineticEventFormTemplateFieldsQueryVariables>;
export function refetchKineticEventFormTemplateFieldsQuery(variables?: KineticEventFormTemplateFieldsQueryVariables) {
      return { query: KineticEventFormTemplateFieldsDocument, variables: variables }
    }
export const AddNetworkConditionsDocument = gql`
    mutation AddNetworkConditions($id: ID!, $boundedRoutes: [NetworkConditionInput!]!) {
  addNetworkConditions(id: $id, boundedRoutes: $boundedRoutes) {
    id
  }
}
    `;
export type AddNetworkConditionsMutationFn = Apollo.MutationFunction<AddNetworkConditionsMutation, AddNetworkConditionsMutationVariables>;

/**
 * __useAddNetworkConditionsMutation__
 *
 * To run a mutation, you first call `useAddNetworkConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNetworkConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNetworkConditionsMutation, { data, loading, error }] = useAddNetworkConditionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      boundedRoutes: // value for 'boundedRoutes'
 *   },
 * });
 */
export function useAddNetworkConditionsMutation(baseOptions?: Apollo.MutationHookOptions<AddNetworkConditionsMutation, AddNetworkConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNetworkConditionsMutation, AddNetworkConditionsMutationVariables>(AddNetworkConditionsDocument, options);
      }
export type AddNetworkConditionsMutationHookResult = ReturnType<typeof useAddNetworkConditionsMutation>;
export type AddNetworkConditionsMutationResult = Apollo.MutationResult<AddNetworkConditionsMutation>;
export type AddNetworkConditionsMutationOptions = Apollo.BaseMutationOptions<AddNetworkConditionsMutation, AddNetworkConditionsMutationVariables>;
export const UpdateNetworkConditionsDocument = gql`
    mutation UpdateNetworkConditions($networkConditions: [String!]!, $conditions: [String!]!, $status: String!, $id: ID!) {
  updateNetworkConditions(
    networkConditions: $networkConditions
    conditions: $conditions
    status: $status
    id: $id
  ) {
    id
  }
}
    `;
export type UpdateNetworkConditionsMutationFn = Apollo.MutationFunction<UpdateNetworkConditionsMutation, UpdateNetworkConditionsMutationVariables>;

/**
 * __useUpdateNetworkConditionsMutation__
 *
 * To run a mutation, you first call `useUpdateNetworkConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNetworkConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNetworkConditionsMutation, { data, loading, error }] = useUpdateNetworkConditionsMutation({
 *   variables: {
 *      networkConditions: // value for 'networkConditions'
 *      conditions: // value for 'conditions'
 *      status: // value for 'status'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateNetworkConditionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNetworkConditionsMutation, UpdateNetworkConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNetworkConditionsMutation, UpdateNetworkConditionsMutationVariables>(UpdateNetworkConditionsDocument, options);
      }
export type UpdateNetworkConditionsMutationHookResult = ReturnType<typeof useUpdateNetworkConditionsMutation>;
export type UpdateNetworkConditionsMutationResult = Apollo.MutationResult<UpdateNetworkConditionsMutation>;
export type UpdateNetworkConditionsMutationOptions = Apollo.BaseMutationOptions<UpdateNetworkConditionsMutation, UpdateNetworkConditionsMutationVariables>;
export const ConfirmNetworkConditionsDocument = gql`
    mutation ConfirmNetworkConditions($id: ID!, $networkConditions: [String!]!) {
  confirmNetworkConditions(id: $id, networkConditions: $networkConditions) {
    id
  }
}
    `;
export type ConfirmNetworkConditionsMutationFn = Apollo.MutationFunction<ConfirmNetworkConditionsMutation, ConfirmNetworkConditionsMutationVariables>;

/**
 * __useConfirmNetworkConditionsMutation__
 *
 * To run a mutation, you first call `useConfirmNetworkConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmNetworkConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmNetworkConditionsMutation, { data, loading, error }] = useConfirmNetworkConditionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      networkConditions: // value for 'networkConditions'
 *   },
 * });
 */
export function useConfirmNetworkConditionsMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmNetworkConditionsMutation, ConfirmNetworkConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmNetworkConditionsMutation, ConfirmNetworkConditionsMutationVariables>(ConfirmNetworkConditionsDocument, options);
      }
export type ConfirmNetworkConditionsMutationHookResult = ReturnType<typeof useConfirmNetworkConditionsMutation>;
export type ConfirmNetworkConditionsMutationResult = Apollo.MutationResult<ConfirmNetworkConditionsMutation>;
export type ConfirmNetworkConditionsMutationOptions = Apollo.BaseMutationOptions<ConfirmNetworkConditionsMutation, ConfirmNetworkConditionsMutationVariables>;
export const ClearNetworkConditionsDocument = gql`
    mutation ClearNetworkConditions($id: ID!, $networkConditions: [String!]!) {
  clearNetworkConditions(id: $id, networkConditions: $networkConditions) {
    id
  }
}
    `;
export type ClearNetworkConditionsMutationFn = Apollo.MutationFunction<ClearNetworkConditionsMutation, ClearNetworkConditionsMutationVariables>;

/**
 * __useClearNetworkConditionsMutation__
 *
 * To run a mutation, you first call `useClearNetworkConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearNetworkConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearNetworkConditionsMutation, { data, loading, error }] = useClearNetworkConditionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      networkConditions: // value for 'networkConditions'
 *   },
 * });
 */
export function useClearNetworkConditionsMutation(baseOptions?: Apollo.MutationHookOptions<ClearNetworkConditionsMutation, ClearNetworkConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearNetworkConditionsMutation, ClearNetworkConditionsMutationVariables>(ClearNetworkConditionsDocument, options);
      }
export type ClearNetworkConditionsMutationHookResult = ReturnType<typeof useClearNetworkConditionsMutation>;
export type ClearNetworkConditionsMutationResult = Apollo.MutationResult<ClearNetworkConditionsMutation>;
export type ClearNetworkConditionsMutationOptions = Apollo.BaseMutationOptions<ClearNetworkConditionsMutation, ClearNetworkConditionsMutationVariables>;
export const DeleteNetworkConditionsDocument = gql`
    mutation DeleteNetworkConditions($id: ID!, $networkConditions: [String!]!) {
  deleteNetworkConditions(id: $id, networkConditions: $networkConditions)
}
    `;
export type DeleteNetworkConditionsMutationFn = Apollo.MutationFunction<DeleteNetworkConditionsMutation, DeleteNetworkConditionsMutationVariables>;

/**
 * __useDeleteNetworkConditionsMutation__
 *
 * To run a mutation, you first call `useDeleteNetworkConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNetworkConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNetworkConditionsMutation, { data, loading, error }] = useDeleteNetworkConditionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      networkConditions: // value for 'networkConditions'
 *   },
 * });
 */
export function useDeleteNetworkConditionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNetworkConditionsMutation, DeleteNetworkConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNetworkConditionsMutation, DeleteNetworkConditionsMutationVariables>(DeleteNetworkConditionsDocument, options);
      }
export type DeleteNetworkConditionsMutationHookResult = ReturnType<typeof useDeleteNetworkConditionsMutation>;
export type DeleteNetworkConditionsMutationResult = Apollo.MutationResult<DeleteNetworkConditionsMutation>;
export type DeleteNetworkConditionsMutationOptions = Apollo.BaseMutationOptions<DeleteNetworkConditionsMutation, DeleteNetworkConditionsMutationVariables>;
export const UpdateNetworkJurisdictionDocument = gql`
    mutation UpdateNetworkJurisdiction($id: ID!, $networkJurisdiction: NetworkJurisdictionInput!) {
  updateNetworkJurisdiction(id: $id, networkJurisdiction: $networkJurisdiction) {
    id
  }
}
    `;
export type UpdateNetworkJurisdictionMutationFn = Apollo.MutationFunction<UpdateNetworkJurisdictionMutation, UpdateNetworkJurisdictionMutationVariables>;

/**
 * __useUpdateNetworkJurisdictionMutation__
 *
 * To run a mutation, you first call `useUpdateNetworkJurisdictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNetworkJurisdictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNetworkJurisdictionMutation, { data, loading, error }] = useUpdateNetworkJurisdictionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      networkJurisdiction: // value for 'networkJurisdiction'
 *   },
 * });
 */
export function useUpdateNetworkJurisdictionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNetworkJurisdictionMutation, UpdateNetworkJurisdictionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNetworkJurisdictionMutation, UpdateNetworkJurisdictionMutationVariables>(UpdateNetworkJurisdictionDocument, options);
      }
export type UpdateNetworkJurisdictionMutationHookResult = ReturnType<typeof useUpdateNetworkJurisdictionMutation>;
export type UpdateNetworkJurisdictionMutationResult = Apollo.MutationResult<UpdateNetworkJurisdictionMutation>;
export type UpdateNetworkJurisdictionMutationOptions = Apollo.BaseMutationOptions<UpdateNetworkJurisdictionMutation, UpdateNetworkJurisdictionMutationVariables>;
export const DeleteNetworkJurisdictionsDocument = gql`
    mutation DeleteNetworkJurisdictions($id: ID!, $networkJurisdictions: [String!]!) {
  deleteNetworkJurisdictions(id: $id, networkJurisdictions: $networkJurisdictions)
}
    `;
export type DeleteNetworkJurisdictionsMutationFn = Apollo.MutationFunction<DeleteNetworkJurisdictionsMutation, DeleteNetworkJurisdictionsMutationVariables>;

/**
 * __useDeleteNetworkJurisdictionsMutation__
 *
 * To run a mutation, you first call `useDeleteNetworkJurisdictionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNetworkJurisdictionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNetworkJurisdictionsMutation, { data, loading, error }] = useDeleteNetworkJurisdictionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      networkJurisdictions: // value for 'networkJurisdictions'
 *   },
 * });
 */
export function useDeleteNetworkJurisdictionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNetworkJurisdictionsMutation, DeleteNetworkJurisdictionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNetworkJurisdictionsMutation, DeleteNetworkJurisdictionsMutationVariables>(DeleteNetworkJurisdictionsDocument, options);
      }
export type DeleteNetworkJurisdictionsMutationHookResult = ReturnType<typeof useDeleteNetworkJurisdictionsMutation>;
export type DeleteNetworkJurisdictionsMutationResult = Apollo.MutationResult<DeleteNetworkJurisdictionsMutation>;
export type DeleteNetworkJurisdictionsMutationOptions = Apollo.BaseMutationOptions<DeleteNetworkJurisdictionsMutation, DeleteNetworkJurisdictionsMutationVariables>;
export const NetworkConditionsListDocument = gql`
    query NetworkConditionsList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  networkConditions(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        segments {
          startMeasure
          endMeasure
          conditions
          status
        }
        classification
        jurisdiction
        lastUpdated
        road
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useNetworkConditionsListQuery__
 *
 * To run a query within a React component, call `useNetworkConditionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkConditionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkConditionsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNetworkConditionsListQuery(baseOptions?: Apollo.QueryHookOptions<NetworkConditionsListQuery, NetworkConditionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkConditionsListQuery, NetworkConditionsListQueryVariables>(NetworkConditionsListDocument, options);
      }
export function useNetworkConditionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkConditionsListQuery, NetworkConditionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkConditionsListQuery, NetworkConditionsListQueryVariables>(NetworkConditionsListDocument, options);
        }
export type NetworkConditionsListQueryHookResult = ReturnType<typeof useNetworkConditionsListQuery>;
export type NetworkConditionsListLazyQueryHookResult = ReturnType<typeof useNetworkConditionsListLazyQuery>;
export type NetworkConditionsListQueryResult = Apollo.QueryResult<NetworkConditionsListQuery, NetworkConditionsListQueryVariables>;
export function refetchNetworkConditionsListQuery(variables?: NetworkConditionsListQueryVariables) {
      return { query: NetworkConditionsListDocument, variables: variables }
    }
export const LiveNetworkConditionDocument = gql`
    subscription LiveNetworkCondition($ids: [ID!]) {
  networkConditionUpdated(ids: $ids) {
    id
  }
}
    `;

/**
 * __useLiveNetworkConditionSubscription__
 *
 * To run a query within a React component, call `useLiveNetworkConditionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveNetworkConditionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveNetworkConditionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveNetworkConditionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveNetworkConditionSubscription, LiveNetworkConditionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveNetworkConditionSubscription, LiveNetworkConditionSubscriptionVariables>(LiveNetworkConditionDocument, options);
      }
export type LiveNetworkConditionSubscriptionHookResult = ReturnType<typeof useLiveNetworkConditionSubscription>;
export type LiveNetworkConditionSubscriptionResult = Apollo.SubscriptionResult<LiveNetworkConditionSubscription>;
export const LiveNetworkConditionsListDocument = gql`
    subscription LiveNetworkConditionsList($ids: [ID!]) {
  networkConditionUpdated(ids: $ids) {
    segments {
      startMeasure
      endMeasure
      conditions
      status
    }
    classification
    jurisdiction
    lastUpdated
    road
    id
  }
}
    `;

/**
 * __useLiveNetworkConditionsListSubscription__
 *
 * To run a query within a React component, call `useLiveNetworkConditionsListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveNetworkConditionsListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveNetworkConditionsListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveNetworkConditionsListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveNetworkConditionsListSubscription, LiveNetworkConditionsListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveNetworkConditionsListSubscription, LiveNetworkConditionsListSubscriptionVariables>(LiveNetworkConditionsListDocument, options);
      }
export type LiveNetworkConditionsListSubscriptionHookResult = ReturnType<typeof useLiveNetworkConditionsListSubscription>;
export type LiveNetworkConditionsListSubscriptionResult = Apollo.SubscriptionResult<LiveNetworkConditionsListSubscription>;
export const NetworkConditionsMapListDocument = gql`
    query NetworkConditionsMapList($filters: [FilterInput!]) {
  networkConditions(query: {filters: $filters, limit: 10000}) {
    edges {
      node {
        segments {
          geometry
          status
        }
        event
        id
      }
    }
  }
}
    `;

/**
 * __useNetworkConditionsMapListQuery__
 *
 * To run a query within a React component, call `useNetworkConditionsMapListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkConditionsMapListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkConditionsMapListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNetworkConditionsMapListQuery(baseOptions?: Apollo.QueryHookOptions<NetworkConditionsMapListQuery, NetworkConditionsMapListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkConditionsMapListQuery, NetworkConditionsMapListQueryVariables>(NetworkConditionsMapListDocument, options);
      }
export function useNetworkConditionsMapListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkConditionsMapListQuery, NetworkConditionsMapListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkConditionsMapListQuery, NetworkConditionsMapListQueryVariables>(NetworkConditionsMapListDocument, options);
        }
export type NetworkConditionsMapListQueryHookResult = ReturnType<typeof useNetworkConditionsMapListQuery>;
export type NetworkConditionsMapListLazyQueryHookResult = ReturnType<typeof useNetworkConditionsMapListLazyQuery>;
export type NetworkConditionsMapListQueryResult = Apollo.QueryResult<NetworkConditionsMapListQuery, NetworkConditionsMapListQueryVariables>;
export function refetchNetworkConditionsMapListQuery(variables?: NetworkConditionsMapListQueryVariables) {
      return { query: NetworkConditionsMapListDocument, variables: variables }
    }
export const NetworkJurisdictionsMapListDocument = gql`
    query NetworkJurisdictionsMapList($filters: [FilterInput!]) {
  networkJurisdictions(query: {filters: $filters, limit: 10000}) {
    edges {
      node {
        geometry
        status
        event
        id
      }
    }
  }
}
    `;

/**
 * __useNetworkJurisdictionsMapListQuery__
 *
 * To run a query within a React component, call `useNetworkJurisdictionsMapListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkJurisdictionsMapListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkJurisdictionsMapListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNetworkJurisdictionsMapListQuery(baseOptions?: Apollo.QueryHookOptions<NetworkJurisdictionsMapListQuery, NetworkJurisdictionsMapListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkJurisdictionsMapListQuery, NetworkJurisdictionsMapListQueryVariables>(NetworkJurisdictionsMapListDocument, options);
      }
export function useNetworkJurisdictionsMapListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkJurisdictionsMapListQuery, NetworkJurisdictionsMapListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkJurisdictionsMapListQuery, NetworkJurisdictionsMapListQueryVariables>(NetworkJurisdictionsMapListDocument, options);
        }
export type NetworkJurisdictionsMapListQueryHookResult = ReturnType<typeof useNetworkJurisdictionsMapListQuery>;
export type NetworkJurisdictionsMapListLazyQueryHookResult = ReturnType<typeof useNetworkJurisdictionsMapListLazyQuery>;
export type NetworkJurisdictionsMapListQueryResult = Apollo.QueryResult<NetworkJurisdictionsMapListQuery, NetworkJurisdictionsMapListQueryVariables>;
export function refetchNetworkJurisdictionsMapListQuery(variables?: NetworkJurisdictionsMapListQueryVariables) {
      return { query: NetworkJurisdictionsMapListDocument, variables: variables }
    }
export const NetworkConditionsCountDocument = gql`
    query NetworkConditionsCount($filters: [FilterInput]) {
  networkConditions(query: {filters: $filters}) {
    totalCount
  }
}
    `;

/**
 * __useNetworkConditionsCountQuery__
 *
 * To run a query within a React component, call `useNetworkConditionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkConditionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkConditionsCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNetworkConditionsCountQuery(baseOptions?: Apollo.QueryHookOptions<NetworkConditionsCountQuery, NetworkConditionsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkConditionsCountQuery, NetworkConditionsCountQueryVariables>(NetworkConditionsCountDocument, options);
      }
export function useNetworkConditionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkConditionsCountQuery, NetworkConditionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkConditionsCountQuery, NetworkConditionsCountQueryVariables>(NetworkConditionsCountDocument, options);
        }
export type NetworkConditionsCountQueryHookResult = ReturnType<typeof useNetworkConditionsCountQuery>;
export type NetworkConditionsCountLazyQueryHookResult = ReturnType<typeof useNetworkConditionsCountLazyQuery>;
export type NetworkConditionsCountQueryResult = Apollo.QueryResult<NetworkConditionsCountQuery, NetworkConditionsCountQueryVariables>;
export function refetchNetworkConditionsCountQuery(variables?: NetworkConditionsCountQueryVariables) {
      return { query: NetworkConditionsCountDocument, variables: variables }
    }
export const NetworkConditionDocument = gql`
    query NetworkCondition($id: ID!) {
  networkCondition(id: $id) {
    segments {
      startMeasure
      endMeasure
      conditions
      status
    }
    classification
    jurisdiction
    lastUpdated
    direction
    event
    road
    id
  }
}
    `;

/**
 * __useNetworkConditionQuery__
 *
 * To run a query within a React component, call `useNetworkConditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkConditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkConditionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNetworkConditionQuery(baseOptions: Apollo.QueryHookOptions<NetworkConditionQuery, NetworkConditionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkConditionQuery, NetworkConditionQueryVariables>(NetworkConditionDocument, options);
      }
export function useNetworkConditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkConditionQuery, NetworkConditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkConditionQuery, NetworkConditionQueryVariables>(NetworkConditionDocument, options);
        }
export type NetworkConditionQueryHookResult = ReturnType<typeof useNetworkConditionQuery>;
export type NetworkConditionLazyQueryHookResult = ReturnType<typeof useNetworkConditionLazyQuery>;
export type NetworkConditionQueryResult = Apollo.QueryResult<NetworkConditionQuery, NetworkConditionQueryVariables>;
export function refetchNetworkConditionQuery(variables: NetworkConditionQueryVariables) {
      return { query: NetworkConditionDocument, variables: variables }
    }
export const NetworkConditionsSummaryListDocument = gql`
    query NetworkConditionsSummaryList($filters: [FilterInput]) {
  networkConditions(query: {limit: 10000, filters: $filters}) {
    edges {
      node {
        segments {
          status
        }
      }
    }
  }
}
    `;

/**
 * __useNetworkConditionsSummaryListQuery__
 *
 * To run a query within a React component, call `useNetworkConditionsSummaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkConditionsSummaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkConditionsSummaryListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNetworkConditionsSummaryListQuery(baseOptions?: Apollo.QueryHookOptions<NetworkConditionsSummaryListQuery, NetworkConditionsSummaryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkConditionsSummaryListQuery, NetworkConditionsSummaryListQueryVariables>(NetworkConditionsSummaryListDocument, options);
      }
export function useNetworkConditionsSummaryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkConditionsSummaryListQuery, NetworkConditionsSummaryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkConditionsSummaryListQuery, NetworkConditionsSummaryListQueryVariables>(NetworkConditionsSummaryListDocument, options);
        }
export type NetworkConditionsSummaryListQueryHookResult = ReturnType<typeof useNetworkConditionsSummaryListQuery>;
export type NetworkConditionsSummaryListLazyQueryHookResult = ReturnType<typeof useNetworkConditionsSummaryListLazyQuery>;
export type NetworkConditionsSummaryListQueryResult = Apollo.QueryResult<NetworkConditionsSummaryListQuery, NetworkConditionsSummaryListQueryVariables>;
export function refetchNetworkConditionsSummaryListQuery(variables?: NetworkConditionsSummaryListQueryVariables) {
      return { query: NetworkConditionsSummaryListDocument, variables: variables }
    }
export const LiveNetworkConditionsSummaryListDocument = gql`
    subscription LiveNetworkConditionsSummaryList($ids: [ID!]) {
  networkConditionUpdated(ids: $ids) {
    segments {
      status
    }
  }
}
    `;

/**
 * __useLiveNetworkConditionsSummaryListSubscription__
 *
 * To run a query within a React component, call `useLiveNetworkConditionsSummaryListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveNetworkConditionsSummaryListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveNetworkConditionsSummaryListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveNetworkConditionsSummaryListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveNetworkConditionsSummaryListSubscription, LiveNetworkConditionsSummaryListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveNetworkConditionsSummaryListSubscription, LiveNetworkConditionsSummaryListSubscriptionVariables>(LiveNetworkConditionsSummaryListDocument, options);
      }
export type LiveNetworkConditionsSummaryListSubscriptionHookResult = ReturnType<typeof useLiveNetworkConditionsSummaryListSubscription>;
export type LiveNetworkConditionsSummaryListSubscriptionResult = Apollo.SubscriptionResult<LiveNetworkConditionsSummaryListSubscription>;
export const RoadConditionsSearchListDocument = gql`
    query RoadConditionsSearchList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  events(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        attributes
        geometry
        name
        id
      }
    }
  }
}
    `;

/**
 * __useRoadConditionsSearchListQuery__
 *
 * To run a query within a React component, call `useRoadConditionsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadConditionsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoadConditionsSearchListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRoadConditionsSearchListQuery(baseOptions?: Apollo.QueryHookOptions<RoadConditionsSearchListQuery, RoadConditionsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoadConditionsSearchListQuery, RoadConditionsSearchListQueryVariables>(RoadConditionsSearchListDocument, options);
      }
export function useRoadConditionsSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoadConditionsSearchListQuery, RoadConditionsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoadConditionsSearchListQuery, RoadConditionsSearchListQueryVariables>(RoadConditionsSearchListDocument, options);
        }
export type RoadConditionsSearchListQueryHookResult = ReturnType<typeof useRoadConditionsSearchListQuery>;
export type RoadConditionsSearchListLazyQueryHookResult = ReturnType<typeof useRoadConditionsSearchListLazyQuery>;
export type RoadConditionsSearchListQueryResult = Apollo.QueryResult<RoadConditionsSearchListQuery, RoadConditionsSearchListQueryVariables>;
export function refetchRoadConditionsSearchListQuery(variables?: RoadConditionsSearchListQueryVariables) {
      return { query: RoadConditionsSearchListDocument, variables: variables }
    }
export const NetworkConditionFiltersListDocument = gql`
    query NetworkConditionFiltersList($filters: [FilterInput]) {
  networkConditions(query: {filters: $filters, limit: 10000}) {
    edges {
      node {
        segments {
          conditions
          status
        }
        classification
        jurisdiction
        id
      }
    }
  }
}
    `;

/**
 * __useNetworkConditionFiltersListQuery__
 *
 * To run a query within a React component, call `useNetworkConditionFiltersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkConditionFiltersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkConditionFiltersListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNetworkConditionFiltersListQuery(baseOptions?: Apollo.QueryHookOptions<NetworkConditionFiltersListQuery, NetworkConditionFiltersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkConditionFiltersListQuery, NetworkConditionFiltersListQueryVariables>(NetworkConditionFiltersListDocument, options);
      }
export function useNetworkConditionFiltersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkConditionFiltersListQuery, NetworkConditionFiltersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkConditionFiltersListQuery, NetworkConditionFiltersListQueryVariables>(NetworkConditionFiltersListDocument, options);
        }
export type NetworkConditionFiltersListQueryHookResult = ReturnType<typeof useNetworkConditionFiltersListQuery>;
export type NetworkConditionFiltersListLazyQueryHookResult = ReturnType<typeof useNetworkConditionFiltersListLazyQuery>;
export type NetworkConditionFiltersListQueryResult = Apollo.QueryResult<NetworkConditionFiltersListQuery, NetworkConditionFiltersListQueryVariables>;
export function refetchNetworkConditionFiltersListQuery(variables?: NetworkConditionFiltersListQueryVariables) {
      return { query: NetworkConditionFiltersListDocument, variables: variables }
    }
export const NetworkJurisdictionsListDocument = gql`
    query NetworkJurisdictionsList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  networkJurisdictions(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        lastUpdated
        conditions
        attributes
        status
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useNetworkJurisdictionsListQuery__
 *
 * To run a query within a React component, call `useNetworkJurisdictionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkJurisdictionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkJurisdictionsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNetworkJurisdictionsListQuery(baseOptions?: Apollo.QueryHookOptions<NetworkJurisdictionsListQuery, NetworkJurisdictionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkJurisdictionsListQuery, NetworkJurisdictionsListQueryVariables>(NetworkJurisdictionsListDocument, options);
      }
export function useNetworkJurisdictionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkJurisdictionsListQuery, NetworkJurisdictionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkJurisdictionsListQuery, NetworkJurisdictionsListQueryVariables>(NetworkJurisdictionsListDocument, options);
        }
export type NetworkJurisdictionsListQueryHookResult = ReturnType<typeof useNetworkJurisdictionsListQuery>;
export type NetworkJurisdictionsListLazyQueryHookResult = ReturnType<typeof useNetworkJurisdictionsListLazyQuery>;
export type NetworkJurisdictionsListQueryResult = Apollo.QueryResult<NetworkJurisdictionsListQuery, NetworkJurisdictionsListQueryVariables>;
export function refetchNetworkJurisdictionsListQuery(variables?: NetworkJurisdictionsListQueryVariables) {
      return { query: NetworkJurisdictionsListDocument, variables: variables }
    }
export const LiveNetworkJurisdictionsListDocument = gql`
    subscription LiveNetworkJurisdictionsList($ids: [ID!]) {
  networkJurisdictionUpdated(ids: $ids) {
    lastUpdated
    conditions
    attributes
    status
    name
    id
  }
}
    `;

/**
 * __useLiveNetworkJurisdictionsListSubscription__
 *
 * To run a query within a React component, call `useLiveNetworkJurisdictionsListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveNetworkJurisdictionsListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveNetworkJurisdictionsListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveNetworkJurisdictionsListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveNetworkJurisdictionsListSubscription, LiveNetworkJurisdictionsListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveNetworkJurisdictionsListSubscription, LiveNetworkJurisdictionsListSubscriptionVariables>(LiveNetworkJurisdictionsListDocument, options);
      }
export type LiveNetworkJurisdictionsListSubscriptionHookResult = ReturnType<typeof useLiveNetworkJurisdictionsListSubscription>;
export type LiveNetworkJurisdictionsListSubscriptionResult = Apollo.SubscriptionResult<LiveNetworkJurisdictionsListSubscription>;
export const LiveNetworkJurisdictionDocument = gql`
    subscription LiveNetworkJurisdiction($ids: [ID!]) {
  networkJurisdictionUpdated(ids: $ids) {
    id
  }
}
    `;

/**
 * __useLiveNetworkJurisdictionSubscription__
 *
 * To run a query within a React component, call `useLiveNetworkJurisdictionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveNetworkJurisdictionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveNetworkJurisdictionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveNetworkJurisdictionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveNetworkJurisdictionSubscription, LiveNetworkJurisdictionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveNetworkJurisdictionSubscription, LiveNetworkJurisdictionSubscriptionVariables>(LiveNetworkJurisdictionDocument, options);
      }
export type LiveNetworkJurisdictionSubscriptionHookResult = ReturnType<typeof useLiveNetworkJurisdictionSubscription>;
export type LiveNetworkJurisdictionSubscriptionResult = Apollo.SubscriptionResult<LiveNetworkJurisdictionSubscription>;
export const NetworkJurisdictionFiltersListDocument = gql`
    query NetworkJurisdictionFiltersList($filters: [FilterInput]) {
  networkJurisdictions(query: {filters: $filters, limit: 10000}) {
    edges {
      node {
        conditions
        status
        id
      }
    }
  }
}
    `;

/**
 * __useNetworkJurisdictionFiltersListQuery__
 *
 * To run a query within a React component, call `useNetworkJurisdictionFiltersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkJurisdictionFiltersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkJurisdictionFiltersListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNetworkJurisdictionFiltersListQuery(baseOptions?: Apollo.QueryHookOptions<NetworkJurisdictionFiltersListQuery, NetworkJurisdictionFiltersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkJurisdictionFiltersListQuery, NetworkJurisdictionFiltersListQueryVariables>(NetworkJurisdictionFiltersListDocument, options);
      }
export function useNetworkJurisdictionFiltersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkJurisdictionFiltersListQuery, NetworkJurisdictionFiltersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkJurisdictionFiltersListQuery, NetworkJurisdictionFiltersListQueryVariables>(NetworkJurisdictionFiltersListDocument, options);
        }
export type NetworkJurisdictionFiltersListQueryHookResult = ReturnType<typeof useNetworkJurisdictionFiltersListQuery>;
export type NetworkJurisdictionFiltersListLazyQueryHookResult = ReturnType<typeof useNetworkJurisdictionFiltersListLazyQuery>;
export type NetworkJurisdictionFiltersListQueryResult = Apollo.QueryResult<NetworkJurisdictionFiltersListQuery, NetworkJurisdictionFiltersListQueryVariables>;
export function refetchNetworkJurisdictionFiltersListQuery(variables?: NetworkJurisdictionFiltersListQueryVariables) {
      return { query: NetworkJurisdictionFiltersListDocument, variables: variables }
    }
export const NetworkJurisdictionDocument = gql`
    query NetworkJurisdiction($id: ID!) {
  networkJurisdiction(id: $id) {
    lastUpdated
    attributes
    conditions
    status
    type
    name
    id
  }
}
    `;

/**
 * __useNetworkJurisdictionQuery__
 *
 * To run a query within a React component, call `useNetworkJurisdictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkJurisdictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkJurisdictionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNetworkJurisdictionQuery(baseOptions: Apollo.QueryHookOptions<NetworkJurisdictionQuery, NetworkJurisdictionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkJurisdictionQuery, NetworkJurisdictionQueryVariables>(NetworkJurisdictionDocument, options);
      }
export function useNetworkJurisdictionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkJurisdictionQuery, NetworkJurisdictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkJurisdictionQuery, NetworkJurisdictionQueryVariables>(NetworkJurisdictionDocument, options);
        }
export type NetworkJurisdictionQueryHookResult = ReturnType<typeof useNetworkJurisdictionQuery>;
export type NetworkJurisdictionLazyQueryHookResult = ReturnType<typeof useNetworkJurisdictionLazyQuery>;
export type NetworkJurisdictionQueryResult = Apollo.QueryResult<NetworkJurisdictionQuery, NetworkJurisdictionQueryVariables>;
export function refetchNetworkJurisdictionQuery(variables: NetworkJurisdictionQueryVariables) {
      return { query: NetworkJurisdictionDocument, variables: variables }
    }
export const NetworkJurisdictionCountDocument = gql`
    query NetworkJurisdictionCount($filters: [FilterInput]) {
  networkJurisdictions(query: {filters: $filters}) {
    totalCount
  }
}
    `;

/**
 * __useNetworkJurisdictionCountQuery__
 *
 * To run a query within a React component, call `useNetworkJurisdictionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkJurisdictionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkJurisdictionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNetworkJurisdictionCountQuery(baseOptions?: Apollo.QueryHookOptions<NetworkJurisdictionCountQuery, NetworkJurisdictionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkJurisdictionCountQuery, NetworkJurisdictionCountQueryVariables>(NetworkJurisdictionCountDocument, options);
      }
export function useNetworkJurisdictionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkJurisdictionCountQuery, NetworkJurisdictionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkJurisdictionCountQuery, NetworkJurisdictionCountQueryVariables>(NetworkJurisdictionCountDocument, options);
        }
export type NetworkJurisdictionCountQueryHookResult = ReturnType<typeof useNetworkJurisdictionCountQuery>;
export type NetworkJurisdictionCountLazyQueryHookResult = ReturnType<typeof useNetworkJurisdictionCountLazyQuery>;
export type NetworkJurisdictionCountQueryResult = Apollo.QueryResult<NetworkJurisdictionCountQuery, NetworkJurisdictionCountQueryVariables>;
export function refetchNetworkJurisdictionCountQuery(variables?: NetworkJurisdictionCountQueryVariables) {
      return { query: NetworkJurisdictionCountDocument, variables: variables }
    }
export const SaveResponseRuleDocument = gql`
    mutation SaveResponseRule($input: ResponseRuleInput!) {
  saveResponseRule(input: $input) {
    id
  }
}
    `;
export type SaveResponseRuleMutationFn = Apollo.MutationFunction<SaveResponseRuleMutation, SaveResponseRuleMutationVariables>;

/**
 * __useSaveResponseRuleMutation__
 *
 * To run a mutation, you first call `useSaveResponseRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveResponseRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveResponseRuleMutation, { data, loading, error }] = useSaveResponseRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveResponseRuleMutation(baseOptions?: Apollo.MutationHookOptions<SaveResponseRuleMutation, SaveResponseRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveResponseRuleMutation, SaveResponseRuleMutationVariables>(SaveResponseRuleDocument, options);
      }
export type SaveResponseRuleMutationHookResult = ReturnType<typeof useSaveResponseRuleMutation>;
export type SaveResponseRuleMutationResult = Apollo.MutationResult<SaveResponseRuleMutation>;
export type SaveResponseRuleMutationOptions = Apollo.BaseMutationOptions<SaveResponseRuleMutation, SaveResponseRuleMutationVariables>;
export const DeleteResponseRuleDocument = gql`
    mutation DeleteResponseRule($id: ID!) {
  deleteResponseRule(id: $id)
}
    `;
export type DeleteResponseRuleMutationFn = Apollo.MutationFunction<DeleteResponseRuleMutation, DeleteResponseRuleMutationVariables>;

/**
 * __useDeleteResponseRuleMutation__
 *
 * To run a mutation, you first call `useDeleteResponseRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResponseRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResponseRuleMutation, { data, loading, error }] = useDeleteResponseRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResponseRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResponseRuleMutation, DeleteResponseRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResponseRuleMutation, DeleteResponseRuleMutationVariables>(DeleteResponseRuleDocument, options);
      }
export type DeleteResponseRuleMutationHookResult = ReturnType<typeof useDeleteResponseRuleMutation>;
export type DeleteResponseRuleMutationResult = Apollo.MutationResult<DeleteResponseRuleMutation>;
export type DeleteResponseRuleMutationOptions = Apollo.BaseMutationOptions<DeleteResponseRuleMutation, DeleteResponseRuleMutationVariables>;
export const ResponseRulesListDocument = gql`
    query ResponseRulesList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  responseRules(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        condition {
          priority
          type
        }
        action {
          type
        }
        automatic
        enabled
        form
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useResponseRulesListQuery__
 *
 * To run a query within a React component, call `useResponseRulesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseRulesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseRulesListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useResponseRulesListQuery(baseOptions?: Apollo.QueryHookOptions<ResponseRulesListQuery, ResponseRulesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseRulesListQuery, ResponseRulesListQueryVariables>(ResponseRulesListDocument, options);
      }
export function useResponseRulesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseRulesListQuery, ResponseRulesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseRulesListQuery, ResponseRulesListQueryVariables>(ResponseRulesListDocument, options);
        }
export type ResponseRulesListQueryHookResult = ReturnType<typeof useResponseRulesListQuery>;
export type ResponseRulesListLazyQueryHookResult = ReturnType<typeof useResponseRulesListLazyQuery>;
export type ResponseRulesListQueryResult = Apollo.QueryResult<ResponseRulesListQuery, ResponseRulesListQueryVariables>;
export function refetchResponseRulesListQuery(variables?: ResponseRulesListQueryVariables) {
      return { query: ResponseRulesListDocument, variables: variables }
    }
export const KineticFormTemplateFieldsDocument = gql`
    query KineticFormTemplateFields($id: ID!) {
  kineticFormTemplateFields(id: $id) {
    label
    value
    type
  }
}
    `;

/**
 * __useKineticFormTemplateFieldsQuery__
 *
 * To run a query within a React component, call `useKineticFormTemplateFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormTemplateFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormTemplateFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKineticFormTemplateFieldsQuery(baseOptions: Apollo.QueryHookOptions<KineticFormTemplateFieldsQuery, KineticFormTemplateFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormTemplateFieldsQuery, KineticFormTemplateFieldsQueryVariables>(KineticFormTemplateFieldsDocument, options);
      }
export function useKineticFormTemplateFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormTemplateFieldsQuery, KineticFormTemplateFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormTemplateFieldsQuery, KineticFormTemplateFieldsQueryVariables>(KineticFormTemplateFieldsDocument, options);
        }
export type KineticFormTemplateFieldsQueryHookResult = ReturnType<typeof useKineticFormTemplateFieldsQuery>;
export type KineticFormTemplateFieldsLazyQueryHookResult = ReturnType<typeof useKineticFormTemplateFieldsLazyQuery>;
export type KineticFormTemplateFieldsQueryResult = Apollo.QueryResult<KineticFormTemplateFieldsQuery, KineticFormTemplateFieldsQueryVariables>;
export function refetchKineticFormTemplateFieldsQuery(variables: KineticFormTemplateFieldsQueryVariables) {
      return { query: KineticFormTemplateFieldsDocument, variables: variables }
    }
export const KineticFormOptionsListDocument = gql`
    query KineticFormOptionsList($query: KineticFormInputQuery!) {
  kineticForms(query: $query) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useKineticFormOptionsListQuery__
 *
 * To run a query within a React component, call `useKineticFormOptionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormOptionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormOptionsListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useKineticFormOptionsListQuery(baseOptions: Apollo.QueryHookOptions<KineticFormOptionsListQuery, KineticFormOptionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormOptionsListQuery, KineticFormOptionsListQueryVariables>(KineticFormOptionsListDocument, options);
      }
export function useKineticFormOptionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormOptionsListQuery, KineticFormOptionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormOptionsListQuery, KineticFormOptionsListQueryVariables>(KineticFormOptionsListDocument, options);
        }
export type KineticFormOptionsListQueryHookResult = ReturnType<typeof useKineticFormOptionsListQuery>;
export type KineticFormOptionsListLazyQueryHookResult = ReturnType<typeof useKineticFormOptionsListLazyQuery>;
export type KineticFormOptionsListQueryResult = Apollo.QueryResult<KineticFormOptionsListQuery, KineticFormOptionsListQueryVariables>;
export function refetchKineticFormOptionsListQuery(variables: KineticFormOptionsListQueryVariables) {
      return { query: KineticFormOptionsListDocument, variables: variables }
    }
export const ResponseRuleDocument = gql`
    query ResponseRule($id: ID!) {
  responseRule(id: $id) {
    condition {
      type
      priority
      tree
      rule
    }
    action {
      resourcePlans
      actionSets
      detours
      message {
        ...SignMessage
      }
      laneControlAction {
        command
        priority
      }
      recommendedContacts {
        recipientId
        name
        label
        email
        smsRecipient
        type
        workNumber
      }
      type
    }
    automatic
    corridor
    enabled
    type
    form
    name
    id
  }
}
    ${SignMessageFragmentDoc}`;

/**
 * __useResponseRuleQuery__
 *
 * To run a query within a React component, call `useResponseRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResponseRuleQuery(baseOptions: Apollo.QueryHookOptions<ResponseRuleQuery, ResponseRuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseRuleQuery, ResponseRuleQueryVariables>(ResponseRuleDocument, options);
      }
export function useResponseRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseRuleQuery, ResponseRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseRuleQuery, ResponseRuleQueryVariables>(ResponseRuleDocument, options);
        }
export type ResponseRuleQueryHookResult = ReturnType<typeof useResponseRuleQuery>;
export type ResponseRuleLazyQueryHookResult = ReturnType<typeof useResponseRuleLazyQuery>;
export type ResponseRuleQueryResult = Apollo.QueryResult<ResponseRuleQuery, ResponseRuleQueryVariables>;
export function refetchResponseRuleQuery(variables: ResponseRuleQueryVariables) {
      return { query: ResponseRuleDocument, variables: variables }
    }
export const ResourcePlanSelectionOptionsDocument = gql`
    query ResourcePlanSelectionOptions($filters: [FilterInput!]) {
  resourcePlans(query: {limit: 1000, filters: $filters}) {
    edges {
      node {
        details {
          name
        }
        id
      }
    }
  }
}
    `;

/**
 * __useResourcePlanSelectionOptionsQuery__
 *
 * To run a query within a React component, call `useResourcePlanSelectionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanSelectionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanSelectionOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useResourcePlanSelectionOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ResourcePlanSelectionOptionsQuery, ResourcePlanSelectionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcePlanSelectionOptionsQuery, ResourcePlanSelectionOptionsQueryVariables>(ResourcePlanSelectionOptionsDocument, options);
      }
export function useResourcePlanSelectionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcePlanSelectionOptionsQuery, ResourcePlanSelectionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcePlanSelectionOptionsQuery, ResourcePlanSelectionOptionsQueryVariables>(ResourcePlanSelectionOptionsDocument, options);
        }
export type ResourcePlanSelectionOptionsQueryHookResult = ReturnType<typeof useResourcePlanSelectionOptionsQuery>;
export type ResourcePlanSelectionOptionsLazyQueryHookResult = ReturnType<typeof useResourcePlanSelectionOptionsLazyQuery>;
export type ResourcePlanSelectionOptionsQueryResult = Apollo.QueryResult<ResourcePlanSelectionOptionsQuery, ResourcePlanSelectionOptionsQueryVariables>;
export function refetchResourcePlanSelectionOptionsQuery(variables?: ResourcePlanSelectionOptionsQueryVariables) {
      return { query: ResourcePlanSelectionOptionsDocument, variables: variables }
    }
export const ActionSetSelectionOptionsDocument = gql`
    query ActionSetSelectionOptions($filters: [FilterInput]) {
  signalActionSets(limit: 1000, filters: $filters) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useActionSetSelectionOptionsQuery__
 *
 * To run a query within a React component, call `useActionSetSelectionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionSetSelectionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionSetSelectionOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useActionSetSelectionOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ActionSetSelectionOptionsQuery, ActionSetSelectionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionSetSelectionOptionsQuery, ActionSetSelectionOptionsQueryVariables>(ActionSetSelectionOptionsDocument, options);
      }
export function useActionSetSelectionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionSetSelectionOptionsQuery, ActionSetSelectionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionSetSelectionOptionsQuery, ActionSetSelectionOptionsQueryVariables>(ActionSetSelectionOptionsDocument, options);
        }
export type ActionSetSelectionOptionsQueryHookResult = ReturnType<typeof useActionSetSelectionOptionsQuery>;
export type ActionSetSelectionOptionsLazyQueryHookResult = ReturnType<typeof useActionSetSelectionOptionsLazyQuery>;
export type ActionSetSelectionOptionsQueryResult = Apollo.QueryResult<ActionSetSelectionOptionsQuery, ActionSetSelectionOptionsQueryVariables>;
export function refetchActionSetSelectionOptionsQuery(variables?: ActionSetSelectionOptionsQueryVariables) {
      return { query: ActionSetSelectionOptionsDocument, variables: variables }
    }
export const SignSelectionOptionsDocument = gql`
    query SignSelectionOptions($filters: [FilterInput!], $limit: Int) {
  signs(filters: $filters, limit: $limit) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useSignSelectionOptionsQuery__
 *
 * To run a query within a React component, call `useSignSelectionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignSelectionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignSelectionOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSignSelectionOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SignSelectionOptionsQuery, SignSelectionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignSelectionOptionsQuery, SignSelectionOptionsQueryVariables>(SignSelectionOptionsDocument, options);
      }
export function useSignSelectionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignSelectionOptionsQuery, SignSelectionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignSelectionOptionsQuery, SignSelectionOptionsQueryVariables>(SignSelectionOptionsDocument, options);
        }
export type SignSelectionOptionsQueryHookResult = ReturnType<typeof useSignSelectionOptionsQuery>;
export type SignSelectionOptionsLazyQueryHookResult = ReturnType<typeof useSignSelectionOptionsLazyQuery>;
export type SignSelectionOptionsQueryResult = Apollo.QueryResult<SignSelectionOptionsQuery, SignSelectionOptionsQueryVariables>;
export function refetchSignSelectionOptionsQuery(variables?: SignSelectionOptionsQueryVariables) {
      return { query: SignSelectionOptionsDocument, variables: variables }
    }
export const ResponseRuleConfigDocument = gql`
    query ResponseRuleConfig($conditionType: ResponseRuleConditionType!, $actionType: ResponseRuleActionType!, $form: ID) {
  responseRuleConfig(
    conditionType: $conditionType
    actionType: $actionType
    form: $form
  )
}
    `;

/**
 * __useResponseRuleConfigQuery__
 *
 * To run a query within a React component, call `useResponseRuleConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseRuleConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseRuleConfigQuery({
 *   variables: {
 *      conditionType: // value for 'conditionType'
 *      actionType: // value for 'actionType'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useResponseRuleConfigQuery(baseOptions: Apollo.QueryHookOptions<ResponseRuleConfigQuery, ResponseRuleConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseRuleConfigQuery, ResponseRuleConfigQueryVariables>(ResponseRuleConfigDocument, options);
      }
export function useResponseRuleConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseRuleConfigQuery, ResponseRuleConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseRuleConfigQuery, ResponseRuleConfigQueryVariables>(ResponseRuleConfigDocument, options);
        }
export type ResponseRuleConfigQueryHookResult = ReturnType<typeof useResponseRuleConfigQuery>;
export type ResponseRuleConfigLazyQueryHookResult = ReturnType<typeof useResponseRuleConfigLazyQuery>;
export type ResponseRuleConfigQueryResult = Apollo.QueryResult<ResponseRuleConfigQuery, ResponseRuleConfigQueryVariables>;
export function refetchResponseRuleConfigQuery(variables: ResponseRuleConfigQueryVariables) {
      return { query: ResponseRuleConfigDocument, variables: variables }
    }
export const CorridorIntegrationsDocument = gql`
    query CorridorIntegrations($id: ID!) {
  corridor(id: $id) {
    integrations
  }
}
    `;

/**
 * __useCorridorIntegrationsQuery__
 *
 * To run a query within a React component, call `useCorridorIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorridorIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorridorIntegrationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCorridorIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<CorridorIntegrationsQuery, CorridorIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorridorIntegrationsQuery, CorridorIntegrationsQueryVariables>(CorridorIntegrationsDocument, options);
      }
export function useCorridorIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorridorIntegrationsQuery, CorridorIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorridorIntegrationsQuery, CorridorIntegrationsQueryVariables>(CorridorIntegrationsDocument, options);
        }
export type CorridorIntegrationsQueryHookResult = ReturnType<typeof useCorridorIntegrationsQuery>;
export type CorridorIntegrationsLazyQueryHookResult = ReturnType<typeof useCorridorIntegrationsLazyQuery>;
export type CorridorIntegrationsQueryResult = Apollo.QueryResult<CorridorIntegrationsQuery, CorridorIntegrationsQueryVariables>;
export function refetchCorridorIntegrationsQuery(variables: CorridorIntegrationsQueryVariables) {
      return { query: CorridorIntegrationsDocument, variables: variables }
    }
export const CameraSelectionListDocument = gql`
    query CameraSelectionList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  cameras(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
    searchFields: ["name", "config.settings.DIRECTION"]
  ) {
    edges {
      node {
        referencePoint
        direction
        road
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useCameraSelectionListQuery__
 *
 * To run a query within a React component, call `useCameraSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCameraSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<CameraSelectionListQuery, CameraSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraSelectionListQuery, CameraSelectionListQueryVariables>(CameraSelectionListDocument, options);
      }
export function useCameraSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraSelectionListQuery, CameraSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraSelectionListQuery, CameraSelectionListQueryVariables>(CameraSelectionListDocument, options);
        }
export type CameraSelectionListQueryHookResult = ReturnType<typeof useCameraSelectionListQuery>;
export type CameraSelectionListLazyQueryHookResult = ReturnType<typeof useCameraSelectionListLazyQuery>;
export type CameraSelectionListQueryResult = Apollo.QueryResult<CameraSelectionListQuery, CameraSelectionListQueryVariables>;
export function refetchCameraSelectionListQuery(variables?: CameraSelectionListQueryVariables) {
      return { query: CameraSelectionListDocument, variables: variables }
    }
export const DetectorSelectionListDocument = gql`
    query DetectorSelectionList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  detectors(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        referencePoint
        direction
        road
        name
        id
        communicationState
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useDetectorSelectionListQuery__
 *
 * To run a query within a React component, call `useDetectorSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDetectorSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<DetectorSelectionListQuery, DetectorSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorSelectionListQuery, DetectorSelectionListQueryVariables>(DetectorSelectionListDocument, options);
      }
export function useDetectorSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorSelectionListQuery, DetectorSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorSelectionListQuery, DetectorSelectionListQueryVariables>(DetectorSelectionListDocument, options);
        }
export type DetectorSelectionListQueryHookResult = ReturnType<typeof useDetectorSelectionListQuery>;
export type DetectorSelectionListLazyQueryHookResult = ReturnType<typeof useDetectorSelectionListLazyQuery>;
export type DetectorSelectionListQueryResult = Apollo.QueryResult<DetectorSelectionListQuery, DetectorSelectionListQueryVariables>;
export function refetchDetectorSelectionListQuery(variables?: DetectorSelectionListQueryVariables) {
      return { query: DetectorSelectionListDocument, variables: variables }
    }
export const DetectorSelectionListUpdatedDocument = gql`
    subscription DetectorSelectionListUpdated($ids: [ID!]) {
  detectorUpdated(ids: $ids) {
    referencePoint
    direction
    road
    name
    id
    communicationState
  }
}
    `;

/**
 * __useDetectorSelectionListUpdatedSubscription__
 *
 * To run a query within a React component, call `useDetectorSelectionListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetectorSelectionListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorSelectionListUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDetectorSelectionListUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DetectorSelectionListUpdatedSubscription, DetectorSelectionListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetectorSelectionListUpdatedSubscription, DetectorSelectionListUpdatedSubscriptionVariables>(DetectorSelectionListUpdatedDocument, options);
      }
export type DetectorSelectionListUpdatedSubscriptionHookResult = ReturnType<typeof useDetectorSelectionListUpdatedSubscription>;
export type DetectorSelectionListUpdatedSubscriptionResult = Apollo.SubscriptionResult<DetectorSelectionListUpdatedSubscription>;
export const ResourcePlanSelectionListDocument = gql`
    query ResourcePlanSelectionList($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 1000, $before: String, $after: String) {
  resourcePlans(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        details {
          description
          name
        }
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useResourcePlanSelectionListQuery__
 *
 * To run a query within a React component, call `useResourcePlanSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePlanSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePlanSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useResourcePlanSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<ResourcePlanSelectionListQuery, ResourcePlanSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcePlanSelectionListQuery, ResourcePlanSelectionListQueryVariables>(ResourcePlanSelectionListDocument, options);
      }
export function useResourcePlanSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcePlanSelectionListQuery, ResourcePlanSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcePlanSelectionListQuery, ResourcePlanSelectionListQueryVariables>(ResourcePlanSelectionListDocument, options);
        }
export type ResourcePlanSelectionListQueryHookResult = ReturnType<typeof useResourcePlanSelectionListQuery>;
export type ResourcePlanSelectionListLazyQueryHookResult = ReturnType<typeof useResourcePlanSelectionListLazyQuery>;
export type ResourcePlanSelectionListQueryResult = Apollo.QueryResult<ResourcePlanSelectionListQuery, ResourcePlanSelectionListQueryVariables>;
export function refetchResourcePlanSelectionListQuery(variables?: ResourcePlanSelectionListQueryVariables) {
      return { query: ResourcePlanSelectionListDocument, variables: variables }
    }
export const LiveResourcePlanSelectionListDocument = gql`
    subscription LiveResourcePlanSelectionList($ids: [ID!]!) {
  resourcePlanUpdated(ids: $ids) {
    details {
      description
      name
    }
    id
  }
}
    `;

/**
 * __useLiveResourcePlanSelectionListSubscription__
 *
 * To run a query within a React component, call `useLiveResourcePlanSelectionListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveResourcePlanSelectionListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveResourcePlanSelectionListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveResourcePlanSelectionListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveResourcePlanSelectionListSubscription, LiveResourcePlanSelectionListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveResourcePlanSelectionListSubscription, LiveResourcePlanSelectionListSubscriptionVariables>(LiveResourcePlanSelectionListDocument, options);
      }
export type LiveResourcePlanSelectionListSubscriptionHookResult = ReturnType<typeof useLiveResourcePlanSelectionListSubscription>;
export type LiveResourcePlanSelectionListSubscriptionResult = Apollo.SubscriptionResult<LiveResourcePlanSelectionListSubscription>;
export const SignSelectionMapEntitiesDocument = gql`
    query SignSelectionMapEntities($filters: [FilterInput!]!) {
  signMapEntities(filters: $filters)
}
    `;

/**
 * __useSignSelectionMapEntitiesQuery__
 *
 * To run a query within a React component, call `useSignSelectionMapEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignSelectionMapEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignSelectionMapEntitiesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSignSelectionMapEntitiesQuery(baseOptions: Apollo.QueryHookOptions<SignSelectionMapEntitiesQuery, SignSelectionMapEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignSelectionMapEntitiesQuery, SignSelectionMapEntitiesQueryVariables>(SignSelectionMapEntitiesDocument, options);
      }
export function useSignSelectionMapEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignSelectionMapEntitiesQuery, SignSelectionMapEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignSelectionMapEntitiesQuery, SignSelectionMapEntitiesQueryVariables>(SignSelectionMapEntitiesDocument, options);
        }
export type SignSelectionMapEntitiesQueryHookResult = ReturnType<typeof useSignSelectionMapEntitiesQuery>;
export type SignSelectionMapEntitiesLazyQueryHookResult = ReturnType<typeof useSignSelectionMapEntitiesLazyQuery>;
export type SignSelectionMapEntitiesQueryResult = Apollo.QueryResult<SignSelectionMapEntitiesQuery, SignSelectionMapEntitiesQueryVariables>;
export function refetchSignSelectionMapEntitiesQuery(variables: SignSelectionMapEntitiesQueryVariables) {
      return { query: SignSelectionMapEntitiesDocument, variables: variables }
    }
export const TravelTimeSelectionListDocument = gql`
    query TravelTimeSelectionList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  travelTimes(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        parts {
          startReference
          endReference
          direction
          road
        }
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTravelTimeSelectionListQuery__
 *
 * To run a query within a React component, call `useTravelTimeSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTravelTimeSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<TravelTimeSelectionListQuery, TravelTimeSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeSelectionListQuery, TravelTimeSelectionListQueryVariables>(TravelTimeSelectionListDocument, options);
      }
export function useTravelTimeSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeSelectionListQuery, TravelTimeSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeSelectionListQuery, TravelTimeSelectionListQueryVariables>(TravelTimeSelectionListDocument, options);
        }
export type TravelTimeSelectionListQueryHookResult = ReturnType<typeof useTravelTimeSelectionListQuery>;
export type TravelTimeSelectionListLazyQueryHookResult = ReturnType<typeof useTravelTimeSelectionListLazyQuery>;
export type TravelTimeSelectionListQueryResult = Apollo.QueryResult<TravelTimeSelectionListQuery, TravelTimeSelectionListQueryVariables>;
export function refetchTravelTimeSelectionListQuery(variables?: TravelTimeSelectionListQueryVariables) {
      return { query: TravelTimeSelectionListDocument, variables: variables }
    }
export const WeatherStationSelectionListDocument = gql`
    query WeatherStationSelectionList($sortField: WeatherStationSortField = NAME, $sortOrder: SortOrder = ASCENDING, $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  weatherStations(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        referencePoint
        direction
        road
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useWeatherStationSelectionListQuery__
 *
 * To run a query within a React component, call `useWeatherStationSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationSelectionListQuery({
 *   variables: {
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWeatherStationSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<WeatherStationSelectionListQuery, WeatherStationSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationSelectionListQuery, WeatherStationSelectionListQueryVariables>(WeatherStationSelectionListDocument, options);
      }
export function useWeatherStationSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationSelectionListQuery, WeatherStationSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationSelectionListQuery, WeatherStationSelectionListQueryVariables>(WeatherStationSelectionListDocument, options);
        }
export type WeatherStationSelectionListQueryHookResult = ReturnType<typeof useWeatherStationSelectionListQuery>;
export type WeatherStationSelectionListLazyQueryHookResult = ReturnType<typeof useWeatherStationSelectionListLazyQuery>;
export type WeatherStationSelectionListQueryResult = Apollo.QueryResult<WeatherStationSelectionListQuery, WeatherStationSelectionListQueryVariables>;
export function refetchWeatherStationSelectionListQuery(variables?: WeatherStationSelectionListQueryVariables) {
      return { query: WeatherStationSelectionListDocument, variables: variables }
    }
export const SaveAlarmConfigDocument = gql`
    mutation SaveAlarmConfig($input: AlarmConfigInput!) {
  saveAlarmConfig(input: $input) {
    ...AlarmConfigFragment
  }
}
    ${AlarmConfigFragmentFragmentDoc}`;
export type SaveAlarmConfigMutationFn = Apollo.MutationFunction<SaveAlarmConfigMutation, SaveAlarmConfigMutationVariables>;

/**
 * __useSaveAlarmConfigMutation__
 *
 * To run a mutation, you first call `useSaveAlarmConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAlarmConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAlarmConfigMutation, { data, loading, error }] = useSaveAlarmConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAlarmConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveAlarmConfigMutation, SaveAlarmConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAlarmConfigMutation, SaveAlarmConfigMutationVariables>(SaveAlarmConfigDocument, options);
      }
export type SaveAlarmConfigMutationHookResult = ReturnType<typeof useSaveAlarmConfigMutation>;
export type SaveAlarmConfigMutationResult = Apollo.MutationResult<SaveAlarmConfigMutation>;
export type SaveAlarmConfigMutationOptions = Apollo.BaseMutationOptions<SaveAlarmConfigMutation, SaveAlarmConfigMutationVariables>;
export const SaveAlarmConfigsDocument = gql`
    mutation SaveAlarmConfigs($input: [AlarmConfigInput!]!) {
  saveAlarmConfigs(input: $input) {
    ...AlarmConfigFragment
  }
}
    ${AlarmConfigFragmentFragmentDoc}`;
export type SaveAlarmConfigsMutationFn = Apollo.MutationFunction<SaveAlarmConfigsMutation, SaveAlarmConfigsMutationVariables>;

/**
 * __useSaveAlarmConfigsMutation__
 *
 * To run a mutation, you first call `useSaveAlarmConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAlarmConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAlarmConfigsMutation, { data, loading, error }] = useSaveAlarmConfigsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAlarmConfigsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAlarmConfigsMutation, SaveAlarmConfigsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAlarmConfigsMutation, SaveAlarmConfigsMutationVariables>(SaveAlarmConfigsDocument, options);
      }
export type SaveAlarmConfigsMutationHookResult = ReturnType<typeof useSaveAlarmConfigsMutation>;
export type SaveAlarmConfigsMutationResult = Apollo.MutationResult<SaveAlarmConfigsMutation>;
export type SaveAlarmConfigsMutationOptions = Apollo.BaseMutationOptions<SaveAlarmConfigsMutation, SaveAlarmConfigsMutationVariables>;
export const DeleteAlarmConfigDocument = gql`
    mutation DeleteAlarmConfig($id: ID!) {
  deleteAlarmConfig(id: $id)
}
    `;
export type DeleteAlarmConfigMutationFn = Apollo.MutationFunction<DeleteAlarmConfigMutation, DeleteAlarmConfigMutationVariables>;

/**
 * __useDeleteAlarmConfigMutation__
 *
 * To run a mutation, you first call `useDeleteAlarmConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlarmConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlarmConfigMutation, { data, loading, error }] = useDeleteAlarmConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlarmConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlarmConfigMutation, DeleteAlarmConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlarmConfigMutation, DeleteAlarmConfigMutationVariables>(DeleteAlarmConfigDocument, options);
      }
export type DeleteAlarmConfigMutationHookResult = ReturnType<typeof useDeleteAlarmConfigMutation>;
export type DeleteAlarmConfigMutationResult = Apollo.MutationResult<DeleteAlarmConfigMutation>;
export type DeleteAlarmConfigMutationOptions = Apollo.BaseMutationOptions<DeleteAlarmConfigMutation, DeleteAlarmConfigMutationVariables>;
export const SaveMibAlarmConfigDocument = gql`
    mutation SaveMibAlarmConfig($input: MibAlarmConfigInput!) {
  saveMibAlarmConfig(input: $input) {
    id
  }
}
    `;
export type SaveMibAlarmConfigMutationFn = Apollo.MutationFunction<SaveMibAlarmConfigMutation, SaveMibAlarmConfigMutationVariables>;

/**
 * __useSaveMibAlarmConfigMutation__
 *
 * To run a mutation, you first call `useSaveMibAlarmConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMibAlarmConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMibAlarmConfigMutation, { data, loading, error }] = useSaveMibAlarmConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMibAlarmConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveMibAlarmConfigMutation, SaveMibAlarmConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMibAlarmConfigMutation, SaveMibAlarmConfigMutationVariables>(SaveMibAlarmConfigDocument, options);
      }
export type SaveMibAlarmConfigMutationHookResult = ReturnType<typeof useSaveMibAlarmConfigMutation>;
export type SaveMibAlarmConfigMutationResult = Apollo.MutationResult<SaveMibAlarmConfigMutation>;
export type SaveMibAlarmConfigMutationOptions = Apollo.BaseMutationOptions<SaveMibAlarmConfigMutation, SaveMibAlarmConfigMutationVariables>;
export const DeleteMibAlarmConfigsDocument = gql`
    mutation DeleteMibAlarmConfigs($ids: [ID!]!) {
  deleteMibAlarmConfigs(ids: $ids)
}
    `;
export type DeleteMibAlarmConfigsMutationFn = Apollo.MutationFunction<DeleteMibAlarmConfigsMutation, DeleteMibAlarmConfigsMutationVariables>;

/**
 * __useDeleteMibAlarmConfigsMutation__
 *
 * To run a mutation, you first call `useDeleteMibAlarmConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMibAlarmConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMibAlarmConfigsMutation, { data, loading, error }] = useDeleteMibAlarmConfigsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteMibAlarmConfigsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMibAlarmConfigsMutation, DeleteMibAlarmConfigsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMibAlarmConfigsMutation, DeleteMibAlarmConfigsMutationVariables>(DeleteMibAlarmConfigsDocument, options);
      }
export type DeleteMibAlarmConfigsMutationHookResult = ReturnType<typeof useDeleteMibAlarmConfigsMutation>;
export type DeleteMibAlarmConfigsMutationResult = Apollo.MutationResult<DeleteMibAlarmConfigsMutation>;
export type DeleteMibAlarmConfigsMutationOptions = Apollo.BaseMutationOptions<DeleteMibAlarmConfigsMutation, DeleteMibAlarmConfigsMutationVariables>;
export const GetAlarmConfigDocument = gql`
    query GetAlarmConfig($id: ID!) {
  alarmConfig(id: $id) {
    ...AlarmConfigFragment
  }
}
    ${AlarmConfigFragmentFragmentDoc}`;

/**
 * __useGetAlarmConfigQuery__
 *
 * To run a query within a React component, call `useGetAlarmConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAlarmConfigQuery(baseOptions: Apollo.QueryHookOptions<GetAlarmConfigQuery, GetAlarmConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlarmConfigQuery, GetAlarmConfigQueryVariables>(GetAlarmConfigDocument, options);
      }
export function useGetAlarmConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlarmConfigQuery, GetAlarmConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlarmConfigQuery, GetAlarmConfigQueryVariables>(GetAlarmConfigDocument, options);
        }
export type GetAlarmConfigQueryHookResult = ReturnType<typeof useGetAlarmConfigQuery>;
export type GetAlarmConfigLazyQueryHookResult = ReturnType<typeof useGetAlarmConfigLazyQuery>;
export type GetAlarmConfigQueryResult = Apollo.QueryResult<GetAlarmConfigQuery, GetAlarmConfigQueryVariables>;
export function refetchGetAlarmConfigQuery(variables: GetAlarmConfigQueryVariables) {
      return { query: GetAlarmConfigDocument, variables: variables }
    }
export const AlarmConfigsForEntityDocument = gql`
    query AlarmConfigsForEntity($source: KineticModule!, $entityType: AlarmEntityType!, $entityId: ID!) {
  alarmConfigsForEntity(
    source: $source
    entityType: $entityType
    entityId: $entityId
  ) {
    ...AlarmConfigFragment
  }
}
    ${AlarmConfigFragmentFragmentDoc}`;

/**
 * __useAlarmConfigsForEntityQuery__
 *
 * To run a query within a React component, call `useAlarmConfigsForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlarmConfigsForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlarmConfigsForEntityQuery({
 *   variables: {
 *      source: // value for 'source'
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useAlarmConfigsForEntityQuery(baseOptions: Apollo.QueryHookOptions<AlarmConfigsForEntityQuery, AlarmConfigsForEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlarmConfigsForEntityQuery, AlarmConfigsForEntityQueryVariables>(AlarmConfigsForEntityDocument, options);
      }
export function useAlarmConfigsForEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlarmConfigsForEntityQuery, AlarmConfigsForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlarmConfigsForEntityQuery, AlarmConfigsForEntityQueryVariables>(AlarmConfigsForEntityDocument, options);
        }
export type AlarmConfigsForEntityQueryHookResult = ReturnType<typeof useAlarmConfigsForEntityQuery>;
export type AlarmConfigsForEntityLazyQueryHookResult = ReturnType<typeof useAlarmConfigsForEntityLazyQuery>;
export type AlarmConfigsForEntityQueryResult = Apollo.QueryResult<AlarmConfigsForEntityQuery, AlarmConfigsForEntityQueryVariables>;
export function refetchAlarmConfigsForEntityQuery(variables: AlarmConfigsForEntityQueryVariables) {
      return { query: AlarmConfigsForEntityDocument, variables: variables }
    }
export const AlarmIntersectionNamesDocument = gql`
    query AlarmIntersectionNames {
  intersections(limit: 100000) {
    edges {
      node {
        id
        details {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAlarmIntersectionNamesQuery__
 *
 * To run a query within a React component, call `useAlarmIntersectionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlarmIntersectionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlarmIntersectionNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlarmIntersectionNamesQuery(baseOptions?: Apollo.QueryHookOptions<AlarmIntersectionNamesQuery, AlarmIntersectionNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlarmIntersectionNamesQuery, AlarmIntersectionNamesQueryVariables>(AlarmIntersectionNamesDocument, options);
      }
export function useAlarmIntersectionNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlarmIntersectionNamesQuery, AlarmIntersectionNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlarmIntersectionNamesQuery, AlarmIntersectionNamesQueryVariables>(AlarmIntersectionNamesDocument, options);
        }
export type AlarmIntersectionNamesQueryHookResult = ReturnType<typeof useAlarmIntersectionNamesQuery>;
export type AlarmIntersectionNamesLazyQueryHookResult = ReturnType<typeof useAlarmIntersectionNamesLazyQuery>;
export type AlarmIntersectionNamesQueryResult = Apollo.QueryResult<AlarmIntersectionNamesQuery, AlarmIntersectionNamesQueryVariables>;
export function refetchAlarmIntersectionNamesQuery(variables?: AlarmIntersectionNamesQueryVariables) {
      return { query: AlarmIntersectionNamesDocument, variables: variables }
    }
export const IntersectionAlarmConfigsDocument = gql`
    query IntersectionAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "SIGNALS"}, {field: "entityType", operator: EQUALS, value: "INTERSECTION"}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useIntersectionAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useIntersectionAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionAlarmConfigsQuery, IntersectionAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionAlarmConfigsQuery, IntersectionAlarmConfigsQueryVariables>(IntersectionAlarmConfigsDocument, options);
      }
export function useIntersectionAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionAlarmConfigsQuery, IntersectionAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionAlarmConfigsQuery, IntersectionAlarmConfigsQueryVariables>(IntersectionAlarmConfigsDocument, options);
        }
export type IntersectionAlarmConfigsQueryHookResult = ReturnType<typeof useIntersectionAlarmConfigsQuery>;
export type IntersectionAlarmConfigsLazyQueryHookResult = ReturnType<typeof useIntersectionAlarmConfigsLazyQuery>;
export type IntersectionAlarmConfigsQueryResult = Apollo.QueryResult<IntersectionAlarmConfigsQuery, IntersectionAlarmConfigsQueryVariables>;
export function refetchIntersectionAlarmConfigsQuery(variables?: IntersectionAlarmConfigsQueryVariables) {
      return { query: IntersectionAlarmConfigsDocument, variables: variables }
    }
export const SearchAlarmConfigsDocument = gql`
    query SearchAlarmConfigs($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 100, $before: String, $after: String, $searchFields: [String!] = ["alarmType", "name", "displayName", "alarmSeverity"]) {
  alarmConfigs(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit, searchFields: $searchFields}
  ) {
    edges {
      node {
        ...AlarmConfigFragment
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${AlarmConfigFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSearchAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useSearchAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAlarmConfigsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      searchFields: // value for 'searchFields'
 *   },
 * });
 */
export function useSearchAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<SearchAlarmConfigsQuery, SearchAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAlarmConfigsQuery, SearchAlarmConfigsQueryVariables>(SearchAlarmConfigsDocument, options);
      }
export function useSearchAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAlarmConfigsQuery, SearchAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAlarmConfigsQuery, SearchAlarmConfigsQueryVariables>(SearchAlarmConfigsDocument, options);
        }
export type SearchAlarmConfigsQueryHookResult = ReturnType<typeof useSearchAlarmConfigsQuery>;
export type SearchAlarmConfigsLazyQueryHookResult = ReturnType<typeof useSearchAlarmConfigsLazyQuery>;
export type SearchAlarmConfigsQueryResult = Apollo.QueryResult<SearchAlarmConfigsQuery, SearchAlarmConfigsQueryVariables>;
export function refetchSearchAlarmConfigsQuery(variables?: SearchAlarmConfigsQueryVariables) {
      return { query: SearchAlarmConfigsDocument, variables: variables }
    }
export const MibAlarmsConfigListDocument = gql`
    query MibAlarmsConfigList {
  mibAlarmConfigs {
    id
    index1
    index2
    bitIndex
    name
    mibName
    displayName
    value1
    value2
    comparison
  }
}
    `;

/**
 * __useMibAlarmsConfigListQuery__
 *
 * To run a query within a React component, call `useMibAlarmsConfigListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMibAlarmsConfigListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMibAlarmsConfigListQuery({
 *   variables: {
 *   },
 * });
 */
export function useMibAlarmsConfigListQuery(baseOptions?: Apollo.QueryHookOptions<MibAlarmsConfigListQuery, MibAlarmsConfigListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MibAlarmsConfigListQuery, MibAlarmsConfigListQueryVariables>(MibAlarmsConfigListDocument, options);
      }
export function useMibAlarmsConfigListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MibAlarmsConfigListQuery, MibAlarmsConfigListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MibAlarmsConfigListQuery, MibAlarmsConfigListQueryVariables>(MibAlarmsConfigListDocument, options);
        }
export type MibAlarmsConfigListQueryHookResult = ReturnType<typeof useMibAlarmsConfigListQuery>;
export type MibAlarmsConfigListLazyQueryHookResult = ReturnType<typeof useMibAlarmsConfigListLazyQuery>;
export type MibAlarmsConfigListQueryResult = Apollo.QueryResult<MibAlarmsConfigListQuery, MibAlarmsConfigListQueryVariables>;
export function refetchMibAlarmsConfigListQuery(variables?: MibAlarmsConfigListQueryVariables) {
      return { query: MibAlarmsConfigListDocument, variables: variables }
    }
export const MibAlarmConfigDocument = gql`
    query MibAlarmConfig($id: ID!) {
  mibAlarmConfig(id: $id) {
    id
    index1
    index2
    bitIndex
    name
    mibName
    displayName
    value1
    value2
    comparison
  }
}
    `;

/**
 * __useMibAlarmConfigQuery__
 *
 * To run a query within a React component, call `useMibAlarmConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useMibAlarmConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMibAlarmConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMibAlarmConfigQuery(baseOptions: Apollo.QueryHookOptions<MibAlarmConfigQuery, MibAlarmConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MibAlarmConfigQuery, MibAlarmConfigQueryVariables>(MibAlarmConfigDocument, options);
      }
export function useMibAlarmConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MibAlarmConfigQuery, MibAlarmConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MibAlarmConfigQuery, MibAlarmConfigQueryVariables>(MibAlarmConfigDocument, options);
        }
export type MibAlarmConfigQueryHookResult = ReturnType<typeof useMibAlarmConfigQuery>;
export type MibAlarmConfigLazyQueryHookResult = ReturnType<typeof useMibAlarmConfigLazyQuery>;
export type MibAlarmConfigQueryResult = Apollo.QueryResult<MibAlarmConfigQuery, MibAlarmConfigQueryVariables>;
export function refetchMibAlarmConfigQuery(variables: MibAlarmConfigQueryVariables) {
      return { query: MibAlarmConfigDocument, variables: variables }
    }
export const GetAlarmsClearedStateDocument = gql`
    query GetAlarmsClearedState($ids: Object!) {
  alarms(query: {limit: 500, filters: [{field: "id", value: $ids, operator: IN}]}) {
    edges {
      node {
        id
        clearedAt
      }
    }
  }
}
    `;

/**
 * __useGetAlarmsClearedStateQuery__
 *
 * To run a query within a React component, call `useGetAlarmsClearedStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmsClearedStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmsClearedStateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAlarmsClearedStateQuery(baseOptions: Apollo.QueryHookOptions<GetAlarmsClearedStateQuery, GetAlarmsClearedStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlarmsClearedStateQuery, GetAlarmsClearedStateQueryVariables>(GetAlarmsClearedStateDocument, options);
      }
export function useGetAlarmsClearedStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlarmsClearedStateQuery, GetAlarmsClearedStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlarmsClearedStateQuery, GetAlarmsClearedStateQueryVariables>(GetAlarmsClearedStateDocument, options);
        }
export type GetAlarmsClearedStateQueryHookResult = ReturnType<typeof useGetAlarmsClearedStateQuery>;
export type GetAlarmsClearedStateLazyQueryHookResult = ReturnType<typeof useGetAlarmsClearedStateLazyQuery>;
export type GetAlarmsClearedStateQueryResult = Apollo.QueryResult<GetAlarmsClearedStateQuery, GetAlarmsClearedStateQueryVariables>;
export function refetchGetAlarmsClearedStateQuery(variables: GetAlarmsClearedStateQueryVariables) {
      return { query: GetAlarmsClearedStateDocument, variables: variables }
    }
export const SaveDatabaseExportTemplateDocument = gql`
    mutation SaveDatabaseExportTemplate($input: DatabaseExportTemplateInput!) {
  saveDatabaseExportTemplate(input: $input) {
    id
    name
    deviceApi
    tableNames
  }
}
    `;
export type SaveDatabaseExportTemplateMutationFn = Apollo.MutationFunction<SaveDatabaseExportTemplateMutation, SaveDatabaseExportTemplateMutationVariables>;

/**
 * __useSaveDatabaseExportTemplateMutation__
 *
 * To run a mutation, you first call `useSaveDatabaseExportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDatabaseExportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDatabaseExportTemplateMutation, { data, loading, error }] = useSaveDatabaseExportTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDatabaseExportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveDatabaseExportTemplateMutation, SaveDatabaseExportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDatabaseExportTemplateMutation, SaveDatabaseExportTemplateMutationVariables>(SaveDatabaseExportTemplateDocument, options);
      }
export type SaveDatabaseExportTemplateMutationHookResult = ReturnType<typeof useSaveDatabaseExportTemplateMutation>;
export type SaveDatabaseExportTemplateMutationResult = Apollo.MutationResult<SaveDatabaseExportTemplateMutation>;
export type SaveDatabaseExportTemplateMutationOptions = Apollo.BaseMutationOptions<SaveDatabaseExportTemplateMutation, SaveDatabaseExportTemplateMutationVariables>;
export const DeleteDatabaseExportTemplateDocument = gql`
    mutation DeleteDatabaseExportTemplate($id: ID!) {
  deleteDatabaseExportTemplate(id: $id)
}
    `;
export type DeleteDatabaseExportTemplateMutationFn = Apollo.MutationFunction<DeleteDatabaseExportTemplateMutation, DeleteDatabaseExportTemplateMutationVariables>;

/**
 * __useDeleteDatabaseExportTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteDatabaseExportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDatabaseExportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDatabaseExportTemplateMutation, { data, loading, error }] = useDeleteDatabaseExportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDatabaseExportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDatabaseExportTemplateMutation, DeleteDatabaseExportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDatabaseExportTemplateMutation, DeleteDatabaseExportTemplateMutationVariables>(DeleteDatabaseExportTemplateDocument, options);
      }
export type DeleteDatabaseExportTemplateMutationHookResult = ReturnType<typeof useDeleteDatabaseExportTemplateMutation>;
export type DeleteDatabaseExportTemplateMutationResult = Apollo.MutationResult<DeleteDatabaseExportTemplateMutation>;
export type DeleteDatabaseExportTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteDatabaseExportTemplateMutation, DeleteDatabaseExportTemplateMutationVariables>;
export const DatabaseExportTemplatesListDocument = gql`
    query DatabaseExportTemplatesList($deviceApi: DeviceViewsProtocolEntityEnum) {
  databaseExportTemplates(deviceApi: $deviceApi) {
    id
    name
    deviceApi
  }
}
    `;

/**
 * __useDatabaseExportTemplatesListQuery__
 *
 * To run a query within a React component, call `useDatabaseExportTemplatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatabaseExportTemplatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatabaseExportTemplatesListQuery({
 *   variables: {
 *      deviceApi: // value for 'deviceApi'
 *   },
 * });
 */
export function useDatabaseExportTemplatesListQuery(baseOptions?: Apollo.QueryHookOptions<DatabaseExportTemplatesListQuery, DatabaseExportTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatabaseExportTemplatesListQuery, DatabaseExportTemplatesListQueryVariables>(DatabaseExportTemplatesListDocument, options);
      }
export function useDatabaseExportTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatabaseExportTemplatesListQuery, DatabaseExportTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatabaseExportTemplatesListQuery, DatabaseExportTemplatesListQueryVariables>(DatabaseExportTemplatesListDocument, options);
        }
export type DatabaseExportTemplatesListQueryHookResult = ReturnType<typeof useDatabaseExportTemplatesListQuery>;
export type DatabaseExportTemplatesListLazyQueryHookResult = ReturnType<typeof useDatabaseExportTemplatesListLazyQuery>;
export type DatabaseExportTemplatesListQueryResult = Apollo.QueryResult<DatabaseExportTemplatesListQuery, DatabaseExportTemplatesListQueryVariables>;
export function refetchDatabaseExportTemplatesListQuery(variables?: DatabaseExportTemplatesListQueryVariables) {
      return { query: DatabaseExportTemplatesListDocument, variables: variables }
    }
export const ViewDatabaseExportTemplateDocument = gql`
    query ViewDatabaseExportTemplate($id: ID!) {
  databaseExportTemplate(id: $id) {
    id
    name
    deviceApi
    tableNames
  }
}
    `;

/**
 * __useViewDatabaseExportTemplateQuery__
 *
 * To run a query within a React component, call `useViewDatabaseExportTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewDatabaseExportTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewDatabaseExportTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewDatabaseExportTemplateQuery(baseOptions: Apollo.QueryHookOptions<ViewDatabaseExportTemplateQuery, ViewDatabaseExportTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewDatabaseExportTemplateQuery, ViewDatabaseExportTemplateQueryVariables>(ViewDatabaseExportTemplateDocument, options);
      }
export function useViewDatabaseExportTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewDatabaseExportTemplateQuery, ViewDatabaseExportTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewDatabaseExportTemplateQuery, ViewDatabaseExportTemplateQueryVariables>(ViewDatabaseExportTemplateDocument, options);
        }
export type ViewDatabaseExportTemplateQueryHookResult = ReturnType<typeof useViewDatabaseExportTemplateQuery>;
export type ViewDatabaseExportTemplateLazyQueryHookResult = ReturnType<typeof useViewDatabaseExportTemplateLazyQuery>;
export type ViewDatabaseExportTemplateQueryResult = Apollo.QueryResult<ViewDatabaseExportTemplateQuery, ViewDatabaseExportTemplateQueryVariables>;
export function refetchViewDatabaseExportTemplateQuery(variables: ViewDatabaseExportTemplateQueryVariables) {
      return { query: ViewDatabaseExportTemplateDocument, variables: variables }
    }
export const GetDatabaseExportTableNamesDocument = gql`
    query GetDatabaseExportTableNames($deviceApi: DeviceViewsProtocolEntityEnum!) {
  deviceViews(id: $deviceApi) {
    id
    views {
      ...viewFragment
      views {
        ...viewFragment
        views {
          ...viewFragment
          views {
            ...viewFragment
            views {
              ...viewFragment
              views {
                ...viewFragment
                views {
                  ...viewFragment
                  views {
                    ...viewFragment
                    views {
                      ...viewFragment
                      views {
                        ...viewFragment
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ViewFragmentFragmentDoc}`;

/**
 * __useGetDatabaseExportTableNamesQuery__
 *
 * To run a query within a React component, call `useGetDatabaseExportTableNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatabaseExportTableNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatabaseExportTableNamesQuery({
 *   variables: {
 *      deviceApi: // value for 'deviceApi'
 *   },
 * });
 */
export function useGetDatabaseExportTableNamesQuery(baseOptions: Apollo.QueryHookOptions<GetDatabaseExportTableNamesQuery, GetDatabaseExportTableNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatabaseExportTableNamesQuery, GetDatabaseExportTableNamesQueryVariables>(GetDatabaseExportTableNamesDocument, options);
      }
export function useGetDatabaseExportTableNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatabaseExportTableNamesQuery, GetDatabaseExportTableNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatabaseExportTableNamesQuery, GetDatabaseExportTableNamesQueryVariables>(GetDatabaseExportTableNamesDocument, options);
        }
export type GetDatabaseExportTableNamesQueryHookResult = ReturnType<typeof useGetDatabaseExportTableNamesQuery>;
export type GetDatabaseExportTableNamesLazyQueryHookResult = ReturnType<typeof useGetDatabaseExportTableNamesLazyQuery>;
export type GetDatabaseExportTableNamesQueryResult = Apollo.QueryResult<GetDatabaseExportTableNamesQuery, GetDatabaseExportTableNamesQueryVariables>;
export function refetchGetDatabaseExportTableNamesQuery(variables: GetDatabaseExportTableNamesQueryVariables) {
      return { query: GetDatabaseExportTableNamesDocument, variables: variables }
    }
export const GetDatabaseProtocolDocument = gql`
    query GetDatabaseProtocol($databaseId: ID!, $intersectionId: ID!) {
  deviceDatabase(id: $databaseId, intersectionId: $intersectionId) {
    id
    protocol
  }
  intersection(id: $intersectionId) {
    id
    devices {
      id
      fieldEntityProtocol
    }
  }
}
    `;

/**
 * __useGetDatabaseProtocolQuery__
 *
 * To run a query within a React component, call `useGetDatabaseProtocolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatabaseProtocolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatabaseProtocolQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useGetDatabaseProtocolQuery(baseOptions: Apollo.QueryHookOptions<GetDatabaseProtocolQuery, GetDatabaseProtocolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatabaseProtocolQuery, GetDatabaseProtocolQueryVariables>(GetDatabaseProtocolDocument, options);
      }
export function useGetDatabaseProtocolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatabaseProtocolQuery, GetDatabaseProtocolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatabaseProtocolQuery, GetDatabaseProtocolQueryVariables>(GetDatabaseProtocolDocument, options);
        }
export type GetDatabaseProtocolQueryHookResult = ReturnType<typeof useGetDatabaseProtocolQuery>;
export type GetDatabaseProtocolLazyQueryHookResult = ReturnType<typeof useGetDatabaseProtocolLazyQuery>;
export type GetDatabaseProtocolQueryResult = Apollo.QueryResult<GetDatabaseProtocolQuery, GetDatabaseProtocolQueryVariables>;
export function refetchGetDatabaseProtocolQuery(variables: GetDatabaseProtocolQueryVariables) {
      return { query: GetDatabaseProtocolDocument, variables: variables }
    }
export const SynchroExportDocument = gql`
    mutation SynchroExport($format: SynchroExportFormat!, $databasePatterns: [DatabasePatternIdExport!]!, $filename: String!, $from: DateTime!, $to: DateTime) {
  synchroExport(
    format: $format
    databasePatterns: $databasePatterns
    filename: $filename
    from: $from
    to: $to
  )
}
    `;
export type SynchroExportMutationFn = Apollo.MutationFunction<SynchroExportMutation, SynchroExportMutationVariables>;

/**
 * __useSynchroExportMutation__
 *
 * To run a mutation, you first call `useSynchroExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSynchroExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [synchroExportMutation, { data, loading, error }] = useSynchroExportMutation({
 *   variables: {
 *      format: // value for 'format'
 *      databasePatterns: // value for 'databasePatterns'
 *      filename: // value for 'filename'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSynchroExportMutation(baseOptions?: Apollo.MutationHookOptions<SynchroExportMutation, SynchroExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SynchroExportMutation, SynchroExportMutationVariables>(SynchroExportDocument, options);
      }
export type SynchroExportMutationHookResult = ReturnType<typeof useSynchroExportMutation>;
export type SynchroExportMutationResult = Apollo.MutationResult<SynchroExportMutation>;
export type SynchroExportMutationOptions = Apollo.BaseMutationOptions<SynchroExportMutation, SynchroExportMutationVariables>;
export const SynchroIntersectionDocument = gql`
    query synchroIntersection($intersectionId: ID!) {
  intersection(id: $intersectionId) {
    id
    details {
      name
    }
    devices {
      id
      name
      fieldEntityProtocol
    }
  }
}
    `;

/**
 * __useSynchroIntersectionQuery__
 *
 * To run a query within a React component, call `useSynchroIntersectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSynchroIntersectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSynchroIntersectionQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useSynchroIntersectionQuery(baseOptions: Apollo.QueryHookOptions<SynchroIntersectionQuery, SynchroIntersectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SynchroIntersectionQuery, SynchroIntersectionQueryVariables>(SynchroIntersectionDocument, options);
      }
export function useSynchroIntersectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SynchroIntersectionQuery, SynchroIntersectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SynchroIntersectionQuery, SynchroIntersectionQueryVariables>(SynchroIntersectionDocument, options);
        }
export type SynchroIntersectionQueryHookResult = ReturnType<typeof useSynchroIntersectionQuery>;
export type SynchroIntersectionLazyQueryHookResult = ReturnType<typeof useSynchroIntersectionLazyQuery>;
export type SynchroIntersectionQueryResult = Apollo.QueryResult<SynchroIntersectionQuery, SynchroIntersectionQueryVariables>;
export function refetchSynchroIntersectionQuery(variables: SynchroIntersectionQueryVariables) {
      return { query: SynchroIntersectionDocument, variables: variables }
    }
export const SynchroDeviceDatabasesDocument = gql`
    query synchroDeviceDatabases($intersectionId: String!) {
  deviceDatabases(
    intersectionId: $intersectionId
    filters: [{operator: NOT_EQUALS, field: "type", value: DRAFT}, {operator: EQUALS, field: "archived", value: false}]
    limit: 10000
  ) {
    edges {
      cursor
      node {
        id
        intersectionId
        comment
        start
        type
      }
      __typename
    }
  }
}
    `;

/**
 * __useSynchroDeviceDatabasesQuery__
 *
 * To run a query within a React component, call `useSynchroDeviceDatabasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSynchroDeviceDatabasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSynchroDeviceDatabasesQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useSynchroDeviceDatabasesQuery(baseOptions: Apollo.QueryHookOptions<SynchroDeviceDatabasesQuery, SynchroDeviceDatabasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SynchroDeviceDatabasesQuery, SynchroDeviceDatabasesQueryVariables>(SynchroDeviceDatabasesDocument, options);
      }
export function useSynchroDeviceDatabasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SynchroDeviceDatabasesQuery, SynchroDeviceDatabasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SynchroDeviceDatabasesQuery, SynchroDeviceDatabasesQueryVariables>(SynchroDeviceDatabasesDocument, options);
        }
export type SynchroDeviceDatabasesQueryHookResult = ReturnType<typeof useSynchroDeviceDatabasesQuery>;
export type SynchroDeviceDatabasesLazyQueryHookResult = ReturnType<typeof useSynchroDeviceDatabasesLazyQuery>;
export type SynchroDeviceDatabasesQueryResult = Apollo.QueryResult<SynchroDeviceDatabasesQuery, SynchroDeviceDatabasesQueryVariables>;
export function refetchSynchroDeviceDatabasesQuery(variables: SynchroDeviceDatabasesQueryVariables) {
      return { query: SynchroDeviceDatabasesDocument, variables: variables }
    }
export const CancelDeviceDatabaseActionDocument = gql`
    mutation CancelDeviceDatabaseAction($databaseId: ID!, $intersectionId: ID!) {
  cancelDeviceDatabaseAction(
    databaseId: $databaseId
    intersectionId: $intersectionId
  )
}
    `;
export type CancelDeviceDatabaseActionMutationFn = Apollo.MutationFunction<CancelDeviceDatabaseActionMutation, CancelDeviceDatabaseActionMutationVariables>;

/**
 * __useCancelDeviceDatabaseActionMutation__
 *
 * To run a mutation, you first call `useCancelDeviceDatabaseActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDeviceDatabaseActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDeviceDatabaseActionMutation, { data, loading, error }] = useCancelDeviceDatabaseActionMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useCancelDeviceDatabaseActionMutation(baseOptions?: Apollo.MutationHookOptions<CancelDeviceDatabaseActionMutation, CancelDeviceDatabaseActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDeviceDatabaseActionMutation, CancelDeviceDatabaseActionMutationVariables>(CancelDeviceDatabaseActionDocument, options);
      }
export type CancelDeviceDatabaseActionMutationHookResult = ReturnType<typeof useCancelDeviceDatabaseActionMutation>;
export type CancelDeviceDatabaseActionMutationResult = Apollo.MutationResult<CancelDeviceDatabaseActionMutation>;
export type CancelDeviceDatabaseActionMutationOptions = Apollo.BaseMutationOptions<CancelDeviceDatabaseActionMutation, CancelDeviceDatabaseActionMutationVariables>;
export const HasActiveDatabaseActionDocument = gql`
    query HasActiveDatabaseAction($intersectionId: ID!) {
  hasActiveDatabaseAction(intersectionId: $intersectionId)
}
    `;

/**
 * __useHasActiveDatabaseActionQuery__
 *
 * To run a query within a React component, call `useHasActiveDatabaseActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasActiveDatabaseActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasActiveDatabaseActionQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useHasActiveDatabaseActionQuery(baseOptions: Apollo.QueryHookOptions<HasActiveDatabaseActionQuery, HasActiveDatabaseActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasActiveDatabaseActionQuery, HasActiveDatabaseActionQueryVariables>(HasActiveDatabaseActionDocument, options);
      }
export function useHasActiveDatabaseActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasActiveDatabaseActionQuery, HasActiveDatabaseActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasActiveDatabaseActionQuery, HasActiveDatabaseActionQueryVariables>(HasActiveDatabaseActionDocument, options);
        }
export type HasActiveDatabaseActionQueryHookResult = ReturnType<typeof useHasActiveDatabaseActionQuery>;
export type HasActiveDatabaseActionLazyQueryHookResult = ReturnType<typeof useHasActiveDatabaseActionLazyQuery>;
export type HasActiveDatabaseActionQueryResult = Apollo.QueryResult<HasActiveDatabaseActionQuery, HasActiveDatabaseActionQueryVariables>;
export function refetchHasActiveDatabaseActionQuery(variables: HasActiveDatabaseActionQueryVariables) {
      return { query: HasActiveDatabaseActionDocument, variables: variables }
    }
export const IntersectionDatabaseActionUpdatedDocument = gql`
    subscription IntersectionDatabaseActionUpdated($intersectionIds: [ID!]) {
  intersectionDatabaseActionUpdated(intersectionIds: $intersectionIds) {
    intersectionId
    hasActiveDatabaseAction
  }
}
    `;

/**
 * __useIntersectionDatabaseActionUpdatedSubscription__
 *
 * To run a query within a React component, call `useIntersectionDatabaseActionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionDatabaseActionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionDatabaseActionUpdatedSubscription({
 *   variables: {
 *      intersectionIds: // value for 'intersectionIds'
 *   },
 * });
 */
export function useIntersectionDatabaseActionUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IntersectionDatabaseActionUpdatedSubscription, IntersectionDatabaseActionUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IntersectionDatabaseActionUpdatedSubscription, IntersectionDatabaseActionUpdatedSubscriptionVariables>(IntersectionDatabaseActionUpdatedDocument, options);
      }
export type IntersectionDatabaseActionUpdatedSubscriptionHookResult = ReturnType<typeof useIntersectionDatabaseActionUpdatedSubscription>;
export type IntersectionDatabaseActionUpdatedSubscriptionResult = Apollo.SubscriptionResult<IntersectionDatabaseActionUpdatedSubscription>;
export const DeviceDatabaseMibChangeLogsDocument = gql`
    query DeviceDatabaseMibChangeLogs($after: String, $before: String, $limit: Int, $sortField: String, $sortOrder: SortOrder, $searchText: String, $searchFields: [String!], $filters: [FilterInput!], $intersectionId: String) {
  deviceDatabaseMibChangeLogs(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
    searchFields: $searchFields
    filters: $filters
    intersectionId: $intersectionId
  ) {
    edges {
      node {
        ...DeviceDatabaseMibChangeLogFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DeviceDatabaseMibChangeLogFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useDeviceDatabaseMibChangeLogsQuery__
 *
 * To run a query within a React component, call `useDeviceDatabaseMibChangeLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceDatabaseMibChangeLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceDatabaseMibChangeLogsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useDeviceDatabaseMibChangeLogsQuery(baseOptions?: Apollo.QueryHookOptions<DeviceDatabaseMibChangeLogsQuery, DeviceDatabaseMibChangeLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceDatabaseMibChangeLogsQuery, DeviceDatabaseMibChangeLogsQueryVariables>(DeviceDatabaseMibChangeLogsDocument, options);
      }
export function useDeviceDatabaseMibChangeLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceDatabaseMibChangeLogsQuery, DeviceDatabaseMibChangeLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceDatabaseMibChangeLogsQuery, DeviceDatabaseMibChangeLogsQueryVariables>(DeviceDatabaseMibChangeLogsDocument, options);
        }
export type DeviceDatabaseMibChangeLogsQueryHookResult = ReturnType<typeof useDeviceDatabaseMibChangeLogsQuery>;
export type DeviceDatabaseMibChangeLogsLazyQueryHookResult = ReturnType<typeof useDeviceDatabaseMibChangeLogsLazyQuery>;
export type DeviceDatabaseMibChangeLogsQueryResult = Apollo.QueryResult<DeviceDatabaseMibChangeLogsQuery, DeviceDatabaseMibChangeLogsQueryVariables>;
export function refetchDeviceDatabaseMibChangeLogsQuery(variables?: DeviceDatabaseMibChangeLogsQueryVariables) {
      return { query: DeviceDatabaseMibChangeLogsDocument, variables: variables }
    }
export const IntersectionMibListsDocument = gql`
    query IntersectionMibLists($intersectionId: String!) {
  intersectionMibLists(intersectionId: $intersectionId) {
    name
    shortName
  }
}
    `;

/**
 * __useIntersectionMibListsQuery__
 *
 * To run a query within a React component, call `useIntersectionMibListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionMibListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionMibListsQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useIntersectionMibListsQuery(baseOptions: Apollo.QueryHookOptions<IntersectionMibListsQuery, IntersectionMibListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionMibListsQuery, IntersectionMibListsQueryVariables>(IntersectionMibListsDocument, options);
      }
export function useIntersectionMibListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionMibListsQuery, IntersectionMibListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionMibListsQuery, IntersectionMibListsQueryVariables>(IntersectionMibListsDocument, options);
        }
export type IntersectionMibListsQueryHookResult = ReturnType<typeof useIntersectionMibListsQuery>;
export type IntersectionMibListsLazyQueryHookResult = ReturnType<typeof useIntersectionMibListsLazyQuery>;
export type IntersectionMibListsQueryResult = Apollo.QueryResult<IntersectionMibListsQuery, IntersectionMibListsQueryVariables>;
export function refetchIntersectionMibListsQuery(variables: IntersectionMibListsQueryVariables) {
      return { query: IntersectionMibListsDocument, variables: variables }
    }
export const LockDatabaseDocument = gql`
    mutation LockDatabase($databaseId: String!, $intersectionId: String!) {
  lockDatabase(databaseId: $databaseId, intersectionId: $intersectionId)
}
    `;
export type LockDatabaseMutationFn = Apollo.MutationFunction<LockDatabaseMutation, LockDatabaseMutationVariables>;

/**
 * __useLockDatabaseMutation__
 *
 * To run a mutation, you first call `useLockDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockDatabaseMutation, { data, loading, error }] = useLockDatabaseMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useLockDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<LockDatabaseMutation, LockDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockDatabaseMutation, LockDatabaseMutationVariables>(LockDatabaseDocument, options);
      }
export type LockDatabaseMutationHookResult = ReturnType<typeof useLockDatabaseMutation>;
export type LockDatabaseMutationResult = Apollo.MutationResult<LockDatabaseMutation>;
export type LockDatabaseMutationOptions = Apollo.BaseMutationOptions<LockDatabaseMutation, LockDatabaseMutationVariables>;
export const UnlockDatabaseDocument = gql`
    mutation UnlockDatabase($databaseId: String!, $intersectionId: String!) {
  unlockDatabase(databaseId: $databaseId, intersectionId: $intersectionId)
}
    `;
export type UnlockDatabaseMutationFn = Apollo.MutationFunction<UnlockDatabaseMutation, UnlockDatabaseMutationVariables>;

/**
 * __useUnlockDatabaseMutation__
 *
 * To run a mutation, you first call `useUnlockDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockDatabaseMutation, { data, loading, error }] = useUnlockDatabaseMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useUnlockDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<UnlockDatabaseMutation, UnlockDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockDatabaseMutation, UnlockDatabaseMutationVariables>(UnlockDatabaseDocument, options);
      }
export type UnlockDatabaseMutationHookResult = ReturnType<typeof useUnlockDatabaseMutation>;
export type UnlockDatabaseMutationResult = Apollo.MutationResult<UnlockDatabaseMutation>;
export type UnlockDatabaseMutationOptions = Apollo.BaseMutationOptions<UnlockDatabaseMutation, UnlockDatabaseMutationVariables>;
export const LockLiveDatabaseDocument = gql`
    mutation LockLiveDatabase($intersectionId: String!) {
  lockLiveDatabase(intersectionId: $intersectionId)
}
    `;
export type LockLiveDatabaseMutationFn = Apollo.MutationFunction<LockLiveDatabaseMutation, LockLiveDatabaseMutationVariables>;

/**
 * __useLockLiveDatabaseMutation__
 *
 * To run a mutation, you first call `useLockLiveDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockLiveDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockLiveDatabaseMutation, { data, loading, error }] = useLockLiveDatabaseMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useLockLiveDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<LockLiveDatabaseMutation, LockLiveDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockLiveDatabaseMutation, LockLiveDatabaseMutationVariables>(LockLiveDatabaseDocument, options);
      }
export type LockLiveDatabaseMutationHookResult = ReturnType<typeof useLockLiveDatabaseMutation>;
export type LockLiveDatabaseMutationResult = Apollo.MutationResult<LockLiveDatabaseMutation>;
export type LockLiveDatabaseMutationOptions = Apollo.BaseMutationOptions<LockLiveDatabaseMutation, LockLiveDatabaseMutationVariables>;
export const UnlockLiveDatabaseDocument = gql`
    mutation UnlockLiveDatabase($intersectionId: String!) {
  unlockLiveDatabase(intersectionId: $intersectionId)
}
    `;
export type UnlockLiveDatabaseMutationFn = Apollo.MutationFunction<UnlockLiveDatabaseMutation, UnlockLiveDatabaseMutationVariables>;

/**
 * __useUnlockLiveDatabaseMutation__
 *
 * To run a mutation, you first call `useUnlockLiveDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockLiveDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockLiveDatabaseMutation, { data, loading, error }] = useUnlockLiveDatabaseMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useUnlockLiveDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<UnlockLiveDatabaseMutation, UnlockLiveDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockLiveDatabaseMutation, UnlockLiveDatabaseMutationVariables>(UnlockLiveDatabaseDocument, options);
      }
export type UnlockLiveDatabaseMutationHookResult = ReturnType<typeof useUnlockLiveDatabaseMutation>;
export type UnlockLiveDatabaseMutationResult = Apollo.MutationResult<UnlockLiveDatabaseMutation>;
export type UnlockLiveDatabaseMutationOptions = Apollo.BaseMutationOptions<UnlockLiveDatabaseMutation, UnlockLiveDatabaseMutationVariables>;
export const AdminUnlockDatabaseDocument = gql`
    mutation AdminUnlockDatabase($databaseId: String!, $intersectionId: String!) {
  adminUnlockDatabase(databaseId: $databaseId, intersectionId: $intersectionId)
}
    `;
export type AdminUnlockDatabaseMutationFn = Apollo.MutationFunction<AdminUnlockDatabaseMutation, AdminUnlockDatabaseMutationVariables>;

/**
 * __useAdminUnlockDatabaseMutation__
 *
 * To run a mutation, you first call `useAdminUnlockDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUnlockDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUnlockDatabaseMutation, { data, loading, error }] = useAdminUnlockDatabaseMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useAdminUnlockDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<AdminUnlockDatabaseMutation, AdminUnlockDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUnlockDatabaseMutation, AdminUnlockDatabaseMutationVariables>(AdminUnlockDatabaseDocument, options);
      }
export type AdminUnlockDatabaseMutationHookResult = ReturnType<typeof useAdminUnlockDatabaseMutation>;
export type AdminUnlockDatabaseMutationResult = Apollo.MutationResult<AdminUnlockDatabaseMutation>;
export type AdminUnlockDatabaseMutationOptions = Apollo.BaseMutationOptions<AdminUnlockDatabaseMutation, AdminUnlockDatabaseMutationVariables>;
export const AdminUnlockLiveDatabaseDocument = gql`
    mutation AdminUnlockLiveDatabase($intersectionId: String!) {
  adminUnlockLiveDatabase(intersectionId: $intersectionId)
}
    `;
export type AdminUnlockLiveDatabaseMutationFn = Apollo.MutationFunction<AdminUnlockLiveDatabaseMutation, AdminUnlockLiveDatabaseMutationVariables>;

/**
 * __useAdminUnlockLiveDatabaseMutation__
 *
 * To run a mutation, you first call `useAdminUnlockLiveDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUnlockLiveDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUnlockLiveDatabaseMutation, { data, loading, error }] = useAdminUnlockLiveDatabaseMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useAdminUnlockLiveDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<AdminUnlockLiveDatabaseMutation, AdminUnlockLiveDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUnlockLiveDatabaseMutation, AdminUnlockLiveDatabaseMutationVariables>(AdminUnlockLiveDatabaseDocument, options);
      }
export type AdminUnlockLiveDatabaseMutationHookResult = ReturnType<typeof useAdminUnlockLiveDatabaseMutation>;
export type AdminUnlockLiveDatabaseMutationResult = Apollo.MutationResult<AdminUnlockLiveDatabaseMutation>;
export type AdminUnlockLiveDatabaseMutationOptions = Apollo.BaseMutationOptions<AdminUnlockLiveDatabaseMutation, AdminUnlockLiveDatabaseMutationVariables>;
export const LiveDatabaseLockDocument = gql`
    query LiveDatabaseLock($intersectionId: ID!) {
  liveDatabaseLock(intersectionId: $intersectionId) {
    ...DeviceDatabaseLock
  }
}
    ${DeviceDatabaseLockFragmentDoc}`;

/**
 * __useLiveDatabaseLockQuery__
 *
 * To run a query within a React component, call `useLiveDatabaseLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveDatabaseLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveDatabaseLockQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useLiveDatabaseLockQuery(baseOptions: Apollo.QueryHookOptions<LiveDatabaseLockQuery, LiveDatabaseLockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveDatabaseLockQuery, LiveDatabaseLockQueryVariables>(LiveDatabaseLockDocument, options);
      }
export function useLiveDatabaseLockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveDatabaseLockQuery, LiveDatabaseLockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveDatabaseLockQuery, LiveDatabaseLockQueryVariables>(LiveDatabaseLockDocument, options);
        }
export type LiveDatabaseLockQueryHookResult = ReturnType<typeof useLiveDatabaseLockQuery>;
export type LiveDatabaseLockLazyQueryHookResult = ReturnType<typeof useLiveDatabaseLockLazyQuery>;
export type LiveDatabaseLockQueryResult = Apollo.QueryResult<LiveDatabaseLockQuery, LiveDatabaseLockQueryVariables>;
export function refetchLiveDatabaseLockQuery(variables: LiveDatabaseLockQueryVariables) {
      return { query: LiveDatabaseLockDocument, variables: variables }
    }
export const DatabaseLockDocument = gql`
    query DatabaseLock($databaseId: ID!, $intersectionId: ID!) {
  databaseLock(databaseId: $databaseId, intersectionId: $intersectionId) {
    ...DeviceDatabaseLock
  }
}
    ${DeviceDatabaseLockFragmentDoc}`;

/**
 * __useDatabaseLockQuery__
 *
 * To run a query within a React component, call `useDatabaseLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatabaseLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatabaseLockQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useDatabaseLockQuery(baseOptions: Apollo.QueryHookOptions<DatabaseLockQuery, DatabaseLockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatabaseLockQuery, DatabaseLockQueryVariables>(DatabaseLockDocument, options);
      }
export function useDatabaseLockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatabaseLockQuery, DatabaseLockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatabaseLockQuery, DatabaseLockQueryVariables>(DatabaseLockDocument, options);
        }
export type DatabaseLockQueryHookResult = ReturnType<typeof useDatabaseLockQuery>;
export type DatabaseLockLazyQueryHookResult = ReturnType<typeof useDatabaseLockLazyQuery>;
export type DatabaseLockQueryResult = Apollo.QueryResult<DatabaseLockQuery, DatabaseLockQueryVariables>;
export function refetchDatabaseLockQuery(variables: DatabaseLockQueryVariables) {
      return { query: DatabaseLockDocument, variables: variables }
    }
export const DatabaseLockUpdatedDocument = gql`
    subscription DatabaseLockUpdated($intersectionIds: [ID!]) {
  databaseLockUpdated(intersectionIds: $intersectionIds) {
    intersectionId
    databaseId
    action
    databaseType
    updatedBy
    userId
    userDisplayName
  }
}
    `;

/**
 * __useDatabaseLockUpdatedSubscription__
 *
 * To run a query within a React component, call `useDatabaseLockUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDatabaseLockUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatabaseLockUpdatedSubscription({
 *   variables: {
 *      intersectionIds: // value for 'intersectionIds'
 *   },
 * });
 */
export function useDatabaseLockUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DatabaseLockUpdatedSubscription, DatabaseLockUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DatabaseLockUpdatedSubscription, DatabaseLockUpdatedSubscriptionVariables>(DatabaseLockUpdatedDocument, options);
      }
export type DatabaseLockUpdatedSubscriptionHookResult = ReturnType<typeof useDatabaseLockUpdatedSubscription>;
export type DatabaseLockUpdatedSubscriptionResult = Apollo.SubscriptionResult<DatabaseLockUpdatedSubscription>;
export const DatabaseUiTableDocument = gql`
    query databaseUiTable($intersectionId: String!, $id: String, $name: String!, $databaseId: String, $firstIndexOnly: Boolean, $topIndex: Int, $filter: Boolean) {
  deviceUITable(
    intersectionId: $intersectionId
    id: $id
    name: $name
    databaseId: $databaseId
    firstIndexOnly: $firstIndexOnly
    filter: $filter
    topIndex: $topIndex
  ) {
    name
    displayName
    col
    row
    height
    width
    swap
    columns {
      name
      displayName
      displayAsHeader
      readonly
      mibName
      description
      type {
        type
        maxValue
        minValue
        decimalPos
        isHexadecimal
        isMultiLines
        onlyFirstRowDescription
        swapRowsColumns
        displayAsHeader
        bits {
          used
          description
          appendIndex
          multiply
          plus
        }
        enum {
          value
          description
        }
      }
      mib {
        name
        mibIndex {
          name
          data {
            index
            counter
            value
            bitField {
              index
              value
            }
            mibIndex {
              name
              data {
                index
                counter
                value
                bitField {
                  index
                  value
                }
              }
            }
          }
        }
        data {
          index
          counter
          value
          bitField {
            index
            value
          }
          mibIndex {
            name
            data {
              index
              counter
              value
              bitField {
                index
                value
              }
            }
          }
        }
      }
    }
    indexes {
      name
      displayed
      rows
    }
  }
}
    `;

/**
 * __useDatabaseUiTableQuery__
 *
 * To run a query within a React component, call `useDatabaseUiTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatabaseUiTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatabaseUiTableQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      databaseId: // value for 'databaseId'
 *      firstIndexOnly: // value for 'firstIndexOnly'
 *      topIndex: // value for 'topIndex'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDatabaseUiTableQuery(baseOptions: Apollo.QueryHookOptions<DatabaseUiTableQuery, DatabaseUiTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatabaseUiTableQuery, DatabaseUiTableQueryVariables>(DatabaseUiTableDocument, options);
      }
export function useDatabaseUiTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatabaseUiTableQuery, DatabaseUiTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatabaseUiTableQuery, DatabaseUiTableQueryVariables>(DatabaseUiTableDocument, options);
        }
export type DatabaseUiTableQueryHookResult = ReturnType<typeof useDatabaseUiTableQuery>;
export type DatabaseUiTableLazyQueryHookResult = ReturnType<typeof useDatabaseUiTableLazyQuery>;
export type DatabaseUiTableQueryResult = Apollo.QueryResult<DatabaseUiTableQuery, DatabaseUiTableQueryVariables>;
export function refetchDatabaseUiTableQuery(variables: DatabaseUiTableQueryVariables) {
      return { query: DatabaseUiTableDocument, variables: variables }
    }
export const DatabaseUiViewDocument = gql`
    query databaseUiView($intersectionId: String!, $id: String, $databaseId: String, $timeout: Int) {
  deviceUI(
    intersectionId: $intersectionId
    id: $id
    databaseId: $databaseId
    timeoutMs: $timeout
  ) {
    views {
      ...viewFragment
      views {
        ...viewFragment
        views {
          ...viewFragment
          views {
            ...viewFragment
            views {
              ...viewFragment
            }
          }
        }
      }
    }
  }
}
    ${ViewFragmentFragmentDoc}`;

/**
 * __useDatabaseUiViewQuery__
 *
 * To run a query within a React component, call `useDatabaseUiViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatabaseUiViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatabaseUiViewQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      id: // value for 'id'
 *      databaseId: // value for 'databaseId'
 *      timeout: // value for 'timeout'
 *   },
 * });
 */
export function useDatabaseUiViewQuery(baseOptions: Apollo.QueryHookOptions<DatabaseUiViewQuery, DatabaseUiViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatabaseUiViewQuery, DatabaseUiViewQueryVariables>(DatabaseUiViewDocument, options);
      }
export function useDatabaseUiViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatabaseUiViewQuery, DatabaseUiViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatabaseUiViewQuery, DatabaseUiViewQueryVariables>(DatabaseUiViewDocument, options);
        }
export type DatabaseUiViewQueryHookResult = ReturnType<typeof useDatabaseUiViewQuery>;
export type DatabaseUiViewLazyQueryHookResult = ReturnType<typeof useDatabaseUiViewLazyQuery>;
export type DatabaseUiViewQueryResult = Apollo.QueryResult<DatabaseUiViewQuery, DatabaseUiViewQueryVariables>;
export function refetchDatabaseUiViewQuery(variables: DatabaseUiViewQueryVariables) {
      return { query: DatabaseUiViewDocument, variables: variables }
    }
export const DeviceDatabaseComparisonDocument = gql`
    query deviceDatabaseComparison($db1: ID!, $db2: ID!, $intersectionId: ID!) {
  deviceDatabaseComparison(
    originalDatabaseId: $db1
    compareDatabaseId: $db2
    intersectionId: $intersectionId
  ) {
    differences {
      type
      originalMib {
        ...DatabaseComparisonMibValueFragment
      }
      compareMib {
        ...DatabaseComparisonMibValueFragment
      }
    }
  }
}
    ${DatabaseComparisonMibValueFragmentFragmentDoc}`;

/**
 * __useDeviceDatabaseComparisonQuery__
 *
 * To run a query within a React component, call `useDeviceDatabaseComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceDatabaseComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceDatabaseComparisonQuery({
 *   variables: {
 *      db1: // value for 'db1'
 *      db2: // value for 'db2'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useDeviceDatabaseComparisonQuery(baseOptions: Apollo.QueryHookOptions<DeviceDatabaseComparisonQuery, DeviceDatabaseComparisonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceDatabaseComparisonQuery, DeviceDatabaseComparisonQueryVariables>(DeviceDatabaseComparisonDocument, options);
      }
export function useDeviceDatabaseComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceDatabaseComparisonQuery, DeviceDatabaseComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceDatabaseComparisonQuery, DeviceDatabaseComparisonQueryVariables>(DeviceDatabaseComparisonDocument, options);
        }
export type DeviceDatabaseComparisonQueryHookResult = ReturnType<typeof useDeviceDatabaseComparisonQuery>;
export type DeviceDatabaseComparisonLazyQueryHookResult = ReturnType<typeof useDeviceDatabaseComparisonLazyQuery>;
export type DeviceDatabaseComparisonQueryResult = Apollo.QueryResult<DeviceDatabaseComparisonQuery, DeviceDatabaseComparisonQueryVariables>;
export function refetchDeviceDatabaseComparisonQuery(variables: DeviceDatabaseComparisonQueryVariables) {
      return { query: DeviceDatabaseComparisonDocument, variables: variables }
    }
export const GetDatabaseCompareLocationsTreeDocument = gql`
    query GetDatabaseCompareLocationsTree {
  locationGroups {
    id
    name
    parentId
    readOnly
    externalCenterId
    order
  }
  locations(query: {limit: 10000}) {
    edges {
      node {
        id
        groupId
        locationType
        order
        details {
          name
        }
        associatedEntities {
          entityType
          entityId
        }
        integrations {
          id
          systemEnabled
          config {
            integrationType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDatabaseCompareLocationsTreeQuery__
 *
 * To run a query within a React component, call `useGetDatabaseCompareLocationsTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatabaseCompareLocationsTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatabaseCompareLocationsTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDatabaseCompareLocationsTreeQuery(baseOptions?: Apollo.QueryHookOptions<GetDatabaseCompareLocationsTreeQuery, GetDatabaseCompareLocationsTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatabaseCompareLocationsTreeQuery, GetDatabaseCompareLocationsTreeQueryVariables>(GetDatabaseCompareLocationsTreeDocument, options);
      }
export function useGetDatabaseCompareLocationsTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatabaseCompareLocationsTreeQuery, GetDatabaseCompareLocationsTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatabaseCompareLocationsTreeQuery, GetDatabaseCompareLocationsTreeQueryVariables>(GetDatabaseCompareLocationsTreeDocument, options);
        }
export type GetDatabaseCompareLocationsTreeQueryHookResult = ReturnType<typeof useGetDatabaseCompareLocationsTreeQuery>;
export type GetDatabaseCompareLocationsTreeLazyQueryHookResult = ReturnType<typeof useGetDatabaseCompareLocationsTreeLazyQuery>;
export type GetDatabaseCompareLocationsTreeQueryResult = Apollo.QueryResult<GetDatabaseCompareLocationsTreeQuery, GetDatabaseCompareLocationsTreeQueryVariables>;
export function refetchGetDatabaseCompareLocationsTreeQuery(variables?: GetDatabaseCompareLocationsTreeQueryVariables) {
      return { query: GetDatabaseCompareLocationsTreeDocument, variables: variables }
    }
export const SaveSignalDetectorGroupDocument = gql`
    mutation SaveSignalDetectorGroup($input: SignalDetectorGroupInput!) {
  saveSignalDetectorGroup(input: $input) {
    id
  }
}
    `;
export type SaveSignalDetectorGroupMutationFn = Apollo.MutationFunction<SaveSignalDetectorGroupMutation, SaveSignalDetectorGroupMutationVariables>;

/**
 * __useSaveSignalDetectorGroupMutation__
 *
 * To run a mutation, you first call `useSaveSignalDetectorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignalDetectorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignalDetectorGroupMutation, { data, loading, error }] = useSaveSignalDetectorGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignalDetectorGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignalDetectorGroupMutation, SaveSignalDetectorGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignalDetectorGroupMutation, SaveSignalDetectorGroupMutationVariables>(SaveSignalDetectorGroupDocument, options);
      }
export type SaveSignalDetectorGroupMutationHookResult = ReturnType<typeof useSaveSignalDetectorGroupMutation>;
export type SaveSignalDetectorGroupMutationResult = Apollo.MutationResult<SaveSignalDetectorGroupMutation>;
export type SaveSignalDetectorGroupMutationOptions = Apollo.BaseMutationOptions<SaveSignalDetectorGroupMutation, SaveSignalDetectorGroupMutationVariables>;
export const DeleteSignalDetectorGroupDocument = gql`
    mutation DeleteSignalDetectorGroup($id: ID!) {
  deleteSignalDetectorGroup(id: $id)
}
    `;
export type DeleteSignalDetectorGroupMutationFn = Apollo.MutationFunction<DeleteSignalDetectorGroupMutation, DeleteSignalDetectorGroupMutationVariables>;

/**
 * __useDeleteSignalDetectorGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSignalDetectorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignalDetectorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignalDetectorGroupMutation, { data, loading, error }] = useDeleteSignalDetectorGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignalDetectorGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignalDetectorGroupMutation, DeleteSignalDetectorGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignalDetectorGroupMutation, DeleteSignalDetectorGroupMutationVariables>(DeleteSignalDetectorGroupDocument, options);
      }
export type DeleteSignalDetectorGroupMutationHookResult = ReturnType<typeof useDeleteSignalDetectorGroupMutation>;
export type DeleteSignalDetectorGroupMutationResult = Apollo.MutationResult<DeleteSignalDetectorGroupMutation>;
export type DeleteSignalDetectorGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSignalDetectorGroupMutation, DeleteSignalDetectorGroupMutationVariables>;
export const DetectorGroupExportDocument = gql`
    mutation DetectorGroupExport($detectorGroupId: String!, $startDateTime: DateTime!, $endDateTime: DateTime!, $fileName: String!, $timezone: String) {
  detectorGroupExport(
    detectorGroupId: $detectorGroupId
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    fileName: $fileName
    timezone: $timezone
  )
}
    `;
export type DetectorGroupExportMutationFn = Apollo.MutationFunction<DetectorGroupExportMutation, DetectorGroupExportMutationVariables>;

/**
 * __useDetectorGroupExportMutation__
 *
 * To run a mutation, you first call `useDetectorGroupExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetectorGroupExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detectorGroupExportMutation, { data, loading, error }] = useDetectorGroupExportMutation({
 *   variables: {
 *      detectorGroupId: // value for 'detectorGroupId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      fileName: // value for 'fileName'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useDetectorGroupExportMutation(baseOptions?: Apollo.MutationHookOptions<DetectorGroupExportMutation, DetectorGroupExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetectorGroupExportMutation, DetectorGroupExportMutationVariables>(DetectorGroupExportDocument, options);
      }
export type DetectorGroupExportMutationHookResult = ReturnType<typeof useDetectorGroupExportMutation>;
export type DetectorGroupExportMutationResult = Apollo.MutationResult<DetectorGroupExportMutation>;
export type DetectorGroupExportMutationOptions = Apollo.BaseMutationOptions<DetectorGroupExportMutation, DetectorGroupExportMutationVariables>;
export const SignalDetectorGroupsListDocument = gql`
    query SignalDetectorGroupsList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  signalDetectorGroups(
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    searchText: $searchText
    limit: $limit
    before: $before
    after: $after
  ) {
    edges {
      node {
        ...DetectorGroupListItem
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${DetectorGroupListItemFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignalDetectorGroupsListQuery__
 *
 * To run a query within a React component, call `useSignalDetectorGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalDetectorGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalDetectorGroupsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSignalDetectorGroupsListQuery(baseOptions?: Apollo.QueryHookOptions<SignalDetectorGroupsListQuery, SignalDetectorGroupsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalDetectorGroupsListQuery, SignalDetectorGroupsListQueryVariables>(SignalDetectorGroupsListDocument, options);
      }
export function useSignalDetectorGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalDetectorGroupsListQuery, SignalDetectorGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalDetectorGroupsListQuery, SignalDetectorGroupsListQueryVariables>(SignalDetectorGroupsListDocument, options);
        }
export type SignalDetectorGroupsListQueryHookResult = ReturnType<typeof useSignalDetectorGroupsListQuery>;
export type SignalDetectorGroupsListLazyQueryHookResult = ReturnType<typeof useSignalDetectorGroupsListLazyQuery>;
export type SignalDetectorGroupsListQueryResult = Apollo.QueryResult<SignalDetectorGroupsListQuery, SignalDetectorGroupsListQueryVariables>;
export function refetchSignalDetectorGroupsListQuery(variables?: SignalDetectorGroupsListQueryVariables) {
      return { query: SignalDetectorGroupsListDocument, variables: variables }
    }
export const DetectorGroupOverviewReportDocument = gql`
    query DetectorGroupOverviewReport($detectorGroupId: ID!, $startDateTime: DateTime!, $endDateTime: DateTime!) {
  detectorGroupOverviewReport(
    detectorGroupId: $detectorGroupId
    startDateTime: $startDateTime
    endDateTime: $endDateTime
  ) {
    name
    dataPoints {
      x
      y
    }
  }
}
    `;

/**
 * __useDetectorGroupOverviewReportQuery__
 *
 * To run a query within a React component, call `useDetectorGroupOverviewReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectorGroupOverviewReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectorGroupOverviewReportQuery({
 *   variables: {
 *      detectorGroupId: // value for 'detectorGroupId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useDetectorGroupOverviewReportQuery(baseOptions: Apollo.QueryHookOptions<DetectorGroupOverviewReportQuery, DetectorGroupOverviewReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectorGroupOverviewReportQuery, DetectorGroupOverviewReportQueryVariables>(DetectorGroupOverviewReportDocument, options);
      }
export function useDetectorGroupOverviewReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectorGroupOverviewReportQuery, DetectorGroupOverviewReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectorGroupOverviewReportQuery, DetectorGroupOverviewReportQueryVariables>(DetectorGroupOverviewReportDocument, options);
        }
export type DetectorGroupOverviewReportQueryHookResult = ReturnType<typeof useDetectorGroupOverviewReportQuery>;
export type DetectorGroupOverviewReportLazyQueryHookResult = ReturnType<typeof useDetectorGroupOverviewReportLazyQuery>;
export type DetectorGroupOverviewReportQueryResult = Apollo.QueryResult<DetectorGroupOverviewReportQuery, DetectorGroupOverviewReportQueryVariables>;
export function refetchDetectorGroupOverviewReportQuery(variables: DetectorGroupOverviewReportQueryVariables) {
      return { query: DetectorGroupOverviewReportDocument, variables: variables }
    }
export const AcceptDeviceDatabaseValidationDocument = gql`
    mutation AcceptDeviceDatabaseValidation($databaseId: String!, $intersectionId: String!) {
  acceptDeviceDatabaseValidation(
    databaseId: $databaseId
    intersectionId: $intersectionId
  )
}
    `;
export type AcceptDeviceDatabaseValidationMutationFn = Apollo.MutationFunction<AcceptDeviceDatabaseValidationMutation, AcceptDeviceDatabaseValidationMutationVariables>;

/**
 * __useAcceptDeviceDatabaseValidationMutation__
 *
 * To run a mutation, you first call `useAcceptDeviceDatabaseValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptDeviceDatabaseValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptDeviceDatabaseValidationMutation, { data, loading, error }] = useAcceptDeviceDatabaseValidationMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useAcceptDeviceDatabaseValidationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptDeviceDatabaseValidationMutation, AcceptDeviceDatabaseValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptDeviceDatabaseValidationMutation, AcceptDeviceDatabaseValidationMutationVariables>(AcceptDeviceDatabaseValidationDocument, options);
      }
export type AcceptDeviceDatabaseValidationMutationHookResult = ReturnType<typeof useAcceptDeviceDatabaseValidationMutation>;
export type AcceptDeviceDatabaseValidationMutationResult = Apollo.MutationResult<AcceptDeviceDatabaseValidationMutation>;
export type AcceptDeviceDatabaseValidationMutationOptions = Apollo.BaseMutationOptions<AcceptDeviceDatabaseValidationMutation, AcceptDeviceDatabaseValidationMutationVariables>;
export const RejectDeviceDatabaseValidationDocument = gql`
    mutation RejectDeviceDatabaseValidation($databaseId: String!, $intersectionId: String!) {
  rejectDeviceDatabaseValidation(
    databaseId: $databaseId
    intersectionId: $intersectionId
  )
}
    `;
export type RejectDeviceDatabaseValidationMutationFn = Apollo.MutationFunction<RejectDeviceDatabaseValidationMutation, RejectDeviceDatabaseValidationMutationVariables>;

/**
 * __useRejectDeviceDatabaseValidationMutation__
 *
 * To run a mutation, you first call `useRejectDeviceDatabaseValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectDeviceDatabaseValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectDeviceDatabaseValidationMutation, { data, loading, error }] = useRejectDeviceDatabaseValidationMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useRejectDeviceDatabaseValidationMutation(baseOptions?: Apollo.MutationHookOptions<RejectDeviceDatabaseValidationMutation, RejectDeviceDatabaseValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectDeviceDatabaseValidationMutation, RejectDeviceDatabaseValidationMutationVariables>(RejectDeviceDatabaseValidationDocument, options);
      }
export type RejectDeviceDatabaseValidationMutationHookResult = ReturnType<typeof useRejectDeviceDatabaseValidationMutation>;
export type RejectDeviceDatabaseValidationMutationResult = Apollo.MutationResult<RejectDeviceDatabaseValidationMutation>;
export type RejectDeviceDatabaseValidationMutationOptions = Apollo.BaseMutationOptions<RejectDeviceDatabaseValidationMutation, RejectDeviceDatabaseValidationMutationVariables>;
export const ValidateDeviceDatabaseDocument = gql`
    mutation ValidateDeviceDatabase($databaseId: String!, $intersectionId: String!) {
  validateDeviceDatabase(databaseId: $databaseId, intersectionId: $intersectionId)
}
    `;
export type ValidateDeviceDatabaseMutationFn = Apollo.MutationFunction<ValidateDeviceDatabaseMutation, ValidateDeviceDatabaseMutationVariables>;

/**
 * __useValidateDeviceDatabaseMutation__
 *
 * To run a mutation, you first call `useValidateDeviceDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDeviceDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDeviceDatabaseMutation, { data, loading, error }] = useValidateDeviceDatabaseMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useValidateDeviceDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDeviceDatabaseMutation, ValidateDeviceDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateDeviceDatabaseMutation, ValidateDeviceDatabaseMutationVariables>(ValidateDeviceDatabaseDocument, options);
      }
export type ValidateDeviceDatabaseMutationHookResult = ReturnType<typeof useValidateDeviceDatabaseMutation>;
export type ValidateDeviceDatabaseMutationResult = Apollo.MutationResult<ValidateDeviceDatabaseMutation>;
export type ValidateDeviceDatabaseMutationOptions = Apollo.BaseMutationOptions<ValidateDeviceDatabaseMutation, ValidateDeviceDatabaseMutationVariables>;
export const GetDeviceDatabaseDocument = gql`
    query getDeviceDatabase($intersectionId: String!, $filters: [FilterInput!], $after: String, $before: String, $limit: Int = 10, $sortField: String = "start", $sortOrder: SortOrder = DESCENDING, $searchText: String, $searchFields: [String!]) {
  deviceDatabases(
    intersectionId: $intersectionId
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    searchFields: $searchFields
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        intersectionId
        comment
        start
        end
        type
        status
        revision
        approved
        approvedComment
        approvedDate
        archived
        progress
        firmwareVersion
        protocol
        user {
          id
        }
        databaseValidation {
          status
          results {
            severity
            description
          }
        }
      }
      __typename
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGetDeviceDatabaseQuery__
 *
 * To run a query within a React component, call `useGetDeviceDatabaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceDatabaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceDatabaseQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *   },
 * });
 */
export function useGetDeviceDatabaseQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceDatabaseQuery, GetDeviceDatabaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceDatabaseQuery, GetDeviceDatabaseQueryVariables>(GetDeviceDatabaseDocument, options);
      }
export function useGetDeviceDatabaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceDatabaseQuery, GetDeviceDatabaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceDatabaseQuery, GetDeviceDatabaseQueryVariables>(GetDeviceDatabaseDocument, options);
        }
export type GetDeviceDatabaseQueryHookResult = ReturnType<typeof useGetDeviceDatabaseQuery>;
export type GetDeviceDatabaseLazyQueryHookResult = ReturnType<typeof useGetDeviceDatabaseLazyQuery>;
export type GetDeviceDatabaseQueryResult = Apollo.QueryResult<GetDeviceDatabaseQuery, GetDeviceDatabaseQueryVariables>;
export function refetchGetDeviceDatabaseQuery(variables: GetDeviceDatabaseQueryVariables) {
      return { query: GetDeviceDatabaseDocument, variables: variables }
    }
export const GetDeviceDatabasesEditorDocument = gql`
    query getDeviceDatabasesEditor($intersectionId: String!, $after: String, $before: String, $limit: Int = 10, $sortField: String = "start", $sortOrder: SortOrder = DESCENDING, $searchText: String) {
  deviceDatabases(
    intersectionId: $intersectionId
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: [{field: "status", operator: IN, value: ["COMPLETE", "FIELD_READY"]}]
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        intersectionId
        comment
        start
        end
        type
        status
        revision
        approved
        approvedComment
        approvedDate
        archived
        firmwareVersion
        locked
        lockedDate
        protocol
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGetDeviceDatabasesEditorQuery__
 *
 * To run a query within a React component, call `useGetDeviceDatabasesEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceDatabasesEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceDatabasesEditorQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetDeviceDatabasesEditorQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceDatabasesEditorQuery, GetDeviceDatabasesEditorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceDatabasesEditorQuery, GetDeviceDatabasesEditorQueryVariables>(GetDeviceDatabasesEditorDocument, options);
      }
export function useGetDeviceDatabasesEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceDatabasesEditorQuery, GetDeviceDatabasesEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceDatabasesEditorQuery, GetDeviceDatabasesEditorQueryVariables>(GetDeviceDatabasesEditorDocument, options);
        }
export type GetDeviceDatabasesEditorQueryHookResult = ReturnType<typeof useGetDeviceDatabasesEditorQuery>;
export type GetDeviceDatabasesEditorLazyQueryHookResult = ReturnType<typeof useGetDeviceDatabasesEditorLazyQuery>;
export type GetDeviceDatabasesEditorQueryResult = Apollo.QueryResult<GetDeviceDatabasesEditorQuery, GetDeviceDatabasesEditorQueryVariables>;
export function refetchGetDeviceDatabasesEditorQuery(variables: GetDeviceDatabasesEditorQueryVariables) {
      return { query: GetDeviceDatabasesEditorDocument, variables: variables }
    }
export const LocalDeviceDatabasesDocument = gql`
    query localDeviceDatabases($id: ID!) {
  localDeviceDatabases(id: $id) {
    id
    type
    name
  }
}
    `;

/**
 * __useLocalDeviceDatabasesQuery__
 *
 * To run a query within a React component, call `useLocalDeviceDatabasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalDeviceDatabasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalDeviceDatabasesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocalDeviceDatabasesQuery(baseOptions: Apollo.QueryHookOptions<LocalDeviceDatabasesQuery, LocalDeviceDatabasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocalDeviceDatabasesQuery, LocalDeviceDatabasesQueryVariables>(LocalDeviceDatabasesDocument, options);
      }
export function useLocalDeviceDatabasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocalDeviceDatabasesQuery, LocalDeviceDatabasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocalDeviceDatabasesQuery, LocalDeviceDatabasesQueryVariables>(LocalDeviceDatabasesDocument, options);
        }
export type LocalDeviceDatabasesQueryHookResult = ReturnType<typeof useLocalDeviceDatabasesQuery>;
export type LocalDeviceDatabasesLazyQueryHookResult = ReturnType<typeof useLocalDeviceDatabasesLazyQuery>;
export type LocalDeviceDatabasesQueryResult = Apollo.QueryResult<LocalDeviceDatabasesQuery, LocalDeviceDatabasesQueryVariables>;
export function refetchLocalDeviceDatabasesQuery(variables: LocalDeviceDatabasesQueryVariables) {
      return { query: LocalDeviceDatabasesDocument, variables: variables }
    }
export const IntersectionDatabaseDetailsDocument = gql`
    query IntersectionDatabaseDetails($id: ID!, $intersectionId: ID!) {
  deviceDatabase(id: $id, intersectionId: $intersectionId) {
    id
    comment
    start
    type
    status
    firmwareVersion
    protocol
  }
}
    `;

/**
 * __useIntersectionDatabaseDetailsQuery__
 *
 * To run a query within a React component, call `useIntersectionDatabaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionDatabaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionDatabaseDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useIntersectionDatabaseDetailsQuery(baseOptions: Apollo.QueryHookOptions<IntersectionDatabaseDetailsQuery, IntersectionDatabaseDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionDatabaseDetailsQuery, IntersectionDatabaseDetailsQueryVariables>(IntersectionDatabaseDetailsDocument, options);
      }
export function useIntersectionDatabaseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionDatabaseDetailsQuery, IntersectionDatabaseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionDatabaseDetailsQuery, IntersectionDatabaseDetailsQueryVariables>(IntersectionDatabaseDetailsDocument, options);
        }
export type IntersectionDatabaseDetailsQueryHookResult = ReturnType<typeof useIntersectionDatabaseDetailsQuery>;
export type IntersectionDatabaseDetailsLazyQueryHookResult = ReturnType<typeof useIntersectionDatabaseDetailsLazyQuery>;
export type IntersectionDatabaseDetailsQueryResult = Apollo.QueryResult<IntersectionDatabaseDetailsQuery, IntersectionDatabaseDetailsQueryVariables>;
export function refetchIntersectionDatabaseDetailsQuery(variables: IntersectionDatabaseDetailsQueryVariables) {
      return { query: IntersectionDatabaseDetailsDocument, variables: variables }
    }
export const DeviceDatabaseUpdatedDocument = gql`
    subscription DeviceDatabaseUpdated($databaseIds: [ID!], $intersectionIds: [ID!]) {
  deviceDatabaseUpdated(
    databaseIds: $databaseIds
    intersectionIds: $intersectionIds
  ) {
    id
    intersectionId
    comment
    progress
    start
    end
    type
    status
    revision
    approved
    approvedComment
    approvedDate
    progress
    archived
    firmwareVersion
    protocol
    user {
      id
    }
  }
}
    `;

/**
 * __useDeviceDatabaseUpdatedSubscription__
 *
 * To run a query within a React component, call `useDeviceDatabaseUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeviceDatabaseUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceDatabaseUpdatedSubscription({
 *   variables: {
 *      databaseIds: // value for 'databaseIds'
 *      intersectionIds: // value for 'intersectionIds'
 *   },
 * });
 */
export function useDeviceDatabaseUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeviceDatabaseUpdatedSubscription, DeviceDatabaseUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeviceDatabaseUpdatedSubscription, DeviceDatabaseUpdatedSubscriptionVariables>(DeviceDatabaseUpdatedDocument, options);
      }
export type DeviceDatabaseUpdatedSubscriptionHookResult = ReturnType<typeof useDeviceDatabaseUpdatedSubscription>;
export type DeviceDatabaseUpdatedSubscriptionResult = Apollo.SubscriptionResult<DeviceDatabaseUpdatedSubscription>;
export const IntersectionCommunicationStatusDocument = gql`
    query IntersectionCommunicationStatus {
  intersectionCommunicationStatus
}
    `;

/**
 * __useIntersectionCommunicationStatusQuery__
 *
 * To run a query within a React component, call `useIntersectionCommunicationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionCommunicationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionCommunicationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionCommunicationStatusQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionCommunicationStatusQuery, IntersectionCommunicationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionCommunicationStatusQuery, IntersectionCommunicationStatusQueryVariables>(IntersectionCommunicationStatusDocument, options);
      }
export function useIntersectionCommunicationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionCommunicationStatusQuery, IntersectionCommunicationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionCommunicationStatusQuery, IntersectionCommunicationStatusQueryVariables>(IntersectionCommunicationStatusDocument, options);
        }
export type IntersectionCommunicationStatusQueryHookResult = ReturnType<typeof useIntersectionCommunicationStatusQuery>;
export type IntersectionCommunicationStatusLazyQueryHookResult = ReturnType<typeof useIntersectionCommunicationStatusLazyQuery>;
export type IntersectionCommunicationStatusQueryResult = Apollo.QueryResult<IntersectionCommunicationStatusQuery, IntersectionCommunicationStatusQueryVariables>;
export function refetchIntersectionCommunicationStatusQuery(variables?: IntersectionCommunicationStatusQueryVariables) {
      return { query: IntersectionCommunicationStatusDocument, variables: variables }
    }
export const IntersectionCommunicationStatusUpdatedDocument = gql`
    subscription IntersectionCommunicationStatusUpdated {
  intersectionCommunicationStatusUpdated {
    intersectionId
    mainlineColor
    communicationState
    category
  }
}
    `;

/**
 * __useIntersectionCommunicationStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useIntersectionCommunicationStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionCommunicationStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionCommunicationStatusUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionCommunicationStatusUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IntersectionCommunicationStatusUpdatedSubscription, IntersectionCommunicationStatusUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IntersectionCommunicationStatusUpdatedSubscription, IntersectionCommunicationStatusUpdatedSubscriptionVariables>(IntersectionCommunicationStatusUpdatedDocument, options);
      }
export type IntersectionCommunicationStatusUpdatedSubscriptionHookResult = ReturnType<typeof useIntersectionCommunicationStatusUpdatedSubscription>;
export type IntersectionCommunicationStatusUpdatedSubscriptionResult = Apollo.SubscriptionResult<IntersectionCommunicationStatusUpdatedSubscription>;
export const GenerateIntersectionStatusReportDocument = gql`
    mutation GenerateIntersectionStatusReport($columns: [String!], $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $searchFields: [String!] = ["details.name", "details.note", "details.mainStreet", "devices.name"]) {
  generateIntersectionStatusReport(
    columns: $columns
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    searchText: $searchText
    searchFields: $searchFields
  )
}
    `;
export type GenerateIntersectionStatusReportMutationFn = Apollo.MutationFunction<GenerateIntersectionStatusReportMutation, GenerateIntersectionStatusReportMutationVariables>;

/**
 * __useGenerateIntersectionStatusReportMutation__
 *
 * To run a mutation, you first call `useGenerateIntersectionStatusReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIntersectionStatusReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIntersectionStatusReportMutation, { data, loading, error }] = useGenerateIntersectionStatusReportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *   },
 * });
 */
export function useGenerateIntersectionStatusReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateIntersectionStatusReportMutation, GenerateIntersectionStatusReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateIntersectionStatusReportMutation, GenerateIntersectionStatusReportMutationVariables>(GenerateIntersectionStatusReportDocument, options);
      }
export type GenerateIntersectionStatusReportMutationHookResult = ReturnType<typeof useGenerateIntersectionStatusReportMutation>;
export type GenerateIntersectionStatusReportMutationResult = Apollo.MutationResult<GenerateIntersectionStatusReportMutation>;
export type GenerateIntersectionStatusReportMutationOptions = Apollo.BaseMutationOptions<GenerateIntersectionStatusReportMutation, GenerateIntersectionStatusReportMutationVariables>;
export const IntersectionDetailDocument = gql`
    query IntersectionDetail($id: ID!) {
  intersection(id: $id) {
    ...IntersectionDetail
  }
}
    ${IntersectionDetailFragmentDoc}`;

/**
 * __useIntersectionDetailQuery__
 *
 * To run a query within a React component, call `useIntersectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionDetailQuery(baseOptions: Apollo.QueryHookOptions<IntersectionDetailQuery, IntersectionDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionDetailQuery, IntersectionDetailQueryVariables>(IntersectionDetailDocument, options);
      }
export function useIntersectionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionDetailQuery, IntersectionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionDetailQuery, IntersectionDetailQueryVariables>(IntersectionDetailDocument, options);
        }
export type IntersectionDetailQueryHookResult = ReturnType<typeof useIntersectionDetailQuery>;
export type IntersectionDetailLazyQueryHookResult = ReturnType<typeof useIntersectionDetailLazyQuery>;
export type IntersectionDetailQueryResult = Apollo.QueryResult<IntersectionDetailQuery, IntersectionDetailQueryVariables>;
export function refetchIntersectionDetailQuery(variables: IntersectionDetailQueryVariables) {
      return { query: IntersectionDetailDocument, variables: variables }
    }
export const IntersectionDetailPageDocument = gql`
    query IntersectionDetailPage($id: ID!) {
  intersection(id: $id) {
    ...IntersectionDetail
  }
}
    ${IntersectionDetailFragmentDoc}`;

/**
 * __useIntersectionDetailPageQuery__
 *
 * To run a query within a React component, call `useIntersectionDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionDetailPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionDetailPageQuery(baseOptions: Apollo.QueryHookOptions<IntersectionDetailPageQuery, IntersectionDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionDetailPageQuery, IntersectionDetailPageQueryVariables>(IntersectionDetailPageDocument, options);
      }
export function useIntersectionDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionDetailPageQuery, IntersectionDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionDetailPageQuery, IntersectionDetailPageQueryVariables>(IntersectionDetailPageDocument, options);
        }
export type IntersectionDetailPageQueryHookResult = ReturnType<typeof useIntersectionDetailPageQuery>;
export type IntersectionDetailPageLazyQueryHookResult = ReturnType<typeof useIntersectionDetailPageLazyQuery>;
export type IntersectionDetailPageQueryResult = Apollo.QueryResult<IntersectionDetailPageQuery, IntersectionDetailPageQueryVariables>;
export function refetchIntersectionDetailPageQuery(variables: IntersectionDetailPageQueryVariables) {
      return { query: IntersectionDetailPageDocument, variables: variables }
    }
export const SignalTemplateDetailDocument = gql`
    query SignalTemplateDetail($id: ID!) {
  intersection(id: $id) {
    ...BaseSignalTemplateDetail
  }
}
    ${BaseSignalTemplateDetailFragmentDoc}`;

/**
 * __useSignalTemplateDetailQuery__
 *
 * To run a query within a React component, call `useSignalTemplateDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalTemplateDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalTemplateDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignalTemplateDetailQuery(baseOptions: Apollo.QueryHookOptions<SignalTemplateDetailQuery, SignalTemplateDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalTemplateDetailQuery, SignalTemplateDetailQueryVariables>(SignalTemplateDetailDocument, options);
      }
export function useSignalTemplateDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalTemplateDetailQuery, SignalTemplateDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalTemplateDetailQuery, SignalTemplateDetailQueryVariables>(SignalTemplateDetailDocument, options);
        }
export type SignalTemplateDetailQueryHookResult = ReturnType<typeof useSignalTemplateDetailQuery>;
export type SignalTemplateDetailLazyQueryHookResult = ReturnType<typeof useSignalTemplateDetailLazyQuery>;
export type SignalTemplateDetailQueryResult = Apollo.QueryResult<SignalTemplateDetailQuery, SignalTemplateDetailQueryVariables>;
export function refetchSignalTemplateDetailQuery(variables: SignalTemplateDetailQueryVariables) {
      return { query: SignalTemplateDetailDocument, variables: variables }
    }
export const IntersectionDevicesDocument = gql`
    query IntersectionDevices($id: ID!) {
  intersection(id: $id) {
    details {
      name
    }
    devices {
      id
      type
    }
    location
  }
}
    `;

/**
 * __useIntersectionDevicesQuery__
 *
 * To run a query within a React component, call `useIntersectionDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionDevicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionDevicesQuery(baseOptions: Apollo.QueryHookOptions<IntersectionDevicesQuery, IntersectionDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionDevicesQuery, IntersectionDevicesQueryVariables>(IntersectionDevicesDocument, options);
      }
export function useIntersectionDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionDevicesQuery, IntersectionDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionDevicesQuery, IntersectionDevicesQueryVariables>(IntersectionDevicesDocument, options);
        }
export type IntersectionDevicesQueryHookResult = ReturnType<typeof useIntersectionDevicesQuery>;
export type IntersectionDevicesLazyQueryHookResult = ReturnType<typeof useIntersectionDevicesLazyQuery>;
export type IntersectionDevicesQueryResult = Apollo.QueryResult<IntersectionDevicesQuery, IntersectionDevicesQueryVariables>;
export function refetchIntersectionDevicesQuery(variables: IntersectionDevicesQueryVariables) {
      return { query: IntersectionDevicesDocument, variables: variables }
    }
export const IntersectionCloneDetailDocument = gql`
    query IntersectionCloneDetail($id: ID!) {
  intersection(id: $id) {
    ...BaseIntersectionDetail
  }
}
    ${BaseIntersectionDetailFragmentDoc}`;

/**
 * __useIntersectionCloneDetailQuery__
 *
 * To run a query within a React component, call `useIntersectionCloneDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionCloneDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionCloneDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionCloneDetailQuery(baseOptions: Apollo.QueryHookOptions<IntersectionCloneDetailQuery, IntersectionCloneDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionCloneDetailQuery, IntersectionCloneDetailQueryVariables>(IntersectionCloneDetailDocument, options);
      }
export function useIntersectionCloneDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionCloneDetailQuery, IntersectionCloneDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionCloneDetailQuery, IntersectionCloneDetailQueryVariables>(IntersectionCloneDetailDocument, options);
        }
export type IntersectionCloneDetailQueryHookResult = ReturnType<typeof useIntersectionCloneDetailQuery>;
export type IntersectionCloneDetailLazyQueryHookResult = ReturnType<typeof useIntersectionCloneDetailLazyQuery>;
export type IntersectionCloneDetailQueryResult = Apollo.QueryResult<IntersectionCloneDetailQuery, IntersectionCloneDetailQueryVariables>;
export function refetchIntersectionCloneDetailQuery(variables: IntersectionCloneDetailQueryVariables) {
      return { query: IntersectionCloneDetailDocument, variables: variables }
    }
export const IntersectionNameDevicesDocument = gql`
    query IntersectionNameDevices($id: ID!) {
  intersection(id: $id) {
    details {
      name
    }
    devices {
      id
      name
      type
      fieldEntityProtocol
    }
  }
  intersectionDetailStatusById(id: $id) {
    firmwareVersion
  }
}
    `;

/**
 * __useIntersectionNameDevicesQuery__
 *
 * To run a query within a React component, call `useIntersectionNameDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionNameDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionNameDevicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionNameDevicesQuery(baseOptions: Apollo.QueryHookOptions<IntersectionNameDevicesQuery, IntersectionNameDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionNameDevicesQuery, IntersectionNameDevicesQueryVariables>(IntersectionNameDevicesDocument, options);
      }
export function useIntersectionNameDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionNameDevicesQuery, IntersectionNameDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionNameDevicesQuery, IntersectionNameDevicesQueryVariables>(IntersectionNameDevicesDocument, options);
        }
export type IntersectionNameDevicesQueryHookResult = ReturnType<typeof useIntersectionNameDevicesQuery>;
export type IntersectionNameDevicesLazyQueryHookResult = ReturnType<typeof useIntersectionNameDevicesLazyQuery>;
export type IntersectionNameDevicesQueryResult = Apollo.QueryResult<IntersectionNameDevicesQuery, IntersectionNameDevicesQueryVariables>;
export function refetchIntersectionNameDevicesQuery(variables: IntersectionNameDevicesQueryVariables) {
      return { query: IntersectionNameDevicesDocument, variables: variables }
    }
export const GetDeviceIdDocument = gql`
    query GetDeviceId($intersectionId: ID!) {
  intersection(id: $intersectionId) {
    devices {
      id
    }
  }
}
    `;

/**
 * __useGetDeviceIdQuery__
 *
 * To run a query within a React component, call `useGetDeviceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceIdQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useGetDeviceIdQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceIdQuery, GetDeviceIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceIdQuery, GetDeviceIdQueryVariables>(GetDeviceIdDocument, options);
      }
export function useGetDeviceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceIdQuery, GetDeviceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceIdQuery, GetDeviceIdQueryVariables>(GetDeviceIdDocument, options);
        }
export type GetDeviceIdQueryHookResult = ReturnType<typeof useGetDeviceIdQuery>;
export type GetDeviceIdLazyQueryHookResult = ReturnType<typeof useGetDeviceIdLazyQuery>;
export type GetDeviceIdQueryResult = Apollo.QueryResult<GetDeviceIdQuery, GetDeviceIdQueryVariables>;
export function refetchGetDeviceIdQuery(variables: GetDeviceIdQueryVariables) {
      return { query: GetDeviceIdDocument, variables: variables }
    }
export const IntersectionNameDocument = gql`
    query IntersectionName($id: ID!) {
  intersection(id: $id) {
    id
    details {
      name
    }
  }
}
    `;

/**
 * __useIntersectionNameQuery__
 *
 * To run a query within a React component, call `useIntersectionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionNameQuery(baseOptions: Apollo.QueryHookOptions<IntersectionNameQuery, IntersectionNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionNameQuery, IntersectionNameQueryVariables>(IntersectionNameDocument, options);
      }
export function useIntersectionNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionNameQuery, IntersectionNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionNameQuery, IntersectionNameQueryVariables>(IntersectionNameDocument, options);
        }
export type IntersectionNameQueryHookResult = ReturnType<typeof useIntersectionNameQuery>;
export type IntersectionNameLazyQueryHookResult = ReturnType<typeof useIntersectionNameLazyQuery>;
export type IntersectionNameQueryResult = Apollo.QueryResult<IntersectionNameQuery, IntersectionNameQueryVariables>;
export function refetchIntersectionNameQuery(variables: IntersectionNameQueryVariables) {
      return { query: IntersectionNameDocument, variables: variables }
    }
export const TimeOfDayWidgetIntersectionDocument = gql`
    query TimeOfDayWidgetIntersection($id: ID!) {
  intersection(id: $id) {
    devices {
      id
      type
    }
  }
}
    `;

/**
 * __useTimeOfDayWidgetIntersectionQuery__
 *
 * To run a query within a React component, call `useTimeOfDayWidgetIntersectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeOfDayWidgetIntersectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeOfDayWidgetIntersectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeOfDayWidgetIntersectionQuery(baseOptions: Apollo.QueryHookOptions<TimeOfDayWidgetIntersectionQuery, TimeOfDayWidgetIntersectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeOfDayWidgetIntersectionQuery, TimeOfDayWidgetIntersectionQueryVariables>(TimeOfDayWidgetIntersectionDocument, options);
      }
export function useTimeOfDayWidgetIntersectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeOfDayWidgetIntersectionQuery, TimeOfDayWidgetIntersectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeOfDayWidgetIntersectionQuery, TimeOfDayWidgetIntersectionQueryVariables>(TimeOfDayWidgetIntersectionDocument, options);
        }
export type TimeOfDayWidgetIntersectionQueryHookResult = ReturnType<typeof useTimeOfDayWidgetIntersectionQuery>;
export type TimeOfDayWidgetIntersectionLazyQueryHookResult = ReturnType<typeof useTimeOfDayWidgetIntersectionLazyQuery>;
export type TimeOfDayWidgetIntersectionQueryResult = Apollo.QueryResult<TimeOfDayWidgetIntersectionQuery, TimeOfDayWidgetIntersectionQueryVariables>;
export function refetchTimeOfDayWidgetIntersectionQuery(variables: TimeOfDayWidgetIntersectionQueryVariables) {
      return { query: TimeOfDayWidgetIntersectionDocument, variables: variables }
    }
export const IntersectionTooltipDocument = gql`
    query IntersectionTooltip($id: ID!) {
  intersection(id: $id) {
    locationId
    details {
      name
    }
    devices {
      type
    }
    devices {
      name
      connectionInfo
      fieldEntityProtocol
    }
    locationId
  }
}
    `;

/**
 * __useIntersectionTooltipQuery__
 *
 * To run a query within a React component, call `useIntersectionTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionTooltipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionTooltipQuery(baseOptions: Apollo.QueryHookOptions<IntersectionTooltipQuery, IntersectionTooltipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionTooltipQuery, IntersectionTooltipQueryVariables>(IntersectionTooltipDocument, options);
      }
export function useIntersectionTooltipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionTooltipQuery, IntersectionTooltipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionTooltipQuery, IntersectionTooltipQueryVariables>(IntersectionTooltipDocument, options);
        }
export type IntersectionTooltipQueryHookResult = ReturnType<typeof useIntersectionTooltipQuery>;
export type IntersectionTooltipLazyQueryHookResult = ReturnType<typeof useIntersectionTooltipLazyQuery>;
export type IntersectionTooltipQueryResult = Apollo.QueryResult<IntersectionTooltipQuery, IntersectionTooltipQueryVariables>;
export function refetchIntersectionTooltipQuery(variables: IntersectionTooltipQueryVariables) {
      return { query: IntersectionTooltipDocument, variables: variables }
    }
export const MiniMapIntersectionDocument = gql`
    query MiniMapIntersection($id: ID!) {
  intersection(id: $id) {
    ...MiniMapIntersection
  }
}
    ${MiniMapIntersectionFragmentDoc}`;

/**
 * __useMiniMapIntersectionQuery__
 *
 * To run a query within a React component, call `useMiniMapIntersectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMiniMapIntersectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMiniMapIntersectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMiniMapIntersectionQuery(baseOptions: Apollo.QueryHookOptions<MiniMapIntersectionQuery, MiniMapIntersectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MiniMapIntersectionQuery, MiniMapIntersectionQueryVariables>(MiniMapIntersectionDocument, options);
      }
export function useMiniMapIntersectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MiniMapIntersectionQuery, MiniMapIntersectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MiniMapIntersectionQuery, MiniMapIntersectionQueryVariables>(MiniMapIntersectionDocument, options);
        }
export type MiniMapIntersectionQueryHookResult = ReturnType<typeof useMiniMapIntersectionQuery>;
export type MiniMapIntersectionLazyQueryHookResult = ReturnType<typeof useMiniMapIntersectionLazyQuery>;
export type MiniMapIntersectionQueryResult = Apollo.QueryResult<MiniMapIntersectionQuery, MiniMapIntersectionQueryVariables>;
export function refetchMiniMapIntersectionQuery(variables: MiniMapIntersectionQueryVariables) {
      return { query: MiniMapIntersectionDocument, variables: variables }
    }
export const MainMapCloneIntersectionDocument = gql`
    query MainMapCloneIntersection($id: ID!) {
  intersection(id: $id) {
    id
    location
    locationId
    details {
      name
    }
  }
}
    `;

/**
 * __useMainMapCloneIntersectionQuery__
 *
 * To run a query within a React component, call `useMainMapCloneIntersectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainMapCloneIntersectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainMapCloneIntersectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMainMapCloneIntersectionQuery(baseOptions: Apollo.QueryHookOptions<MainMapCloneIntersectionQuery, MainMapCloneIntersectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainMapCloneIntersectionQuery, MainMapCloneIntersectionQueryVariables>(MainMapCloneIntersectionDocument, options);
      }
export function useMainMapCloneIntersectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainMapCloneIntersectionQuery, MainMapCloneIntersectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainMapCloneIntersectionQuery, MainMapCloneIntersectionQueryVariables>(MainMapCloneIntersectionDocument, options);
        }
export type MainMapCloneIntersectionQueryHookResult = ReturnType<typeof useMainMapCloneIntersectionQuery>;
export type MainMapCloneIntersectionLazyQueryHookResult = ReturnType<typeof useMainMapCloneIntersectionLazyQuery>;
export type MainMapCloneIntersectionQueryResult = Apollo.QueryResult<MainMapCloneIntersectionQuery, MainMapCloneIntersectionQueryVariables>;
export function refetchMainMapCloneIntersectionQuery(variables: MainMapCloneIntersectionQueryVariables) {
      return { query: MainMapCloneIntersectionDocument, variables: variables }
    }
export const IntersectionListDocument = gql`
    query IntersectionList($searchFields: [String!] = ["details.name", "details.note", "details.mainStreet", "devices.name", "statusCategory"], $sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  intersections(
    searchFields: $searchFields
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        id
        location
        locationId
        details {
          name
          mainStreet
          sideStreet
          note
          labels
        }
        devices {
          id
          name
          connectionInfo
          fieldEntityProtocol
        }
        statusCategory
      }
      __typename
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useIntersectionListQuery__
 *
 * To run a query within a React component, call `useIntersectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useIntersectionListQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionListQuery, IntersectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionListQuery, IntersectionListQueryVariables>(IntersectionListDocument, options);
      }
export function useIntersectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionListQuery, IntersectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionListQuery, IntersectionListQueryVariables>(IntersectionListDocument, options);
        }
export type IntersectionListQueryHookResult = ReturnType<typeof useIntersectionListQuery>;
export type IntersectionListLazyQueryHookResult = ReturnType<typeof useIntersectionListLazyQuery>;
export type IntersectionListQueryResult = Apollo.QueryResult<IntersectionListQuery, IntersectionListQueryVariables>;
export function refetchIntersectionListQuery(variables?: IntersectionListQueryVariables) {
      return { query: IntersectionListDocument, variables: variables }
    }
export const IntersectionTemplateDocument = gql`
    query IntersectionTemplate($id: ID!) {
  intersectionTemplate(id: $id) {
    id
    name
    description
    template {
      ...BaseSignalTemplateDetail
    }
  }
}
    ${BaseSignalTemplateDetailFragmentDoc}`;

/**
 * __useIntersectionTemplateQuery__
 *
 * To run a query within a React component, call `useIntersectionTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionTemplateQuery(baseOptions: Apollo.QueryHookOptions<IntersectionTemplateQuery, IntersectionTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionTemplateQuery, IntersectionTemplateQueryVariables>(IntersectionTemplateDocument, options);
      }
export function useIntersectionTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionTemplateQuery, IntersectionTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionTemplateQuery, IntersectionTemplateQueryVariables>(IntersectionTemplateDocument, options);
        }
export type IntersectionTemplateQueryHookResult = ReturnType<typeof useIntersectionTemplateQuery>;
export type IntersectionTemplateLazyQueryHookResult = ReturnType<typeof useIntersectionTemplateLazyQuery>;
export type IntersectionTemplateQueryResult = Apollo.QueryResult<IntersectionTemplateQuery, IntersectionTemplateQueryVariables>;
export function refetchIntersectionTemplateQuery(variables: IntersectionTemplateQueryVariables) {
      return { query: IntersectionTemplateDocument, variables: variables }
    }
export const IntersectionTemplatesDocument = gql`
    query IntersectionTemplates($after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $searchText: String, $filters: [FilterInput]) {
  intersectionTemplates(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, sortField: $sortField, filters: $filters}
  ) {
    edges {
      node {
        id
        name
        description
        template {
          ...BaseSignalTemplateDetail
        }
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${BaseSignalTemplateDetailFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useIntersectionTemplatesQuery__
 *
 * To run a query within a React component, call `useIntersectionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionTemplatesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useIntersectionTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionTemplatesQuery, IntersectionTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionTemplatesQuery, IntersectionTemplatesQueryVariables>(IntersectionTemplatesDocument, options);
      }
export function useIntersectionTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionTemplatesQuery, IntersectionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionTemplatesQuery, IntersectionTemplatesQueryVariables>(IntersectionTemplatesDocument, options);
        }
export type IntersectionTemplatesQueryHookResult = ReturnType<typeof useIntersectionTemplatesQuery>;
export type IntersectionTemplatesLazyQueryHookResult = ReturnType<typeof useIntersectionTemplatesLazyQuery>;
export type IntersectionTemplatesQueryResult = Apollo.QueryResult<IntersectionTemplatesQuery, IntersectionTemplatesQueryVariables>;
export function refetchIntersectionTemplatesQuery(variables?: IntersectionTemplatesQueryVariables) {
      return { query: IntersectionTemplatesDocument, variables: variables }
    }
export const IntersectionIconListDocument = gql`
    query IntersectionIconList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  intersections(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        icons {
          ...IntersectionIcon
        }
        id
        lanes {
          id
          description
          location
          laneDirection
          travelDirection
          vehicleDetectors {
            description
            distance
            length
            icon {
              ...IntersectionIcon
            }
            location
            number
            showOnMap
            type
            width
          }
        }
        location
      }
    }
  }
}
    ${IntersectionIconFragmentDoc}`;

/**
 * __useIntersectionIconListQuery__
 *
 * To run a query within a React component, call `useIntersectionIconListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionIconListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionIconListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useIntersectionIconListQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionIconListQuery, IntersectionIconListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionIconListQuery, IntersectionIconListQueryVariables>(IntersectionIconListDocument, options);
      }
export function useIntersectionIconListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionIconListQuery, IntersectionIconListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionIconListQuery, IntersectionIconListQueryVariables>(IntersectionIconListDocument, options);
        }
export type IntersectionIconListQueryHookResult = ReturnType<typeof useIntersectionIconListQuery>;
export type IntersectionIconListLazyQueryHookResult = ReturnType<typeof useIntersectionIconListLazyQuery>;
export type IntersectionIconListQueryResult = Apollo.QueryResult<IntersectionIconListQuery, IntersectionIconListQueryVariables>;
export function refetchIntersectionIconListQuery(variables?: IntersectionIconListQueryVariables) {
      return { query: IntersectionIconListDocument, variables: variables }
    }
export const IntersectionNamesDocument = gql`
    query intersectionNames($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $limit: Int = 10, $before: String, $after: String) {
  intersections(
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        id
        details {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useIntersectionNamesQuery__
 *
 * To run a query within a React component, call `useIntersectionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionNamesQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useIntersectionNamesQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionNamesQuery, IntersectionNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionNamesQuery, IntersectionNamesQueryVariables>(IntersectionNamesDocument, options);
      }
export function useIntersectionNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionNamesQuery, IntersectionNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionNamesQuery, IntersectionNamesQueryVariables>(IntersectionNamesDocument, options);
        }
export type IntersectionNamesQueryHookResult = ReturnType<typeof useIntersectionNamesQuery>;
export type IntersectionNamesLazyQueryHookResult = ReturnType<typeof useIntersectionNamesLazyQuery>;
export type IntersectionNamesQueryResult = Apollo.QueryResult<IntersectionNamesQuery, IntersectionNamesQueryVariables>;
export function refetchIntersectionNamesQuery(variables?: IntersectionNamesQueryVariables) {
      return { query: IntersectionNamesDocument, variables: variables }
    }
export const SaveLocationCorridorDocument = gql`
    mutation SaveLocationCorridor($input: LocationCorridorInput!) {
  saveLocationCorridor(input: $input) {
    id
    name
    entryLeg {
      id
    }
    exitLeg {
      id
    }
    links {
      link {
        id
      }
      linkOrder
      downLinkLane {
        id
      }
      upLinkLane {
        id
      }
    }
  }
}
    `;
export type SaveLocationCorridorMutationFn = Apollo.MutationFunction<SaveLocationCorridorMutation, SaveLocationCorridorMutationVariables>;

/**
 * __useSaveLocationCorridorMutation__
 *
 * To run a mutation, you first call `useSaveLocationCorridorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationCorridorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationCorridorMutation, { data, loading, error }] = useSaveLocationCorridorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLocationCorridorMutation(baseOptions?: Apollo.MutationHookOptions<SaveLocationCorridorMutation, SaveLocationCorridorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLocationCorridorMutation, SaveLocationCorridorMutationVariables>(SaveLocationCorridorDocument, options);
      }
export type SaveLocationCorridorMutationHookResult = ReturnType<typeof useSaveLocationCorridorMutation>;
export type SaveLocationCorridorMutationResult = Apollo.MutationResult<SaveLocationCorridorMutation>;
export type SaveLocationCorridorMutationOptions = Apollo.BaseMutationOptions<SaveLocationCorridorMutation, SaveLocationCorridorMutationVariables>;
export const DeleteLocationCorridorDocument = gql`
    mutation DeleteLocationCorridor($id: ID!) {
  deleteLocationCorridor(id: $id)
}
    `;
export type DeleteLocationCorridorMutationFn = Apollo.MutationFunction<DeleteLocationCorridorMutation, DeleteLocationCorridorMutationVariables>;

/**
 * __useDeleteLocationCorridorMutation__
 *
 * To run a mutation, you first call `useDeleteLocationCorridorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationCorridorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationCorridorMutation, { data, loading, error }] = useDeleteLocationCorridorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationCorridorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationCorridorMutation, DeleteLocationCorridorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationCorridorMutation, DeleteLocationCorridorMutationVariables>(DeleteLocationCorridorDocument, options);
      }
export type DeleteLocationCorridorMutationHookResult = ReturnType<typeof useDeleteLocationCorridorMutation>;
export type DeleteLocationCorridorMutationResult = Apollo.MutationResult<DeleteLocationCorridorMutation>;
export type DeleteLocationCorridorMutationOptions = Apollo.BaseMutationOptions<DeleteLocationCorridorMutation, DeleteLocationCorridorMutationVariables>;
export const LocationCorridorsListDocument = gql`
    query LocationCorridorsList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  locationCorridors(
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    searchText: $searchText
    limit: $limit
    before: $before
    after: $after
  ) {
    edges {
      node {
        id
        name
        entryLeg {
          id
          name
          location {
            details {
              name
            }
          }
        }
        exitLeg {
          id
          name
          location {
            details {
              name
            }
          }
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useLocationCorridorsListQuery__
 *
 * To run a query within a React component, call `useLocationCorridorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationCorridorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationCorridorsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLocationCorridorsListQuery(baseOptions?: Apollo.QueryHookOptions<LocationCorridorsListQuery, LocationCorridorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationCorridorsListQuery, LocationCorridorsListQueryVariables>(LocationCorridorsListDocument, options);
      }
export function useLocationCorridorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationCorridorsListQuery, LocationCorridorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationCorridorsListQuery, LocationCorridorsListQueryVariables>(LocationCorridorsListDocument, options);
        }
export type LocationCorridorsListQueryHookResult = ReturnType<typeof useLocationCorridorsListQuery>;
export type LocationCorridorsListLazyQueryHookResult = ReturnType<typeof useLocationCorridorsListLazyQuery>;
export type LocationCorridorsListQueryResult = Apollo.QueryResult<LocationCorridorsListQuery, LocationCorridorsListQueryVariables>;
export function refetchLocationCorridorsListQuery(variables?: LocationCorridorsListQueryVariables) {
      return { query: LocationCorridorsListDocument, variables: variables }
    }
export const GetLocationCorridorDocument = gql`
    query GetLocationCorridor($id: ID!) {
  locationCorridor(id: $id) {
    id
    name
    entryLeg {
      id
    }
    exitLeg {
      id
    }
    links {
      downLinkLane {
        id
      }
      link {
        id
        name
        linkLanes {
          id
          geometry
          occupancy
          departureLeg {
            id
            location {
              details {
                name
              }
            }
          }
          approachLeg {
            id
            location {
              details {
                name
              }
            }
          }
        }
      }
      upLinkLane {
        id
      }
      linkOrder
    }
  }
}
    `;

/**
 * __useGetLocationCorridorQuery__
 *
 * To run a query within a React component, call `useGetLocationCorridorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationCorridorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationCorridorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationCorridorQuery(baseOptions: Apollo.QueryHookOptions<GetLocationCorridorQuery, GetLocationCorridorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationCorridorQuery, GetLocationCorridorQueryVariables>(GetLocationCorridorDocument, options);
      }
export function useGetLocationCorridorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationCorridorQuery, GetLocationCorridorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationCorridorQuery, GetLocationCorridorQueryVariables>(GetLocationCorridorDocument, options);
        }
export type GetLocationCorridorQueryHookResult = ReturnType<typeof useGetLocationCorridorQuery>;
export type GetLocationCorridorLazyQueryHookResult = ReturnType<typeof useGetLocationCorridorLazyQuery>;
export type GetLocationCorridorQueryResult = Apollo.QueryResult<GetLocationCorridorQuery, GetLocationCorridorQueryVariables>;
export function refetchGetLocationCorridorQuery(variables: GetLocationCorridorQueryVariables) {
      return { query: GetLocationCorridorDocument, variables: variables }
    }
export const GetMainMapLocationCorridorsDocument = gql`
    query GetMainMapLocationCorridors {
  locationCorridors(limit: 10000) {
    edges {
      node {
        id
        name
        entryLeg {
          id
          name
        }
        exitLeg {
          id
          name
        }
        links {
          linkOrder
          link {
            id
            linkLanes {
              id
              geometry
              congestionColor
              occupancy
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMainMapLocationCorridorsQuery__
 *
 * To run a query within a React component, call `useGetMainMapLocationCorridorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainMapLocationCorridorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainMapLocationCorridorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMainMapLocationCorridorsQuery(baseOptions?: Apollo.QueryHookOptions<GetMainMapLocationCorridorsQuery, GetMainMapLocationCorridorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainMapLocationCorridorsQuery, GetMainMapLocationCorridorsQueryVariables>(GetMainMapLocationCorridorsDocument, options);
      }
export function useGetMainMapLocationCorridorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainMapLocationCorridorsQuery, GetMainMapLocationCorridorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainMapLocationCorridorsQuery, GetMainMapLocationCorridorsQueryVariables>(GetMainMapLocationCorridorsDocument, options);
        }
export type GetMainMapLocationCorridorsQueryHookResult = ReturnType<typeof useGetMainMapLocationCorridorsQuery>;
export type GetMainMapLocationCorridorsLazyQueryHookResult = ReturnType<typeof useGetMainMapLocationCorridorsLazyQuery>;
export type GetMainMapLocationCorridorsQueryResult = Apollo.QueryResult<GetMainMapLocationCorridorsQuery, GetMainMapLocationCorridorsQueryVariables>;
export function refetchGetMainMapLocationCorridorsQuery(variables?: GetMainMapLocationCorridorsQueryVariables) {
      return { query: GetMainMapLocationCorridorsDocument, variables: variables }
    }
export const GetMainMapLocationCorridorsLinkDocument = gql`
    query GetMainMapLocationCorridorsLink($filters: [FilterInput!], $limit: Int = 10) {
  locationCorridors(filters: $filters, limit: $limit) {
    edges {
      node {
        id
        name
        links {
          link {
            id
            name
            linkLanes {
              id
              geometry
              occupancy
              congestionColor
              departureLeg {
                id
                location {
                  details {
                    name
                  }
                }
              }
              approachLeg {
                id
                location {
                  details {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMainMapLocationCorridorsLinkQuery__
 *
 * To run a query within a React component, call `useGetMainMapLocationCorridorsLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainMapLocationCorridorsLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainMapLocationCorridorsLinkQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMainMapLocationCorridorsLinkQuery(baseOptions?: Apollo.QueryHookOptions<GetMainMapLocationCorridorsLinkQuery, GetMainMapLocationCorridorsLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainMapLocationCorridorsLinkQuery, GetMainMapLocationCorridorsLinkQueryVariables>(GetMainMapLocationCorridorsLinkDocument, options);
      }
export function useGetMainMapLocationCorridorsLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainMapLocationCorridorsLinkQuery, GetMainMapLocationCorridorsLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainMapLocationCorridorsLinkQuery, GetMainMapLocationCorridorsLinkQueryVariables>(GetMainMapLocationCorridorsLinkDocument, options);
        }
export type GetMainMapLocationCorridorsLinkQueryHookResult = ReturnType<typeof useGetMainMapLocationCorridorsLinkQuery>;
export type GetMainMapLocationCorridorsLinkLazyQueryHookResult = ReturnType<typeof useGetMainMapLocationCorridorsLinkLazyQuery>;
export type GetMainMapLocationCorridorsLinkQueryResult = Apollo.QueryResult<GetMainMapLocationCorridorsLinkQuery, GetMainMapLocationCorridorsLinkQueryVariables>;
export function refetchGetMainMapLocationCorridorsLinkQuery(variables?: GetMainMapLocationCorridorsLinkQueryVariables) {
      return { query: GetMainMapLocationCorridorsLinkDocument, variables: variables }
    }
export const SaveLocationCorridorLegDocument = gql`
    mutation SaveLocationCorridorLeg($input: LocationCorridorLegInput!) {
  saveLocationCorridorLeg(input: $input) {
    id
  }
}
    `;
export type SaveLocationCorridorLegMutationFn = Apollo.MutationFunction<SaveLocationCorridorLegMutation, SaveLocationCorridorLegMutationVariables>;

/**
 * __useSaveLocationCorridorLegMutation__
 *
 * To run a mutation, you first call `useSaveLocationCorridorLegMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationCorridorLegMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationCorridorLegMutation, { data, loading, error }] = useSaveLocationCorridorLegMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLocationCorridorLegMutation(baseOptions?: Apollo.MutationHookOptions<SaveLocationCorridorLegMutation, SaveLocationCorridorLegMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLocationCorridorLegMutation, SaveLocationCorridorLegMutationVariables>(SaveLocationCorridorLegDocument, options);
      }
export type SaveLocationCorridorLegMutationHookResult = ReturnType<typeof useSaveLocationCorridorLegMutation>;
export type SaveLocationCorridorLegMutationResult = Apollo.MutationResult<SaveLocationCorridorLegMutation>;
export type SaveLocationCorridorLegMutationOptions = Apollo.BaseMutationOptions<SaveLocationCorridorLegMutation, SaveLocationCorridorLegMutationVariables>;
export const DeleteLocationCorridorLegDocument = gql`
    mutation DeleteLocationCorridorLeg($id: ID!) {
  deleteLocationCorridorLeg(id: $id)
}
    `;
export type DeleteLocationCorridorLegMutationFn = Apollo.MutationFunction<DeleteLocationCorridorLegMutation, DeleteLocationCorridorLegMutationVariables>;

/**
 * __useDeleteLocationCorridorLegMutation__
 *
 * To run a mutation, you first call `useDeleteLocationCorridorLegMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationCorridorLegMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationCorridorLegMutation, { data, loading, error }] = useDeleteLocationCorridorLegMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationCorridorLegMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationCorridorLegMutation, DeleteLocationCorridorLegMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationCorridorLegMutation, DeleteLocationCorridorLegMutationVariables>(DeleteLocationCorridorLegDocument, options);
      }
export type DeleteLocationCorridorLegMutationHookResult = ReturnType<typeof useDeleteLocationCorridorLegMutation>;
export type DeleteLocationCorridorLegMutationResult = Apollo.MutationResult<DeleteLocationCorridorLegMutation>;
export type DeleteLocationCorridorLegMutationOptions = Apollo.BaseMutationOptions<DeleteLocationCorridorLegMutation, DeleteLocationCorridorLegMutationVariables>;
export const LocationCorridorsLegsListDocument = gql`
    query LocationCorridorsLegsList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  locationCorridorLegs(
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    searchText: $searchText
    limit: $limit
    before: $before
    after: $after
  ) {
    edges {
      node {
        id
        name
        location {
          details {
            name
          }
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useLocationCorridorsLegsListQuery__
 *
 * To run a query within a React component, call `useLocationCorridorsLegsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationCorridorsLegsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationCorridorsLegsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLocationCorridorsLegsListQuery(baseOptions?: Apollo.QueryHookOptions<LocationCorridorsLegsListQuery, LocationCorridorsLegsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationCorridorsLegsListQuery, LocationCorridorsLegsListQueryVariables>(LocationCorridorsLegsListDocument, options);
      }
export function useLocationCorridorsLegsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationCorridorsLegsListQuery, LocationCorridorsLegsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationCorridorsLegsListQuery, LocationCorridorsLegsListQueryVariables>(LocationCorridorsLegsListDocument, options);
        }
export type LocationCorridorsLegsListQueryHookResult = ReturnType<typeof useLocationCorridorsLegsListQuery>;
export type LocationCorridorsLegsListLazyQueryHookResult = ReturnType<typeof useLocationCorridorsLegsListLazyQuery>;
export type LocationCorridorsLegsListQueryResult = Apollo.QueryResult<LocationCorridorsLegsListQuery, LocationCorridorsLegsListQueryVariables>;
export function refetchLocationCorridorsLegsListQuery(variables?: LocationCorridorsLegsListQueryVariables) {
      return { query: LocationCorridorsLegsListDocument, variables: variables }
    }
export const GetAllLocationCorridorMapLegsDocument = gql`
    query GetAllLocationCorridorMapLegs($limit: Int = 10000) {
  locationCorridorLegs(limit: $limit) {
    edges {
      node {
        id
        name
        approachGeometry
        departureGeometry
        location {
          id
          details {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllLocationCorridorMapLegsQuery__
 *
 * To run a query within a React component, call `useGetAllLocationCorridorMapLegsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationCorridorMapLegsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationCorridorMapLegsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllLocationCorridorMapLegsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLocationCorridorMapLegsQuery, GetAllLocationCorridorMapLegsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationCorridorMapLegsQuery, GetAllLocationCorridorMapLegsQueryVariables>(GetAllLocationCorridorMapLegsDocument, options);
      }
export function useGetAllLocationCorridorMapLegsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationCorridorMapLegsQuery, GetAllLocationCorridorMapLegsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationCorridorMapLegsQuery, GetAllLocationCorridorMapLegsQueryVariables>(GetAllLocationCorridorMapLegsDocument, options);
        }
export type GetAllLocationCorridorMapLegsQueryHookResult = ReturnType<typeof useGetAllLocationCorridorMapLegsQuery>;
export type GetAllLocationCorridorMapLegsLazyQueryHookResult = ReturnType<typeof useGetAllLocationCorridorMapLegsLazyQuery>;
export type GetAllLocationCorridorMapLegsQueryResult = Apollo.QueryResult<GetAllLocationCorridorMapLegsQuery, GetAllLocationCorridorMapLegsQueryVariables>;
export function refetchGetAllLocationCorridorMapLegsQuery(variables?: GetAllLocationCorridorMapLegsQueryVariables) {
      return { query: GetAllLocationCorridorMapLegsDocument, variables: variables }
    }
export const LocationCorridorsLanesDocument = gql`
    query LocationCorridorsLanes($locationId: ID!) {
  location(id: $locationId) {
    id
    geometry
    lanes {
      id
      geometry
      description
      laneDirection
      travelDirection
    }
  }
}
    `;

/**
 * __useLocationCorridorsLanesQuery__
 *
 * To run a query within a React component, call `useLocationCorridorsLanesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationCorridorsLanesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationCorridorsLanesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useLocationCorridorsLanesQuery(baseOptions: Apollo.QueryHookOptions<LocationCorridorsLanesQuery, LocationCorridorsLanesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationCorridorsLanesQuery, LocationCorridorsLanesQueryVariables>(LocationCorridorsLanesDocument, options);
      }
export function useLocationCorridorsLanesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationCorridorsLanesQuery, LocationCorridorsLanesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationCorridorsLanesQuery, LocationCorridorsLanesQueryVariables>(LocationCorridorsLanesDocument, options);
        }
export type LocationCorridorsLanesQueryHookResult = ReturnType<typeof useLocationCorridorsLanesQuery>;
export type LocationCorridorsLanesLazyQueryHookResult = ReturnType<typeof useLocationCorridorsLanesLazyQuery>;
export type LocationCorridorsLanesQueryResult = Apollo.QueryResult<LocationCorridorsLanesQuery, LocationCorridorsLanesQueryVariables>;
export function refetchLocationCorridorsLanesQuery(variables: LocationCorridorsLanesQueryVariables) {
      return { query: LocationCorridorsLanesDocument, variables: variables }
    }
export const EditLocationCorridorsLegDocument = gql`
    query EditLocationCorridorsLeg($id: ID!) {
  locationCorridorLeg(id: $id) {
    id
    name
    location {
      id
      details {
        name
      }
      geometry
    }
    approachGeometry
    departureGeometry
    lanes {
      id
      geometry
      description
      laneDirection
      travelDirection
    }
  }
}
    `;

/**
 * __useEditLocationCorridorsLegQuery__
 *
 * To run a query within a React component, call `useEditLocationCorridorsLegQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditLocationCorridorsLegQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditLocationCorridorsLegQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditLocationCorridorsLegQuery(baseOptions: Apollo.QueryHookOptions<EditLocationCorridorsLegQuery, EditLocationCorridorsLegQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditLocationCorridorsLegQuery, EditLocationCorridorsLegQueryVariables>(EditLocationCorridorsLegDocument, options);
      }
export function useEditLocationCorridorsLegLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditLocationCorridorsLegQuery, EditLocationCorridorsLegQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditLocationCorridorsLegQuery, EditLocationCorridorsLegQueryVariables>(EditLocationCorridorsLegDocument, options);
        }
export type EditLocationCorridorsLegQueryHookResult = ReturnType<typeof useEditLocationCorridorsLegQuery>;
export type EditLocationCorridorsLegLazyQueryHookResult = ReturnType<typeof useEditLocationCorridorsLegLazyQuery>;
export type EditLocationCorridorsLegQueryResult = Apollo.QueryResult<EditLocationCorridorsLegQuery, EditLocationCorridorsLegQueryVariables>;
export function refetchEditLocationCorridorsLegQuery(variables: EditLocationCorridorsLegQueryVariables) {
      return { query: EditLocationCorridorsLegDocument, variables: variables }
    }
export const GetLocationCorridorLegLocationNameDocument = gql`
    query GetLocationCorridorLegLocationName($id: ID!) {
  locationCorridorLeg(id: $id) {
    name
    location {
      details {
        name
      }
    }
  }
}
    `;

/**
 * __useGetLocationCorridorLegLocationNameQuery__
 *
 * To run a query within a React component, call `useGetLocationCorridorLegLocationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationCorridorLegLocationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationCorridorLegLocationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationCorridorLegLocationNameQuery(baseOptions: Apollo.QueryHookOptions<GetLocationCorridorLegLocationNameQuery, GetLocationCorridorLegLocationNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationCorridorLegLocationNameQuery, GetLocationCorridorLegLocationNameQueryVariables>(GetLocationCorridorLegLocationNameDocument, options);
      }
export function useGetLocationCorridorLegLocationNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationCorridorLegLocationNameQuery, GetLocationCorridorLegLocationNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationCorridorLegLocationNameQuery, GetLocationCorridorLegLocationNameQueryVariables>(GetLocationCorridorLegLocationNameDocument, options);
        }
export type GetLocationCorridorLegLocationNameQueryHookResult = ReturnType<typeof useGetLocationCorridorLegLocationNameQuery>;
export type GetLocationCorridorLegLocationNameLazyQueryHookResult = ReturnType<typeof useGetLocationCorridorLegLocationNameLazyQuery>;
export type GetLocationCorridorLegLocationNameQueryResult = Apollo.QueryResult<GetLocationCorridorLegLocationNameQuery, GetLocationCorridorLegLocationNameQueryVariables>;
export function refetchGetLocationCorridorLegLocationNameQuery(variables: GetLocationCorridorLegLocationNameQueryVariables) {
      return { query: GetLocationCorridorLegLocationNameDocument, variables: variables }
    }
export const GetLocationCorridorLegTailDataDocument = gql`
    query GetLocationCorridorLegTailData($ids: Object!) {
  locationCorridorLegs(filters: [{operator: IN, field: "id", value: $ids}]) {
    edges {
      node {
        id
        name
        location {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationCorridorLegTailDataQuery__
 *
 * To run a query within a React component, call `useGetLocationCorridorLegTailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationCorridorLegTailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationCorridorLegTailDataQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetLocationCorridorLegTailDataQuery(baseOptions: Apollo.QueryHookOptions<GetLocationCorridorLegTailDataQuery, GetLocationCorridorLegTailDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationCorridorLegTailDataQuery, GetLocationCorridorLegTailDataQueryVariables>(GetLocationCorridorLegTailDataDocument, options);
      }
export function useGetLocationCorridorLegTailDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationCorridorLegTailDataQuery, GetLocationCorridorLegTailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationCorridorLegTailDataQuery, GetLocationCorridorLegTailDataQueryVariables>(GetLocationCorridorLegTailDataDocument, options);
        }
export type GetLocationCorridorLegTailDataQueryHookResult = ReturnType<typeof useGetLocationCorridorLegTailDataQuery>;
export type GetLocationCorridorLegTailDataLazyQueryHookResult = ReturnType<typeof useGetLocationCorridorLegTailDataLazyQuery>;
export type GetLocationCorridorLegTailDataQueryResult = Apollo.QueryResult<GetLocationCorridorLegTailDataQuery, GetLocationCorridorLegTailDataQueryVariables>;
export function refetchGetLocationCorridorLegTailDataQuery(variables: GetLocationCorridorLegTailDataQueryVariables) {
      return { query: GetLocationCorridorLegTailDataDocument, variables: variables }
    }
export const GetLocationCorridorLegTooltipDocument = gql`
    query GetLocationCorridorLegTooltip($id: ID!) {
  locationCorridorLeg(id: $id) {
    name
    location {
      details {
        name
      }
    }
    lanes {
      description
      laneDirection
      travelDirection
    }
  }
}
    `;

/**
 * __useGetLocationCorridorLegTooltipQuery__
 *
 * To run a query within a React component, call `useGetLocationCorridorLegTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationCorridorLegTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationCorridorLegTooltipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationCorridorLegTooltipQuery(baseOptions: Apollo.QueryHookOptions<GetLocationCorridorLegTooltipQuery, GetLocationCorridorLegTooltipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationCorridorLegTooltipQuery, GetLocationCorridorLegTooltipQueryVariables>(GetLocationCorridorLegTooltipDocument, options);
      }
export function useGetLocationCorridorLegTooltipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationCorridorLegTooltipQuery, GetLocationCorridorLegTooltipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationCorridorLegTooltipQuery, GetLocationCorridorLegTooltipQueryVariables>(GetLocationCorridorLegTooltipDocument, options);
        }
export type GetLocationCorridorLegTooltipQueryHookResult = ReturnType<typeof useGetLocationCorridorLegTooltipQuery>;
export type GetLocationCorridorLegTooltipLazyQueryHookResult = ReturnType<typeof useGetLocationCorridorLegTooltipLazyQuery>;
export type GetLocationCorridorLegTooltipQueryResult = Apollo.QueryResult<GetLocationCorridorLegTooltipQuery, GetLocationCorridorLegTooltipQueryVariables>;
export function refetchGetLocationCorridorLegTooltipQuery(variables: GetLocationCorridorLegTooltipQueryVariables) {
      return { query: GetLocationCorridorLegTooltipDocument, variables: variables }
    }
export const DeleteLocationCorridorLinkDocument = gql`
    mutation DeleteLocationCorridorLink($id: ID!) {
  deleteLocationCorridorLink(id: $id)
}
    `;
export type DeleteLocationCorridorLinkMutationFn = Apollo.MutationFunction<DeleteLocationCorridorLinkMutation, DeleteLocationCorridorLinkMutationVariables>;

/**
 * __useDeleteLocationCorridorLinkMutation__
 *
 * To run a mutation, you first call `useDeleteLocationCorridorLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationCorridorLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationCorridorLinkMutation, { data, loading, error }] = useDeleteLocationCorridorLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationCorridorLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationCorridorLinkMutation, DeleteLocationCorridorLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationCorridorLinkMutation, DeleteLocationCorridorLinkMutationVariables>(DeleteLocationCorridorLinkDocument, options);
      }
export type DeleteLocationCorridorLinkMutationHookResult = ReturnType<typeof useDeleteLocationCorridorLinkMutation>;
export type DeleteLocationCorridorLinkMutationResult = Apollo.MutationResult<DeleteLocationCorridorLinkMutation>;
export type DeleteLocationCorridorLinkMutationOptions = Apollo.BaseMutationOptions<DeleteLocationCorridorLinkMutation, DeleteLocationCorridorLinkMutationVariables>;
export const SaveLocationCorridorLinkDocument = gql`
    mutation SaveLocationCorridorLink($input: LocationCorridorLinkInput!) {
  saveLocationCorridorLink(input: $input) {
    id
  }
}
    `;
export type SaveLocationCorridorLinkMutationFn = Apollo.MutationFunction<SaveLocationCorridorLinkMutation, SaveLocationCorridorLinkMutationVariables>;

/**
 * __useSaveLocationCorridorLinkMutation__
 *
 * To run a mutation, you first call `useSaveLocationCorridorLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationCorridorLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationCorridorLinkMutation, { data, loading, error }] = useSaveLocationCorridorLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLocationCorridorLinkMutation(baseOptions?: Apollo.MutationHookOptions<SaveLocationCorridorLinkMutation, SaveLocationCorridorLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLocationCorridorLinkMutation, SaveLocationCorridorLinkMutationVariables>(SaveLocationCorridorLinkDocument, options);
      }
export type SaveLocationCorridorLinkMutationHookResult = ReturnType<typeof useSaveLocationCorridorLinkMutation>;
export type SaveLocationCorridorLinkMutationResult = Apollo.MutationResult<SaveLocationCorridorLinkMutation>;
export type SaveLocationCorridorLinkMutationOptions = Apollo.BaseMutationOptions<SaveLocationCorridorLinkMutation, SaveLocationCorridorLinkMutationVariables>;
export const GetLocationCorridorLinkLegLocationsDocument = gql`
    query GetLocationCorridorLinkLegLocations($approachLegId: ID!, $departureLegId: ID!) {
  approachLeg: locationCorridorLeg(id: $approachLegId) {
    approachGeometry
    departureGeometry
  }
  departureLeg: locationCorridorLeg(id: $departureLegId) {
    approachGeometry
    departureGeometry
  }
}
    `;

/**
 * __useGetLocationCorridorLinkLegLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationCorridorLinkLegLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationCorridorLinkLegLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationCorridorLinkLegLocationsQuery({
 *   variables: {
 *      approachLegId: // value for 'approachLegId'
 *      departureLegId: // value for 'departureLegId'
 *   },
 * });
 */
export function useGetLocationCorridorLinkLegLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationCorridorLinkLegLocationsQuery, GetLocationCorridorLinkLegLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationCorridorLinkLegLocationsQuery, GetLocationCorridorLinkLegLocationsQueryVariables>(GetLocationCorridorLinkLegLocationsDocument, options);
      }
export function useGetLocationCorridorLinkLegLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationCorridorLinkLegLocationsQuery, GetLocationCorridorLinkLegLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationCorridorLinkLegLocationsQuery, GetLocationCorridorLinkLegLocationsQueryVariables>(GetLocationCorridorLinkLegLocationsDocument, options);
        }
export type GetLocationCorridorLinkLegLocationsQueryHookResult = ReturnType<typeof useGetLocationCorridorLinkLegLocationsQuery>;
export type GetLocationCorridorLinkLegLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationCorridorLinkLegLocationsLazyQuery>;
export type GetLocationCorridorLinkLegLocationsQueryResult = Apollo.QueryResult<GetLocationCorridorLinkLegLocationsQuery, GetLocationCorridorLinkLegLocationsQueryVariables>;
export function refetchGetLocationCorridorLinkLegLocationsQuery(variables: GetLocationCorridorLinkLegLocationsQueryVariables) {
      return { query: GetLocationCorridorLinkLegLocationsDocument, variables: variables }
    }
export const LocationCorridorsLinksListDocument = gql`
    query LocationCorridorsLinksList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  locationCorridorLinks(
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    searchText: $searchText
    limit: $limit
    before: $before
    after: $after
  ) {
    edges {
      node {
        id
        name
        linkLanes {
          departureLeg {
            location {
              id
              details {
                name
              }
            }
          }
          approachLeg {
            location {
              id
              details {
                name
              }
            }
          }
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useLocationCorridorsLinksListQuery__
 *
 * To run a query within a React component, call `useLocationCorridorsLinksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationCorridorsLinksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationCorridorsLinksListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLocationCorridorsLinksListQuery(baseOptions?: Apollo.QueryHookOptions<LocationCorridorsLinksListQuery, LocationCorridorsLinksListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationCorridorsLinksListQuery, LocationCorridorsLinksListQueryVariables>(LocationCorridorsLinksListDocument, options);
      }
export function useLocationCorridorsLinksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationCorridorsLinksListQuery, LocationCorridorsLinksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationCorridorsLinksListQuery, LocationCorridorsLinksListQueryVariables>(LocationCorridorsLinksListDocument, options);
        }
export type LocationCorridorsLinksListQueryHookResult = ReturnType<typeof useLocationCorridorsLinksListQuery>;
export type LocationCorridorsLinksListLazyQueryHookResult = ReturnType<typeof useLocationCorridorsLinksListLazyQuery>;
export type LocationCorridorsLinksListQueryResult = Apollo.QueryResult<LocationCorridorsLinksListQuery, LocationCorridorsLinksListQueryVariables>;
export function refetchLocationCorridorsLinksListQuery(variables?: LocationCorridorsLinksListQueryVariables) {
      return { query: LocationCorridorsLinksListDocument, variables: variables }
    }
export const GetAllLocationCorridorMapLinksDocument = gql`
    query GetAllLocationCorridorMapLinks($limit: Int = 10000) {
  locationCorridorLinks(limit: $limit) {
    edges {
      node {
        id
        name
        linkLanes {
          id
          departureLeg {
            location {
              id
            }
            id
          }
          approachLeg {
            location {
              id
            }
            id
          }
          speed
          queueClearanceTime
          geometry
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllLocationCorridorMapLinksQuery__
 *
 * To run a query within a React component, call `useGetAllLocationCorridorMapLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationCorridorMapLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationCorridorMapLinksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllLocationCorridorMapLinksQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLocationCorridorMapLinksQuery, GetAllLocationCorridorMapLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationCorridorMapLinksQuery, GetAllLocationCorridorMapLinksQueryVariables>(GetAllLocationCorridorMapLinksDocument, options);
      }
export function useGetAllLocationCorridorMapLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationCorridorMapLinksQuery, GetAllLocationCorridorMapLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationCorridorMapLinksQuery, GetAllLocationCorridorMapLinksQueryVariables>(GetAllLocationCorridorMapLinksDocument, options);
        }
export type GetAllLocationCorridorMapLinksQueryHookResult = ReturnType<typeof useGetAllLocationCorridorMapLinksQuery>;
export type GetAllLocationCorridorMapLinksLazyQueryHookResult = ReturnType<typeof useGetAllLocationCorridorMapLinksLazyQuery>;
export type GetAllLocationCorridorMapLinksQueryResult = Apollo.QueryResult<GetAllLocationCorridorMapLinksQuery, GetAllLocationCorridorMapLinksQueryVariables>;
export function refetchGetAllLocationCorridorMapLinksQuery(variables?: GetAllLocationCorridorMapLinksQueryVariables) {
      return { query: GetAllLocationCorridorMapLinksDocument, variables: variables }
    }
export const EditLocationCorridorsLinkDocument = gql`
    query EditLocationCorridorsLink($id: ID!) {
  locationCorridorLink(id: $id) {
    id
    name
    linkLanes {
      id
      departureLeg {
        id
        location {
          details {
            name
          }
        }
      }
      approachLeg {
        id
        location {
          details {
            name
          }
        }
      }
      speed
      queueClearanceTime
      geometry
      detectorGroupId
    }
  }
}
    `;

/**
 * __useEditLocationCorridorsLinkQuery__
 *
 * To run a query within a React component, call `useEditLocationCorridorsLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditLocationCorridorsLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditLocationCorridorsLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditLocationCorridorsLinkQuery(baseOptions: Apollo.QueryHookOptions<EditLocationCorridorsLinkQuery, EditLocationCorridorsLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditLocationCorridorsLinkQuery, EditLocationCorridorsLinkQueryVariables>(EditLocationCorridorsLinkDocument, options);
      }
export function useEditLocationCorridorsLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditLocationCorridorsLinkQuery, EditLocationCorridorsLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditLocationCorridorsLinkQuery, EditLocationCorridorsLinkQueryVariables>(EditLocationCorridorsLinkDocument, options);
        }
export type EditLocationCorridorsLinkQueryHookResult = ReturnType<typeof useEditLocationCorridorsLinkQuery>;
export type EditLocationCorridorsLinkLazyQueryHookResult = ReturnType<typeof useEditLocationCorridorsLinkLazyQuery>;
export type EditLocationCorridorsLinkQueryResult = Apollo.QueryResult<EditLocationCorridorsLinkQuery, EditLocationCorridorsLinkQueryVariables>;
export function refetchEditLocationCorridorsLinkQuery(variables: EditLocationCorridorsLinkQueryVariables) {
      return { query: EditLocationCorridorsLinkDocument, variables: variables }
    }
export const GetLocationCorridorLinksTailDataDocument = gql`
    query GetLocationCorridorLinksTailData($ids: Object!) {
  locationCorridorLinks(
    limit: 100
    filters: [{operator: IN, field: "id", value: $ids}]
  ) {
    edges {
      node {
        id
        name
        linkLanes {
          departureLeg {
            id
            location {
              id
              details {
                name
              }
            }
          }
          approachLeg {
            id
            location {
              id
              details {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationCorridorLinksTailDataQuery__
 *
 * To run a query within a React component, call `useGetLocationCorridorLinksTailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationCorridorLinksTailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationCorridorLinksTailDataQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetLocationCorridorLinksTailDataQuery(baseOptions: Apollo.QueryHookOptions<GetLocationCorridorLinksTailDataQuery, GetLocationCorridorLinksTailDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationCorridorLinksTailDataQuery, GetLocationCorridorLinksTailDataQueryVariables>(GetLocationCorridorLinksTailDataDocument, options);
      }
export function useGetLocationCorridorLinksTailDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationCorridorLinksTailDataQuery, GetLocationCorridorLinksTailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationCorridorLinksTailDataQuery, GetLocationCorridorLinksTailDataQueryVariables>(GetLocationCorridorLinksTailDataDocument, options);
        }
export type GetLocationCorridorLinksTailDataQueryHookResult = ReturnType<typeof useGetLocationCorridorLinksTailDataQuery>;
export type GetLocationCorridorLinksTailDataLazyQueryHookResult = ReturnType<typeof useGetLocationCorridorLinksTailDataLazyQuery>;
export type GetLocationCorridorLinksTailDataQueryResult = Apollo.QueryResult<GetLocationCorridorLinksTailDataQuery, GetLocationCorridorLinksTailDataQueryVariables>;
export function refetchGetLocationCorridorLinksTailDataQuery(variables: GetLocationCorridorLinksTailDataQueryVariables) {
      return { query: GetLocationCorridorLinksTailDataDocument, variables: variables }
    }
export const GetLocationCorridorLinkDisplayDocument = gql`
    query GetLocationCorridorLinkDisplay($id: ID!) {
  locationCorridorLink(id: $id) {
    id
    name
    linkLanes {
      departureLeg {
        id
        location {
          id
          details {
            name
          }
        }
      }
      approachLeg {
        id
        location {
          id
          details {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationCorridorLinkDisplayQuery__
 *
 * To run a query within a React component, call `useGetLocationCorridorLinkDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationCorridorLinkDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationCorridorLinkDisplayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationCorridorLinkDisplayQuery(baseOptions: Apollo.QueryHookOptions<GetLocationCorridorLinkDisplayQuery, GetLocationCorridorLinkDisplayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationCorridorLinkDisplayQuery, GetLocationCorridorLinkDisplayQueryVariables>(GetLocationCorridorLinkDisplayDocument, options);
      }
export function useGetLocationCorridorLinkDisplayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationCorridorLinkDisplayQuery, GetLocationCorridorLinkDisplayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationCorridorLinkDisplayQuery, GetLocationCorridorLinkDisplayQueryVariables>(GetLocationCorridorLinkDisplayDocument, options);
        }
export type GetLocationCorridorLinkDisplayQueryHookResult = ReturnType<typeof useGetLocationCorridorLinkDisplayQuery>;
export type GetLocationCorridorLinkDisplayLazyQueryHookResult = ReturnType<typeof useGetLocationCorridorLinkDisplayLazyQuery>;
export type GetLocationCorridorLinkDisplayQueryResult = Apollo.QueryResult<GetLocationCorridorLinkDisplayQuery, GetLocationCorridorLinkDisplayQueryVariables>;
export function refetchGetLocationCorridorLinkDisplayQuery(variables: GetLocationCorridorLinkDisplayQueryVariables) {
      return { query: GetLocationCorridorLinkDisplayDocument, variables: variables }
    }
export const GetIntegrationIntersectionDocument = gql`
    query GetIntegrationIntersection($integrationId: Object!) {
  intersections(
    sortOrder: DESCENDING
    sortField: "name"
    limit: 1
    after: null
    filters: [{field: "devices.id", value: $integrationId, operator: EQUALS}]
  ) {
    edges {
      node {
        id
        details {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetIntegrationIntersectionQuery__
 *
 * To run a query within a React component, call `useGetIntegrationIntersectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationIntersectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationIntersectionQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetIntegrationIntersectionQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationIntersectionQuery, GetIntegrationIntersectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationIntersectionQuery, GetIntegrationIntersectionQueryVariables>(GetIntegrationIntersectionDocument, options);
      }
export function useGetIntegrationIntersectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationIntersectionQuery, GetIntegrationIntersectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationIntersectionQuery, GetIntegrationIntersectionQueryVariables>(GetIntegrationIntersectionDocument, options);
        }
export type GetIntegrationIntersectionQueryHookResult = ReturnType<typeof useGetIntegrationIntersectionQuery>;
export type GetIntegrationIntersectionLazyQueryHookResult = ReturnType<typeof useGetIntegrationIntersectionLazyQuery>;
export type GetIntegrationIntersectionQueryResult = Apollo.QueryResult<GetIntegrationIntersectionQuery, GetIntegrationIntersectionQueryVariables>;
export function refetchGetIntegrationIntersectionQuery(variables: GetIntegrationIntersectionQueryVariables) {
      return { query: GetIntegrationIntersectionDocument, variables: variables }
    }
export const IntersectionsLayerLocationsDocument = gql`
    query IntersectionsLayerLocations {
  locations(
    query: {limit: 10000, filters: [{field: "locationType", value: "Intersection", operator: EQUALS}]}
  ) {
    edges {
      node {
        id
        locationType
        geometry
        details {
          name
        }
        signalIntersection {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useIntersectionsLayerLocationsQuery__
 *
 * To run a query within a React component, call `useIntersectionsLayerLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionsLayerLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionsLayerLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionsLayerLocationsQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionsLayerLocationsQuery, IntersectionsLayerLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionsLayerLocationsQuery, IntersectionsLayerLocationsQueryVariables>(IntersectionsLayerLocationsDocument, options);
      }
export function useIntersectionsLayerLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionsLayerLocationsQuery, IntersectionsLayerLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionsLayerLocationsQuery, IntersectionsLayerLocationsQueryVariables>(IntersectionsLayerLocationsDocument, options);
        }
export type IntersectionsLayerLocationsQueryHookResult = ReturnType<typeof useIntersectionsLayerLocationsQuery>;
export type IntersectionsLayerLocationsLazyQueryHookResult = ReturnType<typeof useIntersectionsLayerLocationsLazyQuery>;
export type IntersectionsLayerLocationsQueryResult = Apollo.QueryResult<IntersectionsLayerLocationsQuery, IntersectionsLayerLocationsQueryVariables>;
export function refetchIntersectionsLayerLocationsQuery(variables?: IntersectionsLayerLocationsQueryVariables) {
      return { query: IntersectionsLayerLocationsDocument, variables: variables }
    }
export const LocationNameDocument = gql`
    query LocationName($id: ID!) {
  location(id: $id) {
    id
    details {
      name
    }
  }
}
    `;

/**
 * __useLocationNameQuery__
 *
 * To run a query within a React component, call `useLocationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationNameQuery(baseOptions: Apollo.QueryHookOptions<LocationNameQuery, LocationNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationNameQuery, LocationNameQueryVariables>(LocationNameDocument, options);
      }
export function useLocationNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationNameQuery, LocationNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationNameQuery, LocationNameQueryVariables>(LocationNameDocument, options);
        }
export type LocationNameQueryHookResult = ReturnType<typeof useLocationNameQuery>;
export type LocationNameLazyQueryHookResult = ReturnType<typeof useLocationNameLazyQuery>;
export type LocationNameQueryResult = Apollo.QueryResult<LocationNameQuery, LocationNameQueryVariables>;
export function refetchLocationNameQuery(variables: LocationNameQueryVariables) {
      return { query: LocationNameDocument, variables: variables }
    }
export const SaveIntersectionDocument = gql`
    mutation SaveIntersection($input: IntersectionInput!) {
  saveIntersection(intersectionInput: $input) {
    ...IntersectionDetail
  }
}
    ${IntersectionDetailFragmentDoc}`;
export type SaveIntersectionMutationFn = Apollo.MutationFunction<SaveIntersectionMutation, SaveIntersectionMutationVariables>;

/**
 * __useSaveIntersectionMutation__
 *
 * To run a mutation, you first call `useSaveIntersectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveIntersectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveIntersectionMutation, { data, loading, error }] = useSaveIntersectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveIntersectionMutation(baseOptions?: Apollo.MutationHookOptions<SaveIntersectionMutation, SaveIntersectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveIntersectionMutation, SaveIntersectionMutationVariables>(SaveIntersectionDocument, options);
      }
export type SaveIntersectionMutationHookResult = ReturnType<typeof useSaveIntersectionMutation>;
export type SaveIntersectionMutationResult = Apollo.MutationResult<SaveIntersectionMutation>;
export type SaveIntersectionMutationOptions = Apollo.BaseMutationOptions<SaveIntersectionMutation, SaveIntersectionMutationVariables>;
export const CreateMibSubscriptionDocument = gql`
    mutation createMibSubscription($id: String!, $mibs: [MibWithIndexes!]!, $subscriptionId: String!) {
  subscribeMibs(id: $id, mibs: $mibs, requestId: $subscriptionId) {
    requestId
    success
    failure
  }
}
    `;
export type CreateMibSubscriptionMutationFn = Apollo.MutationFunction<CreateMibSubscriptionMutation, CreateMibSubscriptionMutationVariables>;

/**
 * __useCreateMibSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateMibSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMibSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMibSubscriptionMutation, { data, loading, error }] = useCreateMibSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mibs: // value for 'mibs'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useCreateMibSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMibSubscriptionMutation, CreateMibSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMibSubscriptionMutation, CreateMibSubscriptionMutationVariables>(CreateMibSubscriptionDocument, options);
      }
export type CreateMibSubscriptionMutationHookResult = ReturnType<typeof useCreateMibSubscriptionMutation>;
export type CreateMibSubscriptionMutationResult = Apollo.MutationResult<CreateMibSubscriptionMutation>;
export type CreateMibSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateMibSubscriptionMutation, CreateMibSubscriptionMutationVariables>;
export const DeleteIntersectionDocument = gql`
    mutation deleteIntersection($id: ID!) {
  deleteIntersection(id: $id)
}
    `;
export type DeleteIntersectionMutationFn = Apollo.MutationFunction<DeleteIntersectionMutation, DeleteIntersectionMutationVariables>;

/**
 * __useDeleteIntersectionMutation__
 *
 * To run a mutation, you first call `useDeleteIntersectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntersectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntersectionMutation, { data, loading, error }] = useDeleteIntersectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntersectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntersectionMutation, DeleteIntersectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntersectionMutation, DeleteIntersectionMutationVariables>(DeleteIntersectionDocument, options);
      }
export type DeleteIntersectionMutationHookResult = ReturnType<typeof useDeleteIntersectionMutation>;
export type DeleteIntersectionMutationResult = Apollo.MutationResult<DeleteIntersectionMutation>;
export type DeleteIntersectionMutationOptions = Apollo.BaseMutationOptions<DeleteIntersectionMutation, DeleteIntersectionMutationVariables>;
export const BackupDeviceDatabaseDocument = gql`
    mutation backupDeviceDatabase($deviceId: String!, $comment: String, $makeApproved: Boolean) {
  backupDeviceDatabase(
    deviceId: $deviceId
    comment: $comment
    makeApproved: $makeApproved
  ) {
    id
  }
}
    `;
export type BackupDeviceDatabaseMutationFn = Apollo.MutationFunction<BackupDeviceDatabaseMutation, BackupDeviceDatabaseMutationVariables>;

/**
 * __useBackupDeviceDatabaseMutation__
 *
 * To run a mutation, you first call `useBackupDeviceDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackupDeviceDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backupDeviceDatabaseMutation, { data, loading, error }] = useBackupDeviceDatabaseMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      comment: // value for 'comment'
 *      makeApproved: // value for 'makeApproved'
 *   },
 * });
 */
export function useBackupDeviceDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<BackupDeviceDatabaseMutation, BackupDeviceDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackupDeviceDatabaseMutation, BackupDeviceDatabaseMutationVariables>(BackupDeviceDatabaseDocument, options);
      }
export type BackupDeviceDatabaseMutationHookResult = ReturnType<typeof useBackupDeviceDatabaseMutation>;
export type BackupDeviceDatabaseMutationResult = Apollo.MutationResult<BackupDeviceDatabaseMutation>;
export type BackupDeviceDatabaseMutationOptions = Apollo.BaseMutationOptions<BackupDeviceDatabaseMutation, BackupDeviceDatabaseMutationVariables>;
export const DownloadDeviceDatabaseDocument = gql`
    mutation downloadDeviceDatabase($intersectionId: String!, $databaseId: String!, $comment: String) {
  downloadDeviceDatabase(
    intersectionId: $intersectionId
    databaseId: $databaseId
    comment: $comment
  ) {
    id
  }
}
    `;
export type DownloadDeviceDatabaseMutationFn = Apollo.MutationFunction<DownloadDeviceDatabaseMutation, DownloadDeviceDatabaseMutationVariables>;

/**
 * __useDownloadDeviceDatabaseMutation__
 *
 * To run a mutation, you first call `useDownloadDeviceDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDeviceDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDeviceDatabaseMutation, { data, loading, error }] = useDownloadDeviceDatabaseMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      databaseId: // value for 'databaseId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useDownloadDeviceDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<DownloadDeviceDatabaseMutation, DownloadDeviceDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadDeviceDatabaseMutation, DownloadDeviceDatabaseMutationVariables>(DownloadDeviceDatabaseDocument, options);
      }
export type DownloadDeviceDatabaseMutationHookResult = ReturnType<typeof useDownloadDeviceDatabaseMutation>;
export type DownloadDeviceDatabaseMutationResult = Apollo.MutationResult<DownloadDeviceDatabaseMutation>;
export type DownloadDeviceDatabaseMutationOptions = Apollo.BaseMutationOptions<DownloadDeviceDatabaseMutation, DownloadDeviceDatabaseMutationVariables>;
export const CreateDraftDatabaseDocument = gql`
    mutation createDraftDatabase($intersectionId: String!, $databaseId: String!, $comment: String) {
  createDraftDatabase(
    intersectionId: $intersectionId
    databaseId: $databaseId
    comment: $comment
  ) {
    id
  }
}
    `;
export type CreateDraftDatabaseMutationFn = Apollo.MutationFunction<CreateDraftDatabaseMutation, CreateDraftDatabaseMutationVariables>;

/**
 * __useCreateDraftDatabaseMutation__
 *
 * To run a mutation, you first call `useCreateDraftDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftDatabaseMutation, { data, loading, error }] = useCreateDraftDatabaseMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      databaseId: // value for 'databaseId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateDraftDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftDatabaseMutation, CreateDraftDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftDatabaseMutation, CreateDraftDatabaseMutationVariables>(CreateDraftDatabaseDocument, options);
      }
export type CreateDraftDatabaseMutationHookResult = ReturnType<typeof useCreateDraftDatabaseMutation>;
export type CreateDraftDatabaseMutationResult = Apollo.MutationResult<CreateDraftDatabaseMutation>;
export type CreateDraftDatabaseMutationOptions = Apollo.BaseMutationOptions<CreateDraftDatabaseMutation, CreateDraftDatabaseMutationVariables>;
export const ApproveDatabaseDocument = gql`
    mutation approveDatabase($intersectionId: String!, $databaseId: String!, $comment: String) {
  approveDatabase(
    intersectionId: $intersectionId
    databaseId: $databaseId
    comment: $comment
  ) {
    id
  }
}
    `;
export type ApproveDatabaseMutationFn = Apollo.MutationFunction<ApproveDatabaseMutation, ApproveDatabaseMutationVariables>;

/**
 * __useApproveDatabaseMutation__
 *
 * To run a mutation, you first call `useApproveDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDatabaseMutation, { data, loading, error }] = useApproveDatabaseMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      databaseId: // value for 'databaseId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useApproveDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDatabaseMutation, ApproveDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveDatabaseMutation, ApproveDatabaseMutationVariables>(ApproveDatabaseDocument, options);
      }
export type ApproveDatabaseMutationHookResult = ReturnType<typeof useApproveDatabaseMutation>;
export type ApproveDatabaseMutationResult = Apollo.MutationResult<ApproveDatabaseMutation>;
export type ApproveDatabaseMutationOptions = Apollo.BaseMutationOptions<ApproveDatabaseMutation, ApproveDatabaseMutationVariables>;
export const SetSignalMibsDocument = gql`
    mutation setSignalMibs($deviceId: String!, $mibs: [MibValue!]!, $comment: String) {
  setSignalMibs(deviceId: $deviceId, mibs: $mibs, comment: $comment)
}
    `;
export type SetSignalMibsMutationFn = Apollo.MutationFunction<SetSignalMibsMutation, SetSignalMibsMutationVariables>;

/**
 * __useSetSignalMibsMutation__
 *
 * To run a mutation, you first call `useSetSignalMibsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSignalMibsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSignalMibsMutation, { data, loading, error }] = useSetSignalMibsMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      mibs: // value for 'mibs'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetSignalMibsMutation(baseOptions?: Apollo.MutationHookOptions<SetSignalMibsMutation, SetSignalMibsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSignalMibsMutation, SetSignalMibsMutationVariables>(SetSignalMibsDocument, options);
      }
export type SetSignalMibsMutationHookResult = ReturnType<typeof useSetSignalMibsMutation>;
export type SetSignalMibsMutationResult = Apollo.MutationResult<SetSignalMibsMutation>;
export type SetSignalMibsMutationOptions = Apollo.BaseMutationOptions<SetSignalMibsMutation, SetSignalMibsMutationVariables>;
export const SetDatabaseMibsDocument = gql`
    mutation setDatabaseMibs($intersectionId: String!, $databaseId: String!, $mibs: [DatabaseMibValue!]!, $comment: String) {
  setDatabaseMibs(
    intersectionId: $intersectionId
    databaseId: $databaseId
    mibs: $mibs
    comment: $comment
  ) {
    id
  }
}
    `;
export type SetDatabaseMibsMutationFn = Apollo.MutationFunction<SetDatabaseMibsMutation, SetDatabaseMibsMutationVariables>;

/**
 * __useSetDatabaseMibsMutation__
 *
 * To run a mutation, you first call `useSetDatabaseMibsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDatabaseMibsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDatabaseMibsMutation, { data, loading, error }] = useSetDatabaseMibsMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      databaseId: // value for 'databaseId'
 *      mibs: // value for 'mibs'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetDatabaseMibsMutation(baseOptions?: Apollo.MutationHookOptions<SetDatabaseMibsMutation, SetDatabaseMibsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDatabaseMibsMutation, SetDatabaseMibsMutationVariables>(SetDatabaseMibsDocument, options);
      }
export type SetDatabaseMibsMutationHookResult = ReturnType<typeof useSetDatabaseMibsMutation>;
export type SetDatabaseMibsMutationResult = Apollo.MutationResult<SetDatabaseMibsMutation>;
export type SetDatabaseMibsMutationOptions = Apollo.BaseMutationOptions<SetDatabaseMibsMutation, SetDatabaseMibsMutationVariables>;
export const AddIntersectionCommentDocument = gql`
    mutation addIntersectionComment($intersectionId: ID!, $comment: String!) {
  addIntersectionComment(intersectionId: $intersectionId, comment: $comment) {
    id
    comment
  }
}
    `;
export type AddIntersectionCommentMutationFn = Apollo.MutationFunction<AddIntersectionCommentMutation, AddIntersectionCommentMutationVariables>;

/**
 * __useAddIntersectionCommentMutation__
 *
 * To run a mutation, you first call `useAddIntersectionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIntersectionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIntersectionCommentMutation, { data, loading, error }] = useAddIntersectionCommentMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddIntersectionCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddIntersectionCommentMutation, AddIntersectionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIntersectionCommentMutation, AddIntersectionCommentMutationVariables>(AddIntersectionCommentDocument, options);
      }
export type AddIntersectionCommentMutationHookResult = ReturnType<typeof useAddIntersectionCommentMutation>;
export type AddIntersectionCommentMutationResult = Apollo.MutationResult<AddIntersectionCommentMutation>;
export type AddIntersectionCommentMutationOptions = Apollo.BaseMutationOptions<AddIntersectionCommentMutation, AddIntersectionCommentMutationVariables>;
export const DeleteIntersectionCommentDocument = gql`
    mutation deleteIntersectionComment($id: ID!) {
  deleteIntersectionComment(id: $id)
}
    `;
export type DeleteIntersectionCommentMutationFn = Apollo.MutationFunction<DeleteIntersectionCommentMutation, DeleteIntersectionCommentMutationVariables>;

/**
 * __useDeleteIntersectionCommentMutation__
 *
 * To run a mutation, you first call `useDeleteIntersectionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntersectionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntersectionCommentMutation, { data, loading, error }] = useDeleteIntersectionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntersectionCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntersectionCommentMutation, DeleteIntersectionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntersectionCommentMutation, DeleteIntersectionCommentMutationVariables>(DeleteIntersectionCommentDocument, options);
      }
export type DeleteIntersectionCommentMutationHookResult = ReturnType<typeof useDeleteIntersectionCommentMutation>;
export type DeleteIntersectionCommentMutationResult = Apollo.MutationResult<DeleteIntersectionCommentMutation>;
export type DeleteIntersectionCommentMutationOptions = Apollo.BaseMutationOptions<DeleteIntersectionCommentMutation, DeleteIntersectionCommentMutationVariables>;
export const DeleteAllIntersectionCommentsDocument = gql`
    mutation deleteAllIntersectionComments($intersectionId: ID!) {
  deleteAllIntersectionComments(intersectionId: $intersectionId)
}
    `;
export type DeleteAllIntersectionCommentsMutationFn = Apollo.MutationFunction<DeleteAllIntersectionCommentsMutation, DeleteAllIntersectionCommentsMutationVariables>;

/**
 * __useDeleteAllIntersectionCommentsMutation__
 *
 * To run a mutation, you first call `useDeleteAllIntersectionCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllIntersectionCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllIntersectionCommentsMutation, { data, loading, error }] = useDeleteAllIntersectionCommentsMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useDeleteAllIntersectionCommentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllIntersectionCommentsMutation, DeleteAllIntersectionCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllIntersectionCommentsMutation, DeleteAllIntersectionCommentsMutationVariables>(DeleteAllIntersectionCommentsDocument, options);
      }
export type DeleteAllIntersectionCommentsMutationHookResult = ReturnType<typeof useDeleteAllIntersectionCommentsMutation>;
export type DeleteAllIntersectionCommentsMutationResult = Apollo.MutationResult<DeleteAllIntersectionCommentsMutation>;
export type DeleteAllIntersectionCommentsMutationOptions = Apollo.BaseMutationOptions<DeleteAllIntersectionCommentsMutation, DeleteAllIntersectionCommentsMutationVariables>;
export const SetTimeNowDocument = gql`
    mutation setTimeNow($deviceId: ID!) {
  setTimeNow(deviceId: $deviceId)
}
    `;
export type SetTimeNowMutationFn = Apollo.MutationFunction<SetTimeNowMutation, SetTimeNowMutationVariables>;

/**
 * __useSetTimeNowMutation__
 *
 * To run a mutation, you first call `useSetTimeNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTimeNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTimeNowMutation, { data, loading, error }] = useSetTimeNowMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useSetTimeNowMutation(baseOptions?: Apollo.MutationHookOptions<SetTimeNowMutation, SetTimeNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTimeNowMutation, SetTimeNowMutationVariables>(SetTimeNowDocument, options);
      }
export type SetTimeNowMutationHookResult = ReturnType<typeof useSetTimeNowMutation>;
export type SetTimeNowMutationResult = Apollo.MutationResult<SetTimeNowMutation>;
export type SetTimeNowMutationOptions = Apollo.BaseMutationOptions<SetTimeNowMutation, SetTimeNowMutationVariables>;
export const SaveSignalsTaskMutationDocument = gql`
    mutation SaveSignalsTaskMutation($input: TaskInput!, $centerId: String) {
  saveSignalScheduledTask(input: $input, centerId: $centerId) {
    ...SignalsTaskFragment
  }
}
    ${SignalsTaskFragmentFragmentDoc}`;
export type SaveSignalsTaskMutationMutationFn = Apollo.MutationFunction<SaveSignalsTaskMutationMutation, SaveSignalsTaskMutationMutationVariables>;

/**
 * __useSaveSignalsTaskMutationMutation__
 *
 * To run a mutation, you first call `useSaveSignalsTaskMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignalsTaskMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignalsTaskMutationMutation, { data, loading, error }] = useSaveSignalsTaskMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useSaveSignalsTaskMutationMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignalsTaskMutationMutation, SaveSignalsTaskMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignalsTaskMutationMutation, SaveSignalsTaskMutationMutationVariables>(SaveSignalsTaskMutationDocument, options);
      }
export type SaveSignalsTaskMutationMutationHookResult = ReturnType<typeof useSaveSignalsTaskMutationMutation>;
export type SaveSignalsTaskMutationMutationResult = Apollo.MutationResult<SaveSignalsTaskMutationMutation>;
export type SaveSignalsTaskMutationMutationOptions = Apollo.BaseMutationOptions<SaveSignalsTaskMutationMutation, SaveSignalsTaskMutationMutationVariables>;
export const DeleteSignalScheduledTaskDocument = gql`
    mutation deleteSignalScheduledTask($taskId: ID!, $centerId: String) {
  deleteSignalScheduledTask(taskId: $taskId, centerId: $centerId)
}
    `;
export type DeleteSignalScheduledTaskMutationFn = Apollo.MutationFunction<DeleteSignalScheduledTaskMutation, DeleteSignalScheduledTaskMutationVariables>;

/**
 * __useDeleteSignalScheduledTaskMutation__
 *
 * To run a mutation, you first call `useDeleteSignalScheduledTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignalScheduledTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignalScheduledTaskMutation, { data, loading, error }] = useDeleteSignalScheduledTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      centerId: // value for 'centerId'
 *   },
 * });
 */
export function useDeleteSignalScheduledTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignalScheduledTaskMutation, DeleteSignalScheduledTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignalScheduledTaskMutation, DeleteSignalScheduledTaskMutationVariables>(DeleteSignalScheduledTaskDocument, options);
      }
export type DeleteSignalScheduledTaskMutationHookResult = ReturnType<typeof useDeleteSignalScheduledTaskMutation>;
export type DeleteSignalScheduledTaskMutationResult = Apollo.MutationResult<DeleteSignalScheduledTaskMutation>;
export type DeleteSignalScheduledTaskMutationOptions = Apollo.BaseMutationOptions<DeleteSignalScheduledTaskMutation, DeleteSignalScheduledTaskMutationVariables>;
export const DeleteIntersectionTemplateDocument = gql`
    mutation deleteIntersectionTemplate($id: ID!) {
  deleteIntersectionTemplate(id: $id)
}
    `;
export type DeleteIntersectionTemplateMutationFn = Apollo.MutationFunction<DeleteIntersectionTemplateMutation, DeleteIntersectionTemplateMutationVariables>;

/**
 * __useDeleteIntersectionTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteIntersectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntersectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntersectionTemplateMutation, { data, loading, error }] = useDeleteIntersectionTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntersectionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntersectionTemplateMutation, DeleteIntersectionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntersectionTemplateMutation, DeleteIntersectionTemplateMutationVariables>(DeleteIntersectionTemplateDocument, options);
      }
export type DeleteIntersectionTemplateMutationHookResult = ReturnType<typeof useDeleteIntersectionTemplateMutation>;
export type DeleteIntersectionTemplateMutationResult = Apollo.MutationResult<DeleteIntersectionTemplateMutation>;
export type DeleteIntersectionTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteIntersectionTemplateMutation, DeleteIntersectionTemplateMutationVariables>;
export const SaveIntersectionTemplateDocument = gql`
    mutation saveIntersectionTemplate($input: IntersectionTemplateInput!) {
  saveIntersectionTemplate(input: $input) {
    id
  }
}
    `;
export type SaveIntersectionTemplateMutationFn = Apollo.MutationFunction<SaveIntersectionTemplateMutation, SaveIntersectionTemplateMutationVariables>;

/**
 * __useSaveIntersectionTemplateMutation__
 *
 * To run a mutation, you first call `useSaveIntersectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveIntersectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveIntersectionTemplateMutation, { data, loading, error }] = useSaveIntersectionTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveIntersectionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveIntersectionTemplateMutation, SaveIntersectionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveIntersectionTemplateMutation, SaveIntersectionTemplateMutationVariables>(SaveIntersectionTemplateDocument, options);
      }
export type SaveIntersectionTemplateMutationHookResult = ReturnType<typeof useSaveIntersectionTemplateMutation>;
export type SaveIntersectionTemplateMutationResult = Apollo.MutationResult<SaveIntersectionTemplateMutation>;
export type SaveIntersectionTemplateMutationOptions = Apollo.BaseMutationOptions<SaveIntersectionTemplateMutation, SaveIntersectionTemplateMutationVariables>;
export const SaveSignalActionSetDocument = gql`
    mutation saveSignalActionSet($input: SignalActionSetInput!) {
  saveSignalActionSet(input: $input) {
    id
  }
}
    `;
export type SaveSignalActionSetMutationFn = Apollo.MutationFunction<SaveSignalActionSetMutation, SaveSignalActionSetMutationVariables>;

/**
 * __useSaveSignalActionSetMutation__
 *
 * To run a mutation, you first call `useSaveSignalActionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignalActionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignalActionSetMutation, { data, loading, error }] = useSaveSignalActionSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignalActionSetMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignalActionSetMutation, SaveSignalActionSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignalActionSetMutation, SaveSignalActionSetMutationVariables>(SaveSignalActionSetDocument, options);
      }
export type SaveSignalActionSetMutationHookResult = ReturnType<typeof useSaveSignalActionSetMutation>;
export type SaveSignalActionSetMutationResult = Apollo.MutationResult<SaveSignalActionSetMutation>;
export type SaveSignalActionSetMutationOptions = Apollo.BaseMutationOptions<SaveSignalActionSetMutation, SaveSignalActionSetMutationVariables>;
export const DeleteSignalActionSetDocument = gql`
    mutation deleteSignalActionSet($id: ID!) {
  deleteSignalActionSet(id: $id)
}
    `;
export type DeleteSignalActionSetMutationFn = Apollo.MutationFunction<DeleteSignalActionSetMutation, DeleteSignalActionSetMutationVariables>;

/**
 * __useDeleteSignalActionSetMutation__
 *
 * To run a mutation, you first call `useDeleteSignalActionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignalActionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignalActionSetMutation, { data, loading, error }] = useDeleteSignalActionSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignalActionSetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignalActionSetMutation, DeleteSignalActionSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignalActionSetMutation, DeleteSignalActionSetMutationVariables>(DeleteSignalActionSetDocument, options);
      }
export type DeleteSignalActionSetMutationHookResult = ReturnType<typeof useDeleteSignalActionSetMutation>;
export type DeleteSignalActionSetMutationResult = Apollo.MutationResult<DeleteSignalActionSetMutation>;
export type DeleteSignalActionSetMutationOptions = Apollo.BaseMutationOptions<DeleteSignalActionSetMutation, DeleteSignalActionSetMutationVariables>;
export const DeviceEventExportDocument = gql`
    mutation deviceEventExport($intersectionId: String!, $startDateTime: DateTime!, $endDateTime: DateTime!, $rule: String, $fileName: String!, $timezone: String) {
  deviceEventExport(
    intersectionId: $intersectionId
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    rule: $rule
    fileName: $fileName
    timezone: $timezone
  )
}
    `;
export type DeviceEventExportMutationFn = Apollo.MutationFunction<DeviceEventExportMutation, DeviceEventExportMutationVariables>;

/**
 * __useDeviceEventExportMutation__
 *
 * To run a mutation, you first call `useDeviceEventExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeviceEventExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deviceEventExportMutation, { data, loading, error }] = useDeviceEventExportMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      rule: // value for 'rule'
 *      fileName: // value for 'fileName'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useDeviceEventExportMutation(baseOptions?: Apollo.MutationHookOptions<DeviceEventExportMutation, DeviceEventExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeviceEventExportMutation, DeviceEventExportMutationVariables>(DeviceEventExportDocument, options);
      }
export type DeviceEventExportMutationHookResult = ReturnType<typeof useDeviceEventExportMutation>;
export type DeviceEventExportMutationResult = Apollo.MutationResult<DeviceEventExportMutation>;
export type DeviceEventExportMutationOptions = Apollo.BaseMutationOptions<DeviceEventExportMutation, DeviceEventExportMutationVariables>;
export const DeleteDeviceDatabaseDocument = gql`
    mutation deleteDeviceDatabase($databaseId: String!, $intersectionId: String!) {
  deleteDeviceDatabase(databaseId: $databaseId, intersectionId: $intersectionId) {
    id
  }
}
    `;
export type DeleteDeviceDatabaseMutationFn = Apollo.MutationFunction<DeleteDeviceDatabaseMutation, DeleteDeviceDatabaseMutationVariables>;

/**
 * __useDeleteDeviceDatabaseMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceDatabaseMutation, { data, loading, error }] = useDeleteDeviceDatabaseMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useDeleteDeviceDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceDatabaseMutation, DeleteDeviceDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceDatabaseMutation, DeleteDeviceDatabaseMutationVariables>(DeleteDeviceDatabaseDocument, options);
      }
export type DeleteDeviceDatabaseMutationHookResult = ReturnType<typeof useDeleteDeviceDatabaseMutation>;
export type DeleteDeviceDatabaseMutationResult = Apollo.MutationResult<DeleteDeviceDatabaseMutation>;
export type DeleteDeviceDatabaseMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceDatabaseMutation, DeleteDeviceDatabaseMutationVariables>;
export const FinalizeDraftDeviceDatabaseDocument = gql`
    mutation finalizeDraftDeviceDatabase($databaseId: String!, $intersectionId: String!) {
  finalizeDraftDeviceDatabase(
    databaseId: $databaseId
    intersectionId: $intersectionId
  ) {
    id
    type
    status
  }
}
    `;
export type FinalizeDraftDeviceDatabaseMutationFn = Apollo.MutationFunction<FinalizeDraftDeviceDatabaseMutation, FinalizeDraftDeviceDatabaseMutationVariables>;

/**
 * __useFinalizeDraftDeviceDatabaseMutation__
 *
 * To run a mutation, you first call `useFinalizeDraftDeviceDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeDraftDeviceDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeDraftDeviceDatabaseMutation, { data, loading, error }] = useFinalizeDraftDeviceDatabaseMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useFinalizeDraftDeviceDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeDraftDeviceDatabaseMutation, FinalizeDraftDeviceDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeDraftDeviceDatabaseMutation, FinalizeDraftDeviceDatabaseMutationVariables>(FinalizeDraftDeviceDatabaseDocument, options);
      }
export type FinalizeDraftDeviceDatabaseMutationHookResult = ReturnType<typeof useFinalizeDraftDeviceDatabaseMutation>;
export type FinalizeDraftDeviceDatabaseMutationResult = Apollo.MutationResult<FinalizeDraftDeviceDatabaseMutation>;
export type FinalizeDraftDeviceDatabaseMutationOptions = Apollo.BaseMutationOptions<FinalizeDraftDeviceDatabaseMutation, FinalizeDraftDeviceDatabaseMutationVariables>;
export const CloneDatabaseDocument = gql`
    mutation cloneDatabase($databaseId: String!, $fromIntersectionId: String!, $toIntersectionId: String!) {
  copyDeviceDatabaseDraft(
    databaseId: $databaseId
    fromIntersectionId: $fromIntersectionId
    toIntersectionId: $toIntersectionId
  ) {
    __typename
    id
    type
    status
  }
}
    `;
export type CloneDatabaseMutationFn = Apollo.MutationFunction<CloneDatabaseMutation, CloneDatabaseMutationVariables>;

/**
 * __useCloneDatabaseMutation__
 *
 * To run a mutation, you first call `useCloneDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneDatabaseMutation, { data, loading, error }] = useCloneDatabaseMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      fromIntersectionId: // value for 'fromIntersectionId'
 *      toIntersectionId: // value for 'toIntersectionId'
 *   },
 * });
 */
export function useCloneDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<CloneDatabaseMutation, CloneDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneDatabaseMutation, CloneDatabaseMutationVariables>(CloneDatabaseDocument, options);
      }
export type CloneDatabaseMutationHookResult = ReturnType<typeof useCloneDatabaseMutation>;
export type CloneDatabaseMutationResult = Apollo.MutationResult<CloneDatabaseMutation>;
export type CloneDatabaseMutationOptions = Apollo.BaseMutationOptions<CloneDatabaseMutation, CloneDatabaseMutationVariables>;
export const UpdateDeviceDatabasesArchiveFlagDocument = gql`
    mutation updateDeviceDatabasesArchiveFlag($databaseIds: [String!]!, $intersectionId: String!, $archive: Boolean!) {
  updateDeviceDatabasesArchiveFlag(
    databaseIds: $databaseIds
    intersectionId: $intersectionId
    archive: $archive
  )
}
    `;
export type UpdateDeviceDatabasesArchiveFlagMutationFn = Apollo.MutationFunction<UpdateDeviceDatabasesArchiveFlagMutation, UpdateDeviceDatabasesArchiveFlagMutationVariables>;

/**
 * __useUpdateDeviceDatabasesArchiveFlagMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceDatabasesArchiveFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceDatabasesArchiveFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceDatabasesArchiveFlagMutation, { data, loading, error }] = useUpdateDeviceDatabasesArchiveFlagMutation({
 *   variables: {
 *      databaseIds: // value for 'databaseIds'
 *      intersectionId: // value for 'intersectionId'
 *      archive: // value for 'archive'
 *   },
 * });
 */
export function useUpdateDeviceDatabasesArchiveFlagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceDatabasesArchiveFlagMutation, UpdateDeviceDatabasesArchiveFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceDatabasesArchiveFlagMutation, UpdateDeviceDatabasesArchiveFlagMutationVariables>(UpdateDeviceDatabasesArchiveFlagDocument, options);
      }
export type UpdateDeviceDatabasesArchiveFlagMutationHookResult = ReturnType<typeof useUpdateDeviceDatabasesArchiveFlagMutation>;
export type UpdateDeviceDatabasesArchiveFlagMutationResult = Apollo.MutationResult<UpdateDeviceDatabasesArchiveFlagMutation>;
export type UpdateDeviceDatabasesArchiveFlagMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceDatabasesArchiveFlagMutation, UpdateDeviceDatabasesArchiveFlagMutationVariables>;
export const SignalControllersDocument = gql`
    query SignalControllers($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  signalControllers(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        id
        name
        description
        connectionParameters
        location
      }
    }
  }
}
    `;

/**
 * __useSignalControllersQuery__
 *
 * To run a query within a React component, call `useSignalControllersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalControllersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalControllersQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSignalControllersQuery(baseOptions?: Apollo.QueryHookOptions<SignalControllersQuery, SignalControllersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalControllersQuery, SignalControllersQueryVariables>(SignalControllersDocument, options);
      }
export function useSignalControllersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalControllersQuery, SignalControllersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalControllersQuery, SignalControllersQueryVariables>(SignalControllersDocument, options);
        }
export type SignalControllersQueryHookResult = ReturnType<typeof useSignalControllersQuery>;
export type SignalControllersLazyQueryHookResult = ReturnType<typeof useSignalControllersLazyQuery>;
export type SignalControllersQueryResult = Apollo.QueryResult<SignalControllersQuery, SignalControllersQueryVariables>;
export function refetchSignalControllersQuery(variables?: SignalControllersQueryVariables) {
      return { query: SignalControllersDocument, variables: variables }
    }
export const SignalControllerDocument = gql`
    query SignalController($id: ID!) {
  signalController(id: $id) {
    id
    name
    description
    connectionParameters
    location
  }
}
    `;

/**
 * __useSignalControllerQuery__
 *
 * To run a query within a React component, call `useSignalControllerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalControllerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalControllerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignalControllerQuery(baseOptions: Apollo.QueryHookOptions<SignalControllerQuery, SignalControllerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalControllerQuery, SignalControllerQueryVariables>(SignalControllerDocument, options);
      }
export function useSignalControllerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalControllerQuery, SignalControllerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalControllerQuery, SignalControllerQueryVariables>(SignalControllerDocument, options);
        }
export type SignalControllerQueryHookResult = ReturnType<typeof useSignalControllerQuery>;
export type SignalControllerLazyQueryHookResult = ReturnType<typeof useSignalControllerLazyQuery>;
export type SignalControllerQueryResult = Apollo.QueryResult<SignalControllerQuery, SignalControllerQueryVariables>;
export function refetchSignalControllerQuery(variables: SignalControllerQueryVariables) {
      return { query: SignalControllerDocument, variables: variables }
    }
export const SignalControllerListDocument = gql`
    query SignalControllerList {
  signalControllers(unassigned: true, limit: 100000) {
    edges {
      node {
        id
        name
        location
      }
    }
  }
}
    `;

/**
 * __useSignalControllerListQuery__
 *
 * To run a query within a React component, call `useSignalControllerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalControllerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalControllerListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignalControllerListQuery(baseOptions?: Apollo.QueryHookOptions<SignalControllerListQuery, SignalControllerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalControllerListQuery, SignalControllerListQueryVariables>(SignalControllerListDocument, options);
      }
export function useSignalControllerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalControllerListQuery, SignalControllerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalControllerListQuery, SignalControllerListQueryVariables>(SignalControllerListDocument, options);
        }
export type SignalControllerListQueryHookResult = ReturnType<typeof useSignalControllerListQuery>;
export type SignalControllerListLazyQueryHookResult = ReturnType<typeof useSignalControllerListLazyQuery>;
export type SignalControllerListQueryResult = Apollo.QueryResult<SignalControllerListQuery, SignalControllerListQueryVariables>;
export function refetchSignalControllerListQuery(variables?: SignalControllerListQueryVariables) {
      return { query: SignalControllerListDocument, variables: variables }
    }
export const IntersectionLocationDocument = gql`
    query IntersectionLocation {
  intersectionLocation
}
    `;

/**
 * __useIntersectionLocationQuery__
 *
 * To run a query within a React component, call `useIntersectionLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionLocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionLocationQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionLocationQuery, IntersectionLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionLocationQuery, IntersectionLocationQueryVariables>(IntersectionLocationDocument, options);
      }
export function useIntersectionLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionLocationQuery, IntersectionLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionLocationQuery, IntersectionLocationQueryVariables>(IntersectionLocationDocument, options);
        }
export type IntersectionLocationQueryHookResult = ReturnType<typeof useIntersectionLocationQuery>;
export type IntersectionLocationLazyQueryHookResult = ReturnType<typeof useIntersectionLocationLazyQuery>;
export type IntersectionLocationQueryResult = Apollo.QueryResult<IntersectionLocationQuery, IntersectionLocationQueryVariables>;
export function refetchIntersectionLocationQuery(variables?: IntersectionLocationQueryVariables) {
      return { query: IntersectionLocationDocument, variables: variables }
    }
export const IntersectionSimpleStatusDocument = gql`
    query IntersectionSimpleStatus {
  intersectionSimpleStatus
}
    `;

/**
 * __useIntersectionSimpleStatusQuery__
 *
 * To run a query within a React component, call `useIntersectionSimpleStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionSimpleStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionSimpleStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionSimpleStatusQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionSimpleStatusQuery, IntersectionSimpleStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionSimpleStatusQuery, IntersectionSimpleStatusQueryVariables>(IntersectionSimpleStatusDocument, options);
      }
export function useIntersectionSimpleStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionSimpleStatusQuery, IntersectionSimpleStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionSimpleStatusQuery, IntersectionSimpleStatusQueryVariables>(IntersectionSimpleStatusDocument, options);
        }
export type IntersectionSimpleStatusQueryHookResult = ReturnType<typeof useIntersectionSimpleStatusQuery>;
export type IntersectionSimpleStatusLazyQueryHookResult = ReturnType<typeof useIntersectionSimpleStatusLazyQuery>;
export type IntersectionSimpleStatusQueryResult = Apollo.QueryResult<IntersectionSimpleStatusQuery, IntersectionSimpleStatusQueryVariables>;
export function refetchIntersectionSimpleStatusQuery(variables?: IntersectionSimpleStatusQueryVariables) {
      return { query: IntersectionSimpleStatusDocument, variables: variables }
    }
export const IntersectionSimpleStatusByIdDocument = gql`
    query intersectionSimpleStatusById($id: ID!) {
  intersectionSimpleStatusById(id: $id) {
    mainlineColor
    communicationState
    maneuverColor {
      id
      color
    }
    mainActionColor
    mainCommandSourceColor
    mainImplementAction
    mainImplementCommandSource
    mainImplementPlan
    mainImplementRate
    mainStatus
  }
}
    `;

/**
 * __useIntersectionSimpleStatusByIdQuery__
 *
 * To run a query within a React component, call `useIntersectionSimpleStatusByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionSimpleStatusByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionSimpleStatusByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionSimpleStatusByIdQuery(baseOptions: Apollo.QueryHookOptions<IntersectionSimpleStatusByIdQuery, IntersectionSimpleStatusByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionSimpleStatusByIdQuery, IntersectionSimpleStatusByIdQueryVariables>(IntersectionSimpleStatusByIdDocument, options);
      }
export function useIntersectionSimpleStatusByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionSimpleStatusByIdQuery, IntersectionSimpleStatusByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionSimpleStatusByIdQuery, IntersectionSimpleStatusByIdQueryVariables>(IntersectionSimpleStatusByIdDocument, options);
        }
export type IntersectionSimpleStatusByIdQueryHookResult = ReturnType<typeof useIntersectionSimpleStatusByIdQuery>;
export type IntersectionSimpleStatusByIdLazyQueryHookResult = ReturnType<typeof useIntersectionSimpleStatusByIdLazyQuery>;
export type IntersectionSimpleStatusByIdQueryResult = Apollo.QueryResult<IntersectionSimpleStatusByIdQuery, IntersectionSimpleStatusByIdQueryVariables>;
export function refetchIntersectionSimpleStatusByIdQuery(variables: IntersectionSimpleStatusByIdQueryVariables) {
      return { query: IntersectionSimpleStatusByIdDocument, variables: variables }
    }
export const IntersectionPhaseSummaryCountsDocument = gql`
    query IntersectionPhaseSummaryCounts {
  intersectionPhaseSummaryCounts {
    green
    yellow
    red
    commDisabled
    commFailed
    unknown
  }
}
    `;

/**
 * __useIntersectionPhaseSummaryCountsQuery__
 *
 * To run a query within a React component, call `useIntersectionPhaseSummaryCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionPhaseSummaryCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionPhaseSummaryCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionPhaseSummaryCountsQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionPhaseSummaryCountsQuery, IntersectionPhaseSummaryCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionPhaseSummaryCountsQuery, IntersectionPhaseSummaryCountsQueryVariables>(IntersectionPhaseSummaryCountsDocument, options);
      }
export function useIntersectionPhaseSummaryCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionPhaseSummaryCountsQuery, IntersectionPhaseSummaryCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionPhaseSummaryCountsQuery, IntersectionPhaseSummaryCountsQueryVariables>(IntersectionPhaseSummaryCountsDocument, options);
        }
export type IntersectionPhaseSummaryCountsQueryHookResult = ReturnType<typeof useIntersectionPhaseSummaryCountsQuery>;
export type IntersectionPhaseSummaryCountsLazyQueryHookResult = ReturnType<typeof useIntersectionPhaseSummaryCountsLazyQuery>;
export type IntersectionPhaseSummaryCountsQueryResult = Apollo.QueryResult<IntersectionPhaseSummaryCountsQuery, IntersectionPhaseSummaryCountsQueryVariables>;
export function refetchIntersectionPhaseSummaryCountsQuery(variables?: IntersectionPhaseSummaryCountsQueryVariables) {
      return { query: IntersectionPhaseSummaryCountsDocument, variables: variables }
    }
export const SignalsSummaryDocument = gql`
    query SignalsSummary {
  coord: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: true}]
  ) {
    totalCount
  }
  free: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: false}]
  ) {
    totalCount
  }
  transition: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: true}]
  ) {
    totalCount
  }
  preempt: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: false}]
  ) {
    totalCount
  }
  badPlan: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: true}]
  ) {
    totalCount
  }
  cabinetFlash: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: false}]
  ) {
    totalCount
  }
  controllerFlash: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: true}]
  ) {
    totalCount
  }
  commFailed: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: false}]
  ) {
    totalCount
  }
  commDisabled: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: true}]
  ) {
    totalCount
  }
  unknown: signs(
    filters: [{operator: EQUALS, field: "state.currentState.display.messageActivated", value: false}]
  ) {
    totalCount
  }
}
    `;

/**
 * __useSignalsSummaryQuery__
 *
 * To run a query within a React component, call `useSignalsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignalsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<SignalsSummaryQuery, SignalsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalsSummaryQuery, SignalsSummaryQueryVariables>(SignalsSummaryDocument, options);
      }
export function useSignalsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalsSummaryQuery, SignalsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalsSummaryQuery, SignalsSummaryQueryVariables>(SignalsSummaryDocument, options);
        }
export type SignalsSummaryQueryHookResult = ReturnType<typeof useSignalsSummaryQuery>;
export type SignalsSummaryLazyQueryHookResult = ReturnType<typeof useSignalsSummaryLazyQuery>;
export type SignalsSummaryQueryResult = Apollo.QueryResult<SignalsSummaryQuery, SignalsSummaryQueryVariables>;
export function refetchSignalsSummaryQuery(variables?: SignalsSummaryQueryVariables) {
      return { query: SignalsSummaryDocument, variables: variables }
    }
export const MibSubscriptionDocument = gql`
    subscription mibSubscription($subscriptionId: String!) {
  jobResults(requestIds: [$subscriptionId]) {
    body
  }
}
    `;

/**
 * __useMibSubscriptionSubscription__
 *
 * To run a query within a React component, call `useMibSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMibSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMibSubscriptionSubscription({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useMibSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<MibSubscriptionSubscription, MibSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MibSubscriptionSubscription, MibSubscriptionSubscriptionVariables>(MibSubscriptionDocument, options);
      }
export type MibSubscriptionSubscriptionHookResult = ReturnType<typeof useMibSubscriptionSubscription>;
export type MibSubscriptionSubscriptionResult = Apollo.SubscriptionResult<MibSubscriptionSubscription>;
export const MainlineColorSubscriptionDocument = gql`
    subscription MainlineColorSubscription {
  intersectionSimpleStatusUpdated {
    intersectionId
    mainlineColor
    communicationState
  }
}
    `;

/**
 * __useMainlineColorSubscriptionSubscription__
 *
 * To run a query within a React component, call `useMainlineColorSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMainlineColorSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainlineColorSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMainlineColorSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MainlineColorSubscriptionSubscription, MainlineColorSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MainlineColorSubscriptionSubscription, MainlineColorSubscriptionSubscriptionVariables>(MainlineColorSubscriptionDocument, options);
      }
export type MainlineColorSubscriptionSubscriptionHookResult = ReturnType<typeof useMainlineColorSubscriptionSubscription>;
export type MainlineColorSubscriptionSubscriptionResult = Apollo.SubscriptionResult<MainlineColorSubscriptionSubscription>;
export const CommunicationStatusColorSubscriptionDocument = gql`
    subscription CommunicationStatusColorSubscription {
  intersectionSimpleStatusUpdated {
    intersectionId
    communicationState
  }
}
    `;

/**
 * __useCommunicationStatusColorSubscriptionSubscription__
 *
 * To run a query within a React component, call `useCommunicationStatusColorSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationStatusColorSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationStatusColorSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCommunicationStatusColorSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CommunicationStatusColorSubscriptionSubscription, CommunicationStatusColorSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommunicationStatusColorSubscriptionSubscription, CommunicationStatusColorSubscriptionSubscriptionVariables>(CommunicationStatusColorSubscriptionDocument, options);
      }
export type CommunicationStatusColorSubscriptionSubscriptionHookResult = ReturnType<typeof useCommunicationStatusColorSubscriptionSubscription>;
export type CommunicationStatusColorSubscriptionSubscriptionResult = Apollo.SubscriptionResult<CommunicationStatusColorSubscriptionSubscription>;
export const PreemptLayerStatusDocument = gql`
    subscription PreemptLayerStatus {
  intersectionDetailStatusUpdated {
    intersectionId
    category
    preemptStatus {
      active
      enabled
      number
    }
    prioritorStatus {
      active
      enabled
      number
    }
  }
}
    `;

/**
 * __usePreemptLayerStatusSubscription__
 *
 * To run a query within a React component, call `usePreemptLayerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePreemptLayerStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreemptLayerStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePreemptLayerStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PreemptLayerStatusSubscription, PreemptLayerStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PreemptLayerStatusSubscription, PreemptLayerStatusSubscriptionVariables>(PreemptLayerStatusDocument, options);
      }
export type PreemptLayerStatusSubscriptionHookResult = ReturnType<typeof usePreemptLayerStatusSubscription>;
export type PreemptLayerStatusSubscriptionResult = Apollo.SubscriptionResult<PreemptLayerStatusSubscription>;
export const TimeSyncStatusSubscriptionDocument = gql`
    subscription TimeSyncStatusSubscription {
  intersectionDetailStatusUpdated {
    intersectionId
    category
    time {
      drift
    }
  }
}
    `;

/**
 * __useTimeSyncStatusSubscriptionSubscription__
 *
 * To run a query within a React component, call `useTimeSyncStatusSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTimeSyncStatusSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSyncStatusSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTimeSyncStatusSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TimeSyncStatusSubscriptionSubscription, TimeSyncStatusSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TimeSyncStatusSubscriptionSubscription, TimeSyncStatusSubscriptionSubscriptionVariables>(TimeSyncStatusSubscriptionDocument, options);
      }
export type TimeSyncStatusSubscriptionSubscriptionHookResult = ReturnType<typeof useTimeSyncStatusSubscriptionSubscription>;
export type TimeSyncStatusSubscriptionSubscriptionResult = Apollo.SubscriptionResult<TimeSyncStatusSubscriptionSubscription>;
export const CoordinationStatusDetailSubscriptionDocument = gql`
    subscription CoordinationStatusDetailSubscription {
  intersectionDetailStatusUpdated {
    intersectionId
    category
  }
}
    `;

/**
 * __useCoordinationStatusDetailSubscriptionSubscription__
 *
 * To run a query within a React component, call `useCoordinationStatusDetailSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCoordinationStatusDetailSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoordinationStatusDetailSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCoordinationStatusDetailSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CoordinationStatusDetailSubscriptionSubscription, CoordinationStatusDetailSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CoordinationStatusDetailSubscriptionSubscription, CoordinationStatusDetailSubscriptionSubscriptionVariables>(CoordinationStatusDetailSubscriptionDocument, options);
      }
export type CoordinationStatusDetailSubscriptionSubscriptionHookResult = ReturnType<typeof useCoordinationStatusDetailSubscriptionSubscription>;
export type CoordinationStatusDetailSubscriptionSubscriptionResult = Apollo.SubscriptionResult<CoordinationStatusDetailSubscriptionSubscription>;
export const CoordinationStatusPatternSubscriptionDocument = gql`
    subscription CoordinationStatusPatternSubscription {
  intersectionPatternStatusUpdated {
    intersectionId
    coordStatus
    patternNumber
    patternType
  }
}
    `;

/**
 * __useCoordinationStatusPatternSubscriptionSubscription__
 *
 * To run a query within a React component, call `useCoordinationStatusPatternSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCoordinationStatusPatternSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoordinationStatusPatternSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCoordinationStatusPatternSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CoordinationStatusPatternSubscriptionSubscription, CoordinationStatusPatternSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CoordinationStatusPatternSubscriptionSubscription, CoordinationStatusPatternSubscriptionSubscriptionVariables>(CoordinationStatusPatternSubscriptionDocument, options);
      }
export type CoordinationStatusPatternSubscriptionSubscriptionHookResult = ReturnType<typeof useCoordinationStatusPatternSubscriptionSubscription>;
export type CoordinationStatusPatternSubscriptionSubscriptionResult = Apollo.SubscriptionResult<CoordinationStatusPatternSubscriptionSubscription>;
export const AlarmDetailStatusDocument = gql`
    subscription AlarmDetailStatus {
  intersectionDetailStatusUpdated {
    intersectionId
    category
  }
}
    `;

/**
 * __useAlarmDetailStatusSubscription__
 *
 * To run a query within a React component, call `useAlarmDetailStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAlarmDetailStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlarmDetailStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAlarmDetailStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AlarmDetailStatusSubscription, AlarmDetailStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AlarmDetailStatusSubscription, AlarmDetailStatusSubscriptionVariables>(AlarmDetailStatusDocument, options);
      }
export type AlarmDetailStatusSubscriptionHookResult = ReturnType<typeof useAlarmDetailStatusSubscription>;
export type AlarmDetailStatusSubscriptionResult = Apollo.SubscriptionResult<AlarmDetailStatusSubscription>;
export const SimpleSubscriptionDocument = gql`
    subscription SimpleSubscription($id: ID!) {
  intersectionSimpleStatusUpdated(ids: [$id]) {
    mainlineColor
    communicationState
    maneuverColor {
      id
      color
    }
    mainActionColor
    mainCommandSourceColor
    mainImplementAction
    mainImplementCommandSource
    mainImplementPlan
    mainImplementRate
    mainStatus
  }
}
    `;

/**
 * __useSimpleSubscriptionSubscription__
 *
 * To run a query within a React component, call `useSimpleSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSimpleSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleSubscriptionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSimpleSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<SimpleSubscriptionSubscription, SimpleSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SimpleSubscriptionSubscription, SimpleSubscriptionSubscriptionVariables>(SimpleSubscriptionDocument, options);
      }
export type SimpleSubscriptionSubscriptionHookResult = ReturnType<typeof useSimpleSubscriptionSubscription>;
export type SimpleSubscriptionSubscriptionResult = Apollo.SubscriptionResult<SimpleSubscriptionSubscription>;
export const IntersectionDetailStatusDocument = gql`
    query IntersectionDetailStatus($id: ID!) {
  intersectionDetailStatusById(id: $id) {
    ...IntersectionDetailStatus
  }
}
    ${IntersectionDetailStatusFragmentDoc}`;

/**
 * __useIntersectionDetailStatusQuery__
 *
 * To run a query within a React component, call `useIntersectionDetailStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionDetailStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionDetailStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionDetailStatusQuery(baseOptions: Apollo.QueryHookOptions<IntersectionDetailStatusQuery, IntersectionDetailStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionDetailStatusQuery, IntersectionDetailStatusQueryVariables>(IntersectionDetailStatusDocument, options);
      }
export function useIntersectionDetailStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionDetailStatusQuery, IntersectionDetailStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionDetailStatusQuery, IntersectionDetailStatusQueryVariables>(IntersectionDetailStatusDocument, options);
        }
export type IntersectionDetailStatusQueryHookResult = ReturnType<typeof useIntersectionDetailStatusQuery>;
export type IntersectionDetailStatusLazyQueryHookResult = ReturnType<typeof useIntersectionDetailStatusLazyQuery>;
export type IntersectionDetailStatusQueryResult = Apollo.QueryResult<IntersectionDetailStatusQuery, IntersectionDetailStatusQueryVariables>;
export function refetchIntersectionDetailStatusQuery(variables: IntersectionDetailStatusQueryVariables) {
      return { query: IntersectionDetailStatusDocument, variables: variables }
    }
export const IntersectionPatternStatusDocument = gql`
    query IntersectionPatternStatus {
  intersectionPatternStatus(intersectionType: SIGNAL)
}
    `;

/**
 * __useIntersectionPatternStatusQuery__
 *
 * To run a query within a React component, call `useIntersectionPatternStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionPatternStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionPatternStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionPatternStatusQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionPatternStatusQuery, IntersectionPatternStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionPatternStatusQuery, IntersectionPatternStatusQueryVariables>(IntersectionPatternStatusDocument, options);
      }
export function useIntersectionPatternStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionPatternStatusQuery, IntersectionPatternStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionPatternStatusQuery, IntersectionPatternStatusQueryVariables>(IntersectionPatternStatusDocument, options);
        }
export type IntersectionPatternStatusQueryHookResult = ReturnType<typeof useIntersectionPatternStatusQuery>;
export type IntersectionPatternStatusLazyQueryHookResult = ReturnType<typeof useIntersectionPatternStatusLazyQuery>;
export type IntersectionPatternStatusQueryResult = Apollo.QueryResult<IntersectionPatternStatusQuery, IntersectionPatternStatusQueryVariables>;
export function refetchIntersectionPatternStatusQuery(variables?: IntersectionPatternStatusQueryVariables) {
      return { query: IntersectionPatternStatusDocument, variables: variables }
    }
export const IntersectionDetailAndPatternStatusDocument = gql`
    query IntersectionDetailAndPatternStatus {
  intersectionDetailStatus
  intersectionPatternStatus
}
    `;

/**
 * __useIntersectionDetailAndPatternStatusQuery__
 *
 * To run a query within a React component, call `useIntersectionDetailAndPatternStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionDetailAndPatternStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionDetailAndPatternStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionDetailAndPatternStatusQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionDetailAndPatternStatusQuery, IntersectionDetailAndPatternStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionDetailAndPatternStatusQuery, IntersectionDetailAndPatternStatusQueryVariables>(IntersectionDetailAndPatternStatusDocument, options);
      }
export function useIntersectionDetailAndPatternStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionDetailAndPatternStatusQuery, IntersectionDetailAndPatternStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionDetailAndPatternStatusQuery, IntersectionDetailAndPatternStatusQueryVariables>(IntersectionDetailAndPatternStatusDocument, options);
        }
export type IntersectionDetailAndPatternStatusQueryHookResult = ReturnType<typeof useIntersectionDetailAndPatternStatusQuery>;
export type IntersectionDetailAndPatternStatusLazyQueryHookResult = ReturnType<typeof useIntersectionDetailAndPatternStatusLazyQuery>;
export type IntersectionDetailAndPatternStatusQueryResult = Apollo.QueryResult<IntersectionDetailAndPatternStatusQuery, IntersectionDetailAndPatternStatusQueryVariables>;
export function refetchIntersectionDetailAndPatternStatusQuery(variables?: IntersectionDetailAndPatternStatusQueryVariables) {
      return { query: IntersectionDetailAndPatternStatusDocument, variables: variables }
    }
export const DetailStatusSubscriptionDocument = gql`
    subscription DetailStatusSubscription($id: ID!) {
  intersectionDetailStatusUpdated(ids: [$id]) {
    ...IntersectionDetailStatus
  }
}
    ${IntersectionDetailStatusFragmentDoc}`;

/**
 * __useDetailStatusSubscriptionSubscription__
 *
 * To run a query within a React component, call `useDetailStatusSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetailStatusSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailStatusSubscriptionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetailStatusSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<DetailStatusSubscriptionSubscription, DetailStatusSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetailStatusSubscriptionSubscription, DetailStatusSubscriptionSubscriptionVariables>(DetailStatusSubscriptionDocument, options);
      }
export type DetailStatusSubscriptionSubscriptionHookResult = ReturnType<typeof useDetailStatusSubscriptionSubscription>;
export type DetailStatusSubscriptionSubscriptionResult = Apollo.SubscriptionResult<DetailStatusSubscriptionSubscription>;
export const IntersectionDetailStatusesDocument = gql`
    query IntersectionDetailStatuses {
  intersectionDetailStatus(intersectionType: SIGNAL)
}
    `;

/**
 * __useIntersectionDetailStatusesQuery__
 *
 * To run a query within a React component, call `useIntersectionDetailStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionDetailStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionDetailStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionDetailStatusesQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionDetailStatusesQuery, IntersectionDetailStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionDetailStatusesQuery, IntersectionDetailStatusesQueryVariables>(IntersectionDetailStatusesDocument, options);
      }
export function useIntersectionDetailStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionDetailStatusesQuery, IntersectionDetailStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionDetailStatusesQuery, IntersectionDetailStatusesQueryVariables>(IntersectionDetailStatusesDocument, options);
        }
export type IntersectionDetailStatusesQueryHookResult = ReturnType<typeof useIntersectionDetailStatusesQuery>;
export type IntersectionDetailStatusesLazyQueryHookResult = ReturnType<typeof useIntersectionDetailStatusesLazyQuery>;
export type IntersectionDetailStatusesQueryResult = Apollo.QueryResult<IntersectionDetailStatusesQuery, IntersectionDetailStatusesQueryVariables>;
export function refetchIntersectionDetailStatusesQuery(variables?: IntersectionDetailStatusesQueryVariables) {
      return { query: IntersectionDetailStatusesDocument, variables: variables }
    }
export const DetailStatusesSubscriptionDocument = gql`
    subscription DetailStatusesSubscription {
  intersectionDetailStatusUpdated {
    intersectionId
    ...IntersectionDetailStatus
  }
}
    ${IntersectionDetailStatusFragmentDoc}`;

/**
 * __useDetailStatusesSubscriptionSubscription__
 *
 * To run a query within a React component, call `useDetailStatusesSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetailStatusesSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailStatusesSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useDetailStatusesSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DetailStatusesSubscriptionSubscription, DetailStatusesSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetailStatusesSubscriptionSubscription, DetailStatusesSubscriptionSubscriptionVariables>(DetailStatusesSubscriptionDocument, options);
      }
export type DetailStatusesSubscriptionSubscriptionHookResult = ReturnType<typeof useDetailStatusesSubscriptionSubscription>;
export type DetailStatusesSubscriptionSubscriptionResult = Apollo.SubscriptionResult<DetailStatusesSubscriptionSubscription>;
export const IntersectionIdsDocument = gql`
    query intersectionIds($searchText: String, $filters: [FilterInput!]) {
  intersectionIds(searchText: $searchText, filters: $filters)
}
    `;

/**
 * __useIntersectionIdsQuery__
 *
 * To run a query within a React component, call `useIntersectionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionIdsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useIntersectionIdsQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionIdsQuery, IntersectionIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionIdsQuery, IntersectionIdsQueryVariables>(IntersectionIdsDocument, options);
      }
export function useIntersectionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionIdsQuery, IntersectionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionIdsQuery, IntersectionIdsQueryVariables>(IntersectionIdsDocument, options);
        }
export type IntersectionIdsQueryHookResult = ReturnType<typeof useIntersectionIdsQuery>;
export type IntersectionIdsLazyQueryHookResult = ReturnType<typeof useIntersectionIdsLazyQuery>;
export type IntersectionIdsQueryResult = Apollo.QueryResult<IntersectionIdsQuery, IntersectionIdsQueryVariables>;
export function refetchIntersectionIdsQuery(variables?: IntersectionIdsQueryVariables) {
      return { query: IntersectionIdsDocument, variables: variables }
    }
export const IntersectionStatusCategoriesDocument = gql`
    query intersectionStatusCategories {
  intersectionStatusCategories {
    ...IntersectionStatusCategoriesFragment
  }
}
    ${IntersectionStatusCategoriesFragmentFragmentDoc}`;

/**
 * __useIntersectionStatusCategoriesQuery__
 *
 * To run a query within a React component, call `useIntersectionStatusCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionStatusCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionStatusCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionStatusCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionStatusCategoriesQuery, IntersectionStatusCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionStatusCategoriesQuery, IntersectionStatusCategoriesQueryVariables>(IntersectionStatusCategoriesDocument, options);
      }
export function useIntersectionStatusCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionStatusCategoriesQuery, IntersectionStatusCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionStatusCategoriesQuery, IntersectionStatusCategoriesQueryVariables>(IntersectionStatusCategoriesDocument, options);
        }
export type IntersectionStatusCategoriesQueryHookResult = ReturnType<typeof useIntersectionStatusCategoriesQuery>;
export type IntersectionStatusCategoriesLazyQueryHookResult = ReturnType<typeof useIntersectionStatusCategoriesLazyQuery>;
export type IntersectionStatusCategoriesQueryResult = Apollo.QueryResult<IntersectionStatusCategoriesQuery, IntersectionStatusCategoriesQueryVariables>;
export function refetchIntersectionStatusCategoriesQuery(variables?: IntersectionStatusCategoriesQueryVariables) {
      return { query: IntersectionStatusCategoriesDocument, variables: variables }
    }
export const IntersectionStatusCategoriesSubscriptionDocument = gql`
    subscription intersectionStatusCategoriesSubscription {
  intersectionStatusCategoriesUpdated {
    ...IntersectionStatusCategoriesFragment
  }
}
    ${IntersectionStatusCategoriesFragmentFragmentDoc}`;

/**
 * __useIntersectionStatusCategoriesSubscriptionSubscription__
 *
 * To run a query within a React component, call `useIntersectionStatusCategoriesSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionStatusCategoriesSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionStatusCategoriesSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIntersectionStatusCategoriesSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IntersectionStatusCategoriesSubscriptionSubscription, IntersectionStatusCategoriesSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IntersectionStatusCategoriesSubscriptionSubscription, IntersectionStatusCategoriesSubscriptionSubscriptionVariables>(IntersectionStatusCategoriesSubscriptionDocument, options);
      }
export type IntersectionStatusCategoriesSubscriptionSubscriptionHookResult = ReturnType<typeof useIntersectionStatusCategoriesSubscriptionSubscription>;
export type IntersectionStatusCategoriesSubscriptionSubscriptionResult = Apollo.SubscriptionResult<IntersectionStatusCategoriesSubscriptionSubscription>;
export const IntersectionPhaseStatusByIdDocument = gql`
    query intersectionPhaseStatusById($id: ID!) {
  intersectionPhaseStatusById(id: $id) {
    phaseStatus {
      number
      color
      actualSplit
      programmedSplit
      lastTerm
      timeStampSecondForActualSplit
    }
  }
}
    `;

/**
 * __useIntersectionPhaseStatusByIdQuery__
 *
 * To run a query within a React component, call `useIntersectionPhaseStatusByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionPhaseStatusByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionPhaseStatusByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionPhaseStatusByIdQuery(baseOptions: Apollo.QueryHookOptions<IntersectionPhaseStatusByIdQuery, IntersectionPhaseStatusByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionPhaseStatusByIdQuery, IntersectionPhaseStatusByIdQueryVariables>(IntersectionPhaseStatusByIdDocument, options);
      }
export function useIntersectionPhaseStatusByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionPhaseStatusByIdQuery, IntersectionPhaseStatusByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionPhaseStatusByIdQuery, IntersectionPhaseStatusByIdQueryVariables>(IntersectionPhaseStatusByIdDocument, options);
        }
export type IntersectionPhaseStatusByIdQueryHookResult = ReturnType<typeof useIntersectionPhaseStatusByIdQuery>;
export type IntersectionPhaseStatusByIdLazyQueryHookResult = ReturnType<typeof useIntersectionPhaseStatusByIdLazyQuery>;
export type IntersectionPhaseStatusByIdQueryResult = Apollo.QueryResult<IntersectionPhaseStatusByIdQuery, IntersectionPhaseStatusByIdQueryVariables>;
export function refetchIntersectionPhaseStatusByIdQuery(variables: IntersectionPhaseStatusByIdQueryVariables) {
      return { query: IntersectionPhaseStatusByIdDocument, variables: variables }
    }
export const IntersectionPhaseStatusDocument = gql`
    subscription intersectionPhaseStatus($id: ID!) {
  intersectionPhaseStatusUpdated(ids: [$id]) {
    phaseStatus {
      number
      color
      actualSplit
      programmedSplit
      lastTerm
      timeStampSecondForActualSplit
    }
  }
}
    `;

/**
 * __useIntersectionPhaseStatusSubscription__
 *
 * To run a query within a React component, call `useIntersectionPhaseStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionPhaseStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionPhaseStatusSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionPhaseStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<IntersectionPhaseStatusSubscription, IntersectionPhaseStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IntersectionPhaseStatusSubscription, IntersectionPhaseStatusSubscriptionVariables>(IntersectionPhaseStatusDocument, options);
      }
export type IntersectionPhaseStatusSubscriptionHookResult = ReturnType<typeof useIntersectionPhaseStatusSubscription>;
export type IntersectionPhaseStatusSubscriptionResult = Apollo.SubscriptionResult<IntersectionPhaseStatusSubscription>;
export const IntersectionPatternStatusByIdDocument = gql`
    query intersectionPatternStatusById($id: ID!) {
  intersectionPatternStatusById(id: $id) {
    ...PatternStatusFragment
  }
}
    ${PatternStatusFragmentFragmentDoc}`;

/**
 * __useIntersectionPatternStatusByIdQuery__
 *
 * To run a query within a React component, call `useIntersectionPatternStatusByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionPatternStatusByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionPatternStatusByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionPatternStatusByIdQuery(baseOptions: Apollo.QueryHookOptions<IntersectionPatternStatusByIdQuery, IntersectionPatternStatusByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionPatternStatusByIdQuery, IntersectionPatternStatusByIdQueryVariables>(IntersectionPatternStatusByIdDocument, options);
      }
export function useIntersectionPatternStatusByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionPatternStatusByIdQuery, IntersectionPatternStatusByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionPatternStatusByIdQuery, IntersectionPatternStatusByIdQueryVariables>(IntersectionPatternStatusByIdDocument, options);
        }
export type IntersectionPatternStatusByIdQueryHookResult = ReturnType<typeof useIntersectionPatternStatusByIdQuery>;
export type IntersectionPatternStatusByIdLazyQueryHookResult = ReturnType<typeof useIntersectionPatternStatusByIdLazyQuery>;
export type IntersectionPatternStatusByIdQueryResult = Apollo.QueryResult<IntersectionPatternStatusByIdQuery, IntersectionPatternStatusByIdQueryVariables>;
export function refetchIntersectionPatternStatusByIdQuery(variables: IntersectionPatternStatusByIdQueryVariables) {
      return { query: IntersectionPatternStatusByIdDocument, variables: variables }
    }
export const IntersectionPatternStatusUpdatedDocument = gql`
    subscription intersectionPatternStatusUpdated($id: ID!) {
  intersectionPatternStatusUpdated(ids: [$id]) {
    ...PatternStatusFragment
  }
}
    ${PatternStatusFragmentFragmentDoc}`;

/**
 * __useIntersectionPatternStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useIntersectionPatternStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionPatternStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionPatternStatusUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionPatternStatusUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IntersectionPatternStatusUpdatedSubscription, IntersectionPatternStatusUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IntersectionPatternStatusUpdatedSubscription, IntersectionPatternStatusUpdatedSubscriptionVariables>(IntersectionPatternStatusUpdatedDocument, options);
      }
export type IntersectionPatternStatusUpdatedSubscriptionHookResult = ReturnType<typeof useIntersectionPatternStatusUpdatedSubscription>;
export type IntersectionPatternStatusUpdatedSubscriptionResult = Apollo.SubscriptionResult<IntersectionPatternStatusUpdatedSubscription>;
export const PatternStatusesSubscriptionDocument = gql`
    subscription PatternStatusesSubscription {
  intersectionPatternStatusUpdated(ids: null) {
    intersectionId
    ...PatternStatusFragment
  }
}
    ${PatternStatusFragmentFragmentDoc}`;

/**
 * __usePatternStatusesSubscriptionSubscription__
 *
 * To run a query within a React component, call `usePatternStatusesSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePatternStatusesSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatternStatusesSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePatternStatusesSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PatternStatusesSubscriptionSubscription, PatternStatusesSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PatternStatusesSubscriptionSubscription, PatternStatusesSubscriptionSubscriptionVariables>(PatternStatusesSubscriptionDocument, options);
      }
export type PatternStatusesSubscriptionSubscriptionHookResult = ReturnType<typeof usePatternStatusesSubscriptionSubscription>;
export type PatternStatusesSubscriptionSubscriptionResult = Apollo.SubscriptionResult<PatternStatusesSubscriptionSubscription>;
export const PatternStatuseMultipleIdsSubscriptionDocument = gql`
    subscription PatternStatuseMultipleIdsSubscription($ids: [ID!]) {
  intersectionPatternStatusUpdated(ids: $ids) {
    intersectionId
    ...PatternStatusFragment
  }
}
    ${PatternStatusFragmentFragmentDoc}`;

/**
 * __usePatternStatuseMultipleIdsSubscriptionSubscription__
 *
 * To run a query within a React component, call `usePatternStatuseMultipleIdsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePatternStatuseMultipleIdsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatternStatuseMultipleIdsSubscriptionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePatternStatuseMultipleIdsSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PatternStatuseMultipleIdsSubscriptionSubscription, PatternStatuseMultipleIdsSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PatternStatuseMultipleIdsSubscriptionSubscription, PatternStatuseMultipleIdsSubscriptionSubscriptionVariables>(PatternStatuseMultipleIdsSubscriptionDocument, options);
      }
export type PatternStatuseMultipleIdsSubscriptionSubscriptionHookResult = ReturnType<typeof usePatternStatuseMultipleIdsSubscriptionSubscription>;
export type PatternStatuseMultipleIdsSubscriptionSubscriptionResult = Apollo.SubscriptionResult<PatternStatuseMultipleIdsSubscriptionSubscription>;
export const DetailStatusMultipleIdsSubscriptionDocument = gql`
    subscription DetailStatusMultipleIdsSubscription($ids: [ID!]) {
  intersectionDetailStatusUpdated(ids: $ids) {
    intersectionId
    ...IntersectionDetailStatus
  }
}
    ${IntersectionDetailStatusFragmentDoc}`;

/**
 * __useDetailStatusMultipleIdsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useDetailStatusMultipleIdsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetailStatusMultipleIdsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailStatusMultipleIdsSubscriptionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDetailStatusMultipleIdsSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DetailStatusMultipleIdsSubscriptionSubscription, DetailStatusMultipleIdsSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetailStatusMultipleIdsSubscriptionSubscription, DetailStatusMultipleIdsSubscriptionSubscriptionVariables>(DetailStatusMultipleIdsSubscriptionDocument, options);
      }
export type DetailStatusMultipleIdsSubscriptionSubscriptionHookResult = ReturnType<typeof useDetailStatusMultipleIdsSubscriptionSubscription>;
export type DetailStatusMultipleIdsSubscriptionSubscriptionResult = Apollo.SubscriptionResult<DetailStatusMultipleIdsSubscriptionSubscription>;
export const IntegrationConfigSettingsDocument = gql`
    query IntegrationConfigSettings($id: ID!) {
  integration(id: $id) {
    config {
      settings
    }
  }
}
    `;

/**
 * __useIntegrationConfigSettingsQuery__
 *
 * To run a query within a React component, call `useIntegrationConfigSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationConfigSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationConfigSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationConfigSettingsQuery(baseOptions: Apollo.QueryHookOptions<IntegrationConfigSettingsQuery, IntegrationConfigSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationConfigSettingsQuery, IntegrationConfigSettingsQueryVariables>(IntegrationConfigSettingsDocument, options);
      }
export function useIntegrationConfigSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationConfigSettingsQuery, IntegrationConfigSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationConfigSettingsQuery, IntegrationConfigSettingsQueryVariables>(IntegrationConfigSettingsDocument, options);
        }
export type IntegrationConfigSettingsQueryHookResult = ReturnType<typeof useIntegrationConfigSettingsQuery>;
export type IntegrationConfigSettingsLazyQueryHookResult = ReturnType<typeof useIntegrationConfigSettingsLazyQuery>;
export type IntegrationConfigSettingsQueryResult = Apollo.QueryResult<IntegrationConfigSettingsQuery, IntegrationConfigSettingsQueryVariables>;
export function refetchIntegrationConfigSettingsQuery(variables: IntegrationConfigSettingsQueryVariables) {
      return { query: IntegrationConfigSettingsDocument, variables: variables }
    }
export const IntersectionCommentsDocument = gql`
    query intersectionComments($id: ID!) {
  intersectionComments(id: $id) {
    id
    comment
    intersectionId
    timestamp
    user {
      username
    }
  }
}
    `;

/**
 * __useIntersectionCommentsQuery__
 *
 * To run a query within a React component, call `useIntersectionCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionCommentsQuery(baseOptions: Apollo.QueryHookOptions<IntersectionCommentsQuery, IntersectionCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionCommentsQuery, IntersectionCommentsQueryVariables>(IntersectionCommentsDocument, options);
      }
export function useIntersectionCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionCommentsQuery, IntersectionCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionCommentsQuery, IntersectionCommentsQueryVariables>(IntersectionCommentsDocument, options);
        }
export type IntersectionCommentsQueryHookResult = ReturnType<typeof useIntersectionCommentsQuery>;
export type IntersectionCommentsLazyQueryHookResult = ReturnType<typeof useIntersectionCommentsLazyQuery>;
export type IntersectionCommentsQueryResult = Apollo.QueryResult<IntersectionCommentsQuery, IntersectionCommentsQueryVariables>;
export function refetchIntersectionCommentsQuery(variables: IntersectionCommentsQueryVariables) {
      return { query: IntersectionCommentsDocument, variables: variables }
    }
export const IntersectionCommentsUpdatedDocument = gql`
    subscription IntersectionCommentsUpdated($ids: [ID!]) {
  intersectionCommentsUpdated(ids: $ids) {
    id
    comment
    intersectionId
    timestamp
  }
}
    `;

/**
 * __useIntersectionCommentsUpdatedSubscription__
 *
 * To run a query within a React component, call `useIntersectionCommentsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionCommentsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionCommentsUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useIntersectionCommentsUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IntersectionCommentsUpdatedSubscription, IntersectionCommentsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IntersectionCommentsUpdatedSubscription, IntersectionCommentsUpdatedSubscriptionVariables>(IntersectionCommentsUpdatedDocument, options);
      }
export type IntersectionCommentsUpdatedSubscriptionHookResult = ReturnType<typeof useIntersectionCommentsUpdatedSubscription>;
export type IntersectionCommentsUpdatedSubscriptionResult = Apollo.SubscriptionResult<IntersectionCommentsUpdatedSubscription>;
export const IntersectionIconStatusUpdateDocument = gql`
    subscription intersectionIconStatusUpdate($ids: [ID!]) {
  intersectionIconStatusUpdate(ids: $ids) {
    intersectionId
    icons {
      name
      type
      bearing
      config
      location
      state
    }
  }
}
    `;

/**
 * __useIntersectionIconStatusUpdateSubscription__
 *
 * To run a query within a React component, call `useIntersectionIconStatusUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionIconStatusUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionIconStatusUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useIntersectionIconStatusUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IntersectionIconStatusUpdateSubscription, IntersectionIconStatusUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IntersectionIconStatusUpdateSubscription, IntersectionIconStatusUpdateSubscriptionVariables>(IntersectionIconStatusUpdateDocument, options);
      }
export type IntersectionIconStatusUpdateSubscriptionHookResult = ReturnType<typeof useIntersectionIconStatusUpdateSubscription>;
export type IntersectionIconStatusUpdateSubscriptionResult = Apollo.SubscriptionResult<IntersectionIconStatusUpdateSubscription>;
export const IntersectionIconStatusDocument = gql`
    query intersectionIconStatus($id: ID!) {
  intersectionIconStatus(id: $id) {
    intersectionId
    icons {
      name
      type
      config
      location
      state
      bearing
    }
  }
}
    `;

/**
 * __useIntersectionIconStatusQuery__
 *
 * To run a query within a React component, call `useIntersectionIconStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionIconStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionIconStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntersectionIconStatusQuery(baseOptions: Apollo.QueryHookOptions<IntersectionIconStatusQuery, IntersectionIconStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionIconStatusQuery, IntersectionIconStatusQueryVariables>(IntersectionIconStatusDocument, options);
      }
export function useIntersectionIconStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionIconStatusQuery, IntersectionIconStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionIconStatusQuery, IntersectionIconStatusQueryVariables>(IntersectionIconStatusDocument, options);
        }
export type IntersectionIconStatusQueryHookResult = ReturnType<typeof useIntersectionIconStatusQuery>;
export type IntersectionIconStatusLazyQueryHookResult = ReturnType<typeof useIntersectionIconStatusLazyQuery>;
export type IntersectionIconStatusQueryResult = Apollo.QueryResult<IntersectionIconStatusQuery, IntersectionIconStatusQueryVariables>;
export function refetchIntersectionIconStatusQuery(variables: IntersectionIconStatusQueryVariables) {
      return { query: IntersectionIconStatusDocument, variables: variables }
    }
export const GetSignalTasksByIntersectionDocument = gql`
    query GetSignalTasksByIntersection($intersectionId: ID!, $from: DateTime!, $to: DateTime!, $timezone: String!) {
  signalScheduledTasksByIntersection(
    intersectionId: $intersectionId
    from: $from
    to: $to
    timezone: $timezone
  ) {
    ...TaskOccurrenceFragment
  }
}
    ${TaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useGetSignalTasksByIntersectionQuery__
 *
 * To run a query within a React component, call `useGetSignalTasksByIntersectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalTasksByIntersectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalTasksByIntersectionQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetSignalTasksByIntersectionQuery(baseOptions: Apollo.QueryHookOptions<GetSignalTasksByIntersectionQuery, GetSignalTasksByIntersectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignalTasksByIntersectionQuery, GetSignalTasksByIntersectionQueryVariables>(GetSignalTasksByIntersectionDocument, options);
      }
export function useGetSignalTasksByIntersectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignalTasksByIntersectionQuery, GetSignalTasksByIntersectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignalTasksByIntersectionQuery, GetSignalTasksByIntersectionQueryVariables>(GetSignalTasksByIntersectionDocument, options);
        }
export type GetSignalTasksByIntersectionQueryHookResult = ReturnType<typeof useGetSignalTasksByIntersectionQuery>;
export type GetSignalTasksByIntersectionLazyQueryHookResult = ReturnType<typeof useGetSignalTasksByIntersectionLazyQuery>;
export type GetSignalTasksByIntersectionQueryResult = Apollo.QueryResult<GetSignalTasksByIntersectionQuery, GetSignalTasksByIntersectionQueryVariables>;
export function refetchGetSignalTasksByIntersectionQuery(variables: GetSignalTasksByIntersectionQueryVariables) {
      return { query: GetSignalTasksByIntersectionDocument, variables: variables }
    }
export const GetAllSignalTasksDocument = gql`
    query GetAllSignalTasks($from: DateTime!, $to: DateTime!, $timezone: String!) {
  signalScheduledTasks(from: $from, to: $to, timezone: $timezone) {
    ...TaskOccurrenceFragment
  }
}
    ${TaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useGetAllSignalTasksQuery__
 *
 * To run a query within a React component, call `useGetAllSignalTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSignalTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSignalTasksQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetAllSignalTasksQuery(baseOptions: Apollo.QueryHookOptions<GetAllSignalTasksQuery, GetAllSignalTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSignalTasksQuery, GetAllSignalTasksQueryVariables>(GetAllSignalTasksDocument, options);
      }
export function useGetAllSignalTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSignalTasksQuery, GetAllSignalTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSignalTasksQuery, GetAllSignalTasksQueryVariables>(GetAllSignalTasksDocument, options);
        }
export type GetAllSignalTasksQueryHookResult = ReturnType<typeof useGetAllSignalTasksQuery>;
export type GetAllSignalTasksLazyQueryHookResult = ReturnType<typeof useGetAllSignalTasksLazyQuery>;
export type GetAllSignalTasksQueryResult = Apollo.QueryResult<GetAllSignalTasksQuery, GetAllSignalTasksQueryVariables>;
export function refetchGetAllSignalTasksQuery(variables: GetAllSignalTasksQueryVariables) {
      return { query: GetAllSignalTasksDocument, variables: variables }
    }
export const GetSignalTaskByIdQueryDocument = gql`
    query GetSignalTaskByIdQuery($taskId: ID!) {
  signalScheduledTask(taskId: $taskId) {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;

/**
 * __useGetSignalTaskByIdQueryQuery__
 *
 * To run a query within a React component, call `useGetSignalTaskByIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalTaskByIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalTaskByIdQueryQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetSignalTaskByIdQueryQuery(baseOptions: Apollo.QueryHookOptions<GetSignalTaskByIdQueryQuery, GetSignalTaskByIdQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignalTaskByIdQueryQuery, GetSignalTaskByIdQueryQueryVariables>(GetSignalTaskByIdQueryDocument, options);
      }
export function useGetSignalTaskByIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignalTaskByIdQueryQuery, GetSignalTaskByIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignalTaskByIdQueryQuery, GetSignalTaskByIdQueryQueryVariables>(GetSignalTaskByIdQueryDocument, options);
        }
export type GetSignalTaskByIdQueryQueryHookResult = ReturnType<typeof useGetSignalTaskByIdQueryQuery>;
export type GetSignalTaskByIdQueryLazyQueryHookResult = ReturnType<typeof useGetSignalTaskByIdQueryLazyQuery>;
export type GetSignalTaskByIdQueryQueryResult = Apollo.QueryResult<GetSignalTaskByIdQueryQuery, GetSignalTaskByIdQueryQueryVariables>;
export function refetchGetSignalTaskByIdQueryQuery(variables: GetSignalTaskByIdQueryQueryVariables) {
      return { query: GetSignalTaskByIdQueryDocument, variables: variables }
    }
export const SignalsTaskUpdatedDocument = gql`
    subscription SignalsTaskUpdated($ids: [ID!], $creation: Boolean, $deletion: Boolean) {
  taskUpdated(ids: $ids, creation: $creation, deletion: $deletion) {
    ...SignalsTaskFragment
  }
}
    ${SignalsTaskFragmentFragmentDoc}`;

/**
 * __useSignalsTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useSignalsTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSignalsTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalsTaskUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      creation: // value for 'creation'
 *      deletion: // value for 'deletion'
 *   },
 * });
 */
export function useSignalsTaskUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SignalsTaskUpdatedSubscription, SignalsTaskUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SignalsTaskUpdatedSubscription, SignalsTaskUpdatedSubscriptionVariables>(SignalsTaskUpdatedDocument, options);
      }
export type SignalsTaskUpdatedSubscriptionHookResult = ReturnType<typeof useSignalsTaskUpdatedSubscription>;
export type SignalsTaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<SignalsTaskUpdatedSubscription>;
export const SignalCommandDefinitionsDocument = gql`
    query signalCommandDefinitions {
  signalCommandDefinitions {
    commandType
    commandValues {
      name
      minValue
      maxValue
      defaultValue
      unsetValue
    }
    supportedProtocols
  }
}
    `;

/**
 * __useSignalCommandDefinitionsQuery__
 *
 * To run a query within a React component, call `useSignalCommandDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalCommandDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalCommandDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignalCommandDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<SignalCommandDefinitionsQuery, SignalCommandDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalCommandDefinitionsQuery, SignalCommandDefinitionsQueryVariables>(SignalCommandDefinitionsDocument, options);
      }
export function useSignalCommandDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalCommandDefinitionsQuery, SignalCommandDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalCommandDefinitionsQuery, SignalCommandDefinitionsQueryVariables>(SignalCommandDefinitionsDocument, options);
        }
export type SignalCommandDefinitionsQueryHookResult = ReturnType<typeof useSignalCommandDefinitionsQuery>;
export type SignalCommandDefinitionsLazyQueryHookResult = ReturnType<typeof useSignalCommandDefinitionsLazyQuery>;
export type SignalCommandDefinitionsQueryResult = Apollo.QueryResult<SignalCommandDefinitionsQuery, SignalCommandDefinitionsQueryVariables>;
export function refetchSignalCommandDefinitionsQuery(variables?: SignalCommandDefinitionsQueryVariables) {
      return { query: SignalCommandDefinitionsDocument, variables: variables }
    }
export const GetDeviceEventsDocument = gql`
    query getDeviceEvents($intersectionId: String!, $after: String, $before: String, $limit: Int = 10, $sortField: String = "timeStamp", $sortOrder: SortOrder = DESCENDING, $startDateTime: DateTime, $endDateTime: DateTime, $rule: String) {
  deviceEvents(
    intersectionId: $intersectionId
    sortField: $sortField
    sortOrder: $sortOrder
    before: $before
    limit: $limit
    after: $after
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    rule: $rule
  ) {
    edges {
      cursor
      node {
        ...DeviceEventFragment
      }
      __typename
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${DeviceEventFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useGetDeviceEventsQuery__
 *
 * To run a query within a React component, call `useGetDeviceEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceEventsQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      rule: // value for 'rule'
 *   },
 * });
 */
export function useGetDeviceEventsQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceEventsQuery, GetDeviceEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceEventsQuery, GetDeviceEventsQueryVariables>(GetDeviceEventsDocument, options);
      }
export function useGetDeviceEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceEventsQuery, GetDeviceEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceEventsQuery, GetDeviceEventsQueryVariables>(GetDeviceEventsDocument, options);
        }
export type GetDeviceEventsQueryHookResult = ReturnType<typeof useGetDeviceEventsQuery>;
export type GetDeviceEventsLazyQueryHookResult = ReturnType<typeof useGetDeviceEventsLazyQuery>;
export type GetDeviceEventsQueryResult = Apollo.QueryResult<GetDeviceEventsQuery, GetDeviceEventsQueryVariables>;
export function refetchGetDeviceEventsQuery(variables: GetDeviceEventsQueryVariables) {
      return { query: GetDeviceEventsDocument, variables: variables }
    }
export const TrafficEventDefinitionsDocument = gql`
    query trafficEventDefinitions($intersectionId: String!) {
  trafficEventDefinitions(intersectionId: $intersectionId) {
    vendorEventName
    vendorEventCode
    parameterDescription
    eventDescription
    eventDefinitionType
    universalEventCode
    universalEventName
    eventCategoryId
    eventCategoryName
  }
}
    `;

/**
 * __useTrafficEventDefinitionsQuery__
 *
 * To run a query within a React component, call `useTrafficEventDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficEventDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficEventDefinitionsQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useTrafficEventDefinitionsQuery(baseOptions: Apollo.QueryHookOptions<TrafficEventDefinitionsQuery, TrafficEventDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficEventDefinitionsQuery, TrafficEventDefinitionsQueryVariables>(TrafficEventDefinitionsDocument, options);
      }
export function useTrafficEventDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficEventDefinitionsQuery, TrafficEventDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficEventDefinitionsQuery, TrafficEventDefinitionsQueryVariables>(TrafficEventDefinitionsDocument, options);
        }
export type TrafficEventDefinitionsQueryHookResult = ReturnType<typeof useTrafficEventDefinitionsQuery>;
export type TrafficEventDefinitionsLazyQueryHookResult = ReturnType<typeof useTrafficEventDefinitionsLazyQuery>;
export type TrafficEventDefinitionsQueryResult = Apollo.QueryResult<TrafficEventDefinitionsQuery, TrafficEventDefinitionsQueryVariables>;
export function refetchTrafficEventDefinitionsQuery(variables: TrafficEventDefinitionsQueryVariables) {
      return { query: TrafficEventDefinitionsDocument, variables: variables }
    }
export const TrafficEventCategoryDocument = gql`
    query trafficEventCategory {
  trafficEventCategory {
    categoryId
    categoryName
    universalEventCodeRange
  }
}
    `;

/**
 * __useTrafficEventCategoryQuery__
 *
 * To run a query within a React component, call `useTrafficEventCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficEventCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficEventCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrafficEventCategoryQuery(baseOptions?: Apollo.QueryHookOptions<TrafficEventCategoryQuery, TrafficEventCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficEventCategoryQuery, TrafficEventCategoryQueryVariables>(TrafficEventCategoryDocument, options);
      }
export function useTrafficEventCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficEventCategoryQuery, TrafficEventCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficEventCategoryQuery, TrafficEventCategoryQueryVariables>(TrafficEventCategoryDocument, options);
        }
export type TrafficEventCategoryQueryHookResult = ReturnType<typeof useTrafficEventCategoryQuery>;
export type TrafficEventCategoryLazyQueryHookResult = ReturnType<typeof useTrafficEventCategoryLazyQuery>;
export type TrafficEventCategoryQueryResult = Apollo.QueryResult<TrafficEventCategoryQuery, TrafficEventCategoryQueryVariables>;
export function refetchTrafficEventCategoryQuery(variables?: TrafficEventCategoryQueryVariables) {
      return { query: TrafficEventCategoryDocument, variables: variables }
    }
export const SignalAppliedCommandsDocument = gql`
    query signalAppliedCommands($timezone: String!, $after: String, $before: String, $limit: Int, $sortField: String, $sortOrder: SortOrder, $searchText: String, $searchFields: [String!], $filters: [FilterInput]) {
  signalAppliedCommands(
    timezone: $timezone
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
    searchFields: $searchFields
    filters: $filters
  ) {
    edges {
      cursor
      node {
        ...AppliedCommandFragment
      }
      __typename
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${AppliedCommandFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignalAppliedCommandsQuery__
 *
 * To run a query within a React component, call `useSignalAppliedCommandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalAppliedCommandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalAppliedCommandsQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSignalAppliedCommandsQuery(baseOptions: Apollo.QueryHookOptions<SignalAppliedCommandsQuery, SignalAppliedCommandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalAppliedCommandsQuery, SignalAppliedCommandsQueryVariables>(SignalAppliedCommandsDocument, options);
      }
export function useSignalAppliedCommandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalAppliedCommandsQuery, SignalAppliedCommandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalAppliedCommandsQuery, SignalAppliedCommandsQueryVariables>(SignalAppliedCommandsDocument, options);
        }
export type SignalAppliedCommandsQueryHookResult = ReturnType<typeof useSignalAppliedCommandsQuery>;
export type SignalAppliedCommandsLazyQueryHookResult = ReturnType<typeof useSignalAppliedCommandsLazyQuery>;
export type SignalAppliedCommandsQueryResult = Apollo.QueryResult<SignalAppliedCommandsQuery, SignalAppliedCommandsQueryVariables>;
export function refetchSignalAppliedCommandsQuery(variables: SignalAppliedCommandsQueryVariables) {
      return { query: SignalAppliedCommandsDocument, variables: variables }
    }
export const AppliedCommandFilterOptionsDocument = gql`
    query appliedCommandFilterOptions {
  signalAppliedCommandFilterOptions {
    intersections {
      id
      name
    }
    devices {
      id
      name
    }
    inheritedGroups {
      id
      name
    }
    commands
    sources
  }
}
    `;

/**
 * __useAppliedCommandFilterOptionsQuery__
 *
 * To run a query within a React component, call `useAppliedCommandFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppliedCommandFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppliedCommandFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppliedCommandFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AppliedCommandFilterOptionsQuery, AppliedCommandFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppliedCommandFilterOptionsQuery, AppliedCommandFilterOptionsQueryVariables>(AppliedCommandFilterOptionsDocument, options);
      }
export function useAppliedCommandFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppliedCommandFilterOptionsQuery, AppliedCommandFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppliedCommandFilterOptionsQuery, AppliedCommandFilterOptionsQueryVariables>(AppliedCommandFilterOptionsDocument, options);
        }
export type AppliedCommandFilterOptionsQueryHookResult = ReturnType<typeof useAppliedCommandFilterOptionsQuery>;
export type AppliedCommandFilterOptionsLazyQueryHookResult = ReturnType<typeof useAppliedCommandFilterOptionsLazyQuery>;
export type AppliedCommandFilterOptionsQueryResult = Apollo.QueryResult<AppliedCommandFilterOptionsQuery, AppliedCommandFilterOptionsQueryVariables>;
export function refetchAppliedCommandFilterOptionsQuery(variables?: AppliedCommandFilterOptionsQueryVariables) {
      return { query: AppliedCommandFilterOptionsDocument, variables: variables }
    }
export const AppliedCommandsSubscriptionDocument = gql`
    subscription appliedCommandsSubscription {
  signalAppliedCommandUpdated {
    streamObjectOperation
    dto {
      id
      intersection {
        id
        name
        type
      }
      device {
        id
        name
        type
      }
      inheritedGroup {
        id
        name
        type
      }
      command
      value
      taskId
      startDateTime
      endDateTime
      status
      source
    }
  }
}
    `;

/**
 * __useAppliedCommandsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useAppliedCommandsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppliedCommandsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppliedCommandsSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAppliedCommandsSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AppliedCommandsSubscriptionSubscription, AppliedCommandsSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppliedCommandsSubscriptionSubscription, AppliedCommandsSubscriptionSubscriptionVariables>(AppliedCommandsSubscriptionDocument, options);
      }
export type AppliedCommandsSubscriptionSubscriptionHookResult = ReturnType<typeof useAppliedCommandsSubscriptionSubscription>;
export type AppliedCommandsSubscriptionSubscriptionResult = Apollo.SubscriptionResult<AppliedCommandsSubscriptionSubscription>;
export const NearbyIntersectionsByPointDocument = gql`
    query nearbyIntersectionsByPoint($x: Float!, $y: Float!, $thresholdMiles: Float) {
  nearbyIntersectionsByPoint(x: $x, y: $y, thresholdMiles: $thresholdMiles) {
    id
  }
}
    `;

/**
 * __useNearbyIntersectionsByPointQuery__
 *
 * To run a query within a React component, call `useNearbyIntersectionsByPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useNearbyIntersectionsByPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNearbyIntersectionsByPointQuery({
 *   variables: {
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      thresholdMiles: // value for 'thresholdMiles'
 *   },
 * });
 */
export function useNearbyIntersectionsByPointQuery(baseOptions: Apollo.QueryHookOptions<NearbyIntersectionsByPointQuery, NearbyIntersectionsByPointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NearbyIntersectionsByPointQuery, NearbyIntersectionsByPointQueryVariables>(NearbyIntersectionsByPointDocument, options);
      }
export function useNearbyIntersectionsByPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NearbyIntersectionsByPointQuery, NearbyIntersectionsByPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NearbyIntersectionsByPointQuery, NearbyIntersectionsByPointQueryVariables>(NearbyIntersectionsByPointDocument, options);
        }
export type NearbyIntersectionsByPointQueryHookResult = ReturnType<typeof useNearbyIntersectionsByPointQuery>;
export type NearbyIntersectionsByPointLazyQueryHookResult = ReturnType<typeof useNearbyIntersectionsByPointLazyQuery>;
export type NearbyIntersectionsByPointQueryResult = Apollo.QueryResult<NearbyIntersectionsByPointQuery, NearbyIntersectionsByPointQueryVariables>;
export function refetchNearbyIntersectionsByPointQuery(variables: NearbyIntersectionsByPointQueryVariables) {
      return { query: NearbyIntersectionsByPointDocument, variables: variables }
    }
export const AtspmReportDocument = gql`
    query atspmReport($intersectionId: String!, $startDateTime: DateTime!, $endDateTime: DateTime!, $reportType: ATSPMSignalReport!, $params: Object) {
  atspmReport(
    intersectionId: $intersectionId
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    reportType: $reportType
    params: $params
  ) {
    reportType
    reportTabs {
      ...ReportTabsFragment
    }
  }
}
    ${ReportTabsFragmentFragmentDoc}`;

/**
 * __useAtspmReportQuery__
 *
 * To run a query within a React component, call `useAtspmReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtspmReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtspmReportQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      reportType: // value for 'reportType'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAtspmReportQuery(baseOptions: Apollo.QueryHookOptions<AtspmReportQuery, AtspmReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtspmReportQuery, AtspmReportQueryVariables>(AtspmReportDocument, options);
      }
export function useAtspmReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtspmReportQuery, AtspmReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtspmReportQuery, AtspmReportQueryVariables>(AtspmReportDocument, options);
        }
export type AtspmReportQueryHookResult = ReturnType<typeof useAtspmReportQuery>;
export type AtspmReportLazyQueryHookResult = ReturnType<typeof useAtspmReportLazyQuery>;
export type AtspmReportQueryResult = Apollo.QueryResult<AtspmReportQuery, AtspmReportQueryVariables>;
export function refetchAtspmReportQuery(variables: AtspmReportQueryVariables) {
      return { query: AtspmReportDocument, variables: variables }
    }
export const SignalActionSetsListDocument = gql`
    query SignalActionSetsList($sortOrder: SortOrder = ASCENDING, $sortField: String = "number", $filters: [FilterInput!], $searchText: String, $searchFields: [String!] = ["name", "number"], $limit: Int = 10, $before: String, $after: String) {
  signalActionSets(
    searchText: $searchText
    searchFields: $searchFields
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        id
        name
        number
        impact
        notes
        priority
        commands
        centerId
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useSignalActionSetsListQuery__
 *
 * To run a query within a React component, call `useSignalActionSetsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalActionSetsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalActionSetsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSignalActionSetsListQuery(baseOptions?: Apollo.QueryHookOptions<SignalActionSetsListQuery, SignalActionSetsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalActionSetsListQuery, SignalActionSetsListQueryVariables>(SignalActionSetsListDocument, options);
      }
export function useSignalActionSetsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalActionSetsListQuery, SignalActionSetsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalActionSetsListQuery, SignalActionSetsListQueryVariables>(SignalActionSetsListDocument, options);
        }
export type SignalActionSetsListQueryHookResult = ReturnType<typeof useSignalActionSetsListQuery>;
export type SignalActionSetsListLazyQueryHookResult = ReturnType<typeof useSignalActionSetsListLazyQuery>;
export type SignalActionSetsListQueryResult = Apollo.QueryResult<SignalActionSetsListQuery, SignalActionSetsListQueryVariables>;
export function refetchSignalActionSetsListQuery(variables?: SignalActionSetsListQueryVariables) {
      return { query: SignalActionSetsListDocument, variables: variables }
    }
export const IntegrationsForExternalLinksDocument = gql`
    query IntegrationsForExternalLinks($filters: [FilterInput!]) {
  integrations(filters: $filters) {
    edges {
      node {
        id
        config {
          integrationType
          settings
        }
      }
    }
  }
}
    `;

/**
 * __useIntegrationsForExternalLinksQuery__
 *
 * To run a query within a React component, call `useIntegrationsForExternalLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsForExternalLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsForExternalLinksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useIntegrationsForExternalLinksQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationsForExternalLinksQuery, IntegrationsForExternalLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsForExternalLinksQuery, IntegrationsForExternalLinksQueryVariables>(IntegrationsForExternalLinksDocument, options);
      }
export function useIntegrationsForExternalLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsForExternalLinksQuery, IntegrationsForExternalLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsForExternalLinksQuery, IntegrationsForExternalLinksQueryVariables>(IntegrationsForExternalLinksDocument, options);
        }
export type IntegrationsForExternalLinksQueryHookResult = ReturnType<typeof useIntegrationsForExternalLinksQuery>;
export type IntegrationsForExternalLinksLazyQueryHookResult = ReturnType<typeof useIntegrationsForExternalLinksLazyQuery>;
export type IntegrationsForExternalLinksQueryResult = Apollo.QueryResult<IntegrationsForExternalLinksQuery, IntegrationsForExternalLinksQueryVariables>;
export function refetchIntegrationsForExternalLinksQuery(variables?: IntegrationsForExternalLinksQueryVariables) {
      return { query: IntegrationsForExternalLinksDocument, variables: variables }
    }
export const AppliedCommandLayerStatusDocument = gql`
    query AppliedCommandLayerStatus {
  intersectionDetailStatus
  signalAppliedCommands(timezone: "UTC", limit: 50000) {
    edges {
      node {
        intersection {
          id
        }
        id
        source
      }
    }
  }
}
    `;

/**
 * __useAppliedCommandLayerStatusQuery__
 *
 * To run a query within a React component, call `useAppliedCommandLayerStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppliedCommandLayerStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppliedCommandLayerStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppliedCommandLayerStatusQuery(baseOptions?: Apollo.QueryHookOptions<AppliedCommandLayerStatusQuery, AppliedCommandLayerStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppliedCommandLayerStatusQuery, AppliedCommandLayerStatusQueryVariables>(AppliedCommandLayerStatusDocument, options);
      }
export function useAppliedCommandLayerStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppliedCommandLayerStatusQuery, AppliedCommandLayerStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppliedCommandLayerStatusQuery, AppliedCommandLayerStatusQueryVariables>(AppliedCommandLayerStatusDocument, options);
        }
export type AppliedCommandLayerStatusQueryHookResult = ReturnType<typeof useAppliedCommandLayerStatusQuery>;
export type AppliedCommandLayerStatusLazyQueryHookResult = ReturnType<typeof useAppliedCommandLayerStatusLazyQuery>;
export type AppliedCommandLayerStatusQueryResult = Apollo.QueryResult<AppliedCommandLayerStatusQuery, AppliedCommandLayerStatusQueryVariables>;
export function refetchAppliedCommandLayerStatusQuery(variables?: AppliedCommandLayerStatusQueryVariables) {
      return { query: AppliedCommandLayerStatusDocument, variables: variables }
    }
export const AlarmStatusLayerDocument = gql`
    query AlarmStatusLayer {
  intersectionDetailStatus
  alarms(
    query: {limit: 100000, filters: [{field: "active", value: true, operator: EQUALS}, {field: "source", value: "SIGNALS", operator: EQUALS}]}
  ) {
    edges {
      node {
        entityId
        id
      }
    }
  }
}
    `;

/**
 * __useAlarmStatusLayerQuery__
 *
 * To run a query within a React component, call `useAlarmStatusLayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlarmStatusLayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlarmStatusLayerQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlarmStatusLayerQuery(baseOptions?: Apollo.QueryHookOptions<AlarmStatusLayerQuery, AlarmStatusLayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlarmStatusLayerQuery, AlarmStatusLayerQueryVariables>(AlarmStatusLayerDocument, options);
      }
export function useAlarmStatusLayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlarmStatusLayerQuery, AlarmStatusLayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlarmStatusLayerQuery, AlarmStatusLayerQueryVariables>(AlarmStatusLayerDocument, options);
        }
export type AlarmStatusLayerQueryHookResult = ReturnType<typeof useAlarmStatusLayerQuery>;
export type AlarmStatusLayerLazyQueryHookResult = ReturnType<typeof useAlarmStatusLayerLazyQuery>;
export type AlarmStatusLayerQueryResult = Apollo.QueryResult<AlarmStatusLayerQuery, AlarmStatusLayerQueryVariables>;
export function refetchAlarmStatusLayerQuery(variables?: AlarmStatusLayerQueryVariables) {
      return { query: AlarmStatusLayerDocument, variables: variables }
    }
export const MainLineGreenLayerDocument = gql`
    query MainLineGreenLayer {
  intersectionDetailStatus
  intersectionSimpleStatus
}
    `;

/**
 * __useMainLineGreenLayerQuery__
 *
 * To run a query within a React component, call `useMainLineGreenLayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainLineGreenLayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainLineGreenLayerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMainLineGreenLayerQuery(baseOptions?: Apollo.QueryHookOptions<MainLineGreenLayerQuery, MainLineGreenLayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainLineGreenLayerQuery, MainLineGreenLayerQueryVariables>(MainLineGreenLayerDocument, options);
      }
export function useMainLineGreenLayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainLineGreenLayerQuery, MainLineGreenLayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainLineGreenLayerQuery, MainLineGreenLayerQueryVariables>(MainLineGreenLayerDocument, options);
        }
export type MainLineGreenLayerQueryHookResult = ReturnType<typeof useMainLineGreenLayerQuery>;
export type MainLineGreenLayerLazyQueryHookResult = ReturnType<typeof useMainLineGreenLayerLazyQuery>;
export type MainLineGreenLayerQueryResult = Apollo.QueryResult<MainLineGreenLayerQuery, MainLineGreenLayerQueryVariables>;
export function refetchMainLineGreenLayerQuery(variables?: MainLineGreenLayerQueryVariables) {
      return { query: MainLineGreenLayerDocument, variables: variables }
    }
export const SignalActionSetCommandOptionsDocument = gql`
    query SignalActionSetCommandOptions {
  signalActionSets(limit: 1000) {
    edges {
      node {
        id
        name
        commands
      }
    }
  }
}
    `;

/**
 * __useSignalActionSetCommandOptionsQuery__
 *
 * To run a query within a React component, call `useSignalActionSetCommandOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalActionSetCommandOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalActionSetCommandOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignalActionSetCommandOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SignalActionSetCommandOptionsQuery, SignalActionSetCommandOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalActionSetCommandOptionsQuery, SignalActionSetCommandOptionsQueryVariables>(SignalActionSetCommandOptionsDocument, options);
      }
export function useSignalActionSetCommandOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalActionSetCommandOptionsQuery, SignalActionSetCommandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalActionSetCommandOptionsQuery, SignalActionSetCommandOptionsQueryVariables>(SignalActionSetCommandOptionsDocument, options);
        }
export type SignalActionSetCommandOptionsQueryHookResult = ReturnType<typeof useSignalActionSetCommandOptionsQuery>;
export type SignalActionSetCommandOptionsLazyQueryHookResult = ReturnType<typeof useSignalActionSetCommandOptionsLazyQuery>;
export type SignalActionSetCommandOptionsQueryResult = Apollo.QueryResult<SignalActionSetCommandOptionsQuery, SignalActionSetCommandOptionsQueryVariables>;
export function refetchSignalActionSetCommandOptionsQuery(variables?: SignalActionSetCommandOptionsQueryVariables) {
      return { query: SignalActionSetCommandOptionsDocument, variables: variables }
    }
export const SignalActionSetOptionsDocument = gql`
    query SignalActionSetOptions {
  signalActionSetOptions {
    label
    value
  }
}
    `;

/**
 * __useSignalActionSetOptionsQuery__
 *
 * To run a query within a React component, call `useSignalActionSetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalActionSetOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalActionSetOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignalActionSetOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SignalActionSetOptionsQuery, SignalActionSetOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalActionSetOptionsQuery, SignalActionSetOptionsQueryVariables>(SignalActionSetOptionsDocument, options);
      }
export function useSignalActionSetOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalActionSetOptionsQuery, SignalActionSetOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalActionSetOptionsQuery, SignalActionSetOptionsQueryVariables>(SignalActionSetOptionsDocument, options);
        }
export type SignalActionSetOptionsQueryHookResult = ReturnType<typeof useSignalActionSetOptionsQuery>;
export type SignalActionSetOptionsLazyQueryHookResult = ReturnType<typeof useSignalActionSetOptionsLazyQuery>;
export type SignalActionSetOptionsQueryResult = Apollo.QueryResult<SignalActionSetOptionsQuery, SignalActionSetOptionsQueryVariables>;
export function refetchSignalActionSetOptionsQuery(variables?: SignalActionSetOptionsQueryVariables) {
      return { query: SignalActionSetOptionsDocument, variables: variables }
    }
export const IntersectionLocationsDocument = gql`
    query IntersectionLocations($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 1000, $before: String, $after: String) {
  intersections(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        id
        location
        details {
          name
          mainStreet
          sideStreet
          note
          labels
        }
      }
      __typename
    }
  }
}
    `;

/**
 * __useIntersectionLocationsQuery__
 *
 * To run a query within a React component, call `useIntersectionLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntersectionLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntersectionLocationsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useIntersectionLocationsQuery(baseOptions?: Apollo.QueryHookOptions<IntersectionLocationsQuery, IntersectionLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntersectionLocationsQuery, IntersectionLocationsQueryVariables>(IntersectionLocationsDocument, options);
      }
export function useIntersectionLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntersectionLocationsQuery, IntersectionLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntersectionLocationsQuery, IntersectionLocationsQueryVariables>(IntersectionLocationsDocument, options);
        }
export type IntersectionLocationsQueryHookResult = ReturnType<typeof useIntersectionLocationsQuery>;
export type IntersectionLocationsLazyQueryHookResult = ReturnType<typeof useIntersectionLocationsLazyQuery>;
export type IntersectionLocationsQueryResult = Apollo.QueryResult<IntersectionLocationsQuery, IntersectionLocationsQueryVariables>;
export function refetchIntersectionLocationsQuery(variables?: IntersectionLocationsQueryVariables) {
      return { query: IntersectionLocationsDocument, variables: variables }
    }
export const GetDeviceViewsProtocolsFromEntitiesDocument = gql`
    query GetDeviceViewsProtocolsFromEntities($entityIds: [String!]!) {
  getDeviceViewsProtocolsFromEntities(entityIds: $entityIds)
}
    `;

/**
 * __useGetDeviceViewsProtocolsFromEntitiesQuery__
 *
 * To run a query within a React component, call `useGetDeviceViewsProtocolsFromEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceViewsProtocolsFromEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceViewsProtocolsFromEntitiesQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetDeviceViewsProtocolsFromEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceViewsProtocolsFromEntitiesQuery, GetDeviceViewsProtocolsFromEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceViewsProtocolsFromEntitiesQuery, GetDeviceViewsProtocolsFromEntitiesQueryVariables>(GetDeviceViewsProtocolsFromEntitiesDocument, options);
      }
export function useGetDeviceViewsProtocolsFromEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceViewsProtocolsFromEntitiesQuery, GetDeviceViewsProtocolsFromEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceViewsProtocolsFromEntitiesQuery, GetDeviceViewsProtocolsFromEntitiesQueryVariables>(GetDeviceViewsProtocolsFromEntitiesDocument, options);
        }
export type GetDeviceViewsProtocolsFromEntitiesQueryHookResult = ReturnType<typeof useGetDeviceViewsProtocolsFromEntitiesQuery>;
export type GetDeviceViewsProtocolsFromEntitiesLazyQueryHookResult = ReturnType<typeof useGetDeviceViewsProtocolsFromEntitiesLazyQuery>;
export type GetDeviceViewsProtocolsFromEntitiesQueryResult = Apollo.QueryResult<GetDeviceViewsProtocolsFromEntitiesQuery, GetDeviceViewsProtocolsFromEntitiesQueryVariables>;
export function refetchGetDeviceViewsProtocolsFromEntitiesQuery(variables: GetDeviceViewsProtocolsFromEntitiesQueryVariables) {
      return { query: GetDeviceViewsProtocolsFromEntitiesDocument, variables: variables }
    }
export const GetIntersectionCountFromEntitiesDocument = gql`
    query GetIntersectionCountFromEntities($entityIds: [String!]!) {
  getIntersectionCountFromEntities(entityIds: $entityIds)
}
    `;

/**
 * __useGetIntersectionCountFromEntitiesQuery__
 *
 * To run a query within a React component, call `useGetIntersectionCountFromEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntersectionCountFromEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntersectionCountFromEntitiesQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetIntersectionCountFromEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GetIntersectionCountFromEntitiesQuery, GetIntersectionCountFromEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntersectionCountFromEntitiesQuery, GetIntersectionCountFromEntitiesQueryVariables>(GetIntersectionCountFromEntitiesDocument, options);
      }
export function useGetIntersectionCountFromEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntersectionCountFromEntitiesQuery, GetIntersectionCountFromEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntersectionCountFromEntitiesQuery, GetIntersectionCountFromEntitiesQueryVariables>(GetIntersectionCountFromEntitiesDocument, options);
        }
export type GetIntersectionCountFromEntitiesQueryHookResult = ReturnType<typeof useGetIntersectionCountFromEntitiesQuery>;
export type GetIntersectionCountFromEntitiesLazyQueryHookResult = ReturnType<typeof useGetIntersectionCountFromEntitiesLazyQuery>;
export type GetIntersectionCountFromEntitiesQueryResult = Apollo.QueryResult<GetIntersectionCountFromEntitiesQuery, GetIntersectionCountFromEntitiesQueryVariables>;
export function refetchGetIntersectionCountFromEntitiesQuery(variables: GetIntersectionCountFromEntitiesQueryVariables) {
      return { query: GetIntersectionCountFromEntitiesDocument, variables: variables }
    }
export const ExportSplitMonitorReportDocument = gql`
    mutation ExportSplitMonitorReport($intersectionId: String!, $startDateTime: DateTime!, $endDateTime: DateTime!, $fileName: String!, $timezone: String, $reportType: QFreeSplitMonitorReportType!) {
  splitMonitorExport(
    intersectionId: $intersectionId
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    fileName: $fileName
    timezone: $timezone
    reportType: $reportType
  )
}
    `;
export type ExportSplitMonitorReportMutationFn = Apollo.MutationFunction<ExportSplitMonitorReportMutation, ExportSplitMonitorReportMutationVariables>;

/**
 * __useExportSplitMonitorReportMutation__
 *
 * To run a mutation, you first call `useExportSplitMonitorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSplitMonitorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSplitMonitorReportMutation, { data, loading, error }] = useExportSplitMonitorReportMutation({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      fileName: // value for 'fileName'
 *      timezone: // value for 'timezone'
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function useExportSplitMonitorReportMutation(baseOptions?: Apollo.MutationHookOptions<ExportSplitMonitorReportMutation, ExportSplitMonitorReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSplitMonitorReportMutation, ExportSplitMonitorReportMutationVariables>(ExportSplitMonitorReportDocument, options);
      }
export type ExportSplitMonitorReportMutationHookResult = ReturnType<typeof useExportSplitMonitorReportMutation>;
export type ExportSplitMonitorReportMutationResult = Apollo.MutationResult<ExportSplitMonitorReportMutation>;
export type ExportSplitMonitorReportMutationOptions = Apollo.BaseMutationOptions<ExportSplitMonitorReportMutation, ExportSplitMonitorReportMutationVariables>;
export const SignalTasksDocument = gql`
    query SignalTasks($filters: [FilterInput!], $limit: Int = 10) {
  signalTasks(filters: $filters, limit: $limit) {
    edges {
      node {
        id
        intersectionId
        name
        description
        progress
        status
        associatedId
        error
        updated
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSignalTasksQuery__
 *
 * To run a query within a React component, call `useSignalTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSignalTasksQuery(baseOptions?: Apollo.QueryHookOptions<SignalTasksQuery, SignalTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalTasksQuery, SignalTasksQueryVariables>(SignalTasksDocument, options);
      }
export function useSignalTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalTasksQuery, SignalTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalTasksQuery, SignalTasksQueryVariables>(SignalTasksDocument, options);
        }
export type SignalTasksQueryHookResult = ReturnType<typeof useSignalTasksQuery>;
export type SignalTasksLazyQueryHookResult = ReturnType<typeof useSignalTasksLazyQuery>;
export type SignalTasksQueryResult = Apollo.QueryResult<SignalTasksQuery, SignalTasksQueryVariables>;
export function refetchSignalTasksQuery(variables?: SignalTasksQueryVariables) {
      return { query: SignalTasksDocument, variables: variables }
    }
export const SignalTaskUpdatedDocument = gql`
    subscription SignalTaskUpdated($ids: [ID!]!, $intersectionIds: [String!]!) {
  signalTaskUpdated(ids: $ids, intersectionIds: $intersectionIds) {
    id
    intersectionId
    name
    description
    progress
    status
    associatedId
    error
    updated
  }
}
    `;

/**
 * __useSignalTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useSignalTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSignalTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalTaskUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      intersectionIds: // value for 'intersectionIds'
 *   },
 * });
 */
export function useSignalTaskUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SignalTaskUpdatedSubscription, SignalTaskUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SignalTaskUpdatedSubscription, SignalTaskUpdatedSubscriptionVariables>(SignalTaskUpdatedDocument, options);
      }
export type SignalTaskUpdatedSubscriptionHookResult = ReturnType<typeof useSignalTaskUpdatedSubscription>;
export type SignalTaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<SignalTaskUpdatedSubscription>;
export const ModuleMapSettingValueDocument = gql`
    query moduleMapSettingValue($key: String!) {
  moduleMapSettingValue(key: $key)
}
    `;

/**
 * __useModuleMapSettingValueQuery__
 *
 * To run a query within a React component, call `useModuleMapSettingValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleMapSettingValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleMapSettingValueQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useModuleMapSettingValueQuery(baseOptions: Apollo.QueryHookOptions<ModuleMapSettingValueQuery, ModuleMapSettingValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModuleMapSettingValueQuery, ModuleMapSettingValueQueryVariables>(ModuleMapSettingValueDocument, options);
      }
export function useModuleMapSettingValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModuleMapSettingValueQuery, ModuleMapSettingValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModuleMapSettingValueQuery, ModuleMapSettingValueQueryVariables>(ModuleMapSettingValueDocument, options);
        }
export type ModuleMapSettingValueQueryHookResult = ReturnType<typeof useModuleMapSettingValueQuery>;
export type ModuleMapSettingValueLazyQueryHookResult = ReturnType<typeof useModuleMapSettingValueLazyQuery>;
export type ModuleMapSettingValueQueryResult = Apollo.QueryResult<ModuleMapSettingValueQuery, ModuleMapSettingValueQueryVariables>;
export function refetchModuleMapSettingValueQuery(variables: ModuleMapSettingValueQueryVariables) {
      return { query: ModuleMapSettingValueDocument, variables: variables }
    }
export const SaveSignalModuleSettingsDocument = gql`
    mutation SaveSignalModuleSettings($settings: JSON!) {
  saveSignalModuleSettings(settings: $settings)
}
    `;
export type SaveSignalModuleSettingsMutationFn = Apollo.MutationFunction<SaveSignalModuleSettingsMutation, SaveSignalModuleSettingsMutationVariables>;

/**
 * __useSaveSignalModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveSignalModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignalModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignalModuleSettingsMutation, { data, loading, error }] = useSaveSignalModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveSignalModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignalModuleSettingsMutation, SaveSignalModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignalModuleSettingsMutation, SaveSignalModuleSettingsMutationVariables>(SaveSignalModuleSettingsDocument, options);
      }
export type SaveSignalModuleSettingsMutationHookResult = ReturnType<typeof useSaveSignalModuleSettingsMutation>;
export type SaveSignalModuleSettingsMutationResult = Apollo.MutationResult<SaveSignalModuleSettingsMutation>;
export type SaveSignalModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveSignalModuleSettingsMutation, SaveSignalModuleSettingsMutationVariables>;
export const SignalModuleSettingsDocument = gql`
    query SignalModuleSettings($formViewName: String!) {
  signalModuleSettings(formViewName: $formViewName) {
    id
    name
    views {
      id
      name
      views {
        ...FormViewFragment
        views {
          ...FormViewFragment
          views {
            ...FormViewFragment
          }
        }
      }
    }
    sections {
      ...ModuleFormSectionFragment
    }
    type
  }
}
    ${FormViewFragmentFragmentDoc}
${ModuleFormSectionFragmentFragmentDoc}`;

/**
 * __useSignalModuleSettingsQuery__
 *
 * To run a query within a React component, call `useSignalModuleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalModuleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalModuleSettingsQuery({
 *   variables: {
 *      formViewName: // value for 'formViewName'
 *   },
 * });
 */
export function useSignalModuleSettingsQuery(baseOptions: Apollo.QueryHookOptions<SignalModuleSettingsQuery, SignalModuleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalModuleSettingsQuery, SignalModuleSettingsQueryVariables>(SignalModuleSettingsDocument, options);
      }
export function useSignalModuleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalModuleSettingsQuery, SignalModuleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalModuleSettingsQuery, SignalModuleSettingsQueryVariables>(SignalModuleSettingsDocument, options);
        }
export type SignalModuleSettingsQueryHookResult = ReturnType<typeof useSignalModuleSettingsQuery>;
export type SignalModuleSettingsLazyQueryHookResult = ReturnType<typeof useSignalModuleSettingsLazyQuery>;
export type SignalModuleSettingsQueryResult = Apollo.QueryResult<SignalModuleSettingsQuery, SignalModuleSettingsQueryVariables>;
export function refetchSignalModuleSettingsQuery(variables: SignalModuleSettingsQueryVariables) {
      return { query: SignalModuleSettingsDocument, variables: variables }
    }
export const GenerateDeviceDatabaseReportExportsDocument = gql`
    mutation generateDeviceDatabaseReportExports($databaseId: String!, $intersectionId: String!, $tableNames: [String!]!, $exportReportTypes: [ExportReportType!]!, $excludeDefaults: Boolean, $excludeZeros: Boolean) {
  generateDeviceDatabaseReportExports(
    databaseId: $databaseId
    intersectionId: $intersectionId
    tableNames: $tableNames
    exportReportTypes: $exportReportTypes
    excludeDefaults: $excludeDefaults
    excludeZeros: $excludeZeros
  )
}
    `;
export type GenerateDeviceDatabaseReportExportsMutationFn = Apollo.MutationFunction<GenerateDeviceDatabaseReportExportsMutation, GenerateDeviceDatabaseReportExportsMutationVariables>;

/**
 * __useGenerateDeviceDatabaseReportExportsMutation__
 *
 * To run a mutation, you first call `useGenerateDeviceDatabaseReportExportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDeviceDatabaseReportExportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDeviceDatabaseReportExportsMutation, { data, loading, error }] = useGenerateDeviceDatabaseReportExportsMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *      tableNames: // value for 'tableNames'
 *      exportReportTypes: // value for 'exportReportTypes'
 *      excludeDefaults: // value for 'excludeDefaults'
 *      excludeZeros: // value for 'excludeZeros'
 *   },
 * });
 */
export function useGenerateDeviceDatabaseReportExportsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDeviceDatabaseReportExportsMutation, GenerateDeviceDatabaseReportExportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDeviceDatabaseReportExportsMutation, GenerateDeviceDatabaseReportExportsMutationVariables>(GenerateDeviceDatabaseReportExportsDocument, options);
      }
export type GenerateDeviceDatabaseReportExportsMutationHookResult = ReturnType<typeof useGenerateDeviceDatabaseReportExportsMutation>;
export type GenerateDeviceDatabaseReportExportsMutationResult = Apollo.MutationResult<GenerateDeviceDatabaseReportExportsMutation>;
export type GenerateDeviceDatabaseReportExportsMutationOptions = Apollo.BaseMutationOptions<GenerateDeviceDatabaseReportExportsMutation, GenerateDeviceDatabaseReportExportsMutationVariables>;
export const GenerateMultiDatabaseReportExportsDocument = gql`
    mutation generateMultiDatabaseReportExports($entityIds: [String!]!, $exportReportTypes: [ExportReportType!]!, $reportProtocolInputs: [DatabaseReportProtocolInput!]!) {
  generateMultiDatabaseReportExports(
    entityIds: $entityIds
    exportReportTypes: $exportReportTypes
    reportProtocolInputs: $reportProtocolInputs
  )
}
    `;
export type GenerateMultiDatabaseReportExportsMutationFn = Apollo.MutationFunction<GenerateMultiDatabaseReportExportsMutation, GenerateMultiDatabaseReportExportsMutationVariables>;

/**
 * __useGenerateMultiDatabaseReportExportsMutation__
 *
 * To run a mutation, you first call `useGenerateMultiDatabaseReportExportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMultiDatabaseReportExportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMultiDatabaseReportExportsMutation, { data, loading, error }] = useGenerateMultiDatabaseReportExportsMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      exportReportTypes: // value for 'exportReportTypes'
 *      reportProtocolInputs: // value for 'reportProtocolInputs'
 *   },
 * });
 */
export function useGenerateMultiDatabaseReportExportsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMultiDatabaseReportExportsMutation, GenerateMultiDatabaseReportExportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMultiDatabaseReportExportsMutation, GenerateMultiDatabaseReportExportsMutationVariables>(GenerateMultiDatabaseReportExportsDocument, options);
      }
export type GenerateMultiDatabaseReportExportsMutationHookResult = ReturnType<typeof useGenerateMultiDatabaseReportExportsMutation>;
export type GenerateMultiDatabaseReportExportsMutationResult = Apollo.MutationResult<GenerateMultiDatabaseReportExportsMutation>;
export type GenerateMultiDatabaseReportExportsMutationOptions = Apollo.BaseMutationOptions<GenerateMultiDatabaseReportExportsMutation, GenerateMultiDatabaseReportExportsMutationVariables>;
export const ExportSingleDatabaseBinDocument = gql`
    mutation exportSingleDatabaseBin($databaseId: String!, $intersectionId: String!) {
  exportSingleDatabaseBin(
    databaseId: $databaseId
    intersectionId: $intersectionId
  )
}
    `;
export type ExportSingleDatabaseBinMutationFn = Apollo.MutationFunction<ExportSingleDatabaseBinMutation, ExportSingleDatabaseBinMutationVariables>;

/**
 * __useExportSingleDatabaseBinMutation__
 *
 * To run a mutation, you first call `useExportSingleDatabaseBinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSingleDatabaseBinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSingleDatabaseBinMutation, { data, loading, error }] = useExportSingleDatabaseBinMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useExportSingleDatabaseBinMutation(baseOptions?: Apollo.MutationHookOptions<ExportSingleDatabaseBinMutation, ExportSingleDatabaseBinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSingleDatabaseBinMutation, ExportSingleDatabaseBinMutationVariables>(ExportSingleDatabaseBinDocument, options);
      }
export type ExportSingleDatabaseBinMutationHookResult = ReturnType<typeof useExportSingleDatabaseBinMutation>;
export type ExportSingleDatabaseBinMutationResult = Apollo.MutationResult<ExportSingleDatabaseBinMutation>;
export type ExportSingleDatabaseBinMutationOptions = Apollo.BaseMutationOptions<ExportSingleDatabaseBinMutation, ExportSingleDatabaseBinMutationVariables>;
export const ExportMultipleDatabaseBinsDocument = gql`
    mutation exportMultipleDatabaseBins($entityIds: [String!]!) {
  exportMultipleDatabaseBins(entityIds: $entityIds)
}
    `;
export type ExportMultipleDatabaseBinsMutationFn = Apollo.MutationFunction<ExportMultipleDatabaseBinsMutation, ExportMultipleDatabaseBinsMutationVariables>;

/**
 * __useExportMultipleDatabaseBinsMutation__
 *
 * To run a mutation, you first call `useExportMultipleDatabaseBinsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMultipleDatabaseBinsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMultipleDatabaseBinsMutation, { data, loading, error }] = useExportMultipleDatabaseBinsMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useExportMultipleDatabaseBinsMutation(baseOptions?: Apollo.MutationHookOptions<ExportMultipleDatabaseBinsMutation, ExportMultipleDatabaseBinsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportMultipleDatabaseBinsMutation, ExportMultipleDatabaseBinsMutationVariables>(ExportMultipleDatabaseBinsDocument, options);
      }
export type ExportMultipleDatabaseBinsMutationHookResult = ReturnType<typeof useExportMultipleDatabaseBinsMutation>;
export type ExportMultipleDatabaseBinsMutationResult = Apollo.MutationResult<ExportMultipleDatabaseBinsMutation>;
export type ExportMultipleDatabaseBinsMutationOptions = Apollo.BaseMutationOptions<ExportMultipleDatabaseBinsMutation, ExportMultipleDatabaseBinsMutationVariables>;
export const SignalCommunicationReportDocument = gql`
    query SignalCommunicationReport($after: String, $before: String, $limit: Int = 100, $startDateTime: DateTime!, $endDateTime: DateTime!) {
  signalCommunicationReport(
    after: $after
    before: $before
    limit: $limit
    startDateTime: $startDateTime
    endDateTime: $endDateTime
  ) {
    edges {
      node {
        integrationType
        deviceId
        deviceName
        intersectionId
        intersectionName
        group
        communicationParameters
        communicationState
        latency
        downTime
        requestCount
        failureCount
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useSignalCommunicationReportQuery__
 *
 * To run a query within a React component, call `useSignalCommunicationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalCommunicationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalCommunicationReportQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useSignalCommunicationReportQuery(baseOptions: Apollo.QueryHookOptions<SignalCommunicationReportQuery, SignalCommunicationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalCommunicationReportQuery, SignalCommunicationReportQueryVariables>(SignalCommunicationReportDocument, options);
      }
export function useSignalCommunicationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalCommunicationReportQuery, SignalCommunicationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalCommunicationReportQuery, SignalCommunicationReportQueryVariables>(SignalCommunicationReportDocument, options);
        }
export type SignalCommunicationReportQueryHookResult = ReturnType<typeof useSignalCommunicationReportQuery>;
export type SignalCommunicationReportLazyQueryHookResult = ReturnType<typeof useSignalCommunicationReportLazyQuery>;
export type SignalCommunicationReportQueryResult = Apollo.QueryResult<SignalCommunicationReportQuery, SignalCommunicationReportQueryVariables>;
export function refetchSignalCommunicationReportQuery(variables: SignalCommunicationReportQueryVariables) {
      return { query: SignalCommunicationReportDocument, variables: variables }
    }
export const GetIntersectionDeviceProtocolDocument = gql`
    query GetIntersectionDeviceProtocol($intersectionId: ID!) {
  intersection(id: $intersectionId) {
    id
    devices {
      id
      fieldEntityProtocol
    }
  }
}
    `;

/**
 * __useGetIntersectionDeviceProtocolQuery__
 *
 * To run a query within a React component, call `useGetIntersectionDeviceProtocolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntersectionDeviceProtocolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntersectionDeviceProtocolQuery({
 *   variables: {
 *      intersectionId: // value for 'intersectionId'
 *   },
 * });
 */
export function useGetIntersectionDeviceProtocolQuery(baseOptions: Apollo.QueryHookOptions<GetIntersectionDeviceProtocolQuery, GetIntersectionDeviceProtocolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntersectionDeviceProtocolQuery, GetIntersectionDeviceProtocolQueryVariables>(GetIntersectionDeviceProtocolDocument, options);
      }
export function useGetIntersectionDeviceProtocolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntersectionDeviceProtocolQuery, GetIntersectionDeviceProtocolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntersectionDeviceProtocolQuery, GetIntersectionDeviceProtocolQueryVariables>(GetIntersectionDeviceProtocolDocument, options);
        }
export type GetIntersectionDeviceProtocolQueryHookResult = ReturnType<typeof useGetIntersectionDeviceProtocolQuery>;
export type GetIntersectionDeviceProtocolLazyQueryHookResult = ReturnType<typeof useGetIntersectionDeviceProtocolLazyQuery>;
export type GetIntersectionDeviceProtocolQueryResult = Apollo.QueryResult<GetIntersectionDeviceProtocolQuery, GetIntersectionDeviceProtocolQueryVariables>;
export function refetchGetIntersectionDeviceProtocolQuery(variables: GetIntersectionDeviceProtocolQueryVariables) {
      return { query: GetIntersectionDeviceProtocolDocument, variables: variables }
    }
export const SaveTimeDriftSettingsDocument = gql`
    mutation SaveTimeDriftSettings($input: TimeDriftSettingsInput!) {
  saveTimeDriftSettings(input: $input) {
    autoCorrect
    correctionThreshold
    alarmThreshold
    exceptions {
      start
      end
    }
  }
}
    `;
export type SaveTimeDriftSettingsMutationFn = Apollo.MutationFunction<SaveTimeDriftSettingsMutation, SaveTimeDriftSettingsMutationVariables>;

/**
 * __useSaveTimeDriftSettingsMutation__
 *
 * To run a mutation, you first call `useSaveTimeDriftSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTimeDriftSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTimeDriftSettingsMutation, { data, loading, error }] = useSaveTimeDriftSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTimeDriftSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveTimeDriftSettingsMutation, SaveTimeDriftSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTimeDriftSettingsMutation, SaveTimeDriftSettingsMutationVariables>(SaveTimeDriftSettingsDocument, options);
      }
export type SaveTimeDriftSettingsMutationHookResult = ReturnType<typeof useSaveTimeDriftSettingsMutation>;
export type SaveTimeDriftSettingsMutationResult = Apollo.MutationResult<SaveTimeDriftSettingsMutation>;
export type SaveTimeDriftSettingsMutationOptions = Apollo.BaseMutationOptions<SaveTimeDriftSettingsMutation, SaveTimeDriftSettingsMutationVariables>;
export const TimeDriftSettingsDocument = gql`
    query TimeDriftSettings {
  timeDriftSettings {
    autoCorrect
    correctionThreshold
    alarmThreshold
    exceptions {
      start
      end
    }
  }
}
    `;

/**
 * __useTimeDriftSettingsQuery__
 *
 * To run a query within a React component, call `useTimeDriftSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeDriftSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeDriftSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimeDriftSettingsQuery(baseOptions?: Apollo.QueryHookOptions<TimeDriftSettingsQuery, TimeDriftSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeDriftSettingsQuery, TimeDriftSettingsQueryVariables>(TimeDriftSettingsDocument, options);
      }
export function useTimeDriftSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeDriftSettingsQuery, TimeDriftSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeDriftSettingsQuery, TimeDriftSettingsQueryVariables>(TimeDriftSettingsDocument, options);
        }
export type TimeDriftSettingsQueryHookResult = ReturnType<typeof useTimeDriftSettingsQuery>;
export type TimeDriftSettingsLazyQueryHookResult = ReturnType<typeof useTimeDriftSettingsLazyQuery>;
export type TimeDriftSettingsQueryResult = Apollo.QueryResult<TimeDriftSettingsQuery, TimeDriftSettingsQueryVariables>;
export function refetchTimeDriftSettingsQuery(variables?: TimeDriftSettingsQueryVariables) {
      return { query: TimeDriftSettingsDocument, variables: variables }
    }
export const GetTimeSpaceDataDocument = gql`
    query GetTimeSpaceData($corridorId: ID!, $from: DateTime!, $to: DateTime!) {
  timeSpaceData(corridorId: $corridorId, from: $from, to: $to) {
    id
    name
    deviceId
    upPhase {
      ...timeSpacePhaseFragment
    }
    downPhase {
      ...timeSpacePhaseFragment
    }
    pattern {
      ...timeSpacePatternFragment
    }
    travelUp {
      ...travelDirectionDataFragment
    }
    travelDown {
      ...travelDirectionDataFragment
    }
  }
}
    ${TimeSpacePhaseFragmentFragmentDoc}
${TimeSpacePatternFragmentFragmentDoc}
${TravelDirectionDataFragmentFragmentDoc}`;

/**
 * __useGetTimeSpaceDataQuery__
 *
 * To run a query within a React component, call `useGetTimeSpaceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeSpaceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeSpaceDataQuery({
 *   variables: {
 *      corridorId: // value for 'corridorId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetTimeSpaceDataQuery(baseOptions: Apollo.QueryHookOptions<GetTimeSpaceDataQuery, GetTimeSpaceDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeSpaceDataQuery, GetTimeSpaceDataQueryVariables>(GetTimeSpaceDataDocument, options);
      }
export function useGetTimeSpaceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeSpaceDataQuery, GetTimeSpaceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeSpaceDataQuery, GetTimeSpaceDataQueryVariables>(GetTimeSpaceDataDocument, options);
        }
export type GetTimeSpaceDataQueryHookResult = ReturnType<typeof useGetTimeSpaceDataQuery>;
export type GetTimeSpaceDataLazyQueryHookResult = ReturnType<typeof useGetTimeSpaceDataLazyQuery>;
export type GetTimeSpaceDataQueryResult = Apollo.QueryResult<GetTimeSpaceDataQuery, GetTimeSpaceDataQueryVariables>;
export function refetchGetTimeSpaceDataQuery(variables: GetTimeSpaceDataQueryVariables) {
      return { query: GetTimeSpaceDataDocument, variables: variables }
    }
export const TrafficResponsiveControlLogListDocument = gql`
    query TrafficResponsiveControlLogList($trafficResponsivePlanId: ID!, $after: String, $before: String, $limit: Int, $sortField: String, $sortOrder: SortOrder, $filters: [FilterInput]) {
  trafficResponsiveActionControlLogs(
    trafficResponsivePlanId: $trafficResponsivePlanId
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
  ) {
    edges {
      node {
        id
        timestamp
        actionName
        commandDescription
        referenceValue
        selected
        devices {
          id
          intersection {
            id
            name
            devices {
              id
              name
            }
          }
          firstCommandSent
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTrafficResponsiveControlLogListQuery__
 *
 * To run a query within a React component, call `useTrafficResponsiveControlLogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficResponsiveControlLogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficResponsiveControlLogListQuery({
 *   variables: {
 *      trafficResponsivePlanId: // value for 'trafficResponsivePlanId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTrafficResponsiveControlLogListQuery(baseOptions: Apollo.QueryHookOptions<TrafficResponsiveControlLogListQuery, TrafficResponsiveControlLogListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficResponsiveControlLogListQuery, TrafficResponsiveControlLogListQueryVariables>(TrafficResponsiveControlLogListDocument, options);
      }
export function useTrafficResponsiveControlLogListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficResponsiveControlLogListQuery, TrafficResponsiveControlLogListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficResponsiveControlLogListQuery, TrafficResponsiveControlLogListQueryVariables>(TrafficResponsiveControlLogListDocument, options);
        }
export type TrafficResponsiveControlLogListQueryHookResult = ReturnType<typeof useTrafficResponsiveControlLogListQuery>;
export type TrafficResponsiveControlLogListLazyQueryHookResult = ReturnType<typeof useTrafficResponsiveControlLogListLazyQuery>;
export type TrafficResponsiveControlLogListQueryResult = Apollo.QueryResult<TrafficResponsiveControlLogListQuery, TrafficResponsiveControlLogListQueryVariables>;
export function refetchTrafficResponsiveControlLogListQuery(variables: TrafficResponsiveControlLogListQueryVariables) {
      return { query: TrafficResponsiveControlLogListDocument, variables: variables }
    }
export const TrafficResponsivePlanActionsDocument = gql`
    query TrafficResponsivePlanActions($id: ID!) {
  trafficResponsivePlanSummary(id: $id) {
    id
    actions {
      id
      name
    }
  }
}
    `;

/**
 * __useTrafficResponsivePlanActionsQuery__
 *
 * To run a query within a React component, call `useTrafficResponsivePlanActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficResponsivePlanActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficResponsivePlanActionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrafficResponsivePlanActionsQuery(baseOptions: Apollo.QueryHookOptions<TrafficResponsivePlanActionsQuery, TrafficResponsivePlanActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficResponsivePlanActionsQuery, TrafficResponsivePlanActionsQueryVariables>(TrafficResponsivePlanActionsDocument, options);
      }
export function useTrafficResponsivePlanActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficResponsivePlanActionsQuery, TrafficResponsivePlanActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficResponsivePlanActionsQuery, TrafficResponsivePlanActionsQueryVariables>(TrafficResponsivePlanActionsDocument, options);
        }
export type TrafficResponsivePlanActionsQueryHookResult = ReturnType<typeof useTrafficResponsivePlanActionsQuery>;
export type TrafficResponsivePlanActionsLazyQueryHookResult = ReturnType<typeof useTrafficResponsivePlanActionsLazyQuery>;
export type TrafficResponsivePlanActionsQueryResult = Apollo.QueryResult<TrafficResponsivePlanActionsQuery, TrafficResponsivePlanActionsQueryVariables>;
export function refetchTrafficResponsivePlanActionsQuery(variables: TrafficResponsivePlanActionsQueryVariables) {
      return { query: TrafficResponsivePlanActionsDocument, variables: variables }
    }
export const SaveTrafficResponsivePlanDocument = gql`
    mutation SaveTrafficResponsivePlan($input: TrafficResponsivePlanInput!) {
  saveTrafficResponsivePlan(input: $input) {
    id
  }
}
    `;
export type SaveTrafficResponsivePlanMutationFn = Apollo.MutationFunction<SaveTrafficResponsivePlanMutation, SaveTrafficResponsivePlanMutationVariables>;

/**
 * __useSaveTrafficResponsivePlanMutation__
 *
 * To run a mutation, you first call `useSaveTrafficResponsivePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTrafficResponsivePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTrafficResponsivePlanMutation, { data, loading, error }] = useSaveTrafficResponsivePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTrafficResponsivePlanMutation(baseOptions?: Apollo.MutationHookOptions<SaveTrafficResponsivePlanMutation, SaveTrafficResponsivePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTrafficResponsivePlanMutation, SaveTrafficResponsivePlanMutationVariables>(SaveTrafficResponsivePlanDocument, options);
      }
export type SaveTrafficResponsivePlanMutationHookResult = ReturnType<typeof useSaveTrafficResponsivePlanMutation>;
export type SaveTrafficResponsivePlanMutationResult = Apollo.MutationResult<SaveTrafficResponsivePlanMutation>;
export type SaveTrafficResponsivePlanMutationOptions = Apollo.BaseMutationOptions<SaveTrafficResponsivePlanMutation, SaveTrafficResponsivePlanMutationVariables>;
export const DeleteTrafficResponsivePlanDocument = gql`
    mutation DeleteTrafficResponsivePlan($id: ID!) {
  deleteTrafficResponsivePlan(id: $id)
}
    `;
export type DeleteTrafficResponsivePlanMutationFn = Apollo.MutationFunction<DeleteTrafficResponsivePlanMutation, DeleteTrafficResponsivePlanMutationVariables>;

/**
 * __useDeleteTrafficResponsivePlanMutation__
 *
 * To run a mutation, you first call `useDeleteTrafficResponsivePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrafficResponsivePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrafficResponsivePlanMutation, { data, loading, error }] = useDeleteTrafficResponsivePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrafficResponsivePlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrafficResponsivePlanMutation, DeleteTrafficResponsivePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrafficResponsivePlanMutation, DeleteTrafficResponsivePlanMutationVariables>(DeleteTrafficResponsivePlanDocument, options);
      }
export type DeleteTrafficResponsivePlanMutationHookResult = ReturnType<typeof useDeleteTrafficResponsivePlanMutation>;
export type DeleteTrafficResponsivePlanMutationResult = Apollo.MutationResult<DeleteTrafficResponsivePlanMutation>;
export type DeleteTrafficResponsivePlanMutationOptions = Apollo.BaseMutationOptions<DeleteTrafficResponsivePlanMutation, DeleteTrafficResponsivePlanMutationVariables>;
export const TrafficResponsivePlansDocument = gql`
    query trafficResponsivePlans($sortOrder: SortOrder, $sortField: String, $filters: [FilterInput], $searchText: String, $limit: Int, $before: String, $after: String) {
  trafficResponsivePlans(
    sortOrder: $sortOrder
    sortField: $sortField
    filters: $filters
    searchText: $searchText
    limit: $limit
    before: $before
    after: $after
  ) {
    edges {
      node {
        ...TrafficResponsivePlanFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${TrafficResponsivePlanFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useTrafficResponsivePlansQuery__
 *
 * To run a query within a React component, call `useTrafficResponsivePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficResponsivePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficResponsivePlansQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTrafficResponsivePlansQuery(baseOptions?: Apollo.QueryHookOptions<TrafficResponsivePlansQuery, TrafficResponsivePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficResponsivePlansQuery, TrafficResponsivePlansQueryVariables>(TrafficResponsivePlansDocument, options);
      }
export function useTrafficResponsivePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficResponsivePlansQuery, TrafficResponsivePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficResponsivePlansQuery, TrafficResponsivePlansQueryVariables>(TrafficResponsivePlansDocument, options);
        }
export type TrafficResponsivePlansQueryHookResult = ReturnType<typeof useTrafficResponsivePlansQuery>;
export type TrafficResponsivePlansLazyQueryHookResult = ReturnType<typeof useTrafficResponsivePlansLazyQuery>;
export type TrafficResponsivePlansQueryResult = Apollo.QueryResult<TrafficResponsivePlansQuery, TrafficResponsivePlansQueryVariables>;
export function refetchTrafficResponsivePlansQuery(variables?: TrafficResponsivePlansQueryVariables) {
      return { query: TrafficResponsivePlansDocument, variables: variables }
    }
export const TrafficResponsivePlanOptionsDocument = gql`
    query TrafficResponsivePlanOptions {
  trafficResponsivePlans(limit: 1000) {
    edges {
      node {
        id
        name
        actions {
          detectorGroups {
            detectorGroupId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTrafficResponsivePlanOptionsQuery__
 *
 * To run a query within a React component, call `useTrafficResponsivePlanOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficResponsivePlanOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficResponsivePlanOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrafficResponsivePlanOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TrafficResponsivePlanOptionsQuery, TrafficResponsivePlanOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficResponsivePlanOptionsQuery, TrafficResponsivePlanOptionsQueryVariables>(TrafficResponsivePlanOptionsDocument, options);
      }
export function useTrafficResponsivePlanOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficResponsivePlanOptionsQuery, TrafficResponsivePlanOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficResponsivePlanOptionsQuery, TrafficResponsivePlanOptionsQueryVariables>(TrafficResponsivePlanOptionsDocument, options);
        }
export type TrafficResponsivePlanOptionsQueryHookResult = ReturnType<typeof useTrafficResponsivePlanOptionsQuery>;
export type TrafficResponsivePlanOptionsLazyQueryHookResult = ReturnType<typeof useTrafficResponsivePlanOptionsLazyQuery>;
export type TrafficResponsivePlanOptionsQueryResult = Apollo.QueryResult<TrafficResponsivePlanOptionsQuery, TrafficResponsivePlanOptionsQueryVariables>;
export function refetchTrafficResponsivePlanOptionsQuery(variables?: TrafficResponsivePlanOptionsQueryVariables) {
      return { query: TrafficResponsivePlanOptionsDocument, variables: variables }
    }
export const TrafficResponsivePlanDetectorGroupsDocument = gql`
    query TrafficResponsivePlanDetectorGroups($ids: Object!) {
  signalDetectorGroups(
    limit: 1000
    filters: [{field: "id", operator: IN, value: $ids}]
  ) {
    edges {
      node {
        id
        detectors {
          intersectionId
        }
      }
    }
  }
}
    `;

/**
 * __useTrafficResponsivePlanDetectorGroupsQuery__
 *
 * To run a query within a React component, call `useTrafficResponsivePlanDetectorGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficResponsivePlanDetectorGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficResponsivePlanDetectorGroupsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTrafficResponsivePlanDetectorGroupsQuery(baseOptions: Apollo.QueryHookOptions<TrafficResponsivePlanDetectorGroupsQuery, TrafficResponsivePlanDetectorGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficResponsivePlanDetectorGroupsQuery, TrafficResponsivePlanDetectorGroupsQueryVariables>(TrafficResponsivePlanDetectorGroupsDocument, options);
      }
export function useTrafficResponsivePlanDetectorGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficResponsivePlanDetectorGroupsQuery, TrafficResponsivePlanDetectorGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficResponsivePlanDetectorGroupsQuery, TrafficResponsivePlanDetectorGroupsQueryVariables>(TrafficResponsivePlanDetectorGroupsDocument, options);
        }
export type TrafficResponsivePlanDetectorGroupsQueryHookResult = ReturnType<typeof useTrafficResponsivePlanDetectorGroupsQuery>;
export type TrafficResponsivePlanDetectorGroupsLazyQueryHookResult = ReturnType<typeof useTrafficResponsivePlanDetectorGroupsLazyQuery>;
export type TrafficResponsivePlanDetectorGroupsQueryResult = Apollo.QueryResult<TrafficResponsivePlanDetectorGroupsQuery, TrafficResponsivePlanDetectorGroupsQueryVariables>;
export function refetchTrafficResponsivePlanDetectorGroupsQuery(variables: TrafficResponsivePlanDetectorGroupsQueryVariables) {
      return { query: TrafficResponsivePlanDetectorGroupsDocument, variables: variables }
    }
export const TrafficResponsivePlanSummaryDocument = gql`
    query TrafficResponsivePlanSummary($id: ID!) {
  trafficResponsivePlanSummary(id: $id) {
    id
    name
    description
    number
    frequency
    actions {
      observedFrom
      observedTo
      selected
      id
      command
      minimumImprovement
      referenceValue
      name
      detectorGroups {
        detectorGroupId
        name
        description
        kValue
        occupancy
        volume
        observedOccupancy
        observedVolume
        observedSpeed
        referenceValue
        detectors {
          detector
          intersection {
            id
            name
            type
          }
          observedOccupancy
          observedVolume
          weight
        }
      }
    }
  }
}
    `;

/**
 * __useTrafficResponsivePlanSummaryQuery__
 *
 * To run a query within a React component, call `useTrafficResponsivePlanSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficResponsivePlanSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficResponsivePlanSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrafficResponsivePlanSummaryQuery(baseOptions: Apollo.QueryHookOptions<TrafficResponsivePlanSummaryQuery, TrafficResponsivePlanSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficResponsivePlanSummaryQuery, TrafficResponsivePlanSummaryQueryVariables>(TrafficResponsivePlanSummaryDocument, options);
      }
export function useTrafficResponsivePlanSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficResponsivePlanSummaryQuery, TrafficResponsivePlanSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficResponsivePlanSummaryQuery, TrafficResponsivePlanSummaryQueryVariables>(TrafficResponsivePlanSummaryDocument, options);
        }
export type TrafficResponsivePlanSummaryQueryHookResult = ReturnType<typeof useTrafficResponsivePlanSummaryQuery>;
export type TrafficResponsivePlanSummaryLazyQueryHookResult = ReturnType<typeof useTrafficResponsivePlanSummaryLazyQuery>;
export type TrafficResponsivePlanSummaryQueryResult = Apollo.QueryResult<TrafficResponsivePlanSummaryQuery, TrafficResponsivePlanSummaryQueryVariables>;
export function refetchTrafficResponsivePlanSummaryQuery(variables: TrafficResponsivePlanSummaryQueryVariables) {
      return { query: TrafficResponsivePlanSummaryDocument, variables: variables }
    }
export const TrafficResponsiveActionReportDocument = gql`
    query TrafficResponsiveActionReport($trafficResponsivePlanId: ID!, $startDateTime: DateTime!, $endDateTime: DateTime!) {
  trafficResponsiveActionReport(
    trafficResponsivePlanId: $trafficResponsivePlanId
    startDateTime: $startDateTime
    endDateTime: $endDateTime
  ) {
    title
    xAxis {
      title
      type
      min
      max
      series
    }
    yAxis {
      title
      type
      min
      max
      series
    }
    overlay {
      x1
      x2
      type
      label
      color
      opacity
    }
    checkPoints {
      type
      color
      legend
      dataPoints
    }
    data {
      name
      legend
      type
      color
      shape
      dataPoints {
        x
        y
      }
    }
  }
}
    `;

/**
 * __useTrafficResponsiveActionReportQuery__
 *
 * To run a query within a React component, call `useTrafficResponsiveActionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficResponsiveActionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficResponsiveActionReportQuery({
 *   variables: {
 *      trafficResponsivePlanId: // value for 'trafficResponsivePlanId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useTrafficResponsiveActionReportQuery(baseOptions: Apollo.QueryHookOptions<TrafficResponsiveActionReportQuery, TrafficResponsiveActionReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficResponsiveActionReportQuery, TrafficResponsiveActionReportQueryVariables>(TrafficResponsiveActionReportDocument, options);
      }
export function useTrafficResponsiveActionReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficResponsiveActionReportQuery, TrafficResponsiveActionReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficResponsiveActionReportQuery, TrafficResponsiveActionReportQueryVariables>(TrafficResponsiveActionReportDocument, options);
        }
export type TrafficResponsiveActionReportQueryHookResult = ReturnType<typeof useTrafficResponsiveActionReportQuery>;
export type TrafficResponsiveActionReportLazyQueryHookResult = ReturnType<typeof useTrafficResponsiveActionReportLazyQuery>;
export type TrafficResponsiveActionReportQueryResult = Apollo.QueryResult<TrafficResponsiveActionReportQuery, TrafficResponsiveActionReportQueryVariables>;
export function refetchTrafficResponsiveActionReportQuery(variables: TrafficResponsiveActionReportQueryVariables) {
      return { query: TrafficResponsiveActionReportDocument, variables: variables }
    }
export const SignAlarmConfigsDocument = gql`
    query SignAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "SIGNS"}, {field: "entityType", operator: EQUALS, value: "SIGN"}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useSignAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useSignAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<SignAlarmConfigsQuery, SignAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignAlarmConfigsQuery, SignAlarmConfigsQueryVariables>(SignAlarmConfigsDocument, options);
      }
export function useSignAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignAlarmConfigsQuery, SignAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignAlarmConfigsQuery, SignAlarmConfigsQueryVariables>(SignAlarmConfigsDocument, options);
        }
export type SignAlarmConfigsQueryHookResult = ReturnType<typeof useSignAlarmConfigsQuery>;
export type SignAlarmConfigsLazyQueryHookResult = ReturnType<typeof useSignAlarmConfigsLazyQuery>;
export type SignAlarmConfigsQueryResult = Apollo.QueryResult<SignAlarmConfigsQuery, SignAlarmConfigsQueryVariables>;
export function refetchSignAlarmConfigsQuery(variables?: SignAlarmConfigsQueryVariables) {
      return { query: SignAlarmConfigsDocument, variables: variables }
    }
export const SignNamesDocument = gql`
    query SignNames {
  signs(limit: 10000) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSignNamesQuery__
 *
 * To run a query within a React component, call `useSignNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignNamesQuery(baseOptions?: Apollo.QueryHookOptions<SignNamesQuery, SignNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignNamesQuery, SignNamesQueryVariables>(SignNamesDocument, options);
      }
export function useSignNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignNamesQuery, SignNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignNamesQuery, SignNamesQueryVariables>(SignNamesDocument, options);
        }
export type SignNamesQueryHookResult = ReturnType<typeof useSignNamesQuery>;
export type SignNamesLazyQueryHookResult = ReturnType<typeof useSignNamesLazyQuery>;
export type SignNamesQueryResult = Apollo.QueryResult<SignNamesQuery, SignNamesQueryVariables>;
export function refetchSignNamesQuery(variables?: SignNamesQueryVariables) {
      return { query: SignNamesDocument, variables: variables }
    }
export const SetSignDefaultMessageDocument = gql`
    mutation SetSignDefaultMessage($requests: [SignMessageDisplayRequest!]!) {
  signSetDefaultMessage(requests: $requests)
}
    `;
export type SetSignDefaultMessageMutationFn = Apollo.MutationFunction<SetSignDefaultMessageMutation, SetSignDefaultMessageMutationVariables>;

/**
 * __useSetSignDefaultMessageMutation__
 *
 * To run a mutation, you first call `useSetSignDefaultMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSignDefaultMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSignDefaultMessageMutation, { data, loading, error }] = useSetSignDefaultMessageMutation({
 *   variables: {
 *      requests: // value for 'requests'
 *   },
 * });
 */
export function useSetSignDefaultMessageMutation(baseOptions?: Apollo.MutationHookOptions<SetSignDefaultMessageMutation, SetSignDefaultMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSignDefaultMessageMutation, SetSignDefaultMessageMutationVariables>(SetSignDefaultMessageDocument, options);
      }
export type SetSignDefaultMessageMutationHookResult = ReturnType<typeof useSetSignDefaultMessageMutation>;
export type SetSignDefaultMessageMutationResult = Apollo.MutationResult<SetSignDefaultMessageMutation>;
export type SetSignDefaultMessageMutationOptions = Apollo.BaseMutationOptions<SetSignDefaultMessageMutation, SetSignDefaultMessageMutationVariables>;
export const SetSignDefaultMessageEnabledDocument = gql`
    mutation SetSignDefaultMessageEnabled($id: ID!, $enabled: Boolean!) {
  signEnableDisableDefaultMessage(id: $id, enabled: $enabled)
}
    `;
export type SetSignDefaultMessageEnabledMutationFn = Apollo.MutationFunction<SetSignDefaultMessageEnabledMutation, SetSignDefaultMessageEnabledMutationVariables>;

/**
 * __useSetSignDefaultMessageEnabledMutation__
 *
 * To run a mutation, you first call `useSetSignDefaultMessageEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSignDefaultMessageEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSignDefaultMessageEnabledMutation, { data, loading, error }] = useSetSignDefaultMessageEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetSignDefaultMessageEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetSignDefaultMessageEnabledMutation, SetSignDefaultMessageEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSignDefaultMessageEnabledMutation, SetSignDefaultMessageEnabledMutationVariables>(SetSignDefaultMessageEnabledDocument, options);
      }
export type SetSignDefaultMessageEnabledMutationHookResult = ReturnType<typeof useSetSignDefaultMessageEnabledMutation>;
export type SetSignDefaultMessageEnabledMutationResult = Apollo.MutationResult<SetSignDefaultMessageEnabledMutation>;
export type SetSignDefaultMessageEnabledMutationOptions = Apollo.BaseMutationOptions<SetSignDefaultMessageEnabledMutation, SetSignDefaultMessageEnabledMutationVariables>;
export const SaveSignGroupDocument = gql`
    mutation SaveSignGroup($input: SignGroupInput!) {
  signSaveGroup(input: $input) {
    id
  }
}
    `;
export type SaveSignGroupMutationFn = Apollo.MutationFunction<SaveSignGroupMutation, SaveSignGroupMutationVariables>;

/**
 * __useSaveSignGroupMutation__
 *
 * To run a mutation, you first call `useSaveSignGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignGroupMutation, { data, loading, error }] = useSaveSignGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignGroupMutation, SaveSignGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignGroupMutation, SaveSignGroupMutationVariables>(SaveSignGroupDocument, options);
      }
export type SaveSignGroupMutationHookResult = ReturnType<typeof useSaveSignGroupMutation>;
export type SaveSignGroupMutationResult = Apollo.MutationResult<SaveSignGroupMutation>;
export type SaveSignGroupMutationOptions = Apollo.BaseMutationOptions<SaveSignGroupMutation, SaveSignGroupMutationVariables>;
export const DeleteSignGroupDocument = gql`
    mutation DeleteSignGroup($id: ID!) {
  signDeleteGroup(id: $id)
}
    `;
export type DeleteSignGroupMutationFn = Apollo.MutationFunction<DeleteSignGroupMutation, DeleteSignGroupMutationVariables>;

/**
 * __useDeleteSignGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSignGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignGroupMutation, { data, loading, error }] = useDeleteSignGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignGroupMutation, DeleteSignGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignGroupMutation, DeleteSignGroupMutationVariables>(DeleteSignGroupDocument, options);
      }
export type DeleteSignGroupMutationHookResult = ReturnType<typeof useDeleteSignGroupMutation>;
export type DeleteSignGroupMutationResult = Apollo.MutationResult<DeleteSignGroupMutation>;
export type DeleteSignGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSignGroupMutation, DeleteSignGroupMutationVariables>;
export const RequestInterlockOverrideDocument = gql`
    mutation RequestInterlockOverride($input: [SignInterlockInput!]!, $resourcePlanIds: [String!], $resourcePlanNames: [String!]) {
  requestInterlockOverride(
    input: $input
    resourcePlanIds: $resourcePlanIds
    resourcePlanNames: $resourcePlanNames
  ) {
    approved
    rejected
    id
  }
}
    `;
export type RequestInterlockOverrideMutationFn = Apollo.MutationFunction<RequestInterlockOverrideMutation, RequestInterlockOverrideMutationVariables>;

/**
 * __useRequestInterlockOverrideMutation__
 *
 * To run a mutation, you first call `useRequestInterlockOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestInterlockOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestInterlockOverrideMutation, { data, loading, error }] = useRequestInterlockOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *      resourcePlanIds: // value for 'resourcePlanIds'
 *      resourcePlanNames: // value for 'resourcePlanNames'
 *   },
 * });
 */
export function useRequestInterlockOverrideMutation(baseOptions?: Apollo.MutationHookOptions<RequestInterlockOverrideMutation, RequestInterlockOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestInterlockOverrideMutation, RequestInterlockOverrideMutationVariables>(RequestInterlockOverrideDocument, options);
      }
export type RequestInterlockOverrideMutationHookResult = ReturnType<typeof useRequestInterlockOverrideMutation>;
export type RequestInterlockOverrideMutationResult = Apollo.MutationResult<RequestInterlockOverrideMutation>;
export type RequestInterlockOverrideMutationOptions = Apollo.BaseMutationOptions<RequestInterlockOverrideMutation, RequestInterlockOverrideMutationVariables>;
export const CancelInterlockOverrideDocument = gql`
    mutation CancelInterlockOverride($approvalId: ID!) {
  cancelInterlockOverride(approvalId: $approvalId)
}
    `;
export type CancelInterlockOverrideMutationFn = Apollo.MutationFunction<CancelInterlockOverrideMutation, CancelInterlockOverrideMutationVariables>;

/**
 * __useCancelInterlockOverrideMutation__
 *
 * To run a mutation, you first call `useCancelInterlockOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInterlockOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInterlockOverrideMutation, { data, loading, error }] = useCancelInterlockOverrideMutation({
 *   variables: {
 *      approvalId: // value for 'approvalId'
 *   },
 * });
 */
export function useCancelInterlockOverrideMutation(baseOptions?: Apollo.MutationHookOptions<CancelInterlockOverrideMutation, CancelInterlockOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelInterlockOverrideMutation, CancelInterlockOverrideMutationVariables>(CancelInterlockOverrideDocument, options);
      }
export type CancelInterlockOverrideMutationHookResult = ReturnType<typeof useCancelInterlockOverrideMutation>;
export type CancelInterlockOverrideMutationResult = Apollo.MutationResult<CancelInterlockOverrideMutation>;
export type CancelInterlockOverrideMutationOptions = Apollo.BaseMutationOptions<CancelInterlockOverrideMutation, CancelInterlockOverrideMutationVariables>;
export const ApproveInterlockOverrideDocument = gql`
    mutation ApproveInterlockOverride($approvalId: ID!) {
  approveInterlockOverride(approvalId: $approvalId)
}
    `;
export type ApproveInterlockOverrideMutationFn = Apollo.MutationFunction<ApproveInterlockOverrideMutation, ApproveInterlockOverrideMutationVariables>;

/**
 * __useApproveInterlockOverrideMutation__
 *
 * To run a mutation, you first call `useApproveInterlockOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveInterlockOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveInterlockOverrideMutation, { data, loading, error }] = useApproveInterlockOverrideMutation({
 *   variables: {
 *      approvalId: // value for 'approvalId'
 *   },
 * });
 */
export function useApproveInterlockOverrideMutation(baseOptions?: Apollo.MutationHookOptions<ApproveInterlockOverrideMutation, ApproveInterlockOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveInterlockOverrideMutation, ApproveInterlockOverrideMutationVariables>(ApproveInterlockOverrideDocument, options);
      }
export type ApproveInterlockOverrideMutationHookResult = ReturnType<typeof useApproveInterlockOverrideMutation>;
export type ApproveInterlockOverrideMutationResult = Apollo.MutationResult<ApproveInterlockOverrideMutation>;
export type ApproveInterlockOverrideMutationOptions = Apollo.BaseMutationOptions<ApproveInterlockOverrideMutation, ApproveInterlockOverrideMutationVariables>;
export const RejectInterlockOverrideDocument = gql`
    mutation RejectInterlockOverride($approvalId: ID!) {
  rejectInterlockOverride(approvalId: $approvalId)
}
    `;
export type RejectInterlockOverrideMutationFn = Apollo.MutationFunction<RejectInterlockOverrideMutation, RejectInterlockOverrideMutationVariables>;

/**
 * __useRejectInterlockOverrideMutation__
 *
 * To run a mutation, you first call `useRejectInterlockOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectInterlockOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectInterlockOverrideMutation, { data, loading, error }] = useRejectInterlockOverrideMutation({
 *   variables: {
 *      approvalId: // value for 'approvalId'
 *   },
 * });
 */
export function useRejectInterlockOverrideMutation(baseOptions?: Apollo.MutationHookOptions<RejectInterlockOverrideMutation, RejectInterlockOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectInterlockOverrideMutation, RejectInterlockOverrideMutationVariables>(RejectInterlockOverrideDocument, options);
      }
export type RejectInterlockOverrideMutationHookResult = ReturnType<typeof useRejectInterlockOverrideMutation>;
export type RejectInterlockOverrideMutationResult = Apollo.MutationResult<RejectInterlockOverrideMutation>;
export type RejectInterlockOverrideMutationOptions = Apollo.BaseMutationOptions<RejectInterlockOverrideMutation, RejectInterlockOverrideMutationVariables>;
export const InterlockOverrideRequestsDocument = gql`
    query InterlockOverrideRequests($approvalId: ID!) {
  interlockOverrideRequests(approvalId: $approvalId) {
    userDisplayName
    signs {
      id
      message {
        ...SignMessage
      }
    }
    approvalId
    resourcePlanIds
  }
}
    ${SignMessageFragmentDoc}`;

/**
 * __useInterlockOverrideRequestsQuery__
 *
 * To run a query within a React component, call `useInterlockOverrideRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterlockOverrideRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterlockOverrideRequestsQuery({
 *   variables: {
 *      approvalId: // value for 'approvalId'
 *   },
 * });
 */
export function useInterlockOverrideRequestsQuery(baseOptions: Apollo.QueryHookOptions<InterlockOverrideRequestsQuery, InterlockOverrideRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterlockOverrideRequestsQuery, InterlockOverrideRequestsQueryVariables>(InterlockOverrideRequestsDocument, options);
      }
export function useInterlockOverrideRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterlockOverrideRequestsQuery, InterlockOverrideRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterlockOverrideRequestsQuery, InterlockOverrideRequestsQueryVariables>(InterlockOverrideRequestsDocument, options);
        }
export type InterlockOverrideRequestsQueryHookResult = ReturnType<typeof useInterlockOverrideRequestsQuery>;
export type InterlockOverrideRequestsLazyQueryHookResult = ReturnType<typeof useInterlockOverrideRequestsLazyQuery>;
export type InterlockOverrideRequestsQueryResult = Apollo.QueryResult<InterlockOverrideRequestsQuery, InterlockOverrideRequestsQueryVariables>;
export function refetchInterlockOverrideRequestsQuery(variables: InterlockOverrideRequestsQueryVariables) {
      return { query: InterlockOverrideRequestsDocument, variables: variables }
    }
export const InterlockOverrideApprovalUpdatedDocument = gql`
    subscription InterlockOverrideApprovalUpdated($approvalId: ID!) {
  interlockOverrideApprovalUpdated(approvalId: $approvalId) {
    id
    rejected
    approved
  }
}
    `;

/**
 * __useInterlockOverrideApprovalUpdatedSubscription__
 *
 * To run a query within a React component, call `useInterlockOverrideApprovalUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInterlockOverrideApprovalUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterlockOverrideApprovalUpdatedSubscription({
 *   variables: {
 *      approvalId: // value for 'approvalId'
 *   },
 * });
 */
export function useInterlockOverrideApprovalUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<InterlockOverrideApprovalUpdatedSubscription, InterlockOverrideApprovalUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InterlockOverrideApprovalUpdatedSubscription, InterlockOverrideApprovalUpdatedSubscriptionVariables>(InterlockOverrideApprovalUpdatedDocument, options);
      }
export type InterlockOverrideApprovalUpdatedSubscriptionHookResult = ReturnType<typeof useInterlockOverrideApprovalUpdatedSubscription>;
export type InterlockOverrideApprovalUpdatedSubscriptionResult = Apollo.SubscriptionResult<InterlockOverrideApprovalUpdatedSubscription>;
export const SignBlankDocument = gql`
    mutation SignBlank($ids: [ID!]!) {
  signBlank(ids: $ids) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type SignBlankMutationFn = Apollo.MutationFunction<SignBlankMutation, SignBlankMutationVariables>;

/**
 * __useSignBlankMutation__
 *
 * To run a mutation, you first call `useSignBlankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignBlankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signBlankMutation, { data, loading, error }] = useSignBlankMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSignBlankMutation(baseOptions?: Apollo.MutationHookOptions<SignBlankMutation, SignBlankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignBlankMutation, SignBlankMutationVariables>(SignBlankDocument, options);
      }
export type SignBlankMutationHookResult = ReturnType<typeof useSignBlankMutation>;
export type SignBlankMutationResult = Apollo.MutationResult<SignBlankMutation>;
export type SignBlankMutationOptions = Apollo.BaseMutationOptions<SignBlankMutation, SignBlankMutationVariables>;
export const SignPollDocument = gql`
    mutation SignPoll($ids: [ID!]!) {
  signPoll(ids: $ids) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type SignPollMutationFn = Apollo.MutationFunction<SignPollMutation, SignPollMutationVariables>;

/**
 * __useSignPollMutation__
 *
 * To run a mutation, you first call `useSignPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signPollMutation, { data, loading, error }] = useSignPollMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSignPollMutation(baseOptions?: Apollo.MutationHookOptions<SignPollMutation, SignPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignPollMutation, SignPollMutationVariables>(SignPollDocument, options);
      }
export type SignPollMutationHookResult = ReturnType<typeof useSignPollMutation>;
export type SignPollMutationResult = Apollo.MutationResult<SignPollMutation>;
export type SignPollMutationOptions = Apollo.BaseMutationOptions<SignPollMutation, SignPollMutationVariables>;
export const SignFontDownloadDocument = gql`
    mutation SignFontDownload($id: ID!) {
  signFonts(id: $id) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type SignFontDownloadMutationFn = Apollo.MutationFunction<SignFontDownloadMutation, SignFontDownloadMutationVariables>;

/**
 * __useSignFontDownloadMutation__
 *
 * To run a mutation, you first call `useSignFontDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignFontDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signFontDownloadMutation, { data, loading, error }] = useSignFontDownloadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignFontDownloadMutation(baseOptions?: Apollo.MutationHookOptions<SignFontDownloadMutation, SignFontDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignFontDownloadMutation, SignFontDownloadMutationVariables>(SignFontDownloadDocument, options);
      }
export type SignFontDownloadMutationHookResult = ReturnType<typeof useSignFontDownloadMutation>;
export type SignFontDownloadMutationResult = Apollo.MutationResult<SignFontDownloadMutation>;
export type SignFontDownloadMutationOptions = Apollo.BaseMutationOptions<SignFontDownloadMutation, SignFontDownloadMutationVariables>;
export const SignResetDocument = gql`
    mutation SignReset($id: ID!) {
  signReset(id: $id) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type SignResetMutationFn = Apollo.MutationFunction<SignResetMutation, SignResetMutationVariables>;

/**
 * __useSignResetMutation__
 *
 * To run a mutation, you first call `useSignResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signResetMutation, { data, loading, error }] = useSignResetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignResetMutation(baseOptions?: Apollo.MutationHookOptions<SignResetMutation, SignResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignResetMutation, SignResetMutationVariables>(SignResetDocument, options);
      }
export type SignResetMutationHookResult = ReturnType<typeof useSignResetMutation>;
export type SignResetMutationResult = Apollo.MutationResult<SignResetMutation>;
export type SignResetMutationOptions = Apollo.BaseMutationOptions<SignResetMutation, SignResetMutationVariables>;
export const SetDefaultColorDocument = gql`
    mutation SetDefaultColor($id: ID!, $requestId: String, $color: String!, $isBackground: Boolean!) {
  setDefaultColor(
    id: $id
    requestId: $requestId
    color: $color
    isBackground: $isBackground
  )
}
    `;
export type SetDefaultColorMutationFn = Apollo.MutationFunction<SetDefaultColorMutation, SetDefaultColorMutationVariables>;

/**
 * __useSetDefaultColorMutation__
 *
 * To run a mutation, you first call `useSetDefaultColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultColorMutation, { data, loading, error }] = useSetDefaultColorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requestId: // value for 'requestId'
 *      color: // value for 'color'
 *      isBackground: // value for 'isBackground'
 *   },
 * });
 */
export function useSetDefaultColorMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultColorMutation, SetDefaultColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultColorMutation, SetDefaultColorMutationVariables>(SetDefaultColorDocument, options);
      }
export type SetDefaultColorMutationHookResult = ReturnType<typeof useSetDefaultColorMutation>;
export type SetDefaultColorMutationResult = Apollo.MutationResult<SetDefaultColorMutation>;
export type SetDefaultColorMutationOptions = Apollo.BaseMutationOptions<SetDefaultColorMutation, SetDefaultColorMutationVariables>;
export const SignBrightnessDocument = gql`
    mutation SignBrightness($id: ID!, $brightnessMode: SignBrightnessMode!, $brightness: Int) {
  signBrightness(
    id: $id
    brightnessMode: $brightnessMode
    brightness: $brightness
  ) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type SignBrightnessMutationFn = Apollo.MutationFunction<SignBrightnessMutation, SignBrightnessMutationVariables>;

/**
 * __useSignBrightnessMutation__
 *
 * To run a mutation, you first call `useSignBrightnessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignBrightnessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signBrightnessMutation, { data, loading, error }] = useSignBrightnessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brightnessMode: // value for 'brightnessMode'
 *      brightness: // value for 'brightness'
 *   },
 * });
 */
export function useSignBrightnessMutation(baseOptions?: Apollo.MutationHookOptions<SignBrightnessMutation, SignBrightnessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignBrightnessMutation, SignBrightnessMutationVariables>(SignBrightnessDocument, options);
      }
export type SignBrightnessMutationHookResult = ReturnType<typeof useSignBrightnessMutation>;
export type SignBrightnessMutationResult = Apollo.MutationResult<SignBrightnessMutation>;
export type SignBrightnessMutationOptions = Apollo.BaseMutationOptions<SignBrightnessMutation, SignBrightnessMutationVariables>;
export const SignExtendDocument = gql`
    mutation SignExtend($id: ID!, $expirationTime: DateTime!) {
  signExtend(id: $id, expirationTime: $expirationTime) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type SignExtendMutationFn = Apollo.MutationFunction<SignExtendMutation, SignExtendMutationVariables>;

/**
 * __useSignExtendMutation__
 *
 * To run a mutation, you first call `useSignExtendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignExtendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signExtendMutation, { data, loading, error }] = useSignExtendMutation({
 *   variables: {
 *      id: // value for 'id'
 *      expirationTime: // value for 'expirationTime'
 *   },
 * });
 */
export function useSignExtendMutation(baseOptions?: Apollo.MutationHookOptions<SignExtendMutation, SignExtendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignExtendMutation, SignExtendMutationVariables>(SignExtendDocument, options);
      }
export type SignExtendMutationHookResult = ReturnType<typeof useSignExtendMutation>;
export type SignExtendMutationResult = Apollo.MutationResult<SignExtendMutation>;
export type SignExtendMutationOptions = Apollo.BaseMutationOptions<SignExtendMutation, SignExtendMutationVariables>;
export const DeleteSignMessagesDocument = gql`
    mutation DeleteSignMessages($messageIds: [ID!]!) {
  deleteSignMessages(messages: $messageIds)
}
    `;
export type DeleteSignMessagesMutationFn = Apollo.MutationFunction<DeleteSignMessagesMutation, DeleteSignMessagesMutationVariables>;

/**
 * __useDeleteSignMessagesMutation__
 *
 * To run a mutation, you first call `useDeleteSignMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignMessagesMutation, { data, loading, error }] = useDeleteSignMessagesMutation({
 *   variables: {
 *      messageIds: // value for 'messageIds'
 *   },
 * });
 */
export function useDeleteSignMessagesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignMessagesMutation, DeleteSignMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignMessagesMutation, DeleteSignMessagesMutationVariables>(DeleteSignMessagesDocument, options);
      }
export type DeleteSignMessagesMutationHookResult = ReturnType<typeof useDeleteSignMessagesMutation>;
export type DeleteSignMessagesMutationResult = Apollo.MutationResult<DeleteSignMessagesMutation>;
export type DeleteSignMessagesMutationOptions = Apollo.BaseMutationOptions<DeleteSignMessagesMutation, DeleteSignMessagesMutationVariables>;
export const RemoveQueuedMessagesDocument = gql`
    mutation RemoveQueuedMessages($id: ID!, $queuedMessages: [ID!]!) {
  removeQueuedMessages(id: $id, queuedMessages: $queuedMessages) {
    requestId
    success
    failure
    id
  }
}
    `;
export type RemoveQueuedMessagesMutationFn = Apollo.MutationFunction<RemoveQueuedMessagesMutation, RemoveQueuedMessagesMutationVariables>;

/**
 * __useRemoveQueuedMessagesMutation__
 *
 * To run a mutation, you first call `useRemoveQueuedMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQueuedMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQueuedMessagesMutation, { data, loading, error }] = useRemoveQueuedMessagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      queuedMessages: // value for 'queuedMessages'
 *   },
 * });
 */
export function useRemoveQueuedMessagesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQueuedMessagesMutation, RemoveQueuedMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQueuedMessagesMutation, RemoveQueuedMessagesMutationVariables>(RemoveQueuedMessagesDocument, options);
      }
export type RemoveQueuedMessagesMutationHookResult = ReturnType<typeof useRemoveQueuedMessagesMutation>;
export type RemoveQueuedMessagesMutationResult = Apollo.MutationResult<RemoveQueuedMessagesMutation>;
export type RemoveQueuedMessagesMutationOptions = Apollo.BaseMutationOptions<RemoveQueuedMessagesMutation, RemoveQueuedMessagesMutationVariables>;
export const SaveSignModuleSettingsDocument = gql`
    mutation saveSignModuleSettings($settings: JSON!) {
  saveSignModuleSettings(settings: $settings)
}
    `;
export type SaveSignModuleSettingsMutationFn = Apollo.MutationFunction<SaveSignModuleSettingsMutation, SaveSignModuleSettingsMutationVariables>;

/**
 * __useSaveSignModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveSignModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignModuleSettingsMutation, { data, loading, error }] = useSaveSignModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveSignModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignModuleSettingsMutation, SaveSignModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignModuleSettingsMutation, SaveSignModuleSettingsMutationVariables>(SaveSignModuleSettingsDocument, options);
      }
export type SaveSignModuleSettingsMutationHookResult = ReturnType<typeof useSaveSignModuleSettingsMutation>;
export type SaveSignModuleSettingsMutationResult = Apollo.MutationResult<SaveSignModuleSettingsMutation>;
export type SaveSignModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveSignModuleSettingsMutation, SaveSignModuleSettingsMutationVariables>;
export const MultiPostDocument = gql`
    mutation MultiPost($messages: [SignMessageDisplayRequest!]!) {
  signDisplay(requests: $messages) {
    failure
    success
    id
  }
}
    `;
export type MultiPostMutationFn = Apollo.MutationFunction<MultiPostMutation, MultiPostMutationVariables>;

/**
 * __useMultiPostMutation__
 *
 * To run a mutation, you first call `useMultiPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMultiPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [multiPostMutation, { data, loading, error }] = useMultiPostMutation({
 *   variables: {
 *      messages: // value for 'messages'
 *   },
 * });
 */
export function useMultiPostMutation(baseOptions?: Apollo.MutationHookOptions<MultiPostMutation, MultiPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MultiPostMutation, MultiPostMutationVariables>(MultiPostDocument, options);
      }
export type MultiPostMutationHookResult = ReturnType<typeof useMultiPostMutation>;
export type MultiPostMutationResult = Apollo.MutationResult<MultiPostMutation>;
export type MultiPostMutationOptions = Apollo.BaseMutationOptions<MultiPostMutation, MultiPostMutationVariables>;
export const SetSignMessagePreferencesDocument = gql`
    mutation SetSignMessagePreferences($id: ID!, $preference: ID) {
  signSetMessagePreferences(id: $id, preference: $preference)
}
    `;
export type SetSignMessagePreferencesMutationFn = Apollo.MutationFunction<SetSignMessagePreferencesMutation, SetSignMessagePreferencesMutationVariables>;

/**
 * __useSetSignMessagePreferencesMutation__
 *
 * To run a mutation, you first call `useSetSignMessagePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSignMessagePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSignMessagePreferencesMutation, { data, loading, error }] = useSetSignMessagePreferencesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      preference: // value for 'preference'
 *   },
 * });
 */
export function useSetSignMessagePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SetSignMessagePreferencesMutation, SetSignMessagePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSignMessagePreferencesMutation, SetSignMessagePreferencesMutationVariables>(SetSignMessagePreferencesDocument, options);
      }
export type SetSignMessagePreferencesMutationHookResult = ReturnType<typeof useSetSignMessagePreferencesMutation>;
export type SetSignMessagePreferencesMutationResult = Apollo.MutationResult<SetSignMessagePreferencesMutation>;
export type SetSignMessagePreferencesMutationOptions = Apollo.BaseMutationOptions<SetSignMessagePreferencesMutation, SetSignMessagePreferencesMutationVariables>;
export const SignFanTestDocument = gql`
    mutation SignFanTest($id: ID!) {
  signFanTest(id: $id) {
    failure
    success
  }
}
    `;
export type SignFanTestMutationFn = Apollo.MutationFunction<SignFanTestMutation, SignFanTestMutationVariables>;

/**
 * __useSignFanTestMutation__
 *
 * To run a mutation, you first call `useSignFanTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignFanTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signFanTestMutation, { data, loading, error }] = useSignFanTestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignFanTestMutation(baseOptions?: Apollo.MutationHookOptions<SignFanTestMutation, SignFanTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignFanTestMutation, SignFanTestMutationVariables>(SignFanTestDocument, options);
      }
export type SignFanTestMutationHookResult = ReturnType<typeof useSignFanTestMutation>;
export type SignFanTestMutationResult = Apollo.MutationResult<SignFanTestMutation>;
export type SignFanTestMutationOptions = Apollo.BaseMutationOptions<SignFanTestMutation, SignFanTestMutationVariables>;
export const SignPixelTestDocument = gql`
    mutation SignPixelTest($id: ID!) {
  signPixelTest(id: $id) {
    failure
    success
  }
}
    `;
export type SignPixelTestMutationFn = Apollo.MutationFunction<SignPixelTestMutation, SignPixelTestMutationVariables>;

/**
 * __useSignPixelTestMutation__
 *
 * To run a mutation, you first call `useSignPixelTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignPixelTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signPixelTestMutation, { data, loading, error }] = useSignPixelTestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignPixelTestMutation(baseOptions?: Apollo.MutationHookOptions<SignPixelTestMutation, SignPixelTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignPixelTestMutation, SignPixelTestMutationVariables>(SignPixelTestDocument, options);
      }
export type SignPixelTestMutationHookResult = ReturnType<typeof useSignPixelTestMutation>;
export type SignPixelTestMutationResult = Apollo.MutationResult<SignPixelTestMutation>;
export type SignPixelTestMutationOptions = Apollo.BaseMutationOptions<SignPixelTestMutation, SignPixelTestMutationVariables>;
export const SignLampTestDocument = gql`
    mutation SignLampTest($id: ID!) {
  signLampTest(id: $id) {
    failure
    success
  }
}
    `;
export type SignLampTestMutationFn = Apollo.MutationFunction<SignLampTestMutation, SignLampTestMutationVariables>;

/**
 * __useSignLampTestMutation__
 *
 * To run a mutation, you first call `useSignLampTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignLampTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signLampTestMutation, { data, loading, error }] = useSignLampTestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignLampTestMutation(baseOptions?: Apollo.MutationHookOptions<SignLampTestMutation, SignLampTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignLampTestMutation, SignLampTestMutationVariables>(SignLampTestDocument, options);
      }
export type SignLampTestMutationHookResult = ReturnType<typeof useSignLampTestMutation>;
export type SignLampTestMutationResult = Apollo.MutationResult<SignLampTestMutation>;
export type SignLampTestMutationOptions = Apollo.BaseMutationOptions<SignLampTestMutation, SignLampTestMutationVariables>;
export const SignSetSpeedSettingsDocument = gql`
    mutation SignSetSpeedSettings($id: ID!, $settings: SignSpeedSettingsInput!) {
  signSetSpeedSettings(id: $id, settings: $settings)
}
    `;
export type SignSetSpeedSettingsMutationFn = Apollo.MutationFunction<SignSetSpeedSettingsMutation, SignSetSpeedSettingsMutationVariables>;

/**
 * __useSignSetSpeedSettingsMutation__
 *
 * To run a mutation, you first call `useSignSetSpeedSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignSetSpeedSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signSetSpeedSettingsMutation, { data, loading, error }] = useSignSetSpeedSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSignSetSpeedSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SignSetSpeedSettingsMutation, SignSetSpeedSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignSetSpeedSettingsMutation, SignSetSpeedSettingsMutationVariables>(SignSetSpeedSettingsDocument, options);
      }
export type SignSetSpeedSettingsMutationHookResult = ReturnType<typeof useSignSetSpeedSettingsMutation>;
export type SignSetSpeedSettingsMutationResult = Apollo.MutationResult<SignSetSpeedSettingsMutation>;
export type SignSetSpeedSettingsMutationOptions = Apollo.BaseMutationOptions<SignSetSpeedSettingsMutation, SignSetSpeedSettingsMutationVariables>;
export const SignSetDefaultFontDocument = gql`
    mutation SignSetDefaultFont($id: ID!, $hash: ID!) {
  signSetDefaultFont(id: $id, hash: $hash)
}
    `;
export type SignSetDefaultFontMutationFn = Apollo.MutationFunction<SignSetDefaultFontMutation, SignSetDefaultFontMutationVariables>;

/**
 * __useSignSetDefaultFontMutation__
 *
 * To run a mutation, you first call `useSignSetDefaultFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignSetDefaultFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signSetDefaultFontMutation, { data, loading, error }] = useSignSetDefaultFontMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useSignSetDefaultFontMutation(baseOptions?: Apollo.MutationHookOptions<SignSetDefaultFontMutation, SignSetDefaultFontMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignSetDefaultFontMutation, SignSetDefaultFontMutationVariables>(SignSetDefaultFontDocument, options);
      }
export type SignSetDefaultFontMutationHookResult = ReturnType<typeof useSignSetDefaultFontMutation>;
export type SignSetDefaultFontMutationResult = Apollo.MutationResult<SignSetDefaultFontMutation>;
export type SignSetDefaultFontMutationOptions = Apollo.BaseMutationOptions<SignSetDefaultFontMutation, SignSetDefaultFontMutationVariables>;
export const SignDownloadMessageDocument = gql`
    mutation SignDownloadMessage($id: ID!, $slot: Int!) {
  _signDownloadMessage(id: $id, slot: $slot) {
    failure
    success
  }
}
    `;
export type SignDownloadMessageMutationFn = Apollo.MutationFunction<SignDownloadMessageMutation, SignDownloadMessageMutationVariables>;

/**
 * __useSignDownloadMessageMutation__
 *
 * To run a mutation, you first call `useSignDownloadMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignDownloadMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signDownloadMessageMutation, { data, loading, error }] = useSignDownloadMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      slot: // value for 'slot'
 *   },
 * });
 */
export function useSignDownloadMessageMutation(baseOptions?: Apollo.MutationHookOptions<SignDownloadMessageMutation, SignDownloadMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignDownloadMessageMutation, SignDownloadMessageMutationVariables>(SignDownloadMessageDocument, options);
      }
export type SignDownloadMessageMutationHookResult = ReturnType<typeof useSignDownloadMessageMutation>;
export type SignDownloadMessageMutationResult = Apollo.MutationResult<SignDownloadMessageMutation>;
export type SignDownloadMessageMutationOptions = Apollo.BaseMutationOptions<SignDownloadMessageMutation, SignDownloadMessageMutationVariables>;
export const SignDownloadAllMessagesDocument = gql`
    mutation SignDownloadAllMessages($id: ID!) {
  _signDownloadAllMessages(id: $id) {
    failure
    success
  }
}
    `;
export type SignDownloadAllMessagesMutationFn = Apollo.MutationFunction<SignDownloadAllMessagesMutation, SignDownloadAllMessagesMutationVariables>;

/**
 * __useSignDownloadAllMessagesMutation__
 *
 * To run a mutation, you first call `useSignDownloadAllMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignDownloadAllMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signDownloadAllMessagesMutation, { data, loading, error }] = useSignDownloadAllMessagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignDownloadAllMessagesMutation(baseOptions?: Apollo.MutationHookOptions<SignDownloadAllMessagesMutation, SignDownloadAllMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignDownloadAllMessagesMutation, SignDownloadAllMessagesMutationVariables>(SignDownloadAllMessagesDocument, options);
      }
export type SignDownloadAllMessagesMutationHookResult = ReturnType<typeof useSignDownloadAllMessagesMutation>;
export type SignDownloadAllMessagesMutationResult = Apollo.MutationResult<SignDownloadAllMessagesMutation>;
export type SignDownloadAllMessagesMutationOptions = Apollo.BaseMutationOptions<SignDownloadAllMessagesMutation, SignDownloadAllMessagesMutationVariables>;
export const SignDownloadGraphicDocument = gql`
    mutation SignDownloadGraphic($id: ID!, $slot: Int!) {
  _signDownloadGraphic(id: $id, slot: $slot) {
    failure
    success
  }
}
    `;
export type SignDownloadGraphicMutationFn = Apollo.MutationFunction<SignDownloadGraphicMutation, SignDownloadGraphicMutationVariables>;

/**
 * __useSignDownloadGraphicMutation__
 *
 * To run a mutation, you first call `useSignDownloadGraphicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignDownloadGraphicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signDownloadGraphicMutation, { data, loading, error }] = useSignDownloadGraphicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      slot: // value for 'slot'
 *   },
 * });
 */
export function useSignDownloadGraphicMutation(baseOptions?: Apollo.MutationHookOptions<SignDownloadGraphicMutation, SignDownloadGraphicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignDownloadGraphicMutation, SignDownloadGraphicMutationVariables>(SignDownloadGraphicDocument, options);
      }
export type SignDownloadGraphicMutationHookResult = ReturnType<typeof useSignDownloadGraphicMutation>;
export type SignDownloadGraphicMutationResult = Apollo.MutationResult<SignDownloadGraphicMutation>;
export type SignDownloadGraphicMutationOptions = Apollo.BaseMutationOptions<SignDownloadGraphicMutation, SignDownloadGraphicMutationVariables>;
export const SignDownloadAllGraphicsDocument = gql`
    mutation SignDownloadAllGraphics($id: ID!) {
  _signDownloadAllGraphics(id: $id) {
    failure
    success
  }
}
    `;
export type SignDownloadAllGraphicsMutationFn = Apollo.MutationFunction<SignDownloadAllGraphicsMutation, SignDownloadAllGraphicsMutationVariables>;

/**
 * __useSignDownloadAllGraphicsMutation__
 *
 * To run a mutation, you first call `useSignDownloadAllGraphicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignDownloadAllGraphicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signDownloadAllGraphicsMutation, { data, loading, error }] = useSignDownloadAllGraphicsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignDownloadAllGraphicsMutation(baseOptions?: Apollo.MutationHookOptions<SignDownloadAllGraphicsMutation, SignDownloadAllGraphicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignDownloadAllGraphicsMutation, SignDownloadAllGraphicsMutationVariables>(SignDownloadAllGraphicsDocument, options);
      }
export type SignDownloadAllGraphicsMutationHookResult = ReturnType<typeof useSignDownloadAllGraphicsMutation>;
export type SignDownloadAllGraphicsMutationResult = Apollo.MutationResult<SignDownloadAllGraphicsMutation>;
export type SignDownloadAllGraphicsMutationOptions = Apollo.BaseMutationOptions<SignDownloadAllGraphicsMutation, SignDownloadAllGraphicsMutationVariables>;
export const SignUploadGraphicDocument = gql`
    mutation SignUploadGraphic($arguments: SignUploadGraphicArguments!) {
  _signUploadGraphic(arguments: $arguments) {
    success
    failure
    id
  }
}
    `;
export type SignUploadGraphicMutationFn = Apollo.MutationFunction<SignUploadGraphicMutation, SignUploadGraphicMutationVariables>;

/**
 * __useSignUploadGraphicMutation__
 *
 * To run a mutation, you first call `useSignUploadGraphicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUploadGraphicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUploadGraphicMutation, { data, loading, error }] = useSignUploadGraphicMutation({
 *   variables: {
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useSignUploadGraphicMutation(baseOptions?: Apollo.MutationHookOptions<SignUploadGraphicMutation, SignUploadGraphicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUploadGraphicMutation, SignUploadGraphicMutationVariables>(SignUploadGraphicDocument, options);
      }
export type SignUploadGraphicMutationHookResult = ReturnType<typeof useSignUploadGraphicMutation>;
export type SignUploadGraphicMutationResult = Apollo.MutationResult<SignUploadGraphicMutation>;
export type SignUploadGraphicMutationOptions = Apollo.BaseMutationOptions<SignUploadGraphicMutation, SignUploadGraphicMutationVariables>;
export const SignUploadAllGraphicsDocument = gql`
    mutation SignUploadAllGraphics($id: ID!) {
  signUploadAllGraphics(id: $id)
}
    `;
export type SignUploadAllGraphicsMutationFn = Apollo.MutationFunction<SignUploadAllGraphicsMutation, SignUploadAllGraphicsMutationVariables>;

/**
 * __useSignUploadAllGraphicsMutation__
 *
 * To run a mutation, you first call `useSignUploadAllGraphicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUploadAllGraphicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUploadAllGraphicsMutation, { data, loading, error }] = useSignUploadAllGraphicsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignUploadAllGraphicsMutation(baseOptions?: Apollo.MutationHookOptions<SignUploadAllGraphicsMutation, SignUploadAllGraphicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUploadAllGraphicsMutation, SignUploadAllGraphicsMutationVariables>(SignUploadAllGraphicsDocument, options);
      }
export type SignUploadAllGraphicsMutationHookResult = ReturnType<typeof useSignUploadAllGraphicsMutation>;
export type SignUploadAllGraphicsMutationResult = Apollo.MutationResult<SignUploadAllGraphicsMutation>;
export type SignUploadAllGraphicsMutationOptions = Apollo.BaseMutationOptions<SignUploadAllGraphicsMutation, SignUploadAllGraphicsMutationVariables>;
export const SignDeleteGraphicDocument = gql`
    mutation SignDeleteGraphic($slot: Int!, $id: ID!) {
  _signDeleteGraphic(id: $id, slot: $slot) {
    success
    failure
    id
  }
}
    `;
export type SignDeleteGraphicMutationFn = Apollo.MutationFunction<SignDeleteGraphicMutation, SignDeleteGraphicMutationVariables>;

/**
 * __useSignDeleteGraphicMutation__
 *
 * To run a mutation, you first call `useSignDeleteGraphicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignDeleteGraphicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signDeleteGraphicMutation, { data, loading, error }] = useSignDeleteGraphicMutation({
 *   variables: {
 *      slot: // value for 'slot'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignDeleteGraphicMutation(baseOptions?: Apollo.MutationHookOptions<SignDeleteGraphicMutation, SignDeleteGraphicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignDeleteGraphicMutation, SignDeleteGraphicMutationVariables>(SignDeleteGraphicDocument, options);
      }
export type SignDeleteGraphicMutationHookResult = ReturnType<typeof useSignDeleteGraphicMutation>;
export type SignDeleteGraphicMutationResult = Apollo.MutationResult<SignDeleteGraphicMutation>;
export type SignDeleteGraphicMutationOptions = Apollo.BaseMutationOptions<SignDeleteGraphicMutation, SignDeleteGraphicMutationVariables>;
export const SignDeleteMessageDocument = gql`
    mutation SignDeleteMessage($slot: Int!, $id: ID!) {
  signDeleteCommand(id: $id, slot: $slot) {
    success
    failure
    id
  }
}
    `;
export type SignDeleteMessageMutationFn = Apollo.MutationFunction<SignDeleteMessageMutation, SignDeleteMessageMutationVariables>;

/**
 * __useSignDeleteMessageMutation__
 *
 * To run a mutation, you first call `useSignDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signDeleteMessageMutation, { data, loading, error }] = useSignDeleteMessageMutation({
 *   variables: {
 *      slot: // value for 'slot'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<SignDeleteMessageMutation, SignDeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignDeleteMessageMutation, SignDeleteMessageMutationVariables>(SignDeleteMessageDocument, options);
      }
export type SignDeleteMessageMutationHookResult = ReturnType<typeof useSignDeleteMessageMutation>;
export type SignDeleteMessageMutationResult = Apollo.MutationResult<SignDeleteMessageMutation>;
export type SignDeleteMessageMutationOptions = Apollo.BaseMutationOptions<SignDeleteMessageMutation, SignDeleteMessageMutationVariables>;
export const SignUploadMessageDocument = gql`
    mutation SignUploadMessage($message: SignMessageInput!, $slot: Int!, $id: ID!) {
  signUploadMessage(message: $message, slot: $slot, id: $id) {
    success
    failure
    id
  }
}
    `;
export type SignUploadMessageMutationFn = Apollo.MutationFunction<SignUploadMessageMutation, SignUploadMessageMutationVariables>;

/**
 * __useSignUploadMessageMutation__
 *
 * To run a mutation, you first call `useSignUploadMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUploadMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUploadMessageMutation, { data, loading, error }] = useSignUploadMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *      slot: // value for 'slot'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignUploadMessageMutation(baseOptions?: Apollo.MutationHookOptions<SignUploadMessageMutation, SignUploadMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUploadMessageMutation, SignUploadMessageMutationVariables>(SignUploadMessageDocument, options);
      }
export type SignUploadMessageMutationHookResult = ReturnType<typeof useSignUploadMessageMutation>;
export type SignUploadMessageMutationResult = Apollo.MutationResult<SignUploadMessageMutation>;
export type SignUploadMessageMutationOptions = Apollo.BaseMutationOptions<SignUploadMessageMutation, SignUploadMessageMutationVariables>;
export const SignUploadAllCommandsDocument = gql`
    mutation SignUploadAllCommands($id: ID!) {
  signUploadAllMessages(id: $id)
}
    `;
export type SignUploadAllCommandsMutationFn = Apollo.MutationFunction<SignUploadAllCommandsMutation, SignUploadAllCommandsMutationVariables>;

/**
 * __useSignUploadAllCommandsMutation__
 *
 * To run a mutation, you first call `useSignUploadAllCommandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUploadAllCommandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUploadAllCommandsMutation, { data, loading, error }] = useSignUploadAllCommandsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignUploadAllCommandsMutation(baseOptions?: Apollo.MutationHookOptions<SignUploadAllCommandsMutation, SignUploadAllCommandsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUploadAllCommandsMutation, SignUploadAllCommandsMutationVariables>(SignUploadAllCommandsDocument, options);
      }
export type SignUploadAllCommandsMutationHookResult = ReturnType<typeof useSignUploadAllCommandsMutation>;
export type SignUploadAllCommandsMutationResult = Apollo.MutationResult<SignUploadAllCommandsMutation>;
export type SignUploadAllCommandsMutationOptions = Apollo.BaseMutationOptions<SignUploadAllCommandsMutation, SignUploadAllCommandsMutationVariables>;
export const SignSetFontsDocument = gql`
    mutation SignSetFonts($id: ID!, $fontNumbers: [SignFontNumberInput!]!) {
  signSetFonts(id: $id, fontNumbers: $fontNumbers)
}
    `;
export type SignSetFontsMutationFn = Apollo.MutationFunction<SignSetFontsMutation, SignSetFontsMutationVariables>;

/**
 * __useSignSetFontsMutation__
 *
 * To run a mutation, you first call `useSignSetFontsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignSetFontsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signSetFontsMutation, { data, loading, error }] = useSignSetFontsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fontNumbers: // value for 'fontNumbers'
 *   },
 * });
 */
export function useSignSetFontsMutation(baseOptions?: Apollo.MutationHookOptions<SignSetFontsMutation, SignSetFontsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignSetFontsMutation, SignSetFontsMutationVariables>(SignSetFontsDocument, options);
      }
export type SignSetFontsMutationHookResult = ReturnType<typeof useSignSetFontsMutation>;
export type SignSetFontsMutationResult = Apollo.MutationResult<SignSetFontsMutation>;
export type SignSetFontsMutationOptions = Apollo.BaseMutationOptions<SignSetFontsMutation, SignSetFontsMutationVariables>;
export const SignSetCommandsDocument = gql`
    mutation SignSetCommands($id: ID!, $commands: [SignCommandNumberInput!]!) {
  signSetCommands(id: $id, commands: $commands)
}
    `;
export type SignSetCommandsMutationFn = Apollo.MutationFunction<SignSetCommandsMutation, SignSetCommandsMutationVariables>;

/**
 * __useSignSetCommandsMutation__
 *
 * To run a mutation, you first call `useSignSetCommandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignSetCommandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signSetCommandsMutation, { data, loading, error }] = useSignSetCommandsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      commands: // value for 'commands'
 *   },
 * });
 */
export function useSignSetCommandsMutation(baseOptions?: Apollo.MutationHookOptions<SignSetCommandsMutation, SignSetCommandsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignSetCommandsMutation, SignSetCommandsMutationVariables>(SignSetCommandsDocument, options);
      }
export type SignSetCommandsMutationHookResult = ReturnType<typeof useSignSetCommandsMutation>;
export type SignSetCommandsMutationResult = Apollo.MutationResult<SignSetCommandsMutation>;
export type SignSetCommandsMutationOptions = Apollo.BaseMutationOptions<SignSetCommandsMutation, SignSetCommandsMutationVariables>;
export const SignSetGraphicLabelsDocument = gql`
    mutation SignSetGraphicLabels($id: ID!, $labels: [SignGraphicLabelInput!]!) {
  signSetGraphicLabels(id: $id, labels: $labels)
}
    `;
export type SignSetGraphicLabelsMutationFn = Apollo.MutationFunction<SignSetGraphicLabelsMutation, SignSetGraphicLabelsMutationVariables>;

/**
 * __useSignSetGraphicLabelsMutation__
 *
 * To run a mutation, you first call `useSignSetGraphicLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignSetGraphicLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signSetGraphicLabelsMutation, { data, loading, error }] = useSignSetGraphicLabelsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useSignSetGraphicLabelsMutation(baseOptions?: Apollo.MutationHookOptions<SignSetGraphicLabelsMutation, SignSetGraphicLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignSetGraphicLabelsMutation, SignSetGraphicLabelsMutationVariables>(SignSetGraphicLabelsDocument, options);
      }
export type SignSetGraphicLabelsMutationHookResult = ReturnType<typeof useSignSetGraphicLabelsMutation>;
export type SignSetGraphicLabelsMutationResult = Apollo.MutationResult<SignSetGraphicLabelsMutation>;
export type SignSetGraphicLabelsMutationOptions = Apollo.BaseMutationOptions<SignSetGraphicLabelsMutation, SignSetGraphicLabelsMutationVariables>;
export const SignSetCommandMessagePriorityDocument = gql`
    mutation SignSetCommandMessagePriority($id: ID!, $slot: Int!, $priority: Int!) {
  signSetCommandMessagePriority(id: $id, slot: $slot, priority: $priority)
}
    `;
export type SignSetCommandMessagePriorityMutationFn = Apollo.MutationFunction<SignSetCommandMessagePriorityMutation, SignSetCommandMessagePriorityMutationVariables>;

/**
 * __useSignSetCommandMessagePriorityMutation__
 *
 * To run a mutation, you first call `useSignSetCommandMessagePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignSetCommandMessagePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signSetCommandMessagePriorityMutation, { data, loading, error }] = useSignSetCommandMessagePriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      slot: // value for 'slot'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useSignSetCommandMessagePriorityMutation(baseOptions?: Apollo.MutationHookOptions<SignSetCommandMessagePriorityMutation, SignSetCommandMessagePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignSetCommandMessagePriorityMutation, SignSetCommandMessagePriorityMutationVariables>(SignSetCommandMessagePriorityDocument, options);
      }
export type SignSetCommandMessagePriorityMutationHookResult = ReturnType<typeof useSignSetCommandMessagePriorityMutation>;
export type SignSetCommandMessagePriorityMutationResult = Apollo.MutationResult<SignSetCommandMessagePriorityMutation>;
export type SignSetCommandMessagePriorityMutationOptions = Apollo.BaseMutationOptions<SignSetCommandMessagePriorityMutation, SignSetCommandMessagePriorityMutationVariables>;
export const SaveResourcePlanDocument = gql`
    mutation SaveResourcePlan($input: ResourcePlanInput!) {
  saveResourcePlan(input: $input) {
    id
  }
}
    `;
export type SaveResourcePlanMutationFn = Apollo.MutationFunction<SaveResourcePlanMutation, SaveResourcePlanMutationVariables>;

/**
 * __useSaveResourcePlanMutation__
 *
 * To run a mutation, you first call `useSaveResourcePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveResourcePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveResourcePlanMutation, { data, loading, error }] = useSaveResourcePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveResourcePlanMutation(baseOptions?: Apollo.MutationHookOptions<SaveResourcePlanMutation, SaveResourcePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveResourcePlanMutation, SaveResourcePlanMutationVariables>(SaveResourcePlanDocument, options);
      }
export type SaveResourcePlanMutationHookResult = ReturnType<typeof useSaveResourcePlanMutation>;
export type SaveResourcePlanMutationResult = Apollo.MutationResult<SaveResourcePlanMutation>;
export type SaveResourcePlanMutationOptions = Apollo.BaseMutationOptions<SaveResourcePlanMutation, SaveResourcePlanMutationVariables>;
export const SaveSignMessageDocument = gql`
    mutation SaveSignMessage($input: SignLibraryMessageInput!) {
  saveSignMessage(input: $input) {
    ...SignLibraryMessage
  }
}
    ${SignLibraryMessageFragmentDoc}`;
export type SaveSignMessageMutationFn = Apollo.MutationFunction<SaveSignMessageMutation, SaveSignMessageMutationVariables>;

/**
 * __useSaveSignMessageMutation__
 *
 * To run a mutation, you first call `useSaveSignMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignMessageMutation, { data, loading, error }] = useSaveSignMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignMessageMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignMessageMutation, SaveSignMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignMessageMutation, SaveSignMessageMutationVariables>(SaveSignMessageDocument, options);
      }
export type SaveSignMessageMutationHookResult = ReturnType<typeof useSaveSignMessageMutation>;
export type SaveSignMessageMutationResult = Apollo.MutationResult<SaveSignMessageMutation>;
export type SaveSignMessageMutationOptions = Apollo.BaseMutationOptions<SaveSignMessageMutation, SaveSignMessageMutationVariables>;
export const SignDisplayDocument = gql`
    mutation SignDisplay($requests: [SignMessageDisplayRequest!]!) {
  signDisplay(requests: $requests) {
    ...JobRequest
  }
}
    ${JobRequestFragmentDoc}`;
export type SignDisplayMutationFn = Apollo.MutationFunction<SignDisplayMutation, SignDisplayMutationVariables>;

/**
 * __useSignDisplayMutation__
 *
 * To run a mutation, you first call `useSignDisplayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignDisplayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signDisplayMutation, { data, loading, error }] = useSignDisplayMutation({
 *   variables: {
 *      requests: // value for 'requests'
 *   },
 * });
 */
export function useSignDisplayMutation(baseOptions?: Apollo.MutationHookOptions<SignDisplayMutation, SignDisplayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignDisplayMutation, SignDisplayMutationVariables>(SignDisplayDocument, options);
      }
export type SignDisplayMutationHookResult = ReturnType<typeof useSignDisplayMutation>;
export type SignDisplayMutationResult = Apollo.MutationResult<SignDisplayMutation>;
export type SignDisplayMutationOptions = Apollo.BaseMutationOptions<SignDisplayMutation, SignDisplayMutationVariables>;
export const UpdateQueuedMessageDocument = gql`
    mutation UpdateQueuedMessage($id: ID!, $queuedMessage: SignQueuedMessageInput!) {
  updateQueuedMessage(id: $id, queuedMessage: $queuedMessage) {
    success
    failure
    id
  }
}
    `;
export type UpdateQueuedMessageMutationFn = Apollo.MutationFunction<UpdateQueuedMessageMutation, UpdateQueuedMessageMutationVariables>;

/**
 * __useUpdateQueuedMessageMutation__
 *
 * To run a mutation, you first call `useUpdateQueuedMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueuedMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueuedMessageMutation, { data, loading, error }] = useUpdateQueuedMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      queuedMessage: // value for 'queuedMessage'
 *   },
 * });
 */
export function useUpdateQueuedMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQueuedMessageMutation, UpdateQueuedMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQueuedMessageMutation, UpdateQueuedMessageMutationVariables>(UpdateQueuedMessageDocument, options);
      }
export type UpdateQueuedMessageMutationHookResult = ReturnType<typeof useUpdateQueuedMessageMutation>;
export type UpdateQueuedMessageMutationResult = Apollo.MutationResult<UpdateQueuedMessageMutation>;
export type UpdateQueuedMessageMutationOptions = Apollo.BaseMutationOptions<UpdateQueuedMessageMutation, UpdateQueuedMessageMutationVariables>;
export const SignInterlockAcknowledgeDocument = gql`
    mutation SignInterlockAcknowledge($input: [SignInterlockInput!]!, $resourcePlanIds: [String!]) {
  signInterlockAcknowledge(input: $input, resourcePlanIds: $resourcePlanIds)
}
    `;
export type SignInterlockAcknowledgeMutationFn = Apollo.MutationFunction<SignInterlockAcknowledgeMutation, SignInterlockAcknowledgeMutationVariables>;

/**
 * __useSignInterlockAcknowledgeMutation__
 *
 * To run a mutation, you first call `useSignInterlockAcknowledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInterlockAcknowledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInterlockAcknowledgeMutation, { data, loading, error }] = useSignInterlockAcknowledgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      resourcePlanIds: // value for 'resourcePlanIds'
 *   },
 * });
 */
export function useSignInterlockAcknowledgeMutation(baseOptions?: Apollo.MutationHookOptions<SignInterlockAcknowledgeMutation, SignInterlockAcknowledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInterlockAcknowledgeMutation, SignInterlockAcknowledgeMutationVariables>(SignInterlockAcknowledgeDocument, options);
      }
export type SignInterlockAcknowledgeMutationHookResult = ReturnType<typeof useSignInterlockAcknowledgeMutation>;
export type SignInterlockAcknowledgeMutationResult = Apollo.MutationResult<SignInterlockAcknowledgeMutation>;
export type SignInterlockAcknowledgeMutationOptions = Apollo.BaseMutationOptions<SignInterlockAcknowledgeMutation, SignInterlockAcknowledgeMutationVariables>;
export const DeleteSignMessagePrioritiesDocument = gql`
    mutation DeleteSignMessagePriorities($ids: [ID!]!) {
  deleteSignMessagePriorities(priorities: $ids)
}
    `;
export type DeleteSignMessagePrioritiesMutationFn = Apollo.MutationFunction<DeleteSignMessagePrioritiesMutation, DeleteSignMessagePrioritiesMutationVariables>;

/**
 * __useDeleteSignMessagePrioritiesMutation__
 *
 * To run a mutation, you first call `useDeleteSignMessagePrioritiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignMessagePrioritiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignMessagePrioritiesMutation, { data, loading, error }] = useDeleteSignMessagePrioritiesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteSignMessagePrioritiesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignMessagePrioritiesMutation, DeleteSignMessagePrioritiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignMessagePrioritiesMutation, DeleteSignMessagePrioritiesMutationVariables>(DeleteSignMessagePrioritiesDocument, options);
      }
export type DeleteSignMessagePrioritiesMutationHookResult = ReturnType<typeof useDeleteSignMessagePrioritiesMutation>;
export type DeleteSignMessagePrioritiesMutationResult = Apollo.MutationResult<DeleteSignMessagePrioritiesMutation>;
export type DeleteSignMessagePrioritiesMutationOptions = Apollo.BaseMutationOptions<DeleteSignMessagePrioritiesMutation, DeleteSignMessagePrioritiesMutationVariables>;
export const SaveSignMessagePriorityDocument = gql`
    mutation SaveSignMessagePriority($input: SignMessagePriorityInput!) {
  saveSignMessagePriority(input: $input) {
    id
  }
}
    `;
export type SaveSignMessagePriorityMutationFn = Apollo.MutationFunction<SaveSignMessagePriorityMutation, SaveSignMessagePriorityMutationVariables>;

/**
 * __useSaveSignMessagePriorityMutation__
 *
 * To run a mutation, you first call `useSaveSignMessagePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignMessagePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignMessagePriorityMutation, { data, loading, error }] = useSaveSignMessagePriorityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignMessagePriorityMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignMessagePriorityMutation, SaveSignMessagePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignMessagePriorityMutation, SaveSignMessagePriorityMutationVariables>(SaveSignMessagePriorityDocument, options);
      }
export type SaveSignMessagePriorityMutationHookResult = ReturnType<typeof useSaveSignMessagePriorityMutation>;
export type SaveSignMessagePriorityMutationResult = Apollo.MutationResult<SaveSignMessagePriorityMutation>;
export type SaveSignMessagePriorityMutationOptions = Apollo.BaseMutationOptions<SaveSignMessagePriorityMutation, SaveSignMessagePriorityMutationVariables>;
export const SignMessagePrioritiesListDocument = gql`
    query SignMessagePrioritiesList {
  signMessagePriorities {
    travelTimeDefault
    messageDefault
    description
    priority
    name
    id
  }
}
    `;

/**
 * __useSignMessagePrioritiesListQuery__
 *
 * To run a query within a React component, call `useSignMessagePrioritiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessagePrioritiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessagePrioritiesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignMessagePrioritiesListQuery(baseOptions?: Apollo.QueryHookOptions<SignMessagePrioritiesListQuery, SignMessagePrioritiesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessagePrioritiesListQuery, SignMessagePrioritiesListQueryVariables>(SignMessagePrioritiesListDocument, options);
      }
export function useSignMessagePrioritiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessagePrioritiesListQuery, SignMessagePrioritiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessagePrioritiesListQuery, SignMessagePrioritiesListQueryVariables>(SignMessagePrioritiesListDocument, options);
        }
export type SignMessagePrioritiesListQueryHookResult = ReturnType<typeof useSignMessagePrioritiesListQuery>;
export type SignMessagePrioritiesListLazyQueryHookResult = ReturnType<typeof useSignMessagePrioritiesListLazyQuery>;
export type SignMessagePrioritiesListQueryResult = Apollo.QueryResult<SignMessagePrioritiesListQuery, SignMessagePrioritiesListQueryVariables>;
export function refetchSignMessagePrioritiesListQuery(variables?: SignMessagePrioritiesListQueryVariables) {
      return { query: SignMessagePrioritiesListDocument, variables: variables }
    }
export const SignMessagePriorityDocument = gql`
    query SignMessagePriority($id: ID!) {
  signMessagePriority(id: $id) {
    travelTimeDefault
    messageDefault
    description
    priority
    name
    id
  }
}
    `;

/**
 * __useSignMessagePriorityQuery__
 *
 * To run a query within a React component, call `useSignMessagePriorityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessagePriorityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessagePriorityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignMessagePriorityQuery(baseOptions: Apollo.QueryHookOptions<SignMessagePriorityQuery, SignMessagePriorityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessagePriorityQuery, SignMessagePriorityQueryVariables>(SignMessagePriorityDocument, options);
      }
export function useSignMessagePriorityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessagePriorityQuery, SignMessagePriorityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessagePriorityQuery, SignMessagePriorityQueryVariables>(SignMessagePriorityDocument, options);
        }
export type SignMessagePriorityQueryHookResult = ReturnType<typeof useSignMessagePriorityQuery>;
export type SignMessagePriorityLazyQueryHookResult = ReturnType<typeof useSignMessagePriorityLazyQuery>;
export type SignMessagePriorityQueryResult = Apollo.QueryResult<SignMessagePriorityQuery, SignMessagePriorityQueryVariables>;
export function refetchSignMessagePriorityQuery(variables: SignMessagePriorityQueryVariables) {
      return { query: SignMessagePriorityDocument, variables: variables }
    }
export const SignLibraryMessageUpdatedDocument = gql`
    subscription SignLibraryMessageUpdated {
  libraryMessageUpdated {
    ...SignLibraryMessage
  }
}
    ${SignLibraryMessageFragmentDoc}`;

/**
 * __useSignLibraryMessageUpdatedSubscription__
 *
 * To run a query within a React component, call `useSignLibraryMessageUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSignLibraryMessageUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignLibraryMessageUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSignLibraryMessageUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SignLibraryMessageUpdatedSubscription, SignLibraryMessageUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SignLibraryMessageUpdatedSubscription, SignLibraryMessageUpdatedSubscriptionVariables>(SignLibraryMessageUpdatedDocument, options);
      }
export type SignLibraryMessageUpdatedSubscriptionHookResult = ReturnType<typeof useSignLibraryMessageUpdatedSubscription>;
export type SignLibraryMessageUpdatedSubscriptionResult = Apollo.SubscriptionResult<SignLibraryMessageUpdatedSubscription>;
export const SignSpeedSettingsDocument = gql`
    query SignSpeedSettings($id: ID!) {
  sign(id: $id) {
    speedSettings {
      ...SignSpeedSettings
    }
  }
}
    ${SignSpeedSettingsFragmentDoc}`;

/**
 * __useSignSpeedSettingsQuery__
 *
 * To run a query within a React component, call `useSignSpeedSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignSpeedSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignSpeedSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignSpeedSettingsQuery(baseOptions: Apollo.QueryHookOptions<SignSpeedSettingsQuery, SignSpeedSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignSpeedSettingsQuery, SignSpeedSettingsQueryVariables>(SignSpeedSettingsDocument, options);
      }
export function useSignSpeedSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignSpeedSettingsQuery, SignSpeedSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignSpeedSettingsQuery, SignSpeedSettingsQueryVariables>(SignSpeedSettingsDocument, options);
        }
export type SignSpeedSettingsQueryHookResult = ReturnType<typeof useSignSpeedSettingsQuery>;
export type SignSpeedSettingsLazyQueryHookResult = ReturnType<typeof useSignSpeedSettingsLazyQuery>;
export type SignSpeedSettingsQueryResult = Apollo.QueryResult<SignSpeedSettingsQuery, SignSpeedSettingsQueryVariables>;
export function refetchSignSpeedSettingsQuery(variables: SignSpeedSettingsQueryVariables) {
      return { query: SignSpeedSettingsDocument, variables: variables }
    }
export const SignColorsDocument = gql`
    query SignColors($id: ID!) {
  sign(id: $id) {
    backgroundColor
    foregroundColor
  }
}
    `;

/**
 * __useSignColorsQuery__
 *
 * To run a query within a React component, call `useSignColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignColorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignColorsQuery(baseOptions: Apollo.QueryHookOptions<SignColorsQuery, SignColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignColorsQuery, SignColorsQueryVariables>(SignColorsDocument, options);
      }
export function useSignColorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignColorsQuery, SignColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignColorsQuery, SignColorsQueryVariables>(SignColorsDocument, options);
        }
export type SignColorsQueryHookResult = ReturnType<typeof useSignColorsQuery>;
export type SignColorsLazyQueryHookResult = ReturnType<typeof useSignColorsLazyQuery>;
export type SignColorsQueryResult = Apollo.QueryResult<SignColorsQuery, SignColorsQueryVariables>;
export function refetchSignColorsQuery(variables: SignColorsQueryVariables) {
      return { query: SignColorsDocument, variables: variables }
    }
export const SignControllerFontsDocument = gql`
    query SignControllerFonts($id: ID!) {
  signControllerFonts(id: $id) {
    characterSpacing
    characterHeight
    fontFileName
    lineSpacing
    fontVersion
    font
    id
  }
}
    `;

/**
 * __useSignControllerFontsQuery__
 *
 * To run a query within a React component, call `useSignControllerFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignControllerFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignControllerFontsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignControllerFontsQuery(baseOptions: Apollo.QueryHookOptions<SignControllerFontsQuery, SignControllerFontsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignControllerFontsQuery, SignControllerFontsQueryVariables>(SignControllerFontsDocument, options);
      }
export function useSignControllerFontsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignControllerFontsQuery, SignControllerFontsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignControllerFontsQuery, SignControllerFontsQueryVariables>(SignControllerFontsDocument, options);
        }
export type SignControllerFontsQueryHookResult = ReturnType<typeof useSignControllerFontsQuery>;
export type SignControllerFontsLazyQueryHookResult = ReturnType<typeof useSignControllerFontsLazyQuery>;
export type SignControllerFontsQueryResult = Apollo.QueryResult<SignControllerFontsQuery, SignControllerFontsQueryVariables>;
export function refetchSignControllerFontsQuery(variables: SignControllerFontsQueryVariables) {
      return { query: SignControllerFontsDocument, variables: variables }
    }
export const SignDefaultFontDocument = gql`
    query SignDefaultFont {
  signDefaultFont {
    characterSpacing
    characterHeight
    fontFileName
    lineSpacing
    fontVersion
    font
    id
  }
}
    `;

/**
 * __useSignDefaultFontQuery__
 *
 * To run a query within a React component, call `useSignDefaultFontQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignDefaultFontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignDefaultFontQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignDefaultFontQuery(baseOptions?: Apollo.QueryHookOptions<SignDefaultFontQuery, SignDefaultFontQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignDefaultFontQuery, SignDefaultFontQueryVariables>(SignDefaultFontDocument, options);
      }
export function useSignDefaultFontLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignDefaultFontQuery, SignDefaultFontQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignDefaultFontQuery, SignDefaultFontQueryVariables>(SignDefaultFontDocument, options);
        }
export type SignDefaultFontQueryHookResult = ReturnType<typeof useSignDefaultFontQuery>;
export type SignDefaultFontLazyQueryHookResult = ReturnType<typeof useSignDefaultFontLazyQuery>;
export type SignDefaultFontQueryResult = Apollo.QueryResult<SignDefaultFontQuery, SignDefaultFontQueryVariables>;
export function refetchSignDefaultFontQuery(variables?: SignDefaultFontQueryVariables) {
      return { query: SignDefaultFontDocument, variables: variables }
    }
export const SignCapabilitiesDocument = gql`
    query SignCapabilities($id: ID!) {
  sign(id: $id) {
    capabilities
  }
}
    `;

/**
 * __useSignCapabilitiesQuery__
 *
 * To run a query within a React component, call `useSignCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignCapabilitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignCapabilitiesQuery(baseOptions: Apollo.QueryHookOptions<SignCapabilitiesQuery, SignCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignCapabilitiesQuery, SignCapabilitiesQueryVariables>(SignCapabilitiesDocument, options);
      }
export function useSignCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignCapabilitiesQuery, SignCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignCapabilitiesQuery, SignCapabilitiesQueryVariables>(SignCapabilitiesDocument, options);
        }
export type SignCapabilitiesQueryHookResult = ReturnType<typeof useSignCapabilitiesQuery>;
export type SignCapabilitiesLazyQueryHookResult = ReturnType<typeof useSignCapabilitiesLazyQuery>;
export type SignCapabilitiesQueryResult = Apollo.QueryResult<SignCapabilitiesQuery, SignCapabilitiesQueryVariables>;
export function refetchSignCapabilitiesQuery(variables: SignCapabilitiesQueryVariables) {
      return { query: SignCapabilitiesDocument, variables: variables }
    }
export const SignDisplayTypeDocument = gql`
    query SignDisplayType($id: ID!) {
  signDisplayType(id: $id) {
    ...SignDisplayType
  }
}
    ${SignDisplayTypeFragmentDoc}`;

/**
 * __useSignDisplayTypeQuery__
 *
 * To run a query within a React component, call `useSignDisplayTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignDisplayTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignDisplayTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignDisplayTypeQuery(baseOptions: Apollo.QueryHookOptions<SignDisplayTypeQuery, SignDisplayTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignDisplayTypeQuery, SignDisplayTypeQueryVariables>(SignDisplayTypeDocument, options);
      }
export function useSignDisplayTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignDisplayTypeQuery, SignDisplayTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignDisplayTypeQuery, SignDisplayTypeQueryVariables>(SignDisplayTypeDocument, options);
        }
export type SignDisplayTypeQueryHookResult = ReturnType<typeof useSignDisplayTypeQuery>;
export type SignDisplayTypeLazyQueryHookResult = ReturnType<typeof useSignDisplayTypeLazyQuery>;
export type SignDisplayTypeQueryResult = Apollo.QueryResult<SignDisplayTypeQuery, SignDisplayTypeQueryVariables>;
export function refetchSignDisplayTypeQuery(variables: SignDisplayTypeQueryVariables) {
      return { query: SignDisplayTypeDocument, variables: variables }
    }
export const SignMessageDisplayTypesDocument = gql`
    query SignMessageDisplayTypes {
  signMessageDisplayTypes {
    characterHeight
    characterWidth
    maxCharacters
    defaultFont
    matrixType
    maxLines
    maxPages
    height
    width
    hash
  }
}
    `;

/**
 * __useSignMessageDisplayTypesQuery__
 *
 * To run a query within a React component, call `useSignMessageDisplayTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessageDisplayTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessageDisplayTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignMessageDisplayTypesQuery(baseOptions?: Apollo.QueryHookOptions<SignMessageDisplayTypesQuery, SignMessageDisplayTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessageDisplayTypesQuery, SignMessageDisplayTypesQueryVariables>(SignMessageDisplayTypesDocument, options);
      }
export function useSignMessageDisplayTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessageDisplayTypesQuery, SignMessageDisplayTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessageDisplayTypesQuery, SignMessageDisplayTypesQueryVariables>(SignMessageDisplayTypesDocument, options);
        }
export type SignMessageDisplayTypesQueryHookResult = ReturnType<typeof useSignMessageDisplayTypesQuery>;
export type SignMessageDisplayTypesLazyQueryHookResult = ReturnType<typeof useSignMessageDisplayTypesLazyQuery>;
export type SignMessageDisplayTypesQueryResult = Apollo.QueryResult<SignMessageDisplayTypesQuery, SignMessageDisplayTypesQueryVariables>;
export function refetchSignMessageDisplayTypesQuery(variables?: SignMessageDisplayTypesQueryVariables) {
      return { query: SignMessageDisplayTypesDocument, variables: variables }
    }
export const SignGroupDocument = gql`
    query SignGroup($id: ID!) {
  signGroup(id: $id) {
    ...SignGroup
  }
}
    ${SignGroupFragmentDoc}`;

/**
 * __useSignGroupQuery__
 *
 * To run a query within a React component, call `useSignGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignGroupQuery(baseOptions: Apollo.QueryHookOptions<SignGroupQuery, SignGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignGroupQuery, SignGroupQueryVariables>(SignGroupDocument, options);
      }
export function useSignGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignGroupQuery, SignGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignGroupQuery, SignGroupQueryVariables>(SignGroupDocument, options);
        }
export type SignGroupQueryHookResult = ReturnType<typeof useSignGroupQuery>;
export type SignGroupLazyQueryHookResult = ReturnType<typeof useSignGroupLazyQuery>;
export type SignGroupQueryResult = Apollo.QueryResult<SignGroupQuery, SignGroupQueryVariables>;
export function refetchSignGroupQuery(variables: SignGroupQueryVariables) {
      return { query: SignGroupDocument, variables: variables }
    }
export const SignGroupsListDocument = gql`
    query SignGroupsList($after: String, $before: String, $limit: Int = 10, $sortField: String = "name", $sortOrder: SortOrder = DESCENDING, $searchText: String, $searchFields: [String!] = ["name", "type", "description", "signs"], $filters: [FilterInput]) {
  signGroups(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, searchFields: $searchFields, filters: $filters}
  ) {
    edges {
      node {
        description
        attributes
        signs {
          referencePoint
          displayType {
            ...SignDisplayType
          }
          direction
          id
        }
        type
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${SignDisplayTypeFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignGroupsListQuery__
 *
 * To run a query within a React component, call `useSignGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignGroupsListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSignGroupsListQuery(baseOptions?: Apollo.QueryHookOptions<SignGroupsListQuery, SignGroupsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignGroupsListQuery, SignGroupsListQueryVariables>(SignGroupsListDocument, options);
      }
export function useSignGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignGroupsListQuery, SignGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignGroupsListQuery, SignGroupsListQueryVariables>(SignGroupsListDocument, options);
        }
export type SignGroupsListQueryHookResult = ReturnType<typeof useSignGroupsListQuery>;
export type SignGroupsListLazyQueryHookResult = ReturnType<typeof useSignGroupsListLazyQuery>;
export type SignGroupsListQueryResult = Apollo.QueryResult<SignGroupsListQuery, SignGroupsListQueryVariables>;
export function refetchSignGroupsListQuery(variables?: SignGroupsListQueryVariables) {
      return { query: SignGroupsListDocument, variables: variables }
    }
export const GetSignDocument = gql`
    query GetSign($id: ID!) {
  sign(id: $id) {
    ...SignDetail
  }
}
    ${SignDetailFragmentDoc}`;

/**
 * __useGetSignQuery__
 *
 * To run a query within a React component, call `useGetSignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSignQuery(baseOptions: Apollo.QueryHookOptions<GetSignQuery, GetSignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignQuery, GetSignQueryVariables>(GetSignDocument, options);
      }
export function useGetSignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignQuery, GetSignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignQuery, GetSignQueryVariables>(GetSignDocument, options);
        }
export type GetSignQueryHookResult = ReturnType<typeof useGetSignQuery>;
export type GetSignLazyQueryHookResult = ReturnType<typeof useGetSignLazyQuery>;
export type GetSignQueryResult = Apollo.QueryResult<GetSignQuery, GetSignQueryVariables>;
export function refetchGetSignQuery(variables: GetSignQueryVariables) {
      return { query: GetSignDocument, variables: variables }
    }
export const GetSignGraphicsDocument = gql`
    query GetSignGraphics($filterInput: [FilterInput!]!) {
  getManagedFiles(filterInput: $filterInput) {
    edges {
      node {
        height
        image
        width
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetSignGraphicsQuery__
 *
 * To run a query within a React component, call `useGetSignGraphicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignGraphicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignGraphicsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetSignGraphicsQuery(baseOptions: Apollo.QueryHookOptions<GetSignGraphicsQuery, GetSignGraphicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignGraphicsQuery, GetSignGraphicsQueryVariables>(GetSignGraphicsDocument, options);
      }
export function useGetSignGraphicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignGraphicsQuery, GetSignGraphicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignGraphicsQuery, GetSignGraphicsQueryVariables>(GetSignGraphicsDocument, options);
        }
export type GetSignGraphicsQueryHookResult = ReturnType<typeof useGetSignGraphicsQuery>;
export type GetSignGraphicsLazyQueryHookResult = ReturnType<typeof useGetSignGraphicsLazyQuery>;
export type GetSignGraphicsQueryResult = Apollo.QueryResult<GetSignGraphicsQuery, GetSignGraphicsQueryVariables>;
export function refetchGetSignGraphicsQuery(variables: GetSignGraphicsQueryVariables) {
      return { query: GetSignGraphicsDocument, variables: variables }
    }
export const SignUpdatedDocument = gql`
    subscription SignUpdated($id: ID!) {
  signUpdated(ids: [$id]) {
    ...SignDetail
  }
}
    ${SignDetailFragmentDoc}`;

/**
 * __useSignUpdatedSubscription__
 *
 * To run a query within a React component, call `useSignUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSignUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SignUpdatedSubscription, SignUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SignUpdatedSubscription, SignUpdatedSubscriptionVariables>(SignUpdatedDocument, options);
      }
export type SignUpdatedSubscriptionHookResult = ReturnType<typeof useSignUpdatedSubscription>;
export type SignUpdatedSubscriptionResult = Apollo.SubscriptionResult<SignUpdatedSubscription>;
export const SignMapEntitiesDocument = gql`
    query SignMapEntities($filters: [FilterInput!]!) {
  signMapEntities(filters: $filters)
}
    `;

/**
 * __useSignMapEntitiesQuery__
 *
 * To run a query within a React component, call `useSignMapEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMapEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMapEntitiesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSignMapEntitiesQuery(baseOptions: Apollo.QueryHookOptions<SignMapEntitiesQuery, SignMapEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMapEntitiesQuery, SignMapEntitiesQueryVariables>(SignMapEntitiesDocument, options);
      }
export function useSignMapEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMapEntitiesQuery, SignMapEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMapEntitiesQuery, SignMapEntitiesQueryVariables>(SignMapEntitiesDocument, options);
        }
export type SignMapEntitiesQueryHookResult = ReturnType<typeof useSignMapEntitiesQuery>;
export type SignMapEntitiesLazyQueryHookResult = ReturnType<typeof useSignMapEntitiesLazyQuery>;
export type SignMapEntitiesQueryResult = Apollo.QueryResult<SignMapEntitiesQuery, SignMapEntitiesQueryVariables>;
export function refetchSignMapEntitiesQuery(variables: SignMapEntitiesQueryVariables) {
      return { query: SignMapEntitiesDocument, variables: variables }
    }
export const SignDisplayTypeMessageValidateDocument = gql`
    query SignDisplayTypeMessageValidate($id: ID!, $message: SignMessageInput!) {
  validateDisplayTypeMessage(id: $id, message: $message) {
    failure
  }
}
    `;

/**
 * __useSignDisplayTypeMessageValidateQuery__
 *
 * To run a query within a React component, call `useSignDisplayTypeMessageValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignDisplayTypeMessageValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignDisplayTypeMessageValidateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSignDisplayTypeMessageValidateQuery(baseOptions: Apollo.QueryHookOptions<SignDisplayTypeMessageValidateQuery, SignDisplayTypeMessageValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignDisplayTypeMessageValidateQuery, SignDisplayTypeMessageValidateQueryVariables>(SignDisplayTypeMessageValidateDocument, options);
      }
export function useSignDisplayTypeMessageValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignDisplayTypeMessageValidateQuery, SignDisplayTypeMessageValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignDisplayTypeMessageValidateQuery, SignDisplayTypeMessageValidateQueryVariables>(SignDisplayTypeMessageValidateDocument, options);
        }
export type SignDisplayTypeMessageValidateQueryHookResult = ReturnType<typeof useSignDisplayTypeMessageValidateQuery>;
export type SignDisplayTypeMessageValidateLazyQueryHookResult = ReturnType<typeof useSignDisplayTypeMessageValidateLazyQuery>;
export type SignDisplayTypeMessageValidateQueryResult = Apollo.QueryResult<SignDisplayTypeMessageValidateQuery, SignDisplayTypeMessageValidateQueryVariables>;
export function refetchSignDisplayTypeMessageValidateQuery(variables: SignDisplayTypeMessageValidateQueryVariables) {
      return { query: SignDisplayTypeMessageValidateDocument, variables: variables }
    }
export const SignLibraryMessageValidateDocument = gql`
    query SignLibraryMessageValidate($message: SignLibraryMessageInput!) {
  validateLibraryMessage(message: $message) {
    result
    hash
  }
}
    `;

/**
 * __useSignLibraryMessageValidateQuery__
 *
 * To run a query within a React component, call `useSignLibraryMessageValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignLibraryMessageValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignLibraryMessageValidateQuery({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSignLibraryMessageValidateQuery(baseOptions: Apollo.QueryHookOptions<SignLibraryMessageValidateQuery, SignLibraryMessageValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignLibraryMessageValidateQuery, SignLibraryMessageValidateQueryVariables>(SignLibraryMessageValidateDocument, options);
      }
export function useSignLibraryMessageValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignLibraryMessageValidateQuery, SignLibraryMessageValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignLibraryMessageValidateQuery, SignLibraryMessageValidateQueryVariables>(SignLibraryMessageValidateDocument, options);
        }
export type SignLibraryMessageValidateQueryHookResult = ReturnType<typeof useSignLibraryMessageValidateQuery>;
export type SignLibraryMessageValidateLazyQueryHookResult = ReturnType<typeof useSignLibraryMessageValidateLazyQuery>;
export type SignLibraryMessageValidateQueryResult = Apollo.QueryResult<SignLibraryMessageValidateQuery, SignLibraryMessageValidateQueryVariables>;
export function refetchSignLibraryMessageValidateQuery(variables: SignLibraryMessageValidateQueryVariables) {
      return { query: SignLibraryMessageValidateDocument, variables: variables }
    }
export const SignsSummaryDocument = gql`
    query SignsSummary {
  activeSign: signs(
    filters: [{operator: EXISTS, field: "currentMessage.message", value: true}]
  ) {
    totalCount
  }
  allSigns: signs {
    totalCount
  }
}
    `;

/**
 * __useSignsSummaryQuery__
 *
 * To run a query within a React component, call `useSignsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<SignsSummaryQuery, SignsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignsSummaryQuery, SignsSummaryQueryVariables>(SignsSummaryDocument, options);
      }
export function useSignsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignsSummaryQuery, SignsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignsSummaryQuery, SignsSummaryQueryVariables>(SignsSummaryDocument, options);
        }
export type SignsSummaryQueryHookResult = ReturnType<typeof useSignsSummaryQuery>;
export type SignsSummaryLazyQueryHookResult = ReturnType<typeof useSignsSummaryLazyQuery>;
export type SignsSummaryQueryResult = Apollo.QueryResult<SignsSummaryQuery, SignsSummaryQueryVariables>;
export function refetchSignsSummaryQuery(variables?: SignsSummaryQueryVariables) {
      return { query: SignsSummaryDocument, variables: variables }
    }
export const SignsListDocument = gql`
    query SignsList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchFields: [String!] = ["name", "communicationStatus", "description", "category"], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  signs(
    searchFields: $searchFields
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...SignListFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignListFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignsListQuery__
 *
 * To run a query within a React component, call `useSignsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignsListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSignsListQuery(baseOptions?: Apollo.QueryHookOptions<SignsListQuery, SignsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignsListQuery, SignsListQueryVariables>(SignsListDocument, options);
      }
export function useSignsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignsListQuery, SignsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignsListQuery, SignsListQueryVariables>(SignsListDocument, options);
        }
export type SignsListQueryHookResult = ReturnType<typeof useSignsListQuery>;
export type SignsListLazyQueryHookResult = ReturnType<typeof useSignsListLazyQuery>;
export type SignsListQueryResult = Apollo.QueryResult<SignsListQuery, SignsListQueryVariables>;
export function refetchSignsListQuery(variables?: SignsListQueryVariables) {
      return { query: SignsListDocument, variables: variables }
    }
export const SignLibraryMessageDocument = gql`
    query SignLibraryMessage($id: ID!) {
  signMessage(id: $id) {
    ...SignLibraryMessage
  }
}
    ${SignLibraryMessageFragmentDoc}`;

/**
 * __useSignLibraryMessageQuery__
 *
 * To run a query within a React component, call `useSignLibraryMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignLibraryMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignLibraryMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignLibraryMessageQuery(baseOptions: Apollo.QueryHookOptions<SignLibraryMessageQuery, SignLibraryMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignLibraryMessageQuery, SignLibraryMessageQueryVariables>(SignLibraryMessageDocument, options);
      }
export function useSignLibraryMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignLibraryMessageQuery, SignLibraryMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignLibraryMessageQuery, SignLibraryMessageQueryVariables>(SignLibraryMessageDocument, options);
        }
export type SignLibraryMessageQueryHookResult = ReturnType<typeof useSignLibraryMessageQuery>;
export type SignLibraryMessageLazyQueryHookResult = ReturnType<typeof useSignLibraryMessageLazyQuery>;
export type SignLibraryMessageQueryResult = Apollo.QueryResult<SignLibraryMessageQuery, SignLibraryMessageQueryVariables>;
export function refetchSignLibraryMessageQuery(variables: SignLibraryMessageQueryVariables) {
      return { query: SignLibraryMessageDocument, variables: variables }
    }
export const LiveSignListDocument = gql`
    subscription LiveSignList($ids: [ID!]!) {
  signUpdated(ids: $ids) {
    ...SignListFragment
  }
}
    ${SignListFragmentFragmentDoc}`;

/**
 * __useLiveSignListSubscription__
 *
 * To run a query within a React component, call `useLiveSignListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveSignListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveSignListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveSignListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveSignListSubscription, LiveSignListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveSignListSubscription, LiveSignListSubscriptionVariables>(LiveSignListDocument, options);
      }
export type LiveSignListSubscriptionHookResult = ReturnType<typeof useLiveSignListSubscription>;
export type LiveSignListSubscriptionResult = Apollo.SubscriptionResult<LiveSignListSubscription>;
export const MessageLibraryDocument = gql`
    query MessageLibrary($after: String, $before: String, $limit: Int = 10, $sortField: String = "id", $sortOrder: SortOrder = ASCENDING, $searchText: String, $sign: ID, $type: SignMessageType, $filters: [FilterInput!]) {
  signMessages(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, sign: $sign, searchText: $searchText, filters: $filters, type: $type}
  ) {
    edges {
      node {
        ...SignLibraryMessage
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignLibraryMessageFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useMessageLibraryQuery__
 *
 * To run a query within a React component, call `useMessageLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageLibraryQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      sign: // value for 'sign'
 *      type: // value for 'type'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMessageLibraryQuery(baseOptions?: Apollo.QueryHookOptions<MessageLibraryQuery, MessageLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageLibraryQuery, MessageLibraryQueryVariables>(MessageLibraryDocument, options);
      }
export function useMessageLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageLibraryQuery, MessageLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageLibraryQuery, MessageLibraryQueryVariables>(MessageLibraryDocument, options);
        }
export type MessageLibraryQueryHookResult = ReturnType<typeof useMessageLibraryQuery>;
export type MessageLibraryLazyQueryHookResult = ReturnType<typeof useMessageLibraryLazyQuery>;
export type MessageLibraryQueryResult = Apollo.QueryResult<MessageLibraryQuery, MessageLibraryQueryVariables>;
export function refetchMessageLibraryQuery(variables?: MessageLibraryQueryVariables) {
      return { query: MessageLibraryDocument, variables: variables }
    }
export const SignSettingsDocument = gql`
    query SignSettings {
  signModuleSettings {
    ...SignSettings
  }
}
    ${SignSettingsFragmentDoc}`;

/**
 * __useSignSettingsQuery__
 *
 * To run a query within a React component, call `useSignSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SignSettingsQuery, SignSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignSettingsQuery, SignSettingsQueryVariables>(SignSettingsDocument, options);
      }
export function useSignSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignSettingsQuery, SignSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignSettingsQuery, SignSettingsQueryVariables>(SignSettingsDocument, options);
        }
export type SignSettingsQueryHookResult = ReturnType<typeof useSignSettingsQuery>;
export type SignSettingsLazyQueryHookResult = ReturnType<typeof useSignSettingsLazyQuery>;
export type SignSettingsQueryResult = Apollo.QueryResult<SignSettingsQuery, SignSettingsQueryVariables>;
export function refetchSignSettingsQuery(variables?: SignSettingsQueryVariables) {
      return { query: SignSettingsDocument, variables: variables }
    }
export const SignControllerFontListDocument = gql`
    query SignControllerFontList($id: ID!) {
  signControllerFonts(id: $id) {
    characterSpacing
    characterHeight
    fontFileName
    lineSpacing
    fontVersion
    fontNumber
    font
    id
  }
}
    `;

/**
 * __useSignControllerFontListQuery__
 *
 * To run a query within a React component, call `useSignControllerFontListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignControllerFontListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignControllerFontListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignControllerFontListQuery(baseOptions: Apollo.QueryHookOptions<SignControllerFontListQuery, SignControllerFontListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignControllerFontListQuery, SignControllerFontListQueryVariables>(SignControllerFontListDocument, options);
      }
export function useSignControllerFontListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignControllerFontListQuery, SignControllerFontListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignControllerFontListQuery, SignControllerFontListQueryVariables>(SignControllerFontListDocument, options);
        }
export type SignControllerFontListQueryHookResult = ReturnType<typeof useSignControllerFontListQuery>;
export type SignControllerFontListLazyQueryHookResult = ReturnType<typeof useSignControllerFontListLazyQuery>;
export type SignControllerFontListQueryResult = Apollo.QueryResult<SignControllerFontListQuery, SignControllerFontListQueryVariables>;
export function refetchSignControllerFontListQuery(variables: SignControllerFontListQueryVariables) {
      return { query: SignControllerFontListDocument, variables: variables }
    }
export const SignControllerMessagesDocument = gql`
    query SignControllerMessages($id: ID!) {
  signControllerMessages(id: $id) {
    ...SignMessage
  }
}
    ${SignMessageFragmentDoc}`;

/**
 * __useSignControllerMessagesQuery__
 *
 * To run a query within a React component, call `useSignControllerMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignControllerMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignControllerMessagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignControllerMessagesQuery(baseOptions: Apollo.QueryHookOptions<SignControllerMessagesQuery, SignControllerMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignControllerMessagesQuery, SignControllerMessagesQueryVariables>(SignControllerMessagesDocument, options);
      }
export function useSignControllerMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignControllerMessagesQuery, SignControllerMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignControllerMessagesQuery, SignControllerMessagesQueryVariables>(SignControllerMessagesDocument, options);
        }
export type SignControllerMessagesQueryHookResult = ReturnType<typeof useSignControllerMessagesQuery>;
export type SignControllerMessagesLazyQueryHookResult = ReturnType<typeof useSignControllerMessagesLazyQuery>;
export type SignControllerMessagesQueryResult = Apollo.QueryResult<SignControllerMessagesQuery, SignControllerMessagesQueryVariables>;
export function refetchSignControllerMessagesQuery(variables: SignControllerMessagesQueryVariables) {
      return { query: SignControllerMessagesDocument, variables: variables }
    }
export const SignControllerGraphicsDocument = gql`
    query SignControllerGraphics($id: ID!) {
  signControllerGraphics(id: $id) {
    height
    width
    image
    name
    slot
    id
  }
}
    `;

/**
 * __useSignControllerGraphicsQuery__
 *
 * To run a query within a React component, call `useSignControllerGraphicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignControllerGraphicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignControllerGraphicsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignControllerGraphicsQuery(baseOptions: Apollo.QueryHookOptions<SignControllerGraphicsQuery, SignControllerGraphicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignControllerGraphicsQuery, SignControllerGraphicsQueryVariables>(SignControllerGraphicsDocument, options);
      }
export function useSignControllerGraphicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignControllerGraphicsQuery, SignControllerGraphicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignControllerGraphicsQuery, SignControllerGraphicsQueryVariables>(SignControllerGraphicsDocument, options);
        }
export type SignControllerGraphicsQueryHookResult = ReturnType<typeof useSignControllerGraphicsQuery>;
export type SignControllerGraphicsLazyQueryHookResult = ReturnType<typeof useSignControllerGraphicsLazyQuery>;
export type SignControllerGraphicsQueryResult = Apollo.QueryResult<SignControllerGraphicsQuery, SignControllerGraphicsQueryVariables>;
export function refetchSignControllerGraphicsQuery(variables: SignControllerGraphicsQueryVariables) {
      return { query: SignControllerGraphicsDocument, variables: variables }
    }
export const GetSignCapabilitiesListDocument = gql`
    query GetSignCapabilitiesList($filters: [FilterInput!]) {
  signs(filters: $filters, limit: 10000) {
    edges {
      node {
        capabilities
        id
      }
    }
  }
}
    `;

/**
 * __useGetSignCapabilitiesListQuery__
 *
 * To run a query within a React component, call `useGetSignCapabilitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignCapabilitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignCapabilitiesListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSignCapabilitiesListQuery(baseOptions?: Apollo.QueryHookOptions<GetSignCapabilitiesListQuery, GetSignCapabilitiesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignCapabilitiesListQuery, GetSignCapabilitiesListQueryVariables>(GetSignCapabilitiesListDocument, options);
      }
export function useGetSignCapabilitiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignCapabilitiesListQuery, GetSignCapabilitiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignCapabilitiesListQuery, GetSignCapabilitiesListQueryVariables>(GetSignCapabilitiesListDocument, options);
        }
export type GetSignCapabilitiesListQueryHookResult = ReturnType<typeof useGetSignCapabilitiesListQuery>;
export type GetSignCapabilitiesListLazyQueryHookResult = ReturnType<typeof useGetSignCapabilitiesListLazyQuery>;
export type GetSignCapabilitiesListQueryResult = Apollo.QueryResult<GetSignCapabilitiesListQuery, GetSignCapabilitiesListQueryVariables>;
export function refetchGetSignCapabilitiesListQuery(variables?: GetSignCapabilitiesListQueryVariables) {
      return { query: GetSignCapabilitiesListDocument, variables: variables }
    }
export const SignMultiPostListDocument = gql`
    query SignMultiPostList($filters: [FilterInput!]) {
  signs(filters: $filters, limit: 10000) {
    edges {
      node {
        capabilities
        readOnly
        id
      }
    }
  }
}
    `;

/**
 * __useSignMultiPostListQuery__
 *
 * To run a query within a React component, call `useSignMultiPostListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMultiPostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMultiPostListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSignMultiPostListQuery(baseOptions?: Apollo.QueryHookOptions<SignMultiPostListQuery, SignMultiPostListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMultiPostListQuery, SignMultiPostListQueryVariables>(SignMultiPostListDocument, options);
      }
export function useSignMultiPostListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMultiPostListQuery, SignMultiPostListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMultiPostListQuery, SignMultiPostListQueryVariables>(SignMultiPostListDocument, options);
        }
export type SignMultiPostListQueryHookResult = ReturnType<typeof useSignMultiPostListQuery>;
export type SignMultiPostListLazyQueryHookResult = ReturnType<typeof useSignMultiPostListLazyQuery>;
export type SignMultiPostListQueryResult = Apollo.QueryResult<SignMultiPostListQuery, SignMultiPostListQueryVariables>;
export function refetchSignMultiPostListQuery(variables?: SignMultiPostListQueryVariables) {
      return { query: SignMultiPostListDocument, variables: variables }
    }
export const SignSelectListDocument = gql`
    query SignSelectList {
  signs(limit: 10000) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useSignSelectListQuery__
 *
 * To run a query within a React component, call `useSignSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignSelectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignSelectListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignSelectListQuery(baseOptions?: Apollo.QueryHookOptions<SignSelectListQuery, SignSelectListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignSelectListQuery, SignSelectListQueryVariables>(SignSelectListDocument, options);
      }
export function useSignSelectListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignSelectListQuery, SignSelectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignSelectListQuery, SignSelectListQueryVariables>(SignSelectListDocument, options);
        }
export type SignSelectListQueryHookResult = ReturnType<typeof useSignSelectListQuery>;
export type SignSelectListLazyQueryHookResult = ReturnType<typeof useSignSelectListLazyQuery>;
export type SignSelectListQueryResult = Apollo.QueryResult<SignSelectListQuery, SignSelectListQueryVariables>;
export function refetchSignSelectListQuery(variables?: SignSelectListQueryVariables) {
      return { query: SignSelectListDocument, variables: variables }
    }
export const SignReadOnlyListDocument = gql`
    query SignReadOnlyList($filters: [FilterInput!]) {
  signs(filters: $filters, limit: 10000) {
    edges {
      node {
        external
        readOnly
        id
      }
    }
  }
}
    `;

/**
 * __useSignReadOnlyListQuery__
 *
 * To run a query within a React component, call `useSignReadOnlyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignReadOnlyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignReadOnlyListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSignReadOnlyListQuery(baseOptions?: Apollo.QueryHookOptions<SignReadOnlyListQuery, SignReadOnlyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignReadOnlyListQuery, SignReadOnlyListQueryVariables>(SignReadOnlyListDocument, options);
      }
export function useSignReadOnlyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignReadOnlyListQuery, SignReadOnlyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignReadOnlyListQuery, SignReadOnlyListQueryVariables>(SignReadOnlyListDocument, options);
        }
export type SignReadOnlyListQueryHookResult = ReturnType<typeof useSignReadOnlyListQuery>;
export type SignReadOnlyListLazyQueryHookResult = ReturnType<typeof useSignReadOnlyListLazyQuery>;
export type SignReadOnlyListQueryResult = Apollo.QueryResult<SignReadOnlyListQuery, SignReadOnlyListQueryVariables>;
export function refetchSignReadOnlyListQuery(variables?: SignReadOnlyListQueryVariables) {
      return { query: SignReadOnlyListDocument, variables: variables }
    }
export const NearbySignsByPointDocument = gql`
    query NearbySignsByPoint($x: Float!, $y: Float!, $thresholdMiles: Float, $integrationType: IntegrationType = SIGN) {
  nearbyIntegrationsByPoint(
    x: $x
    y: $y
    thresholdMiles: $thresholdMiles
    integrationType: $integrationType
  ) {
    id
    state {
      current
    }
  }
}
    `;

/**
 * __useNearbySignsByPointQuery__
 *
 * To run a query within a React component, call `useNearbySignsByPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useNearbySignsByPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNearbySignsByPointQuery({
 *   variables: {
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      thresholdMiles: // value for 'thresholdMiles'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useNearbySignsByPointQuery(baseOptions: Apollo.QueryHookOptions<NearbySignsByPointQuery, NearbySignsByPointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NearbySignsByPointQuery, NearbySignsByPointQueryVariables>(NearbySignsByPointDocument, options);
      }
export function useNearbySignsByPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NearbySignsByPointQuery, NearbySignsByPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NearbySignsByPointQuery, NearbySignsByPointQueryVariables>(NearbySignsByPointDocument, options);
        }
export type NearbySignsByPointQueryHookResult = ReturnType<typeof useNearbySignsByPointQuery>;
export type NearbySignsByPointLazyQueryHookResult = ReturnType<typeof useNearbySignsByPointLazyQuery>;
export type NearbySignsByPointQueryResult = Apollo.QueryResult<NearbySignsByPointQuery, NearbySignsByPointQueryVariables>;
export function refetchNearbySignsByPointQuery(variables: NearbySignsByPointQueryVariables) {
      return { query: NearbySignsByPointDocument, variables: variables }
    }
export const SignListUpdatedDocument = gql`
    subscription SignListUpdated($ids: [ID!]!) {
  signUpdated(ids: $ids) {
    ...SignList
  }
}
    ${SignListFragmentDoc}`;

/**
 * __useSignListUpdatedSubscription__
 *
 * To run a query within a React component, call `useSignListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSignListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignListUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSignListUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SignListUpdatedSubscription, SignListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SignListUpdatedSubscription, SignListUpdatedSubscriptionVariables>(SignListUpdatedDocument, options);
      }
export type SignListUpdatedSubscriptionHookResult = ReturnType<typeof useSignListUpdatedSubscription>;
export type SignListUpdatedSubscriptionResult = Apollo.SubscriptionResult<SignListUpdatedSubscription>;
export const SignMessagesDocument = gql`
    query SignMessages($filters: [FilterInput!], $type: SignMessageType, $sortOrder: SortOrder, $searchText: String, $sortField: String, $before: String, $after: String, $limit: Int, $sign: ID!) {
  signMessageLibrary(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after, sign: $sign, type: $type}
  ) {
    edges {
      node {
        ...SignLibraryMessage
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignLibraryMessageFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignMessagesQuery__
 *
 * To run a query within a React component, call `useSignMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      type: // value for 'type'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      sign: // value for 'sign'
 *   },
 * });
 */
export function useSignMessagesQuery(baseOptions: Apollo.QueryHookOptions<SignMessagesQuery, SignMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessagesQuery, SignMessagesQueryVariables>(SignMessagesDocument, options);
      }
export function useSignMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessagesQuery, SignMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessagesQuery, SignMessagesQueryVariables>(SignMessagesDocument, options);
        }
export type SignMessagesQueryHookResult = ReturnType<typeof useSignMessagesQuery>;
export type SignMessagesLazyQueryHookResult = ReturnType<typeof useSignMessagesLazyQuery>;
export type SignMessagesQueryResult = Apollo.QueryResult<SignMessagesQuery, SignMessagesQueryVariables>;
export function refetchSignMessagesQuery(variables: SignMessagesQueryVariables) {
      return { query: SignMessagesDocument, variables: variables }
    }
export const SignMessageLibraryDocument = gql`
    query SignMessageLibrary($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $type: SignMessageType, $searchText: String, $limit: Int = 10, $before: String, $after: String, $sign: ID) {
  signMessages(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit, sign: $sign, type: $type}
  ) {
    edges {
      node {
        ...SignLibraryMessage
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignLibraryMessageFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignMessageLibraryQuery__
 *
 * To run a query within a React component, call `useSignMessageLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessageLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessageLibraryQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      type: // value for 'type'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sign: // value for 'sign'
 *   },
 * });
 */
export function useSignMessageLibraryQuery(baseOptions?: Apollo.QueryHookOptions<SignMessageLibraryQuery, SignMessageLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessageLibraryQuery, SignMessageLibraryQueryVariables>(SignMessageLibraryDocument, options);
      }
export function useSignMessageLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessageLibraryQuery, SignMessageLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessageLibraryQuery, SignMessageLibraryQueryVariables>(SignMessageLibraryDocument, options);
        }
export type SignMessageLibraryQueryHookResult = ReturnType<typeof useSignMessageLibraryQuery>;
export type SignMessageLibraryLazyQueryHookResult = ReturnType<typeof useSignMessageLibraryLazyQuery>;
export type SignMessageLibraryQueryResult = Apollo.QueryResult<SignMessageLibraryQuery, SignMessageLibraryQueryVariables>;
export function refetchSignMessageLibraryQuery(variables?: SignMessageLibraryQueryVariables) {
      return { query: SignMessageLibraryDocument, variables: variables }
    }
export const SignMessageHistoryDocument = gql`
    query SignMessageHistory($sortOrder: SortOrder = DESCENDING, $sortField: String = "timePosted", $filters: [FilterInput!], $startDateTime: DateTime, $endDateTime: DateTime, $association: String, $searchText: String, $limit: Int = 10, $before: String, $after: String, $id: ID!) {
  signMessageHistory(
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    association: $association
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
    id: $id
  ) {
    edges {
      node {
        ...SignMessageHistory
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${SignMessageHistoryFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignMessageHistoryQuery__
 *
 * To run a query within a React component, call `useSignMessageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessageHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessageHistoryQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      association: // value for 'association'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignMessageHistoryQuery(baseOptions: Apollo.QueryHookOptions<SignMessageHistoryQuery, SignMessageHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessageHistoryQuery, SignMessageHistoryQueryVariables>(SignMessageHistoryDocument, options);
      }
export function useSignMessageHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessageHistoryQuery, SignMessageHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessageHistoryQuery, SignMessageHistoryQueryVariables>(SignMessageHistoryDocument, options);
        }
export type SignMessageHistoryQueryHookResult = ReturnType<typeof useSignMessageHistoryQuery>;
export type SignMessageHistoryLazyQueryHookResult = ReturnType<typeof useSignMessageHistoryLazyQuery>;
export type SignMessageHistoryQueryResult = Apollo.QueryResult<SignMessageHistoryQuery, SignMessageHistoryQueryVariables>;
export function refetchSignMessageHistoryQuery(variables: SignMessageHistoryQueryVariables) {
      return { query: SignMessageHistoryDocument, variables: variables }
    }
export const SignFontDocument = gql`
    query SignFont($hash: ID!) {
  signFont(id: $hash) {
    characterSpacing
    characterHeight
    fontFileName
    lineSpacing
    fontVersion
    font
    id
  }
}
    `;

/**
 * __useSignFontQuery__
 *
 * To run a query within a React component, call `useSignFontQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignFontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignFontQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useSignFontQuery(baseOptions: Apollo.QueryHookOptions<SignFontQuery, SignFontQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignFontQuery, SignFontQueryVariables>(SignFontDocument, options);
      }
export function useSignFontLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignFontQuery, SignFontQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignFontQuery, SignFontQueryVariables>(SignFontDocument, options);
        }
export type SignFontQueryHookResult = ReturnType<typeof useSignFontQuery>;
export type SignFontLazyQueryHookResult = ReturnType<typeof useSignFontLazyQuery>;
export type SignFontQueryResult = Apollo.QueryResult<SignFontQuery, SignFontQueryVariables>;
export function refetchSignFontQuery(variables: SignFontQueryVariables) {
      return { query: SignFontDocument, variables: variables }
    }
export const SignFontsDocument = gql`
    query SignFonts {
  signFonts {
    characterSpacing
    characterHeight
    fontFileName
    lineSpacing
    fontVersion
    font
    id
  }
}
    `;

/**
 * __useSignFontsQuery__
 *
 * To run a query within a React component, call `useSignFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignFontsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignFontsQuery(baseOptions?: Apollo.QueryHookOptions<SignFontsQuery, SignFontsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignFontsQuery, SignFontsQueryVariables>(SignFontsDocument, options);
      }
export function useSignFontsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignFontsQuery, SignFontsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignFontsQuery, SignFontsQueryVariables>(SignFontsDocument, options);
        }
export type SignFontsQueryHookResult = ReturnType<typeof useSignFontsQuery>;
export type SignFontsLazyQueryHookResult = ReturnType<typeof useSignFontsLazyQuery>;
export type SignFontsQueryResult = Apollo.QueryResult<SignFontsQuery, SignFontsQueryVariables>;
export function refetchSignFontsQuery(variables?: SignFontsQueryVariables) {
      return { query: SignFontsDocument, variables: variables }
    }
export const SignMessagePrioritiesDocument = gql`
    query SignMessagePriorities {
  signMessagePriorities {
    travelTimeDefault
    messageDefault
    description
    priority
    name
    id
  }
}
    `;

/**
 * __useSignMessagePrioritiesQuery__
 *
 * To run a query within a React component, call `useSignMessagePrioritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessagePrioritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessagePrioritiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignMessagePrioritiesQuery(baseOptions?: Apollo.QueryHookOptions<SignMessagePrioritiesQuery, SignMessagePrioritiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessagePrioritiesQuery, SignMessagePrioritiesQueryVariables>(SignMessagePrioritiesDocument, options);
      }
export function useSignMessagePrioritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessagePrioritiesQuery, SignMessagePrioritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessagePrioritiesQuery, SignMessagePrioritiesQueryVariables>(SignMessagePrioritiesDocument, options);
        }
export type SignMessagePrioritiesQueryHookResult = ReturnType<typeof useSignMessagePrioritiesQuery>;
export type SignMessagePrioritiesLazyQueryHookResult = ReturnType<typeof useSignMessagePrioritiesLazyQuery>;
export type SignMessagePrioritiesQueryResult = Apollo.QueryResult<SignMessagePrioritiesQuery, SignMessagePrioritiesQueryVariables>;
export function refetchSignMessagePrioritiesQuery(variables?: SignMessagePrioritiesQueryVariables) {
      return { query: SignMessagePrioritiesDocument, variables: variables }
    }
export const SignMessagePriorityOptionsDocument = gql`
    query SignMessagePriorityOptions {
  signMessagePriorities {
    name
    priority
    id
  }
}
    `;

/**
 * __useSignMessagePriorityOptionsQuery__
 *
 * To run a query within a React component, call `useSignMessagePriorityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessagePriorityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessagePriorityOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignMessagePriorityOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SignMessagePriorityOptionsQuery, SignMessagePriorityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessagePriorityOptionsQuery, SignMessagePriorityOptionsQueryVariables>(SignMessagePriorityOptionsDocument, options);
      }
export function useSignMessagePriorityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessagePriorityOptionsQuery, SignMessagePriorityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessagePriorityOptionsQuery, SignMessagePriorityOptionsQueryVariables>(SignMessagePriorityOptionsDocument, options);
        }
export type SignMessagePriorityOptionsQueryHookResult = ReturnType<typeof useSignMessagePriorityOptionsQuery>;
export type SignMessagePriorityOptionsLazyQueryHookResult = ReturnType<typeof useSignMessagePriorityOptionsLazyQuery>;
export type SignMessagePriorityOptionsQueryResult = Apollo.QueryResult<SignMessagePriorityOptionsQuery, SignMessagePriorityOptionsQueryVariables>;
export function refetchSignMessagePriorityOptionsQuery(variables?: SignMessagePriorityOptionsQueryVariables) {
      return { query: SignMessagePriorityOptionsDocument, variables: variables }
    }
export const SignCommandMessageDocument = gql`
    query SignCommandMessage($ids: [ID!]!, $command: String!) {
  signCommandMessage(ids: $ids, command: $command) {
    sign
    message {
      ...SignMessage
    }
  }
}
    ${SignMessageFragmentDoc}`;

/**
 * __useSignCommandMessageQuery__
 *
 * To run a query within a React component, call `useSignCommandMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignCommandMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignCommandMessageQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      command: // value for 'command'
 *   },
 * });
 */
export function useSignCommandMessageQuery(baseOptions: Apollo.QueryHookOptions<SignCommandMessageQuery, SignCommandMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignCommandMessageQuery, SignCommandMessageQueryVariables>(SignCommandMessageDocument, options);
      }
export function useSignCommandMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignCommandMessageQuery, SignCommandMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignCommandMessageQuery, SignCommandMessageQueryVariables>(SignCommandMessageDocument, options);
        }
export type SignCommandMessageQueryHookResult = ReturnType<typeof useSignCommandMessageQuery>;
export type SignCommandMessageLazyQueryHookResult = ReturnType<typeof useSignCommandMessageLazyQuery>;
export type SignCommandMessageQueryResult = Apollo.QueryResult<SignCommandMessageQuery, SignCommandMessageQueryVariables>;
export function refetchSignCommandMessageQuery(variables: SignCommandMessageQueryVariables) {
      return { query: SignCommandMessageDocument, variables: variables }
    }
export const SignSelectionListDocument = gql`
    query SignSelectionList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  signs(
    searchText: $searchText
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
    before: $before
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        referencePoint
        laneDirection
        lanePosition
        direction
        laneType
        displayType {
          ...SignDisplayType
        }
        road
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignDisplayTypeFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignSelectionListQuery__
 *
 * To run a query within a React component, call `useSignSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignSelectionListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSignSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<SignSelectionListQuery, SignSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignSelectionListQuery, SignSelectionListQueryVariables>(SignSelectionListDocument, options);
      }
export function useSignSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignSelectionListQuery, SignSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignSelectionListQuery, SignSelectionListQueryVariables>(SignSelectionListDocument, options);
        }
export type SignSelectionListQueryHookResult = ReturnType<typeof useSignSelectionListQuery>;
export type SignSelectionListLazyQueryHookResult = ReturnType<typeof useSignSelectionListLazyQuery>;
export type SignSelectionListQueryResult = Apollo.QueryResult<SignSelectionListQuery, SignSelectionListQueryVariables>;
export function refetchSignSelectionListQuery(variables?: SignSelectionListQueryVariables) {
      return { query: SignSelectionListDocument, variables: variables }
    }
export const SignIdsDocument = gql`
    query SignIds($searchText: String, $filters: [FilterInput!]) {
  signMapEntities(searchText: $searchText, filters: $filters)
}
    `;

/**
 * __useSignIdsQuery__
 *
 * To run a query within a React component, call `useSignIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignIdsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSignIdsQuery(baseOptions?: Apollo.QueryHookOptions<SignIdsQuery, SignIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignIdsQuery, SignIdsQueryVariables>(SignIdsDocument, options);
      }
export function useSignIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignIdsQuery, SignIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignIdsQuery, SignIdsQueryVariables>(SignIdsDocument, options);
        }
export type SignIdsQueryHookResult = ReturnType<typeof useSignIdsQuery>;
export type SignIdsLazyQueryHookResult = ReturnType<typeof useSignIdsLazyQuery>;
export type SignIdsQueryResult = Apollo.QueryResult<SignIdsQuery, SignIdsQueryVariables>;
export function refetchSignIdsQuery(variables?: SignIdsQueryVariables) {
      return { query: SignIdsDocument, variables: variables }
    }
export const GetLedEditorManagedGraphicsDocument = gql`
    query GetLedEditorManagedGraphics($id: ID!) {
  signControllerGraphics(id: $id) {
    height
    width
    image
    name
    slot
    id
  }
}
    `;

/**
 * __useGetLedEditorManagedGraphicsQuery__
 *
 * To run a query within a React component, call `useGetLedEditorManagedGraphicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedEditorManagedGraphicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedEditorManagedGraphicsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLedEditorManagedGraphicsQuery(baseOptions: Apollo.QueryHookOptions<GetLedEditorManagedGraphicsQuery, GetLedEditorManagedGraphicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedEditorManagedGraphicsQuery, GetLedEditorManagedGraphicsQueryVariables>(GetLedEditorManagedGraphicsDocument, options);
      }
export function useGetLedEditorManagedGraphicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLedEditorManagedGraphicsQuery, GetLedEditorManagedGraphicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedEditorManagedGraphicsQuery, GetLedEditorManagedGraphicsQueryVariables>(GetLedEditorManagedGraphicsDocument, options);
        }
export type GetLedEditorManagedGraphicsQueryHookResult = ReturnType<typeof useGetLedEditorManagedGraphicsQuery>;
export type GetLedEditorManagedGraphicsLazyQueryHookResult = ReturnType<typeof useGetLedEditorManagedGraphicsLazyQuery>;
export type GetLedEditorManagedGraphicsQueryResult = Apollo.QueryResult<GetLedEditorManagedGraphicsQuery, GetLedEditorManagedGraphicsQueryVariables>;
export function refetchGetLedEditorManagedGraphicsQuery(variables: GetLedEditorManagedGraphicsQueryVariables) {
      return { query: GetLedEditorManagedGraphicsDocument, variables: variables }
    }
export const SignGroupMapEntitiesDocument = gql`
    query SignGroupMapEntities($searchText: String, $types: [SignGroupType!], $filters: [FilterInput!]) {
  signGroupMapEntities(searchText: $searchText, types: $types, filters: $filters)
}
    `;

/**
 * __useSignGroupMapEntitiesQuery__
 *
 * To run a query within a React component, call `useSignGroupMapEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignGroupMapEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignGroupMapEntitiesQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      types: // value for 'types'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSignGroupMapEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<SignGroupMapEntitiesQuery, SignGroupMapEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignGroupMapEntitiesQuery, SignGroupMapEntitiesQueryVariables>(SignGroupMapEntitiesDocument, options);
      }
export function useSignGroupMapEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignGroupMapEntitiesQuery, SignGroupMapEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignGroupMapEntitiesQuery, SignGroupMapEntitiesQueryVariables>(SignGroupMapEntitiesDocument, options);
        }
export type SignGroupMapEntitiesQueryHookResult = ReturnType<typeof useSignGroupMapEntitiesQuery>;
export type SignGroupMapEntitiesLazyQueryHookResult = ReturnType<typeof useSignGroupMapEntitiesLazyQuery>;
export type SignGroupMapEntitiesQueryResult = Apollo.QueryResult<SignGroupMapEntitiesQuery, SignGroupMapEntitiesQueryVariables>;
export function refetchSignGroupMapEntitiesQuery(variables?: SignGroupMapEntitiesQueryVariables) {
      return { query: SignGroupMapEntitiesDocument, variables: variables }
    }
export const SignGroupUpdatedDocument = gql`
    subscription SignGroupUpdated($ids: [ID!], $types: [SignGroupType!]) {
  signGroupUpdated(ids: $ids, types: $types) {
    id
  }
}
    `;

/**
 * __useSignGroupUpdatedSubscription__
 *
 * To run a query within a React component, call `useSignGroupUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSignGroupUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignGroupUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useSignGroupUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SignGroupUpdatedSubscription, SignGroupUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SignGroupUpdatedSubscription, SignGroupUpdatedSubscriptionVariables>(SignGroupUpdatedDocument, options);
      }
export type SignGroupUpdatedSubscriptionHookResult = ReturnType<typeof useSignGroupUpdatedSubscription>;
export type SignGroupUpdatedSubscriptionResult = Apollo.SubscriptionResult<SignGroupUpdatedSubscription>;
export const SignInterlockValidateDocument = gql`
    query SignInterlockValidate($input: [SignInterlockInput!]!) {
  signInterlockValidate(input: $input) {
    requiresAcknowledgement
    acknowledgementMessage
    requiresApproval
    hasInterlock
    failure
    id
  }
}
    `;

/**
 * __useSignInterlockValidateQuery__
 *
 * To run a query within a React component, call `useSignInterlockValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignInterlockValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignInterlockValidateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInterlockValidateQuery(baseOptions: Apollo.QueryHookOptions<SignInterlockValidateQuery, SignInterlockValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignInterlockValidateQuery, SignInterlockValidateQueryVariables>(SignInterlockValidateDocument, options);
      }
export function useSignInterlockValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignInterlockValidateQuery, SignInterlockValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignInterlockValidateQuery, SignInterlockValidateQueryVariables>(SignInterlockValidateDocument, options);
        }
export type SignInterlockValidateQueryHookResult = ReturnType<typeof useSignInterlockValidateQuery>;
export type SignInterlockValidateLazyQueryHookResult = ReturnType<typeof useSignInterlockValidateLazyQuery>;
export type SignInterlockValidateQueryResult = Apollo.QueryResult<SignInterlockValidateQuery, SignInterlockValidateQueryVariables>;
export function refetchSignInterlockValidateQuery(variables: SignInterlockValidateQueryVariables) {
      return { query: SignInterlockValidateDocument, variables: variables }
    }
export const SignMessageFormDocument = gql`
    query SignMessageForm($id: ID!) {
  signMessage(id: $id) {
    ...SignMessageDetails
  }
}
    ${SignMessageDetailsFragmentDoc}`;

/**
 * __useSignMessageFormQuery__
 *
 * To run a query within a React component, call `useSignMessageFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessageFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessageFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignMessageFormQuery(baseOptions: Apollo.QueryHookOptions<SignMessageFormQuery, SignMessageFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessageFormQuery, SignMessageFormQueryVariables>(SignMessageFormDocument, options);
      }
export function useSignMessageFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessageFormQuery, SignMessageFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessageFormQuery, SignMessageFormQueryVariables>(SignMessageFormDocument, options);
        }
export type SignMessageFormQueryHookResult = ReturnType<typeof useSignMessageFormQuery>;
export type SignMessageFormLazyQueryHookResult = ReturnType<typeof useSignMessageFormLazyQuery>;
export type SignMessageFormQueryResult = Apollo.QueryResult<SignMessageFormQuery, SignMessageFormQueryVariables>;
export function refetchSignMessageFormQuery(variables: SignMessageFormQueryVariables) {
      return { query: SignMessageFormDocument, variables: variables }
    }
export const SignMessageListDocument = gql`
    query SignMessageList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $type: SignMessageType, $searchText: String, $searchFields: [String!] = ["name", "sign", "message.priority", "message"], $limit: Int = 10, $before: String, $after: String) {
  signMessages(
    query: {searchText: $searchText, searchFields: $searchFields, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after, type: $type}
  ) {
    edges {
      node {
        ...SignMessageDetails
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignMessageDetailsFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSignMessageListQuery__
 *
 * To run a query within a React component, call `useSignMessageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignMessageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignMessageListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      type: // value for 'type'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSignMessageListQuery(baseOptions?: Apollo.QueryHookOptions<SignMessageListQuery, SignMessageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignMessageListQuery, SignMessageListQueryVariables>(SignMessageListDocument, options);
      }
export function useSignMessageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignMessageListQuery, SignMessageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignMessageListQuery, SignMessageListQueryVariables>(SignMessageListDocument, options);
        }
export type SignMessageListQueryHookResult = ReturnType<typeof useSignMessageListQuery>;
export type SignMessageListLazyQueryHookResult = ReturnType<typeof useSignMessageListLazyQuery>;
export type SignMessageListQueryResult = Apollo.QueryResult<SignMessageListQuery, SignMessageListQueryVariables>;
export function refetchSignMessageListQuery(variables?: SignMessageListQueryVariables) {
      return { query: SignMessageListDocument, variables: variables }
    }
export const SignDetailsDocument = gql`
    query SignDetails($id: ID!) {
  sign(id: $id) {
    ...SignDetails
  }
}
    ${SignDetailsFragmentDoc}`;

/**
 * __useSignDetailsQuery__
 *
 * To run a query within a React component, call `useSignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignDetailsQuery(baseOptions: Apollo.QueryHookOptions<SignDetailsQuery, SignDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignDetailsQuery, SignDetailsQueryVariables>(SignDetailsDocument, options);
      }
export function useSignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignDetailsQuery, SignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignDetailsQuery, SignDetailsQueryVariables>(SignDetailsDocument, options);
        }
export type SignDetailsQueryHookResult = ReturnType<typeof useSignDetailsQuery>;
export type SignDetailsLazyQueryHookResult = ReturnType<typeof useSignDetailsLazyQuery>;
export type SignDetailsQueryResult = Apollo.QueryResult<SignDetailsQuery, SignDetailsQueryVariables>;
export function refetchSignDetailsQuery(variables: SignDetailsQueryVariables) {
      return { query: SignDetailsDocument, variables: variables }
    }
export const SignGraphicNumbersDocument = gql`
    query SignGraphicNumbers($id: ID!) {
  sign(id: $id) {
    graphics {
      number
      label
    }
  }
}
    `;

/**
 * __useSignGraphicNumbersQuery__
 *
 * To run a query within a React component, call `useSignGraphicNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignGraphicNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignGraphicNumbersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignGraphicNumbersQuery(baseOptions: Apollo.QueryHookOptions<SignGraphicNumbersQuery, SignGraphicNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignGraphicNumbersQuery, SignGraphicNumbersQueryVariables>(SignGraphicNumbersDocument, options);
      }
export function useSignGraphicNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignGraphicNumbersQuery, SignGraphicNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignGraphicNumbersQuery, SignGraphicNumbersQueryVariables>(SignGraphicNumbersDocument, options);
        }
export type SignGraphicNumbersQueryHookResult = ReturnType<typeof useSignGraphicNumbersQuery>;
export type SignGraphicNumbersLazyQueryHookResult = ReturnType<typeof useSignGraphicNumbersLazyQuery>;
export type SignGraphicNumbersQueryResult = Apollo.QueryResult<SignGraphicNumbersQuery, SignGraphicNumbersQueryVariables>;
export function refetchSignGraphicNumbersQuery(variables: SignGraphicNumbersQueryVariables) {
      return { query: SignGraphicNumbersDocument, variables: variables }
    }
export const SignNameDocument = gql`
    query SignName($id: ID!) {
  sign(id: $id) {
    name
  }
}
    `;

/**
 * __useSignNameQuery__
 *
 * To run a query within a React component, call `useSignNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignNameQuery(baseOptions: Apollo.QueryHookOptions<SignNameQuery, SignNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignNameQuery, SignNameQueryVariables>(SignNameDocument, options);
      }
export function useSignNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignNameQuery, SignNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignNameQuery, SignNameQueryVariables>(SignNameDocument, options);
        }
export type SignNameQueryHookResult = ReturnType<typeof useSignNameQuery>;
export type SignNameLazyQueryHookResult = ReturnType<typeof useSignNameLazyQuery>;
export type SignNameQueryResult = Apollo.QueryResult<SignNameQuery, SignNameQueryVariables>;
export function refetchSignNameQuery(variables: SignNameQueryVariables) {
      return { query: SignNameDocument, variables: variables }
    }
export const SignIntegrationsDocument = gql`
    query SignIntegrations($id: ID!) {
  signIntegrations(id: $id) {
    variables {
      label
      value
    }
    name
    type
    id
  }
}
    `;

/**
 * __useSignIntegrationsQuery__
 *
 * To run a query within a React component, call `useSignIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignIntegrationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<SignIntegrationsQuery, SignIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignIntegrationsQuery, SignIntegrationsQueryVariables>(SignIntegrationsDocument, options);
      }
export function useSignIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignIntegrationsQuery, SignIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignIntegrationsQuery, SignIntegrationsQueryVariables>(SignIntegrationsDocument, options);
        }
export type SignIntegrationsQueryHookResult = ReturnType<typeof useSignIntegrationsQuery>;
export type SignIntegrationsLazyQueryHookResult = ReturnType<typeof useSignIntegrationsLazyQuery>;
export type SignIntegrationsQueryResult = Apollo.QueryResult<SignIntegrationsQuery, SignIntegrationsQueryVariables>;
export function refetchSignIntegrationsQuery(variables: SignIntegrationsQueryVariables) {
      return { query: SignIntegrationsDocument, variables: variables }
    }
export const PricingSignIntegrationsDocument = gql`
    query PricingSignIntegrations($id: ID!) {
  getPricingSignIntegrations(id: $id) {
    variables {
      label
      value
    }
    name
    type
    id
  }
}
    `;

/**
 * __usePricingSignIntegrationsQuery__
 *
 * To run a query within a React component, call `usePricingSignIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingSignIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingSignIntegrationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePricingSignIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<PricingSignIntegrationsQuery, PricingSignIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricingSignIntegrationsQuery, PricingSignIntegrationsQueryVariables>(PricingSignIntegrationsDocument, options);
      }
export function usePricingSignIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricingSignIntegrationsQuery, PricingSignIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricingSignIntegrationsQuery, PricingSignIntegrationsQueryVariables>(PricingSignIntegrationsDocument, options);
        }
export type PricingSignIntegrationsQueryHookResult = ReturnType<typeof usePricingSignIntegrationsQuery>;
export type PricingSignIntegrationsLazyQueryHookResult = ReturnType<typeof usePricingSignIntegrationsLazyQuery>;
export type PricingSignIntegrationsQueryResult = Apollo.QueryResult<PricingSignIntegrationsQuery, PricingSignIntegrationsQueryVariables>;
export function refetchPricingSignIntegrationsQuery(variables: PricingSignIntegrationsQueryVariables) {
      return { query: PricingSignIntegrationsDocument, variables: variables }
    }
export const SignGateDelayTimesDocument = gql`
    query SignGateDelayTimes($id: ID!) {
  sign(id: $id) {
    gateOpenTime
    gateClosedTime
  }
}
    `;

/**
 * __useSignGateDelayTimesQuery__
 *
 * To run a query within a React component, call `useSignGateDelayTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignGateDelayTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignGateDelayTimesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignGateDelayTimesQuery(baseOptions: Apollo.QueryHookOptions<SignGateDelayTimesQuery, SignGateDelayTimesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignGateDelayTimesQuery, SignGateDelayTimesQueryVariables>(SignGateDelayTimesDocument, options);
      }
export function useSignGateDelayTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignGateDelayTimesQuery, SignGateDelayTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignGateDelayTimesQuery, SignGateDelayTimesQueryVariables>(SignGateDelayTimesDocument, options);
        }
export type SignGateDelayTimesQueryHookResult = ReturnType<typeof useSignGateDelayTimesQuery>;
export type SignGateDelayTimesLazyQueryHookResult = ReturnType<typeof useSignGateDelayTimesLazyQuery>;
export type SignGateDelayTimesQueryResult = Apollo.QueryResult<SignGateDelayTimesQuery, SignGateDelayTimesQueryVariables>;
export function refetchSignGateDelayTimesQuery(variables: SignGateDelayTimesQueryVariables) {
      return { query: SignGateDelayTimesDocument, variables: variables }
    }
export const TollRoadWidgetSignsDocument = gql`
    query TollRoadWidgetSigns($ids: Object!) {
  signs(
    sortField: "referencePoint"
    sortOrder: ASCENDING
    filters: [{field: "id", operator: IN, value: $ids}]
    limit: 10000
  ) {
    edges {
      node {
        name
        id
        communicationStatus
        backgroundColor
        foregroundColor
        referencePoint
        displayType {
          ...SignDisplayType
        }
        tests {
          ...SignTestsType
        }
        currentMessage {
          message {
            ...SignMessage
          }
        }
      }
    }
  }
}
    ${SignDisplayTypeFragmentDoc}
${SignTestsTypeFragmentDoc}
${SignMessageFragmentDoc}`;

/**
 * __useTollRoadWidgetSignsQuery__
 *
 * To run a query within a React component, call `useTollRoadWidgetSignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollRoadWidgetSignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollRoadWidgetSignsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTollRoadWidgetSignsQuery(baseOptions: Apollo.QueryHookOptions<TollRoadWidgetSignsQuery, TollRoadWidgetSignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollRoadWidgetSignsQuery, TollRoadWidgetSignsQueryVariables>(TollRoadWidgetSignsDocument, options);
      }
export function useTollRoadWidgetSignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollRoadWidgetSignsQuery, TollRoadWidgetSignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollRoadWidgetSignsQuery, TollRoadWidgetSignsQueryVariables>(TollRoadWidgetSignsDocument, options);
        }
export type TollRoadWidgetSignsQueryHookResult = ReturnType<typeof useTollRoadWidgetSignsQuery>;
export type TollRoadWidgetSignsLazyQueryHookResult = ReturnType<typeof useTollRoadWidgetSignsLazyQuery>;
export type TollRoadWidgetSignsQueryResult = Apollo.QueryResult<TollRoadWidgetSignsQuery, TollRoadWidgetSignsQueryVariables>;
export function refetchTollRoadWidgetSignsQuery(variables: TollRoadWidgetSignsQueryVariables) {
      return { query: TollRoadWidgetSignsDocument, variables: variables }
    }
export const SaveAtlasArchiveModuleSettingsDocument = gql`
    mutation SaveAtlasArchiveModuleSettings($settings: JSON!) {
  saveAtlasArchiveModuleSettings(settings: $settings)
}
    `;
export type SaveAtlasArchiveModuleSettingsMutationFn = Apollo.MutationFunction<SaveAtlasArchiveModuleSettingsMutation, SaveAtlasArchiveModuleSettingsMutationVariables>;

/**
 * __useSaveAtlasArchiveModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAtlasArchiveModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAtlasArchiveModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAtlasArchiveModuleSettingsMutation, { data, loading, error }] = useSaveAtlasArchiveModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAtlasArchiveModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAtlasArchiveModuleSettingsMutation, SaveAtlasArchiveModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAtlasArchiveModuleSettingsMutation, SaveAtlasArchiveModuleSettingsMutationVariables>(SaveAtlasArchiveModuleSettingsDocument, options);
      }
export type SaveAtlasArchiveModuleSettingsMutationHookResult = ReturnType<typeof useSaveAtlasArchiveModuleSettingsMutation>;
export type SaveAtlasArchiveModuleSettingsMutationResult = Apollo.MutationResult<SaveAtlasArchiveModuleSettingsMutation>;
export type SaveAtlasArchiveModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAtlasArchiveModuleSettingsMutation, SaveAtlasArchiveModuleSettingsMutationVariables>;
export const AtlasArchiveModuleSettingsDocument = gql`
    query AtlasArchiveModuleSettings($formViewName: String!) {
  atlasArchiveModuleSettings(formViewName: $formViewName) {
    id
    name
    views {
      id
      name
      views {
        ...FormViewFragment
        views {
          ...FormViewFragment
          views {
            ...FormViewFragment
          }
        }
      }
    }
    sections {
      ...ModuleFormSectionFragment
    }
    type
  }
}
    ${FormViewFragmentFragmentDoc}
${ModuleFormSectionFragmentFragmentDoc}`;

/**
 * __useAtlasArchiveModuleSettingsQuery__
 *
 * To run a query within a React component, call `useAtlasArchiveModuleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtlasArchiveModuleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtlasArchiveModuleSettingsQuery({
 *   variables: {
 *      formViewName: // value for 'formViewName'
 *   },
 * });
 */
export function useAtlasArchiveModuleSettingsQuery(baseOptions: Apollo.QueryHookOptions<AtlasArchiveModuleSettingsQuery, AtlasArchiveModuleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtlasArchiveModuleSettingsQuery, AtlasArchiveModuleSettingsQueryVariables>(AtlasArchiveModuleSettingsDocument, options);
      }
export function useAtlasArchiveModuleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtlasArchiveModuleSettingsQuery, AtlasArchiveModuleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtlasArchiveModuleSettingsQuery, AtlasArchiveModuleSettingsQueryVariables>(AtlasArchiveModuleSettingsDocument, options);
        }
export type AtlasArchiveModuleSettingsQueryHookResult = ReturnType<typeof useAtlasArchiveModuleSettingsQuery>;
export type AtlasArchiveModuleSettingsLazyQueryHookResult = ReturnType<typeof useAtlasArchiveModuleSettingsLazyQuery>;
export type AtlasArchiveModuleSettingsQueryResult = Apollo.QueryResult<AtlasArchiveModuleSettingsQuery, AtlasArchiveModuleSettingsQueryVariables>;
export function refetchAtlasArchiveModuleSettingsQuery(variables: AtlasArchiveModuleSettingsQueryVariables) {
      return { query: AtlasArchiveModuleSettingsDocument, variables: variables }
    }
export const KineticUserDocument = gql`
    query KineticUser {
  kineticUser {
    id
    username
    firstName
    lastName
    picture
    email
    preferences {
      key
      value
    }
    kineticPreferences {
      key
      value
    }
  }
  organizationPreferences {
    key
    value
  }
}
    `;

/**
 * __useKineticUserQuery__
 *
 * To run a query within a React component, call `useKineticUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useKineticUserQuery(baseOptions?: Apollo.QueryHookOptions<KineticUserQuery, KineticUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticUserQuery, KineticUserQueryVariables>(KineticUserDocument, options);
      }
export function useKineticUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticUserQuery, KineticUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticUserQuery, KineticUserQueryVariables>(KineticUserDocument, options);
        }
export type KineticUserQueryHookResult = ReturnType<typeof useKineticUserQuery>;
export type KineticUserLazyQueryHookResult = ReturnType<typeof useKineticUserLazyQuery>;
export type KineticUserQueryResult = Apollo.QueryResult<KineticUserQuery, KineticUserQueryVariables>;
export function refetchKineticUserQuery(variables?: KineticUserQueryVariables) {
      return { query: KineticUserDocument, variables: variables }
    }
export const GetKineticUserUsernameDocument = gql`
    query GetKineticUserUsername($id: ID!) {
  getKineticUser(id: $id) {
    username
  }
}
    `;

/**
 * __useGetKineticUserUsernameQuery__
 *
 * To run a query within a React component, call `useGetKineticUserUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKineticUserUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKineticUserUsernameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKineticUserUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetKineticUserUsernameQuery, GetKineticUserUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKineticUserUsernameQuery, GetKineticUserUsernameQueryVariables>(GetKineticUserUsernameDocument, options);
      }
export function useGetKineticUserUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKineticUserUsernameQuery, GetKineticUserUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKineticUserUsernameQuery, GetKineticUserUsernameQueryVariables>(GetKineticUserUsernameDocument, options);
        }
export type GetKineticUserUsernameQueryHookResult = ReturnType<typeof useGetKineticUserUsernameQuery>;
export type GetKineticUserUsernameLazyQueryHookResult = ReturnType<typeof useGetKineticUserUsernameLazyQuery>;
export type GetKineticUserUsernameQueryResult = Apollo.QueryResult<GetKineticUserUsernameQuery, GetKineticUserUsernameQueryVariables>;
export function refetchGetKineticUserUsernameQuery(variables: GetKineticUserUsernameQueryVariables) {
      return { query: GetKineticUserUsernameDocument, variables: variables }
    }
export const GetActiveUserListDocument = gql`
    query GetActiveUserList($sortOrder: SortOrder = ASCENDING, $sortField: String = "firstName", $limit: Int = 10, $after: String, $before: String, $searchText: String, $online: Boolean, $searchGroup: Boolean, $searchRole: Boolean) {
  users(
    sortOrder: $sortOrder
    limit: $limit
    after: $after
    before: $before
    sortField: $sortField
    searchText: $searchText
    online: $online
    searchGroup: $searchGroup
    searchRole: $searchRole
  ) {
    edges {
      node {
        ...KineticUserFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${KineticUserFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useGetActiveUserListQuery__
 *
 * To run a query within a React component, call `useGetActiveUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveUserListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      searchText: // value for 'searchText'
 *      online: // value for 'online'
 *      searchGroup: // value for 'searchGroup'
 *      searchRole: // value for 'searchRole'
 *   },
 * });
 */
export function useGetActiveUserListQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveUserListQuery, GetActiveUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveUserListQuery, GetActiveUserListQueryVariables>(GetActiveUserListDocument, options);
      }
export function useGetActiveUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveUserListQuery, GetActiveUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveUserListQuery, GetActiveUserListQueryVariables>(GetActiveUserListDocument, options);
        }
export type GetActiveUserListQueryHookResult = ReturnType<typeof useGetActiveUserListQuery>;
export type GetActiveUserListLazyQueryHookResult = ReturnType<typeof useGetActiveUserListLazyQuery>;
export type GetActiveUserListQueryResult = Apollo.QueryResult<GetActiveUserListQuery, GetActiveUserListQueryVariables>;
export function refetchGetActiveUserListQuery(variables?: GetActiveUserListQueryVariables) {
      return { query: GetActiveUserListDocument, variables: variables }
    }
export const GetDefaultMapConfigDocument = gql`
    query GetDefaultMapConfig {
  mapConfig(id: "DEFAULT_MAP_BOUNDS") {
    ...MapConfigFragment
  }
}
    ${MapConfigFragmentFragmentDoc}`;

/**
 * __useGetDefaultMapConfigQuery__
 *
 * To run a query within a React component, call `useGetDefaultMapConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultMapConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultMapConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultMapConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultMapConfigQuery, GetDefaultMapConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultMapConfigQuery, GetDefaultMapConfigQueryVariables>(GetDefaultMapConfigDocument, options);
      }
export function useGetDefaultMapConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultMapConfigQuery, GetDefaultMapConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultMapConfigQuery, GetDefaultMapConfigQueryVariables>(GetDefaultMapConfigDocument, options);
        }
export type GetDefaultMapConfigQueryHookResult = ReturnType<typeof useGetDefaultMapConfigQuery>;
export type GetDefaultMapConfigLazyQueryHookResult = ReturnType<typeof useGetDefaultMapConfigLazyQuery>;
export type GetDefaultMapConfigQueryResult = Apollo.QueryResult<GetDefaultMapConfigQuery, GetDefaultMapConfigQueryVariables>;
export function refetchGetDefaultMapConfigQuery(variables?: GetDefaultMapConfigQueryVariables) {
      return { query: GetDefaultMapConfigDocument, variables: variables }
    }
export const GetMapLayerConfigDocument = gql`
    query GetMapLayerConfig($id: ID!) {
  mapLayerConfig(id: $id) {
    ...MapLayerConfigFragment
  }
}
    ${MapLayerConfigFragmentFragmentDoc}`;

/**
 * __useGetMapLayerConfigQuery__
 *
 * To run a query within a React component, call `useGetMapLayerConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapLayerConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapLayerConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMapLayerConfigQuery(baseOptions: Apollo.QueryHookOptions<GetMapLayerConfigQuery, GetMapLayerConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapLayerConfigQuery, GetMapLayerConfigQueryVariables>(GetMapLayerConfigDocument, options);
      }
export function useGetMapLayerConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapLayerConfigQuery, GetMapLayerConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapLayerConfigQuery, GetMapLayerConfigQueryVariables>(GetMapLayerConfigDocument, options);
        }
export type GetMapLayerConfigQueryHookResult = ReturnType<typeof useGetMapLayerConfigQuery>;
export type GetMapLayerConfigLazyQueryHookResult = ReturnType<typeof useGetMapLayerConfigLazyQuery>;
export type GetMapLayerConfigQueryResult = Apollo.QueryResult<GetMapLayerConfigQuery, GetMapLayerConfigQueryVariables>;
export function refetchGetMapLayerConfigQuery(variables: GetMapLayerConfigQueryVariables) {
      return { query: GetMapLayerConfigDocument, variables: variables }
    }
export const GetMapLayerConfigsDocument = gql`
    query GetMapLayerConfigs {
  mapLayerConfigs {
    ...MapLayerConfigFragment
  }
}
    ${MapLayerConfigFragmentFragmentDoc}`;

/**
 * __useGetMapLayerConfigsQuery__
 *
 * To run a query within a React component, call `useGetMapLayerConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapLayerConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapLayerConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMapLayerConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetMapLayerConfigsQuery, GetMapLayerConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapLayerConfigsQuery, GetMapLayerConfigsQueryVariables>(GetMapLayerConfigsDocument, options);
      }
export function useGetMapLayerConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapLayerConfigsQuery, GetMapLayerConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapLayerConfigsQuery, GetMapLayerConfigsQueryVariables>(GetMapLayerConfigsDocument, options);
        }
export type GetMapLayerConfigsQueryHookResult = ReturnType<typeof useGetMapLayerConfigsQuery>;
export type GetMapLayerConfigsLazyQueryHookResult = ReturnType<typeof useGetMapLayerConfigsLazyQuery>;
export type GetMapLayerConfigsQueryResult = Apollo.QueryResult<GetMapLayerConfigsQuery, GetMapLayerConfigsQueryVariables>;
export function refetchGetMapLayerConfigsQuery(variables?: GetMapLayerConfigsQueryVariables) {
      return { query: GetMapLayerConfigsDocument, variables: variables }
    }
export const GetMapConfigDocument = gql`
    query GetMapConfig($id: ID!) {
  mapConfig(id: $id) {
    ...MapConfigFragment
  }
}
    ${MapConfigFragmentFragmentDoc}`;

/**
 * __useGetMapConfigQuery__
 *
 * To run a query within a React component, call `useGetMapConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMapConfigQuery(baseOptions: Apollo.QueryHookOptions<GetMapConfigQuery, GetMapConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapConfigQuery, GetMapConfigQueryVariables>(GetMapConfigDocument, options);
      }
export function useGetMapConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapConfigQuery, GetMapConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapConfigQuery, GetMapConfigQueryVariables>(GetMapConfigDocument, options);
        }
export type GetMapConfigQueryHookResult = ReturnType<typeof useGetMapConfigQuery>;
export type GetMapConfigLazyQueryHookResult = ReturnType<typeof useGetMapConfigLazyQuery>;
export type GetMapConfigQueryResult = Apollo.QueryResult<GetMapConfigQuery, GetMapConfigQueryVariables>;
export function refetchGetMapConfigQuery(variables: GetMapConfigQueryVariables) {
      return { query: GetMapConfigDocument, variables: variables }
    }
export const GetMapConfigsDocument = gql`
    query GetMapConfigs {
  mapConfigs {
    ...MapConfigFragment
  }
}
    ${MapConfigFragmentFragmentDoc}`;

/**
 * __useGetMapConfigsQuery__
 *
 * To run a query within a React component, call `useGetMapConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMapConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetMapConfigsQuery, GetMapConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapConfigsQuery, GetMapConfigsQueryVariables>(GetMapConfigsDocument, options);
      }
export function useGetMapConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapConfigsQuery, GetMapConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapConfigsQuery, GetMapConfigsQueryVariables>(GetMapConfigsDocument, options);
        }
export type GetMapConfigsQueryHookResult = ReturnType<typeof useGetMapConfigsQuery>;
export type GetMapConfigsLazyQueryHookResult = ReturnType<typeof useGetMapConfigsLazyQuery>;
export type GetMapConfigsQueryResult = Apollo.QueryResult<GetMapConfigsQuery, GetMapConfigsQueryVariables>;
export function refetchGetMapConfigsQuery(variables?: GetMapConfigsQueryVariables) {
      return { query: GetMapConfigsDocument, variables: variables }
    }
export const SaveEmailServerSettingsDocument = gql`
    mutation saveEmailServerSettings($settings: EmailServerSettingsInput!) {
  saveEmailServerSettings(settings: $settings) {
    host
    port
    auth
    startTls
    requireStartTls
    sslTrust
    username
    password
    ignoreTls
    from
    sslEnabled
  }
}
    `;
export type SaveEmailServerSettingsMutationFn = Apollo.MutationFunction<SaveEmailServerSettingsMutation, SaveEmailServerSettingsMutationVariables>;

/**
 * __useSaveEmailServerSettingsMutation__
 *
 * To run a mutation, you first call `useSaveEmailServerSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEmailServerSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEmailServerSettingsMutation, { data, loading, error }] = useSaveEmailServerSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveEmailServerSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveEmailServerSettingsMutation, SaveEmailServerSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEmailServerSettingsMutation, SaveEmailServerSettingsMutationVariables>(SaveEmailServerSettingsDocument, options);
      }
export type SaveEmailServerSettingsMutationHookResult = ReturnType<typeof useSaveEmailServerSettingsMutation>;
export type SaveEmailServerSettingsMutationResult = Apollo.MutationResult<SaveEmailServerSettingsMutation>;
export type SaveEmailServerSettingsMutationOptions = Apollo.BaseMutationOptions<SaveEmailServerSettingsMutation, SaveEmailServerSettingsMutationVariables>;
export const DeleteKineticFormsDocument = gql`
    mutation DeleteKineticForms($ids: [ID!]!) {
  deleteKineticForms(ids: $ids)
}
    `;
export type DeleteKineticFormsMutationFn = Apollo.MutationFunction<DeleteKineticFormsMutation, DeleteKineticFormsMutationVariables>;

/**
 * __useDeleteKineticFormsMutation__
 *
 * To run a mutation, you first call `useDeleteKineticFormsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKineticFormsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKineticFormsMutation, { data, loading, error }] = useDeleteKineticFormsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteKineticFormsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKineticFormsMutation, DeleteKineticFormsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKineticFormsMutation, DeleteKineticFormsMutationVariables>(DeleteKineticFormsDocument, options);
      }
export type DeleteKineticFormsMutationHookResult = ReturnType<typeof useDeleteKineticFormsMutation>;
export type DeleteKineticFormsMutationResult = Apollo.MutationResult<DeleteKineticFormsMutation>;
export type DeleteKineticFormsMutationOptions = Apollo.BaseMutationOptions<DeleteKineticFormsMutation, DeleteKineticFormsMutationVariables>;
export const SaveKineticFormDocument = gql`
    mutation SaveKineticForm($form: KineticFormInput!) {
  saveKineticForm(form: $form) {
    ...KineticForm
  }
}
    ${KineticFormFragmentDoc}`;
export type SaveKineticFormMutationFn = Apollo.MutationFunction<SaveKineticFormMutation, SaveKineticFormMutationVariables>;

/**
 * __useSaveKineticFormMutation__
 *
 * To run a mutation, you first call `useSaveKineticFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveKineticFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveKineticFormMutation, { data, loading, error }] = useSaveKineticFormMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useSaveKineticFormMutation(baseOptions?: Apollo.MutationHookOptions<SaveKineticFormMutation, SaveKineticFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveKineticFormMutation, SaveKineticFormMutationVariables>(SaveKineticFormDocument, options);
      }
export type SaveKineticFormMutationHookResult = ReturnType<typeof useSaveKineticFormMutation>;
export type SaveKineticFormMutationResult = Apollo.MutationResult<SaveKineticFormMutation>;
export type SaveKineticFormMutationOptions = Apollo.BaseMutationOptions<SaveKineticFormMutation, SaveKineticFormMutationVariables>;
export const CreateKeycloakClientDocument = gql`
    mutation CreateKeycloakClient {
  createKeycloakClient {
    id
    clientId
    name
    secret
  }
}
    `;
export type CreateKeycloakClientMutationFn = Apollo.MutationFunction<CreateKeycloakClientMutation, CreateKeycloakClientMutationVariables>;

/**
 * __useCreateKeycloakClientMutation__
 *
 * To run a mutation, you first call `useCreateKeycloakClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeycloakClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeycloakClientMutation, { data, loading, error }] = useCreateKeycloakClientMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateKeycloakClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateKeycloakClientMutation, CreateKeycloakClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeycloakClientMutation, CreateKeycloakClientMutationVariables>(CreateKeycloakClientDocument, options);
      }
export type CreateKeycloakClientMutationHookResult = ReturnType<typeof useCreateKeycloakClientMutation>;
export type CreateKeycloakClientMutationResult = Apollo.MutationResult<CreateKeycloakClientMutation>;
export type CreateKeycloakClientMutationOptions = Apollo.BaseMutationOptions<CreateKeycloakClientMutation, CreateKeycloakClientMutationVariables>;
export const RegenerateClientSecretDocument = gql`
    mutation RegenerateClientSecret {
  regenerateClientSecret
}
    `;
export type RegenerateClientSecretMutationFn = Apollo.MutationFunction<RegenerateClientSecretMutation, RegenerateClientSecretMutationVariables>;

/**
 * __useRegenerateClientSecretMutation__
 *
 * To run a mutation, you first call `useRegenerateClientSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateClientSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateClientSecretMutation, { data, loading, error }] = useRegenerateClientSecretMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegenerateClientSecretMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateClientSecretMutation, RegenerateClientSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateClientSecretMutation, RegenerateClientSecretMutationVariables>(RegenerateClientSecretDocument, options);
      }
export type RegenerateClientSecretMutationHookResult = ReturnType<typeof useRegenerateClientSecretMutation>;
export type RegenerateClientSecretMutationResult = Apollo.MutationResult<RegenerateClientSecretMutation>;
export type RegenerateClientSecretMutationOptions = Apollo.BaseMutationOptions<RegenerateClientSecretMutation, RegenerateClientSecretMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($id: ID!) {
  deleteRole(id: $id)
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const DeleteUserGroupDocument = gql`
    mutation DeleteUserGroup($id: ID!) {
  deleteUserGroup(id: $id)
}
    `;
export type DeleteUserGroupMutationFn = Apollo.MutationFunction<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGroupMutation, { data, loading, error }] = useDeleteUserGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(DeleteUserGroupDocument, options);
      }
export type DeleteUserGroupMutationHookResult = ReturnType<typeof useDeleteUserGroupMutation>;
export type DeleteUserGroupMutationResult = Apollo.MutationResult<DeleteUserGroupMutation>;
export type DeleteUserGroupMutationOptions = Apollo.BaseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;
export const SaveRoleDocument = gql`
    mutation SaveRole($role: KineticRoleInput!) {
  saveRole(role: $role) {
    id
    name
    privilegeAssignmentList {
      ...PrivilegeAssignmentFragment
    }
    restrictedIntegrationGroups
    restrictedIntegrations
    restrictedAreas
    restrictedEntities
  }
}
    ${PrivilegeAssignmentFragmentFragmentDoc}`;
export type SaveRoleMutationFn = Apollo.MutationFunction<SaveRoleMutation, SaveRoleMutationVariables>;

/**
 * __useSaveRoleMutation__
 *
 * To run a mutation, you first call `useSaveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRoleMutation, { data, loading, error }] = useSaveRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSaveRoleMutation(baseOptions?: Apollo.MutationHookOptions<SaveRoleMutation, SaveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRoleMutation, SaveRoleMutationVariables>(SaveRoleDocument, options);
      }
export type SaveRoleMutationHookResult = ReturnType<typeof useSaveRoleMutation>;
export type SaveRoleMutationResult = Apollo.MutationResult<SaveRoleMutation>;
export type SaveRoleMutationOptions = Apollo.BaseMutationOptions<SaveRoleMutation, SaveRoleMutationVariables>;
export const SaveUserGroupDocument = gql`
    mutation SaveUserGroup($userGroup: KineticUserGroupInput!) {
  saveUserGroup(userGroup: $userGroup) {
    id
    name
    privilegeAssignmentList {
      ...PrivilegeAssignmentFragment
    }
    roles {
      id
      name
      privilegeAssignmentList {
        ...PrivilegeAssignmentFragment
      }
    }
    users {
      id
      username
      firstName
      lastName
    }
    restrictedIntegrationGroups
    restrictedIntegrations
    restrictedAreas
    restrictedEntities
  }
}
    ${PrivilegeAssignmentFragmentFragmentDoc}`;
export type SaveUserGroupMutationFn = Apollo.MutationFunction<SaveUserGroupMutation, SaveUserGroupMutationVariables>;

/**
 * __useSaveUserGroupMutation__
 *
 * To run a mutation, you first call `useSaveUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserGroupMutation, { data, loading, error }] = useSaveUserGroupMutation({
 *   variables: {
 *      userGroup: // value for 'userGroup'
 *   },
 * });
 */
export function useSaveUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserGroupMutation, SaveUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserGroupMutation, SaveUserGroupMutationVariables>(SaveUserGroupDocument, options);
      }
export type SaveUserGroupMutationHookResult = ReturnType<typeof useSaveUserGroupMutation>;
export type SaveUserGroupMutationResult = Apollo.MutationResult<SaveUserGroupMutation>;
export type SaveUserGroupMutationOptions = Apollo.BaseMutationOptions<SaveUserGroupMutation, SaveUserGroupMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($user: OrganizationKineticUserInput!) {
  createUser(user: $user) {
    id
    username
    firstName
    lastName
    email
    phoneNumbers
    privilegeAssignmentList {
      ...PrivilegeAssignmentFragment
    }
    roleIds
    userGroupIds
  }
}
    ${PrivilegeAssignmentFragmentFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserPrivilegesDocument = gql`
    mutation UpdateUserPrivileges($user: KineticUserPrivilegeAssignmentInput!) {
  updateUserPrivileges(user: $user) {
    id
    roles {
      id
      name
    }
    privilegeAssignmentList {
      ...PrivilegeAssignmentFragment
    }
  }
}
    ${PrivilegeAssignmentFragmentFragmentDoc}`;
export type UpdateUserPrivilegesMutationFn = Apollo.MutationFunction<UpdateUserPrivilegesMutation, UpdateUserPrivilegesMutationVariables>;

/**
 * __useUpdateUserPrivilegesMutation__
 *
 * To run a mutation, you first call `useUpdateUserPrivilegesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPrivilegesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPrivilegesMutation, { data, loading, error }] = useUpdateUserPrivilegesMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserPrivilegesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPrivilegesMutation, UpdateUserPrivilegesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPrivilegesMutation, UpdateUserPrivilegesMutationVariables>(UpdateUserPrivilegesDocument, options);
      }
export type UpdateUserPrivilegesMutationHookResult = ReturnType<typeof useUpdateUserPrivilegesMutation>;
export type UpdateUserPrivilegesMutationResult = Apollo.MutationResult<UpdateUserPrivilegesMutation>;
export type UpdateUserPrivilegesMutationOptions = Apollo.BaseMutationOptions<UpdateUserPrivilegesMutation, UpdateUserPrivilegesMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($id: ID!, $newPassword: String!) {
  resetPassword(id: $id, newPassword: $newPassword)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RemoveUserDocument = gql`
    mutation RemoveUser($id: ID!) {
  removeUser(id: $id)
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const SaveMapConfigDocument = gql`
    mutation SaveMapConfig($config: MapConfigInput!) {
  saveMapConfig(config: $config) {
    ...MapConfigFragment
  }
}
    ${MapConfigFragmentFragmentDoc}`;
export type SaveMapConfigMutationFn = Apollo.MutationFunction<SaveMapConfigMutation, SaveMapConfigMutationVariables>;

/**
 * __useSaveMapConfigMutation__
 *
 * To run a mutation, you first call `useSaveMapConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMapConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMapConfigMutation, { data, loading, error }] = useSaveMapConfigMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useSaveMapConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveMapConfigMutation, SaveMapConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMapConfigMutation, SaveMapConfigMutationVariables>(SaveMapConfigDocument, options);
      }
export type SaveMapConfigMutationHookResult = ReturnType<typeof useSaveMapConfigMutation>;
export type SaveMapConfigMutationResult = Apollo.MutationResult<SaveMapConfigMutation>;
export type SaveMapConfigMutationOptions = Apollo.BaseMutationOptions<SaveMapConfigMutation, SaveMapConfigMutationVariables>;
export const SaveMapLayerConfigDocument = gql`
    mutation SaveMapLayerConfig($config: MapLayerConfigInput!) {
  saveMapLayerConfig(config: $config) {
    ...MapLayerConfigFragment
  }
}
    ${MapLayerConfigFragmentFragmentDoc}`;
export type SaveMapLayerConfigMutationFn = Apollo.MutationFunction<SaveMapLayerConfigMutation, SaveMapLayerConfigMutationVariables>;

/**
 * __useSaveMapLayerConfigMutation__
 *
 * To run a mutation, you first call `useSaveMapLayerConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMapLayerConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMapLayerConfigMutation, { data, loading, error }] = useSaveMapLayerConfigMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useSaveMapLayerConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveMapLayerConfigMutation, SaveMapLayerConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMapLayerConfigMutation, SaveMapLayerConfigMutationVariables>(SaveMapLayerConfigDocument, options);
      }
export type SaveMapLayerConfigMutationHookResult = ReturnType<typeof useSaveMapLayerConfigMutation>;
export type SaveMapLayerConfigMutationResult = Apollo.MutationResult<SaveMapLayerConfigMutation>;
export type SaveMapLayerConfigMutationOptions = Apollo.BaseMutationOptions<SaveMapLayerConfigMutation, SaveMapLayerConfigMutationVariables>;
export const DeleteMapLayerConfigDocument = gql`
    mutation DeleteMapLayerConfig($id: ID!) {
  deleteMapLayerConfig(id: $id)
}
    `;
export type DeleteMapLayerConfigMutationFn = Apollo.MutationFunction<DeleteMapLayerConfigMutation, DeleteMapLayerConfigMutationVariables>;

/**
 * __useDeleteMapLayerConfigMutation__
 *
 * To run a mutation, you first call `useDeleteMapLayerConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMapLayerConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMapLayerConfigMutation, { data, loading, error }] = useDeleteMapLayerConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMapLayerConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMapLayerConfigMutation, DeleteMapLayerConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMapLayerConfigMutation, DeleteMapLayerConfigMutationVariables>(DeleteMapLayerConfigDocument, options);
      }
export type DeleteMapLayerConfigMutationHookResult = ReturnType<typeof useDeleteMapLayerConfigMutation>;
export type DeleteMapLayerConfigMutationResult = Apollo.MutationResult<DeleteMapLayerConfigMutation>;
export type DeleteMapLayerConfigMutationOptions = Apollo.BaseMutationOptions<DeleteMapLayerConfigMutation, DeleteMapLayerConfigMutationVariables>;
export const DeleteMapConfigDocument = gql`
    mutation DeleteMapConfig($id: ID!) {
  deleteMapConfig(id: $id)
}
    `;
export type DeleteMapConfigMutationFn = Apollo.MutationFunction<DeleteMapConfigMutation, DeleteMapConfigMutationVariables>;

/**
 * __useDeleteMapConfigMutation__
 *
 * To run a mutation, you first call `useDeleteMapConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMapConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMapConfigMutation, { data, loading, error }] = useDeleteMapConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMapConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMapConfigMutation, DeleteMapConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMapConfigMutation, DeleteMapConfigMutationVariables>(DeleteMapConfigDocument, options);
      }
export type DeleteMapConfigMutationHookResult = ReturnType<typeof useDeleteMapConfigMutation>;
export type DeleteMapConfigMutationResult = Apollo.MutationResult<DeleteMapConfigMutation>;
export type DeleteMapConfigMutationOptions = Apollo.BaseMutationOptions<DeleteMapConfigMutation, DeleteMapConfigMutationVariables>;
export const SyncDocument = gql`
    mutation sync {
  syncLicense
}
    `;
export type SyncMutationFn = Apollo.MutationFunction<SyncMutation, SyncMutationVariables>;

/**
 * __useSyncMutation__
 *
 * To run a mutation, you first call `useSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncMutation, { data, loading, error }] = useSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncMutation(baseOptions?: Apollo.MutationHookOptions<SyncMutation, SyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncMutation, SyncMutationVariables>(SyncDocument, options);
      }
export type SyncMutationHookResult = ReturnType<typeof useSyncMutation>;
export type SyncMutationResult = Apollo.MutationResult<SyncMutation>;
export type SyncMutationOptions = Apollo.BaseMutationOptions<SyncMutation, SyncMutationVariables>;
export const SaveLicenseDocument = gql`
    mutation saveLicense($key: String!) {
  saveLicense(key: $key)
}
    `;
export type SaveLicenseMutationFn = Apollo.MutationFunction<SaveLicenseMutation, SaveLicenseMutationVariables>;

/**
 * __useSaveLicenseMutation__
 *
 * To run a mutation, you first call `useSaveLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLicenseMutation, { data, loading, error }] = useSaveLicenseMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useSaveLicenseMutation(baseOptions?: Apollo.MutationHookOptions<SaveLicenseMutation, SaveLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLicenseMutation, SaveLicenseMutationVariables>(SaveLicenseDocument, options);
      }
export type SaveLicenseMutationHookResult = ReturnType<typeof useSaveLicenseMutation>;
export type SaveLicenseMutationResult = Apollo.MutationResult<SaveLicenseMutation>;
export type SaveLicenseMutationOptions = Apollo.BaseMutationOptions<SaveLicenseMutation, SaveLicenseMutationVariables>;
export const SaveKineticFormFieldDocument = gql`
    mutation saveKineticFormField($field: KineticFormFieldInput!) {
  saveKineticFormField(field: $field) {
    ...KineticFormFieldFragment
  }
}
    ${KineticFormFieldFragmentFragmentDoc}`;
export type SaveKineticFormFieldMutationFn = Apollo.MutationFunction<SaveKineticFormFieldMutation, SaveKineticFormFieldMutationVariables>;

/**
 * __useSaveKineticFormFieldMutation__
 *
 * To run a mutation, you first call `useSaveKineticFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveKineticFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveKineticFormFieldMutation, { data, loading, error }] = useSaveKineticFormFieldMutation({
 *   variables: {
 *      field: // value for 'field'
 *   },
 * });
 */
export function useSaveKineticFormFieldMutation(baseOptions?: Apollo.MutationHookOptions<SaveKineticFormFieldMutation, SaveKineticFormFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveKineticFormFieldMutation, SaveKineticFormFieldMutationVariables>(SaveKineticFormFieldDocument, options);
      }
export type SaveKineticFormFieldMutationHookResult = ReturnType<typeof useSaveKineticFormFieldMutation>;
export type SaveKineticFormFieldMutationResult = Apollo.MutationResult<SaveKineticFormFieldMutation>;
export type SaveKineticFormFieldMutationOptions = Apollo.BaseMutationOptions<SaveKineticFormFieldMutation, SaveKineticFormFieldMutationVariables>;
export const DeleteKineticFormFieldsDocument = gql`
    mutation DeleteKineticFormFields($selection: [ID!]!) {
  deleteKineticFormFields(ids: $selection)
}
    `;
export type DeleteKineticFormFieldsMutationFn = Apollo.MutationFunction<DeleteKineticFormFieldsMutation, DeleteKineticFormFieldsMutationVariables>;

/**
 * __useDeleteKineticFormFieldsMutation__
 *
 * To run a mutation, you first call `useDeleteKineticFormFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKineticFormFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKineticFormFieldsMutation, { data, loading, error }] = useDeleteKineticFormFieldsMutation({
 *   variables: {
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useDeleteKineticFormFieldsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKineticFormFieldsMutation, DeleteKineticFormFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKineticFormFieldsMutation, DeleteKineticFormFieldsMutationVariables>(DeleteKineticFormFieldsDocument, options);
      }
export type DeleteKineticFormFieldsMutationHookResult = ReturnType<typeof useDeleteKineticFormFieldsMutation>;
export type DeleteKineticFormFieldsMutationResult = Apollo.MutationResult<DeleteKineticFormFieldsMutation>;
export type DeleteKineticFormFieldsMutationOptions = Apollo.BaseMutationOptions<DeleteKineticFormFieldsMutation, DeleteKineticFormFieldsMutationVariables>;
export const SaveCentralAuthPinSettingsDocument = gql`
    mutation saveCentralAuthPinSettings($pin: String!) {
  saveCentralAuthPinSettings(pin: $pin) {
    id
  }
}
    `;
export type SaveCentralAuthPinSettingsMutationFn = Apollo.MutationFunction<SaveCentralAuthPinSettingsMutation, SaveCentralAuthPinSettingsMutationVariables>;

/**
 * __useSaveCentralAuthPinSettingsMutation__
 *
 * To run a mutation, you first call `useSaveCentralAuthPinSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCentralAuthPinSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCentralAuthPinSettingsMutation, { data, loading, error }] = useSaveCentralAuthPinSettingsMutation({
 *   variables: {
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useSaveCentralAuthPinSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveCentralAuthPinSettingsMutation, SaveCentralAuthPinSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCentralAuthPinSettingsMutation, SaveCentralAuthPinSettingsMutationVariables>(SaveCentralAuthPinSettingsDocument, options);
      }
export type SaveCentralAuthPinSettingsMutationHookResult = ReturnType<typeof useSaveCentralAuthPinSettingsMutation>;
export type SaveCentralAuthPinSettingsMutationResult = Apollo.MutationResult<SaveCentralAuthPinSettingsMutation>;
export type SaveCentralAuthPinSettingsMutationOptions = Apollo.BaseMutationOptions<SaveCentralAuthPinSettingsMutation, SaveCentralAuthPinSettingsMutationVariables>;
export const GenerateTokenZipDocument = gql`
    mutation generateTokenZip($refreshToken: String!, $idToken: String!) {
  generateTokenZip(refreshToken: $refreshToken, idToken: $idToken)
}
    `;
export type GenerateTokenZipMutationFn = Apollo.MutationFunction<GenerateTokenZipMutation, GenerateTokenZipMutationVariables>;

/**
 * __useGenerateTokenZipMutation__
 *
 * To run a mutation, you first call `useGenerateTokenZipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTokenZipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTokenZipMutation, { data, loading, error }] = useGenerateTokenZipMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *      idToken: // value for 'idToken'
 *   },
 * });
 */
export function useGenerateTokenZipMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTokenZipMutation, GenerateTokenZipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTokenZipMutation, GenerateTokenZipMutationVariables>(GenerateTokenZipDocument, options);
      }
export type GenerateTokenZipMutationHookResult = ReturnType<typeof useGenerateTokenZipMutation>;
export type GenerateTokenZipMutationResult = Apollo.MutationResult<GenerateTokenZipMutation>;
export type GenerateTokenZipMutationOptions = Apollo.BaseMutationOptions<GenerateTokenZipMutation, GenerateTokenZipMutationVariables>;
export const ImportFormFieldsDocument = gql`
    mutation ImportFormFields($input: [Object!]!) {
  importFormFields(input: $input)
}
    `;
export type ImportFormFieldsMutationFn = Apollo.MutationFunction<ImportFormFieldsMutation, ImportFormFieldsMutationVariables>;

/**
 * __useImportFormFieldsMutation__
 *
 * To run a mutation, you first call `useImportFormFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportFormFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importFormFieldsMutation, { data, loading, error }] = useImportFormFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportFormFieldsMutation(baseOptions?: Apollo.MutationHookOptions<ImportFormFieldsMutation, ImportFormFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportFormFieldsMutation, ImportFormFieldsMutationVariables>(ImportFormFieldsDocument, options);
      }
export type ImportFormFieldsMutationHookResult = ReturnType<typeof useImportFormFieldsMutation>;
export type ImportFormFieldsMutationResult = Apollo.MutationResult<ImportFormFieldsMutation>;
export type ImportFormFieldsMutationOptions = Apollo.BaseMutationOptions<ImportFormFieldsMutation, ImportFormFieldsMutationVariables>;
export const ImportFormsDocument = gql`
    mutation ImportForms($input: [Object!]!) {
  importForms(input: $input)
}
    `;
export type ImportFormsMutationFn = Apollo.MutationFunction<ImportFormsMutation, ImportFormsMutationVariables>;

/**
 * __useImportFormsMutation__
 *
 * To run a mutation, you first call `useImportFormsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportFormsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importFormsMutation, { data, loading, error }] = useImportFormsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportFormsMutation(baseOptions?: Apollo.MutationHookOptions<ImportFormsMutation, ImportFormsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportFormsMutation, ImportFormsMutationVariables>(ImportFormsDocument, options);
      }
export type ImportFormsMutationHookResult = ReturnType<typeof useImportFormsMutation>;
export type ImportFormsMutationResult = Apollo.MutationResult<ImportFormsMutation>;
export type ImportFormsMutationOptions = Apollo.BaseMutationOptions<ImportFormsMutation, ImportFormsMutationVariables>;
export const KeycloakClientDocument = gql`
    query KeycloakClient {
  keycloakClient {
    id
    clientId
    name
    secret
  }
}
    `;

/**
 * __useKeycloakClientQuery__
 *
 * To run a query within a React component, call `useKeycloakClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeycloakClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeycloakClientQuery({
 *   variables: {
 *   },
 * });
 */
export function useKeycloakClientQuery(baseOptions?: Apollo.QueryHookOptions<KeycloakClientQuery, KeycloakClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeycloakClientQuery, KeycloakClientQueryVariables>(KeycloakClientDocument, options);
      }
export function useKeycloakClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeycloakClientQuery, KeycloakClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeycloakClientQuery, KeycloakClientQueryVariables>(KeycloakClientDocument, options);
        }
export type KeycloakClientQueryHookResult = ReturnType<typeof useKeycloakClientQuery>;
export type KeycloakClientLazyQueryHookResult = ReturnType<typeof useKeycloakClientLazyQuery>;
export type KeycloakClientQueryResult = Apollo.QueryResult<KeycloakClientQuery, KeycloakClientQueryVariables>;
export function refetchKeycloakClientQuery(variables?: KeycloakClientQueryVariables) {
      return { query: KeycloakClientDocument, variables: variables }
    }
export const EmailServerSettingsDocument = gql`
    query EmailServerSettings {
  emailServerSettings {
    host
    port
    auth
    startTls
    requireStartTls
    sslTrust
    username
    password
    ignoreTls
    from
    sslEnabled
  }
}
    `;

/**
 * __useEmailServerSettingsQuery__
 *
 * To run a query within a React component, call `useEmailServerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailServerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailServerSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailServerSettingsQuery(baseOptions?: Apollo.QueryHookOptions<EmailServerSettingsQuery, EmailServerSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailServerSettingsQuery, EmailServerSettingsQueryVariables>(EmailServerSettingsDocument, options);
      }
export function useEmailServerSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailServerSettingsQuery, EmailServerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailServerSettingsQuery, EmailServerSettingsQueryVariables>(EmailServerSettingsDocument, options);
        }
export type EmailServerSettingsQueryHookResult = ReturnType<typeof useEmailServerSettingsQuery>;
export type EmailServerSettingsLazyQueryHookResult = ReturnType<typeof useEmailServerSettingsLazyQuery>;
export type EmailServerSettingsQueryResult = Apollo.QueryResult<EmailServerSettingsQuery, EmailServerSettingsQueryVariables>;
export function refetchEmailServerSettingsQuery(variables?: EmailServerSettingsQueryVariables) {
      return { query: EmailServerSettingsDocument, variables: variables }
    }
export const RecentRemoteAgentsDocument = gql`
    query RecentRemoteAgents {
  recentRemoteAgents {
    instanceId
    processId
    systemName
    remoteIpAddress
    clientId
    version
    internalIpAddress
    lastHeartbeat
    labels
  }
}
    `;

/**
 * __useRecentRemoteAgentsQuery__
 *
 * To run a query within a React component, call `useRecentRemoteAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentRemoteAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentRemoteAgentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentRemoteAgentsQuery(baseOptions?: Apollo.QueryHookOptions<RecentRemoteAgentsQuery, RecentRemoteAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentRemoteAgentsQuery, RecentRemoteAgentsQueryVariables>(RecentRemoteAgentsDocument, options);
      }
export function useRecentRemoteAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentRemoteAgentsQuery, RecentRemoteAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentRemoteAgentsQuery, RecentRemoteAgentsQueryVariables>(RecentRemoteAgentsDocument, options);
        }
export type RecentRemoteAgentsQueryHookResult = ReturnType<typeof useRecentRemoteAgentsQuery>;
export type RecentRemoteAgentsLazyQueryHookResult = ReturnType<typeof useRecentRemoteAgentsLazyQuery>;
export type RecentRemoteAgentsQueryResult = Apollo.QueryResult<RecentRemoteAgentsQuery, RecentRemoteAgentsQueryVariables>;
export function refetchRecentRemoteAgentsQuery(variables?: RecentRemoteAgentsQueryVariables) {
      return { query: RecentRemoteAgentsDocument, variables: variables }
    }
export const GetOrgsDocument = gql`
    query GetOrgs {
  organizations {
    id
    name
    address
  }
}
    `;

/**
 * __useGetOrgsQuery__
 *
 * To run a query within a React component, call `useGetOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrgsQuery, GetOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgsQuery, GetOrgsQueryVariables>(GetOrgsDocument, options);
      }
export function useGetOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgsQuery, GetOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgsQuery, GetOrgsQueryVariables>(GetOrgsDocument, options);
        }
export type GetOrgsQueryHookResult = ReturnType<typeof useGetOrgsQuery>;
export type GetOrgsLazyQueryHookResult = ReturnType<typeof useGetOrgsLazyQuery>;
export type GetOrgsQueryResult = Apollo.QueryResult<GetOrgsQuery, GetOrgsQueryVariables>;
export function refetchGetOrgsQuery(variables?: GetOrgsQueryVariables) {
      return { query: GetOrgsDocument, variables: variables }
    }
export const GetRolesDocument = gql`
    query getRoles {
  roles {
    id
    name
    privilegeAssignmentList {
      ...PrivilegeAssignmentFragment
    }
    restrictedIntegrationGroups
    restrictedIntegrations
    restrictedAreas
    restrictedEntities
    restrictedLocations
    restrictedLocationGroups
  }
}
    ${PrivilegeAssignmentFragmentFragmentDoc}`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export function refetchGetRolesQuery(variables?: GetRolesQueryVariables) {
      return { query: GetRolesDocument, variables: variables }
    }
export const GetRoleDocument = gql`
    query getRole($id: ID!) {
  role(id: $id) {
    id
    name
    privilegeAssignmentList {
      ...PrivilegeAssignmentFragment
    }
    restrictedIntegrationGroups
    restrictedIntegrations
    restrictedAreas
    restrictedEntities
  }
}
    ${PrivilegeAssignmentFragmentFragmentDoc}`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export function refetchGetRoleQuery(variables: GetRoleQueryVariables) {
      return { query: GetRoleDocument, variables: variables }
    }
export const RolesUpdatedDocument = gql`
    subscription RolesUpdated($ids: [ID!]!) {
  rolesUpdated(ids: $ids) {
    id
    name
    privilegeAssignmentList {
      ...PrivilegeAssignmentFragment
    }
    restrictedIntegrationGroups
    restrictedIntegrations
    restrictedAreas
    restrictedEntities
  }
}
    ${PrivilegeAssignmentFragmentFragmentDoc}`;

/**
 * __useRolesUpdatedSubscription__
 *
 * To run a query within a React component, call `useRolesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRolesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRolesUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<RolesUpdatedSubscription, RolesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RolesUpdatedSubscription, RolesUpdatedSubscriptionVariables>(RolesUpdatedDocument, options);
      }
export type RolesUpdatedSubscriptionHookResult = ReturnType<typeof useRolesUpdatedSubscription>;
export type RolesUpdatedSubscriptionResult = Apollo.SubscriptionResult<RolesUpdatedSubscription>;
export const GetUserGroupDocument = gql`
    query GetUserGroup($id: ID!) {
  userGroup(id: $id) {
    id
    name
    users {
      id
      username
      firstName
      lastName
    }
    roles {
      id
      name
    }
    restrictedIntegrationGroups
    restrictedIntegrations
    restrictedAreas
    restrictedEntities
    restrictedLocations
    restrictedLocationGroups
    privilegeAssignmentList {
      ...PrivilegeAssignmentFragment
    }
  }
}
    ${PrivilegeAssignmentFragmentFragmentDoc}`;

/**
 * __useGetUserGroupQuery__
 *
 * To run a query within a React component, call `useGetUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserGroupQuery(baseOptions: Apollo.QueryHookOptions<GetUserGroupQuery, GetUserGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupQuery, GetUserGroupQueryVariables>(GetUserGroupDocument, options);
      }
export function useGetUserGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupQuery, GetUserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupQuery, GetUserGroupQueryVariables>(GetUserGroupDocument, options);
        }
export type GetUserGroupQueryHookResult = ReturnType<typeof useGetUserGroupQuery>;
export type GetUserGroupLazyQueryHookResult = ReturnType<typeof useGetUserGroupLazyQuery>;
export type GetUserGroupQueryResult = Apollo.QueryResult<GetUserGroupQuery, GetUserGroupQueryVariables>;
export function refetchGetUserGroupQuery(variables: GetUserGroupQueryVariables) {
      return { query: GetUserGroupDocument, variables: variables }
    }
export const GetUserGroupsDocument = gql`
    query GetUserGroups {
  userGroups {
    id
    name
    users {
      id
    }
    roles {
      id
      name
    }
    restrictedIntegrationGroups
    restrictedIntegrations
    restrictedAreas
    restrictedEntities
  }
}
    `;

/**
 * __useGetUserGroupsQuery__
 *
 * To run a query within a React component, call `useGetUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
      }
export function useGetUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
export type GetUserGroupsQueryHookResult = ReturnType<typeof useGetUserGroupsQuery>;
export type GetUserGroupsLazyQueryHookResult = ReturnType<typeof useGetUserGroupsLazyQuery>;
export type GetUserGroupsQueryResult = Apollo.QueryResult<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export function refetchGetUserGroupsQuery(variables?: GetUserGroupsQueryVariables) {
      return { query: GetUserGroupsDocument, variables: variables }
    }
export const UserGroupsUpdatedDocument = gql`
    subscription UserGroupsUpdated($ids: [ID!]!) {
  userGroupsUpdated(ids: $ids) {
    id
    name
    users {
      id
    }
    roles {
      id
      name
    }
    restrictedIntegrationGroups
    restrictedIntegrations
    restrictedAreas
    restrictedEntities
  }
}
    `;

/**
 * __useUserGroupsUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserGroupsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupsUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUserGroupsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<UserGroupsUpdatedSubscription, UserGroupsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserGroupsUpdatedSubscription, UserGroupsUpdatedSubscriptionVariables>(UserGroupsUpdatedDocument, options);
      }
export type UserGroupsUpdatedSubscriptionHookResult = ReturnType<typeof useUserGroupsUpdatedSubscription>;
export type UserGroupsUpdatedSubscriptionResult = Apollo.SubscriptionResult<UserGroupsUpdatedSubscription>;
export const GetPrivilegesDocument = gql`
    query GetPrivileges {
  privileges {
    id
    privilegeType
    kineticModule
  }
}
    `;

/**
 * __useGetPrivilegesQuery__
 *
 * To run a query within a React component, call `useGetPrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivilegesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrivilegesQuery(baseOptions?: Apollo.QueryHookOptions<GetPrivilegesQuery, GetPrivilegesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivilegesQuery, GetPrivilegesQueryVariables>(GetPrivilegesDocument, options);
      }
export function useGetPrivilegesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivilegesQuery, GetPrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivilegesQuery, GetPrivilegesQueryVariables>(GetPrivilegesDocument, options);
        }
export type GetPrivilegesQueryHookResult = ReturnType<typeof useGetPrivilegesQuery>;
export type GetPrivilegesLazyQueryHookResult = ReturnType<typeof useGetPrivilegesLazyQuery>;
export type GetPrivilegesQueryResult = Apollo.QueryResult<GetPrivilegesQuery, GetPrivilegesQueryVariables>;
export function refetchGetPrivilegesQuery(variables?: GetPrivilegesQueryVariables) {
      return { query: GetPrivilegesDocument, variables: variables }
    }
export const PrivilegeAssignmentsUpdatedDocument = gql`
    subscription PrivilegeAssignmentsUpdated($ids: [ID!]!) {
  privilegeAssignmentsUpdated(ids: $ids) {
    id
  }
}
    `;

/**
 * __usePrivilegeAssignmentsUpdatedSubscription__
 *
 * To run a query within a React component, call `usePrivilegeAssignmentsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePrivilegeAssignmentsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivilegeAssignmentsUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePrivilegeAssignmentsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PrivilegeAssignmentsUpdatedSubscription, PrivilegeAssignmentsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PrivilegeAssignmentsUpdatedSubscription, PrivilegeAssignmentsUpdatedSubscriptionVariables>(PrivilegeAssignmentsUpdatedDocument, options);
      }
export type PrivilegeAssignmentsUpdatedSubscriptionHookResult = ReturnType<typeof usePrivilegeAssignmentsUpdatedSubscription>;
export type PrivilegeAssignmentsUpdatedSubscriptionResult = Apollo.SubscriptionResult<PrivilegeAssignmentsUpdatedSubscription>;
export const IsUsernameUniqueDocument = gql`
    query isUsernameUnique($username: String!) {
  isUsernameUnique(username: $username)
}
    `;

/**
 * __useIsUsernameUniqueQuery__
 *
 * To run a query within a React component, call `useIsUsernameUniqueQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUsernameUniqueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUsernameUniqueQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useIsUsernameUniqueQuery(baseOptions: Apollo.QueryHookOptions<IsUsernameUniqueQuery, IsUsernameUniqueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUsernameUniqueQuery, IsUsernameUniqueQueryVariables>(IsUsernameUniqueDocument, options);
      }
export function useIsUsernameUniqueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUsernameUniqueQuery, IsUsernameUniqueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUsernameUniqueQuery, IsUsernameUniqueQueryVariables>(IsUsernameUniqueDocument, options);
        }
export type IsUsernameUniqueQueryHookResult = ReturnType<typeof useIsUsernameUniqueQuery>;
export type IsUsernameUniqueLazyQueryHookResult = ReturnType<typeof useIsUsernameUniqueLazyQuery>;
export type IsUsernameUniqueQueryResult = Apollo.QueryResult<IsUsernameUniqueQuery, IsUsernameUniqueQueryVariables>;
export function refetchIsUsernameUniqueQuery(variables: IsUsernameUniqueQueryVariables) {
      return { query: IsUsernameUniqueDocument, variables: variables }
    }
export const LicenseFeaturesDocument = gql`
    query licenseFeatures {
  licenseFeatures {
    feature
    value
    enabled
    used
  }
}
    `;

/**
 * __useLicenseFeaturesQuery__
 *
 * To run a query within a React component, call `useLicenseFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicenseFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<LicenseFeaturesQuery, LicenseFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicenseFeaturesQuery, LicenseFeaturesQueryVariables>(LicenseFeaturesDocument, options);
      }
export function useLicenseFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicenseFeaturesQuery, LicenseFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicenseFeaturesQuery, LicenseFeaturesQueryVariables>(LicenseFeaturesDocument, options);
        }
export type LicenseFeaturesQueryHookResult = ReturnType<typeof useLicenseFeaturesQuery>;
export type LicenseFeaturesLazyQueryHookResult = ReturnType<typeof useLicenseFeaturesLazyQuery>;
export type LicenseFeaturesQueryResult = Apollo.QueryResult<LicenseFeaturesQuery, LicenseFeaturesQueryVariables>;
export function refetchLicenseFeaturesQuery(variables?: LicenseFeaturesQueryVariables) {
      return { query: LicenseFeaturesDocument, variables: variables }
    }
export const VersionDocument = gql`
    query version {
  version
  gitHash
  lastGitTag
}
    `;

/**
 * __useVersionQuery__
 *
 * To run a query within a React component, call `useVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useVersionQuery(baseOptions?: Apollo.QueryHookOptions<VersionQuery, VersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VersionQuery, VersionQueryVariables>(VersionDocument, options);
      }
export function useVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VersionQuery, VersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VersionQuery, VersionQueryVariables>(VersionDocument, options);
        }
export type VersionQueryHookResult = ReturnType<typeof useVersionQuery>;
export type VersionLazyQueryHookResult = ReturnType<typeof useVersionLazyQuery>;
export type VersionQueryResult = Apollo.QueryResult<VersionQuery, VersionQueryVariables>;
export function refetchVersionQuery(variables?: VersionQueryVariables) {
      return { query: VersionDocument, variables: variables }
    }
export const LicenseDetailsDocument = gql`
    query licenseDetails {
  licenseDetails {
    key
    activationId
    expiresAt
    leaseExpiresAt
    accountId
    company
    email
  }
}
    `;

/**
 * __useLicenseDetailsQuery__
 *
 * To run a query within a React component, call `useLicenseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicenseDetailsQuery(baseOptions?: Apollo.QueryHookOptions<LicenseDetailsQuery, LicenseDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicenseDetailsQuery, LicenseDetailsQueryVariables>(LicenseDetailsDocument, options);
      }
export function useLicenseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicenseDetailsQuery, LicenseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicenseDetailsQuery, LicenseDetailsQueryVariables>(LicenseDetailsDocument, options);
        }
export type LicenseDetailsQueryHookResult = ReturnType<typeof useLicenseDetailsQuery>;
export type LicenseDetailsLazyQueryHookResult = ReturnType<typeof useLicenseDetailsLazyQuery>;
export type LicenseDetailsQueryResult = Apollo.QueryResult<LicenseDetailsQuery, LicenseDetailsQueryVariables>;
export function refetchLicenseDetailsQuery(variables?: LicenseDetailsQueryVariables) {
      return { query: LicenseDetailsDocument, variables: variables }
    }
export const HasValidLicenseDocument = gql`
    query hasValidLicense {
  hasValidLicense
}
    `;

/**
 * __useHasValidLicenseQuery__
 *
 * To run a query within a React component, call `useHasValidLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasValidLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasValidLicenseQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasValidLicenseQuery(baseOptions?: Apollo.QueryHookOptions<HasValidLicenseQuery, HasValidLicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasValidLicenseQuery, HasValidLicenseQueryVariables>(HasValidLicenseDocument, options);
      }
export function useHasValidLicenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasValidLicenseQuery, HasValidLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasValidLicenseQuery, HasValidLicenseQueryVariables>(HasValidLicenseDocument, options);
        }
export type HasValidLicenseQueryHookResult = ReturnType<typeof useHasValidLicenseQuery>;
export type HasValidLicenseLazyQueryHookResult = ReturnType<typeof useHasValidLicenseLazyQuery>;
export type HasValidLicenseQueryResult = Apollo.QueryResult<HasValidLicenseQuery, HasValidLicenseQueryVariables>;
export function refetchHasValidLicenseQuery(variables?: HasValidLicenseQueryVariables) {
      return { query: HasValidLicenseDocument, variables: variables }
    }
export const KineticFormEventTypesDocument = gql`
    query KineticFormEventTypes($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $category: EventCategory, $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  eventTypes(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, searchText: $searchText, sortField: $sortField, category: $category, filters: $filters}
  ) {
    edges {
      node {
        ...KineticFormEventType
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${KineticFormEventTypeFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useKineticFormEventTypesQuery__
 *
 * To run a query within a React component, call `useKineticFormEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormEventTypesQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      category: // value for 'category'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useKineticFormEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<KineticFormEventTypesQuery, KineticFormEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormEventTypesQuery, KineticFormEventTypesQueryVariables>(KineticFormEventTypesDocument, options);
      }
export function useKineticFormEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormEventTypesQuery, KineticFormEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormEventTypesQuery, KineticFormEventTypesQueryVariables>(KineticFormEventTypesDocument, options);
        }
export type KineticFormEventTypesQueryHookResult = ReturnType<typeof useKineticFormEventTypesQuery>;
export type KineticFormEventTypesLazyQueryHookResult = ReturnType<typeof useKineticFormEventTypesLazyQuery>;
export type KineticFormEventTypesQueryResult = Apollo.QueryResult<KineticFormEventTypesQuery, KineticFormEventTypesQueryVariables>;
export function refetchKineticFormEventTypesQuery(variables?: KineticFormEventTypesQueryVariables) {
      return { query: KineticFormEventTypesDocument, variables: variables }
    }
export const DataSourceConfigListDocument = gql`
    query DataSourceConfigList($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $module: KineticModule, $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  dataSourceConfigs(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, module: $module, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useDataSourceConfigListQuery__
 *
 * To run a query within a React component, call `useDataSourceConfigListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceConfigListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceConfigListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      module: // value for 'module'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDataSourceConfigListQuery(baseOptions?: Apollo.QueryHookOptions<DataSourceConfigListQuery, DataSourceConfigListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceConfigListQuery, DataSourceConfigListQueryVariables>(DataSourceConfigListDocument, options);
      }
export function useDataSourceConfigListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceConfigListQuery, DataSourceConfigListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceConfigListQuery, DataSourceConfigListQueryVariables>(DataSourceConfigListDocument, options);
        }
export type DataSourceConfigListQueryHookResult = ReturnType<typeof useDataSourceConfigListQuery>;
export type DataSourceConfigListLazyQueryHookResult = ReturnType<typeof useDataSourceConfigListLazyQuery>;
export type DataSourceConfigListQueryResult = Apollo.QueryResult<DataSourceConfigListQuery, DataSourceConfigListQueryVariables>;
export function refetchDataSourceConfigListQuery(variables?: DataSourceConfigListQueryVariables) {
      return { query: DataSourceConfigListDocument, variables: variables }
    }
export const KineticFormsDocument = gql`
    query KineticForms($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String, $module: KineticModule) {
  kineticForms(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit, module: $module}
  ) {
    edges {
      node {
        ...KineticForm
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${KineticFormFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useKineticFormsQuery__
 *
 * To run a query within a React component, call `useKineticFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useKineticFormsQuery(baseOptions?: Apollo.QueryHookOptions<KineticFormsQuery, KineticFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormsQuery, KineticFormsQueryVariables>(KineticFormsDocument, options);
      }
export function useKineticFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormsQuery, KineticFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormsQuery, KineticFormsQueryVariables>(KineticFormsDocument, options);
        }
export type KineticFormsQueryHookResult = ReturnType<typeof useKineticFormsQuery>;
export type KineticFormsLazyQueryHookResult = ReturnType<typeof useKineticFormsLazyQuery>;
export type KineticFormsQueryResult = Apollo.QueryResult<KineticFormsQuery, KineticFormsQueryVariables>;
export function refetchKineticFormsQuery(variables?: KineticFormsQueryVariables) {
      return { query: KineticFormsDocument, variables: variables }
    }
export const KineticFormDetailDocument = gql`
    query KineticFormDetail($id: ID!) {
  kineticForm(id: $id) {
    ...KineticForm
  }
}
    ${KineticFormFragmentDoc}`;

/**
 * __useKineticFormDetailQuery__
 *
 * To run a query within a React component, call `useKineticFormDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKineticFormDetailQuery(baseOptions: Apollo.QueryHookOptions<KineticFormDetailQuery, KineticFormDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormDetailQuery, KineticFormDetailQueryVariables>(KineticFormDetailDocument, options);
      }
export function useKineticFormDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormDetailQuery, KineticFormDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormDetailQuery, KineticFormDetailQueryVariables>(KineticFormDetailDocument, options);
        }
export type KineticFormDetailQueryHookResult = ReturnType<typeof useKineticFormDetailQuery>;
export type KineticFormDetailLazyQueryHookResult = ReturnType<typeof useKineticFormDetailLazyQuery>;
export type KineticFormDetailQueryResult = Apollo.QueryResult<KineticFormDetailQuery, KineticFormDetailQueryVariables>;
export function refetchKineticFormDetailQuery(variables: KineticFormDetailQueryVariables) {
      return { query: KineticFormDetailDocument, variables: variables }
    }
export const KineticFormFieldsDocument = gql`
    query KineticFormFields($sortOrder: SortOrder = ASCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  kineticFormFields(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        ...KineticFormFieldFragment
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${KineticFormFieldFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useKineticFormFieldsQuery__
 *
 * To run a query within a React component, call `useKineticFormFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormFieldsQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useKineticFormFieldsQuery(baseOptions?: Apollo.QueryHookOptions<KineticFormFieldsQuery, KineticFormFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormFieldsQuery, KineticFormFieldsQueryVariables>(KineticFormFieldsDocument, options);
      }
export function useKineticFormFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormFieldsQuery, KineticFormFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormFieldsQuery, KineticFormFieldsQueryVariables>(KineticFormFieldsDocument, options);
        }
export type KineticFormFieldsQueryHookResult = ReturnType<typeof useKineticFormFieldsQuery>;
export type KineticFormFieldsLazyQueryHookResult = ReturnType<typeof useKineticFormFieldsLazyQuery>;
export type KineticFormFieldsQueryResult = Apollo.QueryResult<KineticFormFieldsQuery, KineticFormFieldsQueryVariables>;
export function refetchKineticFormFieldsQuery(variables?: KineticFormFieldsQueryVariables) {
      return { query: KineticFormFieldsDocument, variables: variables }
    }
export const KineticFormFieldDetailDocument = gql`
    query KineticFormFieldDetail($id: ID!) {
  kineticFormField(id: $id) {
    ...KineticFormFieldFragment
  }
}
    ${KineticFormFieldFragmentFragmentDoc}`;

/**
 * __useKineticFormFieldDetailQuery__
 *
 * To run a query within a React component, call `useKineticFormFieldDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticFormFieldDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticFormFieldDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKineticFormFieldDetailQuery(baseOptions: Apollo.QueryHookOptions<KineticFormFieldDetailQuery, KineticFormFieldDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KineticFormFieldDetailQuery, KineticFormFieldDetailQueryVariables>(KineticFormFieldDetailDocument, options);
      }
export function useKineticFormFieldDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KineticFormFieldDetailQuery, KineticFormFieldDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KineticFormFieldDetailQuery, KineticFormFieldDetailQueryVariables>(KineticFormFieldDetailDocument, options);
        }
export type KineticFormFieldDetailQueryHookResult = ReturnType<typeof useKineticFormFieldDetailQuery>;
export type KineticFormFieldDetailLazyQueryHookResult = ReturnType<typeof useKineticFormFieldDetailLazyQuery>;
export type KineticFormFieldDetailQueryResult = Apollo.QueryResult<KineticFormFieldDetailQuery, KineticFormFieldDetailQueryVariables>;
export function refetchKineticFormFieldDetailQuery(variables: KineticFormFieldDetailQueryVariables) {
      return { query: KineticFormFieldDetailDocument, variables: variables }
    }
export const GetTaskProgressDocument = gql`
    query getTaskProgress($query: TaskProgressQuery!) {
  taskProgress(query: $query) {
    edges {
      cursor
      node {
        ...TaskProgressFragment
      }
    }
  }
}
    ${TaskProgressFragmentFragmentDoc}`;

/**
 * __useGetTaskProgressQuery__
 *
 * To run a query within a React component, call `useGetTaskProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskProgressQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetTaskProgressQuery(baseOptions: Apollo.QueryHookOptions<GetTaskProgressQuery, GetTaskProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskProgressQuery, GetTaskProgressQueryVariables>(GetTaskProgressDocument, options);
      }
export function useGetTaskProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskProgressQuery, GetTaskProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskProgressQuery, GetTaskProgressQueryVariables>(GetTaskProgressDocument, options);
        }
export type GetTaskProgressQueryHookResult = ReturnType<typeof useGetTaskProgressQuery>;
export type GetTaskProgressLazyQueryHookResult = ReturnType<typeof useGetTaskProgressLazyQuery>;
export type GetTaskProgressQueryResult = Apollo.QueryResult<GetTaskProgressQuery, GetTaskProgressQueryVariables>;
export function refetchGetTaskProgressQuery(variables: GetTaskProgressQueryVariables) {
      return { query: GetTaskProgressDocument, variables: variables }
    }
export const TaskProgressUpdatedDocument = gql`
    subscription taskProgressUpdated {
  taskProgressUpdated {
    ...TaskProgressFragment
  }
}
    ${TaskProgressFragmentFragmentDoc}`;

/**
 * __useTaskProgressUpdatedSubscription__
 *
 * To run a query within a React component, call `useTaskProgressUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTaskProgressUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskProgressUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTaskProgressUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TaskProgressUpdatedSubscription, TaskProgressUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TaskProgressUpdatedSubscription, TaskProgressUpdatedSubscriptionVariables>(TaskProgressUpdatedDocument, options);
      }
export type TaskProgressUpdatedSubscriptionHookResult = ReturnType<typeof useTaskProgressUpdatedSubscription>;
export type TaskProgressUpdatedSubscriptionResult = Apollo.SubscriptionResult<TaskProgressUpdatedSubscription>;
export const CentralAuthenticationSettingsDocument = gql`
    query CentralAuthenticationSettings {
  kineticAuthSettings {
    id
    name
    type
    sections {
      name
      id
      fields {
        id
        name
        label
        type
        required
        hint
        sourceId
        defaultValue
        loading
        showInput
        options {
          label
          value
        }
      }
    }
  }
}
    `;

/**
 * __useCentralAuthenticationSettingsQuery__
 *
 * To run a query within a React component, call `useCentralAuthenticationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCentralAuthenticationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCentralAuthenticationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCentralAuthenticationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<CentralAuthenticationSettingsQuery, CentralAuthenticationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CentralAuthenticationSettingsQuery, CentralAuthenticationSettingsQueryVariables>(CentralAuthenticationSettingsDocument, options);
      }
export function useCentralAuthenticationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CentralAuthenticationSettingsQuery, CentralAuthenticationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CentralAuthenticationSettingsQuery, CentralAuthenticationSettingsQueryVariables>(CentralAuthenticationSettingsDocument, options);
        }
export type CentralAuthenticationSettingsQueryHookResult = ReturnType<typeof useCentralAuthenticationSettingsQuery>;
export type CentralAuthenticationSettingsLazyQueryHookResult = ReturnType<typeof useCentralAuthenticationSettingsLazyQuery>;
export type CentralAuthenticationSettingsQueryResult = Apollo.QueryResult<CentralAuthenticationSettingsQuery, CentralAuthenticationSettingsQueryVariables>;
export function refetchCentralAuthenticationSettingsQuery(variables?: CentralAuthenticationSettingsQueryVariables) {
      return { query: CentralAuthenticationSettingsDocument, variables: variables }
    }
export const SaveCentralAuthenticationSettingsDocument = gql`
    mutation SaveCentralAuthenticationSettings($settings: JSON!) {
  saveKineticAuthSettings(settings: $settings)
}
    `;
export type SaveCentralAuthenticationSettingsMutationFn = Apollo.MutationFunction<SaveCentralAuthenticationSettingsMutation, SaveCentralAuthenticationSettingsMutationVariables>;

/**
 * __useSaveCentralAuthenticationSettingsMutation__
 *
 * To run a mutation, you first call `useSaveCentralAuthenticationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCentralAuthenticationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCentralAuthenticationSettingsMutation, { data, loading, error }] = useSaveCentralAuthenticationSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveCentralAuthenticationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveCentralAuthenticationSettingsMutation, SaveCentralAuthenticationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCentralAuthenticationSettingsMutation, SaveCentralAuthenticationSettingsMutationVariables>(SaveCentralAuthenticationSettingsDocument, options);
      }
export type SaveCentralAuthenticationSettingsMutationHookResult = ReturnType<typeof useSaveCentralAuthenticationSettingsMutation>;
export type SaveCentralAuthenticationSettingsMutationResult = Apollo.MutationResult<SaveCentralAuthenticationSettingsMutation>;
export type SaveCentralAuthenticationSettingsMutationOptions = Apollo.BaseMutationOptions<SaveCentralAuthenticationSettingsMutation, SaveCentralAuthenticationSettingsMutationVariables>;
export const DeviceViewsDocument = gql`
    query deviceViews($id: DeviceViewsProtocolEntityEnum!) {
  deviceViews(id: $id) {
    views {
      ...viewFragment
      views {
        ...viewFragment
        views {
          ...viewFragment
          views {
            ...viewFragment
            views {
              ...viewFragment
              __typename
              views {
                ...viewFragment
                __typename
              }
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    ${ViewFragmentFragmentDoc}`;

/**
 * __useDeviceViewsQuery__
 *
 * To run a query within a React component, call `useDeviceViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceViewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceViewsQuery(baseOptions: Apollo.QueryHookOptions<DeviceViewsQuery, DeviceViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceViewsQuery, DeviceViewsQueryVariables>(DeviceViewsDocument, options);
      }
export function useDeviceViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceViewsQuery, DeviceViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceViewsQuery, DeviceViewsQueryVariables>(DeviceViewsDocument, options);
        }
export type DeviceViewsQueryHookResult = ReturnType<typeof useDeviceViewsQuery>;
export type DeviceViewsLazyQueryHookResult = ReturnType<typeof useDeviceViewsLazyQuery>;
export type DeviceViewsQueryResult = Apollo.QueryResult<DeviceViewsQuery, DeviceViewsQueryVariables>;
export function refetchDeviceViewsQuery(variables: DeviceViewsQueryVariables) {
      return { query: DeviceViewsDocument, variables: variables }
    }
export const CentralAuthPinSettingsDocument = gql`
    query centralAuthPinSettings {
  centralAuthPinSettings {
    id
    pin
  }
}
    `;

/**
 * __useCentralAuthPinSettingsQuery__
 *
 * To run a query within a React component, call `useCentralAuthPinSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCentralAuthPinSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCentralAuthPinSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCentralAuthPinSettingsQuery(baseOptions?: Apollo.QueryHookOptions<CentralAuthPinSettingsQuery, CentralAuthPinSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CentralAuthPinSettingsQuery, CentralAuthPinSettingsQueryVariables>(CentralAuthPinSettingsDocument, options);
      }
export function useCentralAuthPinSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CentralAuthPinSettingsQuery, CentralAuthPinSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CentralAuthPinSettingsQuery, CentralAuthPinSettingsQueryVariables>(CentralAuthPinSettingsDocument, options);
        }
export type CentralAuthPinSettingsQueryHookResult = ReturnType<typeof useCentralAuthPinSettingsQuery>;
export type CentralAuthPinSettingsLazyQueryHookResult = ReturnType<typeof useCentralAuthPinSettingsLazyQuery>;
export type CentralAuthPinSettingsQueryResult = Apollo.QueryResult<CentralAuthPinSettingsQuery, CentralAuthPinSettingsQueryVariables>;
export function refetchCentralAuthPinSettingsQuery(variables?: CentralAuthPinSettingsQueryVariables) {
      return { query: CentralAuthPinSettingsDocument, variables: variables }
    }
export const ExportFormFieldsDocument = gql`
    query ExportFormFields($ids: [ID!]) {
  exportFormFields(ids: $ids)
}
    `;

/**
 * __useExportFormFieldsQuery__
 *
 * To run a query within a React component, call `useExportFormFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportFormFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportFormFieldsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useExportFormFieldsQuery(baseOptions?: Apollo.QueryHookOptions<ExportFormFieldsQuery, ExportFormFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportFormFieldsQuery, ExportFormFieldsQueryVariables>(ExportFormFieldsDocument, options);
      }
export function useExportFormFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportFormFieldsQuery, ExportFormFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportFormFieldsQuery, ExportFormFieldsQueryVariables>(ExportFormFieldsDocument, options);
        }
export type ExportFormFieldsQueryHookResult = ReturnType<typeof useExportFormFieldsQuery>;
export type ExportFormFieldsLazyQueryHookResult = ReturnType<typeof useExportFormFieldsLazyQuery>;
export type ExportFormFieldsQueryResult = Apollo.QueryResult<ExportFormFieldsQuery, ExportFormFieldsQueryVariables>;
export function refetchExportFormFieldsQuery(variables?: ExportFormFieldsQueryVariables) {
      return { query: ExportFormFieldsDocument, variables: variables }
    }
export const ExportFormsDocument = gql`
    query ExportForms($ids: [ID!]) {
  exportForms(ids: $ids)
}
    `;

/**
 * __useExportFormsQuery__
 *
 * To run a query within a React component, call `useExportFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportFormsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useExportFormsQuery(baseOptions?: Apollo.QueryHookOptions<ExportFormsQuery, ExportFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportFormsQuery, ExportFormsQueryVariables>(ExportFormsDocument, options);
      }
export function useExportFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportFormsQuery, ExportFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportFormsQuery, ExportFormsQueryVariables>(ExportFormsDocument, options);
        }
export type ExportFormsQueryHookResult = ReturnType<typeof useExportFormsQuery>;
export type ExportFormsLazyQueryHookResult = ReturnType<typeof useExportFormsLazyQuery>;
export type ExportFormsQueryResult = Apollo.QueryResult<ExportFormsQuery, ExportFormsQueryVariables>;
export function refetchExportFormsQuery(variables?: ExportFormsQueryVariables) {
      return { query: ExportFormsDocument, variables: variables }
    }
export const TaskUpdatedDocument = gql`
    subscription TaskUpdated($ids: [ID!], $creation: Boolean, $deletion: Boolean) {
  taskUpdated(ids: $ids, creation: $creation, deletion: $deletion) {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;

/**
 * __useTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      creation: // value for 'creation'
 *      deletion: // value for 'deletion'
 *   },
 * });
 */
export function useTaskUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TaskUpdatedSubscription, TaskUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TaskUpdatedSubscription, TaskUpdatedSubscriptionVariables>(TaskUpdatedDocument, options);
      }
export type TaskUpdatedSubscriptionHookResult = ReturnType<typeof useTaskUpdatedSubscription>;
export type TaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<TaskUpdatedSubscription>;
export const SaveTollingModuleSettingsDocument = gql`
    mutation SaveTollingModuleSettings($settings: JSON!) {
  saveTollingModuleSettings(settings: $settings)
}
    `;
export type SaveTollingModuleSettingsMutationFn = Apollo.MutationFunction<SaveTollingModuleSettingsMutation, SaveTollingModuleSettingsMutationVariables>;

/**
 * __useSaveTollingModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveTollingModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTollingModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTollingModuleSettingsMutation, { data, loading, error }] = useSaveTollingModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveTollingModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveTollingModuleSettingsMutation, SaveTollingModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTollingModuleSettingsMutation, SaveTollingModuleSettingsMutationVariables>(SaveTollingModuleSettingsDocument, options);
      }
export type SaveTollingModuleSettingsMutationHookResult = ReturnType<typeof useSaveTollingModuleSettingsMutation>;
export type SaveTollingModuleSettingsMutationResult = Apollo.MutationResult<SaveTollingModuleSettingsMutation>;
export type SaveTollingModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveTollingModuleSettingsMutation, SaveTollingModuleSettingsMutationVariables>;
export const TollingPointNamesDocument = gql`
    query TollingPointNames($limit: Int = 10000) {
  tollingPoints(query: {limit: $limit}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTollingPointNamesQuery__
 *
 * To run a query within a React component, call `useTollingPointNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPointNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPointNamesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTollingPointNamesQuery(baseOptions?: Apollo.QueryHookOptions<TollingPointNamesQuery, TollingPointNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPointNamesQuery, TollingPointNamesQueryVariables>(TollingPointNamesDocument, options);
      }
export function useTollingPointNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPointNamesQuery, TollingPointNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPointNamesQuery, TollingPointNamesQueryVariables>(TollingPointNamesDocument, options);
        }
export type TollingPointNamesQueryHookResult = ReturnType<typeof useTollingPointNamesQuery>;
export type TollingPointNamesLazyQueryHookResult = ReturnType<typeof useTollingPointNamesLazyQuery>;
export type TollingPointNamesQueryResult = Apollo.QueryResult<TollingPointNamesQuery, TollingPointNamesQueryVariables>;
export function refetchTollingPointNamesQuery(variables?: TollingPointNamesQueryVariables) {
      return { query: TollingPointNamesDocument, variables: variables }
    }
export const TollingAlarmConfigsDocument = gql`
    query TollingAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "TOLLING"}, {field: "entityType", operator: EQUALS, value: "TOLLING_POINT"}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTollingAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useTollingAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTollingAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<TollingAlarmConfigsQuery, TollingAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingAlarmConfigsQuery, TollingAlarmConfigsQueryVariables>(TollingAlarmConfigsDocument, options);
      }
export function useTollingAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingAlarmConfigsQuery, TollingAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingAlarmConfigsQuery, TollingAlarmConfigsQueryVariables>(TollingAlarmConfigsDocument, options);
        }
export type TollingAlarmConfigsQueryHookResult = ReturnType<typeof useTollingAlarmConfigsQuery>;
export type TollingAlarmConfigsLazyQueryHookResult = ReturnType<typeof useTollingAlarmConfigsLazyQuery>;
export type TollingAlarmConfigsQueryResult = Apollo.QueryResult<TollingAlarmConfigsQuery, TollingAlarmConfigsQueryVariables>;
export function refetchTollingAlarmConfigsQuery(variables?: TollingAlarmConfigsQueryVariables) {
      return { query: TollingAlarmConfigsDocument, variables: variables }
    }
export const TollingModuleSettingsDocument = gql`
    query TollingModuleSettings {
  tollingModuleSettings {
    id
    name
    views {
      id
      name
      views {
        ...FormViewFragment
      }
    }
    sections {
      ...ModuleFormSectionFragment
    }
    type
  }
}
    ${FormViewFragmentFragmentDoc}
${ModuleFormSectionFragmentFragmentDoc}`;

/**
 * __useTollingModuleSettingsQuery__
 *
 * To run a query within a React component, call `useTollingModuleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingModuleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingModuleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTollingModuleSettingsQuery(baseOptions?: Apollo.QueryHookOptions<TollingModuleSettingsQuery, TollingModuleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingModuleSettingsQuery, TollingModuleSettingsQueryVariables>(TollingModuleSettingsDocument, options);
      }
export function useTollingModuleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingModuleSettingsQuery, TollingModuleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingModuleSettingsQuery, TollingModuleSettingsQueryVariables>(TollingModuleSettingsDocument, options);
        }
export type TollingModuleSettingsQueryHookResult = ReturnType<typeof useTollingModuleSettingsQuery>;
export type TollingModuleSettingsLazyQueryHookResult = ReturnType<typeof useTollingModuleSettingsLazyQuery>;
export type TollingModuleSettingsQueryResult = Apollo.QueryResult<TollingModuleSettingsQuery, TollingModuleSettingsQueryVariables>;
export function refetchTollingModuleSettingsQuery(variables?: TollingModuleSettingsQueryVariables) {
      return { query: TollingModuleSettingsDocument, variables: variables }
    }
export const ActivateTollPointDocument = gql`
    mutation ActivateTollPoint($id: ID!) {
  activateTollPoint(id: $id) {
    requestId
    failure
    success
    id
  }
}
    `;
export type ActivateTollPointMutationFn = Apollo.MutationFunction<ActivateTollPointMutation, ActivateTollPointMutationVariables>;

/**
 * __useActivateTollPointMutation__
 *
 * To run a mutation, you first call `useActivateTollPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTollPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTollPointMutation, { data, loading, error }] = useActivateTollPointMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateTollPointMutation(baseOptions?: Apollo.MutationHookOptions<ActivateTollPointMutation, ActivateTollPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateTollPointMutation, ActivateTollPointMutationVariables>(ActivateTollPointDocument, options);
      }
export type ActivateTollPointMutationHookResult = ReturnType<typeof useActivateTollPointMutation>;
export type ActivateTollPointMutationResult = Apollo.MutationResult<ActivateTollPointMutation>;
export type ActivateTollPointMutationOptions = Apollo.BaseMutationOptions<ActivateTollPointMutation, ActivateTollPointMutationVariables>;
export const RefreshTollingPointLinkStatusDocument = gql`
    mutation RefreshTollingPointLinkStatus($id: ID!) {
  refreshTollingPointLinkStatus(id: $id)
}
    `;
export type RefreshTollingPointLinkStatusMutationFn = Apollo.MutationFunction<RefreshTollingPointLinkStatusMutation, RefreshTollingPointLinkStatusMutationVariables>;

/**
 * __useRefreshTollingPointLinkStatusMutation__
 *
 * To run a mutation, you first call `useRefreshTollingPointLinkStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTollingPointLinkStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTollingPointLinkStatusMutation, { data, loading, error }] = useRefreshTollingPointLinkStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshTollingPointLinkStatusMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTollingPointLinkStatusMutation, RefreshTollingPointLinkStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTollingPointLinkStatusMutation, RefreshTollingPointLinkStatusMutationVariables>(RefreshTollingPointLinkStatusDocument, options);
      }
export type RefreshTollingPointLinkStatusMutationHookResult = ReturnType<typeof useRefreshTollingPointLinkStatusMutation>;
export type RefreshTollingPointLinkStatusMutationResult = Apollo.MutationResult<RefreshTollingPointLinkStatusMutation>;
export type RefreshTollingPointLinkStatusMutationOptions = Apollo.BaseMutationOptions<RefreshTollingPointLinkStatusMutation, RefreshTollingPointLinkStatusMutationVariables>;
export const TollPointsListDocument = gql`
    query TollPointsList($searchText: String, $searchFields: [String!] = ["name", "description", "communicationState"], $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  tollingPoints(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, sortField: $sortField, searchText: $searchText, searchFields: $searchFields, filters: $filters}
  ) {
    edges {
      node {
        id
        name
        plazaId
        reversalPlazaId
        location
        locationId
        description
        referencePoint
        plazaDirection
        locationDescription
        linkStatus
        direction
        road
        updatedAt
        tollingPointStatus
        communicationState
        isActive
        tollRoadId
        activeAlarms
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTollPointsListQuery__
 *
 * To run a query within a React component, call `useTollPointsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollPointsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollPointsListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollPointsListQuery(baseOptions?: Apollo.QueryHookOptions<TollPointsListQuery, TollPointsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollPointsListQuery, TollPointsListQueryVariables>(TollPointsListDocument, options);
      }
export function useTollPointsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollPointsListQuery, TollPointsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollPointsListQuery, TollPointsListQueryVariables>(TollPointsListDocument, options);
        }
export type TollPointsListQueryHookResult = ReturnType<typeof useTollPointsListQuery>;
export type TollPointsListLazyQueryHookResult = ReturnType<typeof useTollPointsListLazyQuery>;
export type TollPointsListQueryResult = Apollo.QueryResult<TollPointsListQuery, TollPointsListQueryVariables>;
export function refetchTollPointsListQuery(variables?: TollPointsListQueryVariables) {
      return { query: TollPointsListDocument, variables: variables }
    }
export const LiveTollingPointsListDocument = gql`
    subscription LiveTollingPointsList($ids: [ID!]!) {
  tollingPointUpdated(ids: $ids) {
    name
    plazaId
    reversalPlazaId
    plazaDirection
    location
    locationId
    description
    referencePoint
    linkStatus
    locationDescription
    direction
    road
    updatedAt
    tollingPointStatus
    communicationState
    isActive
    tollRoadId
    id
  }
}
    `;

/**
 * __useLiveTollingPointsListSubscription__
 *
 * To run a query within a React component, call `useLiveTollingPointsListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTollingPointsListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTollingPointsListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveTollingPointsListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveTollingPointsListSubscription, LiveTollingPointsListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveTollingPointsListSubscription, LiveTollingPointsListSubscriptionVariables>(LiveTollingPointsListDocument, options);
      }
export type LiveTollingPointsListSubscriptionHookResult = ReturnType<typeof useLiveTollingPointsListSubscription>;
export type LiveTollingPointsListSubscriptionResult = Apollo.SubscriptionResult<LiveTollingPointsListSubscription>;
export const TollPointSwitcherOptionsDocument = gql`
    query TollPointSwitcherOptions {
  tollingPoints {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTollPointSwitcherOptionsQuery__
 *
 * To run a query within a React component, call `useTollPointSwitcherOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollPointSwitcherOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollPointSwitcherOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTollPointSwitcherOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TollPointSwitcherOptionsQuery, TollPointSwitcherOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollPointSwitcherOptionsQuery, TollPointSwitcherOptionsQueryVariables>(TollPointSwitcherOptionsDocument, options);
      }
export function useTollPointSwitcherOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollPointSwitcherOptionsQuery, TollPointSwitcherOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollPointSwitcherOptionsQuery, TollPointSwitcherOptionsQueryVariables>(TollPointSwitcherOptionsDocument, options);
        }
export type TollPointSwitcherOptionsQueryHookResult = ReturnType<typeof useTollPointSwitcherOptionsQuery>;
export type TollPointSwitcherOptionsLazyQueryHookResult = ReturnType<typeof useTollPointSwitcherOptionsLazyQuery>;
export type TollPointSwitcherOptionsQueryResult = Apollo.QueryResult<TollPointSwitcherOptionsQuery, TollPointSwitcherOptionsQueryVariables>;
export function refetchTollPointSwitcherOptionsQuery(variables?: TollPointSwitcherOptionsQueryVariables) {
      return { query: TollPointSwitcherOptionsDocument, variables: variables }
    }
export const TollingPointOptionsDocument = gql`
    query TollingPointOptions($ids: Object!, $searchText: String) {
  tollingPoints(
    query: {filters: [{operator: IN, value: $ids, field: "id"}], searchText: $searchText, limit: 100}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTollingPointOptionsQuery__
 *
 * To run a query within a React component, call `useTollingPointOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPointOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPointOptionsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useTollingPointOptionsQuery(baseOptions: Apollo.QueryHookOptions<TollingPointOptionsQuery, TollingPointOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPointOptionsQuery, TollingPointOptionsQueryVariables>(TollingPointOptionsDocument, options);
      }
export function useTollingPointOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPointOptionsQuery, TollingPointOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPointOptionsQuery, TollingPointOptionsQueryVariables>(TollingPointOptionsDocument, options);
        }
export type TollingPointOptionsQueryHookResult = ReturnType<typeof useTollingPointOptionsQuery>;
export type TollingPointOptionsLazyQueryHookResult = ReturnType<typeof useTollingPointOptionsLazyQuery>;
export type TollingPointOptionsQueryResult = Apollo.QueryResult<TollingPointOptionsQuery, TollingPointOptionsQueryVariables>;
export function refetchTollingPointOptionsQuery(variables: TollingPointOptionsQueryVariables) {
      return { query: TollingPointOptionsDocument, variables: variables }
    }
export const TollingPointMapListDocument = gql`
    query TollingPointMapList($filters: [FilterInput]) {
  tollingPoints(query: {filters: $filters, limit: 1000}) {
    edges {
      node {
        id
        location
        tollingPointStatus
        communicationState
        isActive
      }
    }
  }
}
    `;

/**
 * __useTollingPointMapListQuery__
 *
 * To run a query within a React component, call `useTollingPointMapListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPointMapListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPointMapListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTollingPointMapListQuery(baseOptions?: Apollo.QueryHookOptions<TollingPointMapListQuery, TollingPointMapListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPointMapListQuery, TollingPointMapListQueryVariables>(TollingPointMapListDocument, options);
      }
export function useTollingPointMapListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPointMapListQuery, TollingPointMapListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPointMapListQuery, TollingPointMapListQueryVariables>(TollingPointMapListDocument, options);
        }
export type TollingPointMapListQueryHookResult = ReturnType<typeof useTollingPointMapListQuery>;
export type TollingPointMapListLazyQueryHookResult = ReturnType<typeof useTollingPointMapListLazyQuery>;
export type TollingPointMapListQueryResult = Apollo.QueryResult<TollingPointMapListQuery, TollingPointMapListQueryVariables>;
export function refetchTollingPointMapListQuery(variables?: TollingPointMapListQueryVariables) {
      return { query: TollingPointMapListDocument, variables: variables }
    }
export const TollingPointMapTooltipDocument = gql`
    query TollingPointMapTooltip($id: ID!) {
  tollingPoint(id: $id) {
    id
    name
    description
    isActive
    plazaId
    tollingPointStatus
    communicationState
    road
    referencePoint
    direction
    updatedAt
  }
}
    `;

/**
 * __useTollingPointMapTooltipQuery__
 *
 * To run a query within a React component, call `useTollingPointMapTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPointMapTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPointMapTooltipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingPointMapTooltipQuery(baseOptions: Apollo.QueryHookOptions<TollingPointMapTooltipQuery, TollingPointMapTooltipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPointMapTooltipQuery, TollingPointMapTooltipQueryVariables>(TollingPointMapTooltipDocument, options);
      }
export function useTollingPointMapTooltipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPointMapTooltipQuery, TollingPointMapTooltipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPointMapTooltipQuery, TollingPointMapTooltipQueryVariables>(TollingPointMapTooltipDocument, options);
        }
export type TollingPointMapTooltipQueryHookResult = ReturnType<typeof useTollingPointMapTooltipQuery>;
export type TollingPointMapTooltipLazyQueryHookResult = ReturnType<typeof useTollingPointMapTooltipLazyQuery>;
export type TollingPointMapTooltipQueryResult = Apollo.QueryResult<TollingPointMapTooltipQuery, TollingPointMapTooltipQueryVariables>;
export function refetchTollingPointMapTooltipQuery(variables: TollingPointMapTooltipQueryVariables) {
      return { query: TollingPointMapTooltipDocument, variables: variables }
    }
export const TollPointDetailsDocument = gql`
    query TollPointDetails($id: ID!) {
  tollingPoint(id: $id) {
    id
    name
    plazaId
    reversalPlazaId
    location
    locationId
    description
    referencePoint
    locationDescription
    linkStatus
    direction
    road
    updatedAt
    tollingPointStatus
    communicationState
    isActive
    tollRoadId
  }
}
    `;

/**
 * __useTollPointDetailsQuery__
 *
 * To run a query within a React component, call `useTollPointDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollPointDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollPointDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollPointDetailsQuery(baseOptions: Apollo.QueryHookOptions<TollPointDetailsQuery, TollPointDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollPointDetailsQuery, TollPointDetailsQueryVariables>(TollPointDetailsDocument, options);
      }
export function useTollPointDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollPointDetailsQuery, TollPointDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollPointDetailsQuery, TollPointDetailsQueryVariables>(TollPointDetailsDocument, options);
        }
export type TollPointDetailsQueryHookResult = ReturnType<typeof useTollPointDetailsQuery>;
export type TollPointDetailsLazyQueryHookResult = ReturnType<typeof useTollPointDetailsLazyQuery>;
export type TollPointDetailsQueryResult = Apollo.QueryResult<TollPointDetailsQuery, TollPointDetailsQueryVariables>;
export function refetchTollPointDetailsQuery(variables: TollPointDetailsQueryVariables) {
      return { query: TollPointDetailsDocument, variables: variables }
    }
export const TollingPointSearchListDocument = gql`
    query TollingPointSearchList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  tollingPoints(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        location
        name
        id
      }
    }
  }
}
    `;

/**
 * __useTollingPointSearchListQuery__
 *
 * To run a query within a React component, call `useTollingPointSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPointSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPointSearchListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTollingPointSearchListQuery(baseOptions?: Apollo.QueryHookOptions<TollingPointSearchListQuery, TollingPointSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPointSearchListQuery, TollingPointSearchListQueryVariables>(TollingPointSearchListDocument, options);
      }
export function useTollingPointSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPointSearchListQuery, TollingPointSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPointSearchListQuery, TollingPointSearchListQueryVariables>(TollingPointSearchListDocument, options);
        }
export type TollingPointSearchListQueryHookResult = ReturnType<typeof useTollingPointSearchListQuery>;
export type TollingPointSearchListLazyQueryHookResult = ReturnType<typeof useTollingPointSearchListLazyQuery>;
export type TollingPointSearchListQueryResult = Apollo.QueryResult<TollingPointSearchListQuery, TollingPointSearchListQueryVariables>;
export function refetchTollingPointSearchListQuery(variables?: TollingPointSearchListQueryVariables) {
      return { query: TollingPointSearchListDocument, variables: variables }
    }
export const TollingPointStatusCountsDocument = gql`
    query TollingPointStatusCounts {
  DISABLED: tollingPoints(
    query: {filters: [{operator: EQUALS, field: "communicationState", value: "DISABLED"}]}
  ) {
    totalCount
  }
  FAILED: tollingPoints(
    query: {filters: [{operator: EQUALS, field: "communicationState", value: "FAILED"}]}
  ) {
    totalCount
  }
  NO_DATA: tollingPoints(
    query: {filters: [{operator: EQUALS, field: "communicationState", value: "NO_DATA"}]}
  ) {
    totalCount
  }
  OPERATIONAL: tollingPoints(
    query: {filters: [{operator: EQUALS, field: "communicationState", value: "OPERATIONAL"}]}
  ) {
    totalCount
  }
  OPERATIONAL_WITH_ERROR: tollingPoints(
    query: {filters: [{operator: EQUALS, field: "communicationState", value: "OPERATIONAL_WITH_ERROR"}]}
  ) {
    totalCount
  }
  OPERATIONAL_WITH_WARNING: tollingPoints(
    query: {filters: [{operator: EQUALS, field: "communicationState", value: "OPERATIONAL_WITH_WARNING"}]}
  ) {
    totalCount
  }
  SUSPECT: tollingPoints(
    query: {filters: [{operator: EQUALS, field: "communicationState", value: "SUSPECT"}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useTollingPointStatusCountsQuery__
 *
 * To run a query within a React component, call `useTollingPointStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPointStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPointStatusCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTollingPointStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<TollingPointStatusCountsQuery, TollingPointStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPointStatusCountsQuery, TollingPointStatusCountsQueryVariables>(TollingPointStatusCountsDocument, options);
      }
export function useTollingPointStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPointStatusCountsQuery, TollingPointStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPointStatusCountsQuery, TollingPointStatusCountsQueryVariables>(TollingPointStatusCountsDocument, options);
        }
export type TollingPointStatusCountsQueryHookResult = ReturnType<typeof useTollingPointStatusCountsQuery>;
export type TollingPointStatusCountsLazyQueryHookResult = ReturnType<typeof useTollingPointStatusCountsLazyQuery>;
export type TollingPointStatusCountsQueryResult = Apollo.QueryResult<TollingPointStatusCountsQuery, TollingPointStatusCountsQueryVariables>;
export function refetchTollingPointStatusCountsQuery(variables?: TollingPointStatusCountsQueryVariables) {
      return { query: TollingPointStatusCountsDocument, variables: variables }
    }
export const TollingPointsByIdDocument = gql`
    query TollingPointsById($ids: Object!) {
  tollingPoints(query: {filters: [{operator: IN, field: "id", value: $ids}]}) {
    edges {
      node {
        id
        name
        location
        locationId
        description
        communicationState
      }
    }
  }
}
    `;

/**
 * __useTollingPointsByIdQuery__
 *
 * To run a query within a React component, call `useTollingPointsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPointsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPointsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTollingPointsByIdQuery(baseOptions: Apollo.QueryHookOptions<TollingPointsByIdQuery, TollingPointsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPointsByIdQuery, TollingPointsByIdQueryVariables>(TollingPointsByIdDocument, options);
      }
export function useTollingPointsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPointsByIdQuery, TollingPointsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPointsByIdQuery, TollingPointsByIdQueryVariables>(TollingPointsByIdDocument, options);
        }
export type TollingPointsByIdQueryHookResult = ReturnType<typeof useTollingPointsByIdQuery>;
export type TollingPointsByIdLazyQueryHookResult = ReturnType<typeof useTollingPointsByIdLazyQuery>;
export type TollingPointsByIdQueryResult = Apollo.QueryResult<TollingPointsByIdQuery, TollingPointsByIdQueryVariables>;
export function refetchTollingPointsByIdQuery(variables: TollingPointsByIdQueryVariables) {
      return { query: TollingPointsByIdDocument, variables: variables }
    }
export const TollingPointGateGroupsDocument = gql`
    query TollingPointGateGroups($id: ID!) {
  tollingPointGateGroups(id: $id) {
    referencePoint
    direction
    rampType
    status
    name
    id
  }
}
    `;

/**
 * __useTollingPointGateGroupsQuery__
 *
 * To run a query within a React component, call `useTollingPointGateGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPointGateGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPointGateGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingPointGateGroupsQuery(baseOptions: Apollo.QueryHookOptions<TollingPointGateGroupsQuery, TollingPointGateGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPointGateGroupsQuery, TollingPointGateGroupsQueryVariables>(TollingPointGateGroupsDocument, options);
      }
export function useTollingPointGateGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPointGateGroupsQuery, TollingPointGateGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPointGateGroupsQuery, TollingPointGateGroupsQueryVariables>(TollingPointGateGroupsDocument, options);
        }
export type TollingPointGateGroupsQueryHookResult = ReturnType<typeof useTollingPointGateGroupsQuery>;
export type TollingPointGateGroupsLazyQueryHookResult = ReturnType<typeof useTollingPointGateGroupsLazyQuery>;
export type TollingPointGateGroupsQueryResult = Apollo.QueryResult<TollingPointGateGroupsQuery, TollingPointGateGroupsQueryVariables>;
export function refetchTollingPointGateGroupsQuery(variables: TollingPointGateGroupsQueryVariables) {
      return { query: TollingPointGateGroupsDocument, variables: variables }
    }
export const TollingPricingListDocument = gql`
    query TollingPricingList($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  tollingPricingList(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, sortField: $sortField, searchText: $searchText, filters: $filters}
  ) {
    edges {
      node {
        communicationStatus
        lastDataReceived
        failedPollCount
        description
        mode
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTollingPricingListQuery__
 *
 * To run a query within a React component, call `useTollingPricingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollingPricingListQuery(baseOptions?: Apollo.QueryHookOptions<TollingPricingListQuery, TollingPricingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingListQuery, TollingPricingListQueryVariables>(TollingPricingListDocument, options);
      }
export function useTollingPricingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingListQuery, TollingPricingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingListQuery, TollingPricingListQueryVariables>(TollingPricingListDocument, options);
        }
export type TollingPricingListQueryHookResult = ReturnType<typeof useTollingPricingListQuery>;
export type TollingPricingListLazyQueryHookResult = ReturnType<typeof useTollingPricingListLazyQuery>;
export type TollingPricingListQueryResult = Apollo.QueryResult<TollingPricingListQuery, TollingPricingListQueryVariables>;
export function refetchTollingPricingListQuery(variables?: TollingPricingListQueryVariables) {
      return { query: TollingPricingListDocument, variables: variables }
    }
export const LiveTollingPricingListDocument = gql`
    subscription LiveTollingPricingList($ids: [ID!]!) {
  tollingPricingUpdated(ids: $ids) {
    communicationStatus
    lastDataReceived
    failedPollCount
    description
    name
    mode
    id
  }
}
    `;

/**
 * __useLiveTollingPricingListSubscription__
 *
 * To run a query within a React component, call `useLiveTollingPricingListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTollingPricingListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTollingPricingListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveTollingPricingListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveTollingPricingListSubscription, LiveTollingPricingListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveTollingPricingListSubscription, LiveTollingPricingListSubscriptionVariables>(LiveTollingPricingListDocument, options);
      }
export type LiveTollingPricingListSubscriptionHookResult = ReturnType<typeof useLiveTollingPricingListSubscription>;
export type LiveTollingPricingListSubscriptionResult = Apollo.SubscriptionResult<LiveTollingPricingListSubscription>;
export const LiveTollingPricingDocument = gql`
    subscription LiveTollingPricing($id: ID!) {
  tollingPricingUpdated(ids: [$id]) {
    id
  }
}
    `;

/**
 * __useLiveTollingPricingSubscription__
 *
 * To run a query within a React component, call `useLiveTollingPricingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTollingPricingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTollingPricingSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLiveTollingPricingSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveTollingPricingSubscription, LiveTollingPricingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveTollingPricingSubscription, LiveTollingPricingSubscriptionVariables>(LiveTollingPricingDocument, options);
      }
export type LiveTollingPricingSubscriptionHookResult = ReturnType<typeof useLiveTollingPricingSubscription>;
export type LiveTollingPricingSubscriptionResult = Apollo.SubscriptionResult<LiveTollingPricingSubscription>;
export const TollingPricingRateOptionsDocument = gql`
    query TollingPricingRateOptions($id: ID!) {
  tollingPricingRateOptions(id: $id) {
    label
    value
  }
}
    `;

/**
 * __useTollingPricingRateOptionsQuery__
 *
 * To run a query within a React component, call `useTollingPricingRateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingRateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingRateOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingPricingRateOptionsQuery(baseOptions: Apollo.QueryHookOptions<TollingPricingRateOptionsQuery, TollingPricingRateOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingRateOptionsQuery, TollingPricingRateOptionsQueryVariables>(TollingPricingRateOptionsDocument, options);
      }
export function useTollingPricingRateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingRateOptionsQuery, TollingPricingRateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingRateOptionsQuery, TollingPricingRateOptionsQueryVariables>(TollingPricingRateOptionsDocument, options);
        }
export type TollingPricingRateOptionsQueryHookResult = ReturnType<typeof useTollingPricingRateOptionsQuery>;
export type TollingPricingRateOptionsLazyQueryHookResult = ReturnType<typeof useTollingPricingRateOptionsLazyQuery>;
export type TollingPricingRateOptionsQueryResult = Apollo.QueryResult<TollingPricingRateOptionsQuery, TollingPricingRateOptionsQueryVariables>;
export function refetchTollingPricingRateOptionsQuery(variables: TollingPricingRateOptionsQueryVariables) {
      return { query: TollingPricingRateOptionsDocument, variables: variables }
    }
export const TollingPricingDetailsDocument = gql`
    query TollingPricingDetails($id: ID!) {
  tollingPricing(id: $id) {
    name
  }
}
    `;

/**
 * __useTollingPricingDetailsQuery__
 *
 * To run a query within a React component, call `useTollingPricingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingPricingDetailsQuery(baseOptions: Apollo.QueryHookOptions<TollingPricingDetailsQuery, TollingPricingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingDetailsQuery, TollingPricingDetailsQueryVariables>(TollingPricingDetailsDocument, options);
      }
export function useTollingPricingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingDetailsQuery, TollingPricingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingDetailsQuery, TollingPricingDetailsQueryVariables>(TollingPricingDetailsDocument, options);
        }
export type TollingPricingDetailsQueryHookResult = ReturnType<typeof useTollingPricingDetailsQuery>;
export type TollingPricingDetailsLazyQueryHookResult = ReturnType<typeof useTollingPricingDetailsLazyQuery>;
export type TollingPricingDetailsQueryResult = Apollo.QueryResult<TollingPricingDetailsQuery, TollingPricingDetailsQueryVariables>;
export function refetchTollingPricingDetailsQuery(variables: TollingPricingDetailsQueryVariables) {
      return { query: TollingPricingDetailsDocument, variables: variables }
    }
export const TollingPricingCurrentRatesDocument = gql`
    query TollingPricingCurrentRates($id: ID!) {
  tollingPricing(id: $id) {
    rates {
      firstDestination
      firstRate
      secondDestination
      secondRate
      thirdDestination
      thirdRate
      name
    }
  }
}
    `;

/**
 * __useTollingPricingCurrentRatesQuery__
 *
 * To run a query within a React component, call `useTollingPricingCurrentRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingCurrentRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingCurrentRatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingPricingCurrentRatesQuery(baseOptions: Apollo.QueryHookOptions<TollingPricingCurrentRatesQuery, TollingPricingCurrentRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingCurrentRatesQuery, TollingPricingCurrentRatesQueryVariables>(TollingPricingCurrentRatesDocument, options);
      }
export function useTollingPricingCurrentRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingCurrentRatesQuery, TollingPricingCurrentRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingCurrentRatesQuery, TollingPricingCurrentRatesQueryVariables>(TollingPricingCurrentRatesDocument, options);
        }
export type TollingPricingCurrentRatesQueryHookResult = ReturnType<typeof useTollingPricingCurrentRatesQuery>;
export type TollingPricingCurrentRatesLazyQueryHookResult = ReturnType<typeof useTollingPricingCurrentRatesLazyQuery>;
export type TollingPricingCurrentRatesQueryResult = Apollo.QueryResult<TollingPricingCurrentRatesQuery, TollingPricingCurrentRatesQueryVariables>;
export function refetchTollingPricingCurrentRatesQuery(variables: TollingPricingCurrentRatesQueryVariables) {
      return { query: TollingPricingCurrentRatesDocument, variables: variables }
    }
export const TollingPricingHistoricalRatesDocument = gql`
    query TollingPricingHistoricalRates($id: ID!) {
  tollingPricing(id: $id) {
    ratesHistorical {
      secondDestination
      thirdDestination
      firstDestination
      signs
    }
  }
}
    `;

/**
 * __useTollingPricingHistoricalRatesQuery__
 *
 * To run a query within a React component, call `useTollingPricingHistoricalRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingHistoricalRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingHistoricalRatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingPricingHistoricalRatesQuery(baseOptions: Apollo.QueryHookOptions<TollingPricingHistoricalRatesQuery, TollingPricingHistoricalRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingHistoricalRatesQuery, TollingPricingHistoricalRatesQueryVariables>(TollingPricingHistoricalRatesDocument, options);
      }
export function useTollingPricingHistoricalRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingHistoricalRatesQuery, TollingPricingHistoricalRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingHistoricalRatesQuery, TollingPricingHistoricalRatesQueryVariables>(TollingPricingHistoricalRatesDocument, options);
        }
export type TollingPricingHistoricalRatesQueryHookResult = ReturnType<typeof useTollingPricingHistoricalRatesQuery>;
export type TollingPricingHistoricalRatesLazyQueryHookResult = ReturnType<typeof useTollingPricingHistoricalRatesLazyQuery>;
export type TollingPricingHistoricalRatesQueryResult = Apollo.QueryResult<TollingPricingHistoricalRatesQuery, TollingPricingHistoricalRatesQueryVariables>;
export function refetchTollingPricingHistoricalRatesQuery(variables: TollingPricingHistoricalRatesQueryVariables) {
      return { query: TollingPricingHistoricalRatesDocument, variables: variables }
    }
export const TollingPricingHistoricalRateDocument = gql`
    query TollingPricingHistoricalRate($id: ID!, $name: String!) {
  tollingPricingHistoricalRate(id: $id, name: $name) {
    secondDestination
    thirdDestination
    firstDestination
    secondRate
    thirdRate
    firstRate
    startTime
    endTime
  }
}
    `;

/**
 * __useTollingPricingHistoricalRateQuery__
 *
 * To run a query within a React component, call `useTollingPricingHistoricalRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingHistoricalRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingHistoricalRateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTollingPricingHistoricalRateQuery(baseOptions: Apollo.QueryHookOptions<TollingPricingHistoricalRateQuery, TollingPricingHistoricalRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingHistoricalRateQuery, TollingPricingHistoricalRateQueryVariables>(TollingPricingHistoricalRateDocument, options);
      }
export function useTollingPricingHistoricalRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingHistoricalRateQuery, TollingPricingHistoricalRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingHistoricalRateQuery, TollingPricingHistoricalRateQueryVariables>(TollingPricingHistoricalRateDocument, options);
        }
export type TollingPricingHistoricalRateQueryHookResult = ReturnType<typeof useTollingPricingHistoricalRateQuery>;
export type TollingPricingHistoricalRateLazyQueryHookResult = ReturnType<typeof useTollingPricingHistoricalRateLazyQuery>;
export type TollingPricingHistoricalRateQueryResult = Apollo.QueryResult<TollingPricingHistoricalRateQuery, TollingPricingHistoricalRateQueryVariables>;
export function refetchTollingPricingHistoricalRateQuery(variables: TollingPricingHistoricalRateQueryVariables) {
      return { query: TollingPricingHistoricalRateDocument, variables: variables }
    }
export const TollingPricingRateHistoryListDocument = gql`
    query TollingPricingRateHistoryList($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  tollingPricingRateHistory(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        timestamp
        rate {
          firstDestination
          firstRate
          secondDestination
          secondRate
          thirdDestination
          thirdRate
          name
        }
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTollingPricingRateHistoryListQuery__
 *
 * To run a query within a React component, call `useTollingPricingRateHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingRateHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingRateHistoryListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollingPricingRateHistoryListQuery(baseOptions?: Apollo.QueryHookOptions<TollingPricingRateHistoryListQuery, TollingPricingRateHistoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingRateHistoryListQuery, TollingPricingRateHistoryListQueryVariables>(TollingPricingRateHistoryListDocument, options);
      }
export function useTollingPricingRateHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingRateHistoryListQuery, TollingPricingRateHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingRateHistoryListQuery, TollingPricingRateHistoryListQueryVariables>(TollingPricingRateHistoryListDocument, options);
        }
export type TollingPricingRateHistoryListQueryHookResult = ReturnType<typeof useTollingPricingRateHistoryListQuery>;
export type TollingPricingRateHistoryListLazyQueryHookResult = ReturnType<typeof useTollingPricingRateHistoryListLazyQuery>;
export type TollingPricingRateHistoryListQueryResult = Apollo.QueryResult<TollingPricingRateHistoryListQuery, TollingPricingRateHistoryListQueryVariables>;
export function refetchTollingPricingRateHistoryListQuery(variables?: TollingPricingRateHistoryListQueryVariables) {
      return { query: TollingPricingRateHistoryListDocument, variables: variables }
    }
export const TollingPricingHistoricalRateHistoryListDocument = gql`
    query TollingPricingHistoricalRateHistoryList($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  tollingPricingHistoricalRateHistoryList(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        timestamp
        rate {
          firstDestination
          secondDestination
          thirdDestination
          signs
        }
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTollingPricingHistoricalRateHistoryListQuery__
 *
 * To run a query within a React component, call `useTollingPricingHistoricalRateHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingHistoricalRateHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingHistoricalRateHistoryListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollingPricingHistoricalRateHistoryListQuery(baseOptions?: Apollo.QueryHookOptions<TollingPricingHistoricalRateHistoryListQuery, TollingPricingHistoricalRateHistoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingHistoricalRateHistoryListQuery, TollingPricingHistoricalRateHistoryListQueryVariables>(TollingPricingHistoricalRateHistoryListDocument, options);
      }
export function useTollingPricingHistoricalRateHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingHistoricalRateHistoryListQuery, TollingPricingHistoricalRateHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingHistoricalRateHistoryListQuery, TollingPricingHistoricalRateHistoryListQueryVariables>(TollingPricingHistoricalRateHistoryListDocument, options);
        }
export type TollingPricingHistoricalRateHistoryListQueryHookResult = ReturnType<typeof useTollingPricingHistoricalRateHistoryListQuery>;
export type TollingPricingHistoricalRateHistoryListLazyQueryHookResult = ReturnType<typeof useTollingPricingHistoricalRateHistoryListLazyQuery>;
export type TollingPricingHistoricalRateHistoryListQueryResult = Apollo.QueryResult<TollingPricingHistoricalRateHistoryListQuery, TollingPricingHistoricalRateHistoryListQueryVariables>;
export function refetchTollingPricingHistoricalRateHistoryListQuery(variables?: TollingPricingHistoricalRateHistoryListQueryVariables) {
      return { query: TollingPricingHistoricalRateHistoryListDocument, variables: variables }
    }
export const TollingPricingHistoricalRateHistoryRatesDocument = gql`
    query TollingPricingHistoricalRateHistoryRates($id: ID!) {
  tollingPricingHistoricalRateHistory(id: $id) {
    secondDestination
    thirdDestination
    firstDestination
    secondRate
    thirdRate
    firstRate
    startTime
    endTime
  }
}
    `;

/**
 * __useTollingPricingHistoricalRateHistoryRatesQuery__
 *
 * To run a query within a React component, call `useTollingPricingHistoricalRateHistoryRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingHistoricalRateHistoryRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingHistoricalRateHistoryRatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingPricingHistoricalRateHistoryRatesQuery(baseOptions: Apollo.QueryHookOptions<TollingPricingHistoricalRateHistoryRatesQuery, TollingPricingHistoricalRateHistoryRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingHistoricalRateHistoryRatesQuery, TollingPricingHistoricalRateHistoryRatesQueryVariables>(TollingPricingHistoricalRateHistoryRatesDocument, options);
      }
export function useTollingPricingHistoricalRateHistoryRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingHistoricalRateHistoryRatesQuery, TollingPricingHistoricalRateHistoryRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingHistoricalRateHistoryRatesQuery, TollingPricingHistoricalRateHistoryRatesQueryVariables>(TollingPricingHistoricalRateHistoryRatesDocument, options);
        }
export type TollingPricingHistoricalRateHistoryRatesQueryHookResult = ReturnType<typeof useTollingPricingHistoricalRateHistoryRatesQuery>;
export type TollingPricingHistoricalRateHistoryRatesLazyQueryHookResult = ReturnType<typeof useTollingPricingHistoricalRateHistoryRatesLazyQuery>;
export type TollingPricingHistoricalRateHistoryRatesQueryResult = Apollo.QueryResult<TollingPricingHistoricalRateHistoryRatesQuery, TollingPricingHistoricalRateHistoryRatesQueryVariables>;
export function refetchTollingPricingHistoricalRateHistoryRatesQuery(variables: TollingPricingHistoricalRateHistoryRatesQueryVariables) {
      return { query: TollingPricingHistoricalRateHistoryRatesDocument, variables: variables }
    }
export const TollingPricingConfirmedRateHistoryDocument = gql`
    query TollingPricingConfirmedRateHistory($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  tollingPricingConfirmedRateHistory(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, sortField: $sortField, searchText: $searchText, filters: $filters}
  ) {
    edges {
      node {
        communicationStatus
        timestamp
        startTime
        endTime
        name
        id
        rate {
          firstDestination
          secondDestination
          thirdDestination
          firstRate
          secondRate
          thirdRate
          name
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTollingPricingConfirmedRateHistoryQuery__
 *
 * To run a query within a React component, call `useTollingPricingConfirmedRateHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingPricingConfirmedRateHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingPricingConfirmedRateHistoryQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollingPricingConfirmedRateHistoryQuery(baseOptions?: Apollo.QueryHookOptions<TollingPricingConfirmedRateHistoryQuery, TollingPricingConfirmedRateHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingPricingConfirmedRateHistoryQuery, TollingPricingConfirmedRateHistoryQueryVariables>(TollingPricingConfirmedRateHistoryDocument, options);
      }
export function useTollingPricingConfirmedRateHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingPricingConfirmedRateHistoryQuery, TollingPricingConfirmedRateHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingPricingConfirmedRateHistoryQuery, TollingPricingConfirmedRateHistoryQueryVariables>(TollingPricingConfirmedRateHistoryDocument, options);
        }
export type TollingPricingConfirmedRateHistoryQueryHookResult = ReturnType<typeof useTollingPricingConfirmedRateHistoryQuery>;
export type TollingPricingConfirmedRateHistoryLazyQueryHookResult = ReturnType<typeof useTollingPricingConfirmedRateHistoryLazyQuery>;
export type TollingPricingConfirmedRateHistoryQueryResult = Apollo.QueryResult<TollingPricingConfirmedRateHistoryQuery, TollingPricingConfirmedRateHistoryQueryVariables>;
export function refetchTollingPricingConfirmedRateHistoryQuery(variables?: TollingPricingConfirmedRateHistoryQueryVariables) {
      return { query: TollingPricingConfirmedRateHistoryDocument, variables: variables }
    }
export const TollingRoadSaveDocument = gql`
    mutation TollingRoadSave($input: TollingRoadInput!) {
  tollingRoadSave(input: $input) {
    id
  }
}
    `;
export type TollingRoadSaveMutationFn = Apollo.MutationFunction<TollingRoadSaveMutation, TollingRoadSaveMutationVariables>;

/**
 * __useTollingRoadSaveMutation__
 *
 * To run a mutation, you first call `useTollingRoadSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTollingRoadSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tollingRoadSaveMutation, { data, loading, error }] = useTollingRoadSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTollingRoadSaveMutation(baseOptions?: Apollo.MutationHookOptions<TollingRoadSaveMutation, TollingRoadSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TollingRoadSaveMutation, TollingRoadSaveMutationVariables>(TollingRoadSaveDocument, options);
      }
export type TollingRoadSaveMutationHookResult = ReturnType<typeof useTollingRoadSaveMutation>;
export type TollingRoadSaveMutationResult = Apollo.MutationResult<TollingRoadSaveMutation>;
export type TollingRoadSaveMutationOptions = Apollo.BaseMutationOptions<TollingRoadSaveMutation, TollingRoadSaveMutationVariables>;
export const TollingRoadDeleteDocument = gql`
    mutation TollingRoadDelete($id: ID!) {
  tollingRoadDelete(id: $id)
}
    `;
export type TollingRoadDeleteMutationFn = Apollo.MutationFunction<TollingRoadDeleteMutation, TollingRoadDeleteMutationVariables>;

/**
 * __useTollingRoadDeleteMutation__
 *
 * To run a mutation, you first call `useTollingRoadDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTollingRoadDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tollingRoadDeleteMutation, { data, loading, error }] = useTollingRoadDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingRoadDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TollingRoadDeleteMutation, TollingRoadDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TollingRoadDeleteMutation, TollingRoadDeleteMutationVariables>(TollingRoadDeleteDocument, options);
      }
export type TollingRoadDeleteMutationHookResult = ReturnType<typeof useTollingRoadDeleteMutation>;
export type TollingRoadDeleteMutationResult = Apollo.MutationResult<TollingRoadDeleteMutation>;
export type TollingRoadDeleteMutationOptions = Apollo.BaseMutationOptions<TollingRoadDeleteMutation, TollingRoadDeleteMutationVariables>;
export const TollRoadsListDocument = gql`
    query TollRoadsList($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  tollingRoads(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, sortField: $sortField, searchText: $searchText, filters: $filters}
  ) {
    edges {
      node {
        dynamicPricingId
        description
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTollRoadsListQuery__
 *
 * To run a query within a React component, call `useTollRoadsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollRoadsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollRoadsListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollRoadsListQuery(baseOptions?: Apollo.QueryHookOptions<TollRoadsListQuery, TollRoadsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollRoadsListQuery, TollRoadsListQueryVariables>(TollRoadsListDocument, options);
      }
export function useTollRoadsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollRoadsListQuery, TollRoadsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollRoadsListQuery, TollRoadsListQueryVariables>(TollRoadsListDocument, options);
        }
export type TollRoadsListQueryHookResult = ReturnType<typeof useTollRoadsListQuery>;
export type TollRoadsListLazyQueryHookResult = ReturnType<typeof useTollRoadsListLazyQuery>;
export type TollRoadsListQueryResult = Apollo.QueryResult<TollRoadsListQuery, TollRoadsListQueryVariables>;
export function refetchTollRoadsListQuery(variables?: TollRoadsListQueryVariables) {
      return { query: TollRoadsListDocument, variables: variables }
    }
export const TollRoadNameDocument = gql`
    query TollRoadName($id: ID!) {
  tollRoad(id: $id) {
    name
    id
  }
}
    `;

/**
 * __useTollRoadNameQuery__
 *
 * To run a query within a React component, call `useTollRoadNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollRoadNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollRoadNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollRoadNameQuery(baseOptions: Apollo.QueryHookOptions<TollRoadNameQuery, TollRoadNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollRoadNameQuery, TollRoadNameQueryVariables>(TollRoadNameDocument, options);
      }
export function useTollRoadNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollRoadNameQuery, TollRoadNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollRoadNameQuery, TollRoadNameQueryVariables>(TollRoadNameDocument, options);
        }
export type TollRoadNameQueryHookResult = ReturnType<typeof useTollRoadNameQuery>;
export type TollRoadNameLazyQueryHookResult = ReturnType<typeof useTollRoadNameLazyQuery>;
export type TollRoadNameQueryResult = Apollo.QueryResult<TollRoadNameQuery, TollRoadNameQueryVariables>;
export function refetchTollRoadNameQuery(variables: TollRoadNameQueryVariables) {
      return { query: TollRoadNameDocument, variables: variables }
    }
export const TollRoadDetailsDocument = gql`
    query TollRoadDetails($id: ID!) {
  tollRoad(id: $id) {
    dynamicPricingId
    tollingSegments
    tollingPoints
    description
    name
    id
  }
}
    `;

/**
 * __useTollRoadDetailsQuery__
 *
 * To run a query within a React component, call `useTollRoadDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollRoadDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollRoadDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollRoadDetailsQuery(baseOptions: Apollo.QueryHookOptions<TollRoadDetailsQuery, TollRoadDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollRoadDetailsQuery, TollRoadDetailsQueryVariables>(TollRoadDetailsDocument, options);
      }
export function useTollRoadDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollRoadDetailsQuery, TollRoadDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollRoadDetailsQuery, TollRoadDetailsQueryVariables>(TollRoadDetailsDocument, options);
        }
export type TollRoadDetailsQueryHookResult = ReturnType<typeof useTollRoadDetailsQuery>;
export type TollRoadDetailsLazyQueryHookResult = ReturnType<typeof useTollRoadDetailsLazyQuery>;
export type TollRoadDetailsQueryResult = Apollo.QueryResult<TollRoadDetailsQuery, TollRoadDetailsQueryVariables>;
export function refetchTollRoadDetailsQuery(variables: TollRoadDetailsQueryVariables) {
      return { query: TollRoadDetailsDocument, variables: variables }
    }
export const DynamicPricingSelectionListDocument = gql`
    query DynamicPricingSelectionList {
  integrations(
    filters: [{operator: EQUALS, value: PRICING, field: "config.integrationType"}]
    limit: 100
  ) {
    edges {
      node {
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useDynamicPricingSelectionListQuery__
 *
 * To run a query within a React component, call `useDynamicPricingSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicPricingSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicPricingSelectionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDynamicPricingSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<DynamicPricingSelectionListQuery, DynamicPricingSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicPricingSelectionListQuery, DynamicPricingSelectionListQueryVariables>(DynamicPricingSelectionListDocument, options);
      }
export function useDynamicPricingSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicPricingSelectionListQuery, DynamicPricingSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicPricingSelectionListQuery, DynamicPricingSelectionListQueryVariables>(DynamicPricingSelectionListDocument, options);
        }
export type DynamicPricingSelectionListQueryHookResult = ReturnType<typeof useDynamicPricingSelectionListQuery>;
export type DynamicPricingSelectionListLazyQueryHookResult = ReturnType<typeof useDynamicPricingSelectionListLazyQuery>;
export type DynamicPricingSelectionListQueryResult = Apollo.QueryResult<DynamicPricingSelectionListQuery, DynamicPricingSelectionListQueryVariables>;
export function refetchDynamicPricingSelectionListQuery(variables?: DynamicPricingSelectionListQueryVariables) {
      return { query: DynamicPricingSelectionListDocument, variables: variables }
    }
export const TollSegmentSelectionListDocument = gql`
    query TollSegmentSelectionList($searchFields: [String!] = ["name", "description", "destinations"], $sortOrder: SortOrder = DESCENDING, $sortField: String = "name", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  tollingSegments(
    query: {searchFields: $searchFields, searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        startReference
        endReference
        destinations
        description
        direction
        road
        name
        id
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTollSegmentSelectionListQuery__
 *
 * To run a query within a React component, call `useTollSegmentSelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollSegmentSelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollSegmentSelectionListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTollSegmentSelectionListQuery(baseOptions?: Apollo.QueryHookOptions<TollSegmentSelectionListQuery, TollSegmentSelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollSegmentSelectionListQuery, TollSegmentSelectionListQueryVariables>(TollSegmentSelectionListDocument, options);
      }
export function useTollSegmentSelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollSegmentSelectionListQuery, TollSegmentSelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollSegmentSelectionListQuery, TollSegmentSelectionListQueryVariables>(TollSegmentSelectionListDocument, options);
        }
export type TollSegmentSelectionListQueryHookResult = ReturnType<typeof useTollSegmentSelectionListQuery>;
export type TollSegmentSelectionListLazyQueryHookResult = ReturnType<typeof useTollSegmentSelectionListLazyQuery>;
export type TollSegmentSelectionListQueryResult = Apollo.QueryResult<TollSegmentSelectionListQuery, TollSegmentSelectionListQueryVariables>;
export function refetchTollSegmentSelectionListQuery(variables?: TollSegmentSelectionListQueryVariables) {
      return { query: TollSegmentSelectionListDocument, variables: variables }
    }
export const TollRoadsOptionsDocument = gql`
    query TollRoadsOptions {
  tollingRoads(query: {}) {
    edges {
      node {
        id
        name
        dynamicPricingId
      }
    }
  }
}
    `;

/**
 * __useTollRoadsOptionsQuery__
 *
 * To run a query within a React component, call `useTollRoadsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollRoadsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollRoadsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTollRoadsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TollRoadsOptionsQuery, TollRoadsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollRoadsOptionsQuery, TollRoadsOptionsQueryVariables>(TollRoadsOptionsDocument, options);
      }
export function useTollRoadsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollRoadsOptionsQuery, TollRoadsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollRoadsOptionsQuery, TollRoadsOptionsQueryVariables>(TollRoadsOptionsDocument, options);
        }
export type TollRoadsOptionsQueryHookResult = ReturnType<typeof useTollRoadsOptionsQuery>;
export type TollRoadsOptionsLazyQueryHookResult = ReturnType<typeof useTollRoadsOptionsLazyQuery>;
export type TollRoadsOptionsQueryResult = Apollo.QueryResult<TollRoadsOptionsQuery, TollRoadsOptionsQueryVariables>;
export function refetchTollRoadsOptionsQuery(variables?: TollRoadsOptionsQueryVariables) {
      return { query: TollRoadsOptionsDocument, variables: variables }
    }
export const TollRoadPricingIdDocument = gql`
    query TollRoadPricingId($id: ID!) {
  tollRoad(id: $id) {
    dynamicPricingId
  }
}
    `;

/**
 * __useTollRoadPricingIdQuery__
 *
 * To run a query within a React component, call `useTollRoadPricingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollRoadPricingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollRoadPricingIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollRoadPricingIdQuery(baseOptions: Apollo.QueryHookOptions<TollRoadPricingIdQuery, TollRoadPricingIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollRoadPricingIdQuery, TollRoadPricingIdQueryVariables>(TollRoadPricingIdDocument, options);
      }
export function useTollRoadPricingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollRoadPricingIdQuery, TollRoadPricingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollRoadPricingIdQuery, TollRoadPricingIdQueryVariables>(TollRoadPricingIdDocument, options);
        }
export type TollRoadPricingIdQueryHookResult = ReturnType<typeof useTollRoadPricingIdQuery>;
export type TollRoadPricingIdLazyQueryHookResult = ReturnType<typeof useTollRoadPricingIdLazyQuery>;
export type TollRoadPricingIdQueryResult = Apollo.QueryResult<TollRoadPricingIdQuery, TollRoadPricingIdQueryVariables>;
export function refetchTollRoadPricingIdQuery(variables: TollRoadPricingIdQueryVariables) {
      return { query: TollRoadPricingIdDocument, variables: variables }
    }
export const TollRoadPricingModeDocument = gql`
    query TollRoadPricingMode($dynamicPricingId: ID!) {
  tollingPricing(id: $dynamicPricingId) {
    id
    mode
    communicationStatus
  }
}
    `;

/**
 * __useTollRoadPricingModeQuery__
 *
 * To run a query within a React component, call `useTollRoadPricingModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollRoadPricingModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollRoadPricingModeQuery({
 *   variables: {
 *      dynamicPricingId: // value for 'dynamicPricingId'
 *   },
 * });
 */
export function useTollRoadPricingModeQuery(baseOptions: Apollo.QueryHookOptions<TollRoadPricingModeQuery, TollRoadPricingModeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollRoadPricingModeQuery, TollRoadPricingModeQueryVariables>(TollRoadPricingModeDocument, options);
      }
export function useTollRoadPricingModeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollRoadPricingModeQuery, TollRoadPricingModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollRoadPricingModeQuery, TollRoadPricingModeQueryVariables>(TollRoadPricingModeDocument, options);
        }
export type TollRoadPricingModeQueryHookResult = ReturnType<typeof useTollRoadPricingModeQuery>;
export type TollRoadPricingModeLazyQueryHookResult = ReturnType<typeof useTollRoadPricingModeLazyQuery>;
export type TollRoadPricingModeQueryResult = Apollo.QueryResult<TollRoadPricingModeQuery, TollRoadPricingModeQueryVariables>;
export function refetchTollRoadPricingModeQuery(variables: TollRoadPricingModeQueryVariables) {
      return { query: TollRoadPricingModeDocument, variables: variables }
    }
export const TollRoadSegmentsDocument = gql`
    query TollRoadSegments($id: ID!) {
  tollRoad(id: $id) {
    tollingSegments
    id
  }
}
    `;

/**
 * __useTollRoadSegmentsQuery__
 *
 * To run a query within a React component, call `useTollRoadSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollRoadSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollRoadSegmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollRoadSegmentsQuery(baseOptions: Apollo.QueryHookOptions<TollRoadSegmentsQuery, TollRoadSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollRoadSegmentsQuery, TollRoadSegmentsQueryVariables>(TollRoadSegmentsDocument, options);
      }
export function useTollRoadSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollRoadSegmentsQuery, TollRoadSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollRoadSegmentsQuery, TollRoadSegmentsQueryVariables>(TollRoadSegmentsDocument, options);
        }
export type TollRoadSegmentsQueryHookResult = ReturnType<typeof useTollRoadSegmentsQuery>;
export type TollRoadSegmentsLazyQueryHookResult = ReturnType<typeof useTollRoadSegmentsLazyQuery>;
export type TollRoadSegmentsQueryResult = Apollo.QueryResult<TollRoadSegmentsQuery, TollRoadSegmentsQueryVariables>;
export function refetchTollRoadSegmentsQuery(variables: TollRoadSegmentsQueryVariables) {
      return { query: TollRoadSegmentsDocument, variables: variables }
    }
export const TollingSegmentSaveDocument = gql`
    mutation TollingSegmentSave($input: TollingSegmentInput!) {
  tollingSegmentSave(input: $input) {
    description
    destinations
    detectors
    direction
    endReference
    id
    locationId
    name
    road
    signs
    startReference
    tollRoadId
  }
}
    `;
export type TollingSegmentSaveMutationFn = Apollo.MutationFunction<TollingSegmentSaveMutation, TollingSegmentSaveMutationVariables>;

/**
 * __useTollingSegmentSaveMutation__
 *
 * To run a mutation, you first call `useTollingSegmentSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tollingSegmentSaveMutation, { data, loading, error }] = useTollingSegmentSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTollingSegmentSaveMutation(baseOptions?: Apollo.MutationHookOptions<TollingSegmentSaveMutation, TollingSegmentSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TollingSegmentSaveMutation, TollingSegmentSaveMutationVariables>(TollingSegmentSaveDocument, options);
      }
export type TollingSegmentSaveMutationHookResult = ReturnType<typeof useTollingSegmentSaveMutation>;
export type TollingSegmentSaveMutationResult = Apollo.MutationResult<TollingSegmentSaveMutation>;
export type TollingSegmentSaveMutationOptions = Apollo.BaseMutationOptions<TollingSegmentSaveMutation, TollingSegmentSaveMutationVariables>;
export const TollingSegmentDeleteDocument = gql`
    mutation TollingSegmentDelete($id: ID!) {
  tollingSegmentDelete(id: $id)
}
    `;
export type TollingSegmentDeleteMutationFn = Apollo.MutationFunction<TollingSegmentDeleteMutation, TollingSegmentDeleteMutationVariables>;

/**
 * __useTollingSegmentDeleteMutation__
 *
 * To run a mutation, you first call `useTollingSegmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tollingSegmentDeleteMutation, { data, loading, error }] = useTollingSegmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingSegmentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TollingSegmentDeleteMutation, TollingSegmentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TollingSegmentDeleteMutation, TollingSegmentDeleteMutationVariables>(TollingSegmentDeleteDocument, options);
      }
export type TollingSegmentDeleteMutationHookResult = ReturnType<typeof useTollingSegmentDeleteMutation>;
export type TollingSegmentDeleteMutationResult = Apollo.MutationResult<TollingSegmentDeleteMutation>;
export type TollingSegmentDeleteMutationOptions = Apollo.BaseMutationOptions<TollingSegmentDeleteMutation, TollingSegmentDeleteMutationVariables>;
export const SaveTollingSegmentCommentDocument = gql`
    mutation SaveTollingSegmentComment($commentId: ID, $entityId: ID!, $mentionedUsers: [ID!], $html: String!) {
  saveTollingSegmentComment(
    commentInput: {id: $commentId, entityId: $entityId, mentionedUsers: $mentionedUsers, html: $html}
  ) {
    id
    entityId
    createdBy
    createdAt
    updatedAt
    mentionedUsers
    html
  }
}
    `;
export type SaveTollingSegmentCommentMutationFn = Apollo.MutationFunction<SaveTollingSegmentCommentMutation, SaveTollingSegmentCommentMutationVariables>;

/**
 * __useSaveTollingSegmentCommentMutation__
 *
 * To run a mutation, you first call `useSaveTollingSegmentCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTollingSegmentCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTollingSegmentCommentMutation, { data, loading, error }] = useSaveTollingSegmentCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      entityId: // value for 'entityId'
 *      mentionedUsers: // value for 'mentionedUsers'
 *      html: // value for 'html'
 *   },
 * });
 */
export function useSaveTollingSegmentCommentMutation(baseOptions?: Apollo.MutationHookOptions<SaveTollingSegmentCommentMutation, SaveTollingSegmentCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTollingSegmentCommentMutation, SaveTollingSegmentCommentMutationVariables>(SaveTollingSegmentCommentDocument, options);
      }
export type SaveTollingSegmentCommentMutationHookResult = ReturnType<typeof useSaveTollingSegmentCommentMutation>;
export type SaveTollingSegmentCommentMutationResult = Apollo.MutationResult<SaveTollingSegmentCommentMutation>;
export type SaveTollingSegmentCommentMutationOptions = Apollo.BaseMutationOptions<SaveTollingSegmentCommentMutation, SaveTollingSegmentCommentMutationVariables>;
export const DeleteTollingSegmentCommentDocument = gql`
    mutation DeleteTollingSegmentComment($commentId: ID!) {
  deleteTollingSegmentComment(id: $commentId)
}
    `;
export type DeleteTollingSegmentCommentMutationFn = Apollo.MutationFunction<DeleteTollingSegmentCommentMutation, DeleteTollingSegmentCommentMutationVariables>;

/**
 * __useDeleteTollingSegmentCommentMutation__
 *
 * To run a mutation, you first call `useDeleteTollingSegmentCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTollingSegmentCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTollingSegmentCommentMutation, { data, loading, error }] = useDeleteTollingSegmentCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteTollingSegmentCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTollingSegmentCommentMutation, DeleteTollingSegmentCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTollingSegmentCommentMutation, DeleteTollingSegmentCommentMutationVariables>(DeleteTollingSegmentCommentDocument, options);
      }
export type DeleteTollingSegmentCommentMutationHookResult = ReturnType<typeof useDeleteTollingSegmentCommentMutation>;
export type DeleteTollingSegmentCommentMutationResult = Apollo.MutationResult<DeleteTollingSegmentCommentMutation>;
export type DeleteTollingSegmentCommentMutationOptions = Apollo.BaseMutationOptions<DeleteTollingSegmentCommentMutation, DeleteTollingSegmentCommentMutationVariables>;
export const ExportCurrentHistoricalRatesDocument = gql`
    mutation ExportCurrentHistoricalRates($rate: String!) {
  exportCurrentHistoricalRates(rate: $rate)
}
    `;
export type ExportCurrentHistoricalRatesMutationFn = Apollo.MutationFunction<ExportCurrentHistoricalRatesMutation, ExportCurrentHistoricalRatesMutationVariables>;

/**
 * __useExportCurrentHistoricalRatesMutation__
 *
 * To run a mutation, you first call `useExportCurrentHistoricalRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCurrentHistoricalRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCurrentHistoricalRatesMutation, { data, loading, error }] = useExportCurrentHistoricalRatesMutation({
 *   variables: {
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useExportCurrentHistoricalRatesMutation(baseOptions?: Apollo.MutationHookOptions<ExportCurrentHistoricalRatesMutation, ExportCurrentHistoricalRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCurrentHistoricalRatesMutation, ExportCurrentHistoricalRatesMutationVariables>(ExportCurrentHistoricalRatesDocument, options);
      }
export type ExportCurrentHistoricalRatesMutationHookResult = ReturnType<typeof useExportCurrentHistoricalRatesMutation>;
export type ExportCurrentHistoricalRatesMutationResult = Apollo.MutationResult<ExportCurrentHistoricalRatesMutation>;
export type ExportCurrentHistoricalRatesMutationOptions = Apollo.BaseMutationOptions<ExportCurrentHistoricalRatesMutation, ExportCurrentHistoricalRatesMutationVariables>;
export const TollingSegmentsListDocument = gql`
    query TollingSegmentsList($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  tollingSegments(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, sortField: $sortField, searchText: $searchText, filters: $filters}
  ) {
    edges {
      node {
        id
        name
        description
        direction
        destinations
        startReference
        endReference
        tollRoadId
      }
    }
    pageInfo {
      ...CursorPageInfo
      __typename
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTollingSegmentsListQuery__
 *
 * To run a query within a React component, call `useTollingSegmentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentsListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollingSegmentsListQuery(baseOptions?: Apollo.QueryHookOptions<TollingSegmentsListQuery, TollingSegmentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentsListQuery, TollingSegmentsListQueryVariables>(TollingSegmentsListDocument, options);
      }
export function useTollingSegmentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentsListQuery, TollingSegmentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentsListQuery, TollingSegmentsListQueryVariables>(TollingSegmentsListDocument, options);
        }
export type TollingSegmentsListQueryHookResult = ReturnType<typeof useTollingSegmentsListQuery>;
export type TollingSegmentsListLazyQueryHookResult = ReturnType<typeof useTollingSegmentsListLazyQuery>;
export type TollingSegmentsListQueryResult = Apollo.QueryResult<TollingSegmentsListQuery, TollingSegmentsListQueryVariables>;
export function refetchTollingSegmentsListQuery(variables?: TollingSegmentsListQueryVariables) {
      return { query: TollingSegmentsListDocument, variables: variables }
    }
export const SegmentLocationOptionsDocument = gql`
    query SegmentLocationOptions {
  locations(
    query: {limit: 10000, filters: [{field: "locationType", operator: EQUALS, value: "Segment"}]}
  ) {
    edges {
      node {
        id
        details {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSegmentLocationOptionsQuery__
 *
 * To run a query within a React component, call `useSegmentLocationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentLocationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentLocationOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentLocationOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SegmentLocationOptionsQuery, SegmentLocationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentLocationOptionsQuery, SegmentLocationOptionsQueryVariables>(SegmentLocationOptionsDocument, options);
      }
export function useSegmentLocationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentLocationOptionsQuery, SegmentLocationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentLocationOptionsQuery, SegmentLocationOptionsQueryVariables>(SegmentLocationOptionsDocument, options);
        }
export type SegmentLocationOptionsQueryHookResult = ReturnType<typeof useSegmentLocationOptionsQuery>;
export type SegmentLocationOptionsLazyQueryHookResult = ReturnType<typeof useSegmentLocationOptionsLazyQuery>;
export type SegmentLocationOptionsQueryResult = Apollo.QueryResult<SegmentLocationOptionsQuery, SegmentLocationOptionsQueryVariables>;
export function refetchSegmentLocationOptionsQuery(variables?: SegmentLocationOptionsQueryVariables) {
      return { query: SegmentLocationOptionsDocument, variables: variables }
    }
export const TollingSegmentSignsDocument = gql`
    query TollingSegmentSigns($signIds: Object!, $limit: Int = 1000) {
  signs(filters: [{field: "id", operator: IN, value: $signIds}], limit: $limit) {
    edges {
      node {
        id
        name
        road
        direction
        referencePoint
      }
    }
  }
}
    `;

/**
 * __useTollingSegmentSignsQuery__
 *
 * To run a query within a React component, call `useTollingSegmentSignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentSignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentSignsQuery({
 *   variables: {
 *      signIds: // value for 'signIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTollingSegmentSignsQuery(baseOptions: Apollo.QueryHookOptions<TollingSegmentSignsQuery, TollingSegmentSignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentSignsQuery, TollingSegmentSignsQueryVariables>(TollingSegmentSignsDocument, options);
      }
export function useTollingSegmentSignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentSignsQuery, TollingSegmentSignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentSignsQuery, TollingSegmentSignsQueryVariables>(TollingSegmentSignsDocument, options);
        }
export type TollingSegmentSignsQueryHookResult = ReturnType<typeof useTollingSegmentSignsQuery>;
export type TollingSegmentSignsLazyQueryHookResult = ReturnType<typeof useTollingSegmentSignsLazyQuery>;
export type TollingSegmentSignsQueryResult = Apollo.QueryResult<TollingSegmentSignsQuery, TollingSegmentSignsQueryVariables>;
export function refetchTollingSegmentSignsQuery(variables: TollingSegmentSignsQueryVariables) {
      return { query: TollingSegmentSignsDocument, variables: variables }
    }
export const TollingSegmentDetectorsDocument = gql`
    query TollingSegmentDetectors($detectorIds: Object!) {
  detectors(query: {filters: [{field: "id", operator: IN, value: $detectorIds}]}) {
    edges {
      node {
        id
        name
        road
        direction
        referencePoint
      }
    }
  }
}
    `;

/**
 * __useTollingSegmentDetectorsQuery__
 *
 * To run a query within a React component, call `useTollingSegmentDetectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentDetectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentDetectorsQuery({
 *   variables: {
 *      detectorIds: // value for 'detectorIds'
 *   },
 * });
 */
export function useTollingSegmentDetectorsQuery(baseOptions: Apollo.QueryHookOptions<TollingSegmentDetectorsQuery, TollingSegmentDetectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentDetectorsQuery, TollingSegmentDetectorsQueryVariables>(TollingSegmentDetectorsDocument, options);
      }
export function useTollingSegmentDetectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentDetectorsQuery, TollingSegmentDetectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentDetectorsQuery, TollingSegmentDetectorsQueryVariables>(TollingSegmentDetectorsDocument, options);
        }
export type TollingSegmentDetectorsQueryHookResult = ReturnType<typeof useTollingSegmentDetectorsQuery>;
export type TollingSegmentDetectorsLazyQueryHookResult = ReturnType<typeof useTollingSegmentDetectorsLazyQuery>;
export type TollingSegmentDetectorsQueryResult = Apollo.QueryResult<TollingSegmentDetectorsQuery, TollingSegmentDetectorsQueryVariables>;
export function refetchTollingSegmentDetectorsQuery(variables: TollingSegmentDetectorsQueryVariables) {
      return { query: TollingSegmentDetectorsDocument, variables: variables }
    }
export const TollingSegmentFormDocument = gql`
    query TollingSegmentForm($id: ID!) {
  tollingSegment(id: $id) {
    description
    destinations
    detectors
    direction
    endReference
    id
    locationId
    name
    road
    signs
    startReference
    tollRoadId
  }
}
    `;

/**
 * __useTollingSegmentFormQuery__
 *
 * To run a query within a React component, call `useTollingSegmentFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingSegmentFormQuery(baseOptions: Apollo.QueryHookOptions<TollingSegmentFormQuery, TollingSegmentFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentFormQuery, TollingSegmentFormQueryVariables>(TollingSegmentFormDocument, options);
      }
export function useTollingSegmentFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentFormQuery, TollingSegmentFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentFormQuery, TollingSegmentFormQueryVariables>(TollingSegmentFormDocument, options);
        }
export type TollingSegmentFormQueryHookResult = ReturnType<typeof useTollingSegmentFormQuery>;
export type TollingSegmentFormLazyQueryHookResult = ReturnType<typeof useTollingSegmentFormLazyQuery>;
export type TollingSegmentFormQueryResult = Apollo.QueryResult<TollingSegmentFormQuery, TollingSegmentFormQueryVariables>;
export function refetchTollingSegmentFormQuery(variables: TollingSegmentFormQueryVariables) {
      return { query: TollingSegmentFormDocument, variables: variables }
    }
export const TollingSegmentDetailsDocument = gql`
    query TollingSegmentDetails($id: ID!) {
  tollingSegment(id: $id) {
    id
    name
    description
    destinations
  }
}
    `;

/**
 * __useTollingSegmentDetailsQuery__
 *
 * To run a query within a React component, call `useTollingSegmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingSegmentDetailsQuery(baseOptions: Apollo.QueryHookOptions<TollingSegmentDetailsQuery, TollingSegmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentDetailsQuery, TollingSegmentDetailsQueryVariables>(TollingSegmentDetailsDocument, options);
      }
export function useTollingSegmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentDetailsQuery, TollingSegmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentDetailsQuery, TollingSegmentDetailsQueryVariables>(TollingSegmentDetailsDocument, options);
        }
export type TollingSegmentDetailsQueryHookResult = ReturnType<typeof useTollingSegmentDetailsQuery>;
export type TollingSegmentDetailsLazyQueryHookResult = ReturnType<typeof useTollingSegmentDetailsLazyQuery>;
export type TollingSegmentDetailsQueryResult = Apollo.QueryResult<TollingSegmentDetailsQuery, TollingSegmentDetailsQueryVariables>;
export function refetchTollingSegmentDetailsQuery(variables: TollingSegmentDetailsQueryVariables) {
      return { query: TollingSegmentDetailsDocument, variables: variables }
    }
export const TollingSegmentOptionsDocument = gql`
    query TollingSegmentOptions {
  tollingSegments(query: {}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTollingSegmentOptionsQuery__
 *
 * To run a query within a React component, call `useTollingSegmentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTollingSegmentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TollingSegmentOptionsQuery, TollingSegmentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentOptionsQuery, TollingSegmentOptionsQueryVariables>(TollingSegmentOptionsDocument, options);
      }
export function useTollingSegmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentOptionsQuery, TollingSegmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentOptionsQuery, TollingSegmentOptionsQueryVariables>(TollingSegmentOptionsDocument, options);
        }
export type TollingSegmentOptionsQueryHookResult = ReturnType<typeof useTollingSegmentOptionsQuery>;
export type TollingSegmentOptionsLazyQueryHookResult = ReturnType<typeof useTollingSegmentOptionsLazyQuery>;
export type TollingSegmentOptionsQueryResult = Apollo.QueryResult<TollingSegmentOptionsQuery, TollingSegmentOptionsQueryVariables>;
export function refetchTollingSegmentOptionsQuery(variables?: TollingSegmentOptionsQueryVariables) {
      return { query: TollingSegmentOptionsDocument, variables: variables }
    }
export const TollingSegmentSummaryCardDocument = gql`
    query TollingSegmentSummaryCard($id: ID!) {
  tollingSegment(id: $id) {
    id
    name
    description
    destinations
    startReference
    endReference
    tollRoadId
  }
}
    `;

/**
 * __useTollingSegmentSummaryCardQuery__
 *
 * To run a query within a React component, call `useTollingSegmentSummaryCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentSummaryCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentSummaryCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingSegmentSummaryCardQuery(baseOptions: Apollo.QueryHookOptions<TollingSegmentSummaryCardQuery, TollingSegmentSummaryCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentSummaryCardQuery, TollingSegmentSummaryCardQueryVariables>(TollingSegmentSummaryCardDocument, options);
      }
export function useTollingSegmentSummaryCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentSummaryCardQuery, TollingSegmentSummaryCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentSummaryCardQuery, TollingSegmentSummaryCardQueryVariables>(TollingSegmentSummaryCardDocument, options);
        }
export type TollingSegmentSummaryCardQueryHookResult = ReturnType<typeof useTollingSegmentSummaryCardQuery>;
export type TollingSegmentSummaryCardLazyQueryHookResult = ReturnType<typeof useTollingSegmentSummaryCardLazyQuery>;
export type TollingSegmentSummaryCardQueryResult = Apollo.QueryResult<TollingSegmentSummaryCardQuery, TollingSegmentSummaryCardQueryVariables>;
export function refetchTollingSegmentSummaryCardQuery(variables: TollingSegmentSummaryCardQueryVariables) {
      return { query: TollingSegmentSummaryCardDocument, variables: variables }
    }
export const TollingSegmentDetailsSignsDocument = gql`
    query TollingSegmentDetailsSigns($id: ID!) {
  tollingSegment(id: $id) {
    id
    signs
  }
}
    `;

/**
 * __useTollingSegmentDetailsSignsQuery__
 *
 * To run a query within a React component, call `useTollingSegmentDetailsSignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentDetailsSignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentDetailsSignsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingSegmentDetailsSignsQuery(baseOptions: Apollo.QueryHookOptions<TollingSegmentDetailsSignsQuery, TollingSegmentDetailsSignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentDetailsSignsQuery, TollingSegmentDetailsSignsQueryVariables>(TollingSegmentDetailsSignsDocument, options);
      }
export function useTollingSegmentDetailsSignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentDetailsSignsQuery, TollingSegmentDetailsSignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentDetailsSignsQuery, TollingSegmentDetailsSignsQueryVariables>(TollingSegmentDetailsSignsDocument, options);
        }
export type TollingSegmentDetailsSignsQueryHookResult = ReturnType<typeof useTollingSegmentDetailsSignsQuery>;
export type TollingSegmentDetailsSignsLazyQueryHookResult = ReturnType<typeof useTollingSegmentDetailsSignsLazyQuery>;
export type TollingSegmentDetailsSignsQueryResult = Apollo.QueryResult<TollingSegmentDetailsSignsQuery, TollingSegmentDetailsSignsQueryVariables>;
export function refetchTollingSegmentDetailsSignsQuery(variables: TollingSegmentDetailsSignsQueryVariables) {
      return { query: TollingSegmentDetailsSignsDocument, variables: variables }
    }
export const TollingSegmentDetailsDetectorsDocument = gql`
    query TollingSegmentDetailsDetectors($id: ID!) {
  tollingSegment(id: $id) {
    id
    detectors
  }
}
    `;

/**
 * __useTollingSegmentDetailsDetectorsQuery__
 *
 * To run a query within a React component, call `useTollingSegmentDetailsDetectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentDetailsDetectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentDetailsDetectorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTollingSegmentDetailsDetectorsQuery(baseOptions: Apollo.QueryHookOptions<TollingSegmentDetailsDetectorsQuery, TollingSegmentDetailsDetectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentDetailsDetectorsQuery, TollingSegmentDetailsDetectorsQueryVariables>(TollingSegmentDetailsDetectorsDocument, options);
      }
export function useTollingSegmentDetailsDetectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentDetailsDetectorsQuery, TollingSegmentDetailsDetectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentDetailsDetectorsQuery, TollingSegmentDetailsDetectorsQueryVariables>(TollingSegmentDetailsDetectorsDocument, options);
        }
export type TollingSegmentDetailsDetectorsQueryHookResult = ReturnType<typeof useTollingSegmentDetailsDetectorsQuery>;
export type TollingSegmentDetailsDetectorsLazyQueryHookResult = ReturnType<typeof useTollingSegmentDetailsDetectorsLazyQuery>;
export type TollingSegmentDetailsDetectorsQueryResult = Apollo.QueryResult<TollingSegmentDetailsDetectorsQuery, TollingSegmentDetailsDetectorsQueryVariables>;
export function refetchTollingSegmentDetailsDetectorsQuery(variables: TollingSegmentDetailsDetectorsQueryVariables) {
      return { query: TollingSegmentDetailsDetectorsDocument, variables: variables }
    }
export const TollingSegmentDetailsSignsListDocument = gql`
    query TollingSegmentDetailsSignsList($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  signs(
    searchText: $searchText
    filters: $filters
    after: $after
    before: $before
    limit: $limit
    sortOrder: $sortOrder
    sortField: $sortField
  ) {
    edges {
      node {
        ...SignList
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignListFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useTollingSegmentDetailsSignsListQuery__
 *
 * To run a query within a React component, call `useTollingSegmentDetailsSignsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentDetailsSignsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentDetailsSignsListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollingSegmentDetailsSignsListQuery(baseOptions?: Apollo.QueryHookOptions<TollingSegmentDetailsSignsListQuery, TollingSegmentDetailsSignsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentDetailsSignsListQuery, TollingSegmentDetailsSignsListQueryVariables>(TollingSegmentDetailsSignsListDocument, options);
      }
export function useTollingSegmentDetailsSignsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentDetailsSignsListQuery, TollingSegmentDetailsSignsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentDetailsSignsListQuery, TollingSegmentDetailsSignsListQueryVariables>(TollingSegmentDetailsSignsListDocument, options);
        }
export type TollingSegmentDetailsSignsListQueryHookResult = ReturnType<typeof useTollingSegmentDetailsSignsListQuery>;
export type TollingSegmentDetailsSignsListLazyQueryHookResult = ReturnType<typeof useTollingSegmentDetailsSignsListLazyQuery>;
export type TollingSegmentDetailsSignsListQueryResult = Apollo.QueryResult<TollingSegmentDetailsSignsListQuery, TollingSegmentDetailsSignsListQueryVariables>;
export function refetchTollingSegmentDetailsSignsListQuery(variables?: TollingSegmentDetailsSignsListQueryVariables) {
      return { query: TollingSegmentDetailsSignsListDocument, variables: variables }
    }
export const TollingSegmentDetailsDetectorsListDocument = gql`
    query TollingSegmentDetailsDetectorsList($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  detectors(
    query: {searchText: $searchText, filters: $filters, after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, sortField: $sortField}
  ) {
    edges {
      node {
        ...Detector
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${DetectorFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useTollingSegmentDetailsDetectorsListQuery__
 *
 * To run a query within a React component, call `useTollingSegmentDetailsDetectorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentDetailsDetectorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentDetailsDetectorsListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollingSegmentDetailsDetectorsListQuery(baseOptions?: Apollo.QueryHookOptions<TollingSegmentDetailsDetectorsListQuery, TollingSegmentDetailsDetectorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentDetailsDetectorsListQuery, TollingSegmentDetailsDetectorsListQueryVariables>(TollingSegmentDetailsDetectorsListDocument, options);
      }
export function useTollingSegmentDetailsDetectorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentDetailsDetectorsListQuery, TollingSegmentDetailsDetectorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentDetailsDetectorsListQuery, TollingSegmentDetailsDetectorsListQueryVariables>(TollingSegmentDetailsDetectorsListDocument, options);
        }
export type TollingSegmentDetailsDetectorsListQueryHookResult = ReturnType<typeof useTollingSegmentDetailsDetectorsListQuery>;
export type TollingSegmentDetailsDetectorsListLazyQueryHookResult = ReturnType<typeof useTollingSegmentDetailsDetectorsListLazyQuery>;
export type TollingSegmentDetailsDetectorsListQueryResult = Apollo.QueryResult<TollingSegmentDetailsDetectorsListQuery, TollingSegmentDetailsDetectorsListQueryVariables>;
export function refetchTollingSegmentDetailsDetectorsListQuery(variables?: TollingSegmentDetailsDetectorsListQueryVariables) {
      return { query: TollingSegmentDetailsDetectorsListDocument, variables: variables }
    }
export const TollSegmentTollRoadDocument = gql`
    query TollSegmentTollRoad($segmentId: ID!) {
  tollingSegment(id: $segmentId) {
    id
    tollRoadId
  }
}
    `;

/**
 * __useTollSegmentTollRoadQuery__
 *
 * To run a query within a React component, call `useTollSegmentTollRoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollSegmentTollRoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollSegmentTollRoadQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useTollSegmentTollRoadQuery(baseOptions: Apollo.QueryHookOptions<TollSegmentTollRoadQuery, TollSegmentTollRoadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollSegmentTollRoadQuery, TollSegmentTollRoadQueryVariables>(TollSegmentTollRoadDocument, options);
      }
export function useTollSegmentTollRoadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollSegmentTollRoadQuery, TollSegmentTollRoadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollSegmentTollRoadQuery, TollSegmentTollRoadQueryVariables>(TollSegmentTollRoadDocument, options);
        }
export type TollSegmentTollRoadQueryHookResult = ReturnType<typeof useTollSegmentTollRoadQuery>;
export type TollSegmentTollRoadLazyQueryHookResult = ReturnType<typeof useTollSegmentTollRoadLazyQuery>;
export type TollSegmentTollRoadQueryResult = Apollo.QueryResult<TollSegmentTollRoadQuery, TollSegmentTollRoadQueryVariables>;
export function refetchTollSegmentTollRoadQuery(variables: TollSegmentTollRoadQueryVariables) {
      return { query: TollSegmentTollRoadDocument, variables: variables }
    }
export const TollSegmentMapLocationDocument = gql`
    query TollSegmentMapLocation($locationId: ID!) {
  location(id: $locationId) {
    id
    geometry
  }
}
    `;

/**
 * __useTollSegmentMapLocationQuery__
 *
 * To run a query within a React component, call `useTollSegmentMapLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollSegmentMapLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollSegmentMapLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useTollSegmentMapLocationQuery(baseOptions: Apollo.QueryHookOptions<TollSegmentMapLocationQuery, TollSegmentMapLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollSegmentMapLocationQuery, TollSegmentMapLocationQueryVariables>(TollSegmentMapLocationDocument, options);
      }
export function useTollSegmentMapLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollSegmentMapLocationQuery, TollSegmentMapLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollSegmentMapLocationQuery, TollSegmentMapLocationQueryVariables>(TollSegmentMapLocationDocument, options);
        }
export type TollSegmentMapLocationQueryHookResult = ReturnType<typeof useTollSegmentMapLocationQuery>;
export type TollSegmentMapLocationLazyQueryHookResult = ReturnType<typeof useTollSegmentMapLocationLazyQuery>;
export type TollSegmentMapLocationQueryResult = Apollo.QueryResult<TollSegmentMapLocationQuery, TollSegmentMapLocationQueryVariables>;
export function refetchTollSegmentMapLocationQuery(variables: TollSegmentMapLocationQueryVariables) {
      return { query: TollSegmentMapLocationDocument, variables: variables }
    }
export const TollSegmentLocationDocument = gql`
    query TollSegmentLocation($segmentId: ID!) {
  tollingSegment(id: $segmentId) {
    id
    locationId
  }
}
    `;

/**
 * __useTollSegmentLocationQuery__
 *
 * To run a query within a React component, call `useTollSegmentLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollSegmentLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollSegmentLocationQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useTollSegmentLocationQuery(baseOptions: Apollo.QueryHookOptions<TollSegmentLocationQuery, TollSegmentLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollSegmentLocationQuery, TollSegmentLocationQueryVariables>(TollSegmentLocationDocument, options);
      }
export function useTollSegmentLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollSegmentLocationQuery, TollSegmentLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollSegmentLocationQuery, TollSegmentLocationQueryVariables>(TollSegmentLocationDocument, options);
        }
export type TollSegmentLocationQueryHookResult = ReturnType<typeof useTollSegmentLocationQuery>;
export type TollSegmentLocationLazyQueryHookResult = ReturnType<typeof useTollSegmentLocationLazyQuery>;
export type TollSegmentLocationQueryResult = Apollo.QueryResult<TollSegmentLocationQuery, TollSegmentLocationQueryVariables>;
export function refetchTollSegmentLocationQuery(variables: TollSegmentLocationQueryVariables) {
      return { query: TollSegmentLocationDocument, variables: variables }
    }
export const TollRoadWidgetSegmentsDocument = gql`
    query TollRoadWidgetSegments($ids: Object!, $direction: Object!) {
  tollingSegments(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "id", operator: IN, value: $ids}, {field: "direction", operator: EQUALS, value: $direction}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
        signs
      }
    }
  }
}
    `;

/**
 * __useTollRoadWidgetSegmentsQuery__
 *
 * To run a query within a React component, call `useTollRoadWidgetSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollRoadWidgetSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollRoadWidgetSegmentsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useTollRoadWidgetSegmentsQuery(baseOptions: Apollo.QueryHookOptions<TollRoadWidgetSegmentsQuery, TollRoadWidgetSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollRoadWidgetSegmentsQuery, TollRoadWidgetSegmentsQueryVariables>(TollRoadWidgetSegmentsDocument, options);
      }
export function useTollRoadWidgetSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollRoadWidgetSegmentsQuery, TollRoadWidgetSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollRoadWidgetSegmentsQuery, TollRoadWidgetSegmentsQueryVariables>(TollRoadWidgetSegmentsDocument, options);
        }
export type TollRoadWidgetSegmentsQueryHookResult = ReturnType<typeof useTollRoadWidgetSegmentsQuery>;
export type TollRoadWidgetSegmentsLazyQueryHookResult = ReturnType<typeof useTollRoadWidgetSegmentsLazyQuery>;
export type TollRoadWidgetSegmentsQueryResult = Apollo.QueryResult<TollRoadWidgetSegmentsQuery, TollRoadWidgetSegmentsQueryVariables>;
export function refetchTollRoadWidgetSegmentsQuery(variables: TollRoadWidgetSegmentsQueryVariables) {
      return { query: TollRoadWidgetSegmentsDocument, variables: variables }
    }
export const TollSegmentCommentsDocument = gql`
    query TollSegmentComments($segmentId: ID!) {
  tollingSegmentComments(entityId: $segmentId) {
    id
    entityId
    createdBy
    createdAt
    updatedAt
    mentionedUsers
    html
  }
}
    `;

/**
 * __useTollSegmentCommentsQuery__
 *
 * To run a query within a React component, call `useTollSegmentCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollSegmentCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollSegmentCommentsQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useTollSegmentCommentsQuery(baseOptions: Apollo.QueryHookOptions<TollSegmentCommentsQuery, TollSegmentCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollSegmentCommentsQuery, TollSegmentCommentsQueryVariables>(TollSegmentCommentsDocument, options);
      }
export function useTollSegmentCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollSegmentCommentsQuery, TollSegmentCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollSegmentCommentsQuery, TollSegmentCommentsQueryVariables>(TollSegmentCommentsDocument, options);
        }
export type TollSegmentCommentsQueryHookResult = ReturnType<typeof useTollSegmentCommentsQuery>;
export type TollSegmentCommentsLazyQueryHookResult = ReturnType<typeof useTollSegmentCommentsLazyQuery>;
export type TollSegmentCommentsQueryResult = Apollo.QueryResult<TollSegmentCommentsQuery, TollSegmentCommentsQueryVariables>;
export function refetchTollSegmentCommentsQuery(variables: TollSegmentCommentsQueryVariables) {
      return { query: TollSegmentCommentsDocument, variables: variables }
    }
export const TollingSegmentsByIdDocument = gql`
    query TollingSegmentsById($ids: Object!) {
  tollingSegments(query: {filters: [{operator: IN, field: "id", value: $ids}]}) {
    edges {
      node {
        id
        name
        location
        locationId
      }
    }
  }
}
    `;

/**
 * __useTollingSegmentsByIdQuery__
 *
 * To run a query within a React component, call `useTollingSegmentsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSegmentsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSegmentsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTollingSegmentsByIdQuery(baseOptions: Apollo.QueryHookOptions<TollingSegmentsByIdQuery, TollingSegmentsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSegmentsByIdQuery, TollingSegmentsByIdQueryVariables>(TollingSegmentsByIdDocument, options);
      }
export function useTollingSegmentsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSegmentsByIdQuery, TollingSegmentsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSegmentsByIdQuery, TollingSegmentsByIdQueryVariables>(TollingSegmentsByIdDocument, options);
        }
export type TollingSegmentsByIdQueryHookResult = ReturnType<typeof useTollingSegmentsByIdQuery>;
export type TollingSegmentsByIdLazyQueryHookResult = ReturnType<typeof useTollingSegmentsByIdLazyQuery>;
export type TollingSegmentsByIdQueryResult = Apollo.QueryResult<TollingSegmentsByIdQuery, TollingSegmentsByIdQueryVariables>;
export function refetchTollingSegmentsByIdQuery(variables: TollingSegmentsByIdQueryVariables) {
      return { query: TollingSegmentsByIdDocument, variables: variables }
    }
export const TollingSignsListDocument = gql`
    query TollingSignsList($searchText: String, $filters: [FilterInput], $after: String, $before: String, $limit: Int = 10, $sortOrder: SortOrder = ASCENDING, $sortField: String) {
  tollingSigns(
    query: {after: $after, before: $before, limit: $limit, sortOrder: $sortOrder, sortField: $sortField, searchText: $searchText, filters: $filters}
  ) {
    edges {
      node {
        id
        communicationState
        secondaryHistoricalRate {
          firstDestination
          firstRate
          secondDestination
          secondRate
          thirdDestination
          thirdRate
          name
        }
        primaryHistoricalRate {
          firstDestination
          firstRate
          secondDestination
          secondRate
          thirdDestination
          thirdRate
          name
        }
        currentMessage {
          ...SignMessage
        }
        rate {
          name
        }
        road
        direction
        referencePoint
        lastDataReceived
        pricingId
        name
        mode
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SignMessageFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useTollingSignsListQuery__
 *
 * To run a query within a React component, call `useTollingSignsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTollingSignsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTollingSignsListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTollingSignsListQuery(baseOptions?: Apollo.QueryHookOptions<TollingSignsListQuery, TollingSignsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TollingSignsListQuery, TollingSignsListQueryVariables>(TollingSignsListDocument, options);
      }
export function useTollingSignsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TollingSignsListQuery, TollingSignsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TollingSignsListQuery, TollingSignsListQueryVariables>(TollingSignsListDocument, options);
        }
export type TollingSignsListQueryHookResult = ReturnType<typeof useTollingSignsListQuery>;
export type TollingSignsListLazyQueryHookResult = ReturnType<typeof useTollingSignsListLazyQuery>;
export type TollingSignsListQueryResult = Apollo.QueryResult<TollingSignsListQuery, TollingSignsListQueryVariables>;
export function refetchTollingSignsListQuery(variables?: TollingSignsListQueryVariables) {
      return { query: TollingSignsListDocument, variables: variables }
    }
export const LiveTollingSignsListDocument = gql`
    subscription LiveTollingSignsList($ids: [ID!]!) {
  tollingSignUpdated(ids: $ids) {
    id
    communicationState
    secondaryHistoricalRate {
      firstDestination
      firstRate
      secondDestination
      secondRate
      thirdDestination
      thirdRate
      name
    }
    primaryHistoricalRate {
      firstDestination
      firstRate
      secondDestination
      secondRate
      thirdDestination
      thirdRate
      name
    }
    currentMessage {
      ...SignMessage
    }
    road
    direction
    referencePoint
    lastDataReceived
    pricingId
    rate {
      name
    }
    name
    mode
  }
}
    ${SignMessageFragmentDoc}`;

/**
 * __useLiveTollingSignsListSubscription__
 *
 * To run a query within a React component, call `useLiveTollingSignsListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTollingSignsListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTollingSignsListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveTollingSignsListSubscription(baseOptions: Apollo.SubscriptionHookOptions<LiveTollingSignsListSubscription, LiveTollingSignsListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveTollingSignsListSubscription, LiveTollingSignsListSubscriptionVariables>(LiveTollingSignsListDocument, options);
      }
export type LiveTollingSignsListSubscriptionHookResult = ReturnType<typeof useLiveTollingSignsListSubscription>;
export type LiveTollingSignsListSubscriptionResult = Apollo.SubscriptionResult<LiveTollingSignsListSubscription>;
export const TravelTimeSegmentPollDocument = gql`
    mutation travelTimeSegmentPoll($ids: [ID!]!) {
  travelTimeSegmentPoll(ids: $ids) {
    success
  }
}
    `;
export type TravelTimeSegmentPollMutationFn = Apollo.MutationFunction<TravelTimeSegmentPollMutation, TravelTimeSegmentPollMutationVariables>;

/**
 * __useTravelTimeSegmentPollMutation__
 *
 * To run a mutation, you first call `useTravelTimeSegmentPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeSegmentPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelTimeSegmentPollMutation, { data, loading, error }] = useTravelTimeSegmentPollMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTravelTimeSegmentPollMutation(baseOptions?: Apollo.MutationHookOptions<TravelTimeSegmentPollMutation, TravelTimeSegmentPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelTimeSegmentPollMutation, TravelTimeSegmentPollMutationVariables>(TravelTimeSegmentPollDocument, options);
      }
export type TravelTimeSegmentPollMutationHookResult = ReturnType<typeof useTravelTimeSegmentPollMutation>;
export type TravelTimeSegmentPollMutationResult = Apollo.MutationResult<TravelTimeSegmentPollMutation>;
export type TravelTimeSegmentPollMutationOptions = Apollo.BaseMutationOptions<TravelTimeSegmentPollMutation, TravelTimeSegmentPollMutationVariables>;
export const TravelTimeListDocument = gql`
    query TravelTimeList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $searchFields: [String!] = ["name", "description", "communicationState"], $limit: Int = 10, $before: String, $after: String) {
  travelTimes(
    query: {searchText: $searchText, searchFields: $searchFields, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        ...TravelTime
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${TravelTimeFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useTravelTimeListQuery__
 *
 * To run a query within a React component, call `useTravelTimeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      searchFields: // value for 'searchFields'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTravelTimeListQuery(baseOptions?: Apollo.QueryHookOptions<TravelTimeListQuery, TravelTimeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeListQuery, TravelTimeListQueryVariables>(TravelTimeListDocument, options);
      }
export function useTravelTimeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeListQuery, TravelTimeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeListQuery, TravelTimeListQueryVariables>(TravelTimeListDocument, options);
        }
export type TravelTimeListQueryHookResult = ReturnType<typeof useTravelTimeListQuery>;
export type TravelTimeListLazyQueryHookResult = ReturnType<typeof useTravelTimeListLazyQuery>;
export type TravelTimeListQueryResult = Apollo.QueryResult<TravelTimeListQuery, TravelTimeListQueryVariables>;
export function refetchTravelTimeListQuery(variables?: TravelTimeListQueryVariables) {
      return { query: TravelTimeListDocument, variables: variables }
    }
export const TravelTimeHistoryListDocument = gql`
    query TravelTimeHistoryList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $startDate: DateTime, $endDate: DateTime, $entityId: String!, $limit: Int = 10, $before: String, $after: String) {
  travelTimeHistory(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, startDate: $startDate, entityId: $entityId, filters: $filters, endDate: $endDate, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        ...TravelTimeHistory
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${TravelTimeHistoryFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useTravelTimeHistoryListQuery__
 *
 * To run a query within a React component, call `useTravelTimeHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeHistoryListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      entityId: // value for 'entityId'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTravelTimeHistoryListQuery(baseOptions: Apollo.QueryHookOptions<TravelTimeHistoryListQuery, TravelTimeHistoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeHistoryListQuery, TravelTimeHistoryListQueryVariables>(TravelTimeHistoryListDocument, options);
      }
export function useTravelTimeHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeHistoryListQuery, TravelTimeHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeHistoryListQuery, TravelTimeHistoryListQueryVariables>(TravelTimeHistoryListDocument, options);
        }
export type TravelTimeHistoryListQueryHookResult = ReturnType<typeof useTravelTimeHistoryListQuery>;
export type TravelTimeHistoryListLazyQueryHookResult = ReturnType<typeof useTravelTimeHistoryListLazyQuery>;
export type TravelTimeHistoryListQueryResult = Apollo.QueryResult<TravelTimeHistoryListQuery, TravelTimeHistoryListQueryVariables>;
export function refetchTravelTimeHistoryListQuery(variables: TravelTimeHistoryListQueryVariables) {
      return { query: TravelTimeHistoryListDocument, variables: variables }
    }
export const TravelTimeDetailDocument = gql`
    query TravelTimeDetail($id: ID!) {
  travelTime(id: $id) {
    ...TravelTime
  }
}
    ${TravelTimeFragmentDoc}`;

/**
 * __useTravelTimeDetailQuery__
 *
 * To run a query within a React component, call `useTravelTimeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTravelTimeDetailQuery(baseOptions: Apollo.QueryHookOptions<TravelTimeDetailQuery, TravelTimeDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeDetailQuery, TravelTimeDetailQueryVariables>(TravelTimeDetailDocument, options);
      }
export function useTravelTimeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeDetailQuery, TravelTimeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeDetailQuery, TravelTimeDetailQueryVariables>(TravelTimeDetailDocument, options);
        }
export type TravelTimeDetailQueryHookResult = ReturnType<typeof useTravelTimeDetailQuery>;
export type TravelTimeDetailLazyQueryHookResult = ReturnType<typeof useTravelTimeDetailLazyQuery>;
export type TravelTimeDetailQueryResult = Apollo.QueryResult<TravelTimeDetailQuery, TravelTimeDetailQueryVariables>;
export function refetchTravelTimeDetailQuery(variables: TravelTimeDetailQueryVariables) {
      return { query: TravelTimeDetailDocument, variables: variables }
    }
export const TravelTimeUpdatedDocument = gql`
    subscription TravelTimeUpdated($ids: [ID!]!) {
  travelTimeUpdated(ids: $ids) {
    ...TravelTime
  }
}
    ${TravelTimeFragmentDoc}`;

/**
 * __useTravelTimeUpdatedSubscription__
 *
 * To run a query within a React component, call `useTravelTimeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTravelTimeUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<TravelTimeUpdatedSubscription, TravelTimeUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TravelTimeUpdatedSubscription, TravelTimeUpdatedSubscriptionVariables>(TravelTimeUpdatedDocument, options);
      }
export type TravelTimeUpdatedSubscriptionHookResult = ReturnType<typeof useTravelTimeUpdatedSubscription>;
export type TravelTimeUpdatedSubscriptionResult = Apollo.SubscriptionResult<TravelTimeUpdatedSubscription>;
export const TravelTimeSelectionDocument = gql`
    query TravelTimeSelection($id: Object!, $searchText: String) {
  travelTimes(
    query: {filters: [{operator: IN, value: [$id], field: "associatedSigns"}], searchText: $searchText, limit: 100}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTravelTimeSelectionQuery__
 *
 * To run a query within a React component, call `useTravelTimeSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeSelectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useTravelTimeSelectionQuery(baseOptions: Apollo.QueryHookOptions<TravelTimeSelectionQuery, TravelTimeSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeSelectionQuery, TravelTimeSelectionQueryVariables>(TravelTimeSelectionDocument, options);
      }
export function useTravelTimeSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeSelectionQuery, TravelTimeSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeSelectionQuery, TravelTimeSelectionQueryVariables>(TravelTimeSelectionDocument, options);
        }
export type TravelTimeSelectionQueryHookResult = ReturnType<typeof useTravelTimeSelectionQuery>;
export type TravelTimeSelectionLazyQueryHookResult = ReturnType<typeof useTravelTimeSelectionLazyQuery>;
export type TravelTimeSelectionQueryResult = Apollo.QueryResult<TravelTimeSelectionQuery, TravelTimeSelectionQueryVariables>;
export function refetchTravelTimeSelectionQuery(variables: TravelTimeSelectionQueryVariables) {
      return { query: TravelTimeSelectionDocument, variables: variables }
    }
export const TravelTimeSelectionOptionsDocument = gql`
    query TravelTimeSelectionOptions($ids: Object!, $searchText: String) {
  travelTimes(
    query: {filters: [{operator: IN, value: $ids, field: "id"}], searchText: $searchText, limit: 100}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTravelTimeSelectionOptionsQuery__
 *
 * To run a query within a React component, call `useTravelTimeSelectionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeSelectionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeSelectionOptionsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useTravelTimeSelectionOptionsQuery(baseOptions: Apollo.QueryHookOptions<TravelTimeSelectionOptionsQuery, TravelTimeSelectionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeSelectionOptionsQuery, TravelTimeSelectionOptionsQueryVariables>(TravelTimeSelectionOptionsDocument, options);
      }
export function useTravelTimeSelectionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeSelectionOptionsQuery, TravelTimeSelectionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeSelectionOptionsQuery, TravelTimeSelectionOptionsQueryVariables>(TravelTimeSelectionOptionsDocument, options);
        }
export type TravelTimeSelectionOptionsQueryHookResult = ReturnType<typeof useTravelTimeSelectionOptionsQuery>;
export type TravelTimeSelectionOptionsLazyQueryHookResult = ReturnType<typeof useTravelTimeSelectionOptionsLazyQuery>;
export type TravelTimeSelectionOptionsQueryResult = Apollo.QueryResult<TravelTimeSelectionOptionsQuery, TravelTimeSelectionOptionsQueryVariables>;
export function refetchTravelTimeSelectionOptionsQuery(variables: TravelTimeSelectionOptionsQueryVariables) {
      return { query: TravelTimeSelectionOptionsDocument, variables: variables }
    }
export const SignSelectionDocument = gql`
    query SignSelection($searchText: String, $filters: [FilterInput!]!) {
  signs(searchText: $searchText, limit: 2000, filters: $filters) {
    edges {
      node {
        id
        name
        capabilities
        travelTimeSegments
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useSignSelectionQuery__
 *
 * To run a query within a React component, call `useSignSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignSelectionQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSignSelectionQuery(baseOptions: Apollo.QueryHookOptions<SignSelectionQuery, SignSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignSelectionQuery, SignSelectionQueryVariables>(SignSelectionDocument, options);
      }
export function useSignSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignSelectionQuery, SignSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignSelectionQuery, SignSelectionQueryVariables>(SignSelectionDocument, options);
        }
export type SignSelectionQueryHookResult = ReturnType<typeof useSignSelectionQuery>;
export type SignSelectionLazyQueryHookResult = ReturnType<typeof useSignSelectionLazyQuery>;
export type SignSelectionQueryResult = Apollo.QueryResult<SignSelectionQuery, SignSelectionQueryVariables>;
export function refetchSignSelectionQuery(variables: SignSelectionQueryVariables) {
      return { query: SignSelectionDocument, variables: variables }
    }
export const TravelTimeActivityLogAddedDocument = gql`
    subscription TravelTimeActivityLogAdded($ids: [ID!], $module: KineticModule = TRAVEL_TIME) {
  addedActivityLog(ids: $ids, module: $module) {
    ...ActivityLogNodeFragment
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}`;

/**
 * __useTravelTimeActivityLogAddedSubscription__
 *
 * To run a query within a React component, call `useTravelTimeActivityLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeActivityLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeActivityLogAddedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useTravelTimeActivityLogAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TravelTimeActivityLogAddedSubscription, TravelTimeActivityLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TravelTimeActivityLogAddedSubscription, TravelTimeActivityLogAddedSubscriptionVariables>(TravelTimeActivityLogAddedDocument, options);
      }
export type TravelTimeActivityLogAddedSubscriptionHookResult = ReturnType<typeof useTravelTimeActivityLogAddedSubscription>;
export type TravelTimeActivityLogAddedSubscriptionResult = Apollo.SubscriptionResult<TravelTimeActivityLogAddedSubscription>;
export const TravelTimeSummaryDocument = gql`
    query TravelTimeSummary($filtersZero: [FilterInput!], $filtersOne: [FilterInput!], $filtersTwo: [FilterInput!], $filtersThree: [FilterInput!], $filtersFour: [FilterInput!]) {
  zero: travelTimes(query: {filters: $filtersZero}) {
    totalCount
  }
  one: travelTimes(query: {filters: $filtersOne}) {
    totalCount
  }
  two: travelTimes(query: {filters: $filtersTwo}) {
    totalCount
  }
  three: travelTimes(query: {filters: $filtersThree}) {
    totalCount
  }
  four: travelTimes(query: {filters: $filtersFour}) {
    totalCount
  }
}
    `;

/**
 * __useTravelTimeSummaryQuery__
 *
 * To run a query within a React component, call `useTravelTimeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeSummaryQuery({
 *   variables: {
 *      filtersZero: // value for 'filtersZero'
 *      filtersOne: // value for 'filtersOne'
 *      filtersTwo: // value for 'filtersTwo'
 *      filtersThree: // value for 'filtersThree'
 *      filtersFour: // value for 'filtersFour'
 *   },
 * });
 */
export function useTravelTimeSummaryQuery(baseOptions?: Apollo.QueryHookOptions<TravelTimeSummaryQuery, TravelTimeSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeSummaryQuery, TravelTimeSummaryQueryVariables>(TravelTimeSummaryDocument, options);
      }
export function useTravelTimeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeSummaryQuery, TravelTimeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeSummaryQuery, TravelTimeSummaryQueryVariables>(TravelTimeSummaryDocument, options);
        }
export type TravelTimeSummaryQueryHookResult = ReturnType<typeof useTravelTimeSummaryQuery>;
export type TravelTimeSummaryLazyQueryHookResult = ReturnType<typeof useTravelTimeSummaryLazyQuery>;
export type TravelTimeSummaryQueryResult = Apollo.QueryResult<TravelTimeSummaryQuery, TravelTimeSummaryQueryVariables>;
export function refetchTravelTimeSummaryQuery(variables?: TravelTimeSummaryQueryVariables) {
      return { query: TravelTimeSummaryDocument, variables: variables }
    }
export const TravelTimeMapEntitiesDocument = gql`
    query TravelTimeMapEntities($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput!], $searchText: String, $limit: Int = 10000000, $before: String, $after: String) {
  travelTimes(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        ...TravelTimeMapEntity
      }
    }
    totalCount
  }
}
    ${TravelTimeMapEntityFragmentDoc}`;

/**
 * __useTravelTimeMapEntitiesQuery__
 *
 * To run a query within a React component, call `useTravelTimeMapEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeMapEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeMapEntitiesQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTravelTimeMapEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<TravelTimeMapEntitiesQuery, TravelTimeMapEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeMapEntitiesQuery, TravelTimeMapEntitiesQueryVariables>(TravelTimeMapEntitiesDocument, options);
      }
export function useTravelTimeMapEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeMapEntitiesQuery, TravelTimeMapEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeMapEntitiesQuery, TravelTimeMapEntitiesQueryVariables>(TravelTimeMapEntitiesDocument, options);
        }
export type TravelTimeMapEntitiesQueryHookResult = ReturnType<typeof useTravelTimeMapEntitiesQuery>;
export type TravelTimeMapEntitiesLazyQueryHookResult = ReturnType<typeof useTravelTimeMapEntitiesLazyQuery>;
export type TravelTimeMapEntitiesQueryResult = Apollo.QueryResult<TravelTimeMapEntitiesQuery, TravelTimeMapEntitiesQueryVariables>;
export function refetchTravelTimeMapEntitiesQuery(variables?: TravelTimeMapEntitiesQueryVariables) {
      return { query: TravelTimeMapEntitiesDocument, variables: variables }
    }
export const TravelTimeUpdatedShortDocument = gql`
    subscription TravelTimeUpdatedShort {
  travelTimeUpdated {
    id
  }
}
    `;

/**
 * __useTravelTimeUpdatedShortSubscription__
 *
 * To run a query within a React component, call `useTravelTimeUpdatedShortSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeUpdatedShortSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeUpdatedShortSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTravelTimeUpdatedShortSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TravelTimeUpdatedShortSubscription, TravelTimeUpdatedShortSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TravelTimeUpdatedShortSubscription, TravelTimeUpdatedShortSubscriptionVariables>(TravelTimeUpdatedShortDocument, options);
      }
export type TravelTimeUpdatedShortSubscriptionHookResult = ReturnType<typeof useTravelTimeUpdatedShortSubscription>;
export type TravelTimeUpdatedShortSubscriptionResult = Apollo.SubscriptionResult<TravelTimeUpdatedShortSubscription>;
export const TravelTimeNameDocument = gql`
    query TravelTimeName($filters: [FilterInput!]!, $limit: Int!) {
  travelTimes(query: {filters: $filters, limit: $limit}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTravelTimeNameQuery__
 *
 * To run a query within a React component, call `useTravelTimeNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeNameQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTravelTimeNameQuery(baseOptions: Apollo.QueryHookOptions<TravelTimeNameQuery, TravelTimeNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeNameQuery, TravelTimeNameQueryVariables>(TravelTimeNameDocument, options);
      }
export function useTravelTimeNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeNameQuery, TravelTimeNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeNameQuery, TravelTimeNameQueryVariables>(TravelTimeNameDocument, options);
        }
export type TravelTimeNameQueryHookResult = ReturnType<typeof useTravelTimeNameQuery>;
export type TravelTimeNameLazyQueryHookResult = ReturnType<typeof useTravelTimeNameLazyQuery>;
export type TravelTimeNameQueryResult = Apollo.QueryResult<TravelTimeNameQuery, TravelTimeNameQueryVariables>;
export function refetchTravelTimeNameQuery(variables: TravelTimeNameQueryVariables) {
      return { query: TravelTimeNameDocument, variables: variables }
    }
export const TravelTimeNamesDocument = gql`
    query TravelTimeNames($limit: Int!) {
  travelTimes(query: {limit: $limit}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTravelTimeNamesQuery__
 *
 * To run a query within a React component, call `useTravelTimeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeNamesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTravelTimeNamesQuery(baseOptions: Apollo.QueryHookOptions<TravelTimeNamesQuery, TravelTimeNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeNamesQuery, TravelTimeNamesQueryVariables>(TravelTimeNamesDocument, options);
      }
export function useTravelTimeNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeNamesQuery, TravelTimeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeNamesQuery, TravelTimeNamesQueryVariables>(TravelTimeNamesDocument, options);
        }
export type TravelTimeNamesQueryHookResult = ReturnType<typeof useTravelTimeNamesQuery>;
export type TravelTimeNamesLazyQueryHookResult = ReturnType<typeof useTravelTimeNamesLazyQuery>;
export type TravelTimeNamesQueryResult = Apollo.QueryResult<TravelTimeNamesQuery, TravelTimeNamesQueryVariables>;
export function refetchTravelTimeNamesQuery(variables: TravelTimeNamesQueryVariables) {
      return { query: TravelTimeNamesDocument, variables: variables }
    }
export const TravelTimeAlarmConfigsDocument = gql`
    query TravelTimeAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "TRAVEL_TIMES"}, {field: "entityType", operator: EQUALS, value: "TRAVEL_TIME"}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTravelTimeAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useTravelTimeAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTravelTimeAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<TravelTimeAlarmConfigsQuery, TravelTimeAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeAlarmConfigsQuery, TravelTimeAlarmConfigsQueryVariables>(TravelTimeAlarmConfigsDocument, options);
      }
export function useTravelTimeAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeAlarmConfigsQuery, TravelTimeAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeAlarmConfigsQuery, TravelTimeAlarmConfigsQueryVariables>(TravelTimeAlarmConfigsDocument, options);
        }
export type TravelTimeAlarmConfigsQueryHookResult = ReturnType<typeof useTravelTimeAlarmConfigsQuery>;
export type TravelTimeAlarmConfigsLazyQueryHookResult = ReturnType<typeof useTravelTimeAlarmConfigsLazyQuery>;
export type TravelTimeAlarmConfigsQueryResult = Apollo.QueryResult<TravelTimeAlarmConfigsQuery, TravelTimeAlarmConfigsQueryVariables>;
export function refetchTravelTimeAlarmConfigsQuery(variables?: TravelTimeAlarmConfigsQueryVariables) {
      return { query: TravelTimeAlarmConfigsDocument, variables: variables }
    }
export const TravelTimeModuleSettingsDocument = gql`
    query travelTimeModuleSettings {
  travelTimeModuleSettings {
    id
    name
    type
    sections {
      name
      id
      fields {
        id
        name
        label
        type
        required
        hint
        sourceId
        defaultValue
        loading
        showInput
        options {
          label
          value
          __typename
        }
        step
        max
        min
        useStepper
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useTravelTimeModuleSettingsQuery__
 *
 * To run a query within a React component, call `useTravelTimeModuleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelTimeModuleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelTimeModuleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTravelTimeModuleSettingsQuery(baseOptions?: Apollo.QueryHookOptions<TravelTimeModuleSettingsQuery, TravelTimeModuleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelTimeModuleSettingsQuery, TravelTimeModuleSettingsQueryVariables>(TravelTimeModuleSettingsDocument, options);
      }
export function useTravelTimeModuleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelTimeModuleSettingsQuery, TravelTimeModuleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelTimeModuleSettingsQuery, TravelTimeModuleSettingsQueryVariables>(TravelTimeModuleSettingsDocument, options);
        }
export type TravelTimeModuleSettingsQueryHookResult = ReturnType<typeof useTravelTimeModuleSettingsQuery>;
export type TravelTimeModuleSettingsLazyQueryHookResult = ReturnType<typeof useTravelTimeModuleSettingsLazyQuery>;
export type TravelTimeModuleSettingsQueryResult = Apollo.QueryResult<TravelTimeModuleSettingsQuery, TravelTimeModuleSettingsQueryVariables>;
export function refetchTravelTimeModuleSettingsQuery(variables?: TravelTimeModuleSettingsQueryVariables) {
      return { query: TravelTimeModuleSettingsDocument, variables: variables }
    }
export const GetTravelTimeDelaySummaryDocument = gql`
    query GetTravelTimeDelaySummary {
  travelTimeDelaySummary {
    id
    count
    startRange
    endRange
    color
  }
}
    `;

/**
 * __useGetTravelTimeDelaySummaryQuery__
 *
 * To run a query within a React component, call `useGetTravelTimeDelaySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTravelTimeDelaySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTravelTimeDelaySummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTravelTimeDelaySummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetTravelTimeDelaySummaryQuery, GetTravelTimeDelaySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTravelTimeDelaySummaryQuery, GetTravelTimeDelaySummaryQueryVariables>(GetTravelTimeDelaySummaryDocument, options);
      }
export function useGetTravelTimeDelaySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTravelTimeDelaySummaryQuery, GetTravelTimeDelaySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTravelTimeDelaySummaryQuery, GetTravelTimeDelaySummaryQueryVariables>(GetTravelTimeDelaySummaryDocument, options);
        }
export type GetTravelTimeDelaySummaryQueryHookResult = ReturnType<typeof useGetTravelTimeDelaySummaryQuery>;
export type GetTravelTimeDelaySummaryLazyQueryHookResult = ReturnType<typeof useGetTravelTimeDelaySummaryLazyQuery>;
export type GetTravelTimeDelaySummaryQueryResult = Apollo.QueryResult<GetTravelTimeDelaySummaryQuery, GetTravelTimeDelaySummaryQueryVariables>;
export function refetchGetTravelTimeDelaySummaryQuery(variables?: GetTravelTimeDelaySummaryQueryVariables) {
      return { query: GetTravelTimeDelaySummaryDocument, variables: variables }
    }
export const TunnelListDocument = gql`
    query TunnelList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  corridors(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        activationType
        description
        deviceTypes
        name
        id
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTunnelListQuery__
 *
 * To run a query within a React component, call `useTunnelListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTunnelListQuery(baseOptions?: Apollo.QueryHookOptions<TunnelListQuery, TunnelListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelListQuery, TunnelListQueryVariables>(TunnelListDocument, options);
      }
export function useTunnelListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelListQuery, TunnelListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelListQuery, TunnelListQueryVariables>(TunnelListDocument, options);
        }
export type TunnelListQueryHookResult = ReturnType<typeof useTunnelListQuery>;
export type TunnelListLazyQueryHookResult = ReturnType<typeof useTunnelListLazyQuery>;
export type TunnelListQueryResult = Apollo.QueryResult<TunnelListQuery, TunnelListQueryVariables>;
export function refetchTunnelListQuery(variables?: TunnelListQueryVariables) {
      return { query: TunnelListDocument, variables: variables }
    }
export const LiveTunnelListDocument = gql`
    subscription LiveTunnelList($ids: [ID!]) {
  corridorUpdated(ids: $ids) {
    activationType
    description
    deviceTypes
    name
    id
  }
}
    `;

/**
 * __useLiveTunnelListSubscription__
 *
 * To run a query within a React component, call `useLiveTunnelListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTunnelListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTunnelListSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLiveTunnelListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LiveTunnelListSubscription, LiveTunnelListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LiveTunnelListSubscription, LiveTunnelListSubscriptionVariables>(LiveTunnelListDocument, options);
      }
export type LiveTunnelListSubscriptionHookResult = ReturnType<typeof useLiveTunnelListSubscription>;
export type LiveTunnelListSubscriptionResult = Apollo.SubscriptionResult<LiveTunnelListSubscription>;
export const TunnelMapListDocument = gql`
    query TunnelMapList($sortOrder: SortOrder = ASCENDING, $sortField: String = "id", $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  corridors(
    query: {searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField, filters: $filters, before: $before, limit: $limit, after: $after}
  ) {
    edges {
      node {
        geometry
        name
        id
        settings
      }
    }
  }
}
    `;

/**
 * __useTunnelMapListQuery__
 *
 * To run a query within a React component, call `useTunnelMapListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelMapListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelMapListQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTunnelMapListQuery(baseOptions?: Apollo.QueryHookOptions<TunnelMapListQuery, TunnelMapListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelMapListQuery, TunnelMapListQueryVariables>(TunnelMapListDocument, options);
      }
export function useTunnelMapListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelMapListQuery, TunnelMapListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelMapListQuery, TunnelMapListQueryVariables>(TunnelMapListDocument, options);
        }
export type TunnelMapListQueryHookResult = ReturnType<typeof useTunnelMapListQuery>;
export type TunnelMapListLazyQueryHookResult = ReturnType<typeof useTunnelMapListLazyQuery>;
export type TunnelMapListQueryResult = Apollo.QueryResult<TunnelMapListQuery, TunnelMapListQueryVariables>;
export function refetchTunnelMapListQuery(variables?: TunnelMapListQueryVariables) {
      return { query: TunnelMapListDocument, variables: variables }
    }
export const TunnelMapDocument = gql`
    query TunnelMap($id: ID!) {
  corridor(id: $id) {
    geometry
    name
    id
  }
}
    `;

/**
 * __useTunnelMapQuery__
 *
 * To run a query within a React component, call `useTunnelMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTunnelMapQuery(baseOptions: Apollo.QueryHookOptions<TunnelMapQuery, TunnelMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelMapQuery, TunnelMapQueryVariables>(TunnelMapDocument, options);
      }
export function useTunnelMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelMapQuery, TunnelMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelMapQuery, TunnelMapQueryVariables>(TunnelMapDocument, options);
        }
export type TunnelMapQueryHookResult = ReturnType<typeof useTunnelMapQuery>;
export type TunnelMapLazyQueryHookResult = ReturnType<typeof useTunnelMapLazyQuery>;
export type TunnelMapQueryResult = Apollo.QueryResult<TunnelMapQuery, TunnelMapQueryVariables>;
export function refetchTunnelMapQuery(variables: TunnelMapQueryVariables) {
      return { query: TunnelMapDocument, variables: variables }
    }
export const TunnelFanAlarmConfigsDocument = gql`
    query TunnelFanAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "TUNNELS"}, {field: "entityType", operator: EQUALS, value: "TUNNEL_FAN"}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useTunnelFanAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useTunnelFanAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunnelFanAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunnelFanAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTunnelFanAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<TunnelFanAlarmConfigsQuery, TunnelFanAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunnelFanAlarmConfigsQuery, TunnelFanAlarmConfigsQueryVariables>(TunnelFanAlarmConfigsDocument, options);
      }
export function useTunnelFanAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunnelFanAlarmConfigsQuery, TunnelFanAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunnelFanAlarmConfigsQuery, TunnelFanAlarmConfigsQueryVariables>(TunnelFanAlarmConfigsDocument, options);
        }
export type TunnelFanAlarmConfigsQueryHookResult = ReturnType<typeof useTunnelFanAlarmConfigsQuery>;
export type TunnelFanAlarmConfigsLazyQueryHookResult = ReturnType<typeof useTunnelFanAlarmConfigsLazyQuery>;
export type TunnelFanAlarmConfigsQueryResult = Apollo.QueryResult<TunnelFanAlarmConfigsQuery, TunnelFanAlarmConfigsQueryVariables>;
export function refetchTunnelFanAlarmConfigsQuery(variables?: TunnelFanAlarmConfigsQueryVariables) {
      return { query: TunnelFanAlarmConfigsDocument, variables: variables }
    }
export const RemoveUserPictureDocument = gql`
    mutation RemoveUserPicture {
  removeUserPicture
}
    `;
export type RemoveUserPictureMutationFn = Apollo.MutationFunction<RemoveUserPictureMutation, RemoveUserPictureMutationVariables>;

/**
 * __useRemoveUserPictureMutation__
 *
 * To run a mutation, you first call `useRemoveUserPictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserPictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserPictureMutation, { data, loading, error }] = useRemoveUserPictureMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveUserPictureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserPictureMutation, RemoveUserPictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserPictureMutation, RemoveUserPictureMutationVariables>(RemoveUserPictureDocument, options);
      }
export type RemoveUserPictureMutationHookResult = ReturnType<typeof useRemoveUserPictureMutation>;
export type RemoveUserPictureMutationResult = Apollo.MutationResult<RemoveUserPictureMutation>;
export type RemoveUserPictureMutationOptions = Apollo.BaseMutationOptions<RemoveUserPictureMutation, RemoveUserPictureMutationVariables>;
export const EffectivePrivilegesDocument = gql`
    query EffectivePrivileges {
  effectivePrivileges {
    id
    privilegeType
    kineticModule
    restrictedIntegrations
    restrictedIntegrationGroups
    restrictedAreas
    restrictedEntities
    restrictedLocationGroups
    restrictedLocations
  }
}
    `;

/**
 * __useEffectivePrivilegesQuery__
 *
 * To run a query within a React component, call `useEffectivePrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEffectivePrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEffectivePrivilegesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEffectivePrivilegesQuery(baseOptions?: Apollo.QueryHookOptions<EffectivePrivilegesQuery, EffectivePrivilegesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EffectivePrivilegesQuery, EffectivePrivilegesQueryVariables>(EffectivePrivilegesDocument, options);
      }
export function useEffectivePrivilegesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EffectivePrivilegesQuery, EffectivePrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EffectivePrivilegesQuery, EffectivePrivilegesQueryVariables>(EffectivePrivilegesDocument, options);
        }
export type EffectivePrivilegesQueryHookResult = ReturnType<typeof useEffectivePrivilegesQuery>;
export type EffectivePrivilegesLazyQueryHookResult = ReturnType<typeof useEffectivePrivilegesLazyQuery>;
export type EffectivePrivilegesQueryResult = Apollo.QueryResult<EffectivePrivilegesQuery, EffectivePrivilegesQueryVariables>;
export function refetchEffectivePrivilegesQuery(variables?: EffectivePrivilegesQueryVariables) {
      return { query: EffectivePrivilegesDocument, variables: variables }
    }
export const EffectivePrivilegesUpdatedDocument = gql`
    subscription EffectivePrivilegesUpdated {
  effectivePrivilegesUpdated {
    id
    privilegeType
    kineticModule
    restrictedIntegrations
    restrictedIntegrationGroups
    restrictedAreas
    restrictedEntities
  }
}
    `;

/**
 * __useEffectivePrivilegesUpdatedSubscription__
 *
 * To run a query within a React component, call `useEffectivePrivilegesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEffectivePrivilegesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEffectivePrivilegesUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEffectivePrivilegesUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EffectivePrivilegesUpdatedSubscription, EffectivePrivilegesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EffectivePrivilegesUpdatedSubscription, EffectivePrivilegesUpdatedSubscriptionVariables>(EffectivePrivilegesUpdatedDocument, options);
      }
export type EffectivePrivilegesUpdatedSubscriptionHookResult = ReturnType<typeof useEffectivePrivilegesUpdatedSubscription>;
export type EffectivePrivilegesUpdatedSubscriptionResult = Apollo.SubscriptionResult<EffectivePrivilegesUpdatedSubscription>;
export const UserSignalPrivilegesDocument = gql`
    query UserSignalPrivileges {
  userSignalPrivileges {
    privilegeType
    restrictions
    lastUpdated
  }
}
    `;

/**
 * __useUserSignalPrivilegesQuery__
 *
 * To run a query within a React component, call `useUserSignalPrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSignalPrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSignalPrivilegesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSignalPrivilegesQuery(baseOptions?: Apollo.QueryHookOptions<UserSignalPrivilegesQuery, UserSignalPrivilegesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSignalPrivilegesQuery, UserSignalPrivilegesQueryVariables>(UserSignalPrivilegesDocument, options);
      }
export function useUserSignalPrivilegesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSignalPrivilegesQuery, UserSignalPrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSignalPrivilegesQuery, UserSignalPrivilegesQueryVariables>(UserSignalPrivilegesDocument, options);
        }
export type UserSignalPrivilegesQueryHookResult = ReturnType<typeof useUserSignalPrivilegesQuery>;
export type UserSignalPrivilegesLazyQueryHookResult = ReturnType<typeof useUserSignalPrivilegesLazyQuery>;
export type UserSignalPrivilegesQueryResult = Apollo.QueryResult<UserSignalPrivilegesQuery, UserSignalPrivilegesQueryVariables>;
export function refetchUserSignalPrivilegesQuery(variables?: UserSignalPrivilegesQueryVariables) {
      return { query: UserSignalPrivilegesDocument, variables: variables }
    }
export const UsersDocument = gql`
    query Users {
  users(limit: 10000) {
    edges {
      node {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export function refetchUsersQuery(variables?: UsersQueryVariables) {
      return { query: UsersDocument, variables: variables }
    }
export const GetUsersDocument = gql`
    query GetUsers($after: String, $before: String, $limit: Int = 10, $sortField: String, $sortOrder: SortOrder, $searchText: String) {
  users(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
  ) {
    edges {
      node {
        id
        username
        firstName
        lastName
        email
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
      return { query: GetUsersDocument, variables: variables }
    }
export const GetBasicUserGroupsDocument = gql`
    query GetBasicUserGroups($id: String) {
  userGroups(userId: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetBasicUserGroupsQuery__
 *
 * To run a query within a React component, call `useGetBasicUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicUserGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBasicUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetBasicUserGroupsQuery, GetBasicUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicUserGroupsQuery, GetBasicUserGroupsQueryVariables>(GetBasicUserGroupsDocument, options);
      }
export function useGetBasicUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicUserGroupsQuery, GetBasicUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicUserGroupsQuery, GetBasicUserGroupsQueryVariables>(GetBasicUserGroupsDocument, options);
        }
export type GetBasicUserGroupsQueryHookResult = ReturnType<typeof useGetBasicUserGroupsQuery>;
export type GetBasicUserGroupsLazyQueryHookResult = ReturnType<typeof useGetBasicUserGroupsLazyQuery>;
export type GetBasicUserGroupsQueryResult = Apollo.QueryResult<GetBasicUserGroupsQuery, GetBasicUserGroupsQueryVariables>;
export function refetchGetBasicUserGroupsQuery(variables?: GetBasicUserGroupsQueryVariables) {
      return { query: GetBasicUserGroupsDocument, variables: variables }
    }
export const BasicUserGroupsUpdatedDocument = gql`
    subscription BasicUserGroupsUpdated($ids: [ID!]!) {
  userGroupsUpdated(ids: $ids) {
    id
    name
  }
}
    `;

/**
 * __useBasicUserGroupsUpdatedSubscription__
 *
 * To run a query within a React component, call `useBasicUserGroupsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBasicUserGroupsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicUserGroupsUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBasicUserGroupsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<BasicUserGroupsUpdatedSubscription, BasicUserGroupsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<BasicUserGroupsUpdatedSubscription, BasicUserGroupsUpdatedSubscriptionVariables>(BasicUserGroupsUpdatedDocument, options);
      }
export type BasicUserGroupsUpdatedSubscriptionHookResult = ReturnType<typeof useBasicUserGroupsUpdatedSubscription>;
export type BasicUserGroupsUpdatedSubscriptionResult = Apollo.SubscriptionResult<BasicUserGroupsUpdatedSubscription>;
export const CommentUserDocument = gql`
    query CommentUser($id: ID!) {
  getKineticUser(id: $id) {
    id
    username
    firstName
    lastName
    email
    phoneNumbers
    roleIds
  }
}
    `;

/**
 * __useCommentUserQuery__
 *
 * To run a query within a React component, call `useCommentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommentUserQuery(baseOptions: Apollo.QueryHookOptions<CommentUserQuery, CommentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentUserQuery, CommentUserQueryVariables>(CommentUserDocument, options);
      }
export function useCommentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentUserQuery, CommentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentUserQuery, CommentUserQueryVariables>(CommentUserDocument, options);
        }
export type CommentUserQueryHookResult = ReturnType<typeof useCommentUserQuery>;
export type CommentUserLazyQueryHookResult = ReturnType<typeof useCommentUserLazyQuery>;
export type CommentUserQueryResult = Apollo.QueryResult<CommentUserQuery, CommentUserQueryVariables>;
export function refetchCommentUserQuery(variables: CommentUserQueryVariables) {
      return { query: CommentUserDocument, variables: variables }
    }
export const GetUserByIdDocument = gql`
    query GetUserById($id: ID!) {
  getKineticUser(id: $id) {
    id
    username
    firstName
    lastName
    email
    phoneNumbers
    roleIds
    userGroupIds
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export function refetchGetUserByIdQuery(variables: GetUserByIdQueryVariables) {
      return { query: GetUserByIdDocument, variables: variables }
    }
export const AllRoleNamesDocument = gql`
    query AllRoleNames {
  roles {
    id
    name
  }
}
    `;

/**
 * __useAllRoleNamesQuery__
 *
 * To run a query within a React component, call `useAllRoleNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRoleNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRoleNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRoleNamesQuery(baseOptions?: Apollo.QueryHookOptions<AllRoleNamesQuery, AllRoleNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRoleNamesQuery, AllRoleNamesQueryVariables>(AllRoleNamesDocument, options);
      }
export function useAllRoleNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRoleNamesQuery, AllRoleNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRoleNamesQuery, AllRoleNamesQueryVariables>(AllRoleNamesDocument, options);
        }
export type AllRoleNamesQueryHookResult = ReturnType<typeof useAllRoleNamesQuery>;
export type AllRoleNamesLazyQueryHookResult = ReturnType<typeof useAllRoleNamesLazyQuery>;
export type AllRoleNamesQueryResult = Apollo.QueryResult<AllRoleNamesQuery, AllRoleNamesQueryVariables>;
export function refetchAllRoleNamesQuery(variables?: AllRoleNamesQueryVariables) {
      return { query: AllRoleNamesDocument, variables: variables }
    }
export const VideoAlarmConfigsDocument = gql`
    query VideoAlarmConfigs {
  alarmConfigs(
    query: {sortField: "name", sortOrder: ASCENDING, filters: [{field: "source", operator: EQUALS, value: "VIDEO"}, {field: "entityType", operator: EQUALS, value: "CAMERA"}], limit: 10000}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useVideoAlarmConfigsQuery__
 *
 * To run a query within a React component, call `useVideoAlarmConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoAlarmConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoAlarmConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVideoAlarmConfigsQuery(baseOptions?: Apollo.QueryHookOptions<VideoAlarmConfigsQuery, VideoAlarmConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoAlarmConfigsQuery, VideoAlarmConfigsQueryVariables>(VideoAlarmConfigsDocument, options);
      }
export function useVideoAlarmConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoAlarmConfigsQuery, VideoAlarmConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoAlarmConfigsQuery, VideoAlarmConfigsQueryVariables>(VideoAlarmConfigsDocument, options);
        }
export type VideoAlarmConfigsQueryHookResult = ReturnType<typeof useVideoAlarmConfigsQuery>;
export type VideoAlarmConfigsLazyQueryHookResult = ReturnType<typeof useVideoAlarmConfigsLazyQuery>;
export type VideoAlarmConfigsQueryResult = Apollo.QueryResult<VideoAlarmConfigsQuery, VideoAlarmConfigsQueryVariables>;
export function refetchVideoAlarmConfigsQuery(variables?: VideoAlarmConfigsQueryVariables) {
      return { query: VideoAlarmConfigsDocument, variables: variables }
    }
export const CameraNamesDocument = gql`
    query CameraNames {
  cameras(limit: 10000) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCameraNamesQuery__
 *
 * To run a query within a React component, call `useCameraNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCameraNamesQuery(baseOptions?: Apollo.QueryHookOptions<CameraNamesQuery, CameraNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraNamesQuery, CameraNamesQueryVariables>(CameraNamesDocument, options);
      }
export function useCameraNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraNamesQuery, CameraNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraNamesQuery, CameraNamesQueryVariables>(CameraNamesDocument, options);
        }
export type CameraNamesQueryHookResult = ReturnType<typeof useCameraNamesQuery>;
export type CameraNamesLazyQueryHookResult = ReturnType<typeof useCameraNamesLazyQuery>;
export type CameraNamesQueryResult = Apollo.QueryResult<CameraNamesQuery, CameraNamesQueryVariables>;
export function refetchCameraNamesQuery(variables?: CameraNamesQueryVariables) {
      return { query: CameraNamesDocument, variables: variables }
    }
export const DeleteCameraGroupsDocument = gql`
    mutation DeleteCameraGroups($groups: [ID!]!) {
  deleteCameraGroups(groups: $groups)
}
    `;
export type DeleteCameraGroupsMutationFn = Apollo.MutationFunction<DeleteCameraGroupsMutation, DeleteCameraGroupsMutationVariables>;

/**
 * __useDeleteCameraGroupsMutation__
 *
 * To run a mutation, you first call `useDeleteCameraGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCameraGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCameraGroupsMutation, { data, loading, error }] = useDeleteCameraGroupsMutation({
 *   variables: {
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useDeleteCameraGroupsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCameraGroupsMutation, DeleteCameraGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCameraGroupsMutation, DeleteCameraGroupsMutationVariables>(DeleteCameraGroupsDocument, options);
      }
export type DeleteCameraGroupsMutationHookResult = ReturnType<typeof useDeleteCameraGroupsMutation>;
export type DeleteCameraGroupsMutationResult = Apollo.MutationResult<DeleteCameraGroupsMutation>;
export type DeleteCameraGroupsMutationOptions = Apollo.BaseMutationOptions<DeleteCameraGroupsMutation, DeleteCameraGroupsMutationVariables>;
export const DeleteToursDocument = gql`
    mutation DeleteTours($tours: [ID!]!) {
  deleteTours(tours: $tours)
}
    `;
export type DeleteToursMutationFn = Apollo.MutationFunction<DeleteToursMutation, DeleteToursMutationVariables>;

/**
 * __useDeleteToursMutation__
 *
 * To run a mutation, you first call `useDeleteToursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteToursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteToursMutation, { data, loading, error }] = useDeleteToursMutation({
 *   variables: {
 *      tours: // value for 'tours'
 *   },
 * });
 */
export function useDeleteToursMutation(baseOptions?: Apollo.MutationHookOptions<DeleteToursMutation, DeleteToursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteToursMutation, DeleteToursMutationVariables>(DeleteToursDocument, options);
      }
export type DeleteToursMutationHookResult = ReturnType<typeof useDeleteToursMutation>;
export type DeleteToursMutationResult = Apollo.MutationResult<DeleteToursMutation>;
export type DeleteToursMutationOptions = Apollo.BaseMutationOptions<DeleteToursMutation, DeleteToursMutationVariables>;
export const CameraGoToPresetDocument = gql`
    mutation CameraGoToPreset($cameraId: String!, $presetId: String!) {
  gotoPreset(cameraGotoPresetInput: {cameraId: $cameraId, presetId: $presetId}) {
    ...CreatedJobRequest
  }
}
    ${CreatedJobRequestFragmentDoc}`;
export type CameraGoToPresetMutationFn = Apollo.MutationFunction<CameraGoToPresetMutation, CameraGoToPresetMutationVariables>;

/**
 * __useCameraGoToPresetMutation__
 *
 * To run a mutation, you first call `useCameraGoToPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCameraGoToPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cameraGoToPresetMutation, { data, loading, error }] = useCameraGoToPresetMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      presetId: // value for 'presetId'
 *   },
 * });
 */
export function useCameraGoToPresetMutation(baseOptions?: Apollo.MutationHookOptions<CameraGoToPresetMutation, CameraGoToPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CameraGoToPresetMutation, CameraGoToPresetMutationVariables>(CameraGoToPresetDocument, options);
      }
export type CameraGoToPresetMutationHookResult = ReturnType<typeof useCameraGoToPresetMutation>;
export type CameraGoToPresetMutationResult = Apollo.MutationResult<CameraGoToPresetMutation>;
export type CameraGoToPresetMutationOptions = Apollo.BaseMutationOptions<CameraGoToPresetMutation, CameraGoToPresetMutationVariables>;
export const DeleteScreensDocument = gql`
    mutation DeleteScreens($screens: [ID!]!) {
  deleteScreens(screens: $screens)
}
    `;
export type DeleteScreensMutationFn = Apollo.MutationFunction<DeleteScreensMutation, DeleteScreensMutationVariables>;

/**
 * __useDeleteScreensMutation__
 *
 * To run a mutation, you first call `useDeleteScreensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScreensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScreensMutation, { data, loading, error }] = useDeleteScreensMutation({
 *   variables: {
 *      screens: // value for 'screens'
 *   },
 * });
 */
export function useDeleteScreensMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScreensMutation, DeleteScreensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScreensMutation, DeleteScreensMutationVariables>(DeleteScreensDocument, options);
      }
export type DeleteScreensMutationHookResult = ReturnType<typeof useDeleteScreensMutation>;
export type DeleteScreensMutationResult = Apollo.MutationResult<DeleteScreensMutation>;
export type DeleteScreensMutationOptions = Apollo.BaseMutationOptions<DeleteScreensMutation, DeleteScreensMutationVariables>;
export const DeleteScenesDocument = gql`
    mutation DeleteScenes($scenes: [ID!]!) {
  deleteScenes(scenes: $scenes)
}
    `;
export type DeleteScenesMutationFn = Apollo.MutationFunction<DeleteScenesMutation, DeleteScenesMutationVariables>;

/**
 * __useDeleteScenesMutation__
 *
 * To run a mutation, you first call `useDeleteScenesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScenesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScenesMutation, { data, loading, error }] = useDeleteScenesMutation({
 *   variables: {
 *      scenes: // value for 'scenes'
 *   },
 * });
 */
export function useDeleteScenesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScenesMutation, DeleteScenesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScenesMutation, DeleteScenesMutationVariables>(DeleteScenesDocument, options);
      }
export type DeleteScenesMutationHookResult = ReturnType<typeof useDeleteScenesMutation>;
export type DeleteScenesMutationResult = Apollo.MutationResult<DeleteScenesMutation>;
export type DeleteScenesMutationOptions = Apollo.BaseMutationOptions<DeleteScenesMutation, DeleteScenesMutationVariables>;
export const SaveSceneDocument = gql`
    mutation SaveScene($input: SceneInput!) {
  saveScene(input: $input) {
    ...Scene
  }
}
    ${SceneFragmentDoc}`;
export type SaveSceneMutationFn = Apollo.MutationFunction<SaveSceneMutation, SaveSceneMutationVariables>;

/**
 * __useSaveSceneMutation__
 *
 * To run a mutation, you first call `useSaveSceneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSceneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSceneMutation, { data, loading, error }] = useSaveSceneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSceneMutation(baseOptions?: Apollo.MutationHookOptions<SaveSceneMutation, SaveSceneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSceneMutation, SaveSceneMutationVariables>(SaveSceneDocument, options);
      }
export type SaveSceneMutationHookResult = ReturnType<typeof useSaveSceneMutation>;
export type SaveSceneMutationResult = Apollo.MutationResult<SaveSceneMutation>;
export type SaveSceneMutationOptions = Apollo.BaseMutationOptions<SaveSceneMutation, SaveSceneMutationVariables>;
export const TourHeartBeatDocument = gql`
    mutation TourHeartBeat($tourId: ID!) {
  tourHeartBeat(tourId: $tourId)
}
    `;
export type TourHeartBeatMutationFn = Apollo.MutationFunction<TourHeartBeatMutation, TourHeartBeatMutationVariables>;

/**
 * __useTourHeartBeatMutation__
 *
 * To run a mutation, you first call `useTourHeartBeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTourHeartBeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tourHeartBeatMutation, { data, loading, error }] = useTourHeartBeatMutation({
 *   variables: {
 *      tourId: // value for 'tourId'
 *   },
 * });
 */
export function useTourHeartBeatMutation(baseOptions?: Apollo.MutationHookOptions<TourHeartBeatMutation, TourHeartBeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TourHeartBeatMutation, TourHeartBeatMutationVariables>(TourHeartBeatDocument, options);
      }
export type TourHeartBeatMutationHookResult = ReturnType<typeof useTourHeartBeatMutation>;
export type TourHeartBeatMutationResult = Apollo.MutationResult<TourHeartBeatMutation>;
export type TourHeartBeatMutationOptions = Apollo.BaseMutationOptions<TourHeartBeatMutation, TourHeartBeatMutationVariables>;
export const DeletePresetsDocument = gql`
    mutation DeletePresets($presets: [ID!]!) {
  deletePresets(presets: $presets)
}
    `;
export type DeletePresetsMutationFn = Apollo.MutationFunction<DeletePresetsMutation, DeletePresetsMutationVariables>;

/**
 * __useDeletePresetsMutation__
 *
 * To run a mutation, you first call `useDeletePresetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePresetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePresetsMutation, { data, loading, error }] = useDeletePresetsMutation({
 *   variables: {
 *      presets: // value for 'presets'
 *   },
 * });
 */
export function useDeletePresetsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePresetsMutation, DeletePresetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePresetsMutation, DeletePresetsMutationVariables>(DeletePresetsDocument, options);
      }
export type DeletePresetsMutationHookResult = ReturnType<typeof useDeletePresetsMutation>;
export type DeletePresetsMutationResult = Apollo.MutationResult<DeletePresetsMutation>;
export type DeletePresetsMutationOptions = Apollo.BaseMutationOptions<DeletePresetsMutation, DeletePresetsMutationVariables>;
export const SavePresetDocument = gql`
    mutation SavePreset($input: PresetInput!) {
  savePreset(input: $input) {
    id
    presetIndex
    name
  }
}
    `;
export type SavePresetMutationFn = Apollo.MutationFunction<SavePresetMutation, SavePresetMutationVariables>;

/**
 * __useSavePresetMutation__
 *
 * To run a mutation, you first call `useSavePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePresetMutation, { data, loading, error }] = useSavePresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePresetMutation(baseOptions?: Apollo.MutationHookOptions<SavePresetMutation, SavePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePresetMutation, SavePresetMutationVariables>(SavePresetDocument, options);
      }
export type SavePresetMutationHookResult = ReturnType<typeof useSavePresetMutation>;
export type SavePresetMutationResult = Apollo.MutationResult<SavePresetMutation>;
export type SavePresetMutationOptions = Apollo.BaseMutationOptions<SavePresetMutation, SavePresetMutationVariables>;
export const SaveCameraPresetDocument = gql`
    mutation SaveCameraPreset($id: String!, $presetId: String!, $presetNumber: Int!) {
  saveCameraPreset(id: $id, presetId: $presetId, presetNumber: $presetNumber) {
    id
    success
    requestId
    failure
  }
}
    `;
export type SaveCameraPresetMutationFn = Apollo.MutationFunction<SaveCameraPresetMutation, SaveCameraPresetMutationVariables>;

/**
 * __useSaveCameraPresetMutation__
 *
 * To run a mutation, you first call `useSaveCameraPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCameraPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCameraPresetMutation, { data, loading, error }] = useSaveCameraPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      presetId: // value for 'presetId'
 *      presetNumber: // value for 'presetNumber'
 *   },
 * });
 */
export function useSaveCameraPresetMutation(baseOptions?: Apollo.MutationHookOptions<SaveCameraPresetMutation, SaveCameraPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCameraPresetMutation, SaveCameraPresetMutationVariables>(SaveCameraPresetDocument, options);
      }
export type SaveCameraPresetMutationHookResult = ReturnType<typeof useSaveCameraPresetMutation>;
export type SaveCameraPresetMutationResult = Apollo.MutationResult<SaveCameraPresetMutation>;
export type SaveCameraPresetMutationOptions = Apollo.BaseMutationOptions<SaveCameraPresetMutation, SaveCameraPresetMutationVariables>;
export const UseCameraCapabilityDocument = gql`
    mutation UseCameraCapability($cameraId: ID!, $capability: CameraCapability!, $option: String!) {
  useCameraCapability(
    cameraId: $cameraId
    capability: $capability
    option: $option
  ) {
    success
  }
}
    `;
export type UseCameraCapabilityMutationFn = Apollo.MutationFunction<UseCameraCapabilityMutation, UseCameraCapabilityMutationVariables>;

/**
 * __useUseCameraCapabilityMutation__
 *
 * To run a mutation, you first call `useUseCameraCapabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseCameraCapabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useCameraCapabilityMutation, { data, loading, error }] = useUseCameraCapabilityMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      capability: // value for 'capability'
 *      option: // value for 'option'
 *   },
 * });
 */
export function useUseCameraCapabilityMutation(baseOptions?: Apollo.MutationHookOptions<UseCameraCapabilityMutation, UseCameraCapabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseCameraCapabilityMutation, UseCameraCapabilityMutationVariables>(UseCameraCapabilityDocument, options);
      }
export type UseCameraCapabilityMutationHookResult = ReturnType<typeof useUseCameraCapabilityMutation>;
export type UseCameraCapabilityMutationResult = Apollo.MutationResult<UseCameraCapabilityMutation>;
export type UseCameraCapabilityMutationOptions = Apollo.BaseMutationOptions<UseCameraCapabilityMutation, UseCameraCapabilityMutationVariables>;
export const EnableCameraAutoFocusDocument = gql`
    mutation EnableCameraAutoFocus($cameraAutoFocusInput: CameraAutoFocusInput!) {
  enableCameraAutoFocus(cameraAutoFocusInput: $cameraAutoFocusInput) {
    ...CreatedJobRequest
  }
}
    ${CreatedJobRequestFragmentDoc}`;
export type EnableCameraAutoFocusMutationFn = Apollo.MutationFunction<EnableCameraAutoFocusMutation, EnableCameraAutoFocusMutationVariables>;

/**
 * __useEnableCameraAutoFocusMutation__
 *
 * To run a mutation, you first call `useEnableCameraAutoFocusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableCameraAutoFocusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableCameraAutoFocusMutation, { data, loading, error }] = useEnableCameraAutoFocusMutation({
 *   variables: {
 *      cameraAutoFocusInput: // value for 'cameraAutoFocusInput'
 *   },
 * });
 */
export function useEnableCameraAutoFocusMutation(baseOptions?: Apollo.MutationHookOptions<EnableCameraAutoFocusMutation, EnableCameraAutoFocusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableCameraAutoFocusMutation, EnableCameraAutoFocusMutationVariables>(EnableCameraAutoFocusDocument, options);
      }
export type EnableCameraAutoFocusMutationHookResult = ReturnType<typeof useEnableCameraAutoFocusMutation>;
export type EnableCameraAutoFocusMutationResult = Apollo.MutationResult<EnableCameraAutoFocusMutation>;
export type EnableCameraAutoFocusMutationOptions = Apollo.BaseMutationOptions<EnableCameraAutoFocusMutation, EnableCameraAutoFocusMutationVariables>;
export const EnableCameraAutoIrisDocument = gql`
    mutation EnableCameraAutoIris($cameraAutoIrisInput: CameraAutoIrisInput!) {
  enableCameraAutoIris(cameraAutoIrisInput: $cameraAutoIrisInput) {
    ...CreatedJobRequest
  }
}
    ${CreatedJobRequestFragmentDoc}`;
export type EnableCameraAutoIrisMutationFn = Apollo.MutationFunction<EnableCameraAutoIrisMutation, EnableCameraAutoIrisMutationVariables>;

/**
 * __useEnableCameraAutoIrisMutation__
 *
 * To run a mutation, you first call `useEnableCameraAutoIrisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableCameraAutoIrisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableCameraAutoIrisMutation, { data, loading, error }] = useEnableCameraAutoIrisMutation({
 *   variables: {
 *      cameraAutoIrisInput: // value for 'cameraAutoIrisInput'
 *   },
 * });
 */
export function useEnableCameraAutoIrisMutation(baseOptions?: Apollo.MutationHookOptions<EnableCameraAutoIrisMutation, EnableCameraAutoIrisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableCameraAutoIrisMutation, EnableCameraAutoIrisMutationVariables>(EnableCameraAutoIrisDocument, options);
      }
export type EnableCameraAutoIrisMutationHookResult = ReturnType<typeof useEnableCameraAutoIrisMutation>;
export type EnableCameraAutoIrisMutationResult = Apollo.MutationResult<EnableCameraAutoIrisMutation>;
export type EnableCameraAutoIrisMutationOptions = Apollo.BaseMutationOptions<EnableCameraAutoIrisMutation, EnableCameraAutoIrisMutationVariables>;
export const FocusCameraDocument = gql`
    mutation FocusCamera($cameraFocusInput: CameraFocusInput!) {
  focusCamera(cameraFocusInput: $cameraFocusInput) {
    ...CreatedJobRequest
  }
}
    ${CreatedJobRequestFragmentDoc}`;
export type FocusCameraMutationFn = Apollo.MutationFunction<FocusCameraMutation, FocusCameraMutationVariables>;

/**
 * __useFocusCameraMutation__
 *
 * To run a mutation, you first call `useFocusCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFocusCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [focusCameraMutation, { data, loading, error }] = useFocusCameraMutation({
 *   variables: {
 *      cameraFocusInput: // value for 'cameraFocusInput'
 *   },
 * });
 */
export function useFocusCameraMutation(baseOptions?: Apollo.MutationHookOptions<FocusCameraMutation, FocusCameraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FocusCameraMutation, FocusCameraMutationVariables>(FocusCameraDocument, options);
      }
export type FocusCameraMutationHookResult = ReturnType<typeof useFocusCameraMutation>;
export type FocusCameraMutationResult = Apollo.MutationResult<FocusCameraMutation>;
export type FocusCameraMutationOptions = Apollo.BaseMutationOptions<FocusCameraMutation, FocusCameraMutationVariables>;
export const IrisCameraDocument = gql`
    mutation IrisCamera($cameraIrisInput: CameraIrisInput!) {
  irisCamera(cameraIrisInput: $cameraIrisInput) {
    ...CreatedJobRequest
  }
}
    ${CreatedJobRequestFragmentDoc}`;
export type IrisCameraMutationFn = Apollo.MutationFunction<IrisCameraMutation, IrisCameraMutationVariables>;

/**
 * __useIrisCameraMutation__
 *
 * To run a mutation, you first call `useIrisCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIrisCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [irisCameraMutation, { data, loading, error }] = useIrisCameraMutation({
 *   variables: {
 *      cameraIrisInput: // value for 'cameraIrisInput'
 *   },
 * });
 */
export function useIrisCameraMutation(baseOptions?: Apollo.MutationHookOptions<IrisCameraMutation, IrisCameraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IrisCameraMutation, IrisCameraMutationVariables>(IrisCameraDocument, options);
      }
export type IrisCameraMutationHookResult = ReturnType<typeof useIrisCameraMutation>;
export type IrisCameraMutationResult = Apollo.MutationResult<IrisCameraMutation>;
export type IrisCameraMutationOptions = Apollo.BaseMutationOptions<IrisCameraMutation, IrisCameraMutationVariables>;
export const ChangeTourStateDocument = gql`
    mutation ChangeTourState($tourId: ID!, $paused: Boolean) {
  changeTourState(tourId: $tourId, paused: $paused)
}
    `;
export type ChangeTourStateMutationFn = Apollo.MutationFunction<ChangeTourStateMutation, ChangeTourStateMutationVariables>;

/**
 * __useChangeTourStateMutation__
 *
 * To run a mutation, you first call `useChangeTourStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTourStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTourStateMutation, { data, loading, error }] = useChangeTourStateMutation({
 *   variables: {
 *      tourId: // value for 'tourId'
 *      paused: // value for 'paused'
 *   },
 * });
 */
export function useChangeTourStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTourStateMutation, ChangeTourStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTourStateMutation, ChangeTourStateMutationVariables>(ChangeTourStateDocument, options);
      }
export type ChangeTourStateMutationHookResult = ReturnType<typeof useChangeTourStateMutation>;
export type ChangeTourStateMutationResult = Apollo.MutationResult<ChangeTourStateMutation>;
export type ChangeTourStateMutationOptions = Apollo.BaseMutationOptions<ChangeTourStateMutation, ChangeTourStateMutationVariables>;
export const SaveVideoModuleSettingsDocument = gql`
    mutation saveVideoModuleSettings($settings: JSON!) {
  saveVideoModuleSettings(settings: $settings)
}
    `;
export type SaveVideoModuleSettingsMutationFn = Apollo.MutationFunction<SaveVideoModuleSettingsMutation, SaveVideoModuleSettingsMutationVariables>;

/**
 * __useSaveVideoModuleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveVideoModuleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveVideoModuleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveVideoModuleSettingsMutation, { data, loading, error }] = useSaveVideoModuleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveVideoModuleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveVideoModuleSettingsMutation, SaveVideoModuleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveVideoModuleSettingsMutation, SaveVideoModuleSettingsMutationVariables>(SaveVideoModuleSettingsDocument, options);
      }
export type SaveVideoModuleSettingsMutationHookResult = ReturnType<typeof useSaveVideoModuleSettingsMutation>;
export type SaveVideoModuleSettingsMutationResult = Apollo.MutationResult<SaveVideoModuleSettingsMutation>;
export type SaveVideoModuleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveVideoModuleSettingsMutation, SaveVideoModuleSettingsMutationVariables>;
export const CameraExplicitLockDocument = gql`
    mutation cameraExplicitLock($cameraId: ID!) {
  cameraExplicitLock(cameraId: $cameraId)
}
    `;
export type CameraExplicitLockMutationFn = Apollo.MutationFunction<CameraExplicitLockMutation, CameraExplicitLockMutationVariables>;

/**
 * __useCameraExplicitLockMutation__
 *
 * To run a mutation, you first call `useCameraExplicitLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCameraExplicitLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cameraExplicitLockMutation, { data, loading, error }] = useCameraExplicitLockMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useCameraExplicitLockMutation(baseOptions?: Apollo.MutationHookOptions<CameraExplicitLockMutation, CameraExplicitLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CameraExplicitLockMutation, CameraExplicitLockMutationVariables>(CameraExplicitLockDocument, options);
      }
export type CameraExplicitLockMutationHookResult = ReturnType<typeof useCameraExplicitLockMutation>;
export type CameraExplicitLockMutationResult = Apollo.MutationResult<CameraExplicitLockMutation>;
export type CameraExplicitLockMutationOptions = Apollo.BaseMutationOptions<CameraExplicitLockMutation, CameraExplicitLockMutationVariables>;
export const UnlockPtzCameraDocument = gql`
    mutation unlockPTZCamera($cameraId: ID!) {
  unlockPTZCamera(cameraId: $cameraId)
}
    `;
export type UnlockPtzCameraMutationFn = Apollo.MutationFunction<UnlockPtzCameraMutation, UnlockPtzCameraMutationVariables>;

/**
 * __useUnlockPtzCameraMutation__
 *
 * To run a mutation, you first call `useUnlockPtzCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockPtzCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockPtzCameraMutation, { data, loading, error }] = useUnlockPtzCameraMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useUnlockPtzCameraMutation(baseOptions?: Apollo.MutationHookOptions<UnlockPtzCameraMutation, UnlockPtzCameraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockPtzCameraMutation, UnlockPtzCameraMutationVariables>(UnlockPtzCameraDocument, options);
      }
export type UnlockPtzCameraMutationHookResult = ReturnType<typeof useUnlockPtzCameraMutation>;
export type UnlockPtzCameraMutationResult = Apollo.MutationResult<UnlockPtzCameraMutation>;
export type UnlockPtzCameraMutationOptions = Apollo.BaseMutationOptions<UnlockPtzCameraMutation, UnlockPtzCameraMutationVariables>;
export const CameraRecordingDocument = gql`
    mutation CameraRecording($cameraId: String!, $streamRecorderId: String!, $streamAccessType: VideoStreamAccessType!, $recordingType: RecordingType, $start: Boolean!, $recordingName: String!) {
  cameraRecording(
    cameraStreamRecordingInput: {cameraId: $cameraId, recordingInitiatedBy: USER, streamRecorderId: $streamRecorderId, streamAccessType: $streamAccessType, recordingType: $recordingType, start: $start, recordingName: $recordingName}
  ) {
    ...CreatedJobRequest
  }
}
    ${CreatedJobRequestFragmentDoc}`;
export type CameraRecordingMutationFn = Apollo.MutationFunction<CameraRecordingMutation, CameraRecordingMutationVariables>;

/**
 * __useCameraRecordingMutation__
 *
 * To run a mutation, you first call `useCameraRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCameraRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cameraRecordingMutation, { data, loading, error }] = useCameraRecordingMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      streamRecorderId: // value for 'streamRecorderId'
 *      streamAccessType: // value for 'streamAccessType'
 *      recordingType: // value for 'recordingType'
 *      start: // value for 'start'
 *      recordingName: // value for 'recordingName'
 *   },
 * });
 */
export function useCameraRecordingMutation(baseOptions?: Apollo.MutationHookOptions<CameraRecordingMutation, CameraRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CameraRecordingMutation, CameraRecordingMutationVariables>(CameraRecordingDocument, options);
      }
export type CameraRecordingMutationHookResult = ReturnType<typeof useCameraRecordingMutation>;
export type CameraRecordingMutationResult = Apollo.MutationResult<CameraRecordingMutation>;
export type CameraRecordingMutationOptions = Apollo.BaseMutationOptions<CameraRecordingMutation, CameraRecordingMutationVariables>;
export const DeleteRecordingsDocument = gql`
    mutation DeleteRecordings($videoRecords: [String!]!) {
  deleteRecordings(videoRecords: $videoRecords)
}
    `;
export type DeleteRecordingsMutationFn = Apollo.MutationFunction<DeleteRecordingsMutation, DeleteRecordingsMutationVariables>;

/**
 * __useDeleteRecordingsMutation__
 *
 * To run a mutation, you first call `useDeleteRecordingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecordingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecordingsMutation, { data, loading, error }] = useDeleteRecordingsMutation({
 *   variables: {
 *      videoRecords: // value for 'videoRecords'
 *   },
 * });
 */
export function useDeleteRecordingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecordingsMutation, DeleteRecordingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecordingsMutation, DeleteRecordingsMutationVariables>(DeleteRecordingsDocument, options);
      }
export type DeleteRecordingsMutationHookResult = ReturnType<typeof useDeleteRecordingsMutation>;
export type DeleteRecordingsMutationResult = Apollo.MutationResult<DeleteRecordingsMutation>;
export type DeleteRecordingsMutationOptions = Apollo.BaseMutationOptions<DeleteRecordingsMutation, DeleteRecordingsMutationVariables>;
export const SaveTourDocument = gql`
    mutation SaveTour($input: TourInput!) {
  saveTour(input: $input) {
    ...TourListNodeFragment
  }
}
    ${TourListNodeFragmentFragmentDoc}`;
export type SaveTourMutationFn = Apollo.MutationFunction<SaveTourMutation, SaveTourMutationVariables>;

/**
 * __useSaveTourMutation__
 *
 * To run a mutation, you first call `useSaveTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTourMutation, { data, loading, error }] = useSaveTourMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTourMutation(baseOptions?: Apollo.MutationHookOptions<SaveTourMutation, SaveTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTourMutation, SaveTourMutationVariables>(SaveTourDocument, options);
      }
export type SaveTourMutationHookResult = ReturnType<typeof useSaveTourMutation>;
export type SaveTourMutationResult = Apollo.MutationResult<SaveTourMutation>;
export type SaveTourMutationOptions = Apollo.BaseMutationOptions<SaveTourMutation, SaveTourMutationVariables>;
export const SaveScreenDocument = gql`
    mutation SaveScreen($input: ScreenInput!) {
  saveScreen(input: $input) {
    ...Screen
  }
}
    ${ScreenFragmentDoc}`;
export type SaveScreenMutationFn = Apollo.MutationFunction<SaveScreenMutation, SaveScreenMutationVariables>;

/**
 * __useSaveScreenMutation__
 *
 * To run a mutation, you first call `useSaveScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScreenMutation, { data, loading, error }] = useSaveScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveScreenMutation(baseOptions?: Apollo.MutationHookOptions<SaveScreenMutation, SaveScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveScreenMutation, SaveScreenMutationVariables>(SaveScreenDocument, options);
      }
export type SaveScreenMutationHookResult = ReturnType<typeof useSaveScreenMutation>;
export type SaveScreenMutationResult = Apollo.MutationResult<SaveScreenMutation>;
export type SaveScreenMutationOptions = Apollo.BaseMutationOptions<SaveScreenMutation, SaveScreenMutationVariables>;
export const ReorderScreensDocument = gql`
    mutation ReorderScreens($screens: [ScreenOrderInput!]!) {
  reorderScreens(screens: $screens)
}
    `;
export type ReorderScreensMutationFn = Apollo.MutationFunction<ReorderScreensMutation, ReorderScreensMutationVariables>;

/**
 * __useReorderScreensMutation__
 *
 * To run a mutation, you first call `useReorderScreensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderScreensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderScreensMutation, { data, loading, error }] = useReorderScreensMutation({
 *   variables: {
 *      screens: // value for 'screens'
 *   },
 * });
 */
export function useReorderScreensMutation(baseOptions?: Apollo.MutationHookOptions<ReorderScreensMutation, ReorderScreensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderScreensMutation, ReorderScreensMutationVariables>(ReorderScreensDocument, options);
      }
export type ReorderScreensMutationHookResult = ReturnType<typeof useReorderScreensMutation>;
export type ReorderScreensMutationResult = Apollo.MutationResult<ReorderScreensMutation>;
export type ReorderScreensMutationOptions = Apollo.BaseMutationOptions<ReorderScreensMutation, ReorderScreensMutationVariables>;
export const ReorderCameraGroupsDocument = gql`
    mutation ReorderCameraGroups($groups: [CameraGroupOrderInput!]!) {
  reorderCameraGroups(groups: $groups)
}
    `;
export type ReorderCameraGroupsMutationFn = Apollo.MutationFunction<ReorderCameraGroupsMutation, ReorderCameraGroupsMutationVariables>;

/**
 * __useReorderCameraGroupsMutation__
 *
 * To run a mutation, you first call `useReorderCameraGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderCameraGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderCameraGroupsMutation, { data, loading, error }] = useReorderCameraGroupsMutation({
 *   variables: {
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useReorderCameraGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderCameraGroupsMutation, ReorderCameraGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderCameraGroupsMutation, ReorderCameraGroupsMutationVariables>(ReorderCameraGroupsDocument, options);
      }
export type ReorderCameraGroupsMutationHookResult = ReturnType<typeof useReorderCameraGroupsMutation>;
export type ReorderCameraGroupsMutationResult = Apollo.MutationResult<ReorderCameraGroupsMutation>;
export type ReorderCameraGroupsMutationOptions = Apollo.BaseMutationOptions<ReorderCameraGroupsMutation, ReorderCameraGroupsMutationVariables>;
export const PanTiltCameraDocument = gql`
    mutation PanTiltCamera($cameraPanTiltInput: CameraPanTiltInput!) {
  panTiltCamera(cameraPanTiltInput: $cameraPanTiltInput) {
    success
  }
}
    `;
export type PanTiltCameraMutationFn = Apollo.MutationFunction<PanTiltCameraMutation, PanTiltCameraMutationVariables>;

/**
 * __usePanTiltCameraMutation__
 *
 * To run a mutation, you first call `usePanTiltCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePanTiltCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [panTiltCameraMutation, { data, loading, error }] = usePanTiltCameraMutation({
 *   variables: {
 *      cameraPanTiltInput: // value for 'cameraPanTiltInput'
 *   },
 * });
 */
export function usePanTiltCameraMutation(baseOptions?: Apollo.MutationHookOptions<PanTiltCameraMutation, PanTiltCameraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PanTiltCameraMutation, PanTiltCameraMutationVariables>(PanTiltCameraDocument, options);
      }
export type PanTiltCameraMutationHookResult = ReturnType<typeof usePanTiltCameraMutation>;
export type PanTiltCameraMutationResult = Apollo.MutationResult<PanTiltCameraMutation>;
export type PanTiltCameraMutationOptions = Apollo.BaseMutationOptions<PanTiltCameraMutation, PanTiltCameraMutationVariables>;
export const CameraZoomDocument = gql`
    mutation CameraZoom($cameraZoomInput: CameraZoomInput!) {
  zoomCamera(cameraZoomInput: $cameraZoomInput) {
    success
  }
}
    `;
export type CameraZoomMutationFn = Apollo.MutationFunction<CameraZoomMutation, CameraZoomMutationVariables>;

/**
 * __useCameraZoomMutation__
 *
 * To run a mutation, you first call `useCameraZoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCameraZoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cameraZoomMutation, { data, loading, error }] = useCameraZoomMutation({
 *   variables: {
 *      cameraZoomInput: // value for 'cameraZoomInput'
 *   },
 * });
 */
export function useCameraZoomMutation(baseOptions?: Apollo.MutationHookOptions<CameraZoomMutation, CameraZoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CameraZoomMutation, CameraZoomMutationVariables>(CameraZoomDocument, options);
      }
export type CameraZoomMutationHookResult = ReturnType<typeof useCameraZoomMutation>;
export type CameraZoomMutationResult = Apollo.MutationResult<CameraZoomMutation>;
export type CameraZoomMutationOptions = Apollo.BaseMutationOptions<CameraZoomMutation, CameraZoomMutationVariables>;
export const CameraPublicFeedDocument = gql`
    mutation CameraPublicFeed($cameraPublicFeedInput: CameraPublicFeedInput!) {
  cameraPublicFeed(cameraPublicFeedInput: $cameraPublicFeedInput) {
    success
  }
}
    `;
export type CameraPublicFeedMutationFn = Apollo.MutationFunction<CameraPublicFeedMutation, CameraPublicFeedMutationVariables>;

/**
 * __useCameraPublicFeedMutation__
 *
 * To run a mutation, you first call `useCameraPublicFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCameraPublicFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cameraPublicFeedMutation, { data, loading, error }] = useCameraPublicFeedMutation({
 *   variables: {
 *      cameraPublicFeedInput: // value for 'cameraPublicFeedInput'
 *   },
 * });
 */
export function useCameraPublicFeedMutation(baseOptions?: Apollo.MutationHookOptions<CameraPublicFeedMutation, CameraPublicFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CameraPublicFeedMutation, CameraPublicFeedMutationVariables>(CameraPublicFeedDocument, options);
      }
export type CameraPublicFeedMutationHookResult = ReturnType<typeof useCameraPublicFeedMutation>;
export type CameraPublicFeedMutationResult = Apollo.MutationResult<CameraPublicFeedMutation>;
export type CameraPublicFeedMutationOptions = Apollo.BaseMutationOptions<CameraPublicFeedMutation, CameraPublicFeedMutationVariables>;
export const SetAsHomePresetDocument = gql`
    mutation SetAsHomePreset($homePresetInput: HomePresetInput!) {
  setAsHomePreset(homePresetInput: $homePresetInput) {
    id
    presetIndex
    name
    isHomePreset
  }
}
    `;
export type SetAsHomePresetMutationFn = Apollo.MutationFunction<SetAsHomePresetMutation, SetAsHomePresetMutationVariables>;

/**
 * __useSetAsHomePresetMutation__
 *
 * To run a mutation, you first call `useSetAsHomePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAsHomePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAsHomePresetMutation, { data, loading, error }] = useSetAsHomePresetMutation({
 *   variables: {
 *      homePresetInput: // value for 'homePresetInput'
 *   },
 * });
 */
export function useSetAsHomePresetMutation(baseOptions?: Apollo.MutationHookOptions<SetAsHomePresetMutation, SetAsHomePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAsHomePresetMutation, SetAsHomePresetMutationVariables>(SetAsHomePresetDocument, options);
      }
export type SetAsHomePresetMutationHookResult = ReturnType<typeof useSetAsHomePresetMutation>;
export type SetAsHomePresetMutationResult = Apollo.MutationResult<SetAsHomePresetMutation>;
export type SetAsHomePresetMutationOptions = Apollo.BaseMutationOptions<SetAsHomePresetMutation, SetAsHomePresetMutationVariables>;
export const SaveCameraGroupDocument = gql`
    mutation SaveCameraGroup($input: CameraGroupInput!) {
  saveCameraGroup(input: $input) {
    ...CameraGroupFragment
  }
}
    ${CameraGroupFragmentFragmentDoc}`;
export type SaveCameraGroupMutationFn = Apollo.MutationFunction<SaveCameraGroupMutation, SaveCameraGroupMutationVariables>;

/**
 * __useSaveCameraGroupMutation__
 *
 * To run a mutation, you first call `useSaveCameraGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCameraGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCameraGroupMutation, { data, loading, error }] = useSaveCameraGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCameraGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveCameraGroupMutation, SaveCameraGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCameraGroupMutation, SaveCameraGroupMutationVariables>(SaveCameraGroupDocument, options);
      }
export type SaveCameraGroupMutationHookResult = ReturnType<typeof useSaveCameraGroupMutation>;
export type SaveCameraGroupMutationResult = Apollo.MutationResult<SaveCameraGroupMutation>;
export type SaveCameraGroupMutationOptions = Apollo.BaseMutationOptions<SaveCameraGroupMutation, SaveCameraGroupMutationVariables>;
export const SaveWidgetDocument = gql`
    mutation SaveWidget($input: WidgetInput!) {
  saveWidget(input: $input) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;
export type SaveWidgetMutationFn = Apollo.MutationFunction<SaveWidgetMutation, SaveWidgetMutationVariables>;

/**
 * __useSaveWidgetMutation__
 *
 * To run a mutation, you first call `useSaveWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWidgetMutation, { data, loading, error }] = useSaveWidgetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveWidgetMutation(baseOptions?: Apollo.MutationHookOptions<SaveWidgetMutation, SaveWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWidgetMutation, SaveWidgetMutationVariables>(SaveWidgetDocument, options);
      }
export type SaveWidgetMutationHookResult = ReturnType<typeof useSaveWidgetMutation>;
export type SaveWidgetMutationResult = Apollo.MutationResult<SaveWidgetMutation>;
export type SaveWidgetMutationOptions = Apollo.BaseMutationOptions<SaveWidgetMutation, SaveWidgetMutationVariables>;
export const DeleteWidgetsDocument = gql`
    mutation DeleteWidgets($widgets: [ID!]!) {
  deleteWidgets(widgets: $widgets)
}
    `;
export type DeleteWidgetsMutationFn = Apollo.MutationFunction<DeleteWidgetsMutation, DeleteWidgetsMutationVariables>;

/**
 * __useDeleteWidgetsMutation__
 *
 * To run a mutation, you first call `useDeleteWidgetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWidgetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWidgetsMutation, { data, loading, error }] = useDeleteWidgetsMutation({
 *   variables: {
 *      widgets: // value for 'widgets'
 *   },
 * });
 */
export function useDeleteWidgetsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWidgetsMutation, DeleteWidgetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWidgetsMutation, DeleteWidgetsMutationVariables>(DeleteWidgetsDocument, options);
      }
export type DeleteWidgetsMutationHookResult = ReturnType<typeof useDeleteWidgetsMutation>;
export type DeleteWidgetsMutationResult = Apollo.MutationResult<DeleteWidgetsMutation>;
export type DeleteWidgetsMutationOptions = Apollo.BaseMutationOptions<DeleteWidgetsMutation, DeleteWidgetsMutationVariables>;
export const DeleteVideoTaskDocument = gql`
    mutation DeleteVideoTask($taskId: ID!) {
  deleteVideoTask(taskId: $taskId)
}
    `;
export type DeleteVideoTaskMutationFn = Apollo.MutationFunction<DeleteVideoTaskMutation, DeleteVideoTaskMutationVariables>;

/**
 * __useDeleteVideoTaskMutation__
 *
 * To run a mutation, you first call `useDeleteVideoTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVideoTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVideoTaskMutation, { data, loading, error }] = useDeleteVideoTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useDeleteVideoTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVideoTaskMutation, DeleteVideoTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVideoTaskMutation, DeleteVideoTaskMutationVariables>(DeleteVideoTaskDocument, options);
      }
export type DeleteVideoTaskMutationHookResult = ReturnType<typeof useDeleteVideoTaskMutation>;
export type DeleteVideoTaskMutationResult = Apollo.MutationResult<DeleteVideoTaskMutation>;
export type DeleteVideoTaskMutationOptions = Apollo.BaseMutationOptions<DeleteVideoTaskMutation, DeleteVideoTaskMutationVariables>;
export const SaveVideoTaskDocument = gql`
    mutation SaveVideoTask($input: TaskInput!) {
  saveTask(input: $input) {
    ...CameraTaskFragment
  }
}
    ${CameraTaskFragmentFragmentDoc}`;
export type SaveVideoTaskMutationFn = Apollo.MutationFunction<SaveVideoTaskMutation, SaveVideoTaskMutationVariables>;

/**
 * __useSaveVideoTaskMutation__
 *
 * To run a mutation, you first call `useSaveVideoTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveVideoTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveVideoTaskMutation, { data, loading, error }] = useSaveVideoTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveVideoTaskMutation(baseOptions?: Apollo.MutationHookOptions<SaveVideoTaskMutation, SaveVideoTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveVideoTaskMutation, SaveVideoTaskMutationVariables>(SaveVideoTaskDocument, options);
      }
export type SaveVideoTaskMutationHookResult = ReturnType<typeof useSaveVideoTaskMutation>;
export type SaveVideoTaskMutationResult = Apollo.MutationResult<SaveVideoTaskMutation>;
export type SaveVideoTaskMutationOptions = Apollo.BaseMutationOptions<SaveVideoTaskMutation, SaveVideoTaskMutationVariables>;
export const GenerateRecordingTokenUrlDocument = gql`
    mutation GenerateRecordingTokenURL($id: ID!) {
  generateRecordingTokenURL(id: $id)
}
    `;
export type GenerateRecordingTokenUrlMutationFn = Apollo.MutationFunction<GenerateRecordingTokenUrlMutation, GenerateRecordingTokenUrlMutationVariables>;

/**
 * __useGenerateRecordingTokenUrlMutation__
 *
 * To run a mutation, you first call `useGenerateRecordingTokenUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRecordingTokenUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRecordingTokenUrlMutation, { data, loading, error }] = useGenerateRecordingTokenUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateRecordingTokenUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateRecordingTokenUrlMutation, GenerateRecordingTokenUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRecordingTokenUrlMutation, GenerateRecordingTokenUrlMutationVariables>(GenerateRecordingTokenUrlDocument, options);
      }
export type GenerateRecordingTokenUrlMutationHookResult = ReturnType<typeof useGenerateRecordingTokenUrlMutation>;
export type GenerateRecordingTokenUrlMutationResult = Apollo.MutationResult<GenerateRecordingTokenUrlMutation>;
export type GenerateRecordingTokenUrlMutationOptions = Apollo.BaseMutationOptions<GenerateRecordingTokenUrlMutation, GenerateRecordingTokenUrlMutationVariables>;
export const BlockVideoStreamDocument = gql`
    mutation BlockVideoStream($input: BlockVideoStreamInput!) {
  blockVideoStream(input: $input) {
    ...VideoStreamBlock
  }
}
    ${VideoStreamBlockFragmentDoc}`;
export type BlockVideoStreamMutationFn = Apollo.MutationFunction<BlockVideoStreamMutation, BlockVideoStreamMutationVariables>;

/**
 * __useBlockVideoStreamMutation__
 *
 * To run a mutation, you first call `useBlockVideoStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockVideoStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockVideoStreamMutation, { data, loading, error }] = useBlockVideoStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBlockVideoStreamMutation(baseOptions?: Apollo.MutationHookOptions<BlockVideoStreamMutation, BlockVideoStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockVideoStreamMutation, BlockVideoStreamMutationVariables>(BlockVideoStreamDocument, options);
      }
export type BlockVideoStreamMutationHookResult = ReturnType<typeof useBlockVideoStreamMutation>;
export type BlockVideoStreamMutationResult = Apollo.MutationResult<BlockVideoStreamMutation>;
export type BlockVideoStreamMutationOptions = Apollo.BaseMutationOptions<BlockVideoStreamMutation, BlockVideoStreamMutationVariables>;
export const UnblockVideoStreamDocument = gql`
    mutation UnblockVideoStream($input: UnblockVideoStreamInput!) {
  unblockVideoStream(input: $input)
}
    `;
export type UnblockVideoStreamMutationFn = Apollo.MutationFunction<UnblockVideoStreamMutation, UnblockVideoStreamMutationVariables>;

/**
 * __useUnblockVideoStreamMutation__
 *
 * To run a mutation, you first call `useUnblockVideoStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockVideoStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockVideoStreamMutation, { data, loading, error }] = useUnblockVideoStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnblockVideoStreamMutation(baseOptions?: Apollo.MutationHookOptions<UnblockVideoStreamMutation, UnblockVideoStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockVideoStreamMutation, UnblockVideoStreamMutationVariables>(UnblockVideoStreamDocument, options);
      }
export type UnblockVideoStreamMutationHookResult = ReturnType<typeof useUnblockVideoStreamMutation>;
export type UnblockVideoStreamMutationResult = Apollo.MutationResult<UnblockVideoStreamMutation>;
export type UnblockVideoStreamMutationOptions = Apollo.BaseMutationOptions<UnblockVideoStreamMutation, UnblockVideoStreamMutationVariables>;
export const SetActiveHardwareScreenDocument = gql`
    mutation SetActiveHardwareScreen($id: String!) {
  setActiveHardwareScreen(id: $id)
}
    `;
export type SetActiveHardwareScreenMutationFn = Apollo.MutationFunction<SetActiveHardwareScreenMutation, SetActiveHardwareScreenMutationVariables>;

/**
 * __useSetActiveHardwareScreenMutation__
 *
 * To run a mutation, you first call `useSetActiveHardwareScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveHardwareScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveHardwareScreenMutation, { data, loading, error }] = useSetActiveHardwareScreenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetActiveHardwareScreenMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveHardwareScreenMutation, SetActiveHardwareScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveHardwareScreenMutation, SetActiveHardwareScreenMutationVariables>(SetActiveHardwareScreenDocument, options);
      }
export type SetActiveHardwareScreenMutationHookResult = ReturnType<typeof useSetActiveHardwareScreenMutation>;
export type SetActiveHardwareScreenMutationResult = Apollo.MutationResult<SetActiveHardwareScreenMutation>;
export type SetActiveHardwareScreenMutationOptions = Apollo.BaseMutationOptions<SetActiveHardwareScreenMutation, SetActiveHardwareScreenMutationVariables>;
export const UpdateCameraDetectionStatusDocument = gql`
    mutation UpdateCameraDetectionStatus($cameraId: ID!, $enable: Boolean!) {
  updateCameraDetectionStatus(cameraId: $cameraId, enable: $enable) {
    id
    isSupported
    enabled
  }
}
    `;
export type UpdateCameraDetectionStatusMutationFn = Apollo.MutationFunction<UpdateCameraDetectionStatusMutation, UpdateCameraDetectionStatusMutationVariables>;

/**
 * __useUpdateCameraDetectionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCameraDetectionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCameraDetectionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCameraDetectionStatusMutation, { data, loading, error }] = useUpdateCameraDetectionStatusMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useUpdateCameraDetectionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCameraDetectionStatusMutation, UpdateCameraDetectionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCameraDetectionStatusMutation, UpdateCameraDetectionStatusMutationVariables>(UpdateCameraDetectionStatusDocument, options);
      }
export type UpdateCameraDetectionStatusMutationHookResult = ReturnType<typeof useUpdateCameraDetectionStatusMutation>;
export type UpdateCameraDetectionStatusMutationResult = Apollo.MutationResult<UpdateCameraDetectionStatusMutation>;
export type UpdateCameraDetectionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCameraDetectionStatusMutation, UpdateCameraDetectionStatusMutationVariables>;
export const CameraGroupsDocument = gql`
    query CameraGroups($searchFields: [CameraGroupSearchField!] = [NAME, DESCRIPTION], $searchText: String, $sortOrder: SortOrder = DESCENDING, $sortField: CameraGroupSortField = ORDER) {
  cameraGroups(
    cameraGroupListFormat: {searchFields: $searchFields, searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField}
  ) {
    id
    name
    description
    order
    items {
      id
      name
      type
    }
    ...CameraSubGroupRecursive
  }
}
    ${CameraSubGroupRecursiveFragmentDoc}`;

/**
 * __useCameraGroupsQuery__
 *
 * To run a query within a React component, call `useCameraGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraGroupsQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useCameraGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CameraGroupsQuery, CameraGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraGroupsQuery, CameraGroupsQueryVariables>(CameraGroupsDocument, options);
      }
export function useCameraGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraGroupsQuery, CameraGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraGroupsQuery, CameraGroupsQueryVariables>(CameraGroupsDocument, options);
        }
export type CameraGroupsQueryHookResult = ReturnType<typeof useCameraGroupsQuery>;
export type CameraGroupsLazyQueryHookResult = ReturnType<typeof useCameraGroupsLazyQuery>;
export type CameraGroupsQueryResult = Apollo.QueryResult<CameraGroupsQuery, CameraGroupsQueryVariables>;
export function refetchCameraGroupsQuery(variables?: CameraGroupsQueryVariables) {
      return { query: CameraGroupsDocument, variables: variables }
    }
export const CamerasListDocument = gql`
    query CamerasList($after: String, $before: String, $limit: Int = 100, $sortField: String, $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput!]) {
  cameras(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
    filters: $filters
  ) {
    edges {
      node {
        ...CameraListNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CameraListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCamerasListQuery__
 *
 * To run a query within a React component, call `useCamerasListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCamerasListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCamerasListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCamerasListQuery(baseOptions?: Apollo.QueryHookOptions<CamerasListQuery, CamerasListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CamerasListQuery, CamerasListQueryVariables>(CamerasListDocument, options);
      }
export function useCamerasListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CamerasListQuery, CamerasListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CamerasListQuery, CamerasListQueryVariables>(CamerasListDocument, options);
        }
export type CamerasListQueryHookResult = ReturnType<typeof useCamerasListQuery>;
export type CamerasListLazyQueryHookResult = ReturnType<typeof useCamerasListLazyQuery>;
export type CamerasListQueryResult = Apollo.QueryResult<CamerasListQuery, CamerasListQueryVariables>;
export function refetchCamerasListQuery(variables?: CamerasListQueryVariables) {
      return { query: CamerasListDocument, variables: variables }
    }
export const CameraDocument = gql`
    query Camera($id: ID!) {
  camera(id: $id) {
    communicationParameters
    id
    name
    communicationStatus
    poweredOn
    road
    direction
    description
    location
    locationDescription
    autoFocusEnabled
    autoIrisEnabled
    userNotes
    referencePoint
    publicFeedEnabled
    privateStreamRecordingInProgress
    cameraCategory
    presets {
      id
      name
      presetIndex
      isHomePreset
      isSystem
      isSelected
    }
    ptzLock {
      isLocked
      requireExplicitCameraControlLocking
      userId
      fullName
      lockStartedAt
      lockEndsAt
      lastUsedTime
    }
    streams {
      name
      url
      accessType
      application
      streamName
      streamType
      streamManager
      recordingServer
    }
    tours {
      id
      name
    }
    capabilities {
      capability
      options
    }
    capabilitiesState
    liveRecordings {
      id
      recordingName
      recordingType
    }
  }
}
    `;

/**
 * __useCameraQuery__
 *
 * To run a query within a React component, call `useCameraQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCameraQuery(baseOptions: Apollo.QueryHookOptions<CameraQuery, CameraQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraQuery, CameraQueryVariables>(CameraDocument, options);
      }
export function useCameraLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraQuery, CameraQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraQuery, CameraQueryVariables>(CameraDocument, options);
        }
export type CameraQueryHookResult = ReturnType<typeof useCameraQuery>;
export type CameraLazyQueryHookResult = ReturnType<typeof useCameraLazyQuery>;
export type CameraQueryResult = Apollo.QueryResult<CameraQuery, CameraQueryVariables>;
export function refetchCameraQuery(variables: CameraQueryVariables) {
      return { query: CameraDocument, variables: variables }
    }
export const CameraMapEntityShortDocument = gql`
    query CameraMapEntityShort($searchText: String) {
  cameraMapEntities(searchText: $searchText)
}
    `;

/**
 * __useCameraMapEntityShortQuery__
 *
 * To run a query within a React component, call `useCameraMapEntityShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraMapEntityShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraMapEntityShortQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useCameraMapEntityShortQuery(baseOptions?: Apollo.QueryHookOptions<CameraMapEntityShortQuery, CameraMapEntityShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraMapEntityShortQuery, CameraMapEntityShortQueryVariables>(CameraMapEntityShortDocument, options);
      }
export function useCameraMapEntityShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraMapEntityShortQuery, CameraMapEntityShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraMapEntityShortQuery, CameraMapEntityShortQueryVariables>(CameraMapEntityShortDocument, options);
        }
export type CameraMapEntityShortQueryHookResult = ReturnType<typeof useCameraMapEntityShortQuery>;
export type CameraMapEntityShortLazyQueryHookResult = ReturnType<typeof useCameraMapEntityShortLazyQuery>;
export type CameraMapEntityShortQueryResult = Apollo.QueryResult<CameraMapEntityShortQuery, CameraMapEntityShortQueryVariables>;
export function refetchCameraMapEntityShortQuery(variables?: CameraMapEntityShortQueryVariables) {
      return { query: CameraMapEntityShortDocument, variables: variables }
    }
export const ToursDocument = gql`
    query Tours($after: String, $before: String, $limit: Int = 100, $sortField: String, $sortOrder: SortOrder = ASCENDING, $searchText: String) {
  tours(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText}
  ) {
    edges {
      node {
        ...TourListNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${TourListNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useToursQuery__
 *
 * To run a query within a React component, call `useToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToursQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useToursQuery(baseOptions?: Apollo.QueryHookOptions<ToursQuery, ToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ToursQuery, ToursQueryVariables>(ToursDocument, options);
      }
export function useToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToursQuery, ToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ToursQuery, ToursQueryVariables>(ToursDocument, options);
        }
export type ToursQueryHookResult = ReturnType<typeof useToursQuery>;
export type ToursLazyQueryHookResult = ReturnType<typeof useToursLazyQuery>;
export type ToursQueryResult = Apollo.QueryResult<ToursQuery, ToursQueryVariables>;
export function refetchToursQuery(variables?: ToursQueryVariables) {
      return { query: ToursDocument, variables: variables }
    }
export const ToursShortListDocument = gql`
    query ToursShortList($after: String, $before: String, $limit: Int = 100, $sortField: String, $sortOrder: SortOrder = ASCENDING, $searchText: String) {
  tours(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText}
  ) {
    edges {
      node {
        ...ToursFields
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${ToursFieldsFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useToursShortListQuery__
 *
 * To run a query within a React component, call `useToursShortListQuery` and pass it any options that fit your needs.
 * When your component renders, `useToursShortListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToursShortListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useToursShortListQuery(baseOptions?: Apollo.QueryHookOptions<ToursShortListQuery, ToursShortListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ToursShortListQuery, ToursShortListQueryVariables>(ToursShortListDocument, options);
      }
export function useToursShortListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToursShortListQuery, ToursShortListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ToursShortListQuery, ToursShortListQueryVariables>(ToursShortListDocument, options);
        }
export type ToursShortListQueryHookResult = ReturnType<typeof useToursShortListQuery>;
export type ToursShortListLazyQueryHookResult = ReturnType<typeof useToursShortListLazyQuery>;
export type ToursShortListQueryResult = Apollo.QueryResult<ToursShortListQuery, ToursShortListQueryVariables>;
export function refetchToursShortListQuery(variables?: ToursShortListQueryVariables) {
      return { query: ToursShortListDocument, variables: variables }
    }
export const ScreensDocument = gql`
    query Screens($searchFields: [ScreenSearchField!] = [NAME, DESCRIPTION], $searchText: String) {
  screens(
    screenListFormat: {searchFields: $searchFields, searchText: $searchText}
  ) {
    ...Screen
  }
}
    ${ScreenFragmentDoc}`;

/**
 * __useScreensQuery__
 *
 * To run a query within a React component, call `useScreensQuery` and pass it any options that fit your needs.
 * When your component renders, `useScreensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScreensQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useScreensQuery(baseOptions?: Apollo.QueryHookOptions<ScreensQuery, ScreensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScreensQuery, ScreensQueryVariables>(ScreensDocument, options);
      }
export function useScreensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScreensQuery, ScreensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScreensQuery, ScreensQueryVariables>(ScreensDocument, options);
        }
export type ScreensQueryHookResult = ReturnType<typeof useScreensQuery>;
export type ScreensLazyQueryHookResult = ReturnType<typeof useScreensLazyQuery>;
export type ScreensQueryResult = Apollo.QueryResult<ScreensQuery, ScreensQueryVariables>;
export function refetchScreensQuery(variables?: ScreensQueryVariables) {
      return { query: ScreensDocument, variables: variables }
    }
export const ScreensShortListDocument = gql`
    query ScreensShortList($searchFields: [ScreenSearchField!] = [NAME, DESCRIPTION], $searchText: String) {
  screens(
    screenListFormat: {searchFields: $searchFields, searchText: $searchText}
  ) {
    id
    name
    description
    orderNum
    type
    videoWallId
    videoWallDetail {
      name
      protocol
    }
  }
}
    `;

/**
 * __useScreensShortListQuery__
 *
 * To run a query within a React component, call `useScreensShortListQuery` and pass it any options that fit your needs.
 * When your component renders, `useScreensShortListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScreensShortListQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useScreensShortListQuery(baseOptions?: Apollo.QueryHookOptions<ScreensShortListQuery, ScreensShortListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScreensShortListQuery, ScreensShortListQueryVariables>(ScreensShortListDocument, options);
      }
export function useScreensShortListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScreensShortListQuery, ScreensShortListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScreensShortListQuery, ScreensShortListQueryVariables>(ScreensShortListDocument, options);
        }
export type ScreensShortListQueryHookResult = ReturnType<typeof useScreensShortListQuery>;
export type ScreensShortListLazyQueryHookResult = ReturnType<typeof useScreensShortListLazyQuery>;
export type ScreensShortListQueryResult = Apollo.QueryResult<ScreensShortListQuery, ScreensShortListQueryVariables>;
export function refetchScreensShortListQuery(variables?: ScreensShortListQueryVariables) {
      return { query: ScreensShortListDocument, variables: variables }
    }
export const ScreenUpdatedDocument = gql`
    subscription ScreenUpdated($ids: [ID!]) {
  screenUpdated(ids: $ids) {
    ...Screen
  }
}
    ${ScreenFragmentDoc}`;

/**
 * __useScreenUpdatedSubscription__
 *
 * To run a query within a React component, call `useScreenUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useScreenUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScreenUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useScreenUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ScreenUpdatedSubscription, ScreenUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ScreenUpdatedSubscription, ScreenUpdatedSubscriptionVariables>(ScreenUpdatedDocument, options);
      }
export type ScreenUpdatedSubscriptionHookResult = ReturnType<typeof useScreenUpdatedSubscription>;
export type ScreenUpdatedSubscriptionResult = Apollo.SubscriptionResult<ScreenUpdatedSubscription>;
export const VideoWallUpdatedDocument = gql`
    subscription VideoWallUpdated {
  videoWallUpdated {
    videoWallObjectType
    streamObjectOperation
    id
  }
}
    `;

/**
 * __useVideoWallUpdatedSubscription__
 *
 * To run a query within a React component, call `useVideoWallUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVideoWallUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoWallUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useVideoWallUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<VideoWallUpdatedSubscription, VideoWallUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<VideoWallUpdatedSubscription, VideoWallUpdatedSubscriptionVariables>(VideoWallUpdatedDocument, options);
      }
export type VideoWallUpdatedSubscriptionHookResult = ReturnType<typeof useVideoWallUpdatedSubscription>;
export type VideoWallUpdatedSubscriptionResult = Apollo.SubscriptionResult<VideoWallUpdatedSubscription>;
export const ScenesDocument = gql`
    query Scenes($searchFields: [SceneSearchField!] = [NAME], $searchText: String, $sortOrder: SortOrder = ASCENDING, $sortField: SceneSortField = NAME) {
  scenes(
    sceneListFormat: {searchFields: $searchFields, searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField}
  ) {
    ...Scene
  }
}
    ${SceneFragmentDoc}`;

/**
 * __useScenesQuery__
 *
 * To run a query within a React component, call `useScenesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenesQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useScenesQuery(baseOptions?: Apollo.QueryHookOptions<ScenesQuery, ScenesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenesQuery, ScenesQueryVariables>(ScenesDocument, options);
      }
export function useScenesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenesQuery, ScenesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenesQuery, ScenesQueryVariables>(ScenesDocument, options);
        }
export type ScenesQueryHookResult = ReturnType<typeof useScenesQuery>;
export type ScenesLazyQueryHookResult = ReturnType<typeof useScenesLazyQuery>;
export type ScenesQueryResult = Apollo.QueryResult<ScenesQuery, ScenesQueryVariables>;
export function refetchScenesQuery(variables?: ScenesQueryVariables) {
      return { query: ScenesDocument, variables: variables }
    }
export const WatchTourSubscriptionDocument = gql`
    subscription WatchTourSubscription($tourId: ID!) {
  watchTour(tourId: $tourId) {
    camera {
      ...CameraNodeFragment
    }
    nextCamera {
      ...CameraNodeFragment
    }
    isPaused
  }
}
    ${CameraNodeFragmentFragmentDoc}`;

/**
 * __useWatchTourSubscriptionSubscription__
 *
 * To run a query within a React component, call `useWatchTourSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchTourSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchTourSubscriptionSubscription({
 *   variables: {
 *      tourId: // value for 'tourId'
 *   },
 * });
 */
export function useWatchTourSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchTourSubscriptionSubscription, WatchTourSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchTourSubscriptionSubscription, WatchTourSubscriptionSubscriptionVariables>(WatchTourSubscriptionDocument, options);
      }
export type WatchTourSubscriptionSubscriptionHookResult = ReturnType<typeof useWatchTourSubscriptionSubscription>;
export type WatchTourSubscriptionSubscriptionResult = Apollo.SubscriptionResult<WatchTourSubscriptionSubscription>;
export const UngroupedCamerasToursDocument = gql`
    query UngroupedCamerasTours($searchFields: [CameraGroupSearchField!] = [NAME], $searchText: String, $sortOrder: SortOrder = ASCENDING, $sortField: CameraGroupSortField = NAME) {
  ungroupedCamerasTours(
    cameraGroupListFormat: {searchFields: $searchFields, searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField}
  ) {
    items {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useUngroupedCamerasToursQuery__
 *
 * To run a query within a React component, call `useUngroupedCamerasToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useUngroupedCamerasToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUngroupedCamerasToursQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useUngroupedCamerasToursQuery(baseOptions?: Apollo.QueryHookOptions<UngroupedCamerasToursQuery, UngroupedCamerasToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UngroupedCamerasToursQuery, UngroupedCamerasToursQueryVariables>(UngroupedCamerasToursDocument, options);
      }
export function useUngroupedCamerasToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UngroupedCamerasToursQuery, UngroupedCamerasToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UngroupedCamerasToursQuery, UngroupedCamerasToursQueryVariables>(UngroupedCamerasToursDocument, options);
        }
export type UngroupedCamerasToursQueryHookResult = ReturnType<typeof useUngroupedCamerasToursQuery>;
export type UngroupedCamerasToursLazyQueryHookResult = ReturnType<typeof useUngroupedCamerasToursLazyQuery>;
export type UngroupedCamerasToursQueryResult = Apollo.QueryResult<UngroupedCamerasToursQuery, UngroupedCamerasToursQueryVariables>;
export function refetchUngroupedCamerasToursQuery(variables?: UngroupedCamerasToursQueryVariables) {
      return { query: UngroupedCamerasToursDocument, variables: variables }
    }
export const TourDocument = gql`
    query Tour($id: ID!) {
  tour(id: $id) {
    ...TourListNodeFragment
  }
}
    ${TourListNodeFragmentFragmentDoc}`;

/**
 * __useTourQuery__
 *
 * To run a query within a React component, call `useTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTourQuery(baseOptions: Apollo.QueryHookOptions<TourQuery, TourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TourQuery, TourQueryVariables>(TourDocument, options);
      }
export function useTourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TourQuery, TourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TourQuery, TourQueryVariables>(TourDocument, options);
        }
export type TourQueryHookResult = ReturnType<typeof useTourQuery>;
export type TourLazyQueryHookResult = ReturnType<typeof useTourLazyQuery>;
export type TourQueryResult = Apollo.QueryResult<TourQuery, TourQueryVariables>;
export function refetchTourQuery(variables: TourQueryVariables) {
      return { query: TourDocument, variables: variables }
    }
export const WidgetsDocument = gql`
    query Widgets($searchFields: [WidgetSearchField!] = [NAME], $searchText: String, $sortOrder: SortOrder = ASCENDING, $sortField: WidgetSortField = NAME) {
  widgets(
    widgetListFormat: {searchFields: $searchFields, searchText: $searchText, sortOrder: $sortOrder, sortField: $sortField}
  ) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;

/**
 * __useWidgetsQuery__
 *
 * To run a query within a React component, call `useWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetsQuery({
 *   variables: {
 *      searchFields: // value for 'searchFields'
 *      searchText: // value for 'searchText'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useWidgetsQuery(baseOptions?: Apollo.QueryHookOptions<WidgetsQuery, WidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetsQuery, WidgetsQueryVariables>(WidgetsDocument, options);
      }
export function useWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetsQuery, WidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetsQuery, WidgetsQueryVariables>(WidgetsDocument, options);
        }
export type WidgetsQueryHookResult = ReturnType<typeof useWidgetsQuery>;
export type WidgetsLazyQueryHookResult = ReturnType<typeof useWidgetsLazyQuery>;
export type WidgetsQueryResult = Apollo.QueryResult<WidgetsQuery, WidgetsQueryVariables>;
export function refetchWidgetsQuery(variables?: WidgetsQueryVariables) {
      return { query: WidgetsDocument, variables: variables }
    }
export const WidgetDocument = gql`
    query Widget($id: ID!) {
  widget(id: $id) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;

/**
 * __useWidgetQuery__
 *
 * To run a query within a React component, call `useWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetQuery(baseOptions: Apollo.QueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
      }
export function useWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
        }
export type WidgetQueryHookResult = ReturnType<typeof useWidgetQuery>;
export type WidgetLazyQueryHookResult = ReturnType<typeof useWidgetLazyQuery>;
export type WidgetQueryResult = Apollo.QueryResult<WidgetQuery, WidgetQueryVariables>;
export function refetchWidgetQuery(variables: WidgetQueryVariables) {
      return { query: WidgetDocument, variables: variables }
    }
export const WidgetUpdatedSubscriptionDocument = gql`
    subscription WidgetUpdatedSubscription($ids: [ID!]) {
  widgetUpdated(ids: $ids) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;

/**
 * __useWidgetUpdatedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useWidgetUpdatedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWidgetUpdatedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetUpdatedSubscriptionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useWidgetUpdatedSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WidgetUpdatedSubscriptionSubscription, WidgetUpdatedSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WidgetUpdatedSubscriptionSubscription, WidgetUpdatedSubscriptionSubscriptionVariables>(WidgetUpdatedSubscriptionDocument, options);
      }
export type WidgetUpdatedSubscriptionSubscriptionHookResult = ReturnType<typeof useWidgetUpdatedSubscriptionSubscription>;
export type WidgetUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<WidgetUpdatedSubscriptionSubscription>;
export const ScreenUpdatedSubscriptionDocument = gql`
    subscription ScreenUpdatedSubscription($ids: [ID!]) {
  screenUpdated(ids: $ids) {
    ...Screen
  }
}
    ${ScreenFragmentDoc}`;

/**
 * __useScreenUpdatedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useScreenUpdatedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useScreenUpdatedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScreenUpdatedSubscriptionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useScreenUpdatedSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ScreenUpdatedSubscriptionSubscription, ScreenUpdatedSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ScreenUpdatedSubscriptionSubscription, ScreenUpdatedSubscriptionSubscriptionVariables>(ScreenUpdatedSubscriptionDocument, options);
      }
export type ScreenUpdatedSubscriptionSubscriptionHookResult = ReturnType<typeof useScreenUpdatedSubscriptionSubscription>;
export type ScreenUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<ScreenUpdatedSubscriptionSubscription>;
export const SceneUpdatedSubscriptionDocument = gql`
    subscription SceneUpdatedSubscription($ids: [ID!]) {
  sceneUpdated(ids: $ids) {
    ...Scene
  }
}
    ${SceneFragmentDoc}`;

/**
 * __useSceneUpdatedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useSceneUpdatedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSceneUpdatedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSceneUpdatedSubscriptionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSceneUpdatedSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SceneUpdatedSubscriptionSubscription, SceneUpdatedSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SceneUpdatedSubscriptionSubscription, SceneUpdatedSubscriptionSubscriptionVariables>(SceneUpdatedSubscriptionDocument, options);
      }
export type SceneUpdatedSubscriptionSubscriptionHookResult = ReturnType<typeof useSceneUpdatedSubscriptionSubscription>;
export type SceneUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<SceneUpdatedSubscriptionSubscription>;
export const CameraUpdatedSubscriptionDocument = gql`
    subscription CameraUpdatedSubscription($ids: [ID!]) {
  cameraUpdated(ids: $ids) {
    ...CameraListNodeFragment
  }
}
    ${CameraListNodeFragmentFragmentDoc}`;

/**
 * __useCameraUpdatedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useCameraUpdatedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCameraUpdatedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraUpdatedSubscriptionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCameraUpdatedSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CameraUpdatedSubscriptionSubscription, CameraUpdatedSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CameraUpdatedSubscriptionSubscription, CameraUpdatedSubscriptionSubscriptionVariables>(CameraUpdatedSubscriptionDocument, options);
      }
export type CameraUpdatedSubscriptionSubscriptionHookResult = ReturnType<typeof useCameraUpdatedSubscriptionSubscription>;
export type CameraUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<CameraUpdatedSubscriptionSubscription>;
export const TourUpdatedSubscriptionDocument = gql`
    subscription TourUpdatedSubscription($ids: [ID!]) {
  tourUpdated(ids: $ids) {
    ...TourListNodeFragment
  }
}
    ${TourListNodeFragmentFragmentDoc}`;

/**
 * __useTourUpdatedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useTourUpdatedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTourUpdatedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourUpdatedSubscriptionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTourUpdatedSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TourUpdatedSubscriptionSubscription, TourUpdatedSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TourUpdatedSubscriptionSubscription, TourUpdatedSubscriptionSubscriptionVariables>(TourUpdatedSubscriptionDocument, options);
      }
export type TourUpdatedSubscriptionSubscriptionHookResult = ReturnType<typeof useTourUpdatedSubscriptionSubscription>;
export type TourUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<TourUpdatedSubscriptionSubscription>;
export const CameraGroupUpdatedSubscriptionDocument = gql`
    subscription CameraGroupUpdatedSubscription($ids: [ID!]) {
  cameraGroupUpdated(ids: $ids) {
    id
    name
    description
    items {
      id
      name
      type
    }
    ...CameraSubGroupRecursive
  }
}
    ${CameraSubGroupRecursiveFragmentDoc}`;

/**
 * __useCameraGroupUpdatedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useCameraGroupUpdatedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCameraGroupUpdatedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraGroupUpdatedSubscriptionSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCameraGroupUpdatedSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CameraGroupUpdatedSubscriptionSubscription, CameraGroupUpdatedSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CameraGroupUpdatedSubscriptionSubscription, CameraGroupUpdatedSubscriptionSubscriptionVariables>(CameraGroupUpdatedSubscriptionDocument, options);
      }
export type CameraGroupUpdatedSubscriptionSubscriptionHookResult = ReturnType<typeof useCameraGroupUpdatedSubscriptionSubscription>;
export type CameraGroupUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<CameraGroupUpdatedSubscriptionSubscription>;
export const VideoModuleSettingsDocument = gql`
    query videoModuleSettings {
  videoModuleSettings {
    ...VideoForm
  }
}
    ${VideoFormFragmentDoc}`;

/**
 * __useVideoModuleSettingsQuery__
 *
 * To run a query within a React component, call `useVideoModuleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoModuleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoModuleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVideoModuleSettingsQuery(baseOptions?: Apollo.QueryHookOptions<VideoModuleSettingsQuery, VideoModuleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoModuleSettingsQuery, VideoModuleSettingsQueryVariables>(VideoModuleSettingsDocument, options);
      }
export function useVideoModuleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoModuleSettingsQuery, VideoModuleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoModuleSettingsQuery, VideoModuleSettingsQueryVariables>(VideoModuleSettingsDocument, options);
        }
export type VideoModuleSettingsQueryHookResult = ReturnType<typeof useVideoModuleSettingsQuery>;
export type VideoModuleSettingsLazyQueryHookResult = ReturnType<typeof useVideoModuleSettingsLazyQuery>;
export type VideoModuleSettingsQueryResult = Apollo.QueryResult<VideoModuleSettingsQuery, VideoModuleSettingsQueryVariables>;
export function refetchVideoModuleSettingsQuery(variables?: VideoModuleSettingsQueryVariables) {
      return { query: VideoModuleSettingsDocument, variables: variables }
    }
export const VideoRecordingsDocument = gql`
    query VideoRecordings($after: String, $before: String, $limit: Int = 10000, $sortField: String, $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput]) {
  videoRecordings(
    recordingsQueryInput: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText, filters: $filters}
  ) {
    edges {
      node {
        ...VideoRecordNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${VideoRecordNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useVideoRecordingsQuery__
 *
 * To run a query within a React component, call `useVideoRecordingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoRecordingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoRecordingsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useVideoRecordingsQuery(baseOptions?: Apollo.QueryHookOptions<VideoRecordingsQuery, VideoRecordingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoRecordingsQuery, VideoRecordingsQueryVariables>(VideoRecordingsDocument, options);
      }
export function useVideoRecordingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoRecordingsQuery, VideoRecordingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoRecordingsQuery, VideoRecordingsQueryVariables>(VideoRecordingsDocument, options);
        }
export type VideoRecordingsQueryHookResult = ReturnType<typeof useVideoRecordingsQuery>;
export type VideoRecordingsLazyQueryHookResult = ReturnType<typeof useVideoRecordingsLazyQuery>;
export type VideoRecordingsQueryResult = Apollo.QueryResult<VideoRecordingsQuery, VideoRecordingsQueryVariables>;
export function refetchVideoRecordingsQuery(variables?: VideoRecordingsQueryVariables) {
      return { query: VideoRecordingsDocument, variables: variables }
    }
export const VideoRecordersDocument = gql`
    query VideoRecorders($sortOrder: SortOrder = ASCENDING, $sortField: String, $searchText: String, $limit: Int = 1000000) {
  integrations(
    integrationType: NETWORK_VIDEO_RECORDER
    searchText: $searchText
    sortOrder: $sortOrder
    sortField: $sortField
    limit: $limit
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useVideoRecordersQuery__
 *
 * To run a query within a React component, call `useVideoRecordersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoRecordersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoRecordersQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useVideoRecordersQuery(baseOptions?: Apollo.QueryHookOptions<VideoRecordersQuery, VideoRecordersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoRecordersQuery, VideoRecordersQueryVariables>(VideoRecordersDocument, options);
      }
export function useVideoRecordersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoRecordersQuery, VideoRecordersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoRecordersQuery, VideoRecordersQueryVariables>(VideoRecordersDocument, options);
        }
export type VideoRecordersQueryHookResult = ReturnType<typeof useVideoRecordersQuery>;
export type VideoRecordersLazyQueryHookResult = ReturnType<typeof useVideoRecordersLazyQuery>;
export type VideoRecordersQueryResult = Apollo.QueryResult<VideoRecordersQuery, VideoRecordersQueryVariables>;
export function refetchVideoRecordersQuery(variables?: VideoRecordersQueryVariables) {
      return { query: VideoRecordersDocument, variables: variables }
    }
export const VideoSummaryDocument = gql`
    query VideoSummary {
  operational: cameras(
    filters: [{operator: IN, field: "state.currentState.communicationState", value: [OPERATIONAL]}]
  ) {
    totalCount
  }
  nonoperational: cameras(
    filters: [{operator: IN, field: "state.currentState.communicationState", value: [OPERATIONAL_WITH_ERROR, FAILED, NO_DATA, SUSPECT, DISABLED]}]
  ) {
    totalCount
  }
}
    `;

/**
 * __useVideoSummaryQuery__
 *
 * To run a query within a React component, call `useVideoSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useVideoSummaryQuery(baseOptions?: Apollo.QueryHookOptions<VideoSummaryQuery, VideoSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoSummaryQuery, VideoSummaryQueryVariables>(VideoSummaryDocument, options);
      }
export function useVideoSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoSummaryQuery, VideoSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoSummaryQuery, VideoSummaryQueryVariables>(VideoSummaryDocument, options);
        }
export type VideoSummaryQueryHookResult = ReturnType<typeof useVideoSummaryQuery>;
export type VideoSummaryLazyQueryHookResult = ReturnType<typeof useVideoSummaryLazyQuery>;
export type VideoSummaryQueryResult = Apollo.QueryResult<VideoSummaryQuery, VideoSummaryQueryVariables>;
export function refetchVideoSummaryQuery(variables?: VideoSummaryQueryVariables) {
      return { query: VideoSummaryDocument, variables: variables }
    }
export const SnapshotsListDocument = gql`
    query SnapshotsList($after: String, $before: String, $limit: Int = 100, $sortField: String = "timestamp", $sortOrder: SortOrder = ASCENDING, $filters: [FilterInput]) {
  snapshots(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, filters: $filters}
  ) {
    edges {
      node {
        ...SnapshotNodeFragment
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${SnapshotNodeFragmentFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSnapshotsListQuery__
 *
 * To run a query within a React component, call `useSnapshotsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotsListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSnapshotsListQuery(baseOptions?: Apollo.QueryHookOptions<SnapshotsListQuery, SnapshotsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnapshotsListQuery, SnapshotsListQueryVariables>(SnapshotsListDocument, options);
      }
export function useSnapshotsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnapshotsListQuery, SnapshotsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnapshotsListQuery, SnapshotsListQueryVariables>(SnapshotsListDocument, options);
        }
export type SnapshotsListQueryHookResult = ReturnType<typeof useSnapshotsListQuery>;
export type SnapshotsListLazyQueryHookResult = ReturnType<typeof useSnapshotsListLazyQuery>;
export type SnapshotsListQueryResult = Apollo.QueryResult<SnapshotsListQuery, SnapshotsListQueryVariables>;
export function refetchSnapshotsListQuery(variables?: SnapshotsListQueryVariables) {
      return { query: SnapshotsListDocument, variables: variables }
    }
export const SnapshostUpdatedDocument = gql`
    subscription SnapshostUpdated($ids: [ID!]) {
  snapshotsUpdated(ids: $ids) {
    streamObjectOperation
    dto {
      ...SnapshotNodeFragment
    }
  }
}
    ${SnapshotNodeFragmentFragmentDoc}`;

/**
 * __useSnapshostUpdatedSubscription__
 *
 * To run a query within a React component, call `useSnapshostUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSnapshostUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshostUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSnapshostUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SnapshostUpdatedSubscription, SnapshostUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SnapshostUpdatedSubscription, SnapshostUpdatedSubscriptionVariables>(SnapshostUpdatedDocument, options);
      }
export type SnapshostUpdatedSubscriptionHookResult = ReturnType<typeof useSnapshostUpdatedSubscription>;
export type SnapshostUpdatedSubscriptionResult = Apollo.SubscriptionResult<SnapshostUpdatedSubscription>;
export const ActivityLogNamesDocument = gql`
    query ActivityLogNames($limit: Int = 1000000, $filters: [FilterInput!]!, $searchText: String) {
  activityLogNames(limit: $limit, filters: $filters, searchText: $searchText) {
    edges {
      node {
        id
        name
        integrationType
      }
    }
  }
}
    `;

/**
 * __useActivityLogNamesQuery__
 *
 * To run a query within a React component, call `useActivityLogNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogNamesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useActivityLogNamesQuery(baseOptions: Apollo.QueryHookOptions<ActivityLogNamesQuery, ActivityLogNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogNamesQuery, ActivityLogNamesQueryVariables>(ActivityLogNamesDocument, options);
      }
export function useActivityLogNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogNamesQuery, ActivityLogNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogNamesQuery, ActivityLogNamesQueryVariables>(ActivityLogNamesDocument, options);
        }
export type ActivityLogNamesQueryHookResult = ReturnType<typeof useActivityLogNamesQuery>;
export type ActivityLogNamesLazyQueryHookResult = ReturnType<typeof useActivityLogNamesLazyQuery>;
export type ActivityLogNamesQueryResult = Apollo.QueryResult<ActivityLogNamesQuery, ActivityLogNamesQueryVariables>;
export function refetchActivityLogNamesQuery(variables: ActivityLogNamesQueryVariables) {
      return { query: ActivityLogNamesDocument, variables: variables }
    }
export const LayoutsDocument = gql`
    query Layouts($videoWallId: ID) {
  layouts(videoWallId: $videoWallId) {
    id
    name
    description
    areas {
      columns
      rows
      areaId
      disabled
    }
  }
}
    `;

/**
 * __useLayoutsQuery__
 *
 * To run a query within a React component, call `useLayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutsQuery({
 *   variables: {
 *      videoWallId: // value for 'videoWallId'
 *   },
 * });
 */
export function useLayoutsQuery(baseOptions?: Apollo.QueryHookOptions<LayoutsQuery, LayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutsQuery, LayoutsQueryVariables>(LayoutsDocument, options);
      }
export function useLayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayoutsQuery, LayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutsQuery, LayoutsQueryVariables>(LayoutsDocument, options);
        }
export type LayoutsQueryHookResult = ReturnType<typeof useLayoutsQuery>;
export type LayoutsLazyQueryHookResult = ReturnType<typeof useLayoutsLazyQuery>;
export type LayoutsQueryResult = Apollo.QueryResult<LayoutsQuery, LayoutsQueryVariables>;
export function refetchLayoutsQuery(variables?: LayoutsQueryVariables) {
      return { query: LayoutsDocument, variables: variables }
    }
export const GetPresetDocument = gql`
    query GetPreset($id: ID!) {
  preset(id: $id) {
    id
    presetIndex
    name
    isSystem
  }
}
    `;

/**
 * __useGetPresetQuery__
 *
 * To run a query within a React component, call `useGetPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPresetQuery(baseOptions: Apollo.QueryHookOptions<GetPresetQuery, GetPresetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPresetQuery, GetPresetQueryVariables>(GetPresetDocument, options);
      }
export function useGetPresetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPresetQuery, GetPresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPresetQuery, GetPresetQueryVariables>(GetPresetDocument, options);
        }
export type GetPresetQueryHookResult = ReturnType<typeof useGetPresetQuery>;
export type GetPresetLazyQueryHookResult = ReturnType<typeof useGetPresetLazyQuery>;
export type GetPresetQueryResult = Apollo.QueryResult<GetPresetQuery, GetPresetQueryVariables>;
export function refetchGetPresetQuery(variables: GetPresetQueryVariables) {
      return { query: GetPresetDocument, variables: variables }
    }
export const CameraFutureTasksDocument = gql`
    query CameraFutureTasks($cameraId: String!, $timezone: String!) {
  cameraFutureTasks(cameraId: $cameraId, timezone: $timezone) {
    id
    name
    start
    end
    data
    rrule
    taskRecurrenceType
    taskType
  }
}
    `;

/**
 * __useCameraFutureTasksQuery__
 *
 * To run a query within a React component, call `useCameraFutureTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraFutureTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraFutureTasksQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useCameraFutureTasksQuery(baseOptions: Apollo.QueryHookOptions<CameraFutureTasksQuery, CameraFutureTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraFutureTasksQuery, CameraFutureTasksQueryVariables>(CameraFutureTasksDocument, options);
      }
export function useCameraFutureTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraFutureTasksQuery, CameraFutureTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraFutureTasksQuery, CameraFutureTasksQueryVariables>(CameraFutureTasksDocument, options);
        }
export type CameraFutureTasksQueryHookResult = ReturnType<typeof useCameraFutureTasksQuery>;
export type CameraFutureTasksLazyQueryHookResult = ReturnType<typeof useCameraFutureTasksLazyQuery>;
export type CameraFutureTasksQueryResult = Apollo.QueryResult<CameraFutureTasksQuery, CameraFutureTasksQueryVariables>;
export function refetchCameraFutureTasksQuery(variables: CameraFutureTasksQueryVariables) {
      return { query: CameraFutureTasksDocument, variables: variables }
    }
export const CameraActivityLogAddedDocument = gql`
    subscription CameraActivityLogAdded($ids: [ID!], $module: KineticModule = VIDEO) {
  addedActivityLog(ids: $ids, module: $module) {
    ...ActivityLogNodeFragment
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}`;

/**
 * __useCameraActivityLogAddedSubscription__
 *
 * To run a query within a React component, call `useCameraActivityLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCameraActivityLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraActivityLogAddedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useCameraActivityLogAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CameraActivityLogAddedSubscription, CameraActivityLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CameraActivityLogAddedSubscription, CameraActivityLogAddedSubscriptionVariables>(CameraActivityLogAddedDocument, options);
      }
export type CameraActivityLogAddedSubscriptionHookResult = ReturnType<typeof useCameraActivityLogAddedSubscription>;
export type CameraActivityLogAddedSubscriptionResult = Apollo.SubscriptionResult<CameraActivityLogAddedSubscription>;
export const GetTourDocument = gql`
    query getTour($id: ID!) {
  tour(id: $id) {
    ...TourListNodeFragment
  }
}
    ${TourListNodeFragmentFragmentDoc}`;

/**
 * __useGetTourQuery__
 *
 * To run a query within a React component, call `useGetTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTourQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTourQuery(baseOptions: Apollo.QueryHookOptions<GetTourQuery, GetTourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTourQuery, GetTourQueryVariables>(GetTourDocument, options);
      }
export function useGetTourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTourQuery, GetTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTourQuery, GetTourQueryVariables>(GetTourDocument, options);
        }
export type GetTourQueryHookResult = ReturnType<typeof useGetTourQuery>;
export type GetTourLazyQueryHookResult = ReturnType<typeof useGetTourLazyQuery>;
export type GetTourQueryResult = Apollo.QueryResult<GetTourQuery, GetTourQueryVariables>;
export function refetchGetTourQuery(variables: GetTourQueryVariables) {
      return { query: GetTourDocument, variables: variables }
    }
export const GetTourInputDocument = gql`
    query getTourInput($id: ID!) {
  tour(id: $id) {
    id
    name
    steps {
      camera {
        id
        name
      }
      preset {
        id
        name
      }
    }
    description
    speed
    isSystem
  }
}
    `;

/**
 * __useGetTourInputQuery__
 *
 * To run a query within a React component, call `useGetTourInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTourInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTourInputQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTourInputQuery(baseOptions: Apollo.QueryHookOptions<GetTourInputQuery, GetTourInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTourInputQuery, GetTourInputQueryVariables>(GetTourInputDocument, options);
      }
export function useGetTourInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTourInputQuery, GetTourInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTourInputQuery, GetTourInputQueryVariables>(GetTourInputDocument, options);
        }
export type GetTourInputQueryHookResult = ReturnType<typeof useGetTourInputQuery>;
export type GetTourInputLazyQueryHookResult = ReturnType<typeof useGetTourInputLazyQuery>;
export type GetTourInputQueryResult = Apollo.QueryResult<GetTourInputQuery, GetTourInputQueryVariables>;
export function refetchGetTourInputQuery(variables: GetTourInputQueryVariables) {
      return { query: GetTourInputDocument, variables: variables }
    }
export const TourStepCamerasDocument = gql`
    query TourStepCameras($after: String, $before: String, $limit: Int = 100, $sortField: String, $sortOrder: SortOrder = ASCENDING, $searchText: String, $filters: [FilterInput!]) {
  cameras(
    after: $after
    before: $before
    limit: $limit
    sortField: $sortField
    sortOrder: $sortOrder
    searchText: $searchText
    filters: $filters
  ) {
    edges {
      node {
        id
        name
        streams {
          name
          accessType
          url
          application
          streamName
          streamType
        }
        ptzLock {
          isLocked
        }
        presets {
          id
          presetIndex
          name
        }
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${CursorPageInfoFragmentDoc}`;

/**
 * __useTourStepCamerasQuery__
 *
 * To run a query within a React component, call `useTourStepCamerasQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourStepCamerasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourStepCamerasQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTourStepCamerasQuery(baseOptions?: Apollo.QueryHookOptions<TourStepCamerasQuery, TourStepCamerasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TourStepCamerasQuery, TourStepCamerasQueryVariables>(TourStepCamerasDocument, options);
      }
export function useTourStepCamerasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TourStepCamerasQuery, TourStepCamerasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TourStepCamerasQuery, TourStepCamerasQueryVariables>(TourStepCamerasDocument, options);
        }
export type TourStepCamerasQueryHookResult = ReturnType<typeof useTourStepCamerasQuery>;
export type TourStepCamerasLazyQueryHookResult = ReturnType<typeof useTourStepCamerasLazyQuery>;
export type TourStepCamerasQueryResult = Apollo.QueryResult<TourStepCamerasQuery, TourStepCamerasQueryVariables>;
export function refetchTourStepCamerasQuery(variables?: TourStepCamerasQueryVariables) {
      return { query: TourStepCamerasDocument, variables: variables }
    }
export const GetCameraGroupDocument = gql`
    query getCameraGroup($id: ID!) {
  cameraGroup(id: $id) {
    ...CameraGroupFragment
  }
}
    ${CameraGroupFragmentFragmentDoc}`;

/**
 * __useGetCameraGroupQuery__
 *
 * To run a query within a React component, call `useGetCameraGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCameraGroupQuery(baseOptions: Apollo.QueryHookOptions<GetCameraGroupQuery, GetCameraGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCameraGroupQuery, GetCameraGroupQueryVariables>(GetCameraGroupDocument, options);
      }
export function useGetCameraGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCameraGroupQuery, GetCameraGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCameraGroupQuery, GetCameraGroupQueryVariables>(GetCameraGroupDocument, options);
        }
export type GetCameraGroupQueryHookResult = ReturnType<typeof useGetCameraGroupQuery>;
export type GetCameraGroupLazyQueryHookResult = ReturnType<typeof useGetCameraGroupLazyQuery>;
export type GetCameraGroupQueryResult = Apollo.QueryResult<GetCameraGroupQuery, GetCameraGroupQueryVariables>;
export function refetchGetCameraGroupQuery(variables: GetCameraGroupQueryVariables) {
      return { query: GetCameraGroupDocument, variables: variables }
    }
export const GetToursDocument = gql`
    query GetTours($after: String, $before: String, $limit: Int = 2000, $sortField: String, $sortOrder: SortOrder = ASCENDING, $searchText: String) {
  tours(
    query: {after: $after, before: $before, limit: $limit, sortField: $sortField, sortOrder: $sortOrder, searchText: $searchText}
  ) {
    edges {
      node {
        id
        name
        steps {
          camera {
            id
            name
          }
          preset {
            id
            name
          }
        }
        description
        speed
      }
    }
  }
}
    `;

/**
 * __useGetToursQuery__
 *
 * To run a query within a React component, call `useGetToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToursQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetToursQuery(baseOptions?: Apollo.QueryHookOptions<GetToursQuery, GetToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetToursQuery, GetToursQueryVariables>(GetToursDocument, options);
      }
export function useGetToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetToursQuery, GetToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetToursQuery, GetToursQueryVariables>(GetToursDocument, options);
        }
export type GetToursQueryHookResult = ReturnType<typeof useGetToursQuery>;
export type GetToursLazyQueryHookResult = ReturnType<typeof useGetToursLazyQuery>;
export type GetToursQueryResult = Apollo.QueryResult<GetToursQuery, GetToursQueryVariables>;
export function refetchGetToursQuery(variables?: GetToursQueryVariables) {
      return { query: GetToursDocument, variables: variables }
    }
export const GetScreenDocument = gql`
    query getScreen($id: ID!) {
  screen(id: $id) {
    ...Screen
  }
}
    ${ScreenFragmentDoc}`;

/**
 * __useGetScreenQuery__
 *
 * To run a query within a React component, call `useGetScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScreenQuery(baseOptions: Apollo.QueryHookOptions<GetScreenQuery, GetScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScreenQuery, GetScreenQueryVariables>(GetScreenDocument, options);
      }
export function useGetScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScreenQuery, GetScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScreenQuery, GetScreenQueryVariables>(GetScreenDocument, options);
        }
export type GetScreenQueryHookResult = ReturnType<typeof useGetScreenQuery>;
export type GetScreenLazyQueryHookResult = ReturnType<typeof useGetScreenLazyQuery>;
export type GetScreenQueryResult = Apollo.QueryResult<GetScreenQuery, GetScreenQueryVariables>;
export function refetchGetScreenQuery(variables: GetScreenQueryVariables) {
      return { query: GetScreenDocument, variables: variables }
    }
export const CameraMapEntitiesIdDocument = gql`
    query CameraMapEntitiesId($searchText: String, $filters: [FilterInput!]) {
  cameraMapEntityIds(searchText: $searchText, filters: $filters)
}
    `;

/**
 * __useCameraMapEntitiesIdQuery__
 *
 * To run a query within a React component, call `useCameraMapEntitiesIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraMapEntitiesIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraMapEntitiesIdQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCameraMapEntitiesIdQuery(baseOptions?: Apollo.QueryHookOptions<CameraMapEntitiesIdQuery, CameraMapEntitiesIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraMapEntitiesIdQuery, CameraMapEntitiesIdQueryVariables>(CameraMapEntitiesIdDocument, options);
      }
export function useCameraMapEntitiesIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraMapEntitiesIdQuery, CameraMapEntitiesIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraMapEntitiesIdQuery, CameraMapEntitiesIdQueryVariables>(CameraMapEntitiesIdDocument, options);
        }
export type CameraMapEntitiesIdQueryHookResult = ReturnType<typeof useCameraMapEntitiesIdQuery>;
export type CameraMapEntitiesIdLazyQueryHookResult = ReturnType<typeof useCameraMapEntitiesIdLazyQuery>;
export type CameraMapEntitiesIdQueryResult = Apollo.QueryResult<CameraMapEntitiesIdQuery, CameraMapEntitiesIdQueryVariables>;
export function refetchCameraMapEntitiesIdQuery(variables?: CameraMapEntitiesIdQueryVariables) {
      return { query: CameraMapEntitiesIdDocument, variables: variables }
    }
export const CameraMapEntityFullDocument = gql`
    query CameraMapEntityFull {
  cameraMapEntities
}
    `;

/**
 * __useCameraMapEntityFullQuery__
 *
 * To run a query within a React component, call `useCameraMapEntityFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraMapEntityFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraMapEntityFullQuery({
 *   variables: {
 *   },
 * });
 */
export function useCameraMapEntityFullQuery(baseOptions?: Apollo.QueryHookOptions<CameraMapEntityFullQuery, CameraMapEntityFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraMapEntityFullQuery, CameraMapEntityFullQueryVariables>(CameraMapEntityFullDocument, options);
      }
export function useCameraMapEntityFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraMapEntityFullQuery, CameraMapEntityFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraMapEntityFullQuery, CameraMapEntityFullQueryVariables>(CameraMapEntityFullDocument, options);
        }
export type CameraMapEntityFullQueryHookResult = ReturnType<typeof useCameraMapEntityFullQuery>;
export type CameraMapEntityFullLazyQueryHookResult = ReturnType<typeof useCameraMapEntityFullLazyQuery>;
export type CameraMapEntityFullQueryResult = Apollo.QueryResult<CameraMapEntityFullQuery, CameraMapEntityFullQueryVariables>;
export function refetchCameraMapEntityFullQuery(variables?: CameraMapEntityFullQueryVariables) {
      return { query: CameraMapEntityFullDocument, variables: variables }
    }
export const CameraTaskUpdatedDocument = gql`
    subscription CameraTaskUpdated($ids: [ID!], $creation: Boolean, $deletion: Boolean) {
  taskUpdated(ids: $ids, creation: $creation, deletion: $deletion) {
    ...CameraTaskFragment
  }
}
    ${CameraTaskFragmentFragmentDoc}`;

/**
 * __useCameraTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useCameraTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCameraTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraTaskUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      creation: // value for 'creation'
 *      deletion: // value for 'deletion'
 *   },
 * });
 */
export function useCameraTaskUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CameraTaskUpdatedSubscription, CameraTaskUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CameraTaskUpdatedSubscription, CameraTaskUpdatedSubscriptionVariables>(CameraTaskUpdatedDocument, options);
      }
export type CameraTaskUpdatedSubscriptionHookResult = ReturnType<typeof useCameraTaskUpdatedSubscription>;
export type CameraTaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<CameraTaskUpdatedSubscription>;
export const CameraUpdatedDocument = gql`
    subscription CameraUpdated($ids: [ID!]) {
  cameraUpdated(ids: $ids) {
    id
    name
    presets {
      id
      name
      presetIndex
      isHomePreset
    }
  }
}
    `;

/**
 * __useCameraUpdatedSubscription__
 *
 * To run a query within a React component, call `useCameraUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCameraUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCameraUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CameraUpdatedSubscription, CameraUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CameraUpdatedSubscription, CameraUpdatedSubscriptionVariables>(CameraUpdatedDocument, options);
      }
export type CameraUpdatedSubscriptionHookResult = ReturnType<typeof useCameraUpdatedSubscription>;
export type CameraUpdatedSubscriptionResult = Apollo.SubscriptionResult<CameraUpdatedSubscription>;
export const GetCameraCapabilitiesDocument = gql`
    query GetCameraCapabilities($cameraId: ID!) {
  cameraCapabilities(cameraId: $cameraId) {
    capability
    options
  }
}
    `;

/**
 * __useGetCameraCapabilitiesQuery__
 *
 * To run a query within a React component, call `useGetCameraCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraCapabilitiesQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useGetCameraCapabilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCameraCapabilitiesQuery, GetCameraCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCameraCapabilitiesQuery, GetCameraCapabilitiesQueryVariables>(GetCameraCapabilitiesDocument, options);
      }
export function useGetCameraCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCameraCapabilitiesQuery, GetCameraCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCameraCapabilitiesQuery, GetCameraCapabilitiesQueryVariables>(GetCameraCapabilitiesDocument, options);
        }
export type GetCameraCapabilitiesQueryHookResult = ReturnType<typeof useGetCameraCapabilitiesQuery>;
export type GetCameraCapabilitiesLazyQueryHookResult = ReturnType<typeof useGetCameraCapabilitiesLazyQuery>;
export type GetCameraCapabilitiesQueryResult = Apollo.QueryResult<GetCameraCapabilitiesQuery, GetCameraCapabilitiesQueryVariables>;
export function refetchGetCameraCapabilitiesQuery(variables: GetCameraCapabilitiesQueryVariables) {
      return { query: GetCameraCapabilitiesDocument, variables: variables }
    }
export const GetCameraDocument = gql`
    query GetCamera($id: ID!) {
  camera(id: $id) {
    ...CameraNode
  }
}
    ${CameraNodeFragmentDoc}`;

/**
 * __useGetCameraQuery__
 *
 * To run a query within a React component, call `useGetCameraQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCameraQuery(baseOptions: Apollo.QueryHookOptions<GetCameraQuery, GetCameraQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCameraQuery, GetCameraQueryVariables>(GetCameraDocument, options);
      }
export function useGetCameraLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCameraQuery, GetCameraQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCameraQuery, GetCameraQueryVariables>(GetCameraDocument, options);
        }
export type GetCameraQueryHookResult = ReturnType<typeof useGetCameraQuery>;
export type GetCameraLazyQueryHookResult = ReturnType<typeof useGetCameraLazyQuery>;
export type GetCameraQueryResult = Apollo.QueryResult<GetCameraQuery, GetCameraQueryVariables>;
export function refetchGetCameraQuery(variables: GetCameraQueryVariables) {
      return { query: GetCameraDocument, variables: variables }
    }
export const GetVideoTasksDocument = gql`
    query GetVideoTasks($cameraId: ID!, $from: DateTime!, $to: DateTime!, $timezone: String!) {
  videoTasks(cameraId: $cameraId, from: $from, to: $to, timezone: $timezone) {
    date
    tasks {
      ...CameraTaskOccurrenceFragment
    }
  }
}
    ${CameraTaskOccurrenceFragmentFragmentDoc}`;

/**
 * __useGetVideoTasksQuery__
 *
 * To run a query within a React component, call `useGetVideoTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoTasksQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetVideoTasksQuery(baseOptions: Apollo.QueryHookOptions<GetVideoTasksQuery, GetVideoTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoTasksQuery, GetVideoTasksQueryVariables>(GetVideoTasksDocument, options);
      }
export function useGetVideoTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoTasksQuery, GetVideoTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoTasksQuery, GetVideoTasksQueryVariables>(GetVideoTasksDocument, options);
        }
export type GetVideoTasksQueryHookResult = ReturnType<typeof useGetVideoTasksQuery>;
export type GetVideoTasksLazyQueryHookResult = ReturnType<typeof useGetVideoTasksLazyQuery>;
export type GetVideoTasksQueryResult = Apollo.QueryResult<GetVideoTasksQuery, GetVideoTasksQueryVariables>;
export function refetchGetVideoTasksQuery(variables: GetVideoTasksQueryVariables) {
      return { query: GetVideoTasksDocument, variables: variables }
    }
export const GetVideoStreamBlockDocument = gql`
    query GetVideoStreamBlock($cameraId: ID!) {
  videoStreamBlocked(cameraId: $cameraId) {
    ...VideoStreamBlock
  }
}
    ${VideoStreamBlockFragmentDoc}`;

/**
 * __useGetVideoStreamBlockQuery__
 *
 * To run a query within a React component, call `useGetVideoStreamBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoStreamBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoStreamBlockQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useGetVideoStreamBlockQuery(baseOptions: Apollo.QueryHookOptions<GetVideoStreamBlockQuery, GetVideoStreamBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoStreamBlockQuery, GetVideoStreamBlockQueryVariables>(GetVideoStreamBlockDocument, options);
      }
export function useGetVideoStreamBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoStreamBlockQuery, GetVideoStreamBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoStreamBlockQuery, GetVideoStreamBlockQueryVariables>(GetVideoStreamBlockDocument, options);
        }
export type GetVideoStreamBlockQueryHookResult = ReturnType<typeof useGetVideoStreamBlockQuery>;
export type GetVideoStreamBlockLazyQueryHookResult = ReturnType<typeof useGetVideoStreamBlockLazyQuery>;
export type GetVideoStreamBlockQueryResult = Apollo.QueryResult<GetVideoStreamBlockQuery, GetVideoStreamBlockQueryVariables>;
export function refetchGetVideoStreamBlockQuery(variables: GetVideoStreamBlockQueryVariables) {
      return { query: GetVideoStreamBlockDocument, variables: variables }
    }
export const VideoStreamBlockUpdatedDocument = gql`
    subscription VideoStreamBlockUpdated($ids: [ID!]) {
  videoStreamBlockUpdated(ids: $ids) {
    ...VideoStreamBlock
  }
}
    ${VideoStreamBlockFragmentDoc}`;

/**
 * __useVideoStreamBlockUpdatedSubscription__
 *
 * To run a query within a React component, call `useVideoStreamBlockUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVideoStreamBlockUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoStreamBlockUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVideoStreamBlockUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<VideoStreamBlockUpdatedSubscription, VideoStreamBlockUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<VideoStreamBlockUpdatedSubscription, VideoStreamBlockUpdatedSubscriptionVariables>(VideoStreamBlockUpdatedDocument, options);
      }
export type VideoStreamBlockUpdatedSubscriptionHookResult = ReturnType<typeof useVideoStreamBlockUpdatedSubscription>;
export type VideoStreamBlockUpdatedSubscriptionResult = Apollo.SubscriptionResult<VideoStreamBlockUpdatedSubscription>;
export const VideoStreamUnblockedDocument = gql`
    subscription VideoStreamUnblocked($ids: [ID!]) {
  videoStreamUnblocked(ids: $ids) {
    ...VideoStreamBlock
  }
}
    ${VideoStreamBlockFragmentDoc}`;

/**
 * __useVideoStreamUnblockedSubscription__
 *
 * To run a query within a React component, call `useVideoStreamUnblockedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVideoStreamUnblockedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoStreamUnblockedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVideoStreamUnblockedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<VideoStreamUnblockedSubscription, VideoStreamUnblockedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<VideoStreamUnblockedSubscription, VideoStreamUnblockedSubscriptionVariables>(VideoStreamUnblockedDocument, options);
      }
export type VideoStreamUnblockedSubscriptionHookResult = ReturnType<typeof useVideoStreamUnblockedSubscription>;
export type VideoStreamUnblockedSubscriptionResult = Apollo.SubscriptionResult<VideoStreamUnblockedSubscription>;
export const CameraDetectionStatusDocument = gql`
    query CameraDetectionStatus($cameraId: ID!) {
  cameraDetectionStatus(cameraId: $cameraId) {
    id
    isSupported
    enabled
  }
}
    `;

/**
 * __useCameraDetectionStatusQuery__
 *
 * To run a query within a React component, call `useCameraDetectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraDetectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraDetectionStatusQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useCameraDetectionStatusQuery(baseOptions: Apollo.QueryHookOptions<CameraDetectionStatusQuery, CameraDetectionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CameraDetectionStatusQuery, CameraDetectionStatusQueryVariables>(CameraDetectionStatusDocument, options);
      }
export function useCameraDetectionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CameraDetectionStatusQuery, CameraDetectionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CameraDetectionStatusQuery, CameraDetectionStatusQueryVariables>(CameraDetectionStatusDocument, options);
        }
export type CameraDetectionStatusQueryHookResult = ReturnType<typeof useCameraDetectionStatusQuery>;
export type CameraDetectionStatusLazyQueryHookResult = ReturnType<typeof useCameraDetectionStatusLazyQuery>;
export type CameraDetectionStatusQueryResult = Apollo.QueryResult<CameraDetectionStatusQuery, CameraDetectionStatusQueryVariables>;
export function refetchCameraDetectionStatusQuery(variables: CameraDetectionStatusQueryVariables) {
      return { query: CameraDetectionStatusDocument, variables: variables }
    }
export const WeatherStationPollDocument = gql`
    mutation WeatherStationPoll($ids: [ID!]!) {
  weatherStationPoll(ids: $ids) {
    success
    failure
  }
}
    `;
export type WeatherStationPollMutationFn = Apollo.MutationFunction<WeatherStationPollMutation, WeatherStationPollMutationVariables>;

/**
 * __useWeatherStationPollMutation__
 *
 * To run a mutation, you first call `useWeatherStationPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [weatherStationPollMutation, { data, loading, error }] = useWeatherStationPollMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useWeatherStationPollMutation(baseOptions?: Apollo.MutationHookOptions<WeatherStationPollMutation, WeatherStationPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WeatherStationPollMutation, WeatherStationPollMutationVariables>(WeatherStationPollDocument, options);
      }
export type WeatherStationPollMutationHookResult = ReturnType<typeof useWeatherStationPollMutation>;
export type WeatherStationPollMutationResult = Apollo.MutationResult<WeatherStationPollMutation>;
export type WeatherStationPollMutationOptions = Apollo.BaseMutationOptions<WeatherStationPollMutation, WeatherStationPollMutationVariables>;
export const WeatherStationsListDocument = gql`
    query WeatherStationsList($sortField: WeatherStationSortField = DATA_RECEIVED, $sortOrder: SortOrder = DESCENDING, $filters: [FilterInput], $searchText: String, $limit: Int = 10, $before: String, $after: String) {
  weatherStations(
    query: {searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, filters: $filters, before: $before, after: $after, limit: $limit}
  ) {
    edges {
      node {
        ...WeatherStationList
      }
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${WeatherStationListFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useWeatherStationsListQuery__
 *
 * To run a query within a React component, call `useWeatherStationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationsListQuery({
 *   variables: {
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWeatherStationsListQuery(baseOptions?: Apollo.QueryHookOptions<WeatherStationsListQuery, WeatherStationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationsListQuery, WeatherStationsListQueryVariables>(WeatherStationsListDocument, options);
      }
export function useWeatherStationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationsListQuery, WeatherStationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationsListQuery, WeatherStationsListQueryVariables>(WeatherStationsListDocument, options);
        }
export type WeatherStationsListQueryHookResult = ReturnType<typeof useWeatherStationsListQuery>;
export type WeatherStationsListLazyQueryHookResult = ReturnType<typeof useWeatherStationsListLazyQuery>;
export type WeatherStationsListQueryResult = Apollo.QueryResult<WeatherStationsListQuery, WeatherStationsListQueryVariables>;
export function refetchWeatherStationsListQuery(variables?: WeatherStationsListQueryVariables) {
      return { query: WeatherStationsListDocument, variables: variables }
    }
export const WeatherStationDocument = gql`
    query WeatherStation($id: ID!) {
  weatherStation(id: $id) {
    ...WeatherStationList
  }
}
    ${WeatherStationListFragmentDoc}`;

/**
 * __useWeatherStationQuery__
 *
 * To run a query within a React component, call `useWeatherStationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWeatherStationQuery(baseOptions: Apollo.QueryHookOptions<WeatherStationQuery, WeatherStationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationQuery, WeatherStationQueryVariables>(WeatherStationDocument, options);
      }
export function useWeatherStationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationQuery, WeatherStationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationQuery, WeatherStationQueryVariables>(WeatherStationDocument, options);
        }
export type WeatherStationQueryHookResult = ReturnType<typeof useWeatherStationQuery>;
export type WeatherStationLazyQueryHookResult = ReturnType<typeof useWeatherStationLazyQuery>;
export type WeatherStationQueryResult = Apollo.QueryResult<WeatherStationQuery, WeatherStationQueryVariables>;
export function refetchWeatherStationQuery(variables: WeatherStationQueryVariables) {
      return { query: WeatherStationDocument, variables: variables }
    }
export const WeatherStationUpdatedDocument = gql`
    subscription WeatherStationUpdated($ids: [ID!]) {
  weatherStationUpdated(ids: $ids) {
    ...WeatherStationList
  }
}
    ${WeatherStationListFragmentDoc}`;

/**
 * __useWeatherStationUpdatedSubscription__
 *
 * To run a query within a React component, call `useWeatherStationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationUpdatedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useWeatherStationUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WeatherStationUpdatedSubscription, WeatherStationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WeatherStationUpdatedSubscription, WeatherStationUpdatedSubscriptionVariables>(WeatherStationUpdatedDocument, options);
      }
export type WeatherStationUpdatedSubscriptionHookResult = ReturnType<typeof useWeatherStationUpdatedSubscription>;
export type WeatherStationUpdatedSubscriptionResult = Apollo.SubscriptionResult<WeatherStationUpdatedSubscription>;
export const WeatherStationRoadsDocument = gql`
    query WeatherStationRoads {
  roads
}
    `;

/**
 * __useWeatherStationRoadsQuery__
 *
 * To run a query within a React component, call `useWeatherStationRoadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationRoadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationRoadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeatherStationRoadsQuery(baseOptions?: Apollo.QueryHookOptions<WeatherStationRoadsQuery, WeatherStationRoadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationRoadsQuery, WeatherStationRoadsQueryVariables>(WeatherStationRoadsDocument, options);
      }
export function useWeatherStationRoadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationRoadsQuery, WeatherStationRoadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationRoadsQuery, WeatherStationRoadsQueryVariables>(WeatherStationRoadsDocument, options);
        }
export type WeatherStationRoadsQueryHookResult = ReturnType<typeof useWeatherStationRoadsQuery>;
export type WeatherStationRoadsLazyQueryHookResult = ReturnType<typeof useWeatherStationRoadsLazyQuery>;
export type WeatherStationRoadsQueryResult = Apollo.QueryResult<WeatherStationRoadsQuery, WeatherStationRoadsQueryVariables>;
export function refetchWeatherStationRoadsQuery(variables?: WeatherStationRoadsQueryVariables) {
      return { query: WeatherStationRoadsDocument, variables: variables }
    }
export const WeatherStationHistoryDocument = gql`
    query WeatherStationHistory($sortOrder: SortOrder = DESCENDING, $category: WeatherSensorCategory, $sortField: String = "timestamp", $filters: [FilterInput!], $startDateTime: DateTime, $endDateTime: DateTime, $linkAddress: [Int!], $searchText: String, $limit: Int = 10, $before: String, $after: String, $id: ID!) {
  weatherStationHistory(
    query: {startDateTime: $startDateTime, linkAddresses: $linkAddress, endDateTime: $endDateTime, searchText: $searchText, sortField: $sortField, sortOrder: $sortOrder, category: $category, filters: $filters, before: $before, limit: $limit, after: $after, id: $id}
  ) {
    edges {
      node {
        ...WeatherStationHistory
      }
    }
    totalCount
    pageInfo {
      ...CursorPageInfo
    }
  }
}
    ${WeatherStationHistoryFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useWeatherStationHistoryQuery__
 *
 * To run a query within a React component, call `useWeatherStationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationHistoryQuery({
 *   variables: {
 *      sortOrder: // value for 'sortOrder'
 *      category: // value for 'category'
 *      sortField: // value for 'sortField'
 *      filters: // value for 'filters'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      linkAddress: // value for 'linkAddress'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWeatherStationHistoryQuery(baseOptions: Apollo.QueryHookOptions<WeatherStationHistoryQuery, WeatherStationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationHistoryQuery, WeatherStationHistoryQueryVariables>(WeatherStationHistoryDocument, options);
      }
export function useWeatherStationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationHistoryQuery, WeatherStationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationHistoryQuery, WeatherStationHistoryQueryVariables>(WeatherStationHistoryDocument, options);
        }
export type WeatherStationHistoryQueryHookResult = ReturnType<typeof useWeatherStationHistoryQuery>;
export type WeatherStationHistoryLazyQueryHookResult = ReturnType<typeof useWeatherStationHistoryLazyQuery>;
export type WeatherStationHistoryQueryResult = Apollo.QueryResult<WeatherStationHistoryQuery, WeatherStationHistoryQueryVariables>;
export function refetchWeatherStationHistoryQuery(variables: WeatherStationHistoryQueryVariables) {
      return { query: WeatherStationHistoryDocument, variables: variables }
    }
export const WeatherStationSelectionDocument = gql`
    query WeatherStationSelection($limit: Int = 10000) {
  weatherStations(query: {limit: $limit}) {
    edges {
      node {
        ...WeatherStationSelect
      }
    }
  }
}
    ${WeatherStationSelectFragmentDoc}`;

/**
 * __useWeatherStationSelectionQuery__
 *
 * To run a query within a React component, call `useWeatherStationSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationSelectionQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWeatherStationSelectionQuery(baseOptions?: Apollo.QueryHookOptions<WeatherStationSelectionQuery, WeatherStationSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationSelectionQuery, WeatherStationSelectionQueryVariables>(WeatherStationSelectionDocument, options);
      }
export function useWeatherStationSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationSelectionQuery, WeatherStationSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationSelectionQuery, WeatherStationSelectionQueryVariables>(WeatherStationSelectionDocument, options);
        }
export type WeatherStationSelectionQueryHookResult = ReturnType<typeof useWeatherStationSelectionQuery>;
export type WeatherStationSelectionLazyQueryHookResult = ReturnType<typeof useWeatherStationSelectionLazyQuery>;
export type WeatherStationSelectionQueryResult = Apollo.QueryResult<WeatherStationSelectionQuery, WeatherStationSelectionQueryVariables>;
export function refetchWeatherStationSelectionQuery(variables?: WeatherStationSelectionQueryVariables) {
      return { query: WeatherStationSelectionDocument, variables: variables }
    }
export const WeatherStationEntityListDocument = gql`
    query WeatherStationEntityList($searchText: String, $filters: [FilterInput!]!) {
  weatherStations(
    query: {limit: 10000, searchText: $searchText, filters: $filters}
  ) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useWeatherStationEntityListQuery__
 *
 * To run a query within a React component, call `useWeatherStationEntityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationEntityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationEntityListQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useWeatherStationEntityListQuery(baseOptions: Apollo.QueryHookOptions<WeatherStationEntityListQuery, WeatherStationEntityListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationEntityListQuery, WeatherStationEntityListQueryVariables>(WeatherStationEntityListDocument, options);
      }
export function useWeatherStationEntityListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationEntityListQuery, WeatherStationEntityListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationEntityListQuery, WeatherStationEntityListQueryVariables>(WeatherStationEntityListDocument, options);
        }
export type WeatherStationEntityListQueryHookResult = ReturnType<typeof useWeatherStationEntityListQuery>;
export type WeatherStationEntityListLazyQueryHookResult = ReturnType<typeof useWeatherStationEntityListLazyQuery>;
export type WeatherStationEntityListQueryResult = Apollo.QueryResult<WeatherStationEntityListQuery, WeatherStationEntityListQueryVariables>;
export function refetchWeatherStationEntityListQuery(variables: WeatherStationEntityListQueryVariables) {
      return { query: WeatherStationEntityListDocument, variables: variables }
    }
export const WeatherStationChartHistoryDocument = gql`
    query WeatherStationChartHistory($types: [WeatherSensorType!], $weatherStationId: ID!, $start: DateTime!, $end: DateTime!) {
  weatherStationChartHistory(
    query: {weatherStationId: $weatherStationId, types: $types, start: $start, end: $end}
  ) {
    ...WeatherStationChartHistory
  }
}
    ${WeatherStationChartHistoryFragmentDoc}`;

/**
 * __useWeatherStationChartHistoryQuery__
 *
 * To run a query within a React component, call `useWeatherStationChartHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationChartHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationChartHistoryQuery({
 *   variables: {
 *      types: // value for 'types'
 *      weatherStationId: // value for 'weatherStationId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useWeatherStationChartHistoryQuery(baseOptions: Apollo.QueryHookOptions<WeatherStationChartHistoryQuery, WeatherStationChartHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationChartHistoryQuery, WeatherStationChartHistoryQueryVariables>(WeatherStationChartHistoryDocument, options);
      }
export function useWeatherStationChartHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationChartHistoryQuery, WeatherStationChartHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationChartHistoryQuery, WeatherStationChartHistoryQueryVariables>(WeatherStationChartHistoryDocument, options);
        }
export type WeatherStationChartHistoryQueryHookResult = ReturnType<typeof useWeatherStationChartHistoryQuery>;
export type WeatherStationChartHistoryLazyQueryHookResult = ReturnType<typeof useWeatherStationChartHistoryLazyQuery>;
export type WeatherStationChartHistoryQueryResult = Apollo.QueryResult<WeatherStationChartHistoryQuery, WeatherStationChartHistoryQueryVariables>;
export function refetchWeatherStationChartHistoryQuery(variables: WeatherStationChartHistoryQueryVariables) {
      return { query: WeatherStationChartHistoryDocument, variables: variables }
    }
export const WeatherStationActivityLogAddedDocument = gql`
    subscription WeatherStationActivityLogAdded($ids: [ID!], $module: KineticModule = WEATHER) {
  addedActivityLog(ids: $ids, module: $module) {
    ...ActivityLogNodeFragment
  }
}
    ${ActivityLogNodeFragmentFragmentDoc}`;

/**
 * __useWeatherStationActivityLogAddedSubscription__
 *
 * To run a query within a React component, call `useWeatherStationActivityLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationActivityLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationActivityLogAddedSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *      module: // value for 'module'
 *   },
 * });
 */
export function useWeatherStationActivityLogAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WeatherStationActivityLogAddedSubscription, WeatherStationActivityLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WeatherStationActivityLogAddedSubscription, WeatherStationActivityLogAddedSubscriptionVariables>(WeatherStationActivityLogAddedDocument, options);
      }
export type WeatherStationActivityLogAddedSubscriptionHookResult = ReturnType<typeof useWeatherStationActivityLogAddedSubscription>;
export type WeatherStationActivityLogAddedSubscriptionResult = Apollo.SubscriptionResult<WeatherStationActivityLogAddedSubscription>;
export const WeatherStationSummaryDocument = gql`
    query WeatherStationSummary {
  operationalWeatherStation: weatherStations(
    query: {filters: [{field: "state.currentState.communicationState", value: OPERATIONAL, operator: EQUALS}]}
  ) {
    totalCount
  }
  nonOperationalWeatherStation: weatherStations(
    query: {filters: [{field: "state.currentState.communicationState", operator: NOT_EQUALS, value: OPERATIONAL}]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useWeatherStationSummaryQuery__
 *
 * To run a query within a React component, call `useWeatherStationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeatherStationSummaryQuery(baseOptions?: Apollo.QueryHookOptions<WeatherStationSummaryQuery, WeatherStationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationSummaryQuery, WeatherStationSummaryQueryVariables>(WeatherStationSummaryDocument, options);
      }
export function useWeatherStationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationSummaryQuery, WeatherStationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationSummaryQuery, WeatherStationSummaryQueryVariables>(WeatherStationSummaryDocument, options);
        }
export type WeatherStationSummaryQueryHookResult = ReturnType<typeof useWeatherStationSummaryQuery>;
export type WeatherStationSummaryLazyQueryHookResult = ReturnType<typeof useWeatherStationSummaryLazyQuery>;
export type WeatherStationSummaryQueryResult = Apollo.QueryResult<WeatherStationSummaryQuery, WeatherStationSummaryQueryVariables>;
export function refetchWeatherStationSummaryQuery(variables?: WeatherStationSummaryQueryVariables) {
      return { query: WeatherStationSummaryDocument, variables: variables }
    }
export const WeatherStationMapEntitiesDocument = gql`
    query WeatherStationMapEntities {
  weatherStationMapEntities
}
    `;

/**
 * __useWeatherStationMapEntitiesQuery__
 *
 * To run a query within a React component, call `useWeatherStationMapEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherStationMapEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherStationMapEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeatherStationMapEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<WeatherStationMapEntitiesQuery, WeatherStationMapEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherStationMapEntitiesQuery, WeatherStationMapEntitiesQueryVariables>(WeatherStationMapEntitiesDocument, options);
      }
export function useWeatherStationMapEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherStationMapEntitiesQuery, WeatherStationMapEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherStationMapEntitiesQuery, WeatherStationMapEntitiesQueryVariables>(WeatherStationMapEntitiesDocument, options);
        }
export type WeatherStationMapEntitiesQueryHookResult = ReturnType<typeof useWeatherStationMapEntitiesQuery>;
export type WeatherStationMapEntitiesLazyQueryHookResult = ReturnType<typeof useWeatherStationMapEntitiesLazyQuery>;
export type WeatherStationMapEntitiesQueryResult = Apollo.QueryResult<WeatherStationMapEntitiesQuery, WeatherStationMapEntitiesQueryVariables>;
export function refetchWeatherStationMapEntitiesQuery(variables?: WeatherStationMapEntitiesQueryVariables) {
      return { query: WeatherStationMapEntitiesDocument, variables: variables }
    }